
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("e0Suo", function(module, exports) {

$parcel$export(module.exports, "__decorate", () => $a33b5536ee447e49$export$29e00dfd3077644b);
/******************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a33b5536ee447e49$var$extendStatics = function(d, b) {
    $a33b5536ee447e49$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a33b5536ee447e49$var$extendStatics(d, b);
};
function $a33b5536ee447e49$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a33b5536ee447e49$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a33b5536ee447e49$export$18ce0697a983be9b = function() {
    $a33b5536ee447e49$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a33b5536ee447e49$export$18ce0697a983be9b.apply(this, arguments);
};
function $a33b5536ee447e49$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a33b5536ee447e49$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a33b5536ee447e49$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a33b5536ee447e49$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a33b5536ee447e49$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a33b5536ee447e49$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a33b5536ee447e49$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a33b5536ee447e49$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a33b5536ee447e49$export$45d3717a4c69092e(o, m, p);
}
function $a33b5536ee447e49$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a33b5536ee447e49$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a33b5536ee447e49$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a33b5536ee447e49$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a33b5536ee447e49$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a33b5536ee447e49$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a33b5536ee447e49$export$10c90e4f7922046c(v) {
    return this instanceof $a33b5536ee447e49$export$10c90e4f7922046c ? (this.v = v, this) : new $a33b5536ee447e49$export$10c90e4f7922046c(v);
}
function $a33b5536ee447e49$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a33b5536ee447e49$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a33b5536ee447e49$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a33b5536ee447e49$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a33b5536ee447e49$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a33b5536ee447e49$export$19a8beecd37a4c45 === "function" ? $a33b5536ee447e49$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a33b5536ee447e49$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a33b5536ee447e49$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a33b5536ee447e49$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a33b5536ee447e49$export$45d3717a4c69092e(result, mod, k);
    }
    $a33b5536ee447e49$var$__setModuleDefault(result, mod);
    return result;
}
function $a33b5536ee447e49$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a33b5536ee447e49$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a33b5536ee447e49$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a33b5536ee447e49$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("ir0rz", function(module, exports) {

$parcel$export(module.exports, "expandToProperty", () => $d6bb17ba9442dd7d$export$203b3c6995397e5e);
$parcel$export(module.exports, "serialize", () => $d6bb17ba9442dd7d$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "serializeAsTexture", () => $d6bb17ba9442dd7d$export$e76ad6c032366edc);
$parcel$export(module.exports, "serializeAsColor3", () => $d6bb17ba9442dd7d$export$f39b11f54e3219cf);
$parcel$export(module.exports, "serializeAsFresnelParameters", () => $d6bb17ba9442dd7d$export$ef9196ceae518245);
$parcel$export(module.exports, "serializeAsVector2", () => $d6bb17ba9442dd7d$export$e0ab9460c5b8abfe);
$parcel$export(module.exports, "serializeAsVector3", () => $d6bb17ba9442dd7d$export$c5783c6fe7ef9867);
$parcel$export(module.exports, "serializeAsMeshReference", () => $d6bb17ba9442dd7d$export$ae00ee082f688526);
$parcel$export(module.exports, "serializeAsColorCurves", () => $d6bb17ba9442dd7d$export$76755f760291e85b);
$parcel$export(module.exports, "serializeAsColor4", () => $d6bb17ba9442dd7d$export$6337ec176e95f4eb);
$parcel$export(module.exports, "serializeAsQuaternion", () => $d6bb17ba9442dd7d$export$aee7845601ccd2d9);
$parcel$export(module.exports, "nativeOverride", () => $d6bb17ba9442dd7d$export$8fa84e8951b5413e);

var $225Mx = parcelRequire("225Mx");
function $d6bb17ba9442dd7d$var$generateSerializableMember(type, sourceName) {
    return (target, propertyKey)=>{
        const classStore = (0, $225Mx.GetDirectStore)(target);
        if (!classStore[propertyKey]) classStore[propertyKey] = {
            type: type,
            sourceName: sourceName
        };
    };
}
function $d6bb17ba9442dd7d$var$generateExpandMember(setCallback, targetKey = null) {
    return (target, propertyKey)=>{
        const key = targetKey || "_" + propertyKey;
        Object.defineProperty(target, propertyKey, {
            get: function() {
                return this[key];
            },
            set: function(value) {
                // does this object (i.e. vector3) has an equals function? use it!
                // Note - not using "with epsilon" here, it is expected te behave like the internal cache does.
                if (typeof this.equals === "function") {
                    if (this.equals(value)) return;
                }
                if (this[key] === value) return;
                this[key] = value;
                target[setCallback].apply(this);
            },
            enumerable: true,
            configurable: true
        });
    };
}
function $d6bb17ba9442dd7d$export$203b3c6995397e5e(callback, targetKey = null) {
    return $d6bb17ba9442dd7d$var$generateExpandMember(callback, targetKey);
}
function $d6bb17ba9442dd7d$export$dfdc1655ccc5b9cb(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(0, sourceName); // value member
}
function $d6bb17ba9442dd7d$export$e76ad6c032366edc(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(1, sourceName); // texture member
}
function $d6bb17ba9442dd7d$export$f39b11f54e3219cf(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(2, sourceName); // color3 member
}
function $d6bb17ba9442dd7d$export$ef9196ceae518245(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(3, sourceName); // fresnel parameters member
}
function $d6bb17ba9442dd7d$export$e0ab9460c5b8abfe(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(4, sourceName); // vector2 member
}
function $d6bb17ba9442dd7d$export$c5783c6fe7ef9867(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(5, sourceName); // vector3 member
}
function $d6bb17ba9442dd7d$export$ae00ee082f688526(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(6, sourceName); // mesh reference member
}
function $d6bb17ba9442dd7d$export$76755f760291e85b(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(7, sourceName); // color curves
}
function $d6bb17ba9442dd7d$export$6337ec176e95f4eb(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(8, sourceName); // color 4
}
function $d6bb17ba9442dd7d$export$5e2d0ccc49dd24b0(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(9, sourceName); // image processing
}
function $d6bb17ba9442dd7d$export$aee7845601ccd2d9(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(10, sourceName); // quaternion member
}
function $d6bb17ba9442dd7d$export$62d5bf94e4c09dfa(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(12, sourceName); // matrix member
}
function $d6bb17ba9442dd7d$export$1f0fc892c6407020(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(11, sourceName); // camera reference member
}
function $d6bb17ba9442dd7d$export$8fa84e8951b5413e(target, propertyKey, descriptor, predicate) {
    // Cache the original JS function for later.
    const jsFunc = descriptor.value;
    // Override the JS function to check for a native override on first invocation. Setting descriptor.value overrides the function at the early stage of code being loaded/imported.
    descriptor.value = (...params)=>{
        // Assume the resolved function will be the original JS function, then we will check for the Babylon Native context.
        let func = jsFunc;
        // Check if we are executing in a Babylon Native context (e.g. check the presence of the _native global property) and if so also check if a function override is available.
        if (typeof _native !== "undefined" && _native[propertyKey]) {
            const nativeFunc = _native[propertyKey];
            // If a predicate was provided, then we'll need to invoke the predicate on each invocation of the underlying function to determine whether to call the native function or the JS function.
            if (predicate) // The resolved function will execute the predicate and then either execute the native function or the JS function.
            func = (...params)=>predicate(...params) ? nativeFunc(...params) : jsFunc(...params);
            else // The resolved function will directly execute the native function.
            func = nativeFunc;
        }
        // Override the JS function again with the final resolved target function.
        target[propertyKey] = func;
        // The JS function has now been overridden based on whether we're executing in the context of Babylon Native, but we still need to invoke that function.
        // Future invocations of the function will just directly invoke the final overridden function, not any of the decorator setup logic above.
        return func(...params);
    };
}
/**
 * Decorator factory that applies the nativeOverride decorator, but determines whether to redirect to the native implementation based on a filter function that evaluates the function arguments.
 * @param predicate
 * @example @nativeOverride.filter((...[arg1]: Parameters<typeof someClass.someMethod>) => arg1.length > 20)
 *          public someMethod(arg1: string, arg2: number): string {
 * @internal
 */ $d6bb17ba9442dd7d$export$8fa84e8951b5413e.filter = function(predicate) {
    return (target, propertyKey, descriptor)=>$d6bb17ba9442dd7d$export$8fa84e8951b5413e(target, propertyKey, descriptor, predicate);
};

});
parcelRegister("225Mx", function(module, exports) {

$parcel$export(module.exports, "GetDirectStore", () => $17b040da3238b37f$export$27a5fe883f738bc2);
$parcel$export(module.exports, "GetMergedStore", () => $17b040da3238b37f$export$48e1269973505d05);
// eslint-disable-next-line @typescript-eslint/naming-convention
const $17b040da3238b37f$var$__mergedStore = {};
// eslint-disable-next-line @typescript-eslint/naming-convention
const $17b040da3238b37f$var$__decoratorInitialStore = {};
function $17b040da3238b37f$export$27a5fe883f738bc2(target) {
    const classKey = target.getClassName();
    if (!$17b040da3238b37f$var$__decoratorInitialStore[classKey]) $17b040da3238b37f$var$__decoratorInitialStore[classKey] = {};
    return $17b040da3238b37f$var$__decoratorInitialStore[classKey];
}
function $17b040da3238b37f$export$48e1269973505d05(target) {
    const classKey = target.getClassName();
    if ($17b040da3238b37f$var$__mergedStore[classKey]) return $17b040da3238b37f$var$__mergedStore[classKey];
    $17b040da3238b37f$var$__mergedStore[classKey] = {};
    const store = $17b040da3238b37f$var$__mergedStore[classKey];
    let currentTarget = target;
    let currentKey = classKey;
    while(currentKey){
        const initialStore = $17b040da3238b37f$var$__decoratorInitialStore[currentKey];
        for(const property in initialStore)store[property] = initialStore[property];
        let parent;
        let done = false;
        do {
            parent = Object.getPrototypeOf(currentTarget);
            if (!parent.getClassName) {
                done = true;
                break;
            }
            if (parent.getClassName() !== currentKey) break;
            currentTarget = parent;
        }while (parent);
        if (done) break;
        currentKey = parent.getClassName();
        currentTarget = parent;
    }
    return store;
}

});


parcelRegister("gmbCk", function(module, exports) {

$parcel$export(module.exports, "Scene", () => $be87b65ec8caf46b$export$38af1803e3442a7f);

var $bOhSV = parcelRequire("bOhSV");

var $blHSI = parcelRequire("blHSI");

var $diGQf = parcelRequire("diGQf");

var $57onU = parcelRequire("57onU");

var $895IS = parcelRequire("895IS");

var $7212E = parcelRequire("7212E");

var $ha1VO = parcelRequire("ha1VO");

var $dG1pf = parcelRequire("dG1pf");

var $ghoTi = parcelRequire("ghoTi");

var $gzCma = parcelRequire("gzCma");

var $cmj0B = parcelRequire("cmj0B");

var $8MhbJ = parcelRequire("8MhbJ");

var $jJNg8 = parcelRequire("jJNg8");

var $bv05l = parcelRequire("bv05l");

var $jFz47 = parcelRequire("jFz47");

var $ejQPp = parcelRequire("ejQPp");

var $dUFYy = parcelRequire("dUFYy");

var $7md5A = parcelRequire("7md5A");

var $2Fclq = parcelRequire("2Fclq");

var $7etnY = parcelRequire("7etnY");

var $9sPMJ = parcelRequire("9sPMJ");

var $3u0QC = parcelRequire("3u0QC");

var $EOxw7 = parcelRequire("EOxw7");

var $1gEbu = parcelRequire("1gEbu");

var $opFp4 = parcelRequire("opFp4");

var $lDzLx = parcelRequire("lDzLx");

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");
var $be87b65ec8caf46b$export$fc68a5778ead24b1;
(function(ScenePerformancePriority) {
    /** Default mode. No change. Performance will be treated as less important than backward compatibility */ ScenePerformancePriority[ScenePerformancePriority["BackwardCompatible"] = 0] = "BackwardCompatible";
    /** Some performance options will be turned on trying to strike a balance between perf and ease of use */ ScenePerformancePriority[ScenePerformancePriority["Intermediate"] = 1] = "Intermediate";
    /** Performance will be top priority */ ScenePerformancePriority[ScenePerformancePriority["Aggressive"] = 2] = "Aggressive";
})($be87b65ec8caf46b$export$fc68a5778ead24b1 || ($be87b65ec8caf46b$export$fc68a5778ead24b1 = {}));
class $be87b65ec8caf46b$export$38af1803e3442a7f {
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Factory used to create the default material.
     * @param scene The scene to create the material for
     * @returns The default material
     */ static DefaultMaterialFactory(scene) {
        throw (0, $dUFYy._WarnImport)("StandardMaterial");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Factory used to create the a collision coordinator.
     * @returns The collision coordinator
     */ static CollisionCoordinatorFactory() {
        throw (0, $dUFYy._WarnImport)("DefaultCollisionCoordinator");
    }
    /**
     * Defines the color used to clear the render buffer (Default is (0.2, 0.2, 0.3, 1.0))
     */ get clearColor() {
        return this._clearColor;
    }
    set clearColor(value) {
        if (value !== this._clearColor) {
            this._clearColor = value;
            this.onClearColorChangedObservable.notifyObservers(this._clearColor);
        }
    }
    /**
     * Default image processing configuration used either in the rendering
     * Forward main pass or through the imageProcessingPostProcess if present.
     * As in the majority of the scene they are the same (exception for multi camera),
     * this is easier to reference from here than from all the materials and post process.
     *
     * No setter as we it is a shared configuration, you can set the values instead.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Gets or sets a value indicating how to treat performance relatively to ease of use and backward compatibility
     */ get performancePriority() {
        return this._performancePriority;
    }
    set performancePriority(value) {
        if (value === this._performancePriority) return;
        this._performancePriority = value;
        switch(value){
            case 0 /* ScenePerformancePriority.BackwardCompatible */ :
                this.skipFrustumClipping = false;
                this._renderingManager.maintainStateBetweenFrames = false;
                this.skipPointerMovePicking = false;
                this.autoClear = true;
                break;
            case 1 /* ScenePerformancePriority.Intermediate */ :
                this.skipFrustumClipping = false;
                this._renderingManager.maintainStateBetweenFrames = false;
                this.skipPointerMovePicking = true;
                this.autoClear = false;
                break;
            case 2 /* ScenePerformancePriority.Aggressive */ :
                this.skipFrustumClipping = true;
                this._renderingManager.maintainStateBetweenFrames = true;
                this.skipPointerMovePicking = true;
                this.autoClear = false;
                break;
        }
        this.onScenePerformancePriorityChangedObservable.notifyObservers(value);
    }
    /**
     * Gets or sets a boolean indicating if all rendering must be done in wireframe
     */ set forceWireframe(value) {
        if (this._forceWireframe === value) return;
        this._forceWireframe = value;
        this.markAllMaterialsAsDirty(16);
    }
    get forceWireframe() {
        return this._forceWireframe;
    }
    /**
     * Gets or sets a boolean indicating if we should skip the frustum clipping part of the active meshes selection
     */ set skipFrustumClipping(value) {
        if (this._skipFrustumClipping === value) return;
        this._skipFrustumClipping = value;
    }
    get skipFrustumClipping() {
        return this._skipFrustumClipping;
    }
    /**
     * Gets or sets a boolean indicating if all rendering must be done in point cloud
     */ set forcePointsCloud(value) {
        if (this._forcePointsCloud === value) return;
        this._forcePointsCloud = value;
        this.markAllMaterialsAsDirty(16);
    }
    get forcePointsCloud() {
        return this._forcePointsCloud;
    }
    /**
     * Texture used in all pbr material as the reflection texture.
     * As in the majority of the scene they are the same (exception for multi room and so on),
     * this is easier to reference from here than from all the materials.
     */ get environmentTexture() {
        return this._environmentTexture;
    }
    /**
     * Texture used in all pbr material as the reflection texture.
     * As in the majority of the scene they are the same (exception for multi room and so on),
     * this is easier to set here than in all the materials.
     */ set environmentTexture(value) {
        if (this._environmentTexture === value) return;
        this._environmentTexture = value;
        this.onEnvironmentTextureChangedObservable.notifyObservers(value);
        this.markAllMaterialsAsDirty(1);
    }
    /**
     * @returns all meshes, lights, cameras, transformNodes and bones
     */ getNodes() {
        let nodes = [];
        nodes = nodes.concat(this.meshes);
        nodes = nodes.concat(this.lights);
        nodes = nodes.concat(this.cameras);
        nodes = nodes.concat(this.transformNodes); // dummies
        this.skeletons.forEach((skeleton)=>nodes = nodes.concat(skeleton.bones));
        return nodes;
    }
    /**
     * Gets or sets the animation properties override
     */ get animationPropertiesOverride() {
        return this._animationPropertiesOverride;
    }
    set animationPropertiesOverride(value) {
        this._animationPropertiesOverride = value;
    }
    /** Sets a function to be executed when this scene is disposed. */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /** Sets a function to be executed before rendering this scene */ set beforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        if (callback) this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /** Sets a function to be executed after rendering this scene */ set afterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        if (callback) this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /** Sets a function to be executed before rendering a camera*/ set beforeCameraRender(callback) {
        if (this._onBeforeCameraRenderObserver) this.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
        this._onBeforeCameraRenderObserver = this.onBeforeCameraRenderObservable.add(callback);
    }
    /** Sets a function to be executed after rendering a camera*/ set afterCameraRender(callback) {
        if (this._onAfterCameraRenderObserver) this.onAfterCameraRenderObservable.remove(this._onAfterCameraRenderObserver);
        this._onAfterCameraRenderObserver = this.onAfterCameraRenderObservable.add(callback);
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer down event
     */ get pointerDownPredicate() {
        return this._pointerPickingConfiguration.pointerDownPredicate;
    }
    set pointerDownPredicate(value) {
        this._pointerPickingConfiguration.pointerDownPredicate = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer up event
     */ get pointerUpPredicate() {
        return this._pointerPickingConfiguration.pointerUpPredicate;
    }
    set pointerUpPredicate(value) {
        this._pointerPickingConfiguration.pointerUpPredicate = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer move event
     */ get pointerMovePredicate() {
        return this._pointerPickingConfiguration.pointerMovePredicate;
    }
    set pointerMovePredicate(value) {
        this._pointerPickingConfiguration.pointerMovePredicate = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer down event
     */ get pointerDownFastCheck() {
        return this._pointerPickingConfiguration.pointerDownFastCheck;
    }
    set pointerDownFastCheck(value) {
        this._pointerPickingConfiguration.pointerDownFastCheck = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer up event
     */ get pointerUpFastCheck() {
        return this._pointerPickingConfiguration.pointerUpFastCheck;
    }
    set pointerUpFastCheck(value) {
        this._pointerPickingConfiguration.pointerUpFastCheck = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer move event
     */ get pointerMoveFastCheck() {
        return this._pointerPickingConfiguration.pointerMoveFastCheck;
    }
    set pointerMoveFastCheck(value) {
        this._pointerPickingConfiguration.pointerMoveFastCheck = value;
    }
    /**
     * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
     */ get skipPointerMovePicking() {
        return this._pointerPickingConfiguration.skipPointerMovePicking;
    }
    set skipPointerMovePicking(value) {
        this._pointerPickingConfiguration.skipPointerMovePicking = value;
    }
    /**
     * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
     */ get skipPointerDownPicking() {
        return this._pointerPickingConfiguration.skipPointerDownPicking;
    }
    set skipPointerDownPicking(value) {
        this._pointerPickingConfiguration.skipPointerDownPicking = value;
    }
    /**
     * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
     */ get skipPointerUpPicking() {
        return this._pointerPickingConfiguration.skipPointerUpPicking;
    }
    set skipPointerUpPicking(value) {
        this._pointerPickingConfiguration.skipPointerUpPicking = value;
    }
    /**
     * Gets the pointer coordinates without any translation (ie. straight out of the pointer event)
     */ get unTranslatedPointer() {
        return this._inputManager.unTranslatedPointer;
    }
    /**
     * Gets or sets the distance in pixel that you have to move to prevent some events. Default is 10 pixels
     */ static get DragMovementThreshold() {
        return (0, $7md5A.InputManager).DragMovementThreshold;
    }
    static set DragMovementThreshold(value) {
        (0, $7md5A.InputManager).DragMovementThreshold = value;
    }
    /**
     * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 500 ms
     */ static get LongPressDelay() {
        return (0, $7md5A.InputManager).LongPressDelay;
    }
    static set LongPressDelay(value) {
        (0, $7md5A.InputManager).LongPressDelay = value;
    }
    /**
     * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 300 ms
     */ static get DoubleClickDelay() {
        return (0, $7md5A.InputManager).DoubleClickDelay;
    }
    static set DoubleClickDelay(value) {
        (0, $7md5A.InputManager).DoubleClickDelay = value;
    }
    /** If you need to check double click without raising a single click at first click, enable this flag */ static get ExclusiveDoubleClickMode() {
        return (0, $7md5A.InputManager).ExclusiveDoubleClickMode;
    }
    static set ExclusiveDoubleClickMode(value) {
        (0, $7md5A.InputManager).ExclusiveDoubleClickMode = value;
    }
    /**
     * Bind the current view position to an effect.
     * @param effect The effect to be bound
     * @param variableName name of the shader variable that will hold the eye position
     * @param isVector3 true to indicates that variableName is a Vector3 and not a Vector4
     * @returns the computed eye position
     */ bindEyePosition(effect, variableName = "vEyePosition", isVector3 = false) {
        const eyePosition = this._forcedViewPosition ? this._forcedViewPosition : this._mirroredCameraPosition ? this._mirroredCameraPosition : this.activeCamera?.globalPosition ?? (0, $ha1VO.Vector3).ZeroReadOnly;
        const invertNormal = this.useRightHandedSystem === (this._mirroredCameraPosition != null);
        (0, $ha1VO.TmpVectors).Vector4[0].set(eyePosition.x, eyePosition.y, eyePosition.z, invertNormal ? -1 : 1);
        if (effect) {
            if (isVector3) effect.setFloat3(variableName, (0, $ha1VO.TmpVectors).Vector4[0].x, (0, $ha1VO.TmpVectors).Vector4[0].y, (0, $ha1VO.TmpVectors).Vector4[0].z);
            else effect.setVector4(variableName, (0, $ha1VO.TmpVectors).Vector4[0]);
        }
        return (0, $ha1VO.TmpVectors).Vector4[0];
    }
    /**
     * Update the scene ubo before it can be used in rendering processing
     * @returns the scene UniformBuffer
     */ finalizeSceneUbo() {
        const ubo = this.getSceneUniformBuffer();
        const eyePosition = this.bindEyePosition(null);
        ubo.updateFloat4("vEyePosition", eyePosition.x, eyePosition.y, eyePosition.z, eyePosition.w);
        ubo.update();
        return ubo;
    }
    /**
     * Gets or sets a boolean indicating if the scene must use right-handed coordinates system
     */ set useRightHandedSystem(value) {
        if (this._useRightHandedSystem === value) return;
        this._useRightHandedSystem = value;
        this.markAllMaterialsAsDirty(16);
    }
    get useRightHandedSystem() {
        return this._useRightHandedSystem;
    }
    /**
     * Sets the step Id used by deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @param newStepId defines the step Id
     */ setStepId(newStepId) {
        this._currentStepId = newStepId;
    }
    /**
     * Gets the step Id used by deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the step Id
     */ getStepId() {
        return this._currentStepId;
    }
    /**
     * Gets the internal step used by deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the internal step
     */ getInternalStep() {
        return this._currentInternalStep;
    }
    /**
     * Gets or sets a boolean indicating if fog is enabled on this scene
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
     * (Default is true)
     */ set fogEnabled(value) {
        if (this._fogEnabled === value) return;
        this._fogEnabled = value;
        this.markAllMaterialsAsDirty(16);
    }
    get fogEnabled() {
        return this._fogEnabled;
    }
    /**
     * Gets or sets the fog mode to use
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
     * | mode | value |
     * | --- | --- |
     * | FOGMODE_NONE | 0 |
     * | FOGMODE_EXP | 1 |
     * | FOGMODE_EXP2 | 2 |
     * | FOGMODE_LINEAR | 3 |
     */ set fogMode(value) {
        if (this._fogMode === value) return;
        this._fogMode = value;
        this.markAllMaterialsAsDirty(16);
    }
    get fogMode() {
        return this._fogMode;
    }
    /**
     * Flag indicating that the frame buffer binding is handled by another component
     */ get prePass() {
        return !!this.prePassRenderer && this.prePassRenderer.defaultRT.enabled;
    }
    /**
     * Gets or sets a boolean indicating if shadows are enabled on this scene
     */ set shadowsEnabled(value) {
        if (this._shadowsEnabled === value) return;
        this._shadowsEnabled = value;
        this.markAllMaterialsAsDirty(2);
    }
    get shadowsEnabled() {
        return this._shadowsEnabled;
    }
    /**
     * Gets or sets a boolean indicating if lights are enabled on this scene
     */ set lightsEnabled(value) {
        if (this._lightsEnabled === value) return;
        this._lightsEnabled = value;
        this.markAllMaterialsAsDirty(2);
    }
    get lightsEnabled() {
        return this._lightsEnabled;
    }
    /** All of the active cameras added to this scene. */ get activeCameras() {
        return this._activeCameras;
    }
    set activeCameras(cameras) {
        if (this._unObserveActiveCameras) {
            this._unObserveActiveCameras();
            this._unObserveActiveCameras = null;
        }
        if (cameras) this._unObserveActiveCameras = (0, $opFp4._ObserveArray)(cameras, ()=>{
            this.onActiveCamerasChanged.notifyObservers(this);
        });
        this._activeCameras = cameras;
    }
    /** Gets or sets the current active camera */ get activeCamera() {
        return this._activeCamera;
    }
    set activeCamera(value) {
        if (value === this._activeCamera) return;
        this._activeCamera = value;
        this.onActiveCameraChanged.notifyObservers(this);
    }
    /** The default material used on meshes when no material is affected */ get defaultMaterial() {
        if (!this._defaultMaterial) this._defaultMaterial = $be87b65ec8caf46b$export$38af1803e3442a7f.DefaultMaterialFactory(this);
        return this._defaultMaterial;
    }
    /** The default material used on meshes when no material is affected */ set defaultMaterial(value) {
        this._defaultMaterial = value;
    }
    /**
     * Gets or sets a boolean indicating if textures are enabled on this scene
     */ set texturesEnabled(value) {
        if (this._texturesEnabled === value) return;
        this._texturesEnabled = value;
        this.markAllMaterialsAsDirty(1);
    }
    get texturesEnabled() {
        return this._texturesEnabled;
    }
    /**
     * Gets or sets the frame graph used to render the scene. If set, the scene will use the frame graph to render the scene instead of the default render loop.
     */ get frameGraph() {
        return this._frameGraph;
    }
    set frameGraph(value) {
        if (this._frameGraph) {
            this._frameGraph = value;
            if (!value) this.customRenderFunction = this._currentCustomRenderFunction;
            return;
        }
        this._frameGraph = value;
        if (value) {
            this._currentCustomRenderFunction = this.customRenderFunction;
            this.customRenderFunction = this._renderWithFrameGraph;
        }
    }
    /**
     * Gets or sets a boolean indicating if skeletons are enabled on this scene
     */ set skeletonsEnabled(value) {
        if (this._skeletonsEnabled === value) return;
        this._skeletonsEnabled = value;
        this.markAllMaterialsAsDirty(8);
    }
    get skeletonsEnabled() {
        return this._skeletonsEnabled;
    }
    /** @internal */ get collisionCoordinator() {
        if (!this._collisionCoordinator) {
            this._collisionCoordinator = $be87b65ec8caf46b$export$38af1803e3442a7f.CollisionCoordinatorFactory();
            this._collisionCoordinator.init(this);
        }
        return this._collisionCoordinator;
    }
    /**
     * Gets the scene's rendering manager
     */ get renderingManager() {
        return this._renderingManager;
    }
    /**
     * Gets the list of frustum planes (built from the active camera)
     */ get frustumPlanes() {
        return this._frustumPlanes;
    }
    /**
     * Registers the transient components if needed.
     */ _registerTransientComponents() {
        // Register components that have been associated lately to the scene.
        if (this._transientComponents.length > 0) {
            for (const component of this._transientComponents)component.register();
            this._transientComponents.length = 0;
        }
    }
    /**
     * @internal
     * Add a component to the scene.
     * Note that the ccomponent could be registered on th next frame if this is called after
     * the register component stage.
     * @param component Defines the component to add to the scene
     */ _addComponent(component) {
        this._components.push(component);
        this._transientComponents.push(component);
        const serializableComponent = component;
        if (serializableComponent.addFromContainer && serializableComponent.serialize) this._serializableComponents.push(serializableComponent);
    }
    /**
     * @internal
     * Gets a component from the scene.
     * @param name defines the name of the component to retrieve
     * @returns the component or null if not present
     */ _getComponent(name) {
        for (const component of this._components){
            if (component.name === name) return component;
        }
        return null;
    }
    /**
     * Creates a new Scene
     * @param engine defines the engine to use to render this scene
     * @param options defines the scene options
     */ constructor(engine, options){
        /** @internal */ this._inputManager = new (0, $7md5A.InputManager)(this);
        /** Define this parameter if you are using multiple cameras and you want to specify which one should be used for pointer position */ this.cameraToUseForPointers = null;
        /** @internal */ this._isScene = true;
        /** @internal */ this._blockEntityCollection = false;
        /**
         * Gets or sets a boolean that indicates if the scene must clear the render buffer before rendering a frame
         */ this.autoClear = true;
        /**
         * Gets or sets a boolean that indicates if the scene must clear the depth and stencil buffers before rendering a frame
         */ this.autoClearDepthAndStencil = true;
        this._clearColor = new (0, $7etnY.Color4)(0.2, 0.2, 0.3, 1.0);
        /**
         * Observable triggered when the performance priority is changed
         */ this.onClearColorChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Defines the color used to simulate the ambient color (Default is (0, 0, 0))
         */ this.ambientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * Intensity of the environment in all pbr material.
         * This dims or reinforces the IBL lighting overall (reflection and diffuse).
         * As in the majority of the scene they are the same (exception for multi room and so on),
         * this is easier to reference from here than from all the materials.
         */ this.environmentIntensity = 1;
        this._performancePriority = 0 /* ScenePerformancePriority.BackwardCompatible */ ;
        /**
         * Observable triggered when the performance priority is changed
         */ this.onScenePerformancePriorityChangedObservable = new (0, $diGQf.Observable)();
        this._forceWireframe = false;
        this._skipFrustumClipping = false;
        this._forcePointsCloud = false;
        /**
         * Gets the list of root nodes (ie. nodes with no parent)
         */ this.rootNodes = [];
        /** All of the cameras added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
         */ this.cameras = [];
        /**
         * All of the lights added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         */ this.lights = [];
        /**
         * All of the (abstract) meshes added to this scene
         */ this.meshes = [];
        /**
         * The list of skeletons added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
         */ this.skeletons = [];
        /**
         * All of the particle systems added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro
         */ this.particleSystems = [];
        /**
         * Gets a list of Animations associated with the scene
         */ this.animations = [];
        /**
         * All of the animation groups added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/groupAnimations
         */ this.animationGroups = [];
        /**
         * All of the multi-materials added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
         */ this.multiMaterials = [];
        /**
         * All of the materials added to this scene
         * In the context of a Scene, it is not supposed to be modified manually.
         * Any addition or removal should be done using the addMaterial and removeMaterial Scene methods.
         * Note also that the order of the Material within the array is not significant and might change.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
         */ this.materials = [];
        /**
         * The list of morph target managers added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph
         */ this.morphTargetManagers = [];
        /**
         * The list of geometries used in the scene.
         */ this.geometries = [];
        /**
         * All of the transform nodes added to this scene
         * In the context of a Scene, it is not supposed to be modified manually.
         * Any addition or removal should be done using the addTransformNode and removeTransformNode Scene methods.
         * Note also that the order of the TransformNode within the array is not significant and might change.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/transform_node
         */ this.transformNodes = [];
        /**
         * ActionManagers available on the scene.
         * @deprecated
         */ this.actionManagers = [];
        /**
         * Textures to keep.
         */ this.textures = [];
        /** @internal */ this._environmentTexture = null;
        /**
         * The list of postprocesses added to the scene
         */ this.postProcesses = [];
        /**
         * The list of effect layers (highlights/glow) added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/highlightLayer
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/glowLayer
         */ this.effectLayers = [];
        /**
         * The list of sounds used in the scene.
         */ this.sounds = null;
        /**
         * The list of layers (background and foreground) of the scene
         */ this.layers = [];
        /**
         * The list of lens flare system added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
         */ this.lensFlareSystems = [];
        /**
         * The list of procedural textures added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/proceduralTextures
         */ this.proceduralTextures = [];
        /**
         * Gets or sets a boolean indicating if animations are enabled
         */ this.animationsEnabled = true;
        this._animationPropertiesOverride = null;
        /**
         * Gets or sets a boolean indicating if a constant deltatime has to be used
         * This is mostly useful for testing purposes when you do not want the animations to scale with the framerate
         */ this.useConstantAnimationDeltaTime = false;
        /**
         * Gets or sets a boolean indicating if the scene must keep the meshUnderPointer property updated
         * Please note that it requires to run a ray cast through the scene on every frame
         */ this.constantlyUpdateMeshUnderPointer = false;
        /**
         * Defines the HTML cursor to use when hovering over interactive elements
         */ this.hoverCursor = "pointer";
        /**
         * Defines the HTML default cursor to use (empty by default)
         */ this.defaultCursor = "";
        /**
         * Defines whether cursors are handled by the scene.
         */ this.doNotHandleCursors = false;
        /**
         * This is used to call preventDefault() on pointer down
         * in order to block unwanted artifacts like system double clicks
         */ this.preventDefaultOnPointerDown = true;
        /**
         * This is used to call preventDefault() on pointer up
         * in order to block unwanted artifacts like system double clicks
         */ this.preventDefaultOnPointerUp = true;
        // Metadata
        /**
         * Gets or sets user defined metadata
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        /**
         * Use this array to add regular expressions used to disable offline support for specific urls
         */ this.disableOfflineSupportExceptionRules = [];
        /**
         * An event triggered when the scene is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onDisposeObserver = null;
        /**
         * An event triggered before rendering the scene (right after animations and physics)
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        this._onBeforeRenderObserver = null;
        /**
         * An event triggered after rendering the scene
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the scene for an active camera (When scene.render is called this will be called after each camera)
         * This is triggered for each "sub" camera in a Camera Rig unlike onAfterCameraRenderObservable
         */ this.onAfterRenderCameraObservable = new (0, $diGQf.Observable)();
        this._onAfterRenderObserver = null;
        /**
         * An event triggered before animating the scene
         */ this.onBeforeAnimationsObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after animations processing
         */ this.onAfterAnimationsObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before draw calls are ready to be sent
         */ this.onBeforeDrawPhaseObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after draw calls have been sent
         */ this.onAfterDrawPhaseObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the scene is ready
         */ this.onReadyObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering a camera
         */ this.onBeforeCameraRenderObservable = new (0, $diGQf.Observable)();
        this._onBeforeCameraRenderObserver = null;
        /**
         * An event triggered after rendering a camera
         * This is triggered for the full rig Camera only unlike onAfterRenderCameraObservable
         */ this.onAfterCameraRenderObservable = new (0, $diGQf.Observable)();
        this._onAfterCameraRenderObserver = null;
        /**
         * An event triggered when active meshes evaluation is about to start
         */ this.onBeforeActiveMeshesEvaluationObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when active meshes evaluation is done
         */ this.onAfterActiveMeshesEvaluationObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when particles rendering is about to start
         * Note: This event can be trigger more than once per frame (because particles can be rendered by render target textures as well)
         */ this.onBeforeParticlesRenderingObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when particles rendering is done
         * Note: This event can be trigger more than once per frame (because particles can be rendered by render target textures as well)
         */ this.onAfterParticlesRenderingObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when SceneLoader.Append or SceneLoader.Load or SceneLoader.ImportMesh were successfully executed
         */ this.onDataLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a camera is created
         */ this.onNewCameraAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a camera is removed
         */ this.onCameraRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a light is created
         */ this.onNewLightAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a light is removed
         */ this.onLightRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a geometry is created
         */ this.onNewGeometryAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a geometry is removed
         */ this.onGeometryRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a transform node is created
         */ this.onNewTransformNodeAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a transform node is removed
         */ this.onTransformNodeRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a mesh is created
         */ this.onNewMeshAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a mesh is removed
         */ this.onMeshRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a skeleton is created
         */ this.onNewSkeletonAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a skeleton is removed
         */ this.onSkeletonRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a material is created
         */ this.onNewMaterialAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a multi material is created
         */ this.onNewMultiMaterialAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a material is removed
         */ this.onMaterialRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a multi material is removed
         */ this.onMultiMaterialRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a texture is created
         */ this.onNewTextureAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a texture is removed
         */ this.onTextureRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when render targets are about to be rendered
         * Can happen multiple times per frame.
         */ this.onBeforeRenderTargetsRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when render targets were rendered.
         * Can happen multiple times per frame.
         */ this.onAfterRenderTargetsRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before calculating deterministic simulation step
         */ this.onBeforeStepObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after calculating deterministic simulation step
         */ this.onAfterStepObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the activeCamera property is updated
         */ this.onActiveCameraChanged = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the activeCameras property is updated
         */ this.onActiveCamerasChanged = new (0, $diGQf.Observable)();
        /**
         * This Observable will be triggered before rendering each renderingGroup of each rendered camera.
         * The RenderingGroupInfo class contains all the information about the context in which the observable is called
         * If you wish to register an Observer only for a given set of renderingGroup, use the mask with a combination of the renderingGroup index elevated to the power of two (1 for renderingGroup 0, 2 for renderingrOup1, 4 for 2 and 8 for 3)
         */ this.onBeforeRenderingGroupObservable = new (0, $diGQf.Observable)();
        /**
         * This Observable will be triggered after rendering each renderingGroup of each rendered camera.
         * The RenderingGroupInfo class contains all the information about the context in which the observable is called
         * If you wish to register an Observer only for a given set of renderingGroup, use the mask with a combination of the renderingGroup index elevated to the power of two (1 for renderingGroup 0, 2 for renderingrOup1, 4 for 2 and 8 for 3)
         */ this.onAfterRenderingGroupObservable = new (0, $diGQf.Observable)();
        /**
         * This Observable will when a mesh has been imported into the scene.
         */ this.onMeshImportedObservable = new (0, $diGQf.Observable)();
        /**
         * This Observable will when an animation file has been imported into the scene.
         */ this.onAnimationFileImportedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the environmentTexture is changed.
         */ this.onEnvironmentTextureChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the state of mesh under pointer, for a specific pointerId, changes.
         */ this.onMeshUnderPointerUpdatedObservable = new (0, $diGQf.Observable)();
        // Animations
        /** @internal */ this._registeredForLateAnimationBindings = new (0, $57onU.SmartArrayNoDuplicate)(256);
        // Pointers
        this._pointerPickingConfiguration = new (0, $lDzLx.PointerPickingConfiguration)();
        /**
         * This observable event is triggered when any ponter event is triggered. It is registered during Scene.attachControl() and it is called BEFORE the 3D engine process anything (mesh/sprite picking for instance).
         * You have the possibility to skip the process and the call to onPointerObservable by setting PointerInfoPre.skipOnPointerObservable to true
         */ this.onPrePointerObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time an input event is received from the rendering canvas
         */ this.onPointerObservable = new (0, $diGQf.Observable)();
        // Keyboard
        /**
         * This observable event is triggered when any keyboard event si raised and registered during Scene.attachControl()
         * You have the possibility to skip the process and the call to onKeyboardObservable by setting KeyboardInfoPre.skipOnPointerObservable to true
         */ this.onPreKeyboardObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time an keyboard event is received from the hosting window
         */ this.onKeyboardObservable = new (0, $diGQf.Observable)();
        // Coordinates system
        this._useRightHandedSystem = false;
        // Deterministic lockstep
        this._timeAccumulator = 0;
        this._currentStepId = 0;
        this._currentInternalStep = 0;
        // Fog
        this._fogEnabled = true;
        this._fogMode = $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_NONE;
        /**
         * Gets or sets the fog color to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is Color3(0.2, 0.2, 0.3))
         */ this.fogColor = new (0, $7etnY.Color3)(0.2, 0.2, 0.3);
        /**
         * Gets or sets the fog density to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is 0.1)
         */ this.fogDensity = 0.1;
        /**
         * Gets or sets the fog start distance to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is 0)
         */ this.fogStart = 0;
        /**
         * Gets or sets the fog end distance to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is 1000)
         */ this.fogEnd = 1000.0;
        /**
         * Flag indicating if we need to store previous matrices when rendering
         */ this.needsPreviousWorldMatrices = false;
        // Lights
        this._shadowsEnabled = true;
        this._lightsEnabled = true;
        this._unObserveActiveCameras = null;
        // Textures
        this._texturesEnabled = true;
        this._frameGraph = null;
        // Physics
        /**
         * Gets or sets a boolean indicating if physic engines are enabled on this scene
         */ this.physicsEnabled = true;
        // Particles
        /**
         * Gets or sets a boolean indicating if particles are enabled on this scene
         */ this.particlesEnabled = true;
        // Sprites
        /**
         * Gets or sets a boolean indicating if sprites are enabled on this scene
         */ this.spritesEnabled = true;
        // Skeletons
        this._skeletonsEnabled = true;
        // Lens flares
        /**
         * Gets or sets a boolean indicating if lens flares are enabled on this scene
         */ this.lensFlaresEnabled = true;
        // Collisions
        /**
         * Gets or sets a boolean indicating if collisions are enabled on this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.collisionsEnabled = true;
        /**
         * Defines the gravity applied to this scene (used only for collisions)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.gravity = new (0, $ha1VO.Vector3)(0, -9.807, 0);
        // Postprocesses
        /**
         * Gets or sets a boolean indicating if postprocesses are enabled on this scene
         */ this.postProcessesEnabled = true;
        // Customs render targets
        /**
         * Gets or sets a boolean indicating if render targets are enabled on this scene
         */ this.renderTargetsEnabled = true;
        /**
         * Gets or sets a boolean indicating if next render targets must be dumped as image for debugging purposes
         * We recommend not using it and instead rely on Spector.js: http://spector.babylonjs.com
         */ this.dumpNextRenderTargets = false;
        /**
         * The list of user defined render targets added to the scene
         */ this.customRenderTargets = [];
        /**
         * Gets the list of meshes imported to the scene through SceneLoader
         */ this.importedMeshesFiles = [];
        // Probes
        /**
         * Gets or sets a boolean indicating if probes are enabled on this scene
         */ this.probesEnabled = true;
        this._meshesForIntersections = new (0, $57onU.SmartArrayNoDuplicate)(256);
        // Procedural textures
        /**
         * Gets or sets a boolean indicating if procedural textures are enabled on this scene
         */ this.proceduralTexturesEnabled = true;
        // Performance counters
        this._totalVertices = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._activeIndices = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._activeParticles = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._activeBones = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._animationTime = 0;
        /**
         * Gets or sets a general scale for animation speed
         * @see https://www.babylonjs-playground.com/#IBU2W7#3
         */ this.animationTimeScale = 1;
        this._renderId = 0;
        this._frameId = 0;
        this._executeWhenReadyTimeoutId = null;
        this._intermediateRendering = false;
        this._defaultFrameBufferCleared = false;
        this._viewUpdateFlag = -1;
        this._projectionUpdateFlag = -1;
        /** @internal */ this._toBeDisposed = new Array(256);
        this._activeRequests = new Array();
        /** @internal */ this._pendingData = new Array();
        this._isDisposed = false;
        /**
         * Gets or sets a boolean indicating that all submeshes of active meshes must be rendered
         * Use this boolean to avoid computing frustum clipping on submeshes (This could help when you are CPU bound)
         */ this.dispatchAllSubMeshesOfActiveMeshes = false;
        this._activeMeshes = new (0, $57onU.SmartArray)(256);
        this._processedMaterials = new (0, $57onU.SmartArray)(256);
        this._renderTargets = new (0, $57onU.SmartArrayNoDuplicate)(256);
        this._materialsRenderTargets = new (0, $57onU.SmartArrayNoDuplicate)(256);
        /** @internal */ this._activeParticleSystems = new (0, $57onU.SmartArray)(256);
        this._activeSkeletons = new (0, $57onU.SmartArrayNoDuplicate)(32);
        this._softwareSkinnedMeshes = new (0, $57onU.SmartArrayNoDuplicate)(32);
        /** @internal */ this._activeAnimatables = new Array();
        this._transformMatrix = (0, $ha1VO.Matrix).Zero();
        /**
         * Gets or sets a boolean indicating if lights must be sorted by priority (off by default)
         * This is useful if there are more lights that the maximum simulteanous authorized
         */ this.requireLightSorting = false;
        /**
         * @internal
         * Backing store of defined scene components.
         */ this._components = [];
        /**
         * @internal
         * Backing store of defined scene components.
         */ this._serializableComponents = [];
        /**
         * List of components to register on the next registration step.
         */ this._transientComponents = [];
        /**
         * @internal
         * Defines the actions happening before camera updates.
         */ this._beforeCameraUpdateStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening before clear the canvas.
         */ this._beforeClearStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening before clear the canvas.
         */ this._beforeRenderTargetClearStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions when collecting render targets for the frame.
         */ this._gatherRenderTargetsStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening for one camera in the frame.
         */ this._gatherActiveCameraRenderTargetsStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the per mesh ready checks.
         */ this._isReadyForMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening before evaluate active mesh checks.
         */ this._beforeEvaluateActiveMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the evaluate sub mesh checks.
         */ this._evaluateSubMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the active mesh stage.
         */ this._preActiveMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the per camera render target step.
         */ this._cameraDrawRenderTargetStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before the active camera is drawing.
         */ this._beforeCameraDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before a render target is drawing.
         */ this._beforeRenderTargetDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before a rendering group is drawing.
         */ this._beforeRenderingGroupDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before a mesh is drawing.
         */ this._beforeRenderingMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after a mesh has been drawn.
         */ this._afterRenderingMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after a rendering group has been drawn.
         */ this._afterRenderingGroupDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after the active camera has been drawn.
         */ this._afterCameraDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after the post processing
         */ this._afterCameraPostProcessStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after a render target has been drawn.
         */ this._afterRenderTargetDrawStage = (0, $bv05l.Stage).Create();
        /**
         * Defines the actions happening just after the post processing on a render target
         */ this._afterRenderTargetPostProcessStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after rendering all cameras and computing intersections.
         */ this._afterRenderStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening when a pointer move event happens.
         */ this._pointerMoveStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening when a pointer down event happens.
         */ this._pointerDownStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening when a pointer up event happens.
         */ this._pointerUpStage = (0, $bv05l.Stage).Create();
        /**
         * an optional map from Geometry Id to Geometry index in the 'geometries' array
         */ this._geometriesByUniqueId = null;
        this._defaultMeshCandidates = {
            data: [],
            length: 0
        };
        this._defaultSubMeshCandidates = {
            data: [],
            length: 0
        };
        this._preventFreeActiveMeshesAndRenderingGroups = false;
        /** @internal */ this._activeMeshesFrozen = false;
        /** @internal */ this._activeMeshesFrozenButKeepClipping = false;
        this._skipEvaluateActiveMeshesCompletely = false;
        /** @internal */ this._allowPostProcessClearColor = true;
        /**
         * User updatable function that will return a deterministic frame time when engine is in deterministic lock step mode
         * @returns the frame time
         */ this.getDeterministicFrameTime = ()=>{
            return this._engine.getTimeStep();
        };
        /** @internal */ this._registeredActions = 0;
        this._blockMaterialDirtyMechanism = false;
        /**
         * Internal perfCollector instance used for sharing between inspector and playground.
         * Marked as protected to allow sharing between prototype extensions, but disallow access at toplevel.
         */ this._perfCollector = null;
        this.activeCameras = [];
        const fullOptions = {
            useGeometryUniqueIdsMap: true,
            useMaterialMeshMap: true,
            useClonedMeshMap: true,
            virtual: false,
            ...options
        };
        engine = this._engine = engine || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (fullOptions.virtual) engine._virtualScenes.push(this);
        else {
            (0, $ejQPp.EngineStore)._LastCreatedScene = this;
            engine.scenes.push(this);
        }
        this._uid = null;
        this._renderingManager = new (0, $jJNg8.RenderingManager)(this);
        if (0, $8MhbJ.PostProcessManager) this.postProcessManager = new (0, $8MhbJ.PostProcessManager)(this);
        if ((0, $jFz47.IsWindowObjectExist)()) this.attachControl();
        // Uniform Buffer
        this._createUbo();
        // Default Image processing definition
        if (0, $dG1pf.ImageProcessingConfiguration) this._imageProcessingConfiguration = new (0, $dG1pf.ImageProcessingConfiguration)();
        this.setDefaultCandidateProviders();
        if (fullOptions.useGeometryUniqueIdsMap) this._geometriesByUniqueId = {};
        this.useMaterialMeshMap = fullOptions.useMaterialMeshMap;
        this.useClonedMeshMap = fullOptions.useClonedMeshMap;
        if (!options || !options.virtual) engine.onNewSceneAddedObservable.notifyObservers(this);
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "Scene" string
     */ getClassName() {
        return "Scene";
    }
    /**
     * @internal
     */ _getDefaultMeshCandidates() {
        this._defaultMeshCandidates.data = this.meshes;
        this._defaultMeshCandidates.length = this.meshes.length;
        return this._defaultMeshCandidates;
    }
    /**
     * @internal
     */ _getDefaultSubMeshCandidates(mesh) {
        this._defaultSubMeshCandidates.data = mesh.subMeshes;
        this._defaultSubMeshCandidates.length = mesh.subMeshes.length;
        return this._defaultSubMeshCandidates;
    }
    /**
     * Sets the default candidate providers for the scene.
     * This sets the getActiveMeshCandidates, getActiveSubMeshCandidates, getIntersectingSubMeshCandidates
     * and getCollidingSubMeshCandidates to their default function
     */ setDefaultCandidateProviders() {
        this.getActiveMeshCandidates = ()=>this._getDefaultMeshCandidates();
        this.getActiveSubMeshCandidates = (mesh)=>this._getDefaultSubMeshCandidates(mesh);
        this.getIntersectingSubMeshCandidates = (mesh, localRay)=>this._getDefaultSubMeshCandidates(mesh);
        this.getCollidingSubMeshCandidates = (mesh, collider)=>this._getDefaultSubMeshCandidates(mesh);
    }
    /**
     * Gets the mesh that is currently under the pointer
     */ get meshUnderPointer() {
        return this._inputManager.meshUnderPointer;
    }
    /**
     * Gets or sets the current on-screen X position of the pointer
     */ get pointerX() {
        return this._inputManager.pointerX;
    }
    set pointerX(value) {
        this._inputManager.pointerX = value;
    }
    /**
     * Gets or sets the current on-screen Y position of the pointer
     */ get pointerY() {
        return this._inputManager.pointerY;
    }
    set pointerY(value) {
        this._inputManager.pointerY = value;
    }
    /**
     * Gets the cached material (ie. the latest rendered one)
     * @returns the cached material
     */ getCachedMaterial() {
        return this._cachedMaterial;
    }
    /**
     * Gets the cached effect (ie. the latest rendered one)
     * @returns the cached effect
     */ getCachedEffect() {
        return this._cachedEffect;
    }
    /**
     * Gets the cached visibility state (ie. the latest rendered one)
     * @returns the cached visibility state
     */ getCachedVisibility() {
        return this._cachedVisibility;
    }
    /**
     * Gets a boolean indicating if the current material / effect / visibility must be bind again
     * @param material defines the current material
     * @param effect defines the current effect
     * @param visibility defines the current visibility state
     * @returns true if one parameter is not cached
     */ isCachedMaterialInvalid(material, effect, visibility = 1) {
        return this._cachedEffect !== effect || this._cachedMaterial !== material || this._cachedVisibility !== visibility;
    }
    /**
     * Gets the engine associated with the scene
     * @returns an Engine
     */ getEngine() {
        return this._engine;
    }
    /**
     * Gets the total number of vertices rendered per frame
     * @returns the total number of vertices rendered per frame
     */ getTotalVertices() {
        return this._totalVertices.current;
    }
    /**
     * Gets the performance counter for total vertices
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get totalVerticesPerfCounter() {
        return this._totalVertices;
    }
    /**
     * Gets the total number of active indices rendered per frame (You can deduce the number of rendered triangles by dividing this number by 3)
     * @returns the total number of active indices rendered per frame
     */ getActiveIndices() {
        return this._activeIndices.current;
    }
    /**
     * Gets the performance counter for active indices
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get totalActiveIndicesPerfCounter() {
        return this._activeIndices;
    }
    /**
     * Gets the total number of active particles rendered per frame
     * @returns the total number of active particles rendered per frame
     */ getActiveParticles() {
        return this._activeParticles.current;
    }
    /**
     * Gets the performance counter for active particles
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get activeParticlesPerfCounter() {
        return this._activeParticles;
    }
    /**
     * Gets the total number of active bones rendered per frame
     * @returns the total number of active bones rendered per frame
     */ getActiveBones() {
        return this._activeBones.current;
    }
    /**
     * Gets the performance counter for active bones
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get activeBonesPerfCounter() {
        return this._activeBones;
    }
    /**
     * Gets the array of active meshes
     * @returns an array of AbstractMesh
     */ getActiveMeshes() {
        return this._activeMeshes;
    }
    /**
     * Gets the animation ratio (which is 1.0 is the scene renders at 60fps and 2 if the scene renders at 30fps, etc.)
     * @returns a number
     */ getAnimationRatio() {
        return this._animationRatio !== undefined ? this._animationRatio : 1;
    }
    /**
     * Gets an unique Id for the current render phase
     * @returns a number
     */ getRenderId() {
        return this._renderId;
    }
    /**
     * Gets an unique Id for the current frame
     * @returns a number
     */ getFrameId() {
        return this._frameId;
    }
    /** Call this function if you want to manually increment the render Id*/ incrementRenderId() {
        this._renderId++;
    }
    _createUbo() {
        this.setSceneUniformBuffer(this.createSceneUniformBuffer());
    }
    /**
     * Use this method to simulate a pointer move on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @returns the current scene
     */ simulatePointerMove(pickResult, pointerEventInit) {
        this._inputManager.simulatePointerMove(pickResult, pointerEventInit);
        return this;
    }
    /**
     * Use this method to simulate a pointer down on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @returns the current scene
     */ simulatePointerDown(pickResult, pointerEventInit) {
        this._inputManager.simulatePointerDown(pickResult, pointerEventInit);
        return this;
    }
    /**
     * Use this method to simulate a pointer up on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @param doubleTap indicates that the pointer up event should be considered as part of a double click (false by default)
     * @returns the current scene
     */ simulatePointerUp(pickResult, pointerEventInit, doubleTap) {
        this._inputManager.simulatePointerUp(pickResult, pointerEventInit, doubleTap);
        return this;
    }
    /**
     * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
     * @param pointerId defines the pointer id to use in a multi-touch scenario (0 by default)
     * @returns true if the pointer was captured
     */ isPointerCaptured(pointerId = 0) {
        return this._inputManager.isPointerCaptured(pointerId);
    }
    /**
     * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
     * @param attachUp defines if you want to attach events to pointerup
     * @param attachDown defines if you want to attach events to pointerdown
     * @param attachMove defines if you want to attach events to pointermove
     */ attachControl(attachUp = true, attachDown = true, attachMove = true) {
        this._inputManager.attachControl(attachUp, attachDown, attachMove);
    }
    /** Detaches all event handlers*/ detachControl() {
        this._inputManager.detachControl();
    }
    /**
     * This function will check if the scene can be rendered (textures are loaded, shaders are compiled)
     * Delay loaded resources are not taking in account
     * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: true)
     * @returns true if all required resources are ready
     */ isReady(checkRenderTargets = true) {
        if (this._isDisposed) return false;
        let index;
        const engine = this.getEngine();
        const currentRenderPassId = engine.currentRenderPassId;
        engine.currentRenderPassId = this.activeCamera?.renderPassId ?? currentRenderPassId;
        let isReady = true;
        // Pending data
        if (this._pendingData.length > 0) isReady = false;
        // Ensures that the pre-pass renderer is enabled if it is to be enabled.
        this.prePassRenderer?.update();
        // OIT
        if (this.useOrderIndependentTransparency && this.depthPeelingRenderer) isReady && (isReady = this.depthPeelingRenderer.isReady());
        // Meshes
        if (checkRenderTargets) {
            this._processedMaterials.reset();
            this._materialsRenderTargets.reset();
        }
        for(index = 0; index < this.meshes.length; index++){
            const mesh = this.meshes[index];
            if (!mesh.subMeshes || mesh.subMeshes.length === 0) continue;
            // Do not stop at the first encountered "unready" object as we want to ensure
            // all materials are starting off their compilation in parallel.
            if (!mesh.isReady(true)) {
                isReady = false;
                continue;
            }
            const hardwareInstancedRendering = mesh.hasThinInstances || mesh.getClassName() === "InstancedMesh" || mesh.getClassName() === "InstancedLinesMesh" || engine.getCaps().instancedArrays && mesh.instances.length > 0;
            // Is Ready For Mesh
            for (const step of this._isReadyForMeshStage)if (!step.action(mesh, hardwareInstancedRendering)) isReady = false;
            if (!checkRenderTargets) continue;
            const mat = mesh.material || this.defaultMaterial;
            if (mat) {
                if (mat._storeEffectOnSubMeshes) for (const subMesh of mesh.subMeshes){
                    const material = subMesh.getMaterial();
                    if (material && material.hasRenderTargetTextures && material.getRenderTargetTextures != null) {
                        if (this._processedMaterials.indexOf(material) === -1) {
                            this._processedMaterials.push(material);
                            this._materialsRenderTargets.concatWithNoDuplicate(material.getRenderTargetTextures());
                        }
                    }
                }
                else {
                    if (mat.hasRenderTargetTextures && mat.getRenderTargetTextures != null) {
                        if (this._processedMaterials.indexOf(mat) === -1) {
                            this._processedMaterials.push(mat);
                            this._materialsRenderTargets.concatWithNoDuplicate(mat.getRenderTargetTextures());
                        }
                    }
                }
            }
        }
        // Render targets
        if (checkRenderTargets) for(index = 0; index < this._materialsRenderTargets.length; ++index){
            const rtt = this._materialsRenderTargets.data[index];
            if (!rtt.isReadyForRendering()) isReady = false;
        }
        // Geometries
        for(index = 0; index < this.geometries.length; index++){
            const geometry = this.geometries[index];
            if (geometry.delayLoadState === 2) isReady = false;
        }
        // Post-processes
        if (this.activeCameras && this.activeCameras.length > 0) {
            for (const camera of this.activeCameras)if (!camera.isReady(true)) isReady = false;
        } else if (this.activeCamera) {
            if (!this.activeCamera.isReady(true)) isReady = false;
        }
        // Particles
        for (const particleSystem of this.particleSystems)if (!particleSystem.isReady()) isReady = false;
        // Layers
        if (this.layers) {
            for (const layer of this.layers)if (!layer.isReady()) isReady = false;
        }
        // Effects
        if (!engine.areAllEffectsReady()) isReady = false;
        engine.currentRenderPassId = currentRenderPassId;
        return isReady;
    }
    /** Resets all cached information relative to material (including effect and visibility) */ resetCachedMaterial() {
        this._cachedMaterial = null;
        this._cachedEffect = null;
        this._cachedVisibility = null;
    }
    /**
     * Registers a function to be called before every frame render
     * @param func defines the function to register
     */ registerBeforeRender(func) {
        this.onBeforeRenderObservable.add(func);
    }
    /**
     * Unregisters a function called before every frame render
     * @param func defines the function to unregister
     */ unregisterBeforeRender(func) {
        this.onBeforeRenderObservable.removeCallback(func);
    }
    /**
     * Registers a function to be called after every frame render
     * @param func defines the function to register
     */ registerAfterRender(func) {
        this.onAfterRenderObservable.add(func);
    }
    /**
     * Unregisters a function called after every frame render
     * @param func defines the function to unregister
     */ unregisterAfterRender(func) {
        this.onAfterRenderObservable.removeCallback(func);
    }
    _executeOnceBeforeRender(func) {
        const execFunc = ()=>{
            func();
            setTimeout(()=>{
                this.unregisterBeforeRender(execFunc);
            });
        };
        this.registerBeforeRender(execFunc);
    }
    /**
     * The provided function will run before render once and will be disposed afterwards.
     * A timeout delay can be provided so that the function will be executed in N ms.
     * The timeout is using the browser's native setTimeout so time percision cannot be guaranteed.
     * @param func The function to be executed.
     * @param timeout optional delay in ms
     */ executeOnceBeforeRender(func, timeout) {
        if (timeout !== undefined) setTimeout(()=>{
            this._executeOnceBeforeRender(func);
        }, timeout);
        else this._executeOnceBeforeRender(func);
    }
    /**
     * This function can help adding any object to the list of data awaited to be ready in order to check for a complete scene loading.
     * @param data defines the object to wait for
     */ addPendingData(data) {
        this._pendingData.push(data);
    }
    /**
     * Remove a pending data from the loading list which has previously been added with addPendingData.
     * @param data defines the object to remove from the pending list
     */ removePendingData(data) {
        const wasLoading = this.isLoading;
        const index = this._pendingData.indexOf(data);
        if (index !== -1) this._pendingData.splice(index, 1);
        if (wasLoading && !this.isLoading) this.onDataLoadedObservable.notifyObservers(this);
    }
    /**
     * Returns the number of items waiting to be loaded
     * @returns the number of items waiting to be loaded
     */ getWaitingItemsCount() {
        return this._pendingData.length;
    }
    /**
     * Returns a boolean indicating if the scene is still loading data
     */ get isLoading() {
        return this._pendingData.length > 0;
    }
    /**
     * Registers a function to be executed when the scene is ready
     * @param func - the function to be executed
     * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
     */ executeWhenReady(func, checkRenderTargets = false) {
        this.onReadyObservable.addOnce(func);
        if (this._executeWhenReadyTimeoutId !== null) return;
        this._checkIsReady(checkRenderTargets);
    }
    /**
     * Returns a promise that resolves when the scene is ready
     * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
     * @returns A promise that resolves when the scene is ready
     */ whenReadyAsync(checkRenderTargets = false) {
        return new Promise((resolve)=>{
            this.executeWhenReady(()=>{
                resolve();
            }, checkRenderTargets);
        });
    }
    /**
     * @internal
     */ _checkIsReady(checkRenderTargets = false) {
        this._registerTransientComponents();
        if (this.isReady(checkRenderTargets)) {
            this.onReadyObservable.notifyObservers(this);
            this.onReadyObservable.clear();
            this._executeWhenReadyTimeoutId = null;
            return;
        }
        if (this._isDisposed) {
            this.onReadyObservable.clear();
            this._executeWhenReadyTimeoutId = null;
            return;
        }
        this._executeWhenReadyTimeoutId = setTimeout(()=>{
            // Ensure materials effects are checked outside render loops
            this.incrementRenderId();
            this._checkIsReady(checkRenderTargets);
        }, 100);
    }
    /**
     * Gets all animatable attached to the scene
     */ get animatables() {
        return this._activeAnimatables;
    }
    /**
     * Resets the last animation time frame.
     * Useful to override when animations start running when loading a scene for the first time.
     */ resetLastAnimationTimeFrame() {
        this._animationTimeLast = (0, $blHSI.PrecisionDate).Now;
    }
    // Matrix
    /**
     * Gets the current view matrix
     * @returns a Matrix
     */ getViewMatrix() {
        return this._viewMatrix;
    }
    /**
     * Gets the current projection matrix
     * @returns a Matrix
     */ getProjectionMatrix() {
        return this._projectionMatrix;
    }
    /**
     * Gets the current transform matrix
     * @returns a Matrix made of View * Projection
     */ getTransformMatrix() {
        return this._transformMatrix;
    }
    /**
     * Sets the current transform matrix
     * @param viewL defines the View matrix to use
     * @param projectionL defines the Projection matrix to use
     * @param viewR defines the right View matrix to use (if provided)
     * @param projectionR defines the right Projection matrix to use (if provided)
     */ setTransformMatrix(viewL, projectionL, viewR, projectionR) {
        // clear the multiviewSceneUbo if no viewR and projectionR are defined
        if (!viewR && !projectionR && this._multiviewSceneUbo) {
            this._multiviewSceneUbo.dispose();
            this._multiviewSceneUbo = null;
        }
        if (this._viewUpdateFlag === viewL.updateFlag && this._projectionUpdateFlag === projectionL.updateFlag) return;
        this._viewUpdateFlag = viewL.updateFlag;
        this._projectionUpdateFlag = projectionL.updateFlag;
        this._viewMatrix = viewL;
        this._projectionMatrix = projectionL;
        this._viewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
        // Update frustum
        if (!this._frustumPlanes) this._frustumPlanes = (0, $9sPMJ.Frustum).GetPlanes(this._transformMatrix);
        else (0, $9sPMJ.Frustum).GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
        if (this._multiviewSceneUbo && this._multiviewSceneUbo.useUbo) this._updateMultiviewUbo(viewR, projectionR);
        else if (this._sceneUbo.useUbo) {
            this._sceneUbo.updateMatrix("viewProjection", this._transformMatrix);
            this._sceneUbo.updateMatrix("view", this._viewMatrix);
            this._sceneUbo.updateMatrix("projection", this._projectionMatrix);
        }
    }
    /**
     * Gets the uniform buffer used to store scene data
     * @returns a UniformBuffer
     */ getSceneUniformBuffer() {
        return this._multiviewSceneUbo ? this._multiviewSceneUbo : this._sceneUbo;
    }
    /**
     * Creates a scene UBO
     * @param name name of the uniform buffer (optional, for debugging purpose only)
     * @returns a new ubo
     */ createSceneUniformBuffer(name) {
        const sceneUbo = new (0, $ghoTi.UniformBuffer)(this._engine, undefined, false, name ?? "scene");
        sceneUbo.addUniform("viewProjection", 16);
        sceneUbo.addUniform("view", 16);
        sceneUbo.addUniform("projection", 16);
        sceneUbo.addUniform("vEyePosition", 4);
        return sceneUbo;
    }
    /**
     * Sets the scene ubo
     * @param ubo the ubo to set for the scene
     */ setSceneUniformBuffer(ubo) {
        this._sceneUbo = ubo;
        this._viewUpdateFlag = -1;
        this._projectionUpdateFlag = -1;
    }
    /**
     * Gets an unique (relatively to the current scene) Id
     * @returns an unique number for the scene
     */ getUniqueId() {
        return (0, $3u0QC.UniqueIdGenerator).UniqueId;
    }
    /**
     * Add a mesh to the list of scene's meshes
     * @param newMesh defines the mesh to add
     * @param recursive if all child meshes should also be added to the scene
     */ addMesh(newMesh, recursive = false) {
        if (this._blockEntityCollection) return;
        this.meshes.push(newMesh);
        newMesh._resyncLightSources();
        if (!newMesh.parent) newMesh._addToSceneRootNodes();
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewMeshAddedObservable.notifyObservers(newMesh);
        });
        if (recursive) newMesh.getChildMeshes().forEach((m)=>{
            this.addMesh(m);
        });
    }
    /**
     * Remove a mesh for the list of scene's meshes
     * @param toRemove defines the mesh to remove
     * @param recursive if all child meshes should also be removed from the scene
     * @returns the index where the mesh was in the mesh list
     */ removeMesh(toRemove, recursive = false) {
        const index = this.meshes.indexOf(toRemove);
        if (index !== -1) {
            // Remove from the scene if the mesh found
            this.meshes.splice(index, 1);
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        this._inputManager._invalidateMesh(toRemove);
        this.onMeshRemovedObservable.notifyObservers(toRemove);
        if (recursive) toRemove.getChildMeshes().forEach((m)=>{
            this.removeMesh(m);
        });
        return index;
    }
    /**
     * Add a transform node to the list of scene's transform nodes
     * @param newTransformNode defines the transform node to add
     */ addTransformNode(newTransformNode) {
        if (this._blockEntityCollection) return;
        if (newTransformNode.getScene() === this && newTransformNode._indexInSceneTransformNodesArray !== -1) // Already there?
        return;
        newTransformNode._indexInSceneTransformNodesArray = this.transformNodes.length;
        this.transformNodes.push(newTransformNode);
        if (!newTransformNode.parent) newTransformNode._addToSceneRootNodes();
        this.onNewTransformNodeAddedObservable.notifyObservers(newTransformNode);
    }
    /**
     * Remove a transform node for the list of scene's transform nodes
     * @param toRemove defines the transform node to remove
     * @returns the index where the transform node was in the transform node list
     */ removeTransformNode(toRemove) {
        const index = toRemove._indexInSceneTransformNodesArray;
        if (index !== -1) {
            if (index !== this.transformNodes.length - 1) {
                const lastNode = this.transformNodes[this.transformNodes.length - 1];
                this.transformNodes[index] = lastNode;
                lastNode._indexInSceneTransformNodesArray = index;
            }
            toRemove._indexInSceneTransformNodesArray = -1;
            this.transformNodes.pop();
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        this.onTransformNodeRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Remove a skeleton for the list of scene's skeletons
     * @param toRemove defines the skeleton to remove
     * @returns the index where the skeleton was in the skeleton list
     */ removeSkeleton(toRemove) {
        const index = this.skeletons.indexOf(toRemove);
        if (index !== -1) {
            // Remove from the scene if found
            this.skeletons.splice(index, 1);
            this.onSkeletonRemovedObservable.notifyObservers(toRemove);
            // Clean active container
            this._executeActiveContainerCleanup(this._activeSkeletons);
        }
        return index;
    }
    /**
     * Remove a morph target for the list of scene's morph targets
     * @param toRemove defines the morph target to remove
     * @returns the index where the morph target was in the morph target list
     */ removeMorphTargetManager(toRemove) {
        const index = this.morphTargetManagers.indexOf(toRemove);
        if (index !== -1) // Remove from the scene if found
        this.morphTargetManagers.splice(index, 1);
        return index;
    }
    /**
     * Remove a light for the list of scene's lights
     * @param toRemove defines the light to remove
     * @returns the index where the light was in the light list
     */ removeLight(toRemove) {
        const index = this.lights.indexOf(toRemove);
        if (index !== -1) {
            // Remove from meshes
            for (const mesh of this.meshes)mesh._removeLightSource(toRemove, false);
            // Remove from the scene if mesh found
            this.lights.splice(index, 1);
            this.sortLightsByPriority();
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        this.onLightRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Remove a camera for the list of scene's cameras
     * @param toRemove defines the camera to remove
     * @returns the index where the camera was in the camera list
     */ removeCamera(toRemove) {
        const index = this.cameras.indexOf(toRemove);
        if (index !== -1) {
            // Remove from the scene if mesh found
            this.cameras.splice(index, 1);
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        // Remove from activeCameras
        if (this.activeCameras) {
            const index2 = this.activeCameras.indexOf(toRemove);
            if (index2 !== -1) // Remove from the scene if mesh found
            this.activeCameras.splice(index2, 1);
        }
        // Reset the activeCamera
        if (this.activeCamera === toRemove) {
            if (this.cameras.length > 0) this.activeCamera = this.cameras[0];
            else this.activeCamera = null;
        }
        this.onCameraRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Remove a particle system for the list of scene's particle systems
     * @param toRemove defines the particle system to remove
     * @returns the index where the particle system was in the particle system list
     */ removeParticleSystem(toRemove) {
        const index = this.particleSystems.indexOf(toRemove);
        if (index !== -1) {
            this.particleSystems.splice(index, 1);
            // Clean active container
            this._executeActiveContainerCleanup(this._activeParticleSystems);
        }
        return index;
    }
    /**
     * Remove a animation for the list of scene's animations
     * @param toRemove defines the animation to remove
     * @returns the index where the animation was in the animation list
     */ removeAnimation(toRemove) {
        const index = this.animations.indexOf(toRemove);
        if (index !== -1) this.animations.splice(index, 1);
        return index;
    }
    /**
     * Will stop the animation of the given target
     * @param target - the target
     * @param animationName - the name of the animation to stop (all animations will be stopped if both this and targetMask are empty)
     * @param targetMask - a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
     */ stopAnimation(target, animationName, targetMask) {
    // Do nothing as code will be provided by animation component
    }
    /**
     * Removes the given animation group from this scene.
     * @param toRemove The animation group to remove
     * @returns The index of the removed animation group
     */ removeAnimationGroup(toRemove) {
        const index = this.animationGroups.indexOf(toRemove);
        if (index !== -1) this.animationGroups.splice(index, 1);
        return index;
    }
    /**
     * Removes the given multi-material from this scene.
     * @param toRemove The multi-material to remove
     * @returns The index of the removed multi-material
     */ removeMultiMaterial(toRemove) {
        const index = this.multiMaterials.indexOf(toRemove);
        if (index !== -1) this.multiMaterials.splice(index, 1);
        this.onMultiMaterialRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Removes the given material from this scene.
     * @param toRemove The material to remove
     * @returns The index of the removed material
     */ removeMaterial(toRemove) {
        const index = toRemove._indexInSceneMaterialArray;
        if (index !== -1 && index < this.materials.length) {
            if (index !== this.materials.length - 1) {
                const lastMaterial = this.materials[this.materials.length - 1];
                this.materials[index] = lastMaterial;
                lastMaterial._indexInSceneMaterialArray = index;
            }
            toRemove._indexInSceneMaterialArray = -1;
            this.materials.pop();
        }
        this.onMaterialRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Removes the given action manager from this scene.
     * @deprecated
     * @param toRemove The action manager to remove
     * @returns The index of the removed action manager
     */ removeActionManager(toRemove) {
        const index = this.actionManagers.indexOf(toRemove);
        if (index !== -1) this.actionManagers.splice(index, 1);
        return index;
    }
    /**
     * Removes the given texture from this scene.
     * @param toRemove The texture to remove
     * @returns The index of the removed texture
     */ removeTexture(toRemove) {
        const index = this.textures.indexOf(toRemove);
        if (index !== -1) this.textures.splice(index, 1);
        this.onTextureRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Adds the given light to this scene
     * @param newLight The light to add
     */ addLight(newLight) {
        if (this._blockEntityCollection) return;
        this.lights.push(newLight);
        this.sortLightsByPriority();
        if (!newLight.parent) newLight._addToSceneRootNodes();
        // Add light to all meshes (To support if the light is removed and then re-added)
        for (const mesh of this.meshes)if (mesh.lightSources.indexOf(newLight) === -1) {
            mesh.lightSources.push(newLight);
            mesh._resyncLightSources();
        }
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewLightAddedObservable.notifyObservers(newLight);
        });
    }
    /**
     * Sorts the list list based on light priorities
     */ sortLightsByPriority() {
        if (this.requireLightSorting) this.lights.sort((0, $1gEbu.LightConstants).CompareLightsPriority);
    }
    /**
     * Adds the given camera to this scene
     * @param newCamera The camera to add
     */ addCamera(newCamera) {
        if (this._blockEntityCollection) return;
        this.cameras.push(newCamera);
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewCameraAddedObservable.notifyObservers(newCamera);
        });
        if (!newCamera.parent) newCamera._addToSceneRootNodes();
    }
    /**
     * Adds the given skeleton to this scene
     * @param newSkeleton The skeleton to add
     */ addSkeleton(newSkeleton) {
        if (this._blockEntityCollection) return;
        this.skeletons.push(newSkeleton);
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewSkeletonAddedObservable.notifyObservers(newSkeleton);
        });
    }
    /**
     * Adds the given particle system to this scene
     * @param newParticleSystem The particle system to add
     */ addParticleSystem(newParticleSystem) {
        if (this._blockEntityCollection) return;
        this.particleSystems.push(newParticleSystem);
    }
    /**
     * Adds the given animation to this scene
     * @param newAnimation The animation to add
     */ addAnimation(newAnimation) {
        if (this._blockEntityCollection) return;
        this.animations.push(newAnimation);
    }
    /**
     * Adds the given animation group to this scene.
     * @param newAnimationGroup The animation group to add
     */ addAnimationGroup(newAnimationGroup) {
        if (this._blockEntityCollection) return;
        this.animationGroups.push(newAnimationGroup);
    }
    /**
     * Adds the given multi-material to this scene
     * @param newMultiMaterial The multi-material to add
     */ addMultiMaterial(newMultiMaterial) {
        if (this._blockEntityCollection) return;
        this.multiMaterials.push(newMultiMaterial);
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewMultiMaterialAddedObservable.notifyObservers(newMultiMaterial);
        });
    }
    /**
     * Adds the given material to this scene
     * @param newMaterial The material to add
     */ addMaterial(newMaterial) {
        if (this._blockEntityCollection) return;
        if (newMaterial.getScene() === this && newMaterial._indexInSceneMaterialArray !== -1) // Already there??
        return;
        newMaterial._indexInSceneMaterialArray = this.materials.length;
        this.materials.push(newMaterial);
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewMaterialAddedObservable.notifyObservers(newMaterial);
        });
    }
    /**
     * Adds the given morph target to this scene
     * @param newMorphTargetManager The morph target to add
     */ addMorphTargetManager(newMorphTargetManager) {
        if (this._blockEntityCollection) return;
        this.morphTargetManagers.push(newMorphTargetManager);
    }
    /**
     * Adds the given geometry to this scene
     * @param newGeometry The geometry to add
     */ addGeometry(newGeometry) {
        if (this._blockEntityCollection) return;
        if (this._geometriesByUniqueId) this._geometriesByUniqueId[newGeometry.uniqueId] = this.geometries.length;
        this.geometries.push(newGeometry);
    }
    /**
     * Adds the given action manager to this scene
     * @deprecated
     * @param newActionManager The action manager to add
     */ addActionManager(newActionManager) {
        this.actionManagers.push(newActionManager);
    }
    /**
     * Adds the given texture to this scene.
     * @param newTexture The texture to add
     */ addTexture(newTexture) {
        if (this._blockEntityCollection) return;
        this.textures.push(newTexture);
        this.onNewTextureAddedObservable.notifyObservers(newTexture);
    }
    /**
     * Switch active camera
     * @param newCamera defines the new active camera
     * @param attachControl defines if attachControl must be called for the new active camera (default: true)
     */ switchActiveCamera(newCamera, attachControl = true) {
        const canvas = this._engine.getInputElement();
        if (!canvas) return;
        if (this.activeCamera) this.activeCamera.detachControl();
        this.activeCamera = newCamera;
        if (attachControl) newCamera.attachControl();
    }
    /**
     * sets the active camera of the scene using its Id
     * @param id defines the camera's Id
     * @returns the new active camera or null if none found.
     */ setActiveCameraById(id) {
        const camera = this.getCameraById(id);
        if (camera) {
            this.activeCamera = camera;
            return camera;
        }
        return null;
    }
    /**
     * sets the active camera of the scene using its name
     * @param name defines the camera's name
     * @returns the new active camera or null if none found.
     */ setActiveCameraByName(name) {
        const camera = this.getCameraByName(name);
        if (camera) {
            this.activeCamera = camera;
            return camera;
        }
        return null;
    }
    /**
     * get an animation group using its name
     * @param name defines the material's name
     * @returns the animation group or null if none found.
     */ getAnimationGroupByName(name) {
        for(let index = 0; index < this.animationGroups.length; index++){
            if (this.animationGroups[index].name === name) return this.animationGroups[index];
        }
        return null;
    }
    _getMaterial(allowMultiMaterials, predicate) {
        for(let index = 0; index < this.materials.length; index++){
            const material = this.materials[index];
            if (predicate(material)) return material;
        }
        if (allowMultiMaterials) for(let index = 0; index < this.multiMaterials.length; index++){
            const material = this.multiMaterials[index];
            if (predicate(material)) return material;
        }
        return null;
    }
    /**
     * Get a material using its unique id
     * @param uniqueId defines the material's unique id
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the material or null if none found.
     */ getMaterialByUniqueID(uniqueId, allowMultiMaterials = false) {
        return this._getMaterial(allowMultiMaterials, (m)=>m.uniqueId === uniqueId);
    }
    /**
     * get a material using its id
     * @param id defines the material's Id
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the material or null if none found.
     */ getMaterialById(id, allowMultiMaterials = false) {
        return this._getMaterial(allowMultiMaterials, (m)=>m.id === id);
    }
    /**
     * Gets a material using its name
     * @param name defines the material's name
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the material or null if none found.
     */ getMaterialByName(name, allowMultiMaterials = false) {
        return this._getMaterial(allowMultiMaterials, (m)=>m.name === name);
    }
    /**
     * Gets a last added material using a given id
     * @param id defines the material's id
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the last material with the given id or null if none found.
     */ getLastMaterialById(id, allowMultiMaterials = false) {
        for(let index = this.materials.length - 1; index >= 0; index--){
            if (this.materials[index].id === id) return this.materials[index];
        }
        if (allowMultiMaterials) for(let index = this.multiMaterials.length - 1; index >= 0; index--){
            if (this.multiMaterials[index].id === id) return this.multiMaterials[index];
        }
        return null;
    }
    /**
     * Get a texture using its unique id
     * @param uniqueId defines the texture's unique id
     * @returns the texture or null if none found.
     */ getTextureByUniqueId(uniqueId) {
        for(let index = 0; index < this.textures.length; index++){
            if (this.textures[index].uniqueId === uniqueId) return this.textures[index];
        }
        return null;
    }
    /**
     * Gets a texture using its name
     * @param name defines the texture's name
     * @returns the texture or null if none found.
     */ getTextureByName(name) {
        for(let index = 0; index < this.textures.length; index++){
            if (this.textures[index].name === name) return this.textures[index];
        }
        return null;
    }
    /**
     * Gets a camera using its Id
     * @param id defines the Id to look for
     * @returns the camera or null if not found
     */ getCameraById(id) {
        for(let index = 0; index < this.cameras.length; index++){
            if (this.cameras[index].id === id) return this.cameras[index];
        }
        return null;
    }
    /**
     * Gets a camera using its unique Id
     * @param uniqueId defines the unique Id to look for
     * @returns the camera or null if not found
     */ getCameraByUniqueId(uniqueId) {
        for(let index = 0; index < this.cameras.length; index++){
            if (this.cameras[index].uniqueId === uniqueId) return this.cameras[index];
        }
        return null;
    }
    /**
     * Gets a camera using its name
     * @param name defines the camera's name
     * @returns the camera or null if none found.
     */ getCameraByName(name) {
        for(let index = 0; index < this.cameras.length; index++){
            if (this.cameras[index].name === name) return this.cameras[index];
        }
        return null;
    }
    /**
     * Gets a bone using its Id
     * @param id defines the bone's Id
     * @returns the bone or null if not found
     */ getBoneById(id) {
        for(let skeletonIndex = 0; skeletonIndex < this.skeletons.length; skeletonIndex++){
            const skeleton = this.skeletons[skeletonIndex];
            for(let boneIndex = 0; boneIndex < skeleton.bones.length; boneIndex++){
                if (skeleton.bones[boneIndex].id === id) return skeleton.bones[boneIndex];
            }
        }
        return null;
    }
    /**
     * Gets a bone using its id
     * @param name defines the bone's name
     * @returns the bone or null if not found
     */ getBoneByName(name) {
        for(let skeletonIndex = 0; skeletonIndex < this.skeletons.length; skeletonIndex++){
            const skeleton = this.skeletons[skeletonIndex];
            for(let boneIndex = 0; boneIndex < skeleton.bones.length; boneIndex++){
                if (skeleton.bones[boneIndex].name === name) return skeleton.bones[boneIndex];
            }
        }
        return null;
    }
    /**
     * Gets a light node using its name
     * @param name defines the light's name
     * @returns the light or null if none found.
     */ getLightByName(name) {
        for(let index = 0; index < this.lights.length; index++){
            if (this.lights[index].name === name) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a light node using its Id
     * @param id defines the light's Id
     * @returns the light or null if none found.
     */ getLightById(id) {
        for(let index = 0; index < this.lights.length; index++){
            if (this.lights[index].id === id) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a light node using its scene-generated unique Id
     * @param uniqueId defines the light's unique Id
     * @returns the light or null if none found.
     */ getLightByUniqueId(uniqueId) {
        for(let index = 0; index < this.lights.length; index++){
            if (this.lights[index].uniqueId === uniqueId) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a particle system by Id
     * @param id defines the particle system Id
     * @returns the corresponding system or null if none found
     */ getParticleSystemById(id) {
        for(let index = 0; index < this.particleSystems.length; index++){
            if (this.particleSystems[index].id === id) return this.particleSystems[index];
        }
        return null;
    }
    /**
     * Gets a geometry using its Id
     * @param id defines the geometry's Id
     * @returns the geometry or null if none found.
     */ getGeometryById(id) {
        for(let index = 0; index < this.geometries.length; index++){
            if (this.geometries[index].id === id) return this.geometries[index];
        }
        return null;
    }
    _getGeometryByUniqueId(uniqueId) {
        if (this._geometriesByUniqueId) {
            const index = this._geometriesByUniqueId[uniqueId];
            if (index !== undefined) return this.geometries[index];
        } else for(let index = 0; index < this.geometries.length; index++){
            if (this.geometries[index].uniqueId === uniqueId) return this.geometries[index];
        }
        return null;
    }
    /**
     * Add a new geometry to this scene
     * @param geometry defines the geometry to be added to the scene.
     * @param force defines if the geometry must be pushed even if a geometry with this id already exists
     * @returns a boolean defining if the geometry was added or not
     */ pushGeometry(geometry, force) {
        if (!force && this._getGeometryByUniqueId(geometry.uniqueId)) return false;
        this.addGeometry(geometry);
        (0, $bOhSV.Tools).SetImmediate(()=>{
            this.onNewGeometryAddedObservable.notifyObservers(geometry);
        });
        return true;
    }
    /**
     * Removes an existing geometry
     * @param geometry defines the geometry to be removed from the scene
     * @returns a boolean defining if the geometry was removed or not
     */ removeGeometry(geometry) {
        let index;
        if (this._geometriesByUniqueId) {
            index = this._geometriesByUniqueId[geometry.uniqueId];
            if (index === undefined) return false;
        } else {
            index = this.geometries.indexOf(geometry);
            if (index < 0) return false;
        }
        if (index !== this.geometries.length - 1) {
            const lastGeometry = this.geometries[this.geometries.length - 1];
            if (lastGeometry) {
                this.geometries[index] = lastGeometry;
                if (this._geometriesByUniqueId) this._geometriesByUniqueId[lastGeometry.uniqueId] = index;
            }
        }
        if (this._geometriesByUniqueId) this._geometriesByUniqueId[geometry.uniqueId] = undefined;
        this.geometries.pop();
        this.onGeometryRemovedObservable.notifyObservers(geometry);
        return true;
    }
    /**
     * Gets the list of geometries attached to the scene
     * @returns an array of Geometry
     */ getGeometries() {
        return this.geometries;
    }
    /**
     * Gets the first added mesh found of a given Id
     * @param id defines the Id to search for
     * @returns the mesh found or null if not found at all
     */ getMeshById(id) {
        for(let index = 0; index < this.meshes.length; index++){
            if (this.meshes[index].id === id) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a list of meshes using their Id
     * @param id defines the Id to search for
     * @returns a list of meshes
     */ getMeshesById(id) {
        return this.meshes.filter(function(m) {
            return m.id === id;
        });
    }
    /**
     * Gets the first added transform node found of a given Id
     * @param id defines the Id to search for
     * @returns the found transform node or null if not found at all.
     */ getTransformNodeById(id) {
        for(let index = 0; index < this.transformNodes.length; index++){
            if (this.transformNodes[index].id === id) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a transform node with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found transform node or null if not found at all.
     */ getTransformNodeByUniqueId(uniqueId) {
        for(let index = 0; index < this.transformNodes.length; index++){
            if (this.transformNodes[index].uniqueId === uniqueId) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a list of transform nodes using their Id
     * @param id defines the Id to search for
     * @returns a list of transform nodes
     */ getTransformNodesById(id) {
        return this.transformNodes.filter(function(m) {
            return m.id === id;
        });
    }
    /**
     * Gets a mesh with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found mesh or null if not found at all.
     */ getMeshByUniqueId(uniqueId) {
        for(let index = 0; index < this.meshes.length; index++){
            if (this.meshes[index].uniqueId === uniqueId) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a the last added mesh using a given Id
     * @param id defines the Id to search for
     * @returns the found mesh or null if not found at all.
     */ getLastMeshById(id) {
        for(let index = this.meshes.length - 1; index >= 0; index--){
            if (this.meshes[index].id === id) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a the last transform node using a given Id
     * @param id defines the Id to search for
     * @returns the found mesh or null if not found at all.
     */ getLastTransformNodeById(id) {
        for(let index = this.transformNodes.length - 1; index >= 0; index--){
            if (this.transformNodes[index].id === id) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a the last added node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     */ getLastEntryById(id) {
        let index;
        for(index = this.meshes.length - 1; index >= 0; index--){
            if (this.meshes[index].id === id) return this.meshes[index];
        }
        for(index = this.transformNodes.length - 1; index >= 0; index--){
            if (this.transformNodes[index].id === id) return this.transformNodes[index];
        }
        for(index = this.cameras.length - 1; index >= 0; index--){
            if (this.cameras[index].id === id) return this.cameras[index];
        }
        for(index = this.lights.length - 1; index >= 0; index--){
            if (this.lights[index].id === id) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     */ getNodeById(id) {
        const mesh = this.getMeshById(id);
        if (mesh) return mesh;
        const transformNode = this.getTransformNodeById(id);
        if (transformNode) return transformNode;
        const light = this.getLightById(id);
        if (light) return light;
        const camera = this.getCameraById(id);
        if (camera) return camera;
        const bone = this.getBoneById(id);
        if (bone) return bone;
        return null;
    }
    /**
     * Gets a node (Mesh, Camera, Light) using a given name
     * @param name defines the name to search for
     * @returns the found node or null if not found at all.
     */ getNodeByName(name) {
        const mesh = this.getMeshByName(name);
        if (mesh) return mesh;
        const transformNode = this.getTransformNodeByName(name);
        if (transformNode) return transformNode;
        const light = this.getLightByName(name);
        if (light) return light;
        const camera = this.getCameraByName(name);
        if (camera) return camera;
        const bone = this.getBoneByName(name);
        if (bone) return bone;
        return null;
    }
    /**
     * Gets a mesh using a given name
     * @param name defines the name to search for
     * @returns the found mesh or null if not found at all.
     */ getMeshByName(name) {
        for(let index = 0; index < this.meshes.length; index++){
            if (this.meshes[index].name === name) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a transform node using a given name
     * @param name defines the name to search for
     * @returns the found transform node or null if not found at all.
     */ getTransformNodeByName(name) {
        for(let index = 0; index < this.transformNodes.length; index++){
            if (this.transformNodes[index].name === name) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
     * @param id defines the Id to search for
     * @returns the found skeleton or null if not found at all.
     */ getLastSkeletonById(id) {
        for(let index = this.skeletons.length - 1; index >= 0; index--){
            if (this.skeletons[index].id === id) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given auto generated unique id
     * @param  uniqueId defines the unique id to search for
     * @returns the found skeleton or null if not found at all.
     */ getSkeletonByUniqueId(uniqueId) {
        for(let index = 0; index < this.skeletons.length; index++){
            if (this.skeletons[index].uniqueId === uniqueId) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given id (if many are found, this function will pick the first one)
     * @param id defines the id to search for
     * @returns the found skeleton or null if not found at all.
     */ getSkeletonById(id) {
        for(let index = 0; index < this.skeletons.length; index++){
            if (this.skeletons[index].id === id) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given name
     * @param name defines the name to search for
     * @returns the found skeleton or null if not found at all.
     */ getSkeletonByName(name) {
        for(let index = 0; index < this.skeletons.length; index++){
            if (this.skeletons[index].name === name) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a morph target manager  using a given id (if many are found, this function will pick the last one)
     * @param id defines the id to search for
     * @returns the found morph target manager or null if not found at all.
     */ getMorphTargetManagerById(id) {
        for(let index = 0; index < this.morphTargetManagers.length; index++){
            if (this.morphTargetManagers[index].uniqueId === id) return this.morphTargetManagers[index];
        }
        return null;
    }
    /**
     * Gets a morph target using a given id (if many are found, this function will pick the first one)
     * @param id defines the id to search for
     * @returns the found morph target or null if not found at all.
     */ getMorphTargetById(id) {
        for(let managerIndex = 0; managerIndex < this.morphTargetManagers.length; ++managerIndex){
            const morphTargetManager = this.morphTargetManagers[managerIndex];
            for(let index = 0; index < morphTargetManager.numTargets; ++index){
                const target = morphTargetManager.getTarget(index);
                if (target.id === id) return target;
            }
        }
        return null;
    }
    /**
     * Gets a morph target using a given name (if many are found, this function will pick the first one)
     * @param name defines the name to search for
     * @returns the found morph target or null if not found at all.
     */ getMorphTargetByName(name) {
        for(let managerIndex = 0; managerIndex < this.morphTargetManagers.length; ++managerIndex){
            const morphTargetManager = this.morphTargetManagers[managerIndex];
            for(let index = 0; index < morphTargetManager.numTargets; ++index){
                const target = morphTargetManager.getTarget(index);
                if (target.name === name) return target;
            }
        }
        return null;
    }
    /**
     * Gets a post process using a given name (if many are found, this function will pick the first one)
     * @param name defines the name to search for
     * @returns the found post process or null if not found at all.
     */ getPostProcessByName(name) {
        for(let postProcessIndex = 0; postProcessIndex < this.postProcesses.length; ++postProcessIndex){
            const postProcess = this.postProcesses[postProcessIndex];
            if (postProcess.name === name) return postProcess;
        }
        return null;
    }
    /**
     * Gets a boolean indicating if the given mesh is active
     * @param mesh defines the mesh to look for
     * @returns true if the mesh is in the active list
     */ isActiveMesh(mesh) {
        return this._activeMeshes.indexOf(mesh) !== -1;
    }
    /**
     * Return a unique id as a string which can serve as an identifier for the scene
     */ get uid() {
        if (!this._uid) this._uid = (0, $bOhSV.Tools).RandomId();
        return this._uid;
    }
    /**
     * Add an externally attached data from its key.
     * This method call will fail and return false, if such key already exists.
     * If you don't care and just want to get the data no matter what, use the more convenient getOrAddExternalDataWithFactory() method.
     * @param key the unique key that identifies the data
     * @param data the data object to associate to the key for this Engine instance
     * @returns true if no such key were already present and the data was added successfully, false otherwise
     */ addExternalData(key, data) {
        if (!this._externalData) this._externalData = new (0, $895IS.StringDictionary)();
        return this._externalData.add(key, data);
    }
    /**
     * Get an externally attached data from its key
     * @param key the unique key that identifies the data
     * @returns the associated data, if present (can be null), or undefined if not present
     */ getExternalData(key) {
        if (!this._externalData) return null;
        return this._externalData.get(key);
    }
    /**
     * Get an externally attached data from its key, create it using a factory if it's not already present
     * @param key the unique key that identifies the data
     * @param factory the factory that will be called to create the instance if and only if it doesn't exists
     * @returns the associated data, can be null if the factory returned null.
     */ getOrAddExternalDataWithFactory(key, factory) {
        if (!this._externalData) this._externalData = new (0, $895IS.StringDictionary)();
        return this._externalData.getOrAddWithFactory(key, factory);
    }
    /**
     * Remove an externally attached data from the Engine instance
     * @param key the unique key that identifies the data
     * @returns true if the data was successfully removed, false if it doesn't exist
     */ removeExternalData(key) {
        return this._externalData.remove(key);
    }
    _evaluateSubMesh(subMesh, mesh, initialMesh, forcePush) {
        if (forcePush || subMesh.isInFrustum(this._frustumPlanes)) {
            for (const step of this._evaluateSubMeshStage)step.action(mesh, subMesh);
            const material = subMesh.getMaterial();
            if (material !== null && material !== undefined) {
                // Render targets
                if (material.hasRenderTargetTextures && material.getRenderTargetTextures != null) {
                    if (this._processedMaterials.indexOf(material) === -1) {
                        this._processedMaterials.push(material);
                        this._materialsRenderTargets.concatWithNoDuplicate(material.getRenderTargetTextures());
                    }
                }
                // Dispatch
                this._renderingManager.dispatch(subMesh, mesh, material);
            }
        }
    }
    /**
     * Clear the processed materials smart array preventing retention point in material dispose.
     */ freeProcessedMaterials() {
        this._processedMaterials.dispose();
    }
    /** Gets or sets a boolean blocking all the calls to freeActiveMeshes and freeRenderingGroups
     * It can be used in order to prevent going through methods freeRenderingGroups and freeActiveMeshes several times to improve performance
     * when disposing several meshes in a row or a hierarchy of meshes.
     * When used, it is the responsibility of the user to blockfreeActiveMeshesAndRenderingGroups back to false.
     */ get blockfreeActiveMeshesAndRenderingGroups() {
        return this._preventFreeActiveMeshesAndRenderingGroups;
    }
    set blockfreeActiveMeshesAndRenderingGroups(value) {
        if (this._preventFreeActiveMeshesAndRenderingGroups === value) return;
        if (value) {
            this.freeActiveMeshes();
            this.freeRenderingGroups();
        }
        this._preventFreeActiveMeshesAndRenderingGroups = value;
    }
    /**
     * Clear the active meshes smart array preventing retention point in mesh dispose.
     */ freeActiveMeshes() {
        if (this.blockfreeActiveMeshesAndRenderingGroups) return;
        this._activeMeshes.dispose();
        if (this.activeCamera && this.activeCamera._activeMeshes) this.activeCamera._activeMeshes.dispose();
        if (this.activeCameras) for(let i = 0; i < this.activeCameras.length; i++){
            const activeCamera = this.activeCameras[i];
            if (activeCamera && activeCamera._activeMeshes) activeCamera._activeMeshes.dispose();
        }
    }
    /**
     * Clear the info related to rendering groups preventing retention points during dispose.
     */ freeRenderingGroups() {
        if (this.blockfreeActiveMeshesAndRenderingGroups) return;
        if (this._renderingManager) this._renderingManager.freeRenderingGroups();
        if (this.textures) for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            if (texture && texture.renderList) texture.freeRenderingGroups();
        }
    }
    /** @internal */ _isInIntermediateRendering() {
        return this._intermediateRendering;
    }
    /**
     * Use this function to stop evaluating active meshes. The current list will be keep alive between frames
     * @param skipEvaluateActiveMeshes defines an optional boolean indicating that the evaluate active meshes step must be completely skipped
     * @param onSuccess optional success callback
     * @param onError optional error callback
     * @param freezeMeshes defines if meshes should be frozen (true by default)
     * @param keepFrustumCulling defines if you want to keep running the frustum clipping (false by default)
     * @returns the current scene
     */ freezeActiveMeshes(skipEvaluateActiveMeshes = false, onSuccess, onError, freezeMeshes = true, keepFrustumCulling = false) {
        this.executeWhenReady(()=>{
            if (!this.activeCamera) {
                onError && onError("No active camera found");
                return;
            }
            if (!this._frustumPlanes) this.updateTransformMatrix();
            this._evaluateActiveMeshes();
            this._activeMeshesFrozen = true;
            this._activeMeshesFrozenButKeepClipping = keepFrustumCulling;
            this._skipEvaluateActiveMeshesCompletely = skipEvaluateActiveMeshes;
            if (freezeMeshes) for(let index = 0; index < this._activeMeshes.length; index++)this._activeMeshes.data[index]._freeze();
            onSuccess && onSuccess();
        });
        return this;
    }
    /**
     * Use this function to restart evaluating active meshes on every frame
     * @returns the current scene
     */ unfreezeActiveMeshes() {
        for(let index = 0; index < this.meshes.length; index++){
            const mesh = this.meshes[index];
            if (mesh._internalAbstractMeshDataInfo) mesh._internalAbstractMeshDataInfo._isActive = false;
        }
        for(let index = 0; index < this._activeMeshes.length; index++)this._activeMeshes.data[index]._unFreeze();
        this._activeMeshesFrozen = false;
        return this;
    }
    _executeActiveContainerCleanup(container) {
        const isInFastMode = this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1;
        if (!isInFastMode && this._activeMeshesFrozen && this._activeMeshes.length) return; // Do not execute in frozen mode
        // We need to ensure we are not in the rendering loop
        this.onBeforeRenderObservable.addOnce(()=>container.dispose());
    }
    _evaluateActiveMeshes() {
        if (this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1) {
            if (this._activeMeshes.length > 0) {
                this.activeCamera?._activeMeshes.reset();
                this._activeMeshes.reset();
                this._renderingManager.reset();
                this._processedMaterials.reset();
                this._activeParticleSystems.reset();
                this._activeSkeletons.reset();
                this._softwareSkinnedMeshes.reset();
            }
            return;
        }
        if (this._activeMeshesFrozen && this._activeMeshes.length) {
            if (!this._skipEvaluateActiveMeshesCompletely) {
                const len = this._activeMeshes.length;
                for(let i = 0; i < len; i++){
                    const mesh = this._activeMeshes.data[i];
                    mesh.computeWorldMatrix();
                }
            }
            if (this._activeParticleSystems) {
                const psLength = this._activeParticleSystems.length;
                for(let i = 0; i < psLength; i++)this._activeParticleSystems.data[i].animate();
            }
            this._renderingManager.resetSprites();
            return;
        }
        if (!this.activeCamera) return;
        this.onBeforeActiveMeshesEvaluationObservable.notifyObservers(this);
        this.activeCamera._activeMeshes.reset();
        this._activeMeshes.reset();
        this._renderingManager.reset();
        this._processedMaterials.reset();
        this._activeParticleSystems.reset();
        this._activeSkeletons.reset();
        this._softwareSkinnedMeshes.reset();
        this._materialsRenderTargets.reset();
        for (const step of this._beforeEvaluateActiveMeshStage)step.action();
        // Determine mesh candidates
        const meshes = this.getActiveMeshCandidates();
        // Check each mesh
        const len = meshes.length;
        for(let i = 0; i < len; i++){
            const mesh = meshes.data[i];
            let currentLOD = mesh._internalAbstractMeshDataInfo._currentLOD.get(this.activeCamera);
            if (currentLOD) currentLOD[1] = -1;
            else {
                currentLOD = [
                    mesh,
                    -1
                ];
                mesh._internalAbstractMeshDataInfo._currentLOD.set(this.activeCamera, currentLOD);
            }
            if (mesh.isBlocked) continue;
            this._totalVertices.addCount(mesh.getTotalVertices(), false);
            if (!mesh.isReady() || !mesh.isEnabled() || mesh.scaling.hasAZeroComponent) continue;
            mesh.computeWorldMatrix();
            // Intersections
            if (mesh.actionManager && mesh.actionManager.hasSpecificTriggers2(12, 13)) this._meshesForIntersections.pushNoDuplicate(mesh);
            // Switch to current LOD
            let meshToRender = this.customLODSelector ? this.customLODSelector(mesh, this.activeCamera) : mesh.getLOD(this.activeCamera);
            currentLOD[0] = meshToRender;
            currentLOD[1] = this._frameId;
            if (meshToRender === undefined || meshToRender === null) continue;
            // Compute world matrix if LOD is billboard
            if (meshToRender !== mesh && meshToRender.billboardMode !== 0) meshToRender.computeWorldMatrix();
            mesh._preActivate();
            if (mesh.isVisible && mesh.visibility > 0 && (mesh.layerMask & this.activeCamera.layerMask) !== 0 && (this._skipFrustumClipping || mesh.alwaysSelectAsActiveMesh || mesh.isInFrustum(this._frustumPlanes))) {
                this._activeMeshes.push(mesh);
                this.activeCamera._activeMeshes.push(mesh);
                if (meshToRender !== mesh) meshToRender._activate(this._renderId, false);
                for (const step of this._preActiveMeshStage)step.action(mesh);
                if (mesh._activate(this._renderId, false)) {
                    if (!mesh.isAnInstance) meshToRender._internalAbstractMeshDataInfo._onlyForInstances = false;
                    else if (mesh._internalAbstractMeshDataInfo._actAsRegularMesh) meshToRender = mesh;
                    meshToRender._internalAbstractMeshDataInfo._isActive = true;
                    this._activeMesh(mesh, meshToRender);
                }
                mesh._postActivate();
            }
        }
        this.onAfterActiveMeshesEvaluationObservable.notifyObservers(this);
        // Particle systems
        if (this.particlesEnabled) {
            this.onBeforeParticlesRenderingObservable.notifyObservers(this);
            for(let particleIndex = 0; particleIndex < this.particleSystems.length; particleIndex++){
                const particleSystem = this.particleSystems[particleIndex];
                if (!particleSystem.isStarted() || !particleSystem.emitter) continue;
                const emitter = particleSystem.emitter;
                if (!emitter.position || emitter.isEnabled()) {
                    this._activeParticleSystems.push(particleSystem);
                    particleSystem.animate();
                    this._renderingManager.dispatchParticles(particleSystem);
                }
            }
            this.onAfterParticlesRenderingObservable.notifyObservers(this);
        }
    }
    /** @internal */ _prepareSkeleton(mesh) {
        if (!this._skeletonsEnabled || !mesh.skeleton) return;
        if (this._activeSkeletons.pushNoDuplicate(mesh.skeleton)) {
            mesh.skeleton.prepare();
            this._activeBones.addCount(mesh.skeleton.bones.length, false);
        }
        if (!mesh.computeBonesUsingShaders) {
            if (this._softwareSkinnedMeshes.pushNoDuplicate(mesh) && this.frameGraph) mesh.applySkeleton(mesh.skeleton);
        }
    }
    _activeMesh(sourceMesh, mesh) {
        this._prepareSkeleton(mesh);
        let forcePush = sourceMesh.hasInstances || sourceMesh.isAnInstance || this.dispatchAllSubMeshesOfActiveMeshes || this._skipFrustumClipping || mesh.alwaysSelectAsActiveMesh;
        if (mesh && mesh.subMeshes && mesh.subMeshes.length > 0) {
            const subMeshes = this.getActiveSubMeshCandidates(mesh);
            const len = subMeshes.length;
            forcePush = forcePush || len === 1;
            for(let i = 0; i < len; i++){
                const subMesh = subMeshes.data[i];
                this._evaluateSubMesh(subMesh, mesh, sourceMesh, forcePush);
            }
        }
    }
    /**
     * Update the transform matrix to update from the current active camera
     * @param force defines a boolean used to force the update even if cache is up to date
     */ updateTransformMatrix(force) {
        const activeCamera = this.activeCamera;
        if (!activeCamera) return;
        if (activeCamera._renderingMultiview) {
            const leftCamera = activeCamera._rigCameras[0];
            const rightCamera = activeCamera._rigCameras[1];
            this.setTransformMatrix(leftCamera.getViewMatrix(), leftCamera.getProjectionMatrix(force), rightCamera.getViewMatrix(), rightCamera.getProjectionMatrix(force));
        } else this.setTransformMatrix(activeCamera.getViewMatrix(), activeCamera.getProjectionMatrix(force));
    }
    _bindFrameBuffer(camera, clear = true) {
        if (camera && camera._multiviewTexture) camera._multiviewTexture._bindFrameBuffer();
        else if (camera && camera.outputRenderTarget) camera.outputRenderTarget._bindFrameBuffer();
        else if (!this._engine._currentFrameBufferIsDefaultFrameBuffer()) this._engine.restoreDefaultFramebuffer();
        if (clear) this._clearFrameBuffer(camera);
    }
    _clearFrameBuffer(camera) {
        // we assume the framebuffer currently bound is the right one
        if (camera && camera._multiviewTexture) ;
        else if (camera && camera.outputRenderTarget && !camera._renderingMultiview) {
            const rtt = camera.outputRenderTarget;
            if (rtt.onClearObservable.hasObservers()) rtt.onClearObservable.notifyObservers(this._engine);
            else if (!rtt.skipInitialClear && !camera.isRightCamera) {
                if (this.autoClear) this._engine.clear(rtt.clearColor || this._clearColor, !rtt._cleared, true, true);
                rtt._cleared = true;
            }
        } else if (!this._defaultFrameBufferCleared) {
            this._defaultFrameBufferCleared = true;
            this._clear();
        } else this._engine.clear(null, false, true, true);
    }
    /**
     * @internal
     */ _renderForCamera(camera, rigParent, bindFrameBuffer = true) {
        if (camera && camera._skipRendering) return;
        const engine = this._engine;
        // Use _activeCamera instead of activeCamera to avoid onActiveCameraChanged
        this._activeCamera = camera;
        if (!this.activeCamera) throw new Error("Active camera not set");
        // Viewport
        engine.setViewport(this.activeCamera.viewport);
        // Camera
        this.resetCachedMaterial();
        this._renderId++;
        if (!this.prePass && bindFrameBuffer) {
            let skipInitialClear = true;
            if (camera._renderingMultiview && camera.outputRenderTarget) {
                skipInitialClear = camera.outputRenderTarget.skipInitialClear;
                if (this.autoClear) {
                    this._defaultFrameBufferCleared = false;
                    camera.outputRenderTarget.skipInitialClear = false;
                }
            }
            this._bindFrameBuffer(this._activeCamera);
            if (camera._renderingMultiview && camera.outputRenderTarget) camera.outputRenderTarget.skipInitialClear = skipInitialClear;
        }
        this.updateTransformMatrix();
        this.onBeforeCameraRenderObservable.notifyObservers(this.activeCamera);
        // Meshes
        this._evaluateActiveMeshes();
        // Software skinning
        for(let softwareSkinnedMeshIndex = 0; softwareSkinnedMeshIndex < this._softwareSkinnedMeshes.length; softwareSkinnedMeshIndex++){
            const mesh = this._softwareSkinnedMeshes.data[softwareSkinnedMeshIndex];
            mesh.applySkeleton(mesh.skeleton);
        }
        // Render targets
        this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
        this._renderTargets.concatWithNoDuplicate(this._materialsRenderTargets);
        if (camera.customRenderTargets && camera.customRenderTargets.length > 0) this._renderTargets.concatWithNoDuplicate(camera.customRenderTargets);
        if (rigParent && rigParent.customRenderTargets && rigParent.customRenderTargets.length > 0) this._renderTargets.concatWithNoDuplicate(rigParent.customRenderTargets);
        if (this.environmentTexture && this.environmentTexture.isRenderTarget) this._renderTargets.pushNoDuplicate(this.environmentTexture);
        // Collects render targets from external components.
        for (const step of this._gatherActiveCameraRenderTargetsStage)step.action(this._renderTargets);
        let needRebind = false;
        if (this.renderTargetsEnabled) {
            this._intermediateRendering = true;
            if (this._renderTargets.length > 0) {
                (0, $bOhSV.Tools).StartPerformanceCounter("Render targets", this._renderTargets.length > 0);
                for(let renderIndex = 0; renderIndex < this._renderTargets.length; renderIndex++){
                    const renderTarget = this._renderTargets.data[renderIndex];
                    if (renderTarget._shouldRender()) {
                        this._renderId++;
                        const hasSpecialRenderTargetCamera = renderTarget.activeCamera && renderTarget.activeCamera !== this.activeCamera;
                        renderTarget.render(hasSpecialRenderTargetCamera, this.dumpNextRenderTargets);
                        needRebind = true;
                    }
                }
                (0, $bOhSV.Tools).EndPerformanceCounter("Render targets", this._renderTargets.length > 0);
                this._renderId++;
            }
            for (const step of this._cameraDrawRenderTargetStage)needRebind = step.action(this.activeCamera) || needRebind;
            this._intermediateRendering = false;
        }
        this._engine.currentRenderPassId = camera.outputRenderTarget?.renderPassId ?? camera.renderPassId ?? 0;
        // Restore framebuffer after rendering to targets
        if (needRebind && !this.prePass) {
            this._bindFrameBuffer(this._activeCamera, false);
            this.updateTransformMatrix();
        }
        this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
        // Prepare Frame
        if (this.postProcessManager && !camera._multiviewTexture && !this.prePass) this.postProcessManager._prepareFrame();
        // Before Camera Draw
        for (const step of this._beforeCameraDrawStage)step.action(this.activeCamera);
        // Render
        this.onBeforeDrawPhaseObservable.notifyObservers(this);
        if (engine.snapshotRendering && engine.snapshotRenderingMode === 1) this.finalizeSceneUbo();
        this._renderingManager.render(null, null, true, true);
        this.onAfterDrawPhaseObservable.notifyObservers(this);
        // After Camera Draw
        for (const step of this._afterCameraDrawStage)step.action(this.activeCamera);
        // Finalize frame
        if (this.postProcessManager && !camera._multiviewTexture) {
            // if the camera has an output render target, render the post process to the render target
            const texture = camera.outputRenderTarget ? camera.outputRenderTarget.renderTarget : undefined;
            this.postProcessManager._finalizeFrame(camera.isIntermediate, texture);
        }
        // After post process
        for (const step of this._afterCameraPostProcessStage)step.action(this.activeCamera);
        // Reset some special arrays
        this._renderTargets.reset();
        this.onAfterCameraRenderObservable.notifyObservers(this.activeCamera);
    }
    _processSubCameras(camera, bindFrameBuffer = true) {
        if (camera.cameraRigMode === 0 || camera._renderingMultiview) {
            if (camera._renderingMultiview && !this._multiviewSceneUbo) this._createMultiviewUbo();
            this._renderForCamera(camera, undefined, bindFrameBuffer);
            this.onAfterRenderCameraObservable.notifyObservers(camera);
            return;
        }
        if (camera._useMultiviewToSingleView) this._renderMultiviewToSingleView(camera);
        else {
            // rig cameras
            this.onBeforeCameraRenderObservable.notifyObservers(camera);
            for(let index = 0; index < camera._rigCameras.length; index++)this._renderForCamera(camera._rigCameras[index], camera);
        }
        // Use _activeCamera instead of activeCamera to avoid onActiveCameraChanged
        this._activeCamera = camera;
        this.updateTransformMatrix();
        this.onAfterRenderCameraObservable.notifyObservers(camera);
    }
    _checkIntersections() {
        for(let index = 0; index < this._meshesForIntersections.length; index++){
            const sourceMesh = this._meshesForIntersections.data[index];
            if (!sourceMesh.actionManager) continue;
            for(let actionIndex = 0; sourceMesh.actionManager && actionIndex < sourceMesh.actionManager.actions.length; actionIndex++){
                const action = sourceMesh.actionManager.actions[actionIndex];
                if (action.trigger === 12 || action.trigger === 13) {
                    const parameters = action.getTriggerParameter();
                    const otherMesh = parameters.mesh ? parameters.mesh : parameters;
                    const areIntersecting = otherMesh.intersectsMesh(sourceMesh, parameters.usePreciseIntersection);
                    const currentIntersectionInProgress = sourceMesh._intersectionsInProgress.indexOf(otherMesh);
                    if (areIntersecting && currentIntersectionInProgress === -1) {
                        if (action.trigger === 12) {
                            action._executeCurrent((0, $cmj0B.ActionEvent).CreateNew(sourceMesh, undefined, otherMesh));
                            sourceMesh._intersectionsInProgress.push(otherMesh);
                        } else if (action.trigger === 13) sourceMesh._intersectionsInProgress.push(otherMesh);
                    } else if (!areIntersecting && currentIntersectionInProgress > -1) {
                        //They intersected, and now they don't.
                        //is this trigger an exit trigger? execute an event.
                        if (action.trigger === 13) action._executeCurrent((0, $cmj0B.ActionEvent).CreateNew(sourceMesh, undefined, otherMesh));
                        //if this is an exit trigger, or no exit trigger exists, remove the id from the intersection in progress array.
                        if (!sourceMesh.actionManager.hasSpecificTrigger(13, (parameter)=>{
                            const parameterMesh = parameter.mesh ? parameter.mesh : parameter;
                            return otherMesh === parameterMesh;
                        }) || action.trigger === 13) sourceMesh._intersectionsInProgress.splice(currentIntersectionInProgress, 1);
                    }
                }
            }
        }
    }
    /**
     * @internal
     */ _advancePhysicsEngineStep(step) {
    // Do nothing. Code will be replaced if physics engine component is referenced
    }
    /** @internal */ _animate(customDeltaTime) {
    // Nothing to do as long as Animatable have not been imported.
    }
    /** Execute all animations (for a frame) */ animate() {
        if (this._engine.isDeterministicLockStep()) {
            let deltaTime = Math.max($be87b65ec8caf46b$export$38af1803e3442a7f.MinDeltaTime, Math.min(this._engine.getDeltaTime(), $be87b65ec8caf46b$export$38af1803e3442a7f.MaxDeltaTime)) + this._timeAccumulator;
            const defaultFrameTime = this._engine.getTimeStep();
            const defaultFPS = 1000.0 / defaultFrameTime / 1000.0;
            let stepsTaken = 0;
            const maxSubSteps = this._engine.getLockstepMaxSteps();
            let internalSteps = Math.floor(deltaTime / defaultFrameTime);
            internalSteps = Math.min(internalSteps, maxSubSteps);
            while(deltaTime > 0 && stepsTaken < internalSteps){
                this.onBeforeStepObservable.notifyObservers(this);
                // Animations
                this._animationRatio = defaultFrameTime * defaultFPS;
                this._animate(defaultFrameTime);
                this.onAfterAnimationsObservable.notifyObservers(this);
                // Physics
                if (this.physicsEnabled) this._advancePhysicsEngineStep(defaultFrameTime);
                this.onAfterStepObservable.notifyObservers(this);
                this._currentStepId++;
                stepsTaken++;
                deltaTime -= defaultFrameTime;
            }
            this._timeAccumulator = deltaTime < 0 ? 0 : deltaTime;
        } else {
            // Animations
            const deltaTime = this.useConstantAnimationDeltaTime ? 16 : Math.max($be87b65ec8caf46b$export$38af1803e3442a7f.MinDeltaTime, Math.min(this._engine.getDeltaTime(), $be87b65ec8caf46b$export$38af1803e3442a7f.MaxDeltaTime));
            this._animationRatio = deltaTime * 0.06;
            this._animate();
            this.onAfterAnimationsObservable.notifyObservers(this);
            // Physics
            if (this.physicsEnabled) this._advancePhysicsEngineStep(deltaTime);
        }
    }
    _clear() {
        if (this.autoClearDepthAndStencil || this.autoClear) this._engine.clear(this._clearColor, this.autoClear || this.forceWireframe || this.forcePointsCloud, this.autoClearDepthAndStencil, this.autoClearDepthAndStencil);
    }
    _checkCameraRenderTarget(camera) {
        if (camera?.outputRenderTarget && !camera?.isRigCamera) camera.outputRenderTarget._cleared = false;
        if (camera?.rigCameras?.length) for(let i = 0; i < camera.rigCameras.length; ++i){
            const rtt = camera.rigCameras[i].outputRenderTarget;
            if (rtt) rtt._cleared = false;
        }
    }
    /**
     * Resets the draw wrappers cache of all meshes
     * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
     */ resetDrawCache(passId) {
        if (!this.meshes) return;
        for (const mesh of this.meshes)mesh.resetDrawCache(passId);
    }
    _renderWithFrameGraph(updateCameras = true, ignoreAnimations = false) {
        this.activeCamera = null;
        this._activeParticleSystems.reset();
        this._activeSkeletons.reset();
        // Update Cameras
        if (updateCameras) for (const camera of this.cameras){
            camera.update();
            if (camera.cameraRigMode !== 0) // rig cameras
            for(let index = 0; index < camera._rigCameras.length; index++)camera._rigCameras[index].update();
        }
        // We must keep these steps because the procedural texture component relies on them.
        // TODO: move the procedural texture component to the frame graph.
        for (const step of this._beforeClearStage)step.action();
        // Process meshes
        const meshes = this.getActiveMeshCandidates();
        const len = meshes.length;
        for(let i = 0; i < len; i++){
            const mesh = meshes.data[i];
            if (mesh.isBlocked) continue;
            this._totalVertices.addCount(mesh.getTotalVertices(), false);
            if (!mesh.isReady() || !mesh.isEnabled() || mesh.scaling.hasAZeroComponent) continue;
            mesh.computeWorldMatrix();
            if (mesh.actionManager && mesh.actionManager.hasSpecificTriggers2(12, 13)) this._meshesForIntersections.pushNoDuplicate(mesh);
        }
        // Animate Particle systems
        if (this.particlesEnabled) for(let particleIndex = 0; particleIndex < this.particleSystems.length; particleIndex++){
            const particleSystem = this.particleSystems[particleIndex];
            if (!particleSystem.isStarted() || !particleSystem.emitter) continue;
            const emitter = particleSystem.emitter;
            if (!emitter.position || emitter.isEnabled()) {
                this._activeParticleSystems.push(particleSystem);
                particleSystem.animate();
            }
        }
        // Render the graph
        this.frameGraph?.execute();
    }
    /**
     * Render the scene
     * @param updateCameras defines a boolean indicating if cameras must update according to their inputs (true by default)
     * @param ignoreAnimations defines a boolean indicating if animations should not be executed (false by default)
     */ render(updateCameras = true, ignoreAnimations = false) {
        if (this.isDisposed) return;
        if (this.onReadyObservable.hasObservers() && this._executeWhenReadyTimeoutId === null) this._checkIsReady();
        this._frameId++;
        this._defaultFrameBufferCleared = false;
        this._checkCameraRenderTarget(this.activeCamera);
        if (this.activeCameras?.length) this.activeCameras.forEach(this._checkCameraRenderTarget);
        // Register components that have been associated lately to the scene.
        this._registerTransientComponents();
        this._activeParticles.fetchNewFrame();
        this._totalVertices.fetchNewFrame();
        this._activeIndices.fetchNewFrame();
        this._activeBones.fetchNewFrame();
        this._meshesForIntersections.reset();
        this.resetCachedMaterial();
        this.onBeforeAnimationsObservable.notifyObservers(this);
        // Actions
        if (this.actionManager) this.actionManager.processTrigger(11);
        // Animations
        if (!ignoreAnimations) this.animate();
        // Before camera update steps
        for (const step of this._beforeCameraUpdateStage)step.action();
        // Update Cameras
        if (updateCameras) {
            if (this.activeCameras && this.activeCameras.length > 0) for(let cameraIndex = 0; cameraIndex < this.activeCameras.length; cameraIndex++){
                const camera = this.activeCameras[cameraIndex];
                camera.update();
                if (camera.cameraRigMode !== 0) // rig cameras
                for(let index = 0; index < camera._rigCameras.length; index++)camera._rigCameras[index].update();
            }
            else if (this.activeCamera) {
                this.activeCamera.update();
                if (this.activeCamera.cameraRigMode !== 0) // rig cameras
                for(let index = 0; index < this.activeCamera._rigCameras.length; index++)this.activeCamera._rigCameras[index].update();
            }
        }
        // Before render
        this.onBeforeRenderObservable.notifyObservers(this);
        // Custom render function?
        if (this.customRenderFunction) {
            this._renderId++;
            this._engine.currentRenderPassId = 0;
            this.customRenderFunction(updateCameras, ignoreAnimations);
        } else {
            const engine = this.getEngine();
            // Customs render targets
            this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
            const currentActiveCamera = this.activeCameras?.length ? this.activeCameras[0] : this.activeCamera;
            if (this.renderTargetsEnabled) {
                (0, $bOhSV.Tools).StartPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0);
                this._intermediateRendering = true;
                for(let customIndex = 0; customIndex < this.customRenderTargets.length; customIndex++){
                    const renderTarget = this.customRenderTargets[customIndex];
                    if (renderTarget._shouldRender()) {
                        this._renderId++;
                        this.activeCamera = renderTarget.activeCamera || this.activeCamera;
                        if (!this.activeCamera) throw new Error("Active camera not set");
                        // Viewport
                        engine.setViewport(this.activeCamera.viewport);
                        // Camera
                        this.updateTransformMatrix();
                        renderTarget.render(currentActiveCamera !== this.activeCamera, this.dumpNextRenderTargets);
                    }
                }
                (0, $bOhSV.Tools).EndPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0);
                this._intermediateRendering = false;
                this._renderId++;
            }
            this._engine.currentRenderPassId = currentActiveCamera?.renderPassId ?? 0;
            // Restore back buffer
            this.activeCamera = currentActiveCamera;
            if (this._activeCamera && this._activeCamera.cameraRigMode !== 22 && !this.prePass) this._bindFrameBuffer(this._activeCamera, false);
            this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
            for (const step of this._beforeClearStage)step.action();
            // Clear
            this._clearFrameBuffer(this.activeCamera);
            // Collects render targets from external components.
            for (const step of this._gatherRenderTargetsStage)step.action(this._renderTargets);
            // Multi-cameras?
            if (this.activeCameras && this.activeCameras.length > 0) for(let cameraIndex = 0; cameraIndex < this.activeCameras.length; cameraIndex++)this._processSubCameras(this.activeCameras[cameraIndex], cameraIndex > 0);
            else {
                if (!this.activeCamera) throw new Error("No camera defined");
                this._processSubCameras(this.activeCamera, !!this.activeCamera.outputRenderTarget);
            }
        }
        // Intersection checks
        this._checkIntersections();
        // Executes the after render stage actions.
        for (const step of this._afterRenderStage)step.action();
        // After render
        if (this.afterRender) this.afterRender();
        this.onAfterRenderObservable.notifyObservers(this);
        // Cleaning
        if (this._toBeDisposed.length) {
            for(let index = 0; index < this._toBeDisposed.length; index++){
                const data = this._toBeDisposed[index];
                if (data) data.dispose();
            }
            this._toBeDisposed.length = 0;
        }
        if (this.dumpNextRenderTargets) this.dumpNextRenderTargets = false;
        this._activeBones.addCount(0, true);
        this._activeIndices.addCount(0, true);
        this._activeParticles.addCount(0, true);
        this._engine.restoreDefaultFramebuffer();
    }
    /**
     * Freeze all materials
     * A frozen material will not be updatable but should be faster to render
     * Note: multimaterials will not be frozen, but their submaterials will
     */ freezeMaterials() {
        for(let i = 0; i < this.materials.length; i++)this.materials[i].freeze();
    }
    /**
     * Unfreeze all materials
     * A frozen material will not be updatable but should be faster to render
     */ unfreezeMaterials() {
        for(let i = 0; i < this.materials.length; i++)this.materials[i].unfreeze();
    }
    /**
     * Releases all held resources
     */ dispose() {
        if (this.isDisposed) return;
        this.beforeRender = null;
        this.afterRender = null;
        this.metadata = null;
        this.skeletons.length = 0;
        this.morphTargetManagers.length = 0;
        this._transientComponents.length = 0;
        this._isReadyForMeshStage.clear();
        this._beforeEvaluateActiveMeshStage.clear();
        this._evaluateSubMeshStage.clear();
        this._preActiveMeshStage.clear();
        this._cameraDrawRenderTargetStage.clear();
        this._beforeCameraDrawStage.clear();
        this._beforeRenderTargetDrawStage.clear();
        this._beforeRenderingGroupDrawStage.clear();
        this._beforeRenderingMeshStage.clear();
        this._afterRenderingMeshStage.clear();
        this._afterRenderingGroupDrawStage.clear();
        this._afterCameraDrawStage.clear();
        this._afterRenderTargetDrawStage.clear();
        this._afterRenderStage.clear();
        this._beforeCameraUpdateStage.clear();
        this._beforeClearStage.clear();
        this._gatherRenderTargetsStage.clear();
        this._gatherActiveCameraRenderTargetsStage.clear();
        this._pointerMoveStage.clear();
        this._pointerDownStage.clear();
        this._pointerUpStage.clear();
        this.importedMeshesFiles = [];
        if (this._activeAnimatables && this.stopAllAnimations) {
            // Ensures that no animatable notifies a callback that could start a new animation group, constantly adding new animatables to the active list...
            this._activeAnimatables.forEach((animatable)=>{
                animatable.onAnimationEndObservable.clear();
                animatable.onAnimationEnd = null;
            });
            this.stopAllAnimations();
        }
        this.resetCachedMaterial();
        // Smart arrays
        if (this.activeCamera) {
            this.activeCamera._activeMeshes.dispose();
            this.activeCamera = null;
        }
        this.activeCameras = null;
        this._activeMeshes.dispose();
        this._renderingManager.dispose();
        this._processedMaterials.dispose();
        this._activeParticleSystems.dispose();
        this._activeSkeletons.dispose();
        this._softwareSkinnedMeshes.dispose();
        this._renderTargets.dispose();
        this._materialsRenderTargets.dispose();
        this._registeredForLateAnimationBindings.dispose();
        this._meshesForIntersections.dispose();
        this._toBeDisposed.length = 0;
        // Abort active requests
        const activeRequests = this._activeRequests.slice();
        for (const request of activeRequests)request.abort();
        this._activeRequests.length = 0;
        // Events
        try {
            this.onDisposeObservable.notifyObservers(this);
        } catch (e) {
            (0, $kVtWi.Logger).Error("An error occurred while calling onDisposeObservable!", e);
        }
        this.detachControl();
        // Detach cameras
        const canvas = this._engine.getInputElement();
        if (canvas) for(let index = 0; index < this.cameras.length; index++)this.cameras[index].detachControl();
        // Release animation groups
        this._disposeList(this.animationGroups);
        // Release lights
        this._disposeList(this.lights);
        // Release materials
        if (this._defaultMaterial) this._defaultMaterial.dispose();
        this._disposeList(this.multiMaterials);
        this._disposeList(this.materials);
        // Release meshes
        this._disposeList(this.meshes, (item)=>item.dispose(true));
        this._disposeList(this.transformNodes, (item)=>item.dispose(true));
        // Release cameras
        const cameras = this.cameras;
        this._disposeList(cameras);
        // Release particles
        this._disposeList(this.particleSystems);
        // Release postProcesses
        this._disposeList(this.postProcesses);
        // Release textures
        this._disposeList(this.textures);
        // Release morph targets
        this._disposeList(this.morphTargetManagers);
        // Release UBO
        this._sceneUbo.dispose();
        if (this._multiviewSceneUbo) this._multiviewSceneUbo.dispose();
        // Post-processes
        this.postProcessManager.dispose();
        // Components
        this._disposeList(this._components);
        // Remove from engine
        let index = this._engine.scenes.indexOf(this);
        if (index > -1) this._engine.scenes.splice(index, 1);
        if ((0, $ejQPp.EngineStore)._LastCreatedScene === this) {
            (0, $ejQPp.EngineStore)._LastCreatedScene = null;
            let engineIndex = (0, $ejQPp.EngineStore).Instances.length - 1;
            while(engineIndex >= 0){
                const engine = (0, $ejQPp.EngineStore).Instances[engineIndex];
                if (engine.scenes.length > 0) {
                    (0, $ejQPp.EngineStore)._LastCreatedScene = engine.scenes[this._engine.scenes.length - 1];
                    break;
                }
                engineIndex--;
            }
        }
        index = this._engine._virtualScenes.indexOf(this);
        if (index > -1) this._engine._virtualScenes.splice(index, 1);
        this._engine.wipeCaches(true);
        this.onDisposeObservable.clear();
        this.onBeforeRenderObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onBeforeRenderTargetsRenderObservable.clear();
        this.onAfterRenderTargetsRenderObservable.clear();
        this.onAfterStepObservable.clear();
        this.onBeforeStepObservable.clear();
        this.onBeforeActiveMeshesEvaluationObservable.clear();
        this.onAfterActiveMeshesEvaluationObservable.clear();
        this.onBeforeParticlesRenderingObservable.clear();
        this.onAfterParticlesRenderingObservable.clear();
        this.onBeforeDrawPhaseObservable.clear();
        this.onAfterDrawPhaseObservable.clear();
        this.onBeforeAnimationsObservable.clear();
        this.onAfterAnimationsObservable.clear();
        this.onDataLoadedObservable.clear();
        this.onBeforeRenderingGroupObservable.clear();
        this.onAfterRenderingGroupObservable.clear();
        this.onMeshImportedObservable.clear();
        this.onBeforeCameraRenderObservable.clear();
        this.onAfterCameraRenderObservable.clear();
        this.onAfterRenderCameraObservable.clear();
        this.onReadyObservable.clear();
        this.onNewCameraAddedObservable.clear();
        this.onCameraRemovedObservable.clear();
        this.onNewLightAddedObservable.clear();
        this.onLightRemovedObservable.clear();
        this.onNewGeometryAddedObservable.clear();
        this.onGeometryRemovedObservable.clear();
        this.onNewTransformNodeAddedObservable.clear();
        this.onTransformNodeRemovedObservable.clear();
        this.onNewMeshAddedObservable.clear();
        this.onMeshRemovedObservable.clear();
        this.onNewSkeletonAddedObservable.clear();
        this.onSkeletonRemovedObservable.clear();
        this.onNewMaterialAddedObservable.clear();
        this.onNewMultiMaterialAddedObservable.clear();
        this.onMaterialRemovedObservable.clear();
        this.onMultiMaterialRemovedObservable.clear();
        this.onNewTextureAddedObservable.clear();
        this.onTextureRemovedObservable.clear();
        this.onPrePointerObservable.clear();
        this.onPointerObservable.clear();
        this.onPreKeyboardObservable.clear();
        this.onKeyboardObservable.clear();
        this.onActiveCameraChanged.clear();
        this.onScenePerformancePriorityChangedObservable.clear();
        this.onClearColorChangedObservable.clear();
        this.onEnvironmentTextureChangedObservable.clear();
        this.onMeshUnderPointerUpdatedObservable.clear();
        this._isDisposed = true;
    }
    _disposeList(items, callback) {
        const itemsCopy = items.slice(0);
        callback = callback ?? ((item)=>item.dispose());
        for (const item of itemsCopy)callback(item);
        items.length = 0;
    }
    /**
     * Gets if the scene is already disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Call this function to reduce memory footprint of the scene.
     * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
     */ clearCachedVertexData() {
        for(let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++){
            const mesh = this.meshes[meshIndex];
            const geometry = mesh.geometry;
            if (geometry) geometry.clearCachedData();
        }
    }
    /**
     * This function will remove the local cached buffer data from texture.
     * It will save memory but will prevent the texture from being rebuilt
     */ cleanCachedTextureBuffer() {
        for (const baseTexture of this.textures){
            const buffer = baseTexture._buffer;
            if (buffer) baseTexture._buffer = null;
        }
    }
    /**
     * Get the world extend vectors with an optional filter
     *
     * @param filterPredicate the predicate - which meshes should be included when calculating the world size
     * @returns {{ min: Vector3; max: Vector3 }} min and max vectors
     */ getWorldExtends(filterPredicate) {
        const min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        filterPredicate = filterPredicate || (()=>true);
        this.meshes.filter(filterPredicate).forEach((mesh)=>{
            mesh.computeWorldMatrix(true);
            if (!mesh.subMeshes || mesh.subMeshes.length === 0 || mesh.infiniteDistance) return;
            const boundingInfo = mesh.getBoundingInfo();
            const minBox = boundingInfo.boundingBox.minimumWorld;
            const maxBox = boundingInfo.boundingBox.maximumWorld;
            (0, $ha1VO.Vector3).CheckExtends(minBox, min, max);
            (0, $ha1VO.Vector3).CheckExtends(maxBox, min, max);
        });
        return {
            min: min,
            max: max
        };
    }
    // Picking
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
     * @param camera defines the camera to use for the picking
     * @param cameraViewSpace defines if picking will be done in view space (false by default)
     * @returns a Ray
     */ createPickingRay(x, y, world, camera, cameraViewSpace = false) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
     * @param result defines the ray where to store the picking ray
     * @param camera defines the camera to use for the picking
     * @param cameraViewSpace defines if picking will be done in view space (false by default)
     * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
     * @returns the current scene
     */ createPickingRayToRef(x, y, world, result, camera, cameraViewSpace = false, enableDistantPicking = false) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param camera defines the camera to use for the picking
     * @returns a Ray
     */ createPickingRayInCameraSpace(x, y, camera) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param result defines the ray where to store the picking ray
     * @param camera defines the camera to use for the picking
     * @returns the current scene
     */ createPickingRayInCameraSpaceToRef(x, y, result, camera) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    /** Launch a ray to try to pick a mesh in the scene
     * @param x position on screen
     * @param y position on screen
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true. thinInstanceIndex is -1 when the mesh is non-instanced
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns a PickingInfo
     */ pick(x, y, predicate, fastCheck, camera, trianglePredicate) {
        const warn = (0, $dUFYy._WarnImport)("Ray", true);
        if (warn) (0, $kVtWi.Logger).Warn(warn);
        // Dummy info if picking as not been imported
        return new (0, $gzCma.PickingInfo)();
    }
    /** Launch a ray to try to pick a mesh in the scene using only bounding information of the main mesh (not using submeshes)
     * @param x position on screen
     * @param y position on screen
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true. thinInstanceIndex is -1 when the mesh is non-instanced
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
     * @returns a PickingInfo (Please note that some info will not be set like distance, bv, bu and everything that cannot be capture by only using bounding infos)
     */ pickWithBoundingInfo(x, y, predicate, fastCheck, camera) {
        const warn = (0, $dUFYy._WarnImport)("Ray", true);
        if (warn) (0, $kVtWi.Logger).Warn(warn);
        // Dummy info if picking as not been imported
        return new (0, $gzCma.PickingInfo)();
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Use the given ray to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param ray The ray to use to pick meshes
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must have isPickable set to true. thinInstanceIndex is -1 when the mesh is non-instanced
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns a PickingInfo
     */ pickWithRay(ray, predicate, fastCheck, trianglePredicate) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Launch a ray to try to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param x X position on screen
     * @param y Y position on screen
     * @param predicate Predicate function used to determine eligible meshes and instances. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true. thinInstanceIndex is -1 when the mesh is non-instanced
     * @param camera camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns an array of PickingInfo
     */ multiPick(x, y, predicate, camera, trianglePredicate) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Launch a ray to try to pick a mesh in the scene
     * @param ray Ray to use
     * @param predicate Predicate function used to determine eligible meshes and instances. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true. thinInstanceIndex is -1 when the mesh is non-instanced
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns an array of PickingInfo
     */ multiPickWithRay(ray, predicate, trianglePredicate) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    /**
     * Force the value of meshUnderPointer
     * @param mesh defines the mesh to use
     * @param pointerId optional pointer id when using more than one pointer
     * @param pickResult optional pickingInfo data used to find mesh
     */ setPointerOverMesh(mesh, pointerId, pickResult) {
        this._inputManager.setPointerOverMesh(mesh, pointerId, pickResult);
    }
    /**
     * Gets the mesh under the pointer
     * @returns a Mesh or null if no mesh is under the pointer
     */ getPointerOverMesh() {
        return this._inputManager.getPointerOverMesh();
    }
    // Misc.
    /** @internal */ _rebuildGeometries() {
        for (const geometry of this.geometries)geometry._rebuild();
        for (const mesh of this.meshes)mesh._rebuild();
        if (this.postProcessManager) this.postProcessManager._rebuild();
        for (const component of this._components)component.rebuild();
        for (const system of this.particleSystems)system.rebuild();
        if (this.spriteManagers) for (const spriteMgr of this.spriteManagers)spriteMgr.rebuild();
    }
    /** @internal */ _rebuildTextures() {
        for (const texture of this.textures)texture._rebuild(true);
        this.markAllMaterialsAsDirty(1);
    }
    /**
     * Get from a list of objects by tags
     * @param list the list of objects to use
     * @param tagsQuery the query to use
     * @param filter a predicate to filter for tags
     * @returns
     */ _getByTags(list, tagsQuery, filter) {
        if (tagsQuery === undefined) // returns the complete list (could be done with Tags.MatchesQuery but no need to have a for-loop here)
        return list;
        const listByTags = [];
        for(const i in list){
            const item = list[i];
            if ((0, $7212E.Tags) && (0, $7212E.Tags).MatchesQuery(item, tagsQuery) && (!filter || filter(item))) listByTags.push(item);
        }
        return listByTags;
    }
    /**
     * Get a list of meshes by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Mesh
     */ getMeshesByTags(tagsQuery, filter) {
        return this._getByTags(this.meshes, tagsQuery, filter);
    }
    /**
     * Get a list of cameras by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Camera
     */ getCamerasByTags(tagsQuery, filter) {
        return this._getByTags(this.cameras, tagsQuery, filter);
    }
    /**
     * Get a list of lights by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Light
     */ getLightsByTags(tagsQuery, filter) {
        return this._getByTags(this.lights, tagsQuery, filter);
    }
    /**
     * Get a list of materials by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Material
     */ getMaterialByTags(tagsQuery, filter) {
        return this._getByTags(this.materials, tagsQuery, filter).concat(this._getByTags(this.multiMaterials, tagsQuery, filter));
    }
    /**
     * Get a list of transform nodes by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of TransformNode
     */ getTransformNodesByTags(tagsQuery, filter) {
        return this._getByTags(this.transformNodes, tagsQuery, filter);
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversly depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._renderingManager.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     * @param depth Automatically clears depth between groups if true and autoClear is true.
     * @param stencil Automatically clears stencil between groups if true and autoClear is true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
        this._renderingManager.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth, stencil);
    }
    /**
     * Gets the current auto clear configuration for one rendering group of the rendering
     * manager.
     * @param index the rendering group index to get the information for
     * @returns The auto clear setup for the requested rendering group
     */ getAutoClearDepthStencilSetup(index) {
        return this._renderingManager.getAutoClearDepthStencilSetup(index);
    }
    /** @internal */ _forceBlockMaterialDirtyMechanism(value) {
        this._blockMaterialDirtyMechanism = value;
    }
    /** Gets or sets a boolean blocking all the calls to markAllMaterialsAsDirty (ie. the materials won't be updated if they are out of sync) */ get blockMaterialDirtyMechanism() {
        return this._blockMaterialDirtyMechanism;
    }
    set blockMaterialDirtyMechanism(value) {
        if (this._blockMaterialDirtyMechanism === value) return;
        this._blockMaterialDirtyMechanism = value;
        if (!value) // Do a complete update
        this.markAllMaterialsAsDirty(63);
    }
    /**
     * Will flag all materials as dirty to trigger new shader compilation
     * @param flag defines the flag used to specify which material part must be marked as dirty
     * @param predicate If not null, it will be used to specify if a material has to be marked as dirty
     */ markAllMaterialsAsDirty(flag, predicate) {
        if (this._blockMaterialDirtyMechanism) return;
        for (const material of this.materials){
            if (predicate && !predicate(material)) continue;
            material.markAsDirty(flag);
        }
    }
    /**
     * @internal
     */ _loadFile(fileOrUrl, onSuccess, onProgress, useOfflineSupport, useArrayBuffer, onError, onOpened) {
        const request = (0, $EOxw7.LoadFile)(fileOrUrl, onSuccess, onProgress, useOfflineSupport ? this.offlineProvider : undefined, useArrayBuffer, onError, onOpened);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * @internal
     */ _loadFileAsync(fileOrUrl, onProgress, useOfflineSupport, useArrayBuffer, onOpened) {
        return new Promise((resolve, reject)=>{
            this._loadFile(fileOrUrl, (data)=>{
                resolve(data);
            }, onProgress, useOfflineSupport, useArrayBuffer, (request, exception)=>{
                reject(exception);
            }, onOpened);
        });
    }
    /**
     * @internal
     */ _requestFile(url, onSuccess, onProgress, useOfflineSupport, useArrayBuffer, onError, onOpened) {
        const request = (0, $EOxw7.RequestFile)(url, onSuccess, onProgress, useOfflineSupport ? this.offlineProvider : undefined, useArrayBuffer, onError, onOpened);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * @internal
     */ _requestFileAsync(url, onProgress, useOfflineSupport, useArrayBuffer, onOpened) {
        return new Promise((resolve, reject)=>{
            this._requestFile(url, (data)=>{
                resolve(data);
            }, onProgress, useOfflineSupport, useArrayBuffer, (error)=>{
                reject(error);
            }, onOpened);
        });
    }
    /**
     * @internal
     */ _readFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
        const request = (0, $EOxw7.ReadFile)(file, onSuccess, onProgress, useArrayBuffer, onError);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * @internal
     */ _readFileAsync(file, onProgress, useArrayBuffer) {
        return new Promise((resolve, reject)=>{
            this._readFile(file, (data)=>{
                resolve(data);
            }, onProgress, useArrayBuffer, (error)=>{
                reject(error);
            });
        });
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * This method gets the performance collector belonging to the scene, which is generally shared with the inspector.
     * @returns the perf collector belonging to the scene.
     */ getPerfCollector() {
        throw (0, $dUFYy._WarnImport)("performanceViewerSceneExtension");
    }
    // deprecated
    /**
     * Sets the active camera of the scene using its Id
     * @param id defines the camera's Id
     * @returns the new active camera or null if none found.
     * @deprecated Please use setActiveCameraById instead
     */ setActiveCameraByID(id) {
        return this.setActiveCameraById(id);
    }
    /**
     * Get a material using its id
     * @param id defines the material's Id
     * @returns the material or null if none found.
     * @deprecated Please use getMaterialById instead
     */ getMaterialByID(id) {
        return this.getMaterialById(id);
    }
    /**
     * Gets a the last added material using a given id
     * @param id defines the material's Id
     * @returns the last material with the given id or null if none found.
     * @deprecated Please use getLastMaterialById instead
     */ getLastMaterialByID(id) {
        return this.getLastMaterialById(id);
    }
    /**
     * Get a texture using its unique id
     * @param uniqueId defines the texture's unique id
     * @returns the texture or null if none found.
     * @deprecated Please use getTextureByUniqueId instead
     */ getTextureByUniqueID(uniqueId) {
        return this.getTextureByUniqueId(uniqueId);
    }
    /**
     * Gets a camera using its Id
     * @param id defines the Id to look for
     * @returns the camera or null if not found
     * @deprecated Please use getCameraById instead
     */ getCameraByID(id) {
        return this.getCameraById(id);
    }
    /**
     * Gets a camera using its unique Id
     * @param uniqueId defines the unique Id to look for
     * @returns the camera or null if not found
     * @deprecated Please use getCameraByUniqueId instead
     */ getCameraByUniqueID(uniqueId) {
        return this.getCameraByUniqueId(uniqueId);
    }
    /**
     * Gets a bone using its Id
     * @param id defines the bone's Id
     * @returns the bone or null if not found
     * @deprecated Please use getBoneById instead
     */ getBoneByID(id) {
        return this.getBoneById(id);
    }
    /**
     * Gets a light node using its Id
     * @param id defines the light's Id
     * @returns the light or null if none found.
     * @deprecated Please use getLightById instead
     */ getLightByID(id) {
        return this.getLightById(id);
    }
    /**
     * Gets a light node using its scene-generated unique Id
     * @param uniqueId defines the light's unique Id
     * @returns the light or null if none found.
     * @deprecated Please use getLightByUniqueId instead
     */ getLightByUniqueID(uniqueId) {
        return this.getLightByUniqueId(uniqueId);
    }
    /**
     * Gets a particle system by Id
     * @param id defines the particle system Id
     * @returns the corresponding system or null if none found
     * @deprecated Please use getParticleSystemById instead
     */ getParticleSystemByID(id) {
        return this.getParticleSystemById(id);
    }
    /**
     * Gets a geometry using its Id
     * @param id defines the geometry's Id
     * @returns the geometry or null if none found.
     * @deprecated Please use getGeometryById instead
     */ getGeometryByID(id) {
        return this.getGeometryById(id);
    }
    /**
     * Gets the first added mesh found of a given Id
     * @param id defines the Id to search for
     * @returns the mesh found or null if not found at all
     * @deprecated Please use getMeshById instead
     */ getMeshByID(id) {
        return this.getMeshById(id);
    }
    /**
     * Gets a mesh with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found mesh or null if not found at all.
     * @deprecated Please use getMeshByUniqueId instead
     */ getMeshByUniqueID(uniqueId) {
        return this.getMeshByUniqueId(uniqueId);
    }
    /**
     * Gets a the last added mesh using a given Id
     * @param id defines the Id to search for
     * @returns the found mesh or null if not found at all.
     * @deprecated Please use getLastMeshById instead
     */ getLastMeshByID(id) {
        return this.getLastMeshById(id);
    }
    /**
     * Gets a list of meshes using their Id
     * @param id defines the Id to search for
     * @returns a list of meshes
     * @deprecated Please use getMeshesById instead
     */ getMeshesByID(id) {
        return this.getMeshesById(id);
    }
    /**
     * Gets the first added transform node found of a given Id
     * @param id defines the Id to search for
     * @returns the found transform node or null if not found at all.
     * @deprecated Please use getTransformNodeById instead
     */ getTransformNodeByID(id) {
        return this.getTransformNodeById(id);
    }
    /**
     * Gets a transform node with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found transform node or null if not found at all.
     * @deprecated Please use getTransformNodeByUniqueId instead
     */ getTransformNodeByUniqueID(uniqueId) {
        return this.getTransformNodeByUniqueId(uniqueId);
    }
    /**
     * Gets a list of transform nodes using their Id
     * @param id defines the Id to search for
     * @returns a list of transform nodes
     * @deprecated Please use getTransformNodesById instead
     */ getTransformNodesByID(id) {
        return this.getTransformNodesById(id);
    }
    /**
     * Gets a node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     * @deprecated Please use getNodeById instead
     */ getNodeByID(id) {
        return this.getNodeById(id);
    }
    /**
     * Gets a the last added node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     * @deprecated Please use getLastEntryById instead
     */ getLastEntryByID(id) {
        return this.getLastEntryById(id);
    }
    /**
     * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
     * @param id defines the Id to search for
     * @returns the found skeleton or null if not found at all.
     * @deprecated Please use getLastSkeletonById instead
     */ getLastSkeletonByID(id) {
        return this.getLastSkeletonById(id);
    }
}
/** The fog is deactivated */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_NONE = 0;
/** The fog density is following an exponential function */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_EXP = 1;
/** The fog density is following an exponential function faster than FOGMODE_EXP */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_EXP2 = 2;
/** The fog density is following a linear function. */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_LINEAR = 3;
/**
 * Gets or sets the minimum deltatime when deterministic lock step is enabled
 * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
 */ $be87b65ec8caf46b$export$38af1803e3442a7f.MinDeltaTime = 1.0;
/**
 * Gets or sets the maximum deltatime when deterministic lock step is enabled
 * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
 */ $be87b65ec8caf46b$export$38af1803e3442a7f.MaxDeltaTime = 1000.0;
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.Scene", $be87b65ec8caf46b$export$38af1803e3442a7f);

});
parcelRegister("bOhSV", function(module, exports) {

$parcel$export(module.exports, "Tools", () => $89923ccd30e6d161$export$390d11d353c16e49);
$parcel$export(module.exports, "AsyncLoop", () => $89923ccd30e6d161$export$867c188241b31f47);

var $diGQf = parcelRequire("diGQf");

var $jFz47 = parcelRequire("jFz47");

var $kVtWi = parcelRequire("kVtWi");

var $fhgis = parcelRequire("fhgis");

var $blHSI = parcelRequire("blHSI");

var $dUFYy = parcelRequire("dUFYy");

var $hUzEl = parcelRequire("hUzEl");

var $ejQPp = parcelRequire("ejQPp");

var $EOxw7 = parcelRequire("EOxw7");

var $av6Bc = parcelRequire("av6Bc");

var $i1moY = parcelRequire("i1moY");

var $321Uk = parcelRequire("321Uk");

var $wK2xc = parcelRequire("wK2xc");
class $89923ccd30e6d161$export$390d11d353c16e49 {
    /**
     * Gets or sets the base URL to use to load assets
     */ static get BaseUrl() {
        return (0, $EOxw7.FileToolsOptions).BaseUrl;
    }
    static set BaseUrl(value) {
        (0, $EOxw7.FileToolsOptions).BaseUrl = value;
    }
    /**
     * Gets or sets the clean URL function to use to load assets
     */ static get CleanUrl() {
        return (0, $EOxw7.FileToolsOptions).CleanUrl;
    }
    static set CleanUrl(value) {
        (0, $EOxw7.FileToolsOptions).CleanUrl = value;
    }
    /**
     * This function checks whether a URL is absolute or not.
     * It will also detect data and blob URLs
     * @param url the url to check
     * @returns is the url absolute or relative
     */ static IsAbsoluteUrl(url) {
        // See https://stackoverflow.com/a/38979205.
        // URL is protocol-relative (= absolute)
        if (url.indexOf("//") === 0) return true;
        // URL has no protocol (= relative)
        if (url.indexOf("://") === -1) return false;
        // URL does not contain a dot, i.e. no TLD (= relative, possibly REST)
        if (url.indexOf(".") === -1) return false;
        // URL does not contain a single slash (= relative)
        if (url.indexOf("/") === -1) return false;
        // The first colon comes after the first slash (= relative)
        if (url.indexOf(":") > url.indexOf("/")) return false;
        // Protocol is defined before first dot (= absolute)
        if (url.indexOf("://") < url.indexOf(".")) return true;
        if (url.indexOf("data:") === 0 || url.indexOf("blob:") === 0) return true;
        // Anything else must be relative
        return false;
    }
    /**
     * Sets the base URL to use to load scripts
     */ static set ScriptBaseUrl(value) {
        (0, $EOxw7.FileToolsOptions).ScriptBaseUrl = value;
    }
    static get ScriptBaseUrl() {
        return (0, $EOxw7.FileToolsOptions).ScriptBaseUrl;
    }
    /**
     * Sets both the script base URL and the assets base URL to the same value.
     * Setter only!
     */ static set CDNBaseUrl(value) {
        $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl = value;
        $89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl = value;
    }
    /**
     * Sets a preprocessing function to run on a source URL before importing it
     * Note that this function will execute AFTER the base URL is appended to the URL
     */ static set ScriptPreprocessUrl(func) {
        (0, $EOxw7.FileToolsOptions).ScriptPreprocessUrl = func;
    }
    static get ScriptPreprocessUrl() {
        return (0, $EOxw7.FileToolsOptions).ScriptPreprocessUrl;
    }
    /**
     * Gets or sets the retry strategy to apply when an error happens while loading an asset
     */ static get DefaultRetryStrategy() {
        return (0, $EOxw7.FileToolsOptions).DefaultRetryStrategy;
    }
    static set DefaultRetryStrategy(strategy) {
        (0, $EOxw7.FileToolsOptions).DefaultRetryStrategy = strategy;
    }
    /**
     * Default behavior for cors in the application.
     * It can be a string if the expected behavior is identical in the entire app.
     * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
     */ static get CorsBehavior() {
        return (0, $EOxw7.FileToolsOptions).CorsBehavior;
    }
    static set CorsBehavior(value) {
        (0, $EOxw7.FileToolsOptions).CorsBehavior = value;
    }
    /**
     * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
     * @ignorenaming
     */ static get UseFallbackTexture() {
        return (0, $ejQPp.EngineStore).UseFallbackTexture;
    }
    static set UseFallbackTexture(value) {
        (0, $ejQPp.EngineStore).UseFallbackTexture = value;
    }
    /**
     * Use this object to register external classes like custom textures or material
     * to allow the loaders to instantiate them
     */ static get RegisteredExternalClasses() {
        return (0, $i1moY.InstantiationTools).RegisteredExternalClasses;
    }
    static set RegisteredExternalClasses(classes) {
        (0, $i1moY.InstantiationTools).RegisteredExternalClasses = classes;
    }
    /**
     * Texture content used if a texture cannot loaded
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get fallbackTexture() {
        return (0, $ejQPp.EngineStore).FallbackTexture;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static set fallbackTexture(value) {
        (0, $ejQPp.EngineStore).FallbackTexture = value;
    }
    /**
     * Read the content of a byte array at a specified coordinates (taking in account wrapping)
     * @param u defines the coordinate on X axis
     * @param v defines the coordinate on Y axis
     * @param width defines the width of the source data
     * @param height defines the height of the source data
     * @param pixels defines the source byte array
     * @param color defines the output color
     */ static FetchToRef(u, v, width, height, pixels, color) {
        const wrappedU = Math.abs(u) * width % width | 0;
        const wrappedV = Math.abs(v) * height % height | 0;
        const position = (wrappedU + wrappedV * width) * 4;
        color.r = pixels[position] / 255;
        color.g = pixels[position + 1] / 255;
        color.b = pixels[position + 2] / 255;
        color.a = pixels[position + 3] / 255;
    }
    /**
     * Interpolates between a and b via alpha
     * @param a The lower value (returned when alpha = 0)
     * @param b The upper value (returned when alpha = 1)
     * @param alpha The interpolation-factor
     * @returns The mixed value
     */ static Mix(a, b, alpha) {
        return 0;
    }
    /**
     * Tries to instantiate a new object from a given class name
     * @param className defines the class name to instantiate
     * @returns the new object or null if the system was not able to do the instantiation
     */ static Instantiate(className) {
        return (0, $i1moY.InstantiationTools).Instantiate(className);
    }
    /**
     * Polyfill for setImmediate
     * @param action defines the action to execute after the current execution block
     */ static SetImmediate(action) {
        (0, $av6Bc.TimingTools).SetImmediate(action);
    }
    /**
     * Function indicating if a number is an exponent of 2
     * @param value defines the value to test
     * @returns true if the value is an exponent of 2
     */ static IsExponentOfTwo(value) {
        return true;
    }
    /**
     * Returns the nearest 32-bit single precision float representation of a Number
     * @param value A Number.  If the parameter is of a different type, it will get converted
     * to a number or to NaN if it cannot be converted
     * @returns number
     */ static FloatRound(value) {
        return Math.fround(value);
    }
    /**
     * Extracts the filename from a path
     * @param path defines the path to use
     * @returns the filename
     */ static GetFilename(path) {
        const index = path.lastIndexOf("/");
        if (index < 0) return path;
        return path.substring(index + 1);
    }
    /**
     * Extracts the "folder" part of a path (everything before the filename).
     * @param uri The URI to extract the info from
     * @param returnUnchangedIfNoSlash Do not touch the URI if no slashes are present
     * @returns The "folder" part of the path
     */ static GetFolderPath(uri, returnUnchangedIfNoSlash = false) {
        const index = uri.lastIndexOf("/");
        if (index < 0) {
            if (returnUnchangedIfNoSlash) return uri;
            return "";
        }
        return uri.substring(0, index + 1);
    }
    /**
     * Convert an angle in radians to degrees
     * @param angle defines the angle to convert
     * @returns the angle in degrees
     */ static ToDegrees(angle) {
        return angle * 180 / Math.PI;
    }
    /**
     * Convert an angle in degrees to radians
     * @param angle defines the angle to convert
     * @returns the angle in radians
     */ static ToRadians(angle) {
        return angle * Math.PI / 180;
    }
    /**
     * Smooth angle changes (kind of low-pass filter), in particular for device orientation "shaking"
     * Use trigonometric functions to avoid discontinuity (0/360, -180/180)
     * @param previousAngle defines last angle value, in degrees
     * @param newAngle defines new angle value, in degrees
     * @param smoothFactor defines smoothing sensitivity; min 0: no smoothing, max 1: new data ignored
     * @returns the angle in degrees
     */ static SmoothAngleChange(previousAngle, newAngle, smoothFactor = 0.9) {
        const previousAngleRad = this.ToRadians(previousAngle);
        const newAngleRad = this.ToRadians(newAngle);
        return this.ToDegrees(Math.atan2((1 - smoothFactor) * Math.sin(newAngleRad) + smoothFactor * Math.sin(previousAngleRad), (1 - smoothFactor) * Math.cos(newAngleRad) + smoothFactor * Math.cos(previousAngleRad)));
    }
    /**
     * Returns an array if obj is not an array
     * @param obj defines the object to evaluate as an array
     * @param allowsNullUndefined defines a boolean indicating if obj is allowed to be null or undefined
     * @returns either obj directly if obj is an array or a new array containing obj
     */ static MakeArray(obj, allowsNullUndefined) {
        if (allowsNullUndefined !== true && (obj === undefined || obj == null)) return null;
        return Array.isArray(obj) ? obj : [
            obj
        ];
    }
    /**
     * Gets the pointer prefix to use
     * @param engine defines the engine we are finding the prefix for
     * @returns "pointer" if touch is enabled. Else returns "mouse"
     */ static GetPointerPrefix(engine) {
        return (0, $jFz47.IsWindowObjectExist)() && !window.PointerEvent ? "mouse" : "pointer";
    }
    /**
     * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
     * @param url define the url we are trying
     * @param element define the dom element where to configure the cors policy
     * @param element.crossOrigin
     */ static SetCorsBehavior(url, element) {
        (0, $EOxw7.SetCorsBehavior)(url, element);
    }
    /**
     * Sets the referrerPolicy behavior on a dom element.
     * @param referrerPolicy define the referrer policy to use
     * @param element define the dom element where to configure the referrer policy
     * @param element.referrerPolicy
     */ static SetReferrerPolicyBehavior(referrerPolicy, element) {
        element.referrerPolicy = referrerPolicy;
    }
    // External files
    /**
     * Gets or sets a function used to pre-process url before using them to load assets
     */ static get PreprocessUrl() {
        return (0, $EOxw7.FileToolsOptions).PreprocessUrl;
    }
    static set PreprocessUrl(processor) {
        (0, $EOxw7.FileToolsOptions).PreprocessUrl = processor;
    }
    /**
     * Loads an image as an HTMLImageElement.
     * @param input url string, ArrayBuffer, or Blob to load
     * @param onLoad callback called when the image successfully loads
     * @param onError callback called when the image fails to load
     * @param offlineProvider offline provider for caching
     * @param mimeType optional mime type
     * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
     * @returns the HTMLImageElement of the loaded image
     */ static LoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
        return (0, $EOxw7.LoadImage)(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions);
    }
    /**
     * Loads a file from a url
     * @param url url string, ArrayBuffer, or Blob to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     */ static LoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        return (0, $EOxw7.LoadFile)(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
    }
    /**
     * Loads a file from a url
     * @param url the file url to load
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @returns a promise containing an ArrayBuffer corresponding to the loaded file
     */ static LoadFileAsync(url, useArrayBuffer = true) {
        return new Promise((resolve, reject)=>{
            (0, $EOxw7.LoadFile)(url, (data)=>{
                resolve(data);
            }, undefined, undefined, useArrayBuffer, (request, exception)=>{
                reject(exception);
            });
        });
    }
    /**
     * This function will convert asset URLs if the AssetBaseUrl parameter is set.
     * Any URL with `assets.babylonjs.com/core` will be replaced with the value of AssetBaseUrl.
     * @param url the URL to convert
     * @returns a new URL
     */ static GetAssetUrl(url) {
        if (!url) return "";
        if ($89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl && url.startsWith($89923ccd30e6d161$export$390d11d353c16e49._DefaultAssetsUrl)) {
            // normalize the baseUrl
            const baseUrl = $89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl[$89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl.length - 1] === "/" ? $89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl.substring(0, $89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl.length - 1) : $89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl;
            return url.replace($89923ccd30e6d161$export$390d11d353c16e49._DefaultAssetsUrl, baseUrl);
        }
        return url;
    }
    /**
     * Get a script URL including preprocessing
     * @param scriptUrl the script Url to process
     * @param forceAbsoluteUrl force the script to be an absolute url (adding the current base url if necessary)
     * @returns a modified URL to use
     */ static GetBabylonScriptURL(scriptUrl, forceAbsoluteUrl) {
        if (!scriptUrl) return "";
        // if the base URL was set, and the script Url is an absolute path change the default path
        if ($89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl && scriptUrl.startsWith($89923ccd30e6d161$export$390d11d353c16e49._DefaultCdnUrl)) {
            // change the default host, which is https://cdn.babylonjs.com with the one defined
            // make sure no trailing slash is present
            const baseUrl = $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl[$89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl.length - 1] === "/" ? $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl.substring(0, $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl.length - 1) : $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl;
            scriptUrl = scriptUrl.replace($89923ccd30e6d161$export$390d11d353c16e49._DefaultCdnUrl, baseUrl);
        }
        // run the preprocessor
        scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.ScriptPreprocessUrl(scriptUrl);
        if (forceAbsoluteUrl) scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.GetAbsoluteUrl(scriptUrl);
        return scriptUrl;
    }
    /**
     * This function is used internally by babylon components to load a script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to load
     * @param onSuccess defines the callback called when the script is loaded
     * @param onError defines the callback to call if an error occurs
     * @param scriptId defines the id of the script element
     */ static LoadBabylonScript(scriptUrl, onSuccess, onError, scriptId) {
        scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.GetBabylonScriptURL(scriptUrl);
        $89923ccd30e6d161$export$390d11d353c16e49.LoadScript(scriptUrl, onSuccess, onError);
    }
    /**
     * Load an asynchronous script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to laod
     * @returns a promise request object
     */ static LoadBabylonScriptAsync(scriptUrl) {
        scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.GetBabylonScriptURL(scriptUrl);
        return $89923ccd30e6d161$export$390d11d353c16e49.LoadScriptAsync(scriptUrl);
    }
    /**
     * This function is used internally by babylon components to load a script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to load
     * @param onSuccess defines the callback called when the script is loaded
     * @param onError defines the callback to call if an error occurs
     * @param scriptId defines the id of the script element
     * @param useModule defines if we should use the module strategy to load the script
     */ static LoadScript(scriptUrl, onSuccess, onError, scriptId, useModule = false) {
        if (typeof importScripts === "function") {
            try {
                importScripts(scriptUrl);
                if (onSuccess) onSuccess();
            } catch (e) {
                onError?.(`Unable to load script '${scriptUrl}' in worker`, e);
            }
            return;
        } else if (!(0, $jFz47.IsWindowObjectExist)()) {
            onError?.(`Cannot load script '${scriptUrl}' outside of a window or a worker`);
            return;
        }
        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        if (useModule) {
            script.setAttribute("type", "module");
            script.innerText = scriptUrl;
        } else {
            script.setAttribute("type", "text/javascript");
            script.setAttribute("src", scriptUrl);
        }
        if (scriptId) script.id = scriptId;
        script.onload = ()=>{
            if (onSuccess) onSuccess();
        };
        script.onerror = (e)=>{
            if (onError) onError(`Unable to load script '${scriptUrl}'`, e);
        };
        head.appendChild(script);
    }
    /**
     * Load an asynchronous script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to load
     * @param scriptId defines the id of the script element
     * @returns a promise request object
     */ static LoadScriptAsync(scriptUrl, scriptId) {
        return new Promise((resolve, reject)=>{
            this.LoadScript(scriptUrl, ()=>{
                resolve();
            }, (message, exception)=>{
                reject(exception || new Error(message));
            }, scriptId);
        });
    }
    /**
     * Loads a file from a blob
     * @param fileToLoad defines the blob to use
     * @param callback defines the callback to call when data is loaded
     * @param progressCallback defines the callback to call during loading process
     * @returns a file request object
     */ static ReadFileAsDataURL(fileToLoad, callback, progressCallback) {
        const reader = new FileReader();
        const request = {
            onCompleteObservable: new (0, $diGQf.Observable)(),
            abort: ()=>reader.abort()
        };
        reader.onloadend = ()=>{
            request.onCompleteObservable.notifyObservers(request);
        };
        reader.onload = (e)=>{
            //target doesn't have result from ts 1.3
            callback(e.target["result"]);
        };
        reader.onprogress = progressCallback;
        reader.readAsDataURL(fileToLoad);
        return request;
    }
    /**
     * Reads a file from a File object
     * @param file defines the file to load
     * @param onSuccess defines the callback to call when data is loaded
     * @param onProgress defines the callback to call during loading process
     * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
     * @param onError defines the callback to call when an error occurs
     * @returns a file request object
     */ static ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
        return (0, $EOxw7.ReadFile)(file, onSuccess, onProgress, useArrayBuffer, onError);
    }
    /**
     * Creates a data url from a given string content
     * @param content defines the content to convert
     * @returns the new data url link
     */ static FileAsURL(content) {
        const fileBlob = new Blob([
            content
        ]);
        const url = window.URL;
        const link = url.createObjectURL(fileBlob);
        return link;
    }
    /**
     * Format the given number to a specific decimal format
     * @param value defines the number to format
     * @param decimals defines the number of decimals to use
     * @returns the formatted string
     */ static Format(value, decimals = 2) {
        return value.toFixed(decimals);
    }
    /**
     * Tries to copy an object by duplicating every property
     * @param source defines the source object
     * @param destination defines the target object
     * @param doNotCopyList defines a list of properties to avoid
     * @param mustCopyList defines a list of properties to copy (even if they start with _)
     */ static DeepCopy(source, destination, doNotCopyList, mustCopyList) {
        (0, $fhgis.DeepCopier).DeepCopy(source, destination, doNotCopyList, mustCopyList);
    }
    /**
     * Gets a boolean indicating if the given object has no own property
     * @param obj defines the object to test
     * @returns true if object has no own property
     */ static IsEmpty(obj) {
        for(const i in obj){
            if (Object.prototype.hasOwnProperty.call(obj, i)) return false;
        }
        return true;
    }
    /**
     * Function used to register events at window level
     * @param windowElement defines the Window object to use
     * @param events defines the events to register
     */ static RegisterTopRootEvents(windowElement, events) {
        for(let index = 0; index < events.length; index++){
            const event = events[index];
            windowElement.addEventListener(event.name, event.handler, false);
            try {
                if (window.parent) window.parent.addEventListener(event.name, event.handler, false);
            } catch (e) {
            // Silently fails...
            }
        }
    }
    /**
     * Function used to unregister events from window level
     * @param windowElement defines the Window object to use
     * @param events defines the events to unregister
     */ static UnregisterTopRootEvents(windowElement, events) {
        for(let index = 0; index < events.length; index++){
            const event = events[index];
            windowElement.removeEventListener(event.name, event.handler);
            try {
                if (windowElement.parent) windowElement.parent.removeEventListener(event.name, event.handler);
            } catch (e) {
            // Silently fails...
            }
        }
    }
    /**
     * Dumps the current bound framebuffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param engine defines the hosting engine
     * @param successCallback defines the callback triggered once the data are available
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns a void promise
     */ static async DumpFramebuffer(width, height, engine, successCallback, mimeType = "image/png", fileName, quality) {
        throw (0, $dUFYy._WarnImport)("DumpTools");
    }
    /**
     * Dumps an array buffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param data the data array
     * @param successCallback defines the callback triggered once the data are available
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param invertY true to invert the picture in the Y dimension
     * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static DumpData(width, height, data, successCallback, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        throw (0, $dUFYy._WarnImport)("DumpTools");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Dumps an array buffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param data the data array
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param invertY true to invert the picture in the Y dimension
     * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns a promise that resolve to the final data
     */ static DumpDataAsync(width, height, data, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        throw (0, $dUFYy._WarnImport)("DumpTools");
    }
    static _IsOffScreenCanvas(canvas) {
        return canvas.convertToBlob !== undefined;
    }
    /**
     * Converts the canvas data to blob.
     * This acts as a polyfill for browsers not supporting the to blob function.
     * @param canvas Defines the canvas to extract the data from (can be an offscreen canvas)
     * @param successCallback Defines the callback triggered once the data are available
     * @param mimeType Defines the mime type of the result
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static ToBlob(canvas, successCallback, mimeType = "image/png", quality) {
        // We need HTMLCanvasElement.toBlob for HD screenshots
        if (!$89923ccd30e6d161$export$390d11d353c16e49._IsOffScreenCanvas(canvas) && !canvas.toBlob) //  low performance polyfill based on toDataURL (https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob)
        canvas.toBlob = function(callback, type, quality) {
            setTimeout(()=>{
                const binStr = atob(this.toDataURL(type, quality).split(",")[1]), len = binStr.length, arr = new Uint8Array(len);
                for(let i = 0; i < len; i++)arr[i] = binStr.charCodeAt(i);
                callback(new Blob([
                    arr
                ]));
            });
        };
        if ($89923ccd30e6d161$export$390d11d353c16e49._IsOffScreenCanvas(canvas)) canvas.convertToBlob({
            type: mimeType,
            quality: quality
        }).then((blob)=>successCallback(blob));
        else canvas.toBlob(function(blob) {
            successCallback(blob);
        }, mimeType, quality);
    }
    /**
     * Download a Blob object
     * @param blob the Blob object
     * @param fileName the file name to download
     */ static DownloadBlob(blob, fileName) {
        //Creating a link if the browser have the download attribute on the a tag, to automatically start download generated image.
        if ("download" in document.createElement("a")) {
            if (!fileName) {
                const date = new Date();
                const stringDate = (date.getFullYear() + "-" + (date.getMonth() + 1)).slice(2) + "-" + date.getDate() + "_" + date.getHours() + "-" + ("0" + date.getMinutes()).slice(-2);
                fileName = "screenshot_" + stringDate + ".png";
            }
            $89923ccd30e6d161$export$390d11d353c16e49.Download(blob, fileName);
        } else if (blob && typeof URL !== "undefined") {
            const url = URL.createObjectURL(blob);
            const newWindow = window.open("");
            if (!newWindow) return;
            const img = newWindow.document.createElement("img");
            img.onload = function() {
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
            };
            img.src = url;
            newWindow.document.body.appendChild(img);
        }
    }
    /**
     * Encodes the canvas data to base 64, or automatically downloads the result if `fileName` is defined.
     * @param canvas The canvas to get the data from, which can be an offscreen canvas.
     * @param successCallback The callback which is triggered once the data is available. If `fileName` is defined, the callback will be invoked after the download occurs, and the `data` argument will be an empty string.
     * @param mimeType The mime type of the result.
     * @param fileName The name of the file to download. If defined, the result will automatically be downloaded. If not defined, and `successCallback` is also not defined, the result will automatically be downloaded with an auto-generated file name.
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static EncodeScreenshotCanvasData(canvas, successCallback, mimeType = "image/png", fileName, quality) {
        if (typeof fileName === "string" || !successCallback) this.ToBlob(canvas, function(blob) {
            if (blob) $89923ccd30e6d161$export$390d11d353c16e49.DownloadBlob(blob, fileName);
            if (successCallback) successCallback("");
        }, mimeType, quality);
        else if (successCallback) {
            if ($89923ccd30e6d161$export$390d11d353c16e49._IsOffScreenCanvas(canvas)) {
                canvas.convertToBlob({
                    type: mimeType,
                    quality: quality
                }).then((blob)=>{
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = ()=>{
                        const base64data = reader.result;
                        successCallback(base64data);
                    };
                });
                return;
            }
            const base64Image = canvas.toDataURL(mimeType, quality);
            successCallback(base64Image);
        }
    }
    /**
     * Downloads a blob in the browser
     * @param blob defines the blob to download
     * @param fileName defines the name of the downloaded file
     */ static Download(blob, fileName) {
        if (typeof URL === "undefined") return;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        a.addEventListener("click", ()=>{
            if (a.parentElement) a.parentElement.removeChild(a);
        });
        a.click();
        window.URL.revokeObjectURL(url);
    }
    /**
     * Will return the right value of the noPreventDefault variable
     * Needed to keep backwards compatibility to the old API.
     *
     * @param args arguments passed to the attachControl function
     * @returns the correct value for noPreventDefault
     */ static BackCompatCameraNoPreventDefault(args) {
        // is it used correctly?
        if (typeof args[0] === "boolean") return args[0];
        else if (typeof args[1] === "boolean") return args[1];
        return false;
    }
    /**
     * Captures a screenshot of the current rendering
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param successCallback defines the callback receives a single parameter which contains the
     * screenshot as a string of base64-encoded characters. This string can be assigned to the
     * src parameter of an <img> to display it
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param forceDownload force the system to download the image even if a successCallback is provided
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshot(engine, camera, size, successCallback, mimeType = "image/png", forceDownload = false, quality) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Captures a screenshot of the current rendering
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * to the src parameter of an <img> to display it
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshotAsync(engine, camera, size, mimeType = "image/png", quality) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    /**
     * Generates an image screenshot from the specified camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine The engine to use for rendering
     * @param camera The camera to use for rendering
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param successCallback The callback receives a single parameter which contains the
     * screenshot as a string of base64-encoded characters. This string can be assigned to the
     * src parameter of an <img> to display it
     * @param mimeType The MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param samples Texture samples (default: 1)
     * @param antialiasing Whether antialiasing should be turned on or not (default: false)
     * @param fileName A name for for the downloaded file.
     * @param renderSprites Whether the sprites should be rendered or not (default: false)
     * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
     * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @param customizeTexture An optional callback that can be used to modify the render target texture before taking the screenshot. This can be used, for instance, to enable camera post-processes before taking the screenshot.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshotUsingRenderTarget(engine, camera, size, successCallback, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality, customizeTexture) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Generates an image screenshot from the specified camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine The engine to use for rendering
     * @param camera The camera to use for rendering
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param mimeType The MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param samples Texture samples (default: 1)
     * @param antialiasing Whether antialiasing should be turned on or not (default: false)
     * @param fileName A name for for the downloaded file.
     * @param renderSprites Whether the sprites should be rendered or not (default: false)
     * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
     * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @param customizeTexture An optional callback that can be used to modify the render target texture before taking the screenshot. This can be used, for instance, to enable camera post-processes before taking the screenshot.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * to the src parameter of an <img> to display it
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshotUsingRenderTargetAsync(engine, camera, size, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality, customizeTexture) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    /**
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a pseudo random id
     */ static RandomId() {
        return (0, $321Uk.RandomGUID)();
    }
    /**
     * Test if the given uri is a base64 string
     * @deprecated Please use FileTools.IsBase64DataUrl instead.
     * @param uri The uri to test
     * @returns True if the uri is a base64 string or false otherwise
     */ static IsBase64(uri) {
        return (0, $EOxw7.IsBase64DataUrl)(uri);
    }
    /**
     * Decode the given base64 uri.
     * @deprecated Please use FileTools.DecodeBase64UrlToBinary instead.
     * @param uri The uri to decode
     * @returns The decoded base64 data.
     */ static DecodeBase64(uri) {
        return (0, $EOxw7.DecodeBase64UrlToBinary)(uri);
    }
    /**
     * Gets a value indicating the number of loading errors
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get errorsCount() {
        return (0, $kVtWi.Logger).errorsCount;
    }
    /**
     * Log a message to the console
     * @param message defines the message to log
     */ static Log(message) {
        (0, $kVtWi.Logger).Log(message);
    }
    /**
     * Write a warning message to the console
     * @param message defines the message to log
     */ static Warn(message) {
        (0, $kVtWi.Logger).Warn(message);
    }
    /**
     * Write an error message to the console
     * @param message defines the message to log
     */ static Error(message) {
        (0, $kVtWi.Logger).Error(message);
    }
    /**
     * Gets current log cache (list of logs)
     */ static get LogCache() {
        return (0, $kVtWi.Logger).LogCache;
    }
    /**
     * Clears the log cache
     */ static ClearLogCache() {
        (0, $kVtWi.Logger).ClearLogCache();
    }
    /**
     * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
     */ static set LogLevels(level) {
        (0, $kVtWi.Logger).LogLevels = level;
    }
    /**
     * Sets the current performance log level
     */ static set PerformanceLogLevel(level) {
        if ((level & $89923ccd30e6d161$export$390d11d353c16e49.PerformanceUserMarkLogLevel) === $89923ccd30e6d161$export$390d11d353c16e49.PerformanceUserMarkLogLevel) {
            $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartUserMark;
            $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndUserMark;
            return;
        }
        if ((level & $89923ccd30e6d161$export$390d11d353c16e49.PerformanceConsoleLogLevel) === $89923ccd30e6d161$export$390d11d353c16e49.PerformanceConsoleLogLevel) {
            $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartPerformanceConsole;
            $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndPerformanceConsole;
            return;
        }
        $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartPerformanceCounterDisabled;
        $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndPerformanceCounterDisabled;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _StartPerformanceCounterDisabled(counterName, condition) {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _EndPerformanceCounterDisabled(counterName, condition) {}
    static _StartUserMark(counterName, condition = true) {
        if (!$89923ccd30e6d161$export$390d11d353c16e49._Performance) {
            if (!(0, $jFz47.IsWindowObjectExist)()) return;
            $89923ccd30e6d161$export$390d11d353c16e49._Performance = window.performance;
        }
        if (!condition || !$89923ccd30e6d161$export$390d11d353c16e49._Performance.mark) return;
        $89923ccd30e6d161$export$390d11d353c16e49._Performance.mark(counterName + "-Begin");
    }
    static _EndUserMark(counterName, condition = true) {
        if (!condition || !$89923ccd30e6d161$export$390d11d353c16e49._Performance.mark) return;
        $89923ccd30e6d161$export$390d11d353c16e49._Performance.mark(counterName + "-End");
        $89923ccd30e6d161$export$390d11d353c16e49._Performance.measure(counterName, counterName + "-Begin", counterName + "-End");
    }
    static _StartPerformanceConsole(counterName, condition = true) {
        if (!condition) return;
        $89923ccd30e6d161$export$390d11d353c16e49._StartUserMark(counterName, condition);
        if (console.time) console.time(counterName);
    }
    static _EndPerformanceConsole(counterName, condition = true) {
        if (!condition) return;
        $89923ccd30e6d161$export$390d11d353c16e49._EndUserMark(counterName, condition);
        console.timeEnd(counterName);
    }
    /**
     * Gets either window.performance.now() if supported or Date.now() else
     */ static get Now() {
        return (0, $blHSI.PrecisionDate).Now;
    }
    /**
     * This method will return the name of the class used to create the instance of the given object.
     * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator.
     * @param object the object to get the class name from
     * @param isType defines if the object is actually a type
     * @returns the name of the class, will be "object" for a custom data type not using the @className decorator
     */ static GetClassName(object, isType = false) {
        let name = null;
        if (!isType && object.getClassName) name = object.getClassName();
        else {
            if (object instanceof Object) {
                const classObj = isType ? object : Object.getPrototypeOf(object);
                name = classObj.constructor["__bjsclassName__"];
            }
            if (!name) name = typeof object;
        }
        return name;
    }
    /**
     * Gets the first element of an array satisfying a given predicate
     * @param array defines the array to browse
     * @param predicate defines the predicate to use
     * @returns null if not found or the element
     */ static First(array, predicate) {
        for (const el of array){
            if (predicate(el)) return el;
        }
        return null;
    }
    /**
     * This method will return the name of the full name of the class, including its owning module (if any).
     * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator or implementing a method getClassName():string (in which case the module won't be specified).
     * @param object the object to get the class name from
     * @param isType defines if the object is actually a type
     * @returns a string that can have two forms: "moduleName.className" if module was specified when the class' Name was registered or "className" if there was not module specified.
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static getFullClassName(object, isType = false) {
        let className = null;
        let moduleName = null;
        if (!isType && object.getClassName) className = object.getClassName();
        else {
            if (object instanceof Object) {
                const classObj = isType ? object : Object.getPrototypeOf(object);
                className = classObj.constructor["__bjsclassName__"];
                moduleName = classObj.constructor["__bjsmoduleName__"];
            }
            if (!className) className = typeof object;
        }
        if (!className) return null;
        return (moduleName != null ? moduleName + "." : "") + className;
    }
    /**
     * Returns a promise that resolves after the given amount of time.
     * @param delay Number of milliseconds to delay
     * @returns Promise that resolves after the given amount of time
     */ static DelayAsync(delay) {
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve();
            }, delay);
        });
    }
    /**
     * Utility function to detect if the current user agent is Safari
     * @returns whether or not the current user agent is safari
     */ static IsSafari() {
        if (!(0, $jFz47.IsNavigatorAvailable)()) return false;
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
}
/**
 * The base URL to use to load assets. If empty the default base url is used.
 */ $89923ccd30e6d161$export$390d11d353c16e49.AssetBaseUrl = "";
/**
 * Enable/Disable Custom HTTP Request Headers globally.
 * default = false
 * @see CustomRequestHeaders
 */ $89923ccd30e6d161$export$390d11d353c16e49.UseCustomRequestHeaders = false;
/**
 * Custom HTTP Request Headers to be sent with XMLHttpRequests
 * i.e. when loading files, where the server/service expects an Authorization header
 */ $89923ccd30e6d161$export$390d11d353c16e49.CustomRequestHeaders = (0, $hUzEl.WebRequest).CustomRequestHeaders;
/**
 * Extracts text content from a DOM element hierarchy
 * Back Compat only, please use GetDOMTextContent instead.
 */ $89923ccd30e6d161$export$390d11d353c16e49.GetDOMTextContent = (0, $jFz47.GetDOMTextContent);
/**
 * @internal
 */ $89923ccd30e6d161$export$390d11d353c16e49._DefaultCdnUrl = "https://cdn.babylonjs.com";
/**
 * @internal
 */ $89923ccd30e6d161$export$390d11d353c16e49._DefaultAssetsUrl = "https://assets.babylonjs.com/core";
// eslint-disable-next-line jsdoc/require-returns-check, jsdoc/require-param
/**
 * @returns the absolute URL of a given (relative) url
 */ $89923ccd30e6d161$export$390d11d353c16e49.GetAbsoluteUrl = typeof document === "object" ? (url)=>{
    const a = document.createElement("a");
    a.href = url;
    return a.href;
} : typeof URL === "function" && typeof location === "object" ? (url)=>new URL(url, location.origin).href : ()=>{
    throw new Error("Unable to get absolute URL. Override BABYLON.Tools.GetAbsoluteUrl to a custom implementation for the current context.");
};
// Logs
/**
 * No log
 */ $89923ccd30e6d161$export$390d11d353c16e49.NoneLogLevel = (0, $kVtWi.Logger).NoneLogLevel;
/**
 * Only message logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.MessageLogLevel = (0, $kVtWi.Logger).MessageLogLevel;
/**
 * Only warning logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.WarningLogLevel = (0, $kVtWi.Logger).WarningLogLevel;
/**
 * Only error logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.ErrorLogLevel = (0, $kVtWi.Logger).ErrorLogLevel;
/**
 * All logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.AllLogLevel = (0, $kVtWi.Logger).AllLogLevel;
/**
 * Checks if the window object exists
 * Back Compat only, please use IsWindowObjectExist instead.
 */ $89923ccd30e6d161$export$390d11d353c16e49.IsWindowObjectExist = (0, $jFz47.IsWindowObjectExist);
// Performances
/**
 * No performance log
 */ $89923ccd30e6d161$export$390d11d353c16e49.PerformanceNoneLogLevel = 0;
/**
 * Use user marks to log performance
 */ $89923ccd30e6d161$export$390d11d353c16e49.PerformanceUserMarkLogLevel = 1;
/**
 * Log performance to the console
 */ $89923ccd30e6d161$export$390d11d353c16e49.PerformanceConsoleLogLevel = 2;
/**
 * Starts a performance counter
 */ $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartPerformanceCounterDisabled;
/**
 * Ends a specific performance counter
 */ $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndPerformanceCounterDisabled;
function $89923ccd30e6d161$export$2913c0c0b5623090(name, module) {
    return (target)=>{
        target["__bjsclassName__"] = name;
        target["__bjsmoduleName__"] = module != null ? module : null;
    };
}
class $89923ccd30e6d161$export$867c188241b31f47 {
    /**
     * Constructor.
     * @param iterations the number of iterations.
     * @param func the function to run each iteration
     * @param successCallback the callback that will be called upon successful execution
     * @param offset starting offset.
     */ constructor(/**
     * Defines the number of iterations for the loop
     */ iterations, func, successCallback, offset = 0){
        this.iterations = iterations;
        this.index = offset - 1;
        this._done = false;
        this._fn = func;
        this._successCallback = successCallback;
    }
    /**
     * Execute the next iteration. Must be called after the last iteration was finished.
     */ executeNext() {
        if (!this._done) {
            if (this.index + 1 < this.iterations) {
                ++this.index;
                this._fn(this);
            } else this.breakLoop();
        }
    }
    /**
     * Break the loop and run the success callback.
     */ breakLoop() {
        this._done = true;
        this._successCallback();
    }
    /**
     * Create and run an async loop.
     * @param iterations the number of iterations.
     * @param fn the function to run each iteration
     * @param successCallback the callback that will be called upon successful execution
     * @param offset starting offset.
     * @returns the created async loop object
     */ static Run(iterations, fn, successCallback, offset = 0) {
        const loop = new $89923ccd30e6d161$export$867c188241b31f47(iterations, fn, successCallback, offset);
        loop.executeNext();
        return loop;
    }
    /**
     * A for-loop that will run a given number of iterations synchronous and the rest async.
     * @param iterations total number of iterations
     * @param syncedIterations number of synchronous iterations in each async iteration.
     * @param fn the function to call each iteration.
     * @param callback a success call back that will be called when iterating stops.
     * @param breakFunction a break condition (optional)
     * @param timeout timeout settings for the setTimeout function. default - 0.
     * @returns the created async loop object
     */ static SyncAsyncForLoop(iterations, syncedIterations, fn, callback, breakFunction, timeout = 0) {
        return $89923ccd30e6d161$export$867c188241b31f47.Run(Math.ceil(iterations / syncedIterations), (loop)=>{
            if (breakFunction && breakFunction()) loop.breakLoop();
            else setTimeout(()=>{
                for(let i = 0; i < syncedIterations; ++i){
                    const iteration = loop.index * syncedIterations + i;
                    if (iteration >= iterations) break;
                    fn(iteration);
                    if (breakFunction && breakFunction()) {
                        loop.breakLoop();
                        break;
                    }
                }
                loop.executeNext();
            }, timeout);
        }, callback);
    }
}
$89923ccd30e6d161$export$390d11d353c16e49.Mix = (0, $wK2xc.Mix);
$89923ccd30e6d161$export$390d11d353c16e49.IsExponentOfTwo = (0, $wK2xc.IsExponentOfTwo);
// Will only be define if Tools is imported freeing up some space when only engine is required
(0, $ejQPp.EngineStore).FallbackTexture = "data:image/jpg;base64,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";

});
parcelRegister("diGQf", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $9aee303f50159649$export$77cea355fa80b5f4);
const $9aee303f50159649$var$isWeakRefSupported = typeof WeakRef !== "undefined";
class $9aee303f50159649$export$194fef50961cb62d {
    /**
     * Create a new EventState
     * @param mask defines the mask associated with this state
     * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     */ constructor(mask, skipNextObservers = false, target, currentTarget){
        this.initialize(mask, skipNextObservers, target, currentTarget);
    }
    /**
     * Initialize the current event state
     * @param mask defines the mask associated with this state
     * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @returns the current event state
     */ initialize(mask, skipNextObservers = false, target, currentTarget) {
        this.mask = mask;
        this.skipNextObservers = skipNextObservers;
        this.target = target;
        this.currentTarget = currentTarget;
        return this;
    }
}
class $9aee303f50159649$export$c1cbdee04e18ea8b {
    /**
     * Creates a new observer
     * @param callback defines the callback to call when the observer is notified
     * @param mask defines the mask of the observer (used to filter notifications)
     * @param scope defines the current scope used to restore the JS context
     */ constructor(/**
     * Defines the callback to call when the observer is notified
     */ callback, /**
     * Defines the mask of the observer (used to filter notifications)
     */ mask, /**
     * [null] Defines the current scope used to restore the JS context
     */ scope = null){
        this.callback = callback;
        this.mask = mask;
        this.scope = scope;
        /** @internal */ this._willBeUnregistered = false;
        /**
         * Gets or sets a property defining that the observer as to be unregistered after the next notification
         */ this.unregisterOnNextCall = false;
        /**
         * this function can be used to remove the observer from the observable.
         * It will be set by the observable that the observer belongs to.
         * @internal
         */ this._remove = null;
    }
    /**
     * Remove the observer from its observable
     * This can be used instead of using the observable's remove function.
     */ remove() {
        if (this._remove) this._remove();
    }
}
class $9aee303f50159649$export$77cea355fa80b5f4 {
    /**
     * Create an observable from a Promise.
     * @param promise a promise to observe for fulfillment.
     * @param onErrorObservable an observable to notify if a promise was rejected.
     * @returns the new Observable
     */ static FromPromise(promise, onErrorObservable) {
        const observable = new $9aee303f50159649$export$77cea355fa80b5f4();
        promise.then((ret)=>{
            observable.notifyObservers(ret);
        }).catch((err)=>{
            if (onErrorObservable) onErrorObservable.notifyObservers(err);
            else throw err;
        });
        return observable;
    }
    /**
     * Gets the list of observers
     * Note that observers that were recently deleted may still be present in the list because they are only really deleted on the next javascript tick!
     */ get observers() {
        return this._observers;
    }
    /**
     * Creates a new observable
     * @param onObserverAdded defines a callback to call when a new observer is added
     * @param notifyIfTriggered If set to true the observable will notify when an observer was added if the observable was already triggered.
     */ constructor(onObserverAdded, /**
     * [false] If set to true the observable will notify when an observer was added if the observable was already triggered.
     * This is helpful to single-state observables like the scene onReady or the dispose observable.
     */ notifyIfTriggered = false){
        this.notifyIfTriggered = notifyIfTriggered;
        this._observers = new Array();
        this._numObserversMarkedAsDeleted = 0;
        this._hasNotified = false;
        this._eventState = new $9aee303f50159649$export$194fef50961cb62d(0);
        if (onObserverAdded) this._onObserverAdded = onObserverAdded;
    }
    add(callback, mask = -1, insertFirst = false, scope = null, unregisterOnFirstCall = false) {
        if (!callback) return null;
        const observer = new $9aee303f50159649$export$c1cbdee04e18ea8b(callback, mask, scope);
        observer.unregisterOnNextCall = unregisterOnFirstCall;
        if (insertFirst) this._observers.unshift(observer);
        else this._observers.push(observer);
        if (this._onObserverAdded) this._onObserverAdded(observer);
        // If the observable was already triggered and the observable is set to notify if triggered, notify the new observer
        if (this._hasNotified && this.notifyIfTriggered) {
            if (this._lastNotifiedValue !== undefined) this.notifyObserver(observer, this._lastNotifiedValue);
        }
        // attach the remove function to the observer
        const observableWeakRef = $9aee303f50159649$var$isWeakRefSupported ? new WeakRef(this) : {
            deref: ()=>this
        };
        observer._remove = ()=>{
            const observable = observableWeakRef.deref();
            if (observable) observable._remove(observer);
        };
        return observer;
    }
    addOnce(callback) {
        return this.add(callback, undefined, undefined, undefined, true);
    }
    /**
     * Remove an Observer from the Observable object
     * @param observer the instance of the Observer to remove
     * @returns false if it doesn't belong to this Observable
     */ remove(observer) {
        if (!observer) return false;
        observer._remove = null;
        const index = this._observers.indexOf(observer);
        if (index !== -1) {
            this._deferUnregister(observer);
            return true;
        }
        return false;
    }
    /**
     * Remove a callback from the Observable object
     * @param callback the callback to remove
     * @param scope optional scope. If used only the callbacks with this scope will be removed
     * @returns false if it doesn't belong to this Observable
     */ removeCallback(callback, scope) {
        for(let index = 0; index < this._observers.length; index++){
            const observer = this._observers[index];
            if (observer._willBeUnregistered) continue;
            if (observer.callback === callback && (!scope || scope === observer.scope)) {
                this._deferUnregister(observer);
                return true;
            }
        }
        return false;
    }
    /**
     * @internal
     */ _deferUnregister(observer) {
        if (observer._willBeUnregistered) return;
        this._numObserversMarkedAsDeleted++;
        observer.unregisterOnNextCall = false;
        observer._willBeUnregistered = true;
        setTimeout(()=>{
            this._remove(observer);
        }, 0);
    }
    // This should only be called when not iterating over _observers to avoid callback skipping.
    // Removes an observer from the _observer Array.
    _remove(observer, updateCounter = true) {
        if (!observer) return false;
        const index = this._observers.indexOf(observer);
        if (index !== -1) {
            if (updateCounter) this._numObserversMarkedAsDeleted--;
            this._observers.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * Moves the observable to the top of the observer list making it get called first when notified
     * @param observer the observer to move
     */ makeObserverTopPriority(observer) {
        this._remove(observer, false);
        this._observers.unshift(observer);
    }
    /**
     * Moves the observable to the bottom of the observer list making it get called last when notified
     * @param observer the observer to move
     */ makeObserverBottomPriority(observer) {
        this._remove(observer, false);
        this._observers.push(observer);
    }
    /**
     * Notify all Observers by calling their respective callback with the given data
     * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
     * @param eventData defines the data to send to all observers
     * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @param userInfo defines any user info to send to observers
     * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
     */ notifyObservers(eventData, mask = -1, target, currentTarget, userInfo) {
        // this prevents potential memory leaks - if an object is disposed but the observable doesn't get cleared.
        if (this.notifyIfTriggered) {
            this._hasNotified = true;
            this._lastNotifiedValue = eventData;
        }
        if (!this._observers.length) return true;
        const state = this._eventState;
        state.mask = mask;
        state.target = target;
        state.currentTarget = currentTarget;
        state.skipNextObservers = false;
        state.lastReturnValue = eventData;
        state.userInfo = userInfo;
        for (const obs of this._observers){
            if (obs._willBeUnregistered) continue;
            if (obs.mask & mask) {
                if (obs.unregisterOnNextCall) this._deferUnregister(obs);
                if (obs.scope) state.lastReturnValue = obs.callback.apply(obs.scope, [
                    eventData,
                    state
                ]);
                else state.lastReturnValue = obs.callback(eventData, state);
            }
            if (state.skipNextObservers) return false;
        }
        return true;
    }
    /**
     * Notify a specific observer
     * @param observer defines the observer to notify
     * @param eventData defines the data to be sent to each callback
     * @param mask is used to filter observers defaults to -1
     */ notifyObserver(observer, eventData, mask = -1) {
        // this prevents potential memory leaks - if an object is disposed but the observable doesn't get cleared.
        if (this.notifyIfTriggered) {
            this._hasNotified = true;
            this._lastNotifiedValue = eventData;
        }
        if (observer._willBeUnregistered) return;
        const state = this._eventState;
        state.mask = mask;
        state.skipNextObservers = false;
        if (observer.unregisterOnNextCall) this._deferUnregister(observer);
        observer.callback(eventData, state);
    }
    /**
     * Gets a boolean indicating if the observable has at least one observer
     * @returns true is the Observable has at least one Observer registered
     */ hasObservers() {
        return this._observers.length - this._numObserversMarkedAsDeleted > 0;
    }
    /**
     * Clear the list of observers
     */ clear() {
        while(this._observers.length){
            const o = this._observers.pop();
            if (o) o._remove = null;
        }
        this._onObserverAdded = null;
        this._numObserversMarkedAsDeleted = 0;
        this.cleanLastNotifiedState();
    }
    /**
     * Clean the last notified state - both the internal last value and the has-notified flag
     */ cleanLastNotifiedState() {
        this._hasNotified = false;
        this._lastNotifiedValue = undefined;
    }
    /**
     * Clone the current observable
     * @returns a new observable
     */ clone() {
        const result = new $9aee303f50159649$export$77cea355fa80b5f4();
        result._observers = this._observers.slice(0);
        return result;
    }
    /**
     * Does this observable handles observer registered with a given mask
     * @param mask defines the mask to be tested
     * @returns whether or not one observer registered with the given mask is handled
     **/ hasSpecificMask(mask = -1) {
        for (const obs of this._observers){
            if (obs.mask & mask || obs.mask === mask) return true;
        }
        return false;
    }
}

});

parcelRegister("jFz47", function(module, exports) {

$parcel$export(module.exports, "IsWindowObjectExist", () => $e51d0be5b0623881$export$5fa14a6824e0afb4);
$parcel$export(module.exports, "IsNavigatorAvailable", () => $e51d0be5b0623881$export$56ff6edc4c9939ed);
$parcel$export(module.exports, "IsDocumentAvailable", () => $e51d0be5b0623881$export$a29feb91d8b4b85d);
$parcel$export(module.exports, "GetDOMTextContent", () => $e51d0be5b0623881$export$5697c7702aeb1f9c);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Checks if the window object exists
 * @returns true if the window object exists
 */ function $e51d0be5b0623881$export$5fa14a6824e0afb4() {
    return typeof window !== "undefined";
}
function $e51d0be5b0623881$export$56ff6edc4c9939ed() {
    return typeof navigator !== "undefined";
}
function $e51d0be5b0623881$export$a29feb91d8b4b85d() {
    return typeof document !== "undefined";
}
function $e51d0be5b0623881$export$5697c7702aeb1f9c(element) {
    let result = "";
    let child = element.firstChild;
    while(child){
        if (child.nodeType === 3) result += child.textContent;
        child = child.nextSibling;
    }
    return result;
}
const $e51d0be5b0623881$export$c5b65df3cf806e8b = {
    IsWindowObjectExist: /**
     * Checks if the window object exists
     * @returns true if the window object exists
     */ $e51d0be5b0623881$export$5fa14a6824e0afb4,
    IsNavigatorAvailable: /**
     * Checks if the navigator object exists
     * @returns true if the navigator object exists
     */ $e51d0be5b0623881$export$56ff6edc4c9939ed,
    IsDocumentAvailable: /**
     * Check if the document object exists
     * @returns true if the document object exists
     */ $e51d0be5b0623881$export$a29feb91d8b4b85d,
    GetDOMTextContent: /**
     * Extracts text content from a DOM element hierarchy
     * @param element defines the root element
     * @returns a string
     */ $e51d0be5b0623881$export$5697c7702aeb1f9c
};

});

parcelRegister("kVtWi", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $f3c05ad6b036a45a$export$efa9a398d6368992);
/* eslint-disable no-console */ /**
 * Logger used throughout the application to allow configuration of
 * the log level required for the messages.
 */ class $f3c05ad6b036a45a$export$efa9a398d6368992 {
    static _CheckLimit(message, limit) {
        let entry = $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs[message];
        if (!entry) {
            entry = {
                limit: limit,
                current: 1
            };
            $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs[message] = entry;
        } else entry.current++;
        return entry.current <= entry.limit;
    }
    static _GenerateLimitMessage(message, level = 1) {
        const entry = $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs[message];
        if (!entry || !$f3c05ad6b036a45a$export$efa9a398d6368992.MessageLimitReached) return;
        const type = this._Levels[level];
        if (entry.current === entry.limit) $f3c05ad6b036a45a$export$efa9a398d6368992[type.name]($f3c05ad6b036a45a$export$efa9a398d6368992.MessageLimitReached.replace(/%LIMIT%/g, "" + entry.limit).replace(/%TYPE%/g, type.name ?? ""));
    }
    static _AddLogEntry(entry) {
        $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache = entry + $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache;
        if ($f3c05ad6b036a45a$export$efa9a398d6368992.OnNewCacheEntry) $f3c05ad6b036a45a$export$efa9a398d6368992.OnNewCacheEntry(entry);
    }
    static _FormatMessage(message) {
        const padStr = (i)=>i < 10 ? "0" + i : "" + i;
        const date = new Date();
        return "[" + padStr(date.getHours()) + ":" + padStr(date.getMinutes()) + ":" + padStr(date.getSeconds()) + "]: " + message;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _LogDisabled(message, limit) {
    // nothing to do
    }
    static _LogEnabled(level = 1, message, limit) {
        // take first message if array
        const msg = Array.isArray(message) ? message[0] : message;
        if (limit !== undefined && !$f3c05ad6b036a45a$export$efa9a398d6368992._CheckLimit(msg, limit)) return;
        const formattedMessage = $f3c05ad6b036a45a$export$efa9a398d6368992._FormatMessage(msg);
        const type = this._Levels[level];
        const optionals = Array.isArray(message) ? message.slice(1) : [];
        type.logFunc && type.logFunc("BJS - " + formattedMessage, ...optionals);
        const entry = `<div style='color:${type.color}'>${formattedMessage}</div><br>`;
        $f3c05ad6b036a45a$export$efa9a398d6368992._AddLogEntry(entry);
        $f3c05ad6b036a45a$export$efa9a398d6368992._GenerateLimitMessage(msg, level);
    }
    /**
     * Gets current log cache (list of logs)
     */ static get LogCache() {
        return $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache;
    }
    /**
     * Clears the log cache
     */ static ClearLogCache() {
        $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache = "";
        $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs = {};
        $f3c05ad6b036a45a$export$efa9a398d6368992.errorsCount = 0;
    }
    /**
     * Sets the current log level. This property is a bit field, allowing you to combine different levels (MessageLogLevel / WarningLogLevel / ErrorLogLevel).
     * Use NoneLogLevel to disable logging and AllLogLevel for a quick way to enable all levels.
     */ static set LogLevels(level) {
        $f3c05ad6b036a45a$export$efa9a398d6368992.Log = $f3c05ad6b036a45a$export$efa9a398d6368992._LogDisabled;
        $f3c05ad6b036a45a$export$efa9a398d6368992.Warn = $f3c05ad6b036a45a$export$efa9a398d6368992._LogDisabled;
        $f3c05ad6b036a45a$export$efa9a398d6368992.Error = $f3c05ad6b036a45a$export$efa9a398d6368992._LogDisabled;
        [
            $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLogLevel,
            $f3c05ad6b036a45a$export$efa9a398d6368992.WarningLogLevel,
            $f3c05ad6b036a45a$export$efa9a398d6368992.ErrorLogLevel
        ].forEach((l)=>{
            if ((level & l) === l) {
                const type = this._Levels[l];
                $f3c05ad6b036a45a$export$efa9a398d6368992[type.name] = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, l);
            }
        });
    }
}
/**
 * No log
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.NoneLogLevel = 0;
/**
 * Only message logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLogLevel = 1;
/**
 * Only warning logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.WarningLogLevel = 2;
/**
 * Only error logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.ErrorLogLevel = 4;
/**
 * All logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.AllLogLevel = 7;
/**
 * Message to display when a message has been logged too many times
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLimitReached = "Too many %TYPE%s (%LIMIT%), no more %TYPE%s will be reported for this message.";
$f3c05ad6b036a45a$export$efa9a398d6368992._LogCache = "";
$f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs = {};
// levels according to the (binary) numbering.
$f3c05ad6b036a45a$export$efa9a398d6368992._Levels = [
    {},
    {
        color: "white",
        logFunc: console.log,
        name: "Log"
    },
    {
        color: "orange",
        logFunc: console.warn,
        name: "Warn"
    },
    {},
    {
        color: "red",
        logFunc: console.error,
        name: "Error"
    }
];
/**
 * Gets a value indicating the number of loading errors
 * @ignorenaming
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
$f3c05ad6b036a45a$export$efa9a398d6368992.errorsCount = 0;
/**
 * Log a message to the console
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.Log = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLogLevel);
/**
 * Write a warning message to the console
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.Warn = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, $f3c05ad6b036a45a$export$efa9a398d6368992.WarningLogLevel);
/**
 * Write an error message to the console
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.Error = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, $f3c05ad6b036a45a$export$efa9a398d6368992.ErrorLogLevel);

});

parcelRegister("fhgis", function(module, exports) {

$parcel$export(module.exports, "DeepCopier", () => $b1f515ba352436f8$export$9500e724ea15a79);

var $kVtWi = parcelRequire("kVtWi");
const $b1f515ba352436f8$var$CloneValue = (source, destinationObject, shallowCopyValues)=>{
    if (!source) return null;
    if (source.getClassName && source.getClassName() === "Mesh") return null;
    if (source.getClassName && (source.getClassName() === "SubMesh" || source.getClassName() === "PhysicsBody")) return source.clone(destinationObject);
    else if (source.clone) return source.clone();
    else if (Array.isArray(source)) return source.slice();
    else if (shallowCopyValues && typeof source === "object") return {
        ...source
    };
    return null;
};
function $b1f515ba352436f8$var$GetAllPropertyNames(obj) {
    const props = [];
    do Object.getOwnPropertyNames(obj).forEach(function(prop) {
        if (props.indexOf(prop) === -1) props.push(prop);
    });
    while (obj = Object.getPrototypeOf(obj));
    return props;
}
class $b1f515ba352436f8$export$9500e724ea15a79 {
    /**
     * Tries to copy an object by duplicating every property
     * @param source defines the source object
     * @param destination defines the target object
     * @param doNotCopyList defines a list of properties to avoid
     * @param mustCopyList defines a list of properties to copy (even if they start with _)
     * @param shallowCopyValues defines wether properties referencing objects (none cloneable) must be shallow copied (false by default)
     * @remarks shallowCopyValues will not instantite the copied values which makes it only usable for "JSON objects"
     */ static DeepCopy(source, destination, doNotCopyList, mustCopyList, shallowCopyValues = false) {
        const properties = $b1f515ba352436f8$var$GetAllPropertyNames(source);
        for (const prop of properties){
            if (prop[0] === "_" && (!mustCopyList || mustCopyList.indexOf(prop) === -1)) continue;
            if (prop.endsWith("Observable")) continue;
            if (doNotCopyList && doNotCopyList.indexOf(prop) !== -1) continue;
            const sourceValue = source[prop];
            const typeOfSourceValue = typeof sourceValue;
            if (typeOfSourceValue === "function") continue;
            try {
                if (typeOfSourceValue === "object") {
                    if (sourceValue instanceof Uint8Array) destination[prop] = Uint8Array.from(sourceValue);
                    else if (sourceValue instanceof Array) {
                        destination[prop] = [];
                        if (sourceValue.length > 0) {
                            if (typeof sourceValue[0] == "object") for(let index = 0; index < sourceValue.length; index++){
                                const clonedValue = $b1f515ba352436f8$var$CloneValue(sourceValue[index], destination, shallowCopyValues);
                                if (destination[prop].indexOf(clonedValue) === -1) // Test if auto inject was not done
                                destination[prop].push(clonedValue);
                            }
                            else destination[prop] = sourceValue.slice(0);
                        }
                    } else destination[prop] = $b1f515ba352436f8$var$CloneValue(sourceValue, destination, shallowCopyValues);
                } else destination[prop] = sourceValue;
            } catch (e) {
                // Log a warning (it could be because of a read-only property)
                (0, $kVtWi.Logger).Warn(e.message);
            }
        }
    }
}

});

parcelRegister("blHSI", function(module, exports) {

$parcel$export(module.exports, "PrecisionDate", () => $8433b1cffc3accb9$export$43f85f75a5a0b594);

var $jFz47 = parcelRequire("jFz47");
class $8433b1cffc3accb9$export$43f85f75a5a0b594 {
    /**
     * Gets either window.performance.now() if supported or Date.now() else
     */ static get Now() {
        if ((0, $jFz47.IsWindowObjectExist)() && window.performance && window.performance.now) return window.performance.now();
        return Date.now();
    }
}

});

parcelRegister("dUFYy", function(module, exports) {

$parcel$export(module.exports, "_WarnImport", () => $a21110d40db8ed13$export$2ee7d0376c644e32);
const $a21110d40db8ed13$var$warnedMap = {};
function $a21110d40db8ed13$export$2ee7d0376c644e32(name, warnOnce = false) {
    if (warnOnce && $a21110d40db8ed13$var$warnedMap[name]) return;
    $a21110d40db8ed13$var$warnedMap[name] = true;
    return `${name} needs to be imported before as it contains a side-effect required by your code.`;
}

});

parcelRegister("hUzEl", function(module, exports) {

$parcel$export(module.exports, "WebRequest", () => $d0a351f143d2884d$export$6f76b2393893a286);
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $d0a351f143d2884d$var$createXMLHttpRequest() {
    // If running in Babylon Native, then defer to the native XMLHttpRequest, which has the same public contract
    if (typeof _native !== "undefined" && _native.XMLHttpRequest) return new _native.XMLHttpRequest();
    else return new XMLHttpRequest();
}
class $d0a351f143d2884d$export$6f76b2393893a286 {
    constructor(){
        this._xhr = $d0a351f143d2884d$var$createXMLHttpRequest();
        this._requestURL = "";
    }
    /**
     * This function can be called to check if there are request modifiers for network requests
     * @returns true if there are any custom requests available
     */ static get IsCustomRequestAvailable() {
        return Object.keys($d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders).length > 0 || $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestModifiers.length > 0;
    }
    /**
     * Returns the requested URL once open has been called
     */ get requestURL() {
        return this._requestURL;
    }
    _injectCustomRequestHeaders() {
        if (this._shouldSkipRequestModifications(this._requestURL)) return;
        for(const key in $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders){
            const val = $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders[key];
            if (val) this._xhr.setRequestHeader(key, val);
        }
    }
    _shouldSkipRequestModifications(url) {
        return $d0a351f143d2884d$export$6f76b2393893a286.SkipRequestModificationForBabylonCDN && (url.includes("preview.babylonjs.com") || url.includes("cdn.babylonjs.com"));
    }
    /**
     * Gets or sets a function to be called when loading progress changes
     */ get onprogress() {
        return this._xhr.onprogress;
    }
    set onprogress(value) {
        this._xhr.onprogress = value;
    }
    /**
     * Returns client's state
     */ get readyState() {
        return this._xhr.readyState;
    }
    /**
     * Returns client's status
     */ get status() {
        return this._xhr.status;
    }
    /**
     * Returns client's status as a text
     */ get statusText() {
        return this._xhr.statusText;
    }
    /**
     * Returns client's response
     */ get response() {
        return this._xhr.response;
    }
    /**
     * Returns client's response url
     */ get responseURL() {
        return this._xhr.responseURL;
    }
    /**
     * Returns client's response as text
     */ get responseText() {
        return this._xhr.responseText;
    }
    /**
     * Gets or sets the expected response type
     */ get responseType() {
        return this._xhr.responseType;
    }
    set responseType(value) {
        this._xhr.responseType = value;
    }
    /**
     * Gets or sets the timeout value in milliseconds
     */ get timeout() {
        return this._xhr.timeout;
    }
    set timeout(value) {
        this._xhr.timeout = value;
    }
    addEventListener(type, listener, options) {
        this._xhr.addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        this._xhr.removeEventListener(type, listener, options);
    }
    /**
     * Cancels any network activity
     */ abort() {
        this._xhr.abort();
    }
    /**
     * Initiates the request. The optional argument provides the request body. The argument is ignored if request method is GET or HEAD
     * @param body defines an optional request body
     */ send(body) {
        if ($d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders) this._injectCustomRequestHeaders();
        this._xhr.send(body);
    }
    /**
     * Sets the request method, request URL
     * @param method defines the method to use (GET, POST, etc..)
     * @param url defines the url to connect with
     */ open(method, url) {
        for (const update of $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestModifiers){
            if (this._shouldSkipRequestModifications(url)) return;
            url = update(this._xhr, url) || url;
        }
        // Clean url
        url = url.replace("file:http:", "http:");
        url = url.replace("file:https:", "https:");
        this._requestURL = url;
        this._xhr.open(method, url, true);
    }
    /**
     * Sets the value of a request header.
     * @param name The name of the header whose value is to be set
     * @param value The value to set as the body of the header
     */ setRequestHeader(name, value) {
        this._xhr.setRequestHeader(name, value);
    }
    /**
     * Get the string containing the text of a particular header's value.
     * @param name The name of the header
     * @returns The string containing the text of the given header name
     */ getResponseHeader(name) {
        return this._xhr.getResponseHeader(name);
    }
}
/**
 * Custom HTTP Request Headers to be sent with XMLHttpRequests
 * i.e. when loading files, where the server/service expects an Authorization header
 */ $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders = {};
/**
 * Add callback functions in this array to update all the requests before they get sent to the network
 */ $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestModifiers = new Array();
/**
 * If set to true, requests to Babylon.js CDN requests will not be modified
 */ $d0a351f143d2884d$export$6f76b2393893a286.SkipRequestModificationForBabylonCDN = true;

});

parcelRegister("ejQPp", function(module, exports) {

$parcel$export(module.exports, "EngineStore", () => $a6cbd19ef6f666c3$export$56410c8371a1c0dc);

var $diGQf = parcelRequire("diGQf");
class $a6cbd19ef6f666c3$export$56410c8371a1c0dc {
    /**
     * Gets the latest created engine
     */ static get LastCreatedEngine() {
        if (this.Instances.length === 0) return null;
        return this.Instances[this.Instances.length - 1];
    }
    /**
     * Gets the latest created scene
     */ static get LastCreatedScene() {
        return this._LastCreatedScene;
    }
}
/** Gets the list of created engines */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.Instances = [];
/**
 * Notifies when an engine was disposed.
 * Mainly used for static/cache cleanup
 */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.OnEnginesDisposedObservable = new (0, $diGQf.Observable)();
/** @internal */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc._LastCreatedScene = null;
/**
 * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
 * @ignorenaming
 */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.UseFallbackTexture = true;
/**
 * Texture content used if a texture cannot loaded
 * @ignorenaming
 */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.FallbackTexture = "";

});

parcelRegister("EOxw7", function(module, exports) {

$parcel$export(module.exports, "FileToolsOptions", () => $07aaf0a72a34b36c$export$c6667b012a1924ce);
$parcel$export(module.exports, "SetCorsBehavior", () => $07aaf0a72a34b36c$export$702ccb4912b94000);
$parcel$export(module.exports, "LoadImage", () => $07aaf0a72a34b36c$export$25299f3c4579a3a1);
$parcel$export(module.exports, "LoadFile", () => $07aaf0a72a34b36c$export$59daebe6f5c4b354);
$parcel$export(module.exports, "ReadFile", () => $07aaf0a72a34b36c$export$dde4d76a2e6dd805);
$parcel$export(module.exports, "DecodeBase64UrlToBinary", () => $07aaf0a72a34b36c$export$c8330d53aa73bc13);
$parcel$export(module.exports, "RequestFile", () => $07aaf0a72a34b36c$export$94e3aec8611d3b55);
$parcel$export(module.exports, "IsBase64DataUrl", () => $07aaf0a72a34b36c$export$dd25b96132dd59eb);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $hUzEl = parcelRequire("hUzEl");

var $jFz47 = parcelRequire("jFz47");

var $diGQf = parcelRequire("diGQf");

var $8btZm = parcelRequire("8btZm");

var $c10Gh = parcelRequire("c10Gh");

var $1FkG9 = parcelRequire("1FkG9");

var $eLv1o = parcelRequire("eLv1o");

var $kbQ0z = parcelRequire("kbQ0z");

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $av6Bc = parcelRequire("av6Bc");

var $cOV0H = parcelRequire("cOV0H");

var $dUFoQ = parcelRequire("dUFoQ");
const $07aaf0a72a34b36c$var$Base64DataUrlRegEx = new RegExp(/^data:([^,]+\/[^,]+)?;base64,/i);
class $07aaf0a72a34b36c$export$43bc2e920b24af3b extends (0, $1FkG9.RuntimeError) {
    /**
     * Creates a new LoadFileError
     * @param message defines the message of the error
     * @param object defines the optional web request
     */ constructor(message, object){
        super(message, (0, $1FkG9.ErrorCodes).LoadFileError);
        this.name = "LoadFileError";
        (0, $1FkG9.BaseError)._setPrototypeOf(this, $07aaf0a72a34b36c$export$43bc2e920b24af3b.prototype);
        if (object instanceof (0, $hUzEl.WebRequest)) this.request = object;
        else this.file = object;
    }
}
class $07aaf0a72a34b36c$export$c5bad8820e6a4362 extends (0, $1FkG9.RuntimeError) {
    /**
     * Creates a new LoadFileError
     * @param message defines the message of the error
     * @param request defines the optional web request
     */ constructor(message, request){
        super(message, (0, $1FkG9.ErrorCodes).RequestFileError);
        this.request = request;
        this.name = "RequestFileError";
        (0, $1FkG9.BaseError)._setPrototypeOf(this, $07aaf0a72a34b36c$export$c5bad8820e6a4362.prototype);
    }
}
class $07aaf0a72a34b36c$export$f20a28865dd27b8f extends (0, $1FkG9.RuntimeError) {
    /**
     * Creates a new ReadFileError
     * @param message defines the message of the error
     * @param file defines the optional file
     */ constructor(message, file){
        super(message, (0, $1FkG9.ErrorCodes).ReadFileError);
        this.file = file;
        this.name = "ReadFileError";
        (0, $1FkG9.BaseError)._setPrototypeOf(this, $07aaf0a72a34b36c$export$f20a28865dd27b8f.prototype);
    }
}
/**
 * Removes unwanted characters from an url
 * @param url defines the url to clean
 * @returns the cleaned url
 */ const $07aaf0a72a34b36c$var$CleanUrl = (url)=>{
    url = url.replace(/#/gm, "%23");
    return url;
};
const $07aaf0a72a34b36c$export$c6667b012a1924ce = {
    /**
     * Gets or sets the retry strategy to apply when an error happens while loading an asset.
     * When defining this function, return the wait time before trying again or return -1 to
     * stop retrying and error out.
     */ DefaultRetryStrategy: (0, $c10Gh.RetryStrategy).ExponentialBackoff(),
    /**
     * Gets or sets the base URL to use to load assets
     */ BaseUrl: "",
    /**
     * Default behaviour for cors in the application.
     * It can be a string if the expected behavior is identical in the entire app.
     * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
     */ CorsBehavior: "anonymous",
    /**
     * Gets or sets a function used to pre-process url before using them to load assets
     * @param url
     * @returns the processed url
     */ PreprocessUrl: (url)=>url,
    /**
     * Gets or sets the base URL to use to load scripts
     * Used for both JS and WASM
     */ ScriptBaseUrl: "",
    /**
     * Gets or sets a function used to pre-process script url before using them to load.
     * Used for both JS and WASM
     * @param url defines the url to process
     * @returns the processed url
     */ ScriptPreprocessUrl: (url)=>url,
    CleanUrl: /**
     * Gets or sets a function used to clean the url before using it to load assets
     * @param url defines the url to clean
     * @returns the cleaned url
     */ $07aaf0a72a34b36c$var$CleanUrl
};
const $07aaf0a72a34b36c$export$702ccb4912b94000 = (url, element)=>{
    if (url && url.indexOf("data:") === 0) return;
    if ($07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior) {
        if (typeof $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior === "string" || $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior instanceof String) element.crossOrigin = $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior;
        else {
            const result = $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior(url);
            if (result) element.crossOrigin = result;
        }
    }
};
const $07aaf0a72a34b36c$export$da15b7dd6cfeda82 = {
    getRequiredSize: null
};
const $07aaf0a72a34b36c$export$25299f3c4579a3a1 = (input, onLoad, onError, offlineProvider, mimeType = "", imageBitmapOptions)=>{
    const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
    if (typeof HTMLImageElement === "undefined" && !engine?._features.forceBitmapOverHTMLImageElement) {
        onError("LoadImage is only supported in web or BabylonNative environments.");
        return null;
    }
    let url;
    let usingObjectURL = false;
    if (input instanceof ArrayBuffer || ArrayBuffer.isView(input)) {
        if (typeof Blob !== "undefined" && typeof URL !== "undefined") {
            url = URL.createObjectURL(new Blob([
                input
            ], {
                type: mimeType
            }));
            usingObjectURL = true;
        } else url = `data:${mimeType};base64,` + (0, $eLv1o.EncodeArrayBufferToBase64)(input);
    } else if (input instanceof Blob) {
        url = URL.createObjectURL(input);
        usingObjectURL = true;
    } else {
        url = $07aaf0a72a34b36c$export$c6667b012a1924ce.CleanUrl(input);
        url = $07aaf0a72a34b36c$export$c6667b012a1924ce.PreprocessUrl(url);
    }
    const onErrorHandler = (exception)=>{
        if (onError) {
            const inputText = url || input.toString();
            onError(`Error while trying to load image: ${inputText.indexOf("http") === 0 || inputText.length <= 128 ? inputText : inputText.slice(0, 128) + "..."}`, exception);
        }
    };
    if (engine?._features.forceBitmapOverHTMLImageElement) {
        $07aaf0a72a34b36c$export$59daebe6f5c4b354(url, (data)=>{
            engine.createImageBitmap(new Blob([
                data
            ], {
                type: mimeType
            }), {
                premultiplyAlpha: "none",
                ...imageBitmapOptions
            }).then((imgBmp)=>{
                onLoad(imgBmp);
                if (usingObjectURL) URL.revokeObjectURL(url);
            }).catch((reason)=>{
                if (onError) onError("Error while trying to load image: " + input, reason);
            });
        }, undefined, offlineProvider || undefined, true, (request, exception)=>{
            onErrorHandler(exception);
        });
        return null;
    }
    const img = new Image();
    if ($07aaf0a72a34b36c$export$da15b7dd6cfeda82.getRequiredSize) {
        const size = $07aaf0a72a34b36c$export$da15b7dd6cfeda82.getRequiredSize(input);
        if (size.width) img.width = size.width;
        if (size.height) img.height = size.height;
    }
    $07aaf0a72a34b36c$export$702ccb4912b94000(url, img);
    const handlersList = [];
    const loadHandlersList = ()=>{
        handlersList.forEach((handler)=>{
            handler.target.addEventListener(handler.name, handler.handler);
        });
    };
    const unloadHandlersList = ()=>{
        handlersList.forEach((handler)=>{
            handler.target.removeEventListener(handler.name, handler.handler);
        });
        handlersList.length = 0;
    };
    const loadHandler = ()=>{
        unloadHandlersList();
        onLoad(img);
        // Must revoke the URL after calling onLoad to avoid security exceptions in
        // certain scenarios (e.g. when hosted in vscode).
        if (usingObjectURL && img.src) URL.revokeObjectURL(img.src);
    };
    const errorHandler = (err)=>{
        unloadHandlersList();
        onErrorHandler(err);
        if (usingObjectURL && img.src) URL.revokeObjectURL(img.src);
    };
    const cspHandler = (err)=>{
        if (err.blockedURI !== img.src || err.disposition === "report") return;
        unloadHandlersList();
        const cspException = new Error(`CSP violation of policy ${err.effectiveDirective} ${err.blockedURI}. Current policy is ${err.originalPolicy}`);
        (0, $ejQPp.EngineStore).UseFallbackTexture = false;
        onErrorHandler(cspException);
        if (usingObjectURL && img.src) URL.revokeObjectURL(img.src);
        img.src = "";
    };
    handlersList.push({
        target: img,
        name: "load",
        handler: loadHandler
    });
    handlersList.push({
        target: img,
        name: "error",
        handler: errorHandler
    });
    handlersList.push({
        target: document,
        name: "securitypolicyviolation",
        handler: cspHandler
    });
    loadHandlersList();
    const fromBlob = url.substring(0, 5) === "blob:";
    const fromData = url.substring(0, 5) === "data:";
    const noOfflineSupport = ()=>{
        if (fromBlob || fromData || !(0, $hUzEl.WebRequest).IsCustomRequestAvailable) img.src = url;
        else $07aaf0a72a34b36c$export$59daebe6f5c4b354(url, (data, _, contentType)=>{
            const type = !mimeType && contentType ? contentType : mimeType;
            const blob = new Blob([
                data
            ], {
                type: type
            });
            const url = URL.createObjectURL(blob);
            usingObjectURL = true;
            img.src = url;
        }, undefined, offlineProvider || undefined, true, (_request, exception)=>{
            onErrorHandler(exception);
        });
    };
    const loadFromOfflineSupport = ()=>{
        if (offlineProvider) offlineProvider.loadImage(url, img);
    };
    if (!fromBlob && !fromData && offlineProvider && offlineProvider.enableTexturesOffline) offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
    else {
        if (url.indexOf("file:") !== -1) {
            const textureName = decodeURIComponent(url.substring(5).toLowerCase());
            if ((0, $8btZm.FilesInputStore).FilesToLoad[textureName] && typeof URL !== "undefined") {
                try {
                    let blobURL;
                    try {
                        blobURL = URL.createObjectURL((0, $8btZm.FilesInputStore).FilesToLoad[textureName]);
                    } catch (ex) {
                        // Chrome doesn't support oneTimeOnly parameter
                        blobURL = URL.createObjectURL((0, $8btZm.FilesInputStore).FilesToLoad[textureName]);
                    }
                    img.src = blobURL;
                    usingObjectURL = true;
                } catch (e) {
                    img.src = "";
                }
                return img;
            }
        }
        noOfflineSupport();
    }
    return img;
};
const $07aaf0a72a34b36c$export$dde4d76a2e6dd805 = (file, onSuccess, onProgress, useArrayBuffer, onError)=>{
    const reader = new FileReader();
    const fileRequest = {
        onCompleteObservable: new (0, $diGQf.Observable)(),
        abort: ()=>reader.abort()
    };
    reader.onloadend = ()=>fileRequest.onCompleteObservable.notifyObservers(fileRequest);
    if (onError) reader.onerror = ()=>{
        onError(new $07aaf0a72a34b36c$export$f20a28865dd27b8f(`Unable to read ${file.name}`, file));
    };
    reader.onload = (e)=>{
        //target doesn't have result from ts 1.3
        onSuccess(e.target["result"]);
    };
    if (onProgress) reader.onprogress = onProgress;
    if (!useArrayBuffer) // Asynchronous read
    reader.readAsText(file);
    else reader.readAsArrayBuffer(file);
    return fileRequest;
};
const $07aaf0a72a34b36c$export$59daebe6f5c4b354 = (fileOrUrl, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened)=>{
    if (fileOrUrl.name) return $07aaf0a72a34b36c$export$dde4d76a2e6dd805(fileOrUrl, onSuccess, onProgress, useArrayBuffer, onError ? (error)=>{
        onError(undefined, error);
    } : undefined);
    const url = fileOrUrl;
    // If file and file input are set
    if (url.indexOf("file:") !== -1) {
        let fileName = decodeURIComponent(url.substring(5).toLowerCase());
        if (fileName.indexOf("./") === 0) fileName = fileName.substring(2);
        const file = (0, $8btZm.FilesInputStore).FilesToLoad[fileName];
        if (file) return $07aaf0a72a34b36c$export$dde4d76a2e6dd805(file, onSuccess, onProgress, useArrayBuffer, onError ? (error)=>onError(undefined, new $07aaf0a72a34b36c$export$43bc2e920b24af3b(error.message, error.file)) : undefined);
    }
    // For a Base64 Data URL
    const { match: match, type: type } = $07aaf0a72a34b36c$export$91734fbaccdffc48(url);
    if (match) {
        const fileRequest = {
            onCompleteObservable: new (0, $diGQf.Observable)(),
            abort: ()=>()=>{}
        };
        try {
            const data = useArrayBuffer ? $07aaf0a72a34b36c$export$c8330d53aa73bc13(url) : $07aaf0a72a34b36c$export$a35972a337c29f7a(url);
            onSuccess(data, undefined, type);
        } catch (error) {
            if (onError) onError(undefined, error);
            else (0, $kVtWi.Logger).Error(error.message || "Failed to parse the Data URL");
        }
        (0, $av6Bc.TimingTools).SetImmediate(()=>{
            fileRequest.onCompleteObservable.notifyObservers(fileRequest);
        });
        return fileRequest;
    }
    return $07aaf0a72a34b36c$export$94e3aec8611d3b55(url, (data, request)=>{
        onSuccess(data, request?.responseURL, request?.getResponseHeader("content-type"));
    }, onProgress, offlineProvider, useArrayBuffer, onError ? (error)=>{
        onError(error.request, new $07aaf0a72a34b36c$export$43bc2e920b24af3b(error.message, error.request));
    } : undefined, onOpened);
};
const $07aaf0a72a34b36c$export$94e3aec8611d3b55 = (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened)=>{
    url = $07aaf0a72a34b36c$export$c6667b012a1924ce.CleanUrl(url);
    url = $07aaf0a72a34b36c$export$c6667b012a1924ce.PreprocessUrl(url);
    const loadUrl = $07aaf0a72a34b36c$export$c6667b012a1924ce.BaseUrl + url;
    let aborted = false;
    const fileRequest = {
        onCompleteObservable: new (0, $diGQf.Observable)(),
        abort: ()=>aborted = true
    };
    const requestFile = ()=>{
        let request = new (0, $hUzEl.WebRequest)();
        let retryHandle = null;
        let onReadyStateChange;
        const unbindEvents = ()=>{
            if (!request) return;
            if (onProgress) request.removeEventListener("progress", onProgress);
            if (onReadyStateChange) request.removeEventListener("readystatechange", onReadyStateChange);
            request.removeEventListener("loadend", onLoadEnd);
        };
        let onLoadEnd = ()=>{
            unbindEvents();
            fileRequest.onCompleteObservable.notifyObservers(fileRequest);
            fileRequest.onCompleteObservable.clear();
            onProgress = undefined;
            onReadyStateChange = null;
            onLoadEnd = null;
            onError = undefined;
            onOpened = undefined;
            onSuccess = undefined;
        };
        fileRequest.abort = ()=>{
            aborted = true;
            if (onLoadEnd) onLoadEnd();
            if (request && request.readyState !== (XMLHttpRequest.DONE || 4)) request.abort();
            if (retryHandle !== null) {
                clearTimeout(retryHandle);
                retryHandle = null;
            }
            request = null;
        };
        const handleError = (error)=>{
            const message = error.message || "Unknown error";
            if (onError && request) onError(new $07aaf0a72a34b36c$export$c5bad8820e6a4362(message, request));
            else (0, $kVtWi.Logger).Error(message);
        };
        const retryLoop = (retryIndex)=>{
            if (!request) return;
            request.open("GET", loadUrl);
            if (onOpened) try {
                onOpened(request);
            } catch (e) {
                handleError(e);
                return;
            }
            if (useArrayBuffer) request.responseType = "arraybuffer";
            if (onProgress) request.addEventListener("progress", onProgress);
            if (onLoadEnd) request.addEventListener("loadend", onLoadEnd);
            onReadyStateChange = ()=>{
                if (aborted || !request) return;
                // In case of undefined state in some browsers.
                if (request.readyState === (XMLHttpRequest.DONE || 4)) {
                    // Some browsers have issues where onreadystatechange can be called multiple times with the same value.
                    if (onReadyStateChange) request.removeEventListener("readystatechange", onReadyStateChange);
                    if (request.status >= 200 && request.status < 300 || request.status === 0 && (!(0, $jFz47.IsWindowObjectExist)() || $07aaf0a72a34b36c$export$83bbca801f4fc9f())) {
                        // It's possible for the request to have a success status code but null response if the underlying
                        // underlying HTTP connection was closed prematurely. See _onHttpResponseClose in xhr2.js. In this
                        // case we will throw an exception if we call the onSuccess handler because "data" will be null
                        // and that then bypasses the retry strategy.
                        const data = useArrayBuffer ? request.response : request.responseText;
                        if (data !== null) {
                            try {
                                if (onSuccess) onSuccess(data, request);
                            } catch (e) {
                                handleError(e);
                            }
                            return;
                        }
                    }
                    const retryStrategy = $07aaf0a72a34b36c$export$c6667b012a1924ce.DefaultRetryStrategy;
                    if (retryStrategy) {
                        const waitTime = retryStrategy(loadUrl, request, retryIndex);
                        if (waitTime !== -1) {
                            // Prevent the request from completing for retry.
                            unbindEvents();
                            request = new (0, $hUzEl.WebRequest)();
                            retryHandle = setTimeout(()=>retryLoop(retryIndex + 1), waitTime);
                            return;
                        }
                    }
                    const error = new $07aaf0a72a34b36c$export$c5bad8820e6a4362("Error status: " + request.status + " " + request.statusText + " - Unable to load " + loadUrl, request);
                    if (onError) onError(error);
                }
            };
            request.addEventListener("readystatechange", onReadyStateChange);
            request.send();
        };
        retryLoop(0);
    };
    // Caching all files
    if (offlineProvider && offlineProvider.enableSceneOffline) {
        const noOfflineSupport = (request)=>{
            if (request && request.status > 400) {
                if (onError) onError(request);
            } else requestFile();
        };
        const loadFromOfflineSupport = ()=>{
            // TODO: database needs to support aborting and should return a IFileRequest
            if (offlineProvider) offlineProvider.loadFile($07aaf0a72a34b36c$export$c6667b012a1924ce.BaseUrl + url, (data)=>{
                if (!aborted && onSuccess) onSuccess(data);
                fileRequest.onCompleteObservable.notifyObservers(fileRequest);
            }, onProgress ? (event)=>{
                if (!aborted && onProgress) onProgress(event);
            } : undefined, noOfflineSupport, useArrayBuffer);
        };
        offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
    } else requestFile();
    return fileRequest;
};
const $07aaf0a72a34b36c$export$83bbca801f4fc9f = ()=>{
    return typeof location !== "undefined" && location.protocol === "file:";
};
const $07aaf0a72a34b36c$export$dd25b96132dd59eb = (uri)=>{
    return $07aaf0a72a34b36c$var$Base64DataUrlRegEx.test(uri);
};
const $07aaf0a72a34b36c$export$91734fbaccdffc48 = (uri)=>{
    const results = $07aaf0a72a34b36c$var$Base64DataUrlRegEx.exec(uri);
    if (results === null || results.length === 0) return {
        match: false,
        type: ""
    };
    else {
        const type = results[0].replace("data:", "").replace("base64,", "");
        return {
            match: true,
            type: type
        };
    }
};
function $07aaf0a72a34b36c$export$c8330d53aa73bc13(uri) {
    return (0, $eLv1o.DecodeBase64ToBinary)(uri.split(",")[1]);
}
const $07aaf0a72a34b36c$export$a35972a337c29f7a = (uri)=>{
    return (0, $eLv1o.DecodeBase64ToString)(uri.split(",")[1]);
};
/**
 * This will be executed automatically for UMD and es5.
 * If esm dev wants the side effects to execute they will have to run it manually
 * Once we build native modules those need to be exported.
 * @internal
 */ const $07aaf0a72a34b36c$var$initSideEffects = ()=>{
    (0, $dUFoQ.AbstractEngine)._FileToolsLoadImage = $07aaf0a72a34b36c$export$25299f3c4579a3a1;
    (0, $cOV0H.EngineFunctionContext).loadFile = $07aaf0a72a34b36c$export$59daebe6f5c4b354;
    (0, $kbQ0z._functionContainer).loadFile = $07aaf0a72a34b36c$export$59daebe6f5c4b354;
};
$07aaf0a72a34b36c$var$initSideEffects();
let $07aaf0a72a34b36c$export$95c1b81028a4cfad;
const $07aaf0a72a34b36c$export$4891d9942bd12bdb = (DecodeBase64UrlToBinary, DecodeBase64UrlToString, FileToolsOptions, IsBase64DataUrl, IsFileURL, LoadFile, LoadImage, ReadFile, RequestFile, SetCorsBehavior)=>{
    /**
     * Backwards compatibility.
     * @internal
     * @deprecated
     */ $07aaf0a72a34b36c$export$95c1b81028a4cfad = {
        DecodeBase64UrlToBinary: DecodeBase64UrlToBinary,
        DecodeBase64UrlToString: DecodeBase64UrlToString,
        DefaultRetryStrategy: FileToolsOptions.DefaultRetryStrategy,
        BaseUrl: FileToolsOptions.BaseUrl,
        CorsBehavior: FileToolsOptions.CorsBehavior,
        PreprocessUrl: FileToolsOptions.PreprocessUrl,
        IsBase64DataUrl: IsBase64DataUrl,
        IsFileURL: IsFileURL,
        LoadFile: LoadFile,
        LoadImage: LoadImage,
        ReadFile: ReadFile,
        RequestFile: RequestFile,
        SetCorsBehavior: SetCorsBehavior
    };
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "DefaultRetryStrategy", {
        get: function() {
            return FileToolsOptions.DefaultRetryStrategy;
        },
        set: function(value) {
            FileToolsOptions.DefaultRetryStrategy = value;
        }
    });
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "BaseUrl", {
        get: function() {
            return FileToolsOptions.BaseUrl;
        },
        set: function(value) {
            FileToolsOptions.BaseUrl = value;
        }
    });
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "PreprocessUrl", {
        get: function() {
            return FileToolsOptions.PreprocessUrl;
        },
        set: function(value) {
            FileToolsOptions.PreprocessUrl = value;
        }
    });
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "CorsBehavior", {
        get: function() {
            return FileToolsOptions.CorsBehavior;
        },
        set: function(value) {
            FileToolsOptions.CorsBehavior = value;
        }
    });
};
$07aaf0a72a34b36c$export$4891d9942bd12bdb($07aaf0a72a34b36c$export$c8330d53aa73bc13, $07aaf0a72a34b36c$export$a35972a337c29f7a, $07aaf0a72a34b36c$export$c6667b012a1924ce, $07aaf0a72a34b36c$export$dd25b96132dd59eb, $07aaf0a72a34b36c$export$83bbca801f4fc9f, $07aaf0a72a34b36c$export$59daebe6f5c4b354, $07aaf0a72a34b36c$export$25299f3c4579a3a1, $07aaf0a72a34b36c$export$dde4d76a2e6dd805, $07aaf0a72a34b36c$export$94e3aec8611d3b55, $07aaf0a72a34b36c$export$702ccb4912b94000);

});
parcelRegister("8btZm", function(module, exports) {

$parcel$export(module.exports, "FilesInputStore", () => $5f569ced0b4209fd$export$16eb4d7c0a0517f4);
/**
 * Class used to help managing file picking and drag'n'drop
 * File Storage
 */ class $5f569ced0b4209fd$export$16eb4d7c0a0517f4 {
}
/**
 * List of files ready to be loaded
 */ $5f569ced0b4209fd$export$16eb4d7c0a0517f4.FilesToLoad = {};

});

parcelRegister("c10Gh", function(module, exports) {

$parcel$export(module.exports, "RetryStrategy", () => $8bf61b3d45bd4953$export$a700efba39673191);
/**
 * Class used to define a retry strategy when error happens while loading assets
 */ class $8bf61b3d45bd4953$export$a700efba39673191 {
    /**
     * Function used to defines an exponential back off strategy
     * @param maxRetries defines the maximum number of retries (3 by default)
     * @param baseInterval defines the interval between retries
     * @returns the strategy function to use
     */ static ExponentialBackoff(maxRetries = 3, baseInterval = 500) {
        return (url, request, retryIndex)=>{
            if (request.status !== 0 || retryIndex >= maxRetries || url.indexOf("file:") !== -1) return -1;
            return Math.pow(2, retryIndex) * baseInterval;
        };
    }
}

});

parcelRegister("1FkG9", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $1369a92b7089f970$export$a490eb03cb7a0a5e);
$parcel$export(module.exports, "ErrorCodes", () => $1369a92b7089f970$export$10e8e1cf990558d7);
$parcel$export(module.exports, "RuntimeError", () => $1369a92b7089f970$export$4a24a86bdbcf02bb);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Base error. Due to limitations of typedoc-check and missing documentation
 * in lib.es5.d.ts, cannot extend Error directly for RuntimeError.
 * @ignore
 */ class $1369a92b7089f970$export$a490eb03cb7a0a5e extends Error {
}
// See https://stackoverflow.com/questions/12915412/how-do-i-extend-a-host-object-e-g-error-in-typescript
// and https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
// Polyfill for Object.setPrototypeOf if necessary.
$1369a92b7089f970$export$a490eb03cb7a0a5e._setPrototypeOf = Object.setPrototypeOf || ((o, proto)=>{
    o.__proto__ = proto;
    return o;
});
const $1369a92b7089f970$export$10e8e1cf990558d7 = {
    // Mesh errors 0-999
    /** Invalid or empty mesh vertex positions. */ MeshInvalidPositionsError: 0,
    // Texture errors 1000-1999
    /** Unsupported texture found. */ UnsupportedTextureError: 1000,
    // GLTFLoader errors 2000-2999
    /** Unexpected magic number found in GLTF file header. */ GLTFLoaderUnexpectedMagicError: 2000,
    // SceneLoader errors 3000-3999
    /** SceneLoader generic error code. Ideally wraps the inner exception. */ SceneLoaderError: 3000,
    // File related errors 4000-4999
    /** Load file error */ LoadFileError: 4000,
    /** Request file error */ RequestFileError: 4001,
    /** Read file error */ ReadFileError: 4002
};
class $1369a92b7089f970$export$4a24a86bdbcf02bb extends $1369a92b7089f970$export$a490eb03cb7a0a5e {
    /**
     * Creates a new RuntimeError
     * @param message defines the message of the error
     * @param errorCode the error code
     * @param innerError the error that caused the outer error
     */ constructor(message, errorCode, innerError){
        super(message);
        this.errorCode = errorCode;
        this.innerError = innerError;
        this.name = "RuntimeError";
        $1369a92b7089f970$export$a490eb03cb7a0a5e._setPrototypeOf(this, $1369a92b7089f970$export$4a24a86bdbcf02bb.prototype);
    }
}
class $1369a92b7089f970$export$18b052ffd8c84d7 extends $1369a92b7089f970$export$a490eb03cb7a0a5e {
    constructor(message = "Operation aborted"){
        super(message);
        this.name = "AbortError";
        $1369a92b7089f970$export$a490eb03cb7a0a5e._setPrototypeOf(this, $1369a92b7089f970$export$18b052ffd8c84d7.prototype);
    }
}

});

parcelRegister("eLv1o", function(module, exports) {

$parcel$export(module.exports, "EncodeArrayBufferToBase64", () => $abfd84b2a7c60488$export$88038554b26d4b46);
$parcel$export(module.exports, "DecodeBase64ToString", () => $abfd84b2a7c60488$export$bf9b48664c8e387);
$parcel$export(module.exports, "DecodeBase64ToBinary", () => $abfd84b2a7c60488$export$3530a531e4225c2f);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Checks for a matching suffix at the end of a string (for ES5 and lower)
 * @param str Source string
 * @param suffix Suffix to search for in the source string
 * @returns Boolean indicating whether the suffix was found (true) or not (false)
 * @deprecated Please use native string function instead
 */ const $abfd84b2a7c60488$export$b378f36d7aa04d3e = (str, suffix)=>{
    return str.endsWith(suffix);
};
const $abfd84b2a7c60488$export$96ebffb07897cd9c = (str, suffix)=>{
    if (!str) return false;
    return str.startsWith(suffix);
};
const $abfd84b2a7c60488$export$325185342b153af9 = (buffer)=>{
    if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(buffer);
    let result = "";
    for(let i = 0; i < buffer.byteLength; i++)result += String.fromCharCode(buffer[i]);
    return result;
};
const $abfd84b2a7c60488$export$88038554b26d4b46 = (buffer)=>{
    const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    const bytes = ArrayBuffer.isView(buffer) ? new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) : new Uint8Array(buffer);
    while(i < bytes.length){
        chr1 = bytes[i++];
        chr2 = i < bytes.length ? bytes[i++] : Number.NaN;
        chr3 = i < bytes.length ? bytes[i++] : Number.NaN;
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
};
const $abfd84b2a7c60488$export$bf9b48664c8e387 = (base64Data)=>{
    return atob(base64Data);
};
const $abfd84b2a7c60488$export$3530a531e4225c2f = (base64Data)=>{
    const decodedString = $abfd84b2a7c60488$export$bf9b48664c8e387(base64Data);
    const bufferLength = decodedString.length;
    const bufferView = new Uint8Array(new ArrayBuffer(bufferLength));
    for(let i = 0; i < bufferLength; i++)bufferView[i] = decodedString.charCodeAt(i);
    return bufferView.buffer;
};
const $abfd84b2a7c60488$export$bc6b405b5a1a6a5b = (num, length)=>{
    let str = String(num);
    while(str.length < length)str = "0" + str;
    return str;
};
const $abfd84b2a7c60488$export$80369d553ce790c0 = {
    EndsWith: $abfd84b2a7c60488$export$b378f36d7aa04d3e,
    StartsWith: $abfd84b2a7c60488$export$96ebffb07897cd9c,
    Decode: $abfd84b2a7c60488$export$325185342b153af9,
    EncodeArrayBufferToBase64: $abfd84b2a7c60488$export$88038554b26d4b46,
    DecodeBase64ToString: $abfd84b2a7c60488$export$bf9b48664c8e387,
    DecodeBase64ToBinary: $abfd84b2a7c60488$export$3530a531e4225c2f,
    PadNumber: $abfd84b2a7c60488$export$bc6b405b5a1a6a5b
};

});

parcelRegister("kbQ0z", function(module, exports) {

$parcel$export(module.exports, "Initialize", () => $eb2d2d73daee21fb$export$b03b1c699c90a9b4);
$parcel$export(module.exports, "Process", () => $eb2d2d73daee21fb$export$ddab65ae98aaa487);
$parcel$export(module.exports, "_ProcessIncludes", () => $eb2d2d73daee21fb$export$3fd043f8e205658a);
$parcel$export(module.exports, "Finalize", () => $eb2d2d73daee21fb$export$29defdae7b3f3a01);
$parcel$export(module.exports, "_functionContainer", () => $eb2d2d73daee21fb$export$e53aa09f5deb83f1);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $9ePQk = parcelRequire("9ePQk");

var $cLE9v = parcelRequire("cLE9v");

var $8LAT3 = parcelRequire("8LAT3");

var $Dmfod = parcelRequire("Dmfod");

var $lxPUQ = parcelRequire("lxPUQ");

var $2V8i3 = parcelRequire("2V8i3");

var $3gTIF = parcelRequire("3gTIF");

var $3FBHc = parcelRequire("3FBHc");

var $lm1xJ = parcelRequire("lm1xJ");

var $dUFYy = parcelRequire("dUFYy");

var $cOV0H = parcelRequire("cOV0H");
const $eb2d2d73daee21fb$var$regexSE = /defined\s*?\((.+?)\)/g;
const $eb2d2d73daee21fb$var$regexSERevert = /defined\s*?\[(.+?)\]/g;
const $eb2d2d73daee21fb$var$regexShaderInclude = /#include\s?<(.+)>(\((.*)\))*(\[(.*)\])*/g;
const $eb2d2d73daee21fb$var$regexShaderDecl = /__decl__/;
const $eb2d2d73daee21fb$var$regexLightX = /light\{X\}.(\w*)/g;
const $eb2d2d73daee21fb$var$regexX = /\{X\}/g;
const $eb2d2d73daee21fb$var$reusableMatches = [];
const $eb2d2d73daee21fb$var$_MoveCursorRegex = /(#ifdef)|(#else)|(#elif)|(#endif)|(#ifndef)|(#if)/;
function $eb2d2d73daee21fb$export$b03b1c699c90a9b4(options) {
    if (options.processor && options.processor.initializeShaders) options.processor.initializeShaders(options.processingContext);
}
function $eb2d2d73daee21fb$export$ddab65ae98aaa487(sourceCode, options, callback, engine) {
    if (options.processor?.preProcessShaderCode) sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
    $eb2d2d73daee21fb$export$3fd043f8e205658a(sourceCode, options, (codeWithIncludes)=>{
        if (options.processCodeAfterIncludes) codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes, options.defines);
        const migratedCode = $eb2d2d73daee21fb$var$_ProcessShaderConversion(codeWithIncludes, options, engine);
        callback(migratedCode, codeWithIncludes);
    });
}
function $eb2d2d73daee21fb$export$29d9fb00cb59eb01(sourceCode, options, callback, engine) {
    if (options.processor?.preProcessShaderCode) sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
    $eb2d2d73daee21fb$export$3fd043f8e205658a(sourceCode, options, (codeWithIncludes)=>{
        if (options.processCodeAfterIncludes) codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes, options.defines);
        const migratedCode = $eb2d2d73daee21fb$var$_ApplyPreProcessing(codeWithIncludes, options, engine);
        callback(migratedCode, codeWithIncludes);
    });
}
function $eb2d2d73daee21fb$export$29defdae7b3f3a01(vertexCode, fragmentCode, options) {
    if (!options.processor || !options.processor.finalizeShaders) return {
        vertexCode: vertexCode,
        fragmentCode: fragmentCode
    };
    return options.processor.finalizeShaders(vertexCode, fragmentCode, options.processingContext);
}
function $eb2d2d73daee21fb$var$_ProcessPrecision(source, options) {
    if (options.processor?.noPrecision) return source;
    const shouldUseHighPrecisionShader = options.shouldUseHighPrecisionShader;
    if (source.indexOf("precision highp float") === -1) {
        if (!shouldUseHighPrecisionShader) source = "precision mediump float;\n" + source;
        else source = "precision highp float;\n" + source;
    } else if (!shouldUseHighPrecisionShader) // Moving highp to mediump
    source = source.replace("precision highp float", "precision mediump float");
    return source;
}
function $eb2d2d73daee21fb$var$_ExtractOperation(expression) {
    const regex = /defined\((.+)\)/;
    const match = regex.exec(expression);
    if (match && match.length) return new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(match[1].trim(), expression[0] === "!");
    const operators = [
        "==",
        "!=",
        ">=",
        "<=",
        "<",
        ">"
    ];
    let operator = "";
    let indexOperator = 0;
    for (operator of operators){
        indexOperator = expression.indexOf(operator);
        if (indexOperator > -1) break;
    }
    if (indexOperator === -1) return new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(expression);
    const define = expression.substring(0, indexOperator).trim();
    const value = expression.substring(indexOperator + operator.length).trim();
    return new (0, $lm1xJ.ShaderDefineArithmeticOperator)(define, operator, value);
}
function $eb2d2d73daee21fb$var$_BuildSubExpression(expression) {
    expression = expression.replace($eb2d2d73daee21fb$var$regexSE, "defined[$1]");
    const postfix = (0, $3FBHc.ShaderDefineExpression).infixToPostfix(expression);
    const stack = [];
    for (const c of postfix){
        if (c !== "||" && c !== "&&") stack.push(c);
        else if (stack.length >= 2) {
            let v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
            stack.length -= 2;
            const operator = c == "&&" ? new (0, $3gTIF.ShaderDefineAndOperator)() : new (0, $2V8i3.ShaderDefineOrOperator)();
            if (typeof v1 === "string") v1 = v1.replace($eb2d2d73daee21fb$var$regexSERevert, "defined($1)");
            if (typeof v2 === "string") v2 = v2.replace($eb2d2d73daee21fb$var$regexSERevert, "defined($1)");
            operator.leftOperand = typeof v2 === "string" ? $eb2d2d73daee21fb$var$_ExtractOperation(v2) : v2;
            operator.rightOperand = typeof v1 === "string" ? $eb2d2d73daee21fb$var$_ExtractOperation(v1) : v1;
            stack.push(operator);
        }
    }
    let result = stack[stack.length - 1];
    if (typeof result === "string") result = result.replace($eb2d2d73daee21fb$var$regexSERevert, "defined($1)");
    // note: stack.length !== 1 if there was an error in the parsing
    return typeof result === "string" ? $eb2d2d73daee21fb$var$_ExtractOperation(result) : result;
}
function $eb2d2d73daee21fb$var$_BuildExpression(line, start) {
    const node = new (0, $Dmfod.ShaderCodeTestNode)();
    const command = line.substring(0, start);
    let expression = line.substring(start);
    expression = expression.substring(0, (expression.indexOf("//") + 1 || expression.length + 1) - 1).trim();
    if (command === "#ifdef") node.testExpression = new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(expression);
    else if (command === "#ifndef") node.testExpression = new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(expression, true);
    else node.testExpression = $eb2d2d73daee21fb$var$_BuildSubExpression(expression);
    return node;
}
function $eb2d2d73daee21fb$var$_MoveCursorWithinIf(cursor, rootNode, ifNode) {
    let line = cursor.currentLine;
    while($eb2d2d73daee21fb$var$_MoveCursor(cursor, ifNode)){
        line = cursor.currentLine;
        const first5 = line.substring(0, 5).toLowerCase();
        if (first5 === "#else") {
            const elseNode = new (0, $9ePQk.ShaderCodeNode)();
            rootNode.children.push(elseNode);
            $eb2d2d73daee21fb$var$_MoveCursor(cursor, elseNode);
            return;
        } else if (first5 === "#elif") {
            const elifNode = $eb2d2d73daee21fb$var$_BuildExpression(line, 5);
            rootNode.children.push(elifNode);
            ifNode = elifNode;
        }
    }
}
function $eb2d2d73daee21fb$var$_MoveCursor(cursor, rootNode) {
    while(cursor.canRead){
        cursor.lineIndex++;
        const line = cursor.currentLine;
        if (line.indexOf("#") >= 0) {
            const matches = $eb2d2d73daee21fb$var$_MoveCursorRegex.exec(line);
            if (matches && matches.length) {
                const keyword = matches[0];
                switch(keyword){
                    case "#ifdef":
                        {
                            const newRootNode = new (0, $8LAT3.ShaderCodeConditionNode)();
                            rootNode.children.push(newRootNode);
                            const ifNode = $eb2d2d73daee21fb$var$_BuildExpression(line, 6);
                            newRootNode.children.push(ifNode);
                            $eb2d2d73daee21fb$var$_MoveCursorWithinIf(cursor, newRootNode, ifNode);
                            break;
                        }
                    case "#else":
                    case "#elif":
                        return true;
                    case "#endif":
                        return false;
                    case "#ifndef":
                        {
                            const newRootNode = new (0, $8LAT3.ShaderCodeConditionNode)();
                            rootNode.children.push(newRootNode);
                            const ifNode = $eb2d2d73daee21fb$var$_BuildExpression(line, 7);
                            newRootNode.children.push(ifNode);
                            $eb2d2d73daee21fb$var$_MoveCursorWithinIf(cursor, newRootNode, ifNode);
                            break;
                        }
                    case "#if":
                        {
                            const newRootNode = new (0, $8LAT3.ShaderCodeConditionNode)();
                            const ifNode = $eb2d2d73daee21fb$var$_BuildExpression(line, 3);
                            rootNode.children.push(newRootNode);
                            newRootNode.children.push(ifNode);
                            $eb2d2d73daee21fb$var$_MoveCursorWithinIf(cursor, newRootNode, ifNode);
                            break;
                        }
                }
                continue;
            }
        }
        const newNode = new (0, $9ePQk.ShaderCodeNode)();
        newNode.line = line;
        rootNode.children.push(newNode);
        // Detect additional defines
        if (line[0] === "#" && line[1] === "d") {
            const split = line.replace(";", "").split(" ");
            newNode.additionalDefineKey = split[1];
            if (split.length === 3) newNode.additionalDefineValue = split[2];
        }
    }
    return false;
}
function $eb2d2d73daee21fb$var$_EvaluatePreProcessors(sourceCode, preprocessors, options) {
    const rootNode = new (0, $9ePQk.ShaderCodeNode)();
    const cursor = new (0, $cLE9v.ShaderCodeCursor)();
    cursor.lineIndex = -1;
    cursor.lines = sourceCode.split("\n");
    // Decompose (We keep it in 2 steps so it is easier to maintain and perf hit is insignificant)
    $eb2d2d73daee21fb$var$_MoveCursor(cursor, rootNode);
    // Recompose
    return rootNode.process(preprocessors, options);
}
function $eb2d2d73daee21fb$var$_PreparePreProcessors(options, engine) {
    const defines = options.defines;
    const preprocessors = {};
    for (const define of defines){
        const keyValue = define.replace("#define", "").replace(";", "").trim();
        const split = keyValue.split(" ");
        preprocessors[split[0]] = split.length > 1 ? split[1] : "";
    }
    if (options.processor?.shaderLanguage === 0 /* ShaderLanguage.GLSL */ ) preprocessors["GL_ES"] = "true";
    preprocessors["__VERSION__"] = options.version;
    preprocessors[options.platformName] = "true";
    (0, $cOV0H._getGlobalDefines)(preprocessors, engine?.isNDCHalfZRange, engine?.useReverseDepthBuffer, engine?.useExactSrgbConversions);
    return preprocessors;
}
function $eb2d2d73daee21fb$var$_ProcessShaderConversion(sourceCode, options, engine) {
    let preparedSourceCode = $eb2d2d73daee21fb$var$_ProcessPrecision(sourceCode, options);
    if (!options.processor) return preparedSourceCode;
    // Already converted
    if (options.processor.shaderLanguage === 0 /* ShaderLanguage.GLSL */  && preparedSourceCode.indexOf("#version 3") !== -1) {
        preparedSourceCode = preparedSourceCode.replace("#version 300 es", "");
        if (!options.processor.parseGLES3) return preparedSourceCode;
    }
    const defines = options.defines;
    const preprocessors = $eb2d2d73daee21fb$var$_PreparePreProcessors(options, engine);
    // General pre processing
    if (options.processor.preProcessor) preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, preprocessors, options.isFragment, options.processingContext);
    preparedSourceCode = $eb2d2d73daee21fb$var$_EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
    // Post processing
    if (options.processor.postProcessor) preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine ? {
        drawBuffersExtensionDisabled: engine.getCaps().drawBuffersExtension ? false : true
    } : {});
    // Inline functions tagged with #define inline
    if (engine?._features.needShaderCodeInlining) preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
    return preparedSourceCode;
}
function $eb2d2d73daee21fb$var$_ApplyPreProcessing(sourceCode, options, engine) {
    let preparedSourceCode = sourceCode;
    const defines = options.defines;
    const preprocessors = $eb2d2d73daee21fb$var$_PreparePreProcessors(options, engine);
    // General pre processing
    if (options.processor?.preProcessor) preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, preprocessors, options.isFragment, options.processingContext);
    preparedSourceCode = $eb2d2d73daee21fb$var$_EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
    // Post processing
    if (options.processor?.postProcessor) preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine ? {
        drawBuffersExtensionDisabled: engine.getCaps().drawBuffersExtension ? false : true
    } : {});
    // Inline functions tagged with #define inline
    if (engine._features.needShaderCodeInlining) preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
    return preparedSourceCode;
}
function $eb2d2d73daee21fb$export$3fd043f8e205658a(sourceCode, options, callback) {
    $eb2d2d73daee21fb$var$reusableMatches.length = 0;
    let match;
    // stay back-compat to the old matchAll syntax
    while((match = $eb2d2d73daee21fb$var$regexShaderInclude.exec(sourceCode)) !== null)$eb2d2d73daee21fb$var$reusableMatches.push(match);
    let returnValue = String(sourceCode);
    let parts = [
        sourceCode
    ];
    let keepProcessing = false;
    for (const match of $eb2d2d73daee21fb$var$reusableMatches){
        let includeFile = match[1];
        // Uniform declaration
        if (includeFile.indexOf("__decl__") !== -1) {
            includeFile = includeFile.replace($eb2d2d73daee21fb$var$regexShaderDecl, "");
            if (options.supportsUniformBuffers) includeFile = includeFile.replace("Vertex", "Ubo").replace("Fragment", "Ubo");
            includeFile = includeFile + "Declaration";
        }
        if (options.includesShadersStore[includeFile]) {
            // Substitution
            let includeContent = options.includesShadersStore[includeFile];
            if (match[2]) {
                const splits = match[3].split(",");
                for(let index = 0; index < splits.length; index += 2){
                    const source = new RegExp(splits[index], "g");
                    const dest = splits[index + 1];
                    includeContent = includeContent.replace(source, dest);
                }
            }
            if (match[4]) {
                const indexString = match[5];
                if (indexString.indexOf("..") !== -1) {
                    const indexSplits = indexString.split("..");
                    const minIndex = parseInt(indexSplits[0]);
                    let maxIndex = parseInt(indexSplits[1]);
                    let sourceIncludeContent = includeContent.slice(0);
                    includeContent = "";
                    if (isNaN(maxIndex)) maxIndex = options.indexParameters[indexSplits[1]];
                    for(let i = minIndex; i < maxIndex; i++){
                        if (!options.supportsUniformBuffers) // Ubo replacement
                        sourceIncludeContent = sourceIncludeContent.replace($eb2d2d73daee21fb$var$regexLightX, (str, p1)=>{
                            return p1 + "{X}";
                        });
                        includeContent += sourceIncludeContent.replace($eb2d2d73daee21fb$var$regexX, i.toString()) + "\n";
                    }
                } else {
                    if (!options.supportsUniformBuffers) // Ubo replacement
                    includeContent = includeContent.replace($eb2d2d73daee21fb$var$regexLightX, (str, p1)=>{
                        return p1 + "{X}";
                    });
                    includeContent = includeContent.replace($eb2d2d73daee21fb$var$regexX, indexString);
                }
            }
            // Replace
            // Split all parts on match[0] and intersperse the parts with the include content
            const newParts = [];
            for (const part of parts){
                const splitPart = part.split(match[0]);
                for(let i = 0; i < splitPart.length - 1; i++){
                    newParts.push(splitPart[i]);
                    newParts.push(includeContent);
                }
                newParts.push(splitPart[splitPart.length - 1]);
            }
            parts = newParts;
            keepProcessing = keepProcessing || includeContent.indexOf("#include<") >= 0 || includeContent.indexOf("#include <") >= 0;
        } else {
            const includeShaderUrl = options.shadersRepository + "ShadersInclude/" + includeFile + ".fx";
            $eb2d2d73daee21fb$export$e53aa09f5deb83f1.loadFile(includeShaderUrl, (fileContent)=>{
                options.includesShadersStore[includeFile] = fileContent;
                $eb2d2d73daee21fb$export$3fd043f8e205658a(parts.join(""), options, callback);
            });
            return;
        }
    }
    $eb2d2d73daee21fb$var$reusableMatches.length = 0;
    returnValue = parts.join("");
    if (keepProcessing) $eb2d2d73daee21fb$export$3fd043f8e205658a(returnValue.toString(), options, callback);
    else callback(returnValue);
}
const $eb2d2d73daee21fb$export$e53aa09f5deb83f1 = {
    /**
     * Loads a file from a url
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     * @internal
     */ loadFile: (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError)=>{
        throw (0, $dUFYy._WarnImport)("FileTools");
    }
};

});
parcelRegister("9ePQk", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeNode", () => $6b9da2cc172255d7$export$860cf9b8229373f3);
const $6b9da2cc172255d7$var$defaultAttributeKeywordName = "attribute";
const $6b9da2cc172255d7$var$defaultVaryingKeywordName = "varying";
class $6b9da2cc172255d7$export$860cf9b8229373f3 {
    constructor(){
        this.children = [];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isValid(preprocessors) {
        return true;
    }
    process(preprocessors, options) {
        let result = "";
        if (this.line) {
            let value = this.line;
            const processor = options.processor;
            if (processor) {
                // This must be done before other replacements to avoid mistakenly changing something that was already changed.
                if (processor.lineProcessor) value = processor.lineProcessor(value, options.isFragment, options.processingContext);
                const attributeKeyword = options.processor?.attributeKeywordName ?? $6b9da2cc172255d7$var$defaultAttributeKeywordName;
                const varyingKeyword = options.isFragment && options.processor?.varyingFragmentKeywordName ? options.processor?.varyingFragmentKeywordName : !options.isFragment && options.processor?.varyingVertexKeywordName ? options.processor?.varyingVertexKeywordName : $6b9da2cc172255d7$var$defaultVaryingKeywordName;
                if (!options.isFragment && processor.attributeProcessor && this.line.startsWith(attributeKeyword)) value = processor.attributeProcessor(this.line, preprocessors, options.processingContext);
                else if (processor.varyingProcessor && (processor.varyingCheck?.(this.line, options.isFragment) || !processor.varyingCheck && this.line.startsWith(varyingKeyword))) value = processor.varyingProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                else if (processor.uniformProcessor && processor.uniformRegexp && processor.uniformRegexp.test(this.line)) {
                    if (!options.lookForClosingBracketForUniformBuffer) value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                } else if (processor.uniformBufferProcessor && processor.uniformBufferRegexp && processor.uniformBufferRegexp.test(this.line)) {
                    if (!options.lookForClosingBracketForUniformBuffer) {
                        value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                        options.lookForClosingBracketForUniformBuffer = true;
                    }
                } else if (processor.textureProcessor && processor.textureRegexp && processor.textureRegexp.test(this.line)) value = processor.textureProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                else if ((processor.uniformProcessor || processor.uniformBufferProcessor) && this.line.startsWith("uniform") && !options.lookForClosingBracketForUniformBuffer) {
                    const regex = /uniform\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/;
                    if (regex.test(this.line)) // uniform
                    {
                        if (processor.uniformProcessor) value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                    } else // Uniform buffer
                    if (processor.uniformBufferProcessor) {
                        value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                        options.lookForClosingBracketForUniformBuffer = true;
                    }
                }
                if (options.lookForClosingBracketForUniformBuffer && this.line.indexOf("}") !== -1) {
                    options.lookForClosingBracketForUniformBuffer = false;
                    if (processor.endOfUniformBufferProcessor) value = processor.endOfUniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                }
            }
            result += value + "\n";
        }
        this.children.forEach((child)=>{
            result += child.process(preprocessors, options);
        });
        if (this.additionalDefineKey) preprocessors[this.additionalDefineKey] = this.additionalDefineValue || "true";
        return result;
    }
}

});

parcelRegister("cLE9v", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeCursor", () => $94b90538c5e84ed0$export$447f9aad68c4a0b5);
/** @internal */ class $94b90538c5e84ed0$export$447f9aad68c4a0b5 {
    constructor(){
        this._lines = [];
    }
    get currentLine() {
        return this._lines[this.lineIndex];
    }
    get canRead() {
        return this.lineIndex < this._lines.length - 1;
    }
    set lines(value) {
        this._lines.length = 0;
        for (const line of value){
            // Skip empty lines
            if (!line || line === "\r") continue;
            // Prevent removing line break in macros.
            if (line[0] === "#") {
                this._lines.push(line);
                continue;
            }
            // Do not split single line comments
            const trimmedLine = line.trim();
            if (!trimmedLine) continue;
            if (trimmedLine.startsWith("//")) {
                this._lines.push(line);
                continue;
            }
            // Work with semicolon in the line
            const semicolonIndex = trimmedLine.indexOf(";");
            if (semicolonIndex === -1) // No semicolon in the line
            this._lines.push(trimmedLine);
            else if (semicolonIndex === trimmedLine.length - 1) // Single semicolon at the end of the line
            // If trimmedLine == ";", we must not push, to be backward compatible with the old code!
            {
                if (trimmedLine.length > 1) this._lines.push(trimmedLine);
            } else {
                // Semicolon in the middle of the line
                const split = line.split(";");
                for(let index = 0; index < split.length; index++){
                    let subLine = split[index];
                    if (!subLine) continue;
                    subLine = subLine.trim();
                    if (!subLine) continue;
                    this._lines.push(subLine + (index !== split.length - 1 ? ";" : ""));
                }
            }
        }
    }
}

});

parcelRegister("8LAT3", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeConditionNode", () => $661f53864883222b$export$bf5fb72825e99da7);

var $9ePQk = parcelRequire("9ePQk");
class $661f53864883222b$export$bf5fb72825e99da7 extends (0, $9ePQk.ShaderCodeNode) {
    process(preprocessors, options) {
        for(let index = 0; index < this.children.length; index++){
            const node = this.children[index];
            if (node.isValid(preprocessors)) return node.process(preprocessors, options);
        }
        return "";
    }
}

});

parcelRegister("Dmfod", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeTestNode", () => $0764e677b7a6d382$export$a671c751cc11167f);

var $9ePQk = parcelRequire("9ePQk");
class $0764e677b7a6d382$export$a671c751cc11167f extends (0, $9ePQk.ShaderCodeNode) {
    isValid(preprocessors) {
        return this.testExpression.isTrue(preprocessors);
    }
}

});

parcelRegister("lxPUQ", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineIsDefinedOperator", () => $faf4f37305ff3435$export$e04e366a8401cd6e);

var $3FBHc = parcelRequire("3FBHc");
class $faf4f37305ff3435$export$e04e366a8401cd6e extends (0, $3FBHc.ShaderDefineExpression) {
    constructor(define, not = false){
        super();
        this.define = define;
        this.not = not;
    }
    isTrue(preprocessors) {
        let condition = preprocessors[this.define] !== undefined;
        if (this.not) condition = !condition;
        return condition;
    }
}

});
parcelRegister("3FBHc", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineExpression", () => $2ac27104007dc5a5$export$71ef9c78ba3a183);
/* eslint-disable @typescript-eslint/naming-convention */ /** @internal */ class $2ac27104007dc5a5$export$71ef9c78ba3a183 {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isTrue(preprocessors) {
        return true;
    }
    static postfixToInfix(postfix) {
        const stack = [];
        for (const c of postfix)if ($2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[c] === undefined) stack.push(c);
        else {
            const v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
            stack.length -= 2;
            stack.push(`(${v2}${c}${v1})`);
        }
        return stack[stack.length - 1];
    }
    /**
     * Converts an infix expression to a postfix expression.
     *
     * This method is used to transform infix expressions, which are more human-readable,
     * into postfix expressions, also known as Reverse Polish Notation (RPN), that can be
     * evaluated more efficiently by a computer. The conversion is based on the operator
     * priority defined in _OperatorPriority.
     *
     * The function employs a stack-based algorithm for the conversion and caches the result
     * to improve performance. The cache keeps track of each converted expression's access time
     * to manage the cache size and optimize memory usage. When the cache size exceeds a specified
     * limit, the least recently accessed items in the cache are deleted.
     *
     * The cache mechanism is particularly helpful for shader compilation, where the same infix
     * expressions might be encountered repeatedly, hence the caching can speed up the process.
     *
     * @param infix - The infix expression to be converted.
     * @returns The postfix expression as an array of strings.
     */ static infixToPostfix(infix) {
        // Is infix already in cache
        const cacheItem = $2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.get(infix);
        if (cacheItem) {
            cacheItem.accessTime = Date.now();
            return cacheItem.result;
        }
        // Is infix contain any operator
        if (!infix.includes("&&") && !infix.includes("||") && !infix.includes(")") && !infix.includes("(")) return [
            infix
        ];
        const result = [];
        let stackIdx = -1;
        const pushOperand = ()=>{
            operand = operand.trim();
            if (operand !== "") {
                result.push(operand);
                operand = "";
            }
        };
        const push = (s)=>{
            if (stackIdx < $2ac27104007dc5a5$export$71ef9c78ba3a183._Stack.length - 1) $2ac27104007dc5a5$export$71ef9c78ba3a183._Stack[++stackIdx] = s;
        };
        const peek = ()=>$2ac27104007dc5a5$export$71ef9c78ba3a183._Stack[stackIdx];
        const pop = ()=>stackIdx === -1 ? "!!INVALID EXPRESSION!!" : $2ac27104007dc5a5$export$71ef9c78ba3a183._Stack[stackIdx--];
        let idx = 0, operand = "";
        while(idx < infix.length){
            const c = infix.charAt(idx), token = idx < infix.length - 1 ? infix.substring(idx, 2 + idx) : "";
            if (c === "(") {
                operand = "";
                push(c);
            } else if (c === ")") {
                pushOperand();
                while(stackIdx !== -1 && peek() !== "(")result.push(pop());
                pop();
            } else if ($2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[token] > 1) {
                pushOperand();
                while(stackIdx !== -1 && $2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[peek()] >= $2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[token])result.push(pop());
                push(token);
                idx++;
            } else operand += c;
            idx++;
        }
        pushOperand();
        while(stackIdx !== -1)if (peek() === "(") pop();
        else result.push(pop());
        // If the cache is at capacity, clear it before adding a new item
        if ($2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.size >= $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheLimitSize) $2ac27104007dc5a5$export$71ef9c78ba3a183.ClearCache();
        // Add the new item to the cache, including the current time as the last access time
        $2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.set(infix, {
            result: result,
            accessTime: Date.now()
        });
        return result;
    }
    static ClearCache() {
        // Convert the cache to an array and sort by last access time
        const sortedCache = Array.from($2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.entries()).sort((a, b)=>a[1].accessTime - b[1].accessTime);
        // Remove the least recently accessed half of the cache
        for(let i = 0; i < $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheCleanupSize; i++)$2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.delete(sortedCache[i][0]);
    }
}
/**
 * Cache items count limit for the InfixToPostfix cache.
 * It uses to improve the performance of the shader compilation.
 * For details see PR: https://github.com/BabylonJS/Babylon.js/pull/13936
 */ $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheLimitSize = 50000;
/**
 * When the cache size is exceeded, a cache cleanup will be triggered
 * and the cache will be reduced by the size specified
 * in the InfixToPostfixCacheCleanupSize variable, removing entries
 * that have not been accessed the longest.
 */ $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheCleanupSize = 25000;
$2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache = new Map();
$2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority = {
    ")": 0,
    "(": 1,
    "||": 2,
    "&&": 3
};
$2ac27104007dc5a5$export$71ef9c78ba3a183._Stack = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
];

});


parcelRegister("2V8i3", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineOrOperator", () => $220755ed94cfe29a$export$69b3a67fedf1f6bb);

var $3FBHc = parcelRequire("3FBHc");
class $220755ed94cfe29a$export$69b3a67fedf1f6bb extends (0, $3FBHc.ShaderDefineExpression) {
    isTrue(preprocessors) {
        return this.leftOperand.isTrue(preprocessors) || this.rightOperand.isTrue(preprocessors);
    }
}

});

parcelRegister("3gTIF", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineAndOperator", () => $261e1671f43d1b3c$export$9fedfc76ed59009d);

var $3FBHc = parcelRequire("3FBHc");
class $261e1671f43d1b3c$export$9fedfc76ed59009d extends (0, $3FBHc.ShaderDefineExpression) {
    isTrue(preprocessors) {
        return this.leftOperand.isTrue(preprocessors) && this.rightOperand.isTrue(preprocessors);
    }
}

});

parcelRegister("lm1xJ", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineArithmeticOperator", () => $f8bcd971b4e116f5$export$31722351e227a615);

var $3FBHc = parcelRequire("3FBHc");
class $f8bcd971b4e116f5$export$31722351e227a615 extends (0, $3FBHc.ShaderDefineExpression) {
    constructor(define, operand, testValue){
        super();
        this.define = define;
        this.operand = operand;
        this.testValue = testValue;
    }
    isTrue(preprocessors) {
        let value = preprocessors[this.define];
        if (value === undefined) value = this.define;
        let condition = false;
        const left = parseInt(value);
        const right = parseInt(this.testValue);
        switch(this.operand){
            case ">":
                condition = left > right;
                break;
            case "<":
                condition = left < right;
                break;
            case "<=":
                condition = left <= right;
                break;
            case ">=":
                condition = left >= right;
                break;
            case "==":
                condition = left === right;
                break;
            case "!=":
                condition = left !== right;
                break;
        }
        return condition;
    }
}

});

parcelRegister("cOV0H", function(module, exports) {

$parcel$export(module.exports, "EngineFunctionContext", () => $955660963fc23238$export$656bafe23106c4d8);
$parcel$export(module.exports, "_ConcatenateShader", () => $955660963fc23238$export$4d1830427dd4f911);
$parcel$export(module.exports, "_loadFile", () => $955660963fc23238$export$6b9e58a2b0a223f6);
$parcel$export(module.exports, "_getGlobalDefines", () => $955660963fc23238$export$85dcdc263d9725b4);
$parcel$export(module.exports, "allocateAndCopyTypedBuffer", () => $955660963fc23238$export$a25b2cd826cd6860);

var $dUFYy = parcelRequire("dUFYy");

var $jFz47 = parcelRequire("jFz47");
const $955660963fc23238$export$656bafe23106c4d8 = {};
function $955660963fc23238$export$4d1830427dd4f911(source, defines, shaderVersion = "") {
    return shaderVersion + (defines ? defines + "\n" : "") + source;
}
function $955660963fc23238$export$6b9e58a2b0a223f6(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, injectedLoadFile) {
    const loadFile = injectedLoadFile || $955660963fc23238$export$656bafe23106c4d8.loadFile;
    if (loadFile) {
        const request = loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        return request;
    }
    throw (0, $dUFYy._WarnImport)("FileTools");
}
function $955660963fc23238$export$2e49a6bbb43ac043(renderingCanvas = null) {
    if (renderingCanvas && renderingCanvas.ownerDocument) return renderingCanvas.ownerDocument;
    return (0, $jFz47.IsDocumentAvailable)() ? document : null;
}
function $955660963fc23238$export$85dcdc263d9725b4(defines, isNDCHalfZRange, useReverseDepthBuffer, useExactSrgbConversions) {
    if (defines) {
        if (isNDCHalfZRange) defines["IS_NDC_HALF_ZRANGE"] = "";
        else delete defines["IS_NDC_HALF_ZRANGE"];
        if (useReverseDepthBuffer) defines["USE_REVERSE_DEPTHBUFFER"] = "";
        else delete defines["USE_REVERSE_DEPTHBUFFER"];
        if (useExactSrgbConversions) defines["USE_EXACT_SRGB_CONVERSIONS"] = "";
        else delete defines["USE_EXACT_SRGB_CONVERSIONS"];
        return;
    } else {
        let s = "";
        if (isNDCHalfZRange) s += "#define IS_NDC_HALF_ZRANGE";
        if (useReverseDepthBuffer) {
            if (s) s += "\n";
            s += "#define USE_REVERSE_DEPTHBUFFER";
        }
        if (useExactSrgbConversions) {
            if (s) s += "\n";
            s += "#define USE_EXACT_SRGB_CONVERSIONS";
        }
        return s;
    }
}
function $955660963fc23238$export$a25b2cd826cd6860(type, sizeOrDstBuffer, sizeInBytes = false, copyBuffer) {
    switch(type){
        case 3:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int8Array(sizeOrDstBuffer) : new Int8Array(sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Int8Array(copyBuffer));
                return buffer;
            }
        case 0:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Uint8Array(copyBuffer));
                return buffer;
            }
        case 4:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int16Array(sizeOrDstBuffer) : new Int16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Int16Array(copyBuffer));
                return buffer;
            }
        case 5:
        case 8:
        case 9:
        case 10:
        case 2:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint16Array(sizeOrDstBuffer) : new Uint16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Uint16Array(copyBuffer));
                return buffer;
            }
        case 6:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int32Array(sizeOrDstBuffer) : new Int32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Int32Array(copyBuffer));
                return buffer;
            }
        case 7:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint32Array(sizeOrDstBuffer) : new Uint32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Uint32Array(copyBuffer));
                return buffer;
            }
        case 1:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Float32Array(sizeOrDstBuffer) : new Float32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Float32Array(copyBuffer));
                return buffer;
            }
    }
    const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);
    if (copyBuffer) buffer.set(new Uint8Array(copyBuffer));
    return buffer;
}

});


parcelRegister("av6Bc", function(module, exports) {

$parcel$export(module.exports, "TimingTools", () => $7a51eb0e2c330399$export$4da47a480c8724e);
$parcel$export(module.exports, "_retryWithInterval", () => $7a51eb0e2c330399$export$7bdf1392cf200079);
let $7a51eb0e2c330399$var$_immediateQueue = [];
class $7a51eb0e2c330399$export$4da47a480c8724e {
    /**
     * Execute a function after the current execution block
     * @param action defines the action to execute after the current execution block
     */ static SetImmediate(action) {
        if ($7a51eb0e2c330399$var$_immediateQueue.length === 0) setTimeout(()=>{
            // Execute all immediate functions
            const functionsToCall = $7a51eb0e2c330399$var$_immediateQueue;
            $7a51eb0e2c330399$var$_immediateQueue = [];
            for (const func of functionsToCall)func();
        }, 1);
        $7a51eb0e2c330399$var$_immediateQueue.push(action);
    }
}
function $7a51eb0e2c330399$var$_runWithCondition(condition, onSuccess, onError) {
    try {
        if (condition()) {
            onSuccess();
            return true;
        }
    } catch (e) {
        onError?.(e);
        return true;
    }
    return false;
}
const $7a51eb0e2c330399$export$7bdf1392cf200079 = (condition, onSuccess, onError, step = 16, maxTimeout = 30000, checkConditionOnCall = true, additionalStringOnTimeout)=>{
    // if checkConditionOnCall is true, we check the condition immediately. If it is true, run everything synchronously
    if (checkConditionOnCall) {
        // that means that one of the two happened - either the condition is true or an exception was thrown when checking the condition
        if ($7a51eb0e2c330399$var$_runWithCondition(condition, onSuccess, onError)) // don't schedule the interval, no reason to check it again.
        return null;
    }
    const int = setInterval(()=>{
        if ($7a51eb0e2c330399$var$_runWithCondition(condition, onSuccess, onError)) clearInterval(int);
        else {
            maxTimeout -= step;
            if (maxTimeout < 0) {
                clearInterval(int);
                onError?.(new Error("Operation timed out after maximum retries. " + (additionalStringOnTimeout || "")), true);
            }
        }
    }, step);
    return ()=>clearInterval(int);
};

});

parcelRegister("dUFoQ", function(module, exports) {

$parcel$export(module.exports, "AbstractEngine", () => $a2109e72261d9ea8$export$1c3aca38fa8ce7e9);

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $lUDWq = parcelRequire("lUDWq");

var $3agwF = parcelRequire("3agwF");

var $blHSI = parcelRequire("blHSI");

var $36XJ5 = parcelRequire("36XJ5");

var $cyIBx = parcelRequire("cyIBx");

var $d7F9z = parcelRequire("d7F9z");

var $ano9R = parcelRequire("ano9R");

var $dUFYy = parcelRequire("dUFYy");

var $b9e4a = parcelRequire("b9e4a");

var $jFz47 = parcelRequire("jFz47");

var $diGQf = parcelRequire("diGQf");

var $cOV0H = parcelRequire("cOV0H");

var $kgxWB = parcelRequire("kgxWB");
function $a2109e72261d9ea8$export$a53fc116e5e6ad5d(func, requester) {
    // Note that there is kind of a typing issue here, as `setTimeout` might return something else than a number (NodeJs returns a NodeJS.Timeout object).
    // Also if the global `requestAnimationFrame`'s returnType is number, `requester.requestPostAnimationFrame` and `requester.requestAnimationFrame` types
    // are `any`.
    if (!(0, $jFz47.IsWindowObjectExist)()) {
        if (typeof requestAnimationFrame === "function") return requestAnimationFrame(func);
    } else {
        const { requestAnimationFrame: requestAnimationFrame1 } = requester || window;
        if (typeof requestAnimationFrame1 === "function") return requestAnimationFrame1(func);
    }
    // fallback to the global `setTimeout`.
    // In most cases (aka in the browser), `window` is the global object, so instead of calling `window.setTimeout` we could call the global `setTimeout`.
    return setTimeout(func, 16);
}
class $a2109e72261d9ea8$export$1c3aca38fa8ce7e9 {
    /**
     * Gets the current frame id
     */ get frameId() {
        return this._frameId;
    }
    /**
     * Gets a boolean indicating if the engine runs in WebGPU or not.
     */ get isWebGPU() {
        return this._isWebGPU;
    }
    /**
     * @internal
     */ _getShaderProcessor(shaderLanguage) {
        return this._shaderProcessor;
    }
    /**
     * Gets the shader platform name used by the effects.
     */ get shaderPlatformName() {
        return this._shaderPlatformName;
    }
    _clearEmptyResources() {
        this._emptyTexture = null;
        this._emptyCubeTexture = null;
        this._emptyTexture3D = null;
        this._emptyTexture2DArray = null;
    }
    /**
     * Gets or sets a boolean indicating if depth buffer should be reverse, going from far to near.
     * This can provide greater z depth for distant objects.
     */ get useReverseDepthBuffer() {
        return this._useReverseDepthBuffer;
    }
    set useReverseDepthBuffer(useReverse) {
        if (useReverse === this._useReverseDepthBuffer) return;
        this._useReverseDepthBuffer = useReverse;
        if (useReverse) this._depthCullingState.depthFunc = 518;
        else this._depthCullingState.depthFunc = 515;
    }
    /**
     * Enable or disable color writing
     * @param enable defines the state to set
     */ setColorWrite(enable) {
        if (enable !== this._colorWrite) {
            this._colorWriteChanged = true;
            this._colorWrite = enable;
        }
    }
    /**
     * Gets a boolean indicating if color writing is enabled
     * @returns the current color writing state
     */ getColorWrite() {
        return this._colorWrite;
    }
    /**
     * Gets the depth culling state manager
     */ get depthCullingState() {
        return this._depthCullingState;
    }
    /**
     * Gets the alpha state manager
     */ get alphaState() {
        return this._alphaState;
    }
    /**
     * Gets the stencil state manager
     */ get stencilState() {
        return this._stencilState;
    }
    /**
     * Gets the stencil state composer
     */ get stencilStateComposer() {
        return this._stencilStateComposer;
    }
    /** @internal */ _getGlobalDefines(defines) {
        if (defines) {
            if (this.isNDCHalfZRange) defines["IS_NDC_HALF_ZRANGE"] = "";
            else delete defines["IS_NDC_HALF_ZRANGE"];
            if (this.useReverseDepthBuffer) defines["USE_REVERSE_DEPTHBUFFER"] = "";
            else delete defines["USE_REVERSE_DEPTHBUFFER"];
            if (this.useExactSrgbConversions) defines["USE_EXACT_SRGB_CONVERSIONS"] = "";
            else delete defines["USE_EXACT_SRGB_CONVERSIONS"];
            return;
        } else {
            let s = "";
            if (this.isNDCHalfZRange) s += "#define IS_NDC_HALF_ZRANGE";
            if (this.useReverseDepthBuffer) {
                if (s) s += "\n";
                s += "#define USE_REVERSE_DEPTHBUFFER";
            }
            if (this.useExactSrgbConversions) {
                if (s) s += "\n";
                s += "#define USE_EXACT_SRGB_CONVERSIONS";
            }
            return s;
        }
    }
    _rebuildInternalTextures() {
        const currentState = this._internalTexturesCache.slice(); // Do a copy because the rebuild will add proxies
        for (const internalTexture of currentState)internalTexture._rebuild();
    }
    _rebuildRenderTargetWrappers() {
        const currentState = this._renderTargetWrapperCache.slice(); // Do a copy because the rebuild will add proxies
        for (const renderTargetWrapper of currentState)renderTargetWrapper._rebuild();
    }
    _rebuildEffects() {
        for(const key in this._compiledEffects){
            const effect = this._compiledEffects[key];
            effect._pipelineContext = null; // because _prepareEffect will try to dispose this pipeline before recreating it and that would lead to webgl errors
            effect._prepareEffect();
        }
        (0, $lUDWq.Effect).ResetCache();
    }
    _rebuildGraphicsResources() {
        // Ensure webgl and engine states are matching
        this.wipeCaches(true);
        // Rebuild effects
        this._rebuildEffects();
        this._rebuildComputeEffects?.();
        // Note:
        //  The call to _rebuildBuffers must be made before the call to _rebuildInternalTextures because in the process of _rebuildBuffers the buffers used by the post process managers will be rebuilt
        //  and we may need to use the post process manager of the scene during _rebuildInternalTextures (in WebGL1, non-POT textures are rescaled using a post process + post process manager of the scene)
        // Rebuild buffers
        this._rebuildBuffers();
        // Rebuild textures
        this._rebuildInternalTextures();
        // Rebuild textures
        this._rebuildTextures();
        // Rebuild textures
        this._rebuildRenderTargetWrappers();
        // Reset engine states after all the buffer/textures/... have been rebuilt
        this.wipeCaches(true);
    }
    _flagContextRestored() {
        (0, $kVtWi.Logger).Warn(this.name + " context successfully restored.");
        this.onContextRestoredObservable.notifyObservers(this);
        this._contextWasLost = false;
    }
    _restoreEngineAfterContextLost(initEngine) {
        // Adding a timeout to avoid race condition at browser level
        setTimeout(async ()=>{
            this._clearEmptyResources();
            const depthTest = this._depthCullingState.depthTest; // backup those values because the call to initEngine / wipeCaches will reset them
            const depthFunc = this._depthCullingState.depthFunc;
            const depthMask = this._depthCullingState.depthMask;
            const stencilTest = this._stencilState.stencilTest;
            // Rebuild context
            await initEngine();
            this._rebuildGraphicsResources();
            this._depthCullingState.depthTest = depthTest;
            this._depthCullingState.depthFunc = depthFunc;
            this._depthCullingState.depthMask = depthMask;
            this._stencilState.stencilTest = stencilTest;
            this._flagContextRestored();
        }, 0);
    }
    /** Gets a boolean indicating if the engine was disposed */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Enables or disables the snapshot rendering mode
     * Note that the WebGL engine does not support snapshot rendering so setting the value won't have any effect for this engine
     */ get snapshotRendering() {
        return false;
    }
    set snapshotRendering(activate) {
    // Do nothing
    }
    /**
     * Gets or sets the snapshot rendering mode
     */ get snapshotRenderingMode() {
        return 0;
    }
    set snapshotRenderingMode(mode) {}
    /**
     * Returns the string "AbstractEngine"
     * @returns "AbstractEngine"
     */ getClassName() {
        return "AbstractEngine";
    }
    /**
     * Gets the default empty texture
     */ get emptyTexture() {
        if (!this._emptyTexture) this._emptyTexture = this.createRawTexture(new Uint8Array(4), 1, 1, 5, false, false, 1);
        return this._emptyTexture;
    }
    /**
     * Gets the default empty 3D texture
     */ get emptyTexture3D() {
        if (!this._emptyTexture3D) this._emptyTexture3D = this.createRawTexture3D(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
        return this._emptyTexture3D;
    }
    /**
     * Gets the default empty 2D array texture
     */ get emptyTexture2DArray() {
        if (!this._emptyTexture2DArray) this._emptyTexture2DArray = this.createRawTexture2DArray(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
        return this._emptyTexture2DArray;
    }
    /**
     * Gets the default empty cube texture
     */ get emptyCubeTexture() {
        if (!this._emptyCubeTexture) {
            const faceData = new Uint8Array(4);
            const cubeData = [
                faceData,
                faceData,
                faceData,
                faceData,
                faceData,
                faceData
            ];
            this._emptyCubeTexture = this.createRawCubeTexture(cubeData, 1, 5, 0, false, false, 1);
        }
        return this._emptyCubeTexture;
    }
    /**
     * Gets the list of current active render loop functions
     * @returns a read only array with the current render loop functions
     */ get activeRenderLoops() {
        return this._activeRenderLoops;
    }
    /**
     * stop executing a render loop function and remove it from the execution array
     * @param renderFunction defines the function to be removed. If not provided all functions will be removed.
     */ stopRenderLoop(renderFunction) {
        if (!renderFunction) {
            this._activeRenderLoops.length = 0;
            this._cancelFrame();
            return;
        }
        const index = this._activeRenderLoops.indexOf(renderFunction);
        if (index >= 0) {
            this._activeRenderLoops.splice(index, 1);
            if (this._activeRenderLoops.length == 0) this._cancelFrame();
        }
    }
    _cancelFrame() {
        if (this._frameHandler !== 0) {
            const handlerToCancel = this._frameHandler;
            this._frameHandler = 0;
            if (!(0, $jFz47.IsWindowObjectExist)()) {
                if (typeof cancelAnimationFrame === "function") return cancelAnimationFrame(handlerToCancel);
            } else {
                const { cancelAnimationFrame: cancelAnimationFrame1 } = this.getHostWindow() || window;
                if (typeof cancelAnimationFrame1 === "function") return cancelAnimationFrame1(handlerToCancel);
            }
            return clearTimeout(handlerToCancel);
        }
    }
    /**
     * Begin a new frame
     */ beginFrame() {
        this.onBeginFrameObservable.notifyObservers(this);
    }
    /**
     * End the current frame
     */ endFrame() {
        this._frameId++;
        this.onEndFrameObservable.notifyObservers(this);
    }
    /** Gets or sets max frame per second allowed. Will return undefined if not capped */ get maxFPS() {
        return this._maxFPS;
    }
    set maxFPS(value) {
        this._maxFPS = value;
        if (value === undefined) return;
        if (value <= 0) {
            this._minFrameTime = Number.MAX_VALUE;
            return;
        }
        this._minFrameTime = 1000 / (value + 1); // We need to provide a bit of leeway to ensure we don't go under because of vbl sync
    }
    _isOverFrameTime(timestamp) {
        if (!timestamp) return false;
        const elapsedTime = timestamp - this._lastFrameTime;
        if (this._maxFPS === undefined || elapsedTime >= this._minFrameTime) {
            this._lastFrameTime = timestamp;
            return false;
        }
        return true;
    }
    _processFrame(timestamp) {
        this._frameHandler = 0;
        if (!this._contextWasLost && !this._isOverFrameTime(timestamp)) {
            let shouldRender = true;
            if (this.isDisposed || !this.renderEvenInBackground && this._windowIsBackground) shouldRender = false;
            if (shouldRender) {
                // Start new frame
                this.beginFrame();
                // Child canvases
                if (!this.skipFrameRender && !this._renderViews()) // Main frame
                this._renderFrame();
                // Present
                this.endFrame();
            }
        }
    }
    /** @internal */ _renderLoop(timestamp) {
        this._processFrame(timestamp);
        // The first condition prevents queuing another frame if we no longer have active render loops (e.g., if
        // `stopRenderLoop` is called mid frame). The second condition prevents queuing another frame if one has
        // already been queued (e.g., if `stopRenderLoop` and `runRenderLoop` is called mid frame).
        if (this._activeRenderLoops.length > 0 && this._frameHandler === 0) this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
    }
    /** @internal */ _renderFrame() {
        for(let index = 0; index < this._activeRenderLoops.length; index++){
            const renderFunction = this._activeRenderLoops[index];
            renderFunction();
        }
    }
    /** @internal */ _renderViews() {
        return false;
    }
    /**
     * Can be used to override the current requestAnimationFrame requester.
     * @internal
     */ _queueNewFrame(bindedRenderFunction, requester) {
        return $a2109e72261d9ea8$export$a53fc116e5e6ad5d(bindedRenderFunction, requester);
    }
    /**
     * Register and execute a render loop. The engine can have more than one render function
     * @param renderFunction defines the function to continuously execute
     */ runRenderLoop(renderFunction) {
        if (this._activeRenderLoops.indexOf(renderFunction) !== -1) return;
        this._activeRenderLoops.push(renderFunction);
        // On the first added function, start the render loop.
        if (this._activeRenderLoops.length === 1 && this._frameHandler === 0) this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
    }
    /**
     * Gets a boolean indicating if depth testing is enabled
     * @returns the current state
     */ getDepthBuffer() {
        return this._depthCullingState.depthTest;
    }
    /**
     * Enable or disable depth buffering
     * @param enable defines the state to set
     */ setDepthBuffer(enable) {
        this._depthCullingState.depthTest = enable;
    }
    /**
     * Set the z offset Factor to apply to current rendering
     * @param value defines the offset to apply
     */ setZOffset(value) {
        this._depthCullingState.zOffset = this.useReverseDepthBuffer ? -value : value;
    }
    /**
     * Gets the current value of the zOffset Factor
     * @returns the current zOffset Factor state
     */ getZOffset() {
        const zOffset = this._depthCullingState.zOffset;
        return this.useReverseDepthBuffer ? -zOffset : zOffset;
    }
    /**
     * Set the z offset Units to apply to current rendering
     * @param value defines the offset to apply
     */ setZOffsetUnits(value) {
        this._depthCullingState.zOffsetUnits = this.useReverseDepthBuffer ? -value : value;
    }
    /**
     * Gets the current value of the zOffset Units
     * @returns the current zOffset Units state
     */ getZOffsetUnits() {
        const zOffsetUnits = this._depthCullingState.zOffsetUnits;
        return this.useReverseDepthBuffer ? -zOffsetUnits : zOffsetUnits;
    }
    /**
     * Gets host window
     * @returns the host window object
     */ getHostWindow() {
        if (!(0, $jFz47.IsWindowObjectExist)()) return null;
        if (this._renderingCanvas && this._renderingCanvas.ownerDocument && this._renderingCanvas.ownerDocument.defaultView) return this._renderingCanvas.ownerDocument.defaultView;
        return window;
    }
    /**
     * (WebGPU only) True (default) to be in compatibility mode, meaning rendering all existing scenes without artifacts (same rendering than WebGL).
     * Setting the property to false will improve performances but may not work in some scenes if some precautions are not taken.
     * See https://doc.babylonjs.com/setup/support/webGPU/webGPUOptimization/webGPUNonCompatibilityMode for more details
     */ get compatibilityMode() {
        return this._compatibilityMode;
    }
    set compatibilityMode(mode) {
        // not supported in WebGL
        this._compatibilityMode = true;
    }
    _rebuildTextures() {
        for (const scene of this.scenes)scene._rebuildTextures();
        for (const scene of this._virtualScenes)scene._rebuildTextures();
    }
    /**
     * @internal
     */ _releaseRenderTargetWrapper(rtWrapper) {
        const index = this._renderTargetWrapperCache.indexOf(rtWrapper);
        if (index !== -1) this._renderTargetWrapperCache.splice(index, 1);
    }
    /**
     * Gets the current viewport
     */ get currentViewport() {
        return this._cachedViewport;
    }
    /**
     * Set the WebGL's viewport
     * @param viewport defines the viewport element to be used
     * @param requiredWidth defines the width required for rendering. If not provided the rendering canvas' width is used
     * @param requiredHeight defines the height required for rendering. If not provided the rendering canvas' height is used
     */ setViewport(viewport, requiredWidth, requiredHeight) {
        const width = requiredWidth || this.getRenderWidth();
        const height = requiredHeight || this.getRenderHeight();
        const x = viewport.x || 0;
        const y = viewport.y || 0;
        this._cachedViewport = viewport;
        this._viewport(x * width, y * height, width * viewport.width, height * viewport.height);
    }
    /**
     * Create an image to use with canvas
     * @returns IImage interface
     */ createCanvasImage() {
        return document.createElement("img");
    }
    /**
     * Returns a string describing the current engine
     */ get description() {
        let description = this.name + this.version;
        if (this._caps.parallelShaderCompile) description += " - Parallel shader compilation";
        return description;
    }
    _createTextureBase(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, prepareTexture, prepareTextureProcess, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, useSRGBBuffer) {
        url = url || "";
        const fromData = url.substr(0, 5) === "data:";
        const fromBlob = url.substr(0, 5) === "blob:";
        const isBase64 = fromData && url.indexOf(";base64,") !== -1;
        const texture = fallback ? fallback : new (0, $b9e4a.InternalTexture)(this, 1 /* InternalTextureSource.Url */ );
        if (texture !== fallback) texture.label = url.substring(0, 60); // default label, can be overriden by the caller
        const originalUrl = url;
        if (this._transformTextureUrl && !isBase64 && !fallback && !buffer) url = this._transformTextureUrl(url);
        if (originalUrl !== url) texture._originalUrl = originalUrl;
        // establish the file extension, if possible
        const lastDot = url.lastIndexOf(".");
        let extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
        // Remove query string
        const queryStringIndex = extension.indexOf("?");
        if (queryStringIndex > -1) extension = extension.split("?")[0];
        const loaderPromise = (0, $kgxWB._GetCompatibleTextureLoader)(extension, mimeType);
        if (scene) scene.addPendingData(texture);
        texture.url = url;
        texture.generateMipMaps = !noMipmap;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
        if (!this._doNotHandleContextLost) // Keep a link to the buffer only if we plan to handle context lost
        texture._buffer = buffer;
        let onLoadObserver = null;
        if (onLoad && !fallback) onLoadObserver = texture.onLoadedObservable.add(onLoad);
        if (!fallback) this._internalTexturesCache.push(texture);
        const onInternalError = (message, exception)=>{
            if (scene) scene.removePendingData(texture);
            if (url === originalUrl) {
                if (onLoadObserver) texture.onLoadedObservable.remove(onLoadObserver);
                if ((0, $ejQPp.EngineStore).UseFallbackTexture && url !== (0, $ejQPp.EngineStore).FallbackTexture) this._createTextureBase((0, $ejQPp.EngineStore).FallbackTexture, noMipmap, texture.invertY, scene, samplingMode, null, onError, prepareTexture, prepareTextureProcess, buffer, texture);
                message = (message || "Unknown error") + ((0, $ejQPp.EngineStore).UseFallbackTexture ? " - Fallback texture was used" : "");
                texture.onErrorObservable.notifyObservers({
                    message: message,
                    exception: exception
                });
                if (onError) onError(message, exception);
            } else {
                // fall back to the original url if the transformed url fails to load
                (0, $kVtWi.Logger).Warn(`Failed to load ${url}, falling back to ${originalUrl}`);
                this._createTextureBase(originalUrl, noMipmap, texture.invertY, scene, samplingMode, onLoad, onError, prepareTexture, prepareTextureProcess, buffer, texture, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
            }
        };
        // processing for non-image formats
        if (loaderPromise) {
            const callback = async (data)=>{
                const loader = await loaderPromise;
                loader.loadData(data, texture, (width, height, loadMipmap, isCompressed, done, loadFailed)=>{
                    if (loadFailed) onInternalError("TextureLoader failed to load data");
                    else prepareTexture(texture, extension, scene, {
                        width: width,
                        height: height
                    }, texture.invertY, !loadMipmap, isCompressed, ()=>{
                        done();
                        return false;
                    }, samplingMode);
                }, loaderOptions);
            };
            if (!buffer) this._loadFile(url, (data)=>callback(new Uint8Array(data)), undefined, scene ? scene.offlineProvider : undefined, true, (request, exception)=>{
                onInternalError("Unable to load " + (request ? request.responseURL : url, exception));
            });
            else {
                if (buffer instanceof ArrayBuffer) callback(new Uint8Array(buffer));
                else if (ArrayBuffer.isView(buffer)) callback(buffer);
                else if (onError) onError("Unable to load: only ArrayBuffer or ArrayBufferView is supported", null);
            }
        } else {
            const onload = (img)=>{
                if (fromBlob && !this._doNotHandleContextLost) // We need to store the image if we need to rebuild the texture
                // in case of a webgl context lost
                texture._buffer = img;
                prepareTexture(texture, extension, scene, img, texture.invertY, noMipmap, false, prepareTextureProcess, samplingMode);
            };
            // According to the WebGL spec section 6.10, ImageBitmaps must be inverted on creation.
            // So, we pass imageOrientation to _FileToolsLoadImage() as it may create an ImageBitmap.
            if (!fromData || isBase64) {
                if (buffer && (typeof buffer.decoding === "string" || buffer.close)) onload(buffer);
                else $a2109e72261d9ea8$export$1c3aca38fa8ce7e9._FileToolsLoadImage(url || "", onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? {
                    imageOrientation: "flipY"
                } : undefined);
            } else if (typeof buffer === "string" || buffer instanceof ArrayBuffer || ArrayBuffer.isView(buffer) || buffer instanceof Blob) $a2109e72261d9ea8$export$1c3aca38fa8ce7e9._FileToolsLoadImage(buffer, onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? {
                imageOrientation: "flipY"
            } : undefined);
            else if (buffer) onload(buffer);
        }
        return texture;
    }
    _rebuildBuffers() {
        // Uniforms
        for (const uniformBuffer of this._uniformBuffers)uniformBuffer._rebuildAfterContextLost();
    }
    /** @internal */ get _shouldUseHighPrecisionShader() {
        return !!(this._caps.highPrecisionShaderSupported && this._highPrecisionShadersAllowed);
    }
    /**
     * Gets host document
     * @returns the host document object
     */ getHostDocument() {
        if (this._renderingCanvas && this._renderingCanvas.ownerDocument) return this._renderingCanvas.ownerDocument;
        return (0, $jFz47.IsDocumentAvailable)() ? document : null;
    }
    /**
     * Gets the list of loaded textures
     * @returns an array containing all loaded textures
     */ getLoadedTexturesCache() {
        return this._internalTexturesCache;
    }
    /**
     * Clears the list of texture accessible through engine.
     * This can help preventing texture load conflict due to name collision.
     */ clearInternalTexturesCache() {
        this._internalTexturesCache.length = 0;
    }
    /**
     * Gets the object containing all engine capabilities
     * @returns the EngineCapabilities object
     */ getCaps() {
        return this._caps;
    }
    /**
     * Reset the texture cache to empty state
     */ resetTextureCache() {
        for(const key in this._boundTexturesCache){
            if (!Object.prototype.hasOwnProperty.call(this._boundTexturesCache, key)) continue;
            this._boundTexturesCache[key] = null;
        }
        this._currentTextureChannel = -1;
    }
    /**
     * Gets or sets the name of the engine
     */ get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    /**
     * Returns the current npm package of the sdk
     */ // Not mixed with Version for tooling purpose.
    static get NpmPackage() {
        return "babylonjs@7.46.0";
    }
    /**
     * Returns the current version of the framework
     */ static get Version() {
        return "7.46.0";
    }
    /**
     * Gets the HTML canvas attached with the current webGL context
     * @returns a HTML canvas
     */ getRenderingCanvas() {
        return this._renderingCanvas;
    }
    /**
     * Gets the audio context specified in engine initialization options
     * @returns an Audio Context
     */ getAudioContext() {
        return this._audioContext;
    }
    /**
     * Gets the audio destination specified in engine initialization options
     * @returns an audio destination node
     */ getAudioDestination() {
        return this._audioDestination;
    }
    /**
     * Defines the hardware scaling level.
     * By default the hardware scaling level is computed from the window device ratio.
     * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
     * @param level defines the level to use
     */ setHardwareScalingLevel(level) {
        this._hardwareScalingLevel = level;
        this.resize();
    }
    /**
     * Gets the current hardware scaling level.
     * By default the hardware scaling level is computed from the window device ratio.
     * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
     * @returns a number indicating the current hardware scaling level
     */ getHardwareScalingLevel() {
        return this._hardwareScalingLevel;
    }
    /**
     * Gets or sets a boolean indicating if resources should be retained to be able to handle context lost events
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#handling-webgl-context-lost
     */ get doNotHandleContextLost() {
        return this._doNotHandleContextLost;
    }
    set doNotHandleContextLost(value) {
        this._doNotHandleContextLost = value;
    }
    /**
     * Returns true if the stencil buffer has been enabled through the creation option of the context.
     */ get isStencilEnable() {
        return this._isStencilEnable;
    }
    /**
     * Gets the options used for engine creation
     * @returns EngineOptions object
     */ getCreationOptions() {
        return this._creationOptions;
    }
    /**
     * Creates a new engine
     * @param antialias defines whether anti-aliasing should be enabled. If undefined, it means that the underlying engine is free to enable it or not
     * @param options defines further options to be sent to the creation context
     * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
     */ constructor(antialias, options, adaptToDeviceRatio){
        // States
        /** @internal */ this._colorWrite = true;
        /** @internal */ this._colorWriteChanged = true;
        /** @internal */ this._depthCullingState = new (0, $36XJ5.DepthCullingState)();
        /** @internal */ this._stencilStateComposer = new (0, $cyIBx.StencilStateComposer)();
        /** @internal */ this._stencilState = new (0, $d7F9z.StencilState)();
        /** @internal */ this._alphaState = new (0, $ano9R.AlphaState)();
        /** @internal */ this._alphaMode = 1;
        /** @internal */ this._alphaEquation = 0;
        this._activeRequests = [];
        /** @internal */ this._badOS = false;
        /** @internal */ this._badDesktopOS = false;
        this._compatibilityMode = true;
        /** @internal */ this._internalTexturesCache = new Array();
        /** @internal */ this._currentRenderTarget = null;
        /** @internal */ this._boundTexturesCache = {};
        /** @internal */ this._activeChannel = 0;
        /** @internal */ this._currentTextureChannel = -1;
        /** @internal */ this._viewportCached = {
            x: 0,
            y: 0,
            z: 0,
            w: 0
        };
        /** @internal */ this._isWebGPU = false;
        /**
         * Observable event triggered each time the canvas loses focus
         */ this.onCanvasBlurObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time the canvas gains focus
         */ this.onCanvasFocusObservable = new (0, $diGQf.Observable)();
        /**
         * Event raised when a new scene is created
         */ this.onNewSceneAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time the rendering canvas is resized
         */ this.onResizeObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time the canvas receives pointerout event
         */ this.onCanvasPointerOutObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time an effect compilation fails
         */ this.onEffectErrorObservable = new (0, $diGQf.Observable)();
        /**
         * Turn this value on if you want to pause FPS computation when in background
         */ this.disablePerformanceMonitorInBackground = false;
        /**
         * Gets or sets a boolean indicating that vertex array object must be disabled even if they are supported
         */ this.disableVertexArrayObjects = false;
        /** @internal */ this._frameId = 0;
        /**
         * Gets information about the current host
         */ this.hostInformation = {
            isMobile: false
        };
        /**
         * Gets a boolean indicating if the engine is currently rendering in fullscreen mode
         */ this.isFullscreen = false;
        /**
         * Gets or sets a boolean to enable/disable IndexedDB support and avoid XHR on .manifest
         **/ this.enableOfflineSupport = false;
        /**
         * Gets or sets a boolean to enable/disable checking manifest if IndexedDB support is enabled (js will always consider the database is up to date)
         **/ this.disableManifestCheck = false;
        /**
         * Gets or sets a boolean to enable/disable the context menu (right-click) from appearing on the main canvas
         */ this.disableContextMenu = true;
        /**
         * Gets or sets the current render pass id
         */ this.currentRenderPassId = 0;
        /**
         * Gets a boolean indicating if the pointer is currently locked
         */ this.isPointerLock = false;
        /**
         * Gets the list of created postprocesses
         */ this.postProcesses = [];
        /** Gets or sets the tab index to set to the rendering canvas. 1 is the minimum value to set to be able to capture keyboard events */ this.canvasTabIndex = 1;
        /** @internal */ this._contextWasLost = false;
        this._useReverseDepthBuffer = false;
        /**
         * Indicates if the z range in NDC space is 0..1 (value: true) or -1..1 (value: false)
         */ this.isNDCHalfZRange = false;
        /**
         * Indicates that the origin of the texture/framebuffer space is the bottom left corner. If false, the origin is top left
         */ this.hasOriginBottomLeft = true;
        /** @internal */ this._renderTargetWrapperCache = new Array();
        /** @internal */ this._compiledEffects = {};
        /** @internal */ this._isDisposed = false;
        /**
         * Gets the list of created scenes
         */ this.scenes = [];
        /** @internal */ this._virtualScenes = new Array();
        /**
         * Observable event triggered before each texture is initialized
         */ this.onBeforeTextureInitObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean indicating if the engine must keep rendering even if the window is not in foreground
         */ this.renderEvenInBackground = true;
        /**
         * Gets or sets a boolean indicating that cache can be kept between frames
         */ this.preventCacheWipeBetweenFrames = false;
        /** @internal */ this._frameHandler = 0;
        /** @internal */ this._activeRenderLoops = new Array();
        /** @internal */ this._windowIsBackground = false;
        /** @internal */ this._boundRenderFunction = (timestamp)=>this._renderLoop(timestamp);
        this._lastFrameTime = 0;
        /**
         * Skip frame rendering but keep the frame heartbeat (begin/end frame).
         * This is useful if you need all the plumbing but not the rendering work.
         * (for instance when capturing a screenshot where you do not want to mix rendering to the screen and to the screenshot)
         */ this.skipFrameRender = false;
        /**
         * Observable raised when the engine is about to compile a shader
         */ this.onBeforeShaderCompilationObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the engine has just compiled a shader
         */ this.onAfterShaderCompilationObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the engine begins a new frame
         */ this.onBeginFrameObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the engine ends the current frame
         */ this.onEndFrameObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._transformTextureUrl = null;
        /** @internal */ this._uniformBuffers = new Array();
        /** @internal */ this._storageBuffers = new Array();
        this._highPrecisionShadersAllowed = true;
        // Lost context
        /**
         * Observable signaled when a context lost event is raised
         */ this.onContextLostObservable = new (0, $diGQf.Observable)();
        /**
         * Observable signaled when a context restored event is raised
         */ this.onContextRestoredObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._name = "";
        /**
         * Defines whether the engine has been created with the premultipliedAlpha option on or not.
         */ this.premultipliedAlpha = true;
        /**
         * If set to true zooming in and out in the browser will rescale the hardware-scaling correctly.
         */ this.adaptToDeviceRatio = false;
        /** @internal */ this._lastDevicePixelRatio = 1.0;
        /** @internal */ this._doNotHandleContextLost = false;
        /**
         * Gets or sets a boolean indicating if back faces must be culled. If false, front faces are culled instead (true by default)
         * If non null, this takes precedence over the value from the material
         */ this.cullBackFaces = null;
        /** @internal */ this._renderPassNames = [
            "main"
        ];
        // FPS
        this._fps = 60;
        this._deltaTime = 0;
        // Deterministic lockstepMaxSteps
        /** @internal */ this._deterministicLockstep = false;
        /** @internal */ this._lockstepMaxSteps = 4;
        /** @internal */ this._timeStep = 1 / 60;
        /**
         * An event triggered when the engine is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a global cleanup of all effects is required
         */ this.onReleaseEffectsObservable = new (0, $diGQf.Observable)();
        (0, $ejQPp.EngineStore).Instances.push(this);
        this.startTime = (0, $blHSI.PrecisionDate).Now;
        this._stencilStateComposer.stencilGlobal = this._stencilState;
        (0, $3agwF.PerformanceConfigurator).SetMatrixPrecision(!!options.useHighPrecisionMatrix);
        if ((0, $jFz47.IsNavigatorAvailable)() && navigator.userAgent) {
            // Detect if we are running on a faulty buggy OS.
            this._badOS = /iPad/i.test(navigator.userAgent) || /iPhone/i.test(navigator.userAgent);
            // Detect if we are running on a faulty buggy desktop OS.
            this._badDesktopOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        }
        // Save this off for use in resize().
        this.adaptToDeviceRatio = adaptToDeviceRatio ?? false;
        options.antialias = antialias ?? options.antialias;
        options.deterministicLockstep = options.deterministicLockstep ?? false;
        options.lockstepMaxSteps = options.lockstepMaxSteps ?? 4;
        options.timeStep = options.timeStep ?? 1 / 60;
        options.audioEngine = options.audioEngine ?? true;
        options.stencil = options.stencil ?? true;
        this._audioContext = options.audioEngineOptions?.audioContext ?? null;
        this._audioDestination = options.audioEngineOptions?.audioDestination ?? null;
        this.premultipliedAlpha = options.premultipliedAlpha ?? true;
        this._doNotHandleContextLost = !!options.doNotHandleContextLost;
        this._isStencilEnable = options.stencil ? true : false;
        this.useExactSrgbConversions = options.useExactSrgbConversions ?? false;
        const devicePixelRatio = (0, $jFz47.IsWindowObjectExist)() ? window.devicePixelRatio || 1.0 : 1.0;
        const limitDeviceRatio = options.limitDeviceRatio || devicePixelRatio;
        // Viewport
        adaptToDeviceRatio = adaptToDeviceRatio || options.adaptToDeviceRatio || false;
        this._hardwareScalingLevel = adaptToDeviceRatio ? 1.0 / Math.min(limitDeviceRatio, devicePixelRatio) : 1.0;
        this._lastDevicePixelRatio = devicePixelRatio;
        this._creationOptions = options;
    }
    /**
     * Resize the view according to the canvas' size
     * @param forceSetSize true to force setting the sizes of the underlying canvas
     */ resize(forceSetSize = false) {
        let width;
        let height;
        // Re-query hardware scaling level to handle zoomed-in resizing.
        if (this.adaptToDeviceRatio) {
            const devicePixelRatio = (0, $jFz47.IsWindowObjectExist)() ? window.devicePixelRatio || 1.0 : 1.0;
            const changeRatio = this._lastDevicePixelRatio / devicePixelRatio;
            this._lastDevicePixelRatio = devicePixelRatio;
            this._hardwareScalingLevel *= changeRatio;
        }
        if ((0, $jFz47.IsWindowObjectExist)() && (0, $jFz47.IsDocumentAvailable)()) {
            // make sure it is a Node object, and is a part of the document.
            if (this._renderingCanvas) {
                const boundingRect = this._renderingCanvas.getBoundingClientRect ? this._renderingCanvas.getBoundingClientRect() : {
                    // fallback to last solution in case the function doesn't exist
                    width: this._renderingCanvas.width * this._hardwareScalingLevel,
                    height: this._renderingCanvas.height * this._hardwareScalingLevel
                };
                width = this._renderingCanvas.clientWidth || boundingRect.width || this._renderingCanvas.width || 100;
                height = this._renderingCanvas.clientHeight || boundingRect.height || this._renderingCanvas.height || 100;
            } else {
                width = window.innerWidth;
                height = window.innerHeight;
            }
        } else {
            width = this._renderingCanvas ? this._renderingCanvas.width : 100;
            height = this._renderingCanvas ? this._renderingCanvas.height : 100;
        }
        this.setSize(width / this._hardwareScalingLevel, height / this._hardwareScalingLevel, forceSetSize);
    }
    /**
     * Force a specific size of the canvas
     * @param width defines the new canvas' width
     * @param height defines the new canvas' height
     * @param forceSetSize true to force setting the sizes of the underlying canvas
     * @returns true if the size was changed
     */ setSize(width, height, forceSetSize = false) {
        if (!this._renderingCanvas) return false;
        width = width | 0;
        height = height | 0;
        if (!forceSetSize && this._renderingCanvas.width === width && this._renderingCanvas.height === height) return false;
        this._renderingCanvas.width = width;
        this._renderingCanvas.height = height;
        if (this.scenes) {
            for(let index = 0; index < this.scenes.length; index++){
                const scene = this.scenes[index];
                for(let camIndex = 0; camIndex < scene.cameras.length; camIndex++){
                    const cam = scene.cameras[camIndex];
                    cam._currentRenderId = 0;
                }
            }
            if (this.onResizeObservable.hasObservers()) this.onResizeObservable.notifyObservers(this);
        }
        return true;
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a raw texture
     * @param data defines the data to store in the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param format defines the format of the data
     * @param generateMipMaps defines if the engine should generate the mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
     * @param compression defines the compression used (null by default)
     * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_BYTE by default)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the raw texture inside an InternalTexture
     */ createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, compression, type, creationFlags, useSRGBBuffer) {
        throw (0, $dUFYy._WarnImport)("engine.rawTexture");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a new raw cube texture
     * @param data defines the array of data to use to create each face
     * @param size defines the size of the textures
     * @param format defines the format of the data
     * @param type defines the type of the data (like Engine.TEXTURETYPE_UNSIGNED_BYTE)
     * @param generateMipMaps  defines if the engine should generate the mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compression used (null by default)
     * @returns the cube texture as an InternalTexture
     */ createRawCubeTexture(data, size, format, type, generateMipMaps, invertY, samplingMode, compression) {
        throw (0, $dUFYy._WarnImport)("engine.rawTexture");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a new raw 3D texture
     * @param data defines the data used to create the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the depth of the texture
     * @param format defines the format of the texture
     * @param generateMipMaps defines if the engine must generate mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compressed used (can be null)
     * @param textureType defines the compressed used (can be null)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @returns a new raw 3D texture (stored in an InternalTexture)
     */ createRawTexture3D(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression, textureType, creationFlags) {
        throw (0, $dUFYy._WarnImport)("engine.rawTexture");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a new raw 2D array texture
     * @param data defines the data used to create the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the number of layers of the texture
     * @param format defines the format of the texture
     * @param generateMipMaps defines if the engine must generate mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compressed used (can be null)
     * @param textureType defines the compressed used (can be null)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @returns a new raw 2D array texture (stored in an InternalTexture)
     */ createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression, textureType, creationFlags) {
        throw (0, $dUFYy._WarnImport)("engine.rawTexture");
    }
    /**
     * Shared initialization across engines types.
     * @param canvas The canvas associated with this instance of the engine.
     */ _sharedInit(canvas) {
        this._renderingCanvas = canvas;
    }
    _setupMobileChecks() {
        if (!(navigator && navigator.userAgent)) return;
        // Function to check if running on mobile device
        this._checkForMobile = ()=>{
            const currentUA = navigator.userAgent;
            this.hostInformation.isMobile = currentUA.indexOf("Mobile") !== -1 || // Needed for iOS 13+ detection on iPad (inspired by solution from https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
            currentUA.indexOf("Mac") !== -1 && (0, $jFz47.IsDocumentAvailable)() && "ontouchend" in document;
        };
        // Set initial isMobile value
        this._checkForMobile();
        // Set up event listener to check when window is resized (used to get emulator activation to work properly)
        if ((0, $jFz47.IsWindowObjectExist)()) window.addEventListener("resize", this._checkForMobile);
    }
    /**
     * creates and returns a new video element
     * @param constraints video constraints
     * @returns video element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createVideoElement(constraints) {
        return document.createElement("video");
    }
    /**
     * @internal
     */ _reportDrawCall(numDrawCalls = 1) {
        this._drawCalls?.addCount(numDrawCalls, false);
    }
    /**
     * Gets the current framerate
     * @returns a number representing the framerate
     */ getFps() {
        return this._fps;
    }
    /**
     * Gets the time spent between current and previous frame
     * @returns a number representing the delta time in ms
     */ getDeltaTime() {
        return this._deltaTime;
    }
    /**
     * Gets a boolean indicating that the engine is running in deterministic lock step mode
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns true if engine is in deterministic lock step mode
     */ isDeterministicLockStep() {
        return this._deterministicLockstep;
    }
    /**
     * Gets the max steps when engine is running in deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the max steps
     */ getLockstepMaxSteps() {
        return this._lockstepMaxSteps;
    }
    /**
     * Returns the time in ms between steps when using deterministic lock step.
     * @returns time step in (ms)
     */ getTimeStep() {
        return this._timeStep * 1000;
    }
    /**
     * Engine abstraction for loading and creating an image bitmap from a given source string.
     * @param imageSource source to load the image from.
     * @param options An object that sets options for the image's extraction.
     */ _createImageBitmapFromSource(imageSource, options) {
        throw new Error("createImageBitmapFromSource is not implemented");
    }
    /**
     * Engine abstraction for createImageBitmap
     * @param image source for image
     * @param options An object that sets options for the image's extraction.
     * @returns ImageBitmap
     */ createImageBitmap(image, options) {
        return createImageBitmap(image, options);
    }
    /**
     * Resize an image and returns the image data as an uint8array
     * @param image image to resize
     * @param bufferWidth destination buffer width
     * @param bufferHeight destination buffer height
     */ resizeImageBitmap(image, bufferWidth, bufferHeight) {
        throw new Error("resizeImageBitmap is not implemented");
    }
    /**
     * Get Font size information
     * @param font font name
     */ getFontOffset(font) {
        throw new Error("getFontOffset is not implemented");
    }
    static _CreateCanvas(width, height) {
        if (typeof document === "undefined") return new OffscreenCanvas(width, height);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    /**
     * Create a canvas. This method is overridden by other engines
     * @param width width
     * @param height height
     * @returns ICanvas interface
     */ createCanvas(width, height) {
        return $a2109e72261d9ea8$export$1c3aca38fa8ce7e9._CreateCanvas(width, height);
    }
    /**
     * Loads an image as an HTMLImageElement.
     * @param input url string, ArrayBuffer, or Blob to load
     * @param onLoad callback called when the image successfully loads
     * @param onError callback called when the image fails to load
     * @param offlineProvider offline provider for caching
     * @param mimeType optional mime type
     * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
     * @returns the HTMLImageElement of the loaded image
     * @internal
     */ static _FileToolsLoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
        throw (0, $dUFYy._WarnImport)("FileTools");
    }
    /**
     * @internal
     */ _loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        const request = (0, $cOV0H._loadFile)(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        this._activeRequests.push(request);
        request.onCompleteObservable.add(()=>{
            const index = this._activeRequests.indexOf(request);
            if (index !== -1) this._activeRequests.splice(index, 1);
        });
        return request;
    }
    /**
     * Loads a file from a url
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     * @internal
     */ static _FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        if ((0, $cOV0H.EngineFunctionContext).loadFile) return (0, $cOV0H.EngineFunctionContext).loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        throw (0, $dUFYy._WarnImport)("FileTools");
    }
    /**
     * Dispose and release all associated resources
     */ dispose() {
        this.releaseEffects();
        this._isDisposed = true;
        this.stopRenderLoop();
        // Empty texture
        if (this._emptyTexture) {
            this._releaseTexture(this._emptyTexture);
            this._emptyTexture = null;
        }
        if (this._emptyCubeTexture) {
            this._releaseTexture(this._emptyCubeTexture);
            this._emptyCubeTexture = null;
        }
        this._renderingCanvas = null;
        // Clear observables
        if (this.onBeforeTextureInitObservable) this.onBeforeTextureInitObservable.clear();
        // Release postProcesses
        while(this.postProcesses.length)this.postProcesses[0].dispose();
        // Release scenes
        while(this.scenes.length)this.scenes[0].dispose();
        while(this._virtualScenes.length)this._virtualScenes[0].dispose();
        // Release effects
        this.releaseComputeEffects?.();
        (0, $lUDWq.Effect).ResetCache();
        // Abort active requests
        for (const request of this._activeRequests)request.abort();
        this._boundRenderFunction = null;
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onResizeObservable.clear();
        this.onCanvasBlurObservable.clear();
        this.onCanvasFocusObservable.clear();
        this.onCanvasPointerOutObservable.clear();
        this.onNewSceneAddedObservable.clear();
        this.onEffectErrorObservable.clear();
        if ((0, $jFz47.IsWindowObjectExist)()) window.removeEventListener("resize", this._checkForMobile);
        // Remove from Instances
        const index = (0, $ejQPp.EngineStore).Instances.indexOf(this);
        if (index >= 0) (0, $ejQPp.EngineStore).Instances.splice(index, 1);
        // no more engines left in the engine store? Notify!
        if (!(0, $ejQPp.EngineStore).Instances.length) {
            (0, $ejQPp.EngineStore).OnEnginesDisposedObservable.notifyObservers(this);
            (0, $ejQPp.EngineStore).OnEnginesDisposedObservable.clear();
        }
        // Observables
        this.onBeginFrameObservable.clear();
        this.onEndFrameObservable.clear();
    }
    /**
     * Method called to create the default loading screen.
     * This can be overridden in your own app.
     * @param canvas The rendering canvas element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static DefaultLoadingScreenFactory(canvas) {
        throw (0, $dUFYy._WarnImport)("LoadingScreen");
    }
    /**
     * Will flag all materials in all scenes in all engines as dirty to trigger new shader compilation
     * @param flag defines which part of the materials must be marked as dirty
     * @param predicate defines a predicate used to filter which materials should be affected
     */ static MarkAllMaterialsAsDirty(flag, predicate) {
        for(let engineIndex = 0; engineIndex < (0, $ejQPp.EngineStore).Instances.length; engineIndex++){
            const engine = (0, $ejQPp.EngineStore).Instances[engineIndex];
            for(let sceneIndex = 0; sceneIndex < engine.scenes.length; sceneIndex++)engine.scenes[sceneIndex].markAllMaterialsAsDirty(flag, predicate);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/naming-convention
/** @internal */ $a2109e72261d9ea8$export$1c3aca38fa8ce7e9._RenderPassIdCounter = 0;
/**
 * Method called to create the default rescale post process on each engine.
 */ $a2109e72261d9ea8$export$1c3aca38fa8ce7e9._RescalePostProcessFactory = null;
// Updatable statics so stick with vars here
/**
 * Gets or sets the epsilon value used by collision engine
 */ $a2109e72261d9ea8$export$1c3aca38fa8ce7e9.CollisionsEpsilon = 0.001;
/**
 * Queue a new function into the requested animation frame pool (ie. this function will be executed by the browser (or the javascript engine) for the next frame)
 * @param func - the function to be called
 * @param requester - the object that will request the next frame. Falls back to window.
 * @returns frame number
 */ $a2109e72261d9ea8$export$1c3aca38fa8ce7e9.QueueNewFrame = $a2109e72261d9ea8$export$a53fc116e5e6ad5d;

});
parcelRegister("lUDWq", function(module, exports) {

$parcel$export(module.exports, "Effect", () => $ff3dcf72127134d1$export$a32b0b1c1ac59d04);

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");

var $68BIi = parcelRequire("68BIi");

var $4kP5d = parcelRequire("4kP5d");

var $av6Bc = parcelRequire("av6Bc");
class $ff3dcf72127134d1$export$a32b0b1c1ac59d04 {
    /**
     * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
     */ static get ShadersRepository() {
        return (0, $68BIi.ShaderStore).ShadersRepository;
    }
    static set ShadersRepository(repo) {
        (0, $68BIi.ShaderStore).ShadersRepository = repo;
    }
    /**
     * Gets a boolean indicating that the effect was already disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Observable that will be called when effect is bound.
     */ get onBindObservable() {
        if (!this._onBindObservable) this._onBindObservable = new (0, $diGQf.Observable)();
        return this._onBindObservable;
    }
    /**
     * Gets the shader language type used to write vertex and fragment source code.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * Instantiates an effect.
     * An effect can be used to create/manage/execute vertex and fragment shaders.
     * @param baseName Name of the effect.
     * @param attributesNamesOrOptions List of attribute names that will be passed to the shader or set of all options to create the effect.
     * @param uniformsNamesOrEngine List of uniform variable names that will be passed to the shader or the engine that will be used to render effect.
     * @param samplers List of sampler variables that will be passed to the shader.
     * @param engine Engine to be used to render the effect
     * @param defines Define statements to be added to the shader.
     * @param fallbacks Possible fallbacks for this effect to improve performance when needed.
     * @param onCompiled Callback that will be called when the shader is compiled.
     * @param onError Callback that will be called if an error occurs during shader compilation.
     * @param indexParameters Parameters to be used with Babylons include syntax to iterate over an array (eg. \{lights: 10\})
     * @param key Effect Key identifying uniquely compiled shader variants
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     * @param extraInitializationsAsync additional async code to run before preparing the effect
     */ constructor(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers = null, engine, defines = null, fallbacks = null, onCompiled = null, onError = null, indexParameters, key = "", shaderLanguage = 0 /* ShaderLanguage.GLSL */ , extraInitializationsAsync){
        /**
         * String container all the define statements that should be set on the shader.
         */ this.defines = "";
        /**
         * Callback that will be called when the shader is compiled.
         */ this.onCompiled = null;
        /**
         * Callback that will be called if an error occurs during shader compilation.
         */ this.onError = null;
        /**
         * Callback that will be called when effect is bound.
         */ this.onBind = null;
        /**
         * Unique ID of the effect.
         */ this.uniqueId = 0;
        /**
         * Observable that will be called when the shader is compiled.
         * It is recommended to use executeWhenCompile() or to make sure that scene.isReady() is called to get this observable raised.
         */ this.onCompileObservable = new (0, $diGQf.Observable)();
        /**
         * Observable that will be called if an error occurs during shader compilation.
         */ this.onErrorObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._onBindObservable = null;
        this._isDisposed = false;
        /** @internal */ this._refCount = 1;
        /** @internal */ this._bonesComputationForcedToCPU = false;
        /** @internal */ this._uniformBuffersNames = {};
        /** @internal */ this._multiTarget = false;
        /** @internal */ this._samplers = {};
        this._isReady = false;
        this._compilationError = "";
        this._allFallbacksProcessed = false;
        /** @internal */ this._uniforms = {};
        /**
         * Key for the effect.
         * @internal
         */ this._key = "";
        this._fallbacks = null;
        this._vertexSourceCodeOverride = "";
        this._fragmentSourceCodeOverride = "";
        this._transformFeedbackVaryings = null;
        /**
         * Compiled shader to webGL program.
         * @internal
         */ this._pipelineContext = null;
        /** @internal */ this._vertexSourceCode = "";
        /** @internal */ this._fragmentSourceCode = "";
        /** @internal */ this._vertexSourceCodeBeforeMigration = "";
        /** @internal */ this._fragmentSourceCodeBeforeMigration = "";
        /** @internal */ this._rawVertexSourceCode = "";
        /** @internal */ this._rawFragmentSourceCode = "";
        this._processCodeAfterIncludes = undefined;
        this._processFinalCode = null;
        this.name = baseName;
        this._key = key;
        const pipelineName = this._key.replace(/\r/g, "").replace(/\n/g, "|");
        let cachedPipeline = undefined;
        if (attributesNamesOrOptions.attributes) {
            const options = attributesNamesOrOptions;
            this._engine = uniformsNamesOrEngine;
            this._attributesNames = options.attributes;
            this._uniformsNames = options.uniformsNames.concat(options.samplers);
            this._samplerList = options.samplers.slice();
            this.defines = options.defines;
            this.onError = options.onError;
            this.onCompiled = options.onCompiled;
            this._fallbacks = options.fallbacks;
            this._indexParameters = options.indexParameters;
            this._transformFeedbackVaryings = options.transformFeedbackVaryings || null;
            this._multiTarget = !!options.multiTarget;
            this._shaderLanguage = options.shaderLanguage ?? 0 /* ShaderLanguage.GLSL */ ;
            if (options.uniformBuffersNames) {
                this._uniformBuffersNamesList = options.uniformBuffersNames.slice();
                for(let i = 0; i < options.uniformBuffersNames.length; i++)this._uniformBuffersNames[options.uniformBuffersNames[i]] = i;
            }
            this._processFinalCode = options.processFinalCode ?? null;
            this._processCodeAfterIncludes = options.processCodeAfterIncludes ?? undefined;
            extraInitializationsAsync = options.extraInitializationsAsync;
            cachedPipeline = options.existingPipelineContext;
        } else {
            this._engine = engine;
            this.defines = defines == null ? "" : defines;
            this._uniformsNames = uniformsNamesOrEngine.concat(samplers);
            this._samplerList = samplers ? samplers.slice() : [];
            this._attributesNames = attributesNamesOrOptions;
            this._uniformBuffersNamesList = [];
            this._shaderLanguage = shaderLanguage;
            this.onError = onError;
            this.onCompiled = onCompiled;
            this._indexParameters = indexParameters;
            this._fallbacks = fallbacks;
        }
        // Use the cache if we can. For now, WebGL2 only.
        if (this._engine.shaderPlatformName === "WEBGL2") cachedPipeline = (0, $4kP5d.getCachedPipeline)(pipelineName, this._engine._gl) ?? cachedPipeline;
        this._attributeLocationByName = {};
        this.uniqueId = $ff3dcf72127134d1$export$a32b0b1c1ac59d04._UniqueIdSeed++;
        if (!cachedPipeline) this._processShaderCodeAsync(null, false, null, extraInitializationsAsync);
        else {
            this._pipelineContext = cachedPipeline;
            this._pipelineContext.setEngine(this._engine);
            this._onRenderingStateCompiled(this._pipelineContext);
            // rebuildRebind for spector
            if (this._pipelineContext.program) this._pipelineContext.program.__SPECTOR_rebuildProgram = this._rebuildProgram.bind(this);
        }
        this._engine.onReleaseEffectsObservable.addOnce(()=>{
            if (this.isDisposed) return;
            this.dispose(true);
        });
    }
    /** @internal */ async _processShaderCodeAsync(shaderProcessor = null, keepExistingPipelineContext = false, shaderProcessingContext = null, extraInitializationsAsync) {
        if (extraInitializationsAsync) await extraInitializationsAsync();
        this._processingContext = shaderProcessingContext || this._engine._getShaderProcessingContext(this._shaderLanguage, false);
        const processorOptions = {
            defines: this.defines.split("\n"),
            indexParameters: this._indexParameters,
            isFragment: false,
            shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
            processor: shaderProcessor ?? this._engine._getShaderProcessor(this._shaderLanguage),
            supportsUniformBuffers: this._engine.supportsUniformBuffers,
            shadersRepository: (0, $68BIi.ShaderStore).GetShadersRepository(this._shaderLanguage),
            includesShadersStore: (0, $68BIi.ShaderStore).GetIncludesShadersStore(this._shaderLanguage),
            version: (this._engine.version * 100).toString(),
            platformName: this._engine.shaderPlatformName,
            processingContext: this._processingContext,
            isNDCHalfZRange: this._engine.isNDCHalfZRange,
            useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
            processCodeAfterIncludes: this._processCodeAfterIncludes
        };
        (0, $4kP5d._processShaderCode)(processorOptions, this.name, this._processFinalCode, (migratedVertexCode, migratedFragmentCode)=>{
            this._vertexSourceCode = migratedVertexCode;
            this._fragmentSourceCode = migratedFragmentCode;
            this._prepareEffect(keepExistingPipelineContext);
        }, this._shaderLanguage, this._engine, this);
    }
    /**
     * Unique key for this effect
     */ get key() {
        return this._key;
    }
    /**
     * If the effect has been compiled and prepared.
     * @returns if the effect is compiled and prepared.
     */ isReady() {
        try {
            return this._isReadyInternal();
        } catch  {
            return false;
        }
    }
    _isReadyInternal() {
        if (this._engine.isDisposed) // Engine is disposed, we return true to prevent looping over the setTimeout call in _checkIsReady
        return true;
        if (this._isReady) return true;
        if (this._pipelineContext) return this._pipelineContext.isReady;
        return false;
    }
    /**
     * The engine the effect was initialized with.
     * @returns the engine.
     */ getEngine() {
        return this._engine;
    }
    /**
     * The pipeline context for this effect
     * @returns the associated pipeline context
     */ getPipelineContext() {
        return this._pipelineContext;
    }
    /**
     * The set of names of attribute variables for the shader.
     * @returns An array of attribute names.
     */ getAttributesNames() {
        return this._attributesNames;
    }
    /**
     * Returns the attribute at the given index.
     * @param index The index of the attribute.
     * @returns The location of the attribute.
     */ getAttributeLocation(index) {
        return this._attributes[index];
    }
    /**
     * Returns the attribute based on the name of the variable.
     * @param name of the attribute to look up.
     * @returns the attribute location.
     */ getAttributeLocationByName(name) {
        return this._attributeLocationByName[name];
    }
    /**
     * The number of attributes.
     * @returns the number of attributes.
     */ getAttributesCount() {
        return this._attributes.length;
    }
    /**
     * Gets the index of a uniform variable.
     * @param uniformName of the uniform to look up.
     * @returns the index.
     */ getUniformIndex(uniformName) {
        return this._uniformsNames.indexOf(uniformName);
    }
    /**
     * Returns the attribute based on the name of the variable.
     * @param uniformName of the uniform to look up.
     * @returns the location of the uniform.
     */ getUniform(uniformName) {
        return this._uniforms[uniformName];
    }
    /**
     * Returns an array of sampler variable names
     * @returns The array of sampler variable names.
     */ getSamplers() {
        return this._samplerList;
    }
    /**
     * Returns an array of uniform variable names
     * @returns The array of uniform variable names.
     */ getUniformNames() {
        return this._uniformsNames;
    }
    /**
     * Returns an array of uniform buffer variable names
     * @returns The array of uniform buffer variable names.
     */ getUniformBuffersNames() {
        return this._uniformBuffersNamesList;
    }
    /**
     * Returns the index parameters used to create the effect
     * @returns The index parameters object
     */ getIndexParameters() {
        return this._indexParameters;
    }
    /**
     * The error from the last compilation.
     * @returns the error string.
     */ getCompilationError() {
        return this._compilationError;
    }
    /**
     * Gets a boolean indicating that all fallbacks were used during compilation
     * @returns true if all fallbacks were used
     */ allFallbacksProcessed() {
        return this._allFallbacksProcessed;
    }
    /**
     * Adds a callback to the onCompiled observable and call the callback immediately if already ready.
     * @param func The callback to be used.
     */ executeWhenCompiled(func) {
        if (this.isReady()) {
            func(this);
            return;
        }
        this.onCompileObservable.add((effect)=>{
            func(effect);
        });
        if (!this._pipelineContext || this._pipelineContext.isAsync) this._checkIsReady(null);
    }
    _checkIsReady(previousPipelineContext) {
        (0, $av6Bc._retryWithInterval)(()=>{
            return this._isReadyInternal() || this._isDisposed;
        }, ()=>{
        // no-op - done in the _isReadyInternal call
        }, (e)=>{
            this._processCompilationErrors(e, previousPipelineContext);
        }, 16, 30000, true, ` - Effect: ${typeof this.name === "string" ? this.name : this.key}`);
    }
    /**
     * Gets the vertex shader source code of this effect
     * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
     */ get vertexSourceCode() {
        return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._vertexSourceCodeOverride : this._pipelineContext?._getVertexShaderCode() ?? this._vertexSourceCode;
    }
    /**
     * Gets the fragment shader source code of this effect
     * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
     */ get fragmentSourceCode() {
        return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._fragmentSourceCodeOverride : this._pipelineContext?._getFragmentShaderCode() ?? this._fragmentSourceCode;
    }
    /**
     * Gets the vertex shader source code before migration.
     * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
     * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
     */ get vertexSourceCodeBeforeMigration() {
        return this._vertexSourceCodeBeforeMigration;
    }
    /**
     * Gets the fragment shader source code before migration.
     * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
     * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
     */ get fragmentSourceCodeBeforeMigration() {
        return this._fragmentSourceCodeBeforeMigration;
    }
    /**
     * Gets the vertex shader source code before it has been modified by any processing
     */ get rawVertexSourceCode() {
        return this._rawVertexSourceCode;
    }
    /**
     * Gets the fragment shader source code before it has been modified by any processing
     */ get rawFragmentSourceCode() {
        return this._rawFragmentSourceCode;
    }
    getPipelineGenerationOptions() {
        return {
            platformName: this._engine.shaderPlatformName,
            shaderLanguage: this._shaderLanguage,
            shaderNameOrContent: this.name,
            key: this._key,
            defines: this.defines.split("\n"),
            addGlobalDefines: false,
            extendedProcessingOptions: {
                indexParameters: this._indexParameters,
                isNDCHalfZRange: this._engine.isNDCHalfZRange,
                useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
                supportsUniformBuffers: this._engine.supportsUniformBuffers
            },
            extendedCreatePipelineOptions: {
                transformFeedbackVaryings: this._transformFeedbackVaryings,
                createAsRaw: !!(this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride)
            }
        };
    }
    /**
     * Recompiles the webGL program
     * @param vertexSourceCode The source code for the vertex shader.
     * @param fragmentSourceCode The source code for the fragment shader.
     * @param onCompiled Callback called when completed.
     * @param onError Callback called on error.
     * @internal
     */ _rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError) {
        this._isReady = false;
        this._vertexSourceCodeOverride = vertexSourceCode;
        this._fragmentSourceCodeOverride = fragmentSourceCode;
        this.onError = (effect, error)=>{
            if (onError) onError(error);
        };
        this.onCompiled = ()=>{
            const scenes = this.getEngine().scenes;
            if (scenes) for(let i = 0; i < scenes.length; i++)scenes[i].markAllMaterialsAsDirty(63);
            this._pipelineContext._handlesSpectorRebuildCallback?.(onCompiled);
        };
        this._fallbacks = null;
        this._prepareEffect();
    }
    _onRenderingStateCompiled(pipelineContext) {
        this._pipelineContext = pipelineContext;
        this._pipelineContext.setEngine(this._engine);
        this._attributes = [];
        this._pipelineContext._fillEffectInformation(this, this._uniformBuffersNames, this._uniformsNames, this._uniforms, this._samplerList, this._samplers, this._attributesNames, this._attributes);
        // Caches attribute locations.
        if (this._attributesNames) for(let i = 0; i < this._attributesNames.length; i++){
            const name = this._attributesNames[i];
            this._attributeLocationByName[name] = this._attributes[i];
        }
        this._engine.bindSamplers(this);
        this._compilationError = "";
        this._isReady = true;
        if (this.onCompiled) this.onCompiled(this);
        this.onCompileObservable.notifyObservers(this);
        this.onCompileObservable.clear();
        // Unbind mesh reference in fallbacks
        if (this._fallbacks) this._fallbacks.unBindMesh();
        if ($ff3dcf72127134d1$export$a32b0b1c1ac59d04.AutomaticallyClearCodeCache) this.clearCodeCache();
    }
    /**
     * Prepares the effect
     * @internal
     */ _prepareEffect(keepExistingPipelineContext = false) {
        const previousPipelineContext = this._pipelineContext;
        this._isReady = false;
        try {
            const overrides = !!(this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride);
            const defines = overrides ? null : this.defines;
            const vertex = overrides ? this._vertexSourceCodeOverride : this._vertexSourceCode;
            const fragment = overrides ? this._fragmentSourceCodeOverride : this._fragmentSourceCode;
            const engine = this._engine;
            this._pipelineContext = (0, $4kP5d.createAndPreparePipelineContext)({
                existingPipelineContext: keepExistingPipelineContext ? previousPipelineContext : null,
                vertex: vertex,
                fragment: fragment,
                context: engine.shaderPlatformName === "WEBGL2" ? engine._gl : undefined,
                rebuildRebind: (vertexSourceCode, fragmentSourceCode, onCompiled, onError)=>this._rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError),
                defines: defines,
                transformFeedbackVaryings: this._transformFeedbackVaryings,
                name: this._key.replace(/\r/g, "").replace(/\n/g, "|"),
                createAsRaw: overrides,
                parallelShaderCompile: engine._caps.parallelShaderCompile,
                shaderProcessingContext: this._processingContext,
                onRenderingStateCompiled: (pipelineContext)=>{
                    if (previousPipelineContext && !keepExistingPipelineContext) this._engine._deletePipelineContext(previousPipelineContext);
                    if (pipelineContext) this._onRenderingStateCompiled(pipelineContext);
                }
            }, this._engine.createPipelineContext.bind(this._engine), this._engine._preparePipelineContext.bind(this._engine), this._engine._executeWhenRenderingStateIsCompiled.bind(this._engine));
            if (this._pipelineContext.isAsync) this._checkIsReady(previousPipelineContext);
        } catch (e) {
            this._processCompilationErrors(e, previousPipelineContext);
        }
    }
    _getShaderCodeAndErrorLine(code, error, isFragment) {
        const regexp = isFragment ? /FRAGMENT SHADER ERROR: 0:(\d+?):/ : /VERTEX SHADER ERROR: 0:(\d+?):/;
        let errorLine = null;
        if (error && code) {
            const res = error.match(regexp);
            if (res && res.length === 2) {
                const lineNumber = parseInt(res[1]);
                const lines = code.split("\n", -1);
                if (lines.length >= lineNumber) errorLine = `Offending line [${lineNumber}] in ${isFragment ? "fragment" : "vertex"} code: ${lines[lineNumber - 1]}`;
            }
        }
        return [
            code,
            errorLine
        ];
    }
    _processCompilationErrors(e, previousPipelineContext = null) {
        this._compilationError = e.message;
        const attributesNames = this._attributesNames;
        const fallbacks = this._fallbacks;
        // Let's go through fallbacks then
        (0, $kVtWi.Logger).Error("Unable to compile effect:");
        (0, $kVtWi.Logger).Error("Uniforms: " + this._uniformsNames.map(function(uniform) {
            return " " + uniform;
        }));
        (0, $kVtWi.Logger).Error("Attributes: " + attributesNames.map(function(attribute) {
            return " " + attribute;
        }));
        (0, $kVtWi.Logger).Error("Defines:\n" + this.defines);
        if ($ff3dcf72127134d1$export$a32b0b1c1ac59d04.LogShaderCodeOnCompilationError) {
            let lineErrorVertex = null, lineErrorFragment = null, code = null;
            if (this._pipelineContext?._getVertexShaderCode()) {
                [code, lineErrorVertex] = this._getShaderCodeAndErrorLine(this._pipelineContext._getVertexShaderCode(), this._compilationError, false);
                if (code) {
                    (0, $kVtWi.Logger).Error("Vertex code:");
                    (0, $kVtWi.Logger).Error(code);
                }
            }
            if (this._pipelineContext?._getFragmentShaderCode()) {
                [code, lineErrorFragment] = this._getShaderCodeAndErrorLine(this._pipelineContext?._getFragmentShaderCode(), this._compilationError, true);
                if (code) {
                    (0, $kVtWi.Logger).Error("Fragment code:");
                    (0, $kVtWi.Logger).Error(code);
                }
            }
            if (lineErrorVertex) (0, $kVtWi.Logger).Error(lineErrorVertex);
            if (lineErrorFragment) (0, $kVtWi.Logger).Error(lineErrorFragment);
        }
        (0, $kVtWi.Logger).Error("Error: " + this._compilationError);
        const notifyErrors = ()=>{
            if (this.onError) this.onError(this, this._compilationError);
            this.onErrorObservable.notifyObservers(this);
            this._engine.onEffectErrorObservable.notifyObservers({
                effect: this,
                errors: this._compilationError
            });
        };
        // In case a previous compilation was successful, we need to restore the previous pipeline context
        if (previousPipelineContext) {
            this._pipelineContext = previousPipelineContext;
            this._isReady = true;
            notifyErrors();
        }
        // Lets try to compile fallbacks as long as we have some.
        if (fallbacks) {
            this._pipelineContext = null;
            if (fallbacks.hasMoreFallbacks) {
                this._allFallbacksProcessed = false;
                (0, $kVtWi.Logger).Error("Trying next fallback.");
                this.defines = fallbacks.reduce(this.defines, this);
                this._prepareEffect();
            } else {
                // Sorry we did everything we can
                this._allFallbacksProcessed = true;
                notifyErrors();
                this.onErrorObservable.clear();
                // Unbind mesh reference in fallbacks
                if (this._fallbacks) this._fallbacks.unBindMesh();
            }
        } else {
            this._allFallbacksProcessed = true;
            // In case of error, without any prior successful compilation, let s notify observers
            if (!previousPipelineContext) notifyErrors();
        }
    }
    /**
     * Checks if the effect is supported. (Must be called after compilation)
     */ get isSupported() {
        return this._compilationError === "";
    }
    /**
     * Binds a texture to the engine to be used as output of the shader.
     * @param channel Name of the output variable.
     * @param texture Texture to bind.
     * @internal
     */ _bindTexture(channel, texture) {
        this._engine._bindTexture(this._samplers[channel], texture, channel);
    }
    /**
     * Sets a texture on the engine to be used in the shader.
     * @param channel Name of the sampler variable.
     * @param texture Texture to set.
     */ setTexture(channel, texture) {
        this._engine.setTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
    }
    /**
     * Sets an array of textures on the engine to be used in the shader.
     * @param channel Name of the variable.
     * @param textures Textures to set.
     */ setTextureArray(channel, textures) {
        const exName = channel + "Ex";
        if (this._samplerList.indexOf(exName + "0") === -1) {
            const initialPos = this._samplerList.indexOf(channel);
            for(let index = 1; index < textures.length; index++){
                const currentExName = exName + (index - 1).toString();
                this._samplerList.splice(initialPos + index, 0, currentExName);
            }
            // Reset every channels
            let channelIndex = 0;
            for (const key of this._samplerList){
                this._samplers[key] = channelIndex;
                channelIndex += 1;
            }
        }
        this._engine.setTextureArray(this._samplers[channel], this._uniforms[channel], textures, channel);
    }
    /**
     * Binds a buffer to a uniform.
     * @param buffer Buffer to bind.
     * @param name Name of the uniform variable to bind to.
     */ bindUniformBuffer(buffer, name) {
        const bufferName = this._uniformBuffersNames[name];
        if (bufferName === undefined || $ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache[bufferName] === buffer && this._engine._features.useUBOBindingCache) return;
        $ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache[bufferName] = buffer;
        this._engine.bindUniformBufferBase(buffer, bufferName, name);
    }
    /**
     * Binds block to a uniform.
     * @param blockName Name of the block to bind.
     * @param index Index to bind.
     */ bindUniformBlock(blockName, index) {
        this._engine.bindUniformBlock(this._pipelineContext, blockName, index);
    }
    /**
     * Sets an integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     * @returns this effect.
     */ setInt(uniformName, value) {
        this._pipelineContext.setInt(uniformName, value);
        return this;
    }
    /**
     * Sets an int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int2.
     * @param y Second int in int2.
     * @returns this effect.
     */ setInt2(uniformName, x, y) {
        this._pipelineContext.setInt2(uniformName, x, y);
        return this;
    }
    /**
     * Sets an int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int3.
     * @param y Second int in int3.
     * @param z Third int in int3.
     * @returns this effect.
     */ setInt3(uniformName, x, y, z) {
        this._pipelineContext.setInt3(uniformName, x, y, z);
        return this;
    }
    /**
     * Sets an int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int4.
     * @param y Second int in int4.
     * @param z Third int in int4.
     * @param w Fourth int in int4.
     * @returns this effect.
     */ setInt4(uniformName, x, y, z, w) {
        this._pipelineContext.setInt4(uniformName, x, y, z, w);
        return this;
    }
    /**
     * Sets an int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray(uniformName, array) {
        this._pipelineContext.setIntArray(uniformName, array);
        return this;
    }
    /**
     * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray2(uniformName, array) {
        this._pipelineContext.setIntArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray3(uniformName, array) {
        this._pipelineContext.setIntArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray4(uniformName, array) {
        this._pipelineContext.setIntArray4(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     * @returns this effect.
     */ setUInt(uniformName, value) {
        this._pipelineContext.setUInt(uniformName, value);
        return this;
    }
    /**
     * Sets an unsigned int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint2.
     * @param y Second unsigned int in uint2.
     * @returns this effect.
     */ setUInt2(uniformName, x, y) {
        this._pipelineContext.setUInt2(uniformName, x, y);
        return this;
    }
    /**
     * Sets an unsigned int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint3.
     * @param y Second unsigned int in uint3.
     * @param z Third unsigned int in uint3.
     * @returns this effect.
     */ setUInt3(uniformName, x, y, z) {
        this._pipelineContext.setUInt3(uniformName, x, y, z);
        return this;
    }
    /**
     * Sets an unsigned int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint4.
     * @param y Second unsigned int in uint4.
     * @param z Third unsigned int in uint4.
     * @param w Fourth unsigned int in uint4.
     * @returns this effect.
     */ setUInt4(uniformName, x, y, z, w) {
        this._pipelineContext.setUInt4(uniformName, x, y, z, w);
        return this;
    }
    /**
     * Sets an unsigned int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray(uniformName, array) {
        this._pipelineContext.setUIntArray(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray2(uniformName, array) {
        this._pipelineContext.setUIntArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray3(uniformName, array) {
        this._pipelineContext.setUIntArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray4(uniformName, array) {
        this._pipelineContext.setUIntArray4(uniformName, array);
        return this;
    }
    /**
     * Sets an float array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray(uniformName, array) {
        this._pipelineContext.setArray(uniformName, array);
        return this;
    }
    /**
     * Sets an float array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray2(uniformName, array) {
        this._pipelineContext.setArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an float array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray3(uniformName, array) {
        this._pipelineContext.setArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an float array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray4(uniformName, array) {
        this._pipelineContext.setArray4(uniformName, array);
        return this;
    }
    /**
     * Sets an array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray(uniformName, array) {
        this._pipelineContext.setArray(uniformName, array);
        return this;
    }
    /**
     * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray2(uniformName, array) {
        this._pipelineContext.setArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray3(uniformName, array) {
        this._pipelineContext.setArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray4(uniformName, array) {
        this._pipelineContext.setArray4(uniformName, array);
        return this;
    }
    /**
     * Sets matrices on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrices matrices to be set.
     * @returns this effect.
     */ setMatrices(uniformName, matrices) {
        this._pipelineContext.setMatrices(uniformName, matrices);
        return this;
    }
    /**
     * Sets matrix on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     * @returns this effect.
     */ setMatrix(uniformName, matrix) {
        this._pipelineContext.setMatrix(uniformName, matrix);
        return this;
    }
    /**
     * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     * @returns this effect.
     */ setMatrix3x3(uniformName, matrix) {
        // the cast is ok because it is gl.uniformMatrix3fv() which is called at the end, and this function accepts Float32Array and Array<number>
        this._pipelineContext.setMatrix3x3(uniformName, matrix);
        return this;
    }
    /**
     * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     * @returns this effect.
     */ setMatrix2x2(uniformName, matrix) {
        // the cast is ok because it is gl.uniformMatrix3fv() which is called at the end, and this function accepts Float32Array and Array<number>
        this._pipelineContext.setMatrix2x2(uniformName, matrix);
        return this;
    }
    /**
     * Sets a float on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value value to be set.
     * @returns this effect.
     */ setFloat(uniformName, value) {
        this._pipelineContext.setFloat(uniformName, value);
        return this;
    }
    /**
     * Sets a boolean on a uniform variable.
     * @param uniformName Name of the variable.
     * @param bool value to be set.
     * @returns this effect.
     */ setBool(uniformName, bool) {
        this._pipelineContext.setInt(uniformName, bool ? 1 : 0);
        return this;
    }
    /**
     * Sets a Vector2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector2 vector2 to be set.
     * @returns this effect.
     */ setVector2(uniformName, vector2) {
        this._pipelineContext.setVector2(uniformName, vector2);
        return this;
    }
    /**
     * Sets a float2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float2.
     * @param y Second float in float2.
     * @returns this effect.
     */ setFloat2(uniformName, x, y) {
        this._pipelineContext.setFloat2(uniformName, x, y);
        return this;
    }
    /**
     * Sets a Vector3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector3 Value to be set.
     * @returns this effect.
     */ setVector3(uniformName, vector3) {
        this._pipelineContext.setVector3(uniformName, vector3);
        return this;
    }
    /**
     * Sets a float3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float3.
     * @param y Second float in float3.
     * @param z Third float in float3.
     * @returns this effect.
     */ setFloat3(uniformName, x, y, z) {
        this._pipelineContext.setFloat3(uniformName, x, y, z);
        return this;
    }
    /**
     * Sets a Vector4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector4 Value to be set.
     * @returns this effect.
     */ setVector4(uniformName, vector4) {
        this._pipelineContext.setVector4(uniformName, vector4);
        return this;
    }
    /**
     * Sets a Quaternion on a uniform variable.
     * @param uniformName Name of the variable.
     * @param quaternion Value to be set.
     * @returns this effect.
     */ setQuaternion(uniformName, quaternion) {
        this._pipelineContext.setQuaternion(uniformName, quaternion);
        return this;
    }
    /**
     * Sets a float4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float4.
     * @param y Second float in float4.
     * @param z Third float in float4.
     * @param w Fourth float in float4.
     * @returns this effect.
     */ setFloat4(uniformName, x, y, z, w) {
        this._pipelineContext.setFloat4(uniformName, x, y, z, w);
        return this;
    }
    /**
     * Sets a Color3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @returns this effect.
     */ setColor3(uniformName, color3) {
        this._pipelineContext.setColor3(uniformName, color3);
        return this;
    }
    /**
     * Sets a Color4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @param alpha Alpha value to be set.
     * @returns this effect.
     */ setColor4(uniformName, color3, alpha) {
        this._pipelineContext.setColor4(uniformName, color3, alpha);
        return this;
    }
    /**
     * Sets a Color4 on a uniform variable
     * @param uniformName defines the name of the variable
     * @param color4 defines the value to be set
     * @returns this effect.
     */ setDirectColor4(uniformName, color4) {
        this._pipelineContext.setDirectColor4(uniformName, color4);
        return this;
    }
    /**
     * Use this wisely: It will remove the cached code from this effect
     * It is probably ok to call it if you are not using ShadowDepthWrapper or if everything is already up and running
     * DO NOT CALL IT if you want to have support for context lost recovery
     */ clearCodeCache() {
        this._vertexSourceCode = "";
        this._fragmentSourceCode = "";
        this._fragmentSourceCodeBeforeMigration = "";
        this._vertexSourceCodeBeforeMigration = "";
    }
    /**
     * Release all associated resources.
     * @param force specifies if the effect must be released no matter what
     **/ dispose(force = false) {
        if (force) this._refCount = 0;
        else {
            if ($ff3dcf72127134d1$export$a32b0b1c1ac59d04.PersistentMode) return;
            this._refCount--;
        }
        if (this._refCount > 0 || this._isDisposed) // Others are still using the effect or the effect was already disposed
        return;
        if (this._pipelineContext) (0, $4kP5d.resetCachedPipeline)(this._pipelineContext);
        this._engine._releaseEffect(this);
        this.clearCodeCache();
        this._isDisposed = true;
    }
    /**
     * This function will add a new shader to the shader store
     * @param name the name of the shader
     * @param pixelShader optional pixel shader content
     * @param vertexShader optional vertex shader content
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     */ static RegisterShader(name, pixelShader, vertexShader, shaderLanguage = 0 /* ShaderLanguage.GLSL */ ) {
        if (pixelShader) (0, $68BIi.ShaderStore).GetShadersStore(shaderLanguage)[`${name}PixelShader`] = pixelShader;
        if (vertexShader) (0, $68BIi.ShaderStore).GetShadersStore(shaderLanguage)[`${name}VertexShader`] = vertexShader;
    }
    /**
     * Resets the cache of effects.
     */ static ResetCache() {
        $ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache = {};
    }
}
/**
 * Enable logging of the shader code when a compilation error occurs
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.LogShaderCodeOnCompilationError = true;
/**
 * Gets or sets a boolean indicating that effect ref counting is disabled
 * If true, the effect will persist in memory until engine is disposed
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.PersistentMode = false;
/**
 * Use this with caution
 * See ClearCodeCache function comments
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.AutomaticallyClearCodeCache = false;
$ff3dcf72127134d1$export$a32b0b1c1ac59d04._UniqueIdSeed = 0;
$ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache = {};
/**
 * Store of each shader (The can be looked up using effect.key)
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.ShadersStore = (0, $68BIi.ShaderStore).ShadersStore;
/**
 * Store of each included file for a shader (The can be looked up using effect.key)
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.IncludesShadersStore = (0, $68BIi.ShaderStore).IncludesShadersStore;

});
parcelRegister("68BIi", function(module, exports) {

$parcel$export(module.exports, "ShaderStore", () => $4780be8fe6bd1293$export$6ac25226e6db297b);
/**
 * Defines the shader related stores and directory
 */ class $4780be8fe6bd1293$export$6ac25226e6db297b {
    /**
     * Gets the shaders repository path for a given shader language
     * @param shaderLanguage the shader language
     * @returns the path to the shaders repository
     */ static GetShadersRepository(shaderLanguage = 0 /* ShaderLanguage.GLSL */ ) {
        return shaderLanguage === 0 /* ShaderLanguage.GLSL */  ? $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepository : $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepositoryWGSL;
    }
    /**
     * Gets the shaders store of a given shader language
     * @param shaderLanguage the shader language
     * @returns the shaders store
     */ static GetShadersStore(shaderLanguage = 0 /* ShaderLanguage.GLSL */ ) {
        return shaderLanguage === 0 /* ShaderLanguage.GLSL */  ? $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStore : $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStoreWGSL;
    }
    /**
     * Gets the include shaders store of a given shader language
     * @param shaderLanguage the shader language
     * @returns the include shaders store
     */ static GetIncludesShadersStore(shaderLanguage = 0 /* ShaderLanguage.GLSL */ ) {
        return shaderLanguage === 0 /* ShaderLanguage.GLSL */  ? $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStore : $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStoreWGSL;
    }
}
/**
 * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepository = "src/Shaders/";
/**
 * Store of each shader (The can be looked up using effect.key)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStore = {};
/**
 * Store of each included file for a shader (The can be looked up using effect.key)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStore = {};
/**
 * Gets or sets the relative url used to load shaders (WGSL) if using the engine in non-minified mode
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepositoryWGSL = "src/ShadersWGSL/";
/**
 * Store of each shader  (WGSL)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStoreWGSL = {};
/**
 * Store of each included file for a shader (WGSL)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStoreWGSL = {};

});

parcelRegister("4kP5d", function(module, exports) {

$parcel$export(module.exports, "getCachedPipeline", () => $3280a7b3d7b07b80$export$664502b7d2ed23);
$parcel$export(module.exports, "resetCachedPipeline", () => $3280a7b3d7b07b80$export$b4259563dff427ca);
$parcel$export(module.exports, "_processShaderCode", () => $3280a7b3d7b07b80$export$17d8dff66a8ab242);
$parcel$export(module.exports, "createAndPreparePipelineContext", () => $3280a7b3d7b07b80$export$d7c6cf0f1d149a31);

var $jFz47 = parcelRequire("jFz47");

var $d2IE3 = parcelRequire("d2IE3");

var $68BIi = parcelRequire("68BIi");

var $kVtWi = parcelRequire("kVtWi");

var $kbQ0z = parcelRequire("kbQ0z");

var $cOV0H = parcelRequire("cOV0H");
function $3280a7b3d7b07b80$export$664502b7d2ed23(name, context) {
    const stateObject = (0, $d2IE3.getStateObject)(context);
    return stateObject.cachedPipelines[name];
}
function $3280a7b3d7b07b80$export$b4259563dff427ca(pipeline) {
    const name = pipeline._name;
    const context = pipeline.context;
    if (name && context) {
        const stateObject = (0, $d2IE3.getStateObject)(context);
        const cachedPipeline = stateObject.cachedPipelines[name];
        cachedPipeline?.dispose();
        delete stateObject.cachedPipelines[name];
    }
}
function $3280a7b3d7b07b80$export$17d8dff66a8ab242(processorOptions, baseName, processFinalCode, onFinalCodeReady, shaderLanguage, engine, effectContext) {
    let vertexSource;
    let fragmentSource;
    // const baseName = this.name;
    const hostDocument = (0, $jFz47.IsWindowObjectExist)() ? engine?.getHostDocument() : null;
    if (typeof baseName === "string") vertexSource = baseName;
    else if (baseName.vertexSource) vertexSource = "source:" + baseName.vertexSource;
    else if (baseName.vertexElement) vertexSource = hostDocument?.getElementById(baseName.vertexElement) || baseName.vertexElement;
    else vertexSource = baseName.vertex || baseName;
    if (typeof baseName === "string") fragmentSource = baseName;
    else if (baseName.fragmentSource) fragmentSource = "source:" + baseName.fragmentSource;
    else if (baseName.fragmentElement) fragmentSource = hostDocument?.getElementById(baseName.fragmentElement) || baseName.fragmentElement;
    else fragmentSource = baseName.fragment || baseName;
    const shaderCodes = [
        undefined,
        undefined
    ];
    const shadersLoaded = ()=>{
        if (shaderCodes[0] && shaderCodes[1]) {
            processorOptions.isFragment = true;
            const [migratedVertexCode, fragmentCode] = shaderCodes;
            (0, $kbQ0z.Process)(fragmentCode, processorOptions, (migratedFragmentCode, codeBeforeMigration)=>{
                if (effectContext) effectContext._fragmentSourceCodeBeforeMigration = codeBeforeMigration;
                if (processFinalCode) migratedFragmentCode = processFinalCode("fragment", migratedFragmentCode);
                const finalShaders = (0, $kbQ0z.Finalize)(migratedVertexCode, migratedFragmentCode, processorOptions);
                processorOptions = null;
                const finalCode = $3280a7b3d7b07b80$var$_useFinalCode(finalShaders.vertexCode, finalShaders.fragmentCode, baseName, shaderLanguage);
                onFinalCodeReady?.(finalCode.vertexSourceCode, finalCode.fragmentSourceCode);
            }, engine);
        }
    };
    $3280a7b3d7b07b80$var$_loadShader(vertexSource, "Vertex", "", (vertexCode)=>{
        (0, $kbQ0z.Initialize)(processorOptions);
        (0, $kbQ0z.Process)(vertexCode, processorOptions, (migratedVertexCode, codeBeforeMigration)=>{
            if (effectContext) {
                effectContext._rawVertexSourceCode = vertexCode;
                effectContext._vertexSourceCodeBeforeMigration = codeBeforeMigration;
            }
            if (processFinalCode) migratedVertexCode = processFinalCode("vertex", migratedVertexCode);
            shaderCodes[0] = migratedVertexCode;
            shadersLoaded();
        }, engine);
    }, shaderLanguage);
    $3280a7b3d7b07b80$var$_loadShader(fragmentSource, "Fragment", "Pixel", (fragmentCode)=>{
        if (effectContext) effectContext._rawFragmentSourceCode = fragmentCode;
        shaderCodes[1] = fragmentCode;
        shadersLoaded();
    }, shaderLanguage);
}
function $3280a7b3d7b07b80$var$_loadShader(shader, key, optionalKey, callback, shaderLanguage, _loadFileInjection) {
    if (typeof HTMLElement !== "undefined") // DOM element ?
    {
        if (shader instanceof HTMLElement) {
            const shaderCode = (0, $jFz47.GetDOMTextContent)(shader);
            callback(shaderCode);
            return;
        }
    }
    // Direct source ?
    if (shader.substring(0, 7) === "source:") {
        callback(shader.substring(7));
        return;
    }
    // Base64 encoded ?
    if (shader.substring(0, 7) === "base64:") {
        const shaderBinary = window.atob(shader.substring(7));
        callback(shaderBinary);
        return;
    }
    const shaderStore = (0, $68BIi.ShaderStore).GetShadersStore(shaderLanguage);
    // Is in local store ?
    if (shaderStore[shader + key + "Shader"]) {
        callback(shaderStore[shader + key + "Shader"]);
        return;
    }
    if (optionalKey && shaderStore[shader + optionalKey + "Shader"]) {
        callback(shaderStore[shader + optionalKey + "Shader"]);
        return;
    }
    let shaderUrl;
    if (shader[0] === "." || shader[0] === "/" || shader.indexOf("http") > -1) shaderUrl = shader;
    else shaderUrl = (0, $68BIi.ShaderStore).GetShadersRepository(shaderLanguage) + shader;
    _loadFileInjection = _loadFileInjection || (0, $cOV0H._loadFile);
    if (!_loadFileInjection) // we got to this point and loadFile was not injected - throw an error
    throw new Error("loadFileInjection is not defined");
    // Vertex shader
    _loadFileInjection(shaderUrl + "." + key.toLowerCase() + ".fx", callback);
}
function $3280a7b3d7b07b80$var$_useFinalCode(migratedVertexCode, migratedFragmentCode, baseName, shaderLanguage) {
    if (baseName) {
        const vertex = baseName.vertexElement || baseName.vertex || baseName.spectorName || baseName;
        const fragment = baseName.fragmentElement || baseName.fragment || baseName.spectorName || baseName;
        return {
            vertexSourceCode: (shaderLanguage === 1 /* ShaderLanguage.WGSL */  ? "//" : "") + "#define SHADER_NAME vertex:" + vertex + "\n" + migratedVertexCode,
            fragmentSourceCode: (shaderLanguage === 1 /* ShaderLanguage.WGSL */  ? "//" : "") + "#define SHADER_NAME fragment:" + fragment + "\n" + migratedFragmentCode
        };
    } else return {
        vertexSourceCode: migratedVertexCode,
        fragmentSourceCode: migratedFragmentCode
    };
}
const $3280a7b3d7b07b80$export$d7c6cf0f1d149a31 = (options, createPipelineContext, _preparePipelineContext, _executeWhenRenderingStateIsCompiled)=>{
    try {
        const pipelineContext = options.existingPipelineContext || createPipelineContext(options.shaderProcessingContext);
        pipelineContext._name = options.name;
        if (options.name && options.context) {
            const stateObject = (0, $d2IE3.getStateObject)(options.context);
            stateObject.cachedPipelines[options.name] = pipelineContext;
        }
        // Flagged as async as we may need to delay load some processing tools
        // This does not break anything as the execution is waiting for _executeWhenRenderingStateIsCompiled
        _preparePipelineContext(pipelineContext, options.vertex, options.fragment, !!options.createAsRaw, "", "", options.rebuildRebind, options.defines, options.transformFeedbackVaryings, "", ()=>{
            _executeWhenRenderingStateIsCompiled(pipelineContext, ()=>{
                options.onRenderingStateCompiled?.(pipelineContext);
            });
        });
        return pipelineContext;
    } catch (e) {
        (0, $kVtWi.Logger).Error("Error compiling effect");
        throw e;
    }
};

});
parcelRegister("d2IE3", function(module, exports) {

$parcel$export(module.exports, "getStateObject", () => $97ee17d8ad4091fd$export$cc5869b674473b0);
$parcel$export(module.exports, "deleteStateObject", () => $97ee17d8ad4091fd$export$421561aa54f65ecc);
$parcel$export(module.exports, "createRawShaderProgram", () => $97ee17d8ad4091fd$export$ca6a74d58be4e8ff);
$parcel$export(module.exports, "_createShaderProgram", () => $97ee17d8ad4091fd$export$f49b94e4181cf9ef);
$parcel$export(module.exports, "createShaderProgram", () => $97ee17d8ad4091fd$export$6d22a9a84c4543f7);
$parcel$export(module.exports, "createPipelineContext", () => $97ee17d8ad4091fd$export$c20c8b2150a3e6fd);
$parcel$export(module.exports, "_finalizePipelineContext", () => $97ee17d8ad4091fd$export$6efa2f27ff323ec5);
$parcel$export(module.exports, "_isRenderingStateCompiled", () => $97ee17d8ad4091fd$export$626f20287b18b4df);
$parcel$export(module.exports, "_preparePipelineContext", () => $97ee17d8ad4091fd$export$9702659cafb5f6ed);
$parcel$export(module.exports, "_setProgram", () => $97ee17d8ad4091fd$export$322d2a5ff4609787);
$parcel$export(module.exports, "_executeWhenRenderingStateIsCompiled", () => $97ee17d8ad4091fd$export$d1849651f715a0e6);

var $d6QZE = parcelRequire("d6QZE");

var $cOV0H = parcelRequire("cOV0H");
/**
 * @internal
 */ const $97ee17d8ad4091fd$var$_stateObject = new WeakMap();
/**
 * This will be used in cases where the engine doesn't have a context (like the nullengine)
 */ const $97ee17d8ad4091fd$var$singleStateObject = {
    _webGLVersion: 2,
    cachedPipelines: {}
};
function $97ee17d8ad4091fd$export$cc5869b674473b0(context) {
    let state = $97ee17d8ad4091fd$var$_stateObject.get(context);
    if (!state) {
        if (!context) return $97ee17d8ad4091fd$var$singleStateObject;
        state = {
            // use feature detection. instanceof returns false. This only exists on WebGL2 context
            _webGLVersion: context.TEXTURE_BINDING_3D ? 2 : 1,
            _context: context,
            // when using the function without an engine we need to set it to enable parallel compilation
            parallelShaderCompile: context.getExtension("KHR_parallel_shader_compile") || undefined,
            cachedPipelines: {}
        };
        $97ee17d8ad4091fd$var$_stateObject.set(context, state);
    }
    return state;
}
function $97ee17d8ad4091fd$export$421561aa54f65ecc(context) {
    $97ee17d8ad4091fd$var$_stateObject.delete(context);
}
function $97ee17d8ad4091fd$export$ca6a74d58be4e8ff(pipelineContext, vertexCode, fragmentCode, context, transformFeedbackVaryings, _createShaderProgramInjection) {
    const stateObject = $97ee17d8ad4091fd$export$cc5869b674473b0(context);
    if (!_createShaderProgramInjection) _createShaderProgramInjection = stateObject._createShaderProgramInjection ?? $97ee17d8ad4091fd$export$f49b94e4181cf9ef;
    const vertexShader = $97ee17d8ad4091fd$var$_compileRawShader(vertexCode, "vertex", context, stateObject._contextWasLost);
    const fragmentShader = $97ee17d8ad4091fd$var$_compileRawShader(fragmentCode, "fragment", context, stateObject._contextWasLost);
    return _createShaderProgramInjection(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings, stateObject.validateShaderPrograms);
}
function $97ee17d8ad4091fd$export$6d22a9a84c4543f7(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null, _createShaderProgramInjection) {
    const stateObject = $97ee17d8ad4091fd$export$cc5869b674473b0(context);
    if (!_createShaderProgramInjection) _createShaderProgramInjection = stateObject._createShaderProgramInjection ?? $97ee17d8ad4091fd$export$f49b94e4181cf9ef;
    const shaderVersion = stateObject._webGLVersion > 1 ? "#version 300 es\n#define WEBGL2 \n" : "";
    const vertexShader = $97ee17d8ad4091fd$var$_compileShader(vertexCode, "vertex", defines, shaderVersion, context, stateObject._contextWasLost);
    const fragmentShader = $97ee17d8ad4091fd$var$_compileShader(fragmentCode, "fragment", defines, shaderVersion, context, stateObject._contextWasLost);
    return _createShaderProgramInjection(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings, stateObject.validateShaderPrograms);
}
function $97ee17d8ad4091fd$export$c20c8b2150a3e6fd(context, _shaderProcessingContext) {
    const pipelineContext = new (0, $d6QZE.WebGLPipelineContext)();
    const stateObject = $97ee17d8ad4091fd$export$cc5869b674473b0(context);
    if (stateObject.parallelShaderCompile) pipelineContext.isParallelCompiled = true;
    pipelineContext.context = stateObject._context;
    return pipelineContext;
}
function $97ee17d8ad4091fd$export$f49b94e4181cf9ef(pipelineContext, vertexShader, fragmentShader, context, _transformFeedbackVaryings = null, validateShaderPrograms) {
    const shaderProgram = context.createProgram();
    pipelineContext.program = shaderProgram;
    if (!shaderProgram) throw new Error("Unable to create program");
    context.attachShader(shaderProgram, vertexShader);
    context.attachShader(shaderProgram, fragmentShader);
    context.linkProgram(shaderProgram);
    pipelineContext.context = context;
    pipelineContext.vertexShader = vertexShader;
    pipelineContext.fragmentShader = fragmentShader;
    if (!pipelineContext.isParallelCompiled) $97ee17d8ad4091fd$export$6efa2f27ff323ec5(pipelineContext, context, validateShaderPrograms);
    return shaderProgram;
}
function $97ee17d8ad4091fd$export$626f20287b18b4df(pipelineContext, gl, validateShaderPrograms) {
    const webGLPipelineContext = pipelineContext;
    if (webGLPipelineContext._isDisposed) return false;
    const stateObject = $97ee17d8ad4091fd$export$cc5869b674473b0(gl);
    if (gl.getProgramParameter(webGLPipelineContext.program, stateObject.parallelShaderCompile.COMPLETION_STATUS_KHR)) {
        $97ee17d8ad4091fd$export$6efa2f27ff323ec5(webGLPipelineContext, gl, validateShaderPrograms);
        return true;
    }
    return false;
}
function $97ee17d8ad4091fd$export$6efa2f27ff323ec5(pipelineContext, gl, validateShaderPrograms) {
    const context = pipelineContext.context;
    const vertexShader = pipelineContext.vertexShader;
    const fragmentShader = pipelineContext.fragmentShader;
    const program = pipelineContext.program;
    const linked = context.getProgramParameter(program, context.LINK_STATUS);
    if (!linked) {
        // Get more info
        // Vertex
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
            const log = gl.getShaderInfoLog(vertexShader);
            if (log) {
                pipelineContext.vertexCompilationError = log;
                throw new Error("VERTEX SHADER " + log);
            }
        }
        // Fragment
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
            const log = gl.getShaderInfoLog(fragmentShader);
            if (log) {
                pipelineContext.fragmentCompilationError = log;
                throw new Error("FRAGMENT SHADER " + log);
            }
        }
        const error = context.getProgramInfoLog(program);
        if (error) {
            pipelineContext.programLinkError = error;
            throw new Error(error);
        }
    }
    if (/*this.*/ validateShaderPrograms) {
        context.validateProgram(program);
        const validated = context.getProgramParameter(program, context.VALIDATE_STATUS);
        if (!validated) {
            const error = context.getProgramInfoLog(program);
            if (error) {
                pipelineContext.programValidationError = error;
                throw new Error(error);
            }
        }
    }
    context.deleteShader(vertexShader);
    context.deleteShader(fragmentShader);
    pipelineContext.vertexShader = undefined;
    pipelineContext.fragmentShader = undefined;
    if (pipelineContext.onCompiled) {
        pipelineContext.onCompiled();
        pipelineContext.onCompiled = undefined;
    }
}
function $97ee17d8ad4091fd$export$9702659cafb5f6ed(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, _rawVertexSourceCode, _rawFragmentSourceCode, rebuildRebind, defines, transformFeedbackVaryings, _key = "", onReady, createRawShaderProgramInjection, createShaderProgramInjection) {
    const stateObject = $97ee17d8ad4091fd$export$cc5869b674473b0(pipelineContext.context);
    if (!createRawShaderProgramInjection) createRawShaderProgramInjection = stateObject.createRawShaderProgramInjection ?? $97ee17d8ad4091fd$export$ca6a74d58be4e8ff;
    if (!createShaderProgramInjection) createShaderProgramInjection = stateObject.createShaderProgramInjection ?? $97ee17d8ad4091fd$export$6d22a9a84c4543f7;
    const webGLRenderingState = pipelineContext;
    if (createAsRaw) webGLRenderingState.program = createRawShaderProgramInjection(webGLRenderingState, vertexSourceCode, fragmentSourceCode, webGLRenderingState.context, transformFeedbackVaryings);
    else webGLRenderingState.program = createShaderProgramInjection(webGLRenderingState, vertexSourceCode, fragmentSourceCode, defines, webGLRenderingState.context, transformFeedbackVaryings);
    webGLRenderingState.program.__SPECTOR_rebuildProgram = rebuildRebind;
    onReady();
}
function $97ee17d8ad4091fd$var$_compileShader(source, type, defines, shaderVersion, gl, _contextWasLost) {
    return $97ee17d8ad4091fd$var$_compileRawShader((0, $cOV0H._ConcatenateShader)(source, defines, shaderVersion), type, gl, _contextWasLost);
}
function $97ee17d8ad4091fd$var$_compileRawShader(source, type, gl, _contextWasLost) {
    const shader = gl.createShader(type === "vertex" ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
    if (!shader) {
        let error = gl.NO_ERROR;
        let tempError = gl.NO_ERROR;
        while((tempError = gl.getError()) !== gl.NO_ERROR)error = tempError;
        throw new Error(`Something went wrong while creating a gl ${type} shader object. gl error=${error}, gl isContextLost=${gl.isContextLost()}, _contextWasLost=${_contextWasLost}`);
    }
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    return shader;
}
function $97ee17d8ad4091fd$export$322d2a5ff4609787(program, gl) {
    gl.useProgram(program);
}
function $97ee17d8ad4091fd$export$d1849651f715a0e6(pipelineContext, action) {
    const webGLPipelineContext = pipelineContext;
    if (!webGLPipelineContext.isParallelCompiled) {
        action(pipelineContext);
        return;
    }
    const oldHandler = webGLPipelineContext.onCompiled;
    webGLPipelineContext.onCompiled = ()=>{
        oldHandler?.();
        action(pipelineContext);
    };
}

});
parcelRegister("d6QZE", function(module, exports) {

$parcel$export(module.exports, "WebGLPipelineContext", () => $98b4f146d346ac54$export$857e3c69c4543d13);
/** @internal */ class $98b4f146d346ac54$export$857e3c69c4543d13 {
    constructor(){
        this._valueCache = {};
        this.vertexCompilationError = null;
        this.fragmentCompilationError = null;
        this.programLinkError = null;
        this.programValidationError = null;
        /** @internal */ this._isDisposed = false;
    }
    get isAsync() {
        return this.isParallelCompiled;
    }
    get isReady() {
        if (this.program) {
            if (this.isParallelCompiled) return this.engine._isRenderingStateCompiled(this);
            return true;
        }
        return false;
    }
    _handlesSpectorRebuildCallback(onCompiled) {
        if (onCompiled && this.program) onCompiled(this.program);
    }
    setEngine(engine) {
        this.engine = engine;
    }
    _fillEffectInformation(effect, uniformBuffersNames, uniformsNames, uniforms, samplerList, samplers, attributesNames, attributes) {
        const engine = this.engine;
        if (engine.supportsUniformBuffers) for(const name in uniformBuffersNames)effect.bindUniformBlock(name, uniformBuffersNames[name]);
        const effectAvailableUniforms = this.engine.getUniforms(this, uniformsNames);
        effectAvailableUniforms.forEach((uniform, index)=>{
            uniforms[uniformsNames[index]] = uniform;
        });
        this._uniforms = uniforms;
        let index;
        for(index = 0; index < samplerList.length; index++){
            const sampler = effect.getUniform(samplerList[index]);
            if (sampler == null) {
                samplerList.splice(index, 1);
                index--;
            }
        }
        samplerList.forEach((name, index)=>{
            samplers[name] = index;
        });
        for (const attr of engine.getAttributes(this, attributesNames))attributes.push(attr);
    }
    /**
     * Release all associated resources.
     **/ dispose() {
        this._uniforms = {};
        this._isDisposed = true;
    }
    /**
     * @internal
     */ _cacheMatrix(uniformName, matrix) {
        const cache = this._valueCache[uniformName];
        const flag = matrix.updateFlag;
        if (cache !== undefined && cache === flag) return false;
        this._valueCache[uniformName] = flag;
        return true;
    }
    /**
     * @internal
     */ _cacheFloat2(uniformName, x, y) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 2) {
            cache = [
                x,
                y
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        return changed;
    }
    /**
     * @internal
     */ _cacheFloat3(uniformName, x, y, z) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 3) {
            cache = [
                x,
                y,
                z
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        if (cache[2] !== z) {
            cache[2] = z;
            changed = true;
        }
        return changed;
    }
    /**
     * @internal
     */ _cacheFloat4(uniformName, x, y, z, w) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 4) {
            cache = [
                x,
                y,
                z,
                w
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        if (cache[2] !== z) {
            cache[2] = z;
            changed = true;
        }
        if (cache[3] !== w) {
            cache[3] = w;
            changed = true;
        }
        return changed;
    }
    /**
     * Sets an integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this.engine.setInt(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a int2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int2.
     * @param y Second int in int2.
     */ setInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this.engine.setInt2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a int3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int3.
     * @param y Second int in int3.
     * @param z Third int in int3.
     */ setInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this.engine.setInt3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a int4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int4.
     * @param y Second int in int4.
     * @param z Third int in int4.
     * @param w Fourth int in int4.
     */ setInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this.engine.setInt4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setUInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this.engine.setUInt(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets an unsigned int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint2.
     * @param y Second unsigned int in uint2.
     */ setUInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this.engine.setUInt2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint3.
     * @param y Second unsigned int in uint3.
     * @param z Third unsigned int in uint3.
     */ setUInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this.engine.setUInt3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint4.
     * @param y Second unsigned int in uint4.
     * @param z Third unsigned int in uint4.
     * @param w Fourth unsigned int in uint4.
     */ setUInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this.engine.setUInt4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets matrices on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrices matrices to be set.
     */ setMatrices(uniformName, matrices) {
        if (!matrices) return;
        this._valueCache[uniformName] = null;
        this.engine.setMatrices(this._uniforms[uniformName], matrices);
    }
    /**
     * Sets matrix on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix(uniformName, matrix) {
        if (this._cacheMatrix(uniformName, matrix)) {
            if (!this.engine.setMatrices(this._uniforms[uniformName], matrix.asArray())) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix3x3(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this.engine.setMatrix3x3(this._uniforms[uniformName], matrix);
    }
    /**
     * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix2x2(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this.engine.setMatrix2x2(this._uniforms[uniformName], matrix);
    }
    /**
     * Sets a float on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value value to be set.
     */ setFloat(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this.engine.setFloat(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a Vector2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector2 vector2 to be set.
     */ setVector2(uniformName, vector2) {
        if (this._cacheFloat2(uniformName, vector2.x, vector2.y)) {
            if (!this.engine.setFloat2(this._uniforms[uniformName], vector2.x, vector2.y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float2.
     * @param y Second float in float2.
     */ setFloat2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this.engine.setFloat2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Vector3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector3 Value to be set.
     */ setVector3(uniformName, vector3) {
        if (this._cacheFloat3(uniformName, vector3.x, vector3.y, vector3.z)) {
            if (!this.engine.setFloat3(this._uniforms[uniformName], vector3.x, vector3.y, vector3.z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float3.
     * @param y Second float in float3.
     * @param z Third float in float3.
     */ setFloat3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this.engine.setFloat3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Vector4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector4 Value to be set.
     */ setVector4(uniformName, vector4) {
        if (this._cacheFloat4(uniformName, vector4.x, vector4.y, vector4.z, vector4.w)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], vector4.x, vector4.y, vector4.z, vector4.w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Quaternion on a uniform variable.
     * @param uniformName Name of the variable.
     * @param quaternion Value to be set.
     */ setQuaternion(uniformName, quaternion) {
        if (this._cacheFloat4(uniformName, quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], quaternion.x, quaternion.y, quaternion.z, quaternion.w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float4.
     * @param y Second float in float4.
     * @param z Third float in float4.
     * @param w Fourth float in float4.
     */ setFloat4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     */ setColor3(uniformName, color3) {
        if (this._cacheFloat3(uniformName, color3.r, color3.g, color3.b)) {
            if (!this.engine.setFloat3(this._uniforms[uniformName], color3.r, color3.g, color3.b)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @param alpha Alpha value to be set.
     */ setColor4(uniformName, color3, alpha) {
        if (this._cacheFloat4(uniformName, color3.r, color3.g, color3.b, alpha)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], color3.r, color3.g, color3.b, alpha)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color4 on a uniform variable
     * @param uniformName defines the name of the variable
     * @param color4 defines the value to be set
     */ setDirectColor4(uniformName, color4) {
        if (this._cacheFloat4(uniformName, color4.r, color4.g, color4.b, color4.a)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], color4.r, color4.g, color4.b, color4.a)) this._valueCache[uniformName] = null;
        }
    }
    _getVertexShaderCode() {
        return this.vertexShader ? this.engine._getShaderSource(this.vertexShader) : null;
    }
    _getFragmentShaderCode() {
        return this.fragmentShader ? this.engine._getShaderSource(this.fragmentShader) : null;
    }
}

});




parcelRegister("3agwF", function(module, exports) {

$parcel$export(module.exports, "PerformanceConfigurator", () => $24df1ffa5ae52c50$export$d3f2aa2665f671ec);
/** @internal */ class $24df1ffa5ae52c50$export$d3f2aa2665f671ec {
    /**
     * @internal
     */ static SetMatrixPrecision(use64bits) {
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackPrecisionChange = false;
        if (use64bits && !$24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits) {
            if ($24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices) for(let m = 0; m < $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices.length; ++m){
                const matrix = $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices[m];
                const values = matrix._m;
                matrix._m = new Array(16);
                for(let i = 0; i < 16; ++i)matrix._m[i] = values[i];
            }
        }
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits = use64bits;
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixCurrentType = $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits ? Array : Float32Array;
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices = null; // reclaim some memory, as we don't need _TrackedMatrices anymore
    }
}
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits = false;
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackPrecisionChange = true;
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixCurrentType = Float32Array;
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices = [];

});

parcelRegister("36XJ5", function(module, exports) {

$parcel$export(module.exports, "DepthCullingState", () => $2440430a59d4103a$export$59ff886bea753bad);
/**
 * @internal
 **/ class $2440430a59d4103a$export$59ff886bea753bad {
    /**
     * Initializes the state.
     * @param reset
     */ constructor(reset = true){
        this._isDepthTestDirty = false;
        this._isDepthMaskDirty = false;
        this._isDepthFuncDirty = false;
        this._isCullFaceDirty = false;
        this._isCullDirty = false;
        this._isZOffsetDirty = false;
        this._isFrontFaceDirty = false;
        if (reset) this.reset();
    }
    get isDirty() {
        return this._isDepthFuncDirty || this._isDepthTestDirty || this._isDepthMaskDirty || this._isCullFaceDirty || this._isCullDirty || this._isZOffsetDirty || this._isFrontFaceDirty;
    }
    get zOffset() {
        return this._zOffset;
    }
    set zOffset(value) {
        if (this._zOffset === value) return;
        this._zOffset = value;
        this._isZOffsetDirty = true;
    }
    get zOffsetUnits() {
        return this._zOffsetUnits;
    }
    set zOffsetUnits(value) {
        if (this._zOffsetUnits === value) return;
        this._zOffsetUnits = value;
        this._isZOffsetDirty = true;
    }
    get cullFace() {
        return this._cullFace;
    }
    set cullFace(value) {
        if (this._cullFace === value) return;
        this._cullFace = value;
        this._isCullFaceDirty = true;
    }
    get cull() {
        return this._cull;
    }
    set cull(value) {
        if (this._cull === value) return;
        this._cull = value;
        this._isCullDirty = true;
    }
    get depthFunc() {
        return this._depthFunc;
    }
    set depthFunc(value) {
        if (this._depthFunc === value) return;
        this._depthFunc = value;
        this._isDepthFuncDirty = true;
    }
    get depthMask() {
        return this._depthMask;
    }
    set depthMask(value) {
        if (this._depthMask === value) return;
        this._depthMask = value;
        this._isDepthMaskDirty = true;
    }
    get depthTest() {
        return this._depthTest;
    }
    set depthTest(value) {
        if (this._depthTest === value) return;
        this._depthTest = value;
        this._isDepthTestDirty = true;
    }
    get frontFace() {
        return this._frontFace;
    }
    set frontFace(value) {
        if (this._frontFace === value) return;
        this._frontFace = value;
        this._isFrontFaceDirty = true;
    }
    reset() {
        this._depthMask = true;
        this._depthTest = true;
        this._depthFunc = null;
        this._cullFace = null;
        this._cull = null;
        this._zOffset = 0;
        this._zOffsetUnits = 0;
        this._frontFace = null;
        this._isDepthTestDirty = true;
        this._isDepthMaskDirty = true;
        this._isDepthFuncDirty = false;
        this._isCullFaceDirty = false;
        this._isCullDirty = false;
        this._isZOffsetDirty = true;
        this._isFrontFaceDirty = false;
    }
    apply(gl) {
        if (!this.isDirty) return;
        // Cull
        if (this._isCullDirty) {
            if (this.cull) gl.enable(gl.CULL_FACE);
            else gl.disable(gl.CULL_FACE);
            this._isCullDirty = false;
        }
        // Cull face
        if (this._isCullFaceDirty) {
            gl.cullFace(this.cullFace);
            this._isCullFaceDirty = false;
        }
        // Depth mask
        if (this._isDepthMaskDirty) {
            gl.depthMask(this.depthMask);
            this._isDepthMaskDirty = false;
        }
        // Depth test
        if (this._isDepthTestDirty) {
            if (this.depthTest) gl.enable(gl.DEPTH_TEST);
            else gl.disable(gl.DEPTH_TEST);
            this._isDepthTestDirty = false;
        }
        // Depth func
        if (this._isDepthFuncDirty) {
            gl.depthFunc(this.depthFunc);
            this._isDepthFuncDirty = false;
        }
        // zOffset
        if (this._isZOffsetDirty) {
            if (this.zOffset || this.zOffsetUnits) {
                gl.enable(gl.POLYGON_OFFSET_FILL);
                gl.polygonOffset(this.zOffset, this.zOffsetUnits);
            } else gl.disable(gl.POLYGON_OFFSET_FILL);
            this._isZOffsetDirty = false;
        }
        // Front face
        if (this._isFrontFaceDirty) {
            gl.frontFace(this.frontFace);
            this._isFrontFaceDirty = false;
        }
    }
}

});

parcelRegister("cyIBx", function(module, exports) {

$parcel$export(module.exports, "StencilStateComposer", () => $924b4284f24e5b9b$export$34fb0697ec4ab56b);
/**
 * @internal
 **/ class $924b4284f24e5b9b$export$34fb0697ec4ab56b {
    get isDirty() {
        return this._isStencilTestDirty || this._isStencilMaskDirty || this._isStencilFuncDirty || this._isStencilOpDirty;
    }
    get func() {
        return this._func;
    }
    set func(value) {
        if (this._func === value) return;
        this._func = value;
        this._isStencilFuncDirty = true;
    }
    get funcRef() {
        return this._funcRef;
    }
    set funcRef(value) {
        if (this._funcRef === value) return;
        this._funcRef = value;
        this._isStencilFuncDirty = true;
    }
    get funcMask() {
        return this._funcMask;
    }
    set funcMask(value) {
        if (this._funcMask === value) return;
        this._funcMask = value;
        this._isStencilFuncDirty = true;
    }
    get opStencilFail() {
        return this._opStencilFail;
    }
    set opStencilFail(value) {
        if (this._opStencilFail === value) return;
        this._opStencilFail = value;
        this._isStencilOpDirty = true;
    }
    get opDepthFail() {
        return this._opDepthFail;
    }
    set opDepthFail(value) {
        if (this._opDepthFail === value) return;
        this._opDepthFail = value;
        this._isStencilOpDirty = true;
    }
    get opStencilDepthPass() {
        return this._opStencilDepthPass;
    }
    set opStencilDepthPass(value) {
        if (this._opStencilDepthPass === value) return;
        this._opStencilDepthPass = value;
        this._isStencilOpDirty = true;
    }
    get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask === value) return;
        this._mask = value;
        this._isStencilMaskDirty = true;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled === value) return;
        this._enabled = value;
        this._isStencilTestDirty = true;
    }
    constructor(reset = true){
        this._isStencilTestDirty = false;
        this._isStencilMaskDirty = false;
        this._isStencilFuncDirty = false;
        this._isStencilOpDirty = false;
        this.useStencilGlobalOnly = false;
        if (reset) this.reset();
    }
    reset() {
        this.stencilMaterial = undefined;
        this.stencilGlobal?.reset();
        this._isStencilTestDirty = true;
        this._isStencilMaskDirty = true;
        this._isStencilFuncDirty = true;
        this._isStencilOpDirty = true;
    }
    apply(gl) {
        if (!gl) return;
        const stencilMaterialEnabled = !this.useStencilGlobalOnly && !!this.stencilMaterial?.enabled;
        this.enabled = stencilMaterialEnabled ? this.stencilMaterial.enabled : this.stencilGlobal.enabled;
        this.func = stencilMaterialEnabled ? this.stencilMaterial.func : this.stencilGlobal.func;
        this.funcRef = stencilMaterialEnabled ? this.stencilMaterial.funcRef : this.stencilGlobal.funcRef;
        this.funcMask = stencilMaterialEnabled ? this.stencilMaterial.funcMask : this.stencilGlobal.funcMask;
        this.opStencilFail = stencilMaterialEnabled ? this.stencilMaterial.opStencilFail : this.stencilGlobal.opStencilFail;
        this.opDepthFail = stencilMaterialEnabled ? this.stencilMaterial.opDepthFail : this.stencilGlobal.opDepthFail;
        this.opStencilDepthPass = stencilMaterialEnabled ? this.stencilMaterial.opStencilDepthPass : this.stencilGlobal.opStencilDepthPass;
        this.mask = stencilMaterialEnabled ? this.stencilMaterial.mask : this.stencilGlobal.mask;
        if (!this.isDirty) return;
        // Stencil test
        if (this._isStencilTestDirty) {
            if (this.enabled) gl.enable(gl.STENCIL_TEST);
            else gl.disable(gl.STENCIL_TEST);
            this._isStencilTestDirty = false;
        }
        // Stencil mask
        if (this._isStencilMaskDirty) {
            gl.stencilMask(this.mask);
            this._isStencilMaskDirty = false;
        }
        // Stencil func
        if (this._isStencilFuncDirty) {
            gl.stencilFunc(this.func, this.funcRef, this.funcMask);
            this._isStencilFuncDirty = false;
        }
        // Stencil op
        if (this._isStencilOpDirty) {
            gl.stencilOp(this.opStencilFail, this.opDepthFail, this.opStencilDepthPass);
            this._isStencilOpDirty = false;
        }
    }
}

});

parcelRegister("d7F9z", function(module, exports) {

$parcel$export(module.exports, "StencilState", () => $98dbd9fe343661e2$export$6e15af2dccca9cb6);
/**
 * @internal
 **/ class $98dbd9fe343661e2$export$6e15af2dccca9cb6 {
    constructor(){
        this.reset();
    }
    reset() {
        this.enabled = false;
        this.mask = 0xff;
        this.func = $98dbd9fe343661e2$export$6e15af2dccca9cb6.ALWAYS;
        this.funcRef = 1;
        this.funcMask = 0xff;
        this.opStencilFail = $98dbd9fe343661e2$export$6e15af2dccca9cb6.KEEP;
        this.opDepthFail = $98dbd9fe343661e2$export$6e15af2dccca9cb6.KEEP;
        this.opStencilDepthPass = $98dbd9fe343661e2$export$6e15af2dccca9cb6.REPLACE;
    }
    get stencilFunc() {
        return this.func;
    }
    set stencilFunc(value) {
        this.func = value;
    }
    get stencilFuncRef() {
        return this.funcRef;
    }
    set stencilFuncRef(value) {
        this.funcRef = value;
    }
    get stencilFuncMask() {
        return this.funcMask;
    }
    set stencilFuncMask(value) {
        this.funcMask = value;
    }
    get stencilOpStencilFail() {
        return this.opStencilFail;
    }
    set stencilOpStencilFail(value) {
        this.opStencilFail = value;
    }
    get stencilOpDepthFail() {
        return this.opDepthFail;
    }
    set stencilOpDepthFail(value) {
        this.opDepthFail = value;
    }
    get stencilOpStencilDepthPass() {
        return this.opStencilDepthPass;
    }
    set stencilOpStencilDepthPass(value) {
        this.opStencilDepthPass = value;
    }
    get stencilMask() {
        return this.mask;
    }
    set stencilMask(value) {
        this.mask = value;
    }
    get stencilTest() {
        return this.enabled;
    }
    set stencilTest(value) {
        this.enabled = value;
    }
}
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */ $98dbd9fe343661e2$export$6e15af2dccca9cb6.ALWAYS = 519;
/** Passed to stencilOperation to specify that stencil value must be kept */ $98dbd9fe343661e2$export$6e15af2dccca9cb6.KEEP = 7680;
/** Passed to stencilOperation to specify that stencil value must be replaced */ $98dbd9fe343661e2$export$6e15af2dccca9cb6.REPLACE = 7681;

});

parcelRegister("ano9R", function(module, exports) {

$parcel$export(module.exports, "AlphaState", () => $78decaa178ba2683$export$366126238ef23200);
/**
 * @internal
 **/ class $78decaa178ba2683$export$366126238ef23200 {
    /**
     * Initializes the state.
     */ constructor(){
        this._blendFunctionParameters = new Array(4);
        this._blendEquationParameters = new Array(2);
        this._blendConstants = new Array(4);
        this._isBlendConstantsDirty = false;
        this._alphaBlend = false;
        this._isAlphaBlendDirty = false;
        this._isBlendFunctionParametersDirty = false;
        this._isBlendEquationParametersDirty = false;
        this.reset();
    }
    get isDirty() {
        return this._isAlphaBlendDirty || this._isBlendFunctionParametersDirty || this._isBlendEquationParametersDirty;
    }
    get alphaBlend() {
        return this._alphaBlend;
    }
    set alphaBlend(value) {
        if (this._alphaBlend === value) return;
        this._alphaBlend = value;
        this._isAlphaBlendDirty = true;
    }
    setAlphaBlendConstants(r, g, b, a) {
        if (this._blendConstants[0] === r && this._blendConstants[1] === g && this._blendConstants[2] === b && this._blendConstants[3] === a) return;
        this._blendConstants[0] = r;
        this._blendConstants[1] = g;
        this._blendConstants[2] = b;
        this._blendConstants[3] = a;
        this._isBlendConstantsDirty = true;
    }
    setAlphaBlendFunctionParameters(value0, value1, value2, value3) {
        if (this._blendFunctionParameters[0] === value0 && this._blendFunctionParameters[1] === value1 && this._blendFunctionParameters[2] === value2 && this._blendFunctionParameters[3] === value3) return;
        this._blendFunctionParameters[0] = value0;
        this._blendFunctionParameters[1] = value1;
        this._blendFunctionParameters[2] = value2;
        this._blendFunctionParameters[3] = value3;
        this._isBlendFunctionParametersDirty = true;
    }
    setAlphaEquationParameters(rgb, alpha) {
        if (this._blendEquationParameters[0] === rgb && this._blendEquationParameters[1] === alpha) return;
        this._blendEquationParameters[0] = rgb;
        this._blendEquationParameters[1] = alpha;
        this._isBlendEquationParametersDirty = true;
    }
    reset() {
        this._alphaBlend = false;
        this._blendFunctionParameters[0] = null;
        this._blendFunctionParameters[1] = null;
        this._blendFunctionParameters[2] = null;
        this._blendFunctionParameters[3] = null;
        this._blendEquationParameters[0] = null;
        this._blendEquationParameters[1] = null;
        this._blendConstants[0] = null;
        this._blendConstants[1] = null;
        this._blendConstants[2] = null;
        this._blendConstants[3] = null;
        this._isAlphaBlendDirty = true;
        this._isBlendFunctionParametersDirty = false;
        this._isBlendEquationParametersDirty = false;
        this._isBlendConstantsDirty = false;
    }
    apply(gl) {
        if (!this.isDirty) return;
        // Alpha blend
        if (this._isAlphaBlendDirty) {
            if (this._alphaBlend) gl.enable(gl.BLEND);
            else gl.disable(gl.BLEND);
            this._isAlphaBlendDirty = false;
        }
        // Alpha function
        if (this._isBlendFunctionParametersDirty) {
            gl.blendFuncSeparate(this._blendFunctionParameters[0], this._blendFunctionParameters[1], this._blendFunctionParameters[2], this._blendFunctionParameters[3]);
            this._isBlendFunctionParametersDirty = false;
        }
        // Alpha equation
        if (this._isBlendEquationParametersDirty) {
            gl.blendEquationSeparate(this._blendEquationParameters[0], this._blendEquationParameters[1]);
            this._isBlendEquationParametersDirty = false;
        }
        // Constants
        if (this._isBlendConstantsDirty) {
            gl.blendColor(this._blendConstants[0], this._blendConstants[1], this._blendConstants[2], this._blendConstants[3]);
            this._isBlendConstantsDirty = false;
        }
    }
}

});

parcelRegister("b9e4a", function(module, exports) {

$parcel$export(module.exports, "InternalTexture", () => $81db7240fd7885fc$export$3ab99feff1488737);

var $diGQf = parcelRequire("diGQf");

var $bEkJJ = parcelRequire("bEkJJ");
var $81db7240fd7885fc$export$63176c729abdb17f;
(function(InternalTextureSource) {
    /**
     * The source of the texture data is unknown
     */ InternalTextureSource[InternalTextureSource["Unknown"] = 0] = "Unknown";
    /**
     * Texture data comes from an URL
     */ InternalTextureSource[InternalTextureSource["Url"] = 1] = "Url";
    /**
     * Texture data is only used for temporary storage
     */ InternalTextureSource[InternalTextureSource["Temp"] = 2] = "Temp";
    /**
     * Texture data comes from raw data (ArrayBuffer)
     */ InternalTextureSource[InternalTextureSource["Raw"] = 3] = "Raw";
    /**
     * Texture content is dynamic (video or dynamic texture)
     */ InternalTextureSource[InternalTextureSource["Dynamic"] = 4] = "Dynamic";
    /**
     * Texture content is generated by rendering to it
     */ InternalTextureSource[InternalTextureSource["RenderTarget"] = 5] = "RenderTarget";
    /**
     * Texture content is part of a multi render target process
     */ InternalTextureSource[InternalTextureSource["MultiRenderTarget"] = 6] = "MultiRenderTarget";
    /**
     * Texture data comes from a cube data file
     */ InternalTextureSource[InternalTextureSource["Cube"] = 7] = "Cube";
    /**
     * Texture data comes from a raw cube data
     */ InternalTextureSource[InternalTextureSource["CubeRaw"] = 8] = "CubeRaw";
    /**
     * Texture data come from a prefiltered cube data file
     */ InternalTextureSource[InternalTextureSource["CubePrefiltered"] = 9] = "CubePrefiltered";
    /**
     * Texture content is raw 3D data
     */ InternalTextureSource[InternalTextureSource["Raw3D"] = 10] = "Raw3D";
    /**
     * Texture content is raw 2D array data
     */ InternalTextureSource[InternalTextureSource["Raw2DArray"] = 11] = "Raw2DArray";
    /**
     * Texture content is a depth/stencil texture
     */ InternalTextureSource[InternalTextureSource["DepthStencil"] = 12] = "DepthStencil";
    /**
     * Texture data comes from a raw cube data encoded with RGBD
     */ InternalTextureSource[InternalTextureSource["CubeRawRGBD"] = 13] = "CubeRawRGBD";
    /**
     * Texture content is a depth texture
     */ InternalTextureSource[InternalTextureSource["Depth"] = 14] = "Depth";
})($81db7240fd7885fc$export$63176c729abdb17f || ($81db7240fd7885fc$export$63176c729abdb17f = {}));
class $81db7240fd7885fc$export$3ab99feff1488737 extends (0, $bEkJJ.TextureSampler) {
    /**
     * Gets a boolean indicating if the texture uses mipmaps
     * TODO implements useMipMaps as a separate setting from generateMipMaps
     */ get useMipMaps() {
        return this.generateMipMaps;
    }
    set useMipMaps(value) {
        this.generateMipMaps = value;
    }
    /** Gets the unique id of the internal texture */ get uniqueId() {
        return this._uniqueId;
    }
    /** @internal */ _setUniqueId(id) {
        this._uniqueId = id;
    }
    /**
     * Gets the Engine the texture belongs to.
     * @returns The babylon engine
     */ getEngine() {
        return this._engine;
    }
    /**
     * Gets the data source type of the texture
     */ get source() {
        return this._source;
    }
    /**
     * Creates a new InternalTexture
     * @param engine defines the engine to use
     * @param source defines the type of data that will be used
     * @param delayAllocation if the texture allocation should be delayed (default: false)
     */ constructor(engine, source, delayAllocation = false){
        super();
        /**
         * Defines if the texture is ready
         */ this.isReady = false;
        /**
         * Defines if the texture is a cube texture
         */ this.isCube = false;
        /**
         * Defines if the texture contains 3D data
         */ this.is3D = false;
        /**
         * Defines if the texture contains 2D array data
         */ this.is2DArray = false;
        /**
         * Defines if the texture contains multiview data
         */ this.isMultiview = false;
        /**
         * Gets the URL used to load this texture
         */ this.url = "";
        /**
         * Gets a boolean indicating if the texture needs mipmaps generation
         */ this.generateMipMaps = false;
        /**
         * Gets the number of samples used by the texture (WebGL2+ only)
         */ this.samples = 0;
        /**
         * Gets the type of the texture (int, float...)
         */ this.type = -1;
        /**
         * Gets the format of the texture (RGB, RGBA...)
         */ this.format = -1;
        /**
         * Observable called when the texture is loaded
         */ this.onLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable called when the texture load is raising an error
         */ this.onErrorObservable = new (0, $diGQf.Observable)();
        /**
         * If this callback is defined it will be called instead of the default _rebuild function
         */ this.onRebuildCallback = null;
        /**
         * Gets the width of the texture
         */ this.width = 0;
        /**
         * Gets the height of the texture
         */ this.height = 0;
        /**
         * Gets the depth of the texture
         */ this.depth = 0;
        /**
         * Gets the initial width of the texture (It could be rescaled if the current system does not support non power of two textures)
         */ this.baseWidth = 0;
        /**
         * Gets the initial height of the texture (It could be rescaled if the current system does not support non power of two textures)
         */ this.baseHeight = 0;
        /**
         * Gets the initial depth of the texture (It could be rescaled if the current system does not support non power of two textures)
         */ this.baseDepth = 0;
        /**
         * Gets a boolean indicating if the texture is inverted on Y axis
         */ this.invertY = false;
        // Private
        /** @internal */ this._invertVScale = false;
        /** @internal */ this._associatedChannel = -1;
        /** @internal */ this._source = 0 /* InternalTextureSource.Unknown */ ;
        /** @internal */ this._buffer = null;
        /** @internal */ this._bufferView = null;
        /** @internal */ this._bufferViewArray = null;
        /** @internal */ this._bufferViewArrayArray = null;
        /** @internal */ this._size = 0;
        /** @internal */ this._extension = "";
        /** @internal */ this._files = null;
        /** @internal */ this._workingCanvas = null;
        /** @internal */ this._workingContext = null;
        /** @internal */ this._cachedCoordinatesMode = null;
        /** @internal */ this._isDisabled = false;
        /** @internal */ this._compression = null;
        /** @internal */ this._sphericalPolynomial = null;
        /** @internal */ this._sphericalPolynomialPromise = null;
        /** @internal */ this._sphericalPolynomialComputed = false;
        /** @internal */ this._lodGenerationScale = 0;
        /** @internal */ this._lodGenerationOffset = 0;
        /** @internal */ this._useSRGBBuffer = false;
        /** @internal */ this._creationFlags = 0;
        // The following three fields helps sharing generated fixed LODs for texture filtering
        // In environment not supporting the textureLOD extension like EDGE. They are for internal use only.
        // They are at the level of the gl texture to benefit from the cache.
        /** @internal */ this._lodTextureHigh = null;
        /** @internal */ this._lodTextureMid = null;
        /** @internal */ this._lodTextureLow = null;
        /** @internal */ this._isRGBD = false;
        /** @internal */ this._linearSpecularLOD = false;
        /** @internal */ this._irradianceTexture = null;
        /** @internal */ this._hardwareTexture = null;
        /** @internal */ this._maxLodLevel = null;
        /** @internal */ this._references = 1;
        /** @internal */ this._gammaSpace = null;
        /** @internal */ this._premulAlpha = false;
        /** @internal */ this._dynamicTextureSource = null;
        /** @internal */ this._autoMSAAManagement = false;
        this._engine = engine;
        this._source = source;
        this._uniqueId = $81db7240fd7885fc$export$3ab99feff1488737._Counter++;
        if (!delayAllocation) this._hardwareTexture = engine._createHardwareTexture();
    }
    /**
     * Increments the number of references (ie. the number of Texture that point to it)
     */ incrementReferences() {
        this._references++;
    }
    /**
     * Change the size of the texture (not the size of the content)
     * @param width defines the new width
     * @param height defines the new height
     * @param depth defines the new depth (1 by default)
     */ updateSize(width, height, depth = 1) {
        this._engine.updateTextureDimensions(this, width, height, depth);
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.baseWidth = width;
        this.baseHeight = height;
        this.baseDepth = depth;
        this._size = width * height * depth;
    }
    /** @internal */ _rebuild() {
        this.isReady = false;
        this._cachedCoordinatesMode = null;
        this._cachedWrapU = null;
        this._cachedWrapV = null;
        this._cachedWrapR = null;
        this._cachedAnisotropicFilteringLevel = null;
        if (this.onRebuildCallback) {
            const data = this.onRebuildCallback(this);
            const swapAndSetIsReady = (proxyInternalTexture)=>{
                proxyInternalTexture._swapAndDie(this, false);
                this.isReady = data.isReady;
            };
            if (data.isAsync) data.proxy.then(swapAndSetIsReady);
            else swapAndSetIsReady(data.proxy);
            return;
        }
        let proxy;
        switch(this.source){
            case 2 /* InternalTextureSource.Temp */ :
                break;
            case 1 /* InternalTextureSource.Url */ :
                proxy = this._engine.createTexture(this._originalUrl ?? this.url, !this.generateMipMaps, this.invertY, null, this.samplingMode, // Do not use Proxy here as it could be fully synchronous
                // and proxy would be undefined.
                (temp)=>{
                    temp._swapAndDie(this, false);
                    this.isReady = true;
                }, null, this._buffer, undefined, this.format, this._extension, undefined, undefined, undefined, this._useSRGBBuffer);
                return;
            case 3 /* InternalTextureSource.Raw */ :
                proxy = this._engine.createRawTexture(this._bufferView, this.baseWidth, this.baseHeight, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type, this._creationFlags, this._useSRGBBuffer);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case 10 /* InternalTextureSource.Raw3D */ :
                proxy = this._engine.createRawTexture3D(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case 11 /* InternalTextureSource.Raw2DArray */ :
                proxy = this._engine.createRawTexture2DArray(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case 4 /* InternalTextureSource.Dynamic */ :
                proxy = this._engine.createDynamicTexture(this.baseWidth, this.baseHeight, this.generateMipMaps, this.samplingMode);
                proxy._swapAndDie(this, false);
                if (this._dynamicTextureSource) this._engine.updateDynamicTexture(this, this._dynamicTextureSource, this.invertY, this._premulAlpha, this.format, true);
                break;
            case 7 /* InternalTextureSource.Cube */ :
                proxy = this._engine.createCubeTexture(this.url, null, this._files, !this.generateMipMaps, ()=>{
                    proxy._swapAndDie(this, false);
                    this.isReady = true;
                }, null, this.format, this._extension, false, 0, 0, null, undefined, this._useSRGBBuffer, ArrayBuffer.isView(this._buffer) ? this._buffer : null);
                return;
            case 8 /* InternalTextureSource.CubeRaw */ :
                proxy = this._engine.createRawCubeTexture(this._bufferViewArray, this.width, this._originalFormat ?? this.format, this.type, this.generateMipMaps, this.invertY, this.samplingMode, this._compression);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case 13 /* InternalTextureSource.CubeRawRGBD */ :
                // This case is being handeled by the environment texture tools and is not a part of the rebuild process.
                // To use CubeRawRGBD use updateRGBDAsync on the cube texture.
                return;
            case 9 /* InternalTextureSource.CubePrefiltered */ :
                proxy = this._engine.createPrefilteredCubeTexture(this.url, null, this._lodGenerationScale, this._lodGenerationOffset, (proxy)=>{
                    if (proxy) proxy._swapAndDie(this, false);
                    this.isReady = true;
                }, null, this.format, this._extension);
                proxy._sphericalPolynomial = this._sphericalPolynomial;
                return;
            case 12 /* InternalTextureSource.DepthStencil */ :
            case 14 /* InternalTextureSource.Depth */ :
                break;
        }
    }
    /**
     * @internal
     */ _swapAndDie(target, swapAll = true) {
        // TODO what about refcount on target?
        this._hardwareTexture?.setUsage(target._source, this.generateMipMaps, this.is2DArray, this.isCube, this.is3D, this.width, this.height, this.depth);
        target._hardwareTexture = this._hardwareTexture;
        if (swapAll) target._isRGBD = this._isRGBD;
        if (this._lodTextureHigh) {
            if (target._lodTextureHigh) target._lodTextureHigh.dispose();
            target._lodTextureHigh = this._lodTextureHigh;
        }
        if (this._lodTextureMid) {
            if (target._lodTextureMid) target._lodTextureMid.dispose();
            target._lodTextureMid = this._lodTextureMid;
        }
        if (this._lodTextureLow) {
            if (target._lodTextureLow) target._lodTextureLow.dispose();
            target._lodTextureLow = this._lodTextureLow;
        }
        if (this._irradianceTexture) {
            if (target._irradianceTexture) target._irradianceTexture.dispose();
            target._irradianceTexture = this._irradianceTexture;
        }
        const cache = this._engine.getLoadedTexturesCache();
        let index = cache.indexOf(this);
        if (index !== -1) cache.splice(index, 1);
        index = cache.indexOf(target);
        if (index === -1) cache.push(target);
    }
    /**
     * Dispose the current allocated resources
     */ dispose() {
        this._references--;
        this.onLoadedObservable.clear();
        this.onErrorObservable.clear();
        if (this._references === 0) {
            this._engine._releaseTexture(this);
            this._hardwareTexture = null;
            this._dynamicTextureSource = null;
        }
    }
}
/** @internal */ $81db7240fd7885fc$export$3ab99feff1488737._Counter = 0;

});
parcelRegister("bEkJJ", function(module, exports) {

$parcel$export(module.exports, "TextureSampler", () => $87b383f9bc05e018$export$ed302f356acc288d);
/**
 * Class used to store a texture sampler data
 */ class $87b383f9bc05e018$export$ed302f356acc288d {
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapU() {
        return this._cachedWrapU;
    }
    set wrapU(value) {
        this._cachedWrapU = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapV() {
        return this._cachedWrapV;
    }
    set wrapV(value) {
        this._cachedWrapV = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapR() {
        return this._cachedWrapR;
    }
    set wrapR(value) {
        this._cachedWrapR = value;
    }
    /**
     * With compliant hardware and browser (supporting anisotropic filtering)
     * this defines the level of anisotropic filtering in the texture.
     * The higher the better but the slower.
     */ get anisotropicFilteringLevel() {
        return this._cachedAnisotropicFilteringLevel;
    }
    set anisotropicFilteringLevel(value) {
        this._cachedAnisotropicFilteringLevel = value;
    }
    /**
     * Gets or sets the comparison function (513, 514, etc). Set 0 to not use a comparison function
     */ get comparisonFunction() {
        return this._comparisonFunction;
    }
    set comparisonFunction(value) {
        this._comparisonFunction = value;
    }
    /**
     * Indicates to use the mip maps (if available on the texture).
     * Thanks to this flag, you can instruct the sampler to not sample the mipmaps even if they exist (and if the sampling mode is set to a value that normally samples the mipmaps!)
     */ get useMipMaps() {
        return this._useMipMaps;
    }
    set useMipMaps(value) {
        this._useMipMaps = value;
    }
    /**
     * Creates a Sampler instance
     */ constructor(){
        /**
         * Gets the sampling mode of the texture
         */ this.samplingMode = -1;
        this._useMipMaps = true;
        /** @internal */ this._cachedWrapU = null;
        /** @internal */ this._cachedWrapV = null;
        /** @internal */ this._cachedWrapR = null;
        /** @internal */ this._cachedAnisotropicFilteringLevel = null;
        /** @internal */ this._comparisonFunction = 0;
    }
    /**
     * Sets all the parameters of the sampler
     * @param wrapU u address mode (default: TEXTURE_WRAP_ADDRESSMODE)
     * @param wrapV v address mode (default: TEXTURE_WRAP_ADDRESSMODE)
     * @param wrapR r address mode (default: TEXTURE_WRAP_ADDRESSMODE)
     * @param anisotropicFilteringLevel anisotropic level (default: 1)
     * @param samplingMode sampling mode (default: 2)
     * @param comparisonFunction comparison function (default: 0 - no comparison function)
     * @returns the current sampler instance
     */ setParameters(wrapU = 1, wrapV = 1, wrapR = 1, anisotropicFilteringLevel = 1, samplingMode = 2, comparisonFunction = 0) {
        this._cachedWrapU = wrapU;
        this._cachedWrapV = wrapV;
        this._cachedWrapR = wrapR;
        this._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
        this.samplingMode = samplingMode;
        this._comparisonFunction = comparisonFunction;
        return this;
    }
    /**
     * Compares this sampler with another one
     * @param other sampler to compare with
     * @returns true if the samplers have the same parametres, else false
     */ compareSampler(other) {
        return this._cachedWrapU === other._cachedWrapU && this._cachedWrapV === other._cachedWrapV && this._cachedWrapR === other._cachedWrapR && this._cachedAnisotropicFilteringLevel === other._cachedAnisotropicFilteringLevel && this.samplingMode === other.samplingMode && this._comparisonFunction === other._comparisonFunction && this._useMipMaps === other._useMipMaps;
    }
}

});


parcelRegister("kgxWB", function(module, exports) {

$parcel$export(module.exports, "_GetCompatibleTextureLoader", () => $ec0fa1e7c3d4b761$export$62e22e512f68a6fa);

var $kVtWi = parcelRequire("kVtWi");
const $ec0fa1e7c3d4b761$var$_registeredTextureLoaders = new Map();
function $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(extension, loaderFactory) {
    if ($ec0fa1e7c3d4b761$export$23f1ac76e641bd90(extension)) (0, $kVtWi.Logger).Warn(`Extension with the name '${name}' already exists`);
    $ec0fa1e7c3d4b761$var$_registeredTextureLoaders.set(extension, loaderFactory);
}
function $ec0fa1e7c3d4b761$export$23f1ac76e641bd90(extension) {
    return $ec0fa1e7c3d4b761$var$_registeredTextureLoaders.delete(extension);
}









function $ec0fa1e7c3d4b761$export$62e22e512f68a6fa(extension, mimeType) {
    if (mimeType === "image/ktx" || mimeType === "image/ktx2") extension = ".ktx";
    if (!$ec0fa1e7c3d4b761$var$_registeredTextureLoaders.has(extension)) {
        if (extension.endsWith(".ies")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".ies", ()=>(parcelRequire("dXfKm")).then((module)=>new module._IESTextureLoader()));
        if (extension.endsWith(".dds")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".dds", ()=>(parcelRequire("g6IQp")).then((module)=>new module._DDSTextureLoader()));
        if (extension.endsWith(".basis")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".basis", ()=>(parcelRequire("gdyN5")).then((module)=>new module._BasisTextureLoader()));
        if (extension.endsWith(".env")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".env", ()=>(parcelRequire("acemA")).then((module)=>new module._ENVTextureLoader()));
        if (extension.endsWith(".hdr")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".hdr", ()=>(parcelRequire("2WcXs")).then((module)=>new module._HDRTextureLoader()));
        // The ".ktx2" file extension is still up for debate: https://github.com/KhronosGroup/KTX-Specification/issues/18
        if (extension.endsWith(".ktx") || extension.endsWith(".ktx2")) {
            $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".ktx", ()=>(parcelRequire("b2HHC")).then((module)=>new module._KTXTextureLoader()));
            $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".ktx2", ()=>(parcelRequire("b2HHC")).then((module)=>new module._KTXTextureLoader()));
        }
        if (extension.endsWith(".tga")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".tga", ()=>(parcelRequire("aFDW7")).then((module)=>new module._TGATextureLoader()));
        if (extension.endsWith(".exr")) $ec0fa1e7c3d4b761$export$eb7f3fbd34768411(".exr", ()=>(parcelRequire("g3P5u")).then((module)=>new module._ExrTextureLoader()));
    }
    const registered = $ec0fa1e7c3d4b761$var$_registeredTextureLoaders.get(extension);
    return registered ? Promise.resolve(registered(mimeType)) : null;
}

});
parcelRegister("dXfKm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3iHFa").then(()=>parcelRequire('27Txk'));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("g6IQp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("6Lxmp"),
    $Gr8vk("2M22I"),
    $Gr8vk("9kPzr")
]).then(()=>parcelRequire('hdvNa'));

});

parcelRegister("gdyN5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5B2hi").then(()=>parcelRequire('d0PoS'));

});

parcelRegister("acemA", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("2nnzJ"),
    $Gr8vk("6Lxmp"),
    $Gr8vk("dOETK")
]).then(()=>parcelRequire('lkQQp'));

});

parcelRegister("2WcXs", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dQ67R").then(()=>parcelRequire('ezxpO'));

});

parcelRegister("b2HHC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jmK8z").then(()=>parcelRequire('72wSy'));

});

parcelRegister("aFDW7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("e5nmT").then(()=>parcelRequire('4eipL'));

});

parcelRegister("g3P5u", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gP7tK").then(()=>parcelRequire('4DKQz'));

});




parcelRegister("i1moY", function(module, exports) {

$parcel$export(module.exports, "InstantiationTools", () => $d1e9b27fd3209819$export$d445cd1e11268bec);

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");
class $d1e9b27fd3209819$export$d445cd1e11268bec {
    /**
     * Tries to instantiate a new object from a given class name
     * @param className defines the class name to instantiate
     * @returns the new object or null if the system was not able to do the instantiation
     */ static Instantiate(className) {
        if (this.RegisteredExternalClasses && this.RegisteredExternalClasses[className]) return this.RegisteredExternalClasses[className];
        const internalClass = (0, $8DoUR.GetClass)(className);
        if (internalClass) return internalClass;
        (0, $kVtWi.Logger).Warn(className + " not found, you may have missed an import.");
        const arr = className.split(".");
        let fn = window || this;
        for(let i = 0, len = arr.length; i < len; i++)fn = fn[arr[i]];
        if (typeof fn !== "function") return null;
        return fn;
    }
}
/**
 * Use this object to register external classes like custom textures or material
 * to allow the loaders to instantiate them
 */ $d1e9b27fd3209819$export$d445cd1e11268bec.RegisteredExternalClasses = {};

});
parcelRegister("8DoUR", function(module, exports) {

$parcel$export(module.exports, "RegisterClass", () => $64954b10efba2b52$export$1b9ac54a99baf77);
$parcel$export(module.exports, "GetClass", () => $64954b10efba2b52$export$8b6eb39d35ebe016);
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $64954b10efba2b52$var$_RegisteredTypes = {};
function $64954b10efba2b52$export$1b9ac54a99baf77(className, type) {
    $64954b10efba2b52$var$_RegisteredTypes[className] = type;
}
function $64954b10efba2b52$export$8b6eb39d35ebe016(fqdn) {
    return $64954b10efba2b52$var$_RegisteredTypes[fqdn];
}
function $64954b10efba2b52$export$1dde4e19e704bfd3(obj) {
    for(const key in $64954b10efba2b52$var$_RegisteredTypes){
        if (obj instanceof $64954b10efba2b52$var$_RegisteredTypes[key] && !key.includes("Abstract")) return key;
    }
    return "Unknown";
}

});


parcelRegister("321Uk", function(module, exports) {

$parcel$export(module.exports, "RandomGUID", () => $235309cb367bc426$export$1d06f1866d73f3cb);
/**
 * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
 * Be aware Math.random() could cause collisions, but:
 * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
 * @returns a pseudo random id
 */ function $235309cb367bc426$export$1d06f1866d73f3cb() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $235309cb367bc426$export$aeae6d33ee4c22ee = {
    /**
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a pseudo random id
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    RandomId: $235309cb367bc426$export$1d06f1866d73f3cb
};

});

parcelRegister("wK2xc", function(module, exports) {

$parcel$export(module.exports, "IsExponentOfTwo", () => $0626b3d5ab722105$export$c3f415aa3baa73a8);
$parcel$export(module.exports, "Mix", () => $0626b3d5ab722105$export$7396bfa63bff91f5);
$parcel$export(module.exports, "NearestPOT", () => $0626b3d5ab722105$export$bffeecb508b73c3);
$parcel$export(module.exports, "FloorPOT", () => $0626b3d5ab722105$export$9bd1933c378a33a4);
$parcel$export(module.exports, "GetExponentOfTwo", () => $0626b3d5ab722105$export$640e11003ef0e859);
/**
 * Function indicating if a number is an exponent of 2
 * @param value defines the value to test
 * @returns true if the value is an exponent of 2
 */ function $0626b3d5ab722105$export$c3f415aa3baa73a8(value) {
    let count = 1;
    do count *= 2;
    while (count < value);
    return count === value;
}
function $0626b3d5ab722105$export$7396bfa63bff91f5(a, b, alpha) {
    return a * (1 - alpha) + b * alpha;
}
function $0626b3d5ab722105$export$bffeecb508b73c3(x) {
    const c = $0626b3d5ab722105$export$126f39bfb662a084(x);
    const f = $0626b3d5ab722105$export$9bd1933c378a33a4(x);
    return c - x > x - f ? f : c;
}
function $0626b3d5ab722105$export$126f39bfb662a084(x) {
    x--;
    x |= x >> 1;
    x |= x >> 2;
    x |= x >> 4;
    x |= x >> 8;
    x |= x >> 16;
    x++;
    return x;
}
function $0626b3d5ab722105$export$9bd1933c378a33a4(x) {
    x = x | x >> 1;
    x = x | x >> 2;
    x = x | x >> 4;
    x = x | x >> 8;
    x = x | x >> 16;
    return x - (x >> 1);
}
function $0626b3d5ab722105$export$640e11003ef0e859(value, max, mode = 2) {
    let pot;
    switch(mode){
        case 1:
            pot = $0626b3d5ab722105$export$9bd1933c378a33a4(value);
            break;
        case 2:
            pot = $0626b3d5ab722105$export$bffeecb508b73c3(value);
            break;
        case 3:
        default:
            pot = $0626b3d5ab722105$export$126f39bfb662a084(value);
            break;
    }
    return Math.min(pot, max);
}

});


parcelRegister("57onU", function(module, exports) {

$parcel$export(module.exports, "SmartArray", () => $3ba0857505d5e249$export$556f92bf4579e18b);
$parcel$export(module.exports, "SmartArrayNoDuplicate", () => $3ba0857505d5e249$export$b3dcd8157693e8e3);
/**
 * Defines an GC Friendly array where the backfield array do not shrink to prevent over allocations.
 */ class $3ba0857505d5e249$export$556f92bf4579e18b {
    /**
     * Instantiates a Smart Array.
     * @param capacity defines the default capacity of the array.
     */ constructor(capacity){
        /**
         * The active length of the array.
         */ this.length = 0;
        this.data = new Array(capacity);
        this._id = $3ba0857505d5e249$export$556f92bf4579e18b._GlobalId++;
    }
    /**
     * Pushes a value at the end of the active data.
     * @param value defines the object to push in the array.
     */ push(value) {
        this.data[this.length++] = value;
        if (this.length > this.data.length) this.data.length *= 2;
    }
    /**
     * Iterates over the active data and apply the lambda to them.
     * @param func defines the action to apply on each value.
     */ forEach(func) {
        for(let index = 0; index < this.length; index++)func(this.data[index]);
    }
    /**
     * Sorts the full sets of data.
     * @param compareFn defines the comparison function to apply.
     */ sort(compareFn) {
        this.data.sort(compareFn);
    }
    /**
     * Resets the active data to an empty array.
     */ reset() {
        this.length = 0;
    }
    /**
     * Releases all the data from the array as well as the array.
     */ dispose() {
        this.reset();
        if (this.data) this.data.length = 0;
    }
    /**
     * Concats the active data with a given array.
     * @param array defines the data to concatenate with.
     */ concat(array) {
        if (array.length === 0) return;
        if (this.length + array.length > this.data.length) this.data.length = (this.length + array.length) * 2;
        for(let index = 0; index < array.length; index++)this.data[this.length++] = (array.data || array)[index];
    }
    /**
     * Returns the position of a value in the active data.
     * @param value defines the value to find the index for
     * @returns the index if found in the active data otherwise -1
     */ indexOf(value) {
        const position = this.data.indexOf(value);
        if (position >= this.length) return -1;
        return position;
    }
    /**
     * Returns whether an element is part of the active data.
     * @param value defines the value to look for
     * @returns true if found in the active data otherwise false
     */ contains(value) {
        return this.indexOf(value) !== -1;
    }
}
// Statics
$3ba0857505d5e249$export$556f92bf4579e18b._GlobalId = 0;
class $3ba0857505d5e249$export$b3dcd8157693e8e3 extends $3ba0857505d5e249$export$556f92bf4579e18b {
    constructor(){
        super(...arguments);
        this._duplicateId = 0;
    }
    /**
     * Pushes a value at the end of the active data.
     * THIS DOES NOT PREVENT DUPPLICATE DATA
     * @param value defines the object to push in the array.
     */ push(value) {
        super.push(value);
        if (!value.__smartArrayFlags) value.__smartArrayFlags = {};
        value.__smartArrayFlags[this._id] = this._duplicateId;
    }
    /**
     * Pushes a value at the end of the active data.
     * If the data is already present, it won t be added again
     * @param value defines the object to push in the array.
     * @returns true if added false if it was already present
     */ pushNoDuplicate(value) {
        if (value.__smartArrayFlags && value.__smartArrayFlags[this._id] === this._duplicateId) return false;
        this.push(value);
        return true;
    }
    /**
     * Resets the active data to an empty array.
     */ reset() {
        super.reset();
        this._duplicateId++;
    }
    /**
     * Concats the active data with a given array.
     * This ensures no duplicate will be present in the result.
     * @param array defines the data to concatenate with.
     */ concatWithNoDuplicate(array) {
        if (array.length === 0) return;
        if (this.length + array.length > this.data.length) this.data.length = (this.length + array.length) * 2;
        for(let index = 0; index < array.length; index++){
            const item = (array.data || array)[index];
            this.pushNoDuplicate(item);
        }
    }
}

});

parcelRegister("895IS", function(module, exports) {

$parcel$export(module.exports, "StringDictionary", () => $5ee39a6fb0067c4c$export$aa8d5945bd10865c);
/**
 * This class implement a typical dictionary using a string as key and the generic type T as value.
 * The underlying implementation relies on an associative array to ensure the best performances.
 * The value can be anything including 'null' but except 'undefined'
 */ class $5ee39a6fb0067c4c$export$aa8d5945bd10865c {
    constructor(){
        this._count = 0;
        this._data = {};
    }
    /**
     * This will clear this dictionary and copy the content from the 'source' one.
     * If the T value is a custom object, it won't be copied/cloned, the same object will be used
     * @param source the dictionary to take the content from and copy to this dictionary
     */ copyFrom(source) {
        this.clear();
        source.forEach((t, v)=>this.add(t, v));
    }
    /**
     * Get a value based from its key
     * @param key the given key to get the matching value from
     * @returns the value if found, otherwise undefined is returned
     */ get(key) {
        const val = this._data[key];
        if (val !== undefined) return val;
        return undefined;
    }
    /**
     * Get a value from its key or add it if it doesn't exist.
     * This method will ensure you that a given key/data will be present in the dictionary.
     * @param key the given key to get the matching value from
     * @param factory the factory that will create the value if the key is not present in the dictionary.
     * The factory will only be invoked if there's no data for the given key.
     * @returns the value corresponding to the key.
     */ getOrAddWithFactory(key, factory) {
        let val = this.get(key);
        if (val !== undefined) return val;
        val = factory(key);
        if (val) this.add(key, val);
        return val;
    }
    /**
     * Get a value from its key if present in the dictionary otherwise add it
     * @param key the key to get the value from
     * @param val if there's no such key/value pair in the dictionary add it with this value
     * @returns the value corresponding to the key
     */ getOrAdd(key, val) {
        const curVal = this.get(key);
        if (curVal !== undefined) return curVal;
        this.add(key, val);
        return val;
    }
    /**
     * Check if there's a given key in the dictionary
     * @param key the key to check for
     * @returns true if the key is present, false otherwise
     */ contains(key) {
        return this._data[key] !== undefined;
    }
    /**
     * Add a new key and its corresponding value
     * @param key the key to add
     * @param value the value corresponding to the key
     * @returns true if the operation completed successfully, false if we couldn't insert the key/value because there was already this key in the dictionary
     */ add(key, value) {
        if (this._data[key] !== undefined) return false;
        this._data[key] = value;
        ++this._count;
        return true;
    }
    /**
     * Update a specific value associated to a key
     * @param key defines the key to use
     * @param value defines the value to store
     * @returns true if the value was updated (or false if the key was not found)
     */ set(key, value) {
        if (this._data[key] === undefined) return false;
        this._data[key] = value;
        return true;
    }
    /**
     * Get the element of the given key and remove it from the dictionary
     * @param key defines the key to search
     * @returns the value associated with the key or null if not found
     */ getAndRemove(key) {
        const val = this.get(key);
        if (val !== undefined) {
            delete this._data[key];
            --this._count;
            return val;
        }
        return null;
    }
    /**
     * Remove a key/value from the dictionary.
     * @param key the key to remove
     * @returns true if the item was successfully deleted, false if no item with such key exist in the dictionary
     */ remove(key) {
        if (this.contains(key)) {
            delete this._data[key];
            --this._count;
            return true;
        }
        return false;
    }
    /**
     * Clear the whole content of the dictionary
     */ clear() {
        this._data = {};
        this._count = 0;
    }
    /**
     * Gets the current count
     */ get count() {
        return this._count;
    }
    /**
     * Execute a callback on each key/val of the dictionary.
     * Note that you can remove any element in this dictionary in the callback implementation
     * @param callback the callback to execute on a given key/value pair
     */ forEach(callback) {
        for(const cur in this._data){
            const val = this._data[cur];
            callback(cur, val);
        }
    }
    /**
     * Execute a callback on every occurrence of the dictionary until it returns a valid TRes object.
     * If the callback returns null or undefined the method will iterate to the next key/value pair
     * Note that you can remove any element in this dictionary in the callback implementation
     * @param callback the callback to execute, if it return a valid T instanced object the enumeration will stop and the object will be returned
     * @returns the first item
     */ first(callback) {
        for(const cur in this._data){
            const val = this._data[cur];
            const res = callback(cur, val);
            if (res) return res;
        }
        return null;
    }
}

});

parcelRegister("7212E", function(module, exports) {

$parcel$export(module.exports, "Tags", () => $51e9872e32043eff$export$b72686b556e29ca6);

var $1VA7I = parcelRequire("1VA7I");
class $51e9872e32043eff$export$b72686b556e29ca6 {
    /**
     * Adds support for tags on the given object
     * @param obj defines the object to use
     */ static EnableFor(obj) {
        obj._tags = obj._tags || {};
        obj.hasTags = ()=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj);
        };
        obj.addTags = (tagsString)=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.AddTagsTo(obj, tagsString);
        };
        obj.removeTags = (tagsString)=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.RemoveTagsFrom(obj, tagsString);
        };
        obj.matchesTagsQuery = (tagsQuery)=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.MatchesQuery(obj, tagsQuery);
        };
    }
    /**
     * Removes tags support
     * @param obj defines the object to use
     */ static DisableFor(obj) {
        delete obj._tags;
        delete obj.hasTags;
        delete obj.addTags;
        delete obj.removeTags;
        delete obj.matchesTagsQuery;
    }
    /**
     * Gets a boolean indicating if the given object has tags
     * @param obj defines the object to use
     * @returns a boolean
     */ static HasTags(obj) {
        if (!obj._tags) return false;
        const tags = obj._tags;
        for(const i in tags){
            if (Object.prototype.hasOwnProperty.call(tags, i)) return true;
        }
        return false;
    }
    /**
     * Gets the tags available on a given object
     * @param obj defines the object to use
     * @param asString defines if the tags must be returned as a string instead of an array of strings
     * @returns the tags
     */ static GetTags(obj, asString = true) {
        if (!obj._tags) return null;
        if (asString) {
            const tagsArray = [];
            for(const tag in obj._tags)if (Object.prototype.hasOwnProperty.call(obj._tags, tag) && obj._tags[tag] === true) tagsArray.push(tag);
            return tagsArray.join(" ");
        } else return obj._tags;
    }
    /**
     * Adds tags to an object
     * @param obj defines the object to use
     * @param tagsString defines the tag string. The tags 'true' and 'false' are reserved and cannot be used as tags.
     * A tag cannot start with '||', '&&', and '!'. It cannot contain whitespaces
     */ static AddTagsTo(obj, tagsString) {
        if (!tagsString) return;
        if (typeof tagsString !== "string") return;
        const tags = tagsString.split(" ");
        tags.forEach(function(tag) {
            $51e9872e32043eff$export$b72686b556e29ca6._AddTagTo(obj, tag);
        });
    }
    /**
     * @internal
     */ static _AddTagTo(obj, tag) {
        tag = tag.trim();
        if (tag === "" || tag === "true" || tag === "false") return;
        if (tag.match(/[\s]/) || tag.match(/^([!]|([|]|[&]){2})/)) return;
        $51e9872e32043eff$export$b72686b556e29ca6.EnableFor(obj);
        obj._tags[tag] = true;
    }
    /**
     * Removes specific tags from a specific object
     * @param obj defines the object to use
     * @param tagsString defines the tags to remove
     */ static RemoveTagsFrom(obj, tagsString) {
        if (!$51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj)) return;
        const tags = tagsString.split(" ");
        for(const t in tags)$51e9872e32043eff$export$b72686b556e29ca6._RemoveTagFrom(obj, tags[t]);
    }
    /**
     * @internal
     */ static _RemoveTagFrom(obj, tag) {
        delete obj._tags[tag];
    }
    /**
     * Defines if tags hosted on an object match a given query
     * @param obj defines the object to use
     * @param tagsQuery defines the tag query
     * @returns a boolean
     */ static MatchesQuery(obj, tagsQuery) {
        if (tagsQuery === undefined) return true;
        if (tagsQuery === "") return $51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj);
        return (0, $1VA7I.AndOrNotEvaluator).Eval(tagsQuery, (r)=>$51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj) && obj._tags[r]);
    }
}

});
parcelRegister("1VA7I", function(module, exports) {

$parcel$export(module.exports, "AndOrNotEvaluator", () => $167722b44b8176d3$export$538bb86bc662e468);
/**
 * Class used to evaluate queries containing `and` and `or` operators
 */ class $167722b44b8176d3$export$538bb86bc662e468 {
    /**
     * Evaluate a query
     * @param query defines the query to evaluate
     * @param evaluateCallback defines the callback used to filter result
     * @returns true if the query matches
     */ static Eval(query, evaluateCallback) {
        if (!query.match(/\([^()]*\)/g)) query = $167722b44b8176d3$export$538bb86bc662e468._HandleParenthesisContent(query, evaluateCallback);
        else query = query.replace(/\([^()]*\)/g, (r)=>{
            // remove parenthesis
            r = r.slice(1, r.length - 1);
            return $167722b44b8176d3$export$538bb86bc662e468._HandleParenthesisContent(r, evaluateCallback);
        });
        if (query === "true") return true;
        if (query === "false") return false;
        return $167722b44b8176d3$export$538bb86bc662e468.Eval(query, evaluateCallback);
    }
    static _HandleParenthesisContent(parenthesisContent, evaluateCallback) {
        evaluateCallback = evaluateCallback || ((r)=>{
            return r === "true" ? true : false;
        });
        let result;
        const or = parenthesisContent.split("||");
        for(const i in or)if (Object.prototype.hasOwnProperty.call(or, i)) {
            let ori = $167722b44b8176d3$export$538bb86bc662e468._SimplifyNegation(or[i].trim());
            const and = ori.split("&&");
            if (and.length > 1) for(let j = 0; j < and.length; ++j){
                const andj = $167722b44b8176d3$export$538bb86bc662e468._SimplifyNegation(and[j].trim());
                if (andj !== "true" && andj !== "false") {
                    if (andj[0] === "!") result = !evaluateCallback(andj.substring(1));
                    else result = evaluateCallback(andj);
                } else result = andj === "true" ? true : false;
                if (!result) {
                    // no need to continue since 'false && ... && ...' will always return false
                    ori = "false";
                    break;
                }
            }
            if (result || ori === "true") {
                // no need to continue since 'true || ... || ...' will always return true
                result = true;
                break;
            }
            // result equals false (or undefined)
            if (ori !== "true" && ori !== "false") {
                if (ori[0] === "!") result = !evaluateCallback(ori.substring(1));
                else result = evaluateCallback(ori);
            } else result = ori === "true" ? true : false;
        }
        // the whole parenthesis scope is replaced by 'true' or 'false'
        return result ? "true" : "false";
    }
    static _SimplifyNegation(booleanString) {
        booleanString = booleanString.replace(/^[\s!]+/, (r)=>{
            // remove whitespaces
            r = r.replace(/[\s]/g, ()=>"");
            return r.length % 2 ? "!" : "";
        });
        booleanString = booleanString.trim();
        if (booleanString === "!true") booleanString = "false";
        else if (booleanString === "!false") booleanString = "true";
        return booleanString;
    }
}

});


parcelRegister("ha1VO", function(module, exports) {

$parcel$export(module.exports, "Vector2", () => $c7e4de670ed74d35$export$c977b3e384af9ae1);
$parcel$export(module.exports, "Vector3", () => $c7e4de670ed74d35$export$64b5c384219d3699);
$parcel$export(module.exports, "Quaternion", () => $c7e4de670ed74d35$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "TmpVectors", () => $c7e4de670ed74d35$export$269f00bf0c0718d1);
$parcel$export(module.exports, "Matrix", () => $c7e4de670ed74d35$export$5b12bf1653c0dd85);
$parcel$export(module.exports, "Vector4", () => $c7e4de670ed74d35$export$fa7daccca11cdbe3);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $53VPf = parcelRequire("53VPf");

var $opFp4 = parcelRequire("opFp4");

var $8DoUR = parcelRequire("8DoUR");

var $3agwF = parcelRequire("3agwF");

var $ejQPp = parcelRequire("ejQPp");

var $iosaP = parcelRequire("iosaP");
// eslint-disable-next-line @typescript-eslint/naming-convention
const $c7e4de670ed74d35$var$_ExtractAsInt = (value)=>{
    return parseInt(value.toString().replace(/\W/g, ""));
};
class $c7e4de670ed74d35$export$c977b3e384af9ae1 {
    /**
     * Creates a new Vector2 from the given x and y coordinates
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     */ constructor(/** [0] defines the first coordinate */ x = 0, /** [0] defines the second coordinate */ y = 0){
        this.x = x;
        this.y = y;
    }
    /**
     * Gets a string with the Vector2 coordinates
     * @returns a string with the Vector2 coordinates
     */ toString() {
        return `{X: ${this.x} Y: ${this.y}}`;
    }
    /**
     * Gets class name
     * @returns the string "Vector2"
     */ getClassName() {
        return "Vector2";
    }
    /**
     * Gets current vector hash code
     * @returns the Vector2 hash code as a number
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this.x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this.y);
        let hash = x;
        hash = hash * 397 ^ y;
        return hash;
    }
    // Operators
    /**
     * Sets the Vector2 coordinates in the given array or Float32Array from the given index.
     * Example Playground https://playground.babylonjs.com/#QYBWV4#15
     * @param array defines the source array
     * @param index defines the offset in source array
     * @returns the current Vector2
     */ toArray(array, index = 0) {
        array[index] = this.x;
        array[index + 1] = this.y;
        return this;
    }
    /**
     * Update the current vector from an array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#39
     * @param array defines the destination array
     * @param offset defines the offset in the destination array
     * @returns the current Vector2
     */ fromArray(array, offset = 0) {
        $c7e4de670ed74d35$export$c977b3e384af9ae1.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Copy the current vector to an array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#40
     * @returns a new array with 2 elements: the Vector2 coordinates.
     */ asArray() {
        return [
            this.x,
            this.y
        ];
    }
    /**
     * Sets the Vector2 coordinates with the given Vector2 coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#24
     * @param source defines the source Vector2
     * @returns the current updated Vector2
     */ copyFrom(source) {
        this.x = source.x;
        this.y = source.y;
        return this;
    }
    /**
     * Sets the Vector2 coordinates with the given floats
     * Example Playground https://playground.babylonjs.com/#QYBWV4#25
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     * @returns the current updated Vector2
     */ copyFromFloats(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
     * Sets the Vector2 coordinates with the given floats
     * Example Playground https://playground.babylonjs.com/#QYBWV4#62
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     * @returns the current updated Vector2
     */ set(x, y) {
        return this.copyFromFloats(x, y);
    }
    /**
     * Copies the given float to the current Vector2 coordinates
     * @param v defines the x and y coordinates of the operand
     * @returns the current updated Vector2
     */ setAll(v) {
        return this.copyFromFloats(v, v);
    }
    /**
     * Add another vector with the current one
     * Example Playground https://playground.babylonjs.com/#QYBWV4#11
     * @param otherVector defines the other vector
     * @returns a new Vector2 set with the addition of the current Vector2 and the given one coordinates
     */ add(otherVector) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x + otherVector.x, this.y + otherVector.y);
    }
    /**
     * Sets the "result" coordinates with the addition of the current Vector2 and the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#12
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ addToRef(otherVector, result) {
        result.x = this.x + otherVector.x;
        result.y = this.y + otherVector.y;
        return result;
    }
    /**
     * Set the Vector2 coordinates by adding the given Vector2 coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#13
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ addInPlace(otherVector) {
        this.x += otherVector.x;
        this.y += otherVector.y;
        return this;
    }
    /**
     * Adds the given coordinates to the current Vector2
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the current updated Vector2
     */ addInPlaceFromFloats(x, y) {
        this.x += x;
        this.y += y;
        return this;
    }
    /**
     * Gets a new Vector2 by adding the current Vector2 coordinates to the given Vector3 x, y coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#14
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ addVector3(otherVector) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x + otherVector.x, this.y + otherVector.y);
    }
    /**
     * Gets a new Vector2 set with the subtracted coordinates of the given one from the current Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#61
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ subtract(otherVector) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x - otherVector.x, this.y - otherVector.y);
    }
    /**
     * Sets the "result" coordinates with the subtraction of the given one from the current Vector2 coordinates.
     * Example Playground https://playground.babylonjs.com/#QYBWV4#63
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ subtractToRef(otherVector, result) {
        result.x = this.x - otherVector.x;
        result.y = this.y - otherVector.y;
        return result;
    }
    /**
     * Sets the current Vector2 coordinates by subtracting from it the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#88
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ subtractInPlace(otherVector) {
        this.x -= otherVector.x;
        this.y -= otherVector.y;
        return this;
    }
    /**
     * Multiplies in place the current Vector2 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#QYBWV4#43
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ multiplyInPlace(otherVector) {
        this.x *= otherVector.x;
        this.y *= otherVector.y;
        return this;
    }
    /**
     * Returns a new Vector2 set with the multiplication of the current Vector2 and the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#42
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ multiply(otherVector) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x * otherVector.x, this.y * otherVector.y);
    }
    /**
     * Sets "result" coordinates with the multiplication of the current Vector2 and the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#44
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ multiplyToRef(otherVector, result) {
        result.x = this.x * otherVector.x;
        result.y = this.y * otherVector.y;
        return result;
    }
    /**
     * Gets a new Vector2 set with the Vector2 coordinates multiplied by the given floats
     * Example Playground https://playground.babylonjs.com/#QYBWV4#89
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     * @returns a new Vector2
     */ multiplyByFloats(x, y) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x * x, this.y * y);
    }
    /**
     * Returns a new Vector2 set with the Vector2 coordinates divided by the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#27
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ divide(otherVector) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x / otherVector.x, this.y / otherVector.y);
    }
    /**
     * Sets the "result" coordinates with the Vector2 divided by the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#30
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ divideToRef(otherVector, result) {
        result.x = this.x / otherVector.x;
        result.y = this.y / otherVector.y;
        return result;
    }
    /**
     * Divides the current Vector2 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#QYBWV4#28
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ divideInPlace(otherVector) {
        this.x = this.x / otherVector.x;
        this.y = this.y / otherVector.y;
        return this;
    }
    /**
     * Updates the current Vector2 with the minimal coordinate values between its and the given vector ones
     * @param other defines the second operand
     * @returns the current updated Vector2
     */ minimizeInPlace(other) {
        return this.minimizeInPlaceFromFloats(other.x, other.y);
    }
    /**
     * Updates the current Vector2 with the maximal coordinate values between its and the given vector ones.
     * @param other defines the second operand
     * @returns the current updated Vector2
     */ maximizeInPlace(other) {
        return this.maximizeInPlaceFromFloats(other.x, other.y);
    }
    /**
     * Updates the current Vector2 with the minimal coordinate values between its and the given coordinates
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the current updated Vector2
     */ minimizeInPlaceFromFloats(x, y) {
        this.x = Math.min(x, this.x);
        this.y = Math.min(y, this.y);
        return this;
    }
    /**
     * Updates the current Vector2 with the maximal coordinate values between its and the given coordinates.
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the current updated Vector2
     */ maximizeInPlaceFromFloats(x, y) {
        this.x = Math.max(x, this.x);
        this.y = Math.max(y, this.y);
        return this;
    }
    /**
     * Returns a new Vector2 set with the subtraction of the given floats from the current Vector2 coordinates
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the resulting Vector2
     */ subtractFromFloats(x, y) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x - x, this.y - y);
    }
    /**
     * Subtracts the given floats from the current Vector2 coordinates and set the given vector "result" with this result
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param result defines the Vector2 object where to store the result
     * @returns the result
     */ subtractFromFloatsToRef(x, y, result) {
        result.x = this.x - x;
        result.y = this.y - y;
        return result;
    }
    /**
     * Gets a new Vector2 with current Vector2 negated coordinates
     * @returns a new Vector2
     */ negate() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(-this.x, -this.y);
    }
    /**
     * Negate this vector in place
     * Example Playground https://playground.babylonjs.com/#QYBWV4#23
     * @returns this
     */ negateInPlace() {
        this.x *= -1;
        this.y *= -1;
        return this;
    }
    /**
     * Negate the current Vector2 and stores the result in the given vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#41
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ negateToRef(result) {
        result.x = -this.x;
        result.y = -this.y;
        return result;
    }
    /**
     * Multiply the Vector2 coordinates by
     * Example Playground https://playground.babylonjs.com/#QYBWV4#59
     * @param scale defines the scaling factor
     * @returns the current updated Vector2
     */ scaleInPlace(scale) {
        this.x *= scale;
        this.y *= scale;
        return this;
    }
    /**
     * Returns a new Vector2 scaled by "scale" from the current Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#52
     * @param scale defines the scaling factor
     * @returns a new Vector2
     */ scale(scale) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x * scale, this.y * scale);
    }
    /**
     * Scale the current Vector2 values by a factor to a given Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#57
     * @param scale defines the scale factor
     * @param result defines the Vector2 object where to store the result
     * @returns result input
     */ scaleToRef(scale, result) {
        result.x = this.x * scale;
        result.y = this.y * scale;
        return result;
    }
    /**
     * Scale the current Vector2 values by a factor and add the result to a given Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#58
     * @param scale defines the scale factor
     * @param result defines the Vector2 object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result.x += this.x * scale;
        result.y += this.y * scale;
        return result;
    }
    /**
     * Gets a boolean if two vectors are equals
     * Example Playground https://playground.babylonjs.com/#QYBWV4#31
     * @param otherVector defines the other vector
     * @returns true if the given vector coordinates strictly equal the current Vector2 ones
     */ equals(otherVector) {
        return otherVector && this.x === otherVector.x && this.y === otherVector.y;
    }
    /**
     * Gets a boolean if two vectors are equals (using an epsilon value)
     * Example Playground https://playground.babylonjs.com/#QYBWV4#32
     * @param otherVector defines the other vector
     * @param epsilon defines the minimal distance to consider equality
     * @returns true if the given vector coordinates are close to the current ones by a distance of epsilon.
     */ equalsWithEpsilon(otherVector, epsilon = (0, $53VPf.Epsilon)) {
        return otherVector && (0, $iosaP.WithinEpsilon)(this.x, otherVector.x, epsilon) && (0, $iosaP.WithinEpsilon)(this.y, otherVector.y, epsilon);
    }
    /**
     * Returns true if the current Vector2 coordinates equals the given floats
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns true if both vectors are equal
     */ equalsToFloats(x, y) {
        return this.x === x && this.y === y;
    }
    /**
     * Gets a new Vector2 from current Vector2 floored values
     * Example Playground https://playground.babylonjs.com/#QYBWV4#35
     * eg (1.2, 2.31) returns (1, 2)
     * @returns a new Vector2
     */ floor() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(Math.floor(this.x), Math.floor(this.y));
    }
    /**
     * Gets the current Vector2's floored values and stores them in result
     * @param result the Vector2 to store the result in
     * @returns the result Vector2
     */ floorToRef(result) {
        result.x = Math.floor(this.x);
        result.y = Math.floor(this.y);
        return result;
    }
    /**
     * Gets a new Vector2 from current Vector2 fractional values
     * Example Playground https://playground.babylonjs.com/#QYBWV4#34
     * eg (1.2, 2.31) returns (0.2, 0.31)
     * @returns a new Vector2
     */ fract() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x - Math.floor(this.x), this.y - Math.floor(this.y));
    }
    /**
     * Gets the current Vector2's fractional values and stores them in result
     * @param result the Vector2 to store the result in
     * @returns the result Vector2
     */ fractToRef(result) {
        result.x = this.x - Math.floor(this.x);
        result.y = this.y - Math.floor(this.y);
        return result;
    }
    /**
     * Rotate the current vector into a given result vector
     * Example Playground https://playground.babylonjs.com/#QYBWV4#49
     * @param angle defines the rotation angle
     * @param result defines the result vector where to store the rotated vector
     * @returns result input
     */ rotateToRef(angle, result) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const x = cos * this.x - sin * this.y;
        const y = sin * this.x + cos * this.y;
        result.x = x;
        result.y = y;
        return result;
    }
    // Properties
    /**
     * Gets the length of the vector
     * @returns the vector length (float)
     */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
     * Gets the vector squared length
     * @returns the vector squared length (float)
     */ lengthSquared() {
        return this.x * this.x + this.y * this.y;
    }
    // Methods
    /**
     * Normalize the vector
     * Example Playground https://playground.babylonjs.com/#QYBWV4#48
     * @returns the current updated Vector2
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Normalize the current Vector2 with the given input length.
     * Please note that this is an in place operation.
     * @param len the length of the vector
     * @returns the current updated Vector2
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize the current Vector2 to a new vector
     * @returns the new Vector2
     */ normalizeToNew() {
        const normalized = new $c7e4de670ed74d35$export$c977b3e384af9ae1();
        this.normalizeToRef(normalized);
        return normalized;
    }
    /**
     * Normalize the current Vector2 to the reference
     * @param result define the Vector to update
     * @returns the updated Vector2
     */ normalizeToRef(result) {
        const len = this.length();
        if (len === 0) {
            result.x = this.x;
            result.y = this.y;
        }
        return this.scaleToRef(1.0 / len, result);
    }
    /**
     * Gets a new Vector2 copied from the Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#20
     * @returns a new Vector2
     */ clone() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(this.x, this.y);
    }
    /**
     * Gets the dot product of the current vector and the vector "otherVector"
     * @param otherVector defines second vector
     * @returns the dot product (float)
     */ dot(otherVector) {
        return this.x * otherVector.x + this.y * otherVector.y;
    }
    // Statics
    /**
     * Gets a new Vector2(0, 0)
     * @returns a new Vector2
     */ static Zero() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(0, 0);
    }
    /**
     * Gets a new Vector2(1, 1)
     * @returns a new Vector2
     */ static One() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(1, 1);
    }
    /**
     * Returns a new Vector2 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Vector2 with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Vector2 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Gets a zero Vector2 that must not be updated
     */ static get ZeroReadOnly() {
        return $c7e4de670ed74d35$export$c977b3e384af9ae1._ZeroReadOnly;
    }
    /**
     * Gets a new Vector2 set from the given index element of the given array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#79
     * @param array defines the data source
     * @param offset defines the offset in the data source
     * @returns a new Vector2
     */ static FromArray(array, offset = 0) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(array[offset], array[offset + 1]);
    }
    /**
     * Sets "result" from the given index element of the given array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#80
     * @param array defines the data source
     * @param offset defines the offset in the data source
     * @param result defines the target vector
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result.x = array[offset];
        result.y = array[offset + 1];
        return result;
    }
    /**
     * Sets the given vector "result" with the given floats.
     * @param x defines the x coordinate of the source
     * @param y defines the y coordinate of the source
     * @param result defines the Vector2 where to store the result
     * @returns the result vector
     */ static FromFloatsToRef(x, y, result) {
        result.copyFromFloats(x, y);
        return result;
    }
    /**
     * Gets a new Vector2 located for "amount" (float) on the CatmullRom spline defined by the given four Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#65
     * @param value1 defines 1st point of control
     * @param value2 defines 2nd point of control
     * @param value3 defines 3rd point of control
     * @param value4 defines 4th point of control
     * @param amount defines the interpolation factor
     * @returns a new Vector2
     */ static CatmullRom(value1, value2, value3, value4, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const x = 0.5 * (2.0 * value2.x + (-value1.x + value3.x) * amount + (2.0 * value1.x - 5.0 * value2.x + 4.0 * value3.x - value4.x) * squared + (-value1.x + 3.0 * value2.x - 3.0 * value3.x + value4.x) * cubed);
        const y = 0.5 * (2.0 * value2.y + (-value1.y + value3.y) * amount + (2.0 * value1.y - 5.0 * value2.y + 4.0 * value3.y - value4.y) * squared + (-value1.y + 3.0 * value2.y - 3.0 * value3.y + value4.y) * cubed);
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(x, y);
    }
    /**
     * Sets reference with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max".
     * If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate.
     * If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate
     * @param value defines the value to clamp
     * @param min defines the lower limit
     * @param max defines the upper limit
     * @param ref the reference
     * @returns the reference
     */ static ClampToRef(value, min, max, ref) {
        ref.x = (0, $iosaP.Clamp)(value.x, min.x, max.x);
        ref.y = (0, $iosaP.Clamp)(value.y, min.y, max.y);
        return ref;
    }
    /**
     * Returns a new Vector2 set with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max".
     * If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate.
     * If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate
     * Example Playground https://playground.babylonjs.com/#QYBWV4#76
     * @param value defines the value to clamp
     * @param min defines the lower limit
     * @param max defines the upper limit
     * @returns a new Vector2
     */ static Clamp(value, min, max) {
        const x = (0, $iosaP.Clamp)(value.x, min.x, max.x);
        const y = (0, $iosaP.Clamp)(value.y, min.y, max.y);
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(x, y);
    }
    /**
     * Returns a new Vector2 located for "amount" (float) on the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#81
     * @param value1 defines the 1st control point
     * @param tangent1 defines the outgoing tangent
     * @param value2 defines the 2nd control point
     * @param tangent2 defines the incoming tangent
     * @param amount defines the interpolation factor
     * @returns a new Vector2
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const x = value1.x * part1 + value2.x * part2 + tangent1.x * part3 + tangent2.x * part4;
        const y = value1.y * part1 + value2.y * part2 + tangent1.y * part3 + tangent2.y * part4;
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(x, y);
    }
    /**
     * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#82
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        return this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, new $c7e4de670ed74d35$export$c977b3e384af9ae1());
    }
    /**
     * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#83
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where the derivative will be stored
     * @returns result input
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result.x = (t2 - time) * 6 * value1.x + (3 * t2 - 4 * time + 1) * tangent1.x + (-t2 + time) * 6 * value2.x + (3 * t2 - 2 * time) * tangent2.x;
        result.y = (t2 - time) * 6 * value1.y + (3 * t2 - 4 * time + 1) * tangent1.y + (-t2 + time) * 6 * value2.y + (3 * t2 - 2 * time) * tangent2.y;
        return result;
    }
    /**
     * Returns a new Vector2 located for "amount" (float) on the linear interpolation between the vector "start" adn the vector "end".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#84
     * @param start defines the start vector
     * @param end defines the end vector
     * @param amount defines the interpolation factor
     * @returns a new Vector2
     */ static Lerp(start, end, amount) {
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.LerpToRef(start, end, amount, new $c7e4de670ed74d35$export$c977b3e384af9ae1());
    }
    /**
     * Sets the given vector "result" with the result of the linear interpolation from the vector "start" for "amount" to the vector "end"
     * @param start defines the start value
     * @param end defines the end value
     * @param amount max defines amount between both (between 0 and 1)
     * @param result defines the Vector2 where to store the result
     * @returns result input
     */ static LerpToRef(start, end, amount, result) {
        result.x = start.x + (end.x - start.x) * amount;
        result.y = start.y + (end.y - start.y) * amount;
        return result;
    }
    /**
     * Gets the dot product of the vector "left" and the vector "right"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#90
     * @param left defines first vector
     * @param right defines second vector
     * @returns the dot product (float)
     */ static Dot(left, right) {
        return left.x * right.x + left.y * right.y;
    }
    /**
     * Returns a new Vector2 equal to the normalized given vector
     * Example Playground https://playground.babylonjs.com/#QYBWV4#46
     * @param vector defines the vector to normalize
     * @returns a new Vector2
     */ static Normalize(vector) {
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.NormalizeToRef(vector, new $c7e4de670ed74d35$export$c977b3e384af9ae1());
    }
    /**
     * Normalize a given vector into a second one
     * Example Playground https://playground.babylonjs.com/#QYBWV4#50
     * @param vector defines the vector to normalize
     * @param result defines the vector where to store the result
     * @returns result input
     */ static NormalizeToRef(vector, result) {
        vector.normalizeToRef(result);
        return result;
    }
    /**
     * Gets a new Vector2 set with the minimal coordinate values from the "left" and "right" vectors
     * Example Playground https://playground.babylonjs.com/#QYBWV4#86
     * @param left defines 1st vector
     * @param right defines 2nd vector
     * @returns a new Vector2
     */ static Minimize(left, right) {
        const x = left.x < right.x ? left.x : right.x;
        const y = left.y < right.y ? left.y : right.y;
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(x, y);
    }
    /**
     * Gets a new Vector2 set with the maximal coordinate values from the "left" and "right" vectors
     * Example Playground https://playground.babylonjs.com/#QYBWV4#86
     * @param left defines 1st vector
     * @param right defines 2nd vector
     * @returns a new Vector2
     */ static Maximize(left, right) {
        const x = left.x > right.x ? left.x : right.x;
        const y = left.y > right.y ? left.y : right.y;
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(x, y);
    }
    /**
     * Gets a new Vector2 set with the transformed coordinates of the given vector by the given transformation matrix
     * Example Playground https://playground.babylonjs.com/#QYBWV4#17
     * @param vector defines the vector to transform
     * @param transformation defines the matrix to apply
     * @returns a new Vector2
     */ static Transform(vector, transformation) {
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.TransformToRef(vector, transformation, new $c7e4de670ed74d35$export$c977b3e384af9ae1());
    }
    /**
     * Transforms the given vector coordinates by the given transformation matrix and stores the result in the vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#19
     * @param vector defines the vector to transform
     * @param transformation defines the matrix to apply
     * @param result defines the target vector
     * @returns result input
     */ static TransformToRef(vector, transformation, result) {
        const m = transformation.m;
        const x = vector.x * m[0] + vector.y * m[4] + m[12];
        const y = vector.x * m[1] + vector.y * m[5] + m[13];
        result.x = x;
        result.y = y;
        return result;
    }
    /**
     * Determines if a given vector is included in a triangle
     * Example Playground https://playground.babylonjs.com/#QYBWV4#87
     * @param p defines the vector to test
     * @param p0 defines 1st triangle point
     * @param p1 defines 2nd triangle point
     * @param p2 defines 3rd triangle point
     * @returns true if the point "p" is in the triangle defined by the vectors "p0", "p1", "p2"
     */ static PointInTriangle(p, p0, p1, p2) {
        const a = 0.5 * (-p1.y * p2.x + p0.y * (-p1.x + p2.x) + p0.x * (p1.y - p2.y) + p1.x * p2.y);
        const sign = a < 0 ? -1 : 1;
        const s = (p0.y * p2.x - p0.x * p2.y + (p2.y - p0.y) * p.x + (p0.x - p2.x) * p.y) * sign;
        const t = (p0.x * p1.y - p0.y * p1.x + (p0.y - p1.y) * p.x + (p1.x - p0.x) * p.y) * sign;
        return s > 0 && t > 0 && s + t < 2 * a * sign;
    }
    /**
     * Gets the distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#71
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @returns the distance between vectors
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$c977b3e384af9ae1.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#72
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @returns the squared distance between vectors
     */ static DistanceSquared(value1, value2) {
        const x = value1.x - value2.x;
        const y = value1.y - value2.y;
        return x * x + y * y;
    }
    /**
     * Gets a new Vector2 located at the center of the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#86
     * Example Playground https://playground.babylonjs.com/#QYBWV4#66
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @returns a new Vector2
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.CenterToRef(value1, value2, new $c7e4de670ed74d35$export$c977b3e384af9ae1());
    }
    /**
     * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#66
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @param ref defines third vector
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2);
    }
    /**
     * Gets the shortest distance (float) between the point "p" and the segment defined by the two points "segA" and "segB".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#77
     * @param p defines the middle point
     * @param segA defines one point of the segment
     * @param segB defines the other point of the segment
     * @returns the shortest distance
     */ static DistanceOfPointFromSegment(p, segA, segB) {
        const l2 = $c7e4de670ed74d35$export$c977b3e384af9ae1.DistanceSquared(segA, segB);
        if (l2 === 0.0) return $c7e4de670ed74d35$export$c977b3e384af9ae1.Distance(p, segA);
        const v = segB.subtract(segA);
        const t = Math.max(0, Math.min(1, $c7e4de670ed74d35$export$c977b3e384af9ae1.Dot(p.subtract(segA), v) / l2));
        const proj = segA.add(v.multiplyByFloats(t, t));
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.Distance(p, proj);
    }
}
/**
 * If the first vector is flagged with integers (as everything is 0,0), V8 stores all of the properties as integers internally because it doesn't know any better yet.
 * If subsequent vectors are created with non-integer values, V8 determines that it would be best to represent these properties as doubles instead of integers,
 * and henceforth it will use floating-point representation for all Vector2 instances that it creates.
 * But the original Vector2 instances are unchanged and has a "deprecated map".
 * If we keep using the Vector2 instances from step 1, it will now be a poison pill which will mess up optimizations in any code it touches.
 */ $c7e4de670ed74d35$export$c977b3e384af9ae1._V8PerformanceHack = new $c7e4de670ed74d35$export$c977b3e384af9ae1(0.5, 0.5);
$c7e4de670ed74d35$export$c977b3e384af9ae1._ZeroReadOnly = $c7e4de670ed74d35$export$c977b3e384af9ae1.Zero();
$c7e4de670ed74d35$export$c977b3e384af9ae1;
Object.defineProperties($c7e4de670ed74d35$export$c977b3e384af9ae1.prototype, {
    dimension: {
        value: [
            2
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$64b5c384219d3699 {
    /** Gets or sets the x coordinate */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._isDirty = true;
    }
    /** Gets or sets the y coordinate */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._isDirty = true;
    }
    /** Gets or sets the z coordinate */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._isDirty = true;
    }
    /**
     * Creates a new Vector3 object from the given x, y, z (floats) coordinates.
     * @param x defines the first coordinates (on X axis)
     * @param y defines the second coordinates (on Y axis)
     * @param z defines the third coordinates (on Z axis)
     */ constructor(x = 0, y = 0, z = 0){
        /** @internal */ this._isDirty = true;
        this._x = x;
        this._y = y;
        this._z = z;
    }
    /**
     * Creates a string representation of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#67
     * @returns a string with the Vector3 coordinates.
     */ toString() {
        return `{X: ${this._x} Y: ${this._y} Z: ${this._z}}`;
    }
    /**
     * Gets the class name
     * @returns the string "Vector3"
     */ getClassName() {
        return "Vector3";
    }
    /**
     * Creates the Vector3 hash code
     * @returns a number which tends to be unique between Vector3 instances
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this._x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this._y);
        const z = $c7e4de670ed74d35$var$_ExtractAsInt(this._z);
        let hash = x;
        hash = hash * 397 ^ y;
        hash = hash * 397 ^ z;
        return hash;
    }
    // Operators
    /**
     * Creates an array containing three elements : the coordinates of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#10
     * @returns a new array of numbers
     */ asArray() {
        return [
            this._x,
            this._y,
            this._z
        ];
    }
    /**
     * Populates the given array or Float32Array from the given index with the successive coordinates of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#65
     * @param array defines the destination array
     * @param index defines the offset in the destination array
     * @returns the current Vector3
     */ toArray(array, index = 0) {
        array[index] = this._x;
        array[index + 1] = this._y;
        array[index + 2] = this._z;
        return this;
    }
    /**
     * Update the current vector from an array
     * Example Playground https://playground.babylonjs.com/#R1F8YU#24
     * @param array defines the destination array
     * @param offset defines the offset in the destination array
     * @returns the current Vector3
     */ fromArray(array, offset = 0) {
        $c7e4de670ed74d35$export$64b5c384219d3699.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Converts the current Vector3 into a quaternion (considering that the Vector3 contains Euler angles representation of a rotation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#66
     * @returns a new Quaternion object, computed from the Vector3 coordinates
     */ toQuaternion() {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRoll(this._y, this._x, this._z);
    }
    /**
     * Adds the given vector to the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#4
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ addInPlace(otherVector) {
        this._x += otherVector._x;
        this._y += otherVector._y;
        this._z += otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Adds the given coordinates to the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#5
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ addInPlaceFromFloats(x, y, z) {
        this._x += x;
        this._y += y;
        this._z += z;
        this._isDirty = true;
        return this;
    }
    /**
     * Gets a new Vector3, result of the addition the current Vector3 and the given vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#3
     * @param otherVector defines the second operand
     * @returns the resulting Vector3
     */ add(otherVector) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x + otherVector._x, this._y + otherVector._y, this._z + otherVector._z);
    }
    /**
     * Adds the current Vector3 to the given one and stores the result in the vector "result"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#6
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ addToRef(otherVector, result) {
        result._x = this._x + otherVector._x;
        result._y = this._y + otherVector._y;
        result._z = this._z + otherVector._z;
        result._isDirty = true;
        return result;
    }
    /**
     * Subtract the given vector from the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#61
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ subtractInPlace(otherVector) {
        this._x -= otherVector._x;
        this._y -= otherVector._y;
        this._z -= otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Returns a new Vector3, result of the subtraction of the given vector from the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#60
     * @param otherVector defines the second operand
     * @returns the resulting Vector3
     */ subtract(otherVector) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x - otherVector._x, this._y - otherVector._y, this._z - otherVector._z);
    }
    /**
     * Subtracts the given vector from the current Vector3 and stores the result in the vector "result".
     * Example Playground https://playground.babylonjs.com/#R1F8YU#63
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ subtractToRef(otherVector, result) {
        return this.subtractFromFloatsToRef(otherVector._x, otherVector._y, otherVector._z, result);
    }
    /**
     * Returns a new Vector3 set with the subtraction of the given floats from the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#62
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the resulting Vector3
     */ subtractFromFloats(x, y, z) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x - x, this._y - y, this._z - z);
    }
    /**
     * Subtracts the given floats from the current Vector3 coordinates and set the given vector "result" with this result
     * Example Playground https://playground.babylonjs.com/#R1F8YU#64
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ subtractFromFloatsToRef(x, y, z, result) {
        result._x = this._x - x;
        result._y = this._y - y;
        result._z = this._z - z;
        result._isDirty = true;
        return result;
    }
    /**
     * Gets a new Vector3 set with the current Vector3 negated coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#35
     * @returns a new Vector3
     */ negate() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(-this._x, -this._y, -this._z);
    }
    /**
     * Negate this vector in place
     * Example Playground https://playground.babylonjs.com/#R1F8YU#36
     * @returns this
     */ negateInPlace() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._isDirty = true;
        return this;
    }
    /**
     * Negate the current Vector3 and stores the result in the given vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#37
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ negateToRef(result) {
        result._x = this._x * -1;
        result._y = this._y * -1;
        result._z = this._z * -1;
        result._isDirty = true;
        return result;
    }
    /**
     * Multiplies the Vector3 coordinates by the float "scale"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#56
     * @param scale defines the multiplier factor
     * @returns the current updated Vector3
     */ scaleInPlace(scale) {
        this._x *= scale;
        this._y *= scale;
        this._z *= scale;
        this._isDirty = true;
        return this;
    }
    /**
     * Returns a new Vector3 set with the current Vector3 coordinates multiplied by the float "scale"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#53
     * @param scale defines the multiplier factor
     * @returns a new Vector3
     */ scale(scale) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x * scale, this._y * scale, this._z * scale);
    }
    /**
     * Multiplies the current Vector3 coordinates by the float "scale" and stores the result in the given vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#57
     * @param scale defines the multiplier factor
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ scaleToRef(scale, result) {
        result._x = this._x * scale;
        result._y = this._y * scale;
        result._z = this._z * scale;
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a vector normal (perpendicular) to the current Vector3 and stores the result in the given vector
     * Out of the infinite possibilities the normal chosen is the one formed by rotating the current vector
     * 90 degrees about an axis which lies perpendicular to the current vector
     * and its projection on the xz plane. In the case of a current vector in the xz plane
     * the normal is calculated to be along the y axis.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#230
     * Example Playground https://playground.babylonjs.com/#R1F8YU#231
     * @param result defines the Vector3 object where to store the resultant normal
     * @returns the result
     */ getNormalToRef(result) {
        /**
         * Calculates the spherical coordinates of the current vector
         * so saves on memory rather than importing whole Spherical Class
         */ const radius = this.length();
        let theta = Math.acos(this.y / radius);
        const phi = Math.atan2(this.z, this.x);
        //makes angle 90 degs to current vector
        if (theta > Math.PI / 2) theta -= Math.PI / 2;
        else theta += Math.PI / 2;
        //Calculates resutant normal vector from spherical coordinate of perpendicular vector
        const x = radius * Math.sin(theta) * Math.cos(phi);
        const y = radius * Math.cos(theta);
        const z = radius * Math.sin(theta) * Math.sin(phi);
        result.set(x, y, z);
        return result;
    }
    /**
     * Rotates the vector using the given unit quaternion and stores the new vector in result
     * Example Playground https://playground.babylonjs.com/#R1F8YU#9
     * @param q the unit quaternion representing the rotation
     * @param result the output vector
     * @returns the result
     */ applyRotationQuaternionToRef(q, result) {
        // Derived from https://raw.org/proof/vector-rotation-using-quaternions/
        const vx = this._x, vy = this._y, vz = this._z;
        const qx = q._x, qy = q._y, qz = q._z, qw = q._w;
        // t = 2q x v
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + w t + q x t
        result._x = vx + qw * tx + qy * tz - qz * ty;
        result._y = vy + qw * ty + qz * tx - qx * tz;
        result._z = vz + qw * tz + qx * ty - qy * tx;
        result._isDirty = true;
        return result;
    }
    /**
     * Rotates the vector in place using the given unit quaternion
     * Example Playground https://playground.babylonjs.com/#R1F8YU#8
     * @param q the unit quaternion representing the rotation
     * @returns the current updated Vector3
     */ applyRotationQuaternionInPlace(q) {
        return this.applyRotationQuaternionToRef(q, this);
    }
    /**
     * Rotates the vector using the given unit quaternion and returns the new vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#7
     * @param q the unit quaternion representing the rotation
     * @returns a new Vector3
     */ applyRotationQuaternion(q) {
        return this.applyRotationQuaternionToRef(q, new $c7e4de670ed74d35$export$64b5c384219d3699());
    }
    /**
     * Scale the current Vector3 values by a factor and add the result to a given Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#55
     * @param scale defines the scale factor
     * @param result defines the Vector3 object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result._x += this._x * scale;
        result._y += this._y * scale;
        result._z += this._z * scale;
        result._isDirty = true;
        return result;
    }
    /**
     * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#48
     * @param plane defines the plane to project to
     * @param origin defines the origin of the projection ray
     * @returns the projected vector3
     */ projectOnPlane(plane, origin) {
        return this.projectOnPlaneToRef(plane, origin, new $c7e4de670ed74d35$export$64b5c384219d3699());
    }
    /**
     * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#49
     * @param plane defines the plane to project to
     * @param origin defines the origin of the projection ray
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ projectOnPlaneToRef(plane, origin, result) {
        const n = plane.normal;
        const d = plane.d;
        const V = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        // ray direction
        this.subtractToRef(origin, V);
        V.normalize();
        const denom = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(V, n);
        //When the ray is close to parallel to the plane return infinity vector
        if (Math.abs(denom) < 0.0000000001) result.setAll(Infinity);
        else {
            const t = -($c7e4de670ed74d35$export$64b5c384219d3699.Dot(origin, n) + d) / denom;
            // P = P0 + t*V
            const scaledV = V.scaleInPlace(t);
            origin.addToRef(scaledV, result);
        }
        return result;
    }
    /**
     * Returns true if the current Vector3 and the given vector coordinates are strictly equal
     * Example Playground https://playground.babylonjs.com/#R1F8YU#19
     * @param otherVector defines the second operand
     * @returns true if both vectors are equals
     */ equals(otherVector) {
        return otherVector && this._x === otherVector._x && this._y === otherVector._y && this._z === otherVector._z;
    }
    /**
     * Returns true if the current Vector3 and the given vector coordinates are distant less than epsilon
     * Example Playground https://playground.babylonjs.com/#R1F8YU#21
     * @param otherVector defines the second operand
     * @param epsilon defines the minimal distance to define values as equals
     * @returns true if both vectors are distant less than epsilon
     */ equalsWithEpsilon(otherVector, epsilon = (0, $53VPf.Epsilon)) {
        return otherVector && (0, $iosaP.WithinEpsilon)(this._x, otherVector._x, epsilon) && (0, $iosaP.WithinEpsilon)(this._y, otherVector._y, epsilon) && (0, $iosaP.WithinEpsilon)(this._z, otherVector._z, epsilon);
    }
    /**
     * Returns true if the current Vector3 coordinates equals the given floats
     * Example Playground https://playground.babylonjs.com/#R1F8YU#20
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns true if both vectors are equal
     */ equalsToFloats(x, y, z) {
        return this._x === x && this._y === y && this._z === z;
    }
    /**
     * Multiplies the current Vector3 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#32
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ multiplyInPlace(otherVector) {
        this._x *= otherVector._x;
        this._y *= otherVector._y;
        this._z *= otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Returns a new Vector3, result of the multiplication of the current Vector3 by the given vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#31
     * @param otherVector defines the second operand
     * @returns the new Vector3
     */ multiply(otherVector) {
        return this.multiplyByFloats(otherVector._x, otherVector._y, otherVector._z);
    }
    /**
     * Multiplies the current Vector3 by the given one and stores the result in the given vector "result"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#33
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ multiplyToRef(otherVector, result) {
        result._x = this._x * otherVector._x;
        result._y = this._y * otherVector._y;
        result._z = this._z * otherVector._z;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 set with the result of the multiplication of the current Vector3 coordinates by the given floats
     * Example Playground https://playground.babylonjs.com/#R1F8YU#34
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the new Vector3
     */ multiplyByFloats(x, y, z) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x * x, this._y * y, this._z * z);
    }
    /**
     * Returns a new Vector3 set with the result of the division of the current Vector3 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#16
     * @param otherVector defines the second operand
     * @returns the new Vector3
     */ divide(otherVector) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x / otherVector._x, this._y / otherVector._y, this._z / otherVector._z);
    }
    /**
     * Divides the current Vector3 coordinates by the given ones and stores the result in the given vector "result"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#18
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ divideToRef(otherVector, result) {
        result._x = this._x / otherVector._x;
        result._y = this._y / otherVector._y;
        result._z = this._z / otherVector._z;
        result._isDirty = true;
        return result;
    }
    /**
     * Divides the current Vector3 coordinates by the given ones.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#17
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ divideInPlace(otherVector) {
        this._x = this._x / otherVector._x;
        this._y = this._y / otherVector._y;
        this._z = this._z / otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Updates the current Vector3 with the minimal coordinate values between its and the given vector ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#29
     * @param other defines the second operand
     * @returns the current updated Vector3
     */ minimizeInPlace(other) {
        return this.minimizeInPlaceFromFloats(other._x, other._y, other._z);
    }
    /**
     * Updates the current Vector3 with the maximal coordinate values between its and the given vector ones.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#27
     * @param other defines the second operand
     * @returns the current updated Vector3
     */ maximizeInPlace(other) {
        return this.maximizeInPlaceFromFloats(other._x, other._y, other._z);
    }
    /**
     * Updates the current Vector3 with the minimal coordinate values between its and the given coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#30
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ minimizeInPlaceFromFloats(x, y, z) {
        if (x < this._x) this.x = x;
        if (y < this._y) this.y = y;
        if (z < this._z) this.z = z;
        return this;
    }
    /**
     * Updates the current Vector3 with the maximal coordinate values between its and the given coordinates.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#28
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ maximizeInPlaceFromFloats(x, y, z) {
        if (x > this._x) this.x = x;
        if (y > this._y) this.y = y;
        if (z > this._z) this.z = z;
        return this;
    }
    /**
     * Due to float precision, scale of a mesh could be uniform but float values are off by a small fraction
     * Check if is non uniform within a certain amount of decimal places to account for this
     * @param epsilon the amount the values can differ
     * @returns if the vector is non uniform to a certain number of decimal places
     */ isNonUniformWithinEpsilon(epsilon) {
        const absX = Math.abs(this._x);
        const absY = Math.abs(this._y);
        if (!(0, $iosaP.WithinEpsilon)(absX, absY, epsilon)) return true;
        const absZ = Math.abs(this._z);
        if (!(0, $iosaP.WithinEpsilon)(absX, absZ, epsilon)) return true;
        if (!(0, $iosaP.WithinEpsilon)(absY, absZ, epsilon)) return true;
        return false;
    }
    /**
     * Gets a boolean indicating that the vector is non uniform meaning x, y or z are not all the same
     */ get isNonUniform() {
        const absX = Math.abs(this._x);
        const absY = Math.abs(this._y);
        if (absX !== absY) return true;
        const absZ = Math.abs(this._z);
        if (absX !== absZ) return true;
        return false;
    }
    /**
     * Gets the current Vector3's floored values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ floorToRef(result) {
        result._x = Math.floor(this._x);
        result._y = Math.floor(this._y);
        result._z = Math.floor(this._z);
        result._isDirty = true;
        return result;
    }
    /**
     * Gets a new Vector3 from current Vector3 floored values
     * Example Playground https://playground.babylonjs.com/#R1F8YU#22
     * @returns a new Vector3
     */ floor() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z));
    }
    /**
     * Gets the current Vector3's fractional values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ fractToRef(result) {
        result._x = this.x - Math.floor(this._x);
        result._y = this.y - Math.floor(this._y);
        result._z = this.z - Math.floor(this._z);
        result._isDirty = true;
        return result;
    }
    /**
     * Gets a new Vector3 from current Vector3 fractional values
     * Example Playground https://playground.babylonjs.com/#R1F8YU#23
     * @returns a new Vector3
     */ fract() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this.x - Math.floor(this._x), this.y - Math.floor(this._y), this.z - Math.floor(this._z));
    }
    // Properties
    /**
     * Gets the length of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#25
     * @returns the length of the Vector3
     */ length() {
        return Math.sqrt(this.lengthSquared());
    }
    /**
     * Gets the squared length of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#26
     * @returns squared length of the Vector3
     */ lengthSquared() {
        return this._x * this._x + this._y * this._y + this._z * this._z;
    }
    /**
     * Gets a boolean indicating if the vector contains a zero in one of its components
     * Example Playground https://playground.babylonjs.com/#R1F8YU#1
     */ get hasAZeroComponent() {
        return this._x * this._y * this._z === 0;
    }
    /**
     * Normalize the current Vector3.
     * Please note that this is an in place operation.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#122
     * @returns the current updated Vector3
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Reorders the x y z properties of the vector in place
     * Example Playground https://playground.babylonjs.com/#R1F8YU#44
     * @param order new ordering of the properties (eg. for vector 1,2,3 with "ZYX" will produce 3,2,1)
     * @returns the current updated vector
     */ reorderInPlace(order) {
        order = order.toLowerCase();
        if (order === "xyz") return this;
        const tem = $c7e4de670ed74d35$var$MathTmp.Vector3[0].copyFrom(this);
        this.x = tem[order[0]];
        this.y = tem[order[1]];
        this.z = tem[order[2]];
        return this;
    }
    /**
     * Rotates the vector around 0,0,0 by a quaternion
     * Example Playground https://playground.babylonjs.com/#R1F8YU#47
     * @param quaternion the rotation quaternion
     * @param result vector to store the result
     * @returns the resulting vector
     */ rotateByQuaternionToRef(quaternion, result) {
        quaternion.toRotationMatrix($c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(this, $c7e4de670ed74d35$var$MathTmp.Matrix[0], result);
        return result;
    }
    /**
     * Rotates a vector around a given point
     * Example Playground https://playground.babylonjs.com/#R1F8YU#46
     * @param quaternion the rotation quaternion
     * @param point the point to rotate around
     * @param result vector to store the result
     * @returns the resulting vector
     */ rotateByQuaternionAroundPointToRef(quaternion, point, result) {
        this.subtractToRef(point, $c7e4de670ed74d35$var$MathTmp.Vector3[0]);
        $c7e4de670ed74d35$var$MathTmp.Vector3[0].rotateByQuaternionToRef(quaternion, $c7e4de670ed74d35$var$MathTmp.Vector3[0]);
        point.addToRef($c7e4de670ed74d35$var$MathTmp.Vector3[0], result);
        return result;
    }
    /**
     * Returns a new Vector3 as the cross product of the current vector and the "other" one
     * The cross product is then orthogonal to both current and "other"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#14
     * @param other defines the right operand
     * @returns the cross product
     */ cross(other) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(this, other, new $c7e4de670ed74d35$export$64b5c384219d3699());
    }
    /**
     * Normalize the current Vector3 with the given input length.
     * Please note that this is an in place operation.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#123
     * @param len the length of the vector
     * @returns the current updated Vector3
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize the current Vector3 to a new vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#124
     * @returns the new Vector3
     */ normalizeToNew() {
        return this.normalizeToRef(new $c7e4de670ed74d35$export$64b5c384219d3699());
    }
    /**
     * Normalize the current Vector3 to the reference
     * Example Playground https://playground.babylonjs.com/#R1F8YU#125
     * @param result define the Vector3 to update
     * @returns the updated Vector3
     */ normalizeToRef(result) {
        const len = this.length();
        if (len === 0 || len === 1.0) {
            result._x = this._x;
            result._y = this._y;
            result._z = this._z;
            result._isDirty = true;
            return result;
        }
        return this.scaleToRef(1.0 / len, result);
    }
    /**
     * Creates a new Vector3 copied from the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#11
     * @returns the new Vector3
     */ clone() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._x, this._y, this._z);
    }
    /**
     * Copies the given vector coordinates to the current Vector3 ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#12
     * @param source defines the source Vector3
     * @returns the current updated Vector3
     */ copyFrom(source) {
        return this.copyFromFloats(source._x, source._y, source._z);
    }
    /**
     * Copies the given floats to the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#13
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ copyFromFloats(x, y, z) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._isDirty = true;
        return this;
    }
    /**
     * Copies the given floats to the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#58
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ set(x, y, z) {
        return this.copyFromFloats(x, y, z);
    }
    /**
     * Copies the given float to the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#59
     * @param v defines the x, y and z coordinates of the operand
     * @returns the current updated Vector3
     */ setAll(v) {
        this._x = this._y = this._z = v;
        this._isDirty = true;
        return this;
    }
    // Statics
    /**
     * Get the clip factor between two vectors
     * Example Playground https://playground.babylonjs.com/#R1F8YU#126
     * @param vector0 defines the first operand
     * @param vector1 defines the second operand
     * @param axis defines the axis to use
     * @param size defines the size along the axis
     * @returns the clip factor
     */ static GetClipFactor(vector0, vector1, axis, size) {
        const d0 = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vector0, axis);
        const d1 = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vector1, axis);
        return (d0 - size) / (d0 - d1);
    }
    /**
     * Get angle between two vectors
     * Example Playground https://playground.babylonjs.com/#R1F8YU#86
     * @param vector0 the starting point
     * @param vector1 the ending point
     * @param normal direction of the normal
     * @returns the angle between vector0 and vector1
     */ static GetAngleBetweenVectors(vector0, vector1, normal) {
        const v0 = vector0.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[1]);
        const v1 = vector1.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[2]);
        let dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(v0, v1);
        // Vectors are normalized so dot will be in [-1, 1] (aside precision issues enough to break the result which explains the below clamp)
        dot = (0, $iosaP.Clamp)(dot, -1, 1);
        const angle = Math.acos(dot);
        const n = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v0, v1, n);
        if ($c7e4de670ed74d35$export$64b5c384219d3699.Dot(n, normal) > 0) return isNaN(angle) ? 0 : angle;
        return isNaN(angle) ? -Math.PI : -Math.acos(dot);
    }
    /**
     * Get angle between two vectors projected on a plane
     * Example Playground https://playground.babylonjs.com/#R1F8YU#87
     * Expectation compute time: 0.01 ms (median) and 0.02 ms (percentile 95%)
     * @param vector0 angle between vector0 and vector1
     * @param vector1 angle between vector0 and vector1
     * @param normal Normal of the projection plane
     * @returns the angle in radians (float) between vector0 and vector1 projected on the plane with the specified normal
     */ static GetAngleBetweenVectorsOnPlane(vector0, vector1, normal) {
        $c7e4de670ed74d35$var$MathTmp.Vector3[0].copyFrom(vector0);
        const v0 = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        $c7e4de670ed74d35$var$MathTmp.Vector3[1].copyFrom(vector1);
        const v1 = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        $c7e4de670ed74d35$var$MathTmp.Vector3[2].copyFrom(normal);
        const vNormal = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        const right = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        const forward = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        v0.normalize();
        v1.normalize();
        vNormal.normalize();
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(vNormal, v0, right);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(right, vNormal, forward);
        const angle = Math.atan2($c7e4de670ed74d35$export$64b5c384219d3699.Dot(v1, right), $c7e4de670ed74d35$export$64b5c384219d3699.Dot(v1, forward));
        return (0, $iosaP.NormalizeRadians)(angle);
    }
    /**
     * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point and stores it in the ref Vector3
     * Example PG https://playground.babylonjs.com/#R1F8YU#189
     * @param start the starting point
     * @param target the target point
     * @param ref the vector3 to store the result
     * @returns ref in the form (pitch, yaw, 0)
     */ static PitchYawRollToMoveBetweenPointsToRef(start, target, ref) {
        const diff = $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0];
        target.subtractToRef(start, diff);
        ref._y = Math.atan2(diff.x, diff.z) || 0;
        ref._x = Math.atan2(Math.sqrt(diff.x ** 2 + diff.z ** 2), diff.y) || 0;
        ref._z = 0;
        ref._isDirty = true;
        return ref;
    }
    /**
     * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point
     * Example PG https://playground.babylonjs.com/#R1F8YU#188
     * @param start the starting point
     * @param target the target point
     * @returns the rotation in the form (pitch, yaw, 0)
     */ static PitchYawRollToMoveBetweenPoints(start, target) {
        const ref = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        return $c7e4de670ed74d35$export$64b5c384219d3699.PitchYawRollToMoveBetweenPointsToRef(start, target, ref);
    }
    /**
     * Slerp between two vectors. See also `SmoothToRef`
     * Slerp is a spherical linear interpolation
     * giving a slow in and out effect
     * Example Playground 1 https://playground.babylonjs.com/#R1F8YU#108
     * Example Playground 2 https://playground.babylonjs.com/#R1F8YU#109
     * @param vector0 Start vector
     * @param vector1 End vector
     * @param slerp amount (will be clamped between 0 and 1)
     * @param result The slerped vector
     * @returns The slerped vector
     */ static SlerpToRef(vector0, vector1, slerp, result) {
        slerp = (0, $iosaP.Clamp)(slerp, 0, 1);
        const vector0Dir = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const vector1Dir = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        vector0Dir.copyFrom(vector0);
        const vector0Length = vector0Dir.length();
        vector0Dir.normalizeFromLength(vector0Length);
        vector1Dir.copyFrom(vector1);
        const vector1Length = vector1Dir.length();
        vector1Dir.normalizeFromLength(vector1Length);
        const dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vector0Dir, vector1Dir);
        let scale0;
        let scale1;
        if (dot < 1 - (0, $53VPf.Epsilon)) {
            const omega = Math.acos(dot);
            const invSin = 1 / Math.sin(omega);
            scale0 = Math.sin((1 - slerp) * omega) * invSin;
            scale1 = Math.sin(slerp * omega) * invSin;
        } else {
            // Use linear interpolation
            scale0 = 1 - slerp;
            scale1 = slerp;
        }
        vector0Dir.scaleInPlace(scale0);
        vector1Dir.scaleInPlace(scale1);
        result.copyFrom(vector0Dir).addInPlace(vector1Dir);
        result.scaleInPlace((0, $iosaP.Lerp)(vector0Length, vector1Length, slerp));
        return result;
    }
    /**
     * Smooth interpolation between two vectors using Slerp
     * Example Playground https://playground.babylonjs.com/#R1F8YU#110
     * @param source source vector
     * @param goal goal vector
     * @param deltaTime current interpolation frame
     * @param lerpTime total interpolation time
     * @param result the smoothed vector
     * @returns the smoothed vector
     */ static SmoothToRef(source, goal, deltaTime, lerpTime, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.SlerpToRef(source, goal, lerpTime === 0 ? 1 : deltaTime / lerpTime, result);
        return result;
    }
    /**
     * Returns a new Vector3 set from the index "offset" of the given array
     * Example Playground https://playground.babylonjs.com/#R1F8YU#83
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @returns the new Vector3
     */ static FromArray(array, offset = 0) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(array[offset], array[offset + 1], array[offset + 2]);
    }
    /**
     * Returns a new Vector3 set from the index "offset" of the given Float32Array
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @returns the new Vector3
     * @deprecated Please use FromArray instead.
     */ static FromFloatArray(array, offset) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.FromArray(array, offset);
    }
    /**
     * Sets the given vector "result" with the element values from the index "offset" of the given array
     * Example Playground https://playground.babylonjs.com/#R1F8YU#84
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result._x = array[offset];
        result._y = array[offset + 1];
        result._z = array[offset + 2];
        result._isDirty = true;
        return result;
    }
    /**
     * Sets the given vector "result" with the element values from the index "offset" of the given Float32Array
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @param result defines the Vector3 where to store the result
     * @deprecated Please use FromArrayToRef instead.
     * @returns result input
     */ static FromFloatArrayToRef(array, offset, result) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.FromArrayToRef(array, offset, result);
    }
    /**
     * Sets the given vector "result" with the given floats.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#85
     * @param x defines the x coordinate of the source
     * @param y defines the y coordinate of the source
     * @param z defines the z coordinate of the source
     * @param result defines the Vector3 where to store the result
     * @returns the result vector
     */ static FromFloatsToRef(x, y, z, result) {
        result.copyFromFloats(x, y, z);
        return result;
    }
    /**
     * Returns a new Vector3 set to (0.0, 0.0, 0.0)
     * @returns a new empty Vector3
     */ static Zero() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 0.0, 0.0);
    }
    /**
     * Returns a new Vector3 set to (1.0, 1.0, 1.0)
     * @returns a new Vector3
     */ static One() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(1.0, 1.0, 1.0);
    }
    /**
     * Returns a new Vector3 set to (0.0, 1.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new up Vector3
     */ static Up() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 1.0, 0.0);
    }
    /**
     * Gets an up Vector3 that must not be updated
     */ static get UpReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._UpReadOnly;
    }
    /**
     * Gets a down Vector3 that must not be updated
     */ static get DownReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._DownReadOnly;
    }
    /**
     * Gets a right Vector3 that must not be updated
     */ static get RightReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._RightReadOnly;
    }
    /**
     * Gets a left Vector3 that must not be updated
     */ static get LeftReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._LeftReadOnly;
    }
    /**
     * Gets a forward Vector3 that must not be updated
     */ static get LeftHandedForwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedForwardReadOnly;
    }
    /**
     * Gets a forward Vector3 that must not be updated
     */ static get RightHandedForwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._RightHandedForwardReadOnly;
    }
    /**
     * Gets a backward Vector3 that must not be updated
     */ static get LeftHandedBackwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedBackwardReadOnly;
    }
    /**
     * Gets a backward Vector3 that must not be updated
     */ static get RightHandedBackwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._RightHandedBackwardReadOnly;
    }
    /**
     * Gets a zero Vector3 that must not be updated
     */ static get ZeroReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._ZeroReadOnly;
    }
    /**
     * Gets a one Vector3 that must not be updated
     */ static get OneReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._OneReadOnly;
    }
    /**
     * Returns a new Vector3 set to (0.0, -1.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new down Vector3
     */ static Down() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, -1, 0.0);
    }
    /**
     * Returns a new Vector3 set to (0.0, 0.0, 1.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @param rightHandedSystem is the scene right-handed (negative z)
     * @returns a new forward Vector3
     */ static Forward(rightHandedSystem = false) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 0.0, rightHandedSystem ? -1 : 1.0);
    }
    /**
     * Returns a new Vector3 set to (0.0, 0.0, -1.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @param rightHandedSystem is the scene right-handed (negative-z)
     * @returns a new Backward Vector3
     */ static Backward(rightHandedSystem = false) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 0.0, rightHandedSystem ? 1.0 : -1);
    }
    /**
     * Returns a new Vector3 set to (1.0, 0.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new right Vector3
     */ static Right() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(1.0, 0.0, 0.0);
    }
    /**
     * Returns a new Vector3 set to (-1.0, 0.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new left Vector3
     */ static Left() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(-1, 0.0, 0.0);
    }
    /**
     * Returns a new Vector3 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Vector3 with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Vector3 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Returns a new Vector3 set with the result of the transformation by the given matrix of the given vector.
     * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#111
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @returns the transformed Vector3
     */ static TransformCoordinates(vector, transformation) {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(vector, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
     * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#113
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformCoordinatesToRef(vector, transformation, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
     * This method computes transformed coordinates only, not transformed direction vectors
     * Example Playground https://playground.babylonjs.com/#R1F8YU#115
     * @param x define the x coordinate of the source vector
     * @param y define the y coordinate of the source vector
     * @param z define the z coordinate of the source vector
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformCoordinatesFromFloatsToRef(x, y, z, transformation, result) {
        const m = transformation.m;
        const rx = x * m[0] + y * m[4] + z * m[8] + m[12];
        const ry = x * m[1] + y * m[5] + z * m[9] + m[13];
        const rz = x * m[2] + y * m[6] + z * m[10] + m[14];
        const rw = 1 / (x * m[3] + y * m[7] + z * m[11] + m[15]);
        result._x = rx * rw;
        result._y = ry * rw;
        result._z = rz * rw;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 set with the result of the normal transformation by the given matrix of the given vector
     * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#112
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @returns the new Vector3
     */ static TransformNormal(vector, transformation) {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformNormalToRef(vector, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector
     * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#114
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformNormalToRef(vector, transformation, result) {
        this.TransformNormalFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z)
     * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#116
     * @param x define the x coordinate of the source vector
     * @param y define the y coordinate of the source vector
     * @param z define the z coordinate of the source vector
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformNormalFromFloatsToRef(x, y, z, transformation, result) {
        const m = transformation.m;
        result._x = x * m[0] + y * m[4] + z * m[8];
        result._y = x * m[1] + y * m[5] + z * m[9];
        result._z = x * m[2] + y * m[6] + z * m[10];
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 located for "amount" on the CatmullRom interpolation spline defined by the vectors "value1", "value2", "value3", "value4"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#69
     * @param value1 defines the first control point
     * @param value2 defines the second control point
     * @param value3 defines the third control point
     * @param value4 defines the fourth control point
     * @param amount defines the amount on the spline to use
     * @returns the new Vector3
     */ static CatmullRom(value1, value2, value3, value4, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const x = 0.5 * (2.0 * value2._x + (-value1._x + value3._x) * amount + (2.0 * value1._x - 5.0 * value2._x + 4.0 * value3._x - value4._x) * squared + (-value1._x + 3.0 * value2._x - 3.0 * value3._x + value4._x) * cubed);
        const y = 0.5 * (2.0 * value2._y + (-value1._y + value3._y) * amount + (2.0 * value1._y - 5.0 * value2._y + 4.0 * value3._y - value4._y) * squared + (-value1._y + 3.0 * value2._y - 3.0 * value3._y + value4._y) * cubed);
        const z = 0.5 * (2.0 * value2._z + (-value1._z + value3._z) * amount + (2.0 * value1._z - 5.0 * value2._z + 4.0 * value3._z - value4._z) * squared + (-value1._z + 3.0 * value2._z - 3.0 * value3._z + value4._z) * cubed);
        return new $c7e4de670ed74d35$export$64b5c384219d3699(x, y, z);
    }
    /**
     * Returns a new Vector3 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * Example Playground https://playground.babylonjs.com/#R1F8YU#76
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @returns the new Vector3
     */ static Clamp(value, min, max) {
        const result = new $c7e4de670ed74d35$export$64b5c384219d3699();
        $c7e4de670ed74d35$export$64b5c384219d3699.ClampToRef(value, min, max, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * Example Playground https://playground.babylonjs.com/#R1F8YU#77
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static ClampToRef(value, min, max, result) {
        let x = value._x;
        x = x > max._x ? max._x : x;
        x = x < min._x ? min._x : x;
        let y = value._y;
        y = y > max._y ? max._y : y;
        y = y < min._y ? min._y : y;
        let z = value._z;
        z = z > max._z ? max._z : z;
        z = z < min._z ? min._z : z;
        result.copyFromFloats(x, y, z);
        return result;
    }
    /**
     * Checks if a given vector is inside a specific range
     * Example Playground https://playground.babylonjs.com/#R1F8YU#75
     * @param v defines the vector to test
     * @param min defines the minimum range
     * @param max defines the maximum range
     */ static CheckExtends(v, min, max) {
        min.minimizeInPlace(v);
        max.maximizeInPlace(v);
    }
    /**
     * Returns a new Vector3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#89
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent vector
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent vector
     * @param amount defines the amount on the interpolation spline (between 0 and 1)
     * @returns the new Vector3
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const x = value1._x * part1 + value2._x * part2 + tangent1._x * part3 + tangent2._x * part4;
        const y = value1._y * part1 + value2._y * part2 + tangent1._y * part3 + tangent2._y * part4;
        const z = value1._z * part1 + value2._z * part2 + tangent1._z * part3 + tangent2._z * part4;
        return new $c7e4de670ed74d35$export$64b5c384219d3699(x, y, z);
    }
    /**
     * Returns a new Vector3 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#R1F8YU#90
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new $c7e4de670ed74d35$export$64b5c384219d3699();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Update a Vector3 with the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#R1F8YU#91
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     * @returns result input
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result._x = (t2 - time) * 6 * value1._x + (3 * t2 - 4 * time + 1) * tangent1._x + (-t2 + time) * 6 * value2._x + (3 * t2 - 2 * time) * tangent2._x;
        result._y = (t2 - time) * 6 * value1._y + (3 * t2 - 4 * time + 1) * tangent1._y + (-t2 + time) * 6 * value2._y + (3 * t2 - 2 * time) * tangent2._y;
        result._z = (t2 - time) * 6 * value1._z + (3 * t2 - 4 * time + 1) * tangent1._z + (-t2 + time) * 6 * value2._z + (3 * t2 - 2 * time) * tangent2._z;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 located for "amount" (float) on the linear interpolation between the vectors "start" and "end"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#95
     * @param start defines the start value
     * @param end defines the end value
     * @param amount max defines amount between both (between 0 and 1)
     * @returns the new Vector3
     */ static Lerp(start, end, amount) {
        const result = new $c7e4de670ed74d35$export$64b5c384219d3699(0, 0, 0);
        $c7e4de670ed74d35$export$64b5c384219d3699.LerpToRef(start, end, amount, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the linear interpolation from the vector "start" for "amount" to the vector "end"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#93
     * @param start defines the start value
     * @param end defines the end value
     * @param amount max defines amount between both (between 0 and 1)
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static LerpToRef(start, end, amount, result) {
        result._x = start._x + (end._x - start._x) * amount;
        result._y = start._y + (end._y - start._y) * amount;
        result._z = start._z + (end._z - start._z) * amount;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns the dot product (float) between the vectors "left" and "right"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#82
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the dot product
     */ static Dot(left, right) {
        return left._x * right._x + left._y * right._y + left._z * right._z;
    }
    /**
     * Returns the dot product (float) between the current vectors and "otherVector"
     * @param otherVector defines the right operand
     * @returns the dot product
     */ dot(otherVector) {
        return this._x * otherVector._x + this._y * otherVector._y + this._z * otherVector._z;
    }
    /**
     * Returns a new Vector3 as the cross product of the vectors "left" and "right"
     * The cross product is then orthogonal to both "left" and "right"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#15
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the cross product
     */ static Cross(left, right) {
        const result = new $c7e4de670ed74d35$export$64b5c384219d3699();
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(left, right, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the cross product of "left" and "right"
     * The cross product is then orthogonal to both "left" and "right"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#78
     * @param left defines the left operand
     * @param right defines the right operand
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static CrossToRef(left, right, result) {
        const x = left._y * right._z - left._z * right._y;
        const y = left._z * right._x - left._x * right._z;
        const z = left._x * right._y - left._y * right._x;
        result.copyFromFloats(x, y, z);
        return result;
    }
    /**
     * Returns a new Vector3 as the normalization of the given vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#98
     * @param vector defines the Vector3 to normalize
     * @returns the new Vector3
     */ static Normalize(vector) {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        $c7e4de670ed74d35$export$64b5c384219d3699.NormalizeToRef(vector, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the normalization of the given first vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#98
     * @param vector defines the Vector3 to normalize
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static NormalizeToRef(vector, result) {
        vector.normalizeToRef(result);
        return result;
    }
    /**
     * Project a Vector3 onto screen space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#101
     * @param vector defines the Vector3 to project
     * @param world defines the world matrix to use
     * @param transform defines the transform (view x projection) matrix to use
     * @param viewport defines the screen viewport to use
     * @returns the new Vector3
     */ static Project(vector, world, transform, viewport) {
        const result = new $c7e4de670ed74d35$export$64b5c384219d3699();
        $c7e4de670ed74d35$export$64b5c384219d3699.ProjectToRef(vector, world, transform, viewport, result);
        return result;
    }
    /**
     * Project a Vector3 onto screen space to reference
     * Example Playground https://playground.babylonjs.com/#R1F8YU#102
     * @param vector defines the Vector3 to project
     * @param world defines the world matrix to use
     * @param transform defines the transform (view x projection) matrix to use
     * @param viewport defines the screen viewport to use
     * @param result the vector in which the screen space will be stored
     * @returns result input
     */ static ProjectToRef(vector, world, transform, viewport, result) {
        const cw = viewport.width;
        const ch = viewport.height;
        const cx = viewport.x;
        const cy = viewport.y;
        const viewportMatrix = $c7e4de670ed74d35$var$MathTmp.Matrix[1];
        const isNDCHalfZRange = (0, $ejQPp.EngineStore).LastCreatedEngine?.isNDCHalfZRange;
        const zScale = isNDCHalfZRange ? 1 : 0.5;
        const zOffset = isNDCHalfZRange ? 0 : 0.5;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(cw / 2.0, 0, 0, 0, 0, -ch / 2.0, 0, 0, 0, 0, zScale, 0, cx + cw / 2.0, ch / 2.0 + cy, zOffset, 1, viewportMatrix);
        const matrix = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        world.multiplyToRef(transform, matrix);
        matrix.multiplyToRef(viewportMatrix, matrix);
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(vector, matrix, result);
        return result;
    }
    /**
     * Reflects a vector off the plane defined by a normalized normal
     * @param inDirection defines the vector direction
     * @param normal defines the normal - Must be normalized
     * @returns the resulting vector
     */ static Reflect(inDirection, normal) {
        return this.ReflectToRef(inDirection, normal, new $c7e4de670ed74d35$export$64b5c384219d3699());
    }
    /**
     * Reflects a vector off the plane defined by a normalized normal to reference
     * @param inDirection defines the vector direction
     * @param normal defines the normal - Must be normalized
     * @param ref defines the Vector3 where to store the result
     * @returns the resulting vector
     */ static ReflectToRef(inDirection, normal, ref) {
        const tmp = $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0];
        tmp.copyFrom(normal).scaleInPlace(2 * $c7e4de670ed74d35$export$64b5c384219d3699.Dot(inDirection, normal));
        return ref.copyFrom(inDirection).subtractInPlace(tmp);
    }
    /**
     * @internal
     */ static _UnprojectFromInvertedMatrixToRef(source, matrix, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(source, matrix, result);
        const m = matrix.m;
        const num = source._x * m[3] + source._y * m[7] + source._z * m[11] + m[15];
        if ((0, $iosaP.WithinEpsilon)(num, 1.0)) result.scaleInPlace(1.0 / num);
        return result;
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#121
     * @param source defines the screen space Vector3 to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param transform defines the transform (view x projection) matrix to use
     * @returns the new Vector3
     */ static UnprojectFromTransform(source, viewportWidth, viewportHeight, world, transform) {
        return this.Unproject(source, viewportWidth, viewportHeight, world, transform, $c7e4de670ed74d35$export$5b12bf1653c0dd85.IdentityReadOnly);
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#117
     * @param source defines the screen space Vector3 to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     * @returns the new Vector3
     */ static Unproject(source, viewportWidth, viewportHeight, world, view, projection) {
        const result = new $c7e4de670ed74d35$export$64b5c384219d3699();
        $c7e4de670ed74d35$export$64b5c384219d3699.UnprojectToRef(source, viewportWidth, viewportHeight, world, view, projection, result);
        return result;
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#119
     * @param source defines the screen space Vector3 to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static UnprojectToRef(source, viewportWidth, viewportHeight, world, view, projection, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.UnprojectFloatsToRef(source._x, source._y, source._z, viewportWidth, viewportHeight, world, view, projection, result);
        return result;
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#120
     * @param sourceX defines the screen space x coordinate to use
     * @param sourceY defines the screen space y coordinate to use
     * @param sourceZ defines the screen space z coordinate to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static UnprojectFloatsToRef(sourceX, sourceY, sourceZ, viewportWidth, viewportHeight, world, view, projection, result) {
        const matrix = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        world.multiplyToRef(view, matrix);
        matrix.multiplyToRef(projection, matrix);
        matrix.invert();
        const screenSource = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        screenSource.x = sourceX / viewportWidth * 2 - 1;
        screenSource.y = -(sourceY / viewportHeight * 2 - 1);
        if ((0, $ejQPp.EngineStore).LastCreatedEngine?.isNDCHalfZRange) screenSource.z = sourceZ;
        else screenSource.z = 2 * sourceZ - 1.0;
        $c7e4de670ed74d35$export$64b5c384219d3699._UnprojectFromInvertedMatrixToRef(screenSource, matrix, result);
        return result;
    }
    /**
     * Gets the minimal coordinate values between two Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#97
     * @param left defines the first operand
     * @param right defines the second operand
     * @returns the new Vector3
     */ static Minimize(left, right) {
        const min = new $c7e4de670ed74d35$export$64b5c384219d3699();
        min.copyFrom(left);
        min.minimizeInPlace(right);
        return min;
    }
    /**
     * Gets the maximal coordinate values between two Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#96
     * @param left defines the first operand
     * @param right defines the second operand
     * @returns the new Vector3
     */ static Maximize(left, right) {
        const max = new $c7e4de670ed74d35$export$64b5c384219d3699();
        max.copyFrom(left);
        max.maximizeInPlace(right);
        return max;
    }
    /**
     * Returns the distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#81
     * @param value1 defines the first operand
     * @param value2 defines the second operand
     * @returns the distance
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$64b5c384219d3699.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#80
     * @param value1 defines the first operand
     * @param value2 defines the second operand
     * @returns the squared distance
     */ static DistanceSquared(value1, value2) {
        const x = value1._x - value2._x;
        const y = value1._y - value2._y;
        const z = value1._z - value2._z;
        return x * x + y * y + z * z;
    }
    /**
     * Projects "vector" on the triangle determined by its extremities "p0", "p1" and "p2", stores the result in "ref"
     * and returns the distance to the projected point.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#104
     * From http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.104.4264&rep=rep1&type=pdf
     *
     * @param vector the vector to get distance from
     * @param p0 extremity of the triangle
     * @param p1 extremity of the triangle
     * @param p2 extremity of the triangle
     * @param ref variable to store the result to
     * @returns The distance between "ref" and "vector"
     */ static ProjectOnTriangleToRef(vector, p0, p1, p2, ref) {
        const p1p0 = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const p2p0 = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        const p2p1 = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        const normal = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        const vectorp0 = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        // Triangle vectors
        p1.subtractToRef(p0, p1p0);
        p2.subtractToRef(p0, p2p0);
        p2.subtractToRef(p1, p2p1);
        const p1p0L = p1p0.length();
        const p2p0L = p2p0.length();
        const p2p1L = p2p1.length();
        if (p1p0L < (0, $53VPf.Epsilon) || p2p0L < (0, $53VPf.Epsilon) || p2p1L < (0, $53VPf.Epsilon)) {
            // This is a degenerate triangle. As we assume this is part of a non-degenerate mesh,
            // we will find a better intersection later.
            // Let's just return one of the extremities
            ref.copyFrom(p0);
            return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, p0);
        }
        // Compute normal and vector to p0
        vector.subtractToRef(p0, vectorp0);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(p1p0, p2p0, normal);
        const nl = normal.length();
        if (nl < (0, $53VPf.Epsilon)) {
            // Extremities are aligned, we are back on the case of a degenerate triangle
            ref.copyFrom(p0);
            return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, p0);
        }
        normal.normalizeFromLength(nl);
        let l = vectorp0.length();
        if (l < (0, $53VPf.Epsilon)) {
            // Vector is p0
            ref.copyFrom(p0);
            return 0;
        }
        vectorp0.normalizeFromLength(l);
        // Project to "proj" that lies on the triangle plane
        const cosA = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(normal, vectorp0);
        const projVector = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        const proj = $c7e4de670ed74d35$var$MathTmp.Vector3[6];
        projVector.copyFrom(normal).scaleInPlace(-l * cosA);
        proj.copyFrom(vector).addInPlace(projVector);
        // Compute barycentric coordinates (v0, v1 and v2 are axis from barycenter to extremities)
        const v0 = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        const v1 = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        const v2 = $c7e4de670ed74d35$var$MathTmp.Vector3[7];
        const tmp = $c7e4de670ed74d35$var$MathTmp.Vector3[8];
        v0.copyFrom(p1p0).scaleInPlace(1 / p1p0L);
        tmp.copyFrom(p2p0).scaleInPlace(1 / p2p0L);
        v0.addInPlace(tmp).scaleInPlace(-1);
        v1.copyFrom(p1p0).scaleInPlace(-1 / p1p0L);
        tmp.copyFrom(p2p1).scaleInPlace(1 / p2p1L);
        v1.addInPlace(tmp).scaleInPlace(-1);
        v2.copyFrom(p2p1).scaleInPlace(-1 / p2p1L);
        tmp.copyFrom(p2p0).scaleInPlace(-1 / p2p0L);
        v2.addInPlace(tmp).scaleInPlace(-1);
        // Determines which edge of the triangle is closest to "proj"
        const projP = $c7e4de670ed74d35$var$MathTmp.Vector3[9];
        let dot;
        projP.copyFrom(proj).subtractInPlace(p0);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v0, projP, tmp);
        dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, normal);
        const s0 = dot;
        projP.copyFrom(proj).subtractInPlace(p1);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v1, projP, tmp);
        dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, normal);
        const s1 = dot;
        projP.copyFrom(proj).subtractInPlace(p2);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v2, projP, tmp);
        dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, normal);
        const s2 = dot;
        const edge = $c7e4de670ed74d35$var$MathTmp.Vector3[10];
        let e0, e1;
        if (s0 > 0 && s1 < 0) {
            edge.copyFrom(p1p0);
            e0 = p0;
            e1 = p1;
        } else if (s1 > 0 && s2 < 0) {
            edge.copyFrom(p2p1);
            e0 = p1;
            e1 = p2;
        } else {
            edge.copyFrom(p2p0).scaleInPlace(-1);
            e0 = p2;
            e1 = p0;
        }
        // Determines if "proj" lies inside the triangle
        const tmp2 = $c7e4de670ed74d35$var$MathTmp.Vector3[9];
        const tmp3 = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        e0.subtractToRef(proj, tmp);
        e1.subtractToRef(proj, tmp2);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(tmp, tmp2, tmp3);
        const isOutside = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp3, normal) < 0;
        // If inside, we already found the projected point, "proj"
        if (!isOutside) {
            ref.copyFrom(proj);
            return Math.abs(l * cosA);
        }
        // If outside, we find "triProj", the closest point from "proj" on the closest edge
        const r = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(edge, tmp3, r);
        r.normalize();
        const e0proj = $c7e4de670ed74d35$var$MathTmp.Vector3[9];
        e0proj.copyFrom(e0).subtractInPlace(proj);
        const e0projL = e0proj.length();
        if (e0projL < (0, $53VPf.Epsilon)) {
            // Proj is e0
            ref.copyFrom(e0);
            return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, e0);
        }
        e0proj.normalizeFromLength(e0projL);
        const cosG = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(r, e0proj);
        const triProj = $c7e4de670ed74d35$var$MathTmp.Vector3[7];
        triProj.copyFrom(proj).addInPlace(r.scaleInPlace(e0projL * cosG));
        // Now we clamp "triProj" so it lies between e0 and e1
        tmp.copyFrom(triProj).subtractInPlace(e0);
        l = edge.length();
        edge.normalizeFromLength(l);
        let t = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, edge) / Math.max(l, (0, $53VPf.Epsilon));
        t = (0, $iosaP.Clamp)(t, 0, 1);
        triProj.copyFrom(e0).addInPlace(edge.scaleInPlace(t * l));
        ref.copyFrom(triProj);
        return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, triProj);
    }
    /**
     * Returns a new Vector3 located at the center between "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#72
     * @param value1 defines the first operand
     * @param value2 defines the second operand
     * @returns the new Vector3
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.CenterToRef(value1, value2, $c7e4de670ed74d35$export$64b5c384219d3699.Zero());
    }
    /**
     * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#73
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @param ref defines third vector
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1._x + value2._x) / 2, (value1._y + value2._y) / 2, (value1._z + value2._z) / 2);
    }
    /**
     * Given three orthogonal normalized left-handed oriented Vector3 axis in space (target system),
     * RotationFromAxis() returns the rotation Euler angles (ex : rotation.x, rotation.y, rotation.z) to apply
     * to something in order to rotate it from its local system to the given target system
     * Note: axis1, axis2 and axis3 are normalized during this operation
     * Example Playground https://playground.babylonjs.com/#R1F8YU#106
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @returns a new Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/target_align
     */ static RotationFromAxis(axis1, axis2, axis3) {
        const rotation = new $c7e4de670ed74d35$export$64b5c384219d3699();
        $c7e4de670ed74d35$export$64b5c384219d3699.RotationFromAxisToRef(axis1, axis2, axis3, rotation);
        return rotation;
    }
    /**
     * The same than RotationFromAxis but updates the given ref Vector3 parameter instead of returning a new Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#107
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @param ref defines the Vector3 where to store the result
     * @returns result input
     */ static RotationFromAxisToRef(axis1, axis2, axis3, ref) {
        const quat = $c7e4de670ed74d35$var$MathTmp.Quaternion[0];
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationQuaternionFromAxisToRef(axis1, axis2, axis3, quat);
        quat.toEulerAnglesToRef(ref);
        return ref;
    }
}
/**
 * If the first vector is flagged with integers (as everything is 0,0,0), V8 stores all of the properties as integers internally because it doesn't know any better yet.
 * If subsequent vectors are created with non-integer values, V8 determines that it would be best to represent these properties as doubles instead of integers,
 * and henceforth it will use floating-point representation for all Vector3 instances that it creates.
 * But the original Vector3 instances are unchanged and has a "deprecated map".
 * If we keep using the Vector3 instances from step 1, it will now be a poison pill which will mess up optimizations in any code it touches.
 */ $c7e4de670ed74d35$export$64b5c384219d3699._V8PerformanceHack = new $c7e4de670ed74d35$export$64b5c384219d3699(0.5, 0.5, 0.5);
$c7e4de670ed74d35$export$64b5c384219d3699._UpReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Up();
$c7e4de670ed74d35$export$64b5c384219d3699._DownReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Down();
$c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedForwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Forward(false);
$c7e4de670ed74d35$export$64b5c384219d3699._RightHandedForwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Forward(true);
$c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedBackwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Backward(false);
$c7e4de670ed74d35$export$64b5c384219d3699._RightHandedBackwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Backward(true);
$c7e4de670ed74d35$export$64b5c384219d3699._RightReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Right();
$c7e4de670ed74d35$export$64b5c384219d3699._LeftReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Left();
$c7e4de670ed74d35$export$64b5c384219d3699._ZeroReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
$c7e4de670ed74d35$export$64b5c384219d3699._OneReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.One();
$c7e4de670ed74d35$export$64b5c384219d3699;
Object.defineProperties($c7e4de670ed74d35$export$64b5c384219d3699.prototype, {
    dimension: {
        value: [
            3
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$fa7daccca11cdbe3 {
    /**
     * Creates a Vector4 object from the given floats.
     * @param x x value of the vector
     * @param y y value of the vector
     * @param z z value of the vector
     * @param w w value of the vector
     */ constructor(/** [0] x value of the vector */ x = 0, /** [0] y value of the vector */ y = 0, /** [0] z value of the vector */ z = 0, /** [0] w value of the vector */ w = 0){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    /**
     * Returns the string with the Vector4 coordinates.
     * @returns a string containing all the vector values
     */ toString() {
        return `{X: ${this.x} Y: ${this.y} Z: ${this.z} W: ${this.w}}`;
    }
    /**
     * Returns the string "Vector4".
     * @returns "Vector4"
     */ getClassName() {
        return "Vector4";
    }
    /**
     * Returns the Vector4 hash code.
     * @returns a unique hash code
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this.x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this.y);
        const z = $c7e4de670ed74d35$var$_ExtractAsInt(this.z);
        const w = $c7e4de670ed74d35$var$_ExtractAsInt(this.w);
        let hash = x;
        hash = hash * 397 ^ y;
        hash = hash * 397 ^ z;
        hash = hash * 397 ^ w;
        return hash;
    }
    // Operators
    /**
     * Returns a new array populated with 4 elements : the Vector4 coordinates.
     * @returns the resulting array
     */ asArray() {
        return [
            this.x,
            this.y,
            this.z,
            this.w
        ];
    }
    /**
     * Populates the given array from the given index with the Vector4 coordinates.
     * @param array array to populate
     * @param index index of the array to start at (default: 0)
     * @returns the Vector4.
     */ toArray(array, index) {
        if (index === undefined) index = 0;
        array[index] = this.x;
        array[index + 1] = this.y;
        array[index + 2] = this.z;
        array[index + 3] = this.w;
        return this;
    }
    /**
     * Update the current vector from an array
     * @param array defines the destination array
     * @param offset defines the offset in the destination array
     * @returns the current Vector3
     */ fromArray(array, offset = 0) {
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Adds the given vector to the current Vector4.
     * @param otherVector the vector to add
     * @returns the updated Vector4.
     */ addInPlace(otherVector) {
        this.x += otherVector.x;
        this.y += otherVector.y;
        this.z += otherVector.z;
        this.w += otherVector.w;
        return this;
    }
    /**
     * Adds the given coordinates to the current Vector4
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param w defines the w coordinate of the operand
     * @returns the current updated Vector4
     */ addInPlaceFromFloats(x, y, z, w) {
        this.x += x;
        this.y += y;
        this.z += z;
        this.w += w;
        return this;
    }
    /**
     * Returns a new Vector4 as the result of the addition of the current Vector4 and the given one.
     * @param otherVector the vector to add
     * @returns the resulting vector
     */ add(otherVector) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x + otherVector.x, this.y + otherVector.y, this.z + otherVector.z, this.w + otherVector.w);
    }
    /**
     * Updates the given vector "result" with the result of the addition of the current Vector4 and the given one.
     * @param otherVector the vector to add
     * @param result the vector to store the result
     * @returns result input
     */ addToRef(otherVector, result) {
        result.x = this.x + otherVector.x;
        result.y = this.y + otherVector.y;
        result.z = this.z + otherVector.z;
        result.w = this.w + otherVector.w;
        return result;
    }
    /**
     * Subtract in place the given vector from the current Vector4.
     * @param otherVector the vector to subtract
     * @returns the updated Vector4.
     */ subtractInPlace(otherVector) {
        this.x -= otherVector.x;
        this.y -= otherVector.y;
        this.z -= otherVector.z;
        this.w -= otherVector.w;
        return this;
    }
    /**
     * Returns a new Vector4 with the result of the subtraction of the given vector from the current Vector4.
     * @param otherVector the vector to add
     * @returns the new vector with the result
     */ subtract(otherVector) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x - otherVector.x, this.y - otherVector.y, this.z - otherVector.z, this.w - otherVector.w);
    }
    /**
     * Sets the given vector "result" with the result of the subtraction of the given vector from the current Vector4.
     * @param otherVector the vector to subtract
     * @param result the vector to store the result
     * @returns result input
     */ subtractToRef(otherVector, result) {
        result.x = this.x - otherVector.x;
        result.y = this.y - otherVector.y;
        result.z = this.z - otherVector.z;
        result.w = this.w - otherVector.w;
        return result;
    }
    /**
     * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.
     * @param x value to subtract
     * @param y value to subtract
     * @param z value to subtract
     * @param w value to subtract
     * @returns new vector containing the result
     */ subtractFromFloats(x, y, z, w) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x - x, this.y - y, this.z - z, this.w - w);
    }
    /**
     * Sets the given vector "result" set with the result of the subtraction of the given floats from the current Vector4 coordinates.
     * @param x value to subtract
     * @param y value to subtract
     * @param z value to subtract
     * @param w value to subtract
     * @param result the vector to store the result in
     * @returns result input
     */ subtractFromFloatsToRef(x, y, z, w, result) {
        result.x = this.x - x;
        result.y = this.y - y;
        result.z = this.z - z;
        result.w = this.w - w;
        return result;
    }
    /**
     * Returns a new Vector4 set with the current Vector4 negated coordinates.
     * @returns a new vector with the negated values
     */ negate() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(-this.x, -this.y, -this.z, -this.w);
    }
    /**
     * Negate this vector in place
     * @returns this
     */ negateInPlace() {
        this.x *= -1;
        this.y *= -1;
        this.z *= -1;
        this.w *= -1;
        return this;
    }
    /**
     * Negate the current Vector4 and stores the result in the given vector "result" coordinates
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ negateToRef(result) {
        result.x = -this.x;
        result.y = -this.y;
        result.z = -this.z;
        result.w = -this.w;
        return result;
    }
    /**
     * Multiplies the current Vector4 coordinates by scale (float).
     * @param scale the number to scale with
     * @returns the updated Vector4.
     */ scaleInPlace(scale) {
        this.x *= scale;
        this.y *= scale;
        this.z *= scale;
        this.w *= scale;
        return this;
    }
    /**
     * Returns a new Vector4 set with the current Vector4 coordinates multiplied by scale (float).
     * @param scale the number to scale with
     * @returns a new vector with the result
     */ scale(scale) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x * scale, this.y * scale, this.z * scale, this.w * scale);
    }
    /**
     * Sets the given vector "result" with the current Vector4 coordinates multiplied by scale (float).
     * @param scale the number to scale with
     * @param result a vector to store the result in
     * @returns result input
     */ scaleToRef(scale, result) {
        result.x = this.x * scale;
        result.y = this.y * scale;
        result.z = this.z * scale;
        result.w = this.w * scale;
        return result;
    }
    /**
     * Scale the current Vector4 values by a factor and add the result to a given Vector4
     * @param scale defines the scale factor
     * @param result defines the Vector4 object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result.x += this.x * scale;
        result.y += this.y * scale;
        result.z += this.z * scale;
        result.w += this.w * scale;
        return result;
    }
    /**
     * Boolean : True if the current Vector4 coordinates are stricly equal to the given ones.
     * @param otherVector the vector to compare against
     * @returns true if they are equal
     */ equals(otherVector) {
        return otherVector && this.x === otherVector.x && this.y === otherVector.y && this.z === otherVector.z && this.w === otherVector.w;
    }
    /**
     * Boolean : True if the current Vector4 coordinates are each beneath the distance "epsilon" from the given vector ones.
     * @param otherVector vector to compare against
     * @param epsilon (Default: very small number)
     * @returns true if they are equal
     */ equalsWithEpsilon(otherVector, epsilon = (0, $53VPf.Epsilon)) {
        return otherVector && (0, $iosaP.WithinEpsilon)(this.x, otherVector.x, epsilon) && (0, $iosaP.WithinEpsilon)(this.y, otherVector.y, epsilon) && (0, $iosaP.WithinEpsilon)(this.z, otherVector.z, epsilon) && (0, $iosaP.WithinEpsilon)(this.w, otherVector.w, epsilon);
    }
    /**
     * Boolean : True if the given floats are strictly equal to the current Vector4 coordinates.
     * @param x x value to compare against
     * @param y y value to compare against
     * @param z z value to compare against
     * @param w w value to compare against
     * @returns true if equal
     */ equalsToFloats(x, y, z, w) {
        return this.x === x && this.y === y && this.z === z && this.w === w;
    }
    /**
     * Multiplies in place the current Vector4 by the given one.
     * @param otherVector vector to multiple with
     * @returns the updated Vector4.
     */ multiplyInPlace(otherVector) {
        this.x *= otherVector.x;
        this.y *= otherVector.y;
        this.z *= otherVector.z;
        this.w *= otherVector.w;
        return this;
    }
    /**
     * Returns a new Vector4 set with the multiplication result of the current Vector4 and the given one.
     * @param otherVector vector to multiple with
     * @returns resulting new vector
     */ multiply(otherVector) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x * otherVector.x, this.y * otherVector.y, this.z * otherVector.z, this.w * otherVector.w);
    }
    /**
     * Updates the given vector "result" with the multiplication result of the current Vector4 and the given one.
     * @param otherVector vector to multiple with
     * @param result vector to store the result
     * @returns result input
     */ multiplyToRef(otherVector, result) {
        result.x = this.x * otherVector.x;
        result.y = this.y * otherVector.y;
        result.z = this.z * otherVector.z;
        result.w = this.w * otherVector.w;
        return result;
    }
    /**
     * Returns a new Vector4 set with the multiplication result of the given floats and the current Vector4 coordinates.
     * @param x x value multiply with
     * @param y y value multiply with
     * @param z z value multiply with
     * @param w w value multiply with
     * @returns resulting new vector
     */ multiplyByFloats(x, y, z, w) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x * x, this.y * y, this.z * z, this.w * w);
    }
    /**
     * Returns a new Vector4 set with the division result of the current Vector4 by the given one.
     * @param otherVector vector to devide with
     * @returns resulting new vector
     */ divide(otherVector) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x / otherVector.x, this.y / otherVector.y, this.z / otherVector.z, this.w / otherVector.w);
    }
    /**
     * Updates the given vector "result" with the division result of the current Vector4 by the given one.
     * @param otherVector vector to devide with
     * @param result vector to store the result
     * @returns result input
     */ divideToRef(otherVector, result) {
        result.x = this.x / otherVector.x;
        result.y = this.y / otherVector.y;
        result.z = this.z / otherVector.z;
        result.w = this.w / otherVector.w;
        return result;
    }
    /**
     * Divides the current Vector3 coordinates by the given ones.
     * @param otherVector vector to devide with
     * @returns the updated Vector3.
     */ divideInPlace(otherVector) {
        return this.divideToRef(otherVector, this);
    }
    /**
     * Updates the Vector4 coordinates with the minimum values between its own and the given vector ones
     * @param other defines the second operand
     * @returns the current updated Vector4
     */ minimizeInPlace(other) {
        if (other.x < this.x) this.x = other.x;
        if (other.y < this.y) this.y = other.y;
        if (other.z < this.z) this.z = other.z;
        if (other.w < this.w) this.w = other.w;
        return this;
    }
    /**
     * Updates the Vector4 coordinates with the maximum values between its own and the given vector ones
     * @param other defines the second operand
     * @returns the current updated Vector4
     */ maximizeInPlace(other) {
        if (other.x > this.x) this.x = other.x;
        if (other.y > this.y) this.y = other.y;
        if (other.z > this.z) this.z = other.z;
        if (other.w > this.w) this.w = other.w;
        return this;
    }
    /**
     * Updates the current Vector4 with the minimal coordinate values between its and the given coordinates
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param w defines the w coordinate of the operand
     * @returns the current updated Vector4
     */ minimizeInPlaceFromFloats(x, y, z, w) {
        this.x = Math.min(x, this.x);
        this.y = Math.min(y, this.y);
        this.z = Math.min(z, this.z);
        this.w = Math.min(w, this.w);
        return this;
    }
    /**
     * Updates the current Vector4 with the maximal coordinate values between its and the given coordinates.
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param w defines the w coordinate of the operand
     * @returns the current updated Vector4
     */ maximizeInPlaceFromFloats(x, y, z, w) {
        this.x = Math.max(x, this.x);
        this.y = Math.max(y, this.y);
        this.z = Math.max(z, this.z);
        this.w = Math.max(w, this.w);
        return this;
    }
    /**
     * Gets the current Vector4's floored values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ floorToRef(result) {
        result.x = Math.floor(this.x);
        result.y = Math.floor(this.y);
        result.z = Math.floor(this.z);
        result.w = Math.floor(this.w);
        return result;
    }
    /**
     * Gets a new Vector4 from current Vector4 floored values
     * @returns a new Vector4
     */ floor() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z), Math.floor(this.w));
    }
    /**
     * Gets the current Vector4's fractional values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ fractToRef(result) {
        result.x = this.x - Math.floor(this.x);
        result.y = this.y - Math.floor(this.y);
        result.z = this.z - Math.floor(this.z);
        result.w = this.w - Math.floor(this.w);
        return result;
    }
    /**
     * Gets a new Vector4 from current Vector4 fractional values
     * @returns a new Vector4
     */ fract() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x - Math.floor(this.x), this.y - Math.floor(this.y), this.z - Math.floor(this.z), this.w - Math.floor(this.w));
    }
    // Properties
    /**
     * Returns the Vector4 length (float).
     * @returns the length
     */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
     * Returns the Vector4 squared length (float).
     * @returns the length squared
     */ lengthSquared() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    // Methods
    /**
     * Normalizes in place the Vector4.
     * @returns the updated Vector4.
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Normalize the current Vector4 with the given input length.
     * Please note that this is an in place operation.
     * @param len the length of the vector
     * @returns the current updated Vector4
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize the current Vector4 to a new vector
     * @returns the new Vector4
     */ normalizeToNew() {
        return this.normalizeToRef(new $c7e4de670ed74d35$export$fa7daccca11cdbe3());
    }
    /**
     * Normalize the current Vector4 to the reference
     * @param reference define the Vector4 to update
     * @returns the updated Vector4
     */ normalizeToRef(reference) {
        const len = this.length();
        if (len === 0 || len === 1.0) {
            reference.x = this.x;
            reference.y = this.y;
            reference.z = this.z;
            reference.w = this.w;
            return reference;
        }
        return this.scaleToRef(1.0 / len, reference);
    }
    /**
     * Returns a new Vector3 from the Vector4 (x, y, z) coordinates.
     * @returns this converted to a new vector3
     */ toVector3() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this.x, this.y, this.z);
    }
    /**
     * Returns a new Vector4 copied from the current one.
     * @returns the new cloned vector
     */ clone() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this.x, this.y, this.z, this.w);
    }
    /**
     * Updates the current Vector4 with the given one coordinates.
     * @param source the source vector to copy from
     * @returns the updated Vector4.
     */ copyFrom(source) {
        this.x = source.x;
        this.y = source.y;
        this.z = source.z;
        this.w = source.w;
        return this;
    }
    /**
     * Updates the current Vector4 coordinates with the given floats.
     * @param x float to copy from
     * @param y float to copy from
     * @param z float to copy from
     * @param w float to copy from
     * @returns the updated Vector4.
     */ copyFromFloats(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
     * Updates the current Vector4 coordinates with the given floats.
     * @param x float to set from
     * @param y float to set from
     * @param z float to set from
     * @param w float to set from
     * @returns the updated Vector4.
     */ set(x, y, z, w) {
        return this.copyFromFloats(x, y, z, w);
    }
    /**
     * Copies the given float to the current Vector4 coordinates
     * @param v defines the x, y, z and w coordinates of the operand
     * @returns the current updated Vector4
     */ setAll(v) {
        this.x = this.y = this.z = this.w = v;
        return this;
    }
    /**
     * Returns the dot product (float) between the current vectors and "otherVector"
     * @param otherVector defines the right operand
     * @returns the dot product
     */ dot(otherVector) {
        return this.x * otherVector.x + this.y * otherVector.y + this.z * otherVector.z + this.w * otherVector.w;
    }
    // Statics
    /**
     * Returns a new Vector4 set from the starting index of the given array.
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @returns the new vector
     */ static FromArray(array, offset) {
        if (!offset) offset = 0;
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    }
    /**
     * Updates the given vector "result" from the starting index of the given array.
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @param result the vector to store the result in
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result.x = array[offset];
        result.y = array[offset + 1];
        result.z = array[offset + 2];
        result.w = array[offset + 3];
        return result;
    }
    /**
     * Updates the given vector "result" from the starting index of the given Float32Array.
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @param result the vector to store the result in
     * @returns result input
     */ static FromFloatArrayToRef(array, offset, result) {
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.FromArrayToRef(array, offset, result);
        return result;
    }
    /**
     * Updates the given vector "result" coordinates from the given floats.
     * @param x float to set from
     * @param y float to set from
     * @param z float to set from
     * @param w float to set from
     * @param result the vector to the floats in
     * @returns result input
     */ static FromFloatsToRef(x, y, z, w, result) {
        result.x = x;
        result.y = y;
        result.z = z;
        result.w = w;
        return result;
    }
    /**
     * Returns a new Vector4 set to (0.0, 0.0, 0.0, 0.0)
     * @returns the new vector
     */ static Zero() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(0.0, 0.0, 0.0, 0.0);
    }
    /**
     * Returns a new Vector4 set to (1.0, 1.0, 1.0, 1.0)
     * @returns the new vector
     */ static One() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(1.0, 1.0, 1.0, 1.0);
    }
    /**
     * Returns a new Vector4 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Vector4 with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Vector4 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        ref.x = (0, $iosaP.RandomRange)(min, max);
        ref.y = (0, $iosaP.RandomRange)(min, max);
        ref.z = (0, $iosaP.RandomRange)(min, max);
        ref.w = (0, $iosaP.RandomRange)(min, max);
        return ref;
    }
    /**
     * Returns a new Vector4 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @returns the new Vector4
     */ static Clamp(value, min, max) {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3.ClampToRef(value, min, max, new $c7e4de670ed74d35$export$fa7daccca11cdbe3());
    }
    /**
     * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @param result defines the Vector4 where to store the result
     * @returns result input
     */ static ClampToRef(value, min, max, result) {
        result.x = (0, $iosaP.Clamp)(value.x, min.x, max.x);
        result.y = (0, $iosaP.Clamp)(value.y, min.y, max.y);
        result.z = (0, $iosaP.Clamp)(value.z, min.z, max.z);
        result.w = (0, $iosaP.Clamp)(value.w, min.w, max.w);
        return result;
    }
    /**
     * Checks if a given vector is inside a specific range
     * Example Playground https://playground.babylonjs.com/#R1F8YU#75
     * @param v defines the vector to test
     * @param min defines the minimum range
     * @param max defines the maximum range
     */ static CheckExtends(v, min, max) {
        min.minimizeInPlace(v);
        max.maximizeInPlace(v);
    }
    /**
     * Gets a zero Vector4 that must not be updated
     */ static get ZeroReadOnly() {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3._ZeroReadOnly;
    }
    /**
     * Returns a new normalized Vector4 from the given one.
     * @param vector the vector to normalize
     * @returns the vector
     */ static Normalize(vector) {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3.NormalizeToRef(vector, new $c7e4de670ed74d35$export$fa7daccca11cdbe3());
    }
    /**
     * Updates the given vector "result" from the normalization of the given one.
     * @param vector the vector to normalize
     * @param result the vector to store the result in
     * @returns result input
     */ static NormalizeToRef(vector, result) {
        vector.normalizeToRef(result);
        return result;
    }
    /**
     * Returns a vector with the minimum values from the left and right vectors
     * @param left left vector to minimize
     * @param right right vector to minimize
     * @returns a new vector with the minimum of the left and right vector values
     */ static Minimize(left, right) {
        const min = new $c7e4de670ed74d35$export$fa7daccca11cdbe3();
        min.copyFrom(left);
        min.minimizeInPlace(right);
        return min;
    }
    /**
     * Returns a vector with the maximum values from the left and right vectors
     * @param left left vector to maximize
     * @param right right vector to maximize
     * @returns a new vector with the maximum of the left and right vector values
     */ static Maximize(left, right) {
        const max = new $c7e4de670ed74d35$export$fa7daccca11cdbe3();
        max.copyFrom(left);
        max.maximizeInPlace(right);
        return max;
    }
    /**
     * Returns the distance (float) between the vectors "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two vectors
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$fa7daccca11cdbe3.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance (float) between the vectors "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two vectors squared
     */ static DistanceSquared(value1, value2) {
        const x = value1.x - value2.x;
        const y = value1.y - value2.y;
        const z = value1.z - value2.z;
        const w = value1.w - value2.w;
        return x * x + y * y + z * z + w * w;
    }
    /**
     * Returns a new Vector4 located at the center between the vectors "value1" and "value2".
     * @param value1 value to calulate the center between
     * @param value2 value to calulate the center between
     * @returns the center between the two vectors
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3.CenterToRef(value1, value2, new $c7e4de670ed74d35$export$fa7daccca11cdbe3());
    }
    /**
     * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @param ref defines third vector
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        ref.x = (value1.x + value2.x) / 2;
        ref.y = (value1.y + value2.y) / 2;
        ref.z = (value1.z + value2.z) / 2;
        ref.w = (value1.w + value2.w) / 2;
        return ref;
    }
    /**
     * Returns a new Vector4 set with the result of the transformation by the given matrix of the given vector.
     * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * The difference with Vector3.TransformCoordinates is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @returns the transformed Vector4
     */ static TransformCoordinates(vector, transformation) {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3.TransformCoordinatesToRef(vector, transformation, new $c7e4de670ed74d35$export$fa7daccca11cdbe3());
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
     * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * The difference with Vector3.TransformCoordinatesToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @param result defines the Vector4 where to store the result
     * @returns result input
     */ static TransformCoordinatesToRef(vector, transformation, result) {
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.TransformCoordinatesFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
     * This method computes tranformed coordinates only, not transformed direction vectors
     * The difference with Vector3.TransformCoordinatesFromFloatsToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
     * @param x define the x coordinate of the source vector
     * @param y define the y coordinate of the source vector
     * @param z define the z coordinate of the source vector
     * @param transformation defines the transformation matrix
     * @param result defines the Vector4 where to store the result
     * @returns result input
     */ static TransformCoordinatesFromFloatsToRef(x, y, z, transformation, result) {
        const m = transformation.m;
        const rx = x * m[0] + y * m[4] + z * m[8] + m[12];
        const ry = x * m[1] + y * m[5] + z * m[9] + m[13];
        const rz = x * m[2] + y * m[6] + z * m[10] + m[14];
        const rw = x * m[3] + y * m[7] + z * m[11] + m[15];
        result.x = rx;
        result.y = ry;
        result.z = rz;
        result.w = rw;
        return result;
    }
    /**
     * Returns a new Vector4 set with the result of the normal transformation by the given matrix of the given vector.
     * This methods computes transformed normalized direction vectors only.
     * @param vector the vector to transform
     * @param transformation the transformation matrix to apply
     * @returns the new vector
     */ static TransformNormal(vector, transformation) {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3.TransformNormalToRef(vector, transformation, new $c7e4de670ed74d35$export$fa7daccca11cdbe3());
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector.
     * This methods computes transformed normalized direction vectors only.
     * @param vector the vector to transform
     * @param transformation the transformation matrix to apply
     * @param result the vector to store the result in
     * @returns result input
     */ static TransformNormalToRef(vector, transformation, result) {
        const m = transformation.m;
        const x = vector.x * m[0] + vector.y * m[4] + vector.z * m[8];
        const y = vector.x * m[1] + vector.y * m[5] + vector.z * m[9];
        const z = vector.x * m[2] + vector.y * m[6] + vector.z * m[10];
        result.x = x;
        result.y = y;
        result.z = z;
        result.w = vector.w;
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z, w).
     * This methods computes transformed normalized direction vectors only.
     * @param x value to transform
     * @param y value to transform
     * @param z value to transform
     * @param w value to transform
     * @param transformation the transformation matrix to apply
     * @param result the vector to store the results in
     * @returns result input
     */ static TransformNormalFromFloatsToRef(x, y, z, w, transformation, result) {
        const m = transformation.m;
        result.x = x * m[0] + y * m[4] + z * m[8];
        result.y = x * m[1] + y * m[5] + z * m[9];
        result.z = x * m[2] + y * m[6] + z * m[10];
        result.w = w;
        return result;
    }
    /**
     * Creates a new Vector4 from a Vector3
     * @param source defines the source data
     * @param w defines the 4th component (default is 0)
     * @returns a new Vector4
     */ static FromVector3(source, w = 0) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(source._x, source._y, source._z, w);
    }
    /**
     * Returns the dot product (float) between the vectors "left" and "right"
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the dot product
     */ static Dot(left, right) {
        return left.x * right.x + left.y * right.y + left.z * right.z + left.w * right.w;
    }
}
/**
 * If the first vector is flagged with integers (as everything is 0,0,0,0), V8 stores all of the properties as integers internally because it doesn't know any better yet.
 * If subsequent vectors are created with non-integer values, V8 determines that it would be best to represent these properties as doubles instead of integers,
 * and henceforth it will use floating-point representation for all Vector4 instances that it creates.
 * But the original Vector4 instances are unchanged and has a "deprecated map".
 * If we keep using the Vector4 instances from step 1, it will now be a poison pill which will mess up optimizations in any code it touches.
 */ $c7e4de670ed74d35$export$fa7daccca11cdbe3._V8PerformanceHack = new $c7e4de670ed74d35$export$fa7daccca11cdbe3(0.5, 0.5, 0.5, 0.5);
$c7e4de670ed74d35$export$fa7daccca11cdbe3._ZeroReadOnly = $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero();
$c7e4de670ed74d35$export$fa7daccca11cdbe3;
Object.defineProperties($c7e4de670ed74d35$export$fa7daccca11cdbe3.prototype, {
    dimension: {
        value: [
            4
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$23d6a54f0bbc85a3 {
    /** Gets or sets the x coordinate */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._isDirty = true;
    }
    /** Gets or sets the y coordinate */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._isDirty = true;
    }
    /** Gets or sets the z coordinate */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._isDirty = true;
    }
    /** Gets or sets the w coordinate */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._isDirty = true;
    }
    /**
     * Creates a new Quaternion from the given floats
     * @param x defines the first component (0 by default)
     * @param y defines the second component (0 by default)
     * @param z defines the third component (0 by default)
     * @param w defines the fourth component (1.0 by default)
     */ constructor(x = 0.0, y = 0.0, z = 0.0, w = 1.0){
        /** @internal */ this._isDirty = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
     * Gets a string representation for the current quaternion
     * @returns a string with the Quaternion coordinates
     */ toString() {
        return `{X: ${this._x} Y: ${this._y} Z: ${this._z} W: ${this._w}}`;
    }
    /**
     * Gets the class name of the quaternion
     * @returns the string "Quaternion"
     */ getClassName() {
        return "Quaternion";
    }
    /**
     * Gets a hash code for this quaternion
     * @returns the quaternion hash code
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this._x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this._y);
        const z = $c7e4de670ed74d35$var$_ExtractAsInt(this._z);
        const w = $c7e4de670ed74d35$var$_ExtractAsInt(this._w);
        let hash = x;
        hash = hash * 397 ^ y;
        hash = hash * 397 ^ z;
        hash = hash * 397 ^ w;
        return hash;
    }
    /**
     * Copy the quaternion to an array
     * Example Playground https://playground.babylonjs.com/#L49EJ7#13
     * @returns a new array populated with 4 elements from the quaternion coordinates
     */ asArray() {
        return [
            this._x,
            this._y,
            this._z,
            this._w
        ];
    }
    /**
     * Stores from the starting index in the given array the Quaternion successive values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#59
     * @param array defines the array where to store the x,y,z,w components
     * @param index defines an optional index in the target array to define where to start storing values
     * @returns the current Quaternion object
     */ toArray(array, index = 0) {
        array[index] = this._x;
        array[index + 1] = this._y;
        array[index + 2] = this._z;
        array[index + 3] = this._w;
        return this;
    }
    fromArray(array, index = 0) {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromArrayToRef(array, index, this);
    }
    /**
     * Check if two quaternions are equals
     * Example Playground https://playground.babylonjs.com/#L49EJ7#38
     * @param otherQuaternion defines the second operand
     * @returns true if the current quaternion and the given one coordinates are strictly equals
     */ equals(otherQuaternion) {
        return otherQuaternion && this._x === otherQuaternion._x && this._y === otherQuaternion._y && this._z === otherQuaternion._z && this._w === otherQuaternion._w;
    }
    /**
     * Gets a boolean if two quaternions are equals (using an epsilon value)
     * Example Playground https://playground.babylonjs.com/#L49EJ7#37
     * @param otherQuaternion defines the other quaternion
     * @param epsilon defines the minimal distance to consider equality
     * @returns true if the given quaternion coordinates are close to the current ones by a distance of epsilon.
     */ equalsWithEpsilon(otherQuaternion, epsilon = (0, $53VPf.Epsilon)) {
        return otherQuaternion && (0, $iosaP.WithinEpsilon)(this._x, otherQuaternion._x, epsilon) && (0, $iosaP.WithinEpsilon)(this._y, otherQuaternion._y, epsilon) && (0, $iosaP.WithinEpsilon)(this._z, otherQuaternion._z, epsilon) && (0, $iosaP.WithinEpsilon)(this._w, otherQuaternion._w, epsilon);
    }
    /**
     * Clone the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#12
     * @returns a new quaternion copied from the current one
     */ clone() {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(this._x, this._y, this._z, this._w);
    }
    /**
     * Copy a quaternion to the current one
     * Example Playground https://playground.babylonjs.com/#L49EJ7#86
     * @param other defines the other quaternion
     * @returns the updated current quaternion
     */ copyFrom(other) {
        this._x = other._x;
        this._y = other._y;
        this._z = other._z;
        this._w = other._w;
        this._isDirty = true;
        return this;
    }
    /**
     * Updates the current quaternion with the given float coordinates
     * Example Playground https://playground.babylonjs.com/#L49EJ7#87
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     * @param z defines the z coordinate
     * @param w defines the w coordinate
     * @returns the updated current quaternion
     */ copyFromFloats(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._isDirty = true;
        return this;
    }
    /**
     * Updates the current quaternion from the given float coordinates
     * Example Playground https://playground.babylonjs.com/#L49EJ7#56
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     * @param z defines the z coordinate
     * @param w defines the w coordinate
     * @returns the updated current quaternion
     */ set(x, y, z, w) {
        return this.copyFromFloats(x, y, z, w);
    }
    setAll(value) {
        return this.copyFromFloats(value, value, value, value);
    }
    /**
     * Adds two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#10
     * @param other defines the second operand
     * @returns a new quaternion as the addition result of the given one and the current quaternion
     */ add(other) {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(this._x + other._x, this._y + other._y, this._z + other._z, this._w + other._w);
    }
    /**
     * Add a quaternion to the current one
     * Example Playground https://playground.babylonjs.com/#L49EJ7#11
     * @param other defines the quaternion to add
     * @returns the current quaternion
     */ addInPlace(other) {
        this._x += other._x;
        this._y += other._y;
        this._z += other._z;
        this._w += other._w;
        this._isDirty = true;
        return this;
    }
    addToRef(other, result) {
        result._x = this._x + other._x;
        result._y = this._y + other._y;
        result._z = this._z + other._z;
        result._w = this._w + other._w;
        result._isDirty = true;
        return result;
    }
    addInPlaceFromFloats(x, y, z, w) {
        this._x += x;
        this._y += y;
        this._z += z;
        this._w += w;
        this._isDirty = true;
        return this;
    }
    subtractToRef(other, result) {
        result._x = this._x - other._x;
        result._y = this._y - other._y;
        result._z = this._z - other._z;
        result._w = this._w - other._w;
        result._isDirty = true;
        return result;
    }
    subtractFromFloats(x, y, z, w) {
        return this.subtractFromFloatsToRef(x, y, z, w, new $c7e4de670ed74d35$export$23d6a54f0bbc85a3());
    }
    subtractFromFloatsToRef(x, y, z, w, result) {
        result._x = this._x - x;
        result._y = this._y - y;
        result._z = this._z - z;
        result._w = this._w - w;
        result._isDirty = true;
        return result;
    }
    /**
     * Subtract two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#57
     * @param other defines the second operand
     * @returns a new quaternion as the subtraction result of the given one from the current one
     */ subtract(other) {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(this._x - other._x, this._y - other._y, this._z - other._z, this._w - other._w);
    }
    /**
     * Subtract a quaternion to the current one
     * Example Playground https://playground.babylonjs.com/#L49EJ7#58
     * @param other defines the quaternion to subtract
     * @returns the current quaternion
     */ subtractInPlace(other) {
        this._x -= other._x;
        this._y -= other._y;
        this._z -= other._z;
        this._w -= other._w;
        this._isDirty = true;
        return this;
    }
    /**
     * Multiplies the current quaternion by a scale factor
     * Example Playground https://playground.babylonjs.com/#L49EJ7#88
     * @param value defines the scale factor
     * @returns a new quaternion set by multiplying the current quaternion coordinates by the float "scale"
     */ scale(value) {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(this._x * value, this._y * value, this._z * value, this._w * value);
    }
    /**
     * Scale the current quaternion values by a factor and stores the result to a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#89
     * @param scale defines the scale factor
     * @param result defines the Quaternion object where to store the result
     * @returns result input
     */ scaleToRef(scale, result) {
        result._x = this._x * scale;
        result._y = this._y * scale;
        result._z = this._z * scale;
        result._w = this._w * scale;
        result._isDirty = true;
        return result;
    }
    /**
     * Multiplies in place the current quaternion by a scale factor
     * Example Playground https://playground.babylonjs.com/#L49EJ7#90
     * @param value defines the scale factor
     * @returns the current modified quaternion
     */ scaleInPlace(value) {
        this._x *= value;
        this._y *= value;
        this._z *= value;
        this._w *= value;
        this._isDirty = true;
        return this;
    }
    /**
     * Scale the current quaternion values by a factor and add the result to a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#91
     * @param scale defines the scale factor
     * @param result defines the Quaternion object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result._x += this._x * scale;
        result._y += this._y * scale;
        result._z += this._z * scale;
        result._w += this._w * scale;
        result._isDirty = true;
        return result;
    }
    /**
     * Multiplies two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#43
     * @param q1 defines the second operand
     * @returns a new quaternion set as the multiplication result of the current one with the given one "q1"
     */ multiply(q1) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0, 0, 0, 1.0);
        this.multiplyToRef(q1, result);
        return result;
    }
    /**
     * Sets the given "result" as the multiplication result of the current one with the given one "q1"
     * Example Playground https://playground.babylonjs.com/#L49EJ7#45
     * @param q1 defines the second operand
     * @param result defines the target quaternion
     * @returns the current quaternion
     */ multiplyToRef(q1, result) {
        const x = this._x * q1._w + this._y * q1._z - this._z * q1._y + this._w * q1._x;
        const y = -this._x * q1._z + this._y * q1._w + this._z * q1._x + this._w * q1._y;
        const z = this._x * q1._y - this._y * q1._x + this._z * q1._w + this._w * q1._z;
        const w = -this._x * q1._x - this._y * q1._y - this._z * q1._z + this._w * q1._w;
        result.copyFromFloats(x, y, z, w);
        return result;
    }
    /**
     * Updates the current quaternion with the multiplication of itself with the given one "q1"
     * Example Playground https://playground.babylonjs.com/#L49EJ7#46
     * @param other defines the second operand
     * @returns the currentupdated quaternion
     */ multiplyInPlace(other) {
        return this.multiplyToRef(other, this);
    }
    multiplyByFloats(x, y, z, w) {
        this._x *= x;
        this._y *= y;
        this._z *= z;
        this._w *= w;
        this._isDirty = true;
        return this;
    }
    /**
     * @internal
     * Do not use
     */ divide(_other) {
        throw new ReferenceError("Can not divide a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ divideToRef(_other, _result) {
        throw new ReferenceError("Can not divide a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ divideInPlace(_other) {
        throw new ReferenceError("Can not divide a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ minimizeInPlace() {
        throw new ReferenceError("Can not minimize a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ minimizeInPlaceFromFloats() {
        throw new ReferenceError("Can not minimize a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ maximizeInPlace() {
        throw new ReferenceError("Can not maximize a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ maximizeInPlaceFromFloats() {
        throw new ReferenceError("Can not maximize a quaternion");
    }
    negate() {
        return this.negateToRef(new $c7e4de670ed74d35$export$23d6a54f0bbc85a3());
    }
    negateInPlace() {
        this._x = -this._x;
        this._y = -this._y;
        this._z = -this._z;
        this._w = -this._w;
        this._isDirty = true;
        return this;
    }
    negateToRef(result) {
        result._x = -this._x;
        result._y = -this._y;
        result._z = -this._z;
        result._w = -this._w;
        result._isDirty = true;
        return result;
    }
    equalsToFloats(x, y, z, w) {
        return this._x === x && this._y === y && this._z === z && this._w === w;
    }
    /**
     * @internal
     * Do not use
     */ floorToRef(_result) {
        throw new ReferenceError("Can not floor a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ floor() {
        throw new ReferenceError("Can not floor a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ fractToRef(_result) {
        throw new ReferenceError("Can not fract a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ fract() {
        throw new ReferenceError("Can not fract a quaternion");
    }
    /**
     * Conjugates the current quaternion and stores the result in the given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#81
     * @param ref defines the target quaternion
     * @returns result input
     */ conjugateToRef(ref) {
        ref.copyFromFloats(-this._x, -this._y, -this._z, this._w);
        return ref;
    }
    /**
     * Conjugates in place the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#82
     * @returns the current updated quaternion
     */ conjugateInPlace() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._isDirty = true;
        return this;
    }
    /**
     * Conjugates (1-q) the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#83
     * @returns a new quaternion
     */ conjugate() {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(-this._x, -this._y, -this._z, this._w);
    }
    /**
     * Returns the inverse of the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#84
     * @returns a new quaternion
     */ invert() {
        const conjugate = this.conjugate();
        const lengthSquared = this.lengthSquared();
        if (lengthSquared == 0 || lengthSquared == 1) return conjugate;
        conjugate.scaleInPlace(1 / lengthSquared);
        return conjugate;
    }
    /**
     * Invert in place the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#85
     * @returns this quaternion
     */ invertInPlace() {
        this.conjugateInPlace();
        const lengthSquared = this.lengthSquared();
        if (lengthSquared == 0 || lengthSquared == 1) return this;
        this.scaleInPlace(1 / lengthSquared);
        return this;
    }
    /**
     * Gets squared length of current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#29
     * @returns the quaternion length (float)
     */ lengthSquared() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
     * Gets length of current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#28
     * @returns the quaternion length (float)
     */ length() {
        return Math.sqrt(this.lengthSquared());
    }
    /**
     * Normalize in place the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#54
     * @returns the current updated quaternion
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Normalize the current quaternion with the given input length.
     * Please note that this is an in place operation.
     * @param len the length of the quaternion
     * @returns the current updated Quaternion
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize a copy of the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#55
     * @returns the normalized quaternion
     */ normalizeToNew() {
        const normalized = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0, 0, 0, 1);
        this.normalizeToRef(normalized);
        return normalized;
    }
    /**
     * Normalize the current Quaternion to the reference
     * @param reference define the Quaternion to update
     * @returns the updated Quaternion
     */ normalizeToRef(reference) {
        const len = this.length();
        if (len === 0 || len === 1.0) return reference.copyFromFloats(this._x, this._y, this._z, this._w);
        return this.scaleToRef(1.0 / len, reference);
    }
    /**
     * Returns a new Vector3 set with the Euler angles translated from the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#32
     * @returns a new Vector3 containing the Euler angles
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
     */ toEulerAngles() {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        this.toEulerAnglesToRef(result);
        return result;
    }
    /**
     * Sets the given vector3 "result" with the Euler angles translated from the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#31
     * @param result defines the vector which will be filled with the Euler angles
     * @returns result input
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
     */ toEulerAnglesToRef(result) {
        const qz = this._z;
        const qx = this._x;
        const qy = this._y;
        const qw = this._w;
        const zAxisY = qy * qz - qx * qw;
        const limit = 0.4999999;
        if (zAxisY < -limit) {
            result._y = 2 * Math.atan2(qy, qw);
            result._x = Math.PI / 2;
            result._z = 0;
            result._isDirty = true;
        } else if (zAxisY > limit) {
            result._y = 2 * Math.atan2(qy, qw);
            result._x = -Math.PI / 2;
            result._z = 0;
            result._isDirty = true;
        } else {
            const sqw = qw * qw;
            const sqz = qz * qz;
            const sqx = qx * qx;
            const sqy = qy * qy;
            result._z = Math.atan2(2.0 * (qx * qy + qz * qw), -sqz - sqx + sqy + sqw);
            result._x = Math.asin(-2 * zAxisY);
            result._y = Math.atan2(2.0 * (qz * qx + qy * qw), sqz - sqx - sqy + sqw);
            result._isDirty = true;
        }
        return result;
    }
    /**
     * Sets the given vector3 "result" with the Alpha, Beta, Gamma Euler angles translated from the current quaternion
     * @param result defines the vector which will be filled with the Euler angles
     * @returns result input
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
     */ toAlphaBetaGammaToRef(result) {
        const qz = this._z;
        const qx = this._x;
        const qy = this._y;
        const qw = this._w;
        // Compute intermediate values
        const sinHalfBeta = Math.sqrt(qx * qx + qy * qy);
        const cosHalfBeta = Math.sqrt(qz * qz + qw * qw);
        // Calculate beta
        const beta = 2 * Math.atan2(sinHalfBeta, cosHalfBeta);
        // Calculate gamma + alpha
        const gammaPlusAlpha = 2 * Math.atan2(qz, qw);
        // Calculate gamma - alpha
        const gammaMinusAlpha = 2 * Math.atan2(qy, qx);
        // Calculate gamma and alpha
        const gamma = (gammaPlusAlpha + gammaMinusAlpha) / 2;
        const alpha = (gammaPlusAlpha - gammaMinusAlpha) / 2;
        result.set(alpha, beta, gamma);
        return result;
    }
    /**
     * Updates the given rotation matrix with the current quaternion values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#67
     * @param result defines the target matrix
     * @returns the updated matrix with the rotation
     */ toRotationMatrix(result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromQuaternionToRef(this, result);
        return result;
    }
    /**
     * Updates the current quaternion from the given rotation matrix values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#41
     * @param matrix defines the source matrix
     * @returns the current updated quaternion
     */ fromRotationMatrix(matrix) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(matrix, this);
        return this;
    }
    /**
     * Returns the dot product (float) between the current quaternions and "other"
     * @param other defines the right operand
     * @returns the dot product
     */ dot(other) {
        return this._x * other._x + this._y * other._y + this._z * other._z + this._w * other._w;
    }
    // Statics
    /**
     * Creates a new quaternion from a rotation matrix
     * Example Playground https://playground.babylonjs.com/#L49EJ7#101
     * @param matrix defines the source matrix
     * @returns a new quaternion created from the given rotation matrix values
     */ static FromRotationMatrix(matrix) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(matrix, result);
        return result;
    }
    /**
     * Updates the given quaternion with the given rotation matrix values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#102
     * @param matrix defines the source matrix
     * @param result defines the target quaternion
     * @returns result input
     */ static FromRotationMatrixToRef(matrix, result) {
        const data = matrix.m;
        const m11 = data[0], m12 = data[4], m13 = data[8];
        const m21 = data[1], m22 = data[5], m23 = data[9];
        const m31 = data[2], m32 = data[6], m33 = data[10];
        const trace = m11 + m22 + m33;
        let s;
        if (trace > 0) {
            s = 0.5 / Math.sqrt(trace + 1.0);
            result._w = 0.25 / s;
            result._x = (m32 - m23) * s;
            result._y = (m13 - m31) * s;
            result._z = (m21 - m12) * s;
            result._isDirty = true;
        } else if (m11 > m22 && m11 > m33) {
            s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            result._w = (m32 - m23) / s;
            result._x = 0.25 * s;
            result._y = (m12 + m21) / s;
            result._z = (m13 + m31) / s;
            result._isDirty = true;
        } else if (m22 > m33) {
            s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            result._w = (m13 - m31) / s;
            result._x = (m12 + m21) / s;
            result._y = 0.25 * s;
            result._z = (m23 + m32) / s;
            result._isDirty = true;
        } else {
            s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            result._w = (m21 - m12) / s;
            result._x = (m13 + m31) / s;
            result._y = (m23 + m32) / s;
            result._z = 0.25 * s;
            result._isDirty = true;
        }
        return result;
    }
    /**
     * Returns the dot product (float) between the quaternions "left" and "right"
     * Example Playground https://playground.babylonjs.com/#L49EJ7#61
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the dot product
     */ static Dot(left, right) {
        return left._x * right._x + left._y * right._y + left._z * right._z + left._w * right._w;
    }
    /**
     * Checks if the orientations of two rotation quaternions are close to each other
     * Example Playground https://playground.babylonjs.com/#L49EJ7#60
     * @param quat0 defines the first quaternion to check
     * @param quat1 defines the second quaternion to check
     * @param epsilon defines closeness, 0 same orientation, 1 PI apart, default 0.1
     * @returns true if the two quaternions are close to each other within epsilon
     */ static AreClose(quat0, quat1, epsilon = 0.1) {
        const dot = $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Dot(quat0, quat1);
        return 1 - dot * dot <= epsilon;
    }
    /**
     * Smooth interpolation between two quaternions using Slerp
     * Example Playground https://playground.babylonjs.com/#L49EJ7#93
     * @param source source quaternion
     * @param goal goal quaternion
     * @param deltaTime current interpolation frame
     * @param lerpTime total interpolation time
     * @param result the smoothed quaternion
     * @returns the smoothed quaternion
     */ static SmoothToRef(source, goal, deltaTime, lerpTime, result) {
        let slerp = lerpTime === 0 ? 1 : deltaTime / lerpTime;
        slerp = (0, $iosaP.Clamp)(slerp, 0, 1);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.SlerpToRef(source, goal, slerp, result);
        return result;
    }
    /**
     * Creates an empty quaternion
     * @returns a new quaternion set to (0.0, 0.0, 0.0)
     */ static Zero() {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.0, 0.0, 0.0, 0.0);
    }
    /**
     * Inverse a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#103
     * @param q defines the source quaternion
     * @returns a new quaternion as the inverted current quaternion
     */ static Inverse(q) {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(-q._x, -q._y, -q._z, q._w);
    }
    /**
     * Inverse a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#104
     * @param q defines the source quaternion
     * @param result the quaternion the result will be stored in
     * @returns the result quaternion
     */ static InverseToRef(q, result) {
        result.set(-q._x, -q._y, -q._z, q._w);
        return result;
    }
    /**
     * Creates an identity quaternion
     * @returns the identity quaternion
     */ static Identity() {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.0, 0.0, 0.0, 1.0);
    }
    /**
     * Gets a boolean indicating if the given quaternion is identity
     * @param quaternion defines the quaternion to check
     * @returns true if the quaternion is identity
     */ static IsIdentity(quaternion) {
        return quaternion && quaternion._x === 0 && quaternion._y === 0 && quaternion._z === 0 && quaternion._w === 1;
    }
    /**
     * Creates a quaternion from a rotation around an axis
     * Example Playground https://playground.babylonjs.com/#L49EJ7#72
     * @param axis defines the axis to use
     * @param angle defines the angle to use
     * @returns a new quaternion created from the given axis (Vector3) and angle in radians (float)
     */ static RotationAxis(axis, angle) {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationAxisToRef(axis, angle, new $c7e4de670ed74d35$export$23d6a54f0bbc85a3());
    }
    /**
     * Creates a rotation around an axis and stores it into the given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#73
     * @param axis defines the axis to use
     * @param angle defines the angle to use
     * @param result defines the target quaternion
     * @returns the target quaternion
     */ static RotationAxisToRef(axis, angle, result) {
        result._w = Math.cos(angle / 2);
        const sinByLength = Math.sin(angle / 2) / axis.length();
        result._x = axis._x * sinByLength;
        result._y = axis._y * sinByLength;
        result._z = axis._z * sinByLength;
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a new quaternion from data stored into an array
     * Example Playground https://playground.babylonjs.com/#L49EJ7#63
     * @param array defines the data source
     * @param offset defines the offset in the source array where the data starts
     * @returns a new quaternion
     */ static FromArray(array, offset) {
        if (!offset) offset = 0;
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    }
    /**
     * Updates the given quaternion "result" from the starting index of the given array.
     * Example Playground https://playground.babylonjs.com/#L49EJ7#64
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @param result the quaternion to store the result in
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result._x = array[offset];
        result._y = array[offset + 1];
        result._z = array[offset + 2];
        result._w = array[offset + 3];
        result._isDirty = true;
        return result;
    }
    /**
     * Sets the given quaternion "result" with the given floats.
     * @param x defines the x coordinate of the source
     * @param y defines the y coordinate of the source
     * @param z defines the z coordinate of the source
     * @param w defines the w coordinate of the source
     * @param result defines the quaternion where to store the result
     * @returns the result quaternion
     */ static FromFloatsToRef(x, y, z, w, result) {
        result.copyFromFloats(x, y, z, w);
        return result;
    }
    /**
     * Create a quaternion from Euler rotation angles
     * Example Playground https://playground.babylonjs.com/#L49EJ7#33
     * @param x Pitch
     * @param y Yaw
     * @param z Roll
     * @returns the new Quaternion
     */ static FromEulerAngles(x, y, z) {
        const q = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(y, x, z, q);
        return q;
    }
    /**
     * Updates a quaternion from Euler rotation angles
     * Example Playground https://playground.babylonjs.com/#L49EJ7#34
     * @param x Pitch
     * @param y Yaw
     * @param z Roll
     * @param result the quaternion to store the result
     * @returns the updated quaternion
     */ static FromEulerAnglesToRef(x, y, z, result) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(y, x, z, result);
        return result;
    }
    /**
     * Create a quaternion from Euler rotation vector
     * Example Playground https://playground.babylonjs.com/#L49EJ7#35
     * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
     * @returns the new Quaternion
     */ static FromEulerVector(vec) {
        const q = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(vec._y, vec._x, vec._z, q);
        return q;
    }
    /**
     * Updates a quaternion from Euler rotation vector
     * Example Playground https://playground.babylonjs.com/#L49EJ7#36
     * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
     * @param result the quaternion to store the result
     * @returns the updated quaternion
     */ static FromEulerVectorToRef(vec, result) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(vec._y, vec._x, vec._z, result);
        return result;
    }
    /**
     * Updates a quaternion so that it rotates vector vecFrom to vector vecTo
     * Example Playground - https://playground.babylonjs.com/#L49EJ7#70
     * @param vecFrom defines the direction vector from which to rotate
     * @param vecTo defines the direction vector to which to rotate
     * @param result the quaternion to store the result
     * @param epsilon defines the minimal dot value to define vecs as opposite. Default: `BABYLON.Epsilon`
     * @returns the updated quaternion
     */ static FromUnitVectorsToRef(vecFrom, vecTo, result, epsilon = (0, $53VPf.Epsilon)) {
        const r = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vecFrom, vecTo) + 1;
        if (r < epsilon) {
            if (Math.abs(vecFrom.x) > Math.abs(vecFrom.z)) result.set(-vecFrom.y, vecFrom.x, 0, 0);
            else result.set(0, -vecFrom.z, vecFrom.y, 0);
        } else {
            $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(vecFrom, vecTo, $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0]);
            result.set($c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0].x, $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0].y, $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0].z, r);
        }
        return result.normalize();
    }
    /**
     * Creates a new quaternion from the given Euler float angles (y, x, z)
     * Example Playground https://playground.babylonjs.com/#L49EJ7#77
     * @param yaw defines the rotation around Y axis
     * @param pitch defines the rotation around X axis
     * @param roll defines the rotation around Z axis
     * @returns the new quaternion
     */ static RotationYawPitchRoll(yaw, pitch, roll) {
        const q = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(yaw, pitch, roll, q);
        return q;
    }
    /**
     * Creates a new rotation from the given Euler float angles (y, x, z) and stores it in the target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#78
     * @param yaw defines the rotation around Y axis
     * @param pitch defines the rotation around X axis
     * @param roll defines the rotation around Z axis
     * @param result defines the target quaternion
     * @returns result input
     */ static RotationYawPitchRollToRef(yaw, pitch, roll, result) {
        // Produces a quaternion from Euler angles in the z-y-x orientation (Tait-Bryan angles)
        const halfRoll = roll * 0.5;
        const halfPitch = pitch * 0.5;
        const halfYaw = yaw * 0.5;
        const sinRoll = Math.sin(halfRoll);
        const cosRoll = Math.cos(halfRoll);
        const sinPitch = Math.sin(halfPitch);
        const cosPitch = Math.cos(halfPitch);
        const sinYaw = Math.sin(halfYaw);
        const cosYaw = Math.cos(halfYaw);
        result._x = cosYaw * sinPitch * cosRoll + sinYaw * cosPitch * sinRoll;
        result._y = sinYaw * cosPitch * cosRoll - cosYaw * sinPitch * sinRoll;
        result._z = cosYaw * cosPitch * sinRoll - sinYaw * sinPitch * cosRoll;
        result._w = cosYaw * cosPitch * cosRoll + sinYaw * sinPitch * sinRoll;
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation
     * Example Playground https://playground.babylonjs.com/#L49EJ7#68
     * @param alpha defines the rotation around first axis
     * @param beta defines the rotation around second axis
     * @param gamma defines the rotation around third axis
     * @returns the new quaternion
     */ static RotationAlphaBetaGamma(alpha, beta, gamma) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationAlphaBetaGammaToRef(alpha, beta, gamma, result);
        return result;
    }
    /**
     * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation and stores it in the target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#69
     * @param alpha defines the rotation around first axis
     * @param beta defines the rotation around second axis
     * @param gamma defines the rotation around third axis
     * @param result defines the target quaternion
     * @returns result input
     */ static RotationAlphaBetaGammaToRef(alpha, beta, gamma, result) {
        // Produces a quaternion from Euler angles in the z-x-z orientation
        const halfGammaPlusAlpha = (gamma + alpha) * 0.5;
        const halfGammaMinusAlpha = (gamma - alpha) * 0.5;
        const halfBeta = beta * 0.5;
        result._x = Math.cos(halfGammaMinusAlpha) * Math.sin(halfBeta);
        result._y = Math.sin(halfGammaMinusAlpha) * Math.sin(halfBeta);
        result._z = Math.sin(halfGammaPlusAlpha) * Math.cos(halfBeta);
        result._w = Math.cos(halfGammaPlusAlpha) * Math.cos(halfBeta);
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a new quaternion containing the rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation)
     * Example Playground https://playground.babylonjs.com/#L49EJ7#75
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @returns the new quaternion
     */ static RotationQuaternionFromAxis(axis1, axis2, axis3) {
        const quat = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.0, 0.0, 0.0, 0.0);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationQuaternionFromAxisToRef(axis1, axis2, axis3, quat);
        return quat;
    }
    /**
     * Creates a rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation) and stores it in the target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#76
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @param ref defines the target quaternion
     * @returns result input
     */ static RotationQuaternionFromAxisToRef(axis1, axis2, axis3, ref) {
        const rotMat = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        axis1 = axis1.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[0]);
        axis2 = axis2.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[1]);
        axis3 = axis3.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[2]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromXYZAxesToRef(axis1, axis2, axis3, rotMat);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(rotMat, ref);
        return ref;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
     * This function works in left handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#96
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns A new quaternion oriented toward the specified forward and up.
     */ static FromLookDirectionLH(forward, up) {
        const quat = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromLookDirectionLHToRef(forward, up, quat);
        return quat;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
     * This function works in left handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#97
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param ref defines the target quaternion.
     * @returns result input
     */ static FromLookDirectionLHToRef(forward, up, ref) {
        const rotMat = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionLHToRef(forward, up, rotMat);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(rotMat, ref);
        return ref;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
     * This function works in right handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#98
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns A new quaternion oriented toward the specified forward and up.
     */ static FromLookDirectionRH(forward, up) {
        const quat = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromLookDirectionRHToRef(forward, up, quat);
        return quat;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
     * This function works in right handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#105
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param ref defines the target quaternion.
     * @returns result input
     */ static FromLookDirectionRHToRef(forward, up, ref) {
        const rotMat = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionRHToRef(forward, up, rotMat);
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(rotMat, ref);
    }
    /**
     * Interpolates between two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#79
     * @param left defines first quaternion
     * @param right defines second quaternion
     * @param amount defines the gradient to use
     * @returns the new interpolated quaternion
     */ static Slerp(left, right, amount) {
        const result = $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Identity();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.SlerpToRef(left, right, amount, result);
        return result;
    }
    /**
     * Interpolates between two quaternions and stores it into a target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#92
     * @param left defines first quaternion
     * @param right defines second quaternion
     * @param amount defines the gradient to use
     * @param result defines the target quaternion
     * @returns result input
     */ static SlerpToRef(left, right, amount, result) {
        let num2;
        let num3;
        let num4 = left._x * right._x + left._y * right._y + left._z * right._z + left._w * right._w;
        let flag = false;
        if (num4 < 0) {
            flag = true;
            num4 = -num4;
        }
        if (num4 > 0.999999) {
            num3 = 1 - amount;
            num2 = flag ? -amount : amount;
        } else {
            const num5 = Math.acos(num4);
            const num6 = 1.0 / Math.sin(num5);
            num3 = Math.sin((1.0 - amount) * num5) * num6;
            num2 = flag ? -Math.sin(amount * num5) * num6 : Math.sin(amount * num5) * num6;
        }
        result._x = num3 * left._x + num2 * right._x;
        result._y = num3 * left._y + num2 * right._y;
        result._z = num3 * left._z + num2 * right._z;
        result._w = num3 * left._w + num2 * right._w;
        result._isDirty = true;
        return result;
    }
    /**
     * Interpolate between two quaternions using Hermite interpolation
     * Example Playground https://playground.babylonjs.com/#L49EJ7#47
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-quaternion-spline
     * @param value1 defines first quaternion
     * @param tangent1 defines the incoming tangent
     * @param value2 defines second quaternion
     * @param tangent2 defines the outgoing tangent
     * @param amount defines the target quaternion
     * @returns the new interpolated quaternion
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const x = value1._x * part1 + value2._x * part2 + tangent1._x * part3 + tangent2._x * part4;
        const y = value1._y * part1 + value2._y * part2 + tangent1._y * part3 + tangent2._y * part4;
        const z = value1._z * part1 + value2._z * part2 + tangent1._z * part3 + tangent2._z * part4;
        const w = value1._w * part1 + value2._w * part2 + tangent1._w * part3 + tangent2._w * part4;
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(x, y, z, w);
    }
    /**
     * Returns a new Quaternion which is the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#L49EJ7#48
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Update a Quaternion with the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#L49EJ7#49
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     * @returns result input
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result._x = (t2 - time) * 6 * value1._x + (3 * t2 - 4 * time + 1) * tangent1._x + (-t2 + time) * 6 * value2._x + (3 * t2 - 2 * time) * tangent2._x;
        result._y = (t2 - time) * 6 * value1._y + (3 * t2 - 4 * time + 1) * tangent1._y + (-t2 + time) * 6 * value2._y + (3 * t2 - 2 * time) * tangent2._y;
        result._z = (t2 - time) * 6 * value1._z + (3 * t2 - 4 * time + 1) * tangent1._z + (-t2 + time) * 6 * value2._z + (3 * t2 - 2 * time) * tangent2._z;
        result._w = (t2 - time) * 6 * value1._w + (3 * t2 - 4 * time + 1) * tangent1._w + (-t2 + time) * 6 * value2._w + (3 * t2 - 2 * time) * tangent2._w;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Quaternion as the normalization of the given Quaternion
     * @param quat defines the Quaternion to normalize
     * @returns the new Quaternion
     */ static Normalize(quat) {
        const result = $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.NormalizeToRef(quat, result);
        return result;
    }
    /**
     * Sets the given Quaternion "result" with the normalization of the given first Quaternion
     * @param quat defines the Quaternion to normalize
     * @param result defines the Quaternion where to store the result
     * @returns result input
     */ static NormalizeToRef(quat, result) {
        quat.normalizeToRef(result);
        return result;
    }
    /**
     * Returns a new Quaternion set with the coordinates of "value", if the quaternion "value" is in the cube defined by the quaternions "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @returns the new Quaternion
     */ static Clamp(value, min, max) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.ClampToRef(value, min, max, result);
        return result;
    }
    /**
     * Sets the given quaternion "result" with the coordinates of "value", if the quaternion "value" is in the cube defined by the quaternions "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @param result defines the Quaternion where to store the result
     * @returns result input
     */ static ClampToRef(value, min, max, result) {
        return result.copyFromFloats((0, $iosaP.Clamp)(value.x, min.x, max.x), (0, $iosaP.Clamp)(value.y, min.y, max.y), (0, $iosaP.Clamp)(value.z, min.z, max.z), (0, $iosaP.Clamp)(value.w, min.w, max.w));
    }
    /**
     * Returns a new Quaternion with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Quaternion with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Quaternion with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Do not use
     * @internal
     */ static Minimize() {
        throw new ReferenceError("Quaternion.Minimize does not make sense");
    }
    /**
     * Do not use
     * @internal
     */ static Maximize() {
        throw new ReferenceError("Quaternion.Maximize does not make sense");
    }
    /**
     * Returns the distance (float) between the quaternions "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two quaternions
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$23d6a54f0bbc85a3.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance (float) between the quaternions "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two quaternions squared
     */ static DistanceSquared(value1, value2) {
        const x = value1.x - value2.x;
        const y = value1.y - value2.y;
        const z = value1.z - value2.z;
        const w = value1.w - value2.w;
        return x * x + y * y + z * z + w * w;
    }
    /**
     * Returns a new Quaternion located at the center between the quaternions "value1" and "value2".
     * @param value1 value to calulate the center between
     * @param value2 value to calulate the center between
     * @returns the center between the two quaternions
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.CenterToRef(value1, value2, $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero());
    }
    /**
     * Gets the center of the quaternions "value1" and "value2" and stores the result in the quaternion "ref"
     * @param value1 defines first quaternion
     * @param value2 defines second quaternion
     * @param ref defines third quaternion
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2, (value1.z + value2.z) / 2, (value1.w + value2.w) / 2);
    }
}
/**
 * If the first quaternion is flagged with integers (as everything is 0,0,0,0), V8 stores all of the properties as integers internally because it doesn't know any better yet.
 * If subsequent quaternion are created with non-integer values, V8 determines that it would be best to represent these properties as doubles instead of integers,
 * and henceforth it will use floating-point representation for all quaternion instances that it creates.
 * But the original quaternion instances are unchanged and has a "deprecated map".
 * If we keep using the quaternion instances from step 1, it will now be a poison pill which will mess up optimizations in any code it touches.
 */ $c7e4de670ed74d35$export$23d6a54f0bbc85a3._V8PerformanceHack = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.5, 0.5, 0.5, 0.5);
$c7e4de670ed74d35$export$23d6a54f0bbc85a3;
Object.defineProperties($c7e4de670ed74d35$export$23d6a54f0bbc85a3.prototype, {
    dimension: {
        value: [
            4
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$5b12bf1653c0dd85 {
    /**
     * Gets the precision of matrix computations
     */ static get Use64Bits() {
        return (0, $3agwF.PerformanceConfigurator).MatrixUse64Bits;
    }
    /**
     * Gets the internal data of the matrix
     */ get m() {
        return this._m;
    }
    /**
     * Update the updateFlag to indicate that the matrix has been updated
     */ markAsUpdated() {
        this.updateFlag = $c7e4de670ed74d35$export$5b12bf1653c0dd85._UpdateFlagSeed++;
        this._isIdentity = false;
        this._isIdentity3x2 = false;
        this._isIdentityDirty = true;
        this._isIdentity3x2Dirty = true;
    }
    _updateIdentityStatus(isIdentity, isIdentityDirty = false, isIdentity3x2 = false, isIdentity3x2Dirty = true) {
        this._isIdentity = isIdentity;
        this._isIdentity3x2 = isIdentity || isIdentity3x2;
        this._isIdentityDirty = this._isIdentity ? false : isIdentityDirty;
        this._isIdentity3x2Dirty = this._isIdentity3x2 ? false : isIdentity3x2Dirty;
    }
    /**
     * Creates an empty matrix (filled with zeros)
     */ constructor(){
        this._isIdentity = false;
        this._isIdentityDirty = true;
        this._isIdentity3x2 = true;
        this._isIdentity3x2Dirty = true;
        /**
         * Gets the update flag of the matrix which is an unique number for the matrix.
         * It will be incremented every time the matrix data change.
         * You can use it to speed the comparison between two versions of the same matrix.
         */ this.updateFlag = -1;
        if ((0, $3agwF.PerformanceConfigurator).MatrixTrackPrecisionChange) (0, $3agwF.PerformanceConfigurator).MatrixTrackedMatrices.push(this);
        this._m = new (0, $3agwF.PerformanceConfigurator).MatrixCurrentType(16);
        this.markAsUpdated();
    }
    // Properties
    /**
     * Check if the current matrix is identity
     * @returns true is the matrix is the identity matrix
     */ isIdentity() {
        if (this._isIdentityDirty) {
            this._isIdentityDirty = false;
            const m = this._m;
            this._isIdentity = m[0] === 1.0 && m[1] === 0.0 && m[2] === 0.0 && m[3] === 0.0 && m[4] === 0.0 && m[5] === 1.0 && m[6] === 0.0 && m[7] === 0.0 && m[8] === 0.0 && m[9] === 0.0 && m[10] === 1.0 && m[11] === 0.0 && m[12] === 0.0 && m[13] === 0.0 && m[14] === 0.0 && m[15] === 1.0;
        }
        return this._isIdentity;
    }
    /**
     * Check if the current matrix is identity as a texture matrix (3x2 store in 4x4)
     * @returns true is the matrix is the identity matrix
     */ isIdentityAs3x2() {
        if (this._isIdentity3x2Dirty) {
            this._isIdentity3x2Dirty = false;
            if (this._m[0] !== 1.0 || this._m[5] !== 1.0 || this._m[15] !== 1.0) this._isIdentity3x2 = false;
            else if (this._m[1] !== 0.0 || this._m[2] !== 0.0 || this._m[3] !== 0.0 || this._m[4] !== 0.0 || this._m[6] !== 0.0 || this._m[7] !== 0.0 || this._m[8] !== 0.0 || this._m[9] !== 0.0 || this._m[10] !== 0.0 || this._m[11] !== 0.0 || this._m[12] !== 0.0 || this._m[13] !== 0.0 || this._m[14] !== 0.0) this._isIdentity3x2 = false;
            else this._isIdentity3x2 = true;
        }
        return this._isIdentity3x2;
    }
    /**
     * Gets the determinant of the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#34
     * @returns the matrix determinant
     */ determinant() {
        if (this._isIdentity === true) return 1;
        const m = this._m;
        const m00 = m[0], m01 = m[1], m02 = m[2], m03 = m[3];
        const m10 = m[4], m11 = m[5], m12 = m[6], m13 = m[7];
        const m20 = m[8], m21 = m[9], m22 = m[10], m23 = m[11];
        const m30 = m[12], m31 = m[13], m32 = m[14], m33 = m[15];
        // https://en.wikipedia.org/wiki/Laplace_expansion
        // to compute the deterrminant of a 4x4 Matrix we compute the cofactors of any row or column,
        // then we multiply each Cofactor by its corresponding matrix value and sum them all to get the determinant
        // Cofactor(i, j) = sign(i,j) * det(Minor(i, j))
        // where
        //  - sign(i,j) = (i+j) % 2 === 0 ? 1 : -1
        //  - Minor(i, j) is the 3x3 matrix we get by removing row i and column j from current Matrix
        //
        // Here we do that for the 1st row.
        const det_22_33 = m22 * m33 - m32 * m23;
        const det_21_33 = m21 * m33 - m31 * m23;
        const det_21_32 = m21 * m32 - m31 * m22;
        const det_20_33 = m20 * m33 - m30 * m23;
        const det_20_32 = m20 * m32 - m22 * m30;
        const det_20_31 = m20 * m31 - m30 * m21;
        const cofact_00 = +(m11 * det_22_33 - m12 * det_21_33 + m13 * det_21_32);
        const cofact_01 = -(m10 * det_22_33 - m12 * det_20_33 + m13 * det_20_32);
        const cofact_02 = +(m10 * det_21_33 - m11 * det_20_33 + m13 * det_20_31);
        const cofact_03 = -(m10 * det_21_32 - m11 * det_20_32 + m12 * det_20_31);
        return m00 * cofact_00 + m01 * cofact_01 + m02 * cofact_02 + m03 * cofact_03;
    }
    // Methods
    /**
     * Gets a string with the Matrix values
     * @returns a string with the Matrix values
     */ toString() {
        return `{${this.m[0]}, ${this.m[1]}, ${this.m[2]}, ${this.m[3]}\n${this.m[4]}, ${this.m[5]}, ${this.m[6]}, ${this.m[7]}\n${this.m[8]}, ${this.m[9]}, ${this.m[10]}, ${this.m[11]}\n${this.m[12]}, ${this.m[13]}, ${this.m[14]}, ${this.m[15]}}`;
    }
    toArray(array = null, index = 0) {
        if (!array) return this._m;
        const m = this._m;
        for(let i = 0; i < 16; i++)array[index + i] = m[i];
        return this;
    }
    /**
     * Returns the matrix as a Float32Array or Array<number>
     * Example Playground - https://playground.babylonjs.com/#AV9X17#114
     * @returns the matrix underlying array.
     */ asArray() {
        return this._m;
    }
    fromArray(array, index = 0) {
        return $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromArrayToRef(array, index, this);
    }
    copyFromFloats(...floats) {
        return $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromArrayToRef(floats, 0, this);
    }
    set(...values) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = values[i];
        this.markAsUpdated();
        return this;
    }
    setAll(value) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = value;
        this.markAsUpdated();
        return this;
    }
    /**
     * Inverts the current matrix in place
     * Example Playground - https://playground.babylonjs.com/#AV9X17#118
     * @returns the current inverted matrix
     */ invert() {
        this.invertToRef(this);
        return this;
    }
    /**
     * Sets all the matrix elements to zero
     * @returns the current matrix
     */ reset() {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, this);
        this._updateIdentityStatus(false);
        return this;
    }
    /**
     * Adds the current matrix with a second one
     * Example Playground - https://playground.babylonjs.com/#AV9X17#44
     * @param other defines the matrix to add
     * @returns a new matrix as the addition of the current matrix and the given one
     */ add(other) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        this.addToRef(other, result);
        return result;
    }
    /**
     * Sets the given matrix "result" to the addition of the current matrix and the given one
     * Example Playground - https://playground.babylonjs.com/#AV9X17#45
     * @param other defines the matrix to add
     * @param result defines the target matrix
     * @returns result input
     */ addToRef(other, result) {
        const m = this._m;
        const resultM = result._m;
        const otherM = other.m;
        for(let index = 0; index < 16; index++)resultM[index] = m[index] + otherM[index];
        result.markAsUpdated();
        return result;
    }
    /**
     * Adds in place the given matrix to the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#46
     * @param other defines the second operand
     * @returns the current updated matrix
     */ addToSelf(other) {
        const m = this._m;
        const otherM = other.m;
        m[0] += otherM[0];
        m[1] += otherM[1];
        m[2] += otherM[2];
        m[3] += otherM[3];
        m[4] += otherM[4];
        m[5] += otherM[5];
        m[6] += otherM[6];
        m[7] += otherM[7];
        m[8] += otherM[8];
        m[9] += otherM[9];
        m[10] += otherM[10];
        m[11] += otherM[11];
        m[12] += otherM[12];
        m[13] += otherM[13];
        m[14] += otherM[14];
        m[15] += otherM[15];
        this.markAsUpdated();
        return this;
    }
    addInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] += otherM[i];
        this.markAsUpdated();
        return this;
    }
    addInPlaceFromFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] += floats[i];
        this.markAsUpdated();
        return this;
    }
    subtract(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] -= otherM[i];
        this.markAsUpdated();
        return this;
    }
    subtractToRef(other, result) {
        const m = this._m, otherM = other.m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] - otherM[i];
        result.markAsUpdated();
        return result;
    }
    subtractInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] -= otherM[i];
        this.markAsUpdated();
        return this;
    }
    subtractFromFloats(...floats) {
        return this.subtractFromFloatsToRef(...floats, new $c7e4de670ed74d35$export$5b12bf1653c0dd85());
    }
    subtractFromFloatsToRef(...args) {
        const result = args.pop(), m = this._m, resultM = result._m, values = args;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] - values[i];
        result.markAsUpdated();
        return result;
    }
    /**
     * Sets the given matrix to the current inverted Matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#119
     * @param other defines the target matrix
     * @returns result input
     */ invertToRef(other) {
        if (this._isIdentity === true) {
            $c7e4de670ed74d35$export$5b12bf1653c0dd85.IdentityToRef(other);
            return other;
        }
        // the inverse of a Matrix is the transpose of cofactor matrix divided by the determinant
        const m = this._m;
        const m00 = m[0], m01 = m[1], m02 = m[2], m03 = m[3];
        const m10 = m[4], m11 = m[5], m12 = m[6], m13 = m[7];
        const m20 = m[8], m21 = m[9], m22 = m[10], m23 = m[11];
        const m30 = m[12], m31 = m[13], m32 = m[14], m33 = m[15];
        const det_22_33 = m22 * m33 - m32 * m23;
        const det_21_33 = m21 * m33 - m31 * m23;
        const det_21_32 = m21 * m32 - m31 * m22;
        const det_20_33 = m20 * m33 - m30 * m23;
        const det_20_32 = m20 * m32 - m22 * m30;
        const det_20_31 = m20 * m31 - m30 * m21;
        const cofact_00 = +(m11 * det_22_33 - m12 * det_21_33 + m13 * det_21_32);
        const cofact_01 = -(m10 * det_22_33 - m12 * det_20_33 + m13 * det_20_32);
        const cofact_02 = +(m10 * det_21_33 - m11 * det_20_33 + m13 * det_20_31);
        const cofact_03 = -(m10 * det_21_32 - m11 * det_20_32 + m12 * det_20_31);
        const det = m00 * cofact_00 + m01 * cofact_01 + m02 * cofact_02 + m03 * cofact_03;
        if (det === 0) {
            // not invertible
            other.copyFrom(this);
            return other;
        }
        const detInv = 1 / det;
        const det_12_33 = m12 * m33 - m32 * m13;
        const det_11_33 = m11 * m33 - m31 * m13;
        const det_11_32 = m11 * m32 - m31 * m12;
        const det_10_33 = m10 * m33 - m30 * m13;
        const det_10_32 = m10 * m32 - m30 * m12;
        const det_10_31 = m10 * m31 - m30 * m11;
        const det_12_23 = m12 * m23 - m22 * m13;
        const det_11_23 = m11 * m23 - m21 * m13;
        const det_11_22 = m11 * m22 - m21 * m12;
        const det_10_23 = m10 * m23 - m20 * m13;
        const det_10_22 = m10 * m22 - m20 * m12;
        const det_10_21 = m10 * m21 - m20 * m11;
        const cofact_10 = -(m01 * det_22_33 - m02 * det_21_33 + m03 * det_21_32);
        const cofact_11 = +(m00 * det_22_33 - m02 * det_20_33 + m03 * det_20_32);
        const cofact_12 = -(m00 * det_21_33 - m01 * det_20_33 + m03 * det_20_31);
        const cofact_13 = +(m00 * det_21_32 - m01 * det_20_32 + m02 * det_20_31);
        const cofact_20 = +(m01 * det_12_33 - m02 * det_11_33 + m03 * det_11_32);
        const cofact_21 = -(m00 * det_12_33 - m02 * det_10_33 + m03 * det_10_32);
        const cofact_22 = +(m00 * det_11_33 - m01 * det_10_33 + m03 * det_10_31);
        const cofact_23 = -(m00 * det_11_32 - m01 * det_10_32 + m02 * det_10_31);
        const cofact_30 = -(m01 * det_12_23 - m02 * det_11_23 + m03 * det_11_22);
        const cofact_31 = +(m00 * det_12_23 - m02 * det_10_23 + m03 * det_10_22);
        const cofact_32 = -(m00 * det_11_23 - m01 * det_10_23 + m03 * det_10_21);
        const cofact_33 = +(m00 * det_11_22 - m01 * det_10_22 + m02 * det_10_21);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(cofact_00 * detInv, cofact_10 * detInv, cofact_20 * detInv, cofact_30 * detInv, cofact_01 * detInv, cofact_11 * detInv, cofact_21 * detInv, cofact_31 * detInv, cofact_02 * detInv, cofact_12 * detInv, cofact_22 * detInv, cofact_32 * detInv, cofact_03 * detInv, cofact_13 * detInv, cofact_23 * detInv, cofact_33 * detInv, other);
        return other;
    }
    /**
     * add a value at the specified position in the current Matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#47
     * @param index the index of the value within the matrix. between 0 and 15.
     * @param value the value to be added
     * @returns the current updated matrix
     */ addAtIndex(index, value) {
        this._m[index] += value;
        this.markAsUpdated();
        return this;
    }
    /**
     * mutiply the specified position in the current Matrix by a value
     * @param index the index of the value within the matrix. between 0 and 15.
     * @param value the value to be added
     * @returns the current updated matrix
     */ multiplyAtIndex(index, value) {
        this._m[index] *= value;
        this.markAsUpdated();
        return this;
    }
    /**
     * Inserts the translation vector (using 3 floats) in the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#120
     * @param x defines the 1st component of the translation
     * @param y defines the 2nd component of the translation
     * @param z defines the 3rd component of the translation
     * @returns the current updated matrix
     */ setTranslationFromFloats(x, y, z) {
        this._m[12] = x;
        this._m[13] = y;
        this._m[14] = z;
        this.markAsUpdated();
        return this;
    }
    /**
     * Adds the translation vector (using 3 floats) in the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#20
     * Example Playground - https://playground.babylonjs.com/#AV9X17#48
     * @param x defines the 1st component of the translation
     * @param y defines the 2nd component of the translation
     * @param z defines the 3rd component of the translation
     * @returns the current updated matrix
     */ addTranslationFromFloats(x, y, z) {
        this._m[12] += x;
        this._m[13] += y;
        this._m[14] += z;
        this.markAsUpdated();
        return this;
    }
    /**
     * Inserts the translation vector in the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#121
     * @param vector3 defines the translation to insert
     * @returns the current updated matrix
     */ setTranslation(vector3) {
        return this.setTranslationFromFloats(vector3._x, vector3._y, vector3._z);
    }
    /**
     * Gets the translation value of the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#122
     * @returns a new Vector3 as the extracted translation from the matrix
     */ getTranslation() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._m[12], this._m[13], this._m[14]);
    }
    /**
     * Fill a Vector3 with the extracted translation from the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#123
     * @param result defines the Vector3 where to store the translation
     * @returns the current matrix
     */ getTranslationToRef(result) {
        result.x = this._m[12];
        result.y = this._m[13];
        result.z = this._m[14];
        return result;
    }
    /**
     * Remove rotation and scaling part from the matrix
     * @returns the updated matrix
     */ removeRotationAndScaling() {
        const m = this.m;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, m[12], m[13], m[14], m[15], this);
        this._updateIdentityStatus(m[12] === 0 && m[13] === 0 && m[14] === 0 && m[15] === 1);
        return this;
    }
    /**
     * Copy the current matrix from the given one
     * Example Playground - https://playground.babylonjs.com/#AV9X17#21
     * @param other defines the source matrix
     * @returns the current updated matrix
     */ copyFrom(other) {
        other.copyToArray(this._m);
        const o = other;
        this.updateFlag = o.updateFlag;
        this._updateIdentityStatus(o._isIdentity, o._isIdentityDirty, o._isIdentity3x2, o._isIdentity3x2Dirty);
        return this;
    }
    /**
     * Populates the given array from the starting index with the current matrix values
     * @param array defines the target array
     * @param offset defines the offset in the target array where to start storing values
     * @returns the current matrix
     */ copyToArray(array, offset = 0) {
        const source = this._m;
        array[offset] = source[0];
        array[offset + 1] = source[1];
        array[offset + 2] = source[2];
        array[offset + 3] = source[3];
        array[offset + 4] = source[4];
        array[offset + 5] = source[5];
        array[offset + 6] = source[6];
        array[offset + 7] = source[7];
        array[offset + 8] = source[8];
        array[offset + 9] = source[9];
        array[offset + 10] = source[10];
        array[offset + 11] = source[11];
        array[offset + 12] = source[12];
        array[offset + 13] = source[13];
        array[offset + 14] = source[14];
        array[offset + 15] = source[15];
        return this;
    }
    /**
     * Multiply two matrices
     * Example Playground - https://playground.babylonjs.com/#AV9X17#15
     * A.multiply(B) means apply B to A so result is B x A
     * @param other defines the second operand
     * @returns a new matrix set with the multiplication result of the current Matrix and the given one
     */ multiply(other) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        this.multiplyToRef(other, result);
        return result;
    }
    /**
     * This method performs component-by-component in-place multiplication, rather than true matrix multiplication.
     * Use multiply or multiplyToRef for matrix multiplication.
     * @param other defines the second operand
     * @returns the current updated matrix
     */ multiplyInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] *= otherM[i];
        this.markAsUpdated();
        return this;
    }
    /**
     * This method performs a component-by-component multiplication of the current matrix with the array of transmitted numbers.
     * Use multiply or multiplyToRef for matrix multiplication.
     * @param floats defines the array of numbers to multiply the matrix by
     * @returns the current updated matrix
     */ multiplyByFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] *= floats[i];
        this.markAsUpdated();
        return this;
    }
    /**
     * Multiples the current matrix by the given floats and stores them in the given ref
     * @param args The floats and ref
     * @returns The updated ref
     */ multiplyByFloatsToRef(...args) {
        const result = args.pop(), m = this._m, resultM = result._m, values = args;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] * values[i];
        result.markAsUpdated();
        return result;
    }
    /**
     * Sets the given matrix "result" with the multiplication result of the current Matrix and the given one
     * A.multiplyToRef(B, R) means apply B to A and store in R and R = B x A
     * Example Playground - https://playground.babylonjs.com/#AV9X17#16
     * @param other defines the second operand
     * @param result defines the matrix where to store the multiplication
     * @returns result input
     */ multiplyToRef(other, result) {
        if (this._isIdentity) {
            result.copyFrom(other);
            return result;
        }
        if (other._isIdentity) {
            result.copyFrom(this);
            return result;
        }
        this.multiplyToArray(other, result._m, 0);
        result.markAsUpdated();
        return result;
    }
    /**
     * Sets the Float32Array "result" from the given index "offset" with the multiplication of the current matrix and the given one
     * @param other defines the second operand
     * @param result defines the array where to store the multiplication
     * @param offset defines the offset in the target array where to start storing values
     * @returns the current matrix
     */ multiplyToArray(other, result, offset) {
        const m = this._m;
        const otherM = other.m;
        const tm0 = m[0], tm1 = m[1], tm2 = m[2], tm3 = m[3];
        const tm4 = m[4], tm5 = m[5], tm6 = m[6], tm7 = m[7];
        const tm8 = m[8], tm9 = m[9], tm10 = m[10], tm11 = m[11];
        const tm12 = m[12], tm13 = m[13], tm14 = m[14], tm15 = m[15];
        const om0 = otherM[0], om1 = otherM[1], om2 = otherM[2], om3 = otherM[3];
        const om4 = otherM[4], om5 = otherM[5], om6 = otherM[6], om7 = otherM[7];
        const om8 = otherM[8], om9 = otherM[9], om10 = otherM[10], om11 = otherM[11];
        const om12 = otherM[12], om13 = otherM[13], om14 = otherM[14], om15 = otherM[15];
        result[offset] = tm0 * om0 + tm1 * om4 + tm2 * om8 + tm3 * om12;
        result[offset + 1] = tm0 * om1 + tm1 * om5 + tm2 * om9 + tm3 * om13;
        result[offset + 2] = tm0 * om2 + tm1 * om6 + tm2 * om10 + tm3 * om14;
        result[offset + 3] = tm0 * om3 + tm1 * om7 + tm2 * om11 + tm3 * om15;
        result[offset + 4] = tm4 * om0 + tm5 * om4 + tm6 * om8 + tm7 * om12;
        result[offset + 5] = tm4 * om1 + tm5 * om5 + tm6 * om9 + tm7 * om13;
        result[offset + 6] = tm4 * om2 + tm5 * om6 + tm6 * om10 + tm7 * om14;
        result[offset + 7] = tm4 * om3 + tm5 * om7 + tm6 * om11 + tm7 * om15;
        result[offset + 8] = tm8 * om0 + tm9 * om4 + tm10 * om8 + tm11 * om12;
        result[offset + 9] = tm8 * om1 + tm9 * om5 + tm10 * om9 + tm11 * om13;
        result[offset + 10] = tm8 * om2 + tm9 * om6 + tm10 * om10 + tm11 * om14;
        result[offset + 11] = tm8 * om3 + tm9 * om7 + tm10 * om11 + tm11 * om15;
        result[offset + 12] = tm12 * om0 + tm13 * om4 + tm14 * om8 + tm15 * om12;
        result[offset + 13] = tm12 * om1 + tm13 * om5 + tm14 * om9 + tm15 * om13;
        result[offset + 14] = tm12 * om2 + tm13 * om6 + tm14 * om10 + tm15 * om14;
        result[offset + 15] = tm12 * om3 + tm13 * om7 + tm14 * om11 + tm15 * om15;
        return this;
    }
    divide(other) {
        return this.divideToRef(other, new $c7e4de670ed74d35$export$5b12bf1653c0dd85());
    }
    divideToRef(other, result) {
        const m = this._m, otherM = other.m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] / otherM[i];
        result.markAsUpdated();
        return result;
    }
    divideInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] /= otherM[i];
        this.markAsUpdated();
        return this;
    }
    minimizeInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], otherM[i]);
        this.markAsUpdated();
        return this;
    }
    minimizeInPlaceFromFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], floats[i]);
        this.markAsUpdated();
        return this;
    }
    maximizeInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], otherM[i]);
        this.markAsUpdated();
        return this;
    }
    maximizeInPlaceFromFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], floats[i]);
        this.markAsUpdated();
        return this;
    }
    negate() {
        return this.negateToRef(new $c7e4de670ed74d35$export$5b12bf1653c0dd85());
    }
    negateInPlace() {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = -m[i];
        this.markAsUpdated();
        return this;
    }
    negateToRef(result) {
        const m = this._m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = -m[i];
        result.markAsUpdated();
        return result;
    }
    /**
     * Check equality between this matrix and a second one
     * @param value defines the second matrix to compare
     * @returns true is the current matrix and the given one values are strictly equal
     */ equals(value) {
        const other = value;
        if (!other) return false;
        if (this._isIdentity || other._isIdentity) {
            if (!this._isIdentityDirty && !other._isIdentityDirty) return this._isIdentity && other._isIdentity;
        }
        const m = this.m;
        const om = other.m;
        return m[0] === om[0] && m[1] === om[1] && m[2] === om[2] && m[3] === om[3] && m[4] === om[4] && m[5] === om[5] && m[6] === om[6] && m[7] === om[7] && m[8] === om[8] && m[9] === om[9] && m[10] === om[10] && m[11] === om[11] && m[12] === om[12] && m[13] === om[13] && m[14] === om[14] && m[15] === om[15];
    }
    equalsWithEpsilon(other, epsilon = 0) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++){
            if (!(0, $iosaP.WithinEpsilon)(m[i], otherM[i], epsilon)) return false;
        }
        return true;
    }
    equalsToFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++){
            if (m[i] != floats[i]) return false;
        }
        return true;
    }
    floor() {
        return this.floorToRef(new $c7e4de670ed74d35$export$5b12bf1653c0dd85());
    }
    floorToRef(result) {
        const m = this._m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = Math.floor(m[i]);
        result.markAsUpdated();
        return result;
    }
    fract() {
        return this.fractToRef(new $c7e4de670ed74d35$export$5b12bf1653c0dd85());
    }
    fractToRef(result) {
        const m = this._m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] - Math.floor(m[i]);
        result.markAsUpdated();
        return result;
    }
    /**
     * Clone the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#18
     * @returns a new matrix from the current matrix
     */ clone() {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        matrix.copyFrom(this);
        return matrix;
    }
    /**
     * Returns the name of the current matrix class
     * @returns the string "Matrix"
     */ getClassName() {
        return "Matrix";
    }
    /**
     * Gets the hash code of the current matrix
     * @returns the hash code
     */ getHashCode() {
        let hash = $c7e4de670ed74d35$var$_ExtractAsInt(this._m[0]);
        for(let i = 1; i < 16; i++)hash = hash * 397 ^ $c7e4de670ed74d35$var$_ExtractAsInt(this._m[i]);
        return hash;
    }
    /**
     * Decomposes the current Matrix into a translation, rotation and scaling components of the provided node
     * Example Playground - https://playground.babylonjs.com/#AV9X17#13
     * @param node the node to decompose the matrix to
     * @returns true if operation was successful
     */ decomposeToTransformNode(node) {
        node.rotationQuaternion = node.rotationQuaternion || new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        return this.decompose(node.scaling, node.rotationQuaternion, node.position);
    }
    /**
     * Decomposes the current Matrix into a translation, rotation and scaling components
     * Example Playground - https://playground.babylonjs.com/#AV9X17#12
     * @param scale defines the scale vector3 given as a reference to update
     * @param rotation defines the rotation quaternion given as a reference to update
     * @param translation defines the translation vector3 given as a reference to update
     * @param preserveScalingNode Use scaling sign coming from this node. Otherwise scaling sign might change.
     * @param useAbsoluteScaling Use scaling sign coming from this absoluteScaling when true or scaling otherwise.
     * @returns true if operation was successful
     */ decompose(scale, rotation, translation, preserveScalingNode, useAbsoluteScaling = true) {
        if (this._isIdentity) {
            if (translation) translation.setAll(0);
            if (scale) scale.setAll(1);
            if (rotation) rotation.copyFromFloats(0, 0, 0, 1);
            return true;
        }
        const m = this._m;
        if (translation) translation.copyFromFloats(m[12], m[13], m[14]);
        scale = scale || $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        scale.x = Math.sqrt(m[0] * m[0] + m[1] * m[1] + m[2] * m[2]);
        scale.y = Math.sqrt(m[4] * m[4] + m[5] * m[5] + m[6] * m[6]);
        scale.z = Math.sqrt(m[8] * m[8] + m[9] * m[9] + m[10] * m[10]);
        if (preserveScalingNode) {
            const signX = (useAbsoluteScaling ? preserveScalingNode.absoluteScaling.x : preserveScalingNode.scaling.x) < 0 ? -1 : 1;
            const signY = (useAbsoluteScaling ? preserveScalingNode.absoluteScaling.y : preserveScalingNode.scaling.y) < 0 ? -1 : 1;
            const signZ = (useAbsoluteScaling ? preserveScalingNode.absoluteScaling.z : preserveScalingNode.scaling.z) < 0 ? -1 : 1;
            scale.x *= signX;
            scale.y *= signY;
            scale.z *= signZ;
        } else if (this.determinant() <= 0) scale.y *= -1;
        if (scale._x === 0 || scale._y === 0 || scale._z === 0) {
            if (rotation) rotation.copyFromFloats(0.0, 0.0, 0.0, 1.0);
            return false;
        }
        if (rotation) {
            const sx = 1 / scale._x, sy = 1 / scale._y, sz = 1 / scale._z;
            $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(m[0] * sx, m[1] * sx, m[2] * sx, 0.0, m[4] * sy, m[5] * sy, m[6] * sy, 0.0, m[8] * sz, m[9] * sz, m[10] * sz, 0.0, 0.0, 0.0, 0.0, 1.0, $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
            $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef($c7e4de670ed74d35$var$MathTmp.Matrix[0], rotation);
        }
        return true;
    }
    /**
     * Gets specific row of the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the number of the row to get
     * @returns the index-th row of the current matrix as a new Vector4
     */ getRow(index) {
        if (index < 0 || index > 3) return null;
        const i = index * 4;
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this._m[i + 0], this._m[i + 1], this._m[i + 2], this._m[i + 3]);
    }
    /**
     * Gets specific row of the matrix to ref
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the number of the row to get
     * @param rowVector vector to store the index-th row of the current matrix
     * @returns result input
     */ getRowToRef(index, rowVector) {
        if (index >= 0 && index <= 3) {
            const i = index * 4;
            rowVector.x = this._m[i + 0];
            rowVector.y = this._m[i + 1];
            rowVector.z = this._m[i + 2];
            rowVector.w = this._m[i + 3];
        }
        return rowVector;
    }
    /**
     * Sets the index-th row of the current matrix to the vector4 values
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the number of the row to set
     * @param row defines the target vector4
     * @returns the updated current matrix
     */ setRow(index, row) {
        return this.setRowFromFloats(index, row.x, row.y, row.z, row.w);
    }
    /**
     * Compute the transpose of the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#40
     * @returns the new transposed matrix
     */ transpose() {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TransposeToRef(this, result);
        return result;
    }
    /**
     * Compute the transpose of the matrix and store it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#41
     * @param result defines the target matrix
     * @returns result input
     */ transposeToRef(result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TransposeToRef(this, result);
        return result;
    }
    /**
     * Sets the index-th row of the current matrix with the given 4 x float values
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the row index
     * @param x defines the x component to set
     * @param y defines the y component to set
     * @param z defines the z component to set
     * @param w defines the w component to set
     * @returns the updated current matrix
     */ setRowFromFloats(index, x, y, z, w) {
        if (index < 0 || index > 3) return this;
        const i = index * 4;
        this._m[i + 0] = x;
        this._m[i + 1] = y;
        this._m[i + 2] = z;
        this._m[i + 3] = w;
        this.markAsUpdated();
        return this;
    }
    /**
     * Compute a new matrix set with the current matrix values multiplied by scale (float)
     * @param scale defines the scale factor
     * @returns a new matrix
     */ scale(scale) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        this.scaleToRef(scale, result);
        return result;
    }
    /**
     * Scale the current matrix values by a factor to a given result matrix
     * @param scale defines the scale factor
     * @param result defines the matrix to store the result
     * @returns result input
     */ scaleToRef(scale, result) {
        for(let index = 0; index < 16; index++)result._m[index] = this._m[index] * scale;
        result.markAsUpdated();
        return result;
    }
    /**
     * Scale the current matrix values by a factor and add the result to a given matrix
     * @param scale defines the scale factor
     * @param result defines the Matrix to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        for(let index = 0; index < 16; index++)result._m[index] += this._m[index] * scale;
        result.markAsUpdated();
        return result;
    }
    scaleInPlace(scale) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] *= scale;
        this.markAsUpdated();
        return this;
    }
    /**
     * Writes to the given matrix a normal matrix, computed from this one (using values from identity matrix for fourth row and column).
     * Example Playground - https://playground.babylonjs.com/#AV9X17#17
     * @param ref matrix to store the result
     * @returns the reference matrix
     */ toNormalMatrix(ref) {
        const tmp = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        this.invertToRef(tmp);
        tmp.transposeToRef(ref);
        const m = ref._m;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(m[0], m[1], m[2], 0.0, m[4], m[5], m[6], 0.0, m[8], m[9], m[10], 0.0, 0.0, 0.0, 0.0, 1.0, ref);
        return ref;
    }
    /**
     * Gets only rotation part of the current matrix
     * @returns a new matrix sets to the extracted rotation matrix from the current one
     */ getRotationMatrix() {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        this.getRotationMatrixToRef(result);
        return result;
    }
    /**
     * Extracts the rotation matrix from the current one and sets it as the given "result"
     * @param result defines the target matrix to store data to
     * @returns result input
     */ getRotationMatrixToRef(result) {
        const scale = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        if (!this.decompose(scale)) {
            $c7e4de670ed74d35$export$5b12bf1653c0dd85.IdentityToRef(result);
            return result;
        }
        const m = this._m;
        const sx = 1 / scale._x, sy = 1 / scale._y, sz = 1 / scale._z;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(m[0] * sx, m[1] * sx, m[2] * sx, 0.0, m[4] * sy, m[5] * sy, m[6] * sy, 0.0, m[8] * sz, m[9] * sz, m[10] * sz, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        return result;
    }
    /**
     * Toggles model matrix from being right handed to left handed in place and vice versa
     * @returns the current updated matrix
     */ toggleModelMatrixHandInPlace() {
        const m = this._m;
        m[2] *= -1;
        m[6] *= -1;
        m[8] *= -1;
        m[9] *= -1;
        m[14] *= -1;
        this.markAsUpdated();
        return this;
    }
    /**
     * Toggles projection matrix from being right handed to left handed in place and vice versa
     * @returns the current updated matrix
     */ toggleProjectionMatrixHandInPlace() {
        const m = this._m;
        m[8] *= -1;
        m[9] *= -1;
        m[10] *= -1;
        m[11] *= -1;
        this.markAsUpdated();
        return this;
    }
    // Statics
    /**
     * Creates a matrix from an array
     * Example Playground - https://playground.babylonjs.com/#AV9X17#42
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns a new Matrix set from the starting index of the given array
     */ static FromArray(array, offset = 0) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromArrayToRef(array, offset, result);
        return result;
    }
    /**
     * Copy the content of an array into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#43
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @param result defines the target matrix
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        for(let index = 0; index < 16; index++)result._m[index] = array[index + offset];
        result.markAsUpdated();
        return result;
    }
    /**
     * Stores an array into a matrix after having multiplied each component by a given factor
     * Example Playground - https://playground.babylonjs.com/#AV9X17#50
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @param scale defines the scaling factor
     * @param result defines the target matrix
     * @returns result input
     */ static FromFloat32ArrayToRefScaled(array, offset, scale, result) {
        result._m[0] = array[0 + offset] * scale;
        result._m[1] = array[1 + offset] * scale;
        result._m[2] = array[2 + offset] * scale;
        result._m[3] = array[3 + offset] * scale;
        result._m[4] = array[4 + offset] * scale;
        result._m[5] = array[5 + offset] * scale;
        result._m[6] = array[6 + offset] * scale;
        result._m[7] = array[7 + offset] * scale;
        result._m[8] = array[8 + offset] * scale;
        result._m[9] = array[9 + offset] * scale;
        result._m[10] = array[10 + offset] * scale;
        result._m[11] = array[11 + offset] * scale;
        result._m[12] = array[12 + offset] * scale;
        result._m[13] = array[13 + offset] * scale;
        result._m[14] = array[14 + offset] * scale;
        result._m[15] = array[15 + offset] * scale;
        result.markAsUpdated();
        return result;
    }
    /**
     * Gets an identity matrix that must not be updated
     */ static get IdentityReadOnly() {
        return $c7e4de670ed74d35$export$5b12bf1653c0dd85._IdentityReadOnly;
    }
    /**
     * Stores a list of values (16) inside a given matrix
     * @param initialM11 defines 1st value of 1st row
     * @param initialM12 defines 2nd value of 1st row
     * @param initialM13 defines 3rd value of 1st row
     * @param initialM14 defines 4th value of 1st row
     * @param initialM21 defines 1st value of 2nd row
     * @param initialM22 defines 2nd value of 2nd row
     * @param initialM23 defines 3rd value of 2nd row
     * @param initialM24 defines 4th value of 2nd row
     * @param initialM31 defines 1st value of 3rd row
     * @param initialM32 defines 2nd value of 3rd row
     * @param initialM33 defines 3rd value of 3rd row
     * @param initialM34 defines 4th value of 3rd row
     * @param initialM41 defines 1st value of 4th row
     * @param initialM42 defines 2nd value of 4th row
     * @param initialM43 defines 3rd value of 4th row
     * @param initialM44 defines 4th value of 4th row
     * @param result defines the target matrix
     */ static FromValuesToRef(initialM11, initialM12, initialM13, initialM14, initialM21, initialM22, initialM23, initialM24, initialM31, initialM32, initialM33, initialM34, initialM41, initialM42, initialM43, initialM44, result) {
        const m = result._m;
        m[0] = initialM11;
        m[1] = initialM12;
        m[2] = initialM13;
        m[3] = initialM14;
        m[4] = initialM21;
        m[5] = initialM22;
        m[6] = initialM23;
        m[7] = initialM24;
        m[8] = initialM31;
        m[9] = initialM32;
        m[10] = initialM33;
        m[11] = initialM34;
        m[12] = initialM41;
        m[13] = initialM42;
        m[14] = initialM43;
        m[15] = initialM44;
        result.markAsUpdated();
    }
    /**
     * Creates new matrix from a list of values (16)
     * @param initialM11 defines 1st value of 1st row
     * @param initialM12 defines 2nd value of 1st row
     * @param initialM13 defines 3rd value of 1st row
     * @param initialM14 defines 4th value of 1st row
     * @param initialM21 defines 1st value of 2nd row
     * @param initialM22 defines 2nd value of 2nd row
     * @param initialM23 defines 3rd value of 2nd row
     * @param initialM24 defines 4th value of 2nd row
     * @param initialM31 defines 1st value of 3rd row
     * @param initialM32 defines 2nd value of 3rd row
     * @param initialM33 defines 3rd value of 3rd row
     * @param initialM34 defines 4th value of 3rd row
     * @param initialM41 defines 1st value of 4th row
     * @param initialM42 defines 2nd value of 4th row
     * @param initialM43 defines 3rd value of 4th row
     * @param initialM44 defines 4th value of 4th row
     * @returns the new matrix
     */ static FromValues(initialM11, initialM12, initialM13, initialM14, initialM21, initialM22, initialM23, initialM24, initialM31, initialM32, initialM33, initialM34, initialM41, initialM42, initialM43, initialM44) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        const m = result._m;
        m[0] = initialM11;
        m[1] = initialM12;
        m[2] = initialM13;
        m[3] = initialM14;
        m[4] = initialM21;
        m[5] = initialM22;
        m[6] = initialM23;
        m[7] = initialM24;
        m[8] = initialM31;
        m[9] = initialM32;
        m[10] = initialM33;
        m[11] = initialM34;
        m[12] = initialM41;
        m[13] = initialM42;
        m[14] = initialM43;
        m[15] = initialM44;
        result.markAsUpdated();
        return result;
    }
    /**
     * Creates a new matrix composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
     * Example Playground - https://playground.babylonjs.com/#AV9X17#24
     * @param scale defines the scale vector3
     * @param rotation defines the rotation quaternion
     * @param translation defines the translation vector3
     * @returns a new matrix
     */ static Compose(scale, rotation, translation) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ComposeToRef(scale, rotation, translation, result);
        return result;
    }
    /**
     * Sets a matrix to a value composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
     * Example Playground - https://playground.babylonjs.com/#AV9X17#25
     * @param scale defines the scale vector3
     * @param rotation defines the rotation quaternion
     * @param translation defines the translation vector3
     * @param result defines the target matrix
     * @returns result input
     */ static ComposeToRef(scale, rotation, translation, result) {
        const m = result._m;
        const x = rotation._x, y = rotation._y, z = rotation._z, w = rotation._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale._x, sy = scale._y, sz = scale._z;
        m[0] = (1 - (yy + zz)) * sx;
        m[1] = (xy + wz) * sx;
        m[2] = (xz - wy) * sx;
        m[3] = 0;
        m[4] = (xy - wz) * sy;
        m[5] = (1 - (xx + zz)) * sy;
        m[6] = (yz + wx) * sy;
        m[7] = 0;
        m[8] = (xz + wy) * sz;
        m[9] = (yz - wx) * sz;
        m[10] = (1 - (xx + yy)) * sz;
        m[11] = 0;
        m[12] = translation._x;
        m[13] = translation._y;
        m[14] = translation._z;
        m[15] = 1;
        result.markAsUpdated();
        return result;
    }
    /**
     * Creates a new identity matrix
     * @returns a new identity matrix
     */ static Identity() {
        const identity = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        identity._updateIdentityStatus(true);
        return identity;
    }
    /**
     * Creates a new identity matrix and stores the result in a given matrix
     * @param result defines the target matrix
     * @returns result input
     */ static IdentityToRef(result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(true);
        return result;
    }
    /**
     * Creates a new zero matrix
     * @returns a new zero matrix
     */ static Zero() {
        const zero = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0);
        zero._updateIdentityStatus(false);
        return zero;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the X axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#97
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationX(angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationXToRef(angle, result);
        return result;
    }
    /**
     * Creates a new matrix as the invert of a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#124
     * @param source defines the source matrix
     * @returns the new matrix
     */ static Invert(source) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        source.invertToRef(result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the X axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#98
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationXToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, c, s, 0.0, 0.0, -s, c, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(c === 1 && s === 0);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Y axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#99
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationY(angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationYToRef(angle, result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Y axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#100
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationYToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(c, 0.0, -s, 0.0, 0.0, 1.0, 0.0, 0.0, s, 0.0, c, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(c === 1 && s === 0);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Z axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#101
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationZ(angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationZToRef(angle, result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Z axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#102
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationZToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(c, s, 0.0, 0.0, -s, c, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(c === 1 && s === 0);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the given axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#96
     * @param axis defines the axis to use
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationAxis(axis, angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationAxisToRef(axis, angle, result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the given axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#94
     * @param axis defines the axis to use
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationAxisToRef(axis, angle, result) {
        const s = Math.sin(-angle);
        const c = Math.cos(-angle);
        const c1 = 1 - c;
        axis = axis.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[0]);
        const m = result._m;
        m[0] = axis._x * axis._x * c1 + c;
        m[1] = axis._x * axis._y * c1 - axis._z * s;
        m[2] = axis._x * axis._z * c1 + axis._y * s;
        m[3] = 0.0;
        m[4] = axis._y * axis._x * c1 + axis._z * s;
        m[5] = axis._y * axis._y * c1 + c;
        m[6] = axis._y * axis._z * c1 - axis._x * s;
        m[7] = 0.0;
        m[8] = axis._z * axis._x * c1 - axis._y * s;
        m[9] = axis._z * axis._y * c1 + axis._x * s;
        m[10] = axis._z * axis._z * c1 + c;
        m[11] = 0.0;
        m[12] = 0.0;
        m[13] = 0.0;
        m[14] = 0.0;
        m[15] = 1.0;
        result.markAsUpdated();
        return result;
    }
    /**
     * Takes normalised vectors and returns a rotation matrix to align "from" with "to".
     * Taken from http://www.iquilezles.org/www/articles/noacos/noacos.htm
     * Example Playground - https://playground.babylonjs.com/#AV9X17#93
     * @param from defines the vector to align
     * @param to defines the vector to align to
     * @param result defines the target matrix
     * @param useYAxisForCoplanar defines a boolean indicating that we should favor Y axis for coplanar vectors (default is false)
     * @returns result input
     */ static RotationAlignToRef(from, to, result, useYAxisForCoplanar = false) {
        const c = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(to, from);
        const m = result._m;
        if (c < -1 + (0, $53VPf.Epsilon)) {
            // from and to are colinear and opposite direction.
            // compute a PI rotation on Y axis
            m[0] = -1;
            m[1] = 0;
            m[2] = 0;
            m[3] = 0;
            m[4] = 0;
            m[5] = useYAxisForCoplanar ? 1 : -1;
            m[6] = 0;
            m[7] = 0;
            m[8] = 0;
            m[9] = 0;
            m[10] = useYAxisForCoplanar ? -1 : 1;
            m[11] = 0;
        } else {
            const v = $c7e4de670ed74d35$export$64b5c384219d3699.Cross(to, from);
            const k = 1 / (1 + c);
            m[0] = v._x * v._x * k + c;
            m[1] = v._y * v._x * k - v._z;
            m[2] = v._z * v._x * k + v._y;
            m[3] = 0;
            m[4] = v._x * v._y * k + v._z;
            m[5] = v._y * v._y * k + c;
            m[6] = v._z * v._y * k - v._x;
            m[7] = 0;
            m[8] = v._x * v._z * k - v._y;
            m[9] = v._y * v._z * k + v._x;
            m[10] = v._z * v._z * k + c;
            m[11] = 0;
        }
        m[12] = 0;
        m[13] = 0;
        m[14] = 0;
        m[15] = 1;
        result.markAsUpdated();
        return result;
    }
    /**
     * Creates a rotation matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#103
     * Example Playground - https://playground.babylonjs.com/#AV9X17#105
     * @param yaw defines the yaw angle in radians (Y axis)
     * @param pitch defines the pitch angle in radians (X axis)
     * @param roll defines the roll angle in radians (Z axis)
     * @returns the new rotation matrix
     */ static RotationYawPitchRoll(yaw, pitch, roll) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationYawPitchRollToRef(yaw, pitch, roll, result);
        return result;
    }
    /**
     * Creates a rotation matrix and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#104
     * @param yaw defines the yaw angle in radians (Y axis)
     * @param pitch defines the pitch angle in radians (X axis)
     * @param roll defines the roll angle in radians (Z axis)
     * @param result defines the target matrix
     * @returns result input
     */ static RotationYawPitchRollToRef(yaw, pitch, roll, result) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(yaw, pitch, roll, $c7e4de670ed74d35$var$MathTmp.Quaternion[0]);
        $c7e4de670ed74d35$var$MathTmp.Quaternion[0].toRotationMatrix(result);
        return result;
    }
    /**
     * Creates a scaling matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#107
     * @param x defines the scale factor on X axis
     * @param y defines the scale factor on Y axis
     * @param z defines the scale factor on Z axis
     * @returns the new matrix
     */ static Scaling(x, y, z) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ScalingToRef(x, y, z, result);
        return result;
    }
    /**
     * Creates a scaling matrix and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#108
     * @param x defines the scale factor on X axis
     * @param y defines the scale factor on Y axis
     * @param z defines the scale factor on Z axis
     * @param result defines the target matrix
     * @returns result input
     */ static ScalingToRef(x, y, z, result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(x, 0.0, 0.0, 0.0, 0.0, y, 0.0, 0.0, 0.0, 0.0, z, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(x === 1 && y === 1 && z === 1);
        return result;
    }
    /**
     * Creates a translation matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#109
     * @param x defines the translation on X axis
     * @param y defines the translation on Y axis
     * @param z defines the translationon Z axis
     * @returns the new matrix
     */ static Translation(x, y, z) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(x, y, z, result);
        return result;
    }
    /**
     * Creates a translation matrix and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#110
     * @param x defines the translation on X axis
     * @param y defines the translation on Y axis
     * @param z defines the translationon Z axis
     * @param result defines the target matrix
     * @returns result input
     */ static TranslationToRef(x, y, z, result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, x, y, z, 1.0, result);
        result._updateIdentityStatus(x === 0 && y === 0 && z === 0);
        return result;
    }
    /**
     * Returns a new Matrix whose values are the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
     * Example Playground - https://playground.babylonjs.com/#AV9X17#55
     * @param startValue defines the start value
     * @param endValue defines the end value
     * @param gradient defines the gradient factor
     * @returns the new matrix
     */ static Lerp(startValue, endValue, gradient) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LerpToRef(startValue, endValue, gradient, result);
        return result;
    }
    /**
     * Set the given matrix "result" as the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
     * Example Playground - https://playground.babylonjs.com/#AV9X17#54
     * @param startValue defines the start value
     * @param endValue defines the end value
     * @param gradient defines the gradient factor
     * @param result defines the Matrix object where to store data
     * @returns result input
     */ static LerpToRef(startValue, endValue, gradient, result) {
        const resultM = result._m;
        const startM = startValue.m;
        const endM = endValue.m;
        for(let index = 0; index < 16; index++)resultM[index] = startM[index] * (1.0 - gradient) + endM[index] * gradient;
        result.markAsUpdated();
        return result;
    }
    /**
     * Builds a new matrix whose values are computed by:
     * * decomposing the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
     * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
     * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
     * Example Playground - https://playground.babylonjs.com/#AV9X17#22
     * Example Playground - https://playground.babylonjs.com/#AV9X17#51
     * @param startValue defines the first matrix
     * @param endValue defines the second matrix
     * @param gradient defines the gradient between the two matrices
     * @returns the new matrix
     */ static DecomposeLerp(startValue, endValue, gradient) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.DecomposeLerpToRef(startValue, endValue, gradient, result);
        return result;
    }
    /**
     * Update a matrix to values which are computed by:
     * * decomposing the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
     * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
     * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
     * Example Playground - https://playground.babylonjs.com/#AV9X17#23
     * Example Playground - https://playground.babylonjs.com/#AV9X17#53
     * @param startValue defines the first matrix
     * @param endValue defines the second matrix
     * @param gradient defines the gradient between the two matrices
     * @param result defines the target matrix
     * @returns result input
     */ static DecomposeLerpToRef(startValue, endValue, gradient, result) {
        const startScale = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const startRotation = $c7e4de670ed74d35$var$MathTmp.Quaternion[0];
        const startTranslation = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        startValue.decompose(startScale, startRotation, startTranslation);
        const endScale = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        const endRotation = $c7e4de670ed74d35$var$MathTmp.Quaternion[1];
        const endTranslation = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        endValue.decompose(endScale, endRotation, endTranslation);
        const resultScale = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        $c7e4de670ed74d35$export$64b5c384219d3699.LerpToRef(startScale, endScale, gradient, resultScale);
        const resultRotation = $c7e4de670ed74d35$var$MathTmp.Quaternion[2];
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.SlerpToRef(startRotation, endRotation, gradient, resultRotation);
        const resultTranslation = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        $c7e4de670ed74d35$export$64b5c384219d3699.LerpToRef(startTranslation, endTranslation, gradient, resultTranslation);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ComposeToRef(resultScale, resultRotation, resultTranslation, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#58
     * Example Playground - https://playground.babylonjs.com/#AV9X17#59
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @returns the new matrix
     */ static LookAtLH(eye, target, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookAtLHToRef(eye, target, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#60
     * Example Playground - https://playground.babylonjs.com/#AV9X17#61
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @param result defines the target matrix
     * @returns result input
     */ static LookAtLHToRef(eye, target, up, result) {
        const xAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const yAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        const zAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        // Z axis
        target.subtractToRef(eye, zAxis);
        zAxis.normalize();
        // X axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, zAxis, xAxis);
        const xSquareLength = xAxis.lengthSquared();
        if (xSquareLength === 0) xAxis.x = 1.0;
        else xAxis.normalizeFromLength(Math.sqrt(xSquareLength));
        // Y axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(zAxis, xAxis, yAxis);
        yAxis.normalize();
        // Eye angles
        const ex = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(xAxis, eye);
        const ey = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(yAxis, eye);
        const ez = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(zAxis, eye);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(xAxis._x, yAxis._x, zAxis._x, 0.0, xAxis._y, yAxis._y, zAxis._y, 0.0, xAxis._z, yAxis._z, zAxis._z, 0.0, ex, ey, ez, 1.0, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#62
     * Example Playground - https://playground.babylonjs.com/#AV9X17#63
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @returns the new matrix
     */ static LookAtRH(eye, target, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookAtRHToRef(eye, target, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#64
     * Example Playground - https://playground.babylonjs.com/#AV9X17#65
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @param result defines the target matrix
     * @returns result input
     */ static LookAtRHToRef(eye, target, up, result) {
        const xAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const yAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        const zAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        // Z axis
        eye.subtractToRef(target, zAxis);
        zAxis.normalize();
        // X axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, zAxis, xAxis);
        const xSquareLength = xAxis.lengthSquared();
        if (xSquareLength === 0) xAxis.x = 1.0;
        else xAxis.normalizeFromLength(Math.sqrt(xSquareLength));
        // Y axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(zAxis, xAxis, yAxis);
        yAxis.normalize();
        // Eye angles
        const ex = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(xAxis, eye);
        const ey = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(yAxis, eye);
        const ez = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(zAxis, eye);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(xAxis._x, yAxis._x, zAxis._x, 0.0, xAxis._y, yAxis._y, zAxis._y, 0.0, xAxis._z, yAxis._z, zAxis._z, 0.0, ex, ey, ez, 1.0, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#66
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns the new matrix
     */ static LookDirectionLH(forward, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionLHToRef(forward, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#67
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param result defines the target matrix
     * @returns result input
     */ static LookDirectionLHToRef(forward, up, result) {
        const back = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        back.copyFrom(forward);
        back.scaleInPlace(-1);
        const left = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, back, left);
        // Generate the rotation matrix.
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(left._x, left._y, left._z, 0.0, up._x, up._y, up._z, 0.0, back._x, back._y, back._z, 0.0, 0, 0, 0, 1.0, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#68
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns the new matrix
     */ static LookDirectionRH(forward, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionRHToRef(forward, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#69
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param result defines the target matrix
     * @returns result input
     */ static LookDirectionRHToRef(forward, up, result) {
        const right = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, forward, right);
        // Generate the rotation matrix.
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(right._x, right._y, right._z, 0.0, up._x, up._y, up._z, 0.0, forward._x, forward._y, forward._z, 0.0, 0, 0, 0, 1.0, result);
        return result;
    }
    /**
     * Create a left-handed orthographic projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#70
     * @param width defines the viewport width
     * @param height defines the viewport height
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns a new matrix as a left-handed orthographic projection matrix
     */ static OrthoLH(width, height, znear, zfar, halfZRange) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoLHToRef(width, height, znear, zfar, matrix, halfZRange);
        return matrix;
    }
    /**
     * Store a left-handed orthographic projection to a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#71
     * @param width defines the viewport width
     * @param height defines the viewport height
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static OrthoLHToRef(width, height, znear, zfar, result, halfZRange) {
        const n = znear;
        const f = zfar;
        const a = 2.0 / width;
        const b = 2.0 / height;
        const c = 2.0 / (f - n);
        const d = -(f + n) / (f - n);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, 0.0, 0.0, d, 1.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(a === 1 && b === 1 && c === 1 && d === 0);
        return result;
    }
    /**
     * Create a left-handed orthographic projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#72
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns a new matrix as a left-handed orthographic projection matrix
     */ static OrthoOffCenterLH(left, right, bottom, top, znear, zfar, halfZRange) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, matrix, halfZRange);
        return matrix;
    }
    /**
     * Stores a left-handed orthographic projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#73
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange) {
        const n = znear;
        const f = zfar;
        const a = 2.0 / (right - left);
        const b = 2.0 / (top - bottom);
        const c = 2.0 / (f - n);
        const d = -(f + n) / (f - n);
        const i0 = (left + right) / (left - right);
        const i1 = (top + bottom) / (bottom - top);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, i0, i1, d, 1.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result.markAsUpdated();
        return result;
    }
    /**
     * Stores a left-handed oblique projection into a given matrix
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param length Length of the shear
     * @param angle Angle (along X/Y Plane) to apply shear
     * @param distance Distance from shear point
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static ObliqueOffCenterLHToRef(left, right, bottom, top, znear, zfar, length, angle, distance, result, halfZRange) {
        const a = -length * Math.cos(angle);
        const b = -length * Math.sin(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, -distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, a, b, 1, 0, 0, 0, 0, 1, $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[1].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[0], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[1], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef(result, result);
        return result;
    }
    /**
     * Creates a right-handed orthographic projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#76
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns a new matrix as a right-handed orthographic projection matrix
     */ static OrthoOffCenterRH(left, right, bottom, top, znear, zfar, halfZRange) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, matrix, halfZRange);
        return matrix;
    }
    /**
     * Stores a right-handed orthographic projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#77
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, result, halfZRange) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
        result._m[10] *= -1; // No need to call markAsUpdated as previous function already called it and let _isIdentityDirty to true
        return result;
    }
    /**
     * Stores a right-handed oblique projection into a given matrix
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param length Length of the shear
     * @param angle Angle (along X/Y Plane) to apply shear
     * @param distance Distance from shear point
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static ObliqueOffCenterRHToRef(left, right, bottom, top, znear, zfar, length, angle, distance, result, halfZRange) {
        const a = length * Math.cos(angle);
        const b = length * Math.sin(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, a, b, 1, 0, 0, 0, 0, 1, $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[1].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[0], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, -distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[1], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef(result, result);
        return result;
    }
    /**
     * Creates a left-handed perspective projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#85
     * @param width defines the viewport width
     * @param height defines the viewport height
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @returns a new matrix as a left-handed perspective projection matrix
     */ static PerspectiveLH(width, height, znear, zfar, halfZRange, projectionPlaneTilt = 0) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        const n = znear;
        const f = zfar;
        const a = 2.0 * n / width;
        const b = 2.0 * n / height;
        const c = (f + n) / (f - n);
        const d = -2 * f * n / (f - n);
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, 1.0, 0.0, 0.0, d, 0.0, matrix);
        if (halfZRange) matrix.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, matrix);
        matrix._updateIdentityStatus(false);
        return matrix;
    }
    /**
     * Creates a left-handed perspective projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#78
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns a new matrix as a left-handed perspective projection matrix
     */ static PerspectiveFovLH(fov, aspect, znear, zfar, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.PerspectiveFovLHToRef(fov, aspect, znear, zfar, matrix, true, halfZRange, projectionPlaneTilt, reverseDepthBufferMode);
        return matrix;
    }
    /**
     * Stores a left-handed perspective projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#81
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns result input
     */ static PerspectiveFovLHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        const n = znear;
        const f = zfar;
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const c = reverseDepthBufferMode && n === 0 ? -1 : f !== 0 ? (f + n) / (f - n) : 1;
        const d = reverseDepthBufferMode && n === 0 ? 2 * f : f !== 0 ? -2 * f * n / (f - n) : -2 * n;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, 1.0, 0.0, 0.0, d, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Stores a left-handed perspective projection into a given matrix with depth reversed
     * Example Playground - https://playground.babylonjs.com/#AV9X17#89
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar not used as infinity is used as far clip
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @returns result input
     */ static PerspectiveFovReverseLHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0) {
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, -znear, 1.0, 0.0, 0.0, 1.0, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Creates a right-handed perspective projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#83
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns a new matrix as a right-handed perspective projection matrix
     */ static PerspectiveFovRH(fov, aspect, znear, zfar, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.PerspectiveFovRHToRef(fov, aspect, znear, zfar, matrix, true, halfZRange, projectionPlaneTilt, reverseDepthBufferMode);
        return matrix;
    }
    /**
     * Stores a right-handed perspective projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#84
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns result input
     */ static PerspectiveFovRHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        //alternatively this could be expressed as:
        //    m = PerspectiveFovLHToRef
        //    m[10] *= -1.0;
        //    m[11] *= -1.0;
        const n = znear;
        const f = zfar;
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const c = reverseDepthBufferMode && n === 0 ? 1 : f !== 0 ? -(f + n) / (f - n) : -1;
        const d = reverseDepthBufferMode && n === 0 ? 2 * f : f !== 0 ? -2 * f * n / (f - n) : -2 * n;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, -1, 0.0, 0.0, d, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Stores a right-handed perspective projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#90
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar not used as infinity is used as far clip
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @returns result input
     */ static PerspectiveFovReverseRHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0) {
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, -znear, -1, 0.0, 0.0, -1, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Computes a complete transformation matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#113
     * @param viewport defines the viewport to use
     * @param world defines the world matrix
     * @param view defines the view matrix
     * @param projection defines the projection matrix
     * @param zmin defines the near clip plane
     * @param zmax defines the far clip plane
     * @returns the transformation matrix
     */ static GetFinalMatrix(viewport, world, view, projection, zmin, zmax) {
        const cw = viewport.width;
        const ch = viewport.height;
        const cx = viewport.x;
        const cy = viewport.y;
        const viewportMatrix = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(cw / 2.0, 0.0, 0.0, 0.0, 0.0, -ch / 2.0, 0.0, 0.0, 0.0, 0.0, zmax - zmin, 0.0, cx + cw / 2.0, ch / 2.0 + cy, zmin, 1.0);
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        world.multiplyToRef(view, matrix);
        matrix.multiplyToRef(projection, matrix);
        return matrix.multiplyToRef(viewportMatrix, matrix);
    }
    /**
     * Extracts a 2x2 matrix from a given matrix and store the result in a Float32Array
     * @param matrix defines the matrix to use
     * @returns a new Float32Array array with 4 elements : the 2x2 matrix extracted from the given matrix
     */ static GetAsMatrix2x2(matrix) {
        const m = matrix.m;
        const arr = [
            m[0],
            m[1],
            m[4],
            m[5]
        ];
        return (0, $3agwF.PerformanceConfigurator).MatrixUse64Bits ? arr : new Float32Array(arr);
    }
    /**
     * Extracts a 3x3 matrix from a given matrix and store the result in a Float32Array
     * @param matrix defines the matrix to use
     * @returns a new Float32Array array with 9 elements : the 3x3 matrix extracted from the given matrix
     */ static GetAsMatrix3x3(matrix) {
        const m = matrix.m;
        const arr = [
            m[0],
            m[1],
            m[2],
            m[4],
            m[5],
            m[6],
            m[8],
            m[9],
            m[10]
        ];
        return (0, $3agwF.PerformanceConfigurator).MatrixUse64Bits ? arr : new Float32Array(arr);
    }
    /**
     * Compute the transpose of a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#111
     * @param matrix defines the matrix to transpose
     * @returns the new matrix
     */ static Transpose(matrix) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TransposeToRef(matrix, result);
        return result;
    }
    /**
     * Compute the transpose of a matrix and store it in a target matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#112
     * @param matrix defines the matrix to transpose
     * @param result defines the target matrix
     * @returns result input
     */ static TransposeToRef(matrix, result) {
        const mm = matrix.m;
        const rm0 = mm[0];
        const rm1 = mm[4];
        const rm2 = mm[8];
        const rm3 = mm[12];
        const rm4 = mm[1];
        const rm5 = mm[5];
        const rm6 = mm[9];
        const rm7 = mm[13];
        const rm8 = mm[2];
        const rm9 = mm[6];
        const rm10 = mm[10];
        const rm11 = mm[14];
        const rm12 = mm[3];
        const rm13 = mm[7];
        const rm14 = mm[11];
        const rm15 = mm[15];
        const rm = result._m;
        rm[0] = rm0;
        rm[1] = rm1;
        rm[2] = rm2;
        rm[3] = rm3;
        rm[4] = rm4;
        rm[5] = rm5;
        rm[6] = rm6;
        rm[7] = rm7;
        rm[8] = rm8;
        rm[9] = rm9;
        rm[10] = rm10;
        rm[11] = rm11;
        rm[12] = rm12;
        rm[13] = rm13;
        rm[14] = rm14;
        rm[15] = rm15;
        result.markAsUpdated();
        // identity-ness does not change when transposing
        result._updateIdentityStatus(matrix._isIdentity, matrix._isIdentityDirty);
        return result;
    }
    /**
     * Computes a reflection matrix from a plane
     * Example Playground - https://playground.babylonjs.com/#AV9X17#87
     * @param plane defines the reflection plane
     * @returns a new matrix
     */ static Reflection(plane) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ReflectionToRef(plane, matrix);
        return matrix;
    }
    /**
     * Computes a reflection matrix from a plane
     * Example Playground - https://playground.babylonjs.com/#AV9X17#88
     * @param plane defines the reflection plane
     * @param result defines the target matrix
     * @returns result input
     */ static ReflectionToRef(plane, result) {
        plane.normalize();
        const x = plane.normal.x;
        const y = plane.normal.y;
        const z = plane.normal.z;
        const temp = -2 * x;
        const temp2 = -2 * y;
        const temp3 = -2 * z;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(temp * x + 1, temp2 * x, temp3 * x, 0.0, temp * y, temp2 * y + 1, temp3 * y, 0.0, temp * z, temp2 * z, temp3 * z + 1, 0.0, temp * plane.d, temp2 * plane.d, temp3 * plane.d, 1.0, result);
        return result;
    }
    /**
     * Sets the given matrix as a rotation matrix composed from the 3 left handed axes
     * @param xaxis defines the value of the 1st axis
     * @param yaxis defines the value of the 2nd axis
     * @param zaxis defines the value of the 3rd axis
     * @param result defines the target matrix
     * @returns result input
     */ static FromXYZAxesToRef(xaxis, yaxis, zaxis, result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(xaxis._x, xaxis._y, xaxis._z, 0.0, yaxis._x, yaxis._y, yaxis._z, 0.0, zaxis._x, zaxis._y, zaxis._z, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        return result;
    }
    /**
     * Creates a rotation matrix from a quaternion and stores it in a target matrix
     * @param quat defines the quaternion to use
     * @param result defines the target matrix
     * @returns result input
     */ static FromQuaternionToRef(quat, result) {
        const xx = quat._x * quat._x;
        const yy = quat._y * quat._y;
        const zz = quat._z * quat._z;
        const xy = quat._x * quat._y;
        const zw = quat._z * quat._w;
        const zx = quat._z * quat._x;
        const yw = quat._y * quat._w;
        const yz = quat._y * quat._z;
        const xw = quat._x * quat._w;
        result._m[0] = 1.0 - 2.0 * (yy + zz);
        result._m[1] = 2.0 * (xy + zw);
        result._m[2] = 2.0 * (zx - yw);
        result._m[3] = 0.0;
        result._m[4] = 2.0 * (xy - zw);
        result._m[5] = 1.0 - 2.0 * (zz + xx);
        result._m[6] = 2.0 * (yz + xw);
        result._m[7] = 0.0;
        result._m[8] = 2.0 * (zx + yw);
        result._m[9] = 2.0 * (yz - xw);
        result._m[10] = 1.0 - 2.0 * (yy + xx);
        result._m[11] = 0.0;
        result._m[12] = 0.0;
        result._m[13] = 0.0;
        result._m[14] = 0.0;
        result._m[15] = 1.0;
        result.markAsUpdated();
        return result;
    }
}
$c7e4de670ed74d35$export$5b12bf1653c0dd85._UpdateFlagSeed = 0;
$c7e4de670ed74d35$export$5b12bf1653c0dd85._IdentityReadOnly = $c7e4de670ed74d35$export$5b12bf1653c0dd85.Identity();
Object.defineProperties($c7e4de670ed74d35$export$5b12bf1653c0dd85.prototype, {
    dimension: {
        value: [
            4,
            4
        ]
    },
    rank: {
        value: 2
    }
});
/**
 * @internal
 * Same as Tmp but not exported to keep it only for math functions to avoid conflicts
 */ class $c7e4de670ed74d35$var$MathTmp {
}
// Temporary Vector3s
$c7e4de670ed74d35$var$MathTmp.Vector3 = (0, $opFp4.BuildTuple)(11, $c7e4de670ed74d35$export$64b5c384219d3699.Zero);
// Temporary Matricies
$c7e4de670ed74d35$var$MathTmp.Matrix = (0, $opFp4.BuildTuple)(2, $c7e4de670ed74d35$export$5b12bf1653c0dd85.Identity);
// Temporary Quaternions
$c7e4de670ed74d35$var$MathTmp.Quaternion = (0, $opFp4.BuildTuple)(3, $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero);
class $c7e4de670ed74d35$export$269f00bf0c0718d1 {
}
/** 3 temp Vector2 at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector2 = (0, $opFp4.BuildTuple)(3, $c7e4de670ed74d35$export$c977b3e384af9ae1.Zero);
/** 13 temp Vector3 at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3 = (0, $opFp4.BuildTuple)(13, $c7e4de670ed74d35$export$64b5c384219d3699.Zero);
/** 3 temp Vector4 at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector4 = (0, $opFp4.BuildTuple)(3, $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero);
/** 3 temp Quaternion at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Quaternion = (0, $opFp4.BuildTuple)(3, $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero);
/** 8 temp Matrices at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Matrix = (0, $opFp4.BuildTuple)(8, $c7e4de670ed74d35$export$5b12bf1653c0dd85.Identity);
(0, $8DoUR.RegisterClass)("BABYLON.Vector2", $c7e4de670ed74d35$export$c977b3e384af9ae1);
(0, $8DoUR.RegisterClass)("BABYLON.Vector3", $c7e4de670ed74d35$export$64b5c384219d3699);
(0, $8DoUR.RegisterClass)("BABYLON.Vector4", $c7e4de670ed74d35$export$fa7daccca11cdbe3);
(0, $8DoUR.RegisterClass)("BABYLON.Matrix", $c7e4de670ed74d35$export$5b12bf1653c0dd85);
const $c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0.5, 0, 0, 0, 0.5, 1);

});
parcelRegister("53VPf", function(module, exports) {

$parcel$export(module.exports, "ToGammaSpace", () => $3afa168367ea15a0$export$a8ac250023fc4297);
$parcel$export(module.exports, "ToLinearSpace", () => $3afa168367ea15a0$export$489f0bc65ef7375c);
$parcel$export(module.exports, "PHI", () => $3afa168367ea15a0$export$ed904dc4011d96f7);
$parcel$export(module.exports, "Epsilon", () => $3afa168367ea15a0$export$cb998ac70542b2c3);
/**
 * Constant used to convert a value to gamma space
 * @ignorenaming
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $3afa168367ea15a0$export$a8ac250023fc4297 = 1 / 2.2;
const $3afa168367ea15a0$export$489f0bc65ef7375c = 2.2;
const $3afa168367ea15a0$export$ed904dc4011d96f7 = (1 + Math.sqrt(5)) / 2;
const $3afa168367ea15a0$export$cb998ac70542b2c3 = 0.001;

});

parcelRegister("opFp4", function(module, exports) {

$parcel$export(module.exports, "BuildArray", () => $049626e575d1494e$export$bc4924e1c905fd64);
$parcel$export(module.exports, "BuildTuple", () => $049626e575d1494e$export$4359f9e0e9766961);
$parcel$export(module.exports, "_ObserveArray", () => $049626e575d1494e$export$96a3d8721b7deb3a);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns an array of the given size filled with elements built from the given constructor and the parameters.
 * @param size the number of element to construct and put in the array.
 * @param itemBuilder a callback responsible for creating new instance of item. Called once per array entry.
 * @returns a new array filled with new objects.
 */ function $049626e575d1494e$export$bc4924e1c905fd64(size, itemBuilder) {
    const a = [];
    for(let i = 0; i < size; ++i)a.push(itemBuilder());
    return a;
}
function $049626e575d1494e$export$4359f9e0e9766961(size, itemBuilder) {
    return $049626e575d1494e$export$bc4924e1c905fd64(size, itemBuilder);
}
/**
 * Observes a function and calls the given callback when it is called.
 * @param object Defines the object the function to observe belongs to.
 * @param functionName Defines the name of the function to observe.
 * @param callback Defines the callback to call when the function is called.
 * @returns A function to call to stop observing
 */ function $049626e575d1494e$var$_observeArrayfunction(object, functionName, callback) {
    // Finds the function to observe
    const oldFunction = object[functionName];
    if (typeof oldFunction !== "function") return null;
    // Creates a new function that calls the callback and the old function
    const newFunction = function() {
        const previousLength = object.length;
        const returnValue = newFunction.previous.apply(object, arguments);
        callback(functionName, previousLength);
        return returnValue;
    };
    // Doublishly links the new function and the old function
    oldFunction.next = newFunction;
    newFunction.previous = oldFunction;
    // Replaces the old function with the new function
    object[functionName] = newFunction;
    // Returns a function to disable the hook
    return ()=>{
        // Only unhook if the function is still hooked
        const previous = newFunction.previous;
        if (!previous) return;
        // Finds the ref to the next function in the chain
        const next = newFunction.next;
        // If in the middle of the chain, link the previous and next functions
        if (next) {
            previous.next = next;
            next.previous = previous;
        } else {
            previous.next = undefined;
            object[functionName] = previous;
        }
        // Lose reference to the previous and next functions
        newFunction.next = undefined;
        newFunction.previous = undefined;
    };
}
/**
 * Defines the list of functions to proxy when observing an array.
 * The scope is currently reduced to the common functions used in the render target render list and the scene cameras.
 */ const $049626e575d1494e$var$observedArrayFunctions = [
    "push",
    "splice",
    "pop",
    "shift",
    "unshift"
];
function $049626e575d1494e$export$96a3d8721b7deb3a(array, callback) {
    // Observes all the required array functions and stores the unhook functions
    const unObserveFunctions = $049626e575d1494e$var$observedArrayFunctions.map((name)=>{
        return $049626e575d1494e$var$_observeArrayfunction(array, name, callback);
    });
    // Returns a function that unhook all the observed functions
    return ()=>{
        unObserveFunctions.forEach((unObserveFunction)=>{
            unObserveFunction?.();
        });
    };
}

});

parcelRegister("iosaP", function(module, exports) {

$parcel$export(module.exports, "WithinEpsilon", () => $d6405296de9267dd$export$af7aa7c6a365352b);
$parcel$export(module.exports, "RandomRange", () => $d6405296de9267dd$export$b784f163cb360c55);
$parcel$export(module.exports, "Lerp", () => $d6405296de9267dd$export$30e52872ef59c897);
$parcel$export(module.exports, "Clamp", () => $d6405296de9267dd$export$90534cad35a14134);
$parcel$export(module.exports, "Hermite", () => $d6405296de9267dd$export$d21ae7c67a1b6c16);
$parcel$export(module.exports, "NormalizeRadians", () => $d6405296de9267dd$export$f5cbed47313e4153);
$parcel$export(module.exports, "ToHex", () => $d6405296de9267dd$export$6a3297bb326da27e);
$parcel$export(module.exports, "ILog2", () => $d6405296de9267dd$export$f91efbafa10dbdfa);
$parcel$export(module.exports, "HighestCommonFactor", () => $d6405296de9267dd$export$f278ef008b722a1f);
/**
 * Extract int value
 * @param value number value
 * @returns int value
 */ function $d6405296de9267dd$export$1b7c609baaf2a9d3(value) {
    return parseInt(value.toString().replace(/\W/g, ""));
}
function $d6405296de9267dd$export$af7aa7c6a365352b(a, b, epsilon = 1.401298e-45) {
    return Math.abs(a - b) <= epsilon;
}
function $d6405296de9267dd$export$b784f163cb360c55(min, max) {
    if (min === max) return min;
    return Math.random() * (max - min) + min;
}
function $d6405296de9267dd$export$30e52872ef59c897(start, end, amount) {
    return start + (end - start) * amount;
}
function $d6405296de9267dd$export$ef73c296543ac997(start, end, amount) {
    let num = $d6405296de9267dd$export$f9d61a2a6155ab51(end - start, 360.0);
    if (num > 180.0) num -= 360.0;
    return start + num * $d6405296de9267dd$export$90534cad35a14134(amount);
}
function $d6405296de9267dd$export$a6c8dd40985f8714(a, b, value) {
    let result = 0;
    if (a != b) result = $d6405296de9267dd$export$90534cad35a14134((value - a) / (b - a));
    else result = 0.0;
    return result;
}
function $d6405296de9267dd$export$d21ae7c67a1b6c16(value1, tangent1, value2, tangent2, amount) {
    const squared = amount * amount;
    const cubed = amount * squared;
    const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
    const part2 = -2 * cubed + 3.0 * squared;
    const part3 = cubed - 2.0 * squared + amount;
    const part4 = cubed - squared;
    return value1 * part1 + value2 * part2 + tangent1 * part3 + tangent2 * part4;
}
function $d6405296de9267dd$export$54435c9b21f5309a(value1, tangent1, value2, tangent2, time) {
    const t2 = time * time;
    return (t2 - time) * 6 * value1 + (3 * t2 - 4 * time + 1) * tangent1 + (-t2 + time) * 6 * value2 + (3 * t2 - 2 * time) * tangent2;
}
function $d6405296de9267dd$export$90534cad35a14134(value, min = 0, max = 1) {
    return Math.min(max, Math.max(min, value));
}
function $d6405296de9267dd$export$f5cbed47313e4153(angle) {
    // More precise but slower version kept for reference.
    // angle = angle % Tools.TwoPi;
    // angle = (angle + Tools.TwoPi) % Tools.TwoPi;
    //if (angle > Math.PI) {
    //	angle -= Tools.TwoPi;
    //}
    angle -= Math.PI * 2 * Math.floor((angle + Math.PI) / (Math.PI * 2));
    return angle;
}
function $d6405296de9267dd$export$6a3297bb326da27e(i) {
    const str = i.toString(16);
    if (i <= 15) return ("0" + str).toUpperCase();
    return str.toUpperCase();
}
function $d6405296de9267dd$export$f91efbafa10dbdfa(value) {
    if (Math.log2) return Math.floor(Math.log2(value));
    if (value < 0) return NaN;
    else if (value === 0) return -Infinity;
    let n = 0;
    if (value < 1) {
        while(value < 1){
            n++;
            value = value * 2;
        }
        n = -n;
    } else if (value > 1) while(value > 1){
        n++;
        value = Math.floor(value / 2);
    }
    return n;
}
function $d6405296de9267dd$export$f9d61a2a6155ab51(value, length) {
    return value - Math.floor(value / length) * length;
}
function $d6405296de9267dd$export$2f0c990471e0f00(value, min, max) {
    return (value - min) / (max - min);
}
function $d6405296de9267dd$export$da037d14d825fa49(normalized, min, max) {
    return normalized * (max - min) + min;
}
function $d6405296de9267dd$export$ecb5b375bee2e8b1(current, target) {
    let num = $d6405296de9267dd$export$f9d61a2a6155ab51(target - current, 360.0);
    if (num > 180.0) num -= 360.0;
    return num;
}
function $d6405296de9267dd$export$87801c312d5bfb5(tx, length) {
    const t = $d6405296de9267dd$export$f9d61a2a6155ab51(tx, length * 2.0);
    return length - Math.abs(t - length);
}
function $d6405296de9267dd$export$318df3a4d2e71730(from, to, tx) {
    let t = $d6405296de9267dd$export$90534cad35a14134(tx);
    t = -2 * t * t * t + 3.0 * t * t;
    return to * t + from * (1.0 - t);
}
function $d6405296de9267dd$export$28aa1391b414ff0f(current, target, maxDelta) {
    let result = 0;
    if (Math.abs(target - current) <= maxDelta) result = target;
    else result = current + Math.sign(target - current) * maxDelta;
    return result;
}
function $d6405296de9267dd$export$dc1af98896c7e0e3(current, target, maxDelta) {
    const num = $d6405296de9267dd$export$ecb5b375bee2e8b1(current, target);
    let result = 0;
    if (-maxDelta < num && num < maxDelta) result = target;
    else {
        target = current + num;
        result = $d6405296de9267dd$export$28aa1391b414ff0f(current, target, maxDelta);
    }
    return result;
}
function $d6405296de9267dd$export$27d319b665e1f281(number, min, max) {
    return (number - min) / (max - min);
}
function $d6405296de9267dd$export$4468ca89a58c5329(percent, min, max) {
    return (max - min) * percent + min;
}
function $d6405296de9267dd$export$f278ef008b722a1f(a, b) {
    const r = a % b;
    if (r === 0) return b;
    return $d6405296de9267dd$export$f278ef008b722a1f(b, r);
}

});


parcelRegister("dG1pf", function(module, exports) {

$parcel$export(module.exports, "ImageProcessingConfiguration", () => $9f5049d6792e7ced$export$e58d65d302f9b7ec);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $7etnY = parcelRequire("7etnY");

var $eVS9r = parcelRequire("eVS9r");

var $wK2xc = parcelRequire("wK2xc");

var $6Ho1L = parcelRequire("6Ho1L");

var $ePyUi = parcelRequire("ePyUi");

var $8DoUR = parcelRequire("8DoUR");
class $9f5049d6792e7ced$export$e58d65d302f9b7ec {
    constructor(){
        /**
         * Color curves setup used in the effect if colorCurvesEnabled is set to true
         */ this.colorCurves = new (0, $eVS9r.ColorCurves)();
        this._colorCurvesEnabled = false;
        this._colorGradingEnabled = false;
        this._colorGradingWithGreenDepth = true;
        this._colorGradingBGR = true;
        /** @internal */ this._exposure = 1.0;
        this._toneMappingEnabled = false;
        this._toneMappingType = $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_STANDARD;
        this._contrast = 1.0;
        /**
         * Vignette stretch size.
         */ this.vignetteStretch = 0;
        /**
         * Vignette center X Offset.
         */ this.vignetteCenterX = 0;
        /**
         * Vignette center Y Offset.
         */ this.vignetteCenterY = 0;
        /**
         * Vignette weight or intensity of the vignette effect.
         */ this.vignetteWeight = 1.5;
        /**
         * Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
         * if vignetteEnabled is set to true.
         */ this.vignetteColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /**
         * Camera field of view used by the Vignette effect.
         */ this.vignetteCameraFov = 0.5;
        this._vignetteBlendMode = $9f5049d6792e7ced$export$e58d65d302f9b7ec.VIGNETTEMODE_MULTIPLY;
        this._vignetteEnabled = false;
        this._ditheringEnabled = false;
        this._ditheringIntensity = 1.0 / 255.0;
        /** @internal */ this._skipFinalColorClamp = false;
        /** @internal */ this._applyByPostProcess = false;
        this._isEnabled = true;
        /**
         * An event triggered when the configuration changes and requires Shader to Update some parameters.
         */ this.onUpdateParameters = new (0, $diGQf.Observable)();
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get colorCurvesEnabled() {
        return this._colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set colorCurvesEnabled(value) {
        if (this._colorCurvesEnabled === value) return;
        this._colorCurvesEnabled = value;
        this._updateParameters();
    }
    /**
     * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
     */ get colorGradingTexture() {
        return this._colorGradingTexture;
    }
    /**
     * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
     */ set colorGradingTexture(value) {
        if (this._colorGradingTexture === value) return;
        this._colorGradingTexture = value;
        this._updateParameters();
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get colorGradingEnabled() {
        return this._colorGradingEnabled;
    }
    /**
     * Sets whether the color grading effect is enabled.
     */ set colorGradingEnabled(value) {
        if (this._colorGradingEnabled === value) return;
        this._colorGradingEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets whether the color grading effect is using a green depth for the 3d Texture.
     */ get colorGradingWithGreenDepth() {
        return this._colorGradingWithGreenDepth;
    }
    /**
     * Sets whether the color grading effect is using a green depth for the 3d Texture.
     */ set colorGradingWithGreenDepth(value) {
        if (this._colorGradingWithGreenDepth === value) return;
        this._colorGradingWithGreenDepth = value;
        this._updateParameters();
    }
    /**
     * Gets whether the color grading texture contains BGR values.
     */ get colorGradingBGR() {
        return this._colorGradingBGR;
    }
    /**
     * Sets whether the color grading texture contains BGR values.
     */ set colorGradingBGR(value) {
        if (this._colorGradingBGR === value) return;
        this._colorGradingBGR = value;
        this._updateParameters();
    }
    /**
     * Gets the Exposure used in the effect.
     */ get exposure() {
        return this._exposure;
    }
    /**
     * Sets the Exposure used in the effect.
     */ set exposure(value) {
        if (this._exposure === value) return;
        this._exposure = value;
        this._updateParameters();
    }
    /**
     * Gets whether the tone mapping effect is enabled.
     */ get toneMappingEnabled() {
        return this._toneMappingEnabled;
    }
    /**
     * Sets whether the tone mapping effect is enabled.
     */ set toneMappingEnabled(value) {
        if (this._toneMappingEnabled === value) return;
        this._toneMappingEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets the type of tone mapping effect.
     */ get toneMappingType() {
        return this._toneMappingType;
    }
    /**
     * Sets the type of tone mapping effect used in BabylonJS.
     */ set toneMappingType(value) {
        if (this._toneMappingType === value) return;
        this._toneMappingType = value;
        this._updateParameters();
    }
    /**
     * Gets the contrast used in the effect.
     */ get contrast() {
        return this._contrast;
    }
    /**
     * Sets the contrast used in the effect.
     */ set contrast(value) {
        if (this._contrast === value) return;
        this._contrast = value;
        this._updateParameters();
    }
    /**
     * Back Compat: Vignette center Y Offset.
     * @deprecated use vignetteCenterY instead
     */ get vignetteCentreY() {
        return this.vignetteCenterY;
    }
    set vignetteCentreY(value) {
        this.vignetteCenterY = value;
    }
    /**
     * Back Compat: Vignette center X Offset.
     * @deprecated use vignetteCenterX instead
     */ get vignetteCentreX() {
        return this.vignetteCenterX;
    }
    set vignetteCentreX(value) {
        this.vignetteCenterX = value;
    }
    /**
     * Gets the vignette blend mode allowing different kind of effect.
     */ get vignetteBlendMode() {
        return this._vignetteBlendMode;
    }
    /**
     * Sets the vignette blend mode allowing different kind of effect.
     */ set vignetteBlendMode(value) {
        if (this._vignetteBlendMode === value) return;
        this._vignetteBlendMode = value;
        this._updateParameters();
    }
    /**
     * Gets whether the vignette effect is enabled.
     */ get vignetteEnabled() {
        return this._vignetteEnabled;
    }
    /**
     * Sets whether the vignette effect is enabled.
     */ set vignetteEnabled(value) {
        if (this._vignetteEnabled === value) return;
        this._vignetteEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets whether the dithering effect is enabled.
     * The dithering effect can be used to reduce banding.
     */ get ditheringEnabled() {
        return this._ditheringEnabled;
    }
    /**
     * Sets whether the dithering effect is enabled.
     * The dithering effect can be used to reduce banding.
     */ set ditheringEnabled(value) {
        if (this._ditheringEnabled === value) return;
        this._ditheringEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
     */ get ditheringIntensity() {
        return this._ditheringIntensity;
    }
    /**
     * Sets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
     */ set ditheringIntensity(value) {
        if (this._ditheringIntensity === value) return;
        this._ditheringIntensity = value;
        this._updateParameters();
    }
    /**
     * If apply by post process is set to true, setting this to true will skip the final color clamp step in the fragment shader
     * Applies to PBR materials.
     */ get skipFinalColorClamp() {
        return this._skipFinalColorClamp;
    }
    /**
     * If apply by post process is set to true, setting this to true will skip the final color clamp step in the fragment shader
     * Applies to PBR materials.
     */ set skipFinalColorClamp(value) {
        if (this._skipFinalColorClamp === value) return;
        this._skipFinalColorClamp = value;
        this._updateParameters();
    }
    /**
     * Gets whether the image processing is applied through a post process or not.
     */ get applyByPostProcess() {
        return this._applyByPostProcess;
    }
    /**
     * Sets whether the image processing is applied through a post process or not.
     */ set applyByPostProcess(value) {
        if (this._applyByPostProcess === value) return;
        this._applyByPostProcess = value;
        this._updateParameters();
    }
    /**
     * Gets whether the image processing is enabled or not.
     */ get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Sets whether the image processing is enabled or not.
     */ set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        this._updateParameters();
    }
    /**
     * Method called each time the image processing information changes requires to recompile the effect.
     */ _updateParameters() {
        this.onUpdateParameters.notifyObservers(this);
    }
    /**
     * Gets the current class name.
     * @returns "ImageProcessingConfiguration"
     */ getClassName() {
        return "ImageProcessingConfiguration";
    }
    /**
     * Prepare the list of defines associated to the shader.
     * @param defines the list of defines to complete
     * @param forPostProcess Define if we are currently in post process mode or not
     */ prepareDefines(defines, forPostProcess = false) {
        if (forPostProcess !== this.applyByPostProcess || !this._isEnabled) {
            defines.VIGNETTE = false;
            defines.TONEMAPPING = 0;
            defines.CONTRAST = false;
            defines.EXPOSURE = false;
            defines.COLORCURVES = false;
            defines.COLORGRADING = false;
            defines.COLORGRADING3D = false;
            defines.DITHER = false;
            defines.IMAGEPROCESSING = false;
            defines.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp;
            defines.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess && this._isEnabled;
            return;
        }
        defines.VIGNETTE = this.vignetteEnabled;
        defines.VIGNETTEBLENDMODEMULTIPLY = this.vignetteBlendMode === $9f5049d6792e7ced$export$e58d65d302f9b7ec._VIGNETTEMODE_MULTIPLY;
        defines.VIGNETTEBLENDMODEOPAQUE = !defines.VIGNETTEBLENDMODEMULTIPLY;
        if (!this._toneMappingEnabled) defines.TONEMAPPING = 0;
        else switch(this._toneMappingType){
            case $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_KHR_PBR_NEUTRAL:
                defines.TONEMAPPING = 3;
                break;
            case $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_ACES:
                defines.TONEMAPPING = 2;
                break;
            default:
                defines.TONEMAPPING = 1;
                break;
        }
        defines.CONTRAST = this.contrast !== 1.0;
        defines.EXPOSURE = this.exposure !== 1.0;
        defines.COLORCURVES = this.colorCurvesEnabled && !!this.colorCurves;
        defines.COLORGRADING = this.colorGradingEnabled && !!this.colorGradingTexture;
        if (defines.COLORGRADING) defines.COLORGRADING3D = this.colorGradingTexture.is3D;
        else defines.COLORGRADING3D = false;
        defines.SAMPLER3DGREENDEPTH = this.colorGradingWithGreenDepth;
        defines.SAMPLER3DBGRMAP = this.colorGradingBGR;
        defines.DITHER = this._ditheringEnabled;
        defines.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess;
        defines.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp;
        defines.IMAGEPROCESSING = defines.VIGNETTE || !!defines.TONEMAPPING || defines.CONTRAST || defines.EXPOSURE || defines.COLORCURVES || defines.COLORGRADING || defines.DITHER;
    }
    /**
     * Returns true if all the image processing information are ready.
     * @returns True if ready, otherwise, false
     */ isReady() {
        // Color Grading texture can not be none blocking.
        return !this.colorGradingEnabled || !this.colorGradingTexture || this.colorGradingTexture.isReady();
    }
    /**
     * Binds the image processing to the shader.
     * @param effect The effect to bind to
     * @param overrideAspectRatio Override the aspect ratio of the effect
     */ bind(effect, overrideAspectRatio) {
        // Color Curves
        if (this._colorCurvesEnabled && this.colorCurves) (0, $eVS9r.ColorCurves).Bind(this.colorCurves, effect);
        // Vignette and dither handled together due to common uniform.
        if (this._vignetteEnabled || this._ditheringEnabled) {
            const inverseWidth = 1 / effect.getEngine().getRenderWidth();
            const inverseHeight = 1 / effect.getEngine().getRenderHeight();
            effect.setFloat2("vInverseScreenSize", inverseWidth, inverseHeight);
            if (this._ditheringEnabled) effect.setFloat("ditherIntensity", 0.5 * this._ditheringIntensity);
            if (this._vignetteEnabled) {
                const aspectRatio = overrideAspectRatio != null ? overrideAspectRatio : inverseHeight / inverseWidth;
                let vignetteScaleY = Math.tan(this.vignetteCameraFov * 0.5);
                let vignetteScaleX = vignetteScaleY * aspectRatio;
                const vignetteScaleGeometricMean = Math.sqrt(vignetteScaleX * vignetteScaleY);
                vignetteScaleX = (0, $wK2xc.Mix)(vignetteScaleX, vignetteScaleGeometricMean, this.vignetteStretch);
                vignetteScaleY = (0, $wK2xc.Mix)(vignetteScaleY, vignetteScaleGeometricMean, this.vignetteStretch);
                effect.setFloat4("vignetteSettings1", vignetteScaleX, vignetteScaleY, -vignetteScaleX * this.vignetteCenterX, -vignetteScaleY * this.vignetteCenterY);
                const vignettePower = -2 * this.vignetteWeight;
                effect.setFloat4("vignetteSettings2", this.vignetteColor.r, this.vignetteColor.g, this.vignetteColor.b, vignettePower);
            }
        }
        // Exposure
        effect.setFloat("exposureLinear", this.exposure);
        // Contrast
        effect.setFloat("contrast", this.contrast);
        // Color transform settings
        if (this.colorGradingTexture) {
            effect.setTexture("txColorTransform", this.colorGradingTexture);
            const textureSize = this.colorGradingTexture.getSize().height;
            effect.setFloat4("colorTransformSettings", (textureSize - 1) / textureSize, 0.5 / textureSize, textureSize, this.colorGradingTexture.level // weight
            );
        }
    }
    /**
     * Clones the current image processing instance.
     * @returns The cloned image processing
     */ clone() {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>new $9f5049d6792e7ced$export$e58d65d302f9b7ec(), this);
    }
    /**
     * Serializes the current image processing instance to a json representation.
     * @returns a JSON representation
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses the image processing from a json representation.
     * @param source the JSON source to parse
     * @returns The parsed image processing
     */ static Parse(source) {
        const parsed = (0, $6Ho1L.SerializationHelper).Parse(()=>new $9f5049d6792e7ced$export$e58d65d302f9b7ec(), source, null, null);
        // Backward compatibility
        if (source.vignetteCentreX !== undefined) parsed.vignetteCenterX = source.vignetteCentreX;
        if (source.vignetteCentreY !== undefined) parsed.vignetteCenterY = source.vignetteCentreY;
        return parsed;
    }
    /**
     * Used to apply the vignette as a mix with the pixel color.
     */ static get VIGNETTEMODE_MULTIPLY() {
        return this._VIGNETTEMODE_MULTIPLY;
    }
    /**
     * Used to apply the vignette as a replacement of the pixel color.
     */ static get VIGNETTEMODE_OPAQUE() {
        return this._VIGNETTEMODE_OPAQUE;
    }
}
/**
 * Default tone mapping applied in BabylonJS.
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_STANDARD = 0;
/**
 * ACES Tone mapping (used by default in unreal and unity). This can help getting closer
 * to other engines rendering to increase portability.
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_ACES = 1;
/**
 * Neutral Tone mapping developped by the Khronos group in order to constrain
 * values between 0 and 1 without shifting Hue.
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_KHR_PBR_NEUTRAL = 2;
/**
 * Prepare the list of uniforms associated with the Image Processing effects.
 * @param uniforms The list of uniforms used in the effect
 * @param defines the list of defines currently in use
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.PrepareUniforms = (0, $ePyUi.PrepareUniformsForImageProcessing);
/**
 * Prepare the list of samplers associated with the Image Processing effects.
 * @param samplersList The list of uniforms used in the effect
 * @param defines the list of defines currently in use
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.PrepareSamplers = (0, $ePyUi.PrepareSamplersForImageProcessing);
// Static constants associated to the image processing.
$9f5049d6792e7ced$export$e58d65d302f9b7ec._VIGNETTEMODE_MULTIPLY = 0;
$9f5049d6792e7ced$export$e58d65d302f9b7ec._VIGNETTEMODE_OPAQUE = 1;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColorCurves)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "colorCurves", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorCurvesEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("colorGradingTexture")
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingWithGreenDepth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingBGR", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_exposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_toneMappingEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_toneMappingType", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_contrast", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteStretch", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteCenterX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteCenterY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteWeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor4)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteCameraFov", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_vignetteBlendMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_vignetteEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_ditheringEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_ditheringIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_skipFinalColorClamp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_applyByPostProcess", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_isEnabled", void 0);
// References the dependencies.
(0, $6Ho1L.SerializationHelper)._ImageProcessingConfigurationParser = $9f5049d6792e7ced$export$e58d65d302f9b7ec.Parse;
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.ImageProcessingConfiguration", $9f5049d6792e7ced$export$e58d65d302f9b7ec);

});
parcelRegister("7etnY", function(module, exports) {

$parcel$export(module.exports, "Color3", () => $5440a29da7c4a7fe$export$b3ff593cf6d17bf0);
$parcel$export(module.exports, "Color4", () => $5440a29da7c4a7fe$export$cb7e366859c95cb0);
$parcel$export(module.exports, "TmpColors", () => $5440a29da7c4a7fe$export$22fd4211f9ff6a1d);

var $opFp4 = parcelRequire("opFp4");

var $8DoUR = parcelRequire("8DoUR");

var $53VPf = parcelRequire("53VPf");

var $iosaP = parcelRequire("iosaP");
function $5440a29da7c4a7fe$var$colorChannelToLinearSpace(color) {
    return Math.pow(color, (0, $53VPf.ToLinearSpace));
}
function $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(color) {
    if (color <= 0.04045) return 0.0773993808 * color;
    return Math.pow(0.947867299 * (color + 0.055), 2.4);
}
function $5440a29da7c4a7fe$var$colorChannelToGammaSpace(color) {
    return Math.pow(color, (0, $53VPf.ToGammaSpace));
}
function $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(color) {
    if (color <= 0.0031308) return 12.92 * color;
    return 1.055 * Math.pow(color, 0.41666) - 0.055;
}
class $5440a29da7c4a7fe$export$b3ff593cf6d17bf0 {
    /**
     * Creates a new Color3 object from red, green, blue values, all between 0 and 1
     * @param r defines the red component (between 0 and 1, default is 0)
     * @param g defines the green component (between 0 and 1, default is 0)
     * @param b defines the blue component (between 0 and 1, default is 0)
     */ constructor(/**
     * [0] Defines the red component (between 0 and 1, default is 0)
     */ r = 0, /**
     * [0] Defines the green component (between 0 and 1, default is 0)
     */ g = 0, /**
     * [0] Defines the blue component (between 0 and 1, default is 0)
     */ b = 0){
        this.r = r;
        this.g = g;
        this.b = b;
    }
    /**
     * Creates a string with the Color3 current values
     * @returns the string representation of the Color3 object
     */ toString() {
        return "{R: " + this.r + " G:" + this.g + " B:" + this.b + "}";
    }
    /**
     * Returns the string "Color3"
     * @returns "Color3"
     */ getClassName() {
        return "Color3";
    }
    /**
     * Compute the Color3 hash code
     * @returns an unique number that can be used to hash Color3 objects
     */ getHashCode() {
        let hash = this.r * 255 | 0;
        hash = hash * 397 ^ (this.g * 255 | 0);
        hash = hash * 397 ^ (this.b * 255 | 0);
        return hash;
    }
    // Operators
    /**
     * Stores in the given array from the given starting index the red, green, blue values as successive elements
     * @param array defines the array where to store the r,g,b components
     * @param index defines an optional index in the target array to define where to start storing values
     * @returns the current Color3 object
     */ toArray(array, index = 0) {
        array[index] = this.r;
        array[index + 1] = this.g;
        array[index + 2] = this.b;
        return this;
    }
    /**
     * Update the current color with values stored in an array from the starting index of the given array
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns the current Color3 object
     */ fromArray(array, offset = 0) {
        $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Returns a new Color4 object from the current Color3 and the given alpha
     * @param alpha defines the alpha component on the new Color4 object (default is 1)
     * @returns a new Color4 object
     */ toColor4(alpha = 1) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r, this.g, this.b, alpha);
    }
    /**
     * Returns a new array populated with 3 numeric elements : red, green and blue values
     * @returns the new array
     */ asArray() {
        return [
            this.r,
            this.g,
            this.b
        ];
    }
    /**
     * Returns the luminance value
     * @returns a float value
     */ toLuminance() {
        return this.r * 0.3 + this.g * 0.59 + this.b * 0.11;
    }
    /**
     * Multiply each Color3 rgb values by the given Color3 rgb values in a new Color3 object
     * @param otherColor defines the second operand
     * @returns the new Color3 object
     */ multiply(otherColor) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r * otherColor.r, this.g * otherColor.g, this.b * otherColor.b);
    }
    /**
     * Multiply the rgb values of the Color3 and the given Color3 and stores the result in the object "result"
     * @param otherColor defines the second operand
     * @param result defines the Color3 object where to store the result
     * @returns the result Color3
     */ multiplyToRef(otherColor, result) {
        result.r = this.r * otherColor.r;
        result.g = this.g * otherColor.g;
        result.b = this.b * otherColor.b;
        return result;
    }
    /**
     * Multiplies the current Color3 coordinates by the given ones
     * @param otherColor defines the second operand
     * @returns the current updated Color3
     */ multiplyInPlace(otherColor) {
        this.r *= otherColor.r;
        this.g *= otherColor.g;
        this.b *= otherColor.b;
        return this;
    }
    /**
     * Returns a new Color3 set with the result of the multiplication of the current Color3 coordinates by the given floats
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the new Color3
     */ multiplyByFloats(r, g, b) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r * r, this.g * g, this.b * b);
    }
    /**
     * @internal
     * Do not use
     */ divide(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideToRef(_other, _result) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideInPlace(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * Updates the current Color3 with the minimal coordinate values between its and the given color ones
     * @param other defines the second operand
     * @returns the current updated Color3
     */ minimizeInPlace(other) {
        return this.minimizeInPlaceFromFloats(other.r, other.g, other.b);
    }
    /**
     * Updates the current Color3 with the maximal coordinate values between its and the given color ones.
     * @param other defines the second operand
     * @returns the current updated Color3
     */ maximizeInPlace(other) {
        return this.maximizeInPlaceFromFloats(other.r, other.g, other.b);
    }
    /**
     * Updates the current Color3 with the minimal coordinate values between its and the given coordinates
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the current updated Color3
     */ minimizeInPlaceFromFloats(r, g, b) {
        this.r = Math.min(r, this.r);
        this.g = Math.min(g, this.g);
        this.b = Math.min(b, this.b);
        return this;
    }
    /**
     * Updates the current Color3 with the maximal coordinate values between its and the given coordinates.
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the current updated Color3
     */ maximizeInPlaceFromFloats(r, g, b) {
        this.r = Math.max(r, this.r);
        this.g = Math.max(g, this.g);
        this.b = Math.max(b, this.b);
        return this;
    }
    /**
     * @internal
     * Do not use
     */ floorToRef(_result) {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ floor() {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ fractToRef(_result) {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * @internal
     * Do not use
     */ fract() {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * Determines equality between Color3 objects
     * @param otherColor defines the second operand
     * @returns true if the rgb values are equal to the given ones
     */ equals(otherColor) {
        return otherColor && this.r === otherColor.r && this.g === otherColor.g && this.b === otherColor.b;
    }
    /**
     * Alias for equalsToFloats
     * @param r red color component
     * @param g green color component
     * @param b blue color component
     * @returns boolean
     */ equalsFloats(r, g, b) {
        return this.equalsToFloats(r, g, b);
    }
    /**
     * Determines equality between the current Color3 object and a set of r,b,g values
     * @param r defines the red component to check
     * @param g defines the green component to check
     * @param b defines the blue component to check
     * @returns true if the rgb values are equal to the given ones
     */ equalsToFloats(r, g, b) {
        return this.r === r && this.g === g && this.b === b;
    }
    /**
     * Returns true if the current Color3 and the given color coordinates are distant less than epsilon
     * @param otherColor defines the second operand
     * @param epsilon defines the minimal distance to define values as equals
     * @returns true if both colors are distant less than epsilon
     */ equalsWithEpsilon(otherColor, epsilon = (0, $53VPf.Epsilon)) {
        return (0, $iosaP.WithinEpsilon)(this.r, otherColor.r, epsilon) && (0, $iosaP.WithinEpsilon)(this.g, otherColor.g, epsilon) && (0, $iosaP.WithinEpsilon)(this.b, otherColor.b, epsilon);
    }
    /**
     * @internal
     * Do not use
     */ negate() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateInPlace() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateToRef(_result) {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * Creates a new Color3 with the current Color3 values multiplied by scale
     * @param scale defines the scaling factor to apply
     * @returns a new Color3 object
     */ scale(scale) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r * scale, this.g * scale, this.b * scale);
    }
    /**
     * Multiplies the Color3 values by the float "scale"
     * @param scale defines the scaling factor to apply
     * @returns the current updated Color3
     */ scaleInPlace(scale) {
        this.r *= scale;
        this.g *= scale;
        this.b *= scale;
        return this;
    }
    /**
     * Multiplies the rgb values by scale and stores the result into "result"
     * @param scale defines the scaling factor
     * @param result defines the Color3 object where to store the result
     * @returns the result Color3
     */ scaleToRef(scale, result) {
        result.r = this.r * scale;
        result.g = this.g * scale;
        result.b = this.b * scale;
        return result;
    }
    /**
     * Scale the current Color3 values by a factor and add the result to a given Color3
     * @param scale defines the scale factor
     * @param result defines color to store the result into
     * @returns the result Color3
     */ scaleAndAddToRef(scale, result) {
        result.r += this.r * scale;
        result.g += this.g * scale;
        result.b += this.b * scale;
        return result;
    }
    /**
     * Clamps the rgb values by the min and max values and stores the result into "result"
     * @param min defines minimum clamping value (default is 0)
     * @param max defines maximum clamping value (default is 1)
     * @param result defines color to store the result into
     * @returns the result Color3
     */ clampToRef(min = 0, max = 1, result) {
        result.r = (0, $iosaP.Clamp)(this.r, min, max);
        result.g = (0, $iosaP.Clamp)(this.g, min, max);
        result.b = (0, $iosaP.Clamp)(this.b, min, max);
        return result;
    }
    /**
     * Creates a new Color3 set with the added values of the current Color3 and of the given one
     * @param otherColor defines the second operand
     * @returns the new Color3
     */ add(otherColor) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r + otherColor.r, this.g + otherColor.g, this.b + otherColor.b);
    }
    /**
     * Adds the given color to the current Color3
     * @param otherColor defines the second operand
     * @returns the current updated Color3
     */ addInPlace(otherColor) {
        this.r += otherColor.r;
        this.g += otherColor.g;
        this.b += otherColor.b;
        return this;
    }
    /**
     * Adds the given coordinates to the current Color3
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the current updated Color3
     */ addInPlaceFromFloats(r, g, b) {
        this.r += r;
        this.g += g;
        this.b += b;
        return this;
    }
    /**
     * Stores the result of the addition of the current Color3 and given one rgb values into "result"
     * @param otherColor defines the second operand
     * @param result defines Color3 object to store the result into
     * @returns the unmodified current Color3
     */ addToRef(otherColor, result) {
        result.r = this.r + otherColor.r;
        result.g = this.g + otherColor.g;
        result.b = this.b + otherColor.b;
        return result;
    }
    /**
     * Returns a new Color3 set with the subtracted values of the given one from the current Color3
     * @param otherColor defines the second operand
     * @returns the new Color3
     */ subtract(otherColor) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r - otherColor.r, this.g - otherColor.g, this.b - otherColor.b);
    }
    /**
     * Stores the result of the subtraction of given one from the current Color3 rgb values into "result"
     * @param otherColor defines the second operand
     * @param result defines Color3 object to store the result into
     * @returns the unmodified current Color3
     */ subtractToRef(otherColor, result) {
        result.r = this.r - otherColor.r;
        result.g = this.g - otherColor.g;
        result.b = this.b - otherColor.b;
        return result;
    }
    /**
     * Subtract the given color from the current Color3
     * @param otherColor defines the second operand
     * @returns the current updated Color3
     */ subtractInPlace(otherColor) {
        this.r -= otherColor.r;
        this.g -= otherColor.g;
        this.b -= otherColor.b;
        return this;
    }
    /**
     * Returns a new Color3 set with the subtraction of the given floats from the current Color3 coordinates
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the resulting Color3
     */ subtractFromFloats(r, g, b) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r - r, this.g - g, this.b - b);
    }
    /**
     * Subtracts the given floats from the current Color3 coordinates and set the given color "result" with this result
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param result defines the Color3 object where to store the result
     * @returns the result
     */ subtractFromFloatsToRef(r, g, b, result) {
        result.r = this.r - r;
        result.g = this.g - g;
        result.b = this.b - b;
        return result;
    }
    /**
     * Copy the current object
     * @returns a new Color3 copied the current one
     */ clone() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(this.r, this.g, this.b);
    }
    /**
     * Copies the rgb values from the source in the current Color3
     * @param source defines the source Color3 object
     * @returns the updated Color3 object
     */ copyFrom(source) {
        this.r = source.r;
        this.g = source.g;
        this.b = source.b;
        return this;
    }
    /**
     * Updates the Color3 rgb values from the given floats
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @returns the current Color3 object
     */ copyFromFloats(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    /**
     * Updates the Color3 rgb values from the given floats
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @returns the current Color3 object
     */ set(r, g, b) {
        return this.copyFromFloats(r, g, b);
    }
    /**
     * Copies the given float to the current Color3 coordinates
     * @param v defines the r, g and b coordinates of the operand
     * @returns the current updated Color3
     */ setAll(v) {
        this.r = this.g = this.b = v;
        return this;
    }
    /**
     * Compute the Color3 hexadecimal code as a string
     * @returns a string containing the hexadecimal representation of the Color3 object
     */ toHexString() {
        const intR = Math.round(this.r * 255);
        const intG = Math.round(this.g * 255);
        const intB = Math.round(this.b * 255);
        return "#" + (0, $iosaP.ToHex)(intR) + (0, $iosaP.ToHex)(intG) + (0, $iosaP.ToHex)(intB);
    }
    /**
     * Updates the Color3 rgb values from the string containing valid hexadecimal values
     * @param hex defines a string containing valid hexadecimal values
     * @returns the current Color3 object
     */ fromHexString(hex) {
        if (hex.substring(0, 1) !== "#" || hex.length !== 7) return this;
        this.r = parseInt(hex.substring(1, 3), 16) / 255;
        this.g = parseInt(hex.substring(3, 5), 16) / 255;
        this.b = parseInt(hex.substring(5, 7), 16) / 255;
        return this;
    }
    /**
     * Converts current color in rgb space to HSV values
     * @returns a new color3 representing the HSV values
     */ toHSV() {
        return this.toHSVToRef(new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0());
    }
    /**
     * Converts current color in rgb space to HSV values
     * @param result defines the Color3 where to store the HSV values
     * @returns the updated result
     */ toHSVToRef(result) {
        const r = this.r;
        const g = this.g;
        const b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h = 0;
        let s = 0;
        const v = max;
        const dm = max - min;
        if (max !== 0) s = dm / max;
        if (max != min) {
            if (max == r) {
                h = (g - b) / dm;
                if (g < b) h += 6;
            } else if (max == g) h = (b - r) / dm + 2;
            else if (max == b) h = (r - g) / dm + 4;
            h *= 60;
        }
        result.r = h;
        result.g = s;
        result.b = v;
        return result;
    }
    /**
     * Computes a new Color3 converted from the current one to linear space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color3 object
     */ toLinearSpace(exact = false) {
        const convertedColor = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0();
        this.toLinearSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color3 values to linear space and stores the result in "convertedColor"
     * @param convertedColor defines the Color3 object where to store the linear space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color3
     */ toLinearSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.b);
        }
        return this;
    }
    /**
     * Computes a new Color3 converted from the current one to gamma space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color3 object
     */ toGammaSpace(exact = false) {
        const convertedColor = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0();
        this.toGammaSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color3 values to gamma space and stores the result in "convertedColor"
     * @param convertedColor defines the Color3 object where to store the gamma space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color3
     */ toGammaSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.b);
        }
        return this;
    }
    /**
     * Converts Hue, saturation and value to a Color3 (RGB)
     * @param hue defines the hue (value between 0 and 360)
     * @param saturation defines the saturation (value between 0 and 1)
     * @param value defines the value (value between 0 and 1)
     * @param result defines the Color3 where to store the RGB values
     * @returns the updated result
     */ static HSVtoRGBToRef(hue, saturation, value, result) {
        const chroma = value * saturation;
        const h = hue / 60;
        const x = chroma * (1 - Math.abs(h % 2 - 1));
        let r = 0;
        let g = 0;
        let b = 0;
        if (h >= 0 && h <= 1) {
            r = chroma;
            g = x;
        } else if (h >= 1 && h <= 2) {
            r = x;
            g = chroma;
        } else if (h >= 2 && h <= 3) {
            g = chroma;
            b = x;
        } else if (h >= 3 && h <= 4) {
            g = x;
            b = chroma;
        } else if (h >= 4 && h <= 5) {
            r = x;
            b = chroma;
        } else if (h >= 5 && h <= 6) {
            r = chroma;
            b = x;
        }
        const m = value - chroma;
        result.r = r + m;
        result.g = g + m;
        result.b = b + m;
        return result;
    }
    /**
     * Converts Hue, saturation and value to a new Color3 (RGB)
     * @param hue defines the hue (value between 0 and 360)
     * @param saturation defines the saturation (value between 0 and 1)
     * @param value defines the value (value between 0 and 1)
     * @returns a new Color3 object
     */ static FromHSV(hue, saturation, value) {
        const result = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 0);
        $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.HSVtoRGBToRef(hue, saturation, value, result);
        return result;
    }
    /**
     * Creates a new Color3 from the string containing valid hexadecimal values
     * @param hex defines a string containing valid hexadecimal values
     * @returns a new Color3 object
     */ static FromHexString(hex) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 0).fromHexString(hex);
    }
    /**
     * Creates a new Color3 from the starting index of the given array
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns a new Color3 object
     */ static FromArray(array, offset = 0) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(array[offset], array[offset + 1], array[offset + 2]);
    }
    /**
     * Creates a new Color3 from the starting index element of the given array
     * @param array defines the source array to read from
     * @param offset defines the offset in the source array
     * @param result defines the target Color3 object
     */ static FromArrayToRef(array, offset = 0, result) {
        result.r = array[offset];
        result.g = array[offset + 1];
        result.b = array[offset + 2];
    }
    /**
     * Creates a new Color3 from integer values (\< 256)
     * @param r defines the red component to read from (value between 0 and 255)
     * @param g defines the green component to read from (value between 0 and 255)
     * @param b defines the blue component to read from (value between 0 and 255)
     * @returns a new Color3 object
     */ static FromInts(r, g, b) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(r / 255.0, g / 255.0, b / 255.0);
    }
    /**
     * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
     * @param start defines the start Color3 value
     * @param end defines the end Color3 value
     * @param amount defines the gradient value between start and end
     * @returns a new Color3 object
     */ static Lerp(start, end, amount) {
        const result = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.0, 0.0, 0.0);
        $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.LerpToRef(start, end, amount, result);
        return result;
    }
    /**
     * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
     * @param left defines the start value
     * @param right defines the end value
     * @param amount defines the gradient factor
     * @param result defines the Color3 object where to store the result
     */ static LerpToRef(left, right, amount, result) {
        result.r = left.r + (right.r - left.r) * amount;
        result.g = left.g + (right.g - left.g) * amount;
        result.b = left.b + (right.b - left.b) * amount;
    }
    /**
     * Returns a new Color3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent Color3
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent Color3
     * @param amount defines the amount on the interpolation spline (between 0 and 1)
     * @returns the new Color3
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const r = value1.r * part1 + value2.r * part2 + tangent1.r * part3 + tangent2.r * part4;
        const g = value1.g * part1 + value2.g * part2 + tangent1.g * part3 + tangent2.g * part4;
        const b = value1.b * part1 + value2.b * part2 + tangent1.b * part3 + tangent2.b * part4;
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(r, g, b);
    }
    /**
     * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.Black();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result.r = (t2 - time) * 6 * value1.r + (3 * t2 - 4 * time + 1) * tangent1.r + (-t2 + time) * 6 * value2.r + (3 * t2 - 2 * time) * tangent2.r;
        result.g = (t2 - time) * 6 * value1.g + (3 * t2 - 4 * time + 1) * tangent1.g + (-t2 + time) * 6 * value2.g + (3 * t2 - 2 * time) * tangent2.g;
        result.b = (t2 - time) * 6 * value1.b + (3 * t2 - 4 * time + 1) * tangent1.b + (-t2 + time) * 6 * value2.b + (3 * t2 - 2 * time) * tangent2.b;
    }
    /**
     * Returns a Color3 value containing a red color
     * @returns a new Color3 object
     */ static Red() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 0, 0);
    }
    /**
     * Returns a Color3 value containing a green color
     * @returns a new Color3 object
     */ static Green() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 1, 0);
    }
    /**
     * Returns a Color3 value containing a blue color
     * @returns a new Color3 object
     */ static Blue() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 1);
    }
    /**
     * Returns a Color3 value containing a black color
     * @returns a new Color3 object
     */ static Black() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 0);
    }
    /**
     * Gets a Color3 value containing a black color that must not be updated
     */ static get BlackReadOnly() {
        return $5440a29da7c4a7fe$export$b3ff593cf6d17bf0._BlackReadOnly;
    }
    /**
     * Returns a Color3 value containing a white color
     * @returns a new Color3 object
     */ static White() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 1, 1);
    }
    /**
     * Returns a Color3 value containing a purple color
     * @returns a new Color3 object
     */ static Purple() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.5, 0, 0.5);
    }
    /**
     * Returns a Color3 value containing a magenta color
     * @returns a new Color3 object
     */ static Magenta() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 0, 1);
    }
    /**
     * Returns a Color3 value containing a yellow color
     * @returns a new Color3 object
     */ static Yellow() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 1, 0);
    }
    /**
     * Returns a Color3 value containing a gray color
     * @returns a new Color3 object
     */ static Gray() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.5, 0.5, 0.5);
    }
    /**
     * Returns a Color3 value containing a teal color
     * @returns a new Color3 object
     */ static Teal() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 1.0, 1.0);
    }
    /**
     * Returns a Color3 value containing a random color
     * @returns a new Color3 object
     */ static Random() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(Math.random(), Math.random(), Math.random());
    }
}
/**
 * If the first color is flagged with integers (as everything is 0,0,0), V8 stores all of the properties as integers internally because it doesn't know any better yet.
 * If subsequent colors are created with non-integer values, V8 determines that it would be best to represent these properties as doubles instead of integers,
 * and henceforth it will use floating-point representation for all color instances that it creates.
 * But the original color instances are unchanged and has a "deprecated map".
 * If we keep using the color instances from step 1, it will now be a poison pill which will mess up optimizations in any code it touches.
 */ $5440a29da7c4a7fe$export$b3ff593cf6d17bf0._V8PerformanceHack = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.5, 0.5, 0.5);
// Statics
$5440a29da7c4a7fe$export$b3ff593cf6d17bf0._BlackReadOnly = $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.Black();
Object.defineProperties($5440a29da7c4a7fe$export$b3ff593cf6d17bf0.prototype, {
    dimension: {
        value: [
            3
        ]
    },
    rank: {
        value: 1
    }
});
class $5440a29da7c4a7fe$export$cb7e366859c95cb0 {
    /**
     * Creates a new Color4 object from red, green, blue values, all between 0 and 1
     * @param r defines the red component (between 0 and 1, default is 0)
     * @param g defines the green component (between 0 and 1, default is 0)
     * @param b defines the blue component (between 0 and 1, default is 0)
     * @param a defines the alpha component (between 0 and 1, default is 1)
     */ constructor(/**
     * [0] Defines the red component (between 0 and 1, default is 0)
     */ r = 0, /**
     * [0] Defines the green component (between 0 and 1, default is 0)
     */ g = 0, /**
     * [0] Defines the blue component (between 0 and 1, default is 0)
     */ b = 0, /**
     * [1] Defines the alpha component (between 0 and 1, default is 1)
     */ a = 1){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    // Operators
    /**
     * Creates a new array populated with 4 numeric elements : red, green, blue, alpha values
     * @returns the new array
     */ asArray() {
        return [
            this.r,
            this.g,
            this.b,
            this.a
        ];
    }
    /**
     * Stores from the starting index in the given array the Color4 successive values
     * @param array defines the array where to store the r,g,b components
     * @param index defines an optional index in the target array to define where to start storing values
     * @returns the current Color4 object
     */ toArray(array, index = 0) {
        array[index] = this.r;
        array[index + 1] = this.g;
        array[index + 2] = this.b;
        array[index + 3] = this.a;
        return this;
    }
    /**
     * Update the current color with values stored in an array from the starting index of the given array
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns the current Color4 object
     */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        this.a = array[offset + 3];
        return this;
    }
    /**
     * Determines equality between Color4 objects
     * @param otherColor defines the second operand
     * @returns true if the rgba values are equal to the given ones
     */ equals(otherColor) {
        return otherColor && this.r === otherColor.r && this.g === otherColor.g && this.b === otherColor.b && this.a === otherColor.a;
    }
    /**
     * Creates a new Color4 set with the added values of the current Color4 and of the given one
     * @param otherColor defines the second operand
     * @returns a new Color4 object
     */ add(otherColor) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r + otherColor.r, this.g + otherColor.g, this.b + otherColor.b, this.a + otherColor.a);
    }
    /**
     * Updates the given color "result" with the result of the addition of the current Color4 and the given one.
     * @param otherColor the color to add
     * @param result the color to store the result
     * @returns result input
     */ addToRef(otherColor, result) {
        result.r = this.r + otherColor.r;
        result.g = this.g + otherColor.g;
        result.b = this.b + otherColor.b;
        result.a = this.a + otherColor.a;
        return result;
    }
    /**
     * Adds in place the given Color4 values to the current Color4 object
     * @param otherColor defines the second operand
     * @returns the current updated Color4 object
     */ addInPlace(otherColor) {
        this.r += otherColor.r;
        this.g += otherColor.g;
        this.b += otherColor.b;
        this.a += otherColor.a;
        return this;
    }
    /**
     * Adds the given coordinates to the current Color4
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param a defines the a coordinate of the operand
     * @returns the current updated Color4
     */ addInPlaceFromFloats(r, g, b, a) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.a += a;
        return this;
    }
    /**
     * Creates a new Color4 set with the subtracted values of the given one from the current Color4
     * @param otherColor defines the second operand
     * @returns a new Color4 object
     */ subtract(otherColor) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r - otherColor.r, this.g - otherColor.g, this.b - otherColor.b, this.a - otherColor.a);
    }
    /**
     * Subtracts the given ones from the current Color4 values and stores the results in "result"
     * @param otherColor defines the second operand
     * @param result defines the Color4 object where to store the result
     * @returns the result Color4 object
     */ subtractToRef(otherColor, result) {
        result.r = this.r - otherColor.r;
        result.g = this.g - otherColor.g;
        result.b = this.b - otherColor.b;
        result.a = this.a - otherColor.a;
        return result;
    }
    /**
     * Subtract in place the given color from the current Color4.
     * @param otherColor the color to subtract
     * @returns the updated Color4.
     */ subtractInPlace(otherColor) {
        this.r -= otherColor.r;
        this.g -= otherColor.g;
        this.b -= otherColor.b;
        this.a -= otherColor.a;
        return this;
    }
    /**
     * Returns a new Color4 set with the result of the subtraction of the given floats from the current Color4 coordinates.
     * @param r value to subtract
     * @param g value to subtract
     * @param b value to subtract
     * @param a value to subtract
     * @returns new color containing the result
     */ subtractFromFloats(r, g, b, a) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r - r, this.g - g, this.b - b, this.a - a);
    }
    /**
     * Sets the given color "result" set with the result of the subtraction of the given floats from the current Color4 coordinates.
     * @param r value to subtract
     * @param g value to subtract
     * @param b value to subtract
     * @param a value to subtract
     * @param result the color to store the result in
     * @returns result input
     */ subtractFromFloatsToRef(r, g, b, a, result) {
        result.r = this.r - r;
        result.g = this.g - g;
        result.b = this.b - b;
        result.a = this.a - a;
        return result;
    }
    /**
     * Creates a new Color4 with the current Color4 values multiplied by scale
     * @param scale defines the scaling factor to apply
     * @returns a new Color4 object
     */ scale(scale) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r * scale, this.g * scale, this.b * scale, this.a * scale);
    }
    /**
     * Multiplies the Color4 values by the float "scale"
     * @param scale defines the scaling factor to apply
     * @returns the current updated Color4
     */ scaleInPlace(scale) {
        this.r *= scale;
        this.g *= scale;
        this.b *= scale;
        this.a *= scale;
        return this;
    }
    /**
     * Multiplies the current Color4 values by scale and stores the result in "result"
     * @param scale defines the scaling factor to apply
     * @param result defines the Color4 object where to store the result
     * @returns the result Color4
     */ scaleToRef(scale, result) {
        result.r = this.r * scale;
        result.g = this.g * scale;
        result.b = this.b * scale;
        result.a = this.a * scale;
        return result;
    }
    /**
     * Scale the current Color4 values by a factor and add the result to a given Color4
     * @param scale defines the scale factor
     * @param result defines the Color4 object where to store the result
     * @returns the result Color4
     */ scaleAndAddToRef(scale, result) {
        result.r += this.r * scale;
        result.g += this.g * scale;
        result.b += this.b * scale;
        result.a += this.a * scale;
        return result;
    }
    /**
     * Clamps the rgb values by the min and max values and stores the result into "result"
     * @param min defines minimum clamping value (default is 0)
     * @param max defines maximum clamping value (default is 1)
     * @param result defines color to store the result into.
     * @returns the result Color4
     */ clampToRef(min = 0, max = 1, result) {
        result.r = (0, $iosaP.Clamp)(this.r, min, max);
        result.g = (0, $iosaP.Clamp)(this.g, min, max);
        result.b = (0, $iosaP.Clamp)(this.b, min, max);
        result.a = (0, $iosaP.Clamp)(this.a, min, max);
        return result;
    }
    /**
     * Multiply an Color4 value by another and return a new Color4 object
     * @param color defines the Color4 value to multiply by
     * @returns a new Color4 object
     */ multiply(color) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r * color.r, this.g * color.g, this.b * color.b, this.a * color.a);
    }
    /**
     * Multiply a Color4 value by another and push the result in a reference value
     * @param color defines the Color4 value to multiply by
     * @param result defines the Color4 to fill the result in
     * @returns the result Color4
     */ multiplyToRef(color, result) {
        result.r = this.r * color.r;
        result.g = this.g * color.g;
        result.b = this.b * color.b;
        result.a = this.a * color.a;
        return result;
    }
    /**
     * Multiplies in place the current Color4 by the given one.
     * @param otherColor color to multiple with
     * @returns the updated Color4.
     */ multiplyInPlace(otherColor) {
        this.r *= otherColor.r;
        this.g *= otherColor.g;
        this.b *= otherColor.b;
        this.a *= otherColor.a;
        return this;
    }
    /**
     * Returns a new Color4 set with the multiplication result of the given floats and the current Color4 coordinates.
     * @param r value multiply with
     * @param g value multiply with
     * @param b value multiply with
     * @param a value multiply with
     * @returns resulting new color
     */ multiplyByFloats(r, g, b, a) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r * r, this.g * g, this.b * b, this.a * a);
    }
    /**
     * @internal
     * Do not use
     */ divide(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideToRef(_other, _result) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideInPlace(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * Updates the Color4 coordinates with the minimum values between its own and the given color ones
     * @param other defines the second operand
     * @returns the current updated Color4
     */ minimizeInPlace(other) {
        this.r = Math.min(this.r, other.r);
        this.g = Math.min(this.g, other.g);
        this.b = Math.min(this.b, other.b);
        this.a = Math.min(this.a, other.a);
        return this;
    }
    /**
     * Updates the Color4 coordinates with the maximum values between its own and the given color ones
     * @param other defines the second operand
     * @returns the current updated Color4
     */ maximizeInPlace(other) {
        this.r = Math.max(this.r, other.r);
        this.g = Math.max(this.g, other.g);
        this.b = Math.max(this.b, other.b);
        this.a = Math.max(this.a, other.a);
        return this;
    }
    /**
     * Updates the current Color4 with the minimal coordinate values between its and the given coordinates
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param a defines the a coordinate of the operand
     * @returns the current updated Color4
     */ minimizeInPlaceFromFloats(r, g, b, a) {
        this.r = Math.min(r, this.r);
        this.g = Math.min(g, this.g);
        this.b = Math.min(b, this.b);
        this.a = Math.min(a, this.a);
        return this;
    }
    /**
     * Updates the current Color4 with the maximal coordinate values between its and the given coordinates.
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param a defines the a coordinate of the operand
     * @returns the current updated Color4
     */ maximizeInPlaceFromFloats(r, g, b, a) {
        this.r = Math.max(r, this.r);
        this.g = Math.max(g, this.g);
        this.b = Math.max(b, this.b);
        this.a = Math.max(a, this.a);
        return this;
    }
    /**
     * @internal
     * Do not use
     */ floorToRef(_result) {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ floor() {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ fractToRef(_result) {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * @internal
     * Do not use
     */ fract() {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * @internal
     * Do not use
     */ negate() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateInPlace() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateToRef(_result) {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * Boolean : True if the current Color4 coordinates are each beneath the distance "epsilon" from the given color ones.
     * @param otherColor color to compare against
     * @param epsilon (Default: very small number)
     * @returns true if they are equal
     */ equalsWithEpsilon(otherColor, epsilon = (0, $53VPf.Epsilon)) {
        return (0, $iosaP.WithinEpsilon)(this.r, otherColor.r, epsilon) && (0, $iosaP.WithinEpsilon)(this.g, otherColor.g, epsilon) && (0, $iosaP.WithinEpsilon)(this.b, otherColor.b, epsilon) && (0, $iosaP.WithinEpsilon)(this.a, otherColor.a, epsilon);
    }
    /**
     * Boolean : True if the given floats are strictly equal to the current Color4 coordinates.
     * @param x x value to compare against
     * @param y y value to compare against
     * @param z z value to compare against
     * @param w w value to compare against
     * @returns true if equal
     */ equalsToFloats(x, y, z, w) {
        return this.r === x && this.g === y && this.b === z && this.a === w;
    }
    /**
     * Creates a string with the Color4 current values
     * @returns the string representation of the Color4 object
     */ toString() {
        return "{R: " + this.r + " G:" + this.g + " B:" + this.b + " A:" + this.a + "}";
    }
    /**
     * Returns the string "Color4"
     * @returns "Color4"
     */ getClassName() {
        return "Color4";
    }
    /**
     * Compute the Color4 hash code
     * @returns an unique number that can be used to hash Color4 objects
     */ getHashCode() {
        let hash = this.r * 255 | 0;
        hash = hash * 397 ^ (this.g * 255 | 0);
        hash = hash * 397 ^ (this.b * 255 | 0);
        hash = hash * 397 ^ (this.a * 255 | 0);
        return hash;
    }
    /**
     * Creates a new Color4 copied from the current one
     * @returns a new Color4 object
     */ clone() {
        const result = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        return result.copyFrom(this);
    }
    /**
     * Copies the given Color4 values into the current one
     * @param source defines the source Color4 object
     * @returns the current updated Color4 object
     */ copyFrom(source) {
        this.r = source.r;
        this.g = source.g;
        this.b = source.b;
        this.a = source.a;
        return this;
    }
    /**
     * Copies the given float values into the current one
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @param a defines the alpha component to read from
     * @returns the current updated Color4 object
     */ copyFromFloats(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this;
    }
    /**
     * Copies the given float values into the current one
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @param a defines the alpha component to read from
     * @returns the current updated Color4 object
     */ set(r, g, b, a) {
        return this.copyFromFloats(r, g, b, a);
    }
    /**
     * Copies the given float to the current Vector4 coordinates
     * @param v defines the r, g, b, and a coordinates of the operand
     * @returns the current updated Vector4
     */ setAll(v) {
        this.r = this.g = this.b = this.a = v;
        return this;
    }
    /**
     * Compute the Color4 hexadecimal code as a string
     * @param returnAsColor3 defines if the string should only contains RGB values (off by default)
     * @returns a string containing the hexadecimal representation of the Color4 object
     */ toHexString(returnAsColor3 = false) {
        const intR = Math.round(this.r * 255);
        const intG = Math.round(this.g * 255);
        const intB = Math.round(this.b * 255);
        if (returnAsColor3) return "#" + (0, $iosaP.ToHex)(intR) + (0, $iosaP.ToHex)(intG) + (0, $iosaP.ToHex)(intB);
        const intA = Math.round(this.a * 255);
        return "#" + (0, $iosaP.ToHex)(intR) + (0, $iosaP.ToHex)(intG) + (0, $iosaP.ToHex)(intB) + (0, $iosaP.ToHex)(intA);
    }
    /**
     * Updates the Color4 rgba values from the string containing valid hexadecimal values.
     *
     * A valid hex string is either in the format #RRGGBB or #RRGGBBAA.
     *
     * When a hex string without alpha is passed, the resulting Color4 keeps
     * its previous alpha value.
     *
     * An invalid string does not modify this object
     *
     * @param hex defines a string containing valid hexadecimal values
     * @returns the current updated Color4 object
     */ fromHexString(hex) {
        if (hex.substring(0, 1) !== "#" || hex.length !== 9 && hex.length !== 7) return this;
        this.r = parseInt(hex.substring(1, 3), 16) / 255;
        this.g = parseInt(hex.substring(3, 5), 16) / 255;
        this.b = parseInt(hex.substring(5, 7), 16) / 255;
        if (hex.length === 9) this.a = parseInt(hex.substring(7, 9), 16) / 255;
        return this;
    }
    /**
     * Computes a new Color4 converted from the current one to linear space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color4 object
     */ toLinearSpace(exact = false) {
        const convertedColor = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        this.toLinearSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color4 values to linear space and stores the result in "convertedColor"
     * @param convertedColor defines the Color4 object where to store the linear space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color4
     */ toLinearSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.b);
        }
        convertedColor.a = this.a;
        return this;
    }
    /**
     * Computes a new Color4 converted from the current one to gamma space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color4 object
     */ toGammaSpace(exact = false) {
        const convertedColor = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        this.toGammaSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color4 values to gamma space and stores the result in "convertedColor"
     * @param convertedColor defines the Color4 object where to store the gamma space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color4
     */ toGammaSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.b);
        }
        convertedColor.a = this.a;
        return this;
    }
    // Statics
    /**
     * Creates a new Color4 from the string containing valid hexadecimal values.
     *
     * A valid hex string is either in the format #RRGGBB or #RRGGBBAA.
     *
     * When a hex string without alpha is passed, the resulting Color4 has
     * its alpha value set to 1.0.
     *
     * An invalid string results in a Color with all its channels set to 0.0,
     * i.e. "transparent black".
     *
     * @param hex defines a string containing valid hexadecimal values
     * @returns a new Color4 object
     */ static FromHexString(hex) {
        if (hex.substring(0, 1) !== "#" || hex.length !== 9 && hex.length !== 7) return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0.0, 0.0, 0.0, 0.0);
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0.0, 0.0, 0.0, 1.0).fromHexString(hex);
    }
    /**
     * Creates a new Color4 object set with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
     * @param left defines the start value
     * @param right defines the end value
     * @param amount defines the gradient factor
     * @returns a new Color4 object
     */ static Lerp(left, right, amount) {
        return $5440a29da7c4a7fe$export$cb7e366859c95cb0.LerpToRef(left, right, amount, new $5440a29da7c4a7fe$export$cb7e366859c95cb0());
    }
    /**
     * Set the given "result" with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
     * @param left defines the start value
     * @param right defines the end value
     * @param amount defines the gradient factor
     * @param result defines the Color4 object where to store data
     * @returns the updated result
     */ static LerpToRef(left, right, amount, result) {
        result.r = left.r + (right.r - left.r) * amount;
        result.g = left.g + (right.g - left.g) * amount;
        result.b = left.b + (right.b - left.b) * amount;
        result.a = left.a + (right.a - left.a) * amount;
        return result;
    }
    /**
     * Interpolate between two Color4 using Hermite interpolation
     * @param value1 defines first Color4
     * @param tangent1 defines the incoming tangent
     * @param value2 defines second Color4
     * @param tangent2 defines the outgoing tangent
     * @param amount defines the target Color4
     * @returns the new interpolated Color4
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const r = value1.r * part1 + value2.r * part2 + tangent1.r * part3 + tangent2.r * part4;
        const g = value1.g * part1 + value2.g * part2 + tangent1.g * part3 + tangent2.g * part4;
        const b = value1.b * part1 + value2.b * part2 + tangent1.b * part3 + tangent2.b * part4;
        const a = value1.a * part1 + value2.a * part2 + tangent1.a * part3 + tangent2.a * part4;
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(r, g, b, a);
    }
    /**
     * Returns a new Color4 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Update a Color4 with the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result.r = (t2 - time) * 6 * value1.r + (3 * t2 - 4 * time + 1) * tangent1.r + (-t2 + time) * 6 * value2.r + (3 * t2 - 2 * time) * tangent2.r;
        result.g = (t2 - time) * 6 * value1.g + (3 * t2 - 4 * time + 1) * tangent1.g + (-t2 + time) * 6 * value2.g + (3 * t2 - 2 * time) * tangent2.g;
        result.b = (t2 - time) * 6 * value1.b + (3 * t2 - 4 * time + 1) * tangent1.b + (-t2 + time) * 6 * value2.b + (3 * t2 - 2 * time) * tangent2.b;
        result.a = (t2 - time) * 6 * value1.a + (3 * t2 - 4 * time + 1) * tangent1.a + (-t2 + time) * 6 * value2.a + (3 * t2 - 2 * time) * tangent2.a;
    }
    /**
     * Creates a new Color4 from a Color3 and an alpha value
     * @param color3 defines the source Color3 to read from
     * @param alpha defines the alpha component (1.0 by default)
     * @returns a new Color4 object
     */ static FromColor3(color3, alpha = 1.0) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(color3.r, color3.g, color3.b, alpha);
    }
    /**
     * Creates a new Color4 from the starting index element of the given array
     * @param array defines the source array to read from
     * @param offset defines the offset in the source array
     * @returns a new Color4 object
     */ static FromArray(array, offset = 0) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    }
    /**
     * Creates a new Color4 from the starting index element of the given array
     * @param array defines the source array to read from
     * @param offset defines the offset in the source array
     * @param result defines the target Color4 object
     */ static FromArrayToRef(array, offset = 0, result) {
        result.r = array[offset];
        result.g = array[offset + 1];
        result.b = array[offset + 2];
        result.a = array[offset + 3];
    }
    /**
     * Creates a new Color3 from integer values (less than 256)
     * @param r defines the red component to read from (value between 0 and 255)
     * @param g defines the green component to read from (value between 0 and 255)
     * @param b defines the blue component to read from (value between 0 and 255)
     * @param a defines the alpha component to read from (value between 0 and 255)
     * @returns a new Color3 object
     */ static FromInts(r, g, b, a) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(r / 255.0, g / 255.0, b / 255.0, a / 255.0);
    }
    /**
     * Check the content of a given array and convert it to an array containing RGBA data
     * If the original array was already containing count * 4 values then it is returned directly
     * @param colors defines the array to check
     * @param count defines the number of RGBA data to expect
     * @returns an array containing count * 4 values (RGBA)
     */ static CheckColors4(colors, count) {
        // Check if color3 was used
        if (colors.length === count * 3) {
            const colors4 = [];
            for(let index = 0; index < colors.length; index += 3){
                const newIndex = index / 3 * 4;
                colors4[newIndex] = colors[index];
                colors4[newIndex + 1] = colors[index + 1];
                colors4[newIndex + 2] = colors[index + 2];
                colors4[newIndex + 3] = 1.0;
            }
            return colors4;
        }
        return colors;
    }
}
/**
 * If the first color is flagged with integers (as everything is 0,0,0,0), V8 stores all of the properties as integers internally because it doesn't know any better yet.
 * If subsequent colors are created with non-integer values, V8 determines that it would be best to represent these properties as doubles instead of integers,
 * and henceforth it will use floating-point representation for all color instances that it creates.
 * But the original color instances are unchanged and has a "deprecated map".
 * If we keep using the color instances from step 1, it will now be a poison pill which will mess up optimizations in any code it touches.
 */ $5440a29da7c4a7fe$export$cb7e366859c95cb0._V8PerformanceHack = new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0.5, 0.5, 0.5, 0.5);
Object.defineProperties($5440a29da7c4a7fe$export$cb7e366859c95cb0.prototype, {
    dimension: {
        value: [
            4
        ]
    },
    rank: {
        value: 1
    }
});
class $5440a29da7c4a7fe$export$22fd4211f9ff6a1d {
}
$5440a29da7c4a7fe$export$22fd4211f9ff6a1d.Color3 = (0, $opFp4.BuildArray)(3, $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.Black);
$5440a29da7c4a7fe$export$22fd4211f9ff6a1d.Color4 = (0, $opFp4.BuildArray)(3, ()=>new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0, 0, 0, 0));
(0, $8DoUR.RegisterClass)("BABYLON.Color3", $5440a29da7c4a7fe$export$b3ff593cf6d17bf0);
(0, $8DoUR.RegisterClass)("BABYLON.Color4", $5440a29da7c4a7fe$export$cb7e366859c95cb0);

});

parcelRegister("eVS9r", function(module, exports) {

$parcel$export(module.exports, "ColorCurves", () => $adf064e0a7b4f422$export$d937e9ba5e5dab2f);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $7etnY = parcelRequire("7etnY");

var $6Ho1L = parcelRequire("6Ho1L");

var $k0jl7 = parcelRequire("k0jl7");
class $adf064e0a7b4f422$export$d937e9ba5e5dab2f {
    constructor(){
        this._dirty = true;
        this._tempColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._globalCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._highlightsCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._midtonesCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._shadowsCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._positiveCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._negativeCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._globalHue = 30;
        this._globalDensity = 0;
        this._globalSaturation = 0;
        this._globalExposure = 0;
        this._highlightsHue = 30;
        this._highlightsDensity = 0;
        this._highlightsSaturation = 0;
        this._highlightsExposure = 0;
        this._midtonesHue = 30;
        this._midtonesDensity = 0;
        this._midtonesSaturation = 0;
        this._midtonesExposure = 0;
        this._shadowsHue = 30;
        this._shadowsDensity = 0;
        this._shadowsSaturation = 0;
        this._shadowsExposure = 0;
    }
    /**
     * Gets the global Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get globalHue() {
        return this._globalHue;
    }
    /**
     * Sets the global Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set globalHue(value) {
        this._globalHue = value;
        this._dirty = true;
    }
    /**
     * Gets the global Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get globalDensity() {
        return this._globalDensity;
    }
    /**
     * Sets the global Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set globalDensity(value) {
        this._globalDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the global Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get globalSaturation() {
        return this._globalSaturation;
    }
    /**
     * Sets the global Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set globalSaturation(value) {
        this._globalSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the global Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get globalExposure() {
        return this._globalExposure;
    }
    /**
     * Sets the global Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set globalExposure(value) {
        this._globalExposure = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get highlightsHue() {
        return this._highlightsHue;
    }
    /**
     * Sets the highlights Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set highlightsHue(value) {
        this._highlightsHue = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get highlightsDensity() {
        return this._highlightsDensity;
    }
    /**
     * Sets the highlights Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set highlightsDensity(value) {
        this._highlightsDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get highlightsSaturation() {
        return this._highlightsSaturation;
    }
    /**
     * Sets the highlights Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set highlightsSaturation(value) {
        this._highlightsSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get highlightsExposure() {
        return this._highlightsExposure;
    }
    /**
     * Sets the highlights Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set highlightsExposure(value) {
        this._highlightsExposure = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get midtonesHue() {
        return this._midtonesHue;
    }
    /**
     * Sets the midtones Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set midtonesHue(value) {
        this._midtonesHue = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get midtonesDensity() {
        return this._midtonesDensity;
    }
    /**
     * Sets the midtones Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set midtonesDensity(value) {
        this._midtonesDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get midtonesSaturation() {
        return this._midtonesSaturation;
    }
    /**
     * Sets the midtones Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set midtonesSaturation(value) {
        this._midtonesSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get midtonesExposure() {
        return this._midtonesExposure;
    }
    /**
     * Sets the midtones Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set midtonesExposure(value) {
        this._midtonesExposure = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get shadowsHue() {
        return this._shadowsHue;
    }
    /**
     * Sets the shadows Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set shadowsHue(value) {
        this._shadowsHue = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get shadowsDensity() {
        return this._shadowsDensity;
    }
    /**
     * Sets the shadows Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set shadowsDensity(value) {
        this._shadowsDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get shadowsSaturation() {
        return this._shadowsSaturation;
    }
    /**
     * Sets the shadows Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set shadowsSaturation(value) {
        this._shadowsSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get shadowsExposure() {
        return this._shadowsExposure;
    }
    /**
     * Sets the shadows Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set shadowsExposure(value) {
        this._shadowsExposure = value;
        this._dirty = true;
    }
    /**
     * Returns the class name
     * @returns The class name
     */ getClassName() {
        return "ColorCurves";
    }
    /**
     * Binds the color curves to the shader.
     * @param colorCurves The color curve to bind
     * @param effect The effect to bind to
     * @param positiveUniform The positive uniform shader parameter
     * @param neutralUniform The neutral uniform shader parameter
     * @param negativeUniform The negative uniform shader parameter
     */ static Bind(colorCurves, effect, positiveUniform = "vCameraColorCurvePositive", neutralUniform = "vCameraColorCurveNeutral", negativeUniform = "vCameraColorCurveNegative") {
        if (colorCurves._dirty) {
            colorCurves._dirty = false;
            // Fill in global info.
            colorCurves._getColorGradingDataToRef(colorCurves._globalHue, colorCurves._globalDensity, colorCurves._globalSaturation, colorCurves._globalExposure, colorCurves._globalCurve);
            // Compute highlights info.
            colorCurves._getColorGradingDataToRef(colorCurves._highlightsHue, colorCurves._highlightsDensity, colorCurves._highlightsSaturation, colorCurves._highlightsExposure, colorCurves._tempColor);
            colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._highlightsCurve);
            // Compute midtones info.
            colorCurves._getColorGradingDataToRef(colorCurves._midtonesHue, colorCurves._midtonesDensity, colorCurves._midtonesSaturation, colorCurves._midtonesExposure, colorCurves._tempColor);
            colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._midtonesCurve);
            // Compute shadows info.
            colorCurves._getColorGradingDataToRef(colorCurves._shadowsHue, colorCurves._shadowsDensity, colorCurves._shadowsSaturation, colorCurves._shadowsExposure, colorCurves._tempColor);
            colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._shadowsCurve);
            // Compute deltas (neutral is midtones).
            colorCurves._highlightsCurve.subtractToRef(colorCurves._midtonesCurve, colorCurves._positiveCurve);
            colorCurves._midtonesCurve.subtractToRef(colorCurves._shadowsCurve, colorCurves._negativeCurve);
        }
        if (effect) {
            effect.setFloat4(positiveUniform, colorCurves._positiveCurve.r, colorCurves._positiveCurve.g, colorCurves._positiveCurve.b, colorCurves._positiveCurve.a);
            effect.setFloat4(neutralUniform, colorCurves._midtonesCurve.r, colorCurves._midtonesCurve.g, colorCurves._midtonesCurve.b, colorCurves._midtonesCurve.a);
            effect.setFloat4(negativeUniform, colorCurves._negativeCurve.r, colorCurves._negativeCurve.g, colorCurves._negativeCurve.b, colorCurves._negativeCurve.a);
        }
    }
    /**
     * Returns color grading data based on a hue, density, saturation and exposure value.
     * @param hue
     * @param density
     * @param saturation The saturation.
     * @param exposure The exposure.
     * @param result The result data container.
     */ _getColorGradingDataToRef(hue, density, saturation, exposure, result) {
        if (hue == null) return;
        hue = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(hue, 0, 360);
        density = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(density, -100, 100);
        saturation = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(saturation, -100, 100);
        exposure = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(exposure, -100, 100);
        // Remap the slider/config filter density with non-linear mapping and also scale by half
        // so that the maximum filter density is only 50% control. This provides fine control
        // for small values and reasonable range.
        density = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._ApplyColorGradingSliderNonlinear(density);
        density *= 0.5;
        exposure = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._ApplyColorGradingSliderNonlinear(exposure);
        if (density < 0) {
            density *= -1;
            hue = (hue + 180) % 360;
        }
        $adf064e0a7b4f422$export$d937e9ba5e5dab2f._FromHSBToRef(hue, density, 50 + 0.25 * exposure, result);
        result.scaleToRef(2, result);
        result.a = 1 + 0.01 * saturation;
    }
    /**
     * Takes an input slider value and returns an adjusted value that provides extra control near the centre.
     * @param value The input slider value in range [-100,100].
     * @returns Adjusted value.
     */ static _ApplyColorGradingSliderNonlinear(value) {
        value /= 100;
        let x = Math.abs(value);
        x = Math.pow(x, 2);
        if (value < 0) x *= -1;
        x *= 100;
        return x;
    }
    /**
     * Returns an RGBA Color4 based on Hue, Saturation and Brightness (also referred to as value, HSV).
     * @param hue The hue (H) input.
     * @param saturation The saturation (S) input.
     * @param brightness The brightness (B) input.
     * @param result
     * @result An RGBA color represented as Vector4.
     */ static _FromHSBToRef(hue, saturation, brightness, result) {
        let h = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(hue, 0, 360);
        const s = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(saturation / 100, 0, 1);
        const v = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(brightness / 100, 0, 1);
        if (s === 0) {
            result.r = v;
            result.g = v;
            result.b = v;
        } else {
            // sector 0 to 5
            h /= 60;
            const i = Math.floor(h);
            // fractional part of h
            const f = h - i;
            const p = v * (1 - s);
            const q = v * (1 - s * f);
            const t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    result.r = v;
                    result.g = t;
                    result.b = p;
                    break;
                case 1:
                    result.r = q;
                    result.g = v;
                    result.b = p;
                    break;
                case 2:
                    result.r = p;
                    result.g = v;
                    result.b = t;
                    break;
                case 3:
                    result.r = p;
                    result.g = q;
                    result.b = v;
                    break;
                case 4:
                    result.r = t;
                    result.g = p;
                    result.b = v;
                    break;
                default:
                    // case 5:
                    result.r = v;
                    result.g = p;
                    result.b = q;
                    break;
            }
        }
        result.a = 1;
    }
    /**
     * Returns a value clamped between min and max
     * @param value The value to clamp
     * @param min The minimum of value
     * @param max The maximum of value
     * @returns The clamped value.
     */ static _Clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }
    /**
     * Clones the current color curve instance.
     * @returns The cloned curves
     */ clone() {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>new $adf064e0a7b4f422$export$d937e9ba5e5dab2f(), this);
    }
    /**
     * Serializes the current color curve instance to a json representation.
     * @returns a JSON representation
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses the color curve from a json representation.
     * @param source the JSON source to parse
     * @returns The parsed curves
     */ static Parse(source) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $adf064e0a7b4f422$export$d937e9ba5e5dab2f(), source, null, null);
    }
}
/**
 * Prepare the list of uniforms associated with the ColorCurves effects.
 * @param uniformsList The list of uniforms used in the effect
 */ $adf064e0a7b4f422$export$d937e9ba5e5dab2f.PrepareUniforms = (0, $k0jl7.PrepareUniformsForColorCurves);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalHue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalDensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalSaturation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalExposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsHue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsDensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsSaturation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsExposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesHue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesDensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesSaturation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesExposure", void 0);
// References the dependencies.
(0, $6Ho1L.SerializationHelper)._ColorCurvesParser = $adf064e0a7b4f422$export$d937e9ba5e5dab2f.Parse;

});
parcelRegister("6Ho1L", function(module, exports) {

$parcel$export(module.exports, "SerializationHelper", () => $4e09659a684f09ce$export$fa3e9fa0be4352ce);

var $dUFYy = parcelRequire("dUFYy");

var $7212E = parcelRequire("7212E");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $225Mx = parcelRequire("225Mx");
const $4e09659a684f09ce$var$_copySource = function(creationFunction, source, instanciate, options = {}) {
    const destination = creationFunction();
    // Tags
    if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(source)) (0, $7212E.Tags).AddTagsTo(destination, (0, $7212E.Tags).GetTags(source, true));
    const classStore = (0, $225Mx.GetMergedStore)(destination);
    // Map from source texture uniqueId to destination texture
    const textureMap = {};
    // Properties
    for(const property in classStore){
        const propertyDescriptor = classStore[property];
        const sourceProperty = source[property];
        const propertyType = propertyDescriptor.type;
        if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId)) switch(propertyType){
            case 0:
            case 6:
            case 9:
            case 11:
                destination[property] = sourceProperty;
                break;
            case 1:
                if (options.cloneTexturesOnlyOnce && textureMap[sourceProperty.uniqueId]) destination[property] = textureMap[sourceProperty.uniqueId];
                else {
                    destination[property] = instanciate || sourceProperty.isRenderTarget ? sourceProperty : sourceProperty.clone();
                    textureMap[sourceProperty.uniqueId] = destination[property];
                }
                break;
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                destination[property] = instanciate ? sourceProperty : sourceProperty.clone();
                break;
        }
    }
    return destination;
};
class $4e09659a684f09ce$export$fa3e9fa0be4352ce {
    /**
     * Appends the serialized animations from the source animations
     * @param source Source containing the animations
     * @param destination Target to store the animations
     */ static AppendSerializedAnimations(source, destination) {
        if (source.animations) {
            destination.animations = [];
            for(let animationIndex = 0; animationIndex < source.animations.length; animationIndex++){
                const animation = source.animations[animationIndex];
                destination.animations.push(animation.serialize());
            }
        }
    }
    /**
     * Static function used to serialized a specific entity
     * @param entity defines the entity to serialize
     * @param serializationObject defines the optional target object where serialization data will be stored
     * @returns a JSON compatible object representing the serialization of the entity
     */ static Serialize(entity, serializationObject) {
        if (!serializationObject) serializationObject = {};
        // Tags
        if (0, $7212E.Tags) serializationObject.tags = (0, $7212E.Tags).GetTags(entity);
        const serializedProperties = (0, $225Mx.GetMergedStore)(entity);
        // Properties
        for(const property in serializedProperties){
            const propertyDescriptor = serializedProperties[property];
            const targetPropertyName = propertyDescriptor.sourceName || property;
            const propertyType = propertyDescriptor.type;
            const sourceProperty = entity[property];
            if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId)) switch(propertyType){
                case 0:
                    serializationObject[targetPropertyName] = sourceProperty;
                    break;
                case 1:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 2:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 3:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 4:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 5:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 6:
                    serializationObject[targetPropertyName] = sourceProperty.id;
                    break;
                case 7:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 8:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 9:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 10:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 11:
                    serializationObject[targetPropertyName] = sourceProperty.id;
                    break;
                case 12:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
            }
        }
        return serializationObject;
    }
    /**
     * Given a source json and a destination object in a scene, this function will parse the source and will try to apply its content to the destination object
     * @param source the source json data
     * @param destination the destination object
     * @param scene the scene where the object is
     * @param rootUrl root url to use to load assets
     */ static ParseProperties(source, destination, scene, rootUrl) {
        if (!rootUrl) rootUrl = "";
        const classStore = (0, $225Mx.GetMergedStore)(destination);
        // Properties
        for(const property in classStore){
            const propertyDescriptor = classStore[property];
            const sourceProperty = source[propertyDescriptor.sourceName || property];
            const propertyType = propertyDescriptor.type;
            if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId)) {
                const dest = destination;
                switch(propertyType){
                    case 0:
                        dest[property] = sourceProperty;
                        break;
                    case 1:
                        if (scene) dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._TextureParser(sourceProperty, scene, rootUrl);
                        break;
                    case 2:
                        dest[property] = (0, $7etnY.Color3).FromArray(sourceProperty);
                        break;
                    case 3:
                        dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._FresnelParametersParser(sourceProperty);
                        break;
                    case 4:
                        dest[property] = (0, $ha1VO.Vector2).FromArray(sourceProperty);
                        break;
                    case 5:
                        dest[property] = (0, $ha1VO.Vector3).FromArray(sourceProperty);
                        break;
                    case 6:
                        if (scene) dest[property] = scene.getLastMeshById(sourceProperty);
                        break;
                    case 7:
                        dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._ColorCurvesParser(sourceProperty);
                        break;
                    case 8:
                        dest[property] = (0, $7etnY.Color4).FromArray(sourceProperty);
                        break;
                    case 9:
                        dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._ImageProcessingConfigurationParser(sourceProperty);
                        break;
                    case 10:
                        dest[property] = (0, $ha1VO.Quaternion).FromArray(sourceProperty);
                        break;
                    case 11:
                        if (scene) dest[property] = scene.getCameraById(sourceProperty);
                        break;
                    case 12:
                        dest[property] = (0, $ha1VO.Matrix).FromArray(sourceProperty);
                        break;
                }
            }
        }
    }
    /**
     * Creates a new entity from a serialization data object
     * @param creationFunction defines a function used to instanciated the new entity
     * @param source defines the source serialization data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root url for resources
     * @returns a new entity
     */ static Parse(creationFunction, source, scene, rootUrl = null) {
        const destination = creationFunction();
        // Tags
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(destination, source.tags);
        $4e09659a684f09ce$export$fa3e9fa0be4352ce.ParseProperties(source, destination, scene, rootUrl);
        return destination;
    }
    /**
     * Clones an object
     * @param creationFunction defines the function used to instanciate the new object
     * @param source defines the source object
     * @param options defines the options to use
     * @returns the cloned object
     */ static Clone(creationFunction, source, options = {}) {
        return $4e09659a684f09ce$var$_copySource(creationFunction, source, false, options);
    }
    /**
     * Instanciates a new object based on a source one (some data will be shared between both object)
     * @param creationFunction defines the function used to instanciate the new object
     * @param source defines the source object
     * @returns the new object
     */ static Instanciate(creationFunction, source) {
        return $4e09659a684f09ce$var$_copySource(creationFunction, source, true);
    }
}
/**
 * Gets or sets a boolean to indicate if the UniqueId property should be serialized
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId = false;
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._ImageProcessingConfigurationParser = (sourceProperty)=>{
    throw (0, $dUFYy._WarnImport)("ImageProcessingConfiguration");
};
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._FresnelParametersParser = (sourceProperty)=>{
    throw (0, $dUFYy._WarnImport)("FresnelParameters");
};
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._ColorCurvesParser = (sourceProperty)=>{
    throw (0, $dUFYy._WarnImport)("ColorCurves");
};
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._TextureParser = (sourceProperty, scene, rootUrl)=>{
    throw (0, $dUFYy._WarnImport)("Texture");
};

});

parcelRegister("k0jl7", function(module, exports) {

$parcel$export(module.exports, "PrepareUniformsForColorCurves", () => $e902cf2db572083d$export$e4309b6d5d5a2775);
/**
 * Prepare the list of uniforms associated with the ColorCurves effects.
 * @param uniformsList The list of uniforms used in the effect
 */ function $e902cf2db572083d$export$e4309b6d5d5a2775(uniformsList) {
    uniformsList.push("vCameraColorCurveNeutral", "vCameraColorCurvePositive", "vCameraColorCurveNegative");
}

});


parcelRegister("ePyUi", function(module, exports) {

$parcel$export(module.exports, "PrepareUniformsForImageProcessing", () => $acc0e7edf62b6ca4$export$15e1616224800f0e);
$parcel$export(module.exports, "PrepareSamplersForImageProcessing", () => $acc0e7edf62b6ca4$export$c032d5c993ceb4aa);

var $k0jl7 = parcelRequire("k0jl7");
function $acc0e7edf62b6ca4$export$15e1616224800f0e(uniforms, defines) {
    if (defines.EXPOSURE) uniforms.push("exposureLinear");
    if (defines.CONTRAST) uniforms.push("contrast");
    if (defines.COLORGRADING) uniforms.push("colorTransformSettings");
    if (defines.VIGNETTE || defines.DITHER) uniforms.push("vInverseScreenSize");
    if (defines.VIGNETTE) {
        uniforms.push("vignetteSettings1");
        uniforms.push("vignetteSettings2");
    }
    if (defines.COLORCURVES) (0, $k0jl7.PrepareUniformsForColorCurves)(uniforms);
    if (defines.DITHER) uniforms.push("ditherIntensity");
}
function $acc0e7edf62b6ca4$export$c032d5c993ceb4aa(samplersList, defines) {
    if (defines.COLORGRADING) samplersList.push("txColorTransform");
}

});


parcelRegister("ghoTi", function(module, exports) {

$parcel$export(module.exports, "UniformBuffer", () => $bda18ab409280b95$export$e0b4e5723e07d1e5);

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");
class $bda18ab409280b95$export$e0b4e5723e07d1e5 {
    /**
     * Instantiates a new Uniform buffer objects.
     *
     * Handles blocks of uniform on the GPU.
     *
     * If WebGL 2 is not available, this class falls back on traditional setUniformXXX calls.
     *
     * For more information, please refer to :
     * @see https://www.khronos.org/opengl/wiki/Uniform_Buffer_Object
     * @param engine Define the engine the buffer is associated with
     * @param data Define the data contained in the buffer
     * @param dynamic Define if the buffer is updatable
     * @param name to assign to the buffer (debugging purpose)
     * @param forceNoUniformBuffer define that this object must not rely on UBO objects
     */ constructor(engine, data, dynamic, name, forceNoUniformBuffer = false){
        // Matrix cache
        this._valueCache = {};
        this._engine = engine;
        this._noUBO = !engine.supportsUniformBuffers || forceNoUniformBuffer;
        this._dynamic = dynamic;
        this._name = name ?? "no-name";
        this._data = data || [];
        this._uniformLocations = {};
        this._uniformSizes = {};
        this._uniformArraySizes = {};
        this._uniformLocationPointer = 0;
        this._needSync = false;
        if (this._engine._features.trackUbosInFrame) {
            this._buffers = [];
            this._bufferIndex = -1;
            this._createBufferOnWrite = false;
            this._currentFrameId = 0;
        }
        if (this._noUBO) {
            this.updateMatrix3x3 = this._updateMatrix3x3ForEffect;
            this.updateMatrix2x2 = this._updateMatrix2x2ForEffect;
            this.updateFloat = this._updateFloatForEffect;
            this.updateFloat2 = this._updateFloat2ForEffect;
            this.updateFloat3 = this._updateFloat3ForEffect;
            this.updateFloat4 = this._updateFloat4ForEffect;
            this.updateFloatArray = this._updateFloatArrayForEffect;
            this.updateArray = this._updateArrayForEffect;
            this.updateIntArray = this._updateIntArrayForEffect;
            this.updateUIntArray = this._updateUIntArrayForEffect;
            this.updateMatrix = this._updateMatrixForEffect;
            this.updateMatrices = this._updateMatricesForEffect;
            this.updateVector3 = this._updateVector3ForEffect;
            this.updateVector4 = this._updateVector4ForEffect;
            this.updateColor3 = this._updateColor3ForEffect;
            this.updateColor4 = this._updateColor4ForEffect;
            this.updateDirectColor4 = this._updateDirectColor4ForEffect;
            this.updateInt = this._updateIntForEffect;
            this.updateInt2 = this._updateInt2ForEffect;
            this.updateInt3 = this._updateInt3ForEffect;
            this.updateInt4 = this._updateInt4ForEffect;
            this.updateUInt = this._updateUIntForEffect;
            this.updateUInt2 = this._updateUInt2ForEffect;
            this.updateUInt3 = this._updateUInt3ForEffect;
            this.updateUInt4 = this._updateUInt4ForEffect;
        } else {
            this._engine._uniformBuffers.push(this);
            this.updateMatrix3x3 = this._updateMatrix3x3ForUniform;
            this.updateMatrix2x2 = this._updateMatrix2x2ForUniform;
            this.updateFloat = this._updateFloatForUniform;
            this.updateFloat2 = this._updateFloat2ForUniform;
            this.updateFloat3 = this._updateFloat3ForUniform;
            this.updateFloat4 = this._updateFloat4ForUniform;
            this.updateFloatArray = this._updateFloatArrayForUniform;
            this.updateArray = this._updateArrayForUniform;
            this.updateIntArray = this._updateIntArrayForUniform;
            this.updateUIntArray = this._updateUIntArrayForUniform;
            this.updateMatrix = this._updateMatrixForUniform;
            this.updateMatrices = this._updateMatricesForUniform;
            this.updateVector3 = this._updateVector3ForUniform;
            this.updateVector4 = this._updateVector4ForUniform;
            this.updateColor3 = this._updateColor3ForUniform;
            this.updateColor4 = this._updateColor4ForUniform;
            this.updateDirectColor4 = this._updateDirectColor4ForUniform;
            this.updateInt = this._updateIntForUniform;
            this.updateInt2 = this._updateInt2ForUniform;
            this.updateInt3 = this._updateInt3ForUniform;
            this.updateInt4 = this._updateInt4ForUniform;
            this.updateUInt = this._updateUIntForUniform;
            this.updateUInt2 = this._updateUInt2ForUniform;
            this.updateUInt3 = this._updateUInt3ForUniform;
            this.updateUInt4 = this._updateUInt4ForUniform;
        }
    }
    /**
     * Indicates if the buffer is using the WebGL2 UBO implementation,
     * or just falling back on setUniformXXX calls.
     */ get useUbo() {
        return !this._noUBO;
    }
    /**
     * Indicates if the WebGL underlying uniform buffer is in sync
     * with the javascript cache data.
     */ get isSync() {
        return !this._needSync;
    }
    /**
     * Indicates if the WebGL underlying uniform buffer is dynamic.
     * Also, a dynamic UniformBuffer will disable cache verification and always
     * update the underlying WebGL uniform buffer to the GPU.
     * @returns if Dynamic, otherwise false
     */ isDynamic() {
        return this._dynamic !== undefined;
    }
    /**
     * The data cache on JS side.
     * @returns the underlying data as a float array
     */ getData() {
        return this._bufferData;
    }
    /**
     * The underlying WebGL Uniform buffer.
     * @returns the webgl buffer
     */ getBuffer() {
        return this._buffer;
    }
    /**
     * std140 layout specifies how to align data within an UBO structure.
     * See https://khronos.org/registry/OpenGL/specs/gl/glspec45.core.pdf#page=159
     * for specs.
     * @param size
     */ _fillAlignment(size) {
        // This code has been simplified because we only use floats, vectors of 1, 2, 3, 4 components
        // and 4x4 matrices
        // TODO : change if other types are used
        let alignment;
        if (size <= 2) alignment = size;
        else alignment = 4;
        if (this._uniformLocationPointer % alignment !== 0) {
            const oldPointer = this._uniformLocationPointer;
            this._uniformLocationPointer += alignment - this._uniformLocationPointer % alignment;
            const diff = this._uniformLocationPointer - oldPointer;
            for(let i = 0; i < diff; i++)this._data.push(0);
        }
    }
    /**
     * Adds an uniform in the buffer.
     * Warning : the subsequents calls of this function must be in the same order as declared in the shader
     * for the layout to be correct ! The addUniform function only handles types like float, vec2, vec3, vec4, mat4,
     * meaning size=1,2,3,4 or 16. It does not handle struct types.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param size Data size, or data directly.
     * @param arraySize The number of elements in the array, 0 if not an array.
     */ addUniform(name, size, arraySize = 0) {
        if (this._noUBO) return;
        if (this._uniformLocations[name] !== undefined) // Already existing uniform
        return;
        // This function must be called in the order of the shader layout !
        // size can be the size of the uniform, or data directly
        let data;
        // std140 FTW...
        if (arraySize > 0) {
            if (size instanceof Array) // eslint-disable-next-line no-throw-literal
            throw "addUniform should not be use with Array in UBO: " + name;
            this._fillAlignment(4);
            this._uniformArraySizes[name] = {
                strideSize: size,
                arraySize: arraySize
            };
            if (size == 16) size = size * arraySize;
            else {
                const perElementPadding = 4 - size;
                const totalPadding = perElementPadding * arraySize;
                size = size * arraySize + totalPadding;
            }
            data = [];
            // Fill with zeros
            for(let i = 0; i < size; i++)data.push(0);
        } else {
            if (size instanceof Array) {
                data = size;
                size = data.length;
            } else {
                size;
                data = [];
                // Fill with zeros
                for(let i = 0; i < size; i++)data.push(0);
            }
            this._fillAlignment(size);
        }
        this._uniformSizes[name] = size;
        this._uniformLocations[name] = this._uniformLocationPointer;
        this._uniformLocationPointer += size;
        for(let i = 0; i < size; i++)this._data.push(data[i]);
        this._needSync = true;
    }
    /**
     * Adds a Matrix 4x4 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param mat A 4x4 matrix.
     */ addMatrix(name, mat) {
        this.addUniform(name, Array.prototype.slice.call(mat.asArray()));
    }
    /**
     * Adds a vec2 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param x Define the x component value of the vec2
     * @param y Define the y component value of the vec2
     */ addFloat2(name, x, y) {
        const temp = [
            x,
            y
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param x Define the x component value of the vec3
     * @param y Define the y component value of the vec3
     * @param z Define the z component value of the vec3
     */ addFloat3(name, x, y, z) {
        const temp = [
            x,
            y,
            z
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param color Define the vec3 from a Color
     */ addColor3(name, color) {
        const temp = [
            color.r,
            color.g,
            color.b
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec4 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param color Define the rgb components from a Color
     * @param alpha Define the a component of the vec4
     */ addColor4(name, color, alpha) {
        const temp = [
            color.r,
            color.g,
            color.b,
            alpha
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param vector Define the vec3 components from a Vector
     */ addVector3(name, vector) {
        const temp = [
            vector.x,
            vector.y,
            vector.z
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a Matrix 3x3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     */ addMatrix3x3(name) {
        this.addUniform(name, 12);
    }
    /**
     * Adds a Matrix 2x2 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     */ addMatrix2x2(name) {
        this.addUniform(name, 8);
    }
    /**
     * Effectively creates the WebGL Uniform Buffer, once layout is completed with `addUniform`.
     */ create() {
        if (this._noUBO) return;
        if (this._buffer) return; // nothing to do
        // See spec, alignment must be filled as a vec4
        this._fillAlignment(4);
        this._bufferData = new Float32Array(this._data);
        this._rebuild();
        this._needSync = true;
    }
    // The result of this method is used for debugging purpose, as part of the buffer name
    // It is meant to more easily know what this buffer is about when debugging
    // Some buffers can have a lot of uniforms (several dozens), so the method only returns the first 10 of them
    // (should be enough to understand what the buffer is for)
    _getNames() {
        const names = [];
        let i = 0;
        for(const name in this._uniformLocations){
            names.push(name);
            if (++i === 10) break;
        }
        return names.join(",");
    }
    /** @internal */ _rebuild() {
        if (this._noUBO || !this._bufferData) return;
        if (this._dynamic) this._buffer = this._engine.createDynamicUniformBuffer(this._bufferData, this._name + "_UniformList:" + this._getNames());
        else this._buffer = this._engine.createUniformBuffer(this._bufferData, this._name + "_UniformList:" + this._getNames());
        if (this._engine._features.trackUbosInFrame) {
            this._buffers.push([
                this._buffer,
                this._engine._features.checkUbosContentBeforeUpload ? this._bufferData.slice() : undefined
            ]);
            this._bufferIndex = this._buffers.length - 1;
            this._createBufferOnWrite = false;
        }
    }
    /** @internal */ _rebuildAfterContextLost() {
        if (this._engine._features.trackUbosInFrame) {
            this._buffers = [];
            this._currentFrameId = 0;
        }
        this._rebuild();
    }
    /** @internal */ get _numBuffers() {
        return this._buffers.length;
    }
    /** @internal */ get _indexBuffer() {
        return this._bufferIndex;
    }
    /** Gets the name of this buffer */ get name() {
        return this._name;
    }
    /** Gets the current effect */ get currentEffect() {
        return this._currentEffect;
    }
    _buffersEqual(buf1, buf2) {
        for(let i = 0; i < buf1.length; ++i){
            if (buf1[i] !== buf2[i]) return false;
        }
        return true;
    }
    _copyBuffer(src, dst) {
        for(let i = 0; i < src.length; ++i)dst[i] = src[i];
    }
    /**
     * Updates the WebGL Uniform Buffer on the GPU.
     * If the `dynamic` flag is set to true, no cache comparison is done.
     * Otherwise, the buffer will be updated only if the cache differs.
     */ update() {
        if (this._noUBO) return;
        this.bindUniformBuffer();
        if (!this._buffer) {
            this.create();
            return;
        }
        if (!this._dynamic && !this._needSync) {
            this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
            return;
        }
        if (this._buffers && this._buffers.length > 1 && this._buffers[this._bufferIndex][1]) {
            if (this._buffersEqual(this._bufferData, this._buffers[this._bufferIndex][1])) {
                this._needSync = false;
                this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
                return;
            } else this._copyBuffer(this._bufferData, this._buffers[this._bufferIndex][1]);
        }
        this._engine.updateUniformBuffer(this._buffer, this._bufferData);
        if (this._engine._features._collectUbosUpdatedInFrame) {
            if (!$bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame[this._name]) $bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame[this._name] = 0;
            $bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame[this._name]++;
        }
        this._needSync = false;
        this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
    }
    _createNewBuffer() {
        if (this._bufferIndex + 1 < this._buffers.length) {
            this._bufferIndex++;
            this._buffer = this._buffers[this._bufferIndex][0];
            this._createBufferOnWrite = false;
            this._needSync = true;
        } else this._rebuild();
    }
    _checkNewFrame() {
        if (this._engine._features.trackUbosInFrame && this._currentFrameId !== this._engine.frameId) {
            this._currentFrameId = this._engine.frameId;
            this._createBufferOnWrite = false;
            if (this._buffers && this._buffers.length > 0) {
                this._needSync = this._bufferIndex !== 0;
                this._bufferIndex = 0;
                this._buffer = this._buffers[this._bufferIndex][0];
            } else this._bufferIndex = -1;
        }
    }
    /**
     * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
     * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
     * @param data Define the flattened data
     * @param size Define the size of the data.
     */ updateUniform(uniformName, data, size) {
        this._checkNewFrame();
        let location = this._uniformLocations[uniformName];
        if (location === undefined) {
            if (this._buffer) {
                // Cannot add an uniform if the buffer is already created
                (0, $kVtWi.Logger).Error("Cannot add an uniform after UBO has been created. uniformName=" + uniformName);
                return;
            }
            this.addUniform(uniformName, size);
            location = this._uniformLocations[uniformName];
        }
        if (!this._buffer) this.create();
        if (!this._dynamic) {
            // Cache for static uniform buffers
            let changed = false;
            for(let i = 0; i < size; i++)// We are checking the matrix cache before calling updateUniform so we do not need to check it here
            // Hence the test for size === 16 to simply commit the matrix values
            if (size === 16 && !this._engine._features.uniformBufferHardCheckMatrix || this._bufferData[location + i] !== Math.fround(data[i])) {
                changed = true;
                if (this._createBufferOnWrite) this._createNewBuffer();
                this._bufferData[location + i] = data[i];
            }
            this._needSync = this._needSync || changed;
        } else // No cache for dynamic
        for(let i = 0; i < size; i++)this._bufferData[location + i] = data[i];
    }
    /**
     * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
     * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
     * @param data Define the flattened data
     * @param size Define the size of the data.
     */ updateUniformArray(uniformName, data, size) {
        this._checkNewFrame();
        const location = this._uniformLocations[uniformName];
        if (location === undefined) {
            (0, $kVtWi.Logger).Error("Cannot add an uniform Array dynamically. Please, add it using addUniform and make sure that uniform buffers are supported by the current engine.");
            return;
        }
        if (!this._buffer) this.create();
        const arraySizes = this._uniformArraySizes[uniformName];
        if (!this._dynamic) {
            // Cache for static uniform buffers
            let changed = false;
            let countToFour = 0;
            let baseStride = 0;
            for(let i = 0; i < size; i++){
                if (this._bufferData[location + baseStride * 4 + countToFour] !== (0, $bOhSV.Tools).FloatRound(data[i])) {
                    changed = true;
                    if (this._createBufferOnWrite) this._createNewBuffer();
                    this._bufferData[location + baseStride * 4 + countToFour] = data[i];
                }
                countToFour++;
                if (countToFour === arraySizes.strideSize) {
                    for(; countToFour < 4; countToFour++)this._bufferData[location + baseStride * 4 + countToFour] = 0;
                    countToFour = 0;
                    baseStride++;
                }
            }
            this._needSync = this._needSync || changed;
        } else // No cache for dynamic
        for(let i = 0; i < size; i++)this._bufferData[location + i] = data[i];
    }
    _cacheMatrix(name, matrix) {
        this._checkNewFrame();
        const cache = this._valueCache[name];
        const flag = matrix.updateFlag;
        if (cache !== undefined && cache === flag) return false;
        this._valueCache[name] = flag;
        return true;
    }
    // Update methods
    _updateMatrix3x3ForUniform(name, matrix) {
        // To match std140, matrix must be realigned
        for(let i = 0; i < 3; i++){
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4] = matrix[i * 3];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 1] = matrix[i * 3 + 1];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 2] = matrix[i * 3 + 2];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 3] = 0.0;
        }
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 12);
    }
    _updateMatrix3x3ForEffect(name, matrix) {
        this._currentEffect.setMatrix3x3(name, matrix);
    }
    _updateMatrix2x2ForEffect(name, matrix) {
        this._currentEffect.setMatrix2x2(name, matrix);
    }
    _updateMatrix2x2ForUniform(name, matrix) {
        // To match std140, matrix must be realigned
        for(let i = 0; i < 2; i++){
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4] = matrix[i * 2];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 1] = matrix[i * 2 + 1];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 2] = 0.0;
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 3] = 0.0;
        }
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 8);
    }
    _updateFloatForEffect(name, x) {
        this._currentEffect.setFloat(name, x);
    }
    _updateFloatForUniform(name, x) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 1);
    }
    _updateFloat2ForEffect(name, x, y, suffix = "") {
        this._currentEffect.setFloat2(name + suffix, x, y);
    }
    _updateFloat2ForUniform(name, x, y) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = y;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 2);
    }
    _updateFloat3ForEffect(name, x, y, z, suffix = "") {
        this._currentEffect.setFloat3(name + suffix, x, y, z);
    }
    _updateFloat3ForUniform(name, x, y, z) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateFloat4ForEffect(name, x, y, z, w, suffix = "") {
        this._currentEffect.setFloat4(name + suffix, x, y, z, w);
    }
    _updateFloat4ForUniform(name, x, y, z, w) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateFloatArrayForEffect(name, array) {
        this._currentEffect.setFloatArray(name, array);
    }
    _updateFloatArrayForUniform(name, array) {
        this.updateUniformArray(name, array, array.length);
    }
    _updateArrayForEffect(name, array) {
        this._currentEffect.setArray(name, array);
    }
    _updateArrayForUniform(name, array) {
        this.updateUniformArray(name, array, array.length);
    }
    _updateIntArrayForEffect(name, array) {
        this._currentEffect.setIntArray(name, array);
    }
    _updateIntArrayForUniform(name, array) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View.set(array);
        this.updateUniformArray(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, array.length);
    }
    _updateUIntArrayForEffect(name, array) {
        this._currentEffect.setUIntArray(name, array);
    }
    _updateUIntArrayForUniform(name, array) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View.set(array);
        this.updateUniformArray(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, array.length);
    }
    _updateMatrixForEffect(name, mat) {
        this._currentEffect.setMatrix(name, mat);
    }
    _updateMatrixForUniform(name, mat) {
        if (this._cacheMatrix(name, mat)) this.updateUniform(name, mat.asArray(), 16);
    }
    _updateMatricesForEffect(name, mat) {
        this._currentEffect.setMatrices(name, mat);
    }
    _updateMatricesForUniform(name, mat) {
        this.updateUniform(name, mat, mat.length);
    }
    _updateVector3ForEffect(name, vector) {
        this._currentEffect.setVector3(name, vector);
    }
    _updateVector3ForUniform(name, vector) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = vector.x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = vector.y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = vector.z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateVector4ForEffect(name, vector) {
        this._currentEffect.setVector4(name, vector);
    }
    _updateVector4ForUniform(name, vector) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = vector.x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = vector.y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = vector.z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = vector.w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateColor3ForEffect(name, color, suffix = "") {
        this._currentEffect.setColor3(name + suffix, color);
    }
    _updateColor3ForUniform(name, color) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = color.r;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = color.g;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = color.b;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateColor4ForEffect(name, color, alpha, suffix = "") {
        this._currentEffect.setColor4(name + suffix, color, alpha);
    }
    _updateDirectColor4ForEffect(name, color, suffix = "") {
        this._currentEffect.setDirectColor4(name + suffix, color);
    }
    _updateColor4ForUniform(name, color, alpha) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = color.r;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = color.g;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = color.b;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = alpha;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateDirectColor4ForUniform(name, color) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = color.r;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = color.g;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = color.b;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = color.a;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateIntForEffect(name, x, suffix = "") {
        this._currentEffect.setInt(name + suffix, x);
    }
    _updateIntForUniform(name, x) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 1);
    }
    _updateInt2ForEffect(name, x, y, suffix = "") {
        this._currentEffect.setInt2(name + suffix, x, y);
    }
    _updateInt2ForUniform(name, x, y) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[1] = y;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 2);
    }
    _updateInt3ForEffect(name, x, y, z, suffix = "") {
        this._currentEffect.setInt3(name + suffix, x, y, z);
    }
    _updateInt3ForUniform(name, x, y, z) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[2] = z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateInt4ForEffect(name, x, y, z, w, suffix = "") {
        this._currentEffect.setInt4(name + suffix, x, y, z, w);
    }
    _updateInt4ForUniform(name, x, y, z, w) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[2] = z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[3] = w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateUIntForEffect(name, x, suffix = "") {
        this._currentEffect.setUInt(name + suffix, x);
    }
    _updateUIntForUniform(name, x) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 1);
    }
    _updateUInt2ForEffect(name, x, y, suffix = "") {
        this._currentEffect.setUInt2(name + suffix, x, y);
    }
    _updateUInt2ForUniform(name, x, y) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[1] = y;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 2);
    }
    _updateUInt3ForEffect(name, x, y, z, suffix = "") {
        this._currentEffect.setUInt3(name + suffix, x, y, z);
    }
    _updateUInt3ForUniform(name, x, y, z) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[2] = z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateUInt4ForEffect(name, x, y, z, w, suffix = "") {
        this._currentEffect.setUInt4(name + suffix, x, y, z, w);
    }
    _updateUInt4ForUniform(name, x, y, z, w) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[2] = z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[3] = w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    /**
     * Sets a sampler uniform on the effect.
     * @param name Define the name of the sampler.
     * @param texture Define the texture to set in the sampler
     */ setTexture(name, texture) {
        this._currentEffect.setTexture(name, texture);
    }
    /**
     * Sets an array of sampler uniforms on the effect.
     * @param name Define the name of uniform.
     * @param textures Define the textures to set in the array of samplers
     */ setTextureArray(name, textures) {
        this._currentEffect.setTextureArray(name, textures);
    }
    /**
     * Sets a sampler uniform on the effect.
     * @param name Define the name of the sampler.
     * @param texture Define the (internal) texture to set in the sampler
     */ bindTexture(name, texture) {
        this._currentEffect._bindTexture(name, texture);
    }
    /**
     * Directly updates the value of the uniform in the cache AND on the GPU.
     * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
     * @param data Define the flattened data
     */ updateUniformDirectly(uniformName, data) {
        this.updateUniform(uniformName, data, data.length);
        this.update();
    }
    /**
     * Associates an effect to this uniform buffer
     * @param effect Define the effect to associate the buffer to
     * @param name Name of the uniform block in the shader.
     */ bindToEffect(effect, name) {
        this._currentEffect = effect;
        this._currentEffectName = name;
    }
    /**
     * Binds the current (GPU) buffer to the effect
     */ bindUniformBuffer() {
        if (!this._noUBO && this._buffer && this._currentEffect) this._currentEffect.bindUniformBuffer(this._buffer, this._currentEffectName);
    }
    /**
     * Dissociates the current effect from this uniform buffer
     */ unbindEffect() {
        this._currentEffect = undefined;
        this._currentEffectName = undefined;
    }
    /**
     * Sets the current state of the class (_bufferIndex, _buffer) to point to the data buffer passed in parameter if this buffer is one of the buffers handled by the class (meaning if it can be found in the _buffers array)
     * This method is meant to be able to update a buffer at any time: just call setDataBuffer to set the class in the right state, call some updateXXX methods and then call udpate() => that will update the GPU buffer on the graphic card
     * @param dataBuffer buffer to look for
     * @returns true if the buffer has been found and the class internal state points to it, else false
     */ setDataBuffer(dataBuffer) {
        if (!this._buffers) return this._buffer === dataBuffer;
        for(let b = 0; b < this._buffers.length; ++b){
            const buffer = this._buffers[b];
            if (buffer[0] === dataBuffer) {
                this._bufferIndex = b;
                this._buffer = dataBuffer;
                this._createBufferOnWrite = false;
                this._currentEffect = undefined;
                return true;
            }
        }
        return false;
    }
    /**
     * Disposes the uniform buffer.
     */ dispose() {
        if (this._noUBO) return;
        const uniformBuffers = this._engine._uniformBuffers;
        const index = uniformBuffers.indexOf(this);
        if (index !== -1) {
            uniformBuffers[index] = uniformBuffers[uniformBuffers.length - 1];
            uniformBuffers.pop();
        }
        if (this._engine._features.trackUbosInFrame && this._buffers) for(let i = 0; i < this._buffers.length; ++i){
            const buffer = this._buffers[i][0];
            this._engine._releaseBuffer(buffer);
        }
        else if (this._buffer && this._engine._releaseBuffer(this._buffer)) this._buffer = null;
    }
}
/** @internal */ $bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame = {};
// Pool for avoiding memory leaks
$bda18ab409280b95$export$e0b4e5723e07d1e5._MAX_UNIFORM_SIZE = 256;
$bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer = new Float32Array($bda18ab409280b95$export$e0b4e5723e07d1e5._MAX_UNIFORM_SIZE);
$bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View = new Int32Array($bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer.buffer);
$bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View = new Uint32Array($bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer.buffer);

});

parcelRegister("gzCma", function(module, exports) {

$parcel$export(module.exports, "PickingInfo", () => $c10dab0bed9b9622$export$7f6d7f420a2935cb);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");
class $c10dab0bed9b9622$export$7f6d7f420a2935cb {
    constructor(){
        /**
         * If the pick collided with an object
         */ this.hit = false;
        /**
         * Distance away where the pick collided
         */ this.distance = 0;
        /**
         * The location of pick collision
         */ this.pickedPoint = null;
        /**
         * The mesh corresponding the pick collision
         */ this.pickedMesh = null;
        /** (See getTextureCoordinates) The barycentric U coordinate that is used when calculating the texture coordinates of the collision.*/ this.bu = 0;
        /** (See getTextureCoordinates) The barycentric V coordinate that is used when calculating the texture coordinates of the collision.*/ this.bv = 0;
        /** The index of the face on the mesh that was picked, or the index of the Line if the picked Mesh is a LinesMesh */ this.faceId = -1;
        /** The index of the face on the subMesh that was picked, or the index of the Line if the picked Mesh is a LinesMesh */ this.subMeshFaceId = -1;
        /** Id of the submesh that was picked */ this.subMeshId = 0;
        /** If a sprite was picked, this will be the sprite the pick collided with */ this.pickedSprite = null;
        /** If we are picking a mesh with thin instance, this will give you the picked thin instance */ this.thinInstanceIndex = -1;
        /**
         * The ray that was used to perform the picking.
         */ this.ray = null;
        /**
         * If a mesh was used to do the picking (eg. 6dof controller) as a "near interaction", this will be populated.
         */ this.originMesh = null;
        /**
         * The aim-space transform of the input used for picking, if it is an XR input source.
         */ this.aimTransform = null;
        /**
         * The grip-space transform of the input used for picking, if it is an XR input source.
         * Some XR sources, such as input coming from head mounted displays, do not have this.
         */ this.gripTransform = null;
    }
    /**
     * Gets the normal corresponding to the face the pick collided with
     * @param useWorldCoordinates If the resulting normal should be relative to the world (default: false)
     * @param useVerticesNormals If the vertices normals should be used to calculate the normal instead of the normal map (default: true)
     * @returns The normal corresponding to the face the pick collided with
     * @remarks Note that the returned normal will always point towards the picking ray.
     */ getNormal(useWorldCoordinates = false, useVerticesNormals = true) {
        if (!this.pickedMesh || useVerticesNormals && !this.pickedMesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) return null;
        let indices = this.pickedMesh.getIndices();
        if (indices?.length === 0) indices = null;
        let result;
        const tmp0 = (0, $ha1VO.TmpVectors).Vector3[0];
        const tmp1 = (0, $ha1VO.TmpVectors).Vector3[1];
        const tmp2 = (0, $ha1VO.TmpVectors).Vector3[2];
        if (useVerticesNormals) {
            const normals = this.pickedMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            let normal0 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(normals, indices[this.faceId * 3] * 3, tmp0) : tmp0.copyFromFloats(normals[this.faceId * 9], normals[this.faceId * 9 + 1], normals[this.faceId * 9 + 2]);
            let normal1 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(normals, indices[this.faceId * 3 + 1] * 3, tmp1) : tmp1.copyFromFloats(normals[(this.faceId * 3 + 1) * 3], normals[(this.faceId * 3 + 1) * 3 + 1], normals[(this.faceId * 3 + 1) * 3 + 2]);
            let normal2 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(normals, indices[this.faceId * 3 + 2] * 3, tmp2) : tmp2.copyFromFloats(normals[(this.faceId * 3 + 2) * 3], normals[(this.faceId * 3 + 2) * 3 + 1], normals[(this.faceId * 3 + 2) * 3 + 2]);
            normal0 = normal0.scale(this.bu);
            normal1 = normal1.scale(this.bv);
            normal2 = normal2.scale(1.0 - this.bu - this.bv);
            result = new (0, $ha1VO.Vector3)(normal0.x + normal1.x + normal2.x, normal0.y + normal1.y + normal2.y, normal0.z + normal1.z + normal2.z);
        } else {
            const positions = this.pickedMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            const vertex1 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(positions, indices[this.faceId * 3] * 3, tmp0) : tmp0.copyFromFloats(positions[this.faceId * 9], positions[this.faceId * 9 + 1], positions[this.faceId * 9 + 2]);
            const vertex2 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(positions, indices[this.faceId * 3 + 1] * 3, tmp1) : tmp1.copyFromFloats(positions[(this.faceId * 3 + 1) * 3], positions[(this.faceId * 3 + 1) * 3 + 1], positions[(this.faceId * 3 + 1) * 3 + 2]);
            const vertex3 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(positions, indices[this.faceId * 3 + 2] * 3, tmp2) : tmp2.copyFromFloats(positions[(this.faceId * 3 + 2) * 3], positions[(this.faceId * 3 + 2) * 3 + 1], positions[(this.faceId * 3 + 2) * 3 + 2]);
            const p1p2 = vertex1.subtract(vertex2);
            const p3p2 = vertex3.subtract(vertex2);
            result = (0, $ha1VO.Vector3).Cross(p1p2, p3p2);
        }
        const transformNormalToWorld = (pickedMesh, n)=>{
            let wm = pickedMesh.getWorldMatrix();
            if (pickedMesh.nonUniformScaling) {
                (0, $ha1VO.TmpVectors).Matrix[0].copyFrom(wm);
                wm = (0, $ha1VO.TmpVectors).Matrix[0];
                wm.setTranslationFromFloats(0, 0, 0);
                wm.invert();
                wm.transposeToRef((0, $ha1VO.TmpVectors).Matrix[1]);
                wm = (0, $ha1VO.TmpVectors).Matrix[1];
            }
            (0, $ha1VO.Vector3).TransformNormalToRef(n, wm, n);
        };
        if (useWorldCoordinates) transformNormalToWorld(this.pickedMesh, result);
        if (this.ray) {
            const normalForDirectionChecking = (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(result);
            if (!useWorldCoordinates) // the normal has not been transformed to world space as part as the normal processing, so we must do it now
            transformNormalToWorld(this.pickedMesh, normalForDirectionChecking);
            // Flip the normal if the picking ray is in the same direction.
            if ((0, $ha1VO.Vector3).Dot(normalForDirectionChecking, this.ray.direction) > 0) result.negateInPlace();
        }
        result.normalize();
        return result;
    }
    /**
     * Gets the texture coordinates of where the pick occurred
     * @param uvSet The UV set to use to calculate the texture coordinates (default: VertexBuffer.UVKind)
     * @returns The vector containing the coordinates of the texture
     */ getTextureCoordinates(uvSet = (0, $b4i1f.VertexBuffer).UVKind) {
        if (!this.pickedMesh || !this.pickedMesh.isVerticesDataPresent(uvSet)) return null;
        const indices = this.pickedMesh.getIndices();
        if (!indices) return null;
        const uvs = this.pickedMesh.getVerticesData(uvSet);
        if (!uvs) return null;
        let uv0 = (0, $ha1VO.Vector2).FromArray(uvs, indices[this.faceId * 3] * 2);
        let uv1 = (0, $ha1VO.Vector2).FromArray(uvs, indices[this.faceId * 3 + 1] * 2);
        let uv2 = (0, $ha1VO.Vector2).FromArray(uvs, indices[this.faceId * 3 + 2] * 2);
        uv0 = uv0.scale(this.bu);
        uv1 = uv1.scale(this.bv);
        uv2 = uv2.scale(1.0 - this.bu - this.bv);
        return new (0, $ha1VO.Vector2)(uv0.x + uv1.x + uv2.x, uv0.y + uv1.y + uv2.y);
    }
}

});
parcelRegister("b4i1f", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $80ee0ba8fbf79d16$export$a143d493d941bafc);
$parcel$export(module.exports, "VertexBuffer", () => $80ee0ba8fbf79d16$export$41825a1ed6473903);

var $6zPKs = parcelRequire("6zPKs");

var $kVtWi = parcelRequire("kVtWi");

var $eTEsG = parcelRequire("eTEsG");
class $80ee0ba8fbf79d16$export$a143d493d941bafc {
    /**
     * Gets a boolean indicating if the Buffer is disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Constructor
     * @param engine the engine
     * @param data the data to use for this buffer
     * @param updatable whether the data is updatable
     * @param stride the stride (optional)
     * @param postponeInternalCreation whether to postpone creating the internal WebGL buffer (optional)
     * @param instanced whether the buffer is instanced (optional)
     * @param useBytes set to true if the stride in in bytes (optional)
     * @param divisor sets an optional divisor for instances (1 by default)
     * @param label defines the label of the buffer (for debug purpose)
     */ constructor(engine, data, updatable, stride = 0, postponeInternalCreation = false, instanced = false, useBytes = false, divisor, label){
        this._isAlreadyOwned = false;
        this._isDisposed = false;
        if (engine && engine.getScene) // old versions of VertexBuffer accepted 'mesh' instead of 'engine'
        this._engine = engine.getScene().getEngine();
        else this._engine = engine;
        this._updatable = updatable;
        this._instanced = instanced;
        this._divisor = divisor || 1;
        this._label = label;
        if (data instanceof (0, $6zPKs.DataBuffer)) {
            this._data = null;
            this._buffer = data;
        } else {
            this._data = data;
            this._buffer = null;
        }
        this.byteStride = useBytes ? stride : stride * Float32Array.BYTES_PER_ELEMENT;
        if (!postponeInternalCreation) // by default
        this.create();
    }
    /**
     * Create a new VertexBuffer based on the current buffer
     * @param kind defines the vertex buffer kind (position, normal, etc.)
     * @param offset defines offset in the buffer (0 by default)
     * @param size defines the size in floats of attributes (position is 3 for instance)
     * @param stride defines the stride size in floats in the buffer (the offset to apply to reach next value when data is interleaved)
     * @param instanced defines if the vertex buffer contains indexed data
     * @param useBytes defines if the offset and stride are in bytes     *
     * @param divisor sets an optional divisor for instances (1 by default)
     * @returns the new vertex buffer
     */ createVertexBuffer(kind, offset, size, stride, instanced, useBytes = false, divisor) {
        const byteOffset = useBytes ? offset : offset * Float32Array.BYTES_PER_ELEMENT;
        const byteStride = stride ? useBytes ? stride : stride * Float32Array.BYTES_PER_ELEMENT : this.byteStride;
        // a lot of these parameters are ignored as they are overridden by the buffer
        return new $80ee0ba8fbf79d16$export$41825a1ed6473903(this._engine, this, kind, this._updatable, true, byteStride, instanced === undefined ? this._instanced : instanced, byteOffset, size, undefined, undefined, true, this._divisor || divisor);
    }
    // Properties
    /**
     * Gets a boolean indicating if the Buffer is updatable?
     * @returns true if the buffer is updatable
     */ isUpdatable() {
        return this._updatable;
    }
    /**
     * Gets current buffer's data
     * @returns a DataArray or null
     */ getData() {
        return this._data;
    }
    /**
     * Gets underlying native buffer
     * @returns underlying native buffer
     */ getBuffer() {
        return this._buffer;
    }
    /**
     * Gets the stride in float32 units (i.e. byte stride / 4).
     * May not be an integer if the byte stride is not divisible by 4.
     * @returns the stride in float32 units
     * @deprecated Please use byteStride instead.
     */ getStrideSize() {
        return this.byteStride / Float32Array.BYTES_PER_ELEMENT;
    }
    // Methods
    /**
     * Store data into the buffer. Creates the buffer if not used already.
     * If the buffer was already used, it will be updated only if it is updatable, otherwise it will do nothing.
     * @param data defines the data to store
     */ create(data = null) {
        if (!data && this._buffer) return; // nothing to do
        data = data || this._data;
        if (!data) return;
        if (!this._buffer) {
            // create buffer
            if (this._updatable) {
                this._buffer = this._engine.createDynamicVertexBuffer(data, this._label);
                this._data = data;
            } else this._buffer = this._engine.createVertexBuffer(data, undefined, this._label);
        } else if (this._updatable) {
            // update buffer
            this._engine.updateDynamicVertexBuffer(this._buffer, data);
            this._data = data;
        }
    }
    /** @internal */ _rebuild() {
        if (!this._data) {
            if (!this._buffer) // Buffer was not yet created, nothing to do
            return;
            if (this._buffer.capacity > 0) {
                // We can at least recreate the buffer with the right size, even if we don't have the data
                if (this._updatable) this._buffer = this._engine.createDynamicVertexBuffer(this._buffer.capacity, this._label);
                else this._buffer = this._engine.createVertexBuffer(this._buffer.capacity, undefined, this._label);
                return;
            }
            (0, $kVtWi.Logger).Warn(`Missing data for buffer "${this._label}" ${this._buffer ? "(uniqueId: " + this._buffer.uniqueId + ")" : ""}. Buffer reconstruction failed.`);
            this._buffer = null;
        } else {
            this._buffer = null;
            this.create(this._data);
        }
    }
    /**
     * Update current buffer data
     * @param data defines the data to store
     */ update(data) {
        this.create(data);
    }
    /**
     * Updates the data directly.
     * @param data the new data
     * @param offset the new offset
     * @param vertexCount the vertex count (optional)
     * @param useBytes set to true if the offset is in bytes
     */ updateDirectly(data, offset, vertexCount, useBytes = false) {
        if (!this._buffer) return;
        if (this._updatable) {
            // update buffer
            this._engine.updateDynamicVertexBuffer(this._buffer, data, useBytes ? offset : offset * Float32Array.BYTES_PER_ELEMENT, vertexCount ? vertexCount * this.byteStride : undefined);
            if (offset === 0 && vertexCount === undefined) // Keep the data if we easily can
            this._data = data;
            else this._data = null;
        }
    }
    /** @internal */ _increaseReferences() {
        if (!this._buffer) return;
        if (!this._isAlreadyOwned) {
            this._isAlreadyOwned = true;
            return;
        }
        this._buffer.references++;
    }
    /**
     * Release all resources
     */ dispose() {
        if (!this._buffer) return;
        // The data buffer has an internal counter as this buffer can be used by several VertexBuffer objects
        // This means that we only flag it as disposed when all references are released (when _releaseBuffer will return true)
        if (this._engine._releaseBuffer(this._buffer)) {
            this._isDisposed = true;
            this._data = null;
            this._buffer = null;
        }
    }
}
class $80ee0ba8fbf79d16$export$41825a1ed6473903 {
    /**
     * Gets a boolean indicating if the Buffer is disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Gets or sets the instance divisor when in instanced mode
     */ get instanceDivisor() {
        return this._instanceDivisor;
    }
    set instanceDivisor(value) {
        const isInstanced = value != 0;
        this._instanceDivisor = value;
        if (isInstanced !== this._instanced) {
            this._instanced = isInstanced;
            this._computeHashCode();
        }
    }
    /**
     * Gets the max possible amount of vertices stored within the current vertex buffer.
     * We do not have the end offset or count so this will be too big for concatenated vertex buffers.
     * @internal
     */ get _maxVerticesCount() {
        const data = this.getData();
        if (!data) return 0;
        if (Array.isArray(data)) // data is a regular number[] with float values
        return data.length / (this.byteStride / 4) - this.byteOffset / 4;
        return (data.byteLength - this.byteOffset) / this.byteStride;
    }
    /** @internal */ constructor(engine, data, kind, updatableOrOptions, postponeInternalCreation, stride, instanced, offset, size, type, normalized = false, useBytes = false, divisor = 1, takeBufferOwnership = false){
        /** @internal */ this._isDisposed = false;
        let updatable = false;
        this.engine = engine;
        if (typeof updatableOrOptions === "object" && updatableOrOptions !== null) {
            updatable = updatableOrOptions.updatable ?? false;
            postponeInternalCreation = updatableOrOptions.postponeInternalCreation;
            stride = updatableOrOptions.stride;
            instanced = updatableOrOptions.instanced;
            offset = updatableOrOptions.offset;
            size = updatableOrOptions.size;
            type = updatableOrOptions.type;
            normalized = updatableOrOptions.normalized ?? false;
            useBytes = updatableOrOptions.useBytes ?? false;
            divisor = updatableOrOptions.divisor ?? 1;
            takeBufferOwnership = updatableOrOptions.takeBufferOwnership ?? false;
            this._label = updatableOrOptions.label;
        } else updatable = !!updatableOrOptions;
        if (data instanceof $80ee0ba8fbf79d16$export$a143d493d941bafc) {
            this._buffer = data;
            this._ownsBuffer = takeBufferOwnership;
        } else {
            this._buffer = new $80ee0ba8fbf79d16$export$a143d493d941bafc(engine, data, updatable, stride, postponeInternalCreation, instanced, useBytes, divisor, this._label);
            this._ownsBuffer = true;
        }
        this.uniqueId = $80ee0ba8fbf79d16$export$41825a1ed6473903._Counter++;
        this._kind = kind;
        if (type === undefined) {
            const vertexData = this.getData();
            this.type = vertexData ? $80ee0ba8fbf79d16$export$41825a1ed6473903.GetDataType(vertexData) : $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT;
        } else this.type = type;
        const typeByteLength = (0, $eTEsG.GetTypeByteLength)(this.type);
        if (useBytes) {
            this._size = size || (stride ? stride / typeByteLength : $80ee0ba8fbf79d16$export$41825a1ed6473903.DeduceStride(kind));
            this.byteStride = stride || this._buffer.byteStride || this._size * typeByteLength;
            this.byteOffset = offset || 0;
        } else {
            this._size = size || stride || $80ee0ba8fbf79d16$export$41825a1ed6473903.DeduceStride(kind);
            this.byteStride = stride ? stride * typeByteLength : this._buffer.byteStride || this._size * typeByteLength;
            this.byteOffset = (offset || 0) * typeByteLength;
        }
        this.normalized = normalized;
        this._instanced = instanced !== undefined ? instanced : false;
        this._instanceDivisor = instanced ? divisor : 0;
        this._alignBuffer();
        this._computeHashCode();
    }
    _computeHashCode() {
        // note: cast to any because the property is declared readonly
        this.hashCode = (this.type - 5120 << 0) + ((this.normalized ? 1 : 0) << 3) + (this._size << 4) + ((this._instanced ? 1 : 0) << 6) + /* keep 5 bits free */ (this.byteStride << 12);
    }
    /** @internal */ _rebuild() {
        this._buffer?._rebuild();
    }
    /**
     * Returns the kind of the VertexBuffer (string)
     * @returns a string
     */ getKind() {
        return this._kind;
    }
    // Properties
    /**
     * Gets a boolean indicating if the VertexBuffer is updatable?
     * @returns true if the buffer is updatable
     */ isUpdatable() {
        return this._buffer.isUpdatable();
    }
    /**
     * Gets current buffer's data
     * @returns a DataArray or null
     */ getData() {
        return this._buffer.getData();
    }
    /**
     * Gets current buffer's data as a float array. Float data is constructed if the vertex buffer data cannot be returned directly.
     * @param totalVertices number of vertices in the buffer to take into account
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns a float array containing vertex data
     */ getFloatData(totalVertices, forceCopy) {
        const data = this.getData();
        if (!data) return null;
        return (0, $eTEsG.GetFloatData)(data, this._size, this.type, this.byteOffset, this.byteStride, this.normalized, totalVertices, forceCopy);
    }
    /**
     * Gets underlying native buffer
     * @returns underlying native buffer
     */ getBuffer() {
        return this._buffer.getBuffer();
    }
    /**
     * Gets the Buffer instance that wraps the native GPU buffer
     * @returns the wrapper buffer
     */ getWrapperBuffer() {
        return this._buffer;
    }
    /**
     * Gets the stride in float32 units (i.e. byte stride / 4).
     * May not be an integer if the byte stride is not divisible by 4.
     * @returns the stride in float32 units
     * @deprecated Please use byteStride instead.
     */ getStrideSize() {
        return this.byteStride / (0, $eTEsG.GetTypeByteLength)(this.type);
    }
    /**
     * Returns the offset as a multiple of the type byte length.
     * @returns the offset in bytes
     * @deprecated Please use byteOffset instead.
     */ getOffset() {
        return this.byteOffset / (0, $eTEsG.GetTypeByteLength)(this.type);
    }
    /**
     * Returns the number of components or the byte size per vertex attribute
     * @param sizeInBytes If true, returns the size in bytes or else the size in number of components of the vertex attribute (default: false)
     * @returns the number of components
     */ getSize(sizeInBytes = false) {
        return sizeInBytes ? this._size * (0, $eTEsG.GetTypeByteLength)(this.type) : this._size;
    }
    /**
     * Gets a boolean indicating is the internal buffer of the VertexBuffer is instanced
     * @returns true if this buffer is instanced
     */ getIsInstanced() {
        return this._instanced;
    }
    /**
     * Returns the instancing divisor, zero for non-instanced (integer).
     * @returns a number
     */ getInstanceDivisor() {
        return this._instanceDivisor;
    }
    // Methods
    /**
     * Store data into the buffer. If the buffer was already used it will be either recreated or updated depending on isUpdatable property
     * @param data defines the data to store
     */ create(data) {
        this._buffer.create(data);
        this._alignBuffer();
    }
    /**
     * Updates the underlying buffer according to the passed numeric array or Float32Array.
     * This function will create a new buffer if the current one is not updatable
     * @param data defines the data to store
     */ update(data) {
        this._buffer.update(data);
        this._alignBuffer();
    }
    /**
     * Updates directly the underlying WebGLBuffer according to the passed numeric array or Float32Array.
     * Returns the directly updated WebGLBuffer.
     * @param data the new data
     * @param offset the new offset
     * @param useBytes set to true if the offset is in bytes
     */ updateDirectly(data, offset, useBytes = false) {
        this._buffer.updateDirectly(data, offset, undefined, useBytes);
        this._alignBuffer();
    }
    /**
     * Disposes the VertexBuffer and the underlying WebGLBuffer.
     */ dispose() {
        if (this._ownsBuffer) this._buffer.dispose();
        this._isDisposed = true;
    }
    /**
     * Enumerates each value of this vertex buffer as numbers.
     * @param count the number of values to enumerate
     * @param callback the callback function called for each value
     */ forEach(count, callback) {
        (0, $eTEsG.EnumerateFloatValues)(this._buffer.getData(), this.byteOffset, this.byteStride, this._size, this.type, count, this.normalized, (values, index)=>{
            for(let i = 0; i < this._size; i++)callback(values[i], index + i);
        });
    }
    /** @internal */ _alignBuffer() {}
    /**
     * Deduces the stride given a kind.
     * @param kind The kind string to deduce
     * @returns The deduced stride
     */ static DeduceStride(kind) {
        switch(kind){
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UVKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV2Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV3Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV4Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV5Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV6Kind:
                return 2;
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.NormalKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.PositionKind:
                return 3;
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorInstanceKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesExtraKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsExtraKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.TangentKind:
                return 4;
            default:
                throw new Error("Invalid kind '" + kind + "'");
        }
    }
    /**
     * Gets the vertex buffer type of the given data array.
     * @param data the data array
     * @returns the vertex buffer type
     */ static GetDataType(data) {
        if (data instanceof Int8Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.BYTE;
        else if (data instanceof Uint8Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_BYTE;
        else if (data instanceof Int16Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.SHORT;
        else if (data instanceof Uint16Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_SHORT;
        else if (data instanceof Int32Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.INT;
        else if (data instanceof Uint32Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_INT;
        else return $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT;
    }
    /**
     * Gets the byte length of the given type.
     * @param type the type
     * @returns the number of bytes
     * @deprecated Use `getTypeByteLength` from `bufferUtils` instead
     */ static GetTypeByteLength(type) {
        return (0, $eTEsG.GetTypeByteLength)(type);
    }
    /**
     * Enumerates each value of the given parameters as numbers.
     * @param data the data to enumerate
     * @param byteOffset the byte offset of the data
     * @param byteStride the byte stride of the data
     * @param componentCount the number of components per element
     * @param componentType the type of the component
     * @param count the number of values to enumerate
     * @param normalized whether the data is normalized
     * @param callback the callback function called for each value
     * @deprecated Use `EnumerateFloatValues` from `bufferUtils` instead
     */ static ForEach(data, byteOffset, byteStride, componentCount, componentType, count, normalized, callback) {
        (0, $eTEsG.EnumerateFloatValues)(data, byteOffset, byteStride, componentCount, componentType, count, normalized, (values, index)=>{
            for(let componentIndex = 0; componentIndex < componentCount; componentIndex++)callback(values[componentIndex], index + componentIndex);
        });
    }
    /**
     * Gets the given data array as a float array. Float data is constructed if the data array cannot be returned directly.
     * @param data the input data array
     * @param size the number of components
     * @param type the component type
     * @param byteOffset the byte offset of the data
     * @param byteStride the byte stride of the data
     * @param normalized whether the data is normalized
     * @param totalVertices number of vertices in the buffer to take into account
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns a float array containing vertex data
     * @deprecated Use `GetFloatData` from `bufferUtils` instead
     */ static GetFloatData(data, size, type, byteOffset, byteStride, normalized, totalVertices, forceCopy) {
        return (0, $eTEsG.GetFloatData)(data, size, type, byteOffset, byteStride, normalized, totalVertices, forceCopy);
    }
}
$80ee0ba8fbf79d16$export$41825a1ed6473903._Counter = 0;
/**
 * The byte type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.BYTE = 5120;
/**
 * The unsigned byte type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_BYTE = 5121;
/**
 * The short type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.SHORT = 5122;
/**
 * The unsigned short type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_SHORT = 5123;
/**
 * The integer type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.INT = 5124;
/**
 * The unsigned integer type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_INT = 5125;
/**
 * The float type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT = 5126;
// Enums
/**
 * Positions
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.PositionKind = `position`;
/**
 * Normals
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.NormalKind = `normal`;
/**
 * Tangents
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.TangentKind = `tangent`;
/**
 * Texture coordinates
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UVKind = `uv`;
/**
 * Texture coordinates 2
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV2Kind = `uv2`;
/**
 * Texture coordinates 3
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV3Kind = `uv3`;
/**
 * Texture coordinates 4
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV4Kind = `uv4`;
/**
 * Texture coordinates 5
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV5Kind = `uv5`;
/**
 * Texture coordinates 6
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV6Kind = `uv6`;
/**
 * Colors
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorKind = `color`;
/**
 * Instance Colors
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorInstanceKind = `instanceColor`;
/**
 * Matrix indices (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesKind = `matricesIndices`;
/**
 * Matrix weights (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsKind = `matricesWeights`;
/**
 * Additional matrix indices (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesExtraKind = `matricesIndicesExtra`;
/**
 * Additional matrix weights (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsExtraKind = `matricesWeightsExtra`;

});
parcelRegister("6zPKs", function(module, exports) {

$parcel$export(module.exports, "DataBuffer", () => $4c9e271f5881ce58$export$e21b1680ace449b);
/**
 * Class used to store gfx data (like WebGLBuffer)
 */ class $4c9e271f5881ce58$export$e21b1680ace449b {
    /**
     * Gets the underlying buffer
     */ get underlyingResource() {
        return null;
    }
    /**
     * Constructs the buffer
     */ constructor(){
        /**
         * Gets or sets the number of objects referencing this buffer
         */ this.references = 0;
        /** Gets or sets the size of the underlying buffer */ this.capacity = 0;
        /**
         * Gets or sets a boolean indicating if the buffer contains 32bits indices
         */ this.is32Bits = false;
        this.uniqueId = $4c9e271f5881ce58$export$e21b1680ace449b._Counter++;
    }
}
$4c9e271f5881ce58$export$e21b1680ace449b._Counter = 0;

});

parcelRegister("eTEsG", function(module, exports) {

$parcel$export(module.exports, "GetTypeByteLength", () => $ad8596960ac8d074$export$60838feae2bc1050);
$parcel$export(module.exports, "EnumerateFloatValues", () => $ad8596960ac8d074$export$9234bc1fe908d2cb);
$parcel$export(module.exports, "GetFloatData", () => $ad8596960ac8d074$export$4e8ac7df43d9a3e8);
$parcel$export(module.exports, "CopyFloatData", () => $ad8596960ac8d074$export$53b734796b478af6);

var $kVtWi = parcelRequire("kVtWi");
function $ad8596960ac8d074$var$GetFloatValue(dataView, type, byteOffset, normalized) {
    switch(type){
        case 5120:
            {
                let value = dataView.getInt8(byteOffset);
                if (normalized) value = Math.max(value / 127, -1);
                return value;
            }
        case 5121:
            {
                let value = dataView.getUint8(byteOffset);
                if (normalized) value = value / 255;
                return value;
            }
        case 5122:
            {
                let value = dataView.getInt16(byteOffset, true);
                if (normalized) value = Math.max(value / 32767, -1);
                return value;
            }
        case 5123:
            {
                let value = dataView.getUint16(byteOffset, true);
                if (normalized) value = value / 65535;
                return value;
            }
        case 5124:
            return dataView.getInt32(byteOffset, true);
        case 5125:
            return dataView.getUint32(byteOffset, true);
        case 5126:
            return dataView.getFloat32(byteOffset, true);
        default:
            throw new Error(`Invalid component type ${type}`);
    }
}
function $ad8596960ac8d074$var$SetFloatValue(dataView, type, byteOffset, normalized, value) {
    switch(type){
        case 5120:
            if (normalized) value = Math.round(value * 127.0);
            dataView.setInt8(byteOffset, value);
            break;
        case 5121:
            if (normalized) value = Math.round(value * 255);
            dataView.setUint8(byteOffset, value);
            break;
        case 5122:
            if (normalized) value = Math.round(value * 32767);
            dataView.setInt16(byteOffset, value, true);
            break;
        case 5123:
            if (normalized) value = Math.round(value * 65535);
            dataView.setUint16(byteOffset, value, true);
            break;
        case 5124:
            dataView.setInt32(byteOffset, value, true);
            break;
        case 5125:
            dataView.setUint32(byteOffset, value, true);
            break;
        case 5126:
            dataView.setFloat32(byteOffset, value, true);
            break;
        default:
            throw new Error(`Invalid component type ${type}`);
    }
}
function $ad8596960ac8d074$export$60838feae2bc1050(type) {
    switch(type){
        case 5120:
        case 5121:
            return 1;
        case 5122:
        case 5123:
            return 2;
        case 5124:
        case 5125:
        case 5126:
            return 4;
        default:
            throw new Error(`Invalid type '${type}'`);
    }
}
function $ad8596960ac8d074$export$3de5a859bccf33d5(componentType) {
    switch(componentType){
        case 5120:
            return Int8Array;
        case 5121:
            return Uint8Array;
        case 5122:
            return Int16Array;
        case 5123:
            return Uint16Array;
        case 5124:
            return Int32Array;
        case 5125:
            return Uint32Array;
        case 5126:
            return Float32Array;
        default:
            throw new Error(`Invalid component type '${componentType}'`);
    }
}
function $ad8596960ac8d074$export$9234bc1fe908d2cb(data, byteOffset, byteStride, componentCount, componentType, count, normalized, callback) {
    const oldValues = new Array(componentCount);
    const newValues = new Array(componentCount);
    if (data instanceof Array) {
        let offset = byteOffset / 4;
        const stride = byteStride / 4;
        for(let index = 0; index < count; index += componentCount){
            for(let componentIndex = 0; componentIndex < componentCount; componentIndex++)oldValues[componentIndex] = newValues[componentIndex] = data[offset + componentIndex];
            callback(newValues, index);
            for(let componentIndex = 0; componentIndex < componentCount; componentIndex++)if (oldValues[componentIndex] !== newValues[componentIndex]) data[offset + componentIndex] = newValues[componentIndex];
            offset += stride;
        }
    } else {
        const dataView = !ArrayBuffer.isView(data) ? new DataView(data) : new DataView(data.buffer, data.byteOffset, data.byteLength);
        const componentByteLength = $ad8596960ac8d074$export$60838feae2bc1050(componentType);
        for(let index = 0; index < count; index += componentCount){
            for(let componentIndex = 0, componentByteOffset = byteOffset; componentIndex < componentCount; componentIndex++, componentByteOffset += componentByteLength)oldValues[componentIndex] = newValues[componentIndex] = $ad8596960ac8d074$var$GetFloatValue(dataView, componentType, componentByteOffset, normalized);
            callback(newValues, index);
            for(let componentIndex = 0, componentByteOffset = byteOffset; componentIndex < componentCount; componentIndex++, componentByteOffset += componentByteLength)if (oldValues[componentIndex] !== newValues[componentIndex]) $ad8596960ac8d074$var$SetFloatValue(dataView, componentType, componentByteOffset, normalized, newValues[componentIndex]);
            byteOffset += byteStride;
        }
    }
}
function $ad8596960ac8d074$export$4e8ac7df43d9a3e8(data, size, type, byteOffset, byteStride, normalized, totalVertices, forceCopy) {
    const tightlyPackedByteStride = size * $ad8596960ac8d074$export$60838feae2bc1050(type);
    const count = totalVertices * size;
    if (type !== 5126 || byteStride !== tightlyPackedByteStride) {
        const copy = new Float32Array(count);
        $ad8596960ac8d074$export$9234bc1fe908d2cb(data, byteOffset, byteStride, size, type, count, normalized, (values, index)=>{
            for(let i = 0; i < size; i++)copy[index + i] = values[i];
        });
        return copy;
    }
    if (!(data instanceof Array || data instanceof Float32Array) || byteOffset !== 0 || data.length !== count) {
        if (data instanceof Array) {
            const offset = byteOffset / 4;
            return data.slice(offset, offset + count);
        } else if (data instanceof ArrayBuffer) return new Float32Array(data, byteOffset, count);
        else {
            const offset = data.byteOffset + byteOffset;
            if ((offset & 3) !== 0) {
                (0, $kVtWi.Logger).Warn("Float array must be aligned to 4-bytes border");
                forceCopy = true;
            }
            if (forceCopy) return new Float32Array(data.buffer.slice(offset, offset + count * Float32Array.BYTES_PER_ELEMENT));
            else return new Float32Array(data.buffer, offset, count);
        }
    }
    if (forceCopy) return data.slice();
    return data;
}
function $ad8596960ac8d074$export$e497377175d767c7(data, size, type, byteOffset, byteStride, normalized, totalVertices, forceCopy) {
    const typeByteLength = $ad8596960ac8d074$export$60838feae2bc1050(type);
    const constructor = $ad8596960ac8d074$export$3de5a859bccf33d5(type);
    const count = totalVertices * size;
    // Handle number[]
    if (Array.isArray(data)) {
        if ((byteOffset & 3) !== 0 || (byteStride & 3) !== 0) throw new Error("byteOffset and byteStride must be a multiple of 4 for number[] data.");
        const offset = byteOffset / 4;
        const stride = byteStride / 4;
        const lastIndex = offset + (totalVertices - 1) * stride + size;
        if (lastIndex > data.length) throw new Error("Last accessed index is out of bounds.");
        if (stride < size) throw new Error("Data stride cannot be smaller than the component size.");
        if (stride !== size) {
            const copy = new constructor(count);
            $ad8596960ac8d074$export$9234bc1fe908d2cb(data, byteOffset, byteStride, size, type, count, normalized, (values, index)=>{
                for(let i = 0; i < size; i++)copy[index + i] = values[i];
            });
            return copy;
        }
        return new constructor(data.slice(offset, offset + count));
    }
    // Handle ArrayBuffer and ArrayBufferView
    let buffer;
    let adjustedByteOffset = byteOffset;
    if (data instanceof ArrayBuffer) buffer = data;
    else {
        buffer = data.buffer;
        adjustedByteOffset += data.byteOffset;
    }
    const lastByteOffset = adjustedByteOffset + (totalVertices - 1) * byteStride + size * typeByteLength;
    if (lastByteOffset > buffer.byteLength) throw new Error("Last accessed byte is out of bounds.");
    const tightlyPackedByteStride = size * typeByteLength;
    if (byteStride < tightlyPackedByteStride) throw new Error("Byte stride cannot be smaller than the component's byte size.");
    if (byteStride !== tightlyPackedByteStride) {
        const copy = new constructor(count);
        $ad8596960ac8d074$export$9234bc1fe908d2cb(buffer, adjustedByteOffset, byteStride, size, type, count, normalized, (values, index)=>{
            for(let i = 0; i < size; i++)copy[index + i] = values[i];
        });
        return copy;
    }
    if (typeByteLength !== 1 && (adjustedByteOffset & typeByteLength - 1) !== 0) {
        (0, $kVtWi.Logger).Warn("Array must be aligned to border of element size. Data will be copied.");
        forceCopy = true;
    }
    if (forceCopy) return new constructor(buffer.slice(adjustedByteOffset, adjustedByteOffset + count * typeByteLength));
    return new constructor(buffer, adjustedByteOffset, count);
}
function $ad8596960ac8d074$export$53b734796b478af6(input, size, type, byteOffset, byteStride, normalized, totalVertices, output) {
    const tightlyPackedByteStride = size * $ad8596960ac8d074$export$60838feae2bc1050(type);
    const count = totalVertices * size;
    if (output.length !== count) throw new Error("Output length is not valid");
    if (type !== 5126 || byteStride !== tightlyPackedByteStride) {
        $ad8596960ac8d074$export$9234bc1fe908d2cb(input, byteOffset, byteStride, size, type, count, normalized, (values, index)=>{
            for(let i = 0; i < size; i++)output[index + i] = values[i];
        });
        return;
    }
    if (input instanceof Array) {
        const offset = byteOffset / 4;
        output.set(input, offset);
    } else if (input instanceof ArrayBuffer) {
        const floatData = new Float32Array(input, byteOffset, count);
        output.set(floatData);
    } else {
        const offset = input.byteOffset + byteOffset;
        if ((offset & 3) !== 0) {
            (0, $kVtWi.Logger).Warn("Float array must be aligned to 4-bytes border");
            output.set(new Float32Array(input.buffer.slice(offset, offset + count * Float32Array.BYTES_PER_ELEMENT)));
            return;
        }
        const floatData = new Float32Array(input.buffer, offset, count);
        output.set(floatData);
    }
}
function $ad8596960ac8d074$export$f7c1d6a4423fdda8(indices, count) {
    if (indices) {
        if (indices instanceof Array) return indices.some((value)=>value >= 65536);
        return indices.BYTES_PER_ELEMENT === 4;
    }
    return count >= 65536;
}

});



parcelRegister("cmj0B", function(module, exports) {

$parcel$export(module.exports, "ActionEvent", () => $8ff648d23f338fa0$export$be110ec04f34d03b);
/**
 * ActionEvent is the event being sent when an action is triggered.
 */ class $8ff648d23f338fa0$export$be110ec04f34d03b {
    /**
     * Creates a new ActionEvent
     * @param source The mesh or sprite that triggered the action
     * @param pointerX The X mouse cursor position at the time of the event
     * @param pointerY The Y mouse cursor position at the time of the event
     * @param meshUnderPointer The mesh that is currently pointed at (can be null)
     * @param sourceEvent the original (browser) event that triggered the ActionEvent
     * @param additionalData additional data for the event
     */ constructor(/** The mesh or sprite that triggered the action */ source, /** The X mouse cursor position at the time of the event */ pointerX, /** The Y mouse cursor position at the time of the event */ pointerY, /** The mesh that is currently pointed at (can be null) */ meshUnderPointer, /** the original (browser) event that triggered the ActionEvent */ sourceEvent, /** additional data for the event */ additionalData){
        this.source = source;
        this.pointerX = pointerX;
        this.pointerY = pointerY;
        this.meshUnderPointer = meshUnderPointer;
        this.sourceEvent = sourceEvent;
        this.additionalData = additionalData;
    }
    /**
     * Helper function to auto-create an ActionEvent from a source mesh.
     * @param source The source mesh that triggered the event
     * @param evt The original (browser) event
     * @param additionalData additional data for the event
     * @returns the new ActionEvent
     */ static CreateNew(source, evt, additionalData) {
        const scene = source.getScene();
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(source, scene.pointerX, scene.pointerY, scene.meshUnderPointer || source, evt, additionalData);
    }
    /**
     * Helper function to auto-create an ActionEvent from a source sprite
     * @param source The source sprite that triggered the event
     * @param scene Scene associated with the sprite
     * @param evt The original (browser) event
     * @param additionalData additional data for the event
     * @returns the new ActionEvent
     */ static CreateNewFromSprite(source, scene, evt, additionalData) {
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(source, scene.pointerX, scene.pointerY, scene.meshUnderPointer, evt, additionalData);
    }
    /**
     * Helper function to auto-create an ActionEvent from a scene. If triggered by a mesh use ActionEvent.CreateNew
     * @param scene the scene where the event occurred
     * @param evt The original (browser) event
     * @returns the new ActionEvent
     */ static CreateNewFromScene(scene, evt) {
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(null, scene.pointerX, scene.pointerY, scene.meshUnderPointer, evt);
    }
    /**
     * Helper function to auto-create an ActionEvent from a primitive
     * @param prim defines the target primitive
     * @param pointerPos defines the pointer position
     * @param evt The original (browser) event
     * @param additionalData additional data for the event
     * @returns the new ActionEvent
     */ static CreateNewFromPrimitive(prim, pointerPos, evt, additionalData) {
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(prim, pointerPos.x, pointerPos.y, null, evt, additionalData);
    }
}

});

parcelRegister("8MhbJ", function(module, exports) {

$parcel$export(module.exports, "PostProcessManager", () => $664023a246d3c804$export$f775f8caa29bd9a0);

var $b4i1f = parcelRequire("b4i1f");

var $diGQf = parcelRequire("diGQf");
class $664023a246d3c804$export$f775f8caa29bd9a0 {
    /**
     * Creates a new instance PostProcess
     * @param scene The scene that the post process is associated with.
     */ constructor(scene){
        this._vertexBuffers = {};
        this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        this._scene = scene;
    }
    _prepareBuffers() {
        if (this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind]) return;
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(this._scene.getEngine(), vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        this._buildIndexBuffer();
    }
    _buildIndexBuffer() {
        // Indices
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = this._scene.getEngine().createIndexBuffer(indices);
    }
    /**
     * Rebuilds the vertex buffers of the manager.
     * @internal
     */ _rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (!vb) return;
        vb._rebuild();
        this._buildIndexBuffer();
    }
    // Methods
    /**
     * Prepares a frame to be run through a post process.
     * @param sourceTexture The input texture to the post processes. (default: null)
     * @param postProcesses An array of post processes to be run. (default: null)
     * @returns True if the post processes were able to be run.
     * @internal
     */ _prepareFrame(sourceTexture = null, postProcesses = null) {
        const camera = this._scene.activeCamera;
        if (!camera) return false;
        postProcesses = postProcesses || camera._postProcesses.filter((pp)=>{
            return pp != null;
        });
        if (!postProcesses || postProcesses.length === 0 || !this._scene.postProcessesEnabled) return false;
        postProcesses[0].activate(camera, sourceTexture, postProcesses !== null && postProcesses !== undefined);
        return true;
    }
    /**
     * Manually render a set of post processes to a texture.
     * Please note, the frame buffer won't be unbound after the call in case you have more render to do.
     * @param postProcesses An array of post processes to be run.
     * @param targetTexture The render target wrapper to render to.
     * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight
     * @param faceIndex defines the face to render to if a cubemap is defined as the target
     * @param lodLevel defines which lod of the texture to render to
     * @param doNotBindFrambuffer If set to true, assumes that the framebuffer has been bound previously
     */ directRender(postProcesses, targetTexture = null, forceFullscreenViewport = false, faceIndex = 0, lodLevel = 0, doNotBindFrambuffer = false) {
        const engine = this._scene.getEngine();
        for(let index = 0; index < postProcesses.length; index++){
            if (index < postProcesses.length - 1) postProcesses[index + 1].activate(this._scene.activeCamera || this._scene, targetTexture?.texture);
            else {
                if (targetTexture) engine.bindFramebuffer(targetTexture, faceIndex, undefined, undefined, forceFullscreenViewport, lodLevel);
                else if (!doNotBindFrambuffer) engine.restoreDefaultFramebuffer();
                engine._debugInsertMarker?.(`post process ${postProcesses[index].name} output`);
            }
            const pp = postProcesses[index];
            const effect = pp.apply();
            if (effect) {
                pp.onBeforeRenderObservable.notifyObservers(effect);
                // VBOs
                this._prepareBuffers();
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
                // Draw order
                engine.drawElementsType(0, 0, 6);
                pp.onAfterRenderObservable.notifyObservers(effect);
            }
        }
        // Restore depth buffer
        engine.setDepthBuffer(true);
        engine.setDepthWrite(true);
    }
    /**
     * Finalize the result of the output of the postprocesses.
     * @param doNotPresent If true the result will not be displayed to the screen.
     * @param targetTexture The render target wrapper to render to.
     * @param faceIndex The index of the face to bind the target texture to.
     * @param postProcesses The array of post processes to render.
     * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight (default: false)
     * @internal
     */ _finalizeFrame(doNotPresent, targetTexture, faceIndex, postProcesses, forceFullscreenViewport = false) {
        const camera = this._scene.activeCamera;
        if (!camera) return;
        this.onBeforeRenderObservable.notifyObservers(this);
        postProcesses = postProcesses || camera._postProcesses.filter((pp)=>{
            return pp != null;
        });
        if (postProcesses.length === 0 || !this._scene.postProcessesEnabled) return;
        const engine = this._scene.getEngine();
        for(let index = 0, len = postProcesses.length; index < len; index++){
            const pp = postProcesses[index];
            if (index < len - 1) pp._outputTexture = postProcesses[index + 1].activate(camera, targetTexture?.texture);
            else {
                if (targetTexture) {
                    engine.bindFramebuffer(targetTexture, faceIndex, undefined, undefined, forceFullscreenViewport);
                    pp._outputTexture = targetTexture;
                } else {
                    engine.restoreDefaultFramebuffer();
                    pp._outputTexture = null;
                }
                engine._debugInsertMarker?.(`post process ${postProcesses[index].name} output`);
            }
            if (doNotPresent) break;
            const effect = pp.apply();
            if (effect) {
                pp.onBeforeRenderObservable.notifyObservers(effect);
                // VBOs
                this._prepareBuffers();
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
                // Draw order
                engine.drawElementsType(0, 0, 6);
                pp.onAfterRenderObservable.notifyObservers(effect);
            }
        }
        // Restore states
        engine.setDepthBuffer(true);
        engine.setDepthWrite(true);
        engine.setAlphaMode(0);
    }
    /**
     * Disposes of the post process manager.
     */ dispose() {
        const buffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (buffer) {
            buffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer) {
            this._scene.getEngine()._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
    }
}

});

parcelRegister("jJNg8", function(module, exports) {

$parcel$export(module.exports, "RenderingManager", () => $e5e86e279e78f743$export$648192f328727d18);

var $78VIa = parcelRequire("78VIa");
class $e5e86e279e78f743$export$306a93d948b9dc21 {
}
class $e5e86e279e78f743$export$648192f328727d18 {
    /**
     * Gets or sets a boolean indicating that the manager will not reset between frames.
     * This means that if a mesh becomes invisible or transparent it will not be visible until this boolean is set to false again.
     * By default, the rendering manager will dispatch all active meshes per frame (moving them to the transparent, opaque or alpha testing lists).
     * By turning this property on, you will accelerate the rendering by keeping all these lists unchanged between frames.
     */ get maintainStateBetweenFrames() {
        return this._maintainStateBetweenFrames;
    }
    set maintainStateBetweenFrames(value) {
        if (value === this._maintainStateBetweenFrames) return;
        this._maintainStateBetweenFrames = value;
        if (!this._maintainStateBetweenFrames) this.restoreDispachedFlags();
    }
    /**
     * Restore wasDispatched flags on the lists of elements to render.
     */ restoreDispachedFlags() {
        for (const mesh of this._scene.meshes){
            if (mesh.subMeshes) for (const subMesh of mesh.subMeshes)subMesh._wasDispatched = false;
        }
        if (this._scene.spriteManagers) for (const spriteManager of this._scene.spriteManagers)spriteManager._wasDispatched = false;
        for (const particleSystem of this._scene.particleSystems)particleSystem._wasDispatched = false;
    }
    /**
     * Instantiates a new rendering group for a particular scene
     * @param scene Defines the scene the groups belongs to
     */ constructor(scene){
        /**
         * @internal
         */ this._useSceneAutoClearSetup = false;
        this._renderingGroups = new Array();
        this._autoClearDepthStencil = {};
        this._customOpaqueSortCompareFn = {};
        this._customAlphaTestSortCompareFn = {};
        this._customTransparentSortCompareFn = {};
        this._renderingGroupInfo = new $e5e86e279e78f743$export$306a93d948b9dc21();
        this._maintainStateBetweenFrames = false;
        this._scene = scene;
        for(let i = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; i < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; i++)this._autoClearDepthStencil[i] = {
            autoClear: true,
            depth: true,
            stencil: true
        };
    }
    /**
     * @returns the rendering group with the specified id.
     * @param id the id of the rendering group (0 by default)
     */ getRenderingGroup(id) {
        const renderingGroupId = id || 0;
        this._prepareRenderingGroup(renderingGroupId);
        return this._renderingGroups[renderingGroupId];
    }
    _clearDepthStencilBuffer(depth = true, stencil = true) {
        if (this._depthStencilBufferAlreadyCleaned) return;
        this._scene.getEngine().clear(null, false, depth, stencil);
        this._depthStencilBufferAlreadyCleaned = true;
    }
    /**
     * Renders the entire managed groups. This is used by the scene or the different render targets.
     * @internal
     */ render(customRenderFunction, activeMeshes, renderParticles, renderSprites) {
        // Update the observable context (not null as it only goes away on dispose)
        const info = this._renderingGroupInfo;
        info.scene = this._scene;
        info.camera = this._scene.activeCamera;
        info.renderingManager = this;
        // Dispatch sprites
        if (this._scene.spriteManagers && renderSprites) for(let index = 0; index < this._scene.spriteManagers.length; index++){
            const manager = this._scene.spriteManagers[index];
            this.dispatchSprites(manager);
        }
        // Render
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            this._depthStencilBufferAlreadyCleaned = index === $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS;
            const renderingGroup = this._renderingGroups[index];
            if (!renderingGroup || renderingGroup._empty) continue;
            const renderingGroupMask = 1 << index;
            info.renderingGroupId = index;
            // Before Observable
            this._scene.onBeforeRenderingGroupObservable.notifyObservers(info, renderingGroupMask);
            // Clear depth/stencil if needed
            if ($e5e86e279e78f743$export$648192f328727d18.AUTOCLEAR) {
                const autoClear = this._useSceneAutoClearSetup ? this._scene.getAutoClearDepthStencilSetup(index) : this._autoClearDepthStencil[index];
                if (autoClear && autoClear.autoClear) this._clearDepthStencilBuffer(autoClear.depth, autoClear.stencil);
            }
            // Render
            for (const step of this._scene._beforeRenderingGroupDrawStage)step.action(index);
            renderingGroup.render(customRenderFunction, renderSprites, renderParticles, activeMeshes);
            for (const step of this._scene._afterRenderingGroupDrawStage)step.action(index);
            // After Observable
            this._scene.onAfterRenderingGroupObservable.notifyObservers(info, renderingGroupMask);
        }
    }
    /**
     * Resets the different information of the group to prepare a new frame
     * @internal
     */ reset() {
        if (this.maintainStateBetweenFrames) return;
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            const renderingGroup = this._renderingGroups[index];
            if (renderingGroup) renderingGroup.prepare();
        }
    }
    /**
     * Resets the sprites information of the group to prepare a new frame
     * @internal
     */ resetSprites() {
        if (this.maintainStateBetweenFrames) return;
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            const renderingGroup = this._renderingGroups[index];
            if (renderingGroup) renderingGroup.prepareSprites();
        }
    }
    /**
     * Dispose and release the group and its associated resources.
     * @internal
     */ dispose() {
        this.freeRenderingGroups();
        this._renderingGroups.length = 0;
        this._renderingGroupInfo = null;
    }
    /**
     * Clear the info related to rendering groups preventing retention points during dispose.
     */ freeRenderingGroups() {
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            const renderingGroup = this._renderingGroups[index];
            if (renderingGroup) renderingGroup.dispose();
        }
    }
    _prepareRenderingGroup(renderingGroupId) {
        if (this._renderingGroups[renderingGroupId] === undefined) this._renderingGroups[renderingGroupId] = new (0, $78VIa.RenderingGroup)(renderingGroupId, this._scene, this._customOpaqueSortCompareFn[renderingGroupId], this._customAlphaTestSortCompareFn[renderingGroupId], this._customTransparentSortCompareFn[renderingGroupId]);
    }
    /**
     * Add a sprite manager to the rendering manager in order to render it this frame.
     * @param spriteManager Define the sprite manager to render
     */ dispatchSprites(spriteManager) {
        if (this.maintainStateBetweenFrames && spriteManager._wasDispatched) return;
        spriteManager._wasDispatched = true;
        this.getRenderingGroup(spriteManager.renderingGroupId).dispatchSprites(spriteManager);
    }
    /**
     * Add a particle system to the rendering manager in order to render it this frame.
     * @param particleSystem Define the particle system to render
     */ dispatchParticles(particleSystem) {
        if (this.maintainStateBetweenFrames && particleSystem._wasDispatched) return;
        particleSystem._wasDispatched = true;
        this.getRenderingGroup(particleSystem.renderingGroupId).dispatchParticles(particleSystem);
    }
    /**
     * Add a submesh to the manager in order to render it this frame
     * @param subMesh The submesh to dispatch
     * @param mesh Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
     * @param material Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
     */ dispatch(subMesh, mesh, material) {
        if (mesh === undefined) mesh = subMesh.getMesh();
        if (this.maintainStateBetweenFrames && subMesh._wasDispatched) return;
        subMesh._wasDispatched = true;
        this.getRenderingGroup(mesh.renderingGroupId).dispatch(subMesh, mesh, material);
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversely depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._customOpaqueSortCompareFn[renderingGroupId] = opaqueSortCompareFn;
        this._customAlphaTestSortCompareFn[renderingGroupId] = alphaTestSortCompareFn;
        this._customTransparentSortCompareFn[renderingGroupId] = transparentSortCompareFn;
        if (this._renderingGroups[renderingGroupId]) {
            const group = this._renderingGroups[renderingGroupId];
            group.opaqueSortCompareFn = this._customOpaqueSortCompareFn[renderingGroupId];
            group.alphaTestSortCompareFn = this._customAlphaTestSortCompareFn[renderingGroupId];
            group.transparentSortCompareFn = this._customTransparentSortCompareFn[renderingGroupId];
        }
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     * @param depth Automatically clears depth between groups if true and autoClear is true.
     * @param stencil Automatically clears stencil between groups if true and autoClear is true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
        this._autoClearDepthStencil[renderingGroupId] = {
            autoClear: autoClearDepthStencil,
            depth: depth,
            stencil: stencil
        };
    }
    /**
     * Gets the current auto clear configuration for one rendering group of the rendering
     * manager.
     * @param index the rendering group index to get the information for
     * @returns The auto clear setup for the requested rendering group
     */ getAutoClearDepthStencilSetup(index) {
        return this._autoClearDepthStencil[index];
    }
}
/**
 * The max id used for rendering groups (not included)
 */ $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS = 4;
/**
 * The min id used for rendering groups (included)
 */ $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS = 0;
/**
 * Used to globally prevent autoclearing scenes.
 */ $e5e86e279e78f743$export$648192f328727d18.AUTOCLEAR = true;

});
parcelRegister("78VIa", function(module, exports) {

$parcel$export(module.exports, "RenderingGroup", () => $53360c0949bf5711$export$9c1352b86d43d054);

var $57onU = parcelRequire("57onU");

var $ha1VO = parcelRequire("ha1VO");
class $53360c0949bf5711$export$9c1352b86d43d054 {
    /**
     * Set the opaque sort comparison function.
     * If null the sub meshes will be render in the order they were created
     */ set opaqueSortCompareFn(value) {
        if (value) this._opaqueSortCompareFn = value;
        else this._opaqueSortCompareFn = $53360c0949bf5711$export$9c1352b86d43d054.PainterSortCompare;
        this._renderOpaque = this._renderOpaqueSorted;
    }
    /**
     * Set the alpha test sort comparison function.
     * If null the sub meshes will be render in the order they were created
     */ set alphaTestSortCompareFn(value) {
        if (value) this._alphaTestSortCompareFn = value;
        else this._alphaTestSortCompareFn = $53360c0949bf5711$export$9c1352b86d43d054.PainterSortCompare;
        this._renderAlphaTest = this._renderAlphaTestSorted;
    }
    /**
     * Set the transparent sort comparison function.
     * If null the sub meshes will be render in the order they were created
     */ set transparentSortCompareFn(value) {
        if (value) this._transparentSortCompareFn = value;
        else this._transparentSortCompareFn = $53360c0949bf5711$export$9c1352b86d43d054.defaultTransparentSortCompare;
        this._renderTransparent = this._renderTransparentSorted;
    }
    /**
     * Creates a new rendering group.
     * @param index The rendering group index
     * @param scene
     * @param opaqueSortCompareFn The opaque sort comparison function. If null no order is applied
     * @param alphaTestSortCompareFn The alpha test sort comparison function. If null no order is applied
     * @param transparentSortCompareFn The transparent sort comparison function. If null back to front + alpha index sort is applied
     */ constructor(index, scene, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null){
        this.index = index;
        this._opaqueSubMeshes = new (0, $57onU.SmartArray)(256);
        this._transparentSubMeshes = new (0, $57onU.SmartArray)(256);
        this._alphaTestSubMeshes = new (0, $57onU.SmartArray)(256);
        this._depthOnlySubMeshes = new (0, $57onU.SmartArray)(256);
        this._particleSystems = new (0, $57onU.SmartArray)(256);
        this._spriteManagers = new (0, $57onU.SmartArray)(256);
        /** @internal */ this._empty = true;
        /** @internal */ this._edgesRenderers = new (0, $57onU.SmartArrayNoDuplicate)(16);
        this._scene = scene;
        this.opaqueSortCompareFn = opaqueSortCompareFn;
        this.alphaTestSortCompareFn = alphaTestSortCompareFn;
        this.transparentSortCompareFn = transparentSortCompareFn;
    }
    /**
     * Render all the sub meshes contained in the group.
     * @param customRenderFunction Used to override the default render behaviour of the group.
     * @param renderSprites
     * @param renderParticles
     * @param activeMeshes
     */ render(customRenderFunction, renderSprites, renderParticles, activeMeshes) {
        if (customRenderFunction) {
            customRenderFunction(this._opaqueSubMeshes, this._alphaTestSubMeshes, this._transparentSubMeshes, this._depthOnlySubMeshes);
            return;
        }
        const engine = this._scene.getEngine();
        // Depth only
        if (this._depthOnlySubMeshes.length !== 0) {
            engine.setColorWrite(false);
            this._renderAlphaTest(this._depthOnlySubMeshes);
            engine.setColorWrite(true);
        }
        // Opaque
        if (this._opaqueSubMeshes.length !== 0) this._renderOpaque(this._opaqueSubMeshes);
        // Alpha test
        if (this._alphaTestSubMeshes.length !== 0) this._renderAlphaTest(this._alphaTestSubMeshes);
        const stencilState = engine.getStencilBuffer();
        engine.setStencilBuffer(false);
        // Sprites
        if (renderSprites) this._renderSprites();
        // Particles
        if (renderParticles) this._renderParticles(activeMeshes);
        if (this.onBeforeTransparentRendering) this.onBeforeTransparentRendering();
        // Transparent
        if (this._transparentSubMeshes.length !== 0 || this._scene.useOrderIndependentTransparency) {
            engine.setStencilBuffer(stencilState);
            if (this._scene.useOrderIndependentTransparency) {
                const excludedMeshes = this._scene.depthPeelingRenderer.render(this._transparentSubMeshes);
                if (excludedMeshes.length) // Render leftover meshes that could not be processed by depth peeling
                this._renderTransparent(excludedMeshes);
            } else this._renderTransparent(this._transparentSubMeshes);
            engine.setAlphaMode(0);
        }
        // Set back stencil to false in case it changes before the edge renderer.
        engine.setStencilBuffer(false);
        // Edges
        if (this._edgesRenderers.length) {
            for(let edgesRendererIndex = 0; edgesRendererIndex < this._edgesRenderers.length; edgesRendererIndex++)this._edgesRenderers.data[edgesRendererIndex].render();
            engine.setAlphaMode(0);
        }
        // Restore Stencil state.
        engine.setStencilBuffer(stencilState);
    }
    /**
     * Renders the opaque submeshes in the order from the opaqueSortCompareFn.
     * @param subMeshes The submeshes to render
     */ _renderOpaqueSorted(subMeshes) {
        $53360c0949bf5711$export$9c1352b86d43d054._RenderSorted(subMeshes, this._opaqueSortCompareFn, this._scene.activeCamera, false);
    }
    /**
     * Renders the opaque submeshes in the order from the alphatestSortCompareFn.
     * @param subMeshes The submeshes to render
     */ _renderAlphaTestSorted(subMeshes) {
        $53360c0949bf5711$export$9c1352b86d43d054._RenderSorted(subMeshes, this._alphaTestSortCompareFn, this._scene.activeCamera, false);
    }
    /**
     * Renders the opaque submeshes in the order from the transparentSortCompareFn.
     * @param subMeshes The submeshes to render
     */ _renderTransparentSorted(subMeshes) {
        $53360c0949bf5711$export$9c1352b86d43d054._RenderSorted(subMeshes, this._transparentSortCompareFn, this._scene.activeCamera, true);
    }
    /**
     * Renders the submeshes in a specified order.
     * @param subMeshes The submeshes to sort before render
     * @param sortCompareFn The comparison function use to sort
     * @param camera The camera position use to preprocess the submeshes to help sorting
     * @param transparent Specifies to activate blending if true
     */ static _RenderSorted(subMeshes, sortCompareFn, camera, transparent) {
        let subIndex = 0;
        let subMesh;
        const cameraPosition = camera ? camera.globalPosition : $53360c0949bf5711$export$9c1352b86d43d054._ZeroVector;
        if (transparent) for(; subIndex < subMeshes.length; subIndex++){
            subMesh = subMeshes.data[subIndex];
            subMesh._alphaIndex = subMesh.getMesh().alphaIndex;
            subMesh._distanceToCamera = (0, $ha1VO.Vector3).Distance(subMesh.getBoundingInfo().boundingSphere.centerWorld, cameraPosition);
        }
        const sortedArray = subMeshes.length === subMeshes.data.length ? subMeshes.data : subMeshes.data.slice(0, subMeshes.length);
        if (sortCompareFn) sortedArray.sort(sortCompareFn);
        const scene = sortedArray[0].getMesh().getScene();
        for(subIndex = 0; subIndex < sortedArray.length; subIndex++){
            subMesh = sortedArray[subIndex];
            if (scene._activeMeshesFrozenButKeepClipping && !subMesh.isInFrustum(scene._frustumPlanes)) continue;
            if (transparent) {
                const material = subMesh.getMaterial();
                if (material && material.needDepthPrePass) {
                    const engine = material.getScene().getEngine();
                    engine.setColorWrite(false);
                    engine.setAlphaMode(0);
                    subMesh.render(false);
                    engine.setColorWrite(true);
                }
            }
            subMesh.render(transparent);
        }
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are rendered back to front if in the same alpha index.
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static defaultTransparentSortCompare(a, b) {
        // Alpha index first
        if (a._alphaIndex > b._alphaIndex) return 1;
        if (a._alphaIndex < b._alphaIndex) return -1;
        // Then distance to camera
        return $53360c0949bf5711$export$9c1352b86d43d054.backToFrontSortCompare(a, b);
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are rendered back to front.
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static backToFrontSortCompare(a, b) {
        // Then distance to camera
        if (a._distanceToCamera < b._distanceToCamera) return 1;
        if (a._distanceToCamera > b._distanceToCamera) return -1;
        return 0;
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are rendered front to back (prevent overdraw).
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static frontToBackSortCompare(a, b) {
        // Then distance to camera
        if (a._distanceToCamera < b._distanceToCamera) return -1;
        if (a._distanceToCamera > b._distanceToCamera) return 1;
        return 0;
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are grouped by material then geometry.
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ static PainterSortCompare(a, b) {
        const meshA = a.getMesh();
        const meshB = b.getMesh();
        if (meshA.material && meshB.material) return meshA.material.uniqueId - meshB.material.uniqueId;
        return meshA.uniqueId - meshB.uniqueId;
    }
    /**
     * Resets the different lists of submeshes to prepare a new frame.
     */ prepare() {
        this._opaqueSubMeshes.reset();
        this._transparentSubMeshes.reset();
        this._alphaTestSubMeshes.reset();
        this._depthOnlySubMeshes.reset();
        this._particleSystems.reset();
        this.prepareSprites();
        this._edgesRenderers.reset();
        this._empty = true;
    }
    /**
     * Resets the different lists of sprites to prepare a new frame.
     */ prepareSprites() {
        this._spriteManagers.reset();
    }
    dispose() {
        this._opaqueSubMeshes.dispose();
        this._transparentSubMeshes.dispose();
        this._alphaTestSubMeshes.dispose();
        this._depthOnlySubMeshes.dispose();
        this._particleSystems.dispose();
        this._spriteManagers.dispose();
        this._edgesRenderers.dispose();
    }
    /**
     * Inserts the submesh in its correct queue depending on its material.
     * @param subMesh The submesh to dispatch
     * @param [mesh] Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
     * @param [material] Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
     */ dispatch(subMesh, mesh, material) {
        // Get mesh and materials if not provided
        if (mesh === undefined) mesh = subMesh.getMesh();
        if (material === undefined) material = subMesh.getMaterial();
        if (material === null || material === undefined) return;
        if (material.needAlphaBlendingForMesh(mesh)) // Transparent
        this._transparentSubMeshes.push(subMesh);
        else if (material.needAlphaTesting()) {
            // Alpha test
            if (material.needDepthPrePass) this._depthOnlySubMeshes.push(subMesh);
            this._alphaTestSubMeshes.push(subMesh);
        } else {
            if (material.needDepthPrePass) this._depthOnlySubMeshes.push(subMesh);
            this._opaqueSubMeshes.push(subMesh); // Opaque
        }
        mesh._renderingGroup = this;
        if (mesh._edgesRenderer && mesh.isEnabled() && mesh.isVisible && mesh._edgesRenderer.isEnabled) this._edgesRenderers.pushNoDuplicate(mesh._edgesRenderer);
        this._empty = false;
    }
    dispatchSprites(spriteManager) {
        this._spriteManagers.push(spriteManager);
        this._empty = false;
    }
    dispatchParticles(particleSystem) {
        this._particleSystems.push(particleSystem);
        this._empty = false;
    }
    _renderParticles(activeMeshes) {
        if (this._particleSystems.length === 0) return;
        // Particles
        const activeCamera = this._scene.activeCamera;
        this._scene.onBeforeParticlesRenderingObservable.notifyObservers(this._scene);
        for(let particleIndex = 0; particleIndex < this._particleSystems.length; particleIndex++){
            const particleSystem = this._particleSystems.data[particleIndex];
            if ((activeCamera && activeCamera.layerMask & particleSystem.layerMask) === 0) continue;
            const emitter = particleSystem.emitter;
            if (!emitter.position || !activeMeshes || activeMeshes.indexOf(emitter) !== -1) this._scene._activeParticles.addCount(particleSystem.render(), false);
        }
        this._scene.onAfterParticlesRenderingObservable.notifyObservers(this._scene);
    }
    _renderSprites() {
        if (!this._scene.spritesEnabled || this._spriteManagers.length === 0) return;
        // Sprites
        const activeCamera = this._scene.activeCamera;
        this._scene.onBeforeSpritesRenderingObservable.notifyObservers(this._scene);
        for(let id = 0; id < this._spriteManagers.length; id++){
            const spriteManager = this._spriteManagers.data[id];
            if ((activeCamera && activeCamera.layerMask & spriteManager.layerMask) !== 0) spriteManager.render();
        }
        this._scene.onAfterSpritesRenderingObservable.notifyObservers(this._scene);
    }
}
$53360c0949bf5711$export$9c1352b86d43d054._ZeroVector = (0, $ha1VO.Vector3).Zero();

});


parcelRegister("bv05l", function(module, exports) {

$parcel$export(module.exports, "SceneComponentConstants", () => $85f2a7de3c8a2128$export$1e988a9817f2f20f);
$parcel$export(module.exports, "Stage", () => $85f2a7de3c8a2128$export$208cd1682bd0e4b6);
/**
 * Groups all the scene component constants in one place to ease maintenance.
 * @internal
 */ class $85f2a7de3c8a2128$export$1e988a9817f2f20f {
}
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_EFFECTLAYER = "EffectLayer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_LAYER = "Layer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_LENSFLARESYSTEM = "LensFlareSystem";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_BOUNDINGBOXRENDERER = "BoundingBoxRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PARTICLESYSTEM = "ParticleSystem";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_GAMEPAD = "Gamepad";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SIMPLIFICATIONQUEUE = "SimplificationQueue";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_GEOMETRYBUFFERRENDERER = "GeometryBufferRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PREPASSRENDERER = "PrePassRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_DEPTHRENDERER = "DepthRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_DEPTHPEELINGRENDERER = "DepthPeelingRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_POSTPROCESSRENDERPIPELINEMANAGER = "PostProcessRenderPipelineManager";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SPRITE = "Sprite";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SUBSURFACE = "SubSurface";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_OUTLINERENDERER = "Outline";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PROCEDURALTEXTURE = "ProceduralTexture";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SHADOWGENERATOR = "ShadowGenerator";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_OCTREE = "Octree";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PHYSICSENGINE = "PhysicsEngine";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_AUDIO = "Audio";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_FLUIDRENDERER = "FluidRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_IBLCDFGENERATOR = "iblCDFGenerator";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_ISREADYFORMESH_EFFECTLAYER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFOREEVALUATEACTIVEMESH_BOUNDINGBOXRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_EVALUATESUBMESH_BOUNDINGBOXRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_PREACTIVEMESH_BOUNDINGBOXRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERADRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERADRAW_EFFECTLAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERADRAW_LAYER = 2;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERTARGETDRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERTARGETDRAW_LAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERINGMESH_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERINGMESH_OUTLINE = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGMESH_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGMESH_OUTLINE = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGGROUPDRAW_BOUNDINGBOXRENDERER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERAUPDATE_SIMPLIFICATIONQUEUE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECLEAR_PROCEDURALTEXTURE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECLEAR_PREPASS = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERTARGETCLEAR_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERTARGETDRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERTARGETDRAW_LAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_EFFECTLAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_LENSFLARESYSTEM = 2;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW = 3;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_LAYER = 4;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_FLUIDRENDERER = 5;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERAPOSTPROCESS_LAYER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERTARGETPOSTPROCESS_LAYER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDER_AUDIO = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_DEPTHRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_SHADOWGENERATOR = 2;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER = 3;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERACTIVECAMERARENDERTARGETS_DEPTHRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERACTIVECAMERARENDERTARGETS_FLUIDRENDERER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_POINTERMOVE_SPRITE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_POINTERDOWN_SPRITE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_POINTERUP_SPRITE = 0;
class $85f2a7de3c8a2128$export$208cd1682bd0e4b6 extends Array {
    /**
     * Hide ctor from the rest of the world.
     * @param items The items to add.
     */ constructor(items){
        super(...items);
    }
    /**
     * Creates a new Stage.
     * @returns A new instance of a Stage
     */ static Create() {
        return Object.create($85f2a7de3c8a2128$export$208cd1682bd0e4b6.prototype);
    }
    /**
     * Registers a step in an ordered way in the targeted stage.
     * @param index Defines the position to register the step in
     * @param component Defines the component attached to the step
     * @param action Defines the action to launch during the step
     */ registerStep(index, component, action) {
        let i = 0;
        let maxIndex = Number.MAX_VALUE;
        for(; i < this.length; i++){
            const step = this[i];
            maxIndex = step.index;
            if (index < maxIndex) break;
        }
        this.splice(i, 0, {
            index: index,
            component: component,
            action: action.bind(component)
        });
    }
    /**
     * Clears all the steps from the stage.
     */ clear() {
        this.length = 0;
    }
}

});

parcelRegister("7md5A", function(module, exports) {

$parcel$export(module.exports, "InputManager", () => $55b4bdb4e513ac29$export$2da2653229140a6c);

var $cfkw4 = parcelRequire("cfkw4");

var $kNPE8 = parcelRequire("kNPE8");

var $gzCma = parcelRequire("gzCma");

var $ha1VO = parcelRequire("ha1VO");

var $cmj0B = parcelRequire("cmj0B");

var $bcFoB = parcelRequire("bcFoB");

var $1orLO = parcelRequire("1orLO");

var $gAZ7u = parcelRequire("gAZ7u");

var $ejQPp = parcelRequire("ejQPp");

var $4e7OM = parcelRequire("4e7OM");
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $55b4bdb4e513ac29$var$_ClickInfo {
    constructor(){
        this._singleClick = false;
        this._doubleClick = false;
        this._hasSwiped = false;
        this._ignore = false;
    }
    get singleClick() {
        return this._singleClick;
    }
    get doubleClick() {
        return this._doubleClick;
    }
    get hasSwiped() {
        return this._hasSwiped;
    }
    get ignore() {
        return this._ignore;
    }
    set singleClick(b) {
        this._singleClick = b;
    }
    set doubleClick(b) {
        this._doubleClick = b;
    }
    set hasSwiped(b) {
        this._hasSwiped = b;
    }
    set ignore(b) {
        this._ignore = b;
    }
}
class $55b4bdb4e513ac29$export$2da2653229140a6c {
    /**
     * Creates a new InputManager
     * @param scene - defines the hosting scene
     */ constructor(scene){
        /** This is a defensive check to not allow control attachment prior to an already active one. If already attached, previous control is unattached before attaching the new one. */ this._alreadyAttached = false;
        this._meshPickProceed = false;
        this._currentPickResult = null;
        this._previousPickResult = null;
        this._activePointerIds = new Array();
        /** Tracks the count of used slots in _activePointerIds for perf */ this._activePointerIdsCount = 0;
        this._doubleClickOccured = false;
        this._isSwiping = false;
        this._swipeButtonPressed = -1;
        this._skipPointerTap = false;
        this._isMultiTouchGesture = false;
        this._pointerX = 0;
        this._pointerY = 0;
        this._startingPointerPosition = new (0, $ha1VO.Vector2)(0, 0);
        this._previousStartingPointerPosition = new (0, $ha1VO.Vector2)(0, 0);
        this._startingPointerTime = 0;
        this._previousStartingPointerTime = 0;
        this._pointerCaptures = {};
        this._meshUnderPointerId = {};
        this._movePointerInfo = null;
        this._cameraObserverCount = 0;
        this._delayedClicks = [
            null,
            null,
            null,
            null,
            null
        ];
        this._deviceSourceManager = null;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this._scene) return;
    }
    /**
     * Gets the mesh that is currently under the pointer
     * @returns Mesh that the pointer is pointer is hovering over
     */ get meshUnderPointer() {
        if (this._movePointerInfo) {
            // Because _pointerOverMesh is populated as part of _pickMove, we need to force a pick to update it.
            // Calling _pickMove calls _setCursorAndPointerOverMesh which calls setPointerOverMesh
            this._movePointerInfo._generatePickInfo();
            // Once we have what we need, we can clear _movePointerInfo because we don't need it anymore
            this._movePointerInfo = null;
        }
        return this._pointerOverMesh;
    }
    /**
     * When using more than one pointer (for example in XR) you can get the mesh under the specific pointer
     * @param pointerId - the pointer id to use
     * @returns The mesh under this pointer id or null if not found
     */ getMeshUnderPointerByPointerId(pointerId) {
        return this._meshUnderPointerId[pointerId] || null;
    }
    /**
     * Gets the pointer coordinates in 2D without any translation (ie. straight out of the pointer event)
     * @returns Vector with X/Y values directly from pointer event
     */ get unTranslatedPointer() {
        return new (0, $ha1VO.Vector2)(this._unTranslatedPointerX, this._unTranslatedPointerY);
    }
    /**
     * Gets or sets the current on-screen X position of the pointer
     * @returns Translated X with respect to screen
     */ get pointerX() {
        return this._pointerX;
    }
    set pointerX(value) {
        this._pointerX = value;
    }
    /**
     * Gets or sets the current on-screen Y position of the pointer
     * @returns Translated Y with respect to screen
     */ get pointerY() {
        return this._pointerY;
    }
    set pointerY(value) {
        this._pointerY = value;
    }
    _updatePointerPosition(evt) {
        const canvasRect = this._scene.getEngine().getInputElementClientRect();
        if (!canvasRect) return;
        this._pointerX = evt.clientX - canvasRect.left;
        this._pointerY = evt.clientY - canvasRect.top;
        this._unTranslatedPointerX = this._pointerX;
        this._unTranslatedPointerY = this._pointerY;
    }
    _processPointerMove(pickResult, evt) {
        const scene = this._scene;
        const engine = scene.getEngine();
        const canvas = engine.getInputElement();
        if (canvas) {
            canvas.tabIndex = engine.canvasTabIndex;
            // Restore pointer
            if (!scene.doNotHandleCursors) canvas.style.cursor = scene.defaultCursor;
        }
        this._setCursorAndPointerOverMesh(pickResult, evt, scene);
        for (const step of scene._pointerMoveStage){
            // If _pointerMoveState is defined, we have an active spriteManager and can't use Lazy Picking
            // Therefore, we need to force a pick to update the pickResult
            pickResult = pickResult || this._pickMove(evt);
            const isMeshPicked = pickResult?.pickedMesh ? true : false;
            pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, isMeshPicked, canvas);
        }
        const type = evt.inputIndex >= (0, $1orLO.PointerInput).MouseWheelX && evt.inputIndex <= (0, $1orLO.PointerInput).MouseWheelZ ? (0, $cfkw4.PointerEventTypes).POINTERWHEEL : (0, $cfkw4.PointerEventTypes).POINTERMOVE;
        if (scene.onPointerMove) {
            // Because of lazy picking, we need to force a pick to update the pickResult
            pickResult = pickResult || this._pickMove(evt);
            scene.onPointerMove(evt, pickResult, type);
        }
        let pointerInfo;
        if (pickResult) {
            pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
            this._setRayOnPointerInfo(pickResult, evt);
        } else {
            pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, null, this);
            this._movePointerInfo = pointerInfo;
        }
        if (scene.onPointerObservable.hasObservers()) scene.onPointerObservable.notifyObservers(pointerInfo, type);
    }
    // Pointers handling
    /** @internal */ _setRayOnPointerInfo(pickInfo, event) {
        const scene = this._scene;
        if (pickInfo && (0, $4e7OM._ImportHelper)._IsPickingAvailable) {
            if (!pickInfo.ray) pickInfo.ray = scene.createPickingRay(event.offsetX, event.offsetY, (0, $ha1VO.Matrix).Identity(), scene.activeCamera);
        }
    }
    /** @internal */ _addCameraPointerObserver(observer, mask) {
        this._cameraObserverCount++;
        return this._scene.onPointerObservable.add(observer, mask);
    }
    /** @internal */ _removeCameraPointerObserver(observer) {
        this._cameraObserverCount--;
        return this._scene.onPointerObservable.remove(observer);
    }
    _checkForPicking() {
        return !!(this._scene.onPointerObservable.observers.length > this._cameraObserverCount || this._scene.onPointerPick);
    }
    _checkPrePointerObservable(pickResult, evt, type) {
        const scene = this._scene;
        const pi = new (0, $cfkw4.PointerInfoPre)(type, evt, this._unTranslatedPointerX, this._unTranslatedPointerY);
        if (pickResult) {
            pi.originalPickingInfo = pickResult;
            pi.ray = pickResult.ray;
            if (evt.pointerType === "xr-near" && pickResult.originMesh) pi.nearInteractionPickingInfo = pickResult;
        }
        scene.onPrePointerObservable.notifyObservers(pi, type);
        if (pi.skipOnPointerObservable) return true;
        else return false;
    }
    /** @internal */ _pickMove(evt) {
        const scene = this._scene;
        const pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerMovePredicate, scene.pointerMoveFastCheck, scene.cameraToUseForPointers, scene.pointerMoveTrianglePredicate);
        this._setCursorAndPointerOverMesh(pickResult, evt, scene);
        return pickResult;
    }
    _setCursorAndPointerOverMesh(pickResult, evt, scene) {
        const engine = scene.getEngine();
        const canvas = engine.getInputElement();
        if (pickResult?.pickedMesh) {
            this.setPointerOverMesh(pickResult.pickedMesh, evt.pointerId, pickResult, evt);
            if (!scene.doNotHandleCursors && canvas && this._pointerOverMesh) {
                const actionManager = this._pointerOverMesh._getActionManagerForTrigger();
                if (actionManager && actionManager.hasPointerTriggers) canvas.style.cursor = actionManager.hoverCursor || scene.hoverCursor;
            }
        } else this.setPointerOverMesh(null, evt.pointerId, pickResult, evt);
    }
    /**
     * Use this method to simulate a pointer move on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult - pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     */ simulatePointerMove(pickResult, pointerEventInit) {
        const evt = new PointerEvent("pointermove", pointerEventInit);
        evt.inputIndex = (0, $1orLO.PointerInput).Move;
        if (this._checkPrePointerObservable(pickResult, evt, (0, $cfkw4.PointerEventTypes).POINTERMOVE)) return;
        this._processPointerMove(pickResult, evt);
    }
    /**
     * Use this method to simulate a pointer down on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult - pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     */ simulatePointerDown(pickResult, pointerEventInit) {
        const evt = new PointerEvent("pointerdown", pointerEventInit);
        evt.inputIndex = evt.button + 2;
        if (this._checkPrePointerObservable(pickResult, evt, (0, $cfkw4.PointerEventTypes).POINTERDOWN)) return;
        this._processPointerDown(pickResult, evt);
    }
    _processPointerDown(pickResult, evt) {
        const scene = this._scene;
        if (pickResult?.pickedMesh) {
            this._pickedDownMesh = pickResult.pickedMesh;
            const actionManager = pickResult.pickedMesh._getActionManagerForTrigger();
            if (actionManager) {
                if (actionManager.hasPickTriggers) {
                    actionManager.processTrigger(5, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                    switch(evt.button){
                        case 0:
                            actionManager.processTrigger(2, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                            break;
                        case 1:
                            actionManager.processTrigger(4, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                            break;
                        case 2:
                            actionManager.processTrigger(3, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                            break;
                    }
                }
                if (actionManager.hasSpecificTrigger(8)) window.setTimeout(()=>{
                    const pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, (mesh)=>mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.actionManager && mesh.actionManager.hasSpecificTrigger(8) && mesh === this._pickedDownMesh, false, scene.cameraToUseForPointers);
                    if (pickResult?.pickedMesh && actionManager) {
                        if (this._activePointerIdsCount !== 0 && Date.now() - this._startingPointerTime > $55b4bdb4e513ac29$export$2da2653229140a6c.LongPressDelay && !this._isPointerSwiping()) {
                            this._startingPointerTime = 0;
                            actionManager.processTrigger(8, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt));
                        }
                    }
                }, $55b4bdb4e513ac29$export$2da2653229140a6c.LongPressDelay);
            }
        } else for (const step of scene._pointerDownStage)pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, evt, false);
        let pointerInfo;
        const type = (0, $cfkw4.PointerEventTypes).POINTERDOWN;
        if (pickResult) {
            if (scene.onPointerDown) scene.onPointerDown(evt, pickResult, type);
            pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
            this._setRayOnPointerInfo(pickResult, evt);
        } else pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, null, this);
        if (scene.onPointerObservable.hasObservers()) scene.onPointerObservable.notifyObservers(pointerInfo, type);
    }
    /**
     * @internal
     * @internals Boolean if delta for pointer exceeds drag movement threshold
     */ _isPointerSwiping() {
        return this._isSwiping;
    }
    /**
     * Use this method to simulate a pointer up on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult - pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @param doubleTap - indicates that the pointer up event should be considered as part of a double click (false by default)
     */ simulatePointerUp(pickResult, pointerEventInit, doubleTap) {
        const evt = new PointerEvent("pointerup", pointerEventInit);
        evt.inputIndex = (0, $1orLO.PointerInput).Move;
        const clickInfo = new $55b4bdb4e513ac29$var$_ClickInfo();
        if (doubleTap) clickInfo.doubleClick = true;
        else clickInfo.singleClick = true;
        if (this._checkPrePointerObservable(pickResult, evt, (0, $cfkw4.PointerEventTypes).POINTERUP)) return;
        this._processPointerUp(pickResult, evt, clickInfo);
    }
    _processPointerUp(pickResult, evt, clickInfo) {
        const scene = this._scene;
        if (pickResult?.pickedMesh) {
            this._pickedUpMesh = pickResult.pickedMesh;
            if (this._pickedDownMesh === this._pickedUpMesh) {
                if (scene.onPointerPick) scene.onPointerPick(evt, pickResult);
                if (clickInfo.singleClick && !clickInfo.ignore && scene.onPointerObservable.observers.length > this._cameraObserverCount) {
                    const type = (0, $cfkw4.PointerEventTypes).POINTERPICK;
                    const pi = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
                    this._setRayOnPointerInfo(pickResult, evt);
                    scene.onPointerObservable.notifyObservers(pi, type);
                }
            }
            const actionManager = pickResult.pickedMesh._getActionManagerForTrigger();
            if (actionManager && !clickInfo.ignore) {
                actionManager.processTrigger(7, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                if (!clickInfo.hasSwiped && clickInfo.singleClick) actionManager.processTrigger(1, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                const doubleClickActionManager = pickResult.pickedMesh._getActionManagerForTrigger(6);
                if (clickInfo.doubleClick && doubleClickActionManager) doubleClickActionManager.processTrigger(6, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
            }
        } else {
            if (!clickInfo.ignore) for (const step of scene._pointerUpStage)pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, evt, clickInfo.doubleClick);
        }
        if (this._pickedDownMesh && this._pickedDownMesh !== this._pickedUpMesh) {
            const pickedDownActionManager = this._pickedDownMesh._getActionManagerForTrigger(16);
            if (pickedDownActionManager) pickedDownActionManager.processTrigger(16, (0, $cmj0B.ActionEvent).CreateNew(this._pickedDownMesh, evt));
        }
        if (!clickInfo.ignore) {
            const pi = new (0, $cfkw4.PointerInfo)((0, $cfkw4.PointerEventTypes).POINTERUP, evt, pickResult);
            // Set ray on picking info.  Note that this info will also be reused for the tap notification.
            this._setRayOnPointerInfo(pickResult, evt);
            scene.onPointerObservable.notifyObservers(pi, (0, $cfkw4.PointerEventTypes).POINTERUP);
            if (scene.onPointerUp) scene.onPointerUp(evt, pickResult, (0, $cfkw4.PointerEventTypes).POINTERUP);
            if (!clickInfo.hasSwiped && !this._skipPointerTap && !this._isMultiTouchGesture) {
                let type = 0;
                if (clickInfo.singleClick) type = (0, $cfkw4.PointerEventTypes).POINTERTAP;
                else if (clickInfo.doubleClick) type = (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP;
                if (type) {
                    const pi = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
                    if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) scene.onPointerObservable.notifyObservers(pi, type);
                }
            }
        }
    }
    /**
     * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
     * @param pointerId - defines the pointer id to use in a multi-touch scenario (0 by default)
     * @returns true if the pointer was captured
     */ isPointerCaptured(pointerId = 0) {
        return this._pointerCaptures[pointerId];
    }
    /**
     * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
     * @param attachUp - defines if you want to attach events to pointerup
     * @param attachDown - defines if you want to attach events to pointerdown
     * @param attachMove - defines if you want to attach events to pointermove
     * @param elementToAttachTo - defines the target DOM element to attach to (will use the canvas by default)
     */ attachControl(attachUp = true, attachDown = true, attachMove = true, elementToAttachTo = null) {
        const scene = this._scene;
        const engine = scene.getEngine();
        if (!elementToAttachTo) elementToAttachTo = engine.getInputElement();
        if (this._alreadyAttached) this.detachControl();
        if (elementToAttachTo) this._alreadyAttachedTo = elementToAttachTo;
        this._deviceSourceManager = new (0, $gAZ7u.DeviceSourceManager)(engine);
        // Because this is only called from _initClickEvent, which is called in _onPointerUp, we'll use the pointerUpPredicate for the pick call
        this._initActionManager = (act)=>{
            if (!this._meshPickProceed) {
                const pickResult = scene.skipPointerUpPicking || scene._registeredActions === 0 && !this._checkForPicking() && !scene.onPointerUp ? null : scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerUpPredicate, scene.pointerUpFastCheck, scene.cameraToUseForPointers, scene.pointerUpTrianglePredicate);
                this._currentPickResult = pickResult;
                if (pickResult) act = pickResult.hit && pickResult.pickedMesh ? pickResult.pickedMesh._getActionManagerForTrigger() : null;
                this._meshPickProceed = true;
            }
            return act;
        };
        this._delayedSimpleClick = (btn, clickInfo, cb)=>{
            // double click delay is over and that no double click has been raised since, or the 2 consecutive keys pressed are different
            if (Date.now() - this._previousStartingPointerTime > $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay && !this._doubleClickOccured || btn !== this._previousButtonPressed) {
                this._doubleClickOccured = false;
                clickInfo.singleClick = true;
                clickInfo.ignore = false;
                // If we have a delayed click, we need to resolve the TAP event
                if (this._delayedClicks[btn]) {
                    const evt = this._delayedClicks[btn].evt;
                    const type = (0, $cfkw4.PointerEventTypes).POINTERTAP;
                    const pi = new (0, $cfkw4.PointerInfo)(type, evt, this._currentPickResult);
                    if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) scene.onPointerObservable.notifyObservers(pi, type);
                    // Clear the delayed click
                    this._delayedClicks[btn] = null;
                }
            }
        };
        this._initClickEvent = (obs1, obs2, evt, cb)=>{
            const clickInfo = new $55b4bdb4e513ac29$var$_ClickInfo();
            this._currentPickResult = null;
            let act = null;
            let checkPicking = obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERPICK) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERPICK) || obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERTAP) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERTAP) || obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
            if (!checkPicking && (0, $kNPE8.AbstractActionManager)) {
                act = this._initActionManager(act, clickInfo);
                if (act) checkPicking = act.hasPickTriggers;
            }
            let needToIgnoreNext = false;
            // Never pick if this is a multi-touch gesture (e.g. pinch)
            checkPicking = checkPicking && !this._isMultiTouchGesture;
            if (checkPicking) {
                const btn = evt.button;
                clickInfo.hasSwiped = this._isPointerSwiping();
                if (!clickInfo.hasSwiped) {
                    let checkSingleClickImmediately = !$55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode;
                    if (!checkSingleClickImmediately) {
                        checkSingleClickImmediately = !obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) && !obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
                        if (checkSingleClickImmediately && !(0, $kNPE8.AbstractActionManager).HasSpecificTrigger(6)) {
                            act = this._initActionManager(act, clickInfo);
                            if (act) checkSingleClickImmediately = !act.hasSpecificTrigger(6);
                        }
                    }
                    if (checkSingleClickImmediately) // single click detected if double click delay is over or two different successive keys pressed without exclusive double click or no double click required
                    {
                        if (Date.now() - this._previousStartingPointerTime > $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay || btn !== this._previousButtonPressed) {
                            clickInfo.singleClick = true;
                            cb(clickInfo, this._currentPickResult);
                            needToIgnoreNext = true;
                        }
                    } else {
                        // Queue up a delayed click, just in case this isn't a double click
                        // It should be noted that while this delayed event happens
                        // because of user input, it shouldn't be considered as a direct,
                        // timing-dependent result of that input.  It's meant to just fire the TAP event
                        const delayedClick = {
                            evt: evt,
                            clickInfo: clickInfo,
                            timeoutId: window.setTimeout(this._delayedSimpleClick.bind(this, btn, clickInfo, cb), $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay)
                        };
                        this._delayedClicks[btn] = delayedClick;
                    }
                    let checkDoubleClick = obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
                    if (!checkDoubleClick && (0, $kNPE8.AbstractActionManager).HasSpecificTrigger(6)) {
                        act = this._initActionManager(act, clickInfo);
                        if (act) checkDoubleClick = act.hasSpecificTrigger(6);
                    }
                    if (checkDoubleClick) {
                        // two successive keys pressed are equal, double click delay is not over and double click has not just occurred
                        if (btn === this._previousButtonPressed && Date.now() - this._previousStartingPointerTime < $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay && !this._doubleClickOccured) {
                            // pointer has not moved for 2 clicks, it's a double click
                            if (!clickInfo.hasSwiped && !this._isPointerSwiping()) {
                                this._previousStartingPointerTime = 0;
                                this._doubleClickOccured = true;
                                clickInfo.doubleClick = true;
                                clickInfo.ignore = false;
                                // If we have a pending click, we need to cancel it
                                if ($55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode && this._delayedClicks[btn]) {
                                    clearTimeout(this._delayedClicks[btn]?.timeoutId);
                                    this._delayedClicks[btn] = null;
                                }
                                cb(clickInfo, this._currentPickResult);
                            } else {
                                this._doubleClickOccured = false;
                                this._previousStartingPointerTime = this._startingPointerTime;
                                this._previousStartingPointerPosition.x = this._startingPointerPosition.x;
                                this._previousStartingPointerPosition.y = this._startingPointerPosition.y;
                                this._previousButtonPressed = btn;
                                if ($55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode) {
                                    // If we have a delayed click, we need to cancel it
                                    if (this._delayedClicks[btn]) {
                                        clearTimeout(this._delayedClicks[btn]?.timeoutId);
                                        this._delayedClicks[btn] = null;
                                    }
                                    cb(clickInfo, this._previousPickResult);
                                } else cb(clickInfo, this._currentPickResult);
                            }
                            needToIgnoreNext = true;
                        } else {
                            this._doubleClickOccured = false;
                            this._previousStartingPointerTime = this._startingPointerTime;
                            this._previousStartingPointerPosition.x = this._startingPointerPosition.x;
                            this._previousStartingPointerPosition.y = this._startingPointerPosition.y;
                            this._previousButtonPressed = btn;
                        }
                    }
                }
            }
            // Even if ExclusiveDoubleClickMode is true, we need to always handle
            // up events at time of execution, unless we're explicitly ignoring them.
            if (!needToIgnoreNext) cb(clickInfo, this._currentPickResult);
        };
        this._onPointerMove = (evt)=>{
            this._updatePointerPosition(evt);
            // Check if pointer leaves DragMovementThreshold range to determine if swipe is occurring
            if (!this._isSwiping && this._swipeButtonPressed !== -1) this._isSwiping = Math.abs(this._startingPointerPosition.x - this._pointerX) > $55b4bdb4e513ac29$export$2da2653229140a6c.DragMovementThreshold || Math.abs(this._startingPointerPosition.y - this._pointerY) > $55b4bdb4e513ac29$export$2da2653229140a6c.DragMovementThreshold;
            // Because there's a race condition between pointermove and pointerlockchange events, we need to
            // verify that the pointer is still locked after each pointermove event.
            if (engine.isPointerLock) engine._verifyPointerLock();
            // PreObservable support
            if (this._checkPrePointerObservable(null, evt, evt.inputIndex >= (0, $1orLO.PointerInput).MouseWheelX && evt.inputIndex <= (0, $1orLO.PointerInput).MouseWheelZ ? (0, $cfkw4.PointerEventTypes).POINTERWHEEL : (0, $cfkw4.PointerEventTypes).POINTERMOVE)) return;
            if (!scene.cameraToUseForPointers && !scene.activeCamera) return;
            if (scene.skipPointerMovePicking) {
                this._processPointerMove(new (0, $gzCma.PickingInfo)(), evt);
                return;
            }
            if (!scene.pointerMovePredicate) scene.pointerMovePredicate = (mesh)=>mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.isEnabled() && (mesh.enablePointerMoveEvents || scene.constantlyUpdateMeshUnderPointer || mesh._getActionManagerForTrigger() !== null) && (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
            const pickResult = scene._registeredActions > 0 || scene.constantlyUpdateMeshUnderPointer ? this._pickMove(evt) : null;
            this._processPointerMove(pickResult, evt);
        };
        this._onPointerDown = (evt)=>{
            const freeIndex = this._activePointerIds.indexOf(-1);
            if (freeIndex === -1) this._activePointerIds.push(evt.pointerId);
            else this._activePointerIds[freeIndex] = evt.pointerId;
            this._activePointerIdsCount++;
            this._pickedDownMesh = null;
            this._meshPickProceed = false;
            // If ExclusiveDoubleClickMode is true, we need to resolve any pending delayed clicks
            if ($55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode) {
                for(let i = 0; i < this._delayedClicks.length; i++)if (this._delayedClicks[i]) {
                    // If the button that was pressed is the same as the one that was released,
                    // just clear the timer.  This will be resolved in the up event.
                    if (evt.button === i) clearTimeout(this._delayedClicks[i]?.timeoutId);
                    else {
                        // Otherwise, we need to resolve the click
                        const clickInfo = this._delayedClicks[i].clickInfo;
                        this._doubleClickOccured = false;
                        clickInfo.singleClick = true;
                        clickInfo.ignore = false;
                        const prevEvt = this._delayedClicks[i].evt;
                        const type = (0, $cfkw4.PointerEventTypes).POINTERTAP;
                        const pi = new (0, $cfkw4.PointerInfo)(type, prevEvt, this._currentPickResult);
                        if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) scene.onPointerObservable.notifyObservers(pi, type);
                        // Clear the delayed click
                        this._delayedClicks[i] = null;
                    }
                }
            }
            this._updatePointerPosition(evt);
            if (this._swipeButtonPressed === -1) this._swipeButtonPressed = evt.button;
            if (scene.preventDefaultOnPointerDown && elementToAttachTo) {
                evt.preventDefault();
                elementToAttachTo.focus();
            }
            this._startingPointerPosition.x = this._pointerX;
            this._startingPointerPosition.y = this._pointerY;
            this._startingPointerTime = Date.now();
            // PreObservable support
            if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERDOWN)) return;
            if (!scene.cameraToUseForPointers && !scene.activeCamera) return;
            this._pointerCaptures[evt.pointerId] = true;
            if (!scene.pointerDownPredicate) scene.pointerDownPredicate = (mesh)=>{
                return mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.isEnabled() && (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
            };
            // Meshes
            this._pickedDownMesh = null;
            let pickResult;
            if (scene.skipPointerDownPicking || scene._registeredActions === 0 && !this._checkForPicking() && !scene.onPointerDown) pickResult = new (0, $gzCma.PickingInfo)();
            else pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerDownPredicate, scene.pointerDownFastCheck, scene.cameraToUseForPointers, scene.pointerDownTrianglePredicate);
            this._processPointerDown(pickResult, evt);
        };
        this._onPointerUp = (evt)=>{
            const pointerIdIndex = this._activePointerIds.indexOf(evt.pointerId);
            if (pointerIdIndex === -1) // We are attaching the pointer up to windows because of a bug in FF
            // If this pointerId is not paired with an _onPointerDown call, ignore it
            return;
            this._activePointerIds[pointerIdIndex] = -1;
            this._activePointerIdsCount--;
            this._pickedUpMesh = null;
            this._meshPickProceed = false;
            this._updatePointerPosition(evt);
            if (scene.preventDefaultOnPointerUp && elementToAttachTo) {
                evt.preventDefault();
                elementToAttachTo.focus();
            }
            this._initClickEvent(scene.onPrePointerObservable, scene.onPointerObservable, evt, (clickInfo, pickResult)=>{
                // PreObservable support
                if (scene.onPrePointerObservable.hasObservers()) {
                    this._skipPointerTap = false;
                    if (!clickInfo.ignore) {
                        if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERUP)) {
                            // If we're skipping the next observable, we need to reset the swipe state before returning
                            if (this._swipeButtonPressed === evt.button) {
                                this._isSwiping = false;
                                this._swipeButtonPressed = -1;
                            }
                            // If we're going to skip the POINTERUP, we need to reset the pointer capture
                            if (evt.buttons === 0) this._pointerCaptures[evt.pointerId] = false;
                            return;
                        }
                        if (!clickInfo.hasSwiped) {
                            if (clickInfo.singleClick && scene.onPrePointerObservable.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERTAP)) {
                                if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERTAP)) this._skipPointerTap = true;
                            }
                            if (clickInfo.doubleClick && scene.onPrePointerObservable.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP)) {
                                if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP)) this._skipPointerTap = true;
                            }
                        }
                    }
                }
                // There should be a pointer captured at this point so if there isn't we should reset and return
                if (!this._pointerCaptures[evt.pointerId]) {
                    if (this._swipeButtonPressed === evt.button) {
                        this._isSwiping = false;
                        this._swipeButtonPressed = -1;
                    }
                    return;
                }
                // Only release capture if all buttons are released
                if (evt.buttons === 0) this._pointerCaptures[evt.pointerId] = false;
                if (!scene.cameraToUseForPointers && !scene.activeCamera) return;
                if (!scene.pointerUpPredicate) scene.pointerUpPredicate = (mesh)=>{
                    return mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.isEnabled() && (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
                };
                // Meshes
                if (!this._meshPickProceed && ((0, $kNPE8.AbstractActionManager) && (0, $kNPE8.AbstractActionManager).HasTriggers || this._checkForPicking() || scene.onPointerUp)) this._initActionManager(null, clickInfo);
                if (!pickResult) pickResult = this._currentPickResult;
                this._processPointerUp(pickResult, evt, clickInfo);
                this._previousPickResult = this._currentPickResult;
                if (this._swipeButtonPressed === evt.button) {
                    this._isSwiping = false;
                    this._swipeButtonPressed = -1;
                }
            });
        };
        this._onKeyDown = (evt)=>{
            const type = (0, $bcFoB.KeyboardEventTypes).KEYDOWN;
            if (scene.onPreKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfoPre)(type, evt);
                scene.onPreKeyboardObservable.notifyObservers(pi, type);
                if (pi.skipOnKeyboardObservable) return;
            }
            if (scene.onKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfo)(type, evt);
                scene.onKeyboardObservable.notifyObservers(pi, type);
            }
            if (scene.actionManager) scene.actionManager.processTrigger(14, (0, $cmj0B.ActionEvent).CreateNewFromScene(scene, evt));
        };
        this._onKeyUp = (evt)=>{
            const type = (0, $bcFoB.KeyboardEventTypes).KEYUP;
            if (scene.onPreKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfoPre)(type, evt);
                scene.onPreKeyboardObservable.notifyObservers(pi, type);
                if (pi.skipOnKeyboardObservable) return;
            }
            if (scene.onKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfo)(type, evt);
                scene.onKeyboardObservable.notifyObservers(pi, type);
            }
            if (scene.actionManager) scene.actionManager.processTrigger(15, (0, $cmj0B.ActionEvent).CreateNewFromScene(scene, evt));
        };
        // If a device connects that we can handle, wire up the observable
        this._deviceSourceManager.onDeviceConnectedObservable.add((deviceSource)=>{
            if (deviceSource.deviceType === (0, $1orLO.DeviceType).Mouse) deviceSource.onInputChangedObservable.add((eventData)=>{
                this._originMouseEvent = eventData;
                if (eventData.inputIndex === (0, $1orLO.PointerInput).LeftClick || eventData.inputIndex === (0, $1orLO.PointerInput).MiddleClick || eventData.inputIndex === (0, $1orLO.PointerInput).RightClick || eventData.inputIndex === (0, $1orLO.PointerInput).BrowserBack || eventData.inputIndex === (0, $1orLO.PointerInput).BrowserForward) {
                    if (attachDown && deviceSource.getInput(eventData.inputIndex) === 1) this._onPointerDown(eventData);
                    else if (attachUp && deviceSource.getInput(eventData.inputIndex) === 0) this._onPointerUp(eventData);
                } else if (attachMove) {
                    if (eventData.inputIndex === (0, $1orLO.PointerInput).Move) this._onPointerMove(eventData);
                    else if (eventData.inputIndex === (0, $1orLO.PointerInput).MouseWheelX || eventData.inputIndex === (0, $1orLO.PointerInput).MouseWheelY || eventData.inputIndex === (0, $1orLO.PointerInput).MouseWheelZ) this._onPointerMove(eventData);
                }
            });
            else if (deviceSource.deviceType === (0, $1orLO.DeviceType).Touch) deviceSource.onInputChangedObservable.add((eventData)=>{
                if (eventData.inputIndex === (0, $1orLO.PointerInput).LeftClick) {
                    if (attachDown && deviceSource.getInput(eventData.inputIndex) === 1) {
                        this._onPointerDown(eventData);
                        if (this._activePointerIdsCount > 1) this._isMultiTouchGesture = true;
                    } else if (attachUp && deviceSource.getInput(eventData.inputIndex) === 0) {
                        this._onPointerUp(eventData);
                        if (this._activePointerIdsCount === 0) this._isMultiTouchGesture = false;
                    }
                }
                if (attachMove && eventData.inputIndex === (0, $1orLO.PointerInput).Move) this._onPointerMove(eventData);
            });
            else if (deviceSource.deviceType === (0, $1orLO.DeviceType).Keyboard) deviceSource.onInputChangedObservable.add((eventData)=>{
                if (eventData.type === "keydown") this._onKeyDown(eventData);
                else if (eventData.type === "keyup") this._onKeyUp(eventData);
            });
        });
        this._alreadyAttached = true;
    }
    /**
     * Detaches all event handlers
     */ detachControl() {
        if (this._alreadyAttached) {
            this._deviceSourceManager.dispose();
            this._deviceSourceManager = null;
            // Cursor
            if (this._alreadyAttachedTo && !this._scene.doNotHandleCursors) this._alreadyAttachedTo.style.cursor = this._scene.defaultCursor;
            this._alreadyAttached = false;
            this._alreadyAttachedTo = null;
        }
    }
    /**
     * Set the value of meshUnderPointer for a given pointerId
     * @param mesh - defines the mesh to use
     * @param pointerId - optional pointer id when using more than one pointer. Defaults to 0
     * @param pickResult - optional pickingInfo data used to find mesh
     * @param evt - optional pointer event
     */ setPointerOverMesh(mesh, pointerId = 0, pickResult, evt) {
        if (this._meshUnderPointerId[pointerId] === mesh && (!mesh || !mesh._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting)) return;
        const underPointerMesh = this._meshUnderPointerId[pointerId];
        let actionManager;
        if (underPointerMesh) {
            actionManager = underPointerMesh._getActionManagerForTrigger(10);
            if (actionManager) actionManager.processTrigger(10, new (0, $cmj0B.ActionEvent)(underPointerMesh, this._pointerX, this._pointerY, mesh, evt, {
                pointerId: pointerId
            }));
        }
        if (mesh) {
            this._meshUnderPointerId[pointerId] = mesh;
            this._pointerOverMesh = mesh;
            actionManager = mesh._getActionManagerForTrigger(9);
            if (actionManager) actionManager.processTrigger(9, new (0, $cmj0B.ActionEvent)(mesh, this._pointerX, this._pointerY, mesh, evt, {
                pointerId: pointerId,
                pickResult: pickResult
            }));
        } else {
            delete this._meshUnderPointerId[pointerId];
            this._pointerOverMesh = null;
        }
        // if we reached this point, meshUnderPointerId has been updated. We need to notify observers that are registered.
        if (this._scene.onMeshUnderPointerUpdatedObservable.hasObservers()) this._scene.onMeshUnderPointerUpdatedObservable.notifyObservers({
            mesh: mesh,
            pointerId: pointerId
        });
    }
    /**
     * Gets the mesh under the pointer
     * @returns a Mesh or null if no mesh is under the pointer
     */ getPointerOverMesh() {
        return this.meshUnderPointer;
    }
    /**
     * @param mesh - Mesh to invalidate
     * @internal
     */ _invalidateMesh(mesh) {
        if (this._pointerOverMesh === mesh) this._pointerOverMesh = null;
        if (this._pickedDownMesh === mesh) this._pickedDownMesh = null;
        if (this._pickedUpMesh === mesh) this._pickedUpMesh = null;
        for(const pointerId in this._meshUnderPointerId)if (this._meshUnderPointerId[pointerId] === mesh) delete this._meshUnderPointerId[pointerId];
    }
}
/** The distance in pixel that you have to move to prevent some events */ $55b4bdb4e513ac29$export$2da2653229140a6c.DragMovementThreshold = 10; // in pixels
/** Time in milliseconds to wait to raise long press events if button is still pressed */ $55b4bdb4e513ac29$export$2da2653229140a6c.LongPressDelay = 500; // in milliseconds
/** Time in milliseconds with two consecutive clicks will be considered as a double click */ $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay = 300; // in milliseconds
/**
 * This flag will modify the behavior so that, when true, a click will happen if and only if
 * another click DOES NOT happen within the DoubleClickDelay time frame.  If another click does
 * happen within that time frame, the first click will not fire an event and and a double click will occur.
 */ $55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode = false;

});
parcelRegister("cfkw4", function(module, exports) {

$parcel$export(module.exports, "PointerEventTypes", () => $8ea6ccd88adf8a8f$export$897237b138a30604);
$parcel$export(module.exports, "PointerInfoPre", () => $8ea6ccd88adf8a8f$export$be6c99d56064cfdd);
$parcel$export(module.exports, "PointerInfo", () => $8ea6ccd88adf8a8f$export$3d32e0a6dc61f70c);

var $ha1VO = parcelRequire("ha1VO");
class $8ea6ccd88adf8a8f$export$897237b138a30604 {
}
/**
 * The pointerdown event is fired when a pointer becomes active. For mouse, it is fired when the device transitions from no buttons depressed to at least one button depressed. For touch, it is fired when physical contact is made with the digitizer. For pen, it is fired when the stylus makes physical contact with the digitizer.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERDOWN = 0x01;
/**
 * The pointerup event is fired when a pointer is no longer active.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERUP = 0x02;
/**
 * The pointermove event is fired when a pointer changes coordinates.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERMOVE = 0x04;
/**
 * The pointerwheel event is fired when a mouse wheel has been rotated.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERWHEEL = 0x08;
/**
 * The pointerpick event is fired when a mesh or sprite has been picked by the pointer.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERPICK = 0x10;
/**
 * The pointertap event is fired when a the object has been touched and released without drag.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERTAP = 0x20;
/**
 * The pointerdoubletap event is fired when a the object has been touched and released twice without drag.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERDOUBLETAP = 0x40;
class $8ea6ccd88adf8a8f$export$7172ff0e05271a1 {
    /**
     * Instantiates the base class of pointers info.
     * @param type Defines the type of event (PointerEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (PointerEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        this.type = type;
        this.event = event;
    }
}
class $8ea6ccd88adf8a8f$export$be6c99d56064cfdd extends $8ea6ccd88adf8a8f$export$7172ff0e05271a1 {
    /**
     * Instantiates a PointerInfoPre to store pointer related info to the onPrePointerObservable event.
     * @param type Defines the type of event (PointerEventTypes)
     * @param event Defines the related dom event
     * @param localX Defines the local x coordinates of the pointer when the event occured
     * @param localY Defines the local y coordinates of the pointer when the event occured
     */ constructor(type, event, localX, localY){
        super(type, event);
        /**
         * Ray from a pointer if available (eg. 6dof controller)
         */ this.ray = null;
        /**
         * The original picking info that was used to trigger the pointer event
         */ this.originalPickingInfo = null;
        this.skipOnPointerObservable = false;
        this.localPosition = new (0, $ha1VO.Vector2)(localX, localY);
    }
}
class $8ea6ccd88adf8a8f$export$3d32e0a6dc61f70c extends $8ea6ccd88adf8a8f$export$7172ff0e05271a1 {
    /**
     * Defines the picking info associated with this PointerInfo object (if applicable)
     */ get pickInfo() {
        if (!this._pickInfo) this._generatePickInfo();
        return this._pickInfo;
    }
    /**
     * Instantiates a PointerInfo to store pointer related info to the onPointerObservable event.
     * @param type Defines the type of event (PointerEventTypes)
     * @param event Defines the related dom event
     * @param pickInfo Defines the picking info associated to the info (if any)
     * @param inputManager Defines the InputManager to use if there is no pickInfo
     */ constructor(type, event, pickInfo, inputManager = null){
        super(type, event);
        this._pickInfo = pickInfo;
        this._inputManager = inputManager;
    }
    /**
     * Generates the picking info if needed
     */ /** @internal */ _generatePickInfo() {
        if (this._inputManager) {
            this._pickInfo = this._inputManager._pickMove(this.event);
            this._inputManager._setRayOnPointerInfo(this._pickInfo, this.event);
            this._inputManager = null;
        }
    }
}

});

parcelRegister("kNPE8", function(module, exports) {

$parcel$export(module.exports, "AbstractActionManager", () => $03e885f839d57774$export$14ad3606dc0e1e35);
/**
 * Abstract class used to decouple action Manager from scene and meshes.
 * Do not instantiate.
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions
 */ class $03e885f839d57774$export$14ad3606dc0e1e35 {
    constructor(){
        /** Gets the cursor to use when hovering items */ this.hoverCursor = "";
        /** Gets the list of actions */ this.actions = [];
        /**
         * Gets or sets a boolean indicating that the manager is recursive meaning that it can trigger action from children
         */ this.isRecursive = false;
        /**
         * Gets or sets a boolean indicating if this ActionManager should be disposed once the last Mesh using it is disposed
         */ this.disposeWhenUnowned = true;
    }
    /**
     * Does exist one action manager with at least one trigger
     **/ static get HasTriggers() {
        for(const t in $03e885f839d57774$export$14ad3606dc0e1e35.Triggers){
            if (Object.prototype.hasOwnProperty.call($03e885f839d57774$export$14ad3606dc0e1e35.Triggers, t)) return true;
        }
        return false;
    }
    /**
     * Does exist one action manager with at least one pick trigger
     **/ static get HasPickTriggers() {
        for(const t in $03e885f839d57774$export$14ad3606dc0e1e35.Triggers)if (Object.prototype.hasOwnProperty.call($03e885f839d57774$export$14ad3606dc0e1e35.Triggers, t)) {
            const tAsInt = parseInt(t);
            if (tAsInt >= 1 && tAsInt <= 7) return true;
        }
        return false;
    }
    /**
     * Does exist one action manager that handles actions of a given trigger
     * @param trigger defines the trigger to be tested
     * @returns a boolean indicating whether the trigger is handled by at least one action manager
     **/ static HasSpecificTrigger(trigger) {
        for(const t in $03e885f839d57774$export$14ad3606dc0e1e35.Triggers)if (Object.prototype.hasOwnProperty.call($03e885f839d57774$export$14ad3606dc0e1e35.Triggers, t)) {
            const tAsInt = parseInt(t);
            if (tAsInt === trigger) return true;
        }
        return false;
    }
}
/** Gets the list of active triggers */ $03e885f839d57774$export$14ad3606dc0e1e35.Triggers = {};

});

parcelRegister("bcFoB", function(module, exports) {

$parcel$export(module.exports, "KeyboardEventTypes", () => $8280ed10dbe12bac$export$62d408755f25b92a);
$parcel$export(module.exports, "KeyboardInfo", () => $8280ed10dbe12bac$export$a6c3dccbac012c10);
$parcel$export(module.exports, "KeyboardInfoPre", () => $8280ed10dbe12bac$export$3c56b2d3254c2f3e);
/**
 * Gather the list of keyboard event types as constants.
 */ class $8280ed10dbe12bac$export$62d408755f25b92a {
}
/**
 * The keydown event is fired when a key becomes active (pressed).
 */ $8280ed10dbe12bac$export$62d408755f25b92a.KEYDOWN = 0x01;
/**
 * The keyup event is fired when a key has been released.
 */ $8280ed10dbe12bac$export$62d408755f25b92a.KEYUP = 0x02;
class $8280ed10dbe12bac$export$a6c3dccbac012c10 {
    /**
     * Instantiates a new keyboard info.
     * This class is used to store keyboard related info for the onKeyboardObservable event.
     * @param type Defines the type of event (KeyboardEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (KeyboardEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        this.type = type;
        this.event = event;
    }
}
class $8280ed10dbe12bac$export$3c56b2d3254c2f3e extends $8280ed10dbe12bac$export$a6c3dccbac012c10 {
    /**
     * Defines whether the engine should skip the next onKeyboardObservable associated to this pre.
     * @deprecated use skipOnKeyboardObservable property instead
     */ get skipOnPointerObservable() {
        return this.skipOnKeyboardObservable;
    }
    set skipOnPointerObservable(value) {
        this.skipOnKeyboardObservable = value;
    }
    /**
     * Instantiates a new keyboard pre info.
     * This class is used to store keyboard related info for the onPreKeyboardObservable event.
     * @param type Defines the type of event (KeyboardEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (KeyboardEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        super(type, event);
        this.type = type;
        this.event = event;
        this.skipOnKeyboardObservable = false;
    }
}

});

parcelRegister("1orLO", function(module, exports) {

$parcel$export(module.exports, "DeviceType", () => $103d92e76a6c0fd3$export$ec1e04e4e5ef8233);
$parcel$export(module.exports, "PointerInput", () => $103d92e76a6c0fd3$export$f35275c6c22f6aff);
/**
 * Enum for Device Types
 */ var $103d92e76a6c0fd3$export$ec1e04e4e5ef8233;
(function(DeviceType) {
    /** Generic */ DeviceType[DeviceType["Generic"] = 0] = "Generic";
    /** Keyboard */ DeviceType[DeviceType["Keyboard"] = 1] = "Keyboard";
    /** Mouse */ DeviceType[DeviceType["Mouse"] = 2] = "Mouse";
    /** Touch Pointers */ DeviceType[DeviceType["Touch"] = 3] = "Touch";
    /** PS4 Dual Shock */ DeviceType[DeviceType["DualShock"] = 4] = "DualShock";
    /** Xbox */ DeviceType[DeviceType["Xbox"] = 5] = "Xbox";
    /** Switch Controller */ DeviceType[DeviceType["Switch"] = 6] = "Switch";
    /** PS5 DualSense */ DeviceType[DeviceType["DualSense"] = 7] = "DualSense";
})($103d92e76a6c0fd3$export$ec1e04e4e5ef8233 || ($103d92e76a6c0fd3$export$ec1e04e4e5ef8233 = {}));
var $103d92e76a6c0fd3$export$f35275c6c22f6aff;
(function(PointerInput) {
    /** Horizontal Axis (Not used in events/observables; only in polling) */ PointerInput[PointerInput["Horizontal"] = 0] = "Horizontal";
    /** Vertical Axis (Not used in events/observables; only in polling) */ PointerInput[PointerInput["Vertical"] = 1] = "Vertical";
    /** Left Click or Touch */ PointerInput[PointerInput["LeftClick"] = 2] = "LeftClick";
    /** Middle Click */ PointerInput[PointerInput["MiddleClick"] = 3] = "MiddleClick";
    /** Right Click */ PointerInput[PointerInput["RightClick"] = 4] = "RightClick";
    /** Browser Back */ PointerInput[PointerInput["BrowserBack"] = 5] = "BrowserBack";
    /** Browser Forward */ PointerInput[PointerInput["BrowserForward"] = 6] = "BrowserForward";
    /** Mouse Wheel X */ PointerInput[PointerInput["MouseWheelX"] = 7] = "MouseWheelX";
    /** Mouse Wheel Y */ PointerInput[PointerInput["MouseWheelY"] = 8] = "MouseWheelY";
    /** Mouse Wheel Z */ PointerInput[PointerInput["MouseWheelZ"] = 9] = "MouseWheelZ";
    /** Used in events/observables to identify if x/y changes occurred */ PointerInput[PointerInput["Move"] = 12] = "Move";
})($103d92e76a6c0fd3$export$f35275c6c22f6aff || ($103d92e76a6c0fd3$export$f35275c6c22f6aff = {}));
var $103d92e76a6c0fd3$export$9404b06a0f226aab;
(function(NativePointerInput) {
    /** Horizontal Axis */ NativePointerInput[NativePointerInput["Horizontal"] = 0] = "Horizontal";
    /** Vertical Axis */ NativePointerInput[NativePointerInput["Vertical"] = 1] = "Vertical";
    /** Left Click or Touch */ NativePointerInput[NativePointerInput["LeftClick"] = 2] = "LeftClick";
    /** Middle Click */ NativePointerInput[NativePointerInput["MiddleClick"] = 3] = "MiddleClick";
    /** Right Click */ NativePointerInput[NativePointerInput["RightClick"] = 4] = "RightClick";
    /** Browser Back */ NativePointerInput[NativePointerInput["BrowserBack"] = 5] = "BrowserBack";
    /** Browser Forward */ NativePointerInput[NativePointerInput["BrowserForward"] = 6] = "BrowserForward";
    /** Mouse Wheel X */ NativePointerInput[NativePointerInput["MouseWheelX"] = 7] = "MouseWheelX";
    /** Mouse Wheel Y */ NativePointerInput[NativePointerInput["MouseWheelY"] = 8] = "MouseWheelY";
    /** Mouse Wheel Z */ NativePointerInput[NativePointerInput["MouseWheelZ"] = 9] = "MouseWheelZ";
    /** Delta X */ NativePointerInput[NativePointerInput["DeltaHorizontal"] = 10] = "DeltaHorizontal";
    /** Delta Y */ NativePointerInput[NativePointerInput["DeltaVertical"] = 11] = "DeltaVertical";
})($103d92e76a6c0fd3$export$9404b06a0f226aab || ($103d92e76a6c0fd3$export$9404b06a0f226aab = {}));
var $103d92e76a6c0fd3$export$90fb9dd49867b794;
(function(DualShockInput) {
    /** Cross */ DualShockInput[DualShockInput["Cross"] = 0] = "Cross";
    /** Circle */ DualShockInput[DualShockInput["Circle"] = 1] = "Circle";
    /** Square */ DualShockInput[DualShockInput["Square"] = 2] = "Square";
    /** Triangle */ DualShockInput[DualShockInput["Triangle"] = 3] = "Triangle";
    /** L1 */ DualShockInput[DualShockInput["L1"] = 4] = "L1";
    /** R1 */ DualShockInput[DualShockInput["R1"] = 5] = "R1";
    /** L2 */ DualShockInput[DualShockInput["L2"] = 6] = "L2";
    /** R2 */ DualShockInput[DualShockInput["R2"] = 7] = "R2";
    /** Share */ DualShockInput[DualShockInput["Share"] = 8] = "Share";
    /** Options */ DualShockInput[DualShockInput["Options"] = 9] = "Options";
    /** L3 */ DualShockInput[DualShockInput["L3"] = 10] = "L3";
    /** R3 */ DualShockInput[DualShockInput["R3"] = 11] = "R3";
    /** DPadUp */ DualShockInput[DualShockInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ DualShockInput[DualShockInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ DualShockInput[DualShockInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ DualShockInput[DualShockInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ DualShockInput[DualShockInput["Home"] = 16] = "Home";
    /** TouchPad */ DualShockInput[DualShockInput["TouchPad"] = 17] = "TouchPad";
    /** LStickXAxis */ DualShockInput[DualShockInput["LStickXAxis"] = 18] = "LStickXAxis";
    /** LStickYAxis */ DualShockInput[DualShockInput["LStickYAxis"] = 19] = "LStickYAxis";
    /** RStickXAxis */ DualShockInput[DualShockInput["RStickXAxis"] = 20] = "RStickXAxis";
    /** RStickYAxis */ DualShockInput[DualShockInput["RStickYAxis"] = 21] = "RStickYAxis";
})($103d92e76a6c0fd3$export$90fb9dd49867b794 || ($103d92e76a6c0fd3$export$90fb9dd49867b794 = {}));
var $103d92e76a6c0fd3$export$ed2f53f4a6709ab5;
(function(DualSenseInput) {
    /** Cross */ DualSenseInput[DualSenseInput["Cross"] = 0] = "Cross";
    /** Circle */ DualSenseInput[DualSenseInput["Circle"] = 1] = "Circle";
    /** Square */ DualSenseInput[DualSenseInput["Square"] = 2] = "Square";
    /** Triangle */ DualSenseInput[DualSenseInput["Triangle"] = 3] = "Triangle";
    /** L1 */ DualSenseInput[DualSenseInput["L1"] = 4] = "L1";
    /** R1 */ DualSenseInput[DualSenseInput["R1"] = 5] = "R1";
    /** L2 */ DualSenseInput[DualSenseInput["L2"] = 6] = "L2";
    /** R2 */ DualSenseInput[DualSenseInput["R2"] = 7] = "R2";
    /** Create */ DualSenseInput[DualSenseInput["Create"] = 8] = "Create";
    /** Options */ DualSenseInput[DualSenseInput["Options"] = 9] = "Options";
    /** L3 */ DualSenseInput[DualSenseInput["L3"] = 10] = "L3";
    /** R3 */ DualSenseInput[DualSenseInput["R3"] = 11] = "R3";
    /** DPadUp */ DualSenseInput[DualSenseInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ DualSenseInput[DualSenseInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ DualSenseInput[DualSenseInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ DualSenseInput[DualSenseInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ DualSenseInput[DualSenseInput["Home"] = 16] = "Home";
    /** TouchPad */ DualSenseInput[DualSenseInput["TouchPad"] = 17] = "TouchPad";
    /** LStickXAxis */ DualSenseInput[DualSenseInput["LStickXAxis"] = 18] = "LStickXAxis";
    /** LStickYAxis */ DualSenseInput[DualSenseInput["LStickYAxis"] = 19] = "LStickYAxis";
    /** RStickXAxis */ DualSenseInput[DualSenseInput["RStickXAxis"] = 20] = "RStickXAxis";
    /** RStickYAxis */ DualSenseInput[DualSenseInput["RStickYAxis"] = 21] = "RStickYAxis";
})($103d92e76a6c0fd3$export$ed2f53f4a6709ab5 || ($103d92e76a6c0fd3$export$ed2f53f4a6709ab5 = {}));
var $103d92e76a6c0fd3$export$3e2b57f863ae2778;
(function(XboxInput) {
    /** A */ XboxInput[XboxInput["A"] = 0] = "A";
    /** B */ XboxInput[XboxInput["B"] = 1] = "B";
    /** X */ XboxInput[XboxInput["X"] = 2] = "X";
    /** Y */ XboxInput[XboxInput["Y"] = 3] = "Y";
    /** LB */ XboxInput[XboxInput["LB"] = 4] = "LB";
    /** RB */ XboxInput[XboxInput["RB"] = 5] = "RB";
    /** LT */ XboxInput[XboxInput["LT"] = 6] = "LT";
    /** RT */ XboxInput[XboxInput["RT"] = 7] = "RT";
    /** Back */ XboxInput[XboxInput["Back"] = 8] = "Back";
    /** Start */ XboxInput[XboxInput["Start"] = 9] = "Start";
    /** LS */ XboxInput[XboxInput["LS"] = 10] = "LS";
    /** RS */ XboxInput[XboxInput["RS"] = 11] = "RS";
    /** DPadUp */ XboxInput[XboxInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ XboxInput[XboxInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ XboxInput[XboxInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ XboxInput[XboxInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ XboxInput[XboxInput["Home"] = 16] = "Home";
    /** LStickXAxis */ XboxInput[XboxInput["LStickXAxis"] = 17] = "LStickXAxis";
    /** LStickYAxis */ XboxInput[XboxInput["LStickYAxis"] = 18] = "LStickYAxis";
    /** RStickXAxis */ XboxInput[XboxInput["RStickXAxis"] = 19] = "RStickXAxis";
    /** RStickYAxis */ XboxInput[XboxInput["RStickYAxis"] = 20] = "RStickYAxis";
})($103d92e76a6c0fd3$export$3e2b57f863ae2778 || ($103d92e76a6c0fd3$export$3e2b57f863ae2778 = {}));
var $103d92e76a6c0fd3$export$f8fd43a15610a9c6;
(function(SwitchInput) {
    /** B */ SwitchInput[SwitchInput["B"] = 0] = "B";
    /** A */ SwitchInput[SwitchInput["A"] = 1] = "A";
    /** Y */ SwitchInput[SwitchInput["Y"] = 2] = "Y";
    /** X */ SwitchInput[SwitchInput["X"] = 3] = "X";
    /** L */ SwitchInput[SwitchInput["L"] = 4] = "L";
    /** R */ SwitchInput[SwitchInput["R"] = 5] = "R";
    /** ZL */ SwitchInput[SwitchInput["ZL"] = 6] = "ZL";
    /** ZR */ SwitchInput[SwitchInput["ZR"] = 7] = "ZR";
    /** Minus */ SwitchInput[SwitchInput["Minus"] = 8] = "Minus";
    /** Plus */ SwitchInput[SwitchInput["Plus"] = 9] = "Plus";
    /** LS */ SwitchInput[SwitchInput["LS"] = 10] = "LS";
    /** RS */ SwitchInput[SwitchInput["RS"] = 11] = "RS";
    /** DPadUp */ SwitchInput[SwitchInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ SwitchInput[SwitchInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ SwitchInput[SwitchInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ SwitchInput[SwitchInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ SwitchInput[SwitchInput["Home"] = 16] = "Home";
    /** Capture */ SwitchInput[SwitchInput["Capture"] = 17] = "Capture";
    /** LStickXAxis */ SwitchInput[SwitchInput["LStickXAxis"] = 18] = "LStickXAxis";
    /** LStickYAxis */ SwitchInput[SwitchInput["LStickYAxis"] = 19] = "LStickYAxis";
    /** RStickXAxis */ SwitchInput[SwitchInput["RStickXAxis"] = 20] = "RStickXAxis";
    /** RStickYAxis */ SwitchInput[SwitchInput["RStickYAxis"] = 21] = "RStickYAxis";
})($103d92e76a6c0fd3$export$f8fd43a15610a9c6 || ($103d92e76a6c0fd3$export$f8fd43a15610a9c6 = {}));

});

parcelRegister("gAZ7u", function(module, exports) {

$parcel$export(module.exports, "DeviceSourceManager", () => $c14f6b3c4d975c6a$export$2719d0694599575b);

var $1orLO = parcelRequire("1orLO");

var $diGQf = parcelRequire("diGQf");

var $hcXui = parcelRequire("hcXui");
class $c14f6b3c4d975c6a$export$2719d0694599575b {
    // Public Functions
    /**
     * Gets a DeviceSource, given a type and slot
     * @param deviceType - Type of Device
     * @param deviceSlot - Slot or ID of device
     * @returns DeviceSource
     */ getDeviceSource(deviceType, deviceSlot) {
        if (deviceSlot === undefined) {
            if (this._firstDevice[deviceType] === undefined) return null;
            deviceSlot = this._firstDevice[deviceType];
        }
        if (!this._devices[deviceType] || this._devices[deviceType][deviceSlot] === undefined) return null;
        return this._devices[deviceType][deviceSlot];
    }
    /**
     * Gets an array of DeviceSource objects for a given device type
     * @param deviceType - Type of Device
     * @returns All available DeviceSources of a given type
     */ getDeviceSources(deviceType) {
        // If device type hasn't had any devices connected yet, return empty array.
        if (!this._devices[deviceType]) return [];
        return this._devices[deviceType].filter((source)=>{
            return !!source;
        });
    }
    /**
     * Default constructor
     * @param engine - Used to get canvas (if applicable)
     */ constructor(engine){
        const numberOfDeviceTypes = Object.keys((0, $1orLO.DeviceType)).length / 2;
        this._devices = new Array(numberOfDeviceTypes);
        this._firstDevice = new Array(numberOfDeviceTypes);
        this._engine = engine;
        if (!this._engine._deviceSourceManager) this._engine._deviceSourceManager = new (0, $hcXui.InternalDeviceSourceManager)(engine);
        this._engine._deviceSourceManager._refCount++;
        // Observables
        this.onDeviceConnectedObservable = new (0, $diGQf.Observable)((observer)=>{
            for (const devices of this._devices)if (devices) {
                for (const device of devices)if (device) this.onDeviceConnectedObservable.notifyObserver(observer, device);
            }
        });
        this.onDeviceDisconnectedObservable = new (0, $diGQf.Observable)();
        this._engine._deviceSourceManager.registerManager(this);
        this._onDisposeObserver = engine.onDisposeObservable.add(()=>{
            this.dispose();
        });
    }
    /**
     * Dispose of DeviceSourceManager
     */ dispose() {
        // Null out observable refs
        this.onDeviceConnectedObservable.clear();
        this.onDeviceDisconnectedObservable.clear();
        if (this._engine._deviceSourceManager) {
            this._engine._deviceSourceManager.unregisterManager(this);
            if (--this._engine._deviceSourceManager._refCount < 1) {
                this._engine._deviceSourceManager.dispose();
                delete this._engine._deviceSourceManager;
            }
        }
        this._engine.onDisposeObservable.remove(this._onDisposeObserver);
    }
    // Hidden Functions
    /**
     * @param deviceSource - Source to add
     * @internal
     */ _addDevice(deviceSource) {
        if (!this._devices[deviceSource.deviceType]) this._devices[deviceSource.deviceType] = new Array();
        if (!this._devices[deviceSource.deviceType][deviceSource.deviceSlot]) {
            this._devices[deviceSource.deviceType][deviceSource.deviceSlot] = deviceSource;
            this._updateFirstDevices(deviceSource.deviceType);
        }
        this.onDeviceConnectedObservable.notifyObservers(deviceSource);
    }
    /**
     * @param deviceType - DeviceType
     * @param deviceSlot - DeviceSlot
     * @internal
     */ _removeDevice(deviceType, deviceSlot) {
        const deviceSource = this._devices[deviceType]?.[deviceSlot]; // Grab local reference to use before removing from devices
        this.onDeviceDisconnectedObservable.notifyObservers(deviceSource);
        if (this._devices[deviceType]?.[deviceSlot]) delete this._devices[deviceType][deviceSlot];
        // Even if we don't delete a device, we should still check for the first device as things may have gotten out of sync.
        this._updateFirstDevices(deviceType);
    }
    /**
     * @param deviceType - DeviceType
     * @param deviceSlot - DeviceSlot
     * @param eventData - Event
     * @internal
     */ _onInputChanged(deviceType, deviceSlot, eventData) {
        this._devices[deviceType]?.[deviceSlot]?.onInputChangedObservable.notifyObservers(eventData);
    }
    // Private Functions
    _updateFirstDevices(type) {
        switch(type){
            case (0, $1orLO.DeviceType).Keyboard:
            case (0, $1orLO.DeviceType).Mouse:
                this._firstDevice[type] = 0;
                break;
            case (0, $1orLO.DeviceType).Touch:
            case (0, $1orLO.DeviceType).DualSense:
            case (0, $1orLO.DeviceType).DualShock:
            case (0, $1orLO.DeviceType).Xbox:
            case (0, $1orLO.DeviceType).Switch:
            case (0, $1orLO.DeviceType).Generic:
                {
                    delete this._firstDevice[type];
                    // eslint-disable-next-line no-case-declarations
                    const devices = this._devices[type];
                    if (devices) {
                        for(let i = 0; i < devices.length; i++)if (devices[i]) {
                            this._firstDevice[type] = i;
                            break;
                        }
                    }
                    break;
                }
        }
    }
}

});
parcelRegister("hcXui", function(module, exports) {

$parcel$export(module.exports, "InternalDeviceSourceManager", () => $c871b3a4837b5826$export$262f6dddbcae2bda);

var $1orLO = parcelRequire("1orLO");

var $91QRI = parcelRequire("91QRI");

var $ehija = parcelRequire("ehija");

var $akBjT = parcelRequire("akBjT");
class $c871b3a4837b5826$export$262f6dddbcae2bda {
    constructor(engine){
        this._registeredManagers = new Array();
        this._refCount = 0;
        // Public Functions
        this.registerManager = (manager)=>{
            for(let deviceType = 0; deviceType < this._devices.length; deviceType++){
                const device = this._devices[deviceType];
                for(const deviceSlotKey in device){
                    const deviceSlot = +deviceSlotKey;
                    manager._addDevice(new (0, $akBjT.DeviceSource)(this._deviceInputSystem, deviceType, deviceSlot));
                }
            }
            this._registeredManagers.push(manager);
        };
        this.unregisterManager = (manager)=>{
            const idx = this._registeredManagers.indexOf(manager);
            if (idx > -1) this._registeredManagers.splice(idx, 1);
        };
        const numberOfDeviceTypes = Object.keys((0, $1orLO.DeviceType)).length / 2;
        this._devices = new Array(numberOfDeviceTypes);
        const onDeviceConnected = (deviceType, deviceSlot)=>{
            if (!this._devices[deviceType]) this._devices[deviceType] = new Array();
            if (!this._devices[deviceType][deviceSlot]) this._devices[deviceType][deviceSlot] = deviceSlot;
            for (const manager of this._registeredManagers){
                const deviceSource = new (0, $akBjT.DeviceSource)(this._deviceInputSystem, deviceType, deviceSlot);
                manager._addDevice(deviceSource);
            }
        };
        const onDeviceDisconnected = (deviceType, deviceSlot)=>{
            if (this._devices[deviceType]?.[deviceSlot]) delete this._devices[deviceType][deviceSlot];
            for (const manager of this._registeredManagers)manager._removeDevice(deviceType, deviceSlot);
        };
        const onInputChanged = (deviceType, deviceSlot, eventData)=>{
            if (eventData) for (const manager of this._registeredManagers)manager._onInputChanged(deviceType, deviceSlot, eventData);
        };
        if (typeof _native !== "undefined") this._deviceInputSystem = new (0, $91QRI.NativeDeviceInputSystem)(onDeviceConnected, onDeviceDisconnected, onInputChanged);
        else this._deviceInputSystem = new (0, $ehija.WebDeviceInputSystem)(engine, onDeviceConnected, onDeviceDisconnected, onInputChanged);
    }
    dispose() {
        this._deviceInputSystem.dispose();
    }
}

});
parcelRegister("91QRI", function(module, exports) {

$parcel$export(module.exports, "NativeDeviceInputSystem", () => $692d36fececf9f85$export$b7cc62e8778b1937);

var $f1QSW = parcelRequire("f1QSW");

var $1orLO = parcelRequire("1orLO");
class $692d36fececf9f85$export$b7cc62e8778b1937 {
    constructor(onDeviceConnected, onDeviceDisconnected, onInputChanged){
        this._nativeInput = _native.DeviceInputSystem ? new _native.DeviceInputSystem(onDeviceConnected, onDeviceDisconnected, (deviceType, deviceSlot, inputIndex, currentState)=>{
            const evt = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent(deviceType, deviceSlot, inputIndex, currentState, this);
            onInputChanged(deviceType, deviceSlot, evt);
        }) : this._createDummyNativeInput();
    }
    // Public functions
    /**
     * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @returns Current value of input
     */ pollInput(deviceType, deviceSlot, inputIndex) {
        return this._nativeInput.pollInput(deviceType, deviceSlot, inputIndex);
    }
    /**
     * Check for a specific device in the DeviceInputSystem
     * @param deviceType Type of device to check for
     * @returns bool with status of device's existence
     */ isDeviceAvailable(deviceType) {
        //TODO: FIx native side first
        return deviceType === (0, $1orLO.DeviceType).Mouse || deviceType === (0, $1orLO.DeviceType).Touch;
    }
    /**
     * Dispose of all the observables
     */ dispose() {
        this._nativeInput.dispose();
    }
    /**
     * For versions of BabylonNative that don't have the NativeInput plugin initialized, create a dummy version
     * @returns Object with dummy functions
     */ _createDummyNativeInput() {
        const nativeInput = {
            pollInput: ()=>{
                return 0;
            },
            isDeviceAvailable: ()=>{
                return false;
            },
            dispose: ()=>{}
        };
        return nativeInput;
    }
}

});
parcelRegister("f1QSW", function(module, exports) {

$parcel$export(module.exports, "DeviceEventFactory", () => $af0ff8e35d988c18$export$6de5b040bf4692b);

var $jzXHO = parcelRequire("jzXHO");

var $1orLO = parcelRequire("1orLO");
class $af0ff8e35d988c18$export$6de5b040bf4692b {
    /**
     * Create device input events based on provided type and slot
     *
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @param pointerId PointerId to use for pointer events
     * @returns IUIEvent object
     */ static CreateDeviceEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId) {
        switch(deviceType){
            case (0, $1orLO.DeviceType).Keyboard:
                return this._CreateKeyboardEvent(inputIndex, currentState, deviceInputSystem, elementToAttachTo);
            case (0, $1orLO.DeviceType).Mouse:
                if (inputIndex === (0, $1orLO.PointerInput).MouseWheelX || inputIndex === (0, $1orLO.PointerInput).MouseWheelY || inputIndex === (0, $1orLO.PointerInput).MouseWheelZ) return this._CreateWheelEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
            // eslint-disable-next-line no-fallthrough
            case (0, $1orLO.DeviceType).Touch:
                return this._CreatePointerEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId);
            default:
                // eslint-disable-next-line no-throw-literal
                throw `Unable to generate event for device ${(0, $1orLO.DeviceType)[deviceType]}`;
        }
    }
    /**
     * Creates pointer event
     *
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @param pointerId PointerId to use for pointer events
     * @returns IUIEvent object (Pointer)
     */ static _CreatePointerEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId) {
        const evt = this._CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
        if (deviceType === (0, $1orLO.DeviceType).Mouse) {
            evt.deviceType = (0, $1orLO.DeviceType).Mouse;
            evt.pointerId = 1;
            evt.pointerType = "mouse";
        } else {
            evt.deviceType = (0, $1orLO.DeviceType).Touch;
            evt.pointerId = pointerId ?? deviceSlot;
            evt.pointerType = "touch";
        }
        let buttons = 0;
        // Populate buttons property with current state of all mouse buttons
        // Uses values found on: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).LeftClick);
        buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).RightClick) * 2;
        buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).MiddleClick) * 4;
        evt.buttons = buttons;
        if (inputIndex === (0, $1orLO.PointerInput).Move) evt.type = "pointermove";
        else if (inputIndex >= (0, $1orLO.PointerInput).LeftClick && inputIndex <= (0, $1orLO.PointerInput).RightClick) {
            evt.type = currentState === 1 ? "pointerdown" : "pointerup";
            evt.button = inputIndex - 2;
        }
        return evt;
    }
    /**
     * Create Mouse Wheel Event
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @returns IUIEvent object (Wheel)
     */ static _CreateWheelEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
        const evt = this._CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
        // While WheelEvents don't generally have a pointerId, we used to add one in the InputManager
        // This line has been added to make the InputManager more platform-agnostic
        // Similar code exists in the WebDeviceInputSystem to handle browser created events
        evt.pointerId = 1;
        evt.type = "wheel";
        evt.deltaMode = (0, $jzXHO.EventConstants).DOM_DELTA_PIXEL;
        evt.deltaX = 0;
        evt.deltaY = 0;
        evt.deltaZ = 0;
        switch(inputIndex){
            case (0, $1orLO.PointerInput).MouseWheelX:
                evt.deltaX = currentState;
                break;
            case (0, $1orLO.PointerInput).MouseWheelY:
                evt.deltaY = currentState;
                break;
            case (0, $1orLO.PointerInput).MouseWheelZ:
                evt.deltaZ = currentState;
                break;
        }
        return evt;
    }
    /**
     * Create Mouse Event
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @returns IUIEvent object (Mouse)
     */ static _CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
        const evt = this._CreateEvent(elementToAttachTo);
        const pointerX = deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).Horizontal);
        const pointerY = deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).Vertical);
        // Handle offsets/deltas based on existence of HTMLElement
        if (elementToAttachTo) {
            evt.movementX = 0;
            evt.movementY = 0;
            evt.offsetX = evt.movementX - elementToAttachTo.getBoundingClientRect().x;
            evt.offsetY = evt.movementY - elementToAttachTo.getBoundingClientRect().y;
        } else {
            evt.movementX = deviceInputSystem.pollInput(deviceType, deviceSlot, 10 /* NativePointerInput.DeltaHorizontal */ ); // DeltaHorizontal
            evt.movementY = deviceInputSystem.pollInput(deviceType, deviceSlot, 11 /* NativePointerInput.DeltaVertical */ ); // DeltaVertical
            evt.offsetX = 0;
            evt.offsetY = 0;
        }
        this._CheckNonCharacterKeys(evt, deviceInputSystem);
        evt.clientX = pointerX;
        evt.clientY = pointerY;
        evt.x = pointerX;
        evt.y = pointerY;
        evt.deviceType = deviceType;
        evt.deviceSlot = deviceSlot;
        evt.inputIndex = inputIndex;
        return evt;
    }
    /**
     * Create Keyboard Event
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @returns IEvent object (Keyboard)
     */ static _CreateKeyboardEvent(inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
        const evt = this._CreateEvent(elementToAttachTo);
        this._CheckNonCharacterKeys(evt, deviceInputSystem);
        evt.deviceType = (0, $1orLO.DeviceType).Keyboard;
        evt.deviceSlot = 0;
        evt.inputIndex = inputIndex;
        evt.type = currentState === 1 ? "keydown" : "keyup";
        evt.key = String.fromCharCode(inputIndex);
        evt.keyCode = inputIndex;
        return evt;
    }
    /**
     * Add parameters for non-character keys (Ctrl, Alt, Meta, Shift)
     * @param evt Event object to add parameters to
     * @param deviceInputSystem DeviceInputSystem to pull values from
     */ static _CheckNonCharacterKeys(evt, deviceInputSystem) {
        const isKeyboardActive = deviceInputSystem.isDeviceAvailable((0, $1orLO.DeviceType).Keyboard);
        const altKey = isKeyboardActive && deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 18) === 1;
        const ctrlKey = isKeyboardActive && deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 17) === 1;
        const metaKey = isKeyboardActive && (deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 91) === 1 || deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 92) === 1 || deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 93) === 1);
        const shiftKey = isKeyboardActive && deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 16) === 1;
        evt.altKey = altKey;
        evt.ctrlKey = ctrlKey;
        evt.metaKey = metaKey;
        evt.shiftKey = shiftKey;
    }
    /**
     * Create base event object
     * @param elementToAttachTo Value to use as event target
     * @returns
     */ static _CreateEvent(elementToAttachTo) {
        const evt = {};
        evt.preventDefault = ()=>{};
        evt.target = elementToAttachTo;
        return evt;
    }
}

});
parcelRegister("jzXHO", function(module, exports) {

$parcel$export(module.exports, "EventConstants", () => $e40f997fe02c49f2$export$34ce6eeede54e4b1);
/**
 * Event Types
 */ var $e40f997fe02c49f2$export$78d4eae8a1afef6a;
(function(DeviceInputEventType) {
    // Pointers
    /** PointerMove */ DeviceInputEventType[DeviceInputEventType["PointerMove"] = 0] = "PointerMove";
    /** PointerDown */ DeviceInputEventType[DeviceInputEventType["PointerDown"] = 1] = "PointerDown";
    /** PointerUp */ DeviceInputEventType[DeviceInputEventType["PointerUp"] = 2] = "PointerUp";
})($e40f997fe02c49f2$export$78d4eae8a1afef6a || ($e40f997fe02c49f2$export$78d4eae8a1afef6a = {}));
class $e40f997fe02c49f2$export$34ce6eeede54e4b1 {
}
/**
 * Pixel delta for Wheel Events (Default)
 */ $e40f997fe02c49f2$export$34ce6eeede54e4b1.DOM_DELTA_PIXEL = 0x00;
/**
 * Line delta for Wheel Events
 */ $e40f997fe02c49f2$export$34ce6eeede54e4b1.DOM_DELTA_LINE = 0x01;
/**
 * Page delta for Wheel Events
 */ $e40f997fe02c49f2$export$34ce6eeede54e4b1.DOM_DELTA_PAGE = 0x02;

});



parcelRegister("ehija", function(module, exports) {

$parcel$export(module.exports, "WebDeviceInputSystem", () => $a650dad51390e5d8$export$9337c7f7aa3e5fe9);

var $jFz47 = parcelRequire("jFz47");

var $bOhSV = parcelRequire("bOhSV");

var $f1QSW = parcelRequire("f1QSW");

var $1orLO = parcelRequire("1orLO");
// eslint-disable-next-line @typescript-eslint/naming-convention
const $a650dad51390e5d8$var$MAX_KEYCODES = 255;
// eslint-disable-next-line @typescript-eslint/naming-convention
const $a650dad51390e5d8$var$MAX_POINTER_INPUTS = Object.keys((0, $1orLO.PointerInput)).length / 2;
class $a650dad51390e5d8$export$9337c7f7aa3e5fe9 {
    /**
     * Constructor for the WebDeviceInputSystem
     * @param engine Engine to reference
     * @param onDeviceConnected Callback to execute when device is connected
     * @param onDeviceDisconnected Callback to execute when device is disconnected
     * @param onInputChanged Callback to execute when input changes on device
     */ constructor(engine, onDeviceConnected, onDeviceDisconnected, onInputChanged){
        // Private Members
        this._inputs = [];
        this._keyboardActive = false;
        this._pointerActive = false;
        this._usingSafari = (0, $bOhSV.Tools).IsSafari();
        // Found solution for determining if MacOS is being used here:
        // https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
        this._usingMacOS = (0, $jFz47.IsNavigatorAvailable)() && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._keyboardDownEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._keyboardUpEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._keyboardBlurEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerMoveEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerDownEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerUpEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerCancelEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerWheelEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerBlurEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerMacOSChromeOutEvent = (evt)=>{};
        this._eventsAttached = false;
        this._mouseId = -1;
        this._isUsingFirefox = (0, $jFz47.IsNavigatorAvailable)() && navigator.userAgent && navigator.userAgent.indexOf("Firefox") !== -1;
        this._isUsingChromium = (0, $jFz47.IsNavigatorAvailable)() && navigator.userAgent && navigator.userAgent.indexOf("Chrome") !== -1;
        this._maxTouchPoints = 0;
        this._pointerInputClearObserver = null;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._gamepadConnectedEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._gamepadDisconnectedEvent = (evt)=>{};
        this._eventPrefix = (0, $bOhSV.Tools).GetPointerPrefix(engine);
        this._engine = engine;
        this._onDeviceConnected = onDeviceConnected;
        this._onDeviceDisconnected = onDeviceDisconnected;
        this._onInputChanged = onInputChanged;
        // If we need a pointerId, set one for future use
        this._mouseId = this._isUsingFirefox ? 0 : 1;
        this._enableEvents();
        if (this._usingMacOS) this._metaKeys = [];
        // Set callback to enable event handler switching when inputElement changes
        if (!this._engine._onEngineViewChanged) this._engine._onEngineViewChanged = ()=>{
            this._enableEvents();
        };
    }
    // Public functions
    /**
     * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @returns Current value of input
     */ pollInput(deviceType, deviceSlot, inputIndex) {
        const device = this._inputs[deviceType][deviceSlot];
        if (!device) // eslint-disable-next-line no-throw-literal
        throw `Unable to find device ${(0, $1orLO.DeviceType)[deviceType]}`;
        if (deviceType >= (0, $1orLO.DeviceType).DualShock && deviceType <= (0, $1orLO.DeviceType).DualSense) this._updateDevice(deviceType, deviceSlot, inputIndex);
        const currentValue = device[inputIndex];
        if (currentValue === undefined) // eslint-disable-next-line no-throw-literal
        throw `Unable to find input ${inputIndex} for device ${(0, $1orLO.DeviceType)[deviceType]} in slot ${deviceSlot}`;
        if (inputIndex === (0, $1orLO.PointerInput).Move) (0, $bOhSV.Tools).Warn(`Unable to provide information for PointerInput.Move.  Try using PointerInput.Horizontal or PointerInput.Vertical for move data.`);
        return currentValue;
    }
    /**
     * Check for a specific device in the DeviceInputSystem
     * @param deviceType Type of device to check for
     * @returns bool with status of device's existence
     */ isDeviceAvailable(deviceType) {
        return this._inputs[deviceType] !== undefined;
    }
    /**
     * Dispose of all the eventlisteners
     */ dispose() {
        // Callbacks
        this._onDeviceConnected = ()=>{};
        this._onDeviceDisconnected = ()=>{};
        this._onInputChanged = ()=>{};
        delete this._engine._onEngineViewChanged;
        if (this._elementToAttachTo) this._disableEvents();
    }
    /**
     * Enable listening for user input events
     */ _enableEvents() {
        const inputElement = this?._engine.getInputElement();
        if (inputElement && (!this._eventsAttached || this._elementToAttachTo !== inputElement)) {
            // Remove events before adding to avoid double events or simultaneous events on multiple canvases
            this._disableEvents();
            // If the inputs array has already been created, zero it out to before setting up events
            if (this._inputs) for (const inputs of this._inputs){
                if (inputs) for(const deviceSlotKey in inputs){
                    const deviceSlot = +deviceSlotKey;
                    const device = inputs[deviceSlot];
                    if (device) for(let inputIndex = 0; inputIndex < device.length; inputIndex++)device[inputIndex] = 0;
                }
            }
            this._elementToAttachTo = inputElement;
            // Set tab index for the inputElement to the engine's canvasTabIndex, if and only if the element's tab index is -1
            this._elementToAttachTo.tabIndex = this._elementToAttachTo.tabIndex !== -1 ? this._elementToAttachTo.tabIndex : this._engine.canvasTabIndex;
            this._handleKeyActions();
            this._handlePointerActions();
            this._handleGamepadActions();
            this._eventsAttached = true;
            // Check for devices that are already connected but aren't registered. Currently, only checks for gamepads and mouse
            this._checkForConnectedDevices();
        }
    }
    /**
     * Disable listening for user input events
     */ _disableEvents() {
        if (this._elementToAttachTo) {
            // Blur Events
            this._elementToAttachTo.removeEventListener("blur", this._keyboardBlurEvent);
            this._elementToAttachTo.removeEventListener("blur", this._pointerBlurEvent);
            // Keyboard Events
            this._elementToAttachTo.removeEventListener("keydown", this._keyboardDownEvent);
            this._elementToAttachTo.removeEventListener("keyup", this._keyboardUpEvent);
            // Pointer Events
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "move", this._pointerMoveEvent);
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "down", this._pointerDownEvent);
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "up", this._pointerUpEvent);
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent);
            this._elementToAttachTo.removeEventListener(this._wheelEventName, this._pointerWheelEvent);
            if (this._usingMacOS && this._isUsingChromium) this._elementToAttachTo.removeEventListener("lostpointercapture", this._pointerMacOSChromeOutEvent);
            // Gamepad Events
            window.removeEventListener("gamepadconnected", this._gamepadConnectedEvent);
            window.removeEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
        }
        if (this._pointerInputClearObserver) this._engine.onEndFrameObservable.remove(this._pointerInputClearObserver);
        this._eventsAttached = false;
    }
    /**
     * Checks for existing connections to devices and register them, if necessary
     * Currently handles gamepads and mouse
     */ _checkForConnectedDevices() {
        if (navigator.getGamepads) {
            const gamepads = navigator.getGamepads();
            for (const gamepad of gamepads)if (gamepad) this._addGamePad(gamepad);
        }
        // If the device in use has mouse capabilities, pre-register mouse
        if (typeof matchMedia === "function" && matchMedia("(pointer:fine)").matches) // This will provide a dummy value for the cursor position and is expected to be overridden when the first mouse event happens.
        // There isn't any good way to get the current position outside of a pointer event so that's why this was done.
        this._addPointerDevice((0, $1orLO.DeviceType).Mouse, 0, 0, 0);
    }
    // Private functions
    /**
     * Add a gamepad to the DeviceInputSystem
     * @param gamepad A single DOM Gamepad object
     */ _addGamePad(gamepad) {
        const deviceType = this._getGamepadDeviceType(gamepad.id);
        const deviceSlot = gamepad.index;
        this._gamepads = this._gamepads || new Array(gamepad.index + 1);
        this._registerDevice(deviceType, deviceSlot, gamepad.buttons.length + gamepad.axes.length);
        this._gamepads[deviceSlot] = deviceType;
    }
    /**
     * Add pointer device to DeviceInputSystem
     * @param deviceType Type of Pointer to add
     * @param deviceSlot Pointer ID (0 for mouse, pointerId for Touch)
     * @param currentX Current X at point of adding
     * @param currentY Current Y at point of adding
     */ _addPointerDevice(deviceType, deviceSlot, currentX, currentY) {
        if (!this._pointerActive) this._pointerActive = true;
        this._registerDevice(deviceType, deviceSlot, $a650dad51390e5d8$var$MAX_POINTER_INPUTS);
        const pointer = this._inputs[deviceType][deviceSlot]; /* initialize our pointer position immediately after registration */ 
        pointer[0] = currentX;
        pointer[1] = currentY;
    }
    /**
     * Add device and inputs to device array
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param numberOfInputs Number of input entries to create for given device
     */ _registerDevice(deviceType, deviceSlot, numberOfInputs) {
        if (deviceSlot === undefined) // eslint-disable-next-line no-throw-literal
        throw `Unable to register device ${(0, $1orLO.DeviceType)[deviceType]} to undefined slot.`;
        if (!this._inputs[deviceType]) this._inputs[deviceType] = {};
        if (!this._inputs[deviceType][deviceSlot]) {
            const device = new Array(numberOfInputs);
            device.fill(0);
            this._inputs[deviceType][deviceSlot] = device;
            this._onDeviceConnected(deviceType, deviceSlot);
        }
    }
    /**
     * Given a specific device name, remove that device from the device map
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     */ _unregisterDevice(deviceType, deviceSlot) {
        if (this._inputs[deviceType][deviceSlot]) {
            delete this._inputs[deviceType][deviceSlot];
            this._onDeviceDisconnected(deviceType, deviceSlot);
        }
    }
    /**
     * Handle all actions that come from keyboard interaction
     */ _handleKeyActions() {
        this._keyboardDownEvent = (evt)=>{
            if (!this._keyboardActive) {
                this._keyboardActive = true;
                this._registerDevice((0, $1orLO.DeviceType).Keyboard, 0, $a650dad51390e5d8$var$MAX_KEYCODES);
            }
            const kbKey = this._inputs[(0, $1orLO.DeviceType).Keyboard][0];
            if (kbKey) {
                kbKey[evt.keyCode] = 1;
                const deviceEvent = evt;
                deviceEvent.inputIndex = evt.keyCode;
                if (this._usingMacOS && evt.metaKey && evt.key !== "Meta") {
                    if (!this._metaKeys.includes(evt.keyCode)) this._metaKeys.push(evt.keyCode);
                }
                this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
            }
        };
        this._keyboardUpEvent = (evt)=>{
            if (!this._keyboardActive) {
                this._keyboardActive = true;
                this._registerDevice((0, $1orLO.DeviceType).Keyboard, 0, $a650dad51390e5d8$var$MAX_KEYCODES);
            }
            const kbKey = this._inputs[(0, $1orLO.DeviceType).Keyboard][0];
            if (kbKey) {
                kbKey[evt.keyCode] = 0;
                const deviceEvent = evt;
                deviceEvent.inputIndex = evt.keyCode;
                if (this._usingMacOS && evt.key === "Meta" && this._metaKeys.length > 0) {
                    for (const keyCode of this._metaKeys){
                        const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Keyboard, 0, keyCode, 0, this, this._elementToAttachTo);
                        kbKey[keyCode] = 0;
                        this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
                    }
                    this._metaKeys.splice(0, this._metaKeys.length);
                }
                this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
            }
        };
        this._keyboardBlurEvent = ()=>{
            if (this._keyboardActive) {
                const kbKey = this._inputs[(0, $1orLO.DeviceType).Keyboard][0];
                for(let i = 0; i < kbKey.length; i++)if (kbKey[i] !== 0) {
                    kbKey[i] = 0;
                    const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Keyboard, 0, i, 0, this, this._elementToAttachTo);
                    this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
                }
                if (this._usingMacOS) this._metaKeys.splice(0, this._metaKeys.length);
            }
        };
        this._elementToAttachTo.addEventListener("keydown", this._keyboardDownEvent);
        this._elementToAttachTo.addEventListener("keyup", this._keyboardUpEvent);
        this._elementToAttachTo.addEventListener("blur", this._keyboardBlurEvent);
    }
    /**
     * Handle all actions that come from pointer interaction
     */ _handlePointerActions() {
        // If maxTouchPoints is defined, use that value.  Otherwise, allow for a minimum for supported gestures like pinch
        this._maxTouchPoints = (0, $jFz47.IsNavigatorAvailable)() && navigator.maxTouchPoints || 2;
        if (!this._activeTouchIds) this._activeTouchIds = new Array(this._maxTouchPoints);
        for(let i = 0; i < this._maxTouchPoints; i++)this._activeTouchIds[i] = -1;
        this._pointerMoveEvent = (evt)=>{
            const deviceType = this._getPointerType(evt);
            let deviceSlot = deviceType === (0, $1orLO.DeviceType).Mouse ? 0 : this._activeTouchIds.indexOf(evt.pointerId);
            // In the event that we're getting pointermove events from touch inputs that we aren't tracking,
            // look for an available slot and retroactively connect it.
            if (deviceType === (0, $1orLO.DeviceType).Touch && deviceSlot === -1) {
                const idx = this._activeTouchIds.indexOf(-1);
                if (idx >= 0) {
                    deviceSlot = idx;
                    this._activeTouchIds[idx] = evt.pointerId;
                    // Because this is a "new" input, inform the connected callback
                    this._onDeviceConnected(deviceType, deviceSlot);
                } else {
                    // We can't find an open slot to store new pointer so just return (can only support max number of touches)
                    (0, $bOhSV.Tools).Warn(`Max number of touches exceeded.  Ignoring touches in excess of ${this._maxTouchPoints}`);
                    return;
                }
            }
            if (!this._inputs[deviceType]) this._inputs[deviceType] = {};
            if (!this._inputs[deviceType][deviceSlot]) this._addPointerDevice(deviceType, deviceSlot, evt.clientX, evt.clientY);
            const pointer = this._inputs[deviceType][deviceSlot];
            if (pointer) {
                const deviceEvent = evt;
                deviceEvent.inputIndex = (0, $1orLO.PointerInput).Move;
                pointer[(0, $1orLO.PointerInput).Horizontal] = evt.clientX;
                pointer[(0, $1orLO.PointerInput).Vertical] = evt.clientY;
                // For touches that aren't started with a down, we need to set the button state to 1
                if (deviceType === (0, $1orLO.DeviceType).Touch && pointer[(0, $1orLO.PointerInput).LeftClick] === 0) pointer[(0, $1orLO.PointerInput).LeftClick] = 1;
                if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                // Lets Propagate the event for move with same position.
                if (!this._usingSafari && evt.button !== -1) {
                    deviceEvent.inputIndex = evt.button + 2;
                    pointer[evt.button + 2] = pointer[evt.button + 2] ? 0 : 1; // Reverse state of button if evt.button has value
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
            }
        };
        this._pointerDownEvent = (evt)=>{
            const deviceType = this._getPointerType(evt);
            let deviceSlot = deviceType === (0, $1orLO.DeviceType).Mouse ? 0 : evt.pointerId;
            if (deviceType === (0, $1orLO.DeviceType).Touch) {
                // See if this pointerId is already using an existing slot
                // (possible on some devices which raise the pointerMove event before the pointerDown event, e.g. when using a pen)
                let idx = this._activeTouchIds.indexOf(evt.pointerId);
                if (idx === -1) // If the pointerId wasn't already using a slot, find an open one
                idx = this._activeTouchIds.indexOf(-1);
                if (idx >= 0) {
                    deviceSlot = idx;
                    this._activeTouchIds[idx] = evt.pointerId;
                } else {
                    // We can't find an open slot to store new pointer so just return (can only support max number of touches)
                    (0, $bOhSV.Tools).Warn(`Max number of touches exceeded.  Ignoring touches in excess of ${this._maxTouchPoints}`);
                    return;
                }
            }
            if (!this._inputs[deviceType]) this._inputs[deviceType] = {};
            if (!this._inputs[deviceType][deviceSlot]) this._addPointerDevice(deviceType, deviceSlot, evt.clientX, evt.clientY);
            else if (deviceType === (0, $1orLO.DeviceType).Touch) this._onDeviceConnected(deviceType, deviceSlot);
            const pointer = this._inputs[deviceType][deviceSlot];
            if (pointer) {
                const previousHorizontal = pointer[(0, $1orLO.PointerInput).Horizontal];
                const previousVertical = pointer[(0, $1orLO.PointerInput).Vertical];
                if (deviceType === (0, $1orLO.DeviceType).Mouse) {
                    // Mouse; Set pointerId if undefined
                    if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                    if (!document.pointerLockElement) try {
                        this._elementToAttachTo.setPointerCapture(this._mouseId);
                    } catch (e) {
                    // DO NOTHING
                    }
                } else {
                    // Touch; Since touches are dynamically assigned, only set capture if we have an id
                    if (evt.pointerId && !document.pointerLockElement) try {
                        this._elementToAttachTo.setPointerCapture(evt.pointerId);
                    } catch (e) {
                    // DO NOTHING
                    }
                }
                pointer[(0, $1orLO.PointerInput).Horizontal] = evt.clientX;
                pointer[(0, $1orLO.PointerInput).Vertical] = evt.clientY;
                pointer[evt.button + 2] = 1;
                const deviceEvent = evt;
                // NOTE: The +2 used here to is because PointerInput has the same value progression for its mouse buttons as PointerEvent.button
                // However, we have our X and Y values front-loaded to group together the touch inputs but not break this progression
                // EG. ([X, Y, Left-click], Middle-click, etc...)
                deviceEvent.inputIndex = evt.button + 2;
                this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                if (previousHorizontal !== evt.clientX || previousVertical !== evt.clientY) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).Move;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
            }
        };
        this._pointerUpEvent = (evt)=>{
            const deviceType = this._getPointerType(evt);
            const deviceSlot = deviceType === (0, $1orLO.DeviceType).Mouse ? 0 : this._activeTouchIds.indexOf(evt.pointerId);
            if (deviceType === (0, $1orLO.DeviceType).Touch) {
                // If we're getting a pointerup event for a touch that isn't active, just return.
                if (deviceSlot === -1) return;
                else this._activeTouchIds[deviceSlot] = -1;
            }
            const pointer = this._inputs[deviceType]?.[deviceSlot];
            if (pointer && pointer[evt.button + 2] !== 0) {
                const previousHorizontal = pointer[(0, $1orLO.PointerInput).Horizontal];
                const previousVertical = pointer[(0, $1orLO.PointerInput).Vertical];
                pointer[(0, $1orLO.PointerInput).Horizontal] = evt.clientX;
                pointer[(0, $1orLO.PointerInput).Vertical] = evt.clientY;
                pointer[evt.button + 2] = 0;
                const deviceEvent = evt;
                if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                if (previousHorizontal !== evt.clientX || previousVertical !== evt.clientY) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).Move;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
                // NOTE: The +2 used here to is because PointerInput has the same value progression for its mouse buttons as PointerEvent.button
                // However, we have our X and Y values front-loaded to group together the touch inputs but not break this progression
                // EG. ([X, Y, Left-click], Middle-click, etc...)
                deviceEvent.inputIndex = evt.button + 2;
                if (deviceType === (0, $1orLO.DeviceType).Mouse && this._mouseId >= 0 && this._elementToAttachTo.hasPointerCapture?.(this._mouseId)) this._elementToAttachTo.releasePointerCapture(this._mouseId);
                else if (evt.pointerId && this._elementToAttachTo.hasPointerCapture?.(evt.pointerId)) this._elementToAttachTo.releasePointerCapture(evt.pointerId);
                this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                if (deviceType === (0, $1orLO.DeviceType).Touch) this._onDeviceDisconnected(deviceType, deviceSlot);
            }
        };
        this._pointerCancelEvent = (evt)=>{
            if (evt.pointerType === "mouse") {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Mouse][0];
                if (this._mouseId >= 0 && this._elementToAttachTo.hasPointerCapture?.(this._mouseId)) this._elementToAttachTo.releasePointerCapture(this._mouseId);
                for(let inputIndex = (0, $1orLO.PointerInput).LeftClick; inputIndex <= (0, $1orLO.PointerInput).BrowserForward; inputIndex++)if (pointer[inputIndex] === 1) {
                    pointer[inputIndex] = 0;
                    const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Mouse, 0, inputIndex, 0, this, this._elementToAttachTo);
                    this._onInputChanged((0, $1orLO.DeviceType).Mouse, 0, deviceEvent);
                }
            } else {
                const deviceSlot = this._activeTouchIds.indexOf(evt.pointerId);
                // If we're getting a pointercancel event for a touch that isn't active, just return
                if (deviceSlot === -1) return;
                if (this._elementToAttachTo.hasPointerCapture?.(evt.pointerId)) this._elementToAttachTo.releasePointerCapture(evt.pointerId);
                this._inputs[(0, $1orLO.DeviceType).Touch][deviceSlot][(0, $1orLO.PointerInput).LeftClick] = 0;
                const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Touch, deviceSlot, (0, $1orLO.PointerInput).LeftClick, 0, this, this._elementToAttachTo, evt.pointerId);
                this._onInputChanged((0, $1orLO.DeviceType).Touch, deviceSlot, deviceEvent);
                this._activeTouchIds[deviceSlot] = -1;
                this._onDeviceDisconnected((0, $1orLO.DeviceType).Touch, deviceSlot);
            }
        };
        // Set Wheel Event Name, code originally from scene.inputManager
        this._wheelEventName = "onwheel" in document.createElement("div") ? "wheel" // Modern browsers support "wheel"
         : document.onmousewheel !== undefined ? "mousewheel" // Webkit and IE support at least "mousewheel"
         : "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox
        // Code originally in scene.inputManager.ts
        // Chrome reports warning in console if wheel listener doesn't set an explicit passive option.
        // IE11 only supports captureEvent:boolean, not options:object, and it defaults to false.
        // Feature detection technique copied from: https://github.com/github/eventlistener-polyfill (MIT license)
        let passiveSupported = false;
        const noop = function() {};
        try {
            const options = Object.defineProperty({}, "passive", {
                get: function() {
                    passiveSupported = true;
                }
            });
            this._elementToAttachTo.addEventListener("test", noop, options);
            this._elementToAttachTo.removeEventListener("test", noop, options);
        } catch (e) {
        /* */ }
        this._pointerBlurEvent = ()=>{
            // Handle mouse buttons
            if (this.isDeviceAvailable((0, $1orLO.DeviceType).Mouse)) {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Mouse][0];
                if (this._mouseId >= 0 && this._elementToAttachTo.hasPointerCapture?.(this._mouseId)) this._elementToAttachTo.releasePointerCapture(this._mouseId);
                for(let inputIndex = (0, $1orLO.PointerInput).LeftClick; inputIndex <= (0, $1orLO.PointerInput).BrowserForward; inputIndex++)if (pointer[inputIndex] === 1) {
                    pointer[inputIndex] = 0;
                    const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Mouse, 0, inputIndex, 0, this, this._elementToAttachTo);
                    this._onInputChanged((0, $1orLO.DeviceType).Mouse, 0, deviceEvent);
                }
            }
            // Handle Active Touches
            if (this.isDeviceAvailable((0, $1orLO.DeviceType).Touch)) {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Touch];
                for(let deviceSlot = 0; deviceSlot < this._activeTouchIds.length; deviceSlot++){
                    const pointerId = this._activeTouchIds[deviceSlot];
                    if (this._elementToAttachTo.hasPointerCapture?.(pointerId)) this._elementToAttachTo.releasePointerCapture(pointerId);
                    if (pointerId !== -1 && pointer[deviceSlot]?.[(0, $1orLO.PointerInput).LeftClick] === 1) {
                        pointer[deviceSlot][(0, $1orLO.PointerInput).LeftClick] = 0;
                        const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Touch, deviceSlot, (0, $1orLO.PointerInput).LeftClick, 0, this, this._elementToAttachTo, pointerId);
                        this._onInputChanged((0, $1orLO.DeviceType).Touch, deviceSlot, deviceEvent);
                        this._activeTouchIds[deviceSlot] = -1;
                        this._onDeviceDisconnected((0, $1orLO.DeviceType).Touch, deviceSlot);
                    }
                }
            }
        };
        this._pointerWheelEvent = (evt)=>{
            const deviceType = (0, $1orLO.DeviceType).Mouse;
            const deviceSlot = 0;
            if (!this._inputs[deviceType]) this._inputs[deviceType] = [];
            if (!this._inputs[deviceType][deviceSlot]) {
                this._pointerActive = true;
                this._registerDevice(deviceType, deviceSlot, $a650dad51390e5d8$var$MAX_POINTER_INPUTS);
            }
            const pointer = this._inputs[deviceType][deviceSlot];
            if (pointer) {
                pointer[(0, $1orLO.PointerInput).MouseWheelX] = evt.deltaX || 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelY] = evt.deltaY || evt.wheelDelta || 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelZ] = evt.deltaZ || 0;
                const deviceEvent = evt;
                // By default, there is no pointerId for mouse wheel events so we'll add one here
                // This logic was originally in the InputManager but was added here to make the
                // InputManager more platform-agnostic
                if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                if (pointer[(0, $1orLO.PointerInput).MouseWheelX] !== 0) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).MouseWheelX;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
                if (pointer[(0, $1orLO.PointerInput).MouseWheelY] !== 0) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).MouseWheelY;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
                if (pointer[(0, $1orLO.PointerInput).MouseWheelZ] !== 0) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).MouseWheelZ;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
            }
        };
        // Workaround for MacOS Chromium Browsers for lost pointer capture bug
        if (this._usingMacOS && this._isUsingChromium) {
            this._pointerMacOSChromeOutEvent = (evt)=>{
                if (evt.buttons > 1) this._pointerCancelEvent(evt);
            };
            this._elementToAttachTo.addEventListener("lostpointercapture", this._pointerMacOSChromeOutEvent);
        }
        this._elementToAttachTo.addEventListener(this._eventPrefix + "move", this._pointerMoveEvent);
        this._elementToAttachTo.addEventListener(this._eventPrefix + "down", this._pointerDownEvent);
        this._elementToAttachTo.addEventListener(this._eventPrefix + "up", this._pointerUpEvent);
        this._elementToAttachTo.addEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent);
        this._elementToAttachTo.addEventListener("blur", this._pointerBlurEvent);
        this._elementToAttachTo.addEventListener(this._wheelEventName, this._pointerWheelEvent, passiveSupported ? {
            passive: false
        } : false);
        // Since there's no up or down event for mouse wheel or delta x/y, clear mouse values at end of frame
        this._pointerInputClearObserver = this._engine.onEndFrameObservable.add(()=>{
            if (this.isDeviceAvailable((0, $1orLO.DeviceType).Mouse)) {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Mouse][0];
                pointer[(0, $1orLO.PointerInput).MouseWheelX] = 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelY] = 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelZ] = 0;
            }
        });
    }
    /**
     * Handle all actions that come from gamepad interaction
     */ _handleGamepadActions() {
        this._gamepadConnectedEvent = (evt)=>{
            this._addGamePad(evt.gamepad);
        };
        this._gamepadDisconnectedEvent = (evt)=>{
            if (this._gamepads) {
                const deviceType = this._getGamepadDeviceType(evt.gamepad.id);
                const deviceSlot = evt.gamepad.index;
                this._unregisterDevice(deviceType, deviceSlot);
                delete this._gamepads[deviceSlot];
            }
        };
        window.addEventListener("gamepadconnected", this._gamepadConnectedEvent);
        window.addEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
    }
    /**
     * Update all non-event based devices with each frame
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     */ _updateDevice(deviceType, deviceSlot, inputIndex) {
        // Gamepads
        const gp = navigator.getGamepads()[deviceSlot];
        if (gp && deviceType === this._gamepads[deviceSlot]) {
            const device = this._inputs[deviceType][deviceSlot];
            if (inputIndex >= gp.buttons.length) device[inputIndex] = gp.axes[inputIndex - gp.buttons.length].valueOf();
            else device[inputIndex] = gp.buttons[inputIndex].value;
        }
    }
    /**
     * Gets DeviceType from the device name
     * @param deviceName Name of Device from DeviceInputSystem
     * @returns DeviceType enum value
     */ _getGamepadDeviceType(deviceName) {
        if (deviceName.indexOf("054c") !== -1) // DualShock 4 Gamepad
        return deviceName.indexOf("0ce6") !== -1 ? (0, $1orLO.DeviceType).DualSense : (0, $1orLO.DeviceType).DualShock;
        else if (deviceName.indexOf("Xbox One") !== -1 || deviceName.search("Xbox 360") !== -1 || deviceName.search("xinput") !== -1) // Xbox Gamepad
        return (0, $1orLO.DeviceType).Xbox;
        else if (deviceName.indexOf("057e") !== -1) // Switch Gamepad
        return (0, $1orLO.DeviceType).Switch;
        return (0, $1orLO.DeviceType).Generic;
    }
    /**
     * Get DeviceType from a given pointer/mouse/touch event.
     * @param evt PointerEvent to evaluate
     * @returns DeviceType interpreted from event
     */ _getPointerType(evt) {
        let deviceType = (0, $1orLO.DeviceType).Mouse;
        if (evt.pointerType === "touch" || evt.pointerType === "pen" || evt.touches) deviceType = (0, $1orLO.DeviceType).Touch;
        return deviceType;
    }
}

});

parcelRegister("akBjT", function(module, exports) {

$parcel$export(module.exports, "DeviceSource", () => $7858b8951db01de7$export$264532641760444);

var $diGQf = parcelRequire("diGQf");
class $7858b8951db01de7$export$264532641760444 {
    /**
     * Default Constructor
     * @param deviceInputSystem - Reference to DeviceInputSystem
     * @param deviceType - Type of device
     * @param deviceSlot - "Slot" or index that device is referenced in
     */ constructor(deviceInputSystem, /** Type of device */ deviceType, /** [0] "Slot" or index that device is referenced in */ deviceSlot = 0){
        this.deviceType = deviceType;
        this.deviceSlot = deviceSlot;
        // Public Members
        /**
         * Observable to handle device input changes per device
         */ this.onInputChangedObservable = new (0, $diGQf.Observable)();
        this._deviceInputSystem = deviceInputSystem;
    }
    /**
     * Get input for specific input
     * @param inputIndex - index of specific input on device
     * @returns Input value from DeviceInputSystem
     */ getInput(inputIndex) {
        return this._deviceInputSystem.pollInput(this.deviceType, this.deviceSlot, inputIndex);
    }
}

});



parcelRegister("4e7OM", function(module, exports) {

$parcel$export(module.exports, "_ImportHelper", () => $313e88bdae7fd627$export$99d6861909bdde75);
/** @internal */ class $313e88bdae7fd627$export$99d6861909bdde75 {
}
/** @internal */ $313e88bdae7fd627$export$99d6861909bdde75._IsPickingAvailable = false;

});


parcelRegister("2Fclq", function(module, exports) {

$parcel$export(module.exports, "PerfCounter", () => $1f08fc7b770eb129$export$b169dc0b1adb5bcf);

var $blHSI = parcelRequire("blHSI");
class $1f08fc7b770eb129$export$b169dc0b1adb5bcf {
    /**
     * Returns the smallest value ever
     */ get min() {
        return this._min;
    }
    /**
     * Returns the biggest value ever
     */ get max() {
        return this._max;
    }
    /**
     * Returns the average value since the performance counter is running
     */ get average() {
        return this._average;
    }
    /**
     * Returns the average value of the last second the counter was monitored
     */ get lastSecAverage() {
        return this._lastSecAverage;
    }
    /**
     * Returns the current value
     */ get current() {
        return this._current;
    }
    /**
     * Gets the accumulated total
     */ get total() {
        return this._totalAccumulated;
    }
    /**
     * Gets the total value count
     */ get count() {
        return this._totalValueCount;
    }
    /**
     * Creates a new counter
     */ constructor(){
        this._startMonitoringTime = 0;
        this._min = 0;
        this._max = 0;
        this._average = 0;
        this._lastSecAverage = 0;
        this._current = 0;
        this._totalValueCount = 0;
        this._totalAccumulated = 0;
        this._lastSecAccumulated = 0;
        this._lastSecTime = 0;
        this._lastSecValueCount = 0;
    }
    /**
     * Call this method to start monitoring a new frame.
     * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the start of the frame, then beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
     */ fetchNewFrame() {
        this._totalValueCount++;
        this._current = 0;
        this._lastSecValueCount++;
    }
    /**
     * Call this method to monitor a count of something (e.g. mesh drawn in viewport count)
     * @param newCount the count value to add to the monitored count
     * @param fetchResult true when it's the last time in the frame you add to the counter and you wish to update the statistics properties (min/max/average), false if you only want to update statistics.
     */ addCount(newCount, fetchResult) {
        if (!$1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled) return;
        this._current += newCount;
        if (fetchResult) this._fetchResult();
    }
    /**
     * Start monitoring this performance counter
     */ beginMonitoring() {
        if (!$1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled) return;
        this._startMonitoringTime = (0, $blHSI.PrecisionDate).Now;
    }
    /**
     * Compute the time lapsed since the previous beginMonitoring() call.
     * @param newFrame true by default to fetch the result and monitor a new frame, if false the time monitored will be added to the current frame counter
     */ endMonitoring(newFrame = true) {
        if (!$1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled) return;
        if (newFrame) this.fetchNewFrame();
        const currentTime = (0, $blHSI.PrecisionDate).Now;
        this._current = currentTime - this._startMonitoringTime;
        if (newFrame) this._fetchResult();
    }
    /**
     * Call this method to end the monitoring of a frame.
     * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the end of the frame, after beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
     */ endFrame() {
        this._fetchResult();
    }
    /** @internal */ _fetchResult() {
        this._totalAccumulated += this._current;
        this._lastSecAccumulated += this._current;
        // Min/Max update
        this._min = Math.min(this._min, this._current);
        this._max = Math.max(this._max, this._current);
        this._average = this._totalAccumulated / this._totalValueCount;
        // Reset last sec?
        const now = (0, $blHSI.PrecisionDate).Now;
        if (now - this._lastSecTime > 1000) {
            this._lastSecAverage = this._lastSecAccumulated / this._lastSecValueCount;
            this._lastSecTime = now;
            this._lastSecAccumulated = 0;
            this._lastSecValueCount = 0;
        }
    }
}
/**
 * Gets or sets a global boolean to turn on and off all the counters
 */ $1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled = true;

});

parcelRegister("9sPMJ", function(module, exports) {

$parcel$export(module.exports, "Frustum", () => $6e3ee5fb23c17dba$export$35efe6f4c85463d2);

var $23POp = parcelRequire("23POp");
class $6e3ee5fb23c17dba$export$35efe6f4c85463d2 {
    /**
     * Gets the planes representing the frustum
     * @param transform matrix to be applied to the returned planes
     * @returns a new array of 6 Frustum planes computed by the given transformation matrix.
     */ static GetPlanes(transform) {
        const frustumPlanes = [];
        for(let index = 0; index < 6; index++)frustumPlanes.push(new (0, $23POp.Plane)(0.0, 0.0, 0.0, 0.0));
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetPlanesToRef(transform, frustumPlanes);
        return frustumPlanes;
    }
    /**
     * Gets the near frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetNearPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] + m[2];
        frustumPlane.normal.y = m[7] + m[6];
        frustumPlane.normal.z = m[11] + m[10];
        frustumPlane.d = m[15] + m[14];
        frustumPlane.normalize();
    }
    /**
     * Gets the far frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetFarPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] - m[2];
        frustumPlane.normal.y = m[7] - m[6];
        frustumPlane.normal.z = m[11] - m[10];
        frustumPlane.d = m[15] - m[14];
        frustumPlane.normalize();
    }
    /**
     * Gets the left frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetLeftPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] + m[0];
        frustumPlane.normal.y = m[7] + m[4];
        frustumPlane.normal.z = m[11] + m[8];
        frustumPlane.d = m[15] + m[12];
        frustumPlane.normalize();
    }
    /**
     * Gets the right frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetRightPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] - m[0];
        frustumPlane.normal.y = m[7] - m[4];
        frustumPlane.normal.z = m[11] - m[8];
        frustumPlane.d = m[15] - m[12];
        frustumPlane.normalize();
    }
    /**
     * Gets the top frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetTopPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] - m[1];
        frustumPlane.normal.y = m[7] - m[5];
        frustumPlane.normal.z = m[11] - m[9];
        frustumPlane.d = m[15] - m[13];
        frustumPlane.normalize();
    }
    /**
     * Gets the bottom frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetBottomPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] + m[1];
        frustumPlane.normal.y = m[7] + m[5];
        frustumPlane.normal.z = m[11] + m[9];
        frustumPlane.d = m[15] + m[13];
        frustumPlane.normalize();
    }
    /**
     * Sets the given array "frustumPlanes" with the 6 Frustum planes computed by the given transformation matrix.
     * @param transform transformation matrix to be applied to the resulting frustum planes
     * @param frustumPlanes the resulting frustum planes
     */ static GetPlanesToRef(transform, frustumPlanes) {
        // Near
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetNearPlaneToRef(transform, frustumPlanes[0]);
        // Far
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetFarPlaneToRef(transform, frustumPlanes[1]);
        // Left
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetLeftPlaneToRef(transform, frustumPlanes[2]);
        // Right
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetRightPlaneToRef(transform, frustumPlanes[3]);
        // Top
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetTopPlaneToRef(transform, frustumPlanes[4]);
        // Bottom
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetBottomPlaneToRef(transform, frustumPlanes[5]);
    }
    /**
     * Tests if a point is located between the frustum planes.
     * @param point defines the point to test
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if the point is located between the frustum planes
     */ static IsPointInFrustum(point, frustumPlanes) {
        for(let i = 0; i < 6; i++){
            if (frustumPlanes[i].dotCoordinate(point) < 0) return false;
        }
        return true;
    }
}

});
parcelRegister("23POp", function(module, exports) {

$parcel$export(module.exports, "Plane", () => $18040d5ac1d0a403$export$7ff5ac152ef991b0);

var $ha1VO = parcelRequire("ha1VO");
class $18040d5ac1d0a403$export$7ff5ac152ef991b0 {
    /**
     * Creates a Plane object according to the given floats a, b, c, d and the plane equation : ax + by + cz + d = 0
     * @param a a component of the plane
     * @param b b component of the plane
     * @param c c component of the plane
     * @param d d component of the plane
     */ constructor(a, b, c, d){
        this.normal = new (0, $ha1VO.Vector3)(a, b, c);
        this.d = d;
    }
    /**
     * @returns the plane coordinates as a new array of 4 elements [a, b, c, d].
     */ asArray() {
        return [
            this.normal.x,
            this.normal.y,
            this.normal.z,
            this.d
        ];
    }
    // Methods
    /**
     * @returns a new plane copied from the current Plane.
     */ clone() {
        return new $18040d5ac1d0a403$export$7ff5ac152ef991b0(this.normal.x, this.normal.y, this.normal.z, this.d);
    }
    /**
     * @returns the string "Plane".
     */ getClassName() {
        return "Plane";
    }
    /**
     * @returns the Plane hash code.
     */ getHashCode() {
        let hash = this.normal.getHashCode();
        hash = hash * 397 ^ (this.d | 0);
        return hash;
    }
    /**
     * Normalize the current Plane in place.
     * @returns the updated Plane.
     */ normalize() {
        const norm = Math.sqrt(this.normal.x * this.normal.x + this.normal.y * this.normal.y + this.normal.z * this.normal.z);
        let magnitude = 0.0;
        if (norm !== 0) magnitude = 1.0 / norm;
        this.normal.x *= magnitude;
        this.normal.y *= magnitude;
        this.normal.z *= magnitude;
        this.d *= magnitude;
        return this;
    }
    /**
     * Applies a transformation the plane and returns the result
     * @param transformation the transformation matrix to be applied to the plane
     * @returns a new Plane as the result of the transformation of the current Plane by the given matrix.
     */ transform(transformation) {
        const invertedMatrix = $18040d5ac1d0a403$export$7ff5ac152ef991b0._TmpMatrix;
        transformation.invertToRef(invertedMatrix);
        const m = invertedMatrix.m;
        const x = this.normal.x;
        const y = this.normal.y;
        const z = this.normal.z;
        const d = this.d;
        const normalX = x * m[0] + y * m[1] + z * m[2] + d * m[3];
        const normalY = x * m[4] + y * m[5] + z * m[6] + d * m[7];
        const normalZ = x * m[8] + y * m[9] + z * m[10] + d * m[11];
        const finalD = x * m[12] + y * m[13] + z * m[14] + d * m[15];
        return new $18040d5ac1d0a403$export$7ff5ac152ef991b0(normalX, normalY, normalZ, finalD);
    }
    /**
     * Compute the dot product between the point and the plane normal
     * @param point point to calculate the dot product with
     * @returns the dot product (float) of the point coordinates and the plane normal.
     */ dotCoordinate(point) {
        return this.normal.x * point.x + this.normal.y * point.y + this.normal.z * point.z + this.d;
    }
    /**
     * Updates the current Plane from the plane defined by the three given points.
     * @param point1 one of the points used to construct the plane
     * @param point2 one of the points used to construct the plane
     * @param point3 one of the points used to construct the plane
     * @returns the updated Plane.
     */ copyFromPoints(point1, point2, point3) {
        const x1 = point2.x - point1.x;
        const y1 = point2.y - point1.y;
        const z1 = point2.z - point1.z;
        const x2 = point3.x - point1.x;
        const y2 = point3.y - point1.y;
        const z2 = point3.z - point1.z;
        const yz = y1 * z2 - z1 * y2;
        const xz = z1 * x2 - x1 * z2;
        const xy = x1 * y2 - y1 * x2;
        const pyth = Math.sqrt(yz * yz + xz * xz + xy * xy);
        let invPyth;
        if (pyth !== 0) invPyth = 1.0 / pyth;
        else invPyth = 0.0;
        this.normal.x = yz * invPyth;
        this.normal.y = xz * invPyth;
        this.normal.z = xy * invPyth;
        this.d = -(this.normal.x * point1.x + this.normal.y * point1.y + this.normal.z * point1.z);
        return this;
    }
    /**
     * Checks if the plane is facing a given direction (meaning if the plane's normal is pointing in the opposite direction of the given vector).
     * Note that for this function to work as expected you should make sure that:
     *   - direction and the plane normal are normalized
     *   - epsilon is a number just bigger than -1, something like -0.99 for eg
     * @param direction the direction to check if the plane is facing
     * @param epsilon value the dot product is compared against (returns true if dot <= epsilon)
     * @returns True if the plane is facing the given direction
     */ isFrontFacingTo(direction, epsilon) {
        const dot = (0, $ha1VO.Vector3).Dot(this.normal, direction);
        return dot <= epsilon;
    }
    /**
     * Calculates the distance to a point
     * @param point point to calculate distance to
     * @returns the signed distance (float) from the given point to the Plane.
     */ signedDistanceTo(point) {
        return (0, $ha1VO.Vector3).Dot(point, this.normal) + this.d;
    }
    // Statics
    /**
     * Creates a plane from an  array
     * @param array the array to create a plane from
     * @returns a new Plane from the given array.
     */ static FromArray(array) {
        return new $18040d5ac1d0a403$export$7ff5ac152ef991b0(array[0], array[1], array[2], array[3]);
    }
    /**
     * Creates a plane from three points
     * @param point1 point used to create the plane
     * @param point2 point used to create the plane
     * @param point3 point used to create the plane
     * @returns a new Plane defined by the three given points.
     */ static FromPoints(point1, point2, point3) {
        const result = new $18040d5ac1d0a403$export$7ff5ac152ef991b0(0.0, 0.0, 0.0, 0.0);
        result.copyFromPoints(point1, point2, point3);
        return result;
    }
    /**
     * Creates a plane from an origin point and a normal
     * @param origin origin of the plane to be constructed
     * @param normal normal of the plane to be constructed
     * @returns a new Plane the normal vector to this plane at the given origin point.
     */ static FromPositionAndNormal(origin, normal) {
        const plane = new $18040d5ac1d0a403$export$7ff5ac152ef991b0(0.0, 0.0, 0.0, 0.0);
        return this.FromPositionAndNormalToRef(origin, normal, plane);
    }
    /**
     * Updates the given Plane "result" from an origin point and a normal.
     * @param origin origin of the plane to be constructed
     * @param normal the normalized normals of the plane to be constructed
     * @param result defines the Plane where to store the result
     * @returns result input
     */ static FromPositionAndNormalToRef(origin, normal, result) {
        result.normal.copyFrom(normal);
        result.normal.normalize();
        result.d = -origin.dot(result.normal);
        return result;
    }
    /**
     * Calculates the distance from a plane and a point
     * @param origin origin of the plane to be constructed
     * @param normal normal of the plane to be constructed
     * @param point point to calculate distance to
     * @returns the signed distance between the plane defined by the normal vector at the "origin"" point and the given other point.
     */ static SignedDistanceToPlaneFromPositionAndNormal(origin, normal, point) {
        const d = -(normal.x * origin.x + normal.y * origin.y + normal.z * origin.z);
        return (0, $ha1VO.Vector3).Dot(point, normal) + d;
    }
}
$18040d5ac1d0a403$export$7ff5ac152ef991b0._TmpMatrix = (0, $ha1VO.Matrix).Identity();

});


parcelRegister("3u0QC", function(module, exports) {

$parcel$export(module.exports, "UniqueIdGenerator", () => $2894d4ca4074affe$export$454cbf26098d48c4);
/**
 * Helper class used to generate session unique ID
 */ class $2894d4ca4074affe$export$454cbf26098d48c4 {
    /**
     * Gets an unique (relatively to the current scene) Id
     */ static get UniqueId() {
        const result = this._UniqueIdCounter;
        this._UniqueIdCounter++;
        return result;
    }
}
// Statics
$2894d4ca4074affe$export$454cbf26098d48c4._UniqueIdCounter = 1;

});

parcelRegister("1gEbu", function(module, exports) {

$parcel$export(module.exports, "LightConstants", () => $0ec674d257277259$export$d8782f3b376962c0);
/** Defines the cross module constantsused by lights to avoid circular dependencies */ class $0ec674d257277259$export$d8782f3b376962c0 {
    /**
     * Sort function to order lights for rendering.
     * @param a First Light object to compare to second.
     * @param b Second Light object to compare first.
     * @returns -1 to reduce's a's index relative to be, 0 for no change, 1 to increase a's index relative to b.
     */ static CompareLightsPriority(a, b) {
        //shadow-casting lights have priority over non-shadow-casting lights
        //the renderPriority is a secondary sort criterion
        if (a.shadowEnabled !== b.shadowEnabled) return (b.shadowEnabled ? 1 : 0) - (a.shadowEnabled ? 1 : 0);
        return b.renderPriority - a.renderPriority;
    }
}
/**
 * Falloff Default: light is falling off following the material specification:
 * standard material is using standard falloff whereas pbr material can request special falloff per materials.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_DEFAULT = 0;
/**
 * Falloff Physical: light is falling off following the inverse squared distance law.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_PHYSICAL = 1;
/**
 * Falloff gltf: light is falling off as described in the gltf moving to PBR document
 * to enhance interoperability with other engines.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_GLTF = 2;
/**
 * Falloff Standard: light is falling off like in the standard material
 * to enhance interoperability with other materials.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_STANDARD = 3;
//lightmapMode Consts
/**
 * If every light affecting the material is in this lightmapMode,
 * material.lightmapTexture adds or multiplies
 * (depends on material.useLightmapAsShadowmap)
 * after every other light calculations.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTMAP_DEFAULT = 0;
/**
 * material.lightmapTexture as only diffuse lighting from this light
 * adds only specular lighting from this light
 * adds dynamic shadows
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTMAP_SPECULAR = 1;
/**
 * material.lightmapTexture as only lighting
 * no light calculation from this light
 * only adds dynamic shadows from this light
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTMAP_SHADOWSONLY = 2;
// Intensity Mode Consts
/**
 * Each light type uses the default quantity according to its type:
 *      point/spot lights use luminous intensity
 *      directional lights use illuminance
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_AUTOMATIC = 0;
/**
 * lumen (lm)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_LUMINOUSPOWER = 1;
/**
 * candela (lm/sr)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_LUMINOUSINTENSITY = 2;
/**
 * lux (lm/m^2)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_ILLUMINANCE = 3;
/**
 * nit (cd/m^2)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_LUMINANCE = 4;
// Light types ids const.
/**
 * Light type const id of the point light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_POINTLIGHT = 0;
/**
 * Light type const id of the directional light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_DIRECTIONALLIGHT = 1;
/**
 * Light type const id of the spot light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_SPOTLIGHT = 2;
/**
 * Light type const id of the hemispheric light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_HEMISPHERICLIGHT = 3;
/**
 * Light type const id of the area light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_RECT_AREALIGHT = 4;

});

parcelRegister("lDzLx", function(module, exports) {

$parcel$export(module.exports, "PointerPickingConfiguration", () => $fc08fbd12e8abddf$export$db76c3278aa44f54);
/**
 * Class used to store configuration data associated with pointer picking
 */ class $fc08fbd12e8abddf$export$db76c3278aa44f54 {
    constructor(){
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer down event
         */ this.pointerDownFastCheck = false;
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer up event
         */ this.pointerUpFastCheck = false;
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer move event
         */ this.pointerMoveFastCheck = false;
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
         */ this.skipPointerMovePicking = false;
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
         */ this.skipPointerDownPicking = false;
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
         */ this.skipPointerUpPicking = false;
    }
}

});


parcelRegister("j2mX5", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $ddc00207ac4a8ab4$export$5431306cf43de24a);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $akOl3 = parcelRequire("akOl3");

var $8DoUR = parcelRequire("8DoUR");

var $dUFYy = parcelRequire("dUFYy");

var $av6Bc = parcelRequire("av6Bc");

var $i1moY = parcelRequire("i1moY");

var $23POp = parcelRequire("23POp");

var $eLv1o = parcelRequire("eLv1o");

var $f2kkL = parcelRequire("f2kkL");

var $fGXjI = parcelRequire("fGXjI");

var $6Ho1L = parcelRequire("6Ho1L");
class $ddc00207ac4a8ab4$export$5431306cf43de24a extends (0, $akOl3.BaseTexture) {
    /**
     * @internal
     */ static _CreateVideoTexture(name, src, scene, generateMipMaps = false, invertY = false, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, settings = {}, onError, format = 5) {
        throw (0, $dUFYy._WarnImport)("VideoTexture");
    }
    /**
     * Are mip maps generated for this texture or not.
     */ get noMipmap() {
        return this._noMipmap;
    }
    /** Returns the texture mime type if it was defined by a loader (undefined else) */ get mimeType() {
        return this._mimeType;
    }
    /**
     * Is the texture preventing material to render while loading.
     * If false, a default texture will be used instead of the loading one during the preparation step.
     */ set isBlocking(value) {
        this._isBlocking = value;
    }
    get isBlocking() {
        return this._isBlocking;
    }
    /**
     * Gets a boolean indicating if the texture needs to be inverted on the y axis during loading
     */ get invertY() {
        return this._invertY;
    }
    /**
     * Instantiates a new texture.
     * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#texture
     * @param url defines the url of the picture to load as a texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
     * @param invertY defines if the texture needs to be inverted on the y axis during loading
     * @param samplingMode defines the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
     * @param onLoad defines a callback triggered when the texture has been loaded
     * @param onError defines a callback triggered when an error occurred during the loading session
     * @param buffer defines the buffer to load the texture from in case the texture is loaded from a buffer representation
     * @param deleteBuffer defines if the buffer we are loading the texture from should be deleted after load
     * @param format defines the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
     * @param mimeType defines an optional mime type information
     * @param loaderOptions options to be passed to the loader
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param forcedExtension defines the extension to use to pick the right loader
     */ constructor(url, sceneOrEngine, noMipmapOrOptions, invertY, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, buffer = null, deleteBuffer = false, format, mimeType, loaderOptions, creationFlags, forcedExtension){
        super(sceneOrEngine);
        /**
         * Define the url of the texture.
         */ this.url = null;
        /**
         * Define an offset on the texture to offset the u coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#offsetting
         */ this.uOffset = 0;
        /**
         * Define an offset on the texture to offset the v coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#offsetting
         */ this.vOffset = 0;
        /**
         * Define an offset on the texture to scale the u coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#tiling
         */ this.uScale = 1.0;
        /**
         * Define an offset on the texture to scale the v coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#tiling
         */ this.vScale = 1.0;
        /**
         * Define an offset on the texture to rotate around the u coordinates of the UVs
         * The angle is defined in radians.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
         */ this.uAng = 0;
        /**
         * Define an offset on the texture to rotate around the v coordinates of the UVs
         * The angle is defined in radians.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
         */ this.vAng = 0;
        /**
         * Define an offset on the texture to rotate around the w coordinates of the UVs (in case of 3d texture)
         * The angle is defined in radians.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
         */ this.wAng = 0;
        /**
         * Defines the center of rotation (U)
         */ this.uRotationCenter = 0.5;
        /**
         * Defines the center of rotation (V)
         */ this.vRotationCenter = 0.5;
        /**
         * Defines the center of rotation (W)
         */ this.wRotationCenter = 0.5;
        /**
         * Sets this property to true to avoid deformations when rotating the texture with non-uniform scaling
         */ this.homogeneousRotationInUVTransform = false;
        /**
         * List of inspectable custom properties (used by the Inspector)
         * @see https://doc.babylonjs.com/toolsAndResources/inspector#extensibility
         */ this.inspectableCustomProperties = null;
        /** @internal */ this._noMipmap = false;
        /** @internal */ this._invertY = false;
        this._rowGenerationMatrix = null;
        this._cachedTextureMatrix = null;
        this._projectionModeMatrix = null;
        this._t0 = null;
        this._t1 = null;
        this._t2 = null;
        this._cachedUOffset = -1;
        this._cachedVOffset = -1;
        this._cachedUScale = 0;
        this._cachedVScale = 0;
        this._cachedUAng = -1;
        this._cachedVAng = -1;
        this._cachedWAng = -1;
        this._cachedReflectionProjectionMatrixId = -1;
        this._cachedURotationCenter = -1;
        this._cachedVRotationCenter = -1;
        this._cachedWRotationCenter = -1;
        this._cachedHomogeneousRotationInUVTransform = false;
        this._cachedIdentity3x2 = true;
        this._cachedReflectionTextureMatrix = null;
        this._cachedReflectionUOffset = -1;
        this._cachedReflectionVOffset = -1;
        this._cachedReflectionUScale = 0;
        this._cachedReflectionVScale = 0;
        this._cachedReflectionCoordinatesMode = -1;
        /** @internal */ this._buffer = null;
        this._deleteBuffer = false;
        this._format = null;
        this._delayedOnLoad = null;
        this._delayedOnError = null;
        /**
         * Observable triggered once the texture has been loaded.
         */ this.onLoadObservable = new (0, $diGQf.Observable)();
        this._isBlocking = true;
        this.name = url || "";
        this.url = url;
        let noMipmap;
        let useSRGBBuffer = false;
        let internalTexture = null;
        let gammaSpace = true;
        if (typeof noMipmapOrOptions === "object" && noMipmapOrOptions !== null) {
            noMipmap = noMipmapOrOptions.noMipmap ?? false;
            invertY = noMipmapOrOptions.invertY ?? !(0, $fGXjI.useOpenGLOrientationForUV);
            samplingMode = noMipmapOrOptions.samplingMode ?? $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE;
            onLoad = noMipmapOrOptions.onLoad ?? null;
            onError = noMipmapOrOptions.onError ?? null;
            buffer = noMipmapOrOptions.buffer ?? null;
            deleteBuffer = noMipmapOrOptions.deleteBuffer ?? false;
            format = noMipmapOrOptions.format;
            mimeType = noMipmapOrOptions.mimeType;
            loaderOptions = noMipmapOrOptions.loaderOptions;
            creationFlags = noMipmapOrOptions.creationFlags;
            useSRGBBuffer = noMipmapOrOptions.useSRGBBuffer ?? false;
            internalTexture = noMipmapOrOptions.internalTexture ?? null;
            gammaSpace = noMipmapOrOptions.gammaSpace ?? gammaSpace;
            forcedExtension = noMipmapOrOptions.forcedExtension ?? forcedExtension;
        } else noMipmap = !!noMipmapOrOptions;
        this._gammaSpace = gammaSpace;
        this._noMipmap = noMipmap;
        this._invertY = invertY === undefined ? !(0, $fGXjI.useOpenGLOrientationForUV) : invertY;
        this._initialSamplingMode = samplingMode;
        this._buffer = buffer;
        this._deleteBuffer = deleteBuffer;
        this._mimeType = mimeType;
        this._loaderOptions = loaderOptions;
        this._creationFlags = creationFlags;
        this._useSRGBBuffer = useSRGBBuffer;
        this._forcedExtension = forcedExtension;
        if (format) this._format = format;
        const scene = this.getScene();
        const engine = this._getEngine();
        if (!engine) return;
        engine.onBeforeTextureInitObservable.notifyObservers(this);
        const load = ()=>{
            if (this._texture) {
                if (this._texture._invertVScale) {
                    this.vScale *= -1;
                    this.vOffset += 1;
                }
                // Update texture to match internal texture's wrapping
                if (this._texture._cachedWrapU !== null) {
                    this.wrapU = this._texture._cachedWrapU;
                    this._texture._cachedWrapU = null;
                }
                if (this._texture._cachedWrapV !== null) {
                    this.wrapV = this._texture._cachedWrapV;
                    this._texture._cachedWrapV = null;
                }
                if (this._texture._cachedWrapR !== null) {
                    this.wrapR = this._texture._cachedWrapR;
                    this._texture._cachedWrapR = null;
                }
            }
            if (this.onLoadObservable.hasObservers()) this.onLoadObservable.notifyObservers(this);
            if (onLoad) onLoad();
            if (!this.isBlocking && scene) scene.resetCachedMaterial();
        };
        const errorHandler = (message, exception)=>{
            this._loadingError = true;
            this._errorObject = {
                message: message,
                exception: exception
            };
            if (onError) onError(message, exception);
            $ddc00207ac4a8ab4$export$5431306cf43de24a.OnTextureLoadErrorObservable.notifyObservers(this);
        };
        if (!this.url && !internalTexture) {
            this._delayedOnLoad = load;
            this._delayedOnError = errorHandler;
            return;
        }
        this._texture = internalTexture ?? this._getFromCache(this.url, noMipmap, samplingMode, this._invertY, useSRGBBuffer, this.isCube);
        if (!this._texture) {
            if (!scene || !scene.useDelayedTextureLoading) {
                try {
                    this._texture = engine.createTexture(this.url, noMipmap, this._invertY, scene, samplingMode, load, errorHandler, this._buffer, undefined, this._format, this._forcedExtension, mimeType, loaderOptions, creationFlags, useSRGBBuffer);
                } catch (e) {
                    errorHandler("error loading", e);
                    throw e;
                }
                if (deleteBuffer) this._buffer = null;
            } else {
                this.delayLoadState = 4;
                this._delayedOnLoad = load;
                this._delayedOnError = errorHandler;
            }
        } else if (this._texture.isReady) (0, $av6Bc.TimingTools).SetImmediate(()=>load());
        else {
            const loadObserver = this._texture.onLoadedObservable.add(load);
            this._texture.onErrorObservable.add((e)=>{
                errorHandler(e.message, e.exception);
                this._texture?.onLoadedObservable.remove(loadObserver);
            });
        }
    }
    /**
     * Update the url (and optional buffer) of this texture if url was null during construction.
     * @param url the url of the texture
     * @param buffer the buffer of the texture (defaults to null)
     * @param onLoad callback called when the texture is loaded  (defaults to null)
     * @param forcedExtension defines the extension to use to pick the right loader
     */ updateURL(url, buffer = null, onLoad, forcedExtension) {
        if (this.url) {
            this.releaseInternalTexture();
            this.getScene().markAllMaterialsAsDirty(1, (mat)=>{
                return mat.hasTexture(this);
            });
        }
        if (!this.name || this.name.startsWith("data:")) this.name = url;
        this.url = url;
        this._buffer = buffer;
        this._forcedExtension = forcedExtension;
        this.delayLoadState = 4;
        if (onLoad) this._delayedOnLoad = onLoad;
        this.delayLoad();
    }
    /**
     * Finish the loading sequence of a texture flagged as delayed load.
     * @internal
     */ delayLoad() {
        if (this.delayLoadState !== 4) return;
        const scene = this.getScene();
        if (!scene) return;
        this.delayLoadState = 1;
        this._texture = this._getFromCache(this.url, this._noMipmap, this.samplingMode, this._invertY, this._useSRGBBuffer, this.isCube);
        if (!this._texture) {
            this._texture = scene.getEngine().createTexture(this.url, this._noMipmap, this._invertY, scene, this.samplingMode, this._delayedOnLoad, this._delayedOnError, this._buffer, null, this._format, this._forcedExtension, this._mimeType, this._loaderOptions, this._creationFlags, this._useSRGBBuffer);
            if (this._deleteBuffer) this._buffer = null;
        } else if (this._delayedOnLoad) {
            if (this._texture.isReady) (0, $av6Bc.TimingTools).SetImmediate(this._delayedOnLoad);
            else this._texture.onLoadedObservable.add(this._delayedOnLoad);
        }
        this._delayedOnLoad = null;
        this._delayedOnError = null;
    }
    _prepareRowForTextureGeneration(x, y, z, t) {
        x *= this._cachedUScale;
        y *= this._cachedVScale;
        x -= this.uRotationCenter * this._cachedUScale;
        y -= this.vRotationCenter * this._cachedVScale;
        z -= this.wRotationCenter;
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, y, z, this._rowGenerationMatrix, t);
        t.x += this.uRotationCenter * this._cachedUScale + this._cachedUOffset;
        t.y += this.vRotationCenter * this._cachedVScale + this._cachedVOffset;
        t.z += this.wRotationCenter;
    }
    /**
     * Get the current texture matrix which includes the requested offsetting, tiling and rotation components.
     * @param uBase The horizontal base offset multiplier (1 by default)
     * @returns the transform matrix of the texture.
     */ getTextureMatrix(uBase = 1) {
        if (this.uOffset === this._cachedUOffset && this.vOffset === this._cachedVOffset && this.uScale * uBase === this._cachedUScale && this.vScale === this._cachedVScale && this.uAng === this._cachedUAng && this.vAng === this._cachedVAng && this.wAng === this._cachedWAng && this.uRotationCenter === this._cachedURotationCenter && this.vRotationCenter === this._cachedVRotationCenter && this.wRotationCenter === this._cachedWRotationCenter && this.homogeneousRotationInUVTransform === this._cachedHomogeneousRotationInUVTransform) return this._cachedTextureMatrix;
        this._cachedUOffset = this.uOffset;
        this._cachedVOffset = this.vOffset;
        this._cachedUScale = this.uScale * uBase;
        this._cachedVScale = this.vScale;
        this._cachedUAng = this.uAng;
        this._cachedVAng = this.vAng;
        this._cachedWAng = this.wAng;
        this._cachedURotationCenter = this.uRotationCenter;
        this._cachedVRotationCenter = this.vRotationCenter;
        this._cachedWRotationCenter = this.wRotationCenter;
        this._cachedHomogeneousRotationInUVTransform = this.homogeneousRotationInUVTransform;
        if (!this._cachedTextureMatrix || !this._rowGenerationMatrix) {
            this._cachedTextureMatrix = (0, $ha1VO.Matrix).Zero();
            this._rowGenerationMatrix = new (0, $ha1VO.Matrix)();
            this._t0 = (0, $ha1VO.Vector3).Zero();
            this._t1 = (0, $ha1VO.Vector3).Zero();
            this._t2 = (0, $ha1VO.Vector3).Zero();
        }
        (0, $ha1VO.Matrix).RotationYawPitchRollToRef(this.vAng, this.uAng, this.wAng, this._rowGenerationMatrix);
        if (this.homogeneousRotationInUVTransform) {
            (0, $ha1VO.Matrix).TranslationToRef(-this._cachedURotationCenter, -this._cachedVRotationCenter, -this._cachedWRotationCenter, (0, $ha1VO.TmpVectors).Matrix[0]);
            (0, $ha1VO.Matrix).TranslationToRef(this._cachedURotationCenter, this._cachedVRotationCenter, this._cachedWRotationCenter, (0, $ha1VO.TmpVectors).Matrix[1]);
            (0, $ha1VO.Matrix).ScalingToRef(this._cachedUScale, this._cachedVScale, 0, (0, $ha1VO.TmpVectors).Matrix[2]);
            (0, $ha1VO.Matrix).TranslationToRef(this._cachedUOffset, this._cachedVOffset, 0, (0, $ha1VO.TmpVectors).Matrix[3]);
            (0, $ha1VO.TmpVectors).Matrix[0].multiplyToRef(this._rowGenerationMatrix, this._cachedTextureMatrix);
            this._cachedTextureMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[1], this._cachedTextureMatrix);
            this._cachedTextureMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[2], this._cachedTextureMatrix);
            this._cachedTextureMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[3], this._cachedTextureMatrix);
            // copy the translation row to the 3rd row of the matrix so that we don't need to update the shaders (which expects the translation to be on the 3rd row)
            this._cachedTextureMatrix.setRowFromFloats(2, this._cachedTextureMatrix.m[12], this._cachedTextureMatrix.m[13], this._cachedTextureMatrix.m[14], 1);
        } else {
            this._prepareRowForTextureGeneration(0, 0, 0, this._t0);
            this._prepareRowForTextureGeneration(1.0, 0, 0, this._t1);
            this._prepareRowForTextureGeneration(0, 1.0, 0, this._t2);
            this._t1.subtractInPlace(this._t0);
            this._t2.subtractInPlace(this._t0);
            (0, $ha1VO.Matrix).FromValuesToRef(this._t1.x, this._t1.y, this._t1.z, 0.0, this._t2.x, this._t2.y, this._t2.z, 0.0, this._t0.x, this._t0.y, this._t0.z, 0.0, 0.0, 0.0, 0.0, 1.0, this._cachedTextureMatrix);
        }
        const scene = this.getScene();
        if (!scene) return this._cachedTextureMatrix;
        const previousIdentity3x2 = this._cachedIdentity3x2;
        this._cachedIdentity3x2 = this._cachedTextureMatrix.isIdentityAs3x2();
        if (this.optimizeUVAllocation && previousIdentity3x2 !== this._cachedIdentity3x2) // We flag the materials that are using this texture as "texture dirty" because depending on the fact that the matrix is the identity or not, some defines
        // will get different values (see PrepareDefinesForMergedUV), meaning we should regenerate the effect accordingly
        scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
        return this._cachedTextureMatrix;
    }
    /**
     * Get the current matrix used to apply reflection. This is useful to rotate an environment texture for instance.
     * @returns The reflection texture transform
     */ getReflectionTextureMatrix() {
        const scene = this.getScene();
        if (!scene) return this._cachedReflectionTextureMatrix;
        if (this.uOffset === this._cachedReflectionUOffset && this.vOffset === this._cachedReflectionVOffset && this.uScale === this._cachedReflectionUScale && this.vScale === this._cachedReflectionVScale && this.coordinatesMode === this._cachedReflectionCoordinatesMode) {
            if (this.coordinatesMode === $ddc00207ac4a8ab4$export$5431306cf43de24a.PROJECTION_MODE) {
                if (this._cachedReflectionProjectionMatrixId === scene.getProjectionMatrix().updateFlag) return this._cachedReflectionTextureMatrix;
            } else return this._cachedReflectionTextureMatrix;
        }
        if (!this._cachedReflectionTextureMatrix) this._cachedReflectionTextureMatrix = (0, $ha1VO.Matrix).Zero();
        if (!this._projectionModeMatrix) this._projectionModeMatrix = (0, $ha1VO.Matrix).Zero();
        const flagMaterialsAsTextureDirty = this._cachedReflectionCoordinatesMode !== this.coordinatesMode;
        this._cachedReflectionUOffset = this.uOffset;
        this._cachedReflectionVOffset = this.vOffset;
        this._cachedReflectionUScale = this.uScale;
        this._cachedReflectionVScale = this.vScale;
        this._cachedReflectionCoordinatesMode = this.coordinatesMode;
        switch(this.coordinatesMode){
            case $ddc00207ac4a8ab4$export$5431306cf43de24a.PLANAR_MODE:
                (0, $ha1VO.Matrix).IdentityToRef(this._cachedReflectionTextureMatrix);
                this._cachedReflectionTextureMatrix[0] = this.uScale;
                this._cachedReflectionTextureMatrix[5] = this.vScale;
                this._cachedReflectionTextureMatrix[12] = this.uOffset;
                this._cachedReflectionTextureMatrix[13] = this.vOffset;
                break;
            case $ddc00207ac4a8ab4$export$5431306cf43de24a.PROJECTION_MODE:
                {
                    (0, $ha1VO.Matrix).FromValuesToRef(0.5, 0.0, 0.0, 0.0, 0.0, -0.5, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.5, 0.5, 1.0, 1.0, this._projectionModeMatrix);
                    const projectionMatrix = scene.getProjectionMatrix();
                    this._cachedReflectionProjectionMatrixId = projectionMatrix.updateFlag;
                    projectionMatrix.multiplyToRef(this._projectionModeMatrix, this._cachedReflectionTextureMatrix);
                    break;
                }
            default:
                (0, $ha1VO.Matrix).IdentityToRef(this._cachedReflectionTextureMatrix);
                break;
        }
        if (flagMaterialsAsTextureDirty) // We flag the materials that are using this texture as "texture dirty" if the coordinatesMode has changed.
        // Indeed, this property is used to set the value of some defines used to generate the effect (in material.isReadyForSubMesh), so we must make sure this code will be re-executed and the effect recreated if necessary
        scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
        return this._cachedReflectionTextureMatrix;
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        const options = {
            noMipmap: this._noMipmap,
            invertY: this._invertY,
            samplingMode: this.samplingMode,
            onLoad: undefined,
            onError: undefined,
            buffer: this._texture ? this._texture._buffer : undefined,
            deleteBuffer: this._deleteBuffer,
            format: this.textureFormat,
            mimeType: this.mimeType,
            loaderOptions: this._loaderOptions,
            creationFlags: this._creationFlags,
            useSRGBBuffer: this._useSRGBBuffer
        };
        return (0, $6Ho1L.SerializationHelper).Clone(()=>{
            return new $ddc00207ac4a8ab4$export$5431306cf43de24a(this._texture ? this._texture.url : null, this.getScene(), options);
        }, this);
    }
    /**
     * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
     * @returns The JSON representation of the texture
     */ serialize() {
        const savedName = this.name;
        if (!$ddc00207ac4a8ab4$export$5431306cf43de24a.SerializeBuffers) {
            if (this.name.startsWith("data:")) this.name = "";
        }
        if (this.name.startsWith("data:") && this.url === this.name) this.url = "";
        const serializationObject = super.serialize($ddc00207ac4a8ab4$export$5431306cf43de24a._SerializeInternalTextureUniqueId);
        if (!serializationObject) return null;
        if ($ddc00207ac4a8ab4$export$5431306cf43de24a.SerializeBuffers || $ddc00207ac4a8ab4$export$5431306cf43de24a.ForceSerializeBuffers) {
            if (typeof this._buffer === "string" && this._buffer.substring(0, 5) === "data:") {
                serializationObject.base64String = this._buffer;
                serializationObject.name = serializationObject.name.replace("data:", "");
            } else if (this.url && this.url.startsWith("data:") && this._buffer instanceof Uint8Array) serializationObject.base64String = "data:image/png;base64," + (0, $eLv1o.EncodeArrayBufferToBase64)(this._buffer);
            else if ($ddc00207ac4a8ab4$export$5431306cf43de24a.ForceSerializeBuffers || this.url && this.url.startsWith("blob:") || this._forceSerialize) serializationObject.base64String = !this._engine || this._engine._features.supportSyncTextureRead ? (0, $f2kkL.GenerateBase64StringFromTexture)(this) : (0, $f2kkL.GenerateBase64StringFromTextureAsync)(this);
        }
        serializationObject.invertY = this._invertY;
        serializationObject.samplingMode = this.samplingMode;
        serializationObject._creationFlags = this._creationFlags;
        serializationObject._useSRGBBuffer = this._useSRGBBuffer;
        if ($ddc00207ac4a8ab4$export$5431306cf43de24a._SerializeInternalTextureUniqueId) serializationObject.internalTextureUniqueId = this._texture?.uniqueId;
        serializationObject.internalTextureLabel = this._texture?.label;
        serializationObject.noMipmap = this._noMipmap;
        this.name = savedName;
        return serializationObject;
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "Texture"
     */ getClassName() {
        return "Texture";
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        super.dispose();
        this.onLoadObservable.clear();
        this._delayedOnLoad = null;
        this._delayedOnError = null;
        this._buffer = null;
    }
    /**
     * Parse the JSON representation of a texture in order to recreate the texture in the given scene.
     * @param parsedTexture Define the JSON representation of the texture
     * @param scene Define the scene the parsed texture should be instantiated in
     * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
     * @returns The parsed texture if successful
     */ static Parse(parsedTexture, scene, rootUrl) {
        if (parsedTexture.customType) {
            const customTexture = (0, $i1moY.InstantiationTools).Instantiate(parsedTexture.customType);
            // Update Sampling Mode
            const parsedCustomTexture = customTexture.Parse(parsedTexture, scene, rootUrl);
            if (parsedTexture.samplingMode && parsedCustomTexture.updateSamplingMode && parsedCustomTexture._samplingMode) {
                if (parsedCustomTexture._samplingMode !== parsedTexture.samplingMode) parsedCustomTexture.updateSamplingMode(parsedTexture.samplingMode);
            }
            return parsedCustomTexture;
        }
        if (parsedTexture.isCube && !parsedTexture.isRenderTarget) return $ddc00207ac4a8ab4$export$5431306cf43de24a._CubeTextureParser(parsedTexture, scene, rootUrl);
        const hasInternalTextureUniqueId = parsedTexture.internalTextureUniqueId !== undefined;
        if (!parsedTexture.name && !parsedTexture.isRenderTarget && !hasInternalTextureUniqueId) return null;
        let internalTexture;
        if (hasInternalTextureUniqueId) {
            const cache = scene.getEngine().getLoadedTexturesCache();
            for (const texture of cache)if (texture.uniqueId === parsedTexture.internalTextureUniqueId) {
                internalTexture = texture;
                break;
            }
        }
        const onLoaded = (texture)=>{
            // Clear cache
            if (texture && texture._texture) {
                texture._texture._cachedWrapU = null;
                texture._texture._cachedWrapV = null;
                texture._texture._cachedWrapR = null;
            }
            // Update Sampling Mode
            if (parsedTexture.samplingMode) {
                const sampling = parsedTexture.samplingMode;
                if (texture && texture.samplingMode !== sampling) texture.updateSamplingMode(sampling);
            }
            // Animations
            if (texture && parsedTexture.animations) for(let animationIndex = 0; animationIndex < parsedTexture.animations.length; animationIndex++){
                const parsedAnimation = parsedTexture.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) texture.animations.push(internalClass.Parse(parsedAnimation));
            }
            if (texture && texture._texture) {
                if (hasInternalTextureUniqueId && !internalTexture) texture._texture._setUniqueId(parsedTexture.internalTextureUniqueId);
                texture._texture.label = parsedTexture.internalTextureLabel;
            }
        };
        const texture = (0, $6Ho1L.SerializationHelper).Parse(()=>{
            let generateMipMaps = true;
            if (parsedTexture.noMipmap) generateMipMaps = false;
            if (parsedTexture.mirrorPlane) {
                const mirrorTexture = $ddc00207ac4a8ab4$export$5431306cf43de24a._CreateMirror(parsedTexture.name, parsedTexture.renderTargetSize, scene, generateMipMaps);
                mirrorTexture._waitingRenderList = parsedTexture.renderList;
                mirrorTexture.mirrorPlane = (0, $23POp.Plane).FromArray(parsedTexture.mirrorPlane);
                onLoaded(mirrorTexture);
                return mirrorTexture;
            } else if (parsedTexture.isRenderTarget) {
                let renderTargetTexture = null;
                if (parsedTexture.isCube) {
                    // Search for an existing reflection probe (which contains a cube render target texture)
                    if (scene.reflectionProbes) for(let index = 0; index < scene.reflectionProbes.length; index++){
                        const probe = scene.reflectionProbes[index];
                        if (probe.name === parsedTexture.name) return probe.cubeTexture;
                    }
                } else {
                    renderTargetTexture = $ddc00207ac4a8ab4$export$5431306cf43de24a._CreateRenderTargetTexture(parsedTexture.name, parsedTexture.renderTargetSize, scene, generateMipMaps, parsedTexture._creationFlags ?? 0);
                    renderTargetTexture._waitingRenderList = parsedTexture.renderList;
                }
                onLoaded(renderTargetTexture);
                return renderTargetTexture;
            } else if (parsedTexture.isVideo) {
                const texture = $ddc00207ac4a8ab4$export$5431306cf43de24a._CreateVideoTexture(rootUrl + (parsedTexture.url || parsedTexture.name), rootUrl + (parsedTexture.src || parsedTexture.url), scene, generateMipMaps, parsedTexture.invertY, parsedTexture.samplingMode, parsedTexture.settings || {});
                onLoaded(texture);
                return texture;
            } else {
                let texture;
                if (parsedTexture.base64String && !internalTexture) {
                    // name and url are the same to ensure caching happens from the actual base64 string
                    texture = $ddc00207ac4a8ab4$export$5431306cf43de24a.CreateFromBase64String(parsedTexture.base64String, parsedTexture.base64String, scene, !generateMipMaps, parsedTexture.invertY, parsedTexture.samplingMode, ()=>{
                        onLoaded(texture);
                    }, parsedTexture._creationFlags ?? 0, parsedTexture._useSRGBBuffer ?? false);
                    // prettier name to fit with the loaded data
                    texture.name = parsedTexture.name;
                } else {
                    let url;
                    if (parsedTexture.name && (parsedTexture.name.indexOf("://") > 0 || parsedTexture.name.startsWith("data:"))) url = parsedTexture.name;
                    else url = rootUrl + parsedTexture.name;
                    if (parsedTexture.url && (parsedTexture.url.startsWith("data:") || $ddc00207ac4a8ab4$export$5431306cf43de24a.UseSerializedUrlIfAny)) url = parsedTexture.url;
                    const options = {
                        noMipmap: !generateMipMaps,
                        invertY: parsedTexture.invertY,
                        samplingMode: parsedTexture.samplingMode,
                        onLoad: ()=>{
                            onLoaded(texture);
                        },
                        internalTexture: internalTexture
                    };
                    texture = new $ddc00207ac4a8ab4$export$5431306cf43de24a(url, scene, options);
                }
                return texture;
            }
        }, parsedTexture, scene);
        return texture;
    }
    /**
     * Creates a texture from its base 64 representation.
     * @param data Define the base64 payload without the data: prefix
     * @param name Define the name of the texture in the scene useful fo caching purpose for instance
     * @param scene Define the scene the texture should belong to
     * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
     * @param invertY define if the texture needs to be inverted on the y axis during loading
     * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
     * @param onLoad define a callback triggered when the texture has been loaded
     * @param onError define a callback triggered when an error occurred during the loading session
     * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param forcedExtension defines the extension to use to pick the right loader
     * @returns the created texture
     */ static CreateFromBase64String(data, name, scene, noMipmapOrOptions, invertY, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, format = 5, creationFlags, forcedExtension) {
        return new $ddc00207ac4a8ab4$export$5431306cf43de24a("data:" + name, scene, noMipmapOrOptions, invertY, samplingMode, onLoad, onError, data, false, format, undefined, undefined, creationFlags, forcedExtension);
    }
    /**
     * Creates a texture from its data: representation. (data: will be added in case only the payload has been passed in)
     * @param name Define the name of the texture in the scene useful fo caching purpose for instance
     * @param buffer define the buffer to load the texture from in case the texture is loaded from a buffer representation
     * @param scene Define the scene the texture should belong to
     * @param deleteBuffer define if the buffer we are loading the texture from should be deleted after load
     * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
     * @param invertY define if the texture needs to be inverted on the y axis during loading
     * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
     * @param onLoad define a callback triggered when the texture has been loaded
     * @param onError define a callback triggered when an error occurred during the loading session
     * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param forcedExtension defines the extension to use to pick the right loader
     * @returns the created texture
     */ static LoadFromDataString(name, buffer, scene, deleteBuffer = false, noMipmapOrOptions, invertY = true, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, format = 5, creationFlags, forcedExtension) {
        if (name.substring(0, 5) !== "data:") name = "data:" + name;
        return new $ddc00207ac4a8ab4$export$5431306cf43de24a(name, scene, noMipmapOrOptions, invertY, samplingMode, onLoad, onError, buffer, deleteBuffer, format, undefined, undefined, creationFlags, forcedExtension);
    }
}
/**
 * Gets or sets a general boolean used to indicate that textures containing direct data (buffers) must be saved as part of the serialization process
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.SerializeBuffers = true;
/**
 * Gets or sets a general boolean used to indicate that texture buffers must be saved as part of the serialization process.
 * If no buffer exists, one will be created as base64 string from the internal webgl data.
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.ForceSerializeBuffers = false;
/**
 * This observable will notify when any texture had a loading error
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.OnTextureLoadErrorObservable = new (0, $diGQf.Observable)();
/** @internal */ $ddc00207ac4a8ab4$export$5431306cf43de24a._SerializeInternalTextureUniqueId = false;
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$ddc00207ac4a8ab4$export$5431306cf43de24a._CubeTextureParser = (jsonTexture, scene, rootUrl)=>{
    throw (0, $dUFYy._WarnImport)("CubeTexture");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$ddc00207ac4a8ab4$export$5431306cf43de24a._CreateMirror = (name, renderTargetSize, scene, generateMipMaps)=>{
    throw (0, $dUFYy._WarnImport)("MirrorTexture");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$ddc00207ac4a8ab4$export$5431306cf43de24a._CreateRenderTargetTexture = (name, renderTargetSize, scene, generateMipMaps, creationFlags)=>{
    throw (0, $dUFYy._WarnImport)("RenderTargetTexture");
};
/** nearest is mag = nearest and min = nearest and no mip */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_SAMPLINGMODE = 1;
/** nearest is mag = nearest and min = nearest and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_NEAREST_MIPLINEAR = 8; // nearest is mag = nearest and min = nearest and mip = linear
/** Bilinear is mag = linear and min = linear and no mip */ $ddc00207ac4a8ab4$export$5431306cf43de24a.BILINEAR_SAMPLINGMODE = 2;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_LINEAR_MIPNEAREST = 11; // Bilinear is mag = linear and min = linear and mip = nearest
/** Trilinear is mag = linear and min = linear and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE = 3;
/** Trilinear is mag = linear and min = linear and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_LINEAR_MIPLINEAR = 3; // Trilinear is mag = linear and min = linear and mip = linear
/** mag = nearest and min = nearest and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_NEAREST_MIPNEAREST = 4;
/** mag = nearest and min = linear and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_LINEAR_MIPNEAREST = 5;
/** mag = nearest and min = linear and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_LINEAR_MIPLINEAR = 6;
/** mag = nearest and min = linear and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_LINEAR = 7;
/** mag = nearest and min = nearest and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_NEAREST = 1;
/** mag = linear and min = nearest and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_NEAREST_MIPNEAREST = 9;
/** mag = linear and min = nearest and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_NEAREST_MIPLINEAR = 10;
/** mag = linear and min = linear and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_LINEAR = 2;
/** mag = linear and min = nearest and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_NEAREST = 12;
/** Explicit coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.EXPLICIT_MODE = 0;
/** Spherical coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.SPHERICAL_MODE = 1;
/** Planar coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.PLANAR_MODE = 2;
/** Cubic coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.CUBIC_MODE = 3;
/** Projection coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.PROJECTION_MODE = 4;
/** Inverse Cubic coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.SKYBOX_MODE = 5;
/** Inverse Cubic coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.INVCUBIC_MODE = 6;
/** Equirectangular coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.EQUIRECTANGULAR_MODE = 7;
/** Equirectangular Fixed coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.FIXED_EQUIRECTANGULAR_MODE = 8;
/** Equirectangular Fixed Mirrored coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
/** Texture is not repeating outside of 0..1 UVs */ $ddc00207ac4a8ab4$export$5431306cf43de24a.CLAMP_ADDRESSMODE = 0;
/** Texture is repeating outside of 0..1 UVs */ $ddc00207ac4a8ab4$export$5431306cf43de24a.WRAP_ADDRESSMODE = 1;
/** Texture is repeating and mirrored */ $ddc00207ac4a8ab4$export$5431306cf43de24a.MIRROR_ADDRESSMODE = 2;
/**
 * Gets or sets a boolean which defines if the texture url must be build from the serialized URL instead of just using the name and loading them side by side with the scene file
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.UseSerializedUrlIfAny = false;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "url", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uAng", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vAng", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "wAng", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uRotationCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vRotationCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "wRotationCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "homogeneousRotationInUVTransform", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "isBlocking", null);
// References the dependencies.
(0, $8DoUR.RegisterClass)("BABYLON.Texture", $ddc00207ac4a8ab4$export$5431306cf43de24a);
(0, $6Ho1L.SerializationHelper)._TextureParser = $ddc00207ac4a8ab4$export$5431306cf43de24a.Parse;

});
parcelRegister("akOl3", function(module, exports) {

$parcel$export(module.exports, "BaseTexture", () => $7862d1d2c5fb3cf3$export$d6306e508f184154);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $ejQPp = parcelRequire("ejQPp");

var $321Uk = parcelRequire("321Uk");
parcelRequire("EOxw7");

var $jyMMC = parcelRequire("jyMMC");

var $6Ho1L = parcelRequire("6Ho1L");
class $7862d1d2c5fb3cf3$export$d6306e508f184154 extends (0, $jyMMC.ThinTexture) {
    /**
     * Define if the texture is having a usable alpha value (can be use for transparency or glossiness for instance).
     */ set hasAlpha(value) {
        if (this._hasAlpha === value) return;
        this._hasAlpha = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get hasAlpha() {
        return this._hasAlpha;
    }
    /**
     * Defines if the alpha value should be determined via the rgb values.
     * If true the luminance of the pixel might be used to find the corresponding alpha value.
     */ set getAlphaFromRGB(value) {
        if (this._getAlphaFromRGB === value) return;
        this._getAlphaFromRGB = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get getAlphaFromRGB() {
        return this._getAlphaFromRGB;
    }
    /**
     * Define the UV channel to use starting from 0 and defaulting to 0.
     * This is part of the texture as textures usually maps to one uv set.
     */ set coordinatesIndex(value) {
        if (this._coordinatesIndex === value) return;
        this._coordinatesIndex = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get coordinatesIndex() {
        return this._coordinatesIndex;
    }
    /**
     * How a texture is mapped.
     *
     * | Value | Type                                | Description |
     * | ----- | ----------------------------------- | ----------- |
     * | 0     | EXPLICIT_MODE                       |             |
     * | 1     | SPHERICAL_MODE                      |             |
     * | 2     | PLANAR_MODE                         |             |
     * | 3     | CUBIC_MODE                          |             |
     * | 4     | PROJECTION_MODE                     |             |
     * | 5     | SKYBOX_MODE                         |             |
     * | 6     | INVCUBIC_MODE                       |             |
     * | 7     | EQUIRECTANGULAR_MODE                |             |
     * | 8     | FIXED_EQUIRECTANGULAR_MODE          |             |
     * | 9     | FIXED_EQUIRECTANGULAR_MIRRORED_MODE |             |
     */ set coordinatesMode(value) {
        if (this._coordinatesMode === value) return;
        this._coordinatesMode = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get coordinatesMode() {
        return this._coordinatesMode;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapU() {
        return this._wrapU;
    }
    set wrapU(value) {
        this._wrapU = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapV() {
        return this._wrapV;
    }
    set wrapV(value) {
        this._wrapV = value;
    }
    /**
     * Define if the texture is a cube texture or if false a 2d texture.
     */ get isCube() {
        if (!this._texture) return this._isCube;
        return this._texture.isCube;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set isCube(value) {
        if (!this._texture) this._isCube = value;
        else this._texture.isCube = value;
    }
    /**
     * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
     */ get is3D() {
        if (!this._texture) return false;
        return this._texture.is3D;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is3D(value) {
        if (!this._texture) return;
        this._texture.is3D = value;
    }
    /**
     * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
     */ get is2DArray() {
        if (!this._texture) return false;
        return this._texture.is2DArray;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is2DArray(value) {
        if (!this._texture) return;
        this._texture.is2DArray = value;
    }
    /**
     * Define if the texture contains data in gamma space (most of the png/jpg aside bump).
     * HDR texture are usually stored in linear space.
     * This only impacts the PBR and Background materials
     */ get gammaSpace() {
        if (!this._texture) return this._gammaSpace;
        else if (this._texture._gammaSpace === null) this._texture._gammaSpace = this._gammaSpace;
        return this._texture._gammaSpace && !this._texture._useSRGBBuffer;
    }
    set gammaSpace(gamma) {
        if (!this._texture) {
            if (this._gammaSpace === gamma) return;
            this._gammaSpace = gamma;
        } else {
            if (this._texture._gammaSpace === gamma) return;
            this._texture._gammaSpace = gamma;
        }
        this.getScene()?.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    /**
     * Gets or sets whether or not the texture contains RGBD data.
     */ get isRGBD() {
        return this._texture != null && this._texture._isRGBD;
    }
    set isRGBD(value) {
        if (value === this.isRGBD) return;
        if (this._texture) this._texture._isRGBD = value;
        this.getScene()?.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    /**
     * Are mip maps generated for this texture or not.
     */ get noMipmap() {
        return false;
    }
    /**
     * With prefiltered texture, defined the offset used during the prefiltering steps.
     */ get lodGenerationOffset() {
        if (this._texture) return this._texture._lodGenerationOffset;
        return 0.0;
    }
    set lodGenerationOffset(value) {
        if (this._texture) this._texture._lodGenerationOffset = value;
    }
    /**
     * With prefiltered texture, defined the scale used during the prefiltering steps.
     */ get lodGenerationScale() {
        if (this._texture) return this._texture._lodGenerationScale;
        return 0.0;
    }
    set lodGenerationScale(value) {
        if (this._texture) this._texture._lodGenerationScale = value;
    }
    /**
     * With prefiltered texture, defined if the specular generation is based on a linear ramp.
     * By default we are using a log2 of the linear roughness helping to keep a better resolution for
     * average roughness values.
     */ get linearSpecularLOD() {
        if (this._texture) return this._texture._linearSpecularLOD;
        return false;
    }
    set linearSpecularLOD(value) {
        if (this._texture) this._texture._linearSpecularLOD = value;
    }
    /**
     * In case a better definition than spherical harmonics is required for the diffuse part of the environment.
     * You can set the irradiance texture to rely on a texture instead of the spherical approach.
     * This texture need to have the same characteristics than its parent (Cube vs 2d, coordinates mode, Gamma/Linear, RGBD).
     */ get irradianceTexture() {
        if (this._texture) return this._texture._irradianceTexture;
        return null;
    }
    set irradianceTexture(value) {
        if (this._texture) this._texture._irradianceTexture = value;
    }
    /**
     * Define the unique id of the texture in the scene.
     */ get uid() {
        if (!this._uid) this._uid = (0, $321Uk.RandomGUID)();
        return this._uid;
    }
    /**
     * Return a string representation of the texture.
     * @returns the texture as a string
     */ toString() {
        return this.name;
    }
    /**
     * Get the class name of the texture.
     * @returns "BaseTexture"
     */ getClassName() {
        return "BaseTexture";
    }
    /**
     * Callback triggered when the texture has been disposed.
     * Kept for back compatibility, you can use the onDisposeObservable instead.
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * Define if the texture is preventing a material to render or not.
     * If not and the texture is not ready, the engine will use a default black texture instead.
     */ get isBlocking() {
        return true;
    }
    /**
     * Was there any loading error?
     */ get loadingError() {
        return this._loadingError;
    }
    /**
     * If a loading error occurred this object will be populated with information about the error.
     */ get errorObject() {
        return this._errorObject;
    }
    /**
     * Instantiates a new BaseTexture.
     * Base class of all the textures in babylon.
     * It groups all the common properties the materials, post process, lights... might need
     * in order to make a correct use of the texture.
     * @param sceneOrEngine Define the scene or engine the texture belongs to
     * @param internalTexture Define the internal texture associated with the texture
     */ constructor(sceneOrEngine, internalTexture = null){
        super(null);
        /**
         * Gets or sets an object used to store user defined information.
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        this._hasAlpha = false;
        this._getAlphaFromRGB = false;
        /**
         * Intensity or strength of the texture.
         * It is commonly used by materials to fine tune the intensity of the texture
         */ this.level = 1;
        this._coordinatesIndex = 0;
        /**
         * Gets or sets a boolean indicating that the texture should try to reduce shader code if there is no UV manipulation.
         * (ie. when texture.getTextureMatrix().isIdentityAs3x2() returns true)
         */ this.optimizeUVAllocation = true;
        this._coordinatesMode = 0;
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */ this.wrapR = 1;
        /**
         * With compliant hardware and browser (supporting anisotropic filtering)
         * this defines the level of anisotropic filtering in the texture.
         * The higher the better but the slower. This defaults to 4 as it seems to be the best tradeoff.
         */ this.anisotropicFilteringLevel = $7862d1d2c5fb3cf3$export$d6306e508f184154.DEFAULT_ANISOTROPIC_FILTERING_LEVEL;
        /** @internal */ this._isCube = false;
        /** @internal */ this._gammaSpace = true;
        /**
         * Is Z inverted in the texture (useful in a cube texture).
         */ this.invertZ = false;
        /**
         * @internal
         */ this.lodLevelInAlpha = false;
        /**
         * Define if the texture is a render target.
         */ this.isRenderTarget = false;
        /** @internal */ this._prefiltered = false;
        /** @internal */ this._forceSerialize = false;
        /**
         * Define the list of animation attached to the texture.
         */ this.animations = [];
        /**
         * An event triggered when the texture is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onDisposeObserver = null;
        this._scene = null;
        /** @internal */ this._uid = null;
        /** @internal */ this._parentContainer = null;
        this._loadingError = false;
        if (sceneOrEngine) {
            if ($7862d1d2c5fb3cf3$export$d6306e508f184154._IsScene(sceneOrEngine)) this._scene = sceneOrEngine;
            else this._engine = sceneOrEngine;
        } else this._scene = (0, $ejQPp.EngineStore).LastCreatedScene;
        if (this._scene) {
            this.uniqueId = this._scene.getUniqueId();
            this._scene.addTexture(this);
            this._engine = this._scene.getEngine();
        }
        this._texture = internalTexture;
        this._uid = null;
    }
    /**
     * Get the scene the texture belongs to.
     * @returns the scene or null if undefined
     */ getScene() {
        return this._scene;
    }
    /** @internal */ _getEngine() {
        return this._engine;
    }
    /**
     * Get the texture transform matrix used to offset tile the texture for instance.
     * @returns the transformation matrix
     */ getTextureMatrix() {
        return (0, $ha1VO.Matrix).IdentityReadOnly;
    }
    /**
     * Get the texture reflection matrix used to rotate/transform the reflection.
     * @returns the reflection matrix
     */ getReflectionTextureMatrix() {
        return (0, $ha1VO.Matrix).IdentityReadOnly;
    }
    /**
     * Gets a suitable rotate/transform matrix when the texture is used for refraction.
     * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
     * @returns The refraction matrix
     */ getRefractionTextureMatrix() {
        return this.getReflectionTextureMatrix();
    }
    /**
     * Get if the texture is ready to be consumed (either it is ready or it is not blocking)
     * @returns true if ready, not blocking or if there was an error loading the texture
     */ isReadyOrNotBlocking() {
        return !this.isBlocking || this.isReady() || this.loadingError;
    }
    /**
     * Scales the texture if is `canRescale()`
     * @param ratio the resize factor we want to use to rescale
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scale(ratio) {}
    /**
     * Get if the texture can rescale.
     */ get canRescale() {
        return false;
    }
    /**
     * @internal
     */ _getFromCache(url, noMipmap, sampling, invertY, useSRGBBuffer, isCube) {
        const engine = this._getEngine();
        if (!engine) return null;
        const correctedUseSRGBBuffer = engine._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
        const texturesCache = engine.getLoadedTexturesCache();
        for(let index = 0; index < texturesCache.length; index++){
            const texturesCacheEntry = texturesCache[index];
            if (useSRGBBuffer === undefined || correctedUseSRGBBuffer === texturesCacheEntry._useSRGBBuffer) {
                if (invertY === undefined || invertY === texturesCacheEntry.invertY) {
                    if (texturesCacheEntry.url === url && texturesCacheEntry.generateMipMaps === !noMipmap) {
                        if (!sampling || sampling === texturesCacheEntry.samplingMode) {
                            if (isCube === undefined || isCube === texturesCacheEntry.isCube) {
                                texturesCacheEntry.incrementReferences();
                                return texturesCacheEntry;
                            }
                        }
                    }
                }
            }
        }
        return null;
    }
    /** @internal */ _rebuild(_fromContextLost = false) {}
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        return null;
    }
    /**
     * Get the texture underlying type (INT, FLOAT...)
     */ get textureType() {
        if (!this._texture) return 0;
        return this._texture.type !== undefined ? this._texture.type : 0;
    }
    /**
     * Get the texture underlying format (RGB, RGBA...)
     */ get textureFormat() {
        if (!this._texture) return 5;
        return this._texture.format !== undefined ? this._texture.format : 5;
    }
    /**
     * Indicates that textures need to be re-calculated for all materials
     */ _markAllSubMeshesAsTexturesDirty() {
        const scene = this.getScene();
        if (!scene) return;
        scene.markAllMaterialsAsDirty(1);
    }
    /**
     * Reads the pixels stored in the webgl texture and returns them as an ArrayBuffer.
     * This will returns an RGBA array buffer containing either in values (0-255) or
     * float values (0-1) depending of the underlying buffer type.
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @param buffer defines a user defined buffer to fill with data (can be null)
     * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
     * @param noDataConversion false to convert the data to Uint8Array (if texture type is UNSIGNED_BYTE) or to Float32Array (if texture type is anything but UNSIGNED_BYTE). If true, the type of the generated buffer (if buffer==null) will depend on the type of the texture
     * @param x defines the region x coordinates to start reading from (default to 0)
     * @param y defines the region y coordinates to start reading from (default to 0)
     * @param width defines the region width to read from (default to the texture size at level)
     * @param height defines the region width to read from (default to the texture size at level)
     * @returns The Array buffer promise containing the pixels data.
     */ readPixels(faceIndex = 0, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0, width = Number.MAX_VALUE, height = Number.MAX_VALUE) {
        if (!this._texture) return null;
        const engine = this._getEngine();
        if (!engine) return null;
        const size = this.getSize();
        let maxWidth = size.width;
        let maxHeight = size.height;
        if (level !== 0) {
            maxWidth = maxWidth / Math.pow(2, level);
            maxHeight = maxHeight / Math.pow(2, level);
            maxWidth = Math.round(maxWidth);
            maxHeight = Math.round(maxHeight);
        }
        width = Math.min(maxWidth, width);
        height = Math.min(maxHeight, height);
        try {
            if (this._texture.isCube) return engine._readTexturePixels(this._texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion, x, y);
            return engine._readTexturePixels(this._texture, width, height, -1, level, buffer, flushRenderer, noDataConversion, x, y);
        } catch (e) {
            return null;
        }
    }
    /**
     * @internal
     */ _readPixelsSync(faceIndex = 0, level = 0, buffer = null, flushRenderer = true, noDataConversion = false) {
        if (!this._texture) return null;
        const size = this.getSize();
        let width = size.width;
        let height = size.height;
        const engine = this._getEngine();
        if (!engine) return null;
        if (level != 0) {
            width = width / Math.pow(2, level);
            height = height / Math.pow(2, level);
            width = Math.round(width);
            height = Math.round(height);
        }
        try {
            if (this._texture.isCube) return engine._readTexturePixelsSync(this._texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion);
            return engine._readTexturePixelsSync(this._texture, width, height, -1, level, buffer, flushRenderer, noDataConversion);
        } catch (e) {
            return null;
        }
    }
    /** @internal */ get _lodTextureHigh() {
        if (this._texture) return this._texture._lodTextureHigh;
        return null;
    }
    /** @internal */ get _lodTextureMid() {
        if (this._texture) return this._texture._lodTextureMid;
        return null;
    }
    /** @internal */ get _lodTextureLow() {
        if (this._texture) return this._texture._lodTextureLow;
        return null;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        if (this._scene) {
            // Animations
            if (this._scene.stopAnimation) this._scene.stopAnimation(this);
            // Remove from scene
            this._scene.removePendingData(this);
            const index = this._scene.textures.indexOf(this);
            if (index >= 0) this._scene.textures.splice(index, 1);
            this._scene.onTextureRemovedObservable.notifyObservers(this);
            this._scene = null;
            if (this._parentContainer) {
                const index = this._parentContainer.textures.indexOf(this);
                if (index > -1) this._parentContainer.textures.splice(index, 1);
                this._parentContainer = null;
            }
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.metadata = null;
        super.dispose();
    }
    /**
     * Serialize the texture into a JSON representation that can be parsed later on.
     * @param allowEmptyName True to force serialization even if name is empty. Default: false
     * @returns the JSON representation of the texture
     */ serialize(allowEmptyName = false) {
        if (!this.name && !allowEmptyName) return null;
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        return serializationObject;
    }
    /**
     * Helper function to be called back once a list of texture contains only ready textures.
     * @param textures Define the list of textures to wait for
     * @param callback Define the callback triggered once the entire list will be ready
     */ static WhenAllReady(textures, callback) {
        let numRemaining = textures.length;
        if (numRemaining === 0) {
            callback();
            return;
        }
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (texture.isReady()) {
                if (--numRemaining === 0) callback();
            } else {
                const onLoadObservable = texture.onLoadObservable;
                if (onLoadObservable) onLoadObservable.addOnce(()=>{
                    if (--numRemaining === 0) callback();
                });
                else if (--numRemaining === 0) callback();
            }
        }
    }
    static _IsScene(sceneOrEngine) {
        return sceneOrEngine.getClassName() === "Scene";
    }
}
/**
 * Default anisotropic filtering level for the application.
 * It is set to 4 as a good tradeoff between perf and quality.
 */ $7862d1d2c5fb3cf3$export$d6306e508f184154.DEFAULT_ANISOTROPIC_FILTERING_LEVEL = 4;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "displayName", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "metadata", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("hasAlpha")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_hasAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("getAlphaFromRGB")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_getAlphaFromRGB", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "level", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("coordinatesIndex")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_coordinatesIndex", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "optimizeUVAllocation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("coordinatesMode")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_coordinatesMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "wrapU", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "wrapV", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "wrapR", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "anisotropicFilteringLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "isCube", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "is3D", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "is2DArray", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "gammaSpace", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "invertZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "lodLevelInAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "lodGenerationOffset", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "lodGenerationScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "linearSpecularLOD", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "irradianceTexture", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "isRenderTarget", void 0);

});
parcelRegister("jyMMC", function(module, exports) {

$parcel$export(module.exports, "ThinTexture", () => $e3d708a51bb30301$export$370601e15e8791a2);

var $93o7r = parcelRequire("93o7r");
class $e3d708a51bb30301$export$370601e15e8791a2 {
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapU() {
        return this._wrapU;
    }
    set wrapU(value) {
        this._wrapU = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapV() {
        return this._wrapV;
    }
    set wrapV(value) {
        this._wrapV = value;
    }
    /**
     * How a texture is mapped.
     * Unused in thin texture mode.
     */ get coordinatesMode() {
        return 0;
    }
    /**
     * Define if the texture is a cube texture or if false a 2d texture.
     */ get isCube() {
        if (!this._texture) return false;
        return this._texture.isCube;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set isCube(value) {
        if (!this._texture) return;
        this._texture.isCube = value;
    }
    /**
     * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
     */ get is3D() {
        if (!this._texture) return false;
        return this._texture.is3D;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is3D(value) {
        if (!this._texture) return;
        this._texture.is3D = value;
    }
    /**
     * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
     */ get is2DArray() {
        if (!this._texture) return false;
        return this._texture.is2DArray;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is2DArray(value) {
        if (!this._texture) return;
        this._texture.is2DArray = value;
    }
    /**
     * Get the class name of the texture.
     * @returns "ThinTexture"
     */ getClassName() {
        return "ThinTexture";
    }
    static _IsRenderTargetWrapper(texture) {
        return texture?.shareDepth !== undefined;
    }
    /**
     * Instantiates a new ThinTexture.
     * Base class of all the textures in babylon.
     * This can be used as an internal texture wrapper in AbstractEngine to benefit from the cache
     * @param internalTexture Define the internalTexture to wrap. You can also pass a RenderTargetWrapper, in which case the texture will be the render target's texture
     */ constructor(internalTexture){
        this._wrapU = 1;
        this._wrapV = 1;
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */ this.wrapR = 1;
        /**
         * With compliant hardware and browser (supporting anisotropic filtering)
         * this defines the level of anisotropic filtering in the texture.
         * The higher the better but the slower. This defaults to 4 as it seems to be the best tradeoff.
         */ this.anisotropicFilteringLevel = 4;
        /**
         * Define the current state of the loading sequence when in delayed load mode.
         */ this.delayLoadState = 0;
        /** @internal */ this._texture = null;
        this._engine = null;
        this._cachedSize = (0, $93o7r.Size).Zero();
        this._cachedBaseSize = (0, $93o7r.Size).Zero();
        /** @internal */ this._initialSamplingMode = 2;
        this._texture = $e3d708a51bb30301$export$370601e15e8791a2._IsRenderTargetWrapper(internalTexture) ? internalTexture.texture : internalTexture;
        if (this._texture) this._engine = this._texture.getEngine();
    }
    /**
     * Get if the texture is ready to be used (downloaded, converted, mip mapped...).
     * @returns true if fully ready
     */ isReady() {
        if (this.delayLoadState === 4) {
            this.delayLoad();
            return false;
        }
        if (this._texture) return this._texture.isReady;
        return false;
    }
    /**
     * Triggers the load sequence in delayed load mode.
     */ delayLoad() {}
    /**
     * Get the underlying lower level texture from Babylon.
     * @returns the internal texture
     */ getInternalTexture() {
        return this._texture;
    }
    /**
     * Get the size of the texture.
     * @returns the texture size.
     */ getSize() {
        if (this._texture) {
            if (this._texture.width) {
                this._cachedSize.width = this._texture.width;
                this._cachedSize.height = this._texture.height;
                return this._cachedSize;
            }
            if (this._texture._size) {
                this._cachedSize.width = this._texture._size;
                this._cachedSize.height = this._texture._size;
                return this._cachedSize;
            }
        }
        return this._cachedSize;
    }
    /**
     * Get the base size of the texture.
     * It can be different from the size if the texture has been resized for POT for instance
     * @returns the base size
     */ getBaseSize() {
        if (!this.isReady() || !this._texture) {
            this._cachedBaseSize.width = 0;
            this._cachedBaseSize.height = 0;
            return this._cachedBaseSize;
        }
        if (this._texture._size) {
            this._cachedBaseSize.width = this._texture._size;
            this._cachedBaseSize.height = this._texture._size;
            return this._cachedBaseSize;
        }
        this._cachedBaseSize.width = this._texture.baseWidth;
        this._cachedBaseSize.height = this._texture.baseHeight;
        return this._cachedBaseSize;
    }
    /**
     * Get the current sampling mode associated with the texture.
     */ get samplingMode() {
        if (!this._texture) return this._initialSamplingMode;
        return this._texture.samplingMode;
    }
    /**
     * Update the sampling mode of the texture.
     * Default is Trilinear mode.
     *
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 1     | NEAREST_SAMPLINGMODE or NEAREST_NEAREST_MIPLINEAR  | Nearest is: mag = nearest, min = nearest, mip = linear |
     * | 2     | BILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPNEAREST | Bilinear is: mag = linear, min = linear, mip = nearest |
     * | 3     | TRILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPLINEAR | Trilinear is: mag = linear, min = linear, mip = linear |
     * | 4     | NEAREST_NEAREST_MIPNEAREST |             |
     * | 5    | NEAREST_LINEAR_MIPNEAREST |             |
     * | 6    | NEAREST_LINEAR_MIPLINEAR |             |
     * | 7    | NEAREST_LINEAR |             |
     * | 8    | NEAREST_NEAREST |             |
     * | 9   | LINEAR_NEAREST_MIPNEAREST |             |
     * | 10   | LINEAR_NEAREST_MIPLINEAR |             |
     * | 11   | LINEAR_LINEAR |             |
     * | 12   | LINEAR_NEAREST |             |
     *
     *    > _mag_: magnification filter (close to the viewer)
     *    > _min_: minification filter (far from the viewer)
     *    > _mip_: filter used between mip map levels
     *@param samplingMode Define the new sampling mode of the texture
     */ updateSamplingMode(samplingMode) {
        if (this._texture && this._engine) this._engine.updateTextureSamplingMode(samplingMode, this._texture);
    }
    /**
     * Release and destroy the underlying lower level texture aka internalTexture.
     */ releaseInternalTexture() {
        if (this._texture) {
            this._texture.dispose();
            this._texture = null;
        }
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        if (this._texture) {
            this.releaseInternalTexture();
            this._engine = null;
        }
    }
}

});
parcelRegister("93o7r", function(module, exports) {

$parcel$export(module.exports, "Size", () => $69771a6a6db876b9$export$cb6da89c6af1a8ec);
/**
 * Size containing width and height
 */ class $69771a6a6db876b9$export$cb6da89c6af1a8ec {
    /**
     * Creates a Size object from the given width and height (floats).
     * @param width width of the new size
     * @param height height of the new size
     */ constructor(width, height){
        this.width = width;
        this.height = height;
    }
    /**
     * Returns a string with the Size width and height
     * @returns a string with the Size width and height
     */ toString() {
        return `{W: ${this.width}, H: ${this.height}}`;
    }
    /**
     * "Size"
     * @returns the string "Size"
     */ getClassName() {
        return "Size";
    }
    /**
     * Returns the Size hash code.
     * @returns a hash code for a unique width and height
     */ getHashCode() {
        let hash = this.width | 0;
        hash = hash * 397 ^ (this.height | 0);
        return hash;
    }
    /**
     * Updates the current size from the given one.
     * @param src the given size
     */ copyFrom(src) {
        this.width = src.width;
        this.height = src.height;
    }
    /**
     * Updates in place the current Size from the given floats.
     * @param width width of the new size
     * @param height height of the new size
     * @returns the updated Size.
     */ copyFromFloats(width, height) {
        this.width = width;
        this.height = height;
        return this;
    }
    /**
     * Updates in place the current Size from the given floats.
     * @param width width to set
     * @param height height to set
     * @returns the updated Size.
     */ set(width, height) {
        return this.copyFromFloats(width, height);
    }
    /**
     * Multiplies the width and height by numbers
     * @param w factor to multiple the width by
     * @param h factor to multiple the height by
     * @returns a new Size set with the multiplication result of the current Size and the given floats.
     */ multiplyByFloats(w, h) {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width * w, this.height * h);
    }
    /**
     * Clones the size
     * @returns a new Size copied from the given one.
     */ clone() {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    /**
     * True if the current Size and the given one width and height are strictly equal.
     * @param other the other size to compare against
     * @returns True if the current Size and the given one width and height are strictly equal.
     */ equals(other) {
        if (!other) return false;
        return this.width === other.width && this.height === other.height;
    }
    /**
     * The surface of the Size : width * height (float).
     */ get surface() {
        return this.width * this.height;
    }
    /**
     * Create a new size of zero
     * @returns a new Size set to (0.0, 0.0)
     */ static Zero() {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(0.0, 0.0);
    }
    /**
     * Sums the width and height of two sizes
     * @param otherSize size to add to this size
     * @returns a new Size set as the addition result of the current Size and the given one.
     */ add(otherSize) {
        const r = new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width + otherSize.width, this.height + otherSize.height);
        return r;
    }
    /**
     * Subtracts the width and height of two
     * @param otherSize size to subtract to this size
     * @returns a new Size set as the subtraction result of  the given one from the current Size.
     */ subtract(otherSize) {
        const r = new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width - otherSize.width, this.height - otherSize.height);
        return r;
    }
    /**
     * Scales the width and height
     * @param scale the scale to multiply the width and height by
     * @returns a new Size set with the multiplication result of the current Size and the given floats.
     */ scale(scale) {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width * scale, this.height * scale);
    }
    /**
     * Creates a new Size set at the linear interpolation "amount" between "start" and "end"
     * @param start starting size to lerp between
     * @param end end size to lerp between
     * @param amount amount to lerp between the start and end values
     * @returns a new Size set at the linear interpolation "amount" between "start" and "end"
     */ static Lerp(start, end, amount) {
        const w = start.width + (end.width - start.width) * amount;
        const h = start.height + (end.height - start.height) * amount;
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(w, h);
    }
}

});



parcelRegister("f2kkL", function(module, exports) {

$parcel$export(module.exports, "GenerateBase64StringFromTexture", () => $af26d0cc3ed27ae3$export$5ff2effb6017083b);
$parcel$export(module.exports, "GenerateBase64StringFromTextureAsync", () => $af26d0cc3ed27ae3$export$4fce851e948778e9);
/**
 * Transform some pixel data to a base64 string
 * @param pixels defines the pixel data to transform to base64
 * @param size defines the width and height of the (texture) data
 * @param invertY true if the data must be inverted for the Y coordinate during the conversion
 * @returns The base64 encoded string or null
 */ function $af26d0cc3ed27ae3$export$87c020095ab48b9a(pixels, size, invertY = false) {
    const width = size.width;
    const height = size.height;
    if (pixels instanceof Float32Array) {
        let len = pixels.byteLength / pixels.BYTES_PER_ELEMENT;
        const npixels = new Uint8Array(len);
        while(--len >= 0){
            let val = pixels[len];
            if (val < 0) val = 0;
            else if (val > 1) val = 1;
            npixels[len] = val * 255;
        }
        pixels = npixels;
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const imageData = ctx.createImageData(width, height);
    const castData = imageData.data;
    castData.set(pixels);
    ctx.putImageData(imageData, 0, 0);
    if (invertY) {
        const canvas2 = document.createElement("canvas");
        canvas2.width = width;
        canvas2.height = height;
        const ctx2 = canvas2.getContext("2d");
        if (!ctx2) return null;
        ctx2.translate(0, height);
        ctx2.scale(1, -1);
        ctx2.drawImage(canvas, 0, 0);
        return canvas2.toDataURL("image/png");
    }
    return canvas.toDataURL("image/png");
}
function $af26d0cc3ed27ae3$export$5ff2effb6017083b(texture, faceIndex = 0, level = 0) {
    const internalTexture = texture.getInternalTexture();
    if (!internalTexture) return null;
    const pixels = texture._readPixelsSync(faceIndex, level);
    if (!pixels) return null;
    return $af26d0cc3ed27ae3$export$87c020095ab48b9a(pixels, texture.getSize(), internalTexture.invertY);
}
async function $af26d0cc3ed27ae3$export$4fce851e948778e9(texture, faceIndex = 0, level = 0) {
    const internalTexture = texture.getInternalTexture();
    if (!internalTexture) return null;
    const pixels = await texture.readPixels(faceIndex, level);
    if (!pixels) return null;
    return $af26d0cc3ed27ae3$export$87c020095ab48b9a(pixels, texture.getSize(), internalTexture.invertY);
}
const $af26d0cc3ed27ae3$export$3481a701739ec579 = {
    GenerateBase64StringFromPixelData: /**
     * Transform some pixel data to a base64 string
     * @param pixels defines the pixel data to transform to base64
     * @param size defines the width and height of the (texture) data
     * @param invertY true if the data must be inverted for the Y coordinate during the conversion
     * @returns The base64 encoded string or null
     */ $af26d0cc3ed27ae3$export$87c020095ab48b9a,
    GenerateBase64StringFromTexture: /**
     * Reads the pixels stored in the webgl texture and returns them as a base64 string
     * @param texture defines the texture to read pixels from
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @returns The base64 encoded string or null
     */ $af26d0cc3ed27ae3$export$5ff2effb6017083b,
    GenerateBase64StringFromTextureAsync: /**
     * Reads the pixels stored in the webgl texture and returns them as a base64 string
     * @param texture defines the texture to read pixels from
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @returns The base64 encoded string or null wrapped in a promise
     */ $af26d0cc3ed27ae3$export$4fce851e948778e9
};

});

parcelRegister("fGXjI", function(module, exports) {

$parcel$export(module.exports, "useOpenGLOrientationForUV", () => $b6c8ca61d91f5b1f$export$723b16d095de6bfd);
/**
 * Defines if the system should use OpenGL convention for UVs when creating geometry or loading .babylon files (false by default)
 */ let $b6c8ca61d91f5b1f$export$723b16d095de6bfd = false;
function $b6c8ca61d91f5b1f$export$1a20d92c9a39d292(value1) {
    $b6c8ca61d91f5b1f$export$723b16d095de6bfd = value1;
}
const $b6c8ca61d91f5b1f$export$2a04715a0c531dd0 = {
    /* eslint-disable @typescript-eslint/naming-convention */ get UseOpenGLOrientationForUV () {
        return $b6c8ca61d91f5b1f$export$723b16d095de6bfd;
    },
    set UseOpenGLOrientationForUV (value){
        $b6c8ca61d91f5b1f$export$723b16d095de6bfd = value;
    }
};

});


parcelRegister("7c9IK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h8vYC").then(()=>parcelRequire('bRIyK'));

});

parcelRegister("65n0B", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("U2cDc").then(()=>parcelRequire('jUUhd'));

});

parcelRegister("b1pUy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6mp9e").then(()=>parcelRequire('busaG'));

});

parcelRegister("6CP4X", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bXJVg").then(()=>parcelRequire('8zMLP'));

});

parcelRegister("ksj2w", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("49P8m").then(()=>parcelRequire('c4AbZ'));

});

parcelRegister("h3R3m", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("20662").then(()=>parcelRequire('7Z1KU'));

});

parcelRegister("44nRt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2nzrc").then(()=>parcelRequire('kqZxW'));

});

parcelRegister("fn9QB", function(module, exports) {

$parcel$export(module.exports, "defaultVertexShader", () => $b310a47bffd39c6d$export$664d1877a3009ae4);
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("5g9r7");
parcelRequire("dcSpY");
parcelRequire("1ZoxO");
parcelRequire("7Hs3g");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("k3wwH");
parcelRequire("cdubm");
parcelRequire("5lMLg");
parcelRequire("eiwUK");
parcelRequire("hgGYG");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("1yLBX");
parcelRequire("c0VT2");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("4kipo");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("f7nPp");
parcelRequire("i4Zbf");
parcelRequire("9N2ej");
parcelRequire("4GjUR");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("5sP5F");
parcelRequire("jl3r6");
parcelRequire("2NtPW");
parcelRequire("a111f");
const $b310a47bffd39c6d$var$name = "defaultVertexShader";
const $b310a47bffd39c6d$var$shader = `#define CUSTOM_VERTEX_EXTENSION
#include<__decl__defaultVertex>
#define CUSTOM_VERTEX_BEGIN
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#ifdef TANGENT
attribute vec4 tangent;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#include<uvAttributeDeclaration>[2..7]
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<helperFunctions>
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
#include<prePassVertexDeclaration>
#include<mainUVVaryingDeclaration>[1..7]
#include<samplerVertexDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse)
#include<samplerVertexDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail)
#include<samplerVertexDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient)
#include<samplerVertexDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity)
#include<samplerVertexDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive)
#include<samplerVertexDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap)
#if defined(SPECULARTERM)
#include<samplerVertexDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular)
#endif
#include<samplerVertexDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump)
#include<samplerVertexDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal)
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<bumpVertexDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#ifdef TANGENT
vec4 tangentUpdated=tangent;
#endif
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#ifdef UV2
vec2 uv2Updated=uv2;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=positionUpdated;
#endif
#define CUSTOM_VERTEX_UPDATE_POSITION
#define CUSTOM_VERTEX_UPDATE_NORMAL
#include<instancesVertex>
#if defined(PREPASS) && ((defined(PREPASS_VELOCITY) || defined(PREPASS_VELOCITY_LINEAR)) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normalWorld[0],normalWorld[0]),dot(normalWorld[1],normalWorld[1]),dot(normalWorld[2],normalWorld[2]));vNormalW=normalize(normalWorld*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normalUpdated);
#endif
#endif
#define CUSTOM_VERTEX_UPDATE_WORLDPOS
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
vPositionW=vec3(worldPos);
#ifdef PREPASS
#include<prePassVertex>
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(positionUpdated,0.0)));
#endif
#ifndef UV1
vec2 uvUpdated=vec2(0.,0.);
#endif
#ifndef UV2
vec2 uv2Updated=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uvUpdated;
#endif
#ifdef MAINUV2
vMainUV2=uv2Updated;
#endif
#include<uvVariableDeclaration>[3..7]
#include<samplerVertexImplementation>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_MATRIXNAME_,diffuse,_INFONAME_,DiffuseInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_MATRIXNAME_,detail,_INFONAME_,DetailInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_MATRIXNAME_,ambient,_INFONAME_,AmbientInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_MATRIXNAME_,opacity,_INFONAME_,OpacityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_MATRIXNAME_,emissive,_INFONAME_,EmissiveInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_MATRIXNAME_,lightmap,_INFONAME_,LightmapInfos.x)
#if defined(SPECULARTERM)
#include<samplerVertexImplementation>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_MATRIXNAME_,specular,_INFONAME_,SpecularInfos.x)
#endif
#include<samplerVertexImplementation>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_MATRIXNAME_,bump,_INFONAME_,BumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_MATRIXNAME_,decal,_INFONAME_,DecalInfos.x)
#include<bumpVertex>
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#include<pointCloudVertex>
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b310a47bffd39c6d$var$name] = $b310a47bffd39c6d$var$shader;
const $b310a47bffd39c6d$export$664d1877a3009ae4 = {
    name: $b310a47bffd39c6d$var$name,
    shader: $b310a47bffd39c6d$var$shader
};

});
parcelRegister("5g9r7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("jsAPu");
const $3d45c43af5a07787$var$name = "defaultVertexDeclaration";
const $3d45c43af5a07787$var$shader = `uniform mat4 viewProjection;
#ifdef MULTIVIEW
mat4 viewProjectionR;
#endif 
uniform mat4 view;
#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform mat4 ambientMatrix;uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY
uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;uniform mat4 emissiveMatrix;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;uniform mat4 lightmapMatrix;
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;uniform mat4 specularMatrix;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform mat4 bumpMatrix;
#endif
#ifdef REFLECTION
uniform mat4 reflectionMatrix;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;uniform mat4 detailMatrix;
#endif
#include<decalVertexDeclaration>
#define ADDITIONAL_VERTEX_DECLARATION
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3d45c43af5a07787$var$name] = $3d45c43af5a07787$var$shader;
const $3d45c43af5a07787$export$fc31011eec8bfe53 = {
    name: $3d45c43af5a07787$var$name,
    shader: $3d45c43af5a07787$var$shader
};

});
parcelRegister("jsAPu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e2ad336efd48eba2$var$name = "decalVertexDeclaration";
const $e2ad336efd48eba2$var$shader = `#ifdef DECAL
uniform vec4 vDecalInfos;uniform mat4 decalMatrix;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e2ad336efd48eba2$var$name] = $e2ad336efd48eba2$var$shader;
const $e2ad336efd48eba2$export$1df775727dc5ccda = {
    name: $e2ad336efd48eba2$var$name,
    shader: $e2ad336efd48eba2$var$shader
};

});


parcelRegister("dcSpY", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
parcelRequire("4u6lu");
const $99d69ba084b7d7da$var$name = "defaultUboDeclaration";
const $99d69ba084b7d7da$var$shader = `layout(std140,column_major) uniform;uniform Material
{vec4 diffuseLeftColor;vec4 diffuseRightColor;vec4 opacityParts;vec4 reflectionLeftColor;vec4 reflectionRightColor;vec4 refractionLeftColor;vec4 refractionRightColor;vec4 emissiveLeftColor;vec4 emissiveRightColor;vec2 vDiffuseInfos;vec2 vAmbientInfos;vec2 vOpacityInfos;vec2 vReflectionInfos;vec3 vReflectionPosition;vec3 vReflectionSize;vec2 vEmissiveInfos;vec2 vLightmapInfos;vec2 vSpecularInfos;vec3 vBumpInfos;mat4 diffuseMatrix;mat4 ambientMatrix;mat4 opacityMatrix;mat4 reflectionMatrix;mat4 emissiveMatrix;mat4 lightmapMatrix;mat4 specularMatrix;mat4 bumpMatrix;vec2 vTangentSpaceParams;float pointSize;float alphaCutOff;mat4 refractionMatrix;vec4 vRefractionInfos;vec3 vRefractionPosition;vec3 vRefractionSize;vec4 vSpecularColor;vec3 vEmissiveColor;vec4 vDiffuseColor;vec3 vAmbientColor;
#define ADDITIONAL_UBO_DECLARATION
};
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$99d69ba084b7d7da$var$name] = $99d69ba084b7d7da$var$shader;
const $99d69ba084b7d7da$export$c2e57b57f6e813a4 = {
    name: $99d69ba084b7d7da$var$name,
    shader: $99d69ba084b7d7da$var$shader
};

});
parcelRegister("eZlZI", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ae97d2ce74ca59f4$var$name = "sceneUboDeclaration";
const $ae97d2ce74ca59f4$var$shader = `layout(std140,column_major) uniform;uniform Scene {mat4 viewProjection;
#ifdef MULTIVIEW
mat4 viewProjectionR;
#endif 
mat4 view;mat4 projection;vec4 vEyePosition;};
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ae97d2ce74ca59f4$var$name] = $ae97d2ce74ca59f4$var$shader;
const $ae97d2ce74ca59f4$export$89e49482cbc67f19 = {
    name: $ae97d2ce74ca59f4$var$name,
    shader: $ae97d2ce74ca59f4$var$shader
};

});

parcelRegister("4u6lu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $343ee2dddd497bd6$var$name = "meshUboDeclaration";
const $343ee2dddd497bd6$var$shader = `#ifdef WEBGL2
uniform mat4 world;uniform float visibility;
#else
layout(std140,column_major) uniform;uniform Mesh
{mat4 world;float visibility;};
#endif
#define WORLD_UBO
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$343ee2dddd497bd6$var$name] = $343ee2dddd497bd6$var$shader;
const $343ee2dddd497bd6$export$7c5f228ba674c3fe = {
    name: $343ee2dddd497bd6$var$name,
    shader: $343ee2dddd497bd6$var$shader
};

});


parcelRegister("1ZoxO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $172e86f68a6d323d$var$name = "uvAttributeDeclaration";
const $172e86f68a6d323d$var$shader = `#ifdef UV{X}
attribute vec2 uv{X};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$172e86f68a6d323d$var$name] = $172e86f68a6d323d$var$shader;
const $172e86f68a6d323d$export$6414608d9aaf5df = {
    name: $172e86f68a6d323d$var$name,
    shader: $172e86f68a6d323d$var$shader
};

});

parcelRegister("7Hs3g", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $59b24f0424d3f607$var$name = "helperFunctions";
const $59b24f0424d3f607$var$shader = `const float PI=3.1415926535897932384626433832795;const float TWO_PI=6.283185307179586;const float HALF_PI=1.5707963267948966;const float RECIPROCAL_PI=0.3183098861837907;const float RECIPROCAL_PI2=0.15915494309189535;const float RECIPROCAL_PI4=0.07957747154594767;const float HALF_MIN=5.96046448e-08; 
const float LinearEncodePowerApprox=2.2;const float GammaEncodePowerApprox=1.0/LinearEncodePowerApprox;const vec3 LuminanceEncodeApprox=vec3(0.2126,0.7152,0.0722);const float Epsilon=0.0000001;
#define saturate(x) clamp(x,0.0,1.0)
#define absEps(x) abs(x)+Epsilon
#define maxEps(x) max(x,Epsilon)
#define saturateEps(x) clamp(x,Epsilon,1.0)
mat3 transposeMat3(mat3 inMatrix) {vec3 i0=inMatrix[0];vec3 i1=inMatrix[1];vec3 i2=inMatrix[2];mat3 outMatrix=mat3(
vec3(i0.x,i1.x,i2.x),
vec3(i0.y,i1.y,i2.y),
vec3(i0.z,i1.z,i2.z)
);return outMatrix;}
mat3 inverseMat3(mat3 inMatrix) {float a00=inMatrix[0][0],a01=inMatrix[0][1],a02=inMatrix[0][2];float a10=inMatrix[1][0],a11=inMatrix[1][1],a12=inMatrix[1][2];float a20=inMatrix[2][0],a21=inMatrix[2][1],a22=inMatrix[2][2];float b01=a22*a11-a12*a21;float b11=-a22*a10+a12*a20;float b21=a21*a10-a11*a20;float det=a00*b01+a01*b11+a02*b21;return mat3(b01,(-a22*a01+a02*a21),(a12*a01-a02*a11),
b11,(a22*a00-a02*a20),(-a12*a00+a02*a10),
b21,(-a21*a00+a01*a20),(a11*a00-a01*a10))/det;}
#if USE_EXACT_SRGB_CONVERSIONS
vec3 toLinearSpaceExact(vec3 color)
{vec3 nearZeroSection=0.0773993808*color;vec3 remainingSection=pow(0.947867299*(color+vec3(0.055)),vec3(2.4));
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.04045)));
#else
return
vec3(
color.r<=0.04045 ? nearZeroSection.r : remainingSection.r,
color.g<=0.04045 ? nearZeroSection.g : remainingSection.g,
color.b<=0.04045 ? nearZeroSection.b : remainingSection.b);
#endif
}
vec3 toGammaSpaceExact(vec3 color)
{vec3 nearZeroSection=12.92*color;vec3 remainingSection=1.055*pow(color,vec3(0.41666))-vec3(0.055);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.0031308)));
#else
return
vec3(
color.r<=0.0031308 ? nearZeroSection.r : remainingSection.r,
color.g<=0.0031308 ? nearZeroSection.g : remainingSection.g,
color.b<=0.0031308 ? nearZeroSection.b : remainingSection.b);
#endif
}
#endif
float toLinearSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=0.0773993808*color;float remainingSection=pow(0.947867299*(color+0.055),2.4);return color<=0.04045 ? nearZeroSection : remainingSection;
#else
return pow(color,LinearEncodePowerApprox);
#endif
}
vec3 toLinearSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toLinearSpaceExact(color);
#else
return pow(color,vec3(LinearEncodePowerApprox));
#endif
}
vec4 toLinearSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toLinearSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(LinearEncodePowerApprox)),color.a);
#endif
}
float toGammaSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=12.92*color;float remainingSection=1.055*pow(color,0.41666)-0.055;return color<=0.0031308 ? nearZeroSection : remainingSection;
#else
return pow(color,GammaEncodePowerApprox);
#endif
}
vec3 toGammaSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toGammaSpaceExact(color);
#else
return pow(color,vec3(GammaEncodePowerApprox));
#endif
}
vec4 toGammaSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toGammaSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(GammaEncodePowerApprox)),color.a);
#endif
}
float square(float value)
{return value*value;}
vec3 square(vec3 value)
{return value*value;}
float pow5(float value) {float sq=value*value;return sq*sq*value;}
float getLuminance(vec3 color)
{return saturate(dot(color,LuminanceEncodeApprox));}
float getRand(vec2 seed) {return fract(sin(dot(seed.xy ,vec2(12.9898,78.233)))*43758.5453);}
float dither(vec2 seed,float varianceAmount) {float rand=getRand(seed);float normVariance=varianceAmount/255.0;float dither=mix(-normVariance,normVariance,rand);return dither;}
const float rgbdMaxRange=255.;vec4 toRGBD(vec3 color) {float maxRGB=maxEps(max(color.r,max(color.g,color.b)));float D =max(rgbdMaxRange/maxRGB,1.);D =saturate(floor(D)/255.);vec3 rgb=color.rgb*D;rgb=toGammaSpace(rgb);return vec4(saturate(rgb),D);}
vec3 fromRGBD(vec4 rgbd) {rgbd.rgb=toLinearSpace(rgbd.rgb);return rgbd.rgb/rgbd.a;}
vec3 parallaxCorrectNormal( vec3 vertexPos,vec3 origVec,vec3 cubeSize,vec3 cubePos ) {vec3 invOrigVec=vec3(1.)/origVec;vec3 halfSize=cubeSize*0.5;vec3 intersecAtMaxPlane=(cubePos+halfSize-vertexPos)*invOrigVec;vec3 intersecAtMinPlane=(cubePos-halfSize-vertexPos)*invOrigVec;vec3 largestIntersec=max(intersecAtMaxPlane,intersecAtMinPlane);float distance=min(min(largestIntersec.x,largestIntersec.y),largestIntersec.z);vec3 intersectPositionWS=vertexPos+origVec*distance;return intersectPositionWS-cubePos;}
vec3 equirectangularToCubemapDirection(vec2 uv) {float longitude=uv.x*TWO_PI-PI;float latitude=HALF_PI-uv.y*PI;vec3 direction;direction.x=cos(latitude)*sin(longitude);direction.y=sin(latitude);direction.z=cos(latitude)*cos(longitude);return direction;}
float sqrtClamped(float value) {return sqrt(max(value,0.));}
float avg(vec3 value) {return dot(value,vec3(0.333333333));}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$59b24f0424d3f607$var$name] = $59b24f0424d3f607$var$shader;
const $59b24f0424d3f607$export$89304a25b58dd7ab = {
    name: $59b24f0424d3f607$var$name,
    shader: $59b24f0424d3f607$var$shader
};

});

parcelRegister("7PW7m", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5b4a60c90ba31b5f$var$name = "bonesDeclaration";
const $5b4a60c90ba31b5f$var$shader = `#if NUM_BONE_INFLUENCERS>0
attribute vec4 matricesIndices;attribute vec4 matricesWeights;
#if NUM_BONE_INFLUENCERS>4
attribute vec4 matricesIndicesExtra;attribute vec4 matricesWeightsExtra;
#endif
#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#ifdef BONETEXTURE
uniform highp sampler2D boneSampler;uniform float boneTextureWidth;
#else
uniform mat4 mBones[BonesPerMesh];
#endif
#ifdef BONES_VELOCITY_ENABLED
uniform mat4 mPreviousBones[BonesPerMesh];
#endif
#ifdef BONETEXTURE
#define inline
mat4 readMatrixFromRawSampler(sampler2D smp,float index)
{float offset=index *4.0;float dx=1.0/boneTextureWidth;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),0.));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),0.));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),0.));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),0.));return mat4(m0,m1,m2,m3);}
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5b4a60c90ba31b5f$var$name] = $5b4a60c90ba31b5f$var$shader;
const $5b4a60c90ba31b5f$export$d4e06f9ec8a1a3b9 = {
    name: $5b4a60c90ba31b5f$var$name,
    shader: $5b4a60c90ba31b5f$var$shader
};

});

parcelRegister("8kYMw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $611f56f6f6f0bece$var$name = "bakedVertexAnimationDeclaration";
const $611f56f6f6f0bece$var$shader = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
uniform float bakedVertexAnimationTime;uniform vec2 bakedVertexAnimationTextureSizeInverted;uniform vec4 bakedVertexAnimationSettings;uniform sampler2D bakedVertexAnimationTexture;
#ifdef INSTANCES
attribute vec4 bakedVertexAnimationSettingsInstanced;
#endif
#define inline
mat4 readMatrixFromRawSamplerVAT(sampler2D smp,float index,float frame)
{float offset=index*4.0;float frameUV=(frame+0.5)*bakedVertexAnimationTextureSizeInverted.y;float dx=bakedVertexAnimationTextureSizeInverted.x;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),frameUV));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),frameUV));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),frameUV));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),frameUV));return mat4(m0,m1,m2,m3);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$611f56f6f6f0bece$var$name] = $611f56f6f6f0bece$var$shader;
const $611f56f6f6f0bece$export$9942938b957c1c75 = {
    name: $611f56f6f6f0bece$var$name,
    shader: $611f56f6f6f0bece$var$shader
};

});

parcelRegister("k3wwH", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e99d51826f18505b$var$name = "instancesDeclaration";
const $e99d51826f18505b$var$shader = `#ifdef INSTANCES
attribute vec4 world0;attribute vec4 world1;attribute vec4 world2;attribute vec4 world3;
#ifdef INSTANCESCOLOR
attribute vec4 instanceColor;
#endif
#if defined(THIN_INSTANCES) && !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY) || defined(PREPASS_VELOCITY_LINEAR) || defined(VELOCITY_LINEAR)
attribute vec4 previousWorld0;attribute vec4 previousWorld1;attribute vec4 previousWorld2;attribute vec4 previousWorld3;
#ifdef THIN_INSTANCES
uniform mat4 previousWorld;
#endif
#endif
#else
#if !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY) || defined(PREPASS_VELOCITY_LINEAR) || defined(VELOCITY_LINEAR)
uniform mat4 previousWorld;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e99d51826f18505b$var$name] = $e99d51826f18505b$var$shader;
const $e99d51826f18505b$export$9b0ca2b8078a529 = {
    name: $e99d51826f18505b$var$name,
    shader: $e99d51826f18505b$var$shader
};

});

parcelRegister("cdubm", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8e4e1c8037d53585$var$name = "prePassVertexDeclaration";
const $8e4e1c8037d53585$var$shader = `#ifdef PREPASS
#ifdef PREPASS_LOCAL_POSITION
varying vec3 vPosition;
#endif
#ifdef PREPASS_DEPTH
varying vec3 vViewPos;
#endif
#if defined(PREPASS_VELOCITY) || defined(PREPASS_VELOCITY_LINEAR)
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8e4e1c8037d53585$var$name] = $8e4e1c8037d53585$var$shader;
const $8e4e1c8037d53585$export$4ec55bfc69889e15 = {
    name: $8e4e1c8037d53585$var$name,
    shader: $8e4e1c8037d53585$var$shader
};

});

parcelRegister("5lMLg", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3e54bce5d98c5a59$var$name = "mainUVVaryingDeclaration";
const $3e54bce5d98c5a59$var$shader = `#ifdef MAINUV{X}
varying vec2 vMainUV{X};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3e54bce5d98c5a59$var$name] = $3e54bce5d98c5a59$var$shader;
const $3e54bce5d98c5a59$export$44745f0433a780d2 = {
    name: $3e54bce5d98c5a59$var$name,
    shader: $3e54bce5d98c5a59$var$shader
};

});

parcelRegister("eiwUK", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $a68c47331f8d8cf4$var$name = "samplerVertexDeclaration";
const $a68c47331f8d8cf4$var$shader = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
varying vec2 v_VARYINGNAME_UV;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$a68c47331f8d8cf4$var$name] = $a68c47331f8d8cf4$var$shader;
const $a68c47331f8d8cf4$export$6b00e48b18c6bdcf = {
    name: $a68c47331f8d8cf4$var$name,
    shader: $a68c47331f8d8cf4$var$shader
};

});

parcelRegister("hgGYG", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $c92544cce48e2dec$var$name = "bumpVertexDeclaration";
const $c92544cce48e2dec$var$shader = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c92544cce48e2dec$var$name] = $c92544cce48e2dec$var$shader;
const $c92544cce48e2dec$export$51cb49746cf68044 = {
    name: $c92544cce48e2dec$var$name,
    shader: $c92544cce48e2dec$var$shader
};

});

parcelRegister("4A4MM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $355e3c8ecba8d2d6$var$name = "clipPlaneVertexDeclaration";
const $355e3c8ecba8d2d6$var$shader = `#ifdef CLIPPLANE
uniform vec4 vClipPlane;varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
uniform vec4 vClipPlane2;varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
uniform vec4 vClipPlane3;varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
uniform vec4 vClipPlane4;varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
uniform vec4 vClipPlane5;varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
uniform vec4 vClipPlane6;varying float fClipDistance6;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$355e3c8ecba8d2d6$var$name] = $355e3c8ecba8d2d6$var$shader;
const $355e3c8ecba8d2d6$export$61ce3e39b95f6070 = {
    name: $355e3c8ecba8d2d6$var$name,
    shader: $355e3c8ecba8d2d6$var$shader
};

});

parcelRegister("bdABV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $82ad4ebfc53513dc$var$name = "fogVertexDeclaration";
const $82ad4ebfc53513dc$var$shader = `#ifdef FOG
varying vec3 vFogDistance;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$82ad4ebfc53513dc$var$name] = $82ad4ebfc53513dc$var$shader;
const $82ad4ebfc53513dc$export$a192dee6a001eb2d = {
    name: $82ad4ebfc53513dc$var$name,
    shader: $82ad4ebfc53513dc$var$shader
};

});

parcelRegister("1yLBX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $122de601600398fe$var$name = "lightVxFragmentDeclaration";
const $122de601600398fe$var$shader = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#if defined(AREALIGHT{X})
uniform vec4 vLightWidth{X};uniform vec4 vLightHeight{X};
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$122de601600398fe$var$name] = $122de601600398fe$var$shader;
const $122de601600398fe$export$40bda2b1eeb332f0 = {
    name: $122de601600398fe$var$name,
    shader: $122de601600398fe$var$shader
};

});

parcelRegister("c0VT2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8bf26339340bd8a9$var$name = "lightVxUboDeclaration";
const $8bf26339340bd8a9$var$shader = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
#if defined(AREALIGHT{X})
vec4 vLightWidth;vec4 vLightHeight;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8bf26339340bd8a9$var$name] = $8bf26339340bd8a9$var$shader;
const $8bf26339340bd8a9$export$6083bacb6a93516e = {
    name: $8bf26339340bd8a9$var$name,
    shader: $8bf26339340bd8a9$var$shader
};

});

parcelRegister("5Eb4I", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $41c9477483c07583$var$name = "morphTargetsVertexGlobalDeclaration";
const $41c9477483c07583$var$shader = `#ifdef MORPHTARGETS
uniform float morphTargetInfluences[NUM_MORPH_INFLUENCERS];
#ifdef MORPHTARGETS_TEXTURE 
uniform float morphTargetTextureIndices[NUM_MORPH_INFLUENCERS];uniform vec3 morphTargetTextureInfo;uniform highp sampler2DArray morphTargets;vec3 readVector3FromRawSampler(int targetIndex,float vertexIndex)
{ 
float y=floor(vertexIndex/morphTargetTextureInfo.y);float x=vertexIndex-y*morphTargetTextureInfo.y;vec3 textureUV=vec3((x+0.5)/morphTargetTextureInfo.y,(y+0.5)/morphTargetTextureInfo.z,morphTargetTextureIndices[targetIndex]);return texture(morphTargets,textureUV).xyz;}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$41c9477483c07583$var$name] = $41c9477483c07583$var$shader;
const $41c9477483c07583$export$d8c22cd8cb3e4149 = {
    name: $41c9477483c07583$var$name,
    shader: $41c9477483c07583$var$shader
};

});

parcelRegister("9H5jp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $70ec40154a05b269$var$name = "morphTargetsVertexDeclaration";
const $70ec40154a05b269$var$shader = `#ifdef MORPHTARGETS
#ifndef MORPHTARGETS_TEXTURE
#ifdef MORPHTARGETS_POSITION
attribute vec3 position{X};
#endif
#ifdef MORPHTARGETS_NORMAL
attribute vec3 normal{X};
#endif
#ifdef MORPHTARGETS_TANGENT
attribute vec3 tangent{X};
#endif
#ifdef MORPHTARGETS_UV
attribute vec2 uv_{X};
#endif
#ifdef MORPHTARGETS_UV2
attribute vec2 uv2_{X};
#endif
#elif {X}==0
uniform int morphTargetCount;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$70ec40154a05b269$var$name] = $70ec40154a05b269$var$shader;
const $70ec40154a05b269$export$695a00cfa0b745dc = {
    name: $70ec40154a05b269$var$name,
    shader: $70ec40154a05b269$var$shader
};

});

parcelRegister("4kipo", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $32674f36d644b329$var$name = "logDepthDeclaration";
const $32674f36d644b329$var$shader = `#ifdef LOGARITHMICDEPTH
uniform float logarithmicDepthConstant;varying float vFragmentDepth;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$32674f36d644b329$var$name] = $32674f36d644b329$var$shader;
const $32674f36d644b329$export$d504a825a83b203c = {
    name: $32674f36d644b329$var$name,
    shader: $32674f36d644b329$var$shader
};

});

parcelRegister("9ulLS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6e87cdb772071107$var$name = "morphTargetsVertexGlobal";
const $6e87cdb772071107$var$shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
float vertexID;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$6e87cdb772071107$var$name] = $6e87cdb772071107$var$shader;
const $6e87cdb772071107$export$f1ab5e2472bd1f4 = {
    name: $6e87cdb772071107$var$name,
    shader: $6e87cdb772071107$var$shader
};

});

parcelRegister("LFrAO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $08f489d34029abd4$var$name = "morphTargetsVertex";
const $08f489d34029abd4$var$shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
#if {X}==0
for (int i=0; i<NUM_MORPH_INFLUENCERS; i++) {if (i>=morphTargetCount) break;vertexID=float(gl_VertexID)*morphTargetTextureInfo.x;
#ifdef MORPHTARGETS_POSITION
positionUpdated+=(readVector3FromRawSampler(i,vertexID)-position)*morphTargetInfluences[i];
#endif
#ifdef MORPHTARGETTEXTURE_HASPOSITIONS
vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(readVector3FromRawSampler(i,vertexID) -normal)*morphTargetInfluences[i];
#endif
#ifdef MORPHTARGETTEXTURE_HASNORMALS
vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(readVector3FromRawSampler(i,vertexID).xy-uv)*morphTargetInfluences[i];
#endif
#ifdef MORPHTARGETTEXTURE_HASUVS
vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(readVector3FromRawSampler(i,vertexID) -tangent.xyz)*morphTargetInfluences[i];
#endif
#ifdef MORPHTARGETTEXTURE_HASTANGENTS
vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_UV2
uv2Updated+=(readVector3FromRawSampler(i,vertexID).xy-uv2)*morphTargetInfluences[i];
#endif
}
#endif
#else
#ifdef MORPHTARGETS_POSITION
positionUpdated+=(position{X}-position)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(normal{X}-normal)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(tangent{X}-tangent.xyz)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(uv_{X}-uv)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_UV2
uv2Updated+=(uv2_{X}-uv2)*morphTargetInfluences[{X}];
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$08f489d34029abd4$var$name] = $08f489d34029abd4$var$shader;
const $08f489d34029abd4$export$b897b5fdf807d651 = {
    name: $08f489d34029abd4$var$name,
    shader: $08f489d34029abd4$var$shader
};

});

parcelRegister("apKdp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7950168e67292231$var$name = "instancesVertex";
const $7950168e67292231$var$shader = `#ifdef INSTANCES
mat4 finalWorld=mat4(world0,world1,world2,world3);
#if defined(PREPASS_VELOCITY) || defined(VELOCITY) || defined(PREPASS_VELOCITY_LINEAR) || defined(VELOCITY_LINEAR)
mat4 finalPreviousWorld=mat4(previousWorld0,previousWorld1,
previousWorld2,previousWorld3);
#endif
#ifdef THIN_INSTANCES
finalWorld=world*finalWorld;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY) || defined(PREPASS_VELOCITY_LINEAR) || defined(VELOCITY_LINEAR)
finalPreviousWorld=previousWorld*finalPreviousWorld;
#endif
#endif
#else
mat4 finalWorld=world;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY) || defined(PREPASS_VELOCITY_LINEAR) || defined(VELOCITY_LINEAR)
mat4 finalPreviousWorld=previousWorld;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7950168e67292231$var$name] = $7950168e67292231$var$shader;
const $7950168e67292231$export$306861c24aa7eac7 = {
    name: $7950168e67292231$var$name,
    shader: $7950168e67292231$var$shader
};

});

parcelRegister("4idCt", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $320368658d08a66f$var$name = "bonesVertex";
const $320368658d08a66f$var$shader = `#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#if NUM_BONE_INFLUENCERS>0
mat4 influence;
#ifdef BONETEXTURE
influence=readMatrixFromRawSampler(boneSampler,matricesIndices[0])*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[1])*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[2])*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[3])*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[0])*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[1])*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[2])*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[3])*matricesWeightsExtra[3];
#endif
#else
influence=mBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=mBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=mBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=mBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=mBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=mBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=mBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=mBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
#endif
finalWorld=finalWorld*influence;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$320368658d08a66f$var$name] = $320368658d08a66f$var$shader;
const $320368658d08a66f$export$e7045d19c7a271ba = {
    name: $320368658d08a66f$var$name,
    shader: $320368658d08a66f$var$shader
};

});

parcelRegister("cIweX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $94229a5aab918704$var$name = "bakedVertexAnimation";
const $94229a5aab918704$var$shader = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
{
#ifdef INSTANCES
#define BVASNAME bakedVertexAnimationSettingsInstanced
#else
#define BVASNAME bakedVertexAnimationSettings
#endif
float VATStartFrame=BVASNAME.x;float VATEndFrame=BVASNAME.y;float VATOffsetFrame=BVASNAME.z;float VATSpeed=BVASNAME.w;float totalFrames=VATEndFrame-VATStartFrame+1.0;float time=bakedVertexAnimationTime*VATSpeed/totalFrames;float frameCorrection=time<1.0 ? 0.0 : 1.0;float numOfFrames=totalFrames-frameCorrection;float VATFrameNum=fract(time)*numOfFrames;VATFrameNum=mod(VATFrameNum+VATOffsetFrame,numOfFrames);VATFrameNum=floor(VATFrameNum);VATFrameNum+=VATStartFrame+frameCorrection;mat4 VATInfluence;VATInfluence=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[0],VATFrameNum)*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[1],VATFrameNum)*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[2],VATFrameNum)*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[3],VATFrameNum)*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[0],VATFrameNum)*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[1],VATFrameNum)*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[2],VATFrameNum)*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[3],VATFrameNum)*matricesWeightsExtra[3];
#endif
finalWorld=finalWorld*VATInfluence;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$94229a5aab918704$var$name] = $94229a5aab918704$var$shader;
const $94229a5aab918704$export$ea1166af1e79822a = {
    name: $94229a5aab918704$var$name,
    shader: $94229a5aab918704$var$shader
};

});

parcelRegister("f7nPp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b019fe3f67f05961$var$name = "prePassVertex";
const $b019fe3f67f05961$var$shader = `#ifdef PREPASS_DEPTH
vViewPos=(view*worldPos).rgb;
#endif
#ifdef PREPASS_LOCAL_POSITION
vPosition=positionUpdated.xyz;
#endif
#if (defined(PREPASS_VELOCITY) || defined(PREPASS_VELOCITY_LINEAR)) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*worldPos;
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif 
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif 
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif 
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif 
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif 
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$b019fe3f67f05961$var$name] = $b019fe3f67f05961$var$shader;
const $b019fe3f67f05961$export$66ea9e487dae2e8b = {
    name: $b019fe3f67f05961$var$name,
    shader: $b019fe3f67f05961$var$shader
};

});

parcelRegister("i4Zbf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d2980ede809e2f06$var$name = "uvVariableDeclaration";
const $d2980ede809e2f06$var$shader = `#if !defined(UV{X}) && defined(MAINUV{X})
vec2 uv{X}=vec2(0.,0.);
#endif
#ifdef MAINUV{X}
vMainUV{X}=uv{X};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d2980ede809e2f06$var$name] = $d2980ede809e2f06$var$shader;
const $d2980ede809e2f06$export$868e2ac23cbabdec = {
    name: $d2980ede809e2f06$var$name,
    shader: $d2980ede809e2f06$var$shader
};

});

parcelRegister("9N2ej", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $720a6b71b0e07637$var$name = "samplerVertexImplementation";
const $720a6b71b0e07637$var$shader = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
if (v_INFONAME_==0.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uvUpdated,1.0,0.0));}
#ifdef UV2
else if (v_INFONAME_==1.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv2Updated,1.0,0.0));}
#endif
#ifdef UV3
else if (v_INFONAME_==2.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv3,1.0,0.0));}
#endif
#ifdef UV4
else if (v_INFONAME_==3.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv4,1.0,0.0));}
#endif
#ifdef UV5
else if (v_INFONAME_==4.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv5,1.0,0.0));}
#endif
#ifdef UV6
else if (v_INFONAME_==5.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv6,1.0,0.0));}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$720a6b71b0e07637$var$name] = $720a6b71b0e07637$var$shader;
const $720a6b71b0e07637$export$f5166e5920e55738 = {
    name: $720a6b71b0e07637$var$name,
    shader: $720a6b71b0e07637$var$shader
};

});

parcelRegister("4GjUR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $368a8896fba5b04e$var$name = "bumpVertex";
const $368a8896fba5b04e$var$shader = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
vec3 tbnNormal=normalize(normalUpdated);vec3 tbnTangent=normalize(tangentUpdated.xyz);vec3 tbnBitangent=cross(tbnNormal,tbnTangent)*tangentUpdated.w;vTBN=mat3(finalWorld)*mat3(tbnTangent,tbnBitangent,tbnNormal);
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$368a8896fba5b04e$var$name] = $368a8896fba5b04e$var$shader;
const $368a8896fba5b04e$export$71c60d5bee6037f3 = {
    name: $368a8896fba5b04e$var$name,
    shader: $368a8896fba5b04e$var$shader
};

});

parcelRegister("kqCfW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $edf3e934e04c583c$var$name = "clipPlaneVertex";
const $edf3e934e04c583c$var$shader = `#ifdef CLIPPLANE
fClipDistance=dot(worldPos,vClipPlane);
#endif
#ifdef CLIPPLANE2
fClipDistance2=dot(worldPos,vClipPlane2);
#endif
#ifdef CLIPPLANE3
fClipDistance3=dot(worldPos,vClipPlane3);
#endif
#ifdef CLIPPLANE4
fClipDistance4=dot(worldPos,vClipPlane4);
#endif
#ifdef CLIPPLANE5
fClipDistance5=dot(worldPos,vClipPlane5);
#endif
#ifdef CLIPPLANE6
fClipDistance6=dot(worldPos,vClipPlane6);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$edf3e934e04c583c$var$name] = $edf3e934e04c583c$var$shader;
const $edf3e934e04c583c$export$c701d17f7fcd46e7 = {
    name: $edf3e934e04c583c$var$name,
    shader: $edf3e934e04c583c$var$shader
};

});

parcelRegister("1pV7g", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $10846e4e5aac614e$var$name = "fogVertex";
const $10846e4e5aac614e$var$shader = `#ifdef FOG
vFogDistance=(view*worldPos).xyz;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$10846e4e5aac614e$var$name] = $10846e4e5aac614e$var$shader;
const $10846e4e5aac614e$export$e9ea39cff335dceb = {
    name: $10846e4e5aac614e$var$name,
    shader: $10846e4e5aac614e$var$shader
};

});

parcelRegister("5sP5F", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3fa732ca74cf0e3d$var$name = "shadowsVertex";
const $3fa732ca74cf0e3d$var$shader = `#ifdef SHADOWS
#if defined(SHADOWCSM{X})
vPositionFromCamera{X}=view*worldPos;for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) {vPositionFromLight{X}[i]=lightMatrix{X}[i]*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}[i]=(-vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}[i]=(vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
}
#elif defined(SHADOW{X}) && !defined(SHADOWCUBE{X})
vPositionFromLight{X}=lightMatrix{X}*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}=(-vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}=(vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3fa732ca74cf0e3d$var$name] = $3fa732ca74cf0e3d$var$shader;
const $3fa732ca74cf0e3d$export$c21d1499746c24a1 = {
    name: $3fa732ca74cf0e3d$var$name,
    shader: $3fa732ca74cf0e3d$var$shader
};

});

parcelRegister("jl3r6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e142a4cea4626059$var$name = "vertexColorMixing";
const $e142a4cea4626059$var$shader = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
vColor=vec4(1.0);
#ifdef VERTEXCOLOR
#ifdef VERTEXALPHA
vColor*=color;
#else
vColor.rgb*=color.rgb;
#endif
#endif
#ifdef INSTANCESCOLOR
vColor*=instanceColor;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e142a4cea4626059$var$name] = $e142a4cea4626059$var$shader;
const $e142a4cea4626059$export$6deafe11f2c8fd78 = {
    name: $e142a4cea4626059$var$name,
    shader: $e142a4cea4626059$var$shader
};

});

parcelRegister("2NtPW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $20974d57ca4b1987$var$name = "pointCloudVertex";
const $20974d57ca4b1987$var$shader = `#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$20974d57ca4b1987$var$name] = $20974d57ca4b1987$var$shader;
const $20974d57ca4b1987$export$1987bee044ebe2eb = {
    name: $20974d57ca4b1987$var$name,
    shader: $20974d57ca4b1987$var$shader
};

});

parcelRegister("a111f", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $74aac9c067b83b9c$var$name = "logDepthVertex";
const $74aac9c067b83b9c$var$shader = `#ifdef LOGARITHMICDEPTH
vFragmentDepth=1.0+gl_Position.w;gl_Position.z=log2(max(0.000001,vFragmentDepth))*logarithmicDepthConstant;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$74aac9c067b83b9c$var$name] = $74aac9c067b83b9c$var$shader;
const $74aac9c067b83b9c$export$d165856bf33dc3a5 = {
    name: $74aac9c067b83b9c$var$name,
    shader: $74aac9c067b83b9c$var$shader
};

});


parcelRegister("5rZFU", function(module, exports) {

$parcel$export(module.exports, "defaultPixelShader", () => $3f7f50b7f7e4e635$export$cc7b573577d674e6);
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("53H4c");
parcelRequire("dcSpY");
parcelRequire("aYEjM");
parcelRequire("7RpqZ");
parcelRequire("5lMLg");
parcelRequire("7Hs3g");
parcelRequire("7UkOz");
parcelRequire("gi9Sf");
parcelRequire("eFnxQ");
parcelRequire("lcI5C");
parcelRequire("b4ZX6");
parcelRequire("6zQZ5");
parcelRequire("6vG1y");
parcelRequire("jtwq6");
parcelRequire("cRFSM");
parcelRequire("lnIOB");
parcelRequire("2KL02");
parcelRequire("82O8L");
parcelRequire("4kipo");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("F4hvB");
parcelRequire("lP7hO");
parcelRequire("6bTUi");
parcelRequire("4ycgE");
parcelRequire("izyqw");
parcelRequire("110hr");
parcelRequire("b21vU");
const $3f7f50b7f7e4e635$var$name = "defaultPixelShader";
const $3f7f50b7f7e4e635$var$shader = `#define CUSTOM_FRAGMENT_EXTENSION
#include<__decl__defaultFragment>
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
#include<prePassDeclaration>[SCENE_MRT_COUNT]
#include<oitDeclaration>
#define CUSTOM_FRAGMENT_BEGIN
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<mainUVVaryingDeclaration>[1..7]
#include<helperFunctions>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<samplerFragmentDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_SAMPLERNAME_,diffuse)
#include<samplerFragmentDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_SAMPLERNAME_,ambient)
#include<samplerFragmentDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_SAMPLERNAME_,opacity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_SAMPLERNAME_,emissive)
#include<samplerFragmentDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_SAMPLERNAME_,lightmap)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_SAMPLERNAME_,decal)
#ifdef REFRACTION
#ifdef REFRACTIONMAP_3D
uniform samplerCube refractionCubeSampler;
#else
uniform sampler2D refraction2DSampler;
#endif
#endif
#if defined(SPECULARTERM)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_SAMPLERNAME_,specular)
#endif
#include<fresnelFunction>
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
uniform samplerCube reflectionCubeSampler;
#else
uniform sampler2D reflection2DSampler;
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#include<reflectionFunction>
#endif
#include<imageProcessingDeclaration>
#include<imageProcessingFunctions>
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);vec4 baseColor=vec4(1.,1.,1.,1.);vec3 diffuseColor=vDiffuseColor.rgb;float alpha=vDiffuseColor.a;
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=normalize(-cross(dFdx(vPositionW),dFdy(vPositionW)));
#endif
#include<bumpFragment>
#ifdef TWOSIDEDLIGHTING
normalW=gl_FrontFacing ? normalW : -normalW;
#endif
#ifdef DIFFUSE
baseColor=texture2D(diffuseSampler,vDiffuseUV+uvOffset);
#if defined(ALPHATEST) && !defined(ALPHATEST_AFTERALLALPHACOMPUTATIONS)
if (baseColor.a<alphaCutOff)
discard;
#endif
#ifdef ALPHAFROMDIFFUSE
alpha*=baseColor.a;
#endif
#define CUSTOM_FRAGMENT_UPDATE_ALPHA
baseColor.rgb*=vDiffuseInfos.y;
#endif
#if defined(DECAL) && !defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#include<depthPrePass>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
baseColor.rgb*=vColor.rgb;
#endif
#ifdef DETAIL
baseColor.rgb=baseColor.rgb*2.0*mix(0.5,detailColor.r,vDetailInfos.y);
#endif
#if defined(DECAL) && defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#define CUSTOM_FRAGMENT_UPDATE_DIFFUSE
vec3 baseAmbientColor=vec3(1.,1.,1.);
#ifdef AMBIENT
baseAmbientColor=texture2D(ambientSampler,vAmbientUV+uvOffset).rgb*vAmbientInfos.y;
#endif
#define CUSTOM_FRAGMENT_BEFORE_LIGHTS
float glossiness=vSpecularColor.a;vec3 specularColor=vSpecularColor.rgb;
#ifdef SPECULARTERM
#ifdef SPECULAR
vec4 specularMapColor=texture2D(specularSampler,vSpecularUV+uvOffset);specularColor=specularMapColor.rgb;
#ifdef GLOSSINESS
glossiness=glossiness*specularMapColor.a;
#endif
#endif
#endif
vec3 diffuseBase=vec3(0.,0.,0.);lightingInfo info;
#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);
#endif
float shadow=1.;float aggShadow=0.;float numLights=0.;
#ifdef LIGHTMAP
vec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);
#ifdef RGBDLIGHTMAP
lightmapColor.rgb=fromRGBD(lightmapColor);
#endif
lightmapColor.rgb*=vLightmapInfos.y;
#endif
#include<lightFragment>[0..maxSimultaneousLights]
aggShadow=aggShadow/numLights;vec4 refractionColor=vec4(0.,0.,0.,1.);
#ifdef REFRACTION
vec3 refractionVector=normalize(refract(-viewDirectionW,normalW,vRefractionInfos.y));
#ifdef REFRACTIONMAP_3D
#ifdef USE_LOCAL_REFRACTIONMAP_CUBIC
refractionVector=parallaxCorrectNormal(vPositionW,refractionVector,vRefractionSize,vRefractionPosition);
#endif
refractionVector.y=refractionVector.y*vRefractionInfos.w;vec4 refractionLookup=textureCube(refractionCubeSampler,refractionVector);if (dot(refractionVector,viewDirectionW)<1.0) {refractionColor=refractionLookup;}
#else
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*vRefractionInfos.z,1.0)));vec2 refractionCoords=vRefractionUVW.xy/vRefractionUVW.z;refractionCoords.y=1.0-refractionCoords.y;refractionColor=texture2D(refraction2DSampler,refractionCoords);
#endif
#ifdef RGBDREFRACTION
refractionColor.rgb=fromRGBD(refractionColor);
#endif
#ifdef IS_REFRACTION_LINEAR
refractionColor.rgb=toGammaSpace(refractionColor.rgb);
#endif
refractionColor.rgb*=vRefractionInfos.x;
#endif
vec4 reflectionColor=vec4(0.,0.,0.,1.);
#ifdef REFLECTION
vec3 vReflectionUVW=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
vReflectionUVW.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
#ifdef ROUGHNESS
float bias=vReflectionInfos.y;
#ifdef SPECULARTERM
#ifdef SPECULAR
#ifdef GLOSSINESS
bias*=(1.0-specularMapColor.a);
#endif
#endif
#endif
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW,bias);
#else
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW);
#endif
#else
vec2 coords=vReflectionUVW.xy;
#ifdef REFLECTIONMAP_PROJECTION
coords/=vReflectionUVW.z;
#endif
coords.y=1.0-coords.y;reflectionColor=texture2D(reflection2DSampler,coords);
#endif
#ifdef RGBDREFLECTION
reflectionColor.rgb=fromRGBD(reflectionColor);
#endif
#ifdef IS_REFLECTION_LINEAR
reflectionColor.rgb=toGammaSpace(reflectionColor.rgb);
#endif
reflectionColor.rgb*=vReflectionInfos.x;
#ifdef REFLECTIONFRESNEL
float reflectionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,reflectionRightColor.a,reflectionLeftColor.a);
#ifdef REFLECTIONFRESNELFROMSPECULAR
#ifdef SPECULARTERM
reflectionColor.rgb*=specularColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#endif
#endif
#ifdef REFRACTIONFRESNEL
float refractionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,refractionRightColor.a,refractionLeftColor.a);refractionColor.rgb*=refractionLeftColor.rgb*(1.0-refractionFresnelTerm)+refractionFresnelTerm*refractionRightColor.rgb;
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vOpacityUV+uvOffset);
#ifdef OPACITYRGB
opacityMap.rgb=opacityMap.rgb*vec3(0.3,0.59,0.11);alpha*=(opacityMap.x+opacityMap.y+opacityMap.z)* vOpacityInfos.y;
#else
alpha*=opacityMap.a*vOpacityInfos.y;
#endif
#endif
#if defined(VERTEXALPHA) || defined(INSTANCESCOLOR) && defined(INSTANCES)
alpha*=vColor.a;
#endif
#ifdef OPACITYFRESNEL
float opacityFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,opacityParts.z,opacityParts.w);alpha+=opacityParts.x*(1.0-opacityFresnelTerm)+opacityFresnelTerm*opacityParts.y;
#endif
#ifdef ALPHATEST
#ifdef ALPHATEST_AFTERALLALPHACOMPUTATIONS
if (alpha<alphaCutOff)
discard;
#endif
#ifndef ALPHABLEND
alpha=1.0;
#endif
#endif
vec3 emissiveColor=vEmissiveColor;
#ifdef EMISSIVE
emissiveColor+=texture2D(emissiveSampler,vEmissiveUV+uvOffset).rgb*vEmissiveInfos.y;
#endif
#ifdef EMISSIVEFRESNEL
float emissiveFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,emissiveRightColor.a,emissiveLeftColor.a);emissiveColor*=emissiveLeftColor.rgb*(1.0-emissiveFresnelTerm)+emissiveFresnelTerm*emissiveRightColor.rgb;
#endif
#ifdef DIFFUSEFRESNEL
float diffuseFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,diffuseRightColor.a,diffuseLeftColor.a);diffuseBase*=diffuseLeftColor.rgb*(1.0-diffuseFresnelTerm)+diffuseFresnelTerm*diffuseRightColor.rgb;
#endif
#ifdef EMISSIVEASILLUMINATION
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
#ifdef LINKEMISSIVEWITHDIFFUSE
vec3 finalDiffuse=clamp((diffuseBase+emissiveColor)*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+emissiveColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#endif
#endif
#ifdef SPECULARTERM
vec3 finalSpecular=specularBase*specularColor;
#ifdef SPECULAROVERALPHA
alpha=clamp(alpha+dot(finalSpecular,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#else
vec3 finalSpecular=vec3(0.0);
#endif
#ifdef REFLECTIONOVERALPHA
alpha=clamp(alpha+dot(reflectionColor.rgb,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#ifdef EMISSIVEASILLUMINATION
vec4 color=vec4(clamp(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+emissiveColor+refractionColor.rgb,0.0,1.0),alpha);
#else
vec4 color=vec4(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+refractionColor.rgb,alpha);
#endif
#ifdef LIGHTMAP
#ifndef LIGHTMAPEXCLUDED
#ifdef USELIGHTMAPASSHADOWMAP
color.rgb*=lightmapColor.rgb;
#else
color.rgb+=lightmapColor.rgb;
#endif
#endif
#endif
#define CUSTOM_FRAGMENT_BEFORE_FOG
color.rgb=max(color.rgb,0.);
#include<logDepthFragment>
#include<fogFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
color.rgb=toLinearSpace(color.rgb);
#else
#ifdef IMAGEPROCESSING
color.rgb=toLinearSpace(color.rgb);color=applyImageProcessing(color);
#endif
#endif
color.a*=visibility;
#ifdef PREMULTIPLYALPHA
color.rgb*=color.a;
#endif
#define CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR
#ifdef PREPASS
float writeGeometryInfo=color.a>0.4 ? 1.0 : 0.0;
#ifdef PREPASS_COLOR
gl_FragData[PREPASS_COLOR_INDEX]=color; 
#endif
#ifdef PREPASS_POSITION
gl_FragData[PREPASS_POSITION_INDEX]=vec4(vPositionW,writeGeometryInfo);
#endif
#ifdef PREPASS_LOCAL_POSITION
gl_FragData[PREPASS_LOCAL_POSITION_INDEX]=vec4(vPosition,writeGeometryInfo);
#endif
#if defined(PREPASS_VELOCITY)
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[PREPASS_VELOCITY_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#elif defined(PREPASS_VELOCITY_LINEAR)
vec2 velocity=vec2(0.5)*((vPreviousPosition.xy/vPreviousPosition.w)-(vCurrentPosition.xy/vCurrentPosition.w));gl_FragData[PREPASS_VELOCITY_LINEAR_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_IRRADIANCE
gl_FragData[PREPASS_IRRADIANCE_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_DEPTH
gl_FragData[PREPASS_DEPTH_INDEX]=vec4(vViewPos.z,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_SCREENSPACE_DEPTH
gl_FragData[PREPASS_SCREENSPACE_DEPTH_INDEX]=vec4(gl_FragCoord.z,0.0,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_NORMAL
#ifdef PREPASS_NORMAL_WORLDSPACE
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalW,writeGeometryInfo);
#else
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalize((view*vec4(normalW,0.0)).rgb),writeGeometryInfo);
#endif
#endif
#ifdef PREPASS_WORLD_NORMAL
gl_FragData[PREPASS_WORLD_NORMAL_INDEX]=vec4(normalW*0.5+0.5,writeGeometryInfo);
#endif
#ifdef PREPASS_ALBEDO
gl_FragData[PREPASS_ALBEDO_INDEX]=vec4(baseColor.rgb,writeGeometryInfo);
#endif
#ifdef PREPASS_ALBEDO_SQRT
gl_FragData[PREPASS_ALBEDO_SQRT_INDEX]=vec4(sqrt(baseColor.rgb),writeGeometryInfo);
#endif
#ifdef PREPASS_REFLECTIVITY
#if defined(SPECULAR)
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularMapColor))*writeGeometryInfo; 
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularColor),1.0)*writeGeometryInfo;
#endif
#endif
#endif
#if !defined(PREPASS) || defined(WEBGL2)
gl_FragColor=color;
#endif
#include<oitFragment>
#if ORDER_INDEPENDENT_TRANSPARENCY
if (fragDepth==nearestDepth) {frontColor.rgb+=color.rgb*color.a*alphaMultiplier;frontColor.a=1.0-alphaMultiplier*(1.0-color.a);} else {backColor+=color;}
#endif
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$3f7f50b7f7e4e635$var$name] = $3f7f50b7f7e4e635$var$shader;
const $3f7f50b7f7e4e635$export$cc7b573577d674e6 = {
    name: $3f7f50b7f7e4e635$var$name,
    shader: $3f7f50b7f7e4e635$var$shader
};

});
parcelRegister("53H4c", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("hbX2w");
const $3aeea3b541097fa2$var$name = "defaultFragmentDeclaration";
const $3aeea3b541097fa2$var$shader = `uniform vec4 vEyePosition;uniform vec4 vDiffuseColor;uniform vec4 vSpecularColor;uniform vec3 vEmissiveColor;uniform vec3 vAmbientColor;uniform float visibility;
#ifdef DIFFUSE
uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY 
uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#ifdef ALPHATEST
uniform float alphaCutOff;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(REFRACTION) || defined(PREPASS)
uniform mat4 view;
#endif
#ifdef REFRACTION
uniform vec4 vRefractionInfos;
#ifndef REFRACTIONMAP_3D
uniform mat4 refractionMatrix;
#endif
#ifdef REFRACTIONFRESNEL
uniform vec4 refractionLeftColor;uniform vec4 refractionRightColor;
#endif
#if defined(USE_LOCAL_REFRACTIONMAP_CUBIC) && defined(REFRACTIONMAP_3D)
uniform vec3 vRefractionPosition;uniform vec3 vRefractionSize; 
#endif
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;
#endif
#ifdef DIFFUSEFRESNEL
uniform vec4 diffuseLeftColor;uniform vec4 diffuseRightColor;
#endif
#ifdef OPACITYFRESNEL
uniform vec4 opacityParts;
#endif
#ifdef EMISSIVEFRESNEL
uniform vec4 emissiveLeftColor;uniform vec4 emissiveRightColor;
#endif
#if defined(REFLECTION) || (defined(AREALIGHTUSED) && defined(AREALIGHTSUPPORTED))
uniform vec2 vReflectionInfos;
#if defined(REFLECTIONMAP_PLANAR) || defined(REFLECTIONMAP_CUBIC) || defined(REFLECTIONMAP_PROJECTION) || defined(REFLECTIONMAP_EQUIRECTANGULAR) || defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_SKYBOX)
uniform mat4 reflectionMatrix;
#endif
#ifndef REFLECTIONMAP_SKYBOX
#if defined(USE_LOCAL_REFLECTIONMAP_CUBIC) && defined(REFLECTIONMAP_CUBIC)
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize; 
#endif
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 reflectionLeftColor;uniform vec4 reflectionRightColor;
#endif
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;
#endif
#include<decalFragmentDeclaration>
#define ADDITIONAL_FRAGMENT_DECLARATION
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3aeea3b541097fa2$var$name] = $3aeea3b541097fa2$var$shader;
const $3aeea3b541097fa2$export$373cd818a5adc946 = {
    name: $3aeea3b541097fa2$var$name,
    shader: $3aeea3b541097fa2$var$shader
};

});
parcelRegister("hbX2w", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $c84142c6e9b067d3$var$name = "decalFragmentDeclaration";
const $c84142c6e9b067d3$var$shader = `#ifdef DECAL
uniform vec4 vDecalInfos;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c84142c6e9b067d3$var$name] = $c84142c6e9b067d3$var$shader;
const $c84142c6e9b067d3$export$6af07c32231b6bd1 = {
    name: $c84142c6e9b067d3$var$name,
    shader: $c84142c6e9b067d3$var$shader
};

});


parcelRegister("aYEjM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7fdec849d6454f7a$var$name = "prePassDeclaration";
const $7fdec849d6454f7a$var$shader = `#ifdef PREPASS
#extension GL_EXT_draw_buffers : require
layout(location=0) out highp vec4 glFragData[{X}];highp vec4 gl_FragColor;
#ifdef PREPASS_LOCAL_POSITION
varying highp vec3 vPosition;
#endif
#ifdef PREPASS_DEPTH
varying highp vec3 vViewPos;
#endif
#if defined(PREPASS_VELOCITY) || defined(PREPASS_VELOCITY_LINEAR)
varying highp vec4 vCurrentPosition;varying highp vec4 vPreviousPosition;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7fdec849d6454f7a$var$name] = $7fdec849d6454f7a$var$shader;
const $7fdec849d6454f7a$export$f53a51f7ec35381 = {
    name: $7fdec849d6454f7a$var$name,
    shader: $7fdec849d6454f7a$var$shader
};

});

parcelRegister("7RpqZ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5b91365b765d37d0$var$name = "oitDeclaration";
const $5b91365b765d37d0$var$shader = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
#extension GL_EXT_draw_buffers : require
layout(location=0) out vec2 depth; 
layout(location=1) out vec4 frontColor;layout(location=2) out vec4 backColor;
#define MAX_DEPTH 99999.0
highp vec4 gl_FragColor;uniform sampler2D oitDepthSampler;uniform sampler2D oitFrontColorSampler;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5b91365b765d37d0$var$name] = $5b91365b765d37d0$var$shader;
const $5b91365b765d37d0$export$a68b3050a640b11a = {
    name: $5b91365b765d37d0$var$name,
    shader: $5b91365b765d37d0$var$shader
};

});

parcelRegister("7UkOz", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5c1de8bf6014eee5$var$name = "lightFragmentDeclaration";
const $5c1de8bf6014eee5$var$shader = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowTexture{X};uniform highp sampler2DArray depthTexture{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowTexture{X};
#else
uniform highp sampler2DArray shadowTexture{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowTexture{X};
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowTexture{X};uniform highp sampler2D depthTexture{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowTexture{X};
#else
uniform sampler2D shadowTexture{X};
#endif
uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#ifdef AREALIGHT{X}
uniform vec4 vLightWidth{X};uniform vec4 vLightHeight{X};
#endif
#ifdef IESLIGHTTEXTURE{X}
uniform sampler2D iesLightTexture{X};
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightTexture{X};
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5c1de8bf6014eee5$var$name] = $5c1de8bf6014eee5$var$shader;
const $5c1de8bf6014eee5$export$9bfdb41ce338dd35 = {
    name: $5c1de8bf6014eee5$var$name,
    shader: $5c1de8bf6014eee5$var$shader
};

});

parcelRegister("gi9Sf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $030f9496d337dbf4$var$name = "lightUboDeclaration";
const $030f9496d337dbf4$var$shader = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
#if defined(AREALIGHT{X})
vec4 vLightWidth;vec4 vLightHeight;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef IESLIGHTTEXTURE{X}
uniform sampler2D iesLightTexture{X};
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightTexture{X};
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowTexture{X};uniform highp sampler2DArray depthTexture{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowTexture{X};
#else
uniform highp sampler2DArray shadowTexture{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowTexture{X}; 
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowTexture{X};uniform highp sampler2D depthTexture{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowTexture{X};
#else
uniform sampler2D shadowTexture{X};
#endif
uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$030f9496d337dbf4$var$name] = $030f9496d337dbf4$var$shader;
const $030f9496d337dbf4$export$a5838adc27ee95d9 = {
    name: $030f9496d337dbf4$var$name,
    shader: $030f9496d337dbf4$var$shader
};

});

parcelRegister("eFnxQ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("93Hof");
const $aad728922284e6d6$var$name = "lightsFragmentFunctions";
const $aad728922284e6d6$var$shader = `struct lightingInfo
{vec3 diffuse;
#ifdef SPECULARTERM
vec3 specular;
#endif
#ifdef NDOTL
float ndl;
#endif
};lightingInfo computeLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 lightVectorW;float attenuation=1.0;if (lightData.w==0.)
{vec3 direction=lightData.xyz-vPositionW;attenuation=max(0.,1.0-length(direction)/range);lightVectorW=normalize(direction);}
else
{lightVectorW=normalize(-lightData.xyz);}
float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
float getAttenuation(float cosAngle,float exponent) {return max(0.,pow(cosAngle,exponent));}
float getIESAttenuation(float cosAngle,sampler2D iesLightSampler) {float angle=acos(cosAngle)/PI;return texture2D(iesLightSampler,vec2(angle,0.)).r;}
lightingInfo basicSpotLighting(vec3 viewDirectionW,vec3 lightVectorW,vec3 vNormal,float attenuation,vec3 diffuseColor,vec3 specularColor,float glossiness) {lightingInfo result; 
float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
lightingInfo computeIESSpotLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec4 lightDirection,vec3 diffuseColor,vec3 specularColor,float range,float glossiness,sampler2D iesLightSampler) { 
vec3 direction=lightData.xyz-vPositionW;vec3 lightVectorW=normalize(direction);float attenuation=max(0.,1.0-length(direction)/range);float dotProduct=dot(lightDirection.xyz,-lightVectorW);float cosAngle=max(0.,dotProduct);if (cosAngle>=lightDirection.w)
{ 
attenuation*=getIESAttenuation(dotProduct,iesLightSampler);return basicSpotLighting(viewDirectionW,lightVectorW,vNormal,attenuation,diffuseColor,specularColor,glossiness);}
lightingInfo result;result.diffuse=vec3(0.);
#ifdef SPECULARTERM
result.specular=vec3(0.);
#endif
#ifdef NDOTL
result.ndl=0.;
#endif
return result;}
lightingInfo computeSpotLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec4 lightDirection,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {vec3 direction=lightData.xyz-vPositionW;vec3 lightVectorW=normalize(direction);float attenuation=max(0.,1.0-length(direction)/range);float cosAngle=max(0.,dot(lightDirection.xyz,-lightVectorW));if (cosAngle>=lightDirection.w)
{ 
attenuation*=getAttenuation(cosAngle,lightData.w);return basicSpotLighting(viewDirectionW,lightVectorW,vNormal,attenuation,diffuseColor,specularColor,glossiness);}
lightingInfo result;result.diffuse=vec3(0.);
#ifdef SPECULARTERM
result.specular=vec3(0.);
#endif
#ifdef NDOTL
result.ndl=0.;
#endif
return result;}
lightingInfo computeHemisphericLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,vec3 groundColor,float glossiness) {lightingInfo result;float ndl=dot(vNormal,lightData.xyz)*0.5+0.5;
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=mix(groundColor,diffuseColor,ndl);
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightData.xyz);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor;
#endif
return result;}
#define inline
vec3 computeProjectionTextureDiffuseLighting(sampler2D projectionLightSampler,mat4 textureProjectionMatrix,vec3 posW){vec4 strq=textureProjectionMatrix*vec4(posW,1.0);strq/=strq.w;vec3 textureColor=texture2D(projectionLightSampler,strq.xy).rgb;return textureColor;}
#if defined(AREALIGHTUSED) && defined(AREALIGHTSUPPORTED)
#include<ltcHelperFunctions>
uniform sampler2D areaLightsLTC1Sampler;uniform sampler2D areaLightsLTC2Sampler;
#define inline
lightingInfo computeAreaLighting(sampler2D ltc1,sampler2D ltc2,vec3 viewDirectionW,vec3 vNormal,vec3 vPosition,vec3 lightPosition,vec3 halfWidth,vec3 halfHeight,vec3 diffuseColor,vec3 specularColor,float roughness) 
{lightingInfo result;areaLightData data=computeAreaLightSpecularDiffuseFresnel(ltc1,ltc2,viewDirectionW,vNormal,vPosition,lightPosition,halfWidth,halfHeight,roughness);
#ifdef SPECULARTERM
vec3 fresnel=( specularColor*data.Fresnel.x+( vec3( 1.0 )-specularColor )*data.Fresnel.y );result.specular+=specularColor*fresnel*data.Specular;
#endif
result.diffuse+=diffuseColor*data.Diffuse;return result;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$aad728922284e6d6$var$name] = $aad728922284e6d6$var$shader;
const $aad728922284e6d6$export$da90bc947c387180 = {
    name: $aad728922284e6d6$var$name,
    shader: $aad728922284e6d6$var$shader
};

});
parcelRegister("93Hof", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $69860d42b283a3b5$var$name = "ltcHelperFunctions";
const $69860d42b283a3b5$var$shader = `vec2 LTCUv( const in vec3 N,const in vec3 V,const in float roughness ) {const float LUTSIZE=64.0;const float LUTSCALE=( LUTSIZE-1.0 )/LUTSIZE;const float LUTBIAS=0.5/LUTSIZE;float dotNV=saturate( dot( N,V ) );vec2 uv=vec2( roughness,sqrt( 1.0-dotNV ) );uv=uv*LUTSCALE+LUTBIAS;return uv;}
float LTCClippedSphereFormFactor( const in vec3 f ) {float l=length( f );return max( ( l*l+f.z )/( l+1.0 ),0.0 );}
vec3 LTCEdgeVectorFormFactor( const in vec3 v1,const in vec3 v2 ) {float x=dot( v1,v2 );float y=abs( x );float a=0.8543985+( 0.4965155+0.0145206*y )*y;float b=3.4175940+( 4.1616724+y )*y;float v=a/b;float thetaSintheta=0.0;if( x>0.0 )
{thetaSintheta=v;}
else
{thetaSintheta=0.5*inversesqrt( max( 1.0-x*x,1e-7 ) )-v;}
return cross( v1,v2 )*thetaSintheta;}
vec3 LTCEvaluate( const in vec3 N,const in vec3 V,const in vec3 P,const in mat3 mInv,const in vec3 rectCoords[ 4 ] ) {vec3 v1=rectCoords[ 1 ]-rectCoords[ 0 ];vec3 v2=rectCoords[ 3 ]-rectCoords[ 0 ];vec3 lightNormal=cross( v1,v2 );if( dot( lightNormal,P-rectCoords[ 0 ] )<0.0 ) return vec3( 0.0 );vec3 T1,T2;T1=normalize( V-N*dot( V,N ) );T2=- cross( N,T1 ); 
mat3 mat=mInv*transposeMat3( mat3( T1,T2,N ) );vec3 coords[ 4 ];coords[ 0 ]=mat*( rectCoords[ 0 ]-P );coords[ 1 ]=mat*( rectCoords[ 1 ]-P );coords[ 2 ]=mat*( rectCoords[ 2 ]-P );coords[ 3 ]=mat*( rectCoords[ 3 ]-P );coords[ 0 ]=normalize( coords[ 0 ] );coords[ 1 ]=normalize( coords[ 1 ] );coords[ 2 ]=normalize( coords[ 2 ] );coords[ 3 ]=normalize( coords[ 3 ] );vec3 vectorFormFactor=vec3( 0.0 );vectorFormFactor+=LTCEdgeVectorFormFactor( coords[ 0 ],coords[ 1 ] );vectorFormFactor+=LTCEdgeVectorFormFactor( coords[ 1 ],coords[ 2 ] );vectorFormFactor+=LTCEdgeVectorFormFactor( coords[ 2 ],coords[ 3 ] );vectorFormFactor+=LTCEdgeVectorFormFactor( coords[ 3 ],coords[ 0 ] );float result=LTCClippedSphereFormFactor( vectorFormFactor );return vec3( result );}
struct areaLightData
{vec3 Diffuse;vec3 Specular;vec4 Fresnel;};
#define inline
areaLightData computeAreaLightSpecularDiffuseFresnel(const in sampler2D ltc1,const in sampler2D ltc2,const in vec3 viewDir,const in vec3 normal,const in vec3 position,const in vec3 lightPos,const in vec3 halfWidth,const in vec3 halfHeight,const in float roughness) 
{areaLightData result;vec3 rectCoords[ 4 ];rectCoords[ 0 ]=lightPos+halfWidth-halfHeight; 
rectCoords[ 1 ]=lightPos-halfWidth-halfHeight;rectCoords[ 2 ]=lightPos-halfWidth+halfHeight;rectCoords[ 3 ]=lightPos+halfWidth+halfHeight;
#ifdef SPECULARTERM
vec2 uv=LTCUv( normal,viewDir,roughness );vec4 t1=texture2D( ltc1,uv );vec4 t2=texture2D( ltc2,uv );mat3 mInv=mat3(
vec3( t1.x,0,t1.y ),
vec3( 0,1, 0 ),
vec3( t1.z,0,t1.w )
);result.Specular=LTCEvaluate( normal,viewDir,position,mInv,rectCoords );result.Fresnel=t2;
#endif
result.Diffuse=LTCEvaluate( normal,viewDir,position,mat3( 1.0 ),rectCoords );return result;}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$69860d42b283a3b5$var$name] = $69860d42b283a3b5$var$shader;
const $69860d42b283a3b5$export$edd3fca5cf509726 = {
    name: $69860d42b283a3b5$var$name,
    shader: $69860d42b283a3b5$var$shader
};

});


parcelRegister("lcI5C", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f6fceb41179b2191$var$name = "shadowsFragmentFunctions";
const $f6fceb41179b2191$var$shader = `#ifdef SHADOWS
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
#ifndef SHADOWFLOAT
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}
#endif
float computeFallOff(float value,vec2 clipSpace,float frustumEdgeFalloff)
{float mask=smoothstep(1.0-frustumEdgeFalloff,1.00000012,clamp(dot(clipSpace,clipSpace),0.,1.));return mix(value,1.0,mask);}
#define inline
float computeShadowCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float darkness,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadow=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadow=textureCube(shadowSampler,directionToLight).x;
#endif
return depth>shadow ? darkness : 1.0;}
#define inline
float computeShadowWithPoissonSamplingCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float mapSize,float darkness,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;float visibility=1.;vec3 poissonDisk[4];poissonDisk[0]=vec3(-1.0,1.0,-1.0);poissonDisk[1]=vec3(1.0,-1.0,-1.0);poissonDisk[2]=vec3(-1.0,-1.0,-1.0);poissonDisk[3]=vec3(1.0,-1.0,1.0);
#ifndef SHADOWFLOAT
if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize))<depth) visibility-=0.25;
#else
if (textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize).x<depth) visibility-=0.25;
#endif
return min(1.0,visibility+darkness);}
#define inline
float computeShadowWithESMCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness);return esm;}
#define inline
float computeShadowWithCloseESMCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return esm;}
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define inline
float computeShadowCSM(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);vec3 uvLayer=vec3(uv.x,uv.y,layer);float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(texture2D(shadowSampler,uvLayer));
#else
float shadow=texture2D(shadowSampler,uvLayer).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}
#endif
#define inline
float computeShadow(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadow=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}}
#define inline
float computeShadowWithPoissonSampling(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float mapSize,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);float visibility=1.;vec2 poissonDisk[4];poissonDisk[0]=vec2(-0.94201624,-0.39906216);poissonDisk[1]=vec2(0.94558609,-0.76890725);poissonDisk[2]=vec2(-0.094184101,-0.92938870);poissonDisk[3]=vec2(0.34495938,0.29387760);
#ifndef SHADOWFLOAT
if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;
#else
if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;
#endif
return computeFallOff(min(1.0,visibility+darkness),clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithCloseESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0); 
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#ifdef IS_NDC_HALF_ZRANGE
#define ZINCLIP clipSpace.z
#else
#define ZINCLIP uvDepth.z
#endif
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define GREATEST_LESS_THAN_ONE 0.99999994
#define DISABLE_UNIFORMITY_ANALYSIS
#define inline
float computeShadowWithCSMPCF1(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float shadow=texture2D(shadowSampler,uvDepthLayer);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF3(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF5(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw2.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow+=uvw2.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[1]),layer,uvDepth.z));shadow+=uvw0.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[2]),layer,uvDepth.z));shadow+=uvw1.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[2]),layer,uvDepth.z));shadow+=uvw2.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[2]),layer,uvDepth.z));shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithPCF1(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float shadow=TEXTUREFUNC(shadowSampler,uvDepth,0.);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF3(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF5(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw2.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow+=uvw2.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[1]),uvDepth.z),0.);shadow+=uvw0.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[2]),uvDepth.z),0.);shadow+=uvw1.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[2]),uvDepth.z),0.);shadow+=uvw2.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[2]),uvDepth.z),0.);shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
const vec3 PoissonSamplers32[64]=vec3[64](
vec3(0.06407013,0.05409927,0.),
vec3(0.7366577,0.5789394,0.),
vec3(-0.6270542,-0.5320278,0.),
vec3(-0.4096107,0.8411095,0.),
vec3(0.6849564,-0.4990818,0.),
vec3(-0.874181,-0.04579735,0.),
vec3(0.9989998,0.0009880066,0.),
vec3(-0.004920578,-0.9151649,0.),
vec3(0.1805763,0.9747483,0.),
vec3(-0.2138451,0.2635818,0.),
vec3(0.109845,0.3884785,0.),
vec3(0.06876755,-0.3581074,0.),
vec3(0.374073,-0.7661266,0.),
vec3(0.3079132,-0.1216763,0.),
vec3(-0.3794335,-0.8271583,0.),
vec3(-0.203878,-0.07715034,0.),
vec3(0.5912697,0.1469799,0.),
vec3(-0.88069,0.3031784,0.),
vec3(0.5040108,0.8283722,0.),
vec3(-0.5844124,0.5494877,0.),
vec3(0.6017799,-0.1726654,0.),
vec3(-0.5554981,0.1559997,0.),
vec3(-0.3016369,-0.3900928,0.),
vec3(-0.5550632,-0.1723762,0.),
vec3(0.925029,0.2995041,0.),
vec3(-0.2473137,0.5538505,0.),
vec3(0.9183037,-0.2862392,0.),
vec3(0.2469421,0.6718712,0.),
vec3(0.3916397,-0.4328209,0.),
vec3(-0.03576927,-0.6220032,0.),
vec3(-0.04661255,0.7995201,0.),
vec3(0.4402924,0.3640312,0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.)
);const vec3 PoissonSamplers64[64]=vec3[64](
vec3(-0.613392,0.617481,0.),
vec3(0.170019,-0.040254,0.),
vec3(-0.299417,0.791925,0.),
vec3(0.645680,0.493210,0.),
vec3(-0.651784,0.717887,0.),
vec3(0.421003,0.027070,0.),
vec3(-0.817194,-0.271096,0.),
vec3(-0.705374,-0.668203,0.),
vec3(0.977050,-0.108615,0.),
vec3(0.063326,0.142369,0.),
vec3(0.203528,0.214331,0.),
vec3(-0.667531,0.326090,0.),
vec3(-0.098422,-0.295755,0.),
vec3(-0.885922,0.215369,0.),
vec3(0.566637,0.605213,0.),
vec3(0.039766,-0.396100,0.),
vec3(0.751946,0.453352,0.),
vec3(0.078707,-0.715323,0.),
vec3(-0.075838,-0.529344,0.),
vec3(0.724479,-0.580798,0.),
vec3(0.222999,-0.215125,0.),
vec3(-0.467574,-0.405438,0.),
vec3(-0.248268,-0.814753,0.),
vec3(0.354411,-0.887570,0.),
vec3(0.175817,0.382366,0.),
vec3(0.487472,-0.063082,0.),
vec3(-0.084078,0.898312,0.),
vec3(0.488876,-0.783441,0.),
vec3(0.470016,0.217933,0.),
vec3(-0.696890,-0.549791,0.),
vec3(-0.149693,0.605762,0.),
vec3(0.034211,0.979980,0.),
vec3(0.503098,-0.308878,0.),
vec3(-0.016205,-0.872921,0.),
vec3(0.385784,-0.393902,0.),
vec3(-0.146886,-0.859249,0.),
vec3(0.643361,0.164098,0.),
vec3(0.634388,-0.049471,0.),
vec3(-0.688894,0.007843,0.),
vec3(0.464034,-0.188818,0.),
vec3(-0.440840,0.137486,0.),
vec3(0.364483,0.511704,0.),
vec3(0.034028,0.325968,0.),
vec3(0.099094,-0.308023,0.),
vec3(0.693960,-0.366253,0.),
vec3(0.678884,-0.204688,0.),
vec3(0.001801,0.780328,0.),
vec3(0.145177,-0.898984,0.),
vec3(0.062655,-0.611866,0.),
vec3(0.315226,-0.604297,0.),
vec3(-0.780145,0.486251,0.),
vec3(-0.371868,0.882138,0.),
vec3(0.200476,0.494430,0.),
vec3(-0.494552,-0.711051,0.),
vec3(0.612476,0.705252,0.),
vec3(-0.578845,-0.768792,0.),
vec3(-0.772454,-0.090976,0.),
vec3(0.504440,0.372295,0.),
vec3(0.155736,0.065157,0.),
vec3(0.391522,0.849605,0.),
vec3(-0.620106,-0.328104,0.),
vec3(0.789239,-0.419965,0.),
vec3(-0.545396,0.538133,0.),
vec3(-0.178564,-0.596057,0.)
);
#define inline
float computeShadowWithCSMPCSS(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=texture2D(depthSampler,vec3(uvDepth.xy+(lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse*PoissonSamplers32[i].xy),layer)).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)*depthCorrection+AAOffset);vec4 filterRadius=vec4(penumbraRatio*lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse,0.,0.);float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec4 offset=vec4(poissonSamplers[i],0.);offset=vec4(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.,0.);shadow+=texture2D(shadowSampler,uvDepthLayer+offset*filterRadius);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,min((depthMetric-avgBlockerDepth)*depthCorrection*penumbraDarkness,1.));shadow=mix(darkness,1.,shadow);if (numBlocker<1.0) {return 1.0;}
else
{return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCSS(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=TEXTUREFUNC(depthSampler,uvDepth.xy+(lightSizeUV*shadowMapSizeInverse*PoissonSamplers32[i].xy),0.).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
if (numBlocker<1.0) {return 1.0;}
else
{float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)+AAOffset);float filterRadius=penumbraRatio*lightSizeUV*shadowMapSizeInverse;float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec3 offset=poissonSamplers[i];offset=vec3(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.);shadow+=TEXTUREFUNC(shadowSampler,uvDepth+offset*filterRadius,0.);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,depthMetric-avgBlockerDepth);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}}
#define inline
float computeShadowWithPCSS16(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS32(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS64(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64);}
#define inline
float computeShadowWithCSMPCSS16(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS32(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS64(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$f6fceb41179b2191$var$name] = $f6fceb41179b2191$var$shader;
const $f6fceb41179b2191$export$65c03943b6a4e3c4 = {
    name: $f6fceb41179b2191$var$name,
    shader: $f6fceb41179b2191$var$shader
};

});

parcelRegister("b4ZX6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $81101fda09a52120$var$name = "samplerFragmentDeclaration";
const $81101fda09a52120$var$shader = `#ifdef _DEFINENAME_
#if _DEFINENAME_DIRECTUV==1
#define v_VARYINGNAME_UV vMainUV1
#elif _DEFINENAME_DIRECTUV==2
#define v_VARYINGNAME_UV vMainUV2
#elif _DEFINENAME_DIRECTUV==3
#define v_VARYINGNAME_UV vMainUV3
#elif _DEFINENAME_DIRECTUV==4
#define v_VARYINGNAME_UV vMainUV4
#elif _DEFINENAME_DIRECTUV==5
#define v_VARYINGNAME_UV vMainUV5
#elif _DEFINENAME_DIRECTUV==6
#define v_VARYINGNAME_UV vMainUV6
#else
varying vec2 v_VARYINGNAME_UV;
#endif
uniform sampler2D _SAMPLERNAME_Sampler;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$81101fda09a52120$var$name] = $81101fda09a52120$var$shader;
const $81101fda09a52120$export$8b4ee44f0f64e626 = {
    name: $81101fda09a52120$var$name,
    shader: $81101fda09a52120$var$shader
};

});

parcelRegister("6zQZ5", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4c9f1c8df46ed1c8$var$name = "fresnelFunction";
const $4c9f1c8df46ed1c8$var$shader = `#ifdef FRESNEL
float computeFresnelTerm(vec3 viewDirection,vec3 worldNormal,float bias,float power)
{float fresnelTerm=pow(bias+abs(dot(viewDirection,worldNormal)),power);return clamp(fresnelTerm,0.,1.);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$4c9f1c8df46ed1c8$var$name] = $4c9f1c8df46ed1c8$var$shader;
const $4c9f1c8df46ed1c8$export$e2a0701410c42cbf = {
    name: $4c9f1c8df46ed1c8$var$name,
    shader: $4c9f1c8df46ed1c8$var$shader
};

});

parcelRegister("6vG1y", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4bd63c684de26b99$var$name = "reflectionFunction";
const $4bd63c684de26b99$var$shader = `vec3 computeFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0); }
vec3 computeMirroredFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(1.0-s,t,0); }
vec3 computeEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 cameraToVertex=normalize(worldPos.xyz-eyePosition);vec3 r=normalize(reflect(cameraToVertex,worldNormal));r=vec3(reflectionMatrix*vec4(r,0));float lon=atan(r.z,r.x);float lat=acos(r.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0);}
vec3 computeSphericalCoords(vec4 worldPos,vec3 worldNormal,mat4 view,mat4 reflectionMatrix)
{vec3 viewDir=normalize(vec3(view*worldPos));vec3 viewNormal=normalize(vec3(view*vec4(worldNormal,0.0)));vec3 r=reflect(viewDir,viewNormal);r=vec3(reflectionMatrix*vec4(r,0));r.z=r.z-1.0;float m=2.0*length(r);return vec3(r.x/m+0.5,1.0-r.y/m-0.5,0);}
vec3 computePlanarCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=worldPos.xyz-eyePosition;vec3 coords=normalize(reflect(viewDir,worldNormal));return vec3(reflectionMatrix*vec4(coords,1));}
vec3 computeCubicCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeCubicLocalCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix,vec3 reflectionSize,vec3 reflectionPosition)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=parallaxCorrectNormal(worldPos.xyz,coords,reflectionSize,reflectionPosition);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeProjectionCoords(vec4 worldPos,mat4 view,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*(view*worldPos));}
vec3 computeSkyBoxCoords(vec3 positionW,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*vec4(positionW,1.));}
#ifdef REFLECTION
vec3 computeReflectionCoords(vec4 worldPos,vec3 worldNormal)
{
#ifdef REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeMirroredFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR
return computeEquirectangularCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SPHERICAL
return computeSphericalCoords(worldPos,worldNormal,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_PLANAR
return computePlanarCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_CUBIC
#ifdef USE_LOCAL_REFLECTIONMAP_CUBIC
return computeCubicLocalCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix,vReflectionSize,vReflectionPosition);
#else
return computeCubicCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#endif
#ifdef REFLECTIONMAP_PROJECTION
return computeProjectionCoords(worldPos,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SKYBOX
return computeSkyBoxCoords(vPositionUVW,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_EXPLICIT
return vec3(0,0,0);
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$4bd63c684de26b99$var$name] = $4bd63c684de26b99$var$shader;
const $4bd63c684de26b99$export$83a38c4d3ad33c8 = {
    name: $4bd63c684de26b99$var$name,
    shader: $4bd63c684de26b99$var$shader
};

});

parcelRegister("jtwq6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e2d9dfb14971d2a5$var$name = "imageProcessingDeclaration";
const $e2d9dfb14971d2a5$var$shader = `#ifdef EXPOSURE
uniform float exposureLinear;
#endif
#ifdef CONTRAST
uniform float contrast;
#endif
#if defined(VIGNETTE) || defined(DITHER)
uniform vec2 vInverseScreenSize;
#endif
#ifdef VIGNETTE
uniform vec4 vignetteSettings1;uniform vec4 vignetteSettings2;
#endif
#ifdef COLORCURVES
uniform vec4 vCameraColorCurveNegative;uniform vec4 vCameraColorCurveNeutral;uniform vec4 vCameraColorCurvePositive;
#endif
#ifdef COLORGRADING
#ifdef COLORGRADING3D
uniform highp sampler3D txColorTransform;
#else
uniform sampler2D txColorTransform;
#endif
uniform vec4 colorTransformSettings;
#endif
#ifdef DITHER
uniform float ditherIntensity;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e2d9dfb14971d2a5$var$name] = $e2d9dfb14971d2a5$var$shader;
const $e2d9dfb14971d2a5$export$ef7bf3c32ad02e4 = {
    name: $e2d9dfb14971d2a5$var$name,
    shader: $e2d9dfb14971d2a5$var$shader
};

});

parcelRegister("cRFSM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $95daec48b0f946d8$var$name = "imageProcessingFunctions";
const $95daec48b0f946d8$var$shader = `#if defined(COLORGRADING) && !defined(COLORGRADING3D)
/** 
* Polyfill for SAMPLE_TEXTURE_3D,which is unsupported in WebGL.
* sampler3dSetting.x=textureOffset (0.5/textureSize).
* sampler3dSetting.y=textureSize.
*/
#define inline
vec3 sampleTexture3D(sampler2D colorTransform,vec3 color,vec2 sampler3dSetting)
{float sliceSize=2.0*sampler3dSetting.x; 
#ifdef SAMPLER3DGREENDEPTH
float sliceContinuous=(color.g-sampler3dSetting.x)*sampler3dSetting.y;
#else
float sliceContinuous=(color.b-sampler3dSetting.x)*sampler3dSetting.y;
#endif
float sliceInteger=floor(sliceContinuous);float sliceFraction=sliceContinuous-sliceInteger;
#ifdef SAMPLER3DGREENDEPTH
vec2 sliceUV=color.rb;
#else
vec2 sliceUV=color.rg;
#endif
sliceUV.x*=sliceSize;sliceUV.x+=sliceInteger*sliceSize;sliceUV=saturate(sliceUV);vec4 slice0Color=texture2D(colorTransform,sliceUV);sliceUV.x+=sliceSize;sliceUV=saturate(sliceUV);vec4 slice1Color=texture2D(colorTransform,sliceUV);vec3 result=mix(slice0Color.rgb,slice1Color.rgb,sliceFraction);
#ifdef SAMPLER3DBGRMAP
color.rgb=result.rgb;
#else
color.rgb=result.bgr;
#endif
return color;}
#endif
#if TONEMAPPING==3
const float PBRNeutralStartCompression=0.8-0.04;const float PBRNeutralDesaturation=0.15;vec3 PBRNeutralToneMapping( vec3 color ) {float x=min(color.r,min(color.g,color.b));float offset=x<0.08 ? x-6.25*x*x : 0.04;color-=offset;float peak=max(color.r,max(color.g,color.b));if (peak<PBRNeutralStartCompression) return color;float d=1.-PBRNeutralStartCompression;float newPeak=1.-d*d/(peak+d-PBRNeutralStartCompression);color*=newPeak/peak;float g=1.-1./(PBRNeutralDesaturation*(peak-newPeak)+1.);return mix(color,newPeak*vec3(1,1,1),g);}
#endif
#if TONEMAPPING==2
const mat3 ACESInputMat=mat3(
vec3(0.59719,0.07600,0.02840),
vec3(0.35458,0.90834,0.13383),
vec3(0.04823,0.01566,0.83777)
);const mat3 ACESOutputMat=mat3(
vec3( 1.60475,-0.10208,-0.00327),
vec3(-0.53108, 1.10813,-0.07276),
vec3(-0.07367,-0.00605, 1.07602)
);vec3 RRTAndODTFit(vec3 v)
{vec3 a=v*(v+0.0245786)-0.000090537;vec3 b=v*(0.983729*v+0.4329510)+0.238081;return a/b;}
vec3 ACESFitted(vec3 color)
{color=ACESInputMat*color;color=RRTAndODTFit(color);color=ACESOutputMat*color;color=saturate(color);return color;}
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_DEFINITIONS
vec4 applyImageProcessing(vec4 result) {
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATSTART
#ifdef EXPOSURE
result.rgb*=exposureLinear;
#endif
#ifdef VIGNETTE
vec2 viewportXY=gl_FragCoord.xy*vInverseScreenSize;viewportXY=viewportXY*2.0-1.0;vec3 vignetteXY1=vec3(viewportXY*vignetteSettings1.xy+vignetteSettings1.zw,1.0);float vignetteTerm=dot(vignetteXY1,vignetteXY1);float vignette=pow(vignetteTerm,vignetteSettings2.w);vec3 vignetteColor=vignetteSettings2.rgb;
#ifdef VIGNETTEBLENDMODEMULTIPLY
vec3 vignetteColorMultiplier=mix(vignetteColor,vec3(1,1,1),vignette);result.rgb*=vignetteColorMultiplier;
#endif
#ifdef VIGNETTEBLENDMODEOPAQUE
result.rgb=mix(vignetteColor,result.rgb,vignette);
#endif
#endif
#if TONEMAPPING==3
result.rgb=PBRNeutralToneMapping(result.rgb);
#elif TONEMAPPING==2
result.rgb=ACESFitted(result.rgb);
#elif TONEMAPPING==1
const float tonemappingCalibration=1.590579;result.rgb=1.0-exp2(-tonemappingCalibration*result.rgb);
#endif
result.rgb=toGammaSpace(result.rgb);result.rgb=saturate(result.rgb);
#ifdef CONTRAST
vec3 resultHighContrast=result.rgb*result.rgb*(3.0-2.0*result.rgb);if (contrast<1.0) {result.rgb=mix(vec3(0.5,0.5,0.5),result.rgb,contrast);} else {result.rgb=mix(result.rgb,resultHighContrast,contrast-1.0);}
#endif
#ifdef COLORGRADING
vec3 colorTransformInput=result.rgb*colorTransformSettings.xxx+colorTransformSettings.yyy;
#ifdef COLORGRADING3D
vec3 colorTransformOutput=texture(txColorTransform,colorTransformInput).rgb;
#else
vec3 colorTransformOutput=sampleTexture3D(txColorTransform,colorTransformInput,colorTransformSettings.yz).rgb;
#endif
result.rgb=mix(result.rgb,colorTransformOutput,colorTransformSettings.www);
#endif
#ifdef COLORCURVES
float luma=getLuminance(result.rgb);vec2 curveMix=clamp(vec2(luma*3.0-1.5,luma*-3.0+1.5),vec2(0.0),vec2(1.0));vec4 colorCurve=vCameraColorCurveNeutral+curveMix.x*vCameraColorCurvePositive-curveMix.y*vCameraColorCurveNegative;result.rgb*=colorCurve.rgb;result.rgb=mix(vec3(luma),result.rgb,colorCurve.a);
#endif
#ifdef DITHER
float rand=getRand(gl_FragCoord.xy*vInverseScreenSize);float dither=mix(-ditherIntensity,ditherIntensity,rand);result.rgb=saturate(result.rgb+vec3(dither));
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATEND
return result;}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$95daec48b0f946d8$var$name] = $95daec48b0f946d8$var$shader;
const $95daec48b0f946d8$export$45e67855eef1d7b7 = {
    name: $95daec48b0f946d8$var$name,
    shader: $95daec48b0f946d8$var$shader
};

});

parcelRegister("lnIOB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f90e8252b460407d$var$name = "bumpFragmentMainFunctions";
const $f90e8252b460407d$var$shader = `#if defined(BUMP) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC) || defined(DETAIL)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#ifdef OBJECTSPACE_NORMALMAP
uniform mat4 normalMatrix;
#if defined(WEBGL2) || defined(WEBGPU)
mat4 toNormalMatrix(mat4 wMatrix)
{mat4 ret=inverse(wMatrix);ret=transpose(ret);ret[0][3]=0.;ret[1][3]=0.;ret[2][3]=0.;ret[3]=vec4(0.,0.,0.,1.);return ret;}
#else
mat4 toNormalMatrix(mat4 m)
{float
a00=m[0][0],a01=m[0][1],a02=m[0][2],a03=m[0][3],
a10=m[1][0],a11=m[1][1],a12=m[1][2],a13=m[1][3],
a20=m[2][0],a21=m[2][1],a22=m[2][2],a23=m[2][3],
a30=m[3][0],a31=m[3][1],a32=m[3][2],a33=m[3][3],
b00=a00*a11-a01*a10,
b01=a00*a12-a02*a10,
b02=a00*a13-a03*a10,
b03=a01*a12-a02*a11,
b04=a01*a13-a03*a11,
b05=a02*a13-a03*a12,
b06=a20*a31-a21*a30,
b07=a20*a32-a22*a30,
b08=a20*a33-a23*a30,
b09=a21*a32-a22*a31,
b10=a21*a33-a23*a31,
b11=a22*a33-a23*a32,
det=b00*b11-b01*b10+b02*b09+b03*b08-b04*b07+b05*b06;mat4 mi=mat4(
a11*b11-a12*b10+a13*b09,
a02*b10-a01*b11-a03*b09,
a31*b05-a32*b04+a33*b03,
a22*b04-a21*b05-a23*b03,
a12*b08-a10*b11-a13*b07,
a00*b11-a02*b08+a03*b07,
a32*b02-a30*b05-a33*b01,
a20*b05-a22*b02+a23*b01,
a10*b10-a11*b08+a13*b06,
a01*b08-a00*b10-a03*b06,
a30*b04-a31*b02+a33*b00,
a21*b02-a20*b04-a23*b00,
a11*b07-a10*b09-a12*b06,
a00*b09-a01*b07+a02*b06,
a31*b01-a30*b03-a32*b00,
a20*b03-a21*b01+a22*b00)/det;return mat4(mi[0][0],mi[1][0],mi[2][0],mi[3][0],
mi[0][1],mi[1][1],mi[2][1],mi[3][1],
mi[0][2],mi[1][2],mi[2][2],mi[3][2],
mi[0][3],mi[1][3],mi[2][3],mi[3][3]);}
#endif
#endif
vec3 perturbNormalBase(mat3 cotangentFrame,vec3 normal,float scale)
{
#ifdef NORMALXYSCALE
normal=normalize(normal*vec3(scale,scale,1.0));
#endif
return normalize(cotangentFrame*normal);}
vec3 perturbNormal(mat3 cotangentFrame,vec3 textureSample,float scale)
{return perturbNormalBase(cotangentFrame,textureSample*2.0-1.0,scale);}
mat3 cotangent_frame(vec3 normal,vec3 p,vec2 uv,vec2 tangentSpaceParams)
{vec3 dp1=dFdx(p);vec3 dp2=dFdy(p);vec2 duv1=dFdx(uv);vec2 duv2=dFdy(uv);vec3 dp2perp=cross(dp2,normal);vec3 dp1perp=cross(normal,dp1);vec3 tangent=dp2perp*duv1.x+dp1perp*duv2.x;vec3 bitangent=dp2perp*duv1.y+dp1perp*duv2.y;tangent*=tangentSpaceParams.x;bitangent*=tangentSpaceParams.y;float det=max(dot(tangent,tangent),dot(bitangent,bitangent));float invmax=det==0.0 ? 0.0 : inversesqrt(det);return mat3(tangent*invmax,bitangent*invmax,normal);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$f90e8252b460407d$var$name] = $f90e8252b460407d$var$shader;
const $f90e8252b460407d$export$627d4672083e63a1 = {
    name: $f90e8252b460407d$var$name,
    shader: $f90e8252b460407d$var$shader
};

});

parcelRegister("2KL02", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("b4ZX6");
const $201455cce0aad236$var$name = "bumpFragmentFunctions";
const $201455cce0aad236$var$shader = `#if defined(BUMP)
#include<samplerFragmentDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_SAMPLERNAME_,bump)
#endif
#if defined(DETAIL)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_SAMPLERNAME_,detail)
#endif
#if defined(BUMP) && defined(PARALLAX)
const float minSamples=4.;const float maxSamples=15.;const int iMaxSamples=15;vec2 parallaxOcclusion(vec3 vViewDirCoT,vec3 vNormalCoT,vec2 texCoord,float parallaxScale) {float parallaxLimit=length(vViewDirCoT.xy)/vViewDirCoT.z;parallaxLimit*=parallaxScale;vec2 vOffsetDir=normalize(vViewDirCoT.xy);vec2 vMaxOffset=vOffsetDir*parallaxLimit;float numSamples=maxSamples+(dot(vViewDirCoT,vNormalCoT)*(minSamples-maxSamples));float stepSize=1.0/numSamples;float currRayHeight=1.0;vec2 vCurrOffset=vec2(0,0);vec2 vLastOffset=vec2(0,0);float lastSampledHeight=1.0;float currSampledHeight=1.0;bool keepWorking=true;for (int i=0; i<iMaxSamples; i++)
{currSampledHeight=texture2D(bumpSampler,texCoord+vCurrOffset).w;if (!keepWorking)
{}
else if (currSampledHeight>currRayHeight)
{float delta1=currSampledHeight-currRayHeight;float delta2=(currRayHeight+stepSize)-lastSampledHeight;float ratio=delta1/(delta1+delta2);vCurrOffset=(ratio)* vLastOffset+(1.0-ratio)*vCurrOffset;keepWorking=false;}
else
{currRayHeight-=stepSize;vLastOffset=vCurrOffset;
#ifdef PARALLAX_RHS
vCurrOffset-=stepSize*vMaxOffset;
#else
vCurrOffset+=stepSize*vMaxOffset;
#endif
lastSampledHeight=currSampledHeight;}}
return vCurrOffset;}
vec2 parallaxOffset(vec3 viewDir,float heightScale)
{float height=texture2D(bumpSampler,vBumpUV).w;vec2 texCoordOffset=heightScale*viewDir.xy*height;
#ifdef PARALLAX_RHS
return texCoordOffset;
#else
return -texCoordOffset;
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$201455cce0aad236$var$name] = $201455cce0aad236$var$shader;
const $201455cce0aad236$export$66987c692cc9b754 = {
    name: $201455cce0aad236$var$name,
    shader: $201455cce0aad236$var$shader
};

});

parcelRegister("82O8L", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5db56776664de2cf$var$name = "clipPlaneFragmentDeclaration";
const $5db56776664de2cf$var$shader = `#ifdef CLIPPLANE
varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
varying float fClipDistance6;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5db56776664de2cf$var$name] = $5db56776664de2cf$var$shader;
const $5db56776664de2cf$export$a7ada6d6747eac28 = {
    name: $5db56776664de2cf$var$name,
    shader: $5db56776664de2cf$var$shader
};

});

parcelRegister("hvLF9", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $cbfa4db95c1c73de$var$name = "fogFragmentDeclaration";
const $cbfa4db95c1c73de$var$shader = `#ifdef FOG
#define FOGMODE_NONE 0.
#define FOGMODE_EXP 1.
#define FOGMODE_EXP2 2.
#define FOGMODE_LINEAR 3.
#define E 2.71828
uniform vec4 vFogInfos;uniform vec3 vFogColor;varying vec3 vFogDistance;float CalcFogFactor()
{float fogCoeff=1.0;float fogStart=vFogInfos.y;float fogEnd=vFogInfos.z;float fogDensity=vFogInfos.w;float fogDistance=length(vFogDistance);if (FOGMODE_LINEAR==vFogInfos.x)
{fogCoeff=(fogEnd-fogDistance)/(fogEnd-fogStart);}
else if (FOGMODE_EXP==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDensity);}
else if (FOGMODE_EXP2==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDistance*fogDensity*fogDensity);}
return clamp(fogCoeff,0.0,1.0);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$cbfa4db95c1c73de$var$name] = $cbfa4db95c1c73de$var$shader;
const $cbfa4db95c1c73de$export$c129e0757f70bb62 = {
    name: $cbfa4db95c1c73de$var$name,
    shader: $cbfa4db95c1c73de$var$shader
};

});

parcelRegister("kg1CD", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ebf68f61df8100fb$var$name = "clipPlaneFragment";
const $ebf68f61df8100fb$var$shader = `#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
if (false) {}
#endif
#ifdef CLIPPLANE
else if (fClipDistance>0.0)
{discard;}
#endif
#ifdef CLIPPLANE2
else if (fClipDistance2>0.0)
{discard;}
#endif
#ifdef CLIPPLANE3
else if (fClipDistance3>0.0)
{discard;}
#endif
#ifdef CLIPPLANE4
else if (fClipDistance4>0.0)
{discard;}
#endif
#ifdef CLIPPLANE5
else if (fClipDistance5>0.0)
{discard;}
#endif
#ifdef CLIPPLANE6
else if (fClipDistance6>0.0)
{discard;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ebf68f61df8100fb$var$name] = $ebf68f61df8100fb$var$shader;
const $ebf68f61df8100fb$export$6a64aed91bad4543 = {
    name: $ebf68f61df8100fb$var$name,
    shader: $ebf68f61df8100fb$var$shader
};

});

parcelRegister("F4hvB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $07b726a5a0c28fda$var$name = "bumpFragment";
const $07b726a5a0c28fda$var$shader = `vec2 uvOffset=vec2(0.0,0.0);
#if defined(BUMP) || defined(PARALLAX) || defined(DETAIL)
#ifdef NORMALXYSCALE
float normalScale=1.0;
#elif defined(BUMP)
float normalScale=vBumpInfos.y;
#else
float normalScale=1.0;
#endif
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#elif defined(BUMP)
vec2 TBNUV=gl_FrontFacing ? vBumpUV : -vBumpUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vTangentSpaceParams);
#else
vec2 TBNUV=gl_FrontFacing ? vDetailUV : -vDetailUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vec2(1.,1.));
#endif
#elif defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#else
vec2 TBNUV=gl_FrontFacing ? vMainUV1 : -vMainUV1;mat3 TBN=cotangent_frame(normalW,vPositionW,TBNUV,vec2(1.,1.));
#endif
#endif
#ifdef PARALLAX
mat3 invTBN=transposeMat3(TBN);
#ifdef PARALLAXOCCLUSION
uvOffset=parallaxOcclusion(invTBN*-viewDirectionW,invTBN*normalW,vBumpUV,vBumpInfos.z);
#else
uvOffset=parallaxOffset(invTBN*viewDirectionW,vBumpInfos.z);
#endif
#endif
#ifdef DETAIL
vec4 detailColor=texture2D(detailSampler,vDetailUV+uvOffset);vec2 detailNormalRG=detailColor.wy*2.0-1.0;float detailNormalB=sqrt(1.-saturate(dot(detailNormalRG,detailNormalRG)));vec3 detailNormal=vec3(detailNormalRG,detailNormalB);
#endif
#ifdef BUMP
#ifdef OBJECTSPACE_NORMALMAP
#define CUSTOM_FRAGMENT_BUMP_FRAGMENT
normalW=normalize(texture2D(bumpSampler,vBumpUV).xyz *2.0-1.0);normalW=normalize(mat3(normalMatrix)*normalW);
#elif !defined(DETAIL)
normalW=perturbNormal(TBN,texture2D(bumpSampler,vBumpUV+uvOffset).xyz,vBumpInfos.y);
#else
vec3 bumpNormal=texture2D(bumpSampler,vBumpUV+uvOffset).xyz*2.0-1.0;
#if DETAIL_NORMALBLENDMETHOD==0 
detailNormal.xy*=vDetailInfos.z;vec3 blendedNormal=normalize(vec3(bumpNormal.xy+detailNormal.xy,bumpNormal.z*detailNormal.z));
#elif DETAIL_NORMALBLENDMETHOD==1 
detailNormal.xy*=vDetailInfos.z;bumpNormal+=vec3(0.0,0.0,1.0);detailNormal*=vec3(-1.0,-1.0,1.0);vec3 blendedNormal=bumpNormal*dot(bumpNormal,detailNormal)/bumpNormal.z-detailNormal;
#endif
normalW=perturbNormalBase(TBN,blendedNormal,vBumpInfos.y);
#endif
#elif defined(DETAIL)
detailNormal.xy*=vDetailInfos.z;normalW=perturbNormalBase(TBN,detailNormal,vDetailInfos.z);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$07b726a5a0c28fda$var$name] = $07b726a5a0c28fda$var$shader;
const $07b726a5a0c28fda$export$88c28ea974c27396 = {
    name: $07b726a5a0c28fda$var$name,
    shader: $07b726a5a0c28fda$var$shader
};

});

parcelRegister("lP7hO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fe34034d7922ea34$var$name = "decalFragment";
const $fe34034d7922ea34$var$shader = `#ifdef DECAL
#ifdef GAMMADECAL
decalColor.rgb=toLinearSpace(decalColor.rgb);
#endif
#ifdef DECAL_SMOOTHALPHA
decalColor.a*=decalColor.a;
#endif
surfaceAlbedo.rgb=mix(surfaceAlbedo.rgb,decalColor.rgb,decalColor.a);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$fe34034d7922ea34$var$name] = $fe34034d7922ea34$var$shader;
const $fe34034d7922ea34$export$f8be594596399f23 = {
    name: $fe34034d7922ea34$var$name,
    shader: $fe34034d7922ea34$var$shader
};

});

parcelRegister("6bTUi", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $481f23229197b00f$var$name = "depthPrePass";
const $481f23229197b00f$var$shader = `#ifdef DEPTHPREPASS
gl_FragColor=vec4(0.,0.,0.,1.0);return;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$481f23229197b00f$var$name] = $481f23229197b00f$var$shader;
const $481f23229197b00f$export$48196b5a939e97d = {
    name: $481f23229197b00f$var$name,
    shader: $481f23229197b00f$var$shader
};

});

parcelRegister("4ycgE", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3503da7f5b0d2323$var$name = "lightFragment";
const $3503da7f5b0d2323$var$shader = `#ifdef LIGHT{X}
#if defined(SHADOWONLY) || defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X}) && defined(LIGHTMAPNOSPECULAR{X})
#else
vec4 diffuse{X}=light{X}.vLightDiffuse;
#define CUSTOM_LIGHT{X}_COLOR 
#ifdef PBR
#ifdef SPOTLIGHT{X}
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW,vPositionW);
#elif defined(POINTLIGHT{X})
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW,vPositionW);
#elif defined(HEMILIGHT{X})
preInfo=computeHemisphericPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(DIRLIGHT{X})
preInfo=computeDirectionalPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(AREALIGHT{X}) && defined(AREALIGHTSUPPORTED)
preInfo=computeAreaPreLightingInfo(areaLightsLTC1Sampler,areaLightsLTC2Sampler,viewDirectionW,normalW,vPositionW,light{X}.vLightData,light{X}.vLightWidth.xyz,light{X}.vLightHeight.xyz,roughness);
#endif
preInfo.NdotV=NdotV;
#ifdef SPOTLIGHT{X}
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);
#ifdef IESLIGHTTEXTURE{X}
preInfo.attenuation*=computeDirectionalLightFalloff_IES(light{X}.vLightDirection.xyz,preInfo.L,iesLightTexture{X});
#else
preInfo.attenuation*=computeDirectionalLightFalloff_GLTF(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#endif
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#ifdef IESLIGHTTEXTURE{X}
preInfo.attenuation*=computeDirectionalLightFalloff_IES(light{X}.vLightDirection.xyz,preInfo.L,iesLightTexture{X});
#else
preInfo.attenuation*=computeDirectionalLightFalloff_Physical(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w);
#endif
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);
#ifdef IESLIGHTTEXTURE{X}
preInfo.attenuation*=computeDirectionalLightFalloff_IES(light{X}.vLightDirection.xyz,preInfo.L,iesLightTexture{X});
#else
preInfo.attenuation*=computeDirectionalLightFalloff_Standard(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w);
#endif
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);
#ifdef IESLIGHTTEXTURE{X}
preInfo.attenuation*=computeDirectionalLightFalloff_IES(light{X}.vLightDirection.xyz,preInfo.L,iesLightTexture{X});
#else
preInfo.attenuation*=computeDirectionalLightFalloff(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#endif 
#endif
#elif defined(POINTLIGHT{X})
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);
#endif
#else
preInfo.attenuation=1.0;
#endif
#if defined(HEMILIGHT{X}) || defined(AREALIGHT{X})
preInfo.roughness=roughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(roughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#ifdef IRIDESCENCE
preInfo.iridescenceIntensity=iridescenceIntensity;
#endif
#ifdef HEMILIGHT{X}
info.diffuse=computeHemisphericDiffuseLighting(preInfo,diffuse{X}.rgb,light{X}.vLightGround);
#elif defined(AREALIGHT{X})
info.diffuse=computeAreaDiffuseLighting(preInfo,diffuse{X}.rgb);
#elif defined(SS_TRANSLUCENCY)
info.diffuse=computeDiffuseAndTransmittedLighting(preInfo,diffuse{X}.rgb,subSurfaceOut.transmittance);
#else
info.diffuse=computeDiffuseLighting(preInfo,diffuse{X}.rgb);
#endif
#ifdef SPECULARTERM
#if AREALIGHT{X}
info.specular=computeAreaSpecularLighting(preInfo,light{X}.vLightSpecular.rgb);
#else
#ifdef ANISOTROPIC
info.specular=computeAnisotropicSpecularLighting(preInfo,viewDirectionW,normalW,anisotropicOut.anisotropicTangent,anisotropicOut.anisotropicBitangent,anisotropicOut.anisotropy,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,diffuse{X}.rgb);
#else
info.specular=computeSpecularLighting(preInfo,normalW,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,diffuse{X}.rgb);
#endif
#endif
#endif
#ifndef AREALIGHT{X}
#ifdef SHEEN
#ifdef SHEEN_LINKWITHALBEDO
preInfo.roughness=sheenOut.sheenIntensity;
#else
#ifdef HEMILIGHT{X}
preInfo.roughness=sheenOut.sheenRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(sheenOut.sheenRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#endif
info.sheen=computeSheenLighting(preInfo,normalW,sheenOut.sheenColor,specularEnvironmentR90,AARoughnessFactors.x,diffuse{X}.rgb);
#endif
#ifdef CLEARCOAT
#ifdef HEMILIGHT{X}
preInfo.roughness=clearcoatOut.clearCoatRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(clearcoatOut.clearCoatRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
info.clearCoat=computeClearCoatLighting(preInfo,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatAARoughnessFactors.x,clearcoatOut.clearCoatIntensity,diffuse{X}.rgb);
#ifdef CLEARCOAT_TINT
absorption=computeClearCoatLightingAbsorption(clearcoatOut.clearCoatNdotVRefract,preInfo.L,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatColor,clearcoatOut.clearCoatThickness,clearcoatOut.clearCoatIntensity);info.diffuse*=absorption;
#ifdef SPECULARTERM
info.specular*=absorption;
#endif
#endif
info.diffuse*=info.clearCoat.w;
#ifdef SPECULARTERM
info.specular*=info.clearCoat.w;
#endif
#ifdef SHEEN
info.sheen*=info.clearCoat.w;
#endif
#endif
#endif
#else
#ifdef SPOTLIGHT{X}
#ifdef IESLIGHTTEXTURE{X}
info=computeIESSpotLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDirection,diffuse{X}.rgb,light{X}.vLightSpecular.rgb,diffuse{X}.a,glossiness,iesLightTexture{X});
#else
info=computeSpotLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDirection,diffuse{X}.rgb,light{X}.vLightSpecular.rgb,diffuse{X}.a,glossiness);
#endif
#elif defined(HEMILIGHT{X})
info=computeHemisphericLighting(viewDirectionW,normalW,light{X}.vLightData,diffuse{X}.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightGround,glossiness);
#elif defined(POINTLIGHT{X}) || defined(DIRLIGHT{X})
info=computeLighting(viewDirectionW,normalW,light{X}.vLightData,diffuse{X}.rgb,light{X}.vLightSpecular.rgb,diffuse{X}.a,glossiness);
#elif defined(AREALIGHT{X}) && defined(AREALIGHTSUPPORTED)
info=computeAreaLighting(areaLightsLTC1Sampler,areaLightsLTC2Sampler,viewDirectionW,normalW,vPositionW,light{X}.vLightData.xyz,light{X}.vLightWidth.rgb,light{X}.vLightHeight.rgb,diffuse{X}.rgb,light{X}.vLightSpecular.rgb,
#ifdef AREALIGHTNOROUGHTNESS
0.5
#else
vReflectionInfos.y
#endif
);
#endif
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
info.diffuse*=computeProjectionTextureDiffuseLighting(projectionLightTexture{X},textureProjectionMatrix{X},vPositionW);
#endif
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) 
{
#ifdef SHADOWCSM_RIGHTHANDED{X}
diff{X}=viewFrustumZ{X}[i]+vPositionFromCamera{X}.z;
#else
diff{X}=viewFrustumZ{X}[i]-vPositionFromCamera{X}.z;
#endif
if (diff{X}>=0.) {index{X}=i;break;}}
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
if (index{X}>=0)
#endif
{
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
shadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
shadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=vec3(shadow)*vCascadeColorsMultiplier{X}[index{X}];
#endif
#ifndef SHADOWCSMNOBLEND{X}
float frustumLength=frustumLengths{X}[index{X}];float diffRatio=clamp(diff{X}/frustumLength,0.,1.)*cascadeBlendFactor{X};if (index{X}<(SHADOWCSMNUM_CASCADES{X}-1) && diffRatio<1.)
{index{X}+=1;float nextShadow=0.;
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
nextShadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
nextShadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
nextShadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
shadow=mix(nextShadow,shadow,diffRatio);
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=mix(vec3(nextShadow)*vCascadeColorsMultiplier{X}[index{X}],shadowDebug{X},diffRatio);
#endif
}
#endif
}
#elif defined(SHADOWCLOSEESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithCloseESMCube(vPositionW,light{X}.vLightData.xyz,shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithCloseESM(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithESMCube(vPositionW,light{X}.vLightData.xyz,shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithESM(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPOISSON{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithPoissonSamplingCube(vPositionW,light{X}.vLightData.xyz,shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadowWithPoissonSampling(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCF1(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCF3(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCF5(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCSS16(vPositionFromLight{X},vDepthMetric{X},depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCSS32(vPositionFromLight{X},vDepthMetric{X},depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCSS64(vPositionFromLight{X},vDepthMetric{X},depthTexture{X},shadowTexture{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#else
#if defined(SHADOWCUBE{X})
shadow=computeShadowCube(vPositionW,light{X}.vLightData.xyz,shadowTexture{X},light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadow(vPositionFromLight{X},vDepthMetric{X},shadowTexture{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#endif
#ifdef SHADOWONLY
#ifndef SHADOWINUSE
#define SHADOWINUSE
#endif
globalShadow+=shadow;shadowLightCount+=1.0;
#endif
#else
shadow=1.;
#endif
aggShadow+=shadow;numLights+=1.0;
#ifndef SHADOWONLY
#ifdef CUSTOMUSERLIGHTING
diffuseBase+=computeCustomDiffuseLighting(info,diffuseBase,shadow);
#ifdef SPECULARTERM
specularBase+=computeCustomSpecularLighting(info,specularBase,shadow);
#endif
#elif defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X})
diffuseBase+=lightmapColor.rgb*shadow;
#ifdef SPECULARTERM
#ifndef LIGHTMAPNOSPECULAR{X}
specularBase+=info.specular*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef CLEARCOAT
#ifndef LIGHTMAPNOSPECULAR{X}
clearCoatBase+=info.clearCoat.rgb*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef SHEEN
#ifndef LIGHTMAPNOSPECULAR{X}
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#else
#ifdef SHADOWCSMDEBUG{X}
diffuseBase+=info.diffuse*shadowDebug{X};
#else 
diffuseBase+=info.diffuse*shadow;
#endif
#ifdef SPECULARTERM
specularBase+=info.specular*shadow;
#endif
#ifdef CLEARCOAT
clearCoatBase+=info.clearCoat.rgb*shadow;
#endif
#ifdef SHEEN
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3503da7f5b0d2323$var$name] = $3503da7f5b0d2323$var$shader;
const $3503da7f5b0d2323$export$a6a1062295ac262 = {
    name: $3503da7f5b0d2323$var$name,
    shader: $3503da7f5b0d2323$var$shader
};

});

parcelRegister("izyqw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d8563351d2d0cb76$var$name = "logDepthFragment";
const $d8563351d2d0cb76$var$shader = `#ifdef LOGARITHMICDEPTH
gl_FragDepthEXT=log2(vFragmentDepth)*logarithmicDepthConstant*0.5;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d8563351d2d0cb76$var$name] = $d8563351d2d0cb76$var$shader;
const $d8563351d2d0cb76$export$dee12c5553ea23e = {
    name: $d8563351d2d0cb76$var$name,
    shader: $d8563351d2d0cb76$var$shader
};

});

parcelRegister("110hr", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0bd61a144baa494f$var$name = "fogFragment";
const $0bd61a144baa494f$var$shader = `#ifdef FOG
float fog=CalcFogFactor();
#ifdef PBR
fog=toLinearSpace(fog);
#endif
color.rgb=mix(vFogColor,color.rgb,fog);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$0bd61a144baa494f$var$name] = $0bd61a144baa494f$var$shader;
const $0bd61a144baa494f$export$f800f8f0095c9706 = {
    name: $0bd61a144baa494f$var$name,
    shader: $0bd61a144baa494f$var$shader
};

});

parcelRegister("b21vU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $80810e30c3f42af7$var$name = "oitFragment";
const $80810e30c3f42af7$var$shader = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
float fragDepth=gl_FragCoord.z; 
#ifdef ORDER_INDEPENDENT_TRANSPARENCY_16BITS
uint halfFloat=packHalf2x16(vec2(fragDepth));vec2 full=unpackHalf2x16(halfFloat);fragDepth=full.x;
#endif
ivec2 fragCoord=ivec2(gl_FragCoord.xy);vec2 lastDepth=texelFetch(oitDepthSampler,fragCoord,0).rg;vec4 lastFrontColor=texelFetch(oitFrontColorSampler,fragCoord,0);depth.rg=vec2(-MAX_DEPTH);frontColor=lastFrontColor;backColor=vec4(0.0);
#ifdef USE_REVERSE_DEPTHBUFFER
float furthestDepth=-lastDepth.x;float nearestDepth=lastDepth.y;
#else
float nearestDepth=-lastDepth.x;float furthestDepth=lastDepth.y;
#endif
float alphaMultiplier=1.0-lastFrontColor.a;
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth>nearestDepth || fragDepth<furthestDepth) {
#else
if (fragDepth<nearestDepth || fragDepth>furthestDepth) {
#endif
return;}
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth<nearestDepth && fragDepth>furthestDepth) {
#else
if (fragDepth>nearestDepth && fragDepth<furthestDepth) {
#endif
depth.rg=vec2(-fragDepth,fragDepth);return;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$80810e30c3f42af7$var$name] = $80810e30c3f42af7$var$shader;
const $80810e30c3f42af7$export$4bd6e7789ff39c0e = {
    name: $80810e30c3f42af7$var$name,
    shader: $80810e30c3f42af7$var$shader
};

});


parcelRegister("5YkyR", function(module, exports) {

$parcel$export(module.exports, "Engine", () => $4592815ea2be2bed$export$2c3b404bf3a77a1f);

var $b9e4a = parcelRequire("b9e4a");

var $ejQPp = parcelRequire("ejQPp");

var $2h5JR = parcelRequire("2h5JR");

var $aDymS = parcelRequire("aDymS");

var $koExS = parcelRequire("koExS");

var $kVtWi = parcelRequire("kVtWi");

var $8ClRi = parcelRequire("8ClRi");
parcelRequire("emm58");
parcelRequire("e7NUJ");
parcelRequire("k0sxV");
parcelRequire("7G59J");
parcelRequire("5jUKR");
parcelRequire("4PdZs");
parcelRequire("hX3rq");
parcelRequire("gfE2b");
parcelRequire("ica7E");
parcelRequire("jo5qL");
parcelRequire("j1xyR");
parcelRequire("46dUh");
parcelRequire("3Kog0");
parcelRequire("4e6Mt");
parcelRequire("3l1SY");

var $dUFoQ = parcelRequire("dUFoQ");

var $e7bN3 = parcelRequire("e7bN3");

var $2Fclq = parcelRequire("2Fclq");
parcelRequire("iIwbj");

var $av6Bc = parcelRequire("av6Bc");
class $4592815ea2be2bed$export$2c3b404bf3a77a1f extends (0, $2h5JR.ThinEngine) {
    /**
     * Returns the current npm package of the sdk
     */ // Not mixed with Version for tooling purpose.
    static get NpmPackage() {
        return (0, $dUFoQ.AbstractEngine).NpmPackage;
    }
    /**
     * Returns the current version of the framework
     */ static get Version() {
        return (0, $dUFoQ.AbstractEngine).Version;
    }
    /** Gets the list of created engines */ static get Instances() {
        return (0, $ejQPp.EngineStore).Instances;
    }
    /**
     * Gets the latest created engine
     */ static get LastCreatedEngine() {
        return (0, $ejQPp.EngineStore).LastCreatedEngine;
    }
    /**
     * Gets the latest created scene
     */ static get LastCreatedScene() {
        return (0, $ejQPp.EngineStore).LastCreatedScene;
    }
    /** @internal */ // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Method called to create the default loading screen.
     * This can be overridden in your own app.
     * @param canvas The rendering canvas element
     * @returns The loading screen
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static DefaultLoadingScreenFactory(canvas) {
        return (0, $dUFoQ.AbstractEngine).DefaultLoadingScreenFactory(canvas);
    }
    get _supportsHardwareTextureRescaling() {
        return !!$4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory;
    }
    _measureFps() {
        this._performanceMonitor.sampleFrame();
        this._fps = this._performanceMonitor.averageFPS;
        this._deltaTime = this._performanceMonitor.instantaneousFrameTime || 0;
    }
    /**
     * Gets the performance monitor attached to this engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#engineinstrumentation
     */ get performanceMonitor() {
        return this._performanceMonitor;
    }
    // Events
    /**
     * Creates a new engine
     * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
     * @param antialias defines enable antialiasing (default: false)
     * @param options defines further options to be sent to the getContext() function
     * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
     */ constructor(canvasOrContext, antialias, options, adaptToDeviceRatio = false){
        super(canvasOrContext, antialias, options, adaptToDeviceRatio);
        // Members
        /**
         * If set, will be used to request the next animation frame for the render loop
         */ this.customAnimationFrameRequester = null;
        this._performanceMonitor = new (0, $aDymS.PerformanceMonitor)();
        this._drawCalls = new (0, $2Fclq.PerfCounter)();
        if (!canvasOrContext) return;
        this._features.supportRenderPasses = true;
        options = this._creationOptions;
    }
    _initGLContext() {
        super._initGLContext();
        this._rescalePostProcess = null;
    }
    /**
     * Shared initialization across engines types.
     * @param canvas The canvas associated with this instance of the engine.
     */ _sharedInit(canvas) {
        super._sharedInit(canvas);
        (0, $e7bN3._CommonInit)(this, canvas, this._creationOptions);
    }
    /**
     * Resize an image and returns the image data as an uint8array
     * @param image image to resize
     * @param bufferWidth destination buffer width
     * @param bufferHeight destination buffer height
     * @returns an uint8array containing RGBA values of bufferWidth * bufferHeight size
     */ resizeImageBitmap(image, bufferWidth, bufferHeight) {
        return (0, $e7bN3.ResizeImageBitmap)(this, image, bufferWidth, bufferHeight);
    }
    /**
     * Engine abstraction for loading and creating an image bitmap from a given source string.
     * @param imageSource source to load the image from.
     * @param options An object that sets options for the image's extraction.
     * @returns ImageBitmap
     */ _createImageBitmapFromSource(imageSource, options) {
        return (0, $e7bN3.CreateImageBitmapFromSource)(this, imageSource, options);
    }
    /**
     * Toggle full screen mode
     * @param requestPointerLock defines if a pointer lock should be requested from the user
     */ switchFullscreen(requestPointerLock) {
        if (this.isFullscreen) this.exitFullscreen();
        else this.enterFullscreen(requestPointerLock);
    }
    /**
     * Enters full screen mode
     * @param requestPointerLock defines if a pointer lock should be requested from the user
     */ enterFullscreen(requestPointerLock) {
        if (!this.isFullscreen) {
            this._pointerLockRequested = requestPointerLock;
            if (this._renderingCanvas) (0, $e7bN3.RequestFullscreen)(this._renderingCanvas);
        }
    }
    /**
     * Exits full screen mode
     */ exitFullscreen() {
        if (this.isFullscreen) (0, $e7bN3.ExitFullscreen)();
    }
    /** States */ /**
     * Sets a boolean indicating if the dithering state is enabled or disabled
     * @param value defines the dithering state
     */ setDitheringState(value) {
        if (value) this._gl.enable(this._gl.DITHER);
        else this._gl.disable(this._gl.DITHER);
    }
    /**
     * Sets a boolean indicating if the rasterizer state is enabled or disabled
     * @param value defines the rasterizer state
     */ setRasterizerState(value) {
        if (value) this._gl.disable(this._gl.RASTERIZER_DISCARD);
        else this._gl.enable(this._gl.RASTERIZER_DISCARD);
    }
    /**
     * Directly set the WebGL Viewport
     * @param x defines the x coordinate of the viewport (in screen space)
     * @param y defines the y coordinate of the viewport (in screen space)
     * @param width defines the width of the viewport (in screen space)
     * @param height defines the height of the viewport (in screen space)
     * @returns the current viewport Object (if any) that is being replaced by this call. You can restore this viewport later on to go back to the original state
     */ setDirectViewport(x, y, width, height) {
        const currentViewport = this._cachedViewport;
        this._cachedViewport = null;
        this._viewport(x, y, width, height);
        return currentViewport;
    }
    /**
     * Executes a scissor clear (ie. a clear on a specific portion of the screen)
     * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
     * @param y defines the y-coordinate of the corner of the clear rectangle
     * @param width defines the width of the clear rectangle
     * @param height defines the height of the clear rectangle
     * @param clearColor defines the clear color
     */ scissorClear(x, y, width, height, clearColor) {
        this.enableScissor(x, y, width, height);
        this.clear(clearColor, true, true, true);
        this.disableScissor();
    }
    /**
     * Enable scissor test on a specific rectangle (ie. render will only be executed on a specific portion of the screen)
     * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
     * @param y defines the y-coordinate of the corner of the clear rectangle
     * @param width defines the width of the clear rectangle
     * @param height defines the height of the clear rectangle
     */ enableScissor(x, y, width, height) {
        const gl = this._gl;
        // Change state
        gl.enable(gl.SCISSOR_TEST);
        gl.scissor(x, y, width, height);
    }
    /**
     * Disable previously set scissor test rectangle
     */ disableScissor() {
        const gl = this._gl;
        gl.disable(gl.SCISSOR_TEST);
    }
    /**
     * @internal
     */ _loadFileAsync(url, offlineProvider, useArrayBuffer) {
        return new Promise((resolve, reject)=>{
            this._loadFile(url, (data)=>{
                resolve(data);
            }, undefined, offlineProvider, useArrayBuffer, (request, exception)=>{
                reject(exception);
            });
        });
    }
    /**
     * Gets the source code of the vertex shader associated with a specific webGL program
     * @param program defines the program to use
     * @returns a string containing the source code of the vertex shader associated with the program
     */ getVertexShaderSource(program) {
        const shaders = this._gl.getAttachedShaders(program);
        if (!shaders) return null;
        return this._gl.getShaderSource(shaders[0]);
    }
    /**
     * Gets the source code of the fragment shader associated with a specific webGL program
     * @param program defines the program to use
     * @returns a string containing the source code of the fragment shader associated with the program
     */ getFragmentShaderSource(program) {
        const shaders = this._gl.getAttachedShaders(program);
        if (!shaders) return null;
        return this._gl.getShaderSource(shaders[1]);
    }
    /**
     * sets the object from which width and height will be taken from when getting render width and height
     * Will fallback to the gl object
     * @param dimensions the framebuffer width and height that will be used.
     */ set framebufferDimensionsObject(dimensions) {
        this._framebufferDimensionsObject = dimensions;
        if (this._framebufferDimensionsObject) this.onResizeObservable.notifyObservers(this);
    }
    _rebuildBuffers() {
        // Index / Vertex
        for (const scene of this.scenes){
            scene.resetCachedMaterial();
            scene._rebuildGeometries();
        }
        for (const scene of this._virtualScenes){
            scene.resetCachedMaterial();
            scene._rebuildGeometries();
        }
        super._rebuildBuffers();
    }
    /**
     * Get Font size information
     * @param font font name
     * @returns an object containing ascent, height and descent
     */ getFontOffset(font) {
        return (0, $e7bN3.GetFontOffset)(font);
    }
    _cancelFrame() {
        if (this.customAnimationFrameRequester) {
            if (this._frameHandler !== 0) {
                this._frameHandler = 0;
                const { cancelAnimationFrame: cancelAnimationFrame } = this.customAnimationFrameRequester;
                if (cancelAnimationFrame) cancelAnimationFrame(this.customAnimationFrameRequester.requestID);
            }
        } else super._cancelFrame();
    }
    _renderLoop(timestamp) {
        this._processFrame(timestamp);
        // The first condition prevents queuing another frame if we no longer have active render loops (e.g., if
        // `stopRenderLoop` is called mid frame). The second condition prevents queuing another frame if one has
        // already been queued (e.g., if `stopRenderLoop` and `runRenderLoop` is called mid frame).
        if (this._activeRenderLoops.length > 0 && this._frameHandler === 0) {
            if (this.customAnimationFrameRequester) {
                this.customAnimationFrameRequester.requestID = this._queueNewFrame(this.customAnimationFrameRequester.renderFunction || this._boundRenderFunction, this.customAnimationFrameRequester);
                this._frameHandler = this.customAnimationFrameRequester.requestID;
            } else this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
        }
    }
    /**
     * Enters Pointerlock mode
     */ enterPointerlock() {
        if (this._renderingCanvas) (0, $e7bN3.RequestPointerlock)(this._renderingCanvas);
    }
    /**
     * Exits Pointerlock mode
     */ exitPointerlock() {
        (0, $e7bN3.ExitPointerlock)();
    }
    /**
     * Begin a new frame
     */ beginFrame() {
        this._measureFps();
        super.beginFrame();
    }
    _deletePipelineContext(pipelineContext) {
        const webGLPipelineContext = pipelineContext;
        if (webGLPipelineContext && webGLPipelineContext.program) {
            if (webGLPipelineContext.transformFeedback) {
                this.deleteTransformFeedback(webGLPipelineContext.transformFeedback);
                webGLPipelineContext.transformFeedback = null;
            }
        }
        super._deletePipelineContext(pipelineContext);
    }
    createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null) {
        context = context || this._gl;
        this.onBeforeShaderCompilationObservable.notifyObservers(this);
        const program = super.createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings);
        this.onAfterShaderCompilationObservable.notifyObservers(this);
        return program;
    }
    _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings = null) {
        const shaderProgram = context.createProgram();
        pipelineContext.program = shaderProgram;
        if (!shaderProgram) throw new Error("Unable to create program");
        context.attachShader(shaderProgram, vertexShader);
        context.attachShader(shaderProgram, fragmentShader);
        if (this.webGLVersion > 1 && transformFeedbackVaryings) {
            const transformFeedback = this.createTransformFeedback();
            this.bindTransformFeedback(transformFeedback);
            this.setTranformFeedbackVaryings(shaderProgram, transformFeedbackVaryings);
            pipelineContext.transformFeedback = transformFeedback;
        }
        context.linkProgram(shaderProgram);
        if (this.webGLVersion > 1 && transformFeedbackVaryings) this.bindTransformFeedback(null);
        pipelineContext.context = context;
        pipelineContext.vertexShader = vertexShader;
        pipelineContext.fragmentShader = fragmentShader;
        if (!pipelineContext.isParallelCompiled) this._finalizePipelineContext(pipelineContext);
        return shaderProgram;
    }
    /**
     * @internal
     */ _releaseTexture(texture) {
        super._releaseTexture(texture);
    }
    /**
     * @internal
     */ _releaseRenderTargetWrapper(rtWrapper) {
        super._releaseRenderTargetWrapper(rtWrapper);
        // Set output texture of post process to null if the framebuffer has been released/disposed
        this.scenes.forEach((scene)=>{
            scene.postProcesses.forEach((postProcess)=>{
                if (postProcess._outputTexture === rtWrapper) postProcess._outputTexture = null;
            });
            scene.cameras.forEach((camera)=>{
                camera._postProcesses.forEach((postProcess)=>{
                    if (postProcess) {
                        if (postProcess._outputTexture === rtWrapper) postProcess._outputTexture = null;
                    }
                });
            });
        });
    }
    /**
     * @internal
     * Rescales a texture
     * @param source input texture
     * @param destination destination texture
     * @param scene scene to use to render the resize
     * @param internalFormat format to use when resizing
     * @param onComplete callback to be called when resize has completed
     */ _rescaleTexture(source, destination, scene, internalFormat, onComplete) {
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, this._gl.LINEAR);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, this._gl.LINEAR);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_S, this._gl.CLAMP_TO_EDGE);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_T, this._gl.CLAMP_TO_EDGE);
        const rtt = this.createRenderTargetTexture({
            width: destination.width,
            height: destination.height
        }, {
            generateMipMaps: false,
            type: 0,
            samplingMode: 2,
            generateDepthBuffer: false,
            generateStencilBuffer: false
        });
        if (!this._rescalePostProcess && $4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory) this._rescalePostProcess = $4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory(this);
        if (this._rescalePostProcess) {
            this._rescalePostProcess.externalTextureSamplerBinding = true;
            const onCompiled = ()=>{
                this._rescalePostProcess.onApply = function(effect) {
                    effect._bindTexture("textureSampler", source);
                };
                let hostingScene = scene;
                if (!hostingScene) hostingScene = this.scenes[this.scenes.length - 1];
                hostingScene.postProcessManager.directRender([
                    this._rescalePostProcess
                ], rtt, true);
                this._bindTextureDirectly(this._gl.TEXTURE_2D, destination, true);
                this._gl.copyTexImage2D(this._gl.TEXTURE_2D, 0, internalFormat, 0, 0, destination.width, destination.height, 0);
                this.unBindFramebuffer(rtt);
                rtt.dispose();
                if (onComplete) onComplete();
            };
            const effect = this._rescalePostProcess.getEffect();
            if (effect) effect.executeWhenCompiled(onCompiled);
            else this._rescalePostProcess.onEffectCreatedObservable.addOnce((effect)=>{
                effect.executeWhenCompiled(onCompiled);
            });
        }
    }
    /**
     * Wraps an external web gl texture in a Babylon texture.
     * @param texture defines the external texture
     * @param hasMipMaps defines whether the external texture has mip maps (default: false)
     * @param samplingMode defines the sampling mode for the external texture (default: 3)
     * @param width defines the width for the external texture (default: 0)
     * @param height defines the height for the external texture (default: 0)
     * @returns the babylon internal texture
     */ wrapWebGLTexture(texture, hasMipMaps = false, samplingMode = 3, width = 0, height = 0) {
        const hardwareTexture = new (0, $8ClRi.WebGLHardwareTexture)(texture, this._gl);
        const internalTexture = new (0, $b9e4a.InternalTexture)(this, 0 /* InternalTextureSource.Unknown */ , true);
        internalTexture._hardwareTexture = hardwareTexture;
        internalTexture.baseWidth = width;
        internalTexture.baseHeight = height;
        internalTexture.width = width;
        internalTexture.height = height;
        internalTexture.isReady = true;
        internalTexture.useMipMaps = hasMipMaps;
        this.updateTextureSamplingMode(samplingMode, internalTexture);
        return internalTexture;
    }
    /**
     * @internal
     */ _uploadImageToTexture(texture, image, faceIndex = 0, lod = 0) {
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(texture.type);
        const format = this._getInternalFormat(texture.format);
        const internalFormat = this._getRGBABufferInternalSizedFormat(texture.type, format);
        const bindTarget = texture.isCube ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D;
        this._bindTextureDirectly(bindTarget, texture, true);
        this._unpackFlipY(texture.invertY);
        let target = gl.TEXTURE_2D;
        if (texture.isCube) target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
        gl.texImage2D(target, lod, internalFormat, format, textureType, image);
        this._bindTextureDirectly(bindTarget, null, true);
    }
    /**
     * Updates a depth texture Comparison Mode and Function.
     * If the comparison Function is equal to 0, the mode will be set to none.
     * Otherwise, this only works in webgl 2 and requires a shadow sampler in the shader.
     * @param texture The texture to set the comparison function for
     * @param comparisonFunction The comparison function to set, 0 if no comparison required
     */ updateTextureComparisonFunction(texture, comparisonFunction) {
        if (this.webGLVersion === 1) {
            (0, $kVtWi.Logger).Error("WebGL 1 does not support texture comparison.");
            return;
        }
        const gl = this._gl;
        if (texture.isCube) {
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, texture, true);
            if (comparisonFunction === 0) {
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_FUNC, 515);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_MODE, gl.NONE);
            } else {
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            }
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
        } else {
            this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
            if (comparisonFunction === 0) {
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_FUNC, 515);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_MODE, gl.NONE);
            } else {
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            }
            this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        }
        texture._comparisonFunction = comparisonFunction;
    }
    /**
     * Creates a webGL buffer to use with instantiation
     * @param capacity defines the size of the buffer
     * @returns the webGL buffer
     */ createInstancesBuffer(capacity) {
        const buffer = this._gl.createBuffer();
        if (!buffer) throw new Error("Unable to create instance buffer");
        const result = new (0, $koExS.WebGLDataBuffer)(buffer);
        result.capacity = capacity;
        this.bindArrayBuffer(result);
        this._gl.bufferData(this._gl.ARRAY_BUFFER, capacity, this._gl.DYNAMIC_DRAW);
        result.references = 1;
        return result;
    }
    /**
     * Delete a webGL buffer used with instantiation
     * @param buffer defines the webGL buffer to delete
     */ deleteInstancesBuffer(buffer) {
        this._gl.deleteBuffer(buffer);
    }
    _clientWaitAsync(sync, flags = 0, intervalms = 10) {
        const gl = this._gl;
        return new Promise((resolve, reject)=>{
            (0, $av6Bc._retryWithInterval)(()=>{
                const res = gl.clientWaitSync(sync, flags, 0);
                if (res == gl.WAIT_FAILED) throw new Error("clientWaitSync failed");
                if (res == gl.TIMEOUT_EXPIRED) return false;
                return true;
            }, resolve, reject, intervalms);
        });
    }
    /**
     * @internal
     */ _readPixelsAsync(x, y, w, h, format, type, outputBuffer) {
        if (this._webGLVersion < 2) throw new Error("_readPixelsAsync only work on WebGL2+");
        const gl = this._gl;
        const buf = gl.createBuffer();
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
        gl.bufferData(gl.PIXEL_PACK_BUFFER, outputBuffer.byteLength, gl.STREAM_READ);
        gl.readPixels(x, y, w, h, format, type, 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        if (!sync) return null;
        gl.flush();
        return this._clientWaitAsync(sync, 0, 10).then(()=>{
            gl.deleteSync(sync);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
            gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, outputBuffer);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
            gl.deleteBuffer(buf);
            return outputBuffer;
        });
    }
    dispose() {
        this.hideLoadingUI();
        // Rescale PP
        if (this._rescalePostProcess) this._rescalePostProcess.dispose();
        (0, $e7bN3._CommonDispose)(this, this._renderingCanvas);
        super.dispose();
    }
}
// Const statics
/** Defines that alpha blending is disabled */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_DISABLE = 0;
/** Defines that alpha blending to SRC ALPHA * SRC + DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_ADD = 1;
/** Defines that alpha blending to SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_COMBINE = 2;
/** Defines that alpha blending to DEST - SRC * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_SUBTRACT = 3;
/** Defines that alpha blending to SRC * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_MULTIPLY = 4;
/** Defines that alpha blending to SRC ALPHA * SRC + (1 - SRC) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_MAXIMIZED = 5;
/** Defines that alpha blending to SRC + DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_ONEONE = 6;
/** Defines that alpha blending to SRC + (1 - SRC ALPHA) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_PREMULTIPLIED = 7;
/**
 * Defines that alpha blending to SRC + (1 - SRC ALPHA) * DEST
 * Alpha will be set to (1 - SRC ALPHA) * DEST ALPHA
 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
/** Defines that alpha blending to CST * SRC + (1 - CST) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_INTERPOLATE = 9;
/**
 * Defines that alpha blending to SRC + (1 - SRC) * DEST
 * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DEST ALPHA
 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_SCREENMODE = 10;
/** Defines that the resource is not delayed*/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_NONE = 0;
/** Defines that the resource was successfully delay loaded */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_LOADED = 1;
/** Defines that the resource is currently delay loading */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_LOADING = 2;
/** Defines that the resource is delayed and has not started loading */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_NOTLOADED = 4;
// Depht or Stencil test Constants.
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass. i.e. Nothing will be drawn */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.NEVER = 512;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALWAYS = 519;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.LESS = 513;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.EQUAL = 514;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.LEQUAL = 515;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.GREATER = 516;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.GEQUAL = 518;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.NOTEQUAL = 517;
// Stencil Actions Constants.
/** Passed to stencilOperation to specify that stencil value must be kept */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.KEEP = 7680;
/** Passed to stencilOperation to specify that stencil value must be replaced */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.REPLACE = 7681;
/** Passed to stencilOperation to specify that stencil value must be incremented */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.INCR = 7682;
/** Passed to stencilOperation to specify that stencil value must be decremented */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DECR = 7683;
/** Passed to stencilOperation to specify that stencil value must be inverted */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.INVERT = 5386;
/** Passed to stencilOperation to specify that stencil value must be incremented with wrapping */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.INCR_WRAP = 34055;
/** Passed to stencilOperation to specify that stencil value must be decremented with wrapping */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DECR_WRAP = 34056;
/** Texture is not repeating outside of 0..1 UVs */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_CLAMP_ADDRESSMODE = 0;
/** Texture is repeating outside of 0..1 UVs */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_WRAP_ADDRESSMODE = 1;
/** Texture is repeating and mirrored */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_MIRROR_ADDRESSMODE = 2;
/** ALPHA */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_ALPHA = 0;
/** LUMINANCE */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_LUMINANCE = 1;
/** LUMINANCE_ALPHA */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
/** RGB */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGB = 4;
/** RGBA */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGBA = 5;
/** RED */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RED = 6;
/** RED (2nd reference) */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_R = 6;
/** RED unsigned short normed to [0, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_R16_UNORM = 33322;
/** RG unsigned short normed to [0, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RG16_UNORM = 33324;
/** RGB unsigned short normed to [0, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGB16_UNORM = 32852;
/** RGBA unsigned short normed to [0, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGBA16_UNORM = 32859;
/** RED signed short normed to [-1, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_R16_SNORM = 36760;
/** RG signed short normed to [-1, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RG16_SNORM = 36761;
/** RGB signed short normed to [-1, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGB16_SNORM = 36762;
/** RGBA signed short normed to [-1, 1] **/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGBA16_SNORM = 36763;
/** RG */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RG = 7;
/** RED_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RED_INTEGER = 8;
/** RED_INTEGER (2nd reference) */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_R_INTEGER = 8;
/** RG_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RG_INTEGER = 9;
/** RGB_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGB_INTEGER = 10;
/** RGBA_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGBA_INTEGER = 11;
/** UNSIGNED_BYTE */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_BYTE = 0;
/** @deprecated use more explicit TEXTURETYPE_UNSIGNED_BYTE instead. Use TEXTURETYPE_UNSIGNED_INTEGER for 32bits values.*/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT = 0;
/** FLOAT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_FLOAT = 1;
/** HALF_FLOAT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_HALF_FLOAT = 2;
/** BYTE */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_BYTE = 3;
/** SHORT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_SHORT = 4;
/** UNSIGNED_SHORT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT = 5;
/** INT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_INT = 6;
/** UNSIGNED_INT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INTEGER = 7;
/** UNSIGNED_SHORT_4_4_4_4 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
/** UNSIGNED_SHORT_5_5_5_1 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
/** UNSIGNED_SHORT_5_6_5 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
/** UNSIGNED_INT_2_10_10_10_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
/** UNSIGNED_INT_24_8 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
/** UNSIGNED_INT_10F_11F_11F_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
/** UNSIGNED_INT_5_9_9_9_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
/** FLOAT_32_UNSIGNED_INT_24_8_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
/** nearest is mag = nearest and min = nearest and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_SAMPLINGMODE = 1;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
/** Trilinear is mag = linear and min = linear and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
/** nearest is mag = nearest and min = nearest and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
/** Trilinear is mag = linear and min = linear and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
/** mag = nearest and min = nearest and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
/** mag = nearest and min = linear and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
/** mag = nearest and min = linear and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
/** mag = nearest and min = linear and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_LINEAR = 7;
/** mag = nearest and min = nearest and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_NEAREST = 1;
/** mag = linear and min = nearest and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
/** mag = linear and min = nearest and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
/** mag = linear and min = linear and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_LINEAR = 2;
/** mag = linear and min = nearest and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_NEAREST = 12;
/** Explicit coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_EXPLICIT_MODE = 0;
/** Spherical coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_SPHERICAL_MODE = 1;
/** Planar coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_PLANAR_MODE = 2;
/** Cubic coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_CUBIC_MODE = 3;
/** Projection coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_PROJECTION_MODE = 4;
/** Skybox coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_SKYBOX_MODE = 5;
/** Inverse Cubic coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_INVCUBIC_MODE = 6;
/** Equirectangular coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_EQUIRECTANGULAR_MODE = 7;
/** Equirectangular Fixed coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
/** Equirectangular Fixed Mirrored coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
// Texture rescaling mode
/** Defines that texture rescaling will use a floor to find the closer power of 2 size */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.SCALEMODE_FLOOR = 1;
/** Defines that texture rescaling will look for the nearest power of 2 size */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.SCALEMODE_NEAREST = 2;
/** Defines that texture rescaling will use a ceil to find the closer power of 2 size */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.SCALEMODE_CEILING = 3;

});
parcelRegister("2h5JR", function(module, exports) {

$parcel$export(module.exports, "ThinEngine", () => $1a819ede290e980a$export$bfb63ef0b91d03e9);

var $d2IE3 = parcelRequire("d2IE3");

var $hqVRr = parcelRequire("hqVRr");

var $kVtWi = parcelRequire("kVtWi");

var $jFz47 = parcelRequire("jFz47");

var $6faFW = parcelRequire("6faFW");

var $i1R6L = parcelRequire("i1R6L");

var $koExS = parcelRequire("koExS");

var $wK2xc = parcelRequire("wK2xc");

var $dUFoQ = parcelRequire("dUFoQ");

var $8ClRi = parcelRequire("8ClRi");

var $b9e4a = parcelRequire("b9e4a");

var $lUDWq = parcelRequire("lUDWq");

var $cOV0H = parcelRequire("cOV0H");

var $4kP5d = parcelRequire("4kP5d");

var $aees9 = parcelRequire("aees9");
/**
 * Keeps track of all the buffer info used in engine.
 */ class $1a819ede290e980a$var$BufferPointer {
}
class $1a819ede290e980a$export$bfb63ef0b91d03e9 extends (0, $dUFoQ.AbstractEngine) {
    /**
     * Gets or sets the name of the engine
     */ get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    /**
     * Returns the version of the engine
     */ get version() {
        return this._webGLVersion;
    }
    /**
     * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
     */ static get ShadersRepository() {
        return (0, $lUDWq.Effect).ShadersRepository;
    }
    static set ShadersRepository(value) {
        (0, $lUDWq.Effect).ShadersRepository = value;
    }
    /**
     * Gets a boolean indicating that the engine supports uniform buffers
     * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
     */ get supportsUniformBuffers() {
        return this.webGLVersion > 1 && !this.disableUniformBuffers;
    }
    /**
     * Gets a boolean indicating that only power of 2 textures are supported
     * Please note that you can still use non power of 2 textures but in this case the engine will forcefully convert them
     */ get needPOTTextures() {
        return this._webGLVersion < 2 || this.forcePOTTextures;
    }
    get _supportsHardwareTextureRescaling() {
        return false;
    }
    /**
     * sets the object from which width and height will be taken from when getting render width and height
     * Will fallback to the gl object
     * @param dimensions the framebuffer width and height that will be used.
     */ set framebufferDimensionsObject(dimensions) {
        this._framebufferDimensionsObject = dimensions;
    }
    /**
     * Creates a new snapshot at the next frame using the current snapshotRenderingMode
     */ snapshotRenderingReset() {
        this.snapshotRendering = false;
    }
    /**
     * Creates a new engine
     * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
     * @param antialias defines whether anti-aliasing should be enabled (default value is "undefined", meaning that the browser may or may not enable it)
     * @param options defines further options to be sent to the getContext() function
     * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
     */ constructor(canvasOrContext, antialias, options, adaptToDeviceRatio){
        options = options || {};
        super(antialias ?? options.antialias, options, adaptToDeviceRatio);
        /** @internal */ this._name = "WebGL";
        /**
         * Gets or sets a boolean that indicates if textures must be forced to power of 2 size even if not required
         */ this.forcePOTTextures = false;
        /** Gets or sets a boolean indicating if the engine should validate programs after compilation */ this.validateShaderPrograms = false;
        /**
         * Gets or sets a boolean indicating that uniform buffers must be disabled even if they are supported
         */ this.disableUniformBuffers = false;
        /** @internal */ this._webGLVersion = 1.0;
        this._vertexAttribArraysEnabled = [];
        this._uintIndicesCurrentlySet = false;
        this._currentBoundBuffer = new Array();
        /** @internal */ this._currentFramebuffer = null;
        /** @internal */ this._dummyFramebuffer = null;
        this._currentBufferPointers = new Array();
        this._currentInstanceLocations = new Array();
        this._currentInstanceBuffers = new Array();
        this._vaoRecordInProgress = false;
        this._mustWipeVertexAttributes = false;
        this._nextFreeTextureSlots = new Array();
        this._maxSimultaneousTextures = 0;
        this._maxMSAASamplesOverride = null;
        this._unpackFlipYCached = null;
        /**
         * In case you are sharing the context with other applications, it might
         * be interested to not cache the unpack flip y state to ensure a consistent
         * value would be set.
         */ this.enableUnpackFlipYCached = true;
        /**
         * @internal
         */ this._boundUniforms = {};
        if (!canvasOrContext) return;
        let canvas = null;
        if (canvasOrContext.getContext) {
            canvas = canvasOrContext;
            if (options.preserveDrawingBuffer === undefined) options.preserveDrawingBuffer = false;
            if (options.xrCompatible === undefined) options.xrCompatible = false;
            // Exceptions
            if (navigator && navigator.userAgent) {
                this._setupMobileChecks();
                const ua = navigator.userAgent;
                for (const exception of $1a819ede290e980a$export$bfb63ef0b91d03e9.ExceptionList){
                    const key = exception.key;
                    const targets = exception.targets;
                    const check = new RegExp(key);
                    if (check.test(ua)) {
                        if (exception.capture && exception.captureConstraint) {
                            const capture = exception.capture;
                            const constraint = exception.captureConstraint;
                            const regex = new RegExp(capture);
                            const matches = regex.exec(ua);
                            if (matches && matches.length > 0) {
                                const capturedValue = parseInt(matches[matches.length - 1]);
                                if (capturedValue >= constraint) continue;
                            }
                        }
                        for (const target of targets)switch(target){
                            case "uniformBuffer":
                                this.disableUniformBuffers = true;
                                break;
                            case "vao":
                                this.disableVertexArrayObjects = true;
                                break;
                            case "antialias":
                                options.antialias = false;
                                break;
                            case "maxMSAASamples":
                                this._maxMSAASamplesOverride = 1;
                                break;
                        }
                    }
                }
            }
            // Context lost
            if (!this._doNotHandleContextLost) {
                this._onContextLost = (evt)=>{
                    evt.preventDefault();
                    this._contextWasLost = true;
                    (0, $d2IE3.deleteStateObject)(this._gl);
                    (0, $kVtWi.Logger).Warn("WebGL context lost.");
                    this.onContextLostObservable.notifyObservers(this);
                };
                this._onContextRestored = ()=>{
                    this._restoreEngineAfterContextLost(()=>this._initGLContext());
                };
                canvas.addEventListener("webglcontextrestored", this._onContextRestored, false);
                options.powerPreference = options.powerPreference || "high-performance";
            } else this._onContextLost = ()=>{
                (0, $d2IE3.deleteStateObject)(this._gl);
            };
            canvas.addEventListener("webglcontextlost", this._onContextLost, false);
            if (this._badDesktopOS) options.xrCompatible = false;
            // GL
            if (!options.disableWebGL2Support) try {
                this._gl = canvas.getContext("webgl2", options) || canvas.getContext("experimental-webgl2", options);
                if (this._gl) {
                    this._webGLVersion = 2.0;
                    this._shaderPlatformName = "WEBGL2";
                    // Prevent weird browsers to lie (yeah that happens!)
                    if (!this._gl.deleteQuery) {
                        this._webGLVersion = 1.0;
                        this._shaderPlatformName = "WEBGL1";
                    }
                }
            } catch (e) {
            // Do nothing
            }
            if (!this._gl) {
                if (!canvas) throw new Error("The provided canvas is null or undefined.");
                try {
                    this._gl = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options);
                } catch (e) {
                    throw new Error("WebGL not supported");
                }
            }
            if (!this._gl) throw new Error("WebGL not supported");
        } else {
            this._gl = canvasOrContext;
            canvas = this._gl.canvas;
            if (this._gl.renderbufferStorageMultisample) {
                this._webGLVersion = 2.0;
                this._shaderPlatformName = "WEBGL2";
            } else this._shaderPlatformName = "WEBGL1";
            const attributes = this._gl.getContextAttributes();
            if (attributes) options.stencil = attributes.stencil;
        }
        this._sharedInit(canvas);
        // Ensures a consistent color space unpacking of textures cross browser.
        this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE);
        if (options.useHighPrecisionFloats !== undefined) this._highPrecisionShadersAllowed = options.useHighPrecisionFloats;
        this.resize();
        this._initGLContext();
        this._initFeatures();
        // Prepare buffer pointers
        for(let i = 0; i < this._caps.maxVertexAttribs; i++)this._currentBufferPointers[i] = new $1a819ede290e980a$var$BufferPointer();
        // Shader processor
        this._shaderProcessor = this.webGLVersion > 1 ? new (0, $i1R6L.WebGL2ShaderProcessor)() : new (0, $6faFW.WebGLShaderProcessor)();
        // Starting with iOS 14, we can trust the browser
        // let matches = navigator.userAgent.match(/Version\/(\d+)/);
        // if (matches && matches.length === 2) {
        //     if (parseInt(matches[1]) >= 14) {
        //         this._badOS = false;
        //     }
        // }
        const versionToLog = `Babylon.js v${$1a819ede290e980a$export$bfb63ef0b91d03e9.Version}`;
        (0, $kVtWi.Logger).Log(versionToLog + ` - ${this.description}`);
        // Check setAttribute in case of workers
        if (this._renderingCanvas && this._renderingCanvas.setAttribute) this._renderingCanvas.setAttribute("data-engine", versionToLog);
        const stateObject = (0, $d2IE3.getStateObject)(this._gl);
        // update state object with the current engine state
        stateObject.validateShaderPrograms = this.validateShaderPrograms;
        stateObject.parallelShaderCompile = this._caps.parallelShaderCompile;
    }
    _clearEmptyResources() {
        this._dummyFramebuffer = null;
        super._clearEmptyResources();
    }
    /**
     * @internal
     */ _getShaderProcessingContext(shaderLanguage) {
        return null;
    }
    /**
     * Gets a boolean indicating if all created effects are ready
     * @returns true if all effects are ready
     */ areAllEffectsReady() {
        for(const key in this._compiledEffects){
            const effect = this._compiledEffects[key];
            if (!effect.isReady()) return false;
        }
        return true;
    }
    _initGLContext() {
        // Caps
        this._caps = {
            maxTexturesImageUnits: this._gl.getParameter(this._gl.MAX_TEXTURE_IMAGE_UNITS),
            maxCombinedTexturesImageUnits: this._gl.getParameter(this._gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
            maxVertexTextureImageUnits: this._gl.getParameter(this._gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
            maxTextureSize: this._gl.getParameter(this._gl.MAX_TEXTURE_SIZE),
            maxSamples: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_SAMPLES) : 1,
            maxCubemapTextureSize: this._gl.getParameter(this._gl.MAX_CUBE_MAP_TEXTURE_SIZE),
            maxRenderTextureSize: this._gl.getParameter(this._gl.MAX_RENDERBUFFER_SIZE),
            maxVertexAttribs: this._gl.getParameter(this._gl.MAX_VERTEX_ATTRIBS),
            maxVaryingVectors: this._gl.getParameter(this._gl.MAX_VARYING_VECTORS),
            maxFragmentUniformVectors: this._gl.getParameter(this._gl.MAX_FRAGMENT_UNIFORM_VECTORS),
            maxVertexUniformVectors: this._gl.getParameter(this._gl.MAX_VERTEX_UNIFORM_VECTORS),
            parallelShaderCompile: this._gl.getExtension("KHR_parallel_shader_compile") || undefined,
            standardDerivatives: this._webGLVersion > 1 || this._gl.getExtension("OES_standard_derivatives") !== null,
            maxAnisotropy: 1,
            astc: this._gl.getExtension("WEBGL_compressed_texture_astc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_astc"),
            bptc: this._gl.getExtension("EXT_texture_compression_bptc") || this._gl.getExtension("WEBKIT_EXT_texture_compression_bptc"),
            s3tc: this._gl.getExtension("WEBGL_compressed_texture_s3tc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc"),
            // eslint-disable-next-line @typescript-eslint/naming-convention
            s3tc_srgb: this._gl.getExtension("WEBGL_compressed_texture_s3tc_srgb") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc_srgb"),
            pvrtc: this._gl.getExtension("WEBGL_compressed_texture_pvrtc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            etc1: this._gl.getExtension("WEBGL_compressed_texture_etc1") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc1"),
            etc2: this._gl.getExtension("WEBGL_compressed_texture_etc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc") || this._gl.getExtension("WEBGL_compressed_texture_es3_0"),
            textureAnisotropicFilterExtension: this._gl.getExtension("EXT_texture_filter_anisotropic") || this._gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic") || this._gl.getExtension("MOZ_EXT_texture_filter_anisotropic"),
            uintIndices: this._webGLVersion > 1 || this._gl.getExtension("OES_element_index_uint") !== null,
            fragmentDepthSupported: this._webGLVersion > 1 || this._gl.getExtension("EXT_frag_depth") !== null,
            highPrecisionShaderSupported: false,
            timerQuery: this._gl.getExtension("EXT_disjoint_timer_query_webgl2") || this._gl.getExtension("EXT_disjoint_timer_query"),
            supportOcclusionQuery: this._webGLVersion > 1,
            canUseTimestampForTimerQuery: false,
            drawBuffersExtension: false,
            maxMSAASamples: 1,
            colorBufferFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_float")),
            supportFloatTexturesResolve: false,
            rg11b10ufColorRenderable: false,
            colorBufferHalfFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_half_float")),
            textureFloat: this._webGLVersion > 1 || this._gl.getExtension("OES_texture_float") ? true : false,
            textureHalfFloat: this._webGLVersion > 1 || this._gl.getExtension("OES_texture_half_float") ? true : false,
            textureHalfFloatRender: false,
            textureFloatLinearFiltering: false,
            textureFloatRender: false,
            textureHalfFloatLinearFiltering: false,
            vertexArrayObject: false,
            instancedArrays: false,
            textureLOD: this._webGLVersion > 1 || this._gl.getExtension("EXT_shader_texture_lod") ? true : false,
            texelFetch: this._webGLVersion !== 1,
            blendMinMax: false,
            multiview: this._gl.getExtension("OVR_multiview2"),
            oculusMultiview: this._gl.getExtension("OCULUS_multiview"),
            depthTextureExtension: false,
            canUseGLInstanceID: this._webGLVersion > 1,
            canUseGLVertexID: this._webGLVersion > 1,
            supportComputeShaders: false,
            supportSRGBBuffers: false,
            supportTransformFeedbacks: this._webGLVersion > 1,
            textureMaxLevel: this._webGLVersion > 1,
            texture2DArrayMaxLayerCount: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_ARRAY_TEXTURE_LAYERS) : 128,
            disableMorphTargetTexture: false,
            textureNorm16: this._gl.getExtension("EXT_texture_norm16") ? true : false
        };
        this._caps.supportFloatTexturesResolve = this._caps.colorBufferFloat;
        this._caps.rg11b10ufColorRenderable = this._caps.colorBufferFloat;
        // Infos
        this._glVersion = this._gl.getParameter(this._gl.VERSION);
        const rendererInfo = this._gl.getExtension("WEBGL_debug_renderer_info");
        if (rendererInfo != null) {
            this._glRenderer = this._gl.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL);
            this._glVendor = this._gl.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL);
        }
        if (!this._glVendor) this._glVendor = this._gl.getParameter(this._gl.VENDOR) || "Unknown vendor";
        if (!this._glRenderer) this._glRenderer = this._gl.getParameter(this._gl.RENDERER) || "Unknown renderer";
        // Constants
        if (this._gl.HALF_FLOAT_OES !== 0x8d61) this._gl.HALF_FLOAT_OES = 0x8d61; // Half floating-point type (16-bit).
        if (this._gl.RGBA16F !== 0x881a) this._gl.RGBA16F = 0x881a; // RGBA 16-bit floating-point color-renderable internal sized format.
        if (this._gl.RGBA32F !== 0x8814) this._gl.RGBA32F = 0x8814; // RGBA 32-bit floating-point color-renderable internal sized format.
        if (this._gl.DEPTH24_STENCIL8 !== 35056) this._gl.DEPTH24_STENCIL8 = 35056;
        // Extensions
        if (this._caps.timerQuery) {
            if (this._webGLVersion === 1) this._gl.getQuery = this._caps.timerQuery.getQueryEXT.bind(this._caps.timerQuery);
            // WebGLQuery casted to number to avoid TS error
            this._caps.canUseTimestampForTimerQuery = (this._gl.getQuery(this._caps.timerQuery.TIMESTAMP_EXT, this._caps.timerQuery.QUERY_COUNTER_BITS_EXT) ?? 0) > 0;
        }
        this._caps.maxAnisotropy = this._caps.textureAnisotropicFilterExtension ? this._gl.getParameter(this._caps.textureAnisotropicFilterExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
        this._caps.textureFloatLinearFiltering = this._caps.textureFloat && this._gl.getExtension("OES_texture_float_linear") ? true : false;
        this._caps.textureFloatRender = this._caps.textureFloat && this._canRenderToFloatFramebuffer() ? true : false;
        this._caps.textureHalfFloatLinearFiltering = this._webGLVersion > 1 || this._caps.textureHalfFloat && this._gl.getExtension("OES_texture_half_float_linear") ? true : false;
        if (this._caps.textureNorm16) {
            this._gl.R16_EXT = 0x822a;
            this._gl.RG16_EXT = 0x822c;
            this._gl.RGB16_EXT = 0x8054;
            this._gl.RGBA16_EXT = 0x805b;
            this._gl.R16_SNORM_EXT = 0x8f98;
            this._gl.RG16_SNORM_EXT = 0x8f99;
            this._gl.RGB16_SNORM_EXT = 0x8f9a;
            this._gl.RGBA16_SNORM_EXT = 0x8f9b;
        }
        // Compressed formats
        if (this._caps.astc) this._gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = this._caps.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
        if (this._caps.bptc) this._gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT = this._caps.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
        if (this._caps.s3tc_srgb) {
            this._gl.COMPRESSED_SRGB_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_S3TC_DXT1_EXT;
            this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
            this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        }
        if (this._caps.etc2) {
            this._gl.COMPRESSED_SRGB8_ETC2 = this._caps.etc2.COMPRESSED_SRGB8_ETC2;
            this._gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = this._caps.etc2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
        }
        // Checks if some of the format renders first to allow the use of webgl inspector.
        if (this._webGLVersion > 1) {
            if (this._gl.HALF_FLOAT_OES !== 0x140b) this._gl.HALF_FLOAT_OES = 0x140b;
        }
        this._caps.textureHalfFloatRender = this._caps.textureHalfFloat && this._canRenderToHalfFloatFramebuffer();
        // Draw buffers
        if (this._webGLVersion > 1) {
            this._caps.drawBuffersExtension = true;
            this._caps.maxMSAASamples = this._maxMSAASamplesOverride !== null ? this._maxMSAASamplesOverride : this._gl.getParameter(this._gl.MAX_SAMPLES);
            this._caps.maxDrawBuffers = this._gl.getParameter(this._gl.MAX_DRAW_BUFFERS);
        } else {
            const drawBuffersExtension = this._gl.getExtension("WEBGL_draw_buffers");
            if (drawBuffersExtension !== null) {
                this._caps.drawBuffersExtension = true;
                this._gl.drawBuffers = drawBuffersExtension.drawBuffersWEBGL.bind(drawBuffersExtension);
                this._caps.maxDrawBuffers = this._gl.getParameter(drawBuffersExtension.MAX_DRAW_BUFFERS_WEBGL);
                this._gl.DRAW_FRAMEBUFFER = this._gl.FRAMEBUFFER;
                for(let i = 0; i < 16; i++)this._gl["COLOR_ATTACHMENT" + i + "_WEBGL"] = drawBuffersExtension["COLOR_ATTACHMENT" + i + "_WEBGL"];
            }
        }
        // Depth Texture
        if (this._webGLVersion > 1) this._caps.depthTextureExtension = true;
        else {
            const depthTextureExtension = this._gl.getExtension("WEBGL_depth_texture");
            if (depthTextureExtension != null) {
                this._caps.depthTextureExtension = true;
                this._gl.UNSIGNED_INT_24_8 = depthTextureExtension.UNSIGNED_INT_24_8_WEBGL;
            }
        }
        // Vertex array object
        if (this.disableVertexArrayObjects) this._caps.vertexArrayObject = false;
        else if (this._webGLVersion > 1) this._caps.vertexArrayObject = true;
        else {
            const vertexArrayObjectExtension = this._gl.getExtension("OES_vertex_array_object");
            if (vertexArrayObjectExtension != null) {
                this._caps.vertexArrayObject = true;
                this._gl.createVertexArray = vertexArrayObjectExtension.createVertexArrayOES.bind(vertexArrayObjectExtension);
                this._gl.bindVertexArray = vertexArrayObjectExtension.bindVertexArrayOES.bind(vertexArrayObjectExtension);
                this._gl.deleteVertexArray = vertexArrayObjectExtension.deleteVertexArrayOES.bind(vertexArrayObjectExtension);
            }
        }
        // Instances count
        if (this._webGLVersion > 1) this._caps.instancedArrays = true;
        else {
            const instanceExtension = this._gl.getExtension("ANGLE_instanced_arrays");
            if (instanceExtension != null) {
                this._caps.instancedArrays = true;
                this._gl.drawArraysInstanced = instanceExtension.drawArraysInstancedANGLE.bind(instanceExtension);
                this._gl.drawElementsInstanced = instanceExtension.drawElementsInstancedANGLE.bind(instanceExtension);
                this._gl.vertexAttribDivisor = instanceExtension.vertexAttribDivisorANGLE.bind(instanceExtension);
            } else this._caps.instancedArrays = false;
        }
        if (this._gl.getShaderPrecisionFormat) {
            const vertexhighp = this._gl.getShaderPrecisionFormat(this._gl.VERTEX_SHADER, this._gl.HIGH_FLOAT);
            const fragmenthighp = this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT);
            if (vertexhighp && fragmenthighp) this._caps.highPrecisionShaderSupported = vertexhighp.precision !== 0 && fragmenthighp.precision !== 0;
        }
        if (this._webGLVersion > 1) this._caps.blendMinMax = true;
        else {
            const blendMinMaxExtension = this._gl.getExtension("EXT_blend_minmax");
            if (blendMinMaxExtension != null) {
                this._caps.blendMinMax = true;
                this._gl.MAX = blendMinMaxExtension.MAX_EXT;
                this._gl.MIN = blendMinMaxExtension.MIN_EXT;
            }
        }
        // sRGB buffers
        // only run this if not already set to true (in the constructor, for example)
        if (!this._caps.supportSRGBBuffers) {
            if (this._webGLVersion > 1) {
                this._caps.supportSRGBBuffers = true;
                this._glSRGBExtensionValues = {
                    SRGB: WebGL2RenderingContext.SRGB,
                    SRGB8: WebGL2RenderingContext.SRGB8,
                    SRGB8_ALPHA8: WebGL2RenderingContext.SRGB8_ALPHA8
                };
            } else {
                const sRGBExtension = this._gl.getExtension("EXT_sRGB");
                if (sRGBExtension != null) {
                    this._caps.supportSRGBBuffers = true;
                    this._glSRGBExtensionValues = {
                        SRGB: sRGBExtension.SRGB_EXT,
                        SRGB8: sRGBExtension.SRGB_ALPHA_EXT,
                        SRGB8_ALPHA8: sRGBExtension.SRGB_ALPHA_EXT
                    };
                }
            }
            // take into account the forced state that was provided in options
            if (this._creationOptions) {
                const forceSRGBBufferSupportState = this._creationOptions.forceSRGBBufferSupportState;
                if (forceSRGBBufferSupportState !== undefined) this._caps.supportSRGBBuffers = this._caps.supportSRGBBuffers && forceSRGBBufferSupportState;
            }
        }
        // Depth buffer
        this._depthCullingState.depthTest = true;
        this._depthCullingState.depthFunc = this._gl.LEQUAL;
        this._depthCullingState.depthMask = true;
        // Texture maps
        this._maxSimultaneousTextures = this._caps.maxCombinedTexturesImageUnits;
        for(let slot = 0; slot < this._maxSimultaneousTextures; slot++)this._nextFreeTextureSlots.push(slot);
        if (this._glRenderer === "Mali-G72") // Overcome a bug when using a texture to store morph targets on Mali-G72
        this._caps.disableMorphTargetTexture = true;
    }
    _initFeatures() {
        this._features = {
            forceBitmapOverHTMLImageElement: typeof HTMLImageElement === "undefined",
            supportRenderAndCopyToLodForFloatTextures: this._webGLVersion !== 1,
            supportDepthStencilTexture: this._webGLVersion !== 1,
            supportShadowSamplers: this._webGLVersion !== 1,
            uniformBufferHardCheckMatrix: false,
            allowTexturePrefiltering: this._webGLVersion !== 1,
            trackUbosInFrame: false,
            checkUbosContentBeforeUpload: false,
            supportCSM: this._webGLVersion !== 1,
            basisNeedsPOT: this._webGLVersion === 1,
            support3DTextures: this._webGLVersion !== 1,
            needTypeSuffixInShaderConstants: this._webGLVersion !== 1,
            supportMSAA: this._webGLVersion !== 1,
            supportSSAO2: this._webGLVersion !== 1,
            supportIBLShadows: this._webGLVersion !== 1,
            supportExtendedTextureFormats: this._webGLVersion !== 1,
            supportSwitchCaseInShader: this._webGLVersion !== 1,
            supportSyncTextureRead: true,
            needsInvertingBitmap: true,
            useUBOBindingCache: true,
            needShaderCodeInlining: false,
            needToAlwaysBindUniformBuffers: false,
            supportRenderPasses: false,
            supportSpriteInstancing: true,
            forceVertexBufferStrideAndOffsetMultiple4Bytes: false,
            _checkNonFloatVertexBuffersDontRecreatePipelineContext: false,
            _collectUbosUpdatedInFrame: false
        };
    }
    /**
     * Gets version of the current webGL context
     * Keep it for back compat - use version instead
     */ get webGLVersion() {
        return this._webGLVersion;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "Engine" string
     */ getClassName() {
        return "ThinEngine";
    }
    /** @internal */ _prepareWorkingCanvas() {
        if (this._workingCanvas) return;
        this._workingCanvas = this.createCanvas(1, 1);
        const context = this._workingCanvas.getContext("2d");
        if (context) this._workingContext = context;
    }
    /**
     * Gets an object containing information about the current engine context
     * @returns an object containing the vendor, the renderer and the version of the current engine context
     */ getInfo() {
        return this.getGlInfo();
    }
    /**
     * Gets an object containing information about the current webGL context
     * @returns an object containing the vendor, the renderer and the version of the current webGL context
     */ getGlInfo() {
        return {
            vendor: this._glVendor,
            renderer: this._glRenderer,
            version: this._glVersion
        };
    }
    /**Gets driver info if available */ extractDriverInfo() {
        const glInfo = this.getGlInfo();
        if (glInfo && glInfo.renderer) return glInfo.renderer;
        return "";
    }
    /**
     * Gets the current render width
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render width
     */ getRenderWidth(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.width;
        return this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferWidth : this._gl.drawingBufferWidth;
    }
    /**
     * Gets the current render height
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render height
     */ getRenderHeight(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.height;
        return this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferHeight : this._gl.drawingBufferHeight;
    }
    /**
     * Clear the current render buffer or the current render target (if any is set up)
     * @param color defines the color to use
     * @param backBuffer defines if the back buffer must be cleared
     * @param depth defines if the depth buffer must be cleared
     * @param stencil defines if the stencil buffer must be cleared
     */ clear(color, backBuffer, depth, stencil = false) {
        const useStencilGlobalOnly = this.stencilStateComposer.useStencilGlobalOnly;
        this.stencilStateComposer.useStencilGlobalOnly = true; // make sure the stencil mask is coming from the global stencil and not from a material (effect) which would currently be in effect
        this.applyStates();
        this.stencilStateComposer.useStencilGlobalOnly = useStencilGlobalOnly;
        let mode = 0;
        if (backBuffer && color) {
            let setBackBufferColor = true;
            if (this._currentRenderTarget) {
                const textureFormat = this._currentRenderTarget.texture?.format;
                if (textureFormat === 8 || textureFormat === 9 || textureFormat === 10 || textureFormat === 11) {
                    const textureType = this._currentRenderTarget.texture?.type;
                    if (textureType === 7 || textureType === 5) {
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[0] = color.r * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[1] = color.g * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[2] = color.b * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[3] = color.a * 255;
                        this._gl.clearBufferuiv(this._gl.COLOR, 0, $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32);
                        setBackBufferColor = false;
                    } else {
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[0] = color.r * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[1] = color.g * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[2] = color.b * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[3] = color.a * 255;
                        this._gl.clearBufferiv(this._gl.COLOR, 0, $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32);
                        setBackBufferColor = false;
                    }
                }
            }
            if (setBackBufferColor) {
                this._gl.clearColor(color.r, color.g, color.b, color.a !== undefined ? color.a : 1.0);
                mode |= this._gl.COLOR_BUFFER_BIT;
            }
        }
        if (depth) {
            if (this.useReverseDepthBuffer) {
                this._depthCullingState.depthFunc = this._gl.GEQUAL;
                this._gl.clearDepth(0.0);
            } else this._gl.clearDepth(1.0);
            mode |= this._gl.DEPTH_BUFFER_BIT;
        }
        if (stencil) {
            this._gl.clearStencil(0);
            mode |= this._gl.STENCIL_BUFFER_BIT;
        }
        this._gl.clear(mode);
    }
    /**
     * @internal
     */ _viewport(x, y, width, height) {
        if (x !== this._viewportCached.x || y !== this._viewportCached.y || width !== this._viewportCached.z || height !== this._viewportCached.w) {
            this._viewportCached.x = x;
            this._viewportCached.y = y;
            this._viewportCached.z = width;
            this._viewportCached.w = height;
            this._gl.viewport(x, y, width, height);
        }
    }
    /**
     * End the current frame
     */ endFrame() {
        super.endFrame();
        // Force a flush in case we are using a bad OS.
        if (this._badOS) this.flushFramebuffer();
    }
    /**
     * Gets the performance monitor attached to this engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#engineinstrumentation
     */ get performanceMonitor() {
        throw new Error("Not Supported by ThinEngine");
    }
    /**
     * Binds the frame buffer to the specified texture.
     * @param rtWrapper The render target wrapper to render to
     * @param faceIndex The face of the texture to render to in case of cube texture and if the render target wrapper is not a multi render target
     * @param requiredWidth The width of the target to render to
     * @param requiredHeight The height of the target to render to
     * @param forceFullscreenViewport Forces the viewport to be the entire texture/screen if true
     * @param lodLevel Defines the lod level to bind to the frame buffer
     * @param layer Defines the 2d array index to bind to the frame buffer if the render target wrapper is not a multi render target
     */ bindFramebuffer(rtWrapper, faceIndex = 0, requiredWidth, requiredHeight, forceFullscreenViewport, lodLevel = 0, layer = 0) {
        const webglRTWrapper = rtWrapper;
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        this._currentRenderTarget = rtWrapper;
        this._bindUnboundFramebuffer(webglRTWrapper._framebuffer);
        const gl = this._gl;
        if (!rtWrapper.isMulti) {
            if (rtWrapper.is2DArray || rtWrapper.is3D) {
                gl.framebufferTextureLayer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, rtWrapper.texture._hardwareTexture?.underlyingResource, lodLevel, layer);
                webglRTWrapper._currentLOD = lodLevel;
            } else if (rtWrapper.isCube) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, rtWrapper.texture._hardwareTexture?.underlyingResource, lodLevel);
            else if (webglRTWrapper._currentLOD !== lodLevel) {
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, rtWrapper.texture._hardwareTexture?.underlyingResource, lodLevel);
                webglRTWrapper._currentLOD = lodLevel;
            }
        }
        const depthStencilTexture = rtWrapper._depthStencilTexture;
        if (depthStencilTexture) {
            if (rtWrapper.is3D) {
                if (rtWrapper.texture.width !== depthStencilTexture.width || rtWrapper.texture.height !== depthStencilTexture.height || rtWrapper.texture.depth !== depthStencilTexture.depth) (0, $kVtWi.Logger).Warn("Depth/Stencil attachment for 3D target must have same dimensions as color attachment");
            }
            const attachment = rtWrapper._depthStencilTextureWithStencil ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
            if (rtWrapper.is2DArray || rtWrapper.is3D) gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, depthStencilTexture._hardwareTexture?.underlyingResource, lodLevel, layer);
            else if (rtWrapper.isCube) gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, depthStencilTexture._hardwareTexture?.underlyingResource, lodLevel);
            else gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, depthStencilTexture._hardwareTexture?.underlyingResource, lodLevel);
        }
        if (webglRTWrapper._MSAAFramebuffer) this._bindUnboundFramebuffer(webglRTWrapper._MSAAFramebuffer);
        if (this._cachedViewport && !forceFullscreenViewport) this.setViewport(this._cachedViewport, requiredWidth, requiredHeight);
        else {
            if (!requiredWidth) {
                requiredWidth = rtWrapper.width;
                if (lodLevel) requiredWidth = requiredWidth / Math.pow(2, lodLevel);
            }
            if (!requiredHeight) {
                requiredHeight = rtWrapper.height;
                if (lodLevel) requiredHeight = requiredHeight / Math.pow(2, lodLevel);
            }
            this._viewport(0, 0, requiredWidth, requiredHeight);
        }
        this.wipeCaches();
    }
    /**
     * Set various states to the webGL context
     * @param culling defines culling state: true to enable culling, false to disable it
     * @param zOffset defines the value to apply to zOffset (0 by default)
     * @param force defines if states must be applied even if cache is up to date
     * @param reverseSide defines if culling must be reversed (CCW if false, CW if true)
     * @param cullBackFaces true to cull back faces, false to cull front faces (if culling is enabled)
     * @param stencil stencil states to set
     * @param zOffsetUnits defines the value to apply to zOffsetUnits (0 by default)
     */ setState(culling, zOffset = 0, force, reverseSide = false, cullBackFaces, stencil, zOffsetUnits = 0) {
        // Culling
        if (this._depthCullingState.cull !== culling || force) this._depthCullingState.cull = culling;
        // Cull face
        const cullFace = this.cullBackFaces ?? cullBackFaces ?? true ? this._gl.BACK : this._gl.FRONT;
        if (this._depthCullingState.cullFace !== cullFace || force) this._depthCullingState.cullFace = cullFace;
        // Z offset
        this.setZOffset(zOffset);
        this.setZOffsetUnits(zOffsetUnits);
        // Front face
        const frontFace = reverseSide ? this._gl.CW : this._gl.CCW;
        if (this._depthCullingState.frontFace !== frontFace || force) this._depthCullingState.frontFace = frontFace;
        this._stencilStateComposer.stencilMaterial = stencil;
    }
    /**
     * @internal
     */ _bindUnboundFramebuffer(framebuffer) {
        if (this._currentFramebuffer !== framebuffer) {
            this._gl.bindFramebuffer(this._gl.FRAMEBUFFER, framebuffer);
            this._currentFramebuffer = framebuffer;
        }
    }
    /** @internal */ _currentFrameBufferIsDefaultFrameBuffer() {
        return this._currentFramebuffer === null;
    }
    /**
     * Generates the mipmaps for a texture
     * @param texture texture to generate the mipmaps for
     */ generateMipmaps(texture) {
        const target = this._getTextureTarget(texture);
        this._bindTextureDirectly(target, texture, true);
        this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
    }
    /**
     * Unbind the current render target texture from the webGL context
     * @param texture defines the render target wrapper to unbind
     * @param disableGenerateMipMaps defines a boolean indicating that mipmaps must not be generated
     * @param onBeforeUnbind defines a function which will be called before the effective unbind
     */ unBindFramebuffer(texture, disableGenerateMipMaps = false, onBeforeUnbind) {
        const webglRTWrapper = texture;
        this._currentRenderTarget = null;
        if (!webglRTWrapper.disableAutomaticMSAAResolve) {
            if (texture.isMulti) this.resolveMultiFramebuffer(texture);
            else this.resolveFramebuffer(texture);
        }
        if (!disableGenerateMipMaps) {
            if (texture.isMulti) this.generateMipMapsMultiFramebuffer(texture);
            else this.generateMipMapsFramebuffer(texture);
        }
        if (onBeforeUnbind) {
            if (webglRTWrapper._MSAAFramebuffer) // Bind the correct framebuffer
            this._bindUnboundFramebuffer(webglRTWrapper._framebuffer);
            onBeforeUnbind();
        }
        this._bindUnboundFramebuffer(null);
    }
    /**
     * Generates mipmaps for the texture of the (single) render target
     * @param texture The render target containing the texture to generate the mipmaps for
     */ generateMipMapsFramebuffer(texture) {
        if (!texture.isMulti && texture.texture?.generateMipMaps && !texture.isCube) this.generateMipmaps(texture.texture);
    }
    /**
     * Resolves the MSAA texture of the (single) render target into its non-MSAA version.
     * Note that if "texture" is not a MSAA render target, no resolve is performed.
     * @param texture  The render target texture containing the MSAA textures to resolve
     */ resolveFramebuffer(texture) {
        const rtWrapper = texture;
        const gl = this._gl;
        if (!rtWrapper._MSAAFramebuffer || rtWrapper.isMulti) return;
        let bufferBits = rtWrapper.resolveMSAAColors ? gl.COLOR_BUFFER_BIT : 0;
        bufferBits |= rtWrapper._generateDepthBuffer && rtWrapper.resolveMSAADepth ? gl.DEPTH_BUFFER_BIT : 0;
        bufferBits |= rtWrapper._generateStencilBuffer && rtWrapper.resolveMSAAStencil ? gl.STENCIL_BUFFER_BIT : 0;
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, rtWrapper._MSAAFramebuffer);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, rtWrapper._framebuffer);
        gl.blitFramebuffer(0, 0, texture.width, texture.height, 0, 0, texture.width, texture.height, bufferBits, gl.NEAREST);
    }
    /**
     * Force a webGL flush (ie. a flush of all waiting webGL commands)
     */ flushFramebuffer() {
        this._gl.flush();
    }
    /**
     * Unbind the current render target and bind the default framebuffer
     */ restoreDefaultFramebuffer() {
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        else this._bindUnboundFramebuffer(null);
        if (this._cachedViewport) this.setViewport(this._cachedViewport);
        this.wipeCaches();
    }
    // VBOs
    /** @internal */ _resetVertexBufferBinding() {
        this.bindArrayBuffer(null);
        this._cachedVertexBuffers = null;
    }
    /**
     * Creates a vertex buffer
     * @param data the data or size for the vertex buffer
     * @param _updatable whether the buffer should be created as updatable
     * @param _label defines the label of the buffer (for debug purpose)
     * @returns the new WebGL static buffer
     */ createVertexBuffer(data, _updatable, _label) {
        return this._createVertexBuffer(data, this._gl.STATIC_DRAW);
    }
    _createVertexBuffer(data, usage) {
        const vbo = this._gl.createBuffer();
        if (!vbo) throw new Error("Unable to create vertex buffer");
        const dataBuffer = new (0, $koExS.WebGLDataBuffer)(vbo);
        this.bindArrayBuffer(dataBuffer);
        if (typeof data !== "number") {
            if (data instanceof Array) {
                this._gl.bufferData(this._gl.ARRAY_BUFFER, new Float32Array(data), usage);
                dataBuffer.capacity = data.length * 4;
            } else {
                this._gl.bufferData(this._gl.ARRAY_BUFFER, data, usage);
                dataBuffer.capacity = data.byteLength;
            }
        } else {
            this._gl.bufferData(this._gl.ARRAY_BUFFER, new Uint8Array(data), usage);
            dataBuffer.capacity = data;
        }
        this._resetVertexBufferBinding();
        dataBuffer.references = 1;
        return dataBuffer;
    }
    /**
     * Creates a dynamic vertex buffer
     * @param data the data for the dynamic vertex buffer
     * @param _label defines the label of the buffer (for debug purpose)
     * @returns the new WebGL dynamic buffer
     */ createDynamicVertexBuffer(data, _label) {
        return this._createVertexBuffer(data, this._gl.DYNAMIC_DRAW);
    }
    _resetIndexBufferBinding() {
        this.bindIndexBuffer(null);
        this._cachedIndexBuffer = null;
    }
    /**
     * Creates a new index buffer
     * @param indices defines the content of the index buffer
     * @param updatable defines if the index buffer must be updatable
     * @param _label defines the label of the buffer (for debug purpose)
     * @returns a new webGL buffer
     */ createIndexBuffer(indices, updatable, _label) {
        const vbo = this._gl.createBuffer();
        const dataBuffer = new (0, $koExS.WebGLDataBuffer)(vbo);
        if (!vbo) throw new Error("Unable to create index buffer");
        this.bindIndexBuffer(dataBuffer);
        const data = this._normalizeIndexData(indices);
        this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, data, updatable ? this._gl.DYNAMIC_DRAW : this._gl.STATIC_DRAW);
        this._resetIndexBufferBinding();
        dataBuffer.references = 1;
        dataBuffer.is32Bits = data.BYTES_PER_ELEMENT === 4;
        return dataBuffer;
    }
    _normalizeIndexData(indices) {
        const bytesPerElement = indices.BYTES_PER_ELEMENT;
        if (bytesPerElement === 2) return indices;
        // Check 32 bit support
        if (this._caps.uintIndices) {
            if (indices instanceof Uint32Array) return indices;
            else {
                // number[] or Int32Array, check if 32 bit is necessary
                for(let index = 0; index < indices.length; index++){
                    if (indices[index] >= 65535) return new Uint32Array(indices);
                }
                return new Uint16Array(indices);
            }
        }
        // No 32 bit support, force conversion to 16 bit (values greater 16 bit are lost)
        return new Uint16Array(indices);
    }
    /**
     * Bind a webGL buffer to the webGL context
     * @param buffer defines the buffer to bind
     */ bindArrayBuffer(buffer) {
        if (!this._vaoRecordInProgress) this._unbindVertexArrayObject();
        this._bindBuffer(buffer, this._gl.ARRAY_BUFFER);
    }
    /**
     * Bind a specific block at a given index in a specific shader program
     * @param pipelineContext defines the pipeline context to use
     * @param blockName defines the block name
     * @param index defines the index where to bind the block
     */ bindUniformBlock(pipelineContext, blockName, index) {
        const program = pipelineContext.program;
        const uniformLocation = this._gl.getUniformBlockIndex(program, blockName);
        this._gl.uniformBlockBinding(program, uniformLocation, index);
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    bindIndexBuffer(buffer) {
        if (!this._vaoRecordInProgress) this._unbindVertexArrayObject();
        this._bindBuffer(buffer, this._gl.ELEMENT_ARRAY_BUFFER);
    }
    _bindBuffer(buffer, target) {
        if (this._vaoRecordInProgress || this._currentBoundBuffer[target] !== buffer) {
            this._gl.bindBuffer(target, buffer ? buffer.underlyingResource : null);
            this._currentBoundBuffer[target] = buffer;
        }
    }
    /**
     * update the bound buffer with the given data
     * @param data defines the data to update
     */ updateArrayBuffer(data) {
        this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
    }
    _vertexAttribPointer(buffer, indx, size, type, normalized, stride, offset) {
        const pointer = this._currentBufferPointers[indx];
        if (!pointer) return;
        let changed = false;
        if (!pointer.active) {
            changed = true;
            pointer.active = true;
            pointer.index = indx;
            pointer.size = size;
            pointer.type = type;
            pointer.normalized = normalized;
            pointer.stride = stride;
            pointer.offset = offset;
            pointer.buffer = buffer;
        } else {
            if (pointer.buffer !== buffer) {
                pointer.buffer = buffer;
                changed = true;
            }
            if (pointer.size !== size) {
                pointer.size = size;
                changed = true;
            }
            if (pointer.type !== type) {
                pointer.type = type;
                changed = true;
            }
            if (pointer.normalized !== normalized) {
                pointer.normalized = normalized;
                changed = true;
            }
            if (pointer.stride !== stride) {
                pointer.stride = stride;
                changed = true;
            }
            if (pointer.offset !== offset) {
                pointer.offset = offset;
                changed = true;
            }
        }
        if (changed || this._vaoRecordInProgress) {
            this.bindArrayBuffer(buffer);
            if (type === this._gl.UNSIGNED_INT || type === this._gl.INT) this._gl.vertexAttribIPointer(indx, size, type, stride, offset);
            else this._gl.vertexAttribPointer(indx, size, type, normalized, stride, offset);
        }
    }
    /**
     * @internal
     */ _bindIndexBufferWithCache(indexBuffer) {
        if (indexBuffer == null) return;
        if (this._cachedIndexBuffer !== indexBuffer) {
            this._cachedIndexBuffer = indexBuffer;
            this.bindIndexBuffer(indexBuffer);
            this._uintIndicesCurrentlySet = indexBuffer.is32Bits;
        }
    }
    _bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers) {
        const attributes = effect.getAttributesNames();
        if (!this._vaoRecordInProgress) this._unbindVertexArrayObject();
        this.unbindAllAttributes();
        for(let index = 0; index < attributes.length; index++){
            const order = effect.getAttributeLocation(index);
            if (order >= 0) {
                const ai = attributes[index];
                let vertexBuffer = null;
                if (overrideVertexBuffers) vertexBuffer = overrideVertexBuffers[ai];
                if (!vertexBuffer) vertexBuffer = vertexBuffers[ai];
                if (!vertexBuffer) continue;
                this._gl.enableVertexAttribArray(order);
                if (!this._vaoRecordInProgress) this._vertexAttribArraysEnabled[order] = true;
                const buffer = vertexBuffer.getBuffer();
                if (buffer) {
                    this._vertexAttribPointer(buffer, order, vertexBuffer.getSize(), vertexBuffer.type, vertexBuffer.normalized, vertexBuffer.byteStride, vertexBuffer.byteOffset);
                    if (vertexBuffer.getIsInstanced()) {
                        this._gl.vertexAttribDivisor(order, vertexBuffer.getInstanceDivisor());
                        if (!this._vaoRecordInProgress) {
                            this._currentInstanceLocations.push(order);
                            this._currentInstanceBuffers.push(buffer);
                        }
                    }
                }
            }
        }
    }
    /**
     * Records a vertex array object
     * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
     * @param vertexBuffers defines the list of vertex buffers to store
     * @param indexBuffer defines the index buffer to store
     * @param effect defines the effect to store
     * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
     * @returns the new vertex array object
     */ recordVertexArrayObject(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        const vao = this._gl.createVertexArray();
        if (!vao) throw new Error("Unable to create VAO");
        this._vaoRecordInProgress = true;
        this._gl.bindVertexArray(vao);
        this._mustWipeVertexAttributes = true;
        this._bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers);
        this.bindIndexBuffer(indexBuffer);
        this._vaoRecordInProgress = false;
        this._gl.bindVertexArray(null);
        return vao;
    }
    /**
     * Bind a specific vertex array object
     * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
     * @param vertexArrayObject defines the vertex array object to bind
     * @param indexBuffer defines the index buffer to bind
     */ bindVertexArrayObject(vertexArrayObject, indexBuffer) {
        if (this._cachedVertexArrayObject !== vertexArrayObject) {
            this._cachedVertexArrayObject = vertexArrayObject;
            this._gl.bindVertexArray(vertexArrayObject);
            this._cachedVertexBuffers = null;
            this._cachedIndexBuffer = null;
            this._uintIndicesCurrentlySet = indexBuffer != null && indexBuffer.is32Bits;
            this._mustWipeVertexAttributes = true;
        }
    }
    /**
     * Bind webGl buffers directly to the webGL context
     * @param vertexBuffer defines the vertex buffer to bind
     * @param indexBuffer defines the index buffer to bind
     * @param vertexDeclaration defines the vertex declaration to use with the vertex buffer
     * @param vertexStrideSize defines the vertex stride of the vertex buffer
     * @param effect defines the effect associated with the vertex buffer
     */ bindBuffersDirectly(vertexBuffer, indexBuffer, vertexDeclaration, vertexStrideSize, effect) {
        if (this._cachedVertexBuffers !== vertexBuffer || this._cachedEffectForVertexBuffers !== effect) {
            this._cachedVertexBuffers = vertexBuffer;
            this._cachedEffectForVertexBuffers = effect;
            const attributesCount = effect.getAttributesCount();
            this._unbindVertexArrayObject();
            this.unbindAllAttributes();
            let offset = 0;
            for(let index = 0; index < attributesCount; index++)if (index < vertexDeclaration.length) {
                const order = effect.getAttributeLocation(index);
                if (order >= 0) {
                    this._gl.enableVertexAttribArray(order);
                    this._vertexAttribArraysEnabled[order] = true;
                    this._vertexAttribPointer(vertexBuffer, order, vertexDeclaration[index], this._gl.FLOAT, false, vertexStrideSize, offset);
                }
                offset += vertexDeclaration[index] * 4;
            }
        }
        this._bindIndexBufferWithCache(indexBuffer);
    }
    _unbindVertexArrayObject() {
        if (!this._cachedVertexArrayObject) return;
        this._cachedVertexArrayObject = null;
        this._gl.bindVertexArray(null);
    }
    /**
     * Bind a list of vertex buffers to the webGL context
     * @param vertexBuffers defines the list of vertex buffers to bind
     * @param indexBuffer defines the index buffer to bind
     * @param effect defines the effect associated with the vertex buffers
     * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
     */ bindBuffers(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        if (this._cachedVertexBuffers !== vertexBuffers || this._cachedEffectForVertexBuffers !== effect) {
            this._cachedVertexBuffers = vertexBuffers;
            this._cachedEffectForVertexBuffers = effect;
            this._bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers);
        }
        this._bindIndexBufferWithCache(indexBuffer);
    }
    /**
     * Unbind all instance attributes
     */ unbindInstanceAttributes() {
        let boundBuffer;
        for(let i = 0, ul = this._currentInstanceLocations.length; i < ul; i++){
            const instancesBuffer = this._currentInstanceBuffers[i];
            if (boundBuffer != instancesBuffer && instancesBuffer.references) {
                boundBuffer = instancesBuffer;
                this.bindArrayBuffer(instancesBuffer);
            }
            const offsetLocation = this._currentInstanceLocations[i];
            this._gl.vertexAttribDivisor(offsetLocation, 0);
        }
        this._currentInstanceBuffers.length = 0;
        this._currentInstanceLocations.length = 0;
    }
    /**
     * Release and free the memory of a vertex array object
     * @param vao defines the vertex array object to delete
     */ releaseVertexArrayObject(vao) {
        this._gl.deleteVertexArray(vao);
    }
    /**
     * @internal
     */ _releaseBuffer(buffer) {
        buffer.references--;
        if (buffer.references === 0) {
            this._deleteBuffer(buffer);
            return true;
        }
        return false;
    }
    _deleteBuffer(buffer) {
        this._gl.deleteBuffer(buffer.underlyingResource);
    }
    /**
     * Update the content of a webGL buffer used with instantiation and bind it to the webGL context
     * @param instancesBuffer defines the webGL buffer to update and bind
     * @param data defines the data to store in the buffer
     * @param offsetLocations defines the offsets or attributes information used to determine where data must be stored in the buffer
     */ updateAndBindInstancesBuffer(instancesBuffer, data, offsetLocations) {
        this.bindArrayBuffer(instancesBuffer);
        if (data) this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
        if (offsetLocations[0].index !== undefined) this.bindInstancesBuffer(instancesBuffer, offsetLocations, true);
        else for(let index = 0; index < 4; index++){
            const offsetLocation = offsetLocations[index];
            if (!this._vertexAttribArraysEnabled[offsetLocation]) {
                this._gl.enableVertexAttribArray(offsetLocation);
                this._vertexAttribArraysEnabled[offsetLocation] = true;
            }
            this._vertexAttribPointer(instancesBuffer, offsetLocation, 4, this._gl.FLOAT, false, 64, index * 16);
            this._gl.vertexAttribDivisor(offsetLocation, 1);
            this._currentInstanceLocations.push(offsetLocation);
            this._currentInstanceBuffers.push(instancesBuffer);
        }
    }
    /**
     * Bind the content of a webGL buffer used with instantiation
     * @param instancesBuffer defines the webGL buffer to bind
     * @param attributesInfo defines the offsets or attributes information used to determine where data must be stored in the buffer
     * @param computeStride defines Whether to compute the strides from the info or use the default 0
     */ bindInstancesBuffer(instancesBuffer, attributesInfo, computeStride = true) {
        this.bindArrayBuffer(instancesBuffer);
        let stride = 0;
        if (computeStride) for(let i = 0; i < attributesInfo.length; i++){
            const ai = attributesInfo[i];
            stride += ai.attributeSize * 4;
        }
        for(let i = 0; i < attributesInfo.length; i++){
            const ai = attributesInfo[i];
            if (ai.index === undefined) ai.index = this._currentEffect.getAttributeLocationByName(ai.attributeName);
            if (ai.index < 0) continue;
            if (!this._vertexAttribArraysEnabled[ai.index]) {
                this._gl.enableVertexAttribArray(ai.index);
                this._vertexAttribArraysEnabled[ai.index] = true;
            }
            this._vertexAttribPointer(instancesBuffer, ai.index, ai.attributeSize, ai.attributeType || this._gl.FLOAT, ai.normalized || false, stride, ai.offset);
            this._gl.vertexAttribDivisor(ai.index, ai.divisor === undefined ? 1 : ai.divisor);
            this._currentInstanceLocations.push(ai.index);
            this._currentInstanceBuffers.push(instancesBuffer);
        }
    }
    /**
     * Disable the instance attribute corresponding to the name in parameter
     * @param name defines the name of the attribute to disable
     */ disableInstanceAttributeByName(name) {
        if (!this._currentEffect) return;
        const attributeLocation = this._currentEffect.getAttributeLocationByName(name);
        this.disableInstanceAttribute(attributeLocation);
    }
    /**
     * Disable the instance attribute corresponding to the location in parameter
     * @param attributeLocation defines the attribute location of the attribute to disable
     */ disableInstanceAttribute(attributeLocation) {
        let shouldClean = false;
        let index;
        while((index = this._currentInstanceLocations.indexOf(attributeLocation)) !== -1){
            this._currentInstanceLocations.splice(index, 1);
            this._currentInstanceBuffers.splice(index, 1);
            shouldClean = true;
            index = this._currentInstanceLocations.indexOf(attributeLocation);
        }
        if (shouldClean) {
            this._gl.vertexAttribDivisor(attributeLocation, 0);
            this.disableAttributeByIndex(attributeLocation);
        }
    }
    /**
     * Disable the attribute corresponding to the location in parameter
     * @param attributeLocation defines the attribute location of the attribute to disable
     */ disableAttributeByIndex(attributeLocation) {
        this._gl.disableVertexAttribArray(attributeLocation);
        this._vertexAttribArraysEnabled[attributeLocation] = false;
        this._currentBufferPointers[attributeLocation].active = false;
    }
    /**
     * Send a draw order
     * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ draw(useTriangles, indexStart, indexCount, instancesCount) {
        this.drawElementsType(useTriangles ? 0 : 1, indexStart, indexCount, instancesCount);
    }
    /**
     * Draw a list of points
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawPointClouds(verticesStart, verticesCount, instancesCount) {
        this.drawArraysType(2, verticesStart, verticesCount, instancesCount);
    }
    /**
     * Draw a list of unindexed primitives
     * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawUnIndexed(useTriangles, verticesStart, verticesCount, instancesCount) {
        this.drawArraysType(useTriangles ? 0 : 1, verticesStart, verticesCount, instancesCount);
    }
    /**
     * Draw a list of indexed primitives
     * @param fillMode defines the primitive to use
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawElementsType(fillMode, indexStart, indexCount, instancesCount) {
        // Apply states
        this.applyStates();
        this._reportDrawCall();
        // Render
        const drawMode = this._drawMode(fillMode);
        const indexFormat = this._uintIndicesCurrentlySet ? this._gl.UNSIGNED_INT : this._gl.UNSIGNED_SHORT;
        const mult = this._uintIndicesCurrentlySet ? 4 : 2;
        if (instancesCount) this._gl.drawElementsInstanced(drawMode, indexCount, indexFormat, indexStart * mult, instancesCount);
        else this._gl.drawElements(drawMode, indexCount, indexFormat, indexStart * mult);
    }
    /**
     * Draw a list of unindexed primitives
     * @param fillMode defines the primitive to use
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawArraysType(fillMode, verticesStart, verticesCount, instancesCount) {
        // Apply states
        this.applyStates();
        this._reportDrawCall();
        const drawMode = this._drawMode(fillMode);
        if (instancesCount) this._gl.drawArraysInstanced(drawMode, verticesStart, verticesCount, instancesCount);
        else this._gl.drawArrays(drawMode, verticesStart, verticesCount);
    }
    _drawMode(fillMode) {
        switch(fillMode){
            // Triangle views
            case 0:
                return this._gl.TRIANGLES;
            case 2:
                return this._gl.POINTS;
            case 1:
                return this._gl.LINES;
            // Draw modes
            case 3:
                return this._gl.POINTS;
            case 4:
                return this._gl.LINES;
            case 5:
                return this._gl.LINE_LOOP;
            case 6:
                return this._gl.LINE_STRIP;
            case 7:
                return this._gl.TRIANGLE_STRIP;
            case 8:
                return this._gl.TRIANGLE_FAN;
            default:
                return this._gl.TRIANGLES;
        }
    }
    // Shaders
    /**
     * @internal
     */ _releaseEffect(effect) {
        if (this._compiledEffects[effect._key]) delete this._compiledEffects[effect._key];
        const pipelineContext = effect.getPipelineContext();
        if (pipelineContext) this._deletePipelineContext(pipelineContext);
    }
    /**
     * @internal
     */ _deletePipelineContext(pipelineContext) {
        const webGLPipelineContext = pipelineContext;
        if (webGLPipelineContext && webGLPipelineContext.program) {
            webGLPipelineContext.program.__SPECTOR_rebuildProgram = null;
            (0, $4kP5d.resetCachedPipeline)(webGLPipelineContext);
            if (this._gl) this._gl.deleteProgram(webGLPipelineContext.program);
        }
    }
    /**
     * @internal
     */ _getGlobalDefines(defines) {
        return (0, $cOV0H._getGlobalDefines)(defines, this.isNDCHalfZRange, this.useReverseDepthBuffer, this.useExactSrgbConversions);
    }
    /**
     * Create a new effect (used to store vertex/fragment shaders)
     * @param baseName defines the base name of the effect (The name of file without .fragment.fx or .vertex.fx)
     * @param attributesNamesOrOptions defines either a list of attribute names or an IEffectCreationOptions object
     * @param uniformsNamesOrEngine defines either a list of uniform names or the engine to use
     * @param samplers defines an array of string used to represent textures
     * @param defines defines the string containing the defines to use to compile the shaders
     * @param fallbacks defines the list of potential fallbacks to use if shader compilation fails
     * @param onCompiled defines a function to call when the effect creation is successful
     * @param onError defines a function to call when the effect creation has failed
     * @param indexParameters defines an object containing the index values to use to compile shaders (like the maximum number of simultaneous lights)
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     * @param extraInitializationsAsync additional async code to run before preparing the effect
     * @returns the new Effect
     */ createEffect(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, defines, fallbacks, onCompiled, onError, indexParameters, shaderLanguage = 0 /* ShaderLanguage.GLSL */ , extraInitializationsAsync) {
        const vertex = typeof baseName === "string" ? baseName : baseName.vertexToken || baseName.vertexSource || baseName.vertexElement || baseName.vertex;
        const fragment = typeof baseName === "string" ? baseName : baseName.fragmentToken || baseName.fragmentSource || baseName.fragmentElement || baseName.fragment;
        const globalDefines = this._getGlobalDefines();
        let fullDefines = defines ?? attributesNamesOrOptions.defines ?? "";
        if (globalDefines) fullDefines += globalDefines;
        const name = vertex + "+" + fragment + "@" + fullDefines;
        if (this._compiledEffects[name]) {
            const compiledEffect = this._compiledEffects[name];
            if (onCompiled && compiledEffect.isReady()) onCompiled(compiledEffect);
            compiledEffect._refCount++;
            return compiledEffect;
        }
        if (this._gl) (0, $d2IE3.getStateObject)(this._gl);
        const effect = new (0, $lUDWq.Effect)(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, this, defines, fallbacks, onCompiled, onError, indexParameters, name, attributesNamesOrOptions.shaderLanguage ?? shaderLanguage, attributesNamesOrOptions.extraInitializationsAsync ?? extraInitializationsAsync);
        this._compiledEffects[name] = effect;
        return effect;
    }
    /**
     * @internal
     */ _getShaderSource(shader) {
        return this._gl.getShaderSource(shader);
    }
    /**
     * Directly creates a webGL program
     * @param pipelineContext  defines the pipeline context to attach to
     * @param vertexCode defines the vertex shader code to use
     * @param fragmentCode defines the fragment shader code to use
     * @param context defines the webGL context to use (if not set, the current one will be used)
     * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
     * @returns the new webGL program
     */ createRawShaderProgram(pipelineContext, vertexCode, fragmentCode, context, transformFeedbackVaryings = null) {
        const stateObject = (0, $d2IE3.getStateObject)(this._gl);
        stateObject._contextWasLost = this._contextWasLost;
        stateObject.validateShaderPrograms = this.validateShaderPrograms;
        return (0, $d2IE3.createRawShaderProgram)(pipelineContext, vertexCode, fragmentCode, context || this._gl, transformFeedbackVaryings);
    }
    /**
     * Creates a webGL program
     * @param pipelineContext  defines the pipeline context to attach to
     * @param vertexCode  defines the vertex shader code to use
     * @param fragmentCode defines the fragment shader code to use
     * @param defines defines the string containing the defines to use to compile the shaders
     * @param context defines the webGL context to use (if not set, the current one will be used)
     * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
     * @returns the new webGL program
     */ createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null) {
        const stateObject = (0, $d2IE3.getStateObject)(this._gl);
        // assure the state object is correct
        stateObject._contextWasLost = this._contextWasLost;
        stateObject.validateShaderPrograms = this.validateShaderPrograms;
        return (0, $d2IE3.createShaderProgram)(pipelineContext, vertexCode, fragmentCode, defines, context || this._gl, transformFeedbackVaryings);
    }
    /**
     * Inline functions in shader code that are marked to be inlined
     * @param code code to inline
     * @returns inlined code
     */ inlineShaderCode(code) {
        // no inlining needed in the WebGL engine
        return code;
    }
    /**
     * Creates a new pipeline context
     * @param shaderProcessingContext defines the shader processing context used during the processing if available
     * @returns the new pipeline
     */ createPipelineContext(shaderProcessingContext) {
        if (this._gl) {
            const stateObject = (0, $d2IE3.getStateObject)(this._gl);
            stateObject.parallelShaderCompile = this._caps.parallelShaderCompile;
        }
        const context = (0, $d2IE3.createPipelineContext)(this._gl, shaderProcessingContext);
        context.engine = this;
        return context;
    }
    /**
     * Creates a new material context
     * @returns the new context
     */ createMaterialContext() {
        return undefined;
    }
    /**
     * Creates a new draw context
     * @returns the new context
     */ createDrawContext() {
        return undefined;
    }
    _finalizePipelineContext(pipelineContext) {
        return (0, $d2IE3._finalizePipelineContext)(pipelineContext, this._gl, this.validateShaderPrograms);
    }
    /**
     * @internal
     */ _preparePipelineContext(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, rawVertexSourceCode, rawFragmentSourceCode, rebuildRebind, defines, transformFeedbackVaryings, key, onReady) {
        const stateObject = (0, $d2IE3.getStateObject)(this._gl);
        stateObject._contextWasLost = this._contextWasLost;
        stateObject.validateShaderPrograms = this.validateShaderPrograms;
        stateObject._createShaderProgramInjection = this._createShaderProgram.bind(this);
        stateObject.createRawShaderProgramInjection = this.createRawShaderProgram.bind(this);
        stateObject.createShaderProgramInjection = this.createShaderProgram.bind(this);
        stateObject.loadFileInjection = this._loadFile.bind(this);
        return (0, $d2IE3._preparePipelineContext)(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, rawVertexSourceCode, rawFragmentSourceCode, rebuildRebind, defines, transformFeedbackVaryings, key, onReady);
    }
    _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings = null) {
        return (0, $d2IE3._createShaderProgram)(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings);
    }
    /**
     * @internal
     */ _isRenderingStateCompiled(pipelineContext) {
        if (this._isDisposed) return false;
        return (0, $d2IE3._isRenderingStateCompiled)(pipelineContext, this._gl, this.validateShaderPrograms);
    }
    /**
     * @internal
     */ _executeWhenRenderingStateIsCompiled(pipelineContext, action) {
        (0, $d2IE3._executeWhenRenderingStateIsCompiled)(pipelineContext, action);
    }
    /**
     * Gets the list of webGL uniform locations associated with a specific program based on a list of uniform names
     * @param pipelineContext defines the pipeline context to use
     * @param uniformsNames defines the list of uniform names
     * @returns an array of webGL uniform locations
     */ getUniforms(pipelineContext, uniformsNames) {
        const results = new Array();
        const webGLPipelineContext = pipelineContext;
        for(let index = 0; index < uniformsNames.length; index++)results.push(this._gl.getUniformLocation(webGLPipelineContext.program, uniformsNames[index]));
        return results;
    }
    /**
     * Gets the list of active attributes for a given webGL program
     * @param pipelineContext defines the pipeline context to use
     * @param attributesNames defines the list of attribute names to get
     * @returns an array of indices indicating the offset of each attribute
     */ getAttributes(pipelineContext, attributesNames) {
        const results = [];
        const webGLPipelineContext = pipelineContext;
        for(let index = 0; index < attributesNames.length; index++)try {
            results.push(this._gl.getAttribLocation(webGLPipelineContext.program, attributesNames[index]));
        } catch (e) {
            results.push(-1);
        }
        return results;
    }
    /**
     * Activates an effect, making it the current one (ie. the one used for rendering)
     * @param effect defines the effect to activate
     */ enableEffect(effect) {
        effect = effect !== null && (0, $hqVRr.IsWrapper)(effect) ? effect.effect : effect; // get only the effect, we don't need a Wrapper in the WebGL engine
        if (!effect || effect === this._currentEffect) return;
        this._stencilStateComposer.stencilMaterial = undefined;
        effect;
        // Use program
        this.bindSamplers(effect);
        this._currentEffect = effect;
        if (effect.onBind) effect.onBind(effect);
        if (effect._onBindObservable) effect._onBindObservable.notifyObservers(effect);
    }
    /**
     * Set the value of an uniform to a number (int)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the int number to store
     * @returns true if the value was set
     */ setInt(uniform, value) {
        if (!uniform) return false;
        this._gl.uniform1i(uniform, value);
        return true;
    }
    /**
     * Set the value of an uniform to a int2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if the value was set
     */ setInt2(uniform, x, y) {
        if (!uniform) return false;
        this._gl.uniform2i(uniform, x, y);
        return true;
    }
    /**
     * Set the value of an uniform to a int3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if the value was set
     */ setInt3(uniform, x, y, z) {
        if (!uniform) return false;
        this._gl.uniform3i(uniform, x, y, z);
        return true;
    }
    /**
     * Set the value of an uniform to a int4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if the value was set
     */ setInt4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._gl.uniform4i(uniform, x, y, z, w);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray(uniform, array) {
        if (!uniform) return false;
        this._gl.uniform1iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray2(uniform, array) {
        if (!uniform || array.length % 2 !== 0) return false;
        this._gl.uniform2iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray3(uniform, array) {
        if (!uniform || array.length % 3 !== 0) return false;
        this._gl.uniform3iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray4(uniform, array) {
        if (!uniform || array.length % 4 !== 0) return false;
        this._gl.uniform4iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to a number (unsigned int)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the unsigned int number to store
     * @returns true if the value was set
     */ setUInt(uniform, value) {
        if (!uniform) return false;
        this._gl.uniform1ui(uniform, value);
        return true;
    }
    /**
     * Set the value of an uniform to a unsigned int2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if the value was set
     */ setUInt2(uniform, x, y) {
        if (!uniform) return false;
        this._gl.uniform2ui(uniform, x, y);
        return true;
    }
    /**
     * Set the value of an uniform to a unsigned int3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if the value was set
     */ setUInt3(uniform, x, y, z) {
        if (!uniform) return false;
        this._gl.uniform3ui(uniform, x, y, z);
        return true;
    }
    /**
     * Set the value of an uniform to a unsigned int4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if the value was set
     */ setUInt4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._gl.uniform4ui(uniform, x, y, z, w);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray(uniform, array) {
        if (!uniform) return false;
        this._gl.uniform1uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32 (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray2(uniform, array) {
        if (!uniform || array.length % 2 !== 0) return false;
        this._gl.uniform2uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32 (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray3(uniform, array) {
        if (!uniform || array.length % 3 !== 0) return false;
        this._gl.uniform3uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32 (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray4(uniform, array) {
        if (!uniform || array.length % 4 !== 0) return false;
        this._gl.uniform4uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray(uniform, array) {
        if (!uniform) return false;
        if (array.length < 1) return false;
        this._gl.uniform1fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray2(uniform, array) {
        if (!uniform || array.length % 2 !== 0) return false;
        this._gl.uniform2fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray3(uniform, array) {
        if (!uniform || array.length % 3 !== 0) return false;
        this._gl.uniform3fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray4(uniform, array) {
        if (!uniform || array.length % 4 !== 0) return false;
        this._gl.uniform4fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32 (stored as matrices)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrices defines the array of float32 to store
     * @returns true if the value was set
     */ setMatrices(uniform, matrices) {
        if (!uniform) return false;
        this._gl.uniformMatrix4fv(uniform, false, matrices);
        return true;
    }
    /**
     * Set the value of an uniform to a matrix (3x3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrix defines the Float32Array representing the 3x3 matrix to store
     * @returns true if the value was set
     */ setMatrix3x3(uniform, matrix) {
        if (!uniform) return false;
        this._gl.uniformMatrix3fv(uniform, false, matrix);
        return true;
    }
    /**
     * Set the value of an uniform to a matrix (2x2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrix defines the Float32Array representing the 2x2 matrix to store
     * @returns true if the value was set
     */ setMatrix2x2(uniform, matrix) {
        if (!uniform) return false;
        this._gl.uniformMatrix2fv(uniform, false, matrix);
        return true;
    }
    /**
     * Set the value of an uniform to a number (float)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the float number to store
     * @returns true if the value was transferred
     */ setFloat(uniform, value) {
        if (!uniform) return false;
        this._gl.uniform1f(uniform, value);
        return true;
    }
    /**
     * Set the value of an uniform to a vec2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if the value was set
     */ setFloat2(uniform, x, y) {
        if (!uniform) return false;
        this._gl.uniform2f(uniform, x, y);
        return true;
    }
    /**
     * Set the value of an uniform to a vec3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if the value was set
     */ setFloat3(uniform, x, y, z) {
        if (!uniform) return false;
        this._gl.uniform3f(uniform, x, y, z);
        return true;
    }
    /**
     * Set the value of an uniform to a vec4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if the value was set
     */ setFloat4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._gl.uniform4f(uniform, x, y, z, w);
        return true;
    }
    // States
    /**
     * Apply all cached states (depth, culling, stencil and alpha)
     */ applyStates() {
        this._depthCullingState.apply(this._gl);
        this._stencilStateComposer.apply(this._gl);
        this._alphaState.apply(this._gl);
        if (this._colorWriteChanged) {
            this._colorWriteChanged = false;
            const enable = this._colorWrite;
            this._gl.colorMask(enable, enable, enable, enable);
        }
    }
    // Textures
    /**
     * Force the entire cache to be cleared
     * You should not have to use this function unless your engine needs to share the webGL context with another engine
     * @param bruteForce defines a boolean to force clearing ALL caches (including stencil, detoh and alpha states)
     */ wipeCaches(bruteForce) {
        if (this.preventCacheWipeBetweenFrames && !bruteForce) return;
        this._currentEffect = null;
        this._viewportCached.x = 0;
        this._viewportCached.y = 0;
        this._viewportCached.z = 0;
        this._viewportCached.w = 0;
        // Done before in case we clean the attributes
        this._unbindVertexArrayObject();
        if (bruteForce) {
            this._currentProgram = null;
            this.resetTextureCache();
            this._stencilStateComposer.reset();
            this._depthCullingState.reset();
            this._depthCullingState.depthFunc = this._gl.LEQUAL;
            this._alphaState.reset();
            this._alphaMode = 1;
            this._alphaEquation = 0;
            this._colorWrite = true;
            this._colorWriteChanged = true;
            this._unpackFlipYCached = null;
            this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE);
            this._gl.pixelStorei(this._gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
            this._mustWipeVertexAttributes = true;
            this.unbindAllAttributes();
        }
        this._resetVertexBufferBinding();
        this._cachedIndexBuffer = null;
        this._cachedEffectForVertexBuffers = null;
        this.bindIndexBuffer(null);
    }
    /**
     * @internal
     */ _getSamplingParameters(samplingMode, generateMipMaps) {
        const gl = this._gl;
        let magFilter = gl.NEAREST;
        let minFilter = gl.NEAREST;
        switch(samplingMode){
            case 11:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_NEAREST;
                else minFilter = gl.LINEAR;
                break;
            case 3:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_LINEAR;
                else minFilter = gl.LINEAR;
                break;
            case 8:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_LINEAR;
                else minFilter = gl.NEAREST;
                break;
            case 4:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_NEAREST;
                else minFilter = gl.NEAREST;
                break;
            case 5:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_NEAREST;
                else minFilter = gl.LINEAR;
                break;
            case 6:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_LINEAR;
                else minFilter = gl.LINEAR;
                break;
            case 7:
                magFilter = gl.NEAREST;
                minFilter = gl.LINEAR;
                break;
            case 1:
                magFilter = gl.NEAREST;
                minFilter = gl.NEAREST;
                break;
            case 9:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_NEAREST;
                else minFilter = gl.NEAREST;
                break;
            case 10:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_LINEAR;
                else minFilter = gl.NEAREST;
                break;
            case 2:
                magFilter = gl.LINEAR;
                minFilter = gl.LINEAR;
                break;
            case 12:
                magFilter = gl.LINEAR;
                minFilter = gl.NEAREST;
                break;
        }
        return {
            min: minFilter,
            mag: magFilter
        };
    }
    /** @internal */ _createTexture() {
        const texture = this._gl.createTexture();
        if (!texture) throw new Error("Unable to create texture");
        return texture;
    }
    /** @internal */ _createHardwareTexture() {
        return new (0, $8ClRi.WebGLHardwareTexture)(this._createTexture(), this._gl);
    }
    /**
     * Creates an internal texture without binding it to a framebuffer
     * @internal
     * @param size defines the size of the texture
     * @param options defines the options used to create the texture
     * @param delayGPUTextureCreation true to delay the texture creation the first time it is really needed. false to create it right away
     * @param source source type of the texture
     * @returns a new internal texture
     */ _createInternalTexture(size, options, delayGPUTextureCreation = true, source = 0 /* InternalTextureSource.Unknown */ ) {
        let generateMipMaps = false;
        let createMipMaps = false;
        let type = 0;
        let samplingMode = 3;
        let format = 5;
        let useSRGBBuffer = false;
        let samples = 1;
        let label;
        let createMSAATexture = false;
        let comparisonFunction = 0;
        if (options !== undefined && typeof options === "object") {
            generateMipMaps = !!options.generateMipMaps;
            createMipMaps = !!options.createMipMaps;
            type = options.type === undefined ? 0 : options.type;
            samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
            format = options.format === undefined ? 5 : options.format;
            useSRGBBuffer = options.useSRGBBuffer === undefined ? false : options.useSRGBBuffer;
            samples = options.samples ?? 1;
            label = options.label;
            createMSAATexture = !!options.createMSAATexture;
            comparisonFunction = options.comparisonFunction || 0;
        } else generateMipMaps = !!options;
        useSRGBBuffer && (useSRGBBuffer = this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU));
        if (type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        if (type === 1 && !this._caps.textureFloat) {
            type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Type forced to TEXTURETYPE_UNSIGNED_BYTE");
        }
        const isDepthTexture = (0, $aees9.IsDepthTexture)(format);
        const hasStencil = (0, $aees9.HasStencilAspect)(format);
        const gl = this._gl;
        const texture = new (0, $b9e4a.InternalTexture)(this, source);
        const width = size.width || size;
        const height = size.height || size;
        const depth = size.depth || 0;
        const layers = size.layers || 0;
        const filters = this._getSamplingParameters(samplingMode, (generateMipMaps || createMipMaps) && !isDepthTexture);
        const target = layers !== 0 ? gl.TEXTURE_2D_ARRAY : depth !== 0 ? gl.TEXTURE_3D : gl.TEXTURE_2D;
        const sizedFormat = isDepthTexture ? this._getInternalFormatFromDepthTextureFormat(format, true, hasStencil) : this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
        const internalFormat = isDepthTexture ? hasStencil ? gl.DEPTH_STENCIL : gl.DEPTH_COMPONENT : this._getInternalFormat(format);
        const textureType = isDepthTexture ? this._getWebGLTextureTypeFromDepthTextureFormat(format) : this._getWebGLTextureType(type);
        // Bind
        this._bindTextureDirectly(target, texture);
        if (layers !== 0) {
            texture.is2DArray = true;
            gl.texImage3D(target, 0, sizedFormat, width, height, layers, 0, internalFormat, textureType, null);
        } else if (depth !== 0) {
            texture.is3D = true;
            gl.texImage3D(target, 0, sizedFormat, width, height, depth, 0, internalFormat, textureType, null);
        } else gl.texImage2D(target, 0, sizedFormat, width, height, 0, internalFormat, textureType, null);
        gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filters.min);
        gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        if (isDepthTexture && this.webGLVersion > 1) {
            if (comparisonFunction === 0) {
                gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, 515);
                gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.NONE);
            } else {
                gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            }
        }
        // MipMaps
        if (generateMipMaps || createMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
        texture._useSRGBBuffer = useSRGBBuffer;
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.depth = layers || depth;
        texture.isReady = true;
        texture.samples = samples;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.type = type;
        texture.format = format;
        texture.label = label;
        texture.comparisonFunction = comparisonFunction;
        this._internalTexturesCache.push(texture);
        if (createMSAATexture) {
            let renderBuffer = null;
            if ((0, $aees9.IsDepthTexture)(texture.format)) renderBuffer = this._setupFramebufferDepthAttachments((0, $aees9.HasStencilAspect)(texture.format), texture.format !== 19, texture.width, texture.height, samples, texture.format, true);
            else renderBuffer = this._createRenderBuffer(texture.width, texture.height, samples, -1 /* not used */ , this._getRGBABufferInternalSizedFormat(texture.type, texture.format, texture._useSRGBBuffer), -1 /* attachment */ );
            if (!renderBuffer) throw new Error("Unable to create render buffer");
            texture._autoMSAAManagement = true;
            let hardwareTexture = texture._hardwareTexture;
            if (!hardwareTexture) hardwareTexture = texture._hardwareTexture = this._createHardwareTexture();
            hardwareTexture.addMSAARenderBuffer(renderBuffer);
        }
        return texture;
    }
    /**
     * @internal
     */ _getUseSRGBBuffer(useSRGBBuffer, noMipmap) {
        // Generating mipmaps for sRGB textures is not supported in WebGL1 so we must disable the support if mipmaps is enabled
        return useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || noMipmap);
    }
    /**
     * Usually called from Texture.ts.
     * Passed information to create a WebGLTexture
     * @param url defines a value which contains one of the following:
     * * A conventional http URL, e.g. 'http://...' or 'file://...'
     * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
     * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
     * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
     * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
     * @param scene needed for loading to the correct scene
     * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
     * @param onLoad optional callback to be called upon successful completion
     * @param onError optional callback to be called upon failure
     * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
     * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
     * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param mimeType defines an optional mime type
     * @param loaderOptions options to be passed to the loader
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns a InternalTexture for assignment back into BABYLON.Texture
     */ createTexture(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, creationFlags, useSRGBBuffer) {
        return this._createTextureBase(url, noMipmap, invertY, scene, samplingMode, onLoad, onError, (...args)=>this._prepareWebGLTexture(...args, format), (potWidth, potHeight, img, extension, texture, continuationCallback)=>{
            const gl = this._gl;
            const isPot = img.width === potWidth && img.height === potHeight;
            texture._creationFlags = creationFlags ?? 0;
            const tip = this._getTexImageParametersForCreateTexture(texture.format, texture._useSRGBBuffer);
            if (isPot) {
                gl.texImage2D(gl.TEXTURE_2D, 0, tip.internalFormat, tip.format, tip.type, img);
                return false;
            }
            const maxTextureSize = this._caps.maxTextureSize;
            if (img.width > maxTextureSize || img.height > maxTextureSize || !this._supportsHardwareTextureRescaling) {
                this._prepareWorkingCanvas();
                if (!this._workingCanvas || !this._workingContext) return false;
                this._workingCanvas.width = potWidth;
                this._workingCanvas.height = potHeight;
                this._workingContext.drawImage(img, 0, 0, img.width, img.height, 0, 0, potWidth, potHeight);
                gl.texImage2D(gl.TEXTURE_2D, 0, tip.internalFormat, tip.format, tip.type, this._workingCanvas);
                texture.width = potWidth;
                texture.height = potHeight;
                return false;
            } else {
                // Using shaders when possible to rescale because canvas.drawImage is lossy
                const source = new (0, $b9e4a.InternalTexture)(this, 2 /* InternalTextureSource.Temp */ );
                this._bindTextureDirectly(gl.TEXTURE_2D, source, true);
                gl.texImage2D(gl.TEXTURE_2D, 0, tip.internalFormat, tip.format, tip.type, img);
                this._rescaleTexture(source, texture, scene, tip.format, ()=>{
                    this._releaseTexture(source);
                    this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
                    continuationCallback();
                });
            }
            return true;
        }, buffer, fallback, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
    }
    /**
     * Calls to the GL texImage2D and texImage3D functions require three arguments describing the pixel format of the texture.
     * createTexture derives these from the babylonFormat and useSRGBBuffer arguments and also the file extension of the URL it's working with.
     * This function encapsulates that derivation for easy unit testing.
     * @param babylonFormat Babylon's format enum, as specified in ITextureCreationOptions.
     * @param fileExtension The file extension including the dot, e.g. .jpg.
     * @param useSRGBBuffer Use SRGB not linear.
     * @returns The options to pass to texImage2D or texImage3D calls.
     * @internal
     */ _getTexImageParametersForCreateTexture(babylonFormat, useSRGBBuffer) {
        let format, internalFormat;
        if (this.webGLVersion === 1) {
            // In WebGL 1, format and internalFormat must be the same and taken from a limited set of values, see https://docs.gl/es2/glTexImage2D.
            // The SRGB extension (https://developer.mozilla.org/en-US/docs/Web/API/EXT_sRGB) adds some extra values, hence passing useSRGBBuffer
            // to getInternalFormat.
            format = this._getInternalFormat(babylonFormat, useSRGBBuffer);
            internalFormat = format;
        } else {
            // In WebGL 2, format has a wider range of values and internal format can be one of the sized formats, see
            // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml.
            // SRGB is included in the sized format and should not be passed in "format", hence always passing useSRGBBuffer as false.
            format = this._getInternalFormat(babylonFormat, false);
            internalFormat = this._getRGBABufferInternalSizedFormat(0, babylonFormat, useSRGBBuffer);
        }
        return {
            internalFormat: internalFormat,
            format: format,
            type: this._gl.UNSIGNED_BYTE
        };
    }
    /**
     * @internal
     */ _rescaleTexture(source, destination, scene, internalFormat, onComplete) {}
    /**
     * @internal
     */ _unpackFlipY(value) {
        if (this._unpackFlipYCached !== value) {
            this._gl.pixelStorei(this._gl.UNPACK_FLIP_Y_WEBGL, value ? 1 : 0);
            if (this.enableUnpackFlipYCached) this._unpackFlipYCached = value;
        }
    }
    /** @internal */ _getUnpackAlignement() {
        return this._gl.getParameter(this._gl.UNPACK_ALIGNMENT);
    }
    /** @internal */ _getTextureTarget(texture) {
        if (texture.isCube) return this._gl.TEXTURE_CUBE_MAP;
        else if (texture.is3D) return this._gl.TEXTURE_3D;
        else if (texture.is2DArray || texture.isMultiview) return this._gl.TEXTURE_2D_ARRAY;
        return this._gl.TEXTURE_2D;
    }
    /**
     * Update the sampling mode of a given texture
     * @param samplingMode defines the required sampling mode
     * @param texture defines the texture to update
     * @param generateMipMaps defines whether to generate mipmaps for the texture
     */ updateTextureSamplingMode(samplingMode, texture, generateMipMaps = false) {
        const target = this._getTextureTarget(texture);
        const filters = this._getSamplingParameters(samplingMode, texture.useMipMaps || generateMipMaps);
        this._setTextureParameterInteger(target, this._gl.TEXTURE_MAG_FILTER, filters.mag, texture);
        this._setTextureParameterInteger(target, this._gl.TEXTURE_MIN_FILTER, filters.min);
        if (generateMipMaps) {
            texture.generateMipMaps = true;
            this._gl.generateMipmap(target);
        }
        this._bindTextureDirectly(target, null);
        texture.samplingMode = samplingMode;
    }
    /**
     * Update the dimensions of a texture
     * @param texture texture to update
     * @param width new width of the texture
     * @param height new height of the texture
     * @param depth new depth of the texture
     */ updateTextureDimensions(texture, width, height, depth = 1) {}
    /**
     * Update the sampling mode of a given texture
     * @param texture defines the texture to update
     * @param wrapU defines the texture wrap mode of the u coordinates
     * @param wrapV defines the texture wrap mode of the v coordinates
     * @param wrapR defines the texture wrap mode of the r coordinates
     */ updateTextureWrappingMode(texture, wrapU, wrapV = null, wrapR = null) {
        const target = this._getTextureTarget(texture);
        if (wrapU !== null) {
            this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(wrapU), texture);
            texture._cachedWrapU = wrapU;
        }
        if (wrapV !== null) {
            this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(wrapV), texture);
            texture._cachedWrapV = wrapV;
        }
        if ((texture.is2DArray || texture.is3D) && wrapR !== null) {
            this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(wrapR), texture);
            texture._cachedWrapR = wrapR;
        }
        this._bindTextureDirectly(target, null);
    }
    /**
     * @internal
     */ _uploadCompressedDataToTextureDirectly(texture, internalFormat, width, height, data, faceIndex = 0, lod = 0) {
        const gl = this._gl;
        let target = gl.TEXTURE_2D;
        if (texture.isCube) target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
        if (texture._useSRGBBuffer) switch(internalFormat){
            case 37492:
            case 36196:
                // Note, if using ETC1 and sRGB is requested, this will use ETC2 if available.
                if (this._caps.etc2) internalFormat = gl.COMPRESSED_SRGB8_ETC2;
                else texture._useSRGBBuffer = false;
                break;
            case 37496:
                if (this._caps.etc2) internalFormat = gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
                else texture._useSRGBBuffer = false;
                break;
            case 36492:
                internalFormat = gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
                break;
            case 37808:
                internalFormat = gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
                break;
            case 33776:
                if (this._caps.s3tc_srgb) internalFormat = gl.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                else // S3TC sRGB extension not supported
                texture._useSRGBBuffer = false;
                break;
            case 33777:
                if (this._caps.s3tc_srgb) internalFormat = gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                else // S3TC sRGB extension not supported
                texture._useSRGBBuffer = false;
                break;
            case 33779:
                if (this._caps.s3tc_srgb) internalFormat = gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                else // S3TC sRGB extension not supported
                texture._useSRGBBuffer = false;
                break;
            default:
                // We don't support a sRGB format corresponding to internalFormat, so revert to non sRGB format
                texture._useSRGBBuffer = false;
                break;
        }
        this._gl.compressedTexImage2D(target, lod, internalFormat, width, height, 0, data);
    }
    /**
     * @internal
     */ _uploadDataToTextureDirectly(texture, imageData, faceIndex = 0, lod = 0, babylonInternalFormat, useTextureWidthAndHeight = false) {
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(texture.type);
        const format = this._getInternalFormat(texture.format);
        const internalFormat = babylonInternalFormat === undefined ? this._getRGBABufferInternalSizedFormat(texture.type, texture.format, texture._useSRGBBuffer) : this._getInternalFormat(babylonInternalFormat, texture._useSRGBBuffer);
        this._unpackFlipY(texture.invertY);
        let target = gl.TEXTURE_2D;
        if (texture.isCube) target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
        const lodMaxWidth = Math.round(Math.log(texture.width) * Math.LOG2E);
        const lodMaxHeight = Math.round(Math.log(texture.height) * Math.LOG2E);
        const width = useTextureWidthAndHeight ? texture.width : Math.pow(2, Math.max(lodMaxWidth - lod, 0));
        const height = useTextureWidthAndHeight ? texture.height : Math.pow(2, Math.max(lodMaxHeight - lod, 0));
        gl.texImage2D(target, lod, internalFormat, width, height, 0, format, textureType, imageData);
    }
    /**
     * Update a portion of an internal texture
     * @param texture defines the texture to update
     * @param imageData defines the data to store into the texture
     * @param xOffset defines the x coordinates of the update rectangle
     * @param yOffset defines the y coordinates of the update rectangle
     * @param width defines the width of the update rectangle
     * @param height defines the height of the update rectangle
     * @param faceIndex defines the face index if texture is a cube (0 by default)
     * @param lod defines the lod level to update (0 by default)
     * @param generateMipMaps defines whether to generate mipmaps or not
     */ updateTextureData(texture, imageData, xOffset, yOffset, width, height, faceIndex = 0, lod = 0, generateMipMaps = false) {
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(texture.type);
        const format = this._getInternalFormat(texture.format);
        this._unpackFlipY(texture.invertY);
        let targetForBinding = gl.TEXTURE_2D;
        let target = gl.TEXTURE_2D;
        if (texture.isCube) {
            target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
            targetForBinding = gl.TEXTURE_CUBE_MAP;
        }
        this._bindTextureDirectly(targetForBinding, texture, true);
        gl.texSubImage2D(target, lod, xOffset, yOffset, width, height, format, textureType, imageData);
        if (generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(targetForBinding, null);
    }
    /**
     * @internal
     */ _uploadArrayBufferViewToTexture(texture, imageData, faceIndex = 0, lod = 0) {
        const gl = this._gl;
        const bindTarget = texture.isCube ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D;
        this._bindTextureDirectly(bindTarget, texture, true);
        this._uploadDataToTextureDirectly(texture, imageData, faceIndex, lod);
        this._bindTextureDirectly(bindTarget, null, true);
    }
    _prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode) {
        const gl = this._gl;
        if (!gl) return;
        const filters = this._getSamplingParameters(samplingMode, !noMipmap);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filters.min);
        if (!noMipmap && !isCompressed) gl.generateMipmap(gl.TEXTURE_2D);
        this._bindTextureDirectly(gl.TEXTURE_2D, null);
        // this.resetTextureCache();
        if (scene) scene.removePendingData(texture);
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
    }
    _prepareWebGLTexture(texture, extension, scene, img, invertY, noMipmap, isCompressed, processFunction, samplingMode, format) {
        const maxTextureSize = this.getCaps().maxTextureSize;
        const potWidth = Math.min(maxTextureSize, this.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(img.width, maxTextureSize) : img.width);
        const potHeight = Math.min(maxTextureSize, this.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(img.height, maxTextureSize) : img.height);
        const gl = this._gl;
        if (!gl) return;
        if (!texture._hardwareTexture) {
            //  this.resetTextureCache();
            if (scene) scene.removePendingData(texture);
            return;
        }
        this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
        this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
        texture.baseWidth = img.width;
        texture.baseHeight = img.height;
        texture.width = potWidth;
        texture.height = potHeight;
        texture.isReady = true;
        texture.type = texture.type !== -1 ? texture.type : 0;
        texture.format = texture.format !== -1 ? texture.format : format ?? (extension === ".jpg" && !texture._useSRGBBuffer ? 4 : 5);
        if (processFunction(potWidth, potHeight, img, extension, texture, ()=>{
            this._prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode);
        })) // Returning as texture needs extra async steps
        return;
        this._prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode);
    }
    _getInternalFormatFromDepthTextureFormat(textureFormat, hasDepth, hasStencil) {
        const gl = this._gl;
        if (!hasDepth) return gl.STENCIL_INDEX8;
        const format = hasStencil ? gl.DEPTH_STENCIL : gl.DEPTH_COMPONENT;
        let internalFormat = format;
        if (this.webGLVersion > 1) {
            if (textureFormat === 15) internalFormat = gl.DEPTH_COMPONENT16;
            else if (textureFormat === 16) internalFormat = gl.DEPTH_COMPONENT24;
            else if (textureFormat === 17 || textureFormat === 13) internalFormat = hasStencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
            else if (textureFormat === 14) internalFormat = gl.DEPTH_COMPONENT32F;
            else if (textureFormat === 18) internalFormat = hasStencil ? gl.DEPTH32F_STENCIL8 : gl.DEPTH_COMPONENT32F;
        } else internalFormat = gl.DEPTH_COMPONENT16;
        return internalFormat;
    }
    _getWebGLTextureTypeFromDepthTextureFormat(textureFormat) {
        const gl = this._gl;
        let type = gl.UNSIGNED_INT;
        if (textureFormat === 15) type = gl.UNSIGNED_SHORT;
        else if (textureFormat === 17 || textureFormat === 13) type = gl.UNSIGNED_INT_24_8;
        else if (textureFormat === 14) type = gl.FLOAT;
        else if (textureFormat === 18) type = gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
        else if (textureFormat === 19) type = gl.UNSIGNED_BYTE;
        return type;
    }
    /**
     * @internal
     */ _setupFramebufferDepthAttachments(generateStencilBuffer, generateDepthBuffer, width, height, samples = 1, depthTextureFormat, dontBindRenderBufferToFrameBuffer = false) {
        const gl = this._gl;
        depthTextureFormat = depthTextureFormat ?? (generateStencilBuffer ? 13 : 14);
        const internalFormat = this._getInternalFormatFromDepthTextureFormat(depthTextureFormat, generateDepthBuffer, generateStencilBuffer);
        // Create the depth/stencil buffer
        if (generateStencilBuffer && generateDepthBuffer) return this._createRenderBuffer(width, height, samples, gl.DEPTH_STENCIL, internalFormat, dontBindRenderBufferToFrameBuffer ? -1 : gl.DEPTH_STENCIL_ATTACHMENT);
        if (generateDepthBuffer) return this._createRenderBuffer(width, height, samples, internalFormat, internalFormat, dontBindRenderBufferToFrameBuffer ? -1 : gl.DEPTH_ATTACHMENT);
        if (generateStencilBuffer) return this._createRenderBuffer(width, height, samples, internalFormat, internalFormat, dontBindRenderBufferToFrameBuffer ? -1 : gl.STENCIL_ATTACHMENT);
        return null;
    }
    /**
     * @internal
     */ _createRenderBuffer(width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer = true) {
        const gl = this._gl;
        const renderBuffer = gl.createRenderbuffer();
        return this._updateRenderBuffer(renderBuffer, width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer);
    }
    _updateRenderBuffer(renderBuffer, width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer = true) {
        const gl = this._gl;
        gl.bindRenderbuffer(gl.RENDERBUFFER, renderBuffer);
        if (samples > 1 && gl.renderbufferStorageMultisample) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, msInternalFormat, width, height);
        else gl.renderbufferStorage(gl.RENDERBUFFER, internalFormat, width, height);
        if (attachment !== -1) gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, renderBuffer);
        if (unbindBuffer) gl.bindRenderbuffer(gl.RENDERBUFFER, null);
        return renderBuffer;
    }
    /**
     * @internal
     */ _releaseTexture(texture) {
        this._deleteTexture(texture._hardwareTexture);
        // Unbind channels
        this.unbindAllTextures();
        const index = this._internalTexturesCache.indexOf(texture);
        if (index !== -1) this._internalTexturesCache.splice(index, 1);
        // Integrated fixed lod samplers.
        if (texture._lodTextureHigh) texture._lodTextureHigh.dispose();
        if (texture._lodTextureMid) texture._lodTextureMid.dispose();
        if (texture._lodTextureLow) texture._lodTextureLow.dispose();
        // Integrated irradiance map.
        if (texture._irradianceTexture) texture._irradianceTexture.dispose();
    }
    _deleteTexture(texture) {
        texture?.release();
    }
    _setProgram(program) {
        if (this._currentProgram !== program) {
            (0, $d2IE3._setProgram)(program, this._gl);
            this._currentProgram = program;
        }
    }
    /**
     * Binds an effect to the webGL context
     * @param effect defines the effect to bind
     */ bindSamplers(effect) {
        const webGLPipelineContext = effect.getPipelineContext();
        this._setProgram(webGLPipelineContext.program);
        const samplers = effect.getSamplers();
        for(let index = 0; index < samplers.length; index++){
            const uniform = effect.getUniform(samplers[index]);
            if (uniform) this._boundUniforms[index] = uniform;
        }
        this._currentEffect = null;
    }
    _activateCurrentTexture() {
        if (this._currentTextureChannel !== this._activeChannel) {
            this._gl.activeTexture(this._gl.TEXTURE0 + this._activeChannel);
            this._currentTextureChannel = this._activeChannel;
        }
    }
    /**
     * @internal
     */ _bindTextureDirectly(target, texture, forTextureDataUpdate = false, force = false) {
        let wasPreviouslyBound = false;
        const isTextureForRendering = texture && texture._associatedChannel > -1;
        if (forTextureDataUpdate && isTextureForRendering) this._activeChannel = texture._associatedChannel;
        const currentTextureBound = this._boundTexturesCache[this._activeChannel];
        if (currentTextureBound !== texture || force) {
            this._activateCurrentTexture();
            if (texture && texture.isMultiview) {
                //this._gl.bindTexture(target, texture ? texture._colorTextureArray : null);
                (0, $kVtWi.Logger).Error([
                    "_bindTextureDirectly called with a multiview texture!",
                    target,
                    texture
                ]);
                // eslint-disable-next-line no-throw-literal
                throw "_bindTextureDirectly called with a multiview texture!";
            } else this._gl.bindTexture(target, texture?._hardwareTexture?.underlyingResource ?? null);
            this._boundTexturesCache[this._activeChannel] = texture;
            if (texture) texture._associatedChannel = this._activeChannel;
        } else if (forTextureDataUpdate) {
            wasPreviouslyBound = true;
            this._activateCurrentTexture();
        }
        if (isTextureForRendering && !forTextureDataUpdate) this._bindSamplerUniformToChannel(texture._associatedChannel, this._activeChannel);
        return wasPreviouslyBound;
    }
    /**
     * @internal
     */ _bindTexture(channel, texture, name) {
        if (channel === undefined) return;
        if (texture) texture._associatedChannel = channel;
        this._activeChannel = channel;
        const target = texture ? this._getTextureTarget(texture) : this._gl.TEXTURE_2D;
        this._bindTextureDirectly(target, texture);
    }
    /**
     * Unbind all textures from the webGL context
     */ unbindAllTextures() {
        for(let channel = 0; channel < this._maxSimultaneousTextures; channel++){
            this._activeChannel = channel;
            this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
            if (this.webGLVersion > 1) {
                this._bindTextureDirectly(this._gl.TEXTURE_3D, null);
                this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null);
            }
        }
    }
    /**
     * Sets a texture to the according uniform.
     * @param channel The texture channel
     * @param uniform The uniform to set
     * @param texture The texture to apply
     * @param name The name of the uniform in the effect
     */ setTexture(channel, uniform, texture, name) {
        if (channel === undefined) return;
        if (uniform) this._boundUniforms[channel] = uniform;
        this._setTexture(channel, texture);
    }
    _bindSamplerUniformToChannel(sourceSlot, destination) {
        const uniform = this._boundUniforms[sourceSlot];
        if (!uniform || uniform._currentState === destination) return;
        this._gl.uniform1i(uniform, destination);
        uniform._currentState = destination;
    }
    _getTextureWrapMode(mode) {
        switch(mode){
            case 1:
                return this._gl.REPEAT;
            case 0:
                return this._gl.CLAMP_TO_EDGE;
            case 2:
                return this._gl.MIRRORED_REPEAT;
        }
        return this._gl.REPEAT;
    }
    _setTexture(channel, texture, isPartOfTextureArray = false, depthStencilTexture = false, name = "") {
        // Not ready?
        if (!texture) {
            if (this._boundTexturesCache[channel] != null) {
                this._activeChannel = channel;
                this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
                this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
                if (this.webGLVersion > 1) {
                    this._bindTextureDirectly(this._gl.TEXTURE_3D, null);
                    this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null);
                }
            }
            return false;
        }
        // Video
        if (texture.video) {
            this._activeChannel = channel;
            const videoInternalTexture = texture.getInternalTexture();
            if (videoInternalTexture) videoInternalTexture._associatedChannel = channel;
            texture.update();
        } else if (texture.delayLoadState === 4) {
            // Delay loading
            texture.delayLoad();
            return false;
        }
        let internalTexture;
        if (depthStencilTexture) internalTexture = texture.depthStencilTexture;
        else if (texture.isReady()) internalTexture = texture.getInternalTexture();
        else if (texture.isCube) internalTexture = this.emptyCubeTexture;
        else if (texture.is3D) internalTexture = this.emptyTexture3D;
        else if (texture.is2DArray) internalTexture = this.emptyTexture2DArray;
        else internalTexture = this.emptyTexture;
        if (!isPartOfTextureArray && internalTexture) internalTexture._associatedChannel = channel;
        let needToBind = true;
        if (this._boundTexturesCache[channel] === internalTexture) {
            if (!isPartOfTextureArray) this._bindSamplerUniformToChannel(internalTexture._associatedChannel, channel);
            needToBind = false;
        }
        this._activeChannel = channel;
        const target = this._getTextureTarget(internalTexture);
        if (needToBind) this._bindTextureDirectly(target, internalTexture, isPartOfTextureArray);
        if (internalTexture && !internalTexture.isMultiview) {
            // CUBIC_MODE and SKYBOX_MODE both require CLAMP_TO_EDGE.  All other modes use REPEAT.
            if (internalTexture.isCube && internalTexture._cachedCoordinatesMode !== texture.coordinatesMode) {
                internalTexture._cachedCoordinatesMode = texture.coordinatesMode;
                const textureWrapMode = texture.coordinatesMode !== 3 && texture.coordinatesMode !== 5 ? 1 : 0;
                texture.wrapU = textureWrapMode;
                texture.wrapV = textureWrapMode;
            }
            if (internalTexture._cachedWrapU !== texture.wrapU) {
                internalTexture._cachedWrapU = texture.wrapU;
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(texture.wrapU), internalTexture);
            }
            if (internalTexture._cachedWrapV !== texture.wrapV) {
                internalTexture._cachedWrapV = texture.wrapV;
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(texture.wrapV), internalTexture);
            }
            if (internalTexture.is3D && internalTexture._cachedWrapR !== texture.wrapR) {
                internalTexture._cachedWrapR = texture.wrapR;
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(texture.wrapR), internalTexture);
            }
            this._setAnisotropicLevel(target, internalTexture, texture.anisotropicFilteringLevel);
        }
        return true;
    }
    /**
     * Sets an array of texture to the webGL context
     * @param channel defines the channel where the texture array must be set
     * @param uniform defines the associated uniform location
     * @param textures defines the array of textures to bind
     * @param name name of the channel
     */ setTextureArray(channel, uniform, textures, name) {
        if (channel === undefined || !uniform) return;
        if (!this._textureUnits || this._textureUnits.length !== textures.length) this._textureUnits = new Int32Array(textures.length);
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i].getInternalTexture();
            if (texture) {
                this._textureUnits[i] = channel + i;
                texture._associatedChannel = channel + i;
            } else this._textureUnits[i] = -1;
        }
        this._gl.uniform1iv(uniform, this._textureUnits);
        for(let index = 0; index < textures.length; index++)this._setTexture(this._textureUnits[index], textures[index], true);
    }
    /**
     * @internal
     */ _setAnisotropicLevel(target, internalTexture, anisotropicFilteringLevel) {
        const anisotropicFilterExtension = this._caps.textureAnisotropicFilterExtension;
        if (internalTexture.samplingMode !== 11 && internalTexture.samplingMode !== 3 && internalTexture.samplingMode !== 2) anisotropicFilteringLevel = 1; // Forcing the anisotropic to 1 because else webgl will force filters to linear
        if (anisotropicFilterExtension && internalTexture._cachedAnisotropicFilteringLevel !== anisotropicFilteringLevel) {
            this._setTextureParameterFloat(target, anisotropicFilterExtension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(anisotropicFilteringLevel, this._caps.maxAnisotropy), internalTexture);
            internalTexture._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
        }
    }
    _setTextureParameterFloat(target, parameter, value, texture) {
        this._bindTextureDirectly(target, texture, true, true);
        this._gl.texParameterf(target, parameter, value);
    }
    _setTextureParameterInteger(target, parameter, value, texture) {
        if (texture) this._bindTextureDirectly(target, texture, true, true);
        this._gl.texParameteri(target, parameter, value);
    }
    /**
     * Unbind all vertex attributes from the webGL context
     */ unbindAllAttributes() {
        if (this._mustWipeVertexAttributes) {
            this._mustWipeVertexAttributes = false;
            for(let i = 0; i < this._caps.maxVertexAttribs; i++)this.disableAttributeByIndex(i);
            return;
        }
        for(let i = 0, ul = this._vertexAttribArraysEnabled.length; i < ul; i++){
            if (i >= this._caps.maxVertexAttribs || !this._vertexAttribArraysEnabled[i]) continue;
            this.disableAttributeByIndex(i);
        }
    }
    /**
     * Force the engine to release all cached effects. This means that next effect compilation will have to be done completely even if a similar effect was already compiled
     */ releaseEffects() {
        this._compiledEffects = {};
        this.onReleaseEffectsObservable.notifyObservers(this);
    }
    /**
     * Dispose and release all associated resources
     */ dispose() {
        // Events
        if ((0, $jFz47.IsWindowObjectExist)()) {
            if (this._renderingCanvas) {
                this._renderingCanvas.removeEventListener("webglcontextlost", this._onContextLost);
                if (this._onContextRestored) this._renderingCanvas.removeEventListener("webglcontextrestored", this._onContextRestored);
            }
        }
        // Should not be moved up of renderingCanvas will be null.
        super.dispose();
        if (this._dummyFramebuffer) this._gl.deleteFramebuffer(this._dummyFramebuffer);
        // Unbind
        this.unbindAllAttributes();
        this._boundUniforms = {};
        this._workingCanvas = null;
        this._workingContext = null;
        this._currentBufferPointers.length = 0;
        this._currentProgram = null;
        if (this._creationOptions.loseContextOnDispose) this._gl.getExtension("WEBGL_lose_context")?.loseContext();
        // clear the state object
        (0, $d2IE3.deleteStateObject)(this._gl);
    }
    /**
     * Attach a new callback raised when context lost event is fired
     * @param callback defines the callback to call
     */ attachContextLostEvent(callback) {
        if (this._renderingCanvas) this._renderingCanvas.addEventListener("webglcontextlost", callback, false);
    }
    /**
     * Attach a new callback raised when context restored event is fired
     * @param callback defines the callback to call
     */ attachContextRestoredEvent(callback) {
        if (this._renderingCanvas) this._renderingCanvas.addEventListener("webglcontextrestored", callback, false);
    }
    /**
     * Get the current error code of the webGL context
     * @returns the error code
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getError
     */ getError() {
        return this._gl.getError();
    }
    _canRenderToFloatFramebuffer() {
        if (this._webGLVersion > 1) return this._caps.colorBufferFloat;
        return this._canRenderToFramebuffer(1);
    }
    _canRenderToHalfFloatFramebuffer() {
        if (this._webGLVersion > 1) return this._caps.colorBufferFloat;
        return this._canRenderToFramebuffer(2);
    }
    // Thank you : http://stackoverflow.com/questions/28827511/webgl-ios-render-to-floating-point-texture
    _canRenderToFramebuffer(type) {
        const gl = this._gl;
        //clear existing errors
        // eslint-disable-next-line no-empty
        while(gl.getError() !== gl.NO_ERROR);
        let successful = true;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, this._getRGBABufferInternalSizedFormat(type), 1, 1, 0, gl.RGBA, this._getWebGLTextureType(type), null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        const fb = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
        successful = successful && status === gl.FRAMEBUFFER_COMPLETE;
        successful = successful && gl.getError() === gl.NO_ERROR;
        //try render by clearing frame buffer's color buffer
        if (successful) {
            gl.clear(gl.COLOR_BUFFER_BIT);
            successful = successful && gl.getError() === gl.NO_ERROR;
        }
        //try reading from frame to ensure render occurs (just creating the FBO is not sufficient to determine if rendering is supported)
        if (successful) {
            //in practice it's sufficient to just read from the backbuffer rather than handle potentially issues reading from the texture
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            const readFormat = gl.RGBA;
            const readType = gl.UNSIGNED_BYTE;
            const buffer = new Uint8Array(4);
            gl.readPixels(0, 0, 1, 1, readFormat, readType, buffer);
            successful = successful && gl.getError() === gl.NO_ERROR;
        }
        //clean up
        gl.deleteTexture(texture);
        gl.deleteFramebuffer(fb);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        //clear accumulated errors
        // eslint-disable-next-line no-empty
        while(!successful && gl.getError() !== gl.NO_ERROR);
        return successful;
    }
    /**
     * @internal
     */ _getWebGLTextureType(type) {
        if (this._webGLVersion === 1) {
            switch(type){
                case 1:
                    return this._gl.FLOAT;
                case 2:
                    return this._gl.HALF_FLOAT_OES;
                case 0:
                    return this._gl.UNSIGNED_BYTE;
                case 8:
                    return this._gl.UNSIGNED_SHORT_4_4_4_4;
                case 9:
                    return this._gl.UNSIGNED_SHORT_5_5_5_1;
                case 10:
                    return this._gl.UNSIGNED_SHORT_5_6_5;
            }
            return this._gl.UNSIGNED_BYTE;
        }
        switch(type){
            case 3:
                return this._gl.BYTE;
            case 0:
                return this._gl.UNSIGNED_BYTE;
            case 4:
                return this._gl.SHORT;
            case 5:
                return this._gl.UNSIGNED_SHORT;
            case 6:
                return this._gl.INT;
            case 7:
                return this._gl.UNSIGNED_INT;
            case 1:
                return this._gl.FLOAT;
            case 2:
                return this._gl.HALF_FLOAT;
            case 8:
                return this._gl.UNSIGNED_SHORT_4_4_4_4;
            case 9:
                return this._gl.UNSIGNED_SHORT_5_5_5_1;
            case 10:
                return this._gl.UNSIGNED_SHORT_5_6_5;
            case 11:
                return this._gl.UNSIGNED_INT_2_10_10_10_REV;
            case 12:
                return this._gl.UNSIGNED_INT_24_8;
            case 13:
                return this._gl.UNSIGNED_INT_10F_11F_11F_REV;
            case 14:
                return this._gl.UNSIGNED_INT_5_9_9_9_REV;
            case 15:
                return this._gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
        }
        return this._gl.UNSIGNED_BYTE;
    }
    /**
     * @internal
     */ _getInternalFormat(format, useSRGBBuffer = false) {
        let internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
        switch(format){
            case 0:
                internalFormat = this._gl.ALPHA;
                break;
            case 1:
                internalFormat = this._gl.LUMINANCE;
                break;
            case 2:
                internalFormat = this._gl.LUMINANCE_ALPHA;
                break;
            case 6:
            case 33322:
            case 36760:
                internalFormat = this._gl.RED;
                break;
            case 7:
            case 33324:
            case 36761:
                internalFormat = this._gl.RG;
                break;
            case 4:
            case 32852:
            case 36762:
                internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
                break;
            case 5:
            case 32859:
            case 36763:
                internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
                break;
        }
        if (this._webGLVersion > 1) switch(format){
            case 8:
                internalFormat = this._gl.RED_INTEGER;
                break;
            case 9:
                internalFormat = this._gl.RG_INTEGER;
                break;
            case 10:
                internalFormat = this._gl.RGB_INTEGER;
                break;
            case 11:
                internalFormat = this._gl.RGBA_INTEGER;
                break;
        }
        return internalFormat;
    }
    /**
     * @internal
     */ _getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer = false) {
        if (this._webGLVersion === 1) {
            if (format !== undefined) switch(format){
                case 0:
                    return this._gl.ALPHA;
                case 1:
                    return this._gl.LUMINANCE;
                case 2:
                    return this._gl.LUMINANCE_ALPHA;
                case 4:
                    return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
            }
            return this._gl.RGBA;
        }
        switch(type){
            case 3:
                switch(format){
                    case 6:
                        return this._gl.R8_SNORM;
                    case 7:
                        return this._gl.RG8_SNORM;
                    case 4:
                        return this._gl.RGB8_SNORM;
                    case 8:
                        return this._gl.R8I;
                    case 9:
                        return this._gl.RG8I;
                    case 10:
                        return this._gl.RGB8I;
                    case 11:
                        return this._gl.RGBA8I;
                    default:
                        return this._gl.RGBA8_SNORM;
                }
            case 0:
                switch(format){
                    case 6:
                        return this._gl.R8;
                    case 7:
                        return this._gl.RG8;
                    case 4:
                        return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8 : this._gl.RGB8; // By default. Other possibilities are RGB565, SRGB8.
                    case 5:
                        return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8; // By default. Other possibilities are RGB5_A1, RGBA4, SRGB8_ALPHA8.
                    case 8:
                        return this._gl.R8UI;
                    case 9:
                        return this._gl.RG8UI;
                    case 10:
                        return this._gl.RGB8UI;
                    case 11:
                        return this._gl.RGBA8UI;
                    case 0:
                        return this._gl.ALPHA;
                    case 1:
                        return this._gl.LUMINANCE;
                    case 2:
                        return this._gl.LUMINANCE_ALPHA;
                    default:
                        return this._gl.RGBA8;
                }
            case 4:
                switch(format){
                    case 8:
                        return this._gl.R16I;
                    case 36760:
                        return this._gl.R16_SNORM_EXT;
                    case 36761:
                        return this._gl.RG16_SNORM_EXT;
                    case 36762:
                        return this._gl.RGB16_SNORM_EXT;
                    case 36763:
                        return this._gl.RGBA16_SNORM_EXT;
                    case 9:
                        return this._gl.RG16I;
                    case 10:
                        return this._gl.RGB16I;
                    case 11:
                        return this._gl.RGBA16I;
                    default:
                        return this._gl.RGBA16I;
                }
            case 5:
                switch(format){
                    case 8:
                        return this._gl.R16UI;
                    case 33322:
                        return this._gl.R16_EXT;
                    case 33324:
                        return this._gl.RG16_EXT;
                    case 32852:
                        return this._gl.RGB16_EXT;
                    case 32859:
                        return this._gl.RGBA16_EXT;
                    case 9:
                        return this._gl.RG16UI;
                    case 10:
                        return this._gl.RGB16UI;
                    case 11:
                        return this._gl.RGBA16UI;
                    default:
                        return this._gl.RGBA16UI;
                }
            case 6:
                switch(format){
                    case 8:
                        return this._gl.R32I;
                    case 9:
                        return this._gl.RG32I;
                    case 10:
                        return this._gl.RGB32I;
                    case 11:
                        return this._gl.RGBA32I;
                    default:
                        return this._gl.RGBA32I;
                }
            case 7:
                switch(format){
                    case 8:
                        return this._gl.R32UI;
                    case 9:
                        return this._gl.RG32UI;
                    case 10:
                        return this._gl.RGB32UI;
                    case 11:
                        return this._gl.RGBA32UI;
                    default:
                        return this._gl.RGBA32UI;
                }
            case 1:
                switch(format){
                    case 6:
                        return this._gl.R32F; // By default. Other possibility is R16F.
                    case 7:
                        return this._gl.RG32F; // By default. Other possibility is RG16F.
                    case 4:
                        return this._gl.RGB32F; // By default. Other possibilities are RGB16F, R11F_G11F_B10F, RGB9_E5.
                    case 5:
                        return this._gl.RGBA32F; // By default. Other possibility is RGBA16F.
                    default:
                        return this._gl.RGBA32F;
                }
            case 2:
                switch(format){
                    case 6:
                        return this._gl.R16F;
                    case 7:
                        return this._gl.RG16F;
                    case 4:
                        return this._gl.RGB16F; // By default. Other possibilities are R11F_G11F_B10F, RGB9_E5.
                    case 5:
                        return this._gl.RGBA16F;
                    default:
                        return this._gl.RGBA16F;
                }
            case 10:
                return this._gl.RGB565;
            case 13:
                return this._gl.R11F_G11F_B10F;
            case 14:
                return this._gl.RGB9_E5;
            case 8:
                return this._gl.RGBA4;
            case 9:
                return this._gl.RGB5_A1;
            case 11:
                switch(format){
                    case 5:
                        return this._gl.RGB10_A2; // By default. Other possibility is RGB5_A1.
                    case 11:
                        return this._gl.RGB10_A2UI;
                    default:
                        return this._gl.RGB10_A2;
                }
        }
        return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8;
    }
    /**
     * Reads pixels from the current frame buffer. Please note that this function can be slow
     * @param x defines the x coordinate of the rectangle where pixels must be read
     * @param y defines the y coordinate of the rectangle where pixels must be read
     * @param width defines the width of the rectangle where pixels must be read
     * @param height defines the height of the rectangle where pixels must be read
     * @param hasAlpha defines whether the output should have alpha or not (defaults to true)
     * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
     * @returns a ArrayBufferView promise (Uint8Array) containing RGBA colors
     */ readPixels(x, y, width, height, hasAlpha = true, flushRenderer = true) {
        const numChannels = hasAlpha ? 4 : 3;
        const format = hasAlpha ? this._gl.RGBA : this._gl.RGB;
        const data = new Uint8Array(height * width * numChannels);
        if (flushRenderer) this.flushFramebuffer();
        this._gl.readPixels(x, y, width, height, format, this._gl.UNSIGNED_BYTE, data);
        return Promise.resolve(data);
    }
    /**
     * Gets a Promise<boolean> indicating if the engine can be instantiated (ie. if a webGL context can be found)
     */ static get IsSupportedAsync() {
        return Promise.resolve(this.isSupported());
    }
    /**
     * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
     */ static get IsSupported() {
        return this.isSupported(); // Backward compat
    }
    /**
     * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
     * @returns true if the engine can be created
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static isSupported() {
        if (this._HasMajorPerformanceCaveat !== null) return !this._HasMajorPerformanceCaveat; // We know it is performant so WebGL is supported
        if (this._IsSupported === null) try {
            const tempcanvas = (0, $dUFoQ.AbstractEngine)._CreateCanvas(1, 1);
            const gl = tempcanvas.getContext("webgl") || tempcanvas.getContext("experimental-webgl");
            this._IsSupported = gl != null && !!window.WebGLRenderingContext;
        } catch (e) {
            this._IsSupported = false;
        }
        return this._IsSupported;
    }
    /**
     * Gets a boolean indicating if the engine can be instantiated on a performant device (ie. if a webGL context can be found and it does not use a slow implementation)
     */ static get HasMajorPerformanceCaveat() {
        if (this._HasMajorPerformanceCaveat === null) try {
            const tempcanvas = (0, $dUFoQ.AbstractEngine)._CreateCanvas(1, 1);
            const gl = tempcanvas.getContext("webgl", {
                failIfMajorPerformanceCaveat: true
            }) || tempcanvas.getContext("experimental-webgl", {
                failIfMajorPerformanceCaveat: true
            });
            this._HasMajorPerformanceCaveat = !gl;
        } catch (e) {
            this._HasMajorPerformanceCaveat = false;
        }
        return this._HasMajorPerformanceCaveat;
    }
}
$1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32 = new Uint32Array(4);
$1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32 = new Int32Array(4);
/** Use this array to turn off some WebGL2 features on known buggy browsers version */ $1a819ede290e980a$export$bfb63ef0b91d03e9.ExceptionList = [
    {
        key: "Chrome/63.0",
        capture: "63\\.0\\.3239\\.(\\d+)",
        captureConstraint: 108,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Firefox/58",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Firefox/59",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Chrome/72.+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Chrome/73.+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Chrome/74.+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Mac OS.+Chrome/71",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Mac OS.+Chrome/72",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Mac OS.+Chrome",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Chrome/12\\d\\..+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    // desktop osx safari 15.4
    {
        key: ".*AppleWebKit.*(15.4).*Safari",
        capture: null,
        captureConstraint: null,
        targets: [
            "antialias",
            "maxMSAASamples"
        ]
    },
    // mobile browsers using safari 15.4 on ios
    {
        key: ".*(15.4).*AppleWebKit.*Safari",
        capture: null,
        captureConstraint: null,
        targets: [
            "antialias",
            "maxMSAASamples"
        ]
    }
];
// eslint-disable-next-line @typescript-eslint/naming-convention
$1a819ede290e980a$export$bfb63ef0b91d03e9._ConcatenateShader = (0, $cOV0H._ConcatenateShader);
// Statics
$1a819ede290e980a$export$bfb63ef0b91d03e9._IsSupported = null;
$1a819ede290e980a$export$bfb63ef0b91d03e9._HasMajorPerformanceCaveat = null;

});
parcelRegister("hqVRr", function(module, exports) {

$parcel$export(module.exports, "IsWrapper", () => $cb11bf5c967f5f4c$export$fc020a550354e4c2);
/**
 * Detect if the effect is a DrawWrapper
 * @param effect defines the entity to test
 * @returns if the entity is a DrawWrapper
 */ function $cb11bf5c967f5f4c$export$fc020a550354e4c2(effect) {
    return effect.getPipelineContext === undefined;
}

});

parcelRegister("6faFW", function(module, exports) {

$parcel$export(module.exports, "WebGLShaderProcessor", () => $48bc6cb5e3d77f22$export$9c673094c18050dc);
/** @internal */ class $48bc6cb5e3d77f22$export$9c673094c18050dc {
    constructor(){
        this.shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
    }
    postProcessor(code, defines, isFragment, processingContext, parameters) {
        // Remove extensions
        if (parameters.drawBuffersExtensionDisabled) {
            // even if enclosed in #if/#endif, IE11 does parse the #extension declaration, so we need to remove it altogether
            const regex = /#extension.+GL_EXT_draw_buffers.+(enable|require)/g;
            code = code.replace(regex, "");
        }
        return code;
    }
}

});

parcelRegister("i1R6L", function(module, exports) {

$parcel$export(module.exports, "WebGL2ShaderProcessor", () => $d20184274f12e3c3$export$93e16198e561ead1);
const $d20184274f12e3c3$var$varyingRegex = /(flat\s)?\s*varying\s*.*/;
class $d20184274f12e3c3$export$93e16198e561ead1 {
    constructor(){
        this.shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
    }
    attributeProcessor(attribute) {
        return attribute.replace("attribute", "in");
    }
    varyingCheck(varying, _isFragment) {
        return $d20184274f12e3c3$var$varyingRegex.test(varying);
    }
    varyingProcessor(varying, isFragment) {
        return varying.replace("varying", isFragment ? "in" : "out");
    }
    postProcessor(code, defines, isFragment) {
        const hasDrawBuffersExtension = code.search(/#extension.+GL_EXT_draw_buffers.+require/) !== -1;
        // Remove extensions
        const regex = /#extension.+(GL_OVR_multiview2|GL_OES_standard_derivatives|GL_EXT_shader_texture_lod|GL_EXT_frag_depth|GL_EXT_draw_buffers).+(enable|require)/g;
        code = code.replace(regex, "");
        // Replace instructions
        code = code.replace(/texture2D\s*\(/g, "texture(");
        if (isFragment) {
            const hasOutput = code.search(/layout *\(location *= *0\) *out/g) !== -1;
            code = code.replace(/texture2DLodEXT\s*\(/g, "textureLod(");
            code = code.replace(/textureCubeLodEXT\s*\(/g, "textureLod(");
            code = code.replace(/textureCube\s*\(/g, "texture(");
            code = code.replace(/gl_FragDepthEXT/g, "gl_FragDepth");
            code = code.replace(/gl_FragColor/g, "glFragColor");
            code = code.replace(/gl_FragData/g, "glFragData");
            code = code.replace(/void\s+?main\s*\(/g, (hasDrawBuffersExtension || hasOutput ? "" : "layout(location = 0) out vec4 glFragColor;\n") + "void main(");
        } else {
            const hasMultiviewExtension = defines.indexOf("#define MULTIVIEW") !== -1;
            if (hasMultiviewExtension) return "#extension GL_OVR_multiview2 : require\nlayout (num_views = 2) in;\n" + code;
        }
        return code;
    }
}

});

parcelRegister("koExS", function(module, exports) {

$parcel$export(module.exports, "WebGLDataBuffer", () => $ed958008223f690e$export$cb9a70451d0ac6d8);

var $6zPKs = parcelRequire("6zPKs");
class $ed958008223f690e$export$cb9a70451d0ac6d8 extends (0, $6zPKs.DataBuffer) {
    constructor(resource){
        super();
        this._buffer = resource;
    }
    get underlyingResource() {
        return this._buffer;
    }
}

});

parcelRegister("8ClRi", function(module, exports) {

$parcel$export(module.exports, "WebGLHardwareTexture", () => $6462d404321370dd$export$ece48379e57ba1fe);
/** @internal */ class $6462d404321370dd$export$ece48379e57ba1fe {
    get underlyingResource() {
        return this._webGLTexture;
    }
    constructor(existingTexture = null, context){
        // There can be multiple buffers for a single WebGL texture because different layers of a 2DArrayTexture / 3DTexture
        // or different faces of a cube texture can be bound to different render targets at the same time.
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this._MSAARenderBuffers = null;
        this._context = context;
        if (!existingTexture) {
            existingTexture = context.createTexture();
            if (!existingTexture) throw new Error("Unable to create webGL texture");
        }
        this.set(existingTexture);
    }
    setUsage() {}
    set(hardwareTexture) {
        this._webGLTexture = hardwareTexture;
    }
    reset() {
        this._webGLTexture = null;
        this._MSAARenderBuffers = null;
    }
    addMSAARenderBuffer(buffer) {
        if (!this._MSAARenderBuffers) this._MSAARenderBuffers = [];
        this._MSAARenderBuffers.push(buffer);
    }
    releaseMSAARenderBuffers() {
        if (this._MSAARenderBuffers) {
            for (const buffer of this._MSAARenderBuffers)this._context.deleteRenderbuffer(buffer);
            this._MSAARenderBuffers = null;
        }
    }
    getMSAARenderBuffer(index = 0) {
        return this._MSAARenderBuffers?.[index] ?? null;
    }
    release() {
        this.releaseMSAARenderBuffers();
        if (this._webGLTexture) this._context.deleteTexture(this._webGLTexture);
        this.reset();
    }
}

});

parcelRegister("aees9", function(module, exports) {

$parcel$export(module.exports, "IsDepthTexture", () => $77266c4493221c77$export$80de36421a841a8f);
$parcel$export(module.exports, "HasStencilAspect", () => $77266c4493221c77$export$74c719a8920420fa);
/**
 * Checks if a given format is a depth texture format
 * @param format Format to check
 * @returns True if the format is a depth texture format
 */ function $77266c4493221c77$export$80de36421a841a8f(format) {
    return format === 13 || format === 14 || format === 15 || format === 16 || format === 17 || format === 18 || format === 19;
}
function $77266c4493221c77$export$68fc8653aef638e(format) {
    switch(format){
        case 13:
        case 17:
        case 18:
        case 14:
        case 16:
            return 1;
        case 15:
            return 5;
        case 19:
            return 0;
    }
    return 0;
}
function $77266c4493221c77$export$74c719a8920420fa(format) {
    return format === 13 || format === 17 || format === 18 || format === 19;
}

});


parcelRegister("aDymS", function(module, exports) {

$parcel$export(module.exports, "PerformanceMonitor", () => $7be834a83633acb2$export$9b229b42dc5ba616);

var $blHSI = parcelRequire("blHSI");
class $7be834a83633acb2$export$9b229b42dc5ba616 {
    /**
     * constructor
     * @param frameSampleSize The number of samples required to saturate the sliding window
     */ constructor(frameSampleSize = 30){
        this._enabled = true;
        this._rollingFrameTime = new $7be834a83633acb2$export$7a96bf227eb00e4(frameSampleSize);
    }
    /**
     * Samples current frame
     * @param timeMs A timestamp in milliseconds of the current frame to compare with other frames
     */ sampleFrame(timeMs = (0, $blHSI.PrecisionDate).Now) {
        if (!this._enabled) return;
        if (this._lastFrameTimeMs != null) {
            const dt = timeMs - this._lastFrameTimeMs;
            this._rollingFrameTime.add(dt);
        }
        this._lastFrameTimeMs = timeMs;
    }
    /**
     * Returns the average frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
     */ get averageFrameTime() {
        return this._rollingFrameTime.average;
    }
    /**
     * Returns the variance frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
     */ get averageFrameTimeVariance() {
        return this._rollingFrameTime.variance;
    }
    /**
     * Returns the frame time of the most recent frame
     */ get instantaneousFrameTime() {
        return this._rollingFrameTime.history(0);
    }
    /**
     * Returns the average framerate in frames per second over the sliding window (or the subset of frames sampled so far)
     */ get averageFPS() {
        return 1000.0 / this._rollingFrameTime.average;
    }
    /**
     * Returns the average framerate in frames per second using the most recent frame time
     */ get instantaneousFPS() {
        const history = this._rollingFrameTime.history(0);
        if (history === 0) return 0;
        return 1000.0 / history;
    }
    /**
     * Returns true if enough samples have been taken to completely fill the sliding window
     */ get isSaturated() {
        return this._rollingFrameTime.isSaturated();
    }
    /**
     * Enables contributions to the sliding window sample set
     */ enable() {
        this._enabled = true;
    }
    /**
     * Disables contributions to the sliding window sample set
     * Samples will not be interpolated over the disabled period
     */ disable() {
        this._enabled = false;
        //clear last sample to avoid interpolating over the disabled period when next enabled
        this._lastFrameTimeMs = null;
    }
    /**
     * Returns true if sampling is enabled
     */ get isEnabled() {
        return this._enabled;
    }
    /**
     * Resets performance monitor
     */ reset() {
        //clear last sample to avoid interpolating over the disabled period when next enabled
        this._lastFrameTimeMs = null;
        //wipe record
        this._rollingFrameTime.reset();
    }
}
class $7be834a83633acb2$export$7a96bf227eb00e4 {
    /**
     * constructor
     * @param length The number of samples required to saturate the sliding window
     */ constructor(length){
        this._samples = new Array(length);
        this.reset();
    }
    /**
     * Adds a sample to the sample set
     * @param v The sample value
     */ add(v) {
        //http://en.wikipedia.org/wiki/Algorithms_for_calculating_variance
        let delta;
        //we need to check if we've already wrapped round
        if (this.isSaturated()) {
            //remove bottom of stack from mean
            const bottomValue = this._samples[this._pos];
            delta = bottomValue - this.average;
            this.average -= delta / (this._sampleCount - 1);
            this._m2 -= delta * (bottomValue - this.average);
        } else this._sampleCount++;
        //add new value to mean
        delta = v - this.average;
        this.average += delta / this._sampleCount;
        this._m2 += delta * (v - this.average);
        //set the new variance
        this.variance = this._m2 / (this._sampleCount - 1);
        this._samples[this._pos] = v;
        this._pos++;
        this._pos %= this._samples.length; //positive wrap around
    }
    /**
     * Returns previously added values or null if outside of history or outside the sliding window domain
     * @param i Index in history. For example, pass 0 for the most recent value and 1 for the value before that
     * @returns Value previously recorded with add() or null if outside of range
     */ history(i) {
        if (i >= this._sampleCount || i >= this._samples.length) return 0;
        const i0 = this._wrapPosition(this._pos - 1.0);
        return this._samples[this._wrapPosition(i0 - i)];
    }
    /**
     * Returns true if enough samples have been taken to completely fill the sliding window
     * @returns true if sample-set saturated
     */ isSaturated() {
        return this._sampleCount >= this._samples.length;
    }
    /**
     * Resets the rolling average (equivalent to 0 samples taken so far)
     */ reset() {
        this.average = 0;
        this.variance = 0;
        this._sampleCount = 0;
        this._pos = 0;
        this._m2 = 0;
    }
    /**
     * Wraps a value around the sample range boundaries
     * @param i Position in sample range, for example if the sample length is 5, and i is -3, then 2 will be returned.
     * @returns Wrapped position in sample range
     */ _wrapPosition(i) {
        const max = this._samples.length;
        return (i % max + max) % max;
    }
}

});

parcelRegister("emm58", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.setAlphaMode = function(mode, noDepthWriteChange = false) {
    if (this._alphaMode === mode) {
        if (!noDepthWriteChange) {
            // Make sure we still have the correct depth mask according to the alpha mode (a transparent material could have forced writting to the depth buffer, for instance)
            const depthMask = mode === 0;
            if (this.depthCullingState.depthMask !== depthMask) this.depthCullingState.depthMask = depthMask;
        }
        return;
    }
    switch(mode){
        case 0:
            this._alphaState.alphaBlend = false;
            break;
        case 7:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 8:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 2:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 6:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ZERO, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 1:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 3:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ZERO, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 4:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_COLOR, this._gl.ZERO, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 5:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 9:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.CONSTANT_COLOR, this._gl.ONE_MINUS_CONSTANT_COLOR, this._gl.CONSTANT_ALPHA, this._gl.ONE_MINUS_CONSTANT_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 10:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 11:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 12:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ZERO);
            this._alphaState.alphaBlend = true;
            break;
        case 13:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE_MINUS_DST_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 14:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 15:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ZERO);
            this._alphaState.alphaBlend = true;
            break;
        case 16:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ZERO, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 17:
            // Same as ALPHA_COMBINE but accumulates (1 - alpha) values in the alpha channel for a later readout in order independant transparency
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
    }
    if (!noDepthWriteChange) this.depthCullingState.depthMask = mode === 0;
    this._alphaMode = mode;
};

});

parcelRegister("e7NUJ", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");

var $wK2xc = parcelRequire("wK2xc");
(0, $2h5JR.ThinEngine).prototype.updateRawTexture = function(texture, data, format, invertY, compression = null, type = 0, useSRGBBuffer = false) {
    if (!texture) return;
    // Babylon's internalSizedFomat but gl's texImage2D internalFormat
    const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
    // Babylon's internalFormat but gl's texImage2D format
    const internalFormat = this._getInternalFormat(format);
    const textureType = this._getWebGLTextureType(type);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
    this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
    if (!this._doNotHandleContextLost) {
        texture._bufferView = data;
        texture.format = format;
        texture.type = type;
        texture.invertY = invertY;
        texture._compression = compression;
    }
    if (texture.width % 4 !== 0) this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1);
    if (compression && data) this._gl.compressedTexImage2D(this._gl.TEXTURE_2D, 0, this.getCaps().s3tc[compression], texture.width, texture.height, 0, data);
    else this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, data);
    if (texture.generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_2D);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
    //  this.resetTextureCache();
    texture.isReady = true;
};
(0, $2h5JR.ThinEngine).prototype.createRawTexture = function(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, // eslint-disable-next-line @typescript-eslint/no-unused-vars
creationFlags = 0, useSRGBBuffer = false) {
    const texture = new (0, $b9e4a.InternalTexture)(this, 3 /* InternalTextureSource.Raw */ );
    texture.baseWidth = width;
    texture.baseHeight = height;
    texture.width = width;
    texture.height = height;
    texture.format = format;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.invertY = invertY;
    texture._compression = compression;
    texture.type = type;
    texture._useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, !generateMipMaps);
    if (!this._doNotHandleContextLost) texture._bufferView = data;
    this.updateRawTexture(texture, data, format, invertY, compression, type, texture._useSRGBBuffer);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
    // Filters
    const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, filters.mag);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, filters.min);
    if (generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_2D);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.createRawCubeTexture = function(data, size, format, type, generateMipMaps, invertY, samplingMode, compression = null) {
    const gl = this._gl;
    const texture = new (0, $b9e4a.InternalTexture)(this, 8 /* InternalTextureSource.CubeRaw */ );
    texture.isCube = true;
    texture.format = format;
    texture.type = type;
    if (!this._doNotHandleContextLost) texture._bufferViewArray = data;
    const textureType = this._getWebGLTextureType(type);
    let internalFormat = this._getInternalFormat(format);
    if (internalFormat === gl.RGB) internalFormat = gl.RGBA;
    // Mipmap generation needs a sized internal format that is both color-renderable and texture-filterable
    if (textureType === gl.FLOAT && !this._caps.textureFloatLinearFiltering) {
        generateMipMaps = false;
        samplingMode = 1;
        (0, $kVtWi.Logger).Warn("Float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
    } else if (textureType === this._gl.HALF_FLOAT_OES && !this._caps.textureHalfFloatLinearFiltering) {
        generateMipMaps = false;
        samplingMode = 1;
        (0, $kVtWi.Logger).Warn("Half float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
    } else if (textureType === gl.FLOAT && !this._caps.textureFloatRender) {
        generateMipMaps = false;
        (0, $kVtWi.Logger).Warn("Render to float textures is not supported. Mipmap generation forced to false.");
    } else if (textureType === gl.HALF_FLOAT && !this._caps.colorBufferFloat) {
        generateMipMaps = false;
        (0, $kVtWi.Logger).Warn("Render to half float textures is not supported. Mipmap generation forced to false.");
    }
    const width = size;
    const height = width;
    texture.width = width;
    texture.height = height;
    texture.invertY = invertY;
    texture._compression = compression;
    // Double check on POT to generate Mips.
    const isPot = !this.needPOTTextures || (0, $wK2xc.IsExponentOfTwo)(texture.width) && (0, $wK2xc.IsExponentOfTwo)(texture.height);
    if (!isPot) generateMipMaps = false;
    // Upload data if needed. The texture won't be ready until then.
    if (data) this.updateRawCubeTexture(texture, data, format, type, invertY, compression);
    else {
        const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
        const level = 0;
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        for(let faceIndex = 0; faceIndex < 6; faceIndex++)if (compression) gl.compressedTexImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, this.getCaps().s3tc[compression], texture.width, texture.height, 0, undefined);
        else gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, null);
        this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
    }
    this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, texture, true);
    // Filters
    if (data && generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
    const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, filters.mag);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, filters.min);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.isReady = true;
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.updateRawCubeTexture = function(texture, data, format, type, invertY, compression = null, level = 0) {
    texture._bufferViewArray = data;
    texture.format = format;
    texture.type = type;
    texture.invertY = invertY;
    texture._compression = compression;
    const gl = this._gl;
    const textureType = this._getWebGLTextureType(type);
    let internalFormat = this._getInternalFormat(format);
    const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
    let needConversion = false;
    if (internalFormat === gl.RGB) {
        internalFormat = gl.RGBA;
        needConversion = true;
    }
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
    this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
    if (texture.width % 4 !== 0) gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    // Data are known to be in +X +Y +Z -X -Y -Z
    for(let faceIndex = 0; faceIndex < 6; faceIndex++){
        let faceData = data[faceIndex];
        if (compression) gl.compressedTexImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, this.getCaps().s3tc[compression], texture.width, texture.height, 0, faceData);
        else {
            if (needConversion) faceData = $a4887001ff88aa24$var$_convertRGBtoRGBATextureData(faceData, texture.width, texture.height, type);
            gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, faceData);
        }
    }
    const isPot = !this.needPOTTextures || (0, $wK2xc.IsExponentOfTwo)(texture.width) && (0, $wK2xc.IsExponentOfTwo)(texture.height);
    if (isPot && texture.generateMipMaps && level === 0) this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
    this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
    // this.resetTextureCache();
    texture.isReady = true;
};
(0, $2h5JR.ThinEngine).prototype.createRawCubeTextureFromUrl = function(url, scene, size, format, type, noMipmap, callback, mipmapGenerator, onLoad = null, onError = null, samplingMode = 3, invertY = false) {
    const gl = this._gl;
    const texture = this.createRawCubeTexture(null, size, format, type, !noMipmap, invertY, samplingMode, null);
    scene?.addPendingData(texture);
    texture.url = url;
    texture.isReady = false;
    this._internalTexturesCache.push(texture);
    const onerror = (request, exception)=>{
        scene?.removePendingData(texture);
        if (onError && request) onError(request.status + " " + request.statusText, exception);
    };
    const internalCallback = (data)=>{
        const width = texture.width;
        const faceDataArrays = callback(data);
        if (!faceDataArrays) return;
        if (mipmapGenerator) {
            const textureType = this._getWebGLTextureType(type);
            let internalFormat = this._getInternalFormat(format);
            const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
            let needConversion = false;
            if (internalFormat === gl.RGB) {
                internalFormat = gl.RGBA;
                needConversion = true;
            }
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
            this._unpackFlipY(false);
            const mipData = mipmapGenerator(faceDataArrays);
            for(let level = 0; level < mipData.length; level++){
                const mipSize = width >> level;
                for(let faceIndex = 0; faceIndex < 6; faceIndex++){
                    let mipFaceData = mipData[level][faceIndex];
                    if (needConversion) mipFaceData = $a4887001ff88aa24$var$_convertRGBtoRGBATextureData(mipFaceData, mipSize, mipSize, type);
                    gl.texImage2D(faceIndex, level, internalSizedFomat, mipSize, mipSize, 0, internalFormat, textureType, mipFaceData);
                }
            }
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
        } else this.updateRawCubeTexture(texture, faceDataArrays, format, type, invertY);
        texture.isReady = true;
        // this.resetTextureCache();
        scene?.removePendingData(texture);
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad();
    };
    this._loadFile(url, (data)=>{
        internalCallback(data);
    }, undefined, scene?.offlineProvider, true, onerror);
    return texture;
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $a4887001ff88aa24$var$_convertRGBtoRGBATextureData(rgbData, width, height, textureType) {
    // Create new RGBA data container.
    let rgbaData;
    let val1 = 1;
    if (textureType === 1) rgbaData = new Float32Array(width * height * 4);
    else if (textureType === 2) {
        rgbaData = new Uint16Array(width * height * 4);
        val1 = 15360; // 15360 is the encoding of 1 in half float
    } else if (textureType === 7) rgbaData = new Uint32Array(width * height * 4);
    else rgbaData = new Uint8Array(width * height * 4);
    // Convert each pixel.
    for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
        const index = (y * width + x) * 3;
        const newIndex = (y * width + x) * 4;
        // Map Old Value to new value.
        rgbaData[newIndex + 0] = rgbData[index + 0];
        rgbaData[newIndex + 1] = rgbData[index + 1];
        rgbaData[newIndex + 2] = rgbData[index + 2];
        // Add fully opaque alpha channel.
        rgbaData[newIndex + 3] = val1;
    }
    return rgbaData;
}
/**
 * Create a function for createRawTexture3D/createRawTexture2DArray
 * @param is3D true for TEXTURE_3D and false for TEXTURE_2D_ARRAY
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $a4887001ff88aa24$var$_makeCreateRawTextureFunction(is3D) {
    return function(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
        const target = is3D ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY;
        const source = is3D ? 10 /* InternalTextureSource.Raw3D */  : 11 /* InternalTextureSource.Raw2DArray */ ;
        const texture = new (0, $b9e4a.InternalTexture)(this, source);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.baseDepth = depth;
        texture.width = width;
        texture.height = height;
        texture.depth = depth;
        texture.format = format;
        texture.type = textureType;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        if (is3D) texture.is3D = true;
        else texture.is2DArray = true;
        if (!this._doNotHandleContextLost) texture._bufferView = data;
        if (is3D) this.updateRawTexture3D(texture, data, format, invertY, compression, textureType);
        else this.updateRawTexture2DArray(texture, data, format, invertY, compression, textureType);
        this._bindTextureDirectly(target, texture, true);
        // Filters
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        this._gl.texParameteri(target, this._gl.TEXTURE_MAG_FILTER, filters.mag);
        this._gl.texParameteri(target, this._gl.TEXTURE_MIN_FILTER, filters.min);
        if (generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
        this._internalTexturesCache.push(texture);
        return texture;
    };
}
(0, $2h5JR.ThinEngine).prototype.createRawTexture2DArray = $a4887001ff88aa24$var$_makeCreateRawTextureFunction(false);
(0, $2h5JR.ThinEngine).prototype.createRawTexture3D = $a4887001ff88aa24$var$_makeCreateRawTextureFunction(true);
/**
 * Create a function for updateRawTexture3D/updateRawTexture2DArray
 * @param is3D true for TEXTURE_3D and false for TEXTURE_2D_ARRAY
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $a4887001ff88aa24$var$_makeUpdateRawTextureFunction(is3D) {
    return function(texture, data, format, invertY, compression = null, textureType = 0) {
        const target = is3D ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY;
        const internalType = this._getWebGLTextureType(textureType);
        const internalFormat = this._getInternalFormat(format);
        const internalSizedFomat = this._getRGBABufferInternalSizedFormat(textureType, format);
        this._bindTextureDirectly(target, texture, true);
        this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
        if (!this._doNotHandleContextLost) {
            texture._bufferView = data;
            texture.format = format;
            texture.invertY = invertY;
            texture._compression = compression;
        }
        if (texture.width % 4 !== 0) this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1);
        if (compression && data) this._gl.compressedTexImage3D(target, 0, this.getCaps().s3tc[compression], texture.width, texture.height, texture.depth, 0, data);
        else this._gl.texImage3D(target, 0, internalSizedFomat, texture.width, texture.height, texture.depth, 0, internalFormat, internalType, data);
        if (texture.generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
        // this.resetTextureCache();
        texture.isReady = true;
    };
}
(0, $2h5JR.ThinEngine).prototype.updateRawTexture2DArray = $a4887001ff88aa24$var$_makeUpdateRawTextureFunction(false);
(0, $2h5JR.ThinEngine).prototype.updateRawTexture3D = $a4887001ff88aa24$var$_makeUpdateRawTextureFunction(true);

});

parcelRegister("k0sxV", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $cOV0H = parcelRequire("cOV0H");
(0, $2h5JR.ThinEngine).prototype._readTexturePixelsSync = function(texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
    const gl = this._gl;
    if (!gl) throw new Error("Engine does not have gl rendering context.");
    if (!this._dummyFramebuffer) {
        const dummy = gl.createFramebuffer();
        if (!dummy) throw new Error("Unable to create dummy framebuffer");
        this._dummyFramebuffer = dummy;
    }
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._dummyFramebuffer);
    if (faceIndex > -1) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, texture._hardwareTexture?.underlyingResource, level);
    else gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture._hardwareTexture?.underlyingResource, level);
    let readType = texture.type !== undefined ? this._getWebGLTextureType(texture.type) : gl.UNSIGNED_BYTE;
    if (!noDataConversion) switch(readType){
        case gl.UNSIGNED_BYTE:
            if (!buffer) buffer = new Uint8Array(4 * width * height);
            readType = gl.UNSIGNED_BYTE;
            break;
        default:
            if (!buffer) buffer = new Float32Array(4 * width * height);
            readType = gl.FLOAT;
            break;
    }
    else if (!buffer) buffer = (0, $cOV0H.allocateAndCopyTypedBuffer)(texture.type, 4 * width * height);
    if (flushRenderer) this.flushFramebuffer();
    gl.readPixels(x, y, width, height, gl.RGBA, readType, buffer);
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._currentFramebuffer);
    return buffer;
};
(0, $2h5JR.ThinEngine).prototype._readTexturePixels = function(texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
    return Promise.resolve(this._readTexturePixelsSync(texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion, x, y));
};

});

parcelRegister("7G59J", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.updateDynamicIndexBuffer = function(indexBuffer, indices, offset = 0) {
    // Force cache update
    this._currentBoundBuffer[this._gl.ELEMENT_ARRAY_BUFFER] = null;
    this.bindIndexBuffer(indexBuffer);
    let view;
    if (indexBuffer.is32Bits) // anything else than Uint32Array needs to be converted to Uint32Array
    view = indices instanceof Uint32Array ? indices : new Uint32Array(indices);
    else // anything else than Uint16Array needs to be converted to Uint16Array
    view = indices instanceof Uint16Array ? indices : new Uint16Array(indices);
    this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, view, this._gl.DYNAMIC_DRAW);
    this._resetIndexBufferBinding();
};
(0, $2h5JR.ThinEngine).prototype.updateDynamicVertexBuffer = function(vertexBuffer, data, byteOffset, byteLength) {
    this.bindArrayBuffer(vertexBuffer);
    if (byteOffset === undefined) byteOffset = 0;
    const dataLength = data.byteLength || data.length;
    if (byteLength === undefined || byteLength >= dataLength && byteOffset === 0) {
        if (data instanceof Array) this._gl.bufferSubData(this._gl.ARRAY_BUFFER, byteOffset, new Float32Array(data));
        else this._gl.bufferSubData(this._gl.ARRAY_BUFFER, byteOffset, data);
    } else if (data instanceof Array) this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, new Float32Array(data).subarray(byteOffset, byteOffset + byteLength));
    else {
        if (data instanceof ArrayBuffer) data = new Uint8Array(data, byteOffset, byteLength);
        else data = new Uint8Array(data.buffer, data.byteOffset + byteOffset, byteLength);
        this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
    }
    this._resetVertexBufferBinding();
};

});

parcelRegister("5jUKR", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $wK2xc = parcelRequire("wK2xc");
(0, $2h5JR.ThinEngine).prototype._createDepthStencilCubeTexture = function(size, options) {
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, 12 /* InternalTextureSource.DepthStencil */ );
    internalTexture.isCube = true;
    if (this.webGLVersion === 1) {
        (0, $kVtWi.Logger).Error("Depth cube texture is not supported by WebGL 1.");
        return internalTexture;
    }
    const internalOptions = {
        bilinearFiltering: false,
        comparisonFunction: 0,
        generateStencil: false,
        ...options
    };
    const gl = this._gl;
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, internalTexture, true);
    this._setupDepthStencilTexture(internalTexture, size, internalOptions.bilinearFiltering, internalOptions.comparisonFunction);
    // Create the depth/stencil buffer
    for(let face = 0; face < 6; face++)if (internalOptions.generateStencil) gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, gl.DEPTH24_STENCIL8, size, size, 0, gl.DEPTH_STENCIL, gl.UNSIGNED_INT_24_8, null);
    else gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, gl.DEPTH_COMPONENT24, size, size, 0, gl.DEPTH_COMPONENT, gl.UNSIGNED_INT, null);
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    this._internalTexturesCache.push(internalTexture);
    return internalTexture;
};
(0, $2h5JR.ThinEngine).prototype._setCubeMapTextureParams = function(texture, loadMipmap, maxLevel) {
    const gl = this._gl;
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, loadMipmap ? gl.LINEAR_MIPMAP_LINEAR : gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    texture.samplingMode = loadMipmap ? 3 : 2;
    if (loadMipmap && this.getCaps().textureMaxLevel && maxLevel !== undefined && maxLevel > 0) {
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAX_LEVEL, maxLevel);
        texture._maxLodLevel = maxLevel;
    }
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
};
(0, $2h5JR.ThinEngine).prototype.createCubeTexture = function(rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, loaderOptions, useSRGBBuffer = false, buffer = null) {
    const gl = this._gl;
    return this.createCubeTextureBase(rootUrl, scene, files, !!noMipmap, onLoad, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset, fallback, (texture)=>this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true), (texture, imgs)=>{
        const width = this.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(imgs[0].width, this._caps.maxCubemapTextureSize) : imgs[0].width;
        const height = width;
        const faces = [
            gl.TEXTURE_CUBE_MAP_POSITIVE_X,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Z
        ];
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        this._unpackFlipY(false);
        const internalFormat = format ? this._getInternalFormat(format, texture._useSRGBBuffer) : texture._useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : gl.RGBA;
        let texelFormat = format ? this._getInternalFormat(format) : gl.RGBA;
        if (texture._useSRGBBuffer && this.webGLVersion === 1) texelFormat = internalFormat;
        for(let index = 0; index < faces.length; index++)if (imgs[index].width !== width || imgs[index].height !== height) {
            this._prepareWorkingCanvas();
            if (!this._workingCanvas || !this._workingContext) {
                (0, $kVtWi.Logger).Warn("Cannot create canvas to resize texture.");
                return;
            }
            this._workingCanvas.width = width;
            this._workingCanvas.height = height;
            this._workingContext.drawImage(imgs[index], 0, 0, imgs[index].width, imgs[index].height, 0, 0, width, height);
            gl.texImage2D(faces[index], 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, this._workingCanvas);
        } else gl.texImage2D(faces[index], 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, imgs[index]);
        if (!noMipmap) gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        this._setCubeMapTextureParams(texture, !noMipmap);
        texture.width = width;
        texture.height = height;
        texture.isReady = true;
        if (format) texture.format = format;
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad();
    }, !!useSRGBBuffer, buffer);
};
(0, $2h5JR.ThinEngine).prototype.generateMipMapsForCubemap = function(texture, unbind = true) {
    if (texture.generateMipMaps) {
        const gl = this._gl;
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        if (unbind) this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    }
};

});

parcelRegister("4PdZs", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");

var $7Hi8b = parcelRequire("7Hi8b");

var $aees9 = parcelRequire("aees9");
parcelRequire("3l1SY");
(0, $2h5JR.ThinEngine).prototype._createHardwareRenderTargetWrapper = function(isMulti, isCube, size) {
    const rtWrapper = new (0, $7Hi8b.WebGLRenderTargetWrapper)(isMulti, isCube, size, this, this._gl);
    this._renderTargetWrapperCache.push(rtWrapper);
    return rtWrapper;
};
(0, $2h5JR.ThinEngine).prototype.createRenderTargetTexture = function(size, options) {
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, size);
    let generateDepthBuffer = true;
    let generateStencilBuffer = false;
    let noColorAttachment = false;
    let colorAttachment = undefined;
    let samples = 1;
    let label = undefined;
    if (options !== undefined && typeof options === "object") {
        generateDepthBuffer = options.generateDepthBuffer ?? true;
        generateStencilBuffer = !!options.generateStencilBuffer;
        noColorAttachment = !!options.noColorAttachment;
        colorAttachment = options.colorAttachment;
        samples = options.samples ?? 1;
        label = options.label;
    }
    const texture = colorAttachment || (noColorAttachment ? null : this._createInternalTexture(size, options, true, 5 /* InternalTextureSource.RenderTarget */ ));
    const width = size.width || size;
    const height = size.height || size;
    const currentFrameBuffer = this._currentFramebuffer;
    const gl = this._gl;
    // Create the framebuffer
    const framebuffer = gl.createFramebuffer();
    this._bindUnboundFramebuffer(framebuffer);
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(generateStencilBuffer, generateDepthBuffer, width, height);
    // No need to rebind on every frame
    if (texture && !texture.is2DArray && !texture.is3D) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture._hardwareTexture.underlyingResource, 0);
    this._bindUnboundFramebuffer(currentFrameBuffer);
    rtWrapper.label = label ?? "RenderTargetWrapper";
    rtWrapper._framebuffer = framebuffer;
    rtWrapper._generateDepthBuffer = generateDepthBuffer;
    rtWrapper._generateStencilBuffer = generateStencilBuffer;
    rtWrapper.setTextures(texture);
    if (!colorAttachment) this.updateRenderTargetTextureSampleCount(rtWrapper, samples);
    else {
        rtWrapper._samples = colorAttachment.samples;
        if (colorAttachment.samples > 1) {
            const msaaRenderBuffer = colorAttachment._hardwareTexture.getMSAARenderBuffer(0);
            rtWrapper._MSAAFramebuffer = gl.createFramebuffer();
            this._bindUnboundFramebuffer(rtWrapper._MSAAFramebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, msaaRenderBuffer);
            this._bindUnboundFramebuffer(null);
        }
    }
    return rtWrapper;
};
(0, $2h5JR.ThinEngine).prototype._createDepthStencilTexture = function(size, options, rtWrapper) {
    const gl = this._gl;
    const layers = size.layers || 0;
    const depth = size.depth || 0;
    let target = gl.TEXTURE_2D;
    if (layers !== 0) target = gl.TEXTURE_2D_ARRAY;
    else if (depth !== 0) target = gl.TEXTURE_3D;
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, 12 /* InternalTextureSource.DepthStencil */ );
    internalTexture.label = options.label;
    if (!this._caps.depthTextureExtension) {
        (0, $kVtWi.Logger).Error("Depth texture is not supported by your browser or hardware.");
        return internalTexture;
    }
    const internalOptions = {
        bilinearFiltering: false,
        comparisonFunction: 0,
        generateStencil: false,
        ...options
    };
    this._bindTextureDirectly(target, internalTexture, true);
    this._setupDepthStencilTexture(internalTexture, size, internalOptions.comparisonFunction === 0 ? false : internalOptions.bilinearFiltering, internalOptions.comparisonFunction, internalOptions.samples);
    if (internalOptions.depthTextureFormat !== undefined) {
        if (internalOptions.depthTextureFormat !== 15 && internalOptions.depthTextureFormat !== 16 && internalOptions.depthTextureFormat !== 17 && internalOptions.depthTextureFormat !== 13 && internalOptions.depthTextureFormat !== 14 && internalOptions.depthTextureFormat !== 18) {
            (0, $kVtWi.Logger).Error(`Depth texture ${internalOptions.depthTextureFormat} format is not supported.`);
            return internalTexture;
        }
        internalTexture.format = internalOptions.depthTextureFormat;
    } else internalTexture.format = internalOptions.generateStencil ? 13 : 16;
    const hasStencil = (0, $aees9.HasStencilAspect)(internalTexture.format);
    const type = this._getWebGLTextureTypeFromDepthTextureFormat(internalTexture.format);
    const format = hasStencil ? gl.DEPTH_STENCIL : gl.DEPTH_COMPONENT;
    const internalFormat = this._getInternalFormatFromDepthTextureFormat(internalTexture.format, true, hasStencil);
    if (internalTexture.is2DArray) gl.texImage3D(target, 0, internalFormat, internalTexture.width, internalTexture.height, layers, 0, format, type, null);
    else if (internalTexture.is3D) gl.texImage3D(target, 0, internalFormat, internalTexture.width, internalTexture.height, depth, 0, format, type, null);
    else gl.texImage2D(target, 0, internalFormat, internalTexture.width, internalTexture.height, 0, format, type, null);
    this._bindTextureDirectly(target, null);
    this._internalTexturesCache.push(internalTexture);
    if (rtWrapper._depthStencilBuffer) {
        gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
        rtWrapper._depthStencilBuffer = null;
    }
    this._bindUnboundFramebuffer(rtWrapper._MSAAFramebuffer ?? rtWrapper._framebuffer);
    rtWrapper._generateStencilBuffer = hasStencil;
    rtWrapper._depthStencilTextureWithStencil = hasStencil;
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.width, rtWrapper.height, rtWrapper.samples, internalTexture.format);
    this._bindUnboundFramebuffer(null);
    return internalTexture;
};
(0, $2h5JR.ThinEngine).prototype.updateRenderTargetTextureSampleCount = function(rtWrapper, samples) {
    if (this.webGLVersion < 2 || !rtWrapper) return 1;
    if (rtWrapper.samples === samples) return samples;
    const gl = this._gl;
    samples = Math.min(samples, this.getCaps().maxMSAASamples);
    // Dispose previous render buffers
    if (rtWrapper._depthStencilBuffer) {
        gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
        rtWrapper._depthStencilBuffer = null;
    }
    if (rtWrapper._MSAAFramebuffer) {
        gl.deleteFramebuffer(rtWrapper._MSAAFramebuffer);
        rtWrapper._MSAAFramebuffer = null;
    }
    const hardwareTexture = rtWrapper.texture?._hardwareTexture;
    hardwareTexture?.releaseMSAARenderBuffers();
    if (rtWrapper.texture && samples > 1 && typeof gl.renderbufferStorageMultisample === "function") {
        const framebuffer = gl.createFramebuffer();
        if (!framebuffer) throw new Error("Unable to create multi sampled framebuffer");
        rtWrapper._MSAAFramebuffer = framebuffer;
        this._bindUnboundFramebuffer(rtWrapper._MSAAFramebuffer);
        const colorRenderbuffer = this._createRenderBuffer(rtWrapper.texture.width, rtWrapper.texture.height, samples, -1 /* not used */ , this._getRGBABufferInternalSizedFormat(rtWrapper.texture.type, rtWrapper.texture.format, rtWrapper.texture._useSRGBBuffer), gl.COLOR_ATTACHMENT0, false);
        if (!colorRenderbuffer) throw new Error("Unable to create multi sampled framebuffer");
        hardwareTexture?.addMSAARenderBuffer(colorRenderbuffer);
    }
    this._bindUnboundFramebuffer(rtWrapper._MSAAFramebuffer ?? rtWrapper._framebuffer);
    if (rtWrapper.texture) rtWrapper.texture.samples = samples;
    rtWrapper._samples = samples;
    const depthFormat = rtWrapper._depthStencilTexture ? rtWrapper._depthStencilTexture.format : undefined;
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.width, rtWrapper.height, samples, depthFormat);
    this._bindUnboundFramebuffer(null);
    return samples;
};
(0, $2h5JR.ThinEngine).prototype._setupDepthStencilTexture = function(internalTexture, size, bilinearFiltering, comparisonFunction, samples = 1) {
    const width = size.width ?? size;
    const height = size.height ?? size;
    const layers = size.layers || 0;
    const depth = size.depth || 0;
    internalTexture.baseWidth = width;
    internalTexture.baseHeight = height;
    internalTexture.width = width;
    internalTexture.height = height;
    internalTexture.is2DArray = layers > 0;
    internalTexture.depth = layers || depth;
    internalTexture.isReady = true;
    internalTexture.samples = samples;
    internalTexture.generateMipMaps = false;
    internalTexture.samplingMode = bilinearFiltering ? 2 : 1;
    internalTexture.type = 0;
    internalTexture._comparisonFunction = comparisonFunction;
    const gl = this._gl;
    const target = this._getTextureTarget(internalTexture);
    const samplingParameters = this._getSamplingParameters(internalTexture.samplingMode, false);
    gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, samplingParameters.mag);
    gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, samplingParameters.min);
    gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // TEXTURE_COMPARE_FUNC/MODE are only availble in WebGL2.
    if (this.webGLVersion > 1) {
        if (comparisonFunction === 0) {
            gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, 515);
            gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.NONE);
        } else {
            gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
            gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
        }
    }
};

});
parcelRegister("7Hi8b", function(module, exports) {

$parcel$export(module.exports, "WebGLRenderTargetWrapper", () => $59aa9cfe4ef7785f$export$71fff2fc651795c2);

var $3QmEA = parcelRequire("3QmEA");

var $aees9 = parcelRequire("aees9");
class $59aa9cfe4ef7785f$export$71fff2fc651795c2 extends (0, $3QmEA.RenderTargetWrapper) {
    setDepthStencilTexture(texture, disposeExisting = true) {
        super.setDepthStencilTexture(texture, disposeExisting);
        if (!texture) return;
        const engine = this._engine;
        const gl = this._context;
        const hardwareTexture = texture._hardwareTexture;
        if (hardwareTexture && texture._autoMSAAManagement && this._MSAAFramebuffer) {
            const currentFB = engine._currentFramebuffer;
            engine._bindUnboundFramebuffer(this._MSAAFramebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, (0, $aees9.HasStencilAspect)(texture.format) ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, hardwareTexture.getMSAARenderBuffer());
            engine._bindUnboundFramebuffer(currentFB);
        }
    }
    constructor(isMulti, isCube, size, engine, context){
        super(isMulti, isCube, size, engine);
        /**
         * @internal
         */ this._framebuffer = null;
        /**
         * @internal
         */ this._depthStencilBuffer = null;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        /**
         * @internal
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this._MSAAFramebuffer = null;
        // Multiview
        /**
         * @internal
         */ this._colorTextureArray = null;
        /**
         * @internal
         */ this._depthStencilTextureArray = null;
        /**
         * @internal
         */ this._disposeOnlyFramebuffers = false;
        /**
         * @internal
         */ this._currentLOD = 0;
        this._context = context;
    }
    _cloneRenderTargetWrapper() {
        let rtw = null;
        if (this._colorTextureArray && this._depthStencilTextureArray) {
            rtw = this._engine.createMultiviewRenderTargetTexture(this.width, this.height);
            rtw.texture.isReady = true;
        } else rtw = super._cloneRenderTargetWrapper();
        return rtw;
    }
    _swapRenderTargetWrapper(target) {
        super._swapRenderTargetWrapper(target);
        target._framebuffer = this._framebuffer;
        target._depthStencilBuffer = this._depthStencilBuffer;
        target._MSAAFramebuffer = this._MSAAFramebuffer;
        target._colorTextureArray = this._colorTextureArray;
        target._depthStencilTextureArray = this._depthStencilTextureArray;
        this._framebuffer = this._depthStencilBuffer = this._MSAAFramebuffer = this._colorTextureArray = this._depthStencilTextureArray = null;
    }
    /**
     * Creates the depth/stencil texture
     * @param comparisonFunction Comparison function to use for the texture
     * @param bilinearFiltering true if bilinear filtering should be used when sampling the texture
     * @param generateStencil true if the stencil aspect should also be created
     * @param samples sample count to use when creating the texture
     * @param format format of the depth texture
     * @param label defines the label to use for the texture (for debugging purpose only)
     * @returns the depth/stencil created texture
     */ createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14, label) {
        if (this._depthStencilBuffer) {
            const engine = this._engine;
            // Dispose previous depth/stencil render buffers and clear the corresponding attachment.
            // Next time this framebuffer is bound, the new depth/stencil texture will be attached.
            const currentFrameBuffer = engine._currentFramebuffer;
            const gl = this._context;
            engine._bindUnboundFramebuffer(this._framebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, null);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, null);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.STENCIL_ATTACHMENT, gl.RENDERBUFFER, null);
            engine._bindUnboundFramebuffer(currentFrameBuffer);
            gl.deleteRenderbuffer(this._depthStencilBuffer);
            this._depthStencilBuffer = null;
        }
        return super.createDepthStencilTexture(comparisonFunction, bilinearFiltering, generateStencil, samples, format, label);
    }
    /**
     * Shares the depth buffer of this render target with another render target.
     * @param renderTarget Destination renderTarget
     */ shareDepth(renderTarget) {
        super.shareDepth(renderTarget);
        const gl = this._context;
        const depthbuffer = this._depthStencilBuffer;
        const framebuffer = renderTarget._MSAAFramebuffer || renderTarget._framebuffer;
        const engine = this._engine;
        if (renderTarget._depthStencilBuffer && renderTarget._depthStencilBuffer !== depthbuffer) gl.deleteRenderbuffer(renderTarget._depthStencilBuffer);
        renderTarget._depthStencilBuffer = depthbuffer;
        const attachment = renderTarget._generateStencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
        engine._bindUnboundFramebuffer(framebuffer);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, depthbuffer);
        engine._bindUnboundFramebuffer(null);
    }
    /**
     * Binds a texture to this render target on a specific attachment
     * @param texture The texture to bind to the framebuffer
     * @param attachmentIndex Index of the attachment
     * @param faceIndexOrLayer The face or layer of the texture to render to in case of cube texture or array texture
     * @param lodLevel defines the lod level to bind to the frame buffer
     */ _bindTextureRenderTarget(texture, attachmentIndex = 0, faceIndexOrLayer, lodLevel = 0) {
        const hardwareTexture = texture._hardwareTexture;
        if (!hardwareTexture) return;
        const framebuffer = this._framebuffer;
        const engine = this._engine;
        const currentFB = engine._currentFramebuffer;
        engine._bindUnboundFramebuffer(framebuffer);
        let attachment;
        if (engine.webGLVersion > 1) {
            const gl = this._context;
            attachment = gl["COLOR_ATTACHMENT" + attachmentIndex];
            if (texture.is2DArray || texture.is3D) {
                faceIndexOrLayer = faceIndexOrLayer ?? this.layerIndices?.[attachmentIndex] ?? 0;
                gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, hardwareTexture.underlyingResource, lodLevel, faceIndexOrLayer);
            } else if (texture.isCube) {
                // if face index is not specified, try to query it from faceIndices
                // default is face 0
                faceIndexOrLayer = faceIndexOrLayer ?? this.faceIndices?.[attachmentIndex] ?? 0;
                gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndexOrLayer, hardwareTexture.underlyingResource, lodLevel);
            } else gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, hardwareTexture.underlyingResource, lodLevel);
        } else {
            // Default behavior (WebGL)
            const gl = this._context;
            attachment = gl["COLOR_ATTACHMENT" + attachmentIndex + "_WEBGL"];
            const target = faceIndexOrLayer !== undefined ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndexOrLayer : gl.TEXTURE_2D;
            gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, target, hardwareTexture.underlyingResource, lodLevel);
        }
        if (texture._autoMSAAManagement && this._MSAAFramebuffer) {
            const gl = this._context;
            engine._bindUnboundFramebuffer(this._MSAAFramebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, hardwareTexture.getMSAARenderBuffer());
        }
        engine._bindUnboundFramebuffer(currentFB);
    }
    /**
     * Set a texture in the textures array
     * @param texture the texture to set
     * @param index the index in the textures array to set
     * @param disposePrevious If this function should dispose the previous texture
     */ setTexture(texture, index = 0, disposePrevious = true) {
        super.setTexture(texture, index, disposePrevious);
        this._bindTextureRenderTarget(texture, index);
    }
    /**
     * Sets the layer and face indices of every render target texture
     * @param layers The layer of the texture to be set (make negative to not modify)
     * @param faces The face of the texture to be set (make negative to not modify)
     */ setLayerAndFaceIndices(layers, faces) {
        super.setLayerAndFaceIndices(layers, faces);
        if (!this.textures || !this.layerIndices || !this.faceIndices) return;
        // the length of this._attachments is the right one as it does not count the depth texture, in case we generated it
        const textureCount = this._attachments?.length ?? this.textures.length;
        for(let index = 0; index < textureCount; index++){
            const texture = this.textures[index];
            if (!texture) continue;
            if (texture.is2DArray || texture.is3D) this._bindTextureRenderTarget(texture, index, this.layerIndices[index]);
            else if (texture.isCube) this._bindTextureRenderTarget(texture, index, this.faceIndices[index]);
            else this._bindTextureRenderTarget(texture, index);
        }
    }
    /**
     * Set the face and layer indices of a texture in the textures array
     * @param index The index of the texture in the textures array to modify
     * @param layer The layer of the texture to be set
     * @param face The face of the texture to be set
     */ setLayerAndFaceIndex(index = 0, layer, face) {
        super.setLayerAndFaceIndex(index, layer, face);
        if (!this.textures || !this.layerIndices || !this.faceIndices) return;
        const texture = this.textures[index];
        if (texture.is2DArray || texture.is3D) this._bindTextureRenderTarget(this.textures[index], index, this.layerIndices[index]);
        else if (texture.isCube) this._bindTextureRenderTarget(this.textures[index], index, this.faceIndices[index]);
    }
    resolveMSAATextures() {
        const engine = this._engine;
        const currentFramebuffer = engine._currentFramebuffer;
        engine._bindUnboundFramebuffer(this._MSAAFramebuffer);
        super.resolveMSAATextures();
        engine._bindUnboundFramebuffer(currentFramebuffer);
    }
    dispose(disposeOnlyFramebuffers = this._disposeOnlyFramebuffers) {
        const gl = this._context;
        if (!disposeOnlyFramebuffers) {
            if (this._colorTextureArray) {
                this._context.deleteTexture(this._colorTextureArray);
                this._colorTextureArray = null;
            }
            if (this._depthStencilTextureArray) {
                this._context.deleteTexture(this._depthStencilTextureArray);
                this._depthStencilTextureArray = null;
            }
        }
        if (this._framebuffer) {
            gl.deleteFramebuffer(this._framebuffer);
            this._framebuffer = null;
        }
        if (this._depthStencilBuffer) {
            gl.deleteRenderbuffer(this._depthStencilBuffer);
            this._depthStencilBuffer = null;
        }
        if (this._MSAAFramebuffer) {
            gl.deleteFramebuffer(this._MSAAFramebuffer);
            this._MSAAFramebuffer = null;
        }
        super.dispose(disposeOnlyFramebuffers);
    }
}

});
parcelRegister("3QmEA", function(module, exports) {

$parcel$export(module.exports, "RenderTargetWrapper", () => $2cc7ccf7db7cd53e$export$a2afcb74070ce2ba);

var $aees9 = parcelRequire("aees9");
class $2cc7ccf7db7cd53e$export$a2afcb74070ce2ba {
    /**
     * Gets the depth/stencil texture
     */ get depthStencilTexture() {
        return this._depthStencilTexture;
    }
    /**
     * Sets the depth/stencil texture
     * @param texture The depth/stencil texture to set
     * @param disposeExisting True to dispose the existing depth/stencil texture (if any) before replacing it (default: true)
     */ setDepthStencilTexture(texture, disposeExisting = true) {
        if (disposeExisting && this._depthStencilTexture) this._depthStencilTexture.dispose();
        this._depthStencilTexture = texture;
        this._generateDepthBuffer = this._generateStencilBuffer = this._depthStencilTextureWithStencil = false;
        if (texture) {
            this._generateDepthBuffer = true;
            this._generateStencilBuffer = this._depthStencilTextureWithStencil = (0, $aees9.HasStencilAspect)(texture.format);
        }
    }
    /**
     * Indicates if the depth/stencil texture has a stencil aspect
     */ get depthStencilTextureWithStencil() {
        return this._depthStencilTextureWithStencil;
    }
    /**
     * Defines if the render target wrapper is for a cube texture or if false a 2d texture
     */ get isCube() {
        return this._isCube;
    }
    /**
     * Defines if the render target wrapper is for a single or multi target render wrapper
     */ get isMulti() {
        return this._isMulti;
    }
    /**
     * Defines if the render target wrapper is for a single or an array of textures
     */ get is2DArray() {
        return this.layers > 0;
    }
    /**
     * Defines if the render target wrapper is for a 3D texture
     */ get is3D() {
        return this.depth > 0;
    }
    /**
     * Gets the size of the render target wrapper (used for cubes, as width=height in this case)
     */ get size() {
        return this.width;
    }
    /**
     * Gets the width of the render target wrapper
     */ get width() {
        return this._size.width ?? this._size;
    }
    /**
     * Gets the height of the render target wrapper
     */ get height() {
        return this._size.height ?? this._size;
    }
    /**
     * Gets the number of layers of the render target wrapper (only used if is2DArray is true and wrapper is not a multi render target)
     */ get layers() {
        return this._size.layers || 0;
    }
    /**
     * Gets the depth of the render target wrapper (only used if is3D is true and wrapper is not a multi render target)
     */ get depth() {
        return this._size.depth || 0;
    }
    /**
     * Gets the render texture. If this is a multi render target, gets the first texture
     */ get texture() {
        return this._textures?.[0] ?? null;
    }
    /**
     * Gets the list of render textures. If we are not in a multi render target, the list will be null (use the texture getter instead)
     */ get textures() {
        return this._textures;
    }
    /**
     * Gets the face indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
     */ get faceIndices() {
        return this._faceIndices;
    }
    /**
     * Gets the layer indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
     */ get layerIndices() {
        return this._layerIndices;
    }
    /**
     * Gets the base array layer of a texture in the textures array
     * This is an number that is calculated based on the layer and face indices set for this texture at that index
     * @param index The index of the texture in the textures array to get the base array layer for
     * @returns the base array layer of the texture at the given index
     */ getBaseArrayLayer(index) {
        if (!this._textures) return -1;
        const texture = this._textures[index];
        const layerIndex = this._layerIndices?.[index] ?? 0;
        const faceIndex = this._faceIndices?.[index] ?? 0;
        return texture.isCube ? layerIndex * 6 + faceIndex : texture.is3D ? 0 : layerIndex;
    }
    /**
     * Gets the sample count of the render target
     */ get samples() {
        return this._samples;
    }
    /**
     * Sets the sample count of the render target
     * @param value sample count
     * @param initializeBuffers If set to true, the engine will make an initializing call to drawBuffers (only used when isMulti=true).
     * @param force true to force calling the update sample count engine function even if the current sample count is equal to value
     * @returns the sample count that has been set
     */ setSamples(value, initializeBuffers = true, force = false) {
        if (this.samples === value && !force) return value;
        const result = this._isMulti ? this._engine.updateMultipleRenderTargetTextureSampleCount(this, value, initializeBuffers) : this._engine.updateRenderTargetTextureSampleCount(this, value);
        this._samples = value;
        return result;
    }
    /**
     * Resolves the MSAA textures into their non-MSAA version.
     * Note that if samples equals 1 (no MSAA), no resolve is performed.
     */ resolveMSAATextures() {
        if (this.isMulti) this._engine.resolveMultiFramebuffer(this);
        else this._engine.resolveFramebuffer(this);
    }
    /**
     * Generates mipmaps for each texture of the render target
     */ generateMipMaps() {
        if (this._engine._currentRenderTarget === this) this._engine.unBindFramebuffer(this, true);
        if (this.isMulti) this._engine.generateMipMapsMultiFramebuffer(this);
        else this._engine.generateMipMapsFramebuffer(this);
    }
    /**
     * Initializes the render target wrapper
     * @param isMulti true if the wrapper is a multi render target
     * @param isCube true if the wrapper should render to a cube texture
     * @param size size of the render target (width/height/layers)
     * @param engine engine used to create the render target
     * @param label defines the label to use for the wrapper (for debugging purpose only)
     */ constructor(isMulti, isCube, size, engine, label){
        this._textures = null;
        this._faceIndices = null;
        this._layerIndices = null;
        /** @internal */ this._samples = 1;
        /** @internal */ this._attachments = null;
        /** @internal */ this._generateStencilBuffer = false;
        /** @internal */ this._generateDepthBuffer = false;
        /** @internal */ this._depthStencilTextureWithStencil = false;
        /**
         * Sets this property to true to disable the automatic MSAA resolve that happens when the render target wrapper is unbound (default is false)
         */ this.disableAutomaticMSAAResolve = false;
        /**
         * Indicates if MSAA color texture(s) should be resolved when a resolve occur (either automatically by the engine or manually by the user) (default is true)
         * Note that you can trigger a MSAA resolve at any time by calling resolveMSAATextures()
         */ this.resolveMSAAColors = true;
        /**
         * Indicates if MSAA depth texture should be resolved when a resolve occur (either automatically by the engine or manually by the user) (default is false)
         */ this.resolveMSAADepth = false;
        /**
         * Indicates if MSAA stencil texture should be resolved when a resolve occur (either automatically by the engine or manually by the user) (default is false)
         */ this.resolveMSAAStencil = false;
        this._isMulti = isMulti;
        this._isCube = isCube;
        this._size = size;
        this._engine = engine;
        this._depthStencilTexture = null;
        this.label = label;
    }
    /**
     * Sets the render target texture(s)
     * @param textures texture(s) to set
     */ setTextures(textures) {
        if (Array.isArray(textures)) this._textures = textures;
        else if (textures) this._textures = [
            textures
        ];
        else this._textures = null;
    }
    /**
     * Set a texture in the textures array
     * @param texture The texture to set
     * @param index The index in the textures array to set
     * @param disposePrevious If this function should dispose the previous texture
     */ setTexture(texture, index = 0, disposePrevious = true) {
        if (!this._textures) this._textures = [];
        if (this._textures[index] === texture) return;
        if (this._textures[index] && disposePrevious) this._textures[index].dispose();
        this._textures[index] = texture;
    }
    /**
     * Sets the layer and face indices of every render target texture bound to each color attachment
     * @param layers The layers of each texture to be set
     * @param faces The faces of each texture to be set
     */ setLayerAndFaceIndices(layers, faces) {
        this._layerIndices = layers;
        this._faceIndices = faces;
    }
    /**
     * Sets the layer and face indices of a texture in the textures array that should be bound to each color attachment
     * @param index The index of the texture in the textures array to modify
     * @param layer The layer of the texture to be set
     * @param face The face of the texture to be set
     */ setLayerAndFaceIndex(index = 0, layer, face) {
        if (!this._layerIndices) this._layerIndices = [];
        if (!this._faceIndices) this._faceIndices = [];
        if (layer !== undefined && layer >= 0) this._layerIndices[index] = layer;
        if (face !== undefined && face >= 0) this._faceIndices[index] = face;
    }
    /**
     * Creates the depth/stencil texture
     * @param comparisonFunction Comparison function to use for the texture
     * @param bilinearFiltering true if bilinear filtering should be used when sampling the texture
     * @param generateStencil Not used anymore. "format" will be used to determine if stencil should be created
     * @param samples sample count to use when creating the texture (default: 1)
     * @param format format of the depth texture (default: 14)
     * @param label defines the label to use for the texture (for debugging purpose only)
     * @returns the depth/stencil created texture
     */ createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14, label) {
        this._depthStencilTexture?.dispose();
        this._depthStencilTextureWithStencil = generateStencil;
        this._depthStencilTextureLabel = label;
        this._depthStencilTexture = this._engine.createDepthStencilTexture(this._size, {
            bilinearFiltering: bilinearFiltering,
            comparisonFunction: comparisonFunction,
            generateStencil: generateStencil,
            isCube: this._isCube,
            samples: samples,
            depthTextureFormat: format,
            label: label
        }, this);
        return this._depthStencilTexture;
    }
    /**
     * @deprecated Use shareDepth instead
     * @param renderTarget Destination renderTarget
     */ _shareDepth(renderTarget) {
        this.shareDepth(renderTarget);
    }
    /**
     * Shares the depth buffer of this render target with another render target.
     * @param renderTarget Destination renderTarget
     */ shareDepth(renderTarget) {
        if (this._depthStencilTexture) {
            if (renderTarget._depthStencilTexture) renderTarget._depthStencilTexture.dispose();
            renderTarget._depthStencilTexture = this._depthStencilTexture;
            renderTarget._depthStencilTextureWithStencil = this._depthStencilTextureWithStencil;
            this._depthStencilTexture.incrementReferences();
        }
    }
    /**
     * @internal
     */ _swapAndDie(target) {
        if (this.texture) this.texture._swapAndDie(target);
        this._textures = null;
        this.dispose(true);
    }
    _cloneRenderTargetWrapper() {
        let rtw = null;
        if (this._isMulti) {
            const textureArray = this.textures;
            if (textureArray && textureArray.length > 0) {
                let generateDepthTexture = false;
                let textureCount = textureArray.length;
                let depthTextureFormat = -1;
                const lastTextureSource = textureArray[textureArray.length - 1]._source;
                if (lastTextureSource === 14 /* InternalTextureSource.Depth */  || lastTextureSource === 12 /* InternalTextureSource.DepthStencil */ ) {
                    generateDepthTexture = true;
                    depthTextureFormat = textureArray[textureArray.length - 1].format;
                    textureCount--;
                }
                const samplingModes = [];
                const types = [];
                const formats = [];
                const targetTypes = [];
                const faceIndex = [];
                const layerIndex = [];
                const layerCounts = [];
                const internalTexture2Index = {};
                for(let i = 0; i < textureCount; ++i){
                    const texture = textureArray[i];
                    samplingModes.push(texture.samplingMode);
                    types.push(texture.type);
                    formats.push(texture.format);
                    const index = internalTexture2Index[texture.uniqueId];
                    if (index !== undefined) {
                        targetTypes.push(-1);
                        layerCounts.push(0);
                    } else {
                        internalTexture2Index[texture.uniqueId] = i;
                        if (texture.is2DArray) {
                            targetTypes.push(35866);
                            layerCounts.push(texture.depth);
                        } else if (texture.isCube) {
                            targetTypes.push(34067);
                            layerCounts.push(0);
                        } else if (texture.is3D) {
                            targetTypes.push(32879);
                            layerCounts.push(texture.depth);
                        } else {
                            targetTypes.push(3553);
                            layerCounts.push(0);
                        }
                    }
                    if (this._faceIndices) faceIndex.push(this._faceIndices[i] ?? 0);
                    if (this._layerIndices) layerIndex.push(this._layerIndices[i] ?? 0);
                }
                const optionsMRT = {
                    samplingModes: samplingModes,
                    generateMipMaps: textureArray[0].generateMipMaps,
                    generateDepthBuffer: this._generateDepthBuffer,
                    generateStencilBuffer: this._generateStencilBuffer,
                    generateDepthTexture: generateDepthTexture,
                    depthTextureFormat: depthTextureFormat,
                    types: types,
                    formats: formats,
                    textureCount: textureCount,
                    targetTypes: targetTypes,
                    faceIndex: faceIndex,
                    layerIndex: layerIndex,
                    layerCounts: layerCounts,
                    label: this.label
                };
                const size = {
                    width: this.width,
                    height: this.height,
                    depth: this.depth
                };
                rtw = this._engine.createMultipleRenderTarget(size, optionsMRT);
                for(let i = 0; i < textureCount; ++i){
                    if (targetTypes[i] !== -1) continue;
                    const index = internalTexture2Index[textureArray[i].uniqueId];
                    rtw.setTexture(rtw.textures[index], i);
                }
            }
        } else {
            const options = {};
            options.generateDepthBuffer = this._generateDepthBuffer;
            options.generateMipMaps = this.texture?.generateMipMaps ?? false;
            options.generateStencilBuffer = this._generateStencilBuffer;
            options.samplingMode = this.texture?.samplingMode;
            options.type = this.texture?.type;
            options.format = this.texture?.format;
            options.noColorAttachment = !this._textures;
            options.label = this.label;
            if (this.isCube) rtw = this._engine.createRenderTargetCubeTexture(this.width, options);
            else {
                const size = {
                    width: this.width,
                    height: this.height,
                    layers: this.is2DArray || this.is3D ? this.texture?.depth : undefined
                };
                rtw = this._engine.createRenderTargetTexture(size, options);
            }
            if (rtw.texture) rtw.texture.isReady = true;
        }
        return rtw;
    }
    _swapRenderTargetWrapper(target) {
        if (this._textures && target._textures) for(let i = 0; i < this._textures.length; ++i){
            this._textures[i]._swapAndDie(target._textures[i], false);
            target._textures[i].isReady = true;
        }
        if (this._depthStencilTexture && target._depthStencilTexture) {
            this._depthStencilTexture._swapAndDie(target._depthStencilTexture);
            target._depthStencilTexture.isReady = true;
        }
        this._textures = null;
        this._depthStencilTexture = null;
    }
    /** @internal */ _rebuild() {
        const rtw = this._cloneRenderTargetWrapper();
        if (!rtw) return;
        if (this._depthStencilTexture) {
            const samplingMode = this._depthStencilTexture.samplingMode;
            const format = this._depthStencilTexture.format;
            const bilinear = samplingMode === 2 || samplingMode === 3 || samplingMode === 11;
            rtw.createDepthStencilTexture(this._depthStencilTexture._comparisonFunction, bilinear, this._depthStencilTextureWithStencil, this._depthStencilTexture.samples, format, this._depthStencilTextureLabel);
        }
        if (this.samples > 1) rtw.setSamples(this.samples);
        rtw._swapRenderTargetWrapper(this);
        rtw.dispose();
    }
    /**
     * Releases the internal render textures
     */ releaseTextures() {
        if (this._textures) for(let i = 0; i < this._textures.length; ++i)this._textures[i].dispose();
        this._textures = null;
    }
    /**
     * Disposes the whole render target wrapper
     * @param disposeOnlyFramebuffers true if only the frame buffers should be released (used for the WebGL engine). If false, all the textures will also be released
     */ dispose(disposeOnlyFramebuffers = false) {
        if (!disposeOnlyFramebuffers) {
            this._depthStencilTexture?.dispose();
            this._depthStencilTexture = null;
            this.releaseTextures();
        }
        this._engine._releaseRenderTargetWrapper(this);
    }
}

});


parcelRegister("3l1SY", function(module, exports) {

var $dUFoQ = parcelRequire("dUFoQ");
(0, $dUFoQ.AbstractEngine).prototype.createDepthStencilTexture = function(size, options, rtWrapper) {
    if (options.isCube) {
        const width = size.width || size;
        return this._createDepthStencilCubeTexture(width, options);
    } else return this._createDepthStencilTexture(size, options, rtWrapper);
};

});


parcelRegister("hX3rq", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.setDepthStencilTexture = function(channel, uniform, texture, name) {
    if (channel === undefined) return;
    if (uniform) this._boundUniforms[channel] = uniform;
    if (!texture || !texture.depthStencilTexture) this._setTexture(channel, null, undefined, undefined, name);
    else this._setTexture(channel, texture, false, true, name);
};

});

parcelRegister("gfE2b", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.createRenderTargetCubeTexture = function(size, options) {
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, true, size);
    const fullOptions = {
        generateMipMaps: true,
        generateDepthBuffer: true,
        generateStencilBuffer: false,
        type: 0,
        samplingMode: 3,
        format: 5,
        ...options
    };
    fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && fullOptions.generateStencilBuffer;
    if (fullOptions.type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
    fullOptions.samplingMode = 1;
    else if (fullOptions.type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
    fullOptions.samplingMode = 1;
    const gl = this._gl;
    const texture = new (0, $b9e4a.InternalTexture)(this, 5 /* InternalTextureSource.RenderTarget */ );
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
    const filters = this._getSamplingParameters(fullOptions.samplingMode, fullOptions.generateMipMaps);
    if (fullOptions.type === 1 && !this._caps.textureFloat) {
        fullOptions.type = 0;
        (0, $kVtWi.Logger).Warn("Float textures are not supported. Cube render target forced to TEXTURETYPE_UNESIGNED_BYTE type");
    }
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, filters.mag);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, filters.min);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    for(let face = 0; face < 6; face++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, this._getRGBABufferInternalSizedFormat(fullOptions.type, fullOptions.format), size, size, 0, this._getInternalFormat(fullOptions.format), this._getWebGLTextureType(fullOptions.type), null);
    // Create the framebuffer
    const framebuffer = gl.createFramebuffer();
    this._bindUnboundFramebuffer(framebuffer);
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(fullOptions.generateStencilBuffer, fullOptions.generateDepthBuffer, size, size);
    // MipMaps
    if (fullOptions.generateMipMaps) gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
    // Unbind
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    this._bindUnboundFramebuffer(null);
    rtWrapper._framebuffer = framebuffer;
    rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
    rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer;
    texture.width = size;
    texture.height = size;
    texture.isReady = true;
    texture.isCube = true;
    texture.samples = 1;
    texture.generateMipMaps = fullOptions.generateMipMaps;
    texture.samplingMode = fullOptions.samplingMode;
    texture.type = fullOptions.type;
    texture.format = fullOptions.format;
    this._internalTexturesCache.push(texture);
    rtWrapper.setTextures(texture);
    return rtWrapper;
};

});

parcelRegister("ica7E", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $f3g09 = parcelRequire("f3g09");

var $akOl3 = parcelRequire("akOl3");

(0, $2h5JR.ThinEngine).prototype.createPrefilteredCubeTexture = function(rootUrl, scene, lodScale, lodOffset, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = true) {
    const callback = async (loadData)=>{
        if (!loadData) {
            if (onLoad) onLoad(null);
            return;
        }
        const texture = loadData.texture;
        if (!createPolynomials) texture._sphericalPolynomial = new (0, $f3g09.SphericalPolynomial)();
        else if (loadData.info.sphericalPolynomial) texture._sphericalPolynomial = loadData.info.sphericalPolynomial;
        texture._source = 9 /* InternalTextureSource.CubePrefiltered */ ;
        if (this.getCaps().textureLOD) {
            // Do not add extra process if texture lod is supported.
            if (onLoad) onLoad(texture);
            return;
        }
        const mipSlices = 3;
        const gl = this._gl;
        const width = loadData.width;
        if (!width) return;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { DDSTools: DDSTools } = await (parcelRequire("hfaur"));
        const textures = [];
        for(let i = 0; i < mipSlices; i++){
            //compute LOD from even spacing in smoothness (matching shader calculation)
            const smoothness = i / (mipSlices - 1);
            const roughness = 1 - smoothness;
            const minLODIndex = lodOffset; // roughness = 0
            const maxLODIndex = Math.log2(width) * lodScale + lodOffset; // roughness = 1
            const lodIndex = minLODIndex + (maxLODIndex - minLODIndex) * roughness;
            const mipmapIndex = Math.round(Math.min(Math.max(lodIndex, 0), maxLODIndex));
            const glTextureFromLod = new (0, $b9e4a.InternalTexture)(this, 2 /* InternalTextureSource.Temp */ );
            glTextureFromLod.type = texture.type;
            glTextureFromLod.format = texture.format;
            glTextureFromLod.width = Math.pow(2, Math.max(Math.log2(width) - mipmapIndex, 0));
            glTextureFromLod.height = glTextureFromLod.width;
            glTextureFromLod.isCube = true;
            glTextureFromLod._cachedWrapU = 0;
            glTextureFromLod._cachedWrapV = 0;
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, glTextureFromLod, true);
            glTextureFromLod.samplingMode = 2;
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            if (loadData.isDDS) {
                const info = loadData.info;
                const data = loadData.data;
                this._unpackFlipY(info.isCompressed);
                DDSTools.UploadDDSLevels(this, glTextureFromLod, data, info, true, 6, mipmapIndex);
            } else (0, $kVtWi.Logger).Warn("DDS is the only prefiltered cube map supported so far.");
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
            // Wrap in a base texture for easy binding.
            const lodTexture = new (0, $akOl3.BaseTexture)(scene);
            lodTexture._isCube = true;
            lodTexture._texture = glTextureFromLod;
            glTextureFromLod.isReady = true;
            textures.push(lodTexture);
        }
        texture._lodTextureHigh = textures[2];
        texture._lodTextureMid = textures[1];
        texture._lodTextureLow = textures[0];
        if (onLoad) onLoad(texture);
    };
    return this.createCubeTexture(rootUrl, scene, null, false, callback, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset);
};

});
parcelRegister("f3g09", function(module, exports) {

$parcel$export(module.exports, "SphericalHarmonics", () => $af538c62014b132a$export$a11ccd906ebcd67c);
$parcel$export(module.exports, "SphericalPolynomial", () => $af538c62014b132a$export$df22d3e5758589d2);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $ha1VO = parcelRequire("ha1VO");
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");
// https://dickyjim.wordpress.com/2013/09/04/spherical-harmonics-for-beginners/
// http://silviojemma.com/public/papers/lighting/spherical-harmonic-lighting.pdf
// https://www.ppsloan.org/publications/StupidSH36.pdf
// http://cseweb.ucsd.edu/~ravir/papers/envmap/envmap.pdf
// https://www.ppsloan.org/publications/SHJCGT.pdf
// https://www.ppsloan.org/publications/shdering.pdf
// https://google.github.io/filament/Filament.md.html#annex/sphericalharmonics
// https://patapom.com/blog/SHPortal/
// https://imdoingitwrong.wordpress.com/2011/04/14/spherical-harmonics-wtf/
// Using real SH basis:
//  m>0             m   m
// y   = sqrt(2) * K * P * cos(m*phi) * cos(theta)
//  l               l   l
//
//  m<0             m   |m|
// y   = sqrt(2) * K * P * sin(m*phi) * cos(theta)
//  l               l   l
//
//  m=0   0   0
// y   = K * P * trigono terms
//  l     l   l
//
//  m       (2l + 1)(l - |m|)!
// K = sqrt(------------------)
//  l           4pi(l + |m|)!
//
// and P by recursion:
//
// P00(x) = 1
// P01(x) = x
// Pll(x) = (-1^l)(2l - 1)!!(1-x*x)^(1/2)
//          ((2l - 1)x[Pl-1/m]-(l + m - 1)[Pl-2/m])
// Plm(x) = ---------------------------------------
//                         l - m
// Leaving the trigonometric terms aside we can precompute the constants to :
const $af538c62014b132a$var$SH3ylmBasisConstants = [
    Math.sqrt(1 / (4 * Math.PI)),
    -Math.sqrt(3 / (4 * Math.PI)),
    Math.sqrt(3 / (4 * Math.PI)),
    -Math.sqrt(3 / (4 * Math.PI)),
    Math.sqrt(15 / (4 * Math.PI)),
    -Math.sqrt(15 / (4 * Math.PI)),
    Math.sqrt(5 / (16 * Math.PI)),
    -Math.sqrt(15 / (4 * Math.PI)),
    Math.sqrt(15 / (16 * Math.PI))
];
// cm = cos(m * phi)
// sm = sin(m * phi)
// {x,y,z} = {cos(phi)sin(theta), sin(phi)sin(theta), cos(theta)}
// By recursion on using trigo identities:
const $af538c62014b132a$var$SH3ylmBasisTrigonometricTerms = [
    ()=>1,
    (direction)=>direction.y,
    (direction)=>direction.z,
    (direction)=>direction.x,
    (direction)=>direction.x * direction.y,
    (direction)=>direction.y * direction.z,
    (direction)=>3 * direction.z * direction.z - 1,
    (direction)=>direction.x * direction.z,
    (direction)=>direction.x * direction.x - direction.y * direction.y
];
// Wrap the full compute
const $af538c62014b132a$var$applySH3 = (lm, direction)=>{
    return $af538c62014b132a$var$SH3ylmBasisConstants[lm] * $af538c62014b132a$var$SH3ylmBasisTrigonometricTerms[lm](direction);
};
// Derived from the integration of the a kernel convolution to SH.
// Great explanation here: https://patapom.com/blog/SHPortal/#about-distant-radiance-and-irradiance-environments
const $af538c62014b132a$var$SHCosKernelConvolution = [
    Math.PI,
    2 * Math.PI / 3,
    2 * Math.PI / 3,
    2 * Math.PI / 3,
    Math.PI / 4,
    Math.PI / 4,
    Math.PI / 4,
    Math.PI / 4,
    Math.PI / 4
];
class $af538c62014b132a$export$a11ccd906ebcd67c {
    constructor(){
        /**
         * Defines whether or not the harmonics have been prescaled for rendering.
         */ this.preScaled = false;
        /**
         * The l0,0 coefficients of the spherical harmonics
         */ this.l00 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l1,-1 coefficients of the spherical harmonics
         */ this.l1_1 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l1,0 coefficients of the spherical harmonics
         */ this.l10 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l1,1 coefficients of the spherical harmonics
         */ this.l11 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,-2 coefficients of the spherical harmonics
         */ this.l2_2 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,-1 coefficients of the spherical harmonics
         */ this.l2_1 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,0 coefficients of the spherical harmonics
         */ this.l20 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,1 coefficients of the spherical harmonics
         */ this.l21 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,2 coefficients of the spherical harmonics
         */ this.l22 = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Adds a light to the spherical harmonics
     * @param direction the direction of the light
     * @param color the color of the light
     * @param deltaSolidAngle the delta solid angle of the light
     */ addLight(direction, color, deltaSolidAngle) {
        (0, $ha1VO.TmpVectors).Vector3[0].set(color.r, color.g, color.b);
        const colorVector = (0, $ha1VO.TmpVectors).Vector3[0];
        const c = (0, $ha1VO.TmpVectors).Vector3[1];
        colorVector.scaleToRef(deltaSolidAngle, c);
        c.scaleToRef($af538c62014b132a$var$applySH3(0, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l00.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(1, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l1_1.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(2, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l10.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(3, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l11.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(4, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l2_2.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(5, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l2_1.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(6, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l20.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(7, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l21.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(8, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l22.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
    }
    /**
     * Scales the spherical harmonics by the given amount
     * @param scale the amount to scale
     */ scaleInPlace(scale) {
        this.l00.scaleInPlace(scale);
        this.l1_1.scaleInPlace(scale);
        this.l10.scaleInPlace(scale);
        this.l11.scaleInPlace(scale);
        this.l2_2.scaleInPlace(scale);
        this.l2_1.scaleInPlace(scale);
        this.l20.scaleInPlace(scale);
        this.l21.scaleInPlace(scale);
        this.l22.scaleInPlace(scale);
    }
    /**
     * Convert from incident radiance (Li) to irradiance (E) by applying convolution with the cosine-weighted hemisphere.
     *
     * ```
     * E_lm = A_l * L_lm
     * ```
     *
     * In spherical harmonics this convolution amounts to scaling factors for each frequency band.
     * This corresponds to equation 5 in "An Efficient Representation for Irradiance Environment Maps", where
     * the scaling factors are given in equation 9.
     */ convertIncidentRadianceToIrradiance() {
        // Constant (Band 0)
        this.l00.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[0]);
        // Linear (Band 1)
        this.l1_1.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[1]);
        this.l10.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[2]);
        this.l11.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[3]);
        // Quadratic (Band 2)
        this.l2_2.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[4]);
        this.l2_1.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[5]);
        this.l20.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[6]);
        this.l21.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[7]);
        this.l22.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[8]);
    }
    /**
     * Convert from irradiance to outgoing radiance for Lambertian BDRF, suitable for efficient shader evaluation.
     *
     * ```
     * L = (1/pi) * E * rho
     * ```
     *
     * This is done by an additional scale by 1/pi, so is a fairly trivial operation but important conceptually.
     */ convertIrradianceToLambertianRadiance() {
        this.scaleInPlace(1.0 / Math.PI);
    // The resultant SH now represents outgoing radiance, so includes the Lambert 1/pi normalisation factor but without albedo (rho) applied
    // (The pixel shader must apply albedo after texture fetches, etc).
    }
    /**
     * Integrates the reconstruction coefficients directly in to the SH preventing further
     * required operations at run time.
     *
     * This is simply done by scaling back the SH with Ylm constants parameter.
     * The trigonometric part being applied by the shader at run time.
     */ preScaleForRendering() {
        this.preScaled = true;
        this.l00.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[0]);
        this.l1_1.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[1]);
        this.l10.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[2]);
        this.l11.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[3]);
        this.l2_2.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[4]);
        this.l2_1.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[5]);
        this.l20.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[6]);
        this.l21.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[7]);
        this.l22.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[8]);
    }
    /**
     * update the spherical harmonics coefficients from the given array
     * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
     * @returns the spherical harmonics (this)
     */ updateFromArray(data) {
        (0, $ha1VO.Vector3).FromArrayToRef(data[0], 0, this.l00);
        (0, $ha1VO.Vector3).FromArrayToRef(data[1], 0, this.l1_1);
        (0, $ha1VO.Vector3).FromArrayToRef(data[2], 0, this.l10);
        (0, $ha1VO.Vector3).FromArrayToRef(data[3], 0, this.l11);
        (0, $ha1VO.Vector3).FromArrayToRef(data[4], 0, this.l2_2);
        (0, $ha1VO.Vector3).FromArrayToRef(data[5], 0, this.l2_1);
        (0, $ha1VO.Vector3).FromArrayToRef(data[6], 0, this.l20);
        (0, $ha1VO.Vector3).FromArrayToRef(data[7], 0, this.l21);
        (0, $ha1VO.Vector3).FromArrayToRef(data[8], 0, this.l22);
        return this;
    }
    /**
     * update the spherical harmonics coefficients from the given floats array
     * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
     * @returns the spherical harmonics (this)
     */ updateFromFloatsArray(data) {
        (0, $ha1VO.Vector3).FromFloatsToRef(data[0], data[1], data[2], this.l00);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[3], data[4], data[5], this.l1_1);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[6], data[7], data[8], this.l10);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[9], data[10], data[11], this.l11);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[12], data[13], data[14], this.l2_2);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[15], data[16], data[17], this.l2_1);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[18], data[19], data[20], this.l20);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[21], data[22], data[23], this.l21);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[24], data[25], data[26], this.l22);
        return this;
    }
    /**
     * Constructs a spherical harmonics from an array.
     * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
     * @returns the spherical harmonics
     */ static FromArray(data) {
        const sh = new $af538c62014b132a$export$a11ccd906ebcd67c();
        return sh.updateFromArray(data);
    }
    // Keep for references.
    /**
     * Gets the spherical harmonics from polynomial
     * @param polynomial the spherical polynomial
     * @returns the spherical harmonics
     */ static FromPolynomial(polynomial) {
        const result = new $af538c62014b132a$export$a11ccd906ebcd67c();
        result.l00 = polynomial.xx.scale(0.376127).add(polynomial.yy.scale(0.376127)).add(polynomial.zz.scale(0.376126));
        result.l1_1 = polynomial.y.scale(0.977204);
        result.l10 = polynomial.z.scale(0.977204);
        result.l11 = polynomial.x.scale(0.977204);
        result.l2_2 = polynomial.xy.scale(1.16538);
        result.l2_1 = polynomial.yz.scale(1.16538);
        result.l20 = polynomial.zz.scale(1.34567).subtract(polynomial.xx.scale(0.672834)).subtract(polynomial.yy.scale(0.672834));
        result.l21 = polynomial.zx.scale(1.16538);
        result.l22 = polynomial.xx.scale(1.16538).subtract(polynomial.yy.scale(1.16538));
        result.l1_1.scaleInPlace(-1);
        result.l11.scaleInPlace(-1);
        result.l2_1.scaleInPlace(-1);
        result.l21.scaleInPlace(-1);
        result.scaleInPlace(Math.PI);
        return result;
    }
}
class $af538c62014b132a$export$df22d3e5758589d2 {
    constructor(){
        /**
         * The x coefficients of the spherical polynomial
         */ this.x = (0, $ha1VO.Vector3).Zero();
        /**
         * The y coefficients of the spherical polynomial
         */ this.y = (0, $ha1VO.Vector3).Zero();
        /**
         * The z coefficients of the spherical polynomial
         */ this.z = (0, $ha1VO.Vector3).Zero();
        /**
         * The xx coefficients of the spherical polynomial
         */ this.xx = (0, $ha1VO.Vector3).Zero();
        /**
         * The yy coefficients of the spherical polynomial
         */ this.yy = (0, $ha1VO.Vector3).Zero();
        /**
         * The zz coefficients of the spherical polynomial
         */ this.zz = (0, $ha1VO.Vector3).Zero();
        /**
         * The xy coefficients of the spherical polynomial
         */ this.xy = (0, $ha1VO.Vector3).Zero();
        /**
         * The yz coefficients of the spherical polynomial
         */ this.yz = (0, $ha1VO.Vector3).Zero();
        /**
         * The zx coefficients of the spherical polynomial
         */ this.zx = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * The spherical harmonics used to create the polynomials.
     */ get preScaledHarmonics() {
        if (!this._harmonics) this._harmonics = $af538c62014b132a$export$a11ccd906ebcd67c.FromPolynomial(this);
        if (!this._harmonics.preScaled) this._harmonics.preScaleForRendering();
        return this._harmonics;
    }
    /**
     * Adds an ambient color to the spherical polynomial
     * @param color the color to add
     */ addAmbient(color) {
        (0, $ha1VO.TmpVectors).Vector3[0].copyFromFloats(color.r, color.g, color.b);
        const colorVector = (0, $ha1VO.TmpVectors).Vector3[0];
        this.xx.addInPlace(colorVector);
        this.yy.addInPlace(colorVector);
        this.zz.addInPlace(colorVector);
    }
    /**
     * Scales the spherical polynomial by the given amount
     * @param scale the amount to scale
     */ scaleInPlace(scale) {
        this.x.scaleInPlace(scale);
        this.y.scaleInPlace(scale);
        this.z.scaleInPlace(scale);
        this.xx.scaleInPlace(scale);
        this.yy.scaleInPlace(scale);
        this.zz.scaleInPlace(scale);
        this.yz.scaleInPlace(scale);
        this.zx.scaleInPlace(scale);
        this.xy.scaleInPlace(scale);
    }
    /**
     * Updates the spherical polynomial from harmonics
     * @param harmonics the spherical harmonics
     * @returns the spherical polynomial
     */ updateFromHarmonics(harmonics) {
        this._harmonics = harmonics;
        this.x.copyFrom(harmonics.l11);
        this.x.scaleInPlace(1.02333).scaleInPlace(-1);
        this.y.copyFrom(harmonics.l1_1);
        this.y.scaleInPlace(1.02333).scaleInPlace(-1);
        this.z.copyFrom(harmonics.l10);
        this.z.scaleInPlace(1.02333);
        this.xx.copyFrom(harmonics.l00);
        (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.247708);
        (0, $ha1VO.TmpVectors).Vector3[1].copyFrom(harmonics.l22).scaleInPlace(0.429043);
        this.xx.scaleInPlace(0.886277).subtractInPlace((0, $ha1VO.TmpVectors).Vector3[0]).addInPlace((0, $ha1VO.TmpVectors).Vector3[1]);
        this.yy.copyFrom(harmonics.l00);
        this.yy.scaleInPlace(0.886277).subtractInPlace((0, $ha1VO.TmpVectors).Vector3[0]).subtractInPlace((0, $ha1VO.TmpVectors).Vector3[1]);
        this.zz.copyFrom(harmonics.l00);
        (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.495417);
        this.zz.scaleInPlace(0.886277).addInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
        this.yz.copyFrom(harmonics.l2_1);
        this.yz.scaleInPlace(0.858086).scaleInPlace(-1);
        this.zx.copyFrom(harmonics.l21);
        this.zx.scaleInPlace(0.858086).scaleInPlace(-1);
        this.xy.copyFrom(harmonics.l2_2);
        this.xy.scaleInPlace(0.858086);
        this.scaleInPlace(1.0 / Math.PI);
        return this;
    }
    /**
     * Gets the spherical polynomial from harmonics
     * @param harmonics the spherical harmonics
     * @returns the spherical polynomial
     */ static FromHarmonics(harmonics) {
        const result = new $af538c62014b132a$export$df22d3e5758589d2();
        return result.updateFromHarmonics(harmonics);
    }
    /**
     * Constructs a spherical polynomial from an array.
     * @param data defines the 9x3 coefficients (x, y, z, xx, yy, zz, yz, zx, xy)
     * @returns the spherical polynomial
     */ static FromArray(data) {
        const sp = new $af538c62014b132a$export$df22d3e5758589d2();
        (0, $ha1VO.Vector3).FromArrayToRef(data[0], 0, sp.x);
        (0, $ha1VO.Vector3).FromArrayToRef(data[1], 0, sp.y);
        (0, $ha1VO.Vector3).FromArrayToRef(data[2], 0, sp.z);
        (0, $ha1VO.Vector3).FromArrayToRef(data[3], 0, sp.xx);
        (0, $ha1VO.Vector3).FromArrayToRef(data[4], 0, sp.yy);
        (0, $ha1VO.Vector3).FromArrayToRef(data[5], 0, sp.zz);
        (0, $ha1VO.Vector3).FromArrayToRef(data[6], 0, sp.yz);
        (0, $ha1VO.Vector3).FromArrayToRef(data[7], 0, sp.zx);
        (0, $ha1VO.Vector3).FromArrayToRef(data[8], 0, sp.xy);
        return sp;
    }
}

});
parcelRegister("6rxfP", function(module, exports) {
$parcel$export(module.exports, "Color3", () => (parcelRequire("7etnY")).Color3);
$parcel$export(module.exports, "Color4", () => (parcelRequire("7etnY")).Color4);
$parcel$export(module.exports, "Quaternion", () => (parcelRequire("ha1VO")).Quaternion);
$parcel$export(module.exports, "TmpVectors", () => (parcelRequire("ha1VO")).TmpVectors);
$parcel$export(module.exports, "Vector2", () => (parcelRequire("ha1VO")).Vector2);
$parcel$export(module.exports, "Vector3", () => (parcelRequire("ha1VO")).Vector3);
parcelRequire("dbxbu");
parcelRequire("7etnY");
parcelRequire("53VPf");
parcelRequire("9sPMJ");
parcelRequire("fm2C6");
parcelRequire("23POp");
parcelRequire("93o7r");
parcelRequire("ha1VO");
parcelRequire("g13hK");
parcelRequire("191mA");

});
parcelRegister("dbxbu", function(module, exports) {

$parcel$export(module.exports, "Axis", () => $99960b2795987ea2$export$d06866a9fb0606da);

var $ha1VO = parcelRequire("ha1VO");
var $99960b2795987ea2$export$eef1e68107c58ef2;
(function(Space) {
    /** Local (object) space */ Space[Space["LOCAL"] = 0] = "LOCAL";
    /** World space */ Space[Space["WORLD"] = 1] = "WORLD";
    /** Bone space */ Space[Space["BONE"] = 2] = "BONE";
})($99960b2795987ea2$export$eef1e68107c58ef2 || ($99960b2795987ea2$export$eef1e68107c58ef2 = {}));
class $99960b2795987ea2$export$d06866a9fb0606da {
}
/** X axis */ $99960b2795987ea2$export$d06866a9fb0606da.X = new (0, $ha1VO.Vector3)(1.0, 0.0, 0.0);
/** Y axis */ $99960b2795987ea2$export$d06866a9fb0606da.Y = new (0, $ha1VO.Vector3)(0.0, 1.0, 0.0);
/** Z axis */ $99960b2795987ea2$export$d06866a9fb0606da.Z = new (0, $ha1VO.Vector3)(0.0, 0.0, 1.0);
var $99960b2795987ea2$export$7faa80054108057;
(function(Coordinate) {
    /** X axis */ Coordinate[Coordinate["X"] = 0] = "X";
    /** Y axis */ Coordinate[Coordinate["Y"] = 1] = "Y";
    /** Z axis */ Coordinate[Coordinate["Z"] = 2] = "Z";
})($99960b2795987ea2$export$7faa80054108057 || ($99960b2795987ea2$export$7faa80054108057 = {}));

});

parcelRegister("fm2C6", function(module, exports) {

$parcel$export(module.exports, "BezierCurve", () => $b2daf017bbb96e17$export$a57c23a30525a34b);
$parcel$export(module.exports, "Path2", () => $b2daf017bbb96e17$export$134926acf342e25);
$parcel$export(module.exports, "Path3D", () => $b2daf017bbb96e17$export$5d6a5d8dc9b2f01b);

var $iosaP = parcelRequire("iosaP");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");
var $b2daf017bbb96e17$export$df54d73aa0ec5e82;
(function(Orientation) {
    /**
     * Clockwise
     */ Orientation[Orientation["CW"] = 0] = "CW";
    /** Counter clockwise */ Orientation[Orientation["CCW"] = 1] = "CCW";
})($b2daf017bbb96e17$export$df54d73aa0ec5e82 || ($b2daf017bbb96e17$export$df54d73aa0ec5e82 = {}));
class $b2daf017bbb96e17$export$a57c23a30525a34b {
    /**
     * Returns the cubic Bezier interpolated value (float) at "t" (float) from the given x1, y1, x2, y2 floats
     * @param t defines the time
     * @param x1 defines the left coordinate on X axis
     * @param y1 defines the left coordinate on Y axis
     * @param x2 defines the right coordinate on X axis
     * @param y2 defines the right coordinate on Y axis
     * @returns the interpolated value
     */ static Interpolate(t, x1, y1, x2, y2) {
        // Extract X (which is equal to time here)
        const f0 = 1 - 3 * x2 + 3 * x1;
        const f1 = 3 * x2 - 6 * x1;
        const f2 = 3 * x1;
        let refinedT = t;
        for(let i = 0; i < 5; i++){
            const refinedT2 = refinedT * refinedT;
            const refinedT3 = refinedT2 * refinedT;
            const x = f0 * refinedT3 + f1 * refinedT2 + f2 * refinedT;
            const slope = 1.0 / (3.0 * f0 * refinedT2 + 2.0 * f1 * refinedT + f2);
            refinedT -= (x - t) * slope;
            refinedT = Math.min(1, Math.max(0, refinedT));
        }
        // Resolve cubic bezier for the given x
        return 3 * Math.pow(1 - refinedT, 2) * refinedT * y1 + 3 * (1 - refinedT) * Math.pow(refinedT, 2) * y2 + Math.pow(refinedT, 3);
    }
}
class $b2daf017bbb96e17$export$6cdc1cb9345ffadf {
    /**
     * Creates an Angle object of "radians" radians (float).
     * @param radians the angle in radians
     */ constructor(radians){
        this._radians = radians;
        if (this._radians < 0.0) this._radians += 2.0 * Math.PI;
    }
    /**
     * Get value in degrees
     * @returns the Angle value in degrees (float)
     */ degrees() {
        return this._radians * 180.0 / Math.PI;
    }
    /**
     * Get value in radians
     * @returns the Angle value in radians (float)
     */ radians() {
        return this._radians;
    }
    /**
     * Gets a new Angle object with a value of the angle (in radians) between the line connecting the two points and the x-axis
     * @param a defines first point as the origin
     * @param b defines point
     * @returns a new Angle
     */ static BetweenTwoPoints(a, b) {
        const delta = b.subtract(a);
        const theta = Math.atan2(delta.y, delta.x);
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(theta);
    }
    /**
     * Gets the angle between the two vectors
     * @param a defines first vector
     * @param b defines vector
     * @returns Returns an new Angle between 0 and PI
     */ static BetweenTwoVectors(a, b) {
        let product = a.lengthSquared() * b.lengthSquared();
        if (product === 0) return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(Math.PI / 2);
        product = Math.sqrt(product);
        let cosVal = a.dot(b) / product;
        cosVal = (0, $iosaP.Clamp)(cosVal, -1, 1);
        const angle = Math.acos(cosVal);
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(angle);
    }
    /**
     * Gets a new Angle object from the given float in radians
     * @param radians defines the angle value in radians
     * @returns a new Angle
     */ static FromRadians(radians) {
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(radians);
    }
    /**
     * Gets a new Angle object from the given float in degrees
     * @param degrees defines the angle value in degrees
     * @returns a new Angle
     */ static FromDegrees(degrees) {
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(degrees * Math.PI / 180.0);
    }
}
class $b2daf017bbb96e17$export$4372ba0b01fe9b6d {
    /**
     * Creates an Arc object from the three given points : start, middle and end.
     * @param startPoint Defines the start point of the arc
     * @param midPoint Defines the middle point of the arc
     * @param endPoint Defines the end point of the arc
     */ constructor(/** Defines the start point of the arc */ startPoint, /** Defines the mid point of the arc */ midPoint, /** Defines the end point of the arc */ endPoint){
        this.startPoint = startPoint;
        this.midPoint = midPoint;
        this.endPoint = endPoint;
        const temp = Math.pow(midPoint.x, 2) + Math.pow(midPoint.y, 2);
        const startToMid = (Math.pow(startPoint.x, 2) + Math.pow(startPoint.y, 2) - temp) / 2;
        const midToEnd = (temp - Math.pow(endPoint.x, 2) - Math.pow(endPoint.y, 2)) / 2;
        const det = (startPoint.x - midPoint.x) * (midPoint.y - endPoint.y) - (midPoint.x - endPoint.x) * (startPoint.y - midPoint.y);
        this.centerPoint = new (0, $ha1VO.Vector2)((startToMid * (midPoint.y - endPoint.y) - midToEnd * (startPoint.y - midPoint.y)) / det, ((startPoint.x - midPoint.x) * midToEnd - (midPoint.x - endPoint.x) * startToMid) / det);
        this.radius = this.centerPoint.subtract(this.startPoint).length();
        this.startAngle = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.BetweenTwoPoints(this.centerPoint, this.startPoint);
        const a1 = this.startAngle.degrees();
        let a2 = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.BetweenTwoPoints(this.centerPoint, this.midPoint).degrees();
        let a3 = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.BetweenTwoPoints(this.centerPoint, this.endPoint).degrees();
        // angles correction
        if (a2 - a1 > 180) a2 -= 360.0;
        if (a2 - a1 < -180) a2 += 360.0;
        if (a3 - a2 > 180) a3 -= 360.0;
        if (a3 - a2 < -180) a3 += 360.0;
        this.orientation = a2 - a1 < 0 ? 0 /* Orientation.CW */  : 1 /* Orientation.CCW */ ;
        this.angle = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.FromDegrees(this.orientation === 0 /* Orientation.CW */  ? a1 - a3 : a3 - a1);
    }
}
class $b2daf017bbb96e17$export$134926acf342e25 {
    /**
     * Creates a Path2 object from the starting 2D coordinates x and y.
     * @param x the starting points x value
     * @param y the starting points y value
     */ constructor(x, y){
        this._points = new Array();
        this._length = 0.0;
        /**
         * If the path start and end point are the same
         */ this.closed = false;
        this._points.push(new (0, $ha1VO.Vector2)(x, y));
    }
    /**
     * Adds a new segment until the given coordinates (x, y) to the current Path2.
     * @param x the added points x value
     * @param y the added points y value
     * @returns the updated Path2.
     */ addLineTo(x, y) {
        if (this.closed) return this;
        const newPoint = new (0, $ha1VO.Vector2)(x, y);
        const previousPoint = this._points[this._points.length - 1];
        this._points.push(newPoint);
        this._length += newPoint.subtract(previousPoint).length();
        return this;
    }
    /**
     * Adds _numberOfSegments_ segments according to the arc definition (middle point coordinates, end point coordinates, the arc start point being the current Path2 last point) to the current Path2.
     * @param midX middle point x value
     * @param midY middle point y value
     * @param endX end point x value
     * @param endY end point y value
     * @param numberOfSegments (default: 36)
     * @returns the updated Path2.
     */ addArcTo(midX, midY, endX, endY, numberOfSegments = 36) {
        if (this.closed) return this;
        const startPoint = this._points[this._points.length - 1];
        const midPoint = new (0, $ha1VO.Vector2)(midX, midY);
        const endPoint = new (0, $ha1VO.Vector2)(endX, endY);
        const arc = new $b2daf017bbb96e17$export$4372ba0b01fe9b6d(startPoint, midPoint, endPoint);
        let increment = arc.angle.radians() / numberOfSegments;
        if (arc.orientation === 0 /* Orientation.CW */ ) increment *= -1;
        let currentAngle = arc.startAngle.radians() + increment;
        for(let i = 0; i < numberOfSegments; i++){
            const x = Math.cos(currentAngle) * arc.radius + arc.centerPoint.x;
            const y = Math.sin(currentAngle) * arc.radius + arc.centerPoint.y;
            this.addLineTo(x, y);
            currentAngle += increment;
        }
        return this;
    }
    /**
     * Adds _numberOfSegments_ segments according to the quadratic curve definition to the current Path2.
     * @param controlX control point x value
     * @param controlY control point y value
     * @param endX end point x value
     * @param endY end point y value
     * @param numberOfSegments (default: 36)
     * @returns the updated Path2.
     */ addQuadraticCurveTo(controlX, controlY, endX, endY, numberOfSegments = 36) {
        if (this.closed) return this;
        const equation = (t, val0, val1, val2)=>{
            const res = (1.0 - t) * (1.0 - t) * val0 + 2.0 * t * (1.0 - t) * val1 + t * t * val2;
            return res;
        };
        const startPoint = this._points[this._points.length - 1];
        for(let i = 0; i <= numberOfSegments; i++){
            const step = i / numberOfSegments;
            const x = equation(step, startPoint.x, controlX, endX);
            const y = equation(step, startPoint.y, controlY, endY);
            this.addLineTo(x, y);
        }
        return this;
    }
    /**
     * Adds _numberOfSegments_ segments according to the bezier curve definition to the current Path2.
     * @param originTangentX tangent vector at the origin point x value
     * @param originTangentY tangent vector at the origin point y value
     * @param destinationTangentX tangent vector at the destination point x value
     * @param destinationTangentY tangent vector at the destination point y value
     * @param endX end point x value
     * @param endY end point y value
     * @param numberOfSegments (default: 36)
     * @returns the updated Path2.
     */ addBezierCurveTo(originTangentX, originTangentY, destinationTangentX, destinationTangentY, endX, endY, numberOfSegments = 36) {
        if (this.closed) return this;
        const equation = (t, val0, val1, val2, val3)=>{
            const res = (1.0 - t) * (1.0 - t) * (1.0 - t) * val0 + 3.0 * t * (1.0 - t) * (1.0 - t) * val1 + 3.0 * t * t * (1.0 - t) * val2 + t * t * t * val3;
            return res;
        };
        const startPoint = this._points[this._points.length - 1];
        for(let i = 0; i <= numberOfSegments; i++){
            const step = i / numberOfSegments;
            const x = equation(step, startPoint.x, originTangentX, destinationTangentX, endX);
            const y = equation(step, startPoint.y, originTangentY, destinationTangentY, endY);
            this.addLineTo(x, y);
        }
        return this;
    }
    /**
     * Defines if a given point is inside the polygon defines by the path
     * @param point defines the point to test
     * @returns true if the point is inside
     */ isPointInside(point) {
        let isInside = false;
        const count = this._points.length;
        for(let p = count - 1, q = 0; q < count; p = q++){
            let edgeLow = this._points[p];
            let edgeHigh = this._points[q];
            let edgeDx = edgeHigh.x - edgeLow.x;
            let edgeDy = edgeHigh.y - edgeLow.y;
            if (Math.abs(edgeDy) > Number.EPSILON) {
                // Not parallel
                if (edgeDy < 0) {
                    edgeLow = this._points[q];
                    edgeDx = -edgeDx;
                    edgeHigh = this._points[p];
                    edgeDy = -edgeDy;
                }
                if (point.y < edgeLow.y || point.y > edgeHigh.y) continue;
                if (point.y === edgeLow.y && point.x === edgeLow.x) return true;
                else {
                    const perpEdge = edgeDy * (point.x - edgeLow.x) - edgeDx * (point.y - edgeLow.y);
                    if (perpEdge === 0) return true;
                    if (perpEdge < 0) continue;
                    isInside = !isInside;
                }
            } else {
                // parallel or collinear
                if (point.y !== edgeLow.y) continue;
                if (edgeHigh.x <= point.x && point.x <= edgeLow.x || edgeLow.x <= point.x && point.x <= edgeHigh.x) return true;
            }
        }
        return isInside;
    }
    /**
     * Closes the Path2.
     * @returns the Path2.
     */ close() {
        this.closed = true;
        return this;
    }
    /**
     * Gets the sum of the distance between each sequential point in the path
     * @returns the Path2 total length (float).
     */ length() {
        let result = this._length;
        if (this.closed) {
            const lastPoint = this._points[this._points.length - 1];
            const firstPoint = this._points[0];
            result += firstPoint.subtract(lastPoint).length();
        }
        return result;
    }
    /**
     * Gets the area of the polygon defined by the path
     * @returns area value
     */ area() {
        const n = this._points.length;
        let value = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)value += this._points[p].x * this._points[q].y - this._points[q].x * this._points[p].y;
        return value * 0.5;
    }
    /**
     * Gets the points which construct the path
     * @returns the Path2 internal array of points.
     */ getPoints() {
        return this._points;
    }
    /**
     * Retrieves the point at the distance aways from the starting point
     * @param normalizedLengthPosition the length along the path to retrieve the point from
     * @returns a new Vector2 located at a percentage of the Path2 total length on this path.
     */ getPointAtLengthPosition(normalizedLengthPosition) {
        if (normalizedLengthPosition < 0 || normalizedLengthPosition > 1) return (0, $ha1VO.Vector2).Zero();
        const lengthPosition = normalizedLengthPosition * this.length();
        let previousOffset = 0;
        for(let i = 0; i < this._points.length; i++){
            const j = (i + 1) % this._points.length;
            const a = this._points[i];
            const b = this._points[j];
            const bToA = b.subtract(a);
            const nextOffset = bToA.length() + previousOffset;
            if (lengthPosition >= previousOffset && lengthPosition <= nextOffset) {
                const dir = bToA.normalize();
                const localOffset = lengthPosition - previousOffset;
                return new (0, $ha1VO.Vector2)(a.x + dir.x * localOffset, a.y + dir.y * localOffset);
            }
            previousOffset = nextOffset;
        }
        return (0, $ha1VO.Vector2).Zero();
    }
    /**
     * Creates a new path starting from an x and y position
     * @param x starting x value
     * @param y starting y value
     * @returns a new Path2 starting at the coordinates (x, y).
     */ static StartingAt(x, y) {
        return new $b2daf017bbb96e17$export$134926acf342e25(x, y);
    }
}
class $b2daf017bbb96e17$export$5d6a5d8dc9b2f01b {
    /**
     * new Path3D(path, normal, raw)
     * Creates a Path3D. A Path3D is a logical math object, so not a mesh.
     * please read the description in the tutorial : https://doc.babylonjs.com/features/featuresDeepDive/mesh/path3D
     * @param path an array of Vector3, the curve axis of the Path3D
     * @param firstNormal (options) Vector3, the first wanted normal to the curve. Ex (0, 1, 0) for a vertical normal.
     * @param raw (optional, default false) : boolean, if true the returned Path3D isn't normalized. Useful to depict path acceleration or speed.
     * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path.
     */ constructor(/**
     * an array of Vector3, the curve axis of the Path3D
     */ path, firstNormal = null, raw, alignTangentsWithPath = false){
        this.path = path;
        this._curve = new Array();
        this._distances = new Array();
        this._tangents = new Array();
        this._normals = new Array();
        this._binormals = new Array();
        // holds interpolated point data
        this._pointAtData = {
            id: 0,
            point: (0, $ha1VO.Vector3).Zero(),
            previousPointArrayIndex: 0,
            position: 0,
            subPosition: 0,
            interpolateReady: false,
            interpolationMatrix: (0, $ha1VO.Matrix).Identity()
        };
        for(let p = 0; p < path.length; p++)this._curve[p] = path[p].clone(); // hard copy
        this._raw = raw || false;
        this._alignTangentsWithPath = alignTangentsWithPath;
        this._compute(firstNormal, alignTangentsWithPath);
    }
    /**
     * Returns the Path3D array of successive Vector3 designing its curve.
     * @returns the Path3D array of successive Vector3 designing its curve.
     */ getCurve() {
        return this._curve;
    }
    /**
     * Returns the Path3D array of successive Vector3 designing its curve.
     * @returns the Path3D array of successive Vector3 designing its curve.
     */ getPoints() {
        return this._curve;
    }
    /**
     * @returns the computed length (float) of the path.
     */ length() {
        return this._distances[this._distances.length - 1];
    }
    /**
     * Returns an array populated with tangent vectors on each Path3D curve point.
     * @returns an array populated with tangent vectors on each Path3D curve point.
     */ getTangents() {
        return this._tangents;
    }
    /**
     * Returns an array populated with normal vectors on each Path3D curve point.
     * @returns an array populated with normal vectors on each Path3D curve point.
     */ getNormals() {
        return this._normals;
    }
    /**
     * Returns an array populated with binormal vectors on each Path3D curve point.
     * @returns an array populated with binormal vectors on each Path3D curve point.
     */ getBinormals() {
        return this._binormals;
    }
    /**
     * Returns an array populated with distances (float) of the i-th point from the first curve point.
     * @returns an array populated with distances (float) of the i-th point from the first curve point.
     */ getDistances() {
        return this._distances;
    }
    /**
     * Returns an interpolated point along this path
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @returns a new Vector3 as the point
     */ getPointAt(position) {
        return this._updatePointAtData(position).point;
    }
    /**
     * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @param interpolated (optional, default false) : boolean, if true returns an interpolated tangent instead of the tangent of the previous path point.
     * @returns a tangent vector corresponding to the interpolated Path3D curve point, if not interpolated, the tangent is taken from the precomputed tangents array.
     */ getTangentAt(position, interpolated = false) {
        this._updatePointAtData(position, interpolated);
        return interpolated ? (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).Forward(), this._pointAtData.interpolationMatrix) : this._tangents[this._pointAtData.previousPointArrayIndex];
    }
    /**
     * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @param interpolated (optional, default false) : boolean, if true returns an interpolated normal instead of the normal of the previous path point.
     * @returns a normal vector corresponding to the interpolated Path3D curve point, if not interpolated, the normal is taken from the precomputed normals array.
     */ getNormalAt(position, interpolated = false) {
        this._updatePointAtData(position, interpolated);
        return interpolated ? (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).Right(), this._pointAtData.interpolationMatrix) : this._normals[this._pointAtData.previousPointArrayIndex];
    }
    /**
     * Returns the binormal vector of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @param interpolated (optional, default false) : boolean, if true returns an interpolated binormal instead of the binormal of the previous path point.
     * @returns a binormal vector corresponding to the interpolated Path3D curve point, if not interpolated, the binormal is taken from the precomputed binormals array.
     */ getBinormalAt(position, interpolated = false) {
        this._updatePointAtData(position, interpolated);
        return interpolated ? (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).UpReadOnly, this._pointAtData.interpolationMatrix) : this._binormals[this._pointAtData.previousPointArrayIndex];
    }
    /**
     * Returns the distance (float) of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @returns the distance of the interpolated Path3D curve point at the specified position along this path.
     */ getDistanceAt(position) {
        return this.length() * position;
    }
    /**
     * Returns the array index of the previous point of an interpolated point along this path
     * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
     * @returns the array index
     */ getPreviousPointIndexAt(position) {
        this._updatePointAtData(position);
        return this._pointAtData.previousPointArrayIndex;
    }
    /**
     * Returns the position of an interpolated point relative to the two path points it lies between, from 0.0 (point A) to 1.0 (point B)
     * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
     * @returns the sub position
     */ getSubPositionAt(position) {
        this._updatePointAtData(position);
        return this._pointAtData.subPosition;
    }
    /**
     * Returns the position of the closest virtual point on this path to an arbitrary Vector3, from 0.0 to 1.0
     * @param target the vector of which to get the closest position to
     * @returns the position of the closest virtual point on this path to the target vector
     */ getClosestPositionTo(target) {
        let smallestDistance = Number.MAX_VALUE;
        let closestPosition = 0.0;
        for(let i = 0; i < this._curve.length - 1; i++){
            const point = this._curve[i + 0];
            const tangent = this._curve[i + 1].subtract(point).normalize();
            const subLength = this._distances[i + 1] - this._distances[i + 0];
            const subPosition = Math.min(Math.max((0, $ha1VO.Vector3).Dot(tangent, target.subtract(point).normalize()), 0.0) * (0, $ha1VO.Vector3).Distance(point, target) / subLength, 1.0);
            const distance = (0, $ha1VO.Vector3).Distance(point.add(tangent.scale(subPosition * subLength)), target);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                closestPosition = (this._distances[i + 0] + subLength * subPosition) / this.length();
            }
        }
        return closestPosition;
    }
    /**
     * Returns a sub path (slice) of this path
     * @param start the position of the fist path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
     * @param end the position of the last path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
     * @returns a sub path (slice) of this path
     */ slice(start = 0.0, end = 1.0) {
        if (start < 0.0) start = 1 - start * -1 % 1.0;
        if (end < 0.0) end = 1 - end * -1 % 1.0;
        if (start > end) {
            const _start = start;
            start = end;
            end = _start;
        }
        const curvePoints = this.getCurve();
        const startPoint = this.getPointAt(start);
        let startIndex = this.getPreviousPointIndexAt(start);
        const endPoint = this.getPointAt(end);
        const endIndex = this.getPreviousPointIndexAt(end) + 1;
        const slicePoints = [];
        if (start !== 0.0) {
            startIndex++;
            slicePoints.push(startPoint);
        }
        slicePoints.push(...curvePoints.slice(startIndex, endIndex));
        if (end !== 1.0 || start === 1.0) slicePoints.push(endPoint);
        return new $b2daf017bbb96e17$export$5d6a5d8dc9b2f01b(slicePoints, this.getNormalAt(start), this._raw, this._alignTangentsWithPath);
    }
    /**
     * Forces the Path3D tangent, normal, binormal and distance recomputation.
     * @param path path which all values are copied into the curves points
     * @param firstNormal which should be projected onto the curve
     * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path
     * @returns the same object updated.
     */ update(path, firstNormal = null, alignTangentsWithPath = false) {
        for(let p = 0; p < path.length; p++){
            this._curve[p].x = path[p].x;
            this._curve[p].y = path[p].y;
            this._curve[p].z = path[p].z;
        }
        this._compute(firstNormal, alignTangentsWithPath);
        return this;
    }
    // private function compute() : computes tangents, normals and binormals
    _compute(firstNormal, alignTangentsWithPath = false) {
        const l = this._curve.length;
        if (l < 2) return;
        // first and last tangents
        this._tangents[0] = this._getFirstNonNullVector(0);
        if (!this._raw) this._tangents[0].normalize();
        this._tangents[l - 1] = this._curve[l - 1].subtract(this._curve[l - 2]);
        if (!this._raw) this._tangents[l - 1].normalize();
        // normals and binormals at first point : arbitrary vector with _normalVector()
        const tg0 = this._tangents[0];
        const pp0 = this._normalVector(tg0, firstNormal);
        this._normals[0] = pp0;
        if (!this._raw) this._normals[0].normalize();
        this._binormals[0] = (0, $ha1VO.Vector3).Cross(tg0, this._normals[0]);
        if (!this._raw) this._binormals[0].normalize();
        this._distances[0] = 0.0;
        // normals and binormals : next points
        let prev; // previous vector (segment)
        let cur; // current vector (segment)
        let curTang; // current tangent
        // previous normal
        let prevNor; // previous normal
        let prevBinor; // previous binormal
        for(let i = 1; i < l; i++){
            // tangents
            prev = this._getLastNonNullVector(i);
            if (i < l - 1) {
                cur = this._getFirstNonNullVector(i);
                this._tangents[i] = alignTangentsWithPath ? cur : prev.add(cur);
                this._tangents[i].normalize();
            }
            this._distances[i] = this._distances[i - 1] + this._curve[i].subtract(this._curve[i - 1]).length();
            // normals and binormals
            // http://www.cs.cmu.edu/afs/andrew/scs/cs/15-462/web/old/asst2camera.html
            curTang = this._tangents[i];
            prevBinor = this._binormals[i - 1];
            this._normals[i] = (0, $ha1VO.Vector3).Cross(prevBinor, curTang);
            if (!this._raw) {
                if (this._normals[i].length() === 0) {
                    prevNor = this._normals[i - 1];
                    this._normals[i] = prevNor.clone();
                } else this._normals[i].normalize();
            }
            this._binormals[i] = (0, $ha1VO.Vector3).Cross(curTang, this._normals[i]);
            if (!this._raw) this._binormals[i].normalize();
        }
        this._pointAtData.id = NaN;
    }
    // private function getFirstNonNullVector(index)
    // returns the first non null vector from index : curve[index + N].subtract(curve[index])
    _getFirstNonNullVector(index) {
        let i = 1;
        let nNVector = this._curve[index + i].subtract(this._curve[index]);
        while(nNVector.length() === 0 && index + i + 1 < this._curve.length){
            i++;
            nNVector = this._curve[index + i].subtract(this._curve[index]);
        }
        return nNVector;
    }
    // private function getLastNonNullVector(index)
    // returns the last non null vector from index : curve[index].subtract(curve[index - N])
    _getLastNonNullVector(index) {
        let i = 1;
        let nLVector = this._curve[index].subtract(this._curve[index - i]);
        while(nLVector.length() === 0 && index > i + 1){
            i++;
            nLVector = this._curve[index].subtract(this._curve[index - i]);
        }
        return nLVector;
    }
    // private function normalVector(v0, vt, va) :
    // returns an arbitrary point in the plane defined by the point v0 and the vector vt orthogonal to this plane
    // if va is passed, it returns the va projection on the plane orthogonal to vt at the point v0
    _normalVector(vt, va) {
        let normal0;
        let tgl = vt.length();
        if (tgl === 0.0) tgl = 1.0;
        if (va === undefined || va === null) {
            let point;
            if (!(0, $iosaP.WithinEpsilon)(Math.abs(vt.y) / tgl, 1.0, (0, $53VPf.Epsilon))) // search for a point in the plane
            point = new (0, $ha1VO.Vector3)(0.0, -1, 0.0);
            else if (!(0, $iosaP.WithinEpsilon)(Math.abs(vt.x) / tgl, 1.0, (0, $53VPf.Epsilon))) point = new (0, $ha1VO.Vector3)(1.0, 0.0, 0.0);
            else if (!(0, $iosaP.WithinEpsilon)(Math.abs(vt.z) / tgl, 1.0, (0, $53VPf.Epsilon))) point = new (0, $ha1VO.Vector3)(0.0, 0.0, 1.0);
            else point = (0, $ha1VO.Vector3).Zero();
            normal0 = (0, $ha1VO.Vector3).Cross(vt, point);
        } else {
            normal0 = (0, $ha1VO.Vector3).Cross(vt, va);
            (0, $ha1VO.Vector3).CrossToRef(normal0, vt, normal0);
        }
        normal0.normalize();
        return normal0;
    }
    /**
     * Updates the point at data for an interpolated point along this curve
     * @param position the position of the point along this curve, from 0.0 to 1.0
     * @param interpolateTNB
     * @interpolateTNB whether to compute the interpolated tangent, normal and binormal
     * @returns the (updated) point at data
     */ _updatePointAtData(position, interpolateTNB = false) {
        // set an id for caching the result
        if (this._pointAtData.id === position) {
            if (!this._pointAtData.interpolateReady) this._updateInterpolationMatrix();
            return this._pointAtData;
        } else this._pointAtData.id = position;
        const curvePoints = this.getPoints();
        // clamp position between 0.0 and 1.0
        if (position <= 0.0) return this._setPointAtData(0.0, 0.0, curvePoints[0], 0, interpolateTNB);
        else if (position >= 1.0) return this._setPointAtData(1.0, 1.0, curvePoints[curvePoints.length - 1], curvePoints.length - 1, interpolateTNB);
        let previousPoint = curvePoints[0];
        let currentPoint;
        let currentLength = 0.0;
        const targetLength = position * this.length();
        for(let i = 1; i < curvePoints.length; i++){
            currentPoint = curvePoints[i];
            const distance = (0, $ha1VO.Vector3).Distance(previousPoint, currentPoint);
            currentLength += distance;
            if (currentLength === targetLength) return this._setPointAtData(position, 1.0, currentPoint, i, interpolateTNB);
            else if (currentLength > targetLength) {
                const toLength = currentLength - targetLength;
                const diff = toLength / distance;
                const dir = previousPoint.subtract(currentPoint);
                const point = currentPoint.add(dir.scaleInPlace(diff));
                return this._setPointAtData(position, 1 - diff, point, i - 1, interpolateTNB);
            }
            previousPoint = currentPoint;
        }
        return this._pointAtData;
    }
    /**
     * Updates the point at data from the specified parameters
     * @param position where along the path the interpolated point is, from 0.0 to 1.0
     * @param subPosition
     * @param point the interpolated point
     * @param parentIndex the index of an existing curve point that is on, or else positionally the first behind, the interpolated point
     * @param interpolateTNB whether to compute the interpolated tangent, normal and binormal
     * @returns the (updated) point at data
     */ _setPointAtData(position, subPosition, point, parentIndex, interpolateTNB) {
        this._pointAtData.point = point;
        this._pointAtData.position = position;
        this._pointAtData.subPosition = subPosition;
        this._pointAtData.previousPointArrayIndex = parentIndex;
        this._pointAtData.interpolateReady = interpolateTNB;
        if (interpolateTNB) this._updateInterpolationMatrix();
        return this._pointAtData;
    }
    /**
     * Updates the point at interpolation matrix for the tangents, normals and binormals
     */ _updateInterpolationMatrix() {
        this._pointAtData.interpolationMatrix = (0, $ha1VO.Matrix).Identity();
        const parentIndex = this._pointAtData.previousPointArrayIndex;
        if (parentIndex !== this._tangents.length - 1) {
            const index = parentIndex + 1;
            const tangentFrom = this._tangents[parentIndex].clone();
            const normalFrom = this._normals[parentIndex].clone();
            const binormalFrom = this._binormals[parentIndex].clone();
            const tangentTo = this._tangents[index].clone();
            const normalTo = this._normals[index].clone();
            const binormalTo = this._binormals[index].clone();
            const quatFrom = (0, $ha1VO.Quaternion).RotationQuaternionFromAxis(normalFrom, binormalFrom, tangentFrom);
            const quatTo = (0, $ha1VO.Quaternion).RotationQuaternionFromAxis(normalTo, binormalTo, tangentTo);
            const quatAt = (0, $ha1VO.Quaternion).Slerp(quatFrom, quatTo, this._pointAtData.subPosition);
            quatAt.toRotationMatrix(this._pointAtData.interpolationMatrix);
        }
    }
}
class $b2daf017bbb96e17$export$82bb9f10f9631442 {
    /**
     * Returns a Curve3 object along a Quadratic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#quadratic-bezier-curve
     * @param v0 (Vector3) the origin point of the Quadratic Bezier
     * @param v1 (Vector3) the control point
     * @param v2 (Vector3) the end point of the Quadratic Bezier
     * @param nbPoints (integer) the wanted number of points in the curve
     * @returns the created Curve3
     */ static CreateQuadraticBezier(v0, v1, v2, nbPoints) {
        nbPoints = nbPoints > 2 ? nbPoints : 3;
        const bez = [];
        const equation = (t, val0, val1, val2)=>{
            const res = (1.0 - t) * (1.0 - t) * val0 + 2.0 * t * (1.0 - t) * val1 + t * t * val2;
            return res;
        };
        for(let i = 0; i <= nbPoints; i++)bez.push(new (0, $ha1VO.Vector3)(equation(i / nbPoints, v0.x, v1.x, v2.x), equation(i / nbPoints, v0.y, v1.y, v2.y), equation(i / nbPoints, v0.z, v1.z, v2.z)));
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(bez);
    }
    /**
     * Returns a Curve3 object along a Cubic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#cubic-bezier-curve
     * @param v0 (Vector3) the origin point of the Cubic Bezier
     * @param v1 (Vector3) the first control point
     * @param v2 (Vector3) the second control point
     * @param v3 (Vector3) the end point of the Cubic Bezier
     * @param nbPoints (integer) the wanted number of points in the curve
     * @returns the created Curve3
     */ static CreateCubicBezier(v0, v1, v2, v3, nbPoints) {
        nbPoints = nbPoints > 3 ? nbPoints : 4;
        const bez = [];
        const equation = (t, val0, val1, val2, val3)=>{
            const res = (1.0 - t) * (1.0 - t) * (1.0 - t) * val0 + 3.0 * t * (1.0 - t) * (1.0 - t) * val1 + 3.0 * t * t * (1.0 - t) * val2 + t * t * t * val3;
            return res;
        };
        for(let i = 0; i <= nbPoints; i++)bez.push(new (0, $ha1VO.Vector3)(equation(i / nbPoints, v0.x, v1.x, v2.x, v3.x), equation(i / nbPoints, v0.y, v1.y, v2.y, v3.y), equation(i / nbPoints, v0.z, v1.z, v2.z, v3.z)));
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(bez);
    }
    /**
     * Returns a Curve3 object along a Hermite Spline curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-spline
     * @param p1 (Vector3) the origin point of the Hermite Spline
     * @param t1 (Vector3) the tangent vector at the origin point
     * @param p2 (Vector3) the end point of the Hermite Spline
     * @param t2 (Vector3) the tangent vector at the end point
     * @param nSeg (integer) the number of curve segments or nSeg + 1 points in the array
     * @returns the created Curve3
     */ static CreateHermiteSpline(p1, t1, p2, t2, nSeg) {
        const hermite = [];
        const step = 1.0 / nSeg;
        for(let i = 0; i <= nSeg; i++)hermite.push((0, $ha1VO.Vector3).Hermite(p1, t1, p2, t2, i * step));
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(hermite);
    }
    /**
     * Returns a Curve3 object along a CatmullRom Spline curve :
     * @param points (array of Vector3) the points the spline must pass through. At least, four points required
     * @param nbPoints (integer) the wanted number of points between each curve control points
     * @param closed (boolean) optional with default false, when true forms a closed loop from the points
     * @returns the created Curve3
     */ static CreateCatmullRomSpline(points, nbPoints, closed) {
        const catmullRom = [];
        const step = 1.0 / nbPoints;
        let amount = 0.0;
        if (closed) {
            const pointsCount = points.length;
            for(let i = 0; i < pointsCount; i++){
                amount = 0;
                for(let c = 0; c < nbPoints; c++){
                    catmullRom.push((0, $ha1VO.Vector3).CatmullRom(points[i % pointsCount], points[(i + 1) % pointsCount], points[(i + 2) % pointsCount], points[(i + 3) % pointsCount], amount));
                    amount += step;
                }
            }
            catmullRom.push(catmullRom[0]);
        } else {
            const totalPoints = [];
            totalPoints.push(points[0].clone());
            Array.prototype.push.apply(totalPoints, points);
            totalPoints.push(points[points.length - 1].clone());
            let i = 0;
            for(; i < totalPoints.length - 3; i++){
                amount = 0;
                for(let c = 0; c < nbPoints; c++){
                    catmullRom.push((0, $ha1VO.Vector3).CatmullRom(totalPoints[i], totalPoints[i + 1], totalPoints[i + 2], totalPoints[i + 3], amount));
                    amount += step;
                }
            }
            i--;
            catmullRom.push((0, $ha1VO.Vector3).CatmullRom(totalPoints[i], totalPoints[i + 1], totalPoints[i + 2], totalPoints[i + 3], amount));
        }
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(catmullRom);
    }
    /**
     * Returns a Curve3 object along an arc through three vector3 points:
     * The three points should not be colinear. When they are the Curve3 is empty.
     * @param first (Vector3) the first point the arc must pass through.
     * @param second (Vector3) the second point the arc must pass through.
     * @param third (Vector3) the third point the arc must pass through.
     * @param steps (number) the larger the number of steps the more detailed the arc.
     * @param closed (boolean) optional with default false, when true forms the chord from the first and third point
     * @param fullCircle Circle (boolean) optional with default false, when true forms the complete circle through the three points
     * @returns the created Curve3
     */ static ArcThru3Points(first, second, third, steps = 32, closed = false, fullCircle = false) {
        const arc = [];
        const vec1 = second.subtract(first);
        const vec2 = third.subtract(second);
        const vec3 = first.subtract(third);
        const zAxis = (0, $ha1VO.Vector3).Cross(vec1, vec2);
        const len4 = zAxis.length();
        if (len4 < Math.pow(10, -8)) return new $b2daf017bbb96e17$export$82bb9f10f9631442(arc); // colinear points arc is empty
        const len1_sq = vec1.lengthSquared();
        const len2_sq = vec2.lengthSquared();
        const len3_sq = vec3.lengthSquared();
        const len4_sq = zAxis.lengthSquared();
        const len1 = vec1.length();
        const len2 = vec2.length();
        const len3 = vec3.length();
        const radius = 0.5 * len1 * len2 * len3 / len4;
        const dot1 = (0, $ha1VO.Vector3).Dot(vec1, vec3);
        const dot2 = (0, $ha1VO.Vector3).Dot(vec1, vec2);
        const dot3 = (0, $ha1VO.Vector3).Dot(vec2, vec3);
        const a = -0.5 * len2_sq * dot1 / len4_sq;
        const b = -0.5 * len3_sq * dot2 / len4_sq;
        const c = -0.5 * len1_sq * dot3 / len4_sq;
        const center = first.scale(a).add(second.scale(b)).add(third.scale(c));
        const radiusVec = first.subtract(center);
        const xAxis = radiusVec.normalize();
        const yAxis = (0, $ha1VO.Vector3).Cross(zAxis, xAxis).normalize();
        if (fullCircle) {
            const dStep = 2 * Math.PI / steps;
            for(let theta = 0; theta <= 2 * Math.PI; theta += dStep)arc.push(center.add(xAxis.scale(radius * Math.cos(theta)).add(yAxis.scale(radius * Math.sin(theta)))));
            arc.push(first);
        } else {
            const dStep = 1 / steps;
            let theta = 0;
            let point = (0, $ha1VO.Vector3).Zero();
            do {
                point = center.add(xAxis.scale(radius * Math.cos(theta)).add(yAxis.scale(radius * Math.sin(theta))));
                arc.push(point);
                theta += dStep;
            }while (!point.equalsWithEpsilon(third, radius * dStep * 1.1));
            arc.push(third);
            if (closed) arc.push(first);
        }
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(arc);
    }
    /**
     * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space.
     * A Curve3 is designed from a series of successive Vector3.
     * Tuto : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#curve3-object
     * @param points points which make up the curve
     */ constructor(points){
        this._length = 0.0;
        this._points = points;
        this._length = this._computeLength(points);
    }
    /**
     * @returns the Curve3 stored array of successive Vector3
     */ getPoints() {
        return this._points;
    }
    /**
     * @returns the computed length (float) of the curve.
     */ length() {
        return this._length;
    }
    /**
     * Returns a new instance of Curve3 object : var curve = curveA.continue(curveB);
     * This new Curve3 is built by translating and sticking the curveB at the end of the curveA.
     * curveA and curveB keep unchanged.
     * @param curve the curve to continue from this curve
     * @returns the newly constructed curve
     */ continue(curve) {
        const lastPoint = this._points[this._points.length - 1];
        const continuedPoints = this._points.slice();
        const curvePoints = curve.getPoints();
        for(let i = 1; i < curvePoints.length; i++)continuedPoints.push(curvePoints[i].subtract(curvePoints[0]).add(lastPoint));
        const continuedCurve = new $b2daf017bbb96e17$export$82bb9f10f9631442(continuedPoints);
        return continuedCurve;
    }
    _computeLength(path) {
        let l = 0;
        for(let i = 1; i < path.length; i++)l += path[i].subtract(path[i - 1]).length();
        return l;
    }
}

});

parcelRegister("g13hK", function(module, exports) {

var $ha1VO = parcelRequire("ha1VO");
class $ba8f49b7445ee893$export$7060026f20f731a4 {
    /**
     * Creates a PositionNormalVertex
     * @param position the position of the vertex (defaut: 0,0,0)
     * @param normal the normal of the vertex (defaut: 0,1,0)
     */ constructor(/** [Vector3.Zero()] the position of the vertex (defaut: 0,0,0) */ position = (0, $ha1VO.Vector3).Zero(), /** [Vector3.Up()] the normal of the vertex (defaut: 0,1,0) */ normal = (0, $ha1VO.Vector3).Up()){
        this.position = position;
        this.normal = normal;
    }
    /**
     * Clones the PositionNormalVertex
     * @returns the cloned PositionNormalVertex
     */ clone() {
        return new $ba8f49b7445ee893$export$7060026f20f731a4(this.position.clone(), this.normal.clone());
    }
}
class $ba8f49b7445ee893$export$e40add16394b9bff {
    /**
     * Creates a PositionNormalTextureVertex
     * @param position the position of the vertex (defaut: 0,0,0)
     * @param normal the normal of the vertex (defaut: 0,1,0)
     * @param uv the uv of the vertex (default: 0,0)
     */ constructor(/** [Vector3.Zero()] the position of the vertex (defaut: 0,0,0) */ position = (0, $ha1VO.Vector3).Zero(), /** [Vector3.Up()] the normal of the vertex (defaut: 0,1,0) */ normal = (0, $ha1VO.Vector3).Up(), /** [Vector3.Zero()] the uv of the vertex (default: 0,0) */ uv = (0, $ha1VO.Vector2).Zero()){
        this.position = position;
        this.normal = normal;
        this.uv = uv;
    }
    /**
     * Clones the PositionNormalTextureVertex
     * @returns the cloned PositionNormalTextureVertex
     */ clone() {
        return new $ba8f49b7445ee893$export$e40add16394b9bff(this.position.clone(), this.normal.clone(), this.uv.clone());
    }
}

});

parcelRegister("191mA", function(module, exports) {

$parcel$export(module.exports, "Viewport", () => $0d57b0684db3128e$export$d5c6c08dc2d3ca7);
/**
 * Class used to represent a viewport on screen
 */ class $0d57b0684db3128e$export$d5c6c08dc2d3ca7 {
    /**
     * Creates a Viewport object located at (x, y) and sized (width, height)
     * @param x defines viewport left coordinate
     * @param y defines viewport top coordinate
     * @param width defines the viewport width
     * @param height defines the viewport height
     */ constructor(/** viewport left coordinate */ x, /** viewport top coordinate */ y, /**viewport width */ width, /** viewport height */ height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
     * Creates a new viewport using absolute sizing (from 0-> width, 0-> height instead of 0->1)
     * @param renderWidth defines the rendering width
     * @param renderHeight defines the rendering height
     * @returns a new Viewport
     */ toGlobal(renderWidth, renderHeight) {
        return new $0d57b0684db3128e$export$d5c6c08dc2d3ca7(this.x * renderWidth, this.y * renderHeight, this.width * renderWidth, this.height * renderHeight);
    }
    /**
     * Stores absolute viewport value into a target viewport (from 0-> width, 0-> height instead of 0->1)
     * @param renderWidth defines the rendering width
     * @param renderHeight defines the rendering height
     * @param ref defines the target viewport
     * @returns the current viewport
     */ toGlobalToRef(renderWidth, renderHeight, ref) {
        ref.x = this.x * renderWidth;
        ref.y = this.y * renderHeight;
        ref.width = this.width * renderWidth;
        ref.height = this.height * renderHeight;
        return this;
    }
    /**
     * Returns a new Viewport copied from the current one
     * @returns a new Viewport
     */ clone() {
        return new $0d57b0684db3128e$export$d5c6c08dc2d3ca7(this.x, this.y, this.width, this.height);
    }
}

});



parcelRegister("hfaur", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("6Lxmp"),
    $Gr8vk("2M22I")
]).then(()=>parcelRequire('ckies'));

});


parcelRegister("jo5qL", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $koExS = parcelRequire("koExS");
(0, $2h5JR.ThinEngine).prototype.createUniformBuffer = function(elements, _label) {
    const ubo = this._gl.createBuffer();
    if (!ubo) throw new Error("Unable to create uniform buffer");
    const result = new (0, $koExS.WebGLDataBuffer)(ubo);
    this.bindUniformBuffer(result);
    if (elements instanceof Float32Array) this._gl.bufferData(this._gl.UNIFORM_BUFFER, elements, this._gl.STATIC_DRAW);
    else this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(elements), this._gl.STATIC_DRAW);
    this.bindUniformBuffer(null);
    result.references = 1;
    return result;
};
(0, $2h5JR.ThinEngine).prototype.createDynamicUniformBuffer = function(elements, _label) {
    const ubo = this._gl.createBuffer();
    if (!ubo) throw new Error("Unable to create dynamic uniform buffer");
    const result = new (0, $koExS.WebGLDataBuffer)(ubo);
    this.bindUniformBuffer(result);
    if (elements instanceof Float32Array) this._gl.bufferData(this._gl.UNIFORM_BUFFER, elements, this._gl.DYNAMIC_DRAW);
    else this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(elements), this._gl.DYNAMIC_DRAW);
    this.bindUniformBuffer(null);
    result.references = 1;
    return result;
};
(0, $2h5JR.ThinEngine).prototype.updateUniformBuffer = function(uniformBuffer, elements, offset, count) {
    this.bindUniformBuffer(uniformBuffer);
    if (offset === undefined) offset = 0;
    if (count === undefined) {
        if (elements instanceof Float32Array) this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, offset, elements);
        else this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, offset, new Float32Array(elements));
    } else if (elements instanceof Float32Array) this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, elements.subarray(offset, offset + count));
    else this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, new Float32Array(elements).subarray(offset, offset + count));
    this.bindUniformBuffer(null);
};
(0, $2h5JR.ThinEngine).prototype.bindUniformBuffer = function(buffer) {
    this._gl.bindBuffer(this._gl.UNIFORM_BUFFER, buffer ? buffer.underlyingResource : null);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.bindUniformBufferBase = function(buffer, location, name) {
    this._gl.bindBufferBase(this._gl.UNIFORM_BUFFER, location, buffer ? buffer.underlyingResource : null);
};
(0, $2h5JR.ThinEngine).prototype.bindUniformBlock = function(pipelineContext, blockName, index) {
    const program = pipelineContext.program;
    const uniformLocation = this._gl.getUniformBlockIndex(program, blockName);
    if (uniformLocation !== 0xffffffff) this._gl.uniformBlockBinding(program, uniformLocation, index);
};

});

parcelRegister("j1xyR", function(module, exports) {

var $jFz47 = parcelRequire("jFz47");

var $dUFoQ = parcelRequire("dUFoQ");
(0, $dUFoQ.AbstractEngine).prototype.displayLoadingUI = function() {
    if (!(0, $jFz47.IsWindowObjectExist)()) return;
    const loadingScreen = this.loadingScreen;
    if (loadingScreen) loadingScreen.displayLoadingUI();
};
(0, $dUFoQ.AbstractEngine).prototype.hideLoadingUI = function() {
    if (!(0, $jFz47.IsWindowObjectExist)()) return;
    const loadingScreen = this._loadingScreen;
    if (loadingScreen) loadingScreen.hideLoadingUI();
};
Object.defineProperty((0, $dUFoQ.AbstractEngine).prototype, "loadingScreen", {
    get: function() {
        if (!this._loadingScreen && this._renderingCanvas) this._loadingScreen = (0, $dUFoQ.AbstractEngine).DefaultLoadingScreenFactory(this._renderingCanvas);
        return this._loadingScreen;
    },
    set: function(value) {
        this._loadingScreen = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $dUFoQ.AbstractEngine).prototype, "loadingUIText", {
    set: function(value) {
        this.loadingScreen.loadingUIText = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $dUFoQ.AbstractEngine).prototype, "loadingUIBackgroundColor", {
    set: function(value) {
        this.loadingScreen.loadingUIBackgroundColor = value;
    },
    enumerable: true,
    configurable: true
});

});

parcelRegister("46dUh", function(module, exports) {

var $dUFoQ = parcelRequire("dUFoQ");
(0, $dUFoQ.AbstractEngine).prototype.getInputElement = function() {
    return this._renderingCanvas;
};
(0, $dUFoQ.AbstractEngine).prototype.getRenderingCanvasClientRect = function() {
    if (!this._renderingCanvas) return null;
    return this._renderingCanvas.getBoundingClientRect();
};
(0, $dUFoQ.AbstractEngine).prototype.getInputElementClientRect = function() {
    if (!this._renderingCanvas) return null;
    return this.getInputElement().getBoundingClientRect();
};
(0, $dUFoQ.AbstractEngine).prototype.getAspectRatio = function(viewportOwner, useScreen = false) {
    const viewport = viewportOwner.viewport;
    return this.getRenderWidth(useScreen) * viewport.width / (this.getRenderHeight(useScreen) * viewport.height);
};
(0, $dUFoQ.AbstractEngine).prototype.getScreenAspectRatio = function() {
    return this.getRenderWidth(true) / this.getRenderHeight(true);
};
(0, $dUFoQ.AbstractEngine).prototype._verifyPointerLock = function() {
    this._onPointerLockChange?.();
};

});

parcelRegister("3Kog0", function(module, exports) {

var $dUFoQ = parcelRequire("dUFoQ");
parcelRequire("i2tdr");
(0, $dUFoQ.AbstractEngine).prototype.getInputElement = function() {
    return this._renderingCanvas;
};
(0, $dUFoQ.AbstractEngine).prototype.getDepthFunction = function() {
    return this._depthCullingState.depthFunc;
};
(0, $dUFoQ.AbstractEngine).prototype.setDepthFunction = function(depthFunc) {
    this._depthCullingState.depthFunc = depthFunc;
};
(0, $dUFoQ.AbstractEngine).prototype.setDepthFunctionToGreater = function() {
    this.setDepthFunction(516);
};
(0, $dUFoQ.AbstractEngine).prototype.setDepthFunctionToGreaterOrEqual = function() {
    this.setDepthFunction(518);
};
(0, $dUFoQ.AbstractEngine).prototype.setDepthFunctionToLess = function() {
    this.setDepthFunction(513);
};
(0, $dUFoQ.AbstractEngine).prototype.setDepthFunctionToLessOrEqual = function() {
    this.setDepthFunction(515);
};
(0, $dUFoQ.AbstractEngine).prototype.getDepthWrite = function() {
    return this._depthCullingState.depthMask;
};
(0, $dUFoQ.AbstractEngine).prototype.setDepthWrite = function(enable) {
    this._depthCullingState.depthMask = enable;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilBuffer = function() {
    return this._stencilState.stencilTest;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilBuffer = function(enable) {
    this._stencilState.stencilTest = enable;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilMask = function() {
    return this._stencilState.stencilMask;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilMask = function(mask) {
    this._stencilState.stencilMask = mask;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilFunction = function() {
    return this._stencilState.stencilFunc;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilFunctionReference = function() {
    return this._stencilState.stencilFuncRef;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilFunctionMask = function() {
    return this._stencilState.stencilFuncMask;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilFunction = function(stencilFunc) {
    this._stencilState.stencilFunc = stencilFunc;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilFunctionReference = function(reference) {
    this._stencilState.stencilFuncRef = reference;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilFunctionMask = function(mask) {
    this._stencilState.stencilFuncMask = mask;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilOperationFail = function() {
    return this._stencilState.stencilOpStencilFail;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilOperationDepthFail = function() {
    return this._stencilState.stencilOpDepthFail;
};
(0, $dUFoQ.AbstractEngine).prototype.getStencilOperationPass = function() {
    return this._stencilState.stencilOpStencilDepthPass;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilOperationFail = function(operation) {
    this._stencilState.stencilOpStencilFail = operation;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilOperationDepthFail = function(operation) {
    this._stencilState.stencilOpDepthFail = operation;
};
(0, $dUFoQ.AbstractEngine).prototype.setStencilOperationPass = function(operation) {
    this._stencilState.stencilOpStencilDepthPass = operation;
};
(0, $dUFoQ.AbstractEngine).prototype.cacheStencilState = function() {
    this._cachedStencilBuffer = this.getStencilBuffer();
    this._cachedStencilFunction = this.getStencilFunction();
    this._cachedStencilMask = this.getStencilMask();
    this._cachedStencilOperationPass = this.getStencilOperationPass();
    this._cachedStencilOperationFail = this.getStencilOperationFail();
    this._cachedStencilOperationDepthFail = this.getStencilOperationDepthFail();
    this._cachedStencilReference = this.getStencilFunctionReference();
};
(0, $dUFoQ.AbstractEngine).prototype.restoreStencilState = function() {
    this.setStencilFunction(this._cachedStencilFunction);
    this.setStencilMask(this._cachedStencilMask);
    this.setStencilBuffer(this._cachedStencilBuffer);
    this.setStencilOperationPass(this._cachedStencilOperationPass);
    this.setStencilOperationFail(this._cachedStencilOperationFail);
    this.setStencilOperationDepthFail(this._cachedStencilOperationDepthFail);
    this.setStencilFunctionReference(this._cachedStencilReference);
};
(0, $dUFoQ.AbstractEngine).prototype.setAlphaConstants = function(r, g, b, a) {
    this._alphaState.setAlphaBlendConstants(r, g, b, a);
};
(0, $dUFoQ.AbstractEngine).prototype.getAlphaMode = function() {
    return this._alphaMode;
};
(0, $dUFoQ.AbstractEngine).prototype.getAlphaEquation = function() {
    return this._alphaEquation;
};

});
parcelRegister("i2tdr", function(module, exports) {

var $dUFoQ = parcelRequire("dUFoQ");
(0, $dUFoQ.AbstractEngine).prototype.setAlphaEquation = function(equation) {
    if (this._alphaEquation === equation) return;
    switch(equation){
        case 0:
            this._alphaState.setAlphaEquationParameters(32774, 32774);
            break;
        case 1:
            this._alphaState.setAlphaEquationParameters(32778, 32778);
            break;
        case 2:
            this._alphaState.setAlphaEquationParameters(32779, 32779);
            break;
        case 3:
            this._alphaState.setAlphaEquationParameters(32776, 32776);
            break;
        case 4:
            this._alphaState.setAlphaEquationParameters(32775, 32775);
            break;
        case 5:
            this._alphaState.setAlphaEquationParameters(32775, 32774);
            break;
    }
    this._alphaEquation = equation;
};

});


parcelRegister("4e6Mt", function(module, exports) {

var $dUFoQ = parcelRequire("dUFoQ");
(0, $dUFoQ.AbstractEngine).prototype.getRenderPassNames = function() {
    return this._renderPassNames;
};
(0, $dUFoQ.AbstractEngine).prototype.getCurrentRenderPassName = function() {
    return this._renderPassNames[this.currentRenderPassId];
};
(0, $dUFoQ.AbstractEngine).prototype.createRenderPassId = function(name) {
    // Note: render pass id == 0 is always for the main render pass
    const id = ++(0, $dUFoQ.AbstractEngine)._RenderPassIdCounter;
    this._renderPassNames[id] = name ?? "NONAME";
    return id;
};
(0, $dUFoQ.AbstractEngine).prototype.releaseRenderPassId = function(id) {
    this._renderPassNames[id] = undefined;
    for(let s = 0; s < this.scenes.length; ++s){
        const scene = this.scenes[s];
        for(let m = 0; m < scene.meshes.length; ++m){
            const mesh = scene.meshes[m];
            if (mesh.subMeshes) for(let b = 0; b < mesh.subMeshes.length; ++b){
                const subMesh = mesh.subMeshes[b];
                subMesh._removeDrawWrapper(id);
            }
        }
    }
};

});

parcelRegister("e7bN3", function(module, exports) {

$parcel$export(module.exports, "_CommonInit", () => $a46add6787f7ab6d$export$70610048caf0e95e);
$parcel$export(module.exports, "RequestPointerlock", () => $a46add6787f7ab6d$export$adaf4b64fb8d9fb2);
$parcel$export(module.exports, "_CommonDispose", () => $a46add6787f7ab6d$export$3e92a0c21d0baf7d);
$parcel$export(module.exports, "GetFontOffset", () => $a46add6787f7ab6d$export$19d9ec475b4df180);
$parcel$export(module.exports, "CreateImageBitmapFromSource", () => $a46add6787f7ab6d$export$f5b5f21e725c208e);
$parcel$export(module.exports, "ResizeImageBitmap", () => $a46add6787f7ab6d$export$cddf563adeed0ec1);
$parcel$export(module.exports, "RequestFullscreen", () => $a46add6787f7ab6d$export$ab8873520d911ae1);
$parcel$export(module.exports, "ExitFullscreen", () => $a46add6787f7ab6d$export$c426566a69e4a168);
$parcel$export(module.exports, "ExitPointerlock", () => $a46add6787f7ab6d$export$90bcb88cb3bc0715);

var $jFz47 = parcelRequire("jFz47");

var $dUFoQ = parcelRequire("dUFoQ");

var $ejQPp = parcelRequire("ejQPp");
/** @internal */ function $a46add6787f7ab6d$var$_DisableTouchAction(canvas) {
    if (!canvas || !canvas.setAttribute) return;
    canvas.setAttribute("touch-action", "none");
    canvas.style.touchAction = "none";
    canvas.style.webkitTapHighlightColor = "transparent";
}
function $a46add6787f7ab6d$export$70610048caf0e95e(commonEngine, canvas, creationOptions) {
    commonEngine._onCanvasFocus = ()=>{
        commonEngine.onCanvasFocusObservable.notifyObservers(commonEngine);
    };
    commonEngine._onCanvasBlur = ()=>{
        commonEngine.onCanvasBlurObservable.notifyObservers(commonEngine);
    };
    commonEngine._onCanvasContextMenu = (evt)=>{
        if (commonEngine.disableContextMenu) evt.preventDefault();
    };
    canvas.addEventListener("focus", commonEngine._onCanvasFocus);
    canvas.addEventListener("blur", commonEngine._onCanvasBlur);
    canvas.addEventListener("contextmenu", commonEngine._onCanvasContextMenu);
    commonEngine._onBlur = ()=>{
        if (commonEngine.disablePerformanceMonitorInBackground) commonEngine.performanceMonitor.disable();
        commonEngine._windowIsBackground = true;
    };
    commonEngine._onFocus = ()=>{
        if (commonEngine.disablePerformanceMonitorInBackground) commonEngine.performanceMonitor.enable();
        commonEngine._windowIsBackground = false;
    };
    commonEngine._onCanvasPointerOut = (ev)=>{
        // Check that the element at the point of the pointer out isn't the canvas and if it isn't, notify observers
        // Note: This is a workaround for a bug with Safari
        if (document.elementFromPoint(ev.clientX, ev.clientY) !== canvas) commonEngine.onCanvasPointerOutObservable.notifyObservers(ev);
    };
    const hostWindow = commonEngine.getHostWindow(); // it calls IsWindowObjectExist()
    if (hostWindow && typeof hostWindow.addEventListener === "function") {
        hostWindow.addEventListener("blur", commonEngine._onBlur);
        hostWindow.addEventListener("focus", commonEngine._onFocus);
    }
    canvas.addEventListener("pointerout", commonEngine._onCanvasPointerOut);
    if (!creationOptions.doNotHandleTouchAction) $a46add6787f7ab6d$var$_DisableTouchAction(canvas);
    // Create Audio Engine if needed.
    if (!(0, $dUFoQ.AbstractEngine).audioEngine && creationOptions.audioEngine && (0, $dUFoQ.AbstractEngine).AudioEngineFactory) (0, $dUFoQ.AbstractEngine).audioEngine = (0, $dUFoQ.AbstractEngine).AudioEngineFactory(commonEngine.getRenderingCanvas(), commonEngine.getAudioContext(), commonEngine.getAudioDestination());
    if ((0, $jFz47.IsDocumentAvailable)()) {
        // Fullscreen
        commonEngine._onFullscreenChange = ()=>{
            commonEngine.isFullscreen = !!document.fullscreenElement;
            // Pointer lock
            if (commonEngine.isFullscreen && commonEngine._pointerLockRequested && canvas) $a46add6787f7ab6d$export$adaf4b64fb8d9fb2(canvas);
        };
        document.addEventListener("fullscreenchange", commonEngine._onFullscreenChange, false);
        document.addEventListener("webkitfullscreenchange", commonEngine._onFullscreenChange, false);
        // Pointer lock
        commonEngine._onPointerLockChange = ()=>{
            commonEngine.isPointerLock = document.pointerLockElement === canvas;
        };
        document.addEventListener("pointerlockchange", commonEngine._onPointerLockChange, false);
        document.addEventListener("webkitpointerlockchange", commonEngine._onPointerLockChange, false);
    }
    commonEngine.enableOfflineSupport = (0, $dUFoQ.AbstractEngine).OfflineProviderFactory !== undefined;
    commonEngine._deterministicLockstep = !!creationOptions.deterministicLockstep;
    commonEngine._lockstepMaxSteps = creationOptions.lockstepMaxSteps || 0;
    commonEngine._timeStep = creationOptions.timeStep || 1 / 60;
}
function $a46add6787f7ab6d$export$3e92a0c21d0baf7d(commonEngine, canvas) {
    // Release audio engine
    if ((0, $ejQPp.EngineStore).Instances.length === 1 && (0, $dUFoQ.AbstractEngine).audioEngine) {
        (0, $dUFoQ.AbstractEngine).audioEngine.dispose();
        (0, $dUFoQ.AbstractEngine).audioEngine = null;
    }
    // Events
    const hostWindow = commonEngine.getHostWindow(); // it calls IsWindowObjectExist()
    if (hostWindow && typeof hostWindow.removeEventListener === "function") {
        hostWindow.removeEventListener("blur", commonEngine._onBlur);
        hostWindow.removeEventListener("focus", commonEngine._onFocus);
    }
    if (canvas) {
        canvas.removeEventListener("focus", commonEngine._onCanvasFocus);
        canvas.removeEventListener("blur", commonEngine._onCanvasBlur);
        canvas.removeEventListener("pointerout", commonEngine._onCanvasPointerOut);
        canvas.removeEventListener("contextmenu", commonEngine._onCanvasContextMenu);
    }
    if ((0, $jFz47.IsDocumentAvailable)()) {
        document.removeEventListener("fullscreenchange", commonEngine._onFullscreenChange);
        document.removeEventListener("mozfullscreenchange", commonEngine._onFullscreenChange);
        document.removeEventListener("webkitfullscreenchange", commonEngine._onFullscreenChange);
        document.removeEventListener("msfullscreenchange", commonEngine._onFullscreenChange);
        document.removeEventListener("pointerlockchange", commonEngine._onPointerLockChange);
        document.removeEventListener("mspointerlockchange", commonEngine._onPointerLockChange);
        document.removeEventListener("mozpointerlockchange", commonEngine._onPointerLockChange);
        document.removeEventListener("webkitpointerlockchange", commonEngine._onPointerLockChange);
    }
}
function $a46add6787f7ab6d$export$19d9ec475b4df180(font) {
    const text = document.createElement("span");
    text.textContent = "Hg";
    text.style.font = font;
    const block = document.createElement("div");
    block.style.display = "inline-block";
    block.style.width = "1px";
    block.style.height = "0px";
    block.style.verticalAlign = "bottom";
    const div = document.createElement("div");
    div.style.whiteSpace = "nowrap";
    div.appendChild(text);
    div.appendChild(block);
    document.body.appendChild(div);
    let fontAscent = 0;
    let fontHeight = 0;
    try {
        fontHeight = block.getBoundingClientRect().top - text.getBoundingClientRect().top;
        block.style.verticalAlign = "baseline";
        fontAscent = block.getBoundingClientRect().top - text.getBoundingClientRect().top;
    } finally{
        document.body.removeChild(div);
    }
    return {
        ascent: fontAscent,
        height: fontHeight,
        descent: fontHeight - fontAscent
    };
}
function $a46add6787f7ab6d$export$f5b5f21e725c208e(engine, imageSource, options) {
    const promise = new Promise((resolve, reject)=>{
        const image = new Image();
        image.onload = ()=>{
            image.decode().then(()=>{
                engine.createImageBitmap(image, options).then((imageBitmap)=>{
                    resolve(imageBitmap);
                });
            });
        };
        image.onerror = ()=>{
            reject(`Error loading image ${image.src}`);
        };
        image.src = imageSource;
    });
    return promise;
}
function $a46add6787f7ab6d$export$cddf563adeed0ec1(engine, image, bufferWidth, bufferHeight) {
    const canvas = engine.createCanvas(bufferWidth, bufferHeight);
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Unable to get 2d context for resizeImageBitmap");
    context.drawImage(image, 0, 0);
    // Create VertexData from map data
    // Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949
    const buffer = context.getImageData(0, 0, bufferWidth, bufferHeight).data;
    return buffer;
}
function $a46add6787f7ab6d$export$ab8873520d911ae1(element) {
    const requestFunction = element.requestFullscreen || element.webkitRequestFullscreen;
    if (!requestFunction) return;
    requestFunction.call(element);
}
function $a46add6787f7ab6d$export$c426566a69e4a168() {
    const anyDoc = document;
    if (document.exitFullscreen) document.exitFullscreen();
    else if (anyDoc.webkitCancelFullScreen) anyDoc.webkitCancelFullScreen();
}
function $a46add6787f7ab6d$export$adaf4b64fb8d9fb2(element) {
    if (element.requestPointerLock) {
        // In some browsers, requestPointerLock returns a promise.
        // Handle possible rejections to avoid an unhandled top-level exception.
        const promise = element.requestPointerLock();
        if (promise instanceof Promise) promise.then(()=>{
            element.focus();
        }).catch(()=>{});
        else element.focus();
    }
}
function $a46add6787f7ab6d$export$90bcb88cb3bc0715() {
    if (document.exitPointerLock) document.exitPointerLock();
}

});

parcelRegister("iIwbj", function(module, exports) {

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");

var $dUFoQ = parcelRequire("dUFoQ");

var $jFz47 = parcelRequire("jFz47");
// Sets the default audio engine to Babylon.js
(0, $dUFoQ.AbstractEngine).AudioEngineFactory = (hostElement, audioContext, audioDestination)=>{
    return new $da054ca30022f9b7$export$2e9600652eafa17(hostElement, audioContext, audioDestination);
};
class $da054ca30022f9b7$export$2e9600652eafa17 {
    /**
     * Gets the current AudioContext if available.
     */ get audioContext() {
        if (!this._audioContextInitialized) this._initializeAudioContext();
        return this._audioContext;
    }
    /**
     * Instantiates a new audio engine.
     *
     * There should be only one per page as some browsers restrict the number
     * of audio contexts you can create.
     * @param hostElement defines the host element where to display the mute icon if necessary
     * @param audioContext defines the audio context to be used by the audio engine
     * @param audioDestination defines the audio destination node to be used by audio engine
     */ constructor(hostElement = null, audioContext = null, audioDestination = null){
        this._audioContext = null;
        this._audioContextInitialized = false;
        this._muteButton = null;
        this._audioDestination = null;
        /**
         * Gets whether the current host supports Web Audio and thus could create AudioContexts.
         */ this.canUseWebAudio = false;
        /**
         * Defines if Babylon should emit a warning if WebAudio is not supported.
         * @ignoreNaming
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.WarnedWebAudioUnsupported = false;
        /**
         * Gets whether or not mp3 are supported by your browser.
         */ this.isMP3supported = false;
        /**
         * Gets whether or not ogg are supported by your browser.
         */ this.isOGGsupported = false;
        /**
         * Gets whether audio has been unlocked on the device.
         * Some Browsers have strong restrictions about Audio and won't autoplay unless
         * a user interaction has happened.
         */ this.unlocked = false;
        /**
         * Defines if the audio engine relies on a custom unlocked button.
         * In this case, the embedded button will not be displayed.
         */ this.useCustomUnlockedButton = false;
        /**
         * Event raised when audio has been unlocked on the browser.
         */ this.onAudioUnlockedObservable = new (0, $diGQf.Observable)();
        /**
         * Event raised when audio has been locked on the browser.
         */ this.onAudioLockedObservable = new (0, $diGQf.Observable)();
        this._tryToRun = false;
        this._onResize = ()=>{
            this._moveButtonToTopLeft();
        };
        if (!(0, $jFz47.IsWindowObjectExist)()) return;
        if (typeof window.AudioContext !== "undefined") this.canUseWebAudio = true;
        const audioElem = document.createElement("audio");
        this._hostElement = hostElement;
        this._audioContext = audioContext;
        this._audioDestination = audioDestination;
        try {
            if (audioElem && !!audioElem.canPlayType && (audioElem.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/, "") || audioElem.canPlayType("audio/mp3").replace(/^no$/, ""))) this.isMP3supported = true;
        } catch (e) {
        // protect error during capability check.
        }
        try {
            if (audioElem && !!audioElem.canPlayType && audioElem.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "")) this.isOGGsupported = true;
        } catch (e) {
        // protect error during capability check.
        }
    }
    /**
     * Flags the audio engine in Locked state.
     * This happens due to new browser policies preventing audio to autoplay.
     */ lock() {
        this._triggerSuspendedState();
    }
    /**
     * Unlocks the audio engine once a user action has been done on the dom.
     * This is helpful to resume play once browser policies have been satisfied.
     */ unlock() {
        if (this._audioContext?.state === "running") {
            this._hideMuteButton();
            if (!this.unlocked) {
                // Notify users that the audio stack is unlocked/unmuted
                this.unlocked = true;
                this.onAudioUnlockedObservable.notifyObservers(this);
            }
            return;
        }
        // On iOS, if the audio context resume request was sent from an event other than a `click` event, then
        // the resume promise will never resolve and the only way to get the audio context unstuck is to
        // suspend it and make another resume request.
        if (this._tryToRun) this._audioContext?.suspend().then(()=>{
            this._tryToRun = false;
            this._triggerRunningState();
        });
        else this._triggerRunningState();
    }
    /** @internal */ _resumeAudioContextOnStateChange() {
        this._audioContext?.addEventListener("statechange", ()=>{
            if (this.unlocked && this._audioContext?.state !== "running") this._resumeAudioContext();
        }, {
            once: true,
            passive: true,
            signal: AbortSignal.timeout(3000)
        });
    }
    _resumeAudioContext() {
        if (this._audioContext?.resume) return this._audioContext.resume();
        return Promise.resolve();
    }
    _initializeAudioContext() {
        try {
            if (this.canUseWebAudio) {
                if (!this._audioContext) this._audioContext = new AudioContext();
                // create a global volume gain node
                this.masterGain = this._audioContext.createGain();
                this.masterGain.gain.value = 1;
                if (!this._audioDestination) this._audioDestination = this._audioContext.destination;
                this.masterGain.connect(this._audioDestination);
                this._audioContextInitialized = true;
                if (this._audioContext.state === "running") // Do not wait for the promise to unlock.
                this._triggerRunningState();
            }
        } catch (e) {
            this.canUseWebAudio = false;
            (0, $kVtWi.Logger).Error("Web Audio: " + e.message);
        }
    }
    _triggerRunningState() {
        if (this._tryToRun) return;
        this._tryToRun = true;
        this._resumeAudioContext().then(()=>{
            this._tryToRun = false;
            if (this._muteButton) this._hideMuteButton();
            // Notify users that the audio stack is unlocked/unmuted
            this.unlocked = true;
            this.onAudioUnlockedObservable.notifyObservers(this);
        }).catch(()=>{
            this._tryToRun = false;
            this.unlocked = false;
        });
    }
    _triggerSuspendedState() {
        this.unlocked = false;
        this.onAudioLockedObservable.notifyObservers(this);
        this._displayMuteButton();
    }
    _displayMuteButton() {
        if (this.useCustomUnlockedButton || this._muteButton) return;
        this._muteButton = document.createElement("BUTTON");
        this._muteButton.className = "babylonUnmuteIcon";
        this._muteButton.id = "babylonUnmuteIconBtn";
        this._muteButton.title = "Unmute";
        const imageUrl = !window.SVGSVGElement ? "https://cdn.babylonjs.com/Assets/audio.png" : "data:image/svg+xml;charset=UTF-8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2239%22%20height%3D%2232%22%20viewBox%3D%220%200%2039%2032%22%3E%3Cpath%20fill%3D%22white%22%20d%3D%22M9.625%2018.938l-0.031%200.016h-4.953q-0.016%200-0.031-0.016v-12.453q0-0.016%200.031-0.016h4.953q0.031%200%200.031%200.016v12.453zM12.125%207.688l8.719-8.703v27.453l-8.719-8.719-0.016-0.047v-9.938zM23.359%207.875l1.406-1.406%204.219%204.203%204.203-4.203%201.422%201.406-4.219%204.219%204.219%204.203-1.484%201.359-4.141-4.156-4.219%204.219-1.406-1.422%204.219-4.203z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";
        const css = ".babylonUnmuteIcon { position: absolute; left: 20px; top: 20px; height: 40px; width: 60px; background-color: rgba(51,51,51,0.7); background-image: url(" + imageUrl + ");  background-size: 80%; background-repeat:no-repeat; background-position: center; background-position-y: 4px; border: none; outline: none; transition: transform 0.125s ease-out; cursor: pointer; z-index: 9999; } .babylonUnmuteIcon:hover { transform: scale(1.05) } .babylonUnmuteIcon:active { background-color: rgba(51,51,51,1) }";
        const style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.getElementsByTagName("head")[0].appendChild(style);
        document.body.appendChild(this._muteButton);
        this._moveButtonToTopLeft();
        this._muteButton.addEventListener("touchend", ()=>{
            this._triggerRunningState();
        }, true);
        this._muteButton.addEventListener("click", ()=>{
            this.unlock();
        }, true);
        window.addEventListener("resize", this._onResize);
    }
    _moveButtonToTopLeft() {
        if (this._hostElement && this._muteButton) {
            this._muteButton.style.top = this._hostElement.offsetTop + 20 + "px";
            this._muteButton.style.left = this._hostElement.offsetLeft + 20 + "px";
        }
    }
    _hideMuteButton() {
        if (this._muteButton) {
            document.body.removeChild(this._muteButton);
            this._muteButton = null;
        }
    }
    /**
     * Destroy and release the resources associated with the audio context.
     */ dispose() {
        if (this.canUseWebAudio && this._audioContextInitialized) {
            if (this._connectedAnalyser && this._audioContext) {
                this._connectedAnalyser.stopDebugCanvas();
                this._connectedAnalyser.dispose();
                this.masterGain.disconnect();
                this.masterGain.connect(this._audioContext.destination);
                this._connectedAnalyser = null;
            }
            this.masterGain.gain.value = 1;
        }
        this.WarnedWebAudioUnsupported = false;
        this._hideMuteButton();
        window.removeEventListener("resize", this._onResize);
        this.onAudioUnlockedObservable.clear();
        this.onAudioLockedObservable.clear();
    }
    /**
     * Gets the global volume sets on the master gain.
     * @returns the global volume if set or -1 otherwise
     */ getGlobalVolume() {
        if (this.canUseWebAudio && this._audioContextInitialized) return this.masterGain.gain.value;
        else return -1;
    }
    /**
     * Sets the global volume of your experience (sets on the master gain).
     * @param newVolume Defines the new global volume of the application
     */ setGlobalVolume(newVolume) {
        if (this.canUseWebAudio && this._audioContextInitialized) this.masterGain.gain.value = newVolume;
    }
    /**
     * Connect the audio engine to an audio analyser allowing some amazing
     * synchronization between the sounds/music and your visualization (VuMeter for instance).
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#using-the-analyser
     * @param analyser The analyser to connect to the engine
     */ connectToAnalyser(analyser) {
        if (this._connectedAnalyser) this._connectedAnalyser.stopDebugCanvas();
        if (this.canUseWebAudio && this._audioContextInitialized && this._audioContext) {
            this._connectedAnalyser = analyser;
            this.masterGain.disconnect();
            this._connectedAnalyser.connectAudioNodes(this.masterGain, this._audioContext.destination);
        }
    }
}

});


parcelRegister("gQtNK", function(module, exports) {

$parcel$export(module.exports, "RenderTargetTexture", () => $c4389e997f107173$export$3b9cb0a05fe91e82);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $8MhbJ = parcelRequire("8MhbJ");

var $wK2xc = parcelRequire("wK2xc");

var $lUDWq = parcelRequire("lUDWq");

var $kVtWi = parcelRequire("kVtWi");

var $jz7aZ = parcelRequire("jz7aZ");
/**
 * Sets a depth stencil texture from a render target on the engine to be used in the shader.
 * @param channel Name of the sampler variable.
 * @param texture Texture to set.
 */ (0, $lUDWq.Effect).prototype.setDepthStencilTexture = function(channel, texture) {
    this._engine.setDepthStencilTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
};

class $c4389e997f107173$export$3b9cb0a05fe91e82 extends (0, $j2mX5.Texture) {
    /**
     * Use this predicate to dynamically define the list of mesh you want to render.
     * If set, the renderList property will be overwritten.
     */ get renderListPredicate() {
        return this._objectRenderer.renderListPredicate;
    }
    set renderListPredicate(value) {
        this._objectRenderer.renderListPredicate = value;
    }
    /**
     * Use this list to define the list of mesh you want to render.
     */ get renderList() {
        return this._objectRenderer.renderList;
    }
    set renderList(value) {
        this._objectRenderer.renderList = value;
    }
    /**
     * Define the list of particle systems to render in the texture. If not provided, will render all the particle systems of the scene.
     * Note that the particle systems are rendered only if renderParticles is set to true.
     */ get particleSystemList() {
        return this._objectRenderer.particleSystemList;
    }
    set particleSystemList(value) {
        this._objectRenderer.particleSystemList = value;
    }
    /**
     * Use this function to overload the renderList array at rendering time.
     * Return null to render with the current renderList, else return the list of meshes to use for rendering.
     * For 2DArray RTT, layerOrFace is the index of the layer that is going to be rendered, else it is the faceIndex of
     * the cube (if the RTT is a cube, else layerOrFace=0).
     * The renderList passed to the function is the current render list (the one that will be used if the function returns null).
     * The length of this list is passed through renderListLength: don't use renderList.length directly because the array can
     * hold dummy elements!
     */ get getCustomRenderList() {
        return this._objectRenderer.getCustomRenderList;
    }
    set getCustomRenderList(value) {
        this._objectRenderer.getCustomRenderList = value;
    }
    /**
     * Define if particles should be rendered in your texture (default: true).
     */ get renderParticles() {
        return this._objectRenderer.renderParticles;
    }
    set renderParticles(value) {
        this._objectRenderer.renderParticles = value;
    }
    /**
     * Define if sprites should be rendered in your texture (default: false).
     */ get renderSprites() {
        return this._objectRenderer.renderSprites;
    }
    set renderSprites(value) {
        this._objectRenderer.renderSprites = value;
    }
    /**
     * Force checking the layerMask property even if a custom list of meshes is provided (ie. if renderList is not undefined) (default: false).
     */ get forceLayerMaskCheck() {
        return this._objectRenderer.forceLayerMaskCheck;
    }
    set forceLayerMaskCheck(value) {
        this._objectRenderer.forceLayerMaskCheck = value;
    }
    /**
     * Define the camera used to render the texture.
     */ get activeCamera() {
        return this._objectRenderer.activeCamera;
    }
    set activeCamera(value) {
        this._objectRenderer.activeCamera = value;
    }
    /**
     * Define the camera used to calculate the LOD of the objects.
     * If not defined, activeCamera will be used. If not defined nor activeCamera, scene's active camera will be used.
     */ get cameraForLOD() {
        return this._objectRenderer.cameraForLOD;
    }
    set cameraForLOD(value) {
        this._objectRenderer.cameraForLOD = value;
    }
    /**
     * Override the mesh isReady function with your own one.
     */ get customIsReadyFunction() {
        return this._objectRenderer.customIsReadyFunction;
    }
    set customIsReadyFunction(value) {
        this._objectRenderer.customIsReadyFunction = value;
    }
    /**
     * Override the render function of the texture with your own one.
     */ get customRenderFunction() {
        return this._objectRenderer.customRenderFunction;
    }
    set customRenderFunction(value) {
        this._objectRenderer.customRenderFunction = value;
    }
    /**
     * Post-processes for this render target
     */ get postProcesses() {
        return this._postProcesses;
    }
    get _prePassEnabled() {
        return !!this._prePassRenderTarget && this._prePassRenderTarget.enabled;
    }
    /**
     * Set a after unbind callback in the texture.
     * This has been kept for backward compatibility and use of onAfterUnbindObservable is recommended.
     */ set onAfterUnbind(callback) {
        if (this._onAfterUnbindObserver) this.onAfterUnbindObservable.remove(this._onAfterUnbindObserver);
        this._onAfterUnbindObserver = this.onAfterUnbindObservable.add(callback);
    }
    /**
     * An event triggered before rendering the texture
     */ get onBeforeRenderObservable() {
        return this._objectRenderer.onBeforeRenderObservable;
    }
    /**
     * Set a before render callback in the texture.
     * This has been kept for backward compatibility and use of onBeforeRenderObservable is recommended.
     */ set onBeforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /**
     * An event triggered after rendering the texture
     */ get onAfterRenderObservable() {
        return this._objectRenderer.onAfterRenderObservable;
    }
    /**
     * Set a after render callback in the texture.
     * This has been kept for backward compatibility and use of onAfterRenderObservable is recommended.
     */ set onAfterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /**
     * Set a clear callback in the texture.
     * This has been kept for backward compatibility and use of onClearObservable is recommended.
     */ set onClear(callback) {
        if (this._onClearObserver) this.onClearObservable.remove(this._onClearObserver);
        this._onClearObserver = this.onClearObservable.add(callback);
    }
    /** @internal */ get _waitingRenderList() {
        return this._objectRenderer._waitingRenderList;
    }
    /** @internal */ set _waitingRenderList(value) {
        this._objectRenderer._waitingRenderList = value;
    }
    /**
     * Current render pass id of the render target texture. Note it can change over the rendering as there's a separate id for each face of a cube / each layer of an array layer!
     */ get renderPassId() {
        return this._objectRenderer.renderPassId;
    }
    /**
     * Gets the render pass ids used by the render target texture. For a single render target the array length will be 1, for a cube texture it will be 6 and for
     * a 2D texture array it will return an array of ids the size of the 2D texture array
     */ get renderPassIds() {
        return this._objectRenderer.renderPassIds;
    }
    /**
     * Gets the current value of the refreshId counter
     */ get currentRefreshId() {
        return this._objectRenderer.currentRefreshId;
    }
    /**
     * Sets a specific material to be used to render a mesh/a list of meshes in this render target texture
     * @param mesh mesh or array of meshes
     * @param material material or array of materials to use for this render pass. If undefined is passed, no specific material will be used but the regular material instead (mesh.material). It's possible to provide an array of materials to use a different material for each rendering in the case of a cube texture (6 rendering) and a 2D texture array (as many rendering as the length of the array)
     */ setMaterialForRendering(mesh, material) {
        this._objectRenderer.setMaterialForRendering(mesh, material);
    }
    /**
     * Define if the texture has multiple draw buffers or if false a single draw buffer.
     */ get isMulti() {
        return this._renderTarget?.isMulti ?? false;
    }
    /**
     * Gets render target creation options that were used.
     */ get renderTargetOptions() {
        return this._renderTargetOptions;
    }
    /**
     * Gets the render target wrapper associated with this render target
     */ get renderTarget() {
        return this._renderTarget;
    }
    _onRatioRescale() {
        if (this._sizeRatio) this.resize(this._initialSizeParameter);
    }
    /**
     * Gets or sets the size of the bounding box associated with the texture (when in cube mode)
     * When defined, the cubemap will switch to local mode
     * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
     * @example https://www.babylonjs-playground.com/#RNASML
     */ set boundingBoxSize(value) {
        if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) return;
        this._boundingBoxSize = value;
        const scene = this.getScene();
        if (scene) scene.markAllMaterialsAsDirty(1);
    }
    get boundingBoxSize() {
        return this._boundingBoxSize;
    }
    /**
     * In case the RTT has been created with a depth texture, get the associated
     * depth texture.
     * Otherwise, return null.
     */ get depthStencilTexture() {
        return this._renderTarget?._depthStencilTexture ?? null;
    }
    /** @internal */ constructor(name, size, scene, generateMipMaps = false, doNotChangeAspectRatio = true, type = 0, isCube = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, generateDepthBuffer = true, generateStencilBuffer = false, isMulti = false, format = 5, delayAllocation = false, samples, creationFlags, noColorAttachment = false, useSRGBBuffer = false){
        let colorAttachment = undefined;
        let gammaSpace = true;
        let existingObjectRenderer = undefined;
        if (typeof generateMipMaps === "object") {
            const options = generateMipMaps;
            generateMipMaps = !!options.generateMipMaps;
            doNotChangeAspectRatio = options.doNotChangeAspectRatio ?? true;
            type = options.type ?? 0;
            isCube = !!options.isCube;
            samplingMode = options.samplingMode ?? (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE;
            generateDepthBuffer = options.generateDepthBuffer ?? true;
            generateStencilBuffer = !!options.generateStencilBuffer;
            isMulti = !!options.isMulti;
            format = options.format ?? 5;
            delayAllocation = !!options.delayAllocation;
            samples = options.samples;
            creationFlags = options.creationFlags;
            noColorAttachment = !!options.noColorAttachment;
            useSRGBBuffer = !!options.useSRGBBuffer;
            colorAttachment = options.colorAttachment;
            gammaSpace = options.gammaSpace ?? gammaSpace;
            existingObjectRenderer = options.existingObjectRenderer;
        }
        super(null, scene, !generateMipMaps, undefined, samplingMode, undefined, undefined, undefined, undefined, format);
        /**
         * Define if the camera viewport should be respected while rendering the texture or if the render should be done to the entire texture.
         */ this.ignoreCameraViewport = false;
        /**
         * An event triggered when the texture is unbind.
         */ this.onBeforeBindObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the texture is unbind.
         */ this.onAfterUnbindObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the texture clear
         */ this.onClearObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the texture is resized.
         */ this.onResizeObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._cleared = false;
        /**
         * Skip the initial clear of the rtt at the beginning of the frame render loop
         */ this.skipInitialClear = false;
        this._samples = 1;
        this._canRescale = true;
        this._renderTarget = null;
        this._dontDisposeObjectRenderer = false;
        /**
         * Gets or sets the center of the bounding box associated with the texture (when in cube mode)
         * It must define where the camera used to render the texture is set
         */ this.boundingBoxPosition = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._disableEngineStages = false; // TODO: remove this when the shadow generator task (frame graph) is reworked (see https://github.com/BabylonJS/Babylon.js/pull/15962#discussion_r1874417607)
        this._dumpToolsLoading = false;
        scene = this.getScene();
        if (!scene) return;
        const engine = this.getScene().getEngine();
        this._gammaSpace = gammaSpace;
        this._coordinatesMode = (0, $j2mX5.Texture).PROJECTION_MODE;
        this.name = name;
        this.isRenderTarget = true;
        this._initialSizeParameter = size;
        this._dontDisposeObjectRenderer = !!existingObjectRenderer;
        this._processSizeParameter(size);
        this._objectRenderer = existingObjectRenderer ?? new (0, $jz7aZ.ObjectRenderer)(name, scene, {
            numPasses: isCube ? 6 : this.getRenderLayers() || 1,
            doNotChangeAspectRatio: doNotChangeAspectRatio
        });
        this._onBeforeRenderingManagerRenderObserver = this._objectRenderer.onBeforeRenderingManagerRenderObservable.add(()=>{
            // Before clear
            if (!this._disableEngineStages) for (const step of this._scene._beforeRenderTargetClearStage)step.action(this, this._currentFaceIndex, this._currentLayer);
            // Clear
            if (this.onClearObservable.hasObservers()) this.onClearObservable.notifyObservers(engine);
            else if (!this.skipInitialClear) engine.clear(this.clearColor || this._scene.clearColor, true, true, true);
            if (!this._doNotChangeAspectRatio) this._scene.updateTransformMatrix(true);
            // Before Camera Draw
            if (!this._disableEngineStages) for (const step of this._scene._beforeRenderTargetDrawStage)step.action(this, this._currentFaceIndex, this._currentLayer);
        });
        this._onAfterRenderingManagerRenderObserver = this._objectRenderer.onAfterRenderingManagerRenderObservable.add(()=>{
            // After Camera Draw
            if (!this._disableEngineStages) for (const step of this._scene._afterRenderTargetDrawStage)step.action(this, this._currentFaceIndex, this._currentLayer);
            const saveGenerateMipMaps = this._texture?.generateMipMaps ?? false;
            if (this._texture) this._texture.generateMipMaps = false; // if left true, the mipmaps will be generated (if this._texture.generateMipMaps = true) when the first post process binds its own RTT: by doing so it will unbind the current RTT,
            if (this._postProcessManager) this._postProcessManager._finalizeFrame(false, this._renderTarget ?? undefined, this._currentFaceIndex, this._postProcesses, this.ignoreCameraViewport);
            else if (this._currentUseCameraPostProcess) this._scene.postProcessManager._finalizeFrame(false, this._renderTarget ?? undefined, this._currentFaceIndex);
            if (!this._disableEngineStages) for (const step of this._scene._afterRenderTargetPostProcessStage)step.action(this, this._currentFaceIndex, this._currentLayer);
            if (this._texture) this._texture.generateMipMaps = saveGenerateMipMaps;
            if (!this._doNotChangeAspectRatio) this._scene.updateTransformMatrix(true);
            // Dump ?
            if (this._currentDumpForDebug) {
                if (!this._dumpTools) (0, $kVtWi.Logger).Error("dumpTools module is still being loaded. To speed up the process import dump tools directly in your project");
                else this._dumpTools.DumpFramebuffer(this.getRenderWidth(), this.getRenderHeight(), engine);
            }
        });
        this._onFastPathRenderObserver = this._objectRenderer.onFastPathRenderObservable.add(()=>{
            if (this.onClearObservable.hasObservers()) this.onClearObservable.notifyObservers(engine);
            else if (!this.skipInitialClear) engine.clear(this.clearColor || this._scene.clearColor, true, true, true);
        });
        this._resizeObserver = engine.onResizeObservable.add(()=>{});
        this._generateMipMaps = generateMipMaps ? true : false;
        this._doNotChangeAspectRatio = doNotChangeAspectRatio;
        if (isMulti) return;
        this._renderTargetOptions = {
            generateMipMaps: generateMipMaps,
            type: type,
            format: this._format ?? undefined,
            samplingMode: this.samplingMode,
            generateDepthBuffer: generateDepthBuffer,
            generateStencilBuffer: generateStencilBuffer,
            samples: samples,
            creationFlags: creationFlags,
            noColorAttachment: noColorAttachment,
            useSRGBBuffer: useSRGBBuffer,
            colorAttachment: colorAttachment,
            label: this.name
        };
        if (this.samplingMode === (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE) {
            this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        }
        if (!delayAllocation) {
            if (isCube) {
                this._renderTarget = scene.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions);
                this.coordinatesMode = (0, $j2mX5.Texture).INVCUBIC_MODE;
                this._textureMatrix = (0, $ha1VO.Matrix).Identity();
            } else this._renderTarget = scene.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions);
            this._texture = this._renderTarget.texture;
            if (samples !== undefined) this.samples = samples;
        }
    }
    /**
     * Creates a depth stencil texture.
     * This is only available in WebGL 2 or with the depth texture extension available.
     * @param comparisonFunction Specifies the comparison function to set on the texture. If 0 or undefined, the texture is not in comparison mode (default: 0)
     * @param bilinearFiltering Specifies whether or not bilinear filtering is enable on the texture (default: true)
     * @param generateStencil Specifies whether or not a stencil should be allocated in the texture (default: false)
     * @param samples sample count of the depth/stencil texture (default: 1)
     * @param format format of the depth texture (default: 14)
     * @param label defines the label of the texture (for debugging purpose)
     */ createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14, label) {
        this._renderTarget?.createDepthStencilTexture(comparisonFunction, bilinearFiltering, generateStencil, samples, format, label);
    }
    _processSizeParameter(size) {
        if (size.ratio) {
            this._sizeRatio = size.ratio;
            const engine = this._getEngine();
            this._size = {
                width: this._bestReflectionRenderTargetDimension(engine.getRenderWidth(), this._sizeRatio),
                height: this._bestReflectionRenderTargetDimension(engine.getRenderHeight(), this._sizeRatio)
            };
        } else this._size = size;
    }
    /**
     * Define the number of samples to use in case of MSAA.
     * It defaults to one meaning no MSAA has been enabled.
     */ get samples() {
        return this._renderTarget?.samples ?? this._samples;
    }
    set samples(value) {
        if (this._renderTarget) this._samples = this._renderTarget.setSamples(value);
    }
    /**
     * Adds a post process to the render target rendering passes.
     * @param postProcess define the post process to add
     */ addPostProcess(postProcess) {
        if (!this._postProcessManager) {
            const scene = this.getScene();
            if (!scene) return;
            this._postProcessManager = new (0, $8MhbJ.PostProcessManager)(scene);
            this._postProcesses = new Array();
        }
        this._postProcesses.push(postProcess);
        this._postProcesses[0].autoClear = false;
    }
    /**
     * Clear all the post processes attached to the render target
     * @param dispose define if the cleared post processes should also be disposed (false by default)
     */ clearPostProcesses(dispose = false) {
        if (!this._postProcesses) return;
        if (dispose) for (const postProcess of this._postProcesses)postProcess.dispose();
        this._postProcesses = [];
    }
    /**
     * Remove one of the post process from the list of attached post processes to the texture
     * @param postProcess define the post process to remove from the list
     */ removePostProcess(postProcess) {
        if (!this._postProcesses) return;
        const index = this._postProcesses.indexOf(postProcess);
        if (index === -1) return;
        this._postProcesses.splice(index, 1);
        if (this._postProcesses.length > 0) this._postProcesses[0].autoClear = false;
    }
    /**
     * Resets the refresh counter of the texture and start bak from scratch.
     * Could be useful to regenerate the texture if it is setup to render only once.
     */ resetRefreshCounter() {
        this._objectRenderer.resetRefreshCounter();
    }
    /**
     * Define the refresh rate of the texture or the rendering frequency.
     * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
     */ get refreshRate() {
        return this._objectRenderer.refreshRate;
    }
    set refreshRate(value) {
        this._objectRenderer.refreshRate = value;
    }
    /** @internal */ _shouldRender() {
        return this._objectRenderer.shouldRender();
    }
    /**
     * Gets the actual render size of the texture.
     * @returns the width of the render size
     */ getRenderSize() {
        return this.getRenderWidth();
    }
    /**
     * Gets the actual render width of the texture.
     * @returns the width of the render size
     */ getRenderWidth() {
        if (this._size.width) return this._size.width;
        return this._size;
    }
    /**
     * Gets the actual render height of the texture.
     * @returns the height of the render size
     */ getRenderHeight() {
        if (this._size.width) return this._size.height;
        return this._size;
    }
    /**
     * Gets the actual number of layers of the texture or, in the case of a 3D texture, return the depth.
     * @returns the number of layers
     */ getRenderLayers() {
        const layers = this._size.layers;
        if (layers) return layers;
        const depth = this._size.depth;
        if (depth) return depth;
        return 0;
    }
    /**
     * Don't allow this render target texture to rescale. Mainly used to prevent rescaling by the scene optimizer.
     */ disableRescaling() {
        this._canRescale = false;
    }
    /**
     * Get if the texture can be rescaled or not.
     */ get canRescale() {
        return this._canRescale;
    }
    /**
     * Resize the texture using a ratio.
     * @param ratio the ratio to apply to the texture size in order to compute the new target size
     */ scale(ratio) {
        const newSize = Math.max(1, this.getRenderSize() * ratio);
        this.resize(newSize);
    }
    /**
     * Get the texture reflection matrix used to rotate/transform the reflection.
     * @returns the reflection matrix
     */ getReflectionTextureMatrix() {
        if (this.isCube) return this._textureMatrix;
        return super.getReflectionTextureMatrix();
    }
    /**
     * Resize the texture to a new desired size.
     * Be careful as it will recreate all the data in the new texture.
     * @param size Define the new size. It can be:
     *   - a number for squared texture,
     *   - an object containing { width: number, height: number }
     *   - or an object containing a ratio { ratio: number }
     */ resize(size) {
        const wasCube = this.isCube;
        this._renderTarget?.dispose();
        this._renderTarget = null;
        const scene = this.getScene();
        if (!scene) return;
        this._processSizeParameter(size);
        if (wasCube) this._renderTarget = scene.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions);
        else this._renderTarget = scene.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions);
        this._texture = this._renderTarget.texture;
        if (this._renderTargetOptions.samples !== undefined) this.samples = this._renderTargetOptions.samples;
        if (this.onResizeObservable.hasObservers()) this.onResizeObservable.notifyObservers(this);
    }
    /**
     * Renders all the objects from the render list into the texture.
     * @param useCameraPostProcess Define if camera post processes should be used during the rendering
     * @param dumpForDebug Define if the rendering result should be dumped (copied) for debugging purpose
     */ render(useCameraPostProcess = false, dumpForDebug = false) {
        this._render(useCameraPostProcess, dumpForDebug);
    }
    /**
     * This function will check if the render target texture can be rendered (textures are loaded, shaders are compiled)
     * @returns true if all required resources are ready
     */ isReadyForRendering() {
        if (!this._dumpToolsLoading) {
            this._dumpToolsLoading = true;
            // avoid a static import to allow ignoring the import in some cases
            (parcelRequire("2nL19")).then((module)=>this._dumpTools = module);
        }
        this._objectRenderer.prepareRenderList();
        this.onBeforeBindObservable.notifyObservers(this);
        this._objectRenderer.initRender(this.getRenderWidth(), this.getRenderHeight());
        const isReady = this._objectRenderer._checkReadiness();
        this.onAfterUnbindObservable.notifyObservers(this);
        this._objectRenderer.finishRender();
        return isReady;
    }
    _render(useCameraPostProcess = false, dumpForDebug = false) {
        const scene = this.getScene();
        if (!scene) return;
        if (this.useCameraPostProcesses !== undefined) useCameraPostProcess = this.useCameraPostProcesses;
        this._objectRenderer.prepareRenderList();
        this.onBeforeBindObservable.notifyObservers(this);
        this._objectRenderer.initRender(this.getRenderWidth(), this.getRenderHeight());
        if ((this.is2DArray || this.is3D) && !this.isMulti) for(let layer = 0; layer < this.getRenderLayers(); layer++){
            this._renderToTarget(0, useCameraPostProcess, dumpForDebug, layer);
            scene.incrementRenderId();
            scene.resetCachedMaterial();
        }
        else if (this.isCube && !this.isMulti) for(let face = 0; face < 6; face++){
            this._renderToTarget(face, useCameraPostProcess, dumpForDebug);
            scene.incrementRenderId();
            scene.resetCachedMaterial();
        }
        else this._renderToTarget(0, useCameraPostProcess, dumpForDebug);
        this.onAfterUnbindObservable.notifyObservers(this);
        this._objectRenderer.finishRender();
    }
    _bestReflectionRenderTargetDimension(renderDimension, scale) {
        const minimum = 128;
        const x = renderDimension * scale;
        const curved = (0, $wK2xc.NearestPOT)(x + minimum * minimum / (minimum + x));
        // Ensure we don't exceed the render dimension (while staying POT)
        return Math.min((0, $wK2xc.FloorPOT)(renderDimension), curved);
    }
    /**
     * @internal
     * @param faceIndex face index to bind to if this is a cubetexture
     * @param layer defines the index of the texture to bind in the array
     */ _bindFrameBuffer(faceIndex = 0, layer = 0) {
        const scene = this.getScene();
        if (!scene) return;
        const engine = scene.getEngine();
        if (this._renderTarget) engine.bindFramebuffer(this._renderTarget, this.isCube ? faceIndex : undefined, undefined, undefined, this.ignoreCameraViewport, 0, layer);
    }
    _unbindFrameBuffer(engine, faceIndex) {
        if (!this._renderTarget) return;
        engine.unBindFramebuffer(this._renderTarget, this.isCube, ()=>{
            this.onAfterRenderObservable.notifyObservers(faceIndex);
        });
    }
    /**
     * @internal
     */ _prepareFrame(scene, faceIndex, layer, useCameraPostProcess) {
        if (this._postProcessManager) {
            if (!this._prePassEnabled) this._postProcessManager._prepareFrame(this._texture, this._postProcesses);
        } else if (!useCameraPostProcess || !scene.postProcessManager._prepareFrame(this._texture)) this._bindFrameBuffer(faceIndex, layer);
    }
    _renderToTarget(faceIndex, useCameraPostProcess, dumpForDebug, layer = 0) {
        const scene = this.getScene();
        if (!scene) return;
        const engine = scene.getEngine();
        this._currentFaceIndex = faceIndex;
        this._currentLayer = layer;
        this._currentUseCameraPostProcess = useCameraPostProcess;
        this._currentDumpForDebug = dumpForDebug;
        this._prepareFrame(scene, faceIndex, layer, useCameraPostProcess);
        engine._debugPushGroup?.(`render to face #${faceIndex} layer #${layer}`, 2);
        this._objectRenderer.render(faceIndex + layer, true); // only faceIndex or layer (if any) will be different from 0 (we don't support array of cubes), so it's safe to add them to get the pass index
        engine._debugPopGroup?.(2);
        this._unbindFrameBuffer(engine, faceIndex);
        if (this._texture && this.isCube && faceIndex === 5) engine.generateMipMapsForCubemap(this._texture, true);
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversely depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._objectRenderer.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil) {
        this._objectRenderer.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil);
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        const textureSize = this.getSize();
        const newTexture = new $c4389e997f107173$export$3b9cb0a05fe91e82(this.name, textureSize, this.getScene(), this._renderTargetOptions.generateMipMaps, this._doNotChangeAspectRatio, this._renderTargetOptions.type, this.isCube, this._renderTargetOptions.samplingMode, this._renderTargetOptions.generateDepthBuffer, this._renderTargetOptions.generateStencilBuffer, undefined, this._renderTargetOptions.format, undefined, this._renderTargetOptions.samples);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // RenderTarget Texture
        newTexture.coordinatesMode = this.coordinatesMode;
        if (this.renderList) newTexture.renderList = this.renderList.slice(0);
        return newTexture;
    }
    /**
     * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
     * @returns The JSON representation of the texture
     */ serialize() {
        if (!this.name) return null;
        const serializationObject = super.serialize();
        serializationObject.renderTargetSize = this.getRenderSize();
        serializationObject.renderList = [];
        if (this.renderList) for(let index = 0; index < this.renderList.length; index++)serializationObject.renderList.push(this.renderList[index].id);
        return serializationObject;
    }
    /**
     *  This will remove the attached framebuffer objects. The texture will not be able to be used as render target anymore
     */ disposeFramebufferObjects() {
        this._renderTarget?.dispose(true);
    }
    /**
     * Release and destroy the underlying lower level texture aka internalTexture.
     */ releaseInternalTexture() {
        this._renderTarget?.releaseTextures();
        this._texture = null;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        this.onResizeObservable.clear();
        this.onClearObservable.clear();
        this.onAfterUnbindObservable.clear();
        this.onBeforeBindObservable.clear();
        if (this._postProcessManager) {
            this._postProcessManager.dispose();
            this._postProcessManager = null;
        }
        if (this._prePassRenderTarget) this._prePassRenderTarget.dispose();
        this._objectRenderer.onBeforeRenderingManagerRenderObservable.remove(this._onBeforeRenderingManagerRenderObserver);
        this._objectRenderer.onAfterRenderingManagerRenderObservable.remove(this._onAfterRenderingManagerRenderObserver);
        this._objectRenderer.onFastPathRenderObservable.remove(this._onFastPathRenderObserver);
        if (!this._dontDisposeObjectRenderer) this._objectRenderer.dispose();
        this.clearPostProcesses(true);
        if (this._resizeObserver) {
            this.getScene().getEngine().onResizeObservable.remove(this._resizeObserver);
            this._resizeObserver = null;
        }
        // Remove from custom render targets
        const scene = this.getScene();
        if (!scene) return;
        let index = scene.customRenderTargets.indexOf(this);
        if (index >= 0) scene.customRenderTargets.splice(index, 1);
        for (const camera of scene.cameras){
            index = camera.customRenderTargets.indexOf(this);
            if (index >= 0) camera.customRenderTargets.splice(index, 1);
        }
        this._renderTarget?.dispose();
        this._renderTarget = null;
        this._texture = null;
        super.dispose();
    }
    /** @internal */ _rebuild() {
        this._objectRenderer._rebuild();
        if (this._postProcessManager) this._postProcessManager._rebuild();
    }
    /**
     * Clear the info related to rendering groups preventing retention point in material dispose.
     */ freeRenderingGroups() {
        this._objectRenderer.freeRenderingGroups();
    }
    /**
     * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
     * @returns the view count
     */ getViewCount() {
        return 1;
    }
}
/**
 * The texture will only be rendered once which can be useful to improve performance if everything in your render is static for instance.
 */ $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONCE = (0, $jz7aZ.ObjectRenderer).REFRESHRATE_RENDER_ONCE;
/**
 * The texture will be rendered every frame and is recommended for dynamic contents.
 */ $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONEVERYFRAME = (0, $jz7aZ.ObjectRenderer).REFRESHRATE_RENDER_ONEVERYFRAME;
/**
 * The texture will be rendered every 2 frames which could be enough if your dynamic objects are not
 * the central point of your effect and can save a lot of performances.
 */ $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONEVERYTWOFRAMES = (0, $jz7aZ.ObjectRenderer).REFRESHRATE_RENDER_ONEVERYTWOFRAMES;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $j2mX5.Texture)._CreateRenderTargetTexture = (name, renderTargetSize, scene, generateMipMaps, creationFlags)=>{
    return new $c4389e997f107173$export$3b9cb0a05fe91e82(name, renderTargetSize, scene, generateMipMaps);
};

});
parcelRegister("jz7aZ", function(module, exports) {

$parcel$export(module.exports, "ObjectRenderer", () => $e3e6da3d7976691f$export$ca67b0b0fa758253);

var $diGQf = parcelRequire("diGQf");

var $jJNg8 = parcelRequire("jJNg8");

var $opFp4 = parcelRequire("opFp4");
class $e3e6da3d7976691f$export$ca67b0b0fa758253 {
    /**
     * Use this list to define the list of mesh you want to render.
     */ get renderList() {
        return this._renderList;
    }
    set renderList(value) {
        if (this._renderList === value) return;
        if (this._unObserveRenderList) {
            this._unObserveRenderList();
            this._unObserveRenderList = null;
        }
        if (value) this._unObserveRenderList = (0, $opFp4._ObserveArray)(value, this._renderListHasChanged);
        this._renderList = value;
    }
    /**
     * Friendly name of the object renderer
     */ get name() {
        return this._name;
    }
    set name(value) {
        if (this._name === value) return;
        this._name = value;
        if (!this._scene) return;
        const engine = this._scene.getEngine();
        for(let i = 0; i < this._renderPassIds.length; ++i){
            const renderPassId = this._renderPassIds[i];
            engine._renderPassNames[renderPassId] = `${this._name}#${i}`;
        }
    }
    /**
     * Gets the render pass ids used by the object renderer.
     */ get renderPassIds() {
        return this._renderPassIds;
    }
    /**
     * Gets the current value of the refreshId counter
     */ get currentRefreshId() {
        return this._currentRefreshId;
    }
    /**
     * Sets a specific material to be used to render a mesh/a list of meshes with this object renderer
     * @param mesh mesh or array of meshes
     * @param material material or array of materials to use for this render pass. If undefined is passed, no specific material will be used but the regular material instead (mesh.material). It's possible to provide an array of materials to use a different material for each rendering pass.
     */ setMaterialForRendering(mesh, material) {
        let meshes;
        if (!Array.isArray(mesh)) meshes = [
            mesh
        ];
        else meshes = mesh;
        for(let j = 0; j < meshes.length; ++j)for(let i = 0; i < this.options.numPasses; ++i)meshes[j].setMaterialForRenderPass(this._renderPassIds[i], material !== undefined ? Array.isArray(material) ? material[i] : material : undefined);
    }
    /**
     * Instantiates an object renderer.
     * @param name The friendly name of the object renderer
     * @param scene The scene the renderer belongs to
     * @param options The options used to create the renderer (optional)
     */ constructor(name, scene, options){
        this._unObserveRenderList = null;
        this._renderListHasChanged = (_functionName, previousLength)=>{
            const newLength = this._renderList ? this._renderList.length : 0;
            if (previousLength === 0 && newLength > 0 || newLength === 0) this._scene.meshes.forEach((mesh)=>{
                mesh._markSubMeshesAsLightDirty();
            });
        };
        /**
         * Define the list of particle systems to render. If not provided, will render all the particle systems of the scene.
         * Note that the particle systems are rendered only if renderParticles is set to true.
         */ this.particleSystemList = null;
        /**
         * Use this function to overload the renderList array at rendering time.
         * Return null to render with the current renderList, else return the list of meshes to use for rendering.
         * For 2DArray, layerOrFace is the index of the layer that is going to be rendered, else it is the faceIndex of
         * the cube (if the RTT is a cube, else layerOrFace=0).
         * The renderList passed to the function is the current render list (the one that will be used if the function returns null).
         * The length of this list is passed through renderListLength: don't use renderList.length directly because the array can
         * hold dummy elements!
         */ this.getCustomRenderList = null;
        /**
         * Define if particles should be rendered.
         */ this.renderParticles = true;
        /**
         * Define if sprites should be rendered.
         */ this.renderSprites = false;
        /**
         * Force checking the layerMask property even if a custom list of meshes is provided (ie. if renderList is not undefined)
         */ this.forceLayerMaskCheck = false;
        /**
         * An event triggered before rendering the objects
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the objects
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before the rendering group is processed
         */ this.onBeforeRenderingManagerRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the rendering group is processed
         */ this.onAfterRenderingManagerRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when fast path rendering is used
         */ this.onFastPathRenderObservable = new (0, $diGQf.Observable)();
        this._currentRefreshId = -1;
        this._refreshRate = 1;
        this._currentSceneCamera = null;
        this.name = name;
        this._scene = scene;
        this.renderList = [];
        this._renderPassIds = [];
        this.options = {
            numPasses: 1,
            doNotChangeAspectRatio: true,
            ...options
        };
        this._createRenderPassId();
        this.renderPassId = this._renderPassIds[0];
        // Rendering groups
        this._renderingManager = new (0, $jJNg8.RenderingManager)(scene);
        this._renderingManager._useSceneAutoClearSetup = true;
    }
    _releaseRenderPassId() {
        const engine = this._scene.getEngine();
        for(let i = 0; i < this.options.numPasses; ++i)engine.releaseRenderPassId(this._renderPassIds[i]);
        this._renderPassIds.length = 0;
    }
    _createRenderPassId() {
        this._releaseRenderPassId();
        const engine = this._scene.getEngine();
        for(let i = 0; i < this.options.numPasses; ++i)this._renderPassIds[i] = engine.createRenderPassId(`${this.name}#${i}`);
    }
    /**
     * Resets the refresh counter of the renderer and start back from scratch.
     * Could be useful to re-render if it is setup to render only once.
     */ resetRefreshCounter() {
        this._currentRefreshId = -1;
    }
    /**
     * Defines the refresh rate of the rendering or the rendering frequency.
     * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
     */ get refreshRate() {
        return this._refreshRate;
    }
    set refreshRate(value) {
        this._refreshRate = value;
        this.resetRefreshCounter();
    }
    /**
     * Indicates if the renderer should render the current frame.
     * The output is based on the specified refresh rate.
     * @returns true if the renderer should render the current frame
     */ shouldRender() {
        if (this._currentRefreshId === -1) {
            // At least render once
            this._currentRefreshId = 1;
            return true;
        }
        if (this.refreshRate === this._currentRefreshId) {
            this._currentRefreshId = 1;
            return true;
        }
        this._currentRefreshId++;
        return false;
    }
    /**
     * This function will check if the renderer is ready to render (textures are loaded, shaders are compiled)
     * @param viewportWidth defines the width of the viewport
     * @param viewportHeight defines the height of the viewport
     * @returns true if all required resources are ready
     */ isReadyForRendering(viewportWidth, viewportHeight) {
        this.prepareRenderList();
        this.initRender(viewportWidth, viewportHeight);
        const isReady = this._checkReadiness();
        this.finishRender();
        return isReady;
    }
    /**
     * Makes sure the list of meshes is ready to be rendered
     * You should call this function before "initRender", but if you know the render list is ok, you may call "initRender" directly
     */ prepareRenderList() {
        const scene = this._scene;
        if (this._waitingRenderList) {
            if (!this.renderListPredicate) {
                this.renderList = [];
                for(let index = 0; index < this._waitingRenderList.length; index++){
                    const id = this._waitingRenderList[index];
                    const mesh = scene.getMeshById(id);
                    if (mesh) this.renderList.push(mesh);
                }
            }
            this._waitingRenderList = undefined;
        }
        // Is predicate defined?
        if (this.renderListPredicate) {
            if (this.renderList) this.renderList.length = 0; // Clear previous renderList
            else this.renderList = [];
            const sceneMeshes = this._scene.meshes;
            for(let index = 0; index < sceneMeshes.length; index++){
                const mesh = sceneMeshes[index];
                if (this.renderListPredicate(mesh)) this.renderList.push(mesh);
            }
        }
    }
    /**
     * This method makes sure everything is setup before "render" can be called
     * @param viewportWidth Width of the viewport to render to
     * @param viewportHeight Height of the viewport to render to
     */ initRender(viewportWidth, viewportHeight) {
        const engine = this._scene.getEngine();
        const camera = this.activeCamera ?? this._scene.activeCamera;
        this._currentSceneCamera = this._scene.activeCamera;
        if (camera) {
            if (camera !== this._scene.activeCamera) {
                this._scene.setTransformMatrix(camera.getViewMatrix(), camera.getProjectionMatrix(true));
                this._scene.activeCamera = camera;
            }
            engine.setViewport(camera.rigParent ? camera.rigParent.viewport : camera.viewport, viewportWidth, viewportHeight);
        }
        this._defaultRenderListPrepared = false;
    }
    /**
     * This method must be called after the "render" call(s), to complete the rendering process.
     */ finishRender() {
        const scene = this._scene;
        scene.activeCamera = this._currentSceneCamera;
        if (this._currentSceneCamera) {
            if (this.activeCamera && this.activeCamera !== scene.activeCamera) scene.setTransformMatrix(this._currentSceneCamera.getViewMatrix(), this._currentSceneCamera.getProjectionMatrix(true));
            scene.getEngine().setViewport(this._currentSceneCamera.viewport);
        }
        scene.resetCachedMaterial();
    }
    /**
     * Renders all the objects (meshes, particles systems, sprites) to the currently bound render target texture.
     * @param passIndex defines the pass index to use (default: 0)
     * @param skipOnAfterRenderObservable defines a flag to skip raising the onAfterRenderObservable
     */ render(passIndex = 0, skipOnAfterRenderObservable = false) {
        const scene = this._scene;
        const engine = scene.getEngine();
        const currentRenderPassId = engine.currentRenderPassId;
        engine.currentRenderPassId = this._renderPassIds[passIndex];
        this.onBeforeRenderObservable.notifyObservers(passIndex);
        const fastPath = engine.snapshotRendering && engine.snapshotRenderingMode === 1;
        if (!fastPath) {
            // Get the list of meshes to render
            let currentRenderList = null;
            const defaultRenderList = this.renderList ? this.renderList : scene.getActiveMeshes().data;
            const defaultRenderListLength = this.renderList ? this.renderList.length : scene.getActiveMeshes().length;
            if (this.getCustomRenderList) currentRenderList = this.getCustomRenderList(passIndex, defaultRenderList, defaultRenderListLength);
            if (!currentRenderList) {
                // No custom render list provided, we prepare the rendering for the default list, but check
                // first if we did not already performed the preparation before so as to avoid re-doing it several times
                if (!this._defaultRenderListPrepared) {
                    this._prepareRenderingManager(defaultRenderList, defaultRenderListLength, !this.renderList || this.forceLayerMaskCheck);
                    this._defaultRenderListPrepared = true;
                }
                currentRenderList = defaultRenderList;
            } else // Prepare the rendering for the custom render list provided
            this._prepareRenderingManager(currentRenderList, currentRenderList.length, this.forceLayerMaskCheck);
            this.onBeforeRenderingManagerRenderObservable.notifyObservers(passIndex);
            this._renderingManager.render(this.customRenderFunction, currentRenderList, this.renderParticles, this.renderSprites);
            this.onAfterRenderingManagerRenderObservable.notifyObservers(passIndex);
        } else this.onFastPathRenderObservable.notifyObservers(passIndex);
        if (!skipOnAfterRenderObservable) this.onAfterRenderObservable.notifyObservers(passIndex);
        engine.currentRenderPassId = currentRenderPassId;
    }
    /** @internal */ _checkReadiness() {
        const scene = this._scene;
        const engine = scene.getEngine();
        const currentRenderPassId = engine.currentRenderPassId;
        let returnValue = true;
        if (!scene.getViewMatrix()) // We probably didn't execute scene.render() yet, so make sure we have a view/projection matrix setup for the scene
        scene.updateTransformMatrix();
        const numPasses = this.options.numPasses;
        for(let passIndex = 0; passIndex < numPasses && returnValue; passIndex++){
            let currentRenderList = null;
            const defaultRenderList = this.renderList ? this.renderList : scene.getActiveMeshes().data;
            const defaultRenderListLength = this.renderList ? this.renderList.length : scene.getActiveMeshes().length;
            engine.currentRenderPassId = this._renderPassIds[passIndex];
            this.onBeforeRenderObservable.notifyObservers(passIndex);
            if (this.getCustomRenderList) currentRenderList = this.getCustomRenderList(passIndex, defaultRenderList, defaultRenderListLength);
            if (!currentRenderList) currentRenderList = defaultRenderList;
            if (!this.options.doNotChangeAspectRatio) scene.updateTransformMatrix(true);
            for(let i = 0; i < currentRenderList.length && returnValue; ++i){
                const mesh = currentRenderList[i];
                if (!mesh.isEnabled() || mesh.isBlocked || !mesh.isVisible || !mesh.subMeshes) continue;
                if (this.customIsReadyFunction) {
                    if (!this.customIsReadyFunction(mesh, this.refreshRate, true)) {
                        returnValue = false;
                        continue;
                    }
                } else if (!mesh.isReady(true)) {
                    returnValue = false;
                    continue;
                }
            }
            this.onAfterRenderObservable.notifyObservers(passIndex);
            if (numPasses > 1) {
                scene.incrementRenderId();
                scene.resetCachedMaterial();
            }
        }
        const particleSystems = this.particleSystemList || scene.particleSystems;
        for (const particleSystem of particleSystems)if (!particleSystem.isReady()) returnValue = false;
        engine.currentRenderPassId = currentRenderPassId;
        return returnValue;
    }
    _prepareRenderingManager(currentRenderList, currentRenderListLength, checkLayerMask) {
        const scene = this._scene;
        const camera = scene.activeCamera; // note that at this point, scene.activeCamera == this.activeCamera if defined, because initRender() has been called before
        const cameraForLOD = this.cameraForLOD ?? camera;
        this._renderingManager.reset();
        const sceneRenderId = scene.getRenderId();
        const currentFrameId = scene.getFrameId();
        for(let meshIndex = 0; meshIndex < currentRenderListLength; meshIndex++){
            const mesh = currentRenderList[meshIndex];
            if (mesh && !mesh.isBlocked) {
                if (this.customIsReadyFunction) {
                    if (!this.customIsReadyFunction(mesh, this.refreshRate, false)) {
                        this.resetRefreshCounter();
                        continue;
                    }
                } else if (!mesh.isReady(this.refreshRate === 0)) {
                    this.resetRefreshCounter();
                    continue;
                }
                let meshToRender = null;
                if (cameraForLOD) {
                    const meshToRenderAndFrameId = mesh._internalAbstractMeshDataInfo._currentLOD.get(cameraForLOD);
                    if (!meshToRenderAndFrameId || meshToRenderAndFrameId[1] !== currentFrameId) {
                        meshToRender = scene.customLODSelector ? scene.customLODSelector(mesh, cameraForLOD) : mesh.getLOD(cameraForLOD);
                        if (!meshToRenderAndFrameId) mesh._internalAbstractMeshDataInfo._currentLOD.set(cameraForLOD, [
                            meshToRender,
                            currentFrameId
                        ]);
                        else {
                            meshToRenderAndFrameId[0] = meshToRender;
                            meshToRenderAndFrameId[1] = currentFrameId;
                        }
                    } else meshToRender = meshToRenderAndFrameId[0];
                } else meshToRender = mesh;
                if (!meshToRender) continue;
                if (meshToRender !== mesh && meshToRender.billboardMode !== 0) meshToRender.computeWorldMatrix(); // Compute world matrix if LOD is billboard
                meshToRender._preActivateForIntermediateRendering(sceneRenderId);
                let isMasked;
                if (checkLayerMask && camera) isMasked = (mesh.layerMask & camera.layerMask) === 0;
                else isMasked = false;
                if (mesh.isEnabled() && mesh.isVisible && mesh.subMeshes && !isMasked) {
                    if (meshToRender !== mesh) meshToRender._activate(sceneRenderId, true);
                    if (mesh._activate(sceneRenderId, true) && mesh.subMeshes.length) {
                        if (!mesh.isAnInstance) meshToRender._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = false;
                        else if (mesh._internalAbstractMeshDataInfo._actAsRegularMesh) meshToRender = mesh;
                        meshToRender._internalAbstractMeshDataInfo._isActiveIntermediate = true;
                        scene._prepareSkeleton(meshToRender);
                        for(let subIndex = 0; subIndex < meshToRender.subMeshes.length; subIndex++){
                            const subMesh = meshToRender.subMeshes[subIndex];
                            this._renderingManager.dispatch(subMesh, meshToRender);
                        }
                    }
                    mesh._postActivate();
                }
            }
        }
        const particleSystems = this.particleSystemList || scene.particleSystems;
        for(let particleIndex = 0; particleIndex < particleSystems.length; particleIndex++){
            const particleSystem = particleSystems[particleIndex];
            const emitter = particleSystem.emitter;
            if (!particleSystem.isStarted() || !emitter || emitter.position && !emitter.isEnabled()) continue;
            this._renderingManager.dispatchParticles(particleSystem);
        }
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversely depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._renderingManager.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     * @param depth Automatically clears depth between groups if true and autoClear is true.
     * @param stencil Automatically clears stencil between groups if true and autoClear is true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
        this._renderingManager.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth, stencil);
        this._renderingManager._useSceneAutoClearSetup = false;
    }
    /**
     * Clones the renderer.
     * @returns the cloned renderer
     */ clone() {
        const newRenderer = new $e3e6da3d7976691f$export$ca67b0b0fa758253(this.name, this._scene, this.options);
        if (this.renderList) newRenderer.renderList = this.renderList.slice(0);
        return newRenderer;
    }
    /**
     * Dispose the renderer and release its associated resources.
     */ dispose() {
        const renderList = this.renderList ? this.renderList : this._scene.getActiveMeshes().data;
        const renderListLength = this.renderList ? this.renderList.length : this._scene.getActiveMeshes().length;
        for(let i = 0; i < renderListLength; i++){
            const mesh = renderList[i];
            if (mesh.getMaterialForRenderPass(this.renderPassId) !== undefined) mesh.setMaterialForRenderPass(this.renderPassId, undefined);
        }
        this.onBeforeRenderObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onBeforeRenderingManagerRenderObservable.clear();
        this.onAfterRenderingManagerRenderObservable.clear();
        this.onFastPathRenderObservable.clear();
        this._releaseRenderPassId();
        this.renderList = null;
    }
    /** @internal */ _rebuild() {
        if (this.refreshRate === $e3e6da3d7976691f$export$ca67b0b0fa758253.REFRESHRATE_RENDER_ONCE) this.refreshRate = $e3e6da3d7976691f$export$ca67b0b0fa758253.REFRESHRATE_RENDER_ONCE;
    }
    /**
     * Clear the info related to rendering groups preventing retention point in material dispose.
     */ freeRenderingGroups() {
        if (this._renderingManager) this._renderingManager.freeRenderingGroups();
    }
}
/**
 * Objects will only be rendered once which can be useful to improve performance if everything in your render is static for instance.
 */ $e3e6da3d7976691f$export$ca67b0b0fa758253.REFRESHRATE_RENDER_ONCE = 0;
/**
 * Objects will be rendered every frame and is recommended for dynamic contents.
 */ $e3e6da3d7976691f$export$ca67b0b0fa758253.REFRESHRATE_RENDER_ONEVERYFRAME = 1;
/**
 * Objects will be rendered every 2 frames which could be enough if your dynamic objects are not
 * the central point of your effect and can save a lot of performances.
 */ $e3e6da3d7976691f$export$ca67b0b0fa758253.REFRESHRATE_RENDER_ONEVERYTWOFRAMES = 2;

});

parcelRegister("2nL19", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2nnzJ").then(()=>parcelRequire('4dKnp'));

});


parcelRegister("cFdBb", function(module, exports) {

$parcel$export(module.exports, "PostProcess", () => $9383dcc74058dbdc$export$f2e2be0a47b5edf8);

var $e0Suo = parcelRequire("e0Suo");

var $57onU = parcelRequire("57onU");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $lUDWq = parcelRequire("lUDWq");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");

var $dUFoQ = parcelRequire("dUFoQ");

var $wK2xc = parcelRequire("wK2xc");

var $iYGpr = parcelRequire("iYGpr");
(0, $dUFoQ.AbstractEngine).prototype.setTextureFromPostProcess = function(channel, postProcess, name) {
    let postProcessInput = null;
    if (postProcess) {
        if (postProcess._forcedOutputTexture) postProcessInput = postProcess._forcedOutputTexture;
        else if (postProcess._textures.data[postProcess._currentRenderTextureInd]) postProcessInput = postProcess._textures.data[postProcess._currentRenderTextureInd];
    }
    this._bindTexture(channel, postProcessInput?.texture ?? null, name);
};
(0, $dUFoQ.AbstractEngine).prototype.setTextureFromPostProcessOutput = function(channel, postProcess, name) {
    this._bindTexture(channel, postProcess?._outputTexture?.texture ?? null, name);
};
/**
 * Sets a texture to be the input of the specified post process. (To use the output, pass in the next post process in the pipeline)
 * @param channel Name of the sampler variable.
 * @param postProcess Post process to get the input texture from.
 */ (0, $lUDWq.Effect).prototype.setTextureFromPostProcess = function(channel, postProcess) {
    this._engine.setTextureFromPostProcess(this._samplers[channel], postProcess, channel);
};
/**
 * (Warning! setTextureFromPostProcessOutput may be desired instead)
 * Sets the input texture of the passed in post process to be input of this effect. (To use the output of the passed in post process use setTextureFromPostProcessOutput)
 * @param channel Name of the sampler variable.
 * @param postProcess Post process to get the output texture from.
 */ (0, $lUDWq.Effect).prototype.setTextureFromPostProcessOutput = function(channel, postProcess) {
    this._engine.setTextureFromPostProcessOutput(this._samplers[channel], postProcess, channel);
};


class $9383dcc74058dbdc$export$f2e2be0a47b5edf8 {
    /**
     * Force all the postprocesses to compile to glsl even on WebGPU engines.
     * False by default. This is mostly meant for backward compatibility.
     */ static get ForceGLSL() {
        return (0, $iYGpr.EffectWrapper).ForceGLSL;
    }
    static set ForceGLSL(force) {
        (0, $iYGpr.EffectWrapper).ForceGLSL = force;
    }
    /**
     * Registers a shader code processing with a post process name.
     * @param postProcessName name of the post process. Use null for the fallback shader code processing. This is the shader code processing that will be used in case no specific shader code processing has been associated to a post process name
     * @param customShaderCodeProcessing shader code processing to associate to the post process name
     */ static RegisterShaderCodeProcessing(postProcessName, customShaderCodeProcessing) {
        (0, $iYGpr.EffectWrapper).RegisterShaderCodeProcessing(postProcessName, customShaderCodeProcessing);
    }
    /** Name of the PostProcess. */ get name() {
        return this._effectWrapper.name;
    }
    set name(value) {
        this._effectWrapper.name = value;
    }
    /**
     * Type of alpha mode to use when performing the post process (default: Engine.ALPHA_DISABLE)
     */ get alphaMode() {
        return this._effectWrapper.alphaMode;
    }
    set alphaMode(value) {
        this._effectWrapper.alphaMode = value;
    }
    /**
     * Number of sample textures (default: 1)
     */ get samples() {
        return this._samples;
    }
    set samples(n) {
        this._samples = Math.min(n, this._engine.getCaps().maxMSAASamples);
        this._textures.forEach((texture)=>{
            texture.setSamples(this._samples);
        });
    }
    /**
     * Gets the shader language type used to generate vertex and fragment source code.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * Returns the fragment url or shader name used in the post process.
     * @returns the fragment url or name in the shader store.
     */ getEffectName() {
        return this._fragmentUrl;
    }
    /**
     * A function that is added to the onActivateObservable
     */ set onActivate(callback) {
        if (this._onActivateObserver) this.onActivateObservable.remove(this._onActivateObserver);
        if (callback) this._onActivateObserver = this.onActivateObservable.add(callback);
    }
    /**
     * A function that is added to the onSizeChangedObservable
     */ set onSizeChanged(callback) {
        if (this._onSizeChangedObserver) this.onSizeChangedObservable.remove(this._onSizeChangedObserver);
        this._onSizeChangedObserver = this.onSizeChangedObservable.add(callback);
    }
    /**
     * A function that is added to the onApplyObservable
     */ set onApply(callback) {
        if (this._onApplyObserver) this.onApplyObservable.remove(this._onApplyObserver);
        this._onApplyObserver = this.onApplyObservable.add(callback);
    }
    /**
     * A function that is added to the onBeforeRenderObservable
     */ set onBeforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /**
     * A function that is added to the onAfterRenderObservable
     */ set onAfterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /**
     * The input texture for this post process and the output texture of the previous post process. When added to a pipeline the previous post process will
     * render it's output into this texture and this texture will be used as textureSampler in the fragment shader of this post process.
     */ get inputTexture() {
        return this._textures.data[this._currentRenderTextureInd];
    }
    set inputTexture(value) {
        this._forcedOutputTexture = value;
    }
    /**
     * Since inputTexture should always be defined, if we previously manually set `inputTexture`,
     * the only way to unset it is to use this function to restore its internal state
     */ restoreDefaultInputTexture() {
        if (this._forcedOutputTexture) {
            this._forcedOutputTexture = null;
            this.markTextureDirty();
        }
    }
    /**
     * Gets the camera which post process is applied to.
     * @returns The camera the post process is applied to.
     */ getCamera() {
        return this._camera;
    }
    /**
     * Gets the texel size of the postprocess.
     * See https://en.wikipedia.org/wiki/Texel_(graphics)
     */ get texelSize() {
        if (this._shareOutputWithPostProcess) return this._shareOutputWithPostProcess.texelSize;
        if (this._forcedOutputTexture) this._texelSize.copyFromFloats(1.0 / this._forcedOutputTexture.width, 1.0 / this._forcedOutputTexture.height);
        return this._texelSize;
    }
    /** @internal */ constructor(name, fragmentUrl, parameters, samplers, _size, camera, samplingMode = 1, engine, reusable, defines = null, textureType = 0, vertexUrl = "postprocess", indexParameters, blockCompilation = false, textureFormat = 5, shaderLanguage, extraInitializations){
        /** @internal */ this._parentContainer = null;
        /**
         * Width of the texture to apply the post process on
         */ this.width = -1;
        /**
         * Height of the texture to apply the post process on
         */ this.height = -1;
        /**
         * Gets the node material used to create this postprocess (null if the postprocess was manually created)
         */ this.nodeMaterialSource = null;
        /**
         * Internal, reference to the location where this postprocess was output to. (Typically the texture on the next postprocess in the chain)
         * @internal
         */ this._outputTexture = null;
        /**
         * If the buffer needs to be cleared before applying the post process. (default: true)
         * Should be set to false if shader will overwrite all previous pixels.
         */ this.autoClear = true;
        /**
         * If clearing the buffer should be forced in autoClear mode, even when alpha mode is enabled (default: false).
         * By default, the buffer will only be cleared if alpha mode is disabled (and autoClear is true).
         */ this.forceAutoClearInAlphaMode = false;
        /**
         * Animations to be used for the post processing
         */ this.animations = [];
        /**
         * Enable Pixel Perfect mode where texture is not scaled to be power of 2.
         * Can only be used on a single postprocess or on the last one of a chain. (default: false)
         */ this.enablePixelPerfectMode = false;
        /**
         * Force the postprocess to be applied without taking in account viewport
         */ this.forceFullscreenViewport = true;
        /**
         * Scale mode for the post process (default: Engine.SCALEMODE_FLOOR)
         *
         * | Value | Type                                | Description |
         * | ----- | ----------------------------------- | ----------- |
         * | 1     | SCALEMODE_FLOOR                     | [engine.scalemode_floor](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_floor) |
         * | 2     | SCALEMODE_NEAREST                   | [engine.scalemode_nearest](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_nearest) |
         * | 3     | SCALEMODE_CEILING                   | [engine.scalemode_ceiling](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_ceiling) |
         *
         */ this.scaleMode = 1;
        /**
         * Force textures to be a power of two (default: false)
         */ this.alwaysForcePOT = false;
        this._samples = 1;
        /**
         * Modify the scale of the post process to be the same as the viewport (default: false)
         */ this.adaptScaleToCurrentViewport = false;
        this._webGPUReady = false;
        this._reusable = false;
        this._renderId = 0;
        /**
         * if externalTextureSamplerBinding is true, the "apply" method won't bind the textureSampler texture, it is expected to be done by the "outside" (by the onApplyObservable observer most probably).
         * counter-productive in some cases because if the texture bound by "apply" is different from the currently texture bound, (the one set by the onApplyObservable observer, for eg) some
         * internal structures (materialContext) will be dirtified, which may impact performances
         */ this.externalTextureSamplerBinding = false;
        /**
         * Smart array of input and output textures for the post process.
         * @internal
         */ this._textures = new (0, $57onU.SmartArray)(2);
        /**
         * Smart array of input and output textures for the post process.
         * @internal
         */ this._textureCache = [];
        /**
         * The index in _textures that corresponds to the output texture.
         * @internal
         */ this._currentRenderTextureInd = 0;
        this._scaleRatio = new (0, $ha1VO.Vector2)(1, 1);
        this._texelSize = (0, $ha1VO.Vector2).Zero();
        // Events
        /**
         * An event triggered when the postprocess is activated.
         */ this.onActivateObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the postprocess changes its size.
         */ this.onSizeChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the postprocess applies its effect.
         */ this.onApplyObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering the postprocess
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the postprocess
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        let size = 1;
        let uniformBuffers = null;
        let effectWrapper;
        if (parameters && !Array.isArray(parameters)) {
            const options = parameters;
            parameters = options.uniforms ?? null;
            samplers = options.samplers ?? null;
            size = options.size ?? 1;
            camera = options.camera ?? null;
            samplingMode = options.samplingMode ?? 1;
            engine = options.engine;
            reusable = options.reusable;
            defines = Array.isArray(options.defines) ? options.defines.join("\n") : options.defines ?? null;
            textureType = options.textureType ?? 0;
            vertexUrl = options.vertexUrl ?? "postprocess";
            indexParameters = options.indexParameters;
            blockCompilation = options.blockCompilation ?? false;
            textureFormat = options.textureFormat ?? 5;
            shaderLanguage = options.shaderLanguage ?? 0 /* ShaderLanguage.GLSL */ ;
            uniformBuffers = options.uniformBuffers ?? null;
            extraInitializations = options.extraInitializations;
            effectWrapper = options.effectWrapper;
        } else if (_size) {
            if (typeof _size === "number") size = _size;
            else size = {
                width: _size.width,
                height: _size.height
            };
        }
        const useExistingThinPostProcess = !!effectWrapper;
        this._effectWrapper = effectWrapper ?? new (0, $iYGpr.EffectWrapper)({
            name: name,
            useShaderStore: true,
            useAsPostProcess: true,
            fragmentShader: fragmentUrl,
            engine: engine || camera?.getScene().getEngine(),
            uniforms: parameters,
            samplers: samplers,
            uniformBuffers: uniformBuffers,
            defines: defines,
            vertexUrl: vertexUrl,
            indexParameters: indexParameters,
            blockCompilation: true,
            shaderLanguage: shaderLanguage,
            extraInitializations: undefined
        });
        this.name = name;
        this.onEffectCreatedObservable = this._effectWrapper.onEffectCreatedObservable;
        if (camera != null) {
            this._camera = camera;
            this._scene = camera.getScene();
            camera.attachPostProcess(this);
            this._engine = this._scene.getEngine();
            this._scene.postProcesses.push(this);
            this.uniqueId = this._scene.getUniqueId();
        } else if (engine) {
            this._engine = engine;
            this._engine.postProcesses.push(this);
        }
        this._options = size;
        this.renderTargetSamplingMode = samplingMode ? samplingMode : 1;
        this._reusable = reusable || false;
        this._textureType = textureType;
        this._textureFormat = textureFormat;
        this._shaderLanguage = shaderLanguage || 0 /* ShaderLanguage.GLSL */ ;
        this._samplers = samplers || [];
        if (this._samplers.indexOf("textureSampler") === -1) this._samplers.push("textureSampler");
        this._fragmentUrl = fragmentUrl;
        this._vertexUrl = vertexUrl;
        this._parameters = parameters || [];
        if (this._parameters.indexOf("scale") === -1) this._parameters.push("scale");
        this._uniformBuffers = uniformBuffers || [];
        this._indexParameters = indexParameters;
        if (!useExistingThinPostProcess) {
            this._webGPUReady = this._shaderLanguage === 1 /* ShaderLanguage.WGSL */ ;
            const importPromises = [];
            this._gatherImports(this._engine.isWebGPU && !$9383dcc74058dbdc$export$f2e2be0a47b5edf8.ForceGLSL, importPromises);
            this._effectWrapper._webGPUReady = this._webGPUReady;
            this._effectWrapper._postConstructor(blockCompilation, defines, extraInitializations, importPromises);
        }
    }
    _gatherImports(useWebGPU = false, list) {
        // this._webGPUReady is used to detect when a postprocess is intended to be used with WebGPU
        if (useWebGPU && this._webGPUReady) list.push(Promise.all([
            (parcelRequire("4RfZ4"))
        ]));
        else list.push(Promise.all([
            Promise.resolve((parcelRequire("cr88r")))
        ]));
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "PostProcess" string
     */ getClassName() {
        return "PostProcess";
    }
    /**
     * Gets the engine which this post process belongs to.
     * @returns The engine the post process was enabled with.
     */ getEngine() {
        return this._engine;
    }
    /**
     * The effect that is created when initializing the post process.
     * @returns The created effect corresponding to the postprocess.
     */ getEffect() {
        return this._effectWrapper.drawWrapper.effect;
    }
    /**
     * To avoid multiple redundant textures for multiple post process, the output the output texture for this post process can be shared with another.
     * @param postProcess The post process to share the output with.
     * @returns This post process.
     */ shareOutputWith(postProcess) {
        this._disposeTextures();
        this._shareOutputWithPostProcess = postProcess;
        return this;
    }
    /**
     * Reverses the effect of calling shareOutputWith and returns the post process back to its original state.
     * This should be called if the post process that shares output with this post process is disabled/disposed.
     */ useOwnOutput() {
        if (this._textures.length == 0) this._textures = new (0, $57onU.SmartArray)(2);
        this._shareOutputWithPostProcess = null;
    }
    /**
     * Updates the effect with the current post process compile time values and recompiles the shader.
     * @param defines Define statements that should be added at the beginning of the shader. (default: null)
     * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
     * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
     * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
     * @param onCompiled Called when the shader has been compiled.
     * @param onError Called if there is an error when compiling a shader.
     * @param vertexUrl The url of the vertex shader to be used (default: the one given at construction time)
     * @param fragmentUrl The url of the fragment shader to be used (default: the one given at construction time)
     */ updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError, vertexUrl, fragmentUrl) {
        this._effectWrapper.updateEffect(defines, uniforms, samplers, indexParameters, onCompiled, onError, vertexUrl, fragmentUrl);
        this._postProcessDefines = Array.isArray(this._effectWrapper.options.defines) ? this._effectWrapper.options.defines.join("\n") : this._effectWrapper.options.defines;
    }
    /**
     * The post process is reusable if it can be used multiple times within one frame.
     * @returns If the post process is reusable
     */ isReusable() {
        return this._reusable;
    }
    /** invalidate frameBuffer to hint the postprocess to create a depth buffer */ markTextureDirty() {
        this.width = -1;
    }
    _createRenderTargetTexture(textureSize, textureOptions, channel = 0) {
        for(let i = 0; i < this._textureCache.length; i++){
            if (this._textureCache[i].texture.width === textureSize.width && this._textureCache[i].texture.height === textureSize.height && this._textureCache[i].postProcessChannel === channel && this._textureCache[i].texture._generateDepthBuffer === textureOptions.generateDepthBuffer && this._textureCache[i].texture.samples === textureOptions.samples) return this._textureCache[i].texture;
        }
        const tex = this._engine.createRenderTargetTexture(textureSize, textureOptions);
        this._textureCache.push({
            texture: tex,
            postProcessChannel: channel,
            lastUsedRenderId: -1
        });
        return tex;
    }
    _flushTextureCache() {
        const currentRenderId = this._renderId;
        for(let i = this._textureCache.length - 1; i >= 0; i--)if (currentRenderId - this._textureCache[i].lastUsedRenderId > 100) {
            let currentlyUsed = false;
            for(let j = 0; j < this._textures.length; j++)if (this._textures.data[j] === this._textureCache[i].texture) {
                currentlyUsed = true;
                break;
            }
            if (!currentlyUsed) {
                this._textureCache[i].texture.dispose();
                this._textureCache.splice(i, 1);
            }
        }
    }
    /**
     * Resizes the post-process texture
     * @param width Width of the texture
     * @param height Height of the texture
     * @param camera The camera this post-process is applied to. Pass null if the post-process is used outside the context of a camera post-process chain (default: null)
     * @param needMipMaps True if mip maps need to be generated after render (default: false)
     * @param forceDepthStencil True to force post-process texture creation with stencil depth and buffer (default: false)
     */ resize(width, height, camera = null, needMipMaps = false, forceDepthStencil = false) {
        if (this._textures.length > 0) this._textures.reset();
        this.width = width;
        this.height = height;
        let firstPP = null;
        if (camera) {
            for(let i = 0; i < camera._postProcesses.length; i++)if (camera._postProcesses[i] !== null) {
                firstPP = camera._postProcesses[i];
                break;
            }
        }
        const textureSize = {
            width: this.width,
            height: this.height
        };
        const textureOptions = {
            generateMipMaps: needMipMaps,
            generateDepthBuffer: forceDepthStencil || firstPP === this,
            generateStencilBuffer: (forceDepthStencil || firstPP === this) && this._engine.isStencilEnable,
            samplingMode: this.renderTargetSamplingMode,
            type: this._textureType,
            format: this._textureFormat,
            samples: this._samples,
            label: "PostProcessRTT-" + this.name
        };
        this._textures.push(this._createRenderTargetTexture(textureSize, textureOptions, 0));
        if (this._reusable) this._textures.push(this._createRenderTargetTexture(textureSize, textureOptions, 1));
        this._texelSize.copyFromFloats(1.0 / this.width, 1.0 / this.height);
        this.onSizeChangedObservable.notifyObservers(this);
    }
    _getTarget() {
        let target;
        if (this._shareOutputWithPostProcess) target = this._shareOutputWithPostProcess.inputTexture;
        else if (this._forcedOutputTexture) {
            target = this._forcedOutputTexture;
            this.width = this._forcedOutputTexture.width;
            this.height = this._forcedOutputTexture.height;
        } else {
            target = this.inputTexture;
            let cache;
            for(let i = 0; i < this._textureCache.length; i++)if (this._textureCache[i].texture === target) {
                cache = this._textureCache[i];
                break;
            }
            if (cache) cache.lastUsedRenderId = this._renderId;
        }
        return target;
    }
    /**
     * Activates the post process by intializing the textures to be used when executed. Notifies onActivateObservable.
     * When this post process is used in a pipeline, this is call will bind the input texture of this post process to the output of the previous.
     * @param cameraOrScene The camera that will be used in the post process. This camera will be used when calling onActivateObservable. You can also pass the scene if no camera is available.
     * @param sourceTexture The source texture to be inspected to get the width and height if not specified in the post process constructor. (default: null)
     * @param forceDepthStencil If true, a depth and stencil buffer will be generated. (default: false)
     * @returns The render target wrapper that was bound to be written to.
     */ activate(cameraOrScene, sourceTexture = null, forceDepthStencil) {
        const camera = cameraOrScene === null || cameraOrScene.cameraRigMode !== undefined ? cameraOrScene || this._camera : null;
        const scene = camera?.getScene() ?? cameraOrScene;
        const engine = scene.getEngine();
        const maxSize = engine.getCaps().maxTextureSize;
        const requiredWidth = (sourceTexture ? sourceTexture.width : this._engine.getRenderWidth(true)) * this._options | 0;
        const requiredHeight = (sourceTexture ? sourceTexture.height : this._engine.getRenderHeight(true)) * this._options | 0;
        let desiredWidth = this._options.width || requiredWidth;
        let desiredHeight = this._options.height || requiredHeight;
        const needMipMaps = this.renderTargetSamplingMode !== 7 && this.renderTargetSamplingMode !== 1 && this.renderTargetSamplingMode !== 2;
        let target = null;
        if (!this._shareOutputWithPostProcess && !this._forcedOutputTexture) {
            if (this.adaptScaleToCurrentViewport) {
                const currentViewport = engine.currentViewport;
                if (currentViewport) {
                    desiredWidth *= currentViewport.width;
                    desiredHeight *= currentViewport.height;
                }
            }
            if (needMipMaps || this.alwaysForcePOT) {
                if (!this._options.width) desiredWidth = engine.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(desiredWidth, maxSize, this.scaleMode) : desiredWidth;
                if (!this._options.height) desiredHeight = engine.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(desiredHeight, maxSize, this.scaleMode) : desiredHeight;
            }
            if (this.width !== desiredWidth || this.height !== desiredHeight || !(target = this._getTarget())) this.resize(desiredWidth, desiredHeight, camera, needMipMaps, forceDepthStencil);
            this._textures.forEach((texture)=>{
                if (texture.samples !== this.samples) this._engine.updateRenderTargetTextureSampleCount(texture, this.samples);
            });
            this._flushTextureCache();
            this._renderId++;
        }
        if (!target) target = this._getTarget();
        // Bind the input of this post process to be used as the output of the previous post process.
        if (this.enablePixelPerfectMode) {
            this._scaleRatio.copyFromFloats(requiredWidth / desiredWidth, requiredHeight / desiredHeight);
            this._engine.bindFramebuffer(target, 0, requiredWidth, requiredHeight, this.forceFullscreenViewport);
        } else {
            this._scaleRatio.copyFromFloats(1, 1);
            this._engine.bindFramebuffer(target, 0, undefined, undefined, this.forceFullscreenViewport);
        }
        this._engine._debugInsertMarker?.(`post process ${this.name} input`);
        this.onActivateObservable.notifyObservers(camera);
        // Clear
        if (this.autoClear && (this.alphaMode === 0 || this.forceAutoClearInAlphaMode)) this._engine.clear(this.clearColor ? this.clearColor : scene.clearColor, scene._allowPostProcessClearColor, true, true);
        if (this._reusable) this._currentRenderTextureInd = (this._currentRenderTextureInd + 1) % 2;
        return target;
    }
    /**
     * If the post process is supported.
     */ get isSupported() {
        return this._effectWrapper.drawWrapper.effect.isSupported;
    }
    /**
     * The aspect ratio of the output texture.
     */ get aspectRatio() {
        if (this._shareOutputWithPostProcess) return this._shareOutputWithPostProcess.aspectRatio;
        if (this._forcedOutputTexture) return this._forcedOutputTexture.width / this._forcedOutputTexture.height;
        return this.width / this.height;
    }
    /**
     * Get a value indicating if the post-process is ready to be used
     * @returns true if the post-process is ready (shader is compiled)
     */ isReady() {
        return this._effectWrapper.isReady();
    }
    /**
     * Binds all textures and uniforms to the shader, this will be run on every pass.
     * @returns the effect corresponding to this post process. Null if not compiled or not ready.
     */ apply() {
        // Check
        if (!this._effectWrapper.isReady()) return null;
        // States
        this._engine.enableEffect(this._effectWrapper.drawWrapper);
        this._engine.setState(false);
        this._engine.setDepthBuffer(false);
        this._engine.setDepthWrite(false);
        // Alpha
        if (this.alphaConstants) this.getEngine().setAlphaConstants(this.alphaConstants.r, this.alphaConstants.g, this.alphaConstants.b, this.alphaConstants.a);
        // Bind the output texture of the preivous post process as the input to this post process.
        let source;
        if (this._shareOutputWithPostProcess) source = this._shareOutputWithPostProcess.inputTexture;
        else if (this._forcedOutputTexture) source = this._forcedOutputTexture;
        else source = this.inputTexture;
        if (!this.externalTextureSamplerBinding) this._effectWrapper.drawWrapper.effect._bindTexture("textureSampler", source?.texture);
        // Parameters
        this._effectWrapper.drawWrapper.effect.setVector2("scale", this._scaleRatio);
        this.onApplyObservable.notifyObservers(this._effectWrapper.drawWrapper.effect);
        this._effectWrapper.bind();
        return this._effectWrapper.drawWrapper.effect;
    }
    _disposeTextures() {
        if (this._shareOutputWithPostProcess || this._forcedOutputTexture) {
            this._disposeTextureCache();
            return;
        }
        this._disposeTextureCache();
        this._textures.dispose();
    }
    _disposeTextureCache() {
        for(let i = this._textureCache.length - 1; i >= 0; i--)this._textureCache[i].texture.dispose();
        this._textureCache.length = 0;
    }
    /**
     * Sets the required values to the prepass renderer.
     * @param prePassRenderer defines the prepass renderer to setup.
     * @returns true if the pre pass is needed.
     */ setPrePassRenderer(prePassRenderer) {
        if (this._prePassEffectConfiguration) {
            this._prePassEffectConfiguration = prePassRenderer.addEffectConfiguration(this._prePassEffectConfiguration);
            this._prePassEffectConfiguration.enabled = true;
            return true;
        }
        return false;
    }
    /**
     * Disposes the post process.
     * @param camera The camera to dispose the post process on.
     */ dispose(camera) {
        camera = camera || this._camera;
        this._disposeTextures();
        let index;
        if (this._scene) {
            index = this._scene.postProcesses.indexOf(this);
            if (index !== -1) this._scene.postProcesses.splice(index, 1);
        }
        if (this._parentContainer) {
            const index = this._parentContainer.postProcesses.indexOf(this);
            if (index > -1) this._parentContainer.postProcesses.splice(index, 1);
            this._parentContainer = null;
        }
        index = this._engine.postProcesses.indexOf(this);
        if (index !== -1) this._engine.postProcesses.splice(index, 1);
        if (!camera) return;
        camera.detachPostProcess(this);
        index = camera._postProcesses.indexOf(this);
        if (index === 0 && camera._postProcesses.length > 0) {
            const firstPostProcess = this._camera._getFirstPostProcess();
            if (firstPostProcess) firstPostProcess.markTextureDirty();
        }
        this.onActivateObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onApplyObservable.clear();
        this.onBeforeRenderObservable.clear();
        this.onSizeChangedObservable.clear();
        this.onEffectCreatedObservable.clear();
    }
    /**
     * Serializes the post process to a JSON object
     * @returns the JSON object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        const camera = this.getCamera() || this._scene && this._scene.activeCamera;
        serializationObject.customType = "BABYLON." + this.getClassName();
        serializationObject.cameraId = camera ? camera.id : null;
        serializationObject.reusable = this._reusable;
        serializationObject.textureType = this._textureType;
        serializationObject.fragmentUrl = this._fragmentUrl;
        serializationObject.parameters = this._parameters;
        serializationObject.samplers = this._samplers;
        serializationObject.uniformBuffers = this._uniformBuffers;
        serializationObject.options = this._options;
        serializationObject.defines = this._postProcessDefines;
        serializationObject.textureFormat = this._textureFormat;
        serializationObject.vertexUrl = this._vertexUrl;
        serializationObject.indexParameters = this._indexParameters;
        return serializationObject;
    }
    /**
     * Clones this post process
     * @returns a new post process similar to this one
     */ clone() {
        const serializationObject = this.serialize();
        serializationObject._engine = this._engine;
        serializationObject.cameraId = null;
        const result = $9383dcc74058dbdc$export$f2e2be0a47b5edf8.Parse(serializationObject, this._scene, "");
        if (!result) return null;
        result.onActivateObservable = this.onActivateObservable.clone();
        result.onSizeChangedObservable = this.onSizeChangedObservable.clone();
        result.onApplyObservable = this.onApplyObservable.clone();
        result.onBeforeRenderObservable = this.onBeforeRenderObservable.clone();
        result.onAfterRenderObservable = this.onAfterRenderObservable.clone();
        result._prePassEffectConfiguration = this._prePassEffectConfiguration;
        return result;
    }
    /**
     * Creates a material from parsed material data
     * @param parsedPostProcess defines parsed post process data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures
     * @returns a new post process
     */ static Parse(parsedPostProcess, scene, rootUrl) {
        const postProcessType = (0, $8DoUR.GetClass)(parsedPostProcess.customType);
        if (!postProcessType || !postProcessType._Parse) return null;
        const camera = scene ? scene.getCameraById(parsedPostProcess.cameraId) : null;
        return postProcessType._Parse(parsedPostProcess, camera, scene, rootUrl);
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $9383dcc74058dbdc$export$f2e2be0a47b5edf8(parsedPostProcess.name, parsedPostProcess.fragmentUrl, parsedPostProcess.parameters, parsedPostProcess.samplers, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable, parsedPostProcess.defines, parsedPostProcess.textureType, parsedPostProcess.vertexUrl, parsedPostProcess.indexParameters, false, parsedPostProcess.textureFormat);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "name", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "width", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "height", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "renderTargetSamplingMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor4)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "clearColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "autoClear", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "forceAutoClearInAlphaMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "alphaMode", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "alphaConstants", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "enablePixelPerfectMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "forceFullscreenViewport", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "scaleMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "alwaysForcePOT", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("samples")
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "_samples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "adaptScaleToCurrentViewport", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PostProcess", $9383dcc74058dbdc$export$f2e2be0a47b5edf8);

});
parcelRegister("iYGpr", function(module, exports) {

$parcel$export(module.exports, "EffectRenderer", () => $dd0eba39da5b41c9$export$68f948415c5722f2);
$parcel$export(module.exports, "EffectWrapper", () => $dd0eba39da5b41c9$export$b901a4b52520d353);

var $b4i1f = parcelRequire("b4i1f");

var $191mA = parcelRequire("191mA");

var $diGQf = parcelRequire("diGQf");

var $lUDWq = parcelRequire("lUDWq");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("cr88r");
// Fullscreen quad buffers by default.
const $dd0eba39da5b41c9$var$defaultOptions = {
    positions: [
        1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        -1
    ],
    indices: [
        0,
        1,
        2,
        0,
        2,
        3
    ]
};
class $dd0eba39da5b41c9$export$68f948415c5722f2 {
    /**
     * Creates an effect renderer
     * @param engine the engine to use for rendering
     * @param options defines the options of the effect renderer
     */ constructor(engine, options = $dd0eba39da5b41c9$var$defaultOptions){
        this._fullscreenViewport = new (0, $191mA.Viewport)(0, 0, 1, 1);
        const positions = options.positions ?? $dd0eba39da5b41c9$var$defaultOptions.positions;
        const indices = options.indices ?? $dd0eba39da5b41c9$var$defaultOptions.indices;
        this.engine = engine;
        this._vertexBuffers = {
            [(0, $b4i1f.VertexBuffer).PositionKind]: new (0, $b4i1f.VertexBuffer)(engine, positions, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2)
        };
        this._indexBuffer = engine.createIndexBuffer(indices);
        this._onContextRestoredObserver = engine.onContextRestoredObservable.add(()=>{
            this._indexBuffer = engine.createIndexBuffer(indices);
            for(const key in this._vertexBuffers){
                const vertexBuffer = this._vertexBuffers[key];
                vertexBuffer._rebuild();
            }
        });
    }
    /**
     * Sets the current viewport in normalized coordinates 0-1
     * @param viewport Defines the viewport to set (defaults to 0 0 1 1)
     */ setViewport(viewport = this._fullscreenViewport) {
        this.engine.setViewport(viewport);
    }
    /**
     * Binds the embedded attributes buffer to the effect.
     * @param effect Defines the effect to bind the attributes for
     */ bindBuffers(effect) {
        this.engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
    }
    /**
     * Sets the current effect wrapper to use during draw.
     * The effect needs to be ready before calling this api.
     * This also sets the default full screen position attribute.
     * @param effectWrapper Defines the effect to draw with
     */ applyEffectWrapper(effectWrapper) {
        this.engine.setState(true);
        this.engine.depthCullingState.depthTest = false;
        this.engine.stencilState.stencilTest = false;
        this.engine.enableEffect(effectWrapper.drawWrapper);
        this.bindBuffers(effectWrapper.effect);
        effectWrapper.onApplyObservable.notifyObservers({});
    }
    /**
     * Saves engine states
     */ saveStates() {
        this._savedStateDepthTest = this.engine.depthCullingState.depthTest;
        this._savedStateStencilTest = this.engine.stencilState.stencilTest;
    }
    /**
     * Restores engine states
     */ restoreStates() {
        this.engine.depthCullingState.depthTest = this._savedStateDepthTest;
        this.engine.stencilState.stencilTest = this._savedStateStencilTest;
    }
    /**
     * Draws a full screen quad.
     */ draw() {
        this.engine.drawElementsType(0, 0, 6);
    }
    _isRenderTargetTexture(texture) {
        return texture.renderTarget !== undefined;
    }
    /**
     * renders one or more effects to a specified texture
     * @param effectWrapper the effect to renderer
     * @param outputTexture texture to draw to, if null it will render to the currently bound frame buffer
     */ render(effectWrapper, outputTexture = null) {
        // Ensure effect is ready
        if (!effectWrapper.effect.isReady()) return;
        this.saveStates();
        // Reset state
        this.setViewport();
        const out = outputTexture === null ? null : this._isRenderTargetTexture(outputTexture) ? outputTexture.renderTarget : outputTexture;
        if (out) this.engine.bindFramebuffer(out);
        this.applyEffectWrapper(effectWrapper);
        this.draw();
        if (out) this.engine.unBindFramebuffer(out);
        this.restoreStates();
    }
    /**
     * Disposes of the effect renderer
     */ dispose() {
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            delete this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        }
        if (this._indexBuffer) this.engine._releaseBuffer(this._indexBuffer);
        if (this._onContextRestoredObserver) {
            this.engine.onContextRestoredObservable.remove(this._onContextRestoredObserver);
            this._onContextRestoredObserver = null;
        }
    }
}


class $dd0eba39da5b41c9$export$b901a4b52520d353 {
    /**
     * Registers a shader code processing with an effect wrapper name.
     * @param effectWrapperName name of the effect wrapper. Use null for the fallback shader code processing. This is the shader code processing that will be used in case no specific shader code processing has been associated to an effect wrapper name
     * @param customShaderCodeProcessing shader code processing to associate to the effect wrapper name
     */ static RegisterShaderCodeProcessing(effectWrapperName, customShaderCodeProcessing) {
        if (!customShaderCodeProcessing) {
            delete $dd0eba39da5b41c9$export$b901a4b52520d353._CustomShaderCodeProcessing[effectWrapperName ?? ""];
            return;
        }
        $dd0eba39da5b41c9$export$b901a4b52520d353._CustomShaderCodeProcessing[effectWrapperName ?? ""] = customShaderCodeProcessing;
    }
    static _GetShaderCodeProcessing(effectWrapperName) {
        return $dd0eba39da5b41c9$export$b901a4b52520d353._CustomShaderCodeProcessing[effectWrapperName] ?? $dd0eba39da5b41c9$export$b901a4b52520d353._CustomShaderCodeProcessing[""];
    }
    /**
     * Gets or sets the name of the effect wrapper
     */ get name() {
        return this.options.name;
    }
    set name(value) {
        this.options.name = value;
    }
    /**
     * Get a value indicating if the effect is ready to be used
     * @returns true if the post-process is ready (shader is compiled)
     */ isReady() {
        return this._drawWrapper.effect?.isReady() ?? false;
    }
    /**
     * Get the draw wrapper associated with the effect wrapper
     * @returns the draw wrapper associated with the effect wrapper
     */ get drawWrapper() {
        return this._drawWrapper;
    }
    /**
     * The underlying effect
     */ get effect() {
        return this._drawWrapper.effect;
    }
    set effect(effect) {
        this._drawWrapper.effect = effect;
    }
    /**
     * Creates an effect to be rendered
     * @param creationOptions options to create the effect
     */ constructor(creationOptions){
        /**
         * Type of alpha mode to use when applying the effect (default: Engine.ALPHA_DISABLE). Used only if useAsPostProcess is true.
         */ this.alphaMode = 0;
        /**
         * Executed when the effect is created
         * @returns effect that was created for this effect wrapper
         */ this.onEffectCreatedObservable = new (0, $diGQf.Observable)(undefined, true);
        /**
         * Event that is fired (only when the EffectWrapper is used with an EffectRenderer) right before the effect is drawn (should be used to update uniforms)
         */ this.onApplyObservable = new (0, $diGQf.Observable)();
        this._shadersLoaded = false;
        /** @internal */ this._webGPUReady = false;
        this._importPromises = [];
        this.options = {
            ...creationOptions,
            name: creationOptions.name || "effectWrapper",
            engine: creationOptions.engine,
            uniforms: creationOptions.uniforms || creationOptions.uniformNames || [],
            uniformNames: undefined,
            samplers: creationOptions.samplers || creationOptions.samplerNames || [],
            samplerNames: undefined,
            attributeNames: creationOptions.attributeNames || [
                "position"
            ],
            uniformBuffers: creationOptions.uniformBuffers || [],
            defines: creationOptions.defines || "",
            useShaderStore: creationOptions.useShaderStore || false,
            vertexUrl: creationOptions.vertexUrl || creationOptions.vertexShader || "postprocess",
            vertexShader: undefined,
            fragmentShader: creationOptions.fragmentShader || "pass",
            indexParameters: creationOptions.indexParameters,
            blockCompilation: creationOptions.blockCompilation || false,
            shaderLanguage: creationOptions.shaderLanguage || 0 /* ShaderLanguage.GLSL */ ,
            onCompiled: creationOptions.onCompiled || undefined,
            extraInitializations: creationOptions.extraInitializations || undefined,
            extraInitializationsAsync: creationOptions.extraInitializationsAsync || undefined,
            useAsPostProcess: creationOptions.useAsPostProcess ?? false
        };
        this.options.uniformNames = this.options.uniforms;
        this.options.samplerNames = this.options.samplers;
        this.options.vertexShader = this.options.vertexUrl;
        if (this.options.useAsPostProcess) {
            if (this.options.samplers.indexOf("textureSampler") === -1) this.options.samplers.push("textureSampler");
            if (this.options.uniforms.indexOf("scale") === -1) this.options.uniforms.push("scale");
        }
        if (creationOptions.vertexUrl || creationOptions.vertexShader) this._shaderPath = {
            vertexSource: this.options.vertexShader
        };
        else {
            if (!this.options.useAsPostProcess) {
                this.options.uniforms.push("scale");
                this.onApplyObservable.add(()=>{
                    this.effect.setFloat2("scale", 1, 1);
                });
            }
            this._shaderPath = {
                vertex: this.options.vertexShader
            };
        }
        this._shaderPath.fragmentSource = this.options.fragmentShader;
        this._shaderPath.spectorName = this.options.name;
        if (this.options.useShaderStore) {
            this._shaderPath.fragment = this._shaderPath.fragmentSource;
            if (!this._shaderPath.vertex) this._shaderPath.vertex = this._shaderPath.vertexSource;
            delete this._shaderPath.fragmentSource;
            delete this._shaderPath.vertexSource;
        }
        this.onApplyObservable.add(()=>{
            this.bind();
        });
        if (!this.options.useShaderStore) this._onContextRestoredObserver = this.options.engine.onContextRestoredObservable.add(()=>{
            this.effect._pipelineContext = null; // because _prepareEffect will try to dispose this pipeline before recreating it and that would lead to webgl errors
            this.effect._prepareEffect();
        });
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(this.options.engine);
        this._webGPUReady = this.options.shaderLanguage === 1 /* ShaderLanguage.WGSL */ ;
        const defines = Array.isArray(this.options.defines) ? this.options.defines.join("\n") : this.options.defines;
        this._postConstructor(this.options.blockCompilation, defines, this.options.extraInitializations);
    }
    _gatherImports(useWebGPU = false, list) {
        if (!this.options.useAsPostProcess) return;
        // this._webGPUReady is used to detect when an effect wrapper is intended to be used with WebGPU
        if (useWebGPU && this._webGPUReady) list.push(Promise.all([
            (parcelRequire("4RfZ4"))
        ]));
        else list.push(Promise.all([
            Promise.resolve((parcelRequire("cr88r")))
        ]));
    }
    /** @internal */ _postConstructor(blockCompilation, defines = null, extraInitializations, importPromises) {
        this._importPromises.length = 0;
        if (importPromises) this._importPromises.push(...importPromises);
        const useWebGPU = this.options.engine.isWebGPU && !$dd0eba39da5b41c9$export$b901a4b52520d353.ForceGLSL;
        this._gatherImports(useWebGPU, this._importPromises);
        if (extraInitializations !== undefined) extraInitializations(useWebGPU, this._importPromises);
        if (useWebGPU && this._webGPUReady) this.options.shaderLanguage = 1 /* ShaderLanguage.WGSL */ ;
        if (!blockCompilation) this.updateEffect(defines);
    }
    /**
     * Updates the effect with the current effect wrapper compile time values and recompiles the shader.
     * @param defines Define statements that should be added at the beginning of the shader. (default: null)
     * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
     * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
     * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
     * @param onCompiled Called when the shader has been compiled.
     * @param onError Called if there is an error when compiling a shader.
     * @param vertexUrl The url of the vertex shader to be used (default: the one given at construction time)
     * @param fragmentUrl The url of the fragment shader to be used (default: the one given at construction time)
     */ updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError, vertexUrl, fragmentUrl) {
        const customShaderCodeProcessing = $dd0eba39da5b41c9$export$b901a4b52520d353._GetShaderCodeProcessing(this.name);
        if (customShaderCodeProcessing?.defineCustomBindings) {
            const newUniforms = uniforms?.slice() ?? [];
            newUniforms.push(...this.options.uniforms);
            const newSamplers = samplers?.slice() ?? [];
            newSamplers.push(...this.options.samplers);
            defines = customShaderCodeProcessing.defineCustomBindings(this.name, defines, newUniforms, newSamplers);
            uniforms = newUniforms;
            samplers = newSamplers;
        }
        this.options.defines = defines || "";
        const waitImportsLoaded = this._shadersLoaded || this._importPromises.length === 0 ? undefined : async ()=>{
            await Promise.all(this._importPromises);
            this._shadersLoaded = true;
        };
        let extraInitializationsAsync;
        if (this.options.extraInitializationsAsync) extraInitializationsAsync = async ()=>{
            waitImportsLoaded?.();
            await this.options.extraInitializationsAsync;
        };
        else extraInitializationsAsync = waitImportsLoaded;
        if (this.options.useShaderStore) this._drawWrapper.effect = this.options.engine.createEffect({
            vertex: vertexUrl ?? this._shaderPath.vertex,
            fragment: fragmentUrl ?? this._shaderPath.fragment
        }, {
            attributes: this.options.attributeNames,
            uniformsNames: uniforms || this.options.uniforms,
            uniformBuffersNames: this.options.uniformBuffers,
            samplers: samplers || this.options.samplers,
            defines: defines !== null ? defines : "",
            fallbacks: null,
            onCompiled: onCompiled ?? this.options.onCompiled,
            onError: onError ?? null,
            indexParameters: indexParameters || this.options.indexParameters,
            processCodeAfterIncludes: customShaderCodeProcessing?.processCodeAfterIncludes ? (shaderType, code)=>customShaderCodeProcessing.processCodeAfterIncludes(this.name, shaderType, code) : null,
            processFinalCode: customShaderCodeProcessing?.processFinalCode ? (shaderType, code)=>customShaderCodeProcessing.processFinalCode(this.name, shaderType, code) : null,
            shaderLanguage: this.options.shaderLanguage,
            extraInitializationsAsync: extraInitializationsAsync
        }, this.options.engine);
        else this._drawWrapper.effect = new (0, $lUDWq.Effect)(this._shaderPath, this.options.attributeNames, uniforms || this.options.uniforms, samplers || this.options.samplerNames, this.options.engine, defines, undefined, onCompiled || this.options.onCompiled, undefined, undefined, undefined, this.options.shaderLanguage, extraInitializationsAsync);
        this.onEffectCreatedObservable.notifyObservers(this._drawWrapper.effect);
    }
    /**
     * Binds the data to the effect.
     */ bind() {
        if (this.options.useAsPostProcess) {
            this.options.engine.setAlphaMode(this.alphaMode);
            this.drawWrapper.effect.setFloat2("scale", 1, 1);
        }
        $dd0eba39da5b41c9$export$b901a4b52520d353._GetShaderCodeProcessing(this.name)?.bindCustomBindings?.(this.name, this._drawWrapper.effect);
    }
    /**
     * Disposes of the effect wrapper
     * @param _ignored kept for backward compatibility
     */ dispose(_ignored = false) {
        if (this._onContextRestoredObserver) {
            this.effect.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
            this._onContextRestoredObserver = null;
        }
        this.onEffectCreatedObservable.clear();
        this._drawWrapper.dispose(true);
    }
}
/**
 * Force code to compile to glsl even on WebGPU engines.
 * False by default. This is mostly meant for backward compatibility.
 */ $dd0eba39da5b41c9$export$b901a4b52520d353.ForceGLSL = false;
$dd0eba39da5b41c9$export$b901a4b52520d353._CustomShaderCodeProcessing = {};

});
parcelRegister("hOyoX", function(module, exports) {

$parcel$export(module.exports, "DrawWrapper", () => $cf81ca9f655ca25e$export$76dd59d923282679);

var $av6Bc = parcelRequire("av6Bc");
class $cf81ca9f655ca25e$export$76dd59d923282679 {
    static GetEffect(effect) {
        return effect.getPipelineContext === undefined ? effect.effect : effect;
    }
    constructor(engine, createMaterialContext = true){
        /**
         * @internal
         * Specifies if the effect was previously ready
         */ this._wasPreviouslyReady = false;
        /**
         * @internal
         * Forces the code from bindForSubMesh to be fully run the next time it is called
         */ this._forceRebindOnNextCall = true;
        /**
         * @internal
         * Specifies if the effect was previously using instances
         */ this._wasPreviouslyUsingInstances = null;
        this.effect = null;
        this.defines = null;
        this.drawContext = engine.createDrawContext();
        if (createMaterialContext) this.materialContext = engine.createMaterialContext();
    }
    setEffect(effect, defines, resetContext = true) {
        this.effect = effect;
        if (defines !== undefined) this.defines = defines;
        if (resetContext) this.drawContext?.reset();
    }
    /**
     * Dispose the effect wrapper and its resources
     * @param immediate if the effect should be disposed immediately or on the next frame.
     * If dispose() is not called during a scene or engine dispose, we want to delay the dispose of the underlying effect. Mostly to give a chance to user code to reuse the effect in some way.
     */ dispose(immediate = false) {
        if (this.effect) {
            const effect = this.effect;
            if (immediate) effect.dispose();
            else (0, $av6Bc.TimingTools).SetImmediate(()=>{
                effect.getEngine().onEndFrameObservable.addOnce(()=>{
                    effect.dispose();
                });
            });
            this.effect = null;
        }
        this.drawContext?.dispose();
    }
}

});

parcelRegister("cr88r", function(module, exports) {

$parcel$export(module.exports, "postprocessVertexShader", () => $90de512353ac9a9d$export$5141e57baab30e29);
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $90de512353ac9a9d$var$name = "postprocessVertexShader";
const $90de512353ac9a9d$var$shader = `attribute vec2 position;uniform vec2 scale;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=(position*madd+madd)*scale;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$90de512353ac9a9d$var$name] = $90de512353ac9a9d$var$shader;
const $90de512353ac9a9d$export$5141e57baab30e29 = {
    name: $90de512353ac9a9d$var$name,
    shader: $90de512353ac9a9d$var$shader
};

});

parcelRegister("4RfZ4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("9strh").then(()=>parcelRequire('4z1y7'));

});



parcelRegister("jXgiT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3e1iM").then(()=>parcelRequire('4dtvf'));

});

parcelRegister("8ryEv", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ePVtm").then(()=>parcelRequire('7QfgW'));

});

parcelRegister("Squjx", function(module, exports) {

$parcel$export(module.exports, "geometryPixelShader", () => $0a3997369d1d99f4$export$d97d9a5440f7474e);
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("cblTU");
parcelRequire("lnIOB");
parcelRequire("2KL02");
parcelRequire("7Hs3g");
parcelRequire("kg1CD");
parcelRequire("F4hvB");
const $0a3997369d1d99f4$var$name = "geometryPixelShader";
const $0a3997369d1d99f4$var$shader = `#extension GL_EXT_draw_buffers : require
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
precision highp float;
#ifdef BUMP
varying mat4 vWorldView;varying vec3 vNormalW;
#else
varying vec3 vNormalV;
#endif
varying vec4 vViewPos;
#if defined(POSITION) || defined(BUMP)
varying vec3 vPositionW;
#endif
#if defined(VELOCITY) || defined(VELOCITY_LINEAR)
varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#ifdef NEED_UV
varying vec2 vUV;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#if defined(REFLECTIVITY)
#if defined(ORMTEXTURE) || defined(SPECULARGLOSSINESSTEXTURE) || defined(REFLECTIVITYTEXTURE)
uniform sampler2D reflectivitySampler;varying vec2 vReflectivityUV;
#endif
#ifdef ALBEDOTEXTURE
varying vec2 vAlbedoUV;uniform sampler2D albedoSampler;
#endif
#ifdef REFLECTIVITYCOLOR
uniform vec3 reflectivityColor;
#endif
#ifdef ALBEDOCOLOR
uniform vec3 albedoColor;
#endif
#ifdef METALLIC
uniform float metallic;
#endif
#if defined(ROUGHNESS) || defined(GLOSSINESS)
uniform float glossiness;
#endif
#endif
#if defined(ALPHATEST) && defined(NEED_UV)
uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#include<mrtFragmentDeclaration>[SCENE_MRT_COUNT]
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<helperFunctions>
void main() {
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
vec3 normalOutput;
#ifdef BUMP
vec3 normalW=normalize(vNormalW);
#include<bumpFragment>
#ifdef NORMAL_WORLDSPACE
normalOutput=normalW;
#else
normalOutput=normalize(vec3(vWorldView*vec4(normalW,0.0)));
#endif
#else
normalOutput=normalize(vNormalV);
#endif
#ifdef ENCODE_NORMAL
normalOutput=normalOutput*0.5+0.5;
#endif
#ifdef DEPTH
gl_FragData[DEPTH_INDEX]=vec4(vViewPos.z/vViewPos.w,0.0,0.0,1.0);
#endif
#ifdef NORMAL
gl_FragData[NORMAL_INDEX]=vec4(normalOutput,1.0);
#endif
#ifdef SCREENSPACE_DEPTH
gl_FragData[SCREENSPACE_DEPTH_INDEX]=vec4(gl_FragCoord.z,0.0,0.0,1.0);
#endif
#ifdef POSITION
gl_FragData[POSITION_INDEX]=vec4(vPositionW,1.0);
#endif
#ifdef VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[VELOCITY_INDEX]=vec4(velocity,0.0,1.0);
#endif
#ifdef VELOCITY_LINEAR
vec2 velocity=vec2(0.5)*((vPreviousPosition.xy/vPreviousPosition.w) -
(vCurrentPosition.xy/vCurrentPosition.w));gl_FragData[VELOCITY_LINEAR_INDEX]=vec4(velocity,0.0,1.0);
#endif
#ifdef REFLECTIVITY
vec4 reflectivity=vec4(0.0,0.0,0.0,1.0);
#ifdef METALLICWORKFLOW
float metal=1.0;float roughness=1.0;
#ifdef ORMTEXTURE
metal*=texture2D(reflectivitySampler,vReflectivityUV).b;roughness*=texture2D(reflectivitySampler,vReflectivityUV).g;
#endif
#ifdef METALLIC
metal*=metallic;
#endif
#ifdef ROUGHNESS
roughness*=(1.0-glossiness); 
#endif
reflectivity.a-=roughness;vec3 color=vec3(1.0);
#ifdef ALBEDOTEXTURE
color=texture2D(albedoSampler,vAlbedoUV).rgb;
#ifdef GAMMAALBEDO
color=toLinearSpace(color);
#endif
#endif
#ifdef ALBEDOCOLOR
color*=albedoColor.xyz;
#endif
reflectivity.rgb=mix(vec3(0.04),color,metal);
#else
#if defined(SPECULARGLOSSINESSTEXTURE) || defined(REFLECTIVITYTEXTURE)
reflectivity=texture2D(reflectivitySampler,vReflectivityUV);
#ifdef GAMMAREFLECTIVITYTEXTURE
reflectivity.rgb=toLinearSpace(reflectivity.rgb);
#endif
#else 
#ifdef REFLECTIVITYCOLOR
reflectivity.rgb=toLinearSpace(reflectivityColor.xyz);reflectivity.a=1.0;
#endif
#endif
#ifdef GLOSSINESSS
reflectivity.a*=glossiness; 
#endif
#endif
gl_FragData[REFLECTIVITY_INDEX]=reflectivity;
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$0a3997369d1d99f4$var$name] = $0a3997369d1d99f4$var$shader;
const $0a3997369d1d99f4$export$d97d9a5440f7474e = {
    name: $0a3997369d1d99f4$var$name,
    shader: $0a3997369d1d99f4$var$shader
};

});
parcelRegister("cblTU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8de7802498fa7885$var$name = "mrtFragmentDeclaration";
const $8de7802498fa7885$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
layout(location=0) out vec4 glFragData[{X}];
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8de7802498fa7885$var$name] = $8de7802498fa7885$var$shader;
const $8de7802498fa7885$export$48c2f8813edb7710 = {
    name: $8de7802498fa7885$var$name,
    shader: $8de7802498fa7885$var$shader
};

});


parcelRegister("7phX0", function(module, exports) {

$parcel$export(module.exports, "geometryVertexShader", () => $5648cad7d3ed7444$export$902a4ff66265d834);
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("k3wwH");
parcelRequire("44ME7");
parcelRequire("gQ7sy");
parcelRequire("4A4MM");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
parcelRequire("4GjUR");
const $5648cad7d3ed7444$var$name = "geometryVertexShader";
const $5648cad7d3ed7444$var$shader = `precision highp float;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<instancesDeclaration>
#include<__decl__geometryVertex>
#include<clipPlaneVertexDeclaration>
attribute vec3 position;attribute vec3 normal;
#ifdef NEED_UV
varying vec2 vUV;
#ifdef ALPHATEST
uniform mat4 diffuseMatrix;
#endif
#ifdef BUMP
uniform mat4 bumpMatrix;varying vec2 vBumpUV;
#endif
#ifdef REFLECTIVITY
uniform mat4 reflectivityMatrix;uniform mat4 albedoMatrix;varying vec2 vReflectivityUV;varying vec2 vAlbedoUV;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#ifdef BUMP
varying mat4 vWorldView;
#endif
#ifdef BUMP
varying vec3 vNormalW;
#else
varying vec3 vNormalV;
#endif
varying vec4 vViewPos;
#if defined(POSITION) || defined(BUMP)
varying vec3 vPositionW;
#endif
#if defined(VELOCITY) || defined(VELOCITY_LINEAR)
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;vec3 normalUpdated=normal;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#ifdef UV2
vec2 uv2Updated=uv2;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#if (defined(VELOCITY) || defined(VELOCITY_LINEAR)) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=vec4(finalWorld*vec4(positionUpdated,1.0));
#ifdef BUMP
vWorldView=view*finalWorld;mat3 normalWorld=mat3(finalWorld);vNormalW=normalize(normalWorld*normalUpdated);
#else
#ifdef NORMAL_WORLDSPACE
vNormalV=normalize(vec3(finalWorld*vec4(normalUpdated,0.0)));
#else
vNormalV=normalize(vec3((view*finalWorld)*vec4(normalUpdated,0.0)));
#endif
#endif
vViewPos=view*worldPos;
#if (defined(VELOCITY) || defined(VELOCITY_LINEAR)) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
#if defined(POSITION) || defined(BUMP)
vPositionW=worldPos.xyz/worldPos.w;
#endif
gl_Position=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#include<clipPlaneVertex>
#ifdef NEED_UV
#ifdef UV1
#if defined(ALPHATEST) && defined(ALPHATEST_UV1)
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#else
vUV=uvUpdated;
#endif
#ifdef BUMP_UV1
vBumpUV=vec2(bumpMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef REFLECTIVITY_UV1
vReflectivityUV=vec2(reflectivityMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef ALBEDO_UV1
vAlbedoUV=vec2(albedoMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#endif
#ifdef UV2
#if defined(ALPHATEST) && defined(ALPHATEST_UV2)
vUV=vec2(diffuseMatrix*vec4(uv2Updated,1.0,0.0));
#else
vUV=uv2Updated;
#endif
#ifdef BUMP_UV2
vBumpUV=vec2(bumpMatrix*vec4(uv2Updated,1.0,0.0));
#endif
#ifdef REFLECTIVITY_UV2
vReflectivityUV=vec2(reflectivityMatrix*vec4(uv2Updated,1.0,0.0));
#endif
#ifdef ALBEDO_UV2
vAlbedoUV=vec2(albedoMatrix*vec4(uv2Updated,1.0,0.0));
#endif
#endif
#endif
#include<bumpVertex>
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$5648cad7d3ed7444$var$name] = $5648cad7d3ed7444$var$shader;
const $5648cad7d3ed7444$export$902a4ff66265d834 = {
    name: $5648cad7d3ed7444$var$name,
    shader: $5648cad7d3ed7444$var$shader
};

});
parcelRegister("44ME7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2f7d454019bc554e$var$name = "geometryVertexDeclaration";
const $2f7d454019bc554e$var$shader = `uniform mat4 viewProjection;uniform mat4 view;`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$2f7d454019bc554e$var$name] = $2f7d454019bc554e$var$shader;
const $2f7d454019bc554e$export$1ae3f777a09e01af = {
    name: $2f7d454019bc554e$var$name,
    shader: $2f7d454019bc554e$var$shader
};

});

parcelRegister("gQ7sy", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
const $c42749fbc06430a7$var$name = "geometryUboDeclaration";
const $c42749fbc06430a7$var$shader = `#include<sceneUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c42749fbc06430a7$var$name] = $c42749fbc06430a7$var$shader;
const $c42749fbc06430a7$export$313b253abf90f245 = {
    name: $c42749fbc06430a7$var$name,
    shader: $c42749fbc06430a7$var$shader
};

});


parcelRegister("ljIAV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7YrHe").then(()=>parcelRequire('itU0l'));

});

parcelRegister("01GWI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5U6Ps").then(()=>parcelRequire('kK4Iy'));

});

parcelRegister("avKjR", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("qv7dg").then(()=>parcelRequire('7EjKo'));

});

parcelRegister("dhzOq", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bDE6d").then(()=>parcelRequire('2J7Zg'));

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});


parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("bUtXH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2von7").then(()=>parcelRequire('6MxR1'));

});

parcelRegister("k3U9J", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kCp00").then(()=>parcelRequire('awS6Z'));

});

parcelRegister("jkCXV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bQWTN").then(()=>parcelRequire('jiOMu'));

});

parcelRegister("6ZPCO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("c5BVq").then(()=>parcelRequire('cGwq9'));

});

parcelRegister("k4Loe", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kskMa").then(()=>parcelRequire('ePhBh'));

});

parcelRegister("aj3L0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ipsKo").then(()=>parcelRequire('1ewVh'));

});

parcelRegister("kdcUk", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3Q8Ie").then(()=>parcelRequire('6ueFN'));

});

parcelRegister("bLhm7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8FsUp").then(()=>parcelRequire('bBTDU'));

});

var $b5d487f1cc225cfd$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"60QF2\",\"index.0f1822cd.js\",\"3iHFa\",\"iesTextureLoader.5ee2a7c6.js\",\"9kPzr\",\"ddsTextureLoader.19494642.js\",\"2M22I\",\"dds.0fb14390.js\",\"6Lxmp\",\"dds.1153d144.js\",\"gvkMv\",\"lodCube.fragment.3076f7d1.js\",\"lLanN\",\"lod.fragment.80f303f4.js\",\"3Ailm\",\"lodCube.fragment.14fa40d2.js\",\"eKWIs\",\"lod.fragment.3248a21b.js\",\"j1Su3\",\"pass.fragment.43be8b2c.js\",\"6y0A7\",\"pass.fragment.95d24380.js\",\"gPNR9\",\"passCube.fragment.6c4fb773.js\",\"4Joz9\",\"passCube.fragment.50cad309.js\",\"2nnzJ\",\"dumpTools.1a5def90.js\",\"9strh\",\"postprocess.vertex.9296e1da.js\",\"5B2hi\",\"basisTextureLoader.ce43da3f.js\",\"dOETK\",\"envTextureLoader.82bc7b83.js\",\"1bZ3p\",\"rgbdDecode.fragment.c9cc7faf.js\",\"4xh5F\",\"rgbdDecode.fragment.cb83d6d6.js\",\"3owIw\",\"rgbdEncode.fragment.79216bc6.js\",\"cIyW8\",\"rgbdEncode.fragment.38c57c00.js\",\"dQ67R\",\"hdrTextureLoader.05c9c6d1.js\",\"jmK8z\",\"ktxTextureLoader.cd92a0a1.js\",\"e5nmT\",\"tgaTextureLoader.009c6ce3.js\",\"gP7tK\",\"exrTextureLoader.b2ee163b.js\",\"h8vYC\",\"default.vertex.525dc01a.js\",\"U2cDc\",\"default.fragment.993b8c81.js\",\"6mp9e\",\"mesh.vertexData.functions.267d88ba.js\",\"bXJVg\",\"color.vertex.af9dd4a0.js\",\"49P8m\",\"color.fragment.2717b858.js\",\"20662\",\"color.vertex.3a7cb6d3.js\",\"2nzrc\",\"color.fragment.1784b60d.js\",\"3e1iM\",\"imageProcessing.fragment.7ec01177.js\",\"ePVtm\",\"imageProcessing.fragment.407d3afc.js\",\"7YrHe\",\"geometry.vertex.05351be0.js\",\"5U6Ps\",\"geometry.fragment.b8920192.js\",\"qv7dg\",\"motionBlur.fragment.5c45ec61.js\",\"bDE6d\",\"motionBlur.fragment.a83fd751.js\",\"4wAnV\",\"T_Star.e1bc310e.png\",\"dIGYV\",\"T_SunSurface.e9090abc.png\",\"5H158\",\"Fire-21.61410770.mp3\",\"i7ByI\",\"Fire-4.1010d6b4.mp3\",\"j60LD\",\"Fire-18.122e26b5.mp3\",\"keKTG\",\"Fire-9.ce18cc11.mp3\",\"2ewMM\",\"Fire-10.95d4b00d.mp3\",\"jypRZ\",\"Fire-22.8eb7044e.mp3\",\"c2lqa\",\"Fire-23.904f0cc2.mp3\",\"2von7\",\"layer.vertex.c1952e40.js\",\"kCp00\",\"layer.fragment.eb926a2d.js\",\"bQWTN\",\"layer.vertex.3815e263.js\",\"c5BVq\",\"layer.fragment.4c837bc9.js\",\"kskMa\",\"particles.vertex.68ef1481.js\",\"ipsKo\",\"particles.fragment.b2f05e82.js\",\"3Q8Ie\",\"particles.vertex.fb2acfef.js\",\"8FsUp\",\"particles.fragment.45b87089.js\"]"));


var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $57onU = parcelRequire("57onU");

var $gmbCk = parcelRequire("gmbCk");

var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");
/**
 * Configuration needed for prepass-capable materials
 */ class $9c7b0616b7e91126$export$ccd4486ebb81b39a {
    constructor(){
        /**
         * Previous world matrices of meshes carrying this material
         * Used for computing velocity
         */ this.previousWorldMatrices = {};
        /**
         * Previous bones of meshes carrying this material
         * Used for computing velocity
         */ this.previousBones = {};
    }
    /**
     * Add the required uniforms to the current list.
     * @param uniforms defines the current uniform list.
     */ static AddUniforms(uniforms) {
        uniforms.push("previousWorld", "previousViewProjection", "mPreviousBones");
    }
    /**
     * Add the required samplers to the current list.
     * @param samplers defines the current sampler list.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static AddSamplers(samplers) {
    // pass
    }
    /**
     * Binds the material data.
     * @param effect defines the effect to update
     * @param scene defines the scene the material belongs to.
     * @param mesh The mesh
     * @param world World matrix of this mesh
     * @param isFrozen Is the material frozen
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bindForSubMesh(effect, scene, mesh, world, isFrozen) {
        if (scene.prePassRenderer && scene.prePassRenderer.enabled && scene.prePassRenderer.currentRTisSceneRT) {
            if (scene.prePassRenderer.getIndex(2) !== -1 || scene.prePassRenderer.getIndex(11) !== -1) {
                if (!this.previousWorldMatrices[mesh.uniqueId]) this.previousWorldMatrices[mesh.uniqueId] = world.clone();
                if (!this.previousViewProjection) {
                    this.previousViewProjection = scene.getTransformMatrix().clone();
                    this.currentViewProjection = scene.getTransformMatrix().clone();
                }
                const engine = scene.getEngine();
                if (this.currentViewProjection.updateFlag !== scene.getTransformMatrix().updateFlag) {
                    // First update of the prepass configuration for this rendering pass
                    this._lastUpdateFrameId = engine.frameId;
                    this.previousViewProjection.copyFrom(this.currentViewProjection);
                    this.currentViewProjection.copyFrom(scene.getTransformMatrix());
                } else if (this._lastUpdateFrameId !== engine.frameId) {
                    // The scene transformation did not change from the previous frame (so no camera motion), we must update previousViewProjection accordingly
                    this._lastUpdateFrameId = engine.frameId;
                    this.previousViewProjection.copyFrom(this.currentViewProjection);
                }
                effect.setMatrix("previousWorld", this.previousWorldMatrices[mesh.uniqueId]);
                effect.setMatrix("previousViewProjection", this.previousViewProjection);
                this.previousWorldMatrices[mesh.uniqueId] = world.clone();
            }
        }
    }
}



var $dG1pf = parcelRequire("dG1pf");

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $ejQPp = parcelRequire("ejQPp");

var $b4i1f = parcelRequire("b4i1f");
/**
 * @internal
 */ class $da5dace7af8aa5ae$export$3ec28a530ce1ca87 {
    constructor(bu, bv, distance){
        this.bu = bu;
        this.bv = bv;
        this.distance = distance;
        this.faceId = 0;
        this.subMeshId = 0;
    }
}



var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");
class $551375aec883d052$export$63080c4de6cfc362 {
    /**
     * Creates a new bounding box
     * @param min defines the minimum vector (in local space)
     * @param max defines the maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ constructor(min, max, worldMatrix){
        /**
         * Gets the 8 vectors representing the bounding box in local space
         */ this.vectors = (0, $opFp4.BuildArray)(8, (0, $ha1VO.Vector3).Zero);
        /**
         * Gets the center of the bounding box in local space
         */ this.center = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the center of the bounding box in world space
         */ this.centerWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets half the size of the extent in local space. Multiply by 2 to obtain the full size of the box!
         */ this.extendSize = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets half the size of the extent in world space. Multiply by 2 to obtain the full size of the box!
         */ this.extendSizeWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the OBB (object bounding box) directions
         */ this.directions = (0, $opFp4.BuildArray)(3, (0, $ha1VO.Vector3).Zero);
        /**
         * Gets the 8 vectors representing the bounding box in world space
         */ this.vectorsWorld = (0, $opFp4.BuildArray)(8, (0, $ha1VO.Vector3).Zero);
        /**
         * Gets the minimum vector in world space
         */ this.minimumWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the maximum vector in world space
         */ this.maximumWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the minimum vector in local space
         */ this.minimum = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the maximum vector in local space
         */ this.maximum = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._drawWrapperFront = null;
        /** @internal */ this._drawWrapperBack = null;
        this.reConstruct(min, max, worldMatrix);
    }
    // Methods
    /**
     * Recreates the entire bounding box from scratch as if we call the constructor in place
     * @param min defines the new minimum vector (in local space)
     * @param max defines the new maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ reConstruct(min, max, worldMatrix) {
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        const vectors = this.vectors;
        this.minimum.copyFromFloats(minX, minY, minZ);
        this.maximum.copyFromFloats(maxX, maxY, maxZ);
        vectors[0].copyFromFloats(minX, minY, minZ);
        vectors[1].copyFromFloats(maxX, maxY, maxZ);
        vectors[2].copyFromFloats(maxX, minY, minZ);
        vectors[3].copyFromFloats(minX, maxY, minZ);
        vectors[4].copyFromFloats(minX, minY, maxZ);
        vectors[5].copyFromFloats(maxX, maxY, minZ);
        vectors[6].copyFromFloats(minX, maxY, maxZ);
        vectors[7].copyFromFloats(maxX, minY, maxZ);
        // OBB
        max.addToRef(min, this.center).scaleInPlace(0.5);
        max.subtractToRef(min, this.extendSize).scaleInPlace(0.5);
        this._worldMatrix = worldMatrix || (0, $ha1VO.Matrix).IdentityReadOnly;
        this._update(this._worldMatrix);
    }
    /**
     * Scale the current bounding box by applying a scale factor
     * @param factor defines the scale factor to apply
     * @returns the current bounding box
     */ scale(factor) {
        const tmpVectors = $551375aec883d052$export$63080c4de6cfc362._TmpVector3;
        const diff = this.maximum.subtractToRef(this.minimum, tmpVectors[0]);
        const len = diff.length();
        diff.normalizeFromLength(len);
        const distance = len * factor;
        const newRadius = diff.scaleInPlace(distance * 0.5);
        const min = this.center.subtractToRef(newRadius, tmpVectors[1]);
        const max = this.center.addToRef(newRadius, tmpVectors[2]);
        this.reConstruct(min, max, this._worldMatrix);
        return this;
    }
    /**
     * Gets the world matrix of the bounding box
     * @returns a matrix
     */ getWorldMatrix() {
        return this._worldMatrix;
    }
    /**
     * @internal
     */ _update(world) {
        const minWorld = this.minimumWorld;
        const maxWorld = this.maximumWorld;
        const directions = this.directions;
        const vectorsWorld = this.vectorsWorld;
        const vectors = this.vectors;
        if (!world.isIdentity()) {
            minWorld.setAll(Number.MAX_VALUE);
            maxWorld.setAll(-Number.MAX_VALUE);
            for(let index = 0; index < 8; ++index){
                const v = vectorsWorld[index];
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(vectors[index], world, v);
                minWorld.minimizeInPlace(v);
                maxWorld.maximizeInPlace(v);
            }
            // Extend
            maxWorld.subtractToRef(minWorld, this.extendSizeWorld).scaleInPlace(0.5);
            maxWorld.addToRef(minWorld, this.centerWorld).scaleInPlace(0.5);
        } else {
            minWorld.copyFrom(this.minimum);
            maxWorld.copyFrom(this.maximum);
            for(let index = 0; index < 8; ++index)vectorsWorld[index].copyFrom(vectors[index]);
            // Extend
            this.extendSizeWorld.copyFrom(this.extendSize);
            this.centerWorld.copyFrom(this.center);
        }
        (0, $ha1VO.Vector3).FromArrayToRef(world.m, 0, directions[0]);
        (0, $ha1VO.Vector3).FromArrayToRef(world.m, 4, directions[1]);
        (0, $ha1VO.Vector3).FromArrayToRef(world.m, 8, directions[2]);
        this._worldMatrix = world;
    }
    /**
     * Tests if the bounding box is intersecting the frustum planes
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an intersection
     */ isInFrustum(frustumPlanes) {
        return $551375aec883d052$export$63080c4de6cfc362.IsInFrustum(this.vectorsWorld, frustumPlanes);
    }
    /**
     * Tests if the bounding box is entirely inside the frustum planes
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an inclusion
     */ isCompletelyInFrustum(frustumPlanes) {
        return $551375aec883d052$export$63080c4de6cfc362.IsCompletelyInFrustum(this.vectorsWorld, frustumPlanes);
    }
    /**
     * Tests if a point is inside the bounding box
     * @param point defines the point to test
     * @returns true if the point is inside the bounding box
     */ intersectsPoint(point) {
        const min = this.minimumWorld;
        const max = this.maximumWorld;
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        const pointX = point.x, pointY = point.y, pointZ = point.z;
        const delta = -(0, $53VPf.Epsilon);
        if (maxX - pointX < delta || delta > pointX - minX) return false;
        if (maxY - pointY < delta || delta > pointY - minY) return false;
        if (maxZ - pointZ < delta || delta > pointZ - minZ) return false;
        return true;
    }
    /**
     * Tests if the bounding box intersects with a bounding sphere
     * @param sphere defines the sphere to test
     * @returns true if there is an intersection
     */ intersectsSphere(sphere) {
        return $551375aec883d052$export$63080c4de6cfc362.IntersectsSphere(this.minimumWorld, this.maximumWorld, sphere.centerWorld, sphere.radiusWorld);
    }
    /**
     * Tests if the bounding box intersects with a box defined by a min and max vectors
     * @param min defines the min vector to use
     * @param max defines the max vector to use
     * @returns true if there is an intersection
     */ intersectsMinMax(min, max) {
        const myMin = this.minimumWorld;
        const myMax = this.maximumWorld;
        const myMinX = myMin.x, myMinY = myMin.y, myMinZ = myMin.z, myMaxX = myMax.x, myMaxY = myMax.y, myMaxZ = myMax.z;
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        if (myMaxX < minX || myMinX > maxX) return false;
        if (myMaxY < minY || myMinY > maxY) return false;
        if (myMaxZ < minZ || myMinZ > maxZ) return false;
        return true;
    }
    /**
     * Disposes the resources of the class
     */ dispose() {
        this._drawWrapperFront?.dispose();
        this._drawWrapperBack?.dispose();
    }
    // Statics
    /**
     * Tests if two bounding boxes are intersections
     * @param box0 defines the first box to test
     * @param box1 defines the second box to test
     * @returns true if there is an intersection
     */ static Intersects(box0, box1) {
        return box0.intersectsMinMax(box1.minimumWorld, box1.maximumWorld);
    }
    /**
     * Tests if a bounding box defines by a min/max vectors intersects a sphere
     * @param minPoint defines the minimum vector of the bounding box
     * @param maxPoint defines the maximum vector of the bounding box
     * @param sphereCenter defines the sphere center
     * @param sphereRadius defines the sphere radius
     * @returns true if there is an intersection
     */ static IntersectsSphere(minPoint, maxPoint, sphereCenter, sphereRadius) {
        const vector = $551375aec883d052$export$63080c4de6cfc362._TmpVector3[0];
        (0, $ha1VO.Vector3).ClampToRef(sphereCenter, minPoint, maxPoint, vector);
        const num = (0, $ha1VO.Vector3).DistanceSquared(sphereCenter, vector);
        return num <= sphereRadius * sphereRadius;
    }
    /**
     * Tests if a bounding box defined with 8 vectors is entirely inside frustum planes
     * @param boundingVectors defines an array of 8 vectors representing a bounding box
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an inclusion
     */ static IsCompletelyInFrustum(boundingVectors, frustumPlanes) {
        for(let p = 0; p < 6; ++p){
            const frustumPlane = frustumPlanes[p];
            for(let i = 0; i < 8; ++i){
                if (frustumPlane.dotCoordinate(boundingVectors[i]) < 0) return false;
            }
        }
        return true;
    }
    /**
     * Tests if a bounding box defined with 8 vectors intersects frustum planes
     * @param boundingVectors defines an array of 8 vectors representing a bounding box
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an intersection
     */ static IsInFrustum(boundingVectors, frustumPlanes) {
        for(let p = 0; p < 6; ++p){
            let canReturnFalse = true;
            const frustumPlane = frustumPlanes[p];
            for(let i = 0; i < 8; ++i)if (frustumPlane.dotCoordinate(boundingVectors[i]) >= 0) {
                canReturnFalse = false;
                break;
            }
            if (canReturnFalse) return false;
        }
        return true;
    }
}
$551375aec883d052$export$63080c4de6cfc362._TmpVector3 = (0, $opFp4.BuildArray)(3, (0, $ha1VO.Vector3).Zero);



var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");
class $7ba1063d4f2776f9$export$c74f7bf74a297961 {
    /**
     * Creates a new bounding sphere
     * @param min defines the minimum vector (in local space)
     * @param max defines the maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ constructor(min, max, worldMatrix){
        /**
         * Gets the center of the bounding sphere in local space
         */ this.center = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the center of the bounding sphere in world space
         */ this.centerWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the minimum vector in local space
         */ this.minimum = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the maximum vector in local space
         */ this.maximum = (0, $ha1VO.Vector3).Zero();
        this.reConstruct(min, max, worldMatrix);
    }
    /**
     * Recreates the entire bounding sphere from scratch as if we call the constructor in place
     * @param min defines the new minimum vector (in local space)
     * @param max defines the new maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ reConstruct(min, max, worldMatrix) {
        this.minimum.copyFrom(min);
        this.maximum.copyFrom(max);
        const distance = (0, $ha1VO.Vector3).Distance(min, max);
        max.addToRef(min, this.center).scaleInPlace(0.5);
        this.radius = distance * 0.5;
        this._update(worldMatrix || (0, $ha1VO.Matrix).IdentityReadOnly);
    }
    /**
     * Scale the current bounding sphere by applying a scale factor
     * @param factor defines the scale factor to apply
     * @returns the current bounding box
     */ scale(factor) {
        const newRadius = this.radius * factor;
        const tmpVectors = $7ba1063d4f2776f9$export$c74f7bf74a297961._TmpVector3;
        const tempRadiusVector = tmpVectors[0].setAll(newRadius);
        const min = this.center.subtractToRef(tempRadiusVector, tmpVectors[1]);
        const max = this.center.addToRef(tempRadiusVector, tmpVectors[2]);
        this.reConstruct(min, max, this._worldMatrix);
        return this;
    }
    /**
     * Gets the world matrix of the bounding box
     * @returns a matrix
     */ getWorldMatrix() {
        return this._worldMatrix;
    }
    // Methods
    /**
     * @internal
     */ _update(worldMatrix) {
        if (!worldMatrix.isIdentity()) {
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this.center, worldMatrix, this.centerWorld);
            const tempVector = $7ba1063d4f2776f9$export$c74f7bf74a297961._TmpVector3[0];
            (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(1.0, 1.0, 1.0, worldMatrix, tempVector);
            this.radiusWorld = Math.max(Math.abs(tempVector.x), Math.abs(tempVector.y), Math.abs(tempVector.z)) * this.radius;
        } else {
            this.centerWorld.copyFrom(this.center);
            this.radiusWorld = this.radius;
        }
    }
    /**
     * Tests if the bounding sphere is intersecting the frustum planes
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an intersection
     */ isInFrustum(frustumPlanes) {
        const center = this.centerWorld;
        const radius = this.radiusWorld;
        for(let i = 0; i < 6; i++){
            if (frustumPlanes[i].dotCoordinate(center) <= -radius) return false;
        }
        return true;
    }
    /**
     * Tests if the bounding sphere center is in between the frustum planes.
     * Used for optimistic fast inclusion.
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if the sphere center is in between the frustum planes
     */ isCenterInFrustum(frustumPlanes) {
        const center = this.centerWorld;
        for(let i = 0; i < 6; i++){
            if (frustumPlanes[i].dotCoordinate(center) < 0) return false;
        }
        return true;
    }
    /**
     * Tests if a point is inside the bounding sphere
     * @param point defines the point to test
     * @returns true if the point is inside the bounding sphere
     */ intersectsPoint(point) {
        const squareDistance = (0, $ha1VO.Vector3).DistanceSquared(this.centerWorld, point);
        if (this.radiusWorld * this.radiusWorld < squareDistance) return false;
        return true;
    }
    // Statics
    /**
     * Checks if two sphere intersect
     * @param sphere0 sphere 0
     * @param sphere1 sphere 1
     * @returns true if the spheres intersect
     */ static Intersects(sphere0, sphere1) {
        const squareDistance = (0, $ha1VO.Vector3).DistanceSquared(sphere0.centerWorld, sphere1.centerWorld);
        const radiusSum = sphere0.radiusWorld + sphere1.radiusWorld;
        if (radiusSum * radiusSum < squareDistance) return false;
        return true;
    }
    /**
     * Creates a sphere from a center and a radius
     * @param center The center
     * @param radius radius
     * @param matrix Optional worldMatrix
     * @returns The sphere
     */ static CreateFromCenterAndRadius(center, radius, matrix) {
        this._TmpVector3[0].copyFrom(center);
        this._TmpVector3[1].copyFromFloats(0, 0, radius);
        this._TmpVector3[2].copyFrom(center);
        this._TmpVector3[0].addInPlace(this._TmpVector3[1]);
        this._TmpVector3[2].subtractInPlace(this._TmpVector3[1]);
        const sphere = new $7ba1063d4f2776f9$export$c74f7bf74a297961(this._TmpVector3[0], this._TmpVector3[2]);
        if (matrix) sphere._worldMatrix = matrix;
        else sphere._worldMatrix = (0, $ha1VO.Matrix).Identity();
        return sphere;
    }
}
$7ba1063d4f2776f9$export$c74f7bf74a297961._TmpVector3 = (0, $opFp4.BuildArray)(3, (0, $ha1VO.Vector3).Zero);


const $a5e27a85374b8b23$var$_result0 = {
    min: 0,
    max: 0
};
const $a5e27a85374b8b23$var$_result1 = {
    min: 0,
    max: 0
};
const $a5e27a85374b8b23$var$computeBoxExtents = (axis, box, result)=>{
    const p = (0, $ha1VO.Vector3).Dot(box.centerWorld, axis);
    const r0 = Math.abs((0, $ha1VO.Vector3).Dot(box.directions[0], axis)) * box.extendSize.x;
    const r1 = Math.abs((0, $ha1VO.Vector3).Dot(box.directions[1], axis)) * box.extendSize.y;
    const r2 = Math.abs((0, $ha1VO.Vector3).Dot(box.directions[2], axis)) * box.extendSize.z;
    const r = r0 + r1 + r2;
    result.min = p - r;
    result.max = p + r;
};
const $a5e27a85374b8b23$var$axisOverlap = (axis, box0, box1)=>{
    $a5e27a85374b8b23$var$computeBoxExtents(axis, box0, $a5e27a85374b8b23$var$_result0);
    $a5e27a85374b8b23$var$computeBoxExtents(axis, box1, $a5e27a85374b8b23$var$_result1);
    return !($a5e27a85374b8b23$var$_result0.min > $a5e27a85374b8b23$var$_result1.max || $a5e27a85374b8b23$var$_result1.min > $a5e27a85374b8b23$var$_result0.max);
};
class $a5e27a85374b8b23$export$dc03daefa4f9a8c4 {
    /**
     * Constructs bounding info
     * @param minimum min vector of the bounding box/sphere
     * @param maximum max vector of the bounding box/sphere
     * @param worldMatrix defines the new world matrix
     */ constructor(minimum, maximum, worldMatrix){
        this._isLocked = false;
        this.boundingBox = new (0, $551375aec883d052$export$63080c4de6cfc362)(minimum, maximum, worldMatrix);
        this.boundingSphere = new (0, $7ba1063d4f2776f9$export$c74f7bf74a297961)(minimum, maximum, worldMatrix);
    }
    /**
     * Recreates the entire bounding info from scratch as if we call the constructor in place
     * @param min defines the new minimum vector (in local space)
     * @param max defines the new maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ reConstruct(min, max, worldMatrix) {
        this.boundingBox.reConstruct(min, max, worldMatrix);
        this.boundingSphere.reConstruct(min, max, worldMatrix);
    }
    /**
     * min vector of the bounding box/sphere
     */ get minimum() {
        return this.boundingBox.minimum;
    }
    /**
     * max vector of the bounding box/sphere
     */ get maximum() {
        return this.boundingBox.maximum;
    }
    /**
     * If the info is locked and won't be updated to avoid perf overhead
     */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        this._isLocked = value;
    }
    // Methods
    /**
     * Updates the bounding sphere and box
     * @param world world matrix to be used to update
     */ update(world) {
        if (this._isLocked) return;
        this.boundingBox._update(world);
        this.boundingSphere._update(world);
    }
    /**
     * Recreate the bounding info to be centered around a specific point given a specific extend.
     * @param center New center of the bounding info
     * @param extend New extend of the bounding info
     * @returns the current bounding info
     */ centerOn(center, extend) {
        const minimum = $a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3[0].copyFrom(center).subtractInPlace(extend);
        const maximum = $a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3[1].copyFrom(center).addInPlace(extend);
        this.boundingBox.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        this.boundingSphere.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        return this;
    }
    /**
     * Grows the bounding info to include the given point.
     * @param point The point that will be included in the current bounding info (in local space)
     * @returns the current bounding info
     */ encapsulate(point) {
        const minimum = (0, $ha1VO.Vector3).Minimize(this.minimum, point);
        const maximum = (0, $ha1VO.Vector3).Maximize(this.maximum, point);
        this.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        return this;
    }
    /**
     * Grows the bounding info to encapsulate the given bounding info.
     * @param toEncapsulate The bounding info that will be encapsulated in the current bounding info
     * @returns the current bounding info
     */ encapsulateBoundingInfo(toEncapsulate) {
        const invw = (0, $ha1VO.TmpVectors).Matrix[0];
        this.boundingBox.getWorldMatrix().invertToRef(invw);
        const v = (0, $ha1VO.TmpVectors).Vector3[0];
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(toEncapsulate.boundingBox.minimumWorld, invw, v);
        this.encapsulate(v);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(toEncapsulate.boundingBox.maximumWorld, invw, v);
        this.encapsulate(v);
        return this;
    }
    /**
     * Scale the current bounding info by applying a scale factor
     * @param factor defines the scale factor to apply
     * @returns the current bounding info
     */ scale(factor) {
        this.boundingBox.scale(factor);
        this.boundingSphere.scale(factor);
        return this;
    }
    /**
     * Returns `true` if the bounding info is within the frustum defined by the passed array of planes.
     * @param frustumPlanes defines the frustum to test
     * @param strategy defines the strategy to use for the culling (default is BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD)
     * The different strategies available are:
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD most accurate but slower @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_STANDARD
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY faster but less accurate @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
     * @returns true if the bounding info is in the frustum planes
     */ isInFrustum(frustumPlanes, strategy = 0) {
        const inclusionTest = strategy === 2 || strategy === 3;
        if (inclusionTest) {
            if (this.boundingSphere.isCenterInFrustum(frustumPlanes)) return true;
        }
        if (!this.boundingSphere.isInFrustum(frustumPlanes)) return false;
        const bSphereOnlyTest = strategy === 1 || strategy === 3;
        if (bSphereOnlyTest) return true;
        return this.boundingBox.isInFrustum(frustumPlanes);
    }
    /**
     * Gets the world distance between the min and max points of the bounding box
     */ get diagonalLength() {
        const boundingBox = this.boundingBox;
        const diag = boundingBox.maximumWorld.subtractToRef(boundingBox.minimumWorld, $a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3[0]);
        return diag.length();
    }
    /**
     * Checks if a cullable object (mesh...) is in the camera frustum
     * Unlike isInFrustum this checks the full bounding box
     * @param frustumPlanes Camera near/planes
     * @returns true if the object is in frustum otherwise false
     */ isCompletelyInFrustum(frustumPlanes) {
        return this.boundingBox.isCompletelyInFrustum(frustumPlanes);
    }
    /**
     * @internal
     */ _checkCollision(collider) {
        return collider._canDoCollision(this.boundingSphere.centerWorld, this.boundingSphere.radiusWorld, this.boundingBox.minimumWorld, this.boundingBox.maximumWorld);
    }
    /**
     * Checks if a point is inside the bounding box and bounding sphere or the mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
     * @param point the point to check intersection with
     * @returns if the point intersects
     */ intersectsPoint(point) {
        if (!this.boundingSphere.centerWorld) return false;
        if (!this.boundingSphere.intersectsPoint(point)) return false;
        if (!this.boundingBox.intersectsPoint(point)) return false;
        return true;
    }
    /**
     * Checks if another bounding info intersects the bounding box and bounding sphere or the mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
     * @param boundingInfo the bounding info to check intersection with
     * @param precise if the intersection should be done using OBB
     * @returns if the bounding info intersects
     */ intersects(boundingInfo, precise) {
        if (!(0, $7ba1063d4f2776f9$export$c74f7bf74a297961).Intersects(this.boundingSphere, boundingInfo.boundingSphere)) return false;
        if (!(0, $551375aec883d052$export$63080c4de6cfc362).Intersects(this.boundingBox, boundingInfo.boundingBox)) return false;
        if (!precise) return true;
        const box0 = this.boundingBox;
        const box1 = boundingInfo.boundingBox;
        if (!$a5e27a85374b8b23$var$axisOverlap(box0.directions[0], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box0.directions[1], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box0.directions[2], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box1.directions[0], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box1.directions[1], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box1.directions[2], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[0], box1.directions[0]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[0], box1.directions[1]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[0], box1.directions[2]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[1], box1.directions[0]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[1], box1.directions[1]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[1], box1.directions[2]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[2], box1.directions[0]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[2], box1.directions[1]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[2], box1.directions[2]), box0, box1)) return false;
        return true;
    }
}
$a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3 = (0, $opFp4.BuildArray)(2, (0, $ha1VO.Vector3).Zero);



var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $ir0rz = parcelRequire("ir0rz");
// This helper class is only here so we can apply the nativeOverride decorator to functions.
class $14fdbb07a947065f$var$MathHelpers {
    static extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, minimum, maximum) {
        for(let index = indexStart; index < indexStart + indexCount; index++){
            const offset = indices[index] * 3;
            const x = positions[offset];
            const y = positions[offset + 1];
            const z = positions[offset + 2];
            minimum.minimizeInPlaceFromFloats(x, y, z);
            maximum.maximizeInPlaceFromFloats(x, y, z);
        }
    }
    static extractMinAndMax(positions, start, count, stride, minimum, maximum) {
        for(let index = start, offset = start * stride; index < start + count; index++, offset += stride){
            const x = positions[offset];
            const y = positions[offset + 1];
            const z = positions[offset + 2];
            minimum.minimizeInPlaceFromFloats(x, y, z);
            maximum.maximizeInPlaceFromFloats(x, y, z);
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[positions, indices])=>!Array.isArray(positions) && !Array.isArray(indices))
], $14fdbb07a947065f$var$MathHelpers, "extractMinAndMaxIndexed", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[positions])=>!Array.isArray(positions))
], $14fdbb07a947065f$var$MathHelpers, "extractMinAndMax", null);
function $14fdbb07a947065f$export$85b47c2d039f4f24(positions, indices, indexStart, indexCount, bias = null) {
    const minimum = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const maximum = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    $14fdbb07a947065f$var$MathHelpers.extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, minimum, maximum);
    if (bias) {
        minimum.x -= minimum.x * bias.x + bias.y;
        minimum.y -= minimum.y * bias.x + bias.y;
        minimum.z -= minimum.z * bias.x + bias.y;
        maximum.x += maximum.x * bias.x + bias.y;
        maximum.y += maximum.y * bias.x + bias.y;
        maximum.z += maximum.z * bias.x + bias.y;
    }
    return {
        minimum: minimum,
        maximum: maximum
    };
}
function $14fdbb07a947065f$export$e1bada46cc64caed(positions, start, count, bias = null, stride) {
    const minimum = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const maximum = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    if (!stride) stride = 3;
    $14fdbb07a947065f$var$MathHelpers.extractMinAndMax(positions, start, count, stride, minimum, maximum);
    if (bias) {
        minimum.x -= minimum.x * bias.x + bias.y;
        minimum.y -= minimum.y * bias.x + bias.y;
        minimum.z -= minimum.z * bias.x + bias.y;
        maximum.x += maximum.x * bias.x + bias.y;
        maximum.y += maximum.y * bias.x + bias.y;
        maximum.z += maximum.z * bias.x + bias.y;
    }
    return {
        minimum: minimum,
        maximum: maximum
    };
}
function $14fdbb07a947065f$export$32e3945687da8294(positions, indices) {
    const boundingInfo = $14fdbb07a947065f$export$e1bada46cc64caed(positions, 0, positions.length / 3);
    const inside = boundingInfo.maximum.subtract(boundingInfo.minimum).scale(0.5).add(boundingInfo.minimum);
    const tmpVectorA = new (0, $ha1VO.Vector3)();
    const tmpVectorB = new (0, $ha1VO.Vector3)();
    const tmpVectorC = new (0, $ha1VO.Vector3)();
    const tmpVectorAB = new (0, $ha1VO.Vector3)();
    const tmpVectorAC = new (0, $ha1VO.Vector3)();
    const tmpVectorNormal = new (0, $ha1VO.Vector3)();
    const tmpVectorAvgNormal = new (0, $ha1VO.Vector3)();
    // Clean indices
    for(let index = 0; index < indices.length; index += 3){
        const a = indices[index];
        const b = indices[index + 1];
        const c = indices[index + 2];
        // Evaluate face normal
        tmpVectorA.fromArray(positions, a * 3);
        tmpVectorB.fromArray(positions, b * 3);
        tmpVectorC.fromArray(positions, c * 3);
        tmpVectorB.subtractToRef(tmpVectorA, tmpVectorAB);
        tmpVectorC.subtractToRef(tmpVectorA, tmpVectorAC);
        (0, $ha1VO.Vector3).CrossToRef(tmpVectorAB, tmpVectorAC, tmpVectorNormal);
        tmpVectorNormal.normalize();
        // Calculate normal from face center to the inside of the geometry
        const avgX = tmpVectorA.x + tmpVectorB.x + tmpVectorC.x;
        const avgY = tmpVectorA.y + tmpVectorB.y + tmpVectorC.y;
        const avgZ = tmpVectorA.z + tmpVectorB.z + tmpVectorC.z;
        tmpVectorAvgNormal.set(avgX / 3, avgY / 3, avgZ / 3);
        tmpVectorAvgNormal.subtractInPlace(inside);
        tmpVectorAvgNormal.normalize();
        if ((0, $ha1VO.Vector3).Dot(tmpVectorNormal, tmpVectorAvgNormal) >= 0) {
            // Flip!
            indices[index] = c;
            indices[index + 2] = a;
        }
    }
}



var $hOyoX = parcelRequire("hOyoX");
class $fc3ab70ba5c9f506$export$c684db7d654df572 {
    /**
     * Gets material defines used by the effect associated to the sub mesh
     */ get materialDefines() {
        return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.defines : this._getDrawWrapper()?.defines;
    }
    /**
     * Sets material defines used by the effect associated to the sub mesh
     */ set materialDefines(defines) {
        const drawWrapper = this._mainDrawWrapperOverride ?? this._getDrawWrapper(undefined, true);
        drawWrapper.defines = defines;
    }
    /**
     * @internal
     */ _getDrawWrapper(passId, createIfNotExisting = false) {
        passId = passId ?? this._engine.currentRenderPassId;
        let drawWrapper = this._drawWrappers[passId];
        if (!drawWrapper && createIfNotExisting) this._drawWrappers[passId] = drawWrapper = new (0, $hOyoX.DrawWrapper)(this._mesh.getScene().getEngine());
        return drawWrapper;
    }
    /**
     * @internal
     */ _removeDrawWrapper(passId, disposeWrapper = true, immediate = false) {
        if (disposeWrapper) this._drawWrappers[passId]?.dispose(immediate);
        this._drawWrappers[passId] = undefined;
    }
    /**
     * Gets associated (main) effect (possibly the effect override if defined)
     */ get effect() {
        return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.effect : this._getDrawWrapper()?.effect ?? null;
    }
    /** @internal */ get _drawWrapper() {
        return this._mainDrawWrapperOverride ?? this._getDrawWrapper(undefined, true);
    }
    /** @internal */ get _drawWrapperOverride() {
        return this._mainDrawWrapperOverride;
    }
    /**
     * @internal
     */ _setMainDrawWrapperOverride(wrapper) {
        this._mainDrawWrapperOverride = wrapper;
    }
    /**
     * Sets associated effect (effect used to render this submesh)
     * @param effect defines the effect to associate with
     * @param defines defines the set of defines used to compile this effect
     * @param materialContext material context associated to the effect
     * @param resetContext true to reset the draw context
     */ setEffect(effect, defines = null, materialContext, resetContext = true) {
        const drawWrapper = this._drawWrapper;
        drawWrapper.setEffect(effect, defines, resetContext);
        if (materialContext !== undefined) drawWrapper.materialContext = materialContext;
        if (!effect) {
            drawWrapper.defines = null;
            drawWrapper.materialContext = undefined;
        }
    }
    /**
     * Resets the draw wrappers cache
     * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
     * @param immediate If true, the draw wrapper will dispose the effect immediately (false by default)
     */ resetDrawCache(passId, immediate = false) {
        if (this._drawWrappers) {
            if (passId !== undefined) {
                this._removeDrawWrapper(passId, true, immediate);
                return;
            } else for (const drawWrapper of this._drawWrappers)drawWrapper?.dispose(immediate);
        }
        this._drawWrappers = [];
    }
    /**
     * Add a new submesh to a mesh
     * @param materialIndex defines the material index to use
     * @param verticesStart defines vertex index start
     * @param verticesCount defines vertices count
     * @param indexStart defines index start
     * @param indexCount defines indices count
     * @param mesh defines the parent mesh
     * @param renderingMesh defines an optional rendering mesh
     * @param createBoundingBox defines if bounding box should be created for this submesh
     * @returns the new submesh
     */ static AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox = true) {
        return new $fc3ab70ba5c9f506$export$c684db7d654df572(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox);
    }
    /**
     * Creates a new submesh
     * @param materialIndex defines the material index to use
     * @param verticesStart defines vertex index start
     * @param verticesCount defines vertices count
     * @param indexStart defines index start
     * @param indexCount defines indices count
     * @param mesh defines the parent mesh
     * @param renderingMesh defines an optional rendering mesh
     * @param createBoundingBox defines if bounding box should be created for this submesh
     * @param addToMesh defines a boolean indicating that the submesh must be added to the mesh.subMeshes array (true by default)
     */ constructor(/** the material index to use */ materialIndex, /** vertex index start */ verticesStart, /** vertices count */ verticesCount, /** index start */ indexStart, /** indices count */ indexCount, mesh, renderingMesh, createBoundingBox = true, addToMesh = true){
        this.materialIndex = materialIndex;
        this.verticesStart = verticesStart;
        this.verticesCount = verticesCount;
        this.indexStart = indexStart;
        this.indexCount = indexCount;
        this._mainDrawWrapperOverride = null;
        /** @internal */ this._linesIndexCount = 0;
        this._linesIndexBuffer = null;
        /** @internal */ this._lastColliderWorldVertices = null;
        /** @internal */ this._lastColliderTransformMatrix = null;
        /** @internal */ this._wasDispatched = false;
        /** @internal */ this._renderId = 0;
        /** @internal */ this._alphaIndex = 0;
        /** @internal */ this._distanceToCamera = 0;
        this._currentMaterial = null;
        this._mesh = mesh;
        this._renderingMesh = renderingMesh || mesh;
        if (addToMesh) mesh.subMeshes.push(this);
        this._engine = this._mesh.getScene().getEngine();
        this.resetDrawCache();
        this._trianglePlanes = [];
        this._id = mesh.subMeshes.length - 1;
        if (createBoundingBox) {
            this.refreshBoundingInfo();
            mesh.computeWorldMatrix(true);
        }
    }
    /**
     * Returns true if this submesh covers the entire parent mesh
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    get IsGlobal() {
        return this.verticesStart === 0 && this.verticesCount === this._mesh.getTotalVertices() && this.indexStart === 0 && this.indexCount === this._mesh.getTotalIndices();
    }
    /**
     * Returns the submesh BoundingInfo object
     * @returns current bounding info (or mesh's one if the submesh is global)
     */ getBoundingInfo() {
        if (this.IsGlobal || this._mesh.hasThinInstances) return this._mesh.getBoundingInfo();
        return this._boundingInfo;
    }
    /**
     * Sets the submesh BoundingInfo
     * @param boundingInfo defines the new bounding info to use
     * @returns the SubMesh
     */ setBoundingInfo(boundingInfo) {
        this._boundingInfo = boundingInfo;
        return this;
    }
    /**
     * Returns the mesh of the current submesh
     * @returns the parent mesh
     */ getMesh() {
        return this._mesh;
    }
    /**
     * Returns the rendering mesh of the submesh
     * @returns the rendering mesh (could be different from parent mesh)
     */ getRenderingMesh() {
        return this._renderingMesh;
    }
    /**
     * Returns the replacement mesh of the submesh
     * @returns the replacement mesh (could be different from parent mesh)
     */ getReplacementMesh() {
        return this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
    }
    /**
     * Returns the effective mesh of the submesh
     * @returns the effective mesh (could be different from parent mesh)
     */ getEffectiveMesh() {
        const replacementMesh = this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
        return replacementMesh ? replacementMesh : this._renderingMesh;
    }
    /**
     * Returns the submesh material
     * @param getDefaultMaterial Defines whether or not to get the default material if nothing has been defined.
     * @returns null or the current material
     */ getMaterial(getDefaultMaterial = true) {
        const rootMaterial = this._renderingMesh.getMaterialForRenderPass(this._engine.currentRenderPassId) ?? this._renderingMesh.material;
        if (!rootMaterial) return getDefaultMaterial ? this._mesh.getScene().defaultMaterial : null;
        else if (this._isMultiMaterial(rootMaterial)) {
            const effectiveMaterial = rootMaterial.getSubMaterial(this.materialIndex);
            if (this._currentMaterial !== effectiveMaterial) {
                this._currentMaterial = effectiveMaterial;
                this.resetDrawCache();
            }
            return effectiveMaterial;
        }
        return rootMaterial;
    }
    _isMultiMaterial(material) {
        return material.getSubMaterial !== undefined;
    }
    // Methods
    /**
     * Sets a new updated BoundingInfo object to the submesh
     * @param data defines an optional position array to use to determine the bounding info
     * @returns the SubMesh
     */ refreshBoundingInfo(data = null) {
        this._lastColliderWorldVertices = null;
        if (this.IsGlobal || !this._renderingMesh || !this._renderingMesh.geometry) return this;
        if (!data) data = this._renderingMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!data) {
            this._boundingInfo = this._mesh.getBoundingInfo();
            return this;
        }
        const indices = this._renderingMesh.getIndices();
        let extend;
        //is this the only submesh?
        if (this.indexStart === 0 && this.indexCount === indices.length) {
            const boundingInfo = this._renderingMesh.getBoundingInfo();
            //the rendering mesh's bounding info can be used, it is the standard submesh for all indices.
            extend = {
                minimum: boundingInfo.minimum.clone(),
                maximum: boundingInfo.maximum.clone()
            };
        } else extend = (0, $14fdbb07a947065f$export$85b47c2d039f4f24)(data, indices, this.indexStart, this.indexCount, this._renderingMesh.geometry.boundingBias);
        if (this._boundingInfo) this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
        else this._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)(extend.minimum, extend.maximum);
        return this;
    }
    /**
     * @internal
     */ _checkCollision(collider) {
        const boundingInfo = this.getBoundingInfo();
        return boundingInfo._checkCollision(collider);
    }
    /**
     * Updates the submesh BoundingInfo
     * @param world defines the world matrix to use to update the bounding info
     * @returns the submesh
     */ updateBoundingInfo(world) {
        let boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) {
            this.refreshBoundingInfo();
            boundingInfo = this.getBoundingInfo();
        }
        if (boundingInfo) boundingInfo.update(world);
        return this;
    }
    /**
     * True is the submesh bounding box intersects the frustum defined by the passed array of planes.
     * @param frustumPlanes defines the frustum planes
     * @returns true if the submesh is intersecting with the frustum
     */ isInFrustum(frustumPlanes) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) return false;
        return boundingInfo.isInFrustum(frustumPlanes, this._mesh.cullingStrategy);
    }
    /**
     * True is the submesh bounding box is completely inside the frustum defined by the passed array of planes
     * @param frustumPlanes defines the frustum planes
     * @returns true if the submesh is inside the frustum
     */ isCompletelyInFrustum(frustumPlanes) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) return false;
        return boundingInfo.isCompletelyInFrustum(frustumPlanes);
    }
    /**
     * Renders the submesh
     * @param enableAlphaMode defines if alpha needs to be used
     * @returns the submesh
     */ render(enableAlphaMode) {
        this._renderingMesh.render(this, enableAlphaMode, this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : undefined);
        return this;
    }
    /**
     * @internal
     */ _getLinesIndexBuffer(indices, engine) {
        if (!this._linesIndexBuffer) {
            const adjustedIndexCount = Math.floor(this.indexCount / 3) * 6;
            const shouldUseUint32 = this.verticesStart + this.verticesCount > 65535;
            const linesIndices = shouldUseUint32 ? new Uint32Array(adjustedIndexCount) : new Uint16Array(adjustedIndexCount);
            let offset = 0;
            if (indices.length === 0) // Unindexed mesh
            for(let index = this.indexStart; index < this.indexStart + this.indexCount; index += 3){
                linesIndices[offset++] = index;
                linesIndices[offset++] = index + 1;
                linesIndices[offset++] = index + 1;
                linesIndices[offset++] = index + 2;
                linesIndices[offset++] = index + 2;
                linesIndices[offset++] = index;
            }
            else for(let index = this.indexStart; index < this.indexStart + this.indexCount; index += 3){
                linesIndices[offset++] = indices[index];
                linesIndices[offset++] = indices[index + 1];
                linesIndices[offset++] = indices[index + 1];
                linesIndices[offset++] = indices[index + 2];
                linesIndices[offset++] = indices[index + 2];
                linesIndices[offset++] = indices[index];
            }
            this._linesIndexBuffer = engine.createIndexBuffer(linesIndices);
            this._linesIndexCount = linesIndices.length;
        }
        return this._linesIndexBuffer;
    }
    /**
     * Checks if the submesh intersects with a ray
     * @param ray defines the ray to test
     * @returns true is the passed ray intersects the submesh bounding box
     */ canIntersects(ray) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) return false;
        return ray.intersectsBox(boundingInfo.boundingBox);
    }
    /**
     * Intersects current submesh with a ray
     * @param ray defines the ray to test
     * @param positions defines mesh's positions array
     * @param indices defines mesh's indices array
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns intersection info or null if no intersection
     */ intersects(ray, positions, indices, fastCheck, trianglePredicate) {
        const material = this.getMaterial();
        if (!material) return null;
        let step = 3;
        let checkStopper = false;
        switch(material.fillMode){
            case 3:
            case 5:
            case 6:
            case 8:
                return null;
            case 7:
                step = 1;
                checkStopper = true;
                break;
            default:
                break;
        }
        // LineMesh first as it's also a Mesh...
        if (material.fillMode === 4) {
            // Check if mesh is unindexed
            if (!indices.length) return this._intersectUnIndexedLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
            return this._intersectLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
        } else {
            // Check if mesh is unindexed
            if (!indices.length && this._mesh._unIndexed) return this._intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate);
            return this._intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate);
        }
    }
    /**
     * @internal
     */ _intersectLines(ray, positions, indices, intersectionThreshold, fastCheck) {
        let intersectInfo = null;
        // Line test
        for(let index = this.indexStart; index < this.indexStart + this.indexCount; index += 2){
            const p0 = positions[indices[index]];
            const p1 = positions[indices[index + 1]];
            const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
            if (length < 0) continue;
            if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
                intersectInfo = new (0, $da5dace7af8aa5ae$export$3ec28a530ce1ca87)(null, null, length);
                intersectInfo.faceId = index / 2;
                if (fastCheck) break;
            }
        }
        return intersectInfo;
    }
    /**
     * @internal
     */ _intersectUnIndexedLines(ray, positions, indices, intersectionThreshold, fastCheck) {
        let intersectInfo = null;
        // Line test
        for(let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 2){
            const p0 = positions[index];
            const p1 = positions[index + 1];
            const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
            if (length < 0) continue;
            if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
                intersectInfo = new (0, $da5dace7af8aa5ae$export$3ec28a530ce1ca87)(null, null, length);
                intersectInfo.faceId = index / 2;
                if (fastCheck) break;
            }
        }
        return intersectInfo;
    }
    /**
     * @internal
     */ _intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate) {
        let intersectInfo = null;
        // Triangles test
        let faceId = -1;
        for(let index = this.indexStart; index < this.indexStart + this.indexCount - (3 - step); index += step){
            faceId++;
            const indexA = indices[index];
            const indexB = indices[index + 1];
            const indexC = indices[index + 2];
            if (checkStopper && indexC === 0xffffffff) {
                index += 2;
                continue;
            }
            const p0 = positions[indexA];
            const p1 = positions[indexB];
            const p2 = positions[indexC];
            // stay defensive and don't check against undefined positions.
            if (!p0 || !p1 || !p2) continue;
            if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, indexA, indexB, indexC)) continue;
            const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
            if (currentIntersectInfo) {
                if (currentIntersectInfo.distance < 0) continue;
                if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                    intersectInfo = currentIntersectInfo;
                    intersectInfo.faceId = faceId;
                    if (fastCheck) break;
                }
            }
        }
        return intersectInfo;
    }
    /**
     * @internal
     */ _intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate) {
        let intersectInfo = null;
        // Triangles test
        for(let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 3){
            const p0 = positions[index];
            const p1 = positions[index + 1];
            const p2 = positions[index + 2];
            if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, -1, -1, -1)) continue;
            const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
            if (currentIntersectInfo) {
                if (currentIntersectInfo.distance < 0) continue;
                if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                    intersectInfo = currentIntersectInfo;
                    intersectInfo.faceId = index / 3;
                    if (fastCheck) break;
                }
            }
        }
        return intersectInfo;
    }
    /** @internal */ _rebuild() {
        if (this._linesIndexBuffer) this._linesIndexBuffer = null;
    }
    // Clone
    /**
     * Creates a new submesh from the passed mesh
     * @param newMesh defines the new hosting mesh
     * @param newRenderingMesh defines an optional rendering mesh
     * @returns the new submesh
     */ clone(newMesh, newRenderingMesh) {
        const result = new $fc3ab70ba5c9f506$export$c684db7d654df572(this.materialIndex, this.verticesStart, this.verticesCount, this.indexStart, this.indexCount, newMesh, newRenderingMesh, false);
        if (!this.IsGlobal) {
            const boundingInfo = this.getBoundingInfo();
            if (!boundingInfo) return result;
            result._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)(boundingInfo.minimum, boundingInfo.maximum);
        }
        return result;
    }
    // Dispose
    /**
     * Release associated resources
     * @param immediate If true, the effect will be disposed immediately (false by default)
     */ dispose(immediate = false) {
        if (this._linesIndexBuffer) {
            this._mesh.getScene().getEngine()._releaseBuffer(this._linesIndexBuffer);
            this._linesIndexBuffer = null;
        }
        // Remove from mesh
        const index = this._mesh.subMeshes.indexOf(this);
        this._mesh.subMeshes.splice(index, 1);
        this.resetDrawCache(undefined, immediate);
    }
    /**
     * Gets the class name
     * @returns the string "SubMesh".
     */ getClassName() {
        return "SubMesh";
    }
    // Statics
    /**
     * Creates a new submesh from indices data
     * @param materialIndex the index of the main mesh material
     * @param startIndex the index where to start the copy in the mesh indices array
     * @param indexCount the number of indices to copy then from the startIndex
     * @param mesh the main mesh to create the submesh from
     * @param renderingMesh the optional rendering mesh
     * @param createBoundingBox defines if bounding box should be created for this submesh
     * @returns a new submesh
     */ static CreateFromIndices(materialIndex, startIndex, indexCount, mesh, renderingMesh, createBoundingBox = true) {
        let minVertexIndex = Number.MAX_VALUE;
        let maxVertexIndex = -Number.MAX_VALUE;
        const whatWillRender = renderingMesh || mesh;
        const indices = whatWillRender.getIndices();
        for(let index = startIndex; index < startIndex + indexCount; index++){
            const vertexIndex = indices[index];
            if (vertexIndex < minVertexIndex) minVertexIndex = vertexIndex;
            if (vertexIndex > maxVertexIndex) maxVertexIndex = vertexIndex;
        }
        return new $fc3ab70ba5c9f506$export$c684db7d654df572(materialIndex, minVertexIndex, maxVertexIndex - minVertexIndex + 1, startIndex, indexCount, mesh, renderingMesh, createBoundingBox);
    }
}



var $ghoTi = parcelRequire("ghoTi");

var $kVtWi = parcelRequire("kVtWi");

var $23POp = parcelRequire("23POp");

var $hOyoX = parcelRequire("hOyoX");

var $e0Suo = parcelRequire("e0Suo");

var $6Ho1L = parcelRequire("6Ho1L");

var $ir0rz = parcelRequire("ir0rz");
class $5d249d29bbd510f6$export$4fedf983a2fab8f7 {
    /**
     * Creates a material stencil state instance
     */ constructor(){
        this.reset();
    }
    /**
     * Resets all the stencil states to default values
     */ reset() {
        this.enabled = false;
        this.mask = 0xff;
        this.func = 519;
        this.funcRef = 1;
        this.funcMask = 0xff;
        this.opStencilFail = 7680;
        this.opDepthFail = 7680;
        this.opStencilDepthPass = 7681;
    }
    /**
     * Gets or sets the stencil function
     */ get func() {
        return this._func;
    }
    set func(value) {
        this._func = value;
    }
    /**
     * Gets or sets the stencil function reference
     */ get funcRef() {
        return this._funcRef;
    }
    set funcRef(value) {
        this._funcRef = value;
    }
    /**
     * Gets or sets the stencil function mask
     */ get funcMask() {
        return this._funcMask;
    }
    set funcMask(value) {
        this._funcMask = value;
    }
    /**
     * Gets or sets the operation when the stencil test fails
     */ get opStencilFail() {
        return this._opStencilFail;
    }
    set opStencilFail(value) {
        this._opStencilFail = value;
    }
    /**
     * Gets or sets the operation when the depth test fails
     */ get opDepthFail() {
        return this._opDepthFail;
    }
    set opDepthFail(value) {
        this._opDepthFail = value;
    }
    /**
     * Gets or sets the operation when the stencil+depth test succeeds
     */ get opStencilDepthPass() {
        return this._opStencilDepthPass;
    }
    set opStencilDepthPass(value) {
        this._opStencilDepthPass = value;
    }
    /**
     * Gets or sets the stencil mask
     */ get mask() {
        return this._mask;
    }
    set mask(value) {
        this._mask = value;
    }
    /**
     * Enables or disables the stencil test
     */ get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._enabled = value;
    }
    /**
     * Get the current class name, useful for serialization or dynamic coding.
     * @returns "MaterialStencilState"
     */ getClassName() {
        return "MaterialStencilState";
    }
    /**
     * Makes a duplicate of the current configuration into another one.
     * @param stencilState defines stencil state where to copy the info
     */ copyTo(stencilState) {
        (0, $6Ho1L.SerializationHelper).Clone(()=>stencilState, this);
    }
    /**
     * Serializes this stencil configuration.
     * @returns - An object with the serialized config.
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses a stencil state configuration from a serialized object.
     * @param source - Serialized object.
     * @param scene Defines the scene we are parsing for
     * @param rootUrl Defines the rootUrl to load from
     */ parse(source, scene, rootUrl) {
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "func", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "funcRef", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "funcMask", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "opStencilFail", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "opDepthFail", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "opStencilDepthPass", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "mask", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "enabled", null);



var $kVtWi = parcelRequire("kVtWi");

var $7etnY = parcelRequire("7etnY");

var $ejQPp = parcelRequire("ejQPp");

var $1gEbu = parcelRequire("1gEbu");
/** @internal */ function $7b5d4109d15c2b5f$export$959caf24bcfab1fd(uniforms) {
    if (uniforms.indexOf("vClipPlane") === -1) uniforms.push("vClipPlane");
    if (uniforms.indexOf("vClipPlane2") === -1) uniforms.push("vClipPlane2");
    if (uniforms.indexOf("vClipPlane3") === -1) uniforms.push("vClipPlane3");
    if (uniforms.indexOf("vClipPlane4") === -1) uniforms.push("vClipPlane4");
    if (uniforms.indexOf("vClipPlane5") === -1) uniforms.push("vClipPlane5");
    if (uniforms.indexOf("vClipPlane6") === -1) uniforms.push("vClipPlane6");
}
function $7b5d4109d15c2b5f$export$8deac9e8ed5fc6a9(primaryHolder, secondaryHolder, defines) {
    const clipPlane = !!(primaryHolder.clipPlane ?? secondaryHolder.clipPlane);
    const clipPlane2 = !!(primaryHolder.clipPlane2 ?? secondaryHolder.clipPlane2);
    const clipPlane3 = !!(primaryHolder.clipPlane3 ?? secondaryHolder.clipPlane3);
    const clipPlane4 = !!(primaryHolder.clipPlane4 ?? secondaryHolder.clipPlane4);
    const clipPlane5 = !!(primaryHolder.clipPlane5 ?? secondaryHolder.clipPlane5);
    const clipPlane6 = !!(primaryHolder.clipPlane6 ?? secondaryHolder.clipPlane6);
    if (clipPlane) defines.push("#define CLIPPLANE");
    if (clipPlane2) defines.push("#define CLIPPLANE2");
    if (clipPlane3) defines.push("#define CLIPPLANE3");
    if (clipPlane4) defines.push("#define CLIPPLANE4");
    if (clipPlane5) defines.push("#define CLIPPLANE5");
    if (clipPlane6) defines.push("#define CLIPPLANE6");
}
function $7b5d4109d15c2b5f$export$9a3f745585b7389d(primaryHolder, secondaryHolder, defines) {
    let changed = false;
    const clipPlane = !!(primaryHolder.clipPlane ?? secondaryHolder.clipPlane);
    const clipPlane2 = !!(primaryHolder.clipPlane2 ?? secondaryHolder.clipPlane2);
    const clipPlane3 = !!(primaryHolder.clipPlane3 ?? secondaryHolder.clipPlane3);
    const clipPlane4 = !!(primaryHolder.clipPlane4 ?? secondaryHolder.clipPlane4);
    const clipPlane5 = !!(primaryHolder.clipPlane5 ?? secondaryHolder.clipPlane5);
    const clipPlane6 = !!(primaryHolder.clipPlane6 ?? secondaryHolder.clipPlane6);
    // Do not factorize this code, it breaks browsers optimizations.
    if (defines["CLIPPLANE"] !== clipPlane) {
        defines["CLIPPLANE"] = clipPlane;
        changed = true;
    }
    if (defines["CLIPPLANE2"] !== clipPlane2) {
        defines["CLIPPLANE2"] = clipPlane2;
        changed = true;
    }
    if (defines["CLIPPLANE3"] !== clipPlane3) {
        defines["CLIPPLANE3"] = clipPlane3;
        changed = true;
    }
    if (defines["CLIPPLANE4"] !== clipPlane4) {
        defines["CLIPPLANE4"] = clipPlane4;
        changed = true;
    }
    if (defines["CLIPPLANE5"] !== clipPlane5) {
        defines["CLIPPLANE5"] = clipPlane5;
        changed = true;
    }
    if (defines["CLIPPLANE6"] !== clipPlane6) {
        defines["CLIPPLANE6"] = clipPlane6;
        changed = true;
    }
    return changed;
}
function $7b5d4109d15c2b5f$export$99061f41c02073b(effect, primaryHolder, secondaryHolder) {
    let clipPlane = primaryHolder.clipPlane ?? secondaryHolder.clipPlane;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane", clipPlane);
    clipPlane = primaryHolder.clipPlane2 ?? secondaryHolder.clipPlane2;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane2", clipPlane);
    clipPlane = primaryHolder.clipPlane3 ?? secondaryHolder.clipPlane3;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane3", clipPlane);
    clipPlane = primaryHolder.clipPlane4 ?? secondaryHolder.clipPlane4;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane4", clipPlane);
    clipPlane = primaryHolder.clipPlane5 ?? secondaryHolder.clipPlane5;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane5", clipPlane);
    clipPlane = primaryHolder.clipPlane6 ?? secondaryHolder.clipPlane6;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane6", clipPlane);
}
function $7b5d4109d15c2b5f$var$setClipPlane(effect, uniformName, clipPlane) {
    if (clipPlane) effect.setFloat4(uniformName, clipPlane.normal.x, clipPlane.normal.y, clipPlane.normal.z, clipPlane.d);
}


// Temps
const $7893e784ec9add9a$var$_TempFogColor = (0, $7etnY.Color3).Black();
const $7893e784ec9add9a$var$_TmpMorphInfluencers = {
    NUM_MORPH_INFLUENCERS: 0,
    NORMAL: false,
    TANGENT: false,
    UV: false,
    UV2: false
};
function $7893e784ec9add9a$export$c51be962d0cbc5db(defines, effect, scene) {
    if (!defines || defines["LOGARITHMICDEPTH"] || defines.indexOf && defines.indexOf("LOGARITHMICDEPTH") >= 0) {
        const camera = scene.activeCamera;
        if (camera.mode === 1) (0, $kVtWi.Logger).Error("Logarithmic depth is not compatible with orthographic cameras!", 20);
        effect.setFloat("logarithmicDepthConstant", 2.0 / (Math.log(camera.maxZ + 1.0) / Math.LN2));
    }
}
function $7893e784ec9add9a$export$531a83026b679e28(scene, mesh, effect, linearSpace = false) {
    if (effect && scene.fogEnabled && (!mesh || mesh.applyFog) && scene.fogMode !== 0) {
        effect.setFloat4("vFogInfos", scene.fogMode, scene.fogStart, scene.fogEnd, scene.fogDensity);
        // Convert fog color to linear space if used in a linear space computed shader.
        if (linearSpace) {
            scene.fogColor.toLinearSpaceToRef($7893e784ec9add9a$var$_TempFogColor, scene.getEngine().useExactSrgbConversions);
            effect.setColor3("vFogColor", $7893e784ec9add9a$var$_TempFogColor);
        } else effect.setColor3("vFogColor", scene.fogColor);
    }
}
function $7893e784ec9add9a$export$84f21fdc333b90e7(morphTargetManager, defines, attribs, mesh, usePositionMorph, useNormalMorph, useTangentMorph, useUVMorph, useUV2Morph) {
    const numMorphInfluencers = morphTargetManager.numMaxInfluencers || morphTargetManager.numInfluencers;
    if (numMorphInfluencers <= 0) return 0;
    defines.push("#define MORPHTARGETS");
    if (morphTargetManager.hasPositions) defines.push("#define MORPHTARGETTEXTURE_HASPOSITIONS");
    if (morphTargetManager.hasNormals) defines.push("#define MORPHTARGETTEXTURE_HASNORMALS");
    if (morphTargetManager.hasTangents) defines.push("#define MORPHTARGETTEXTURE_HASTANGENTS");
    if (morphTargetManager.hasUVs) defines.push("#define MORPHTARGETTEXTURE_HASUVS");
    if (morphTargetManager.hasUV2s) defines.push("#define MORPHTARGETTEXTURE_HASUV2S");
    if (morphTargetManager.supportsPositions && usePositionMorph) defines.push("#define MORPHTARGETS_POSITION");
    if (morphTargetManager.supportsNormals && useNormalMorph) defines.push("#define MORPHTARGETS_NORMAL");
    if (morphTargetManager.supportsTangents && useTangentMorph) defines.push("#define MORPHTARGETS_TANGENT");
    if (morphTargetManager.supportsUVs && useUVMorph) defines.push("#define MORPHTARGETS_UV");
    if (morphTargetManager.supportsUV2s && useUV2Morph) defines.push("#define MORPHTARGETS_UV2");
    defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
    if (morphTargetManager.isUsingTextureForTargets) defines.push("#define MORPHTARGETS_TEXTURE");
    $7893e784ec9add9a$var$_TmpMorphInfluencers.NUM_MORPH_INFLUENCERS = numMorphInfluencers;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.NORMAL = useNormalMorph;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.TANGENT = useTangentMorph;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.UV = useUVMorph;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.UV2 = useUV2Morph;
    $7893e784ec9add9a$export$3f648d9015556392(attribs, mesh, $7893e784ec9add9a$var$_TmpMorphInfluencers, usePositionMorph);
    return numMorphInfluencers;
}
function $7893e784ec9add9a$export$ad216e1b4044d0a2(attribs, mesh, influencers) {
    $7893e784ec9add9a$var$_TmpMorphInfluencers.NUM_MORPH_INFLUENCERS = influencers;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.NORMAL = false;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.TANGENT = false;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.UV = false;
    $7893e784ec9add9a$var$_TmpMorphInfluencers.UV2 = false;
    $7893e784ec9add9a$export$3f648d9015556392(attribs, mesh, $7893e784ec9add9a$var$_TmpMorphInfluencers, true);
}
function $7893e784ec9add9a$export$3f648d9015556392(attribs, mesh, defines, usePositionMorph = true) {
    const influencers = defines["NUM_MORPH_INFLUENCERS"];
    if (influencers > 0 && (0, $ejQPp.EngineStore).LastCreatedEngine) {
        const maxAttributesCount = (0, $ejQPp.EngineStore).LastCreatedEngine.getCaps().maxVertexAttribs;
        const manager = mesh.morphTargetManager;
        if (manager?.isUsingTextureForTargets) return;
        const position = manager && manager.supportsPositions && usePositionMorph;
        const normal = manager && manager.supportsNormals && defines["NORMAL"];
        const tangent = manager && manager.supportsTangents && defines["TANGENT"];
        const uv = manager && manager.supportsUVs && defines["UV1"];
        const uv2 = manager && manager.supportsUV2s && defines["UV2"];
        for(let index = 0; index < influencers; index++){
            if (position) attribs.push(`position` + index);
            if (normal) attribs.push(`normal` + index);
            if (tangent) attribs.push(`tangent` + index);
            if (uv) attribs.push(`uv` + "_" + index);
            if (uv2) attribs.push(`uv2` + "_" + index);
            if (attribs.length > maxAttributesCount) (0, $kVtWi.Logger).Error("Cannot add more vertex attributes for mesh " + mesh.name);
        }
    }
}
function $7893e784ec9add9a$export$3016ce9563275624(attribs, needsPreviousMatrices = false) {
    attribs.push("world0");
    attribs.push("world1");
    attribs.push("world2");
    attribs.push("world3");
    if (needsPreviousMatrices) {
        attribs.push("previousWorld0");
        attribs.push("previousWorld1");
        attribs.push("previousWorld2");
        attribs.push("previousWorld3");
    }
}
function $7893e784ec9add9a$export$f33581baf6024652(abstractMesh, effect) {
    const manager = abstractMesh.morphTargetManager;
    if (!abstractMesh || !manager) return;
    effect.setFloatArray("morphTargetInfluences", manager.influences);
}
function $7893e784ec9add9a$export$92f8908347587afc(effect, sceneUbo) {
    sceneUbo.bindToEffect(effect, "Scene");
}
function $7893e784ec9add9a$export$a906c176bc893d2a(texture, defines, key) {
    defines._needUVs = true;
    defines[key] = true;
    if (texture.optimizeUVAllocation && texture.getTextureMatrix().isIdentityAs3x2()) {
        defines[key + "DIRECTUV"] = texture.coordinatesIndex + 1;
        defines["MAINUV" + (texture.coordinatesIndex + 1)] = true;
    } else defines[key + "DIRECTUV"] = 0;
}
function $7893e784ec9add9a$export$c335cd4c3275cd5a(texture, uniformBuffer, key) {
    const matrix = texture.getTextureMatrix();
    uniformBuffer.updateMatrix(key + "Matrix", matrix);
}
function $7893e784ec9add9a$export$b48abe8455f59858(attribs, mesh, defines) {
    const enabled = defines["BAKED_VERTEX_ANIMATION_TEXTURE"] && defines["INSTANCES"];
    if (enabled) attribs.push("bakedVertexAnimationSettingsInstanced");
}
// Copies the bones transformation matrices into the target array and returns the target's reference
function $7893e784ec9add9a$var$_CopyBonesTransformationMatrices(source, target) {
    target.set(source);
    return target;
}
function $7893e784ec9add9a$export$1544400469443a89(mesh, effect, prePassConfiguration) {
    if (!effect || !mesh) return;
    if (mesh.computeBonesUsingShaders && effect._bonesComputationForcedToCPU) mesh.computeBonesUsingShaders = false;
    if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
        const skeleton = mesh.skeleton;
        if (skeleton.isUsingTextureForMatrices && effect.getUniformIndex("boneTextureWidth") > -1) {
            const boneTexture = skeleton.getTransformMatrixTexture(mesh);
            effect.setTexture("boneSampler", boneTexture);
            effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
        } else {
            const matrices = skeleton.getTransformMatrices(mesh);
            if (matrices) {
                effect.setMatrices("mBones", matrices);
                if (prePassConfiguration && mesh.getScene().prePassRenderer && mesh.getScene().prePassRenderer.getIndex(2)) {
                    if (!prePassConfiguration.previousBones[mesh.uniqueId]) prePassConfiguration.previousBones[mesh.uniqueId] = matrices.slice();
                    effect.setMatrices("mPreviousBones", prePassConfiguration.previousBones[mesh.uniqueId]);
                    $7893e784ec9add9a$var$_CopyBonesTransformationMatrices(matrices, prePassConfiguration.previousBones[mesh.uniqueId]);
                }
            }
        }
    }
}
function $7893e784ec9add9a$export$2d66eba98da98e84(light, effect, lightIndex) {
    light.transferToEffect(effect, lightIndex + "");
}
function $7893e784ec9add9a$export$dc223d5211922d9c(light, lightIndex, scene, effect, useSpecular, receiveShadows = true) {
    light._bindLight(lightIndex, scene, effect, useSpecular, receiveShadows);
}
function $7893e784ec9add9a$export$c3115b30871adb94(scene, mesh, effect, defines, maxSimultaneousLights = 4) {
    const len = Math.min(mesh.lightSources.length, maxSimultaneousLights);
    for(let i = 0; i < len; i++){
        const light = mesh.lightSources[i];
        $7893e784ec9add9a$export$dc223d5211922d9c(light, i, scene, effect, typeof defines === "boolean" ? defines : defines["SPECULARTERM"], mesh.receiveShadows);
    }
}
function $7893e784ec9add9a$export$71c246cd17c53a0d(attribs, mesh, defines, fallbacks) {
    if (defines["NUM_BONE_INFLUENCERS"] > 0) {
        fallbacks.addCPUSkinningFallback(0, mesh);
        attribs.push(`matricesIndices`);
        attribs.push(`matricesWeights`);
        if (defines["NUM_BONE_INFLUENCERS"] > 4) {
            attribs.push(`matricesIndicesExtra`);
            attribs.push(`matricesWeightsExtra`);
        }
    }
}
function $7893e784ec9add9a$export$f9fb9b44aa29cc31(attribs, defines) {
    if (defines["INSTANCES"] || defines["THIN_INSTANCES"]) $7893e784ec9add9a$export$3016ce9563275624(attribs, !!defines["PREPASS_VELOCITY"]);
    if (defines.INSTANCESCOLOR) attribs.push(`instanceColor`);
}
function $7893e784ec9add9a$export$ae20fd35f0de291d(defines, fallbacks, maxSimultaneousLights = 4, rank = 0) {
    let lightFallbackRank = 0;
    for(let lightIndex = 0; lightIndex < maxSimultaneousLights; lightIndex++){
        if (!defines["LIGHT" + lightIndex]) break;
        if (lightIndex > 0) {
            lightFallbackRank = rank + lightIndex;
            fallbacks.addFallback(lightFallbackRank, "LIGHT" + lightIndex);
        }
        if (!defines["SHADOWS"]) {
            if (defines["SHADOW" + lightIndex]) fallbacks.addFallback(rank, "SHADOW" + lightIndex);
            if (defines["SHADOWPCF" + lightIndex]) fallbacks.addFallback(rank, "SHADOWPCF" + lightIndex);
            if (defines["SHADOWPCSS" + lightIndex]) fallbacks.addFallback(rank, "SHADOWPCSS" + lightIndex);
            if (defines["SHADOWPOISSON" + lightIndex]) fallbacks.addFallback(rank, "SHADOWPOISSON" + lightIndex);
            if (defines["SHADOWESM" + lightIndex]) fallbacks.addFallback(rank, "SHADOWESM" + lightIndex);
            if (defines["SHADOWCLOSEESM" + lightIndex]) fallbacks.addFallback(rank, "SHADOWCLOSEESM" + lightIndex);
        }
    }
    return lightFallbackRank++;
}
function $7893e784ec9add9a$export$d5d977fc33c7973(mesh, scene) {
    return scene.fogEnabled && mesh.applyFog && scene.fogMode !== 0;
}
function $7893e784ec9add9a$export$a000bd067dd304c2(mesh, scene, useLogarithmicDepth, pointsCloud, fogEnabled, alphaTest, defines, applyDecalAfterDetail = false) {
    if (defines._areMiscDirty) {
        defines["LOGARITHMICDEPTH"] = useLogarithmicDepth;
        defines["POINTSIZE"] = pointsCloud;
        defines["FOG"] = fogEnabled && $7893e784ec9add9a$export$d5d977fc33c7973(mesh, scene);
        defines["NONUNIFORMSCALING"] = mesh.nonUniformScaling;
        defines["ALPHATEST"] = alphaTest;
        defines["DECAL_AFTER_DETAIL"] = applyDecalAfterDetail;
    }
}
function $7893e784ec9add9a$export$9810631b9b84b23d(scene, mesh, defines, specularSupported, maxSimultaneousLights = 4, disableLighting = false) {
    if (!defines._areLightsDirty) return defines._needNormals;
    let lightIndex = 0;
    const state = {
        needNormals: defines._needNormals,
        needRebuild: false,
        lightmapMode: false,
        shadowEnabled: false,
        specularEnabled: false
    };
    if (scene.lightsEnabled && !disableLighting) for (const light of mesh.lightSources){
        $7893e784ec9add9a$export$14850268f573bb88(scene, mesh, light, lightIndex, defines, specularSupported, state);
        lightIndex++;
        if (lightIndex === maxSimultaneousLights) break;
    }
    defines["SPECULARTERM"] = state.specularEnabled;
    defines["SHADOWS"] = state.shadowEnabled;
    // Resetting all other lights if any
    for(let index = lightIndex; index < maxSimultaneousLights; index++)if (defines["LIGHT" + index] !== undefined) {
        defines["LIGHT" + index] = false;
        defines["HEMILIGHT" + index] = false;
        defines["POINTLIGHT" + index] = false;
        defines["DIRLIGHT" + index] = false;
        defines["SPOTLIGHT" + index] = false;
        defines["AREALIGHT" + index] = false;
        defines["SHADOW" + index] = false;
        defines["SHADOWCSM" + index] = false;
        defines["SHADOWCSMDEBUG" + index] = false;
        defines["SHADOWCSMNUM_CASCADES" + index] = false;
        defines["SHADOWCSMUSESHADOWMAXZ" + index] = false;
        defines["SHADOWCSMNOBLEND" + index] = false;
        defines["SHADOWCSM_RIGHTHANDED" + index] = false;
        defines["SHADOWPCF" + index] = false;
        defines["SHADOWPCSS" + index] = false;
        defines["SHADOWPOISSON" + index] = false;
        defines["SHADOWESM" + index] = false;
        defines["SHADOWCLOSEESM" + index] = false;
        defines["SHADOWCUBE" + index] = false;
        defines["SHADOWLOWQUALITY" + index] = false;
        defines["SHADOWMEDIUMQUALITY" + index] = false;
    }
    const caps = scene.getEngine().getCaps();
    if (defines["SHADOWFLOAT"] === undefined) state.needRebuild = true;
    defines["SHADOWFLOAT"] = state.shadowEnabled && (caps.textureFloatRender && caps.textureFloatLinearFiltering || caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering);
    defines["LIGHTMAPEXCLUDED"] = state.lightmapMode;
    if (state.needRebuild) defines.rebuild();
    return state.needNormals;
}
function $7893e784ec9add9a$export$14850268f573bb88(scene, mesh, light, lightIndex, defines, specularSupported, state) {
    state.needNormals = true;
    if (defines["LIGHT" + lightIndex] === undefined) state.needRebuild = true;
    defines["LIGHT" + lightIndex] = true;
    defines["SPOTLIGHT" + lightIndex] = false;
    defines["HEMILIGHT" + lightIndex] = false;
    defines["POINTLIGHT" + lightIndex] = false;
    defines["DIRLIGHT" + lightIndex] = false;
    defines["AREALIGHT" + lightIndex] = false;
    light.prepareLightSpecificDefines(defines, lightIndex);
    // FallOff.
    defines["LIGHT_FALLOFF_PHYSICAL" + lightIndex] = false;
    defines["LIGHT_FALLOFF_GLTF" + lightIndex] = false;
    defines["LIGHT_FALLOFF_STANDARD" + lightIndex] = false;
    switch(light.falloffType){
        case (0, $1gEbu.LightConstants).FALLOFF_GLTF:
            defines["LIGHT_FALLOFF_GLTF" + lightIndex] = true;
            break;
        case (0, $1gEbu.LightConstants).FALLOFF_PHYSICAL:
            defines["LIGHT_FALLOFF_PHYSICAL" + lightIndex] = true;
            break;
        case (0, $1gEbu.LightConstants).FALLOFF_STANDARD:
            defines["LIGHT_FALLOFF_STANDARD" + lightIndex] = true;
            break;
    }
    // Specular
    if (specularSupported && !light.specular.equalsFloats(0, 0, 0)) state.specularEnabled = true;
    // Shadows
    defines["SHADOW" + lightIndex] = false;
    defines["SHADOWCSM" + lightIndex] = false;
    defines["SHADOWCSMDEBUG" + lightIndex] = false;
    defines["SHADOWCSMNUM_CASCADES" + lightIndex] = false;
    defines["SHADOWCSMUSESHADOWMAXZ" + lightIndex] = false;
    defines["SHADOWCSMNOBLEND" + lightIndex] = false;
    defines["SHADOWCSM_RIGHTHANDED" + lightIndex] = false;
    defines["SHADOWPCF" + lightIndex] = false;
    defines["SHADOWPCSS" + lightIndex] = false;
    defines["SHADOWPOISSON" + lightIndex] = false;
    defines["SHADOWESM" + lightIndex] = false;
    defines["SHADOWCLOSEESM" + lightIndex] = false;
    defines["SHADOWCUBE" + lightIndex] = false;
    defines["SHADOWLOWQUALITY" + lightIndex] = false;
    defines["SHADOWMEDIUMQUALITY" + lightIndex] = false;
    if (mesh && mesh.receiveShadows && scene.shadowsEnabled && light.shadowEnabled) {
        const shadowGenerator = light.getShadowGenerator(scene.activeCamera) ?? light.getShadowGenerator();
        if (shadowGenerator) {
            const shadowMap = shadowGenerator.getShadowMap();
            if (shadowMap) {
                if (shadowMap.renderList && shadowMap.renderList.length > 0) {
                    state.shadowEnabled = true;
                    shadowGenerator.prepareDefines(defines, lightIndex);
                }
            }
        }
    }
    if (light.lightmapMode != (0, $1gEbu.LightConstants).LIGHTMAP_DEFAULT) {
        state.lightmapMode = true;
        defines["LIGHTMAPEXCLUDED" + lightIndex] = true;
        defines["LIGHTMAPNOSPECULAR" + lightIndex] = light.lightmapMode == (0, $1gEbu.LightConstants).LIGHTMAP_SHADOWSONLY;
    } else {
        defines["LIGHTMAPEXCLUDED" + lightIndex] = false;
        defines["LIGHTMAPNOSPECULAR" + lightIndex] = false;
    }
}
function $7893e784ec9add9a$export$40fda531e0d45992(scene, engine, material, defines, useInstances, useClipPlane = null, useThinInstances = false) {
    let changed = $7893e784ec9add9a$export$4229761abe9cca61(scene, defines);
    if (useClipPlane !== false) changed = (0, $7b5d4109d15c2b5f$export$9a3f745585b7389d)(material, scene, defines);
    if (defines["DEPTHPREPASS"] !== !engine.getColorWrite()) {
        defines["DEPTHPREPASS"] = !defines["DEPTHPREPASS"];
        changed = true;
    }
    if (defines["INSTANCES"] !== useInstances) {
        defines["INSTANCES"] = useInstances;
        changed = true;
    }
    if (defines["THIN_INSTANCES"] !== useThinInstances) {
        defines["THIN_INSTANCES"] = useThinInstances;
        changed = true;
    }
    if (changed) defines.markAsUnprocessed();
}
function $7893e784ec9add9a$export$af9ee06238217031(mesh, defines) {
    if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
        defines["NUM_BONE_INFLUENCERS"] = mesh.numBoneInfluencers;
        const materialSupportsBoneTexture = defines["BONETEXTURE"] !== undefined;
        if (mesh.skeleton.isUsingTextureForMatrices && materialSupportsBoneTexture) defines["BONETEXTURE"] = true;
        else {
            defines["BonesPerMesh"] = mesh.skeleton.bones.length + 1;
            defines["BONETEXTURE"] = materialSupportsBoneTexture ? false : undefined;
            const prePassRenderer = mesh.getScene().prePassRenderer;
            if (prePassRenderer && prePassRenderer.enabled) {
                const nonExcluded = prePassRenderer.excludedSkinnedMesh.indexOf(mesh) === -1;
                defines["BONES_VELOCITY_ENABLED"] = nonExcluded;
            }
        }
    } else {
        defines["NUM_BONE_INFLUENCERS"] = 0;
        defines["BonesPerMesh"] = 0;
        if (defines["BONETEXTURE"] !== undefined) defines["BONETEXTURE"] = false;
    }
}
function $7893e784ec9add9a$export$3f96155d9d03dc3d(mesh, defines) {
    const manager = mesh.morphTargetManager;
    if (manager) {
        defines["MORPHTARGETS_UV"] = manager.supportsUVs && defines["UV1"];
        defines["MORPHTARGETS_UV2"] = manager.supportsUV2s && defines["UV2"];
        defines["MORPHTARGETS_TANGENT"] = manager.supportsTangents && defines["TANGENT"];
        defines["MORPHTARGETS_NORMAL"] = manager.supportsNormals && defines["NORMAL"];
        defines["MORPHTARGETS_POSITION"] = manager.supportsPositions;
        defines["MORPHTARGETTEXTURE_HASUVS"] = manager.hasUVs;
        defines["MORPHTARGETTEXTURE_HASUV2S"] = manager.hasUV2s;
        defines["MORPHTARGETTEXTURE_HASTANGENTS"] = manager.hasTangents;
        defines["MORPHTARGETTEXTURE_HASNORMALS"] = manager.hasNormals;
        defines["MORPHTARGETTEXTURE_HASPOSITIONS"] = manager.hasPositions;
        defines["NUM_MORPH_INFLUENCERS"] = manager.numMaxInfluencers || manager.numInfluencers;
        defines["MORPHTARGETS"] = defines["NUM_MORPH_INFLUENCERS"] > 0;
        defines["MORPHTARGETS_TEXTURE"] = manager.isUsingTextureForTargets;
    } else {
        defines["MORPHTARGETS_UV"] = false;
        defines["MORPHTARGETS_UV2"] = false;
        defines["MORPHTARGETS_TANGENT"] = false;
        defines["MORPHTARGETS_NORMAL"] = false;
        defines["MORPHTARGETS_POSITION"] = false;
        defines["MORPHTARGETTEXTURE_HASUVS"] = false;
        defines["MORPHTARGETTEXTURE_HASUV2S"] = false;
        defines["MORPHTARGETTEXTURE_HASTANGENTS"] = false;
        defines["MORPHTARGETTEXTURE_HASNORMALS"] = false;
        defines["MORPHTARGETTEXTURE_HASPOSITIONS"] = false;
        defines["MORPHTARGETS"] = false;
        defines["NUM_MORPH_INFLUENCERS"] = 0;
    }
}
function $7893e784ec9add9a$export$ac9079f07ec6c77a(mesh, defines) {
    const manager = mesh.bakedVertexAnimationManager;
    defines["BAKED_VERTEX_ANIMATION_TEXTURE"] = manager && manager.isEnabled ? true : false;
}
function $7893e784ec9add9a$export$9bf973b33bf006f1(mesh, defines, useVertexColor, useBones, useMorphTargets = false, useVertexAlpha = true, useBakedVertexAnimation = true) {
    if (!defines._areAttributesDirty && defines._needNormals === defines._normals && defines._needUVs === defines._uvs) return false;
    defines._normals = defines._needNormals;
    defines._uvs = defines._needUVs;
    defines["NORMAL"] = defines._needNormals && mesh.isVerticesDataPresent(`normal`);
    if (defines._needNormals && mesh.isVerticesDataPresent(`tangent`)) defines["TANGENT"] = true;
    for(let i = 1; i <= 6; ++i)defines["UV" + i] = defines._needUVs ? mesh.isVerticesDataPresent(`uv${i === 1 ? "" : i}`) : false;
    if (useVertexColor) {
        const hasVertexColors = mesh.useVertexColors && mesh.isVerticesDataPresent(`color`);
        defines["VERTEXCOLOR"] = hasVertexColors;
        defines["VERTEXALPHA"] = mesh.hasVertexAlpha && hasVertexColors && useVertexAlpha;
    }
    if (mesh.isVerticesDataPresent(`instanceColor`) && (mesh.hasInstances || mesh.hasThinInstances)) defines["INSTANCESCOLOR"] = true;
    if (useBones) $7893e784ec9add9a$export$af9ee06238217031(mesh, defines);
    if (useMorphTargets) $7893e784ec9add9a$export$3f96155d9d03dc3d(mesh, defines);
    if (useBakedVertexAnimation) $7893e784ec9add9a$export$ac9079f07ec6c77a(mesh, defines);
    return true;
}
function $7893e784ec9add9a$export$55684373b0a692af(scene, defines) {
    if (scene.activeCamera) {
        const previousMultiview = defines.MULTIVIEW;
        defines.MULTIVIEW = scene.activeCamera.outputRenderTarget !== null && scene.activeCamera.outputRenderTarget.getViewCount() > 1;
        if (defines.MULTIVIEW != previousMultiview) defines.markAsUnprocessed();
    }
}
function $7893e784ec9add9a$export$667351a72233f2a3(scene, defines, needAlphaBlending) {
    const previousDefine = defines.ORDER_INDEPENDENT_TRANSPARENCY;
    const previousDefine16Bits = defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS;
    defines.ORDER_INDEPENDENT_TRANSPARENCY = scene.useOrderIndependentTransparency && needAlphaBlending;
    defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = !scene.getEngine().getCaps().textureFloatLinearFiltering;
    if (previousDefine !== defines.ORDER_INDEPENDENT_TRANSPARENCY || previousDefine16Bits !== defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS) defines.markAsUnprocessed();
}
function $7893e784ec9add9a$export$73d6edd5c9bebe3d(scene, defines, canRenderToMRT) {
    const previousPrePass = defines.PREPASS;
    if (!defines._arePrePassDirty) return;
    const texturesList = [
        {
            type: 1,
            define: "PREPASS_POSITION",
            index: "PREPASS_POSITION_INDEX"
        },
        {
            type: 9,
            define: "PREPASS_LOCAL_POSITION",
            index: "PREPASS_LOCAL_POSITION_INDEX"
        },
        {
            type: 2,
            define: "PREPASS_VELOCITY",
            index: "PREPASS_VELOCITY_INDEX"
        },
        {
            type: 11,
            define: "PREPASS_VELOCITY_LINEAR",
            index: "PREPASS_VELOCITY_LINEAR_INDEX"
        },
        {
            type: 3,
            define: "PREPASS_REFLECTIVITY",
            index: "PREPASS_REFLECTIVITY_INDEX"
        },
        {
            type: 0,
            define: "PREPASS_IRRADIANCE",
            index: "PREPASS_IRRADIANCE_INDEX"
        },
        {
            type: 7,
            define: "PREPASS_ALBEDO_SQRT",
            index: "PREPASS_ALBEDO_SQRT_INDEX"
        },
        {
            type: 5,
            define: "PREPASS_DEPTH",
            index: "PREPASS_DEPTH_INDEX"
        },
        {
            type: 10,
            define: "PREPASS_SCREENSPACE_DEPTH",
            index: "PREPASS_SCREENSPACE_DEPTH_INDEX"
        },
        {
            type: 6,
            define: "PREPASS_NORMAL",
            index: "PREPASS_NORMAL_INDEX"
        },
        {
            type: 8,
            define: "PREPASS_WORLD_NORMAL",
            index: "PREPASS_WORLD_NORMAL_INDEX"
        }
    ];
    if (scene.prePassRenderer && scene.prePassRenderer.enabled && canRenderToMRT) {
        defines.PREPASS = true;
        defines.SCENE_MRT_COUNT = scene.prePassRenderer.mrtCount;
        defines.PREPASS_NORMAL_WORLDSPACE = scene.prePassRenderer.generateNormalsInWorldSpace;
        defines.PREPASS_COLOR = true;
        defines.PREPASS_COLOR_INDEX = 0;
        for(let i = 0; i < texturesList.length; i++){
            const index = scene.prePassRenderer.getIndex(texturesList[i].type);
            if (index !== -1) {
                defines[texturesList[i].define] = true;
                defines[texturesList[i].index] = index;
            } else defines[texturesList[i].define] = false;
        }
    } else {
        defines.PREPASS = false;
        for(let i = 0; i < texturesList.length; i++)defines[texturesList[i].define] = false;
    }
    if (defines.PREPASS != previousPrePass) {
        defines.markAsUnprocessed();
        defines.markAsImageProcessingDirty();
    }
}
function $7893e784ec9add9a$export$4229761abe9cca61(scene, defines) {
    let changed = false;
    if (scene.activeCamera) {
        const wasOrtho = defines["CAMERA_ORTHOGRAPHIC"] ? 1 : 0;
        const wasPersp = defines["CAMERA_PERSPECTIVE"] ? 1 : 0;
        const isOrtho = scene.activeCamera.mode === 1 ? 1 : 0;
        const isPersp = scene.activeCamera.mode === 0 ? 1 : 0;
        if (wasOrtho ^ isOrtho || wasPersp ^ isPersp) {
            defines["CAMERA_ORTHOGRAPHIC"] = isOrtho === 1;
            defines["CAMERA_PERSPECTIVE"] = isPersp === 1;
            changed = true;
        }
    }
    return changed;
}
function $7893e784ec9add9a$export$5ae312277f42b016(lightIndex, uniformsList, samplersList, projectedLightTexture, uniformBuffersList = null, updateOnlyBuffersList = false, iesLightTexture = false) {
    if (uniformBuffersList) uniformBuffersList.push("Light" + lightIndex);
    if (updateOnlyBuffersList) return;
    uniformsList.push("vLightData" + lightIndex, "vLightDiffuse" + lightIndex, "vLightSpecular" + lightIndex, "vLightDirection" + lightIndex, "vLightWidth" + lightIndex, "vLightHeight" + lightIndex, "vLightFalloff" + lightIndex, "vLightGround" + lightIndex, "lightMatrix" + lightIndex, "shadowsInfo" + lightIndex, "depthValues" + lightIndex);
    samplersList.push("shadowTexture" + lightIndex);
    samplersList.push("depthTexture" + lightIndex);
    uniformsList.push("viewFrustumZ" + lightIndex, "cascadeBlendFactor" + lightIndex, "lightSizeUVCorrection" + lightIndex, "depthCorrection" + lightIndex, "penumbraDarkness" + lightIndex, "frustumLengths" + lightIndex);
    if (projectedLightTexture) {
        samplersList.push("projectionLightTexture" + lightIndex);
        uniformsList.push("textureProjectionMatrix" + lightIndex);
    }
    if (iesLightTexture) samplersList.push("iesLightTexture" + lightIndex);
}
function $7893e784ec9add9a$export$8c6b0867b1144725(uniformsListOrOptions, samplersList, defines, maxSimultaneousLights = 4) {
    let uniformsList;
    let uniformBuffersList = null;
    if (uniformsListOrOptions.uniformsNames) {
        const options = uniformsListOrOptions;
        uniformsList = options.uniformsNames;
        uniformBuffersList = options.uniformBuffersNames;
        samplersList = options.samplers;
        defines = options.defines;
        maxSimultaneousLights = options.maxSimultaneousLights || 0;
    } else {
        uniformsList = uniformsListOrOptions;
        if (!samplersList) samplersList = [];
    }
    for(let lightIndex = 0; lightIndex < maxSimultaneousLights; lightIndex++){
        if (!defines["LIGHT" + lightIndex]) break;
        $7893e784ec9add9a$export$5ae312277f42b016(lightIndex, uniformsList, samplersList, defines["PROJECTEDLIGHTTEXTURE" + lightIndex], uniformBuffersList, false, defines["IESLIGHTTEXTURE" + lightIndex]);
    }
    if (defines["NUM_MORPH_INFLUENCERS"]) {
        uniformsList.push("morphTargetInfluences");
        uniformsList.push("morphTargetCount");
    }
    if (defines["BAKED_VERTEX_ANIMATION_TEXTURE"]) {
        uniformsList.push("bakedVertexAnimationSettings");
        uniformsList.push("bakedVertexAnimationTextureSizeInverted");
        uniformsList.push("bakedVertexAnimationTime");
        samplersList.push("bakedVertexAnimationTexture");
    }
}



var $6Ho1L = parcelRequire("6Ho1L");
class $3afee756ef198914$export$a2d8b23205c25948 {
    /** @internal */ get _supportGlowLayer() {
        return false;
    }
    /** @internal */ set _glowModeEnabled(value) {
    // Do nothing here
    }
    /**
     * Gets the shader language used in this material.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * If the material can be rendered to several textures with MRT extension
     */ get canRenderToMRT() {
        // By default, shaders are not compatible with MRTs
        // Base classes should override that if their shader supports MRT
        return false;
    }
    /**
     * Sets the alpha value of the material
     */ set alpha(value) {
        if (this._alpha === value) return;
        const oldValue = this._alpha;
        this._alpha = value;
        // Only call dirty when there is a state change (no alpha / alpha)
        if (oldValue === 1 || value === 1) this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag + $3afee756ef198914$export$a2d8b23205c25948.PrePassDirtyFlag);
    }
    /**
     * Gets the alpha value of the material
     */ get alpha() {
        return this._alpha;
    }
    /**
     * Sets the culling state (true to enable culling, false to disable)
     */ set backFaceCulling(value) {
        if (this._backFaceCulling === value) return;
        this._backFaceCulling = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag);
    }
    /**
     * Gets the culling state
     */ get backFaceCulling() {
        return this._backFaceCulling;
    }
    /**
     * Sets the type of faces that should be culled (true for back faces, false for front faces)
     */ set cullBackFaces(value) {
        if (this._cullBackFaces === value) return;
        this._cullBackFaces = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag);
    }
    /**
     * Gets the type of faces that should be culled
     */ get cullBackFaces() {
        return this._cullBackFaces;
    }
    /**
     * Block the dirty-mechanism for this specific material
     * When set to false after being true the material will be marked as dirty.
     */ get blockDirtyMechanism() {
        return this._blockDirtyMechanism;
    }
    set blockDirtyMechanism(value) {
        if (this._blockDirtyMechanism === value) return;
        this._blockDirtyMechanism = value;
        if (!value) this.markDirty();
    }
    /**
     * This allows you to modify the material without marking it as dirty after every change.
     * This function should be used if you need to make more than one dirty-enabling change to the material - adding a texture, setting a new fill mode and so on.
     * The callback will pass the material as an argument, so you can make your changes to it.
     * @param callback the callback to be executed that will update the material
     */ atomicMaterialsUpdate(callback) {
        this.blockDirtyMechanism = true;
        try {
            callback(this);
        } finally{
            this.blockDirtyMechanism = false;
        }
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        this._eventInfo.hasRenderTargetTextures = false;
        this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
        return this._eventInfo.hasRenderTargetTextures;
    }
    /**
     * Called during a dispose event
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * An event triggered when the material is bound
     */ get onBindObservable() {
        if (!this._onBindObservable) this._onBindObservable = new (0, $diGQf.Observable)();
        return this._onBindObservable;
    }
    /**
     * Called during a bind event
     */ set onBind(callback) {
        if (this._onBindObserver) this.onBindObservable.remove(this._onBindObserver);
        this._onBindObserver = this.onBindObservable.add(callback);
    }
    /**
     * An event triggered when the material is unbound
     */ get onUnBindObservable() {
        if (!this._onUnBindObservable) this._onUnBindObservable = new (0, $diGQf.Observable)();
        return this._onUnBindObservable;
    }
    /**
     * An event triggered when the effect is (re)created
     */ get onEffectCreatedObservable() {
        if (!this._onEffectCreatedObservable) this._onEffectCreatedObservable = new (0, $diGQf.Observable)();
        return this._onEffectCreatedObservable;
    }
    /**
     * Sets the value of the alpha mode.
     *
     * | Value | Type | Description |
     * | --- | --- | --- |
     * | 0 | ALPHA_DISABLE |   |
     * | 1 | ALPHA_ADD |   |
     * | 2 | ALPHA_COMBINE |   |
     * | 3 | ALPHA_SUBTRACT |   |
     * | 4 | ALPHA_MULTIPLY |   |
     * | 5 | ALPHA_MAXIMIZED |   |
     * | 6 | ALPHA_ONEONE |   |
     * | 7 | ALPHA_PREMULTIPLIED |   |
     * | 8 | ALPHA_PREMULTIPLIED_PORTERDUFF |   |
     * | 9 | ALPHA_INTERPOLATE |   |
     * | 10 | ALPHA_SCREENMODE |   |
     *
     */ set alphaMode(value) {
        if (this._alphaMode === value) return;
        this._alphaMode = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag);
    }
    /**
     * Gets the value of the alpha mode
     */ get alphaMode() {
        return this._alphaMode;
    }
    /**
     * Sets the need depth pre-pass value
     */ set needDepthPrePass(value) {
        if (this._needDepthPrePass === value) return;
        this._needDepthPrePass = value;
        if (this._needDepthPrePass) this.checkReadyOnEveryCall = true;
    }
    /**
     * Gets the depth pre-pass value
     */ get needDepthPrePass() {
        return this._needDepthPrePass;
    }
    /**
     * Can this material render to prepass
     */ get isPrePassCapable() {
        return false;
    }
    /**
     * Sets the state for enabling fog
     */ set fogEnabled(value) {
        if (this._fogEnabled === value) return;
        this._fogEnabled = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag);
    }
    /**
     * Gets the value of the fog enabled state
     */ get fogEnabled() {
        return this._fogEnabled;
    }
    get wireframe() {
        switch(this._fillMode){
            case $3afee756ef198914$export$a2d8b23205c25948.WireFrameFillMode:
            case $3afee756ef198914$export$a2d8b23205c25948.LineListDrawMode:
            case $3afee756ef198914$export$a2d8b23205c25948.LineLoopDrawMode:
            case $3afee756ef198914$export$a2d8b23205c25948.LineStripDrawMode:
                return true;
        }
        return this._scene.forceWireframe;
    }
    /**
     * Sets the state of wireframe mode
     */ set wireframe(value) {
        this.fillMode = value ? $3afee756ef198914$export$a2d8b23205c25948.WireFrameFillMode : $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode;
    }
    /**
     * Gets the value specifying if point clouds are enabled
     */ get pointsCloud() {
        switch(this._fillMode){
            case $3afee756ef198914$export$a2d8b23205c25948.PointFillMode:
            case $3afee756ef198914$export$a2d8b23205c25948.PointListDrawMode:
                return true;
        }
        return this._scene.forcePointsCloud;
    }
    /**
     * Sets the state of point cloud mode
     */ set pointsCloud(value) {
        this.fillMode = value ? $3afee756ef198914$export$a2d8b23205c25948.PointFillMode : $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode;
    }
    /**
     * Gets the material fill mode
     */ get fillMode() {
        return this._fillMode;
    }
    /**
     * Sets the material fill mode
     */ set fillMode(value) {
        if (this._fillMode === value) return;
        this._fillMode = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag);
    }
    /**
     * In case the depth buffer does not allow enough depth precision for your scene (might be the case in large scenes)
     * You can try switching to logarithmic depth.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/logarithmicDepthBuffer
     */ get useLogarithmicDepth() {
        return this._useLogarithmicDepth;
    }
    set useLogarithmicDepth(value) {
        const fragmentDepthSupported = this.getScene().getEngine().getCaps().fragmentDepthSupported;
        if (value && !fragmentDepthSupported) (0, $kVtWi.Logger).Warn("Logarithmic depth has been requested for a material on a device that doesn't support it.");
        this._useLogarithmicDepth = value && fragmentDepthSupported;
        this._markAllSubMeshesAsMiscDirty();
    }
    /** @internal */ _getDrawWrapper() {
        return this._drawWrapper;
    }
    /**
     * @internal
     */ _setDrawWrapper(drawWrapper) {
        this._drawWrapper = drawWrapper;
    }
    /**
     * Creates a material instance
     * @param name defines the name of the material
     * @param scene defines the scene to reference
     * @param doNotAdd specifies if the material should be added to the scene
     * @param forceGLSL Use the GLSL code generation for the shader (even on WebGPU). Default is false
     */ constructor(name, scene, doNotAdd, forceGLSL = false){
        /**
         * Custom shadow depth material to use for shadow rendering instead of the in-built one
         */ this.shadowDepthWrapper = null;
        /**
         * Gets or sets a boolean indicating that the material is allowed (if supported) to do shader hot swapping.
         * This means that the material can keep using a previous shader while a new one is being compiled.
         * This is mostly used when shader parallel compilation is supported (true by default)
         */ this.allowShaderHotSwapping = true;
        /** Shader language used by the material */ this._shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
        this._forceGLSL = false;
        /**
         * Gets or sets user defined metadata
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        /**
         * Specifies if the ready state should be checked on each call
         */ this.checkReadyOnEveryCall = false;
        /**
         * Specifies if the ready state should be checked once
         */ this.checkReadyOnlyOnce = false;
        /**
         * The state of the material
         */ this.state = "";
        /**
         * The alpha value of the material
         */ this._alpha = 1.0;
        /**
         * Specifies if back face culling is enabled
         */ this._backFaceCulling = true;
        /**
         * Specifies if back or front faces should be culled (when culling is enabled)
         */ this._cullBackFaces = true;
        this._blockDirtyMechanism = false;
        /**
         * Stores the value for side orientation
         */ this.sideOrientation = null;
        /**
         * Callback triggered when the material is compiled
         */ this.onCompiled = null;
        /**
         * Callback triggered when an error occurs
         */ this.onError = null;
        /**
         * Callback triggered to get the render target textures
         */ this.getRenderTargetTextures = null;
        /**
         * Specifies if the material should be serialized
         */ this.doNotSerialize = false;
        /**
         * @internal
         */ this._storeEffectOnSubMeshes = false;
        /**
         * Stores the animations for the material
         */ this.animations = null;
        /**
         * An event triggered when the material is disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An observer which watches for dispose events
         */ this._onDisposeObserver = null;
        this._onUnBindObservable = null;
        /**
         * An observer which watches for bind events
         */ this._onBindObserver = null;
        /**
         * Stores the value of the alpha mode
         */ this._alphaMode = 2;
        /**
         * Stores the state of the need depth pre-pass value
         */ this._needDepthPrePass = false;
        /**
         * Specifies if depth writing should be disabled
         */ this.disableDepthWrite = false;
        /**
         * Specifies if color writing should be disabled
         */ this.disableColorWrite = false;
        /**
         * Specifies if depth writing should be forced
         */ this.forceDepthWrite = false;
        /**
         * Specifies the depth function that should be used. 0 means the default engine function
         */ this.depthFunction = 0;
        /**
         * Specifies if there should be a separate pass for culling
         */ this.separateCullingPass = false;
        /**
         * Stores the state specifying if fog should be enabled
         */ this._fogEnabled = true;
        /**
         * Stores the size of points
         */ this.pointSize = 1.0;
        /**
         * Stores the z offset Factor value
         */ this.zOffset = 0;
        /**
         * Stores the z offset Units value
         */ this.zOffsetUnits = 0;
        /**
         * Gives access to the stencil properties of the material
         */ this.stencil = new (0, $5d249d29bbd510f6$export$4fedf983a2fab8f7)();
        /**
         * Specifies if uniform buffers should be used
         */ this._useUBO = false;
        /**
         * Stores the fill mode state
         */ this._fillMode = $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode;
        /**
         * Specifies if the depth write state should be cached
         */ this._cachedDepthWriteState = false;
        /**
         * Specifies if the color write state should be cached
         */ this._cachedColorWriteState = false;
        /**
         * Specifies if the depth function state should be cached
         */ this._cachedDepthFunctionState = 0;
        /** @internal */ this._indexInSceneMaterialArray = -1;
        /** @internal */ this.meshMap = null;
        /** @internal */ this._parentContainer = null;
        /** @internal */ this._uniformBufferLayoutBuilt = false;
        this._eventInfo = {}; // will be initialized before each event notification
        /** @internal */ this._callbackPluginEventGeneric = ()=>void 0;
        /** @internal */ this._callbackPluginEventIsReadyForSubMesh = ()=>void 0;
        /** @internal */ this._callbackPluginEventPrepareDefines = ()=>void 0;
        /** @internal */ this._callbackPluginEventPrepareDefinesBeforeAttributes = ()=>void 0;
        /** @internal */ this._callbackPluginEventHardBindForSubMesh = ()=>void 0;
        /** @internal */ this._callbackPluginEventBindForSubMesh = ()=>void 0;
        /** @internal */ this._callbackPluginEventHasRenderTargetTextures = ()=>void 0;
        /** @internal */ this._callbackPluginEventFillRenderTargetTextures = ()=>void 0;
        /**
         * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
         */ this._forceAlphaTest = false;
        /**
         * The transparency mode of the material.
         */ this._transparencyMode = null;
        this.name = name;
        const setScene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!setScene) return;
        this._scene = setScene;
        this._dirtyCallbacks = {};
        this._forceGLSL = forceGLSL;
        this._dirtyCallbacks[1] = this._markAllSubMeshesAsTexturesDirty.bind(this);
        this._dirtyCallbacks[2] = this._markAllSubMeshesAsLightsDirty.bind(this);
        this._dirtyCallbacks[4] = this._markAllSubMeshesAsFresnelDirty.bind(this);
        this._dirtyCallbacks[8] = this._markAllSubMeshesAsAttributesDirty.bind(this);
        this._dirtyCallbacks[16] = this._markAllSubMeshesAsMiscDirty.bind(this);
        this._dirtyCallbacks[32] = this._markAllSubMeshesAsPrePassDirty.bind(this);
        this._dirtyCallbacks[63] = this._markAllSubMeshesAsAllDirty.bind(this);
        this.id = name || (0, $bOhSV.Tools).RandomId();
        this.uniqueId = this._scene.getUniqueId();
        this._materialContext = this._scene.getEngine().createMaterialContext();
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(this._scene.getEngine(), false);
        this._drawWrapper.materialContext = this._materialContext;
        this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(this._scene.getEngine(), undefined, undefined, name);
        this._useUBO = this.getScene().getEngine().supportsUniformBuffers;
        this._createUniformBuffer();
        if (!doNotAdd) this._scene.addMaterial(this);
        if (this._scene.useMaterialMeshMap) this.meshMap = {};
        $3afee756ef198914$export$a2d8b23205c25948.OnEventObservable.notifyObservers(this, 1 /* MaterialPluginEvent.Created */ );
    }
    /** @internal */ _createUniformBuffer() {
        const engine = this.getScene().getEngine();
        this._uniformBuffer?.dispose();
        if (engine.isWebGPU && !this._forceGLSL) {
            // Switch main UBO to non UBO to connect to leftovers UBO in webgpu
            this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(engine, undefined, undefined, this.name, true);
            this._shaderLanguage = 1 /* ShaderLanguage.WGSL */ ;
        } else this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(this._scene.getEngine(), undefined, undefined, this.name);
        this._uniformBufferLayoutBuilt = false;
    }
    /**
     * Returns a string representation of the current material
     * @param fullDetails defines a boolean indicating which levels of logging is desired
     * @returns a string with material information
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toString(fullDetails) {
        const ret = "Name: " + this.name;
        return ret;
    }
    /**
     * Gets the class name of the material
     * @returns a string with the class name of the material
     */ getClassName() {
        return "Material";
    }
    /** @internal */ get _isMaterial() {
        return true;
    }
    /**
     * Specifies if updates for the material been locked
     */ get isFrozen() {
        return this.checkReadyOnlyOnce;
    }
    /**
     * Locks updates for the material
     */ freeze() {
        this.markDirty();
        this.checkReadyOnlyOnce = true;
    }
    /**
     * Unlocks updates for the material
     */ unfreeze() {
        this.markDirty();
        this.checkReadyOnlyOnce = false;
    }
    /**
     * Specifies if the material is ready to be used
     * @param mesh defines the mesh to check
     * @param useInstances specifies if instances should be used
     * @returns a boolean indicating if the material is ready to be used
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isReady(mesh, useInstances) {
        return true;
    }
    /**
     * Specifies that the submesh is ready to be used
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isReadyForSubMesh(mesh, subMesh, useInstances) {
        const defines = subMesh.materialDefines;
        if (!defines) return false;
        this._eventInfo.isReadyForSubMesh = true;
        this._eventInfo.defines = defines;
        this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
        return this._eventInfo.isReadyForSubMesh;
    }
    /**
     * Returns the material effect
     * @returns the effect associated with the material
     */ getEffect() {
        return this._drawWrapper.effect;
    }
    /**
     * Returns the current scene
     * @returns a Scene
     */ getScene() {
        return this._scene;
    }
    /** @internal */ _getEffectiveOrientation(mesh) {
        return this.sideOrientation !== null ? this.sideOrientation : mesh.sideOrientation;
    }
    /**
     * Gets the current transparency mode.
     */ get transparencyMode() {
        return this._transparencyMode;
    }
    /**
     * Sets the transparency mode of the material.
     *
     * | Value | Type                                | Description |
     * | ----- | ----------------------------------- | ----------- |
     * | 0     | OPAQUE                              |             |
     * | 1     | ALPHATEST                           |             |
     * | 2     | ALPHABLEND                          |             |
     * | 3     | ALPHATESTANDBLEND                   |             |
     *
     */ set transparencyMode(value) {
        if (this._transparencyMode === value) return;
        this._transparencyMode = value;
        this._forceAlphaTest = value === $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATESTANDBLEND;
        this._markAllSubMeshesAsTexturesAndMiscDirty();
    }
    /**
     * Returns true if alpha blending should be disabled.
     */ get _disableAlphaBlending() {
        return this._transparencyMode === $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_OPAQUE || this._transparencyMode === $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATEST;
    }
    /**
     * Specifies whether or not this material should be rendered in alpha blend mode.
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        if (this._disableAlphaBlending) return false;
        return this.alpha < 1.0;
    }
    /**
     * Specifies if the mesh will require alpha blending
     * @param mesh defines the mesh to check
     * @returns a boolean specifying if alpha blending is needed for the mesh
     */ needAlphaBlendingForMesh(mesh) {
        if (mesh.visibility < 1.0) return true;
        if (this._disableAlphaBlending) return false;
        return mesh.hasVertexAlpha || this.needAlphaBlending();
    }
    /**
     * Specifies whether or not this material should be rendered in alpha test mode.
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        if (this._forceAlphaTest) return true;
        return false;
    }
    /**
     * Specifies if material alpha testing should be turned on for the mesh
     * @param mesh defines the mesh to check
     * @returns a boolean specifying if alpha testing should be turned on for the mesh
     */ _shouldTurnAlphaTestOn(mesh) {
        return !this.needAlphaBlendingForMesh(mesh) && this.needAlphaTesting();
    }
    /**
     * Gets the texture used for the alpha test
     * @returns the texture to use for alpha testing
     */ getAlphaTestTexture() {
        return null;
    }
    /**
     * Marks the material to indicate that it needs to be re-calculated
     * @param forceMaterialDirty - Forces the material to be marked as dirty for all components (same as this.markAsDirty(Material.AllDirtyFlag)). You should use this flag if the material is frozen and you want to force a recompilation.
     */ markDirty(forceMaterialDirty = false) {
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                if (subMesh.getMaterial() !== this) continue;
                for (const drawWrapper of subMesh._drawWrappers){
                    if (!drawWrapper) continue;
                    if (this._materialContext === drawWrapper.materialContext) {
                        drawWrapper._wasPreviouslyReady = false;
                        drawWrapper._wasPreviouslyUsingInstances = null;
                        drawWrapper._forceRebindOnNextCall = forceMaterialDirty;
                    }
                }
            }
        }
        if (forceMaterialDirty) this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.AllDirtyFlag);
    }
    /**
     * @internal
     */ _preBind(effect, overrideOrientation = null) {
        const engine = this._scene.getEngine();
        const orientation = overrideOrientation == null ? this.sideOrientation : overrideOrientation;
        const reverse = orientation === $3afee756ef198914$export$a2d8b23205c25948.ClockWiseSideOrientation;
        engine.enableEffect(effect ? effect : this._getDrawWrapper());
        engine.setState(this.backFaceCulling, this.zOffset, false, reverse, this._scene._mirroredCameraPosition ? !this.cullBackFaces : this.cullBackFaces, this.stencil, this.zOffsetUnits);
        return reverse;
    }
    /**
     * Binds the material to the mesh
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh to bind the material to
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bind(world, mesh) {}
    /**
     * Initializes the uniform buffer layout for the shader.
     */ buildUniformLayout() {
        const ubo = this._uniformBuffer;
        this._eventInfo.ubo = ubo;
        this._callbackPluginEventGeneric(8 /* MaterialPluginEvent.PrepareUniformBuffer */ , this._eventInfo);
        ubo.create();
        this._uniformBufferLayoutBuilt = true;
    }
    /**
     * Binds the submesh to the material
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        const drawWrapper = subMesh._drawWrapper;
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventBindForSubMesh(this._eventInfo);
        drawWrapper._forceRebindOnNextCall = false;
    }
    /**
     * Binds the world matrix to the material
     * @param world defines the world transformation matrix
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bindOnlyWorldMatrix(world) {}
    /**
     * Binds the view matrix to the effect
     * @param effect defines the effect to bind the view matrix to
     */ bindView(effect) {
        if (!this._useUBO) effect.setMatrix("view", this.getScene().getViewMatrix());
        else this._needToBindSceneUbo = true;
    }
    /**
     * Binds the view projection and projection matrices to the effect
     * @param effect defines the effect to bind the view projection and projection matrices to
     */ bindViewProjection(effect) {
        if (!this._useUBO) {
            effect.setMatrix("viewProjection", this.getScene().getTransformMatrix());
            effect.setMatrix("projection", this.getScene().getProjectionMatrix());
        } else this._needToBindSceneUbo = true;
    }
    /**
     * Binds the view matrix to the effect
     * @param effect defines the effect to bind the view matrix to
     * @param variableName name of the shader variable that will hold the eye position
     */ bindEyePosition(effect, variableName) {
        if (!this._useUBO) this._scene.bindEyePosition(effect, variableName);
        else this._needToBindSceneUbo = true;
    }
    /**
     * Processes to execute after binding the material to a mesh
     * @param mesh defines the rendered mesh
     * @param effect defines the effect used to bind the material
     * @param _subMesh defines the subMesh that the material has been bound for
     */ _afterBind(mesh, effect = null, _subMesh) {
        this._scene._cachedMaterial = this;
        if (this._needToBindSceneUbo) {
            if (effect) {
                this._needToBindSceneUbo = false;
                (0, $7893e784ec9add9a$export$92f8908347587afc)(effect, this.getScene().getSceneUniformBuffer());
                this._scene.finalizeSceneUbo();
            }
        }
        if (mesh) this._scene._cachedVisibility = mesh.visibility;
        else this._scene._cachedVisibility = 1;
        if (this._onBindObservable && mesh) this._onBindObservable.notifyObservers(mesh);
        if (this.disableDepthWrite) {
            const engine = this._scene.getEngine();
            this._cachedDepthWriteState = engine.getDepthWrite();
            engine.setDepthWrite(false);
        }
        if (this.disableColorWrite) {
            const engine = this._scene.getEngine();
            this._cachedColorWriteState = engine.getColorWrite();
            engine.setColorWrite(false);
        }
        if (this.depthFunction !== 0) {
            const engine = this._scene.getEngine();
            this._cachedDepthFunctionState = engine.getDepthFunction() || 0;
            engine.setDepthFunction(this.depthFunction);
        }
    }
    /**
     * Unbinds the material from the mesh
     */ unbind() {
        if (this._onUnBindObservable) this._onUnBindObservable.notifyObservers(this);
        if (this.depthFunction !== 0) {
            const engine = this._scene.getEngine();
            engine.setDepthFunction(this._cachedDepthFunctionState);
        }
        if (this.disableDepthWrite) {
            const engine = this._scene.getEngine();
            engine.setDepthWrite(this._cachedDepthWriteState);
        }
        if (this.disableColorWrite) {
            const engine = this._scene.getEngine();
            engine.setColorWrite(this._cachedColorWriteState);
        }
    }
    /**
     * Returns the animatable textures.
     * @returns - Array of animatable textures.
     */ getAnimatables() {
        this._eventInfo.animatables = [];
        this._callbackPluginEventGeneric(256 /* MaterialPluginEvent.GetAnimatables */ , this._eventInfo);
        return this._eventInfo.animatables;
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        this._eventInfo.activeTextures = [];
        this._callbackPluginEventGeneric(512 /* MaterialPluginEvent.GetActiveTextures */ , this._eventInfo);
        return this._eventInfo.activeTextures;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        this._eventInfo.hasTexture = false;
        this._eventInfo.texture = texture;
        this._callbackPluginEventGeneric(1024 /* MaterialPluginEvent.HasTexture */ , this._eventInfo);
        return this._eventInfo.hasTexture;
    }
    /**
     * Makes a duplicate of the material, and gives it a new name
     * @param name defines the new name for the duplicated material
     * @returns the cloned material
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clone(name) {
        return null;
    }
    _clonePlugins(targetMaterial, rootUrl) {
        const serializationObject = {};
        // Create plugins in targetMaterial in case they don't exist
        this._serializePlugins(serializationObject);
        $3afee756ef198914$export$a2d8b23205c25948._ParsePlugins(serializationObject, targetMaterial, this._scene, rootUrl);
        // Copy the properties of the current plugins to the cloned material's plugins
        if (this.pluginManager) for (const plugin of this.pluginManager._plugins){
            const targetPlugin = targetMaterial.pluginManager.getPlugin(plugin.name);
            if (targetPlugin) plugin.copyTo(targetPlugin);
        }
    }
    /**
     * Gets the meshes bound to the material
     * @returns an array of meshes bound to the material
     */ getBindedMeshes() {
        if (this.meshMap) {
            const result = [];
            for(const meshId in this.meshMap){
                const mesh = this.meshMap[meshId];
                if (mesh) result.push(mesh);
            }
            return result;
        } else {
            const meshes = this._scene.meshes;
            return meshes.filter((mesh)=>mesh.material === this);
        }
    }
    /**
     * Force shader compilation
     * @param mesh defines the mesh associated with this material
     * @param onCompiled defines a function to execute once the material is compiled
     * @param options defines the options to configure the compilation
     * @param onError defines a function to execute if the material fails compiling
     */ forceCompilation(mesh, onCompiled, options, onError) {
        const localOptions = {
            clipPlane: false,
            useInstances: false,
            ...options
        };
        const scene = this.getScene();
        const currentHotSwapingState = this.allowShaderHotSwapping;
        this.allowShaderHotSwapping = false; // Turned off to let us evaluate the real compilation state
        const checkReady = ()=>{
            if (!this._scene || !this._scene.getEngine()) return;
            const clipPlaneState = scene.clipPlane;
            if (localOptions.clipPlane) scene.clipPlane = new (0, $23POp.Plane)(0, 0, 0, 1);
            if (this._storeEffectOnSubMeshes) {
                let allDone = true, lastError = null;
                if (mesh.subMeshes) {
                    const tempSubMesh = new (0, $fc3ab70ba5c9f506$export$c684db7d654df572)(0, 0, 0, 0, 0, mesh, undefined, false, false);
                    if (tempSubMesh.materialDefines) tempSubMesh.materialDefines._renderId = -1;
                    if (!this.isReadyForSubMesh(mesh, tempSubMesh, localOptions.useInstances)) {
                        if (tempSubMesh.effect && tempSubMesh.effect.getCompilationError() && tempSubMesh.effect.allFallbacksProcessed()) lastError = tempSubMesh.effect.getCompilationError();
                        else {
                            allDone = false;
                            setTimeout(checkReady, 16);
                        }
                    }
                }
                if (allDone) {
                    this.allowShaderHotSwapping = currentHotSwapingState;
                    if (lastError) {
                        if (onError) onError(lastError);
                    }
                    if (onCompiled) onCompiled(this);
                }
            } else if (this.isReady()) {
                this.allowShaderHotSwapping = currentHotSwapingState;
                if (onCompiled) onCompiled(this);
            } else setTimeout(checkReady, 16);
            if (localOptions.clipPlane) scene.clipPlane = clipPlaneState;
        };
        checkReady();
    }
    /**
     * Force shader compilation
     * @param mesh defines the mesh that will use this material
     * @param options defines additional options for compiling the shaders
     * @returns a promise that resolves when the compilation completes
     */ forceCompilationAsync(mesh, options) {
        return new Promise((resolve, reject)=>{
            this.forceCompilation(mesh, ()=>{
                resolve();
            }, options, (reason)=>{
                reject(reason);
            });
        });
    }
    /**
     * Marks a define in the material to indicate that it needs to be re-computed
     * @param flag defines a flag used to determine which parts of the material have to be marked as dirty
     */ markAsDirty(flag) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) return;
        $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.length = 0;
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.LightDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._LightsDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.FresnelDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.AttributesDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._AttributeDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.PrePassDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._PrePassDirtyCallBack);
        if ($3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.length) this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._RunDirtyCallBacks);
        this.getScene().resetCachedMaterial();
    }
    /**
     * Resets the draw wrappers cache for all submeshes that are using this material
     */ resetDrawCache() {
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                if (subMesh.getMaterial() !== this) continue;
                subMesh.resetDrawCache();
            }
        }
    }
    /**
     * Marks all submeshes of a material to indicate that their material defines need to be re-calculated
     * @param func defines a function which checks material defines against the submeshes
     */ _markAllSubMeshesAsDirty(func) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) return;
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                // We want to skip the submeshes which are not using this material or which have not yet rendered at least once
                if (subMesh.getMaterial(false) !== this) continue;
                for (const drawWrapper of subMesh._drawWrappers){
                    if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) continue;
                    if (this._materialContext === drawWrapper.materialContext) func(drawWrapper.defines);
                }
            }
        }
    }
    /**
     * Indicates that the scene should check if the rendering now needs a prepass
     */ _markScenePrePassDirty() {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) return;
        const prePassRenderer = this.getScene().enablePrePassRenderer();
        if (prePassRenderer) prePassRenderer.markAsDirty();
    }
    /**
     * Indicates that we need to re-calculated for all submeshes
     */ _markAllSubMeshesAsAllDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._AllDirtyCallBack);
    }
    /**
     * Indicates that image processing needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsImageProcessingDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._ImageProcessingDirtyCallBack);
    }
    /**
     * Indicates that textures need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsTexturesDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack);
    }
    /**
     * Indicates that fresnel needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsFresnelDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack);
    }
    /**
     * Indicates that fresnel and misc need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsFresnelAndMiscDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._FresnelAndMiscDirtyCallBack);
    }
    /**
     * Indicates that lights need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsLightsDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._LightsDirtyCallBack);
    }
    /**
     * Indicates that attributes need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsAttributesDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._AttributeDirtyCallBack);
    }
    /**
     * Indicates that misc needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsMiscDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack);
    }
    /**
     * Indicates that prepass needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsPrePassDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack);
    }
    /**
     * Indicates that textures and misc need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsTexturesAndMiscDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._TextureAndMiscDirtyCallBack);
    }
    _checkScenePerformancePriority() {
        if (this._scene.performancePriority !== 0 /* ScenePerformancePriority.BackwardCompatible */ ) {
            this.checkReadyOnlyOnce = true;
            // re-set the flag when the perf priority changes
            const observer = this._scene.onScenePerformancePriorityChangedObservable.addOnce(()=>{
                this.checkReadyOnlyOnce = false;
            });
            // if this material is disposed before the scene is disposed, cleanup the observer
            this.onDisposeObservable.add(()=>{
                this._scene.onScenePerformancePriorityChangedObservable.remove(observer);
            });
        }
    }
    /**
     * Sets the required values to the prepass renderer.
     * @param prePassRenderer defines the prepass renderer to setup.
     * @returns true if the pre pass is needed.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setPrePassRenderer(prePassRenderer) {
        // Do Nothing by default
        return false;
    }
    /**
     * Disposes the material
     * @param _forceDisposeEffect kept for backward compat. We reference count the effect now.
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
     */ dispose(_forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        const scene = this.getScene();
        // Animations
        scene.stopAnimation(this);
        scene.freeProcessedMaterials();
        // Remove from scene
        scene.removeMaterial(this);
        this._eventInfo.forceDisposeTextures = forceDisposeTextures;
        this._callbackPluginEventGeneric(2 /* MaterialPluginEvent.Disposed */ , this._eventInfo);
        if (this._parentContainer) {
            const index = this._parentContainer.materials.indexOf(this);
            if (index > -1) this._parentContainer.materials.splice(index, 1);
            this._parentContainer = null;
        }
        if (notBoundToMesh !== true) {
            // Remove from meshes
            if (this.meshMap) for(const meshId in this.meshMap){
                const mesh = this.meshMap[meshId];
                this._disposeMeshResources(mesh);
            }
            else {
                const meshes = scene.meshes;
                for (const mesh of meshes)this._disposeMeshResources(mesh);
            }
        }
        this._uniformBuffer.dispose();
        // Shader are kept in cache for further use but we can get rid of this by using forceDisposeEffect
        if (this._drawWrapper.effect) {
            if (!this._storeEffectOnSubMeshes) this._drawWrapper.effect.dispose();
            this._drawWrapper.effect = null;
        }
        this.metadata = null;
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        if (this._onBindObservable) this._onBindObservable.clear();
        if (this._onUnBindObservable) this._onUnBindObservable.clear();
        if (this._onEffectCreatedObservable) this._onEffectCreatedObservable.clear();
        if (this._eventInfo) this._eventInfo = {};
    }
    _disposeMeshResources(mesh) {
        if (!mesh) return;
        const geometry = mesh.geometry;
        const materialForRenderPass = mesh._internalAbstractMeshDataInfo._materialForRenderPass;
        if (this._storeEffectOnSubMeshes) {
            if (mesh.subMeshes && materialForRenderPass) for (const subMesh of mesh.subMeshes){
                const drawWrappers = subMesh._drawWrappers;
                for(let renderPassIndex = 0; renderPassIndex < drawWrappers.length; renderPassIndex++){
                    const effect = drawWrappers[renderPassIndex]?.effect;
                    if (!effect) continue;
                    const material = materialForRenderPass[renderPassIndex];
                    if (material === this) {
                        geometry?._releaseVertexArrayObject(effect);
                        subMesh._removeDrawWrapper(renderPassIndex, true, true);
                    }
                }
            }
        } else geometry?._releaseVertexArrayObject(this._drawWrapper.effect);
        if (mesh.material === this && !mesh.sourceMesh) mesh.material = null;
    }
    /**
     * Serializes this material
     * @returns the serialized material object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.stencil = this.stencil.serialize();
        serializationObject.uniqueId = this.uniqueId;
        this._serializePlugins(serializationObject);
        return serializationObject;
    }
    _serializePlugins(serializationObject) {
        serializationObject.plugins = {};
        if (this.pluginManager) {
            for (const plugin of this.pluginManager._plugins)if (!plugin.doNotSerialize) serializationObject.plugins[plugin.getClassName()] = plugin.serialize();
        }
    }
    /**
     * Creates a material from parsed material data
     * @param parsedMaterial defines parsed material data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures
     * @returns a new material
     */ static Parse(parsedMaterial, scene, rootUrl) {
        if (!parsedMaterial.customType) parsedMaterial.customType = "BABYLON.StandardMaterial";
        else if (parsedMaterial.customType === "BABYLON.PBRMaterial" && parsedMaterial.overloadedAlbedo) {
            parsedMaterial.customType = "BABYLON.LegacyPBRMaterial";
            if (!BABYLON.LegacyPBRMaterial) {
                (0, $kVtWi.Logger).Error("Your scene is trying to load a legacy version of the PBRMaterial, please, include it from the materials library.");
                return null;
            }
        }
        const materialType = (0, $bOhSV.Tools).Instantiate(parsedMaterial.customType);
        const material = materialType.Parse(parsedMaterial, scene, rootUrl);
        material._loadedUniqueId = parsedMaterial.uniqueId;
        return material;
    }
    static _ParsePlugins(serializationObject, material, scene, rootUrl) {
        if (!serializationObject.plugins) return;
        for(const pluginClassName in serializationObject.plugins){
            const pluginData = serializationObject.plugins[pluginClassName];
            let plugin = material.pluginManager?.getPlugin(pluginData.name);
            if (!plugin) {
                const pluginClassType = (0, $bOhSV.Tools).Instantiate("BABYLON." + pluginClassName);
                if (pluginClassType) plugin = new pluginClassType(material);
            }
            plugin?.parse(pluginData, scene, rootUrl);
        }
    }
}
/**
 * Returns the triangle fill mode
 */ $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode = 0;
/**
 * Returns the wireframe mode
 */ $3afee756ef198914$export$a2d8b23205c25948.WireFrameFillMode = 1;
/**
 * Returns the point fill mode
 */ $3afee756ef198914$export$a2d8b23205c25948.PointFillMode = 2;
/**
 * Returns the point list draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.PointListDrawMode = 3;
/**
 * Returns the line list draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.LineListDrawMode = 4;
/**
 * Returns the line loop draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.LineLoopDrawMode = 5;
/**
 * Returns the line strip draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.LineStripDrawMode = 6;
/**
 * Returns the triangle strip draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.TriangleStripDrawMode = 7;
/**
 * Returns the triangle fan draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.TriangleFanDrawMode = 8;
/**
 * Stores the clock-wise side orientation
 */ $3afee756ef198914$export$a2d8b23205c25948.ClockWiseSideOrientation = 0;
/**
 * Stores the counter clock-wise side orientation
 */ $3afee756ef198914$export$a2d8b23205c25948.CounterClockWiseSideOrientation = 1;
/**
 * The dirty texture flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag = 1;
/**
 * The dirty light flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.LightDirtyFlag = 2;
/**
 * The dirty fresnel flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.FresnelDirtyFlag = 4;
/**
 * The dirty attribute flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.AttributesDirtyFlag = 8;
/**
 * The dirty misc flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag = 16;
/**
 * The dirty prepass flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.PrePassDirtyFlag = 32;
/**
 * The all dirty flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.AllDirtyFlag = 63;
/**
 * MaterialTransparencyMode: No transparency mode, Alpha channel is not use.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_OPAQUE = 0;
/**
 * MaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATEST = 1;
/**
 * MaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHABLEND = 2;
/**
 * MaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 * They are also discarded below the alpha cutoff threshold to improve performances.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATESTANDBLEND = 3;
/**
 * The Whiteout method is used to blend normals.
 * Details of the algorithm can be found here: https://blog.selfshadow.com/publications/blending-in-detail/
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_NORMALBLENDMETHOD_WHITEOUT = 0;
/**
 * The Reoriented Normal Mapping method is used to blend normals.
 * Details of the algorithm can be found here: https://blog.selfshadow.com/publications/blending-in-detail/
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_NORMALBLENDMETHOD_RNM = 1;
/**
 * Event observable which raises global events common to all materials (like MaterialPluginEvent.Created)
 */ $3afee756ef198914$export$a2d8b23205c25948.OnEventObservable = new (0, $diGQf.Observable)();
$3afee756ef198914$export$a2d8b23205c25948._AllDirtyCallBack = (defines)=>defines.markAllAsDirty();
$3afee756ef198914$export$a2d8b23205c25948._ImageProcessingDirtyCallBack = (defines)=>defines.markAsImageProcessingDirty();
$3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack = (defines)=>defines.markAsTexturesDirty();
$3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack = (defines)=>defines.markAsFresnelDirty();
$3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack = (defines)=>defines.markAsMiscDirty();
$3afee756ef198914$export$a2d8b23205c25948._PrePassDirtyCallBack = (defines)=>defines.markAsPrePassDirty();
$3afee756ef198914$export$a2d8b23205c25948._LightsDirtyCallBack = (defines)=>defines.markAsLightDirty();
$3afee756ef198914$export$a2d8b23205c25948._AttributeDirtyCallBack = (defines)=>defines.markAsAttributesDirty();
$3afee756ef198914$export$a2d8b23205c25948._FresnelAndMiscDirtyCallBack = (defines)=>{
    $3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack(defines);
    $3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack(defines);
};
$3afee756ef198914$export$a2d8b23205c25948._TextureAndMiscDirtyCallBack = (defines)=>{
    $3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack(defines);
    $3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack(defines);
};
$3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray = [];
$3afee756ef198914$export$a2d8b23205c25948._RunDirtyCallBacks = (defines)=>{
    for (const cb of $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray)cb(defines);
};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "id", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "metadata", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "checkReadyOnEveryCall", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "checkReadyOnlyOnce", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "state", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("alpha")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_alpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("backFaceCulling")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_backFaceCulling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("cullBackFaces")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_cullBackFaces", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "sideOrientation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("alphaMode")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_alphaMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_needDepthPrePass", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "disableDepthWrite", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "disableColorWrite", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "forceDepthWrite", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "depthFunction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "separateCullingPass", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("fogEnabled")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_fogEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "pointSize", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "zOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "zOffsetUnits", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "pointsCloud", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "fillMode", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "useLogarithmicDepth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "transparencyMode", null);


/**
 * Manages the defines for the Material
 */ class $23fbb8c84eee5c40$export$4c55cb8c02c1a25d {
    /**
     * Creates a new instance
     * @param externalProperties list of external properties to inject into the object
     */ constructor(externalProperties){
        /** @internal */ this._keys = [];
        this._isDirty = true;
        /** @internal */ this._areLightsDirty = true;
        /** @internal */ this._areLightsDisposed = false;
        /** @internal */ this._areAttributesDirty = true;
        /** @internal */ this._areTexturesDirty = true;
        /** @internal */ this._areFresnelDirty = true;
        /** @internal */ this._areMiscDirty = true;
        /** @internal */ this._arePrePassDirty = true;
        /** @internal */ this._areImageProcessingDirty = true;
        /** @internal */ this._normals = false;
        /** @internal */ this._uvs = false;
        /** @internal */ this._needNormals = false;
        /** @internal */ this._needUVs = false;
        this._externalProperties = externalProperties;
        // Initialize External Properties
        if (externalProperties) {
            for(const prop in externalProperties)if (Object.prototype.hasOwnProperty.call(externalProperties, prop)) this._setDefaultValue(prop);
        }
    }
    /**
     * Specifies if the material needs to be re-calculated
     */ get isDirty() {
        return this._isDirty;
    }
    /**
     * Marks the material to indicate that it has been re-calculated
     */ markAsProcessed() {
        this._isDirty = false;
        this._areAttributesDirty = false;
        this._areTexturesDirty = false;
        this._areFresnelDirty = false;
        this._areLightsDirty = false;
        this._areLightsDisposed = false;
        this._areMiscDirty = false;
        this._arePrePassDirty = false;
        this._areImageProcessingDirty = false;
    }
    /**
     * Marks the material to indicate that it needs to be re-calculated
     */ markAsUnprocessed() {
        this._isDirty = true;
    }
    /**
     * Marks the material to indicate all of its defines need to be re-calculated
     */ markAllAsDirty() {
        this._areTexturesDirty = true;
        this._areAttributesDirty = true;
        this._areLightsDirty = true;
        this._areFresnelDirty = true;
        this._areMiscDirty = true;
        this._arePrePassDirty = false;
        this._areImageProcessingDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the material to indicate that image processing needs to be re-calculated
     */ markAsImageProcessingDirty() {
        this._areImageProcessingDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the material to indicate the lights need to be re-calculated
     * @param disposed Defines whether the light is dirty due to dispose or not
     */ markAsLightDirty(disposed = false) {
        this._areLightsDirty = true;
        this._areLightsDisposed = this._areLightsDisposed || disposed;
        this._isDirty = true;
    }
    /**
     * Marks the attribute state as changed
     */ markAsAttributesDirty() {
        this._areAttributesDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the texture state as changed
     */ markAsTexturesDirty() {
        this._areTexturesDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the fresnel state as changed
     */ markAsFresnelDirty() {
        this._areFresnelDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the misc state as changed
     */ markAsMiscDirty() {
        this._areMiscDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the prepass state as changed
     */ markAsPrePassDirty() {
        this._arePrePassDirty = true;
        this._isDirty = true;
    }
    /**
     * Rebuilds the material defines
     */ rebuild() {
        this._keys.length = 0;
        for (const key of Object.keys(this)){
            if (key[0] === "_") continue;
            this._keys.push(key);
        }
        if (this._externalProperties) {
            for(const name in this._externalProperties)if (this._keys.indexOf(name) === -1) this._keys.push(name);
        }
    }
    /**
     * Specifies if two material defines are equal
     * @param other - A material define instance to compare to
     * @returns - Boolean indicating if the material defines are equal (true) or not (false)
     */ isEqual(other) {
        if (this._keys.length !== other._keys.length) return false;
        for(let index = 0; index < this._keys.length; index++){
            const prop = this._keys[index];
            if (this[prop] !== other[prop]) return false;
        }
        return true;
    }
    /**
     * Clones this instance's defines to another instance
     * @param other - material defines to clone values to
     */ cloneTo(other) {
        if (this._keys.length !== other._keys.length) other._keys = this._keys.slice(0);
        for(let index = 0; index < this._keys.length; index++){
            const prop = this._keys[index];
            other[prop] = this[prop];
        }
    }
    /**
     * Resets the material define values
     */ reset() {
        this._keys.forEach((prop)=>this._setDefaultValue(prop));
    }
    _setDefaultValue(prop) {
        const type = this._externalProperties?.[prop]?.type ?? typeof this[prop];
        const defValue = this._externalProperties?.[prop]?.default;
        switch(type){
            case "number":
                this[prop] = defValue ?? 0;
                break;
            case "string":
                this[prop] = defValue ?? "";
                break;
            default:
                this[prop] = defValue ?? false;
                break;
        }
    }
    /**
     * Converts the material define values to a string
     * @returns - String of material define information
     */ toString() {
        let result = "";
        for(let index = 0; index < this._keys.length; index++){
            const prop = this._keys[index];
            const value = this[prop];
            const type = typeof value;
            switch(type){
                case "number":
                case "string":
                    result += "#define " + prop + " " + value + "\n";
                    break;
                default:
                    if (value) result += "#define " + prop + "\n";
                    break;
            }
        }
        return result;
    }
}



var $ha1VO = parcelRequire("ha1VO");

class $7a0e949889738692$export$9026dbc30178f7ea extends (0, $3afee756ef198914$export$a2d8b23205c25948) {
    constructor(name, scene, storeEffectOnSubMeshes = true, forceGLSL = false){
        super(name, scene, undefined, forceGLSL);
        this._normalMatrix = new (0, $ha1VO.Matrix)();
        this._storeEffectOnSubMeshes = storeEffectOnSubMeshes;
    }
    getEffect() {
        return this._storeEffectOnSubMeshes ? this._activeEffect : super.getEffect();
    }
    isReady(mesh, useInstances) {
        if (!mesh) return false;
        if (!this._storeEffectOnSubMeshes) return true;
        if (!mesh.subMeshes || mesh.subMeshes.length === 0) return true;
        return this.isReadyForSubMesh(mesh, mesh.subMeshes[0], useInstances);
    }
    _isReadyForSubMesh(subMesh) {
        const defines = subMesh.materialDefines;
        if (!this.checkReadyOnEveryCall && subMesh.effect && defines) {
            if (defines._renderId === this.getScene().getRenderId()) return true;
        }
        return false;
    }
    /**
     * Binds the given world matrix to the active effect
     *
     * @param world the matrix to bind
     */ bindOnlyWorldMatrix(world) {
        this._activeEffect.setMatrix("world", world);
    }
    /**
     * Binds the given normal matrix to the active effect
     *
     * @param normalMatrix the matrix to bind
     */ bindOnlyNormalMatrix(normalMatrix) {
        this._activeEffect.setMatrix("normalMatrix", normalMatrix);
    }
    bind(world, mesh) {
        if (!mesh) return;
        this.bindForSubMesh(world, mesh, mesh.subMeshes[0]);
    }
    _afterBind(mesh, effect = null, subMesh) {
        super._afterBind(mesh, effect, subMesh);
        this.getScene()._cachedEffect = effect;
        if (subMesh) subMesh._drawWrapper._forceRebindOnNextCall = false;
        else this._drawWrapper._forceRebindOnNextCall = false;
    }
    _mustRebind(scene, effect, subMesh, visibility = 1) {
        return subMesh._drawWrapper._forceRebindOnNextCall || scene.isCachedMaterialInvalid(this, effect, visibility);
    }
    dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        this._activeEffect = undefined;
        super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
    }
}



var $j2mX5 = parcelRequire("j2mX5");

var $8DoUR = parcelRequire("8DoUR");

var $dUFoQ = parcelRequire("dUFoQ");
class $1aa143b647fe12a5$export$cf9c31ce2002efcc {
    /**
     * Are diffuse textures enabled in the application.
     */ static get DiffuseTextureEnabled() {
        return this._DiffuseTextureEnabled;
    }
    static set DiffuseTextureEnabled(value) {
        if (this._DiffuseTextureEnabled === value) return;
        this._DiffuseTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Is the OpenPBR Base Weight texture enabled in the application.
     */ static get BaseWeightTextureEnabled() {
        return this._BaseWeightTextureEnabled;
    }
    static set BaseWeightTextureEnabled(value) {
        if (this._BaseWeightTextureEnabled === value) return;
        this._BaseWeightTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are detail textures enabled in the application.
     */ static get DetailTextureEnabled() {
        return this._DetailTextureEnabled;
    }
    static set DetailTextureEnabled(value) {
        if (this._DetailTextureEnabled === value) return;
        this._DetailTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are decal maps enabled in the application.
     */ static get DecalMapEnabled() {
        return this._DecalMapEnabled;
    }
    static set DecalMapEnabled(value) {
        if (this._DecalMapEnabled === value) return;
        this._DecalMapEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are ambient textures enabled in the application.
     */ static get AmbientTextureEnabled() {
        return this._AmbientTextureEnabled;
    }
    static set AmbientTextureEnabled(value) {
        if (this._AmbientTextureEnabled === value) return;
        this._AmbientTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are opacity textures enabled in the application.
     */ static get OpacityTextureEnabled() {
        return this._OpacityTextureEnabled;
    }
    static set OpacityTextureEnabled(value) {
        if (this._OpacityTextureEnabled === value) return;
        this._OpacityTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are reflection textures enabled in the application.
     */ static get ReflectionTextureEnabled() {
        return this._ReflectionTextureEnabled;
    }
    static set ReflectionTextureEnabled(value) {
        if (this._ReflectionTextureEnabled === value) return;
        this._ReflectionTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are emissive textures enabled in the application.
     */ static get EmissiveTextureEnabled() {
        return this._EmissiveTextureEnabled;
    }
    static set EmissiveTextureEnabled(value) {
        if (this._EmissiveTextureEnabled === value) return;
        this._EmissiveTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are specular textures enabled in the application.
     */ static get SpecularTextureEnabled() {
        return this._SpecularTextureEnabled;
    }
    static set SpecularTextureEnabled(value) {
        if (this._SpecularTextureEnabled === value) return;
        this._SpecularTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are bump textures enabled in the application.
     */ static get BumpTextureEnabled() {
        return this._BumpTextureEnabled;
    }
    static set BumpTextureEnabled(value) {
        if (this._BumpTextureEnabled === value) return;
        this._BumpTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are lightmap textures enabled in the application.
     */ static get LightmapTextureEnabled() {
        return this._LightmapTextureEnabled;
    }
    static set LightmapTextureEnabled(value) {
        if (this._LightmapTextureEnabled === value) return;
        this._LightmapTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are refraction textures enabled in the application.
     */ static get RefractionTextureEnabled() {
        return this._RefractionTextureEnabled;
    }
    static set RefractionTextureEnabled(value) {
        if (this._RefractionTextureEnabled === value) return;
        this._RefractionTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are color grading textures enabled in the application.
     */ static get ColorGradingTextureEnabled() {
        return this._ColorGradingTextureEnabled;
    }
    static set ColorGradingTextureEnabled(value) {
        if (this._ColorGradingTextureEnabled === value) return;
        this._ColorGradingTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are fresnels enabled in the application.
     */ static get FresnelEnabled() {
        return this._FresnelEnabled;
    }
    static set FresnelEnabled(value) {
        if (this._FresnelEnabled === value) return;
        this._FresnelEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(4);
    }
    /**
     * Are clear coat textures enabled in the application.
     */ static get ClearCoatTextureEnabled() {
        return this._ClearCoatTextureEnabled;
    }
    static set ClearCoatTextureEnabled(value) {
        if (this._ClearCoatTextureEnabled === value) return;
        this._ClearCoatTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are clear coat bump textures enabled in the application.
     */ static get ClearCoatBumpTextureEnabled() {
        return this._ClearCoatBumpTextureEnabled;
    }
    static set ClearCoatBumpTextureEnabled(value) {
        if (this._ClearCoatBumpTextureEnabled === value) return;
        this._ClearCoatBumpTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are clear coat tint textures enabled in the application.
     */ static get ClearCoatTintTextureEnabled() {
        return this._ClearCoatTintTextureEnabled;
    }
    static set ClearCoatTintTextureEnabled(value) {
        if (this._ClearCoatTintTextureEnabled === value) return;
        this._ClearCoatTintTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are sheen textures enabled in the application.
     */ static get SheenTextureEnabled() {
        return this._SheenTextureEnabled;
    }
    static set SheenTextureEnabled(value) {
        if (this._SheenTextureEnabled === value) return;
        this._SheenTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are anisotropic textures enabled in the application.
     */ static get AnisotropicTextureEnabled() {
        return this._AnisotropicTextureEnabled;
    }
    static set AnisotropicTextureEnabled(value) {
        if (this._AnisotropicTextureEnabled === value) return;
        this._AnisotropicTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are thickness textures enabled in the application.
     */ static get ThicknessTextureEnabled() {
        return this._ThicknessTextureEnabled;
    }
    static set ThicknessTextureEnabled(value) {
        if (this._ThicknessTextureEnabled === value) return;
        this._ThicknessTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are refraction intensity textures enabled in the application.
     */ static get RefractionIntensityTextureEnabled() {
        return this._ThicknessTextureEnabled;
    }
    static set RefractionIntensityTextureEnabled(value) {
        if (this._RefractionIntensityTextureEnabled === value) return;
        this._RefractionIntensityTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are translucency intensity textures enabled in the application.
     */ static get TranslucencyIntensityTextureEnabled() {
        return this._TranslucencyIntensityTextureEnabled;
    }
    static set TranslucencyIntensityTextureEnabled(value) {
        if (this._TranslucencyIntensityTextureEnabled === value) return;
        this._TranslucencyIntensityTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are translucency tint textures enabled in the application.
     */ static get TranslucencyColorTextureEnabled() {
        return this._TranslucencyColorTextureEnabled;
    }
    static set TranslucencyColorTextureEnabled(value) {
        if (this._TranslucencyColorTextureEnabled === value) return;
        this._TranslucencyColorTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are translucency intensity textures enabled in the application.
     */ static get IridescenceTextureEnabled() {
        return this._IridescenceTextureEnabled;
    }
    static set IridescenceTextureEnabled(value) {
        if (this._IridescenceTextureEnabled === value) return;
        this._IridescenceTextureEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(1);
    }
}
// Flags used to enable or disable a type of texture for all Standard Materials
$1aa143b647fe12a5$export$cf9c31ce2002efcc._DiffuseTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._BaseWeightTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._DetailTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._DecalMapEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._AmbientTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._OpacityTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ReflectionTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._EmissiveTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._SpecularTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._BumpTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._LightmapTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._RefractionTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ColorGradingTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._FresnelEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ClearCoatTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ClearCoatBumpTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ClearCoatTintTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._SheenTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._AnisotropicTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ThicknessTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._RefractionIntensityTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._TranslucencyIntensityTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._TranslucencyColorTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._IridescenceTextureEnabled = true;


/**
 * EffectFallbacks can be used to add fallbacks (properties to disable) to certain properties when desired to improve performance.
 * (Eg. Start at high quality with reflection and fog, if fps is low, remove reflection, if still low remove fog)
 */ class $bca4896819e5389c$export$3e78d35a7e1b5710 {
    constructor(){
        this._defines = {};
        this._currentRank = 32;
        this._maxRank = -1;
        this._mesh = null;
    }
    /**
     * Removes the fallback from the bound mesh.
     */ unBindMesh() {
        this._mesh = null;
    }
    /**
     * Adds a fallback on the specified property.
     * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
     * @param define The name of the define in the shader
     */ addFallback(rank, define) {
        if (!this._defines[rank]) {
            if (rank < this._currentRank) this._currentRank = rank;
            if (rank > this._maxRank) this._maxRank = rank;
            this._defines[rank] = new Array();
        }
        this._defines[rank].push(define);
    }
    /**
     * Sets the mesh to use CPU skinning when needing to fallback.
     * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
     * @param mesh The mesh to use the fallbacks.
     */ addCPUSkinningFallback(rank, mesh) {
        this._mesh = mesh;
        if (rank < this._currentRank) this._currentRank = rank;
        if (rank > this._maxRank) this._maxRank = rank;
    }
    /**
     * Checks to see if more fallbacks are still available.
     */ get hasMoreFallbacks() {
        return this._currentRank <= this._maxRank;
    }
    /**
     * Removes the defines that should be removed when falling back.
     * @param currentDefines defines the current define statements for the shader.
     * @param effect defines the current effect we try to compile
     * @returns The resulting defines with defines of the current rank removed.
     */ reduce(currentDefines, effect) {
        // First we try to switch to CPU skinning
        if (this._mesh && this._mesh.computeBonesUsingShaders && this._mesh.numBoneInfluencers > 0) {
            this._mesh.computeBonesUsingShaders = false;
            currentDefines = currentDefines.replace("#define NUM_BONE_INFLUENCERS " + this._mesh.numBoneInfluencers, "#define NUM_BONE_INFLUENCERS 0");
            effect._bonesComputationForcedToCPU = true;
            const scene = this._mesh.getScene();
            for(let index = 0; index < scene.meshes.length; index++){
                const otherMesh = scene.meshes[index];
                if (!otherMesh.material) {
                    if (!this._mesh.material && otherMesh.computeBonesUsingShaders && otherMesh.numBoneInfluencers > 0) otherMesh.computeBonesUsingShaders = false;
                    continue;
                }
                if (!otherMesh.computeBonesUsingShaders || otherMesh.numBoneInfluencers === 0) continue;
                if (otherMesh.material.getEffect() === effect) otherMesh.computeBonesUsingShaders = false;
                else if (otherMesh.subMeshes) for (const subMesh of otherMesh.subMeshes){
                    const subMeshEffect = subMesh.effect;
                    if (subMeshEffect === effect) {
                        otherMesh.computeBonesUsingShaders = false;
                        break;
                    }
                }
            }
        } else {
            const currentFallbacks = this._defines[this._currentRank];
            if (currentFallbacks) for(let index = 0; index < currentFallbacks.length; index++)currentDefines = currentDefines.replace("#define " + currentFallbacks[index], "");
            this._currentRank++;
        }
        return currentDefines;
    }
}



var $e0Suo = parcelRequire("e0Suo");


var $ir0rz = parcelRequire("ir0rz");



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");


var $ejQPp = parcelRequire("ejQPp");

var $kbQ0z = parcelRequire("kbQ0z");

var $68BIi = parcelRequire("68BIi");
const $cc019f276676254c$var$rxOption = new RegExp("^([gimus]+)!");
class $cc019f276676254c$export$cfed4346ad531eca {
    /**
     * Creates a new instance of the plugin manager
     * @param material material that this manager will manage the plugins for
     */ constructor(material){
        /** @internal */ this._plugins = [];
        this._activePlugins = [];
        this._activePluginsForExtraEvents = [];
        this._material = material;
        this._scene = material.getScene();
        this._engine = this._scene.getEngine();
    }
    /**
     * @internal
     */ _addPlugin(plugin) {
        for(let i = 0; i < this._plugins.length; ++i){
            if (this._plugins[i].name === plugin.name) return false;
        }
        if (this._material._uniformBufferLayoutBuilt) {
            this._material.resetDrawCache();
            this._material._createUniformBuffer();
        }
        if (!plugin.isCompatible(this._material.shaderLanguage)) // eslint-disable-next-line no-throw-literal
        throw `The plugin "${plugin.name}" can't be added to the material "${this._material.name}" because the plugin is not compatible with the shader language of the material.`;
        const pluginClassName = plugin.getClassName();
        if (!$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine[pluginClassName]) $cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine[pluginClassName] = "MATERIALPLUGIN_" + ++$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginCounter;
        this._material._callbackPluginEventGeneric = (id, info)=>this._handlePluginEvent(id, info);
        this._plugins.push(plugin);
        this._plugins.sort((a, b)=>a.priority - b.priority);
        this._codeInjectionPoints = {};
        const defineNamesFromPlugins = {};
        defineNamesFromPlugins[$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine[pluginClassName]] = {
            type: "boolean",
            default: true
        };
        for (const plugin of this._plugins){
            plugin.collectDefines(defineNamesFromPlugins);
            this._collectPointNames("vertex", plugin.getCustomCode("vertex", this._material.shaderLanguage));
            this._collectPointNames("fragment", plugin.getCustomCode("fragment", this._material.shaderLanguage));
        }
        this._defineNamesFromPlugins = defineNamesFromPlugins;
        return true;
    }
    /**
     * @internal
     */ _activatePlugin(plugin) {
        if (this._activePlugins.indexOf(plugin) === -1) {
            this._activePlugins.push(plugin);
            this._activePlugins.sort((a, b)=>a.priority - b.priority);
            this._material._callbackPluginEventIsReadyForSubMesh = this._handlePluginEventIsReadyForSubMesh.bind(this);
            this._material._callbackPluginEventPrepareDefinesBeforeAttributes = this._handlePluginEventPrepareDefinesBeforeAttributes.bind(this);
            this._material._callbackPluginEventPrepareDefines = this._handlePluginEventPrepareDefines.bind(this);
            this._material._callbackPluginEventBindForSubMesh = this._handlePluginEventBindForSubMesh.bind(this);
            if (plugin.registerForExtraEvents) {
                this._activePluginsForExtraEvents.push(plugin);
                this._activePluginsForExtraEvents.sort((a, b)=>a.priority - b.priority);
                this._material._callbackPluginEventHasRenderTargetTextures = this._handlePluginEventHasRenderTargetTextures.bind(this);
                this._material._callbackPluginEventFillRenderTargetTextures = this._handlePluginEventFillRenderTargetTextures.bind(this);
                this._material._callbackPluginEventHardBindForSubMesh = this._handlePluginEventHardBindForSubMesh.bind(this);
            }
        }
    }
    /**
     * Gets a plugin from the list of plugins managed by this manager
     * @param name name of the plugin
     * @returns the plugin if found, else null
     */ getPlugin(name) {
        for(let i = 0; i < this._plugins.length; ++i){
            if (this._plugins[i].name === name) return this._plugins[i];
        }
        return null;
    }
    _handlePluginEventIsReadyForSubMesh(eventData) {
        let isReady = true;
        for (const plugin of this._activePlugins)isReady = isReady && plugin.isReadyForSubMesh(eventData.defines, this._scene, this._engine, eventData.subMesh);
        eventData.isReadyForSubMesh = isReady;
    }
    _handlePluginEventPrepareDefinesBeforeAttributes(eventData) {
        for (const plugin of this._activePlugins)plugin.prepareDefinesBeforeAttributes(eventData.defines, this._scene, eventData.mesh);
    }
    _handlePluginEventPrepareDefines(eventData) {
        for (const plugin of this._activePlugins)plugin.prepareDefines(eventData.defines, this._scene, eventData.mesh);
    }
    _handlePluginEventHardBindForSubMesh(eventData) {
        for (const plugin of this._activePluginsForExtraEvents)plugin.hardBindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, eventData.subMesh);
    }
    _handlePluginEventBindForSubMesh(eventData) {
        for (const plugin of this._activePlugins)plugin.bindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, eventData.subMesh);
    }
    _handlePluginEventHasRenderTargetTextures(eventData) {
        let hasRenderTargetTextures = false;
        for (const plugin of this._activePluginsForExtraEvents){
            hasRenderTargetTextures = plugin.hasRenderTargetTextures();
            if (hasRenderTargetTextures) break;
        }
        eventData.hasRenderTargetTextures = hasRenderTargetTextures;
    }
    _handlePluginEventFillRenderTargetTextures(eventData) {
        for (const plugin of this._activePluginsForExtraEvents)plugin.fillRenderTargetTextures(eventData.renderTargets);
    }
    _handlePluginEvent(id, info) {
        switch(id){
            case 512 /* MaterialPluginEvent.GetActiveTextures */ :
                {
                    const eventData = info;
                    for (const plugin of this._activePlugins)plugin.getActiveTextures(eventData.activeTextures);
                    break;
                }
            case 256 /* MaterialPluginEvent.GetAnimatables */ :
                {
                    const eventData = info;
                    for (const plugin of this._activePlugins)plugin.getAnimatables(eventData.animatables);
                    break;
                }
            case 1024 /* MaterialPluginEvent.HasTexture */ :
                {
                    const eventData = info;
                    let hasTexture = false;
                    for (const plugin of this._activePlugins){
                        hasTexture = plugin.hasTexture(eventData.texture);
                        if (hasTexture) break;
                    }
                    eventData.hasTexture = hasTexture;
                    break;
                }
            case 2 /* MaterialPluginEvent.Disposed */ :
                {
                    const eventData = info;
                    for (const plugin of this._plugins)plugin.dispose(eventData.forceDisposeTextures);
                    break;
                }
            case 4 /* MaterialPluginEvent.GetDefineNames */ :
                {
                    const eventData = info;
                    eventData.defineNames = this._defineNamesFromPlugins;
                    break;
                }
            case 128 /* MaterialPluginEvent.PrepareEffect */ :
                {
                    const eventData = info;
                    for (const plugin of this._activePlugins){
                        eventData.fallbackRank = plugin.addFallbacks(eventData.defines, eventData.fallbacks, eventData.fallbackRank);
                        plugin.getAttributes(eventData.attributes, this._scene, eventData.mesh);
                    }
                    if (this._uniformList.length > 0) eventData.uniforms.push(...this._uniformList);
                    if (this._samplerList.length > 0) eventData.samplers.push(...this._samplerList);
                    if (this._uboList.length > 0) eventData.uniformBuffersNames.push(...this._uboList);
                    eventData.customCode = this._injectCustomCode(eventData, eventData.customCode);
                    break;
                }
            case 8 /* MaterialPluginEvent.PrepareUniformBuffer */ :
                {
                    const eventData = info;
                    this._uboDeclaration = "";
                    this._vertexDeclaration = "";
                    this._fragmentDeclaration = "";
                    this._uniformList = [];
                    this._samplerList = [];
                    this._uboList = [];
                    const isWebGPU = this._material.shaderLanguage === 1 /* ShaderLanguage.WGSL */ ;
                    for (const plugin of this._plugins){
                        const uniforms = plugin.getUniforms(this._material.shaderLanguage);
                        if (uniforms) {
                            if (uniforms.ubo) for (const uniform of uniforms.ubo){
                                if (uniform.size && uniform.type) {
                                    const arraySize = uniform.arraySize ?? 0;
                                    eventData.ubo.addUniform(uniform.name, uniform.size, arraySize);
                                    if (isWebGPU) {
                                        let type;
                                        switch(uniform.type){
                                            case "mat4":
                                                type = "mat4x4f";
                                                break;
                                            case "float":
                                                type = "f32";
                                                break;
                                            default:
                                                type = `${uniform.type}f`;
                                                break;
                                        }
                                        this._uboDeclaration += `uniform ${uniform.name}: ${type}${arraySize > 0 ? `[${arraySize}]` : ""};\n`;
                                    } else this._uboDeclaration += `${uniform.type} ${uniform.name}${arraySize > 0 ? `[${arraySize}]` : ""};\n`;
                                }
                                this._uniformList.push(uniform.name);
                            }
                            if (uniforms.vertex) this._vertexDeclaration += uniforms.vertex + "\n";
                            if (uniforms.fragment) this._fragmentDeclaration += uniforms.fragment + "\n";
                        }
                        plugin.getSamplers(this._samplerList);
                        plugin.getUniformBuffersNames(this._uboList);
                    }
                    break;
                }
        }
    }
    _collectPointNames(shaderType, customCode) {
        if (!customCode) return;
        for(const pointName in customCode){
            if (!this._codeInjectionPoints[shaderType]) this._codeInjectionPoints[shaderType] = {};
            this._codeInjectionPoints[shaderType][pointName] = true;
        }
    }
    _injectCustomCode(eventData, existingCallback) {
        return (shaderType, code)=>{
            if (existingCallback) code = existingCallback(shaderType, code);
            if (this._uboDeclaration) code = code.replace("#define ADDITIONAL_UBO_DECLARATION", this._uboDeclaration);
            if (this._vertexDeclaration) code = code.replace("#define ADDITIONAL_VERTEX_DECLARATION", this._vertexDeclaration);
            if (this._fragmentDeclaration) code = code.replace("#define ADDITIONAL_FRAGMENT_DECLARATION", this._fragmentDeclaration);
            const points = this._codeInjectionPoints?.[shaderType];
            if (!points) return code;
            let processorOptions = null;
            for(let pointName in points){
                let injectedCode = "";
                for (const plugin of this._activePlugins){
                    let customCode = plugin.getCustomCode(shaderType, this._material.shaderLanguage)?.[pointName];
                    if (!customCode) continue;
                    if (plugin.resolveIncludes) {
                        if (processorOptions === null) {
                            const shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
                            processorOptions = {
                                defines: [],
                                indexParameters: eventData.indexParameters,
                                isFragment: false,
                                shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
                                processor: undefined,
                                supportsUniformBuffers: this._engine.supportsUniformBuffers,
                                shadersRepository: (0, $68BIi.ShaderStore).GetShadersRepository(shaderLanguage),
                                includesShadersStore: (0, $68BIi.ShaderStore).GetIncludesShadersStore(shaderLanguage),
                                version: undefined,
                                platformName: this._engine.shaderPlatformName,
                                processingContext: undefined,
                                isNDCHalfZRange: this._engine.isNDCHalfZRange,
                                useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
                                processCodeAfterIncludes: undefined
                            };
                        }
                        processorOptions.isFragment = shaderType === "fragment";
                        (0, $kbQ0z._ProcessIncludes)(customCode, processorOptions, (code)=>customCode = code);
                    }
                    injectedCode += customCode + "\n";
                }
                if (injectedCode.length > 0) {
                    if (pointName.charAt(0) === "!") {
                        // pointName is a regular expression
                        pointName = pointName.substring(1);
                        let regexFlags = "g";
                        if (pointName.charAt(0) === "!") {
                            // no flags
                            regexFlags = "";
                            pointName = pointName.substring(1);
                        } else {
                            // get the flag(s)
                            const matchOption = $cc019f276676254c$var$rxOption.exec(pointName);
                            if (matchOption && matchOption.length >= 2) {
                                regexFlags = matchOption[1];
                                pointName = pointName.substring(regexFlags.length + 1);
                            }
                        }
                        if (regexFlags.indexOf("g") < 0) // we force the "g" flag so that the regexp object is stateful!
                        regexFlags += "g";
                        const sourceCode = code;
                        const rx = new RegExp(pointName, regexFlags);
                        let match = rx.exec(sourceCode);
                        while(match !== null){
                            let newCode = injectedCode;
                            for(let i = 0; i < match.length; ++i)newCode = newCode.replace("$" + i, match[i]);
                            code = code.replace(match[0], newCode);
                            match = rx.exec(sourceCode);
                        }
                    } else {
                        const fullPointName = "#define " + pointName;
                        code = code.replace(fullPointName, "\n" + injectedCode + "\n" + fullPointName);
                    }
                }
            }
            return code;
        };
    }
}
/** Map a plugin class name to a #define name (used in the vertex/fragment shaders as a marker of the plugin usage) */ $cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine = {};
$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginCounter = 0;
(()=>{
    (0, $ejQPp.EngineStore).OnEnginesDisposedObservable.add(()=>{
        $cc019f276676254c$export$6f779d17b215c2fa();
    });
})();
const $cc019f276676254c$var$plugins = [];
let $cc019f276676254c$var$inited = false;
let $cc019f276676254c$var$observer = null;
function $cc019f276676254c$export$787415a59e199b09(pluginName, factory) {
    if (!$cc019f276676254c$var$inited) {
        $cc019f276676254c$var$observer = (0, $3afee756ef198914$export$a2d8b23205c25948).OnEventObservable.add((material)=>{
            for (const [, factory] of $cc019f276676254c$var$plugins)factory(material);
        }, 1 /* MaterialPluginEvent.Created */ );
        $cc019f276676254c$var$inited = true;
    }
    const existing = $cc019f276676254c$var$plugins.filter(([name, _factory])=>name === pluginName);
    if (existing.length > 0) existing[0][1] = factory;
    else $cc019f276676254c$var$plugins.push([
        pluginName,
        factory
    ]);
}
function $cc019f276676254c$export$c603bda0a41a9e24(pluginName) {
    for(let i = 0; i < $cc019f276676254c$var$plugins.length; ++i)if ($cc019f276676254c$var$plugins[i][0] === pluginName) {
        $cc019f276676254c$var$plugins.splice(i, 1);
        if ($cc019f276676254c$var$plugins.length === 0) $cc019f276676254c$export$6f779d17b215c2fa();
        return true;
    }
    return false;
}
function $cc019f276676254c$export$6f779d17b215c2fa() {
    $cc019f276676254c$var$plugins.length = 0;
    $cc019f276676254c$var$inited = false;
    (0, $3afee756ef198914$export$a2d8b23205c25948).OnEventObservable.remove($cc019f276676254c$var$observer);
    $cc019f276676254c$var$observer = null;
}



var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");
class $686a4ce3c70ae4d4$export$2e779f428b78d16a {
    /**
     * Gets a boolean indicating that the plugin is compatible with a given shader language.
     * @param shaderLanguage The shader language to use.
     * @returns true if the plugin is compatible with the shader language
     */ isCompatible(shaderLanguage) {
        switch(shaderLanguage){
            case 0 /* ShaderLanguage.GLSL */ :
                return true;
            default:
                return false;
        }
    }
    _enable(enable) {
        if (enable) this._pluginManager._activatePlugin(this);
    }
    /**
     * Creates a new material plugin
     * @param material parent material of the plugin
     * @param name name of the plugin
     * @param priority priority of the plugin
     * @param defines list of defines used by the plugin. The value of the property is the default value for this property
     * @param addToPluginList true to add the plugin to the list of plugins managed by the material plugin manager of the material (default: true)
     * @param enable true to enable the plugin (it is handy if the plugin does not handle properties to switch its current activation)
     * @param resolveIncludes Indicates that any #include directive in the plugin code must be replaced by the corresponding code (default: false)
     */ constructor(material, name, priority, defines, addToPluginList = true, enable = false, resolveIncludes = false){
        /**
         * Defines the priority of the plugin. Lower numbers run first.
         */ this.priority = 500;
        /**
         * Indicates that any #include directive in the plugin code must be replaced by the corresponding code.
         */ this.resolveIncludes = false;
        /**
         * Indicates that this plugin should be notified for the extra events (HasRenderTargetTextures / FillRenderTargetTextures / HardBindForSubMesh)
         */ this.registerForExtraEvents = false;
        /**
         * Specifies if the material plugin should be serialized, `true` to skip serialization
         */ this.doNotSerialize = false;
        this._material = material;
        this.name = name;
        this.priority = priority;
        this.resolveIncludes = resolveIncludes;
        if (!material.pluginManager) {
            material.pluginManager = new (0, $cc019f276676254c$export$cfed4346ad531eca)(material);
            material.onDisposeObservable.add(()=>{
                material.pluginManager = undefined;
            });
        }
        this._pluginDefineNames = defines;
        this._pluginManager = material.pluginManager;
        if (addToPluginList) this._pluginManager._addPlugin(this);
        if (enable) this._enable(true);
        this.markAllDefinesAsDirty = material._dirtyCallbacks[63];
    }
    /**
     * Gets the current class name useful for serialization or dynamic coding.
     * @returns The class name.
     */ getClassName() {
        return "MaterialPluginBase";
    }
    /**
     * Specifies that the submesh is ready to be used.
     * @param _defines the list of "defines" to update.
     * @param _scene defines the scene the material belongs to.
     * @param _engine the engine this scene belongs to.
     * @param _subMesh the submesh to check for readiness
     * @returns - boolean indicating that the submesh is ready or not.
     */ isReadyForSubMesh(_defines, _scene, _engine, _subMesh) {
        return true;
    }
    /**
     * Binds the material data (this function is called even if mustRebind() returns false)
     * @param _uniformBuffer defines the Uniform buffer to fill in.
     * @param _scene defines the scene the material belongs to.
     * @param _engine defines the engine the material belongs to.
     * @param _subMesh the submesh to bind data for
     */ hardBindForSubMesh(_uniformBuffer, _scene, _engine, _subMesh) {}
    /**
     * Binds the material data.
     * @param _uniformBuffer defines the Uniform buffer to fill in.
     * @param _scene defines the scene the material belongs to.
     * @param _engine the engine this scene belongs to.
     * @param _subMesh the submesh to bind data for
     */ bindForSubMesh(_uniformBuffer, _scene, _engine, _subMesh) {}
    /**
     * Disposes the resources of the material.
     * @param _forceDisposeTextures - Forces the disposal of all textures.
     */ dispose(_forceDisposeTextures) {}
    /**
     * Returns a list of custom shader code fragments to customize the shader.
     * @param _shaderType "vertex" or "fragment"
     * @param _shaderLanguage The shader language to use.
     * @returns null if no code to be added, or a list of pointName =\> code.
     * Note that `pointName` can also be a regular expression if it starts with a `!`.
     * In that case, the string found by the regular expression (if any) will be
     * replaced by the code provided.
     */ getCustomCode(_shaderType, _shaderLanguage = 0 /* ShaderLanguage.GLSL */ ) {
        return null;
    }
    /**
     * Collects all defines.
     * @param defines The object to append to.
     */ collectDefines(defines) {
        if (!this._pluginDefineNames) return;
        for (const key of Object.keys(this._pluginDefineNames)){
            if (key[0] === "_") continue;
            const type = typeof this._pluginDefineNames[key];
            defines[key] = {
                type: type === "number" ? "number" : type === "string" ? "string" : type === "boolean" ? "boolean" : "object",
                default: this._pluginDefineNames[key]
            };
        }
    }
    /**
     * Sets the defines for the next rendering. Called before PrepareDefinesForAttributes is called.
     * @param _defines the list of "defines" to update.
     * @param _scene defines the scene to the material belongs to.
     * @param _mesh the mesh being rendered
     */ prepareDefinesBeforeAttributes(_defines, _scene, _mesh) {}
    /**
     * Sets the defines for the next rendering
     * @param _defines the list of "defines" to update.
     * @param _scene defines the scene to the material belongs to.
     * @param _mesh the mesh being rendered
     */ prepareDefines(_defines, _scene, _mesh) {}
    /**
     * Checks to see if a texture is used in the material.
     * @param _texture - Base texture to use.
     * @returns - Boolean specifying if a texture is used in the material.
     */ hasTexture(_texture) {
        return false;
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     * @returns true if this uses a render target otherwise false.
     */ hasRenderTargetTextures() {
        return false;
    }
    /**
     * Fills the list of render target textures.
     * @param _renderTargets the list of render targets to update
     */ fillRenderTargetTextures(_renderTargets) {}
    /**
     * Returns an array of the actively used textures.
     * @param _activeTextures Array of BaseTextures
     */ getActiveTextures(_activeTextures) {}
    /**
     * Returns the animatable textures.
     * @param _animatables Array of animatable textures.
     */ getAnimatables(_animatables) {}
    /**
     * Add fallbacks to the effect fallbacks list.
     * @param defines defines the Base texture to use.
     * @param fallbacks defines the current fallback list.
     * @param currentRank defines the current fallback rank.
     * @returns the new fallback rank.
     */ addFallbacks(defines, fallbacks, currentRank) {
        return currentRank;
    }
    /**
     * Gets the samplers used by the plugin.
     * @param _samplers list that the sampler names should be added to.
     */ getSamplers(_samplers) {}
    /**
     * Gets the attributes used by the plugin.
     * @param _attributes list that the attribute names should be added to.
     * @param _scene the scene that the material belongs to.
     * @param _mesh the mesh being rendered.
     */ getAttributes(_attributes, _scene, _mesh) {}
    /**
     * Gets the uniform buffers names added by the plugin.
     * @param _ubos list that the ubo names should be added to.
     */ getUniformBuffersNames(_ubos) {}
    /**
     * Gets the description of the uniforms to add to the ubo (if engine supports ubos) or to inject directly in the vertex/fragment shaders (if engine does not support ubos)
     * @param _shaderLanguage The shader language to use.
     * @returns the description of the uniforms
     */ getUniforms(_shaderLanguage = 0 /* ShaderLanguage.GLSL */ ) {
        return {};
    }
    /**
     * Makes a duplicate of the current configuration into another one.
     * @param plugin define the config where to copy the info
     */ copyTo(plugin) {
        (0, $6Ho1L.SerializationHelper).Clone(()=>plugin, this);
    }
    /**
     * Serializes this plugin configuration.
     * @returns - An object with the serialized config.
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses a plugin configuration from a serialized object.
     * @param source - Serialized object.
     * @param scene Defines the scene we are parsing for
     * @param rootUrl Defines the rootUrl to load from
     */ parse(source, scene, rootUrl) {
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "priority", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "resolveIncludes", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "registerForExtraEvents", void 0);
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.MaterialPluginBase", $686a4ce3c70ae4d4$export$2e779f428b78d16a);



class $8a41416de02c81e4$export$e59daebb20f46cc8 extends (0, $23fbb8c84eee5c40$export$4c55cb8c02c1a25d) {
    constructor(){
        super(...arguments);
        this.DETAIL = false;
        this.DETAILDIRECTUV = 0;
        this.DETAIL_NORMALBLENDMETHOD = 0;
    }
}
class $8a41416de02c81e4$export$37c50da823378b6e extends (0, $686a4ce3c70ae4d4$export$2e779f428b78d16a) {
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    /**
     * Gets a boolean indicating that the plugin is compatible with a given shader language.
     * @returns true if the plugin is compatible with the shader language
     */ isCompatible() {
        return true;
    }
    constructor(material, addToPluginList = true){
        super(material, "DetailMap", 140, new $8a41416de02c81e4$export$e59daebb20f46cc8(), addToPluginList);
        this._texture = null;
        /**
         * Defines how strongly the detail diffuse/albedo channel is blended with the regular diffuse/albedo texture
         * Bigger values mean stronger blending
         */ this.diffuseBlendLevel = 1;
        /**
         * Defines how strongly the detail roughness channel is blended with the regular roughness value
         * Bigger values mean stronger blending. Only used with PBR materials
         */ this.roughnessBlendLevel = 1;
        /**
         * Defines how strong the bump effect from the detail map is
         * Bigger values mean stronger effect
         */ this.bumpLevel = 1;
        this._normalBlendMethod = (0, $3afee756ef198914$export$a2d8b23205c25948).MATERIAL_NORMALBLENDMETHOD_WHITEOUT;
        this._isEnabled = false;
        /**
         * Enable or disable the detail map on this material
         */ this.isEnabled = false;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
    }
    isReadyForSubMesh(defines, scene, engine) {
        if (!this._isEnabled) return true;
        if (defines._areTexturesDirty && scene.texturesEnabled) {
            if (engine.getCaps().standardDerivatives && this._texture && (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DetailTextureEnabled) {
                // Detail texture cannot be not blocking.
                if (!this._texture.isReady()) return false;
            }
        }
        return true;
    }
    prepareDefines(defines, scene) {
        if (this._isEnabled) {
            defines.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
            const engine = scene.getEngine();
            if (defines._areTexturesDirty) {
                if (engine.getCaps().standardDerivatives && this._texture && (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DetailTextureEnabled && this._isEnabled) {
                    (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._texture, defines, "DETAIL");
                    defines.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
                } else defines.DETAIL = false;
            }
        } else defines.DETAIL = false;
    }
    bindForSubMesh(uniformBuffer, scene) {
        if (!this._isEnabled) return;
        const isFrozen = this._material.isFrozen;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (this._texture && (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DetailTextureEnabled) {
                uniformBuffer.updateFloat4("vDetailInfos", this._texture.coordinatesIndex, this.diffuseBlendLevel, this.bumpLevel, this.roughnessBlendLevel);
                (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._texture, uniformBuffer, "detail");
            }
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._texture && (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DetailTextureEnabled) uniformBuffer.setTexture("detailSampler", this._texture);
        }
    }
    hasTexture(texture) {
        if (this._texture === texture) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._texture) activeTextures.push(this._texture);
    }
    getAnimatables(animatables) {
        if (this._texture && this._texture.animations && this._texture.animations.length > 0) animatables.push(this._texture);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) this._texture?.dispose();
    }
    getClassName() {
        return "DetailMapConfiguration";
    }
    getSamplers(samplers) {
        samplers.push("detailSampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vDetailInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "detailMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("detailTexture"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "diffuseBlendLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "roughnessBlendLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "bumpLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "normalBlendMethod", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "isEnabled", void 0);





var $6Ho1L = parcelRequire("6Ho1L");

var $ha1VO = parcelRequire("ha1VO");
var $551eb891fe6c445d$export$848291e839a1a3e0;
(function(GeometryRenderingTextureClearType) {
    /**
     * Clear the texture with zero.
     */ GeometryRenderingTextureClearType[GeometryRenderingTextureClearType["Zero"] = 0] = "Zero";
    /**
     * Clear the texture with one.
     */ GeometryRenderingTextureClearType[GeometryRenderingTextureClearType["One"] = 1] = "One";
    /**
     * Clear the texture with the maximum view Z value.
     */ GeometryRenderingTextureClearType[GeometryRenderingTextureClearType["MaxViewZ"] = 2] = "MaxViewZ";
})($551eb891fe6c445d$export$848291e839a1a3e0 || ($551eb891fe6c445d$export$848291e839a1a3e0 = {}));
class $551eb891fe6c445d$export$fb311b9fc5942600 {
    /**
     * Creates a new geometry rendering configuration.
     * @param renderPassId Render pass id the configuration is created for.
     * @returns The created configuration.
     */ static CreateConfiguration(renderPassId) {
        $551eb891fe6c445d$export$fb311b9fc5942600._Configurations[renderPassId] = {
            defines: {},
            previousWorldMatrices: {},
            previousViewProjection: (0, $ha1VO.Matrix).Zero(),
            currentViewProjection: (0, $ha1VO.Matrix).Zero(),
            previousBones: {},
            lastUpdateFrameId: -1,
            excludedSkinnedMesh: []
        };
        return $551eb891fe6c445d$export$fb311b9fc5942600._Configurations[renderPassId];
    }
    /**
     * Deletes a geometry rendering configuration.
     * @param renderPassId The render pass id of the configuration to delete.
     */ static DeleteConfiguration(renderPassId) {
        delete $551eb891fe6c445d$export$fb311b9fc5942600._Configurations[renderPassId];
    }
    /**
     * Gets a geometry rendering configuration.
     * @param renderPassId The render pass id of the configuration to get.
     * @returns The configuration.
     */ static GetConfiguration(renderPassId) {
        return $551eb891fe6c445d$export$fb311b9fc5942600._Configurations[renderPassId];
    }
    /**
     * Adds uniforms and samplers for geometry rendering.
     * @param uniforms The array of uniforms to add to.
     * @param _samplers The array of samplers to add to.
     */ static AddUniformsAndSamplers(uniforms, _samplers) {
        uniforms.push("previousWorld", "previousViewProjection", "mPreviousBones");
    }
    /**
     * Marks a list of meshes as dirty for geometry rendering.
     * @param renderPassId The render pass id the meshes are marked as dirty for.
     * @param meshes The list of meshes to mark as dirty.
     */ static MarkAsDirty(renderPassId, meshes) {
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes)subMesh._removeDrawWrapper(renderPassId);
        }
    }
    /**
     * Prepares defines for geometry rendering.
     * @param renderPassId The render pass id the defines are prepared for.
     * @param mesh The mesh the defines are prepared for.
     * @param defines The defines to update according to the geometry rendering configuration.
     */ static PrepareDefines(renderPassId, mesh, defines) {
        if (!defines._arePrePassDirty) return;
        const configuration = $551eb891fe6c445d$export$fb311b9fc5942600._Configurations[renderPassId];
        if (!configuration) return;
        defines["PREPASS"] = true;
        defines["PREPASS_COLOR"] = false;
        defines["PREPASS_COLOR_INDEX"] = -1;
        let numMRT = 0;
        for(let i = 0; i < $551eb891fe6c445d$export$fb311b9fc5942600.GeometryTextureDescriptions.length; i++){
            const geometryTextureDescription = $551eb891fe6c445d$export$fb311b9fc5942600.GeometryTextureDescriptions[i];
            const defineName = geometryTextureDescription.define;
            const defineIndex = geometryTextureDescription.defineIndex;
            const index = configuration.defines[defineIndex];
            if (index !== undefined) {
                defines[defineName] = true;
                defines[defineIndex] = index;
                numMRT++;
            } else {
                defines[defineName] = false;
                delete defines[defineIndex];
            }
        }
        defines["SCENE_MRT_COUNT"] = numMRT;
        defines["BONES_VELOCITY_ENABLED"] = mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton && !mesh.skeleton.isUsingTextureForMatrices && configuration.excludedSkinnedMesh.indexOf(mesh) === -1;
    }
    /**
     * Binds geometry rendering data for a mesh.
     * @param renderPassId The render pass id the geometry rendering data is bound for.
     * @param effect The effect to bind the geometry rendering data to.
     * @param mesh The mesh to bind the geometry rendering data for.
     * @param world The world matrix of the mesh.
     */ static Bind(renderPassId, effect, mesh, world) {
        const configuration = $551eb891fe6c445d$export$fb311b9fc5942600._Configurations[renderPassId];
        if (!configuration) return;
        if (configuration.defines["PREPASS_VELOCITY_INDEX"] !== undefined || configuration.defines["PREPASS_VELOCITY_LINEAR_INDEX"] !== undefined) {
            if (!configuration.previousWorldMatrices[mesh.uniqueId]) configuration.previousWorldMatrices[mesh.uniqueId] = world.clone();
            const scene = mesh.getScene();
            if (!configuration.previousViewProjection) {
                configuration.previousViewProjection = scene.getTransformMatrix().clone();
                configuration.currentViewProjection = scene.getTransformMatrix().clone();
            }
            const engine = scene.getEngine();
            if (configuration.currentViewProjection.updateFlag !== scene.getTransformMatrix().updateFlag) {
                // First update of the prepass configuration for this rendering pass
                configuration.lastUpdateFrameId = engine.frameId;
                configuration.previousViewProjection.copyFrom(configuration.currentViewProjection);
                configuration.currentViewProjection.copyFrom(scene.getTransformMatrix());
            } else if (configuration.lastUpdateFrameId !== engine.frameId) {
                // The scene transformation did not change from the previous frame (so no camera motion), we must update previousViewProjection accordingly
                configuration.lastUpdateFrameId = engine.frameId;
                configuration.previousViewProjection.copyFrom(configuration.currentViewProjection);
            }
            effect.setMatrix("previousWorld", configuration.previousWorldMatrices[mesh.uniqueId]);
            effect.setMatrix("previousViewProjection", configuration.previousViewProjection);
            configuration.previousWorldMatrices[mesh.uniqueId] = world.clone();
            if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
                const skeleton = mesh.skeleton;
                if (!skeleton.isUsingTextureForMatrices || effect.getUniformIndex("boneTextureWidth") === -1) {
                    const matrices = skeleton.getTransformMatrices(mesh);
                    if (matrices) {
                        if (!configuration.previousBones[mesh.uniqueId]) configuration.previousBones[mesh.uniqueId] = matrices.slice();
                        effect.setMatrices("mPreviousBones", configuration.previousBones[mesh.uniqueId]);
                        configuration.previousBones[mesh.uniqueId].set(matrices);
                    }
                }
            }
        }
    }
}
/**
 * Descriptions of the geometry textures.
 */ $551eb891fe6c445d$export$fb311b9fc5942600.GeometryTextureDescriptions = [
    {
        type: 0,
        name: "Irradiance",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_IRRADIANCE",
        defineIndex: "PREPASS_IRRADIANCE_INDEX"
    },
    {
        type: 1,
        name: "WorldPosition",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_POSITION",
        defineIndex: "PREPASS_POSITION_INDEX"
    },
    {
        type: 2,
        name: "Velocity",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_VELOCITY",
        defineIndex: "PREPASS_VELOCITY_INDEX"
    },
    {
        type: 3,
        name: "Reflectivity",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_REFLECTIVITY",
        defineIndex: "PREPASS_REFLECTIVITY_INDEX"
    },
    {
        type: 5,
        name: "ViewDepth",
        clearType: 2 /* GeometryRenderingTextureClearType.MaxViewZ */ ,
        define: "PREPASS_DEPTH",
        defineIndex: "PREPASS_DEPTH_INDEX"
    },
    {
        type: 6,
        name: "ViewNormal",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_NORMAL",
        defineIndex: "PREPASS_NORMAL_INDEX"
    },
    {
        type: 7,
        name: "AlbedoSqrt",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_ALBEDO_SQRT",
        defineIndex: "PREPASS_ALBEDO_SQRT_INDEX"
    },
    {
        type: 8,
        name: "WorldNormal",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_WORLD_NORMAL",
        defineIndex: "PREPASS_WORLD_NORMAL_INDEX"
    },
    {
        type: 9,
        name: "LocalPosition",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_LOCAL_POSITION",
        defineIndex: "PREPASS_LOCAL_POSITION_INDEX"
    },
    {
        type: 10,
        name: "ScreenDepth",
        clearType: 1 /* GeometryRenderingTextureClearType.One */ ,
        define: "PREPASS_SCREENSPACE_DEPTH",
        defineIndex: "PREPASS_SCREENSPACE_DEPTH_INDEX"
    },
    {
        type: 11,
        name: "LinearVelocity",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_VELOCITY_LINEAR",
        defineIndex: "PREPASS_VELOCITY_LINEAR_INDEX"
    },
    {
        type: 12,
        name: "Albedo",
        clearType: 0 /* GeometryRenderingTextureClearType.Zero */ ,
        define: "PREPASS_ALBEDO",
        defineIndex: "PREPASS_ALBEDO_INDEX"
    }
];
$551eb891fe6c445d$export$fb311b9fc5942600._Configurations = {};


const $c14168b02f7bcc00$var$onCreatedEffectParameters = {
    effect: null,
    subMesh: null
};
class $c14168b02f7bcc00$export$8a3963f3d5f6315f extends (0, $23fbb8c84eee5c40$export$4c55cb8c02c1a25d) {
    /**
     * Initializes the Standard Material defines.
     * @param externalProperties The external properties
     */ constructor(externalProperties){
        super(externalProperties);
        this.MAINUV1 = false;
        this.MAINUV2 = false;
        this.MAINUV3 = false;
        this.MAINUV4 = false;
        this.MAINUV5 = false;
        this.MAINUV6 = false;
        this.DIFFUSE = false;
        this.DIFFUSEDIRECTUV = 0;
        this.BAKED_VERTEX_ANIMATION_TEXTURE = false;
        this.AMBIENT = false;
        this.AMBIENTDIRECTUV = 0;
        this.OPACITY = false;
        this.OPACITYDIRECTUV = 0;
        this.OPACITYRGB = false;
        this.REFLECTION = false;
        this.EMISSIVE = false;
        this.EMISSIVEDIRECTUV = 0;
        this.SPECULAR = false;
        this.SPECULARDIRECTUV = 0;
        this.BUMP = false;
        this.BUMPDIRECTUV = 0;
        this.PARALLAX = false;
        this.PARALLAX_RHS = false;
        this.PARALLAXOCCLUSION = false;
        this.SPECULAROVERALPHA = false;
        this.CLIPPLANE = false;
        this.CLIPPLANE2 = false;
        this.CLIPPLANE3 = false;
        this.CLIPPLANE4 = false;
        this.CLIPPLANE5 = false;
        this.CLIPPLANE6 = false;
        this.ALPHATEST = false;
        this.DEPTHPREPASS = false;
        this.ALPHAFROMDIFFUSE = false;
        this.POINTSIZE = false;
        this.FOG = false;
        this.SPECULARTERM = false;
        this.DIFFUSEFRESNEL = false;
        this.OPACITYFRESNEL = false;
        this.REFLECTIONFRESNEL = false;
        this.REFRACTIONFRESNEL = false;
        this.EMISSIVEFRESNEL = false;
        this.FRESNEL = false;
        this.NORMAL = false;
        this.TANGENT = false;
        this.UV1 = false;
        this.UV2 = false;
        this.UV3 = false;
        this.UV4 = false;
        this.UV5 = false;
        this.UV6 = false;
        this.VERTEXCOLOR = false;
        this.VERTEXALPHA = false;
        this.NUM_BONE_INFLUENCERS = 0;
        this.BonesPerMesh = 0;
        this.BONETEXTURE = false;
        this.BONES_VELOCITY_ENABLED = false;
        this.INSTANCES = false;
        this.THIN_INSTANCES = false;
        this.INSTANCESCOLOR = false;
        this.GLOSSINESS = false;
        this.ROUGHNESS = false;
        this.EMISSIVEASILLUMINATION = false;
        this.LINKEMISSIVEWITHDIFFUSE = false;
        this.REFLECTIONFRESNELFROMSPECULAR = false;
        this.LIGHTMAP = false;
        this.LIGHTMAPDIRECTUV = 0;
        this.OBJECTSPACE_NORMALMAP = false;
        this.USELIGHTMAPASSHADOWMAP = false;
        this.REFLECTIONMAP_3D = false;
        this.REFLECTIONMAP_SPHERICAL = false;
        this.REFLECTIONMAP_PLANAR = false;
        this.REFLECTIONMAP_CUBIC = false;
        this.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
        this.USE_LOCAL_REFRACTIONMAP_CUBIC = false;
        this.REFLECTIONMAP_PROJECTION = false;
        this.REFLECTIONMAP_SKYBOX = false;
        this.REFLECTIONMAP_EXPLICIT = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
        this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
        this.REFLECTIONMAP_OPPOSITEZ = false;
        this.INVERTCUBICMAP = false;
        this.LOGARITHMICDEPTH = false;
        this.REFRACTION = false;
        this.REFRACTIONMAP_3D = false;
        this.REFLECTIONOVERALPHA = false;
        this.TWOSIDEDLIGHTING = false;
        this.SHADOWFLOAT = false;
        this.MORPHTARGETS = false;
        this.MORPHTARGETS_POSITION = false;
        this.MORPHTARGETS_NORMAL = false;
        this.MORPHTARGETS_TANGENT = false;
        this.MORPHTARGETS_UV = false;
        this.MORPHTARGETS_UV2 = false;
        this.MORPHTARGETTEXTURE_HASPOSITIONS = false;
        this.MORPHTARGETTEXTURE_HASNORMALS = false;
        this.MORPHTARGETTEXTURE_HASTANGENTS = false;
        this.MORPHTARGETTEXTURE_HASUVS = false;
        this.MORPHTARGETTEXTURE_HASUV2S = false;
        this.NUM_MORPH_INFLUENCERS = 0;
        this.MORPHTARGETS_TEXTURE = false;
        this.NONUNIFORMSCALING = false; // https://playground.babylonjs.com#V6DWIH
        this.PREMULTIPLYALPHA = false; // https://playground.babylonjs.com#LNVJJ7
        this.ALPHATEST_AFTERALLALPHACOMPUTATIONS = false;
        this.ALPHABLEND = true;
        this.PREPASS = false;
        this.PREPASS_COLOR = false;
        this.PREPASS_COLOR_INDEX = -1;
        this.PREPASS_IRRADIANCE = false;
        this.PREPASS_IRRADIANCE_INDEX = -1;
        this.PREPASS_ALBEDO = false;
        this.PREPASS_ALBEDO_INDEX = -1;
        this.PREPASS_ALBEDO_SQRT = false;
        this.PREPASS_ALBEDO_SQRT_INDEX = -1;
        this.PREPASS_DEPTH = false;
        this.PREPASS_DEPTH_INDEX = -1;
        this.PREPASS_SCREENSPACE_DEPTH = false;
        this.PREPASS_SCREENSPACE_DEPTH_INDEX = -1;
        this.PREPASS_NORMAL = false;
        this.PREPASS_NORMAL_INDEX = -1;
        this.PREPASS_NORMAL_WORLDSPACE = false;
        this.PREPASS_WORLD_NORMAL = false;
        this.PREPASS_WORLD_NORMAL_INDEX = -1;
        this.PREPASS_POSITION = false;
        this.PREPASS_POSITION_INDEX = -1;
        this.PREPASS_LOCAL_POSITION = false;
        this.PREPASS_LOCAL_POSITION_INDEX = -1;
        this.PREPASS_VELOCITY = false;
        this.PREPASS_VELOCITY_INDEX = -1;
        this.PREPASS_VELOCITY_LINEAR = false;
        this.PREPASS_VELOCITY_LINEAR_INDEX = -1;
        this.PREPASS_REFLECTIVITY = false;
        this.PREPASS_REFLECTIVITY_INDEX = -1;
        this.SCENE_MRT_COUNT = 0;
        this.RGBDLIGHTMAP = false;
        this.RGBDREFLECTION = false;
        this.RGBDREFRACTION = false;
        this.IMAGEPROCESSING = false;
        this.VIGNETTE = false;
        this.VIGNETTEBLENDMODEMULTIPLY = false;
        this.VIGNETTEBLENDMODEOPAQUE = false;
        this.TONEMAPPING = 0;
        this.CONTRAST = false;
        this.COLORCURVES = false;
        this.COLORGRADING = false;
        this.COLORGRADING3D = false;
        this.SAMPLER3DGREENDEPTH = false;
        this.SAMPLER3DBGRMAP = false;
        this.DITHER = false;
        this.IMAGEPROCESSINGPOSTPROCESS = false;
        this.SKIPFINALCOLORCLAMP = false;
        this.MULTIVIEW = false;
        this.ORDER_INDEPENDENT_TRANSPARENCY = false;
        this.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = false;
        this.CAMERA_ORTHOGRAPHIC = false;
        this.CAMERA_PERSPECTIVE = false;
        this.AREALIGHTSUPPORTED = true;
        /**
         * If the reflection texture on this material is in linear color space
         * @internal
         */ this.IS_REFLECTION_LINEAR = false;
        /**
         * If the refraction texture on this material is in linear color space
         * @internal
         */ this.IS_REFRACTION_LINEAR = false;
        this.EXPOSURE = false;
        this.DECAL_AFTER_DETAIL = false;
        this.rebuild();
    }
    setReflectionMode(modeToEnable) {
        const modes = [
            "REFLECTIONMAP_CUBIC",
            "REFLECTIONMAP_EXPLICIT",
            "REFLECTIONMAP_PLANAR",
            "REFLECTIONMAP_PROJECTION",
            "REFLECTIONMAP_PROJECTION",
            "REFLECTIONMAP_SKYBOX",
            "REFLECTIONMAP_SPHERICAL",
            "REFLECTIONMAP_EQUIRECTANGULAR",
            "REFLECTIONMAP_EQUIRECTANGULAR_FIXED",
            "REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED"
        ];
        for (const mode of modes)this[mode] = mode === modeToEnable;
    }
}




class $c14168b02f7bcc00$export$cb949309547a0dd7 extends (0, $7a0e949889738692$export$9026dbc30178f7ea) {
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
        // Ensure the effect will be rebuilt.
        this._markAllSubMeshesAsTexturesDirty();
    }
    /**
     * Attaches a new image processing configuration to the Standard Material.
     * @param configuration
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed
        if (!configuration) this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
        // Attaches observer
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._markAllSubMeshesAsImageProcessingDirty();
        });
    }
    /**
     * Can this material render to prepass
     */ get isPrePassCapable() {
        return !this.disableDepthWrite;
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get cameraColorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set cameraColorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get cameraColorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ set cameraColorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
    }
    /**
     * Gets whether tonemapping is enabled or not.
     */ get cameraToneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
    }
    /**
     * Sets whether tonemapping is enabled or not
     */ set cameraToneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ get cameraExposure() {
        return this._imageProcessingConfiguration.exposure;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ set cameraExposure(value) {
        this._imageProcessingConfiguration.exposure = value;
    }
    /**
     * Gets The camera contrast used on this material.
     */ get cameraContrast() {
        return this._imageProcessingConfiguration.contrast;
    }
    /**
     * Sets The camera contrast used on this material.
     */ set cameraContrast(value) {
        this._imageProcessingConfiguration.contrast = value;
    }
    /**
     * Gets the Color Grading 2D Lookup Texture.
     */ get cameraColorGradingTexture() {
        return this._imageProcessingConfiguration.colorGradingTexture;
    }
    /**
     * Sets the Color Grading 2D Lookup Texture.
     */ set cameraColorGradingTexture(value) {
        this._imageProcessingConfiguration.colorGradingTexture = value;
    }
    /**
     * The color grading curves provide additional color adjustmnent that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ get cameraColorCurves() {
        return this._imageProcessingConfiguration.colorCurves;
    }
    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ set cameraColorCurves(value) {
        this._imageProcessingConfiguration.colorCurves = value;
    }
    /**
     * Can this material render to several textures at once
     */ get canRenderToMRT() {
        return true;
    }
    /**
     * Instantiates a new standard material.
     * This is the default material used in Babylon. It is the best trade off between quality
     * and performances.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
     * @param name Define the name of the material in the scene
     * @param scene Define the scene the material belong to
     * @param forceGLSL Use the GLSL code generation for the shader (even on WebGPU). Default is false
     */ constructor(name, scene, forceGLSL = false){
        super(name, scene, undefined, forceGLSL || $c14168b02f7bcc00$export$cb949309547a0dd7.ForceGLSL);
        this._diffuseTexture = null;
        this._ambientTexture = null;
        this._opacityTexture = null;
        this._reflectionTexture = null;
        this._emissiveTexture = null;
        this._specularTexture = null;
        this._bumpTexture = null;
        this._lightmapTexture = null;
        this._refractionTexture = null;
        /**
         * The color of the material lit by the environmental background lighting.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#ambient-color-example
         */ this.ambientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * The basic color of the material as viewed under a light.
         */ this.diffuseColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Define how the color and intensity of the highlight given by the light in the material.
         */ this.specularColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Define the color of the material as if self lit.
         * This will be mixed in the final result even in the absence of light.
         */ this.emissiveColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * Defines how sharp are the highlights in the material.
         * The bigger the value the sharper giving a more glossy feeling to the result.
         * Reversely, the smaller the value the blurrier giving a more rough feeling to the result.
         */ this.specularPower = 64;
        this._useAlphaFromDiffuseTexture = false;
        this._useEmissiveAsIllumination = false;
        this._linkEmissiveWithDiffuse = false;
        this._useSpecularOverAlpha = false;
        this._useReflectionOverAlpha = false;
        this._disableLighting = false;
        this._useObjectSpaceNormalMap = false;
        this._useParallax = false;
        this._useParallaxOcclusion = false;
        /**
         * Apply a scaling factor that determine which "depth" the height map should reprensent. A value between 0.05 and 0.1 is reasonnable in Parallax, you can reach 0.2 using Parallax Occlusion.
         */ this.parallaxScaleBias = 0.05;
        this._roughness = 0;
        /**
         * In case of refraction, define the value of the index of refraction.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#how-to-obtain-reflections-and-refractions
         */ this.indexOfRefraction = 0.98;
        /**
         * Invert the refraction texture alongside the y axis.
         * It can be useful with procedural textures or probe for instance.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#how-to-obtain-reflections-and-refractions
         */ this.invertRefractionY = true;
        /**
         * Defines the alpha limits in alpha test mode.
         */ this.alphaCutOff = 0.4;
        this._useLightmapAsShadowmap = false;
        this._useReflectionFresnelFromSpecular = false;
        this._useGlossinessFromSpecularMapAlpha = false;
        this._maxSimultaneousLights = 4;
        this._invertNormalMapX = false;
        this._invertNormalMapY = false;
        this._twoSidedLighting = false;
        this._applyDecalMapAfterDetailMap = false;
        this._shadersLoaded = false;
        this._renderTargets = new (0, $57onU.SmartArray)(16);
        this._globalAmbientColor = new (0, $7etnY.Color3)(0, 0, 0);
        this._cacheHasRenderTargetTextures = false;
        this.detailMap = new (0, $8a41416de02c81e4$export$37c50da823378b6e)(this);
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        this.prePassConfiguration = new (0, $9c7b0616b7e91126$export$ccd4486ebb81b39a)();
        this.getRenderTargetTextures = ()=>{
            this._renderTargets.reset();
            if ($c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) this._renderTargets.push(this._reflectionTexture);
            if ($c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) this._renderTargets.push(this._refractionTexture);
            this._eventInfo.renderTargets = this._renderTargets;
            this._callbackPluginEventFillRenderTargetTextures(this._eventInfo);
            return this._renderTargets;
        };
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        if ($c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) return true;
        if ($c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) return true;
        return this._cacheHasRenderTargetTextures;
    }
    /**
     * Gets the current class name of the material e.g. "StandardMaterial"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "StandardMaterial";
    }
    /**
     * Specifies if the material will require alpha blending
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        if (this._disableAlphaBlending) return false;
        return this.alpha < 1.0 || this._opacityTexture != null || this._shouldUseAlphaFromDiffuseTexture() || this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled;
    }
    /**
     * Specifies if this material should be rendered in alpha test mode
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        if (this._forceAlphaTest) return true;
        return this._hasAlphaChannel() && (this._transparencyMode == null || this._transparencyMode === (0, $3afee756ef198914$export$a2d8b23205c25948).MATERIAL_ALPHATEST);
    }
    /**
     * @returns whether or not the alpha value of the diffuse texture should be used for alpha blending.
     */ _shouldUseAlphaFromDiffuseTexture() {
        return this._diffuseTexture != null && this._diffuseTexture.hasAlpha && this._useAlphaFromDiffuseTexture && this._transparencyMode !== (0, $3afee756ef198914$export$a2d8b23205c25948).MATERIAL_OPAQUE;
    }
    /**
     * @returns whether or not there is a usable alpha channel for transparency.
     */ _hasAlphaChannel() {
        return this._diffuseTexture != null && this._diffuseTexture.hasAlpha || this._opacityTexture != null;
    }
    /**
     * Get the texture used for alpha test purpose.
     * @returns the diffuse texture in case of the standard material.
     */ getAlphaTestTexture() {
        return this._diffuseTexture;
    }
    /**
     * Get if the submesh is ready to be used and all its information available.
     * Child classes can use it to update shaders
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ isReadyForSubMesh(mesh, subMesh, useInstances = false) {
        if (!this._uniformBufferLayoutBuilt) this.buildUniformLayout();
        const drawWrapper = subMesh._drawWrapper;
        if (drawWrapper.effect && this.isFrozen) {
            if (drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        if (!subMesh.materialDefines) {
            this._callbackPluginEventGeneric(4 /* MaterialPluginEvent.GetDefineNames */ , this._eventInfo);
            subMesh.materialDefines = new $c14168b02f7bcc00$export$8a3963f3d5f6315f(this._eventInfo.defineNames);
        }
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (this._isReadyForSubMesh(subMesh)) return true;
        const engine = scene.getEngine();
        // Lights
        defines._needNormals = (0, $7893e784ec9add9a$export$9810631b9b84b23d)(scene, mesh, defines, true, this._maxSimultaneousLights, this._disableLighting);
        // Multiview
        (0, $7893e784ec9add9a$export$55684373b0a692af)(scene, defines);
        // PrePass
        const oit = this.needAlphaBlendingForMesh(mesh) && this.getScene().useOrderIndependentTransparency;
        (0, $7893e784ec9add9a$export$73d6edd5c9bebe3d)(scene, defines, this.canRenderToMRT && !oit);
        // Order independant transparency
        (0, $7893e784ec9add9a$export$667351a72233f2a3)(scene, defines, oit);
        (0, $551eb891fe6c445d$export$fb311b9fc5942600).PrepareDefines(engine.currentRenderPassId, mesh, defines);
        // Textures
        if (defines._areTexturesDirty) {
            this._eventInfo.hasRenderTargetTextures = false;
            this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
            this._cacheHasRenderTargetTextures = this._eventInfo.hasRenderTargetTextures;
            defines._needUVs = false;
            for(let i = 1; i <= 6; ++i)defines["MAINUV" + i] = false;
            if (scene.texturesEnabled) {
                defines.DIFFUSEDIRECTUV = 0;
                defines.BUMPDIRECTUV = 0;
                defines.AMBIENTDIRECTUV = 0;
                defines.OPACITYDIRECTUV = 0;
                defines.EMISSIVEDIRECTUV = 0;
                defines.SPECULARDIRECTUV = 0;
                defines.LIGHTMAPDIRECTUV = 0;
                if (this._diffuseTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.DiffuseTextureEnabled) {
                    if (!this._diffuseTexture.isReadyOrNotBlocking()) return false;
                    else (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._diffuseTexture, defines, "DIFFUSE");
                } else defines.DIFFUSE = false;
                if (this._ambientTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.AmbientTextureEnabled) {
                    if (!this._ambientTexture.isReadyOrNotBlocking()) return false;
                    else (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._ambientTexture, defines, "AMBIENT");
                } else defines.AMBIENT = false;
                if (this._opacityTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.OpacityTextureEnabled) {
                    if (!this._opacityTexture.isReadyOrNotBlocking()) return false;
                    else {
                        (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._opacityTexture, defines, "OPACITY");
                        defines.OPACITYRGB = this._opacityTexture.getAlphaFromRGB;
                    }
                } else defines.OPACITY = false;
                if (this._reflectionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled) {
                    if (!this._reflectionTexture.isReadyOrNotBlocking()) return false;
                    else {
                        defines._needNormals = true;
                        defines.REFLECTION = true;
                        defines.ROUGHNESS = this._roughness > 0;
                        defines.REFLECTIONOVERALPHA = this._useReflectionOverAlpha;
                        defines.INVERTCUBICMAP = this._reflectionTexture.coordinatesMode === (0, $j2mX5.Texture).INVCUBIC_MODE;
                        defines.REFLECTIONMAP_3D = this._reflectionTexture.isCube;
                        defines.REFLECTIONMAP_OPPOSITEZ = defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !this._reflectionTexture.invertZ : this._reflectionTexture.invertZ;
                        defines.RGBDREFLECTION = this._reflectionTexture.isRGBD;
                        switch(this._reflectionTexture.coordinatesMode){
                            case (0, $j2mX5.Texture).EXPLICIT_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_EXPLICIT");
                                break;
                            case (0, $j2mX5.Texture).PLANAR_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_PLANAR");
                                break;
                            case (0, $j2mX5.Texture).PROJECTION_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_PROJECTION");
                                break;
                            case (0, $j2mX5.Texture).SKYBOX_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_SKYBOX");
                                break;
                            case (0, $j2mX5.Texture).SPHERICAL_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_SPHERICAL");
                                break;
                            case (0, $j2mX5.Texture).EQUIRECTANGULAR_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR");
                                break;
                            case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR_FIXED");
                                break;
                            case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED");
                                break;
                            case (0, $j2mX5.Texture).CUBIC_MODE:
                            case (0, $j2mX5.Texture).INVCUBIC_MODE:
                            default:
                                defines.setReflectionMode("REFLECTIONMAP_CUBIC");
                                break;
                        }
                        defines.USE_LOCAL_REFLECTIONMAP_CUBIC = this._reflectionTexture.boundingBoxSize ? true : false;
                    }
                } else {
                    defines.REFLECTION = false;
                    defines.REFLECTIONMAP_OPPOSITEZ = false;
                }
                if (this._emissiveTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled) {
                    if (!this._emissiveTexture.isReadyOrNotBlocking()) return false;
                    else (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._emissiveTexture, defines, "EMISSIVE");
                } else defines.EMISSIVE = false;
                if (this._lightmapTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.LightmapTextureEnabled) {
                    if (!this._lightmapTexture.isReadyOrNotBlocking()) return false;
                    else {
                        (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._lightmapTexture, defines, "LIGHTMAP");
                        defines.USELIGHTMAPASSHADOWMAP = this._useLightmapAsShadowmap;
                        defines.RGBDLIGHTMAP = this._lightmapTexture.isRGBD;
                    }
                } else defines.LIGHTMAP = false;
                if (this._specularTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.SpecularTextureEnabled) {
                    if (!this._specularTexture.isReadyOrNotBlocking()) return false;
                    else {
                        (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._specularTexture, defines, "SPECULAR");
                        defines.GLOSSINESS = this._useGlossinessFromSpecularMapAlpha;
                    }
                } else defines.SPECULAR = false;
                if (scene.getEngine().getCaps().standardDerivatives && this._bumpTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.BumpTextureEnabled) {
                    // Bump texture can not be not blocking.
                    if (!this._bumpTexture.isReady()) return false;
                    else {
                        (0, $7893e784ec9add9a$export$a906c176bc893d2a)(this._bumpTexture, defines, "BUMP");
                        defines.PARALLAX = this._useParallax;
                        defines.PARALLAX_RHS = scene.useRightHandedSystem;
                        defines.PARALLAXOCCLUSION = this._useParallaxOcclusion;
                    }
                    defines.OBJECTSPACE_NORMALMAP = this._useObjectSpaceNormalMap;
                } else {
                    defines.BUMP = false;
                    defines.PARALLAX = false;
                    defines.PARALLAX_RHS = false;
                    defines.PARALLAXOCCLUSION = false;
                }
                if (this._refractionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled) {
                    if (!this._refractionTexture.isReadyOrNotBlocking()) return false;
                    else {
                        defines._needUVs = true;
                        defines.REFRACTION = true;
                        defines.REFRACTIONMAP_3D = this._refractionTexture.isCube;
                        defines.RGBDREFRACTION = this._refractionTexture.isRGBD;
                        defines.USE_LOCAL_REFRACTIONMAP_CUBIC = this._refractionTexture.boundingBoxSize ? true : false;
                    }
                } else defines.REFRACTION = false;
                defines.TWOSIDEDLIGHTING = !this._backFaceCulling && this._twoSidedLighting;
            } else {
                defines.DIFFUSE = false;
                defines.AMBIENT = false;
                defines.OPACITY = false;
                defines.REFLECTION = false;
                defines.EMISSIVE = false;
                defines.LIGHTMAP = false;
                defines.BUMP = false;
                defines.REFRACTION = false;
            }
            defines.ALPHAFROMDIFFUSE = this._shouldUseAlphaFromDiffuseTexture();
            defines.EMISSIVEASILLUMINATION = this._useEmissiveAsIllumination;
            defines.LINKEMISSIVEWITHDIFFUSE = this._linkEmissiveWithDiffuse;
            defines.SPECULAROVERALPHA = this._useSpecularOverAlpha;
            defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
            defines.ALPHATEST_AFTERALLALPHACOMPUTATIONS = this.transparencyMode !== null;
            defines.ALPHABLEND = this.transparencyMode === null || this.needAlphaBlendingForMesh(mesh); // check on null for backward compatibility
        }
        this._eventInfo.isReadyForSubMesh = true;
        this._eventInfo.defines = defines;
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
        if (!this._eventInfo.isReadyForSubMesh) return false;
        if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
            if (!this._imageProcessingConfiguration.isReady()) return false;
            this._imageProcessingConfiguration.prepareDefines(defines);
            defines.IS_REFLECTION_LINEAR = this.reflectionTexture != null && !this.reflectionTexture.gammaSpace;
            defines.IS_REFRACTION_LINEAR = this.refractionTexture != null && !this.refractionTexture.gammaSpace;
        }
        if (defines._areFresnelDirty) {
            if ($c14168b02f7bcc00$export$cb949309547a0dd7.FresnelEnabled) // Fresnel
            {
                if (this._diffuseFresnelParameters || this._opacityFresnelParameters || this._emissiveFresnelParameters || this._refractionFresnelParameters || this._reflectionFresnelParameters) {
                    defines.DIFFUSEFRESNEL = this._diffuseFresnelParameters && this._diffuseFresnelParameters.isEnabled;
                    defines.OPACITYFRESNEL = this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled;
                    defines.REFLECTIONFRESNEL = this._reflectionFresnelParameters && this._reflectionFresnelParameters.isEnabled;
                    defines.REFLECTIONFRESNELFROMSPECULAR = this._useReflectionFresnelFromSpecular;
                    defines.REFRACTIONFRESNEL = this._refractionFresnelParameters && this._refractionFresnelParameters.isEnabled;
                    defines.EMISSIVEFRESNEL = this._emissiveFresnelParameters && this._emissiveFresnelParameters.isEnabled;
                    defines._needNormals = true;
                    defines.FRESNEL = true;
                }
            } else defines.FRESNEL = false;
        }
        // Check if Area Lights have LTC texture.
        if (defines["AREALIGHTUSED"]) for(let index = 0; index < mesh.lightSources.length; index++){
            if (!mesh.lightSources[index]._isReady()) return false;
        }
        // Misc.
        (0, $7893e784ec9add9a$export$a000bd067dd304c2)(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh) || this._forceAlphaTest, defines, this._applyDecalMapAfterDetailMap);
        // Values that need to be evaluated on every frame
        (0, $7893e784ec9add9a$export$40fda531e0d45992)(scene, engine, this, defines, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
        // External config
        this._eventInfo.defines = defines;
        this._eventInfo.mesh = mesh;
        this._callbackPluginEventPrepareDefinesBeforeAttributes(this._eventInfo);
        // Attribs
        (0, $7893e784ec9add9a$export$9bf973b33bf006f1)(mesh, defines, true, true, true);
        // External config
        this._callbackPluginEventPrepareDefines(this._eventInfo);
        // Get correct effect
        let forceWasNotReadyPreviously = false;
        if (defines.isDirty) {
            const lightDisposed = defines._areLightsDisposed;
            defines.markAsProcessed();
            // Fallbacks
            const fallbacks = new (0, $bca4896819e5389c$export$3e78d35a7e1b5710)();
            if (defines.REFLECTION) fallbacks.addFallback(0, "REFLECTION");
            if (defines.SPECULAR) fallbacks.addFallback(0, "SPECULAR");
            if (defines.BUMP) fallbacks.addFallback(0, "BUMP");
            if (defines.PARALLAX) fallbacks.addFallback(1, "PARALLAX");
            if (defines.PARALLAX_RHS) fallbacks.addFallback(1, "PARALLAX_RHS");
            if (defines.PARALLAXOCCLUSION) fallbacks.addFallback(0, "PARALLAXOCCLUSION");
            if (defines.SPECULAROVERALPHA) fallbacks.addFallback(0, "SPECULAROVERALPHA");
            if (defines.FOG) fallbacks.addFallback(1, "FOG");
            if (defines.POINTSIZE) fallbacks.addFallback(0, "POINTSIZE");
            if (defines.LOGARITHMICDEPTH) fallbacks.addFallback(0, "LOGARITHMICDEPTH");
            (0, $7893e784ec9add9a$export$ae20fd35f0de291d)(defines, fallbacks, this._maxSimultaneousLights);
            if (defines.SPECULARTERM) fallbacks.addFallback(0, "SPECULARTERM");
            if (defines.DIFFUSEFRESNEL) fallbacks.addFallback(1, "DIFFUSEFRESNEL");
            if (defines.OPACITYFRESNEL) fallbacks.addFallback(2, "OPACITYFRESNEL");
            if (defines.REFLECTIONFRESNEL) fallbacks.addFallback(3, "REFLECTIONFRESNEL");
            if (defines.EMISSIVEFRESNEL) fallbacks.addFallback(4, "EMISSIVEFRESNEL");
            if (defines.FRESNEL) fallbacks.addFallback(4, "FRESNEL");
            if (defines.MULTIVIEW) fallbacks.addFallback(0, "MULTIVIEW");
            //Attributes
            const attribs = [
                (0, $b4i1f.VertexBuffer).PositionKind
            ];
            if (defines.NORMAL) attribs.push((0, $b4i1f.VertexBuffer).NormalKind);
            if (defines.TANGENT) attribs.push((0, $b4i1f.VertexBuffer).TangentKind);
            for(let i = 1; i <= 6; ++i)if (defines["UV" + i]) attribs.push(`uv${i === 1 ? "" : i}`);
            if (defines.VERTEXCOLOR) attribs.push((0, $b4i1f.VertexBuffer).ColorKind);
            (0, $7893e784ec9add9a$export$71c246cd17c53a0d)(attribs, mesh, defines, fallbacks);
            (0, $7893e784ec9add9a$export$f9fb9b44aa29cc31)(attribs, defines);
            (0, $7893e784ec9add9a$export$3f648d9015556392)(attribs, mesh, defines);
            (0, $7893e784ec9add9a$export$b48abe8455f59858)(attribs, mesh, defines);
            let shaderName = "default";
            const uniforms = [
                "world",
                "view",
                "viewProjection",
                "vEyePosition",
                "vLightsType",
                "vAmbientColor",
                "vDiffuseColor",
                "vSpecularColor",
                "vEmissiveColor",
                "visibility",
                "vFogInfos",
                "vFogColor",
                "pointSize",
                "vDiffuseInfos",
                "vAmbientInfos",
                "vOpacityInfos",
                "vReflectionInfos",
                "vEmissiveInfos",
                "vSpecularInfos",
                "vBumpInfos",
                "vLightmapInfos",
                "vRefractionInfos",
                "mBones",
                "diffuseMatrix",
                "ambientMatrix",
                "opacityMatrix",
                "reflectionMatrix",
                "emissiveMatrix",
                "specularMatrix",
                "bumpMatrix",
                "normalMatrix",
                "lightmapMatrix",
                "refractionMatrix",
                "diffuseLeftColor",
                "diffuseRightColor",
                "opacityParts",
                "reflectionLeftColor",
                "reflectionRightColor",
                "emissiveLeftColor",
                "emissiveRightColor",
                "refractionLeftColor",
                "refractionRightColor",
                "vReflectionPosition",
                "vReflectionSize",
                "vRefractionPosition",
                "vRefractionSize",
                "logarithmicDepthConstant",
                "vTangentSpaceParams",
                "alphaCutOff",
                "boneTextureWidth",
                "morphTargetTextureInfo",
                "morphTargetTextureIndices"
            ];
            const samplers = [
                "diffuseSampler",
                "ambientSampler",
                "opacitySampler",
                "reflectionCubeSampler",
                "reflection2DSampler",
                "emissiveSampler",
                "specularSampler",
                "bumpSampler",
                "lightmapSampler",
                "refractionCubeSampler",
                "refraction2DSampler",
                "boneSampler",
                "morphTargets",
                "oitDepthSampler",
                "oitFrontColorSampler",
                "areaLightsLTC1Sampler",
                "areaLightsLTC2Sampler"
            ];
            const uniformBuffers = [
                "Material",
                "Scene",
                "Mesh"
            ];
            const indexParameters = {
                maxSimultaneousLights: this._maxSimultaneousLights,
                maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS
            };
            this._eventInfo.fallbacks = fallbacks;
            this._eventInfo.fallbackRank = 0;
            this._eventInfo.defines = defines;
            this._eventInfo.uniforms = uniforms;
            this._eventInfo.attributes = attribs;
            this._eventInfo.samplers = samplers;
            this._eventInfo.uniformBuffersNames = uniformBuffers;
            this._eventInfo.customCode = undefined;
            this._eventInfo.mesh = mesh;
            this._eventInfo.indexParameters = indexParameters;
            this._callbackPluginEventGeneric(128 /* MaterialPluginEvent.PrepareEffect */ , this._eventInfo);
            (0, $551eb891fe6c445d$export$fb311b9fc5942600).AddUniformsAndSamplers(uniforms, samplers);
            (0, $9c7b0616b7e91126$export$ccd4486ebb81b39a).AddUniforms(uniforms);
            (0, $9c7b0616b7e91126$export$ccd4486ebb81b39a).AddSamplers(samplers);
            if (0, $dG1pf.ImageProcessingConfiguration) {
                (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, defines);
                (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, defines);
            }
            (0, $7893e784ec9add9a$export$8c6b0867b1144725)({
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: defines,
                maxSimultaneousLights: this._maxSimultaneousLights
            });
            (0, $7b5d4109d15c2b5f$export$959caf24bcfab1fd)(uniforms);
            const csnrOptions = {};
            if (this.customShaderNameResolve) shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs, csnrOptions);
            const join = defines.toString();
            const previousEffect = subMesh.effect;
            let effect = scene.getEngine().createEffect(shaderName, {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                fallbacks: fallbacks,
                onCompiled: this.onCompiled,
                onError: this.onError,
                indexParameters: indexParameters,
                processFinalCode: csnrOptions.processFinalCode,
                processCodeAfterIncludes: this._eventInfo.customCode,
                multiTarget: defines.PREPASS,
                shaderLanguage: this._shaderLanguage,
                extraInitializationsAsync: this._shadersLoaded ? undefined : async ()=>{
                    if (this._shaderLanguage === 1 /* ShaderLanguage.WGSL */ ) await Promise.all([
                        (parcelRequire("7c9IK")),
                        (parcelRequire("65n0B"))
                    ]);
                    else await Promise.all([
                        Promise.resolve((parcelRequire("fn9QB"))),
                        Promise.resolve((parcelRequire("5rZFU")))
                    ]);
                    this._shadersLoaded = true;
                }
            }, engine);
            this._eventInfo.customCode = undefined;
            if (effect) {
                if (this._onEffectCreatedObservable) {
                    $c14168b02f7bcc00$var$onCreatedEffectParameters.effect = effect;
                    $c14168b02f7bcc00$var$onCreatedEffectParameters.subMesh = subMesh;
                    this._onEffectCreatedObservable.notifyObservers($c14168b02f7bcc00$var$onCreatedEffectParameters);
                }
                // Use previous effect while new one is compiling
                if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                    effect = previousEffect;
                    defines.markAsUnprocessed();
                    forceWasNotReadyPreviously = this.isFrozen;
                    if (lightDisposed) {
                        // re register in case it takes more than one frame.
                        defines._areLightsDisposed = true;
                        return false;
                    }
                } else {
                    scene.resetCachedMaterial();
                    subMesh.setEffect(effect, defines, this._materialContext);
                }
            }
        }
        if (!subMesh.effect || !subMesh.effect.isReady()) return false;
        defines._renderId = scene.getRenderId();
        drawWrapper._wasPreviouslyReady = forceWasNotReadyPreviously ? false : true;
        drawWrapper._wasPreviouslyUsingInstances = useInstances;
        this._checkScenePerformancePriority();
        return true;
    }
    /**
     * Builds the material UBO layouts.
     * Used internally during the effect preparation.
     */ buildUniformLayout() {
        // Order is important !
        const ubo = this._uniformBuffer;
        ubo.addUniform("diffuseLeftColor", 4);
        ubo.addUniform("diffuseRightColor", 4);
        ubo.addUniform("opacityParts", 4);
        ubo.addUniform("reflectionLeftColor", 4);
        ubo.addUniform("reflectionRightColor", 4);
        ubo.addUniform("refractionLeftColor", 4);
        ubo.addUniform("refractionRightColor", 4);
        ubo.addUniform("emissiveLeftColor", 4);
        ubo.addUniform("emissiveRightColor", 4);
        ubo.addUniform("vDiffuseInfos", 2);
        ubo.addUniform("vAmbientInfos", 2);
        ubo.addUniform("vOpacityInfos", 2);
        ubo.addUniform("vReflectionInfos", 2);
        ubo.addUniform("vReflectionPosition", 3);
        ubo.addUniform("vReflectionSize", 3);
        ubo.addUniform("vEmissiveInfos", 2);
        ubo.addUniform("vLightmapInfos", 2);
        ubo.addUniform("vSpecularInfos", 2);
        ubo.addUniform("vBumpInfos", 3);
        ubo.addUniform("diffuseMatrix", 16);
        ubo.addUniform("ambientMatrix", 16);
        ubo.addUniform("opacityMatrix", 16);
        ubo.addUniform("reflectionMatrix", 16);
        ubo.addUniform("emissiveMatrix", 16);
        ubo.addUniform("lightmapMatrix", 16);
        ubo.addUniform("specularMatrix", 16);
        ubo.addUniform("bumpMatrix", 16);
        ubo.addUniform("vTangentSpaceParams", 2);
        ubo.addUniform("pointSize", 1);
        ubo.addUniform("alphaCutOff", 1);
        ubo.addUniform("refractionMatrix", 16);
        ubo.addUniform("vRefractionInfos", 4);
        ubo.addUniform("vRefractionPosition", 3);
        ubo.addUniform("vRefractionSize", 3);
        ubo.addUniform("vSpecularColor", 4);
        ubo.addUniform("vEmissiveColor", 3);
        ubo.addUniform("vDiffuseColor", 4);
        ubo.addUniform("vAmbientColor", 3);
        super.buildUniformLayout();
    }
    /**
     * Binds the submesh to this material by preparing the effect and shader to draw
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (!defines) return;
        const effect = subMesh.effect;
        if (!effect) return;
        this._activeEffect = effect;
        // Matrices Mesh.
        mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
        mesh.transferToEffect(world);
        // Binding unconditionally
        this._uniformBuffer.bindToEffect(effect, "Material");
        this.prePassConfiguration.bindForSubMesh(this._activeEffect, scene, mesh, world, this.isFrozen);
        (0, $551eb891fe6c445d$export$fb311b9fc5942600).Bind(scene.getEngine().currentRenderPassId, this._activeEffect, mesh, world);
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventHardBindForSubMesh(this._eventInfo);
        // Normal Matrix
        if (defines.OBJECTSPACE_NORMALMAP) {
            world.toNormalMatrix(this._normalMatrix);
            this.bindOnlyNormalMatrix(this._normalMatrix);
        }
        const mustRebind = this._mustRebind(scene, effect, subMesh, mesh.visibility);
        // Bones
        (0, $7893e784ec9add9a$export$1544400469443a89)(mesh, effect);
        const ubo = this._uniformBuffer;
        if (mustRebind) {
            this.bindViewProjection(effect);
            if (!ubo.useUbo || !this.isFrozen || !ubo.isSync || subMesh._drawWrapper._forceRebindOnNextCall) {
                if ($c14168b02f7bcc00$export$cb949309547a0dd7.FresnelEnabled && defines.FRESNEL) {
                    // Fresnel
                    if (this.diffuseFresnelParameters && this.diffuseFresnelParameters.isEnabled) {
                        ubo.updateColor4("diffuseLeftColor", this.diffuseFresnelParameters.leftColor, this.diffuseFresnelParameters.power);
                        ubo.updateColor4("diffuseRightColor", this.diffuseFresnelParameters.rightColor, this.diffuseFresnelParameters.bias);
                    }
                    if (this.opacityFresnelParameters && this.opacityFresnelParameters.isEnabled) ubo.updateColor4("opacityParts", new (0, $7etnY.Color3)(this.opacityFresnelParameters.leftColor.toLuminance(), this.opacityFresnelParameters.rightColor.toLuminance(), this.opacityFresnelParameters.bias), this.opacityFresnelParameters.power);
                    if (this.reflectionFresnelParameters && this.reflectionFresnelParameters.isEnabled) {
                        ubo.updateColor4("reflectionLeftColor", this.reflectionFresnelParameters.leftColor, this.reflectionFresnelParameters.power);
                        ubo.updateColor4("reflectionRightColor", this.reflectionFresnelParameters.rightColor, this.reflectionFresnelParameters.bias);
                    }
                    if (this.refractionFresnelParameters && this.refractionFresnelParameters.isEnabled) {
                        ubo.updateColor4("refractionLeftColor", this.refractionFresnelParameters.leftColor, this.refractionFresnelParameters.power);
                        ubo.updateColor4("refractionRightColor", this.refractionFresnelParameters.rightColor, this.refractionFresnelParameters.bias);
                    }
                    if (this.emissiveFresnelParameters && this.emissiveFresnelParameters.isEnabled) {
                        ubo.updateColor4("emissiveLeftColor", this.emissiveFresnelParameters.leftColor, this.emissiveFresnelParameters.power);
                        ubo.updateColor4("emissiveRightColor", this.emissiveFresnelParameters.rightColor, this.emissiveFresnelParameters.bias);
                    }
                }
                // Textures
                if (scene.texturesEnabled) {
                    if (this._diffuseTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.DiffuseTextureEnabled) {
                        ubo.updateFloat2("vDiffuseInfos", this._diffuseTexture.coordinatesIndex, this._diffuseTexture.level);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._diffuseTexture, ubo, "diffuse");
                    }
                    if (this._ambientTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.AmbientTextureEnabled) {
                        ubo.updateFloat2("vAmbientInfos", this._ambientTexture.coordinatesIndex, this._ambientTexture.level);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._ambientTexture, ubo, "ambient");
                    }
                    if (this._opacityTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.OpacityTextureEnabled) {
                        ubo.updateFloat2("vOpacityInfos", this._opacityTexture.coordinatesIndex, this._opacityTexture.level);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._opacityTexture, ubo, "opacity");
                    }
                    if (this._hasAlphaChannel()) ubo.updateFloat("alphaCutOff", this.alphaCutOff);
                    if (this._reflectionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled) {
                        ubo.updateFloat2("vReflectionInfos", this._reflectionTexture.level, this.roughness);
                        ubo.updateMatrix("reflectionMatrix", this._reflectionTexture.getReflectionTextureMatrix());
                        if (this._reflectionTexture.boundingBoxSize) {
                            const cubeTexture = this._reflectionTexture;
                            ubo.updateVector3("vReflectionPosition", cubeTexture.boundingBoxPosition);
                            ubo.updateVector3("vReflectionSize", cubeTexture.boundingBoxSize);
                        }
                    } else ubo.updateFloat2("vReflectionInfos", 0.0, this.roughness);
                    if (this._emissiveTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled) {
                        ubo.updateFloat2("vEmissiveInfos", this._emissiveTexture.coordinatesIndex, this._emissiveTexture.level);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._emissiveTexture, ubo, "emissive");
                    }
                    if (this._lightmapTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.LightmapTextureEnabled) {
                        ubo.updateFloat2("vLightmapInfos", this._lightmapTexture.coordinatesIndex, this._lightmapTexture.level);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._lightmapTexture, ubo, "lightmap");
                    }
                    if (this._specularTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.SpecularTextureEnabled) {
                        ubo.updateFloat2("vSpecularInfos", this._specularTexture.coordinatesIndex, this._specularTexture.level);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._specularTexture, ubo, "specular");
                    }
                    if (this._bumpTexture && scene.getEngine().getCaps().standardDerivatives && $c14168b02f7bcc00$export$cb949309547a0dd7.BumpTextureEnabled) {
                        ubo.updateFloat3("vBumpInfos", this._bumpTexture.coordinatesIndex, 1.0 / this._bumpTexture.level, this.parallaxScaleBias);
                        (0, $7893e784ec9add9a$export$c335cd4c3275cd5a)(this._bumpTexture, ubo, "bump");
                        if (scene._mirroredCameraPosition) ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? 1.0 : -1, this._invertNormalMapY ? 1.0 : -1);
                        else ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? -1 : 1.0, this._invertNormalMapY ? -1 : 1.0);
                    }
                    if (this._refractionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled) {
                        let depth = 1.0;
                        if (!this._refractionTexture.isCube) {
                            ubo.updateMatrix("refractionMatrix", this._refractionTexture.getReflectionTextureMatrix());
                            if (this._refractionTexture.depth) depth = this._refractionTexture.depth;
                        }
                        ubo.updateFloat4("vRefractionInfos", this._refractionTexture.level, this.indexOfRefraction, depth, this.invertRefractionY ? -1 : 1);
                        if (this._refractionTexture.boundingBoxSize) {
                            const cubeTexture = this._refractionTexture;
                            ubo.updateVector3("vRefractionPosition", cubeTexture.boundingBoxPosition);
                            ubo.updateVector3("vRefractionSize", cubeTexture.boundingBoxSize);
                        }
                    }
                }
                // Point size
                if (this.pointsCloud) ubo.updateFloat("pointSize", this.pointSize);
                ubo.updateColor4("vSpecularColor", this.specularColor, this.specularPower);
                ubo.updateColor3("vEmissiveColor", $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled ? this.emissiveColor : (0, $7etnY.Color3).BlackReadOnly);
                ubo.updateColor4("vDiffuseColor", this.diffuseColor, this.alpha);
                scene.ambientColor.multiplyToRef(this.ambientColor, this._globalAmbientColor);
                ubo.updateColor3("vAmbientColor", this._globalAmbientColor);
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._diffuseTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.DiffuseTextureEnabled) effect.setTexture("diffuseSampler", this._diffuseTexture);
                if (this._ambientTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.AmbientTextureEnabled) effect.setTexture("ambientSampler", this._ambientTexture);
                if (this._opacityTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.OpacityTextureEnabled) effect.setTexture("opacitySampler", this._opacityTexture);
                if (this._reflectionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled) {
                    if (this._reflectionTexture.isCube) effect.setTexture("reflectionCubeSampler", this._reflectionTexture);
                    else effect.setTexture("reflection2DSampler", this._reflectionTexture);
                }
                if (this._emissiveTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled) effect.setTexture("emissiveSampler", this._emissiveTexture);
                if (this._lightmapTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.LightmapTextureEnabled) effect.setTexture("lightmapSampler", this._lightmapTexture);
                if (this._specularTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.SpecularTextureEnabled) effect.setTexture("specularSampler", this._specularTexture);
                if (this._bumpTexture && scene.getEngine().getCaps().standardDerivatives && $c14168b02f7bcc00$export$cb949309547a0dd7.BumpTextureEnabled) effect.setTexture("bumpSampler", this._bumpTexture);
                if (this._refractionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled) {
                    if (this._refractionTexture.isCube) effect.setTexture("refractionCubeSampler", this._refractionTexture);
                    else effect.setTexture("refraction2DSampler", this._refractionTexture);
                }
            }
            // OIT with depth peeling
            if (this.getScene().useOrderIndependentTransparency && this.needAlphaBlendingForMesh(mesh)) this.getScene().depthPeelingRenderer.bind(effect);
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventBindForSubMesh(this._eventInfo);
            // Clip plane
            (0, $7b5d4109d15c2b5f$export$99061f41c02073b)(effect, this, scene);
            // Colors
            this.bindEyePosition(effect);
        } else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) this._needToBindSceneUbo = true;
        if (mustRebind || !this.isFrozen) {
            // Lights
            if (scene.lightsEnabled && !this._disableLighting) (0, $7893e784ec9add9a$export$c3115b30871adb94)(scene, mesh, effect, defines, this._maxSimultaneousLights);
            // View
            if (scene.fogEnabled && mesh.applyFog && scene.fogMode !== (0, $gmbCk.Scene).FOGMODE_NONE || this._reflectionTexture || this._refractionTexture || mesh.receiveShadows || defines.PREPASS) this.bindView(effect);
            // Fog
            (0, $7893e784ec9add9a$export$531a83026b679e28)(scene, mesh, effect);
            // Morph targets
            if (defines.NUM_MORPH_INFLUENCERS) (0, $7893e784ec9add9a$export$f33581baf6024652)(mesh, effect);
            if (defines.BAKED_VERTEX_ANIMATION_TEXTURE) mesh.bakedVertexAnimationManager?.bind(effect, defines.INSTANCES);
            // Log. depth
            if (this.useLogarithmicDepth) (0, $7893e784ec9add9a$export$c51be962d0cbc5db)(defines, effect, scene);
            // image processing
            if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) this._imageProcessingConfiguration.bind(this._activeEffect);
        }
        this._afterBind(mesh, this._activeEffect, subMesh);
        ubo.update();
    }
    /**
     * Get the list of animatables in the material.
     * @returns the list of animatables object used in the material
     */ getAnimatables() {
        const results = super.getAnimatables();
        if (this._diffuseTexture && this._diffuseTexture.animations && this._diffuseTexture.animations.length > 0) results.push(this._diffuseTexture);
        if (this._ambientTexture && this._ambientTexture.animations && this._ambientTexture.animations.length > 0) results.push(this._ambientTexture);
        if (this._opacityTexture && this._opacityTexture.animations && this._opacityTexture.animations.length > 0) results.push(this._opacityTexture);
        if (this._reflectionTexture && this._reflectionTexture.animations && this._reflectionTexture.animations.length > 0) results.push(this._reflectionTexture);
        if (this._emissiveTexture && this._emissiveTexture.animations && this._emissiveTexture.animations.length > 0) results.push(this._emissiveTexture);
        if (this._specularTexture && this._specularTexture.animations && this._specularTexture.animations.length > 0) results.push(this._specularTexture);
        if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) results.push(this._bumpTexture);
        if (this._lightmapTexture && this._lightmapTexture.animations && this._lightmapTexture.animations.length > 0) results.push(this._lightmapTexture);
        if (this._refractionTexture && this._refractionTexture.animations && this._refractionTexture.animations.length > 0) results.push(this._refractionTexture);
        return results;
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        const activeTextures = super.getActiveTextures();
        if (this._diffuseTexture) activeTextures.push(this._diffuseTexture);
        if (this._ambientTexture) activeTextures.push(this._ambientTexture);
        if (this._opacityTexture) activeTextures.push(this._opacityTexture);
        if (this._reflectionTexture) activeTextures.push(this._reflectionTexture);
        if (this._emissiveTexture) activeTextures.push(this._emissiveTexture);
        if (this._specularTexture) activeTextures.push(this._specularTexture);
        if (this._bumpTexture) activeTextures.push(this._bumpTexture);
        if (this._lightmapTexture) activeTextures.push(this._lightmapTexture);
        if (this._refractionTexture) activeTextures.push(this._refractionTexture);
        return activeTextures;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        if (this._diffuseTexture === texture) return true;
        if (this._ambientTexture === texture) return true;
        if (this._opacityTexture === texture) return true;
        if (this._reflectionTexture === texture) return true;
        if (this._emissiveTexture === texture) return true;
        if (this._specularTexture === texture) return true;
        if (this._bumpTexture === texture) return true;
        if (this._lightmapTexture === texture) return true;
        if (this._refractionTexture === texture) return true;
        return false;
    }
    /**
     * Disposes the material
     * @param forceDisposeEffect specifies if effects should be forcefully disposed
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     */ dispose(forceDisposeEffect, forceDisposeTextures) {
        if (forceDisposeTextures) {
            this._diffuseTexture?.dispose();
            this._ambientTexture?.dispose();
            this._opacityTexture?.dispose();
            this._reflectionTexture?.dispose();
            this._emissiveTexture?.dispose();
            this._specularTexture?.dispose();
            this._bumpTexture?.dispose();
            this._lightmapTexture?.dispose();
            this._refractionTexture?.dispose();
        }
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        super.dispose(forceDisposeEffect, forceDisposeTextures);
    }
    /**
     * Makes a duplicate of the material, and gives it a new name
     * @param name defines the new name for the duplicated material
     * @param cloneTexturesOnlyOnce - if a texture is used in more than one channel (e.g diffuse and opacity), only clone it once and reuse it on the other channels. Default false.
     * @param rootUrl defines the root URL to use to load textures
     * @returns the cloned material
     */ clone(name, cloneTexturesOnlyOnce = true, rootUrl = "") {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $c14168b02f7bcc00$export$cb949309547a0dd7(name, this.getScene()), this, {
            cloneTexturesOnlyOnce: cloneTexturesOnlyOnce
        });
        result.name = name;
        result.id = name;
        this.stencil.copyTo(result.stencil);
        this._clonePlugins(result, rootUrl);
        return result;
    }
    /**
     * Creates a standard material from parsed material data
     * @param source defines the JSON representation of the material
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a new standard material
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $c14168b02f7bcc00$export$cb949309547a0dd7(source.name, scene), source, scene, rootUrl);
        if (source.stencil) material.stencil.parse(source.stencil, scene, rootUrl);
        (0, $3afee756ef198914$export$a2d8b23205c25948)._ParsePlugins(source, material, scene, rootUrl);
        return material;
    }
    // Flags used to enable or disable a type of texture for all Standard Materials
    /**
     * Are diffuse textures enabled in the application.
     */ static get DiffuseTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DiffuseTextureEnabled;
    }
    static set DiffuseTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DiffuseTextureEnabled = value;
    }
    /**
     * Are detail textures enabled in the application.
     */ static get DetailTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DetailTextureEnabled;
    }
    static set DetailTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).DetailTextureEnabled = value;
    }
    /**
     * Are ambient textures enabled in the application.
     */ static get AmbientTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).AmbientTextureEnabled;
    }
    static set AmbientTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).AmbientTextureEnabled = value;
    }
    /**
     * Are opacity textures enabled in the application.
     */ static get OpacityTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).OpacityTextureEnabled;
    }
    static set OpacityTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).OpacityTextureEnabled = value;
    }
    /**
     * Are reflection textures enabled in the application.
     */ static get ReflectionTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).ReflectionTextureEnabled;
    }
    static set ReflectionTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).ReflectionTextureEnabled = value;
    }
    /**
     * Are emissive textures enabled in the application.
     */ static get EmissiveTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).EmissiveTextureEnabled;
    }
    static set EmissiveTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).EmissiveTextureEnabled = value;
    }
    /**
     * Are specular textures enabled in the application.
     */ static get SpecularTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).SpecularTextureEnabled;
    }
    static set SpecularTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).SpecularTextureEnabled = value;
    }
    /**
     * Are bump textures enabled in the application.
     */ static get BumpTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).BumpTextureEnabled;
    }
    static set BumpTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).BumpTextureEnabled = value;
    }
    /**
     * Are lightmap textures enabled in the application.
     */ static get LightmapTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).LightmapTextureEnabled;
    }
    static set LightmapTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).LightmapTextureEnabled = value;
    }
    /**
     * Are refraction textures enabled in the application.
     */ static get RefractionTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).RefractionTextureEnabled;
    }
    static set RefractionTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).RefractionTextureEnabled = value;
    }
    /**
     * Are color grading textures enabled in the application.
     */ static get ColorGradingTextureEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).ColorGradingTextureEnabled;
    }
    static set ColorGradingTextureEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).ColorGradingTextureEnabled = value;
    }
    /**
     * Are fresnels enabled in the application.
     */ static get FresnelEnabled() {
        return (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).FresnelEnabled;
    }
    static set FresnelEnabled(value) {
        (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).FresnelEnabled = value;
    }
}
/**
 * Force all the standard materials to compile to glsl even on WebGPU engines.
 * False by default. This is mostly meant for backward compatibility.
 */ $c14168b02f7bcc00$export$cb949309547a0dd7.ForceGLSL = false;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("diffuseTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("ambientTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_ambientTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "ambientTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("opacityTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_opacityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "opacityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("reflectionTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("emissiveTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_emissiveTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "emissiveTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("specularTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_specularTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "specularTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("bumpTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_bumpTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "bumpTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("lightmapTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_lightmapTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "lightmapTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("refractionTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_refractionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "refractionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("ambient")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "ambientColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("diffuse")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "diffuseColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("specular")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "specularColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("emissive")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "emissiveColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "specularPower", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useAlphaFromDiffuseTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useAlphaFromDiffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useAlphaFromDiffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useEmissiveAsIllumination")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useEmissiveAsIllumination", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useEmissiveAsIllumination", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("linkEmissiveWithDiffuse")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_linkEmissiveWithDiffuse", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "linkEmissiveWithDiffuse", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useSpecularOverAlpha")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useSpecularOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useSpecularOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useReflectionOverAlpha")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useReflectionOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useReflectionOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("disableLighting")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_disableLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "disableLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useObjectSpaceNormalMap")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useObjectSpaceNormalMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useObjectSpaceNormalMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useParallax")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useParallax", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useParallax", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useParallaxOcclusion")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useParallaxOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useParallaxOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "parallaxScaleBias", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("roughness")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "indexOfRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "invertRefractionY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "alphaCutOff", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useLightmapAsShadowmap")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useLightmapAsShadowmap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useLightmapAsShadowmap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("diffuseFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_diffuseFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "diffuseFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("opacityFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_opacityFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "opacityFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("reflectionFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_reflectionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "reflectionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("refractionFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_refractionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "refractionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("emissiveFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_emissiveFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "emissiveFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useReflectionFresnelFromSpecular")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useReflectionFresnelFromSpecular", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useReflectionFresnelFromSpecular", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useGlossinessFromSpecularMapAlpha")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useGlossinessFromSpecularMapAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useGlossinessFromSpecularMapAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("maxSimultaneousLights")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("invertNormalMapX")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_invertNormalMapX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "invertNormalMapX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("invertNormalMapY")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_invertNormalMapY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "invertNormalMapY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("twoSidedLighting")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_twoSidedLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "twoSidedLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("applyDecalMapAfterDetailMap")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_applyDecalMapAfterDetailMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "applyDecalMapAfterDetailMap", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.StandardMaterial", $c14168b02f7bcc00$export$cb949309547a0dd7);
(0, $gmbCk.Scene).DefaultMaterialFactory = (scene)=>{
    return new $c14168b02f7bcc00$export$cb949309547a0dd7("default material", scene);
};


/* eslint-disable @typescript-eslint/naming-convention */ 
var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $fhgis = parcelRequire("fhgis");

var $7212E = parcelRequire("7212E");
/* eslint-disable @typescript-eslint/naming-convention */ // "Coroutines are computer program components that generalize subroutines for non-preemptive multitasking, by allowing execution to be suspended and resumed."
// https://en.wikipedia.org/wiki/Coroutine
// The inline scheduler simply steps the coroutine synchronously. This is useful for running a coroutine synchronously, and also as a helper function for other schedulers.
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $391b8c7fee050f1f$export$a907eb56dd5ff8c2(coroutine, onStep, onError) {
    try {
        const step = coroutine.next();
        if (step.done) onStep(step);
        else if (!step.value) // NOTE: The properties of step have been narrowed, but the type of step itself is not narrowed, so the cast below is the most type safe way to deal with this without instantiating a new object to hold the values.
        onStep(step);
        else step.value.then(()=>{
            step.value = undefined;
            onStep(step);
        }, onError);
    } catch (error) {
        onError(error);
    }
}
function $391b8c7fee050f1f$export$c074d25b4dc6a454(yieldAfterMS = 25) {
    let startTime;
    return (coroutine, onStep, onError)=>{
        const currentTime = performance.now();
        if (startTime === undefined || currentTime - startTime > yieldAfterMS) {
            // If this is the first coroutine step, or if the time interval has elapsed, record a new start time, and schedule the coroutine step to happen later, effectively yielding control of the execution context.
            startTime = currentTime;
            setTimeout(()=>{
                $391b8c7fee050f1f$export$a907eb56dd5ff8c2(coroutine, onStep, onError);
            }, 0);
        } else // Otherwise it is not time to yield yet, so step the coroutine synchronously.
        $391b8c7fee050f1f$export$a907eb56dd5ff8c2(coroutine, onStep, onError);
    };
}
function $391b8c7fee050f1f$export$33a305be445da385(coroutine, scheduler, onSuccess, onError, abortSignal) {
    const resume = ()=>{
        let reschedule;
        const onStep = (stepResult)=>{
            if (stepResult.done) // If the coroutine is done, report success.
            onSuccess(stepResult.value);
            else // If the coroutine is not done, resume the coroutine (via the scheduler).
            if (reschedule === undefined) // If reschedule is undefined at this point, then the coroutine must have stepped synchronously, so just flag another loop iteration.
            reschedule = true;
            else // If reschedule is defined at this point, then the coroutine must have stepped asynchronously, so call resume to restart the step loop.
            resume();
        };
        do {
            reschedule = undefined;
            if (!abortSignal || !abortSignal.aborted) scheduler(coroutine, onStep, onError);
            else onError(new Error("Aborted"));
            if (reschedule === undefined) // If reschedule is undefined at this point, then the coroutine must have stepped asynchronously, so stop looping and let the coroutine be resumed later.
            reschedule = false;
        }while (reschedule);
    };
    resume();
}
function $391b8c7fee050f1f$export$47bff35b05234608(coroutine, abortSignal) {
    // Run the coroutine with the inline scheduler, storing the returned value, or re-throwing the error (since the error callback will be called synchronously by the inline scheduler).
    let result;
    $391b8c7fee050f1f$export$33a305be445da385(coroutine, $391b8c7fee050f1f$export$a907eb56dd5ff8c2, (r)=>result = r, (e)=>{
        throw e;
    }, abortSignal);
    // Synchronously return the result of the coroutine.
    return result;
}
function $391b8c7fee050f1f$export$73fc13c1ca5fca48(coroutine, scheduler, abortSignal) {
    // Run the coroutine with a yielding scheduler, resolving or rejecting the result promise when the coroutine finishes.
    return new Promise((resolve, reject)=>{
        $391b8c7fee050f1f$export$33a305be445da385(coroutine, scheduler, resolve, reject, abortSignal);
    });
}
function $391b8c7fee050f1f$export$7241269ae9cbc8ee(coroutineFactory, abortSignal) {
    return (...params)=>{
        // Run the coroutine synchronously.
        return $391b8c7fee050f1f$export$47bff35b05234608(coroutineFactory(...params), abortSignal);
    };
}
function $391b8c7fee050f1f$export$9162d5b4b7d28c6c(coroutineFactory, scheduler, abortSignal) {
    return (...params)=>{
        // Run the coroutine asynchronously.
        return $391b8c7fee050f1f$export$73fc13c1ca5fca48(coroutineFactory(...params), scheduler, abortSignal);
    };
}



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $57onU = parcelRequire("57onU");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ejQPp = parcelRequire("ejQPp");

var $dUFYy = parcelRequire("dUFYy");

var $6Ho1L = parcelRequire("6Ho1L");
/** @internal */ class $021dcb6a570ae9c1$var$_InternalNodeDataInfo {
    constructor(){
        this._doNotSerialize = false;
        this._isDisposed = false;
        this._sceneRootNodesIndex = -1;
        this._isEnabled = true;
        this._isParentEnabled = true;
        this._isReady = true;
        this._onEnabledStateChangedObservable = new (0, $diGQf.Observable)();
        this._onClonedObservable = new (0, $diGQf.Observable)();
    }
}
class $021dcb6a570ae9c1$export$85c928794f8d04d4 {
    /**
     * Add a new node constructor
     * @param type defines the type name of the node to construct
     * @param constructorFunc defines the constructor function
     */ static AddNodeConstructor(type, constructorFunc) {
        this._NodeConstructors[type] = constructorFunc;
    }
    /**
     * Returns a node constructor based on type name
     * @param type defines the type name
     * @param name defines the new node name
     * @param scene defines the hosting scene
     * @param options defines optional options to transmit to constructors
     * @returns the new constructor or null
     */ static Construct(type, name, scene, options) {
        const constructorFunc = this._NodeConstructors[type];
        if (!constructorFunc) return null;
        return constructorFunc(name, scene, options);
    }
    /**
     * Gets or sets the accessibility tag to describe the node for accessibility purpose.
     */ set accessibilityTag(value) {
        this._accessibilityTag = value;
        this.onAccessibilityTagChangedObservable.notifyObservers(value);
    }
    get accessibilityTag() {
        return this._accessibilityTag;
    }
    /**
     * Gets or sets a boolean used to define if the node must be serialized
     */ get doNotSerialize() {
        if (this._nodeDataStorage._doNotSerialize) return true;
        if (this._parentNode) return this._parentNode.doNotSerialize;
        return false;
    }
    set doNotSerialize(value) {
        this._nodeDataStorage._doNotSerialize = value;
    }
    /**
     * Gets a boolean indicating if the node has been disposed
     * @returns true if the node was disposed
     */ isDisposed() {
        return this._nodeDataStorage._isDisposed;
    }
    /**
     * Gets or sets the parent of the node (without keeping the current position in the scene)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
     */ set parent(parent) {
        if (this._parentNode === parent) return;
        const previousParentNode = this._parentNode;
        // Remove self from list of children of parent
        if (this._parentNode && this._parentNode._children !== undefined && this._parentNode._children !== null) {
            const index = this._parentNode._children.indexOf(this);
            if (index !== -1) this._parentNode._children.splice(index, 1);
            if (!parent && !this._nodeDataStorage._isDisposed) this._addToSceneRootNodes();
        }
        // Store new parent
        this._parentNode = parent;
        this._isDirty = true;
        // Add as child to new parent
        if (this._parentNode) {
            if (this._parentNode._children === undefined || this._parentNode._children === null) this._parentNode._children = new Array();
            this._parentNode._children.push(this);
            if (!previousParentNode) this._removeFromSceneRootNodes();
        }
        // Enabled state
        this._syncParentEnabledState();
    }
    get parent() {
        return this._parentNode;
    }
    /**
     * @internal
     */ _serializeAsParent(serializationObject) {
        serializationObject.parentId = this.uniqueId;
    }
    /** @internal */ _addToSceneRootNodes() {
        if (this._nodeDataStorage._sceneRootNodesIndex === -1) {
            this._nodeDataStorage._sceneRootNodesIndex = this._scene.rootNodes.length;
            this._scene.rootNodes.push(this);
        }
    }
    /** @internal */ _removeFromSceneRootNodes() {
        if (this._nodeDataStorage._sceneRootNodesIndex !== -1) {
            const rootNodes = this._scene.rootNodes;
            const lastIdx = rootNodes.length - 1;
            rootNodes[this._nodeDataStorage._sceneRootNodesIndex] = rootNodes[lastIdx];
            rootNodes[this._nodeDataStorage._sceneRootNodesIndex]._nodeDataStorage._sceneRootNodesIndex = this._nodeDataStorage._sceneRootNodesIndex;
            this._scene.rootNodes.pop();
            this._nodeDataStorage._sceneRootNodesIndex = -1;
        }
    }
    /**
     * Gets or sets the animation properties override
     */ get animationPropertiesOverride() {
        if (!this._animationPropertiesOverride) return this._scene.animationPropertiesOverride;
        return this._animationPropertiesOverride;
    }
    set animationPropertiesOverride(value) {
        this._animationPropertiesOverride = value;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "Node" string
     */ getClassName() {
        return "Node";
    }
    /**
     * Sets a callback that will be raised when the node will be disposed
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * An event triggered when the enabled state of the node changes
     */ get onEnabledStateChangedObservable() {
        return this._nodeDataStorage._onEnabledStateChangedObservable;
    }
    /**
     * An event triggered when the node is cloned
     */ get onClonedObservable() {
        return this._nodeDataStorage._onClonedObservable;
    }
    /**
     * Creates a new Node
     * @param name the name and id to be given to this node
     * @param scene the scene this node will be added to
     * @param isPure indicates this Node is just a Node, and not a derived class like Mesh or Camera
     */ constructor(name, scene = null, isPure = true){
        this._isDirty = false;
        this._nodeDataStorage = new $021dcb6a570ae9c1$var$_InternalNodeDataInfo();
        /**
         * Gets or sets a string used to store user defined state for the node
         */ this.state = "";
        /**
         * Gets or sets an object used to store user defined information for the node
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        this._accessibilityTag = null;
        /**
         * Observable fired when an accessibility tag is changed
         */ this.onAccessibilityTagChangedObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._parentContainer = null;
        /**
         * Gets a list of Animations associated with the node
         */ this.animations = [];
        this._ranges = {};
        /**
         * Callback raised when the node is ready to be used
         */ this.onReady = null;
        /** @internal */ this._currentRenderId = -1;
        this._parentUpdateId = -1;
        /** @internal */ this._childUpdateId = -1;
        /** @internal */ this._waitingParentId = null;
        /** @internal */ this._waitingParentInstanceIndex = null;
        /** @internal */ this._waitingParsedUniqueId = null;
        /** @internal */ this._cache = {};
        this._parentNode = null;
        /** @internal */ this._children = null;
        /** @internal */ this._worldMatrix = (0, $ha1VO.Matrix).Identity();
        /** @internal */ this._worldMatrixDeterminant = 0;
        /** @internal */ this._worldMatrixDeterminantIsDirty = true;
        this._animationPropertiesOverride = null;
        /** @internal */ this._isNode = true;
        /**
         * An event triggered when the mesh is disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onDisposeObserver = null;
        // Behaviors
        this._behaviors = new Array();
        this.name = name;
        this.id = name;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this.uniqueId = this._scene.getUniqueId();
        this._initCache();
        if (isPure) this._addToSceneRootNodes();
    }
    /**
     * Gets the scene of the node
     * @returns a scene
     */ getScene() {
        return this._scene;
    }
    /**
     * Gets the engine of the node
     * @returns a Engine
     */ getEngine() {
        return this._scene.getEngine();
    }
    /**
     * Attach a behavior to the node
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     * @param behavior defines the behavior to attach
     * @param attachImmediately defines that the behavior must be attached even if the scene is still loading
     * @returns the current Node
     */ addBehavior(behavior, attachImmediately = false) {
        const index = this._behaviors.indexOf(behavior);
        if (index !== -1) return this;
        behavior.init();
        if (this._scene.isLoading && !attachImmediately) // We defer the attach when the scene will be loaded
        this._scene.onDataLoadedObservable.addOnce(()=>{
            behavior.attach(this);
        });
        else behavior.attach(this);
        this._behaviors.push(behavior);
        return this;
    }
    /**
     * Remove an attached behavior
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     * @param behavior defines the behavior to attach
     * @returns the current Node
     */ removeBehavior(behavior) {
        const index = this._behaviors.indexOf(behavior);
        if (index === -1) return this;
        this._behaviors[index].detach();
        this._behaviors.splice(index, 1);
        return this;
    }
    /**
     * Gets the list of attached behaviors
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     */ get behaviors() {
        return this._behaviors;
    }
    /**
     * Gets an attached behavior by name
     * @param name defines the name of the behavior to look for
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     * @returns null if behavior was not found else the requested behavior
     */ getBehaviorByName(name) {
        for (const behavior of this._behaviors){
            if (behavior.name === name) return behavior;
        }
        return null;
    }
    /**
     * Returns the latest update of the World matrix
     * @returns a Matrix
     */ getWorldMatrix() {
        if (this._currentRenderId !== this._scene.getRenderId()) this.computeWorldMatrix();
        return this._worldMatrix;
    }
    /** @internal */ _getWorldMatrixDeterminant() {
        if (this._worldMatrixDeterminantIsDirty) {
            this._worldMatrixDeterminantIsDirty = false;
            this._worldMatrixDeterminant = this._worldMatrix.determinant();
        }
        return this._worldMatrixDeterminant;
    }
    /**
     * Returns directly the latest state of the mesh World matrix.
     * A Matrix is returned.
     */ get worldMatrixFromCache() {
        return this._worldMatrix;
    }
    // override it in derived class if you add new variables to the cache
    // and call the parent class method
    /** @internal */ _initCache() {
        this._cache = {};
    }
    /**
     * @internal
     */ updateCache(force) {
        if (!force && this.isSynchronized()) return;
        this._updateCache();
    }
    /**
     * @internal
     */ _getActionManagerForTrigger(trigger, _initialCall = true) {
        if (!this.parent) return null;
        return this.parent._getActionManagerForTrigger(trigger, false);
    }
    // override it in derived class if you add new variables to the cache
    // and call the parent class method if !ignoreParentClass
    /**
     * @internal
     */ _updateCache(_ignoreParentClass) {}
    // override it in derived class if you add new variables to the cache
    /** @internal */ _isSynchronized() {
        return true;
    }
    /** @internal */ _markSyncedWithParent() {
        if (this._parentNode) this._parentUpdateId = this._parentNode._childUpdateId;
    }
    /** @internal */ isSynchronizedWithParent() {
        if (!this._parentNode) return true;
        if (this._parentNode._isDirty || this._parentUpdateId !== this._parentNode._childUpdateId) return false;
        return this._parentNode.isSynchronized();
    }
    /** @internal */ isSynchronized() {
        if (this._parentNode && !this.isSynchronizedWithParent()) return false;
        return this._isSynchronized();
    }
    /**
     * Is this node ready to be used/rendered
     * @param _completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
     * @returns true if the node is ready
     */ isReady(_completeCheck = false) {
        return this._nodeDataStorage._isReady;
    }
    /**
     * Flag the  node as dirty (Forcing it to update everything)
     * @param _property helps children apply precise "dirtyfication"
     * @returns this node
     */ markAsDirty(_property) {
        this._currentRenderId = Number.MAX_VALUE;
        this._isDirty = true;
        return this;
    }
    /**
     * Is this node enabled?
     * If the node has a parent, all ancestors will be checked and false will be returned if any are false (not enabled), otherwise will return true
     * @param checkAncestors indicates if this method should check the ancestors. The default is to check the ancestors. If set to false, the method will return the value of this node without checking ancestors
     * @returns whether this node (and its parent) is enabled
     */ isEnabled(checkAncestors = true) {
        if (checkAncestors === false) return this._nodeDataStorage._isEnabled;
        if (!this._nodeDataStorage._isEnabled) return false;
        return this._nodeDataStorage._isParentEnabled;
    }
    /** @internal */ _syncParentEnabledState() {
        this._nodeDataStorage._isParentEnabled = this._parentNode ? this._parentNode.isEnabled() : true;
        if (this._children) this._children.forEach((c)=>{
            c._syncParentEnabledState(); // Force children to update accordingly
        });
    }
    /**
     * Set the enabled state of this node
     * @param value defines the new enabled state
     */ setEnabled(value) {
        if (this._nodeDataStorage._isEnabled === value) return;
        this._nodeDataStorage._isEnabled = value;
        this._syncParentEnabledState();
        this._nodeDataStorage._onEnabledStateChangedObservable.notifyObservers(value);
    }
    /**
     * Is this node a descendant of the given node?
     * The function will iterate up the hierarchy until the ancestor was found or no more parents defined
     * @param ancestor defines the parent node to inspect
     * @returns a boolean indicating if this node is a descendant of the given node
     */ isDescendantOf(ancestor) {
        if (this.parent) {
            if (this.parent === ancestor) return true;
            return this.parent.isDescendantOf(ancestor);
        }
        return false;
    }
    /**
     * @internal
     */ _getDescendants(results, directDescendantsOnly = false, predicate) {
        if (!this._children) return;
        for(let index = 0; index < this._children.length; index++){
            const item = this._children[index];
            if (!predicate || predicate(item)) results.push(item);
            if (!directDescendantsOnly) item._getDescendants(results, false, predicate);
        }
    }
    /**
     * Will return all nodes that have this node as ascendant
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns all children nodes of all types
     */ getDescendants(directDescendantsOnly, predicate) {
        const results = [];
        this._getDescendants(results, directDescendantsOnly, predicate);
        return results;
    }
    /**
     * Get all child-meshes of this node
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: false)
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns an array of AbstractMesh
     */ getChildMeshes(directDescendantsOnly, predicate) {
        const results = [];
        this._getDescendants(results, directDescendantsOnly, (node)=>{
            return (!predicate || predicate(node)) && node.cullingStrategy !== undefined;
        });
        return results;
    }
    /**
     * Get all direct children of this node
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: true)
     * @returns an array of Node
     */ getChildren(predicate, directDescendantsOnly = true) {
        return this.getDescendants(directDescendantsOnly, predicate);
    }
    /**
     * @internal
     */ _setReady(state) {
        if (state === this._nodeDataStorage._isReady) return;
        if (!state) {
            this._nodeDataStorage._isReady = false;
            return;
        }
        if (this.onReady) this.onReady(this);
        this._nodeDataStorage._isReady = true;
    }
    /**
     * Get an animation by name
     * @param name defines the name of the animation to look for
     * @returns null if not found else the requested animation
     */ getAnimationByName(name) {
        for(let i = 0; i < this.animations.length; i++){
            const animation = this.animations[i];
            if (animation.name === name) return animation;
        }
        return null;
    }
    /**
     * Creates an animation range for this node
     * @param name defines the name of the range
     * @param from defines the starting key
     * @param to defines the end key
     */ createAnimationRange(name, from, to) {
        // check name not already in use
        if (!this._ranges[name]) {
            this._ranges[name] = $021dcb6a570ae9c1$export$85c928794f8d04d4._AnimationRangeFactory(name, from, to);
            for(let i = 0, nAnimations = this.animations.length; i < nAnimations; i++)if (this.animations[i]) this.animations[i].createRange(name, from, to);
        }
    }
    /**
     * Delete a specific animation range
     * @param name defines the name of the range to delete
     * @param deleteFrames defines if animation frames from the range must be deleted as well
     */ deleteAnimationRange(name, deleteFrames = true) {
        for(let i = 0, nAnimations = this.animations.length; i < nAnimations; i++)if (this.animations[i]) this.animations[i].deleteRange(name, deleteFrames);
        this._ranges[name] = null; // said much faster than 'delete this._range[name]'
    }
    /**
     * Get an animation range by name
     * @param name defines the name of the animation range to look for
     * @returns null if not found else the requested animation range
     */ getAnimationRange(name) {
        return this._ranges[name] || null;
    }
    /**
     * Clone the current node
     * @param name Name of the new clone
     * @param newParent New parent for the clone
     * @param doNotCloneChildren Do not clone children hierarchy
     * @returns the new transform node
     */ clone(name, newParent, doNotCloneChildren) {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $021dcb6a570ae9c1$export$85c928794f8d04d4(name, this.getScene()), this);
        if (newParent) result.parent = newParent;
        if (!doNotCloneChildren) {
            // Children
            const directDescendants = this.getDescendants(true);
            for(let index = 0; index < directDescendants.length; index++){
                const child = directDescendants[index];
                child.clone(name + "." + child.name, result);
            }
        }
        return result;
    }
    /**
     * Gets the list of all animation ranges defined on this node
     * @returns an array
     */ getAnimationRanges() {
        const animationRanges = [];
        let name;
        for(name in this._ranges)animationRanges.push(this._ranges[name]);
        return animationRanges;
    }
    /**
     * Will start the animation sequence
     * @param name defines the range frames for animation sequence
     * @param loop defines if the animation should loop (false by default)
     * @param speedRatio defines the speed factor in which to run the animation (1 by default)
     * @param onAnimationEnd defines a function to be executed when the animation ended (undefined by default)
     * @returns the object created for this animation. If range does not exist, it will return null
     */ beginAnimation(name, loop, speedRatio, onAnimationEnd) {
        const range = this.getAnimationRange(name);
        if (!range) return null;
        return this._scene.beginAnimation(this, range.from, range.to, loop, speedRatio, onAnimationEnd);
    }
    /**
     * Serialize animation ranges into a JSON compatible object
     * @returns serialization object
     */ serializeAnimationRanges() {
        const serializationRanges = [];
        for(const name in this._ranges){
            const localRange = this._ranges[name];
            if (!localRange) continue;
            const range = {};
            range.name = name;
            range.from = localRange.from;
            range.to = localRange.to;
            serializationRanges.push(range);
        }
        return serializationRanges;
    }
    /**
     * Computes the world matrix of the node
     * @param _force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
     * @returns the world matrix
     */ computeWorldMatrix(_force) {
        if (!this._worldMatrix) this._worldMatrix = (0, $ha1VO.Matrix).Identity();
        return this._worldMatrix;
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this._nodeDataStorage._isDisposed = true;
        if (!doNotRecurse) {
            const nodes = this.getDescendants(true);
            for (const node of nodes)node.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        if (!this.parent) this._removeFromSceneRootNodes();
        else this.parent = null;
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onEnabledStateChangedObservable.clear();
        this.onClonedObservable.clear();
        // Behaviors
        for (const behavior of this._behaviors)behavior.detach();
        this._behaviors.length = 0;
        this.metadata = null;
    }
    /**
     * Parse animation range data from a serialization object and store them into a given node
     * @param node defines where to store the animation ranges
     * @param parsedNode defines the serialization object to read data from
     * @param _scene defines the hosting scene
     */ static ParseAnimationRanges(node, parsedNode, _scene) {
        if (parsedNode.ranges) for(let index = 0; index < parsedNode.ranges.length; index++){
            const data = parsedNode.ranges[index];
            node.createAnimationRange(data.name, data.from, data.to);
        }
    }
    /**
     * Return the minimum and maximum world vectors of the entire hierarchy under current node
     * @param includeDescendants Include bounding info from descendants as well (true by default)
     * @param predicate defines a callback function that can be customize to filter what meshes should be included in the list used to compute the bounding vectors
     * @returns the new bounding vectors
     */ getHierarchyBoundingVectors(includeDescendants = true, predicate = null) {
        // Ensures that all world matrix will be recomputed.
        this.getScene().incrementRenderId();
        this.computeWorldMatrix(true);
        let min;
        let max;
        const thisAbstractMesh = this;
        if (thisAbstractMesh.getBoundingInfo && thisAbstractMesh.subMeshes) {
            // If this is an abstract mesh get its bounding info
            const boundingInfo = thisAbstractMesh.getBoundingInfo();
            min = boundingInfo.boundingBox.minimumWorld.clone();
            max = boundingInfo.boundingBox.maximumWorld.clone();
        } else {
            min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        }
        if (includeDescendants) {
            const descendants = this.getDescendants(false);
            for (const descendant of descendants){
                const childMesh = descendant;
                childMesh.computeWorldMatrix(true);
                // Filters meshes based on custom predicate function.
                if (predicate && !predicate(childMesh)) continue;
                //make sure we have the needed params to get mix and max
                if (!childMesh.getBoundingInfo || childMesh.getTotalVertices() === 0) continue;
                const childBoundingInfo = childMesh.getBoundingInfo();
                const boundingBox = childBoundingInfo.boundingBox;
                const minBox = boundingBox.minimumWorld;
                const maxBox = boundingBox.maximumWorld;
                (0, $ha1VO.Vector3).CheckExtends(minBox, min, max);
                (0, $ha1VO.Vector3).CheckExtends(maxBox, min, max);
            }
        }
        return {
            min: min,
            max: max
        };
    }
}
/**
 * @internal
 */ $021dcb6a570ae9c1$export$85c928794f8d04d4._AnimationRangeFactory = (_name, _from, _to)=>{
    throw (0, $dUFYy._WarnImport)("AnimationRange");
};
$021dcb6a570ae9c1$export$85c928794f8d04d4._NodeConstructors = {};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "id", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "state", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "metadata", void 0);



var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");

var $dUFYy = parcelRequire("dUFYy");

var $191mA = parcelRequire("191mA");

var $9sPMJ = parcelRequire("9sPMJ");

var $6Ho1L = parcelRequire("6Ho1L");
class $52736139c8513fb2$export$79f141de891a5fed extends (0, $021dcb6a570ae9c1$export$85c928794f8d04d4) {
    /**
     * Define the current local position of the camera in the scene
     */ get position() {
        return this._position;
    }
    set position(newPosition) {
        this._position = newPosition;
    }
    /**
     * The vector the camera should consider as up.
     * (default is Vector3(0, 1, 0) aka Vector3.Up())
     */ set upVector(vec) {
        this._upVector = vec;
    }
    get upVector() {
        return this._upVector;
    }
    /**
     * The screen area in scene units squared
     */ get screenArea() {
        let x = 0;
        let y = 0;
        if (this.mode === $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA) {
            if (this.fovMode === $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED) {
                y = this.minZ * 2 * Math.tan(this.fov / 2);
                x = this.getEngine().getAspectRatio(this) * y;
            } else {
                x = this.minZ * 2 * Math.tan(this.fov / 2);
                y = x / this.getEngine().getAspectRatio(this);
            }
        } else {
            const halfWidth = this.getEngine().getRenderWidth() / 2.0;
            const halfHeight = this.getEngine().getRenderHeight() / 2.0;
            x = (this.orthoRight ?? halfWidth) - (this.orthoLeft ?? -halfWidth);
            y = (this.orthoTop ?? halfHeight) - (this.orthoBottom ?? -halfHeight);
        }
        return x * y;
    }
    /**
     * Define the current limit on the left side for an orthographic camera
     * In scene unit
     */ set orthoLeft(value) {
        this._orthoLeft = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoLeft = value;
    }
    get orthoLeft() {
        return this._orthoLeft;
    }
    /**
     * Define the current limit on the right side for an orthographic camera
     * In scene unit
     */ set orthoRight(value) {
        this._orthoRight = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoRight = value;
    }
    get orthoRight() {
        return this._orthoRight;
    }
    /**
     * Define the current limit on the bottom side for an orthographic camera
     * In scene unit
     */ set orthoBottom(value) {
        this._orthoBottom = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoBottom = value;
    }
    get orthoBottom() {
        return this._orthoBottom;
    }
    /**
     * Define the current limit on the top side for an orthographic camera
     * In scene unit
     */ set orthoTop(value) {
        this._orthoTop = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoTop = value;
    }
    get orthoTop() {
        return this._orthoTop;
    }
    /**
     * Define the mode of the camera (Camera.PERSPECTIVE_CAMERA or Camera.ORTHOGRAPHIC_CAMERA)
     */ set mode(mode) {
        this._mode = mode;
        // Pass the mode down to the rig cameras
        for (const rigCamera of this._rigCameras)rigCamera.mode = mode;
    }
    get mode() {
        return this._mode;
    }
    /**
     * Gets a flag indicating that the camera has moved in some way since the last call to Camera.update()
     */ get hasMoved() {
        return this._hasMoved;
    }
    /**
     * Instantiates a new camera object.
     * This should not be used directly but through the inherited cameras: ArcRotate, Free...
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
     * @param name Defines the name of the camera in the scene
     * @param position Defines the position of the camera
     * @param scene Defines the scene the camera belongs too
     * @param setActiveOnSceneIfNoneActive Defines if the camera should be set as active after creation if no other camera have been defined in the scene
     */ constructor(name, position, scene, setActiveOnSceneIfNoneActive = true){
        super(name, scene, false);
        /** @internal */ this._position = (0, $ha1VO.Vector3).Zero();
        this._upVector = (0, $ha1VO.Vector3).Up();
        /**
         * Object containing oblique projection values (only used with ORTHOGRAPHIC_CAMERA)
         */ this.oblique = null;
        this._orthoLeft = null;
        this._orthoRight = null;
        this._orthoBottom = null;
        this._orthoTop = null;
        /**
         * Field Of View is set in Radians. (default is 0.8)
         */ this.fov = 0.8;
        /**
         * Projection plane tilt around the X axis (horizontal), set in Radians. (default is 0)
         * Can be used to make vertical lines in world space actually vertical on the screen.
         * See https://forum.babylonjs.com/t/add-vertical-shift-to-3ds-max-exporter-babylon-cameras/17480
         */ this.projectionPlaneTilt = 0;
        /**
         * Define the minimum distance the camera can see from.
         * This is important to note that the depth buffer are not infinite and the closer it starts
         * the more your scene might encounter depth fighting issue.
         */ this.minZ = 1;
        /**
         * Define the maximum distance the camera can see to.
         * This is important to note that the depth buffer are not infinite and the further it end
         * the more your scene might encounter depth fighting issue.
         */ this.maxZ = 10000.0;
        /**
         * Define the default inertia of the camera.
         * This helps giving a smooth feeling to the camera movement.
         */ this.inertia = 0.9;
        this._mode = $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA;
        /**
         * Define whether the camera is intermediate.
         * This is useful to not present the output directly to the screen in case of rig without post process for instance
         */ this.isIntermediate = false;
        /**
         * Define the viewport of the camera.
         * This correspond to the portion of the screen the camera will render to in normalized 0 to 1 unit.
         */ this.viewport = new (0, $191mA.Viewport)(0, 0, 1.0, 1.0);
        /**
         * Restricts the camera to viewing objects with the same layerMask.
         * A camera with a layerMask of 1 will render mesh.layerMask & camera.layerMask!== 0
         */ this.layerMask = 0x0fffffff;
        /**
         * fovMode sets the camera frustum bounds to the viewport bounds. (default is FOVMODE_VERTICAL_FIXED)
         */ this.fovMode = $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED;
        /**
         * Rig mode of the camera.
         * This is useful to create the camera with two "eyes" instead of one to create VR or stereoscopic scenes.
         * This is normally controlled byt the camera themselves as internal use.
         */ this.cameraRigMode = $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE;
        /**
         * Defines the list of custom render target which are rendered to and then used as the input to this camera's render. Eg. display another camera view on a TV in the main scene
         * This is pretty helpful if you wish to make a camera render to a texture you could reuse somewhere
         * else in the scene. (Eg. security camera)
         *
         * To change the final output target of the camera, camera.outputRenderTarget should be used instead (eg. webXR renders to a render target corresponding to an HMD)
         */ this.customRenderTargets = [];
        /**
         * When set, the camera will render to this render target instead of the default canvas
         *
         * If the desire is to use the output of a camera as a texture in the scene consider using camera.customRenderTargets instead
         */ this.outputRenderTarget = null;
        /**
         * Observable triggered when the camera view matrix has changed.
         * Beware of reentrance! Some methods like Camera.getViewMatrix and Camera.getWorldMatrix can trigger the onViewMatrixChangedObservable
         * observable, so using them inside an observer will require additional logic to avoid a stack overflow error.
         */ this.onViewMatrixChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when the camera Projection matrix has changed.
         */ this.onProjectionMatrixChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when the inputs have been processed.
         */ this.onAfterCheckInputsObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when reset has been called and applied to the camera.
         */ this.onRestoreStateObservable = new (0, $diGQf.Observable)();
        /**
         * Is this camera a part of a rig system?
         */ this.isRigCamera = false;
        this._hasMoved = false;
        /** @internal */ this._rigCameras = new Array();
        /** @internal */ this._skipRendering = false;
        /** @internal */ this._projectionMatrix = new (0, $ha1VO.Matrix)();
        /** @internal */ this._postProcesses = new Array();
        /** @internal */ this._activeMeshes = new (0, $57onU.SmartArray)(256);
        this._globalPosition = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._computedViewMatrix = (0, $ha1VO.Matrix).Identity();
        this._doNotComputeProjectionMatrix = false;
        this._transformMatrix = (0, $ha1VO.Matrix).Zero();
        this._refreshFrustumPlanes = true;
        this._absoluteRotation = (0, $ha1VO.Quaternion).Identity();
        /** @internal */ this._isCamera = true;
        /** @internal */ this._isLeftCamera = false;
        /** @internal */ this._isRightCamera = false;
        this.getScene().addCamera(this);
        if (setActiveOnSceneIfNoneActive && !this.getScene().activeCamera) this.getScene().activeCamera = this;
        this.position = position;
        this.renderPassId = this.getScene().getEngine().createRenderPassId(`Camera ${name}`);
    }
    /**
     * Store current camera state (fov, position, etc..)
     * @returns the camera
     */ storeState() {
        this._stateStored = true;
        this._storedFov = this.fov;
        return this;
    }
    /**
     * Returns true if a state has been stored by calling storeState method.
     * @returns true if state has been stored.
     */ hasStateStored() {
        return !!this._stateStored;
    }
    /**
     * Restores the camera state values if it has been stored. You must call storeState() first
     * @returns true if restored and false otherwise
     */ _restoreStateValues() {
        if (!this._stateStored) return false;
        this.fov = this._storedFov;
        return true;
    }
    /**
     * Restored camera state. You must call storeState() first.
     * @returns true if restored and false otherwise
     */ restoreState() {
        if (this._restoreStateValues()) {
            this.onRestoreStateObservable.notifyObservers(this);
            return true;
        }
        return false;
    }
    /**
     * Gets the class name of the camera.
     * @returns the class name
     */ getClassName() {
        return "Camera";
    }
    /**
     * Gets a string representation of the camera useful for debug purpose.
     * @param fullDetails Defines that a more verbose level of logging is required
     * @returns the string representation
     */ toString(fullDetails) {
        let ret = "Name: " + this.name;
        ret += ", type: " + this.getClassName();
        if (this.animations) for(let i = 0; i < this.animations.length; i++)ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
        return ret;
    }
    /**
     * Automatically tilts the projection plane, using `projectionPlaneTilt`, to correct the perspective effect on vertical lines.
     */ applyVerticalCorrection() {
        const rot = this.absoluteRotation.toEulerAngles();
        this.projectionPlaneTilt = this._scene.useRightHandedSystem ? -rot.x : rot.x;
    }
    /**
     * Gets the current world space position of the camera.
     */ get globalPosition() {
        return this._globalPosition;
    }
    /**
     * Gets the list of active meshes this frame (meshes no culled or excluded by lod s in the frame)
     * @returns the active meshe list
     */ getActiveMeshes() {
        return this._activeMeshes;
    }
    /**
     * Check whether a mesh is part of the current active mesh list of the camera
     * @param mesh Defines the mesh to check
     * @returns true if active, false otherwise
     */ isActiveMesh(mesh) {
        return this._activeMeshes.indexOf(mesh) !== -1;
    }
    /**
     * Is this camera ready to be used/rendered
     * @param completeCheck defines if a complete check (including post processes) has to be done (false by default)
     * @returns true if the camera is ready
     */ isReady(completeCheck = false) {
        if (completeCheck) for (const pp of this._postProcesses){
            if (pp && !pp.isReady()) return false;
        }
        return super.isReady(completeCheck);
    }
    /** @internal */ _initCache() {
        super._initCache();
        this._cache.position = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.upVector = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.mode = undefined;
        this._cache.minZ = undefined;
        this._cache.maxZ = undefined;
        this._cache.fov = undefined;
        this._cache.fovMode = undefined;
        this._cache.aspectRatio = undefined;
        this._cache.orthoLeft = undefined;
        this._cache.orthoRight = undefined;
        this._cache.orthoBottom = undefined;
        this._cache.orthoTop = undefined;
        this._cache.obliqueAngle = undefined;
        this._cache.obliqueLength = undefined;
        this._cache.obliqueOffset = undefined;
        this._cache.renderWidth = undefined;
        this._cache.renderHeight = undefined;
    }
    /**
     * @internal
     */ _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) super._updateCache();
        this._cache.position.copyFrom(this.position);
        this._cache.upVector.copyFrom(this.upVector);
    }
    /** @internal */ _isSynchronized() {
        return this._isSynchronizedViewMatrix() && this._isSynchronizedProjectionMatrix();
    }
    /** @internal */ _isSynchronizedViewMatrix() {
        if (!super._isSynchronized()) return false;
        return this._cache.position.equals(this.position) && this._cache.upVector.equals(this.upVector) && this.isSynchronizedWithParent();
    }
    /** @internal */ _isSynchronizedProjectionMatrix() {
        let isSynchronized = this._cache.mode === this.mode && this._cache.minZ === this.minZ && this._cache.maxZ === this.maxZ;
        if (!isSynchronized) return false;
        const engine = this.getEngine();
        if (this.mode === $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA) isSynchronized = this._cache.fov === this.fov && this._cache.fovMode === this.fovMode && this._cache.aspectRatio === engine.getAspectRatio(this) && this._cache.projectionPlaneTilt === this.projectionPlaneTilt;
        else {
            isSynchronized = this._cache.orthoLeft === this.orthoLeft && this._cache.orthoRight === this.orthoRight && this._cache.orthoBottom === this.orthoBottom && this._cache.orthoTop === this.orthoTop && this._cache.renderWidth === engine.getRenderWidth() && this._cache.renderHeight === engine.getRenderHeight();
            if (this.oblique) isSynchronized = isSynchronized && this._cache.obliqueAngle === this.oblique.angle && this._cache.obliqueLength === this.oblique.length && this._cache.obliqueOffset === this.oblique.offset;
        }
        return isSynchronized;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * This function is here because typescript removes the typing of the last function.
     * @param _ignored defines an ignored parameter kept for backward compatibility.
     * @param _noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(_ignored, _noPreventDefault) {}
    /**
     * Detach the current controls from the specified dom element.
     * This function is here because typescript removes the typing of the last function.
     * @param _ignored defines an ignored parameter kept for backward compatibility.
     */ detachControl(_ignored) {}
    /**
     * Update the camera state according to the different inputs gathered during the frame.
     */ update() {
        this._hasMoved = false;
        this._checkInputs();
        if (this.cameraRigMode !== $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE) this._updateRigCameras();
        // Attempt to update the camera's view and projection matrices.
        // This call is being made because these matrices are no longer being updated
        // as a part of the picking ray process (in addition to scene.render).
        this.getViewMatrix();
        this.getProjectionMatrix();
    }
    /** @internal */ _checkInputs() {
        this.onAfterCheckInputsObservable.notifyObservers(this);
    }
    /** @internal */ get rigCameras() {
        return this._rigCameras;
    }
    /**
     * Gets the post process used by the rig cameras
     */ get rigPostProcess() {
        return this._rigPostProcess;
    }
    /**
     * Internal, gets the first post process.
     * @returns the first post process to be run on this camera.
     */ _getFirstPostProcess() {
        for(let ppIndex = 0; ppIndex < this._postProcesses.length; ppIndex++){
            if (this._postProcesses[ppIndex] !== null) return this._postProcesses[ppIndex];
        }
        return null;
    }
    _cascadePostProcessesToRigCams() {
        // invalidate framebuffer
        const firstPostProcess = this._getFirstPostProcess();
        if (firstPostProcess) firstPostProcess.markTextureDirty();
        // glue the rigPostProcess to the end of the user postprocesses & assign to each sub-camera
        for(let i = 0, len = this._rigCameras.length; i < len; i++){
            const cam = this._rigCameras[i];
            const rigPostProcess = cam._rigPostProcess;
            // for VR rig, there does not have to be a post process
            if (rigPostProcess) {
                const isPass = rigPostProcess.getEffectName() === "pass";
                if (isPass) // any rig which has a PassPostProcess for rig[0], cannot be isIntermediate when there are also user postProcesses
                cam.isIntermediate = this._postProcesses.length === 0;
                cam._postProcesses = this._postProcesses.slice(0).concat(rigPostProcess);
                rigPostProcess.markTextureDirty();
            } else cam._postProcesses = this._postProcesses.slice(0);
        }
    }
    /**
     * Attach a post process to the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
     * @param postProcess The post process to attach to the camera
     * @param insertAt The position of the post process in case several of them are in use in the scene
     * @returns the position the post process has been inserted at
     */ attachPostProcess(postProcess, insertAt = null) {
        if (!postProcess.isReusable() && this._postProcesses.indexOf(postProcess) > -1) {
            (0, $kVtWi.Logger).Error("You're trying to reuse a post process not defined as reusable.");
            return 0;
        }
        if (insertAt == null || insertAt < 0) this._postProcesses.push(postProcess);
        else if (this._postProcesses[insertAt] === null) this._postProcesses[insertAt] = postProcess;
        else this._postProcesses.splice(insertAt, 0, postProcess);
        this._cascadePostProcessesToRigCams(); // also ensures framebuffer invalidated
        // Update prePass
        if (this._scene.prePassRenderer) this._scene.prePassRenderer.markAsDirty();
        return this._postProcesses.indexOf(postProcess);
    }
    /**
     * Detach a post process to the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
     * @param postProcess The post process to detach from the camera
     */ detachPostProcess(postProcess) {
        const idx = this._postProcesses.indexOf(postProcess);
        if (idx !== -1) this._postProcesses[idx] = null;
        // Update prePass
        if (this._scene.prePassRenderer) this._scene.prePassRenderer.markAsDirty();
        this._cascadePostProcessesToRigCams(); // also ensures framebuffer invalidated
    }
    /**
     * Gets the current world matrix of the camera
     * @returns the world matrix
     */ getWorldMatrix() {
        if (this._isSynchronizedViewMatrix()) return this._worldMatrix;
        // Getting the view matrix will also compute the world matrix.
        this.getViewMatrix();
        return this._worldMatrix;
    }
    /** @internal */ _getViewMatrix() {
        return (0, $ha1VO.Matrix).Identity();
    }
    /**
     * Gets the current view matrix of the camera.
     * @param force forces the camera to recompute the matrix without looking at the cached state
     * @returns the view matrix
     */ getViewMatrix(force) {
        if (!force && this._isSynchronizedViewMatrix()) return this._computedViewMatrix;
        this._hasMoved = true;
        this.updateCache();
        this._computedViewMatrix = this._getViewMatrix();
        this._currentRenderId = this.getScene().getRenderId();
        this._childUpdateId++;
        this._refreshFrustumPlanes = true;
        if (this._cameraRigParams && this._cameraRigParams.vrPreViewMatrix) this._computedViewMatrix.multiplyToRef(this._cameraRigParams.vrPreViewMatrix, this._computedViewMatrix);
        // Notify parent camera if rig camera is changed
        if (this.parent && this.parent.onViewMatrixChangedObservable) this.parent.onViewMatrixChangedObservable.notifyObservers(this.parent);
        this.onViewMatrixChangedObservable.notifyObservers(this);
        this._computedViewMatrix.invertToRef(this._worldMatrix);
        return this._computedViewMatrix;
    }
    /**
     * Freeze the projection matrix.
     * It will prevent the cache check of the camera projection compute and can speed up perf
     * if no parameter of the camera are meant to change
     * @param projection Defines manually a projection if necessary
     */ freezeProjectionMatrix(projection) {
        this._doNotComputeProjectionMatrix = true;
        if (projection !== undefined) this._projectionMatrix = projection;
    }
    /**
     * Unfreeze the projection matrix if it has previously been freezed by freezeProjectionMatrix.
     */ unfreezeProjectionMatrix() {
        this._doNotComputeProjectionMatrix = false;
    }
    /**
     * Gets the current projection matrix of the camera.
     * @param force forces the camera to recompute the matrix without looking at the cached state
     * @returns the projection matrix
     */ getProjectionMatrix(force) {
        if (this._doNotComputeProjectionMatrix || !force && this._isSynchronizedProjectionMatrix()) return this._projectionMatrix;
        // Cache
        this._cache.mode = this.mode;
        this._cache.minZ = this.minZ;
        this._cache.maxZ = this.maxZ;
        // Matrix
        this._refreshFrustumPlanes = true;
        const engine = this.getEngine();
        const scene = this.getScene();
        const reverseDepth = engine.useReverseDepthBuffer;
        if (this.mode === $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA) {
            this._cache.fov = this.fov;
            this._cache.fovMode = this.fovMode;
            this._cache.aspectRatio = engine.getAspectRatio(this);
            this._cache.projectionPlaneTilt = this.projectionPlaneTilt;
            if (this.minZ <= 0) this.minZ = 0.1;
            let getProjectionMatrix;
            if (scene.useRightHandedSystem) getProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovRHToRef;
            else getProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovLHToRef;
            getProjectionMatrix(this.fov, engine.getAspectRatio(this), reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, this.fovMode === $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED, engine.isNDCHalfZRange, this.projectionPlaneTilt, reverseDepth);
        } else {
            const halfWidth = engine.getRenderWidth() / 2.0;
            const halfHeight = engine.getRenderHeight() / 2.0;
            if (scene.useRightHandedSystem) {
                if (this.oblique) (0, $ha1VO.Matrix).ObliqueOffCenterRHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this.oblique.length, this.oblique.angle, this._computeObliqueDistance(this.oblique.offset), this._projectionMatrix, engine.isNDCHalfZRange);
                else (0, $ha1VO.Matrix).OrthoOffCenterRHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
            } else if (this.oblique) (0, $ha1VO.Matrix).ObliqueOffCenterLHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this.oblique.length, this.oblique.angle, this._computeObliqueDistance(this.oblique.offset), this._projectionMatrix, engine.isNDCHalfZRange);
            else (0, $ha1VO.Matrix).OrthoOffCenterLHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
            this._cache.orthoLeft = this.orthoLeft;
            this._cache.orthoRight = this.orthoRight;
            this._cache.orthoBottom = this.orthoBottom;
            this._cache.orthoTop = this.orthoTop;
            this._cache.obliqueAngle = this.oblique?.angle;
            this._cache.obliqueLength = this.oblique?.length;
            this._cache.obliqueOffset = this.oblique?.offset;
            this._cache.renderWidth = engine.getRenderWidth();
            this._cache.renderHeight = engine.getRenderHeight();
        }
        this.onProjectionMatrixChangedObservable.notifyObservers(this);
        return this._projectionMatrix;
    }
    /**
     * Gets the transformation matrix (ie. the multiplication of view by projection matrices)
     * @returns a Matrix
     */ getTransformationMatrix() {
        this._computedViewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
        return this._transformMatrix;
    }
    _computeObliqueDistance(offset) {
        const arcRotateCamera = this;
        const targetCamera = this;
        return (arcRotateCamera.radius || (targetCamera.target ? (0, $ha1VO.Vector3).Distance(this.position, targetCamera.target) : this.position.length())) + offset;
    }
    /** @internal */ _updateFrustumPlanes() {
        if (!this._refreshFrustumPlanes) return;
        this.getTransformationMatrix();
        if (!this._frustumPlanes) this._frustumPlanes = (0, $9sPMJ.Frustum).GetPlanes(this._transformMatrix);
        else (0, $9sPMJ.Frustum).GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
        this._refreshFrustumPlanes = false;
    }
    /**
     * Checks if a cullable object (mesh...) is in the camera frustum
     * This checks the bounding box center. See isCompletelyInFrustum for a full bounding check
     * @param target The object to check
     * @param checkRigCameras If the rig cameras should be checked (eg. with VR camera both eyes should be checked) (Default: false)
     * @returns true if the object is in frustum otherwise false
     */ isInFrustum(target, checkRigCameras = false) {
        this._updateFrustumPlanes();
        if (checkRigCameras && this.rigCameras.length > 0) {
            let result = false;
            this.rigCameras.forEach((cam)=>{
                cam._updateFrustumPlanes();
                result = result || target.isInFrustum(cam._frustumPlanes);
            });
            return result;
        } else return target.isInFrustum(this._frustumPlanes);
    }
    /**
     * Checks if a cullable object (mesh...) is in the camera frustum
     * Unlike isInFrustum this checks the full bounding box
     * @param target The object to check
     * @returns true if the object is in frustum otherwise false
     */ isCompletelyInFrustum(target) {
        this._updateFrustumPlanes();
        return target.isCompletelyInFrustum(this._frustumPlanes);
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Gets a ray in the forward direction from the camera.
     * @param length Defines the length of the ray to create
     * @param transform Defines the transform to apply to the ray, by default the world matrix is used to create a workd space ray
     * @param origin Defines the start point of the ray which defaults to the camera position
     * @returns the forward ray
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getForwardRay(length = 100, transform, origin) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Gets a ray in the forward direction from the camera.
     * @param refRay the ray to (re)use when setting the values
     * @param length Defines the length of the ray to create
     * @param transform Defines the transform to apply to the ray, by default the world matrx is used to create a workd space ray
     * @param origin Defines the start point of the ray which defaults to the camera position
     * @returns the forward ray
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getForwardRayToRef(refRay, length = 100, transform, origin) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        // Observables
        this.onViewMatrixChangedObservable.clear();
        this.onProjectionMatrixChangedObservable.clear();
        this.onAfterCheckInputsObservable.clear();
        this.onRestoreStateObservable.clear();
        // Inputs
        if (this.inputs) this.inputs.clear();
        // Animations
        this.getScene().stopAnimation(this);
        // Remove from scene
        this.getScene().removeCamera(this);
        while(this._rigCameras.length > 0){
            const camera = this._rigCameras.pop();
            if (camera) camera.dispose();
        }
        if (this._parentContainer) {
            const index = this._parentContainer.cameras.indexOf(this);
            if (index > -1) this._parentContainer.cameras.splice(index, 1);
            this._parentContainer = null;
        }
        // Postprocesses
        if (this._rigPostProcess) {
            this._rigPostProcess.dispose(this);
            this._rigPostProcess = null;
            this._postProcesses.length = 0;
        } else if (this.cameraRigMode !== $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE) {
            this._rigPostProcess = null;
            this._postProcesses.length = 0;
        } else {
            let i = this._postProcesses.length;
            while(--i >= 0){
                const postProcess = this._postProcesses[i];
                if (postProcess) postProcess.dispose(this);
            }
        }
        // Render targets
        let i = this.customRenderTargets.length;
        while(--i >= 0)this.customRenderTargets[i].dispose();
        this.customRenderTargets.length = 0;
        // Active Meshes
        this._activeMeshes.dispose();
        this.getScene().getEngine().releaseRenderPassId(this.renderPassId);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * Gets the left camera of a rig setup in case of Rigged Camera
     */ get isLeftCamera() {
        return this._isLeftCamera;
    }
    /**
     * Gets the right camera of a rig setup in case of Rigged Camera
     */ get isRightCamera() {
        return this._isRightCamera;
    }
    /**
     * Gets the left camera of a rig setup in case of Rigged Camera
     */ get leftCamera() {
        if (this._rigCameras.length < 1) return null;
        return this._rigCameras[0];
    }
    /**
     * Gets the right camera of a rig setup in case of Rigged Camera
     */ get rightCamera() {
        if (this._rigCameras.length < 2) return null;
        return this._rigCameras[1];
    }
    /**
     * Gets the left camera target of a rig setup in case of Rigged Camera
     * @returns the target position
     */ getLeftTarget() {
        if (this._rigCameras.length < 1) return null;
        return this._rigCameras[0].getTarget();
    }
    /**
     * Gets the right camera target of a rig setup in case of Rigged Camera
     * @returns the target position
     */ getRightTarget() {
        if (this._rigCameras.length < 2) return null;
        return this._rigCameras[1].getTarget();
    }
    /**
     * @internal
     */ setCameraRigMode(mode, rigParams) {
        if (this.cameraRigMode === mode) return;
        while(this._rigCameras.length > 0){
            const camera = this._rigCameras.pop();
            if (camera) camera.dispose();
        }
        this.cameraRigMode = mode;
        this._cameraRigParams = {};
        //we have to implement stereo camera calcultating left and right viewpoints from interaxialDistance and target,
        //not from a given angle as it is now, but until that complete code rewriting provisional stereoHalfAngle value is introduced
        this._cameraRigParams.interaxialDistance = rigParams.interaxialDistance || 0.0637;
        this._cameraRigParams.stereoHalfAngle = (0, $bOhSV.Tools).ToRadians(this._cameraRigParams.interaxialDistance / 0.0637);
        // create the rig cameras, unless none
        if (this.cameraRigMode !== $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE) {
            const leftCamera = this.createRigCamera(this.name + "_L", 0);
            if (leftCamera) leftCamera._isLeftCamera = true;
            const rightCamera = this.createRigCamera(this.name + "_R", 1);
            if (rightCamera) rightCamera._isRightCamera = true;
            if (leftCamera && rightCamera) {
                this._rigCameras.push(leftCamera);
                this._rigCameras.push(rightCamera);
            }
        }
        this._setRigMode(rigParams);
        this._cascadePostProcessesToRigCams();
        this.update();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _setRigMode(rigParams) {
    // no-op
    }
    /** @internal */ _getVRProjectionMatrix() {
        (0, $ha1VO.Matrix).PerspectiveFovLHToRef(this._cameraRigParams.vrMetrics.aspectRatioFov, this._cameraRigParams.vrMetrics.aspectRatio, this.minZ, this.maxZ, this._cameraRigParams.vrWorkMatrix, true, this.getEngine().isNDCHalfZRange);
        this._cameraRigParams.vrWorkMatrix.multiplyToRef(this._cameraRigParams.vrHMatrix, this._projectionMatrix);
        return this._projectionMatrix;
    }
    /**
     * @internal
     */ setCameraRigParameter(name, value) {
        if (!this._cameraRigParams) this._cameraRigParams = {};
        this._cameraRigParams[name] = value;
        //provisionnally:
        if (name === "interaxialDistance") this._cameraRigParams.stereoHalfAngle = (0, $bOhSV.Tools).ToRadians(value / 0.0637);
    }
    /**
     * needs to be overridden by children so sub has required properties to be copied
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createRigCamera(name, cameraIndex) {
        return null;
    }
    /**
     * May need to be overridden by children
     * @internal
     */ _updateRigCameras() {
        for(let i = 0; i < this._rigCameras.length; i++){
            this._rigCameras[i].minZ = this.minZ;
            this._rigCameras[i].maxZ = this.maxZ;
            this._rigCameras[i].fov = this.fov;
            this._rigCameras[i].upVector.copyFrom(this.upVector);
        }
        // only update viewport when ANAGLYPH
        if (this.cameraRigMode === $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_ANAGLYPH) this._rigCameras[0].viewport = this._rigCameras[1].viewport = this.viewport;
    }
    /** @internal */ _setupInputs() {}
    /**
     * Serialiaze the camera setup to a json representation
     * @returns the JSON representation
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.uniqueId = this.uniqueId;
        // Type
        serializationObject.type = this.getClassName();
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        if (this.inputs) this.inputs.serialize(serializationObject);
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        serializationObject.isEnabled = this.isEnabled();
        return serializationObject;
    }
    /**
     * Clones the current camera.
     * @param name The cloned camera name
     * @param newParent The cloned camera's new parent (none by default)
     * @returns the cloned camera
     */ clone(name, newParent = null) {
        const camera = (0, $6Ho1L.SerializationHelper).Clone($52736139c8513fb2$export$79f141de891a5fed.GetConstructorFromName(this.getClassName(), name, this.getScene(), this.interaxialDistance, this.isStereoscopicSideBySide), this);
        camera.name = name;
        camera.parent = newParent;
        this.onClonedObservable.notifyObservers(camera);
        return camera;
    }
    /**
     * Gets the direction of the camera relative to a given local axis.
     * @param localAxis Defines the reference axis to provide a relative direction.
     * @returns the direction
     */ getDirection(localAxis) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getDirectionToRef(localAxis, result);
        return result;
    }
    /**
     * Returns the current camera absolute rotation
     */ get absoluteRotation() {
        this.getWorldMatrix().decompose(undefined, this._absoluteRotation);
        return this._absoluteRotation;
    }
    /**
     * Gets the direction of the camera relative to a given local axis into a passed vector.
     * @param localAxis Defines the reference axis to provide a relative direction.
     * @param result Defines the vector to store the result in
     */ getDirectionToRef(localAxis, result) {
        (0, $ha1VO.Vector3).TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
    }
    /**
     * Gets a camera constructor for a given camera type
     * @param type The type of the camera to construct (should be equal to one of the camera class name)
     * @param name The name of the camera the result will be able to instantiate
     * @param scene The scene the result will construct the camera in
     * @param interaxial_distance In case of stereoscopic setup, the distance between both eyes
     * @param isStereoscopicSideBySide In case of stereoscopic setup, should the sereo be side b side
     * @returns a factory method to construct the camera
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static GetConstructorFromName(type, name, scene, interaxial_distance = 0, isStereoscopicSideBySide = true) {
        const constructorFunc = (0, $021dcb6a570ae9c1$export$85c928794f8d04d4).Construct(type, name, scene, {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            interaxial_distance: interaxial_distance,
            isStereoscopicSideBySide: isStereoscopicSideBySide
        });
        if (constructorFunc) return constructorFunc;
        // Default to universal camera
        return ()=>$52736139c8513fb2$export$79f141de891a5fed._CreateDefaultParsedCamera(name, scene);
    }
    /**
     * Compute the world  matrix of the camera.
     * @returns the camera world matrix
     */ computeWorldMatrix() {
        return this.getWorldMatrix();
    }
    /**
     * Parse a JSON and creates the camera from the parsed information
     * @param parsedCamera The JSON to parse
     * @param scene The scene to instantiate the camera in
     * @returns the newly constructed camera
     */ static Parse(parsedCamera, scene) {
        const type = parsedCamera.type;
        const construct = $52736139c8513fb2$export$79f141de891a5fed.GetConstructorFromName(type, parsedCamera.name, scene, parsedCamera.interaxial_distance, parsedCamera.isStereoscopicSideBySide);
        const camera = (0, $6Ho1L.SerializationHelper).Parse(construct, parsedCamera, scene);
        // Parent
        if (parsedCamera.parentId !== undefined) camera._waitingParentId = parsedCamera.parentId;
        // Parent instance index
        if (parsedCamera.parentInstanceIndex !== undefined) camera._waitingParentInstanceIndex = parsedCamera.parentInstanceIndex;
        //If camera has an input manager, let it parse inputs settings
        if (camera.inputs) {
            camera.inputs.parse(parsedCamera);
            camera._setupInputs();
        }
        if (parsedCamera.upVector) camera.upVector = (0, $ha1VO.Vector3).FromArray(parsedCamera.upVector); // need to force the upVector
        if (camera.setPosition) {
            // need to force position
            camera.position.copyFromFloats(0, 0, 0);
            camera.setPosition((0, $ha1VO.Vector3).FromArray(parsedCamera.position));
        }
        // Target
        if (parsedCamera.target) {
            if (camera.setTarget) camera.setTarget((0, $ha1VO.Vector3).FromArray(parsedCamera.target));
        }
        // Apply 3d rig, when found
        if (parsedCamera.cameraRigMode) {
            const rigParams = parsedCamera.interaxial_distance ? {
                interaxialDistance: parsedCamera.interaxial_distance
            } : {};
            camera.setCameraRigMode(parsedCamera.cameraRigMode, rigParams);
        }
        // Animations
        if (parsedCamera.animations) {
            for(let animationIndex = 0; animationIndex < parsedCamera.animations.length; animationIndex++){
                const parsedAnimation = parsedCamera.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) camera.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $021dcb6a570ae9c1$export$85c928794f8d04d4).ParseAnimationRanges(camera, parsedCamera, scene);
        }
        if (parsedCamera.autoAnimate) scene.beginAnimation(camera, parsedCamera.autoAnimateFrom, parsedCamera.autoAnimateTo, parsedCamera.autoAnimateLoop, parsedCamera.autoAnimateSpeed || 1.0);
        // Check if isEnabled is defined to be back compatible with prior serialized versions.
        if (parsedCamera.isEnabled !== undefined) camera.setEnabled(parsedCamera.isEnabled);
        return camera;
    }
    /** @internal */ _calculateHandednessMultiplier() {
        let handednessMultiplier = this.getScene().useRightHandedSystem ? -1 : 1;
        if (this.parent && this.parent._getWorldMatrixDeterminant() < 0) handednessMultiplier *= -1;
        return handednessMultiplier;
    }
}
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$52736139c8513fb2$export$79f141de891a5fed._CreateDefaultParsedCamera = (name, scene)=>{
    throw (0, $dUFYy._WarnImport)("UniversalCamera");
};
/**
 * This is the default projection mode used by the cameras.
 * It helps recreating a feeling of perspective and better appreciate depth.
 * This is the best way to simulate real life cameras.
 */ $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA = 0;
/**
 * This helps creating camera with an orthographic mode.
 * Orthographic is commonly used in engineering as a means to produce object specifications that communicate dimensions unambiguously, each line of 1 unit length (cm, meter..whatever) will appear to have the same length everywhere on the drawing. This allows the drafter to dimension only a subset of lines and let the reader know that other lines of that length on the drawing are also that length in reality. Every parallel line in the drawing is also parallel in the object.
 */ $52736139c8513fb2$export$79f141de891a5fed.ORTHOGRAPHIC_CAMERA = 1;
/**
 * This is the default FOV mode for perspective cameras.
 * This setting aligns the upper and lower bounds of the viewport to the upper and lower bounds of the camera frustum.
 */ $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED = 0;
/**
 * This setting aligns the left and right bounds of the viewport to the left and right bounds of the camera frustum.
 */ $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_HORIZONTAL_FIXED = 1;
/**
 * This specifies there is no need for a camera rig.
 * Basically only one eye is rendered corresponding to the camera.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE = 0;
/**
 * Simulates a camera Rig with one blue eye and one red eye.
 * This can be use with 3d blue and red glasses.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
/**
 * Defines that both eyes of the camera will be rendered side by side with a parallel target.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
/**
 * Defines that both eyes of the camera will be rendered side by side with a none parallel target.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
/**
 * Defines that both eyes of the camera will be rendered over under each other.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
/**
 * Defines that both eyes of the camera will be rendered on successive lines interlaced for passive 3d monitors.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
/**
 * Defines that both eyes of the camera should be renderered in a VR mode (carbox).
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_VR = 20;
/**
 * Custom rig mode allowing rig cameras to be populated manually with any number of cameras
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_CUSTOM = 22;
/**
 * Defines if by default attaching controls should prevent the default javascript event to continue.
 */ $52736139c8513fb2$export$79f141de891a5fed.ForceAttachControlToAlwaysPreventDefault = false;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("position")
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "_position", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("upVector")
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "_upVector", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoRight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoBottom", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "fov", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "projectionPlaneTilt", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "minZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "maxZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "inertia", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "mode", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "layerMask", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "fovMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "cameraRigMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "interaxialDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "isStereoscopicSideBySide", void 0);



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");


var $b4i1f = parcelRequire("b4i1f");

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $dUFYy = parcelRequire("dUFYy");

var $7etnY = parcelRequire("7etnY");

var $kVtWi = parcelRequire("kVtWi");

var $ir0rz = parcelRequire("ir0rz");


var $1FkG9 = parcelRequire("1FkG9");

class $4014d881db0e9bc6$export$f5240a0ce3a46ac1 {
}
class $4014d881db0e9bc6$export$8570d39351855acb {
    /**
     * Creates a new VertexData
     */ constructor(){
        /**
         * Gets the unique ID of this vertex Data
         */ this.uniqueId = 0;
        /**
         * Metadata used to store contextual values
         */ this.metadata = {};
        this._applyTo = (0, $391b8c7fee050f1f$export$7241269ae9cbc8ee)(this._applyToCoroutine.bind(this));
        this.uniqueId = $4014d881db0e9bc6$export$8570d39351855acb._UniqueIDGenerator;
        $4014d881db0e9bc6$export$8570d39351855acb._UniqueIDGenerator++;
    }
    /**
     * Uses the passed data array to set the set the values for the specified kind of data
     * @param data a linear array of floating numbers
     * @param kind the type of data that is being set, eg positions, colors etc
     */ set(data, kind) {
        if (!data.length) (0, $kVtWi.Logger).Warn(`Setting vertex data kind '${kind}' with an empty array`);
        switch(kind){
            case (0, $b4i1f.VertexBuffer).PositionKind:
                this.positions = data;
                break;
            case (0, $b4i1f.VertexBuffer).NormalKind:
                this.normals = data;
                break;
            case (0, $b4i1f.VertexBuffer).TangentKind:
                this.tangents = data;
                break;
            case (0, $b4i1f.VertexBuffer).UVKind:
                this.uvs = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV2Kind:
                this.uvs2 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV3Kind:
                this.uvs3 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV4Kind:
                this.uvs4 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV5Kind:
                this.uvs5 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV6Kind:
                this.uvs6 = data;
                break;
            case (0, $b4i1f.VertexBuffer).ColorKind:
                this.colors = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesIndicesKind:
                this.matricesIndices = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesWeightsKind:
                this.matricesWeights = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind:
                this.matricesIndicesExtra = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind:
                this.matricesWeightsExtra = data;
                break;
        }
    }
    /**
     * Associates the vertexData to the passed Mesh.
     * Sets it as updatable or not (default `false`)
     * @param mesh the mesh the vertexData is applied to
     * @param updatable when used and having the value true allows new data to update the vertexData
     * @returns the VertexData
     */ applyToMesh(mesh, updatable) {
        this._applyTo(mesh, updatable, false);
        return this;
    }
    /**
     * Associates the vertexData to the passed Geometry.
     * Sets it as updatable or not (default `false`)
     * @param geometry the geometry the vertexData is applied to
     * @param updatable when used and having the value true allows new data to update the vertexData
     * @returns VertexData
     */ applyToGeometry(geometry, updatable) {
        this._applyTo(geometry, updatable, false);
        return this;
    }
    /**
     * Updates the associated mesh
     * @param mesh the mesh to be updated
     * @returns VertexData
     */ updateMesh(mesh) {
        this._update(mesh);
        return this;
    }
    /**
     * Updates the associated geometry
     * @param geometry the geometry to be updated
     * @returns VertexData.
     */ updateGeometry(geometry) {
        this._update(geometry);
        return this;
    }
    /**
     * @internal
     */ *_applyToCoroutine(meshOrGeometry, updatable = false, isAsync) {
        if (this.positions) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this.positions, updatable);
            if (isAsync) yield;
        }
        if (this.normals) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, this.normals, updatable);
            if (isAsync) yield;
        }
        if (this.tangents) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, this.tangents, updatable);
            if (isAsync) yield;
        }
        if (this.uvs) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, this.uvs, updatable);
            if (isAsync) yield;
        }
        if (this.uvs2) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, this.uvs2, updatable);
            if (isAsync) yield;
        }
        if (this.uvs3) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, this.uvs3, updatable);
            if (isAsync) yield;
        }
        if (this.uvs4) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, this.uvs4, updatable);
            if (isAsync) yield;
        }
        if (this.uvs5) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, this.uvs5, updatable);
            if (isAsync) yield;
        }
        if (this.uvs6) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, this.uvs6, updatable);
            if (isAsync) yield;
        }
        if (this.colors) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, this.colors, updatable);
            if (this.hasVertexAlpha && meshOrGeometry.hasVertexAlpha !== undefined) meshOrGeometry.hasVertexAlpha = true;
            if (isAsync) yield;
        }
        if (this.matricesIndices) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, this.matricesIndices, updatable);
            if (isAsync) yield;
        }
        if (this.matricesWeights) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, this.matricesWeights, updatable);
            if (isAsync) yield;
        }
        if (this.matricesIndicesExtra) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, this.matricesIndicesExtra, updatable);
            if (isAsync) yield;
        }
        if (this.matricesWeightsExtra) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, this.matricesWeightsExtra, updatable);
            if (isAsync) yield;
        }
        if (this.indices) {
            meshOrGeometry.setIndices(this.indices, null, updatable);
            if (isAsync) yield;
        } else meshOrGeometry.setIndices([], null);
        if (meshOrGeometry.subMeshes && this.materialInfos && this.materialInfos.length > 1) {
            const mesh = meshOrGeometry;
            mesh.subMeshes = [];
            for (const matInfo of this.materialInfos)new (0, $fc3ab70ba5c9f506$export$c684db7d654df572)(matInfo.materialIndex, matInfo.verticesStart, matInfo.verticesCount, matInfo.indexStart, matInfo.indexCount, mesh);
        }
        return this;
    }
    _update(meshOrGeometry, updateExtends, makeItUnique) {
        if (this.positions) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this.positions, updateExtends, makeItUnique);
        if (this.normals) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, this.normals, updateExtends, makeItUnique);
        if (this.tangents) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).TangentKind, this.tangents, updateExtends, makeItUnique);
        if (this.uvs) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, this.uvs, updateExtends, makeItUnique);
        if (this.uvs2) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, this.uvs2, updateExtends, makeItUnique);
        if (this.uvs3) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, this.uvs3, updateExtends, makeItUnique);
        if (this.uvs4) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, this.uvs4, updateExtends, makeItUnique);
        if (this.uvs5) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, this.uvs5, updateExtends, makeItUnique);
        if (this.uvs6) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, this.uvs6, updateExtends, makeItUnique);
        if (this.colors) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, this.colors, updateExtends, makeItUnique);
        if (this.matricesIndices) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, this.matricesIndices, updateExtends, makeItUnique);
        if (this.matricesWeights) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, this.matricesWeights, updateExtends, makeItUnique);
        if (this.matricesIndicesExtra) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, this.matricesIndicesExtra, updateExtends, makeItUnique);
        if (this.matricesWeightsExtra) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, this.matricesWeightsExtra, updateExtends, makeItUnique);
        if (this.indices) meshOrGeometry.setIndices(this.indices, null);
        return this;
    }
    static _TransformVector3Coordinates(coordinates, transformation, offset = 0, length = coordinates.length) {
        const coordinate = (0, $ha1VO.TmpVectors).Vector3[0];
        const transformedCoordinate = (0, $ha1VO.TmpVectors).Vector3[1];
        for(let index = offset; index < offset + length; index += 3){
            (0, $ha1VO.Vector3).FromArrayToRef(coordinates, index, coordinate);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(coordinate, transformation, transformedCoordinate);
            coordinates[index] = transformedCoordinate.x;
            coordinates[index + 1] = transformedCoordinate.y;
            coordinates[index + 2] = transformedCoordinate.z;
        }
    }
    static _TransformVector3Normals(normals, transformation, offset = 0, length = normals.length) {
        const normal = (0, $ha1VO.TmpVectors).Vector3[0];
        const transformedNormal = (0, $ha1VO.TmpVectors).Vector3[1];
        for(let index = offset; index < offset + length; index += 3){
            (0, $ha1VO.Vector3).FromArrayToRef(normals, index, normal);
            (0, $ha1VO.Vector3).TransformNormalToRef(normal, transformation, transformedNormal);
            normals[index] = transformedNormal.x;
            normals[index + 1] = transformedNormal.y;
            normals[index + 2] = transformedNormal.z;
        }
    }
    static _TransformVector4Normals(normals, transformation, offset = 0, length = normals.length) {
        const normal = (0, $ha1VO.TmpVectors).Vector4[0];
        const transformedNormal = (0, $ha1VO.TmpVectors).Vector4[1];
        for(let index = offset; index < offset + length; index += 4){
            (0, $ha1VO.Vector4).FromArrayToRef(normals, index, normal);
            (0, $ha1VO.Vector4).TransformNormalToRef(normal, transformation, transformedNormal);
            normals[index] = transformedNormal.x;
            normals[index + 1] = transformedNormal.y;
            normals[index + 2] = transformedNormal.z;
            normals[index + 3] = transformedNormal.w;
        }
    }
    static _FlipFaces(indices, offset = 0, length = indices.length) {
        for(let index = offset; index < offset + length; index += 3){
            const tmp = indices[index + 1];
            indices[index + 1] = indices[index + 2];
            indices[index + 2] = tmp;
        }
    }
    /**
     * Transforms each position and each normal of the vertexData according to the passed Matrix
     * @param matrix the transforming matrix
     * @returns the VertexData
     */ transform(matrix) {
        const flip = matrix.determinant() < 0;
        if (this.positions) $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Coordinates(this.positions, matrix);
        if (this.normals) $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Normals(this.normals, matrix);
        if (this.tangents) $4014d881db0e9bc6$export$8570d39351855acb._TransformVector4Normals(this.tangents, matrix);
        if (flip && this.indices) $4014d881db0e9bc6$export$8570d39351855acb._FlipFaces(this.indices);
        return this;
    }
    /**
     * Generates an array of vertex data where each vertex data only has one material info
     * @returns An array of VertexData
     */ splitBasedOnMaterialID() {
        if (!this.materialInfos || this.materialInfos.length < 2) return [
            this
        ];
        const result = [];
        for (const materialInfo of this.materialInfos){
            const vertexData = new $4014d881db0e9bc6$export$8570d39351855acb();
            if (this.positions) vertexData.positions = this.positions.slice(materialInfo.verticesStart * 3, (materialInfo.verticesCount + materialInfo.verticesStart) * 3);
            if (this.normals) vertexData.normals = this.normals.slice(materialInfo.verticesStart * 3, (materialInfo.verticesCount + materialInfo.verticesStart) * 3);
            if (this.tangents) vertexData.tangents = this.tangents.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.colors) vertexData.colors = this.colors.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.uvs) vertexData.uvs = this.uvs.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs2) vertexData.uvs2 = this.uvs2.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs3) vertexData.uvs3 = this.uvs3.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs4) vertexData.uvs4 = this.uvs4.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs5) vertexData.uvs5 = this.uvs5.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs6) vertexData.uvs6 = this.uvs6.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.matricesIndices) vertexData.matricesIndices = this.matricesIndices.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.matricesIndicesExtra) vertexData.matricesIndicesExtra = this.matricesIndicesExtra.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.matricesWeights) vertexData.matricesWeights = this.matricesWeights.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.matricesWeightsExtra) vertexData.matricesWeightsExtra = this.matricesWeightsExtra.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.indices) {
                vertexData.indices = [];
                for(let index = materialInfo.indexStart; index < materialInfo.indexStart + materialInfo.indexCount; index++)vertexData.indices.push(this.indices[index] - materialInfo.verticesStart);
            }
            const newMaterialInfo = new $4014d881db0e9bc6$export$f5240a0ce3a46ac1();
            newMaterialInfo.indexStart = 0;
            newMaterialInfo.indexCount = vertexData.indices ? vertexData.indices.length : 0;
            newMaterialInfo.materialIndex = materialInfo.materialIndex;
            newMaterialInfo.verticesStart = 0;
            newMaterialInfo.verticesCount = (vertexData.positions ? vertexData.positions.length : 0) / 3;
            vertexData.materialInfos = [
                newMaterialInfo
            ];
            result.push(vertexData);
        }
        return result;
    }
    /**
     * Merges the passed VertexData into the current one
     * @param others the VertexData to be merged into the current one
     * @param use32BitsIndices defines a boolean indicating if indices must be store in a 32 bits array
     * @param forceCloneIndices defines a boolean indicating if indices are forced to be cloned
     * @param mergeMaterialIds defines a boolean indicating if we need to merge the material infos
     * @param enableCompletion defines a boolean indicating if the vertex data should be completed to be compatible
     * @returns the modified VertexData
     */ merge(others, use32BitsIndices = false, forceCloneIndices = false, mergeMaterialIds = false, enableCompletion = false) {
        const vertexDatas = Array.isArray(others) ? others.map((other)=>{
            return {
                vertexData: other
            };
        }) : [
            {
                vertexData: others
            }
        ];
        return (0, $391b8c7fee050f1f$export$47bff35b05234608)(this._mergeCoroutine(undefined, vertexDatas, use32BitsIndices, false, forceCloneIndices, mergeMaterialIds, enableCompletion));
    }
    /**
     * @internal
     */ *_mergeCoroutine(transform, vertexDatas, use32BitsIndices = false, isAsync, forceCloneIndices, mergeMaterialIds = false, enableCompletion = false) {
        this._validate();
        let others = vertexDatas.map((vertexData)=>vertexData.vertexData);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let root = this;
        if (enableCompletion) // First let's make sure we have the max set of attributes on the main vertex data
        for (const other of others){
            if (!other) continue;
            other._validate();
            if (!this.normals && other.normals) this.normals = new Float32Array(this.positions.length);
            if (!this.tangents && other.tangents) this.tangents = new Float32Array(this.positions.length / 3 * 4);
            if (!this.uvs && other.uvs) this.uvs = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs2 && other.uvs2) this.uvs2 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs3 && other.uvs3) this.uvs3 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs4 && other.uvs4) this.uvs4 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs5 && other.uvs5) this.uvs5 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs6 && other.uvs6) this.uvs6 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.colors && other.colors) {
                this.colors = new Float32Array(this.positions.length / 3 * 4);
                this.colors.fill(1); // Set to white by default
            }
            if (!this.matricesIndices && other.matricesIndices) this.matricesIndices = new Float32Array(this.positions.length / 3 * 4);
            if (!this.matricesWeights && other.matricesWeights) this.matricesWeights = new Float32Array(this.positions.length / 3 * 4);
            if (!this.matricesIndicesExtra && other.matricesIndicesExtra) this.matricesIndicesExtra = new Float32Array(this.positions.length / 3 * 4);
            if (!this.matricesWeightsExtra && other.matricesWeightsExtra) this.matricesWeightsExtra = new Float32Array(this.positions.length / 3 * 4);
        }
        for (const other of others){
            if (!other) continue;
            if (!enableCompletion) {
                other._validate();
                if (!this.normals !== !other.normals || !this.tangents !== !other.tangents || !this.uvs !== !other.uvs || !this.uvs2 !== !other.uvs2 || !this.uvs3 !== !other.uvs3 || !this.uvs4 !== !other.uvs4 || !this.uvs5 !== !other.uvs5 || !this.uvs6 !== !other.uvs6 || !this.colors !== !other.colors || !this.matricesIndices !== !other.matricesIndices || !this.matricesWeights !== !other.matricesWeights || !this.matricesIndicesExtra !== !other.matricesIndicesExtra || !this.matricesWeightsExtra !== !other.matricesWeightsExtra) throw new Error("Cannot merge vertex data that do not have the same set of attributes");
            } else {
                // Align the others with main set of attributes
                if (this.normals && !other.normals) other.normals = new Float32Array(other.positions.length);
                if (this.tangents && !other.tangents) other.tangents = new Float32Array(other.positions.length / 3 * 4);
                if (this.uvs && !other.uvs) other.uvs = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs2 && !other.uvs2) other.uvs2 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs3 && !other.uvs3) other.uvs3 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs4 && !other.uvs4) other.uvs4 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs5 && !other.uvs5) other.uvs5 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs6 && !other.uvs6) other.uvs6 = new Float32Array(other.positions.length / 3 * 2);
                if (this.colors && !other.colors) {
                    other.colors = new Float32Array(other.positions.length / 3 * 4);
                    other.colors.fill(1); // Set to white by default
                }
                if (this.matricesIndices && !other.matricesIndices) other.matricesIndices = new Float32Array(other.positions.length / 3 * 4);
                if (this.matricesWeights && !other.matricesWeights) other.matricesWeights = new Float32Array(other.positions.length / 3 * 4);
                if (this.matricesIndicesExtra && !other.matricesIndicesExtra) other.matricesIndicesExtra = new Float32Array(other.positions.length / 3 * 4);
                if (this.matricesWeightsExtra && !other.matricesWeightsExtra) other.matricesWeightsExtra = new Float32Array(other.positions.length / 3 * 4);
            }
        }
        if (mergeMaterialIds) {
            // Merge material infos
            let materialIndex = 0;
            let indexOffset = 0;
            let vertexOffset = 0;
            const materialInfos = [];
            let currentMaterialInfo = null;
            const vertexDataList = [];
            // We need to split vertexData with more than one materialInfo
            for (const split of this.splitBasedOnMaterialID())vertexDataList.push({
                vertexData: split,
                transform: transform
            });
            for (const data of vertexDatas){
                if (!data.vertexData) continue;
                for (const split of data.vertexData.splitBasedOnMaterialID())vertexDataList.push({
                    vertexData: split,
                    transform: data.transform
                });
            }
            // Sort by material IDs
            vertexDataList.sort((a, b)=>{
                const matInfoA = a.vertexData.materialInfos ? a.vertexData.materialInfos[0].materialIndex : 0;
                const matInfoB = b.vertexData.materialInfos ? b.vertexData.materialInfos[0].materialIndex : 0;
                if (matInfoA > matInfoB) return 1;
                if (matInfoA === matInfoB) return 0;
                return -1;
            });
            // Build the new material info
            for (const vertexDataSource of vertexDataList){
                const vertexData = vertexDataSource.vertexData;
                if (vertexData.materialInfos) materialIndex = vertexData.materialInfos[0].materialIndex;
                else materialIndex = 0;
                if (currentMaterialInfo && currentMaterialInfo.materialIndex === materialIndex) {
                    currentMaterialInfo.indexCount += vertexData.indices.length;
                    currentMaterialInfo.verticesCount += vertexData.positions.length / 3;
                } else {
                    const materialInfo = new $4014d881db0e9bc6$export$f5240a0ce3a46ac1();
                    materialInfo.materialIndex = materialIndex;
                    materialInfo.indexStart = indexOffset;
                    materialInfo.indexCount = vertexData.indices.length;
                    materialInfo.verticesStart = vertexOffset;
                    materialInfo.verticesCount = vertexData.positions.length / 3;
                    materialInfos.push(materialInfo);
                    currentMaterialInfo = materialInfo;
                }
                indexOffset += vertexData.indices.length;
                vertexOffset += vertexData.positions.length / 3;
            }
            // Extract sorted values
            const first = vertexDataList.splice(0, 1)[0];
            root = first.vertexData;
            transform = first.transform;
            others = vertexDataList.map((v)=>v.vertexData);
            vertexDatas = vertexDataList;
            this.materialInfos = materialInfos;
        }
        // Merge geometries
        const totalIndices = others.reduce((indexSum, vertexData)=>indexSum + (vertexData.indices?.length ?? 0), root.indices?.length ?? 0);
        const sliceIndices = forceCloneIndices || others.some((vertexData)=>vertexData.indices === root.indices);
        let indices = sliceIndices ? root.indices?.slice() : root.indices;
        if (totalIndices > 0) {
            let indicesOffset = indices?.length ?? 0;
            if (!indices) indices = new Array(totalIndices);
            if (indices.length !== totalIndices) {
                if (Array.isArray(indices)) indices.length = totalIndices;
                else {
                    const temp = use32BitsIndices || indices instanceof Uint32Array ? new Uint32Array(totalIndices) : new Uint16Array(totalIndices);
                    temp.set(indices);
                    indices = temp;
                }
                if (transform && transform.determinant() < 0) $4014d881db0e9bc6$export$8570d39351855acb._FlipFaces(indices, 0, indicesOffset);
            }
            let positionsOffset = root.positions ? root.positions.length / 3 : 0;
            for (const { vertexData: other, transform: transform } of vertexDatas)if (other.indices) {
                for(let index = 0; index < other.indices.length; index++)indices[indicesOffset + index] = other.indices[index] + positionsOffset;
                if (transform && transform.determinant() < 0) $4014d881db0e9bc6$export$8570d39351855acb._FlipFaces(indices, indicesOffset, other.indices.length);
                // The call to _validate already checked for positions
                positionsOffset += other.positions.length / 3;
                indicesOffset += other.indices.length;
                if (isAsync) yield;
            }
        }
        this.indices = indices;
        this.positions = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).PositionKind, root.positions, transform, vertexDatas.map((other)=>[
                other.vertexData.positions,
                other.transform
            ]));
        if (isAsync) yield;
        if (root.normals) {
            this.normals = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).NormalKind, root.normals, transform, vertexDatas.map((other)=>[
                    other.vertexData.normals,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.tangents) {
            this.tangents = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).TangentKind, root.tangents, transform, vertexDatas.map((other)=>[
                    other.vertexData.tangents,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs) {
            this.uvs = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UVKind, root.uvs, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs2) {
            this.uvs2 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV2Kind, root.uvs2, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs2,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs3) {
            this.uvs3 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV3Kind, root.uvs3, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs3,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs4) {
            this.uvs4 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV4Kind, root.uvs4, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs4,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs5) {
            this.uvs5 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV5Kind, root.uvs5, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs5,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs6) {
            this.uvs6 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV6Kind, root.uvs6, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs6,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.colors) {
            this.colors = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).ColorKind, root.colors, transform, vertexDatas.map((other)=>[
                    other.vertexData.colors,
                    other.transform
                ]));
            if (root.hasVertexAlpha !== undefined || vertexDatas.some((other)=>other.vertexData.hasVertexAlpha !== undefined)) this.hasVertexAlpha = root.hasVertexAlpha || vertexDatas.some((other)=>other.vertexData.hasVertexAlpha);
            if (isAsync) yield;
        }
        if (root.matricesIndices) {
            this.matricesIndices = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesIndicesKind, root.matricesIndices, transform, vertexDatas.map((other)=>[
                    other.vertexData.matricesIndices,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.matricesWeights) {
            this.matricesWeights = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesWeightsKind, root.matricesWeights, transform, vertexDatas.map((other)=>[
                    other.vertexData.matricesWeights,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.matricesIndicesExtra) {
            this.matricesIndicesExtra = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, root.matricesIndicesExtra, transform, vertexDatas.map((other)=>[
                    other.vertexData.matricesIndicesExtra,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.matricesWeightsExtra) this.matricesWeightsExtra = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, root.matricesWeightsExtra, transform, vertexDatas.map((other)=>[
                other.vertexData.matricesWeightsExtra,
                other.transform
            ]));
        return this;
    }
    static _MergeElement(kind, source, transform, others) {
        const nonNullOthers = others.filter((other)=>other[0] !== null && other[0] !== undefined);
        // If there is no source to copy and no other non-null sources then skip this element.
        if (!source && nonNullOthers.length == 0) return source;
        if (!source) return this._MergeElement(kind, nonNullOthers[0][0], nonNullOthers[0][1], nonNullOthers.slice(1));
        const len = nonNullOthers.reduce((sumLen, elements)=>sumLen + elements[0].length, source.length);
        const transformRange = kind === (0, $b4i1f.VertexBuffer).PositionKind ? $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Coordinates : kind === (0, $b4i1f.VertexBuffer).NormalKind ? $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Normals : kind === (0, $b4i1f.VertexBuffer).TangentKind ? $4014d881db0e9bc6$export$8570d39351855acb._TransformVector4Normals : ()=>{};
        if (source instanceof Float32Array) {
            // use non-loop method when the source is Float32Array
            const ret32 = new Float32Array(len);
            ret32.set(source);
            transform && transformRange(ret32, transform, 0, source.length);
            let offset = source.length;
            for (const [vertexData, transform] of nonNullOthers){
                ret32.set(vertexData, offset);
                transform && transformRange(ret32, transform, offset, vertexData.length);
                offset += vertexData.length;
            }
            return ret32;
        } else {
            // don't use concat as it is super slow, just loop for other cases
            const ret = new Array(len);
            for(let i = 0; i < source.length; i++)ret[i] = source[i];
            transform && transformRange(ret, transform, 0, source.length);
            let offset = source.length;
            for (const [vertexData, transform] of nonNullOthers){
                for(let i = 0; i < vertexData.length; i++)ret[offset + i] = vertexData[i];
                transform && transformRange(ret, transform, offset, vertexData.length);
                offset += vertexData.length;
            }
            return ret;
        }
    }
    _validate() {
        if (!this.positions) throw new (0, $1FkG9.RuntimeError)("Positions are required", (0, $1FkG9.ErrorCodes).MeshInvalidPositionsError);
        const getElementCount = (kind, values)=>{
            const stride = (0, $b4i1f.VertexBuffer).DeduceStride(kind);
            if (values.length % stride !== 0) throw new Error("The " + kind + "s array count must be a multiple of " + stride);
            return values.length / stride;
        };
        const positionsElementCount = getElementCount((0, $b4i1f.VertexBuffer).PositionKind, this.positions);
        const validateElementCount = (kind, values)=>{
            const elementCount = getElementCount(kind, values);
            if (elementCount !== positionsElementCount) throw new Error("The " + kind + "s element count (" + elementCount + ") does not match the positions count (" + positionsElementCount + ")");
        };
        if (this.normals) validateElementCount((0, $b4i1f.VertexBuffer).NormalKind, this.normals);
        if (this.tangents) validateElementCount((0, $b4i1f.VertexBuffer).TangentKind, this.tangents);
        if (this.uvs) validateElementCount((0, $b4i1f.VertexBuffer).UVKind, this.uvs);
        if (this.uvs2) validateElementCount((0, $b4i1f.VertexBuffer).UV2Kind, this.uvs2);
        if (this.uvs3) validateElementCount((0, $b4i1f.VertexBuffer).UV3Kind, this.uvs3);
        if (this.uvs4) validateElementCount((0, $b4i1f.VertexBuffer).UV4Kind, this.uvs4);
        if (this.uvs5) validateElementCount((0, $b4i1f.VertexBuffer).UV5Kind, this.uvs5);
        if (this.uvs6) validateElementCount((0, $b4i1f.VertexBuffer).UV6Kind, this.uvs6);
        if (this.colors) validateElementCount((0, $b4i1f.VertexBuffer).ColorKind, this.colors);
        if (this.matricesIndices) validateElementCount((0, $b4i1f.VertexBuffer).MatricesIndicesKind, this.matricesIndices);
        if (this.matricesWeights) validateElementCount((0, $b4i1f.VertexBuffer).MatricesWeightsKind, this.matricesWeights);
        if (this.matricesIndicesExtra) validateElementCount((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, this.matricesIndicesExtra);
        if (this.matricesWeightsExtra) validateElementCount((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, this.matricesWeightsExtra);
    }
    /**
     * Clone the current vertex data
     * @returns a copy of the current data
     */ clone() {
        const serializationObject = this.serialize();
        return $4014d881db0e9bc6$export$8570d39351855acb.Parse(serializationObject);
    }
    /**
     * Serializes the VertexData
     * @returns a serialized object
     */ serialize() {
        const serializationObject = {};
        if (this.positions) serializationObject.positions = Array.from(this.positions);
        if (this.normals) serializationObject.normals = Array.from(this.normals);
        if (this.tangents) serializationObject.tangents = Array.from(this.tangents);
        if (this.uvs) serializationObject.uvs = Array.from(this.uvs);
        if (this.uvs2) serializationObject.uvs2 = Array.from(this.uvs2);
        if (this.uvs3) serializationObject.uvs3 = Array.from(this.uvs3);
        if (this.uvs4) serializationObject.uvs4 = Array.from(this.uvs4);
        if (this.uvs5) serializationObject.uvs5 = Array.from(this.uvs5);
        if (this.uvs6) serializationObject.uvs6 = Array.from(this.uvs6);
        if (this.colors) {
            serializationObject.colors = Array.from(this.colors);
            serializationObject.hasVertexAlpha = this.hasVertexAlpha;
        }
        if (this.matricesIndices) {
            serializationObject.matricesIndices = Array.from(this.matricesIndices);
            serializationObject.matricesIndices._isExpanded = true;
        }
        if (this.matricesWeights) serializationObject.matricesWeights = Array.from(this.matricesWeights);
        if (this.matricesIndicesExtra) {
            serializationObject.matricesIndicesExtra = Array.from(this.matricesIndicesExtra);
            serializationObject.matricesIndicesExtra._isExpanded = true;
        }
        if (this.matricesWeightsExtra) serializationObject.matricesWeightsExtra = Array.from(this.matricesWeightsExtra);
        serializationObject.indices = Array.from(this.indices);
        if (this.materialInfos) {
            serializationObject.materialInfos = [];
            for (const materialInfo of this.materialInfos){
                const materialInfoSerializationObject = {
                    indexStart: materialInfo.indexStart,
                    indexCount: materialInfo.indexCount,
                    materialIndex: materialInfo.materialIndex,
                    verticesStart: materialInfo.verticesStart,
                    verticesCount: materialInfo.verticesCount
                };
                serializationObject.materialInfos.push(materialInfoSerializationObject);
            }
        }
        return serializationObject;
    }
    // Statics
    /**
     * Extracts the vertexData from a mesh
     * @param mesh the mesh from which to extract the VertexData
     * @param copyWhenShared defines if the VertexData must be cloned when shared between multiple meshes, optional, default false
     * @param forceCopy indicating that the VertexData must be cloned, optional, default false
     * @returns the object VertexData associated to the passed mesh
     */ static ExtractFromMesh(mesh, copyWhenShared, forceCopy) {
        return $4014d881db0e9bc6$export$8570d39351855acb._ExtractFrom(mesh, copyWhenShared, forceCopy);
    }
    /**
     * Extracts the vertexData from the geometry
     * @param geometry the geometry from which to extract the VertexData
     * @param copyWhenShared defines if the VertexData must be cloned when the geometry is shared between multiple meshes, optional, default false
     * @param forceCopy indicating that the VertexData must be cloned, optional, default false
     * @returns the object VertexData associated to the passed mesh
     */ static ExtractFromGeometry(geometry, copyWhenShared, forceCopy) {
        return $4014d881db0e9bc6$export$8570d39351855acb._ExtractFrom(geometry, copyWhenShared, forceCopy);
    }
    static _ExtractFrom(meshOrGeometry, copyWhenShared, forceCopy) {
        const result = new $4014d881db0e9bc6$export$8570d39351855acb();
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) result.positions = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) result.normals = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) result.tangents = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) result.uvs = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UVKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) result.uvs2 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV3Kind)) result.uvs3 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV4Kind)) result.uvs4 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV5Kind)) result.uvs5 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV6Kind)) result.uvs6 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind)) {
            const geometry = meshOrGeometry.geometry || meshOrGeometry;
            const vertexBuffer = geometry.getVertexBuffer((0, $b4i1f.VertexBuffer).ColorKind);
            const colors = geometry.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind, copyWhenShared, forceCopy);
            if (vertexBuffer.getSize() === 3) {
                const newColors = new Float32Array(colors.length * 4 / 3);
                for(let i = 0, j = 0; i < colors.length; i += 3, j += 4){
                    newColors[j] = colors[i];
                    newColors[j + 1] = colors[i + 1];
                    newColors[j + 2] = colors[i + 2];
                    newColors[j + 3] = 1;
                }
                result.colors = newColors;
            } else if (vertexBuffer.getSize() === 4) result.colors = colors;
            else throw new Error(`Unexpected number of color components: ${vertexBuffer.getSize()}`);
        }
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) result.matricesIndices = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) result.matricesWeights = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind)) result.matricesIndicesExtra = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind)) result.matricesWeightsExtra = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, copyWhenShared, forceCopy);
        result.indices = meshOrGeometry.getIndices(copyWhenShared, forceCopy);
        return result;
    }
    /**
     * Creates the VertexData for a Ribbon
     * @param options an object used to set the following optional parameters for the ribbon, required but can be empty
     * * pathArray array of paths, each of which an array of successive Vector3
     * * closeArray creates a seam between the first and the last paths of the pathArray, optional, default false
     * * closePath creates a seam between the first and the last points of each path of the path array, optional, default false
     * * offset a positive integer, only used when pathArray contains a single path (offset = 10 means the point 1 is joined to the point 11), default rounded half size of the pathArray length
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * * invertUV swaps in the U and V coordinates when applying a texture, optional, default false
     * * uvs a linear array, of length 2 * number of vertices, of custom UV values, optional
     * * colors a linear array, of length 4 * number of vertices, of custom color values, optional
     * @returns the VertexData of the ribbon
     * @deprecated use CreateRibbonVertexData instead
     */ static CreateRibbon(options) {
        throw (0, $dUFYy._WarnImport)("ribbonBuilder");
    }
    /**
     * Creates the VertexData for a box
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * size sets the width, height and depth of the box to the value of size, optional default 1
     * * width sets the width (x direction) of the box, overwrites the width set by size, optional, default size
     * * height sets the height (y direction) of the box, overwrites the height set by size, optional, default size
     * * depth sets the depth (z direction) of the box, overwrites the depth set by size, optional, default size
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the box
     * @deprecated Please use CreateBoxVertexData from the BoxBuilder file instead
     */ static CreateBox(options) {
        throw (0, $dUFYy._WarnImport)("boxBuilder");
    }
    /**
     * Creates the VertexData for a tiled box
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * faceTiles sets the pattern, tile size and number of tiles for a face
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @param options.pattern
     * @param options.width
     * @param options.height
     * @param options.depth
     * @param options.tileSize
     * @param options.tileWidth
     * @param options.tileHeight
     * @param options.alignHorizontal
     * @param options.alignVertical
     * @param options.faceUV
     * @param options.faceColors
     * @param options.sideOrientation
     * @returns the VertexData of the box
     * @deprecated Please use CreateTiledBoxVertexData instead
     */ static CreateTiledBox(options) {
        throw (0, $dUFYy._WarnImport)("tiledBoxBuilder");
    }
    /**
     * Creates the VertexData for a tiled plane
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * pattern a limited pattern arrangement depending on the number
     * * tileSize sets the width, height and depth of the tile to the value of size, optional default 1
     * * tileWidth sets the width (x direction) of the tile, overwrites the width set by size, optional, default size
     * * tileHeight sets the height (y direction) of the tile, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the tiled plane
     * @deprecated use CreateTiledPlaneVertexData instead
     */ static CreateTiledPlane(options) {
        throw (0, $dUFYy._WarnImport)("tiledPlaneBuilder");
    }
    /**
     * Creates the VertexData for an ellipsoid, defaults to a sphere
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * segments sets the number of horizontal strips optional, default 32
     * * diameter sets the axes dimensions, diameterX, diameterY and diameterZ to the value of diameter, optional default 1
     * * diameterX sets the diameterX (x direction) of the ellipsoid, overwrites the diameterX set by diameter, optional, default diameter
     * * diameterY sets the diameterY (y direction) of the ellipsoid, overwrites the diameterY set by diameter, optional, default diameter
     * * diameterZ sets the diameterZ (z direction) of the ellipsoid, overwrites the diameterZ set by diameter, optional, default diameter
     * * arc a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the circumference (latitude) given by the arc value, optional, default 1
     * * slice a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the height (latitude) given by the arc value, optional, default 1
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the ellipsoid
     * @deprecated use CreateSphereVertexData instead
     */ static CreateSphere(options) {
        throw (0, $dUFYy._WarnImport)("sphereBuilder");
    }
    /**
     * Creates the VertexData for a cylinder, cone or prism
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * height sets the height (y direction) of the cylinder, optional, default 2
     * * diameterTop sets the diameter of the top of the cone, overwrites diameter,  optional, default diameter
     * * diameterBottom sets the diameter of the bottom of the cone, overwrites diameter,  optional, default diameter
     * * diameter sets the diameter of the top and bottom of the cone, optional default 1
     * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
     * * subdivisions` the number of rings along the cylinder height, optional, default 1
     * * arc a number from 0 to 1, to create an unclosed cylinder based on the fraction of the circumference given by the arc value, optional, default 1
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * hasRings when true makes each subdivision independently treated as a face for faceUV and faceColors, optional, default false
     * * enclose when true closes an open cylinder by adding extra flat faces between the height axis and vertical edges, think cut cake
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the cylinder, cone or prism
     * @deprecated please use CreateCylinderVertexData instead
     */ static CreateCylinder(options) {
        throw (0, $dUFYy._WarnImport)("cylinderBuilder");
    }
    /**
     * Creates the VertexData for a torus
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * diameter the diameter of the torus, optional default 1
     * * thickness the diameter of the tube forming the torus, optional default 0.5
     * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the torus
     * @deprecated use CreateTorusVertexData instead
     */ static CreateTorus(options) {
        throw (0, $dUFYy._WarnImport)("torusBuilder");
    }
    /**
     * Creates the VertexData of the LineSystem
     * @param options an object used to set the following optional parameters for the LineSystem, required but can be empty
     *  - lines an array of lines, each line being an array of successive Vector3
     *  - colors an array of line colors, each of the line colors being an array of successive Color4, one per line point
     * @returns the VertexData of the LineSystem
     * @deprecated use CreateLineSystemVertexData instead
     */ static CreateLineSystem(options) {
        throw (0, $dUFYy._WarnImport)("linesBuilder");
    }
    /**
     * Create the VertexData for a DashedLines
     * @param options an object used to set the following optional parameters for the DashedLines, required but can be empty
     *  - points an array successive Vector3
     *  - dashSize the size of the dashes relative to the dash number, optional, default 3
     *  - gapSize the size of the gap between two successive dashes relative to the dash number, optional, default 1
     *  - dashNb the intended total number of dashes, optional, default 200
     * @returns the VertexData for the DashedLines
     * @deprecated use CreateDashedLinesVertexData instead
     */ static CreateDashedLines(options) {
        throw (0, $dUFYy._WarnImport)("linesBuilder");
    }
    /**
     * Creates the VertexData for a Ground
     * @param options an object used to set the following optional parameters for the Ground, required but can be empty
     *  - width the width (x direction) of the ground, optional, default 1
     *  - height the height (z direction) of the ground, optional, default 1
     *  - subdivisions the number of subdivisions per side, optional, default 1
     * @returns the VertexData of the Ground
     * @deprecated Please use CreateGroundVertexData instead
     */ static CreateGround(options) {
        throw (0, $dUFYy._WarnImport)("groundBuilder");
    }
    /**
     * Creates the VertexData for a TiledGround by subdividing the ground into tiles
     * @param options an object used to set the following optional parameters for the Ground, required but can be empty
     * * xmin the ground minimum X coordinate, optional, default -1
     * * zmin the ground minimum Z coordinate, optional, default -1
     * * xmax the ground maximum X coordinate, optional, default 1
     * * zmax the ground maximum Z coordinate, optional, default 1
     * * subdivisions a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the ground width and height creating 'tiles', default {w: 6, h: 6}
     * * precision a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the tile width and height, default {w: 2, h: 2}
     * @returns the VertexData of the TiledGround
     * @deprecated use CreateTiledGroundVertexData instead
     */ static CreateTiledGround(options) {
        throw (0, $dUFYy._WarnImport)("groundBuilder");
    }
    /**
     * Creates the VertexData of the Ground designed from a heightmap
     * @param options an object used to set the following parameters for the Ground, required and provided by CreateGroundFromHeightMap
     * * width the width (x direction) of the ground
     * * height the height (z direction) of the ground
     * * subdivisions the number of subdivisions per side
     * * minHeight the minimum altitude on the ground, optional, default 0
     * * maxHeight the maximum altitude on the ground, optional default 1
     * * colorFilter the filter to apply to the image pixel colors to compute the height, optional Color3, default (0.3, 0.59, 0.11)
     * * buffer the array holding the image color data
     * * bufferWidth the width of image
     * * bufferHeight the height of image
     * * alphaFilter Remove any data where the alpha channel is below this value, defaults 0 (all data visible)
     * @returns the VertexData of the Ground designed from a heightmap
     * @deprecated use CreateGroundFromHeightMapVertexData instead
     */ static CreateGroundFromHeightMap(options) {
        throw (0, $dUFYy._WarnImport)("groundBuilder");
    }
    /**
     * Creates the VertexData for a Plane
     * @param options an object used to set the following optional parameters for the plane, required but can be empty
     * * size sets the width and height of the plane to the value of size, optional default 1
     * * width sets the width (x direction) of the plane, overwrites the width set by size, optional, default size
     * * height sets the height (y direction) of the plane, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the box
     * @deprecated use CreatePlaneVertexData instead
     */ static CreatePlane(options) {
        throw (0, $dUFYy._WarnImport)("planeBuilder");
    }
    /**
     * Creates the VertexData of the Disc or regular Polygon
     * @param options an object used to set the following optional parameters for the disc, required but can be empty
     * * radius the radius of the disc, optional default 0.5
     * * tessellation the number of polygon sides, optional, default 64
     * * arc a number from 0 to 1, to create an unclosed polygon based on the fraction of the circumference given by the arc value, optional, default 1
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the box
     * @deprecated use CreateDiscVertexData instead
     */ static CreateDisc(options) {
        throw (0, $dUFYy._WarnImport)("discBuilder");
    }
    /**
     * Creates the VertexData for an irregular Polygon in the XoZ plane using a mesh built by polygonTriangulation.build()
     * All parameters are provided by CreatePolygon as needed
     * @param polygon a mesh built from polygonTriangulation.build()
     * @param sideOrientation takes the values Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @param fUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * @param fColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * @param frontUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * @param backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param wrap a boolean, default false, when true and fUVs used texture is wrapped around all sides, when false texture is applied side
     * @returns the VertexData of the Polygon
     * @deprecated use CreatePolygonVertexData instead
     */ static CreatePolygon(polygon, sideOrientation, fUV, fColors, frontUVs, backUVs, wrap) {
        throw (0, $dUFYy._WarnImport)("polygonBuilder");
    }
    /**
     * Creates the VertexData of the IcoSphere
     * @param options an object used to set the following optional parameters for the IcoSphere, required but can be empty
     * * radius the radius of the IcoSphere, optional default 1
     * * radiusX allows stretching in the x direction, optional, default radius
     * * radiusY allows stretching in the y direction, optional, default radius
     * * radiusZ allows stretching in the z direction, optional, default radius
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the IcoSphere
     * @deprecated use CreateIcoSphereVertexData instead
     */ static CreateIcoSphere(options) {
        throw (0, $dUFYy._WarnImport)("icoSphereBuilder");
    }
    // inspired from // http://stemkoski.github.io/Three.js/Polyhedra.html
    /**
     * Creates the VertexData for a Polyhedron
     * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
     * * type provided types are:
     *  * 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
     *  * 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
     * * size the size of the IcoSphere, optional default 1
     * * sizeX allows stretching in the x direction, optional, default size
     * * sizeY allows stretching in the y direction, optional, default size
     * * sizeZ allows stretching in the z direction, optional, default size
     * * custom a number that overwrites the type to create from an extended set of polyhedron from https://www.babylonjs-playground.com/#21QRSK#15 with minimised editor
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the Polyhedron
     * @deprecated use CreatePolyhedronVertexData instead
     */ static CreatePolyhedron(options) {
        throw (0, $dUFYy._WarnImport)("polyhedronBuilder");
    }
    /**
     * Creates the VertexData for a Capsule, inspired from https://github.com/maximeq/three-js-capsule-geometry/blob/master/src/CapsuleBufferGeometry.js
     * @param options an object used to set the following optional parameters for the capsule, required but can be empty
     * @returns the VertexData of the Capsule
     * @deprecated Please use CreateCapsuleVertexData from the capsuleBuilder file instead
     */ static CreateCapsule(options = {
        orientation: (0, $ha1VO.Vector3).Up(),
        subdivisions: 2,
        tessellation: 16,
        height: 1,
        radius: 0.25,
        capSubdivisions: 6
    }) {
        throw (0, $dUFYy._WarnImport)("capsuleBuilder");
    }
    // based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3D/src/away3d/primitives/TorusKnot.as?spec=svn2473&r=2473
    /**
     * Creates the VertexData for a TorusKnot
     * @param options an object used to set the following optional parameters for the TorusKnot, required but can be empty
     * * radius the radius of the torus knot, optional, default 2
     * * tube the thickness of the tube, optional, default 0.5
     * * radialSegments the number of sides on each tube segments, optional, default 32
     * * tubularSegments the number of tubes to decompose the knot into, optional, default 32
     * * p the number of windings around the z axis, optional,  default 2
     * * q the number of windings around the x axis, optional,  default 3
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the Torus Knot
     * @deprecated use CreateTorusKnotVertexData instead
     */ static CreateTorusKnot(options) {
        throw (0, $dUFYy._WarnImport)("torusKnotBuilder");
    }
    // Tools
    /**
     * Compute normals for given positions and indices
     * @param positions an array of vertex positions, [...., x, y, z, ......]
     * @param indices an array of indices in groups of three for each triangular facet, [...., i, j, k, ......]
     * @param normals an array of vertex normals, [...., x, y, z, ......]
     * @param options an object used to set the following optional parameters for the TorusKnot, optional
     * * facetNormals : optional array of facet normals (vector3)
     * * facetPositions : optional array of facet positions (vector3)
     * * facetPartitioning : optional partitioning array. facetPositions is required for facetPartitioning computation
     * * ratio : optional partitioning ratio / bounding box, required for facetPartitioning computation
     * * bInfo : optional bounding info, required for facetPartitioning computation
     * * bbSize : optional bounding box size data, required for facetPartitioning computation
     * * subDiv : optional partitioning data about subdivisions on  each axis (int), required for facetPartitioning computation
     * * useRightHandedSystem: optional boolean to for right handed system computation
     * * depthSort : optional boolean to enable the facet depth sort computation
     * * distanceTo : optional Vector3 to compute the facet depth from this location
     * * depthSortedFacets : optional array of depthSortedFacets to store the facet distances from the reference location
     */ static ComputeNormals(positions, indices, normals, options) {
        // temporary scalar variables
        let index = 0; // facet index
        let p1p2x = 0.0; // p1p2 vector x coordinate
        let p1p2y = 0.0; // p1p2 vector y coordinate
        let p1p2z = 0.0; // p1p2 vector z coordinate
        let p3p2x = 0.0; // p3p2 vector x coordinate
        let p3p2y = 0.0; // p3p2 vector y coordinate
        let p3p2z = 0.0; // p3p2 vector z coordinate
        let faceNormalx = 0.0; // facet normal x coordinate
        let faceNormaly = 0.0; // facet normal y coordinate
        let faceNormalz = 0.0; // facet normal z coordinate
        let length = 0.0; // facet normal length before normalization
        let v1x = 0; // vector1 x index in the positions array
        let v1y = 0; // vector1 y index in the positions array
        let v1z = 0; // vector1 z index in the positions array
        let v2x = 0; // vector2 x index in the positions array
        let v2y = 0; // vector2 y index in the positions array
        let v2z = 0; // vector2 z index in the positions array
        let v3x = 0; // vector3 x index in the positions array
        let v3y = 0; // vector3 y index in the positions array
        let v3z = 0; // vector3 z index in the positions array
        let computeFacetNormals = false;
        let computeFacetPositions = false;
        let computeFacetPartitioning = false;
        let computeDepthSort = false;
        let faceNormalSign = 1;
        let ratio = 0;
        let distanceTo = null;
        if (options) {
            computeFacetNormals = options.facetNormals ? true : false;
            computeFacetPositions = options.facetPositions ? true : false;
            computeFacetPartitioning = options.facetPartitioning ? true : false;
            faceNormalSign = options.useRightHandedSystem === true ? -1 : 1;
            ratio = options.ratio || 0;
            computeDepthSort = options.depthSort ? true : false;
            distanceTo = options.distanceTo;
            if (computeDepthSort) {
                if (distanceTo === undefined) distanceTo = (0, $ha1VO.Vector3).Zero();
            }
        }
        // facetPartitioning reinit if needed
        let xSubRatio = 0;
        let ySubRatio = 0;
        let zSubRatio = 0;
        let subSq = 0;
        if (computeFacetPartitioning && options && options.bbSize) {
            //let bbSizeMax = options.bbSize.x > options.bbSize.y ? options.bbSize.x : options.bbSize.y;
            //bbSizeMax = bbSizeMax > options.bbSize.z ? bbSizeMax : options.bbSize.z;
            xSubRatio = options.subDiv.X * ratio / options.bbSize.x;
            ySubRatio = options.subDiv.Y * ratio / options.bbSize.y;
            zSubRatio = options.subDiv.Z * ratio / options.bbSize.z;
            subSq = options.subDiv.max * options.subDiv.max;
            options.facetPartitioning.length = 0;
        }
        // reset the normals
        for(index = 0; index < positions.length; index++)normals[index] = 0.0;
        // Loop : 1 indice triplet = 1 facet
        const nbFaces = indices.length / 3 | 0;
        for(index = 0; index < nbFaces; index++){
            // get the indexes of the coordinates of each vertex of the facet
            v1x = indices[index * 3] * 3;
            v1y = v1x + 1;
            v1z = v1x + 2;
            v2x = indices[index * 3 + 1] * 3;
            v2y = v2x + 1;
            v2z = v2x + 2;
            v3x = indices[index * 3 + 2] * 3;
            v3y = v3x + 1;
            v3z = v3x + 2;
            p1p2x = positions[v1x] - positions[v2x]; // compute two vectors per facet : p1p2 and p3p2
            p1p2y = positions[v1y] - positions[v2y];
            p1p2z = positions[v1z] - positions[v2z];
            p3p2x = positions[v3x] - positions[v2x];
            p3p2y = positions[v3y] - positions[v2y];
            p3p2z = positions[v3z] - positions[v2z];
            // compute the face normal with the cross product
            faceNormalx = faceNormalSign * (p1p2y * p3p2z - p1p2z * p3p2y);
            faceNormaly = faceNormalSign * (p1p2z * p3p2x - p1p2x * p3p2z);
            faceNormalz = faceNormalSign * (p1p2x * p3p2y - p1p2y * p3p2x);
            // normalize this normal and store it in the array facetData
            length = Math.sqrt(faceNormalx * faceNormalx + faceNormaly * faceNormaly + faceNormalz * faceNormalz);
            length = length === 0 ? 1.0 : length;
            faceNormalx /= length;
            faceNormaly /= length;
            faceNormalz /= length;
            if (computeFacetNormals && options) {
                options.facetNormals[index].x = faceNormalx;
                options.facetNormals[index].y = faceNormaly;
                options.facetNormals[index].z = faceNormalz;
            }
            if (computeFacetPositions && options) {
                // compute and the facet barycenter coordinates in the array facetPositions
                options.facetPositions[index].x = (positions[v1x] + positions[v2x] + positions[v3x]) / 3.0;
                options.facetPositions[index].y = (positions[v1y] + positions[v2y] + positions[v3y]) / 3.0;
                options.facetPositions[index].z = (positions[v1z] + positions[v2z] + positions[v3z]) / 3.0;
            }
            if (computeFacetPartitioning && options) {
                // store the facet indexes in arrays in the main facetPartitioning array :
                // compute each facet vertex (+ facet barycenter) index in the partiniong array
                const ox = Math.floor((options.facetPositions[index].x - options.bInfo.minimum.x * ratio) * xSubRatio);
                const oy = Math.floor((options.facetPositions[index].y - options.bInfo.minimum.y * ratio) * ySubRatio);
                const oz = Math.floor((options.facetPositions[index].z - options.bInfo.minimum.z * ratio) * zSubRatio);
                const b1x = Math.floor((positions[v1x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                const b1y = Math.floor((positions[v1y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                const b1z = Math.floor((positions[v1z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                const b2x = Math.floor((positions[v2x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                const b2y = Math.floor((positions[v2y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                const b2z = Math.floor((positions[v2z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                const b3x = Math.floor((positions[v3x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                const b3y = Math.floor((positions[v3y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                const b3z = Math.floor((positions[v3z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                const block_idx_v1 = b1x + options.subDiv.max * b1y + subSq * b1z;
                const block_idx_v2 = b2x + options.subDiv.max * b2y + subSq * b2z;
                const block_idx_v3 = b3x + options.subDiv.max * b3y + subSq * b3z;
                const block_idx_o = ox + options.subDiv.max * oy + subSq * oz;
                options.facetPartitioning[block_idx_o] = options.facetPartitioning[block_idx_o] ? options.facetPartitioning[block_idx_o] : new Array();
                options.facetPartitioning[block_idx_v1] = options.facetPartitioning[block_idx_v1] ? options.facetPartitioning[block_idx_v1] : new Array();
                options.facetPartitioning[block_idx_v2] = options.facetPartitioning[block_idx_v2] ? options.facetPartitioning[block_idx_v2] : new Array();
                options.facetPartitioning[block_idx_v3] = options.facetPartitioning[block_idx_v3] ? options.facetPartitioning[block_idx_v3] : new Array();
                // push each facet index in each block containing the vertex
                options.facetPartitioning[block_idx_v1].push(index);
                if (block_idx_v2 != block_idx_v1) options.facetPartitioning[block_idx_v2].push(index);
                if (!(block_idx_v3 == block_idx_v2 || block_idx_v3 == block_idx_v1)) options.facetPartitioning[block_idx_v3].push(index);
                if (!(block_idx_o == block_idx_v1 || block_idx_o == block_idx_v2 || block_idx_o == block_idx_v3)) options.facetPartitioning[block_idx_o].push(index);
            }
            if (computeDepthSort && options && options.facetPositions) {
                const dsf = options.depthSortedFacets[index];
                dsf.ind = index * 3;
                dsf.sqDistance = (0, $ha1VO.Vector3).DistanceSquared(options.facetPositions[index], distanceTo);
            }
            // compute the normals anyway
            normals[v1x] += faceNormalx; // accumulate all the normals per face
            normals[v1y] += faceNormaly;
            normals[v1z] += faceNormalz;
            normals[v2x] += faceNormalx;
            normals[v2y] += faceNormaly;
            normals[v2z] += faceNormalz;
            normals[v3x] += faceNormalx;
            normals[v3y] += faceNormaly;
            normals[v3z] += faceNormalz;
        }
        // last normalization of each normal
        for(index = 0; index < normals.length / 3; index++){
            faceNormalx = normals[index * 3];
            faceNormaly = normals[index * 3 + 1];
            faceNormalz = normals[index * 3 + 2];
            length = Math.sqrt(faceNormalx * faceNormalx + faceNormaly * faceNormaly + faceNormalz * faceNormalz);
            length = length === 0 ? 1.0 : length;
            faceNormalx /= length;
            faceNormaly /= length;
            faceNormalz /= length;
            normals[index * 3] = faceNormalx;
            normals[index * 3 + 1] = faceNormaly;
            normals[index * 3 + 2] = faceNormalz;
        }
    }
    /**
     * @internal
     */ static _ComputeSides(sideOrientation, positions, indices, normals, uvs, frontUVs, backUVs) {
        const li = indices.length;
        const ln = normals.length;
        let i;
        let n;
        sideOrientation = sideOrientation || $4014d881db0e9bc6$export$8570d39351855acb.DEFAULTSIDE;
        switch(sideOrientation){
            case $4014d881db0e9bc6$export$8570d39351855acb.FRONTSIDE:
                break;
            case $4014d881db0e9bc6$export$8570d39351855acb.BACKSIDE:
                // indices
                for(i = 0; i < li; i += 3){
                    const tmp = indices[i];
                    indices[i] = indices[i + 2];
                    indices[i + 2] = tmp;
                }
                // normals
                for(n = 0; n < ln; n++)normals[n] = -normals[n];
                break;
            case $4014d881db0e9bc6$export$8570d39351855acb.DOUBLESIDE:
                {
                    // positions
                    const lp = positions.length;
                    const l = lp / 3;
                    for(let p = 0; p < lp; p++)positions[lp + p] = positions[p];
                    // indices
                    for(i = 0; i < li; i += 3){
                        indices[i + li] = indices[i + 2] + l;
                        indices[i + 1 + li] = indices[i + 1] + l;
                        indices[i + 2 + li] = indices[i] + l;
                    }
                    // normals
                    for(n = 0; n < ln; n++)normals[ln + n] = -normals[n];
                    // uvs
                    const lu = uvs.length;
                    let u = 0;
                    for(u = 0; u < lu; u++)uvs[u + lu] = uvs[u];
                    frontUVs = frontUVs ? frontUVs : new (0, $ha1VO.Vector4)(0.0, 0.0, 1.0, 1.0);
                    backUVs = backUVs ? backUVs : new (0, $ha1VO.Vector4)(0.0, 0.0, 1.0, 1.0);
                    u = 0;
                    for(i = 0; i < lu / 2; i++){
                        uvs[u] = frontUVs.x + (frontUVs.z - frontUVs.x) * uvs[u];
                        uvs[u + 1] = frontUVs.y + (frontUVs.w - frontUVs.y) * uvs[u + 1];
                        uvs[u + lu] = backUVs.x + (backUVs.z - backUVs.x) * uvs[u + lu];
                        uvs[u + lu + 1] = backUVs.y + (backUVs.w - backUVs.y) * uvs[u + lu + 1];
                        u += 2;
                    }
                    break;
                }
        }
    }
    /**
     * Creates a VertexData from serialized data
     * @param parsedVertexData the parsed data from an imported file
     * @returns a VertexData
     */ static Parse(parsedVertexData) {
        const vertexData = new $4014d881db0e9bc6$export$8570d39351855acb();
        // positions
        const positions = parsedVertexData.positions;
        if (positions) vertexData.set(positions, (0, $b4i1f.VertexBuffer).PositionKind);
        // normals
        const normals = parsedVertexData.normals;
        if (normals) vertexData.set(normals, (0, $b4i1f.VertexBuffer).NormalKind);
        // tangents
        const tangents = parsedVertexData.tangents;
        if (tangents) vertexData.set(tangents, (0, $b4i1f.VertexBuffer).TangentKind);
        // uvs
        const uvs = parsedVertexData.uvs;
        if (uvs) vertexData.set(uvs, (0, $b4i1f.VertexBuffer).UVKind);
        // uv2s
        const uvs2 = parsedVertexData.uvs2;
        if (uvs2) vertexData.set(uvs2, (0, $b4i1f.VertexBuffer).UV2Kind);
        // uv3s
        const uvs3 = parsedVertexData.uvs3;
        if (uvs3) vertexData.set(uvs3, (0, $b4i1f.VertexBuffer).UV3Kind);
        // uv4s
        const uvs4 = parsedVertexData.uvs4;
        if (uvs4) vertexData.set(uvs4, (0, $b4i1f.VertexBuffer).UV4Kind);
        // uv5s
        const uvs5 = parsedVertexData.uvs5;
        if (uvs5) vertexData.set(uvs5, (0, $b4i1f.VertexBuffer).UV5Kind);
        // uv6s
        const uvs6 = parsedVertexData.uvs6;
        if (uvs6) vertexData.set(uvs6, (0, $b4i1f.VertexBuffer).UV6Kind);
        // colors
        const colors = parsedVertexData.colors;
        if (colors) {
            vertexData.set((0, $7etnY.Color4).CheckColors4(colors, positions.length / 3), (0, $b4i1f.VertexBuffer).ColorKind);
            if (parsedVertexData.hasVertexAlpha !== undefined) vertexData.hasVertexAlpha = parsedVertexData.hasVertexAlpha;
        }
        // matricesIndices
        const matricesIndices = parsedVertexData.matricesIndices;
        if (matricesIndices) vertexData.set(matricesIndices, (0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        // matricesWeights
        const matricesWeights = parsedVertexData.matricesWeights;
        if (matricesWeights) vertexData.set(matricesWeights, (0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        // indices
        const indices = parsedVertexData.indices;
        if (indices) vertexData.indices = indices;
        // MaterialInfos
        const materialInfos = parsedVertexData.materialInfos;
        if (materialInfos) {
            vertexData.materialInfos = [];
            for (const materialInfoFromJSON of materialInfos){
                const materialInfo = new $4014d881db0e9bc6$export$f5240a0ce3a46ac1();
                materialInfo.indexCount = materialInfoFromJSON.indexCount;
                materialInfo.indexStart = materialInfoFromJSON.indexStart;
                materialInfo.verticesCount = materialInfoFromJSON.verticesCount;
                materialInfo.verticesStart = materialInfoFromJSON.verticesStart;
                materialInfo.materialIndex = materialInfoFromJSON.materialIndex;
                vertexData.materialInfos.push(materialInfo);
            }
        }
        return vertexData;
    }
    /**
     * Applies VertexData created from the imported parameters to the geometry
     * @param parsedVertexData the parsed data from an imported file
     * @param geometry the geometry to apply the VertexData to
     */ static ImportVertexData(parsedVertexData, geometry) {
        const vertexData = $4014d881db0e9bc6$export$8570d39351855acb.Parse(parsedVertexData);
        geometry.setAllVerticesData(vertexData, parsedVertexData.updatable);
    }
}
/**
 * Mesh side orientation : usually the external or front surface
 */ $4014d881db0e9bc6$export$8570d39351855acb.FRONTSIDE = 0;
/**
 * Mesh side orientation : usually the internal or back surface
 */ $4014d881db0e9bc6$export$8570d39351855acb.BACKSIDE = 1;
/**
 * Mesh side orientation : both internal and external or front and back surfaces
 */ $4014d881db0e9bc6$export$8570d39351855acb.DOUBLESIDE = 2;
/**
 * Mesh side orientation : by default, `FRONTSIDE`
 */ $4014d881db0e9bc6$export$8570d39351855acb.DEFAULTSIDE = 0;
$4014d881db0e9bc6$export$8570d39351855acb._UniqueIDGenerator = 0;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[coordinates])=>!Array.isArray(coordinates))
], $4014d881db0e9bc6$export$8570d39351855acb, "_TransformVector3Coordinates", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[normals])=>!Array.isArray(normals))
], $4014d881db0e9bc6$export$8570d39351855acb, "_TransformVector3Normals", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[normals])=>!Array.isArray(normals))
], $4014d881db0e9bc6$export$8570d39351855acb, "_TransformVector4Normals", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[indices])=>!Array.isArray(indices))
], $4014d881db0e9bc6$export$8570d39351855acb, "_FlipFaces", null);



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");


var $b4i1f = parcelRequire("b4i1f");

/**
 * Class used to represent data loading progression
 */ class $ec6fcfe568825603$export$6ec0b2ecad265743 {
    /**
     * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
     */ static get ForceFullSceneLoadingForIncremental() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._ForceFullSceneLoadingForIncremental;
    }
    static set ForceFullSceneLoadingForIncremental(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._ForceFullSceneLoadingForIncremental = value;
    }
    /**
     * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
     */ static get ShowLoadingScreen() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._ShowLoadingScreen;
    }
    static set ShowLoadingScreen(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._ShowLoadingScreen = value;
    }
    /**
     * Defines the current logging level (while loading the scene)
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get loggingLevel() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._LoggingLevel;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static set loggingLevel(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._LoggingLevel = value;
    }
    /**
     * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
     */ static get CleanBoneMatrixWeights() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._CleanBoneMatrixWeights;
    }
    static set CleanBoneMatrixWeights(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._CleanBoneMatrixWeights = value;
    }
}
// Flags
$ec6fcfe568825603$export$6ec0b2ecad265743._ForceFullSceneLoadingForIncremental = false;
$ec6fcfe568825603$export$6ec0b2ecad265743._ShowLoadingScreen = true;
$ec6fcfe568825603$export$6ec0b2ecad265743._CleanBoneMatrixWeights = false;
$ec6fcfe568825603$export$6ec0b2ecad265743._LoggingLevel = 0;




var $bOhSV = parcelRequire("bOhSV");

var $7212E = parcelRequire("7212E");


var $ejQPp = parcelRequire("ejQPp");

var $fGXjI = parcelRequire("fGXjI");

var $eTEsG = parcelRequire("eTEsG");
class $07dfcf3146d3f600$export$2db6c17465f94a2 {
    /**
     *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
     */ get boundingBias() {
        return this._boundingBias;
    }
    /**
     *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
     */ set boundingBias(value) {
        if (this._boundingBias) this._boundingBias.copyFrom(value);
        else this._boundingBias = value.clone();
        this._updateBoundingInfo(true, null);
    }
    /**
     * Static function used to attach a new empty geometry to a mesh
     * @param mesh defines the mesh to attach the geometry to
     * @returns the new Geometry
     */ static CreateGeometryForMesh(mesh) {
        const geometry = new $07dfcf3146d3f600$export$2db6c17465f94a2($07dfcf3146d3f600$export$2db6c17465f94a2.RandomId(), mesh.getScene());
        geometry.applyToMesh(mesh);
        return geometry;
    }
    /** Get the list of meshes using this geometry */ get meshes() {
        return this._meshes;
    }
    /**
     * Creates a new geometry
     * @param id defines the unique ID
     * @param scene defines the hosting scene
     * @param vertexData defines the VertexData used to get geometry data
     * @param updatable defines if geometry must be updatable (false by default)
     * @param mesh defines the mesh that will be associated with the geometry
     */ constructor(id, scene, vertexData, updatable = false, mesh = null){
        /**
         * Gets the delay loading state of the geometry (none by default which means not delayed)
         */ this.delayLoadState = 0;
        this._totalVertices = 0;
        this._isDisposed = false;
        this._indexBufferIsUpdatable = false;
        this._positionsCache = [];
        /** @internal */ this._parentContainer = null;
        /**
         * If set to true (false by default), the bounding info applied to the meshes sharing this geometry will be the bounding info defined at the class level
         * and won't be computed based on the vertex positions (which is what we get when useBoundingInfoFromGeometry = false)
         */ this.useBoundingInfoFromGeometry = false;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this._scene) return;
        this.id = id;
        this.uniqueId = this._scene.getUniqueId();
        this._engine = this._scene.getEngine();
        this._meshes = [];
        //Init vertex buffer cache
        this._vertexBuffers = {};
        this._indices = [];
        this._updatable = updatable;
        // vertexData
        if (vertexData) this.setAllVerticesData(vertexData, updatable);
        else this._totalVertices = 0;
        if (this._engine.getCaps().vertexArrayObject) this._vertexArrayObjects = {};
        // applyToMesh
        if (mesh) {
            this.applyToMesh(mesh);
            mesh.computeWorldMatrix(true);
        }
    }
    /**
     * Gets the current extend of the geometry
     */ get extend() {
        return this._extend;
    }
    /**
     * Gets the hosting scene
     * @returns the hosting Scene
     */ getScene() {
        return this._scene;
    }
    /**
     * Gets the hosting engine
     * @returns the hosting Engine
     */ getEngine() {
        return this._engine;
    }
    /**
     * Defines if the geometry is ready to use
     * @returns true if the geometry is ready to be used
     */ isReady() {
        return this.delayLoadState === 1 || this.delayLoadState === 0;
    }
    /**
     * Gets a value indicating that the geometry should not be serialized
     */ get doNotSerialize() {
        for(let index = 0; index < this._meshes.length; index++){
            if (!this._meshes[index].doNotSerialize) return false;
        }
        return true;
    }
    /** @internal */ _rebuild() {
        if (this._vertexArrayObjects) this._vertexArrayObjects = {};
        // Index buffer
        if (this._meshes.length !== 0 && this._indices) this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable, "Geometry_" + this.id + "_IndexBuffer");
        // Vertex buffers
        const buffers = new Set();
        for(const key in this._vertexBuffers)buffers.add(this._vertexBuffers[key].getWrapperBuffer());
        buffers.forEach((buffer)=>{
            buffer._rebuild();
        });
    }
    /**
     * Affects all geometry data in one call
     * @param vertexData defines the geometry data
     * @param updatable defines if the geometry must be flagged as updatable (false as default)
     */ setAllVerticesData(vertexData, updatable) {
        vertexData.applyToGeometry(this, updatable);
        this._notifyUpdate();
    }
    /**
     * Set specific vertex data
     * @param kind defines the data kind (Position, normal, etc...)
     * @param data defines the vertex data to use
     * @param updatable defines if the vertex must be flagged as updatable (false as default)
     * @param stride defines the stride to use (0 by default). This value is deduced from the kind value if not specified
     */ setVerticesData(kind, data, updatable = false, stride) {
        if (updatable && Array.isArray(data)) // to avoid converting to Float32Array at each draw call in engine.updateDynamicVertexBuffer, we make the conversion a single time here
        data = new Float32Array(data);
        const buffer = new (0, $b4i1f.VertexBuffer)(this._engine, data, kind, {
            updatable: updatable,
            postponeInternalCreation: this._meshes.length === 0,
            stride: stride,
            label: "Geometry_" + this.id + "_" + kind
        });
        this.setVerticesBuffer(buffer);
    }
    /**
     * Removes a specific vertex data
     * @param kind defines the data kind (Position, normal, etc...)
     */ removeVerticesData(kind) {
        if (this._vertexBuffers[kind]) {
            this._vertexBuffers[kind].dispose();
            delete this._vertexBuffers[kind];
        }
        if (this._vertexArrayObjects) this._disposeVertexArrayObjects();
    }
    /**
     * Affect a vertex buffer to the geometry. the vertexBuffer.getKind() function is used to determine where to store the data
     * @param buffer defines the vertex buffer to use
     * @param totalVertices defines the total number of vertices for position kind (could be null)
     * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
     */ setVerticesBuffer(buffer, totalVertices = null, disposeExistingBuffer = true) {
        const kind = buffer.getKind();
        if (this._vertexBuffers[kind] && disposeExistingBuffer) this._vertexBuffers[kind].dispose();
        if (buffer._buffer) buffer._buffer._increaseReferences();
        this._vertexBuffers[kind] = buffer;
        const meshes = this._meshes;
        const numOfMeshes = meshes.length;
        if (kind === (0, $b4i1f.VertexBuffer).PositionKind) {
            this._totalVertices = totalVertices ?? buffer._maxVerticesCount;
            this._updateExtend(buffer.getFloatData(this._totalVertices));
            this._resetPointsArrayCache();
            // this._extend can be empty if buffer.getFloatData(this._totalVertices) returned null
            const minimum = this._extend && this._extend.minimum || new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
            const maximum = this._extend && this._extend.maximum || new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            for(let index = 0; index < numOfMeshes; index++){
                const mesh = meshes[index];
                mesh.buildBoundingInfo(minimum, maximum);
                mesh._createGlobalSubMesh(mesh.isUnIndexed);
                mesh.computeWorldMatrix(true);
                mesh.synchronizeInstances();
            }
        }
        this._notifyUpdate(kind);
    }
    /**
     * Update a specific vertex buffer
     * This function will directly update the underlying DataBuffer according to the passed numeric array or Float32Array
     * It will do nothing if the buffer is not updatable
     * @param kind defines the data kind (Position, normal, etc...)
     * @param data defines the data to use
     * @param offset defines the offset in the target buffer where to store the data
     * @param useBytes set to true if the offset is in bytes
     */ updateVerticesDataDirectly(kind, data, offset, useBytes = false) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return;
        vertexBuffer.updateDirectly(data, offset, useBytes);
        this._notifyUpdate(kind);
    }
    /**
     * Update a specific vertex buffer
     * This function will create a new buffer if the current one is not updatable
     * @param kind defines the data kind (Position, normal, etc...)
     * @param data defines the data to use
     * @param updateExtends defines if the geometry extends must be recomputed (false by default)
     */ updateVerticesData(kind, data, updateExtends = false) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return;
        vertexBuffer.update(data);
        if (kind === (0, $b4i1f.VertexBuffer).PositionKind) this._updateBoundingInfo(updateExtends, data);
        this._notifyUpdate(kind);
    }
    _updateBoundingInfo(updateExtends, data) {
        if (updateExtends) this._updateExtend(data);
        this._resetPointsArrayCache();
        if (updateExtends) {
            const meshes = this._meshes;
            for (const mesh of meshes){
                if (mesh.hasBoundingInfo) mesh.getBoundingInfo().reConstruct(this._extend.minimum, this._extend.maximum);
                else mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                const subMeshes = mesh.subMeshes;
                for (const subMesh of subMeshes)subMesh.refreshBoundingInfo();
            }
        }
    }
    /**
     * @internal
     */ _bind(effect, indexToBind, overrideVertexBuffers, overrideVertexArrayObjects) {
        if (!effect) return;
        if (indexToBind === undefined) indexToBind = this._indexBuffer;
        const vbs = this.getVertexBuffers();
        if (!vbs) return;
        if (indexToBind != this._indexBuffer || !this._vertexArrayObjects && !overrideVertexArrayObjects) {
            this._engine.bindBuffers(vbs, indexToBind, effect, overrideVertexBuffers);
            return;
        }
        const vaos = overrideVertexArrayObjects ? overrideVertexArrayObjects : this._vertexArrayObjects;
        const engine = this._engine;
        // Using VAO
        if (!vaos[effect.key]) vaos[effect.key] = engine.recordVertexArrayObject(vbs, indexToBind, effect, overrideVertexBuffers);
        engine.bindVertexArrayObject(vaos[effect.key], indexToBind);
    }
    /**
     * Gets total number of vertices
     * @returns the total number of vertices
     */ getTotalVertices() {
        if (!this.isReady()) return 0;
        return this._totalVertices;
    }
    /**
     * Gets a specific vertex data attached to this geometry. Float data is constructed if the vertex buffer data cannot be returned directly.
     * @param kind defines the data kind (Position, normal, etc...)
     * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns a float array containing vertex data
     */ getVerticesData(kind, copyWhenShared, forceCopy) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return null;
        return vertexBuffer.getFloatData(this._totalVertices, forceCopy || copyWhenShared && this._meshes.length !== 1);
    }
    /**
     * Copies the requested vertex data kind into the given vertex data map. Float data is constructed if the map doesn't have the data.
     * @param kind defines the data kind (Position, normal, etc...)
     * @param vertexData defines the map that stores the resulting data
     */ copyVerticesData(kind, vertexData) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return;
        vertexData[kind] || (vertexData[kind] = new Float32Array(this._totalVertices * vertexBuffer.getSize()));
        const data = vertexBuffer.getData();
        if (data) (0, $eTEsG.CopyFloatData)(data, vertexBuffer.getSize(), vertexBuffer.type, vertexBuffer.byteOffset, vertexBuffer.byteStride, vertexBuffer.normalized, this._totalVertices, vertexData[kind]);
    }
    /**
     * Returns a boolean defining if the vertex data for the requested `kind` is updatable
     * @param kind defines the data kind (Position, normal, etc...)
     * @returns true if the vertex buffer with the specified kind is updatable
     */ isVertexBufferUpdatable(kind) {
        const vb = this._vertexBuffers[kind];
        if (!vb) return false;
        return vb.isUpdatable();
    }
    /**
     * Gets a specific vertex buffer
     * @param kind defines the data kind (Position, normal, etc...)
     * @returns a VertexBuffer
     */ getVertexBuffer(kind) {
        if (!this.isReady()) return null;
        return this._vertexBuffers[kind];
    }
    /**
     * Returns all vertex buffers
     * @returns an object holding all vertex buffers indexed by kind
     */ getVertexBuffers() {
        if (!this.isReady()) return null;
        return this._vertexBuffers;
    }
    /**
     * Gets a boolean indicating if specific vertex buffer is present
     * @param kind defines the data kind (Position, normal, etc...)
     * @returns true if data is present
     */ isVerticesDataPresent(kind) {
        if (!this._vertexBuffers) {
            if (this._delayInfo) return this._delayInfo.indexOf(kind) !== -1;
            return false;
        }
        return this._vertexBuffers[kind] !== undefined;
    }
    /**
     * Gets a list of all attached data kinds (Position, normal, etc...)
     * @returns a list of string containing all kinds
     */ getVerticesDataKinds() {
        const result = [];
        let kind;
        if (!this._vertexBuffers && this._delayInfo) for(kind in this._delayInfo)result.push(kind);
        else for(kind in this._vertexBuffers)result.push(kind);
        return result;
    }
    /**
     * Update index buffer
     * @param indices defines the indices to store in the index buffer
     * @param offset defines the offset in the target buffer where to store the data
     * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
     */ updateIndices(indices, offset, gpuMemoryOnly = false) {
        if (!this._indexBuffer) return;
        if (!this._indexBufferIsUpdatable) this.setIndices(indices, null, true);
        else {
            const needToUpdateSubMeshes = indices.length !== this._indices.length;
            if (!gpuMemoryOnly) this._indices = indices.slice();
            this._engine.updateDynamicIndexBuffer(this._indexBuffer, indices, offset);
            if (needToUpdateSubMeshes) for (const mesh of this._meshes)mesh._createGlobalSubMesh(true);
        }
    }
    /**
     * Sets the index buffer for this geometry.
     * @param indexBuffer Defines the index buffer to use for this geometry
     * @param totalVertices Defines the total number of vertices used by the buffer
     * @param totalIndices Defines the total number of indices in the index buffer
     */ setIndexBuffer(indexBuffer, totalVertices, totalIndices) {
        this._indices = [];
        this._indexBufferIsUpdatable = false;
        this._indexBuffer = indexBuffer;
        this._totalVertices = totalVertices;
        this._totalIndices = totalIndices;
        indexBuffer.is32Bits || (indexBuffer.is32Bits = this._totalIndices > 65535);
        for (const mesh of this._meshes){
            mesh._createGlobalSubMesh(true);
            mesh.synchronizeInstances();
        }
        this._notifyUpdate();
    }
    /**
     * Creates a new index buffer
     * @param indices defines the indices to store in the index buffer
     * @param totalVertices defines the total number of vertices (could be null)
     * @param updatable defines if the index buffer must be flagged as updatable (false by default)
     * @param dontForceSubMeshRecreation defines a boolean indicating that we don't want to force the recreation of sub-meshes if we don't have to (false by default)
     */ setIndices(indices, totalVertices = null, updatable = false, dontForceSubMeshRecreation = false) {
        if (this._indexBuffer) this._engine._releaseBuffer(this._indexBuffer);
        this._indices = indices;
        this._indexBufferIsUpdatable = updatable;
        if (this._meshes.length !== 0 && this._indices) this._indexBuffer = this._engine.createIndexBuffer(this._indices, updatable, "Geometry_" + this.id + "_IndexBuffer");
        if (totalVertices != undefined) // including null and undefined
        this._totalVertices = totalVertices;
        for (const mesh of this._meshes){
            mesh._createGlobalSubMesh(!dontForceSubMeshRecreation);
            mesh.synchronizeInstances();
        }
        this._notifyUpdate();
    }
    /**
     * Return the total number of indices
     * @returns the total number of indices
     */ getTotalIndices() {
        if (!this.isReady()) return 0;
        return this._totalIndices !== undefined ? this._totalIndices : this._indices.length;
    }
    /**
     * Gets the index buffer array
     * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns the index buffer array
     */ getIndices(copyWhenShared, forceCopy) {
        if (!this.isReady()) return null;
        const orig = this._indices;
        if (!forceCopy && (!copyWhenShared || this._meshes.length === 1)) return orig;
        else return orig.slice();
    }
    /**
     * Gets the index buffer
     * @returns the index buffer
     */ getIndexBuffer() {
        if (!this.isReady()) return null;
        return this._indexBuffer;
    }
    /**
     * @internal
     */ _releaseVertexArrayObject(effect = null) {
        if (!effect || !this._vertexArrayObjects) return;
        if (this._vertexArrayObjects[effect.key]) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObjects[effect.key]);
            delete this._vertexArrayObjects[effect.key];
        }
    }
    /**
     * Release the associated resources for a specific mesh
     * @param mesh defines the source mesh
     * @param shouldDispose defines if the geometry must be disposed if there is no more mesh pointing to it
     */ releaseForMesh(mesh, shouldDispose) {
        const meshes = this._meshes;
        const index = meshes.indexOf(mesh);
        if (index === -1) return;
        meshes.splice(index, 1);
        if (this._vertexArrayObjects) mesh._invalidateInstanceVertexArrayObject();
        mesh._geometry = null;
        if (meshes.length === 0 && shouldDispose) this.dispose();
    }
    /**
     * Apply current geometry to a given mesh
     * @param mesh defines the mesh to apply geometry to
     */ applyToMesh(mesh) {
        if (mesh._geometry === this) return;
        const previousGeometry = mesh._geometry;
        if (previousGeometry) previousGeometry.releaseForMesh(mesh);
        if (this._vertexArrayObjects) mesh._invalidateInstanceVertexArrayObject();
        const meshes = this._meshes;
        // must be done before setting vertexBuffers because of mesh._createGlobalSubMesh()
        mesh._geometry = this;
        mesh._internalAbstractMeshDataInfo._positions = null;
        this._scene.pushGeometry(this);
        meshes.push(mesh);
        if (this.isReady()) this._applyToMesh(mesh);
        else if (this._boundingInfo) mesh.setBoundingInfo(this._boundingInfo);
    }
    _updateExtend(data = null) {
        if (this.useBoundingInfoFromGeometry && this._boundingInfo) this._extend = {
            minimum: this._boundingInfo.minimum.clone(),
            maximum: this._boundingInfo.maximum.clone()
        };
        else {
            if (!data) {
                data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
                // This can happen if the buffer comes from a Hardware Buffer where
                // The data have not been uploaded by Babylon. (ex: Compute Shaders and Storage Buffers)
                if (!data) return;
            }
            this._extend = (0, $14fdbb07a947065f$export$e1bada46cc64caed)(data, 0, this._totalVertices, this.boundingBias, 3);
        }
    }
    _applyToMesh(mesh) {
        const numOfMeshes = this._meshes.length;
        // vertexBuffers
        for(const kind in this._vertexBuffers){
            if (numOfMeshes === 1) this._vertexBuffers[kind].create();
            if (kind === (0, $b4i1f.VertexBuffer).PositionKind) {
                if (!this._extend) this._updateExtend();
                mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                mesh._createGlobalSubMesh(mesh.isUnIndexed);
                //bounding info was just created again, world matrix should be applied again.
                mesh._updateBoundingInfo();
            }
        }
        // indexBuffer
        if (numOfMeshes === 1 && this._indices && this._indices.length > 0) this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable, "Geometry_" + this.id + "_IndexBuffer");
        // morphTargets
        mesh._syncGeometryWithMorphTargetManager();
        // instances
        mesh.synchronizeInstances();
    }
    _notifyUpdate(kind) {
        if (this.onGeometryUpdated) this.onGeometryUpdated(this, kind);
        if (this._vertexArrayObjects) this._disposeVertexArrayObjects();
        for (const mesh of this._meshes)mesh._markSubMeshesAsAttributesDirty();
    }
    /**
     * Load the geometry if it was flagged as delay loaded
     * @param scene defines the hosting scene
     * @param onLoaded defines a callback called when the geometry is loaded
     */ load(scene, onLoaded) {
        if (this.delayLoadState === 2) return;
        if (this.isReady()) {
            if (onLoaded) onLoaded();
            return;
        }
        this.delayLoadState = 2;
        this._queueLoad(scene, onLoaded);
    }
    _queueLoad(scene, onLoaded) {
        if (!this.delayLoadingFile) return;
        scene.addPendingData(this);
        scene._loadFile(this.delayLoadingFile, (data)=>{
            if (!this._delayLoadingFunction) return;
            this._delayLoadingFunction(JSON.parse(data), this);
            this.delayLoadState = 1;
            this._delayInfo = [];
            scene.removePendingData(this);
            const meshes = this._meshes;
            const numOfMeshes = meshes.length;
            for(let index = 0; index < numOfMeshes; index++)this._applyToMesh(meshes[index]);
            if (onLoaded) onLoaded();
        }, undefined, true);
    }
    /**
     * Invert the geometry to move from a right handed system to a left handed one.
     */ toLeftHanded() {
        // Flip faces
        const tIndices = this.getIndices(false);
        if (tIndices != null && tIndices.length > 0) {
            for(let i = 0; i < tIndices.length; i += 3){
                const tTemp = tIndices[i + 0];
                tIndices[i + 0] = tIndices[i + 2];
                tIndices[i + 2] = tTemp;
            }
            this.setIndices(tIndices);
        }
        // Negate position.z
        const tPositions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, false);
        if (tPositions != null && tPositions.length > 0) {
            for(let i = 0; i < tPositions.length; i += 3)tPositions[i + 2] = -tPositions[i + 2];
            this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, tPositions, false);
        }
        // Negate normal.z
        const tNormals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind, false);
        if (tNormals != null && tNormals.length > 0) {
            for(let i = 0; i < tNormals.length; i += 3)tNormals[i + 2] = -tNormals[i + 2];
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, tNormals, false);
        }
    }
    // Cache
    /** @internal */ _resetPointsArrayCache() {
        this._positions = null;
    }
    /** @internal */ _generatePointsArray() {
        if (this._positions) return true;
        const data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!data || data.length === 0) return false;
        for(let index = this._positionsCache.length * 3, arrayIdx = this._positionsCache.length; index < data.length; index += 3, ++arrayIdx)this._positionsCache[arrayIdx] = (0, $ha1VO.Vector3).FromArray(data, index);
        for(let index = 0, arrayIdx = 0; index < data.length; index += 3, ++arrayIdx)this._positionsCache[arrayIdx].set(data[0 + index], data[1 + index], data[2 + index]);
        // just in case the number of positions was reduced, splice the array
        this._positionsCache.length = data.length / 3;
        this._positions = this._positionsCache;
        return true;
    }
    /**
     * Gets a value indicating if the geometry is disposed
     * @returns true if the geometry was disposed
     */ isDisposed() {
        return this._isDisposed;
    }
    _disposeVertexArrayObjects() {
        if (this._vertexArrayObjects) {
            for(const kind in this._vertexArrayObjects)this._engine.releaseVertexArrayObject(this._vertexArrayObjects[kind]);
            this._vertexArrayObjects = {}; // Will trigger a rebuild of the VAO if supported
            const meshes = this._meshes;
            const numOfMeshes = meshes.length;
            for(let index = 0; index < numOfMeshes; index++)meshes[index]._invalidateInstanceVertexArrayObject();
        }
    }
    /**
     * Free all associated resources
     */ dispose() {
        const meshes = this._meshes;
        const numOfMeshes = meshes.length;
        let index;
        for(index = 0; index < numOfMeshes; index++)this.releaseForMesh(meshes[index]);
        this._meshes.length = 0;
        this._disposeVertexArrayObjects();
        for(const kind in this._vertexBuffers)this._vertexBuffers[kind].dispose();
        this._vertexBuffers = {};
        this._totalVertices = 0;
        if (this._indexBuffer) this._engine._releaseBuffer(this._indexBuffer);
        this._indexBuffer = null;
        this._indices = [];
        this.delayLoadState = 0;
        this.delayLoadingFile = null;
        this._delayLoadingFunction = null;
        this._delayInfo = [];
        this._boundingInfo = null;
        this._scene.removeGeometry(this);
        if (this._parentContainer) {
            const index = this._parentContainer.geometries.indexOf(this);
            if (index > -1) this._parentContainer.geometries.splice(index, 1);
            this._parentContainer = null;
        }
        this._isDisposed = true;
    }
    /**
     * Clone the current geometry into a new geometry
     * @param id defines the unique ID of the new geometry
     * @returns a new geometry object
     */ copy(id) {
        const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
        vertexData.indices = [];
        const indices = this.getIndices();
        if (indices) for(let index = 0; index < indices.length; index++)vertexData.indices.push(indices[index]);
        let updatable = false;
        let stopChecking = false;
        let kind;
        for(kind in this._vertexBuffers){
            // using slice() to make a copy of the array and not just reference it
            const data = this.getVerticesData(kind);
            if (data) {
                if (data instanceof Float32Array) vertexData.set(new Float32Array(data), kind);
                else vertexData.set(data.slice(0), kind);
                if (!stopChecking) {
                    const vb = this.getVertexBuffer(kind);
                    if (vb) {
                        updatable = vb.isUpdatable();
                        stopChecking = !updatable;
                    }
                }
            }
        }
        const geometry = new $07dfcf3146d3f600$export$2db6c17465f94a2(id, this._scene, vertexData, updatable);
        geometry.delayLoadState = this.delayLoadState;
        geometry.delayLoadingFile = this.delayLoadingFile;
        geometry._delayLoadingFunction = this._delayLoadingFunction;
        for(kind in this._delayInfo){
            geometry._delayInfo = geometry._delayInfo || [];
            geometry._delayInfo.push(kind);
        }
        // Bounding info
        geometry._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)(this._extend.minimum, this._extend.maximum);
        return geometry;
    }
    /**
     * Serialize the current geometry info (and not the vertices data) into a JSON object
     * @returns a JSON representation of the current geometry data (without the vertices data)
     */ serialize() {
        const serializationObject = {};
        serializationObject.id = this.id;
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.updatable = this._updatable;
        if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(this)) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        return serializationObject;
    }
    _toNumberArray(origin) {
        if (Array.isArray(origin)) return origin;
        else return Array.prototype.slice.call(origin);
    }
    /**
     * Release any memory retained by the cached data on the Geometry.
     *
     * Call this function to reduce memory footprint of the mesh.
     * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
     */ clearCachedData() {
        this._indices = [];
        this._resetPointsArrayCache();
        for(const vbName in this._vertexBuffers){
            if (!Object.prototype.hasOwnProperty.call(this._vertexBuffers, vbName)) continue;
            this._vertexBuffers[vbName]._buffer._data = null;
        }
    }
    /**
     * Serialize all vertices data into a JSON object
     * @returns a JSON representation of the current geometry data
     */ serializeVerticeData() {
        const serializationObject = this.serialize();
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) {
            serializationObject.positions = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind)) serializationObject.positions._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
            serializationObject.normals = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).NormalKind)) serializationObject.normals._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) {
            serializationObject.tangents = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).TangentKind)) serializationObject.tangents._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
            serializationObject.uvs = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UVKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UVKind)) serializationObject.uvs._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
            serializationObject.uvs2 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV2Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV2Kind)) serializationObject.uvs2._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV3Kind)) {
            serializationObject.uvs3 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV3Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV3Kind)) serializationObject.uvs3._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV4Kind)) {
            serializationObject.uvs4 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV4Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV4Kind)) serializationObject.uvs4._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV5Kind)) {
            serializationObject.uvs5 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV5Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV5Kind)) serializationObject.uvs5._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV6Kind)) {
            serializationObject.uvs6 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV6Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV6Kind)) serializationObject.uvs6._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind)) {
            serializationObject.colors = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).ColorKind)) serializationObject.colors._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) {
            serializationObject.matricesIndices = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind));
            serializationObject.matricesIndices._isExpanded = true;
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) serializationObject.matricesIndices._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) {
            serializationObject.matricesWeights = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) serializationObject.matricesWeights._updatable = true;
        }
        serializationObject.indices = this._toNumberArray(this.getIndices());
        return serializationObject;
    }
    // Statics
    /**
     * Extracts a clone of a mesh geometry
     * @param mesh defines the source mesh
     * @param id defines the unique ID of the new geometry object
     * @returns the new geometry object
     */ static ExtractFromMesh(mesh, id) {
        const geometry = mesh._geometry;
        if (!geometry) return null;
        return geometry.copy(id);
    }
    /**
     * You should now use Tools.RandomId(), this method is still here for legacy reasons.
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a string containing a new GUID
     */ static RandomId() {
        return (0, $bOhSV.Tools).RandomId();
    }
    static _GetGeometryByLoadedUniqueId(uniqueId, scene) {
        for(let index = 0; index < scene.geometries.length; index++){
            if (scene.geometries[index]._loadedUniqueId === uniqueId) return scene.geometries[index];
        }
        return null;
    }
    /**
     * @internal
     */ static _ImportGeometry(parsedGeometry, mesh) {
        const scene = mesh.getScene();
        // Geometry
        const geometryUniqueId = parsedGeometry.geometryUniqueId;
        const geometryId = parsedGeometry.geometryId;
        if (geometryUniqueId || geometryId) {
            const geometry = geometryUniqueId ? this._GetGeometryByLoadedUniqueId(geometryUniqueId, scene) : scene.getGeometryById(geometryId);
            if (geometry) geometry.applyToMesh(mesh);
        } else if (parsedGeometry instanceof ArrayBuffer) {
            const binaryInfo = mesh._binaryInfo;
            if (binaryInfo.positionsAttrDesc && binaryInfo.positionsAttrDesc.count > 0) {
                const positionsData = new Float32Array(parsedGeometry, binaryInfo.positionsAttrDesc.offset, binaryInfo.positionsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positionsData, false);
            }
            if (binaryInfo.normalsAttrDesc && binaryInfo.normalsAttrDesc.count > 0) {
                const normalsData = new Float32Array(parsedGeometry, binaryInfo.normalsAttrDesc.offset, binaryInfo.normalsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normalsData, false);
            }
            if (binaryInfo.tangetsAttrDesc && binaryInfo.tangetsAttrDesc.count > 0) {
                const tangentsData = new Float32Array(parsedGeometry, binaryInfo.tangetsAttrDesc.offset, binaryInfo.tangetsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, tangentsData, false);
            }
            if (binaryInfo.uvsAttrDesc && binaryInfo.uvsAttrDesc.count > 0) {
                const uvsData = new Float32Array(parsedGeometry, binaryInfo.uvsAttrDesc.offset, binaryInfo.uvsAttrDesc.count);
                if (0, $fGXjI.useOpenGLOrientationForUV) for(let index = 1; index < uvsData.length; index += 2)uvsData[index] = 1 - uvsData[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvsData, false);
            }
            if (binaryInfo.uvs2AttrDesc && binaryInfo.uvs2AttrDesc.count > 0) {
                const uvs2Data = new Float32Array(parsedGeometry, binaryInfo.uvs2AttrDesc.offset, binaryInfo.uvs2AttrDesc.count);
                if (0, $fGXjI.useOpenGLOrientationForUV) for(let index = 1; index < uvs2Data.length; index += 2)uvs2Data[index] = 1 - uvs2Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, uvs2Data, false);
            }
            if (binaryInfo.uvs3AttrDesc && binaryInfo.uvs3AttrDesc.count > 0) {
                const uvs3Data = new Float32Array(parsedGeometry, binaryInfo.uvs3AttrDesc.offset, binaryInfo.uvs3AttrDesc.count);
                if (0, $fGXjI.useOpenGLOrientationForUV) for(let index = 1; index < uvs3Data.length; index += 2)uvs3Data[index] = 1 - uvs3Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, uvs3Data, false);
            }
            if (binaryInfo.uvs4AttrDesc && binaryInfo.uvs4AttrDesc.count > 0) {
                const uvs4Data = new Float32Array(parsedGeometry, binaryInfo.uvs4AttrDesc.offset, binaryInfo.uvs4AttrDesc.count);
                if (0, $fGXjI.useOpenGLOrientationForUV) for(let index = 1; index < uvs4Data.length; index += 2)uvs4Data[index] = 1 - uvs4Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, uvs4Data, false);
            }
            if (binaryInfo.uvs5AttrDesc && binaryInfo.uvs5AttrDesc.count > 0) {
                const uvs5Data = new Float32Array(parsedGeometry, binaryInfo.uvs5AttrDesc.offset, binaryInfo.uvs5AttrDesc.count);
                if (0, $fGXjI.useOpenGLOrientationForUV) for(let index = 1; index < uvs5Data.length; index += 2)uvs5Data[index] = 1 - uvs5Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, uvs5Data, false);
            }
            if (binaryInfo.uvs6AttrDesc && binaryInfo.uvs6AttrDesc.count > 0) {
                const uvs6Data = new Float32Array(parsedGeometry, binaryInfo.uvs6AttrDesc.offset, binaryInfo.uvs6AttrDesc.count);
                if (0, $fGXjI.useOpenGLOrientationForUV) for(let index = 1; index < uvs6Data.length; index += 2)uvs6Data[index] = 1 - uvs6Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, uvs6Data, false);
            }
            if (binaryInfo.colorsAttrDesc && binaryInfo.colorsAttrDesc.count > 0) {
                const colorsData = new Float32Array(parsedGeometry, binaryInfo.colorsAttrDesc.offset, binaryInfo.colorsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, colorsData, false, binaryInfo.colorsAttrDesc.stride);
            }
            if (binaryInfo.matricesIndicesAttrDesc && binaryInfo.matricesIndicesAttrDesc.count > 0) {
                const matricesIndicesData = new Int32Array(parsedGeometry, binaryInfo.matricesIndicesAttrDesc.offset, binaryInfo.matricesIndicesAttrDesc.count);
                const floatIndices = [];
                for(let i = 0; i < matricesIndicesData.length; i++){
                    const index = matricesIndicesData[i];
                    floatIndices.push(index & 0x000000ff);
                    floatIndices.push((index & 0x0000ff00) >> 8);
                    floatIndices.push((index & 0x00ff0000) >> 16);
                    floatIndices.push(index >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                }
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, floatIndices, false);
            }
            if (binaryInfo.matricesIndicesExtraAttrDesc && binaryInfo.matricesIndicesExtraAttrDesc.count > 0) {
                const matricesIndicesData = new Int32Array(parsedGeometry, binaryInfo.matricesIndicesExtraAttrDesc.offset, binaryInfo.matricesIndicesExtraAttrDesc.count);
                const floatIndices = [];
                for(let i = 0; i < matricesIndicesData.length; i++){
                    const index = matricesIndicesData[i];
                    floatIndices.push(index & 0x000000ff);
                    floatIndices.push((index & 0x0000ff00) >> 8);
                    floatIndices.push((index & 0x00ff0000) >> 16);
                    floatIndices.push(index >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                }
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, floatIndices, false);
            }
            if (binaryInfo.matricesWeightsAttrDesc && binaryInfo.matricesWeightsAttrDesc.count > 0) {
                const matricesWeightsData = new Float32Array(parsedGeometry, binaryInfo.matricesWeightsAttrDesc.offset, binaryInfo.matricesWeightsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeightsData, false);
            }
            if (binaryInfo.indicesAttrDesc && binaryInfo.indicesAttrDesc.count > 0) {
                const indicesData = new Int32Array(parsedGeometry, binaryInfo.indicesAttrDesc.offset, binaryInfo.indicesAttrDesc.count);
                mesh.setIndices(indicesData, null);
            }
            if (binaryInfo.subMeshesAttrDesc && binaryInfo.subMeshesAttrDesc.count > 0) {
                const subMeshesData = new Int32Array(parsedGeometry, binaryInfo.subMeshesAttrDesc.offset, binaryInfo.subMeshesAttrDesc.count * 5);
                mesh.subMeshes = [];
                for(let i = 0; i < binaryInfo.subMeshesAttrDesc.count; i++){
                    const materialIndex = subMeshesData[i * 5 + 0];
                    const verticesStart = subMeshesData[i * 5 + 1];
                    const verticesCount = subMeshesData[i * 5 + 2];
                    const indexStart = subMeshesData[i * 5 + 3];
                    const indexCount = subMeshesData[i * 5 + 4];
                    (0, $fc3ab70ba5c9f506$export$c684db7d654df572).AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh);
                }
            }
        } else if (parsedGeometry.positions && parsedGeometry.normals && parsedGeometry.indices) {
            mesh.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, parsedGeometry.positions, parsedGeometry.positions._updatable);
            mesh.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, parsedGeometry.normals, parsedGeometry.normals._updatable);
            if (parsedGeometry.tangents) mesh.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, parsedGeometry.tangents, parsedGeometry.tangents._updatable);
            if (parsedGeometry.uvs) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, parsedGeometry.uvs, parsedGeometry.uvs._updatable);
            if (parsedGeometry.uvs2) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, parsedGeometry.uvs2, parsedGeometry.uvs2._updatable);
            if (parsedGeometry.uvs3) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, parsedGeometry.uvs3, parsedGeometry.uvs3._updatable);
            if (parsedGeometry.uvs4) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, parsedGeometry.uvs4, parsedGeometry.uvs4._updatable);
            if (parsedGeometry.uvs5) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, parsedGeometry.uvs5, parsedGeometry.uvs5._updatable);
            if (parsedGeometry.uvs6) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, parsedGeometry.uvs6, parsedGeometry.uvs6._updatable);
            if (parsedGeometry.colors) mesh.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, (0, $7etnY.Color4).CheckColors4(parsedGeometry.colors, parsedGeometry.positions.length / 3), parsedGeometry.colors._updatable);
            if (parsedGeometry.matricesIndices) {
                if (!parsedGeometry.matricesIndices._isExpanded) {
                    const floatIndices = [];
                    for(let i = 0; i < parsedGeometry.matricesIndices.length; i++){
                        const matricesIndex = parsedGeometry.matricesIndices[i];
                        floatIndices.push(matricesIndex & 0x000000ff);
                        floatIndices.push((matricesIndex & 0x0000ff00) >> 8);
                        floatIndices.push((matricesIndex & 0x00ff0000) >> 16);
                        floatIndices.push(matricesIndex >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                    }
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, floatIndices, parsedGeometry.matricesIndices._updatable);
                } else {
                    delete parsedGeometry.matricesIndices._isExpanded;
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, parsedGeometry.matricesIndices, parsedGeometry.matricesIndices._updatable);
                }
            }
            if (parsedGeometry.matricesIndicesExtra) {
                if (!parsedGeometry.matricesIndicesExtra._isExpanded) {
                    const floatIndices = [];
                    for(let i = 0; i < parsedGeometry.matricesIndicesExtra.length; i++){
                        const matricesIndex = parsedGeometry.matricesIndicesExtra[i];
                        floatIndices.push(matricesIndex & 0x000000ff);
                        floatIndices.push((matricesIndex & 0x0000ff00) >> 8);
                        floatIndices.push((matricesIndex & 0x00ff0000) >> 16);
                        floatIndices.push(matricesIndex >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                    }
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, floatIndices, parsedGeometry.matricesIndicesExtra._updatable);
                } else {
                    delete parsedGeometry.matricesIndices._isExpanded;
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, parsedGeometry.matricesIndicesExtra, parsedGeometry.matricesIndicesExtra._updatable);
                }
            }
            if (parsedGeometry.matricesWeights) {
                $07dfcf3146d3f600$export$2db6c17465f94a2._CleanMatricesWeights(parsedGeometry, mesh);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, parsedGeometry.matricesWeights, parsedGeometry.matricesWeights._updatable);
            }
            if (parsedGeometry.matricesWeightsExtra) mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, parsedGeometry.matricesWeightsExtra, parsedGeometry.matricesWeights._updatable);
            mesh.setIndices(parsedGeometry.indices, null);
        }
        // SubMeshes
        if (parsedGeometry.subMeshes) {
            mesh.subMeshes = [];
            for(let subIndex = 0; subIndex < parsedGeometry.subMeshes.length; subIndex++){
                const parsedSubMesh = parsedGeometry.subMeshes[subIndex];
                (0, $fc3ab70ba5c9f506$export$c684db7d654df572).AddToMesh(parsedSubMesh.materialIndex, parsedSubMesh.verticesStart, parsedSubMesh.verticesCount, parsedSubMesh.indexStart, parsedSubMesh.indexCount, mesh);
            }
        }
        // Flat shading
        if (mesh._shouldGenerateFlatShading) {
            mesh.convertToFlatShadedMesh();
            mesh._shouldGenerateFlatShading = false;
        }
        // Update
        mesh.computeWorldMatrix(true);
        scene.onMeshImportedObservable.notifyObservers(mesh);
    }
    static _CleanMatricesWeights(parsedGeometry, mesh) {
        const epsilon = 1e-3;
        if (!(0, $ec6fcfe568825603$export$6ec0b2ecad265743).CleanBoneMatrixWeights) return;
        let noInfluenceBoneIndex = 0.0;
        if (parsedGeometry.skeletonId > -1) {
            const skeleton = mesh.getScene().getLastSkeletonById(parsedGeometry.skeletonId);
            if (!skeleton) return;
            noInfluenceBoneIndex = skeleton.bones.length;
        } else return;
        const matricesIndices = mesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        const matricesIndicesExtra = mesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
        const matricesWeights = parsedGeometry.matricesWeights;
        const matricesWeightsExtra = parsedGeometry.matricesWeightsExtra;
        const influencers = parsedGeometry.numBoneInfluencer;
        const size = matricesWeights.length;
        for(let i = 0; i < size; i += 4){
            let weight = 0.0;
            let firstZeroWeight = -1;
            for(let j = 0; j < 4; j++){
                const w = matricesWeights[i + j];
                weight += w;
                if (w < epsilon && firstZeroWeight < 0) firstZeroWeight = j;
            }
            if (matricesWeightsExtra) for(let j = 0; j < 4; j++){
                const w = matricesWeightsExtra[i + j];
                weight += w;
                if (w < epsilon && firstZeroWeight < 0) firstZeroWeight = j + 4;
            }
            if (firstZeroWeight < 0 || firstZeroWeight > influencers - 1) firstZeroWeight = influencers - 1;
            if (weight > epsilon) {
                const mweight = 1.0 / weight;
                for(let j = 0; j < 4; j++)matricesWeights[i + j] *= mweight;
                if (matricesWeightsExtra) for(let j = 0; j < 4; j++)matricesWeightsExtra[i + j] *= mweight;
            } else if (firstZeroWeight >= 4) {
                matricesWeightsExtra[i + firstZeroWeight - 4] = 1.0 - weight;
                matricesIndicesExtra[i + firstZeroWeight - 4] = noInfluenceBoneIndex;
            } else {
                matricesWeights[i + firstZeroWeight] = 1.0 - weight;
                matricesIndices[i + firstZeroWeight] = noInfluenceBoneIndex;
            }
        }
        mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, matricesIndices);
        if (parsedGeometry.matricesWeightsExtra) mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, matricesIndicesExtra);
    }
    /**
     * Create a new geometry from persisted data (Using .babylon file format)
     * @param parsedVertexData defines the persisted data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root url to use to load assets (like delayed data)
     * @returns the new geometry object
     */ static Parse(parsedVertexData, scene, rootUrl) {
        const geometry = new $07dfcf3146d3f600$export$2db6c17465f94a2(parsedVertexData.id, scene, undefined, parsedVertexData.updatable);
        geometry._loadedUniqueId = parsedVertexData.uniqueId;
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(geometry, parsedVertexData.tags);
        if (parsedVertexData.delayLoadingFile) {
            geometry.delayLoadState = 4;
            geometry.delayLoadingFile = rootUrl + parsedVertexData.delayLoadingFile;
            geometry._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)((0, $ha1VO.Vector3).FromArray(parsedVertexData.boundingBoxMinimum), (0, $ha1VO.Vector3).FromArray(parsedVertexData.boundingBoxMaximum));
            geometry._delayInfo = [];
            if (parsedVertexData.hasUVs) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UVKind);
            if (parsedVertexData.hasUVs2) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV2Kind);
            if (parsedVertexData.hasUVs3) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV3Kind);
            if (parsedVertexData.hasUVs4) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV4Kind);
            if (parsedVertexData.hasUVs5) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV5Kind);
            if (parsedVertexData.hasUVs6) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV6Kind);
            if (parsedVertexData.hasColors) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).ColorKind);
            if (parsedVertexData.hasMatricesIndices) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            if (parsedVertexData.hasMatricesWeights) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            geometry._delayLoadingFunction = (0, $4014d881db0e9bc6$export$8570d39351855acb).ImportVertexData;
        } else (0, $4014d881db0e9bc6$export$8570d39351855acb).ImportVertexData(parsedVertexData, geometry);
        scene.pushGeometry(geometry, true);
        return geometry;
    }
}



var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");


var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");


var $8DoUR = parcelRequire("8DoUR");
const $ecfbb5db4d70b862$var$convertRHSToLHS = (0, $ha1VO.Matrix).Compose((0, $ha1VO.Vector3).One(), (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0), (0, $ha1VO.Vector3).Zero());
class $ecfbb5db4d70b862$export$b600d080bad015f extends (0, $021dcb6a570ae9c1$export$85c928794f8d04d4) {
    /**
     * Gets or sets the billboard mode. Default is 0.
     *
     * | Value | Type | Description |
     * | --- | --- | --- |
     * | 0 | BILLBOARDMODE_NONE |  |
     * | 1 | BILLBOARDMODE_X |  |
     * | 2 | BILLBOARDMODE_Y |  |
     * | 4 | BILLBOARDMODE_Z |  |
     * | 7 | BILLBOARDMODE_ALL |  |
     *
     */ get billboardMode() {
        return this._billboardMode;
    }
    set billboardMode(value) {
        if (this._billboardMode === value) return;
        this._billboardMode = value;
        this._cache.useBillboardPosition = (this._billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_USE_POSITION) !== 0;
        this._computeUseBillboardPath();
    }
    /**
     * Gets or sets a boolean indicating that parent rotation should be preserved when using billboards.
     * This could be useful for glTF objects where parent rotation helps converting from right handed to left handed
     */ get preserveParentRotationForBillboard() {
        return this._preserveParentRotationForBillboard;
    }
    set preserveParentRotationForBillboard(value) {
        if (value === this._preserveParentRotationForBillboard) return;
        this._preserveParentRotationForBillboard = value;
        this._computeUseBillboardPath();
    }
    _computeUseBillboardPath() {
        this._cache.useBillboardPath = this._billboardMode !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
    }
    /**
     * Gets or sets the distance of the object to max, often used by skybox
     */ get infiniteDistance() {
        return this._infiniteDistance;
    }
    set infiniteDistance(value) {
        if (this._infiniteDistance === value) return;
        this._infiniteDistance = value;
    }
    constructor(name, scene = null, isPure = true){
        super(name, scene, false);
        this._forward = new (0, $ha1VO.Vector3)(0, 0, 1);
        this._up = new (0, $ha1VO.Vector3)(0, 1, 0);
        this._right = new (0, $ha1VO.Vector3)(1, 0, 0);
        // Properties
        this._position = (0, $ha1VO.Vector3).Zero();
        this._rotation = (0, $ha1VO.Vector3).Zero();
        this._rotationQuaternion = null;
        this._scaling = (0, $ha1VO.Vector3).One();
        this._transformToBoneReferal = null;
        this._isAbsoluteSynced = false;
        this._billboardMode = $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE;
        this._preserveParentRotationForBillboard = false;
        /**
         * Multiplication factor on scale x/y/z when computing the world matrix. Eg. for a 1x1x1 cube setting this to 2 will make it a 2x2x2 cube
         */ this.scalingDeterminant = 1;
        this._infiniteDistance = false;
        /**
         * Gets or sets a boolean indicating that non uniform scaling (when at least one component is different from others) should be ignored.
         * By default the system will update normals to compensate
         */ this.ignoreNonUniformScaling = false;
        /**
         * Gets or sets a boolean indicating that even if rotationQuaternion is defined, you can keep updating rotation property and Babylon.js will just mix both
         */ this.reIntegrateRotationIntoRotationQuaternion = false;
        // Cache
        /** @internal */ this._poseMatrix = null;
        /** @internal */ this._localMatrix = (0, $ha1VO.Matrix).Zero();
        this._usePivotMatrix = false;
        this._absolutePosition = (0, $ha1VO.Vector3).Zero();
        this._absoluteScaling = (0, $ha1VO.Vector3).Zero();
        this._absoluteRotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._pivotMatrix = (0, $ha1VO.Matrix).Identity();
        /** @internal */ this._postMultiplyPivotMatrix = false;
        this._isWorldMatrixFrozen = false;
        /** @internal */ this._indexInSceneTransformNodesArray = -1;
        /**
         * An event triggered after the world matrix is updated
         */ this.onAfterWorldMatrixUpdateObservable = new (0, $diGQf.Observable)();
        this._nonUniformScaling = false;
        if (isPure) this.getScene().addTransformNode(this);
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "TransformNode" string
     */ getClassName() {
        return "TransformNode";
    }
    /**
     * Gets or set the node position (default is (0.0, 0.0, 0.0))
     */ get position() {
        return this._position;
    }
    set position(newPosition) {
        this._position = newPosition;
        this._markAsDirtyInternal();
    }
    /**
     * return true if a pivot has been set
     * @returns true if a pivot matrix is used
     */ isUsingPivotMatrix() {
        return this._usePivotMatrix;
    }
    /**
     * @returns true if pivot matrix must be cancelled in the world matrix. When this parameter is set to true (default), the inverse of the pivot matrix is also applied at the end to cancel the transformation effect.
     */ isUsingPostMultiplyPivotMatrix() {
        return this._postMultiplyPivotMatrix;
    }
    /**
     * Gets or sets the rotation property : a Vector3 defining the rotation value in radians around each local axis X, Y, Z  (default is (0.0, 0.0, 0.0)).
     * If rotation quaternion is set, this Vector3 will be ignored and copy from the quaternion
     */ get rotation() {
        return this._rotation;
    }
    set rotation(newRotation) {
        this._rotation = newRotation;
        this._rotationQuaternion = null;
        this._markAsDirtyInternal();
    }
    /**
     * Gets or sets the scaling property : a Vector3 defining the node scaling along each local axis X, Y, Z (default is (1.0, 1.0, 1.0)).
     */ get scaling() {
        return this._scaling;
    }
    set scaling(newScaling) {
        this._scaling = newScaling;
        this._markAsDirtyInternal();
    }
    /**
     * Gets or sets the rotation Quaternion property : this a Quaternion object defining the node rotation by using a unit quaternion (undefined by default, but can be null).
     * If set, only the rotationQuaternion is then used to compute the node rotation (ie. node.rotation will be ignored)
     */ get rotationQuaternion() {
        return this._rotationQuaternion;
    }
    set rotationQuaternion(quaternion) {
        this._rotationQuaternion = quaternion;
        //reset the rotation vector.
        if (quaternion) this._rotation.setAll(0.0);
        this._markAsDirtyInternal();
    }
    _markAsDirtyInternal() {
        if (this._isDirty) return;
        this._isDirty = true;
        if (this.customMarkAsDirty) this.customMarkAsDirty();
    }
    /**
     * The forward direction of that transform in world space.
     */ get forward() {
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(0, 0, this.getScene().useRightHandedSystem ? -1 : 1.0, this.getWorldMatrix(), this._forward);
        return this._forward.normalize();
    }
    /**
     * The up direction of that transform in world space.
     */ get up() {
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(0, 1, 0, this.getWorldMatrix(), this._up);
        return this._up.normalize();
    }
    /**
     * The right direction of that transform in world space.
     */ get right() {
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(this.getScene().useRightHandedSystem ? -1 : 1.0, 0, 0, this.getWorldMatrix(), this._right);
        return this._right.normalize();
    }
    /**
     * Copies the parameter passed Matrix into the mesh Pose matrix.
     * @param matrix the matrix to copy the pose from
     * @returns this TransformNode.
     */ updatePoseMatrix(matrix) {
        if (!this._poseMatrix) {
            this._poseMatrix = matrix.clone();
            return this;
        }
        this._poseMatrix.copyFrom(matrix);
        return this;
    }
    /**
     * Returns the mesh Pose matrix.
     * @returns the pose matrix
     */ getPoseMatrix() {
        if (!this._poseMatrix) this._poseMatrix = (0, $ha1VO.Matrix).Identity();
        return this._poseMatrix;
    }
    /** @internal */ _isSynchronized() {
        const cache = this._cache;
        if (this._billboardMode !== cache.billboardMode || this._billboardMode !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE) return false;
        if (cache.pivotMatrixUpdated) return false;
        if (this._infiniteDistance) return false;
        if (this._position._isDirty) return false;
        if (this._scaling._isDirty) return false;
        if (this._rotationQuaternion && this._rotationQuaternion._isDirty || this._rotation._isDirty) return false;
        return true;
    }
    /** @internal */ _initCache() {
        super._initCache();
        const cache = this._cache;
        cache.localMatrixUpdated = false;
        cache.billboardMode = -1;
        cache.infiniteDistance = false;
        cache.useBillboardPosition = false;
        cache.useBillboardPath = false;
    }
    /**
     * Returns the current mesh absolute position.
     * Returns a Vector3.
     */ get absolutePosition() {
        return this.getAbsolutePosition();
    }
    /**
     * Returns the current mesh absolute scaling.
     * Returns a Vector3.
     */ get absoluteScaling() {
        this._syncAbsoluteScalingAndRotation();
        return this._absoluteScaling;
    }
    /**
     * Returns the current mesh absolute rotation.
     * Returns a Quaternion.
     */ get absoluteRotationQuaternion() {
        this._syncAbsoluteScalingAndRotation();
        return this._absoluteRotationQuaternion;
    }
    /**
     * Sets a new matrix to apply before all other transformation
     * @param matrix defines the transform matrix
     * @returns the current TransformNode
     */ setPreTransformMatrix(matrix) {
        return this.setPivotMatrix(matrix, false);
    }
    /**
     * Sets a new pivot matrix to the current node
     * @param matrix defines the new pivot matrix to use
     * @param postMultiplyPivotMatrix defines if the pivot matrix must be cancelled in the world matrix. When this parameter is set to true (default), the inverse of the pivot matrix is also applied at the end to cancel the transformation effect
     * @returns the current TransformNode
     */ setPivotMatrix(matrix, postMultiplyPivotMatrix = true) {
        this._pivotMatrix.copyFrom(matrix);
        this._usePivotMatrix = !this._pivotMatrix.isIdentity();
        this._cache.pivotMatrixUpdated = true;
        this._postMultiplyPivotMatrix = postMultiplyPivotMatrix;
        if (this._postMultiplyPivotMatrix) {
            if (!this._pivotMatrixInverse) this._pivotMatrixInverse = (0, $ha1VO.Matrix).Invert(this._pivotMatrix);
            else this._pivotMatrix.invertToRef(this._pivotMatrixInverse);
        }
        return this;
    }
    /**
     * Returns the mesh pivot matrix.
     * Default : Identity.
     * @returns the matrix
     */ getPivotMatrix() {
        return this._pivotMatrix;
    }
    /**
     * Instantiate (when possible) or clone that node with its hierarchy
     * @param newParent defines the new parent to use for the instance (or clone)
     * @param options defines options to configure how copy is done
     * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
     * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
     * @returns an instance (or a clone) of the current node with its hierarchy
     */ instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
        const clone = this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true);
        if (clone) {
            if (onNewNodeCreated) onNewNodeCreated(this, clone);
        }
        for (const child of this.getChildTransformNodes(true))child.instantiateHierarchy(clone, options, onNewNodeCreated);
        return clone;
    }
    /**
     * Prevents the World matrix to be computed any longer
     * @param newWorldMatrix defines an optional matrix to use as world matrix
     * @param decompose defines whether to decompose the given newWorldMatrix or directly assign
     * @returns the TransformNode.
     */ freezeWorldMatrix(newWorldMatrix = null, decompose = false) {
        if (newWorldMatrix) {
            if (decompose) {
                this._rotation.setAll(0);
                this._rotationQuaternion = this._rotationQuaternion || (0, $ha1VO.Quaternion).Identity();
                newWorldMatrix.decompose(this._scaling, this._rotationQuaternion, this._position);
                this.computeWorldMatrix(true);
            } else {
                this._worldMatrix = newWorldMatrix;
                this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]);
                this._afterComputeWorldMatrix();
            }
        } else {
            this._isWorldMatrixFrozen = false; // no guarantee world is not already frozen, switch off temporarily
            this.computeWorldMatrix(true);
        }
        this._isDirty = false;
        this._isWorldMatrixFrozen = true;
        return this;
    }
    /**
     * Allows back the World matrix computation.
     * @returns the TransformNode.
     */ unfreezeWorldMatrix() {
        this._isWorldMatrixFrozen = false;
        this.computeWorldMatrix(true);
        return this;
    }
    /**
     * True if the World matrix has been frozen.
     */ get isWorldMatrixFrozen() {
        return this._isWorldMatrixFrozen;
    }
    /**
     * Returns the mesh absolute position in the World.
     * @returns a Vector3.
     */ getAbsolutePosition() {
        this.computeWorldMatrix();
        return this._absolutePosition;
    }
    /**
     * Sets the mesh absolute position in the World from a Vector3 or an Array(3).
     * @param absolutePosition the absolute position to set
     * @returns the TransformNode.
     */ setAbsolutePosition(absolutePosition) {
        if (!absolutePosition) return this;
        let absolutePositionX;
        let absolutePositionY;
        let absolutePositionZ;
        if (absolutePosition.x === undefined) {
            if (arguments.length < 3) return this;
            absolutePositionX = arguments[0];
            absolutePositionY = arguments[1];
            absolutePositionZ = arguments[2];
        } else {
            absolutePositionX = absolutePosition.x;
            absolutePositionY = absolutePosition.y;
            absolutePositionZ = absolutePosition.z;
        }
        if (this.parent) {
            const invertParentWorldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            this.parent.getWorldMatrix().invertToRef(invertParentWorldMatrix);
            (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(absolutePositionX, absolutePositionY, absolutePositionZ, invertParentWorldMatrix, this.position);
        } else {
            this.position.x = absolutePositionX;
            this.position.y = absolutePositionY;
            this.position.z = absolutePositionZ;
        }
        this._absolutePosition.copyFrom(absolutePosition);
        return this;
    }
    /**
     * Sets the mesh position in its local space.
     * @param vector3 the position to set in localspace
     * @returns the TransformNode.
     */ setPositionWithLocalVector(vector3) {
        this.computeWorldMatrix();
        this.position = (0, $ha1VO.Vector3).TransformNormal(vector3, this._localMatrix);
        return this;
    }
    /**
     * Returns the mesh position in the local space from the current World matrix values.
     * @returns a new Vector3.
     */ getPositionExpressedInLocalSpace() {
        this.computeWorldMatrix();
        const invLocalWorldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        this._localMatrix.invertToRef(invLocalWorldMatrix);
        return (0, $ha1VO.Vector3).TransformNormal(this.position, invLocalWorldMatrix);
    }
    /**
     * Translates the mesh along the passed Vector3 in its local space.
     * @param vector3 the distance to translate in localspace
     * @returns the TransformNode.
     */ locallyTranslate(vector3) {
        this.computeWorldMatrix(true);
        this.position = (0, $ha1VO.Vector3).TransformCoordinates(vector3, this._localMatrix);
        return this;
    }
    /**
     * Orients a mesh towards a target point. Mesh must be drawn facing user.
     * @param targetPoint the position (must be in same space as current mesh) to look at
     * @param yawCor optional yaw (y-axis) correction in radians
     * @param pitchCor optional pitch (x-axis) correction in radians
     * @param rollCor optional roll (z-axis) correction in radians
     * @param space the chosen space of the target
     * @returns the TransformNode.
     */ lookAt(targetPoint, yawCor = 0, pitchCor = 0, rollCor = 0, space = 0 /* Space.LOCAL */ ) {
        const dv = $ecfbb5db4d70b862$export$b600d080bad015f._LookAtVectorCache;
        const pos = space === 0 /* Space.LOCAL */  ? this.position : this.getAbsolutePosition();
        targetPoint.subtractToRef(pos, dv);
        this.setDirection(dv, yawCor, pitchCor, rollCor);
        // Correct for parent's rotation offset
        if (space === 1 /* Space.WORLD */  && this.parent) {
            if (this.rotationQuaternion) {
                // Get local rotation matrix of the looking object
                const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                this.rotationQuaternion.toRotationMatrix(rotationMatrix);
                // Offset rotation by parent's inverted rotation matrix to correct in world space
                const parentRotationMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                this.parent.getWorldMatrix().getRotationMatrixToRef(parentRotationMatrix);
                parentRotationMatrix.invert();
                rotationMatrix.multiplyToRef(parentRotationMatrix, rotationMatrix);
                this.rotationQuaternion.fromRotationMatrix(rotationMatrix);
            } else {
                // Get local rotation matrix of the looking object
                const quaternionRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
                (0, $ha1VO.Quaternion).FromEulerVectorToRef(this.rotation, quaternionRotation);
                const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                quaternionRotation.toRotationMatrix(rotationMatrix);
                // Offset rotation by parent's inverted rotation matrix to correct in world space
                const parentRotationMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                this.parent.getWorldMatrix().getRotationMatrixToRef(parentRotationMatrix);
                parentRotationMatrix.invert();
                rotationMatrix.multiplyToRef(parentRotationMatrix, rotationMatrix);
                quaternionRotation.fromRotationMatrix(rotationMatrix);
                quaternionRotation.toEulerAnglesToRef(this.rotation);
            }
        }
        return this;
    }
    /**
     * Returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
     * This Vector3 is expressed in the World space.
     * @param localAxis axis to rotate
     * @returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
     */ getDirection(localAxis) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getDirectionToRef(localAxis, result);
        return result;
    }
    /**
     * Sets the Vector3 "result" as the rotated Vector3 "localAxis" in the same rotation than the mesh.
     * localAxis is expressed in the mesh local space.
     * result is computed in the World space from the mesh World matrix.
     * @param localAxis axis to rotate
     * @param result the resulting transformnode
     * @returns this TransformNode.
     */ getDirectionToRef(localAxis, result) {
        (0, $ha1VO.Vector3).TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
        return this;
    }
    /**
     * Sets this transform node rotation to the given local axis.
     * @param localAxis the axis in local space
     * @param yawCor optional yaw (y-axis) correction in radians
     * @param pitchCor optional pitch (x-axis) correction in radians
     * @param rollCor optional roll (z-axis) correction in radians
     * @returns this TransformNode
     */ setDirection(localAxis, yawCor = 0, pitchCor = 0, rollCor = 0) {
        const yaw = -Math.atan2(localAxis.z, localAxis.x) + Math.PI / 2;
        const len = Math.sqrt(localAxis.x * localAxis.x + localAxis.z * localAxis.z);
        const pitch = -Math.atan2(localAxis.y, len);
        if (this.rotationQuaternion) (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(yaw + yawCor, pitch + pitchCor, rollCor, this.rotationQuaternion);
        else {
            this.rotation.x = pitch + pitchCor;
            this.rotation.y = yaw + yawCor;
            this.rotation.z = rollCor;
        }
        return this;
    }
    /**
     * Sets a new pivot point to the current node
     * @param point defines the new pivot point to use
     * @param space defines if the point is in world or local space (local by default)
     * @returns the current TransformNode
     */ setPivotPoint(point, space = 0 /* Space.LOCAL */ ) {
        if (this.getScene().getRenderId() == 0) this.computeWorldMatrix(true);
        const wm = this.getWorldMatrix();
        if (space == 1 /* Space.WORLD */ ) {
            const tmat = (0, $ha1VO.TmpVectors).Matrix[0];
            wm.invertToRef(tmat);
            point = (0, $ha1VO.Vector3).TransformCoordinates(point, tmat);
        }
        return this.setPivotMatrix((0, $ha1VO.Matrix).Translation(-point.x, -point.y, -point.z), true);
    }
    /**
     * Returns a new Vector3 set with the mesh pivot point coordinates in the local space.
     * @returns the pivot point
     */ getPivotPoint() {
        const point = (0, $ha1VO.Vector3).Zero();
        this.getPivotPointToRef(point);
        return point;
    }
    /**
     * Sets the passed Vector3 "result" with the coordinates of the mesh pivot point in the local space.
     * @param result the vector3 to store the result
     * @returns this TransformNode.
     */ getPivotPointToRef(result) {
        result.x = -this._pivotMatrix.m[12];
        result.y = -this._pivotMatrix.m[13];
        result.z = -this._pivotMatrix.m[14];
        return this;
    }
    /**
     * Returns a new Vector3 set with the mesh pivot point World coordinates.
     * @returns a new Vector3 set with the mesh pivot point World coordinates.
     */ getAbsolutePivotPoint() {
        const point = (0, $ha1VO.Vector3).Zero();
        this.getAbsolutePivotPointToRef(point);
        return point;
    }
    /**
     * Sets the Vector3 "result" coordinates with the mesh pivot point World coordinates.
     * @param result vector3 to store the result
     * @returns this TransformNode.
     */ getAbsolutePivotPointToRef(result) {
        this.getPivotPointToRef(result);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(result, this.getWorldMatrix(), result);
        return this;
    }
    /**
     * Flag the transform node as dirty (Forcing it to update everything)
     * @param property if set to "rotation" the objects rotationQuaternion will be set to null
     * @returns this  node
     */ markAsDirty(property) {
        if (this._isDirty) return this;
        // We need to explicitly update the children
        // as the scene.evaluateActiveMeshes will not poll the transform nodes
        if (this._children) for (const child of this._children)child.markAsDirty(property);
        return super.markAsDirty(property);
    }
    /**
     * Defines the passed node as the parent of the current node.
     * The node will remain exactly where it is and its position / rotation will be updated accordingly.
     * If you don't want to preserve the current rotation / position, assign the parent through parent accessor.
     * Note that if the mesh has a pivot matrix / point defined it will be applied after the parent was updated.
     * In that case the node will not remain in the same space as it is, as the pivot will be applied.
     * To avoid this, you can set updatePivot to true and the pivot will be updated to identity
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
     * @param node the node ot set as the parent
     * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
     * @param updatePivot if true, update the pivot matrix to keep the node in the same space as before
     * @returns this TransformNode.
     */ setParent(node, preserveScalingSign = false, updatePivot = false) {
        if (!node && !this.parent) return this;
        const quatRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
        const position = (0, $ha1VO.TmpVectors).Vector3[0];
        const scale = (0, $ha1VO.TmpVectors).Vector3[1];
        const invParentMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
        (0, $ha1VO.Matrix).IdentityToRef(invParentMatrix);
        const composedMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        this.computeWorldMatrix(true);
        let currentRotation = this.rotationQuaternion;
        if (!currentRotation) {
            currentRotation = $ecfbb5db4d70b862$export$b600d080bad015f._TmpRotation;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, currentRotation);
        }
        // current global transformation without pivot
        (0, $ha1VO.Matrix).ComposeToRef(this.scaling, currentRotation, this.position, composedMatrix);
        if (this.parent) composedMatrix.multiplyToRef(this.parent.computeWorldMatrix(true), composedMatrix);
        // is a node was set, calculate the difference between this and the node
        if (node) {
            node.computeWorldMatrix(true).invertToRef(invParentMatrix);
            composedMatrix.multiplyToRef(invParentMatrix, composedMatrix);
        }
        composedMatrix.decompose(scale, quatRotation, position, preserveScalingSign ? this : undefined);
        if (this.rotationQuaternion) this.rotationQuaternion.copyFrom(quatRotation);
        else quatRotation.toEulerAnglesToRef(this.rotation);
        this.scaling.copyFrom(scale);
        this.position.copyFrom(position);
        this.parent = node;
        if (updatePivot) this.setPivotMatrix((0, $ha1VO.Matrix).Identity());
        return this;
    }
    /**
     * Adds the passed mesh as a child to the current mesh.
     * The node will remain exactly where it is and its position / rotation will be updated accordingly.
     * This method is equivalent to calling setParent().
     * @param mesh defines the child mesh
     * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
     * @returns the current mesh
     */ addChild(mesh, preserveScalingSign = false) {
        mesh.setParent(this, preserveScalingSign);
        return this;
    }
    /**
     * Removes the passed mesh from the current mesh children list
     * @param mesh defines the child mesh
     * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
     * @returns the current mesh
     */ removeChild(mesh, preserveScalingSign = false) {
        if (mesh.parent !== this) return this;
        mesh.setParent(null, preserveScalingSign);
        return this;
    }
    /**
     * True if the scaling property of this object is non uniform eg. (1,2,1)
     */ get nonUniformScaling() {
        return this._nonUniformScaling;
    }
    /**
     * @internal
     */ _updateNonUniformScalingState(value) {
        if (this._nonUniformScaling === value) return false;
        this._nonUniformScaling = value;
        return true;
    }
    /**
     * Attach the current TransformNode to another TransformNode associated with a bone
     * @param bone Bone affecting the TransformNode
     * @param affectedTransformNode TransformNode associated with the bone
     * @returns this object
     */ attachToBone(bone, affectedTransformNode) {
        this._currentParentWhenAttachingToBone = this.parent;
        this._transformToBoneReferal = affectedTransformNode;
        this.parent = bone;
        bone.getSkeleton().prepare(true); // make sure bone.getFinalMatrix() is up to date
        if (bone.getFinalMatrix().determinant() < 0) this.scalingDeterminant *= -1;
        return this;
    }
    /**
     * Detach the transform node if its associated with a bone
     * @param resetToPreviousParent Indicates if the parent that was in effect when attachToBone was called should be set back or if we should set parent to null instead (defaults to the latter)
     * @returns this object
     */ detachFromBone(resetToPreviousParent = false) {
        if (!this.parent) {
            if (resetToPreviousParent) this.parent = this._currentParentWhenAttachingToBone;
            return this;
        }
        if (this.parent.getWorldMatrix().determinant() < 0) this.scalingDeterminant *= -1;
        this._transformToBoneReferal = null;
        if (resetToPreviousParent) this.parent = this._currentParentWhenAttachingToBone;
        else this.parent = null;
        return this;
    }
    /**
     * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in the given space.
     * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
     * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
     * The passed axis is also normalized.
     * @param axis the axis to rotate around
     * @param amount the amount to rotate in radians
     * @param space Space to rotate in (Default: local)
     * @returns the TransformNode.
     */ rotate(axis, amount, space) {
        axis.normalize();
        if (!this.rotationQuaternion) {
            this.rotationQuaternion = this.rotation.toQuaternion();
            this.rotation.setAll(0);
        }
        let rotationQuaternion;
        if (!space || space === 0 /* Space.LOCAL */ ) {
            rotationQuaternion = (0, $ha1VO.Quaternion).RotationAxisToRef(axis, amount, $ecfbb5db4d70b862$export$b600d080bad015f._RotationAxisCache);
            this.rotationQuaternion.multiplyToRef(rotationQuaternion, this.rotationQuaternion);
        } else {
            if (this.parent) {
                const parentWorldMatrix = this.parent.getWorldMatrix();
                const invertParentWorldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                parentWorldMatrix.invertToRef(invertParentWorldMatrix);
                axis = (0, $ha1VO.Vector3).TransformNormal(axis, invertParentWorldMatrix);
                if (parentWorldMatrix.determinant() < 0) amount *= -1;
            }
            rotationQuaternion = (0, $ha1VO.Quaternion).RotationAxisToRef(axis, amount, $ecfbb5db4d70b862$export$b600d080bad015f._RotationAxisCache);
            rotationQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
        }
        return this;
    }
    /**
     * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in world space.
     * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
     * The passed axis is also normalized. .
     * Method is based on http://www.euclideanspace.com/maths/geometry/affine/aroundPoint/index.htm
     * @param point the point to rotate around
     * @param axis the axis to rotate around
     * @param amount the amount to rotate in radians
     * @returns the TransformNode
     */ rotateAround(point, axis, amount) {
        axis.normalize();
        if (!this.rotationQuaternion) {
            this.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z);
            this.rotation.setAll(0);
        }
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        const finalScale = (0, $ha1VO.TmpVectors).Vector3[1];
        const finalTranslation = (0, $ha1VO.TmpVectors).Vector3[2];
        const finalRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
        const translationMatrix = (0, $ha1VO.TmpVectors).Matrix[0]; // T
        const translationMatrixInv = (0, $ha1VO.TmpVectors).Matrix[1]; // T'
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[2]; // R
        const finalMatrix = (0, $ha1VO.TmpVectors).Matrix[3]; // T' x R x T
        point.subtractToRef(this.position, tmpVector);
        (0, $ha1VO.Matrix).TranslationToRef(tmpVector.x, tmpVector.y, tmpVector.z, translationMatrix); // T
        (0, $ha1VO.Matrix).TranslationToRef(-tmpVector.x, -tmpVector.y, -tmpVector.z, translationMatrixInv); // T'
        (0, $ha1VO.Matrix).RotationAxisToRef(axis, amount, rotationMatrix); // R
        translationMatrixInv.multiplyToRef(rotationMatrix, finalMatrix); // T' x R
        finalMatrix.multiplyToRef(translationMatrix, finalMatrix); // T' x R x T
        finalMatrix.decompose(finalScale, finalRotation, finalTranslation);
        this.position.addInPlace(finalTranslation);
        finalRotation.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
        return this;
    }
    /**
     * Translates the mesh along the axis vector for the passed distance in the given space.
     * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
     * @param axis the axis to translate in
     * @param distance the distance to translate
     * @param space Space to rotate in (Default: local)
     * @returns the TransformNode.
     */ translate(axis, distance, space) {
        const displacementVector = axis.scale(distance);
        if (!space || space === 0 /* Space.LOCAL */ ) {
            const tempV3 = this.getPositionExpressedInLocalSpace().add(displacementVector);
            this.setPositionWithLocalVector(tempV3);
        } else this.setAbsolutePosition(this.getAbsolutePosition().add(displacementVector));
        return this;
    }
    /**
     * Adds a rotation step to the mesh current rotation.
     * x, y, z are Euler angles expressed in radians.
     * This methods updates the current mesh rotation, either mesh.rotation, either mesh.rotationQuaternion if it's set.
     * This means this rotation is made in the mesh local space only.
     * It's useful to set a custom rotation order different from the BJS standard one YXZ.
     * Example : this rotates the mesh first around its local X axis, then around its local Z axis, finally around its local Y axis.
     * ```javascript
     * mesh.addRotation(x1, 0, 0).addRotation(0, 0, z2).addRotation(0, 0, y3);
     * ```
     * Note that `addRotation()` accumulates the passed rotation values to the current ones and computes the .rotation or .rotationQuaternion updated values.
     * Under the hood, only quaternions are used. So it's a little faster is you use .rotationQuaternion because it doesn't need to translate them back to Euler angles.
     * @param x Rotation to add
     * @param y Rotation to add
     * @param z Rotation to add
     * @returns the TransformNode.
     */ addRotation(x, y, z) {
        let rotationQuaternion;
        if (this.rotationQuaternion) rotationQuaternion = this.rotationQuaternion;
        else {
            rotationQuaternion = (0, $ha1VO.TmpVectors).Quaternion[1];
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, rotationQuaternion);
        }
        const accumulation = (0, $ha1VO.TmpVectors).Quaternion[0];
        (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(y, x, z, accumulation);
        rotationQuaternion.multiplyInPlace(accumulation);
        if (!this.rotationQuaternion) rotationQuaternion.toEulerAnglesToRef(this.rotation);
        return this;
    }
    /**
     * @internal
     */ _getEffectiveParent() {
        return this.parent;
    }
    /**
     * Returns whether the transform node world matrix computation needs the camera information to be computed.
     * This is the case when the node is a billboard or has an infinite distance for instance.
     * @returns true if the world matrix computation needs the camera information to be computed
     */ isWorldMatrixCameraDependent() {
        return this._infiniteDistance && !this.parent || this._billboardMode !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
    }
    /**
     * Computes the world matrix of the node
     * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
     * @param camera defines the camera used if different from the scene active camera (This is used with modes like Billboard or infinite distance)
     * @returns the world matrix
     */ computeWorldMatrix(force = false, camera = null) {
        if (this._isWorldMatrixFrozen && !this._isDirty) return this._worldMatrix;
        const currentRenderId = this.getScene().getRenderId();
        if (!this._isDirty && !force && (this._currentRenderId === currentRenderId || this.isSynchronized())) {
            this._currentRenderId = currentRenderId;
            return this._worldMatrix;
        }
        camera = camera || this.getScene().activeCamera;
        this._updateCache();
        const cache = this._cache;
        cache.pivotMatrixUpdated = false;
        cache.billboardMode = this.billboardMode;
        cache.infiniteDistance = this.infiniteDistance;
        cache.parent = this._parentNode;
        this._currentRenderId = currentRenderId;
        this._childUpdateId += 1;
        this._isDirty = false;
        this._position._isDirty = false;
        this._rotation._isDirty = false;
        this._scaling._isDirty = false;
        const parent = this._getEffectiveParent();
        // Scaling
        const scaling = $ecfbb5db4d70b862$export$b600d080bad015f._TmpScaling;
        let translation = this._position;
        // Translation
        if (this._infiniteDistance) {
            if (!this.parent && camera) {
                const cameraWorldMatrix = camera.getWorldMatrix();
                const cameraGlobalPosition = new (0, $ha1VO.Vector3)(cameraWorldMatrix.m[12], cameraWorldMatrix.m[13], cameraWorldMatrix.m[14]);
                translation = $ecfbb5db4d70b862$export$b600d080bad015f._TmpTranslation;
                translation.copyFromFloats(this._position.x + cameraGlobalPosition.x, this._position.y + cameraGlobalPosition.y, this._position.z + cameraGlobalPosition.z);
            }
        }
        // Scaling
        scaling.copyFromFloats(this._scaling.x * this.scalingDeterminant, this._scaling.y * this.scalingDeterminant, this._scaling.z * this.scalingDeterminant);
        // Rotation
        let rotation;
        if (this._rotationQuaternion) {
            this._rotationQuaternion._isDirty = false;
            rotation = this._rotationQuaternion;
            if (this.reIntegrateRotationIntoRotationQuaternion) {
                const len = this.rotation.lengthSquared();
                if (len) {
                    this._rotationQuaternion.multiplyInPlace((0, $ha1VO.Quaternion).RotationYawPitchRoll(this._rotation.y, this._rotation.x, this._rotation.z));
                    this._rotation.copyFromFloats(0, 0, 0);
                }
            }
        } else {
            rotation = $ecfbb5db4d70b862$export$b600d080bad015f._TmpRotation;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, rotation);
        }
        // Compose
        if (this._usePivotMatrix) {
            const scaleMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
            (0, $ha1VO.Matrix).ScalingToRef(scaling.x, scaling.y, scaling.z, scaleMatrix);
            // Rotation
            const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            rotation.toRotationMatrix(rotationMatrix);
            // Composing transformations
            this._pivotMatrix.multiplyToRef(scaleMatrix, (0, $ha1VO.TmpVectors).Matrix[4]);
            (0, $ha1VO.TmpVectors).Matrix[4].multiplyToRef(rotationMatrix, this._localMatrix);
            // Post multiply inverse of pivotMatrix
            if (this._postMultiplyPivotMatrix) this._localMatrix.multiplyToRef(this._pivotMatrixInverse, this._localMatrix);
            this._localMatrix.addTranslationFromFloats(translation.x, translation.y, translation.z);
        } else (0, $ha1VO.Matrix).ComposeToRef(scaling, rotation, translation, this._localMatrix);
        // Parent
        if (parent && parent.getWorldMatrix) {
            if (force) parent.computeWorldMatrix(force);
            if (cache.useBillboardPath) {
                if (this._transformToBoneReferal) {
                    const bone = this.parent;
                    bone.getSkeleton().prepare();
                    bone.getFinalMatrix().multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), (0, $ha1VO.TmpVectors).Matrix[7]);
                } else (0, $ha1VO.TmpVectors).Matrix[7].copyFrom(parent.getWorldMatrix());
                // Extract scaling and translation from parent
                const translation = (0, $ha1VO.TmpVectors).Vector3[5];
                const scale = (0, $ha1VO.TmpVectors).Vector3[6];
                const orientation = (0, $ha1VO.TmpVectors).Quaternion[0];
                (0, $ha1VO.TmpVectors).Matrix[7].decompose(scale, orientation, translation);
                (0, $ha1VO.Matrix).ScalingToRef(scale.x, scale.y, scale.z, (0, $ha1VO.TmpVectors).Matrix[7]);
                (0, $ha1VO.TmpVectors).Matrix[7].setTranslation(translation);
                if ($ecfbb5db4d70b862$export$b600d080bad015f.BillboardUseParentOrientation) {
                    // set localMatrix translation to be transformed against parent's orientation.
                    this._position.applyRotationQuaternionToRef(orientation, translation);
                    this._localMatrix.setTranslation(translation);
                }
                this._localMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[7], this._worldMatrix);
            } else if (this._transformToBoneReferal) {
                const bone = this.parent;
                bone.getSkeleton().prepare();
                this._localMatrix.multiplyToRef(bone.getFinalMatrix(), (0, $ha1VO.TmpVectors).Matrix[6]);
                (0, $ha1VO.TmpVectors).Matrix[6].multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), this._worldMatrix);
            } else this._localMatrix.multiplyToRef(parent.getWorldMatrix(), this._worldMatrix);
            this._markSyncedWithParent();
        } else this._worldMatrix.copyFrom(this._localMatrix);
        // Billboarding based on camera orientation (testing PG:http://www.babylonjs-playground.com/#UJEIL#13)
        if (cache.useBillboardPath && camera && this.billboardMode && !cache.useBillboardPosition) {
            const storedTranslation = (0, $ha1VO.TmpVectors).Vector3[0];
            this._worldMatrix.getTranslationToRef(storedTranslation); // Save translation
            // Cancel camera rotation
            (0, $ha1VO.TmpVectors).Matrix[1].copyFrom(camera.getViewMatrix());
            if (this._scene.useRightHandedSystem) (0, $ha1VO.TmpVectors).Matrix[1].multiplyToRef($ecfbb5db4d70b862$var$convertRHSToLHS, (0, $ha1VO.TmpVectors).Matrix[1]);
            (0, $ha1VO.TmpVectors).Matrix[1].setTranslationFromFloats(0, 0, 0);
            (0, $ha1VO.TmpVectors).Matrix[1].invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) {
                (0, $ha1VO.TmpVectors).Matrix[0].decompose(undefined, (0, $ha1VO.TmpVectors).Quaternion[0], undefined);
                const eulerAngles = (0, $ha1VO.TmpVectors).Vector3[1];
                (0, $ha1VO.TmpVectors).Quaternion[0].toEulerAnglesToRef(eulerAngles);
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) eulerAngles.x = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) eulerAngles.y = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) eulerAngles.z = 0;
                (0, $ha1VO.Matrix).RotationYawPitchRollToRef(eulerAngles.y, eulerAngles.x, eulerAngles.z, (0, $ha1VO.TmpVectors).Matrix[0]);
            }
            this._worldMatrix.setTranslationFromFloats(0, 0, 0);
            this._worldMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[0], this._worldMatrix);
            // Restore translation
            this._worldMatrix.setTranslation((0, $ha1VO.TmpVectors).Vector3[0]);
        } else if (cache.useBillboardPath && camera && cache.useBillboardPosition) {
            const storedTranslation = (0, $ha1VO.TmpVectors).Vector3[0];
            // Save translation
            this._worldMatrix.getTranslationToRef(storedTranslation);
            // Compute camera position in local space
            const cameraPosition = camera.globalPosition;
            this._worldMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[1]);
            const camInObjSpace = (0, $ha1VO.TmpVectors).Vector3[1];
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(cameraPosition, (0, $ha1VO.TmpVectors).Matrix[1], camInObjSpace);
            camInObjSpace.normalize();
            // Find the lookAt info in local space
            const yaw = -Math.atan2(camInObjSpace.z, camInObjSpace.x) + Math.PI / 2;
            const len = Math.sqrt(camInObjSpace.x * camInObjSpace.x + camInObjSpace.z * camInObjSpace.z);
            const pitch = -Math.atan2(camInObjSpace.y, len);
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(yaw, pitch, 0, (0, $ha1VO.TmpVectors).Quaternion[0]);
            if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) {
                const eulerAngles = (0, $ha1VO.TmpVectors).Vector3[1];
                (0, $ha1VO.TmpVectors).Quaternion[0].toEulerAnglesToRef(eulerAngles);
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) eulerAngles.x = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) eulerAngles.y = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) eulerAngles.z = 0;
                (0, $ha1VO.Matrix).RotationYawPitchRollToRef(eulerAngles.y, eulerAngles.x, eulerAngles.z, (0, $ha1VO.TmpVectors).Matrix[0]);
            } else (0, $ha1VO.Matrix).FromQuaternionToRef((0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Matrix[0]);
            // Cancel translation
            this._worldMatrix.setTranslationFromFloats(0, 0, 0);
            // Rotate according to lookat (diff from local to lookat)
            this._worldMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[0], this._worldMatrix);
            // Restore translation
            this._worldMatrix.setTranslation((0, $ha1VO.TmpVectors).Vector3[0]);
        }
        // Normal matrix
        if (!this.ignoreNonUniformScaling) {
            if (this._scaling.isNonUniformWithinEpsilon(0.000001)) this._updateNonUniformScalingState(true);
            else if (parent && parent._nonUniformScaling) this._updateNonUniformScalingState(parent._nonUniformScaling);
            else this._updateNonUniformScalingState(false);
        } else this._updateNonUniformScalingState(false);
        this._afterComputeWorldMatrix();
        // Absolute position
        this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]);
        this._isAbsoluteSynced = false;
        // Callbacks
        this.onAfterWorldMatrixUpdateObservable.notifyObservers(this);
        if (!this._poseMatrix) this._poseMatrix = (0, $ha1VO.Matrix).Invert(this._worldMatrix);
        // Cache the determinant
        this._worldMatrixDeterminantIsDirty = true;
        return this._worldMatrix;
    }
    /**
     * Resets this nodeTransform's local matrix to Matrix.Identity().
     * @param independentOfChildren indicates if all child nodeTransform's world-space transform should be preserved.
     */ resetLocalMatrix(independentOfChildren = true) {
        this.computeWorldMatrix();
        if (independentOfChildren) {
            const children = this.getChildren();
            for(let i = 0; i < children.length; ++i){
                const child = children[i];
                if (child) {
                    child.computeWorldMatrix();
                    const bakedMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                    child._localMatrix.multiplyToRef(this._localMatrix, bakedMatrix);
                    const tmpRotationQuaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
                    bakedMatrix.decompose(child.scaling, tmpRotationQuaternion, child.position);
                    if (child.rotationQuaternion) child.rotationQuaternion.copyFrom(tmpRotationQuaternion);
                    else tmpRotationQuaternion.toEulerAnglesToRef(child.rotation);
                }
            }
        }
        this.scaling.copyFromFloats(1, 1, 1);
        this.position.copyFromFloats(0, 0, 0);
        this.rotation.copyFromFloats(0, 0, 0);
        //only if quaternion is already set
        if (this.rotationQuaternion) this.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._worldMatrix = (0, $ha1VO.Matrix).Identity();
    }
    _afterComputeWorldMatrix() {}
    /**
     * If you'd like to be called back after the mesh position, rotation or scaling has been updated.
     * @param func callback function to add
     *
     * @returns the TransformNode.
     */ registerAfterWorldMatrixUpdate(func) {
        this.onAfterWorldMatrixUpdateObservable.add(func);
        return this;
    }
    /**
     * Removes a registered callback function.
     * @param func callback function to remove
     * @returns the TransformNode.
     */ unregisterAfterWorldMatrixUpdate(func) {
        this.onAfterWorldMatrixUpdateObservable.removeCallback(func);
        return this;
    }
    /**
     * Gets the position of the current mesh in camera space
     * @param camera defines the camera to use
     * @returns a position
     */ getPositionInCameraSpace(camera = null) {
        if (!camera) camera = this.getScene().activeCamera;
        return (0, $ha1VO.Vector3).TransformCoordinates(this.getAbsolutePosition(), camera.getViewMatrix());
    }
    /**
     * Returns the distance from the mesh to the active camera
     * @param camera defines the camera to use
     * @returns the distance
     */ getDistanceToCamera(camera = null) {
        if (!camera) camera = this.getScene().activeCamera;
        return this.getAbsolutePosition().subtract(camera.globalPosition).length();
    }
    /**
     * Clone the current transform node
     * @param name Name of the new clone
     * @param newParent New parent for the clone
     * @param doNotCloneChildren Do not clone children hierarchy
     * @returns the new transform node
     */ clone(name, newParent, doNotCloneChildren) {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $ecfbb5db4d70b862$export$b600d080bad015f(name, this.getScene()), this);
        result.name = name;
        result.id = name;
        if (newParent) result.parent = newParent;
        if (!doNotCloneChildren) {
            // Children
            const directDescendants = this.getDescendants(true);
            for(let index = 0; index < directDescendants.length; index++){
                const child = directDescendants[index];
                if (child.clone) child.clone(name + "." + child.name, result);
            }
        }
        return result;
    }
    /**
     * Serializes the objects information.
     * @param currentSerializationObject defines the object to serialize in
     * @returns the serialized object
     */ serialize(currentSerializationObject) {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this, currentSerializationObject);
        serializationObject.type = this.getClassName();
        serializationObject.uniqueId = this.uniqueId;
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        serializationObject.localMatrix = this.getPivotMatrix().asArray();
        serializationObject.isEnabled = this.isEnabled();
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        return serializationObject;
    }
    // Statics
    /**
     * Returns a new TransformNode object parsed from the source provided.
     * @param parsedTransformNode is the source.
     * @param scene the scene the object belongs to
     * @param rootUrl is a string, it's the root URL to prefix the `delayLoadingFile` property with
     * @returns a new TransformNode object parsed from the source provided.
     */ static Parse(parsedTransformNode, scene, rootUrl) {
        const transformNode = (0, $6Ho1L.SerializationHelper).Parse(()=>new $ecfbb5db4d70b862$export$b600d080bad015f(parsedTransformNode.name, scene), parsedTransformNode, scene, rootUrl);
        if (parsedTransformNode.localMatrix) transformNode.setPreTransformMatrix((0, $ha1VO.Matrix).FromArray(parsedTransformNode.localMatrix));
        else if (parsedTransformNode.pivotMatrix) transformNode.setPivotMatrix((0, $ha1VO.Matrix).FromArray(parsedTransformNode.pivotMatrix));
        transformNode.setEnabled(parsedTransformNode.isEnabled);
        transformNode._waitingParsedUniqueId = parsedTransformNode.uniqueId;
        // Parent
        if (parsedTransformNode.parentId !== undefined) transformNode._waitingParentId = parsedTransformNode.parentId;
        if (parsedTransformNode.parentInstanceIndex !== undefined) transformNode._waitingParentInstanceIndex = parsedTransformNode.parentInstanceIndex;
        // Animations
        if (parsedTransformNode.animations) {
            for(let animationIndex = 0; animationIndex < parsedTransformNode.animations.length; animationIndex++){
                const parsedAnimation = parsedTransformNode.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) transformNode.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $021dcb6a570ae9c1$export$85c928794f8d04d4).ParseAnimationRanges(transformNode, parsedTransformNode, scene);
        }
        if (parsedTransformNode.autoAnimate) scene.beginAnimation(transformNode, parsedTransformNode.autoAnimateFrom, parsedTransformNode.autoAnimateTo, parsedTransformNode.autoAnimateLoop, parsedTransformNode.autoAnimateSpeed || 1.0);
        return transformNode;
    }
    /**
     * Get all child-transformNodes of this node
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns an array of TransformNode
     */ getChildTransformNodes(directDescendantsOnly, predicate) {
        const results = [];
        this._getDescendants(results, directDescendantsOnly, (node)=>{
            return (!predicate || predicate(node)) && node instanceof $ecfbb5db4d70b862$export$b600d080bad015f;
        });
        return results;
    }
    /**
     * Releases resources associated with this transform node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        // Animations
        this.getScene().stopAnimation(this);
        // Remove from scene
        this.getScene().removeTransformNode(this);
        if (this._parentContainer) {
            const index = this._parentContainer.transformNodes.indexOf(this);
            if (index > -1) this._parentContainer.transformNodes.splice(index, 1);
            this._parentContainer = null;
        }
        this.onAfterWorldMatrixUpdateObservable.clear();
        if (doNotRecurse) {
            const transformNodes = this.getChildTransformNodes(true);
            for (const transformNode of transformNodes){
                transformNode.parent = null;
                transformNode.computeWorldMatrix(true);
            }
        }
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
     * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
     * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
     * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
     * @returns the current mesh
     */ normalizeToUnitCube(includeDescendants = true, ignoreRotation = false, predicate) {
        let storedRotation = null;
        let storedRotationQuaternion = null;
        if (ignoreRotation) {
            if (this.rotationQuaternion) {
                storedRotationQuaternion = this.rotationQuaternion.clone();
                this.rotationQuaternion.copyFromFloats(0, 0, 0, 1);
            } else if (this.rotation) {
                storedRotation = this.rotation.clone();
                this.rotation.copyFromFloats(0, 0, 0);
            }
        }
        const boundingVectors = this.getHierarchyBoundingVectors(includeDescendants, predicate);
        const sizeVec = boundingVectors.max.subtract(boundingVectors.min);
        const maxDimension = Math.max(sizeVec.x, sizeVec.y, sizeVec.z);
        if (maxDimension === 0) return this;
        const scale = 1 / maxDimension;
        this.scaling.scaleInPlace(scale);
        if (ignoreRotation) {
            if (this.rotationQuaternion && storedRotationQuaternion) this.rotationQuaternion.copyFrom(storedRotationQuaternion);
            else if (this.rotation && storedRotation) this.rotation.copyFrom(storedRotation);
        }
        return this;
    }
    _syncAbsoluteScalingAndRotation() {
        if (!this._isAbsoluteSynced) {
            this._worldMatrix.decompose(this._absoluteScaling, this._absoluteRotationQuaternion);
            this._isAbsoluteSynced = true;
        }
    }
}
// Statics
/**
 * Object will not rotate to face the camera
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE = 0;
/**
 * Object will rotate to face the camera but only on the x axis
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X = 1;
/**
 * Object will rotate to face the camera but only on the y axis
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y = 2;
/**
 * Object will rotate to face the camera but only on the z axis
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z = 4;
/**
 * Object will rotate to face the camera
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL = 7;
/**
 * Object will rotate to face the camera's position instead of orientation
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_USE_POSITION = 128;
/**
 * Child transform with Billboard flags should or should not apply parent rotation (default if off)
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BillboardUseParentOrientation = false;
$ecfbb5db4d70b862$export$b600d080bad015f._TmpRotation = (0, $ha1VO.Quaternion).Zero();
$ecfbb5db4d70b862$export$b600d080bad015f._TmpScaling = (0, $ha1VO.Vector3).Zero();
$ecfbb5db4d70b862$export$b600d080bad015f._TmpTranslation = (0, $ha1VO.Vector3).Zero();
$ecfbb5db4d70b862$export$b600d080bad015f._LookAtVectorCache = new (0, $ha1VO.Vector3)(0, 0, 0);
$ecfbb5db4d70b862$export$b600d080bad015f._RotationAxisCache = new (0, $ha1VO.Quaternion)();
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("position")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_position", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("rotation")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_rotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsQuaternion)("rotationQuaternion")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_rotationQuaternion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("scaling")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_scaling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("billboardMode")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_billboardMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "scalingDeterminant", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("infiniteDistance")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_infiniteDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "ignoreNonUniformScaling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "reIntegrateRotationIntoRotationQuaternion", void 0);



var $gzCma = parcelRequire("gzCma");


var $ghoTi = parcelRequire("ghoTi");

var $ha1VO = parcelRequire("ha1VO");
class $9bc9e8f1bdf7b64f$export$ca00c1cbe6d8a82e {
    constructor(){
        this._checkCollisions = false;
        this._collisionMask = -1;
        this._collisionGroup = -1;
        this._surroundingMeshes = null;
        this._collider = null;
        this._oldPositionForCollisions = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._diffPositionForCollisions = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._collisionResponse = true;
    }
}



var $dUFYy = parcelRequire("dUFYy");


var $7etnY = parcelRequire("7etnY");

var $53VPf = parcelRequire("53VPf");

var $dbxbu = parcelRequire("dbxbu");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $dUFoQ = parcelRequire("dUFoQ");
function $0009db3ebb3b86d3$var$applyMorph(data, kind, morphTargetManager) {
    let getTargetData = null;
    switch(kind){
        case (0, $b4i1f.VertexBuffer).PositionKind:
            getTargetData = (target)=>target.getPositions();
            break;
        case (0, $b4i1f.VertexBuffer).NormalKind:
            getTargetData = (target)=>target.getNormals();
            break;
        case (0, $b4i1f.VertexBuffer).TangentKind:
            getTargetData = (target)=>target.getTangents();
            break;
        case (0, $b4i1f.VertexBuffer).UVKind:
            getTargetData = (target)=>target.getUVs();
            break;
        default:
            return;
    }
    for(let index = 0; index < data.length; index++){
        let value = data[index];
        for(let targetCount = 0; targetCount < morphTargetManager.numTargets; targetCount++){
            const target = morphTargetManager.getTarget(targetCount);
            const influence = target.influence;
            if (influence !== 0) {
                const targetData = getTargetData(target);
                if (targetData) value += (targetData[index] - data[index]) * influence;
            }
        }
        data[index] = value;
    }
}
function $0009db3ebb3b86d3$var$applySkeleton(data, kind, skeletonMatrices, matricesIndicesData, matricesWeightsData, matricesIndicesExtraData, matricesWeightsExtraData) {
    const tempVector = (0, $ha1VO.TmpVectors).Vector3[0];
    const finalMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
    const tempMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
    const transformFromFloatsToRef = kind === (0, $b4i1f.VertexBuffer).NormalKind ? (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef : (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef;
    for(let index = 0, matWeightIdx = 0; index < data.length; index += 3, matWeightIdx += 4){
        finalMatrix.reset();
        let inf;
        let weight;
        for(inf = 0; inf < 4; inf++){
            weight = matricesWeightsData[matWeightIdx + inf];
            if (weight > 0) {
                (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesData[matWeightIdx + inf] * 16), weight, tempMatrix);
                finalMatrix.addToSelf(tempMatrix);
            }
        }
        if (matricesIndicesExtraData && matricesWeightsExtraData) for(inf = 0; inf < 4; inf++){
            weight = matricesWeightsExtraData[matWeightIdx + inf];
            if (weight > 0) {
                (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesExtraData[matWeightIdx + inf] * 16), weight, tempMatrix);
                finalMatrix.addToSelf(tempMatrix);
            }
        }
        transformFromFloatsToRef(data[index], data[index + 1], data[index + 2], finalMatrix, tempVector);
        tempVector.toArray(data, index);
    }
}
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $0009db3ebb3b86d3$var$_FacetDataStorage {
    constructor(){
        this.facetNb = 0; // facet number
        this.partitioningSubdivisions = 10; // number of subdivisions per axis in the partitioning space
        this.partitioningBBoxRatio = 1.01; // the partitioning array space is by default 1% bigger than the bounding box
        this.facetDataEnabled = false; // is the facet data feature enabled on this mesh ?
        this.facetParameters = {}; // keep a reference to the object parameters to avoid memory re-allocation
        this.bbSize = (0, $ha1VO.Vector3).Zero(); // bbox size approximated for facet data
        this.subDiv = {
            // actual number of subdivisions per axis for ComputeNormals()
            max: 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            X: 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Y: 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Z: 1
        };
        this.facetDepthSort = false; // is the facet depth sort to be computed
        this.facetDepthSortEnabled = false; // is the facet depth sort initialized
    }
}
/**
 * @internal
 **/ // eslint-disable-next-line @typescript-eslint/naming-convention
class $0009db3ebb3b86d3$var$_InternalAbstractMeshDataInfo {
    constructor(){
        this._hasVertexAlpha = false;
        this._useVertexColors = true;
        this._numBoneInfluencers = 4;
        this._applyFog = true;
        this._receiveShadows = false;
        this._facetData = new $0009db3ebb3b86d3$var$_FacetDataStorage();
        this._visibility = 1.0;
        this._skeleton = null;
        this._layerMask = 0x0fffffff;
        this._computeBonesUsingShaders = true;
        this._isActive = false;
        this._onlyForInstances = false;
        this._isActiveIntermediate = false;
        this._onlyForInstancesIntermediate = false;
        this._actAsRegularMesh = false;
        this._currentLOD = new Map();
        this._collisionRetryCount = 3;
        this._morphTargetManager = null;
        this._renderingGroupId = 0;
        this._bakedVertexAnimationManager = null;
        this._material = null;
        this._positions = null;
        this._pointerOverDisableMeshTesting = false;
        // Collisions
        this._meshCollisionData = new (0, $9bc9e8f1bdf7b64f$export$ca00c1cbe6d8a82e)();
        this._enableDistantPicking = false;
        /** @internal
         * Bounding info that is unnafected by the addition of thin instances
         */ this._rawBoundingInfo = null;
        /** @internal
         * This value will indicate us that at some point, the mesh was specifically used with the opposite winding order
         * We use that as a clue to force the material to sideOrientation = null
         */ this._sideOrientationHint = false;
        /**
         * @internal
         * if this is set to true, the mesh will be visible only if its parent(s) are also visible
         */ this._inheritVisibility = false;
    }
}

class $0009db3ebb3b86d3$export$8f1d8af674c785a5 extends (0, $ecfbb5db4d70b862$export$b600d080bad015f) {
    /**
     * No billboard
     */ static get BILLBOARDMODE_NONE() {
        return (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_NONE;
    }
    /** Billboard on X axis */ static get BILLBOARDMODE_X() {
        return (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_X;
    }
    /** Billboard on Y axis */ static get BILLBOARDMODE_Y() {
        return (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_Y;
    }
    /** Billboard on Z axis */ static get BILLBOARDMODE_Z() {
        return (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_Z;
    }
    /** Billboard on all axes */ static get BILLBOARDMODE_ALL() {
        return (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_ALL;
    }
    /** Billboard on using position instead of orientation */ static get BILLBOARDMODE_USE_POSITION() {
        return (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_USE_POSITION;
    }
    /**
     * Gets the number of facets in the mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
     */ get facetNb() {
        return this._internalAbstractMeshDataInfo._facetData.facetNb;
    }
    /**
     * Gets or set the number (integer) of subdivisions per axis in the partitioning space
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
     */ get partitioningSubdivisions() {
        return this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions;
    }
    set partitioningSubdivisions(nb) {
        this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions = nb;
    }
    /**
     * The ratio (float) to apply to the bounding box size to set to the partitioning space.
     * Ex : 1.01 (default) the partitioning space is 1% bigger than the bounding box
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
     */ get partitioningBBoxRatio() {
        return this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio;
    }
    set partitioningBBoxRatio(ratio) {
        this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio = ratio;
    }
    /**
     * Gets or sets a boolean indicating that the facets must be depth sorted on next call to `updateFacetData()`.
     * Works only for updatable meshes.
     * Doesn't work with multi-materials
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
     */ get mustDepthSortFacets() {
        return this._internalAbstractMeshDataInfo._facetData.facetDepthSort;
    }
    set mustDepthSortFacets(sort) {
        this._internalAbstractMeshDataInfo._facetData.facetDepthSort = sort;
    }
    /**
     * The location (Vector3) where the facet depth sort must be computed from.
     * By default, the active camera position.
     * Used only when facet depth sort is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
     */ get facetDepthSortFrom() {
        return this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom;
    }
    set facetDepthSortFrom(location) {
        this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom = location;
    }
    /** number of collision detection tries. Change this value if not all collisions are detected and handled properly */ get collisionRetryCount() {
        return this._internalAbstractMeshDataInfo._collisionRetryCount;
    }
    set collisionRetryCount(retryCount) {
        this._internalAbstractMeshDataInfo._collisionRetryCount = retryCount;
    }
    /**
     * gets a boolean indicating if facetData is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
     */ get isFacetDataEnabled() {
        return this._internalAbstractMeshDataInfo._facetData.facetDataEnabled;
    }
    /**
     * Gets or sets the morph target manager
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/morphTargets
     */ get morphTargetManager() {
        return this._internalAbstractMeshDataInfo._morphTargetManager;
    }
    set morphTargetManager(value) {
        if (this._internalAbstractMeshDataInfo._morphTargetManager === value) return;
        this._internalAbstractMeshDataInfo._morphTargetManager = value;
        this._syncGeometryWithMorphTargetManager();
    }
    /**
     * Gets or sets the baked vertex animation manager
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/baked_texture_animations
     */ get bakedVertexAnimationManager() {
        return this._internalAbstractMeshDataInfo._bakedVertexAnimationManager;
    }
    set bakedVertexAnimationManager(value) {
        if (this._internalAbstractMeshDataInfo._bakedVertexAnimationManager === value) return;
        this._internalAbstractMeshDataInfo._bakedVertexAnimationManager = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /** @internal */ _syncGeometryWithMorphTargetManager() {}
    /**
     * @internal
     */ _updateNonUniformScalingState(value) {
        if (!super._updateNonUniformScalingState(value)) return false;
        this._markSubMeshesAsMiscDirty();
        return true;
    }
    /** @internal */ get rawBoundingInfo() {
        return this._internalAbstractMeshDataInfo._rawBoundingInfo;
    }
    set rawBoundingInfo(boundingInfo) {
        this._internalAbstractMeshDataInfo._rawBoundingInfo = boundingInfo;
    }
    /** Set a function to call when this mesh collides with another one */ set onCollide(callback) {
        if (this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver) this.onCollideObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver);
        this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver = this.onCollideObservable.add(callback);
    }
    /** Set a function to call when the collision's position changes */ set onCollisionPositionChange(callback) {
        if (this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver) this.onCollisionPositionChangeObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver);
        this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver = this.onCollisionPositionChangeObservable.add(callback);
    }
    /**
     * Gets or sets mesh visibility between 0 and 1 (default is 1)
     */ get visibility() {
        return this._internalAbstractMeshDataInfo._visibility;
    }
    /**
     * Gets or sets mesh visibility between 0 and 1 (default is 1)
     */ set visibility(value) {
        if (this._internalAbstractMeshDataInfo._visibility === value) return;
        const oldValue = this._internalAbstractMeshDataInfo._visibility;
        this._internalAbstractMeshDataInfo._visibility = value;
        if (oldValue === 1 && value !== 1 || oldValue !== 1 && value === 1) this._markSubMeshesAsDirty((defines)=>{
            defines.markAsMiscDirty();
            defines.markAsPrePassDirty();
        });
    }
    /**
     * If set to true, a mesh will only be visible only if its parent(s) are also visible (default is false)
     */ get inheritVisibility() {
        return this._internalAbstractMeshDataInfo._inheritVisibility;
    }
    set inheritVisibility(value) {
        this._internalAbstractMeshDataInfo._inheritVisibility = value;
    }
    /**
     * Gets or sets a boolean indicating if the mesh is visible (renderable). Default is true
     */ get isVisible() {
        if (!this._isVisible || !this.inheritVisibility || !this._parentNode) return this._isVisible;
        if (this._isVisible) {
            let parent = this._parentNode;
            while(parent){
                const parentVisible = parent.isVisible;
                if (typeof parentVisible !== "undefined") return parentVisible;
                parent = parent.parent;
            }
        }
        return this._isVisible;
    }
    set isVisible(value) {
        this._isVisible = value;
    }
    /**
     * Gets or sets the property which disables the test that is checking that the mesh under the pointer is the same than the previous time we tested for it (default: false).
     * Set this property to true if you want thin instances picking to be reported accurately when moving over the mesh.
     * Note that setting this property to true will incur some performance penalties when dealing with pointer events for this mesh so use it sparingly.
     */ get pointerOverDisableMeshTesting() {
        return this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting;
    }
    set pointerOverDisableMeshTesting(disable) {
        this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting = disable;
    }
    /**
     * Specifies the rendering group id for this mesh (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#rendering-groups
     */ get renderingGroupId() {
        return this._internalAbstractMeshDataInfo._renderingGroupId;
    }
    set renderingGroupId(value) {
        this._internalAbstractMeshDataInfo._renderingGroupId = value;
    }
    /** Gets or sets current material */ get material() {
        return this._internalAbstractMeshDataInfo._material;
    }
    set material(value) {
        this._setMaterial(value);
    }
    /** @internal */ _setMaterial(value) {
        if (this._internalAbstractMeshDataInfo._material === value) return;
        // remove from material mesh map id needed
        if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = undefined;
        this._internalAbstractMeshDataInfo._material = value;
        if (value && value.meshMap) value.meshMap[this.uniqueId] = this;
        if (this.onMaterialChangedObservable.hasObservers()) this.onMaterialChangedObservable.notifyObservers(this);
        if (!this.subMeshes) return;
        this.resetDrawCache(undefined, value == null);
        this._unBindEffect();
    }
    /**
     * Gets the material used to render the mesh in a specific render pass
     * @param renderPassId render pass id
     * @returns material used for the render pass. If no specific material is used for this render pass, undefined is returned (meaning mesh.material is used for this pass)
     */ getMaterialForRenderPass(renderPassId) {
        return this._internalAbstractMeshDataInfo._materialForRenderPass?.[renderPassId];
    }
    /**
     * Sets the material to be used to render the mesh in a specific render pass
     * @param renderPassId render pass id
     * @param material material to use for this render pass. If undefined is passed, no specific material will be used for this render pass but the regular material will be used instead (mesh.material)
     */ setMaterialForRenderPass(renderPassId, material) {
        this.resetDrawCache(renderPassId);
        if (!this._internalAbstractMeshDataInfo._materialForRenderPass) this._internalAbstractMeshDataInfo._materialForRenderPass = [];
        const currentMaterial = this._internalAbstractMeshDataInfo._materialForRenderPass[renderPassId];
        if (currentMaterial?.meshMap?.[this.uniqueId]) currentMaterial.meshMap[this.uniqueId] = undefined;
        this._internalAbstractMeshDataInfo._materialForRenderPass[renderPassId] = material;
        if (material && material.meshMap) material.meshMap[this.uniqueId] = this;
    }
    /**
     * Gets or sets a boolean indicating that this mesh can receive realtime shadows
     * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
     */ get receiveShadows() {
        return this._internalAbstractMeshDataInfo._receiveShadows;
    }
    set receiveShadows(value) {
        if (this._internalAbstractMeshDataInfo._receiveShadows === value) return;
        this._internalAbstractMeshDataInfo._receiveShadows = value;
        this._markSubMeshesAsLightDirty();
    }
    /**
     * Gets or sets a boolean indicating that this mesh needs to use vertex alpha data to render.
     * This property is misnamed and should be `useVertexAlpha`. Note that the mesh will be rendered
     * with alpha blending when this flag is set even if vertex alpha data is missing from the geometry.
     */ get hasVertexAlpha() {
        return this._internalAbstractMeshDataInfo._hasVertexAlpha;
    }
    set hasVertexAlpha(value) {
        if (this._internalAbstractMeshDataInfo._hasVertexAlpha === value) return;
        this._internalAbstractMeshDataInfo._hasVertexAlpha = value;
        this._markSubMeshesAsAttributesDirty();
        this._markSubMeshesAsMiscDirty();
    }
    /** Gets or sets a boolean indicating that this mesh needs to use vertex color data to render (if this kind of vertex data is available in the geometry) */ get useVertexColors() {
        return this._internalAbstractMeshDataInfo._useVertexColors;
    }
    set useVertexColors(value) {
        if (this._internalAbstractMeshDataInfo._useVertexColors === value) return;
        this._internalAbstractMeshDataInfo._useVertexColors = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /**
     * Gets or sets a boolean indicating that bone animations must be computed by the GPU (true by default)
     */ get computeBonesUsingShaders() {
        return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
    }
    set computeBonesUsingShaders(value) {
        if (this._internalAbstractMeshDataInfo._computeBonesUsingShaders === value) return;
        this._internalAbstractMeshDataInfo._computeBonesUsingShaders = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /** Gets or sets the number of allowed bone influences per vertex (4 by default) */ get numBoneInfluencers() {
        return this._internalAbstractMeshDataInfo._numBoneInfluencers;
    }
    set numBoneInfluencers(value) {
        if (this._internalAbstractMeshDataInfo._numBoneInfluencers === value) return;
        this._internalAbstractMeshDataInfo._numBoneInfluencers = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /** Gets or sets a boolean indicating that this mesh will allow fog to be rendered on it (true by default) */ get applyFog() {
        return this._internalAbstractMeshDataInfo._applyFog;
    }
    set applyFog(value) {
        if (this._internalAbstractMeshDataInfo._applyFog === value) return;
        this._internalAbstractMeshDataInfo._applyFog = value;
        this._markSubMeshesAsMiscDirty();
    }
    /** When enabled, decompose picking matrices for better precision with large values for mesh position and scling */ get enableDistantPicking() {
        return this._internalAbstractMeshDataInfo._enableDistantPicking;
    }
    set enableDistantPicking(value) {
        this._internalAbstractMeshDataInfo._enableDistantPicking = value;
    }
    /**
     * Gets or sets the current layer mask (default is 0x0FFFFFFF)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/layerMasksAndMultiCam
     */ get layerMask() {
        return this._internalAbstractMeshDataInfo._layerMask;
    }
    set layerMask(value) {
        if (value === this._internalAbstractMeshDataInfo._layerMask) return;
        this._internalAbstractMeshDataInfo._layerMask = value;
        this._resyncLightSources();
    }
    /**
     * Gets or sets a collision mask used to mask collisions (default is -1).
     * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
     */ get collisionMask() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask;
    }
    set collisionMask(mask) {
        this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask = !isNaN(mask) ? mask : -1;
    }
    /**
     * Gets or sets a collision response flag (default is true).
     * when collisionResponse is false, events are still triggered but colliding entity has no response
     * This helps creating trigger volume when user wants collision feedback events but not position/velocity
     * to respond to the collision.
     */ get collisionResponse() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse;
    }
    set collisionResponse(response) {
        this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse = response;
    }
    /**
     * Gets or sets the current collision group mask (-1 by default).
     * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
     */ get collisionGroup() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup;
    }
    set collisionGroup(mask) {
        this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup = !isNaN(mask) ? mask : -1;
    }
    /**
     * Gets or sets current surrounding meshes (null by default).
     *
     * By default collision detection is tested against every mesh in the scene.
     * It is possible to set surroundingMeshes to a defined list of meshes and then only these specified
     * meshes will be tested for the collision.
     *
     * Note: if set to an empty array no collision will happen when this mesh is moved.
     */ get surroundingMeshes() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes;
    }
    set surroundingMeshes(meshes) {
        this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes = meshes;
    }
    /** Gets the list of lights affecting that mesh */ get lightSources() {
        return this._lightSources;
    }
    /**
     * Gets or sets a skeleton to apply skinning transformations
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
     */ set skeleton(value) {
        const skeleton = this._internalAbstractMeshDataInfo._skeleton;
        if (skeleton && skeleton.needInitialSkinMatrix) skeleton._unregisterMeshWithPoseMatrix(this);
        if (value && value.needInitialSkinMatrix) value._registerMeshWithPoseMatrix(this);
        this._internalAbstractMeshDataInfo._skeleton = value;
        if (!this._internalAbstractMeshDataInfo._skeleton) this._bonesTransformMatrices = null;
        this._markSubMeshesAsAttributesDirty();
    }
    get skeleton() {
        return this._internalAbstractMeshDataInfo._skeleton;
    }
    // Constructor
    /**
     * Creates a new AbstractMesh
     * @param name defines the name of the mesh
     * @param scene defines the hosting scene
     */ constructor(name, scene = null){
        super(name, scene, false);
        // Internal data
        /** @internal */ this._internalAbstractMeshDataInfo = new $0009db3ebb3b86d3$var$_InternalAbstractMeshDataInfo();
        /** @internal */ this._waitingMaterialId = null;
        /** @internal */ this._waitingMorphTargetManagerId = null;
        /**
         * The culling strategy to use to check whether the mesh must be rendered or not.
         * This value can be changed at any time and will be used on the next render mesh selection.
         * The possible values are :
         * - AbstractMesh.CULLINGSTRATEGY_STANDARD
         * - AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
         * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
         * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
         * Please read each static variable documentation to get details about the culling process.
         * */ this.cullingStrategy = $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;
        // Events
        /**
         * An event triggered when this mesh collides with another one
         */ this.onCollideObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the collision's position changes
         */ this.onCollisionPositionChangeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when material is changed
         */ this.onMaterialChangedObservable = new (0, $diGQf.Observable)();
        // Properties
        /**
         * Gets or sets the orientation for POV movement & rotation
         */ this.definedFacingForward = true;
        /** @internal */ this._occlusionQuery = null;
        /** @internal */ this._renderingGroup = null;
        /** Gets or sets the alpha index used to sort transparent meshes
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#alpha-index
         */ this.alphaIndex = Number.MAX_VALUE;
        this._isVisible = true;
        /**
         * Gets or sets a boolean indicating if the mesh can be picked (by scene.pick for instance or through actions). Default is true
         */ this.isPickable = true;
        /**
         * Gets or sets a boolean indicating if the mesh can be near picked (touched by the XR controller or hands). Default is false
         */ this.isNearPickable = false;
        /**
         * Gets or sets a boolean indicating if the mesh can be grabbed. Default is false.
         * Setting this to true, while using the XR near interaction feature, will trigger a pointer event when the mesh is grabbed.
         * Grabbing means that the controller is using the squeeze or main trigger button to grab the mesh.
         * This is different from nearPickable which only triggers the event when the mesh is touched by the controller
         */ this.isNearGrabbable = false;
        /** Gets or sets a boolean indicating that bounding boxes of subMeshes must be rendered as well (false by default) */ this.showSubMeshesBoundingBox = false;
        /** Gets or sets a boolean indicating if the mesh must be considered as a ray blocker for lens flares (false by default)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
         */ this.isBlocker = false;
        /**
         * Gets or sets a boolean indicating that pointer move events must be supported on this mesh (false by default)
         */ this.enablePointerMoveEvents = false;
        /** Defines color to use when rendering outline */ this.outlineColor = (0, $7etnY.Color3).Red();
        /** Define width to use when rendering outline */ this.outlineWidth = 0.02;
        /** Defines color to use when rendering overlay */ this.overlayColor = (0, $7etnY.Color3).Red();
        /** Defines alpha to use when rendering overlay */ this.overlayAlpha = 0.5;
        /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes selection (true by default) */ this.useOctreeForRenderingSelection = true;
        /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes picking (true by default) */ this.useOctreeForPicking = true;
        /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes collision (true by default) */ this.useOctreeForCollisions = true;
        /**
         * True if the mesh must be rendered in any case (this will shortcut the frustum clipping phase)
         */ this.alwaysSelectAsActiveMesh = false;
        /**
         * Gets or sets a boolean indicating that the bounding info does not need to be kept in sync (for performance reason)
         */ this.doNotSyncBoundingInfo = false;
        /**
         * Gets or sets the current action manager
         * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions
         */ this.actionManager = null;
        /**
         * Gets or sets the ellipsoid used to impersonate this mesh when using collision engine (default is (0.5, 1, 0.5))
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.ellipsoid = new (0, $ha1VO.Vector3)(0.5, 1, 0.5);
        /**
         * Gets or sets the ellipsoid offset used to impersonate this mesh when using collision engine (default is (0, 0, 0))
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.ellipsoidOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        // Edges
        /**
         * Defines edge width used when edgesRenderer is enabled
         * @see https://www.babylonjs-playground.com/#10OJSG#13
         */ this.edgesWidth = 1;
        /**
         * Defines edge color used when edgesRenderer is enabled
         * @see https://www.babylonjs-playground.com/#10OJSG#13
         */ this.edgesColor = new (0, $7etnY.Color4)(1, 0, 0, 1);
        /** @internal */ this._edgesRenderer = null;
        /** @internal */ this._masterMesh = null;
        this._boundingInfo = null;
        this._boundingInfoIsDirty = true;
        /** @internal */ this._renderId = 0;
        /** @internal */ this._intersectionsInProgress = new Array();
        /** @internal */ this._unIndexed = false;
        /** @internal */ this._lightSources = new Array();
        // Loading properties
        /** @internal */ this._waitingData = {
            lods: null,
            actions: null,
            freezeWorldMatrix: null
        };
        /** @internal */ this._bonesTransformMatrices = null;
        /** @internal */ this._transformMatrixTexture = null;
        /**
         * An event triggered when the mesh is rebuilt.
         */ this.onRebuildObservable = new (0, $diGQf.Observable)();
        this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null)=>{
            newPosition.subtractToRef(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions);
            if (this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions.length() > (0, $dUFoQ.AbstractEngine).CollisionsEpsilon) this.position.addInPlace(this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions);
            if (collidedMesh) this.onCollideObservable.notifyObservers(collidedMesh);
            this.onCollisionPositionChangeObservable.notifyObservers(this.position);
        };
        scene = this.getScene();
        scene.addMesh(this);
        this._resyncLightSources();
        // Mesh Uniform Buffer.
        this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(this.getScene().getEngine(), undefined, undefined, name, !this.getScene().getEngine().isWebGPU);
        this._buildUniformLayout();
        switch(scene.performancePriority){
            case 2 /* ScenePerformancePriority.Aggressive */ :
                this.doNotSyncBoundingInfo = true;
            // eslint-disable-next-line no-fallthrough
            case 1 /* ScenePerformancePriority.Intermediate */ :
                this.alwaysSelectAsActiveMesh = true;
                this.isPickable = false;
                break;
        }
    }
    _buildUniformLayout() {
        this._uniformBuffer.addUniform("world", 16);
        this._uniformBuffer.addUniform("visibility", 1);
        this._uniformBuffer.create();
    }
    /**
     * Transfer the mesh values to its UBO.
     * @param world The world matrix associated with the mesh
     */ transferToEffect(world) {
        const ubo = this._uniformBuffer;
        ubo.updateMatrix("world", world);
        ubo.updateFloat("visibility", this._internalAbstractMeshDataInfo._visibility);
        ubo.update();
    }
    /**
     * Gets the mesh uniform buffer.
     * @returns the uniform buffer of the mesh.
     */ getMeshUniformBuffer() {
        return this._uniformBuffer;
    }
    /**
     * Returns the string "AbstractMesh"
     * @returns "AbstractMesh"
     */ getClassName() {
        return "AbstractMesh";
    }
    /**
     * Gets a string representation of the current mesh
     * @param fullDetails defines a boolean indicating if full details must be included
     * @returns a string representation of the current mesh
     */ toString(fullDetails) {
        let ret = "Name: " + this.name + ", isInstance: " + (this.getClassName() !== "InstancedMesh" ? "YES" : "NO");
        ret += ", # of submeshes: " + (this.subMeshes ? this.subMeshes.length : 0);
        const skeleton = this._internalAbstractMeshDataInfo._skeleton;
        if (skeleton) ret += ", skeleton: " + skeleton.name;
        if (fullDetails) {
            ret += ", billboard mode: " + [
                "NONE",
                "X",
                "Y",
                null,
                "Z",
                null,
                null,
                "ALL"
            ][this.billboardMode];
            ret += ", freeze wrld mat: " + (this._isWorldMatrixFrozen || this._waitingData.freezeWorldMatrix ? "YES" : "NO");
        }
        return ret;
    }
    /**
     * @internal
     */ _getEffectiveParent() {
        if (this._masterMesh && this.billboardMode !== (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_NONE) return this._masterMesh;
        return super._getEffectiveParent();
    }
    /**
     * @internal
     */ _getActionManagerForTrigger(trigger, initialCall = true) {
        if (this.actionManager && (initialCall || this.actionManager.isRecursive)) {
            if (trigger) {
                if (this.actionManager.hasSpecificTrigger(trigger)) return this.actionManager;
            } else return this.actionManager;
        }
        if (!this.parent) return null;
        return this.parent._getActionManagerForTrigger(trigger, false);
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _rebuild(dispose = false) {
        this.onRebuildObservable.notifyObservers(this);
        if (this._occlusionQuery !== null) this._occlusionQuery = null;
        if (!this.subMeshes) return;
        for (const subMesh of this.subMeshes)subMesh._rebuild();
        this.resetDrawCache();
    }
    /** @internal */ _resyncLightSources() {
        this._lightSources.length = 0;
        for (const light of this.getScene().lights){
            if (!light.isEnabled()) continue;
            if (light.canAffectMesh(this)) this._lightSources.push(light);
        }
        this._markSubMeshesAsLightDirty();
    }
    /**
     * @internal
     */ _resyncLightSource(light) {
        const isIn = light.isEnabled() && light.canAffectMesh(this);
        const index = this._lightSources.indexOf(light);
        let removed = false;
        if (index === -1) {
            if (!isIn) return;
            this._lightSources.push(light);
        } else {
            if (isIn) return;
            removed = true;
            this._lightSources.splice(index, 1);
        }
        this._markSubMeshesAsLightDirty(removed);
    }
    /** @internal */ _unBindEffect() {
        for (const subMesh of this.subMeshes)subMesh.setEffect(null);
    }
    /**
     * @internal
     */ _removeLightSource(light, dispose) {
        const index = this._lightSources.indexOf(light);
        if (index === -1) return;
        this._lightSources.splice(index, 1);
        this._markSubMeshesAsLightDirty(dispose);
    }
    _markSubMeshesAsDirty(func) {
        if (!this.subMeshes) return;
        for (const subMesh of this.subMeshes)for(let i = 0; i < subMesh._drawWrappers.length; ++i){
            const drawWrapper = subMesh._drawWrappers[i];
            if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) continue;
            func(drawWrapper.defines);
        }
    }
    /**
     * @internal
     */ _markSubMeshesAsLightDirty(dispose = false) {
        this._markSubMeshesAsDirty((defines)=>defines.markAsLightDirty(dispose));
    }
    /** @internal */ _markSubMeshesAsAttributesDirty() {
        this._markSubMeshesAsDirty((defines)=>defines.markAsAttributesDirty());
    }
    /** @internal */ _markSubMeshesAsMiscDirty() {
        this._markSubMeshesAsDirty((defines)=>defines.markAsMiscDirty());
    }
    /**
     * Flag the AbstractMesh as dirty (Forcing it to update everything)
     * @param property if set to "rotation" the objects rotationQuaternion will be set to null
     * @returns this AbstractMesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    markAsDirty(property) {
        this._currentRenderId = Number.MAX_VALUE;
        super.markAsDirty(property);
        this._isDirty = true;
        return this;
    }
    /**
     * Resets the draw wrappers cache for all submeshes of this abstract mesh
     * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
     * @param immediate If true, the effect will be released immediately, otherwise it will be released at the next frame
     */ resetDrawCache(passId, immediate = false) {
        if (!this.subMeshes) return;
        for (const subMesh of this.subMeshes)subMesh.resetDrawCache(passId, immediate);
    }
    // Methods
    /**
     * Returns true if the mesh is blocked. Implemented by child classes
     */ get isBlocked() {
        return false;
    }
    /**
     * Returns the mesh itself by default. Implemented by child classes
     * @param camera defines the camera to use to pick the right LOD level
     * @returns the currentAbstractMesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getLOD(camera) {
        return this;
    }
    /**
     * Returns 0 by default. Implemented by child classes
     * @returns an integer
     */ getTotalVertices() {
        return 0;
    }
    /**
     * Returns a positive integer : the total number of indices in this mesh geometry.
     * @returns the number of indices or zero if the mesh has no geometry.
     */ getTotalIndices() {
        return 0;
    }
    /**
     * Returns null by default. Implemented by child classes
     * @returns null
     */ getIndices() {
        return null;
    }
    /**
     * Returns the array of the requested vertex data kind. Implemented by child classes
     * @param kind defines the vertex data kind to use
     * @returns null
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getVerticesData(kind) {
        return null;
    }
    /**
     * Sets the vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
     * Note that a new underlying VertexBuffer object is created each call.
     * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
     * @param kind defines vertex data kind:
     * * VertexBuffer.PositionKind
     * * VertexBuffer.UVKind
     * * VertexBuffer.UV2Kind
     * * VertexBuffer.UV3Kind
     * * VertexBuffer.UV4Kind
     * * VertexBuffer.UV5Kind
     * * VertexBuffer.UV6Kind
     * * VertexBuffer.ColorKind
     * * VertexBuffer.MatricesIndicesKind
     * * VertexBuffer.MatricesIndicesExtraKind
     * * VertexBuffer.MatricesWeightsKind
     * * VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updatable defines if the data must be flagged as updatable (or static)
     * @param stride defines the vertex stride (size of an entire vertex). Can be null and in this case will be deduced from vertex data kind
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setVerticesData(kind, data, updatable, stride) {
        return this;
    }
    /**
     * Updates the existing vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, it is simply returned as it is.
     * @param kind defines vertex data kind:
     * * VertexBuffer.PositionKind
     * * VertexBuffer.UVKind
     * * VertexBuffer.UV2Kind
     * * VertexBuffer.UV3Kind
     * * VertexBuffer.UV4Kind
     * * VertexBuffer.UV5Kind
     * * VertexBuffer.UV6Kind
     * * VertexBuffer.ColorKind
     * * VertexBuffer.MatricesIndicesKind
     * * VertexBuffer.MatricesIndicesExtraKind
     * * VertexBuffer.MatricesWeightsKind
     * * VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updateExtends If `kind` is `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed
     * @param makeItUnique If true, a new global geometry is created from this data and is set to the mesh
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateVerticesData(kind, data, updateExtends, makeItUnique) {
        return this;
    }
    /**
     * Sets the mesh indices,
     * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
     * @param indices Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array)
     * @param totalVertices Defines the total number of vertices
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setIndices(indices, totalVertices) {
        return this;
    }
    /**
     * Gets a boolean indicating if specific vertex data is present
     * @param kind defines the vertex data kind to use
     * @returns true is data kind is present
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isVerticesDataPresent(kind) {
        return false;
    }
    /**
     * Returns the mesh BoundingInfo object or creates a new one and returns if it was undefined.
     * Note that it returns a shallow bounding of the mesh (i.e. it does not include children).
     * However, if the mesh contains thin instances, it will be expanded to include them. If you want the "raw" bounding data instead, then use `getRawBoundingInfo()`.
     * To get the full bounding of all children, call `getHierarchyBoundingVectors` instead.
     * @returns a BoundingInfo
     */ getBoundingInfo() {
        if (this._masterMesh) return this._masterMesh.getBoundingInfo();
        if (this._boundingInfoIsDirty) {
            this._boundingInfoIsDirty = false;
            // this._boundingInfo is being created if undefined
            this._updateBoundingInfo();
        }
        // cannot be null.
        return this._boundingInfo;
    }
    /**
     * Returns the bounding info unnafected by instance data.
     * @returns the bounding info of the mesh unaffected by instance data.
     */ getRawBoundingInfo() {
        return this.rawBoundingInfo ?? this.getBoundingInfo();
    }
    /**
     * Overwrite the current bounding info
     * @param boundingInfo defines the new bounding info
     * @returns the current mesh
     */ setBoundingInfo(boundingInfo) {
        this._boundingInfo = boundingInfo;
        return this;
    }
    /**
     * Returns true if there is already a bounding info
     */ get hasBoundingInfo() {
        return this._boundingInfo !== null;
    }
    /**
     * Creates a new bounding info for the mesh
     * @param minimum min vector of the bounding box/sphere
     * @param maximum max vector of the bounding box/sphere
     * @param worldMatrix defines the new world matrix
     * @returns the new bounding info
     */ buildBoundingInfo(minimum, maximum, worldMatrix) {
        this._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)(minimum, maximum, worldMatrix);
        return this._boundingInfo;
    }
    /**
     * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
     * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
     * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
     * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
     * @returns the current mesh
     */ normalizeToUnitCube(includeDescendants = true, ignoreRotation = false, predicate) {
        return super.normalizeToUnitCube(includeDescendants, ignoreRotation, predicate);
    }
    /** Gets a boolean indicating if this mesh has skinning data and an attached skeleton */ get useBones() {
        return this.skeleton && this.getScene().skeletonsEnabled && this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind) && this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
    }
    /** @internal */ _preActivate() {}
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _preActivateForIntermediateRendering(renderId) {}
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _activate(renderId, intermediateRendering) {
        this._renderId = renderId;
        return true;
    }
    /** @internal */ _postActivate() {
    // Do nothing
    }
    /** @internal */ _freeze() {
    // Do nothing
    }
    /** @internal */ _unFreeze() {
    // Do nothing
    }
    /**
     * Gets the current world matrix
     * @returns a Matrix
     */ getWorldMatrix() {
        if (this._masterMesh && this.billboardMode === (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_NONE) return this._masterMesh.getWorldMatrix();
        return super.getWorldMatrix();
    }
    /** @internal */ _getWorldMatrixDeterminant() {
        if (this._masterMesh) return this._masterMesh._getWorldMatrixDeterminant();
        return super._getWorldMatrixDeterminant();
    }
    /**
     * Gets a boolean indicating if this mesh is an instance or a regular mesh
     */ get isAnInstance() {
        return false;
    }
    /**
     * Gets a boolean indicating if this mesh has instances
     */ get hasInstances() {
        return false;
    }
    /**
     * Gets a boolean indicating if this mesh has thin instances
     */ get hasThinInstances() {
        return false;
    }
    // ================================== Point of View Movement =================================
    /**
     * Perform relative position change from the point of view of behind the front of the mesh.
     * This is performed taking into account the meshes current rotation, so you do not have to care.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param amountRight defines the distance on the right axis
     * @param amountUp defines the distance on the up axis
     * @param amountForward defines the distance on the forward axis
     * @returns the current mesh
     */ movePOV(amountRight, amountUp, amountForward) {
        this.position.addInPlace(this.calcMovePOV(amountRight, amountUp, amountForward));
        return this;
    }
    /**
     * Calculate relative position change from the point of view of behind the front of the mesh.
     * This is performed taking into account the meshes current rotation, so you do not have to care.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param amountRight defines the distance on the right axis
     * @param amountUp defines the distance on the up axis
     * @param amountForward defines the distance on the forward axis
     * @returns the new displacement vector
     */ calcMovePOV(amountRight, amountUp, amountForward) {
        const rotMatrix = new (0, $ha1VO.Matrix)();
        const rotQuaternion = this.rotationQuaternion ? this.rotationQuaternion : (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z);
        rotQuaternion.toRotationMatrix(rotMatrix);
        const translationDelta = (0, $ha1VO.Vector3).Zero();
        const defForwardMult = this.definedFacingForward ? -1 : 1;
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(amountRight * defForwardMult, amountUp, amountForward * defForwardMult, rotMatrix, translationDelta);
        return translationDelta;
    }
    // ================================== Point of View Rotation =================================
    /**
     * Perform relative rotation change from the point of view of behind the front of the mesh.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param flipBack defines the flip
     * @param twirlClockwise defines the twirl
     * @param tiltRight defines the tilt
     * @returns the current mesh
     */ rotatePOV(flipBack, twirlClockwise, tiltRight) {
        this.rotation.addInPlace(this.calcRotatePOV(flipBack, twirlClockwise, tiltRight));
        return this;
    }
    /**
     * Calculate relative rotation change from the point of view of behind the front of the mesh.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param flipBack defines the flip
     * @param twirlClockwise defines the twirl
     * @param tiltRight defines the tilt
     * @returns the new rotation vector
     */ calcRotatePOV(flipBack, twirlClockwise, tiltRight) {
        const defForwardMult = this.definedFacingForward ? 1 : -1;
        return new (0, $ha1VO.Vector3)(flipBack * defForwardMult, twirlClockwise, tiltRight * defForwardMult);
    }
    /**
     * @internal
     */ _refreshBoundingInfo(data, bias) {
        if (data) {
            const extend = (0, $14fdbb07a947065f$export$e1bada46cc64caed)(data, 0, this.getTotalVertices(), bias);
            if (this._boundingInfo) this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
            else this._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)(extend.minimum, extend.maximum);
        }
        if (this.subMeshes) for(let index = 0; index < this.subMeshes.length; index++)this.subMeshes[index].refreshBoundingInfo(data);
        this._updateBoundingInfo();
    }
    /**
     * @internal
     */ _refreshBoundingInfoDirect(extend) {
        if (this._boundingInfo) this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
        else this._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)(extend.minimum, extend.maximum);
        if (this.subMeshes) for(let index = 0; index < this.subMeshes.length; index++)this.subMeshes[index].refreshBoundingInfo(null);
        this._updateBoundingInfo();
    }
    // This function is only here so we can apply the nativeOverride decorator.
    static _ApplySkeleton(data, kind, skeletonMatrices, matricesIndicesData, matricesWeightsData, matricesIndicesExtraData, matricesWeightsExtraData) {
        $0009db3ebb3b86d3$var$applySkeleton(data, kind, skeletonMatrices, matricesIndicesData, matricesWeightsData, matricesIndicesExtraData, matricesWeightsExtraData);
    }
    /** @internal */ _getData(options, data, kind = (0, $b4i1f.VertexBuffer).PositionKind) {
        const cache = options.cache;
        const getVertexData = (kind)=>{
            if (cache) {
                const vertexData = cache._vertexData || (cache._vertexData = {});
                if (!vertexData[kind]) this.copyVerticesData(kind, vertexData);
                return vertexData[kind];
            }
            return this.getVerticesData(kind);
        };
        data || (data = getVertexData(kind));
        if (!data) return null;
        if (cache) {
            if (cache._outputData) cache._outputData.set(data);
            else cache._outputData = new Float32Array(data);
            data = cache._outputData;
        } else if (options.applyMorph && this.morphTargetManager || options.applySkeleton && this.skeleton) data = data.slice();
        if (options.applyMorph && this.morphTargetManager) $0009db3ebb3b86d3$var$applyMorph(data, kind, this.morphTargetManager);
        if (options.applySkeleton && this.skeleton) {
            const matricesIndicesData = getVertexData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            const matricesWeightsData = getVertexData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (matricesWeightsData && matricesIndicesData) {
                const needExtras = this.numBoneInfluencers > 4;
                const matricesIndicesExtraData = needExtras ? getVertexData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind) : null;
                const matricesWeightsExtraData = needExtras ? getVertexData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind) : null;
                const skeletonMatrices = this.skeleton.getTransformMatrices(this);
                $0009db3ebb3b86d3$export$8f1d8af674c785a5._ApplySkeleton(data, kind, skeletonMatrices, matricesIndicesData, matricesWeightsData, matricesIndicesExtraData, matricesWeightsExtraData);
            }
        }
        if (options.updatePositionsArray !== false && kind === (0, $b4i1f.VertexBuffer).PositionKind) {
            const positions = this._internalAbstractMeshDataInfo._positions || [];
            const previousLength = positions.length;
            positions.length = data.length / 3;
            if (previousLength < positions.length) for(let positionIndex = previousLength; positionIndex < positions.length; positionIndex++)positions[positionIndex] = new (0, $ha1VO.Vector3)();
            for(let positionIndex = 0, dataIndex = 0; positionIndex < positions.length; positionIndex++, dataIndex += 3)positions[positionIndex].copyFromFloats(data[dataIndex], data[dataIndex + 1], data[dataIndex + 2]);
            this._internalAbstractMeshDataInfo._positions = positions;
        }
        return data;
    }
    /**
     * Get the normals vertex data and optionally apply skeleton and morphing.
     * @param applySkeleton defines whether to apply the skeleton
     * @param applyMorph  defines whether to apply the morph target
     * @returns the normals data
     */ getNormalsData(applySkeleton = false, applyMorph = false) {
        return this._getData({
            applySkeleton: applySkeleton,
            applyMorph: applyMorph,
            updatePositionsArray: false
        }, null, (0, $b4i1f.VertexBuffer).NormalKind);
    }
    /**
     * Get the position vertex data and optionally apply skeleton and morphing.
     * @param applySkeleton defines whether to apply the skeleton
     * @param applyMorph  defines whether to apply the morph target
     * @param data defines the position data to apply the skeleton and morph to
     * @returns the position data
     */ getPositionData(applySkeleton = false, applyMorph = false, data = null) {
        return this._getData({
            applySkeleton: applySkeleton,
            applyMorph: applyMorph,
            updatePositionsArray: false
        }, data, (0, $b4i1f.VertexBuffer).PositionKind);
    }
    /** @internal */ _updateBoundingInfo() {
        if (this._boundingInfo) this._boundingInfo.update(this.worldMatrixFromCache);
        else this._boundingInfo = new (0, $a5e27a85374b8b23$export$dc03daefa4f9a8c4)((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Zero(), this.worldMatrixFromCache);
        this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
        return this;
    }
    /**
     * @internal
     */ _updateSubMeshesBoundingInfo(matrix) {
        if (!this.subMeshes) return this;
        const count = this.subMeshes.length;
        for(let subIndex = 0; subIndex < count; subIndex++){
            const subMesh = this.subMeshes[subIndex];
            if (count > 1 || !subMesh.IsGlobal) subMesh.updateBoundingInfo(matrix);
        }
        return this;
    }
    /** @internal */ _afterComputeWorldMatrix() {
        if (this.doNotSyncBoundingInfo) return;
        // Bounding info
        this._boundingInfoIsDirty = true;
    }
    /**
     * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
     * A mesh is in the frustum if its bounding box intersects the frustum
     * @param frustumPlanes defines the frustum to test
     * @returns true if the mesh is in the frustum planes
     */ isInFrustum(frustumPlanes) {
        return this.getBoundingInfo().isInFrustum(frustumPlanes, this.cullingStrategy);
    }
    /**
     * Returns `true` if the mesh is completely in the frustum defined be the passed array of planes.
     * A mesh is completely in the frustum if its bounding box it completely inside the frustum.
     * @param frustumPlanes defines the frustum to test
     * @returns true if the mesh is completely in the frustum planes
     */ isCompletelyInFrustum(frustumPlanes) {
        return this.getBoundingInfo().isCompletelyInFrustum(frustumPlanes);
    }
    /**
     * True if the mesh intersects another mesh or a SolidParticle object
     * @param mesh defines a target mesh or SolidParticle to test
     * @param precise Unless the parameter `precise` is set to `true` the intersection is computed according to Axis Aligned Bounding Boxes (AABB), else according to OBB (Oriented BBoxes)
     * @param includeDescendants Can be set to true to test if the mesh defined in parameters intersects with the current mesh or any child meshes
     * @returns true if there is an intersection
     */ intersectsMesh(mesh, precise = false, includeDescendants) {
        const boundingInfo = this.getBoundingInfo();
        const otherBoundingInfo = mesh.getBoundingInfo();
        if (boundingInfo.intersects(otherBoundingInfo, precise)) return true;
        if (includeDescendants) for (const child of this.getChildMeshes()){
            if (child.intersectsMesh(mesh, precise, true)) return true;
        }
        return false;
    }
    /**
     * Returns true if the passed point (Vector3) is inside the mesh bounding box
     * @param point defines the point to test
     * @returns true if there is an intersection
     */ intersectsPoint(point) {
        return this.getBoundingInfo().intersectsPoint(point);
    }
    // Collisions
    /**
     * Gets or sets a boolean indicating that this mesh can be used in the collision engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
     */ get checkCollisions() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions;
    }
    set checkCollisions(collisionEnabled) {
        this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions = collisionEnabled;
    }
    /**
     * Gets Collider object used to compute collisions (not physics)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
     */ get collider() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collider;
    }
    /**
     * Move the mesh using collision engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
     * @param displacement defines the requested displacement vector
     * @returns the current mesh
     */ moveWithCollisions(displacement) {
        const globalPosition = this.getAbsolutePosition();
        globalPosition.addToRef(this.ellipsoidOffset, this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions);
        const coordinator = this.getScene().collisionCoordinator;
        if (!this._internalAbstractMeshDataInfo._meshCollisionData._collider) this._internalAbstractMeshDataInfo._meshCollisionData._collider = coordinator.createCollider();
        this._internalAbstractMeshDataInfo._meshCollisionData._collider._radius = this.ellipsoid;
        coordinator.getNewPosition(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, displacement, this._internalAbstractMeshDataInfo._meshCollisionData._collider, this.collisionRetryCount, this, this._onCollisionPositionChange, this.uniqueId);
        return this;
    }
    // Collisions
    /**
     * @internal
     */ _collideForSubMesh(subMesh, transformMatrix, collider) {
        this._generatePointsArray();
        if (!this._positions) return this;
        // Transformation
        if (!subMesh._lastColliderWorldVertices || !subMesh._lastColliderTransformMatrix.equals(transformMatrix)) {
            subMesh._lastColliderTransformMatrix = transformMatrix.clone();
            subMesh._lastColliderWorldVertices = [];
            subMesh._trianglePlanes = [];
            const start = subMesh.verticesStart;
            const end = subMesh.verticesStart + subMesh.verticesCount;
            for(let i = start; i < end; i++)subMesh._lastColliderWorldVertices.push((0, $ha1VO.Vector3).TransformCoordinates(this._positions[i], transformMatrix));
        }
        // Collide
        collider._collide(subMesh._trianglePlanes, subMesh._lastColliderWorldVertices, this.getIndices(), subMesh.indexStart, subMesh.indexStart + subMesh.indexCount, subMesh.verticesStart, !!subMesh.getMaterial(), this, this._shouldConvertRHS(), subMesh.getMaterial()?.fillMode === 7);
        return this;
    }
    /**
     * @internal
     */ _processCollisionsForSubMeshes(collider, transformMatrix) {
        const subMeshes = this._scene.getCollidingSubMeshCandidates(this, collider);
        const len = subMeshes.length;
        for(let index = 0; index < len; index++){
            const subMesh = subMeshes.data[index];
            // Bounding test
            if (len > 1 && !subMesh._checkCollision(collider)) continue;
            this._collideForSubMesh(subMesh, transformMatrix, collider);
        }
        return this;
    }
    /** @internal */ _shouldConvertRHS() {
        return false;
    }
    /**
     * @internal
     */ _checkCollision(collider) {
        // Bounding box test
        if (!this.getBoundingInfo()._checkCollision(collider)) return this;
        // Transformation matrix
        const collisionsScalingMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        const collisionsTransformMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
        (0, $ha1VO.Matrix).ScalingToRef(1.0 / collider._radius.x, 1.0 / collider._radius.y, 1.0 / collider._radius.z, collisionsScalingMatrix);
        this.worldMatrixFromCache.multiplyToRef(collisionsScalingMatrix, collisionsTransformMatrix);
        this._processCollisionsForSubMeshes(collider, collisionsTransformMatrix);
        return this;
    }
    // Picking
    /** @internal */ _generatePointsArray() {
        return false;
    }
    /**
     * Checks if the passed Ray intersects with the mesh. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param ray defines the ray to use. It should be in the mesh's LOCAL coordinate space.
     * @param fastCheck defines if fast mode (but less precise) must be used (false by default)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
     * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
     * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
     * @returns the picking info
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
     */ intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
        const pickingInfo = new (0, $gzCma.PickingInfo)();
        const className = this.getClassName();
        const intersectionThreshold = className === "InstancedLinesMesh" || className === "LinesMesh" || className === "GreasedLineMesh" ? this.intersectionThreshold : 0;
        const boundingInfo = this.getBoundingInfo();
        if (!this.subMeshes) return pickingInfo;
        if (!skipBoundingInfo && (!ray.intersectsSphere(boundingInfo.boundingSphere, intersectionThreshold) || !ray.intersectsBox(boundingInfo.boundingBox, intersectionThreshold))) return pickingInfo;
        if (onlyBoundingInfo) {
            pickingInfo.hit = skipBoundingInfo ? false : true;
            pickingInfo.pickedMesh = skipBoundingInfo ? null : this;
            pickingInfo.distance = skipBoundingInfo ? 0 : (0, $ha1VO.Vector3).Distance(ray.origin, boundingInfo.boundingSphere.center);
            pickingInfo.subMeshId = 0;
            return pickingInfo;
        }
        if (!this._generatePointsArray()) return pickingInfo;
        let intersectInfo = null;
        const subMeshes = this._scene.getIntersectingSubMeshCandidates(this, ray);
        const len = subMeshes.length;
        // Check if all submeshes are using a material that don't allow picking (point/lines rendering)
        // if no submesh can be picked that way, then fallback to BBox picking
        let anySubmeshSupportIntersect = false;
        for(let index = 0; index < len; index++){
            const subMesh = subMeshes.data[index];
            const material = subMesh.getMaterial();
            if (!material) continue;
            if (material.fillMode == 7 || material.fillMode == 0 || material.fillMode == 1 || material.fillMode == 2 || material.fillMode == 4) {
                anySubmeshSupportIntersect = true;
                break;
            }
        }
        // no sub mesh support intersection, fallback to BBox that has already be done
        if (!anySubmeshSupportIntersect) {
            pickingInfo.hit = true;
            pickingInfo.pickedMesh = this;
            pickingInfo.distance = (0, $ha1VO.Vector3).Distance(ray.origin, boundingInfo.boundingSphere.center);
            pickingInfo.subMeshId = -1;
            return pickingInfo;
        }
        // at least 1 submesh supports intersection, keep going
        for(let index = 0; index < len; index++){
            const subMesh = subMeshes.data[index];
            // Bounding test
            if (len > 1 && !skipBoundingInfo && !subMesh.canIntersects(ray)) continue;
            const currentIntersectInfo = subMesh.intersects(ray, this._positions, this.getIndices(), fastCheck, trianglePredicate);
            if (currentIntersectInfo) {
                if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                    intersectInfo = currentIntersectInfo;
                    intersectInfo.subMeshId = index;
                    if (fastCheck) break;
                }
            }
        }
        if (intersectInfo) {
            // Get picked point
            const world = worldToUse ?? this.getWorldMatrix();
            const worldOrigin = (0, $ha1VO.TmpVectors).Vector3[0];
            const direction = (0, $ha1VO.TmpVectors).Vector3[1];
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(ray.origin, world, worldOrigin);
            ray.direction.scaleToRef(intersectInfo.distance, direction);
            const worldDirection = (0, $ha1VO.Vector3).TransformNormal(direction, world);
            const pickedPoint = worldDirection.addInPlace(worldOrigin);
            // Return result
            pickingInfo.hit = true;
            pickingInfo.distance = (0, $ha1VO.Vector3).Distance(worldOrigin, pickedPoint);
            pickingInfo.pickedPoint = pickedPoint;
            pickingInfo.pickedMesh = this;
            pickingInfo.bu = intersectInfo.bu || 0;
            pickingInfo.bv = intersectInfo.bv || 0;
            pickingInfo.subMeshFaceId = intersectInfo.faceId;
            pickingInfo.faceId = intersectInfo.faceId + subMeshes.data[intersectInfo.subMeshId].indexStart / (this.getClassName().indexOf("LinesMesh") !== -1 ? 2 : 3);
            pickingInfo.subMeshId = intersectInfo.subMeshId;
            return pickingInfo;
        }
        return pickingInfo;
    }
    /**
     * Clones the current mesh
     * @param name defines the mesh name
     * @param newParent defines the new mesh parent
     * @param doNotCloneChildren defines a boolean indicating that children must not be cloned (false by default)
     * @returns the new mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clone(name, newParent, doNotCloneChildren) {
        return null;
    }
    /**
     * Disposes all the submeshes of the current mesh
     * @param immediate should dispose the effects immediately or not
     * @returns the current mesh
     */ releaseSubMeshes(immediate = false) {
        if (this.subMeshes) while(this.subMeshes.length)this.subMeshes[0].dispose(immediate);
        else this.subMeshes = [];
        return this;
    }
    /**
     * Releases resources associated with this abstract mesh.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        let index;
        const scene = this.getScene();
        // mesh map release.
        if (this._scene.useMaterialMeshMap) // remove from material mesh map id needed
        {
            if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = undefined;
        }
        // Smart Array Retainers.
        scene.freeActiveMeshes();
        scene.freeRenderingGroups();
        if (scene.renderingManager.maintainStateBetweenFrames) scene.renderingManager.restoreDispachedFlags();
        // Action manager
        if (this.actionManager !== undefined && this.actionManager !== null) {
            // If we are the only mesh using the action manager, dispose of the action manager too unless it has opted out from that behavior
            if (this.actionManager.disposeWhenUnowned && !this._scene.meshes.some((m)=>m !== this && m.actionManager === this.actionManager)) this.actionManager.dispose();
            this.actionManager = null;
        }
        // Skeleton
        this._internalAbstractMeshDataInfo._skeleton = null;
        if (this._transformMatrixTexture) {
            this._transformMatrixTexture.dispose();
            this._transformMatrixTexture = null;
        }
        // Intersections in progress
        for(index = 0; index < this._intersectionsInProgress.length; index++){
            const other = this._intersectionsInProgress[index];
            const pos = other._intersectionsInProgress.indexOf(this);
            other._intersectionsInProgress.splice(pos, 1);
        }
        this._intersectionsInProgress.length = 0;
        // Lights
        const lights = scene.lights;
        lights.forEach((light)=>{
            let meshIndex = light.includedOnlyMeshes.indexOf(this);
            if (meshIndex !== -1) light.includedOnlyMeshes.splice(meshIndex, 1);
            meshIndex = light.excludedMeshes.indexOf(this);
            if (meshIndex !== -1) light.excludedMeshes.splice(meshIndex, 1);
            // Shadow generators
            const generators = light.getShadowGenerators();
            if (generators) {
                const iterator = generators.values();
                for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                    const generator = key.value;
                    const shadowMap = generator.getShadowMap();
                    if (shadowMap && shadowMap.renderList) {
                        meshIndex = shadowMap.renderList.indexOf(this);
                        if (meshIndex !== -1) shadowMap.renderList.splice(meshIndex, 1);
                    }
                }
            }
        });
        // SubMeshes
        if (this.getClassName() !== "InstancedMesh" || this.getClassName() !== "InstancedLinesMesh") this.releaseSubMeshes(true);
        // Query
        const engine = scene.getEngine();
        if (this._occlusionQuery !== null) {
            this.isOcclusionQueryInProgress = false;
            engine.deleteQuery(this._occlusionQuery);
            this._occlusionQuery = null;
        }
        // Engine
        engine.wipeCaches();
        // Remove from scene
        scene.removeMesh(this);
        if (this._parentContainer) {
            const index = this._parentContainer.meshes.indexOf(this);
            if (index > -1) this._parentContainer.meshes.splice(index, 1);
            this._parentContainer = null;
        }
        if (disposeMaterialAndTextures) {
            if (this.material) {
                if (this.material.getClassName() === "MultiMaterial") this.material.dispose(false, true, true);
                else this.material.dispose(false, true);
            }
        }
        if (!doNotRecurse) {
            // Particles
            for(index = 0; index < scene.particleSystems.length; index++)if (scene.particleSystems[index].emitter === this) {
                scene.particleSystems[index].dispose();
                index--;
            }
        }
        // facet data
        if (this._internalAbstractMeshDataInfo._facetData.facetDataEnabled) this.disableFacetData();
        this._uniformBuffer.dispose();
        this.onAfterWorldMatrixUpdateObservable.clear();
        this.onCollideObservable.clear();
        this.onCollisionPositionChangeObservable.clear();
        this.onRebuildObservable.clear();
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    // Facet data
    /** @internal */ _initFacetData() {
        const data = this._internalAbstractMeshDataInfo._facetData;
        if (!data.facetNormals) data.facetNormals = [];
        if (!data.facetPositions) data.facetPositions = [];
        if (!data.facetPartitioning) data.facetPartitioning = new Array();
        data.facetNb = this.getIndices().length / 3 | 0;
        data.partitioningSubdivisions = data.partitioningSubdivisions ? data.partitioningSubdivisions : 10; // default nb of partitioning subdivisions = 10
        data.partitioningBBoxRatio = data.partitioningBBoxRatio ? data.partitioningBBoxRatio : 1.01; // default ratio 1.01 = the partitioning is 1% bigger than the bounding box
        for(let f = 0; f < data.facetNb; f++){
            data.facetNormals[f] = (0, $ha1VO.Vector3).Zero();
            data.facetPositions[f] = (0, $ha1VO.Vector3).Zero();
        }
        data.facetDataEnabled = true;
        return this;
    }
    /**
     * Updates the mesh facetData arrays and the internal partitioning when the mesh is morphed or updated.
     * This method can be called within the render loop.
     * You don't need to call this method by yourself in the render loop when you update/morph a mesh with the methods CreateXXX() as they automatically manage this computation
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ updateFacetData() {
        const data = this._internalAbstractMeshDataInfo._facetData;
        if (!data.facetDataEnabled) this._initFacetData();
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this.getIndices();
        const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const bInfo = this.getBoundingInfo();
        if (data.facetDepthSort && !data.facetDepthSortEnabled) {
            // init arrays, matrix and sort function on first call
            data.facetDepthSortEnabled = true;
            if (indices instanceof Uint16Array) data.depthSortedIndices = new Uint16Array(indices);
            else if (indices instanceof Uint32Array) data.depthSortedIndices = new Uint32Array(indices);
            else {
                let needs32bits = false;
                for(let i = 0; i < indices.length; i++)if (indices[i] > 65535) {
                    needs32bits = true;
                    break;
                }
                if (needs32bits) data.depthSortedIndices = new Uint32Array(indices);
                else data.depthSortedIndices = new Uint16Array(indices);
            }
            data.facetDepthSortFunction = function(f1, f2) {
                return f2.sqDistance - f1.sqDistance;
            };
            if (!data.facetDepthSortFrom) {
                const camera = this.getScene().activeCamera;
                data.facetDepthSortFrom = camera ? camera.position : (0, $ha1VO.Vector3).Zero();
            }
            data.depthSortedFacets = [];
            for(let f = 0; f < data.facetNb; f++){
                const depthSortedFacet = {
                    ind: f * 3,
                    sqDistance: 0.0
                };
                data.depthSortedFacets.push(depthSortedFacet);
            }
            data.invertedMatrix = (0, $ha1VO.Matrix).Identity();
            data.facetDepthSortOrigin = (0, $ha1VO.Vector3).Zero();
        }
        data.bbSize.x = bInfo.maximum.x - bInfo.minimum.x > (0, $53VPf.Epsilon) ? bInfo.maximum.x - bInfo.minimum.x : (0, $53VPf.Epsilon);
        data.bbSize.y = bInfo.maximum.y - bInfo.minimum.y > (0, $53VPf.Epsilon) ? bInfo.maximum.y - bInfo.minimum.y : (0, $53VPf.Epsilon);
        data.bbSize.z = bInfo.maximum.z - bInfo.minimum.z > (0, $53VPf.Epsilon) ? bInfo.maximum.z - bInfo.minimum.z : (0, $53VPf.Epsilon);
        let bbSizeMax = data.bbSize.x > data.bbSize.y ? data.bbSize.x : data.bbSize.y;
        bbSizeMax = bbSizeMax > data.bbSize.z ? bbSizeMax : data.bbSize.z;
        data.subDiv.max = data.partitioningSubdivisions;
        data.subDiv.X = Math.floor(data.subDiv.max * data.bbSize.x / bbSizeMax); // adjust the number of subdivisions per axis
        data.subDiv.Y = Math.floor(data.subDiv.max * data.bbSize.y / bbSizeMax); // according to each bbox size per axis
        data.subDiv.Z = Math.floor(data.subDiv.max * data.bbSize.z / bbSizeMax);
        data.subDiv.X = data.subDiv.X < 1 ? 1 : data.subDiv.X; // at least one subdivision
        data.subDiv.Y = data.subDiv.Y < 1 ? 1 : data.subDiv.Y;
        data.subDiv.Z = data.subDiv.Z < 1 ? 1 : data.subDiv.Z;
        // set the parameters for ComputeNormals()
        data.facetParameters.facetNormals = this.getFacetLocalNormals();
        data.facetParameters.facetPositions = this.getFacetLocalPositions();
        data.facetParameters.facetPartitioning = this.getFacetLocalPartitioning();
        data.facetParameters.bInfo = bInfo;
        data.facetParameters.bbSize = data.bbSize;
        data.facetParameters.subDiv = data.subDiv;
        data.facetParameters.ratio = this.partitioningBBoxRatio;
        data.facetParameters.depthSort = data.facetDepthSort;
        if (data.facetDepthSort && data.facetDepthSortEnabled) {
            this.computeWorldMatrix(true);
            this._worldMatrix.invertToRef(data.invertedMatrix);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(data.facetDepthSortFrom, data.invertedMatrix, data.facetDepthSortOrigin);
            data.facetParameters.distanceTo = data.facetDepthSortOrigin;
        }
        data.facetParameters.depthSortedFacets = data.depthSortedFacets;
        if (normals) (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals, data.facetParameters);
        if (data.facetDepthSort && data.facetDepthSortEnabled) {
            data.depthSortedFacets.sort(data.facetDepthSortFunction);
            const l = data.depthSortedIndices.length / 3 | 0;
            for(let f = 0; f < l; f++){
                const sind = data.depthSortedFacets[f].ind;
                data.depthSortedIndices[f * 3] = indices[sind];
                data.depthSortedIndices[f * 3 + 1] = indices[sind + 1];
                data.depthSortedIndices[f * 3 + 2] = indices[sind + 2];
            }
            this.updateIndices(data.depthSortedIndices, undefined, true);
        }
        return this;
    }
    /**
     * Returns the facetLocalNormals array.
     * The normals are expressed in the mesh local spac
     * @returns an array of Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetLocalNormals() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (!facetData.facetNormals) this.updateFacetData();
        return facetData.facetNormals;
    }
    /**
     * Returns the facetLocalPositions array.
     * The facet positions are expressed in the mesh local space
     * @returns an array of Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetLocalPositions() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (!facetData.facetPositions) this.updateFacetData();
        return facetData.facetPositions;
    }
    /**
     * Returns the facetLocalPartitioning array
     * @returns an array of array of numbers
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetLocalPartitioning() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (!facetData.facetPartitioning) this.updateFacetData();
        return facetData.facetPartitioning;
    }
    /**
     * Returns the i-th facet position in the world system.
     * This method allocates a new Vector3 per call
     * @param i defines the facet index
     * @returns a new Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetPosition(i) {
        const pos = (0, $ha1VO.Vector3).Zero();
        this.getFacetPositionToRef(i, pos);
        return pos;
    }
    /**
     * Sets the reference Vector3 with the i-th facet position in the world system
     * @param i defines the facet index
     * @param ref defines the target vector
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetPositionToRef(i, ref) {
        const localPos = this.getFacetLocalPositions()[i];
        const world = this.getWorldMatrix();
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(localPos, world, ref);
        return this;
    }
    /**
     * Returns the i-th facet normal in the world system.
     * This method allocates a new Vector3 per call
     * @param i defines the facet index
     * @returns a new Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetNormal(i) {
        const norm = (0, $ha1VO.Vector3).Zero();
        this.getFacetNormalToRef(i, norm);
        return norm;
    }
    /**
     * Sets the reference Vector3 with the i-th facet normal in the world system
     * @param i defines the facet index
     * @param ref defines the target vector
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetNormalToRef(i, ref) {
        const localNorm = this.getFacetLocalNormals()[i];
        (0, $ha1VO.Vector3).TransformNormalToRef(localNorm, this.getWorldMatrix(), ref);
        return this;
    }
    /**
     * Returns the facets (in an array) in the same partitioning block than the one the passed coordinates are located (expressed in the mesh local system)
     * @param x defines x coordinate
     * @param y defines y coordinate
     * @param z defines z coordinate
     * @returns the array of facet indexes
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetsAtLocalCoordinates(x, y, z) {
        const bInfo = this.getBoundingInfo();
        const data = this._internalAbstractMeshDataInfo._facetData;
        const ox = Math.floor((x - bInfo.minimum.x * data.partitioningBBoxRatio) * data.subDiv.X * data.partitioningBBoxRatio / data.bbSize.x);
        const oy = Math.floor((y - bInfo.minimum.y * data.partitioningBBoxRatio) * data.subDiv.Y * data.partitioningBBoxRatio / data.bbSize.y);
        const oz = Math.floor((z - bInfo.minimum.z * data.partitioningBBoxRatio) * data.subDiv.Z * data.partitioningBBoxRatio / data.bbSize.z);
        if (ox < 0 || ox > data.subDiv.max || oy < 0 || oy > data.subDiv.max || oz < 0 || oz > data.subDiv.max) return null;
        return data.facetPartitioning[ox + data.subDiv.max * oy + data.subDiv.max * data.subDiv.max * oz];
    }
    /**
     * Returns the closest mesh facet index at (x,y,z) World coordinates, null if not found
     * @param x defines x coordinate
     * @param y defines y coordinate
     * @param z defines z coordinate
     * @param projected sets as the (x,y,z) world projection on the facet
     * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
     * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
     * @returns the face index if found (or null instead)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getClosestFacetAtCoordinates(x, y, z, projected, checkFace = false, facing = true) {
        const world = this.getWorldMatrix();
        const invMat = (0, $ha1VO.TmpVectors).Matrix[5];
        world.invertToRef(invMat);
        const invVect = (0, $ha1VO.TmpVectors).Vector3[8];
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, y, z, invMat, invVect); // transform (x,y,z) to coordinates in the mesh local space
        const closest = this.getClosestFacetAtLocalCoordinates(invVect.x, invVect.y, invVect.z, projected, checkFace, facing);
        if (projected) // transform the local computed projected vector to world coordinates
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(projected.x, projected.y, projected.z, world, projected);
        return closest;
    }
    /**
     * Returns the closest mesh facet index at (x,y,z) local coordinates, null if not found
     * @param x defines x coordinate
     * @param y defines y coordinate
     * @param z defines z coordinate
     * @param projected sets as the (x,y,z) local projection on the facet
     * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
     * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
     * @returns the face index if found (or null instead)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getClosestFacetAtLocalCoordinates(x, y, z, projected, checkFace = false, facing = true) {
        let closest = null;
        let tmpx = 0.0;
        let tmpy = 0.0;
        let tmpz = 0.0;
        let d = 0.0; // tmp dot facet normal * facet position
        let t0 = 0.0;
        let projx = 0.0;
        let projy = 0.0;
        let projz = 0.0;
        // Get all the facets in the same partitioning block than (x, y, z)
        const facetPositions = this.getFacetLocalPositions();
        const facetNormals = this.getFacetLocalNormals();
        const facetsInBlock = this.getFacetsAtLocalCoordinates(x, y, z);
        if (!facetsInBlock) return null;
        // Get the closest facet to (x, y, z)
        let shortest = Number.MAX_VALUE; // init distance vars
        let tmpDistance = shortest;
        let fib; // current facet in the block
        let norm; // current facet normal
        let p0; // current facet barycenter position
        // loop on all the facets in the current partitioning block
        for(let idx = 0; idx < facetsInBlock.length; idx++){
            fib = facetsInBlock[idx];
            norm = facetNormals[fib];
            p0 = facetPositions[fib];
            d = (x - p0.x) * norm.x + (y - p0.y) * norm.y + (z - p0.z) * norm.z;
            if (!checkFace || checkFace && facing && d >= 0.0 || checkFace && !facing && d <= 0.0) {
                // compute (x,y,z) projection on the facet = (projx, projy, projz)
                d = norm.x * p0.x + norm.y * p0.y + norm.z * p0.z;
                t0 = -(norm.x * x + norm.y * y + norm.z * z - d) / (norm.x * norm.x + norm.y * norm.y + norm.z * norm.z);
                projx = x + norm.x * t0;
                projy = y + norm.y * t0;
                projz = z + norm.z * t0;
                tmpx = projx - x;
                tmpy = projy - y;
                tmpz = projz - z;
                tmpDistance = tmpx * tmpx + tmpy * tmpy + tmpz * tmpz; // compute length between (x, y, z) and its projection on the facet
                if (tmpDistance < shortest) {
                    // just keep the closest facet to (x, y, z)
                    shortest = tmpDistance;
                    closest = fib;
                    if (projected) {
                        projected.x = projx;
                        projected.y = projy;
                        projected.z = projz;
                    }
                }
            }
        }
        return closest;
    }
    /**
     * Returns the object "parameter" set with all the expected parameters for facetData computation by ComputeNormals()
     * @returns the parameters
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetDataParameters() {
        return this._internalAbstractMeshDataInfo._facetData.facetParameters;
    }
    /**
     * Disables the feature FacetData and frees the related memory
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ disableFacetData() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (facetData.facetDataEnabled) {
            facetData.facetDataEnabled = false;
            facetData.facetPositions = [];
            facetData.facetNormals = [];
            facetData.facetPartitioning = new Array();
            facetData.facetParameters = {};
            facetData.depthSortedIndices = new Uint32Array(0);
        }
        return this;
    }
    /**
     * Updates the AbstractMesh indices array
     * @param indices defines the data source
     * @param offset defines the offset in the index buffer where to store the new data (can be null)
     * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateIndices(indices, offset, gpuMemoryOnly = false) {
        return this;
    }
    /**
     * Creates new normals data for the mesh
     * @param updatable defines if the normal vertex buffer must be flagged as updatable
     * @returns the current mesh
     */ createNormals(updatable) {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this.getIndices();
        let normals;
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        else normals = [];
        (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals, {
            useRightHandedSystem: this.getScene().useRightHandedSystem
        });
        this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, updatable);
        return this;
    }
    /**
     * Optimize the indices order so that we keep the faces with similar indices together
     * @returns the current mesh
     */ async optimizeIndicesAsync() {
        const indices = this.getIndices();
        if (!indices) return this;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { OptimizeIndices: OptimizeIndices } = await (parcelRequire("b1pUy"));
        OptimizeIndices(indices);
        this.setIndices(indices, this.getTotalVertices());
        return this;
    }
    /**
     * Align the mesh with a normal
     * @param normal defines the normal to use
     * @param upDirection can be used to redefined the up vector to use (will use the (0, 1, 0) by default)
     * @returns the current mesh
     */ alignWithNormal(normal, upDirection) {
        if (!upDirection) upDirection = (0, $dbxbu.Axis).Y;
        const axisX = (0, $ha1VO.TmpVectors).Vector3[0];
        const axisZ = (0, $ha1VO.TmpVectors).Vector3[1];
        (0, $ha1VO.Vector3).CrossToRef(upDirection, normal, axisZ);
        (0, $ha1VO.Vector3).CrossToRef(normal, axisZ, axisX);
        if (this.rotationQuaternion) (0, $ha1VO.Quaternion).RotationQuaternionFromAxisToRef(axisX, normal, axisZ, this.rotationQuaternion);
        else (0, $ha1VO.Vector3).RotationFromAxisToRef(axisX, normal, axisZ, this.rotation);
        return this;
    }
    /** @internal */ _checkOcclusionQuery() {
        // Will be replaced by correct code if Occlusion queries are referenced
        return false;
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Disables the mesh edge rendering mode
     * @returns the currentAbstractMesh
     */ disableEdgesRendering() {
        throw (0, $dUFYy._WarnImport)("EdgesRenderer");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Enables the edge rendering mode on the mesh.
     * This mode makes the mesh edges visible
     * @param epsilon defines the maximal distance between two angles to detect a face
     * @param checkVerticesInsteadOfIndices indicates that we should check vertex list directly instead of faces
     * @param options options to the edge renderer
     * @returns the currentAbstractMesh
     * @see https://www.babylonjs-playground.com/#19O9TU#0
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    enableEdgesRendering(epsilon, checkVerticesInsteadOfIndices, options) {
        throw (0, $dUFYy._WarnImport)("EdgesRenderer");
    }
    /**
     * This function returns all of the particle systems in the scene that use the mesh as an emitter.
     * @returns an array of particle systems in the scene that use the mesh as an emitter
     */ getConnectedParticleSystems() {
        return this._scene.particleSystems.filter((particleSystem)=>particleSystem.emitter === this);
    }
}
/** No occlusion */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_TYPE_NONE = 0;
/** Occlusion set to optimistic */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_TYPE_OPTIMISTIC = 1;
/** Occlusion set to strict */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_TYPE_STRICT = 2;
/** Use an accurate occlusion algorithm */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_ALGORITHM_TYPE_ACCURATE = 0;
/** Use a conservative occlusion algorithm */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_ALGORITHM_TYPE_CONSERVATIVE = 1;
/** Default culling strategy : this is an exclusion test and it's the more accurate.
 *  Test order :
 *  Is the bounding sphere outside the frustum ?
 *  If not, are the bounding box vertices outside the frustum ?
 *  It not, then the cullable object is in the frustum.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_STANDARD = 0;
/** Culling strategy : Bounding Sphere Only.
 *  This is an exclusion test. It's faster than the standard strategy because the bounding box is not tested.
 *  It's also less accurate than the standard because some not visible objects can still be selected.
 *  Test : is the bounding sphere outside the frustum ?
 *  If not, then the cullable object is in the frustum.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
/** Culling strategy : Optimistic Inclusion.
 *  This in an inclusion test first, then the standard exclusion test.
 *  This can be faster when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the standard test when the tested object center is not the frustum but one of its bounding box vertex is still inside.
 *  Anyway, it's as accurate as the standard strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the default culling strategy.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
/** Culling strategy : Optimistic Inclusion then Bounding Sphere Only.
 *  This in an inclusion test first, then the bounding sphere only exclusion test.
 *  This can be the fastest test when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the BoundingSphereOnly strategy when the tested object center is not in the frustum but its bounding sphere still intersects it.
 *  It's less accurate than the standard strategy and as accurate as the BoundingSphereOnly strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the Bounding Sphere Only strategy. No Bounding Box is tested here.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[data, matricesIndicesData, matricesWeightsData, matricesIndicesExtraData, matricesWeightsExtraData])=>!Array.isArray(data) && !Array.isArray(matricesIndicesData) && !Array.isArray(matricesWeightsData) && !Array.isArray(matricesIndicesExtraData) && !Array.isArray(matricesWeightsExtraData))
], $0009db3ebb3b86d3$export$8f1d8af674c785a5, "_ApplySkeleton", null);
(0, $8DoUR.RegisterClass)("BABYLON.AbstractMesh", $0009db3ebb3b86d3$export$8f1d8af674c785a5);






var $7212E = parcelRequire("7212E");

var $8DoUR = parcelRequire("8DoUR");
class $29a508bfe7b38d6b$export$4f1842f7cdf61f78 extends (0, $3afee756ef198914$export$a2d8b23205c25948) {
    /**
     * Gets or Sets the list of Materials used within the multi material.
     * They need to be ordered according to the submeshes order in the associated mesh
     */ get subMaterials() {
        return this._subMaterials;
    }
    set subMaterials(value) {
        this._subMaterials = value;
        this._hookArray(value);
    }
    /**
     * Function used to align with Node.getChildren()
     * @returns the list of Materials used within the multi material
     */ getChildren() {
        return this.subMaterials;
    }
    /**
     * Instantiates a new Multi Material
     * A multi-material is used to apply different materials to different parts of the same object without the need of
     * separate meshes. This can be use to improve performances.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
     * @param name Define the name in the scene
     * @param scene Define the scene the material belongs to
     */ constructor(name, scene){
        super(name, scene, true);
        /** @internal */ this._waitingSubMaterialsUniqueIds = [];
        this.getScene().addMultiMaterial(this);
        this.subMaterials = [];
        this._storeEffectOnSubMeshes = true; // multimaterial is considered like a push material
    }
    _hookArray(array) {
        const oldPush = array.push;
        array.push = (...items)=>{
            const result = oldPush.apply(array, items);
            this._markAllSubMeshesAsTexturesDirty();
            return result;
        };
        const oldSplice = array.splice;
        array.splice = (index, deleteCount)=>{
            const deleted = oldSplice.apply(array, [
                index,
                deleteCount
            ]);
            this._markAllSubMeshesAsTexturesDirty();
            return deleted;
        };
    }
    /**
     * Get one of the submaterial by its index in the submaterials array
     * @param index The index to look the sub material at
     * @returns The Material if the index has been defined
     */ getSubMaterial(index) {
        if (index < 0 || index >= this.subMaterials.length) return this.getScene().defaultMaterial;
        return this.subMaterials[index];
    }
    /**
     * Get the list of active textures for the whole sub materials list.
     * @returns All the textures that will be used during the rendering
     */ getActiveTextures() {
        return super.getActiveTextures().concat(...this.subMaterials.map((subMaterial)=>{
            if (subMaterial) return subMaterial.getActiveTextures();
            else return [];
        }));
    }
    /**
     * Specifies if any sub-materials of this multi-material use a given texture.
     * @param texture Defines the texture to check against this multi-material's sub-materials.
     * @returns A boolean specifying if any sub-material of this multi-material uses the texture.
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        for(let i = 0; i < this.subMaterials.length; i++){
            if (this.subMaterials[i]?.hasTexture(texture)) return true;
        }
        return false;
    }
    /**
     * Gets the current class name of the material e.g. "MultiMaterial"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "MultiMaterial";
    }
    /**
     * Checks if the material is ready to render the requested sub mesh
     * @param mesh Define the mesh the submesh belongs to
     * @param subMesh Define the sub mesh to look readiness for
     * @param useInstances Define whether or not the material is used with instances
     * @returns true if ready, otherwise false
     */ isReadyForSubMesh(mesh, subMesh, useInstances) {
        for(let index = 0; index < this.subMaterials.length; index++){
            const subMaterial = this.subMaterials[index];
            if (subMaterial) {
                if (subMaterial._storeEffectOnSubMeshes) {
                    if (!subMaterial.isReadyForSubMesh(mesh, subMesh, useInstances)) return false;
                    continue;
                }
                if (!subMaterial.isReady(mesh)) return false;
            }
        }
        return true;
    }
    /**
     * Clones the current material and its related sub materials
     * @param name Define the name of the newly cloned material
     * @param cloneChildren Define if submaterial will be cloned or shared with the parent instance
     * @returns the cloned material
     */ clone(name, cloneChildren) {
        const newMultiMaterial = new $29a508bfe7b38d6b$export$4f1842f7cdf61f78(name, this.getScene());
        for(let index = 0; index < this.subMaterials.length; index++){
            let subMaterial = null;
            const current = this.subMaterials[index];
            if (cloneChildren && current) subMaterial = current.clone(name + "-" + current.name);
            else subMaterial = this.subMaterials[index];
            newMultiMaterial.subMaterials.push(subMaterial);
        }
        return newMultiMaterial;
    }
    /**
     * Serializes the materials into a JSON representation.
     * @returns the JSON representation
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.id = this.id;
        serializationObject.uniqueId = this.uniqueId;
        if (0, $7212E.Tags) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        serializationObject.materialsUniqueIds = [];
        serializationObject.materials = [];
        for(let matIndex = 0; matIndex < this.subMaterials.length; matIndex++){
            const subMat = this.subMaterials[matIndex];
            if (subMat) {
                serializationObject.materialsUniqueIds.push(subMat.uniqueId);
                serializationObject.materials.push(subMat.id);
            } else {
                serializationObject.materialsUniqueIds.push(null);
                serializationObject.materials.push(null);
            }
        }
        return serializationObject;
    }
    /**
     * Dispose the material and release its associated resources
     * @param forceDisposeEffect Define if we want to force disposing the associated effect (if false the shader is not released and could be reuse later on)
     * @param forceDisposeTextures Define if we want to force disposing the associated textures (if false, they will not be disposed and can still be use elsewhere in the app)
     * @param forceDisposeChildren Define if we want to force disposing the associated submaterials (if false, they will not be disposed and can still be use elsewhere in the app)
     */ dispose(forceDisposeEffect, forceDisposeTextures, forceDisposeChildren) {
        const scene = this.getScene();
        if (!scene) return;
        if (forceDisposeChildren) for(let index = 0; index < this.subMaterials.length; index++){
            const subMaterial = this.subMaterials[index];
            if (subMaterial) subMaterial.dispose(forceDisposeEffect, forceDisposeTextures);
        }
        const index = scene.multiMaterials.indexOf(this);
        if (index >= 0) scene.multiMaterials.splice(index, 1);
        super.dispose(forceDisposeEffect, forceDisposeTextures);
    }
    /**
     * Creates a MultiMaterial from parsed MultiMaterial data.
     * @param parsedMultiMaterial defines parsed MultiMaterial data.
     * @param scene defines the hosting scene
     * @returns a new MultiMaterial
     */ static ParseMultiMaterial(parsedMultiMaterial, scene) {
        const multiMaterial = new $29a508bfe7b38d6b$export$4f1842f7cdf61f78(parsedMultiMaterial.name, scene);
        multiMaterial.id = parsedMultiMaterial.id;
        multiMaterial._loadedUniqueId = parsedMultiMaterial.uniqueId;
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(multiMaterial, parsedMultiMaterial.tags);
        if (parsedMultiMaterial.materialsUniqueIds) multiMaterial._waitingSubMaterialsUniqueIds = parsedMultiMaterial.materialsUniqueIds;
        else parsedMultiMaterial.materials.forEach((subMatId)=>multiMaterial.subMaterials.push(scene.getLastMaterialById(subMatId)));
        return multiMaterial;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MultiMaterial", $29a508bfe7b38d6b$export$4f1842f7cdf61f78);




var $6Ho1L = parcelRequire("6Ho1L");

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");

var $dUFYy = parcelRequire("dUFYy");

var $bv05l = parcelRequire("bv05l");
/**
 * Class used to represent a specific level of detail of a mesh
 * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
 */ class $6834609b79a79ffd$export$70c2ba6cf05fb340 {
    /**
     * Creates a new LOD level
     * @param distanceOrScreenCoverage defines either the distance or the screen coverage where this level should start being displayed
     * @param mesh defines the mesh to use to render this level
     */ constructor(/** Either distance from the center of the object to show this level or the screen coverage if `useLODScreenCoverage` is set to `true` on the mesh*/ distanceOrScreenCoverage, /** Defines the mesh to use to render this level */ mesh){
        this.distanceOrScreenCoverage = distanceOrScreenCoverage;
        this.mesh = mesh;
    }
}


class $b0df7c384622c537$export$40270a8f3a8ca785 {
}
/**
 * @internal
 **/ class $b0df7c384622c537$var$_InstanceDataStorage {
    constructor(){
        this.visibleInstances = {};
        this.batchCache = new $b0df7c384622c537$export$5016a5ee8d7edd22();
        this.batchCacheReplacementModeInFrozenMode = new $b0df7c384622c537$export$5016a5ee8d7edd22();
        this.instancesBufferSize = 2048; // let's start with a maximum of 32 instances
    }
}
class $b0df7c384622c537$export$5016a5ee8d7edd22 {
    constructor(){
        this.mustReturn = false;
        this.visibleInstances = new Array();
        this.renderSelf = [];
        this.hardwareInstancedRendering = [];
    }
}
/**
 * @internal
 **/ class $b0df7c384622c537$var$_ThinInstanceDataStorage {
    constructor(){
        this.instancesCount = 0;
        this.matrixBuffer = null;
        this.previousMatrixBuffer = null;
        this.matrixBufferSize = 512; // let's start with a maximum of 32 thin instances
        this.matrixData = null;
        this.boundingVectors = [];
        this.worldMatrices = null;
    }
}
/**
 * @internal
 **/ class $b0df7c384622c537$var$_InternalMeshDataInfo {
    constructor(){
        this._areNormalsFrozen = false; // Will be used by ribbons mainly
        // Will be used to save a source mesh reference, If any
        this._source = null;
        // Will be used to for fast cloned mesh lookup
        this.meshMap = null;
        this._preActivateId = -1;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this._LODLevels = new Array();
        /** Alternative definition of LOD level, using screen coverage instead of distance */ this._useLODScreenCoverage = false;
        this._effectiveMaterial = null;
        this._forcedInstanceCount = 0;
        this._overrideRenderingFillMode = null;
    }
}
const $b0df7c384622c537$var$meshCreationOptions = {
    source: null,
    parent: null,
    doNotCloneChildren: false,
    clonePhysicsImpostor: true,
    cloneThinInstances: false
};
class $b0df7c384622c537$export$e176487c05830cc5 extends (0, $0009db3ebb3b86d3$export$8f1d8af674c785a5) {
    /**
     * Gets the default side orientation.
     * @param orientation the orientation to value to attempt to get
     * @returns the default orientation
     * @internal
     */ static _GetDefaultSideOrientation(orientation) {
        return orientation || $b0df7c384622c537$export$e176487c05830cc5.FRONTSIDE; // works as Mesh.FRONTSIDE is 0
    }
    /**
     * Determines if the LOD levels are intended to be calculated using screen coverage (surface area ratio) instead of distance.
     */ get useLODScreenCoverage() {
        return this._internalMeshDataInfo._useLODScreenCoverage;
    }
    set useLODScreenCoverage(value) {
        this._internalMeshDataInfo._useLODScreenCoverage = value;
        this._sortLODLevels();
    }
    get computeBonesUsingShaders() {
        return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
    }
    set computeBonesUsingShaders(value) {
        if (this._internalAbstractMeshDataInfo._computeBonesUsingShaders === value) return;
        if (value && this._internalMeshDataInfo._sourcePositions) {
            // switch from software to GPU computation: we need to reset the vertex and normal buffers that have been updated by the software process
            this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this._internalMeshDataInfo._sourcePositions, true);
            if (this._internalMeshDataInfo._sourceNormals) this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, this._internalMeshDataInfo._sourceNormals, true);
            this._internalMeshDataInfo._sourcePositions = null;
            this._internalMeshDataInfo._sourceNormals = null;
        }
        this._internalAbstractMeshDataInfo._computeBonesUsingShaders = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /**
     * An event triggered before rendering the mesh
     */ get onBeforeRenderObservable() {
        if (!this._internalMeshDataInfo._onBeforeRenderObservable) this._internalMeshDataInfo._onBeforeRenderObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBeforeRenderObservable;
    }
    /**
     * An event triggered before binding the mesh
     */ get onBeforeBindObservable() {
        if (!this._internalMeshDataInfo._onBeforeBindObservable) this._internalMeshDataInfo._onBeforeBindObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBeforeBindObservable;
    }
    /**
     * An event triggered after rendering the mesh
     */ get onAfterRenderObservable() {
        if (!this._internalMeshDataInfo._onAfterRenderObservable) this._internalMeshDataInfo._onAfterRenderObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onAfterRenderObservable;
    }
    /**
     * An event triggeredbetween rendering pass when using separateCullingPass = true
     */ get onBetweenPassObservable() {
        if (!this._internalMeshDataInfo._onBetweenPassObservable) this._internalMeshDataInfo._onBetweenPassObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBetweenPassObservable;
    }
    /**
     * An event triggered before drawing the mesh
     */ get onBeforeDrawObservable() {
        if (!this._internalMeshDataInfo._onBeforeDrawObservable) this._internalMeshDataInfo._onBeforeDrawObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBeforeDrawObservable;
    }
    /**
     * Sets a callback to call before drawing the mesh. It is recommended to use onBeforeDrawObservable instead
     */ set onBeforeDraw(callback) {
        if (this._onBeforeDrawObserver) this.onBeforeDrawObservable.remove(this._onBeforeDrawObserver);
        this._onBeforeDrawObserver = this.onBeforeDrawObservable.add(callback);
    }
    get hasInstances() {
        return this.instances.length > 0;
    }
    get hasThinInstances() {
        return (this.forcedInstanceCount || this._thinInstanceDataStorage.instancesCount || 0) > 0;
    }
    /**
     * Gets or sets the forced number of instances to display.
     * If 0 (default value), the number of instances is not forced and depends on the draw type
     * (regular / instance / thin instances mesh)
     */ get forcedInstanceCount() {
        return this._internalMeshDataInfo._forcedInstanceCount;
    }
    set forcedInstanceCount(count) {
        this._internalMeshDataInfo._forcedInstanceCount = count;
    }
    /**
     * Use this property to change the original side orientation defined at construction time
     * Material.sideOrientation will override this value if set
     * User will still be able to change the material sideOrientation afterwards if they really need it
     */ get sideOrientation() {
        return this._internalMeshDataInfo._sideOrientation;
    }
    set sideOrientation(value) {
        this._internalMeshDataInfo._sideOrientation = value;
        this._internalAbstractMeshDataInfo._sideOrientationHint = this._scene.useRightHandedSystem && value === 1 || !this._scene.useRightHandedSystem && value === 0;
    }
    /**
     * @deprecated Please use sideOrientation instead.
     * @see https://doc.babylonjs.com/breaking-changes#7110
     */ get overrideMaterialSideOrientation() {
        return this.sideOrientation;
    }
    set overrideMaterialSideOrientation(value) {
        this.sideOrientation = value;
        if (this.material) this.material.sideOrientation = null;
    }
    /**
     * Use this property to override the Material's fillMode value
     */ get overrideRenderingFillMode() {
        return this._internalMeshDataInfo._overrideRenderingFillMode;
    }
    set overrideRenderingFillMode(fillMode) {
        this._internalMeshDataInfo._overrideRenderingFillMode = fillMode;
    }
    get material() {
        return this._internalAbstractMeshDataInfo._material;
    }
    set material(value) {
        if (value && (this.material && this.material.sideOrientation === null || this._internalAbstractMeshDataInfo._sideOrientationHint)) value.sideOrientation = null;
        this._setMaterial(value);
    }
    /**
     * Gets the source mesh (the one used to clone this one from)
     */ get source() {
        return this._internalMeshDataInfo._source;
    }
    /**
     * Gets the list of clones of this mesh
     * The scene must have been constructed with useClonedMeshMap=true for this to work!
     * Note that useClonedMeshMap=true is the default setting
     */ get cloneMeshMap() {
        return this._internalMeshDataInfo.meshMap;
    }
    /**
     * Gets or sets a boolean indicating that this mesh does not use index buffer
     */ get isUnIndexed() {
        return this._unIndexed;
    }
    set isUnIndexed(value) {
        if (this._unIndexed !== value) {
            this._unIndexed = value;
            this._markSubMeshesAsAttributesDirty();
        }
    }
    /** Gets the array buffer used to store the instanced buffer used for instances' world matrices */ get worldMatrixInstancedBuffer() {
        return this._instanceDataStorage.instancesData;
    }
    /** Gets the array buffer used to store the instanced buffer used for instances' previous world matrices */ get previousWorldMatrixInstancedBuffer() {
        return this._instanceDataStorage.instancesPreviousData;
    }
    /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */ get manualUpdateOfWorldMatrixInstancedBuffer() {
        return this._instanceDataStorage.manualUpdate;
    }
    set manualUpdateOfWorldMatrixInstancedBuffer(value) {
        this._instanceDataStorage.manualUpdate = value;
    }
    /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */ get manualUpdateOfPreviousWorldMatrixInstancedBuffer() {
        return this._instanceDataStorage.previousManualUpdate;
    }
    set manualUpdateOfPreviousWorldMatrixInstancedBuffer(value) {
        this._instanceDataStorage.previousManualUpdate = value;
    }
    /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices must be performed in all cases (and notably even in frozen mode) */ get forceWorldMatrixInstancedBufferUpdate() {
        return this._instanceDataStorage.forceMatrixUpdates;
    }
    set forceWorldMatrixInstancedBufferUpdate(value) {
        this._instanceDataStorage.forceMatrixUpdates = value;
    }
    _copySource(source, doNotCloneChildren, clonePhysicsImpostor = true, cloneThinInstances = false) {
        const scene = this.getScene();
        // Geometry
        if (source._geometry) source._geometry.applyToMesh(this);
        // Deep copy
        (0, $fhgis.DeepCopier).DeepCopy(source, this, [
            "name",
            "material",
            "skeleton",
            "instances",
            "parent",
            "uniqueId",
            "source",
            "metadata",
            "morphTargetManager",
            "hasInstances",
            "worldMatrixInstancedBuffer",
            "previousWorldMatrixInstancedBuffer",
            "hasLODLevels",
            "geometry",
            "isBlocked",
            "areNormalsFrozen",
            "facetNb",
            "isFacetDataEnabled",
            "lightSources",
            "useBones",
            "isAnInstance",
            "collider",
            "edgesRenderer",
            "forward",
            "up",
            "right",
            "absolutePosition",
            "absoluteScaling",
            "absoluteRotationQuaternion",
            "isWorldMatrixFrozen",
            "nonUniformScaling",
            "behaviors",
            "worldMatrixFromCache",
            "hasThinInstances",
            "cloneMeshMap",
            "hasBoundingInfo",
            "physicsBody",
            "physicsImpostor"
        ], [
            "_poseMatrix"
        ]);
        // Source mesh
        this._internalMeshDataInfo._source = source;
        if (scene.useClonedMeshMap) {
            if (!source._internalMeshDataInfo.meshMap) source._internalMeshDataInfo.meshMap = {};
            source._internalMeshDataInfo.meshMap[this.uniqueId] = this;
        }
        // Construction Params
        // Clone parameters allowing mesh to be updated in case of parametric shapes.
        this._originalBuilderSideOrientation = source._originalBuilderSideOrientation;
        this._creationDataStorage = source._creationDataStorage;
        // Animation ranges
        if (source._ranges) {
            const ranges = source._ranges;
            for(const name in ranges){
                if (!Object.prototype.hasOwnProperty.call(ranges, name)) continue;
                if (!ranges[name]) continue;
                this.createAnimationRange(name, ranges[name].from, ranges[name].to);
            }
        }
        // Metadata
        if (source.metadata && source.metadata.clone) this.metadata = source.metadata.clone();
        else this.metadata = source.metadata;
        this._internalMetadata = source._internalMetadata;
        // Tags
        if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(source)) (0, $7212E.Tags).AddTagsTo(this, (0, $7212E.Tags).GetTags(source, true));
        // Enabled. We shouldn't need to check the source's ancestors, as this mesh
        // will have the same ones.
        this.setEnabled(source.isEnabled(false));
        // Parent
        this.parent = source.parent;
        // Pivot
        this.setPivotMatrix(source.getPivotMatrix(), this._postMultiplyPivotMatrix);
        this.id = this.name + "." + source.id;
        // Material
        this.material = source.material;
        if (!doNotCloneChildren) {
            // Children
            const directDescendants = source.getDescendants(true);
            for(let index = 0; index < directDescendants.length; index++){
                const child = directDescendants[index];
                if (child._isMesh) {
                    $b0df7c384622c537$var$meshCreationOptions.parent = this;
                    $b0df7c384622c537$var$meshCreationOptions.doNotCloneChildren = doNotCloneChildren;
                    $b0df7c384622c537$var$meshCreationOptions.clonePhysicsImpostor = clonePhysicsImpostor;
                    $b0df7c384622c537$var$meshCreationOptions.cloneThinInstances = cloneThinInstances;
                    child.clone(this.name + "." + child.name, $b0df7c384622c537$var$meshCreationOptions);
                } else if (child.clone) child.clone(this.name + "." + child.name, this);
            }
        }
        // Morphs
        if (source.morphTargetManager) this.morphTargetManager = source.morphTargetManager;
        // Physics clone
        if (scene.getPhysicsEngine) {
            const physicsEngine = scene.getPhysicsEngine();
            if (clonePhysicsImpostor && physicsEngine) {
                if (physicsEngine.getPluginVersion() === 1) {
                    const impostor = physicsEngine.getImpostorForPhysicsObject(source);
                    if (impostor) this.physicsImpostor = impostor.clone(this);
                } else if (physicsEngine.getPluginVersion() === 2) {
                    if (source.physicsBody) source.physicsBody.clone(this);
                }
            }
        }
        // Particles
        for(let index = 0; index < scene.particleSystems.length; index++){
            const system = scene.particleSystems[index];
            if (system.emitter === source) system.clone(system.name, this);
        }
        // Skeleton
        this.skeleton = source.skeleton;
        // Thin instances
        if (cloneThinInstances) {
            if (source._thinInstanceDataStorage.matrixData) {
                this.thinInstanceSetBuffer("matrix", new Float32Array(source._thinInstanceDataStorage.matrixData), 16, !source._thinInstanceDataStorage.matrixBuffer.isUpdatable());
                this._thinInstanceDataStorage.matrixBufferSize = source._thinInstanceDataStorage.matrixBufferSize;
                this._thinInstanceDataStorage.instancesCount = source._thinInstanceDataStorage.instancesCount;
            } else this._thinInstanceDataStorage.matrixBufferSize = source._thinInstanceDataStorage.matrixBufferSize;
            if (source._userThinInstanceBuffersStorage) {
                const userThinInstance = source._userThinInstanceBuffersStorage;
                for(const kind in userThinInstance.data){
                    this.thinInstanceSetBuffer(kind, new Float32Array(userThinInstance.data[kind]), userThinInstance.strides[kind], !userThinInstance.vertexBuffers?.[kind]?.isUpdatable());
                    this._userThinInstanceBuffersStorage.sizes[kind] = userThinInstance.sizes[kind];
                }
            }
        }
        this.refreshBoundingInfo(true, true);
        this.computeWorldMatrix(true);
    }
    /** @internal */ constructor(name, scene = null, parentOrOptions = null, source = null, doNotCloneChildren, clonePhysicsImpostor = true){
        super(name, scene);
        // Internal data
        this._internalMeshDataInfo = new $b0df7c384622c537$var$_InternalMeshDataInfo();
        // Members
        /**
         * Gets the delay loading state of the mesh (when delay loading is turned on)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/importers/incrementalLoading
         */ this.delayLoadState = 0;
        /**
         * Gets the list of instances created from this mesh
         * it is not supposed to be modified manually.
         * Note also that the order of the InstancedMesh wihin the array is not significant and might change.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
         */ this.instances = [];
        // Private
        /** @internal */ this._creationDataStorage = null;
        /** @internal */ this._geometry = null;
        /** @internal */ this._instanceDataStorage = new $b0df7c384622c537$var$_InstanceDataStorage();
        /** @internal */ this._thinInstanceDataStorage = new $b0df7c384622c537$var$_ThinInstanceDataStorage();
        /** @internal */ this._shouldGenerateFlatShading = false;
        // Use by builder only to know what orientation were the mesh build in.
        /** @internal */ this._originalBuilderSideOrientation = $b0df7c384622c537$export$e176487c05830cc5.DEFAULTSIDE;
        /**
         * Gets or sets a boolean indicating whether to render ignoring the active camera's max z setting. (false by default)
         * You should not mix meshes that have this property set to true with meshes that have it set to false if they all write
         * to the depth buffer, because the z-values are not comparable in the two cases and you will get rendering artifacts if you do.
         * You can set the property to true for meshes that do not write to the depth buffer, or set the same value (either false or true) otherwise.
         * Note this will reduce performance when set to true.
         */ this.ignoreCameraMaxZ = false;
        scene = this.getScene();
        if (this._scene.useRightHandedSystem) this.sideOrientation = 0;
        else this.sideOrientation = 1;
        this._onBeforeDraw = (isInstance, world, effectiveMaterial)=>{
            if (isInstance && effectiveMaterial) {
                if (this._uniformBuffer) this.transferToEffect(world);
                else effectiveMaterial.bindOnlyWorldMatrix(world);
            }
        };
        let parent = null;
        let cloneThinInstances = false;
        if (parentOrOptions && parentOrOptions._addToSceneRootNodes === undefined) {
            const options = parentOrOptions;
            parent = options.parent ?? null;
            source = options.source ?? null;
            doNotCloneChildren = options.doNotCloneChildren ?? false;
            clonePhysicsImpostor = options.clonePhysicsImpostor ?? true;
            cloneThinInstances = options.cloneThinInstances ?? false;
        } else parent = parentOrOptions;
        if (source) this._copySource(source, doNotCloneChildren, clonePhysicsImpostor, cloneThinInstances);
        // Parent
        if (parent !== null) this.parent = parent;
        this._instanceDataStorage.hardwareInstancedRendering = this.getEngine().getCaps().instancedArrays;
        this._internalMeshDataInfo._onMeshReadyObserverAdded = (observer)=>{
            // only notify once! then unregister the observer
            observer.unregisterOnNextCall = true;
            if (this.isReady(true)) this.onMeshReadyObservable.notifyObservers(this);
            else if (!this._internalMeshDataInfo._checkReadinessObserver) this._internalMeshDataInfo._checkReadinessObserver = this._scene.onBeforeRenderObservable.add(()=>{
                // check for complete readiness
                if (this.isReady(true)) {
                    this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver);
                    this._internalMeshDataInfo._checkReadinessObserver = null;
                    this.onMeshReadyObservable.notifyObservers(this);
                }
            });
        };
        this.onMeshReadyObservable = new (0, $diGQf.Observable)(this._internalMeshDataInfo._onMeshReadyObserverAdded);
        if (source) source.onClonedObservable.notifyObservers(this);
    }
    instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
        const instance = this.getTotalVertices() === 0 || options && options.doNotInstantiate && (options.doNotInstantiate === true || options.doNotInstantiate(this)) ? this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true) : this.createInstance("instance of " + (this.name || this.id));
        instance.parent = newParent || this.parent;
        instance.position = this.position.clone();
        instance.scaling = this.scaling.clone();
        if (this.rotationQuaternion) instance.rotationQuaternion = this.rotationQuaternion.clone();
        else instance.rotation = this.rotation.clone();
        if (onNewNodeCreated) onNewNodeCreated(this, instance);
        for (const child of this.getChildTransformNodes(true))// instancedMesh should have a different sourced mesh
        if (child.getClassName() === "InstancedMesh" && instance.getClassName() === "Mesh" && child.sourceMesh === this) child.instantiateHierarchy(instance, {
            doNotInstantiate: options && options.doNotInstantiate || false,
            newSourcedMesh: instance
        }, onNewNodeCreated);
        else child.instantiateHierarchy(instance, options, onNewNodeCreated);
        return instance;
    }
    /**
     * Gets the class name
     * @returns the string "Mesh".
     */ getClassName() {
        return "Mesh";
    }
    /** @internal */ get _isMesh() {
        return true;
    }
    /**
     * Returns a description of this mesh
     * @param fullDetails define if full details about this mesh must be used
     * @returns a descriptive string representing this mesh
     */ toString(fullDetails) {
        let ret = super.toString(fullDetails);
        ret += ", n vertices: " + this.getTotalVertices();
        ret += ", parent: " + (this._waitingParentId ? this._waitingParentId : this.parent ? this.parent.name : "NONE");
        if (this.animations) for(let i = 0; i < this.animations.length; i++)ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
        if (fullDetails) {
            if (this._geometry) {
                const ib = this.getIndices();
                const vb = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
                if (vb && ib) ret += ", flat shading: " + (vb.length / 3 === ib.length ? "YES" : "NO");
            } else ret += ", flat shading: UNKNOWN";
        }
        return ret;
    }
    /** @internal */ _unBindEffect() {
        super._unBindEffect();
        for (const instance of this.instances)instance._unBindEffect();
    }
    /**
     * Gets a boolean indicating if this mesh has LOD
     */ get hasLODLevels() {
        return this._internalMeshDataInfo._LODLevels.length > 0;
    }
    /**
     * Gets the list of MeshLODLevel associated with the current mesh
     * @returns an array of MeshLODLevel
     */ getLODLevels() {
        return this._internalMeshDataInfo._LODLevels;
    }
    _sortLODLevels() {
        const sortingOrderFactor = this._internalMeshDataInfo._useLODScreenCoverage ? -1 : 1;
        this._internalMeshDataInfo._LODLevels.sort((a, b)=>{
            if (a.distanceOrScreenCoverage < b.distanceOrScreenCoverage) return sortingOrderFactor;
            if (a.distanceOrScreenCoverage > b.distanceOrScreenCoverage) return -sortingOrderFactor;
            return 0;
        });
    }
    /**
     * Add a mesh as LOD level triggered at the given distance.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param distanceOrScreenCoverage Either distance from the center of the object to show this level or the screen coverage if `useScreenCoverage` is set to `true`.
     * If screen coverage, value is a fraction of the screen's total surface, between 0 and 1.
     * Example Playground for distance https://playground.babylonjs.com/#QE7KM#197
     * Example Playground for screen coverage https://playground.babylonjs.com/#QE7KM#196
     * @param mesh The mesh to be added as LOD level (can be null)
     * @returns This mesh (for chaining)
     */ addLODLevel(distanceOrScreenCoverage, mesh) {
        if (mesh && mesh._masterMesh) {
            (0, $kVtWi.Logger).Warn("You cannot use a mesh as LOD level twice");
            return this;
        }
        const level = new (0, $6834609b79a79ffd$export$70c2ba6cf05fb340)(distanceOrScreenCoverage, mesh);
        this._internalMeshDataInfo._LODLevels.push(level);
        if (mesh) mesh._masterMesh = this;
        this._sortLODLevels();
        return this;
    }
    /**
     * Returns the LOD level mesh at the passed distance or null if not found.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param distance The distance from the center of the object to show this level
     * @returns a Mesh or `null`
     */ getLODLevelAtDistance(distance) {
        const internalDataInfo = this._internalMeshDataInfo;
        for(let index = 0; index < internalDataInfo._LODLevels.length; index++){
            const level = internalDataInfo._LODLevels[index];
            if (level.distanceOrScreenCoverage === distance) return level.mesh;
        }
        return null;
    }
    /**
     * Remove a mesh from the LOD array
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param mesh defines the mesh to be removed
     * @returns This mesh (for chaining)
     */ removeLODLevel(mesh) {
        const internalDataInfo = this._internalMeshDataInfo;
        for(let index = 0; index < internalDataInfo._LODLevels.length; index++)if (internalDataInfo._LODLevels[index].mesh === mesh) {
            internalDataInfo._LODLevels.splice(index, 1);
            if (mesh) mesh._masterMesh = null;
        }
        this._sortLODLevels();
        return this;
    }
    /**
     * Returns the registered LOD mesh distant from the parameter `camera` position if any, else returns the current mesh.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param camera defines the camera to use to compute distance
     * @param boundingSphere defines a custom bounding sphere to use instead of the one from this mesh
     * @returns This mesh (for chaining)
     */ getLOD(camera, boundingSphere) {
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._LODLevels || internalDataInfo._LODLevels.length === 0) return this;
        const bSphere = boundingSphere || this.getBoundingInfo().boundingSphere;
        const distanceToCamera = camera.mode === (0, $52736139c8513fb2$export$79f141de891a5fed).ORTHOGRAPHIC_CAMERA ? camera.minZ : bSphere.centerWorld.subtract(camera.globalPosition).length();
        let compareValue = distanceToCamera;
        let compareSign = 1;
        if (internalDataInfo._useLODScreenCoverage) {
            const screenArea = camera.screenArea;
            let meshArea = bSphere.radiusWorld * camera.minZ / distanceToCamera;
            meshArea = meshArea * meshArea * Math.PI;
            compareValue = meshArea / screenArea;
            compareSign = -1;
        }
        if (compareSign * internalDataInfo._LODLevels[internalDataInfo._LODLevels.length - 1].distanceOrScreenCoverage > compareSign * compareValue) {
            if (this.onLODLevelSelection) this.onLODLevelSelection(compareValue, this, this);
            return this;
        }
        for(let index = 0; index < internalDataInfo._LODLevels.length; index++){
            const level = internalDataInfo._LODLevels[index];
            if (compareSign * level.distanceOrScreenCoverage < compareSign * compareValue) {
                if (level.mesh) {
                    if (level.mesh.delayLoadState === 4) {
                        level.mesh._checkDelayState();
                        return this;
                    }
                    if (level.mesh.delayLoadState === 2) return this;
                    level.mesh._preActivate();
                    level.mesh._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
                }
                if (this.onLODLevelSelection) this.onLODLevelSelection(compareValue, this, level.mesh);
                return level.mesh;
            }
        }
        if (this.onLODLevelSelection) this.onLODLevelSelection(compareValue, this, this);
        return this;
    }
    /**
     * Gets the mesh internal Geometry object
     */ get geometry() {
        return this._geometry;
    }
    /**
     * Returns the total number of vertices within the mesh geometry or zero if the mesh has no geometry.
     * @returns the total number of vertices
     */ getTotalVertices() {
        if (this._geometry === null || this._geometry === undefined) return 0;
        return this._geometry.getTotalVertices();
    }
    /**
     * Returns the content of an associated vertex buffer
     * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param copyWhenShared defines a boolean indicating that if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one
     * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a FloatArray or null if the mesh has no geometry or no vertex buffer for this kind.
     */ getVerticesData(kind, copyWhenShared, forceCopy, bypassInstanceData) {
        if (!this._geometry) return null;
        let data = bypassInstanceData ? undefined : this._userInstancedBuffersStorage?.vertexBuffers[kind]?.getFloatData(this.instances.length + 1, forceCopy || copyWhenShared && this._geometry.meshes.length !== 1);
        if (!data) data = this._geometry.getVerticesData(kind, copyWhenShared, forceCopy);
        return data;
    }
    copyVerticesData(kind, vertexData) {
        if (this._geometry) this._geometry.copyVerticesData(kind, vertexData);
    }
    /**
     * Returns the mesh VertexBuffer object from the requested `kind`
     * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.NormalKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a FloatArray or null if the mesh has no vertex buffer for this kind.
     */ getVertexBuffer(kind, bypassInstanceData) {
        if (!this._geometry) return null;
        return (bypassInstanceData ? undefined : this._userInstancedBuffersStorage?.vertexBuffers[kind]) ?? this._geometry.getVertexBuffer(kind);
    }
    /**
     * Tests if a specific vertex buffer is associated with this mesh
     * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.NormalKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a boolean
     */ isVerticesDataPresent(kind, bypassInstanceData) {
        if (!this._geometry) {
            if (this._delayInfo) return this._delayInfo.indexOf(kind) !== -1;
            return false;
        }
        return !bypassInstanceData && this._userInstancedBuffersStorage?.vertexBuffers[kind] !== undefined || this._geometry.isVerticesDataPresent(kind);
    }
    /**
     * Returns a boolean defining if the vertex data for the requested `kind` is updatable.
     * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a boolean
     */ isVertexBufferUpdatable(kind, bypassInstanceData) {
        if (!this._geometry) {
            if (this._delayInfo) return this._delayInfo.indexOf(kind) !== -1;
            return false;
        }
        if (!bypassInstanceData) {
            const buffer = this._userInstancedBuffersStorage?.vertexBuffers[kind];
            if (buffer) return buffer.isUpdatable();
        }
        return this._geometry.isVertexBufferUpdatable(kind);
    }
    /**
     * Returns a string which contains the list of existing `kinds` of Vertex Data associated with this mesh.
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns an array of strings
     */ getVerticesDataKinds(bypassInstanceData) {
        if (!this._geometry) {
            const result = [];
            if (this._delayInfo) this._delayInfo.forEach(function(kind) {
                result.push(kind);
            });
            return result;
        }
        const kinds = this._geometry.getVerticesDataKinds();
        if (!bypassInstanceData && this._userInstancedBuffersStorage) {
            for(const kind in this._userInstancedBuffersStorage.vertexBuffers)if (kinds.indexOf(kind) === -1) kinds.push(kind);
        }
        return kinds;
    }
    /**
     * Returns a positive integer : the total number of indices in this mesh geometry.
     * @returns the numner of indices or zero if the mesh has no geometry.
     */ getTotalIndices() {
        if (!this._geometry) return 0;
        return this._geometry.getTotalIndices();
    }
    /**
     * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
     * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns the indices array or an empty array if the mesh has no geometry
     */ getIndices(copyWhenShared, forceCopy) {
        if (!this._geometry) return [];
        return this._geometry.getIndices(copyWhenShared, forceCopy);
    }
    get isBlocked() {
        return this._masterMesh !== null && this._masterMesh !== undefined;
    }
    /**
     * Determine if the current mesh is ready to be rendered
     * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
     * @param forceInstanceSupport will check if the mesh will be ready when used with instances (false by default)
     * @returns true if all associated assets are ready (material, textures, shaders)
     */ isReady(completeCheck = false, forceInstanceSupport = false) {
        if (this.delayLoadState === 2) return false;
        if (!super.isReady(completeCheck)) return false;
        if (!this.subMeshes || this.subMeshes.length === 0) return true;
        if (!completeCheck) return true;
        const engine = this.getEngine();
        const scene = this.getScene();
        const hardwareInstancedRendering = forceInstanceSupport || engine.getCaps().instancedArrays && (this.instances.length > 0 || this.hasThinInstances);
        this.computeWorldMatrix();
        const mat = this.material || scene.defaultMaterial;
        if (mat) {
            if (mat._storeEffectOnSubMeshes) for (const subMesh of this.subMeshes){
                const effectiveMaterial = subMesh.getMaterial();
                if (effectiveMaterial) {
                    if (effectiveMaterial._storeEffectOnSubMeshes) {
                        if (!effectiveMaterial.isReadyForSubMesh(this, subMesh, hardwareInstancedRendering)) return false;
                    } else {
                        if (!effectiveMaterial.isReady(this, hardwareInstancedRendering)) return false;
                    }
                }
            }
            else {
                if (!mat.isReady(this, hardwareInstancedRendering)) return false;
            }
        }
        // Shadows
        const currentRenderPassId = engine.currentRenderPassId;
        for (const light of this.lightSources){
            const generators = light.getShadowGenerators();
            if (!generators) continue;
            const iterator = generators.values();
            for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                const generator = key.value;
                if (generator && (!generator.getShadowMap()?.renderList || generator.getShadowMap()?.renderList && generator.getShadowMap()?.renderList?.indexOf(this) !== -1)) {
                    const shadowMap = generator.getShadowMap();
                    const renderPassIds = shadowMap.renderPassIds ?? [
                        engine.currentRenderPassId
                    ];
                    for(let p = 0; p < renderPassIds.length; ++p){
                        engine.currentRenderPassId = renderPassIds[p];
                        for (const subMesh of this.subMeshes)if (!generator.isReady(subMesh, hardwareInstancedRendering, subMesh.getMaterial()?.needAlphaBlendingForMesh(this) ?? false)) {
                            engine.currentRenderPassId = currentRenderPassId;
                            return false;
                        }
                    }
                    engine.currentRenderPassId = currentRenderPassId;
                }
            }
        }
        // LOD
        for (const lod of this._internalMeshDataInfo._LODLevels){
            if (lod.mesh && !lod.mesh.isReady(hardwareInstancedRendering)) return false;
        }
        return true;
    }
    /**
     * Gets a boolean indicating if the normals aren't to be recomputed on next mesh `positions` array update. This property is pertinent only for updatable parametric shapes.
     */ get areNormalsFrozen() {
        return this._internalMeshDataInfo._areNormalsFrozen;
    }
    /**
     * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It prevents the mesh normals from being recomputed on next `positions` array update.
     * @returns the current mesh
     */ freezeNormals() {
        this._internalMeshDataInfo._areNormalsFrozen = true;
        return this;
    }
    /**
     * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It reactivates the mesh normals computation if it was previously frozen
     * @returns the current mesh
     */ unfreezeNormals() {
        this._internalMeshDataInfo._areNormalsFrozen = false;
        return this;
    }
    /**
     * Sets a value overriding the instance count. Only applicable when custom instanced InterleavedVertexBuffer are used rather than InstancedMeshs
     */ set overridenInstanceCount(count) {
        this._instanceDataStorage.overridenInstanceCount = count;
    }
    // Methods
    /** @internal */ _preActivate() {
        const internalDataInfo = this._internalMeshDataInfo;
        const sceneRenderId = this.getScene().getRenderId();
        if (internalDataInfo._preActivateId === sceneRenderId) return this;
        internalDataInfo._preActivateId = sceneRenderId;
        this._instanceDataStorage.visibleInstances = null;
        return this;
    }
    /**
     * @internal
     */ _preActivateForIntermediateRendering(renderId) {
        if (this._instanceDataStorage.visibleInstances) this._instanceDataStorage.visibleInstances.intermediateDefaultRenderId = renderId;
        return this;
    }
    /**
     * @internal
     */ _registerInstanceForRenderId(instance, renderId) {
        if (!this._instanceDataStorage.visibleInstances) this._instanceDataStorage.visibleInstances = {
            defaultRenderId: renderId,
            selfDefaultRenderId: this._renderId
        };
        if (!this._instanceDataStorage.visibleInstances[renderId]) {
            if (this._instanceDataStorage.previousRenderId !== undefined && this._instanceDataStorage.isFrozen) this._instanceDataStorage.visibleInstances[this._instanceDataStorage.previousRenderId] = null;
            this._instanceDataStorage.previousRenderId = renderId;
            this._instanceDataStorage.visibleInstances[renderId] = new Array();
        }
        this._instanceDataStorage.visibleInstances[renderId].push(instance);
        return this;
    }
    _afterComputeWorldMatrix() {
        super._afterComputeWorldMatrix();
        if (!this.hasThinInstances) return;
        if (!this.doNotSyncBoundingInfo) this.thinInstanceRefreshBoundingInfo(false);
    }
    /** @internal */ _postActivate() {
        if (this.edgesShareWithInstances && this.edgesRenderer && this.edgesRenderer.isEnabled && this._renderingGroup) {
            this._renderingGroup._edgesRenderers.pushNoDuplicate(this.edgesRenderer);
            this.edgesRenderer.customInstances.push(this.getWorldMatrix());
        }
    }
    /**
     * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
     * This means the mesh underlying bounding box and sphere are recomputed.
     * @param applySkeletonOrOptions defines whether to apply the skeleton before computing the bounding info or a set of options
     * @param applyMorph defines whether to apply the morph target before computing the bounding info
     * @returns the current mesh
     */ refreshBoundingInfo(applySkeletonOrOptions = false, applyMorph = false) {
        if (this.hasBoundingInfo && this.getBoundingInfo().isLocked) return this;
        let options;
        if (typeof applySkeletonOrOptions === "object") options = applySkeletonOrOptions;
        else options = {
            applySkeleton: applySkeletonOrOptions,
            applyMorph: applyMorph
        };
        const bias = this.geometry ? this.geometry.boundingBias : null;
        this._refreshBoundingInfo(this._getData(options, null, (0, $b4i1f.VertexBuffer).PositionKind), bias);
        return this;
    }
    /**
     * @internal
     */ _createGlobalSubMesh(force) {
        const totalVertices = this.getTotalVertices();
        if (!totalVertices || !this.getIndices()) return null;
        // Check if we need to recreate the submeshes
        if (this.subMeshes && this.subMeshes.length > 0) {
            const ib = this.getIndices();
            if (!ib) return null;
            const totalIndices = ib.length;
            let needToRecreate = false;
            if (force) needToRecreate = true;
            else for (const submesh of this.subMeshes){
                if (submesh.indexStart + submesh.indexCount > totalIndices) {
                    needToRecreate = true;
                    break;
                }
                if (submesh.verticesStart + submesh.verticesCount > totalVertices) {
                    needToRecreate = true;
                    break;
                }
            }
            if (!needToRecreate) return this.subMeshes[0];
        }
        this.releaseSubMeshes();
        return new (0, $fc3ab70ba5c9f506$export$c684db7d654df572)(0, 0, totalVertices, 0, this.getTotalIndices() || totalVertices, this); // getTotalIndices() can be zero if the mesh is unindexed
    }
    /**
     * This function will subdivide the mesh into multiple submeshes
     * @param count defines the expected number of submeshes
     */ subdivide(count) {
        if (count < 1) return;
        const totalIndices = this.getTotalIndices();
        let subdivisionSize = totalIndices / count | 0;
        let offset = 0;
        // Ensure that subdivisionSize is a multiple of 3
        while(subdivisionSize % 3 !== 0)subdivisionSize++;
        this.releaseSubMeshes();
        for(let index = 0; index < count; index++){
            if (offset >= totalIndices) break;
            (0, $fc3ab70ba5c9f506$export$c684db7d654df572).CreateFromIndices(0, offset, index === count - 1 ? totalIndices - offset : subdivisionSize, this, undefined, false);
            offset += subdivisionSize;
        }
        this.refreshBoundingInfo();
        this.synchronizeInstances();
    }
    /**
     * Copy a FloatArray into a specific associated vertex buffer
     * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updatable defines if the updated vertex buffer must be flagged as updatable
     * @param stride defines the data stride size (can be null)
     * @returns the current mesh
     */ setVerticesData(kind, data, updatable = false, stride) {
        if (!this._geometry) {
            const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
            vertexData.set(data, kind);
            const scene = this.getScene();
            new (0, $07dfcf3146d3f600$export$2db6c17465f94a2)((0, $07dfcf3146d3f600$export$2db6c17465f94a2).RandomId(), scene, vertexData, updatable, this);
        } else this._geometry.setVerticesData(kind, data, updatable, stride);
        return this;
    }
    /**
     * Delete a vertex buffer associated with this mesh
     * @param kind defines which buffer to delete (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     */ removeVerticesData(kind) {
        if (!this._geometry) return;
        this._geometry.removeVerticesData(kind);
    }
    /**
     * Flags an associated vertex buffer as updatable
     * @param kind defines which buffer to use (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param updatable defines if the updated vertex buffer must be flagged as updatable
     */ markVerticesDataAsUpdatable(kind, updatable = true) {
        const vb = this.getVertexBuffer(kind);
        if (!vb || vb.isUpdatable() === updatable) return;
        this.setVerticesData(kind, this.getVerticesData(kind), updatable);
    }
    /**
     * Sets the mesh global Vertex Buffer
     * @param buffer defines the buffer to use
     * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
     * @returns the current mesh
     */ setVerticesBuffer(buffer, disposeExistingBuffer = true) {
        if (!this._geometry) this._geometry = (0, $07dfcf3146d3f600$export$2db6c17465f94a2).CreateGeometryForMesh(this);
        this._geometry.setVerticesBuffer(buffer, null, disposeExistingBuffer);
        return this;
    }
    /**
     * Update a specific associated vertex buffer
     * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updateExtends defines if extends info of the mesh must be updated (can be null). This is mostly useful for "position" kind
     * @param makeItUnique defines if the geometry associated with the mesh must be cloned to make the change only for this mesh (and not all meshes associated with the same geometry)
     * @returns the current mesh
     */ updateVerticesData(kind, data, updateExtends, makeItUnique) {
        if (!this._geometry) return this;
        if (!makeItUnique) this._geometry.updateVerticesData(kind, data, updateExtends);
        else {
            this.makeGeometryUnique();
            this.updateVerticesData(kind, data, updateExtends, false);
        }
        return this;
    }
    /**
     * This method updates the vertex positions of an updatable mesh according to the `positionFunction` returned values.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#other-shapes-updatemeshpositions
     * @param positionFunction is a simple JS function what is passed the mesh `positions` array. It doesn't need to return anything
     * @param computeNormals is a boolean (default true) to enable/disable the mesh normal recomputation after the vertex position update
     * @returns the current mesh
     */ updateMeshPositions(positionFunction, computeNormals = true) {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positions) return this;
        positionFunction(positions);
        this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, false, false);
        if (computeNormals) {
            const indices = this.getIndices();
            const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            if (!normals) return this;
            (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
            this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, false, false);
        }
        return this;
    }
    /**
     * Creates a un-shared specific occurence of the geometry for the mesh.
     * @returns the current mesh
     */ makeGeometryUnique() {
        if (!this._geometry) return this;
        if (this._geometry.meshes.length === 1) return this;
        const oldGeometry = this._geometry;
        const geometry = this._geometry.copy((0, $07dfcf3146d3f600$export$2db6c17465f94a2).RandomId());
        oldGeometry.releaseForMesh(this, true);
        geometry.applyToMesh(this);
        return this;
    }
    /**
     * Sets the index buffer of this mesh.
     * @param indexBuffer Defines the index buffer to use for this mesh
     * @param totalVertices Defines the total number of vertices used by the buffer
     * @param totalIndices Defines the total number of indices in the index buffer
     */ setIndexBuffer(indexBuffer, totalVertices, totalIndices) {
        let geometry = this._geometry;
        if (!geometry) geometry = new (0, $07dfcf3146d3f600$export$2db6c17465f94a2)((0, $07dfcf3146d3f600$export$2db6c17465f94a2).RandomId(), this.getScene(), undefined, undefined, this);
        geometry.setIndexBuffer(indexBuffer, totalVertices, totalIndices);
    }
    /**
     * Set the index buffer of this mesh
     * @param indices defines the source data
     * @param totalVertices defines the total number of vertices referenced by this index data (can be null)
     * @param updatable defines if the updated index buffer must be flagged as updatable (default is false)
     * @param dontForceSubMeshRecreation defines a boolean indicating that we don't want to force the recreation of sub-meshes if we don't have to (false by default)
     * @returns the current mesh
     */ setIndices(indices, totalVertices = null, updatable = false, dontForceSubMeshRecreation = false) {
        if (!this._geometry) {
            const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
            vertexData.indices = indices;
            const scene = this.getScene();
            new (0, $07dfcf3146d3f600$export$2db6c17465f94a2)((0, $07dfcf3146d3f600$export$2db6c17465f94a2).RandomId(), scene, vertexData, updatable, this);
        } else this._geometry.setIndices(indices, totalVertices, updatable, dontForceSubMeshRecreation);
        return this;
    }
    /**
     * Update the current index buffer
     * @param indices defines the source data
     * @param offset defines the offset in the index buffer where to store the new data (can be null)
     * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
     * @returns the current mesh
     */ updateIndices(indices, offset, gpuMemoryOnly = false) {
        if (!this._geometry) return this;
        this._geometry.updateIndices(indices, offset, gpuMemoryOnly);
        return this;
    }
    /**
     * Invert the geometry to move from a right handed system to a left handed one.
     * @returns the current mesh
     */ toLeftHanded() {
        if (!this._geometry) return this;
        this._geometry.toLeftHanded();
        return this;
    }
    /**
     * @internal
     */ _bind(subMesh, effect, fillMode, allowInstancedRendering = true) {
        if (!this._geometry) return this;
        const engine = this.getScene().getEngine();
        // Wireframe
        let indexToBind;
        if (this._unIndexed) switch(this._getRenderingFillMode(fillMode)){
            case (0, $3afee756ef198914$export$a2d8b23205c25948).WireFrameFillMode:
                indexToBind = subMesh._getLinesIndexBuffer(this.getIndices(), engine);
                break;
            default:
                indexToBind = null;
                break;
        }
        else switch(this._getRenderingFillMode(fillMode)){
            case (0, $3afee756ef198914$export$a2d8b23205c25948).PointFillMode:
                indexToBind = null;
                break;
            case (0, $3afee756ef198914$export$a2d8b23205c25948).WireFrameFillMode:
                indexToBind = subMesh._getLinesIndexBuffer(this.getIndices(), engine);
                break;
            default:
            case (0, $3afee756ef198914$export$a2d8b23205c25948).TriangleFillMode:
                indexToBind = this._geometry.getIndexBuffer();
                break;
        }
        return this._bindDirect(effect, indexToBind, allowInstancedRendering);
    }
    /**
     * @internal
     */ _bindDirect(effect, indexToBind, allowInstancedRendering = true) {
        if (!this._geometry) return this;
        // Morph targets
        if (this.morphTargetManager && this.morphTargetManager.isUsingTextureForTargets) this.morphTargetManager._bind(effect);
        // VBOs
        if (!allowInstancedRendering || !this._userInstancedBuffersStorage || this.hasThinInstances) this._geometry._bind(effect, indexToBind);
        else this._geometry._bind(effect, indexToBind, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects);
        return this;
    }
    /**
     * @internal
     */ _draw(subMesh, fillMode, instancesCount) {
        if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer()) return this;
        if (this._internalMeshDataInfo._onBeforeDrawObservable) this._internalMeshDataInfo._onBeforeDrawObservable.notifyObservers(this);
        const scene = this.getScene();
        const engine = scene.getEngine();
        if (this._unIndexed && fillMode !== (0, $3afee756ef198914$export$a2d8b23205c25948).WireFrameFillMode || fillMode == (0, $3afee756ef198914$export$a2d8b23205c25948).PointFillMode) // or triangles as points
        engine.drawArraysType(fillMode, subMesh.verticesStart, subMesh.verticesCount, this.forcedInstanceCount || instancesCount);
        else if (fillMode == (0, $3afee756ef198914$export$a2d8b23205c25948).WireFrameFillMode) // Triangles as wireframe
        engine.drawElementsType(fillMode, 0, subMesh._linesIndexCount, this.forcedInstanceCount || instancesCount);
        else engine.drawElementsType(fillMode, subMesh.indexStart, subMesh.indexCount, this.forcedInstanceCount || instancesCount);
        return this;
    }
    /**
     * Registers for this mesh a javascript function called just before the rendering process
     * @param func defines the function to call before rendering this mesh
     * @returns the current mesh
     */ registerBeforeRender(func) {
        this.onBeforeRenderObservable.add(func);
        return this;
    }
    /**
     * Disposes a previously registered javascript function called before the rendering
     * @param func defines the function to remove
     * @returns the current mesh
     */ unregisterBeforeRender(func) {
        this.onBeforeRenderObservable.removeCallback(func);
        return this;
    }
    /**
     * Registers for this mesh a javascript function called just after the rendering is complete
     * @param func defines the function to call after rendering this mesh
     * @returns the current mesh
     */ registerAfterRender(func) {
        this.onAfterRenderObservable.add(func);
        return this;
    }
    /**
     * Disposes a previously registered javascript function called after the rendering.
     * @param func defines the function to remove
     * @returns the current mesh
     */ unregisterAfterRender(func) {
        this.onAfterRenderObservable.removeCallback(func);
        return this;
    }
    /**
     * @internal
     */ _getInstancesRenderList(subMeshId, isReplacementMode = false) {
        if (this._instanceDataStorage.isFrozen) {
            if (isReplacementMode) {
                this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.hardwareInstancedRendering[subMeshId] = false;
                this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.renderSelf[subMeshId] = true;
                return this._instanceDataStorage.batchCacheReplacementModeInFrozenMode;
            }
            if (this._instanceDataStorage.previousBatch) return this._instanceDataStorage.previousBatch;
        }
        const scene = this.getScene();
        const isInIntermediateRendering = scene._isInIntermediateRendering();
        const onlyForInstances = isInIntermediateRendering ? this._internalAbstractMeshDataInfo._onlyForInstancesIntermediate : this._internalAbstractMeshDataInfo._onlyForInstances;
        const batchCache = this._instanceDataStorage.batchCache;
        batchCache.mustReturn = false;
        batchCache.renderSelf[subMeshId] = isReplacementMode || !onlyForInstances && this.isEnabled() && this.isVisible;
        batchCache.visibleInstances[subMeshId] = null;
        if (this._instanceDataStorage.visibleInstances && !isReplacementMode) {
            const visibleInstances = this._instanceDataStorage.visibleInstances;
            const currentRenderId = scene.getRenderId();
            const defaultRenderId = isInIntermediateRendering ? visibleInstances.intermediateDefaultRenderId : visibleInstances.defaultRenderId;
            batchCache.visibleInstances[subMeshId] = visibleInstances[currentRenderId];
            if (!batchCache.visibleInstances[subMeshId] && defaultRenderId) batchCache.visibleInstances[subMeshId] = visibleInstances[defaultRenderId];
        }
        batchCache.hardwareInstancedRendering[subMeshId] = !isReplacementMode && this._instanceDataStorage.hardwareInstancedRendering && batchCache.visibleInstances[subMeshId] !== null && batchCache.visibleInstances[subMeshId] !== undefined;
        this._instanceDataStorage.previousBatch = batchCache;
        return batchCache;
    }
    /**
     * @internal
     */ _renderWithInstances(subMesh, fillMode, batch, effect, engine) {
        const visibleInstances = batch.visibleInstances[subMesh._id];
        const visibleInstanceCount = visibleInstances ? visibleInstances.length : 0;
        const instanceStorage = this._instanceDataStorage;
        const currentInstancesBufferSize = instanceStorage.instancesBufferSize;
        let instancesBuffer = instanceStorage.instancesBuffer;
        let instancesPreviousBuffer = instanceStorage.instancesPreviousBuffer;
        const matricesCount = visibleInstanceCount + 1;
        const bufferSize = matricesCount * 64;
        while(instanceStorage.instancesBufferSize < bufferSize)instanceStorage.instancesBufferSize *= 2;
        if (!instanceStorage.instancesData || currentInstancesBufferSize != instanceStorage.instancesBufferSize) instanceStorage.instancesData = new Float32Array(instanceStorage.instancesBufferSize / 4);
        if (this._scene.needsPreviousWorldMatrices && !instanceStorage.instancesPreviousData || currentInstancesBufferSize != instanceStorage.instancesBufferSize) instanceStorage.instancesPreviousData = new Float32Array(instanceStorage.instancesBufferSize / 4);
        let offset = 0;
        let instancesCount = 0;
        const renderSelf = batch.renderSelf[subMesh._id];
        const needUpdateBuffer = !instancesBuffer || currentInstancesBufferSize !== instanceStorage.instancesBufferSize || this._scene.needsPreviousWorldMatrices && !instanceStorage.instancesPreviousBuffer;
        if (!this._instanceDataStorage.manualUpdate && (!instanceStorage.isFrozen || needUpdateBuffer)) {
            const world = this.getWorldMatrix();
            if (renderSelf) {
                if (this._scene.needsPreviousWorldMatrices) {
                    if (!instanceStorage.masterMeshPreviousWorldMatrix) {
                        instanceStorage.masterMeshPreviousWorldMatrix = world.clone();
                        instanceStorage.masterMeshPreviousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                    } else {
                        instanceStorage.masterMeshPreviousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                        instanceStorage.masterMeshPreviousWorldMatrix.copyFrom(world);
                    }
                }
                world.copyToArray(instanceStorage.instancesData, offset);
                offset += 16;
                instancesCount++;
            }
            if (visibleInstances) {
                if ($b0df7c384622c537$export$e176487c05830cc5.INSTANCEDMESH_SORT_TRANSPARENT && this._scene.activeCamera && subMesh.getMaterial()?.needAlphaBlendingForMesh(subMesh.getRenderingMesh())) {
                    const cameraPosition = this._scene.activeCamera.globalPosition;
                    for(let instanceIndex = 0; instanceIndex < visibleInstances.length; instanceIndex++){
                        const instanceMesh = visibleInstances[instanceIndex];
                        instanceMesh._distanceToCamera = (0, $ha1VO.Vector3).Distance(instanceMesh.getBoundingInfo().boundingSphere.centerWorld, cameraPosition);
                    }
                    visibleInstances.sort((m1, m2)=>{
                        return m1._distanceToCamera > m2._distanceToCamera ? -1 : m1._distanceToCamera < m2._distanceToCamera ? 1 : 0;
                    });
                }
                for(let instanceIndex = 0; instanceIndex < visibleInstances.length; instanceIndex++){
                    const instance = visibleInstances[instanceIndex];
                    const matrix = instance.getWorldMatrix();
                    matrix.copyToArray(instanceStorage.instancesData, offset);
                    if (this._scene.needsPreviousWorldMatrices) {
                        if (!instance._previousWorldMatrix) {
                            instance._previousWorldMatrix = matrix.clone();
                            instance._previousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                        } else {
                            instance._previousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                            instance._previousWorldMatrix.copyFrom(matrix);
                        }
                    }
                    offset += 16;
                    instancesCount++;
                }
            }
        } else instancesCount = (renderSelf ? 1 : 0) + visibleInstanceCount;
        if (needUpdateBuffer) {
            if (instancesBuffer) instancesBuffer.dispose();
            if (instancesPreviousBuffer) instancesPreviousBuffer.dispose();
            instancesBuffer = new (0, $b4i1f.Buffer)(engine, instanceStorage.instancesData, true, 16, false, true);
            instanceStorage.instancesBuffer = instancesBuffer;
            if (!this._userInstancedBuffersStorage) this._userInstancedBuffersStorage = {
                data: {},
                vertexBuffers: {},
                strides: {},
                sizes: {},
                vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : undefined
            };
            this._userInstancedBuffersStorage.vertexBuffers["world0"] = instancesBuffer.createVertexBuffer("world0", 0, 4);
            this._userInstancedBuffersStorage.vertexBuffers["world1"] = instancesBuffer.createVertexBuffer("world1", 4, 4);
            this._userInstancedBuffersStorage.vertexBuffers["world2"] = instancesBuffer.createVertexBuffer("world2", 8, 4);
            this._userInstancedBuffersStorage.vertexBuffers["world3"] = instancesBuffer.createVertexBuffer("world3", 12, 4);
            if (this._scene.needsPreviousWorldMatrices) {
                instancesPreviousBuffer = new (0, $b4i1f.Buffer)(engine, instanceStorage.instancesPreviousData, true, 16, false, true);
                instanceStorage.instancesPreviousBuffer = instancesPreviousBuffer;
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld0"] = instancesPreviousBuffer.createVertexBuffer("previousWorld0", 0, 4);
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld1"] = instancesPreviousBuffer.createVertexBuffer("previousWorld1", 4, 4);
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld2"] = instancesPreviousBuffer.createVertexBuffer("previousWorld2", 8, 4);
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld3"] = instancesPreviousBuffer.createVertexBuffer("previousWorld3", 12, 4);
            }
            this._invalidateInstanceVertexArrayObject();
        } else if (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) {
            instancesBuffer.updateDirectly(instanceStorage.instancesData, 0, instancesCount);
            if (this._scene.needsPreviousWorldMatrices && (!this._instanceDataStorage.manualUpdate || this._instanceDataStorage.previousManualUpdate)) instancesPreviousBuffer.updateDirectly(instanceStorage.instancesPreviousData, 0, instancesCount);
        }
        this._processInstancedBuffers(visibleInstances, renderSelf);
        // Stats
        this.getScene()._activeIndices.addCount(subMesh.indexCount * instancesCount, false);
        // Draw
        if (engine._currentDrawContext) engine._currentDrawContext.useInstancing = true;
        this._bind(subMesh, effect, fillMode);
        this._draw(subMesh, fillMode, instancesCount);
        // Write current matrices as previous matrices in case of manual update
        // Default behaviour when previous matrices are not specified explicitly
        // Will break if instances number/order changes
        if (this._scene.needsPreviousWorldMatrices && !needUpdateBuffer && this._instanceDataStorage.manualUpdate && (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) && !this._instanceDataStorage.previousManualUpdate) instancesPreviousBuffer.updateDirectly(instanceStorage.instancesData, 0, instancesCount);
        engine.unbindInstanceAttributes();
        return this;
    }
    /**
     * @internal
     */ _renderWithThinInstances(subMesh, fillMode, effect, engine) {
        // Stats
        const instancesCount = this._thinInstanceDataStorage?.instancesCount ?? 0;
        this.getScene()._activeIndices.addCount(subMesh.indexCount * instancesCount, false);
        // Draw
        if (engine._currentDrawContext) engine._currentDrawContext.useInstancing = true;
        this._bind(subMesh, effect, fillMode);
        this._draw(subMesh, fillMode, instancesCount);
        // Write current matrices as previous matrices
        // Default behaviour when previous matrices are not specified explicitly
        // Will break if instances number/order changes
        if (this._scene.needsPreviousWorldMatrices && !this._thinInstanceDataStorage.previousMatrixData && this._thinInstanceDataStorage.matrixData) {
            if (!this._thinInstanceDataStorage.previousMatrixBuffer) this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", this._thinInstanceDataStorage.matrixData, false);
            else this._thinInstanceDataStorage.previousMatrixBuffer.updateDirectly(this._thinInstanceDataStorage.matrixData, 0, instancesCount);
        }
        engine.unbindInstanceAttributes();
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _processInstancedBuffers(visibleInstances, renderSelf) {
    // Do nothing
    }
    /**
     * @internal
     */ _processRendering(renderingMesh, subMesh, effect, fillMode, batch, hardwareInstancedRendering, onBeforeDraw, effectiveMaterial) {
        const scene = this.getScene();
        const engine = scene.getEngine();
        fillMode = this._getRenderingFillMode(fillMode);
        if (hardwareInstancedRendering && subMesh.getRenderingMesh().hasThinInstances) {
            this._renderWithThinInstances(subMesh, fillMode, effect, engine);
            return this;
        }
        if (hardwareInstancedRendering) this._renderWithInstances(subMesh, fillMode, batch, effect, engine);
        else {
            if (engine._currentDrawContext) engine._currentDrawContext.useInstancing = false;
            let instanceCount = 0;
            if (batch.renderSelf[subMesh._id]) {
                // Draw
                if (onBeforeDraw) onBeforeDraw(false, renderingMesh.getWorldMatrix(), effectiveMaterial);
                instanceCount++;
                this._draw(subMesh, fillMode, this._instanceDataStorage.overridenInstanceCount);
            }
            const visibleInstancesForSubMesh = batch.visibleInstances[subMesh._id];
            if (visibleInstancesForSubMesh) {
                const visibleInstanceCount = visibleInstancesForSubMesh.length;
                instanceCount += visibleInstanceCount;
                // Stats
                for(let instanceIndex = 0; instanceIndex < visibleInstanceCount; instanceIndex++){
                    const instance = visibleInstancesForSubMesh[instanceIndex];
                    // World
                    const world = instance.getWorldMatrix();
                    if (onBeforeDraw) onBeforeDraw(true, world, effectiveMaterial);
                    // Draw
                    this._draw(subMesh, fillMode);
                }
            }
            // Stats
            scene._activeIndices.addCount(subMesh.indexCount * instanceCount, false);
        }
        return this;
    }
    /**
     * @internal
     */ _rebuild(dispose = false) {
        if (this._instanceDataStorage.instancesBuffer) {
            // Dispose instance buffer to be recreated in _renderWithInstances when rendered
            if (dispose) this._instanceDataStorage.instancesBuffer.dispose();
            this._instanceDataStorage.instancesBuffer = null;
        }
        if (this._userInstancedBuffersStorage) {
            for(const kind in this._userInstancedBuffersStorage.vertexBuffers){
                const buffer = this._userInstancedBuffersStorage.vertexBuffers[kind];
                if (buffer) {
                    // Dispose instance buffer to be recreated in _renderWithInstances when rendered
                    if (dispose) buffer.dispose();
                    this._userInstancedBuffersStorage.vertexBuffers[kind] = null;
                }
            }
            if (this._userInstancedBuffersStorage.vertexArrayObjects) this._userInstancedBuffersStorage.vertexArrayObjects = {};
        }
        this._internalMeshDataInfo._effectiveMaterial = null;
        super._rebuild(dispose);
    }
    /** @internal */ _freeze() {
        if (!this.subMeshes) return;
        // Prepare batches
        for(let index = 0; index < this.subMeshes.length; index++)this._getInstancesRenderList(index);
        this._internalMeshDataInfo._effectiveMaterial = null;
        this._instanceDataStorage.isFrozen = true;
    }
    /** @internal */ _unFreeze() {
        this._instanceDataStorage.isFrozen = false;
        this._instanceDataStorage.previousBatch = null;
    }
    /**
     * Triggers the draw call for the mesh (or a submesh), for a specific render pass id
     * @param renderPassId defines the render pass id to use to draw the mesh / submesh. If not provided, use the current renderPassId of the engine.
     * @param enableAlphaMode defines if alpha mode can be changed (default: false)
     * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering (default: undefined)
     * @param subMesh defines the subMesh to render. If not provided, draw all mesh submeshes (default: undefined)
     * @param checkFrustumCulling defines if frustum culling must be checked (default: true). If you know the mesh is in the frustum (or if you don't care!), you can pass false to optimize.
     * @returns the current mesh
     */ renderWithRenderPassId(renderPassId, enableAlphaMode, effectiveMeshReplacement, subMesh, checkFrustumCulling = true) {
        const engine = this._scene.getEngine();
        const currentRenderPassId = engine.currentRenderPassId;
        if (renderPassId !== undefined) engine.currentRenderPassId = renderPassId;
        if (subMesh) {
            if (!checkFrustumCulling || checkFrustumCulling && subMesh.isInFrustum(this._scene._frustumPlanes)) this.render(subMesh, !!enableAlphaMode, effectiveMeshReplacement);
        } else for(let s = 0; s < this.subMeshes.length; s++){
            const subMesh = this.subMeshes[s];
            if (!checkFrustumCulling || checkFrustumCulling && subMesh.isInFrustum(this._scene._frustumPlanes)) this.render(subMesh, !!enableAlphaMode, effectiveMeshReplacement);
        }
        if (renderPassId !== undefined) engine.currentRenderPassId = currentRenderPassId;
        return this;
    }
    /**
     * Render a complete mesh by going through all submeshes
     * @returns the current mesh
     * #5SPY1V#2: simple test
     * #5SPY1V#5: perf test
     */ directRender() {
        if (!this.subMeshes) return this;
        for (const submesh of this.subMeshes)this.render(submesh, false);
        return this;
    }
    /**
     * Triggers the draw call for the mesh. Usually, you don't need to call this method by your own because the mesh rendering is handled by the scene rendering manager
     * @param subMesh defines the subMesh to render
     * @param enableAlphaMode defines if alpha mode can be changed
     * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering
     * @returns the current mesh
     */ render(subMesh, enableAlphaMode, effectiveMeshReplacement) {
        const scene = this.getScene();
        if (this._internalAbstractMeshDataInfo._isActiveIntermediate) this._internalAbstractMeshDataInfo._isActiveIntermediate = false;
        else this._internalAbstractMeshDataInfo._isActive = false;
        const numActiveCameras = scene.activeCameras?.length ?? 0;
        const canCheckOcclusionQuery = numActiveCameras > 1 && scene.activeCamera === scene.activeCameras[0] || numActiveCameras <= 1;
        if (canCheckOcclusionQuery && this._checkOcclusionQuery() && !this._occlusionDataStorage.forceRenderingWhenOccluded) return this;
        // Managing instances
        const batch = this._getInstancesRenderList(subMesh._id, !!effectiveMeshReplacement);
        if (batch.mustReturn) return this;
        // Checking geometry state
        if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer()) return this;
        const engine = scene.getEngine();
        let oldCameraMaxZ = 0;
        let oldCamera = null;
        if (this.ignoreCameraMaxZ && scene.activeCamera && !scene._isInIntermediateRendering()) {
            oldCameraMaxZ = scene.activeCamera.maxZ;
            oldCamera = scene.activeCamera;
            scene.activeCamera.maxZ = 0;
            scene.updateTransformMatrix(true);
        }
        if (this._internalMeshDataInfo._onBeforeRenderObservable) this._internalMeshDataInfo._onBeforeRenderObservable.notifyObservers(this);
        const renderingMesh = subMesh.getRenderingMesh();
        const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances || !!this._userInstancedBuffersStorage && !subMesh.getMesh()._internalAbstractMeshDataInfo._actAsRegularMesh;
        const instanceDataStorage = this._instanceDataStorage;
        const material = subMesh.getMaterial();
        if (!material) {
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            return this;
        }
        // Material
        if (!instanceDataStorage.isFrozen || !this._internalMeshDataInfo._effectiveMaterial || this._internalMeshDataInfo._effectiveMaterial !== material) {
            if (material._storeEffectOnSubMeshes) {
                if (!material.isReadyForSubMesh(this, subMesh, hardwareInstancedRendering)) {
                    if (oldCamera) {
                        oldCamera.maxZ = oldCameraMaxZ;
                        scene.updateTransformMatrix(true);
                    }
                    return this;
                }
            } else if (!material.isReady(this, hardwareInstancedRendering)) {
                if (oldCamera) {
                    oldCamera.maxZ = oldCameraMaxZ;
                    scene.updateTransformMatrix(true);
                }
                return this;
            }
            this._internalMeshDataInfo._effectiveMaterial = material;
        } else if (material._storeEffectOnSubMeshes && !subMesh._drawWrapper?._wasPreviouslyReady || !material._storeEffectOnSubMeshes && !material._getDrawWrapper()._wasPreviouslyReady) {
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            return this;
        }
        // Alpha mode
        if (enableAlphaMode) engine.setAlphaMode(this._internalMeshDataInfo._effectiveMaterial.alphaMode);
        let drawWrapper;
        if (this._internalMeshDataInfo._effectiveMaterial._storeEffectOnSubMeshes) drawWrapper = subMesh._drawWrapper;
        else drawWrapper = this._internalMeshDataInfo._effectiveMaterial._getDrawWrapper();
        const effect = drawWrapper?.effect ?? null;
        for (const step of scene._beforeRenderingMeshStage)step.action(this, subMesh, batch, effect);
        if (!drawWrapper || !effect) {
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            return this;
        }
        const effectiveMesh = effectiveMeshReplacement || this;
        let sideOrientation;
        if (!instanceDataStorage.isFrozen && (this._internalMeshDataInfo._effectiveMaterial.backFaceCulling || this._internalMeshDataInfo._effectiveMaterial.sideOrientation !== null || this._internalMeshDataInfo._effectiveMaterial.twoSidedLighting)) {
            // Note: if two sided lighting is enabled, we need to ensure that the normal will point in the right direction even if the determinant of the world matrix is negative
            const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
            sideOrientation = this._internalMeshDataInfo._effectiveMaterial._getEffectiveOrientation(this);
            if (mainDeterminant < 0) sideOrientation = sideOrientation === (0, $3afee756ef198914$export$a2d8b23205c25948).ClockWiseSideOrientation ? (0, $3afee756ef198914$export$a2d8b23205c25948).CounterClockWiseSideOrientation : (0, $3afee756ef198914$export$a2d8b23205c25948).ClockWiseSideOrientation;
            instanceDataStorage.sideOrientation = sideOrientation;
        } else sideOrientation = instanceDataStorage.sideOrientation;
        const reverse = this._internalMeshDataInfo._effectiveMaterial._preBind(drawWrapper, sideOrientation);
        if (this._internalMeshDataInfo._effectiveMaterial.forceDepthWrite) engine.setDepthWrite(true);
        // Bind
        const effectiveMaterial = this._internalMeshDataInfo._effectiveMaterial;
        const fillMode = effectiveMaterial.fillMode;
        if (this._internalMeshDataInfo._onBeforeBindObservable) this._internalMeshDataInfo._onBeforeBindObservable.notifyObservers(this);
        if (!hardwareInstancedRendering) // Binding will be done later because we need to add more info to the VB
        this._bind(subMesh, effect, fillMode, false);
        const world = effectiveMesh.getWorldMatrix();
        if (effectiveMaterial._storeEffectOnSubMeshes) effectiveMaterial.bindForSubMesh(world, this, subMesh);
        else effectiveMaterial.bind(world, this);
        if (!effectiveMaterial.backFaceCulling && effectiveMaterial.separateCullingPass) {
            engine.setState(true, effectiveMaterial.zOffset, false, !reverse, effectiveMaterial.cullBackFaces, effectiveMaterial.stencil, effectiveMaterial.zOffsetUnits);
            this._processRendering(this, subMesh, effect, fillMode, batch, hardwareInstancedRendering, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial);
            engine.setState(true, effectiveMaterial.zOffset, false, reverse, effectiveMaterial.cullBackFaces, effectiveMaterial.stencil, effectiveMaterial.zOffsetUnits);
            if (this._internalMeshDataInfo._onBetweenPassObservable) this._internalMeshDataInfo._onBetweenPassObservable.notifyObservers(subMesh);
        }
        // Draw
        this._processRendering(this, subMesh, effect, fillMode, batch, hardwareInstancedRendering, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial);
        // Unbind
        this._internalMeshDataInfo._effectiveMaterial.unbind();
        for (const step of scene._afterRenderingMeshStage)step.action(this, subMesh, batch, effect);
        if (this._internalMeshDataInfo._onAfterRenderObservable) this._internalMeshDataInfo._onAfterRenderObservable.notifyObservers(this);
        if (oldCamera) {
            oldCamera.maxZ = oldCameraMaxZ;
            scene.updateTransformMatrix(true);
        }
        if (scene.performancePriority === 2 /* ScenePerformancePriority.Aggressive */  && !instanceDataStorage.isFrozen) this._freeze();
        return this;
    }
    /**
     *   Renormalize the mesh and patch it up if there are no weights
     *   Similar to normalization by adding the weights compute the reciprocal and multiply all elements, this wil ensure that everything adds to 1.
     *   However in the case of zero weights then we set just a single influence to 1.
     *   We check in the function for extra's present and if so we use the normalizeSkinWeightsWithExtras rather than the FourWeights version.
     */ cleanMatrixWeights() {
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) {
            if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind)) this._normalizeSkinWeightsAndExtra();
            else this._normalizeSkinFourWeights();
        }
    }
    // faster 4 weight version.
    _normalizeSkinFourWeights() {
        const matricesWeights = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        const numWeights = matricesWeights.length;
        for(let a = 0; a < numWeights; a += 4){
            // accumulate weights
            const t = matricesWeights[a] + matricesWeights[a + 1] + matricesWeights[a + 2] + matricesWeights[a + 3];
            // check for invalid weight and just set it to 1.
            if (t === 0) matricesWeights[a] = 1;
            else {
                // renormalize so everything adds to 1 use reciprocal
                const recip = 1 / t;
                matricesWeights[a] *= recip;
                matricesWeights[a + 1] *= recip;
                matricesWeights[a + 2] *= recip;
                matricesWeights[a + 3] *= recip;
            }
        }
        this.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeights);
    }
    // handle special case of extra verts.  (in theory gltf can handle 12 influences)
    _normalizeSkinWeightsAndExtra() {
        const matricesWeightsExtra = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
        const matricesWeights = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        const numWeights = matricesWeights.length;
        for(let a = 0; a < numWeights; a += 4){
            // accumulate weights
            let t = matricesWeights[a] + matricesWeights[a + 1] + matricesWeights[a + 2] + matricesWeights[a + 3];
            t += matricesWeightsExtra[a] + matricesWeightsExtra[a + 1] + matricesWeightsExtra[a + 2] + matricesWeightsExtra[a + 3];
            // check for invalid weight and just set it to 1.
            if (t === 0) matricesWeights[a] = 1;
            else {
                // renormalize so everything adds to 1 use reciprocal
                const recip = 1 / t;
                matricesWeights[a] *= recip;
                matricesWeights[a + 1] *= recip;
                matricesWeights[a + 2] *= recip;
                matricesWeights[a + 3] *= recip;
                // same goes for extras
                matricesWeightsExtra[a] *= recip;
                matricesWeightsExtra[a + 1] *= recip;
                matricesWeightsExtra[a + 2] *= recip;
                matricesWeightsExtra[a + 3] *= recip;
            }
        }
        this.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeights);
        this.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeightsExtra);
    }
    /**
     * ValidateSkinning is used to determine that a mesh has valid skinning data along with skin metrics, if missing weights,
     * or not normalized it is returned as invalid mesh the string can be used for console logs, or on screen messages to let
     * the user know there was an issue with importing the mesh
     * @returns a validation object with skinned, valid and report string
     */ validateSkinning() {
        const matricesWeightsExtra = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
        const matricesWeights = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        if (matricesWeights === null || this.skeleton == null) return {
            skinned: false,
            valid: true,
            report: "not skinned"
        };
        const numWeights = matricesWeights.length;
        let numberNotSorted = 0;
        let missingWeights = 0;
        let maxUsedWeights = 0;
        let numberNotNormalized = 0;
        const numInfluences = matricesWeightsExtra === null ? 4 : 8;
        const usedWeightCounts = [];
        for(let a = 0; a <= numInfluences; a++)usedWeightCounts[a] = 0;
        const toleranceEpsilon = 0.001;
        for(let a = 0; a < numWeights; a += 4){
            let lastWeight = matricesWeights[a];
            let t = lastWeight;
            let usedWeights = t === 0 ? 0 : 1;
            for(let b = 1; b < numInfluences; b++){
                const d = b < 4 ? matricesWeights[a + b] : matricesWeightsExtra[a + b - 4];
                if (d > lastWeight) numberNotSorted++;
                if (d !== 0) usedWeights++;
                t += d;
                lastWeight = d;
            }
            // count the buffer weights usage
            usedWeightCounts[usedWeights]++;
            // max influences
            if (usedWeights > maxUsedWeights) maxUsedWeights = usedWeights;
            // check for invalid weight and just set it to 1.
            if (t === 0) missingWeights++;
            else {
                // renormalize so everything adds to 1 use reciprocal
                const recip = 1 / t;
                let tolerance = 0;
                for(let b = 0; b < numInfluences; b++)if (b < 4) tolerance += Math.abs(matricesWeights[a + b] - matricesWeights[a + b] * recip);
                else tolerance += Math.abs(matricesWeightsExtra[a + b - 4] - matricesWeightsExtra[a + b - 4] * recip);
                // arbitrary epsilon value for dictating not normalized
                if (tolerance > toleranceEpsilon) numberNotNormalized++;
            }
        }
        // validate bone indices are in range of the skeleton
        const numBones = this.skeleton.bones.length;
        const matricesIndices = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        const matricesIndicesExtra = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
        let numBadBoneIndices = 0;
        for(let a = 0; a < numWeights; a += 4)for(let b = 0; b < numInfluences; b++){
            const index = b < 4 ? matricesIndices[a + b] : matricesIndicesExtra[a + b - 4];
            if (index >= numBones || index < 0) numBadBoneIndices++;
        }
        // log mesh stats
        const output = "Number of Weights = " + numWeights / 4 + "\nMaximum influences = " + maxUsedWeights + "\nMissing Weights = " + missingWeights + "\nNot Sorted = " + numberNotSorted + "\nNot Normalized = " + numberNotNormalized + "\nWeightCounts = [" + usedWeightCounts + "]" + "\nNumber of bones = " + numBones + "\nBad Bone Indices = " + numBadBoneIndices;
        return {
            skinned: true,
            valid: missingWeights === 0 && numberNotNormalized === 0 && numBadBoneIndices === 0,
            report: output
        };
    }
    /** @internal */ _checkDelayState() {
        const scene = this.getScene();
        if (this._geometry) this._geometry.load(scene);
        else if (this.delayLoadState === 4) {
            this.delayLoadState = 2;
            this._queueLoad(scene);
        }
        return this;
    }
    _queueLoad(scene) {
        scene.addPendingData(this);
        const getBinaryData = this.delayLoadingFile.indexOf(".babylonbinarymeshdata") !== -1;
        (0, $bOhSV.Tools).LoadFile(this.delayLoadingFile, (data)=>{
            if (data instanceof ArrayBuffer) this._delayLoadingFunction(data, this);
            else this._delayLoadingFunction(JSON.parse(data), this);
            this.instances.forEach((instance)=>{
                instance.refreshBoundingInfo();
                instance._syncSubMeshes();
            });
            this.delayLoadState = 1;
            scene.removePendingData(this);
        }, ()=>{}, scene.offlineProvider, getBinaryData);
        return this;
    }
    /**
     * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
     * A mesh is in the frustum if its bounding box intersects the frustum
     * @param frustumPlanes defines the frustum to test
     * @returns true if the mesh is in the frustum planes
     */ isInFrustum(frustumPlanes) {
        if (this.delayLoadState === 2) return false;
        if (!super.isInFrustum(frustumPlanes)) return false;
        this._checkDelayState();
        return true;
    }
    /**
     * Sets the mesh material by the material or multiMaterial `id` property
     * @param id is a string identifying the material or the multiMaterial
     * @returns the current mesh
     */ setMaterialById(id) {
        const materials = this.getScene().materials;
        let index;
        for(index = materials.length - 1; index > -1; index--)if (materials[index].id === id) {
            this.material = materials[index];
            return this;
        }
        // Multi
        const multiMaterials = this.getScene().multiMaterials;
        for(index = multiMaterials.length - 1; index > -1; index--)if (multiMaterials[index].id === id) {
            this.material = multiMaterials[index];
            return this;
        }
        return this;
    }
    /**
     * Returns as a new array populated with the mesh material and/or skeleton, if any.
     * @returns an array of IAnimatable
     */ getAnimatables() {
        const results = [];
        if (this.material) results.push(this.material);
        if (this.skeleton) results.push(this.skeleton);
        return results;
    }
    /**
     * Modifies the mesh geometry according to the passed transformation matrix.
     * This method returns nothing, but it really modifies the mesh even if it's originally not set as updatable.
     * The mesh normals are modified using the same transformation.
     * Note that, under the hood, this method sets a new VertexBuffer each call.
     * @param transform defines the transform matrix to use
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
     * @returns the current mesh
     */ bakeTransformIntoVertices(transform) {
        // Position
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) return this;
        const submeshes = this.subMeshes.splice(0);
        this._resetPointsArrayCache();
        let data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const temp = (0, $ha1VO.Vector3).Zero();
        let index;
        for(index = 0; index < data.length; index += 3)(0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).toArray(data, index);
        this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, data, this.getVertexBuffer((0, $b4i1f.VertexBuffer).PositionKind).isUpdatable());
        // Normals
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
            data = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            for(index = 0; index < data.length; index += 3)(0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).normalize().toArray(data, index);
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, data, this.getVertexBuffer((0, $b4i1f.VertexBuffer).NormalKind).isUpdatable());
        }
        // Tangents
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) {
            data = this.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind);
            for(index = 0; index < data.length; index += 4)(0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).normalize().toArray(data, index);
            this.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, data, this.getVertexBuffer((0, $b4i1f.VertexBuffer).TangentKind).isUpdatable());
        }
        // flip faces?
        if (transform.determinant() < 0) this.flipFaces();
        // Restore submeshes
        this.releaseSubMeshes();
        this.subMeshes = submeshes;
        return this;
    }
    /**
     * Modifies the mesh geometry according to its own current World Matrix.
     * The mesh World Matrix is then reset.
     * This method returns nothing but really modifies the mesh even if it's originally not set as updatable.
     * Note that, under the hood, this method sets a new VertexBuffer each call.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
     * @param bakeIndependentlyOfChildren indicates whether to preserve all child nodes' World Matrix during baking
     * @returns the current mesh
     */ bakeCurrentTransformIntoVertices(bakeIndependentlyOfChildren = true) {
        this.bakeTransformIntoVertices(this.computeWorldMatrix(true));
        this.resetLocalMatrix(bakeIndependentlyOfChildren);
        return this;
    }
    // Cache
    /** @internal */ get _positions() {
        return this._internalAbstractMeshDataInfo._positions || this._geometry && this._geometry._positions || null;
    }
    /** @internal */ _resetPointsArrayCache() {
        if (this._geometry) this._geometry._resetPointsArrayCache();
        return this;
    }
    /** @internal */ _generatePointsArray() {
        if (this._geometry) return this._geometry._generatePointsArray();
        return false;
    }
    /**
     * Returns a new Mesh object generated from the current mesh properties.
     * This method must not get confused with createInstance()
     * @param name is a string, the name given to the new mesh
     * @param newParent can be any Node object (default `null`) or an instance of MeshCloneOptions. If the latter, doNotCloneChildren and clonePhysicsImpostor are unused.
     * @param doNotCloneChildren allows/denies the recursive cloning of the original mesh children if any (default `false`)
     * @param clonePhysicsImpostor allows/denies the cloning in the same time of the original mesh `body` used by the physics engine, if any (default `true`)
     * @returns a new mesh
     */ clone(name = "", newParent = null, doNotCloneChildren, clonePhysicsImpostor = true) {
        if (newParent && newParent._addToSceneRootNodes === undefined) {
            const cloneOptions = newParent;
            $b0df7c384622c537$var$meshCreationOptions.source = this;
            $b0df7c384622c537$var$meshCreationOptions.doNotCloneChildren = cloneOptions.doNotCloneChildren;
            $b0df7c384622c537$var$meshCreationOptions.clonePhysicsImpostor = cloneOptions.clonePhysicsImpostor;
            $b0df7c384622c537$var$meshCreationOptions.cloneThinInstances = cloneOptions.cloneThinInstances;
            return new $b0df7c384622c537$export$e176487c05830cc5(name, this.getScene(), $b0df7c384622c537$var$meshCreationOptions);
        }
        return new $b0df7c384622c537$export$e176487c05830cc5(name, this.getScene(), newParent, this, doNotCloneChildren, clonePhysicsImpostor);
    }
    /**
     * Releases resources associated with this mesh.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this.morphTargetManager = null;
        if (this._geometry) this._geometry.releaseForMesh(this, true);
        const internalDataInfo = this._internalMeshDataInfo;
        if (internalDataInfo._onBeforeDrawObservable) internalDataInfo._onBeforeDrawObservable.clear();
        if (internalDataInfo._onBeforeBindObservable) internalDataInfo._onBeforeBindObservable.clear();
        if (internalDataInfo._onBeforeRenderObservable) internalDataInfo._onBeforeRenderObservable.clear();
        if (internalDataInfo._onAfterRenderObservable) internalDataInfo._onAfterRenderObservable.clear();
        if (internalDataInfo._onBetweenPassObservable) internalDataInfo._onBetweenPassObservable.clear();
        // Sources
        if (this._scene.useClonedMeshMap) {
            if (internalDataInfo.meshMap) for(const uniqueId in internalDataInfo.meshMap){
                const mesh = internalDataInfo.meshMap[uniqueId];
                if (mesh) {
                    mesh._internalMeshDataInfo._source = null;
                    internalDataInfo.meshMap[uniqueId] = undefined;
                }
            }
            if (internalDataInfo._source && internalDataInfo._source._internalMeshDataInfo.meshMap) internalDataInfo._source._internalMeshDataInfo.meshMap[this.uniqueId] = undefined;
        } else {
            const meshes = this.getScene().meshes;
            for (const abstractMesh of meshes){
                const mesh = abstractMesh;
                if (mesh._internalMeshDataInfo && mesh._internalMeshDataInfo._source && mesh._internalMeshDataInfo._source === this) mesh._internalMeshDataInfo._source = null;
            }
        }
        internalDataInfo._source = null;
        this._instanceDataStorage.visibleInstances = {};
        // Instances
        this._disposeInstanceSpecificData();
        // Thin instances
        this._disposeThinInstanceSpecificData();
        if (this._internalMeshDataInfo._checkReadinessObserver) this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /** @internal */ _disposeInstanceSpecificData() {
    // Do nothing
    }
    /** @internal */ _disposeThinInstanceSpecificData() {
    // Do nothing
    }
    /** @internal */ _invalidateInstanceVertexArrayObject() {
    // Do nothing
    }
    /**
     * Modifies the mesh geometry according to a displacement map.
     * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
     * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
     * @param url is a string, the URL from the image file is to be downloaded.
     * @param minHeight is the lower limit of the displacement.
     * @param maxHeight is the upper limit of the displacement.
     * @param onSuccess is an optional Javascript function to be called just after the mesh is modified. It is passed the modified mesh and must return nothing.
     * @param uvOffset is an optional vector2 used to offset UV.
     * @param uvScale is an optional vector2 used to scale UV.
     * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
     * @param onError defines a callback called when an error occurs during the processing of the request.
     * @returns the Mesh.
     */ applyDisplacementMap(url, minHeight, maxHeight, onSuccess, uvOffset, uvScale, forceUpdate = false, onError) {
        const scene = this.getScene();
        const onload = (img)=>{
            // Getting height map data
            const heightMapWidth = img.width;
            const heightMapHeight = img.height;
            const canvas = this.getEngine().createCanvas(heightMapWidth, heightMapHeight);
            const context = canvas.getContext("2d");
            context.drawImage(img, 0, 0);
            // Create VertexData from map data
            //Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949
            const buffer = context.getImageData(0, 0, heightMapWidth, heightMapHeight).data;
            this.applyDisplacementMapFromBuffer(buffer, heightMapWidth, heightMapHeight, minHeight, maxHeight, uvOffset, uvScale, forceUpdate);
            //execute success callback, if set
            if (onSuccess) onSuccess(this);
        };
        (0, $bOhSV.Tools).LoadImage(url, onload, onError ? onError : ()=>{}, scene.offlineProvider);
        return this;
    }
    /**
     * Modifies the mesh geometry according to a displacementMap buffer.
     * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
     * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
     * @param buffer is a `Uint8Array` buffer containing series of `Uint8` lower than 255, the red, green, blue and alpha values of each successive pixel.
     * @param heightMapWidth is the width of the buffer image.
     * @param heightMapHeight is the height of the buffer image.
     * @param minHeight is the lower limit of the displacement.
     * @param maxHeight is the upper limit of the displacement.
     * @param uvOffset is an optional vector2 used to offset UV.
     * @param uvScale is an optional vector2 used to scale UV.
     * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
     * @returns the Mesh.
     */ applyDisplacementMapFromBuffer(buffer, heightMapWidth, heightMapHeight, minHeight, maxHeight, uvOffset, uvScale, forceUpdate = false) {
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind) || !this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind) || !this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
            (0, $kVtWi.Logger).Warn("Cannot call applyDisplacementMap: Given mesh is not complete. Position, Normal or UV are missing");
            return this;
        }
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, true, true);
        const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const uvs = this.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        let position = (0, $ha1VO.Vector3).Zero();
        const normal = (0, $ha1VO.Vector3).Zero();
        const uv = (0, $ha1VO.Vector2).Zero();
        uvOffset = uvOffset || (0, $ha1VO.Vector2).Zero();
        uvScale = uvScale || new (0, $ha1VO.Vector2)(1, 1);
        for(let index = 0; index < positions.length; index += 3){
            (0, $ha1VO.Vector3).FromArrayToRef(positions, index, position);
            (0, $ha1VO.Vector3).FromArrayToRef(normals, index, normal);
            (0, $ha1VO.Vector2).FromArrayToRef(uvs, index / 3 * 2, uv);
            // Compute height
            const u = Math.abs(uv.x * uvScale.x + uvOffset.x % 1) * (heightMapWidth - 1) % heightMapWidth | 0;
            const v = Math.abs(uv.y * uvScale.y + uvOffset.y % 1) * (heightMapHeight - 1) % heightMapHeight | 0;
            const pos = (u + v * heightMapWidth) * 4;
            const r = buffer[pos] / 255.0;
            const g = buffer[pos + 1] / 255.0;
            const b = buffer[pos + 2] / 255.0;
            const gradient = r * 0.3 + g * 0.59 + b * 0.11;
            normal.normalize();
            normal.scaleInPlace(minHeight + (maxHeight - minHeight) * gradient);
            position = position.add(normal);
            position.toArray(positions, index);
        }
        (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, this.getIndices(), normals);
        if (forceUpdate) {
            this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions);
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals);
            this.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvs);
        } else {
            this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions);
            this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals);
        }
        return this;
    }
    _getFlattenedNormals(indices, positions) {
        const normals = new Float32Array(indices.length * 3);
        let normalsCount = 0;
        // Decide if normals should be flipped
        const flipNormalGeneration = this.sideOrientation === (this._scene.useRightHandedSystem ? 1 : 0);
        // Generate new normals
        for(let index = 0; index < indices.length; index += 3){
            const p1 = (0, $ha1VO.Vector3).FromArray(positions, indices[index] * 3);
            const p2 = (0, $ha1VO.Vector3).FromArray(positions, indices[index + 1] * 3);
            const p3 = (0, $ha1VO.Vector3).FromArray(positions, indices[index + 2] * 3);
            const p1p2 = p1.subtract(p2);
            const p3p2 = p3.subtract(p2);
            const normal = (0, $ha1VO.Vector3).Normalize((0, $ha1VO.Vector3).Cross(p1p2, p3p2));
            if (flipNormalGeneration) normal.scaleInPlace(-1);
            // Store same normals for every vertex
            for(let localIndex = 0; localIndex < 3; localIndex++){
                normals[normalsCount++] = normal.x;
                normals[normalsCount++] = normal.y;
                normals[normalsCount++] = normal.z;
            }
        }
        return normals;
    }
    _convertToUnIndexedMesh(flattenNormals = false) {
        const kinds = this.getVerticesDataKinds().filter((kind)=>!this.getVertexBuffer(kind)?.getIsInstanced());
        const indices = this.getIndices();
        const data = {};
        const separateVertices = (data, size)=>{
            const newData = new Float32Array(indices.length * size);
            let count = 0;
            for(let index = 0; index < indices.length; index++)for(let offset = 0; offset < size; offset++)newData[count++] = data[indices[index] * size + offset];
            return newData;
        };
        // Save mesh bounding info
        const meshBoundingInfo = this.getBoundingInfo();
        // Save previous submeshes
        const previousSubmeshes = this.geometry ? this.subMeshes.slice(0) : [];
        // Cache vertex data
        for (const kind of kinds)data[kind] = this.getVerticesData(kind);
        // Update vertex data
        for (const kind of kinds){
            const vertexBuffer = this.getVertexBuffer(kind);
            const size = vertexBuffer.getSize();
            if (flattenNormals && kind === (0, $b4i1f.VertexBuffer).NormalKind) {
                const normals = this._getFlattenedNormals(indices, data[(0, $b4i1f.VertexBuffer).PositionKind]);
                this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, vertexBuffer.isUpdatable(), size);
            } else this.setVerticesData(kind, separateVertices(data[kind], size), vertexBuffer.isUpdatable(), size);
        }
        // Update morph targets
        if (this.morphTargetManager) {
            for(let targetIndex = 0; targetIndex < this.morphTargetManager.numTargets; targetIndex++){
                const target = this.morphTargetManager.getTarget(targetIndex);
                const positions = target.getPositions();
                target.setPositions(separateVertices(positions, 3));
                const normals = target.getNormals();
                if (normals) target.setNormals(flattenNormals ? this._getFlattenedNormals(indices, positions) : separateVertices(normals, 3));
                const tangents = target.getTangents();
                if (tangents) target.setTangents(separateVertices(tangents, 3));
                const uvs = target.getUVs();
                if (uvs) target.setUVs(separateVertices(uvs, 2));
            }
            this.morphTargetManager.synchronize();
        }
        // Update indices
        for(let index = 0; index < indices.length; index++)indices[index] = index;
        this.setIndices(indices);
        this._unIndexed = true;
        // Update submeshes
        this.releaseSubMeshes();
        for (const previousOne of previousSubmeshes){
            const boundingInfo = previousOne.getBoundingInfo();
            const subMesh = (0, $fc3ab70ba5c9f506$export$c684db7d654df572).AddToMesh(previousOne.materialIndex, previousOne.indexStart, previousOne.indexCount, previousOne.indexStart, previousOne.indexCount, this);
            subMesh.setBoundingInfo(boundingInfo);
        }
        this.setBoundingInfo(meshBoundingInfo);
        this.synchronizeInstances();
        return this;
    }
    /**
     * Modify the mesh to get a flat shading rendering.
     * This means each mesh facet will then have its own normals. Usually new vertices are added in the mesh geometry to get this result.
     * Warning : the mesh is really modified even if not set originally as updatable and, under the hood, a new VertexBuffer is allocated.
     * @returns current mesh
     */ convertToFlatShadedMesh() {
        return this._convertToUnIndexedMesh(true);
    }
    /**
     * This method removes all the mesh indices and add new vertices (duplication) in order to unfold facets into buffers.
     * In other words, more vertices, no more indices and a single bigger VBO.
     * The mesh is really modified even if not set originally as updatable. Under the hood, a new VertexBuffer is allocated.
     * @returns current mesh
     */ convertToUnIndexedMesh() {
        return this._convertToUnIndexedMesh();
    }
    /**
     * Inverses facet orientations.
     * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
     * @param flipNormals will also inverts the normals
     * @returns current mesh
     */ flipFaces(flipNormals = false) {
        const vertex_data = (0, $4014d881db0e9bc6$export$8570d39351855acb).ExtractFromMesh(this);
        let i;
        if (flipNormals && this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind) && vertex_data.normals) {
            for(i = 0; i < vertex_data.normals.length; i++)vertex_data.normals[i] *= -1;
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, vertex_data.normals, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).NormalKind));
        }
        if (vertex_data.indices) {
            let temp;
            for(i = 0; i < vertex_data.indices.length; i += 3){
                // reassign indices
                temp = vertex_data.indices[i + 1];
                vertex_data.indices[i + 1] = vertex_data.indices[i + 2];
                vertex_data.indices[i + 2] = temp;
            }
            this.setIndices(vertex_data.indices, null, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind), true);
        }
        return this;
    }
    /**
     * Increase the number of facets and hence vertices in a mesh
     * Vertex normals are interpolated from existing vertex normals
     * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
     * @param numberPerEdge the number of new vertices to add to each edge of a facet, optional default 1
     */ increaseVertices(numberPerEdge = 1) {
        const vertex_data = (0, $4014d881db0e9bc6$export$8570d39351855acb).ExtractFromMesh(this);
        const currentIndices = vertex_data.indices && !Array.isArray(vertex_data.indices) && Array.from ? Array.from(vertex_data.indices) : vertex_data.indices;
        const positions = vertex_data.positions && !Array.isArray(vertex_data.positions) && Array.from ? Array.from(vertex_data.positions) : vertex_data.positions;
        const uvs = vertex_data.uvs && !Array.isArray(vertex_data.uvs) && Array.from ? Array.from(vertex_data.uvs) : vertex_data.uvs;
        const normals = vertex_data.normals && !Array.isArray(vertex_data.normals) && Array.from ? Array.from(vertex_data.normals) : vertex_data.normals;
        if (!currentIndices || !positions) (0, $kVtWi.Logger).Warn("Couldn't increase number of vertices : VertexData must contain at least indices and positions");
        else {
            vertex_data.indices = currentIndices;
            vertex_data.positions = positions;
            if (uvs) vertex_data.uvs = uvs;
            if (normals) vertex_data.normals = normals;
            const segments = numberPerEdge + 1; //segments per current facet edge, become sides of new facets
            const tempIndices = new Array();
            for(let i = 0; i < segments + 1; i++)tempIndices[i] = new Array();
            let a; //vertex index of one end of a side
            let b; //vertex index of other end of the side
            const deltaPosition = new (0, $ha1VO.Vector3)(0, 0, 0);
            const deltaNormal = new (0, $ha1VO.Vector3)(0, 0, 0);
            const deltaUV = new (0, $ha1VO.Vector2)(0, 0);
            const indices = new Array();
            const vertexIndex = new Array();
            const side = new Array();
            let len;
            let positionPtr = positions.length;
            let uvPtr;
            if (uvs) uvPtr = uvs.length;
            let normalsPtr;
            if (normals) normalsPtr = normals.length;
            for(let i = 0; i < currentIndices.length; i += 3){
                vertexIndex[0] = currentIndices[i];
                vertexIndex[1] = currentIndices[i + 1];
                vertexIndex[2] = currentIndices[i + 2];
                for(let j = 0; j < 3; j++){
                    a = vertexIndex[j];
                    b = vertexIndex[(j + 1) % 3];
                    if (side[a] === undefined && side[b] === undefined) {
                        side[a] = new Array();
                        side[b] = new Array();
                    } else {
                        if (side[a] === undefined) side[a] = new Array();
                        if (side[b] === undefined) side[b] = new Array();
                    }
                    if (side[a][b] === undefined && side[b][a] === undefined) {
                        side[a][b] = [];
                        deltaPosition.x = (positions[3 * b] - positions[3 * a]) / segments;
                        deltaPosition.y = (positions[3 * b + 1] - positions[3 * a + 1]) / segments;
                        deltaPosition.z = (positions[3 * b + 2] - positions[3 * a + 2]) / segments;
                        if (normals) {
                            deltaNormal.x = (normals[3 * b] - normals[3 * a]) / segments;
                            deltaNormal.y = (normals[3 * b + 1] - normals[3 * a + 1]) / segments;
                            deltaNormal.z = (normals[3 * b + 2] - normals[3 * a + 2]) / segments;
                        }
                        if (uvs) {
                            deltaUV.x = (uvs[2 * b] - uvs[2 * a]) / segments;
                            deltaUV.y = (uvs[2 * b + 1] - uvs[2 * a + 1]) / segments;
                        }
                        side[a][b].push(a);
                        for(let k = 1; k < segments; k++){
                            side[a][b].push(positions.length / 3);
                            positions[positionPtr++] = positions[3 * a] + k * deltaPosition.x;
                            positions[positionPtr++] = positions[3 * a + 1] + k * deltaPosition.y;
                            positions[positionPtr++] = positions[3 * a + 2] + k * deltaPosition.z;
                            if (normals) {
                                normals[normalsPtr++] = normals[3 * a] + k * deltaNormal.x;
                                normals[normalsPtr++] = normals[3 * a + 1] + k * deltaNormal.y;
                                normals[normalsPtr++] = normals[3 * a + 2] + k * deltaNormal.z;
                            }
                            if (uvs) {
                                uvs[uvPtr++] = uvs[2 * a] + k * deltaUV.x;
                                uvs[uvPtr++] = uvs[2 * a + 1] + k * deltaUV.y;
                            }
                        }
                        side[a][b].push(b);
                        side[b][a] = new Array();
                        len = side[a][b].length;
                        for(let idx = 0; idx < len; idx++)side[b][a][idx] = side[a][b][len - 1 - idx];
                    }
                }
                //Calculate positions, normals and uvs of new internal vertices
                tempIndices[0][0] = currentIndices[i];
                tempIndices[1][0] = side[currentIndices[i]][currentIndices[i + 1]][1];
                tempIndices[1][1] = side[currentIndices[i]][currentIndices[i + 2]][1];
                for(let k = 2; k < segments; k++){
                    tempIndices[k][0] = side[currentIndices[i]][currentIndices[i + 1]][k];
                    tempIndices[k][k] = side[currentIndices[i]][currentIndices[i + 2]][k];
                    deltaPosition.x = (positions[3 * tempIndices[k][k]] - positions[3 * tempIndices[k][0]]) / k;
                    deltaPosition.y = (positions[3 * tempIndices[k][k] + 1] - positions[3 * tempIndices[k][0] + 1]) / k;
                    deltaPosition.z = (positions[3 * tempIndices[k][k] + 2] - positions[3 * tempIndices[k][0] + 2]) / k;
                    if (normals) {
                        deltaNormal.x = (normals[3 * tempIndices[k][k]] - normals[3 * tempIndices[k][0]]) / k;
                        deltaNormal.y = (normals[3 * tempIndices[k][k] + 1] - normals[3 * tempIndices[k][0] + 1]) / k;
                        deltaNormal.z = (normals[3 * tempIndices[k][k] + 2] - normals[3 * tempIndices[k][0] + 2]) / k;
                    }
                    if (uvs) {
                        deltaUV.x = (uvs[2 * tempIndices[k][k]] - uvs[2 * tempIndices[k][0]]) / k;
                        deltaUV.y = (uvs[2 * tempIndices[k][k] + 1] - uvs[2 * tempIndices[k][0] + 1]) / k;
                    }
                    for(let j = 1; j < k; j++){
                        tempIndices[k][j] = positions.length / 3;
                        positions[positionPtr++] = positions[3 * tempIndices[k][0]] + j * deltaPosition.x;
                        positions[positionPtr++] = positions[3 * tempIndices[k][0] + 1] + j * deltaPosition.y;
                        positions[positionPtr++] = positions[3 * tempIndices[k][0] + 2] + j * deltaPosition.z;
                        if (normals) {
                            normals[normalsPtr++] = normals[3 * tempIndices[k][0]] + j * deltaNormal.x;
                            normals[normalsPtr++] = normals[3 * tempIndices[k][0] + 1] + j * deltaNormal.y;
                            normals[normalsPtr++] = normals[3 * tempIndices[k][0] + 2] + j * deltaNormal.z;
                        }
                        if (uvs) {
                            uvs[uvPtr++] = uvs[2 * tempIndices[k][0]] + j * deltaUV.x;
                            uvs[uvPtr++] = uvs[2 * tempIndices[k][0] + 1] + j * deltaUV.y;
                        }
                    }
                }
                tempIndices[segments] = side[currentIndices[i + 1]][currentIndices[i + 2]];
                // reform indices
                indices.push(tempIndices[0][0], tempIndices[1][0], tempIndices[1][1]);
                for(let k = 1; k < segments; k++){
                    let j;
                    for(j = 0; j < k; j++){
                        indices.push(tempIndices[k][j], tempIndices[k + 1][j], tempIndices[k + 1][j + 1]);
                        indices.push(tempIndices[k][j], tempIndices[k + 1][j + 1], tempIndices[k][j + 1]);
                    }
                    indices.push(tempIndices[k][j], tempIndices[k + 1][j], tempIndices[k + 1][j + 1]);
                }
            }
            vertex_data.indices = indices;
            vertex_data.applyToMesh(this, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind));
        }
    }
    /**
     * Force adjacent facets to share vertices and remove any facets that have all vertices in a line
     * This will undo any application of covertToFlatShadedMesh
     * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
     */ forceSharedVertices() {
        const vertex_data = (0, $4014d881db0e9bc6$export$8570d39351855acb).ExtractFromMesh(this);
        const currentUVs = vertex_data.uvs;
        const currentIndices = vertex_data.indices;
        const currentPositions = vertex_data.positions;
        const currentColors = vertex_data.colors;
        const currentMatrixIndices = vertex_data.matricesIndices;
        const currentMatrixWeights = vertex_data.matricesWeights;
        const currentMatrixIndicesExtra = vertex_data.matricesIndicesExtra;
        const currentMatrixWeightsExtra = vertex_data.matricesWeightsExtra;
        if (currentIndices === void 0 || currentPositions === void 0 || currentIndices === null || currentPositions === null) (0, $kVtWi.Logger).Warn("VertexData contains empty entries");
        else {
            const positions = new Array();
            const indices = new Array();
            const uvs = new Array();
            const colors = new Array();
            const matrixIndices = new Array();
            const matrixWeights = new Array();
            const matrixIndicesExtra = new Array();
            const matrixWeightsExtra = new Array();
            let pstring = new Array(); //lists facet vertex positions (a,b,c) as string "a|b|c"
            let indexPtr = 0; // pointer to next available index value
            const uniquePositions = {}; // unique vertex positions
            let ptr; // pointer to element in uniquePositions
            let facet;
            for(let i = 0; i < currentIndices.length; i += 3){
                facet = [
                    currentIndices[i],
                    currentIndices[i + 1],
                    currentIndices[i + 2]
                ]; //facet vertex indices
                pstring = [];
                for(let j = 0; j < 3; j++){
                    pstring[j] = "";
                    for(let k = 0; k < 3; k++){
                        //small values make 0
                        if (Math.abs(currentPositions[3 * facet[j] + k]) < 0.00000001) currentPositions[3 * facet[j] + k] = 0;
                        pstring[j] += currentPositions[3 * facet[j] + k] + "|";
                    }
                }
                //check facet vertices to see that none are repeated
                // do not process any facet that has a repeated vertex, ie is a line
                if (!(pstring[0] == pstring[1] || pstring[0] == pstring[2] || pstring[1] == pstring[2])) //for each facet position check if already listed in uniquePositions
                // if not listed add to uniquePositions and set index pointer
                // if listed use its index in uniquePositions and new index pointer
                for(let j = 0; j < 3; j++){
                    ptr = uniquePositions[pstring[j]];
                    if (ptr === undefined) {
                        uniquePositions[pstring[j]] = indexPtr;
                        ptr = indexPtr++;
                        //not listed so add individual x, y, z coordinates to positions
                        for(let k = 0; k < 3; k++)positions.push(currentPositions[3 * facet[j] + k]);
                        if (currentColors !== null && currentColors !== void 0) for(let k = 0; k < 4; k++)colors.push(currentColors[4 * facet[j] + k]);
                        if (currentUVs !== null && currentUVs !== void 0) for(let k = 0; k < 2; k++)uvs.push(currentUVs[2 * facet[j] + k]);
                        if (currentMatrixIndices !== null && currentMatrixIndices !== void 0) for(let k = 0; k < 4; k++)matrixIndices.push(currentMatrixIndices[4 * facet[j] + k]);
                        if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) for(let k = 0; k < 4; k++)matrixWeights.push(currentMatrixWeights[4 * facet[j] + k]);
                        if (currentMatrixIndicesExtra !== null && currentMatrixIndicesExtra !== void 0) for(let k = 0; k < 4; k++)matrixIndicesExtra.push(currentMatrixIndicesExtra[4 * facet[j] + k]);
                        if (currentMatrixWeightsExtra !== null && currentMatrixWeightsExtra !== void 0) for(let k = 0; k < 4; k++)matrixWeightsExtra.push(currentMatrixWeightsExtra[4 * facet[j] + k]);
                    }
                    // add new index pointer to indices array
                    indices.push(ptr);
                }
            }
            const normals = new Array();
            (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
            //create new vertex data object and update
            vertex_data.positions = positions;
            vertex_data.indices = indices;
            vertex_data.normals = normals;
            if (currentUVs !== null && currentUVs !== void 0) vertex_data.uvs = uvs;
            if (currentColors !== null && currentColors !== void 0) vertex_data.colors = colors;
            if (currentMatrixIndices !== null && currentMatrixIndices !== void 0) vertex_data.matricesIndices = matrixIndices;
            if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) vertex_data.matricesWeights = matrixWeights;
            if (currentMatrixIndicesExtra !== null && currentMatrixIndicesExtra !== void 0) vertex_data.matricesIndicesExtra = matrixIndicesExtra;
            if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) vertex_data.matricesWeightsExtra = matrixWeightsExtra;
            vertex_data.applyToMesh(this, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind));
        }
    }
    // Instances
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/naming-convention
    static _instancedMeshFactory(name, mesh) {
        throw (0, $dUFYy._WarnImport)("InstancedMesh");
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _PhysicsImpostorParser(scene, physicObject, jsonObject) {
        throw (0, $dUFYy._WarnImport)("PhysicsImpostor");
    }
    /**
     * Creates a new InstancedMesh object from the mesh model.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
     * @param name defines the name of the new instance
     * @returns a new InstancedMesh
     */ createInstance(name) {
        const instance = $b0df7c384622c537$export$e176487c05830cc5._instancedMeshFactory(name, this);
        instance.parent = this.parent;
        return instance;
    }
    /**
     * Synchronises all the mesh instance submeshes to the current mesh submeshes, if any.
     * After this call, all the mesh instances have the same submeshes than the current mesh.
     * @returns the current mesh
     */ synchronizeInstances() {
        for(let instanceIndex = 0; instanceIndex < this.instances.length; instanceIndex++){
            const instance = this.instances[instanceIndex];
            instance._syncSubMeshes();
        }
        return this;
    }
    /**
     * Optimization of the mesh's indices, in case a mesh has duplicated vertices.
     * The function will only reorder the indices and will not remove unused vertices to avoid problems with submeshes.
     * This should be used together with the simplification to avoid disappearing triangles.
     * @param successCallback an optional success callback to be called after the optimization finished.
     * @returns the current mesh
     */ optimizeIndices(successCallback) {
        const indices = this.getIndices();
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positions || !indices) return this;
        const vectorPositions = [];
        for(let pos = 0; pos < positions.length; pos = pos + 3)vectorPositions.push((0, $ha1VO.Vector3).FromArray(positions, pos));
        const dupes = [];
        (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(vectorPositions.length, 40, (iteration)=>{
            const realPos = vectorPositions.length - 1 - iteration;
            const testedPosition = vectorPositions[realPos];
            for(let j = 0; j < realPos; ++j){
                const againstPosition = vectorPositions[j];
                if (testedPosition.equals(againstPosition)) {
                    dupes[realPos] = j;
                    break;
                }
            }
        }, ()=>{
            for(let i = 0; i < indices.length; ++i)indices[i] = dupes[indices[i]] || indices[i];
            //indices are now reordered
            const originalSubMeshes = this.subMeshes.slice(0);
            this.setIndices(indices);
            this.subMeshes = originalSubMeshes;
            if (successCallback) successCallback(this);
        });
        return this;
    }
    /**
     * Serialize current mesh
     * @param serializationObject defines the object which will receive the serialization data
     * @returns the serialized object
     */ serialize(serializationObject = {}) {
        serializationObject.name = this.name;
        serializationObject.id = this.id;
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.type = this.getClassName();
        if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(this)) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        serializationObject.position = this.position.asArray();
        if (this.rotationQuaternion) serializationObject.rotationQuaternion = this.rotationQuaternion.asArray();
        else if (this.rotation) serializationObject.rotation = this.rotation.asArray();
        serializationObject.scaling = this.scaling.asArray();
        if (this._postMultiplyPivotMatrix) serializationObject.pivotMatrix = this.getPivotMatrix().asArray();
        else serializationObject.localMatrix = this.getPivotMatrix().asArray();
        serializationObject.isEnabled = this.isEnabled(false);
        serializationObject.isVisible = this.isVisible;
        serializationObject.infiniteDistance = this.infiniteDistance;
        serializationObject.pickable = this.isPickable;
        serializationObject.receiveShadows = this.receiveShadows;
        serializationObject.billboardMode = this.billboardMode;
        serializationObject.visibility = this.visibility;
        serializationObject.alwaysSelectAsActiveMesh = this.alwaysSelectAsActiveMesh;
        serializationObject.checkCollisions = this.checkCollisions;
        serializationObject.ellipsoid = this.ellipsoid.asArray();
        serializationObject.ellipsoidOffset = this.ellipsoidOffset.asArray();
        serializationObject.doNotSyncBoundingInfo = this.doNotSyncBoundingInfo;
        serializationObject.isBlocker = this.isBlocker;
        serializationObject.sideOrientation = this.sideOrientation;
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        // Geometry
        serializationObject.isUnIndexed = this.isUnIndexed;
        const geometry = this._geometry;
        if (geometry && this.subMeshes) {
            serializationObject.geometryUniqueId = geometry.uniqueId;
            serializationObject.geometryId = geometry.id;
            // SubMeshes
            serializationObject.subMeshes = [];
            for(let subIndex = 0; subIndex < this.subMeshes.length; subIndex++){
                const subMesh = this.subMeshes[subIndex];
                serializationObject.subMeshes.push({
                    materialIndex: subMesh.materialIndex,
                    verticesStart: subMesh.verticesStart,
                    verticesCount: subMesh.verticesCount,
                    indexStart: subMesh.indexStart,
                    indexCount: subMesh.indexCount
                });
            }
        }
        // Material
        if (this.material) {
            if (!this.material.doNotSerialize) {
                serializationObject.materialUniqueId = this.material.uniqueId;
                serializationObject.materialId = this.material.id; // back compat
            }
        } else {
            this.material = null;
            serializationObject.materialUniqueId = this._scene.defaultMaterial.uniqueId;
            serializationObject.materialId = this._scene.defaultMaterial.id; // back compat
        }
        // Morph targets
        if (this.morphTargetManager) serializationObject.morphTargetManagerId = this.morphTargetManager.uniqueId;
        // Skeleton
        if (this.skeleton) {
            serializationObject.skeletonId = this.skeleton.id;
            serializationObject.numBoneInfluencers = this.numBoneInfluencers;
        }
        // Physics
        //TODO implement correct serialization for physics impostors.
        if (this.getScene()._getComponent((0, $bv05l.SceneComponentConstants).NAME_PHYSICSENGINE)) {
            const impostor = this.getPhysicsImpostor();
            if (impostor) {
                serializationObject.physicsMass = impostor.getParam("mass");
                serializationObject.physicsFriction = impostor.getParam("friction");
                serializationObject.physicsRestitution = impostor.getParam("mass");
                serializationObject.physicsImpostor = impostor.type;
            }
        }
        // Metadata
        if (this.metadata) serializationObject.metadata = this.metadata;
        // Instances
        serializationObject.instances = [];
        for(let index = 0; index < this.instances.length; index++){
            const instance = this.instances[index];
            if (instance.doNotSerialize) continue;
            const serializationInstance = {
                name: instance.name,
                id: instance.id,
                isEnabled: instance.isEnabled(false),
                isVisible: instance.isVisible,
                isPickable: instance.isPickable,
                checkCollisions: instance.checkCollisions,
                position: instance.position.asArray(),
                scaling: instance.scaling.asArray()
            };
            if (instance.parent) instance.parent._serializeAsParent(serializationInstance);
            if (instance.rotationQuaternion) serializationInstance.rotationQuaternion = instance.rotationQuaternion.asArray();
            else if (instance.rotation) serializationInstance.rotation = instance.rotation.asArray();
            // Physics
            //TODO implement correct serialization for physics impostors.
            if (this.getScene()._getComponent((0, $bv05l.SceneComponentConstants).NAME_PHYSICSENGINE)) {
                const impostor = instance.getPhysicsImpostor();
                if (impostor) {
                    serializationInstance.physicsMass = impostor.getParam("mass");
                    serializationInstance.physicsFriction = impostor.getParam("friction");
                    serializationInstance.physicsRestitution = impostor.getParam("mass");
                    serializationInstance.physicsImpostor = impostor.type;
                }
            }
            // Metadata
            if (instance.metadata) serializationInstance.metadata = instance.metadata;
            // Action Manager
            if (instance.actionManager) serializationInstance.actions = instance.actionManager.serialize(instance.name);
            serializationObject.instances.push(serializationInstance);
            // Animations
            (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(instance, serializationInstance);
            serializationInstance.ranges = instance.serializeAnimationRanges();
        }
        // Thin instances
        if (this._thinInstanceDataStorage.instancesCount && this._thinInstanceDataStorage.matrixData) {
            serializationObject.thinInstances = {
                instancesCount: this._thinInstanceDataStorage.instancesCount,
                matrixData: Array.from(this._thinInstanceDataStorage.matrixData),
                matrixBufferSize: this._thinInstanceDataStorage.matrixBufferSize,
                enablePicking: this.thinInstanceEnablePicking
            };
            if (this._userThinInstanceBuffersStorage) {
                const userThinInstance = {
                    data: {},
                    sizes: {},
                    strides: {}
                };
                for(const kind in this._userThinInstanceBuffersStorage.data){
                    userThinInstance.data[kind] = Array.from(this._userThinInstanceBuffersStorage.data[kind]);
                    userThinInstance.sizes[kind] = this._userThinInstanceBuffersStorage.sizes[kind];
                    userThinInstance.strides[kind] = this._userThinInstanceBuffersStorage.strides[kind];
                }
                serializationObject.thinInstances.userThinInstance = userThinInstance;
            }
        }
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        // Layer mask
        serializationObject.layerMask = this.layerMask;
        // Alpha
        serializationObject.alphaIndex = this.alphaIndex;
        serializationObject.hasVertexAlpha = this.hasVertexAlpha;
        // Overlay
        serializationObject.overlayAlpha = this.overlayAlpha;
        serializationObject.overlayColor = this.overlayColor.asArray();
        serializationObject.renderOverlay = this.renderOverlay;
        // Fog
        serializationObject.applyFog = this.applyFog;
        // Action Manager
        if (this.actionManager) serializationObject.actions = this.actionManager.serialize(this.name);
        return serializationObject;
    }
    /** @internal */ _syncGeometryWithMorphTargetManager() {
        if (!this.geometry) return;
        this._markSubMeshesAsAttributesDirty();
        const morphTargetManager = this._internalAbstractMeshDataInfo._morphTargetManager;
        if (morphTargetManager && morphTargetManager.vertexCount) {
            if (morphTargetManager.vertexCount !== this.getTotalVertices()) {
                (0, $kVtWi.Logger).Error("Mesh is incompatible with morph targets. Targets and mesh must all have the same vertices count.");
                this.morphTargetManager = null;
                return;
            }
            if (morphTargetManager.isUsingTextureForTargets) return;
            for(let index = 0; index < morphTargetManager.numInfluencers; index++){
                const morphTarget = morphTargetManager.getActiveTarget(index);
                const positions = morphTarget.getPositions();
                if (!positions) {
                    (0, $kVtWi.Logger).Error("Invalid morph target. Target must have positions.");
                    return;
                }
                this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind + index, positions, false, 3);
                const normals = morphTarget.getNormals();
                if (normals) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind + index, normals, false, 3);
                const tangents = morphTarget.getTangents();
                if (tangents) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind + index, tangents, false, 3);
                const uvs = morphTarget.getUVs();
                if (uvs) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).UVKind + "_" + index, uvs, false, 2);
                const uv2s = morphTarget.getUV2s();
                if (uv2s) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind + "_" + index, uv2s, false, 2);
            }
        } else {
            let index = 0;
            // Positions
            while(this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind + index)){
                this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).PositionKind + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).NormalKind + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).TangentKind + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).UVKind + "_" + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).UV2Kind + "_" + index);
                index++;
            }
        }
    }
    /**
     * Returns a new Mesh object parsed from the source provided.
     * @param parsedMesh is the source
     * @param scene defines the hosting scene
     * @param rootUrl is the root URL to prefix the `delayLoadingFile` property with
     * @returns a new Mesh
     */ static Parse(parsedMesh, scene, rootUrl) {
        let mesh;
        if (parsedMesh.type && parsedMesh.type === "LinesMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._LinesMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "GroundMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._GroundMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "GoldbergMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._GoldbergMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "GreasedLineMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._GreasedLineMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "TrailMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._TrailMeshParser(parsedMesh, scene);
        else mesh = new $b0df7c384622c537$export$e176487c05830cc5(parsedMesh.name, scene);
        mesh.id = parsedMesh.id;
        mesh._waitingParsedUniqueId = parsedMesh.uniqueId;
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(mesh, parsedMesh.tags);
        mesh.position = (0, $ha1VO.Vector3).FromArray(parsedMesh.position);
        if (parsedMesh.metadata !== undefined) mesh.metadata = parsedMesh.metadata;
        if (parsedMesh.rotationQuaternion) mesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromArray(parsedMesh.rotationQuaternion);
        else if (parsedMesh.rotation) mesh.rotation = (0, $ha1VO.Vector3).FromArray(parsedMesh.rotation);
        mesh.scaling = (0, $ha1VO.Vector3).FromArray(parsedMesh.scaling);
        if (parsedMesh.localMatrix) mesh.setPreTransformMatrix((0, $ha1VO.Matrix).FromArray(parsedMesh.localMatrix));
        else if (parsedMesh.pivotMatrix) mesh.setPivotMatrix((0, $ha1VO.Matrix).FromArray(parsedMesh.pivotMatrix));
        mesh.setEnabled(parsedMesh.isEnabled);
        mesh.isVisible = parsedMesh.isVisible;
        mesh.infiniteDistance = parsedMesh.infiniteDistance;
        mesh.alwaysSelectAsActiveMesh = !!parsedMesh.alwaysSelectAsActiveMesh;
        mesh.showBoundingBox = parsedMesh.showBoundingBox;
        mesh.showSubMeshesBoundingBox = parsedMesh.showSubMeshesBoundingBox;
        if (parsedMesh.applyFog !== undefined) mesh.applyFog = parsedMesh.applyFog;
        if (parsedMesh.pickable !== undefined) mesh.isPickable = parsedMesh.pickable;
        if (parsedMesh.alphaIndex !== undefined) mesh.alphaIndex = parsedMesh.alphaIndex;
        mesh.receiveShadows = parsedMesh.receiveShadows;
        if (parsedMesh.billboardMode !== undefined) mesh.billboardMode = parsedMesh.billboardMode;
        if (parsedMesh.visibility !== undefined) mesh.visibility = parsedMesh.visibility;
        mesh.checkCollisions = parsedMesh.checkCollisions;
        mesh.doNotSyncBoundingInfo = !!parsedMesh.doNotSyncBoundingInfo;
        if (parsedMesh.ellipsoid) mesh.ellipsoid = (0, $ha1VO.Vector3).FromArray(parsedMesh.ellipsoid);
        if (parsedMesh.ellipsoidOffset) mesh.ellipsoidOffset = (0, $ha1VO.Vector3).FromArray(parsedMesh.ellipsoidOffset);
        // For Backward compatibility ("!=" to exclude null and undefined)
        if (parsedMesh.overrideMaterialSideOrientation != null) mesh.sideOrientation = parsedMesh.overrideMaterialSideOrientation;
        if (parsedMesh.sideOrientation !== undefined) mesh.sideOrientation = parsedMesh.sideOrientation;
        if (parsedMesh.isBlocker !== undefined) mesh.isBlocker = parsedMesh.isBlocker;
        mesh._shouldGenerateFlatShading = parsedMesh.useFlatShading;
        // freezeWorldMatrix
        if (parsedMesh.freezeWorldMatrix) mesh._waitingData.freezeWorldMatrix = parsedMesh.freezeWorldMatrix;
        // Parent
        if (parsedMesh.parentId !== undefined) mesh._waitingParentId = parsedMesh.parentId;
        if (parsedMesh.parentInstanceIndex !== undefined) mesh._waitingParentInstanceIndex = parsedMesh.parentInstanceIndex;
        // Actions
        if (parsedMesh.actions !== undefined) mesh._waitingData.actions = parsedMesh.actions;
        // Overlay
        if (parsedMesh.overlayAlpha !== undefined) mesh.overlayAlpha = parsedMesh.overlayAlpha;
        if (parsedMesh.overlayColor !== undefined) mesh.overlayColor = (0, $7etnY.Color3).FromArray(parsedMesh.overlayColor);
        if (parsedMesh.renderOverlay !== undefined) mesh.renderOverlay = parsedMesh.renderOverlay;
        // Geometry
        mesh.isUnIndexed = !!parsedMesh.isUnIndexed;
        mesh.hasVertexAlpha = parsedMesh.hasVertexAlpha;
        if (parsedMesh.delayLoadingFile) {
            mesh.delayLoadState = 4;
            mesh.delayLoadingFile = rootUrl + parsedMesh.delayLoadingFile;
            mesh.buildBoundingInfo((0, $ha1VO.Vector3).FromArray(parsedMesh.boundingBoxMinimum), (0, $ha1VO.Vector3).FromArray(parsedMesh.boundingBoxMaximum));
            if (parsedMesh._binaryInfo) mesh._binaryInfo = parsedMesh._binaryInfo;
            mesh._delayInfo = [];
            if (parsedMesh.hasUVs) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UVKind);
            if (parsedMesh.hasUVs2) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV2Kind);
            if (parsedMesh.hasUVs3) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV3Kind);
            if (parsedMesh.hasUVs4) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV4Kind);
            if (parsedMesh.hasUVs5) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV5Kind);
            if (parsedMesh.hasUVs6) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV6Kind);
            if (parsedMesh.hasColors) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).ColorKind);
            if (parsedMesh.hasMatricesIndices) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            if (parsedMesh.hasMatricesWeights) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            mesh._delayLoadingFunction = (0, $07dfcf3146d3f600$export$2db6c17465f94a2)._ImportGeometry;
            if ((0, $ec6fcfe568825603$export$6ec0b2ecad265743).ForceFullSceneLoadingForIncremental) mesh._checkDelayState();
        } else (0, $07dfcf3146d3f600$export$2db6c17465f94a2)._ImportGeometry(parsedMesh, mesh);
        // Material
        if (parsedMesh.materialUniqueId) mesh._waitingMaterialId = parsedMesh.materialUniqueId;
        else if (parsedMesh.materialId) mesh._waitingMaterialId = parsedMesh.materialId;
        // Morph targets
        if (parsedMesh.morphTargetManagerId > -1) mesh._waitingMorphTargetManagerId = parsedMesh.morphTargetManagerId;
        // Skeleton
        if (parsedMesh.skeletonId !== undefined && parsedMesh.skeletonId !== null) {
            mesh.skeleton = scene.getLastSkeletonById(parsedMesh.skeletonId);
            if (parsedMesh.numBoneInfluencers) mesh.numBoneInfluencers = parsedMesh.numBoneInfluencers;
        }
        // Animations
        if (parsedMesh.animations) {
            for(let animationIndex = 0; animationIndex < parsedMesh.animations.length; animationIndex++){
                const parsedAnimation = parsedMesh.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) mesh.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $021dcb6a570ae9c1$export$85c928794f8d04d4).ParseAnimationRanges(mesh, parsedMesh, scene);
        }
        if (parsedMesh.autoAnimate) scene.beginAnimation(mesh, parsedMesh.autoAnimateFrom, parsedMesh.autoAnimateTo, parsedMesh.autoAnimateLoop, parsedMesh.autoAnimateSpeed || 1.0);
        // Layer Mask
        if (parsedMesh.layerMask && !isNaN(parsedMesh.layerMask)) mesh.layerMask = Math.abs(parseInt(parsedMesh.layerMask));
        else mesh.layerMask = 0x0fffffff;
        // Physics
        if (parsedMesh.physicsImpostor) mesh.physicsImpostor = $b0df7c384622c537$export$e176487c05830cc5._PhysicsImpostorParser(scene, mesh, parsedMesh);
        // Levels
        if (parsedMesh.lodMeshIds) mesh._waitingData.lods = {
            ids: parsedMesh.lodMeshIds,
            distances: parsedMesh.lodDistances ? parsedMesh.lodDistances : null,
            coverages: parsedMesh.lodCoverages ? parsedMesh.lodCoverages : null
        };
        // Instances
        if (parsedMesh.instances) for(let index = 0; index < parsedMesh.instances.length; index++){
            const parsedInstance = parsedMesh.instances[index];
            const instance = mesh.createInstance(parsedInstance.name);
            if (parsedInstance.id) instance.id = parsedInstance.id;
            if (0, $7212E.Tags) {
                if (parsedInstance.tags) (0, $7212E.Tags).AddTagsTo(instance, parsedInstance.tags);
                else (0, $7212E.Tags).AddTagsTo(instance, parsedMesh.tags);
            }
            instance.position = (0, $ha1VO.Vector3).FromArray(parsedInstance.position);
            if (parsedInstance.metadata !== undefined) instance.metadata = parsedInstance.metadata;
            if (parsedInstance.parentId !== undefined) instance._waitingParentId = parsedInstance.parentId;
            if (parsedInstance.parentInstanceIndex !== undefined) instance._waitingParentInstanceIndex = parsedInstance.parentInstanceIndex;
            if (parsedInstance.isEnabled !== undefined && parsedInstance.isEnabled !== null) instance.setEnabled(parsedInstance.isEnabled);
            if (parsedInstance.isVisible !== undefined && parsedInstance.isVisible !== null) instance.isVisible = parsedInstance.isVisible;
            if (parsedInstance.isPickable !== undefined && parsedInstance.isPickable !== null) instance.isPickable = parsedInstance.isPickable;
            if (parsedInstance.rotationQuaternion) instance.rotationQuaternion = (0, $ha1VO.Quaternion).FromArray(parsedInstance.rotationQuaternion);
            else if (parsedInstance.rotation) instance.rotation = (0, $ha1VO.Vector3).FromArray(parsedInstance.rotation);
            instance.scaling = (0, $ha1VO.Vector3).FromArray(parsedInstance.scaling);
            if (parsedInstance.checkCollisions != undefined && parsedInstance.checkCollisions != null) instance.checkCollisions = parsedInstance.checkCollisions;
            if (parsedInstance.pickable != undefined && parsedInstance.pickable != null) instance.isPickable = parsedInstance.pickable;
            if (parsedInstance.showBoundingBox != undefined && parsedInstance.showBoundingBox != null) instance.showBoundingBox = parsedInstance.showBoundingBox;
            if (parsedInstance.showSubMeshesBoundingBox != undefined && parsedInstance.showSubMeshesBoundingBox != null) instance.showSubMeshesBoundingBox = parsedInstance.showSubMeshesBoundingBox;
            if (parsedInstance.alphaIndex != undefined && parsedInstance.showSubMeshesBoundingBox != null) instance.alphaIndex = parsedInstance.alphaIndex;
            // Physics
            if (parsedInstance.physicsImpostor) instance.physicsImpostor = $b0df7c384622c537$export$e176487c05830cc5._PhysicsImpostorParser(scene, instance, parsedInstance);
            // Actions
            if (parsedInstance.actions !== undefined) instance._waitingData.actions = parsedInstance.actions;
            // Animation
            if (parsedInstance.animations) {
                for(let animationIndex = 0; animationIndex < parsedInstance.animations.length; animationIndex++){
                    const parsedAnimation = parsedInstance.animations[animationIndex];
                    const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                    if (internalClass) instance.animations.push(internalClass.Parse(parsedAnimation));
                }
                (0, $021dcb6a570ae9c1$export$85c928794f8d04d4).ParseAnimationRanges(instance, parsedInstance, scene);
                if (parsedInstance.autoAnimate) scene.beginAnimation(instance, parsedInstance.autoAnimateFrom, parsedInstance.autoAnimateTo, parsedInstance.autoAnimateLoop, parsedInstance.autoAnimateSpeed || 1.0);
            }
        }
        // Thin instances
        if (parsedMesh.thinInstances) {
            const thinInstances = parsedMesh.thinInstances;
            mesh.thinInstanceEnablePicking = !!thinInstances.enablePicking;
            if (thinInstances.matrixData) {
                mesh.thinInstanceSetBuffer("matrix", new Float32Array(thinInstances.matrixData), 16, false);
                mesh._thinInstanceDataStorage.matrixBufferSize = thinInstances.matrixBufferSize;
                mesh._thinInstanceDataStorage.instancesCount = thinInstances.instancesCount;
            } else mesh._thinInstanceDataStorage.matrixBufferSize = thinInstances.matrixBufferSize;
            if (parsedMesh.thinInstances.userThinInstance) {
                const userThinInstance = parsedMesh.thinInstances.userThinInstance;
                for(const kind in userThinInstance.data){
                    mesh.thinInstanceSetBuffer(kind, new Float32Array(userThinInstance.data[kind]), userThinInstance.strides[kind], false);
                    mesh._userThinInstanceBuffersStorage.sizes[kind] = userThinInstance.sizes[kind];
                }
            }
        }
        return mesh;
    }
    // Skeletons
    /**
     * Prepare internal position array for software CPU skinning
     * @returns original positions used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh
     */ setPositionsForCPUSkinning() {
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._sourcePositions) {
            const source = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            if (!source) return internalDataInfo._sourcePositions;
            internalDataInfo._sourcePositions = new Float32Array(source);
            if (!this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind)) this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, source, true);
        }
        return internalDataInfo._sourcePositions;
    }
    /**
     * Prepare internal normal array for software CPU skinning
     * @returns original normals used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh.
     */ setNormalsForCPUSkinning() {
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._sourceNormals) {
            const source = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            if (!source) return internalDataInfo._sourceNormals;
            internalDataInfo._sourceNormals = new Float32Array(source);
            if (!this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).NormalKind)) this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, source, true);
        }
        return internalDataInfo._sourceNormals;
    }
    /**
     * Updates the vertex buffer by applying transformation from the bones
     * @param skeleton defines the skeleton to apply to current mesh
     * @returns the current mesh
     */ applySkeleton(skeleton) {
        if (!this.geometry) return this;
        if (this.geometry._softwareSkinningFrameId == this.getScene().getFrameId()) return this;
        this.geometry._softwareSkinningFrameId = this.getScene().getFrameId();
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) return this;
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) return this;
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) return this;
        const hasNormals = this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind);
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._sourcePositions) {
            const submeshes = this.subMeshes.slice();
            this.setPositionsForCPUSkinning();
            this.subMeshes = submeshes;
        }
        if (hasNormals && !internalDataInfo._sourceNormals) this.setNormalsForCPUSkinning();
        // positionsData checks for not being Float32Array will only pass at most once
        let positionsData = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positionsData) return this;
        if (!(positionsData instanceof Float32Array)) positionsData = new Float32Array(positionsData);
        // normalsData checks for not being Float32Array will only pass at most once
        let normalsData = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        if (hasNormals) {
            if (!normalsData) return this;
            if (!(normalsData instanceof Float32Array)) normalsData = new Float32Array(normalsData);
        }
        const matricesIndicesData = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        const matricesWeightsData = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        if (!matricesWeightsData || !matricesIndicesData) return this;
        const needExtras = this.numBoneInfluencers > 4;
        const matricesIndicesExtraData = needExtras ? this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind) : null;
        const matricesWeightsExtraData = needExtras ? this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind) : null;
        const skeletonMatrices = skeleton.getTransformMatrices(this);
        const tempVector3 = (0, $ha1VO.Vector3).Zero();
        const finalMatrix = new (0, $ha1VO.Matrix)();
        const tempMatrix = new (0, $ha1VO.Matrix)();
        let matWeightIdx = 0;
        let inf;
        for(let index = 0; index < positionsData.length; index += 3, matWeightIdx += 4){
            let weight;
            for(inf = 0; inf < 4; inf++){
                weight = matricesWeightsData[matWeightIdx + inf];
                if (weight > 0) {
                    (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesData[matWeightIdx + inf] * 16), weight, tempMatrix);
                    finalMatrix.addToSelf(tempMatrix);
                }
            }
            if (needExtras) for(inf = 0; inf < 4; inf++){
                weight = matricesWeightsExtraData[matWeightIdx + inf];
                if (weight > 0) {
                    (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesExtraData[matWeightIdx + inf] * 16), weight, tempMatrix);
                    finalMatrix.addToSelf(tempMatrix);
                }
            }
            (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(internalDataInfo._sourcePositions[index], internalDataInfo._sourcePositions[index + 1], internalDataInfo._sourcePositions[index + 2], finalMatrix, tempVector3);
            tempVector3.toArray(positionsData, index);
            if (hasNormals) {
                (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(internalDataInfo._sourceNormals[index], internalDataInfo._sourceNormals[index + 1], internalDataInfo._sourceNormals[index + 2], finalMatrix, tempVector3);
                tempVector3.toArray(normalsData, index);
            }
            finalMatrix.reset();
        }
        this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positionsData);
        if (hasNormals) this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normalsData);
        return this;
    }
    // Tools
    /**
     * Returns an object containing a min and max Vector3 which are the minimum and maximum vectors of each mesh bounding box from the passed array, in the world coordinates
     * @param meshes defines the list of meshes to scan
     * @returns an object `{min:` Vector3`, max:` Vector3`}`
     */ static MinMax(meshes) {
        let minVector = null;
        let maxVector = null;
        meshes.forEach(function(mesh) {
            const boundingInfo = mesh.getBoundingInfo();
            const boundingBox = boundingInfo.boundingBox;
            if (!minVector || !maxVector) {
                minVector = boundingBox.minimumWorld;
                maxVector = boundingBox.maximumWorld;
            } else {
                minVector.minimizeInPlace(boundingBox.minimumWorld);
                maxVector.maximizeInPlace(boundingBox.maximumWorld);
            }
        });
        if (!minVector || !maxVector) return {
            min: (0, $ha1VO.Vector3).Zero(),
            max: (0, $ha1VO.Vector3).Zero()
        };
        return {
            min: minVector,
            max: maxVector
        };
    }
    /**
     * Returns the center of the `{min:` Vector3`, max:` Vector3`}` or the center of MinMax vector3 computed from a mesh array
     * @param meshesOrMinMaxVector could be an array of meshes or a `{min:` Vector3`, max:` Vector3`}` object
     * @returns a vector3
     */ static Center(meshesOrMinMaxVector) {
        const minMaxVector = meshesOrMinMaxVector instanceof Array ? $b0df7c384622c537$export$e176487c05830cc5.MinMax(meshesOrMinMaxVector) : meshesOrMinMaxVector;
        return (0, $ha1VO.Vector3).Center(minMaxVector.min, minMaxVector.max);
    }
    /**
     * Merge the array of meshes into a single mesh for performance reasons.
     * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
     * @param disposeSource when true (default), dispose of the vertices from the source meshes.
     * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
     * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
     * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
     * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
     * @returns a new mesh
     */ static MergeMeshes(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials) {
        return (0, $391b8c7fee050f1f$export$47bff35b05234608)($b0df7c384622c537$export$e176487c05830cc5._MergeMeshesCoroutine(meshes, disposeSource, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, false));
    }
    /**
     * Merge the array of meshes into a single mesh for performance reasons.
     * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
     * @param disposeSource when true (default), dispose of the vertices from the source meshes.
     * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
     * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
     * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
     * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
     * @returns a new mesh
     */ static MergeMeshesAsync(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials) {
        return (0, $391b8c7fee050f1f$export$73fc13c1ca5fca48)($b0df7c384622c537$export$e176487c05830cc5._MergeMeshesCoroutine(meshes, disposeSource, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, true), (0, $391b8c7fee050f1f$export$c074d25b4dc6a454)());
    }
    static *_MergeMeshesCoroutine(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, isAsync) {
        // Remove any null/undefined entries from the mesh array
        meshes = meshes.filter(Boolean);
        if (meshes.length === 0) return null;
        let index;
        if (!allow32BitsIndices) {
            let totalVertices = 0;
            // Counting vertices
            for(index = 0; index < meshes.length; index++){
                totalVertices += meshes[index].getTotalVertices();
                if (totalVertices >= 65536) {
                    (0, $kVtWi.Logger).Warn("Cannot merge meshes because resulting mesh will have more than 65536 vertices. Please use allow32BitsIndices = true to use 32 bits indices");
                    return null;
                }
            }
        }
        if (multiMultiMaterials) subdivideWithSubMeshes = false;
        const materialArray = new Array();
        const materialIndexArray = new Array();
        // Merge
        const indiceArray = new Array();
        const currentsideOrientation = meshes[0].sideOrientation;
        for(index = 0; index < meshes.length; index++){
            const mesh = meshes[index];
            if (mesh.isAnInstance) {
                (0, $kVtWi.Logger).Warn("Cannot merge instance meshes.");
                return null;
            }
            if (currentsideOrientation !== mesh.sideOrientation) {
                (0, $kVtWi.Logger).Warn("Cannot merge meshes with different sideOrientation values.");
                return null;
            }
            if (subdivideWithSubMeshes) indiceArray.push(mesh.getTotalIndices());
            if (multiMultiMaterials) {
                if (mesh.material) {
                    const material = mesh.material;
                    if (material instanceof (0, $29a508bfe7b38d6b$export$4f1842f7cdf61f78)) {
                        for(let matIndex = 0; matIndex < material.subMaterials.length; matIndex++)if (materialArray.indexOf(material.subMaterials[matIndex]) < 0) materialArray.push(material.subMaterials[matIndex]);
                        for(let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++){
                            materialIndexArray.push(materialArray.indexOf(material.subMaterials[mesh.subMeshes[subIndex].materialIndex]));
                            indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                        }
                    } else {
                        if (materialArray.indexOf(material) < 0) materialArray.push(material);
                        for(let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++){
                            materialIndexArray.push(materialArray.indexOf(material));
                            indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                        }
                    }
                } else for(let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++){
                    materialIndexArray.push(0);
                    indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                }
            }
        }
        const source = meshes[0];
        const getVertexDataFromMesh = (mesh)=>{
            const wm = mesh.computeWorldMatrix(true);
            const vertexData = (0, $4014d881db0e9bc6$export$8570d39351855acb).ExtractFromMesh(mesh, false, false);
            return {
                vertexData: vertexData,
                transform: wm
            };
        };
        const { vertexData: sourceVertexData, transform: sourceTransform } = getVertexDataFromMesh(source);
        if (isAsync) yield;
        const meshVertexDatas = new Array(meshes.length - 1);
        for(let i = 1; i < meshes.length; i++){
            meshVertexDatas[i - 1] = getVertexDataFromMesh(meshes[i]);
            if (isAsync) yield;
        }
        const mergeCoroutine = sourceVertexData._mergeCoroutine(sourceTransform, meshVertexDatas, allow32BitsIndices, isAsync, !disposeSource);
        let mergeCoroutineStep = mergeCoroutine.next();
        while(!mergeCoroutineStep.done){
            if (isAsync) yield;
            mergeCoroutineStep = mergeCoroutine.next();
        }
        const vertexData = mergeCoroutineStep.value;
        if (!meshSubclass) meshSubclass = new $b0df7c384622c537$export$e176487c05830cc5(source.name + "_merged", source.getScene());
        const applyToCoroutine = vertexData._applyToCoroutine(meshSubclass, undefined, isAsync);
        let applyToCoroutineStep = applyToCoroutine.next();
        while(!applyToCoroutineStep.done){
            if (isAsync) yield;
            applyToCoroutineStep = applyToCoroutine.next();
        }
        // Setting properties
        meshSubclass.checkCollisions = source.checkCollisions;
        meshSubclass.sideOrientation = source.sideOrientation;
        // Cleaning
        if (disposeSource) for(index = 0; index < meshes.length; index++)meshes[index].dispose();
        // Subdivide
        if (subdivideWithSubMeshes || multiMultiMaterials) {
            //-- removal of global submesh
            meshSubclass.releaseSubMeshes();
            index = 0;
            let offset = 0;
            //-- apply subdivision according to index table
            while(index < indiceArray.length){
                (0, $fc3ab70ba5c9f506$export$c684db7d654df572).CreateFromIndices(0, offset, indiceArray[index], meshSubclass, undefined, false);
                offset += indiceArray[index];
                index++;
            }
            for (const subMesh of meshSubclass.subMeshes)subMesh.refreshBoundingInfo();
            meshSubclass.computeWorldMatrix(true);
        }
        if (multiMultiMaterials) {
            const newMultiMaterial = new (0, $29a508bfe7b38d6b$export$4f1842f7cdf61f78)(source.name + "_merged", source.getScene());
            newMultiMaterial.subMaterials = materialArray;
            for(let subIndex = 0; subIndex < meshSubclass.subMeshes.length; subIndex++)meshSubclass.subMeshes[subIndex].materialIndex = materialIndexArray[subIndex];
            meshSubclass.material = newMultiMaterial;
        } else meshSubclass.material = source.material;
        return meshSubclass;
    }
    /**
     * @internal
     */ addInstance(instance) {
        instance._indexInSourceMeshInstanceArray = this.instances.length;
        this.instances.push(instance);
    }
    /**
     * @internal
     */ removeInstance(instance) {
        // Remove from mesh
        const index = instance._indexInSourceMeshInstanceArray;
        if (index != -1) {
            if (index !== this.instances.length - 1) {
                const last = this.instances[this.instances.length - 1];
                this.instances[index] = last;
                last._indexInSourceMeshInstanceArray = index;
            }
            instance._indexInSourceMeshInstanceArray = -1;
            this.instances.pop();
        }
    }
    /** @internal */ _shouldConvertRHS() {
        return this._scene.useRightHandedSystem && this.sideOrientation === (0, $3afee756ef198914$export$a2d8b23205c25948).CounterClockWiseSideOrientation;
    }
    /** @internal */ _getRenderingFillMode(fillMode) {
        const scene = this.getScene();
        if (scene.forcePointsCloud) return (0, $3afee756ef198914$export$a2d8b23205c25948).PointFillMode;
        if (scene.forceWireframe) return (0, $3afee756ef198914$export$a2d8b23205c25948).WireFrameFillMode;
        return this.overrideRenderingFillMode ?? fillMode;
    }
    // deprecated methods
    /**
     * Sets the mesh material by the material or multiMaterial `id` property
     * @param id is a string identifying the material or the multiMaterial
     * @returns the current mesh
     * @deprecated Please use MeshBuilder instead Please use setMaterialById instead
     */ setMaterialByID(id) {
        return this.setMaterialById(id);
    }
    /**
     * Creates a ribbon mesh.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @param name defines the name of the mesh to create
     * @param pathArray is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry.
     * @param closeArray creates a seam between the first and the last paths of the path array (default is false)
     * @param closePath creates a seam between the first and the last points of each path of the path array
     * @param offset is taken in account only if the `pathArray` is containing a single path
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance defines an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#ribbon)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateRibbon(name, pathArray, closeArray, closePath, offset, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a plane polygonal mesh.  By default, this is a disc.
     * @param name defines the name of the mesh to create
     * @param radius sets the radius size (float) of the polygon (default 0.5)
     * @param tessellation sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateDisc(name, radius, tessellation, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a box mesh.
     * @param name defines the name of the mesh to create
     * @param size sets the size (float) of each box side (default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateBox(name, size, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a sphere mesh.
     * @param name defines the name of the mesh to create
     * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
     * @param diameter sets the diameter size (float) of the sphere (default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateSphere(name, segments, diameter, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a hemisphere mesh.
     * @param name defines the name of the mesh to create
     * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
     * @param diameter sets the diameter size (float) of the sphere (default 1)
     * @param scene defines the hosting scene
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateHemisphere(name, segments, diameter, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a cylinder or a cone mesh.
     * @param name defines the name of the mesh to create
     * @param height sets the height size (float) of the cylinder/cone (float, default 2)
     * @param diameterTop set the top cap diameter (floats, default 1)
     * @param diameterBottom set the bottom cap diameter (floats, default 1). This value can't be zero
     * @param tessellation sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance
     * @param subdivisions sets the number of rings along the cylinder height (positive integer, default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateCylinder(name, height, diameterTop, diameterBottom, tessellation, subdivisions, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    // Torus  (Code from SharpDX.org)
    /**
     * Creates a torus mesh.
     * @param name defines the name of the mesh to create
     * @param diameter sets the diameter size (float) of the torus (default 1)
     * @param thickness sets the diameter size of the tube of the torus (float, default 0.5)
     * @param tessellation sets the number of torus sides (positive integer, default 16)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTorus(name, diameter, thickness, tessellation, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a torus knot mesh.
     * @param name defines the name of the mesh to create
     * @param radius sets the global radius size (float) of the torus knot (default 2)
     * @param tube sets the diameter size of the tube of the torus (float, default 0.5)
     * @param radialSegments sets the number of sides on each tube segments (positive integer, default 32)
     * @param tubularSegments sets the number of tubes to decompose the knot into (positive integer, default 32)
     * @param p the number of windings on X axis (positive integers, default 2)
     * @param q the number of windings on Y axis (positive integers, default 3)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTorusKnot(name, radius, tube, radialSegments, tubularSegments, p, q, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a line mesh..
     * @param name defines the name of the mesh to create
     * @param points is an array successive Vector3
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines).
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateLines(name, points, scene, updatable, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a dashed line mesh.
     * @param name defines the name of the mesh to create
     * @param points is an array successive Vector3
     * @param dashSize is the size of the dashes relatively the dash number (positive float, default 3)
     * @param gapSize is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
     * @param dashNb is the intended total number of dashes (positive integer, default 200)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateDashedLines(name, points, dashSize, gapSize, dashNb, scene, updatable, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a polygon mesh.Please consider using the same method from the MeshBuilder class instead
     * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh.
     * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors.
     * You can set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * Remember you can only change the shape positions, not their number when updating a polygon.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#non-regular-polygon
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
     * @param scene defines the hosting scene
     * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreatePolygon(name, shape, scene, holes, updatable, sideOrientation, earcutInjection) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates an extruded polygon mesh, with depth in the Y direction..
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-non-regular-polygon
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
     * @param depth defines the height of extrusion
     * @param scene defines the hosting scene
     * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static ExtrudePolygon(name, shape, depth, scene, holes, updatable, sideOrientation, earcutInjection) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates an extruded shape mesh.
     * The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
     * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
     * @param scale is the value to scale the shape
     * @param rotation is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve
     * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#extruded-shape)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static ExtrudeShape(name, shape, path, scale, rotation, cap, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates an custom extruded shape mesh.
     * The custom extrusion is a parametric shape.
     * It has no predefined shape. Its final shape will depend on the input parameters.
     *
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
     * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
     * @param scaleFunction is a custom Javascript function called on each path point
     * @param rotationFunction is a custom Javascript function called on each path point
     * @param ribbonCloseArray forces the extrusion underlying ribbon to close all the paths in its `pathArray`
     * @param ribbonClosePath forces the extrusion underlying ribbon to close its `pathArray`
     * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#extruded-shape)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static ExtrudeShapeCustom(name, shape, path, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates lathe mesh.
     * The lathe is a shape with a symmetry axis : a 2D model shape is rotated around this axis to design the lathe.
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
     * @param radius is the radius value of the lathe
     * @param tessellation is the side number of the lathe.
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateLathe(name, shape, radius, tessellation, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a plane mesh.
     * @param name defines the name of the mesh to create
     * @param size sets the size (float) of both sides of the plane at once (default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreatePlane(name, size, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a ground mesh.
     * @param name defines the name of the mesh to create
     * @param width set the width of the ground
     * @param height set the height of the ground
     * @param subdivisions sets the number of subdivisions per side
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateGround(name, width, height, subdivisions, scene, updatable) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a tiled ground mesh.
     * @param name defines the name of the mesh to create
     * @param xmin set the ground minimum X coordinate
     * @param zmin set the ground minimum Y coordinate
     * @param xmax set the ground maximum X coordinate
     * @param zmax set the ground maximum Z coordinate
     * @param subdivisions is an object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
     * @param precision is an object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTiledGround(name, xmin, zmin, xmax, zmax, subdivisions, precision, scene, updatable) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a ground mesh from a height map.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/height_map
     * @param name defines the name of the mesh to create
     * @param url sets the URL of the height map image resource
     * @param width set the ground width size
     * @param height set the ground height size
     * @param subdivisions sets the number of subdivision per side
     * @param minHeight is the minimum altitude on the ground
     * @param maxHeight is the maximum altitude on the ground
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param onReady  is a callback function that will be called  once the mesh is built (the height map download can last some time)
     * @param alphaFilter will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateGroundFromHeightMap(name, url, width, height, subdivisions, minHeight, maxHeight, scene, updatable, onReady, alphaFilter) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a tube mesh.
     * The tube is a parametric shape.
     * It has no predefined shape. Its final shape will depend on the input parameters.
     *
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @param name defines the name of the mesh to create
     * @param path is a required array of successive Vector3. It is the curve used as the axis of the tube
     * @param radius sets the tube radius size
     * @param tessellation is the number of sides on the tubular surface
     * @param radiusFunction is a custom function. If it is not null, it overrides the parameter `radius`. This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path
     * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance is an instance of an existing Tube object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#tube)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTube(name, path, radius, tessellation, radiusFunction, cap, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a polyhedron mesh.
     *.
     * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embedded types. Please refer to the type sheet in the tutorial to choose the wanted type
     * * The parameter `size` (positive float, default 1) sets the polygon size
     * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
     * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overwrittes the parameter `type`
     * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
     * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
     * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
     * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
     * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh to create
     * @param options defines the options used to create the mesh
     * @param scene defines the hosting scene
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreatePolyhedron(name, options, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
     * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
     * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value than `radius`)
     * * The parameter `subdivisions` sets the number of subdivisions (positive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
     * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
     * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra#icosphere
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param scene defines the hosting scene
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateIcoSphere(name, options, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a decal mesh.
     *.
     * A decal is a mesh usually applied as a model onto the surface of another mesh
     * @param name  defines the name of the mesh
     * @param sourceMesh defines the mesh receiving the decal
     * @param position sets the position of the decal in world coordinates
     * @param normal sets the normal of the mesh where the decal is applied onto in world coordinates
     * @param size sets the decal scaling
     * @param angle sets the angle to rotate the decal
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateDecal(name, sourceMesh, position, normal, size, angle) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /** Creates a Capsule Mesh
     * @param name defines the name of the mesh.
     * @param options the constructors options used to shape the mesh.
     * @param scene defines the scene the mesh is scoped to.
     * @returns the capsule mesh
     * @see https://doc.babylonjs.com/how_to/capsule_shape
     * @deprecated Please use MeshBuilder instead
     */ static CreateCapsule(name, options, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Extends a mesh to a Goldberg mesh
     * Warning  the mesh to convert MUST be an import of a perviously exported Goldberg mesh
     * @param mesh the mesh to convert
     * @returns the extended mesh
     * @deprecated Please use ExtendMeshToGoldberg instead
     */ static ExtendToGoldberg(mesh) {
        throw new Error("Import MeshBuilder to populate this function");
    }
}
// Consts
/**
 * Mesh side orientation : usually the external or front surface
 */ $b0df7c384622c537$export$e176487c05830cc5.FRONTSIDE = (0, $4014d881db0e9bc6$export$8570d39351855acb).FRONTSIDE;
/**
 * Mesh side orientation : usually the internal or back surface
 */ $b0df7c384622c537$export$e176487c05830cc5.BACKSIDE = (0, $4014d881db0e9bc6$export$8570d39351855acb).BACKSIDE;
/**
 * Mesh side orientation : both internal and external or front and back surfaces
 */ $b0df7c384622c537$export$e176487c05830cc5.DOUBLESIDE = (0, $4014d881db0e9bc6$export$8570d39351855acb).DOUBLESIDE;
/**
 * Mesh side orientation : by default, `FRONTSIDE`
 */ $b0df7c384622c537$export$e176487c05830cc5.DEFAULTSIDE = (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
/**
 * Mesh cap setting : no cap
 */ $b0df7c384622c537$export$e176487c05830cc5.NO_CAP = 0;
/**
 * Mesh cap setting : one cap at the beginning of the mesh
 */ $b0df7c384622c537$export$e176487c05830cc5.CAP_START = 1;
/**
 * Mesh cap setting : one cap at the end of the mesh
 */ $b0df7c384622c537$export$e176487c05830cc5.CAP_END = 2;
/**
 * Mesh cap setting : two caps, one at the beginning  and one at the end of the mesh
 */ $b0df7c384622c537$export$e176487c05830cc5.CAP_ALL = 3;
/**
 * Mesh pattern setting : no flip or rotate
 */ $b0df7c384622c537$export$e176487c05830cc5.NO_FLIP = 0;
/**
 * Mesh pattern setting : flip (reflect in y axis) alternate tiles on each row or column
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_TILE = 1;
/**
 * Mesh pattern setting : rotate (180degs) alternate tiles on each row or column
 */ $b0df7c384622c537$export$e176487c05830cc5.ROTATE_TILE = 2;
/**
 * Mesh pattern setting : flip (reflect in y axis) all tiles on alternate rows
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_ROW = 3;
/**
 * Mesh pattern setting : rotate (180degs) all tiles on alternate rows
 */ $b0df7c384622c537$export$e176487c05830cc5.ROTATE_ROW = 4;
/**
 * Mesh pattern setting : flip and rotate alternate tiles on each row or column
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_N_ROTATE_TILE = 5;
/**
 * Mesh pattern setting : rotate pattern and rotate
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_N_ROTATE_ROW = 6;
/**
 * Mesh tile positioning : part tiles same on left/right or top/bottom
 */ $b0df7c384622c537$export$e176487c05830cc5.CENTER = 0;
/**
 * Mesh tile positioning : part tiles on left
 */ $b0df7c384622c537$export$e176487c05830cc5.LEFT = 1;
/**
 * Mesh tile positioning : part tiles on right
 */ $b0df7c384622c537$export$e176487c05830cc5.RIGHT = 2;
/**
 * Mesh tile positioning : part tiles on top
 */ $b0df7c384622c537$export$e176487c05830cc5.TOP = 3;
/**
 * Mesh tile positioning : part tiles on bottom
 */ $b0df7c384622c537$export$e176487c05830cc5.BOTTOM = 4;
/**
 * Indicates that the instanced meshes should be sorted from back to front before rendering if their material is transparent
 */ $b0df7c384622c537$export$e176487c05830cc5.INSTANCEDMESH_SORT_TRANSPARENT = false;
// Statics
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GroundMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GroundMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GoldbergMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GoldbergMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._LinesMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("LinesMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GreasedLineMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GreasedLineMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GreasedLineRibbonMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GreasedLineRibbonMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._TrailMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("TrailMesh");
};
(0, $8DoUR.RegisterClass)("BABYLON.Mesh", $b0df7c384622c537$export$e176487c05830cc5);



var $b4i1f = parcelRequire("b4i1f");


var $fGXjI = parcelRequire("fGXjI");
function $7c39a49659d9e77f$export$8bfbd062631af8b2(options) {
    let pathArray = options.pathArray;
    const closeArray = options.closeArray || false;
    const closePath = options.closePath || false;
    const invertUV = options.invertUV || false;
    const defaultOffset = Math.floor(pathArray[0].length / 2);
    let offset = options.offset || defaultOffset;
    offset = offset > defaultOffset ? defaultOffset : Math.floor(offset); // offset max allowed : defaultOffset
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const customUV = options.uvs;
    const customColors = options.colors;
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    const us = []; // us[path_id] = [uDist1, uDist2, uDist3 ... ] distances between points on path path_id
    const vs = []; // vs[i] = [vDist1, vDist2, vDist3, ... ] distances between points i of consecutive paths from pathArray
    const uTotalDistance = []; // uTotalDistance[p] : total distance of path p
    const vTotalDistance = []; //  vTotalDistance[i] : total distance between points i of first and last path from pathArray
    let minlg; // minimal length among all paths from pathArray
    const lg = []; // array of path lengths : nb of vertex per path
    const idx = []; // array of path indexes : index of each path (first vertex) in the total vertex number
    let p; // path iterator
    let i; // point iterator
    let j; // point iterator
    // if single path in pathArray
    if (pathArray.length < 2) {
        const ar1 = [];
        const ar2 = [];
        for(i = 0; i < pathArray[0].length - offset; i++){
            ar1.push(pathArray[0][i]);
            ar2.push(pathArray[0][i + offset]);
        }
        pathArray = [
            ar1,
            ar2
        ];
    }
    // positions and horizontal distances (u)
    let idc = 0;
    const closePathCorr = closePath ? 1 : 0; // the final index will be +1 if closePath
    const closeArrayCorr = closeArray ? 1 : 0;
    let path;
    let l;
    minlg = pathArray[0].length;
    let vectlg;
    let dist;
    for(p = 0; p < pathArray.length + closeArrayCorr; p++){
        uTotalDistance[p] = 0;
        us[p] = [
            0
        ];
        path = p === pathArray.length ? pathArray[0] : pathArray[p];
        l = path.length;
        minlg = minlg < l ? minlg : l;
        j = 0;
        while(j < l){
            positions.push(path[j].x, path[j].y, path[j].z);
            if (j > 0) {
                vectlg = path[j].subtract(path[j - 1]).length();
                dist = vectlg + uTotalDistance[p];
                us[p].push(dist);
                uTotalDistance[p] = dist;
            }
            j++;
        }
        if (closePath) {
            // an extra hidden vertex is added in the "positions" array
            j--;
            positions.push(path[0].x, path[0].y, path[0].z);
            vectlg = path[j].subtract(path[0]).length();
            dist = vectlg + uTotalDistance[p];
            us[p].push(dist);
            uTotalDistance[p] = dist;
        }
        lg[p] = l + closePathCorr;
        idx[p] = idc;
        idc += l + closePathCorr;
    }
    // vertical distances (v)
    let path1;
    let path2;
    let vertex1 = null;
    let vertex2 = null;
    for(i = 0; i < minlg + closePathCorr; i++){
        vTotalDistance[i] = 0;
        vs[i] = [
            0
        ];
        for(p = 0; p < pathArray.length - 1 + closeArrayCorr; p++){
            path1 = pathArray[p];
            path2 = p === pathArray.length - 1 ? pathArray[0] : pathArray[p + 1];
            if (i === minlg) {
                // closePath
                vertex1 = path1[0];
                vertex2 = path2[0];
            } else {
                vertex1 = path1[i];
                vertex2 = path2[i];
            }
            vectlg = vertex2.subtract(vertex1).length();
            dist = vectlg + vTotalDistance[i];
            vs[i].push(dist);
            vTotalDistance[i] = dist;
        }
    }
    // uvs
    let u;
    let v;
    if (customUV) for(p = 0; p < customUV.length; p++)uvs.push(customUV[p].x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - customUV[p].y : customUV[p].y);
    else {
        for(p = 0; p < pathArray.length + closeArrayCorr; p++)for(i = 0; i < minlg + closePathCorr; i++){
            u = uTotalDistance[p] != 0.0 ? us[p][i] / uTotalDistance[p] : 0.0;
            v = vTotalDistance[i] != 0.0 ? vs[i][p] / vTotalDistance[i] : 0.0;
            if (invertUV) uvs.push(v, u);
            else uvs.push(u, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - v : v);
        }
    }
    // indices
    p = 0; // path index
    let pi = 0; // positions array index
    let l1 = lg[p] - 1; // path1 length
    let l2 = lg[p + 1] - 1; // path2 length
    let min = l1 < l2 ? l1 : l2; // current path stop index
    let shft = idx[1] - idx[0]; // shift
    const path1nb = lg.length - 1; // number of path1 to iterate on
    while(pi <= min && p < path1nb){
        //  stay under min and don't go over next to last path
        // draw two triangles between path1 (p1) and path2 (p2) : (p1.pi, p2.pi, p1.pi+1) and (p2.pi+1, p1.pi+1, p2.pi) clockwise
        indices.push(pi, pi + shft, pi + 1);
        indices.push(pi + shft + 1, pi + 1, pi + shft);
        pi += 1;
        if (pi === min) {
            // if end of one of two consecutive paths reached, go to next existing path
            p++;
            shft = idx[p + 1] - idx[p];
            l1 = lg[p] - 1;
            l2 = lg[p + 1] - 1;
            pi = idx[p];
            min = l1 < l2 ? l1 + pi : l2 + pi;
        }
    }
    // normals
    (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
    if (closePath) {
        // update both the first and last vertex normals to their average value
        let indexFirst = 0;
        let indexLast = 0;
        for(p = 0; p < pathArray.length; p++){
            indexFirst = idx[p] * 3;
            if (p + 1 < pathArray.length) indexLast = (idx[p + 1] - 1) * 3;
            else indexLast = normals.length - 3;
            normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
            normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
            normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
            const l = Math.sqrt(normals[indexFirst] * normals[indexFirst] + normals[indexFirst + 1] * normals[indexFirst + 1] + normals[indexFirst + 2] * normals[indexFirst + 2]);
            normals[indexFirst] /= l;
            normals[indexFirst + 1] /= l;
            normals[indexFirst + 2] /= l;
            normals[indexLast] = normals[indexFirst];
            normals[indexLast + 1] = normals[indexFirst + 1];
            normals[indexLast + 2] = normals[indexFirst + 2];
        }
    }
    if (closeArray) {
        let indexFirst = idx[0] * 3;
        let indexLast = idx[pathArray.length] * 3;
        for(i = 0; i < minlg + closePathCorr; i++){
            normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
            normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
            normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
            const l = Math.sqrt(normals[indexFirst] * normals[indexFirst] + normals[indexFirst + 1] * normals[indexFirst + 1] + normals[indexFirst + 2] * normals[indexFirst + 2]);
            normals[indexFirst] /= l;
            normals[indexFirst + 1] /= l;
            normals[indexFirst + 2] /= l;
            normals[indexLast] = normals[indexFirst];
            normals[indexLast + 1] = normals[indexFirst + 1];
            normals[indexLast + 2] = normals[indexFirst + 2];
            indexFirst += 3;
            indexLast += 3;
        }
    }
    // sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Colors
    let colors = null;
    if (customColors) {
        colors = new Float32Array(customColors.length * 4);
        for(let c = 0; c < customColors.length; c++){
            colors[c * 4] = customColors[c].r;
            colors[c * 4 + 1] = customColors[c].g;
            colors[c * 4 + 2] = customColors[c].b;
            colors[c * 4 + 3] = customColors[c].a;
        }
    }
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    const positions32 = new Float32Array(positions);
    const normals32 = new Float32Array(normals);
    const uvs32 = new Float32Array(uvs);
    vertexData.indices = indices;
    vertexData.positions = positions32;
    vertexData.normals = normals32;
    vertexData.uvs = uvs32;
    if (colors) vertexData.set(colors, (0, $b4i1f.VertexBuffer).ColorKind);
    if (closePath) vertexData._idx = idx;
    return vertexData;
}
function $7c39a49659d9e77f$export$821dd8d5c9753978(name, options, scene = null) {
    const pathArray = options.pathArray;
    const closeArray = options.closeArray;
    const closePath = options.closePath;
    const sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    const instance = options.instance;
    const updatable = options.updatable;
    if (instance) {
        // existing ribbon instance update
        // positionFunction : ribbon case
        // only pathArray and sideOrientation parameters are taken into account for positions update
        const minimum = (0, $ha1VO.TmpVectors).Vector3[0].setAll(Number.MAX_VALUE);
        const maximum = (0, $ha1VO.TmpVectors).Vector3[1].setAll(-Number.MAX_VALUE);
        const positionFunction = (positions)=>{
            let minlg = pathArray[0].length;
            const mesh = instance;
            let i = 0;
            const ns = mesh._originalBuilderSideOrientation === (0, $b0df7c384622c537$export$e176487c05830cc5).DOUBLESIDE ? 2 : 1;
            for(let si = 1; si <= ns; ++si)for(let p = 0; p < pathArray.length; ++p){
                const path = pathArray[p];
                const l = path.length;
                minlg = minlg < l ? minlg : l;
                for(let j = 0; j < minlg; ++j){
                    const pathPoint = path[j];
                    positions[i] = pathPoint.x;
                    positions[i + 1] = pathPoint.y;
                    positions[i + 2] = pathPoint.z;
                    minimum.minimizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                    maximum.maximizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                    i += 3;
                }
                if (mesh._creationDataStorage && mesh._creationDataStorage.closePath) {
                    const pathPoint = path[0];
                    positions[i] = pathPoint.x;
                    positions[i + 1] = pathPoint.y;
                    positions[i + 2] = pathPoint.z;
                    i += 3;
                }
            }
        };
        const positions = instance.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        positionFunction(positions);
        if (instance.hasBoundingInfo) instance.getBoundingInfo().reConstruct(minimum, maximum, instance._worldMatrix);
        else instance.buildBoundingInfo(minimum, maximum, instance._worldMatrix);
        instance.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, false, false);
        if (options.colors) {
            const colors = instance.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
            for(let c = 0, colorIndex = 0; c < options.colors.length; c++, colorIndex += 4){
                const color = options.colors[c];
                colors[colorIndex] = color.r;
                colors[colorIndex + 1] = color.g;
                colors[colorIndex + 2] = color.b;
                colors[colorIndex + 3] = color.a;
            }
            instance.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, colors, false, false);
        }
        if (options.uvs) {
            const uvs = instance.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
            for(let i = 0; i < options.uvs.length; i++){
                uvs[i * 2] = options.uvs[i].x;
                uvs[i * 2 + 1] = (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - options.uvs[i].y : options.uvs[i].y;
            }
            instance.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvs, false, false);
        }
        if (!instance.areNormalsFrozen || instance.isFacetDataEnabled) {
            const indices = instance.getIndices();
            const normals = instance.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            const params = instance.isFacetDataEnabled ? instance.getFacetDataParameters() : null;
            (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals, params);
            if (instance._creationDataStorage && instance._creationDataStorage.closePath) {
                let indexFirst = 0;
                let indexLast = 0;
                for(let p = 0; p < pathArray.length; p++){
                    indexFirst = instance._creationDataStorage.idx[p] * 3;
                    if (p + 1 < pathArray.length) indexLast = (instance._creationDataStorage.idx[p + 1] - 1) * 3;
                    else indexLast = normals.length - 3;
                    normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                    normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                    normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                    normals[indexLast] = normals[indexFirst];
                    normals[indexLast + 1] = normals[indexFirst + 1];
                    normals[indexLast + 2] = normals[indexFirst + 2];
                }
            }
            if (!instance.areNormalsFrozen) instance.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, false, false);
        }
        return instance;
    } else {
        // new ribbon creation
        const ribbon = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
        ribbon._originalBuilderSideOrientation = sideOrientation;
        ribbon._creationDataStorage = new (0, $b0df7c384622c537$export$40270a8f3a8ca785)();
        const vertexData = $7c39a49659d9e77f$export$8bfbd062631af8b2(options);
        if (closePath) ribbon._creationDataStorage.idx = vertexData._idx;
        ribbon._creationDataStorage.closePath = closePath;
        ribbon._creationDataStorage.closeArray = closeArray;
        vertexData.applyToMesh(ribbon, updatable);
        return ribbon;
    }
}
const $7c39a49659d9e77f$export$17914ccb395fb032 = {
    CreateRibbon: // eslint-disable-next-line @typescript-eslint/naming-convention
    $7c39a49659d9e77f$export$821dd8d5c9753978
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateRibbon = $7c39a49659d9e77f$export$8bfbd062631af8b2;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateRibbon = (name, pathArray, closeArray = false, closePath, offset, scene, updatable = false, sideOrientation, instance)=>{
    return $7c39a49659d9e77f$export$821dd8d5c9753978(name, {
        pathArray: pathArray,
        closeArray: closeArray,
        closePath: closePath,
        offset: offset,
        updatable: updatable,
        sideOrientation: sideOrientation,
        instance: instance
    }, scene);
};





var $fGXjI = parcelRequire("fGXjI");
function $b9c1e5d353ae02eb$export$22f9ddef46ce85f7(options) {
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    const radius = options.radius || 0.5;
    const tessellation = options.tessellation || 64;
    const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    // positions and uvs
    positions.push(0, 0, 0); // disc center first
    uvs.push(0.5, 0.5);
    const theta = Math.PI * 2 * arc;
    const step = arc === 1 ? theta / tessellation : theta / (tessellation - 1);
    let a = 0;
    for(let t = 0; t < tessellation; t++){
        const x = Math.cos(a);
        const y = Math.sin(a);
        const u = (x + 1) / 2;
        const v = (1 - y) / 2;
        positions.push(radius * x, radius * y, 0);
        uvs.push(u, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
        a += step;
    }
    if (arc === 1) {
        positions.push(positions[3], positions[4], positions[5]); // close the circle
        uvs.push(uvs[2], (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - uvs[3] : uvs[3]);
    }
    //indices
    const vertexNb = positions.length / 3;
    for(let i = 1; i < vertexNb - 1; i++)indices.push(i + 1, 0, i);
    // result
    (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f(name, options = {}, scene = null) {
    const disc = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    disc._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $b9c1e5d353ae02eb$export$22f9ddef46ce85f7(options);
    vertexData.applyToMesh(disc, options.updatable);
    return disc;
}
const $b9c1e5d353ae02eb$export$ea7bd162c220cdb3 = {
    CreateDisc: // eslint-disable-next-line @typescript-eslint/naming-convention
    $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateDisc = $b9c1e5d353ae02eb$export$22f9ddef46ce85f7;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateDisc = (name, radius, tessellation, scene = null, updatable, sideOrientation)=>{
    const options = {
        radius: radius,
        tessellation: tessellation,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");



var $fGXjI = parcelRequire("fGXjI");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");



var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

(0, $b0df7c384622c537$export$e176487c05830cc5)._GroundMeshParser = (parsedMesh, scene)=>{
    return $0e050fa3c8fa4c95$export$c798fdfefb9e9068.Parse(parsedMesh, scene);
};
class $0e050fa3c8fa4c95$export$c798fdfefb9e9068 extends (0, $b0df7c384622c537$export$e176487c05830cc5) {
    constructor(name, scene){
        super(name, scene);
        /** If octree should be generated */ this.generateOctree = false;
    }
    /**
     * "GroundMesh"
     * @returns "GroundMesh"
     */ getClassName() {
        return "GroundMesh";
    }
    /**
     * The minimum of x and y subdivisions
     */ get subdivisions() {
        return Math.min(this._subdivisionsX, this._subdivisionsY);
    }
    /**
     * X subdivisions
     */ get subdivisionsX() {
        return this._subdivisionsX;
    }
    /**
     * Y subdivisions
     */ get subdivisionsY() {
        return this._subdivisionsY;
    }
    /**
     * This function will divide the mesh into submeshes and update an octree to help to select the right submeshes
     * for rendering, picking and collision computations. Please note that you must have a decent number of submeshes
     * to get performance improvements when using an octree.
     * @param chunksCount the number of submeshes the mesh will be divided into
     * @param octreeBlocksSize the maximum size of the octree blocks (Default: 32)
     */ optimize(chunksCount, octreeBlocksSize = 32) {
        this._subdivisionsX = chunksCount;
        this._subdivisionsY = chunksCount;
        this.subdivide(chunksCount);
        // Call the octree system optimization if it is defined.
        const thisAsAny = this;
        if (thisAsAny.createOrUpdateSubmeshesOctree) thisAsAny.createOrUpdateSubmeshesOctree(octreeBlocksSize);
    }
    /**
     * Returns a height (y) value in the World system :
     * the ground altitude at the coordinates (x, z) expressed in the World system.
     * @param x x coordinate
     * @param z z coordinate
     * @returns the ground y position if (x, z) are outside the ground surface.
     */ getHeightAtCoordinates(x, z) {
        const world = this.getWorldMatrix();
        const invMat = (0, $ha1VO.TmpVectors).Matrix[5];
        world.invertToRef(invMat);
        const tmpVect = (0, $ha1VO.TmpVectors).Vector3[8];
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, 0.0, z, invMat, tmpVect); // transform x,z in the mesh local space
        x = tmpVect.x;
        z = tmpVect.z;
        if (x < this._minX || x >= this._maxX || z <= this._minZ || z > this._maxZ) return this.position.y;
        if (!this._heightQuads || this._heightQuads.length == 0) {
            this._initHeightQuads();
            this._computeHeightQuads();
        }
        const facet = this._getFacetAt(x, z);
        const y = -(facet.x * x + facet.z * z + facet.w) / facet.y;
        // return y in the World system
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(0.0, y, 0.0, world, tmpVect);
        return tmpVect.y;
    }
    /**
     * Returns a normalized vector (Vector3) orthogonal to the ground
     * at the ground coordinates (x, z) expressed in the World system.
     * @param x x coordinate
     * @param z z coordinate
     * @returns Vector3(0.0, 1.0, 0.0) if (x, z) are outside the ground surface.
     */ getNormalAtCoordinates(x, z) {
        const normal = new (0, $ha1VO.Vector3)(0.0, 1.0, 0.0);
        this.getNormalAtCoordinatesToRef(x, z, normal);
        return normal;
    }
    /**
     * Updates the Vector3 passed a reference with a normalized vector orthogonal to the ground
     * at the ground coordinates (x, z) expressed in the World system.
     * Doesn't update the reference Vector3 if (x, z) are outside the ground surface.
     * @param x x coordinate
     * @param z z coordinate
     * @param ref vector to store the result
     * @returns the GroundMesh.
     */ getNormalAtCoordinatesToRef(x, z, ref) {
        const world = this.getWorldMatrix();
        const tmpMat = (0, $ha1VO.TmpVectors).Matrix[5];
        world.invertToRef(tmpMat);
        const tmpVect = (0, $ha1VO.TmpVectors).Vector3[8];
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, 0.0, z, tmpMat, tmpVect); // transform x,z in the mesh local space
        x = tmpVect.x;
        z = tmpVect.z;
        if (x < this._minX || x > this._maxX || z < this._minZ || z > this._maxZ) return this;
        if (!this._heightQuads || this._heightQuads.length == 0) {
            this._initHeightQuads();
            this._computeHeightQuads();
        }
        const facet = this._getFacetAt(x, z);
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(facet.x, facet.y, facet.z, world, ref);
        return this;
    }
    /**
     * Force the heights to be recomputed for getHeightAtCoordinates() or getNormalAtCoordinates()
     * if the ground has been updated.
     * This can be used in the render loop.
     * @returns the GroundMesh.
     */ updateCoordinateHeights() {
        if (!this._heightQuads || this._heightQuads.length == 0) this._initHeightQuads();
        this._computeHeightQuads();
        return this;
    }
    // Returns the element "facet" from the heightQuads array relative to (x, z) local coordinates
    _getFacetAt(x, z) {
        // retrieve col and row from x, z coordinates in the ground local system
        const col = Math.floor((x + this._maxX) * this._subdivisionsX / this._width);
        const row = Math.floor(-(z + this._maxZ) * this._subdivisionsY / this._height + this._subdivisionsY);
        const quad = this._heightQuads[row * this._subdivisionsX + col];
        let facet;
        if (z < quad.slope.x * x + quad.slope.y) facet = quad.facet1;
        else facet = quad.facet2;
        return facet;
    }
    //  Creates and populates the heightMap array with "facet" elements :
    // a quad is two triangular facets separated by a slope, so a "facet" element is 1 slope + 2 facets
    // slope : Vector2(c, h) = 2D diagonal line equation setting apart two triangular facets in a quad : z = cx + h
    // facet1 : Vector4(a, b, c, d) = first facet 3D plane equation : ax + by + cz + d = 0
    // facet2 :  Vector4(a, b, c, d) = second facet 3D plane equation : ax + by + cz + d = 0
    // Returns the GroundMesh.
    _initHeightQuads() {
        const subdivisionsX = this._subdivisionsX;
        const subdivisionsY = this._subdivisionsY;
        this._heightQuads = new Array();
        for(let row = 0; row < subdivisionsY; row++)for(let col = 0; col < subdivisionsX; col++){
            const quad = {
                slope: (0, $ha1VO.Vector2).Zero(),
                facet1: new (0, $ha1VO.Vector4)(0.0, 0.0, 0.0, 0.0),
                facet2: new (0, $ha1VO.Vector4)(0.0, 0.0, 0.0, 0.0)
            };
            this._heightQuads[row * subdivisionsX + col] = quad;
        }
        return this;
    }
    // Compute each quad element values and update the heightMap array :
    // slope : Vector2(c, h) = 2D diagonal line equation setting apart two triangular facets in a quad : z = cx + h
    // facet1 : Vector4(a, b, c, d) = first facet 3D plane equation : ax + by + cz + d = 0
    // facet2 :  Vector4(a, b, c, d) = second facet 3D plane equation : ax + by + cz + d = 0
    // Returns the GroundMesh.
    _computeHeightQuads() {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positions) return this;
        const v1 = (0, $ha1VO.TmpVectors).Vector3[3];
        const v2 = (0, $ha1VO.TmpVectors).Vector3[2];
        const v3 = (0, $ha1VO.TmpVectors).Vector3[1];
        const v4 = (0, $ha1VO.TmpVectors).Vector3[0];
        const v1v2 = (0, $ha1VO.TmpVectors).Vector3[4];
        const v1v3 = (0, $ha1VO.TmpVectors).Vector3[5];
        const v1v4 = (0, $ha1VO.TmpVectors).Vector3[6];
        const norm1 = (0, $ha1VO.TmpVectors).Vector3[7];
        const norm2 = (0, $ha1VO.TmpVectors).Vector3[8];
        let i = 0;
        let j = 0;
        let k = 0;
        let cd = 0; // 2D slope coefficient : z = cd * x + h
        let h = 0;
        let d1 = 0; // facet plane equation : ax + by + cz + d = 0
        let d2 = 0;
        const subdivisionsX = this._subdivisionsX;
        const subdivisionsY = this._subdivisionsY;
        for(let row = 0; row < subdivisionsY; row++)for(let col = 0; col < subdivisionsX; col++){
            i = col * 3;
            j = row * (subdivisionsX + 1) * 3;
            k = (row + 1) * (subdivisionsX + 1) * 3;
            v1.x = positions[j + i];
            v1.y = positions[j + i + 1];
            v1.z = positions[j + i + 2];
            v2.x = positions[j + i + 3];
            v2.y = positions[j + i + 4];
            v2.z = positions[j + i + 5];
            v3.x = positions[k + i];
            v3.y = positions[k + i + 1];
            v3.z = positions[k + i + 2];
            v4.x = positions[k + i + 3];
            v4.y = positions[k + i + 4];
            v4.z = positions[k + i + 5];
            // 2D slope V1V4
            cd = (v4.z - v1.z) / (v4.x - v1.x);
            h = v1.z - cd * v1.x; // v1 belongs to the slope
            // facet equations :
            // we compute each facet normal vector
            // the equation of the facet plane is : norm.x * x + norm.y * y + norm.z * z + d = 0
            // we compute the value d by applying the equation to v1 which belongs to the plane
            // then we store the facet equation in a Vector4
            v2.subtractToRef(v1, v1v2);
            v3.subtractToRef(v1, v1v3);
            v4.subtractToRef(v1, v1v4);
            (0, $ha1VO.Vector3).CrossToRef(v1v4, v1v3, norm1); // caution : CrossToRef uses the Tmp class
            (0, $ha1VO.Vector3).CrossToRef(v1v2, v1v4, norm2);
            norm1.normalize();
            norm2.normalize();
            d1 = -(norm1.x * v1.x + norm1.y * v1.y + norm1.z * v1.z);
            d2 = -(norm2.x * v2.x + norm2.y * v2.y + norm2.z * v2.z);
            const quad = this._heightQuads[row * subdivisionsX + col];
            quad.slope.copyFromFloats(cd, h);
            quad.facet1.copyFromFloats(norm1.x, norm1.y, norm1.z, d1);
            quad.facet2.copyFromFloats(norm2.x, norm2.y, norm2.z, d2);
        }
        return this;
    }
    /**
     * Serializes this ground mesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.subdivisionsX = this._subdivisionsX;
        serializationObject.subdivisionsY = this._subdivisionsY;
        serializationObject.minX = this._minX;
        serializationObject.maxX = this._maxX;
        serializationObject.minZ = this._minZ;
        serializationObject.maxZ = this._maxZ;
        serializationObject.width = this._width;
        serializationObject.height = this._height;
    }
    /**
     * Parses a serialized ground mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the ground mesh in
     * @returns the created ground mesh
     */ static Parse(parsedMesh, scene) {
        const result = new $0e050fa3c8fa4c95$export$c798fdfefb9e9068(parsedMesh.name, scene);
        result._subdivisionsX = parsedMesh.subdivisionsX || 1;
        result._subdivisionsY = parsedMesh.subdivisionsY || 1;
        result._minX = parsedMesh.minX;
        result._maxX = parsedMesh.maxX;
        result._minZ = parsedMesh.minZ;
        result._maxZ = parsedMesh.maxZ;
        result._width = parsedMesh.width;
        result._height = parsedMesh.height;
        return result;
    }
}



var $bOhSV = parcelRequire("bOhSV");

var $ejQPp = parcelRequire("ejQPp");

var $53VPf = parcelRequire("53VPf");

var $fGXjI = parcelRequire("fGXjI");
function $646061de4fd29ff7$export$ae47f6dc1ba8f3ec(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let row, col;
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const subdivisionsX = (options.subdivisionsX || options.subdivisions || 1) | 0;
    const subdivisionsY = (options.subdivisionsY || options.subdivisions || 1) | 0;
    for(row = 0; row <= subdivisionsY; row++)for(col = 0; col <= subdivisionsX; col++){
        const position = new (0, $ha1VO.Vector3)(col * width / subdivisionsX - width / 2.0, 0, (subdivisionsY - row) * height / subdivisionsY - height / 2.0);
        const normal = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        positions.push(position.x, position.y, position.z);
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(col / subdivisionsX, (0, $fGXjI.useOpenGLOrientationForUV) ? row / subdivisionsY : 1.0 - row / subdivisionsY);
    }
    for(row = 0; row < subdivisionsY; row++)for(col = 0; col < subdivisionsX; col++){
        indices.push(col + 1 + (row + 1) * (subdivisionsX + 1));
        indices.push(col + 1 + row * (subdivisionsX + 1));
        indices.push(col + row * (subdivisionsX + 1));
        indices.push(col + (row + 1) * (subdivisionsX + 1));
        indices.push(col + 1 + (row + 1) * (subdivisionsX + 1));
        indices.push(col + row * (subdivisionsX + 1));
    }
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $646061de4fd29ff7$export$af0f3de94a9367a1(options) {
    const xmin = options.xmin !== undefined && options.xmin !== null ? options.xmin : -1;
    const zmin = options.zmin !== undefined && options.zmin !== null ? options.zmin : -1;
    const xmax = options.xmax !== undefined && options.xmax !== null ? options.xmax : 1.0;
    const zmax = options.zmax !== undefined && options.zmax !== null ? options.zmax : 1.0;
    const subdivisions = options.subdivisions || {
        w: 1,
        h: 1
    };
    const precision = options.precision || {
        w: 1,
        h: 1
    };
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let row, col, tileRow, tileCol;
    subdivisions.h = subdivisions.h < 1 ? 1 : subdivisions.h;
    subdivisions.w = subdivisions.w < 1 ? 1 : subdivisions.w;
    precision.w = precision.w < 1 ? 1 : precision.w;
    precision.h = precision.h < 1 ? 1 : precision.h;
    const tileSize = {
        w: (xmax - xmin) / subdivisions.w,
        h: (zmax - zmin) / subdivisions.h
    };
    function applyTile(xTileMin, zTileMin, xTileMax, zTileMax) {
        // Indices
        const base = positions.length / 3;
        const rowLength = precision.w + 1;
        for(row = 0; row < precision.h; row++)for(col = 0; col < precision.w; col++){
            const square = [
                base + col + row * rowLength,
                base + (col + 1) + row * rowLength,
                base + (col + 1) + (row + 1) * rowLength,
                base + col + (row + 1) * rowLength
            ];
            indices.push(square[1]);
            indices.push(square[2]);
            indices.push(square[3]);
            indices.push(square[0]);
            indices.push(square[1]);
            indices.push(square[3]);
        }
        // Position, normals and uvs
        const position = (0, $ha1VO.Vector3).Zero();
        const normal = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        for(row = 0; row <= precision.h; row++){
            position.z = row * (zTileMax - zTileMin) / precision.h + zTileMin;
            for(col = 0; col <= precision.w; col++){
                position.x = col * (xTileMax - xTileMin) / precision.w + xTileMin;
                position.y = 0;
                positions.push(position.x, position.y, position.z);
                normals.push(normal.x, normal.y, normal.z);
                uvs.push(col / precision.w, row / precision.h);
            }
        }
    }
    for(tileRow = 0; tileRow < subdivisions.h; tileRow++)for(tileCol = 0; tileCol < subdivisions.w; tileCol++)applyTile(xmin + tileCol * tileSize.w, zmin + tileRow * tileSize.h, xmin + (tileCol + 1) * tileSize.w, zmin + (tileRow + 1) * tileSize.h);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $646061de4fd29ff7$export$ea9d2c5bab487ab0(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let row, col;
    const filter = options.colorFilter || new (0, $7etnY.Color3)(0.3, 0.59, 0.11);
    const alphaFilter = options.alphaFilter || 0.0;
    let invert = false;
    if (options.minHeight > options.maxHeight) {
        invert = true;
        const temp = options.maxHeight;
        options.maxHeight = options.minHeight;
        options.minHeight = temp;
    }
    // Vertices
    for(row = 0; row <= options.subdivisions; row++)for(col = 0; col <= options.subdivisions; col++){
        const position = new (0, $ha1VO.Vector3)(col * options.width / options.subdivisions - options.width / 2.0, 0, (options.subdivisions - row) * options.height / options.subdivisions - options.height / 2.0);
        // Compute height
        const heightMapX = (position.x + options.width / 2) / options.width * (options.bufferWidth - 1) | 0;
        const heightMapY = (1.0 - (position.z + options.height / 2) / options.height) * (options.bufferHeight - 1) | 0;
        const pos = (heightMapX + heightMapY * options.bufferWidth) * 4;
        let r = options.buffer[pos] / 255.0;
        let g = options.buffer[pos + 1] / 255.0;
        let b = options.buffer[pos + 2] / 255.0;
        const a = options.buffer[pos + 3] / 255.0;
        if (invert) {
            r = 1.0 - r;
            g = 1.0 - g;
            b = 1.0 - b;
        }
        const gradient = r * filter.r + g * filter.g + b * filter.b;
        // If our alpha channel is not within our filter then we will assign a 'special' height
        // Then when building the indices, we will ignore any vertex that is using the special height
        if (a >= alphaFilter) position.y = options.minHeight + (options.maxHeight - options.minHeight) * gradient;
        else position.y = options.minHeight - (0, $53VPf.Epsilon); // We can't have a height below minHeight, normally.
        if (options.heightBuffer) // set the height buffer information in row major order.
        options.heightBuffer[row * (options.subdivisions + 1) + col] = position.y;
        // Add  vertex
        positions.push(position.x, position.y, position.z);
        normals.push(0, 0, 0);
        uvs.push(col / options.subdivisions, 1.0 - row / options.subdivisions);
    }
    // Indices
    for(row = 0; row < options.subdivisions; row++)for(col = 0; col < options.subdivisions; col++){
        // Calculate Indices
        const idx1 = col + 1 + (row + 1) * (options.subdivisions + 1);
        const idx2 = col + 1 + row * (options.subdivisions + 1);
        const idx3 = col + row * (options.subdivisions + 1);
        const idx4 = col + (row + 1) * (options.subdivisions + 1);
        // Check that all indices are visible (based on our special height)
        // Only display the vertex if all Indices are visible
        // Positions are stored x,y,z for each vertex, hence the * 3 and + 1 for height
        const isVisibleIdx1 = positions[idx1 * 3 + 1] >= options.minHeight;
        const isVisibleIdx2 = positions[idx2 * 3 + 1] >= options.minHeight;
        const isVisibleIdx3 = positions[idx3 * 3 + 1] >= options.minHeight;
        if (isVisibleIdx1 && isVisibleIdx2 && isVisibleIdx3) {
            indices.push(idx1);
            indices.push(idx2);
            indices.push(idx3);
        }
        const isVisibleIdx4 = positions[idx4 * 3 + 1] >= options.minHeight;
        if (isVisibleIdx4 && isVisibleIdx1 && isVisibleIdx3) {
            indices.push(idx4);
            indices.push(idx1);
            indices.push(idx3);
        }
    }
    // Normals
    (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $646061de4fd29ff7$export$36f42a4c5f351a31(name, options = {}, scene) {
    const ground = new (0, $0e050fa3c8fa4c95$export$c798fdfefb9e9068)(name, scene);
    ground._setReady(false);
    ground._subdivisionsX = options.subdivisionsX || options.subdivisions || 1;
    ground._subdivisionsY = options.subdivisionsY || options.subdivisions || 1;
    ground._width = options.width || 1;
    ground._height = options.height || 1;
    ground._maxX = ground._width / 2;
    ground._maxZ = ground._height / 2;
    ground._minX = -ground._maxX;
    ground._minZ = -ground._maxZ;
    const vertexData = $646061de4fd29ff7$export$ae47f6dc1ba8f3ec(options);
    vertexData.applyToMesh(ground, options.updatable);
    ground._setReady(true);
    return ground;
}
function $646061de4fd29ff7$export$c78da18d8c5de609(name, options, scene = null) {
    const tiledGround = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    const vertexData = $646061de4fd29ff7$export$af0f3de94a9367a1(options);
    vertexData.applyToMesh(tiledGround, options.updatable);
    return tiledGround;
}
function $646061de4fd29ff7$export$1106a851f720f529(name, url, options = {}, scene = null) {
    const width = options.width || 10.0;
    const height = options.height || 10.0;
    const subdivisions = options.subdivisions || 1;
    const minHeight = options.minHeight || 0.0;
    const maxHeight = options.maxHeight || 1.0;
    const filter = options.colorFilter || new (0, $7etnY.Color3)(0.3, 0.59, 0.11);
    const alphaFilter = options.alphaFilter || 0.0;
    const updatable = options.updatable;
    const onReady = options.onReady;
    scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
    const ground = new (0, $0e050fa3c8fa4c95$export$c798fdfefb9e9068)(name, scene);
    ground._subdivisionsX = subdivisions;
    ground._subdivisionsY = subdivisions;
    ground._width = width;
    ground._height = height;
    ground._maxX = ground._width / 2.0;
    ground._maxZ = ground._height / 2.0;
    ground._minX = -ground._maxX;
    ground._minZ = -ground._maxZ;
    ground._setReady(false);
    let heightBuffer;
    if (options.passHeightBufferInCallback) heightBuffer = new Float32Array((subdivisions + 1) * (subdivisions + 1));
    const onBufferLoaded = (buffer, bufferWidth, bufferHeight)=>{
        const vertexData = $646061de4fd29ff7$export$ea9d2c5bab487ab0({
            width: width,
            height: height,
            subdivisions: subdivisions,
            minHeight: minHeight,
            maxHeight: maxHeight,
            colorFilter: filter,
            buffer: buffer,
            bufferWidth: bufferWidth,
            bufferHeight: bufferHeight,
            alphaFilter: alphaFilter,
            heightBuffer: heightBuffer
        });
        vertexData.applyToMesh(ground, updatable);
        //execute ready callback, if set
        if (onReady) onReady(ground, heightBuffer);
        ground._setReady(true);
    };
    if (typeof url === "string") {
        const onload = (img)=>{
            const bufferWidth = img.width;
            const bufferHeight = img.height;
            if (scene.isDisposed) return;
            const buffer = scene?.getEngine().resizeImageBitmap(img, bufferWidth, bufferHeight);
            onBufferLoaded(buffer, bufferWidth, bufferHeight);
        };
        (0, $bOhSV.Tools).LoadImage(url, onload, options.onError ? options.onError : ()=>{}, scene.offlineProvider);
    } else onBufferLoaded(url.data, url.width, url.height);
    return ground;
}
const $646061de4fd29ff7$export$517861b98adbb032 = {
    CreateGround: // eslint-disable-next-line @typescript-eslint/naming-convention
    $646061de4fd29ff7$export$36f42a4c5f351a31,
    CreateGroundFromHeightMap: // eslint-disable-next-line @typescript-eslint/naming-convention
    $646061de4fd29ff7$export$1106a851f720f529,
    CreateTiledGround: // eslint-disable-next-line @typescript-eslint/naming-convention
    $646061de4fd29ff7$export$c78da18d8c5de609
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateGround = $646061de4fd29ff7$export$ae47f6dc1ba8f3ec;
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateTiledGround = $646061de4fd29ff7$export$af0f3de94a9367a1;
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateGroundFromHeightMap = $646061de4fd29ff7$export$ea9d2c5bab487ab0;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateGround = (name, width, height, subdivisions, scene, updatable)=>{
    const options = {
        width: width,
        height: height,
        subdivisions: subdivisions,
        updatable: updatable
    };
    return $646061de4fd29ff7$export$36f42a4c5f351a31(name, options, scene);
};
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateTiledGround = (name, xmin, zmin, xmax, zmax, subdivisions, precision, scene, updatable)=>{
    const options = {
        xmin: xmin,
        zmin: zmin,
        xmax: xmax,
        zmax: zmax,
        subdivisions: subdivisions,
        precision: precision,
        updatable: updatable
    };
    return $646061de4fd29ff7$export$c78da18d8c5de609(name, options, scene);
};
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateGroundFromHeightMap = (name, url, width, height, subdivisions, minHeight, maxHeight, scene, updatable, onReady, alphaFilter)=>{
    const options = {
        width: width,
        height: height,
        subdivisions: subdivisions,
        minHeight: minHeight,
        maxHeight: maxHeight,
        updatable: updatable,
        onReady: onReady,
        alphaFilter: alphaFilter
    };
    return $646061de4fd29ff7$export$1106a851f720f529(name, url, options, scene);
};


function $35c0cb96afcabbf6$export$61e48839003b8044(options) {
    const nbFaces = 6;
    let indices = [
        0,
        1,
        2,
        0,
        2,
        3,
        4,
        5,
        6,
        4,
        6,
        7,
        8,
        9,
        10,
        8,
        10,
        11,
        12,
        13,
        14,
        12,
        14,
        15,
        16,
        17,
        18,
        16,
        18,
        19,
        20,
        21,
        22,
        20,
        22,
        23
    ];
    const normals = [
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0
    ];
    const uvs = [];
    let positions = [];
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const depth = options.depth || options.size || 1;
    const wrap = options.wrap || false;
    let topBaseAt = options.topBaseAt === void 0 ? 1 : options.topBaseAt;
    let bottomBaseAt = options.bottomBaseAt === void 0 ? 0 : options.bottomBaseAt;
    topBaseAt = (topBaseAt + 4) % 4; // places values as 0 to 3
    bottomBaseAt = (bottomBaseAt + 4) % 4; // places values as 0 to 3
    const topOrder = [
        2,
        0,
        3,
        1
    ];
    const bottomOrder = [
        2,
        0,
        1,
        3
    ];
    let topIndex = topOrder[topBaseAt];
    let bottomIndex = bottomOrder[bottomBaseAt];
    let basePositions = [
        1,
        -1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        -1,
        1,
        1,
        -1,
        1,
        1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        1
    ];
    if (wrap) {
        indices = [
            2,
            3,
            0,
            2,
            0,
            1,
            4,
            5,
            6,
            4,
            6,
            7,
            9,
            10,
            11,
            9,
            11,
            8,
            12,
            14,
            15,
            12,
            13,
            14
        ];
        basePositions = [
            -1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1
        ];
        let topFaceBase = [
            [
                1,
                1,
                1
            ],
            [
                -1,
                1,
                1
            ],
            [
                -1,
                1,
                -1
            ],
            [
                1,
                1,
                -1
            ]
        ];
        let bottomFaceBase = [
            [
                -1,
                -1,
                1
            ],
            [
                1,
                -1,
                1
            ],
            [
                1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1
            ]
        ];
        const topFaceOrder = [
            17,
            18,
            19,
            16
        ];
        const bottomFaceOrder = [
            22,
            23,
            20,
            21
        ];
        while(topIndex > 0){
            topFaceBase.unshift(topFaceBase.pop());
            topFaceOrder.unshift(topFaceOrder.pop());
            topIndex--;
        }
        while(bottomIndex > 0){
            bottomFaceBase.unshift(bottomFaceBase.pop());
            bottomFaceOrder.unshift(bottomFaceOrder.pop());
            bottomIndex--;
        }
        topFaceBase = topFaceBase.flat();
        bottomFaceBase = bottomFaceBase.flat();
        basePositions = basePositions.concat(topFaceBase).concat(bottomFaceBase);
        indices.push(topFaceOrder[0], topFaceOrder[2], topFaceOrder[3], topFaceOrder[0], topFaceOrder[1], topFaceOrder[2]);
        indices.push(bottomFaceOrder[0], bottomFaceOrder[2], bottomFaceOrder[3], bottomFaceOrder[0], bottomFaceOrder[1], bottomFaceOrder[2]);
    }
    const scaleArray = [
        width / 2,
        height / 2,
        depth / 2
    ];
    positions = basePositions.reduce((accumulator, currentValue, currentIndex)=>accumulator.concat(currentValue * scaleArray[currentIndex % 3]), []);
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const faceUV = options.faceUV || new Array(6);
    const faceColors = options.faceColors;
    const colors = [];
    // default face colors and UV if undefined
    for(let f = 0; f < 6; f++){
        if (faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    // Create each face in turn.
    for(let index = 0; index < nbFaces; index++){
        uvs.push(faceUV[index].z, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - faceUV[index].w : faceUV[index].w);
        uvs.push(faceUV[index].x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - faceUV[index].w : faceUV[index].w);
        uvs.push(faceUV[index].x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - faceUV[index].y : faceUV[index].y);
        uvs.push(faceUV[index].z, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - faceUV[index].y : faceUV[index].y);
        if (faceColors) for(let c = 0; c < 4; c++)colors.push(faceColors[index].r, faceColors[index].g, faceColors[index].b, faceColors[index].a);
    }
    // sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) {
        const totalColors = sideOrientation === (0, $4014d881db0e9bc6$export$8570d39351855acb).DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
    }
    return vertexData;
}
function $35c0cb96afcabbf6$export$39179513b98c3e7(options) {
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const depth = options.depth || options.size || 1;
    const widthSegments = (options.widthSegments || options.segments || 1) | 0;
    const heightSegments = (options.heightSegments || options.segments || 1) | 0;
    const depthSegments = (options.depthSegments || options.segments || 1) | 0;
    const rotationMatrix = new (0, $ha1VO.Matrix)();
    const translationMatrix = new (0, $ha1VO.Matrix)();
    const transformMatrix = new (0, $ha1VO.Matrix)();
    const bottomPlane = (0, $646061de4fd29ff7$export$ae47f6dc1ba8f3ec)({
        width: width,
        height: depth,
        subdivisionsX: widthSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, -height / 2, 0, translationMatrix);
    (0, $ha1VO.Matrix).RotationZToRef(Math.PI, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    bottomPlane.transform(transformMatrix);
    const topPlane = (0, $646061de4fd29ff7$export$ae47f6dc1ba8f3ec)({
        width: width,
        height: depth,
        subdivisionsX: widthSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, height / 2, 0, transformMatrix);
    topPlane.transform(transformMatrix);
    const negXPlane = (0, $646061de4fd29ff7$export$ae47f6dc1ba8f3ec)({
        width: height,
        height: depth,
        subdivisionsX: heightSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(-width / 2, 0, 0, translationMatrix);
    (0, $ha1VO.Matrix).RotationZToRef(Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    negXPlane.transform(transformMatrix);
    const posXPlane = (0, $646061de4fd29ff7$export$ae47f6dc1ba8f3ec)({
        width: height,
        height: depth,
        subdivisionsX: heightSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(width / 2, 0, 0, translationMatrix);
    (0, $ha1VO.Matrix).RotationZToRef(-Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    posXPlane.transform(transformMatrix);
    const negZPlane = (0, $646061de4fd29ff7$export$ae47f6dc1ba8f3ec)({
        width: width,
        height: height,
        subdivisionsX: widthSegments,
        subdivisionsY: heightSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, 0, -depth / 2, translationMatrix);
    (0, $ha1VO.Matrix).RotationXToRef(-Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    negZPlane.transform(transformMatrix);
    const posZPlane = (0, $646061de4fd29ff7$export$ae47f6dc1ba8f3ec)({
        width: width,
        height: height,
        subdivisionsX: widthSegments,
        subdivisionsY: heightSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, 0, depth / 2, translationMatrix);
    (0, $ha1VO.Matrix).RotationXToRef(Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    posZPlane.transform(transformMatrix);
    // Result
    bottomPlane.merge([
        topPlane,
        posXPlane,
        negXPlane,
        negZPlane,
        posZPlane
    ], true);
    return bottomPlane;
}
function $35c0cb96afcabbf6$export$37ca2b0c6cbdecde(name, options = {}, scene = null) {
    const box = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    box._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $35c0cb96afcabbf6$export$61e48839003b8044(options);
    vertexData.applyToMesh(box, options.updatable);
    return box;
}
const $35c0cb96afcabbf6$export$fadfc01d7a04cecf = {
    CreateBox: // eslint-disable-next-line @typescript-eslint/naming-convention
    $35c0cb96afcabbf6$export$37ca2b0c6cbdecde
};
// Side effects
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateBox = $35c0cb96afcabbf6$export$61e48839003b8044;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateBox = (name, size, scene = null, updatable, sideOrientation)=>{
    const options = {
        size: size,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $35c0cb96afcabbf6$export$37ca2b0c6cbdecde(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");




function $f7ffc5db927c078f$export$ecaceef85ee00d8e(options) {
    const flipTile = options.pattern || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_FLIP;
    const tileWidth = options.tileWidth || options.tileSize || 1;
    const tileHeight = options.tileHeight || options.tileSize || 1;
    const alignH = options.alignHorizontal || 0;
    const alignV = options.alignVertical || 0;
    const width = options.width || options.size || 1;
    const tilesX = Math.floor(width / tileWidth);
    let offsetX = width - tilesX * tileWidth;
    const height = options.height || options.size || 1;
    const tilesY = Math.floor(height / tileHeight);
    let offsetY = height - tilesY * tileHeight;
    const halfWidth = tileWidth * tilesX / 2;
    const halfHeight = tileHeight * tilesY / 2;
    let adjustX = 0;
    let adjustY = 0;
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    //Part Tiles
    if (offsetX > 0 || offsetY > 0) {
        startX = -halfWidth;
        startY = -halfHeight;
        endX = halfWidth;
        endY = halfHeight;
        switch(alignH){
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CENTER:
                offsetX /= 2;
                startX -= offsetX;
                endX += offsetX;
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).LEFT:
                endX += offsetX;
                adjustX = -offsetX / 2;
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).RIGHT:
                startX -= offsetX;
                adjustX = offsetX / 2;
                break;
        }
        switch(alignV){
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CENTER:
                offsetY /= 2;
                startY -= offsetY;
                endY += offsetY;
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).BOTTOM:
                endY += offsetY;
                adjustY = -offsetY / 2;
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).TOP:
                startY -= offsetY;
                adjustY = offsetY / 2;
                break;
        }
    }
    const positions = [];
    const normals = [];
    const uvBase = [];
    uvBase[0] = [
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1
    ];
    uvBase[1] = [
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1
    ];
    if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW) uvBase[1] = [
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0
    ];
    if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW) uvBase[1] = [
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1
    ];
    if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvBase[1] = [
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0
    ];
    let uvs = [];
    const colors = [];
    const indices = [];
    let index = 0;
    for(let y = 0; y < tilesY; y++)for(let x = 0; x < tilesX; x++){
        positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
        positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
        indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
        if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBase[(x % 2 + y % 2) % 2]);
        else if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBase[y % 2]);
        else uvs = uvs.concat(uvBase[0]);
        colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
        normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        index += 4;
    }
    //Part Tiles
    if (offsetX > 0 || offsetY > 0) {
        const partialBottomRow = offsetY > 0 && (alignV === (0, $b0df7c384622c537$export$e176487c05830cc5).CENTER || alignV === (0, $b0df7c384622c537$export$e176487c05830cc5).TOP);
        const partialTopRow = offsetY > 0 && (alignV === (0, $b0df7c384622c537$export$e176487c05830cc5).CENTER || alignV === (0, $b0df7c384622c537$export$e176487c05830cc5).BOTTOM);
        const partialLeftCol = offsetX > 0 && (alignH === (0, $b0df7c384622c537$export$e176487c05830cc5).CENTER || alignH === (0, $b0df7c384622c537$export$e176487c05830cc5).RIGHT);
        const partialRightCol = offsetX > 0 && (alignH === (0, $b0df7c384622c537$export$e176487c05830cc5).CENTER || alignH === (0, $b0df7c384622c537$export$e176487c05830cc5).LEFT);
        let uvPart = [];
        let a, b, c, d;
        //corners
        if (partialBottomRow && partialLeftCol) {
            //bottom left corner
            positions.push(startX + adjustX, startY + adjustY, 0);
            positions.push(-halfWidth + adjustX, startY + adjustY, 0);
            positions.push(-halfWidth + adjustX, startY + offsetY + adjustY, 0);
            positions.push(startX + adjustX, startY + offsetY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 1 - offsetX / tileWidth;
            b = 1 - offsetY / tileHeight;
            c = 1;
            d = 1;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        if (partialBottomRow && partialRightCol) {
            //bottom right corner
            positions.push(halfWidth + adjustX, startY + adjustY, 0);
            positions.push(endX + adjustX, startY + adjustY, 0);
            positions.push(endX + adjustX, startY + offsetY + adjustY, 0);
            positions.push(halfWidth + adjustX, startY + offsetY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 0;
            b = 1 - offsetY / tileHeight;
            c = offsetX / tileWidth;
            d = 1;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE && tilesX % 2 === 0) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE && tilesX % 2 === 0) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE && tilesX % 2 === 0) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        if (partialTopRow && partialLeftCol) {
            //top left corner
            positions.push(startX + adjustX, halfHeight + adjustY, 0);
            positions.push(-halfWidth + adjustX, halfHeight + adjustY, 0);
            positions.push(-halfWidth + adjustX, endY + adjustY, 0);
            positions.push(startX + adjustX, endY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 1 - offsetX / tileWidth;
            b = 0;
            c = 1;
            d = offsetY / tileHeight;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE && tilesY % 1 === 0) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW && tilesY % 2 === 1 || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE && tilesY % 2 === 0) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE && tilesY % 2 === 0) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        if (partialTopRow && partialRightCol) {
            //top right corner
            positions.push(halfWidth + adjustX, halfHeight + adjustY, 0);
            positions.push(endX + adjustX, halfHeight + adjustY, 0);
            positions.push(endX + adjustX, endY + adjustY, 0);
            positions.push(halfWidth + adjustX, endY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 0;
            b = 0;
            c = offsetX / tileWidth;
            d = offsetY / tileHeight;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE && (tilesY + tilesX) % 2 === 1) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW && tilesY % 2 === 1 || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE && (tilesY + tilesX) % 2 === 1) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE && (tilesY + tilesX) % 2 === 1) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        //part rows
        if (partialBottomRow) {
            const uvBaseBR = [];
            a = 0;
            b = 1 - offsetY / tileHeight;
            c = 1;
            d = 1;
            uvBaseBR[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseBR[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW) uvBaseBR[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW) uvBaseBR[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvBaseBR[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let x = 0; x < tilesX; x++){
                positions.push(-halfWidth + x * tileWidth + adjustX, startY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                positions.push(-halfWidth + x * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseBR[(x + 1) % 2]);
                else if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseBR[1]);
                else uvs = uvs.concat(uvBaseBR[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
        if (partialTopRow) {
            const uvBaseTR = [];
            a = 0;
            b = 0;
            c = 1;
            d = offsetY / tileHeight;
            uvBaseTR[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseTR[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW) uvBaseTR[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW) uvBaseTR[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvBaseTR[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let x = 0; x < tilesX; x++){
                positions.push(-halfWidth + x * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY + adjustY, 0);
                positions.push(-halfWidth + x * tileWidth + adjustX, endY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseTR[(x + tilesY) % 2]);
                else if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseTR[tilesY % 2]);
                else uvs = uvs.concat(uvBaseTR[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
        if (partialLeftCol) {
            const uvBaseLC = [];
            a = 1 - offsetX / tileWidth;
            b = 0;
            c = 1;
            d = 1;
            uvBaseLC[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseLC[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW) uvBaseLC[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW) uvBaseLC[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvBaseLC[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let y = 0; y < tilesY; y++){
                positions.push(startX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(startX + offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(startX + offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                positions.push(startX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseLC[(y + 1) % 2]);
                else if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseLC[y % 2]);
                else uvs = uvs.concat(uvBaseLC[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
        if (partialRightCol) {
            const uvBaseRC = [];
            a = 0;
            b = 0;
            c = offsetX / tileHeight;
            d = 1;
            uvBaseRC[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseRC[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW) uvBaseRC[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW) uvBaseRC[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvBaseRC[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let y = 0; y < tilesY; y++){
                positions.push(endX - offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(endX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(endX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                positions.push(endX - offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_TILE || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseRC[(y + tilesX) % 2]);
                else if (flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).ROTATE_ROW || flipTile === (0, $b0df7c384622c537$export$e176487c05830cc5).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseRC[y % 2]);
                else uvs = uvs.concat(uvBaseRC[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
    }
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    // sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    const totalColors = sideOrientation === (0, $4014d881db0e9bc6$export$8570d39351855acb).DOUBLESIDE ? colors.concat(colors) : colors;
    vertexData.colors = totalColors;
    return vertexData;
}
function $f7ffc5db927c078f$export$5d0c250509e3dc5f(name, options, scene = null) {
    const plane = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    plane._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $f7ffc5db927c078f$export$ecaceef85ee00d8e(options);
    vertexData.applyToMesh(plane, options.updatable);
    return plane;
}
const $f7ffc5db927c078f$export$b40b2cde2e4016b = {
    CreateTiledPlane: // eslint-disable-next-line @typescript-eslint/naming-convention
    $f7ffc5db927c078f$export$5d0c250509e3dc5f
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateTiledPlane = $f7ffc5db927c078f$export$ecaceef85ee00d8e;



var $fGXjI = parcelRequire("fGXjI");
function $b87964e9a5a0cd0a$export$3d751018f73de3b6(options) {
    const nbFaces = 6;
    const faceUV = options.faceUV || new Array(6);
    const faceColors = options.faceColors;
    const flipTile = options.pattern || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_FLIP;
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const depth = options.depth || options.size || 1;
    const tileWidth = options.tileWidth || options.tileSize || 1;
    const tileHeight = options.tileHeight || options.tileSize || 1;
    const alignH = options.alignHorizontal || 0;
    const alignV = options.alignVertical || 0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    // default face colors and UV if undefined
    for(let f = 0; f < nbFaces; f++){
        if (faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    const halfWidth = width / 2;
    const halfHeight = height / 2;
    const halfDepth = depth / 2;
    const faceVertexData = [];
    for(let f = 0; f < 2; f++)//front and back
    faceVertexData[f] = (0, $f7ffc5db927c078f$export$ecaceef85ee00d8e)({
        pattern: flipTile,
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        width: width,
        height: height,
        alignVertical: alignV,
        alignHorizontal: alignH,
        sideOrientation: sideOrientation
    });
    for(let f = 2; f < 4; f++)//sides
    faceVertexData[f] = (0, $f7ffc5db927c078f$export$ecaceef85ee00d8e)({
        pattern: flipTile,
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        width: depth,
        height: height,
        alignVertical: alignV,
        alignHorizontal: alignH,
        sideOrientation: sideOrientation
    });
    let baseAlignV = alignV;
    if (alignV === (0, $b0df7c384622c537$export$e176487c05830cc5).BOTTOM) baseAlignV = (0, $b0df7c384622c537$export$e176487c05830cc5).TOP;
    else if (alignV === (0, $b0df7c384622c537$export$e176487c05830cc5).TOP) baseAlignV = (0, $b0df7c384622c537$export$e176487c05830cc5).BOTTOM;
    for(let f = 4; f < 6; f++)//top and bottom
    faceVertexData[f] = (0, $f7ffc5db927c078f$export$ecaceef85ee00d8e)({
        pattern: flipTile,
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        width: width,
        height: depth,
        alignVertical: baseAlignV,
        alignHorizontal: alignH,
        sideOrientation: sideOrientation
    });
    let positions = [];
    let normals = [];
    let uvs = [];
    let indices = [];
    const colors = [];
    const facePositions = [];
    const faceNormals = [];
    const newFaceUV = [];
    let lu = 0;
    let li = 0;
    for(let f = 0; f < nbFaces; f++){
        const len = faceVertexData[f].positions.length;
        facePositions[f] = [];
        faceNormals[f] = [];
        for(let p = 0; p < len / 3; p++){
            facePositions[f].push(new (0, $ha1VO.Vector3)(faceVertexData[f].positions[3 * p], faceVertexData[f].positions[3 * p + 1], faceVertexData[f].positions[3 * p + 2]));
            faceNormals[f].push(new (0, $ha1VO.Vector3)(faceVertexData[f].normals[3 * p], faceVertexData[f].normals[3 * p + 1], faceVertexData[f].normals[3 * p + 2]));
        }
        // uvs
        lu = faceVertexData[f].uvs.length;
        newFaceUV[f] = [];
        for(let i = 0; i < lu; i += 2){
            newFaceUV[f][i] = faceUV[f].x + (faceUV[f].z - faceUV[f].x) * faceVertexData[f].uvs[i];
            newFaceUV[f][i + 1] = faceUV[f].y + (faceUV[f].w - faceUV[f].y) * faceVertexData[f].uvs[i + 1];
            if (0, $fGXjI.useOpenGLOrientationForUV) newFaceUV[f][i + 1] = 1.0 - newFaceUV[f][i + 1];
        }
        uvs = uvs.concat(newFaceUV[f]);
        indices = indices.concat(faceVertexData[f].indices.map((x)=>x + li));
        li += facePositions[f].length;
        if (faceColors) for(let c = 0; c < 4; c++)colors.push(faceColors[f].r, faceColors[f].g, faceColors[f].b, faceColors[f].a);
    }
    const vec0 = new (0, $ha1VO.Vector3)(0, 0, halfDepth);
    const mtrx0 = (0, $ha1VO.Matrix).RotationY(Math.PI);
    positions = facePositions[0].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx0).add(vec0)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []);
    normals = faceNormals[0].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx0)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []);
    positions = positions.concat(facePositions[1].map((entry)=>entry.subtract(vec0)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[1].map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const vec2 = new (0, $ha1VO.Vector3)(halfWidth, 0, 0);
    const mtrx2 = (0, $ha1VO.Matrix).RotationY(-Math.PI / 2);
    positions = positions.concat(facePositions[2].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx2).add(vec2)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[2].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx2)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const mtrx3 = (0, $ha1VO.Matrix).RotationY(Math.PI / 2);
    positions = positions.concat(facePositions[3].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx3).subtract(vec2)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[3].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx3)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const vec4 = new (0, $ha1VO.Vector3)(0, halfHeight, 0);
    const mtrx4 = (0, $ha1VO.Matrix).RotationX(Math.PI / 2);
    positions = positions.concat(facePositions[4].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx4).add(vec4)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[4].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx4)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const mtrx5 = (0, $ha1VO.Matrix).RotationX(-Math.PI / 2);
    positions = positions.concat(facePositions[5].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx5).subtract(vec4)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[5].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx5)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    // sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) {
        const totalColors = sideOrientation === (0, $4014d881db0e9bc6$export$8570d39351855acb).DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
    }
    return vertexData;
}
function $b87964e9a5a0cd0a$export$1fb6e45d350ad273(name, options, scene = null) {
    const box = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    box._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $b87964e9a5a0cd0a$export$3d751018f73de3b6(options);
    vertexData.applyToMesh(box, options.updatable);
    return box;
}
const $b87964e9a5a0cd0a$export$381da3590f80f043 = {
    CreateTiledBox: // eslint-disable-next-line @typescript-eslint/naming-convention
    $b87964e9a5a0cd0a$export$1fb6e45d350ad273
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateTiledBox = $b87964e9a5a0cd0a$export$3d751018f73de3b6;



var $ha1VO = parcelRequire("ha1VO");



var $fGXjI = parcelRequire("fGXjI");
function $65e76adba60735aa$export$9639f6f681cdb12(options) {
    const segments = (options.segments || 32) | 0;
    const diameterX = options.diameterX || options.diameter || 1;
    const diameterY = options.diameterY || options.diameter || 1;
    const diameterZ = options.diameterZ || options.diameter || 1;
    const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
    const slice = options.slice && options.slice <= 0 ? 1.0 : options.slice || 1.0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const dedupTopBottomIndices = !!options.dedupTopBottomIndices;
    const radius = new (0, $ha1VO.Vector3)(diameterX / 2, diameterY / 2, diameterZ / 2);
    const totalZRotationSteps = 2 + segments;
    const totalYRotationSteps = 2 * totalZRotationSteps;
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    for(let zRotationStep = 0; zRotationStep <= totalZRotationSteps; zRotationStep++){
        const normalizedZ = zRotationStep / totalZRotationSteps;
        const angleZ = normalizedZ * Math.PI * slice;
        for(let yRotationStep = 0; yRotationStep <= totalYRotationSteps; yRotationStep++){
            const normalizedY = yRotationStep / totalYRotationSteps;
            const angleY = normalizedY * Math.PI * 2 * arc;
            const rotationZ = (0, $ha1VO.Matrix).RotationZ(-angleZ);
            const rotationY = (0, $ha1VO.Matrix).RotationY(angleY);
            const afterRotZ = (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).Up(), rotationZ);
            const complete = (0, $ha1VO.Vector3).TransformCoordinates(afterRotZ, rotationY);
            const vertex = complete.multiply(radius);
            const normal = complete.divide(radius).normalize();
            positions.push(vertex.x, vertex.y, vertex.z);
            normals.push(normal.x, normal.y, normal.z);
            uvs.push(normalizedY, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - normalizedZ : normalizedZ);
        }
        if (zRotationStep > 0) {
            const verticesCount = positions.length / 3;
            for(let firstIndex = verticesCount - 2 * (totalYRotationSteps + 1); firstIndex + totalYRotationSteps + 2 < verticesCount; firstIndex++)if (dedupTopBottomIndices) {
                if (zRotationStep > 1) {
                    indices.push(firstIndex);
                    indices.push(firstIndex + 1);
                    indices.push(firstIndex + totalYRotationSteps + 1);
                }
                if (zRotationStep < totalZRotationSteps || slice < 1.0) {
                    indices.push(firstIndex + totalYRotationSteps + 1);
                    indices.push(firstIndex + 1);
                    indices.push(firstIndex + totalYRotationSteps + 2);
                }
            } else {
                indices.push(firstIndex);
                indices.push(firstIndex + 1);
                indices.push(firstIndex + totalYRotationSteps + 1);
                indices.push(firstIndex + totalYRotationSteps + 1);
                indices.push(firstIndex + 1);
                indices.push(firstIndex + totalYRotationSteps + 2);
            }
        }
    }
    // Sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $65e76adba60735aa$export$7d1fdd0805366e9b(name, options = {}, scene = null) {
    const sphere = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    sphere._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $65e76adba60735aa$export$9639f6f681cdb12(options);
    vertexData.applyToMesh(sphere, options.updatable);
    return sphere;
}
const $65e76adba60735aa$export$3be740db72ac9cf4 = {
    CreateSphere: // eslint-disable-next-line @typescript-eslint/naming-convention
    $65e76adba60735aa$export$7d1fdd0805366e9b
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateSphere = $65e76adba60735aa$export$9639f6f681cdb12;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateSphere = (name, segments, diameter, scene, updatable, sideOrientation)=>{
    const options = {
        segments: segments,
        diameterX: diameter,
        diameterY: diameter,
        diameterZ: diameter,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $65e76adba60735aa$export$7d1fdd0805366e9b(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");



var $gmbCk = parcelRequire("gmbCk");

var $dbxbu = parcelRequire("dbxbu");

var $fGXjI = parcelRequire("fGXjI");
function $6f95fd90f7c5af1a$export$621338c722a68fde(options) {
    const height = options.height || 2;
    let diameterTop = options.diameterTop === 0 ? 0 : options.diameterTop || options.diameter || 1;
    let diameterBottom = options.diameterBottom === 0 ? 0 : options.diameterBottom || options.diameter || 1;
    diameterTop = diameterTop || 0.00001; // Prevent broken normals
    diameterBottom = diameterBottom || 0.00001; // Prevent broken normals
    const tessellation = (options.tessellation || 24) | 0;
    const subdivisions = (options.subdivisions || 1) | 0;
    const hasRings = options.hasRings ? true : false;
    const enclose = options.enclose ? true : false;
    const cap = options.cap === 0 ? 0 : options.cap || (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL;
    const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const faceUV = options.faceUV || new Array(3);
    const faceColors = options.faceColors;
    // default face colors and UV if undefined
    const quadNb = arc !== 1 && enclose ? 2 : 0;
    const ringNb = hasRings ? subdivisions : 1;
    const surfaceNb = 2 + (1 + quadNb) * ringNb;
    let f;
    for(f = 0; f < surfaceNb; f++)if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    for(f = 0; f < surfaceNb; f++)if (faceUV && faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const colors = [];
    const angleStep = Math.PI * 2 * arc / tessellation;
    let angle;
    let h;
    let radius;
    const tan = (diameterBottom - diameterTop) / 2 / height;
    const ringVertex = (0, $ha1VO.Vector3).Zero();
    const ringNormal = (0, $ha1VO.Vector3).Zero();
    const ringFirstVertex = (0, $ha1VO.Vector3).Zero();
    const ringFirstNormal = (0, $ha1VO.Vector3).Zero();
    const quadNormal = (0, $ha1VO.Vector3).Zero();
    const Y = (0, $dbxbu.Axis).Y;
    // positions, normals, uvs
    let i;
    let j;
    let r;
    let ringIdx = 1;
    let s = 1; // surface index
    let cs = 0;
    let v = 0;
    for(i = 0; i <= subdivisions; i++){
        h = i / subdivisions;
        radius = (h * (diameterTop - diameterBottom) + diameterBottom) / 2;
        ringIdx = hasRings && i !== 0 && i !== subdivisions ? 2 : 1;
        for(r = 0; r < ringIdx; r++){
            if (hasRings) s += r;
            if (enclose) s += 2 * r;
            for(j = 0; j <= tessellation; j++){
                angle = j * angleStep;
                // position
                ringVertex.x = Math.cos(-angle) * radius;
                ringVertex.y = -height / 2 + h * height;
                ringVertex.z = Math.sin(-angle) * radius;
                // normal
                if (diameterTop === 0 && i === subdivisions) {
                    // if no top cap, reuse former normals
                    ringNormal.x = normals[normals.length - (tessellation + 1) * 3];
                    ringNormal.y = normals[normals.length - (tessellation + 1) * 3 + 1];
                    ringNormal.z = normals[normals.length - (tessellation + 1) * 3 + 2];
                } else {
                    ringNormal.x = ringVertex.x;
                    ringNormal.z = ringVertex.z;
                    ringNormal.y = Math.sqrt(ringNormal.x * ringNormal.x + ringNormal.z * ringNormal.z) * tan;
                    ringNormal.normalize();
                }
                // keep first ring vertex values for enclose
                if (j === 0) {
                    ringFirstVertex.copyFrom(ringVertex);
                    ringFirstNormal.copyFrom(ringNormal);
                }
                positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                normals.push(ringNormal.x, ringNormal.y, ringNormal.z);
                if (hasRings) v = cs !== s ? faceUV[s].y : faceUV[s].w;
                else v = faceUV[s].y + (faceUV[s].w - faceUV[s].y) * h;
                uvs.push(faceUV[s].x + (faceUV[s].z - faceUV[s].x) * j / tessellation, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
                if (faceColors) colors.push(faceColors[s].r, faceColors[s].g, faceColors[s].b, faceColors[s].a);
            }
            // if enclose, add four vertices and their dedicated normals
            if (arc !== 1 && enclose) {
                positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                positions.push(0, ringVertex.y, 0);
                positions.push(0, ringVertex.y, 0);
                positions.push(ringFirstVertex.x, ringFirstVertex.y, ringFirstVertex.z);
                (0, $ha1VO.Vector3).CrossToRef(Y, ringNormal, quadNormal);
                quadNormal.normalize();
                normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                (0, $ha1VO.Vector3).CrossToRef(ringFirstNormal, Y, quadNormal);
                quadNormal.normalize();
                normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                if (hasRings) v = cs !== s ? faceUV[s + 1].y : faceUV[s + 1].w;
                else v = faceUV[s + 1].y + (faceUV[s + 1].w - faceUV[s + 1].y) * h;
                uvs.push(faceUV[s + 1].x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
                uvs.push(faceUV[s + 1].z, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
                if (hasRings) v = cs !== s ? faceUV[s + 2].y : faceUV[s + 2].w;
                else v = faceUV[s + 2].y + (faceUV[s + 2].w - faceUV[s + 2].y) * h;
                uvs.push(faceUV[s + 2].x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
                uvs.push(faceUV[s + 2].z, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
                if (faceColors) {
                    colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                    colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                    colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                    colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                }
            }
            if (cs !== s) cs = s;
        }
    }
    // indices
    const e = arc !== 1 && enclose ? tessellation + 4 : tessellation; // correction of number of iteration if enclose
    i = 0;
    for(s = 0; s < subdivisions; s++){
        let i0 = 0;
        let i1 = 0;
        let i2 = 0;
        let i3 = 0;
        for(j = 0; j < tessellation; j++){
            i0 = i * (e + 1) + j;
            i1 = (i + 1) * (e + 1) + j;
            i2 = i * (e + 1) + (j + 1);
            i3 = (i + 1) * (e + 1) + (j + 1);
            indices.push(i0, i1, i2);
            indices.push(i3, i2, i1);
        }
        if (arc !== 1 && enclose) {
            // if enclose, add two quads
            indices.push(i0 + 2, i1 + 2, i2 + 2);
            indices.push(i3 + 2, i2 + 2, i1 + 2);
            indices.push(i0 + 4, i1 + 4, i2 + 4);
            indices.push(i3 + 4, i2 + 4, i1 + 4);
        }
        i = hasRings ? i + 2 : i + 1;
    }
    // Caps
    const createCylinderCap = (isTop)=>{
        const radius = isTop ? diameterTop / 2 : diameterBottom / 2;
        if (radius === 0) return;
        // Cap positions, normals & uvs
        let angle;
        let circleVector;
        let i;
        const u = isTop ? faceUV[surfaceNb - 1] : faceUV[0];
        let c = null;
        if (faceColors) c = isTop ? faceColors[surfaceNb - 1] : faceColors[0];
        // cap center
        const vbase = positions.length / 3;
        const offset = isTop ? height / 2 : -height / 2;
        const center = new (0, $ha1VO.Vector3)(0, offset, 0);
        positions.push(center.x, center.y, center.z);
        normals.push(0, isTop ? 1 : -1, 0);
        const v = u.y + (u.w - u.y) * 0.5;
        uvs.push(u.x + (u.z - u.x) * 0.5, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
        if (c) colors.push(c.r, c.g, c.b, c.a);
        const textureScale = new (0, $ha1VO.Vector2)(0.5, 0.5);
        for(i = 0; i <= tessellation; i++){
            angle = Math.PI * 2 * i * arc / tessellation;
            const cos = Math.cos(-angle);
            const sin = Math.sin(-angle);
            circleVector = new (0, $ha1VO.Vector3)(cos * radius, offset, sin * radius);
            const textureCoordinate = new (0, $ha1VO.Vector2)(cos * textureScale.x + 0.5, sin * textureScale.y + 0.5);
            positions.push(circleVector.x, circleVector.y, circleVector.z);
            normals.push(0, isTop ? 1 : -1, 0);
            const v = u.y + (u.w - u.y) * textureCoordinate.y;
            uvs.push(u.x + (u.z - u.x) * textureCoordinate.x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
            if (c) colors.push(c.r, c.g, c.b, c.a);
        }
        // Cap indices
        for(i = 0; i < tessellation; i++)if (!isTop) {
            indices.push(vbase);
            indices.push(vbase + (i + 1));
            indices.push(vbase + (i + 2));
        } else {
            indices.push(vbase);
            indices.push(vbase + (i + 2));
            indices.push(vbase + (i + 1));
        }
    };
    // add caps to geometry based on cap parameter
    if (cap === (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_START || cap === (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL) createCylinderCap(false);
    if (cap === (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_END || cap === (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL) createCylinderCap(true);
    // Sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) vertexData.colors = colors;
    return vertexData;
}
function $6f95fd90f7c5af1a$export$c71239caf0e43983(name, options = {}, scene) {
    const cylinder = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    cylinder._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $6f95fd90f7c5af1a$export$621338c722a68fde(options);
    vertexData.applyToMesh(cylinder, options.updatable);
    return cylinder;
}
const $6f95fd90f7c5af1a$export$16476d5921a767a8 = {
    CreateCylinder: // eslint-disable-next-line @typescript-eslint/naming-convention
    $6f95fd90f7c5af1a$export$c71239caf0e43983
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateCylinder = $6f95fd90f7c5af1a$export$621338c722a68fde;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateCylinder = (name, height, diameterTop, diameterBottom, tessellation, subdivisions, scene, updatable, sideOrientation)=>{
    if (scene === undefined || !(scene instanceof (0, $gmbCk.Scene))) {
        if (scene !== undefined) {
            sideOrientation = updatable || (0, $b0df7c384622c537$export$e176487c05830cc5).DEFAULTSIDE;
            updatable = scene;
        }
        scene = subdivisions;
        subdivisions = 1;
    }
    const options = {
        height: height,
        diameterTop: diameterTop,
        diameterBottom: diameterBottom,
        tessellation: tessellation,
        subdivisions: subdivisions,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $6f95fd90f7c5af1a$export$c71239caf0e43983(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");



var $fGXjI = parcelRequire("fGXjI");
function $87667de2ca334d5c$export$9d57ec7ebb41da6e(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const diameter = options.diameter || 1;
    const thickness = options.thickness || 0.5;
    const tessellation = (options.tessellation || 16) | 0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const stride = tessellation + 1;
    for(let i = 0; i <= tessellation; i++){
        const u = i / tessellation;
        const outerAngle = i * Math.PI * 2.0 / tessellation - Math.PI / 2.0;
        const transform = (0, $ha1VO.Matrix).Translation(diameter / 2.0, 0, 0).multiply((0, $ha1VO.Matrix).RotationY(outerAngle));
        for(let j = 0; j <= tessellation; j++){
            const v = 1 - j / tessellation;
            const innerAngle = j * Math.PI * 2.0 / tessellation + Math.PI;
            const dx = Math.cos(innerAngle);
            const dy = Math.sin(innerAngle);
            // Create a vertex.
            let normal = new (0, $ha1VO.Vector3)(dx, dy, 0);
            let position = normal.scale(thickness / 2);
            const textureCoordinate = new (0, $ha1VO.Vector2)(u, v);
            position = (0, $ha1VO.Vector3).TransformCoordinates(position, transform);
            normal = (0, $ha1VO.Vector3).TransformNormal(normal, transform);
            positions.push(position.x, position.y, position.z);
            normals.push(normal.x, normal.y, normal.z);
            uvs.push(textureCoordinate.x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - textureCoordinate.y : textureCoordinate.y);
            // And create indices for two triangles.
            const nextI = (i + 1) % stride;
            const nextJ = (j + 1) % stride;
            indices.push(i * stride + j);
            indices.push(i * stride + nextJ);
            indices.push(nextI * stride + j);
            indices.push(i * stride + nextJ);
            indices.push(nextI * stride + nextJ);
            indices.push(nextI * stride + j);
        }
    }
    // Sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $87667de2ca334d5c$export$51ab2f2e5b6ce5fb(name, options = {}, scene) {
    const torus = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    torus._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $87667de2ca334d5c$export$9d57ec7ebb41da6e(options);
    vertexData.applyToMesh(torus, options.updatable);
    return torus;
}
const $87667de2ca334d5c$export$f0867b191e0a11e = {
    CreateTorus: // eslint-disable-next-line @typescript-eslint/naming-convention
    $87667de2ca334d5c$export$51ab2f2e5b6ce5fb
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateTorus = $87667de2ca334d5c$export$9d57ec7ebb41da6e;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateTorus = (name, diameter, thickness, tessellation, scene, updatable, sideOrientation)=>{
    const options = {
        diameter: diameter,
        thickness: thickness,
        tessellation: tessellation,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $87667de2ca334d5c$export$51ab2f2e5b6ce5fb(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");



var $fGXjI = parcelRequire("fGXjI");
function $bd18b164246d46e4$export$8b2c43e1ab8fcb89(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const radius = options.radius || 2;
    const tube = options.tube || 0.5;
    const radialSegments = options.radialSegments || 32;
    const tubularSegments = options.tubularSegments || 32;
    const p = options.p || 2;
    const q = options.q || 3;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    // Helper
    const getPos = (angle)=>{
        const cu = Math.cos(angle);
        const su = Math.sin(angle);
        const quOverP = q / p * angle;
        const cs = Math.cos(quOverP);
        const tx = radius * (2 + cs) * 0.5 * cu;
        const ty = radius * (2 + cs) * su * 0.5;
        const tz = radius * Math.sin(quOverP) * 0.5;
        return new (0, $ha1VO.Vector3)(tx, ty, tz);
    };
    // Vertices
    let i;
    let j;
    for(i = 0; i <= radialSegments; i++){
        const modI = i % radialSegments;
        const u = modI / radialSegments * 2 * p * Math.PI;
        const p1 = getPos(u);
        const p2 = getPos(u + 0.01);
        const tang = p2.subtract(p1);
        let n = p2.add(p1);
        const bitan = (0, $ha1VO.Vector3).Cross(tang, n);
        n = (0, $ha1VO.Vector3).Cross(bitan, tang);
        bitan.normalize();
        n.normalize();
        for(j = 0; j < tubularSegments; j++){
            const modJ = j % tubularSegments;
            const v = modJ / tubularSegments * 2 * Math.PI;
            const cx = -tube * Math.cos(v);
            const cy = tube * Math.sin(v);
            positions.push(p1.x + cx * n.x + cy * bitan.x);
            positions.push(p1.y + cx * n.y + cy * bitan.y);
            positions.push(p1.z + cx * n.z + cy * bitan.z);
            uvs.push(i / radialSegments);
            uvs.push((0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - j / tubularSegments : j / tubularSegments);
        }
    }
    for(i = 0; i < radialSegments; i++)for(j = 0; j < tubularSegments; j++){
        const jNext = (j + 1) % tubularSegments;
        const a = i * tubularSegments + j;
        const b = (i + 1) * tubularSegments + j;
        const c = (i + 1) * tubularSegments + jNext;
        const d = i * tubularSegments + jNext;
        indices.push(d);
        indices.push(b);
        indices.push(a);
        indices.push(d);
        indices.push(c);
        indices.push(b);
    }
    // Normals
    (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
    // Sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $bd18b164246d46e4$export$15125c50b1408b05(name, options = {}, scene) {
    const torusKnot = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    torusKnot._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $bd18b164246d46e4$export$8b2c43e1ab8fcb89(options);
    vertexData.applyToMesh(torusKnot, options.updatable);
    return torusKnot;
}
const $bd18b164246d46e4$export$36acfe2c554e8f81 = {
    CreateTorusKnot: // eslint-disable-next-line @typescript-eslint/naming-convention
    $bd18b164246d46e4$export$15125c50b1408b05
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateTorusKnot = $bd18b164246d46e4$export$8b2c43e1ab8fcb89;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateTorusKnot = (name, radius, tube, radialSegments, tubularSegments, p, q, scene, updatable, sideOrientation)=>{
    const options = {
        radius: radius,
        tube: tube,
        radialSegments: radialSegments,
        tubularSegments: tubularSegments,
        p: p,
        q: q,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $bd18b164246d46e4$export$15125c50b1408b05(name, options, scene);
};


/* eslint-disable @typescript-eslint/naming-convention */ 
var $ha1VO = parcelRequire("ha1VO");



var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");


var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");



var $fhgis = parcelRequire("fhgis");


var $b4i1f = parcelRequire("b4i1f");

var $bOhSV = parcelRequire("bOhSV");

var $8DoUR = parcelRequire("8DoUR");
(0, $b0df7c384622c537$export$e176487c05830cc5)._instancedMeshFactory = (name, mesh)=>{
    const instance = new $740423c584384d56$export$f3c979c331175ad7(name, mesh);
    if (mesh.instancedBuffers) {
        instance.instancedBuffers = {};
        for(const key in mesh.instancedBuffers)instance.instancedBuffers[key] = mesh.instancedBuffers[key];
    }
    return instance;
};
class $740423c584384d56$export$f3c979c331175ad7 extends (0, $0009db3ebb3b86d3$export$8f1d8af674c785a5) {
    /**
     * Creates a new InstancedMesh object from the mesh source.
     * @param name defines the name of the instance
     * @param source the mesh to create the instance from
     */ constructor(name, source){
        super(name, source.getScene());
        /** @internal */ this._indexInSourceMeshInstanceArray = -1;
        /** @internal */ this._distanceToCamera = 0;
        source.addInstance(this);
        this._sourceMesh = source;
        this._unIndexed = source._unIndexed;
        this.position.copyFrom(source.position);
        this.rotation.copyFrom(source.rotation);
        this.scaling.copyFrom(source.scaling);
        if (source.rotationQuaternion) this.rotationQuaternion = source.rotationQuaternion.clone();
        this.animations = source.animations.slice();
        for (const range of source.getAnimationRanges())if (range != null) this.createAnimationRange(range.name, range.from, range.to);
        this.infiniteDistance = source.infiniteDistance;
        this.setPivotMatrix(source.getPivotMatrix());
        this.refreshBoundingInfo(true, true);
        this._syncSubMeshes();
    }
    /**
     * @returns the string "InstancedMesh".
     */ getClassName() {
        return "InstancedMesh";
    }
    /** Gets the list of lights affecting that mesh */ get lightSources() {
        return this._sourceMesh._lightSources;
    }
    _resyncLightSources() {
    // Do nothing as all the work will be done by source mesh
    }
    _resyncLightSource() {
    // Do nothing as all the work will be done by source mesh
    }
    _removeLightSource() {
    // Do nothing as all the work will be done by source mesh
    }
    // Methods
    /**
     * If the source mesh receives shadows
     */ get receiveShadows() {
        return this._sourceMesh.receiveShadows;
    }
    set receiveShadows(_value) {
        if (this._sourceMesh?.receiveShadows !== _value) (0, $bOhSV.Tools).Warn("Setting receiveShadows on an instanced mesh has no effect");
    }
    /**
     * The material of the source mesh
     */ get material() {
        return this._sourceMesh.material;
    }
    set material(_value) {
        if (this._sourceMesh?.material !== _value) (0, $bOhSV.Tools).Warn("Setting material on an instanced mesh has no effect");
    }
    /**
     * Visibility of the source mesh
     */ get visibility() {
        return this._sourceMesh.visibility;
    }
    set visibility(_value) {
        if (this._sourceMesh?.visibility !== _value) (0, $bOhSV.Tools).Warn("Setting visibility on an instanced mesh has no effect");
    }
    /**
     * Skeleton of the source mesh
     */ get skeleton() {
        return this._sourceMesh.skeleton;
    }
    set skeleton(_value) {
        if (this._sourceMesh?.skeleton !== _value) (0, $bOhSV.Tools).Warn("Setting skeleton on an instanced mesh has no effect");
    }
    /**
     * Rendering ground id of the source mesh
     */ get renderingGroupId() {
        return this._sourceMesh.renderingGroupId;
    }
    set renderingGroupId(value) {
        if (!this._sourceMesh || value === this._sourceMesh.renderingGroupId) return;
        //no-op with warning
        (0, $kVtWi.Logger).Warn("Note - setting renderingGroupId of an instanced mesh has no effect on the scene");
    }
    /**
     * @returns the total number of vertices (integer).
     */ getTotalVertices() {
        return this._sourceMesh ? this._sourceMesh.getTotalVertices() : 0;
    }
    /**
     * Returns a positive integer : the total number of indices in this mesh geometry.
     * @returns the number of indices or zero if the mesh has no geometry.
     */ getTotalIndices() {
        return this._sourceMesh.getTotalIndices();
    }
    /**
     * The source mesh of the instance
     */ get sourceMesh() {
        return this._sourceMesh;
    }
    /**
     * Creates a new InstancedMesh object from the mesh model.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
     * @param name defines the name of the new instance
     * @returns a new InstancedMesh
     */ createInstance(name) {
        return this._sourceMesh.createInstance(name);
    }
    /**
     * Is this node ready to be used/rendered
     * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
     * @returns {boolean} is it ready
     */ isReady(completeCheck = false) {
        return this._sourceMesh.isReady(completeCheck, true);
    }
    /**
     * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
     * @param kind kind of verticies to retrieve (eg. positions, normals, uvs, etc.)
     * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
     * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
     * @returns a float array or a Float32Array of the requested kind of data : positions, normals, uvs, etc.
     */ getVerticesData(kind, copyWhenShared, forceCopy) {
        return this._sourceMesh.getVerticesData(kind, copyWhenShared, forceCopy);
    }
    copyVerticesData(kind, vertexData) {
        this._sourceMesh.copyVerticesData(kind, vertexData);
    }
    /**
     * Sets the vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
     * The `data` are either a numeric array either a Float32Array.
     * The parameter `updatable` is passed as is to the underlying Geometry object constructor (if initially none) or updater.
     * The parameter `stride` is an optional positive integer, it is usually automatically deducted from the `kind` (3 for positions or normals, 2 for UV, etc).
     * Note that a new underlying VertexBuffer object is created each call.
     * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
     *
     * Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     *
     * Returns the Mesh.
     * @param kind defines vertex data kind
     * @param data defines the data source
     * @param updatable defines if the data must be flagged as updatable (false as default)
     * @param stride defines the vertex stride (optional)
     * @returns the current mesh
     */ setVerticesData(kind, data, updatable, stride) {
        if (this.sourceMesh) this.sourceMesh.setVerticesData(kind, data, updatable, stride);
        return this.sourceMesh;
    }
    /**
     * Updates the existing vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, it is simply returned as it is.
     * The `data` are either a numeric array either a Float32Array.
     * No new underlying VertexBuffer object is created.
     * If the `kind` is the `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
     * If the parameter `makeItUnique` is true, a new global geometry is created from this positions and is set to the mesh.
     *
     * Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     *
     * Returns the Mesh.
     * @param kind defines vertex data kind
     * @param data defines the data source
     * @param updateExtends defines if extends info of the mesh must be updated (can be null). This is mostly useful for "position" kind
     * @param makeItUnique defines it the updated vertex buffer must be flagged as unique (false by default)
     * @returns the source mesh
     */ updateVerticesData(kind, data, updateExtends, makeItUnique) {
        if (this.sourceMesh) this.sourceMesh.updateVerticesData(kind, data, updateExtends, makeItUnique);
        return this.sourceMesh;
    }
    /**
     * Sets the mesh indices.
     * Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array).
     * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
     * This method creates a new index buffer each call.
     * Returns the Mesh.
     * @param indices the source data
     * @param totalVertices defines the total number of vertices referenced by indices (could be null)
     * @returns source mesh
     */ setIndices(indices, totalVertices = null) {
        if (this.sourceMesh) this.sourceMesh.setIndices(indices, totalVertices);
        return this.sourceMesh;
    }
    /**
     * Boolean : True if the mesh owns the requested kind of data.
     * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @returns true if data kind is present
     */ isVerticesDataPresent(kind) {
        return this._sourceMesh.isVerticesDataPresent(kind);
    }
    /**
     * @returns an array of indices (IndicesArray).
     */ getIndices() {
        return this._sourceMesh.getIndices();
    }
    get _positions() {
        return this._sourceMesh._positions;
    }
    refreshBoundingInfo(applySkeletonOrOptions = false, applyMorph = false) {
        if (this.hasBoundingInfo && this.getBoundingInfo().isLocked) return this;
        let options;
        if (typeof applySkeletonOrOptions === "object") options = applySkeletonOrOptions;
        else options = {
            applySkeleton: applySkeletonOrOptions,
            applyMorph: applyMorph
        };
        const bias = this._sourceMesh.geometry ? this._sourceMesh.geometry.boundingBias : null;
        this._refreshBoundingInfo(this._sourceMesh._getData(options, null, (0, $b4i1f.VertexBuffer).PositionKind), bias);
        return this;
    }
    /** @internal */ _preActivate() {
        if (this._currentLOD) this._currentLOD._preActivate();
        return this;
    }
    /**
     * @internal
     */ _activate(renderId, intermediateRendering) {
        super._activate(renderId, intermediateRendering);
        if (!this._sourceMesh.subMeshes) (0, $kVtWi.Logger).Warn("Instances should only be created for meshes with geometry.");
        if (this._currentLOD) {
            const differentSign = this._currentLOD._getWorldMatrixDeterminant() >= 0 !== this._getWorldMatrixDeterminant() >= 0;
            if (differentSign) {
                this._internalAbstractMeshDataInfo._actAsRegularMesh = true;
                return true;
            }
            this._internalAbstractMeshDataInfo._actAsRegularMesh = false;
            this._currentLOD._registerInstanceForRenderId(this, renderId);
            if (intermediateRendering) {
                if (!this._currentLOD._internalAbstractMeshDataInfo._isActiveIntermediate) {
                    this._currentLOD._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = true;
                    return true;
                }
            } else if (!this._currentLOD._internalAbstractMeshDataInfo._isActive) {
                this._currentLOD._internalAbstractMeshDataInfo._onlyForInstances = true;
                return true;
            }
        }
        return false;
    }
    /** @internal */ _postActivate() {
        if (this._sourceMesh.edgesShareWithInstances && this._sourceMesh._edgesRenderer && this._sourceMesh._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup) {
            // we are using the edge renderer of the source mesh
            this._sourceMesh._renderingGroup._edgesRenderers.pushNoDuplicate(this._sourceMesh._edgesRenderer);
            this._sourceMesh._edgesRenderer.customInstances.push(this.getWorldMatrix());
        } else if (this._edgesRenderer && this._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup) // we are using the edge renderer defined for this instance
        this._sourceMesh._renderingGroup._edgesRenderers.push(this._edgesRenderer);
    }
    getWorldMatrix() {
        if (this._currentLOD && this._currentLOD.billboardMode !== (0, $ecfbb5db4d70b862$export$b600d080bad015f).BILLBOARDMODE_NONE && this._currentLOD._masterMesh !== this) {
            if (!this._billboardWorldMatrix) this._billboardWorldMatrix = new (0, $ha1VO.Matrix)();
            const tempMaster = this._currentLOD._masterMesh;
            this._currentLOD._masterMesh = this;
            (0, $ha1VO.TmpVectors).Vector3[7].copyFrom(this._currentLOD.position);
            this._currentLOD.position.set(0, 0, 0);
            this._billboardWorldMatrix.copyFrom(this._currentLOD.computeWorldMatrix(true));
            this._currentLOD.position.copyFrom((0, $ha1VO.TmpVectors).Vector3[7]);
            this._currentLOD._masterMesh = tempMaster;
            return this._billboardWorldMatrix;
        }
        return super.getWorldMatrix();
    }
    get isAnInstance() {
        return true;
    }
    /**
     * Returns the current associated LOD AbstractMesh.
     * @param camera defines the camera to use to pick the LOD level
     * @returns a Mesh or `null` if no LOD is associated with the AbstractMesh
     */ getLOD(camera) {
        if (!camera) return this;
        const sourceMeshLODLevels = this.sourceMesh.getLODLevels();
        if (!sourceMeshLODLevels || sourceMeshLODLevels.length === 0) this._currentLOD = this.sourceMesh;
        else {
            const boundingInfo = this.getBoundingInfo();
            this._currentLOD = this.sourceMesh.getLOD(camera, boundingInfo.boundingSphere);
        }
        return this._currentLOD;
    }
    /**
     * @internal
     */ _preActivateForIntermediateRendering(renderId) {
        return this.sourceMesh._preActivateForIntermediateRendering(renderId);
    }
    /** @internal */ _syncSubMeshes() {
        this.releaseSubMeshes();
        if (this._sourceMesh.subMeshes) for(let index = 0; index < this._sourceMesh.subMeshes.length; index++)this._sourceMesh.subMeshes[index].clone(this, this._sourceMesh);
        return this;
    }
    /** @internal */ _generatePointsArray() {
        return this._sourceMesh._generatePointsArray();
    }
    /** @internal */ _updateBoundingInfo() {
        if (this.hasBoundingInfo) this.getBoundingInfo().update(this.worldMatrixFromCache);
        else this.buildBoundingInfo(this.absolutePosition, this.absolutePosition, this.worldMatrixFromCache);
        this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
        return this;
    }
    /**
     * Creates a new InstancedMesh from the current mesh.
     *
     * Returns the clone.
     * @param name the cloned mesh name
     * @param newParent the optional Node to parent the clone to.
     * @param doNotCloneChildren if `true` the model children aren't cloned.
     * @param newSourceMesh if set this mesh will be used as the source mesh instead of ths instance's one
     * @returns the clone
     */ clone(name, newParent = null, doNotCloneChildren, newSourceMesh) {
        const result = (newSourceMesh || this._sourceMesh).createInstance(name);
        // Deep copy
        (0, $fhgis.DeepCopier).DeepCopy(this, result, [
            "name",
            "subMeshes",
            "uniqueId",
            "parent",
            "lightSources",
            "receiveShadows",
            "material",
            "visibility",
            "skeleton",
            "sourceMesh",
            "isAnInstance",
            "facetNb",
            "isFacetDataEnabled",
            "isBlocked",
            "useBones",
            "hasInstances",
            "collider",
            "edgesRenderer",
            "forward",
            "up",
            "right",
            "absolutePosition",
            "absoluteScaling",
            "absoluteRotationQuaternion",
            "isWorldMatrixFrozen",
            "nonUniformScaling",
            "behaviors",
            "worldMatrixFromCache",
            "hasThinInstances",
            "hasBoundingInfo"
        ], []);
        // Bounding info
        this.refreshBoundingInfo();
        // Parent
        if (newParent) result.parent = newParent;
        if (!doNotCloneChildren) // Children
        for(let index = 0; index < this.getScene().meshes.length; index++){
            const mesh = this.getScene().meshes[index];
            if (mesh.parent === this) mesh.clone(mesh.name, result);
        }
        result.computeWorldMatrix(true);
        this.onClonedObservable.notifyObservers(result);
        return result;
    }
    /**
     * Disposes the InstancedMesh.
     * Returns nothing.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        // Remove from mesh
        this._sourceMesh.removeInstance(this);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * @internal
     */ _serializeAsParent(serializationObject) {
        super._serializeAsParent(serializationObject);
        serializationObject.parentId = this._sourceMesh.uniqueId;
        serializationObject.parentInstanceIndex = this._indexInSourceMeshInstanceArray;
    }
    /**
     * Instantiate (when possible) or clone that node with its hierarchy
     * @param newParent defines the new parent to use for the instance (or clone)
     * @param options defines options to configure how copy is done
     * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
     * @param options.newSourcedMesh newSourcedMesh the new source mesh for the instance (or clone)
     * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
     * @returns an instance (or a clone) of the current node with its hierarchy
     */ instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
        const clone = this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true, options && options.newSourcedMesh);
        if (clone) {
            if (onNewNodeCreated) onNewNodeCreated(this, clone);
        }
        for (const child of this.getChildTransformNodes(true))child.instantiateHierarchy(clone, options, onNewNodeCreated);
        return clone;
    }
}
(0, $b0df7c384622c537$export$e176487c05830cc5).prototype.registerInstancedBuffer = function(kind, stride) {
    // Remove existing one
    this._userInstancedBuffersStorage?.vertexBuffers[kind]?.dispose();
    // Creates the instancedBuffer field if not present
    if (!this.instancedBuffers) {
        this.instancedBuffers = {};
        for (const instance of this.instances)instance.instancedBuffers = {};
    }
    if (!this._userInstancedBuffersStorage) this._userInstancedBuffersStorage = {
        data: {},
        vertexBuffers: {},
        strides: {},
        sizes: {},
        vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : undefined
    };
    // Creates an empty property for this kind
    this.instancedBuffers[kind] = null;
    this._userInstancedBuffersStorage.strides[kind] = stride;
    this._userInstancedBuffersStorage.sizes[kind] = stride * 32; // Initial size
    this._userInstancedBuffersStorage.data[kind] = new Float32Array(this._userInstancedBuffersStorage.sizes[kind]);
    this._userInstancedBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), this._userInstancedBuffersStorage.data[kind], kind, true, false, stride, true);
    for (const instance of this.instances)instance.instancedBuffers[kind] = null;
    this._invalidateInstanceVertexArrayObject();
    this._markSubMeshesAsAttributesDirty();
};
(0, $b0df7c384622c537$export$e176487c05830cc5).prototype._processInstancedBuffers = function(visibleInstances, renderSelf) {
    const instanceCount = visibleInstances ? visibleInstances.length : 0;
    for(const kind in this.instancedBuffers){
        let size = this._userInstancedBuffersStorage.sizes[kind];
        const stride = this._userInstancedBuffersStorage.strides[kind];
        // Resize if required
        const expectedSize = (instanceCount + 1) * stride;
        while(size < expectedSize)size *= 2;
        if (this._userInstancedBuffersStorage.data[kind].length != size) {
            this._userInstancedBuffersStorage.data[kind] = new Float32Array(size);
            this._userInstancedBuffersStorage.sizes[kind] = size;
            if (this._userInstancedBuffersStorage.vertexBuffers[kind]) {
                this._userInstancedBuffersStorage.vertexBuffers[kind].dispose();
                this._userInstancedBuffersStorage.vertexBuffers[kind] = null;
            }
        }
        const data = this._userInstancedBuffersStorage.data[kind];
        // Update data buffer
        let offset = 0;
        if (renderSelf) {
            const value = this.instancedBuffers[kind];
            if (value.toArray) value.toArray(data, offset);
            else if (value.copyToArray) value.copyToArray(data, offset);
            else data[offset] = value;
            offset += stride;
        }
        for(let instanceIndex = 0; instanceIndex < instanceCount; instanceIndex++){
            const instance = visibleInstances[instanceIndex];
            const value = instance.instancedBuffers[kind];
            if (value.toArray) value.toArray(data, offset);
            else if (value.copyToArray) value.copyToArray(data, offset);
            else data[offset] = value;
            offset += stride;
        }
        // Update vertex buffer
        if (!this._userInstancedBuffersStorage.vertexBuffers[kind]) {
            this._userInstancedBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), this._userInstancedBuffersStorage.data[kind], kind, true, false, stride, true);
            this._invalidateInstanceVertexArrayObject();
        } else this._userInstancedBuffersStorage.vertexBuffers[kind].updateDirectly(data, 0);
    }
};
(0, $b0df7c384622c537$export$e176487c05830cc5).prototype._invalidateInstanceVertexArrayObject = function() {
    if (!this._userInstancedBuffersStorage || this._userInstancedBuffersStorage.vertexArrayObjects === undefined) return;
    for(const kind in this._userInstancedBuffersStorage.vertexArrayObjects)this.getEngine().releaseVertexArrayObject(this._userInstancedBuffersStorage.vertexArrayObjects[kind]);
    this._userInstancedBuffersStorage.vertexArrayObjects = {};
};
(0, $b0df7c384622c537$export$e176487c05830cc5).prototype._disposeInstanceSpecificData = function() {
    if (this._instanceDataStorage.instancesBuffer) {
        this._instanceDataStorage.instancesBuffer.dispose();
        this._instanceDataStorage.instancesBuffer = null;
    }
    while(this.instances.length)this.instances[0].dispose();
    for(const kind in this.instancedBuffers)if (this._userInstancedBuffersStorage.vertexBuffers[kind]) this._userInstancedBuffersStorage.vertexBuffers[kind].dispose();
    this._invalidateInstanceVertexArrayObject();
    this.instancedBuffers = {};
};
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.InstancedMesh", $740423c584384d56$export$f3c979c331175ad7);




var $6Ho1L = parcelRequire("6Ho1L");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $8DoUR = parcelRequire("8DoUR");

var $7etnY = parcelRequire("7etnY");


var $hUzEl = parcelRequire("hUzEl");


var $ejQPp = parcelRequire("ejQPp");


const $36e10aeb8f79d080$var$onCreatedEffectParameters = {
    effect: null,
    subMesh: null
};
class $36e10aeb8f79d080$export$83c7d75d550a8b0d extends (0, $7a0e949889738692$export$9026dbc30178f7ea) {
    /**
     * Instantiate a new shader material.
     * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
     * This returned material effects how the mesh will look based on the code in the shaders.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/shaders/shaderMaterial
     * @param name Define the name of the material in the scene
     * @param scene Define the scene the material belongs to
     * @param shaderPath Defines  the route to the shader code.
     * @param options Define the options used to create the shader
     * @param storeEffectOnSubMeshes true to store effect on submeshes, false to store the effect directly in the material class.
     */ constructor(name, scene, shaderPath, options = {}, storeEffectOnSubMeshes = true){
        super(name, scene, storeEffectOnSubMeshes);
        this._textures = {};
        this._textureArrays = {};
        this._externalTextures = {};
        this._floats = {};
        this._ints = {};
        this._uints = {};
        this._floatsArrays = {};
        this._colors3 = {};
        this._colors3Arrays = {};
        this._colors4 = {};
        this._colors4Arrays = {};
        this._vectors2 = {};
        this._vectors3 = {};
        this._vectors4 = {};
        this._quaternions = {};
        this._quaternionsArrays = {};
        this._matrices = {};
        this._matrixArrays = {};
        this._matrices3x3 = {};
        this._matrices2x2 = {};
        this._vectors2Arrays = {};
        this._vectors3Arrays = {};
        this._vectors4Arrays = {};
        this._uniformBuffers = {};
        this._textureSamplers = {};
        this._storageBuffers = {};
        this._cachedWorldViewMatrix = new (0, $ha1VO.Matrix)();
        this._cachedWorldViewProjectionMatrix = new (0, $ha1VO.Matrix)();
        this._multiview = false;
        /**
         * @internal
         */ this._materialHelperNeedsPreviousMatrices = false;
        this._shaderPath = shaderPath;
        this._options = {
            needAlphaBlending: false,
            needAlphaTesting: false,
            attributes: [
                "position",
                "normal",
                "uv"
            ],
            uniforms: [
                "worldViewProjection"
            ],
            uniformBuffers: [],
            samplers: [],
            externalTextures: [],
            samplerObjects: [],
            storageBuffers: [],
            defines: [],
            useClipPlane: false,
            ...options
        };
    }
    /**
     * Gets the shader path used to define the shader code
     * It can be modified to trigger a new compilation
     */ get shaderPath() {
        return this._shaderPath;
    }
    /**
     * Sets the shader path used to define the shader code
     * It can be modified to trigger a new compilation
     */ set shaderPath(shaderPath) {
        this._shaderPath = shaderPath;
    }
    /**
     * Gets the options used to compile the shader.
     * They can be modified to trigger a new compilation
     */ get options() {
        return this._options;
    }
    /**
     * is multiview set to true?
     */ get isMultiview() {
        return this._multiview;
    }
    /**
     * Gets the current class name of the material e.g. "ShaderMaterial"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "ShaderMaterial";
    }
    /**
     * Specifies if the material will require alpha blending
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        return this.alpha < 1.0 || this._options.needAlphaBlending;
    }
    /**
     * Specifies if this material should be rendered in alpha test mode
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        return this._options.needAlphaTesting;
    }
    _checkUniform(uniformName) {
        if (this._options.uniforms.indexOf(uniformName) === -1) this._options.uniforms.push(uniformName);
    }
    /**
     * Set a texture in the shader.
     * @param name Define the name of the uniform samplers as defined in the shader
     * @param texture Define the texture to bind to this sampler
     * @returns the material itself allowing "fluent" like uniform updates
     */ setTexture(name, texture) {
        if (this._options.samplers.indexOf(name) === -1) this._options.samplers.push(name);
        this._textures[name] = texture;
        return this;
    }
    /**
     * Remove a texture from the material.
     * @param name Define the name of the texture to remove
     */ removeTexture(name) {
        delete this._textures[name];
    }
    /**
     * Set a texture array in the shader.
     * @param name Define the name of the uniform sampler array as defined in the shader
     * @param textures Define the list of textures to bind to this sampler
     * @returns the material itself allowing "fluent" like uniform updates
     */ setTextureArray(name, textures) {
        if (this._options.samplers.indexOf(name) === -1) this._options.samplers.push(name);
        this._checkUniform(name);
        this._textureArrays[name] = textures;
        return this;
    }
    /**
     * Set an internal texture in the shader.
     * @param name Define the name of the uniform samplers as defined in the shader
     * @param texture Define the texture to bind to this sampler
     * @returns the material itself allowing "fluent" like uniform updates
     */ setExternalTexture(name, texture) {
        if (this._options.externalTextures.indexOf(name) === -1) this._options.externalTextures.push(name);
        this._externalTextures[name] = texture;
        return this;
    }
    /**
     * Set a float in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setFloat(name, value) {
        this._checkUniform(name);
        this._floats[name] = value;
        return this;
    }
    /**
     * Set a int in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setInt(name, value) {
        this._checkUniform(name);
        this._ints[name] = value;
        return this;
    }
    /**
     * Set a unsigned int in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setUInt(name, value) {
        this._checkUniform(name);
        this._uints[name] = value;
        return this;
    }
    /**
     * Set an array of floats in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setFloats(name, value) {
        this._checkUniform(name);
        this._floatsArrays[name] = value;
        return this;
    }
    /**
     * Set a vec3 in the shader from a Color3.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor3(name, value) {
        this._checkUniform(name);
        this._colors3[name] = value;
        return this;
    }
    /**
     * Set a vec3 array in the shader from a Color3 array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor3Array(name, value) {
        this._checkUniform(name);
        this._colors3Arrays[name] = value.reduce((arr, color)=>{
            color.toArray(arr, arr.length);
            return arr;
        }, []);
        return this;
    }
    /**
     * Set a vec4 in the shader from a Color4.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor4(name, value) {
        this._checkUniform(name);
        this._colors4[name] = value;
        return this;
    }
    /**
     * Set a vec4 array in the shader from a Color4 array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor4Array(name, value) {
        this._checkUniform(name);
        this._colors4Arrays[name] = value.reduce((arr, color)=>{
            color.toArray(arr, arr.length);
            return arr;
        }, []);
        return this;
    }
    /**
     * Set a vec2 in the shader from a Vector2.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setVector2(name, value) {
        this._checkUniform(name);
        this._vectors2[name] = value;
        return this;
    }
    /**
     * Set a vec3 in the shader from a Vector3.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setVector3(name, value) {
        this._checkUniform(name);
        this._vectors3[name] = value;
        return this;
    }
    /**
     * Set a vec4 in the shader from a Vector4.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setVector4(name, value) {
        this._checkUniform(name);
        this._vectors4[name] = value;
        return this;
    }
    /**
     * Set a vec4 in the shader from a Quaternion.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setQuaternion(name, value) {
        this._checkUniform(name);
        this._quaternions[name] = value;
        return this;
    }
    /**
     * Set a vec4 array in the shader from a Quaternion array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setQuaternionArray(name, value) {
        this._checkUniform(name);
        this._quaternionsArrays[name] = value.reduce((arr, quaternion)=>{
            quaternion.toArray(arr, arr.length);
            return arr;
        }, []);
        return this;
    }
    /**
     * Set a mat4 in the shader from a Matrix.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrix(name, value) {
        this._checkUniform(name);
        this._matrices[name] = value;
        return this;
    }
    /**
     * Set a float32Array in the shader from a matrix array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrices(name, value) {
        this._checkUniform(name);
        const float32Array = new Float32Array(value.length * 16);
        for(let index = 0; index < value.length; index++){
            const matrix = value[index];
            matrix.copyToArray(float32Array, index * 16);
        }
        this._matrixArrays[name] = float32Array;
        return this;
    }
    /**
     * Set a mat3 in the shader from a Float32Array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrix3x3(name, value) {
        this._checkUniform(name);
        this._matrices3x3[name] = value;
        return this;
    }
    /**
     * Set a mat2 in the shader from a Float32Array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrix2x2(name, value) {
        this._checkUniform(name);
        this._matrices2x2[name] = value;
        return this;
    }
    /**
     * Set a vec2 array in the shader from a number array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setArray2(name, value) {
        this._checkUniform(name);
        this._vectors2Arrays[name] = value;
        return this;
    }
    /**
     * Set a vec3 array in the shader from a number array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setArray3(name, value) {
        this._checkUniform(name);
        this._vectors3Arrays[name] = value;
        return this;
    }
    /**
     * Set a vec4 array in the shader from a number array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setArray4(name, value) {
        this._checkUniform(name);
        this._vectors4Arrays[name] = value;
        return this;
    }
    /**
     * Set a uniform buffer in the shader
     * @param name Define the name of the uniform as defined in the shader
     * @param buffer Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setUniformBuffer(name, buffer) {
        if (this._options.uniformBuffers.indexOf(name) === -1) this._options.uniformBuffers.push(name);
        this._uniformBuffers[name] = buffer;
        return this;
    }
    /**
     * Set a texture sampler in the shader
     * @param name Define the name of the uniform as defined in the shader
     * @param sampler Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setTextureSampler(name, sampler) {
        if (this._options.samplerObjects.indexOf(name) === -1) this._options.samplerObjects.push(name);
        this._textureSamplers[name] = sampler;
        return this;
    }
    /**
     * Set a storage buffer in the shader
     * @param name Define the name of the storage buffer as defined in the shader
     * @param buffer Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setStorageBuffer(name, buffer) {
        if (this._options.storageBuffers.indexOf(name) === -1) this._options.storageBuffers.push(name);
        this._storageBuffers[name] = buffer;
        return this;
    }
    /**
     * Adds, removes, or replaces the specified shader define and value.
     * * setDefine("MY_DEFINE", true); // enables a boolean define
     * * setDefine("MY_DEFINE", "0.5"); // adds "#define MY_DEFINE 0.5" to the shader (or sets and replaces the value of any existing define with that name)
     * * setDefine("MY_DEFINE", false); // disables and removes the define
     * Note if the active defines do change, the shader will be recompiled and this can be expensive.
     * @param define the define name e.g., "OUTPUT_TO_SRGB" or "#define OUTPUT_TO_SRGB". If the define was passed into the constructor already, the version used should match that, and in either case, it should not include any appended value.
     * @param value either the value of the define (e.g. a numerical value) or for booleans, true if the define should be enabled or false if it should be disabled
     * @returns the material itself allowing "fluent" like uniform updates
     */ setDefine(define, value) {
        // First remove any existing define with this name.
        const defineName = define.trimEnd() + " ";
        const existingDefineIdx = this.options.defines.findIndex((x)=>x === define || x.startsWith(defineName));
        if (existingDefineIdx >= 0) this.options.defines.splice(existingDefineIdx, 1);
        // Then add the new define value. (If it's a boolean value and false, don't add it.)
        if (typeof value !== "boolean" || value) this.options.defines.push(defineName + value);
        return this;
    }
    /**
     * Specifies that the submesh is ready to be used
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ isReadyForSubMesh(mesh, subMesh, useInstances) {
        return this.isReady(mesh, useInstances, subMesh);
    }
    /**
     * Checks if the material is ready to render the requested mesh
     * @param mesh Define the mesh to render
     * @param useInstances Define whether or not the material is used with instances
     * @param subMesh defines which submesh to render
     * @returns true if ready, otherwise false
     */ isReady(mesh, useInstances, subMesh) {
        const storeEffectOnSubMeshes = subMesh && this._storeEffectOnSubMeshes;
        if (this.isFrozen) {
            const drawWrapper = storeEffectOnSubMeshes ? subMesh._drawWrapper : this._drawWrapper;
            if (drawWrapper.effect && drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        const scene = this.getScene();
        const engine = scene.getEngine();
        // Instances
        const defines = [];
        const attribs = [];
        let fallbacks = null;
        let shaderName = this._shaderPath, uniforms = this._options.uniforms, uniformBuffers = this._options.uniformBuffers, samplers = this._options.samplers;
        // global multiview
        if (engine.getCaps().multiview && scene.activeCamera && scene.activeCamera.outputRenderTarget && scene.activeCamera.outputRenderTarget.getViewCount() > 1) {
            this._multiview = true;
            defines.push("#define MULTIVIEW");
            if (uniforms.indexOf("viewProjection") !== -1 && uniforms.indexOf("viewProjectionR") === -1) uniforms.push("viewProjectionR");
        }
        for(let index = 0; index < this._options.defines.length; index++){
            const defineToAdd = this._options.defines[index].indexOf("#define") === 0 ? this._options.defines[index] : `#define ${this._options.defines[index]}`;
            defines.push(defineToAdd);
        }
        for(let index = 0; index < this._options.attributes.length; index++)attribs.push(this._options.attributes[index]);
        if (mesh && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind)) {
            if (attribs.indexOf((0, $b4i1f.VertexBuffer).ColorKind) === -1) attribs.push((0, $b4i1f.VertexBuffer).ColorKind);
            defines.push("#define VERTEXCOLOR");
        }
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $7893e784ec9add9a$export$3016ce9563275624)(attribs, this._materialHelperNeedsPreviousMatrices);
            if (mesh?.hasThinInstances) {
                defines.push("#define THIN_INSTANCES");
                if (mesh && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorInstanceKind)) {
                    attribs.push((0, $b4i1f.VertexBuffer).ColorInstanceKind);
                    defines.push("#define INSTANCESCOLOR");
                }
            }
        }
        // Bones
        if (mesh && mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            const skeleton = mesh.skeleton;
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            fallbacks = new (0, $bca4896819e5389c$export$3e78d35a7e1b5710)();
            fallbacks.addCPUSkinningFallback(0, mesh);
            if (skeleton.isUsingTextureForMatrices) {
                defines.push("#define BONETEXTURE");
                if (uniforms.indexOf("boneTextureWidth") === -1) uniforms.push("boneTextureWidth");
                if (this._options.samplers.indexOf("boneSampler") === -1) this._options.samplers.push("boneSampler");
            } else {
                defines.push("#define BonesPerMesh " + (skeleton.bones.length + 1));
                if (uniforms.indexOf("mBones") === -1) uniforms.push("mBones");
            }
        } else defines.push("#define NUM_BONE_INFLUENCERS 0");
        // Morph
        let numInfluencers = 0;
        const manager = mesh ? mesh.morphTargetManager : null;
        if (manager) {
            const uv = defines.indexOf("#define UV1") !== -1;
            const uv2 = defines.indexOf("#define UV2") !== -1;
            const tangent = defines.indexOf("#define TANGENT") !== -1;
            const normal = defines.indexOf("#define NORMAL") !== -1;
            numInfluencers = (0, $7893e784ec9add9a$export$84f21fdc333b90e7)(manager, defines, attribs, mesh, true, normal, tangent, uv, uv2 // useUV2Morph
            );
            if (manager.isUsingTextureForTargets) {
                if (uniforms.indexOf("morphTargetTextureIndices") === -1) uniforms.push("morphTargetTextureIndices");
                if (this._options.samplers.indexOf("morphTargets") === -1) this._options.samplers.push("morphTargets");
            }
            if (numInfluencers > 0) {
                uniforms = uniforms.slice();
                uniforms.push("morphTargetInfluences");
                uniforms.push("morphTargetCount");
                uniforms.push("morphTargetTextureInfo");
                uniforms.push("morphTargetTextureIndices");
            }
        } else defines.push("#define NUM_MORPH_INFLUENCERS 0");
        // Baked Vertex Animation
        if (mesh) {
            const bvaManager = mesh.bakedVertexAnimationManager;
            if (bvaManager && bvaManager.isEnabled) {
                defines.push("#define BAKED_VERTEX_ANIMATION_TEXTURE");
                if (uniforms.indexOf("bakedVertexAnimationSettings") === -1) uniforms.push("bakedVertexAnimationSettings");
                if (uniforms.indexOf("bakedVertexAnimationTextureSizeInverted") === -1) uniforms.push("bakedVertexAnimationTextureSizeInverted");
                if (uniforms.indexOf("bakedVertexAnimationTime") === -1) uniforms.push("bakedVertexAnimationTime");
                if (this._options.samplers.indexOf("bakedVertexAnimationTexture") === -1) this._options.samplers.push("bakedVertexAnimationTexture");
            }
            (0, $7893e784ec9add9a$export$b48abe8455f59858)(attribs, mesh, defines);
        }
        // Textures
        for(const name in this._textures){
            if (!this._textures[name].isReady()) return false;
        }
        // Alpha test
        if (mesh && this._shouldTurnAlphaTestOn(mesh)) defines.push("#define ALPHATEST");
        // Clip planes
        if (this._options.useClipPlane !== false) {
            (0, $7b5d4109d15c2b5f$export$959caf24bcfab1fd)(uniforms);
            (0, $7b5d4109d15c2b5f$export$8deac9e8ed5fc6a9)(this, scene, defines);
        }
        // Fog
        if (scene.fogEnabled && mesh?.applyFog && scene.fogMode !== (0, $gmbCk.Scene).FOGMODE_NONE) {
            defines.push("#define FOG");
            if (uniforms.indexOf("view") === -1) uniforms.push("view");
            if (uniforms.indexOf("vFogInfos") === -1) uniforms.push("vFogInfos");
            if (uniforms.indexOf("vFogColor") === -1) uniforms.push("vFogColor");
        }
        // Misc
        if (this._useLogarithmicDepth) {
            defines.push("#define LOGARITHMICDEPTH");
            if (uniforms.indexOf("logarithmicDepthConstant") === -1) uniforms.push("logarithmicDepthConstant");
        }
        if (this.customShaderNameResolve) {
            uniforms = uniforms.slice();
            uniformBuffers = uniformBuffers.slice();
            samplers = samplers.slice();
            shaderName = this.customShaderNameResolve(this.name, uniforms, uniformBuffers, samplers, defines, attribs);
        }
        const drawWrapper = storeEffectOnSubMeshes ? subMesh._getDrawWrapper(undefined, true) : this._drawWrapper;
        const previousEffect = drawWrapper?.effect ?? null;
        const previousDefines = drawWrapper?.defines ?? null;
        const join = defines.join("\n");
        let effect = previousEffect;
        if (previousDefines !== join) {
            effect = engine.createEffect(shaderName, {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                fallbacks: fallbacks,
                onCompiled: this.onCompiled,
                onError: this.onError,
                indexParameters: {
                    maxSimultaneousMorphTargets: numInfluencers
                },
                shaderLanguage: this._options.shaderLanguage,
                extraInitializationsAsync: this._options.extraInitializationsAsync
            }, engine);
            if (storeEffectOnSubMeshes) subMesh.setEffect(effect, join, this._materialContext);
            else if (drawWrapper) drawWrapper.setEffect(effect, join);
            if (this._onEffectCreatedObservable) {
                $36e10aeb8f79d080$var$onCreatedEffectParameters.effect = effect;
                $36e10aeb8f79d080$var$onCreatedEffectParameters.subMesh = subMesh ?? mesh?.subMeshes[0] ?? null;
                this._onEffectCreatedObservable.notifyObservers($36e10aeb8f79d080$var$onCreatedEffectParameters);
            }
        }
        drawWrapper._wasPreviouslyUsingInstances = !!useInstances;
        if (!effect?.isReady()) return false;
        if (previousEffect !== effect) scene.resetCachedMaterial();
        drawWrapper._wasPreviouslyReady = true;
        return true;
    }
    /**
     * Binds the world matrix to the material
     * @param world defines the world transformation matrix
     * @param effectOverride - If provided, use this effect instead of internal effect
     */ bindOnlyWorldMatrix(world, effectOverride) {
        const effect = effectOverride ?? this.getEffect();
        if (!effect) return;
        const uniforms = this._options.uniforms;
        if (uniforms.indexOf("world") !== -1) effect.setMatrix("world", world);
        const scene = this.getScene();
        if (uniforms.indexOf("worldView") !== -1) {
            world.multiplyToRef(scene.getViewMatrix(), this._cachedWorldViewMatrix);
            effect.setMatrix("worldView", this._cachedWorldViewMatrix);
        }
        if (uniforms.indexOf("worldViewProjection") !== -1) {
            world.multiplyToRef(scene.getTransformMatrix(), this._cachedWorldViewProjectionMatrix);
            effect.setMatrix("worldViewProjection", this._cachedWorldViewProjectionMatrix);
        }
        if (uniforms.indexOf("view") !== -1) effect.setMatrix("view", scene.getViewMatrix());
    }
    /**
     * Binds the submesh to this material by preparing the effect and shader to draw
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        this.bind(world, mesh, subMesh._drawWrapperOverride?.effect, subMesh);
    }
    /**
     * Binds the material to the mesh
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh to bind the material to
     * @param effectOverride - If provided, use this effect instead of internal effect
     * @param subMesh defines the submesh to bind the material to
     */ bind(world, mesh, effectOverride, subMesh) {
        // Std values
        const storeEffectOnSubMeshes = subMesh && this._storeEffectOnSubMeshes;
        const effect = effectOverride ?? (storeEffectOnSubMeshes ? subMesh.effect : this.getEffect());
        if (!effect) return;
        const scene = this.getScene();
        this._activeEffect = effect;
        this.bindOnlyWorldMatrix(world, effectOverride);
        const uniformBuffers = this._options.uniformBuffers;
        let useSceneUBO = false;
        if (effect && uniformBuffers && uniformBuffers.length > 0 && scene.getEngine().supportsUniformBuffers) for(let i = 0; i < uniformBuffers.length; ++i){
            const bufferName = uniformBuffers[i];
            switch(bufferName){
                case "Mesh":
                    if (mesh) {
                        mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                        mesh.transferToEffect(world);
                    }
                    break;
                case "Scene":
                    (0, $7893e784ec9add9a$export$92f8908347587afc)(effect, scene.getSceneUniformBuffer());
                    scene.finalizeSceneUbo();
                    useSceneUBO = true;
                    break;
            }
        }
        const mustRebind = mesh && storeEffectOnSubMeshes ? this._mustRebind(scene, effect, subMesh, mesh.visibility) : scene.getCachedMaterial() !== this;
        if (effect && mustRebind) {
            if (!useSceneUBO && this._options.uniforms.indexOf("view") !== -1) effect.setMatrix("view", scene.getViewMatrix());
            if (!useSceneUBO && this._options.uniforms.indexOf("projection") !== -1) effect.setMatrix("projection", scene.getProjectionMatrix());
            if (!useSceneUBO && this._options.uniforms.indexOf("viewProjection") !== -1) {
                effect.setMatrix("viewProjection", scene.getTransformMatrix());
                if (this._multiview) effect.setMatrix("viewProjectionR", scene._transformMatrixR);
            }
            if (scene.activeCamera && this._options.uniforms.indexOf("cameraPosition") !== -1) effect.setVector3("cameraPosition", scene.activeCamera.globalPosition);
            // Bones
            (0, $7893e784ec9add9a$export$1544400469443a89)(mesh, effect);
            // Clip plane
            (0, $7b5d4109d15c2b5f$export$99061f41c02073b)(effect, this, scene);
            // Misc
            if (this._useLogarithmicDepth) (0, $7893e784ec9add9a$export$c51be962d0cbc5db)(storeEffectOnSubMeshes ? subMesh.materialDefines : effect.defines, effect, scene);
            // Fog
            if (mesh) (0, $7893e784ec9add9a$export$531a83026b679e28)(scene, mesh, effect);
            let name;
            // Texture
            for(name in this._textures)effect.setTexture(name, this._textures[name]);
            // Texture arrays
            for(name in this._textureArrays)effect.setTextureArray(name, this._textureArrays[name]);
            // Int
            for(name in this._ints)effect.setInt(name, this._ints[name]);
            // UInt
            for(name in this._uints)effect.setUInt(name, this._uints[name]);
            // Float
            for(name in this._floats)effect.setFloat(name, this._floats[name]);
            // Floats
            for(name in this._floatsArrays)effect.setArray(name, this._floatsArrays[name]);
            // Color3
            for(name in this._colors3)effect.setColor3(name, this._colors3[name]);
            // Color3Array
            for(name in this._colors3Arrays)effect.setArray3(name, this._colors3Arrays[name]);
            // Color4
            for(name in this._colors4){
                const color = this._colors4[name];
                effect.setFloat4(name, color.r, color.g, color.b, color.a);
            }
            // Color4Array
            for(name in this._colors4Arrays)effect.setArray4(name, this._colors4Arrays[name]);
            // Vector2
            for(name in this._vectors2)effect.setVector2(name, this._vectors2[name]);
            // Vector3
            for(name in this._vectors3)effect.setVector3(name, this._vectors3[name]);
            // Vector4
            for(name in this._vectors4)effect.setVector4(name, this._vectors4[name]);
            // Quaternion
            for(name in this._quaternions)effect.setQuaternion(name, this._quaternions[name]);
            // Matrix
            for(name in this._matrices)effect.setMatrix(name, this._matrices[name]);
            // MatrixArray
            for(name in this._matrixArrays)effect.setMatrices(name, this._matrixArrays[name]);
            // Matrix 3x3
            for(name in this._matrices3x3)effect.setMatrix3x3(name, this._matrices3x3[name]);
            // Matrix 2x2
            for(name in this._matrices2x2)effect.setMatrix2x2(name, this._matrices2x2[name]);
            // Vector2Array
            for(name in this._vectors2Arrays)effect.setArray2(name, this._vectors2Arrays[name]);
            // Vector3Array
            for(name in this._vectors3Arrays)effect.setArray3(name, this._vectors3Arrays[name]);
            // Vector4Array
            for(name in this._vectors4Arrays)effect.setArray4(name, this._vectors4Arrays[name]);
            // QuaternionArray
            for(name in this._quaternionsArrays)effect.setArray4(name, this._quaternionsArrays[name]);
            // Uniform buffers
            for(name in this._uniformBuffers){
                const buffer = this._uniformBuffers[name].getBuffer();
                if (buffer) effect.bindUniformBuffer(buffer, name);
            }
            const engineWebGPU = scene.getEngine();
            // External texture
            const setExternalTexture = engineWebGPU.setExternalTexture;
            if (setExternalTexture) for(name in this._externalTextures)setExternalTexture.call(engineWebGPU, name, this._externalTextures[name]);
            // Samplers
            const setTextureSampler = engineWebGPU.setTextureSampler;
            if (setTextureSampler) for(name in this._textureSamplers)setTextureSampler.call(engineWebGPU, name, this._textureSamplers[name]);
            // Storage buffers
            const setStorageBuffer = engineWebGPU.setStorageBuffer;
            if (setStorageBuffer) for(name in this._storageBuffers)setStorageBuffer.call(engineWebGPU, name, this._storageBuffers[name]);
        }
        if (effect && mesh && (mustRebind || !this.isFrozen)) {
            // Morph targets
            (0, $7893e784ec9add9a$export$f33581baf6024652)(mesh, effect);
            if (mesh.morphTargetManager && mesh.morphTargetManager.isUsingTextureForTargets) mesh.morphTargetManager._bind(effect);
            const bvaManager = mesh.bakedVertexAnimationManager;
            if (bvaManager && bvaManager.isEnabled) {
                const drawWrapper = storeEffectOnSubMeshes ? subMesh._drawWrapper : this._drawWrapper;
                mesh.bakedVertexAnimationManager?.bind(effect, !!drawWrapper._wasPreviouslyUsingInstances);
            }
        }
        this._afterBind(mesh, effect, subMesh);
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        const activeTextures = super.getActiveTextures();
        for(const name in this._textures)activeTextures.push(this._textures[name]);
        for(const name in this._textureArrays){
            const array = this._textureArrays[name];
            for(let index = 0; index < array.length; index++)activeTextures.push(array[index]);
        }
        return activeTextures;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        for(const name in this._textures){
            if (this._textures[name] === texture) return true;
        }
        for(const name in this._textureArrays){
            const array = this._textureArrays[name];
            for(let index = 0; index < array.length; index++){
                if (array[index] === texture) return true;
            }
        }
        return false;
    }
    /**
     * Makes a duplicate of the material, and gives it a new name
     * @param name defines the new name for the duplicated material
     * @returns the cloned material
     */ clone(name) {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $36e10aeb8f79d080$export$83c7d75d550a8b0d(name, this.getScene(), this._shaderPath, this._options, this._storeEffectOnSubMeshes), this);
        result.name = name;
        result.id = name;
        // Shader code path
        if (typeof result._shaderPath === "object") result._shaderPath = {
            ...result._shaderPath
        };
        // Options
        this._options = {
            ...this._options
        };
        Object.keys(this._options).forEach((propName)=>{
            const propValue = this._options[propName];
            if (Array.isArray(propValue)) this._options[propName] = propValue.slice(0);
        });
        // Stencil
        this.stencil.copyTo(result.stencil);
        // Texture
        for(const key in this._textures)result.setTexture(key, this._textures[key]);
        // TextureArray
        for(const key in this._textureArrays)result.setTextureArray(key, this._textureArrays[key]);
        // External texture
        for(const key in this._externalTextures)result.setExternalTexture(key, this._externalTextures[key]);
        // Int
        for(const key in this._ints)result.setInt(key, this._ints[key]);
        // UInt
        for(const key in this._uints)result.setUInt(key, this._uints[key]);
        // Float
        for(const key in this._floats)result.setFloat(key, this._floats[key]);
        // Floats
        for(const key in this._floatsArrays)result.setFloats(key, this._floatsArrays[key]);
        // Color3
        for(const key in this._colors3)result.setColor3(key, this._colors3[key]);
        // Color3Array
        for(const key in this._colors3Arrays)result._colors3Arrays[key] = this._colors3Arrays[key];
        // Color4
        for(const key in this._colors4)result.setColor4(key, this._colors4[key]);
        // Color4Array
        for(const key in this._colors4Arrays)result._colors4Arrays[key] = this._colors4Arrays[key];
        // Vector2
        for(const key in this._vectors2)result.setVector2(key, this._vectors2[key]);
        // Vector3
        for(const key in this._vectors3)result.setVector3(key, this._vectors3[key]);
        // Vector4
        for(const key in this._vectors4)result.setVector4(key, this._vectors4[key]);
        // Quaternion
        for(const key in this._quaternions)result.setQuaternion(key, this._quaternions[key]);
        // QuaternionArray
        for(const key in this._quaternionsArrays)result._quaternionsArrays[key] = this._quaternionsArrays[key];
        // Matrix
        for(const key in this._matrices)result.setMatrix(key, this._matrices[key]);
        // MatrixArray
        for(const key in this._matrixArrays)result._matrixArrays[key] = this._matrixArrays[key].slice();
        // Matrix 3x3
        for(const key in this._matrices3x3)result.setMatrix3x3(key, this._matrices3x3[key]);
        // Matrix 2x2
        for(const key in this._matrices2x2)result.setMatrix2x2(key, this._matrices2x2[key]);
        // Vector2Array
        for(const key in this._vectors2Arrays)result.setArray2(key, this._vectors2Arrays[key]);
        // Vector3Array
        for(const key in this._vectors3Arrays)result.setArray3(key, this._vectors3Arrays[key]);
        // Vector4Array
        for(const key in this._vectors4Arrays)result.setArray4(key, this._vectors4Arrays[key]);
        // Uniform buffers
        for(const key in this._uniformBuffers)result.setUniformBuffer(key, this._uniformBuffers[key]);
        // Samplers
        for(const key in this._textureSamplers)result.setTextureSampler(key, this._textureSamplers[key]);
        // Storag buffers
        for(const key in this._storageBuffers)result.setStorageBuffer(key, this._storageBuffers[key]);
        return result;
    }
    /**
     * Disposes the material
     * @param forceDisposeEffect specifies if effects should be forcefully disposed
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
     */ dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        if (forceDisposeTextures) {
            let name;
            for(name in this._textures)this._textures[name].dispose();
            for(name in this._textureArrays){
                const array = this._textureArrays[name];
                for(let index = 0; index < array.length; index++)array[index].dispose();
            }
        }
        this._textures = {};
        super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
    }
    /**
     * Serializes this material in a JSON representation
     * @returns the serialized material object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "BABYLON.ShaderMaterial";
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.options = this._options;
        serializationObject.shaderPath = this._shaderPath;
        serializationObject.storeEffectOnSubMeshes = this._storeEffectOnSubMeshes;
        let name;
        // Stencil
        serializationObject.stencil = this.stencil.serialize();
        // Texture
        serializationObject.textures = {};
        for(name in this._textures)serializationObject.textures[name] = this._textures[name].serialize();
        // Texture arrays
        serializationObject.textureArrays = {};
        for(name in this._textureArrays){
            serializationObject.textureArrays[name] = [];
            const array = this._textureArrays[name];
            for(let index = 0; index < array.length; index++)serializationObject.textureArrays[name].push(array[index].serialize());
        }
        // Int
        serializationObject.ints = {};
        for(name in this._ints)serializationObject.ints[name] = this._ints[name];
        // UInt
        serializationObject.uints = {};
        for(name in this._uints)serializationObject.uints[name] = this._uints[name];
        // Float
        serializationObject.floats = {};
        for(name in this._floats)serializationObject.floats[name] = this._floats[name];
        // Floats
        serializationObject.floatsArrays = {};
        for(name in this._floatsArrays)serializationObject.floatsArrays[name] = this._floatsArrays[name];
        // Color3
        serializationObject.colors3 = {};
        for(name in this._colors3)serializationObject.colors3[name] = this._colors3[name].asArray();
        // Color3 array
        serializationObject.colors3Arrays = {};
        for(name in this._colors3Arrays)serializationObject.colors3Arrays[name] = this._colors3Arrays[name];
        // Color4
        serializationObject.colors4 = {};
        for(name in this._colors4)serializationObject.colors4[name] = this._colors4[name].asArray();
        // Color4 array
        serializationObject.colors4Arrays = {};
        for(name in this._colors4Arrays)serializationObject.colors4Arrays[name] = this._colors4Arrays[name];
        // Vector2
        serializationObject.vectors2 = {};
        for(name in this._vectors2){
            const v2 = this._vectors2[name];
            serializationObject.vectors2[name] = [
                v2.x,
                v2.y
            ];
        }
        // Vector3
        serializationObject.vectors3 = {};
        for(name in this._vectors3){
            const v3 = this._vectors3[name];
            serializationObject.vectors3[name] = [
                v3.x,
                v3.y,
                v3.z
            ];
        }
        // Vector4
        serializationObject.vectors4 = {};
        for(name in this._vectors4){
            const v4 = this._vectors4[name];
            serializationObject.vectors4[name] = [
                v4.x,
                v4.y,
                v4.z,
                v4.w
            ];
        }
        // Quaternion
        serializationObject.quaternions = {};
        for(name in this._quaternions)serializationObject.quaternions[name] = this._quaternions[name].asArray();
        // Matrix
        serializationObject.matrices = {};
        for(name in this._matrices)serializationObject.matrices[name] = this._matrices[name].asArray();
        // MatrixArray
        serializationObject.matrixArray = {};
        for(name in this._matrixArrays)serializationObject.matrixArray[name] = this._matrixArrays[name];
        // Matrix 3x3
        serializationObject.matrices3x3 = {};
        for(name in this._matrices3x3)serializationObject.matrices3x3[name] = this._matrices3x3[name];
        // Matrix 2x2
        serializationObject.matrices2x2 = {};
        for(name in this._matrices2x2)serializationObject.matrices2x2[name] = this._matrices2x2[name];
        // Vector2Array
        serializationObject.vectors2Arrays = {};
        for(name in this._vectors2Arrays)serializationObject.vectors2Arrays[name] = this._vectors2Arrays[name];
        // Vector3Array
        serializationObject.vectors3Arrays = {};
        for(name in this._vectors3Arrays)serializationObject.vectors3Arrays[name] = this._vectors3Arrays[name];
        // Vector4Array
        serializationObject.vectors4Arrays = {};
        for(name in this._vectors4Arrays)serializationObject.vectors4Arrays[name] = this._vectors4Arrays[name];
        // QuaternionArray
        serializationObject.quaternionsArrays = {};
        for(name in this._quaternionsArrays)serializationObject.quaternionsArrays[name] = this._quaternionsArrays[name];
        return serializationObject;
    }
    /**
     * Creates a shader material from parsed shader material data
     * @param source defines the JSON representation of the material
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a new material
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $36e10aeb8f79d080$export$83c7d75d550a8b0d(source.name, scene, source.shaderPath, source.options, source.storeEffectOnSubMeshes), source, scene, rootUrl);
        let name;
        // Stencil
        if (source.stencil) material.stencil.parse(source.stencil, scene, rootUrl);
        // Texture
        for(name in source.textures)material.setTexture(name, (0, $j2mX5.Texture).Parse(source.textures[name], scene, rootUrl));
        // Texture arrays
        for(name in source.textureArrays){
            const array = source.textureArrays[name];
            const textureArray = [];
            for(let index = 0; index < array.length; index++)textureArray.push((0, $j2mX5.Texture).Parse(array[index], scene, rootUrl));
            material.setTextureArray(name, textureArray);
        }
        // Int
        for(name in source.ints)material.setInt(name, source.ints[name]);
        // UInt
        for(name in source.uints)material.setUInt(name, source.uints[name]);
        // Float
        for(name in source.floats)material.setFloat(name, source.floats[name]);
        // Floats
        for(name in source.floatsArrays)material.setFloats(name, source.floatsArrays[name]);
        // Color3
        for(name in source.colors3)material.setColor3(name, (0, $7etnY.Color3).FromArray(source.colors3[name]));
        // Color3 arrays
        for(name in source.colors3Arrays){
            const colors = source.colors3Arrays[name].reduce((arr, num, i)=>{
                if (i % 3 === 0) arr.push([
                    num
                ]);
                else arr[arr.length - 1].push(num);
                return arr;
            }, []).map((color)=>(0, $7etnY.Color3).FromArray(color));
            material.setColor3Array(name, colors);
        }
        // Color4
        for(name in source.colors4)material.setColor4(name, (0, $7etnY.Color4).FromArray(source.colors4[name]));
        // Color4 arrays
        for(name in source.colors4Arrays){
            const colors = source.colors4Arrays[name].reduce((arr, num, i)=>{
                if (i % 4 === 0) arr.push([
                    num
                ]);
                else arr[arr.length - 1].push(num);
                return arr;
            }, []).map((color)=>(0, $7etnY.Color4).FromArray(color));
            material.setColor4Array(name, colors);
        }
        // Vector2
        for(name in source.vectors2)material.setVector2(name, (0, $ha1VO.Vector2).FromArray(source.vectors2[name]));
        // Vector3
        for(name in source.vectors3)material.setVector3(name, (0, $ha1VO.Vector3).FromArray(source.vectors3[name]));
        // Vector4
        for(name in source.vectors4)material.setVector4(name, (0, $ha1VO.Vector4).FromArray(source.vectors4[name]));
        // Quaternion
        for(name in source.quaternions)material.setQuaternion(name, (0, $ha1VO.Quaternion).FromArray(source.quaternions[name]));
        // Matrix
        for(name in source.matrices)material.setMatrix(name, (0, $ha1VO.Matrix).FromArray(source.matrices[name]));
        // MatrixArray
        for(name in source.matrixArray)material._matrixArrays[name] = new Float32Array(source.matrixArray[name]);
        // Matrix 3x3
        for(name in source.matrices3x3)material.setMatrix3x3(name, source.matrices3x3[name]);
        // Matrix 2x2
        for(name in source.matrices2x2)material.setMatrix2x2(name, source.matrices2x2[name]);
        // Vector2Array
        for(name in source.vectors2Arrays)material.setArray2(name, source.vectors2Arrays[name]);
        // Vector3Array
        for(name in source.vectors3Arrays)material.setArray3(name, source.vectors3Arrays[name]);
        // Vector4Array
        for(name in source.vectors4Arrays)material.setArray4(name, source.vectors4Arrays[name]);
        // QuaternionArray
        for(name in source.quaternionsArrays)material.setArray4(name, source.quaternionsArrays[name]);
        return material;
    }
    /**
     * Creates a new ShaderMaterial from a snippet saved in a remote file
     * @param name defines the name of the ShaderMaterial to create (can be null or empty to use the one from the json data)
     * @param url defines the url to load from
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new ShaderMaterial
     */ static ParseFromFileAsync(name, url, scene, rootUrl = "") {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const serializationObject = JSON.parse(request.responseText);
                        const output = this.Parse(serializationObject, scene || (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl);
                        if (name) output.name = name;
                        resolve(output);
                    } else reject("Unable to load the ShaderMaterial");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    /**
     * Creates a ShaderMaterial from a snippet saved by the Inspector
     * @param snippetId defines the snippet to load
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new ShaderMaterial
     */ static ParseFromSnippetAsync(snippetId, scene, rootUrl = "") {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        const serializationObject = JSON.parse(snippet.shaderMaterial);
                        const output = this.Parse(serializationObject, scene || (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl);
                        output.snippetId = snippetId;
                        resolve(output);
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
/** Define the Url to load snippets */ $36e10aeb8f79d080$export$83c7d75d550a8b0d.SnippetUrl = `https://snippet.babylonjs.com`;
/**
 * Creates a ShaderMaterial from a snippet saved by the Inspector
 * @deprecated Please use ParseFromSnippetAsync instead
 * @param snippetId defines the snippet to load
 * @param scene defines the hosting scene
 * @param rootUrl defines the root URL to use to load textures and relative dependencies
 * @returns a promise that will resolve to the new ShaderMaterial
 */ $36e10aeb8f79d080$export$83c7d75d550a8b0d.CreateFromSnippetAsync = $36e10aeb8f79d080$export$83c7d75d550a8b0d.ParseFromSnippetAsync;
(0, $8DoUR.RegisterClass)("BABYLON.ShaderMaterial", $36e10aeb8f79d080$export$83c7d75d550a8b0d);


(0, $b0df7c384622c537$export$e176487c05830cc5)._LinesMeshParser = (parsedMesh, scene)=>{
    return $769a2062ec6bae3f$export$9955070e3d6299.Parse(parsedMesh, scene);
};




class $769a2062ec6bae3f$export$9955070e3d6299 extends (0, $b0df7c384622c537$export$e176487c05830cc5) {
    _isShaderMaterial(shader) {
        return shader.getClassName() === "ShaderMaterial";
    }
    /**
     * Creates a new LinesMesh
     * @param name defines the name
     * @param scene defines the hosting scene
     * @param parent defines the parent mesh if any
     * @param source defines the optional source LinesMesh used to clone data from
     * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
     * When false, achieved by calling a clone(), also passing False.
     * This will make creation of children, recursive.
     * @param useVertexColor defines if this LinesMesh supports vertex color
     * @param useVertexAlpha defines if this LinesMesh supports vertex alpha
     * @param material material to use to draw the line. If not provided, will create a new one
     */ constructor(name, scene = null, parent = null, source = null, doNotCloneChildren, /**
     * If vertex color should be applied to the mesh
     */ useVertexColor, /**
     * If vertex alpha should be applied to the mesh
     */ useVertexAlpha, material){
        super(name, scene, parent, source, doNotCloneChildren);
        this.useVertexColor = useVertexColor;
        this.useVertexAlpha = useVertexAlpha;
        /**
         * Color of the line (Default: White)
         */ this.color = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Alpha of the line (Default: 1)
         */ this.alpha = 1;
        /** Shader language used by the material */ this._shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
        if (source) {
            this.color = source.color.clone();
            this.alpha = source.alpha;
            this.useVertexColor = source.useVertexColor;
            this.useVertexAlpha = source.useVertexAlpha;
        }
        this.intersectionThreshold = 0.1;
        const defines = [];
        const options = {
            attributes: [
                (0, $b4i1f.VertexBuffer).PositionKind
            ],
            uniforms: [
                "world",
                "viewProjection"
            ],
            needAlphaBlending: true,
            defines: defines,
            useClipPlane: null,
            shaderLanguage: 0 /* ShaderLanguage.GLSL */ 
        };
        if (!this.useVertexAlpha) options.needAlphaBlending = false;
        else options.defines.push("#define VERTEXALPHA");
        if (!this.useVertexColor) {
            options.uniforms.push("color");
            this._color4 = new (0, $7etnY.Color4)();
        } else {
            options.defines.push("#define VERTEXCOLOR");
            options.attributes.push((0, $b4i1f.VertexBuffer).ColorKind);
        }
        if (material) this.material = material;
        else {
            const engine = this.getScene().getEngine();
            if (engine.isWebGPU && !$769a2062ec6bae3f$export$9955070e3d6299.ForceGLSL) this._shaderLanguage = 1 /* ShaderLanguage.WGSL */ ;
            options.shaderLanguage = this._shaderLanguage;
            options.extraInitializationsAsync = async ()=>{
                if (this._shaderLanguage === 1 /* ShaderLanguage.WGSL */ ) await Promise.all([
                    (parcelRequire("6CP4X")),
                    (parcelRequire("ksj2w"))
                ]);
                else await Promise.all([
                    (parcelRequire("h3R3m")),
                    (parcelRequire("44nRt"))
                ]);
            };
            this.material = new (0, $36e10aeb8f79d080$export$83c7d75d550a8b0d)("colorShader", this.getScene(), "color", options, false);
            this.material.doNotSerialize = true;
        }
    }
    isReady() {
        if (!this._lineMaterial.isReady(this, !!this._userInstancedBuffersStorage || this.hasThinInstances)) return false;
        return super.isReady();
    }
    /**
     * @returns the string "LineMesh"
     */ getClassName() {
        return "LinesMesh";
    }
    /**
     * @internal
     */ get material() {
        return this._lineMaterial;
    }
    /**
     * @internal
     */ set material(value) {
        this._lineMaterial = value;
        this._lineMaterial.fillMode = (0, $3afee756ef198914$export$a2d8b23205c25948).LineListDrawMode;
    }
    /**
     * @internal
     */ get checkCollisions() {
        return false;
    }
    set checkCollisions(value) {
    // Just ignore it
    }
    /**
     * @internal
     */ _bind(_subMesh, colorEffect) {
        if (!this._geometry) return this;
        // VBOs
        const indexToBind = this.isUnIndexed ? null : this._geometry.getIndexBuffer();
        if (!this._userInstancedBuffersStorage || this.hasThinInstances) this._geometry._bind(colorEffect, indexToBind);
        else this._geometry._bind(colorEffect, indexToBind, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects);
        // Color
        if (!this.useVertexColor && this._isShaderMaterial(this._lineMaterial)) {
            const { r: r, g: g, b: b } = this.color;
            this._color4.set(r, g, b, this.alpha);
            this._lineMaterial.setColor4("color", this._color4);
        }
        return this;
    }
    /**
     * @internal
     */ _draw(subMesh, fillMode, instancesCount) {
        if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer()) return this;
        const engine = this.getScene().getEngine();
        // Draw order
        if (this._unIndexed) engine.drawArraysType((0, $3afee756ef198914$export$a2d8b23205c25948).LineListDrawMode, subMesh.verticesStart, subMesh.verticesCount, instancesCount);
        else engine.drawElementsType((0, $3afee756ef198914$export$a2d8b23205c25948).LineListDrawMode, subMesh.indexStart, subMesh.indexCount, instancesCount);
        return this;
    }
    /**
     * Disposes of the line mesh
     * @param doNotRecurse If children should be disposed
     * @param disposeMaterialAndTextures This parameter is not used by the LineMesh class
     * @param doNotDisposeMaterial If the material should not be disposed (default: false, meaning the material is disposed)
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispose(doNotRecurse, disposeMaterialAndTextures = false, doNotDisposeMaterial) {
        if (!doNotDisposeMaterial) this._lineMaterial.dispose(false, false, true);
        super.dispose(doNotRecurse);
    }
    /**
     * Returns a new LineMesh object cloned from the current one.
     * @param name defines the cloned mesh name
     * @param newParent defines the new mesh parent
     * @param doNotCloneChildren if set to true, none of the mesh children are cloned (false by default)
     * @returns the new mesh
     */ clone(name, newParent = null, doNotCloneChildren) {
        return new $769a2062ec6bae3f$export$9955070e3d6299(name, this.getScene(), newParent, this, doNotCloneChildren);
    }
    /**
     * Creates a new InstancedLinesMesh object from the mesh model.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
     * @param name defines the name of the new instance
     * @returns a new InstancedLinesMesh
     */ createInstance(name) {
        const instance = new $769a2062ec6bae3f$export$59ce9705b5ce8121(name, this);
        if (this.instancedBuffers) {
            instance.instancedBuffers = {};
            for(const key in this.instancedBuffers)instance.instancedBuffers[key] = this.instancedBuffers[key];
        }
        return instance;
    }
    /**
     * Serializes this ground mesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.color = this.color.asArray();
        serializationObject.alpha = this.alpha;
    }
    /**
     * Parses a serialized ground mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the ground mesh in
     * @returns the created ground mesh
     */ static Parse(parsedMesh, scene) {
        const result = new $769a2062ec6bae3f$export$9955070e3d6299(parsedMesh.name, scene);
        result.color = (0, $7etnY.Color3).FromArray(parsedMesh.color);
        result.alpha = parsedMesh.alpha;
        return result;
    }
}
/**
 * Force all the LineMeshes to compile their default color material to glsl even on WebGPU engines.
 * False by default. This is mostly meant for backward compatibility.
 */ $769a2062ec6bae3f$export$9955070e3d6299.ForceGLSL = false;
class $769a2062ec6bae3f$export$59ce9705b5ce8121 extends (0, $740423c584384d56$export$f3c979c331175ad7) {
    constructor(name, source){
        super(name, source);
        this.intersectionThreshold = source.intersectionThreshold;
    }
    /**
     * @returns the string "InstancedLinesMesh".
     */ getClassName() {
        return "InstancedLinesMesh";
    }
}



var $b4i1f = parcelRequire("b4i1f");

var $kVtWi = parcelRequire("kVtWi");
function $64ccbca0cbde8de7$export$a5883ab4872ed73d(options) {
    const indices = [];
    const positions = [];
    const lines = options.lines;
    const colors = options.colors;
    const vertexColors = [];
    let idx = 0;
    for(let l = 0; l < lines.length; l++){
        const points = lines[l];
        for(let index = 0; index < points.length; index++){
            const { x: x, y: y, z: z } = points[index];
            positions.push(x, y, z);
            if (colors) {
                const color = colors[l];
                const { r: r, g: g, b: b, a: a } = color[index];
                vertexColors.push(r, g, b, a);
            }
            if (index > 0) {
                indices.push(idx - 1);
                indices.push(idx);
            }
            idx++;
        }
    }
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    if (colors) vertexData.colors = vertexColors;
    return vertexData;
}
function $64ccbca0cbde8de7$export$258b4b1be50025(options) {
    const dashSize = options.dashSize || 3;
    const gapSize = options.gapSize || 1;
    const dashNb = options.dashNb || 200;
    const points = options.points;
    const positions = [];
    const indices = [];
    const curvect = (0, $ha1VO.Vector3).Zero();
    let lg = 0;
    let nb = 0;
    let shft = 0;
    let dashshft = 0;
    let curshft = 0;
    let idx = 0;
    let i = 0;
    for(i = 0; i < points.length - 1; i++){
        points[i + 1].subtractToRef(points[i], curvect);
        lg += curvect.length();
    }
    shft = lg / dashNb;
    dashshft = dashSize * shft / (dashSize + gapSize);
    for(i = 0; i < points.length - 1; i++){
        points[i + 1].subtractToRef(points[i], curvect);
        nb = Math.floor(curvect.length() / shft);
        curvect.normalize();
        for(let j = 0; j < nb; j++){
            curshft = shft * j;
            positions.push(points[i].x + curshft * curvect.x, points[i].y + curshft * curvect.y, points[i].z + curshft * curvect.z);
            positions.push(points[i].x + (curshft + dashshft) * curvect.x, points[i].y + (curshft + dashshft) * curvect.y, points[i].z + (curshft + dashshft) * curvect.z);
            indices.push(idx, idx + 1);
            idx += 2;
        }
    }
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.positions = positions;
    vertexData.indices = indices;
    return vertexData;
}
function $64ccbca0cbde8de7$export$d2e386952db4e290(name, options, scene = null) {
    const instance = options.instance;
    const lines = options.lines;
    const colors = options.colors;
    if (instance) {
        // lines update
        const positions = instance.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        let vertexColor;
        let lineColors;
        if (colors) vertexColor = instance.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        let i = 0;
        let c = 0;
        for(let l = 0; l < lines.length; l++){
            const points = lines[l];
            for(let p = 0; p < points.length; p++){
                positions[i] = points[p].x;
                positions[i + 1] = points[p].y;
                positions[i + 2] = points[p].z;
                if (colors && vertexColor) {
                    lineColors = colors[l];
                    vertexColor[c] = lineColors[p].r;
                    vertexColor[c + 1] = lineColors[p].g;
                    vertexColor[c + 2] = lineColors[p].b;
                    vertexColor[c + 3] = lineColors[p].a;
                    c += 4;
                }
                i += 3;
            }
        }
        instance.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, false, false);
        if (colors && vertexColor) instance.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, vertexColor, false, false);
        instance.refreshBoundingInfo();
        return instance;
    }
    // line system creation
    const useVertexColor = colors ? true : false;
    const lineSystem = new (0, $769a2062ec6bae3f$export$9955070e3d6299)(name, scene, null, undefined, undefined, useVertexColor, options.useVertexAlpha, options.material);
    const vertexData = $64ccbca0cbde8de7$export$a5883ab4872ed73d(options);
    vertexData.applyToMesh(lineSystem, options.updatable);
    return lineSystem;
}
function $64ccbca0cbde8de7$export$5c8430a92ff1a8d2(name, options, scene = null) {
    const colors = options.colors ? [
        options.colors
    ] : null;
    const lines = $64ccbca0cbde8de7$export$d2e386952db4e290(name, {
        lines: [
            options.points
        ],
        updatable: options.updatable,
        instance: options.instance,
        colors: colors,
        useVertexAlpha: options.useVertexAlpha,
        material: options.material
    }, scene);
    return lines;
}
function $64ccbca0cbde8de7$export$1a25fda3f613818a(name, options, scene = null) {
    const points = options.points;
    const instance = options.instance;
    const gapSize = options.gapSize || 1;
    const dashSize = options.dashSize || 3;
    if (instance) {
        //  dashed lines update
        const positionFunction = (positions)=>{
            const curvect = (0, $ha1VO.Vector3).Zero();
            const nbSeg = positions.length / 6;
            let lg = 0;
            let nb = 0;
            let shft = 0;
            let dashshft = 0;
            let curshft = 0;
            let p = 0;
            let i = 0;
            let j = 0;
            for(i = 0; i < points.length - 1; i++){
                points[i + 1].subtractToRef(points[i], curvect);
                lg += curvect.length();
            }
            shft = lg / nbSeg;
            const dashSize = instance._creationDataStorage.dashSize;
            const gapSize = instance._creationDataStorage.gapSize;
            dashshft = dashSize * shft / (dashSize + gapSize);
            for(i = 0; i < points.length - 1; i++){
                points[i + 1].subtractToRef(points[i], curvect);
                nb = Math.floor(curvect.length() / shft);
                curvect.normalize();
                j = 0;
                while(j < nb && p < positions.length){
                    curshft = shft * j;
                    positions[p] = points[i].x + curshft * curvect.x;
                    positions[p + 1] = points[i].y + curshft * curvect.y;
                    positions[p + 2] = points[i].z + curshft * curvect.z;
                    positions[p + 3] = points[i].x + (curshft + dashshft) * curvect.x;
                    positions[p + 4] = points[i].y + (curshft + dashshft) * curvect.y;
                    positions[p + 5] = points[i].z + (curshft + dashshft) * curvect.z;
                    p += 6;
                    j++;
                }
            }
            while(p < positions.length){
                positions[p] = points[i].x;
                positions[p + 1] = points[i].y;
                positions[p + 2] = points[i].z;
                p += 3;
            }
        };
        if (options.dashNb || options.dashSize || options.gapSize || options.useVertexAlpha || options.material) (0, $kVtWi.Logger).Warn("You have used an option other than points with the instance option. Please be aware that these other options will be ignored.");
        instance.updateMeshPositions(positionFunction, false);
        return instance;
    }
    // dashed lines creation
    const dashedLines = new (0, $769a2062ec6bae3f$export$9955070e3d6299)(name, scene, null, undefined, undefined, undefined, options.useVertexAlpha, options.material);
    const vertexData = $64ccbca0cbde8de7$export$258b4b1be50025(options);
    vertexData.applyToMesh(dashedLines, options.updatable);
    dashedLines._creationDataStorage = new (0, $b0df7c384622c537$export$40270a8f3a8ca785)();
    dashedLines._creationDataStorage.dashSize = dashSize;
    dashedLines._creationDataStorage.gapSize = gapSize;
    return dashedLines;
}
const $64ccbca0cbde8de7$export$9cd2aadbd9dffed = {
    CreateDashedLines: $64ccbca0cbde8de7$export$1a25fda3f613818a,
    CreateLineSystem: $64ccbca0cbde8de7$export$d2e386952db4e290,
    CreateLines: $64ccbca0cbde8de7$export$5c8430a92ff1a8d2
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateLineSystem = $64ccbca0cbde8de7$export$a5883ab4872ed73d;
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateDashedLines = $64ccbca0cbde8de7$export$258b4b1be50025;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateLines = (name, points, scene = null, updatable = false, instance = null)=>{
    const options = {
        points: points,
        updatable: updatable,
        instance: instance
    };
    return $64ccbca0cbde8de7$export$5c8430a92ff1a8d2(name, options, scene);
};
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateDashedLines = (name, points, dashSize, gapSize, dashNb, scene = null, updatable, instance)=>{
    const options = {
        points: points,
        dashSize: dashSize,
        gapSize: gapSize,
        dashNb: dashNb,
        updatable: updatable,
        instance: instance
    };
    return $64ccbca0cbde8de7$export$1a25fda3f613818a(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");



var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");



var $fm2C6 = parcelRequire("fm2C6");

var $53VPf = parcelRequire("53VPf");

var $ejQPp = parcelRequire("ejQPp");
/**
 * Vector2 wth index property
 */ class $756019cf1144be99$var$IndexedVector2 extends (0, $ha1VO.Vector2) {
    constructor(original, /** Index of the vector2 */ index){
        super(original.x, original.y);
        this.index = index;
    }
}
/**
 * Defines points to create a polygon
 */ class $756019cf1144be99$var$PolygonPoints {
    constructor(){
        this.elements = [];
    }
    add(originalPoints) {
        const result = [];
        originalPoints.forEach((point)=>{
            const newPoint = new $756019cf1144be99$var$IndexedVector2(point, this.elements.length);
            result.push(newPoint);
            this.elements.push(newPoint);
        });
        return result;
    }
    computeBounds() {
        const lmin = new (0, $ha1VO.Vector2)(this.elements[0].x, this.elements[0].y);
        const lmax = new (0, $ha1VO.Vector2)(this.elements[0].x, this.elements[0].y);
        this.elements.forEach((point)=>{
            // x
            if (point.x < lmin.x) lmin.x = point.x;
            else if (point.x > lmax.x) lmax.x = point.x;
            // y
            if (point.y < lmin.y) lmin.y = point.y;
            else if (point.y > lmax.y) lmax.y = point.y;
        });
        return {
            min: lmin,
            max: lmax,
            width: lmax.x - lmin.x,
            height: lmax.y - lmin.y
        };
    }
}
class $756019cf1144be99$export$7d31b617c820d435 {
    /**
     * Creates a rectangle
     * @param xmin bottom X coord
     * @param ymin bottom Y coord
     * @param xmax top X coord
     * @param ymax top Y coord
     * @returns points that make the resulting rectangle
     */ static Rectangle(xmin, ymin, xmax, ymax) {
        return [
            new (0, $ha1VO.Vector2)(xmin, ymin),
            new (0, $ha1VO.Vector2)(xmax, ymin),
            new (0, $ha1VO.Vector2)(xmax, ymax),
            new (0, $ha1VO.Vector2)(xmin, ymax)
        ];
    }
    /**
     * Creates a circle
     * @param radius radius of circle
     * @param cx scale in x
     * @param cy scale in y
     * @param numberOfSides number of sides that make up the circle
     * @returns points that make the resulting circle
     */ static Circle(radius, cx = 0, cy = 0, numberOfSides = 32) {
        const result = [];
        let angle = 0;
        const increment = Math.PI * 2 / numberOfSides;
        for(let i = 0; i < numberOfSides; i++){
            result.push(new (0, $ha1VO.Vector2)(cx + Math.cos(angle) * radius, cy + Math.sin(angle) * radius));
            angle -= increment;
        }
        return result;
    }
    /**
     * Creates a polygon from input string
     * @param input Input polygon data
     * @returns the parsed points
     */ static Parse(input) {
        const floats = input.split(/[^-+eE.\d]+/).map(parseFloat).filter((val)=>!isNaN(val));
        let i;
        const result = [];
        for(i = 0; i < (floats.length & 0x7ffffffe); i += 2)result.push(new (0, $ha1VO.Vector2)(floats[i], floats[i + 1]));
        return result;
    }
    /**
     * Starts building a polygon from x and y coordinates
     * @param x x coordinate
     * @param y y coordinate
     * @returns the started path2
     */ static StartingAt(x, y) {
        return (0, $fm2C6.Path2).StartingAt(x, y);
    }
}
class $756019cf1144be99$export$b8a40edac54f9787 {
    _addToepoint(points) {
        for (const p of points)this._epoints.push(p.x, p.y);
    }
    /**
     * Creates a PolygonMeshBuilder
     * @param name name of the builder
     * @param contours Path of the polygon
     * @param scene scene to add to when creating the mesh
     * @param earcutInjection can be used to inject your own earcut reference
     */ constructor(name, contours, scene, earcutInjection = earcut){
        this._points = new $756019cf1144be99$var$PolygonPoints();
        this._outlinepoints = new $756019cf1144be99$var$PolygonPoints();
        this._holes = new Array();
        this._epoints = new Array();
        this._eholes = new Array();
        this.bjsEarcut = earcutInjection;
        this._name = name;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        let points;
        if (contours instanceof (0, $fm2C6.Path2)) points = contours.getPoints();
        else points = contours;
        this._addToepoint(points);
        this._points.add(points);
        this._outlinepoints.add(points);
        if (typeof this.bjsEarcut === "undefined") (0, $kVtWi.Logger).Warn("Earcut was not found, the polygon will not be built.");
    }
    /**
     * Adds a hole within the polygon
     * @param hole Array of points defining the hole
     * @returns this
     */ addHole(hole) {
        this._points.add(hole);
        const holepoints = new $756019cf1144be99$var$PolygonPoints();
        holepoints.add(hole);
        this._holes.push(holepoints);
        this._eholes.push(this._epoints.length / 2);
        this._addToepoint(hole);
        return this;
    }
    /**
     * Creates the polygon
     * @param updatable If the mesh should be updatable
     * @param depth The depth of the mesh created
     * @param smoothingThreshold Dot product threshold for smoothed normals
     * @returns the created mesh
     */ build(updatable = false, depth = 0, smoothingThreshold = 2) {
        const result = new (0, $b0df7c384622c537$export$e176487c05830cc5)(this._name, this._scene);
        const vertexData = this.buildVertexData(depth, smoothingThreshold);
        result.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, vertexData.positions, updatable);
        result.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, vertexData.normals, updatable);
        result.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, vertexData.uvs, updatable);
        result.setIndices(vertexData.indices);
        return result;
    }
    /**
     * Creates the polygon
     * @param depth The depth of the mesh created
     * @param smoothingThreshold Dot product threshold for smoothed normals
     * @returns the created VertexData
     */ buildVertexData(depth = 0, smoothingThreshold = 2) {
        const result = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
        const normals = [];
        const positions = [];
        const uvs = [];
        const bounds = this._points.computeBounds();
        this._points.elements.forEach((p)=>{
            normals.push(0, 1.0, 0);
            positions.push(p.x, 0, p.y);
            uvs.push((p.x - bounds.min.x) / bounds.width, (p.y - bounds.min.y) / bounds.height);
        });
        const indices = [];
        const res = this.bjsEarcut(this._epoints, this._eholes, 2);
        for(let i = 0; i < res.length; i++)indices.push(res[i]);
        if (depth > 0) {
            const positionscount = positions.length / 3; //get the current pointcount
            this._points.elements.forEach((p)=>{
                //add the elements at the depth
                normals.push(0, -1, 0);
                positions.push(p.x, -depth, p.y);
                uvs.push(1 - (p.x - bounds.min.x) / bounds.width, 1 - (p.y - bounds.min.y) / bounds.height);
            });
            const totalCount = indices.length;
            for(let i = 0; i < totalCount; i += 3){
                const i0 = indices[i + 0];
                const i1 = indices[i + 1];
                const i2 = indices[i + 2];
                indices.push(i2 + positionscount);
                indices.push(i1 + positionscount);
                indices.push(i0 + positionscount);
            }
            //Add the sides
            this._addSide(positions, normals, uvs, indices, bounds, this._outlinepoints, depth, false, smoothingThreshold);
            this._holes.forEach((hole)=>{
                this._addSide(positions, normals, uvs, indices, bounds, hole, depth, true, smoothingThreshold);
            });
        }
        result.indices = indices;
        result.positions = positions;
        result.normals = normals;
        result.uvs = uvs;
        return result;
    }
    /**
     * Adds a side to the polygon
     * @param positions points that make the polygon
     * @param normals normals of the polygon
     * @param uvs uvs of the polygon
     * @param indices indices of the polygon
     * @param bounds bounds of the polygon
     * @param points points of the polygon
     * @param depth depth of the polygon
     * @param flip flip of the polygon
     * @param smoothingThreshold
     */ _addSide(positions, normals, uvs, indices, bounds, points, depth, flip, smoothingThreshold) {
        let startIndex = positions.length / 3;
        let ulength = 0;
        for(let i = 0; i < points.elements.length; i++){
            const p = points.elements[i];
            const p1 = points.elements[(i + 1) % points.elements.length];
            positions.push(p.x, 0, p.y);
            positions.push(p.x, -depth, p.y);
            positions.push(p1.x, 0, p1.y);
            positions.push(p1.x, -depth, p1.y);
            const p0 = points.elements[(i + points.elements.length - 1) % points.elements.length];
            const p2 = points.elements[(i + 2) % points.elements.length];
            let vc = new (0, $ha1VO.Vector3)(-(p1.y - p.y), 0, p1.x - p.x);
            let vp = new (0, $ha1VO.Vector3)(-(p.y - p0.y), 0, p.x - p0.x);
            let vn = new (0, $ha1VO.Vector3)(-(p2.y - p1.y), 0, p2.x - p1.x);
            if (!flip) {
                vc = vc.scale(-1);
                vp = vp.scale(-1);
                vn = vn.scale(-1);
            }
            const vc_norm = vc.normalizeToNew();
            let vp_norm = vp.normalizeToNew();
            let vn_norm = vn.normalizeToNew();
            const dotp = (0, $ha1VO.Vector3).Dot(vp_norm, vc_norm);
            if (dotp > smoothingThreshold) {
                if (dotp < (0, $53VPf.Epsilon) - 1) vp_norm = new (0, $ha1VO.Vector3)(p.x, 0, p.y).subtract(new (0, $ha1VO.Vector3)(p1.x, 0, p1.y)).normalize();
                else // cheap average weighed by side length
                vp_norm = vp.add(vc).normalize();
            } else vp_norm = vc_norm;
            const dotn = (0, $ha1VO.Vector3).Dot(vn, vc);
            if (dotn > smoothingThreshold) {
                if (dotn < (0, $53VPf.Epsilon) - 1) // back to back
                vn_norm = new (0, $ha1VO.Vector3)(p1.x, 0, p1.y).subtract(new (0, $ha1VO.Vector3)(p.x, 0, p.y)).normalize();
                else // cheap average weighed by side length
                vn_norm = vn.add(vc).normalize();
            } else vn_norm = vc_norm;
            uvs.push(ulength / bounds.width, 0);
            uvs.push(ulength / bounds.width, 1);
            ulength += vc.length();
            uvs.push(ulength / bounds.width, 0);
            uvs.push(ulength / bounds.width, 1);
            normals.push(vp_norm.x, vp_norm.y, vp_norm.z);
            normals.push(vp_norm.x, vp_norm.y, vp_norm.z);
            normals.push(vn_norm.x, vn_norm.y, vn_norm.z);
            normals.push(vn_norm.x, vn_norm.y, vn_norm.z);
            if (!flip) {
                indices.push(startIndex);
                indices.push(startIndex + 1);
                indices.push(startIndex + 2);
                indices.push(startIndex + 1);
                indices.push(startIndex + 3);
                indices.push(startIndex + 2);
            } else {
                indices.push(startIndex);
                indices.push(startIndex + 2);
                indices.push(startIndex + 1);
                indices.push(startIndex + 1);
                indices.push(startIndex + 2);
                indices.push(startIndex + 3);
            }
            startIndex += 4;
        }
    }
}



var $b4i1f = parcelRequire("b4i1f");

var $ejQPp = parcelRequire("ejQPp");

var $fGXjI = parcelRequire("fGXjI");
function $74fbaf67623e82ac$export$8b0a0fcd41a39f4b(polygon, sideOrientation, fUV, fColors, frontUVs, backUVs, wrp) {
    const faceUV = fUV || new Array(3);
    const faceColors = fColors;
    const colors = [];
    const wrap = wrp || false;
    // default face colors and UV if undefined
    for(let f = 0; f < 3; f++){
        if (faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    const positions = polygon.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
    const normals = polygon.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
    const uvs = polygon.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
    const indices = polygon.getIndices();
    const startIndex = positions.length / 9;
    let disp = 0;
    let distX = 0;
    let distZ = 0;
    let dist = 0;
    let totalLen = 0;
    const cumulate = [
        0
    ];
    if (wrap) for(let idx = startIndex; idx < positions.length / 3; idx += 4){
        distX = positions[3 * (idx + 2)] - positions[3 * idx];
        distZ = positions[3 * (idx + 2) + 2] - positions[3 * idx + 2];
        dist = Math.sqrt(distX * distX + distZ * distZ);
        totalLen += dist;
        cumulate.push(totalLen);
    }
    // set face colours and textures
    let idx = 0;
    let face = 0;
    for(let index = 0; index < normals.length; index += 3){
        //Edge Face  no. 1
        if (Math.abs(normals[index + 1]) < 0.001) face = 1;
        //Top Face  no. 0
        if (Math.abs(normals[index + 1] - 1) < 0.001) face = 0;
        //Bottom Face  no. 2
        if (Math.abs(normals[index + 1] + 1) < 0.001) face = 2;
        idx = index / 3;
        if (face === 1) {
            disp = idx - startIndex;
            if (disp % 4 < 1.5) {
                if (wrap) uvs[2 * idx] = faceUV[face].x + (faceUV[face].z - faceUV[face].x) * cumulate[Math.floor(disp / 4)] / totalLen;
                else uvs[2 * idx] = faceUV[face].x;
            } else if (wrap) uvs[2 * idx] = faceUV[face].x + (faceUV[face].z - faceUV[face].x) * cumulate[Math.floor(disp / 4) + 1] / totalLen;
            else uvs[2 * idx] = faceUV[face].z;
            if (disp % 2 === 0) uvs[2 * idx + 1] = (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - faceUV[face].w : faceUV[face].w;
            else uvs[2 * idx + 1] = (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - faceUV[face].y : faceUV[face].y;
        } else {
            uvs[2 * idx] = (1 - uvs[2 * idx]) * faceUV[face].x + uvs[2 * idx] * faceUV[face].z;
            uvs[2 * idx + 1] = (1 - uvs[2 * idx + 1]) * faceUV[face].y + uvs[2 * idx + 1] * faceUV[face].w;
            if (0, $fGXjI.useOpenGLOrientationForUV) uvs[2 * idx + 1] = 1.0 - uvs[2 * idx + 1];
        }
        if (faceColors) colors.push(faceColors[face].r, faceColors[face].g, faceColors[face].b, faceColors[face].a);
    }
    // sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, frontUVs, backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) {
        const totalColors = sideOrientation === (0, $4014d881db0e9bc6$export$8570d39351855acb).DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
    }
    return vertexData;
}
function $74fbaf67623e82ac$export$2076f2784b460eb2(name, options, scene = null, earcutInjection = earcut) {
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    const shape = options.shape;
    const holes = options.holes || [];
    const depth = options.depth || 0;
    const smoothingThreshold = options.smoothingThreshold || 2;
    const contours = [];
    let hole = [];
    for(let i = 0; i < shape.length; i++)contours[i] = new (0, $ha1VO.Vector2)(shape[i].x, shape[i].z);
    const epsilon = 0.00000001;
    if (contours[0].equalsWithEpsilon(contours[contours.length - 1], epsilon)) contours.pop();
    const polygonTriangulation = new (0, $756019cf1144be99$export$b8a40edac54f9787)(name, contours, scene || (0, $ejQPp.EngineStore).LastCreatedScene, earcutInjection);
    for(let hNb = 0; hNb < holes.length; hNb++){
        hole = [];
        for(let hPoint = 0; hPoint < holes[hNb].length; hPoint++)hole.push(new (0, $ha1VO.Vector2)(holes[hNb][hPoint].x, holes[hNb][hPoint].z));
        polygonTriangulation.addHole(hole);
    }
    //updatability is set during applyToMesh; setting to true in triangulation build produces errors
    const polygon = polygonTriangulation.build(false, depth, smoothingThreshold);
    polygon._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $74fbaf67623e82ac$export$8b0a0fcd41a39f4b(polygon, options.sideOrientation, options.faceUV, options.faceColors, options.frontUVs, options.backUVs, options.wrap);
    vertexData.applyToMesh(polygon, options.updatable);
    return polygon;
}
function $74fbaf67623e82ac$export$7ab7ef8f70a7afeb(name, options, scene = null, earcutInjection = earcut) {
    return $74fbaf67623e82ac$export$2076f2784b460eb2(name, options, scene, earcutInjection);
}
const $74fbaf67623e82ac$export$ab2e43fdbfddd162 = {
    ExtrudePolygon: $74fbaf67623e82ac$export$7ab7ef8f70a7afeb,
    CreatePolygon: $74fbaf67623e82ac$export$2076f2784b460eb2
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreatePolygon = $74fbaf67623e82ac$export$8b0a0fcd41a39f4b;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreatePolygon = (name, shape, scene, holes, updatable, sideOrientation, earcutInjection = earcut)=>{
    const options = {
        shape: shape,
        holes: holes,
        updatable: updatable,
        sideOrientation: sideOrientation
    };
    return $74fbaf67623e82ac$export$2076f2784b460eb2(name, options, scene, earcutInjection);
};
(0, $b0df7c384622c537$export$e176487c05830cc5).ExtrudePolygon = (name, shape, depth, scene, holes, updatable, sideOrientation, earcutInjection = earcut)=>{
    const options = {
        shape: shape,
        holes: holes,
        depth: depth,
        updatable: updatable,
        sideOrientation: sideOrientation
    };
    return $74fbaf67623e82ac$export$7ab7ef8f70a7afeb(name, options, scene, earcutInjection);
};



var $ha1VO = parcelRequire("ha1VO");



var $fm2C6 = parcelRequire("fm2C6");
function $f55ac4e07ca7f06f$export$154977f2a337af53(name, options, scene = null) {
    const path = options.path;
    const shape = options.shape;
    const scale = options.scale || 1;
    const rotation = options.rotation || 0;
    const cap = options.cap === 0 ? 0 : options.cap || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP;
    const updatable = options.updatable;
    const sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    const instance = options.instance || null;
    const invertUV = options.invertUV || false;
    const closeShape = options.closeShape || false;
    const closePath = options.closePath || false;
    return $f55ac4e07ca7f06f$var$_ExtrudeShapeGeneric(name, shape, path, scale, rotation, null, null, closePath, closeShape, cap, false, scene, updatable ? true : false, sideOrientation, instance, invertUV, options.frontUVs || null, options.backUVs || null, options.firstNormal || null, options.adjustFrame ? true : false);
}
function $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3(name, options, scene = null) {
    const path = options.path;
    const shape = options.shape;
    const scaleFunction = options.scaleFunction || (()=>{
        return 1;
    });
    const rotationFunction = options.rotationFunction || (()=>{
        return 0;
    });
    const ribbonCloseArray = options.closePath || options.ribbonCloseArray || false;
    const ribbonClosePath = options.closeShape || options.ribbonClosePath || false;
    const cap = options.cap === 0 ? 0 : options.cap || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP;
    const updatable = options.updatable;
    const firstNormal = options.firstNormal || null;
    const adjustFrame = options.adjustFrame || false;
    const sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    const instance = options.instance;
    const invertUV = options.invertUV || false;
    return $f55ac4e07ca7f06f$var$_ExtrudeShapeGeneric(name, shape, path, null, null, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, true, scene, updatable ? true : false, sideOrientation, instance || null, invertUV, options.frontUVs || null, options.backUVs || null, firstNormal, adjustFrame);
}
function $f55ac4e07ca7f06f$var$_ExtrudeShapeGeneric(name, shape, curve, scale, rotation, scaleFunction, rotateFunction, rbCA, rbCP, cap, custom, scene, updtbl, side, instance, invertUV, frontUVs, backUVs, firstNormal, adjustFrame) {
    // extrusion geometry
    const extrusionPathArray = (shape, curve, path3D, shapePaths, scale, rotation, scaleFunction, rotateFunction, cap, custom, adjustFrame)=>{
        const tangents = path3D.getTangents();
        const normals = path3D.getNormals();
        const binormals = path3D.getBinormals();
        const distances = path3D.getDistances();
        if (adjustFrame) /* fix tangents,normals, binormals */ for(let i = 0; i < tangents.length; i++){
            if (tangents[i].x == 0 && tangents[i].y == 0 && tangents[i].z == 0) tangents[i].copyFrom(tangents[i - 1]);
            if (normals[i].x == 0 && normals[i].y == 0 && normals[i].z == 0) normals[i].copyFrom(normals[i - 1]);
            if (binormals[i].x == 0 && binormals[i].y == 0 && binormals[i].z == 0) binormals[i].copyFrom(binormals[i - 1]);
            if (i > 0) {
                let v = tangents[i - 1];
                if ((0, $ha1VO.Vector3).Dot(v, tangents[i]) < 0) tangents[i].scaleInPlace(-1);
                v = normals[i - 1];
                if ((0, $ha1VO.Vector3).Dot(v, normals[i]) < 0) normals[i].scaleInPlace(-1);
                v = binormals[i - 1];
                if ((0, $ha1VO.Vector3).Dot(v, binormals[i]) < 0) binormals[i].scaleInPlace(-1);
            }
        }
        let angle = 0;
        const returnScale = ()=>{
            return scale !== null ? scale : 1;
        };
        const returnRotation = ()=>{
            return rotation !== null ? rotation : 0;
        };
        const rotate = custom && rotateFunction ? rotateFunction : returnRotation;
        const scl = custom && scaleFunction ? scaleFunction : returnScale;
        let index = cap === (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP || cap === (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_END ? 0 : 2;
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        for(let i = 0; i < curve.length; i++){
            const shapePath = [];
            const angleStep = rotate(i, distances[i]);
            const scaleRatio = scl(i, distances[i]);
            (0, $ha1VO.Matrix).RotationAxisToRef(tangents[i], angle, rotationMatrix);
            for(let p = 0; p < shape.length; p++){
                const planed = tangents[i].scale(shape[p].z).add(normals[i].scale(shape[p].x)).add(binormals[i].scale(shape[p].y));
                const rotated = (0, $ha1VO.Vector3).Zero();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(planed, rotationMatrix, rotated);
                rotated.scaleInPlace(scaleRatio).addInPlace(curve[i]);
                shapePath[p] = rotated;
            }
            shapePaths[index] = shapePath;
            angle += angleStep;
            index++;
        }
        // cap
        const capPath = (shapePath)=>{
            const pointCap = Array();
            const barycenter = (0, $ha1VO.Vector3).Zero();
            let i;
            for(i = 0; i < shapePath.length; i++)barycenter.addInPlace(shapePath[i]);
            barycenter.scaleInPlace(1.0 / shapePath.length);
            for(i = 0; i < shapePath.length; i++)pointCap.push(barycenter);
            return pointCap;
        };
        switch(cap){
            case (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP:
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_START:
                shapePaths[0] = capPath(shapePaths[2]);
                shapePaths[1] = shapePaths[2];
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_END:
                shapePaths[index] = shapePaths[index - 1];
                shapePaths[index + 1] = capPath(shapePaths[index - 1]);
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL:
                shapePaths[0] = capPath(shapePaths[2]);
                shapePaths[1] = shapePaths[2];
                shapePaths[index] = shapePaths[index - 1];
                shapePaths[index + 1] = capPath(shapePaths[index - 1]);
                break;
            default:
                break;
        }
        return shapePaths;
    };
    let path3D;
    let pathArray;
    if (instance) {
        // instance update
        const storage = instance._creationDataStorage;
        path3D = firstNormal ? storage.path3D.update(curve, firstNormal) : storage.path3D.update(curve);
        pathArray = extrusionPathArray(shape, curve, storage.path3D, storage.pathArray, scale, rotation, scaleFunction, rotateFunction, storage.cap, custom, adjustFrame);
        instance = (0, $7c39a49659d9e77f$export$821dd8d5c9753978)("", {
            pathArray: pathArray,
            closeArray: false,
            closePath: false,
            offset: 0,
            updatable: false,
            sideOrientation: 0,
            instance: instance
        }, scene || undefined);
        return instance;
    }
    // extruded shape creation
    path3D = firstNormal ? new (0, $fm2C6.Path3D)(curve, firstNormal) : new (0, $fm2C6.Path3D)(curve);
    const newShapePaths = new Array();
    cap = cap < 0 || cap > 3 ? 0 : cap;
    pathArray = extrusionPathArray(shape, curve, path3D, newShapePaths, scale, rotation, scaleFunction, rotateFunction, cap, custom, adjustFrame);
    const extrudedGeneric = (0, $7c39a49659d9e77f$export$821dd8d5c9753978)(name, {
        pathArray: pathArray,
        closeArray: rbCA,
        closePath: rbCP,
        updatable: updtbl,
        sideOrientation: side,
        invertUV: invertUV,
        frontUVs: frontUVs || undefined,
        backUVs: backUVs || undefined
    }, scene);
    extrudedGeneric._creationDataStorage.pathArray = pathArray;
    extrudedGeneric._creationDataStorage.path3D = path3D;
    extrudedGeneric._creationDataStorage.cap = cap;
    return extrudedGeneric;
}
const $f55ac4e07ca7f06f$export$db37cc886555ba45 = {
    ExtrudeShape: // eslint-disable-next-line @typescript-eslint/naming-convention
    $f55ac4e07ca7f06f$export$154977f2a337af53,
    ExtrudeShapeCustom: // eslint-disable-next-line @typescript-eslint/naming-convention
    $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3
};
(0, $b0df7c384622c537$export$e176487c05830cc5).ExtrudeShape = (name, shape, path, scale, rotation, cap, scene = null, updatable, sideOrientation, instance)=>{
    const options = {
        shape: shape,
        path: path,
        scale: scale,
        rotation: rotation,
        cap: cap === 0 ? 0 : cap || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP,
        sideOrientation: sideOrientation,
        instance: instance,
        updatable: updatable
    };
    return $f55ac4e07ca7f06f$export$154977f2a337af53(name, options, scene);
};
(0, $b0df7c384622c537$export$e176487c05830cc5).ExtrudeShapeCustom = (name, shape, path, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, scene, updatable, sideOrientation, instance)=>{
    const options = {
        shape: shape,
        path: path,
        scaleFunction: scaleFunction,
        rotationFunction: rotationFunction,
        ribbonCloseArray: ribbonCloseArray,
        ribbonClosePath: ribbonClosePath,
        cap: cap === 0 ? 0 : cap || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP,
        sideOrientation: sideOrientation,
        instance: instance,
        updatable: updatable
    };
    return $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");


function $bbf9dea6106419fd$export$1aa598e2d5431c62(name, options, scene = null) {
    const arc = options.arc ? options.arc <= 0 || options.arc > 1 ? 1.0 : options.arc : 1.0;
    const closed = options.closed === undefined ? true : options.closed;
    const shape = options.shape;
    const radius = options.radius || 1;
    const tessellation = options.tessellation || 64;
    const clip = options.clip || 0;
    const updatable = options.updatable;
    const sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    const cap = options.cap || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP;
    const pi2 = Math.PI * 2;
    const paths = [];
    const invertUV = options.invertUV || false;
    let i = 0;
    let p = 0;
    const step = pi2 / tessellation * arc;
    let rotated;
    let path;
    for(i = 0; i <= tessellation - clip; i++){
        path = [];
        if (cap == (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_START || cap == (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL) {
            path.push(new (0, $ha1VO.Vector3)(0, shape[0].y, 0));
            path.push(new (0, $ha1VO.Vector3)(Math.cos(i * step) * shape[0].x * radius, shape[0].y, Math.sin(i * step) * shape[0].x * radius));
        }
        for(p = 0; p < shape.length; p++){
            rotated = new (0, $ha1VO.Vector3)(Math.cos(i * step) * shape[p].x * radius, shape[p].y, Math.sin(i * step) * shape[p].x * radius);
            path.push(rotated);
        }
        if (cap == (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_END || cap == (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL) {
            path.push(new (0, $ha1VO.Vector3)(Math.cos(i * step) * shape[shape.length - 1].x * radius, shape[shape.length - 1].y, Math.sin(i * step) * shape[shape.length - 1].x * radius));
            path.push(new (0, $ha1VO.Vector3)(0, shape[shape.length - 1].y, 0));
        }
        paths.push(path);
    }
    // lathe ribbon
    const lathe = (0, $7c39a49659d9e77f$export$821dd8d5c9753978)(name, {
        pathArray: paths,
        closeArray: closed,
        sideOrientation: sideOrientation,
        updatable: updatable,
        invertUV: invertUV,
        frontUVs: options.frontUVs,
        backUVs: options.backUVs
    }, scene);
    return lathe;
}
const $bbf9dea6106419fd$export$fb6a5c9c9babfdfd = {
    CreateLathe: // eslint-disable-next-line @typescript-eslint/naming-convention
    $bbf9dea6106419fd$export$1aa598e2d5431c62
};
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateLathe = (name, shape, radius, tessellation, scene, updatable, sideOrientation)=>{
    const options = {
        shape: shape,
        radius: radius,
        tessellation: tessellation,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $bbf9dea6106419fd$export$1aa598e2d5431c62(name, options, scene);
};





var $fGXjI = parcelRequire("fGXjI");
function $ee6b855236d2e2b5$export$f53dee9f1fba62c2(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const width = options.width !== undefined ? options.width : options.size !== undefined ? options.size : 1;
    const height = options.height !== undefined ? options.height : options.size !== undefined ? options.size : 1;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    // Vertices
    const halfWidth = width / 2.0;
    const halfHeight = height / 2.0;
    positions.push(-halfWidth, -halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(0.0, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 : 0.0);
    positions.push(halfWidth, -halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(1.0, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 : 0.0);
    positions.push(halfWidth, halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(1.0, (0, $fGXjI.useOpenGLOrientationForUV) ? 0.0 : 1.0);
    positions.push(-halfWidth, halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(0.0, (0, $fGXjI.useOpenGLOrientationForUV) ? 0.0 : 1.0);
    // Indices
    indices.push(0);
    indices.push(1);
    indices.push(2);
    indices.push(0);
    indices.push(2);
    indices.push(3);
    // Sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $ee6b855236d2e2b5$export$474050064c328a47(name, options = {}, scene = null) {
    const plane = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    plane._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $ee6b855236d2e2b5$export$f53dee9f1fba62c2(options);
    vertexData.applyToMesh(plane, options.updatable);
    if (options.sourcePlane) {
        plane.translate(options.sourcePlane.normal, -options.sourcePlane.d);
        plane.setDirection(options.sourcePlane.normal.scale(-1));
    }
    return plane;
}
const $ee6b855236d2e2b5$export$1a236e78939b969a = {
    CreatePlane: // eslint-disable-next-line @typescript-eslint/naming-convention
    $ee6b855236d2e2b5$export$474050064c328a47
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreatePlane = $ee6b855236d2e2b5$export$f53dee9f1fba62c2;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreatePlane = (name, size, scene, updatable, sideOrientation)=>{
    const options = {
        size: size,
        width: size,
        height: size,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $ee6b855236d2e2b5$export$474050064c328a47(name, options, scene);
};





var $ha1VO = parcelRequire("ha1VO");



var $fm2C6 = parcelRequire("fm2C6");
function $31b9410618830924$export$e35b4d126241f338(name, options, scene = null) {
    const path = options.path;
    let instance = options.instance;
    let radius = 1.0;
    if (options.radius !== undefined) radius = options.radius;
    else if (instance) radius = instance._creationDataStorage.radius;
    const tessellation = options.tessellation || 64;
    const radiusFunction = options.radiusFunction || null;
    let cap = options.cap || (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP;
    const invertUV = options.invertUV || false;
    const updatable = options.updatable;
    const sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    options.arc = options.arc && (options.arc <= 0.0 || options.arc > 1.0) ? 1.0 : options.arc || 1.0;
    // tube geometry
    const tubePathArray = (path, path3D, circlePaths, radius, tessellation, radiusFunction, cap, arc)=>{
        const tangents = path3D.getTangents();
        const normals = path3D.getNormals();
        const distances = path3D.getDistances();
        const pi2 = Math.PI * 2;
        const step = pi2 / tessellation * arc;
        const returnRadius = ()=>radius;
        const radiusFunctionFinal = radiusFunction || returnRadius;
        let circlePath;
        let rad;
        let normal;
        let rotated;
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        let index = cap === (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP || cap === (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_END ? 0 : 2;
        for(let i = 0; i < path.length; i++){
            rad = radiusFunctionFinal(i, distances[i]); // current radius
            circlePath = Array(); // current circle array
            normal = normals[i]; // current normal
            for(let t = 0; t < tessellation; t++){
                (0, $ha1VO.Matrix).RotationAxisToRef(tangents[i], step * t, rotationMatrix);
                rotated = circlePath[t] ? circlePath[t] : (0, $ha1VO.Vector3).Zero();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(normal, rotationMatrix, rotated);
                rotated.scaleInPlace(rad).addInPlace(path[i]);
                circlePath[t] = rotated;
            }
            circlePaths[index] = circlePath;
            index++;
        }
        // cap
        const capPath = (nbPoints, pathIndex)=>{
            const pointCap = Array();
            for(let i = 0; i < nbPoints; i++)pointCap.push(path[pathIndex]);
            return pointCap;
        };
        switch(cap){
            case (0, $b0df7c384622c537$export$e176487c05830cc5).NO_CAP:
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_START:
                circlePaths[0] = capPath(tessellation, 0);
                circlePaths[1] = circlePaths[2].slice(0);
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_END:
                circlePaths[index] = circlePaths[index - 1].slice(0);
                circlePaths[index + 1] = capPath(tessellation, path.length - 1);
                break;
            case (0, $b0df7c384622c537$export$e176487c05830cc5).CAP_ALL:
                circlePaths[0] = capPath(tessellation, 0);
                circlePaths[1] = circlePaths[2].slice(0);
                circlePaths[index] = circlePaths[index - 1].slice(0);
                circlePaths[index + 1] = capPath(tessellation, path.length - 1);
                break;
            default:
                break;
        }
        return circlePaths;
    };
    let path3D;
    let pathArray;
    if (instance) {
        // tube update
        const storage = instance._creationDataStorage;
        const arc = options.arc || storage.arc;
        path3D = storage.path3D.update(path);
        pathArray = tubePathArray(path, path3D, storage.pathArray, radius, storage.tessellation, radiusFunction, storage.cap, arc);
        instance = (0, $7c39a49659d9e77f$export$821dd8d5c9753978)("", {
            pathArray: pathArray,
            instance: instance
        });
        // Update mode, no need to recreate the storage.
        storage.path3D = path3D;
        storage.pathArray = pathArray;
        storage.arc = arc;
        storage.radius = radius;
        return instance;
    }
    // tube creation
    path3D = new (0, $fm2C6.Path3D)(path);
    const newPathArray = new Array();
    cap = cap < 0 || cap > 3 ? 0 : cap;
    pathArray = tubePathArray(path, path3D, newPathArray, radius, tessellation, radiusFunction, cap, options.arc);
    const tube = (0, $7c39a49659d9e77f$export$821dd8d5c9753978)(name, {
        pathArray: pathArray,
        closePath: true,
        closeArray: false,
        updatable: updatable,
        sideOrientation: sideOrientation,
        invertUV: invertUV,
        frontUVs: options.frontUVs,
        backUVs: options.backUVs
    }, scene);
    tube._creationDataStorage.pathArray = pathArray;
    tube._creationDataStorage.path3D = path3D;
    tube._creationDataStorage.tessellation = tessellation;
    tube._creationDataStorage.cap = cap;
    tube._creationDataStorage.arc = options.arc;
    tube._creationDataStorage.radius = radius;
    return tube;
}
const $31b9410618830924$export$b20f6b29ce4ae5fc = {
    CreateTube: // eslint-disable-next-line @typescript-eslint/naming-convention
    $31b9410618830924$export$e35b4d126241f338
};
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateTube = (name, path, radius, tessellation, radiusFunction, cap, scene, updatable, sideOrientation, instance)=>{
    const options = {
        path: path,
        radius: radius,
        tessellation: tessellation,
        radiusFunction: radiusFunction,
        arc: 1,
        cap: cap,
        updatable: updatable,
        sideOrientation: sideOrientation,
        instance: instance
    };
    return $31b9410618830924$export$e35b4d126241f338(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");



var $fGXjI = parcelRequire("fGXjI");
function $1d49167c5ec927a7$export$c72e10f5a1c9dc82(options) {
    // provided polyhedron types :
    // 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
    // 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
    const polyhedra = [];
    polyhedra[0] = {
        vertex: [
            [
                0,
                0,
                1.732051
            ],
            [
                1.632993,
                0,
                -0.5773503
            ],
            [
                -0.8164966,
                1.414214,
                -0.5773503
            ],
            [
                -0.8164966,
                -1.414214,
                -0.5773503
            ]
        ],
        face: [
            [
                0,
                1,
                2
            ],
            [
                0,
                2,
                3
            ],
            [
                0,
                3,
                1
            ],
            [
                1,
                3,
                2
            ]
        ]
    };
    polyhedra[1] = {
        vertex: [
            [
                0,
                0,
                1.414214
            ],
            [
                1.414214,
                0,
                0
            ],
            [
                0,
                1.414214,
                0
            ],
            [
                -1.414214,
                0,
                0
            ],
            [
                0,
                -1.414214,
                0
            ],
            [
                0,
                0,
                -1.414214
            ]
        ],
        face: [
            [
                0,
                1,
                2
            ],
            [
                0,
                2,
                3
            ],
            [
                0,
                3,
                4
            ],
            [
                0,
                4,
                1
            ],
            [
                1,
                4,
                5
            ],
            [
                1,
                5,
                2
            ],
            [
                2,
                5,
                3
            ],
            [
                3,
                5,
                4
            ]
        ]
    };
    polyhedra[2] = {
        vertex: [
            [
                0,
                0,
                1.070466
            ],
            [
                0.7136442,
                0,
                0.7978784
            ],
            [
                -0.3568221,
                0.618034,
                0.7978784
            ],
            [
                -0.3568221,
                -0.618034,
                0.7978784
            ],
            [
                0.7978784,
                0.618034,
                0.3568221
            ],
            [
                0.7978784,
                -0.618034,
                0.3568221
            ],
            [
                -0.9341724,
                0.381966,
                0.3568221
            ],
            [
                0.1362939,
                1,
                0.3568221
            ],
            [
                0.1362939,
                -1,
                0.3568221
            ],
            [
                -0.9341724,
                -0.381966,
                0.3568221
            ],
            [
                0.9341724,
                0.381966,
                -0.3568221
            ],
            [
                0.9341724,
                -0.381966,
                -0.3568221
            ],
            [
                -0.7978784,
                0.618034,
                -0.3568221
            ],
            [
                -0.1362939,
                1,
                -0.3568221
            ],
            [
                -0.1362939,
                -1,
                -0.3568221
            ],
            [
                -0.7978784,
                -0.618034,
                -0.3568221
            ],
            [
                0.3568221,
                0.618034,
                -0.7978784
            ],
            [
                0.3568221,
                -0.618034,
                -0.7978784
            ],
            [
                -0.7136442,
                0,
                -0.7978784
            ],
            [
                0,
                0,
                -1.070466
            ]
        ],
        face: [
            [
                0,
                1,
                4,
                7,
                2
            ],
            [
                0,
                2,
                6,
                9,
                3
            ],
            [
                0,
                3,
                8,
                5,
                1
            ],
            [
                1,
                5,
                11,
                10,
                4
            ],
            [
                2,
                7,
                13,
                12,
                6
            ],
            [
                3,
                9,
                15,
                14,
                8
            ],
            [
                4,
                10,
                16,
                13,
                7
            ],
            [
                5,
                8,
                14,
                17,
                11
            ],
            [
                6,
                12,
                18,
                15,
                9
            ],
            [
                10,
                11,
                17,
                19,
                16
            ],
            [
                12,
                13,
                16,
                19,
                18
            ],
            [
                14,
                15,
                18,
                19,
                17
            ]
        ]
    };
    polyhedra[3] = {
        vertex: [
            [
                0,
                0,
                1.175571
            ],
            [
                1.051462,
                0,
                0.5257311
            ],
            [
                0.3249197,
                1,
                0.5257311
            ],
            [
                -0.8506508,
                0.618034,
                0.5257311
            ],
            [
                -0.8506508,
                -0.618034,
                0.5257311
            ],
            [
                0.3249197,
                -1,
                0.5257311
            ],
            [
                0.8506508,
                0.618034,
                -0.5257311
            ],
            [
                0.8506508,
                -0.618034,
                -0.5257311
            ],
            [
                -0.3249197,
                1,
                -0.5257311
            ],
            [
                -1.051462,
                0,
                -0.5257311
            ],
            [
                -0.3249197,
                -1,
                -0.5257311
            ],
            [
                0,
                0,
                -1.175571
            ]
        ],
        face: [
            [
                0,
                1,
                2
            ],
            [
                0,
                2,
                3
            ],
            [
                0,
                3,
                4
            ],
            [
                0,
                4,
                5
            ],
            [
                0,
                5,
                1
            ],
            [
                1,
                5,
                7
            ],
            [
                1,
                7,
                6
            ],
            [
                1,
                6,
                2
            ],
            [
                2,
                6,
                8
            ],
            [
                2,
                8,
                3
            ],
            [
                3,
                8,
                9
            ],
            [
                3,
                9,
                4
            ],
            [
                4,
                9,
                10
            ],
            [
                4,
                10,
                5
            ],
            [
                5,
                10,
                7
            ],
            [
                6,
                7,
                11
            ],
            [
                6,
                11,
                8
            ],
            [
                7,
                10,
                11
            ],
            [
                8,
                11,
                9
            ],
            [
                9,
                11,
                10
            ]
        ]
    };
    polyhedra[4] = {
        vertex: [
            [
                0,
                0,
                1.070722
            ],
            [
                0.7148135,
                0,
                0.7971752
            ],
            [
                -0.104682,
                0.7071068,
                0.7971752
            ],
            [
                -0.6841528,
                0.2071068,
                0.7971752
            ],
            [
                -0.104682,
                -0.7071068,
                0.7971752
            ],
            [
                0.6101315,
                0.7071068,
                0.5236279
            ],
            [
                1.04156,
                0.2071068,
                0.1367736
            ],
            [
                0.6101315,
                -0.7071068,
                0.5236279
            ],
            [
                -0.3574067,
                1,
                0.1367736
            ],
            [
                -0.7888348,
                -0.5,
                0.5236279
            ],
            [
                -0.9368776,
                0.5,
                0.1367736
            ],
            [
                -0.3574067,
                -1,
                0.1367736
            ],
            [
                0.3574067,
                1,
                -0.1367736
            ],
            [
                0.9368776,
                -0.5,
                -0.1367736
            ],
            [
                0.7888348,
                0.5,
                -0.5236279
            ],
            [
                0.3574067,
                -1,
                -0.1367736
            ],
            [
                -0.6101315,
                0.7071068,
                -0.5236279
            ],
            [
                -1.04156,
                -0.2071068,
                -0.1367736
            ],
            [
                -0.6101315,
                -0.7071068,
                -0.5236279
            ],
            [
                0.104682,
                0.7071068,
                -0.7971752
            ],
            [
                0.6841528,
                -0.2071068,
                -0.7971752
            ],
            [
                0.104682,
                -0.7071068,
                -0.7971752
            ],
            [
                -0.7148135,
                0,
                -0.7971752
            ],
            [
                0,
                0,
                -1.070722
            ]
        ],
        face: [
            [
                0,
                2,
                3
            ],
            [
                1,
                6,
                5
            ],
            [
                4,
                9,
                11
            ],
            [
                7,
                15,
                13
            ],
            [
                8,
                16,
                10
            ],
            [
                12,
                14,
                19
            ],
            [
                17,
                22,
                18
            ],
            [
                20,
                21,
                23
            ],
            [
                0,
                1,
                5,
                2
            ],
            [
                0,
                3,
                9,
                4
            ],
            [
                0,
                4,
                7,
                1
            ],
            [
                1,
                7,
                13,
                6
            ],
            [
                2,
                5,
                12,
                8
            ],
            [
                2,
                8,
                10,
                3
            ],
            [
                3,
                10,
                17,
                9
            ],
            [
                4,
                11,
                15,
                7
            ],
            [
                5,
                6,
                14,
                12
            ],
            [
                6,
                13,
                20,
                14
            ],
            [
                8,
                12,
                19,
                16
            ],
            [
                9,
                17,
                18,
                11
            ],
            [
                10,
                16,
                22,
                17
            ],
            [
                11,
                18,
                21,
                15
            ],
            [
                13,
                15,
                21,
                20
            ],
            [
                14,
                20,
                23,
                19
            ],
            [
                16,
                19,
                23,
                22
            ],
            [
                18,
                22,
                23,
                21
            ]
        ]
    };
    polyhedra[5] = {
        vertex: [
            [
                0,
                0,
                1.322876
            ],
            [
                1.309307,
                0,
                0.1889822
            ],
            [
                -0.9819805,
                0.8660254,
                0.1889822
            ],
            [
                0.1636634,
                -1.299038,
                0.1889822
            ],
            [
                0.3273268,
                0.8660254,
                -0.9449112
            ],
            [
                -0.8183171,
                -0.4330127,
                -0.9449112
            ]
        ],
        face: [
            [
                0,
                3,
                1
            ],
            [
                2,
                4,
                5
            ],
            [
                0,
                1,
                4,
                2
            ],
            [
                0,
                2,
                5,
                3
            ],
            [
                1,
                3,
                5,
                4
            ]
        ]
    };
    polyhedra[6] = {
        vertex: [
            [
                0,
                0,
                1.159953
            ],
            [
                1.013464,
                0,
                0.5642542
            ],
            [
                -0.3501431,
                0.9510565,
                0.5642542
            ],
            [
                -0.7715208,
                -0.6571639,
                0.5642542
            ],
            [
                0.6633206,
                0.9510565,
                -0.03144481
            ],
            [
                0.8682979,
                -0.6571639,
                -0.3996071
            ],
            [
                -1.121664,
                0.2938926,
                -0.03144481
            ],
            [
                -0.2348831,
                -1.063314,
                -0.3996071
            ],
            [
                0.5181548,
                0.2938926,
                -0.9953061
            ],
            [
                -0.5850262,
                -0.112257,
                -0.9953061
            ]
        ],
        face: [
            [
                0,
                1,
                4,
                2
            ],
            [
                0,
                2,
                6,
                3
            ],
            [
                1,
                5,
                8,
                4
            ],
            [
                3,
                6,
                9,
                7
            ],
            [
                5,
                7,
                9,
                8
            ],
            [
                0,
                3,
                7,
                5,
                1
            ],
            [
                2,
                4,
                8,
                9,
                6
            ]
        ]
    };
    polyhedra[7] = {
        vertex: [
            [
                0,
                0,
                1.118034
            ],
            [
                0.8944272,
                0,
                0.6708204
            ],
            [
                -0.2236068,
                0.8660254,
                0.6708204
            ],
            [
                -0.7826238,
                -0.4330127,
                0.6708204
            ],
            [
                0.6708204,
                0.8660254,
                0.2236068
            ],
            [
                1.006231,
                -0.4330127,
                -0.2236068
            ],
            [
                -1.006231,
                0.4330127,
                0.2236068
            ],
            [
                -0.6708204,
                -0.8660254,
                -0.2236068
            ],
            [
                0.7826238,
                0.4330127,
                -0.6708204
            ],
            [
                0.2236068,
                -0.8660254,
                -0.6708204
            ],
            [
                -0.8944272,
                0,
                -0.6708204
            ],
            [
                0,
                0,
                -1.118034
            ]
        ],
        face: [
            [
                0,
                1,
                4,
                2
            ],
            [
                0,
                2,
                6,
                3
            ],
            [
                1,
                5,
                8,
                4
            ],
            [
                3,
                6,
                10,
                7
            ],
            [
                5,
                9,
                11,
                8
            ],
            [
                7,
                10,
                11,
                9
            ],
            [
                0,
                3,
                7,
                9,
                5,
                1
            ],
            [
                2,
                4,
                8,
                11,
                10,
                6
            ]
        ]
    };
    polyhedra[8] = {
        vertex: [
            [
                -0.729665,
                0.670121,
                0.319155
            ],
            [
                -0.655235,
                -0.29213,
                -0.754096
            ],
            [
                -0.093922,
                -0.607123,
                0.537818
            ],
            [
                0.702196,
                0.595691,
                0.485187
            ],
            [
                0.776626,
                -0.36656,
                -0.588064
            ]
        ],
        face: [
            [
                1,
                4,
                2
            ],
            [
                0,
                1,
                2
            ],
            [
                3,
                0,
                2
            ],
            [
                4,
                3,
                2
            ],
            [
                4,
                1,
                0,
                3
            ]
        ]
    };
    polyhedra[9] = {
        vertex: [
            [
                -0.868849,
                -0.100041,
                0.61257
            ],
            [
                -0.329458,
                0.976099,
                0.28078
            ],
            [
                -0.26629,
                -0.013796,
                -0.477654
            ],
            [
                -0.13392,
                -1.034115,
                0.229829
            ],
            [
                0.738834,
                0.707117,
                -0.307018
            ],
            [
                0.859683,
                -0.535264,
                -0.338508
            ]
        ],
        face: [
            [
                3,
                0,
                2
            ],
            [
                5,
                3,
                2
            ],
            [
                4,
                5,
                2
            ],
            [
                1,
                4,
                2
            ],
            [
                0,
                1,
                2
            ],
            [
                0,
                3,
                5,
                4,
                1
            ]
        ]
    };
    polyhedra[10] = {
        vertex: [
            [
                -0.610389,
                0.243975,
                0.531213
            ],
            [
                -0.187812,
                -0.48795,
                -0.664016
            ],
            [
                -0.187812,
                0.9759,
                -0.664016
            ],
            [
                0.187812,
                -0.9759,
                0.664016
            ],
            [
                0.798201,
                0.243975,
                0.132803
            ]
        ],
        face: [
            [
                1,
                3,
                0
            ],
            [
                3,
                4,
                0
            ],
            [
                3,
                1,
                4
            ],
            [
                0,
                2,
                1
            ],
            [
                0,
                4,
                2
            ],
            [
                2,
                4,
                1
            ]
        ]
    };
    polyhedra[11] = {
        vertex: [
            [
                -1.028778,
                0.392027,
                -0.048786
            ],
            [
                -0.640503,
                -0.646161,
                0.621837
            ],
            [
                -0.125162,
                -0.395663,
                -0.540059
            ],
            [
                0.004683,
                0.888447,
                -0.651988
            ],
            [
                0.125161,
                0.395663,
                0.540059
            ],
            [
                0.632925,
                -0.791376,
                0.433102
            ],
            [
                1.031672,
                0.157063,
                -0.354165
            ]
        ],
        face: [
            [
                3,
                2,
                0
            ],
            [
                2,
                1,
                0
            ],
            [
                2,
                5,
                1
            ],
            [
                0,
                4,
                3
            ],
            [
                0,
                1,
                4
            ],
            [
                4,
                1,
                5
            ],
            [
                2,
                3,
                6
            ],
            [
                3,
                4,
                6
            ],
            [
                5,
                2,
                6
            ],
            [
                4,
                5,
                6
            ]
        ]
    };
    polyhedra[12] = {
        vertex: [
            [
                -0.669867,
                0.334933,
                -0.529576
            ],
            [
                -0.669867,
                0.334933,
                0.529577
            ],
            [
                -0.4043,
                1.212901,
                0
            ],
            [
                -0.334933,
                -0.669867,
                -0.529576
            ],
            [
                -0.334933,
                -0.669867,
                0.529577
            ],
            [
                0.334933,
                0.669867,
                -0.529576
            ],
            [
                0.334933,
                0.669867,
                0.529577
            ],
            [
                0.4043,
                -1.212901,
                0
            ],
            [
                0.669867,
                -0.334933,
                -0.529576
            ],
            [
                0.669867,
                -0.334933,
                0.529577
            ]
        ],
        face: [
            [
                8,
                9,
                7
            ],
            [
                6,
                5,
                2
            ],
            [
                3,
                8,
                7
            ],
            [
                5,
                0,
                2
            ],
            [
                4,
                3,
                7
            ],
            [
                0,
                1,
                2
            ],
            [
                9,
                4,
                7
            ],
            [
                1,
                6,
                2
            ],
            [
                9,
                8,
                5,
                6
            ],
            [
                8,
                3,
                0,
                5
            ],
            [
                3,
                4,
                1,
                0
            ],
            [
                4,
                9,
                6,
                1
            ]
        ]
    };
    polyhedra[13] = {
        vertex: [
            [
                -0.931836,
                0.219976,
                -0.264632
            ],
            [
                -0.636706,
                0.318353,
                0.692816
            ],
            [
                -0.613483,
                -0.735083,
                -0.264632
            ],
            [
                -0.326545,
                0.979634,
                0
            ],
            [
                -0.318353,
                -0.636706,
                0.692816
            ],
            [
                -0.159176,
                0.477529,
                -0.856368
            ],
            [
                0.159176,
                -0.477529,
                -0.856368
            ],
            [
                0.318353,
                0.636706,
                0.692816
            ],
            [
                0.326545,
                -0.979634,
                0
            ],
            [
                0.613482,
                0.735082,
                -0.264632
            ],
            [
                0.636706,
                -0.318353,
                0.692816
            ],
            [
                0.931835,
                -0.219977,
                -0.264632
            ]
        ],
        face: [
            [
                11,
                10,
                8
            ],
            [
                7,
                9,
                3
            ],
            [
                6,
                11,
                8
            ],
            [
                9,
                5,
                3
            ],
            [
                2,
                6,
                8
            ],
            [
                5,
                0,
                3
            ],
            [
                4,
                2,
                8
            ],
            [
                0,
                1,
                3
            ],
            [
                10,
                4,
                8
            ],
            [
                1,
                7,
                3
            ],
            [
                10,
                11,
                9,
                7
            ],
            [
                11,
                6,
                5,
                9
            ],
            [
                6,
                2,
                0,
                5
            ],
            [
                2,
                4,
                1,
                0
            ],
            [
                4,
                10,
                7,
                1
            ]
        ]
    };
    polyhedra[14] = {
        vertex: [
            [
                -0.93465,
                0.300459,
                -0.271185
            ],
            [
                -0.838689,
                -0.260219,
                -0.516017
            ],
            [
                -0.711319,
                0.717591,
                0.128359
            ],
            [
                -0.710334,
                -0.156922,
                0.080946
            ],
            [
                -0.599799,
                0.556003,
                -0.725148
            ],
            [
                -0.503838,
                -0.004675,
                -0.969981
            ],
            [
                -0.487004,
                0.26021,
                0.48049
            ],
            [
                -0.460089,
                -0.750282,
                -0.512622
            ],
            [
                -0.376468,
                0.973135,
                -0.325605
            ],
            [
                -0.331735,
                -0.646985,
                0.084342
            ],
            [
                -0.254001,
                0.831847,
                0.530001
            ],
            [
                -0.125239,
                -0.494738,
                -0.966586
            ],
            [
                0.029622,
                0.027949,
                0.730817
            ],
            [
                0.056536,
                -0.982543,
                -0.262295
            ],
            [
                0.08085,
                1.087391,
                0.076037
            ],
            [
                0.125583,
                -0.532729,
                0.485984
            ],
            [
                0.262625,
                0.599586,
                0.780328
            ],
            [
                0.391387,
                -0.726999,
                -0.716259
            ],
            [
                0.513854,
                -0.868287,
                0.139347
            ],
            [
                0.597475,
                0.85513,
                0.326364
            ],
            [
                0.641224,
                0.109523,
                0.783723
            ],
            [
                0.737185,
                -0.451155,
                0.538891
            ],
            [
                0.848705,
                -0.612742,
                -0.314616
            ],
            [
                0.976075,
                0.365067,
                0.32976
            ],
            [
                1.072036,
                -0.19561,
                0.084927
            ]
        ],
        face: [
            [
                15,
                18,
                21
            ],
            [
                12,
                20,
                16
            ],
            [
                6,
                10,
                2
            ],
            [
                3,
                0,
                1
            ],
            [
                9,
                7,
                13
            ],
            [
                2,
                8,
                4,
                0
            ],
            [
                0,
                4,
                5,
                1
            ],
            [
                1,
                5,
                11,
                7
            ],
            [
                7,
                11,
                17,
                13
            ],
            [
                13,
                17,
                22,
                18
            ],
            [
                18,
                22,
                24,
                21
            ],
            [
                21,
                24,
                23,
                20
            ],
            [
                20,
                23,
                19,
                16
            ],
            [
                16,
                19,
                14,
                10
            ],
            [
                10,
                14,
                8,
                2
            ],
            [
                15,
                9,
                13,
                18
            ],
            [
                12,
                15,
                21,
                20
            ],
            [
                6,
                12,
                16,
                10
            ],
            [
                3,
                6,
                2,
                0
            ],
            [
                9,
                3,
                1,
                7
            ],
            [
                9,
                15,
                12,
                6,
                3
            ],
            [
                22,
                17,
                11,
                5,
                4,
                8,
                14,
                19,
                23,
                24
            ]
        ]
    };
    const type = options.type && (options.type < 0 || options.type >= polyhedra.length) ? 0 : options.type || 0;
    const size = options.size;
    const sizeX = options.sizeX || size || 1;
    const sizeY = options.sizeY || size || 1;
    const sizeZ = options.sizeZ || size || 1;
    const data = options.custom || polyhedra[type];
    const nbfaces = data.face.length;
    const faceUV = options.faceUV || new Array(nbfaces);
    const faceColors = options.faceColors;
    const flat = options.flat === undefined ? true : options.flat;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    const colors = [];
    let index = 0;
    let faceIdx = 0; // face cursor in the array "indexes"
    const indexes = [];
    let i = 0;
    let f = 0;
    let u, v, ang, x, y, tmp;
    // default face colors and UV if undefined
    if (flat) for(f = 0; f < nbfaces; f++){
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
        if (faceUV && faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
    }
    if (!flat) {
        for(i = 0; i < data.vertex.length; i++){
            positions.push(data.vertex[i][0] * sizeX, data.vertex[i][1] * sizeY, data.vertex[i][2] * sizeZ);
            uvs.push(0, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 : 0);
        }
        for(f = 0; f < nbfaces; f++)for(i = 0; i < data.face[f].length - 2; i++)indices.push(data.face[f][0], data.face[f][i + 2], data.face[f][i + 1]);
    } else for(f = 0; f < nbfaces; f++){
        const fl = data.face[f].length; // number of vertices of the current face
        ang = 2 * Math.PI / fl;
        x = 0.5 * Math.tan(ang / 2);
        y = 0.5;
        // positions, uvs, colors
        for(i = 0; i < fl; i++){
            // positions
            positions.push(data.vertex[data.face[f][i]][0] * sizeX, data.vertex[data.face[f][i]][1] * sizeY, data.vertex[data.face[f][i]][2] * sizeZ);
            indexes.push(index);
            index++;
            // uvs
            u = faceUV[f].x + (faceUV[f].z - faceUV[f].x) * (0.5 + x);
            v = faceUV[f].y + (faceUV[f].w - faceUV[f].y) * (y - 0.5);
            uvs.push(u, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - v : v);
            tmp = x * Math.cos(ang) - y * Math.sin(ang);
            y = x * Math.sin(ang) + y * Math.cos(ang);
            x = tmp;
            // colors
            if (faceColors) colors.push(faceColors[f].r, faceColors[f].g, faceColors[f].b, faceColors[f].a);
        }
        // indices from indexes
        for(i = 0; i < fl - 2; i++)indices.push(indexes[0 + faceIdx], indexes[i + 2 + faceIdx], indexes[i + 1 + faceIdx]);
        faceIdx += fl;
    }
    (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(positions, indices, normals);
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.positions = positions;
    vertexData.indices = indices;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors && flat) vertexData.colors = colors;
    return vertexData;
}
function $1d49167c5ec927a7$export$1cb5c9516e55bfc7(name, options = {}, scene = null) {
    const polyhedron = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    polyhedron._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $1d49167c5ec927a7$export$c72e10f5a1c9dc82(options);
    vertexData.applyToMesh(polyhedron, options.updatable);
    return polyhedron;
}
const $1d49167c5ec927a7$export$ccaedb7c99deedc1 = {
    CreatePolyhedron: // eslint-disable-next-line @typescript-eslint/naming-convention
    $1d49167c5ec927a7$export$1cb5c9516e55bfc7
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreatePolyhedron = $1d49167c5ec927a7$export$c72e10f5a1c9dc82;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreatePolyhedron = (name, options, scene)=>{
    return $1d49167c5ec927a7$export$1cb5c9516e55bfc7(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");



var $fGXjI = parcelRequire("fGXjI");
function $bb03d208aef23781$export$f71122fae51601ba(options) {
    const sideOrientation = options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const radius = options.radius || 1;
    const flat = options.flat === undefined ? true : options.flat;
    const subdivisions = (options.subdivisions || 4) | 0;
    const radiusX = options.radiusX || radius;
    const radiusY = options.radiusY || radius;
    const radiusZ = options.radiusZ || radius;
    const t = (1 + Math.sqrt(5)) / 2;
    // 12 vertex x,y,z
    const icoVertices = [
        -1,
        t,
        -0,
        1,
        t,
        0,
        -1,
        -t,
        0,
        1,
        -t,
        0,
        0,
        -1,
        -t,
        0,
        1,
        -t,
        0,
        -1,
        t,
        0,
        1,
        t,
        t,
        0,
        1,
        t,
        0,
        -1,
        -t,
        0,
        1,
        -t,
        0,
        -1
    ];
    // index of 3 vertex makes a face of icopshere
    const ico_indices = [
        0,
        11,
        5,
        0,
        5,
        1,
        0,
        1,
        7,
        0,
        7,
        10,
        12,
        22,
        23,
        1,
        5,
        20,
        5,
        11,
        4,
        23,
        22,
        13,
        22,
        18,
        6,
        7,
        1,
        8,
        14,
        21,
        4,
        14,
        4,
        2,
        16,
        13,
        6,
        15,
        6,
        19,
        3,
        8,
        9,
        4,
        21,
        5,
        13,
        17,
        23,
        6,
        13,
        22,
        19,
        6,
        18,
        9,
        8,
        1
    ];
    // vertex for uv have aliased position, not for UV
    const vertices_unalias_id = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        // vertex alias
        0,
        2,
        3,
        3,
        3,
        4,
        7,
        8,
        9,
        9,
        10,
        11
    ];
    // uv as integer step (not pixels !)
    const ico_vertexuv = [
        5,
        1,
        3,
        1,
        6,
        4,
        0,
        0,
        5,
        3,
        4,
        2,
        2,
        2,
        4,
        0,
        2,
        0,
        1,
        1,
        6,
        0,
        6,
        2,
        // vertex alias (for same vertex on different faces)
        0,
        4,
        3,
        3,
        4,
        4,
        3,
        1,
        4,
        2,
        4,
        4,
        0,
        2,
        1,
        1,
        2,
        2,
        3,
        3,
        1,
        3,
        2,
        4
    ];
    // Vertices[0, 1, ...9, A, B] : position on UV plane
    // '+' indicate duplicate position to be fixed (3,9:0,2,3,4,7,8,A,B)
    // First island of uv mapping
    // v = 4h          3+  2
    // v = 3h        9+  4
    // v = 2h      9+  5   B
    // v = 1h    9   1   0
    // v = 0h  3   8   7   A
    //     u = 0 1 2 3 4 5 6  *a
    // Second island of uv mapping
    // v = 4h  0+  B+  4+
    // v = 3h    A+  2+
    // v = 2h  7+  6   3+
    // v = 1h    8+  3+
    // v = 0h
    //     u = 0 1 2 3 4 5 6  *a
    // Face layout on texture UV mapping
    // ============
    // \ 4  /\ 16 /   ======
    //  \  /  \  /   /\ 11 /
    //   \/ 7  \/   /  \  /
    //    =======  / 10 \/
    //   /\ 17 /\  =======
    //  /  \  /  \ \ 15 /\
    // / 8  \/ 12 \ \  /  \
    // ============  \/ 6  \
    // \ 18 /\  ============
    //  \  /  \ \ 5  /\ 0  /
    //   \/ 13 \ \  /  \  /
    //   =======  \/ 1  \/
    //       =============
    //      /\ 19 /\  2 /\
    //     /  \  /  \  /  \
    //    / 14 \/ 9  \/  3 \
    //   ===================
    // uv step is u:1 or 0.5, v:cos(30)=sqrt(3)/2, ratio approx is 84/97
    const ustep = 138 / 1024;
    const vstep = 239 / 1024;
    const uoffset = 60 / 1024;
    const voffset = 26 / 1024;
    // Second island should have margin, not to touch the first island
    // avoid any borderline artefact in pixel rounding
    const island_u_offset = -40 / 1024;
    const island_v_offset = 20 / 1024;
    // face is either island 0 or 1 :
    // second island is for faces : [4, 7, 8, 12, 13, 16, 17, 18]
    const island = [
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ];
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let current_indice = 0;
    // prepare array of 3 vector (empty) (to be worked in place, shared for each face)
    const face_vertex_pos = new Array(3);
    const face_vertex_uv = new Array(3);
    let v012;
    for(v012 = 0; v012 < 3; v012++){
        face_vertex_pos[v012] = (0, $ha1VO.Vector3).Zero();
        face_vertex_uv[v012] = (0, $ha1VO.Vector2).Zero();
    }
    // create all with normals
    for(let face = 0; face < 20; face++){
        // 3 vertex per face
        for(v012 = 0; v012 < 3; v012++){
            // look up vertex 0,1,2 to its index in 0 to 11 (or 23 including alias)
            const v_id = ico_indices[3 * face + v012];
            // vertex have 3D position (x,y,z)
            face_vertex_pos[v012].copyFromFloats(icoVertices[3 * vertices_unalias_id[v_id]], icoVertices[3 * vertices_unalias_id[v_id] + 1], icoVertices[3 * vertices_unalias_id[v_id] + 2]);
            // Normalize to get normal
            face_vertex_pos[v012].normalize();
            // uv Coordinates from vertex ID
            face_vertex_uv[v012].copyFromFloats(ico_vertexuv[2 * v_id] * ustep + uoffset + island[face] * island_u_offset, ico_vertexuv[2 * v_id + 1] * vstep + voffset + island[face] * island_v_offset);
        }
        // Subdivide the face (interpolate pos, norm, uv)
        // - pos is linear interpolation, then projected to sphere (converge polyhedron to sphere)
        // - norm is linear interpolation of vertex corner normal
        //   (to be checked if better to re-calc from face vertex, or if approximation is OK ??? )
        // - uv is linear interpolation
        //
        // Topology is as below for sub-divide by 2
        // vertex shown as v0,v1,v2
        // interp index is i1 to progress in range [v0,v1[
        // interp index is i2 to progress in range [v0,v2[
        // face index as  (i1,i2)  for /\  : (i1,i2),(i1+1,i2),(i1,i2+1)
        //            and (i1,i2)' for \/  : (i1+1,i2),(i1+1,i2+1),(i1,i2+1)
        //
        //
        //                    i2    v2
        //                    ^    ^
        //                   /    / \
        //                  /    /   \
        //                 /    /     \
        //                /    / (0,1) \
        //               /    #---------\
        //              /    / \ (0,0)'/ \
        //             /    /   \     /   \
        //            /    /     \   /     \
        //           /    / (0,0) \ / (1,0) \
        //          /    #---------#---------\
        //              v0                    v1
        //
        //              --------------------> i1
        //
        // interp of (i1,i2):
        //  along i2 :  x0=lerp(v0,v2, i2/S) <---> x1=lerp(v1,v2, i2/S)
        //  along i1 :  lerp(x0,x1, i1/(S-i2))
        //
        // centroid of triangle is needed to get help normal computation
        //  (c1,c2) are used for centroid location
        const interp_vertex = (i1, i2, c1, c2)=>{
            // vertex is interpolated from
            //   - face_vertex_pos[0..2]
            //   - face_vertex_uv[0..2]
            const pos_x0 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[0], face_vertex_pos[2], i2 / subdivisions);
            const pos_x1 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[1], face_vertex_pos[2], i2 / subdivisions);
            const pos_interp = subdivisions === i2 ? face_vertex_pos[2] : (0, $ha1VO.Vector3).Lerp(pos_x0, pos_x1, i1 / (subdivisions - i2));
            pos_interp.normalize();
            let vertex_normal;
            if (flat) {
                // in flat mode, recalculate normal as face centroid normal
                const centroid_x0 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[0], face_vertex_pos[2], c2 / subdivisions);
                const centroid_x1 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[1], face_vertex_pos[2], c2 / subdivisions);
                vertex_normal = (0, $ha1VO.Vector3).Lerp(centroid_x0, centroid_x1, c1 / (subdivisions - c2));
            } else // in smooth mode, recalculate normal from each single vertex position
            vertex_normal = new (0, $ha1VO.Vector3)(pos_interp.x, pos_interp.y, pos_interp.z);
            // Vertex normal need correction due to X,Y,Z radius scaling
            vertex_normal.x /= radiusX;
            vertex_normal.y /= radiusY;
            vertex_normal.z /= radiusZ;
            vertex_normal.normalize();
            const uv_x0 = (0, $ha1VO.Vector2).Lerp(face_vertex_uv[0], face_vertex_uv[2], i2 / subdivisions);
            const uv_x1 = (0, $ha1VO.Vector2).Lerp(face_vertex_uv[1], face_vertex_uv[2], i2 / subdivisions);
            const uv_interp = subdivisions === i2 ? face_vertex_uv[2] : (0, $ha1VO.Vector2).Lerp(uv_x0, uv_x1, i1 / (subdivisions - i2));
            positions.push(pos_interp.x * radiusX, pos_interp.y * radiusY, pos_interp.z * radiusZ);
            normals.push(vertex_normal.x, vertex_normal.y, vertex_normal.z);
            uvs.push(uv_interp.x, (0, $fGXjI.useOpenGLOrientationForUV) ? 1.0 - uv_interp.y : uv_interp.y);
            // push each vertex has member of a face
            // Same vertex can belong to multiple face, it is pushed multiple time (duplicate vertex are present)
            indices.push(current_indice);
            current_indice++;
        };
        for(let i2 = 0; i2 < subdivisions; i2++)for(let i1 = 0; i1 + i2 < subdivisions; i1++){
            // face : (i1,i2)  for /\  :
            // interp for : (i1,i2),(i1+1,i2),(i1,i2+1)
            interp_vertex(i1, i2, i1 + 1.0 / 3, i2 + 1.0 / 3);
            interp_vertex(i1 + 1, i2, i1 + 1.0 / 3, i2 + 1.0 / 3);
            interp_vertex(i1, i2 + 1, i1 + 1.0 / 3, i2 + 1.0 / 3);
            if (i1 + i2 + 1 < subdivisions) {
                // face : (i1,i2)' for \/  :
                // interp for (i1+1,i2),(i1+1,i2+1),(i1,i2+1)
                interp_vertex(i1 + 1, i2, i1 + 2.0 / 3, i2 + 2.0 / 3);
                interp_vertex(i1 + 1, i2 + 1, i1 + 2.0 / 3, i2 + 2.0 / 3);
                interp_vertex(i1, i2 + 1, i1 + 2.0 / 3, i2 + 2.0 / 3);
            }
        }
    }
    // Sides
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $bb03d208aef23781$export$2bceb0111207e85d(name, options = {}, scene = null) {
    const sphere = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    sphere._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $bb03d208aef23781$export$f71122fae51601ba(options);
    vertexData.applyToMesh(sphere, options.updatable);
    return sphere;
}
const $bb03d208aef23781$export$ecc833c0c02ed574 = {
    CreateIcoSphere: // eslint-disable-next-line @typescript-eslint/naming-convention
    $bb03d208aef23781$export$2bceb0111207e85d
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateIcoSphere = $bb03d208aef23781$export$f71122fae51601ba;
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateIcoSphere = (name, options, scene)=>{
    return $bb03d208aef23781$export$2bceb0111207e85d(name, options, scene);
};



var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");


var $b4i1f = parcelRequire("b4i1f");


var $fGXjI = parcelRequire("fGXjI");
const $0e606b1f6b3f9d8d$var$xpAxis = new (0, $ha1VO.Vector3)(1, 0, 0);
const $0e606b1f6b3f9d8d$var$xnAxis = new (0, $ha1VO.Vector3)(-1, 0, 0);
const $0e606b1f6b3f9d8d$var$ypAxis = new (0, $ha1VO.Vector3)(0, 1, 0);
const $0e606b1f6b3f9d8d$var$ynAxis = new (0, $ha1VO.Vector3)(0, -1, 0);
const $0e606b1f6b3f9d8d$var$zpAxis = new (0, $ha1VO.Vector3)(0, 0, 1);
const $0e606b1f6b3f9d8d$var$znAxis = new (0, $ha1VO.Vector3)(0, 0, -1);
/** @internal */ class $0e606b1f6b3f9d8d$var$DecalVertex {
    constructor(position = (0, $ha1VO.Vector3).Zero(), normal = (0, $ha1VO.Vector3).Up(), uv = (0, $ha1VO.Vector2).Zero(), vertexIdx = 0, vertexIdxForBones = 0, localPositionOverride = null, localNormalOverride = null, matrixIndicesOverride = null, matrixWeightsOverride = null){
        this.position = position;
        this.normal = normal;
        this.uv = uv;
        this.vertexIdx = vertexIdx;
        this.vertexIdxForBones = vertexIdxForBones;
        this.localPositionOverride = localPositionOverride;
        this.localNormalOverride = localNormalOverride;
        this.matrixIndicesOverride = matrixIndicesOverride;
        this.matrixWeightsOverride = matrixWeightsOverride;
    }
    clone() {
        return new $0e606b1f6b3f9d8d$var$DecalVertex(this.position.clone(), this.normal.clone(), this.uv.clone(), this.vertexIdx, this.vertexIdxForBones, this.localPositionOverride?.slice(), this.localNormalOverride?.slice(), this.matrixIndicesOverride?.slice(), this.matrixWeightsOverride?.slice());
    }
}
function $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8(name, sourceMesh, options) {
    const hasSkeleton = !!sourceMesh.skeleton;
    const useLocalComputation = options.localMode || hasSkeleton;
    const indices = sourceMesh.getIndices();
    const positions = hasSkeleton ? sourceMesh.getPositionData(true, true) : sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
    const normals = hasSkeleton ? sourceMesh.getNormalsData(true, true) : sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
    const localPositions = useLocalComputation ? hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind) : positions : null;
    const localNormals = useLocalComputation ? hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind) : normals : null;
    const uvs = sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
    const matIndices = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind) : null;
    const matWeights = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind) : null;
    const matIndicesExtra = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind) : null;
    const matWeightsExtra = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind) : null;
    const position = options.position || (0, $ha1VO.Vector3).Zero();
    let normal = options.normal || (0, $ha1VO.Vector3).Up();
    const size = options.size || (0, $ha1VO.Vector3).One();
    const angle = options.angle || 0;
    // Getting correct rotation
    if (!normal) {
        const target = new (0, $ha1VO.Vector3)(0, 0, 1);
        const camera = sourceMesh.getScene().activeCamera;
        const cameraWorldTarget = (0, $ha1VO.Vector3).TransformCoordinates(target, camera.getWorldMatrix());
        normal = camera.globalPosition.subtract(cameraWorldTarget);
    }
    const yaw = -Math.atan2(normal.z, normal.x) - Math.PI / 2;
    const len = Math.sqrt(normal.x * normal.x + normal.z * normal.z);
    const pitch = Math.atan2(normal.y, len);
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.indices = [];
    vertexData.positions = [];
    vertexData.normals = [];
    vertexData.uvs = [];
    vertexData.matricesIndices = hasSkeleton ? [] : null;
    vertexData.matricesWeights = hasSkeleton ? [] : null;
    vertexData.matricesIndicesExtra = matIndicesExtra ? [] : null;
    vertexData.matricesWeightsExtra = matWeightsExtra ? [] : null;
    let currentVertexDataIndex = 0;
    const extractDecalVector3 = (indexId, transformMatrix)=>{
        const result = new $0e606b1f6b3f9d8d$var$DecalVertex();
        if (!indices || !positions || !normals) return result;
        const vertexId = indices[indexId];
        result.vertexIdx = vertexId * 3;
        result.vertexIdxForBones = vertexId * 4;
        // Send vector to decal local world
        result.position = new (0, $ha1VO.Vector3)(positions[vertexId * 3], positions[vertexId * 3 + 1], positions[vertexId * 3 + 2]);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(result.position, transformMatrix, result.position);
        // Get normal
        result.normal = new (0, $ha1VO.Vector3)(normals[vertexId * 3], normals[vertexId * 3 + 1], normals[vertexId * 3 + 2]);
        (0, $ha1VO.Vector3).TransformNormalToRef(result.normal, transformMatrix, result.normal);
        if (options.captureUVS && uvs) {
            const v = uvs[vertexId * 2 + 1];
            result.uv = new (0, $ha1VO.Vector2)(uvs[vertexId * 2], (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
        }
        return result;
    };
    const emptyArray = [
        0,
        0,
        0,
        0
    ];
    // Inspired by https://github.com/mrdoob/three.js/blob/eee231960882f6f3b6113405f524956145148146/examples/js/geometries/DecalGeometry.js
    const clip = (vertices, axis)=>{
        if (vertices.length === 0) return vertices;
        const clipSize = 0.5 * Math.abs((0, $ha1VO.Vector3).Dot(size, axis));
        const indexOf = (arr, val, start, num)=>{
            for(let i = 0; i < num; ++i){
                if (arr[start + i] === val) return start + i;
            }
            return -1;
        };
        const clipVertices = (v0, v1)=>{
            const clipFactor = (0, $ha1VO.Vector3).GetClipFactor(v0.position, v1.position, axis, clipSize);
            let indices = emptyArray;
            let weights = emptyArray;
            if (matIndices && matWeights) {
                const mat0Index = v0.matrixIndicesOverride ? 0 : v0.vertexIdxForBones;
                const v0Indices = v0.matrixIndicesOverride ?? matIndices;
                const v0Weights = v0.matrixWeightsOverride ?? matWeights;
                const mat1Index = v1.matrixIndicesOverride ? 0 : v1.vertexIdxForBones;
                const v1Indices = v1.matrixIndicesOverride ?? matIndices;
                const v1Weights = v1.matrixWeightsOverride ?? matWeights;
                indices = [
                    0,
                    0,
                    0,
                    0
                ];
                weights = [
                    0,
                    0,
                    0,
                    0
                ];
                let index = 0;
                for(let i = 0; i < 4; ++i)if (v0Weights[mat0Index + i] > 0) {
                    const idx = indexOf(v1Indices, v0Indices[mat0Index + i], mat1Index, 4);
                    indices[index] = v0Indices[mat0Index + i];
                    weights[index] = (0, $iosaP.Lerp)(v0Weights[mat0Index + i], idx >= 0 ? v1Weights[idx] : 0, clipFactor);
                    index++;
                }
                for(let i = 0; i < 4 && index < 4; ++i){
                    const ind = v1Indices[mat1Index + i];
                    if (indexOf(v0Indices, ind, mat0Index, 4) !== -1) continue;
                    indices[index] = ind;
                    weights[index] = (0, $iosaP.Lerp)(0, v1Weights[mat1Index + i], clipFactor);
                    index++;
                }
                const sumw = weights[0] + weights[1] + weights[2] + weights[3];
                weights[0] /= sumw;
                weights[1] /= sumw;
                weights[2] /= sumw;
                weights[3] /= sumw;
            }
            const v0LocalPositionX = v0.localPositionOverride ? v0.localPositionOverride[0] : localPositions?.[v0.vertexIdx] ?? 0;
            const v0LocalPositionY = v0.localPositionOverride ? v0.localPositionOverride[1] : localPositions?.[v0.vertexIdx + 1] ?? 0;
            const v0LocalPositionZ = v0.localPositionOverride ? v0.localPositionOverride[2] : localPositions?.[v0.vertexIdx + 2] ?? 0;
            const v1LocalPositionX = v1.localPositionOverride ? v1.localPositionOverride[0] : localPositions?.[v1.vertexIdx] ?? 0;
            const v1LocalPositionY = v1.localPositionOverride ? v1.localPositionOverride[1] : localPositions?.[v1.vertexIdx + 1] ?? 0;
            const v1LocalPositionZ = v1.localPositionOverride ? v1.localPositionOverride[2] : localPositions?.[v1.vertexIdx + 2] ?? 0;
            const v0LocalNormalX = v0.localNormalOverride ? v0.localNormalOverride[0] : localNormals?.[v0.vertexIdx] ?? 0;
            const v0LocalNormalY = v0.localNormalOverride ? v0.localNormalOverride[1] : localNormals?.[v0.vertexIdx + 1] ?? 0;
            const v0LocalNormalZ = v0.localNormalOverride ? v0.localNormalOverride[2] : localNormals?.[v0.vertexIdx + 2] ?? 0;
            const v1LocalNormalX = v1.localNormalOverride ? v1.localNormalOverride[0] : localNormals?.[v1.vertexIdx] ?? 0;
            const v1LocalNormalY = v1.localNormalOverride ? v1.localNormalOverride[1] : localNormals?.[v1.vertexIdx + 1] ?? 0;
            const v1LocalNormalZ = v1.localNormalOverride ? v1.localNormalOverride[2] : localNormals?.[v1.vertexIdx + 2] ?? 0;
            const interpNormalX = v0LocalNormalX + (v1LocalNormalX - v0LocalNormalX) * clipFactor;
            const interpNormalY = v0LocalNormalY + (v1LocalNormalY - v0LocalNormalY) * clipFactor;
            const interpNormalZ = v0LocalNormalZ + (v1LocalNormalZ - v0LocalNormalZ) * clipFactor;
            const norm = Math.sqrt(interpNormalX * interpNormalX + interpNormalY * interpNormalY + interpNormalZ * interpNormalZ);
            return new $0e606b1f6b3f9d8d$var$DecalVertex((0, $ha1VO.Vector3).Lerp(v0.position, v1.position, clipFactor), (0, $ha1VO.Vector3).Lerp(v0.normal, v1.normal, clipFactor).normalize(), (0, $ha1VO.Vector2).Lerp(v0.uv, v1.uv, clipFactor), -1, -1, localPositions ? [
                v0LocalPositionX + (v1LocalPositionX - v0LocalPositionX) * clipFactor,
                v0LocalPositionY + (v1LocalPositionY - v0LocalPositionY) * clipFactor,
                v0LocalPositionZ + (v1LocalPositionZ - v0LocalPositionZ) * clipFactor
            ] : null, localNormals ? [
                interpNormalX / norm,
                interpNormalY / norm,
                interpNormalZ / norm
            ] : null, indices, weights);
        };
        let clipResult = null;
        if (vertices.length > 3) clipResult = [];
        for(let index = 0; index < vertices.length; index += 3){
            let total = 0;
            let nV1 = null;
            let nV2 = null;
            let nV3 = null;
            let nV4 = null;
            const d1 = (0, $ha1VO.Vector3).Dot(vertices[index].position, axis) - clipSize;
            const d2 = (0, $ha1VO.Vector3).Dot(vertices[index + 1].position, axis) - clipSize;
            const d3 = (0, $ha1VO.Vector3).Dot(vertices[index + 2].position, axis) - clipSize;
            const v1Out = d1 > 0;
            const v2Out = d2 > 0;
            const v3Out = d3 > 0;
            total = (v1Out ? 1 : 0) + (v2Out ? 1 : 0) + (v3Out ? 1 : 0);
            switch(total){
                case 0:
                    if (vertices.length > 3) {
                        clipResult.push(vertices[index]);
                        clipResult.push(vertices[index + 1]);
                        clipResult.push(vertices[index + 2]);
                    } else clipResult = vertices;
                    break;
                case 1:
                    clipResult = clipResult ?? new Array();
                    if (v1Out) {
                        nV1 = vertices[index + 1];
                        nV2 = vertices[index + 2];
                        nV3 = clipVertices(vertices[index], nV1);
                        nV4 = clipVertices(vertices[index], nV2);
                    }
                    if (v2Out) {
                        nV1 = vertices[index];
                        nV2 = vertices[index + 2];
                        nV3 = clipVertices(vertices[index + 1], nV1);
                        nV4 = clipVertices(vertices[index + 1], nV2);
                        clipResult.push(nV3);
                        clipResult.push(nV2.clone());
                        clipResult.push(nV1.clone());
                        clipResult.push(nV2.clone());
                        clipResult.push(nV3.clone());
                        clipResult.push(nV4);
                        break;
                    }
                    if (v3Out) {
                        nV1 = vertices[index];
                        nV2 = vertices[index + 1];
                        nV3 = clipVertices(vertices[index + 2], nV1);
                        nV4 = clipVertices(vertices[index + 2], nV2);
                    }
                    if (nV1 && nV2 && nV3 && nV4) {
                        clipResult.push(nV1.clone());
                        clipResult.push(nV2.clone());
                        clipResult.push(nV3);
                        clipResult.push(nV4);
                        clipResult.push(nV3.clone());
                        clipResult.push(nV2.clone());
                    }
                    break;
                case 2:
                    clipResult = clipResult ?? new Array();
                    if (!v1Out) {
                        nV1 = vertices[index].clone();
                        nV2 = clipVertices(nV1, vertices[index + 1]);
                        nV3 = clipVertices(nV1, vertices[index + 2]);
                        clipResult.push(nV1);
                        clipResult.push(nV2);
                        clipResult.push(nV3);
                    }
                    if (!v2Out) {
                        nV1 = vertices[index + 1].clone();
                        nV2 = clipVertices(nV1, vertices[index + 2]);
                        nV3 = clipVertices(nV1, vertices[index]);
                        clipResult.push(nV1);
                        clipResult.push(nV2);
                        clipResult.push(nV3);
                    }
                    if (!v3Out) {
                        nV1 = vertices[index + 2].clone();
                        nV2 = clipVertices(nV1, vertices[index]);
                        nV3 = clipVertices(nV1, vertices[index + 1]);
                        clipResult.push(nV1);
                        clipResult.push(nV2);
                        clipResult.push(nV3);
                    }
                    break;
                case 3:
                    break;
            }
        }
        return clipResult;
    };
    const sourceMeshAsMesh = sourceMesh instanceof (0, $b0df7c384622c537$export$e176487c05830cc5) ? sourceMesh : null;
    const matrixData = sourceMeshAsMesh?._thinInstanceDataStorage.matrixData;
    const numMatrices = sourceMeshAsMesh?.thinInstanceCount || 1;
    const thinInstanceMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
    thinInstanceMatrix.copyFrom((0, $ha1VO.Matrix).IdentityReadOnly);
    for(let m = 0; m < numMatrices; ++m){
        if (sourceMeshAsMesh?.hasThinInstances && matrixData) {
            const ofst = m * 16;
            thinInstanceMatrix.setRowFromFloats(0, matrixData[ofst + 0], matrixData[ofst + 1], matrixData[ofst + 2], matrixData[ofst + 3]);
            thinInstanceMatrix.setRowFromFloats(1, matrixData[ofst + 4], matrixData[ofst + 5], matrixData[ofst + 6], matrixData[ofst + 7]);
            thinInstanceMatrix.setRowFromFloats(2, matrixData[ofst + 8], matrixData[ofst + 9], matrixData[ofst + 10], matrixData[ofst + 11]);
            thinInstanceMatrix.setRowFromFloats(3, matrixData[ofst + 12], matrixData[ofst + 13], matrixData[ofst + 14], matrixData[ofst + 15]);
        }
        // Matrix
        const decalWorldMatrix = (0, $ha1VO.Matrix).RotationYawPitchRoll(yaw, pitch, angle).multiply((0, $ha1VO.Matrix).Translation(position.x, position.y, position.z));
        const inverseDecalWorldMatrix = (0, $ha1VO.Matrix).Invert(decalWorldMatrix);
        const meshWorldMatrix = sourceMesh.getWorldMatrix();
        const transformMatrix = thinInstanceMatrix.multiply(meshWorldMatrix).multiply(inverseDecalWorldMatrix);
        const oneFaceVertices = new Array(3);
        for(let index = 0; index < indices.length; index += 3){
            let faceVertices = oneFaceVertices;
            faceVertices[0] = extractDecalVector3(index, transformMatrix);
            faceVertices[1] = extractDecalVector3(index + 1, transformMatrix);
            faceVertices[2] = extractDecalVector3(index + 2, transformMatrix);
            if (options.cullBackFaces) {
                // If all the normals of the vertices of the face are pointing away from the view direction we discard the face.
                // As computations are done in the decal coordinate space, the viewDirection is (0,0,1), so when dot(vertexNormal, -viewDirection) <= 0 the vertex is culled
                if (-faceVertices[0].normal.z <= 0 && -faceVertices[1].normal.z <= 0 && -faceVertices[2].normal.z <= 0) continue;
            }
            // Clip
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$xpAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$xnAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$ypAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$ynAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$zpAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$znAxis);
            if (!faceVertices) continue;
            // Add UVs and get back to world
            for(let vIndex = 0; vIndex < faceVertices.length; vIndex++){
                const vertex = faceVertices[vIndex];
                //TODO check for Int32Array | Uint32Array | Uint16Array
                vertexData.indices.push(currentVertexDataIndex);
                if (useLocalComputation) {
                    if (vertex.localPositionOverride) {
                        vertexData.positions[currentVertexDataIndex * 3] = vertex.localPositionOverride[0];
                        vertexData.positions[currentVertexDataIndex * 3 + 1] = vertex.localPositionOverride[1];
                        vertexData.positions[currentVertexDataIndex * 3 + 2] = vertex.localPositionOverride[2];
                    } else if (localPositions) {
                        vertexData.positions[currentVertexDataIndex * 3] = localPositions[vertex.vertexIdx];
                        vertexData.positions[currentVertexDataIndex * 3 + 1] = localPositions[vertex.vertexIdx + 1];
                        vertexData.positions[currentVertexDataIndex * 3 + 2] = localPositions[vertex.vertexIdx + 2];
                    }
                    if (vertex.localNormalOverride) {
                        vertexData.normals[currentVertexDataIndex * 3] = vertex.localNormalOverride[0];
                        vertexData.normals[currentVertexDataIndex * 3 + 1] = vertex.localNormalOverride[1];
                        vertexData.normals[currentVertexDataIndex * 3 + 2] = vertex.localNormalOverride[2];
                    } else if (localNormals) {
                        vertexData.normals[currentVertexDataIndex * 3] = localNormals[vertex.vertexIdx];
                        vertexData.normals[currentVertexDataIndex * 3 + 1] = localNormals[vertex.vertexIdx + 1];
                        vertexData.normals[currentVertexDataIndex * 3 + 2] = localNormals[vertex.vertexIdx + 2];
                    }
                } else {
                    vertex.position.toArray(vertexData.positions, currentVertexDataIndex * 3);
                    vertex.normal.toArray(vertexData.normals, currentVertexDataIndex * 3);
                }
                if (vertexData.matricesIndices && vertexData.matricesWeights) {
                    if (vertex.matrixIndicesOverride) {
                        vertexData.matricesIndices[currentVertexDataIndex * 4] = vertex.matrixIndicesOverride[0];
                        vertexData.matricesIndices[currentVertexDataIndex * 4 + 1] = vertex.matrixIndicesOverride[1];
                        vertexData.matricesIndices[currentVertexDataIndex * 4 + 2] = vertex.matrixIndicesOverride[2];
                        vertexData.matricesIndices[currentVertexDataIndex * 4 + 3] = vertex.matrixIndicesOverride[3];
                    } else {
                        if (matIndices) {
                            vertexData.matricesIndices[currentVertexDataIndex * 4] = matIndices[vertex.vertexIdxForBones];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 1] = matIndices[vertex.vertexIdxForBones + 1];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 2] = matIndices[vertex.vertexIdxForBones + 2];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 3] = matIndices[vertex.vertexIdxForBones + 3];
                        }
                        if (matIndicesExtra && vertexData.matricesIndicesExtra) {
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4] = matIndicesExtra[vertex.vertexIdxForBones];
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 1] = matIndicesExtra[vertex.vertexIdxForBones + 1];
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 2] = matIndicesExtra[vertex.vertexIdxForBones + 2];
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 3] = matIndicesExtra[vertex.vertexIdxForBones + 3];
                        }
                    }
                    if (vertex.matrixWeightsOverride) {
                        vertexData.matricesWeights[currentVertexDataIndex * 4] = vertex.matrixWeightsOverride[0];
                        vertexData.matricesWeights[currentVertexDataIndex * 4 + 1] = vertex.matrixWeightsOverride[1];
                        vertexData.matricesWeights[currentVertexDataIndex * 4 + 2] = vertex.matrixWeightsOverride[2];
                        vertexData.matricesWeights[currentVertexDataIndex * 4 + 3] = vertex.matrixWeightsOverride[3];
                    } else {
                        if (matWeights) {
                            vertexData.matricesWeights[currentVertexDataIndex * 4] = matWeights[vertex.vertexIdxForBones];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 1] = matWeights[vertex.vertexIdxForBones + 1];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 2] = matWeights[vertex.vertexIdxForBones + 2];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 3] = matWeights[vertex.vertexIdxForBones + 3];
                        }
                        if (matWeightsExtra && vertexData.matricesWeightsExtra) {
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4] = matWeightsExtra[vertex.vertexIdxForBones];
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 1] = matWeightsExtra[vertex.vertexIdxForBones + 1];
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 2] = matWeightsExtra[vertex.vertexIdxForBones + 2];
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 3] = matWeightsExtra[vertex.vertexIdxForBones + 3];
                        }
                    }
                }
                if (!options.captureUVS) {
                    vertexData.uvs.push(0.5 + vertex.position.x / size.x);
                    const v = 0.5 + vertex.position.y / size.y;
                    vertexData.uvs.push((0, $fGXjI.useOpenGLOrientationForUV) ? 1 - v : v);
                } else vertex.uv.toArray(vertexData.uvs, currentVertexDataIndex * 2);
                currentVertexDataIndex++;
            }
        }
    }
    // Avoid the "Setting vertex data kind 'XXX' with an empty array" warning when calling vertexData.applyToMesh
    if (vertexData.indices.length === 0) vertexData.indices = null;
    if (vertexData.positions.length === 0) vertexData.positions = null;
    if (vertexData.normals.length === 0) vertexData.normals = null;
    if (vertexData.uvs.length === 0) vertexData.uvs = null;
    if (vertexData.matricesIndices?.length === 0) vertexData.matricesIndices = null;
    if (vertexData.matricesWeights?.length === 0) vertexData.matricesWeights = null;
    if (vertexData.matricesIndicesExtra?.length === 0) vertexData.matricesIndicesExtra = null;
    if (vertexData.matricesWeightsExtra?.length === 0) vertexData.matricesWeightsExtra = null;
    // Return mesh
    const decal = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, sourceMesh.getScene());
    vertexData.applyToMesh(decal);
    if (useLocalComputation) {
        decal.skeleton = sourceMesh.skeleton;
        decal.parent = sourceMesh;
    } else {
        decal.position = position.clone();
        decal.rotation = new (0, $ha1VO.Vector3)(pitch, yaw, angle);
    }
    decal.computeWorldMatrix(true);
    decal.refreshBoundingInfo(true, true);
    return decal;
}
const $0e606b1f6b3f9d8d$export$400e42794e248371 = {
    CreateDecal: // eslint-disable-next-line @typescript-eslint/naming-convention
    $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8
};
(0, $b0df7c384622c537$export$e176487c05830cc5).CreateDecal = (name, sourceMesh, position, normal, size, angle)=>{
    const options = {
        position: position,
        normal: normal,
        size: size,
        angle: angle
    };
    return $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8(name, sourceMesh, options);
};




var $ha1VO = parcelRequire("ha1VO");


var $fGXjI = parcelRequire("fGXjI");
function $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2(options = {
    subdivisions: 2,
    tessellation: 16,
    height: 1,
    radius: 0.25,
    capSubdivisions: 6
}) {
    const subdivisions = Math.max(options.subdivisions ? options.subdivisions : 2, 1) | 0;
    const tessellation = Math.max(options.tessellation ? options.tessellation : 16, 3) | 0;
    const height = Math.max(options.height ? options.height : 1, 0);
    const radius = Math.max(options.radius ? options.radius : 0.25, 0);
    const capDetail = Math.max(options.capSubdivisions ? options.capSubdivisions : 6, 1) | 0;
    const radialSegments = tessellation;
    const heightSegments = subdivisions;
    const radiusTop = Math.max(options.radiusTop ? options.radiusTop : radius, 0);
    const radiusBottom = Math.max(options.radiusBottom ? options.radiusBottom : radius, 0);
    const heightMinusCaps = height - (radiusTop + radiusBottom);
    const thetaStart = 0.0;
    const thetaLength = 2.0 * Math.PI;
    const capsTopSegments = Math.max(options.topCapSubdivisions ? options.topCapSubdivisions : capDetail, 1);
    const capsBottomSegments = Math.max(options.bottomCapSubdivisions ? options.bottomCapSubdivisions : capDetail, 1);
    const alpha = Math.acos((radiusBottom - radiusTop) / height);
    let indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let index = 0;
    const indexArray = [], halfHeight = heightMinusCaps * 0.5;
    const pi2 = Math.PI * 0.5;
    let x, y;
    const normal = (0, $ha1VO.Vector3).Zero();
    const vertex = (0, $ha1VO.Vector3).Zero();
    const cosAlpha = Math.cos(alpha);
    const sinAlpha = Math.sin(alpha);
    const coneLength = new (0, $ha1VO.Vector2)(radiusTop * sinAlpha, halfHeight + radiusTop * cosAlpha).subtract(new (0, $ha1VO.Vector2)(radiusBottom * sinAlpha, -halfHeight + radiusBottom * cosAlpha)).length();
    // Total length for v texture coord
    const vl = radiusTop * alpha + coneLength + radiusBottom * (pi2 - alpha);
    let v = 0;
    for(y = 0; y <= capsTopSegments; y++){
        const indexRow = [];
        const a = pi2 - alpha * (y / capsTopSegments);
        v += radiusTop * alpha / capsTopSegments;
        const cosA = Math.cos(a);
        const sinA = Math.sin(a);
        // calculate the radius of the current row
        const _radius = cosA * radiusTop;
        for(x = 0; x <= radialSegments; x++){
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // vertex
            vertex.x = _radius * sinTheta;
            vertex.y = halfHeight + sinA * radiusTop;
            vertex.z = _radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normal.set(cosA * sinTheta, sinA, cosA * cosTheta);
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, (0, $fGXjI.useOpenGLOrientationForUV) ? v / vl : 1 - v / vl);
            // save index of vertex in respective row
            indexRow.push(index);
            // increase index
            index++;
        }
        // now save vertices of the row in our index array
        indexArray.push(indexRow);
    }
    const coneHeight = height - radiusTop - radiusBottom + cosAlpha * radiusTop - cosAlpha * radiusBottom;
    const slope = sinAlpha * (radiusBottom - radiusTop) / coneHeight;
    for(y = 1; y <= heightSegments; y++){
        const indexRow = [];
        v += coneLength / heightSegments;
        // calculate the radius of the current row
        const _radius = sinAlpha * (y * (radiusBottom - radiusTop) / heightSegments + radiusTop);
        for(x = 0; x <= radialSegments; x++){
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // vertex
            vertex.x = _radius * sinTheta;
            vertex.y = halfHeight + cosAlpha * radiusTop - y * coneHeight / heightSegments;
            vertex.z = _radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normal.set(sinTheta, slope, cosTheta).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, (0, $fGXjI.useOpenGLOrientationForUV) ? v / vl : 1 - v / vl);
            // save index of vertex in respective row
            indexRow.push(index);
            // increase index
            index++;
        }
        // now save vertices of the row in our index array
        indexArray.push(indexRow);
    }
    for(y = 1; y <= capsBottomSegments; y++){
        const indexRow = [];
        const a = pi2 - alpha - (Math.PI - alpha) * (y / capsBottomSegments);
        v += radiusBottom * alpha / capsBottomSegments;
        const cosA = Math.cos(a);
        const sinA = Math.sin(a);
        // calculate the radius of the current row
        const _radius = cosA * radiusBottom;
        for(x = 0; x <= radialSegments; x++){
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // vertex
            vertex.x = _radius * sinTheta;
            vertex.y = -halfHeight + sinA * radiusBottom;
            vertex.z = _radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normal.set(cosA * sinTheta, sinA, cosA * cosTheta);
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, (0, $fGXjI.useOpenGLOrientationForUV) ? v / vl : 1 - v / vl);
            // save index of vertex in respective row
            indexRow.push(index);
            // increase index
            index++;
        }
        // now save vertices of the row in our index array
        indexArray.push(indexRow);
    }
    // generate indices
    for(x = 0; x < radialSegments; x++)for(y = 0; y < capsTopSegments + heightSegments + capsBottomSegments; y++){
        // we use the index array to access the correct indices
        const i1 = indexArray[y][x];
        const i2 = indexArray[y + 1][x];
        const i3 = indexArray[y + 1][x + 1];
        const i4 = indexArray[y][x + 1];
        // face one
        indices.push(i1);
        indices.push(i2);
        indices.push(i4);
        // face two
        indices.push(i2);
        indices.push(i3);
        indices.push(i4);
    }
    indices = indices.reverse();
    if (options.orientation && !options.orientation.equals((0, $ha1VO.Vector3).Up())) {
        const m = new (0, $ha1VO.Matrix)();
        options.orientation.clone().scale(Math.PI * 0.5).cross((0, $ha1VO.Vector3).Up()).toQuaternion().toRotationMatrix(m);
        const v = (0, $ha1VO.Vector3).Zero();
        for(let i = 0; i < vertices.length; i += 3){
            v.set(vertices[i], vertices[i + 1], vertices[i + 2]);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(v.clone(), m, v);
            vertices[i] = v.x;
            vertices[i + 1] = v.y;
            vertices[i + 2] = v.z;
        }
    }
    const vDat = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vDat.positions = vertices;
    vDat.normals = normals;
    vDat.uvs = uvs;
    vDat.indices = indices;
    return vDat;
}
function $17c23aeaa7b72fc3$export$509367f6dcf345a3(name, options = {
    orientation: (0, $ha1VO.Vector3).Up(),
    subdivisions: 2,
    tessellation: 16,
    height: 1,
    radius: 0.25,
    capSubdivisions: 6,
    updatable: false
}, scene = null) {
    const capsule = new (0, $b0df7c384622c537$export$e176487c05830cc5)(name, scene);
    const vertexData = $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2(options);
    vertexData.applyToMesh(capsule, options.updatable);
    return capsule;
}
const $17c23aeaa7b72fc3$export$275401f3d9833758 = {
    CreateCapsule: // eslint-disable-next-line @typescript-eslint/naming-convention
    $17c23aeaa7b72fc3$export$509367f6dcf345a3
};
/**
 * Creates a capsule or a pill mesh
 * @param name defines the name of the mesh.
 * @param options the constructors options used to shape the mesh.
 * @param scene defines the scene the mesh is scoped to.
 * @returns the capsule mesh
 * @see https://doc.babylonjs.com/how_to/capsule_shape
 */ (0, $b0df7c384622c537$export$e176487c05830cc5).CreateCapsule = (name, options, scene)=>{
    return $17c23aeaa7b72fc3$export$509367f6dcf345a3(name, options, scene);
};
(0, $4014d881db0e9bc6$export$8570d39351855acb).CreateCapsule = $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2;




var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");

var $53VPf = parcelRequire("53VPf");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");
class $3ed5ab04dea8673e$export$6d3da39d626954f1 {
    /**
     * Creates a new isovector from the given x and y coordinates
     * @param x defines the first coordinate, must be an integer
     * @param y defines the second coordinate, must be an integer
     */ constructor(/** [0] defines the first coordinate */ x = 0, /** [0] defines the second coordinate */ y = 0){
        this.x = x;
        this.y = y;
        if (x !== Math.floor(x)) {
            x = Math.floor(x);
            (0, $kVtWi.Logger).Warn("x is not an integer, floor(x) used");
        }
        if (y !== Math.floor(y)) {
            y = Math.floor(y);
            (0, $kVtWi.Logger).Warn("y is not an integer, floor(y) used");
        }
    }
    // Operators
    /**
     * Gets a new IsoVector copied from the IsoVector
     * @returns a new IsoVector
     */ clone() {
        return new $3ed5ab04dea8673e$export$6d3da39d626954f1(this.x, this.y);
    }
    /**
     * Rotates one IsoVector 60 degrees counter clockwise about another
     * Please note that this is an in place operation
     * @param other an IsoVector a center of rotation
     * @returns the rotated IsoVector
     */ rotate60About(other) {
        //other IsoVector
        const x = this.x;
        this.x = other.x + other.y - this.y;
        this.y = x + this.y - other.x;
        return this;
    }
    /**
     * Rotates one IsoVector 60 degrees clockwise about another
     * Please note that this is an in place operation
     * @param other an IsoVector as center of rotation
     * @returns the rotated IsoVector
     */ rotateNeg60About(other) {
        const x = this.x;
        this.x = x + this.y - other.y;
        this.y = other.x + other.y - x;
        return this;
    }
    /**
     * For an equilateral triangle OAB with O at isovector (0, 0) and A at isovector (m, n)
     * Rotates one IsoVector 120 degrees counter clockwise about the center of the triangle
     * Please note that this is an in place operation
     * @param m integer a measure a Primary triangle of order (m, n) m > n
     * @param n >= 0 integer a measure for a Primary triangle of order (m, n)
     * @returns the rotated IsoVector
     */ rotate120(m, n) {
        //m, n integers
        if (m !== Math.floor(m)) {
            m = Math.floor(m);
            (0, $kVtWi.Logger).Warn("m not an integer only floor(m) used");
        }
        if (n !== Math.floor(n)) {
            n = Math.floor(n);
            (0, $kVtWi.Logger).Warn("n not an integer only floor(n) used");
        }
        const x = this.x;
        this.x = m - x - this.y;
        this.y = n + x;
        return this;
    }
    /**
     * For an equilateral triangle OAB with O at isovector (0, 0) and A at isovector (m, n)
     * Rotates one IsoVector 120 degrees clockwise about the center of the triangle
     * Please note that this is an in place operation
     * @param m integer a measure a Primary triangle of order (m, n) m > n
     * @param n >= 0 integer a measure for a Primary triangle of order (m, n)
     * @returns the rotated IsoVector
     */ rotateNeg120(m, n) {
        //m, n integers
        if (m !== Math.floor(m)) {
            m = Math.floor(m);
            (0, $kVtWi.Logger).Warn("m is not an integer, floor(m) used");
        }
        if (n !== Math.floor(n)) {
            n = Math.floor(n);
            (0, $kVtWi.Logger).Warn("n is not an integer,   floor(n) used");
        }
        const x = this.x;
        this.x = this.y - n;
        this.y = m + n - x - this.y;
        return this;
    }
    /**
     * Transforms an IsoVector to one in Cartesian 3D space based on an isovector
     * @param origin an IsoVector
     * @param isoGridSize
     * @returns Point as a Vector3
     */ toCartesianOrigin(origin, isoGridSize) {
        const point = (0, $ha1VO.Vector3).Zero();
        point.x = origin.x + 2 * this.x * isoGridSize + this.y * isoGridSize;
        point.y = origin.y + Math.sqrt(3) * this.y * isoGridSize;
        return point;
    }
    // Statics
    /**
     * Gets a new IsoVector(0, 0)
     * @returns a new IsoVector
     */ static Zero() {
        return new $3ed5ab04dea8673e$export$6d3da39d626954f1(0, 0);
    }
}


class $d65feca8fd77fc63$export$242532ea034459b {
    constructor(){
        this.cartesian = [];
        this.vertices = [];
        this.max = [];
        this.min = [];
        this.closestTo = [];
        this.innerFacets = [];
        this.isoVecsABOB = [];
        this.isoVecsOBOA = [];
        this.isoVecsBAOA = [];
        this.vertexTypes = [];
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.IDATA = new $d65feca8fd77fc63$export$5e1fb625f5ac029c("icosahedron", "Regular", [
            [
                0,
                (0, $53VPf.PHI),
                -1
            ],
            [
                -(0, $53VPf.PHI),
                1,
                0
            ],
            [
                -1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                (0, $53VPf.PHI),
                1,
                0
            ],
            [
                0,
                (0, $53VPf.PHI),
                1
            ],
            [
                -1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                -(0, $53VPf.PHI),
                -1,
                0
            ],
            [
                0,
                -(0, $53VPf.PHI),
                -1
            ],
            [
                (0, $53VPf.PHI),
                -1,
                0
            ],
            [
                1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                0,
                -(0, $53VPf.PHI),
                1
            ]
        ], [
            [
                0,
                2,
                1
            ],
            [
                0,
                3,
                2
            ],
            [
                0,
                4,
                3
            ],
            [
                0,
                5,
                4
            ],
            [
                0,
                1,
                5
            ],
            [
                7,
                6,
                1
            ],
            [
                8,
                7,
                2
            ],
            [
                9,
                8,
                3
            ],
            [
                10,
                9,
                4
            ],
            [
                6,
                10,
                5
            ],
            [
                2,
                7,
                1
            ],
            [
                3,
                8,
                2
            ],
            [
                4,
                9,
                3
            ],
            [
                5,
                10,
                4
            ],
            [
                1,
                6,
                5
            ],
            [
                11,
                6,
                7
            ],
            [
                11,
                7,
                8
            ],
            [
                11,
                8,
                9
            ],
            [
                11,
                9,
                10
            ],
            [
                11,
                10,
                6
            ]
        ]);
    }
    /**
     * Creates the PrimaryIsoTriangle Triangle OAB
     * @param m an integer
     * @param n an integer
     */ //operators
    setIndices() {
        let indexCount = 12; // 12 vertices already assigned
        const vecToidx = {}; //maps iso-vectors to indexCount;
        const m = this.m;
        const n = this.n;
        let g = m; // hcf of m, n when n != 0
        let m1 = 1;
        let n1 = 0;
        if (n !== 0) g = (0, $iosaP.HighestCommonFactor)(m, n);
        m1 = m / g;
        n1 = n / g;
        let fr; //face to the right of current face
        let rot; //rotation about which vertex for fr
        let O;
        let A;
        let B;
        const oVec = (0, $3ed5ab04dea8673e$export$6d3da39d626954f1).Zero();
        const aVec = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(m, n);
        const bVec = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(-n, m + n);
        const oaVec = (0, $3ed5ab04dea8673e$export$6d3da39d626954f1).Zero();
        const abVec = (0, $3ed5ab04dea8673e$export$6d3da39d626954f1).Zero();
        const obVec = (0, $3ed5ab04dea8673e$export$6d3da39d626954f1).Zero();
        let verts = [];
        let idx;
        let idxR;
        let isoId;
        let isoIdR;
        const closestTo = [];
        const vDist = this.vertByDist;
        const matchIdx = (f, fr, isoId, isoIdR)=>{
            idx = f + "|" + isoId;
            idxR = fr + "|" + isoIdR;
            if (!(idx in vecToidx || idxR in vecToidx)) {
                vecToidx[idx] = indexCount;
                vecToidx[idxR] = indexCount;
                indexCount++;
            } else if (idx in vecToidx && !(idxR in vecToidx)) vecToidx[idxR] = vecToidx[idx];
            else if (idxR in vecToidx && !(idx in vecToidx)) vecToidx[idx] = vecToidx[idxR];
            if (vDist[isoId][0] > 2) closestTo[vecToidx[idx]] = [
                -vDist[isoId][0],
                vDist[isoId][1],
                vecToidx[idx]
            ];
            else closestTo[vecToidx[idx]] = [
                verts[vDist[isoId][0]],
                vDist[isoId][1],
                vecToidx[idx]
            ];
        };
        this.IDATA.edgematch = [
            [
                1,
                "B"
            ],
            [
                2,
                "B"
            ],
            [
                3,
                "B"
            ],
            [
                4,
                "B"
            ],
            [
                0,
                "B"
            ],
            [
                10,
                "O",
                14,
                "A"
            ],
            [
                11,
                "O",
                10,
                "A"
            ],
            [
                12,
                "O",
                11,
                "A"
            ],
            [
                13,
                "O",
                12,
                "A"
            ],
            [
                14,
                "O",
                13,
                "A"
            ],
            [
                0,
                "O"
            ],
            [
                1,
                "O"
            ],
            [
                2,
                "O"
            ],
            [
                3,
                "O"
            ],
            [
                4,
                "O"
            ],
            [
                19,
                "B",
                5,
                "A"
            ],
            [
                15,
                "B",
                6,
                "A"
            ],
            [
                16,
                "B",
                7,
                "A"
            ],
            [
                17,
                "B",
                8,
                "A"
            ],
            [
                18,
                "B",
                9,
                "A"
            ]
        ];
        /***edges AB to OB***** rotation about B*/ for(let f = 0; f < 20; f++){
            //f current face
            verts = this.IDATA.face[f];
            O = verts[2];
            A = verts[1];
            B = verts[0];
            isoId = oVec.x + "|" + oVec.y;
            idx = f + "|" + isoId;
            if (!(idx in vecToidx)) {
                vecToidx[idx] = O;
                closestTo[O] = [
                    verts[vDist[isoId][0]],
                    vDist[isoId][1]
                ];
            }
            isoId = aVec.x + "|" + aVec.y;
            idx = f + "|" + isoId;
            if (!(idx in vecToidx)) {
                vecToidx[idx] = A;
                closestTo[A] = [
                    verts[vDist[isoId][0]],
                    vDist[isoId][1]
                ];
            }
            isoId = bVec.x + "|" + bVec.y;
            idx = f + "|" + isoId;
            if (!(idx in vecToidx)) {
                vecToidx[idx] = B;
                closestTo[B] = [
                    verts[vDist[isoId][0]],
                    vDist[isoId][1]
                ];
            }
            //for edge vertices
            fr = this.IDATA.edgematch[f][0];
            rot = this.IDATA.edgematch[f][1];
            if (rot === "B") for(let i = 1; i < g; i++){
                abVec.x = m - i * (m1 + n1);
                abVec.y = n + i * m1;
                obVec.x = -i * n1;
                obVec.y = i * (m1 + n1);
                isoId = abVec.x + "|" + abVec.y;
                isoIdR = obVec.x + "|" + obVec.y;
                matchIdx(f, fr, isoId, isoIdR);
            }
            if (rot === "O") for(let i = 1; i < g; i++){
                obVec.x = -i * n1;
                obVec.y = i * (m1 + n1);
                oaVec.x = i * m1;
                oaVec.y = i * n1;
                isoId = obVec.x + "|" + obVec.y;
                isoIdR = oaVec.x + "|" + oaVec.y;
                matchIdx(f, fr, isoId, isoIdR);
            }
            fr = this.IDATA.edgematch[f][2];
            rot = this.IDATA.edgematch[f][3];
            if (rot && rot === "A") for(let i = 1; i < g; i++){
                oaVec.x = i * m1;
                oaVec.y = i * n1;
                abVec.x = m - (g - i) * (m1 + n1); //reversed for BA
                abVec.y = n + (g - i) * m1; //reversed for BA
                isoId = oaVec.x + "|" + oaVec.y;
                isoIdR = abVec.x + "|" + abVec.y;
                matchIdx(f, fr, isoId, isoIdR);
            }
            for(let i = 0; i < this.vertices.length; i++){
                isoId = this.vertices[i].x + "|" + this.vertices[i].y;
                idx = f + "|" + isoId;
                if (!(idx in vecToidx)) {
                    vecToidx[idx] = indexCount++;
                    if (vDist[isoId][0] > 2) closestTo[vecToidx[idx]] = [
                        -vDist[isoId][0],
                        vDist[isoId][1],
                        vecToidx[idx]
                    ];
                    else closestTo[vecToidx[idx]] = [
                        verts[vDist[isoId][0]],
                        vDist[isoId][1],
                        vecToidx[idx]
                    ];
                }
            }
        }
        this.closestTo = closestTo;
        this.vecToidx = vecToidx;
    }
    calcCoeffs() {
        const m = this.m;
        const n = this.n;
        const thirdR3 = Math.sqrt(3) / 3;
        const LSQD = m * m + n * n + m * n;
        this.coau = (m + n) / LSQD;
        this.cobu = -n / LSQD;
        this.coav = -thirdR3 * (m - n) / LSQD;
        this.cobv = thirdR3 * (2 * m + n) / LSQD;
    }
    createInnerFacets() {
        const m = this.m;
        const n = this.n;
        for(let y = 0; y < n + m + 1; y++)for(let x = this.min[y]; x < this.max[y] + 1; x++){
            if (x < this.max[y] && x < this.max[y + 1] + 1) this.innerFacets.push([
                "|" + x + "|" + y,
                "|" + x + "|" + (y + 1),
                "|" + (x + 1) + "|" + y
            ]);
            if (y > 0 && x < this.max[y - 1] && x + 1 < this.max[y] + 1) this.innerFacets.push([
                "|" + x + "|" + y,
                "|" + (x + 1) + "|" + y,
                "|" + (x + 1) + "|" + (y - 1)
            ]);
        }
    }
    edgeVecsABOB() {
        const m = this.m;
        const n = this.n;
        const B = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(-n, m + n);
        for(let y = 1; y < m + n; y++){
            const point = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(this.min[y], y);
            const prev = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(this.min[y - 1], y - 1);
            const next = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(this.min[y + 1], y + 1);
            const pointR = point.clone();
            const prevR = prev.clone();
            const nextR = next.clone();
            pointR.rotate60About(B);
            prevR.rotate60About(B);
            nextR.rotate60About(B);
            const maxPoint = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(this.max[pointR.y], pointR.y);
            const maxPrev = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(this.max[pointR.y - 1], pointR.y - 1);
            const maxLeftPrev = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(this.max[pointR.y - 1] - 1, pointR.y - 1);
            if (pointR.x !== maxPoint.x || pointR.y !== maxPoint.y) {
                if (pointR.x !== maxPrev.x) {
                    // type2
                    //up
                    this.vertexTypes.push([
                        1,
                        0,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxPrev,
                        maxLeftPrev
                    ]);
                    //down
                    this.vertexTypes.push([
                        1,
                        0,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxLeftPrev,
                        maxPoint
                    ]);
                } else if (pointR.y === nextR.y) {
                    // type1
                    //up
                    this.vertexTypes.push([
                        1,
                        1,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        prev,
                        maxPrev
                    ]);
                    //down
                    this.vertexTypes.push([
                        1,
                        0,
                        1
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxPrev,
                        next
                    ]);
                } else {
                    // type 0
                    //up
                    this.vertexTypes.push([
                        1,
                        1,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        prev,
                        maxPrev
                    ]);
                    //down
                    this.vertexTypes.push([
                        1,
                        0,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxPrev,
                        maxPoint
                    ]);
                }
            }
        }
    }
    mapABOBtoOBOA() {
        const point = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(0, 0);
        for(let i = 0; i < this.isoVecsABOB.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++){
                point.x = this.isoVecsABOB[i][j].x;
                point.y = this.isoVecsABOB[i][j].y;
                if (this.vertexTypes[i][j] === 0) point.rotateNeg120(this.m, this.n);
                temp.push(point.clone());
            }
            this.isoVecsOBOA.push(temp);
        }
    }
    mapABOBtoBAOA() {
        const point = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(0, 0);
        for(let i = 0; i < this.isoVecsABOB.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++){
                point.x = this.isoVecsABOB[i][j].x;
                point.y = this.isoVecsABOB[i][j].y;
                if (this.vertexTypes[i][j] === 1) point.rotate120(this.m, this.n);
                temp.push(point.clone());
            }
            this.isoVecsBAOA.push(temp);
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MapToFace(faceNb, geodesicData) {
        const F = this.IDATA.face[faceNb];
        const oidx = F[2];
        const aidx = F[1];
        const bidx = F[0];
        const O = (0, $ha1VO.Vector3).FromArray(this.IDATA.vertex[oidx]);
        const A = (0, $ha1VO.Vector3).FromArray(this.IDATA.vertex[aidx]);
        const B = (0, $ha1VO.Vector3).FromArray(this.IDATA.vertex[bidx]);
        const OA = A.subtract(O);
        const OB = B.subtract(O);
        const x = OA.scale(this.coau).add(OB.scale(this.cobu));
        const y = OA.scale(this.coav).add(OB.scale(this.cobv));
        const mapped = [];
        let idx;
        let tempVec = (0, $ha1VO.TmpVectors).Vector3[0];
        for(let i = 0; i < this.cartesian.length; i++){
            tempVec = x.scale(this.cartesian[i].x).add(y.scale(this.cartesian[i].y)).add(O);
            mapped[i] = [
                tempVec.x,
                tempVec.y,
                tempVec.z
            ];
            idx = faceNb + "|" + this.vertices[i].x + "|" + this.vertices[i].y;
            geodesicData.vertex[this.vecToidx[idx]] = [
                tempVec.x,
                tempVec.y,
                tempVec.z
            ];
        }
    }
    //statics
    /**Creates a primary triangle
     * @internal
     */ build(m, n) {
        const vertices = [];
        const O = (0, $3ed5ab04dea8673e$export$6d3da39d626954f1).Zero();
        const A = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(m, n);
        const B = new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(-n, m + n);
        vertices.push(O, A, B);
        //max internal isoceles triangle vertices
        for(let y = n; y < m + 1; y++)for(let x = 0; x < m + 1 - y; x++)vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(x, y));
        //shared vertices along edges when needed
        if (n > 0) {
            const g = (0, $iosaP.HighestCommonFactor)(m, n);
            const m1 = m / g;
            const n1 = n / g;
            for(let i = 1; i < g; i++){
                vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(i * m1, i * n1)); //OA
                vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(-i * n1, i * (m1 + n1))); //OB
                vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(m - i * (m1 + n1), n + i * m1)); // AB
            }
            //lower rows vertices and their rotations
            const ratio = m / n;
            for(let y = 1; y < n; y++)for(let x = 0; x < y * ratio; x++){
                vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(x, y));
                vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(x, y).rotate120(m, n));
                vertices.push(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(x, y).rotateNeg120(m, n));
            }
        }
        //order vertices by x and then y
        vertices.sort((a, b)=>{
            return a.x - b.x;
        });
        vertices.sort((a, b)=>{
            return a.y - b.y;
        });
        const min = new Array(m + n + 1);
        const max = new Array(m + n + 1);
        for(let i = 0; i < min.length; i++){
            min[i] = Infinity;
            max[i] = -Infinity;
        }
        let y = 0;
        let x = 0;
        const len = vertices.length;
        for(let i = 0; i < len; i++){
            x = vertices[i].x;
            y = vertices[i].y;
            min[y] = Math.min(x, min[y]);
            max[y] = Math.max(x, max[y]);
        }
        //calculates the distance of a vertex from a given primary vertex
        const distFrom = (vert, primVert)=>{
            const v = vert.clone();
            if (primVert === "A") v.rotateNeg120(m, n);
            if (primVert === "B") v.rotate120(m, n);
            if (v.x < 0) return v.y;
            return v.x + v.y;
        };
        const cartesian = [];
        const distFromO = [];
        const distFromA = [];
        const distFromB = [];
        const vertByDist = {};
        const vertData = [];
        let closest = -1;
        let dist = -1;
        for(let i = 0; i < len; i++){
            cartesian[i] = vertices[i].toCartesianOrigin(new (0, $3ed5ab04dea8673e$export$6d3da39d626954f1)(0, 0), 0.5);
            distFromO[i] = distFrom(vertices[i], "O");
            distFromA[i] = distFrom(vertices[i], "A");
            distFromB[i] = distFrom(vertices[i], "B");
            if (distFromO[i] === distFromA[i] && distFromA[i] === distFromB[i]) {
                closest = 3;
                dist = distFromO[i];
            } else if (distFromO[i] === distFromA[i]) {
                closest = 4;
                dist = distFromO[i];
            } else if (distFromA[i] === distFromB[i]) {
                closest = 5;
                dist = distFromA[i];
            } else if (distFromB[i] === distFromO[i]) {
                closest = 6;
                dist = distFromO[i];
            }
            if (distFromO[i] < distFromA[i] && distFromO[i] < distFromB[i]) {
                closest = 2;
                dist = distFromO[i];
            }
            if (distFromA[i] < distFromO[i] && distFromA[i] < distFromB[i]) {
                closest = 1;
                dist = distFromA[i];
            }
            if (distFromB[i] < distFromA[i] && distFromB[i] < distFromO[i]) {
                closest = 0;
                dist = distFromB[i];
            }
            vertData.push([
                closest,
                dist,
                vertices[i].x,
                vertices[i].y
            ]);
        }
        vertData.sort((a, b)=>{
            return a[2] - b[2];
        });
        vertData.sort((a, b)=>{
            return a[3] - b[3];
        });
        vertData.sort((a, b)=>{
            return a[1] - b[1];
        });
        vertData.sort((a, b)=>{
            return a[0] - b[0];
        });
        for(let v = 0; v < vertData.length; v++)vertByDist[vertData[v][2] + "|" + vertData[v][3]] = [
            vertData[v][0],
            vertData[v][1],
            v
        ];
        this.m = m;
        this.n = n;
        this.vertices = vertices;
        this.vertByDist = vertByDist;
        this.cartesian = cartesian;
        this.min = min;
        this.max = max;
        return this;
    }
}
class $d65feca8fd77fc63$export$5e1fb625f5ac029c {
    constructor(/**
     * The name of the polyhedron
     */ name, /**
     * The category of the polyhedron
     */ category, /**
     * vertex data
     */ vertex, /**
     * face data
     */ face){
        this.name = name;
        this.category = category;
        this.vertex = vertex;
        this.face = face;
    }
}
class $d65feca8fd77fc63$export$f97f132d55c4fea9 extends $d65feca8fd77fc63$export$5e1fb625f5ac029c {
    /**
     * @internal
     */ innerToData(face, primTri) {
        for(let i = 0; i < primTri.innerFacets.length; i++)this.face.push(primTri.innerFacets[i].map((el)=>primTri.vecToidx[face + el]));
    }
    /**
     * @internal
     */ mapABOBtoDATA(faceNb, primTri) {
        const fr = primTri.IDATA.edgematch[faceNb][0];
        for(let i = 0; i < primTri.isoVecsABOB.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++)if (primTri.vertexTypes[i][j] === 0) temp.push(faceNb + "|" + primTri.isoVecsABOB[i][j].x + "|" + primTri.isoVecsABOB[i][j].y);
            else temp.push(fr + "|" + primTri.isoVecsABOB[i][j].x + "|" + primTri.isoVecsABOB[i][j].y);
            this.face.push([
                primTri.vecToidx[temp[0]],
                primTri.vecToidx[temp[1]],
                primTri.vecToidx[temp[2]]
            ]);
        }
    }
    /**
     * @internal
     */ mapOBOAtoDATA(faceNb, primTri) {
        const fr = primTri.IDATA.edgematch[faceNb][0];
        for(let i = 0; i < primTri.isoVecsOBOA.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++)if (primTri.vertexTypes[i][j] === 1) temp.push(faceNb + "|" + primTri.isoVecsOBOA[i][j].x + "|" + primTri.isoVecsOBOA[i][j].y);
            else temp.push(fr + "|" + primTri.isoVecsOBOA[i][j].x + "|" + primTri.isoVecsOBOA[i][j].y);
            this.face.push([
                primTri.vecToidx[temp[0]],
                primTri.vecToidx[temp[1]],
                primTri.vecToidx[temp[2]]
            ]);
        }
    }
    /**
     * @internal
     */ mapBAOAtoDATA(faceNb, primTri) {
        const fr = primTri.IDATA.edgematch[faceNb][2];
        for(let i = 0; i < primTri.isoVecsBAOA.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++)if (primTri.vertexTypes[i][j] === 1) temp.push(faceNb + "|" + primTri.isoVecsBAOA[i][j].x + "|" + primTri.isoVecsBAOA[i][j].y);
            else temp.push(fr + "|" + primTri.isoVecsBAOA[i][j].x + "|" + primTri.isoVecsBAOA[i][j].y);
            this.face.push([
                primTri.vecToidx[temp[0]],
                primTri.vecToidx[temp[1]],
                primTri.vecToidx[temp[2]]
            ]);
        }
    }
    /**
     * @internal
     */ orderData(primTri) {
        const nearTo = [];
        for(let i = 0; i < 13; i++)nearTo[i] = [];
        const close = primTri.closestTo;
        for(let i = 0; i < close.length; i++){
            if (close[i][0] > -1) {
                if (close[i][1] > 0) nearTo[close[i][0]].push([
                    i,
                    close[i][1]
                ]);
            } else nearTo[12].push([
                i,
                close[i][0]
            ]);
        }
        const near = [];
        for(let i = 0; i < 12; i++)near[i] = i;
        let nearIndex = 12;
        for(let i = 0; i < 12; i++){
            nearTo[i].sort((a, b)=>{
                return a[1] - b[1];
            });
            for(let j = 0; j < nearTo[i].length; j++)near[nearTo[i][j][0]] = nearIndex++;
        }
        for(let j = 0; j < nearTo[12].length; j++)near[nearTo[12][j][0]] = nearIndex++;
        for(let i = 0; i < this.vertex.length; i++)this.vertex[i].push(near[i]);
        this.vertex.sort((a, b)=>{
            return a[3] - b[3];
        });
        for(let i = 0; i < this.vertex.length; i++)this.vertex[i].pop();
        for(let i = 0; i < this.face.length; i++)for(let j = 0; j < this.face[i].length; j++)this.face[i][j] = near[this.face[i][j]];
        this.sharedNodes = nearTo[12].length;
        this.poleNodes = this.vertex.length - this.sharedNodes;
    }
    /**
     * @internal
     */ setOrder(m, faces) {
        const adjVerts = [];
        const dualFaces = [];
        let face = faces.pop();
        dualFaces.push(face);
        let index = this.face[face].indexOf(m);
        index = (index + 2) % 3;
        let v = this.face[face][index];
        adjVerts.push(v);
        let f = 0;
        while(faces.length > 0){
            face = faces[f];
            if (this.face[face].indexOf(v) > -1) {
                // v is a vertex of face f
                index = (this.face[face].indexOf(v) + 1) % 3;
                v = this.face[face][index];
                adjVerts.push(v);
                dualFaces.push(face);
                faces.splice(f, 1);
                f = 0;
            } else f++;
        }
        this.adjacentFaces.push(adjVerts);
        return dualFaces;
    }
    /**
     * @internal
     */ toGoldbergPolyhedronData() {
        const goldbergPolyhedronData = new $d65feca8fd77fc63$export$5e1fb625f5ac029c("GeoDual", "Goldberg", [], []);
        goldbergPolyhedronData.name = "GD dual";
        const verticesNb = this.vertex.length;
        const map = new Array(verticesNb);
        for(let v = 0; v < verticesNb; v++)map[v] = [];
        for(let f = 0; f < this.face.length; f++)for(let i = 0; i < 3; i++)map[this.face[f][i]].push(f);
        let cx = 0;
        let cy = 0;
        let cz = 0;
        let face = [];
        let vertex = [];
        this.adjacentFaces = [];
        for(let m = 0; m < map.length; m++){
            goldbergPolyhedronData.face[m] = this.setOrder(m, map[m].concat([]));
            map[m].forEach((el)=>{
                cx = 0;
                cy = 0;
                cz = 0;
                face = this.face[el];
                for(let i = 0; i < 3; i++){
                    vertex = this.vertex[face[i]];
                    cx += vertex[0];
                    cy += vertex[1];
                    cz += vertex[2];
                }
                goldbergPolyhedronData.vertex[el] = [
                    cx / 3,
                    cy / 3,
                    cz / 3
                ];
            });
        }
        return goldbergPolyhedronData;
    }
    //statics
    /**Builds the data for a Geodesic Polyhedron from a primary triangle
     * @param primTri the primary triangle
     * @internal
     */ static BuildGeodesicData(primTri) {
        const geodesicData = new $d65feca8fd77fc63$export$f97f132d55c4fea9("Geodesic-m-n", "Geodesic", [
            [
                0,
                (0, $53VPf.PHI),
                -1
            ],
            [
                -(0, $53VPf.PHI),
                1,
                0
            ],
            [
                -1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                (0, $53VPf.PHI),
                1,
                0
            ],
            [
                0,
                (0, $53VPf.PHI),
                1
            ],
            [
                -1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                -(0, $53VPf.PHI),
                -1,
                0
            ],
            [
                0,
                -(0, $53VPf.PHI),
                -1
            ],
            [
                (0, $53VPf.PHI),
                -1,
                0
            ],
            [
                1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                0,
                -(0, $53VPf.PHI),
                1
            ]
        ], []);
        primTri.setIndices();
        primTri.calcCoeffs();
        primTri.createInnerFacets();
        primTri.edgeVecsABOB();
        primTri.mapABOBtoOBOA();
        primTri.mapABOBtoBAOA();
        for(let f = 0; f < primTri.IDATA.face.length; f++){
            primTri.MapToFace(f, geodesicData);
            geodesicData.innerToData(f, primTri);
            if (primTri.IDATA.edgematch[f][1] === "B") geodesicData.mapABOBtoDATA(f, primTri);
            if (primTri.IDATA.edgematch[f][1] === "O") geodesicData.mapOBOAtoDATA(f, primTri);
            if (primTri.IDATA.edgematch[f][3] === "A") geodesicData.mapBAOAtoDATA(f, primTri);
        }
        geodesicData.orderData(primTri);
        const radius = 1;
        geodesicData.vertex = geodesicData.vertex.map(function(el) {
            const a = el[0];
            const b = el[1];
            const c = el[2];
            const d = Math.sqrt(a * a + b * b + c * c);
            el[0] *= radius / d;
            el[1] *= radius / d;
            el[2] *= radius / d;
            return el;
        });
        return geodesicData;
    }
}


function $f484da790f7b4a54$export$616f62b64ab14d82(name, options, scene = null) {
    let m = options.m || 1;
    if (m !== Math.floor(m)) {
        m = Math.floor(m);
        (0, $kVtWi.Logger).Warn("m not an integer only floor(m) used");
    }
    let n = options.n || 0;
    if (n !== Math.floor(n)) {
        n = Math.floor(n);
        (0, $kVtWi.Logger).Warn("n not an integer only floor(n) used");
    }
    if (n > m) {
        const temp = n;
        n = m;
        m = temp;
        (0, $kVtWi.Logger).Warn("n > m therefore m and n swapped");
    }
    const primTri = new (0, $d65feca8fd77fc63$export$242532ea034459b)();
    primTri.build(m, n);
    const geodesicData = (0, $d65feca8fd77fc63$export$f97f132d55c4fea9).BuildGeodesicData(primTri);
    const geoOptions = {
        custom: geodesicData,
        size: options.size,
        sizeX: options.sizeX,
        sizeY: options.sizeY,
        sizeZ: options.sizeZ,
        faceUV: options.faceUV,
        faceColors: options.faceColors,
        flat: options.flat,
        updatable: options.updatable,
        sideOrientation: options.sideOrientation,
        frontUVs: options.frontUVs,
        backUVs: options.backUVs
    };
    const geodesic = (0, $1d49167c5ec927a7$export$1cb5c9516e55bfc7)(name, geoOptions, scene);
    return geodesic;
}



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");



var $kVtWi = parcelRequire("kVtWi");


var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");


var $7etnY = parcelRequire("7etnY");

var $kVtWi = parcelRequire("kVtWi");
(0, $b0df7c384622c537$export$e176487c05830cc5)._GoldbergMeshParser = (parsedMesh, scene)=>{
    return $8bcde881235d9b6b$export$33c9f07b719e61e4.Parse(parsedMesh, scene);
};
class $8bcde881235d9b6b$export$33c9f07b719e61e4 extends (0, $b0df7c384622c537$export$e176487c05830cc5) {
    constructor(){
        super(...arguments);
        /**
         * Defines the specific Goldberg data used in this mesh construction.
         */ this.goldbergData = {
            faceColors: [],
            faceCenters: [],
            faceZaxis: [],
            faceXaxis: [],
            faceYaxis: [],
            nbSharedFaces: 0,
            nbUnsharedFaces: 0,
            nbFaces: 0,
            nbFacesAtPole: 0,
            adjacentFaces: []
        };
    }
    /**
     * Gets the related Goldberg face from pole infos
     * @param poleOrShared Defines the pole index or the shared face index if the fromPole parameter is passed in
     * @param fromPole Defines an optional pole index to find the related info from
     * @returns the goldberg face number
     */ relatedGoldbergFace(poleOrShared, fromPole) {
        if (fromPole === void 0) {
            if (poleOrShared > this.goldbergData.nbUnsharedFaces - 1) {
                (0, $kVtWi.Logger).Warn("Maximum number of unshared faces used");
                poleOrShared = this.goldbergData.nbUnsharedFaces - 1;
            }
            return this.goldbergData.nbUnsharedFaces + poleOrShared;
        }
        if (poleOrShared > 11) {
            (0, $kVtWi.Logger).Warn("Last pole used");
            poleOrShared = 11;
        }
        if (fromPole > this.goldbergData.nbFacesAtPole - 1) {
            (0, $kVtWi.Logger).Warn("Maximum number of faces at a pole used");
            fromPole = this.goldbergData.nbFacesAtPole - 1;
        }
        return 12 + poleOrShared * this.goldbergData.nbFacesAtPole + fromPole;
    }
    _changeGoldbergFaceColors(colorRange) {
        for(let i = 0; i < colorRange.length; i++){
            const min = colorRange[i][0];
            const max = colorRange[i][1];
            const col = colorRange[i][2];
            for(let f = min; f < max + 1; f++)this.goldbergData.faceColors[f] = col;
        }
        const newCols = [];
        for(let f = 0; f < 12; f++)for(let i = 0; i < 5; i++)newCols.push(this.goldbergData.faceColors[f].r, this.goldbergData.faceColors[f].g, this.goldbergData.faceColors[f].b, this.goldbergData.faceColors[f].a);
        for(let f = 12; f < this.goldbergData.faceColors.length; f++)for(let i = 0; i < 6; i++)newCols.push(this.goldbergData.faceColors[f].r, this.goldbergData.faceColors[f].g, this.goldbergData.faceColors[f].b, this.goldbergData.faceColors[f].a);
        return newCols;
    }
    /**
     * Set new goldberg face colors
     * @param colorRange the new color to apply to the mesh
     */ setGoldbergFaceColors(colorRange) {
        const newCols = this._changeGoldbergFaceColors(colorRange);
        this.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, newCols);
    }
    /**
     * Updates new goldberg face colors
     * @param colorRange the new color to apply to the mesh
     */ updateGoldbergFaceColors(colorRange) {
        const newCols = this._changeGoldbergFaceColors(colorRange);
        this.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, newCols);
    }
    _changeGoldbergFaceUVs(uvRange) {
        const uvs = this.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        for(let i = 0; i < uvRange.length; i++){
            const min = uvRange[i][0];
            const max = uvRange[i][1];
            const center = uvRange[i][2];
            const radius = uvRange[i][3];
            const angle = uvRange[i][4];
            const points5 = [];
            const points6 = [];
            let u;
            let v;
            for(let p = 0; p < 5; p++){
                u = center.x + radius * Math.cos(angle + p * Math.PI / 2.5);
                v = center.y + radius * Math.sin(angle + p * Math.PI / 2.5);
                if (u < 0) u = 0;
                if (u > 1) u = 1;
                points5.push(u, v);
            }
            for(let p = 0; p < 6; p++){
                u = center.x + radius * Math.cos(angle + p * Math.PI / 3);
                v = center.y + radius * Math.sin(angle + p * Math.PI / 3);
                if (u < 0) u = 0;
                if (u > 1) u = 1;
                points6.push(u, v);
            }
            for(let f = min; f < Math.min(12, max + 1); f++)for(let p = 0; p < 5; p++){
                uvs[10 * f + 2 * p] = points5[2 * p];
                uvs[10 * f + 2 * p + 1] = points5[2 * p + 1];
            }
            for(let f = Math.max(12, min); f < max + 1; f++)for(let p = 0; p < 6; p++){
                //120 + 12 * (f - 12) = 12 * f - 24
                uvs[12 * f - 24 + 2 * p] = points6[2 * p];
                uvs[12 * f - 23 + 2 * p] = points6[2 * p + 1];
            }
        }
        return uvs;
    }
    /**
     * set new goldberg face UVs
     * @param uvRange the new UVs to apply to the mesh
     */ setGoldbergFaceUVs(uvRange) {
        const newUVs = this._changeGoldbergFaceUVs(uvRange);
        this.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, newUVs);
    }
    /**
     * Updates new goldberg face UVs
     * @param uvRange the new UVs to apply to the mesh
     */ updateGoldbergFaceUVs(uvRange) {
        const newUVs = this._changeGoldbergFaceUVs(uvRange);
        this.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, newUVs);
    }
    /**
     * Places a mesh on a particular face of the goldberg polygon
     * @param mesh Defines the mesh to position
     * @param face Defines the face to position onto
     * @param position Defines the position relative to the face we are positioning the mesh onto
     */ placeOnGoldbergFaceAt(mesh, face, position) {
        const orientation = (0, $ha1VO.Vector3).RotationFromAxis(this.goldbergData.faceXaxis[face], this.goldbergData.faceYaxis[face], this.goldbergData.faceZaxis[face]);
        mesh.rotation = orientation;
        mesh.position = this.goldbergData.faceCenters[face].add(this.goldbergData.faceXaxis[face].scale(position.x)).add(this.goldbergData.faceYaxis[face].scale(position.y)).add(this.goldbergData.faceZaxis[face].scale(position.z));
    }
    /**
     * Serialize current mesh
     * @param serializationObject defines the object which will receive the serialization data
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.type = "GoldbergMesh";
        const goldbergData = {};
        goldbergData.adjacentFaces = this.goldbergData.adjacentFaces;
        goldbergData.nbSharedFaces = this.goldbergData.nbSharedFaces;
        goldbergData.nbUnsharedFaces = this.goldbergData.nbUnsharedFaces;
        goldbergData.nbFaces = this.goldbergData.nbFaces;
        goldbergData.nbFacesAtPole = this.goldbergData.nbFacesAtPole;
        if (this.goldbergData.faceColors) {
            goldbergData.faceColors = [];
            for (const color of this.goldbergData.faceColors)goldbergData.faceColors.push(color.asArray());
        }
        if (this.goldbergData.faceCenters) {
            goldbergData.faceCenters = [];
            for (const vector of this.goldbergData.faceCenters)goldbergData.faceCenters.push(vector.asArray());
        }
        if (this.goldbergData.faceZaxis) {
            goldbergData.faceZaxis = [];
            for (const vector of this.goldbergData.faceZaxis)goldbergData.faceZaxis.push(vector.asArray());
        }
        if (this.goldbergData.faceYaxis) {
            goldbergData.faceYaxis = [];
            for (const vector of this.goldbergData.faceYaxis)goldbergData.faceYaxis.push(vector.asArray());
        }
        if (this.goldbergData.faceXaxis) {
            goldbergData.faceXaxis = [];
            for (const vector of this.goldbergData.faceXaxis)goldbergData.faceXaxis.push(vector.asArray());
        }
        serializationObject.goldbergData = goldbergData;
    }
    /**
     * Parses a serialized goldberg mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the goldberg mesh in
     * @returns the created goldberg mesh
     */ static Parse(parsedMesh, scene) {
        const goldbergData = parsedMesh.goldbergData;
        goldbergData.faceColors = goldbergData.faceColors.map((el)=>(0, $7etnY.Color4).FromArray(el));
        goldbergData.faceCenters = goldbergData.faceCenters.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        goldbergData.faceZaxis = goldbergData.faceZaxis.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        goldbergData.faceXaxis = goldbergData.faceXaxis.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        goldbergData.faceYaxis = goldbergData.faceYaxis.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        const goldberg = new $8bcde881235d9b6b$export$33c9f07b719e61e4(parsedMesh.name, scene);
        goldberg.goldbergData = goldbergData;
        return goldberg;
    }
}



var $fGXjI = parcelRequire("fGXjI");
function $41dcdb4627c57f34$export$e4bb3982c9d1679d(options, goldbergData) {
    const size = options.size;
    const sizeX = options.sizeX || size || 1;
    const sizeY = options.sizeY || size || 1;
    const sizeZ = options.sizeZ || size || 1;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $4014d881db0e9bc6$export$8570d39351855acb).DEFAULTSIDE;
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for(let v = 0; v < goldbergData.vertex.length; v++){
        minX = Math.min(minX, goldbergData.vertex[v][0] * sizeX);
        maxX = Math.max(maxX, goldbergData.vertex[v][0] * sizeX);
        minY = Math.min(minY, goldbergData.vertex[v][1] * sizeY);
        maxY = Math.max(maxY, goldbergData.vertex[v][1] * sizeY);
    }
    let index = 0;
    for(let f = 0; f < goldbergData.face.length; f++){
        const verts = goldbergData.face[f];
        const a = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[0]]);
        const b = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[2]]);
        const c = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[1]]);
        const ba = b.subtract(a);
        const ca = c.subtract(a);
        const norm = (0, $ha1VO.Vector3).Cross(ca, ba).normalize();
        for(let v = 0; v < verts.length; v++){
            normals.push(norm.x, norm.y, norm.z);
            const pdata = goldbergData.vertex[verts[v]];
            positions.push(pdata[0] * sizeX, pdata[1] * sizeY, pdata[2] * sizeZ);
            const vCoord = (pdata[1] * sizeY - minY) / (maxY - minY);
            uvs.push((pdata[0] * sizeX - minX) / (maxX - minX), (0, $fGXjI.useOpenGLOrientationForUV) ? 1 - vCoord : vCoord);
        }
        for(let v = 0; v < verts.length - 2; v++)indices.push(index, index + v + 2, index + v + 1);
        index += verts.length;
    }
    (0, $4014d881db0e9bc6$export$8570d39351855acb)._ComputeSides(sideOrientation, positions, indices, normals, uvs);
    const vertexData = new (0, $4014d881db0e9bc6$export$8570d39351855acb)();
    vertexData.positions = positions;
    vertexData.indices = indices;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $41dcdb4627c57f34$export$5f8a698e30111661(name, options, scene = null) {
    const size = options.size;
    const sizeX = options.sizeX || size || 1;
    const sizeY = options.sizeY || size || 1;
    const sizeZ = options.sizeZ || size || 1;
    let m = options.m || 1;
    if (m !== Math.floor(m)) {
        m = Math.floor(m);
        (0, $kVtWi.Logger).Warn("m not an integer only floor(m) used");
    }
    let n = options.n || 0;
    if (n !== Math.floor(n)) {
        n = Math.floor(n);
        (0, $kVtWi.Logger).Warn("n not an integer only floor(n) used");
    }
    if (n > m) {
        const temp = n;
        n = m;
        m = temp;
        (0, $kVtWi.Logger).Warn("n > m therefore m and n swapped");
    }
    const primTri = new (0, $d65feca8fd77fc63$export$242532ea034459b)();
    primTri.build(m, n);
    const geodesicData = (0, $d65feca8fd77fc63$export$f97f132d55c4fea9).BuildGeodesicData(primTri);
    const goldbergData = geodesicData.toGoldbergPolyhedronData();
    const goldberg = new (0, $8bcde881235d9b6b$export$33c9f07b719e61e4)(name, scene);
    options.sideOrientation = (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation);
    goldberg._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $41dcdb4627c57f34$export$e4bb3982c9d1679d(options, goldbergData);
    vertexData.applyToMesh(goldberg, options.updatable);
    goldberg.goldbergData.nbSharedFaces = geodesicData.sharedNodes;
    goldberg.goldbergData.nbUnsharedFaces = geodesicData.poleNodes;
    goldberg.goldbergData.adjacentFaces = geodesicData.adjacentFaces;
    goldberg.goldbergData.nbFaces = goldberg.goldbergData.nbSharedFaces + goldberg.goldbergData.nbUnsharedFaces;
    goldberg.goldbergData.nbFacesAtPole = (goldberg.goldbergData.nbUnsharedFaces - 12) / 12;
    for(let f = 0; f < geodesicData.vertex.length; f++){
        goldberg.goldbergData.faceCenters.push((0, $ha1VO.Vector3).FromArray(geodesicData.vertex[f]));
        goldberg.goldbergData.faceCenters[f].x *= sizeX;
        goldberg.goldbergData.faceCenters[f].y *= sizeY;
        goldberg.goldbergData.faceCenters[f].z *= sizeZ;
        goldberg.goldbergData.faceColors.push(new (0, $7etnY.Color4)(1, 1, 1, 1));
    }
    for(let f = 0; f < goldbergData.face.length; f++){
        const verts = goldbergData.face[f];
        const a = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[0]]);
        const b = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[2]]);
        const c = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[1]]);
        const ba = b.subtract(a);
        const ca = c.subtract(a);
        const norm = (0, $ha1VO.Vector3).Cross(ca, ba).normalize();
        const z = (0, $ha1VO.Vector3).Cross(ca, norm).normalize();
        goldberg.goldbergData.faceXaxis.push(ca.normalize());
        goldberg.goldbergData.faceYaxis.push(norm);
        goldberg.goldbergData.faceZaxis.push(z);
    }
    return goldberg;
}



var $fm2C6 = parcelRequire("fm2C6");

var $ha1VO = parcelRequire("ha1VO");



// Shape functions
class $9e6f64b8b89708c8$var$ShapePath {
    /** Create the ShapePath used to support glyphs
     * @param resolution defines the resolution used to determine the number of points per curve (default is 4)
     */ constructor(resolution){
        this._paths = [];
        this._tempPaths = [];
        this._holes = [];
        this._resolution = resolution;
    }
    /** Move the virtual cursor to a coordinate
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     */ moveTo(x, y) {
        this._currentPath = new (0, $fm2C6.Path2)(x, y);
        this._tempPaths.push(this._currentPath);
    }
    /** Draw a line from the virtual cursor to a given coordinate
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     */ lineTo(x, y) {
        this._currentPath.addLineTo(x, y);
    }
    /** Create a quadratic curve from the virtual cursor to a given coordinate
     * @param cpx defines the x coordinate of the control point
     * @param cpy defines the y coordinate of the control point
     * @param x defines the x coordinate of the end point
     * @param y defines the y coordinate of the end point
     */ quadraticCurveTo(cpx, cpy, x, y) {
        this._currentPath.addQuadraticCurveTo(cpx, cpy, x, y, this._resolution);
    }
    /**
     * Create a bezier curve from the virtual cursor to a given coordinate
     * @param cpx1 defines the x coordinate of the first control point
     * @param cpy1 defines the y coordinate of the first control point
     * @param cpx2 defines the x coordinate of the second control point
     * @param cpy2 defines the y coordinate of the second control point
     * @param x defines the x coordinate of the end point
     * @param y defines the y coordinate of the end point
     */ bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y) {
        this._currentPath.addBezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y, this._resolution);
    }
    /** Extract holes based on CW / CCW */ extractHoles() {
        for (const path of this._tempPaths)if (path.area() > 0) this._holes.push(path);
        else this._paths.push(path);
        if (!this._paths.length && this._holes.length) {
            const temp = this._holes;
            this._holes = this._paths;
            this._paths = temp;
        }
        this._tempPaths.length = 0;
    }
    /** Gets the list of paths */ get paths() {
        return this._paths;
    }
    /** Gets the list of holes */ get holes() {
        return this._holes;
    }
}
// Utility functions
function $9e6f64b8b89708c8$var$CreateShapePath(char, scale, offsetX, offsetY, resolution, fontData) {
    const glyph = fontData.glyphs[char] || fontData.glyphs["?"];
    if (!glyph) // return if there is no glyph data
    return null;
    const shapePath = new $9e6f64b8b89708c8$var$ShapePath(resolution);
    if (glyph.o) {
        const outline = glyph.o.split(" ");
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case "m":
                    {
                        // moveTo
                        const x = parseInt(outline[i++]) * scale + offsetX;
                        const y = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.moveTo(x, y);
                        break;
                    }
                case "l":
                    {
                        // lineTo
                        const x = parseInt(outline[i++]) * scale + offsetX;
                        const y = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.lineTo(x, y);
                        break;
                    }
                case "q":
                    {
                        // quadraticCurveTo
                        const cpx = parseInt(outline[i++]) * scale + offsetX;
                        const cpy = parseInt(outline[i++]) * scale + offsetY;
                        const cpx1 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy1 = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                        break;
                    }
                case "b":
                    {
                        // bezierCurveTo
                        const cpx = parseInt(outline[i++]) * scale + offsetX;
                        const cpy = parseInt(outline[i++]) * scale + offsetY;
                        const cpx1 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy1 = parseInt(outline[i++]) * scale + offsetY;
                        const cpx2 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy2 = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                        break;
                    }
            }
        }
    }
    // Extract holes (based on clockwise data)
    shapePath.extractHoles();
    return {
        offsetX: glyph.ha * scale,
        shapePath: shapePath
    };
}
function $9e6f64b8b89708c8$export$9a18c13a50e752ce(text, size, resolution, fontData) {
    const chars = Array.from(text);
    const scale = size / fontData.resolution;
    const line_height = (fontData.boundingBox.yMax - fontData.boundingBox.yMin + fontData.underlineThickness) * scale;
    const shapePaths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === "\n") {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = $9e6f64b8b89708c8$var$CreateShapePath(char, scale, offsetX, offsetY, resolution, fontData);
            if (ret) {
                offsetX += ret.offsetX;
                shapePaths.push(ret.shapePath);
            }
        }
    }
    return shapePaths;
}
function $9e6f64b8b89708c8$export$1d5955fa6cbe384b(name, text, fontData, options = {
    size: 50,
    resolution: 8,
    depth: 1.0
}, scene = null, earcutInjection = earcut) {
    // First we need to generate the paths
    const shapePaths = $9e6f64b8b89708c8$export$9a18c13a50e752ce(text, options.size || 50, options.resolution || 8, fontData);
    // And extrude them
    const meshes = [];
    let letterIndex = 0;
    for (const shapePath of shapePaths){
        if (!shapePath.paths.length) continue;
        const holes = shapePath.holes.slice(); // Copy it as we will update the copy
        for (const path of shapePath.paths){
            const holeVectors = [];
            const shapeVectors = [];
            const points = path.getPoints();
            for (const point of points)shapeVectors.push(new (0, $ha1VO.Vector3)(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
            // Holes
            const localHolesCopy = holes.slice();
            for (const hole of localHolesCopy){
                const points = hole.getPoints();
                let found = false;
                for (const point of points)if (path.isPointInside(point)) {
                    found = true;
                    break;
                }
                if (!found) continue;
                const holePoints = [];
                for (const point of points)holePoints.push(new (0, $ha1VO.Vector3)(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                holeVectors.push(holePoints);
                // Remove the hole as it was already used
                holes.splice(holes.indexOf(hole), 1);
            }
            // There is at least a hole but it was unaffected
            if (!holeVectors.length && holes.length) for (const hole of holes){
                const points = hole.getPoints();
                const holePoints = [];
                for (const point of points)holePoints.push(new (0, $ha1VO.Vector3)(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                holeVectors.push(holePoints);
            }
            // Extrusion!
            const mesh = (0, $74fbaf67623e82ac$export$7ab7ef8f70a7afeb)(name, {
                shape: shapeVectors,
                holes: holeVectors.length ? holeVectors : undefined,
                depth: options.depth || 1.0,
                faceUV: options.faceUV || options.perLetterFaceUV?.(letterIndex),
                faceColors: options.faceColors || options.perLetterFaceColors?.(letterIndex),
                sideOrientation: (0, $b0df7c384622c537$export$e176487c05830cc5)._GetDefaultSideOrientation(options.sideOrientation || (0, $b0df7c384622c537$export$e176487c05830cc5).DOUBLESIDE)
            }, scene, earcutInjection);
            meshes.push(mesh);
            letterIndex++;
        }
    }
    // Then we can merge everyone into one single mesh
    const newMesh = (0, $b0df7c384622c537$export$e176487c05830cc5).MergeMeshes(meshes, true, true);
    if (newMesh) {
        // Move pivot to desired center / bottom / center position
        const bbox = newMesh.getBoundingInfo().boundingBox;
        newMesh.position.x += -(bbox.minimumWorld.x + bbox.maximumWorld.x) / 2; // Mid X
        newMesh.position.y += -(bbox.minimumWorld.y + bbox.maximumWorld.y) / 2; // Mid Z as it will rotate
        newMesh.position.z += -(bbox.minimumWorld.z + bbox.maximumWorld.z) / 2 + bbox.extendSize.z; // Bottom Y as it will rotate
        newMesh.name = name;
        // Rotate 90° Up
        const pivot = new (0, $ecfbb5db4d70b862$export$b600d080bad015f)("pivot", scene);
        pivot.rotation.x = -Math.PI / 2;
        newMesh.parent = pivot;
        newMesh.bakeCurrentTransformIntoVertices();
        // Remove the pivot
        newMesh.parent = null;
        pivot.dispose();
    }
    return newMesh;
}


const $9b72f98286da73ed$export$b65e9a89c410ca15 = {
    CreateBox: $35c0cb96afcabbf6$export$37ca2b0c6cbdecde,
    CreateTiledBox: $b87964e9a5a0cd0a$export$1fb6e45d350ad273,
    CreateSphere: $65e76adba60735aa$export$7d1fdd0805366e9b,
    CreateDisc: $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f,
    CreateIcoSphere: $bb03d208aef23781$export$2bceb0111207e85d,
    CreateRibbon: $7c39a49659d9e77f$export$821dd8d5c9753978,
    CreateCylinder: $6f95fd90f7c5af1a$export$c71239caf0e43983,
    CreateTorus: $87667de2ca334d5c$export$51ab2f2e5b6ce5fb,
    CreateTorusKnot: $bd18b164246d46e4$export$15125c50b1408b05,
    CreateLineSystem: $64ccbca0cbde8de7$export$d2e386952db4e290,
    CreateLines: $64ccbca0cbde8de7$export$5c8430a92ff1a8d2,
    CreateDashedLines: $64ccbca0cbde8de7$export$1a25fda3f613818a,
    ExtrudeShape: $f55ac4e07ca7f06f$export$154977f2a337af53,
    ExtrudeShapeCustom: $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3,
    CreateLathe: $bbf9dea6106419fd$export$1aa598e2d5431c62,
    CreateTiledPlane: $f7ffc5db927c078f$export$5d0c250509e3dc5f,
    CreatePlane: $ee6b855236d2e2b5$export$474050064c328a47,
    CreateGround: $646061de4fd29ff7$export$36f42a4c5f351a31,
    CreateTiledGround: $646061de4fd29ff7$export$c78da18d8c5de609,
    CreateGroundFromHeightMap: $646061de4fd29ff7$export$1106a851f720f529,
    CreatePolygon: $74fbaf67623e82ac$export$2076f2784b460eb2,
    ExtrudePolygon: $74fbaf67623e82ac$export$7ab7ef8f70a7afeb,
    CreateTube: $31b9410618830924$export$e35b4d126241f338,
    CreatePolyhedron: $1d49167c5ec927a7$export$1cb5c9516e55bfc7,
    CreateGeodesic: $f484da790f7b4a54$export$616f62b64ab14d82,
    CreateGoldberg: $41dcdb4627c57f34$export$5f8a698e30111661,
    CreateDecal: $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8,
    CreateCapsule: $17c23aeaa7b72fc3$export$509367f6dcf345a3,
    CreateText: $9e6f64b8b89708c8$export$1d5955fa6cbe384b
};


parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");
var $ha1VO = parcelRequire("ha1VO");

var $fhgis = parcelRequire("fhgis");

var $7etnY = parcelRequire("7etnY");

var $6Ho1L = parcelRequire("6Ho1L");

var $dUFoQ = parcelRequire("dUFoQ");
class $08f87ed26b8946a4$export$ead2cdea5a43d2d2 {
    /**
     * Define if the fresnel effect is enable or not.
     */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        (0, $dUFoQ.AbstractEngine).MarkAllMaterialsAsDirty(20);
    }
    /**
     * Creates a new FresnelParameters object.
     *
     * @param options provide your own settings to optionally to override defaults
     */ constructor(options = {}){
        this._isEnabled = true;
        this.bias = options.bias === undefined ? 0 : options.bias;
        this.power = options.power === undefined ? 1 : options.power;
        this.leftColor = options.leftColor || (0, $7etnY.Color3).White();
        this.rightColor = options.rightColor || (0, $7etnY.Color3).Black();
        if (options.isEnabled === false) this.isEnabled = false;
    }
    /**
     * Clones the current fresnel and its values
     * @returns a clone fresnel configuration
     */ clone() {
        const newFresnelParameters = new $08f87ed26b8946a4$export$ead2cdea5a43d2d2();
        (0, $fhgis.DeepCopier).DeepCopy(this, newFresnelParameters);
        return newFresnelParameters;
    }
    /**
     * Determines equality between FresnelParameters objects
     * @param otherFresnelParameters defines the second operand
     * @returns true if the power, bias, leftColor, rightColor and isEnabled values are equal to the given ones
     */ equals(otherFresnelParameters) {
        return otherFresnelParameters && this.bias === otherFresnelParameters.bias && this.power === otherFresnelParameters.power && this.leftColor.equals(otherFresnelParameters.leftColor) && this.rightColor.equals(otherFresnelParameters.rightColor) && this.isEnabled === otherFresnelParameters.isEnabled;
    }
    /**
     * Serializes the current fresnel parameters to a JSON representation.
     * @returns the JSON serialization
     */ serialize() {
        return {
            isEnabled: this.isEnabled,
            leftColor: this.leftColor.asArray(),
            rightColor: this.rightColor.asArray(),
            bias: this.bias,
            power: this.power
        };
    }
    /**
     * Parse a JSON object and deserialize it to a new Fresnel parameter object.
     * @param parsedFresnelParameters Define the JSON representation
     * @returns the parsed parameters
     */ static Parse(parsedFresnelParameters) {
        return new $08f87ed26b8946a4$export$ead2cdea5a43d2d2({
            isEnabled: parsedFresnelParameters.isEnabled,
            leftColor: (0, $7etnY.Color3).FromArray(parsedFresnelParameters.leftColor),
            rightColor: (0, $7etnY.Color3).FromArray(parsedFresnelParameters.rightColor),
            bias: parsedFresnelParameters.bias,
            power: parsedFresnelParameters.power || 1.0
        });
    }
}
// References the dependencies.
(0, $6Ho1L.SerializationHelper)._FresnelParametersParser = $08f87ed26b8946a4$export$ead2cdea5a43d2d2.Parse;



parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

/**
 * This is here for backwards compatibility with 4.2
 * @internal
 */ 
var $b4i1f = parcelRequire("b4i1f");


var $b4i1f = parcelRequire("b4i1f");
class $ad89493dfaad9a4d$export$c56dffd5b07e66bc extends (0, $b0df7c384622c537$export$e176487c05830cc5) {
    constructor(name, scene, positions){
        super(name, scene);
        if (typeof positions == 'number') this._setIcoSphere(positions);
        else if (positions) this._setPositions(positions);
        else this._update(10);
        return this;
    }
    _setIcoSphere(subdivisions, radius) {
        let options = {
            subdivisions: subdivisions
        };
        if (subdivisions) options.subdivisions = subdivisions;
        else options.subdivisions = 2;
        if (radius) options.radius = radius;
        else options.radius = 0.7;
        var vertexData = (0, $4014d881db0e9bc6$export$8570d39351855acb).CreateIcoSphere(options);
        vertexData.applyToMesh(this, false);
    }
    _setPositions(newpositions) {
        let vertexData = (0, $4014d881db0e9bc6$export$8570d39351855acb).CreateSphere({
            segments: 2
        });
        vertexData.applyToMesh(this, false);
        let indices = this.getIndices();
        let normals = [];
        this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, newpositions);
        (0, $4014d881db0e9bc6$export$8570d39351855acb).ComputeNormals(newpositions, indices, normals);
        this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals);
        this.convertToFlatShadedMesh();
    }
    _update(pearlSize) {
        let vertexData = (0, $4014d881db0e9bc6$export$8570d39351855acb).CreateSphere({
            segments: 2
        });
        vertexData.applyToMesh(this, false);
        let positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        let numberOfPoints = positions.length / 3;
        let map = [];
        // The higher point in the sphere
        let max = [];
        for(let i = 0; i < numberOfPoints; i++){
            let p = new (0, $ha1VO.Vector3)(positions[i * 3], positions[i * 3 + 1], positions[i * 3 + 2]);
            if (p.y >= pearlSize / 2) max.push(p);
            let found = false;
            for(let index = 0; index < map.length && !found; index++){
                let array = map[index];
                let p0 = array[0];
                if (p0.equals(p) || p0.subtract(p).lengthSquared() < 0.01) {
                    array.push(i * 3);
                    found = true;
                }
            }
            if (!found) {
                let array = [];
                array.push(p, i * 3);
                map.push(array);
            }
        }
        let randomNumber = function(min, max) {
            if (min == max) return min;
            let random = Math.random();
            return random * (max - min) + min;
        };
        map.forEach((array)=>{
            let index, min = -pearlSize / 70, max = pearlSize / 70;
            let rx = randomNumber(min, max);
            let ry = randomNumber(min, max);
            let rz = randomNumber(min, max);
            for(index = 1; index < array.length; index++){
                let i = array[index];
                positions[i] = positions[i] + rx;
                positions[i + 1] = positions[i + 1] + ry;
                positions[i + 2] = positions[i + 2] + rz;
            }
        });
        positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        this.pearlPositions = positions;
        this._setPositions(positions);
        return positions;
    }
    _getPositions() {
        return this.pearlPositions;
    }
}



var $ha1VO = parcelRequire("ha1VO");

var $opFp4 = parcelRequire("opFp4");

class $bbab17c2ca6aeebf$export$b127726e56765aa4 extends (0, $021dcb6a570ae9c1$export$85c928794f8d04d4) {
    /** @internal */ get _matrix() {
        this._compose();
        return this._localMatrix;
    }
    /** @internal */ set _matrix(value) {
        // skip if the matrices are the same
        if (value.updateFlag === this._localMatrix.updateFlag && !this._needToCompose) return;
        this._needToCompose = false; // in case there was a pending compose
        this._localMatrix.copyFrom(value);
        this._markAsDirtyAndDecompose();
    }
    /**
     * Create a new bone
     * @param name defines the bone name
     * @param skeleton defines the parent skeleton
     * @param parentBone defines the parent (can be null if the bone is the root)
     * @param localMatrix defines the local matrix (default: identity)
     * @param restMatrix defines the rest matrix (default: localMatrix)
     * @param bindMatrix defines the bind matrix (default: localMatrix)
     * @param index defines index of the bone in the hierarchy (default: null)
     */ constructor(/**
     * defines the bone name
     */ name, skeleton, parentBone = null, localMatrix = null, restMatrix = null, bindMatrix = null, index = null){
        super(name, skeleton.getScene(), false);
        this.name = name;
        /**
         * Gets the list of child bones
         */ this.children = [];
        /** Gets the animations associated with this bone */ this.animations = [];
        /**
         * @internal Internal only
         * Set this value to map this bone to a different index in the transform matrices
         * Set this value to -1 to exclude the bone from the transform matrices
         */ this._index = null;
        this._scalingDeterminant = 1;
        this._needToDecompose = true;
        this._needToCompose = false;
        /** @internal */ this._linkedTransformNode = null;
        /** @internal */ this._waitingTransformNodeId = null;
        this._skeleton = skeleton;
        this._localMatrix = localMatrix?.clone() ?? (0, $ha1VO.Matrix).Identity();
        this._restMatrix = restMatrix ?? this._localMatrix.clone();
        this._bindMatrix = bindMatrix ?? this._localMatrix.clone();
        this._index = index;
        this._absoluteMatrix = new (0, $ha1VO.Matrix)();
        this._absoluteBindMatrix = new (0, $ha1VO.Matrix)();
        this._absoluteInverseBindMatrix = new (0, $ha1VO.Matrix)();
        this._finalMatrix = new (0, $ha1VO.Matrix)();
        skeleton.bones.push(this);
        this.setParent(parentBone, false);
        this._updateAbsoluteBindMatrices();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "Bone";
    }
    // Members
    /**
     * Gets the parent skeleton
     * @returns a skeleton
     */ getSkeleton() {
        return this._skeleton;
    }
    get parent() {
        return this._parentNode;
    }
    /**
     * Gets parent bone
     * @returns a bone or null if the bone is the root of the bone hierarchy
     */ getParent() {
        return this.parent;
    }
    /**
     * Returns an array containing the children of the bone
     * @returns an array containing the children of the bone (can be empty if the bone has no children)
     */ getChildren() {
        return this.children;
    }
    /**
     * Gets the node index in matrix array generated for rendering
     * @returns the node index
     */ getIndex() {
        return this._index === null ? this.getSkeleton().bones.indexOf(this) : this._index;
    }
    set parent(newParent) {
        this.setParent(newParent);
    }
    /**
     * Sets the parent bone
     * @param parent defines the parent (can be null if the bone is the root)
     * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be updated
     */ setParent(parent, updateAbsoluteBindMatrices = true) {
        if (this.parent === parent) return;
        if (this.parent) {
            const index = this.parent.children.indexOf(this);
            if (index !== -1) this.parent.children.splice(index, 1);
        }
        this._parentNode = parent;
        if (this.parent) this.parent.children.push(this);
        if (updateAbsoluteBindMatrices) this._updateAbsoluteBindMatrices();
        this.markAsDirty();
    }
    /**
     * Gets the local matrix
     * @returns the local matrix
     */ getLocalMatrix() {
        this._compose();
        return this._localMatrix;
    }
    /**
     * Gets the bind matrix
     * @returns the bind matrix
     */ getBindMatrix() {
        return this._bindMatrix;
    }
    /**
     * Gets the bind matrix.
     * @returns the bind matrix
     * @deprecated Please use getBindMatrix instead
     */ getBaseMatrix() {
        return this.getBindMatrix();
    }
    /**
     * Gets the rest matrix
     * @returns the rest matrix
     */ getRestMatrix() {
        return this._restMatrix;
    }
    /**
     * Gets the rest matrix
     * @returns the rest matrix
     * @deprecated Please use getRestMatrix instead
     */ getRestPose() {
        return this.getRestMatrix();
    }
    /**
     * Sets the rest matrix
     * @param matrix the local-space rest matrix to set for this bone
     */ setRestMatrix(matrix) {
        this._restMatrix.copyFrom(matrix);
    }
    /**
     * Sets the rest matrix
     * @param matrix the local-space rest to set for this bone
     * @deprecated Please use setRestMatrix instead
     */ setRestPose(matrix) {
        this.setRestMatrix(matrix);
    }
    /**
     * Gets the bind matrix
     * @returns the bind matrix
     * @deprecated Please use getBindMatrix instead
     */ getBindPose() {
        return this.getBindMatrix();
    }
    /**
     * Sets the bind matrix
     * This will trigger a recomputation of the absolute bind and absolute inverse bind matrices for this bone and its children
     * Note that the local matrix will also be set with the matrix passed in parameter!
     * @param matrix the local-space bind matrix to set for this bone
     */ setBindMatrix(matrix) {
        this.updateMatrix(matrix);
    }
    /**
     * Sets the bind matrix
     * @param matrix the local-space bind to set for this bone
     * @deprecated Please use setBindMatrix instead
     */ setBindPose(matrix) {
        this.setBindMatrix(matrix);
    }
    /**
     * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
     * @returns the final world matrix
     */ getFinalMatrix() {
        return this._finalMatrix;
    }
    /**
     * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
     * @deprecated Please use getFinalMatrix instead
     * @returns the final world matrix
     */ getWorldMatrix() {
        return this.getFinalMatrix();
    }
    /**
     * Sets the local matrix to the rest matrix
     */ returnToRest() {
        if (this._linkedTransformNode) {
            const localScaling = (0, $ha1VO.TmpVectors).Vector3[0];
            const localRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
            const localPosition = (0, $ha1VO.TmpVectors).Vector3[1];
            this.getRestMatrix().decompose(localScaling, localRotation, localPosition);
            this._linkedTransformNode.position.copyFrom(localPosition);
            this._linkedTransformNode.rotationQuaternion = this._linkedTransformNode.rotationQuaternion ?? (0, $ha1VO.Quaternion).Identity();
            this._linkedTransformNode.rotationQuaternion.copyFrom(localRotation);
            this._linkedTransformNode.scaling.copyFrom(localScaling);
        } else this._matrix = this._restMatrix;
    }
    /**
     * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
     * @returns the inverse bind matrix, in world space
     */ getAbsoluteInverseBindMatrix() {
        return this._absoluteInverseBindMatrix;
    }
    /**
     * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
     * @returns the inverse bind matrix, in world space
     * @deprecated Please use getAbsoluteInverseBindMatrix instead
     */ getInvertedAbsoluteTransform() {
        return this.getAbsoluteInverseBindMatrix();
    }
    /**
     * Gets the bone matrix, in world space (relative to the skeleton root)
     * @returns the bone matrix, in world space
     */ getAbsoluteMatrix() {
        return this._absoluteMatrix;
    }
    /**
     * Gets the bone matrix, in world space (relative to the skeleton root)
     * @returns the bone matrix, in world space
     * @deprecated Please use getAbsoluteMatrix instead
     */ getAbsoluteTransform() {
        return this._absoluteMatrix;
    }
    /**
     * Links with the given transform node.
     * The local matrix of this bone is overwritten by the transform of the node every frame.
     * @param transformNode defines the transform node to link to
     */ linkTransformNode(transformNode) {
        if (this._linkedTransformNode) this._skeleton._numBonesWithLinkedTransformNode--;
        this._linkedTransformNode = transformNode;
        if (this._linkedTransformNode) this._skeleton._numBonesWithLinkedTransformNode++;
    }
    // Properties (matches TransformNode properties)
    /**
     * Gets the node used to drive the bone's transformation
     * @returns a transform node or null
     */ getTransformNode() {
        return this._linkedTransformNode;
    }
    /** Gets or sets current position (in local space) */ get position() {
        this._decompose();
        return this._localPosition;
    }
    set position(newPosition) {
        this._decompose();
        this._localPosition.copyFrom(newPosition);
        this._markAsDirtyAndCompose();
    }
    /** Gets or sets current rotation (in local space) */ get rotation() {
        return this.getRotation();
    }
    set rotation(newRotation) {
        this.setRotation(newRotation);
    }
    /** Gets or sets current rotation quaternion (in local space) */ get rotationQuaternion() {
        this._decompose();
        return this._localRotation;
    }
    set rotationQuaternion(newRotation) {
        this.setRotationQuaternion(newRotation);
    }
    /** Gets or sets current scaling (in local space) */ get scaling() {
        return this.getScale();
    }
    set scaling(newScaling) {
        this.setScale(newScaling);
    }
    /**
     * Gets the animation properties override
     */ get animationPropertiesOverride() {
        return this._skeleton.animationPropertiesOverride;
    }
    // Methods
    _decompose() {
        if (!this._needToDecompose) return;
        this._needToDecompose = false;
        if (!this._localScaling) {
            this._localScaling = (0, $ha1VO.Vector3).Zero();
            this._localRotation = (0, $ha1VO.Quaternion).Zero();
            this._localPosition = (0, $ha1VO.Vector3).Zero();
        }
        this._localMatrix.decompose(this._localScaling, this._localRotation, this._localPosition);
    }
    _compose() {
        if (!this._needToCompose) return;
        if (!this._localScaling) {
            this._needToCompose = false;
            return;
        }
        this._needToCompose = false;
        (0, $ha1VO.Matrix).ComposeToRef(this._localScaling, this._localRotation, this._localPosition, this._localMatrix);
    }
    /**
     * Update the bind (and optionally the local) matrix
     * @param bindMatrix defines the new matrix to set to the bind/local matrix, in local space
     * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be recomputed (default: true)
     * @param updateLocalMatrix defines if the local matrix should also be updated with the matrix passed in parameter (default: true)
     */ updateMatrix(bindMatrix, updateAbsoluteBindMatrices = true, updateLocalMatrix = true) {
        this._bindMatrix.copyFrom(bindMatrix);
        if (updateAbsoluteBindMatrices) this._updateAbsoluteBindMatrices();
        if (updateLocalMatrix) this._matrix = bindMatrix;
        else this.markAsDirty();
    }
    /**
     * @internal
     */ _updateAbsoluteBindMatrices(bindMatrix, updateChildren = true) {
        if (!bindMatrix) bindMatrix = this._bindMatrix;
        if (this.parent) bindMatrix.multiplyToRef(this.parent._absoluteBindMatrix, this._absoluteBindMatrix);
        else this._absoluteBindMatrix.copyFrom(bindMatrix);
        this._absoluteBindMatrix.invertToRef(this._absoluteInverseBindMatrix);
        if (updateChildren) for(let index = 0; index < this.children.length; index++)this.children[index]._updateAbsoluteBindMatrices();
        this._scalingDeterminant = this._absoluteBindMatrix.determinant() < 0 ? -1 : 1;
    }
    /**
     * Flag the bone as dirty (Forcing it to update everything)
     * @returns this bone
     */ markAsDirty() {
        this._currentRenderId++;
        this._childUpdateId++;
        this._skeleton._markAsDirty();
        return this;
    }
    /** @internal */ _markAsDirtyAndCompose() {
        this.markAsDirty();
        this._needToCompose = true;
    }
    _markAsDirtyAndDecompose() {
        this.markAsDirty();
        this._needToDecompose = true;
    }
    _updatePosition(vec, space = 0 /* Space.LOCAL */ , tNode, translationMode = true) {
        const lm = this.getLocalMatrix();
        if (space == 0 /* Space.LOCAL */ ) {
            if (translationMode) {
                lm.addAtIndex(12, vec.x);
                lm.addAtIndex(13, vec.y);
                lm.addAtIndex(14, vec.z);
            } else lm.setTranslationFromFloats(vec.x, vec.y, vec.z);
        } else {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) wm = tNode.getWorldMatrix();
            this._skeleton.computeAbsoluteMatrices();
            const tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            const tvec = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpVecs[0];
            if (this.parent) {
                if (tNode && wm) {
                    tmat.copyFrom(this.parent.getAbsoluteMatrix());
                    tmat.multiplyToRef(wm, tmat);
                } else tmat.copyFrom(this.parent.getAbsoluteMatrix());
            } else (0, $ha1VO.Matrix).IdentityToRef(tmat);
            if (translationMode) tmat.setTranslationFromFloats(0, 0, 0);
            tmat.invert();
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(vec, tmat, tvec);
            if (translationMode) {
                lm.addAtIndex(12, tvec.x);
                lm.addAtIndex(13, tvec.y);
                lm.addAtIndex(14, tvec.z);
            } else lm.setTranslationFromFloats(tvec.x, tvec.y, tvec.z);
        }
        this._markAsDirtyAndDecompose();
    }
    /**
     * Translate the bone in local or world space
     * @param vec The amount to translate the bone
     * @param space The space that the translation is in (default: Space.LOCAL)
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ translate(vec, space = 0 /* Space.LOCAL */ , tNode) {
        this._updatePosition(vec, space, tNode, true);
    }
    /**
     * Set the position of the bone in local or world space
     * @param position The position to set the bone
     * @param space The space that the position is in (default: Space.LOCAL)
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setPosition(position, space = 0 /* Space.LOCAL */ , tNode) {
        this._updatePosition(position, space, tNode, false);
    }
    /**
     * Set the absolute position of the bone (world space)
     * @param position The position to set the bone
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setAbsolutePosition(position, tNode) {
        this.setPosition(position, 1 /* Space.WORLD */ , tNode);
    }
    /**
     * Scale the bone on the x, y and z axes (in local space)
     * @param x The amount to scale the bone on the x axis
     * @param y The amount to scale the bone on the y axis
     * @param z The amount to scale the bone on the z axis
     * @param scaleChildren sets this to true if children of the bone should be scaled as well (false by default)
     */ scale(x, y, z, scaleChildren = false) {
        const locMat = this.getLocalMatrix();
        // Apply new scaling on top of current local matrix
        const scaleMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        (0, $ha1VO.Matrix).ScalingToRef(x, y, z, scaleMat);
        scaleMat.multiplyToRef(locMat, locMat);
        // Invert scaling matrix and apply the inverse to all children
        scaleMat.invert();
        for (const child of this.children){
            const cm = child.getLocalMatrix();
            cm.multiplyToRef(scaleMat, cm);
            cm.multiplyAtIndex(12, x);
            cm.multiplyAtIndex(13, y);
            cm.multiplyAtIndex(14, z);
            child._markAsDirtyAndDecompose();
        }
        this._markAsDirtyAndDecompose();
        if (scaleChildren) for (const child of this.children)child.scale(x, y, z, scaleChildren);
    }
    /**
     * Set the bone scaling in local space
     * @param scale defines the scaling vector
     */ setScale(scale) {
        this._decompose();
        this._localScaling.copyFrom(scale);
        this._markAsDirtyAndCompose();
    }
    /**
     * Gets the current scaling in local space
     * @returns the current scaling vector
     */ getScale() {
        this._decompose();
        return this._localScaling;
    }
    /**
     * Gets the current scaling in local space and stores it in a target vector
     * @param result defines the target vector
     */ getScaleToRef(result) {
        this._decompose();
        result.copyFrom(this._localScaling);
    }
    /**
     * Set the yaw, pitch, and roll of the bone in local or world space
     * @param yaw The rotation of the bone on the y axis
     * @param pitch The rotation of the bone on the x axis
     * @param roll The rotation of the bone on the z axis
     * @param space The space that the axes of rotation are in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setYawPitchRoll(yaw, pitch, roll, space = 0 /* Space.LOCAL */ , tNode) {
        if (space === 0 /* Space.LOCAL */ ) {
            const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(yaw, pitch, roll, quat);
            this.setRotationQuaternion(quat, space, tNode);
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        (0, $ha1VO.Matrix).RotationYawPitchRollToRef(yaw, pitch, roll, rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat);
        this._rotateWithMatrix(rotMat, space, tNode);
    }
    /**
     * Add a rotation to the bone on an axis in local or world space
     * @param axis The axis to rotate the bone on
     * @param amount The amount to rotate the bone
     * @param space The space that the axis is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ rotate(axis, amount, space = 0 /* Space.LOCAL */ , tNode) {
        const rmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        rmat.setTranslationFromFloats(0, 0, 0);
        (0, $ha1VO.Matrix).RotationAxisToRef(axis, amount, rmat);
        this._rotateWithMatrix(rmat, space, tNode);
    }
    /**
     * Set the rotation of the bone to a particular axis angle in local or world space
     * @param axis The axis to rotate the bone on
     * @param angle The angle that the bone should be rotated to
     * @param space The space that the axis is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setAxisAngle(axis, angle, space = 0 /* Space.LOCAL */ , tNode) {
        if (space === 0 /* Space.LOCAL */ ) {
            const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
            (0, $ha1VO.Quaternion).RotationAxisToRef(axis, angle, quat);
            this.setRotationQuaternion(quat, space, tNode);
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        (0, $ha1VO.Matrix).RotationAxisToRef(axis, angle, rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat);
        this._rotateWithMatrix(rotMat, space, tNode);
    }
    /**
     * Set the euler rotation of the bone in local or world space
     * @param rotation The euler rotation that the bone should be set to
     * @param space The space that the rotation is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setRotation(rotation, space = 0 /* Space.LOCAL */ , tNode) {
        this.setYawPitchRoll(rotation.y, rotation.x, rotation.z, space, tNode);
    }
    /**
     * Set the quaternion rotation of the bone in local or world space
     * @param quat The quaternion rotation that the bone should be set to
     * @param space The space that the rotation is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setRotationQuaternion(quat, space = 0 /* Space.LOCAL */ , tNode) {
        if (space === 0 /* Space.LOCAL */ ) {
            this._decompose();
            this._localRotation.copyFrom(quat);
            this._markAsDirtyAndCompose();
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        (0, $ha1VO.Matrix).FromQuaternionToRef(quat, rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat);
        this._rotateWithMatrix(rotMat, space, tNode);
    }
    /**
     * Set the rotation matrix of the bone in local or world space
     * @param rotMat The rotation matrix that the bone should be set to
     * @param space The space that the rotation is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setRotationMatrix(rotMat, space = 0 /* Space.LOCAL */ , tNode) {
        if (space === 0 /* Space.LOCAL */ ) {
            const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
            (0, $ha1VO.Quaternion).FromRotationMatrixToRef(rotMat, quat);
            this.setRotationQuaternion(quat, space, tNode);
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat2 = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        rotMat2.copyFrom(rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat2);
        this._rotateWithMatrix(rotMat2, space, tNode);
    }
    _rotateWithMatrix(rmat, space = 0 /* Space.LOCAL */ , tNode) {
        const lmat = this.getLocalMatrix();
        const lx = lmat.m[12];
        const ly = lmat.m[13];
        const lz = lmat.m[14];
        const parent = this.getParent();
        const parentScale = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[3];
        const parentScaleInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[4];
        if (parent && space == 1 /* Space.WORLD */ ) {
            if (tNode) {
                parentScale.copyFrom(tNode.getWorldMatrix());
                parent.getAbsoluteMatrix().multiplyToRef(parentScale, parentScale);
            } else parentScale.copyFrom(parent.getAbsoluteMatrix());
            parentScaleInv.copyFrom(parentScale);
            parentScaleInv.invert();
            lmat.multiplyToRef(parentScale, lmat);
            lmat.multiplyToRef(rmat, lmat);
            lmat.multiplyToRef(parentScaleInv, lmat);
        } else if (space == 1 /* Space.WORLD */  && tNode) {
            parentScale.copyFrom(tNode.getWorldMatrix());
            parentScaleInv.copyFrom(parentScale);
            parentScaleInv.invert();
            lmat.multiplyToRef(parentScale, lmat);
            lmat.multiplyToRef(rmat, lmat);
            lmat.multiplyToRef(parentScaleInv, lmat);
        } else lmat.multiplyToRef(rmat, lmat);
        lmat.setTranslationFromFloats(lx, ly, lz);
        this.computeAbsoluteMatrices();
        this._markAsDirtyAndDecompose();
    }
    _getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode) {
        const scaleMatrix = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[2];
        rotMatInv.copyFrom(this.getAbsoluteMatrix());
        if (tNode) {
            rotMatInv.multiplyToRef(tNode.getWorldMatrix(), rotMatInv);
            (0, $ha1VO.Matrix).ScalingToRef(tNode.scaling.x, tNode.scaling.y, tNode.scaling.z, scaleMatrix);
        } else (0, $ha1VO.Matrix).IdentityToRef(scaleMatrix);
        rotMatInv.invert();
        if (isNaN(rotMatInv.m[0])) // Matrix failed to invert.
        // This can happen if scale is zero for example.
        return false;
        scaleMatrix.multiplyAtIndex(0, this._scalingDeterminant);
        rotMatInv.multiplyToRef(scaleMatrix, rotMatInv);
        return true;
    }
    /**
     * Get the position of the bone in local or world space
     * @param space The space that the returned position is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The position of the bone
     */ getPosition(space = 0 /* Space.LOCAL */ , tNode = null) {
        const pos = (0, $ha1VO.Vector3).Zero();
        this.getPositionToRef(space, tNode, pos);
        return pos;
    }
    /**
     * Copy the position of the bone to a vector3 in local or world space
     * @param space The space that the returned position is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 to copy the position to
     */ getPositionToRef(space = 0 /* Space.LOCAL */ , tNode, result) {
        if (space == 0 /* Space.LOCAL */ ) {
            const lm = this.getLocalMatrix();
            result.x = lm.m[12];
            result.y = lm.m[13];
            result.z = lm.m[14];
        } else {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) wm = tNode.getWorldMatrix();
            this._skeleton.computeAbsoluteMatrices();
            let tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            if (tNode && wm) {
                tmat.copyFrom(this.getAbsoluteMatrix());
                tmat.multiplyToRef(wm, tmat);
            } else tmat = this.getAbsoluteMatrix();
            result.x = tmat.m[12];
            result.y = tmat.m[13];
            result.z = tmat.m[14];
        }
    }
    /**
     * Get the absolute position of the bone (world space)
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The absolute position of the bone
     */ getAbsolutePosition(tNode = null) {
        const pos = (0, $ha1VO.Vector3).Zero();
        this.getPositionToRef(1 /* Space.WORLD */ , tNode, pos);
        return pos;
    }
    /**
     * Copy the absolute position of the bone (world space) to the result param
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 to copy the absolute position to
     */ getAbsolutePositionToRef(tNode, result) {
        this.getPositionToRef(1 /* Space.WORLD */ , tNode, result);
    }
    /**
     * Compute the absolute matrices of this bone and its children
     */ computeAbsoluteMatrices() {
        this._compose();
        if (this.parent) this._localMatrix.multiplyToRef(this.parent._absoluteMatrix, this._absoluteMatrix);
        else {
            this._absoluteMatrix.copyFrom(this._localMatrix);
            const poseMatrix = this._skeleton.getPoseMatrix();
            if (poseMatrix) this._absoluteMatrix.multiplyToRef(poseMatrix, this._absoluteMatrix);
        }
        const children = this.children;
        const len = children.length;
        for(let i = 0; i < len; i++)children[i].computeAbsoluteMatrices();
    }
    /**
     * Compute the absolute matrices of this bone and its children
     * @deprecated Please use computeAbsoluteMatrices instead
     */ computeAbsoluteTransforms() {
        this.computeAbsoluteMatrices();
    }
    /**
     * Get the world direction from an axis that is in the local space of the bone
     * @param localAxis The local direction that is used to compute the world direction
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The world direction
     */ getDirection(localAxis, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getDirectionToRef(localAxis, tNode, result);
        return result;
    }
    /**
     * Copy the world direction to a vector3 from an axis that is in the local space of the bone
     * @param localAxis The local direction that is used to compute the world direction
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the world direction will be copied to
     */ getDirectionToRef(localAxis, tNode = null, result) {
        let wm = null;
        //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
        if (tNode) wm = tNode.getWorldMatrix();
        this._skeleton.computeAbsoluteMatrices();
        const mat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        mat.copyFrom(this.getAbsoluteMatrix());
        if (tNode && wm) mat.multiplyToRef(wm, mat);
        (0, $ha1VO.Vector3).TransformNormalToRef(localAxis, mat, result);
        result.normalize();
    }
    /**
     * Get the euler rotation of the bone in local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The euler rotation
     */ getRotation(space = 0 /* Space.LOCAL */ , tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getRotationToRef(space, tNode, result);
        return result;
    }
    /**
     * Copy the euler rotation of the bone to a vector3.  The rotation can be in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the rotation should be copied to
     */ getRotationToRef(space = 0 /* Space.LOCAL */ , tNode = null, result) {
        const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
        this.getRotationQuaternionToRef(space, tNode, quat);
        quat.toEulerAnglesToRef(result);
    }
    /**
     * Get the quaternion rotation of the bone in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The quaternion rotation
     */ getRotationQuaternion(space = 0 /* Space.LOCAL */ , tNode = null) {
        const result = (0, $ha1VO.Quaternion).Identity();
        this.getRotationQuaternionToRef(space, tNode, result);
        return result;
    }
    /**
     * Copy the quaternion rotation of the bone to a quaternion.  The rotation can be in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The quaternion that the rotation should be copied to
     */ getRotationQuaternionToRef(space = 0 /* Space.LOCAL */ , tNode = null, result) {
        if (space == 0 /* Space.LOCAL */ ) {
            this._decompose();
            result.copyFrom(this._localRotation);
        } else {
            const mat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            const amat = this.getAbsoluteMatrix();
            if (tNode) amat.multiplyToRef(tNode.getWorldMatrix(), mat);
            else mat.copyFrom(amat);
            mat.multiplyAtIndex(0, this._scalingDeterminant);
            mat.multiplyAtIndex(1, this._scalingDeterminant);
            mat.multiplyAtIndex(2, this._scalingDeterminant);
            mat.decompose(undefined, result, undefined);
        }
    }
    /**
     * Get the rotation matrix of the bone in local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The rotation matrix
     */ getRotationMatrix(space = 0 /* Space.LOCAL */ , tNode) {
        const result = (0, $ha1VO.Matrix).Identity();
        this.getRotationMatrixToRef(space, tNode, result);
        return result;
    }
    /**
     * Copy the rotation matrix of the bone to a matrix.  The rotation can be in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The quaternion that the rotation should be copied to
     */ getRotationMatrixToRef(space = 0 /* Space.LOCAL */ , tNode, result) {
        if (space == 0 /* Space.LOCAL */ ) this.getLocalMatrix().getRotationMatrixToRef(result);
        else {
            const mat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            const amat = this.getAbsoluteMatrix();
            if (tNode) amat.multiplyToRef(tNode.getWorldMatrix(), mat);
            else mat.copyFrom(amat);
            mat.multiplyAtIndex(0, this._scalingDeterminant);
            mat.multiplyAtIndex(1, this._scalingDeterminant);
            mat.multiplyAtIndex(2, this._scalingDeterminant);
            mat.getRotationMatrixToRef(result);
        }
    }
    /**
     * Get the world position of a point that is in the local space of the bone
     * @param position The local position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The world position
     */ getAbsolutePositionFromLocal(position, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getAbsolutePositionFromLocalToRef(position, tNode, result);
        return result;
    }
    /**
     * Get the world position of a point that is in the local space of the bone and copy it to the result param
     * @param position The local position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the world position should be copied to
     */ getAbsolutePositionFromLocalToRef(position, tNode = null, result) {
        let wm = null;
        //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
        if (tNode) wm = tNode.getWorldMatrix();
        this._skeleton.computeAbsoluteMatrices();
        const tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        tmat.copyFrom(this.getAbsoluteMatrix());
        if (tNode && wm) tmat.multiplyToRef(wm, tmat);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, tmat, result);
    }
    /**
     * Get the local position of a point that is in world space
     * @param position The world position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The local position
     */ getLocalPositionFromAbsolute(position, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getLocalPositionFromAbsoluteToRef(position, tNode, result);
        return result;
    }
    /**
     * Get the local position of a point that is in world space and copy it to the result param
     * @param position The world position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the local position should be copied to
     */ getLocalPositionFromAbsoluteToRef(position, tNode = null, result) {
        let wm = null;
        //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
        if (tNode) wm = tNode.getWorldMatrix();
        this._skeleton.computeAbsoluteMatrices();
        const tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        tmat.copyFrom(this.getAbsoluteMatrix());
        if (tNode && wm) tmat.multiplyToRef(wm, tmat);
        tmat.invert();
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, tmat, result);
    }
    /**
     * Set the current local matrix as the restMatrix for this bone.
     */ setCurrentPoseAsRest() {
        this.setRestMatrix(this.getLocalMatrix());
    }
    /**
     * Releases associated resources
     */ dispose() {
        this._linkedTransformNode = null;
        const index = this._skeleton.bones.indexOf(this);
        if (index !== -1) this._skeleton.bones.splice(index, 1);
        if (this._parentNode && this._parentNode.children) {
            const children = this._parentNode.children;
            const index = children.indexOf(this);
            if (index !== -1) children.splice(index, 1);
        }
        super.dispose();
    }
}
$bbab17c2ca6aeebf$export$b127726e56765aa4._TmpVecs = (0, $opFp4.BuildArray)(2, (0, $ha1VO.Vector3).Zero);
$bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat = (0, $ha1VO.Quaternion).Identity();
$bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats = (0, $opFp4.BuildArray)(5, (0, $ha1VO.Matrix).Identity);



var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $iosaP = parcelRequire("iosaP");

var $8DoUR = parcelRequire("8DoUR");
/**
 * Represents the range of an animation
 */ class $ed727cbc04f22ca3$export$eeed3d1abb539eaf {
    /**
     * Initializes the range of an animation
     * @param name The name of the animation range
     * @param from The starting frame of the animation
     * @param to The ending frame of the animation
     */ constructor(/**The name of the animation range**/ name, /**The starting frame of the animation */ from, /**The ending frame of the animation*/ to){
        this.name = name;
        this.from = from;
        this.to = to;
    }
    /**
     * Makes a copy of the animation range
     * @returns A copy of the animation range
     */ clone() {
        return new $ed727cbc04f22ca3$export$eeed3d1abb539eaf(this.name, this.from, this.to);
    }
}




var $93o7r = parcelRequire("93o7r");

var $hUzEl = parcelRequire("hUzEl");

var $6Ho1L = parcelRequire("6Ho1L");
const $ff91d59daa75db10$export$519770a712ff637a = Object.freeze(new (0, $ha1VO.Quaternion)(0, 0, 0, 0));
const $ff91d59daa75db10$export$499344e023610249 = Object.freeze((0, $ha1VO.Vector3).Zero());
const $ff91d59daa75db10$export$6d83b9c8972825ff = Object.freeze((0, $ha1VO.Vector2).Zero());
const $ff91d59daa75db10$export$1246757db6a7aaea = Object.freeze((0, $93o7r.Size).Zero());
const $ff91d59daa75db10$export$d98e5cb9b7a6dc07 = Object.freeze((0, $7etnY.Color3).Black());
const $ff91d59daa75db10$export$6e4972fa3772cc35 = Object.freeze(new (0, $7etnY.Color4)(0, 0, 0, 0));
const $ff91d59daa75db10$var$evaluateAnimationState = {
    key: 0,
    repeatCount: 0,
    loopMode: 2 /*Animation.ANIMATIONLOOPMODE_CONSTANT*/ 
};
class $ff91d59daa75db10$export$c35d437ae5945fcd {
    /**
     * @internal Internal use
     */ static _PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction) {
        let dataType = undefined;
        if (!isNaN(parseFloat(from)) && isFinite(from)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT;
        else if (from instanceof (0, $ha1VO.Quaternion)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION;
        else if (from instanceof (0, $ha1VO.Vector3)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3;
        else if (from instanceof (0, $ha1VO.Vector2)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2;
        else if (from instanceof (0, $7etnY.Color3)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3;
        else if (from instanceof (0, $7etnY.Color4)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4;
        else if (from instanceof (0, $93o7r.Size)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE;
        if (dataType == undefined) return null;
        const animation = new $ff91d59daa75db10$export$c35d437ae5945fcd(name, targetProperty, framePerSecond, dataType, loopMode);
        const keys = [
            {
                frame: 0,
                value: from
            },
            {
                frame: totalFrame,
                value: to
            }
        ];
        animation.setKeys(keys);
        if (easingFunction !== undefined) animation.setEasingFunction(easingFunction);
        return animation;
    }
    /**
     * Sets up an animation
     * @param property The property to animate
     * @param animationType The animation type to apply
     * @param framePerSecond The frames per second of the animation
     * @param easingFunction The easing function used in the animation
     * @returns The created animation
     */ static CreateAnimation(property, animationType, framePerSecond, easingFunction) {
        const animation = new $ff91d59daa75db10$export$c35d437ae5945fcd(property + "Animation", property, framePerSecond, animationType, $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT);
        animation.setEasingFunction(easingFunction);
        return animation;
    }
    /**
     * Create and start an animation on a node
     * @param name defines the name of the global animation that will be run on all nodes
     * @param target defines the target where the animation will take place
     * @param targetProperty defines property to animate
     * @param framePerSecond defines the number of frame per second yo use
     * @param totalFrame defines the number of frames in total
     * @param from defines the initial value
     * @param to defines the final value
     * @param loopMode defines which loop mode you want to use (off by default)
     * @param easingFunction defines the easing function to use (linear by default)
     * @param onAnimationEnd defines the callback to call when animation end
     * @param scene defines the hosting scene
     * @returns the animatable created for this animation
     */ static CreateAndStartAnimation(name, target, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd, scene) {
        const animation = $ff91d59daa75db10$export$c35d437ae5945fcd._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
        if (!animation) return null;
        if (target.getScene) scene = target.getScene();
        if (!scene) return null;
        return scene.beginDirectAnimation(target, [
            animation
        ], 0, totalFrame, animation.loopMode !== $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT, 1.0, onAnimationEnd);
    }
    /**
     * Create and start an animation on a node and its descendants
     * @param name defines the name of the global animation that will be run on all nodes
     * @param node defines the root node where the animation will take place
     * @param directDescendantsOnly if true only direct descendants will be used, if false direct and also indirect (children of children, an so on in a recursive manner) descendants will be used
     * @param targetProperty defines property to animate
     * @param framePerSecond defines the number of frame per second to use
     * @param totalFrame defines the number of frames in total
     * @param from defines the initial value
     * @param to defines the final value
     * @param loopMode defines which loop mode you want to use (off by default)
     * @param easingFunction defines the easing function to use (linear by default)
     * @param onAnimationEnd defines the callback to call when an animation ends (will be called once per node)
     * @returns the list of animatables created for all nodes
     * @example https://www.babylonjs-playground.com/#MH0VLI
     */ static CreateAndStartHierarchyAnimation(name, node, directDescendantsOnly, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd) {
        const animation = $ff91d59daa75db10$export$c35d437ae5945fcd._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
        if (!animation) return null;
        const scene = node.getScene();
        return scene.beginDirectHierarchyAnimation(node, directDescendantsOnly, [
            animation
        ], 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
    }
    /**
     * Creates a new animation, merges it with the existing animations and starts it
     * @param name Name of the animation
     * @param node Node which contains the scene that begins the animations
     * @param targetProperty Specifies which property to animate
     * @param framePerSecond The frames per second of the animation
     * @param totalFrame The total number of frames
     * @param from The frame at the beginning of the animation
     * @param to The frame at the end of the animation
     * @param loopMode Specifies the loop mode of the animation
     * @param easingFunction (Optional) The easing function of the animation, which allow custom mathematical formulas for animations
     * @param onAnimationEnd Callback to run once the animation is complete
     * @returns Nullable animation
     */ static CreateMergeAndStartAnimation(name, node, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd) {
        const animation = $ff91d59daa75db10$export$c35d437ae5945fcd._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
        if (!animation) return null;
        node.animations.push(animation);
        return node.getScene().beginAnimation(node, 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
    }
    /** @internal */ static MakeAnimationAdditive(sourceAnimation, referenceFrameOrOptions, range, cloneOriginal = false, clonedName) {
        let options;
        if (typeof referenceFrameOrOptions === "object") options = referenceFrameOrOptions;
        else options = {
            referenceFrame: referenceFrameOrOptions ?? 0,
            range: range,
            cloneOriginalAnimation: cloneOriginal,
            clonedAnimationName: clonedName
        };
        let animation = sourceAnimation;
        if (options.cloneOriginalAnimation) {
            animation = sourceAnimation.clone();
            animation.name = options.clonedAnimationName || animation.name;
        }
        if (!animation._keys.length) return animation;
        const referenceFrame = options.referenceFrame && options.referenceFrame >= 0 ? options.referenceFrame : 0;
        let startIndex = 0;
        const firstKey = animation._keys[0];
        let endIndex = animation._keys.length - 1;
        const lastKey = animation._keys[endIndex];
        const valueStore = {
            referenceValue: firstKey.value,
            referencePosition: (0, $ha1VO.TmpVectors).Vector3[0],
            referenceQuaternion: (0, $ha1VO.TmpVectors).Quaternion[0],
            referenceScaling: (0, $ha1VO.TmpVectors).Vector3[1],
            keyPosition: (0, $ha1VO.TmpVectors).Vector3[2],
            keyQuaternion: (0, $ha1VO.TmpVectors).Quaternion[1],
            keyScaling: (0, $ha1VO.TmpVectors).Vector3[3]
        };
        let from = firstKey.frame;
        let to = lastKey.frame;
        if (options.range) {
            const rangeValue = animation.getRange(options.range);
            if (rangeValue) {
                from = rangeValue.from;
                to = rangeValue.to;
            }
        } else {
            from = options.fromFrame ?? from;
            to = options.toFrame ?? to;
        }
        if (from !== firstKey.frame) startIndex = animation.createKeyForFrame(from);
        if (to !== lastKey.frame) endIndex = animation.createKeyForFrame(to);
        // There's only one key, so use it
        if (animation._keys.length === 1) {
            const value = animation._getKeyValue(animation._keys[0]);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        } else if (referenceFrame <= firstKey.frame) {
            const value = animation._getKeyValue(firstKey.value);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        } else if (referenceFrame >= lastKey.frame) {
            const value = animation._getKeyValue(lastKey.value);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        } else {
            $ff91d59daa75db10$var$evaluateAnimationState.key = 0;
            const value = animation._interpolate(referenceFrame, $ff91d59daa75db10$var$evaluateAnimationState);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        }
        // Conjugate the quaternion
        if (animation.dataType === $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION) valueStore.referenceValue.normalize().conjugateInPlace();
        else if (animation.dataType === $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX) {
            valueStore.referenceValue.decompose(valueStore.referenceScaling, valueStore.referenceQuaternion, valueStore.referencePosition);
            valueStore.referenceQuaternion.normalize().conjugateInPlace();
        }
        let startFrame = Number.MAX_VALUE;
        const clippedKeys = options.clipKeys ? [] : null;
        // Subtract the reference value from all of the key values
        for(let index = startIndex; index <= endIndex; index++){
            let key = animation._keys[index];
            if (clippedKeys || options.cloneOriginalAnimation) {
                key = {
                    frame: key.frame,
                    value: key.value.clone ? key.value.clone() : key.value,
                    inTangent: key.inTangent,
                    outTangent: key.outTangent,
                    interpolation: key.interpolation,
                    lockedTangent: key.lockedTangent
                };
                if (clippedKeys) {
                    if (startFrame === Number.MAX_VALUE) startFrame = key.frame;
                    key.frame -= startFrame;
                    clippedKeys.push(key);
                }
            }
            // If this key was duplicated to create a frame 0 key, skip it because its value has already been updated
            if (index && animation.dataType !== $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT && key.value === firstKey.value) continue;
            switch(animation.dataType){
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                    key.value.decompose(valueStore.keyScaling, valueStore.keyQuaternion, valueStore.keyPosition);
                    valueStore.keyPosition.subtractInPlace(valueStore.referencePosition);
                    valueStore.keyScaling.divideInPlace(valueStore.referenceScaling);
                    valueStore.referenceQuaternion.multiplyToRef(valueStore.keyQuaternion, valueStore.keyQuaternion);
                    (0, $ha1VO.Matrix).ComposeToRef(valueStore.keyScaling, valueStore.keyQuaternion, valueStore.keyPosition, key.value);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                    valueStore.referenceValue.multiplyToRef(key.value, key.value);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                    key.value.subtractToRef(valueStore.referenceValue, key.value);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE:
                    key.value.width -= valueStore.referenceValue.width;
                    key.value.height -= valueStore.referenceValue.height;
                    break;
                default:
                    key.value -= valueStore.referenceValue;
            }
        }
        if (clippedKeys) animation.setKeys(clippedKeys, true);
        return animation;
    }
    /**
     * Transition property of an host to the target Value
     * @param property The property to transition
     * @param targetValue The target Value of the property
     * @param host The object where the property to animate belongs
     * @param scene Scene used to run the animation
     * @param frameRate Framerate (in frame/s) to use
     * @param transition The transition type we want to use
     * @param duration The duration of the animation, in milliseconds
     * @param onAnimationEnd Callback trigger at the end of the animation
     * @returns Nullable animation
     */ static TransitionTo(property, targetValue, host, scene, frameRate, transition, duration, onAnimationEnd = null) {
        if (duration <= 0) {
            host[property] = targetValue;
            if (onAnimationEnd) onAnimationEnd();
            return null;
        }
        const endFrame = frameRate * (duration / 1000);
        transition.setKeys([
            {
                frame: 0,
                value: host[property].clone ? host[property].clone() : host[property]
            },
            {
                frame: endFrame,
                value: targetValue
            }
        ]);
        if (!host.animations) host.animations = [];
        host.animations.push(transition);
        const animation = scene.beginAnimation(host, 0, endFrame, false);
        animation.onAnimationEnd = onAnimationEnd;
        return animation;
    }
    /**
     * Return the array of runtime animations currently using this animation
     */ get runtimeAnimations() {
        return this._runtimeAnimations;
    }
    /**
     * Specifies if any of the runtime animations are currently running
     */ get hasRunningRuntimeAnimations() {
        for (const runtimeAnimation of this._runtimeAnimations){
            if (!runtimeAnimation.isStopped()) return true;
        }
        return false;
    }
    /**
     * Initializes the animation
     * @param name Name of the animation
     * @param targetProperty Property to animate
     * @param framePerSecond The frames per second of the animation
     * @param dataType The data type of the animation
     * @param loopMode The loop mode of the animation
     * @param enableBlending Specifies if blending should be enabled
     */ constructor(/**Name of the animation */ name, /**Property to animate */ targetProperty, /**The frames per second of the animation */ framePerSecond, /**The data type of the animation */ dataType, /**The loop mode of the animation */ loopMode, /**Specifies if blending should be enabled */ enableBlending){
        this.name = name;
        this.targetProperty = targetProperty;
        this.framePerSecond = framePerSecond;
        this.dataType = dataType;
        this.loopMode = loopMode;
        this.enableBlending = enableBlending;
        /**
         * Stores the easing function of the animation
         */ this._easingFunction = null;
        /**
         * @internal Internal use only
         */ this._runtimeAnimations = new Array();
        /**
         * The set of event that will be linked to this animation
         */ this._events = new Array();
        /**
         * Stores the blending speed of the animation
         */ this.blendingSpeed = 0.01;
        /**
         * Stores the animation ranges for the animation
         */ this._ranges = {};
        this.targetPropertyPath = targetProperty.split(".");
        this.dataType = dataType;
        this.loopMode = loopMode === undefined ? $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE : loopMode;
        this.uniqueId = $ff91d59daa75db10$export$c35d437ae5945fcd._UniqueIdGenerator++;
    }
    // Methods
    /**
     * Converts the animation to a string
     * @param fullDetails support for multiple levels of logging within scene loading
     * @returns String form of the animation
     */ toString(fullDetails) {
        let ret = "Name: " + this.name + ", property: " + this.targetProperty;
        ret += ", datatype: " + [
            "Float",
            "Vector3",
            "Quaternion",
            "Matrix",
            "Color3",
            "Vector2"
        ][this.dataType];
        ret += ", nKeys: " + (this._keys ? this._keys.length : "none");
        ret += ", nRanges: " + (this._ranges ? Object.keys(this._ranges).length : "none");
        if (fullDetails) {
            ret += ", Ranges: {";
            let first = true;
            for(const name in this._ranges){
                if (first) {
                    ret += ", ";
                    first = false;
                }
                ret += name;
            }
            ret += "}";
        }
        return ret;
    }
    /**
     * Add an event to this animation
     * @param event Event to add
     */ addEvent(event) {
        this._events.push(event);
        this._events.sort((a, b)=>a.frame - b.frame);
    }
    /**
     * Remove all events found at the given frame
     * @param frame The frame to remove events from
     */ removeEvents(frame) {
        for(let index = 0; index < this._events.length; index++)if (this._events[index].frame === frame) {
            this._events.splice(index, 1);
            index--;
        }
    }
    /**
     * Retrieves all the events from the animation
     * @returns Events from the animation
     */ getEvents() {
        return this._events;
    }
    /**
     * Creates an animation range
     * @param name Name of the animation range
     * @param from Starting frame of the animation range
     * @param to Ending frame of the animation
     */ createRange(name, from, to) {
        // check name not already in use; could happen for bones after serialized
        if (!this._ranges[name]) this._ranges[name] = new (0, $ed727cbc04f22ca3$export$eeed3d1abb539eaf)(name, from, to);
    }
    /**
     * Deletes an animation range by name
     * @param name Name of the animation range to delete
     * @param deleteFrames Specifies if the key frames for the range should also be deleted (true) or not (false)
     */ deleteRange(name, deleteFrames = true) {
        const range = this._ranges[name];
        if (!range) return;
        if (deleteFrames) {
            const from = range.from;
            const to = range.to;
            // this loop MUST go high to low for multiple splices to work
            for(let key = this._keys.length - 1; key >= 0; key--)if (this._keys[key].frame >= from && this._keys[key].frame <= to) this._keys.splice(key, 1);
        }
        this._ranges[name] = null; // said much faster than 'delete this._range[name]'
    }
    /**
     * Gets the animation range by name, or null if not defined
     * @param name Name of the animation range
     * @returns Nullable animation range
     */ getRange(name) {
        return this._ranges[name];
    }
    /**
     * Gets the key frames from the animation
     * @returns The key frames of the animation
     */ getKeys() {
        return this._keys;
    }
    /**
     * Gets the highest frame of the animation
     * @returns Highest frame of the animation
     */ getHighestFrame() {
        let ret = 0;
        for(let key = 0, nKeys = this._keys.length; key < nKeys; key++)if (ret < this._keys[key].frame) ret = this._keys[key].frame;
        return ret;
    }
    /**
     * Gets the easing function of the animation
     * @returns Easing function of the animation
     */ getEasingFunction() {
        return this._easingFunction;
    }
    /**
     * Sets the easing function of the animation
     * @param easingFunction A custom mathematical formula for animation
     */ setEasingFunction(easingFunction) {
        this._easingFunction = easingFunction;
    }
    /**
     * Interpolates a scalar linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated scalar value
     */ floatInterpolateFunction(startValue, endValue, gradient) {
        return (0, $iosaP.Lerp)(startValue, endValue, gradient);
    }
    /**
     * Interpolates a scalar cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated scalar value
     */ floatInterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $iosaP.Hermite)(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a quaternion using a spherical linear interpolation
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated quaternion value
     */ quaternionInterpolateFunction(startValue, endValue, gradient) {
        return (0, $ha1VO.Quaternion).Slerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a quaternion cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation curve
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated quaternion value
     */ quaternionInterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $ha1VO.Quaternion).Hermite(startValue, outTangent, endValue, inTangent, gradient).normalize();
    }
    /**
     * Interpolates a Vector3 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns Interpolated scalar value
     */ vector3InterpolateFunction(startValue, endValue, gradient) {
        return (0, $ha1VO.Vector3).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Vector3 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns InterpolatedVector3 value
     */ vector3InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $ha1VO.Vector3).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a Vector2 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns Interpolated Vector2 value
     */ vector2InterpolateFunction(startValue, endValue, gradient) {
        return (0, $ha1VO.Vector2).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Vector2 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns Interpolated Vector2 value
     */ vector2InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $ha1VO.Vector2).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a size linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated Size value
     */ sizeInterpolateFunction(startValue, endValue, gradient) {
        return (0, $93o7r.Size).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Color3 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated Color3 value
     */ color3InterpolateFunction(startValue, endValue, gradient) {
        return (0, $7etnY.Color3).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Color3 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns interpolated value
     */ color3InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $7etnY.Color3).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a Color4 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated Color3 value
     */ color4InterpolateFunction(startValue, endValue, gradient) {
        return (0, $7etnY.Color4).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Color4 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns interpolated value
     */ color4InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $7etnY.Color4).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * @internal Internal use only
     */ _getKeyValue(value) {
        if (typeof value === "function") return value();
        return value;
    }
    /**
     * Evaluate the animation value at a given frame
     * @param currentFrame defines the frame where we want to evaluate the animation
     * @returns the animation value
     */ evaluate(currentFrame) {
        $ff91d59daa75db10$var$evaluateAnimationState.key = 0;
        return this._interpolate(currentFrame, $ff91d59daa75db10$var$evaluateAnimationState);
    }
    /**
     * @internal Internal use only
     */ _interpolate(currentFrame, state, searchClosestKeyOnly = false) {
        if (state.loopMode === $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT && state.repeatCount > 0) return state.highLimitValue.clone ? state.highLimitValue.clone() : state.highLimitValue;
        const keys = this._keys;
        const keysLength = keys.length;
        let key = state.key;
        while(key >= 0 && currentFrame < keys[key].frame)--key;
        while(key + 1 <= keysLength - 1 && currentFrame >= keys[key + 1].frame)++key;
        state.key = key;
        if (key < 0) return searchClosestKeyOnly ? undefined : this._getKeyValue(keys[0].value);
        else if (key + 1 > keysLength - 1) return searchClosestKeyOnly ? undefined : this._getKeyValue(keys[keysLength - 1].value);
        const startKey = keys[key];
        const endKey = keys[key + 1];
        if (searchClosestKeyOnly && (currentFrame === startKey.frame || currentFrame === endKey.frame)) return undefined;
        const startValue = this._getKeyValue(startKey.value);
        const endValue = this._getKeyValue(endKey.value);
        if (startKey.interpolation === 1 /* AnimationKeyInterpolation.STEP */ ) {
            if (endKey.frame > currentFrame) return startValue;
            else return endValue;
        }
        const useTangent = startKey.outTangent !== undefined && endKey.inTangent !== undefined;
        const frameDelta = endKey.frame - startKey.frame;
        // gradient : percent of currentFrame between the frame inf and the frame sup
        let gradient = (currentFrame - startKey.frame) / frameDelta;
        // check for easingFunction and correction of gradient
        const easingFunction = startKey.easingFunction || this.getEasingFunction();
        if (easingFunction !== null) gradient = easingFunction.ease(gradient);
        switch(this.dataType){
            // Float
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT:
                {
                    const floatValue = useTangent ? this.floatInterpolateFunctionWithTangents(startValue, startKey.outTangent * frameDelta, endValue, endKey.inTangent * frameDelta, gradient) : this.floatInterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return floatValue;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return (state.offsetValue ?? 0) * state.repeatCount + floatValue;
                    }
                    break;
                }
            // Quaternion
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                {
                    const quatValue = useTangent ? this.quaternionInterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.quaternionInterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return quatValue;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return quatValue.addInPlace((state.offsetValue || $ff91d59daa75db10$export$519770a712ff637a).scale(state.repeatCount));
                    }
                    return quatValue;
                }
            // Vector3
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                {
                    const vec3Value = useTangent ? this.vector3InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.vector3InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return vec3Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return vec3Value.add((state.offsetValue || $ff91d59daa75db10$export$499344e023610249).scale(state.repeatCount));
                    }
                    break;
                }
            // Vector2
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2:
                {
                    const vec2Value = useTangent ? this.vector2InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.vector2InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return vec2Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return vec2Value.add((state.offsetValue || $ff91d59daa75db10$export$6d83b9c8972825ff).scale(state.repeatCount));
                    }
                    break;
                }
            // Size
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE:
                switch(state.loopMode){
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                        return this.sizeInterpolateFunction(startValue, endValue, gradient);
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                        return this.sizeInterpolateFunction(startValue, endValue, gradient).add((state.offsetValue || $ff91d59daa75db10$export$1246757db6a7aaea).scale(state.repeatCount));
                }
                break;
            // Color3
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                {
                    const color3Value = useTangent ? this.color3InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.color3InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return color3Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return color3Value.add((state.offsetValue || $ff91d59daa75db10$export$d98e5cb9b7a6dc07).scale(state.repeatCount));
                    }
                    break;
                }
            // Color4
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                {
                    const color4Value = useTangent ? this.color4InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.color4InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return color4Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return color4Value.add((state.offsetValue || $ff91d59daa75db10$export$6e4972fa3772cc35).scale(state.repeatCount));
                    }
                    break;
                }
            // Matrix
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                switch(state.loopMode){
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                        if ($ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatricesInterpolation) return this.matrixInterpolateFunction(startValue, endValue, gradient, state.workValue);
                        return startValue;
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                        return startValue;
                }
                break;
        }
        return 0;
    }
    /**
     * Defines the function to use to interpolate matrices
     * @param startValue defines the start matrix
     * @param endValue defines the end matrix
     * @param gradient defines the gradient between both matrices
     * @param result defines an optional target matrix where to store the interpolation
     * @returns the interpolated matrix
     */ matrixInterpolateFunction(startValue, endValue, gradient, result) {
        if ($ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatrixDecomposeForInterpolation) {
            if (result) {
                (0, $ha1VO.Matrix).DecomposeLerpToRef(startValue, endValue, gradient, result);
                return result;
            }
            return (0, $ha1VO.Matrix).DecomposeLerp(startValue, endValue, gradient);
        }
        if (result) {
            (0, $ha1VO.Matrix).LerpToRef(startValue, endValue, gradient, result);
            return result;
        }
        return (0, $ha1VO.Matrix).Lerp(startValue, endValue, gradient);
    }
    /**
     * Makes a copy of the animation
     * @returns Cloned animation
     */ clone() {
        const clone = new $ff91d59daa75db10$export$c35d437ae5945fcd(this.name, this.targetPropertyPath.join("."), this.framePerSecond, this.dataType, this.loopMode);
        clone.enableBlending = this.enableBlending;
        clone.blendingSpeed = this.blendingSpeed;
        if (this._keys) clone.setKeys(this._keys);
        if (this._ranges) {
            clone._ranges = {};
            for(const name in this._ranges){
                const range = this._ranges[name];
                if (!range) continue;
                clone._ranges[name] = range.clone();
            }
        }
        return clone;
    }
    /**
     * Sets the key frames of the animation
     * @param values The animation key frames to set
     * @param dontClone Whether to clone the keys or not (default is false, so the array of keys is cloned)
     */ setKeys(values, dontClone = false) {
        this._keys = !dontClone ? values.slice(0) : values;
    }
    /**
     * Creates a key for the frame passed as a parameter and adds it to the animation IF a key doesn't already exist for that frame
     * @param frame Frame number
     * @returns The key index if the key was added or the index of the pre existing key if the frame passed as parameter already has a corresponding key
     */ createKeyForFrame(frame) {
        // Find the key corresponding to frame
        $ff91d59daa75db10$var$evaluateAnimationState.key = 0;
        const value = this._interpolate(frame, $ff91d59daa75db10$var$evaluateAnimationState, true);
        if (!value) // A key corresponding to this frame already exists
        return this._keys[$ff91d59daa75db10$var$evaluateAnimationState.key].frame === frame ? $ff91d59daa75db10$var$evaluateAnimationState.key : $ff91d59daa75db10$var$evaluateAnimationState.key + 1;
        // The frame is between two keys, so create a new key
        const newKey = {
            frame: frame,
            value: value.clone ? value.clone() : value
        };
        this._keys.splice($ff91d59daa75db10$var$evaluateAnimationState.key + 1, 0, newKey);
        return $ff91d59daa75db10$var$evaluateAnimationState.key + 1;
    }
    /**
     * Serializes the animation to an object
     * @returns Serialized object
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.property = this.targetProperty;
        serializationObject.framePerSecond = this.framePerSecond;
        serializationObject.dataType = this.dataType;
        serializationObject.loopBehavior = this.loopMode;
        serializationObject.enableBlending = this.enableBlending;
        serializationObject.blendingSpeed = this.blendingSpeed;
        const dataType = this.dataType;
        serializationObject.keys = [];
        const keys = this.getKeys();
        for(let index = 0; index < keys.length; index++){
            const animationKey = keys[index];
            const key = {};
            key.frame = animationKey.frame;
            switch(dataType){
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT:
                    key.values = [
                        animationKey.value
                    ];
                    if (animationKey.inTangent !== undefined) key.values.push(animationKey.inTangent);
                    if (animationKey.outTangent !== undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.outTangent);
                    }
                    if (animationKey.interpolation !== undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        if (animationKey.outTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.interpolation);
                    }
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                    key.values = animationKey.value.asArray();
                    if (animationKey.inTangent != undefined) key.values.push(animationKey.inTangent.asArray());
                    if (animationKey.outTangent != undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.outTangent.asArray());
                    }
                    if (animationKey.interpolation !== undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        if (animationKey.outTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.interpolation);
                    }
                    break;
            }
            serializationObject.keys.push(key);
        }
        serializationObject.ranges = [];
        for(const name in this._ranges){
            const source = this._ranges[name];
            if (!source) continue;
            const range = {};
            range.name = name;
            range.from = source.from;
            range.to = source.to;
            serializationObject.ranges.push(range);
        }
        return serializationObject;
    }
    /**
     * @internal
     */ static _UniversalLerp(left, right, amount) {
        const constructor = left.constructor;
        if (constructor.Lerp) // Lerp supported
        return constructor.Lerp(left, right, amount);
        else if (constructor.Slerp) // Slerp supported
        return constructor.Slerp(left, right, amount);
        else if (left.toFixed) // Number
        return left * (1.0 - amount) + amount * right;
        else // Blending not supported
        return right;
    }
    /**
     * Parses an animation object and creates an animation
     * @param parsedAnimation Parsed animation object
     * @returns Animation object
     */ static Parse(parsedAnimation) {
        const animation = new $ff91d59daa75db10$export$c35d437ae5945fcd(parsedAnimation.name, parsedAnimation.property, parsedAnimation.framePerSecond, parsedAnimation.dataType, parsedAnimation.loopBehavior);
        const dataType = parsedAnimation.dataType;
        const keys = [];
        let data;
        let index;
        if (parsedAnimation.enableBlending) animation.enableBlending = parsedAnimation.enableBlending;
        if (parsedAnimation.blendingSpeed) animation.blendingSpeed = parsedAnimation.blendingSpeed;
        for(index = 0; index < parsedAnimation.keys.length; index++){
            const key = parsedAnimation.keys[index];
            let inTangent = undefined;
            let outTangent = undefined;
            let interpolation = undefined;
            switch(dataType){
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT:
                    data = key.values[0];
                    if (key.values.length >= 2) inTangent = key.values[1];
                    if (key.values.length >= 3) outTangent = key.values[2];
                    if (key.values.length >= 4) interpolation = key.values[3];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                    data = (0, $ha1VO.Quaternion).FromArray(key.values);
                    if (key.values.length >= 8) {
                        const _inTangent = (0, $ha1VO.Quaternion).FromArray(key.values.slice(4, 8));
                        if (!_inTangent.equals((0, $ha1VO.Quaternion).Zero())) inTangent = _inTangent;
                    }
                    if (key.values.length >= 12) {
                        const _outTangent = (0, $ha1VO.Quaternion).FromArray(key.values.slice(8, 12));
                        if (!_outTangent.equals((0, $ha1VO.Quaternion).Zero())) outTangent = _outTangent;
                    }
                    if (key.values.length >= 13) interpolation = key.values[12];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                    data = (0, $ha1VO.Matrix).FromArray(key.values);
                    if (key.values.length >= 17) interpolation = key.values[16];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                    data = (0, $7etnY.Color3).FromArray(key.values);
                    if (key.values[3]) inTangent = (0, $7etnY.Color3).FromArray(key.values[3]);
                    if (key.values[4]) outTangent = (0, $7etnY.Color3).FromArray(key.values[4]);
                    if (key.values[5]) interpolation = key.values[5];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                    data = (0, $7etnY.Color4).FromArray(key.values);
                    if (key.values[4]) inTangent = (0, $7etnY.Color4).FromArray(key.values[4]);
                    if (key.values[5]) outTangent = (0, $7etnY.Color4).FromArray(key.values[5]);
                    if (key.values[6]) interpolation = (0, $7etnY.Color4).FromArray(key.values[6]);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                default:
                    data = (0, $ha1VO.Vector3).FromArray(key.values);
                    if (key.values[3]) inTangent = (0, $ha1VO.Vector3).FromArray(key.values[3]);
                    if (key.values[4]) outTangent = (0, $ha1VO.Vector3).FromArray(key.values[4]);
                    if (key.values[5]) interpolation = key.values[5];
                    break;
            }
            const keyData = {};
            keyData.frame = key.frame;
            keyData.value = data;
            if (inTangent != undefined) keyData.inTangent = inTangent;
            if (outTangent != undefined) keyData.outTangent = outTangent;
            if (interpolation != undefined) keyData.interpolation = interpolation;
            keys.push(keyData);
        }
        animation.setKeys(keys);
        if (parsedAnimation.ranges) for(index = 0; index < parsedAnimation.ranges.length; index++){
            data = parsedAnimation.ranges[index];
            animation.createRange(data.name, data.from, data.to);
        }
        return animation;
    }
    /**
     * Appends the serialized animations from the source animations
     * @param source Source containing the animations
     * @param destination Target to store the animations
     */ static AppendSerializedAnimations(source, destination) {
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(source, destination);
    }
    /**
     * Creates a new animation or an array of animations from a snippet saved in a remote file
     * @param name defines the name of the animation to create (can be null or empty to use the one from the json data)
     * @param url defines the url to load from
     * @returns a promise that will resolve to the new animation or an array of animations
     */ static ParseFromFileAsync(name, url) {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        let serializationObject = JSON.parse(request.responseText);
                        if (serializationObject.animations) serializationObject = serializationObject.animations;
                        if (serializationObject.length) {
                            const output = [];
                            for (const serializedAnimation of serializationObject)output.push(this.Parse(serializedAnimation));
                            resolve(output);
                        } else {
                            const output = this.Parse(serializationObject);
                            if (name) output.name = name;
                            resolve(output);
                        }
                    } else reject("Unable to load the animation");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    /**
     * Creates an animation or an array of animations from a snippet saved by the Inspector
     * @param snippetId defines the snippet to load
     * @returns a promise that will resolve to the new animation or a new array of animations
     */ static ParseFromSnippetAsync(snippetId) {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        if (snippet.animations) {
                            const serializationObject = JSON.parse(snippet.animations);
                            const outputs = [];
                            for (const serializedAnimation of serializationObject.animations){
                                const output = this.Parse(serializedAnimation);
                                output.snippetId = snippetId;
                                outputs.push(output);
                            }
                            resolve(outputs);
                        } else {
                            const serializationObject = JSON.parse(snippet.animation);
                            const output = this.Parse(serializationObject);
                            output.snippetId = snippetId;
                            resolve(output);
                        }
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
$ff91d59daa75db10$export$c35d437ae5945fcd._UniqueIdGenerator = 0;
/**
 * Use matrix interpolation instead of using direct key value when animating matrices
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatricesInterpolation = false;
/**
 * When matrix interpolation is enabled, this boolean forces the system to use Matrix.DecomposeLerp instead of Matrix.Lerp. Interpolation is more precise but slower
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatrixDecomposeForInterpolation = true;
/** Define the Url to load snippets */ $ff91d59daa75db10$export$c35d437ae5945fcd.SnippetUrl = `https://snippet.babylonjs.com`;
// Statics
/**
 * Float animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT = 0;
/**
 * Vector3 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3 = 1;
/**
 * Quaternion animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION = 2;
/**
 * Matrix animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX = 3;
/**
 * Color3 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3 = 4;
/**
 * Color3 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4 = 7;
/**
 * Vector2 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2 = 5;
/**
 * Size animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE = 6;
/**
 * Relative Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE = 0;
/**
 * Cycle Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE = 1;
/**
 * Constant Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT = 2;
/**
 * Yoyo Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO = 4;
/**
 * Relative Loop Mode (add to current value of animated object, unlike ANIMATIONLOOPMODE_RELATIVE)
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT = 5;
/**
 * Creates an animation or an array of animations from a snippet saved by the Inspector
 * @deprecated Please use ParseFromSnippetAsync instead
 * @param snippetId defines the snippet to load
 * @returns a promise that will resolve to the new animation or a new array of animations
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.CreateFromSnippetAsync = $ff91d59daa75db10$export$c35d437ae5945fcd.ParseFromSnippetAsync;
(0, $8DoUR.RegisterClass)("BABYLON.Animation", $ff91d59daa75db10$export$c35d437ae5945fcd);
(0, $021dcb6a570ae9c1$export$85c928794f8d04d4)._AnimationRangeFactory = (name, from, to)=>new (0, $ed727cbc04f22ca3$export$eeed3d1abb539eaf)(name, from, to);


class $49d72768d87ebb9d$export$ce4961f17ea23fea {
    /**
     * Gets the current frame of the runtime animation
     */ get currentFrame() {
        return this._currentFrame;
    }
    /**
     * Gets the weight of the runtime animation
     */ get weight() {
        return this._weight;
    }
    /**
     * Gets the current value of the runtime animation
     */ get currentValue() {
        return this._currentValue;
    }
    /**
     * Gets or sets the target path of the runtime animation
     */ get targetPath() {
        return this._targetPath;
    }
    /**
     * Gets the actual target of the runtime animation
     */ get target() {
        return this._currentActiveTarget;
    }
    /**
     * Gets the additive state of the runtime animation
     */ get isAdditive() {
        return this._host && this._host.isAdditive;
    }
    /**
     * Create a new RuntimeAnimation object
     * @param target defines the target of the animation
     * @param animation defines the source animation object
     * @param scene defines the hosting scene
     * @param host defines the initiating Animatable
     */ constructor(target, animation, scene, host){
        this._events = new Array();
        /**
         * The current frame of the runtime animation
         */ this._currentFrame = 0;
        /**
         * The original value of the runtime animation
         */ this._originalValue = new Array();
        /**
         * The original blend value of the runtime animation
         */ this._originalBlendValue = null;
        /**
         * The offsets cache of the runtime animation
         */ this._offsetsCache = {};
        /**
         * The high limits cache of the runtime animation
         */ this._highLimitsCache = {};
        /**
         * Specifies if the runtime animation has been stopped
         */ this._stopped = false;
        /**
         * The blending factor of the runtime animation
         */ this._blendingFactor = 0;
        /**
         * The current value of the runtime animation
         */ this._currentValue = null;
        this._currentActiveTarget = null;
        this._directTarget = null;
        /**
         * The target path of the runtime animation
         */ this._targetPath = "";
        /**
         * The weight of the runtime animation
         */ this._weight = 1.0;
        /**
         * The absolute frame offset of the runtime animation
         */ this._absoluteFrameOffset = 0;
        /**
         * The previous elapsed time (since start of animation) of the runtime animation
         */ this._previousElapsedTime = 0;
        this._yoyoDirection = 1;
        /**
         * The previous absolute frame of the runtime animation (meaning, without taking into account the from/to values, only the elapsed time and the fps)
         */ this._previousAbsoluteFrame = 0;
        this._targetIsArray = false;
        this._animation = animation;
        this._target = target;
        this._scene = scene;
        this._host = host;
        this._activeTargets = [];
        animation._runtimeAnimations.push(this);
        // State
        this._animationState = {
            key: 0,
            repeatCount: 0,
            loopMode: this._getCorrectLoopMode()
        };
        if (this._animation.dataType === (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_MATRIX) this._animationState.workValue = (0, $ha1VO.Matrix).Zero();
        // Limits
        this._keys = this._animation.getKeys();
        this._minFrame = this._keys[0].frame;
        this._maxFrame = this._keys[this._keys.length - 1].frame;
        this._minValue = this._keys[0].value;
        this._maxValue = this._keys[this._keys.length - 1].value;
        // Add a start key at frame 0 if missing
        if (this._minFrame !== 0) {
            const newKey = {
                frame: 0,
                value: this._minValue
            };
            this._keys.splice(0, 0, newKey);
        }
        // Check data
        if (this._target instanceof Array) {
            let index = 0;
            for (const target of this._target){
                this._preparePath(target, index);
                this._getOriginalValues(index);
                index++;
            }
            this._targetIsArray = true;
        } else {
            this._preparePath(this._target);
            this._getOriginalValues();
            this._targetIsArray = false;
            this._directTarget = this._activeTargets[0];
        }
        // Cloning events locally
        const events = animation.getEvents();
        if (events && events.length > 0) events.forEach((e)=>{
            this._events.push(e._clone());
        });
        this._enableBlending = target && target.animationPropertiesOverride ? target.animationPropertiesOverride.enableBlending : this._animation.enableBlending;
    }
    _preparePath(target, targetIndex = 0) {
        const targetPropertyPath = this._animation.targetPropertyPath;
        if (targetPropertyPath.length > 1) {
            let property = target;
            for(let index = 0; index < targetPropertyPath.length - 1; index++){
                const name = targetPropertyPath[index];
                property = property[name];
                if (property === undefined) throw new Error(`Invalid property (${name}) in property path (${targetPropertyPath.join(".")})`);
            }
            this._targetPath = targetPropertyPath[targetPropertyPath.length - 1];
            this._activeTargets[targetIndex] = property;
        } else {
            this._targetPath = targetPropertyPath[0];
            this._activeTargets[targetIndex] = target;
        }
        if (this._activeTargets[targetIndex][this._targetPath] === undefined) throw new Error(`Invalid property (${this._targetPath}) in property path (${targetPropertyPath.join(".")})`);
    }
    /**
     * Gets the animation from the runtime animation
     */ get animation() {
        return this._animation;
    }
    /**
     * Resets the runtime animation to the beginning
     * @param restoreOriginal defines whether to restore the target property to the original value
     */ reset(restoreOriginal = false) {
        if (restoreOriginal) {
            if (this._target instanceof Array) {
                let index = 0;
                for (const target of this._target){
                    if (this._originalValue[index] !== undefined) this._setValue(target, this._activeTargets[index], this._originalValue[index], -1, index);
                    index++;
                }
            } else if (this._originalValue[0] !== undefined) this._setValue(this._target, this._directTarget, this._originalValue[0], -1, 0);
        }
        this._offsetsCache = {};
        this._highLimitsCache = {};
        this._currentFrame = 0;
        this._blendingFactor = 0;
        // Events
        for(let index = 0; index < this._events.length; index++)this._events[index].isDone = false;
    }
    /**
     * Specifies if the runtime animation is stopped
     * @returns Boolean specifying if the runtime animation is stopped
     */ isStopped() {
        return this._stopped;
    }
    /**
     * Disposes of the runtime animation
     */ dispose() {
        const index = this._animation.runtimeAnimations.indexOf(this);
        if (index > -1) this._animation.runtimeAnimations.splice(index, 1);
    }
    /**
     * Apply the interpolated value to the target
     * @param currentValue defines the value computed by the animation
     * @param weight defines the weight to apply to this value (Defaults to 1.0)
     */ setValue(currentValue, weight) {
        if (this._targetIsArray) {
            for(let index = 0; index < this._target.length; index++){
                const target = this._target[index];
                this._setValue(target, this._activeTargets[index], currentValue, weight, index);
            }
            return;
        }
        this._setValue(this._target, this._directTarget, currentValue, weight, 0);
    }
    _getOriginalValues(targetIndex = 0) {
        let originalValue;
        const target = this._activeTargets[targetIndex];
        if (target.getLocalMatrix && this._targetPath === "_matrix") // For bones
        originalValue = target.getLocalMatrix();
        else originalValue = target[this._targetPath];
        if (originalValue && originalValue.clone) this._originalValue[targetIndex] = originalValue.clone();
        else this._originalValue[targetIndex] = originalValue;
    }
    _registerTargetForLateAnimationBinding(runtimeAnimation, originalValue) {
        const target = runtimeAnimation.target;
        this._scene._registeredForLateAnimationBindings.pushNoDuplicate(target);
        if (!target._lateAnimationHolders) target._lateAnimationHolders = {};
        if (!target._lateAnimationHolders[runtimeAnimation.targetPath]) target._lateAnimationHolders[runtimeAnimation.targetPath] = {
            totalWeight: 0,
            totalAdditiveWeight: 0,
            animations: [],
            additiveAnimations: [],
            originalValue: originalValue
        };
        if (runtimeAnimation.isAdditive) {
            target._lateAnimationHolders[runtimeAnimation.targetPath].additiveAnimations.push(runtimeAnimation);
            target._lateAnimationHolders[runtimeAnimation.targetPath].totalAdditiveWeight += runtimeAnimation.weight;
        } else {
            target._lateAnimationHolders[runtimeAnimation.targetPath].animations.push(runtimeAnimation);
            target._lateAnimationHolders[runtimeAnimation.targetPath].totalWeight += runtimeAnimation.weight;
        }
    }
    _setValue(target, destination, currentValue, weight, targetIndex) {
        // Set value
        this._currentActiveTarget = destination;
        this._weight = weight;
        if (this._enableBlending && this._blendingFactor <= 1.0) {
            if (!this._originalBlendValue) {
                const originalValue = destination[this._targetPath];
                if (originalValue.clone) this._originalBlendValue = originalValue.clone();
                else this._originalBlendValue = originalValue;
            }
            if (this._originalBlendValue.m) {
                // Matrix
                if ((0, $ff91d59daa75db10$export$c35d437ae5945fcd).AllowMatrixDecomposeForInterpolation) {
                    if (this._currentValue) (0, $ha1VO.Matrix).DecomposeLerpToRef(this._originalBlendValue, currentValue, this._blendingFactor, this._currentValue);
                    else this._currentValue = (0, $ha1VO.Matrix).DecomposeLerp(this._originalBlendValue, currentValue, this._blendingFactor);
                } else if (this._currentValue) (0, $ha1VO.Matrix).LerpToRef(this._originalBlendValue, currentValue, this._blendingFactor, this._currentValue);
                else this._currentValue = (0, $ha1VO.Matrix).Lerp(this._originalBlendValue, currentValue, this._blendingFactor);
            } else this._currentValue = (0, $ff91d59daa75db10$export$c35d437ae5945fcd)._UniversalLerp(this._originalBlendValue, currentValue, this._blendingFactor);
            const blendingSpeed = target && target.animationPropertiesOverride ? target.animationPropertiesOverride.blendingSpeed : this._animation.blendingSpeed;
            this._blendingFactor += blendingSpeed;
        } else {
            if (!this._currentValue) {
                if (currentValue?.clone) this._currentValue = currentValue.clone();
                else this._currentValue = currentValue;
            } else if (this._currentValue.copyFrom) this._currentValue.copyFrom(currentValue);
            else this._currentValue = currentValue;
        }
        if (weight !== -1) this._registerTargetForLateAnimationBinding(this, this._originalValue[targetIndex]);
        else if (this._animationState.loopMode === (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT) {
            if (this._currentValue.addToRef) this._currentValue.addToRef(this._originalValue[targetIndex], destination[this._targetPath]);
            else destination[this._targetPath] = this._originalValue[targetIndex] + this._currentValue;
        } else destination[this._targetPath] = this._currentValue;
        if (target.markAsDirty) target.markAsDirty(this._animation.targetProperty);
    }
    /**
     * Gets the loop pmode of the runtime animation
     * @returns Loop Mode
     */ _getCorrectLoopMode() {
        if (this._target && this._target.animationPropertiesOverride) return this._target.animationPropertiesOverride.loopMode;
        return this._animation.loopMode;
    }
    /**
     * Move the current animation to a given frame
     * @param frame defines the frame to move to
     * @param weight defines the weight to apply to the animation (-1.0 by default)
     */ goToFrame(frame, weight = -1) {
        const keys = this._animation.getKeys();
        if (frame < keys[0].frame) frame = keys[0].frame;
        else if (frame > keys[keys.length - 1].frame) frame = keys[keys.length - 1].frame;
        // Need to reset animation events
        const events = this._events;
        if (events.length) {
            for(let index = 0; index < events.length; index++)if (!events[index].onlyOnce) // reset events in the future
            events[index].isDone = events[index].frame < frame;
        }
        this._currentFrame = frame;
        const currentValue = this._animation._interpolate(frame, this._animationState);
        this.setValue(currentValue, weight);
    }
    /**
     * @internal Internal use only
     */ _prepareForSpeedRatioChange(newSpeedRatio) {
        const newAbsoluteFrame = this._previousElapsedTime * (this._animation.framePerSecond * newSpeedRatio) / 1000.0;
        this._absoluteFrameOffset = this._previousAbsoluteFrame - newAbsoluteFrame;
    }
    /**
     * Execute the current animation
     * @param elapsedTimeSinceAnimationStart defines the elapsed time (in milliseconds) since the animation was started
     * @param from defines the lower frame of the animation range
     * @param to defines the upper frame of the animation range
     * @param loop defines if the current animation must loop
     * @param speedRatio defines the current speed ratio
     * @param weight defines the weight of the animation (default is -1 so no weight)
     * @returns a boolean indicating if the animation is running
     */ animate(elapsedTimeSinceAnimationStart, from, to, loop, speedRatio, weight = -1) {
        const animation = this._animation;
        const targetPropertyPath = animation.targetPropertyPath;
        if (!targetPropertyPath || targetPropertyPath.length < 1) {
            this._stopped = true;
            return false;
        }
        let returnValue = true;
        // Check limits
        if (from < this._minFrame || from > this._maxFrame) from = this._minFrame;
        if (to < this._minFrame || to > this._maxFrame) to = this._maxFrame;
        const frameRange = to - from;
        let offsetValue;
        // Compute the frame according to the elapsed time and the fps of the animation ("from" and "to" are not factored in!)
        let absoluteFrame = elapsedTimeSinceAnimationStart * (animation.framePerSecond * speedRatio) / 1000.0 + this._absoluteFrameOffset;
        let highLimitValue = 0;
        // Apply the yoyo function if required
        let yoyoLoop = false;
        const yoyoMode = loop && this._animationState.loopMode === (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONLOOPMODE_YOYO;
        if (yoyoMode) {
            const position = (absoluteFrame - from) / frameRange;
            // Apply the yoyo curve
            const sin = Math.sin(position * Math.PI);
            const yoyoPosition = Math.abs(sin);
            // Map the yoyo position back to the range
            absoluteFrame = yoyoPosition * frameRange + from;
            const direction = sin >= 0 ? 1 : -1;
            if (this._yoyoDirection !== direction) yoyoLoop = true;
            this._yoyoDirection = direction;
        }
        this._previousElapsedTime = elapsedTimeSinceAnimationStart;
        this._previousAbsoluteFrame = absoluteFrame;
        if (!loop && to >= from && (absoluteFrame >= frameRange && speedRatio > 0 || absoluteFrame <= 0 && speedRatio < 0)) {
            // If we are out of range and not looping get back to caller
            returnValue = false;
            highLimitValue = animation._getKeyValue(this._maxValue);
        } else if (!loop && from >= to && (absoluteFrame <= frameRange && speedRatio < 0 || absoluteFrame >= 0 && speedRatio > 0)) {
            returnValue = false;
            highLimitValue = animation._getKeyValue(this._minValue);
        } else if (this._animationState.loopMode !== (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONLOOPMODE_CYCLE) {
            const keyOffset = to.toString() + from.toString();
            if (!this._offsetsCache[keyOffset]) {
                this._animationState.repeatCount = 0;
                this._animationState.loopMode = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONLOOPMODE_CYCLE; // force a specific codepath in animation._interpolate()!
                const fromValue = animation._interpolate(from, this._animationState);
                const toValue = animation._interpolate(to, this._animationState);
                this._animationState.loopMode = this._getCorrectLoopMode();
                switch(animation.dataType){
                    // Float
                    case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_FLOAT:
                        this._offsetsCache[keyOffset] = toValue - fromValue;
                        break;
                    // Quaternion
                    case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_QUATERNION:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Vector3
                    case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_VECTOR3:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Vector2
                    case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_VECTOR2:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Size
                    case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_SIZE:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Color3
                    case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_COLOR3:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    default:
                        break;
                }
                this._highLimitsCache[keyOffset] = toValue;
            }
            highLimitValue = this._highLimitsCache[keyOffset];
            offsetValue = this._offsetsCache[keyOffset];
        }
        if (offsetValue === undefined) switch(animation.dataType){
            // Float
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_FLOAT:
                offsetValue = 0;
                break;
            // Quaternion
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_QUATERNION:
                offsetValue = (0, $ff91d59daa75db10$export$519770a712ff637a);
                break;
            // Vector3
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_VECTOR3:
                offsetValue = (0, $ff91d59daa75db10$export$499344e023610249);
                break;
            // Vector2
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_VECTOR2:
                offsetValue = (0, $ff91d59daa75db10$export$6d83b9c8972825ff);
                break;
            // Size
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_SIZE:
                offsetValue = (0, $ff91d59daa75db10$export$1246757db6a7aaea);
                break;
            // Color3
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_COLOR3:
                offsetValue = (0, $ff91d59daa75db10$export$d98e5cb9b7a6dc07);
                break;
            case (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_COLOR4:
                offsetValue = (0, $ff91d59daa75db10$export$6e4972fa3772cc35);
                break;
        }
        // Compute value
        let currentFrame;
        if (this._host && this._host.syncRoot) {
            // If we must sync with an animatable, calculate the current frame based on the frame of the root animatable
            const syncRoot = this._host.syncRoot;
            const hostNormalizedFrame = (syncRoot.masterFrame - syncRoot.fromFrame) / (syncRoot.toFrame - syncRoot.fromFrame);
            currentFrame = from + frameRange * hostNormalizedFrame;
        } else if (absoluteFrame > 0 && from > to || absoluteFrame < 0 && from < to) currentFrame = returnValue && frameRange !== 0 ? to + absoluteFrame % frameRange : from;
        else currentFrame = returnValue && frameRange !== 0 ? from + absoluteFrame % frameRange : to;
        const events = this._events;
        // Reset event/state if looping
        if (!yoyoMode && (speedRatio > 0 && this.currentFrame > currentFrame || speedRatio < 0 && this.currentFrame < currentFrame) || yoyoMode && yoyoLoop) {
            this._onLoop();
            // Need to reset animation events
            for(let index = 0; index < events.length; index++)if (!events[index].onlyOnce) // reset event, the animation is looping
            events[index].isDone = false;
            this._animationState.key = speedRatio > 0 ? 0 : animation.getKeys().length - 1;
        }
        this._currentFrame = currentFrame;
        this._animationState.repeatCount = frameRange === 0 ? 0 : absoluteFrame / frameRange >> 0;
        this._animationState.highLimitValue = highLimitValue;
        this._animationState.offsetValue = offsetValue;
        const currentValue = animation._interpolate(currentFrame, this._animationState);
        // Set value
        this.setValue(currentValue, weight);
        // Check events
        if (events.length) {
            for(let index = 0; index < events.length; index++)// Make sure current frame has passed event frame and that event frame is within the current range
            // Also, handle both forward and reverse animations
            if (frameRange >= 0 && currentFrame >= events[index].frame && events[index].frame >= from || frameRange < 0 && currentFrame <= events[index].frame && events[index].frame <= from) {
                const event = events[index];
                if (!event.isDone) {
                    // If event should be done only once, remove it.
                    if (event.onlyOnce) {
                        events.splice(index, 1);
                        index--;
                    }
                    event.isDone = true;
                    event.action(currentFrame);
                } // Don't do anything if the event has already been done.
            }
        }
        if (!returnValue) this._stopped = true;
        return returnValue;
    }
}




var $blHSI = parcelRequire("blHSI");

var $ha1VO = parcelRequire("ha1VO");
class $de573fe9da9bea6a$export$8d0d04e6da868f4 {
    /**
     * Gets the root Animatable used to synchronize and normalize animations
     */ get syncRoot() {
        return this._syncRoot;
    }
    /**
     * Gets the current frame of the first RuntimeAnimation
     * Used to synchronize Animatables
     */ get masterFrame() {
        if (this._runtimeAnimations.length === 0) return 0;
        return this._runtimeAnimations[0].currentFrame;
    }
    /**
     * Gets or sets the animatable weight (-1.0 by default meaning not weighted)
     */ get weight() {
        return this._weight;
    }
    set weight(value) {
        if (value === -1) {
            // -1 is ok and means no weight
            this._weight = -1;
            return;
        }
        // Else weight must be in [0, 1] range
        this._weight = Math.min(Math.max(value, 0), 1.0);
    }
    /**
     * Gets or sets the speed ratio to apply to the animatable (1.0 by default)
     */ get speedRatio() {
        return this._speedRatio;
    }
    set speedRatio(value) {
        for(let index = 0; index < this._runtimeAnimations.length; index++){
            const animation = this._runtimeAnimations[index];
            animation._prepareForSpeedRatioChange(value);
        }
        this._speedRatio = value;
        // Resync _manualJumpDelay in case goToFrame was called before speedRatio was set.
        if (this._goToFrame !== null) this.goToFrame(this._goToFrame);
    }
    /**
     * Gets the elapsed time since the animatable started in milliseconds
     */ get elapsedTime() {
        return this._localDelayOffset === null ? 0 : this._scene._animationTime - this._localDelayOffset;
    }
    /**
     * Creates a new Animatable
     * @param scene defines the hosting scene
     * @param target defines the target object
     * @param fromFrame defines the starting frame number (default is 0)
     * @param toFrame defines the ending frame number (default is 100)
     * @param loopAnimation defines if the animation must loop (default is false)
     * @param speedRatio defines the factor to apply to animation speed (default is 1)
     * @param onAnimationEnd defines a callback to call when animation ends if it is not looping
     * @param animations defines a group of animation to add to the new Animatable
     * @param onAnimationLoop defines a callback to call when animation loops
     * @param isAdditive defines whether the animation should be evaluated additively
     * @param playOrder defines the order in which this animatable should be processed in the list of active animatables (default: 0)
     */ constructor(scene, /** defines the target object */ target, /** [0] defines the starting frame number (default is 0) */ fromFrame = 0, /** [100] defines the ending frame number (default is 100) */ toFrame = 100, /** [false] defines if the animation must loop (default is false)  */ loopAnimation = false, speedRatio = 1.0, /** defines a callback to call when animation ends if it is not looping */ onAnimationEnd, animations, /** defines a callback to call when animation loops */ onAnimationLoop, /** [false] defines whether the animation should be evaluated additively */ isAdditive = false, /** [0] defines the order in which this animatable should be processed in the list of active animatables (default: 0) */ playOrder = 0){
        this.target = target;
        this.fromFrame = fromFrame;
        this.toFrame = toFrame;
        this.loopAnimation = loopAnimation;
        this.onAnimationEnd = onAnimationEnd;
        this.onAnimationLoop = onAnimationLoop;
        this.isAdditive = isAdditive;
        this.playOrder = playOrder;
        this._localDelayOffset = null;
        this._pausedDelay = null;
        this._manualJumpDelay = null;
        /** @hidden */ this._runtimeAnimations = new Array();
        this._paused = false;
        this._speedRatio = 1;
        this._weight = -1;
        this._syncRoot = null;
        this._frameToSyncFromJump = null;
        this._goToFrame = null;
        /**
         * Gets or sets a boolean indicating if the animatable must be disposed and removed at the end of the animation.
         * This will only apply for non looping animation (default is true)
         */ this.disposeOnEnd = true;
        /**
         * Gets a boolean indicating if the animation has started
         */ this.animationStarted = false;
        /**
         * Observer raised when the animation ends
         */ this.onAnimationEndObservable = new (0, $diGQf.Observable)();
        /**
         * Observer raised when the animation loops
         */ this.onAnimationLoopObservable = new (0, $diGQf.Observable)();
        this._scene = scene;
        if (animations) this.appendAnimations(target, animations);
        this._speedRatio = speedRatio;
        scene._activeAnimatables.push(this);
    }
    // Methods
    /**
     * Synchronize and normalize current Animatable with a source Animatable
     * This is useful when using animation weights and when animations are not of the same length
     * @param root defines the root Animatable to synchronize with (null to stop synchronizing)
     * @returns the current Animatable
     */ syncWith(root) {
        this._syncRoot = root;
        if (root) {
            // Make sure this animatable will animate after the root
            const index = this._scene._activeAnimatables.indexOf(this);
            if (index > -1) {
                this._scene._activeAnimatables.splice(index, 1);
                this._scene._activeAnimatables.push(this);
            }
        }
        return this;
    }
    /**
     * Gets the list of runtime animations
     * @returns an array of RuntimeAnimation
     */ getAnimations() {
        return this._runtimeAnimations;
    }
    /**
     * Adds more animations to the current animatable
     * @param target defines the target of the animations
     * @param animations defines the new animations to add
     */ appendAnimations(target, animations) {
        for(let index = 0; index < animations.length; index++){
            const animation = animations[index];
            const newRuntimeAnimation = new (0, $49d72768d87ebb9d$export$ce4961f17ea23fea)(target, animation, this._scene, this);
            newRuntimeAnimation._onLoop = ()=>{
                this.onAnimationLoopObservable.notifyObservers(this);
                if (this.onAnimationLoop) this.onAnimationLoop();
            };
            this._runtimeAnimations.push(newRuntimeAnimation);
        }
    }
    /**
     * Gets the source animation for a specific property
     * @param property defines the property to look for
     * @returns null or the source animation for the given property
     */ getAnimationByTargetProperty(property) {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++){
            if (runtimeAnimations[index].animation.targetProperty === property) return runtimeAnimations[index].animation;
        }
        return null;
    }
    /**
     * Gets the runtime animation for a specific property
     * @param property defines the property to look for
     * @returns null or the runtime animation for the given property
     */ getRuntimeAnimationByTargetProperty(property) {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++){
            if (runtimeAnimations[index].animation.targetProperty === property) return runtimeAnimations[index];
        }
        return null;
    }
    /**
     * Resets the animatable to its original state
     */ reset() {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].reset(true);
        this._localDelayOffset = null;
        this._pausedDelay = null;
    }
    /**
     * Allows the animatable to blend with current running animations
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
     * @param blendingSpeed defines the blending speed to use
     */ enableBlending(blendingSpeed) {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++){
            runtimeAnimations[index].animation.enableBlending = true;
            runtimeAnimations[index].animation.blendingSpeed = blendingSpeed;
        }
    }
    /**
     * Disable animation blending
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
     */ disableBlending() {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].animation.enableBlending = false;
    }
    /**
     * Jump directly to a given frame
     * @param frame defines the frame to jump to
     * @param useWeight defines whether the animation weight should be applied to the image to be jumped to (false by default)
     */ goToFrame(frame, useWeight = false) {
        const runtimeAnimations = this._runtimeAnimations;
        if (runtimeAnimations[0]) {
            const fps = runtimeAnimations[0].animation.framePerSecond;
            this._frameToSyncFromJump = this._frameToSyncFromJump ?? runtimeAnimations[0].currentFrame;
            const delay = this.speedRatio === 0 ? 0 : (frame - this._frameToSyncFromJump) / fps * 1000 / this.speedRatio;
            this._manualJumpDelay = -delay;
        }
        for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].goToFrame(frame, useWeight ? this._weight : -1);
        this._goToFrame = frame;
    }
    /**
     * Returns true if the animations for this animatable are paused
     */ get paused() {
        return this._paused;
    }
    /**
     * Pause the animation
     */ pause() {
        if (this._paused) return;
        this._paused = true;
    }
    /**
     * Restart the animation
     */ restart() {
        this._paused = false;
    }
    _raiseOnAnimationEnd() {
        if (this.onAnimationEnd) this.onAnimationEnd();
        this.onAnimationEndObservable.notifyObservers(this);
    }
    /**
     * Stop and delete the current animation
     * @param animationName defines a string used to only stop some of the runtime animations instead of all
     * @param targetMask a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
     * @param useGlobalSplice if true, the animatables will be removed by the caller of this function (false by default)
     * @param skipOnAnimationEnd defines if the system should not raise onAnimationEnd. Default is false
     */ stop(animationName, targetMask, useGlobalSplice = false, skipOnAnimationEnd = false) {
        if (animationName || targetMask) {
            const idx = this._scene._activeAnimatables.indexOf(this);
            if (idx > -1) {
                const runtimeAnimations = this._runtimeAnimations;
                for(let index = runtimeAnimations.length - 1; index >= 0; index--){
                    const runtimeAnimation = runtimeAnimations[index];
                    if (animationName && runtimeAnimation.animation.name != animationName) continue;
                    if (targetMask && !targetMask(runtimeAnimation.target)) continue;
                    runtimeAnimation.dispose();
                    runtimeAnimations.splice(index, 1);
                }
                if (runtimeAnimations.length == 0) {
                    if (!useGlobalSplice) this._scene._activeAnimatables.splice(idx, 1);
                    if (!skipOnAnimationEnd) this._raiseOnAnimationEnd();
                }
            }
        } else {
            const index = this._scene._activeAnimatables.indexOf(this);
            if (index > -1) {
                if (!useGlobalSplice) this._scene._activeAnimatables.splice(index, 1);
                const runtimeAnimations = this._runtimeAnimations;
                for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].dispose();
                this._runtimeAnimations.length = 0;
                if (!skipOnAnimationEnd) this._raiseOnAnimationEnd();
            }
        }
    }
    /**
     * Wait asynchronously for the animation to end
     * @returns a promise which will be fulfilled when the animation ends
     */ waitAsync() {
        return new Promise((resolve)=>{
            this.onAnimationEndObservable.add(()=>{
                resolve(this);
            }, undefined, undefined, this, true);
        });
    }
    /**
     * @internal
     */ _animate(delay) {
        if (this._paused) {
            this.animationStarted = false;
            if (this._pausedDelay === null) this._pausedDelay = delay;
            return true;
        }
        if (this._localDelayOffset === null) {
            this._localDelayOffset = delay;
            this._pausedDelay = null;
        } else if (this._pausedDelay !== null) {
            this._localDelayOffset += delay - this._pausedDelay;
            this._pausedDelay = null;
        }
        if (this._manualJumpDelay !== null) {
            this._localDelayOffset += this._manualJumpDelay;
            this._manualJumpDelay = null;
            this._frameToSyncFromJump = null;
        }
        this._goToFrame = null;
        if (this._weight === 0) // We consider that an animatable with a weight === 0 is "actively" paused
        return true;
        // Animating
        let running = false;
        const runtimeAnimations = this._runtimeAnimations;
        let index;
        for(index = 0; index < runtimeAnimations.length; index++){
            const animation = runtimeAnimations[index];
            const isRunning = animation.animate(delay - this._localDelayOffset, this.fromFrame, this.toFrame, this.loopAnimation, this._speedRatio, this._weight);
            running = running || isRunning;
        }
        this.animationStarted = running;
        if (!running) {
            if (this.disposeOnEnd) {
                // Remove from active animatables
                index = this._scene._activeAnimatables.indexOf(this);
                this._scene._activeAnimatables.splice(index, 1);
                // Dispose all runtime animations
                for(index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].dispose();
            }
            this._raiseOnAnimationEnd();
            if (this.disposeOnEnd) {
                this.onAnimationEnd = null;
                this.onAnimationLoop = null;
                this.onAnimationLoopObservable.clear();
                this.onAnimationEndObservable.clear();
            }
        }
        return running;
    }
}
/** @internal */ function $de573fe9da9bea6a$var$ProcessLateAnimationBindingsForMatrices(holder) {
    if (holder.totalWeight === 0 && holder.totalAdditiveWeight === 0) return holder.originalValue;
    let normalizer = 1.0;
    const finalPosition = (0, $ha1VO.TmpVectors).Vector3[0];
    const finalScaling = (0, $ha1VO.TmpVectors).Vector3[1];
    const finalQuaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
    let startIndex = 0;
    const originalAnimation = holder.animations[0];
    const originalValue = holder.originalValue;
    let scale = 1;
    let skipOverride = false;
    if (holder.totalWeight < 1.0) {
        // We need to mix the original value in
        scale = 1.0 - holder.totalWeight;
        originalValue.decompose(finalScaling, finalQuaternion, finalPosition);
    } else {
        startIndex = 1;
        // We need to normalize the weights
        normalizer = holder.totalWeight;
        scale = originalAnimation.weight / normalizer;
        if (scale == 1) {
            if (holder.totalAdditiveWeight) skipOverride = true;
            else return originalAnimation.currentValue;
        }
        originalAnimation.currentValue.decompose(finalScaling, finalQuaternion, finalPosition);
    }
    // Add up the override animations
    if (!skipOverride) {
        finalScaling.scaleInPlace(scale);
        finalPosition.scaleInPlace(scale);
        finalQuaternion.scaleInPlace(scale);
        for(let animIndex = startIndex; animIndex < holder.animations.length; animIndex++){
            const runtimeAnimation = holder.animations[animIndex];
            if (runtimeAnimation.weight === 0) continue;
            scale = runtimeAnimation.weight / normalizer;
            const currentPosition = (0, $ha1VO.TmpVectors).Vector3[2];
            const currentScaling = (0, $ha1VO.TmpVectors).Vector3[3];
            const currentQuaternion = (0, $ha1VO.TmpVectors).Quaternion[1];
            runtimeAnimation.currentValue.decompose(currentScaling, currentQuaternion, currentPosition);
            currentScaling.scaleAndAddToRef(scale, finalScaling);
            currentQuaternion.scaleAndAddToRef((0, $ha1VO.Quaternion).Dot(finalQuaternion, currentQuaternion) > 0 ? scale : -scale, finalQuaternion);
            currentPosition.scaleAndAddToRef(scale, finalPosition);
        }
        finalQuaternion.normalize();
    }
    // Add up the additive animations
    for(let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++){
        const runtimeAnimation = holder.additiveAnimations[animIndex];
        if (runtimeAnimation.weight === 0) continue;
        const currentPosition = (0, $ha1VO.TmpVectors).Vector3[2];
        const currentScaling = (0, $ha1VO.TmpVectors).Vector3[3];
        const currentQuaternion = (0, $ha1VO.TmpVectors).Quaternion[1];
        runtimeAnimation.currentValue.decompose(currentScaling, currentQuaternion, currentPosition);
        currentScaling.multiplyToRef(finalScaling, currentScaling);
        (0, $ha1VO.Vector3).LerpToRef(finalScaling, currentScaling, runtimeAnimation.weight, finalScaling);
        finalQuaternion.multiplyToRef(currentQuaternion, currentQuaternion);
        (0, $ha1VO.Quaternion).SlerpToRef(finalQuaternion, currentQuaternion, runtimeAnimation.weight, finalQuaternion);
        currentPosition.scaleAndAddToRef(runtimeAnimation.weight, finalPosition);
    }
    const workValue = originalAnimation ? originalAnimation._animationState.workValue : (0, $ha1VO.TmpVectors).Matrix[0].clone();
    (0, $ha1VO.Matrix).ComposeToRef(finalScaling, finalQuaternion, finalPosition, workValue);
    return workValue;
}
/** @internal */ function $de573fe9da9bea6a$var$ProcessLateAnimationBindingsForQuaternions(holder, refQuaternion) {
    if (holder.totalWeight === 0 && holder.totalAdditiveWeight === 0) return refQuaternion;
    const originalAnimation = holder.animations[0];
    const originalValue = holder.originalValue;
    let cumulativeQuaternion = refQuaternion;
    if (holder.totalWeight === 0 && holder.totalAdditiveWeight > 0) cumulativeQuaternion.copyFrom(originalValue);
    else if (holder.animations.length === 1) {
        (0, $ha1VO.Quaternion).SlerpToRef(originalValue, originalAnimation.currentValue, Math.min(1.0, holder.totalWeight), cumulativeQuaternion);
        if (holder.totalAdditiveWeight === 0) return cumulativeQuaternion;
    } else if (holder.animations.length > 1) {
        // Add up the override animations
        let normalizer = 1.0;
        let quaternions;
        let weights;
        if (holder.totalWeight < 1.0) {
            const scale = 1.0 - holder.totalWeight;
            quaternions = [];
            weights = [];
            quaternions.push(originalValue);
            weights.push(scale);
        } else {
            if (holder.animations.length === 2) {
                // Slerp as soon as we can
                (0, $ha1VO.Quaternion).SlerpToRef(holder.animations[0].currentValue, holder.animations[1].currentValue, holder.animations[1].weight / holder.totalWeight, refQuaternion);
                if (holder.totalAdditiveWeight === 0) return refQuaternion;
            }
            quaternions = [];
            weights = [];
            normalizer = holder.totalWeight;
        }
        for(let animIndex = 0; animIndex < holder.animations.length; animIndex++){
            const runtimeAnimation = holder.animations[animIndex];
            quaternions.push(runtimeAnimation.currentValue);
            weights.push(runtimeAnimation.weight / normalizer);
        }
        // https://gamedev.stackexchange.com/questions/62354/method-for-interpolation-between-3-quaternions
        let cumulativeAmount = 0;
        for(let index = 0; index < quaternions.length;){
            if (!index) {
                (0, $ha1VO.Quaternion).SlerpToRef(quaternions[index], quaternions[index + 1], weights[index + 1] / (weights[index] + weights[index + 1]), refQuaternion);
                cumulativeQuaternion = refQuaternion;
                cumulativeAmount = weights[index] + weights[index + 1];
                index += 2;
                continue;
            }
            cumulativeAmount += weights[index];
            (0, $ha1VO.Quaternion).SlerpToRef(cumulativeQuaternion, quaternions[index], weights[index] / cumulativeAmount, cumulativeQuaternion);
            index++;
        }
    }
    // Add up the additive animations
    for(let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++){
        const runtimeAnimation = holder.additiveAnimations[animIndex];
        if (runtimeAnimation.weight === 0) continue;
        cumulativeQuaternion.multiplyToRef(runtimeAnimation.currentValue, (0, $ha1VO.TmpVectors).Quaternion[0]);
        (0, $ha1VO.Quaternion).SlerpToRef(cumulativeQuaternion, (0, $ha1VO.TmpVectors).Quaternion[0], runtimeAnimation.weight, cumulativeQuaternion);
    }
    return cumulativeQuaternion;
}
/** @internal */ function $de573fe9da9bea6a$var$ProcessLateAnimationBindings(scene) {
    if (!scene._registeredForLateAnimationBindings.length) return;
    for(let index = 0; index < scene._registeredForLateAnimationBindings.length; index++){
        const target = scene._registeredForLateAnimationBindings.data[index];
        for(const path in target._lateAnimationHolders){
            const holder = target._lateAnimationHolders[path];
            const originalAnimation = holder.animations[0];
            const originalValue = holder.originalValue;
            if (originalValue === undefined || originalValue === null) continue;
            const matrixDecomposeMode = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).AllowMatrixDecomposeForInterpolation && originalValue.m; // ie. data is matrix
            let finalValue = target[path];
            if (matrixDecomposeMode) finalValue = $de573fe9da9bea6a$var$ProcessLateAnimationBindingsForMatrices(holder);
            else {
                const quaternionMode = originalValue.w !== undefined;
                if (quaternionMode) finalValue = $de573fe9da9bea6a$var$ProcessLateAnimationBindingsForQuaternions(holder, finalValue || (0, $ha1VO.Quaternion).Identity());
                else {
                    let startIndex = 0;
                    let normalizer = 1.0;
                    const originalAnimationIsLoopRelativeFromCurrent = originalAnimation && originalAnimation._animationState.loopMode === (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT;
                    if (holder.totalWeight < 1.0) {
                        // We need to mix the original value in
                        if (originalAnimationIsLoopRelativeFromCurrent) finalValue = originalValue.clone ? originalValue.clone() : originalValue;
                        else if (originalAnimation && originalValue.scale) finalValue = originalValue.scale(1.0 - holder.totalWeight);
                        else if (originalAnimation) finalValue = originalValue * (1.0 - holder.totalWeight);
                        else if (originalValue.clone) finalValue = originalValue.clone();
                        else finalValue = originalValue;
                    } else if (originalAnimation) {
                        // We need to normalize the weights
                        normalizer = holder.totalWeight;
                        const scale = originalAnimation.weight / normalizer;
                        if (scale !== 1) {
                            if (originalAnimation.currentValue.scale) finalValue = originalAnimation.currentValue.scale(scale);
                            else finalValue = originalAnimation.currentValue * scale;
                        } else finalValue = originalAnimation.currentValue;
                        if (originalAnimationIsLoopRelativeFromCurrent) {
                            if (finalValue.addToRef) finalValue.addToRef(originalValue, finalValue);
                            else finalValue += originalValue;
                        }
                        startIndex = 1;
                    }
                    // Add up the override animations
                    for(let animIndex = startIndex; animIndex < holder.animations.length; animIndex++){
                        const runtimeAnimation = holder.animations[animIndex];
                        const scale = runtimeAnimation.weight / normalizer;
                        if (!scale) continue;
                        else if (runtimeAnimation.currentValue.scaleAndAddToRef) runtimeAnimation.currentValue.scaleAndAddToRef(scale, finalValue);
                        else finalValue += runtimeAnimation.currentValue * scale;
                    }
                    // Add up the additive animations
                    for(let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++){
                        const runtimeAnimation = holder.additiveAnimations[animIndex];
                        const scale = runtimeAnimation.weight;
                        if (!scale) continue;
                        else if (runtimeAnimation.currentValue.scaleAndAddToRef) runtimeAnimation.currentValue.scaleAndAddToRef(scale, finalValue);
                        else finalValue += runtimeAnimation.currentValue * scale;
                    }
                }
            }
            target[path] = finalValue;
        }
        target._lateAnimationHolders = {};
    }
    scene._registeredForLateAnimationBindings.reset();
}
function $de573fe9da9bea6a$export$deee85a681cd559(scene, runtimeAnimation, originalValue) {
    const target = runtimeAnimation.target;
    scene._registeredForLateAnimationBindings.pushNoDuplicate(target);
    if (!target._lateAnimationHolders) target._lateAnimationHolders = {};
    if (!target._lateAnimationHolders[runtimeAnimation.targetPath]) target._lateAnimationHolders[runtimeAnimation.targetPath] = {
        totalWeight: 0,
        totalAdditiveWeight: 0,
        animations: [],
        additiveAnimations: [],
        originalValue: originalValue
    };
    if (runtimeAnimation.isAdditive) {
        target._lateAnimationHolders[runtimeAnimation.targetPath].additiveAnimations.push(runtimeAnimation);
        target._lateAnimationHolders[runtimeAnimation.targetPath].totalAdditiveWeight += runtimeAnimation.weight;
    } else {
        target._lateAnimationHolders[runtimeAnimation.targetPath].animations.push(runtimeAnimation);
        target._lateAnimationHolders[runtimeAnimation.targetPath].totalWeight += runtimeAnimation.weight;
    }
}
function $de573fe9da9bea6a$export$8794f931f19f408e(sceneClass, boneClass) {
    if (boneClass) boneClass.prototype.copyAnimationRange = function(source, rangeName, frameOffset, rescaleAsRequired = false, skelDimensionsRatio = null) {
        // all animation may be coming from a library skeleton, so may need to create animation
        if (this.animations.length === 0) {
            this.animations.push(new (0, $ff91d59daa75db10$export$c35d437ae5945fcd)(this.name, "_matrix", source.animations[0].framePerSecond, (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_MATRIX, 0));
            this.animations[0].setKeys([]);
        }
        // get animation info / verify there is such a range from the source bone
        const sourceRange = source.animations[0].getRange(rangeName);
        if (!sourceRange) return false;
        const from = sourceRange.from;
        const to = sourceRange.to;
        const sourceKeys = source.animations[0].getKeys();
        // rescaling prep
        const sourceBoneLength = source.length;
        const sourceParent = source.getParent();
        const parent = this.getParent();
        const parentScalingReqd = rescaleAsRequired && sourceParent && sourceBoneLength && this.length && sourceBoneLength !== this.length;
        const parentRatio = parentScalingReqd && parent && sourceParent ? parent.length / sourceParent.length : 1;
        const dimensionsScalingReqd = rescaleAsRequired && !parent && skelDimensionsRatio && (skelDimensionsRatio.x !== 1 || skelDimensionsRatio.y !== 1 || skelDimensionsRatio.z !== 1);
        const destKeys = this.animations[0].getKeys();
        // loop vars declaration
        let orig;
        let origTranslation;
        let mat;
        for(let key = 0, nKeys = sourceKeys.length; key < nKeys; key++){
            orig = sourceKeys[key];
            if (orig.frame >= from && orig.frame <= to) {
                if (rescaleAsRequired) {
                    mat = orig.value.clone();
                    // scale based on parent ratio, when bone has parent
                    if (parentScalingReqd) {
                        origTranslation = mat.getTranslation();
                        mat.setTranslation(origTranslation.scaleInPlace(parentRatio));
                    // scale based on skeleton dimension ratio when root bone, and value is passed
                    } else if (dimensionsScalingReqd && skelDimensionsRatio) {
                        origTranslation = mat.getTranslation();
                        mat.setTranslation(origTranslation.multiplyInPlace(skelDimensionsRatio));
                    // use original when root bone, and no data for skelDimensionsRatio
                    } else mat = orig.value;
                } else mat = orig.value;
                destKeys.push({
                    frame: orig.frame + frameOffset,
                    value: mat
                });
            }
        }
        this.animations[0].createRange(rangeName, from + frameOffset, to + frameOffset);
        return true;
    };
    if (!sceneClass) return;
    sceneClass.prototype._animate = function(customDeltaTime) {
        if (!this.animationsEnabled) return;
        // Getting time
        const now = (0, $blHSI.PrecisionDate).Now;
        if (!this._animationTimeLast) {
            if (this._pendingData.length > 0) return;
            this._animationTimeLast = now;
        }
        this.deltaTime = customDeltaTime !== undefined ? customDeltaTime : this.useConstantAnimationDeltaTime ? 16.0 : (now - this._animationTimeLast) * this.animationTimeScale;
        this._animationTimeLast = now;
        const animatables = this._activeAnimatables;
        if (animatables.length === 0) return;
        this._animationTime += this.deltaTime;
        const animationTime = this._animationTime;
        for(let index = 0; index < animatables.length; index++){
            const animatable = animatables[index];
            if (!animatable._animate(animationTime) && animatable.disposeOnEnd) index--; // Array was updated
        }
        // Late animation bindings
        $de573fe9da9bea6a$var$ProcessLateAnimationBindings(this);
    };
    sceneClass.prototype.sortActiveAnimatables = function() {
        this._activeAnimatables.sort((a, b)=>{
            return a.playOrder - b.playOrder;
        });
    };
    sceneClass.prototype.beginWeightedAnimation = function(target, from, to, weight = 1.0, loop, speedRatio = 1.0, onAnimationEnd, animatable, targetMask, onAnimationLoop, isAdditive = false) {
        const returnedAnimatable = this.beginAnimation(target, from, to, loop, speedRatio, onAnimationEnd, animatable, false, targetMask, onAnimationLoop, isAdditive);
        returnedAnimatable.weight = weight;
        return returnedAnimatable;
    };
    sceneClass.prototype.beginAnimation = function(target, from, to, loop, speedRatio = 1.0, onAnimationEnd, animatable, stopCurrent = true, targetMask, onAnimationLoop, isAdditive = false) {
        // get speed speedRatio, to and from, based on the sign and value(s)
        if (speedRatio < 0) {
            const tmp = from;
            from = to;
            to = tmp;
            speedRatio = -speedRatio;
        }
        // if from > to switch speed ratio
        if (from > to) speedRatio = -speedRatio;
        if (stopCurrent) this.stopAnimation(target, undefined, targetMask);
        if (!animatable) animatable = new $de573fe9da9bea6a$export$8d0d04e6da868f4(this, target, from, to, loop, speedRatio, onAnimationEnd, undefined, onAnimationLoop, isAdditive);
        const shouldRunTargetAnimations = targetMask ? targetMask(target) : true;
        // Local animations
        if (target.animations && shouldRunTargetAnimations) animatable.appendAnimations(target, target.animations);
        // Children animations
        if (target.getAnimatables) {
            const animatables = target.getAnimatables();
            for(let index = 0; index < animatables.length; index++)this.beginAnimation(animatables[index], from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, onAnimationLoop);
        }
        animatable.reset();
        return animatable;
    };
    sceneClass.prototype.beginHierarchyAnimation = function(target, directDescendantsOnly, from, to, loop, speedRatio = 1.0, onAnimationEnd, animatable, stopCurrent = true, targetMask, onAnimationLoop, isAdditive = false) {
        const children = target.getDescendants(directDescendantsOnly);
        const result = [];
        result.push(this.beginAnimation(target, from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, undefined, isAdditive));
        for (const child of children)result.push(this.beginAnimation(child, from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, undefined, isAdditive));
        return result;
    };
    sceneClass.prototype.beginDirectAnimation = function(target, animations, from, to, loop, speedRatio = 1.0, onAnimationEnd, onAnimationLoop, isAdditive = false) {
        // get speed speedRatio, to and from, based on the sign and value(s)
        if (speedRatio < 0) {
            const tmp = from;
            from = to;
            to = tmp;
            speedRatio = -speedRatio;
        }
        // if from > to switch speed ratio
        if (from > to) speedRatio = -speedRatio;
        const animatable = new $de573fe9da9bea6a$export$8d0d04e6da868f4(this, target, from, to, loop, speedRatio, onAnimationEnd, animations, onAnimationLoop, isAdditive);
        return animatable;
    };
    sceneClass.prototype.beginDirectHierarchyAnimation = function(target, directDescendantsOnly, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive = false) {
        const children = target.getDescendants(directDescendantsOnly);
        const result = [];
        result.push(this.beginDirectAnimation(target, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive));
        for (const child of children)result.push(this.beginDirectAnimation(child, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive));
        return result;
    };
    sceneClass.prototype.getAnimatableByTarget = function(target) {
        for(let index = 0; index < this._activeAnimatables.length; index++){
            if (this._activeAnimatables[index].target === target) return this._activeAnimatables[index];
        }
        return null;
    };
    sceneClass.prototype.getAllAnimatablesByTarget = function(target) {
        const result = [];
        for(let index = 0; index < this._activeAnimatables.length; index++)if (this._activeAnimatables[index].target === target) result.push(this._activeAnimatables[index]);
        return result;
    };
    sceneClass.prototype.stopAnimation = function(target, animationName, targetMask) {
        const animatables = this.getAllAnimatablesByTarget(target);
        for (const animatable of animatables)animatable.stop(animationName, targetMask);
    };
    sceneClass.prototype.stopAllAnimations = function() {
        if (this._activeAnimatables) {
            for(let i = 0; i < this._activeAnimatables.length; i++)this._activeAnimatables[i].stop(undefined, undefined, true);
            this._activeAnimatables.length = 0;
        }
        for (const group of this.animationGroups)group.stop();
    };
}



var $gmbCk = parcelRequire("gmbCk");
// Connect everything!
(0, $de573fe9da9bea6a$export$8794f931f19f408e)((0, $gmbCk.Scene), (0, $bbab17c2ca6aeebf$export$b127726e56765aa4));


parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");

var $lUDWq = parcelRequire("lUDWq");


var $8DoUR = parcelRequire("8DoUR");

var $7etnY = parcelRequire("7etnY");
parcelRequire("fn9QB");
parcelRequire("5rZFU");
class $27c681c3fbf85650$export$c9c01839d3b82e5 {
    constructor(){}
}
class $27c681c3fbf85650$export$aba4b48bcf1d0984 {
    constructor(){}
}
class $27c681c3fbf85650$export$55538ea799e2f967 extends (0, $c14168b02f7bcc00$export$cb949309547a0dd7) {
    /**
     * Runs after the material is bound to a mesh
     * @param mesh mesh bound
     * @param effect bound effect used to render
     */ AttachAfterBind(mesh, effect) {
        if (this._newUniformInstances) for(const el in this._newUniformInstances){
            const ea = el.toString().split("-");
            if (ea[0] == "vec2") effect.setVector2(ea[1], this._newUniformInstances[el]);
            else if (ea[0] == "vec3") {
                if (this._newUniformInstances[el] instanceof (0, $7etnY.Color3)) effect.setColor3(ea[1], this._newUniformInstances[el]);
                else effect.setVector3(ea[1], this._newUniformInstances[el]);
            } else if (ea[0] == "vec4") {
                if (this._newUniformInstances[el] instanceof (0, $7etnY.Color4)) effect.setDirectColor4(ea[1], this._newUniformInstances[el]);
                else effect.setVector4(ea[1], this._newUniformInstances[el]);
                effect.setVector4(ea[1], this._newUniformInstances[el]);
            } else if (ea[0] == "mat4") effect.setMatrix(ea[1], this._newUniformInstances[el]);
            else if (ea[0] == "float") effect.setFloat(ea[1], this._newUniformInstances[el]);
        }
        if (this._newSamplerInstances) for(const el in this._newSamplerInstances){
            const ea = el.toString().split("-");
            if (ea[0] == "sampler2D" && this._newSamplerInstances[el].isReady && this._newSamplerInstances[el].isReady()) effect.setTexture(ea[1], this._newSamplerInstances[el]);
        }
    }
    /**
     * @internal
     */ ReviewUniform(name, arr) {
        if (name == "uniform" && this._newUniforms) {
            for(let ind = 0; ind < this._newUniforms.length; ind++)if (this._customUniform[ind].indexOf("sampler") == -1) arr.push(this._newUniforms[ind].replace(/\[\d*\]/g, ""));
        }
        if (name == "sampler" && this._newUniforms) {
            for(let ind = 0; ind < this._newUniforms.length; ind++)if (this._customUniform[ind].indexOf("sampler") != -1) arr.push(this._newUniforms[ind].replace(/\[\d*\]/g, ""));
        }
        return arr;
    }
    /**
     * Builds the material
     * @param shaderName name of the shader
     * @param uniforms list of uniforms
     * @param uniformBuffers list of uniform buffers
     * @param samplers list of samplers
     * @param defines list of defines
     * @param attributes list of attributes
     * @returns the shader name
     */ Builder(shaderName, uniforms, uniformBuffers, samplers, defines, attributes) {
        if (attributes && this._customAttributes && this._customAttributes.length > 0) attributes.push(...this._customAttributes);
        this.ReviewUniform("uniform", uniforms);
        this.ReviewUniform("sampler", samplers);
        const name = this._createdShaderName;
        if ((0, $lUDWq.Effect).ShadersStore[name + "VertexShader"] && (0, $lUDWq.Effect).ShadersStore[name + "PixelShader"]) return name;
        (0, $lUDWq.Effect).ShadersStore[name + "VertexShader"] = this._injectCustomCode(this.VertexShader, "vertex");
        (0, $lUDWq.Effect).ShadersStore[name + "PixelShader"] = this._injectCustomCode(this.FragmentShader, "fragment");
        return name;
    }
    _injectCustomCode(code, shaderType) {
        const customCode = this._getCustomCode(shaderType);
        for(const point in customCode){
            const injectedCode = customCode[point];
            if (injectedCode && injectedCode.length > 0) {
                const fullPointName = "#define " + point;
                code = code.replace(fullPointName, "\n" + injectedCode + "\n" + fullPointName);
            }
        }
        return code;
    }
    _getCustomCode(shaderType) {
        if (shaderType === "vertex") return {
            CUSTOM_VERTEX_BEGIN: this.CustomParts.Vertex_Begin,
            CUSTOM_VERTEX_DEFINITIONS: (this._customUniform?.join("\n") || "") + (this.CustomParts.Vertex_Definitions || ""),
            CUSTOM_VERTEX_MAIN_BEGIN: this.CustomParts.Vertex_MainBegin,
            CUSTOM_VERTEX_UPDATE_POSITION: this.CustomParts.Vertex_Before_PositionUpdated,
            CUSTOM_VERTEX_UPDATE_NORMAL: this.CustomParts.Vertex_Before_NormalUpdated,
            CUSTOM_VERTEX_MAIN_END: this.CustomParts.Vertex_MainEnd,
            CUSTOM_VERTEX_UPDATE_WORLDPOS: this.CustomParts.Vertex_After_WorldPosComputed
        };
        return {
            CUSTOM_FRAGMENT_BEGIN: this.CustomParts.Fragment_Begin,
            CUSTOM_FRAGMENT_DEFINITIONS: (this._customUniform?.join("\n") || "") + (this.CustomParts.Fragment_Definitions || ""),
            CUSTOM_FRAGMENT_MAIN_BEGIN: this.CustomParts.Fragment_MainBegin,
            CUSTOM_FRAGMENT_UPDATE_DIFFUSE: this.CustomParts.Fragment_Custom_Diffuse,
            CUSTOM_FRAGMENT_UPDATE_ALPHA: this.CustomParts.Fragment_Custom_Alpha,
            CUSTOM_FRAGMENT_BEFORE_LIGHTS: this.CustomParts.Fragment_Before_Lights,
            CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR: this.CustomParts.Fragment_Before_FragColor,
            CUSTOM_FRAGMENT_MAIN_END: this.CustomParts.Fragment_MainEnd,
            CUSTOM_FRAGMENT_BEFORE_FOG: this.CustomParts.Fragment_Before_Fog
        };
    }
    constructor(name, scene){
        super(name, scene, true);
        this.CustomParts = new $27c681c3fbf85650$export$aba4b48bcf1d0984();
        this.customShaderNameResolve = this.Builder;
        this.FragmentShader = (0, $lUDWq.Effect).ShadersStore["defaultPixelShader"];
        this.VertexShader = (0, $lUDWq.Effect).ShadersStore["defaultVertexShader"];
        $27c681c3fbf85650$export$55538ea799e2f967.ShaderIndexer++;
        this._createdShaderName = "custom_" + $27c681c3fbf85650$export$55538ea799e2f967.ShaderIndexer;
    }
    _afterBind(mesh, effect = null, subMesh) {
        if (!effect) return;
        this.AttachAfterBind(mesh, effect);
        try {
            super._afterBind(mesh, effect, subMesh);
        } catch (e) {}
    }
    /**
     * Adds a new uniform to the shader
     * @param name the name of the uniform to add
     * @param kind the type of the uniform to add
     * @param param the value of the uniform to add
     * @returns the current material
     */ AddUniform(name, kind, param) {
        if (!this._customUniform) {
            this._customUniform = new Array();
            this._newUniforms = new Array();
            this._newSamplerInstances = {};
            this._newUniformInstances = {};
        }
        if (param) {
            if (kind.indexOf("sampler") != -1) this._newSamplerInstances[kind + "-" + name] = param;
            else this._newUniformInstances[kind + "-" + name] = param;
        }
        this._customUniform.push("uniform " + kind + " " + name + ";");
        this._newUniforms.push(name);
        return this;
    }
    /**
     * Adds a custom attribute
     * @param name the name of the attribute
     * @returns the current material
     */ AddAttribute(name) {
        if (!this._customAttributes) this._customAttributes = [];
        this._customAttributes.push(name);
        return this;
    }
    /**
     * Sets the code on Fragment_Begin portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Begin(shaderPart) {
        this.CustomParts.Fragment_Begin = shaderPart;
        return this;
    }
    /**
     * Sets the code on Fragment_Definitions portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Definitions(shaderPart) {
        this.CustomParts.Fragment_Definitions = shaderPart;
        return this;
    }
    /**
     * Sets the code on Fragment_MainBegin portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_MainBegin(shaderPart) {
        this.CustomParts.Fragment_MainBegin = shaderPart;
        return this;
    }
    /**
     * Sets the code on Fragment_MainEnd portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_MainEnd(shaderPart) {
        this.CustomParts.Fragment_MainEnd = shaderPart;
        return this;
    }
    /**
     * Sets the code on Fragment_Custom_Diffuse portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Custom_Diffuse(shaderPart) {
        this.CustomParts.Fragment_Custom_Diffuse = shaderPart.replace("result", "diffuseColor");
        return this;
    }
    /**
     * Sets the code on Fragment_Custom_Alpha portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Custom_Alpha(shaderPart) {
        this.CustomParts.Fragment_Custom_Alpha = shaderPart.replace("result", "alpha");
        return this;
    }
    /**
     * Sets the code on Fragment_Before_Lights portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Before_Lights(shaderPart) {
        this.CustomParts.Fragment_Before_Lights = shaderPart;
        return this;
    }
    /**
     * Sets the code on Fragment_Before_Fog portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Before_Fog(shaderPart) {
        this.CustomParts.Fragment_Before_Fog = shaderPart;
        return this;
    }
    /**
     * Sets the code on Fragment_Before_FragColor portion
     * @param shaderPart the code string
     * @returns the current material
     */ Fragment_Before_FragColor(shaderPart) {
        this.CustomParts.Fragment_Before_FragColor = shaderPart.replace("result", "color");
        return this;
    }
    /**
     * Sets the code on Vertex_Begin portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_Begin(shaderPart) {
        this.CustomParts.Vertex_Begin = shaderPart;
        return this;
    }
    /**
     * Sets the code on Vertex_Definitions portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_Definitions(shaderPart) {
        this.CustomParts.Vertex_Definitions = shaderPart;
        return this;
    }
    /**
     * Sets the code on Vertex_MainBegin portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_MainBegin(shaderPart) {
        this.CustomParts.Vertex_MainBegin = shaderPart;
        return this;
    }
    /**
     * Sets the code on Vertex_Before_PositionUpdated portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_Before_PositionUpdated(shaderPart) {
        this.CustomParts.Vertex_Before_PositionUpdated = shaderPart.replace("result", "positionUpdated");
        return this;
    }
    /**
     * Sets the code on Vertex_Before_NormalUpdated portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_Before_NormalUpdated(shaderPart) {
        this.CustomParts.Vertex_Before_NormalUpdated = shaderPart.replace("result", "normalUpdated");
        return this;
    }
    /**
     * Sets the code on Vertex_After_WorldPosComputed portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_After_WorldPosComputed(shaderPart) {
        this.CustomParts.Vertex_After_WorldPosComputed = shaderPart;
        return this;
    }
    /**
     * Sets the code on Vertex_MainEnd portion
     * @param shaderPart the code string
     * @returns the current material
     */ Vertex_MainEnd(shaderPart) {
        this.CustomParts.Vertex_MainEnd = shaderPart;
        return this;
    }
}
/**
 * Index for each created shader
 */ $27c681c3fbf85650$export$55538ea799e2f967.ShaderIndexer = 1;
(0, $8DoUR.RegisterClass)("BABYLON.CustomMaterial", $27c681c3fbf85650$export$55538ea799e2f967);



var $j2mX5 = parcelRequire("j2mX5");

var $5YkyR = parcelRequire("5YkyR");

var $gmbCk = parcelRequire("gmbCk");

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");



var $cfkw4 = parcelRequire("cfkw4");

var $blHSI = parcelRequire("blHSI");

var $53VPf = parcelRequire("53VPf");
class $549bdcf6bf9469ac$export$26177590adee994 {
    constructor(){
        this._zoomStopsAnimation = false;
        this._idleRotationSpeed = 0.05;
        this._idleRotationWaitTime = 2000;
        this._idleRotationSpinupTime = 2000;
        /**
         * Target alpha
         */ this.targetAlpha = null;
        this._isPointerDown = false;
        this._lastFrameTime = null;
        this._lastInteractionTime = -Infinity;
        this._cameraRotationSpeed = 0;
        this._lastFrameRadius = 0;
    }
    /**
     * Gets the name of the behavior.
     */ get name() {
        return "AutoRotation";
    }
    /**
     * Sets the flag that indicates if user zooming should stop animation.
     */ set zoomStopsAnimation(flag) {
        this._zoomStopsAnimation = flag;
    }
    /**
     * Gets the flag that indicates if user zooming should stop animation.
     */ get zoomStopsAnimation() {
        return this._zoomStopsAnimation;
    }
    /**
     * Sets the default speed at which the camera rotates around the model.
     */ set idleRotationSpeed(speed) {
        this._idleRotationSpeed = speed;
    }
    /**
     * Gets the default speed at which the camera rotates around the model.
     */ get idleRotationSpeed() {
        return this._idleRotationSpeed;
    }
    /**
     * Sets the time (in milliseconds) to wait after user interaction before the camera starts rotating.
     */ set idleRotationWaitTime(time) {
        this._idleRotationWaitTime = time;
    }
    /**
     * Gets the time (milliseconds) to wait after user interaction before the camera starts rotating.
     */ get idleRotationWaitTime() {
        return this._idleRotationWaitTime;
    }
    /**
     * Sets the time (milliseconds) to take to spin up to the full idle rotation speed.
     */ set idleRotationSpinupTime(time) {
        this._idleRotationSpinupTime = time;
    }
    /**
     * Gets the time (milliseconds) to take to spin up to the full idle rotation speed.
     */ get idleRotationSpinupTime() {
        return this._idleRotationSpinupTime;
    }
    /**
     * Gets a value indicating if the camera is currently rotating because of this behavior
     */ get rotationInProgress() {
        return Math.abs(this._cameraRotationSpeed) > 0;
    }
    /**
     * Initializes the behavior.
     */ init() {
    // Do nothing
    }
    /**
     * Attaches the behavior to its arc rotate camera.
     * @param camera Defines the camera to attach the behavior to
     */ attach(camera) {
        this._attachedCamera = camera;
        const scene = this._attachedCamera.getScene();
        this._onPrePointerObservableObserver = scene.onPrePointerObservable.add((pointerInfoPre)=>{
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                this._isPointerDown = true;
                return;
            }
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERUP) this._isPointerDown = false;
        });
        this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(()=>{
            if (this._reachTargetAlpha()) return;
            const now = (0, $blHSI.PrecisionDate).Now;
            let dt = 0;
            if (this._lastFrameTime != null) dt = now - this._lastFrameTime;
            this._lastFrameTime = now;
            // Stop the animation if there is user interaction and the animation should stop for this interaction
            this._applyUserInteraction();
            const timeToRotation = now - this._lastInteractionTime - this._idleRotationWaitTime;
            const scale = Math.max(Math.min(timeToRotation / this._idleRotationSpinupTime, 1), 0);
            this._cameraRotationSpeed = this._idleRotationSpeed * scale;
            // Step camera rotation by rotation speed
            if (this._attachedCamera) this._attachedCamera.alpha -= this._cameraRotationSpeed * (dt / 1000);
        });
    }
    /**
     * Detaches the behavior from its current arc rotate camera.
     */ detach() {
        if (!this._attachedCamera) return;
        const scene = this._attachedCamera.getScene();
        if (this._onPrePointerObservableObserver) scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
        this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
        this._attachedCamera = null;
        this._lastFrameTime = null;
    }
    /**
     * Force-reset the last interaction time
     * @param customTime an optional time that will be used instead of the current last interaction time. For example `Date.now()`
     */ resetLastInteractionTime(customTime) {
        this._lastInteractionTime = customTime ?? (0, $blHSI.PrecisionDate).Now;
    }
    /**
     * Returns true if camera alpha reaches the target alpha
     * @returns true if camera alpha reaches the target alpha
     */ _reachTargetAlpha() {
        if (this._attachedCamera && this.targetAlpha) return Math.abs(this._attachedCamera.alpha - this.targetAlpha) < (0, $53VPf.Epsilon);
        return false;
    }
    /**
     * Returns true if user is scrolling.
     * @returns true if user is scrolling.
     */ _userIsZooming() {
        if (!this._attachedCamera) return false;
        return this._attachedCamera.inertialRadiusOffset !== 0;
    }
    _shouldAnimationStopForInteraction() {
        if (!this._attachedCamera) return false;
        let zoomHasHitLimit = false;
        if (this._lastFrameRadius === this._attachedCamera.radius && this._attachedCamera.inertialRadiusOffset !== 0) zoomHasHitLimit = true;
        // Update the record of previous radius - works as an approx. indicator of hitting radius limits
        this._lastFrameRadius = this._attachedCamera.radius;
        return this._zoomStopsAnimation ? zoomHasHitLimit : this._userIsZooming();
    }
    /**
     *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
     */ _applyUserInteraction() {
        if (this._userIsMoving() && !this._shouldAnimationStopForInteraction()) this._lastInteractionTime = (0, $blHSI.PrecisionDate).Now;
    }
    // Tools
    _userIsMoving() {
        if (!this._attachedCamera) return false;
        return this._attachedCamera.inertialAlphaOffset !== 0 || this._attachedCamera.inertialBetaOffset !== 0 || this._attachedCamera.inertialRadiusOffset !== 0 || this._attachedCamera.inertialPanningX !== 0 || this._attachedCamera.inertialPanningY !== 0 || this._isPointerDown;
    }
}



var $fm2C6 = parcelRequire("fm2C6");
class $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    constructor(){
        this._easingMode = $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEIN;
    }
    /**
     * Sets the easing mode of the current function.
     * @param easingMode Defines the willing mode (EASINGMODE_EASEIN, EASINGMODE_EASEOUT or EASINGMODE_EASEINOUT)
     */ setEasingMode(easingMode) {
        const n = Math.min(Math.max(easingMode, 0), 2);
        this._easingMode = n;
    }
    /**
     * Gets the current easing mode.
     * @returns the easing mode
     */ getEasingMode() {
        return this._easingMode;
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    easeInCore(gradient) {
        throw new Error("You must implement this method");
    }
    /**
     * Given an input gradient between 0 and 1, this returns the corresponding value
     * of the easing function.
     * @param gradient Defines the value between 0 and 1 we want the easing value for
     * @returns the corresponding value on the curve defined by the easing function
     */ ease(gradient) {
        switch(this._easingMode){
            case $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEIN:
                return this.easeInCore(gradient);
            case $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEOUT:
                return 1 - this.easeInCore(1 - gradient);
        }
        if (gradient >= 0.5) return (1 - this.easeInCore((1 - gradient) * 2)) * 0.5 + 0.5;
        return this.easeInCore(gradient * 2) * 0.5;
    }
}
/**
 * Interpolation follows the mathematical formula associated with the easing function.
 */ $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEIN = 0;
/**
 * Interpolation follows 100% interpolation minus the output of the formula associated with the easing function.
 */ $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEOUT = 1;
/**
 * Interpolation uses EaseIn for the first half of the animation and EaseOut for the second half.
 */ $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEINOUT = 2;
class $005b3f0c7a6c24da$export$682c243b9f175ba2 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        gradient = Math.max(0, Math.min(1, gradient));
        return 1.0 - Math.sqrt(1.0 - gradient * gradient);
    }
}
class $005b3f0c7a6c24da$export$1de0cb74a12790e5 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates a back ease easing
     * @see https://easings.net/#easeInBack
     * @param amplitude Defines the amplitude of the function
     */ constructor(/** [1] Defines the amplitude of the function */ amplitude = 1){
        super();
        this.amplitude = amplitude;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        const num = Math.max(0, this.amplitude);
        return Math.pow(gradient, 3.0) - gradient * num * Math.sin(3.1415926535897931 * gradient);
    }
}
class $005b3f0c7a6c24da$export$f2f580055f47d939 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates a bounce easing
     * @see https://easings.net/#easeInBounce
     * @param bounces Defines the number of bounces
     * @param bounciness Defines the amplitude of the bounce
     */ constructor(/** [3] Defines the number of bounces */ bounces = 3, /** [2] Defines the amplitude of the bounce */ bounciness = 2){
        super();
        this.bounces = bounces;
        this.bounciness = bounciness;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        const y = Math.max(0.0, this.bounces);
        let bounciness = this.bounciness;
        if (bounciness <= 1.0) bounciness = 1.001;
        const num9 = Math.pow(bounciness, y);
        const num5 = 1.0 - bounciness;
        const num4 = (1.0 - num9) / num5 + num9 * 0.5;
        const num15 = gradient * num4;
        const num65 = Math.log(-num15 * (1.0 - bounciness) + 1.0) / Math.log(bounciness);
        const num3 = Math.floor(num65);
        const num13 = num3 + 1.0;
        const num8 = (1.0 - Math.pow(bounciness, num3)) / (num5 * num4);
        const num12 = (1.0 - Math.pow(bounciness, num13)) / (num5 * num4);
        const num7 = (num8 + num12) * 0.5;
        const num6 = gradient - num7;
        const num2 = num7 - num8;
        return -Math.pow(1.0 / bounciness, y - num3) / (num2 * num2) * (num6 - num2) * (num6 + num2);
    }
}
class $005b3f0c7a6c24da$export$b9f6da40882c34cc extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$73d66f7d40f87bb4 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates an elastic easing function
     * @see https://easings.net/#easeInElastic
     * @param oscillations Defines the number of oscillations
     * @param springiness Defines the amplitude of the oscillations
     */ constructor(/** [3] Defines the number of oscillations*/ oscillations = 3, /** [3] Defines the amplitude of the oscillations*/ springiness = 3){
        super();
        this.oscillations = oscillations;
        this.springiness = springiness;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        let num2;
        const num3 = Math.max(0.0, this.oscillations);
        const num = Math.max(0.0, this.springiness);
        if (num == 0) num2 = gradient;
        else num2 = (Math.exp(num * gradient) - 1.0) / (Math.exp(num) - 1.0);
        return num2 * Math.sin((6.2831853071795862 * num3 + 1.5707963267948966) * gradient);
    }
}
class $005b3f0c7a6c24da$export$796b0dbcc6df23ee extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates an exponential easing function
     * @see https://easings.net/#easeInExpo
     * @param exponent Defines the exponent of the function
     */ constructor(/** [3] Defines the exponent of the function */ exponent = 2){
        super();
        this.exponent = exponent;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        if (this.exponent <= 0) return gradient;
        return (Math.exp(this.exponent * gradient) - 1.0) / (Math.exp(this.exponent) - 1.0);
    }
}
class $005b3f0c7a6c24da$export$1e13f737331ff2e4 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates an power base easing function
     * @see https://easings.net/#easeInQuad
     * @param power Defines the power of the function
     */ constructor(/** [2] Defines the power of the function */ power = 2){
        super();
        this.power = power;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        const y = Math.max(0.0, this.power);
        return Math.pow(gradient, y);
    }
}
class $005b3f0c7a6c24da$export$2a6c337c04bf5461 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$92b6eb3430aedbbd extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient * gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$2321f37863089117 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient * gradient * gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$2e71abf7a3c7d863 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return 1.0 - Math.sin(1.5707963267948966 * (1.0 - gradient));
    }
}
class $005b3f0c7a6c24da$export$2d1c5f5e8681690c extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates a bezier function
     * @see http://cubic-bezier.com/#.17,.67,.83,.67
     * @param x1 Defines the x component of the start tangent in the bezier curve
     * @param y1 Defines the y component of the start tangent in the bezier curve
     * @param x2 Defines the x component of the end tangent in the bezier curve
     * @param y2 Defines the y component of the end tangent in the bezier curve
     */ constructor(/** [0] Defines the x component of the start tangent in the bezier curve */ x1 = 0, /** [0] Defines the y component of the start tangent in the bezier curve */ y1 = 0, /** [1] Defines the x component of the end tangent in the bezier curve */ x2 = 1, /** [1] Defines the y component of the end tangent in the bezier curve */ y2 = 1){
        super();
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        return (0, $fm2C6.BezierCurve).Interpolate(gradient, this.x1, this.y1, this.x2, this.y2);
    }
}



class $8020ca7199b79bd4$export$bdf68dcd10685529 {
    constructor(){
        /**
         * The duration of the animation, in milliseconds
         */ this.transitionDuration = 450;
        /**
         * Length of the distance animated by the transition when lower radius is reached
         */ this.lowerRadiusTransitionRange = 2;
        /**
         * Length of the distance animated by the transition when upper radius is reached
         */ this.upperRadiusTransitionRange = -2;
        this._autoTransitionRange = false;
        // Animations
        this._radiusIsAnimating = false;
        this._radiusBounceTransition = null;
        this._animatables = new Array();
    }
    /**
     * Gets the name of the behavior.
     */ get name() {
        return "Bouncing";
    }
    /**
     * Gets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
     */ get autoTransitionRange() {
        return this._autoTransitionRange;
    }
    /**
     * Sets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
     * Transition ranges will be set to 5% of the bounding box diagonal in world space
     */ set autoTransitionRange(value) {
        if (this._autoTransitionRange === value) return;
        this._autoTransitionRange = value;
        const camera = this._attachedCamera;
        if (!camera) return;
        if (value) this._onMeshTargetChangedObserver = camera.onMeshTargetChangedObservable.add((transformNode)=>{
            if (!transformNode) return;
            transformNode.computeWorldMatrix(true);
            if (transformNode.getBoundingInfo) {
                const diagonal = transformNode.getBoundingInfo().diagonalLength;
                this.lowerRadiusTransitionRange = diagonal * 0.05;
                this.upperRadiusTransitionRange = diagonal * 0.05;
            }
        });
        else if (this._onMeshTargetChangedObserver) camera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
    }
    /**
     * Initializes the behavior.
     */ init() {
    // Do nothing
    }
    /**
     * Attaches the behavior to its arc rotate camera.
     * @param camera Defines the camera to attach the behavior to
     */ attach(camera) {
        this._attachedCamera = camera;
        this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(()=>{
            if (!this._attachedCamera) return;
            // Add the bounce animation to the lower radius limit
            if (this._isRadiusAtLimit(this._attachedCamera.lowerRadiusLimit)) this._applyBoundRadiusAnimation(this.lowerRadiusTransitionRange);
            // Add the bounce animation to the upper radius limit
            if (this._isRadiusAtLimit(this._attachedCamera.upperRadiusLimit)) this._applyBoundRadiusAnimation(this.upperRadiusTransitionRange);
        });
    }
    /**
     * Detaches the behavior from its current arc rotate camera.
     */ detach() {
        if (!this._attachedCamera) return;
        if (this._onAfterCheckInputsObserver) this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
        if (this._onMeshTargetChangedObserver) this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
        this._attachedCamera = null;
    }
    /**
     * Checks if the camera radius is at the specified limit. Takes into account animation locks.
     * @param radiusLimit The limit to check against.
     * @returns Bool to indicate if at limit.
     */ _isRadiusAtLimit(radiusLimit) {
        if (!this._attachedCamera) return false;
        if (this._attachedCamera.radius === radiusLimit && !this._radiusIsAnimating) return true;
        return false;
    }
    /**
     * Applies an animation to the radius of the camera, extending by the radiusDelta.
     * @param radiusDelta The delta by which to animate to. Can be negative.
     */ _applyBoundRadiusAnimation(radiusDelta) {
        if (!this._attachedCamera) return;
        if (!this._radiusBounceTransition) {
            $8020ca7199b79bd4$export$bdf68dcd10685529.EasingFunction.setEasingMode($8020ca7199b79bd4$export$bdf68dcd10685529.EasingMode);
            this._radiusBounceTransition = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).CreateAnimation("radius", (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_FLOAT, 60, $8020ca7199b79bd4$export$bdf68dcd10685529.EasingFunction);
        }
        // Prevent zoom until bounce has completed
        this._cachedWheelPrecision = this._attachedCamera.wheelPrecision;
        this._attachedCamera.wheelPrecision = Infinity;
        this._attachedCamera.inertialRadiusOffset = 0;
        // Animate to the radius limit
        this.stopAllAnimations();
        this._radiusIsAnimating = true;
        const animatable = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).TransitionTo("radius", this._attachedCamera.radius + radiusDelta, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusBounceTransition, this.transitionDuration, ()=>this._clearAnimationLocks());
        if (animatable) this._animatables.push(animatable);
    }
    /**
     * Removes all animation locks. Allows new animations to be added to any of the camera properties.
     */ _clearAnimationLocks() {
        this._radiusIsAnimating = false;
        if (this._attachedCamera) this._attachedCamera.wheelPrecision = this._cachedWheelPrecision;
    }
    /**
     * Stops and removes all animations that have been applied to the camera
     */ stopAllAnimations() {
        if (this._attachedCamera) this._attachedCamera.animations = [];
        while(this._animatables.length){
            this._animatables[0].onAnimationEnd = null;
            this._animatables[0].stop();
            this._animatables.shift();
        }
    }
}
/**
 * The easing function used by animations
 */ $8020ca7199b79bd4$export$bdf68dcd10685529.EasingFunction = new (0, $005b3f0c7a6c24da$export$1de0cb74a12790e5)(0.3);
/**
 * The easing mode used by animations
 */ $8020ca7199b79bd4$export$bdf68dcd10685529.EasingMode = (0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEOUT;




var $diGQf = parcelRequire("diGQf");

var $cfkw4 = parcelRequire("cfkw4");

var $blHSI = parcelRequire("blHSI");

var $ha1VO = parcelRequire("ha1VO");

class $e658c5daf376ba2a$export$77fc4267b4cbd0a1 {
    constructor(){
        /**
         * An event triggered when the animation to zoom on target mesh has ended
         */ this.onTargetFramingAnimationEndObservable = new (0, $diGQf.Observable)();
        this._mode = $e658c5daf376ba2a$export$77fc4267b4cbd0a1.FitFrustumSidesMode;
        this._radiusScale = 1.0;
        this._positionScale = 0.5;
        this._defaultElevation = 0.3;
        this._elevationReturnTime = 1500;
        this._elevationReturnWaitTime = 1000;
        this._zoomStopsAnimation = false;
        this._framingTime = 1500;
        /**
         * Define if the behavior should automatically change the configured
         * camera limits and sensibilities.
         */ this.autoCorrectCameraLimitsAndSensibility = true;
        this._isPointerDown = false;
        this._lastInteractionTime = -Infinity;
        // Framing control
        this._animatables = new Array();
        this._betaIsAnimating = false;
    }
    /**
     * Gets the name of the behavior.
     */ get name() {
        return "Framing";
    }
    /**
     * Sets the current mode used by the behavior
     */ set mode(mode) {
        this._mode = mode;
    }
    /**
     * Gets current mode used by the behavior.
     */ get mode() {
        return this._mode;
    }
    /**
     * Sets the scale applied to the radius (1 by default)
     */ set radiusScale(radius) {
        this._radiusScale = radius;
    }
    /**
     * Gets the scale applied to the radius
     */ get radiusScale() {
        return this._radiusScale;
    }
    /**
     * Sets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
     */ set positionScale(scale) {
        this._positionScale = scale;
    }
    /**
     * Gets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
     */ get positionScale() {
        return this._positionScale;
    }
    /**
     * Sets the angle above/below the horizontal plane to return to when the return to default elevation idle
     * behaviour is triggered, in radians.
     */ set defaultElevation(elevation) {
        this._defaultElevation = elevation;
    }
    /**
     * Gets the angle above/below the horizontal plane to return to when the return to default elevation idle
     * behaviour is triggered, in radians.
     */ get defaultElevation() {
        return this._defaultElevation;
    }
    /**
     * Sets the time (in milliseconds) taken to return to the default beta position.
     * Negative value indicates camera should not return to default.
     */ set elevationReturnTime(speed) {
        this._elevationReturnTime = speed;
    }
    /**
     * Gets the time (in milliseconds) taken to return to the default beta position.
     * Negative value indicates camera should not return to default.
     */ get elevationReturnTime() {
        return this._elevationReturnTime;
    }
    /**
     * Sets the delay (in milliseconds) taken before the camera returns to the default beta position.
     */ set elevationReturnWaitTime(time) {
        this._elevationReturnWaitTime = time;
    }
    /**
     * Gets the delay (in milliseconds) taken before the camera returns to the default beta position.
     */ get elevationReturnWaitTime() {
        return this._elevationReturnWaitTime;
    }
    /**
     * Sets the flag that indicates if user zooming should stop animation.
     */ set zoomStopsAnimation(flag) {
        this._zoomStopsAnimation = flag;
    }
    /**
     * Gets the flag that indicates if user zooming should stop animation.
     */ get zoomStopsAnimation() {
        return this._zoomStopsAnimation;
    }
    /**
     * Sets the transition time when framing the mesh, in milliseconds
     */ set framingTime(time) {
        this._framingTime = time;
    }
    /**
     * Gets the transition time when framing the mesh, in milliseconds
     */ get framingTime() {
        return this._framingTime;
    }
    /**
     * Initializes the behavior.
     */ init() {
    // Do nothing
    }
    /**
     * Attaches the behavior to its arc rotate camera.
     * @param camera Defines the camera to attach the behavior to
     */ attach(camera) {
        this._attachedCamera = camera;
        const scene = this._attachedCamera.getScene();
        $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction.setEasingMode($e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingMode);
        this._onPrePointerObservableObserver = scene.onPrePointerObservable.add((pointerInfoPre)=>{
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                this._isPointerDown = true;
                return;
            }
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERUP) this._isPointerDown = false;
        });
        this._onMeshTargetChangedObserver = camera.onMeshTargetChangedObservable.add((transformNode)=>{
            if (transformNode && transformNode.getBoundingInfo) this.zoomOnMesh(transformNode, undefined, ()=>{
                this.onTargetFramingAnimationEndObservable.notifyObservers();
            });
        });
        this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(()=>{
            // Stop the animation if there is user interaction and the animation should stop for this interaction
            this._applyUserInteraction();
            // Maintain the camera above the ground. If the user pulls the camera beneath the ground plane, lift it
            // back to the default position after a given timeout
            this._maintainCameraAboveGround();
        });
    }
    /**
     * Detaches the behavior from its current arc rotate camera.
     */ detach() {
        if (!this._attachedCamera) return;
        const scene = this._attachedCamera.getScene();
        if (this._onPrePointerObservableObserver) scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
        if (this._onAfterCheckInputsObserver) this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
        if (this._onMeshTargetChangedObserver) this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
        this._attachedCamera = null;
    }
    /**
     * Targets the given mesh and updates zoom level accordingly.
     * @param mesh  The mesh to target.
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     */ zoomOnMesh(mesh, focusOnOriginXZ = false, onAnimationEnd = null) {
        mesh.computeWorldMatrix(true);
        const boundingBox = mesh.getBoundingInfo().boundingBox;
        this.zoomOnBoundingInfo(boundingBox.minimumWorld, boundingBox.maximumWorld, focusOnOriginXZ, onAnimationEnd);
    }
    /**
     * Targets the given mesh with its children and updates zoom level accordingly.
     * @param mesh The mesh to target.
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     */ zoomOnMeshHierarchy(mesh, focusOnOriginXZ = false, onAnimationEnd = null) {
        mesh.computeWorldMatrix(true);
        const boundingBox = mesh.getHierarchyBoundingVectors(true);
        this.zoomOnBoundingInfo(boundingBox.min, boundingBox.max, focusOnOriginXZ, onAnimationEnd);
    }
    /**
     * Targets the given meshes with their children and updates zoom level accordingly.
     * @param meshes  The mesh to target.
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     */ zoomOnMeshesHierarchy(meshes, focusOnOriginXZ = false, onAnimationEnd = null) {
        const min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        for(let i = 0; i < meshes.length; i++){
            const boundingInfo = meshes[i].getHierarchyBoundingVectors(true);
            (0, $ha1VO.Vector3).CheckExtends(boundingInfo.min, min, max);
            (0, $ha1VO.Vector3).CheckExtends(boundingInfo.max, min, max);
        }
        this.zoomOnBoundingInfo(min, max, focusOnOriginXZ, onAnimationEnd);
    }
    /**
     * Targets the bounding box info defined by its extends and updates zoom level accordingly.
     * @param minimumWorld Determines the smaller position of the bounding box extend
     * @param maximumWorld Determines the bigger position of the bounding box extend
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     * @returns true if the zoom was done
     */ zoomOnBoundingInfo(minimumWorld, maximumWorld, focusOnOriginXZ = false, onAnimationEnd = null) {
        let zoomTarget;
        if (!this._attachedCamera) return false;
        // Find target by interpolating from bottom of bounding box in world-space to top via framingPositionY
        const bottom = minimumWorld.y;
        const top = maximumWorld.y;
        const zoomTargetY = bottom + (top - bottom) * this._positionScale;
        const radiusWorld = maximumWorld.subtract(minimumWorld).scale(0.5);
        if (focusOnOriginXZ) zoomTarget = new (0, $ha1VO.Vector3)(0, zoomTargetY, 0);
        else {
            const centerWorld = minimumWorld.add(radiusWorld);
            zoomTarget = new (0, $ha1VO.Vector3)(centerWorld.x, zoomTargetY, centerWorld.z);
        }
        if (!this._vectorTransition) this._vectorTransition = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).CreateAnimation("target", (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_VECTOR3, 60, $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction);
        this._betaIsAnimating = true;
        let animatable = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).TransitionTo("target", zoomTarget, this._attachedCamera, this._attachedCamera.getScene(), 60, this._vectorTransition, this._framingTime);
        if (animatable) this._animatables.push(animatable);
        // sets the radius and lower radius bounds
        // Small delta ensures camera is not always at lower zoom limit.
        let radius = 0;
        if (this._mode === $e658c5daf376ba2a$export$77fc4267b4cbd0a1.FitFrustumSidesMode) {
            const position = this._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld);
            if (this.autoCorrectCameraLimitsAndSensibility) this._attachedCamera.lowerRadiusLimit = radiusWorld.length() + this._attachedCamera.minZ;
            radius = position;
        } else if (this._mode === $e658c5daf376ba2a$export$77fc4267b4cbd0a1.IgnoreBoundsSizeMode) {
            radius = this._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld);
            if (this.autoCorrectCameraLimitsAndSensibility && this._attachedCamera.lowerRadiusLimit === null) this._attachedCamera.lowerRadiusLimit = this._attachedCamera.minZ;
        }
        // Set sensibilities
        if (this.autoCorrectCameraLimitsAndSensibility) {
            const extend = maximumWorld.subtract(minimumWorld).length();
            this._attachedCamera.panningSensibility = 5000 / extend;
            this._attachedCamera.wheelPrecision = 100 / radius;
        }
        // transition to new radius
        if (!this._radiusTransition) this._radiusTransition = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).CreateAnimation("radius", (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_FLOAT, 60, $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction);
        animatable = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).TransitionTo("radius", radius, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusTransition, this._framingTime, ()=>{
            this.stopAllAnimations();
            if (onAnimationEnd) onAnimationEnd();
            if (this._attachedCamera && this._attachedCamera.useInputToRestoreState) this._attachedCamera.storeState();
        });
        if (animatable) this._animatables.push(animatable);
        return true;
    }
    /**
     * Calculates the lowest radius for the camera based on the bounding box of the mesh.
     * @param minimumWorld
     * @param maximumWorld
     * @returns The minimum distance from the primary mesh's center point at which the camera must be kept in order
     *		 to fully enclose the mesh in the viewing frustum.
     */ _calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld) {
        const camera = this._attachedCamera;
        if (!camera) return 0;
        let distance = camera._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld, this._radiusScale);
        if (camera.lowerRadiusLimit && this._mode === $e658c5daf376ba2a$export$77fc4267b4cbd0a1.IgnoreBoundsSizeMode) // Don't exceed the requested limit
        distance = distance < camera.lowerRadiusLimit ? camera.lowerRadiusLimit : distance;
        // Don't exceed the upper radius limit
        if (camera.upperRadiusLimit) distance = distance > camera.upperRadiusLimit ? camera.upperRadiusLimit : distance;
        return distance;
    }
    /**
     * Keeps the camera above the ground plane. If the user pulls the camera below the ground plane, the camera
     * is automatically returned to its default position (expected to be above ground plane).
     */ _maintainCameraAboveGround() {
        if (this._elevationReturnTime < 0) return;
        const timeSinceInteraction = (0, $blHSI.PrecisionDate).Now - this._lastInteractionTime;
        const defaultBeta = Math.PI * 0.5 - this._defaultElevation;
        const limitBeta = Math.PI * 0.5;
        // Bring the camera back up if below the ground plane
        if (this._attachedCamera && !this._betaIsAnimating && this._attachedCamera.beta > limitBeta && timeSinceInteraction >= this._elevationReturnWaitTime) {
            this._betaIsAnimating = true;
            //Transition to new position
            this.stopAllAnimations();
            if (!this._betaTransition) this._betaTransition = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).CreateAnimation("beta", (0, $ff91d59daa75db10$export$c35d437ae5945fcd).ANIMATIONTYPE_FLOAT, 60, $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction);
            const animatabe = (0, $ff91d59daa75db10$export$c35d437ae5945fcd).TransitionTo("beta", defaultBeta, this._attachedCamera, this._attachedCamera.getScene(), 60, this._betaTransition, this._elevationReturnTime, ()=>{
                this._clearAnimationLocks();
                this.stopAllAnimations();
            });
            if (animatabe) this._animatables.push(animatabe);
        }
    }
    /**
     * Removes all animation locks. Allows new animations to be added to any of the arcCamera properties.
     */ _clearAnimationLocks() {
        this._betaIsAnimating = false;
    }
    /**
     *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
     */ _applyUserInteraction() {
        if (this.isUserIsMoving) {
            this._lastInteractionTime = (0, $blHSI.PrecisionDate).Now;
            this.stopAllAnimations();
            this._clearAnimationLocks();
        }
    }
    /**
     * Stops and removes all animations that have been applied to the camera
     */ stopAllAnimations() {
        if (this._attachedCamera) this._attachedCamera.animations = [];
        while(this._animatables.length){
            if (this._animatables[0]) {
                this._animatables[0].onAnimationEnd = null;
                this._animatables[0].stop();
            }
            this._animatables.shift();
        }
    }
    /**
     * Gets a value indicating if the user is moving the camera
     */ get isUserIsMoving() {
        if (!this._attachedCamera) return false;
        return this._attachedCamera.inertialAlphaOffset !== 0 || this._attachedCamera.inertialBetaOffset !== 0 || this._attachedCamera.inertialRadiusOffset !== 0 || this._attachedCamera.inertialPanningX !== 0 || this._attachedCamera.inertialPanningY !== 0 || this._isPointerDown;
    }
}
/**
 * The easing function used by animations
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction = new (0, $005b3f0c7a6c24da$export$796b0dbcc6df23ee)();
/**
 * The easing mode used by animations
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingMode = (0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEINOUT;
// Statics
/**
 * The camera can move all the way towards the mesh.
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.IgnoreBoundsSizeMode = 0;
/**
 * The camera is not allowed to zoom closer to the mesh than the point at which the adjusted bounding sphere touches the frustum sides
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.FitFrustumSidesMode = 1;




var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");


var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");

var $dbxbu = parcelRequire("dbxbu");

(0, $021dcb6a570ae9c1$export$85c928794f8d04d4).AddNodeConstructor("TargetCamera", (name, scene)=>{
    return ()=>new $b739cdf8d675d7c2$export$afbb020f06951903(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $b739cdf8d675d7c2$export$afbb020f06951903 extends (0, $52736139c8513fb2$export$79f141de891a5fed) {
    /**
     * Instantiates a target camera that takes a mesh or position as a target and continues to look at it while it moves.
     * This is the base of the follow, arc rotate cameras and Free camera
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
     * @param name Defines the name of the camera in the scene
     * @param position Defines the start position of the camera in the scene
     * @param scene Defines the scene the camera belongs to
     * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
     */ constructor(name, position, scene, setActiveOnSceneIfNoneActive = true){
        super(name, position, scene, setActiveOnSceneIfNoneActive);
        this._tmpUpVector = (0, $ha1VO.Vector3).Zero();
        this._tmpTargetVector = (0, $ha1VO.Vector3).Zero();
        /**
         * Define the current direction the camera is moving to
         */ this.cameraDirection = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Define the current rotation the camera is rotating to
         */ this.cameraRotation = new (0, $ha1VO.Vector2)(0, 0);
        /** Gets or sets a boolean indicating that the scaling of the parent hierarchy will not be taken in account by the camera */ this.ignoreParentScaling = false;
        /**
         * When set, the up vector of the camera will be updated by the rotation of the camera
         */ this.updateUpVectorFromRotation = false;
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        /**
         * Define the current rotation of the camera
         */ this.rotation = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Define the current speed of the camera
         */ this.speed = 2.0;
        /**
         * Add constraint to the camera to prevent it to move freely in all directions and
         * around all axis.
         */ this.noRotationConstraint = false;
        /**
         * Reverses mouselook direction to 'natural' panning as opposed to traditional direct
         * panning
         */ this.invertRotation = false;
        /**
         * Speed multiplier for inverse camera panning
         */ this.inverseRotationSpeed = 0.2;
        /**
         * Define the current target of the camera as an object or a position.
         * Please note that locking a target will disable panning.
         */ this.lockedTarget = null;
        /** @internal */ this._currentTarget = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._initialFocalDistance = 1;
        /** @internal */ this._viewMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._camMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._cameraTransformMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._cameraRotationMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._referencePoint = new (0, $ha1VO.Vector3)(0, 0, 1);
        /** @internal */ this._transformedReferencePoint = (0, $ha1VO.Vector3).Zero();
        this._deferredPositionUpdate = new (0, $ha1VO.Vector3)();
        this._deferredRotationQuaternionUpdate = new (0, $ha1VO.Quaternion)();
        this._deferredRotationUpdate = new (0, $ha1VO.Vector3)();
        this._deferredUpdated = false;
        this._deferOnly = false;
        this._defaultUp = (0, $ha1VO.Vector3).Up();
        this._cachedRotationZ = 0;
        this._cachedQuaternionRotationZ = 0;
    }
    /**
     * Gets the position in front of the camera at a given distance.
     * @param distance The distance from the camera we want the position to be
     * @returns the position
     */ getFrontPosition(distance) {
        this.getWorldMatrix();
        const worldForward = (0, $ha1VO.TmpVectors).Vector3[0];
        const localForward = (0, $ha1VO.TmpVectors).Vector3[1];
        localForward.set(0, 0, this._scene.useRightHandedSystem ? -1 : 1.0);
        this.getDirectionToRef(localForward, worldForward);
        worldForward.scaleInPlace(distance);
        return this.globalPosition.add(worldForward);
    }
    /** @internal */ _getLockedTargetPosition() {
        if (!this.lockedTarget) return null;
        if (this.lockedTarget.absolutePosition) {
            const lockedTarget = this.lockedTarget;
            const m = lockedTarget.computeWorldMatrix();
            // in some cases the absolute position resets externally, but doesn't update since the matrix is cached.
            m.getTranslationToRef(lockedTarget.absolutePosition);
        }
        return this.lockedTarget.absolutePosition || this.lockedTarget;
    }
    /**
     * Store current camera state of the camera (fov, position, rotation, etc..)
     * @returns the camera
     */ storeState() {
        this._storedPosition = this.position.clone();
        this._storedRotation = this.rotation.clone();
        if (this.rotationQuaternion) this._storedRotationQuaternion = this.rotationQuaternion.clone();
        return super.storeState();
    }
    /**
     * Restored camera state. You must call storeState() first
     * @returns whether it was successful or not
     * @internal
     */ _restoreStateValues() {
        if (!super._restoreStateValues()) return false;
        this.position = this._storedPosition.clone();
        this.rotation = this._storedRotation.clone();
        if (this.rotationQuaternion) this.rotationQuaternion = this._storedRotationQuaternion.clone();
        this.cameraDirection.copyFromFloats(0, 0, 0);
        this.cameraRotation.copyFromFloats(0, 0);
        return true;
    }
    /** @internal */ _initCache() {
        super._initCache();
        this._cache.lockedTarget = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.rotation = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.rotationQuaternion = new (0, $ha1VO.Quaternion)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    }
    /**
     * @internal
     */ _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) super._updateCache();
        const lockedTargetPosition = this._getLockedTargetPosition();
        if (!lockedTargetPosition) this._cache.lockedTarget = null;
        else if (!this._cache.lockedTarget) this._cache.lockedTarget = lockedTargetPosition.clone();
        else this._cache.lockedTarget.copyFrom(lockedTargetPosition);
        this._cache.rotation.copyFrom(this.rotation);
        if (this.rotationQuaternion) this._cache.rotationQuaternion.copyFrom(this.rotationQuaternion);
    }
    // Synchronized
    /** @internal */ _isSynchronizedViewMatrix() {
        if (!super._isSynchronizedViewMatrix()) return false;
        const lockedTargetPosition = this._getLockedTargetPosition();
        return (this._cache.lockedTarget ? this._cache.lockedTarget.equals(lockedTargetPosition) : !lockedTargetPosition) && (this.rotationQuaternion ? this.rotationQuaternion.equals(this._cache.rotationQuaternion) : this._cache.rotation.equals(this.rotation));
    }
    // Methods
    /** @internal */ _computeLocalCameraSpeed() {
        const engine = this.getEngine();
        return this.speed * Math.sqrt(engine.getDeltaTime() / (engine.getFps() * 100.0));
    }
    // Target
    /**
     * Defines the target the camera should look at.
     * @param target Defines the new target as a Vector
     */ setTarget(target) {
        this.upVector.normalize();
        this._initialFocalDistance = target.subtract(this.position).length();
        if (this.position.z === target.z) this.position.z += (0, $53VPf.Epsilon);
        this._referencePoint.normalize().scaleInPlace(this._initialFocalDistance);
        (0, $ha1VO.Matrix).LookAtLHToRef(this.position, target, this._defaultUp, this._camMatrix);
        this._camMatrix.invert();
        this.rotation.x = Math.atan(this._camMatrix.m[6] / this._camMatrix.m[10]);
        const vDir = target.subtract(this.position);
        if (vDir.x >= 0.0) this.rotation.y = -Math.atan(vDir.z / vDir.x) + Math.PI / 2.0;
        else this.rotation.y = -Math.atan(vDir.z / vDir.x) - Math.PI / 2.0;
        this.rotation.z = 0;
        if (isNaN(this.rotation.x)) this.rotation.x = 0;
        if (isNaN(this.rotation.y)) this.rotation.y = 0;
        if (isNaN(this.rotation.z)) this.rotation.z = 0;
        if (this.rotationQuaternion) (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this.rotationQuaternion);
    }
    /**
     * Defines the target point of the camera.
     * The camera looks towards it form the radius distance.
     */ get target() {
        return this.getTarget();
    }
    set target(value) {
        this.setTarget(value);
    }
    /**
     * Return the current target position of the camera. This value is expressed in local space.
     * @returns the target position
     */ getTarget() {
        return this._currentTarget;
    }
    /** @internal */ _decideIfNeedsToMove() {
        return Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
    }
    /** @internal */ _updatePosition() {
        if (this.parent) {
            this.parent.getWorldMatrix().invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            (0, $ha1VO.Vector3).TransformNormalToRef(this.cameraDirection, (0, $ha1VO.TmpVectors).Matrix[0], (0, $ha1VO.TmpVectors).Vector3[0]);
            this._deferredPositionUpdate.addInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
            if (!this._deferOnly) this.position.copyFrom(this._deferredPositionUpdate);
            else this._deferredUpdated = true;
            return;
        }
        this._deferredPositionUpdate.addInPlace(this.cameraDirection);
        if (!this._deferOnly) this.position.copyFrom(this._deferredPositionUpdate);
        else this._deferredUpdated = true;
    }
    /** @internal */ _checkInputs() {
        const directionMultiplier = this.invertRotation ? -this.inverseRotationSpeed : 1.0;
        const needToMove = this._decideIfNeedsToMove();
        const needToRotate = this.cameraRotation.x || this.cameraRotation.y;
        this._deferredUpdated = false;
        this._deferredRotationUpdate.copyFrom(this.rotation);
        this._deferredPositionUpdate.copyFrom(this.position);
        if (this.rotationQuaternion) this._deferredRotationQuaternionUpdate.copyFrom(this.rotationQuaternion);
        // Move
        if (needToMove) this._updatePosition();
        // Rotate
        if (needToRotate) {
            //rotate, if quaternion is set and rotation was used
            if (this.rotationQuaternion) this.rotationQuaternion.toEulerAnglesToRef(this._deferredRotationUpdate);
            this._deferredRotationUpdate.x += this.cameraRotation.x * directionMultiplier;
            this._deferredRotationUpdate.y += this.cameraRotation.y * directionMultiplier;
            // Apply constraints
            if (!this.noRotationConstraint) {
                const limit = 1.570796;
                if (this._deferredRotationUpdate.x > limit) this._deferredRotationUpdate.x = limit;
                if (this._deferredRotationUpdate.x < -limit) this._deferredRotationUpdate.x = -limit;
            }
            if (!this._deferOnly) this.rotation.copyFrom(this._deferredRotationUpdate);
            else this._deferredUpdated = true;
            //rotate, if quaternion is set and rotation was used
            if (this.rotationQuaternion) {
                const len = this._deferredRotationUpdate.lengthSquared();
                if (len) {
                    (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._deferredRotationUpdate.y, this._deferredRotationUpdate.x, this._deferredRotationUpdate.z, this._deferredRotationQuaternionUpdate);
                    if (!this._deferOnly) this.rotationQuaternion.copyFrom(this._deferredRotationQuaternionUpdate);
                    else this._deferredUpdated = true;
                }
            }
        }
        // Inertia
        if (needToMove) {
            if (Math.abs(this.cameraDirection.x) < this.speed * (0, $53VPf.Epsilon)) this.cameraDirection.x = 0;
            if (Math.abs(this.cameraDirection.y) < this.speed * (0, $53VPf.Epsilon)) this.cameraDirection.y = 0;
            if (Math.abs(this.cameraDirection.z) < this.speed * (0, $53VPf.Epsilon)) this.cameraDirection.z = 0;
            this.cameraDirection.scaleInPlace(this.inertia);
        }
        if (needToRotate) {
            if (Math.abs(this.cameraRotation.x) < this.speed * (0, $53VPf.Epsilon)) this.cameraRotation.x = 0;
            if (Math.abs(this.cameraRotation.y) < this.speed * (0, $53VPf.Epsilon)) this.cameraRotation.y = 0;
            this.cameraRotation.scaleInPlace(this.inertia);
        }
        super._checkInputs();
    }
    _updateCameraRotationMatrix() {
        if (this.rotationQuaternion) this.rotationQuaternion.toRotationMatrix(this._cameraRotationMatrix);
        else (0, $ha1VO.Matrix).RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this._cameraRotationMatrix);
    }
    /**
     * Update the up vector to apply the rotation of the camera (So if you changed the camera rotation.z this will let you update the up vector as well)
     * @returns the current camera
     */ _rotateUpVectorWithCameraRotationMatrix() {
        (0, $ha1VO.Vector3).TransformNormalToRef(this._defaultUp, this._cameraRotationMatrix, this.upVector);
        return this;
    }
    /** @internal */ _getViewMatrix() {
        if (this.lockedTarget) this.setTarget(this._getLockedTargetPosition());
        // Compute
        this._updateCameraRotationMatrix();
        // Apply the changed rotation to the upVector
        if (this.rotationQuaternion && this._cachedQuaternionRotationZ != this.rotationQuaternion.z) {
            this._rotateUpVectorWithCameraRotationMatrix();
            this._cachedQuaternionRotationZ = this.rotationQuaternion.z;
        } else if (this._cachedRotationZ !== this.rotation.z) {
            this._rotateUpVectorWithCameraRotationMatrix();
            this._cachedRotationZ = this.rotation.z;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._referencePoint, this._cameraRotationMatrix, this._transformedReferencePoint);
        // Computing target and final matrix
        this.position.addToRef(this._transformedReferencePoint, this._currentTarget);
        if (this.updateUpVectorFromRotation) {
            if (this.rotationQuaternion) (0, $dbxbu.Axis).Y.rotateByQuaternionToRef(this.rotationQuaternion, this.upVector);
            else {
                (0, $ha1VO.Quaternion).FromEulerVectorToRef(this.rotation, this._tmpQuaternion);
                (0, $dbxbu.Axis).Y.rotateByQuaternionToRef(this._tmpQuaternion, this.upVector);
            }
        }
        this._computeViewMatrix(this.position, this._currentTarget, this.upVector);
        return this._viewMatrix;
    }
    _computeViewMatrix(position, target, up) {
        if (this.ignoreParentScaling) {
            if (this.parent) {
                const parentWorldMatrix = this.parent.getWorldMatrix();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, parentWorldMatrix, this._globalPosition);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(target, parentWorldMatrix, this._tmpTargetVector);
                (0, $ha1VO.Vector3).TransformNormalToRef(up, parentWorldMatrix, this._tmpUpVector);
                this._markSyncedWithParent();
            } else {
                this._globalPosition.copyFrom(position);
                this._tmpTargetVector.copyFrom(target);
                this._tmpUpVector.copyFrom(up);
            }
            if (this.getScene().useRightHandedSystem) (0, $ha1VO.Matrix).LookAtRHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
            else (0, $ha1VO.Matrix).LookAtLHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
            return;
        }
        if (this.getScene().useRightHandedSystem) (0, $ha1VO.Matrix).LookAtRHToRef(position, target, up, this._viewMatrix);
        else (0, $ha1VO.Matrix).LookAtLHToRef(position, target, up, this._viewMatrix);
        if (this.parent) {
            const parentWorldMatrix = this.parent.getWorldMatrix();
            this._viewMatrix.invert();
            this._viewMatrix.multiplyToRef(parentWorldMatrix, this._viewMatrix);
            this._viewMatrix.getTranslationToRef(this._globalPosition);
            this._viewMatrix.invert();
            this._markSyncedWithParent();
        } else this._globalPosition.copyFrom(position);
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createRigCamera(name, cameraIndex) {
        if (this.cameraRigMode !== (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_NONE) {
            const rigCamera = new $b739cdf8d675d7c2$export$afbb020f06951903(name, this.position.clone(), this.getScene());
            rigCamera.isRigCamera = true;
            rigCamera.rigParent = this;
            if (this.cameraRigMode === (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_VR) {
                if (!this.rotationQuaternion) this.rotationQuaternion = new (0, $ha1VO.Quaternion)();
                rigCamera._cameraRigParams = {};
                rigCamera.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            }
            rigCamera.mode = this.mode;
            rigCamera.orthoLeft = this.orthoLeft;
            rigCamera.orthoRight = this.orthoRight;
            rigCamera.orthoTop = this.orthoTop;
            rigCamera.orthoBottom = this.orthoBottom;
            return rigCamera;
        }
        return null;
    }
    /**
     * @internal
     */ _updateRigCameras() {
        const camLeft = this._rigCameras[0];
        const camRight = this._rigCameras[1];
        this.computeWorldMatrix();
        switch(this.cameraRigMode){
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_ANAGLYPH:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_OVERUNDER:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_INTERLACED:
                {
                    //provisionnaly using _cameraRigParams.stereoHalfAngle instead of calculations based on _cameraRigParams.interaxialDistance:
                    const leftSign = this.cameraRigMode === (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? 1 : -1;
                    const rightSign = this.cameraRigMode === (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? -1 : 1;
                    this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * leftSign, camLeft);
                    this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * rightSign, camRight);
                    break;
                }
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_VR:
                if (camLeft.rotationQuaternion) {
                    camLeft.rotationQuaternion.copyFrom(this.rotationQuaternion);
                    camRight.rotationQuaternion.copyFrom(this.rotationQuaternion);
                } else {
                    camLeft.rotation.copyFrom(this.rotation);
                    camRight.rotation.copyFrom(this.rotation);
                }
                camLeft.position.copyFrom(this.position);
                camRight.position.copyFrom(this.position);
                break;
        }
        super._updateRigCameras();
    }
    _getRigCamPositionAndTarget(halfSpace, rigCamera) {
        const target = this.getTarget();
        target.subtractToRef(this.position, $b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint);
        $b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint.normalize().scaleInPlace(this._initialFocalDistance);
        const newFocalTarget = $b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint.addInPlace(this.position);
        (0, $ha1VO.Matrix).TranslationToRef(-newFocalTarget.x, -newFocalTarget.y, -newFocalTarget.z, $b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix);
        $b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix.multiplyToRef((0, $ha1VO.Matrix).RotationAxis(rigCamera.upVector, halfSpace), $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix);
        (0, $ha1VO.Matrix).TranslationToRef(newFocalTarget.x, newFocalTarget.y, newFocalTarget.z, $b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix);
        $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix.multiplyToRef($b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix, $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this.position, $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix, rigCamera.position);
        rigCamera.setTarget(newFocalTarget);
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "TargetCamera";
    }
}
$b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix = new (0, $ha1VO.Matrix)();
$b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix = new (0, $ha1VO.Matrix)();
$b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint = new (0, $ha1VO.Vector3)();
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "ignoreParentScaling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "updateUpVectorFromRotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "rotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "speed", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)("lockedTargetId")
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "lockedTarget", void 0);



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $kVtWi = parcelRequire("kVtWi");

var $6Ho1L = parcelRequire("6Ho1L");

var $1920200f7582fd1d$export$19a2c4de0d3d218f = {};
class $1920200f7582fd1d$export$6f455b9fd6012781 {
    /**
     * Instantiate a new Camera Input Manager.
     * @param camera Defines the camera the input manager belongs to
     */ constructor(camera){
        /**
         * Defines the dom element the camera is collecting inputs from.
         * This is null if the controls have not been attached.
         */ this.attachedToElement = false;
        this.attached = {};
        this.camera = camera;
        this.checkInputs = ()=>{};
    }
    /**
     * Add an input method to a camera
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     * @param input Camera input method
     */ add(input) {
        const type = input.getSimpleName();
        if (this.attached[type]) {
            (0, $kVtWi.Logger).Warn("camera input of type " + type + " already exists on camera");
            return;
        }
        this.attached[type] = input;
        input.camera = this.camera;
        // for checkInputs, we are dynamically creating a function
        // the goal is to avoid the performance penalty of looping for inputs in the render loop
        if (input.checkInputs) this.checkInputs = this._addCheckInputs(input.checkInputs.bind(input));
        if (this.attachedToElement) input.attachControl(this.noPreventDefault);
    }
    /**
     * Remove a specific input method from a camera
     * example: camera.inputs.remove(camera.inputs.attached.mouse);
     * @param inputToRemove camera input method
     */ remove(inputToRemove) {
        for(const cam in this.attached){
            const input = this.attached[cam];
            if (input === inputToRemove) {
                input.detachControl();
                input.camera = null;
                delete this.attached[cam];
                this.rebuildInputCheck();
                return;
            }
        }
    }
    /**
     * Remove a specific input type from a camera
     * example: camera.inputs.remove("ArcRotateCameraGamepadInput");
     * @param inputType the type of the input to remove
     */ removeByType(inputType) {
        for(const cam in this.attached){
            const input = this.attached[cam];
            if (input.getClassName() === inputType) {
                input.detachControl();
                input.camera = null;
                delete this.attached[cam];
                this.rebuildInputCheck();
            }
        }
    }
    _addCheckInputs(fn) {
        const current = this.checkInputs;
        return ()=>{
            current();
            fn();
        };
    }
    /**
     * Attach the input controls to the currently attached dom element to listen the events from.
     * @param input Defines the input to attach
     */ attachInput(input) {
        if (this.attachedToElement) input.attachControl(this.noPreventDefault);
    }
    /**
     * Attach the current manager inputs controls to a specific dom element to listen the events from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachElement(noPreventDefault = false) {
        if (this.attachedToElement) return;
        noPreventDefault = (0, $52736139c8513fb2$export$79f141de891a5fed).ForceAttachControlToAlwaysPreventDefault ? false : noPreventDefault;
        this.attachedToElement = true;
        this.noPreventDefault = noPreventDefault;
        for(const cam in this.attached)this.attached[cam].attachControl(noPreventDefault);
    }
    /**
     * Detach the current manager inputs controls from a specific dom element.
     * @param disconnect Defines whether the input should be removed from the current list of attached inputs
     */ detachElement(disconnect = false) {
        for(const cam in this.attached){
            this.attached[cam].detachControl();
            if (disconnect) this.attached[cam].camera = null;
        }
        this.attachedToElement = false;
    }
    /**
     * Rebuild the dynamic inputCheck function from the current list of
     * defined inputs in the manager.
     */ rebuildInputCheck() {
        this.checkInputs = ()=>{};
        for(const cam in this.attached){
            const input = this.attached[cam];
            if (input.checkInputs) this.checkInputs = this._addCheckInputs(input.checkInputs.bind(input));
        }
    }
    /**
     * Remove all attached input methods from a camera
     */ clear() {
        if (this.attachedToElement) this.detachElement(true);
        this.attached = {};
        this.attachedToElement = false;
        this.checkInputs = ()=>{};
    }
    /**
     * Serialize the current input manager attached to a camera.
     * This ensures than once parsed,
     * the input associated to the camera will be identical to the current ones
     * @param serializedCamera Defines the camera serialization JSON the input serialization should write to
     */ serialize(serializedCamera) {
        const inputs = {};
        for(const cam in this.attached){
            const input = this.attached[cam];
            const res = (0, $6Ho1L.SerializationHelper).Serialize(input);
            inputs[input.getClassName()] = res;
        }
        serializedCamera.inputsmgr = inputs;
    }
    /**
     * Parses an input manager serialized JSON to restore the previous list of inputs
     * and states associated to a camera.
     * @param parsedCamera Defines the JSON to parse
     */ parse(parsedCamera) {
        const parsedInputs = parsedCamera.inputsmgr;
        if (parsedInputs) {
            this.clear();
            for(const n in parsedInputs){
                const construct = $1920200f7582fd1d$export$19a2c4de0d3d218f[n];
                if (construct) {
                    const parsedinput = parsedInputs[n];
                    const input = (0, $6Ho1L.SerializationHelper).Parse(()=>{
                        return new construct();
                    }, parsedinput, null);
                    this.add(input);
                }
            }
        } else //2016-03-08 this part is for managing backward compatibility
        for(const n in this.attached){
            const construct = $1920200f7582fd1d$export$19a2c4de0d3d218f[this.attached[n].getClassName()];
            if (construct) {
                const input = (0, $6Ho1L.SerializationHelper).Parse(()=>{
                    return new construct();
                }, parsedCamera, null);
                this.remove(this.attached[n]);
                this.add(input);
            }
        }
    }
}



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $cfkw4 = parcelRequire("cfkw4");
class $8fe18f34372a4966$export$7aa7850931793f07 {
    constructor(){
        this._currentActiveButton = -1;
        /**
         * Defines the buttons associated with the input to handle camera move.
         */ this.buttons = [
            0,
            1,
            2
        ];
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        const engine = this.camera.getEngine();
        const element = engine.getInputElement();
        let previousPinchSquaredDistance = 0;
        let previousMultiTouchPanPosition = null;
        this._pointA = null;
        this._pointB = null;
        this._altKey = false;
        this._ctrlKey = false;
        this._metaKey = false;
        this._shiftKey = false;
        this._buttonsPressed = 0;
        this._pointerInput = (p)=>{
            const evt = p.event;
            const isTouch = evt.pointerType === "touch";
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && this.buttons.indexOf(evt.button) === -1) return;
            const srcElement = evt.target;
            this._altKey = evt.altKey;
            this._ctrlKey = evt.ctrlKey;
            this._metaKey = evt.metaKey;
            this._shiftKey = evt.shiftKey;
            this._buttonsPressed = evt.buttons;
            if (engine.isPointerLock) {
                const offsetX = evt.movementX;
                const offsetY = evt.movementY;
                this.onTouch(null, offsetX, offsetY);
                this._pointA = null;
                this._pointB = null;
            } else if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && p.type !== (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP && isTouch && this._pointA?.pointerId !== evt.pointerId && this._pointB?.pointerId !== evt.pointerId) return; // If we get a non-down event for a touch that we're not tracking, ignore it
            else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN && (this._currentActiveButton === -1 || isTouch)) {
                try {
                    srcElement?.setPointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error. Execution will continue.
                }
                if (this._pointA === null) this._pointA = {
                    x: evt.clientX,
                    y: evt.clientY,
                    pointerId: evt.pointerId,
                    type: evt.pointerType
                };
                else if (this._pointB === null) this._pointB = {
                    x: evt.clientX,
                    y: evt.clientY,
                    pointerId: evt.pointerId,
                    type: evt.pointerType
                };
                else return; // We are already tracking two pointers so ignore this one
                if (this._currentActiveButton === -1 && !isTouch) this._currentActiveButton = evt.button;
                this.onButtonDown(evt);
                if (!noPreventDefault) {
                    evt.preventDefault();
                    element && element.focus();
                }
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) this.onDoubleTap(evt.pointerType);
            else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERUP && (this._currentActiveButton === evt.button || isTouch)) {
                try {
                    srcElement?.releasePointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error.
                }
                if (!isTouch) this._pointB = null; // Mouse and pen are mono pointer
                //would be better to use pointers.remove(evt.pointerId) for multitouch gestures,
                //but emptying completely pointers collection is required to fix a bug on iPhone :
                //when changing orientation while pinching camera,
                //one pointer stay pressed forever if we don't release all pointers
                //will be ok to put back pointers.remove(evt.pointerId); when iPhone bug corrected
                if (engine._badOS) this._pointA = this._pointB = null;
                else {
                    //only remove the impacted pointer in case of multitouch allowing on most
                    //platforms switching from rotate to zoom and pan seamlessly.
                    if (this._pointB && this._pointA && this._pointA.pointerId == evt.pointerId) {
                        this._pointA = this._pointB;
                        this._pointB = null;
                    } else if (this._pointA && this._pointB && this._pointB.pointerId == evt.pointerId) this._pointB = null;
                    else this._pointA = this._pointB = null;
                }
                if (previousPinchSquaredDistance !== 0 || previousMultiTouchPanPosition) {
                    // Previous pinch data is populated but a button has been lifted
                    // so pinch has ended.
                    this.onMultiTouch(this._pointA, this._pointB, previousPinchSquaredDistance, 0, previousMultiTouchPanPosition, null // multiTouchPanPosition
                    );
                    previousPinchSquaredDistance = 0;
                    previousMultiTouchPanPosition = null;
                }
                this._currentActiveButton = -1;
                this.onButtonUp(evt);
                if (!noPreventDefault) evt.preventDefault();
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (!noPreventDefault) evt.preventDefault();
                // One button down
                if (this._pointA && this._pointB === null) {
                    const offsetX = evt.clientX - this._pointA.x;
                    const offsetY = evt.clientY - this._pointA.y;
                    this._pointA.x = evt.clientX;
                    this._pointA.y = evt.clientY;
                    this.onTouch(this._pointA, offsetX, offsetY);
                } else if (this._pointA && this._pointB) {
                    const ed = this._pointA.pointerId === evt.pointerId ? this._pointA : this._pointB;
                    ed.x = evt.clientX;
                    ed.y = evt.clientY;
                    const distX = this._pointA.x - this._pointB.x;
                    const distY = this._pointA.y - this._pointB.y;
                    const pinchSquaredDistance = distX * distX + distY * distY;
                    const multiTouchPanPosition = {
                        x: (this._pointA.x + this._pointB.x) / 2,
                        y: (this._pointA.y + this._pointB.y) / 2,
                        pointerId: evt.pointerId,
                        type: p.type
                    };
                    this.onMultiTouch(this._pointA, this._pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition);
                    previousMultiTouchPanPosition = multiTouchPanPosition;
                    previousPinchSquaredDistance = pinchSquaredDistance;
                }
            }
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE | (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
        this._onLostFocus = ()=>{
            this._pointA = this._pointB = null;
            previousPinchSquaredDistance = 0;
            previousMultiTouchPanPosition = null;
            this.onLostFocus();
        };
        this._contextMenuBind = (evt)=>this.onContextMenu(evt);
        element && element.addEventListener("contextmenu", this._contextMenuBind, false);
        const hostWindow = this.camera.getScene().getEngine().getHostWindow();
        if (hostWindow) (0, $bOhSV.Tools).RegisterTopRootEvents(hostWindow, [
            {
                name: "blur",
                handler: this._onLostFocus
            }
        ]);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._onLostFocus) {
            const hostWindow = this.camera.getScene().getEngine().getHostWindow();
            if (hostWindow) (0, $bOhSV.Tools).UnregisterTopRootEvents(hostWindow, [
                {
                    name: "blur",
                    handler: this._onLostFocus
                }
            ]);
        }
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this._observer = null;
            if (this._contextMenuBind) {
                const inputElement = this.camera.getScene().getEngine().getInputElement();
                inputElement && inputElement.removeEventListener("contextmenu", this._contextMenuBind);
            }
            this._onLostFocus = null;
        }
        this._altKey = false;
        this._ctrlKey = false;
        this._metaKey = false;
        this._shiftKey = false;
        this._buttonsPressed = 0;
        this._currentActiveButton = -1;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "BaseCameraPointersInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "pointers";
    }
    /**
     * Called on pointer POINTERDOUBLETAP event.
     * Override this method to provide functionality on POINTERDOUBLETAP event.
     * @param type type of event
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDoubleTap(type) {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    /**
     * Called on pointer POINTERMOVE event if only a single touch is active.
     * Override this method to provide functionality.
     * @param point The current position of the pointer
     * @param offsetX The offsetX of the pointer when the event occurred
     * @param offsetY The offsetY of the pointer when the event occurred
     */ onTouch(point, offsetX, offsetY) {}
    /**
     * Called on pointer POINTERMOVE event if multiple touches are active.
     * Override this method to provide functionality.
     * @param _pointA First point in the pair
     * @param _pointB Second point in the pair
     * @param previousPinchSquaredDistance Sqr Distance between the points the last time this event was fired (by this input)
     * @param pinchSquaredDistance Sqr Distance between the points this time
     * @param previousMultiTouchPanPosition Previous center point between the points
     * @param multiTouchPanPosition Current center point between the points
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onMultiTouch(_pointA, _pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) {}
    /**
     * Called on JS contextmenu event.
     * Override this method to provide functionality.
     * @param evt the event to be handled
     */ onContextMenu(evt) {
        evt.preventDefault();
    }
    /**
     * Called each time a new POINTERDOWN event occurs. Ie, for each button
     * press.
     * Override this method to provide functionality.
     * @param _evt Defines the event to track
     */ onButtonDown(_evt) {}
    /**
     * Called each time a new POINTERUP event occurs. Ie, for each button
     * release.
     * Override this method to provide functionality.
     * @param _evt Defines the event to track
     */ onButtonUp(_evt) {}
    /**
     * Called when window becomes inactive.
     * Override this method to provide functionality.
     */ onLostFocus() {}
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8fe18f34372a4966$export$7aa7850931793f07.prototype, "buttons", void 0);


class $b7058fc4c829024a$export$3c1d686c016ce91b extends (0, $8fe18f34372a4966$export$7aa7850931793f07) {
    constructor(){
        super(...arguments);
        /**
         * Defines the buttons associated with the input to handle camera move.
         */ this.buttons = [
            0,
            1,
            2
        ];
        /**
         * Defines the pointer angular sensibility  along the X axis or how fast is
         * the camera rotating.
         */ this.angularSensibilityX = 1000.0;
        /**
         * Defines the pointer angular sensibility along the Y axis or how fast is
         * the camera rotating.
         */ this.angularSensibilityY = 1000.0;
        /**
         * Defines the pointer pinch precision or how fast is the camera zooming.
         */ this.pinchPrecision = 12.0;
        /**
         * pinchDeltaPercentage will be used instead of pinchPrecision if different
         * from 0.
         * It defines the percentage of current camera.radius to use as delta when
         * pinch zoom is used.
         */ this.pinchDeltaPercentage = 0;
        /**
         * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
         * that any object in the plane at the camera's target point will scale
         * perfectly with finger motion.
         * Overrides pinchDeltaPercentage and pinchPrecision.
         */ this.useNaturalPinchZoom = false;
        /**
         * Defines whether zoom (2 fingers pinch) is enabled through multitouch
         */ this.pinchZoom = true;
        /**
         * Defines the pointer panning sensibility or how fast is the camera moving.
         */ this.panningSensibility = 1000.0;
        /**
         * Defines whether panning (2 fingers swipe) is enabled through multitouch.
         */ this.multiTouchPanning = true;
        /**
         * Defines whether panning is enabled for both pan (2 fingers swipe) and
         * zoom (pinch) through multitouch.
         */ this.multiTouchPanAndZoom = true;
        /**
         * Revers pinch action direction.
         */ this.pinchInwards = true;
        this._isPanClick = false;
        this._twoFingerActivityCount = 0;
        this._isPinching = false;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraPointersInput";
    }
    /**
     * Move camera from multi touch panning positions.
     * @param previousMultiTouchPanPosition
     * @param multiTouchPanPosition
     */ _computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition) {
        if (this.panningSensibility !== 0 && previousMultiTouchPanPosition && multiTouchPanPosition) {
            const moveDeltaX = multiTouchPanPosition.x - previousMultiTouchPanPosition.x;
            const moveDeltaY = multiTouchPanPosition.y - previousMultiTouchPanPosition.y;
            this.camera.inertialPanningX += -moveDeltaX / this.panningSensibility;
            this.camera.inertialPanningY += moveDeltaY / this.panningSensibility;
        }
    }
    /**
     * Move camera from pinch zoom distances.
     * @param previousPinchSquaredDistance
     * @param pinchSquaredDistance
     */ _computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance) {
        const radius = this.camera.radius || $b7058fc4c829024a$export$3c1d686c016ce91b.MinimumRadiusForPinch;
        if (this.useNaturalPinchZoom) this.camera.radius = radius * Math.sqrt(previousPinchSquaredDistance) / Math.sqrt(pinchSquaredDistance);
        else if (this.pinchDeltaPercentage) this.camera.inertialRadiusOffset += (pinchSquaredDistance - previousPinchSquaredDistance) * 0.001 * radius * this.pinchDeltaPercentage;
        else this.camera.inertialRadiusOffset += (pinchSquaredDistance - previousPinchSquaredDistance) / (this.pinchPrecision * (this.pinchInwards ? 1 : -1) * (this.angularSensibilityX + this.angularSensibilityY) / 2);
    }
    /**
     * Called on pointer POINTERMOVE event if only a single touch is active.
     * @param point current touch point
     * @param offsetX offset on X
     * @param offsetY offset on Y
     */ onTouch(point, offsetX, offsetY) {
        if (this.panningSensibility !== 0 && (this._ctrlKey && this.camera._useCtrlForPanning || this._isPanClick)) {
            this.camera.inertialPanningX += -offsetX / this.panningSensibility;
            this.camera.inertialPanningY += offsetY / this.panningSensibility;
        } else {
            this.camera.inertialAlphaOffset -= offsetX / this.angularSensibilityX;
            this.camera.inertialBetaOffset -= offsetY / this.angularSensibilityY;
        }
    }
    /**
     * Called on pointer POINTERDOUBLETAP event.
     */ onDoubleTap() {
        if (this.camera.useInputToRestoreState) this.camera.restoreState();
    }
    /**
     * Called on pointer POINTERMOVE event if multiple touches are active.
     * @param pointA point A
     * @param pointB point B
     * @param previousPinchSquaredDistance distance between points in previous pinch
     * @param pinchSquaredDistance distance between points in current pinch
     * @param previousMultiTouchPanPosition multi-touch position in previous step
     * @param multiTouchPanPosition multi-touch position in current step
     */ onMultiTouch(pointA, pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) {
        if (previousPinchSquaredDistance === 0 && previousMultiTouchPanPosition === null) // First time this method is called for new pinch.
        // Next time this is called there will be a
        // previousPinchSquaredDistance and pinchSquaredDistance to compare.
        return;
        if (pinchSquaredDistance === 0 && multiTouchPanPosition === null) // Last time this method is called at the end of a pinch.
        return;
        // Zoom and panning enabled together
        if (this.multiTouchPanAndZoom) {
            this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
            this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
        // Zoom and panning enabled but only one at a time
        } else if (this.multiTouchPanning && this.pinchZoom) {
            this._twoFingerActivityCount++;
            if (this._isPinching || this._twoFingerActivityCount < 20 && Math.abs(Math.sqrt(pinchSquaredDistance) - Math.sqrt(previousPinchSquaredDistance)) > this.camera.pinchToPanMaxDistance) {
                // Since pinch has not been active long, assume we intend to zoom.
                this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
                // Since we are pinching, remain pinching on next iteration.
                this._isPinching = true;
            } else // Pause between pinch starting and moving implies not a zoom event. Pan instead.
            this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
        // Panning enabled, zoom disabled
        } else if (this.multiTouchPanning) this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
        else if (this.pinchZoom) this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
    }
    /**
     * Called each time a new POINTERDOWN event occurs. Ie, for each button
     * press.
     * @param evt Defines the event to track
     */ onButtonDown(evt) {
        this._isPanClick = evt.button === this.camera._panningMouseButton;
    }
    /**
     * Called each time a new POINTERUP event occurs. Ie, for each button
     * release.
     * @param _evt Defines the event to track
     */ onButtonUp(_evt) {
        this._twoFingerActivityCount = 0;
        this._isPinching = false;
    }
    /**
     * Called when window becomes inactive.
     */ onLostFocus() {
        this._isPanClick = false;
        this._twoFingerActivityCount = 0;
        this._isPinching = false;
    }
}
/**
 * The minimum radius used for pinch, to avoid radius lock at 0
 */ $b7058fc4c829024a$export$3c1d686c016ce91b.MinimumRadiusForPinch = 0.001;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "buttons", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "angularSensibilityX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "angularSensibilityY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "pinchPrecision", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "pinchDeltaPercentage", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "useNaturalPinchZoom", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "pinchZoom", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "panningSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "multiTouchPanning", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "multiTouchPanAndZoom", void 0);
(0, $1920200f7582fd1d$export$19a2c4de0d3d218f)["ArcRotateCameraPointersInput"] = $b7058fc4c829024a$export$3c1d686c016ce91b;



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");


var $bcFoB = parcelRequire("bcFoB");

var $bOhSV = parcelRequire("bOhSV");
class $181b46c40b28cc66$export$5968949a47534c31 {
    constructor(){
        /**
         * Defines the list of key codes associated with the up action (increase alpha)
         */ this.keysUp = [
            38
        ];
        /**
         * Defines the list of key codes associated with the down action (decrease alpha)
         */ this.keysDown = [
            40
        ];
        /**
         * Defines the list of key codes associated with the left action (increase beta)
         */ this.keysLeft = [
            37
        ];
        /**
         * Defines the list of key codes associated with the right action (decrease beta)
         */ this.keysRight = [
            39
        ];
        /**
         * Defines the list of key codes associated with the reset action.
         * Those keys reset the camera to its last stored state (with the method camera.storeState())
         */ this.keysReset = [
            220
        ];
        /**
         * Defines the panning sensibility of the inputs.
         * (How fast is the camera panning)
         */ this.panningSensibility = 50.0;
        /**
         * Defines the zooming sensibility of the inputs.
         * (How fast is the camera zooming)
         */ this.zoomingSensibility = 25.0;
        /**
         * Defines whether maintaining the alt key down switch the movement mode from
         * orientation to zoom.
         */ this.useAltToZoom = true;
        /**
         * Rotation speed of the camera
         */ this.angularSpeed = 0.01;
        this._keys = new Array();
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // was there a second variable defined?
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        if (this._onCanvasBlurObserver) return;
        this._scene = this.camera.getScene();
        this._engine = this._scene.getEngine();
        this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(()=>{
            this._keys.length = 0;
        });
        this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info)=>{
            const evt = info.event;
            if (!evt.metaKey) {
                if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) {
                    this._ctrlPressed = evt.ctrlKey;
                    this._altPressed = evt.altKey;
                    if (this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1 || this.keysReset.indexOf(evt.keyCode) !== -1) {
                        const index = this._keys.indexOf(evt.keyCode);
                        if (index === -1) this._keys.push(evt.keyCode);
                        if (evt.preventDefault) {
                            if (!noPreventDefault) evt.preventDefault();
                        }
                    }
                } else if (this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1 || this.keysReset.indexOf(evt.keyCode) !== -1) {
                    const index = this._keys.indexOf(evt.keyCode);
                    if (index >= 0) this._keys.splice(index, 1);
                    if (evt.preventDefault) {
                        if (!noPreventDefault) evt.preventDefault();
                    }
                }
            }
        });
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._scene) {
            if (this._onKeyboardObserver) this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
            if (this._onCanvasBlurObserver) this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
            this._onKeyboardObserver = null;
            this._onCanvasBlurObserver = null;
        }
        this._keys.length = 0;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._onKeyboardObserver) {
            const camera = this.camera;
            for(let index = 0; index < this._keys.length; index++){
                const keyCode = this._keys[index];
                if (this.keysLeft.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningX -= 1 / this.panningSensibility;
                    else camera.inertialAlphaOffset -= this.angularSpeed;
                } else if (this.keysUp.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningY += 1 / this.panningSensibility;
                    else if (this._altPressed && this.useAltToZoom) camera.inertialRadiusOffset += 1 / this.zoomingSensibility;
                    else camera.inertialBetaOffset -= this.angularSpeed;
                } else if (this.keysRight.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningX += 1 / this.panningSensibility;
                    else camera.inertialAlphaOffset += this.angularSpeed;
                } else if (this.keysDown.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningY -= 1 / this.panningSensibility;
                    else if (this._altPressed && this.useAltToZoom) camera.inertialRadiusOffset -= 1 / this.zoomingSensibility;
                    else camera.inertialBetaOffset += this.angularSpeed;
                } else if (this.keysReset.indexOf(keyCode) !== -1) {
                    if (camera.useInputToRestoreState) camera.restoreState();
                }
            }
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraKeyboardMoveInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "keyboard";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysUp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysDown", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysLeft", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysRight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysReset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "panningSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "zoomingSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "useAltToZoom", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "angularSpeed", void 0);
(0, $1920200f7582fd1d$export$19a2c4de0d3d218f)["ArcRotateCameraKeyboardMoveInput"] = $181b46c40b28cc66$export$5968949a47534c31;



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");


var $cfkw4 = parcelRequire("cfkw4");

var $23POp = parcelRequire("23POp");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");

var $jzXHO = parcelRequire("jzXHO");

var $iosaP = parcelRequire("iosaP");

var $bOhSV = parcelRequire("bOhSV");
/**
 * Firefox uses a different scheme to report scroll distances to other
 * browsers. Rather than use complicated methods to calculate the exact
 * multiple we need to apply, let's just cheat and use a constant.
 * https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode
 * https://stackoverflow.com/questions/20110224/what-is-the-height-of-a-line-in-a-wheel-event-deltamode-dom-delta-line
 */ const $79e18bc39470cd29$var$ffMultiplier = 40;
class $79e18bc39470cd29$export$6603ac392977df4 {
    constructor(){
        /**
         * Gets or Set the mouse wheel precision or how fast is the camera zooming.
         */ this.wheelPrecision = 3.0;
        /**
         * Gets or Set the boolean value that controls whether or not the mouse wheel
         * zooms to the location of the mouse pointer or not.  The default is false.
         */ this.zoomToMouseLocation = false;
        /**
         * wheelDeltaPercentage will be used instead of wheelPrecision if different from 0.
         * It defines the percentage of current camera.radius to use as delta when wheel is used.
         */ this.wheelDeltaPercentage = 0;
        /**
         * If set, this function will be used to set the radius delta that will be added to the current camera radius
         */ this.customComputeDeltaFromMouseWheel = null;
        this._viewOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._globalOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._inertialPanning = (0, $ha1VO.Vector3).Zero();
    }
    _computeDeltaFromMouseWheelLegacyEvent(mouseWheelDelta, radius) {
        let delta = 0;
        const wheelDelta = mouseWheelDelta * 0.01 * this.wheelDeltaPercentage * radius;
        if (mouseWheelDelta > 0) delta = wheelDelta / (1.0 + this.wheelDeltaPercentage);
        else delta = wheelDelta * (1.0 + this.wheelDeltaPercentage);
        return delta;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this._wheel = (p)=>{
            //sanity check - this should be a PointerWheel event.
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            const event = p.event;
            let delta = 0;
            const platformScale = event.deltaMode === (0, $jzXHO.EventConstants).DOM_DELTA_LINE ? $79e18bc39470cd29$var$ffMultiplier : 1; // If this happens to be set to DOM_DELTA_LINE, adjust accordingly
            const wheelDelta = -(event.deltaY * platformScale);
            if (this.customComputeDeltaFromMouseWheel) delta = this.customComputeDeltaFromMouseWheel(wheelDelta, this, event);
            else if (this.wheelDeltaPercentage) {
                delta = this._computeDeltaFromMouseWheelLegacyEvent(wheelDelta, this.camera.radius);
                // If zooming in, estimate the target radius and use that to compute the delta for inertia
                // this will stop multiple scroll events zooming in from adding too much inertia
                if (delta > 0) {
                    let estimatedTargetRadius = this.camera.radius;
                    let targetInertia = this.camera.inertialRadiusOffset + delta;
                    for(let i = 0; i < 20 && Math.abs(targetInertia) > 0.001; i++){
                        estimatedTargetRadius -= targetInertia;
                        targetInertia *= this.camera.inertia;
                    }
                    estimatedTargetRadius = (0, $iosaP.Clamp)(estimatedTargetRadius, 0, Number.MAX_VALUE);
                    delta = this._computeDeltaFromMouseWheelLegacyEvent(wheelDelta, estimatedTargetRadius);
                }
            } else delta = wheelDelta / (this.wheelPrecision * 40);
            if (delta) {
                if (this.zoomToMouseLocation) {
                    // If we are zooming to the mouse location, then we need to get the hit plane at the start of the zoom gesture if it doesn't exist
                    // The hit plane is normally calculated after the first motion and each time there's motion so if we don't do this first,
                    // the first zoom will be to the center of the screen
                    if (!this._hitPlane) this._updateHitPlane();
                    this._zoomToMouse(delta);
                } else this.camera.inertialRadiusOffset += delta;
            }
            if (event.preventDefault) {
                if (!noPreventDefault) event.preventDefault();
            }
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, (0, $cfkw4.PointerEventTypes).POINTERWHEEL);
        if (this.zoomToMouseLocation) this._inertialPanning.setAll(0);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this._observer = null;
            this._wheel = null;
        }
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (!this.zoomToMouseLocation) return;
        const camera = this.camera;
        const motion = 0.0 + camera.inertialAlphaOffset + camera.inertialBetaOffset + camera.inertialRadiusOffset;
        if (motion) {
            // if zooming is still happening as a result of inertia, then we also need to update
            // the hit plane.
            this._updateHitPlane();
            // Note we cannot  use arcRotateCamera.inertialPlanning here because arcRotateCamera panning
            // uses a different panningInertia which could cause this panning to get out of sync with
            // the zooming, and for this to work they must be exactly in sync.
            camera.target.addInPlace(this._inertialPanning);
            this._inertialPanning.scaleInPlace(camera.inertia);
            this._zeroIfClose(this._inertialPanning);
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraMouseWheelInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "mousewheel";
    }
    _updateHitPlane() {
        const camera = this.camera;
        const direction = camera.target.subtract(camera.position);
        this._hitPlane = (0, $23POp.Plane).FromPositionAndNormal(camera.target, direction);
    }
    // Get position on the hit plane
    _getPosition() {
        const camera = this.camera;
        const scene = camera.getScene();
        // since the _hitPlane is always updated to be orthogonal to the camera position vector
        // we don't have to worry about this ray shooting off to infinity. This ray creates
        // a vector defining where we want to zoom to.
        const ray = scene.createPickingRay(scene.pointerX, scene.pointerY, (0, $ha1VO.Matrix).Identity(), camera, false);
        // Since the camera is the origin of the picking ray, we need to offset it by the camera's offset manually
        // Because the offset is in view space, we need to convert it to world space first
        if (camera.targetScreenOffset.x !== 0 || camera.targetScreenOffset.y !== 0) {
            this._viewOffset.set(camera.targetScreenOffset.x, camera.targetScreenOffset.y, 0);
            camera.getViewMatrix().invertToRef(camera._cameraTransformMatrix);
            this._globalOffset = (0, $ha1VO.Vector3).TransformNormal(this._viewOffset, camera._cameraTransformMatrix);
            ray.origin.addInPlace(this._globalOffset);
        }
        let distance = 0;
        if (this._hitPlane) distance = ray.intersectsPlane(this._hitPlane) ?? 0;
        // not using this ray again, so modifying its vectors here is fine
        return ray.origin.addInPlace(ray.direction.scaleInPlace(distance));
    }
    _zoomToMouse(delta) {
        const camera = this.camera;
        const inertiaComp = 1 - camera.inertia;
        if (camera.lowerRadiusLimit) {
            const lowerLimit = camera.lowerRadiusLimit ?? 0;
            if (camera.radius - (camera.inertialRadiusOffset + delta) / inertiaComp < lowerLimit) delta = (camera.radius - lowerLimit) * inertiaComp - camera.inertialRadiusOffset;
        }
        if (camera.upperRadiusLimit) {
            const upperLimit = camera.upperRadiusLimit ?? 0;
            if (camera.radius - (camera.inertialRadiusOffset + delta) / inertiaComp > upperLimit) delta = (camera.radius - upperLimit) * inertiaComp - camera.inertialRadiusOffset;
        }
        const zoomDistance = delta / inertiaComp;
        const ratio = zoomDistance / camera.radius;
        const vec = this._getPosition();
        // Now this vector tells us how much we also need to pan the camera
        // so the targeted mouse location becomes the center of zooming.
        const directionToZoomLocation = (0, $ha1VO.TmpVectors).Vector3[6];
        vec.subtractToRef(camera.target, directionToZoomLocation);
        directionToZoomLocation.scaleInPlace(ratio);
        directionToZoomLocation.scaleInPlace(inertiaComp);
        this._inertialPanning.addInPlace(directionToZoomLocation);
        camera.inertialRadiusOffset += delta;
    }
    // Sets x y or z of passed in vector to zero if less than Epsilon.
    _zeroIfClose(vec) {
        if (Math.abs(vec.x) < (0, $53VPf.Epsilon)) vec.x = 0;
        if (Math.abs(vec.y) < (0, $53VPf.Epsilon)) vec.y = 0;
        if (Math.abs(vec.z) < (0, $53VPf.Epsilon)) vec.z = 0;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $79e18bc39470cd29$export$6603ac392977df4.prototype, "wheelPrecision", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $79e18bc39470cd29$export$6603ac392977df4.prototype, "zoomToMouseLocation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $79e18bc39470cd29$export$6603ac392977df4.prototype, "wheelDeltaPercentage", void 0);
(0, $1920200f7582fd1d$export$19a2c4de0d3d218f)["ArcRotateCameraMouseWheelInput"] = $79e18bc39470cd29$export$6603ac392977df4;



class $bef5be55ba1ec18a$export$cbf1896b2dde8a14 extends (0, $1920200f7582fd1d$export$6f455b9fd6012781) {
    /**
     * Instantiates a new ArcRotateCameraInputsManager.
     * @param camera Defines the camera the inputs belong to
     */ constructor(camera){
        super(camera);
    }
    /**
     * Add mouse wheel input support to the input manager.
     * @returns the current input manager
     */ addMouseWheel() {
        this.add(new (0, $79e18bc39470cd29$export$6603ac392977df4)());
        return this;
    }
    /**
     * Add pointers input support to the input manager.
     * @returns the current input manager
     */ addPointers() {
        this.add(new (0, $b7058fc4c829024a$export$3c1d686c016ce91b)());
        return this;
    }
    /**
     * Add keyboard input support to the input manager.
     * @returns the current input manager
     */ addKeyboard() {
        this.add(new (0, $181b46c40b28cc66$export$5968949a47534c31)());
        return this;
    }
}



var $53VPf = parcelRequire("53VPf");

var $bOhSV = parcelRequire("bOhSV");

var $8DoUR = parcelRequire("8DoUR");
(0, $021dcb6a570ae9c1$export$85c928794f8d04d4).AddNodeConstructor("ArcRotateCamera", (name, scene)=>{
    return ()=>new $e59f949a590d8aa8$export$8438041bb8e406c8(name, 0, 0, 1.0, (0, $ha1VO.Vector3).Zero(), scene);
});
class $e59f949a590d8aa8$export$8438041bb8e406c8 extends (0, $b739cdf8d675d7c2$export$afbb020f06951903) {
    /**
     * Defines the target point of the camera.
     * The camera looks towards it from the radius distance.
     */ get target() {
        return this._target;
    }
    set target(value) {
        this.setTarget(value);
    }
    /**
     * Defines the target transform node of the camera.
     * The camera looks towards it from the radius distance.
     * Please note that setting a target host will disable panning.
     */ get targetHost() {
        return this._targetHost;
    }
    set targetHost(value) {
        if (value) this.setTarget(value);
    }
    /**
     * Return the current target position of the camera. This value is expressed in local space.
     * @returns the target position
     */ getTarget() {
        return this.target;
    }
    /**
     * Define the current local position of the camera in the scene
     */ get position() {
        return this._position;
    }
    set position(newPosition) {
        this.setPosition(newPosition);
    }
    /**
     * The vector the camera should consider as up. (default is Vector3(0, 1, 0) as returned by Vector3.Up())
     * Setting this will copy the given vector to the camera's upVector, and set rotation matrices to and from Y up.
     * DO NOT set the up vector using copyFrom or copyFromFloats, as this bypasses setting the above matrices.
     */ set upVector(vec) {
        if (!this._upToYMatrix) {
            this._yToUpMatrix = new (0, $ha1VO.Matrix)();
            this._upToYMatrix = new (0, $ha1VO.Matrix)();
            this._upVector = (0, $ha1VO.Vector3).Zero();
        }
        vec.normalize();
        this._upVector.copyFrom(vec);
        this.setMatUp();
    }
    get upVector() {
        return this._upVector;
    }
    /**
     * Sets the Y-up to camera up-vector rotation matrix, and the up-vector to Y-up rotation matrix.
     */ setMatUp() {
        // from y-up to custom-up (used in _getViewMatrix)
        (0, $ha1VO.Matrix).RotationAlignToRef((0, $ha1VO.Vector3).UpReadOnly, this._upVector, this._yToUpMatrix);
        // from custom-up to y-up (used in rebuildAnglesAndRadius)
        (0, $ha1VO.Matrix).RotationAlignToRef(this._upVector, (0, $ha1VO.Vector3).UpReadOnly, this._upToYMatrix);
    }
    //-- begin properties for backward compatibility for inputs
    /**
     * Gets or Set the pointer angular sensibility  along the X axis or how fast is the camera rotating.
     */ get angularSensibilityX() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.angularSensibilityX;
        return 0;
    }
    set angularSensibilityX(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.angularSensibilityX = value;
    }
    /**
     * Gets or Set the pointer angular sensibility along the Y axis or how fast is the camera rotating.
     */ get angularSensibilityY() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.angularSensibilityY;
        return 0;
    }
    set angularSensibilityY(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.angularSensibilityY = value;
    }
    /**
     * Gets or Set the pointer pinch precision or how fast is the camera zooming.
     */ get pinchPrecision() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.pinchPrecision;
        return 0;
    }
    set pinchPrecision(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.pinchPrecision = value;
    }
    /**
     * Gets or Set the pointer pinch delta percentage or how fast is the camera zooming.
     * It will be used instead of pinchPrecision if different from 0.
     * It defines the percentage of current camera.radius to use as delta when pinch zoom is used.
     */ get pinchDeltaPercentage() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.pinchDeltaPercentage;
        return 0;
    }
    set pinchDeltaPercentage(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.pinchDeltaPercentage = value;
    }
    /**
     * Gets or Set the pointer use natural pinch zoom to override the pinch precision
     * and pinch delta percentage.
     * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
     * that any object in the plane at the camera's target point will scale
     * perfectly with finger motion.
     */ get useNaturalPinchZoom() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.useNaturalPinchZoom;
        return false;
    }
    set useNaturalPinchZoom(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.useNaturalPinchZoom = value;
    }
    /**
     * Gets or Set the pointer panning sensibility or how fast is the camera moving.
     */ get panningSensibility() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.panningSensibility;
        return 0;
    }
    set panningSensibility(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.panningSensibility = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control beta angle in a positive direction.
     */ get keysUp() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysUp;
        return [];
    }
    set keysUp(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysUp = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control beta angle in a negative direction.
     */ get keysDown() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysDown;
        return [];
    }
    set keysDown(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysDown = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control alpha angle in a negative direction.
     */ get keysLeft() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysLeft;
        return [];
    }
    set keysLeft(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysLeft = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control alpha angle in a positive direction.
     */ get keysRight() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRight;
        return [];
    }
    set keysRight(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRight = value;
    }
    /**
     * Gets or Set the mouse wheel precision or how fast is the camera zooming.
     */ get wheelPrecision() {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) return mousewheel.wheelPrecision;
        return 0;
    }
    set wheelPrecision(value) {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) mousewheel.wheelPrecision = value;
    }
    /**
     * Gets or Set the boolean value that controls whether or not the mouse wheel
     * zooms to the location of the mouse pointer or not.  The default is false.
     */ get zoomToMouseLocation() {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) return mousewheel.zoomToMouseLocation;
        return false;
    }
    set zoomToMouseLocation(value) {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) mousewheel.zoomToMouseLocation = value;
    }
    /**
     * Gets or Set the mouse wheel delta percentage or how fast is the camera zooming.
     * It will be used instead of wheelPrecision if different from 0.
     * It defines the percentage of current camera.radius to use as delta when wheel zoom is used.
     */ get wheelDeltaPercentage() {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) return mousewheel.wheelDeltaPercentage;
        return 0;
    }
    set wheelDeltaPercentage(value) {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) mousewheel.wheelDeltaPercentage = value;
    }
    /**
     * Gets the bouncing behavior of the camera if it has been enabled.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
     */ get bouncingBehavior() {
        return this._bouncingBehavior;
    }
    /**
     * Defines if the bouncing behavior of the camera is enabled on the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
     */ get useBouncingBehavior() {
        return this._bouncingBehavior != null;
    }
    set useBouncingBehavior(value) {
        if (value === this.useBouncingBehavior) return;
        if (value) {
            this._bouncingBehavior = new (0, $8020ca7199b79bd4$export$bdf68dcd10685529)();
            this.addBehavior(this._bouncingBehavior);
        } else if (this._bouncingBehavior) {
            this.removeBehavior(this._bouncingBehavior);
            this._bouncingBehavior = null;
        }
    }
    /**
     * Gets the framing behavior of the camera if it has been enabled.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
     */ get framingBehavior() {
        return this._framingBehavior;
    }
    /**
     * Defines if the framing behavior of the camera is enabled on the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
     */ get useFramingBehavior() {
        return this._framingBehavior != null;
    }
    set useFramingBehavior(value) {
        if (value === this.useFramingBehavior) return;
        if (value) {
            this._framingBehavior = new (0, $e658c5daf376ba2a$export$77fc4267b4cbd0a1)();
            this.addBehavior(this._framingBehavior);
        } else if (this._framingBehavior) {
            this.removeBehavior(this._framingBehavior);
            this._framingBehavior = null;
        }
    }
    /**
     * Gets the auto rotation behavior of the camera if it has been enabled.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
     */ get autoRotationBehavior() {
        return this._autoRotationBehavior;
    }
    /**
     * Defines if the auto rotation behavior of the camera is enabled on the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
     */ get useAutoRotationBehavior() {
        return this._autoRotationBehavior != null;
    }
    set useAutoRotationBehavior(value) {
        if (value === this.useAutoRotationBehavior) return;
        if (value) {
            this._autoRotationBehavior = new (0, $549bdcf6bf9469ac$export$26177590adee994)();
            this.addBehavior(this._autoRotationBehavior);
        } else if (this._autoRotationBehavior) {
            this.removeBehavior(this._autoRotationBehavior);
            this._autoRotationBehavior = null;
        }
    }
    /**
     * Instantiates a new ArcRotateCamera in a given scene
     * @param name Defines the name of the camera
     * @param alpha Defines the camera rotation along the longitudinal axis
     * @param beta Defines the camera rotation along the latitudinal axis
     * @param radius Defines the camera distance from its target
     * @param target Defines the camera target
     * @param scene Defines the scene the camera belongs to
     * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
     */ constructor(name, alpha, beta, radius, target, scene, setActiveOnSceneIfNoneActive = true){
        super(name, (0, $ha1VO.Vector3).Zero(), scene, setActiveOnSceneIfNoneActive);
        /**
         * Current inertia value on the longitudinal axis.
         * The bigger this number the longer it will take for the camera to stop.
         */ this.inertialAlphaOffset = 0;
        /**
         * Current inertia value on the latitudinal axis.
         * The bigger this number the longer it will take for the camera to stop.
         */ this.inertialBetaOffset = 0;
        /**
         * Current inertia value on the radius axis.
         * The bigger this number the longer it will take for the camera to stop.
         */ this.inertialRadiusOffset = 0;
        /**
         * Minimum allowed angle on the longitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerAlphaLimit = null;
        /**
         * Maximum allowed angle on the longitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperAlphaLimit = null;
        /**
         * Minimum allowed angle on the latitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerBetaLimit = 0.01;
        /**
         * Maximum allowed angle on the latitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperBetaLimit = Math.PI - 0.01;
        /**
         * Minimum allowed distance of the camera to the target (The camera can not get closer).
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerRadiusLimit = null;
        /**
         * Maximum allowed distance of the camera to the target (The camera can not get further).
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperRadiusLimit = null;
        /**
         * Defines the current inertia value used during panning of the camera along the X axis.
         */ this.inertialPanningX = 0;
        /**
         * Defines the current inertia value used during panning of the camera along the Y axis.
         */ this.inertialPanningY = 0;
        /**
         * Defines the distance used to consider the camera in pan mode vs pinch/zoom.
         * Basically if your fingers moves away from more than this distance you will be considered
         * in pinch mode.
         */ this.pinchToPanMaxDistance = 20;
        /**
         * Defines the maximum distance the camera can pan.
         * This could help keeping the camera always in your scene.
         */ this.panningDistanceLimit = null;
        /**
         * Defines the target of the camera before panning.
         */ this.panningOriginTarget = (0, $ha1VO.Vector3).Zero();
        /**
         * Defines the value of the inertia used during panning.
         * 0 would mean stop inertia and one would mean no deceleration at all.
         */ this.panningInertia = 0.9;
        //-- end properties for backward compatibility for inputs
        /**
         * Defines how much the radius should be scaled while zooming on a particular mesh (through the zoomOn function)
         */ this.zoomOnFactor = 1;
        /**
         * Defines a screen offset for the camera position.
         */ this.targetScreenOffset = (0, $ha1VO.Vector2).Zero();
        /**
         * Allows the camera to be completely reversed.
         * If false the camera can not arrive upside down.
         */ this.allowUpsideDown = true;
        /**
         * Define if double tap/click is used to restore the previously saved state of the camera.
         */ this.useInputToRestoreState = true;
        /**
         * Factor for restoring information interpolation. default is 0 = off. Any value \< 0 or \> 1 will disable interpolation.
         */ this.restoreStateInterpolationFactor = 0;
        this._currentInterpolationFactor = 0;
        /** @internal */ this._viewMatrix = new (0, $ha1VO.Matrix)();
        /**
         * Defines the allowed panning axis.
         */ this.panningAxis = new (0, $ha1VO.Vector3)(1, 1, 0);
        this._transformedDirection = new (0, $ha1VO.Vector3)();
        /**
         * Defines if camera will eliminate transform on y axis.
         */ this.mapPanning = false;
        // restoring state progressively
        this._progressiveRestore = false;
        /**
         * Observable triggered when the transform node target has been changed on the camera.
         */ this.onMeshTargetChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Defines whether the camera should check collision with the objects oh the scene.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#how-can-i-do-this-
         */ this.checkCollisions = false;
        /**
         * Defines the collision radius of the camera.
         * This simulates a sphere around the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#arcrotatecamera
         */ this.collisionRadius = new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5);
        this._previousPosition = (0, $ha1VO.Vector3).Zero();
        this._collisionVelocity = (0, $ha1VO.Vector3).Zero();
        this._newPosition = (0, $ha1VO.Vector3).Zero();
        this._computationVector = (0, $ha1VO.Vector3).Zero();
        this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null)=>{
            if (!collidedMesh) this._previousPosition.copyFrom(this._position);
            else {
                this.setPosition(newPosition);
                if (this.onCollide) this.onCollide(collidedMesh);
            }
            // Recompute because of constraints
            const cosa = Math.cos(this.alpha);
            const sina = Math.sin(this.alpha);
            const cosb = Math.cos(this.beta);
            let sinb = Math.sin(this.beta);
            if (sinb === 0) sinb = 0.0001;
            const target = this._getTargetPosition();
            this._computationVector.copyFromFloats(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb);
            target.addToRef(this._computationVector, this._newPosition);
            this._position.copyFrom(this._newPosition);
            let up = this.upVector;
            if (this.allowUpsideDown && this.beta < 0) {
                up = up.clone();
                up = up.negate();
            }
            this._computeViewMatrix(this._position, target, up);
            this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x);
            this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
            this._collisionTriggered = false;
        };
        this._target = (0, $ha1VO.Vector3).Zero();
        if (target) this.setTarget(target);
        this.alpha = alpha;
        this.beta = beta;
        this.radius = radius;
        this.getViewMatrix();
        this.inputs = new (0, $bef5be55ba1ec18a$export$cbf1896b2dde8a14)(this);
        this.inputs.addKeyboard().addMouseWheel().addPointers();
    }
    // Cache
    /** @internal */ _initCache() {
        super._initCache();
        this._cache._target = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.alpha = undefined;
        this._cache.beta = undefined;
        this._cache.radius = undefined;
        this._cache.targetScreenOffset = (0, $ha1VO.Vector2).Zero();
    }
    /**
     * @internal
     */ _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) super._updateCache();
        this._cache._target.copyFrom(this._getTargetPosition());
        this._cache.alpha = this.alpha;
        this._cache.beta = this.beta;
        this._cache.radius = this.radius;
        this._cache.targetScreenOffset.copyFrom(this.targetScreenOffset);
    }
    _getTargetPosition() {
        if (this._targetHost && this._targetHost.getAbsolutePosition) {
            const pos = this._targetHost.getAbsolutePosition();
            if (this._targetBoundingCenter) pos.addToRef(this._targetBoundingCenter, this._target);
            else this._target.copyFrom(pos);
        }
        const lockedTargetPosition = this._getLockedTargetPosition();
        if (lockedTargetPosition) return lockedTargetPosition;
        return this._target;
    }
    /**
     * Stores the current state of the camera (alpha, beta, radius and target)
     * @returns the camera itself
     */ storeState() {
        this._storedAlpha = this._goalAlpha = this.alpha;
        this._storedBeta = this._goalBeta = this.beta;
        this._storedRadius = this._goalRadius = this.radius;
        this._storedTarget = this._goalTarget = this._getTargetPosition().clone();
        this._storedTargetScreenOffset = this._goalTargetScreenOffset = this.targetScreenOffset.clone();
        return super.storeState();
    }
    /**
     * @internal
     * Restored camera state. You must call storeState() first
     */ _restoreStateValues() {
        if (this.hasStateStored() && this.restoreStateInterpolationFactor > (0, $53VPf.Epsilon) && this.restoreStateInterpolationFactor < 1) {
            this.interpolateTo(this._storedAlpha, this._storedBeta, this._storedRadius, this._storedTarget, this._storedTargetScreenOffset, this.restoreStateInterpolationFactor);
            return true;
        }
        if (!super._restoreStateValues()) return false;
        this.setTarget(this._storedTarget.clone());
        this.alpha = this._storedAlpha;
        this.beta = this._storedBeta;
        this.radius = this._storedRadius;
        this.targetScreenOffset = this._storedTargetScreenOffset.clone();
        this.inertialAlphaOffset = 0;
        this.inertialBetaOffset = 0;
        this.inertialRadiusOffset = 0;
        this.inertialPanningX = 0;
        this.inertialPanningY = 0;
        return true;
    }
    /**
     * Interpolates the camera to a goal state.
     * @param alpha Defines the goal alpha.
     * @param beta Defines the goal beta.
     * @param radius Defines the goal radius.
     * @param target Defines the goal target.
     * @param targetScreenOffset Defines the goal target screen offset.
     * @param interpolationFactor A value  between 0 and 1 that determines the speed of the interpolation.
     */ interpolateTo(alpha = this.alpha, beta = this.beta, radius = this.radius, target = this.target, targetScreenOffset = this.targetScreenOffset, interpolationFactor) {
        this._progressiveRestore = true;
        this.inertialAlphaOffset = 0;
        this.inertialBetaOffset = 0;
        this.inertialRadiusOffset = 0;
        this.inertialPanningX = 0;
        this.inertialPanningY = 0;
        if (interpolationFactor != null) this._currentInterpolationFactor = interpolationFactor;
        else if (this.restoreStateInterpolationFactor !== 0) this._currentInterpolationFactor = this.restoreStateInterpolationFactor;
        else this._currentInterpolationFactor = 0.1;
        alpha = (0, $iosaP.Clamp)(alpha, this.lowerAlphaLimit ?? -Infinity, this.upperAlphaLimit ?? Infinity);
        beta = (0, $iosaP.Clamp)(beta, this.lowerBetaLimit ?? -Infinity, this.upperBetaLimit ?? Infinity);
        radius = (0, $iosaP.Clamp)(radius, this.lowerRadiusLimit ?? -Infinity, this.upperRadiusLimit ?? Infinity);
        this._goalAlpha = alpha;
        this._goalBeta = beta;
        this._goalRadius = radius;
        this._goalTarget = target;
        this._goalTargetScreenOffset = targetScreenOffset;
    }
    // Synchronized
    /** @internal */ _isSynchronizedViewMatrix() {
        if (!super._isSynchronizedViewMatrix()) return false;
        return this._cache._target.equals(this._getTargetPosition()) && this._cache.alpha === this.alpha && this._cache.beta === this.beta && this._cache.radius === this.radius && this._cache.targetScreenOffset.equals(this.targetScreenOffset);
    }
    /**
     * Attached controls to the current camera.
     * @param ignored defines an ignored parameter kept for backward compatibility.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     * @param useCtrlForPanning  Defines whether ctrl is used for panning within the controls
     * @param panningMouseButton Defines whether panning is allowed through mouse click button
     */ attachControl(ignored, noPreventDefault, useCtrlForPanning = true, panningMouseButton = 2) {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(args);
        this._useCtrlForPanning = useCtrlForPanning;
        this._panningMouseButton = panningMouseButton;
        // backwards compatibility
        if (typeof args[0] === "boolean") {
            if (args.length > 1) this._useCtrlForPanning = args[1];
            if (args.length > 2) this._panningMouseButton = args[2];
        }
        this.inputs.attachElement(noPreventDefault);
        this._reset = ()=>{
            this.inertialAlphaOffset = 0;
            this.inertialBetaOffset = 0;
            this.inertialRadiusOffset = 0;
            this.inertialPanningX = 0;
            this.inertialPanningY = 0;
        };
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this.inputs.detachElement();
        if (this._reset) this._reset();
    }
    /** @internal */ _checkInputs() {
        //if (async) collision inspection was triggered, don't update the camera's position - until the collision callback was called.
        if (this._collisionTriggered) return;
        this.inputs.checkInputs();
        // progressive restore
        if (this._progressiveRestore) {
            const dt = this._scene.getEngine().getDeltaTime() / 1000;
            const t = 1 - Math.pow(2, -dt / this._currentInterpolationFactor);
            // can't use tmp vector here because of assignment
            this.setTarget((0, $ha1VO.Vector3).Lerp(this.getTarget(), this._goalTarget, t));
            // Using quaternion for smoother interpolation (and no Euler angles modulo)
            (0, $ha1VO.Quaternion).RotationAlphaBetaGammaToRef(this._goalAlpha, this._goalBeta, 0, (0, $ha1VO.TmpVectors).Quaternion[0]);
            (0, $ha1VO.Quaternion).RotationAlphaBetaGammaToRef(this.alpha, this.beta, 0, (0, $ha1VO.TmpVectors).Quaternion[1]);
            (0, $ha1VO.Quaternion).SlerpToRef((0, $ha1VO.TmpVectors).Quaternion[1], (0, $ha1VO.TmpVectors).Quaternion[0], t, (0, $ha1VO.TmpVectors).Quaternion[2]);
            (0, $ha1VO.TmpVectors).Quaternion[2].normalize();
            (0, $ha1VO.TmpVectors).Quaternion[2].toAlphaBetaGammaToRef((0, $ha1VO.TmpVectors).Vector3[0]);
            this.alpha = (0, $ha1VO.TmpVectors).Vector3[0].x;
            this.beta = (0, $ha1VO.TmpVectors).Vector3[0].y;
            this.radius += (this._goalRadius - this.radius) * t;
            (0, $ha1VO.Vector2).LerpToRef(this.targetScreenOffset, this._goalTargetScreenOffset, t, this.targetScreenOffset);
            // stop restoring when within close range or when user starts interacting
            if ((0, $ha1VO.Vector3).DistanceSquared(this.getTarget(), this._goalTarget) < (0, $53VPf.Epsilon) && (0, $ha1VO.TmpVectors).Quaternion[2].equalsWithEpsilon((0, $ha1VO.TmpVectors).Quaternion[0]) && Math.pow(this._goalRadius - this.radius, 2) < (0, $53VPf.Epsilon) && (0, $ha1VO.Vector2).Distance(this.targetScreenOffset, this._goalTargetScreenOffset) < (0, $53VPf.Epsilon) || this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0 || this.inertialRadiusOffset !== 0 || this.inertialPanningX !== 0 || this.inertialPanningY !== 0) this._progressiveRestore = false;
        }
        // Inertia
        if (this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0 || this.inertialRadiusOffset !== 0) {
            const directionModifier = this.invertRotation ? -1 : 1;
            const handednessMultiplier = this._calculateHandednessMultiplier();
            let inertialAlphaOffset = this.inertialAlphaOffset * handednessMultiplier;
            if (this.beta < 0) inertialAlphaOffset *= -1;
            this.alpha += inertialAlphaOffset * directionModifier;
            this.beta += this.inertialBetaOffset * directionModifier;
            this.radius -= this.inertialRadiusOffset;
            this.inertialAlphaOffset *= this.inertia;
            this.inertialBetaOffset *= this.inertia;
            this.inertialRadiusOffset *= this.inertia;
            if (Math.abs(this.inertialAlphaOffset) < (0, $53VPf.Epsilon)) this.inertialAlphaOffset = 0;
            if (Math.abs(this.inertialBetaOffset) < (0, $53VPf.Epsilon)) this.inertialBetaOffset = 0;
            if (Math.abs(this.inertialRadiusOffset) < this.speed * (0, $53VPf.Epsilon)) this.inertialRadiusOffset = 0;
        }
        // Panning inertia
        if (this.inertialPanningX !== 0 || this.inertialPanningY !== 0) {
            const localDirection = new (0, $ha1VO.Vector3)(this.inertialPanningX, this.inertialPanningY, this.inertialPanningY);
            this._viewMatrix.invertToRef(this._cameraTransformMatrix);
            localDirection.multiplyInPlace(this.panningAxis);
            (0, $ha1VO.Vector3).TransformNormalToRef(localDirection, this._cameraTransformMatrix, this._transformedDirection);
            // If mapPanning is enabled, we need to take the upVector into account and
            // make sure we're not panning in the y direction
            if (this.mapPanning) {
                const up = this.upVector;
                const right = (0, $ha1VO.Vector3).CrossToRef(this._transformedDirection, up, this._transformedDirection);
                (0, $ha1VO.Vector3).CrossToRef(up, right, this._transformedDirection);
            } else if (!this.panningAxis.y) this._transformedDirection.y = 0;
            if (!this._targetHost) {
                if (this.panningDistanceLimit) {
                    this._transformedDirection.addInPlace(this._target);
                    const distanceSquared = (0, $ha1VO.Vector3).DistanceSquared(this._transformedDirection, this.panningOriginTarget);
                    if (distanceSquared <= this.panningDistanceLimit * this.panningDistanceLimit) this._target.copyFrom(this._transformedDirection);
                } else {
                    if (this.parent) {
                        const m = (0, $ha1VO.TmpVectors).Matrix[0];
                        this.parent.getWorldMatrix().getRotationMatrixToRef(m);
                        m.transposeToRef(m);
                        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._transformedDirection, m, this._transformedDirection);
                    }
                    this._target.addInPlace(this._transformedDirection);
                }
            }
            this.inertialPanningX *= this.panningInertia;
            this.inertialPanningY *= this.panningInertia;
            if (Math.abs(this.inertialPanningX) < this.speed * (0, $53VPf.Epsilon)) this.inertialPanningX = 0;
            if (Math.abs(this.inertialPanningY) < this.speed * (0, $53VPf.Epsilon)) this.inertialPanningY = 0;
        }
        // Limits
        this._checkLimits();
        super._checkInputs();
    }
    _checkLimits() {
        if (this.lowerBetaLimit === null || this.lowerBetaLimit === undefined) {
            if (this.allowUpsideDown && this.beta > Math.PI) this.beta = this.beta - 2 * Math.PI;
        } else if (this.beta < this.lowerBetaLimit) this.beta = this.lowerBetaLimit;
        if (this.upperBetaLimit === null || this.upperBetaLimit === undefined) {
            if (this.allowUpsideDown && this.beta < -Math.PI) this.beta = this.beta + 2 * Math.PI;
        } else if (this.beta > this.upperBetaLimit) this.beta = this.upperBetaLimit;
        if (this.lowerAlphaLimit !== null && this.alpha < this.lowerAlphaLimit) this.alpha = this.lowerAlphaLimit;
        if (this.upperAlphaLimit !== null && this.alpha > this.upperAlphaLimit) this.alpha = this.upperAlphaLimit;
        if (this.lowerRadiusLimit !== null && this.radius < this.lowerRadiusLimit) {
            this.radius = this.lowerRadiusLimit;
            this.inertialRadiusOffset = 0;
        }
        if (this.upperRadiusLimit !== null && this.radius > this.upperRadiusLimit) {
            this.radius = this.upperRadiusLimit;
            this.inertialRadiusOffset = 0;
        }
    }
    /**
     * Rebuilds angles (alpha, beta) and radius from the give position and target
     */ rebuildAnglesAndRadius() {
        this._position.subtractToRef(this._getTargetPosition(), this._computationVector);
        // need to rotate to Y up equivalent if up vector not Axis.Y
        if (this._upVector.x !== 0 || this._upVector.y !== 1.0 || this._upVector.z !== 0) (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._computationVector, this._upToYMatrix, this._computationVector);
        this.radius = this._computationVector.length();
        if (this.radius === 0) this.radius = 0.0001; // Just to avoid division by zero
        // Alpha
        const previousAlpha = this.alpha;
        if (this._computationVector.x === 0 && this._computationVector.z === 0) this.alpha = Math.PI / 2; // avoid division by zero when looking along up axis, and set to acos(0)
        else this.alpha = Math.acos(this._computationVector.x / Math.sqrt(Math.pow(this._computationVector.x, 2) + Math.pow(this._computationVector.z, 2)));
        if (this._computationVector.z < 0) this.alpha = 2 * Math.PI - this.alpha;
        // Calculate the number of revolutions between the new and old alpha values.
        const alphaCorrectionTurns = Math.round((previousAlpha - this.alpha) / (2.0 * Math.PI));
        // Adjust alpha so that its numerical representation is the closest one to the old value.
        this.alpha += alphaCorrectionTurns * 2.0 * Math.PI;
        // Beta
        this.beta = Math.acos(this._computationVector.y / this.radius);
        this._checkLimits();
    }
    /**
     * Use a position to define the current camera related information like alpha, beta and radius
     * @param position Defines the position to set the camera at
     */ setPosition(position) {
        if (this._position.equals(position)) return;
        this._position.copyFrom(position);
        this.rebuildAnglesAndRadius();
    }
    /**
     * Defines the target the camera should look at.
     * This will automatically adapt alpha beta and radius to fit within the new target.
     * Please note that setting a target as a mesh will disable panning.
     * @param target Defines the new target as a Vector or a transform node
     * @param toBoundingCenter In case of a mesh target, defines whether to target the mesh position or its bounding information center
     * @param allowSamePosition If false, prevents reapplying the new computed position if it is identical to the current one (optim)
     * @param cloneAlphaBetaRadius If true, replicate the current setup (alpha, beta, radius) on the new target
     */ setTarget(target, toBoundingCenter = false, allowSamePosition = false, cloneAlphaBetaRadius = false) {
        cloneAlphaBetaRadius = this.overrideCloneAlphaBetaRadius ?? cloneAlphaBetaRadius;
        if (target.computeWorldMatrix) {
            if (toBoundingCenter && target.getBoundingInfo) this._targetBoundingCenter = target.getBoundingInfo().boundingBox.centerWorld.clone();
            else this._targetBoundingCenter = null;
            target.computeWorldMatrix();
            this._targetHost = target;
            this._target = this._getTargetPosition();
            this.onMeshTargetChangedObservable.notifyObservers(this._targetHost);
        } else {
            const newTarget = target;
            const currentTarget = this._getTargetPosition();
            if (currentTarget && !allowSamePosition && currentTarget.equals(newTarget)) return;
            this._targetHost = null;
            this._target = newTarget;
            this._targetBoundingCenter = null;
            this.onMeshTargetChangedObservable.notifyObservers(null);
        }
        if (!cloneAlphaBetaRadius) this.rebuildAnglesAndRadius();
    }
    /** @internal */ _getViewMatrix() {
        // Compute
        const cosa = Math.cos(this.alpha);
        const sina = Math.sin(this.alpha);
        const cosb = Math.cos(this.beta);
        let sinb = Math.sin(this.beta);
        if (sinb === 0) sinb = 0.0001;
        if (this.radius === 0) this.radius = 0.0001; // Just to avoid division by zero
        const target = this._getTargetPosition();
        this._computationVector.copyFromFloats(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb);
        // Rotate according to up vector
        if (this._upVector.x !== 0 || this._upVector.y !== 1.0 || this._upVector.z !== 0) (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._computationVector, this._yToUpMatrix, this._computationVector);
        target.addToRef(this._computationVector, this._newPosition);
        if (this.getScene().collisionsEnabled && this.checkCollisions) {
            const coordinator = this.getScene().collisionCoordinator;
            if (!this._collider) this._collider = coordinator.createCollider();
            this._collider._radius = this.collisionRadius;
            this._newPosition.subtractToRef(this._position, this._collisionVelocity);
            this._collisionTriggered = true;
            coordinator.getNewPosition(this._position, this._collisionVelocity, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
        } else {
            this._position.copyFrom(this._newPosition);
            let up = this.upVector;
            if (this.allowUpsideDown && sinb < 0) up = up.negate();
            this._computeViewMatrix(this._position, target, up);
            this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x);
            this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
        }
        this._currentTarget = target;
        return this._viewMatrix;
    }
    /**
     * Zooms on a mesh to be at the min distance where we could see it fully in the current viewport.
     * @param meshes Defines the mesh to zoom on
     * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
     */ zoomOn(meshes, doNotUpdateMaxZ = false) {
        meshes = meshes || this.getScene().meshes;
        const minMaxVector = (0, $b0df7c384622c537$export$e176487c05830cc5).MinMax(meshes);
        let distance = this._calculateLowerRadiusFromModelBoundingSphere(minMaxVector.min, minMaxVector.max);
        // If there are defined limits, we need to take them into account
        distance = Math.max(Math.min(distance, this.upperRadiusLimit || Number.MAX_VALUE), this.lowerRadiusLimit || 0);
        this.radius = distance * this.zoomOnFactor;
        this.focusOn({
            min: minMaxVector.min,
            max: minMaxVector.max,
            distance: distance
        }, doNotUpdateMaxZ);
    }
    /**
     * Focus on a mesh or a bounding box. This adapts the target and maxRadius if necessary but does not update the current radius.
     * The target will be changed but the radius
     * @param meshesOrMinMaxVectorAndDistance Defines the mesh or bounding info to focus on
     * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
     */ focusOn(meshesOrMinMaxVectorAndDistance, doNotUpdateMaxZ = false) {
        let meshesOrMinMaxVector;
        let distance;
        if (meshesOrMinMaxVectorAndDistance.min === undefined) {
            // meshes
            const meshes = meshesOrMinMaxVectorAndDistance || this.getScene().meshes;
            meshesOrMinMaxVector = (0, $b0df7c384622c537$export$e176487c05830cc5).MinMax(meshes);
            distance = (0, $ha1VO.Vector3).Distance(meshesOrMinMaxVector.min, meshesOrMinMaxVector.max);
        } else {
            //minMaxVector and distance
            const minMaxVectorAndDistance = meshesOrMinMaxVectorAndDistance;
            meshesOrMinMaxVector = minMaxVectorAndDistance;
            distance = minMaxVectorAndDistance.distance;
        }
        this._target = (0, $b0df7c384622c537$export$e176487c05830cc5).Center(meshesOrMinMaxVector);
        if (!doNotUpdateMaxZ) this.maxZ = distance * 2;
    }
    /**
     * @override
     * Override Camera.createRigCamera
     * @param name the name of the camera
     * @param cameraIndex the index of the camera in the rig cameras array
     */ createRigCamera(name, cameraIndex) {
        let alphaShift = 0;
        switch(this.cameraRigMode){
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_ANAGLYPH:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_OVERUNDER:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_INTERLACED:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_VR:
                alphaShift = this._cameraRigParams.stereoHalfAngle * (cameraIndex === 0 ? 1 : -1);
                break;
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                alphaShift = this._cameraRigParams.stereoHalfAngle * (cameraIndex === 0 ? -1 : 1);
                break;
        }
        const rigCam = new $e59f949a590d8aa8$export$8438041bb8e406c8(name, this.alpha + alphaShift, this.beta, this.radius, this._target, this.getScene());
        rigCam._cameraRigParams = {};
        rigCam.isRigCamera = true;
        rigCam.rigParent = this;
        rigCam.upVector = this.upVector;
        rigCam.mode = this.mode;
        rigCam.orthoLeft = this.orthoLeft;
        rigCam.orthoRight = this.orthoRight;
        rigCam.orthoBottom = this.orthoBottom;
        rigCam.orthoTop = this.orthoTop;
        return rigCam;
    }
    /**
     * @internal
     * @override
     * Override Camera._updateRigCameras
     */ _updateRigCameras() {
        const camLeft = this._rigCameras[0];
        const camRight = this._rigCameras[1];
        camLeft.beta = camRight.beta = this.beta;
        switch(this.cameraRigMode){
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_ANAGLYPH:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_OVERUNDER:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_INTERLACED:
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_VR:
                camLeft.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
                camRight.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
                break;
            case (0, $52736139c8513fb2$export$79f141de891a5fed).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                camLeft.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
                camRight.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
                break;
        }
        super._updateRigCameras();
    }
    /**
     * @internal
     */ _calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld, radiusScale = 1) {
        const boxVectorGlobalDiagonal = (0, $ha1VO.Vector3).Distance(minimumWorld, maximumWorld);
        // Get aspect ratio in order to calculate frustum slope
        const engine = this.getScene().getEngine();
        const aspectRatio = engine.getAspectRatio(this);
        const frustumSlopeY = Math.tan(this.fov / 2);
        const frustumSlopeX = frustumSlopeY * aspectRatio;
        // Formula for setting distance
        // (Good explanation: http://stackoverflow.com/questions/2866350/move-camera-to-fit-3d-scene)
        const radiusWithoutFraming = boxVectorGlobalDiagonal * 0.5;
        // Horizon distance
        const radius = radiusWithoutFraming * radiusScale;
        const distanceForHorizontalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlopeX * frustumSlopeX));
        const distanceForVerticalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlopeY * frustumSlopeY));
        return Math.max(distanceForHorizontalFrustum, distanceForVerticalFrustum);
    }
    /**
     * Destroy the camera and release the current resources hold by it.
     */ dispose() {
        this.inputs.clear();
        super.dispose();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCamera";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "alpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "beta", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "radius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "overrideCloneAlphaBetaRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("target")
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "_target", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)("targetHost")
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "_targetHost", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialAlphaOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialBetaOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialRadiusOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "lowerAlphaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "upperAlphaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "lowerBetaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "upperBetaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "lowerRadiusLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "upperRadiusLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialPanningX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialPanningY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "pinchToPanMaxDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "panningDistanceLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "panningOriginTarget", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "panningInertia", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "zoomToMouseLocation", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "zoomOnFactor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector2)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "targetScreenOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "allowUpsideDown", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "useInputToRestoreState", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "restoreStateInterpolationFactor", void 0);
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.ArcRotateCamera", $e59f949a590d8aa8$export$8438041bb8e406c8);


parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");
var $ha1VO = parcelRequire("ha1VO");

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.restoreSingleAttachment = function() {
    const gl = this._gl;
    this.bindAttachments([
        gl.BACK
    ]);
};
(0, $2h5JR.ThinEngine).prototype.restoreSingleAttachmentForRenderTarget = function() {
    const gl = this._gl;
    this.bindAttachments([
        gl.COLOR_ATTACHMENT0
    ]);
};
(0, $2h5JR.ThinEngine).prototype.buildTextureLayout = function(textureStatus) {
    const gl = this._gl;
    const result = [];
    for(let i = 0; i < textureStatus.length; i++)if (textureStatus[i]) result.push(gl["COLOR_ATTACHMENT" + i]);
    else result.push(gl.NONE);
    return result;
};
(0, $2h5JR.ThinEngine).prototype.bindAttachments = function(attachments) {
    const gl = this._gl;
    gl.drawBuffers(attachments);
};
(0, $2h5JR.ThinEngine).prototype.unBindMultiColorAttachmentFramebuffer = function(rtWrapper, disableGenerateMipMaps = false, onBeforeUnbind) {
    this._currentRenderTarget = null;
    if (!rtWrapper.disableAutomaticMSAAResolve) this.resolveMultiFramebuffer(rtWrapper);
    if (!disableGenerateMipMaps) this.generateMipMapsMultiFramebuffer(rtWrapper);
    if (onBeforeUnbind) {
        if (rtWrapper._MSAAFramebuffer) // Bind the correct framebuffer
        this._bindUnboundFramebuffer(rtWrapper._framebuffer);
        onBeforeUnbind();
    }
    this._bindUnboundFramebuffer(null);
};
(0, $2h5JR.ThinEngine).prototype.createMultipleRenderTarget = function(size, options, initializeBuffers = true) {
    let generateMipMaps = false;
    let generateDepthBuffer = true;
    let generateStencilBuffer = false;
    let generateDepthTexture = false;
    let depthTextureFormat = undefined;
    let textureCount = 1;
    let samples = 1;
    const defaultType = 0;
    const defaultSamplingMode = 3;
    const defaultUseSRGBBuffer = false;
    const defaultFormat = 5;
    const defaultTarget = 3553;
    let types = [];
    let samplingModes = [];
    let useSRGBBuffers = [];
    let formats = [];
    let targets = [];
    let faceIndex = [];
    let layerIndex = [];
    let layers = [];
    let labels = [];
    let dontCreateTextures = false;
    const rtWrapper = this._createHardwareRenderTargetWrapper(true, false, size);
    if (options !== undefined) {
        generateMipMaps = options.generateMipMaps === undefined ? false : options.generateMipMaps;
        generateDepthBuffer = options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
        generateStencilBuffer = options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
        generateDepthTexture = options.generateDepthTexture === undefined ? false : options.generateDepthTexture;
        textureCount = options.textureCount ?? 1;
        samples = options.samples ?? samples;
        types = options.types || types;
        samplingModes = options.samplingModes || samplingModes;
        useSRGBBuffers = options.useSRGBBuffers || useSRGBBuffers;
        formats = options.formats || formats;
        targets = options.targetTypes || targets;
        faceIndex = options.faceIndex || faceIndex;
        layerIndex = options.layerIndex || layerIndex;
        layers = options.layerCounts || layers;
        labels = options.labels || labels;
        dontCreateTextures = options.dontCreateTextures ?? false;
        if (this.webGLVersion > 1 && (options.depthTextureFormat === 13 || options.depthTextureFormat === 17 || options.depthTextureFormat === 16 || options.depthTextureFormat === 14 || options.depthTextureFormat === 18)) depthTextureFormat = options.depthTextureFormat;
    }
    if (depthTextureFormat === undefined) depthTextureFormat = generateStencilBuffer ? 13 : 14;
    const gl = this._gl;
    // Create the framebuffer
    const currentFramebuffer = this._currentFramebuffer;
    const framebuffer = gl.createFramebuffer();
    this._bindUnboundFramebuffer(framebuffer);
    const width = size.width ?? size;
    const height = size.height ?? size;
    const textures = [];
    const attachments = [];
    const useStencilTexture = this.webGLVersion > 1 && (depthTextureFormat === 13 || depthTextureFormat === 17 || depthTextureFormat === 18);
    rtWrapper.label = options?.label ?? "MultiRenderTargetWrapper";
    rtWrapper._framebuffer = framebuffer;
    rtWrapper._generateDepthBuffer = generateDepthTexture || generateDepthBuffer;
    rtWrapper._generateStencilBuffer = generateDepthTexture ? useStencilTexture : generateStencilBuffer;
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, width, height, 1, depthTextureFormat);
    rtWrapper._attachments = attachments;
    for(let i = 0; i < textureCount; i++){
        let samplingMode = samplingModes[i] || defaultSamplingMode;
        let type = types[i] || defaultType;
        let useSRGBBuffer = useSRGBBuffers[i] || defaultUseSRGBBuffer;
        const format = formats[i] || defaultFormat;
        const target = targets[i] || defaultTarget;
        const layerCount = layers[i] ?? 1;
        if (type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        if (type === 1 && !this._caps.textureFloat) {
            type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Render target forced to TEXTURETYPE_UNSIGNED_BYTE type");
        }
        useSRGBBuffer = useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU);
        const isWebGL2 = this.webGLVersion > 1;
        const attachment = gl[isWebGL2 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
        attachments.push(attachment);
        if (target === -1 || dontCreateTextures) continue;
        const texture = new (0, $b9e4a.InternalTexture)(this, 6 /* InternalTextureSource.MultiRenderTarget */ );
        textures[i] = texture;
        gl.activeTexture(gl["TEXTURE" + i]);
        gl.bindTexture(target, texture._hardwareTexture.underlyingResource);
        gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filters.min);
        gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        const internalSizedFormat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
        const internalFormat = this._getInternalFormat(format);
        const webGLTextureType = this._getWebGLTextureType(type);
        if (isWebGL2 && (target === 35866 || target === 32879)) {
            if (target === 35866) texture.is2DArray = true;
            else texture.is3D = true;
            texture.baseDepth = texture.depth = layerCount;
            gl.texImage3D(target, 0, internalSizedFormat, width, height, layerCount, 0, internalFormat, webGLTextureType, null);
        } else if (target === 34067) {
            // We have to generate all faces to complete the framebuffer
            for(let i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, internalSizedFormat, width, height, 0, internalFormat, webGLTextureType, null);
            texture.isCube = true;
        } else gl.texImage2D(gl.TEXTURE_2D, 0, internalSizedFormat, width, height, 0, internalFormat, webGLTextureType, null);
        if (generateMipMaps) gl.generateMipmap(target);
        // Unbind
        this._bindTextureDirectly(target, null);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.isReady = true;
        texture.samples = 1;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.type = type;
        texture._useSRGBBuffer = useSRGBBuffer;
        texture.format = format;
        texture.label = labels[i] ?? rtWrapper.label + "-Texture" + i;
        this._internalTexturesCache.push(texture);
    }
    if (generateDepthTexture && this._caps.depthTextureExtension && !dontCreateTextures) {
        // Depth texture
        const depthTexture = new (0, $b9e4a.InternalTexture)(this, 14 /* InternalTextureSource.Depth */ );
        let depthTextureType = 5;
        let glDepthTextureInternalFormat = gl.DEPTH_COMPONENT16;
        let glDepthTextureFormat = gl.DEPTH_COMPONENT;
        let glDepthTextureType = gl.UNSIGNED_SHORT;
        let glDepthTextureAttachment = gl.DEPTH_ATTACHMENT;
        if (this.webGLVersion < 2) glDepthTextureInternalFormat = gl.DEPTH_COMPONENT;
        else {
            if (depthTextureFormat === 14) {
                depthTextureType = 1;
                glDepthTextureType = gl.FLOAT;
                glDepthTextureInternalFormat = gl.DEPTH_COMPONENT32F;
            } else if (depthTextureFormat === 18) {
                depthTextureType = 0;
                glDepthTextureType = gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
                glDepthTextureInternalFormat = gl.DEPTH32F_STENCIL8;
                glDepthTextureFormat = gl.DEPTH_STENCIL;
                glDepthTextureAttachment = gl.DEPTH_STENCIL_ATTACHMENT;
            } else if (depthTextureFormat === 16) {
                depthTextureType = 0;
                glDepthTextureType = gl.UNSIGNED_INT;
                glDepthTextureInternalFormat = gl.DEPTH_COMPONENT24;
                glDepthTextureAttachment = gl.DEPTH_ATTACHMENT;
            } else if (depthTextureFormat === 13 || depthTextureFormat === 17) {
                depthTextureType = 12;
                glDepthTextureType = gl.UNSIGNED_INT_24_8;
                glDepthTextureInternalFormat = gl.DEPTH24_STENCIL8;
                glDepthTextureFormat = gl.DEPTH_STENCIL;
                glDepthTextureAttachment = gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        this._bindTextureDirectly(gl.TEXTURE_2D, depthTexture, true);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texImage2D(gl.TEXTURE_2D, 0, glDepthTextureInternalFormat, width, height, 0, glDepthTextureFormat, glDepthTextureType, null);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, glDepthTextureAttachment, gl.TEXTURE_2D, depthTexture._hardwareTexture.underlyingResource, 0);
        this._bindTextureDirectly(gl.TEXTURE_2D, null);
        rtWrapper._depthStencilTexture = depthTexture;
        rtWrapper._depthStencilTextureWithStencil = useStencilTexture;
        depthTexture.baseWidth = width;
        depthTexture.baseHeight = height;
        depthTexture.width = width;
        depthTexture.height = height;
        depthTexture.isReady = true;
        depthTexture.samples = 1;
        depthTexture.generateMipMaps = generateMipMaps;
        depthTexture.samplingMode = 1;
        depthTexture.format = depthTextureFormat;
        depthTexture.type = depthTextureType;
        depthTexture.label = rtWrapper.label + "-DepthStencil";
        textures[textureCount] = depthTexture;
        this._internalTexturesCache.push(depthTexture);
    }
    rtWrapper.setTextures(textures);
    if (initializeBuffers) gl.drawBuffers(attachments);
    this._bindUnboundFramebuffer(currentFramebuffer);
    rtWrapper.setLayerAndFaceIndices(layerIndex, faceIndex);
    this.resetTextureCache();
    if (!dontCreateTextures) this.updateMultipleRenderTargetTextureSampleCount(rtWrapper, samples, initializeBuffers);
    else if (samples > 1) {
        const framebuffer = gl.createFramebuffer();
        if (!framebuffer) throw new Error("Unable to create multi sampled framebuffer");
        rtWrapper._samples = samples;
        rtWrapper._MSAAFramebuffer = framebuffer;
        if (textureCount > 0 && initializeBuffers) {
            this._bindUnboundFramebuffer(framebuffer);
            gl.drawBuffers(attachments);
            this._bindUnboundFramebuffer(currentFramebuffer);
        }
    }
    return rtWrapper;
};
(0, $2h5JR.ThinEngine).prototype.updateMultipleRenderTargetTextureSampleCount = function(rtWrapper, samples, initializeBuffers = true) {
    if (this.webGLVersion < 2 || !rtWrapper) return 1;
    if (rtWrapper.samples === samples) return samples;
    const gl = this._gl;
    samples = Math.min(samples, this.getCaps().maxMSAASamples);
    // Dispose previous render buffers
    if (rtWrapper._depthStencilBuffer) {
        gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
        rtWrapper._depthStencilBuffer = null;
    }
    if (rtWrapper._MSAAFramebuffer) {
        gl.deleteFramebuffer(rtWrapper._MSAAFramebuffer);
        rtWrapper._MSAAFramebuffer = null;
    }
    const count = rtWrapper._attachments.length; // We do it this way instead of rtWrapper.textures.length to avoid taking into account the depth/stencil texture, in case it has been created
    for(let i = 0; i < count; i++){
        const texture = rtWrapper.textures[i];
        const hardwareTexture = texture._hardwareTexture;
        hardwareTexture?.releaseMSAARenderBuffers();
    }
    if (samples > 1 && typeof gl.renderbufferStorageMultisample === "function") {
        const framebuffer = gl.createFramebuffer();
        if (!framebuffer) throw new Error("Unable to create multi sampled framebuffer");
        rtWrapper._MSAAFramebuffer = framebuffer;
        this._bindUnboundFramebuffer(framebuffer);
        const attachments = [];
        for(let i = 0; i < count; i++){
            const texture = rtWrapper.textures[i];
            const hardwareTexture = texture._hardwareTexture;
            const attachment = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
            const colorRenderbuffer = this._createRenderBuffer(texture.width, texture.height, samples, -1 /* not used */ , this._getRGBABufferInternalSizedFormat(texture.type, texture.format, texture._useSRGBBuffer), attachment);
            if (!colorRenderbuffer) throw new Error("Unable to create multi sampled framebuffer");
            hardwareTexture.addMSAARenderBuffer(colorRenderbuffer);
            texture.samples = samples;
            attachments.push(attachment);
        }
        if (initializeBuffers) gl.drawBuffers(attachments);
    } else this._bindUnboundFramebuffer(rtWrapper._framebuffer);
    const depthFormat = rtWrapper._depthStencilTexture ? rtWrapper._depthStencilTexture.format : undefined;
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.width, rtWrapper.height, samples, depthFormat);
    this._bindUnboundFramebuffer(null);
    rtWrapper._samples = samples;
    return samples;
};
(0, $2h5JR.ThinEngine).prototype.generateMipMapsMultiFramebuffer = function(texture) {
    const rtWrapper = texture;
    const gl = this._gl;
    if (!rtWrapper.isMulti) return;
    for(let i = 0; i < rtWrapper._attachments.length; i++){
        const texture = rtWrapper.textures[i];
        if (texture?.generateMipMaps && !texture?.isCube && !texture?.is3D) {
            this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
            gl.generateMipmap(gl.TEXTURE_2D);
            this._bindTextureDirectly(gl.TEXTURE_2D, null);
        }
    }
};
(0, $2h5JR.ThinEngine).prototype.resolveMultiFramebuffer = function(texture) {
    const rtWrapper = texture;
    const gl = this._gl;
    if (!rtWrapper._MSAAFramebuffer || !rtWrapper.isMulti) return;
    let bufferBits = rtWrapper.resolveMSAAColors ? gl.COLOR_BUFFER_BIT : 0;
    bufferBits |= rtWrapper._generateDepthBuffer && rtWrapper.resolveMSAADepth ? gl.DEPTH_BUFFER_BIT : 0;
    bufferBits |= rtWrapper._generateStencilBuffer && rtWrapper.resolveMSAAStencil ? gl.STENCIL_BUFFER_BIT : 0;
    const attachments = rtWrapper._attachments;
    const count = attachments.length;
    gl.bindFramebuffer(gl.READ_FRAMEBUFFER, rtWrapper._MSAAFramebuffer);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, rtWrapper._framebuffer);
    for(let i = 0; i < count; i++){
        const texture = rtWrapper.textures[i];
        for(let j = 0; j < count; j++)attachments[j] = gl.NONE;
        attachments[i] = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
        gl.readBuffer(attachments[i]);
        gl.drawBuffers(attachments);
        gl.blitFramebuffer(0, 0, texture.width, texture.height, 0, 0, texture.width, texture.height, bufferBits, gl.NEAREST);
    }
    for(let i = 0; i < count; i++)attachments[i] = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
    gl.drawBuffers(attachments);
    gl.bindFramebuffer(this._gl.FRAMEBUFFER, rtWrapper._MSAAFramebuffer);
};


class $2d74a16bff4ef9de$export$81ca19ef131ad840 extends (0, $gQtNK.RenderTargetTexture) {
    /**
     * Get if draw buffers (render textures) are currently supported by the used hardware and browser.
     */ get isSupported() {
        return this._engine?.getCaps().drawBuffersExtension ?? false;
    }
    /**
     * Get the list of textures generated by the multi render target.
     */ get textures() {
        return this._textures;
    }
    /**
     * Gets the number of textures in this MRT. This number can be different from `_textures.length` in case a depth texture is generated.
     */ get count() {
        return this._count;
    }
    /**
     * Get the depth texture generated by the multi render target if options.generateDepthTexture has been set
     */ get depthTexture() {
        return this._textures[this._textures.length - 1];
    }
    /**
     * Set the wrapping mode on U of all the textures we are rendering to.
     * Can be any of the Texture. (CLAMP_ADDRESSMODE, MIRROR_ADDRESSMODE or WRAP_ADDRESSMODE)
     */ set wrapU(wrap) {
        if (this._textures) for(let i = 0; i < this._textures.length; i++)this._textures[i].wrapU = wrap;
    }
    /**
     * Set the wrapping mode on V of all the textures we are rendering to.
     * Can be any of the Texture. (CLAMP_ADDRESSMODE, MIRROR_ADDRESSMODE or WRAP_ADDRESSMODE)
     */ set wrapV(wrap) {
        if (this._textures) for(let i = 0; i < this._textures.length; i++)this._textures[i].wrapV = wrap;
    }
    /**
     * Instantiate a new multi render target texture.
     * A multi render target, like a render target provides the ability to render to a texture.
     * Unlike the render target, it can render to several draw buffers (render textures) in one draw.
     * This is specially interesting in deferred rendering or for any effects requiring more than
     * just one color from a single pass.
     * @param name Define the name of the texture
     * @param size Define the size of the buffers to render to
     * @param count Define the number of target we are rendering into
     * @param scene Define the scene the texture belongs to
     * @param options Define the options used to create the multi render target
     * @param textureNames Define the names to set to the textures (if count \> 0 - optional)
     */ constructor(name, size, count, scene, options, textureNames){
        const generateMipMaps = options && options.generateMipMaps ? options.generateMipMaps : false;
        const generateDepthTexture = options && options.generateDepthTexture ? options.generateDepthTexture : false;
        const depthTextureFormat = options && options.depthTextureFormat ? options.depthTextureFormat : 15;
        const doNotChangeAspectRatio = !options || options.doNotChangeAspectRatio === undefined ? true : options.doNotChangeAspectRatio;
        const drawOnlyOnFirstAttachmentByDefault = options && options.drawOnlyOnFirstAttachmentByDefault ? options.drawOnlyOnFirstAttachmentByDefault : false;
        super(name, size, scene, generateMipMaps, doNotChangeAspectRatio, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true);
        if (!this.isSupported) {
            this.dispose();
            return;
        }
        this._textureNames = textureNames;
        const types = [];
        const samplingModes = [];
        const useSRGBBuffers = [];
        const formats = [];
        const targetTypes = [];
        const faceIndex = [];
        const layerIndex = [];
        const layerCounts = [];
        this._initTypes(count, types, samplingModes, useSRGBBuffers, formats, targetTypes, faceIndex, layerIndex, layerCounts, options);
        const generateDepthBuffer = !options || options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
        const generateStencilBuffer = !options || options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
        const samples = options && options.samples ? options.samples : 1;
        this._multiRenderTargetOptions = {
            samplingModes: samplingModes,
            generateMipMaps: generateMipMaps,
            generateDepthBuffer: generateDepthBuffer,
            generateStencilBuffer: generateStencilBuffer,
            generateDepthTexture: generateDepthTexture,
            depthTextureFormat: depthTextureFormat,
            types: types,
            textureCount: count,
            useSRGBBuffers: useSRGBBuffers,
            samples: samples,
            formats: formats,
            targetTypes: targetTypes,
            faceIndex: faceIndex,
            layerIndex: layerIndex,
            layerCounts: layerCounts,
            labels: textureNames,
            label: name
        };
        this._count = count;
        this._drawOnlyOnFirstAttachmentByDefault = drawOnlyOnFirstAttachmentByDefault;
        if (count > 0) {
            this._createInternalTextures();
            this._createTextures(textureNames);
        }
    }
    _initTypes(count, types, samplingModes, useSRGBBuffers, formats, targets, faceIndex, layerIndex, layerCounts, options) {
        for(let i = 0; i < count; i++){
            if (options && options.types && options.types[i] !== undefined) types.push(options.types[i]);
            else types.push(options && options.defaultType ? options.defaultType : 0);
            if (options && options.samplingModes && options.samplingModes[i] !== undefined) samplingModes.push(options.samplingModes[i]);
            else samplingModes.push((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
            if (options && options.useSRGBBuffers && options.useSRGBBuffers[i] !== undefined) useSRGBBuffers.push(options.useSRGBBuffers[i]);
            else useSRGBBuffers.push(false);
            if (options && options.formats && options.formats[i] !== undefined) formats.push(options.formats[i]);
            else formats.push(5);
            if (options && options.targetTypes && options.targetTypes[i] !== undefined) targets.push(options.targetTypes[i]);
            else targets.push(3553);
            if (options && options.faceIndex && options.faceIndex[i] !== undefined) faceIndex.push(options.faceIndex[i]);
            else faceIndex.push(0);
            if (options && options.layerIndex && options.layerIndex[i] !== undefined) layerIndex.push(options.layerIndex[i]);
            else layerIndex.push(0);
            if (options && options.layerCounts && options.layerCounts[i] !== undefined) layerCounts.push(options.layerCounts[i]);
            else layerCounts.push(1);
        }
    }
    _createInternaTextureIndexMapping() {
        const mapMainInternalTexture2Index = {};
        const mapInternalTexture2MainIndex = [];
        if (!this._renderTarget) return mapInternalTexture2MainIndex;
        const internalTextures = this._renderTarget.textures;
        for(let i = 0; i < internalTextures.length; i++){
            const texture = internalTextures[i];
            if (!texture) continue;
            const mainIndex = mapMainInternalTexture2Index[texture.uniqueId];
            if (mainIndex !== undefined) mapInternalTexture2MainIndex[i] = mainIndex;
            else mapMainInternalTexture2Index[texture.uniqueId] = i;
        }
        return mapInternalTexture2MainIndex;
    }
    /**
     * @internal
     */ _rebuild(fromContextLost = false, forceFullRebuild = false, textureNames) {
        if (this._count < 1 || fromContextLost) return;
        const mapInternalTexture2MainIndex = this._createInternaTextureIndexMapping();
        this.releaseInternalTextures();
        this._createInternalTextures();
        if (forceFullRebuild) {
            this._releaseTextures();
            this._createTextures(textureNames);
        }
        const internalTextures = this._renderTarget.textures;
        for(let i = 0; i < internalTextures.length; i++){
            const texture = this._textures[i];
            if (mapInternalTexture2MainIndex[i] !== undefined) this._renderTarget.setTexture(internalTextures[mapInternalTexture2MainIndex[i]], i);
            texture._texture = internalTextures[i];
            if (texture._texture) {
                texture._noMipmap = !texture._texture.useMipMaps;
                texture._useSRGBBuffer = texture._texture._useSRGBBuffer;
            }
        }
        if (this.samples !== 1) this._renderTarget.setSamples(this.samples, !this._drawOnlyOnFirstAttachmentByDefault, true);
    }
    _createInternalTextures() {
        this._renderTarget = this._getEngine().createMultipleRenderTarget(this._size, this._multiRenderTargetOptions, !this._drawOnlyOnFirstAttachmentByDefault);
        this._texture = this._renderTarget.texture;
    }
    _releaseTextures() {
        if (this._textures) for(let i = 0; i < this._textures.length; i++){
            this._textures[i]._texture = null; // internal textures are released by a call to releaseInternalTextures()
            this._textures[i].dispose();
        }
    }
    _createTextures(textureNames) {
        const internalTextures = this._renderTarget.textures;
        this._textures = [];
        for(let i = 0; i < internalTextures.length; i++){
            const texture = new (0, $j2mX5.Texture)(null, this.getScene());
            if (textureNames?.[i]) texture.name = textureNames[i];
            texture._texture = internalTextures[i];
            if (texture._texture) {
                texture._noMipmap = !texture._texture.useMipMaps;
                texture._useSRGBBuffer = texture._texture._useSRGBBuffer;
            }
            this._textures.push(texture);
        }
    }
    /**
     * Replaces an internal texture within the MRT. Useful to share textures between MultiRenderTarget.
     * @param texture The new texture to set in the MRT
     * @param index The index of the texture to replace
     * @param disposePrevious Set to true if the previous internal texture should be disposed
     */ setInternalTexture(texture, index, disposePrevious = true) {
        if (!this.renderTarget) return;
        if (index === 0) this._texture = texture;
        this.renderTarget.setTexture(texture, index, disposePrevious);
        if (!this.textures[index]) {
            this.textures[index] = new (0, $j2mX5.Texture)(null, this.getScene());
            this.textures[index].name = this._textureNames?.[index] ?? this.textures[index].name;
        }
        this.textures[index]._texture = texture;
        this.textures[index]._noMipmap = !texture.useMipMaps;
        this.textures[index]._useSRGBBuffer = texture._useSRGBBuffer;
        this._count = this.renderTarget.textures ? this.renderTarget.textures.length : 0;
        if (this._multiRenderTargetOptions.types) this._multiRenderTargetOptions.types[index] = texture.type;
        if (this._multiRenderTargetOptions.samplingModes) this._multiRenderTargetOptions.samplingModes[index] = texture.samplingMode;
        if (this._multiRenderTargetOptions.useSRGBBuffers) this._multiRenderTargetOptions.useSRGBBuffers[index] = texture._useSRGBBuffer;
        if (this._multiRenderTargetOptions.targetTypes && this._multiRenderTargetOptions.targetTypes[index] !== -1) {
            let target = 0;
            if (texture.is2DArray) target = 35866;
            else if (texture.isCube) target = 34067;
            else if (texture.is3D) target = 32879;
            else target = 3553;
            this._multiRenderTargetOptions.targetTypes[index] = target;
        }
    }
    /**
     * Changes an attached texture's face index or layer.
     * @param index The index of the texture to modify the attachment of
     * @param layerIndex The layer index of the texture to be attached to the framebuffer
     * @param faceIndex The face index of the texture to be attached to the framebuffer
     */ setLayerAndFaceIndex(index, layerIndex = -1, faceIndex = -1) {
        if (!this.textures[index] || !this.renderTarget) return;
        if (this._multiRenderTargetOptions.layerIndex) this._multiRenderTargetOptions.layerIndex[index] = layerIndex;
        if (this._multiRenderTargetOptions.faceIndex) this._multiRenderTargetOptions.faceIndex[index] = faceIndex;
        this.renderTarget.setLayerAndFaceIndex(index, layerIndex, faceIndex);
    }
    /**
     * Changes every attached texture's face index or layer.
     * @param layerIndices The layer indices of the texture to be attached to the framebuffer
     * @param faceIndices The face indices of the texture to be attached to the framebuffer
     */ setLayerAndFaceIndices(layerIndices, faceIndices) {
        if (!this.renderTarget) return;
        this._multiRenderTargetOptions.layerIndex = layerIndices;
        this._multiRenderTargetOptions.faceIndex = faceIndices;
        this.renderTarget.setLayerAndFaceIndices(layerIndices, faceIndices);
    }
    /**
     * Define the number of samples used if MSAA is enabled.
     */ get samples() {
        return this._samples;
    }
    set samples(value) {
        if (this._renderTarget) this._samples = this._renderTarget.setSamples(value);
        else // In case samples are set with 0 textures created, we must save the desired samples value
        this._samples = value;
    }
    /**
     * Resize all the textures in the multi render target.
     * Be careful as it will recreate all the data in the new texture.
     * @param size Define the new size
     */ resize(size) {
        this._processSizeParameter(size);
        this._rebuild(false, undefined, this._textureNames);
    }
    /**
     * Changes the number of render targets in this MRT
     * Be careful as it will recreate all the data in the new texture.
     * @param count new texture count
     * @param options Specifies texture types and sampling modes for new textures
     * @param textureNames Specifies the names of the textures (optional)
     */ updateCount(count, options, textureNames) {
        this._multiRenderTargetOptions.textureCount = count;
        this._count = count;
        const types = [];
        const samplingModes = [];
        const useSRGBBuffers = [];
        const formats = [];
        const targetTypes = [];
        const faceIndex = [];
        const layerIndex = [];
        const layerCounts = [];
        this._textureNames = textureNames;
        this._initTypes(count, types, samplingModes, useSRGBBuffers, formats, targetTypes, faceIndex, layerIndex, layerCounts, options);
        this._multiRenderTargetOptions.types = types;
        this._multiRenderTargetOptions.samplingModes = samplingModes;
        this._multiRenderTargetOptions.useSRGBBuffers = useSRGBBuffers;
        this._multiRenderTargetOptions.formats = formats;
        this._multiRenderTargetOptions.targetTypes = targetTypes;
        this._multiRenderTargetOptions.faceIndex = faceIndex;
        this._multiRenderTargetOptions.layerIndex = layerIndex;
        this._multiRenderTargetOptions.layerCounts = layerCounts;
        this._multiRenderTargetOptions.labels = textureNames;
        this._rebuild(false, true, textureNames);
    }
    _unbindFrameBuffer(engine, faceIndex) {
        if (this._renderTarget) engine.unBindMultiColorAttachmentFramebuffer(this._renderTarget, this.isCube, ()=>{
            this.onAfterRenderObservable.notifyObservers(faceIndex);
        });
    }
    /**
     * Dispose the render targets and their associated resources
     * @param doNotDisposeInternalTextures if set to true, internal textures won't be disposed (default: false).
     */ dispose(doNotDisposeInternalTextures = false) {
        this._releaseTextures();
        if (!doNotDisposeInternalTextures) this.releaseInternalTextures();
        else // Prevent internal texture dispose in super.dispose
        this._texture = null;
        super.dispose();
    }
    /**
     * Release all the underlying texture used as draw buffers (render textures).
     */ releaseInternalTextures() {
        const internalTextures = this._renderTarget?.textures;
        if (!internalTextures) return;
        for(let i = internalTextures.length - 1; i >= 0; i--)this._textures[i]._texture = null;
        this._renderTarget?.dispose();
        this._renderTarget = null;
    }
}



var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $dG1pf = parcelRequire("dG1pf");

var $cFdBb = parcelRequire("cFdBb");

var $ejQPp = parcelRequire("ejQPp");


class $a5607e3e77bdd809$export$bc751ed5a93e3d23 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        // We are almost sure it is applied by post process as
        // We are in the post process :-)
        value.applyByPostProcess = true;
        this._attachImageProcessingConfiguration(value);
    }
    /**
     * Attaches a new image processing configuration to the PBR Material.
     * @param configuration
     * @param doNotBuild
     */ _attachImageProcessingConfiguration(configuration, doNotBuild = false) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer.
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed.
        if (!configuration) {
            let scene = null;
            const engine = this.getEngine();
            const camera = this.getCamera();
            if (camera) scene = camera.getScene();
            else if (engine && engine.scenes) {
                const scenes = engine.scenes;
                scene = scenes[scenes.length - 1];
            } else scene = (0, $ejQPp.EngineStore).LastCreatedScene;
            if (scene) this._imageProcessingConfiguration = scene.imageProcessingConfiguration;
            else this._imageProcessingConfiguration = new (0, $dG1pf.ImageProcessingConfiguration)();
        } else this._imageProcessingConfiguration = configuration;
        // Attaches observer.
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._updateParameters();
        });
        // Ensure the effect will be rebuilt.
        if (!doNotBuild) this._updateParameters();
    }
    /**
     * If the post process is supported.
     */ get isSupported() {
        const effect = this.getEffect();
        return !effect || effect.isSupported;
    }
    /**
     * Gets Color curves setup used in the effect if colorCurvesEnabled is set to true .
     */ get colorCurves() {
        return this.imageProcessingConfiguration.colorCurves;
    }
    /**
     * Sets Color curves setup used in the effect if colorCurvesEnabled is set to true .
     */ set colorCurves(value) {
        this.imageProcessingConfiguration.colorCurves = value;
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get colorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set colorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
    }
    /**
     * Gets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
     */ get colorGradingTexture() {
        return this.imageProcessingConfiguration.colorGradingTexture;
    }
    /**
     * Sets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
     */ set colorGradingTexture(value) {
        this.imageProcessingConfiguration.colorGradingTexture = value;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get colorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ set colorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
    }
    /**
     * Gets exposure used in the effect.
     */ get exposure() {
        return this.imageProcessingConfiguration.exposure;
    }
    /**
     * Sets exposure used in the effect.
     */ set exposure(value) {
        this.imageProcessingConfiguration.exposure = value;
    }
    /**
     * Gets whether tonemapping is enabled or not.
     */ get toneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
    }
    /**
     * Sets whether tonemapping is enabled or not
     */ set toneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
    }
    /**
     * Gets the type of tone mapping effect.
     */ get toneMappingType() {
        return this._imageProcessingConfiguration.toneMappingType;
    }
    /**
     * Sets the type of tone mapping effect.
     */ set toneMappingType(value) {
        this._imageProcessingConfiguration.toneMappingType = value;
    }
    /**
     * Gets contrast used in the effect.
     */ get contrast() {
        return this.imageProcessingConfiguration.contrast;
    }
    /**
     * Sets contrast used in the effect.
     */ set contrast(value) {
        this.imageProcessingConfiguration.contrast = value;
    }
    /**
     * Gets Vignette stretch size.
     */ get vignetteStretch() {
        return this.imageProcessingConfiguration.vignetteStretch;
    }
    /**
     * Sets Vignette stretch size.
     */ set vignetteStretch(value) {
        this.imageProcessingConfiguration.vignetteStretch = value;
    }
    /**
     * Gets Vignette center X Offset.
     * @deprecated use vignetteCenterX instead
     */ get vignetteCentreX() {
        return this.imageProcessingConfiguration.vignetteCenterX;
    }
    /**
     * Sets Vignette center X Offset.
     * @deprecated use vignetteCenterX instead
     */ set vignetteCentreX(value) {
        this.imageProcessingConfiguration.vignetteCenterX = value;
    }
    /**
     * Gets Vignette center Y Offset.
     * @deprecated use vignetteCenterY instead
     */ get vignetteCentreY() {
        return this.imageProcessingConfiguration.vignetteCenterY;
    }
    /**
     * Sets Vignette center Y Offset.
     * @deprecated use vignetteCenterY instead
     */ set vignetteCentreY(value) {
        this.imageProcessingConfiguration.vignetteCenterY = value;
    }
    /**
     * Vignette center Y Offset.
     */ get vignetteCenterY() {
        return this.imageProcessingConfiguration.vignetteCenterY;
    }
    set vignetteCenterY(value) {
        this.imageProcessingConfiguration.vignetteCenterY = value;
    }
    /**
     * Vignette center X Offset.
     */ get vignetteCenterX() {
        return this.imageProcessingConfiguration.vignetteCenterX;
    }
    set vignetteCenterX(value) {
        this.imageProcessingConfiguration.vignetteCenterX = value;
    }
    /**
     * Gets Vignette weight or intensity of the vignette effect.
     */ get vignetteWeight() {
        return this.imageProcessingConfiguration.vignetteWeight;
    }
    /**
     * Sets Vignette weight or intensity of the vignette effect.
     */ set vignetteWeight(value) {
        this.imageProcessingConfiguration.vignetteWeight = value;
    }
    /**
     * Gets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
     * if vignetteEnabled is set to true.
     */ get vignetteColor() {
        return this.imageProcessingConfiguration.vignetteColor;
    }
    /**
     * Sets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
     * if vignetteEnabled is set to true.
     */ set vignetteColor(value) {
        this.imageProcessingConfiguration.vignetteColor = value;
    }
    /**
     * Gets Camera field of view used by the Vignette effect.
     */ get vignetteCameraFov() {
        return this.imageProcessingConfiguration.vignetteCameraFov;
    }
    /**
     * Sets Camera field of view used by the Vignette effect.
     */ set vignetteCameraFov(value) {
        this.imageProcessingConfiguration.vignetteCameraFov = value;
    }
    /**
     * Gets the vignette blend mode allowing different kind of effect.
     */ get vignetteBlendMode() {
        return this.imageProcessingConfiguration.vignetteBlendMode;
    }
    /**
     * Sets the vignette blend mode allowing different kind of effect.
     */ set vignetteBlendMode(value) {
        this.imageProcessingConfiguration.vignetteBlendMode = value;
    }
    /**
     * Gets whether the vignette effect is enabled.
     */ get vignetteEnabled() {
        return this.imageProcessingConfiguration.vignetteEnabled;
    }
    /**
     * Sets whether the vignette effect is enabled.
     */ set vignetteEnabled(value) {
        this.imageProcessingConfiguration.vignetteEnabled = value;
    }
    /**
     * Gets intensity of the dithering effect.
     */ get ditheringIntensity() {
        return this.imageProcessingConfiguration.ditheringIntensity;
    }
    /**
     * Sets intensity of the dithering effect.
     */ set ditheringIntensity(value) {
        this.imageProcessingConfiguration.ditheringIntensity = value;
    }
    /**
     * Gets whether the dithering effect is enabled.
     */ get ditheringEnabled() {
        return this.imageProcessingConfiguration.ditheringEnabled;
    }
    /**
     * Sets whether the dithering effect is enabled.
     */ set ditheringEnabled(value) {
        this.imageProcessingConfiguration.ditheringEnabled = value;
    }
    /**
     * Gets whether the input of the processing is in Gamma or Linear Space.
     */ get fromLinearSpace() {
        return this._fromLinearSpace;
    }
    /**
     * Sets whether the input of the processing is in Gamma or Linear Space.
     */ set fromLinearSpace(value) {
        if (this._fromLinearSpace === value) return;
        this._fromLinearSpace = value;
        this._updateParameters();
    }
    constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, imageProcessingConfiguration){
        super(name, "imageProcessing", [], [], options, camera, samplingMode, engine, reusable, null, textureType, "postprocess", null, true);
        this._fromLinearSpace = true;
        /**
         * Defines cache preventing GC.
         */ this._defines = {
            IMAGEPROCESSING: false,
            VIGNETTE: false,
            VIGNETTEBLENDMODEMULTIPLY: false,
            VIGNETTEBLENDMODEOPAQUE: false,
            TONEMAPPING: 0,
            CONTRAST: false,
            COLORCURVES: false,
            COLORGRADING: false,
            COLORGRADING3D: false,
            FROMLINEARSPACE: false,
            SAMPLER3DGREENDEPTH: false,
            SAMPLER3DBGRMAP: false,
            DITHER: false,
            IMAGEPROCESSINGPOSTPROCESS: false,
            EXPOSURE: false,
            SKIPFINALCOLORCLAMP: false
        };
        // Setup the configuration as forced by the constructor. This would then not force the
        // scene materials output in linear space and let untouched the default forward pass.
        if (imageProcessingConfiguration) {
            imageProcessingConfiguration.applyByPostProcess = true;
            this._attachImageProcessingConfiguration(imageProcessingConfiguration, true);
            // This will cause the shader to be compiled
            this._updateParameters();
        } else {
            this._attachImageProcessingConfiguration(null, true);
            this.imageProcessingConfiguration.applyByPostProcess = true;
        }
        this.onApply = (effect)=>{
            this.imageProcessingConfiguration.bind(effect, this.aspectRatio);
        };
    }
    _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
            this._webGPUReady = true;
            list.push((parcelRequire("jXgiT")));
        } else list.push((parcelRequire("8ryEv")));
        super._gatherImports(useWebGPU, list);
    }
    /**
     *  "ImageProcessingPostProcess"
     * @returns "ImageProcessingPostProcess"
     */ getClassName() {
        return "ImageProcessingPostProcess";
    }
    /**
     * @internal
     */ _updateParameters() {
        this._defines.FROMLINEARSPACE = this._fromLinearSpace;
        this.imageProcessingConfiguration.prepareDefines(this._defines, true);
        let defines = "";
        for(const prop in this._defines){
            const value = this._defines[prop];
            const type = typeof value;
            switch(type){
                case "number":
                case "string":
                    defines += `#define ${prop} ${value};\n`;
                    break;
                default:
                    if (value) defines += `#define ${prop};\n`;
                    break;
            }
        }
        const samplers = [
            "textureSampler"
        ];
        const uniforms = [
            "scale"
        ];
        if (0, $dG1pf.ImageProcessingConfiguration) {
            (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, this._defines);
            (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, this._defines);
        }
        this.updateEffect(defines, uniforms, samplers);
    }
    dispose(camera) {
        super.dispose(camera);
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        if (this._imageProcessingConfiguration) this.imageProcessingConfiguration.applyByPostProcess = false;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a5607e3e77bdd809$export$bc751ed5a93e3d23.prototype, "_fromLinearSpace", void 0);


class $872656c79ebd68ab$export$b41e293af8980c02 extends (0, $2d74a16bff4ef9de$export$81ca19ef131ad840) {
    constructor(name, renderTargetTexture, size, count, scene, options){
        super(name, size, count, scene, options);
        /**
         * @internal
         */ this._beforeCompositionPostProcesses = [];
        /**
         * @internal
         */ this._internalTextureDirty = false;
        /**
         * Is this render target enabled for prepass rendering
         */ this.enabled = false;
        /**
         * Render target associated with this prePassRenderTarget
         * If this is `null`, it means this prePassRenderTarget is associated with the scene
         */ this.renderTargetTexture = null;
        this.renderTargetTexture = renderTargetTexture;
    }
    /**
     * Creates a composition effect for this RT
     * @internal
     */ _createCompositionEffect() {
        this.imageProcessingPostProcess = new (0, $a5607e3e77bdd809$export$bc751ed5a93e3d23)("prePassComposition", 1, null, undefined, this._engine);
        this.imageProcessingPostProcess._updateParameters();
    }
    /**
     * Checks that the size of this RT is still adapted to the desired render size.
     * @internal
     */ _checkSize() {
        const requiredWidth = this._engine.getRenderWidth(true);
        const requiredHeight = this._engine.getRenderHeight(true);
        const width = this.getRenderWidth();
        const height = this.getRenderHeight();
        if (width !== requiredWidth || height !== requiredHeight) {
            this.resize({
                width: requiredWidth,
                height: requiredHeight
            });
            this._internalTextureDirty = true;
        }
    }
    /**
     * Changes the number of render targets in this MRT
     * Be careful as it will recreate all the data in the new texture.
     * @param count new texture count
     * @param options Specifies texture types and sampling modes for new textures
     * @param textureNames Specifies the names of the textures (optional)
     */ updateCount(count, options, textureNames) {
        super.updateCount(count, options, textureNames);
        this._internalTextureDirty = true;
    }
    /**
     * Resets the post processes chains applied to this RT.
     * @internal
     */ _resetPostProcessChain() {
        this._beforeCompositionPostProcesses.length = 0;
    }
    /**
     * Diposes this render target
     */ dispose() {
        const scene = this._scene;
        super.dispose();
        if (scene && scene.prePassRenderer) {
            const index = scene.prePassRenderer.renderTargets.indexOf(this);
            if (index !== -1) scene.prePassRenderer.renderTargets.splice(index, 1);
        }
        if (this.imageProcessingPostProcess) this.imageProcessingPostProcess.dispose();
        if (this.renderTargetTexture) this.renderTargetTexture._prePassRenderTarget = null;
        if (this._outputPostProcess) {
            this._outputPostProcess.autoClear = true;
            this._outputPostProcess.restoreDefaultInputTexture();
        }
    }
}



var $dUFYy = parcelRequire("dUFYy");

var $7etnY = parcelRequire("7etnY");


var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");


var $7etnY = parcelRequire("7etnY");

var $dUFYy = parcelRequire("dUFYy");

parcelRequire("Squjx");
parcelRequire("7phX0");




/** list the uniforms used by the geometry renderer */ const $c586800380a87410$var$uniforms = [
    "world",
    "mBones",
    "viewProjection",
    "diffuseMatrix",
    "view",
    "previousWorld",
    "previousViewProjection",
    "mPreviousBones",
    "bumpMatrix",
    "reflectivityMatrix",
    "albedoMatrix",
    "reflectivityColor",
    "albedoColor",
    "metallic",
    "glossiness",
    "vTangentSpaceParams",
    "vBumpInfos",
    "morphTargetInfluences",
    "morphTargetCount",
    "morphTargetTextureInfo",
    "morphTargetTextureIndices",
    "boneTextureWidth"
];
(0, $7b5d4109d15c2b5f$export$959caf24bcfab1fd)($c586800380a87410$var$uniforms);




class $c586800380a87410$export$8a4e79b98d630eed {
    /**
     * Gets a boolean indicating if normals are encoded in the [0,1] range in the render target. If true, you should do `normal = normal_rt * 2.0 - 1.0` to get the right normal
     */ get normalsAreUnsigned() {
        return this._normalsAreUnsigned;
    }
    /**
     * @internal
     * Sets up internal structures to share outputs with PrePassRenderer
     * This method should only be called by the PrePassRenderer itself
     */ _linkPrePassRenderer(prePassRenderer) {
        this._linkedWithPrePass = true;
        this._prePassRenderer = prePassRenderer;
        if (this._multiRenderTarget) {
            // prevents clearing of the RT since it's done by prepass
            this._multiRenderTarget.onClearObservable.clear();
            this._multiRenderTarget.onClearObservable.add(()=>{
            // pass
            });
        }
    }
    /**
     * @internal
     * Separates internal structures from PrePassRenderer so the geometry buffer can now operate by itself.
     * This method should only be called by the PrePassRenderer itself
     */ _unlinkPrePassRenderer() {
        this._linkedWithPrePass = false;
        this._createRenderTargets();
    }
    /**
     * @internal
     * Resets the geometry buffer layout
     */ _resetLayout() {
        this._enableDepth = true;
        this._enableNormal = true;
        this._enablePosition = false;
        this._enableReflectivity = false;
        this._enableVelocity = false;
        this._enableVelocityLinear = false;
        this._enableScreenspaceDepth = false;
        this._attachmentsFromPrePass = [];
    }
    /**
     * @internal
     * Replaces a texture in the geometry buffer renderer
     * Useful when linking textures of the prepass renderer
     */ _forceTextureType(geometryBufferType, index) {
        if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE) {
            this._positionIndex = index;
            this._enablePosition = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE) {
            this._velocityIndex = index;
            this._enableVelocity = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_LINEAR_TEXTURE_TYPE) {
            this._velocityLinearIndex = index;
            this._enableVelocityLinear = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE) {
            this._reflectivityIndex = index;
            this._enableReflectivity = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE) {
            this._depthIndex = index;
            this._enableDepth = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE) {
            this._normalIndex = index;
            this._enableNormal = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.SCREENSPACE_DEPTH_TEXTURE_TYPE) {
            this._screenspaceDepthIndex = index;
            this._enableScreenspaceDepth = true;
        }
    }
    /**
     * @internal
     * Sets texture attachments
     * Useful when linking textures of the prepass renderer
     */ _setAttachments(attachments) {
        this._attachmentsFromPrePass = attachments;
    }
    /**
     * @internal
     * Replaces the first texture which is hard coded as a depth texture in the geometry buffer
     * Useful when linking textures of the prepass renderer
     */ _linkInternalTexture(internalTexture) {
        this._multiRenderTarget.setInternalTexture(internalTexture, 0, false);
    }
    /**
     * Gets the render list (meshes to be rendered) used in the G buffer.
     */ get renderList() {
        return this._multiRenderTarget.renderList;
    }
    /**
     * Set the render list (meshes to be rendered) used in the G buffer.
     */ set renderList(meshes) {
        this._multiRenderTarget.renderList = meshes;
    }
    /**
     * Gets whether or not G buffer are supported by the running hardware.
     * This requires draw buffer supports
     */ get isSupported() {
        return this._multiRenderTarget.isSupported;
    }
    /**
     * Returns the index of the given texture type in the G-Buffer textures array
     * @param textureType The texture type constant. For example GeometryBufferRenderer.POSITION_TEXTURE_INDEX
     * @returns the index of the given texture type in the G-Buffer textures array
     */ getTextureIndex(textureType) {
        switch(textureType){
            case $c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE:
                return this._positionIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE:
                return this._velocityIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_LINEAR_TEXTURE_TYPE:
                return this._velocityLinearIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE:
                return this._reflectivityIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE:
                return this._depthIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE:
                return this._normalIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.SCREENSPACE_DEPTH_TEXTURE_TYPE:
                return this._screenspaceDepthIndex;
            default:
                return -1;
        }
    }
    /**
     * @returns a boolean indicating if object's depths are enabled for the G buffer.
     */ get enableDepth() {
        return this._enableDepth;
    }
    /**
     * Sets whether or not object's depths are enabled for the G buffer.
     */ set enableDepth(enable) {
        this._enableDepth = enable;
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * @returns a boolean indicating if object's normals are enabled for the G buffer.
     */ get enableNormal() {
        return this._enableNormal;
    }
    /**
     * Sets whether or not object's normals are enabled for the G buffer.
     */ set enableNormal(enable) {
        this._enableNormal = enable;
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * @returns a boolean indicating if objects positions are enabled for the G buffer.
     */ get enablePosition() {
        return this._enablePosition;
    }
    /**
     * Sets whether or not objects positions are enabled for the G buffer.
     */ set enablePosition(enable) {
        this._enablePosition = enable;
        // PrePass handles index and texture links
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * @returns a boolean indicating if objects velocities are enabled for the G buffer.
     */ get enableVelocity() {
        return this._enableVelocity;
    }
    /**
     * Sets whether or not objects velocities are enabled for the G buffer.
     */ set enableVelocity(enable) {
        this._enableVelocity = enable;
        if (!enable) this._previousTransformationMatrices = {};
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
        this._scene.needsPreviousWorldMatrices = enable;
    }
    /**
     * @returns a boolean indicating if object's linear velocities are enabled for the G buffer.
     */ get enableVelocityLinear() {
        return this._enableVelocityLinear;
    }
    /**
     * Sets whether or not object's linear velocities are enabled for the G buffer.
     */ set enableVelocityLinear(enable) {
        this._enableVelocityLinear = enable;
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * Gets a boolean indicating if objects reflectivity are enabled in the G buffer.
     */ get enableReflectivity() {
        return this._enableReflectivity;
    }
    /**
     * Sets whether or not objects reflectivity are enabled for the G buffer.
     * For Metallic-Roughness workflow with ORM texture, we assume that ORM texture is defined according to the default layout:
     * pbr.useRoughnessFromMetallicTextureAlpha = false;
     * pbr.useRoughnessFromMetallicTextureGreen = true;
     * pbr.useMetallnessFromMetallicTextureBlue = true;
     */ set enableReflectivity(enable) {
        this._enableReflectivity = enable;
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * Sets whether or not objects screenspace depth are enabled for the G buffer.
     */ get enableScreenspaceDepth() {
        return this._enableScreenspaceDepth;
    }
    set enableScreenspaceDepth(enable) {
        this._enableScreenspaceDepth = enable;
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * Gets the scene associated with the buffer.
     */ get scene() {
        return this._scene;
    }
    /**
     * Gets the ratio used by the buffer during its creation.
     * How big is the buffer related to the main canvas.
     */ get ratio() {
        return typeof this._ratioOrDimensions === "object" ? 1 : this._ratioOrDimensions;
    }
    /**
     * Gets the shader language used in this material.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * Creates a new G Buffer for the scene
     * @param scene The scene the buffer belongs to
     * @param ratioOrDimensions How big is the buffer related to the main canvas (default: 1). You can also directly pass a width and height for the generated textures
     * @param depthFormat Format of the depth texture (default: 15)
     * @param textureTypesAndFormats The types and formats of textures to create as render targets. If not provided, all textures will be RGBA and float or half float, depending on the engine capabilities.
     */ constructor(scene, ratioOrDimensions = 1, depthFormat = 15, textureTypesAndFormats){
        /**
         * Dictionary used to store the previous transformation matrices of each rendered mesh
         * in order to compute objects velocities when enableVelocity is set to "true"
         * @internal
         */ this._previousTransformationMatrices = {};
        /**
         * Dictionary used to store the previous bones transformation matrices of each rendered mesh
         * in order to compute objects velocities when enableVelocity is set to "true"
         * @internal
         */ this._previousBonesTransformationMatrices = {};
        /**
         * Array used to store the ignored skinned meshes while computing velocity map (typically used by the motion blur post-process).
         * Avoids computing bones velocities and computes only mesh's velocity itself (position, rotation, scaling).
         */ this.excludedSkinnedMeshesFromVelocity = [];
        /** Gets or sets a boolean indicating if transparent meshes should be rendered */ this.renderTransparentMeshes = true;
        /**
         * Gets or sets a boolean indicating if normals should be generated in world space (default: false, meaning normals are generated in view space)
         */ this.generateNormalsInWorldSpace = false;
        this._normalsAreUnsigned = false;
        this._resizeObserver = null;
        this._enableDepth = true;
        this._enableNormal = true;
        this._enablePosition = false;
        this._enableVelocity = false;
        this._enableVelocityLinear = false;
        this._enableReflectivity = false;
        this._enableScreenspaceDepth = false;
        this._clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._clearDepthColor = new (0, $7etnY.Color4)(1e8, 0, 0, 1); // "infinity" value - depth in the depth texture is view.z, not a 0..1 value!
        this._positionIndex = -1;
        this._velocityIndex = -1;
        this._velocityLinearIndex = -1;
        this._reflectivityIndex = -1;
        this._depthIndex = -1;
        this._normalIndex = -1;
        this._screenspaceDepthIndex = -1;
        this._linkedWithPrePass = false;
        /**
         * If set to true (default: false), the depth texture will be cleared with the depth value corresponding to the far plane (1 in normal mode, 0 in reverse depth buffer mode)
         * If set to false, the depth texture is always cleared with 0.
         */ this.useSpecificClearForDepthTexture = false;
        /** Shader language used by the material */ this._shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
        this._shadersLoaded = false;
        this._scene = scene;
        this._ratioOrDimensions = ratioOrDimensions;
        this._useUbo = scene.getEngine().supportsUniformBuffers;
        this._depthFormat = depthFormat;
        this._textureTypesAndFormats = textureTypesAndFormats || {};
        this._initShaderSourceAsync();
        $c586800380a87410$export$8a4e79b98d630eed._SceneComponentInitialization(this._scene);
        // Render target
        this._createRenderTargets();
    }
    async _initShaderSourceAsync() {
        const engine = this._scene.getEngine();
        if (engine.isWebGPU && !$c586800380a87410$export$8a4e79b98d630eed.ForceGLSL) {
            this._shaderLanguage = 1 /* ShaderLanguage.WGSL */ ;
            await Promise.all([
                (parcelRequire("ljIAV")),
                (parcelRequire("01GWI"))
            ]);
        } else await Promise.all([
            Promise.resolve((parcelRequire("7phX0"))),
            Promise.resolve((parcelRequire("Squjx")))
        ]);
        this._shadersLoaded = true;
    }
    /**
     * Checks whether everything is ready to render a submesh to the G buffer.
     * @param subMesh the submesh to check readiness for
     * @param useInstances is the mesh drawn using instance or not
     * @returns true if ready otherwise false
     */ isReady(subMesh, useInstances) {
        if (!this._shadersLoaded) return false;
        const material = subMesh.getMaterial();
        if (material && material.disableDepthWrite) return false;
        const defines = [];
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind,
            (0, $b4i1f.VertexBuffer).NormalKind
        ];
        const mesh = subMesh.getMesh();
        let uv1 = false;
        let uv2 = false;
        if (material) {
            let needUv = false;
            // Alpha test
            if (material.needAlphaTesting() && material.getAlphaTestTexture()) {
                defines.push("#define ALPHATEST");
                defines.push(`#define ALPHATEST_UV${material.getAlphaTestTexture().coordinatesIndex + 1}`);
                needUv = true;
            }
            // Normal map texture
            if ((material.bumpTexture || material.normalTexture) && (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).BumpTextureEnabled) {
                const texture = material.bumpTexture || material.normalTexture;
                defines.push("#define BUMP");
                defines.push(`#define BUMP_UV${texture.coordinatesIndex + 1}`);
                needUv = true;
            }
            if (this._enableReflectivity) {
                let metallicWorkflow = false;
                // for PBR materials: cf. https://doc.babylonjs.com/features/featuresDeepDive/materials/using/masterPBR
                if (material.getClassName() === "PBRMetallicRoughnessMaterial") {
                    // if it is a PBR material in MetallicRoughness Mode:
                    if (material.metallicRoughnessTexture) {
                        defines.push("#define ORMTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.metallicRoughnessTexture.coordinatesIndex + 1}`);
                        defines.push("#define METALLICWORKFLOW");
                        needUv = true;
                        metallicWorkflow = true;
                    }
                    // null or undefined
                    if (material.metallic != null) {
                        defines.push("#define METALLIC");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    // null or undefined
                    if (material.roughness != null) {
                        defines.push("#define ROUGHNESS");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    if (metallicWorkflow) {
                        if (material.baseTexture) {
                            defines.push("#define ALBEDOTEXTURE");
                            defines.push(`#define ALBEDO_UV${material.baseTexture.coordinatesIndex + 1}`);
                            if (material.baseTexture.gammaSpace) defines.push("#define GAMMAALBEDO");
                            needUv = true;
                        }
                        if (material.baseColor) defines.push("#define ALBEDOCOLOR");
                    }
                } else if (material.getClassName() === "PBRSpecularGlossinessMaterial") {
                    // if it is a PBR material in Specular/Glossiness Mode:
                    if (material.specularGlossinessTexture) {
                        defines.push("#define SPECULARGLOSSINESSTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.specularGlossinessTexture.coordinatesIndex + 1}`);
                        needUv = true;
                        if (material.specularGlossinessTexture.gammaSpace) defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                    } else if (material.specularColor) defines.push("#define REFLECTIVITYCOLOR");
                    // null or undefined
                    if (material.glossiness != null) defines.push("#define GLOSSINESS");
                } else if (material.getClassName() === "PBRMaterial") {
                    // if it is the bigger PBRMaterial
                    if (material.metallicTexture) {
                        defines.push("#define ORMTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.metallicTexture.coordinatesIndex + 1}`);
                        defines.push("#define METALLICWORKFLOW");
                        needUv = true;
                        metallicWorkflow = true;
                    }
                    // null or undefined
                    if (material.metallic != null) {
                        defines.push("#define METALLIC");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    // null or undefined
                    if (material.roughness != null) {
                        defines.push("#define ROUGHNESS");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    if (metallicWorkflow) {
                        if (material.albedoTexture) {
                            defines.push("#define ALBEDOTEXTURE");
                            defines.push(`#define ALBEDO_UV${material.albedoTexture.coordinatesIndex + 1}`);
                            if (material.albedoTexture.gammaSpace) defines.push("#define GAMMAALBEDO");
                            needUv = true;
                        }
                        if (material.albedoColor) defines.push("#define ALBEDOCOLOR");
                    } else {
                        // SpecularGlossiness Model
                        if (material.reflectivityTexture) {
                            defines.push("#define SPECULARGLOSSINESSTEXTURE");
                            defines.push(`#define REFLECTIVITY_UV${material.reflectivityTexture.coordinatesIndex + 1}`);
                            if (material.reflectivityTexture.gammaSpace) defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                            needUv = true;
                        } else if (material.reflectivityColor) defines.push("#define REFLECTIVITYCOLOR");
                        // null or undefined
                        if (material.microSurface != null) defines.push("#define GLOSSINESS");
                    }
                } else if (material.getClassName() === "StandardMaterial") {
                    // if StandardMaterial:
                    if (material.specularTexture) {
                        defines.push("#define REFLECTIVITYTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.specularTexture.coordinatesIndex + 1}`);
                        if (material.specularTexture.gammaSpace) defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                        needUv = true;
                    }
                    if (material.specularColor) defines.push("#define REFLECTIVITYCOLOR");
                }
            }
            if (needUv) {
                defines.push("#define NEED_UV");
                if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                    attribs.push((0, $b4i1f.VertexBuffer).UVKind);
                    defines.push("#define UV1");
                    uv1 = true;
                }
                if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
                    attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
                    defines.push("#define UV2");
                    uv2 = true;
                }
            }
        }
        // Buffers
        if (this._enableDepth) {
            defines.push("#define DEPTH");
            defines.push("#define DEPTH_INDEX " + this._depthIndex);
        }
        if (this._enableNormal) {
            defines.push("#define NORMAL");
            defines.push("#define NORMAL_INDEX " + this._normalIndex);
        }
        if (this._enablePosition) {
            defines.push("#define POSITION");
            defines.push("#define POSITION_INDEX " + this._positionIndex);
        }
        if (this._enableVelocity) {
            defines.push("#define VELOCITY");
            defines.push("#define VELOCITY_INDEX " + this._velocityIndex);
            if (this.excludedSkinnedMeshesFromVelocity.indexOf(mesh) === -1) defines.push("#define BONES_VELOCITY_ENABLED");
        }
        if (this._enableVelocityLinear) {
            defines.push("#define VELOCITY_LINEAR");
            defines.push("#define VELOCITY_LINEAR_INDEX " + this._velocityLinearIndex);
            if (this.excludedSkinnedMeshesFromVelocity.indexOf(mesh) === -1) defines.push("#define BONES_VELOCITY_ENABLED");
        }
        if (this._enableReflectivity) {
            defines.push("#define REFLECTIVITY");
            defines.push("#define REFLECTIVITY_INDEX " + this._reflectivityIndex);
        }
        if (this._enableScreenspaceDepth) {
            if (this._screenspaceDepthIndex !== -1) {
                defines.push("#define SCREENSPACE_DEPTH_INDEX " + this._screenspaceDepthIndex);
                defines.push("#define SCREENSPACE_DEPTH");
            }
        }
        if (this.generateNormalsInWorldSpace) defines.push("#define NORMAL_WORLDSPACE");
        if (this._normalsAreUnsigned) defines.push("#define ENCODE_NORMAL");
        // Bones
        if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            defines.push("#define BONETEXTURE " + mesh.skeleton.isUsingTextureForMatrices);
            defines.push("#define BonesPerMesh " + (mesh.skeleton.bones.length + 1));
        } else {
            defines.push("#define NUM_BONE_INFLUENCERS 0");
            defines.push("#define BONETEXTURE false");
            defines.push("#define BonesPerMesh 0");
        }
        // Morph targets
        const numMorphInfluencers = mesh.morphTargetManager ? (0, $7893e784ec9add9a$export$84f21fdc333b90e7)(mesh.morphTargetManager, defines, attribs, mesh, true, true, false, uv1, uv2 // useUV2Morph
        ) : 0;
        // Instances
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $7893e784ec9add9a$export$3016ce9563275624)(attribs, this._enableVelocity || this._enableVelocityLinear);
            if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
        }
        // Setup textures count
        if (this._linkedWithPrePass) defines.push("#define SCENE_MRT_COUNT " + this._attachmentsFromPrePass.length);
        else defines.push("#define SCENE_MRT_COUNT " + this._multiRenderTarget.textures.length);
        (0, $7b5d4109d15c2b5f$export$8deac9e8ed5fc6a9)(material, this._scene, defines);
        // Get correct effect
        const engine = this._scene.getEngine();
        const drawWrapper = subMesh._getDrawWrapper(undefined, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) drawWrapper.setEffect(engine.createEffect("geometry", {
            attributes: attribs,
            uniformsNames: $c586800380a87410$var$uniforms,
            samplers: [
                "diffuseSampler",
                "bumpSampler",
                "reflectivitySampler",
                "albedoSampler",
                "morphTargets",
                "boneSampler"
            ],
            defines: join,
            onCompiled: null,
            fallbacks: null,
            onError: null,
            uniformBuffersNames: [
                "Scene"
            ],
            indexParameters: {
                buffersCount: this._multiRenderTarget.textures.length - 1,
                maxSimultaneousMorphTargets: numMorphInfluencers
            },
            shaderLanguage: this.shaderLanguage
        }, engine), join);
        return drawWrapper.effect.isReady();
    }
    /**
     * Gets the current underlying G Buffer.
     * @returns the buffer
     */ getGBuffer() {
        return this._multiRenderTarget;
    }
    /**
     * Gets the number of samples used to render the buffer (anti aliasing).
     */ get samples() {
        return this._multiRenderTarget.samples;
    }
    /**
     * Sets the number of samples used to render the buffer (anti aliasing).
     */ set samples(value) {
        this._multiRenderTarget.samples = value;
    }
    /**
     * Disposes the renderer and frees up associated resources.
     */ dispose() {
        if (this._resizeObserver) {
            const engine = this._scene.getEngine();
            engine.onResizeObservable.remove(this._resizeObserver);
            this._resizeObserver = null;
        }
        this.getGBuffer().dispose();
    }
    _assignRenderTargetIndices() {
        const textureNames = [];
        const textureTypesAndFormats = [];
        let count = 0;
        if (this._enableDepth) {
            this._depthIndex = count;
            count++;
            textureNames.push("gBuffer_Depth");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE]);
        }
        if (this._enableNormal) {
            this._normalIndex = count;
            count++;
            textureNames.push("gBuffer_Normal");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE]);
        }
        if (this._enablePosition) {
            this._positionIndex = count;
            count++;
            textureNames.push("gBuffer_Position");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE]);
        }
        if (this._enableVelocity) {
            this._velocityIndex = count;
            count++;
            textureNames.push("gBuffer_Velocity");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE]);
        }
        if (this._enableVelocityLinear) {
            this._velocityLinearIndex = count;
            count++;
            textureNames.push("gBuffer_VelocityLinear");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.VELOCITY_LINEAR_TEXTURE_TYPE]);
        }
        if (this._enableReflectivity) {
            this._reflectivityIndex = count;
            count++;
            textureNames.push("gBuffer_Reflectivity");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE]);
        }
        if (this._enableScreenspaceDepth) {
            this._screenspaceDepthIndex = count;
            count++;
            textureNames.push("gBuffer_ScreenspaceDepth");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.SCREENSPACE_DEPTH_TEXTURE_TYPE]);
        }
        return [
            count,
            textureNames,
            textureTypesAndFormats
        ];
    }
    _createRenderTargets() {
        const engine = this._scene.getEngine();
        const [count, textureNames, textureTypesAndFormat] = this._assignRenderTargetIndices();
        let type = 0;
        if (engine._caps.textureFloat && engine._caps.textureFloatLinearFiltering) type = 1;
        else if (engine._caps.textureHalfFloat && engine._caps.textureHalfFloatLinearFiltering) type = 2;
        const dimensions = this._ratioOrDimensions.width !== undefined ? this._ratioOrDimensions : {
            width: engine.getRenderWidth() * this._ratioOrDimensions,
            height: engine.getRenderHeight() * this._ratioOrDimensions
        };
        const textureTypes = [];
        const textureFormats = [];
        for (const typeAndFormat of textureTypesAndFormat)if (typeAndFormat) {
            textureTypes.push(typeAndFormat.textureType);
            textureFormats.push(typeAndFormat.textureFormat);
        } else {
            textureTypes.push(type);
            textureFormats.push(5);
        }
        this._normalsAreUnsigned = textureTypes[$c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE] === 11 || textureTypes[$c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE] === 13;
        this._multiRenderTarget = new (0, $2d74a16bff4ef9de$export$81ca19ef131ad840)("gBuffer", dimensions, count, this._scene, {
            generateMipMaps: false,
            generateDepthTexture: true,
            types: textureTypes,
            formats: textureFormats,
            depthTextureFormat: this._depthFormat
        }, textureNames.concat("gBuffer_DepthBuffer"));
        if (!this.isSupported) return;
        this._multiRenderTarget.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._multiRenderTarget.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._multiRenderTarget.refreshRate = 1;
        this._multiRenderTarget.renderParticles = false;
        this._multiRenderTarget.renderList = null;
        // Depth is always the first texture in the geometry buffer renderer!
        const layoutAttachmentsAll = [
            true
        ];
        const layoutAttachmentsAllButDepth = [
            false
        ];
        const layoutAttachmentsDepthOnly = [
            true
        ];
        for(let i = 1; i < count; ++i){
            layoutAttachmentsAll.push(true);
            layoutAttachmentsDepthOnly.push(false);
            layoutAttachmentsAllButDepth.push(true);
        }
        const attachmentsAll = engine.buildTextureLayout(layoutAttachmentsAll);
        const attachmentsAllButDepth = engine.buildTextureLayout(layoutAttachmentsAllButDepth);
        const attachmentsDepthOnly = engine.buildTextureLayout(layoutAttachmentsDepthOnly);
        this._multiRenderTarget.onClearObservable.add((engine)=>{
            engine.bindAttachments(this.useSpecificClearForDepthTexture ? attachmentsAllButDepth : attachmentsAll);
            engine.clear(this._clearColor, true, true, true);
            if (this.useSpecificClearForDepthTexture) {
                engine.bindAttachments(attachmentsDepthOnly);
                engine.clear(this._clearDepthColor, true, true, true);
            }
            engine.bindAttachments(attachmentsAll);
        });
        this._resizeObserver = engine.onResizeObservable.add(()=>{
            if (this._multiRenderTarget) {
                const dimensions = this._ratioOrDimensions.width !== undefined ? this._ratioOrDimensions : {
                    width: engine.getRenderWidth() * this._ratioOrDimensions,
                    height: engine.getRenderHeight() * this._ratioOrDimensions
                };
                this._multiRenderTarget.resize(dimensions);
            }
        });
        // Custom render function
        const renderSubMesh = (subMesh)=>{
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = subMesh.getEffectiveMesh();
            const scene = this._scene;
            const engine = scene.getEngine();
            const material = subMesh.getMaterial();
            if (!material) return;
            effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            // Velocity
            if ((this._enableVelocity || this._enableVelocityLinear) && !this._previousTransformationMatrices[effectiveMesh.uniqueId]) {
                this._previousTransformationMatrices[effectiveMesh.uniqueId] = {
                    world: (0, $ha1VO.Matrix).Identity(),
                    viewProjection: scene.getTransformMatrix()
                };
                if (renderingMesh.skeleton) {
                    const bonesTransformations = renderingMesh.skeleton.getTransformMatrices(renderingMesh);
                    this._previousBonesTransformationMatrices[renderingMesh.uniqueId] = this._copyBonesTransformationMatrices(bonesTransformations, new Float32Array(bonesTransformations.length));
                }
            }
            // Managing instances
            const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
            if (batch.mustReturn) return;
            const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
            const world = effectiveMesh.getWorldMatrix();
            if (this.isReady(subMesh, hardwareInstancedRendering)) {
                const drawWrapper = subMesh._getDrawWrapper();
                if (!drawWrapper) return;
                const effect = drawWrapper.effect;
                engine.enableEffect(drawWrapper);
                if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
                if (!this._useUbo) {
                    effect.setMatrix("viewProjection", scene.getTransformMatrix());
                    effect.setMatrix("view", scene.getViewMatrix());
                } else {
                    (0, $7893e784ec9add9a$export$92f8908347587afc)(effect, this._scene.getSceneUniformBuffer());
                    this._scene.finalizeSceneUbo();
                }
                let sideOrientation;
                const instanceDataStorage = renderingMesh._instanceDataStorage;
                if (!instanceDataStorage.isFrozen && (material.backFaceCulling || material.sideOrientation !== null)) {
                    const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
                    sideOrientation = material._getEffectiveOrientation(renderingMesh);
                    if (mainDeterminant < 0) sideOrientation = sideOrientation === (0, $3afee756ef198914$export$a2d8b23205c25948).ClockWiseSideOrientation ? (0, $3afee756ef198914$export$a2d8b23205c25948).CounterClockWiseSideOrientation : (0, $3afee756ef198914$export$a2d8b23205c25948).ClockWiseSideOrientation;
                } else sideOrientation = instanceDataStorage.sideOrientation;
                material._preBind(drawWrapper, sideOrientation);
                // Alpha test
                if (material.needAlphaTesting()) {
                    const alphaTexture = material.getAlphaTestTexture();
                    if (alphaTexture) {
                        effect.setTexture("diffuseSampler", alphaTexture);
                        effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                    }
                }
                // Bump
                if ((material.bumpTexture || material.normalTexture) && scene.getEngine().getCaps().standardDerivatives && (0, $1aa143b647fe12a5$export$cf9c31ce2002efcc).BumpTextureEnabled) {
                    const texture = material.bumpTexture || material.normalTexture;
                    effect.setFloat3("vBumpInfos", texture.coordinatesIndex, 1.0 / texture.level, material.parallaxScaleBias);
                    effect.setMatrix("bumpMatrix", texture.getTextureMatrix());
                    effect.setTexture("bumpSampler", texture);
                    effect.setFloat2("vTangentSpaceParams", material.invertNormalMapX ? -1 : 1.0, material.invertNormalMapY ? -1 : 1.0);
                }
                // Reflectivity
                if (this._enableReflectivity) {
                    // for PBR materials: cf. https://doc.babylonjs.com/features/featuresDeepDive/materials/using/masterPBR
                    if (material.getClassName() === "PBRMetallicRoughnessMaterial") {
                        // if it is a PBR material in MetallicRoughness Mode:
                        if (material.metallicRoughnessTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.metallicRoughnessTexture);
                            effect.setMatrix("reflectivityMatrix", material.metallicRoughnessTexture.getTextureMatrix());
                        }
                        if (material.metallic !== null) effect.setFloat("metallic", material.metallic);
                        if (material.roughness !== null) effect.setFloat("glossiness", 1.0 - material.roughness);
                        if (material.baseTexture !== null) {
                            effect.setTexture("albedoSampler", material.baseTexture);
                            effect.setMatrix("albedoMatrix", material.baseTexture.getTextureMatrix());
                        }
                        if (material.baseColor !== null) effect.setColor3("albedoColor", material.baseColor);
                    } else if (material.getClassName() === "PBRSpecularGlossinessMaterial") {
                        // if it is a PBR material in Specular/Glossiness Mode:
                        if (material.specularGlossinessTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.specularGlossinessTexture);
                            effect.setMatrix("reflectivityMatrix", material.specularGlossinessTexture.getTextureMatrix());
                        } else if (material.specularColor !== null) effect.setColor3("reflectivityColor", material.specularColor);
                        if (material.glossiness !== null) effect.setFloat("glossiness", material.glossiness);
                    } else if (material.getClassName() === "PBRMaterial") {
                        // if it is the bigger PBRMaterial
                        if (material.metallicTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.metallicTexture);
                            effect.setMatrix("reflectivityMatrix", material.metallicTexture.getTextureMatrix());
                        }
                        if (material.metallic !== null) effect.setFloat("metallic", material.metallic);
                        if (material.roughness !== null) effect.setFloat("glossiness", 1.0 - material.roughness);
                        if (material.roughness !== null || material.metallic !== null || material.metallicTexture !== null) {
                            // MetallicRoughness Model
                            if (material.albedoTexture !== null) {
                                effect.setTexture("albedoSampler", material.albedoTexture);
                                effect.setMatrix("albedoMatrix", material.albedoTexture.getTextureMatrix());
                            }
                            if (material.albedoColor !== null) effect.setColor3("albedoColor", material.albedoColor);
                        } else {
                            // SpecularGlossiness Model
                            if (material.reflectivityTexture !== null) {
                                effect.setTexture("reflectivitySampler", material.reflectivityTexture);
                                effect.setMatrix("reflectivityMatrix", material.reflectivityTexture.getTextureMatrix());
                            } else if (material.reflectivityColor !== null) effect.setColor3("reflectivityColor", material.reflectivityColor);
                            if (material.microSurface !== null) effect.setFloat("glossiness", material.microSurface);
                        }
                    } else if (material.getClassName() === "StandardMaterial") {
                        // if StandardMaterial:
                        if (material.specularTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.specularTexture);
                            effect.setMatrix("reflectivityMatrix", material.specularTexture.getTextureMatrix());
                        }
                        if (material.specularColor !== null) effect.setColor3("reflectivityColor", material.specularColor);
                    }
                }
                // Clip plane
                (0, $7b5d4109d15c2b5f$export$99061f41c02073b)(effect, material, this._scene);
                // Bones
                if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                    const skeleton = renderingMesh.skeleton;
                    if (skeleton.isUsingTextureForMatrices && effect.getUniformIndex("boneTextureWidth") > -1) {
                        const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                        effect.setTexture("boneSampler", boneTexture);
                        effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                    } else effect.setMatrices("mBones", renderingMesh.skeleton.getTransformMatrices(renderingMesh));
                    if (this._enableVelocity || this._enableVelocityLinear) effect.setMatrices("mPreviousBones", this._previousBonesTransformationMatrices[renderingMesh.uniqueId]);
                }
                // Morph targets
                (0, $7893e784ec9add9a$export$f33581baf6024652)(renderingMesh, effect);
                if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) renderingMesh.morphTargetManager._bind(effect);
                // Velocity
                if (this._enableVelocity || this._enableVelocityLinear) {
                    effect.setMatrix("previousWorld", this._previousTransformationMatrices[effectiveMesh.uniqueId].world);
                    effect.setMatrix("previousViewProjection", this._previousTransformationMatrices[effectiveMesh.uniqueId].viewProjection);
                }
                if (hardwareInstancedRendering && renderingMesh.hasThinInstances) effect.setMatrix("world", world);
                // Draw
                renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, w)=>{
                    if (!isInstance) effect.setMatrix("world", w);
                });
            }
            // Velocity
            if (this._enableVelocity || this._enableVelocityLinear) {
                this._previousTransformationMatrices[effectiveMesh.uniqueId].world = world.clone();
                this._previousTransformationMatrices[effectiveMesh.uniqueId].viewProjection = this._scene.getTransformMatrix().clone();
                if (renderingMesh.skeleton) this._copyBonesTransformationMatrices(renderingMesh.skeleton.getTransformMatrices(renderingMesh), this._previousBonesTransformationMatrices[effectiveMesh.uniqueId]);
            }
        };
        this._multiRenderTarget.customIsReadyFunction = (mesh, refreshRate, preWarm)=>{
            if ((preWarm || refreshRate === 0) && mesh.subMeshes) for(let i = 0; i < mesh.subMeshes.length; ++i){
                const subMesh = mesh.subMeshes[i];
                const material = subMesh.getMaterial();
                const renderingMesh = subMesh.getRenderingMesh();
                if (!material) continue;
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
                if (!this.isReady(subMesh, hardwareInstancedRendering)) return false;
            }
            return true;
        };
        this._multiRenderTarget.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes)=>{
            let index;
            if (this._linkedWithPrePass) {
                if (!this._prePassRenderer.enabled) return;
                this._scene.getEngine().bindAttachments(this._attachmentsFromPrePass);
            }
            if (depthOnlySubMeshes.length) {
                engine.setColorWrite(false);
                for(index = 0; index < depthOnlySubMeshes.length; index++)renderSubMesh(depthOnlySubMeshes.data[index]);
                engine.setColorWrite(true);
            }
            for(index = 0; index < opaqueSubMeshes.length; index++)renderSubMesh(opaqueSubMeshes.data[index]);
            engine.setDepthWrite(false);
            for(index = 0; index < alphaTestSubMeshes.length; index++)renderSubMesh(alphaTestSubMeshes.data[index]);
            if (this.renderTransparentMeshes) for(index = 0; index < transparentSubMeshes.length; index++)renderSubMesh(transparentSubMeshes.data[index]);
            engine.setDepthWrite(true);
        };
    }
    // Copies the bones transformation matrices into the target array and returns the target's reference
    _copyBonesTransformationMatrices(source, target) {
        for(let i = 0; i < source.length; i++)target[i] = source[i];
        return target;
    }
}
/**
 * Force all the standard materials to compile to glsl even on WebGPU engines.
 * False by default. This is mostly meant for backward compatibility.
 */ $c586800380a87410$export$8a4e79b98d630eed.ForceGLSL = false;
/**
 * Constant used to retrieve the depth texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.DEPTH_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE = 0;
/**
 * Constant used to retrieve the normal texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.NORMAL_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE = 1;
/**
 * Constant used to retrieve the position texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.POSITION_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE = 2;
/**
 * Constant used to retrieve the velocity texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.VELOCITY_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE = 3;
/**
 * Constant used to retrieve the reflectivity texture index in the G-Buffer textures array
 * using the getIndex(GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE)
 */ $c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE = 4;
/**
 * Constant used to retrieve the screen-space depth texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.SCREENSPACE_DEPTH_TEXTURE_TYPE)
 */ $c586800380a87410$export$8a4e79b98d630eed.SCREENSPACE_DEPTH_TEXTURE_TYPE = 5;
/**
 * Constant used to retrieve the linear velocity texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.VELOCITY_LINEAR_TEXTURE_TYPE)
 */ $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_LINEAR_TEXTURE_TYPE = 6;
/**
 * @internal
 */ $c586800380a87410$export$8a4e79b98d630eed._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("GeometryBufferRendererSceneComponent");
};



class $b97fe3ee0f5fb378$export$b211103d23883ea6 {
    /**
     * Indicates if the prepass renderer is generating normals in world space or camera space (default: camera space)
     */ get generateNormalsInWorldSpace() {
        return this._generateNormalsInWorldSpace;
    }
    set generateNormalsInWorldSpace(value) {
        if (this._generateNormalsInWorldSpace === value) return;
        this._generateNormalsInWorldSpace = value;
        this._markAllMaterialsAsPrePassDirty();
    }
    /**
     * Returns the index of a texture in the multi render target texture array.
     * @param type Texture type
     * @returns The index
     */ getIndex(type) {
        return this._textureIndices[type];
    }
    /**
     * How many samples are used for MSAA of the scene render target
     */ get samples() {
        return this.defaultRT.samples;
    }
    set samples(n) {
        this.defaultRT.samples = n;
    }
    /**
     * If set to true (default: false), the depth texture will be cleared with the depth value corresponding to the far plane (1 in normal mode, 0 in reverse depth buffer mode)
     * If set to false, the depth texture is always cleared with 0.
     */ get useSpecificClearForDepthTexture() {
        return this._useSpecificClearForDepthTexture;
    }
    set useSpecificClearForDepthTexture(value) {
        if (this._useSpecificClearForDepthTexture === value) return;
        this._useSpecificClearForDepthTexture = value;
        this._isDirty = true;
    }
    /**
     * @returns the prepass render target for the rendering pass.
     * If we are currently rendering a render target, it returns the PrePassRenderTarget
     * associated with that render target. Otherwise, it returns the scene default PrePassRenderTarget
     */ getRenderTarget() {
        return this._currentTarget;
    }
    /**
     * @internal
     * Managed by the scene component
     * @param prePassRenderTarget
     */ _setRenderTarget(prePassRenderTarget) {
        if (prePassRenderTarget) this._currentTarget = prePassRenderTarget;
        else {
            this._currentTarget = this.defaultRT;
            this._engine.currentRenderPassId = this._scene.activeCamera?.renderPassId ?? this._currentTarget.renderPassId;
        }
    }
    /**
     * Returns true if the currently rendered prePassRenderTarget is the one
     * associated with the scene.
     */ get currentRTisSceneRT() {
        return this._currentTarget === this.defaultRT;
    }
    _refreshGeometryBufferRendererLink() {
        if (!this.doNotUseGeometryRendererFallback) {
            this._geometryBuffer = this._scene.enableGeometryBufferRenderer();
            if (!this._geometryBuffer) {
                // Not supported
                this.doNotUseGeometryRendererFallback = true;
                return;
            }
            this._geometryBuffer._linkPrePassRenderer(this);
        } else {
            if (this._geometryBuffer) this._geometryBuffer._unlinkPrePassRenderer();
            this._geometryBuffer = null;
            this._scene.disableGeometryBufferRenderer();
        }
    }
    /**
     * Indicates if the prepass is enabled
     */ get enabled() {
        return this._enabled;
    }
    /**
     * Instantiates a prepass renderer
     * @param scene The scene
     */ constructor(scene){
        /**
         * To save performance, we can excluded skinned meshes from the prepass
         */ this.excludedSkinnedMesh = [];
        /**
         * Force material to be excluded from the prepass
         * Can be useful when `useGeometryBufferFallback` is set to `true`
         * and you don't want a material to show in the effect.
         */ this.excludedMaterials = [];
        /**
         * Number of textures in the multi render target texture where the scene is directly rendered
         */ this.mrtCount = 0;
        this._mrtTypes = [];
        this._mrtFormats = [];
        this._mrtLayout = [];
        this._mrtNames = [];
        this._textureIndices = [];
        this._generateNormalsInWorldSpace = false;
        this._useSpecificClearForDepthTexture = false;
        this._isDirty = true;
        /**
         * Configuration for prepass effects
         */ this._effectConfigurations = [];
        /**
         * Prevents the PrePassRenderer from using the GeometryBufferRenderer as a fallback
         */ this.doNotUseGeometryRendererFallback = true;
        /**
         * All the render targets generated by prepass
         */ this.renderTargets = [];
        this._clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._clearDepthColor = new (0, $7etnY.Color4)(1e8, 0, 0, 1); // "infinity" value - depth in the depth texture is view.z, not a 0..1 value!
        this._enabled = false;
        this._needsCompositionForThisPass = false;
        /**
         * Set to true to disable gamma transform in PrePass.
         * Can be useful in case you already proceed to gamma transform on a material level
         * and your post processes don't need to be in linear color space.
         */ this.disableGammaTransform = false;
        this._scene = scene;
        this._engine = scene.getEngine();
        let type = 0;
        if (this._engine._caps.textureFloat && this._engine._caps.textureFloatLinearFiltering) type = 1;
        else if (this._engine._caps.textureHalfFloat && this._engine._caps.textureHalfFloatLinearFiltering) type = 2;
        for(let i = 0; i < $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats.length; ++i){
            const format = $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].format;
            if ($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].type === 1) {
                $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].type = type;
                if (type === 1 && (format === 6 || format === 7 || format === 5) && !this._engine._caps.supportFloatTexturesResolve) // We don't know in advance if the texture will be used as a resolve target, so we revert to half_float if the extension to resolve full float textures is not supported
                $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].type = 2;
            }
        }
        $b97fe3ee0f5fb378$export$b211103d23883ea6._SceneComponentInitialization(this._scene);
        this.defaultRT = this._createRenderTarget("sceneprePassRT", null);
        this._currentTarget = this.defaultRT;
    }
    /**
     * Creates a new PrePassRenderTarget
     * This should be the only way to instantiate a `PrePassRenderTarget`
     * @param name Name of the `PrePassRenderTarget`
     * @param renderTargetTexture RenderTarget the `PrePassRenderTarget` will be attached to.
     * Can be `null` if the created `PrePassRenderTarget` is attached to the scene (default framebuffer).
     * @internal
     */ _createRenderTarget(name, renderTargetTexture) {
        const rt = new (0, $872656c79ebd68ab$export$b41e293af8980c02)(name, renderTargetTexture, {
            width: this._engine.getRenderWidth(),
            height: this._engine.getRenderHeight()
        }, 0, this._scene, {
            generateMipMaps: false,
            generateStencilBuffer: this._engine.isStencilEnable,
            defaultType: 0,
            types: [],
            drawOnlyOnFirstAttachmentByDefault: true
        });
        this.renderTargets.push(rt);
        if (this._enabled) // The pre-pass renderer is already enabled, so make sure we create the render target with the correct number of textures
        this._update();
        return rt;
    }
    /**
     * Indicates if rendering a prepass is supported
     */ get isSupported() {
        return this._scene.getEngine().getCaps().drawBuffersExtension;
    }
    /**
     * Sets the proper output textures to draw in the engine.
     * @param effect The effect that is drawn. It can be or not be compatible with drawing to several output textures.
     * @param subMesh Submesh on which the effect is applied
     */ bindAttachmentsForEffect(effect, subMesh) {
        const material = subMesh.getMaterial();
        const isPrePassCapable = material && material.isPrePassCapable;
        const excluded = material && this.excludedMaterials.indexOf(material) !== -1;
        if (this.enabled && this._currentTarget.enabled) {
            if (effect._multiTarget && isPrePassCapable && !excluded) this._engine.bindAttachments(this._multiRenderAttachments);
            else {
                if (this._engine._currentRenderTarget) this._engine.bindAttachments(this._defaultAttachments);
                else this._engine.restoreSingleAttachment();
                if (this._geometryBuffer && this.currentRTisSceneRT && !excluded) this._geometryBuffer.renderList.push(subMesh.getRenderingMesh());
            }
        }
    }
    _reinitializeAttachments() {
        const multiRenderLayout = [];
        const clearLayout = [
            false
        ];
        const clearDepthLayout = [
            false
        ];
        const defaultLayout = [
            true
        ];
        for(let i = 0; i < this.mrtCount; i++){
            multiRenderLayout.push(true);
            if (i > 0) {
                if (this._useSpecificClearForDepthTexture && this._mrtLayout[i] === 5) {
                    clearLayout.push(false);
                    clearDepthLayout.push(true);
                } else {
                    clearLayout.push(true);
                    clearDepthLayout.push(false);
                }
                defaultLayout.push(false);
            }
        }
        this._multiRenderAttachments = this._engine.buildTextureLayout(multiRenderLayout);
        this._clearAttachments = this._engine.buildTextureLayout(clearLayout);
        this._clearDepthAttachments = this._engine.buildTextureLayout(clearDepthLayout);
        this._defaultAttachments = this._engine.buildTextureLayout(defaultLayout);
    }
    _resetLayout() {
        for(let i = 0; i < $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats.length; i++)this._textureIndices[$b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].purpose] = -1;
        this._textureIndices[4] = 0;
        this._mrtLayout = [
            4
        ];
        this._mrtTypes = [
            $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[4].type
        ];
        this._mrtFormats = [
            $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[4].format
        ];
        this._mrtNames = [
            $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[4].name
        ];
        this.mrtCount = 1;
    }
    _updateGeometryBufferLayout() {
        this._refreshGeometryBufferRendererLink();
        if (this._geometryBuffer) {
            this._geometryBuffer._resetLayout();
            const texturesActivated = [];
            for(let i = 0; i < this._mrtLayout.length; i++)texturesActivated.push(false);
            this._geometryBuffer._linkInternalTexture(this.defaultRT.getInternalTexture());
            const matches = [
                {
                    prePassConstant: 5,
                    geometryBufferConstant: (0, $c586800380a87410$export$8a4e79b98d630eed).DEPTH_TEXTURE_TYPE
                },
                {
                    prePassConstant: 6,
                    geometryBufferConstant: (0, $c586800380a87410$export$8a4e79b98d630eed).NORMAL_TEXTURE_TYPE
                },
                {
                    prePassConstant: 1,
                    geometryBufferConstant: (0, $c586800380a87410$export$8a4e79b98d630eed).POSITION_TEXTURE_TYPE
                },
                {
                    prePassConstant: 3,
                    geometryBufferConstant: (0, $c586800380a87410$export$8a4e79b98d630eed).REFLECTIVITY_TEXTURE_TYPE
                },
                {
                    prePassConstant: 2,
                    geometryBufferConstant: (0, $c586800380a87410$export$8a4e79b98d630eed).VELOCITY_TEXTURE_TYPE
                }
            ];
            // replace textures in the geometryBuffer RT
            for(let i = 0; i < matches.length; i++){
                const index = this._mrtLayout.indexOf(matches[i].prePassConstant);
                if (index !== -1) {
                    this._geometryBuffer._forceTextureType(matches[i].geometryBufferConstant, index);
                    texturesActivated[index] = true;
                }
            }
            this._geometryBuffer._setAttachments(this._engine.buildTextureLayout(texturesActivated));
        }
    }
    /**
     * Restores attachments for single texture draw.
     */ restoreAttachments() {
        if (this.enabled && this._currentTarget.enabled && this._defaultAttachments) {
            if (this._engine._currentRenderTarget) this._engine.bindAttachments(this._defaultAttachments);
            else this._engine.restoreSingleAttachment();
        }
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _beforeDraw(camera, faceIndex, layer) {
        // const previousEnabled = this._enabled && this._currentTarget.enabled;
        if (this._isDirty) this._update();
        if (!this._enabled || !this._currentTarget.enabled) return;
        if (this._geometryBuffer) this._geometryBuffer.renderList = [];
        this._setupOutputForThisPass(this._currentTarget, camera);
    }
    _prepareFrame(prePassRenderTarget, faceIndex, layer) {
        if (prePassRenderTarget.renderTargetTexture) prePassRenderTarget.renderTargetTexture._prepareFrame(this._scene, faceIndex, layer, prePassRenderTarget.renderTargetTexture.useCameraPostProcesses);
        else if (this._postProcessesSourceForThisPass.length) this._scene.postProcessManager._prepareFrame();
        else this._engine.restoreDefaultFramebuffer();
    }
    /**
     * Sets an intermediary texture between prepass and postprocesses. This texture
     * will be used as input for post processes
     * @param rt The render target texture to use
     * @returns true if there are postprocesses that will use this texture,
     * false if there is no postprocesses - and the function has no effect
     */ setCustomOutput(rt) {
        const firstPP = this._postProcessesSourceForThisPass[0];
        if (!firstPP) return false;
        firstPP.inputTexture = rt.renderTarget;
        return true;
    }
    _renderPostProcesses(prePassRenderTarget, faceIndex) {
        const firstPP = this._postProcessesSourceForThisPass[0];
        const outputTexture = firstPP ? firstPP.inputTexture : prePassRenderTarget.renderTargetTexture ? prePassRenderTarget.renderTargetTexture.renderTarget : null;
        // Build post process chain for this prepass post draw
        let postProcessChain = this._currentTarget._beforeCompositionPostProcesses;
        if (this._needsCompositionForThisPass) postProcessChain = postProcessChain.concat([
            this._currentTarget.imageProcessingPostProcess
        ]);
        // Activates and renders the chain
        if (postProcessChain.length) {
            this._scene.postProcessManager._prepareFrame(this._currentTarget.renderTarget?.texture, postProcessChain);
            this._scene.postProcessManager.directRender(postProcessChain, outputTexture, false, faceIndex);
        }
    }
    /**
     * @internal
     */ _afterDraw(faceIndex, layer) {
        if (this._enabled && this._currentTarget.enabled) {
            this._prepareFrame(this._currentTarget, faceIndex, layer);
            this._renderPostProcesses(this._currentTarget, faceIndex);
        }
    }
    /**
     * Clears the current prepass render target (in the sense of settings pixels to the scene clear color value)
     * @internal
     */ _clear() {
        if (this._isDirty) this._update();
        if (this._enabled && this._currentTarget.enabled) {
            this._bindFrameBuffer();
            // Clearing other attachment with 0 on all other attachments
            this._engine.bindAttachments(this._clearAttachments);
            this._engine.clear(this._clearColor, true, false, false);
            if (this._useSpecificClearForDepthTexture) {
                this._engine.bindAttachments(this._clearDepthAttachments);
                this._engine.clear(this._clearDepthColor, true, false, false);
            }
            // Regular clear color with the scene clear color of the 1st attachment
            this._engine.bindAttachments(this._defaultAttachments);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _bindFrameBuffer() {
        if (this._enabled && this._currentTarget.enabled) {
            this._currentTarget._checkSize();
            const internalTexture = this._currentTarget.renderTarget;
            if (internalTexture) this._engine.bindFramebuffer(internalTexture);
        }
    }
    _setEnabled(enabled) {
        this._enabled = enabled;
    }
    _setRenderTargetEnabled(prePassRenderTarget, enabled) {
        prePassRenderTarget.enabled = enabled;
        if (!enabled) this._unlinkInternalTexture(prePassRenderTarget);
    }
    /**
     * Adds an effect configuration to the prepass render target.
     * If an effect has already been added, it won't add it twice and will return the configuration
     * already present.
     * @param cfg the effect configuration
     * @returns the effect configuration now used by the prepass
     */ addEffectConfiguration(cfg) {
        // Do not add twice
        for(let i = 0; i < this._effectConfigurations.length; i++){
            if (this._effectConfigurations[i].name === cfg.name) return this._effectConfigurations[i];
        }
        this._effectConfigurations.push(cfg);
        return cfg;
    }
    /**
     * Retrieves an effect configuration by name
     * @param name the name of the effect configuration
     * @returns the effect configuration, or null if not present
     */ getEffectConfiguration(name) {
        for(let i = 0; i < this._effectConfigurations.length; i++){
            if (this._effectConfigurations[i].name === name) return this._effectConfigurations[i];
        }
        return null;
    }
    _enable() {
        const previousMrtCount = this.mrtCount;
        for(let i = 0; i < this._effectConfigurations.length; i++)if (this._effectConfigurations[i].enabled) this._enableTextures(this._effectConfigurations[i].texturesRequired);
        for(let i = 0; i < this.renderTargets.length; i++){
            if (this.mrtCount !== previousMrtCount || this.renderTargets[i].count !== this.mrtCount) this.renderTargets[i].updateCount(this.mrtCount, {
                types: this._mrtTypes,
                formats: this._mrtFormats
            }, this._mrtNames.concat("prePass_DepthBuffer"));
            this.renderTargets[i]._resetPostProcessChain();
            for(let j = 0; j < this._effectConfigurations.length; j++)if (this._effectConfigurations[j].enabled) {
                // TODO : subsurface scattering has 1 scene-wide effect configuration
                // solution : do not stock postProcess on effectConfiguration, but in the prepassRenderTarget (hashmap configuration => postProcess)
                // And call createPostProcess whenever the post process does not exist in the RT
                if (!this._effectConfigurations[j].postProcess && this._effectConfigurations[j].createPostProcess) this._effectConfigurations[j].createPostProcess();
                if (this._effectConfigurations[j].postProcess) this.renderTargets[i]._beforeCompositionPostProcesses.push(this._effectConfigurations[j].postProcess);
            }
        }
        this._reinitializeAttachments();
        this._setEnabled(true);
        this._updateGeometryBufferLayout();
    }
    _disable() {
        this._setEnabled(false);
        for(let i = 0; i < this.renderTargets.length; i++)this._setRenderTargetEnabled(this.renderTargets[i], false);
        this._resetLayout();
        for(let i = 0; i < this._effectConfigurations.length; i++)this._effectConfigurations[i].enabled = false;
    }
    _getPostProcessesSource(prePassRenderTarget, camera) {
        if (camera) return camera._postProcesses;
        else if (prePassRenderTarget.renderTargetTexture) {
            if (prePassRenderTarget.renderTargetTexture.useCameraPostProcesses) {
                const camera = prePassRenderTarget.renderTargetTexture.activeCamera ? prePassRenderTarget.renderTargetTexture.activeCamera : this._scene.activeCamera;
                return camera ? camera._postProcesses : [];
            } else if (prePassRenderTarget.renderTargetTexture.postProcesses) return prePassRenderTarget.renderTargetTexture.postProcesses;
            else return [];
        } else return this._scene.activeCamera ? this._scene.activeCamera._postProcesses : [];
    }
    _setupOutputForThisPass(prePassRenderTarget, camera) {
        // Order is : draw ===> prePassRenderTarget._postProcesses ==> ipp ==> camera._postProcesses
        const secondaryCamera = camera && this._scene.activeCameras && !!this._scene.activeCameras.length && this._scene.activeCameras.indexOf(camera) !== 0;
        this._postProcessesSourceForThisPass = this._getPostProcessesSource(prePassRenderTarget, camera);
        this._postProcessesSourceForThisPass = this._postProcessesSourceForThisPass.filter((pp)=>{
            return pp != null;
        });
        this._scene.autoClear = true;
        const cameraHasImageProcessing = this._hasImageProcessing(this._postProcessesSourceForThisPass);
        this._needsCompositionForThisPass = !cameraHasImageProcessing && !this.disableGammaTransform && this._needsImageProcessing() && !secondaryCamera;
        const firstCameraPP = this._getFirstPostProcess(this._postProcessesSourceForThisPass);
        const firstPrePassPP = prePassRenderTarget._beforeCompositionPostProcesses && prePassRenderTarget._beforeCompositionPostProcesses[0];
        let firstPP = null;
        // Setting the scene-wide post process configuration
        this._scene.imageProcessingConfiguration.applyByPostProcess = this._needsCompositionForThisPass || cameraHasImageProcessing;
        // Create composition effect if needed
        if (this._needsCompositionForThisPass && !prePassRenderTarget.imageProcessingPostProcess) prePassRenderTarget._createCompositionEffect();
        // Setting the prePassRenderTarget as input texture of the first PP
        if (firstPrePassPP) firstPP = firstPrePassPP;
        else if (this._needsCompositionForThisPass) firstPP = prePassRenderTarget.imageProcessingPostProcess;
        else if (firstCameraPP) firstPP = firstCameraPP;
        this._bindFrameBuffer();
        this._linkInternalTexture(prePassRenderTarget, firstPP);
    }
    _linkInternalTexture(prePassRenderTarget, postProcess) {
        if (postProcess) {
            postProcess.autoClear = false;
            postProcess.inputTexture = prePassRenderTarget.renderTarget;
        }
        if (prePassRenderTarget._outputPostProcess !== postProcess) {
            if (prePassRenderTarget._outputPostProcess) this._unlinkInternalTexture(prePassRenderTarget);
            prePassRenderTarget._outputPostProcess = postProcess;
        }
        if (prePassRenderTarget._internalTextureDirty) {
            this._updateGeometryBufferLayout();
            prePassRenderTarget._internalTextureDirty = false;
        }
    }
    /**
     * @internal
     */ _unlinkInternalTexture(prePassRenderTarget) {
        if (prePassRenderTarget._outputPostProcess) {
            prePassRenderTarget._outputPostProcess.autoClear = true;
            prePassRenderTarget._outputPostProcess.restoreDefaultInputTexture();
            prePassRenderTarget._outputPostProcess = null;
        }
    }
    _needsImageProcessing() {
        for(let i = 0; i < this._effectConfigurations.length; i++){
            if (this._effectConfigurations[i].enabled && this._effectConfigurations[i].needsImageProcessing) return true;
        }
        return false;
    }
    _hasImageProcessing(postProcesses) {
        let isIPPAlreadyPresent = false;
        if (postProcesses) {
            for(let i = 0; i < postProcesses.length; i++)if (postProcesses[i]?.getClassName() === "ImageProcessingPostProcess") {
                isIPPAlreadyPresent = true;
                break;
            }
        }
        return isIPPAlreadyPresent;
    }
    /**
     * Internal, gets the first post proces.
     * @param postProcesses
     * @returns the first post process to be run on this camera.
     */ _getFirstPostProcess(postProcesses) {
        for(let ppIndex = 0; ppIndex < postProcesses.length; ppIndex++){
            if (postProcesses[ppIndex] !== null) return postProcesses[ppIndex];
        }
        return null;
    }
    /**
     * Marks the prepass renderer as dirty, triggering a check if the prepass is necessary for the next rendering.
     */ markAsDirty() {
        this._isDirty = true;
    }
    /**
     * Enables a texture on the MultiRenderTarget for prepass
     * @param types
     */ _enableTextures(types) {
        // For velocity : enable storage of previous matrices for instances
        this._scene.needsPreviousWorldMatrices = false;
        for(let i = 0; i < types.length; i++){
            const type = types[i];
            if (this._textureIndices[type] === -1) {
                this._textureIndices[type] = this._mrtLayout.length;
                this._mrtLayout.push(type);
                this._mrtTypes.push($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[type].type);
                this._mrtFormats.push($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[type].format);
                this._mrtNames.push($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[type].name);
                this.mrtCount++;
            }
            if (type === 2 || type === 11) this._scene.needsPreviousWorldMatrices = true;
        }
    }
    /**
     * Makes sure that the prepass renderer is up to date if it has been dirtified.
     */ update() {
        if (this._isDirty) this._update();
    }
    _update() {
        this._disable();
        let enablePrePass = false;
        this._scene.imageProcessingConfiguration.applyByPostProcess = false;
        if (this._scene._depthPeelingRenderer && this._scene.useOrderIndependentTransparency) {
            this._scene._depthPeelingRenderer.setPrePassRenderer(this);
            enablePrePass = true;
        }
        for(let i = 0; i < this._scene.materials.length; i++)if (this._scene.materials[i].setPrePassRenderer(this)) enablePrePass = true;
        if (enablePrePass) this._setRenderTargetEnabled(this.defaultRT, true);
        let postProcesses;
        for(let i = 0; i < this.renderTargets.length; i++){
            if (this.renderTargets[i].renderTargetTexture) postProcesses = this._getPostProcessesSource(this.renderTargets[i]);
            else {
                const camera = this._scene.activeCamera;
                if (!camera) continue;
                postProcesses = camera._postProcesses;
            }
            if (!postProcesses) continue;
            postProcesses = postProcesses.filter((pp)=>{
                return pp != null;
            });
            if (postProcesses) {
                for(let j = 0; j < postProcesses.length; j++)if (postProcesses[j].setPrePassRenderer(this)) {
                    this._setRenderTargetEnabled(this.renderTargets[i], true);
                    enablePrePass = true;
                }
                if (this._hasImageProcessing(postProcesses)) this._scene.imageProcessingConfiguration.applyByPostProcess = true;
            }
        }
        this._markAllMaterialsAsPrePassDirty();
        this._isDirty = false;
        if (enablePrePass) this._enable();
    }
    _markAllMaterialsAsPrePassDirty() {
        const materials = this._scene.materials;
        for(let i = 0; i < materials.length; i++)materials[i].markAsDirty((0, $3afee756ef198914$export$a2d8b23205c25948).PrePassDirtyFlag);
    }
    /**
     * Disposes the prepass renderer.
     */ dispose() {
        for(let i = this.renderTargets.length - 1; i >= 0; i--)this.renderTargets[i].dispose();
        for(let i = 0; i < this._effectConfigurations.length; i++)if (this._effectConfigurations[i].dispose) this._effectConfigurations[i].dispose();
    }
}
/**
 * @internal
 */ $b97fe3ee0f5fb378$export$b211103d23883ea6._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("PrePassRendererSceneComponent");
};
/**
 * Describes the types and formats of the textures used by the pre-pass renderer
 */ $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats = [
    {
        purpose: 0,
        type: 2,
        format: 5,
        name: "prePass_Irradiance"
    },
    {
        purpose: 1,
        type: 2,
        format: 5,
        name: "prePass_Position"
    },
    {
        purpose: 2,
        type: 0,
        format: 5,
        name: "prePass_Velocity"
    },
    {
        purpose: 3,
        type: 0,
        format: 5,
        name: "prePass_Reflectivity"
    },
    {
        purpose: 4,
        type: 2,
        format: 5,
        name: "prePass_Color"
    },
    {
        purpose: 5,
        type: 1,
        format: 6,
        name: "prePass_Depth"
    },
    {
        purpose: 6,
        type: 2,
        format: 5,
        name: "prePass_Normal"
    },
    {
        purpose: 7,
        type: 0,
        format: 5,
        name: "prePass_Albedo"
    },
    {
        purpose: 8,
        type: 0,
        format: 5,
        name: "prePass_WorldNormal"
    },
    {
        purpose: 9,
        type: 2,
        format: 5,
        name: "prePass_LocalPosition"
    },
    {
        purpose: 10,
        type: 1,
        format: 6,
        name: "prePass_ScreenDepth"
    },
    {
        purpose: 11,
        type: 2,
        format: 5,
        name: "prePass_VelocityLinear"
    }
];



var $kVtWi = parcelRequire("kVtWi");
Object.defineProperty((0, $gmbCk.Scene).prototype, "prePassRenderer", {
    get: function() {
        return this._prePassRenderer;
    },
    set: function(value) {
        if (value && value.isSupported) this._prePassRenderer = value;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.enablePrePassRenderer = function() {
    if (this._prePassRenderer) return this._prePassRenderer;
    this._prePassRenderer = new (0, $b97fe3ee0f5fb378$export$b211103d23883ea6)(this);
    if (!this._prePassRenderer.isSupported) {
        this._prePassRenderer = null;
        (0, $kVtWi.Logger).Error("PrePassRenderer needs WebGL 2 support.\nMaybe you tried to use the following features that need the PrePassRenderer :\n + Subsurface Scattering");
    }
    return this._prePassRenderer;
};
(0, $gmbCk.Scene).prototype.disablePrePassRenderer = function() {
    if (!this._prePassRenderer) return;
    this._prePassRenderer.dispose();
    this._prePassRenderer = null;
};
class $2fe103ad296d9f2a$export$41856413c14c1264 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_PREPASSRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERADRAW_PREPASS, this, this._beforeCameraDraw);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_PREPASS, this, this._afterCameraDraw);
        this.scene._beforeRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERTARGETDRAW_PREPASS, this, this._beforeRenderTargetDraw);
        this.scene._afterRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_PREPASS, this, this._afterRenderTargetDraw);
        this.scene._beforeClearStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECLEAR_PREPASS, this, this._beforeClearStage);
        this.scene._beforeRenderTargetClearStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERTARGETCLEAR_PREPASS, this, this._beforeRenderTargetClearStage);
        this.scene._beforeRenderingMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERINGMESH_PREPASS, this, this._beforeRenderingMeshStage);
        this.scene._afterRenderingMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERINGMESH_PREPASS, this, this._afterRenderingMeshStage);
    }
    _beforeRenderTargetDraw(renderTarget, faceIndex, layer) {
        if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
            this.scene.prePassRenderer._setRenderTarget(renderTarget._prePassRenderTarget);
            this.scene.prePassRenderer._beforeDraw(undefined, faceIndex, layer);
        }
    }
    _afterRenderTargetDraw(renderTarget, faceIndex, layer) {
        if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) this.scene.prePassRenderer._afterDraw(faceIndex, layer);
    }
    _beforeRenderTargetClearStage(renderTarget) {
        if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
            if (!renderTarget._prePassRenderTarget) renderTarget._prePassRenderTarget = this.scene.prePassRenderer._createRenderTarget(renderTarget.name + "_prePassRTT", renderTarget);
            this.scene.prePassRenderer._setRenderTarget(renderTarget._prePassRenderTarget);
            this.scene.prePassRenderer._clear();
        }
    }
    _beforeCameraDraw(camera) {
        if (this.scene.prePassRenderer) {
            this.scene.prePassRenderer._setRenderTarget(null);
            this.scene.prePassRenderer._beforeDraw(camera);
        }
    }
    _afterCameraDraw() {
        if (this.scene.prePassRenderer) this.scene.prePassRenderer._afterDraw();
    }
    _beforeClearStage() {
        if (this.scene.prePassRenderer) {
            this.scene.prePassRenderer._setRenderTarget(null);
            this.scene.prePassRenderer._clear();
        }
    }
    _beforeRenderingMeshStage(mesh, subMesh, batch, effect) {
        if (!effect) return;
        // Render to MRT
        const scene = mesh.getScene();
        if (scene.prePassRenderer) scene.prePassRenderer.bindAttachmentsForEffect(effect, subMesh);
    }
    _afterRenderingMeshStage(mesh) {
        const scene = mesh.getScene();
        if (scene.prePassRenderer) scene.prePassRenderer.restoreAttachments();
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        this.scene.disablePrePassRenderer();
    }
}
(0, $b97fe3ee0f5fb378$export$b211103d23883ea6)._SceneComponentInitialization = (scene)=>{
    // Register the G Buffer component to the scene.
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_PREPASSRENDERER);
    if (!component) {
        component = new $2fe103ad296d9f2a$export$41856413c14c1264(scene);
        scene._addComponent(component);
    }
};



var $e0Suo = parcelRequire("e0Suo");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $cFdBb = parcelRequire("cFdBb");

/**
 * Contains all parameters needed for the prepass to perform
 * motion blur
 */ class $e5218d4adbfdf478$export$4fb596d0fee3d97d {
    constructor(){
        /**
         * Is motion blur enabled
         */ this.enabled = false;
        /**
         * Name of the configuration
         */ this.name = "motionBlur";
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            2
        ];
    }
}




var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

Object.defineProperty((0, $gmbCk.Scene).prototype, "geometryBufferRenderer", {
    get: function() {
        return this._geometryBufferRenderer;
    },
    set: function(value) {
        if (value && value.isSupported) this._geometryBufferRenderer = value;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.enableGeometryBufferRenderer = function(ratio = 1, depthFormat = 15, textureTypesAndFormats) {
    if (this._geometryBufferRenderer) return this._geometryBufferRenderer;
    this._geometryBufferRenderer = new (0, $c586800380a87410$export$8a4e79b98d630eed)(this, ratio, depthFormat, textureTypesAndFormats);
    if (!this._geometryBufferRenderer.isSupported) this._geometryBufferRenderer = null;
    return this._geometryBufferRenderer;
};
(0, $gmbCk.Scene).prototype.disableGeometryBufferRenderer = function() {
    if (!this._geometryBufferRenderer) return;
    this._geometryBufferRenderer.dispose();
    this._geometryBufferRenderer = null;
};
class $95ff1c88dc49c388$export$7d9c20398a2df1eb {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_GEOMETRYBUFFERRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._gatherRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER, this, this._gatherRenderTargets);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
    // Nothing to do for this component
    }
    _gatherRenderTargets(renderTargets) {
        if (this.scene._geometryBufferRenderer) renderTargets.push(this.scene._geometryBufferRenderer.getGBuffer());
    }
}
(0, $c586800380a87410$export$8a4e79b98d630eed)._SceneComponentInitialization = (scene)=>{
    // Register the G Buffer component to the scene.
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_GEOMETRYBUFFERRENDERER);
    if (!component) {
        component = new $95ff1c88dc49c388$export$7d9c20398a2df1eb(scene);
        scene._addComponent(component);
    }
};



var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");


class $087ccb6c95d43552$export$512056e66e9deaee extends (0, $cFdBb.PostProcess) {
    /**
     * Gets the number of iterations are used for motion blur quality. Default value is equal to 32
     */ get motionBlurSamples() {
        return this._motionBlurSamples;
    }
    /**
     * Sets the number of iterations to be used for motion blur quality
     */ set motionBlurSamples(samples) {
        this._motionBlurSamples = samples;
        this._updateEffect();
    }
    /**
     * Gets whether or not the motion blur post-process is in object based mode.
     */ get isObjectBased() {
        return this._isObjectBased;
    }
    /**
     * Sets whether or not the motion blur post-process is in object based mode.
     */ set isObjectBased(value) {
        if (this._isObjectBased === value) return;
        this._isObjectBased = value;
        this._applyMode();
    }
    get _geometryBufferRenderer() {
        if (!this._forceGeometryBuffer) return null;
        return this._scene.geometryBufferRenderer;
    }
    get _prePassRenderer() {
        if (this._forceGeometryBuffer) return null;
        return this._scene.prePassRenderer;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "MotionBlurPostProcess" string
     */ getClassName() {
        return "MotionBlurPostProcess";
    }
    /**
     * Creates a new instance MotionBlurPostProcess
     * @param name The name of the effect.
     * @param scene The scene containing the objects to blur according to their velocity.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: true)
     * @param forceGeometryBuffer If this post process should use geometry buffer instead of prepass (default: false)
     */ constructor(name, scene, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false, forceGeometryBuffer = false){
        super(name, "motionBlur", [
            "motionStrength",
            "motionScale",
            "screenSize",
            "inverseViewProjection",
            "prevViewProjection",
            "projection"
        ], [
            "velocitySampler",
            "depthSampler"
        ], options, camera, samplingMode, engine, reusable, "#define GEOMETRY_SUPPORTED\n#define SAMPLES 64.0\n#define OBJECT_BASED", textureType, undefined, null, blockCompilation);
        /**
         * Defines how much the image is blurred by the movement. Default value is equal to 1
         */ this.motionStrength = 1;
        this._motionBlurSamples = 32;
        this._isObjectBased = true;
        this._forceGeometryBuffer = false;
        this._invViewProjection = null;
        this._previousViewProjection = null;
        this._forceGeometryBuffer = forceGeometryBuffer;
        // Set up assets
        if (this._forceGeometryBuffer) {
            scene.enableGeometryBufferRenderer();
            if (this._geometryBufferRenderer) this._geometryBufferRenderer.enableVelocity = this._isObjectBased;
        } else {
            scene.enablePrePassRenderer();
            if (this._prePassRenderer) {
                this._prePassRenderer.markAsDirty();
                this._prePassEffectConfiguration = new (0, $e5218d4adbfdf478$export$4fb596d0fee3d97d)();
            }
        }
        this._applyMode();
    }
    _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
            this._webGPUReady = true;
            list.push(Promise.all([
                (parcelRequire("avKjR"))
            ]));
        } else list.push(Promise.all([
            (parcelRequire("dhzOq"))
        ]));
        super._gatherImports(useWebGPU, list);
    }
    /**
     * Excludes the given skinned mesh from computing bones velocities.
     * Computing bones velocities can have a cost and that cost. The cost can be saved by calling this function and by passing the skinned mesh reference to ignore.
     * @param skinnedMesh The mesh containing the skeleton to ignore when computing the velocity map.
     */ excludeSkinnedMesh(skinnedMesh) {
        if (skinnedMesh.skeleton) {
            let list;
            if (this._geometryBufferRenderer) list = this._geometryBufferRenderer.excludedSkinnedMeshesFromVelocity;
            else if (this._prePassRenderer) list = this._prePassRenderer.excludedSkinnedMesh;
            else return;
            list.push(skinnedMesh);
        }
    }
    /**
     * Removes the given skinned mesh from the excluded meshes to integrate bones velocities while rendering the velocity map.
     * @param skinnedMesh The mesh containing the skeleton that has been ignored previously.
     * @see excludeSkinnedMesh to exclude a skinned mesh from bones velocity computation.
     */ removeExcludedSkinnedMesh(skinnedMesh) {
        if (skinnedMesh.skeleton) {
            let list;
            if (this._geometryBufferRenderer) list = this._geometryBufferRenderer.excludedSkinnedMeshesFromVelocity;
            else if (this._prePassRenderer) list = this._prePassRenderer.excludedSkinnedMesh;
            else return;
            const index = list.indexOf(skinnedMesh);
            if (index !== -1) list.splice(index, 1);
        }
    }
    /**
     * Disposes the post process.
     * @param camera The camera to dispose the post process on.
     */ dispose(camera) {
        if (this._geometryBufferRenderer) {
            // Clear previous transformation matrices dictionary used to compute objects velocities
            this._geometryBufferRenderer._previousTransformationMatrices = {};
            this._geometryBufferRenderer._previousBonesTransformationMatrices = {};
            this._geometryBufferRenderer.excludedSkinnedMeshesFromVelocity = [];
        }
        super.dispose(camera);
    }
    /**
     * Called on the mode changed (object based or screen based).
     * @returns void
     */ _applyMode() {
        if (!this._geometryBufferRenderer && !this._prePassRenderer) {
            // We can't get a velocity or depth texture. So, work as a passthrough.
            (0, $kVtWi.Logger).Warn("Multiple Render Target support needed to compute object based motion blur");
            return this.updateEffect();
        }
        if (this._geometryBufferRenderer) this._geometryBufferRenderer.enableVelocity = this._isObjectBased;
        this._updateEffect();
        this._invViewProjection = null;
        this._previousViewProjection = null;
        if (this.isObjectBased) {
            if (this._prePassRenderer && this._prePassEffectConfiguration) this._prePassEffectConfiguration.texturesRequired[0] = 2;
            this.onApply = (effect)=>this._onApplyObjectBased(effect);
        } else {
            this._invViewProjection = (0, $ha1VO.Matrix).Identity();
            this._previousViewProjection = this._scene.getTransformMatrix().clone();
            if (this._prePassRenderer && this._prePassEffectConfiguration) this._prePassEffectConfiguration.texturesRequired[0] = 5;
            this.onApply = (effect)=>this._onApplyScreenBased(effect);
        }
    }
    /**
     * Called on the effect is applied when the motion blur post-process is in object based mode.
     * @param effect
     */ _onApplyObjectBased(effect) {
        effect.setVector2("screenSize", new (0, $ha1VO.Vector2)(this.width, this.height));
        effect.setFloat("motionScale", this._scene.getAnimationRatio());
        effect.setFloat("motionStrength", this.motionStrength);
        if (this._geometryBufferRenderer) {
            const velocityIndex = this._geometryBufferRenderer.getTextureIndex((0, $c586800380a87410$export$8a4e79b98d630eed).VELOCITY_TEXTURE_TYPE);
            effect.setTexture("velocitySampler", this._geometryBufferRenderer.getGBuffer().textures[velocityIndex]);
        } else if (this._prePassRenderer) {
            const velocityIndex = this._prePassRenderer.getIndex(2);
            effect.setTexture("velocitySampler", this._prePassRenderer.getRenderTarget().textures[velocityIndex]);
        }
    }
    /**
     * Called on the effect is applied when the motion blur post-process is in screen based mode.
     * @param effect
     */ _onApplyScreenBased(effect) {
        const viewProjection = (0, $ha1VO.TmpVectors).Matrix[0];
        viewProjection.copyFrom(this._scene.getTransformMatrix());
        viewProjection.invertToRef(this._invViewProjection);
        effect.setMatrix("inverseViewProjection", this._invViewProjection);
        effect.setMatrix("prevViewProjection", this._previousViewProjection);
        this._previousViewProjection.copyFrom(viewProjection);
        effect.setMatrix("projection", this._scene.getProjectionMatrix());
        effect.setVector2("screenSize", new (0, $ha1VO.Vector2)(this.width, this.height));
        effect.setFloat("motionScale", this._scene.getAnimationRatio());
        effect.setFloat("motionStrength", this.motionStrength);
        if (this._geometryBufferRenderer) {
            const depthIndex = this._geometryBufferRenderer.getTextureIndex((0, $c586800380a87410$export$8a4e79b98d630eed).DEPTH_TEXTURE_TYPE);
            effect.setTexture("depthSampler", this._geometryBufferRenderer.getGBuffer().textures[depthIndex]);
        } else if (this._prePassRenderer) {
            const depthIndex = this._prePassRenderer.getIndex(5);
            effect.setTexture("depthSampler", this._prePassRenderer.getRenderTarget().textures[depthIndex]);
        }
    }
    /**
     * Called on the effect must be updated (changed mode, samples count, etc.).
     */ _updateEffect() {
        if (this._geometryBufferRenderer || this._prePassRenderer) {
            const defines = [
                "#define GEOMETRY_SUPPORTED",
                "#define SAMPLES " + this._motionBlurSamples.toFixed(1),
                this._isObjectBased ? "#define OBJECT_BASED" : "#define SCREEN_BASED"
            ];
            this.updateEffect(defines.join("\n"));
        }
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $087ccb6c95d43552$export$512056e66e9deaee(parsedPostProcess.name, scene, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, false);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $087ccb6c95d43552$export$512056e66e9deaee.prototype, "motionStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $087ccb6c95d43552$export$512056e66e9deaee.prototype, "motionBlurSamples", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $087ccb6c95d43552$export$512056e66e9deaee.prototype, "isObjectBased", null);
(0, $8DoUR.RegisterClass)("BABYLON.MotionBlurPostProcess", $087ccb6c95d43552$export$512056e66e9deaee);


/* eslint-disable @typescript-eslint/naming-convention */ /** Defines the cross module used constants to avoid circular dependencies */ class $bd523120f282dc29$export$a002182e51710d39 {
}
/** Sampler suffix when associated with a texture name */ $bd523120f282dc29$export$a002182e51710d39.AUTOSAMPLERSUFFIX = "Sampler";
/** Flag used to disable diagnostics for WebGPU */ $bd523120f282dc29$export$a002182e51710d39.DISABLEUA = "#define DISABLE_UNIFORMITY_ANALYSIS";
/** Defines that alpha blending is disabled */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_DISABLE = 0;
/** Defines that alpha blending is SRC ALPHA * SRC + DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ADD = 1;
/** Defines that alpha blending is SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_COMBINE = 2;
/** Defines that alpha blending is DEST - SRC * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_SUBTRACT = 3;
/** Defines that alpha blending is SRC * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_MULTIPLY = 4;
/** Defines that alpha blending is SRC ALPHA * SRC + (1 - SRC) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_MAXIMIZED = 5;
/** Defines that alpha blending is SRC + DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ONEONE = 6;
/** Defines that alpha blending is SRC + (1 - SRC ALPHA) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_PREMULTIPLIED = 7;
/**
 * Defines that alpha blending is SRC + (1 - SRC ALPHA) * DEST
 * Alpha will be set to (1 - SRC ALPHA) * DEST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
/** Defines that alpha blending is CST * SRC + (1 - CST) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_INTERPOLATE = 9;
/**
 * Defines that alpha blending is SRC + (1 - SRC) * DEST
 * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DEST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_SCREENMODE = 10;
/**
 * Defines that alpha blending is SRC + DST
 * Alpha will be set to SRC ALPHA + DST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ONEONE_ONEONE = 11;
/**
 * Defines that alpha blending is SRC * DST ALPHA + DST
 * Alpha will be set to 0
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ALPHATOCOLOR = 12;
/**
 * Defines that alpha blending is SRC * (1 - DST) + DST * (1 - SRC)
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_REVERSEONEMINUS = 13;
/**
 * Defines that alpha blending is SRC + DST * (1 - SRC ALPHA)
 * Alpha will be set to SRC ALPHA + DST ALPHA * (1 - SRC ALPHA)
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_SRC_DSTONEMINUSSRCALPHA = 14;
/**
 * Defines that alpha blending is SRC + DST
 * Alpha will be set to SRC ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ONEONE_ONEZERO = 15;
/**
 * Defines that alpha blending is SRC * (1 - DST) + DST * (1 - SRC)
 * Alpha will be set to DST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EXCLUSION = 16;
/**
 * Defines that alpha blending is SRC * SRC ALPHA + DST * (1 - SRC ALPHA)
 * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_LAYER_ACCUMULATE = 17;
/** Defines that alpha blending equation a SUM */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_ADD = 0;
/** Defines that alpha blending equation a SUBSTRACTION */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_SUBSTRACT = 1;
/** Defines that alpha blending equation a REVERSE SUBSTRACTION */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_REVERSE_SUBTRACT = 2;
/** Defines that alpha blending equation a MAX operation */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_MAX = 3;
/** Defines that alpha blending equation a MIN operation */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_MIN = 4;
/**
 * Defines that alpha blending equation a DARKEN operation:
 * It takes the min of the src and sums the alpha channels.
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_DARKEN = 5;
/** Defines that the resource is not delayed*/ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_NONE = 0;
/** Defines that the resource was successfully delay loaded */ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_LOADED = 1;
/** Defines that the resource is currently delay loading */ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_LOADING = 2;
/** Defines that the resource is delayed and has not started loading */ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_NOTLOADED = 4;
// Depth or Stencil test Constants.
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass. i.e. Nothing will be drawn */ $bd523120f282dc29$export$a002182e51710d39.NEVER = 0x0200;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */ $bd523120f282dc29$export$a002182e51710d39.ALWAYS = 0x0207;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value */ $bd523120f282dc29$export$a002182e51710d39.LESS = 0x0201;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value */ $bd523120f282dc29$export$a002182e51710d39.EQUAL = 0x0202;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value */ $bd523120f282dc29$export$a002182e51710d39.LEQUAL = 0x0203;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value */ $bd523120f282dc29$export$a002182e51710d39.GREATER = 0x0204;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value */ $bd523120f282dc29$export$a002182e51710d39.GEQUAL = 0x0206;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value */ $bd523120f282dc29$export$a002182e51710d39.NOTEQUAL = 0x0205;
// Stencil Actions Constants.
/** Passed to stencilOperation to specify that stencil value must be kept */ $bd523120f282dc29$export$a002182e51710d39.KEEP = 0x1e00;
/** Passed to stencilOperation to specify that stencil value must be zero */ $bd523120f282dc29$export$a002182e51710d39.ZERO = 0x0000;
/** Passed to stencilOperation to specify that stencil value must be replaced */ $bd523120f282dc29$export$a002182e51710d39.REPLACE = 0x1e01;
/** Passed to stencilOperation to specify that stencil value must be incremented */ $bd523120f282dc29$export$a002182e51710d39.INCR = 0x1e02;
/** Passed to stencilOperation to specify that stencil value must be decremented */ $bd523120f282dc29$export$a002182e51710d39.DECR = 0x1e03;
/** Passed to stencilOperation to specify that stencil value must be inverted */ $bd523120f282dc29$export$a002182e51710d39.INVERT = 0x150a;
/** Passed to stencilOperation to specify that stencil value must be incremented with wrapping */ $bd523120f282dc29$export$a002182e51710d39.INCR_WRAP = 0x8507;
/** Passed to stencilOperation to specify that stencil value must be decremented with wrapping */ $bd523120f282dc29$export$a002182e51710d39.DECR_WRAP = 0x8508;
/** Texture is not repeating outside of 0..1 UVs */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CLAMP_ADDRESSMODE = 0;
/** Texture is repeating outside of 0..1 UVs */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_WRAP_ADDRESSMODE = 1;
/** Texture is repeating and mirrored */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_MIRROR_ADDRESSMODE = 2;
/** Flag to create a storage texture */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CREATIONFLAG_STORAGE = 1;
/** ALPHA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_ALPHA = 0;
/** LUMINANCE */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_LUMINANCE = 1;
/** LUMINANCE_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
/** RGB */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGB = 4;
/** RGBA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGBA = 5;
/** RED */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RED = 6;
/** RED (2nd reference) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_R = 6;
/** RED unsigned short normed to [0, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_R16_UNORM = 0x822a;
/** RG unsigned short normed to [0, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RG16_UNORM = 0x822c;
/** RGB unsigned short normed to [0, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGB16_UNORM = 0x8054;
/** RGBA unsigned short normed to [0, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGBA16_UNORM = 0x805b;
/** RED signed short normed to [-1, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_R16_SNORM = 0x8f98;
/** RG signed short normed to [-1, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RG16_SNORM = 0x8f99;
/** RGB signed short normed to [-1, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGB16_SNORM = 0x8f9a;
/** RGBA signed short normed to [-1, 1] **/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGBA16_SNORM = 0x8f9b;
/** RG */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RG = 7;
/** RED_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RED_INTEGER = 8;
/** RED_INTEGER (2nd reference) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_R_INTEGER = 8;
/** RG_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RG_INTEGER = 9;
/** RGB_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGB_INTEGER = 10;
/** RGBA_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGBA_INTEGER = 11;
/** BGRA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_BGRA = 12;
/** Depth 24 bits + Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH24_STENCIL8 = 13;
/** Depth 32 bits float */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH32_FLOAT = 14;
/** Depth 16 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH16 = 15;
/** Depth 24 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH24 = 16;
/** Depth 24 bits unorm + Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH24UNORM_STENCIL8 = 17;
/** Depth 32 bits float + Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH32FLOAT_STENCIL8 = 18;
/** Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_STENCIL8 = 19;
/** UNDEFINED */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_UNDEFINED = 0xffffffff;
/** Compressed BC7 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_BPTC_UNORM = 36492;
/** Compressed BC7 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_BPTC_UNORM = 36493;
/** Compressed BC6 unsigned float */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT = 36495;
/** Compressed BC6 signed float */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_BPTC_SIGNED_FLOAT = 36494;
/** Compressed BC3 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT5 = 33779;
/** Compressed BC3 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919;
/** Compressed BC2 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT3 = 33778;
/** Compressed BC2 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918;
/** Compressed BC1 (RGBA) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT1 = 33777;
/** Compressed BC1 (RGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_S3TC_DXT1 = 33776;
/** Compressed BC1 (SRGB+A) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917;
/** Compressed BC1 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916;
/** Compressed ASTC 4x4 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_ASTC_4x4 = 37808;
/** Compressed ASTC 4x4 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = 37840;
/** Compressed ETC1 (RGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_ETC1_WEBGL = 36196;
/** Compressed ETC2 (RGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB8_ETC2 = 37492;
/** Compressed ETC2 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_ETC2 = 37493;
/** Compressed ETC2 (RGB+A1) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494;
/** Compressed ETC2 (SRGB+A1)*/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495;
/** Compressed ETC2 (RGB+A) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA8_ETC2_EAC = 37496;
/** Compressed ETC2 (SRGB+1) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497;
/** UNSIGNED_BYTE */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_BYTE = 0;
/** @deprecated use more explicit TEXTURETYPE_UNSIGNED_BYTE instead. Use TEXTURETYPE_UNSIGNED_INTEGER for 32bits values.*/ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT = 0;
/** FLOAT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_FLOAT = 1;
/** HALF_FLOAT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_HALF_FLOAT = 2;
/** BYTE */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_BYTE = 3;
/** SHORT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_SHORT = 4;
/** UNSIGNED_SHORT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT = 5;
/** INT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_INT = 6;
/** UNSIGNED_INT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INTEGER = 7;
/** UNSIGNED_SHORT_4_4_4_4 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
/** UNSIGNED_SHORT_5_5_5_1 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
/** UNSIGNED_SHORT_5_6_5 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
/** UNSIGNED_INT_2_10_10_10_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
/** UNSIGNED_INT_24_8 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
/** UNSIGNED_INT_10F_11F_11F_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
/** UNSIGNED_INT_5_9_9_9_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
/** FLOAT_32_UNSIGNED_INT_24_8_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
/** UNDEFINED */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNDEFINED = 16;
/** 2D Texture target*/ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_2D = 3553;
/** 2D Array Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_2D_ARRAY = 35866;
/** Cube Map Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CUBE_MAP = 34067;
/** Cube Map Array Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CUBE_MAP_ARRAY = 0xdeadbeef;
/** 3D Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_3D = 32879;
/** nearest is mag = nearest and min = nearest and no mip */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_SAMPLINGMODE = 1;
/** mag = nearest and min = nearest and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_NEAREST = 1;
/** Bilinear is mag = linear and min = linear and no mip */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
/** mag = linear and min = linear and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_LINEAR = 2;
/** Trilinear is mag = linear and min = linear and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
/** Trilinear is mag = linear and min = linear and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
/** mag = nearest and min = nearest and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
/** mag = nearest and min = linear and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
/** mag = nearest and min = linear and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
/** mag = nearest and min = linear and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_LINEAR = 7;
/** nearest is mag = nearest and min = nearest and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
/** mag = linear and min = nearest and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
/** mag = linear and min = nearest and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
/** mag = linear and min = nearest and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_NEAREST = 12;
/** Explicit coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_EXPLICIT_MODE = 0;
/** Spherical coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_SPHERICAL_MODE = 1;
/** Planar coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_PLANAR_MODE = 2;
/** Cubic coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CUBIC_MODE = 3;
/** Projection coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_PROJECTION_MODE = 4;
/** Skybox coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_SKYBOX_MODE = 5;
/** Inverse Cubic coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_INVCUBIC_MODE = 6;
/** Equirectangular coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_EQUIRECTANGULAR_MODE = 7;
/** Equirectangular Fixed coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
/** Equirectangular Fixed Mirrored coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
/** Offline (baking) quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_OFFLINE = 4096;
/** High quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_HIGH = 64;
/** Medium quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_MEDIUM = 16;
/** Low quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_LOW = 8;
// Texture rescaling mode
/** Defines that texture rescaling will use a floor to find the closer power of 2 size */ $bd523120f282dc29$export$a002182e51710d39.SCALEMODE_FLOOR = 1;
/** Defines that texture rescaling will look for the nearest power of 2 size */ $bd523120f282dc29$export$a002182e51710d39.SCALEMODE_NEAREST = 2;
/** Defines that texture rescaling will use a ceil to find the closer power of 2 size */ $bd523120f282dc29$export$a002182e51710d39.SCALEMODE_CEILING = 3;
/**
 * The dirty texture flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TextureDirtyFlag = 1;
/**
 * The dirty light flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LightDirtyFlag = 2;
/**
 * The dirty fresnel flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_FresnelDirtyFlag = 4;
/**
 * The dirty attribute flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_AttributesDirtyFlag = 8;
/**
 * The dirty misc flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_MiscDirtyFlag = 16;
/**
 * The dirty prepass flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_PrePassDirtyFlag = 32;
/**
 * The all dirty flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_AllDirtyFlag = 63;
/**
 * Returns the triangle fill mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TriangleFillMode = 0;
/**
 * Returns the wireframe mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_WireFrameFillMode = 1;
/**
 * Returns the point fill mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_PointFillMode = 2;
/**
 * Returns the point list draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_PointListDrawMode = 3;
/**
 * Returns the line list draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LineListDrawMode = 4;
/**
 * Returns the line loop draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LineLoopDrawMode = 5;
/**
 * Returns the line strip draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LineStripDrawMode = 6;
/**
 * Returns the triangle strip draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TriangleStripDrawMode = 7;
/**
 * Returns the triangle fan draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TriangleFanDrawMode = 8;
/**
 * Stores the clock-wise side orientation
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_ClockWiseSideOrientation = 0;
/**
 * Stores the counter clock-wise side orientation
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_CounterClockWiseSideOrientation = 1;
/**
 * Nothing
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_NothingTrigger = 0;
/**
 * On pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickTrigger = 1;
/**
 * On left pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnLeftPickTrigger = 2;
/**
 * On right pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnRightPickTrigger = 3;
/**
 * On center pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnCenterPickTrigger = 4;
/**
 * On pick down
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickDownTrigger = 5;
/**
 * On double pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnDoublePickTrigger = 6;
/**
 * On pick up
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickUpTrigger = 7;
/**
 * On pick out.
 * This trigger will only be raised if you also declared a OnPickDown
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickOutTrigger = 16;
/**
 * On long press
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnLongPressTrigger = 8;
/**
 * On pointer over
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPointerOverTrigger = 9;
/**
 * On pointer out
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPointerOutTrigger = 10;
/**
 * On every frame
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnEveryFrameTrigger = 11;
/**
 * On intersection enter
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnIntersectionEnterTrigger = 12;
/**
 * On intersection exit
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnIntersectionExitTrigger = 13;
/**
 * On key down
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnKeyDownTrigger = 14;
/**
 * On key up
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnKeyUpTrigger = 15;
/**
 * Billboard mode will only apply to Y axis
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_Y = 2;
/**
 * Billboard mode will apply to all axes
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_ALL = 7;
/**
 * Special billboard mode where the particle will be biilboard to the camera but rotated to align with direction
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_STRETCHED = 8;
/**
 * Special billboard mode where the particle will be billboard to the camera but only around the axis of the direction of particle emission
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_STRETCHED_LOCAL = 9;
/** Default culling strategy : this is an exclusion test and it's the more accurate.
 *  Test order :
 *  Is the bounding sphere outside the frustum ?
 *  If not, are the bounding box vertices outside the frustum ?
 *  It not, then the cullable object is in the frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_STANDARD = 0;
/** Culling strategy : Bounding Sphere Only.
 *  This is an exclusion test. It's faster than the standard strategy because the bounding box is not tested.
 *  It's also less accurate than the standard because some not visible objects can still be selected.
 *  Test : is the bounding sphere outside the frustum ?
 *  If not, then the cullable object is in the frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
/** Culling strategy : Optimistic Inclusion.
 *  This in an inclusion test first, then the standard exclusion test.
 *  This can be faster when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the standard test when the tested object center is not the frustum but one of its bounding box vertex is still inside.
 *  Anyway, it's as accurate as the standard strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the default culling strategy.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
/** Culling strategy : Optimistic Inclusion then Bounding Sphere Only.
 *  This in an inclusion test first, then the bounding sphere only exclusion test.
 *  This can be the fastest test when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the BoundingSphereOnly strategy when the tested object center is not in the frustum but its bounding sphere still intersects it.
 *  It's less accurate than the standard strategy and as accurate as the BoundingSphereOnly strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the Bounding Sphere Only strategy. No Bounding Box is tested here.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
/**
 * No logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_NO_LOGGING = 0;
/**
 * Minimal logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_MINIMAL_LOGGING = 1;
/**
 * Summary logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_SUMMARY_LOGGING = 2;
/**
 * Detailed logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_DETAILED_LOGGING = 3;
/**
 * Constant used to retrieve the irradiance texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_IRRADIANCE_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_IRRADIANCE_TEXTURE_TYPE = 0;
/**
 * Constant used to retrieve the position texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_POSITION_TEXTURE_INDEX)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_POSITION_TEXTURE_TYPE = 1;
/**
 * Constant used to retrieve the velocity texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_VELOCITY_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_VELOCITY_TEXTURE_TYPE = 2;
/**
 * Constant used to retrieve the reflectivity texture index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_REFLECTIVITY_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_REFLECTIVITY_TEXTURE_TYPE = 3;
/**
 * Constant used to retrieve the lit color texture index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_COLOR_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_COLOR_TEXTURE_TYPE = 4;
/**
 * Constant used to retrieve depth index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_DEPTH_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_DEPTH_TEXTURE_TYPE = 5;
/**
 * Constant used to retrieve normal index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_NORMAL_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_NORMAL_TEXTURE_TYPE = 6;
/**
 * Constant used to retrieve (sqrt) albedo index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_ALBEDO_SQRT_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_ALBEDO_SQRT_TEXTURE_TYPE = 7;
/**
 * Constant used to retrieve world normal index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_WORLD_NORMAL_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_WORLD_NORMAL_TEXTURE_TYPE = 8;
/**
 * Constant used to retrieve the local position texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_LOCAL_POSITION_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_LOCAL_POSITION_TEXTURE_TYPE = 9;
/**
 * Constant used to retrieve screen-space (non-linear) depth index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_SCREENSPACE_DEPTH_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_SCREENSPACE_DEPTH_TEXTURE_TYPE = 10;
/**
 * Constant used to retrieve the velocity texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_VELOCITY_LINEAR_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_VELOCITY_LINEAR_TEXTURE_TYPE = 11;
/**
 * Constant used to retrieve albedo index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_ALBEDO_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_ALBEDO_TEXTURE_TYPE = 12;
/** Flag to create a readable buffer (the buffer can be the source of a copy) */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_READ = 1;
/** Flag to create a writable buffer (the buffer can be the destination of a copy) */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_WRITE = 2;
/** Flag to create a readable and writable buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_READWRITE = 3;
/** Flag to create a buffer suitable to be used as a uniform buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_UNIFORM = 4;
/** Flag to create a buffer suitable to be used as a vertex buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_VERTEX = 8;
/** Flag to create a buffer suitable to be used as an index buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_INDEX = 16;
/** Flag to create a buffer suitable to be used as a storage buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_STORAGE = 32;
/** Flag to create a buffer suitable to be used for indirect calls, such as `dispatchIndirect` */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_INDIRECT = 64;
/**
 * Prefixes used by the engine for sub mesh draw wrappers
 */ /** @internal */ $bd523120f282dc29$export$a002182e51710d39.RENDERPASS_MAIN = 0;
/**
 * Constant used as key code for Alt key
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_ALT_KEY = 18;
/**
 * Constant used as key code for Ctrl key
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_CTRL_KEY = 17;
/**
 * Constant used as key code for Meta key (Left Win, Left Cmd)
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_META_KEY1 = 91;
/**
 * Constant used as key code for Meta key (Right Win)
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_META_KEY2 = 92;
/**
 * Constant used as key code for Meta key (Right Win, Right Cmd)
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_META_KEY3 = 93;
/**
 * Constant used as key code for Shift key
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_SHIFT_KEY = 16;
/** Standard snapshot rendering. In this mode, some form of dynamic behavior is possible (for eg, uniform buffers are still updated) */ $bd523120f282dc29$export$a002182e51710d39.SNAPSHOTRENDERING_STANDARD = 0;
/** Fast snapshot rendering. In this mode, everything is static and only some limited form of dynamic behaviour is possible */ $bd523120f282dc29$export$a002182e51710d39.SNAPSHOTRENDERING_FAST = 1;
/**
 * This is the default projection mode used by the cameras.
 * It helps recreating a feeling of perspective and better appreciate depth.
 * This is the best way to simulate real life cameras.
 */ $bd523120f282dc29$export$a002182e51710d39.PERSPECTIVE_CAMERA = 0;
/**
 * This helps creating camera with an orthographic mode.
 * Orthographic is commonly used in engineering as a means to produce object specifications that communicate dimensions unambiguously, each line of 1 unit length (cm, meter..whatever) will appear to have the same length everywhere on the drawing. This allows the drafter to dimension only a subset of lines and let the reader know that other lines of that length on the drawing are also that length in reality. Every parallel line in the drawing is also parallel in the object.
 */ $bd523120f282dc29$export$a002182e51710d39.ORTHOGRAPHIC_CAMERA = 1;
/**
 * This is the default FOV mode for perspective cameras.
 * This setting aligns the upper and lower bounds of the viewport to the upper and lower bounds of the camera frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.FOVMODE_VERTICAL_FIXED = 0;
/**
 * This setting aligns the left and right bounds of the viewport to the left and right bounds of the camera frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.FOVMODE_HORIZONTAL_FIXED = 1;
/**
 * This specifies there is no need for a camera rig.
 * Basically only one eye is rendered corresponding to the camera.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_NONE = 0;
/**
 * Simulates a camera Rig with one blue eye and one red eye.
 * This can be use with 3d blue and red glasses.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
/**
 * Defines that both eyes of the camera will be rendered side by side with a parallel target.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
/**
 * Defines that both eyes of the camera will be rendered side by side with a none parallel target.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
/**
 * Defines that both eyes of the camera will be rendered over under each other.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
/**
 * Defines that both eyes of the camera will be rendered on successive lines interlaced for passive 3d monitors.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
/**
 * Defines that both eyes of the camera should be renderered in a VR mode (carbox).
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_VR = 20;
/**
 * Custom rig mode allowing rig cameras to be populated manually with any number of cameras
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_CUSTOM = 22;
/**
 * Maximum number of uv sets supported
 */ $bd523120f282dc29$export$a002182e51710d39.MAX_SUPPORTED_UV_SETS = 6;
/**
 * GL constants
 */ /** Alpha blend equation: ADD */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_ADD = 0x8006;
/** Alpha equation: MIN */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_MIN = 0x8007;
/** Alpha equation: MAX */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_MAX = 0x8008;
/** Alpha equation: SUBTRACT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_SUBTRACT = 0x800a;
/** Alpha equation: REVERSE_SUBTRACT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_REVERSE_SUBTRACT = 0x800b;
/** Alpha blend function: SRC */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC = 0x0300;
/** Alpha blend function: ONE_MINUS_SRC */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_SRC_COLOR = 0x0301;
/** Alpha blend function: SRC_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC_ALPHA = 0x0302;
/** Alpha blend function: ONE_MINUS_SRC_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_SRC_ALPHA = 0x0303;
/** Alpha blend function: DST_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_DST_ALPHA = 0x0304;
/** Alpha blend function: ONE_MINUS_DST_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_DST_ALPHA = 0x0305;
/** Alpha blend function: ONE_MINUS_DST */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_DST_COLOR = 0x0306;
/** Alpha blend function: ONE_MINUS_DST */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_DST_COLOR = 0x0307;
/** Alpha blend function: SRC_ALPHA_SATURATED */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC_ALPHA_SATURATED = 0x0308;
/** Alpha blend function: CONSTANT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_CONSTANT_COLOR = 0x8001;
/** Alpha blend function: ONE_MINUS_CONSTANT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_CONSTANT_COLOR = 0x8002;
/** Alpha blend function: CONSTANT_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_CONSTANT_ALPHA = 0x8003;
/** Alpha blend function: ONE_MINUS_CONSTANT_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_CONSTANT_ALPHA = 0x8004;
/** Alpha blend function: SRC1 */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC1_COLOR = 0x88f9;
/** Alpha blend function: SRC1 */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_SRC1_COLOR = 0x88fa;
/** Alpha blend function: SRC1 */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC1_ALPHA = 0x8589;
/** Alpha blend function: SRC1 */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_SRC1_ALPHA = 0x88fb;
/** URL to the snippet server. Points to the public snippet server by default */ $bd523120f282dc29$export$a002182e51710d39.SnippetUrl = "https://snippet.babylonjs.com";
/** The fog is deactivated */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_NONE = 0;
/** The fog density is following an exponential function */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_EXP = 1;
/** The fog density is following an exponential function faster than FOGMODE_EXP */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_EXP2 = 2;
/** The fog density is following a linear function. */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_LINEAR = 3;
/**
 * The byte type.
 */ $bd523120f282dc29$export$a002182e51710d39.BYTE = 5120;
/**
 * The unsigned byte type.
 */ $bd523120f282dc29$export$a002182e51710d39.UNSIGNED_BYTE = 5121;
/**
 * The short type.
 */ $bd523120f282dc29$export$a002182e51710d39.SHORT = 5122;
/**
 * The unsigned short type.
 */ $bd523120f282dc29$export$a002182e51710d39.UNSIGNED_SHORT = 5123;
/**
 * The integer type.
 */ $bd523120f282dc29$export$a002182e51710d39.INT = 5124;
/**
 * The unsigned integer type.
 */ $bd523120f282dc29$export$a002182e51710d39.UNSIGNED_INT = 5125;
/**
 * The float type.
 */ $bd523120f282dc29$export$a002182e51710d39.FLOAT = 5126;
/**
 * Positions
 */ $bd523120f282dc29$export$a002182e51710d39.PositionKind = "position";
/**
 * Normals
 */ $bd523120f282dc29$export$a002182e51710d39.NormalKind = "normal";
/**
 * Tangents
 */ $bd523120f282dc29$export$a002182e51710d39.TangentKind = "tangent";
/**
 * Texture coordinates
 */ $bd523120f282dc29$export$a002182e51710d39.UVKind = "uv";
/**
 * Texture coordinates 2
 */ $bd523120f282dc29$export$a002182e51710d39.UV2Kind = "uv2";
/**
 * Texture coordinates 3
 */ $bd523120f282dc29$export$a002182e51710d39.UV3Kind = "uv3";
/**
 * Texture coordinates 4
 */ $bd523120f282dc29$export$a002182e51710d39.UV4Kind = "uv4";
/**
 * Texture coordinates 5
 */ $bd523120f282dc29$export$a002182e51710d39.UV5Kind = "uv5";
/**
 * Texture coordinates 6
 */ $bd523120f282dc29$export$a002182e51710d39.UV6Kind = "uv6";
/**
 * Colors
 */ $bd523120f282dc29$export$a002182e51710d39.ColorKind = "color";
/**
 * Instance Colors
 */ $bd523120f282dc29$export$a002182e51710d39.ColorInstanceKind = "instanceColor";
/**
 * Matrix indices (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesIndicesKind = "matricesIndices";
/**
 * Matrix weights (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesWeightsKind = "matricesWeights";
/**
 * Additional matrix indices (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesIndicesExtraKind = "matricesIndicesExtra";
/**
 * Additional matrix weights (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesWeightsExtraKind = "matricesWeightsExtra";
/**
 * The default minZ value for the near plane of a frustum light
 */ $bd523120f282dc29$export$a002182e51710d39.ShadowMinZ = 0;
/**
 * The default maxZ value for the far plane of a frustum light
 */ $bd523120f282dc29$export$a002182e51710d39.ShadowMaxZ = 10000;



parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

class $854be06c1a29939d$export$39459471b3952c34 {
    constructor(type, system){
        this.position = (0, $ha1VO.Vector2).Zero();
        this.size = 1;
        this.system = system;
        this.key = type + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        this.addTransformMesh();
    }
    addTransformMesh() {
        this.transformMesh = new (0, $ecfbb5db4d70b862$export$b600d080bad015f)(this.key, this.system.scene);
    }
    _setPosition(pos) {
        this.position = pos;
    }
    _setSize(size) {
        this.size = size;
    }
    setSize(size) {
        this._setSize(size);
        this.setTransformMeshSize(size);
    }
    setTransformMeshSize(size) {
        this.transformMesh.scaling.x = size;
        this.transformMesh.scaling.y = size;
        this.transformMesh.scaling.z = size;
    }
    setPosition(pos) {
        this._setPosition(pos);
        this.transformMesh.position.x = pos.x;
        this.transformMesh.position.z = pos.y;
        this.transformMesh.position.y = 1;
    }
    setRotation(rot) {
        this.transformMesh.rotation.y = rot;
    }
}


var $e991a8ea9bf02b62$exports = {};
var $5aba4f6d9f8304a3$exports = {};
var $e780807e2b795134$exports = {};
var $ec073f38db6e7d54$exports = {};
var $bbb2d98cae25b61a$exports = {};
var $dd14efc87ba1cd5b$exports = {};
var $83df40714bf7006e$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$83df40714bf7006e$exports = $83df40714bf7006e$var$listCacheClear;


var $d22fe27824ff9351$exports = {};
var $87257b05f5d9ad81$exports = {};
var $50557587dab070a0$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$50557587dab070a0$exports = $50557587dab070a0$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($50557587dab070a0$exports(array[length][0], key)) return length;
    }
    return -1;
}
$87257b05f5d9ad81$exports = $87257b05f5d9ad81$var$assocIndexOf;


/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$d22fe27824ff9351$exports = $d22fe27824ff9351$var$listCacheDelete;


var $b2e6263d81cdc1b3$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$b2e6263d81cdc1b3$exports = $b2e6263d81cdc1b3$var$listCacheGet;


var $29e2bc7b7348833e$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $87257b05f5d9ad81$exports(this.__data__, key) > -1;
}
$29e2bc7b7348833e$exports = $29e2bc7b7348833e$var$listCacheHas;


var $ff9311500b60ab72$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $87257b05f5d9ad81$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ff9311500b60ab72$exports = $ff9311500b60ab72$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $83df40714bf7006e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $d22fe27824ff9351$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $b2e6263d81cdc1b3$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $29e2bc7b7348833e$exports;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $ff9311500b60ab72$exports;
$dd14efc87ba1cd5b$exports = $dd14efc87ba1cd5b$var$ListCache;


var $e8ee1d354807980a$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $dd14efc87ba1cd5b$exports;
    this.size = 0;
}
$e8ee1d354807980a$exports = $e8ee1d354807980a$var$stackClear;


var $b2ddb9d63293f3a5$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$b2ddb9d63293f3a5$exports = $b2ddb9d63293f3a5$var$stackDelete;


var $80d0940a423a17dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$80d0940a423a17dc$exports = $80d0940a423a17dc$var$stackGet;


var $010f38d5d914cfa2$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
$010f38d5d914cfa2$exports = $010f38d5d914cfa2$var$stackHas;


var $9280d00f89f25fa9$exports = {};

var $19b02faa57603249$exports = {};
var $5037fd2e597c2a03$exports = {};
var $8360225fb63098b3$exports = {};
var $004783abbde551e4$exports = {};
var $a7f8a2555793d7d3$exports = {};
var $3ba72ebe7e4419b5$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $f9ff2e983beb6b86$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$f9ff2e983beb6b86$exports = $f9ff2e983beb6b86$var$isObject;


/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$f9ff2e983beb6b86$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a7f8a2555793d7d3$exports(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
$004783abbde551e4$exports = $004783abbde551e4$var$isFunction;


var $5e8d211f630cd46d$exports = {};
var $baf78e1246b3b18f$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
$baf78e1246b3b18f$exports = $baf78e1246b3b18f$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($baf78e1246b3b18f$exports && $baf78e1246b3b18f$exports.keys && $baf78e1246b3b18f$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
$5e8d211f630cd46d$exports = $5e8d211f630cd46d$var$isMasked;



var $9c6b3ec69362487e$exports = {};
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$9c6b3ec69362487e$exports = $9c6b3ec69362487e$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$f9ff2e983beb6b86$exports(value) || $5e8d211f630cd46d$exports(value)) return false;
    var pattern = $004783abbde551e4$exports(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($9c6b3ec69362487e$exports(value));
}
$8360225fb63098b3$exports = $8360225fb63098b3$var$baseIsNative;


var $d50b255f8680c47a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d50b255f8680c47a$exports = $d50b255f8680c47a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $d50b255f8680c47a$exports(object, key);
    return $8360225fb63098b3$exports(value) ? value : undefined;
}
$5037fd2e597c2a03$exports = $5037fd2e597c2a03$var$getNative;



var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $5037fd2e597c2a03$exports($23YZo, 'Map');
$19b02faa57603249$exports = $19b02faa57603249$var$Map;


var $4902f64a16640324$exports = {};
var $df2cd4bc93f21548$exports = {};
var $8d50e526a9e9b7fa$exports = {};
var $80f20c637ba11563$exports = {};
var $e95343b7bf5d617b$exports = {};

/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $5037fd2e597c2a03$exports(Object, 'create');
$e95343b7bf5d617b$exports = $e95343b7bf5d617b$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $e95343b7bf5d617b$exports ? $e95343b7bf5d617b$exports(null) : {};
    this.size = 0;
}
$80f20c637ba11563$exports = $80f20c637ba11563$var$hashClear;


var $60a2188452e03a76$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$60a2188452e03a76$exports = $60a2188452e03a76$var$hashDelete;


var $0ade0ffa62051a98$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($e95343b7bf5d617b$exports) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$0ade0ffa62051a98$exports = $0ade0ffa62051a98$var$hashGet;


var $0d7f9677a17b6bef$exports = {};

/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $e95343b7bf5d617b$exports ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
$0d7f9677a17b6bef$exports = $0d7f9677a17b6bef$var$hashHas;


var $d33db65186b62952$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $e95343b7bf5d617b$exports && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
$d33db65186b62952$exports = $d33db65186b62952$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $80f20c637ba11563$exports;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $60a2188452e03a76$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $0ade0ffa62051a98$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $0d7f9677a17b6bef$exports;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $d33db65186b62952$exports;
$8d50e526a9e9b7fa$exports = $8d50e526a9e9b7fa$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $8d50e526a9e9b7fa$exports,
        'map': new ($19b02faa57603249$exports || $dd14efc87ba1cd5b$exports),
        'string': new $8d50e526a9e9b7fa$exports
    };
}
$df2cd4bc93f21548$exports = $df2cd4bc93f21548$var$mapCacheClear;


var $44464964ade29765$exports = {};
var $c0b23e5f03c2595b$exports = {};
var $09c4668903e66c1d$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$09c4668903e66c1d$exports = $09c4668903e66c1d$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $09c4668903e66c1d$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$c0b23e5f03c2595b$exports = $c0b23e5f03c2595b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $c0b23e5f03c2595b$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$44464964ade29765$exports = $44464964ade29765$var$mapCacheDelete;


var $ba80406da5503086$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $c0b23e5f03c2595b$exports(this, key).get(key);
}
$ba80406da5503086$exports = $ba80406da5503086$var$mapCacheGet;


var $d3abe18ea687dfb7$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $c0b23e5f03c2595b$exports(this, key).has(key);
}
$d3abe18ea687dfb7$exports = $d3abe18ea687dfb7$var$mapCacheHas;


var $347643e3dcfcc207$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $c0b23e5f03c2595b$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$347643e3dcfcc207$exports = $347643e3dcfcc207$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $df2cd4bc93f21548$exports;
$4902f64a16640324$var$MapCache.prototype['delete'] = $44464964ade29765$exports;
$4902f64a16640324$var$MapCache.prototype.get = $ba80406da5503086$exports;
$4902f64a16640324$var$MapCache.prototype.has = $d3abe18ea687dfb7$exports;
$4902f64a16640324$var$MapCache.prototype.set = $347643e3dcfcc207$exports;
$4902f64a16640324$exports = $4902f64a16640324$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $dd14efc87ba1cd5b$exports) {
        var pairs = data.__data__;
        if (!$19b02faa57603249$exports || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $4902f64a16640324$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9280d00f89f25fa9$exports = $9280d00f89f25fa9$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $dd14efc87ba1cd5b$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $e8ee1d354807980a$exports;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $b2ddb9d63293f3a5$exports;
$bbb2d98cae25b61a$var$Stack.prototype.get = $80d0940a423a17dc$exports;
$bbb2d98cae25b61a$var$Stack.prototype.has = $010f38d5d914cfa2$exports;
$bbb2d98cae25b61a$var$Stack.prototype.set = $9280d00f89f25fa9$exports;
$bbb2d98cae25b61a$exports = $bbb2d98cae25b61a$var$Stack;


var $769812b29c18141e$exports = {};
var $567f2dd161ebd4f6$exports = {};

var $1081bd3a2e361911$exports = {};
var $a29ccdc0f60e279e$exports = {};

var $dda8f7b6b589544e$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
$dda8f7b6b589544e$exports = $dda8f7b6b589544e$var$setCacheAdd;


var $66732c92c350622c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$66732c92c350622c$exports = $66732c92c350622c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $4902f64a16640324$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $dda8f7b6b589544e$exports;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $66732c92c350622c$exports;
$a29ccdc0f60e279e$exports = $a29ccdc0f60e279e$var$SetCache;


var $aae24ad60cc3cfcb$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$aae24ad60cc3cfcb$exports = $aae24ad60cc3cfcb$var$arraySome;


var $1b44096ad4b9e2d5$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
$1b44096ad4b9e2d5$exports = $1b44096ad4b9e2d5$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $a29ccdc0f60e279e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$aae24ad60cc3cfcb$exports(other, function(othValue, othIndex) {
                if (!$1b44096ad4b9e2d5$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1081bd3a2e361911$exports = $1081bd3a2e361911$var$equalArrays;


var $baf52b9e146f3da7$exports = {};

var $facf83d1449a27b8$exports = {};

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
$facf83d1449a27b8$exports = $facf83d1449a27b8$var$Uint8Array;




var $91d4444cbb077e0c$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$91d4444cbb077e0c$exports = $91d4444cbb077e0c$var$mapToArray;


var $11f509f8f53d8c36$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11f509f8f53d8c36$exports = $11f509f8f53d8c36$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $facf83d1449a27b8$exports(object), new $facf83d1449a27b8$exports(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $50557587dab070a0$exports(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $91d4444cbb077e0c$exports;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11f509f8f53d8c36$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1081bd3a2e361911$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
$baf52b9e146f3da7$exports = $baf52b9e146f3da7$var$equalByTag;


var $ac8a81cbae0357e8$exports = {};
var $7958eecccfe4cef6$exports = {};
var $9144d49da7a47a72$exports = {};
var $cc77dbb7c08db6a8$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$cc77dbb7c08db6a8$exports = $cc77dbb7c08db6a8$var$arrayPush;


var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0488fde9aa355453$exports(object) ? result : $cc77dbb7c08db6a8$exports(result, symbolsFunc(object));
}
$9144d49da7a47a72$exports = $9144d49da7a47a72$var$baseGetAllKeys;


var $51326a29f571e7cd$exports = {};
var $6549fed720324048$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$6549fed720324048$exports = $6549fed720324048$var$arrayFilter;


var $8fc9f7df9b0c06bb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
$8fc9f7df9b0c06bb$exports = $8fc9f7df9b0c06bb$var$stubArray;


/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $8fc9f7df9b0c06bb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $6549fed720324048$exports($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
$51326a29f571e7cd$exports = $51326a29f571e7cd$var$getSymbols;


var $08f0eaf3fbcb2fde$exports = {};
var $64568844439edb7f$exports = {};
var $b14d62a510ae7f2d$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$b14d62a510ae7f2d$exports = $b14d62a510ae7f2d$var$baseTimes;


var $7d0c6fd0eb26be0e$exports = {};
var $fb8f823cdc90f511$exports = {};

var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $fb8f823cdc90f511$var$argsTag;
}
$fb8f823cdc90f511$exports = $fb8f823cdc90f511$var$baseIsArguments;



/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $fb8f823cdc90f511$exports(function() {
    return arguments;
}()) ? $fb8f823cdc90f511$exports : function(value) {
    return $61269cf1f3e020be$exports(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
$7d0c6fd0eb26be0e$exports = $7d0c6fd0eb26be0e$var$isArguments;




var $f504n = parcelRequire("f504n");
var $d83738e053b5eb08$exports = {};
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$d83738e053b5eb08$exports = $d83738e053b5eb08$var$isIndex;


var $156c3727697ab085$exports = {};
var $9d076681a0e29d68$exports = {};

var $15d215b19bcf1187$exports = {};
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
$15d215b19bcf1187$exports = $15d215b19bcf1187$var$isLength;



/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $61269cf1f3e020be$exports(value) && $15d215b19bcf1187$exports(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$a7f8a2555793d7d3$exports(value)];
}
$9d076681a0e29d68$exports = $9d076681a0e29d68$var$baseIsTypedArray;


var $692cb5474f422969$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$692cb5474f422969$exports = $692cb5474f422969$var$baseUnary;



var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $692cb5474f422969$exports($156c3727697ab085$var$nodeIsTypedArray) : $9d076681a0e29d68$exports;
$156c3727697ab085$exports = $156c3727697ab085$var$isTypedArray;


/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $0488fde9aa355453$exports(value), isArg = !isArr && $7d0c6fd0eb26be0e$exports(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $156c3727697ab085$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $b14d62a510ae7f2d$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $d83738e053b5eb08$exports(key, length)))) result.push(key);
    return result;
}
$64568844439edb7f$exports = $64568844439edb7f$var$arrayLikeKeys;


var $e811d2e210fb58cc$exports = {};
var $292432068be14a79$exports = {};
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
$292432068be14a79$exports = $292432068be14a79$var$isPrototype;


var $0b26005314403d97$exports = {};
var $ff813e49bf3cca3d$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ff813e49bf3cca3d$exports = $ff813e49bf3cca3d$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $ff813e49bf3cca3d$exports(Object.keys, Object);
$0b26005314403d97$exports = $0b26005314403d97$var$nativeKeys;


/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$292432068be14a79$exports(object)) return $0b26005314403d97$exports(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$e811d2e210fb58cc$exports = $e811d2e210fb58cc$var$baseKeys;


var $ac2c42592aa05543$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $15d215b19bcf1187$exports(value.length) && !$004783abbde551e4$exports(value);
}
$ac2c42592aa05543$exports = $ac2c42592aa05543$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $ac2c42592aa05543$exports(object) ? $64568844439edb7f$exports(object) : $e811d2e210fb58cc$exports(object);
}
$08f0eaf3fbcb2fde$exports = $08f0eaf3fbcb2fde$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $9144d49da7a47a72$exports(object, $08f0eaf3fbcb2fde$exports, $51326a29f571e7cd$exports);
}
$7958eecccfe4cef6$exports = $7958eecccfe4cef6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $7958eecccfe4cef6$exports(object), objLength = objProps.length, othProps = $7958eecccfe4cef6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$ac8a81cbae0357e8$exports = $ac8a81cbae0357e8$var$equalObjects;


var $474f685f496bfe31$exports = {};
var $41ce0ff3b38ee753$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $5037fd2e597c2a03$exports($23YZo, 'DataView');
$41ce0ff3b38ee753$exports = $41ce0ff3b38ee753$var$DataView;



var $b0226bdea11cb834$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $5037fd2e597c2a03$exports($23YZo, 'Promise');
$b0226bdea11cb834$exports = $b0226bdea11cb834$var$Promise;


var $05f44e958da968eb$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $5037fd2e597c2a03$exports($23YZo, 'Set');
$05f44e958da968eb$exports = $05f44e958da968eb$var$Set;


var $aedce50092a1e6a6$exports = {};


var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $5037fd2e597c2a03$exports($23YZo, 'WeakMap');
$aedce50092a1e6a6$exports = $aedce50092a1e6a6$var$WeakMap;




/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $9c6b3ec69362487e$exports($41ce0ff3b38ee753$exports), $474f685f496bfe31$var$mapCtorString = $9c6b3ec69362487e$exports($19b02faa57603249$exports), $474f685f496bfe31$var$promiseCtorString = $9c6b3ec69362487e$exports($b0226bdea11cb834$exports), $474f685f496bfe31$var$setCtorString = $9c6b3ec69362487e$exports($05f44e958da968eb$exports), $474f685f496bfe31$var$weakMapCtorString = $9c6b3ec69362487e$exports($aedce50092a1e6a6$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $a7f8a2555793d7d3$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($41ce0ff3b38ee753$exports && $474f685f496bfe31$var$getTag(new $41ce0ff3b38ee753$exports(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $19b02faa57603249$exports && $474f685f496bfe31$var$getTag(new $19b02faa57603249$exports) != $474f685f496bfe31$var$mapTag || $b0226bdea11cb834$exports && $474f685f496bfe31$var$getTag($b0226bdea11cb834$exports.resolve()) != $474f685f496bfe31$var$promiseTag || $05f44e958da968eb$exports && $474f685f496bfe31$var$getTag(new $05f44e958da968eb$exports) != $474f685f496bfe31$var$setTag || $aedce50092a1e6a6$exports && $474f685f496bfe31$var$getTag(new $aedce50092a1e6a6$exports) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $a7f8a2555793d7d3$exports(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9c6b3ec69362487e$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
$474f685f496bfe31$exports = $474f685f496bfe31$var$getTag;




var $f504n = parcelRequire("f504n");

/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0488fde9aa355453$exports(object), othIsArr = $0488fde9aa355453$exports(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $474f685f496bfe31$exports(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bbb2d98cae25b61a$exports);
        return objIsArr || $156c3727697ab085$exports(object) ? $1081bd3a2e361911$exports(object, other, bitmask, customizer, equalFunc, stack) : $baf52b9e146f3da7$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bbb2d98cae25b61a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bbb2d98cae25b61a$exports);
    return $ac8a81cbae0357e8$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$567f2dd161ebd4f6$exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61269cf1f3e020be$exports(value) && !$61269cf1f3e020be$exports(other)) return value !== value && other !== other;
    return $567f2dd161ebd4f6$exports(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
$769812b29c18141e$exports = $769812b29c18141e$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bbb2d98cae25b61a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $769812b29c18141e$exports(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$ec073f38db6e7d54$exports = $ec073f38db6e7d54$var$baseIsMatch;


var $6b4f84f6be7f825c$exports = {};
var $0ff8edf4f90a7955$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$f9ff2e983beb6b86$exports(value);
}
$0ff8edf4f90a7955$exports = $0ff8edf4f90a7955$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $08f0eaf3fbcb2fde$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $0ff8edf4f90a7955$exports(value)
        ];
    }
    return result;
}
$6b4f84f6be7f825c$exports = $6b4f84f6be7f825c$var$getMatchData;


var $1f9d5e891556ddb9$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$1f9d5e891556ddb9$exports = $1f9d5e891556ddb9$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $6b4f84f6be7f825c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $1f9d5e891556ddb9$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $ec073f38db6e7d54$exports(object, source, matchData);
    };
}
$e780807e2b795134$exports = $e780807e2b795134$var$baseMatches;


var $d5fe8a98fe4800eb$exports = {};

var $d299ac421c05c135$exports = {};
var $fd2d90f592c63519$exports = {};
var $38afcbfab85a0553$exports = {};

var $03e9beb856e9b4cd$exports = {};

var $6b5a5095e0934938$exports = {};


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($0488fde9aa355453$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $6b5a5095e0934938$exports(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$03e9beb856e9b4cd$exports = $03e9beb856e9b4cd$var$isKey;


var $f9135a667399ede4$exports = {};
var $6aae515404bf5dd2$exports = {};
var $17f5c88c594eac51$exports = {};

/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $4902f64a16640324$exports);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $4902f64a16640324$exports;
$17f5c88c594eac51$exports = $17f5c88c594eac51$var$memoize;


/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $17f5c88c594eac51$exports(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$6aae515404bf5dd2$exports = $6aae515404bf5dd2$var$memoizeCapped;


/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $6aae515404bf5dd2$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$f9135a667399ede4$exports = $f9135a667399ede4$var$stringToPath;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};

var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($0488fde9aa355453$exports(value)) return value;
    return $03e9beb856e9b4cd$exports(value, object) ? [
        value
    ] : $f9135a667399ede4$exports($f5d9385a9cc7e413$exports(value));
}
$38afcbfab85a0553$exports = $38afcbfab85a0553$var$castPath;


var $4d60aa8c33155976$exports = {};

/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $6b5a5095e0934938$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
$4d60aa8c33155976$exports = $4d60aa8c33155976$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4d60aa8c33155976$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$fd2d90f592c63519$exports = $fd2d90f592c63519$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fd2d90f592c63519$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d299ac421c05c135$exports = $d299ac421c05c135$var$get;


var $221e04e57e35dd04$exports = {};
var $d53c6080f339a51f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$d53c6080f339a51f$exports = $d53c6080f339a51f$var$baseHasIn;


var $85aaea8f77d790ae$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $38afcbfab85a0553$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4d60aa8c33155976$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $15d215b19bcf1187$exports(length) && $d83738e053b5eb08$exports(key, length) && ($0488fde9aa355453$exports(object) || $7d0c6fd0eb26be0e$exports(object));
}
$85aaea8f77d790ae$exports = $85aaea8f77d790ae$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $85aaea8f77d790ae$exports(object, path, $d53c6080f339a51f$exports);
}
$221e04e57e35dd04$exports = $221e04e57e35dd04$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($03e9beb856e9b4cd$exports(path) && $0ff8edf4f90a7955$exports(srcValue)) return $1f9d5e891556ddb9$exports($4d60aa8c33155976$exports(path), srcValue);
    return function(object) {
        var objValue = $d299ac421c05c135$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $221e04e57e35dd04$exports(object, path) : $769812b29c18141e$exports(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
$d5fe8a98fe4800eb$exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;


var $37dff9aa04444f9c$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
$37dff9aa04444f9c$exports = $37dff9aa04444f9c$var$identity;



var $87123e72266aa58c$exports = {};
var $d45a621b4548f6bb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$d45a621b4548f6bb$exports = $d45a621b4548f6bb$var$baseProperty;


var $e029d02f9dd10368$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $fd2d90f592c63519$exports(object, path);
    };
}
$e029d02f9dd10368$exports = $e029d02f9dd10368$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $03e9beb856e9b4cd$exports(path) ? $d45a621b4548f6bb$exports($4d60aa8c33155976$exports(path)) : $e029d02f9dd10368$exports(path);
}
$87123e72266aa58c$exports = $87123e72266aa58c$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $37dff9aa04444f9c$exports;
    if (typeof value == 'object') return $0488fde9aa355453$exports(value) ? $d5fe8a98fe4800eb$exports(value[0], value[1]) : $e780807e2b795134$exports(value);
    return $87123e72266aa58c$exports(value);
}
$5aba4f6d9f8304a3$exports = $5aba4f6d9f8304a3$var$baseIteratee;


var $65b6a9e5a3dbf7e3$exports = {};
var $c48cdc53eae67a7f$exports = {};

var $c9d0ae50fd1d1372$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c9d0ae50fd1d1372$exports = $c9d0ae50fd1d1372$var$last;


var $b03c5325a6e99e83$exports = {};

var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $b03c5325a6e99e83$var$parent(object, path) {
    return path.length < 2 ? object : $fd2d90f592c63519$exports(object, $109fb88fe59de104$exports(path, 0, -1));
}
$b03c5325a6e99e83$exports = $b03c5325a6e99e83$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c48cdc53eae67a7f$var$baseUnset(object, path) {
    path = $38afcbfab85a0553$exports(path, object);
    object = $b03c5325a6e99e83$exports(object, path);
    return object == null || delete object[$4d60aa8c33155976$exports($c9d0ae50fd1d1372$exports(path))];
}
$c48cdc53eae67a7f$exports = $c48cdc53eae67a7f$var$baseUnset;



/** Used for built-in method references. */ var $65b6a9e5a3dbf7e3$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $65b6a9e5a3dbf7e3$var$splice = $65b6a9e5a3dbf7e3$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */ function $65b6a9e5a3dbf7e3$var$basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while(length--){
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
            var previous = index;
            if ($d83738e053b5eb08$exports(index)) $65b6a9e5a3dbf7e3$var$splice.call(array, index, 1);
            else $c48cdc53eae67a7f$exports(array, index);
        }
    }
    return array;
}
$65b6a9e5a3dbf7e3$exports = $65b6a9e5a3dbf7e3$var$basePullAt;


/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */ function $e991a8ea9bf02b62$var$remove(array, predicate) {
    var result = [];
    if (!(array && array.length)) return result;
    var index = -1, indexes = [], length = array.length;
    predicate = $5aba4f6d9f8304a3$exports(predicate, 3);
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
        }
    }
    $65b6a9e5a3dbf7e3$exports(array, indexes);
    return result;
}
$e991a8ea9bf02b62$exports = $e991a8ea9bf02b62$var$remove;


class $f2ab65773a27cb19$export$42d239a7180b47de {
    constructor(){
        this.fps = 60;
        this.fpsratio = 1;
        this.focusback = false;
        this.list = [];
        window.addEventListener("focus", ()=>{
            this.setFocusBack();
        });
        window.addEventListener("blur", ()=>{
            this.setFocusBack();
        });
    }
    /**
	 * Make one step forward for all animations
	 * @param fps Frame per second of the engine
	 */ runAnimations(fps) {
        // if (mode == 'develoment') this.fpsnode.textContent = fps+' - '+this.list.length;
        this.fps = fps;
        this.fpsratio = 60 / this.fps;
        // if (this.focusback) return;
        // To avoid acceleration when focus back
        let fpsratio = Math.min(this.fpsratio, 2);
        for(let i = 0; i < this.list.length; i++){
            let anim = this.list[i];
            if (anim.running) {
                anim.funct(anim.count, anim.count / anim.howmany);
                if (anim.count >= anim.howmany) anim.stop(true);
                anim.count += anim.step * fpsratio;
            }
        }
    }
    /**
	 * Stop all the scene animation
	 */ stopAnimations() {
        this.setFocusBack();
        for(let i = 0; i < this.list.length; i++){
            let anim = this.list[i];
            anim.stop(true);
        }
    }
    /**
	 * Restart all the scene animation if there is any
	 */ restartAnimations() {
        this.setFocusBack();
        for(let i = 0; i < this.list.length; i++){
            let anim = this.list[i];
            anim.restart();
        }
    }
    /**
	 * Make a small pause of animations (Used when focus is back to window)
	 */ setFocusBack() {
        this.focusback = true;
        // In case in worker
        // if (localStorage) localStorage.clear();
        setTimeout(()=>{
            this.focusback = false;
        }, 200);
    }
}
class $f2ab65773a27cb19$export$c35d437ae5945fcd {
    /**
	 * Create a new animation
	 * @param animationManager Manager where to push animation
	 * @param howmany How many step is needed to end the animation
	 * @param start Starting value
	 * @param step Progress step used in each run call
	 */ constructor(animationManager, howmany, start, step){
        /**
	 * Starting value
	 */ this.start = 0;
        /**
	 * Current progress
	 */ this.count = 0;
        /**
	 * Progress step used in each run call
	 */ this.step = 1;
        /**
	 * Is the animation running or not
	 */ this.running = false;
        this.animationManager = animationManager;
        if (howmany) this.setParam(howmany, start, step);
        this.key = Math.random().toString(36);
        return this;
    }
    /**
	 * Set animation parameters
	 * @param howmany How many step is needed to end the animation
	 * @param start Starting value
	 * @param step Progress step used in each run call
	 */ setParam(howmany, start, step) {
        if (this.running) this.stop(true);
        this.howmany = howmany - 1;
        if (step) this.step = step;
        if (start) this.start = start;
        this.count = this.start;
        return this;
    }
    /**
	 * Create an infinite animation which will never stop
	 * @param funct Function called at each run and used to animate something
	 */ infinite(funct) {
        let howmany = 1000000000000;
        this.simple(howmany, funct);
        return this;
    }
    /**
	 * Create an infinite animation which will never stop
	 * @param howmany How many step is needed to end the animation
	 * @param alter How many step do we need to alternate the animation
	 * @param funct1 Alternate function 1
	 * @param funct2 Alternate function 2
	 * @param functend Function called when animation is over
	 */ alternate(howmany, alter, funct1, funct2, functend) {
        let ft = true;
        let alterstep = 0;
        this.simple(howmany, (count, perc)=>{
            if (count > alter * (alterstep + 1)) {
                ft = !ft;
                alterstep++;
            }
            count = count - alter * alterstep;
            perc = count / alter;
            if (ft) funct1(count, perc);
            else if (funct2) funct2(count, perc);
        }, functend);
        return this;
    }
    /**
	 * Create an infinite animation which will never stop
	 * @param howmany How many step is needed to end the animation
	 * @param loop How many step do we need to loopn the animation
	 * @param funct Function called at each run and used to animate something
	 * @param functloop Function called everytime the loop goes back to start
	 * @param functend Function called when animation is over
	 */ loop(howmany, loop, funct, functloop, functend) {
        let loopstep = 0;
        this.simple(howmany, (count, perc)=>{
            if (count > loop * (loopstep + 1)) {
                loopstep++;
                if (functloop) functloop();
            }
            count = count - loop * loopstep;
            perc = count / loop;
            funct(count, perc);
        }, functend);
        return this;
    }
    /**
	 * Reverse the current step of the animation
	 */ reverse() {
        this.step = -this.step;
        return this;
    }
    interval(time, funct) {
        let timeTest = 0;
        this.infinite((count)=>{
            let milisecond = count * 1000 / 60;
            if (milisecond - timeTest > time) {
                funct();
                timeTest = milisecond;
            }
        });
    }
    // steps (steps:any) {
    // 	this.loopsteps(steps, 0);
    // 	return this;
    // }
    //
    // loopsteps (steps:any, step:number) {
    // 	if (!steps[step]) return;
    // 	let stepO = steps[step];
    // 	this.simple(stepO.howmany, (count, perc) => {
    // 		stepO.funct(count, perc);
    // 	}, () => {
    // 		stepO.functend();
    // 		step++
    // 		if (!this.running) this.loopsteps(steps, step);
    // 	});
    // }
    /**
	 * Easiest way to lauch an animation (By default it start at 0 and use a step of 1)
	 * @param howmany How many step is needed to end the animation
	 * @param funct Function called at each run and used to animate something
	 * @param functend Function called when animation is over
	 */ simple(howmany, funct, functend) {
        if (this.running) this.stop();
        this.start = 0;
        this.count = 0;
        this.step = 1;
        this.howmany = howmany;
        this.go(funct, functend);
        return this;
    }
    /**
	 * Set main animation functions and launch it (Often used after setting the animation parameters)
	 * @param funct Function called at each run and used to animate something
	 * @param functend Function called when animation is over
	 */ go(funct, functend) {
        this.pause();
        this.running = true;
        this.funct = funct;
        this.functend = functend;
        this.play();
        return this;
    }
    /**
	 * Restart animation
	 */ restart() {
        if (this.running) {
            this.pause();
            this.go(this.funct, this.functend);
        }
    }
    /**
	 * Stop animation
	 * @param arg Sent to functend so that it knows the stop can be forced and is not due to the end of the animation
	 */ stop(arg) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.animationManager.list, (a)=>{
            return a.key == this.key;
        });
        this.count = this.start;
        if (this.functend && this.running) {
            this.running = false;
            this.functend(arg);
        }
        return this;
    }
    /**
	 * Pause animation
	 */ pause() {
        (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.animationManager.list, (a)=>{
            return a.key == this.key;
        });
        this.running = false;
        return this;
    }
    /**
	 * Play animation
	 */ play() {
        if (this.animationManager.list.indexOf(this) == -1) this.animationManager.list.push(this);
        return this;
    }
}


class $4f85fb42b602b6da$export$7bc9e6fdd5ef4b53 extends (0, $854be06c1a29939d$export$39459471b3952c34) {
    constructor(type, system){
        super(type, system), this.offset = 0 // Used to determine beginning position around gravityEntity
        , this.cycle = 0 // Around its gravityEntity % Math.PI
        , this.stationaryRadius = 1, this.stationaryVelocity = 1;
        this.satelliteAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
    }
    setGeostationnaryMovement(stationaryRadius, stationaryVelocity) {
        this.stationaryRadius = stationaryRadius;
        this.stationaryVelocity = Math.max(stationaryVelocity, 2);
    }
    setParent(parent) {
        this.transformMesh.parent = parent;
    }
    setOffset(offset) {
        this.offset = offset;
    }
}


let $4373291cff47fc4d$export$5fa999cbd7347f0 = 10;
let $4373291cff47fc4d$var$grabCurve = new (0, $005b3f0c7a6c24da$export$b9f6da40882c34cc)();
$4373291cff47fc4d$var$grabCurve.setEasingMode((0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEINOUT);
const $4373291cff47fc4d$export$30e52872ef59c897 = (a, b, alpha)=>{
    return a + alpha * (b - a);
};
class $4373291cff47fc4d$export$8304f7f371e2a37b extends (0, $4f85fb42b602b6da$export$7bc9e6fdd5ef4b53) {
    setGravity(gravity) {
        this.gravity = gravity;
        this.updateGravityField();
    }
    _setSize(size) {
        this.size = size;
        this.updateGravityField();
    }
    updateGravityField() {
        this.gravityField = Math.sqrt(this.size * this.gravity) * $4373291cff47fc4d$export$5fa999cbd7347f0;
    }
    getSatelliteRadius(num) {
        return (2 + num) * this.size;
    }
    satelliteCycle() {
        for(let i = 0; i < this.satellites.length; i++){
            const satellite = this.satellites[i];
            const { stationaryVelocity: stationaryVelocity, stationaryRadius: stationaryRadius, cycle: cycle, offset: offset } = satellite;
            satellite.stationaryRadius = $4373291cff47fc4d$export$30e52872ef59c897(stationaryRadius, this.getSatelliteRadius(i), 0.1);
            const x = (this.size * 1.5 + stationaryRadius) * Math.cos(stationaryVelocity * cycle / 100 + offset);
            const y = (this.size * 1.5 + stationaryRadius) * Math.sin(stationaryVelocity * cycle / 100 + offset);
            satellite.setPosition(new (0, $ha1VO.Vector2)(x, y));
            satellite.setRotation(stationaryVelocity * (this.cycleSize / 100));
            satellite.cycle += this.cycleSize * this.system.fpsRatio;
        }
    }
    removeAllSatellites() {
        // for (let i = 0; i < this.satellites.length; i++) {
        //     const satellite = this.satellites[i];
        //     satellite.hide();
        //     this.planetMap.storagePlanet(planet);
        // }
        this.satellites = [];
    }
    fixeSatellite(satellite) {
        satellite.setParent(this.transformMesh);
        this.satellites.push(satellite);
    }
    grabSatellite(satellite, radius, velocity) {
        let xgap = this.position.x - satellite.position.x;
        let ygap = this.position.y - satellite.position.y;
        let offset = xgap > 0 ? Math.atan(ygap / xgap) + Math.PI : Math.atan(ygap / xgap);
        satellite.setOffset(offset);
        let dist = (0, $ha1VO.Vector2).Distance(satellite.position, this.position);
        let radiusTemp = dist - this.size;
        let radiusChange = radiusTemp - radius;
        satellite.setGeostationnaryMovement(radius + radiusChange, 0);
        satellite.satelliteAnimation.simple(this.grabAnimationLength, (count, perc)=>{
            let progress = $4373291cff47fc4d$var$grabCurve.ease(perc);
            satellite.setGeostationnaryMovement(radius + (1 - progress) * radiusChange, progress * velocity);
        }, ()=>{
            satellite.setGeostationnaryMovement(radius, velocity);
        });
    }
    constructor(...args){
        super(...args), this.gravity = 1, this.gravityField = 1, this.cycleAbsorb = 1, this.satellites = [], this.cycleSize = 1, this.grabAnimationLength = 50;
    }
}



class $17f863f85fbdf179$export$e1dae5660003ffa7 {
    /**
     * Creates a new System
     * @param canvas Element where the scene will be drawn
     */ constructor(canvas){
        /**
    * Max Hardware scaling of BabylonJS Engine
    */ this.maxScaling = 1;
        this.currentRadius = 0;
        this.shacking = false;
        this.center = (0, $ha1VO.Vector2).Zero();
        this.size = 300;
        /**
    * Tell if system currently rendering scene
    */ this.rendering = false;
        /**
    * Tell if scene needs to be render
    */ this.started = false;
        this.limitSwitch = true;
        this.limitFPS = false;
        this.fps = 60;
        this.fpsRatio = 1;
        // if (!Engine.isSupported()) throw 'WebGL not supported';
        this.canvas = canvas;
        // For now keep false as the last argument of the engine,
        // We don't want the canvas to adapt to screen ratio as it slow down too much the scene
        // preserveDrawingBuffer and stencil needed for screenshot
        // let engineOption;
        // if (!screenshot) engineOption = { limitDeviceRatio: this.maxScaling };
        // else engineOption = { limitDeviceRatio: this.maxScaling, preserveDrawingBuffer: true, stencil: true };
        // let engineOption = { limitDeviceRatio: this.maxScaling, preserveDrawingBuffer: true, stencil: true };
        let engineOption = {};
        this.engine = new (0, $5YkyR.Engine)(this.canvas, true, engineOption, false);
        // NOTE to avoid request for manifest files because it can block loading on safari
        this.engine.enableOfflineSupport = false;
        this.animationManager = new (0, $f2ab65773a27cb19$export$42d239a7180b47de)();
        this.buildScene();
        window.addEventListener('resize', ()=>{
            this.engine.resize();
        });
    }
    buildScene() {
        this.scene = new (0, $gmbCk.Scene)(this.engine);
        this.scene.ambientColor = new (0, $7etnY.Color3)(0.0, 0.0, 0.0);
        this.scene.clearColor = new (0, $7etnY.Color4)(0.0, 0.0, 0.0, 0.0);
        this.scene.autoClear = false; // Color buffer
        this.scene.autoClearDepthAndStencil = false; // Depth and stencil, obviously
        this.scene.blockfreeActiveMeshesAndRenderingGroups = true;
        this.scene.shadowsEnabled = false;
        this.scene.fogEnabled = false;
        // Can't freeze because of particles
        // Can't blockMaterialDirtyMechanism because of PBR
        // this.scene.blockMaterialDirtyMechanism = true;
        // this.scene.setRenderingAutoClearDepthStencil(renderingGroupIdx, autoClear, depth, stencil);
        this.setCamera();
        this.setLimitFPS(true);
        // setInterval(() => {
        //     let fps = this.engine.getFps();
        //     if (fps < 50) this.setLimitFPS(true);
        //     else this.setLimitFPS(false);
        // }, 1000);
        this.motionBlur = new (0, $087ccb6c95d43552$export$512056e66e9deaee)('mb', this.scene, 1.0, this.camera, undefined, undefined, undefined, (0, $bd523120f282dc29$export$a002182e51710d39).TEXTURETYPE_HALF_FLOAT, undefined, true);
        this.camera.detachPostProcess(this.motionBlur);
    }
    setCamera() {
        // this.camera = new ArcRotateCamera('camera', 0, Math.PI/6, 10, Vector3.Zero(), this.scene);
        this.camera = new (0, $e59f949a590d8aa8$export$8438041bb8e406c8)('camera', Math.PI, 0, 10, (0, $ha1VO.Vector3).Zero(), this.scene);
        this.camera.minZ = 0;
        this.camera.setTarget((0, $ha1VO.Vector3).Zero());
        // this.camera.attachControl(this.canvas);
        this.shakeAnim = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.animationManager);
        // this.motionBlur.motionStrength = 10;
        // this.motionBlur.isEnabled = fasle;
        this.camera.mode = (0, $52736139c8513fb2$export$79f141de891a5fed).ORTHOGRAPHIC_CAMERA;
    }
    lerpCamera(radius) {
        const newRadius = (0, $4373291cff47fc4d$export$30e52872ef59c897)(this.currentRadius, radius, 0.01);
        this.setCameraRadius(newRadius);
    }
    setCameraRadius(radius) {
        this.currentRadius = radius;
        const { camera: camera, scene: scene } = this;
        let aspect = scene.getEngine().getAspectRatio(camera);
        let ortho = radius * 0.4;
        camera.radius = radius;
        camera.orthoTop = ortho;
        camera.orthoBottom = -ortho;
        camera.orthoLeft = -ortho * aspect;
        camera.orthoRight = ortho * aspect;
    }
    addMotionBLur() {
        this.camera.attachPostProcess(this.motionBlur);
        this.shakeAnim.simple(100, (count, perc)=>{
            const p = Math.min(perc, 1 - perc);
            this.motionBlur.motionStrength = p * 5;
        }, ()=>{
            this.camera.detachPostProcess(this.motionBlur);
        });
    }
    setAlpha(alpha) {
        this.camera.beta = Math.PI / 4;
        this.camera.alpha = Math.PI / 4 + alpha;
    }
    cameraShake(power) {
        this.shacking = true;
        this.shakeAnim.alternate(30, 3, (count, perc)=>{
            this.setAlpha(power * perc / 20);
        }, (count, perc)=>{
            this.setAlpha(-power * perc / 20);
        }, ()=>{
            this.shacking = false;
            // this.cameraposition = camPosition;
            this.setAlpha(0);
        });
    }
    setCenterAndSize(center, size) {
        this.setCenter(center);
        this.setSize(size);
    }
    setCenter(center) {
        this.center = center;
    }
    setSize(size) {
        this.size = size;
    }
    /**
     * @ignore
     */ setVisible(canvasVisible) {
        // If overflow style = hidden, there is no scrollingElement on document
        if (canvasVisible && !this.rendering) this.startRender();
        else if (!canvasVisible && this.rendering) this.pauseRender();
    }
    /**
     * Allow to launch scene rendering (when everything is loaded for instance)
     */ launchRender() {
        this.started = true;
        this.startRender();
    }
    /**
     * Stop scene rendering
     */ stopRender() {
        this.started = false;
        this.pauseRender();
    }
    /**
     * @ignore
     */ pauseRender() {
        this.rendering = false;
        this.engine.stopRenderLoop();
    }
    startRender() {
        this.rendering = true;
        this.engine.stopRenderLoop();
        if (this.limitFPS) this.engine.runRenderLoop(()=>{
            this.animationManager.runAnimations(this.engine.getFps());
            if (this.limitSwitch) this.scene.render();
            this.limitSwitch = !this.limitSwitch;
        });
        else this.engine.runRenderLoop(()=>{
            this.animationManager.runAnimations(this.engine.getFps());
            this.scene.render();
        });
    }
    // Keep first value as true so that render function is called straight away
    // Otherwise you could have a flash 
    setLimitFPS(limitFPS) {
        if (limitFPS == this.limitFPS) return;
        this.limitFPS = limitFPS;
        if (this.limitFPS) this.fps = 30;
        else this.fps = 60;
        this.fpsRatio = 60 / this.fps;
        if (this.rendering) this.startRender();
    }
    /**
     * Optimize scene to make rendering faster
     * https://doc.babylonjs.com/how_to/optimizing_your_scene#reducing-shaders-overhead
     */ optimize() {
        // this.scene.blockMaterialDirtyMechanism = true;
        this.scene.autoClear = false; // Color buffer
        this.scene.autoClearDepthAndStencil = false; // Depth and stencil, obviously
    // let activeTest = 0;
    // this.scene.registerBeforeRender(() => {
    //     activeTest++;
    //     this.scene.freezeActiveMeshes();
    //     if (activeTest > 30) {
    //         activeTest = 0;
    //         this.scene.unfreezeActiveMeshes();
    //     }
    // });
    }
    /**
     * UnOptimize scene rendering
     * https://doc.babylonjs.com/how_to/optimizing_your_scene#reducing-shaders-overhead
     */ unOptimize() {
        this.scene.blockMaterialDirtyMechanism = false;
        this.scene.autoClear = true; // Color buffer
        this.scene.autoClearDepthAndStencil = true; // Depth and stencil, obviously
    }
    /**
     * Optimize scene to make rendering faster
     * https://doc.babylonjs.com/how_to/optimizing_your_scene#reducing-shaders-overhead
     */ optimizeHard() {
        this.optimize();
        this.scene.freezeActiveMeshes();
        this.scene.blockMaterialDirtyMechanism = true;
    // this.scene.setRenderingAutoClearDepthStencil(renderingGroupIdx, autoClear, depth, stencil);
    }
    /**
     * UnOptimize scene rendering
     * https://doc.babylonjs.com/how_to/optimizing_your_scene#reducing-shaders-overhead
     */ unOptimizeHard() {
        this.unOptimize();
        this.scene.unfreezeActiveMeshes();
        this.scene.blockMaterialDirtyMechanism = false;
    // this.scene.setRenderingAutoClearDepthStencil(renderingGroupIdx, autoClear, depth, stencil);
    }
    checkActiveMeshes() {
        this.scene.unfreezeActiveMeshes();
        this.scene.freezeActiveMeshes();
    }
}


var $d808ef187f63a460$exports = {};
$d808ef187f63a460$exports = new URL("T_Star.e1bc310e.png", import.meta.url).toString();


var $08fc44335498e21f$exports = {};
$08fc44335498e21f$exports = new URL("T_SunSurface.e9090abc.png", import.meta.url).toString();


const $9612821352bbabe0$var$SKYS = [
    {
        color0: new (0, $7etnY.Color3)(31 / 255, 21 / 255, 33 / 255),
        color1: new (0, $7etnY.Color3)(112 / 255, 68 / 255, 166 / 255),
        color2: new (0, $7etnY.Color3)(48 / 255, 200 / 255, 200 / 255),
        name: 'Orion'
    },
    {
        color0: new (0, $7etnY.Color3)(12 / 255, 38 / 255, 36 / 255),
        color1: new (0, $7etnY.Color3)(0.4, 232 / 255, 180 / 255),
        color2: new (0, $7etnY.Color3)(122 / 255, 252 / 255, 0.4),
        name: 'Eagle'
    },
    {
        color0: new (0, $7etnY.Color3)(33 / 255, 28 / 255, 11 / 255),
        color1: new (0, $7etnY.Color3)(222 / 255, 162 / 255, 48 / 255),
        color2: new (0, $7etnY.Color3)(220 / 255, 80 / 255, 80 / 255),
        name: 'Trifid'
    },
    {
        color0: new (0, $7etnY.Color3)(20 / 255, 18 / 255, 71 / 255),
        color1: new (0, $7etnY.Color3)(66 / 255, 76 / 255, 200 / 255),
        color2: new (0, $7etnY.Color3)(220 / 255, 50 / 255, 220 / 255),
        name: 'Helix'
    },
    {
        color0: new (0, $7etnY.Color3)(26 / 255, 36 / 255, 25 / 255),
        color1: new (0, $7etnY.Color3)(112 / 255, 192 / 255, 96 / 255),
        color2: new (0, $7etnY.Color3)(220 / 255, 220 / 255, 48 / 255),
        name: 'Dumbbell'
    },
    {
        color0: new (0, $7etnY.Color3)(50 / 255, 36 / 255, 0.2),
        color1: new (0, $7etnY.Color3)(154 / 255, 68 / 255, 106 / 255),
        color2: new (0, $7etnY.Color3)(24 / 255, 150 / 255, 200 / 255),
        name: 'Tarantula'
    }
];
class $9612821352bbabe0$export$efcc5cd87cfb9a73 extends (0, $17f863f85fbdf179$export$e1dae5660003ffa7) {
    /**
     * Creates a new System
     * @param canvas Element where the scene will be drawn
     */ constructor(canvas){
        super(canvas), this.sky = $9612821352bbabe0$var$SKYS[0];
        this.addRibbonMaterial();
        this.sparkleTexture = new (0, $j2mX5.Texture)((0, (/*@__PURE__*/$parcel$interopDefault($d808ef187f63a460$exports))), this.scene);
        this.surfaceTexture = new (0, $j2mX5.Texture)((0, (/*@__PURE__*/$parcel$interopDefault($08fc44335498e21f$exports))), this.scene);
    }
    setSky(design) {
        this.sky = $9612821352bbabe0$var$SKYS[design];
        const { color1: color1, color2: color2 } = this.sky;
        this.skyColor = color1;
        this.planetMaterial.emissiveFresnelParameters.leftColor = color1;
        this.planetMaterial.emissiveFresnelParameters.rightColor = color2;
        const lightColor = color1.multiplyByFloats(2, 2, 2).minimizeInPlaceFromFloats(1, 1, 1);
        this.skyColorHex = lightColor.toHexString();
    }
    addRibbonMaterial() {
        this.ribbonMaterial = new (0, $27c681c3fbf85650$export$55538ea799e2f967)("ribbonMaterial", this.scene);
        // this.ribbonMaterial.alpha = 0.5;
        this.ribbonMaterial.AddUniform('color0', 'vec3', (0, $7etnY.Color3).White());
        this.ribbonMaterial.AddUniform('color1', 'vec3', (0, $7etnY.Color3).White());
        this.ribbonMaterial.AddUniform('color2', 'vec3', (0, $7etnY.Color3).Black());
        this.ribbonMaterial.Vertex_Definitions("varying vec3 vPosition;");
        this.ribbonMaterial.Fragment_Definitions("varying vec3 vPosition;");
        this.ribbonMaterial.Vertex_MainBegin("vPosition = position;");
        this.ribbonMaterial.Fragment_Before_FragColor(`
                float x = vPosition.x;
                float z = vPosition.z;
                float y = vPosition.y;

                // SUN LIGHT
                float starLight = (y * 1.) + 1.0;

                // SQUARE GRID LINES
                float frequency = 1.0;
                float power = 10.0;
                float gridX = pow(1. - abs(sin(x * frequency)), power);
                float gridZ = pow(1. - abs(sin(z * frequency)), power);
                float grid = min(gridX + gridZ, 1.);

                vec3 gridColor = mix(color1, color2, y);

                vec3 colorLight = color0 * starLight;
                color.rgb = mix(colorLight, gridColor, grid/2.);

                // float blackHole = 2. - (y / 10.);
                // blackHole = min(max(blackHole, 0.), 1.);
                // color.rgb *= blackHole;
            `);
        this.ribbonMaterial.onBindObservable.add(()=>{
            const { color0: color0, color1: color1, color2: color2 } = this.sky;
            const effect = this.ribbonMaterial.getEffect();
            effect.setColor3('color0', color0);
            effect.setColor3('color1', color1);
            effect.setColor3('color2', color2);
        });
    }
}



var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $dUFYy = parcelRequire("dUFYy");

var $ejQPp = parcelRequire("ejQPp");

var $8DoUR = parcelRequire("8DoUR");

var $dUFoQ = parcelRequire("dUFoQ");

var $av6Bc = parcelRequire("av6Bc");
class $c204841fc2d888eb$export$85990f0f98a390bb {
    /**
     * Does the sound loop after it finishes playing once.
     */ get loop() {
        return this._loop;
    }
    set loop(value) {
        if (value === this._loop) return;
        this._loop = value;
        this.updateOptions({
            loop: value
        });
    }
    /**
     * Gets the current time for the sound.
     */ get currentTime() {
        if (this._htmlAudioElement) return this._htmlAudioElement.currentTime;
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.audioContext && (this.isPlaying || this.isPaused)) {
            // The `_currentTime` member is only updated when the sound is paused. Add the time since the last start
            // to get the actual current time.
            const timeSinceLastStart = this.isPaused ? 0 : (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime - this._startTime;
            return this._currentTime + timeSinceLastStart;
        }
        return 0;
    }
    /**
     * Does this sound enables spatial sound.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ get spatialSound() {
        return this._spatialSound;
    }
    /**
     * Does this sound enables spatial sound.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ set spatialSound(newValue) {
        if (newValue == this._spatialSound) return;
        const wasPlaying = this.isPlaying;
        this.pause();
        if (newValue) {
            this._spatialSound = newValue;
            this._updateSpatialParameters();
        } else this._disableSpatialSound();
        if (wasPlaying) this.play();
    }
    /**
     * Create a sound and attach it to a scene
     * @param name Name of your sound
     * @param urlOrArrayBuffer Url to the sound to load async or ArrayBuffer, it also works with MediaStreams and AudioBuffers
     * @param scene defines the scene the sound belongs to
     * @param readyToPlayCallback Provide a callback function if you'd like to load your code once the sound is ready to be played
     * @param options Objects to provide with the current available options: autoplay, loop, volume, spatialSound, maxDistance, rolloffFactor, refDistance, distanceModel, panningModel, streaming
     */ constructor(name, urlOrArrayBuffer, scene, readyToPlayCallback = null, options){
        /**
         * Does the sound autoplay once loaded.
         */ this.autoplay = false;
        this._loop = false;
        /**
         * Does the sound use a custom attenuation curve to simulate the falloff
         * happening when the source gets further away from the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-your-own-custom-attenuation-function
         */ this.useCustomAttenuation = false;
        /**
         * Is this sound currently played.
         */ this.isPlaying = false;
        /**
         * Is this sound currently paused.
         */ this.isPaused = false;
        /**
         * Define the reference distance the sound should be heard perfectly.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.refDistance = 1;
        /**
         * Define the roll off factor of spatial sounds.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.rolloffFactor = 1;
        /**
         * Define the max distance the sound should be heard (intensity just became 0 at this point).
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.maxDistance = 100;
        /**
         * Define the distance attenuation model the sound will follow.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.distanceModel = "linear";
        /**
         * Gets or sets an object used to store user defined information for the sound.
         */ this.metadata = null;
        /**
         * Observable event when the current playing sound finishes.
         */ this.onEndedObservable = new (0, $diGQf.Observable)();
        this._spatialSound = false;
        this._panningModel = "equalpower";
        this._playbackRate = 1;
        this._streaming = false;
        this._startTime = 0;
        this._currentTime = 0;
        this._position = (0, $ha1VO.Vector3).Zero();
        this._localDirection = new (0, $ha1VO.Vector3)(1, 0, 0);
        this._volume = 1;
        this._isReadyToPlay = false;
        this._isDirectional = false;
        // Used if you'd like to create a directional sound.
        // If not set, the sound will be omnidirectional
        this._coneInnerAngle = 360;
        this._coneOuterAngle = 360;
        this._coneOuterGain = 0;
        this._isOutputConnected = false;
        this._urlType = "Unknown";
        this.name = name;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        $c204841fc2d888eb$export$85990f0f98a390bb._SceneComponentInitialization(scene);
        this._readyToPlayCallback = readyToPlayCallback;
        // Default custom attenuation function is a linear attenuation
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._customAttenuationFunction = (currentVolume, currentDistance, maxDistance, refDistance, rolloffFactor)=>{
            if (currentDistance < maxDistance) return currentVolume * (1 - currentDistance / maxDistance);
            else return 0;
        };
        if (options) {
            this.autoplay = options.autoplay || false;
            this._loop = options.loop || false;
            // if volume === 0, we need another way to check this option
            if (options.volume !== undefined) this._volume = options.volume;
            this._spatialSound = options.spatialSound ?? false;
            this.maxDistance = options.maxDistance ?? 100;
            this.useCustomAttenuation = options.useCustomAttenuation ?? false;
            this.rolloffFactor = options.rolloffFactor || 1;
            this.refDistance = options.refDistance || 1;
            this.distanceModel = options.distanceModel || "linear";
            this._playbackRate = options.playbackRate || 1;
            this._streaming = options.streaming ?? false;
            this._length = options.length;
            this._offset = options.offset;
        }
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && (0, $dUFoQ.AbstractEngine).audioEngine.audioContext) {
            this._soundGain = (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.createGain();
            this._soundGain.gain.value = this._volume;
            this._inputAudioNode = this._soundGain;
            this._outputAudioNode = this._soundGain;
            if (this._spatialSound) this._createSpatialParameters();
            this._scene.mainSoundTrack.addSound(this);
            let validParameter = true;
            // if no parameter is passed, you need to call setAudioBuffer yourself to prepare the sound
            if (urlOrArrayBuffer) try {
                if (typeof urlOrArrayBuffer === "string") {
                    this._urlType = "String";
                    this._url = urlOrArrayBuffer;
                } else if (urlOrArrayBuffer instanceof ArrayBuffer) this._urlType = "ArrayBuffer";
                else if (urlOrArrayBuffer instanceof HTMLMediaElement) this._urlType = "MediaElement";
                else if (urlOrArrayBuffer instanceof MediaStream) this._urlType = "MediaStream";
                else if (urlOrArrayBuffer instanceof AudioBuffer) this._urlType = "AudioBuffer";
                else if (Array.isArray(urlOrArrayBuffer)) this._urlType = "Array";
                let urls = [];
                let codecSupportedFound = false;
                switch(this._urlType){
                    case "MediaElement":
                        this._streaming = true;
                        this._isReadyToPlay = true;
                        this._streamingSource = (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.createMediaElementSource(urlOrArrayBuffer);
                        if (this.autoplay) this.play(0, this._offset, this._length);
                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                        break;
                    case "MediaStream":
                        this._streaming = true;
                        this._isReadyToPlay = true;
                        this._streamingSource = (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.createMediaStreamSource(urlOrArrayBuffer);
                        if (this.autoplay) this.play(0, this._offset, this._length);
                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                        break;
                    case "ArrayBuffer":
                        if (urlOrArrayBuffer.byteLength > 0) {
                            codecSupportedFound = true;
                            this._soundLoaded(urlOrArrayBuffer);
                        }
                        break;
                    case "AudioBuffer":
                        this._audioBufferLoaded(urlOrArrayBuffer);
                        break;
                    case "String":
                        urls.push(urlOrArrayBuffer);
                    // eslint-disable-next-line no-fallthrough
                    case "Array":
                        if (urls.length === 0) urls = urlOrArrayBuffer;
                        // If we found a supported format, we load it immediately and stop the loop
                        for(let i = 0; i < urls.length; i++){
                            const url = urls[i];
                            codecSupportedFound = options && options.skipCodecCheck || url.indexOf(".mp3", url.length - 4) !== -1 && (0, $dUFoQ.AbstractEngine).audioEngine.isMP3supported || url.indexOf(".ogg", url.length - 4) !== -1 && (0, $dUFoQ.AbstractEngine).audioEngine.isOGGsupported || url.indexOf(".wav", url.length - 4) !== -1 || url.indexOf(".m4a", url.length - 4) !== -1 || url.indexOf(".mp4", url.length - 4) !== -1 || url.indexOf("blob:") !== -1;
                            if (codecSupportedFound) {
                                // Loading sound
                                if (!this._streaming) this._scene._loadFile(url, (data)=>{
                                    this._soundLoaded(data);
                                }, undefined, true, true, (exception)=>{
                                    if (exception) (0, $kVtWi.Logger).Error("XHR " + exception.status + " error on: " + url + ".");
                                    (0, $kVtWi.Logger).Error("Sound creation aborted.");
                                    this._scene.mainSoundTrack.removeSound(this);
                                });
                                else {
                                    this._htmlAudioElement = new Audio(url);
                                    this._htmlAudioElement.controls = false;
                                    this._htmlAudioElement.loop = this.loop;
                                    (0, $bOhSV.Tools).SetCorsBehavior(url, this._htmlAudioElement);
                                    this._htmlAudioElement.preload = "auto";
                                    this._htmlAudioElement.addEventListener("canplaythrough", ()=>{
                                        this._isReadyToPlay = true;
                                        if (this.autoplay) this.play(0, this._offset, this._length);
                                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                                    }, {
                                        once: true
                                    });
                                    document.body.appendChild(this._htmlAudioElement);
                                    this._htmlAudioElement.load();
                                }
                                break;
                            }
                        }
                        break;
                    default:
                        validParameter = false;
                        break;
                }
                if (!validParameter) (0, $kVtWi.Logger).Error("Parameter must be a URL to the sound, an Array of URLs (.mp3 & .ogg) or an ArrayBuffer of the sound.");
                else if (!codecSupportedFound) {
                    this._isReadyToPlay = true;
                    // Simulating a ready to play event to avoid breaking code path
                    if (this._readyToPlayCallback) setTimeout(()=>{
                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                    }, 1000);
                }
            } catch (ex) {
                (0, $kVtWi.Logger).Error("Unexpected error. Sound creation aborted.");
                this._scene.mainSoundTrack.removeSound(this);
            }
        } else {
            // Adding an empty sound to avoid breaking audio calls for non Web Audio browsers
            this._scene.mainSoundTrack.addSound(this);
            if ((0, $dUFoQ.AbstractEngine).audioEngine && !(0, $dUFoQ.AbstractEngine).audioEngine.WarnedWebAudioUnsupported) {
                (0, $kVtWi.Logger).Error("Web Audio is not supported by your browser.");
                (0, $dUFoQ.AbstractEngine).audioEngine.WarnedWebAudioUnsupported = true;
            }
            // Simulating a ready to play event to avoid breaking code for non web audio browsers
            if (this._readyToPlayCallback) setTimeout(()=>{
                if (this._readyToPlayCallback) this._readyToPlayCallback();
            }, 1000);
        }
    }
    /**
     * Release the sound and its associated resources
     */ dispose() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio) {
            if (this.isPlaying) this.stop();
            this._isReadyToPlay = false;
            if (this.soundTrackId === -1) this._scene.mainSoundTrack.removeSound(this);
            else if (this._scene.soundTracks) this._scene.soundTracks[this.soundTrackId].removeSound(this);
            if (this._soundGain) {
                this._soundGain.disconnect();
                this._soundGain = null;
            }
            if (this._soundPanner) {
                this._soundPanner.disconnect();
                this._soundPanner = null;
            }
            if (this._soundSource) {
                this._soundSource.disconnect();
                this._soundSource = null;
            }
            this._audioBuffer = null;
            if (this._htmlAudioElement) {
                this._htmlAudioElement.pause();
                this._htmlAudioElement.src = "";
                document.body.removeChild(this._htmlAudioElement);
                this._htmlAudioElement = null;
            }
            if (this._streamingSource) {
                this._streamingSource.disconnect();
                this._streamingSource = null;
            }
            if (this._connectedTransformNode && this._registerFunc) {
                this._connectedTransformNode.unregisterAfterWorldMatrixUpdate(this._registerFunc);
                this._connectedTransformNode = null;
            }
            this._clearTimeoutsAndObservers();
        }
    }
    /**
     * Gets if the sounds is ready to be played or not.
     * @returns true if ready, otherwise false
     */ isReady() {
        return this._isReadyToPlay;
    }
    /**
     * Get the current class name.
     * @returns current class name
     */ getClassName() {
        return "Sound";
    }
    _audioBufferLoaded(buffer) {
        if (!(0, $dUFoQ.AbstractEngine).audioEngine?.audioContext) return;
        this._audioBuffer = buffer;
        this._isReadyToPlay = true;
        if (this.autoplay) this.play(0, this._offset, this._length);
        if (this._readyToPlayCallback) this._readyToPlayCallback();
    }
    _soundLoaded(audioData) {
        if (!(0, $dUFoQ.AbstractEngine).audioEngine?.audioContext) return;
        (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.decodeAudioData(audioData, (buffer)=>{
            this._audioBufferLoaded(buffer);
        }, (err)=>{
            (0, $kVtWi.Logger).Error("Error while decoding audio data for: " + this.name + " / Error: " + err);
        });
    }
    /**
     * Sets the data of the sound from an audiobuffer
     * @param audioBuffer The audioBuffer containing the data
     */ setAudioBuffer(audioBuffer) {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio) {
            this._audioBuffer = audioBuffer;
            this._isReadyToPlay = true;
        }
    }
    /**
     * Updates the current sounds options such as maxdistance, loop...
     * @param options A JSON object containing values named as the object properties
     */ updateOptions(options) {
        if (options) {
            this.loop = options.loop ?? this.loop;
            this.maxDistance = options.maxDistance ?? this.maxDistance;
            this.useCustomAttenuation = options.useCustomAttenuation ?? this.useCustomAttenuation;
            this.rolloffFactor = options.rolloffFactor ?? this.rolloffFactor;
            this.refDistance = options.refDistance ?? this.refDistance;
            this.distanceModel = options.distanceModel ?? this.distanceModel;
            this._playbackRate = options.playbackRate ?? this._playbackRate;
            this._length = options.length ?? undefined;
            this.spatialSound = options.spatialSound ?? this._spatialSound;
            this._setOffset(options.offset ?? undefined);
            this.setVolume(options.volume ?? this._volume);
            this._updateSpatialParameters();
            if (this.isPlaying) {
                if (this._streaming && this._htmlAudioElement) {
                    this._htmlAudioElement.playbackRate = this._playbackRate;
                    if (this._htmlAudioElement.loop !== this.loop) this._htmlAudioElement.loop = this.loop;
                } else if (this._soundSource) {
                    this._soundSource.playbackRate.value = this._playbackRate;
                    if (this._soundSource.loop !== this.loop) this._soundSource.loop = this.loop;
                    if (this._offset !== undefined && this._soundSource.loopStart !== this._offset) this._soundSource.loopStart = this._offset;
                    if (this._length !== undefined && this._length !== this._soundSource.loopEnd) this._soundSource.loopEnd = (this._offset | 0) + this._length;
                }
            }
        }
    }
    _createSpatialParameters() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && (0, $dUFoQ.AbstractEngine).audioEngine.audioContext) {
            if (this._scene.headphone) this._panningModel = "HRTF";
            this._soundPanner = this._soundPanner ?? (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.createPanner();
            if (this._soundPanner && this._outputAudioNode) {
                this._updateSpatialParameters();
                this._soundPanner.connect(this._outputAudioNode);
                this._inputAudioNode = this._soundPanner;
            }
        }
    }
    _disableSpatialSound() {
        if (!this._spatialSound) return;
        this._inputAudioNode = this._soundGain;
        this._soundPanner?.disconnect();
        this._soundPanner = null;
        this._spatialSound = false;
    }
    _updateSpatialParameters() {
        if (!this._spatialSound) return;
        if (this._soundPanner) {
            if (this.useCustomAttenuation) {
                // Tricks to disable in a way embedded Web Audio attenuation
                this._soundPanner.distanceModel = "linear";
                this._soundPanner.maxDistance = Number.MAX_VALUE;
                this._soundPanner.refDistance = 1;
                this._soundPanner.rolloffFactor = 1;
                this._soundPanner.panningModel = this._panningModel;
            } else {
                this._soundPanner.distanceModel = this.distanceModel;
                this._soundPanner.maxDistance = this.maxDistance;
                this._soundPanner.refDistance = this.refDistance;
                this._soundPanner.rolloffFactor = this.rolloffFactor;
                this._soundPanner.panningModel = this._panningModel;
            }
        } else this._createSpatialParameters();
    }
    /**
     * Switch the panning model to HRTF:
     * Renders a stereo output of higher quality than equalpower — it uses a convolution with measured impulse responses from human subjects.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToHRTF() {
        this._panningModel = "HRTF";
        this._switchPanningModel();
    }
    /**
     * Switch the panning model to Equal Power:
     * Represents the equal-power panning algorithm, generally regarded as simple and efficient. equalpower is the default value.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToEqualPower() {
        this._panningModel = "equalpower";
        this._switchPanningModel();
    }
    _switchPanningModel() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner) this._soundPanner.panningModel = this._panningModel;
    }
    /**
     * Connect this sound to a sound track audio node like gain...
     * @param soundTrackAudioNode the sound track audio node to connect to
     */ connectToSoundTrackAudioNode(soundTrackAudioNode) {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._outputAudioNode) {
            if (this._isOutputConnected) this._outputAudioNode.disconnect();
            this._outputAudioNode.connect(soundTrackAudioNode);
            this._isOutputConnected = true;
        }
    }
    /**
     * Transform this sound into a directional source
     * @param coneInnerAngle Size of the inner cone in degree
     * @param coneOuterAngle Size of the outer cone in degree
     * @param coneOuterGain Volume of the sound outside the outer cone (between 0.0 and 1.0)
     */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        if (coneOuterAngle < coneInnerAngle) {
            (0, $kVtWi.Logger).Error("setDirectionalCone(): outer angle of the cone must be superior or equal to the inner angle.");
            return;
        }
        this._coneInnerAngle = coneInnerAngle;
        this._coneOuterAngle = coneOuterAngle;
        this._coneOuterGain = coneOuterGain;
        this._isDirectional = true;
        if (this.isPlaying && this.loop) {
            this.stop();
            this.play(0, this._offset, this._length);
        }
    }
    /**
     * Gets or sets the inner angle for the directional cone.
     */ get directionalConeInnerAngle() {
        return this._coneInnerAngle;
    }
    /**
     * Gets or sets the inner angle for the directional cone.
     */ set directionalConeInnerAngle(value) {
        if (value != this._coneInnerAngle) {
            if (this._coneOuterAngle < value) {
                (0, $kVtWi.Logger).Error("directionalConeInnerAngle: outer angle of the cone must be superior or equal to the inner angle.");
                return;
            }
            this._coneInnerAngle = value;
            if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner) this._soundPanner.coneInnerAngle = this._coneInnerAngle;
        }
    }
    /**
     * Gets or sets the outer angle for the directional cone.
     */ get directionalConeOuterAngle() {
        return this._coneOuterAngle;
    }
    /**
     * Gets or sets the outer angle for the directional cone.
     */ set directionalConeOuterAngle(value) {
        if (value != this._coneOuterAngle) {
            if (value < this._coneInnerAngle) {
                (0, $kVtWi.Logger).Error("directionalConeOuterAngle: outer angle of the cone must be superior or equal to the inner angle.");
                return;
            }
            this._coneOuterAngle = value;
            if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner) this._soundPanner.coneOuterAngle = this._coneOuterAngle;
        }
    }
    /**
     * Sets the position of the emitter if spatial sound is enabled
     * @param newPosition Defines the new position
     */ setPosition(newPosition) {
        if (newPosition.equals(this._position)) return;
        this._position.copyFrom(newPosition);
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner && !isNaN(this._position.x) && !isNaN(this._position.y) && !isNaN(this._position.z)) {
            this._soundPanner.positionX.value = this._position.x;
            this._soundPanner.positionY.value = this._position.y;
            this._soundPanner.positionZ.value = this._position.z;
        }
    }
    /**
     * Sets the local direction of the emitter if spatial sound is enabled
     * @param newLocalDirection Defines the new local direction
     */ setLocalDirectionToMesh(newLocalDirection) {
        this._localDirection = newLocalDirection;
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._connectedTransformNode && this.isPlaying) this._updateDirection();
    }
    _updateDirection() {
        if (!this._connectedTransformNode || !this._soundPanner) return;
        const mat = this._connectedTransformNode.getWorldMatrix();
        const direction = (0, $ha1VO.Vector3).TransformNormal(this._localDirection, mat);
        direction.normalize();
        this._soundPanner.orientationX.value = direction.x;
        this._soundPanner.orientationY.value = direction.y;
        this._soundPanner.orientationZ.value = direction.z;
    }
    /** @internal */ updateDistanceFromListener() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._connectedTransformNode && this.useCustomAttenuation && this._soundGain && this._scene.activeCamera) {
            const distance = this._scene.audioListenerPositionProvider ? this._connectedTransformNode.position.subtract(this._scene.audioListenerPositionProvider()).length() : this._connectedTransformNode.getDistanceToCamera(this._scene.activeCamera);
            this._soundGain.gain.value = this._customAttenuationFunction(this._volume, distance, this.maxDistance, this.refDistance, this.rolloffFactor);
        }
    }
    /**
     * Sets a new custom attenuation function for the sound.
     * @param callback Defines the function used for the attenuation
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-your-own-custom-attenuation-function
     */ setAttenuationFunction(callback) {
        this._customAttenuationFunction = callback;
    }
    /**
     * Play the sound
     * @param time (optional) Start the sound after X seconds. Start immediately (0) by default.
     * @param offset (optional) Start the sound at a specific time in seconds
     * @param length (optional) Sound duration (in seconds)
     */ play(time, offset, length) {
        if (this._isReadyToPlay && this._scene.audioEnabled && (0, $dUFoQ.AbstractEngine).audioEngine?.audioContext) try {
            this._clearTimeoutsAndObservers();
            let startTime = time ? (0, $dUFoQ.AbstractEngine).audioEngine?.audioContext.currentTime + time : (0, $dUFoQ.AbstractEngine).audioEngine?.audioContext.currentTime;
            if (!this._soundSource || !this._streamingSource) {
                if (this._spatialSound && this._soundPanner) {
                    if (!isNaN(this._position.x) && !isNaN(this._position.y) && !isNaN(this._position.z)) {
                        this._soundPanner.positionX.value = this._position.x;
                        this._soundPanner.positionY.value = this._position.y;
                        this._soundPanner.positionZ.value = this._position.z;
                    }
                    if (this._isDirectional) {
                        this._soundPanner.coneInnerAngle = this._coneInnerAngle;
                        this._soundPanner.coneOuterAngle = this._coneOuterAngle;
                        this._soundPanner.coneOuterGain = this._coneOuterGain;
                        if (this._connectedTransformNode) this._updateDirection();
                        else this._soundPanner.setOrientation(this._localDirection.x, this._localDirection.y, this._localDirection.z);
                    }
                }
            }
            if (this._streaming) {
                if (!this._streamingSource && this._htmlAudioElement) {
                    this._streamingSource = (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.createMediaElementSource(this._htmlAudioElement);
                    this._htmlAudioElement.onended = ()=>{
                        this._onended();
                    };
                    this._htmlAudioElement.playbackRate = this._playbackRate;
                }
                if (this._streamingSource) {
                    this._streamingSource.disconnect();
                    if (this._inputAudioNode) this._streamingSource.connect(this._inputAudioNode);
                }
                if (this._htmlAudioElement) {
                    // required to manage properly the new suspended default state of Chrome
                    // When the option 'streaming: true' is used, we need first to wait for
                    // the audio engine to be unlocked by a user gesture before trying to play
                    // an HTML Audio element
                    const tryToPlay = ()=>{
                        if ((0, $dUFoQ.AbstractEngine).audioEngine?.unlocked) {
                            if (!this._htmlAudioElement) return;
                            this._htmlAudioElement.currentTime = offset ?? 0;
                            const playPromise = this._htmlAudioElement.play();
                            // In browsers that don’t yet support this functionality,
                            // playPromise won’t be defined.
                            if (playPromise !== undefined) playPromise.catch(()=>{
                                // Automatic playback failed.
                                // Waiting for the audio engine to be unlocked by user click on unmute
                                (0, $dUFoQ.AbstractEngine).audioEngine?.lock();
                                if (this.loop || this.autoplay) this._audioUnlockedObserver = (0, $dUFoQ.AbstractEngine).audioEngine?.onAudioUnlockedObservable.addOnce(()=>{
                                    tryToPlay();
                                });
                            });
                        } else if (this.loop || this.autoplay) this._audioUnlockedObserver = (0, $dUFoQ.AbstractEngine).audioEngine?.onAudioUnlockedObservable.addOnce(()=>{
                            tryToPlay();
                        });
                    };
                    tryToPlay();
                }
            } else {
                const tryToPlay = ()=>{
                    if ((0, $dUFoQ.AbstractEngine).audioEngine?.audioContext) {
                        length = length || this._length;
                        if (offset !== undefined) this._setOffset(offset);
                        if (this._soundSource) {
                            const oldSource = this._soundSource;
                            oldSource.onended = ()=>{
                                oldSource.disconnect();
                            };
                        }
                        this._soundSource = (0, $dUFoQ.AbstractEngine).audioEngine?.audioContext.createBufferSource();
                        if (this._soundSource && this._inputAudioNode) {
                            this._soundSource.buffer = this._audioBuffer;
                            this._soundSource.connect(this._inputAudioNode);
                            this._soundSource.loop = this.loop;
                            if (offset !== undefined) this._soundSource.loopStart = offset;
                            if (length !== undefined) this._soundSource.loopEnd = (offset | 0) + length;
                            this._soundSource.playbackRate.value = this._playbackRate;
                            this._soundSource.onended = ()=>{
                                this._onended();
                            };
                            startTime = time ? (0, $dUFoQ.AbstractEngine).audioEngine?.audioContext.currentTime + time : (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime;
                            const actualOffset = ((this.isPaused ? this.currentTime : 0) + (this._offset ?? 0)) % this._soundSource.buffer.duration;
                            this._soundSource.start(startTime, actualOffset, this.loop ? undefined : length);
                        }
                    }
                };
                if ((0, $dUFoQ.AbstractEngine).audioEngine?.audioContext.state === "suspended") // Wait a bit for FF as context seems late to be ready.
                this._tryToPlayTimeout = setTimeout(()=>{
                    if ((0, $dUFoQ.AbstractEngine).audioEngine?.audioContext.state === "suspended") {
                        // Automatic playback failed.
                        // Waiting for the audio engine to be unlocked by user click on unmute
                        (0, $dUFoQ.AbstractEngine).audioEngine.lock();
                        if (this.loop || this.autoplay) this._audioUnlockedObserver = (0, $dUFoQ.AbstractEngine).audioEngine.onAudioUnlockedObservable.addOnce(()=>{
                            tryToPlay();
                        });
                    } else tryToPlay();
                }, 500);
                else tryToPlay();
            }
            this._startTime = startTime;
            this.isPlaying = true;
            this.isPaused = false;
        } catch (ex) {
            (0, $kVtWi.Logger).Error("Error while trying to play audio: " + this.name + ", " + ex.message);
        }
    }
    _onended() {
        this.isPlaying = false;
        this._startTime = 0;
        this._currentTime = 0;
        if (this.onended) this.onended();
        this.onEndedObservable.notifyObservers(this);
    }
    /**
     * Stop the sound
     * @param time (optional) Stop the sound after X seconds. Stop immediately (0) by default.
     */ stop(time) {
        if (this.isPlaying) {
            this._clearTimeoutsAndObservers();
            if (this._streaming) {
                if (this._htmlAudioElement) {
                    this._htmlAudioElement.pause();
                    // Test needed for Firefox or it will generate an Invalid State Error
                    if (this._htmlAudioElement.currentTime > 0) this._htmlAudioElement.currentTime = 0;
                } else this._streamingSource?.disconnect();
                this.isPlaying = false;
            } else if ((0, $dUFoQ.AbstractEngine).audioEngine?.audioContext && this._soundSource) {
                const stopTime = time ? (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime + time : undefined;
                this._soundSource.onended = ()=>{
                    this.isPlaying = false;
                    this.isPaused = false;
                    this._startTime = 0;
                    this._currentTime = 0;
                    if (this._soundSource) this._soundSource.onended = ()=>void 0;
                    this._onended();
                };
                this._soundSource.stop(stopTime);
            } else this.isPlaying = false;
        } else if (this.isPaused) {
            this.isPaused = false;
            this._startTime = 0;
            this._currentTime = 0;
        }
    }
    /**
     * Put the sound in pause
     */ pause() {
        if (this.isPlaying) {
            this._clearTimeoutsAndObservers();
            if (this._streaming) {
                if (this._htmlAudioElement) this._htmlAudioElement.pause();
                else this._streamingSource?.disconnect();
                this.isPlaying = false;
                this.isPaused = true;
            } else if ((0, $dUFoQ.AbstractEngine).audioEngine?.audioContext && this._soundSource) {
                this._soundSource.onended = ()=>void 0;
                this._soundSource.stop();
                this.isPlaying = false;
                this.isPaused = true;
                this._currentTime += (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime - this._startTime;
            }
        }
    }
    /**
     * Sets a dedicated volume for this sounds
     * @param newVolume Define the new volume of the sound
     * @param time Define time for gradual change to new volume
     */ setVolume(newVolume, time) {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._soundGain) {
            if (time && (0, $dUFoQ.AbstractEngine).audioEngine.audioContext) {
                this._soundGain.gain.cancelScheduledValues((0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime);
                this._soundGain.gain.setValueAtTime(this._soundGain.gain.value, (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime);
                this._soundGain.gain.linearRampToValueAtTime(newVolume, (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.currentTime + time);
            } else this._soundGain.gain.value = newVolume;
        }
        this._volume = newVolume;
    }
    /**
     * Set the sound play back rate
     * @param newPlaybackRate Define the playback rate the sound should be played at
     */ setPlaybackRate(newPlaybackRate) {
        this._playbackRate = newPlaybackRate;
        if (this.isPlaying) {
            if (this._streaming && this._htmlAudioElement) this._htmlAudioElement.playbackRate = this._playbackRate;
            else if (this._soundSource) this._soundSource.playbackRate.value = this._playbackRate;
        }
    }
    /**
     * Gets the sound play back rate.
     * @returns the  play back rate of the sound
     */ getPlaybackRate() {
        return this._playbackRate;
    }
    /**
     * Gets the volume of the sound.
     * @returns the volume of the sound
     */ getVolume() {
        return this._volume;
    }
    /**
     * Attach the sound to a dedicated mesh
     * @param transformNode The transform node to connect the sound with
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#attaching-a-sound-to-a-mesh
     */ attachToMesh(transformNode) {
        if (this._connectedTransformNode && this._registerFunc) {
            this._connectedTransformNode.unregisterAfterWorldMatrixUpdate(this._registerFunc);
            this._registerFunc = null;
        }
        this._connectedTransformNode = transformNode;
        if (!this._spatialSound) {
            this._spatialSound = true;
            this._createSpatialParameters();
            if (this.isPlaying && this.loop) {
                this.stop();
                this.play(0, this._offset, this._length);
            }
        }
        this._onRegisterAfterWorldMatrixUpdate(this._connectedTransformNode);
        this._registerFunc = (transformNode)=>this._onRegisterAfterWorldMatrixUpdate(transformNode);
        this._connectedTransformNode.registerAfterWorldMatrixUpdate(this._registerFunc);
    }
    /**
     * Detach the sound from the previously attached mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#attaching-a-sound-to-a-mesh
     */ detachFromMesh() {
        if (this._connectedTransformNode && this._registerFunc) {
            this._connectedTransformNode.unregisterAfterWorldMatrixUpdate(this._registerFunc);
            this._registerFunc = null;
            this._connectedTransformNode = null;
        }
    }
    _onRegisterAfterWorldMatrixUpdate(node) {
        if (!node.getBoundingInfo) this.setPosition(node.absolutePosition);
        else {
            const mesh = node;
            const boundingInfo = mesh.getBoundingInfo();
            this.setPosition(boundingInfo.boundingSphere.centerWorld);
        }
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._isDirectional && this.isPlaying) this._updateDirection();
    }
    /**
     * Clone the current sound in the scene.
     * @returns the new sound clone
     */ clone() {
        if (!this._streaming) {
            const setBufferAndRun = ()=>{
                (0, $av6Bc._retryWithInterval)(()=>this._isReadyToPlay, ()=>{
                    clonedSound._audioBuffer = this.getAudioBuffer();
                    clonedSound._isReadyToPlay = true;
                    if (clonedSound.autoplay) clonedSound.play(0, this._offset, this._length);
                }, undefined, 300);
            };
            const currentOptions = {
                autoplay: this.autoplay,
                loop: this.loop,
                volume: this._volume,
                spatialSound: this._spatialSound,
                maxDistance: this.maxDistance,
                useCustomAttenuation: this.useCustomAttenuation,
                rolloffFactor: this.rolloffFactor,
                refDistance: this.refDistance,
                distanceModel: this.distanceModel
            };
            const clonedSound = new $c204841fc2d888eb$export$85990f0f98a390bb(this.name + "_cloned", new ArrayBuffer(0), this._scene, null, currentOptions);
            if (this.useCustomAttenuation) clonedSound.setAttenuationFunction(this._customAttenuationFunction);
            clonedSound.setPosition(this._position);
            clonedSound.setPlaybackRate(this._playbackRate);
            setBufferAndRun();
            return clonedSound;
        } else return null;
    }
    /**
     * Gets the current underlying audio buffer containing the data
     * @returns the audio buffer
     */ getAudioBuffer() {
        return this._audioBuffer;
    }
    /**
     * Gets the WebAudio AudioBufferSourceNode, lets you keep track of and stop instances of this Sound.
     * @returns the source node
     */ getSoundSource() {
        return this._soundSource;
    }
    /**
     * Gets the WebAudio GainNode, gives you precise control over the gain of instances of this Sound.
     * @returns the gain node
     */ getSoundGain() {
        return this._soundGain;
    }
    /**
     * Serializes the Sound in a JSON representation
     * @returns the JSON representation of the sound
     */ serialize() {
        const serializationObject = {
            name: this.name,
            url: this._url,
            autoplay: this.autoplay,
            loop: this.loop,
            volume: this._volume,
            spatialSound: this._spatialSound,
            maxDistance: this.maxDistance,
            rolloffFactor: this.rolloffFactor,
            refDistance: this.refDistance,
            distanceModel: this.distanceModel,
            playbackRate: this._playbackRate,
            panningModel: this._panningModel,
            soundTrackId: this.soundTrackId,
            metadata: this.metadata
        };
        if (this._spatialSound) {
            if (this._connectedTransformNode) serializationObject.connectedMeshId = this._connectedTransformNode.id;
            serializationObject.position = this._position.asArray();
            serializationObject.refDistance = this.refDistance;
            serializationObject.distanceModel = this.distanceModel;
            serializationObject.isDirectional = this._isDirectional;
            serializationObject.localDirectionToMesh = this._localDirection.asArray();
            serializationObject.coneInnerAngle = this._coneInnerAngle;
            serializationObject.coneOuterAngle = this._coneOuterAngle;
            serializationObject.coneOuterGain = this._coneOuterGain;
        }
        return serializationObject;
    }
    /**
     * Parse a JSON representation of a sound to instantiate in a given scene
     * @param parsedSound Define the JSON representation of the sound (usually coming from the serialize method)
     * @param scene Define the scene the new parsed sound should be created in
     * @param rootUrl Define the rooturl of the load in case we need to fetch relative dependencies
     * @param sourceSound Define a sound place holder if do not need to instantiate a new one
     * @returns the newly parsed sound
     */ static Parse(parsedSound, scene, rootUrl, sourceSound) {
        const soundName = parsedSound.name;
        let soundUrl;
        if (parsedSound.url) soundUrl = rootUrl + parsedSound.url;
        else soundUrl = rootUrl + soundName;
        const options = {
            autoplay: parsedSound.autoplay,
            loop: parsedSound.loop,
            volume: parsedSound.volume,
            spatialSound: parsedSound.spatialSound,
            maxDistance: parsedSound.maxDistance,
            rolloffFactor: parsedSound.rolloffFactor,
            refDistance: parsedSound.refDistance,
            distanceModel: parsedSound.distanceModel,
            playbackRate: parsedSound.playbackRate
        };
        let newSound;
        if (!sourceSound) {
            newSound = new $c204841fc2d888eb$export$85990f0f98a390bb(soundName, soundUrl, scene, ()=>{
                scene.removePendingData(newSound);
            }, options);
            scene.addPendingData(newSound);
        } else {
            const setBufferAndRun = ()=>{
                (0, $av6Bc._retryWithInterval)(()=>sourceSound._isReadyToPlay, ()=>{
                    newSound._audioBuffer = sourceSound.getAudioBuffer();
                    newSound._isReadyToPlay = true;
                    if (newSound.autoplay) newSound.play(0, newSound._offset, newSound._length);
                }, undefined, 300);
            };
            newSound = new $c204841fc2d888eb$export$85990f0f98a390bb(soundName, new ArrayBuffer(0), scene, null, options);
            setBufferAndRun();
        }
        if (parsedSound.position) {
            const soundPosition = (0, $ha1VO.Vector3).FromArray(parsedSound.position);
            newSound.setPosition(soundPosition);
        }
        if (parsedSound.isDirectional) {
            newSound.setDirectionalCone(parsedSound.coneInnerAngle || 360, parsedSound.coneOuterAngle || 360, parsedSound.coneOuterGain || 0);
            if (parsedSound.localDirectionToMesh) {
                const localDirectionToMesh = (0, $ha1VO.Vector3).FromArray(parsedSound.localDirectionToMesh);
                newSound.setLocalDirectionToMesh(localDirectionToMesh);
            }
        }
        if (parsedSound.connectedMeshId) {
            const connectedMesh = scene.getMeshById(parsedSound.connectedMeshId);
            if (connectedMesh) newSound.attachToMesh(connectedMesh);
        }
        if (parsedSound.metadata) newSound.metadata = parsedSound.metadata;
        return newSound;
    }
    _setOffset(value) {
        if (this._offset === value) return;
        if (this.isPaused) {
            this.stop();
            this.isPaused = false;
        }
        this._offset = value;
    }
    _clearTimeoutsAndObservers() {
        if (this._tryToPlayTimeout) {
            clearTimeout(this._tryToPlayTimeout);
            this._tryToPlayTimeout = null;
        }
        if (this._audioUnlockedObserver) {
            (0, $dUFoQ.AbstractEngine).audioEngine?.onAudioUnlockedObservable.remove(this._audioUnlockedObserver);
            this._audioUnlockedObserver = null;
        }
    }
}
/**
 * @internal
 */ $c204841fc2d888eb$export$85990f0f98a390bb._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("AudioSceneComponent");
};
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.Sound", $c204841fc2d888eb$export$85990f0f98a390bb);



var $ejQPp = parcelRequire("ejQPp");

var $dUFoQ = parcelRequire("dUFoQ");
class $f14bc9e38480ee3f$export$a652c0a9bcc18c16 {
    /**
     * Creates a new sound track.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#using-sound-tracks
     * @param scene Define the scene the sound track belongs to
     * @param options
     */ constructor(scene, options = {}){
        /**
         * The unique identifier of the sound track in the scene.
         */ this.id = -1;
        this._isInitialized = false;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        this.soundCollection = [];
        this._options = options;
        if (!this._options.mainTrack && this._scene.soundTracks) {
            this._scene.soundTracks.push(this);
            this.id = this._scene.soundTracks.length - 1;
        }
    }
    _initializeSoundTrackAudioGraph() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && (0, $dUFoQ.AbstractEngine).audioEngine.audioContext) {
            this._outputAudioNode = (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.createGain();
            this._outputAudioNode.connect((0, $dUFoQ.AbstractEngine).audioEngine.masterGain);
            if (this._options) {
                if (this._options.volume) this._outputAudioNode.gain.value = this._options.volume;
            }
            this._isInitialized = true;
        }
    }
    /**
     * Release the sound track and its associated resources
     */ dispose() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine && (0, $dUFoQ.AbstractEngine).audioEngine.canUseWebAudio) {
            if (this._connectedAnalyser) this._connectedAnalyser.stopDebugCanvas();
            while(this.soundCollection.length)this.soundCollection[0].dispose();
            if (this._outputAudioNode) this._outputAudioNode.disconnect();
            this._outputAudioNode = null;
        }
    }
    /**
     * Adds a sound to this sound track
     * @param sound define the sound to add
     * @ignoreNaming
     */ addSound(sound) {
        if (!this._isInitialized) this._initializeSoundTrackAudioGraph();
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._outputAudioNode) sound.connectToSoundTrackAudioNode(this._outputAudioNode);
        if (sound.soundTrackId !== undefined) {
            if (sound.soundTrackId === -1) this._scene.mainSoundTrack.removeSound(sound);
            else if (this._scene.soundTracks) this._scene.soundTracks[sound.soundTrackId].removeSound(sound);
        }
        this.soundCollection.push(sound);
        sound.soundTrackId = this.id;
    }
    /**
     * Removes a sound to this sound track
     * @param sound define the sound to remove
     * @ignoreNaming
     */ removeSound(sound) {
        const index = this.soundCollection.indexOf(sound);
        if (index !== -1) this.soundCollection.splice(index, 1);
    }
    /**
     * Set a global volume for the full sound track.
     * @param newVolume Define the new volume of the sound track
     */ setVolume(newVolume) {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._outputAudioNode) this._outputAudioNode.gain.value = newVolume;
    }
    /**
     * Switch the panning model to HRTF:
     * Renders a stereo output of higher quality than equalpower — it uses a convolution with measured impulse responses from human subjects.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToHRTF() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio) for(let i = 0; i < this.soundCollection.length; i++)this.soundCollection[i].switchPanningModelToHRTF();
    }
    /**
     * Switch the panning model to Equal Power:
     * Represents the equal-power panning algorithm, generally regarded as simple and efficient. equalpower is the default value.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToEqualPower() {
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio) for(let i = 0; i < this.soundCollection.length; i++)this.soundCollection[i].switchPanningModelToEqualPower();
    }
    /**
     * Connect the sound track to an audio analyser allowing some amazing
     * synchronization between the sounds/music and your visualization (VuMeter for instance).
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#using-the-analyser
     * @param analyser The analyser to connect to the engine
     */ connectToAnalyser(analyser) {
        if (this._connectedAnalyser) this._connectedAnalyser.stopDebugCanvas();
        this._connectedAnalyser = analyser;
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio && this._outputAudioNode) {
            this._outputAudioNode.disconnect();
            this._connectedAnalyser.connectAudioNodes(this._outputAudioNode, (0, $dUFoQ.AbstractEngine).audioEngine.masterGain);
        }
    }
}



var $ha1VO = parcelRequire("ha1VO");

var $bv05l = parcelRequire("bv05l");

var $gmbCk = parcelRequire("gmbCk");
parcelRequire("iIwbj");

var $blHSI = parcelRequire("blHSI");

var $ejQPp = parcelRequire("ejQPp");

var $dUFoQ = parcelRequire("dUFoQ");
/**
 * Stores the list of available parsers in the application.
 */ const $97f0acfd91b6202c$var$_BabylonFileParsers = {};
/**
 * Stores the list of available individual parsers in the application.
 */ const $97f0acfd91b6202c$var$_IndividualBabylonFileParsers = {};
function $97f0acfd91b6202c$export$cc96a9211a5590a0(name, parser) {
    $97f0acfd91b6202c$var$_BabylonFileParsers[name] = parser;
}
function $97f0acfd91b6202c$export$1b070a2716a465af(name) {
    if ($97f0acfd91b6202c$var$_BabylonFileParsers[name]) return $97f0acfd91b6202c$var$_BabylonFileParsers[name];
    return null;
}
function $97f0acfd91b6202c$export$2b0cb82aecbf467a(name, parser) {
    $97f0acfd91b6202c$var$_IndividualBabylonFileParsers[name] = parser;
}
function $97f0acfd91b6202c$export$26657278d7472a0d(name) {
    if ($97f0acfd91b6202c$var$_IndividualBabylonFileParsers[name]) return $97f0acfd91b6202c$var$_IndividualBabylonFileParsers[name];
    return null;
}
function $97f0acfd91b6202c$export$29abf071d92c5cc2(jsonData, scene, container, rootUrl) {
    for(const parserName in $97f0acfd91b6202c$var$_BabylonFileParsers)if (Object.prototype.hasOwnProperty.call($97f0acfd91b6202c$var$_BabylonFileParsers, parserName)) $97f0acfd91b6202c$var$_BabylonFileParsers[parserName](jsonData, scene, container, rootUrl);
}


// Adds the parser to the scene parsers.
(0, $97f0acfd91b6202c$export$cc96a9211a5590a0)((0, $bv05l.SceneComponentConstants).NAME_AUDIO, (parsedData, scene, container, rootUrl)=>{
    // TODO: add sound
    let loadedSounds = [];
    let loadedSound;
    container.sounds = container.sounds || [];
    if (parsedData.sounds !== undefined && parsedData.sounds !== null) for(let index = 0, cache = parsedData.sounds.length; index < cache; index++){
        const parsedSound = parsedData.sounds[index];
        if ((0, $dUFoQ.AbstractEngine).audioEngine?.canUseWebAudio) {
            if (!parsedSound.url) parsedSound.url = parsedSound.name;
            if (!loadedSounds[parsedSound.url]) {
                loadedSound = (0, $c204841fc2d888eb$export$85990f0f98a390bb).Parse(parsedSound, scene, rootUrl);
                loadedSounds[parsedSound.url] = loadedSound;
                container.sounds.push(loadedSound);
            } else container.sounds.push((0, $c204841fc2d888eb$export$85990f0f98a390bb).Parse(parsedSound, scene, rootUrl, loadedSounds[parsedSound.url]));
        } else container.sounds.push(new (0, $c204841fc2d888eb$export$85990f0f98a390bb)(parsedSound.name, null, scene));
    }
    loadedSounds = [];
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "mainSoundTrack", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (!this._mainSoundTrack) this._mainSoundTrack = new (0, $f14bc9e38480ee3f$export$a652c0a9bcc18c16)(this, {
            mainTrack: true
        });
        return this._mainSoundTrack;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.getSoundByName = function(name) {
    let index;
    for(index = 0; index < this.mainSoundTrack.soundCollection.length; index++){
        if (this.mainSoundTrack.soundCollection[index].name === name) return this.mainSoundTrack.soundCollection[index];
    }
    if (this.soundTracks) {
        for(let sdIndex = 0; sdIndex < this.soundTracks.length; sdIndex++)for(index = 0; index < this.soundTracks[sdIndex].soundCollection.length; index++){
            if (this.soundTracks[sdIndex].soundCollection[index].name === name) return this.soundTracks[sdIndex].soundCollection[index];
        }
    }
    return null;
};
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioEnabled", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioEnabled;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value) compo.enableAudio();
        else compo.disableAudio();
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "headphone", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.headphone;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value) compo.switchAudioModeForHeadphones();
        else compo.switchAudioModeForNormalSpeakers();
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioListenerPositionProvider", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioListenerPositionProvider;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value && typeof value !== "function") throw new Error("The value passed to [Scene.audioListenerPositionProvider] must be a function that returns a Vector3");
        else compo.audioListenerPositionProvider = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioListenerRotationProvider", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioListenerRotationProvider;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value && typeof value !== "function") throw new Error("The value passed to [Scene.audioListenerRotationProvider] must be a function that returns a Vector3");
        else compo.audioListenerRotationProvider = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioPositioningRefreshRate", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioPositioningRefreshRate;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        compo.audioPositioningRefreshRate = value;
    },
    enumerable: true,
    configurable: true
});
class $d614fb81c5ef8408$export$45aa9da8559a72fa {
    /**
     * Gets whether audio is enabled or not.
     * Please use related enable/disable method to switch state.
     */ get audioEnabled() {
        return this._audioEnabled;
    }
    /**
     * Gets whether audio is outputting to headphone or not.
     * Please use the according Switch methods to change output.
     */ get headphone() {
        return this._headphone;
    }
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_AUDIO;
        this._audioEnabled = true;
        this._headphone = false;
        /**
         * Gets or sets a refresh rate when using 3D audio positioning
         */ this.audioPositioningRefreshRate = 500;
        /**
         * Gets or Sets a custom listener position for all sounds in the scene
         * By default, this is the position of the first active camera
         */ this.audioListenerPositionProvider = null;
        /**
         * Gets or Sets a custom listener rotation for all sounds in the scene
         * By default, this is the rotation of the first active camera
         */ this.audioListenerRotationProvider = null;
        this._cachedCameraDirection = new (0, $ha1VO.Vector3)();
        this._cachedCameraPosition = new (0, $ha1VO.Vector3)();
        this._lastCheck = 0;
        this._invertMatrixTemp = new (0, $ha1VO.Matrix)();
        this._cameraDirectionTemp = new (0, $ha1VO.Vector3)();
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this.scene = scene;
        scene.soundTracks = [];
        scene.sounds = [];
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._afterRenderStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDER_AUDIO, this, this._afterRender);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do here. (Not rendering related)
    }
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */ serialize(serializationObject) {
        serializationObject.sounds = [];
        if (this.scene.soundTracks) for(let index = 0; index < this.scene.soundTracks.length; index++){
            const soundtrack = this.scene.soundTracks[index];
            for(let soundId = 0; soundId < soundtrack.soundCollection.length; soundId++)serializationObject.sounds.push(soundtrack.soundCollection[soundId].serialize());
        }
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ addFromContainer(container) {
        if (!container.sounds) return;
        container.sounds.forEach((sound)=>{
            sound.play();
            sound.autoplay = true;
            this.scene.mainSoundTrack.addSound(sound);
        });
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ removeFromContainer(container, dispose = false) {
        if (!container.sounds) return;
        container.sounds.forEach((sound)=>{
            sound.stop();
            sound.autoplay = false;
            this.scene.mainSoundTrack.removeSound(sound);
            if (dispose) sound.dispose();
        });
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        const scene = this.scene;
        if (scene._mainSoundTrack) scene.mainSoundTrack.dispose();
        if (scene.soundTracks) for(let scIndex = 0; scIndex < scene.soundTracks.length; scIndex++)scene.soundTracks[scIndex].dispose();
    }
    /**
     * Disables audio in the associated scene.
     */ disableAudio() {
        const scene = this.scene;
        this._audioEnabled = false;
        if ((0, $dUFoQ.AbstractEngine).audioEngine && (0, $dUFoQ.AbstractEngine).audioEngine.audioContext) (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.suspend();
        let i;
        for(i = 0; i < scene.mainSoundTrack.soundCollection.length; i++)scene.mainSoundTrack.soundCollection[i].pause();
        if (scene.soundTracks) {
            for(i = 0; i < scene.soundTracks.length; i++)for(let j = 0; j < scene.soundTracks[i].soundCollection.length; j++)scene.soundTracks[i].soundCollection[j].pause();
        }
    }
    /**
     * Enables audio in the associated scene.
     */ enableAudio() {
        const scene = this.scene;
        this._audioEnabled = true;
        if ((0, $dUFoQ.AbstractEngine).audioEngine && (0, $dUFoQ.AbstractEngine).audioEngine.audioContext) (0, $dUFoQ.AbstractEngine).audioEngine.audioContext.resume();
        let i;
        for(i = 0; i < scene.mainSoundTrack.soundCollection.length; i++)if (scene.mainSoundTrack.soundCollection[i].isPaused) scene.mainSoundTrack.soundCollection[i].play();
        if (scene.soundTracks) for(i = 0; i < scene.soundTracks.length; i++){
            for(let j = 0; j < scene.soundTracks[i].soundCollection.length; j++)if (scene.soundTracks[i].soundCollection[j].isPaused) scene.soundTracks[i].soundCollection[j].play();
        }
    }
    /**
     * Switch audio to headphone output.
     */ switchAudioModeForHeadphones() {
        const scene = this.scene;
        this._headphone = true;
        scene.mainSoundTrack.switchPanningModelToHRTF();
        if (scene.soundTracks) for(let i = 0; i < scene.soundTracks.length; i++)scene.soundTracks[i].switchPanningModelToHRTF();
    }
    /**
     * Switch audio to normal speakers.
     */ switchAudioModeForNormalSpeakers() {
        const scene = this.scene;
        this._headphone = false;
        scene.mainSoundTrack.switchPanningModelToEqualPower();
        if (scene.soundTracks) for(let i = 0; i < scene.soundTracks.length; i++)scene.soundTracks[i].switchPanningModelToEqualPower();
    }
    _afterRender() {
        const now = (0, $blHSI.PrecisionDate).Now;
        if (this._lastCheck && now - this._lastCheck < this.audioPositioningRefreshRate) return;
        this._lastCheck = now;
        const scene = this.scene;
        if (!this._audioEnabled || !scene._mainSoundTrack || !scene.soundTracks || scene._mainSoundTrack.soundCollection.length === 0 && scene.soundTracks.length === 1) return;
        const audioEngine = (0, $dUFoQ.AbstractEngine).audioEngine;
        if (!audioEngine) return;
        if (audioEngine.audioContext) {
            let listeningCamera = scene.activeCamera;
            if (scene.activeCameras && scene.activeCameras.length > 0) listeningCamera = scene.activeCameras[0];
            // A custom listener position provider was set
            // Use the users provided position instead of camera's
            if (this.audioListenerPositionProvider) {
                const position = this.audioListenerPositionProvider();
                // Set the listener position
                audioEngine.audioContext.listener.setPosition(position.x || 0, position.y || 0, position.z || 0);
            // Check if there is a listening camera
            } else if (listeningCamera) // Set the listener position to the listening camera global position
            {
                if (!this._cachedCameraPosition.equals(listeningCamera.globalPosition)) {
                    this._cachedCameraPosition.copyFrom(listeningCamera.globalPosition);
                    audioEngine.audioContext.listener.setPosition(listeningCamera.globalPosition.x, listeningCamera.globalPosition.y, listeningCamera.globalPosition.z);
                }
            } else // Set the listener position
            audioEngine.audioContext.listener.setPosition(0, 0, 0);
            // A custom listener rotation provider was set
            // Use the users provided rotation instead of camera's
            if (this.audioListenerRotationProvider) {
                const rotation = this.audioListenerRotationProvider();
                audioEngine.audioContext.listener.setOrientation(rotation.x || 0, rotation.y || 0, rotation.z || 0, 0, 1, 0);
            // Check if there is a listening camera
            } else if (listeningCamera) {
                // for VR cameras
                if (listeningCamera.rigCameras && listeningCamera.rigCameras.length > 0) listeningCamera = listeningCamera.rigCameras[0];
                listeningCamera.getViewMatrix().invertToRef(this._invertMatrixTemp);
                (0, $ha1VO.Vector3).TransformNormalToRef($d614fb81c5ef8408$export$45aa9da8559a72fa._CameraDirection, this._invertMatrixTemp, this._cameraDirectionTemp);
                this._cameraDirectionTemp.normalize();
                // To avoid some errors on GearVR
                if (!isNaN(this._cameraDirectionTemp.x) && !isNaN(this._cameraDirectionTemp.y) && !isNaN(this._cameraDirectionTemp.z)) {
                    if (!this._cachedCameraDirection.equals(this._cameraDirectionTemp)) {
                        this._cachedCameraDirection.copyFrom(this._cameraDirectionTemp);
                        audioEngine.audioContext.listener.setOrientation(this._cameraDirectionTemp.x, this._cameraDirectionTemp.y, this._cameraDirectionTemp.z, 0, 1, 0);
                    }
                }
            } else // Set the listener position
            audioEngine.audioContext.listener.setOrientation(0, 0, 0, 0, 1, 0);
            let i;
            for(i = 0; i < scene.mainSoundTrack.soundCollection.length; i++){
                const sound = scene.mainSoundTrack.soundCollection[i];
                if (sound.useCustomAttenuation) sound.updateDistanceFromListener();
            }
            if (scene.soundTracks) {
                for(i = 0; i < scene.soundTracks.length; i++)for(let j = 0; j < scene.soundTracks[i].soundCollection.length; j++){
                    const sound = scene.soundTracks[i].soundCollection[j];
                    if (sound.useCustomAttenuation) sound.updateDistanceFromListener();
                }
            }
        }
    }
}
$d614fb81c5ef8408$export$45aa9da8559a72fa._CameraDirection = new (0, $ha1VO.Vector3)(0, 0, -1);
(0, $c204841fc2d888eb$export$85990f0f98a390bb)._SceneComponentInitialization = (scene)=>{
    let compo = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
    if (!compo) {
        compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(scene);
        scene._addComponent(compo);
    }
};


parcelRequire("iIwbj");

var $6578d05764c8afc8$exports = {};
var $acb3703f94fb96ce$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $acb3703f94fb96ce$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$ac2c42592aa05543$exports(collection)) {
            var iteratee = $5aba4f6d9f8304a3$exports(predicate, 3);
            collection = $08f0eaf3fbcb2fde$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$acb3703f94fb96ce$exports = $acb3703f94fb96ce$var$createFind;


var $90893b1abc59631b$exports = {};
var $a9e76203bd7c412f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$a9e76203bd7c412f$exports = $a9e76203bd7c412f$var$baseFindIndex;



var $20712de2064d78dd$exports = {};
var $6ceabe126a95a54e$exports = {};
var $dc614d828223dea6$exports = {};


/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $dc614d828223dea6$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6b5a5095e0934938$exports(value)) return $dc614d828223dea6$var$NAN;
    if ($f9ff2e983beb6b86$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f9ff2e983beb6b86$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($dc614d828223dea6$var$reTrim, '');
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
$dc614d828223dea6$exports = $dc614d828223dea6$var$toNumber;


/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $dc614d828223dea6$exports(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$6ceabe126a95a54e$exports = $6ceabe126a95a54e$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $6ceabe126a95a54e$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$20712de2064d78dd$exports = $20712de2064d78dd$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $90893b1abc59631b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $90893b1abc59631b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $20712de2064d78dd$exports(fromIndex);
    if (index < 0) index = $90893b1abc59631b$var$nativeMax(length + index, 0);
    return $a9e76203bd7c412f$exports(array, $5aba4f6d9f8304a3$exports(predicate, 3), index);
}
$90893b1abc59631b$exports = $90893b1abc59631b$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $6578d05764c8afc8$var$find = $acb3703f94fb96ce$exports($90893b1abc59631b$exports);
$6578d05764c8afc8$exports = $6578d05764c8afc8$var$find;



var $4170da19230619f0$exports = {};
$4170da19230619f0$exports = new URL("Fire-21.61410770.mp3", import.meta.url).toString();


var $a7c8c7b7529e0d62$exports = {};
$a7c8c7b7529e0d62$exports = new URL("Fire-4.1010d6b4.mp3", import.meta.url).toString();


var $74e9d32b6cfa50f4$exports = {};
$74e9d32b6cfa50f4$exports = new URL("Fire-18.122e26b5.mp3", import.meta.url).toString();


var $aaffc874ece33aa7$exports = {};
$aaffc874ece33aa7$exports = new URL("Fire-9.ce18cc11.mp3", import.meta.url).toString();


var $52ae2bbbfeb2b56c$exports = {};
$52ae2bbbfeb2b56c$exports = new URL("Fire-10.95d4b00d.mp3", import.meta.url).toString();


var $c7d7c59cc8786c3e$exports = {};
$c7d7c59cc8786c3e$exports = new URL("Fire-22.8eb7044e.mp3", import.meta.url).toString();


var $16548897164e1128$exports = {};
$16548897164e1128$exports = new URL("Fire-23.904f0cc2.mp3", import.meta.url).toString();


let $30018e00f2a92e4f$var$soundList = [
    {
        name: 'nebulaChange',
        volume: 0.8,
        needClone: false,
        loop: false,
        spatial: false,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($aaffc874ece33aa7$exports)))
    },
    {
        name: 'sunChange',
        volume: 0.3,
        needClone: false,
        loop: false,
        spatial: false,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4170da19230619f0$exports)))
    },
    {
        name: 'play',
        volume: 1,
        needClone: false,
        loop: false,
        spatial: false,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($52ae2bbbfeb2b56c$exports)))
    },
    {
        name: 'dead',
        volume: 0.6,
        needClone: false,
        loop: false,
        spatial: false,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($52ae2bbbfeb2b56c$exports)))
    },
    {
        name: 'catchPlanet',
        volume: 0.8,
        needClone: true,
        loop: false,
        spatial: false,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($16548897164e1128$exports)))
    },
    // { name: 'catchDust', volume: 0.06, needClone: true, loop: false, spatial: false, path: fire6 },
    {
        name: 'absorb',
        volume: 0.5,
        needClone: true,
        loop: true,
        spatial: true,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($c7d7c59cc8786c3e$exports)))
    },
    // { name: 'explodeStart', volume: 1, needClone: true, loop: false, spatial: true, path: fire6 },
    {
        name: 'explodeEnd',
        volume: 0.4,
        needClone: true,
        loop: false,
        spatial: true,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($a7c8c7b7529e0d62$exports)))
    },
    // { name: 'levelDown', volume: 0.5, needClone: false, loop: false, spatial: false, path: fire1 },
    // { name: 'levelUp', volume: 0.5, needClone: false, loop: false, spatial: false, path: fire1 },
    {
        name: 'accelerate',
        volume: 0.6,
        needClone: true,
        loop: false,
        spatial: true,
        path: (0, (/*@__PURE__*/$parcel$interopDefault($74e9d32b6cfa50f4$exports)))
    }
];
class $30018e00f2a92e4f$export$a62869ddf53aa3e3 {
    constructor(scene){
        this.Sounds = {};
        this.on = true;
        this.soundsPlaying = [];
        this.scene = scene;
        window.addEventListener('blur', ()=>{
            this.stopAllSounds();
        });
    }
    load() {
        // this.mainsound = new Sound('mainsound', asseturl + "sound/wazana.mp3", scene);
        for(let i = 0; i < $30018e00f2a92e4f$var$soundList.length; i++){
            const sound = $30018e00f2a92e4f$var$soundList[i];
            const { name: name, path: path, loop: loop, spatial: spatial } = sound;
            //! BJS Sounds does not work if there is a query in the path
            const pathWithoutQuery = path.split('?')[0];
            this.Sounds[name] = new (0, $c204841fc2d888eb$export$85990f0f98a390bb)(name, pathWithoutQuery, this.scene, null, {
                loop: loop
            });
        // this.Sounds[name].on
        }
    }
    setOn() {
        this.on = true;
    }
    setOff() {
        this.on = false;
        this.stopAllSounds();
    }
    play(sound) {
        if (!this.on) return null;
        return this.start(sound, 1);
    }
    playMesh(sound, mesh, volume) {
        if (!this.on) return null;
        let soundO = this.start(sound, volume || 1, mesh);
        if (mesh && soundO) {
            if (mesh.position) soundO.attachToMesh(mesh);
        }
        return soundO;
    }
    fadeIn(sound, time) {
        if (this.Sounds[sound] == undefined) return;
        let soundParam = (0, (/*@__PURE__*/$parcel$interopDefault($6578d05764c8afc8$exports)))($30018e00f2a92e4f$var$soundList, (s)=>{
            return s.name == sound;
        });
        this.Sounds[sound].play();
        this.Sounds[sound].setVolume(soundParam.volume, time || 2);
    }
    fadeOut(sound, time) {
        if (this.Sounds[sound] == undefined) return;
        this.Sounds[sound].setVolume(0, time || 2);
        setTimeout(()=>{
            this.Sounds[sound].stop();
        }, (time || 2) * 1000);
    }
    start(sound, volume, mesh) {
        let soundParam = (0, (/*@__PURE__*/$parcel$interopDefault($6578d05764c8afc8$exports)))($30018e00f2a92e4f$var$soundList, (s)=>{
            return s.name == sound;
        });
        let soundO;
        if (soundParam.needClone) soundO = this.Sounds[sound].clone();
        else soundO = this.Sounds[sound];
        soundO.setVolume(volume * soundParam.volume);
        soundO.play();
        this.soundsPlaying.push(soundO);
        return soundO;
    }
    stop(sound, soundO) {
        soundO.stop();
        (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.soundsPlaying, (s)=>{
            return s == soundO;
        });
        let soundParam = (0, (/*@__PURE__*/$parcel$interopDefault($6578d05764c8afc8$exports)))($30018e00f2a92e4f$var$soundList, (s)=>{
            return s.name == sound;
        });
        if (soundParam.needClone) soundO.dispose();
    }
    stopAllSounds() {
        for(let i = 0; i < this.soundsPlaying.length; i++){
            const soundO = this.soundsPlaying[i];
            soundO.stop();
        }
        this.soundsPlaying = [];
    }
}


class $19190f008fbf8981$export$1cd65882cd591ad1 extends (0, $9612821352bbabe0$export$efcc5cd87cfb9a73) {
    constructor(canvas){
        super(canvas);
        this.addHeart();
        this.addDustMesh();
        this.addUpperDustMesh();
        this.addPlanetMesh();
        this.soundManager = new (0, $30018e00f2a92e4f$export$a62869ddf53aa3e3)(this.scene);
    }
    addDustMesh() {
        this.dustMaterial = this.getNewDustMaterial();
        this.dustMaterial.emissiveColor = new (0, $7etnY.Color3)(1, 1, 0);
        this.dustMesh = this.getNewDust();
        this.dustMesh.material = this.dustMaterial;
    }
    addUpperDustMesh() {
        this.upperDustMaterial = this.getNewDustMaterial();
        this.upperDustMaterial.emissiveColor = new (0, $7etnY.Color3)(1, 1, 1);
        this.upperDustMesh = this.getNewDust();
        this.upperDustMesh.material = this.upperDustMaterial;
        this.upperDustMesh.scaling = new (0, $ha1VO.Vector3)(0.2, 0.2, 0.2);
    }
    getNewDust() {
        // this.mesh = MeshBuilder.CreateIcoSphere(this.key + "star", { radius: 1, flat: true, subdivisions: 2 }, this.system.scene);
        // this.mesh.isBlocker = false;
        let dustMesh = (0, $9b72f98286da73ed$export$b65e9a89c410ca15).CreateSphere("dust", {
            diameter: 1
        }, this.scene);
        dustMesh.alwaysSelectAsActiveMesh = true;
        dustMesh.doNotSyncBoundingInfo = true;
        dustMesh.isVisible = false;
        return dustMesh;
    }
    getNewDustMaterial() {
        let dustMaterial = new (0, $c14168b02f7bcc00$export$cb949309547a0dd7)("dustMaterial1", this.scene);
        dustMaterial.maxSimultaneousLights = 0;
        dustMaterial.diffuseColor = (0, $7etnY.Color3).Black();
        dustMaterial.specularColor = (0, $7etnY.Color3).Black();
        return dustMaterial;
    }
    addHeart() {
        // this.heart = MeshBuilder.CreateIcoSphere(this.key + "star", { radius: 1, flat: true, subdivisions: 2 }, this.system.scene);
        this.heart = (0, $9b72f98286da73ed$export$b65e9a89c410ca15).CreateSphere("heart", {
            diameter: 2.8
        }, this.scene);
        // Not always active as we check if heart in frustrum for opti
        this.heart.alwaysSelectAsActiveMesh = true;
        this.heart.doNotSyncBoundingInfo = true;
        this.heart.isBlocker = false;
        this.heart.isVisible = false;
        this.heartMaterial = new (0, $c14168b02f7bcc00$export$cb949309547a0dd7)("heartMaterial", this.scene);
        this.heartMaterial.backFaceCulling = false;
        this.heartMaterial.maxSimultaneousLights = 0;
    // console.log(this.heartMaterial);
    // this.system.starGlowLayer.addIncludedOnlyMesh(this.heart);
    }
    addPlanetMesh() {
        // this.planetMesh = MeshBuilder.CreatePolyhedron("surface", { type: 2, size: 0.5 }, this.scene);
        this.planetMesh = new (0, $ad89493dfaad9a4d$export$c56dffd5b07e66bc)("planet", this.scene);
        // Not always active as we check if star in frustrum for opti
        this.planetMesh.alwaysSelectAsActiveMesh = true;
        this.planetMesh.doNotSyncBoundingInfo = true;
        this.planetMesh.isBlocker = false;
        this.planetMesh.isVisible = false;
        this.planetMaterial = new (0, $c14168b02f7bcc00$export$cb949309547a0dd7)("planetMaterial", this.scene);
        // this.planetMaterial.wireframe = true;
        this.planetMaterial.emissiveColor = new (0, $7etnY.Color3)(1, 1, 1);
        this.planetMaterial.emissiveFresnelParameters = new (0, $08f87ed26b8946a4$export$ead2cdea5a43d2d2)();
        this.planetMaterial.emissiveFresnelParameters.power = 1;
        this.planetMaterial.disableLighting = true;
        this.planetMesh.material = this.planetMaterial;
    }
    unfreezeMaterials() {
        // for (let i = 0; i < this.scene.materials.length; i++) {
        //     const material = this.scene.materials[i];
        //     material.unfreeze();
        // }
        this.dustMaterial.unfreeze();
        this.planetMaterial.unfreeze();
        this.ribbonMaterial.unfreeze();
    }
    freezeMaterials() {
        // for (let i = 0; i < this.scene.materials.length; i++) {
        //     const material = this.scene.materials[i];
        //     material.freeze();
        // }
        this.dustMaterial.freeze();
        this.planetMaterial.freeze();
        this.ribbonMaterial.freeze();
    }
    checkMaterials() {
        // Freeze all material to have better performance
        this.unfreezeMaterials();
        this.freezeMaterials();
    // setTimeout(() => {
    //     this.freezeMaterials();
    // }, 100);
    }
}



var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");

var $cfkw4 = parcelRequire("cfkw4");
/**
 * Gather the list of clipboard event types as constants.
 */ class $69c5a2609ea6c722$export$1b8ff22bd0e43412 {
}
/**
 * The clipboard event is fired when a copy command is active (pressed).
 */ $69c5a2609ea6c722$export$1b8ff22bd0e43412.COPY = 0x01; //
/**
 *  The clipboard event is fired when a cut command is active (pressed).
 */ $69c5a2609ea6c722$export$1b8ff22bd0e43412.CUT = 0x02;
/**
 * The clipboard event is fired when a paste command is active (pressed).
 */ $69c5a2609ea6c722$export$1b8ff22bd0e43412.PASTE = 0x03;
class $69c5a2609ea6c722$export$738268be25b46e31 {
    /**
     *Creates an instance of ClipboardInfo.
     * @param type Defines the type of event (BABYLON.ClipboardEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (BABYLON.ClipboardEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        this.type = type;
        this.event = event;
    }
    /**
     *  Get the clipboard event's type from the keycode.
     * @param keyCode Defines the keyCode for the current keyboard event.
     * @returns {number}
     */ static GetTypeFromCharacter(keyCode) {
        const charCode = keyCode;
        //TODO: add codes for extended ASCII
        switch(charCode){
            case 67:
                return $69c5a2609ea6c722$export$1b8ff22bd0e43412.COPY;
            case 86:
                return $69c5a2609ea6c722$export$1b8ff22bd0e43412.PASTE;
            case 88:
                return $69c5a2609ea6c722$export$1b8ff22bd0e43412.CUT;
            default:
                return -1;
        }
    }
}



var $bcFoB = parcelRequire("bcFoB");

var $j2mX5 = parcelRequire("j2mX5");

var $kVtWi = parcelRequire("kVtWi");

var $j2mX5 = parcelRequire("j2mX5");

var $wK2xc = parcelRequire("wK2xc");

var $2h5JR = parcelRequire("2h5JR");

var $b9e4a = parcelRequire("b9e4a");
(0, $2h5JR.ThinEngine).prototype.createDynamicTexture = function(width, height, generateMipMaps, samplingMode) {
    const texture = new (0, $b9e4a.InternalTexture)(this, 4 /* InternalTextureSource.Dynamic */ );
    texture.baseWidth = width;
    texture.baseHeight = height;
    if (generateMipMaps) {
        width = this.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(width, this._caps.maxTextureSize) : width;
        height = this.needPOTTextures ? (0, $wK2xc.GetExponentOfTwo)(height, this._caps.maxTextureSize) : height;
    }
    //  this.resetTextureCache();
    texture.width = width;
    texture.height = height;
    texture.isReady = false;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    this.updateTextureSamplingMode(samplingMode, texture);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.updateDynamicTexture = function(texture, source, invertY, premulAlpha = false, format, forceBindTexture = false, // eslint-disable-next-line @typescript-eslint/no-unused-vars
allowGPUOptimization = false) {
    if (!texture) return;
    const gl = this._gl;
    const target = gl.TEXTURE_2D;
    const wasPreviouslyBound = this._bindTextureDirectly(target, texture, true, forceBindTexture);
    this._unpackFlipY(invertY === undefined ? texture.invertY : invertY);
    if (premulAlpha) gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 1);
    const textureType = this._getWebGLTextureType(texture.type);
    const glformat = this._getInternalFormat(format ? format : texture.format);
    const internalFormat = this._getRGBABufferInternalSizedFormat(texture.type, glformat);
    gl.texImage2D(target, 0, internalFormat, glformat, textureType, source);
    if (texture.generateMipMaps) gl.generateMipmap(target);
    if (!wasPreviouslyBound) this._bindTextureDirectly(target, null);
    if (premulAlpha) gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
    if (format) texture.format = format;
    texture._dynamicTextureSource = source;
    texture._premulAlpha = premulAlpha;
    texture.invertY = invertY || false;
    texture.isReady = true;
};


class $b7371b076ec25b92$export$da80c28953472f54 extends (0, $j2mX5.Texture) {
    /** @internal */ constructor(name, canvasOrSize, sceneOrOptions, generateMipMaps = false, samplingMode = 3, format = 5, invertY){
        const isScene = !sceneOrOptions || sceneOrOptions._isScene;
        const scene = isScene ? sceneOrOptions : sceneOrOptions?.scene;
        const noMipmap = isScene ? !generateMipMaps : sceneOrOptions;
        super(null, scene, noMipmap, invertY, samplingMode, undefined, undefined, undefined, undefined, format);
        this.name = name;
        this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._generateMipMaps = generateMipMaps;
        const engine = this._getEngine();
        if (!engine) return;
        if (canvasOrSize.getContext) {
            this._canvas = canvasOrSize;
            this._ownCanvas = false;
            this._texture = engine.createDynamicTexture(this._canvas.width, this._canvas.height, generateMipMaps, samplingMode);
        } else {
            this._canvas = engine.createCanvas(1, 1);
            this._ownCanvas = true;
            const optionsAsSize = canvasOrSize;
            if (optionsAsSize.width || optionsAsSize.width === 0) this._texture = engine.createDynamicTexture(optionsAsSize.width, optionsAsSize.height, generateMipMaps, samplingMode);
            else this._texture = engine.createDynamicTexture(canvasOrSize, canvasOrSize, generateMipMaps, samplingMode);
        }
        const textureSize = this.getSize();
        if (this._canvas.width !== textureSize.width) this._canvas.width = textureSize.width;
        if (this._canvas.height !== textureSize.height) this._canvas.height = textureSize.height;
        this._context = this._canvas.getContext("2d");
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "DynamicTexture"
     */ getClassName() {
        return "DynamicTexture";
    }
    /**
     * Gets the current state of canRescale
     */ get canRescale() {
        return true;
    }
    _recreate(textureSize) {
        this._canvas.width = textureSize.width;
        this._canvas.height = textureSize.height;
        this.releaseInternalTexture();
        this._texture = this._getEngine().createDynamicTexture(textureSize.width, textureSize.height, this._generateMipMaps, this.samplingMode);
    }
    /**
     * Scales the texture
     * @param ratio the scale factor to apply to both width and height
     */ scale(ratio) {
        const textureSize = this.getSize();
        textureSize.width *= ratio;
        textureSize.height *= ratio;
        this._recreate(textureSize);
    }
    /**
     * Resizes the texture
     * @param width the new width
     * @param height the new height
     */ scaleTo(width, height) {
        const textureSize = this.getSize();
        textureSize.width = width;
        textureSize.height = height;
        this._recreate(textureSize);
    }
    /**
     * Gets the context of the canvas used by the texture
     * @returns the canvas context of the dynamic texture
     */ getContext() {
        return this._context;
    }
    /**
     * Clears the texture
     * @param clearColor Defines the clear color to use
     */ clear(clearColor) {
        const size = this.getSize();
        if (clearColor) this._context.fillStyle = clearColor;
        this._context.clearRect(0, 0, size.width, size.height);
    }
    /**
     * Updates the texture
     * @param invertY defines the direction for the Y axis (default is true - y increases downwards)
     * @param premulAlpha defines if alpha is stored as premultiplied (default is false)
     * @param allowGPUOptimization true to allow some specific GPU optimizations (subject to engine feature "allowGPUOptimizationsForGUI" being true)
     */ update(invertY, premulAlpha = false, allowGPUOptimization = false) {
        this._getEngine().updateDynamicTexture(this._texture, this._canvas, invertY === undefined ? true : invertY, premulAlpha, this._format || undefined, undefined, allowGPUOptimization);
    }
    /**
     * Draws text onto the texture
     * @param text defines the text to be drawn
     * @param x defines the placement of the text from the left
     * @param y defines the placement of the text from the top when invertY is true and from the bottom when false
     * @param font defines the font to be used with font-style, font-size, font-name
     * @param color defines the color used for the text
     * @param fillColor defines the color for the canvas, use null to not overwrite canvas (this bleands with the background to replace, use the clear function)
     * @param invertY defines the direction for the Y axis (default is true - y increases downwards)
     * @param update defines whether texture is immediately update (default is true)
     */ drawText(text, x, y, font, color, fillColor, invertY, update = true) {
        const size = this.getSize();
        if (fillColor) {
            this._context.fillStyle = fillColor;
            this._context.fillRect(0, 0, size.width, size.height);
        }
        this._context.font = font;
        if (x === null || x === undefined) {
            const textSize = this._context.measureText(text);
            x = (size.width - textSize.width) / 2;
        }
        if (y === null || y === undefined) {
            const fontSize = parseInt(font.replace(/\D/g, ""));
            y = size.height / 2 + fontSize / 3.65;
        }
        this._context.fillStyle = color || "";
        this._context.fillText(text, x, y);
        if (update) this.update(invertY);
    }
    /**
     * Disposes the dynamic texture.
     */ dispose() {
        super.dispose();
        if (this._ownCanvas) this._canvas?.remove?.();
        this._canvas = null;
        this._context = null;
    }
    /**
     * Clones the texture
     * @returns the clone of the texture.
     */ clone() {
        const scene = this.getScene();
        if (!scene) return this;
        const textureSize = this.getSize();
        const newTexture = new $b7371b076ec25b92$export$da80c28953472f54(this.name, textureSize, scene, this._generateMipMaps);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // Dynamic Texture
        newTexture.wrapU = this.wrapU;
        newTexture.wrapV = this.wrapV;
        return newTexture;
    }
    /**
     * Serializes the dynamic texture.  The scene should be ready before the dynamic texture is serialized
     * @returns a serialized dynamic texture object
     */ serialize() {
        const scene = this.getScene();
        if (scene && !scene.isReady()) (0, $kVtWi.Logger).Warn("The scene must be ready before serializing the dynamic texture");
        const serializationObject = super.serialize();
        if ($b7371b076ec25b92$export$da80c28953472f54._IsCanvasElement(this._canvas)) serializationObject.base64String = this._canvas.toDataURL();
        serializationObject.invertY = this._invertY;
        serializationObject.samplingMode = this.samplingMode;
        return serializationObject;
    }
    static _IsCanvasElement(canvas) {
        return canvas.toDataURL !== undefined;
    }
    /** @internal */ _rebuild() {
        this.update();
    }
}



var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $ejQPp = parcelRequire("ejQPp");

var $b4i1f = parcelRequire("b4i1f");


var $j2mX5 = parcelRequire("j2mX5");

var $bv05l = parcelRequire("bv05l");

var $bv05l = parcelRequire("bv05l");

var $ejQPp = parcelRequire("ejQPp");
class $3b88994aee31475a$export$98912974b6a8e94a {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_LAYER;
        this.scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this.scene) return;
        this._engine = this.scene.getEngine();
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERADRAW_LAYER, this, this._drawCameraBackground);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_LAYER, this, this._drawCameraForegroundWithPostProcessing);
        this.scene._afterCameraPostProcessStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERAPOSTPROCESS_LAYER, this, this._drawCameraForegroundWithoutPostProcessing);
        this.scene._beforeRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERTARGETDRAW_LAYER, this, this._drawRenderTargetBackground);
        this.scene._afterRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERTARGETDRAW_LAYER, this, this._drawRenderTargetForegroundWithPostProcessing);
        this.scene._afterRenderTargetPostProcessStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERTARGETPOSTPROCESS_LAYER, this, this._drawRenderTargetForegroundWithoutPostProcessing);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        const layers = this.scene.layers;
        for (const layer of layers)layer._rebuild();
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        const layers = this.scene.layers;
        while(layers.length)layers[0].dispose();
    }
    _draw(predicate) {
        const layers = this.scene.layers;
        if (layers.length) {
            this._engine.setDepthBuffer(false);
            for (const layer of layers)if (predicate(layer)) layer.render();
            this._engine.setDepthBuffer(true);
        }
    }
    _drawCameraPredicate(layer, isBackground, applyPostProcess, cameraLayerMask) {
        return !layer.renderOnlyInRenderTargetTextures && layer.isBackground === isBackground && layer.applyPostProcess === applyPostProcess && (layer.layerMask & cameraLayerMask) !== 0;
    }
    _drawCameraBackground(camera) {
        this._draw((layer)=>{
            return this._drawCameraPredicate(layer, true, true, camera.layerMask);
        });
    }
    _drawCameraForegroundWithPostProcessing(camera) {
        this._draw((layer)=>{
            return this._drawCameraPredicate(layer, false, true, camera.layerMask);
        });
    }
    _drawCameraForegroundWithoutPostProcessing(camera) {
        this._draw((layer)=>{
            return this._drawCameraPredicate(layer, false, false, camera.layerMask);
        });
    }
    _drawRenderTargetPredicate(layer, isBackground, applyPostProcess, cameraLayerMask, renderTargetTexture) {
        return layer.renderTargetTextures.length > 0 && layer.isBackground === isBackground && layer.applyPostProcess === applyPostProcess && layer.renderTargetTextures.indexOf(renderTargetTexture) > -1 && (layer.layerMask & cameraLayerMask) !== 0;
    }
    _drawRenderTargetBackground(renderTarget) {
        this._draw((layer)=>{
            return this._drawRenderTargetPredicate(layer, true, true, this.scene.activeCamera.layerMask, renderTarget);
        });
    }
    _drawRenderTargetForegroundWithPostProcessing(renderTarget) {
        this._draw((layer)=>{
            return this._drawRenderTargetPredicate(layer, false, true, this.scene.activeCamera.layerMask, renderTarget);
        });
    }
    _drawRenderTargetForegroundWithoutPostProcessing(renderTarget) {
        this._draw((layer)=>{
            return this._drawRenderTargetPredicate(layer, false, false, this.scene.activeCamera.layerMask, renderTarget);
        });
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ addFromContainer(container) {
        if (!container.layers) return;
        container.layers.forEach((layer)=>{
            this.scene.layers.push(layer);
        });
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ removeFromContainer(container, dispose = false) {
        if (!container.layers) return;
        container.layers.forEach((layer)=>{
            const index = this.scene.layers.indexOf(layer);
            if (index !== -1) this.scene.layers.splice(index, 1);
            if (dispose) layer.dispose();
        });
    }
}



var $hOyoX = parcelRequire("hOyoX");




class $601908f1c5e3fa9a$export$936d0764594b6eb3 {
    /**
     * Determines if the layer is drawn before (true) or after (false) post-processing.
     * If the layer is background, it is always before.
     */ set applyPostProcess(value) {
        this._applyPostProcess = value;
    }
    get applyPostProcess() {
        return this.isBackground || this._applyPostProcess;
    }
    /**
     * Back compatibility with callback before the onDisposeObservable existed.
     * The set callback will be triggered when the layer has been disposed.
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * Back compatibility with callback before the onBeforeRenderObservable existed.
     * The set callback will be triggered just before rendering the layer.
     */ set onBeforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /**
     * Back compatibility with callback before the onAfterRenderObservable existed.
     * The set callback will be triggered just after rendering the layer.
     */ set onAfterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /**
     * Gets the shader language used in this material.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * Instantiates a new layer.
     * This represents a full screen 2d layer.
     * This can be useful to display a picture in the  background of your scene for instance.
     * @see https://www.babylonjs-playground.com/#08A2BS#1
     * @param name Define the name of the layer in the scene
     * @param imgUrl Define the url of the texture to display in the layer
     * @param scene Define the scene the layer belongs to
     * @param isBackground Defines whether the layer is displayed in front or behind the scene
     * @param color Defines a color for the layer
     * @param forceGLSL Use the GLSL code generation for the shader (even on WebGPU). Default is false
     */ constructor(/**
     * Define the name of the layer.
     */ name, imgUrl, scene, isBackground, color, forceGLSL = false){
        this.name = name;
        this._applyPostProcess = true;
        /**
         * Define the scale of the layer in order to zoom in out of the texture.
         */ this.scale = new (0, $ha1VO.Vector2)(1, 1);
        /**
         * Define an offset for the layer in order to shift the texture.
         */ this.offset = new (0, $ha1VO.Vector2)(0, 0);
        /**
         * Define the alpha blending mode used in the layer in case the texture or color has an alpha.
         */ this.alphaBlendingMode = 2;
        /**
         * Define a mask to restrict the layer to only some of the scene cameras.
         */ this.layerMask = 0x0fffffff;
        /**
         * Define the list of render target the layer is visible into.
         */ this.renderTargetTextures = [];
        /**
         * Define if the layer is only used in renderTarget or if it also
         * renders in the main frame buffer of the canvas.
         */ this.renderOnlyInRenderTargetTextures = false;
        /**
         * Define if the colors of the layer should be generated in linear space (default: false)
         */ this.convertToLinearSpace = false;
        /**
         * Define if the layer is enabled (ie. should be displayed). Default: true
         */ this.isEnabled = true;
        this._vertexBuffers = {};
        /**
         * An event triggered when the layer is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering the scene
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the scene
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        /** Shader language used by the material */ this._shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
        this._shadersLoaded = false;
        this.texture = imgUrl ? new (0, $j2mX5.Texture)(imgUrl, scene, true) : null;
        this.isBackground = isBackground === undefined ? true : isBackground;
        this.color = color === undefined ? new (0, $7etnY.Color4)(1, 1, 1, 1) : color;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        const engine = this._scene.getEngine();
        if (engine.isWebGPU && !forceGLSL && !$601908f1c5e3fa9a$export$936d0764594b6eb3.ForceGLSL) this._shaderLanguage = 1 /* ShaderLanguage.WGSL */ ;
        let layerComponent = this._scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_LAYER);
        if (!layerComponent) {
            layerComponent = new (0, $3b88994aee31475a$export$98912974b6a8e94a)(this._scene);
            this._scene._addComponent(layerComponent);
        }
        this._scene.layers.push(this);
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(engine);
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        const vertexBuffer = new (0, $b4i1f.VertexBuffer)(engine, vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = vertexBuffer;
        this._createIndexBuffer();
    }
    _createIndexBuffer() {
        const engine = this._scene.getEngine();
        // Indices
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = engine.createIndexBuffer(indices);
    }
    /** @internal */ _rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vb) vb._rebuild();
        this._createIndexBuffer();
    }
    /**
     * Checks if the layer is ready to be rendered
     * @returns true if the layer is ready. False otherwise.
     */ isReady() {
        const engine = this._scene.getEngine();
        let defines = "";
        if (this.alphaTest) defines = "#define ALPHATEST";
        if (this.texture) {
            if (this.texture.gammaSpace) {
                if (this.convertToLinearSpace) defines += "\n#define CONVERT_TO_LINEAR";
            } else if (!this.convertToLinearSpace) defines += "\n#define CONVERT_TO_GAMMA";
        }
        if (this._previousDefines !== defines) {
            this._previousDefines = defines;
            this._drawWrapper.effect = engine.createEffect("layer", [
                (0, $b4i1f.VertexBuffer).PositionKind
            ], [
                "textureMatrix",
                "color",
                "scale",
                "offset"
            ], [
                "textureSampler"
            ], defines, undefined, undefined, undefined, undefined, this._shaderLanguage, this._shadersLoaded ? undefined : async ()=>{
                if (this._shaderLanguage === 1 /* ShaderLanguage.WGSL */ ) await Promise.all([
                    (parcelRequire("bUtXH")),
                    (parcelRequire("k3U9J"))
                ]);
                else await Promise.all([
                    (parcelRequire("jkCXV")),
                    (parcelRequire("6ZPCO"))
                ]);
                this._shadersLoaded = true;
            });
        }
        const currentEffect = this._drawWrapper.effect;
        return !!currentEffect?.isReady() && (!this.texture || this.texture.isReady());
    }
    /**
     * Renders the layer in the scene.
     */ render() {
        if (!this.isEnabled) return;
        const engine = this._scene.getEngine();
        // Check
        if (!this.isReady()) return;
        const currentEffect = this._drawWrapper.effect;
        this.onBeforeRenderObservable.notifyObservers(this);
        // Render
        engine.enableEffect(this._drawWrapper);
        engine.setState(false);
        // Texture
        if (this.texture) {
            currentEffect.setTexture("textureSampler", this.texture);
            currentEffect.setMatrix("textureMatrix", this.texture.getTextureMatrix());
        }
        // Color
        currentEffect.setFloat4("color", this.color.r, this.color.g, this.color.b, this.color.a);
        // Scale / offset
        currentEffect.setVector2("offset", this.offset);
        currentEffect.setVector2("scale", this.scale);
        // VBOs
        engine.bindBuffers(this._vertexBuffers, this._indexBuffer, currentEffect);
        // Draw order
        if (!this.alphaTest) {
            engine.setAlphaMode(this.alphaBlendingMode);
            engine.drawElementsType((0, $3afee756ef198914$export$a2d8b23205c25948).TriangleFillMode, 0, 6);
            engine.setAlphaMode(0);
        } else engine.drawElementsType((0, $3afee756ef198914$export$a2d8b23205c25948).TriangleFillMode, 0, 6);
        this.onAfterRenderObservable.notifyObservers(this);
    }
    /**
     * Disposes and releases the associated resources.
     */ dispose() {
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer) {
            this._scene.getEngine()._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        if (this.texture) {
            this.texture.dispose();
            this.texture = null;
        }
        // Clean RTT list
        this.renderTargetTextures = [];
        // Remove from scene
        const index = this._scene.layers.indexOf(this);
        this._scene.layers.splice(index, 1);
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onBeforeRenderObservable.clear();
    }
}
/**
 * Force all the layers to compile to glsl even on WebGPU engines.
 * False by default. This is mostly meant for backward compatibility.
 */ $601908f1c5e3fa9a$export$936d0764594b6eb3.ForceGLSL = false;



var $e0Suo = parcelRequire("e0Suo");

var $kVtWi = parcelRequire("kVtWi");

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $cfkw4 = parcelRequire("cfkw4");

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");
class $a038095510e5ba9b$export$839f347a6ebe19f5 {
    /**
     * Creates a new ValueAndUnit
     * @param value defines the value to store
     * @param unit defines the unit to store - defaults to ValueAndUnit.UNITMODE_PIXEL
     * @param negativeValueAllowed defines a boolean indicating if the value can be negative
     */ constructor(value, /** defines the unit to store */ unit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL, /** defines a boolean indicating if the value can be negative */ negativeValueAllowed = true){
        this.negativeValueAllowed = negativeValueAllowed;
        this._value = 1;
        this._unit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL;
        /**
         * Gets or sets a value indicating that this value will not scale accordingly with adaptive scaling property
         * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
         */ this.ignoreAdaptiveScaling = false;
        /**
         * Observable event triggered each time the value or unit changes
         */ this.onChangedObservable = new (0, $diGQf.Observable)();
        this._value = value;
        this._unit = unit;
        this._originalUnit = unit;
    }
    /** Gets a boolean indicating if the value is a percentage */ get isPercentage() {
        return this._unit === $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE;
    }
    /** Gets a boolean indicating if the value is store as pixel */ get isPixel() {
        return this._unit === $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL;
    }
    /**
     * Gets value (without units)
     * @deprecated use value property instead
     */ get internalValue() {
        return this._value;
    }
    /** Gets value (without units) */ get value() {
        return this._value;
    }
    /** Sets value (without units) */ set value(value) {
        if (value !== this._value) {
            this._value = value;
            this.onChangedObservable.notifyObservers();
        }
    }
    /** Gets units (without value) */ get unit() {
        return this._unit;
    }
    /** Sets units (without value) */ set unit(value) {
        if (value !== this._unit) {
            this._unit = value;
            this.onChangedObservable.notifyObservers();
        }
    }
    /**
     * Gets value as pixel
     * @param host defines the root host
     * @param refValue defines the reference value for percentages
     * @returns the value as pixel
     */ getValueInPixel(host, refValue) {
        if (this.isPixel) return this.getValue(host);
        return this.getValue(host) * refValue;
    }
    /**
     * Update the current value and unit.
     * @param value defines the value to store
     * @param unit defines the unit to store
     * @returns the current ValueAndUnit
     */ updateInPlace(value, unit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL) {
        if (this.value !== value || this.unit !== unit) {
            // set member variables to notify only once
            this._value = value;
            this._unit = unit;
            this.onChangedObservable.notifyObservers();
        }
        return this;
    }
    /**
     * Gets the value accordingly to its unit
     * @param host  defines the root host
     * @returns the value
     */ getValue(host) {
        if (host && !this.ignoreAdaptiveScaling && this.unit !== $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE) {
            let width = 0;
            let height = 0;
            if (host.idealWidth) width = Math.ceil(this._value * host.getSize().width / host.idealWidth);
            if (host.idealHeight) height = Math.ceil(this._value * host.getSize().height / host.idealHeight);
            if (host.useSmallestIdeal && host.idealWidth && host.idealHeight) return window.innerWidth < window.innerHeight ? width : height;
            if (host.idealWidth) // horizontal
            return width;
            if (host.idealHeight) // vertical
            return height;
        }
        return this._value;
    }
    /**
     * Gets a string representation of the value
     * @param host defines the root host
     * @param decimals defines an optional number of decimals to display
     * @returns a string
     */ toString(host, decimals) {
        switch(this._unit){
            case $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE:
                {
                    const percentage = this.getValue(host) * 100;
                    return (decimals ? percentage.toFixed(decimals) : percentage) + "%";
                }
            case $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL:
                {
                    const pixels = this.getValue(host);
                    return (decimals ? pixels.toFixed(decimals) : pixels) + "px";
                }
        }
        return this._unit.toString();
    }
    /**
     * Store a value parsed from a string
     * @param source defines the source string
     * @returns true if the value was successfully parsed and updated
     */ fromString(source) {
        const match = $a038095510e5ba9b$export$839f347a6ebe19f5._Regex.exec(source.toString());
        if (!match || match.length === 0) return false;
        let sourceValue = parseFloat(match[1]);
        let sourceUnit = this._originalUnit;
        if (!this.negativeValueAllowed) {
            if (sourceValue < 0) sourceValue = 0;
        }
        if (match.length === 4) switch(match[3]){
            case "px":
                sourceUnit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL;
                break;
            case "%":
                sourceUnit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE;
                sourceValue /= 100.0;
                break;
        }
        if (sourceValue === this._value && sourceUnit === this._unit) return false;
        this._value = sourceValue;
        this._unit = sourceUnit;
        this.onChangedObservable.notifyObservers();
        return true;
    }
    /** UNITMODE_PERCENTAGE */ static get UNITMODE_PERCENTAGE() {
        return $a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PERCENTAGE;
    }
    /** UNITMODE_PIXEL */ static get UNITMODE_PIXEL() {
        return $a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PIXEL;
    }
}
// Static
$a038095510e5ba9b$export$839f347a6ebe19f5._Regex = /(^-?\d*(\.\d+)?)(%|px)?/;
$a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PERCENTAGE = 0;
$a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PIXEL = 1;



var $ha1VO = parcelRequire("ha1VO");
const $fc6a12d4b9dc7831$var$tmpRect = [
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0)
];
const $fc6a12d4b9dc7831$var$tmpRect2 = [
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0)
];
const $fc6a12d4b9dc7831$var$tmpV1 = new (0, $ha1VO.Vector2)(0, 0);
const $fc6a12d4b9dc7831$var$tmpV2 = new (0, $ha1VO.Vector2)(0, 0);
class $fc6a12d4b9dc7831$export$76df7375f104822f {
    /**
     * Creates a new measure
     * @param left defines left coordinate
     * @param top defines top coordinate
     * @param width defines width dimension
     * @param height defines height dimension
     */ constructor(/** defines left coordinate */ left, /** defines top coordinate  */ top, /** defines width dimension  */ width, /** defines height dimension */ height){
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    /**
     * Copy from another measure
     * @param other defines the other measure to copy from
     */ copyFrom(other) {
        this.left = other.left;
        this.top = other.top;
        this.width = other.width;
        this.height = other.height;
    }
    /**
     * Copy from a group of 4 floats
     * @param left defines left coordinate
     * @param top defines top coordinate
     * @param width defines width dimension
     * @param height defines height dimension
     */ copyFromFloats(left, top, width, height) {
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    /**
     * Computes the axis aligned bounding box measure for two given measures
     * @param a Input measure
     * @param b Input measure
     * @param result the resulting bounding measure
     */ static CombineToRef(a, b, result) {
        const left = Math.min(a.left, b.left);
        const top = Math.min(a.top, b.top);
        const right = Math.max(a.left + a.width, b.left + b.width);
        const bottom = Math.max(a.top + a.height, b.top + b.height);
        result.left = left;
        result.top = top;
        result.width = right - left;
        result.height = bottom - top;
    }
    /**
     * Computes the axis aligned bounding box of the measure after it is modified by a given transform
     * @param transform the matrix to transform the measure before computing the AABB
     * @param addX number to add to left
     * @param addY number to add to top
     * @param addWidth number to add to width
     * @param addHeight number to add to height
     * @param result the resulting AABB
     */ addAndTransformToRef(transform, addX, addY, addWidth, addHeight, result) {
        const left = this.left + addX;
        const top = this.top + addY;
        const width = this.width + addWidth;
        const height = this.height + addHeight;
        $fc6a12d4b9dc7831$var$tmpRect[0].copyFromFloats(left, top);
        $fc6a12d4b9dc7831$var$tmpRect[1].copyFromFloats(left + width, top);
        $fc6a12d4b9dc7831$var$tmpRect[2].copyFromFloats(left + width, top + height);
        $fc6a12d4b9dc7831$var$tmpRect[3].copyFromFloats(left, top + height);
        $fc6a12d4b9dc7831$var$tmpV1.copyFromFloats(Number.MAX_VALUE, Number.MAX_VALUE);
        $fc6a12d4b9dc7831$var$tmpV2.copyFromFloats(0, 0);
        for(let i = 0; i < 4; i++){
            transform.transformCoordinates($fc6a12d4b9dc7831$var$tmpRect[i].x, $fc6a12d4b9dc7831$var$tmpRect[i].y, $fc6a12d4b9dc7831$var$tmpRect2[i]);
            $fc6a12d4b9dc7831$var$tmpV1.x = Math.floor(Math.min($fc6a12d4b9dc7831$var$tmpV1.x, $fc6a12d4b9dc7831$var$tmpRect2[i].x));
            $fc6a12d4b9dc7831$var$tmpV1.y = Math.floor(Math.min($fc6a12d4b9dc7831$var$tmpV1.y, $fc6a12d4b9dc7831$var$tmpRect2[i].y));
            $fc6a12d4b9dc7831$var$tmpV2.x = Math.ceil(Math.max($fc6a12d4b9dc7831$var$tmpV2.x, $fc6a12d4b9dc7831$var$tmpRect2[i].x));
            $fc6a12d4b9dc7831$var$tmpV2.y = Math.ceil(Math.max($fc6a12d4b9dc7831$var$tmpV2.y, $fc6a12d4b9dc7831$var$tmpRect2[i].y));
        }
        result.left = $fc6a12d4b9dc7831$var$tmpV1.x;
        result.top = $fc6a12d4b9dc7831$var$tmpV1.y;
        result.width = $fc6a12d4b9dc7831$var$tmpV2.x - $fc6a12d4b9dc7831$var$tmpV1.x;
        result.height = $fc6a12d4b9dc7831$var$tmpV2.y - $fc6a12d4b9dc7831$var$tmpV1.y;
    }
    /**
     * Computes the axis aligned bounding box of the measure after it is modified by a given transform
     * @param transform the matrix to transform the measure before computing the AABB
     * @param result the resulting AABB
     */ transformToRef(transform, result) {
        this.addAndTransformToRef(transform, 0, 0, 0, 0, result);
    }
    /**
     * Check equality between this measure and another one
     * @param other defines the other measures
     * @returns true if both measures are equals
     */ isEqualsTo(other) {
        if (this.left !== other.left) return false;
        if (this.top !== other.top) return false;
        if (this.width !== other.width) return false;
        if (this.height !== other.height) return false;
        return true;
    }
    /**
     * Creates an empty measure
     * @returns a new measure
     */ static Empty() {
        return new $fc6a12d4b9dc7831$export$76df7375f104822f(0, 0, 0, 0);
    }
}



var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");
class $e2393c5f4672a478$export$b71b64568b3d7bf8 extends (0, $ha1VO.Vector2) {
    /**
     * Creates a new Vector2WithInfo
     * @param source defines the vector2 data to transport
     * @param buttonIndex defines the current mouse button index
     */ constructor(source, /** defines the current mouse button index */ buttonIndex = 0){
        super(source.x, source.y);
        this.buttonIndex = buttonIndex;
    }
}
class $e2393c5f4672a478$export$26e6ecd136a15474 {
    /**
     * Creates a new matrix
     * @param m00 defines value for (0, 0)
     * @param m01 defines value for (0, 1)
     * @param m10 defines value for (1, 0)
     * @param m11 defines value for (1, 1)
     * @param m20 defines value for (2, 0)
     * @param m21 defines value for (2, 1)
     */ constructor(m00, m01, m10, m11, m20, m21){
        /** Gets the internal array of 6 floats used to store matrix data */ this.m = new Float32Array(6);
        this.fromValues(m00, m01, m10, m11, m20, m21);
    }
    /**
     * Fills the matrix from direct values
     * @param m00 defines value for (0, 0)
     * @param m01 defines value for (0, 1)
     * @param m10 defines value for (1, 0)
     * @param m11 defines value for (1, 1)
     * @param m20 defines value for (2, 0)
     * @param m21 defines value for (2, 1)
     * @returns the current modified matrix
     */ fromValues(m00, m01, m10, m11, m20, m21) {
        this.m[0] = m00;
        this.m[1] = m01;
        this.m[2] = m10;
        this.m[3] = m11;
        this.m[4] = m20;
        this.m[5] = m21;
        return this;
    }
    /**
     * Gets matrix determinant
     * @returns the determinant
     */ determinant() {
        return this.m[0] * this.m[3] - this.m[1] * this.m[2];
    }
    /**
     * Inverses the matrix and stores it in a target matrix
     * @param result defines the target matrix
     * @returns the current matrix
     */ invertToRef(result) {
        const l0 = this.m[0];
        const l1 = this.m[1];
        const l2 = this.m[2];
        const l3 = this.m[3];
        const l4 = this.m[4];
        const l5 = this.m[5];
        const det = this.determinant();
        if (det < (0, $53VPf.Epsilon) * (0, $53VPf.Epsilon)) {
            result.m[0] = 0;
            result.m[1] = 0;
            result.m[2] = 0;
            result.m[3] = 0;
            result.m[4] = 0;
            result.m[5] = 0;
            return this;
        }
        const detDiv = 1 / det;
        const det4 = l2 * l5 - l3 * l4;
        const det5 = l1 * l4 - l0 * l5;
        result.m[0] = l3 * detDiv;
        result.m[1] = -l1 * detDiv;
        result.m[2] = -l2 * detDiv;
        result.m[3] = l0 * detDiv;
        result.m[4] = det4 * detDiv;
        result.m[5] = det5 * detDiv;
        return this;
    }
    /**
     * Multiplies the current matrix with another one
     * @param other defines the second operand
     * @param result defines the target matrix
     * @returns the current matrix
     */ multiplyToRef(other, result) {
        const l0 = this.m[0];
        const l1 = this.m[1];
        const l2 = this.m[2];
        const l3 = this.m[3];
        const l4 = this.m[4];
        const l5 = this.m[5];
        const r0 = other.m[0];
        const r1 = other.m[1];
        const r2 = other.m[2];
        const r3 = other.m[3];
        const r4 = other.m[4];
        const r5 = other.m[5];
        result.m[0] = l0 * r0 + l1 * r2;
        result.m[1] = l0 * r1 + l1 * r3;
        result.m[2] = l2 * r0 + l3 * r2;
        result.m[3] = l2 * r1 + l3 * r3;
        result.m[4] = l4 * r0 + l5 * r2 + r4;
        result.m[5] = l4 * r1 + l5 * r3 + r5;
        return this;
    }
    /**
     * Applies the current matrix to a set of 2 floats and stores the result in a vector2
     * @param x defines the x coordinate to transform
     * @param y defines the x coordinate to transform
     * @param result defines the target vector2
     * @returns the current matrix
     */ transformCoordinates(x, y, result) {
        result.x = x * this.m[0] + y * this.m[2] + this.m[4];
        result.y = x * this.m[1] + y * this.m[3] + this.m[5];
        return this;
    }
    // Statics
    /**
     * Creates an identity matrix
     * @returns a new matrix
     */ static Identity() {
        return new $e2393c5f4672a478$export$26e6ecd136a15474(1, 0, 0, 1, 0, 0);
    }
    /**
     * Creates an identity matrix and stores it in a target matrix
     * @param result defines the target matrix
     */ static IdentityToRef(result) {
        result.m[0] = 1;
        result.m[1] = 0;
        result.m[2] = 0;
        result.m[3] = 1;
        result.m[4] = 0;
        result.m[5] = 0;
    }
    /**
     * Creates a translation matrix and stores it in a target matrix
     * @param x defines the x coordinate of the translation
     * @param y defines the y coordinate of the translation
     * @param result defines the target matrix
     */ static TranslationToRef(x, y, result) {
        result.fromValues(1, 0, 0, 1, x, y);
    }
    /**
     * Creates a scaling matrix and stores it in a target matrix
     * @param x defines the x coordinate of the scaling
     * @param y defines the y coordinate of the scaling
     * @param result defines the target matrix
     */ static ScalingToRef(x, y, result) {
        result.fromValues(x, 0, 0, y, 0, 0);
    }
    /**
     * Creates a rotation matrix and stores it in a target matrix
     * @param angle defines the rotation angle
     * @param result defines the target matrix
     */ static RotationToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        result.fromValues(c, s, -s, c, 0, 0);
    }
    /**
     * Composes a matrix from translation, rotation, scaling and parent matrix and stores it in a target matrix
     * @param tx defines the x coordinate of the translation
     * @param ty defines the y coordinate of the translation
     * @param angle defines the rotation angle
     * @param scaleX defines the x coordinate of the scaling
     * @param scaleY defines the y coordinate of the scaling
     * @param parentMatrix defines the parent matrix to multiply by (can be null)
     * @param result defines the target matrix
     */ static ComposeToRef(tx, ty, angle, scaleX, scaleY, parentMatrix, result) {
        $e2393c5f4672a478$export$26e6ecd136a15474.TranslationToRef(tx, ty, $e2393c5f4672a478$export$26e6ecd136a15474._TempPreTranslationMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474.ScalingToRef(scaleX, scaleY, $e2393c5f4672a478$export$26e6ecd136a15474._TempScalingMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474.RotationToRef(angle, $e2393c5f4672a478$export$26e6ecd136a15474._TempRotationMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474.TranslationToRef(-tx, -ty, $e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474._TempPreTranslationMatrix.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempScalingMatrix, $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose0);
        $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose0.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempRotationMatrix, $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1);
        if (parentMatrix) {
            $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix, $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose2);
            $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose2.multiplyToRef(parentMatrix, result);
        } else $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix, result);
    }
}
$e2393c5f4672a478$export$26e6ecd136a15474._TempPreTranslationMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempRotationMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempScalingMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempCompose0 = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1 = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempCompose2 = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
class $e2393c5f4672a478$export$65fca0bb37409f64 {
    /**
     * Rounds a number to the nearest multiple of a given precision
     * @param value the value to be rounded
     * @param precision the multiple to which the value will be rounded. Default is 100 (2 decimal digits)
     * @returns
     */ static Round(value, precision = $e2393c5f4672a478$export$65fca0bb37409f64.DefaultRoundingPrecision) {
        return Math.round(value * precision) / precision;
    }
}
/**
 * Default rounding precision for GUI elements. It should be
 * set to a power of ten, where the exponent means the number
 * of decimal digits to round to, i.e, 100 means 2 decimal digits,
 * 1000 means 3 decimal digits, etc. Default is 100 (2 decimal digits).
 */ $e2393c5f4672a478$export$65fca0bb37409f64.DefaultRoundingPrecision = 100;



var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $ejQPp = parcelRequire("ejQPp");
class $b6009490051f50fb$export$7a7fa4424cb20976 {
    /**
     * Gets or sets a boolean indicating if the control is readonly (default: false).
     * A readonly control will still raise pointer events but will not react to them
     */ get isReadOnly() {
        return this._isReadOnly;
    }
    set isReadOnly(value) {
        this._isReadOnly = value;
    }
    /**
     * Gets the transformed measure, that is the bounding box of the control after applying all transformations
     */ get transformedMeasure() {
        return this._evaluatedMeasure;
    }
    /**
     * Sets/Gets a boolean indicating if the children are clipped to the current control bounds.
     * Please note that not clipping children may generate issues with adt.useInvalidateRectOptimization so it is recommended to turn this optimization off if you want to use unclipped children
     */ set clipChildren(value) {
        this._clipChildren = value;
    }
    get clipChildren() {
        return this._clipChildren;
    }
    /**
     * Sets/Gets a boolean indicating that control content must be clipped
     * Please note that not clipping content may generate issues with adt.useInvalidateRectOptimization so it is recommended to turn this optimization off if you want to use unclipped children
     */ set clipContent(value) {
        this._clipContent = value;
    }
    get clipContent() {
        return this._clipContent;
    }
    /** Gets or sets a value indicating the offset to apply on X axis to render the shadow */ get shadowOffsetX() {
        return this._shadowOffsetX;
    }
    set shadowOffsetX(value) {
        if (this._shadowOffsetX === value) return;
        this._shadowOffsetX = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the offset to apply on Y axis to render the shadow */ get shadowOffsetY() {
        return this._shadowOffsetY;
    }
    set shadowOffsetY(value) {
        if (this._shadowOffsetY === value) return;
        this._shadowOffsetY = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the amount of blur to use to render the shadow */ get shadowBlur() {
        return this._shadowBlur;
    }
    set shadowBlur(value) {
        if (this._shadowBlur === value) return;
        this._previousShadowBlur = this._shadowBlur;
        this._shadowBlur = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the color of the shadow (black by default ie. "#000") */ get shadowColor() {
        return this._shadowColor;
    }
    set shadowColor(value) {
        if (this._shadowColor === value) return;
        this._shadowColor = value;
        this._markAsDirty();
    }
    // Properties
    /** Gets the control type name */ get typeName() {
        return this._getTypeName();
    }
    /**
     * Get the current class name of the control.
     * @returns current class name
     */ getClassName() {
        return this._getTypeName();
    }
    /**
     * Gets or sets the accessibility tag to describe the control for accessibility purpose.
     * By default, GUI controls already indicate accessibility info, but one can override the info using this tag.
     */ set accessibilityTag(value) {
        this._accessibilityTag = value;
        this.onAccessibilityTagChangedObservable.notifyObservers(value);
    }
    get accessibilityTag() {
        return this._accessibilityTag;
    }
    /**
     * Get the hosting AdvancedDynamicTexture
     */ get host() {
        return this._host;
    }
    /** Gets or set information about font offsets (used to render and align text) */ get fontOffset() {
        return this._fontOffset;
    }
    set fontOffset(offset) {
        this._fontOffset = offset;
    }
    /** Gets or sets alpha value for the control (1 means opaque and 0 means entirely transparent) */ get alpha() {
        return this._alpha;
    }
    set alpha(value) {
        if (this._alpha === value) return;
        this._alphaSet = true;
        this._alpha = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a number indicating size of stroke we want to highlight the control with (mostly for debugging purpose)
     */ get highlightLineWidth() {
        return this._highlightLineWidth;
    }
    set highlightLineWidth(value) {
        if (this._highlightLineWidth === value) return;
        this._highlightLineWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating that we want to highlight the control (mostly for debugging purpose)
     */ get isHighlighted() {
        return this._isHighlighted;
    }
    set isHighlighted(value) {
        if (this._isHighlighted === value) return;
        this._isHighlighted = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a string defining the color to use for highlighting this control
     */ get highlightColor() {
        return this._highlightColor;
    }
    set highlightColor(value) {
        if (this._highlightColor === value) return;
        this._highlightColor = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the scale factor on X axis (1 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get scaleX() {
        return this._scaleX;
    }
    set scaleX(value) {
        if (this._scaleX === value) return;
        this._scaleX = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets a value indicating the scale factor on Y axis (1 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get scaleY() {
        return this._scaleY;
    }
    set scaleY(value) {
        if (this._scaleY === value) return;
        this._scaleY = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets the rotation angle (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation === value) return;
        this._rotation = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets the transformation center on Y axis (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get transformCenterY() {
        return this._transformCenterY;
    }
    set transformCenterY(value) {
        if (this._transformCenterY === value) return;
        this._transformCenterY = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets the transformation center on X axis (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get transformCenterX() {
        return this._transformCenterX;
    }
    set transformCenterX(value) {
        if (this._transformCenterX === value) return;
        this._transformCenterX = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /**
     * Gets or sets the horizontal alignment
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#alignments
     */ get horizontalAlignment() {
        return this._horizontalAlignment;
    }
    set horizontalAlignment(value) {
        if (this._horizontalAlignment === value) return;
        this._horizontalAlignment = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the vertical alignment
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#alignments
     */ get verticalAlignment() {
        return this._verticalAlignment;
    }
    set verticalAlignment(value) {
        if (this._verticalAlignment === value) return;
        this._verticalAlignment = value;
        this._markAsDirty();
    }
    set fixedRatio(value) {
        if (this._fixedRatio === value) return;
        this._fixedRatio = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a fixed ratio for this control.
     * When different from 0, the ratio is used to compute the "second" dimension.
     * The first dimension used in the computation is the last one set (by setting width / widthInPixels or height / heightInPixels), and the
     * second dimension is computed as first dimension * fixedRatio
     */ get fixedRatio() {
        return this._fixedRatio;
    }
    set fixedRatioMasterIsWidth(value) {
        if (this._fixedRatioMasterIsWidth === value) return;
        this._fixedRatioMasterIsWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating that the fixed ratio is set on the width instead of the height. True by default.
     * When the height of a control is set, this property is changed to false.
     */ get fixedRatioMasterIsWidth() {
        return this._fixedRatioMasterIsWidth;
    }
    /**
     * Gets or sets control width
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get width() {
        return this._width.toString(this._host);
    }
    set width(value) {
        this._fixedRatioMasterIsWidth = true;
        if (this._width.toString(this._host) === value) return;
        if (this._width.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets the control width in pixel
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get widthInPixels() {
        return this._width.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set widthInPixels(value) {
        if (isNaN(value)) return;
        this._fixedRatioMasterIsWidth = true;
        this.width = value + "px";
    }
    /**
     * Gets or sets control height
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get height() {
        return this._height.toString(this._host);
    }
    set height(value) {
        this._fixedRatioMasterIsWidth = false;
        if (this._height.toString(this._host) === value) return;
        if (this._height.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets control height in pixel
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get heightInPixels() {
        return this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set heightInPixels(value) {
        if (isNaN(value)) return;
        this._fixedRatioMasterIsWidth = false;
        this.height = value + "px";
    }
    /** Gets or set font family */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this._resetFontCache();
    }
    /** Gets or sets font style */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value;
        this._resetFontCache();
    }
    /** Gets or sets font weight */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this._resetFontCache();
    }
    /**
     * Gets or sets style
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#styles
     */ get style() {
        return this._style;
    }
    set style(value) {
        if (this._style) {
            this._style.onChangedObservable.remove(this._styleObserver);
            this._styleObserver = null;
        }
        this._style = value;
        if (this._style) this._styleObserver = this._style.onChangedObservable.add(()=>{
            this._markAsDirty();
            this._resetFontCache();
        });
        this._markAsDirty();
        this._resetFontCache();
    }
    /** @internal */ get _isFontSizeInPercentage() {
        return this._fontSize.isPercentage;
    }
    /** Gets or sets font size in pixels */ get fontSizeInPixels() {
        const fontSizeToUse = this._style ? this._style._fontSize : this._fontSize;
        if (fontSizeToUse.isPixel) return fontSizeToUse.getValue(this._host);
        return fontSizeToUse.getValueInPixel(this._host, this._tempParentMeasure.height || this._cachedParentMeasure.height);
    }
    set fontSizeInPixels(value) {
        if (isNaN(value)) return;
        this.fontSize = value + "px";
    }
    /** Gets or sets font size */ get fontSize() {
        return this._fontSize.toString(this._host);
    }
    set fontSize(value) {
        if (this._fontSize.toString(this._host) === value) return;
        if (this._fontSize.fromString(value)) {
            this._markAsDirty();
            this._resetFontCache();
        }
    }
    /** Gets or sets foreground color */ get color() {
        return this._color;
    }
    set color(value) {
        if (this._color === value) return;
        this._color = value;
        this._markAsDirty();
    }
    /** Gets or sets gradient. Setting a gradient will override the color */ get gradient() {
        return this._gradient;
    }
    set gradient(value) {
        if (this._gradient === value) return;
        this._gradient = value;
        this._markAsDirty();
    }
    /** Gets or sets z index which is used to reorder controls on the z axis */ get zIndex() {
        return this._zIndex;
    }
    set zIndex(value) {
        if (this.zIndex === value) return;
        this._zIndex = value;
        if (this.parent) this.parent._reOrderControl(this);
    }
    /** Gets or sets a boolean indicating if the control can be rendered */ get notRenderable() {
        return this._doNotRender;
    }
    set notRenderable(value) {
        if (this._doNotRender === value) return;
        this._doNotRender = value;
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the control is visible */ get isVisible() {
        return this._isVisible;
    }
    set isVisible(value) {
        if (this._isVisible === value) return;
        this._isVisible = value;
        this._markAsDirty(true);
        this.onIsVisibleChangedObservable.notifyObservers(value);
    }
    /** Gets a boolean indicating that the control needs to update its rendering */ get isDirty() {
        return this._isDirty;
    }
    /**
     * Gets the current linked mesh (or null if none)
     */ get linkedMesh() {
        return this._linkedMesh;
    }
    /**
     * Gets or sets a value indicating the padding should work like in CSS.
     * Basically, it will add the padding amount on each side of the parent control for its children.
     */ get descendantsOnlyPadding() {
        return this._descendantsOnlyPadding;
    }
    set descendantsOnlyPadding(value) {
        if (this._descendantsOnlyPadding === value) return;
        this._descendantsOnlyPadding = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding to use on the left of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingLeft() {
        return this._paddingLeft.toString(this._host);
    }
    set paddingLeft(value) {
        if (this._paddingLeft.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the left of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingLeftInPixels() {
        return this._paddingLeft.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set paddingLeftInPixels(value) {
        if (isNaN(value)) return;
        this.paddingLeft = value + "px";
    }
    /** @internal */ get _paddingLeftInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingLeftInPixels;
    }
    /**
     * Gets or sets a value indicating the padding to use on the right of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingRight() {
        return this._paddingRight.toString(this._host);
    }
    set paddingRight(value) {
        if (this._paddingRight.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the right of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingRightInPixels() {
        return this._paddingRight.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set paddingRightInPixels(value) {
        if (isNaN(value)) return;
        this.paddingRight = value + "px";
    }
    /** @internal */ get _paddingRightInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingRightInPixels;
    }
    /**
     * Gets or sets a value indicating the padding to use on the top of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingTop() {
        return this._paddingTop.toString(this._host);
    }
    set paddingTop(value) {
        if (this._paddingTop.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the top of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingTopInPixels() {
        return this._paddingTop.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set paddingTopInPixels(value) {
        if (isNaN(value)) return;
        this.paddingTop = value + "px";
    }
    /** @internal */ get _paddingTopInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingTopInPixels;
    }
    /**
     * Gets or sets a value indicating the padding to use on the bottom of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingBottom() {
        return this._paddingBottom.toString(this._host);
    }
    set paddingBottom(value) {
        if (this._paddingBottom.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the bottom of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingBottomInPixels() {
        return this._paddingBottom.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set paddingBottomInPixels(value) {
        if (isNaN(value)) return;
        this.paddingBottom = value + "px";
    }
    /** @internal */ get _paddingBottomInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingBottomInPixels;
    }
    /**
     * Gets or sets a value indicating the left coordinate of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get left() {
        return this._left.toString(this._host);
    }
    set left(value) {
        if (this._left.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the left coordinate in pixels of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get leftInPixels() {
        return this._left.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set leftInPixels(value) {
        if (isNaN(value)) return;
        this.left = value + "px";
    }
    /**
     * Gets or sets a value indicating the top coordinate of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get top() {
        return this._top.toString(this._host);
    }
    set top(value) {
        if (this._top.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the top coordinate in pixels of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get topInPixels() {
        return this._top.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set topInPixels(value) {
        if (isNaN(value)) return;
        this.top = value + "px";
    }
    /**
     * Gets or sets a value indicating the offset on X axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetX() {
        return this._linkOffsetX.toString(this._host);
    }
    set linkOffsetX(value) {
        if (this._linkOffsetX.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the offset in pixels on X axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetXInPixels() {
        return this._linkOffsetX.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set linkOffsetXInPixels(value) {
        if (isNaN(value)) return;
        this.linkOffsetX = value + "px";
    }
    /**
     * Gets or sets a value indicating the offset on Y axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetY() {
        return this._linkOffsetY.toString(this._host);
    }
    set linkOffsetY(value) {
        if (this._linkOffsetY.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the offset in pixels on Y axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetYInPixels() {
        return this._linkOffsetY.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set linkOffsetYInPixels(value) {
        if (isNaN(value)) return;
        this.linkOffsetY = value + "px";
    }
    /** Gets the center coordinate on X axis */ get centerX() {
        return this._currentMeasure.left + this._currentMeasure.width / 2;
    }
    /** Gets the center coordinate on Y axis */ get centerY() {
        return this._currentMeasure.top + this._currentMeasure.height / 2;
    }
    /** Gets or sets if control is Enabled */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        this._markAsDirty();
        // if this control or any of it's descendants are under a pointer, we need to fire a pointerOut event
        const recursivelyFirePointerOut = (control)=>{
            if (!control.host) return;
            for(const pointer in control.host._lastControlOver)if (control === this.host._lastControlOver[pointer]) {
                control._onPointerOut(control, null, true);
                delete control.host._lastControlOver[pointer];
            }
            if (control.children !== undefined) control.children.forEach(recursivelyFirePointerOut);
        };
        recursivelyFirePointerOut(this);
        this.onEnabledStateChangedObservable.notifyObservers(value);
    }
    /** Gets or sets background color of control if it's disabled. Only applies to Button class. */ get disabledColor() {
        return this._disabledColor;
    }
    set disabledColor(value) {
        if (this._disabledColor === value) return;
        this._disabledColor = value;
        this._markAsDirty();
    }
    /** Gets or sets front color of control if it's disabled. Only applies to Checkbox class. */ get disabledColorItem() {
        return this._disabledColorItem;
    }
    set disabledColorItem(value) {
        if (this._disabledColorItem === value) return;
        this._disabledColorItem = value;
        this._markAsDirty();
    }
    /**
     * Border color when control is focused
     * When not defined the ADT color will be used. If no ADT color is defined, focused state won't have any border
     */ get focusedColor() {
        return this._focusedColor;
    }
    set focusedColor(value) {
        this._focusedColor = value;
    }
    /** @internal */ onBlur() {
        if (this._isFocused) {
            this._isFocused = false;
            if (this.focusedColor && this._unfocusedColor != null) // Set color back to saved unfocused color
            this.color = this._unfocusedColor;
            this.onBlurObservable.notifyObservers(this);
        }
    }
    /** @internal */ onFocus() {
        this._isFocused = true;
        if (this.focusedColor) {
            // Save the unfocused color
            this._unfocusedColor = this.color;
            this.color = this.focusedColor;
        }
        this.onFocusObservable.notifyObservers(this);
    }
    /**
     * Function called to get the list of controls that should not steal the focus from this control
     * @returns an array of controls
     */ keepsFocusWith() {
        return null;
    }
    /**
     * Function to focus a button programmatically
     */ focus() {
        this._host.moveFocusToControl(this);
    }
    /**
     * Function to unfocus a button programmatically
     */ blur() {
        this._host.focusedControl = null;
    }
    /**
     * Handles the keyboard event
     * @param evt Defines the KeyboardEvent
     */ processKeyboard(evt) {
        // if enter, trigger the new observable
        if (evt.key === "Enter") this.onEnterPressedObservable.notifyObservers(this);
        this.onKeyboardEventProcessedObservable.notifyObservers(evt, -1, this);
    }
    // Functions
    /**
     * Creates a new control
     * @param name defines the name of the control
     */ constructor(/** defines the name of the control */ name){
        this.name = name;
        this._alpha = 1;
        this._alphaSet = false;
        this._zIndex = 0;
        /** @internal */ this._currentMeasure = (0, $fc6a12d4b9dc7831$export$76df7375f104822f).Empty();
        /** @internal */ this._tempPaddingMeasure = (0, $fc6a12d4b9dc7831$export$76df7375f104822f).Empty();
        this._fontFamily = "";
        this._fontStyle = "";
        this._fontWeight = "";
        this._fontSize = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(18, (0, $a038095510e5ba9b$export$839f347a6ebe19f5).UNITMODE_PIXEL, false);
        /** @internal */ this._width = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(1, (0, $a038095510e5ba9b$export$839f347a6ebe19f5).UNITMODE_PERCENTAGE, false);
        /** @internal */ this._height = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(1, (0, $a038095510e5ba9b$export$839f347a6ebe19f5).UNITMODE_PERCENTAGE, false);
        this._color = "";
        this._style = null;
        /** @internal */ this._horizontalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_CENTER;
        /** @internal */ this._verticalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_CENTER;
        /** @internal */ this._isDirty = true;
        /** @internal */ this._wasDirty = false;
        /** @internal */ this._tempParentMeasure = (0, $fc6a12d4b9dc7831$export$76df7375f104822f).Empty();
        /** @internal */ this._prevCurrentMeasureTransformedIntoGlobalSpace = (0, $fc6a12d4b9dc7831$export$76df7375f104822f).Empty();
        /** @internal */ this._cachedParentMeasure = (0, $fc6a12d4b9dc7831$export$76df7375f104822f).Empty();
        this._descendantsOnlyPadding = false;
        this._paddingLeft = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._paddingRight = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._paddingTop = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._paddingBottom = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        /** @internal */ this._left = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        /** @internal */ this._top = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._scaleX = 1.0;
        this._scaleY = 1.0;
        this._rotation = 0;
        this._transformCenterX = 0.5;
        this._transformCenterY = 0.5;
        /** @internal */ this._transformMatrix = (0, $e2393c5f4672a478$export$26e6ecd136a15474).Identity();
        /** @internal */ this._invertTransformMatrix = (0, $e2393c5f4672a478$export$26e6ecd136a15474).Identity();
        /** @internal */ this._transformedPosition = (0, $ha1VO.Vector2).Zero();
        this._isMatrixDirty = true;
        this._isVisible = true;
        this._isHighlighted = false;
        this._highlightColor = "#4affff";
        this._highlightLineWidth = 2;
        this._fontSet = false;
        this._dummyVector2 = (0, $ha1VO.Vector2).Zero();
        this._downCount = 0;
        this._enterCount = -1;
        this._doNotRender = false;
        this._downPointerIds = {};
        this._evaluatedMeasure = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
        this._evaluatedParentMeasure = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
        this._isEnabled = true;
        this._disabledColor = "#9a9a9a";
        this._disabledColorItem = "#6a6a6a";
        this._isReadOnly = false;
        this._gradient = null;
        /** @internal */ this._rebuildLayout = false;
        /**
         * Observable that fires when the control's enabled state changes
         */ this.onEnabledStateChangedObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._customData = {};
        /** @internal */ this._isClipped = false;
        /** @internal */ this._automaticSize = false;
        /**
         * Gets or sets an object used to store user defined information for the node
         */ this.metadata = null;
        /** Gets or sets a boolean indicating if the control can be hit with pointer events */ this.isHitTestVisible = true;
        /** Gets or sets a boolean indicating if the control can block pointer events. False by default except on the following controls:
         * * Button controls (Button, RadioButton, ToggleButton)
         * * Checkbox
         * * ColorPicker
         * * InputText
         * * Slider
         */ this.isPointerBlocker = false;
        /** Gets or sets a boolean indicating if the control can be focusable */ this.isFocusInvisible = false;
        this._clipChildren = true;
        this._clipContent = true;
        /**
         * Gets or sets a boolean indicating that the current control should cache its rendering (useful when the control does not change often)
         */ this.useBitmapCache = false;
        this._shadowOffsetX = 0;
        this._shadowOffsetY = 0;
        this._shadowBlur = 0;
        this._previousShadowBlur = 0;
        this._shadowColor = "black";
        /** Gets or sets the cursor to use when the control is hovered */ this.hoverCursor = "";
        /** @internal */ this._linkOffsetX = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        /** @internal */ this._linkOffsetY = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._accessibilityTag = null;
        /**
         * Observable that fires whenever the accessibility event of the control has changed
         */ this.onAccessibilityTagChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when pointer wheel is scrolled
         */ this.onWheelObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the pointer moves over the control.
         */ this.onPointerMoveObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the pointer moves out of the control.
         */ this.onPointerOutObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the pointer taps the control
         */ this.onPointerDownObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when pointer up
         */ this.onPointerUpObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a control is clicked on
         */ this.onPointerClickObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a control receives an ENTER key down event
         */ this.onEnterPressedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when pointer enters the control
         */ this.onPointerEnterObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the control is marked as dirty
         */ this.onDirtyObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before drawing the control
         */ this.onBeforeDrawObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the control was drawn
         */ this.onAfterDrawObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the control has been disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the control isVisible is changed
         */ this.onIsVisibleChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Indicates if the control should be serialized. Defaults to true.
         */ this.isSerializable = true;
        this._fixedRatio = 0;
        this._fixedRatioMasterIsWidth = true;
        /**
         * Array of animations
         */ this.animations = null;
        // Focus functionality
        this._focusedColor = null;
        /**
         * The tab index of this control. -1 indicates this control is not part of the tab navigation.
         * A positive value indicates the order of the control in the tab navigation.
         * A value of 0 indicated the control will be focused after all controls with a positive index.
         * More than one control can have the same tab index and the navigation would then go through all controls with the same value in an order defined by the layout or the hierarchy.
         * The value can be changed at any time.
         * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
         */ this.tabIndex = -1;
        this._isFocused = false;
        this._unfocusedColor = null;
        /** Observable raised when the control gets the focus */ this.onFocusObservable = new (0, $diGQf.Observable)();
        /** Observable raised when the control loses the focus */ this.onBlurObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a key event was processed */ this.onKeyboardEventProcessedObservable = new (0, $diGQf.Observable)();
        this._tmpMeasureA = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
    }
    /** @internal */ _getTypeName() {
        return "Control";
    }
    /**
     * Gets the first ascendant in the hierarchy of the given type
     * @param className defines the required type
     * @returns the ascendant or null if not found
     */ getAscendantOfClass(className) {
        if (!this.parent) return null;
        if (this.parent.getClassName() === className) return this.parent;
        return this.parent.getAscendantOfClass(className);
    }
    /**
     * Mark control element as dirty
     * @param force force non visible elements to be marked too
     */ markAsDirty(force = false) {
        this._markAsDirty(force);
    }
    /**
     * Mark the element and its children as dirty
     */ markAllAsDirty() {
        this._markAllAsDirty();
    }
    /** @internal */ _resetFontCache() {
        this._fontSet = true;
        this._markAsDirty();
    }
    /**
     * Determines if a container is an ascendant of the current control
     * @param container defines the container to look for
     * @returns true if the container is one of the ascendant of the control
     */ isAscendant(container) {
        if (!this.parent) return false;
        if (this.parent === container) return true;
        return this.parent.isAscendant(container);
    }
    /**
     * Gets coordinates in local control space
     * @param globalCoordinates defines the coordinates to transform
     * @returns the new coordinates in local space
     */ getLocalCoordinates(globalCoordinates) {
        const result = (0, $ha1VO.Vector2).Zero();
        this.getLocalCoordinatesToRef(globalCoordinates, result);
        return result;
    }
    /**
     * Gets coordinates in local control space
     * @param globalCoordinates defines the coordinates to transform
     * @param result defines the target vector2 where to store the result
     * @returns the current control
     */ getLocalCoordinatesToRef(globalCoordinates, result) {
        result.x = globalCoordinates.x - this._currentMeasure.left;
        result.y = globalCoordinates.y - this._currentMeasure.top;
        return this;
    }
    /**
     * Gets coordinates in parent local control space
     * @param globalCoordinates defines the coordinates to transform
     * @returns the new coordinates in parent local space
     */ getParentLocalCoordinates(globalCoordinates) {
        const result = (0, $ha1VO.Vector2).Zero();
        result.x = globalCoordinates.x - this._cachedParentMeasure.left;
        result.y = globalCoordinates.y - this._cachedParentMeasure.top;
        return result;
    }
    /**
     * Move the current control to a vector3 position projected onto the screen.
     * @param position defines the target position
     * @param scene defines the hosting scene
     */ moveToVector3(position, scene) {
        if (!this._host || this.parent !== this._host._rootContainer) {
            (0, $bOhSV.Tools).Error("Cannot move a control to a vector3 if the control is not at root level");
            return;
        }
        this.horizontalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_LEFT;
        this.verticalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_TOP;
        const globalViewport = this._host._getGlobalViewport();
        const projectedPosition = (0, $ha1VO.Vector3).Project(position, (0, $ha1VO.Matrix).IdentityReadOnly, scene.getTransformMatrix(), globalViewport);
        this._moveToProjectedPosition(projectedPosition);
        if (projectedPosition.z < 0 || projectedPosition.z > 1) {
            this.notRenderable = true;
            return;
        }
        this.notRenderable = false;
    }
    /**
     * Will store all controls that have this control as ascendant in a given array
     * @param results defines the array where to store the descendants
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     */ getDescendantsToRef(results, directDescendantsOnly = false, predicate) {
    // Do nothing by default
    }
    /**
     * Will return all controls that have this control as ascendant
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns all child controls
     */ getDescendants(directDescendantsOnly, predicate) {
        const results = [];
        this.getDescendantsToRef(results, directDescendantsOnly, predicate);
        return results;
    }
    /**
     * Link current control with a target mesh
     * @param mesh defines the mesh to link with
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ linkWithMesh(mesh) {
        if (!this._host || this.parent && this.parent !== this._host._rootContainer) {
            if (mesh) (0, $bOhSV.Tools).Error("Cannot link a control to a mesh if the control is not at root level");
            return;
        }
        const index = this._host._linkedControls.indexOf(this);
        if (index !== -1) {
            this._linkedMesh = mesh;
            if (!mesh) this._host._linkedControls.splice(index, 1);
            return;
        } else if (!mesh) return;
        this.horizontalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_LEFT;
        this.verticalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_TOP;
        this._linkedMesh = mesh;
        this._host._linkedControls.push(this);
    }
    /**
     * Shorthand function to set the top, right, bottom, and left padding values on the control.
     * @param { string | number} paddingTop - The value of the top padding.
     * @param { string | number} paddingRight - The value of the right padding. If omitted, top is used.
     * @param { string | number} paddingBottom - The value of the bottom padding. If omitted, top is used.
     * @param { string | number} paddingLeft - The value of the left padding. If omitted, right is used.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ setPadding(paddingTop, paddingRight, paddingBottom, paddingLeft) {
        const top = paddingTop;
        const right = paddingRight ?? top;
        const bottom = paddingBottom ?? top;
        const left = paddingLeft ?? right;
        this.paddingTop = top;
        this.paddingRight = right;
        this.paddingBottom = bottom;
        this.paddingLeft = left;
    }
    /**
     * Shorthand funtion to set the top, right, bottom, and left padding values in pixels on the control.
     * @param { number} paddingTop - The value in pixels of the top padding.
     * @param { number} paddingRight - The value in pixels of the right padding. If omitted, top is used.
     * @param { number} paddingBottom - The value in pixels of the bottom padding. If omitted, top is used.
     * @param { number} paddingLeft - The value in pixels of the left padding. If omitted, right is used.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ setPaddingInPixels(paddingTop, paddingRight, paddingBottom, paddingLeft) {
        const top = paddingTop;
        const right = paddingRight ?? top;
        const bottom = paddingBottom ?? top;
        const left = paddingLeft ?? right;
        this.paddingTopInPixels = top;
        this.paddingRightInPixels = right;
        this.paddingBottomInPixels = bottom;
        this.paddingLeftInPixels = left;
    }
    /**
     * @internal
     */ _moveToProjectedPosition(projectedPosition) {
        const oldLeft = this._left.getValue(this._host);
        const oldTop = this._top.getValue(this._host);
        const parentMeasure = this.parent?._currentMeasure;
        if (parentMeasure) this._processMeasures(parentMeasure, this._host.getContext());
        let newLeft = projectedPosition.x + this._linkOffsetX.getValue(this._host) - this._currentMeasure.width / 2;
        let newTop = projectedPosition.y + this._linkOffsetY.getValue(this._host) - this._currentMeasure.height / 2;
        const leftAndTopIgnoreAdaptiveScaling = this._left.ignoreAdaptiveScaling && this._top.ignoreAdaptiveScaling;
        if (leftAndTopIgnoreAdaptiveScaling) {
            if (Math.abs(newLeft - oldLeft) < 0.5) newLeft = oldLeft;
            if (Math.abs(newTop - oldTop) < 0.5) newTop = oldTop;
        }
        if (!leftAndTopIgnoreAdaptiveScaling && oldLeft === newLeft && oldTop === newTop) return;
        this.left = newLeft + "px";
        this.top = newTop + "px";
        this._left.ignoreAdaptiveScaling = true;
        this._top.ignoreAdaptiveScaling = true;
        this._markAsDirty();
    }
    /**
     * @internal
     */ _offsetLeft(offset) {
        this._isDirty = true;
        this._currentMeasure.left += offset;
    }
    /**
     * @internal
     */ _offsetTop(offset) {
        this._isDirty = true;
        this._currentMeasure.top += offset;
    }
    /** @internal */ _markMatrixAsDirty() {
        this._isMatrixDirty = true;
        this._flagDescendantsAsMatrixDirty();
    }
    /** @internal */ _flagDescendantsAsMatrixDirty() {
    // No child
    }
    /**
     * @internal
     */ _intersectsRect(rect, context) {
        // make sure we are transformed correctly before checking intersections. no-op if nothing is dirty.
        this._transform(context);
        if (this._evaluatedMeasure.left >= rect.left + rect.width) return false;
        if (this._evaluatedMeasure.top >= rect.top + rect.height) return false;
        if (this._evaluatedMeasure.left + this._evaluatedMeasure.width <= rect.left) return false;
        if (this._evaluatedMeasure.top + this._evaluatedMeasure.height <= rect.top) return false;
        return true;
    }
    /** @internal */ _computeAdditionalOffsetX() {
        return 0;
    }
    /** @internal */ _computeAdditionalOffsetY() {
        return 0;
    }
    /** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
    invalidateRect() {
        this._transform();
        if (this.host && this.host.useInvalidateRectOptimization) {
            // Rotate by transform to get the measure transformed to global space
            this._currentMeasure.transformToRef(this._transformMatrix, this._tmpMeasureA);
            // get the boudning box of the current measure and last frames measure in global space and invalidate it
            // the previous measure is used to properly clear a control that is scaled down
            (0, $fc6a12d4b9dc7831$export$76df7375f104822f).CombineToRef(this._tmpMeasureA, this._prevCurrentMeasureTransformedIntoGlobalSpace, this._tmpMeasureA);
            // Expand rect based on shadows
            const shadowOffsetX = this.shadowOffsetX;
            const shadowOffsetY = this.shadowOffsetY;
            const shadowBlur = Math.max(this._previousShadowBlur, this.shadowBlur);
            const leftShadowOffset = Math.min(Math.min(shadowOffsetX, 0) - shadowBlur * 2, 0);
            const rightShadowOffset = Math.max(Math.max(shadowOffsetX, 0) + shadowBlur * 2, 0);
            const topShadowOffset = Math.min(Math.min(shadowOffsetY, 0) - shadowBlur * 2, 0);
            const bottomShadowOffset = Math.max(Math.max(shadowOffsetY, 0) + shadowBlur * 2, 0);
            const offsetX = this._computeAdditionalOffsetX();
            const offsetY = this._computeAdditionalOffsetY();
            this.host.invalidateRect(Math.floor(this._tmpMeasureA.left + leftShadowOffset - offsetX), Math.floor(this._tmpMeasureA.top + topShadowOffset - offsetY), Math.ceil(this._tmpMeasureA.left + this._tmpMeasureA.width + rightShadowOffset + offsetX), Math.ceil(this._tmpMeasureA.top + this._tmpMeasureA.height + bottomShadowOffset + offsetY));
        }
    }
    /**
     * @internal
     */ _markAsDirty(force = false) {
        if (!this._isVisible && !force) return;
        this._isDirty = true;
        this._markMatrixAsDirty();
        // Redraw only this rectangle
        if (this._host) this._host.markAsDirty();
    }
    /** @internal */ _markAllAsDirty() {
        this._markAsDirty();
        if (this._font) this._prepareFont();
    }
    /**
     * @internal
     */ _link(host) {
        this._host = host;
        if (this._host) this.uniqueId = this._host.getScene().getUniqueId();
    }
    /**
     * @internal
     */ _transform(context) {
        if (!this._isMatrixDirty && this._scaleX === 1 && this._scaleY === 1 && this._rotation === 0) return;
        // postTranslate
        const offsetX = this._currentMeasure.width * this._transformCenterX + this._currentMeasure.left;
        const offsetY = this._currentMeasure.height * this._transformCenterY + this._currentMeasure.top;
        if (context) {
            context.translate(offsetX, offsetY);
            // rotate
            context.rotate(this._rotation);
            // scale
            context.scale(this._scaleX, this._scaleY);
            // preTranslate
            context.translate(-offsetX, -offsetY);
        }
        // Need to update matrices?
        if (this._isMatrixDirty || this._cachedOffsetX !== offsetX || this._cachedOffsetY !== offsetY) {
            this._cachedOffsetX = offsetX;
            this._cachedOffsetY = offsetY;
            this._isMatrixDirty = false;
            this._flagDescendantsAsMatrixDirty();
            (0, $e2393c5f4672a478$export$26e6ecd136a15474).ComposeToRef(-offsetX, -offsetY, this._rotation, this._scaleX, this._scaleY, this.parent ? this.parent._transformMatrix : null, this._transformMatrix);
            this._transformMatrix.invertToRef(this._invertTransformMatrix);
            this._currentMeasure.transformToRef(this._transformMatrix, this._evaluatedMeasure);
        }
    }
    /**
     * @internal
     */ _renderHighlight(context) {
        if (!this.isHighlighted) return;
        context.save();
        context.strokeStyle = this._highlightColor;
        context.lineWidth = this._highlightLineWidth;
        this._renderHighlightSpecific(context);
        context.restore();
    }
    /**
     * @internal
     */ _renderHighlightSpecific(context) {
        context.strokeRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
    }
    _getColor(context) {
        return this.gradient ? this.gradient.getCanvasGradient(context) : this.color;
    }
    /**
     * @internal
     */ _applyStates(context) {
        if (this._isFontSizeInPercentage) this._fontSet = true;
        if (this._host && this._host.useSmallestIdeal && !this._font) this._fontSet = true;
        if (this._fontSet) {
            this._prepareFont();
            this._fontSet = false;
        }
        if (this._font) context.font = this._font;
        if (this._color || this.gradient) context.fillStyle = this._getColor(context);
        if ($b6009490051f50fb$export$7a7fa4424cb20976.AllowAlphaInheritance) context.globalAlpha *= this._alpha;
        else if (this._alphaSet) context.globalAlpha = this.parent && !this.parent.renderToIntermediateTexture ? this.parent.alpha * this._alpha : this._alpha;
    }
    /**
     * @internal
     */ _layout(parentMeasure, context) {
        if (!this.isDirty && (!this.isVisible || this.notRenderable)) return false;
        if (this._isDirty || !this._cachedParentMeasure.isEqualsTo(parentMeasure)) {
            this.host._numLayoutCalls++;
            this._currentMeasure.addAndTransformToRef(this._transformMatrix, -this._paddingLeftInPixels | 0, -this._paddingTopInPixels | 0, this._paddingRightInPixels | 0, this._paddingBottomInPixels | 0, this._prevCurrentMeasureTransformedIntoGlobalSpace);
            context.save();
            this._applyStates(context);
            let rebuildCount = 0;
            do {
                this._rebuildLayout = false;
                this._processMeasures(parentMeasure, context);
                rebuildCount++;
            }while (this._rebuildLayout && rebuildCount < 3);
            if (rebuildCount >= 3) (0, $kVtWi.Logger).Error(`Layout cycle detected in GUI (Control name=${this.name}, uniqueId=${this.uniqueId})`);
            context.restore();
            this.invalidateRect();
            this._evaluateClippingState(parentMeasure);
        }
        this._wasDirty = this._isDirty;
        this._isDirty = false;
        return true;
    }
    /**
     * @internal
     */ _processMeasures(parentMeasure, context) {
        this._tempPaddingMeasure.copyFrom(parentMeasure);
        // Apply padding if in correct mode
        if (this.parent && this.parent.descendantsOnlyPadding) {
            this._tempPaddingMeasure.left += this.parent.paddingLeftInPixels;
            this._tempPaddingMeasure.top += this.parent.paddingTopInPixels;
            this._tempPaddingMeasure.width -= this.parent.paddingLeftInPixels + this.parent.paddingRightInPixels;
            this._tempPaddingMeasure.height -= this.parent.paddingTopInPixels + this.parent.paddingBottomInPixels;
        }
        this._currentMeasure.copyFrom(this._tempPaddingMeasure);
        // Let children take some pre-measurement actions
        this._preMeasure(this._tempPaddingMeasure, context);
        this._measure();
        // Let children take some post-measurement actions
        this._postMeasure(this._tempPaddingMeasure, context);
        this._computeAlignment(this._tempPaddingMeasure, context);
        // Convert to int values
        this._currentMeasure.left = this._currentMeasure.left | 0;
        this._currentMeasure.top = this._currentMeasure.top | 0;
        this._currentMeasure.width = this._currentMeasure.width | 0;
        this._currentMeasure.height = this._currentMeasure.height | 0;
        // Let children add more features
        this._additionalProcessing(this._tempPaddingMeasure, context);
        this._cachedParentMeasure.copyFrom(this._tempPaddingMeasure);
        this._currentMeasure.transformToRef(this._transformMatrix, this._evaluatedMeasure);
        if (this.onDirtyObservable.hasObservers()) this.onDirtyObservable.notifyObservers(this);
    }
    _evaluateClippingState(parentMeasure) {
        // Since transformMatrix is used here, we need to have it freshly computed
        this._transform();
        this._currentMeasure.transformToRef(this._transformMatrix, this._evaluatedMeasure);
        if (this.parent && this.parent.clipChildren) {
            parentMeasure.transformToRef(this.parent._transformMatrix, this._evaluatedParentMeasure);
            // Early clip
            if (this._evaluatedMeasure.left > this._evaluatedParentMeasure.left + this._evaluatedParentMeasure.width) {
                this._isClipped = true;
                return;
            }
            if (this._evaluatedMeasure.left + this._evaluatedMeasure.width < this._evaluatedParentMeasure.left) {
                this._isClipped = true;
                return;
            }
            if (this._evaluatedMeasure.top > this._evaluatedParentMeasure.top + this._evaluatedParentMeasure.height) {
                this._isClipped = true;
                return;
            }
            if (this._evaluatedMeasure.top + this._evaluatedMeasure.height < this._evaluatedParentMeasure.top) {
                this._isClipped = true;
                return;
            }
        }
        this._isClipped = false;
    }
    /** @internal */ _measure() {
        // Width / Height
        if (this._width.isPixel) this._currentMeasure.width = this._width.getValue(this._host);
        else this._currentMeasure.width *= this._width.getValue(this._host);
        if (this._height.isPixel) this._currentMeasure.height = this._height.getValue(this._host);
        else this._currentMeasure.height *= this._height.getValue(this._host);
        if (this._fixedRatio !== 0) {
            if (this._fixedRatioMasterIsWidth) this._currentMeasure.height = this._currentMeasure.width * this._fixedRatio;
            else this._currentMeasure.width = this._currentMeasure.height * this._fixedRatio;
        }
    }
    /**
     * @internal
     */ _computeAlignment(parentMeasure, context) {
        const width = this._currentMeasure.width;
        const height = this._currentMeasure.height;
        const parentWidth = parentMeasure.width;
        const parentHeight = parentMeasure.height;
        // Left / top
        let x = 0;
        let y = 0;
        switch(this.horizontalAlignment){
            case $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_LEFT:
                x = 0;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_RIGHT:
                x = parentWidth - width;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_CENTER:
                x = (parentWidth - width) / 2;
                break;
        }
        switch(this.verticalAlignment){
            case $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_TOP:
                y = 0;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_BOTTOM:
                y = parentHeight - height;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_CENTER:
                y = (parentHeight - height) / 2;
                break;
        }
        if (!this.descendantsOnlyPadding) {
            if (this._paddingLeft.isPixel) {
                this._currentMeasure.left += this._paddingLeft.getValue(this._host);
                this._currentMeasure.width -= this._paddingLeft.getValue(this._host);
            } else {
                this._currentMeasure.left += parentWidth * this._paddingLeft.getValue(this._host);
                this._currentMeasure.width -= parentWidth * this._paddingLeft.getValue(this._host);
            }
            if (this._paddingRight.isPixel) this._currentMeasure.width -= this._paddingRight.getValue(this._host);
            else this._currentMeasure.width -= parentWidth * this._paddingRight.getValue(this._host);
            if (this._paddingTop.isPixel) {
                this._currentMeasure.top += this._paddingTop.getValue(this._host);
                this._currentMeasure.height -= this._paddingTop.getValue(this._host);
            } else {
                this._currentMeasure.top += parentHeight * this._paddingTop.getValue(this._host);
                this._currentMeasure.height -= parentHeight * this._paddingTop.getValue(this._host);
            }
            if (this._paddingBottom.isPixel) this._currentMeasure.height -= this._paddingBottom.getValue(this._host);
            else this._currentMeasure.height -= parentHeight * this._paddingBottom.getValue(this._host);
        }
        if (this._left.isPixel) this._currentMeasure.left += this._left.getValue(this._host);
        else this._currentMeasure.left += parentWidth * this._left.getValue(this._host);
        if (this._top.isPixel) this._currentMeasure.top += this._top.getValue(this._host);
        else this._currentMeasure.top += parentHeight * this._top.getValue(this._host);
        this._currentMeasure.left += x;
        this._currentMeasure.top += y;
    }
    /**
     * @internal
     */ _preMeasure(parentMeasure, context) {
    // Do nothing
    }
    /**
     * @internal
     */ _postMeasure(parentMeasure, context) {
    // Do nothing
    }
    /**
     * @internal
     */ _additionalProcessing(parentMeasure, context) {
    // Do nothing
    }
    /**
     * @internal
     */ _clipForChildren(context) {
    // DO nothing
    }
    _clip(context, invalidatedRectangle) {
        context.beginPath();
        $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.copyFrom(this._currentMeasure);
        if (invalidatedRectangle) {
            // Rotate the invalidated rect into the control's space
            invalidatedRectangle.transformToRef(this._invertTransformMatrix, this._tmpMeasureA);
            // Get the intersection of the rect in context space and the current context
            const intersection = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
            intersection.left = Math.max(this._tmpMeasureA.left, this._currentMeasure.left);
            intersection.top = Math.max(this._tmpMeasureA.top, this._currentMeasure.top);
            intersection.width = Math.min(this._tmpMeasureA.left + this._tmpMeasureA.width, this._currentMeasure.left + this._currentMeasure.width) - intersection.left;
            intersection.height = Math.min(this._tmpMeasureA.top + this._tmpMeasureA.height, this._currentMeasure.top + this._currentMeasure.height) - intersection.top;
            $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.copyFrom(intersection);
        }
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            const shadowOffsetX = this.shadowOffsetX;
            const shadowOffsetY = this.shadowOffsetY;
            const shadowBlur = this.shadowBlur;
            const leftShadowOffset = Math.min(Math.min(shadowOffsetX, 0) - shadowBlur * 2, 0);
            const rightShadowOffset = Math.max(Math.max(shadowOffsetX, 0) + shadowBlur * 2, 0);
            const topShadowOffset = Math.min(Math.min(shadowOffsetY, 0) - shadowBlur * 2, 0);
            const bottomShadowOffset = Math.max(Math.max(shadowOffsetY, 0) + shadowBlur * 2, 0);
            context.rect($b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.left + leftShadowOffset, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.top + topShadowOffset, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.width + rightShadowOffset - leftShadowOffset, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.height + bottomShadowOffset - topShadowOffset);
        } else context.rect($b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.left, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.top, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.width, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.height);
        context.clip();
    }
    /**
     * @internal
     */ _render(context, invalidatedRectangle) {
        if (!this.isVisible || this.notRenderable || this._isClipped) {
            this._isDirty = false;
            return false;
        }
        this.host._numRenderCalls++;
        context.save();
        this._applyStates(context);
        // Transform
        this._transform(context);
        // Clip
        if (this.clipContent) this._clip(context, invalidatedRectangle);
        if (this.onBeforeDrawObservable.hasObservers()) this.onBeforeDrawObservable.notifyObservers(this);
        if (this.useBitmapCache && !this._wasDirty && this._cacheData) context.putImageData(this._cacheData, this._currentMeasure.left, this._currentMeasure.top);
        else this._draw(context, invalidatedRectangle);
        if (this.useBitmapCache && this._wasDirty) this._cacheData = context.getImageData(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        this._renderHighlight(context);
        if (this.onAfterDrawObservable.hasObservers()) this.onAfterDrawObservable.notifyObservers(this);
        context.restore();
        return true;
    }
    /**
     * @internal
     */ _draw(context, invalidatedRectangle) {
    // Do nothing
    }
    /**
     * Tests if a given coordinates belong to the current control
     * @param x defines x coordinate to test
     * @param y defines y coordinate to test
     * @returns true if the coordinates are inside the control
     */ contains(x, y) {
        // Invert transform
        this._invertTransformMatrix.transformCoordinates(x, y, this._transformedPosition);
        x = this._transformedPosition.x;
        y = this._transformedPosition.y;
        // Check
        if (x < this._currentMeasure.left) return false;
        if (x > this._currentMeasure.left + this._currentMeasure.width) return false;
        if (y < this._currentMeasure.top) return false;
        if (y > this._currentMeasure.top + this._currentMeasure.height) return false;
        if (this.isPointerBlocker) this._host._shouldBlockPointer = true;
        return true;
    }
    /**
     * @internal
     */ _processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled) return false;
        if (!this.isHitTestVisible || !this.isVisible || this._doNotRender) return false;
        if (!this.contains(x, y)) return false;
        this._processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY);
        return true;
    }
    /**
     * @internal
     */ _onPointerMove(target, coordinates, pointerId, pi) {
        const canNotify = this.onPointerMoveObservable.notifyObservers(coordinates, -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerMove(target, coordinates, pointerId, pi);
    }
    /**
     * @internal
     */ _onPointerEnter(target, pi) {
        if (!this._isEnabled) return false;
        if (this._enterCount > 0) return false;
        if (this._enterCount === -1) // -1 is for touch input, we are now sure we are with a mouse or pencil
        this._enterCount = 0;
        this._enterCount++;
        const canNotify = this.onPointerEnterObservable.notifyObservers(this, -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerEnter(target, pi);
        return true;
    }
    /**
     * @internal
     */ _onPointerOut(target, pi, force = false) {
        if (!force && !this._isEnabled) return;
        this._enterCount = 0;
        let canNotify = true;
        if (!target.isAscendant(this)) canNotify = this.onPointerOutObservable.notifyObservers(this, -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerOut(target, pi, force);
    }
    /**
     * @internal
     */ _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        // Prevent pointerout to lose control context.
        // Event redundancy is checked inside the function.
        this._onPointerEnter(this, pi);
        if (this.tabIndex !== -1) this.host.focusedControl = this;
        if (this._downCount !== 0) return false;
        this._downCount++;
        this._downPointerIds[pointerId] = true;
        const canNotify = this.onPointerDownObservable.notifyObservers(new (0, $e2393c5f4672a478$export$b71b64568b3d7bf8)(coordinates, buttonIndex), -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerDown(target, coordinates, pointerId, buttonIndex, pi);
        if (pi && this.uniqueId !== this._host.rootContainer.uniqueId) this._host._capturedPointerIds.add(pi.event.pointerId);
        return true;
    }
    /**
     * @internal
     */ _onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick, pi) {
        if (!this._isEnabled) return;
        this._downCount = 0;
        delete this._downPointerIds[pointerId];
        let canNotifyClick = notifyClick;
        if (notifyClick && (this._enterCount > 0 || this._enterCount === -1)) {
            if (!this._host.usePointerTapForClickEvent) canNotifyClick = this.onPointerClickObservable.notifyObservers(new (0, $e2393c5f4672a478$export$b71b64568b3d7bf8)(coordinates, buttonIndex), -1, target, this, pi);
        }
        const canNotify = this.onPointerUpObservable.notifyObservers(new (0, $e2393c5f4672a478$export$b71b64568b3d7bf8)(coordinates, buttonIndex), -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerUp(target, coordinates, pointerId, buttonIndex, canNotifyClick, pi);
        if (pi && this.uniqueId !== this._host.rootContainer.uniqueId) this._host._capturedPointerIds.delete(pi.event.pointerId);
        if (this._host.usePointerTapForClickEvent && this.isPointerBlocker) this._host._shouldBlockPointer = false;
    }
    _onPointerPick(target, coordinates, pointerId, buttonIndex, notifyClick, pi) {
        if (!this._host.usePointerTapForClickEvent) return false;
        let canNotifyClick = notifyClick;
        if (notifyClick && (this._enterCount > 0 || this._enterCount === -1)) canNotifyClick = this.onPointerClickObservable.notifyObservers(new (0, $e2393c5f4672a478$export$b71b64568b3d7bf8)(coordinates, buttonIndex), -1, target, this, pi);
        const canNotify = this.onPointerUpObservable.notifyObservers(new (0, $e2393c5f4672a478$export$b71b64568b3d7bf8)(coordinates, buttonIndex), -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerPick(target, coordinates, pointerId, buttonIndex, canNotifyClick, pi);
        if (this._host.usePointerTapForClickEvent && this.isPointerBlocker) this._host._shouldBlockPointer = true;
        return true;
    }
    /**
     * @internal
     */ _forcePointerUp(pointerId = null) {
        if (pointerId !== null) this._onPointerUp(this, (0, $ha1VO.Vector2).Zero(), pointerId, 0, true);
        else for(const key in this._downPointerIds)this._onPointerUp(this, (0, $ha1VO.Vector2).Zero(), +key, 0, true);
    }
    /**
     * @internal
     */ _onWheelScroll(deltaX, deltaY) {
        if (!this._isEnabled) return;
        const canNotify = this.onWheelObservable.notifyObservers(new (0, $ha1VO.Vector2)(deltaX, deltaY));
        if (canNotify && this.parent != null) this.parent._onWheelScroll(deltaX, deltaY);
    }
    /** @internal */ _onCanvasBlur() {}
    /**
     * @internal
     */ _processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled) return false;
        this._dummyVector2.copyFromFloats(x, y);
        if (type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
            this._onPointerMove(this, this._dummyVector2, pointerId, pi);
            const previousControlOver = this._host._lastControlOver[pointerId];
            if (previousControlOver && previousControlOver !== this) previousControlOver._onPointerOut(this, pi);
            if (previousControlOver !== this) this._onPointerEnter(this, pi);
            this._host._lastControlOver[pointerId] = this;
            return true;
        } else if (type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
            this._onPointerDown(this, this._dummyVector2, pointerId, buttonIndex, pi);
            this._host._registerLastControlDown(this, pointerId);
            this._host._lastPickedControl = this;
            return true;
        } else if (type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
            if (this._host._lastControlDown[pointerId]) this._host._lastControlDown[pointerId]._onPointerUp(this, this._dummyVector2, pointerId, buttonIndex, true, pi);
            if (!this._host.usePointerTapForClickEvent) delete this._host._lastControlDown[pointerId];
            return true;
        } else if (type === (0, $cfkw4.PointerEventTypes).POINTERWHEEL) {
            if (this._host._lastControlOver[pointerId]) {
                this._host._lastControlOver[pointerId]._onWheelScroll(deltaX, deltaY);
                return true;
            }
        } else if (type === (0, $cfkw4.PointerEventTypes).POINTERTAP) {
            if (this._host._lastControlDown[pointerId]) this._host._lastControlDown[pointerId]._onPointerPick(this, this._dummyVector2, pointerId, buttonIndex, true, pi);
            delete this._host._lastControlDown[pointerId];
            return true;
        }
        return false;
    }
    _getStyleProperty(propName, defaultValue) {
        const prop = (this._style && this._style[propName]) ?? this[propName];
        if (!prop && this.parent) return this.parent._getStyleProperty(propName, defaultValue);
        else if (!this.parent) return defaultValue;
        else return prop;
    }
    _prepareFont() {
        if (!this._font && !this._fontSet) return;
        this._font = this._getStyleProperty("fontStyle", "") + " " + this._getStyleProperty("fontWeight", "") + " " + this.fontSizeInPixels + "px " + this._getStyleProperty("fontFamily", "Arial");
        this._fontOffset = $b6009490051f50fb$export$7a7fa4424cb20976._GetFontOffset(this._font, this._host?.getScene()?.getEngine());
        //children need to be refreshed
        this.getDescendants().forEach((child)=>child._markAllAsDirty());
    }
    /**
     * A control has a dimension fully defined if that dimension doesn't depend on the parent's dimension.
     * As an example, a control that has dimensions in pixels is fully defined, while in percentage is not fully defined.
     * @param dim the dimension to check (width or height)
     * @returns if the dimension is fully defined
     */ isDimensionFullyDefined(dim) {
        return this.getDimension(dim).isPixel;
    }
    /**
     * Gets the dimension of the control along a specified axis
     * @param dim the dimension to retrieve (width or height)
     * @returns the dimension value along the specified axis
     */ getDimension(dim) {
        if (dim === "width") return this._width;
        else return this._height;
    }
    /**
     * Clones a control and its descendants
     * @param host the texture where the control will be instantiated. Can be empty, in which case the control will be created on the same texture
     * @returns the cloned control
     */ clone(host) {
        const serialization = {};
        this.serialize(serialization, true);
        const controlType = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serialization.className);
        const cloned = new controlType();
        cloned.parse(serialization, host);
        return cloned;
    }
    /**
     * Parses a serialized object into this control
     * @param serializedObject the object with the serialized properties
     * @param host the texture where the control will be instantiated. Can be empty, in which case the control will be created on the same texture
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     * @returns this control
     */ parse(serializedObject, host, urlRewriter) {
        this._urlRewriter = urlRewriter;
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, serializedObject, null);
        this.name = serializedObject.name;
        this._parseFromContent(serializedObject, host ?? this._host);
        return this;
    }
    /**
     * Serializes the current control
     * @param serializationObject defined the JSON serialized object
     * @param force if the control should be serialized even if the isSerializable flag is set to false (default false)
     * @param allowCanvas defines if the control is allowed to use a Canvas2D object to serialize (true by default)
     */ serialize(serializationObject, force = false, allowCanvas = true) {
        if (!this.isSerializable && !force) return;
        let idealWidth = 0;
        let idealHeight = 0;
        // the host's ideal width and height are influencing the serialization, as they are used in getValue() of ValueAndUnit.
        // for a proper serialization, we need to temporarily set them to 0 and re-set them back afterwards.
        if (this.host) {
            idealHeight = this.host.idealHeight;
            idealWidth = this.host.idealWidth;
            this.host.idealWidth = 0;
            this.host.idealHeight = 0;
        }
        (0, $6Ho1L.SerializationHelper).Serialize(this, serializationObject);
        serializationObject.name = this.name;
        serializationObject.className = this.getClassName();
        // Call prepareFont to guarantee the font is properly set before serializing
        if (allowCanvas) this._prepareFont();
        if (this._fontFamily) serializationObject.fontFamily = this._fontFamily;
        if (this.fontSize) serializationObject.fontSize = this.fontSize;
        if (this.fontWeight) serializationObject.fontWeight = this.fontWeight;
        if (this.fontStyle) serializationObject.fontStyle = this.fontStyle;
        if (this._gradient) {
            serializationObject.gradient = {};
            this._gradient.serialize(serializationObject.gradient);
        }
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        // re-set the ideal width and height
        if (this.host) {
            this.host.idealWidth = idealWidth;
            this.host.idealHeight = idealHeight;
        }
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host, urlRewriter) {
        if (serializedObject.fontFamily) this.fontFamily = serializedObject.fontFamily;
        if (serializedObject.fontSize) this.fontSize = serializedObject.fontSize;
        if (serializedObject.fontWeight) this.fontWeight = serializedObject.fontWeight;
        if (serializedObject.fontStyle) this.fontStyle = serializedObject.fontStyle;
        // Gradient
        if (serializedObject.gradient) {
            const className = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.gradient.className);
            this._gradient = new className();
            this._gradient?.parse(serializedObject.gradient);
        }
        // Animations
        if (serializedObject.animations) {
            this.animations = [];
            for(let animationIndex = 0; animationIndex < serializedObject.animations.length; animationIndex++){
                const parsedAnimation = serializedObject.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) this.animations.push(internalClass.Parse(parsedAnimation));
            }
            if (serializedObject.autoAnimate && this._host && this._host.getScene()) this._host.getScene().beginAnimation(this, serializedObject.autoAnimateFrom, serializedObject.autoAnimateTo, serializedObject.autoAnimateLoop, serializedObject.autoAnimateSpeed || 1.0);
        }
        this.fixedRatioMasterIsWidth = serializedObject.fixedRatioMasterIsWidth ?? this.fixedRatioMasterIsWidth;
    }
    /** Releases associated resources */ dispose() {
        this.onDirtyObservable.clear();
        this.onBeforeDrawObservable.clear();
        this.onAfterDrawObservable.clear();
        this.onPointerDownObservable.clear();
        this.onPointerEnterObservable.clear();
        this.onPointerMoveObservable.clear();
        this.onPointerOutObservable.clear();
        this.onPointerUpObservable.clear();
        this.onPointerClickObservable.clear();
        this.onWheelObservable.clear();
        // focus
        this.onBlurObservable.clear();
        this.onFocusObservable.clear();
        this.onKeyboardEventProcessedObservable.clear();
        if (this._styleObserver && this._style) {
            this._style.onChangedObservable.remove(this._styleObserver);
            this._styleObserver = null;
        }
        if (this.parent) {
            this.parent.removeControl(this);
            this.parent = null;
        }
        if (this._host) {
            const index = this._host._linkedControls.indexOf(this);
            if (index > -1) this.linkWithMesh(null);
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
    }
    /** HORIZONTAL_ALIGNMENT_LEFT */ static get HORIZONTAL_ALIGNMENT_LEFT() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_LEFT;
    }
    /** HORIZONTAL_ALIGNMENT_RIGHT */ static get HORIZONTAL_ALIGNMENT_RIGHT() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_RIGHT;
    }
    /** HORIZONTAL_ALIGNMENT_CENTER */ static get HORIZONTAL_ALIGNMENT_CENTER() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_CENTER;
    }
    /** VERTICAL_ALIGNMENT_TOP */ static get VERTICAL_ALIGNMENT_TOP() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_TOP;
    }
    /** VERTICAL_ALIGNMENT_BOTTOM */ static get VERTICAL_ALIGNMENT_BOTTOM() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_BOTTOM;
    }
    /** VERTICAL_ALIGNMENT_CENTER */ static get VERTICAL_ALIGNMENT_CENTER() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_CENTER;
    }
    /**
     * @internal
     */ static _GetFontOffset(font, engineToUse) {
        if ($b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes[font]) return $b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes[font];
        const engine = engineToUse || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        const result = engine.getFontOffset(font);
        $b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes[font] = result;
        return result;
    }
    /**
     * Creates a Control from parsed data
     * @param serializedObject defines parsed data
     * @param host defines the hosting AdvancedDynamicTexture
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     * @returns a new Control
     */ static Parse(serializedObject, host, urlRewriter) {
        const controlType = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.className);
        const control = (0, $6Ho1L.SerializationHelper).Parse(()=>{
            const newControl = new controlType();
            newControl._urlRewriter = urlRewriter;
            return newControl;
        }, serializedObject, null);
        control.name = serializedObject.name;
        control._parseFromContent(serializedObject, host, urlRewriter);
        return control;
    }
    /**
     * @internal
     */ static drawEllipse(x, y, width, height, arc, context) {
        context.translate(x, y);
        context.scale(width, height);
        context.beginPath();
        context.arc(0, 0, 1, 0, 2 * Math.PI * arc, arc < 0);
        if (arc >= 1) context.closePath();
        context.scale(1 / width, 1 / height);
        context.translate(-x, -y);
    }
    /**
     * Returns true if the control is ready to be used
     * @returns
     */ isReady() {
        // Most controls are ready by default, so the default implementation is to return true
        return true;
    }
}
/**
 * Gets or sets a boolean indicating if alpha must be an inherited value (false by default)
 */ $b6009490051f50fb$export$7a7fa4424cb20976.AllowAlphaInheritance = false;
$b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
// Statics
$b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_LEFT = 0;
$b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_RIGHT = 1;
$b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_CENTER = 2;
$b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_TOP = 0;
$b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_BOTTOM = 1;
$b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_CENTER = 2;
$b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes = {};
$b6009490051f50fb$export$7a7fa4424cb20976.AddHeader = ()=>{};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "metadata", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isHitTestVisible", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isPointerBlocker", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isFocusInvisible", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "clipChildren", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "clipContent", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "useBitmapCache", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowOffsetX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowOffsetY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowBlur", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "hoverCursor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "fontOffset", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "alpha", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isSerializable", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "scaleX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "scaleY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "rotation", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "transformCenterY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "transformCenterX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "horizontalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "verticalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "fixedRatio", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "fixedRatioMasterIsWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "width", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "height", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "style", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "color", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "gradient", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "zIndex", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "notRenderable", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isVisible", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "descendantsOnlyPadding", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingRight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingBottom", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "left", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "top", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "linkOffsetX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "linkOffsetY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "disabledColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "disabledColorItem", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "overlapGroup", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "overlapDeltaMultiplier", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Control", $b6009490051f50fb$export$7a7fa4424cb20976);




var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");


var $j2mX5 = parcelRequire("j2mX5");


var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

class $a86b55aad2faeec0$export$42a852a2b6b56249 extends (0, $b6009490051f50fb$export$7a7fa4424cb20976) {
    /** Gets or sets boolean indicating if children should be rendered to an intermediate texture rather than directly to host, useful for alpha blending */ get renderToIntermediateTexture() {
        return this._renderToIntermediateTexture;
    }
    set renderToIntermediateTexture(value) {
        if (this._renderToIntermediateTexture === value) return;
        this._renderToIntermediateTexture = value;
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the container should try to adapt to its children height */ get adaptHeightToChildren() {
        return this._adaptHeightToChildren;
    }
    set adaptHeightToChildren(value) {
        if (this._adaptHeightToChildren === value) return;
        this._adaptHeightToChildren = value;
        if (value) this.height = "100%";
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the container should try to adapt to its children width */ get adaptWidthToChildren() {
        return this._adaptWidthToChildren;
    }
    set adaptWidthToChildren(value) {
        if (this._adaptWidthToChildren === value) return;
        this._adaptWidthToChildren = value;
        if (value) this.width = "100%";
        this._markAsDirty();
    }
    /** Gets or sets background color */ get background() {
        return this._background;
    }
    set background(value) {
        if (this._background === value) return;
        this._background = value;
        this._markAsDirty();
    }
    /** Gets or sets background gradient color. Takes precedence over background */ get backgroundGradient() {
        return this._backgroundGradient;
    }
    set backgroundGradient(value) {
        if (this._backgroundGradient === value) return;
        this._backgroundGradient = value;
        this._markAsDirty();
    }
    /** Gets the list of children */ get children() {
        return this._children;
    }
    get isReadOnly() {
        return this._isReadOnly;
    }
    set isReadOnly(value) {
        this._isReadOnly = value;
        for (const child of this._children)child.isReadOnly = value;
    }
    /**
     * Creates a new Container
     * @param name defines the name of the container
     */ constructor(name){
        super(name);
        this.name = name;
        /** @internal */ this._children = new Array();
        /** @internal */ this._measureForChildren = (0, $fc6a12d4b9dc7831$export$76df7375f104822f).Empty();
        /** @internal */ this._background = "";
        /** @internal */ this._backgroundGradient = null;
        /** @internal */ this._adaptWidthToChildren = false;
        /** @internal */ this._adaptHeightToChildren = false;
        /** @internal */ this._renderToIntermediateTexture = false;
        /** @internal */ this._intermediateTexture = null;
        /**
         * Gets or sets a boolean indicating that the container will let internal controls handle picking instead of doing it directly using its bounding info
         */ this.delegatePickingToChildren = false;
        /**
         * Gets or sets a boolean indicating that layout cycle errors should be displayed on the console
         */ this.logLayoutCycleErrors = false;
        /**
         * Gets or sets the number of layout cycles (a change involved by a control while evaluating the layout) allowed
         */ this.maxLayoutCycle = 3;
        /**
         * An event triggered when any control is added to this container.
         */ this.onControlAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when any control is removed from this container.
         */ this.onControlRemovedObservable = new (0, $diGQf.Observable)();
        this._inverseTransformMatrix = (0, $e2393c5f4672a478$export$26e6ecd136a15474).Identity();
        this._inverseMeasure = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
    }
    _getTypeName() {
        return "Container";
    }
    _flagDescendantsAsMatrixDirty() {
        for (const child of this.children){
            child._isClipped = false;
            child._markMatrixAsDirty();
        }
    }
    /**
     * Gets a child using its name
     * @param name defines the child name to look for
     * @returns the child control if found
     */ getChildByName(name) {
        for (const child of this.children){
            if (child.name === name) return child;
        }
        return null;
    }
    /**
     * Gets a child using its type and its name
     * @param name defines the child name to look for
     * @param type defines the child type to look for
     * @returns the child control if found
     */ getChildByType(name, type) {
        for (const child of this.children){
            if (child.typeName === type) return child;
        }
        return null;
    }
    /**
     * Search for a specific control in children
     * @param control defines the control to look for
     * @returns true if the control is in child list
     */ containsControl(control) {
        return this.children.indexOf(control) !== -1;
    }
    /**
     * Adds a new control to the current container
     * @param control defines the control to add
     * @returns the current container
     */ addControl(control) {
        if (!control) return this;
        const index = this._children.indexOf(control);
        if (index !== -1) return this;
        control._link(this._host);
        control._markAllAsDirty();
        this._reOrderControl(control);
        this._markAsDirty();
        this.onControlAddedObservable.notifyObservers(control);
        return this;
    }
    /**
     * Removes all controls from the current container
     * @returns the current container
     */ clearControls() {
        const children = this.children.slice();
        for (const child of children)this.removeControl(child);
        return this;
    }
    /**
     * Removes a control from the current container
     * @param control defines the control to remove
     * @returns the current container
     */ removeControl(control) {
        const index = this._children.indexOf(control);
        if (index !== -1) {
            this._children.splice(index, 1);
            control.parent = null;
        }
        control.linkWithMesh(null);
        if (this._host) this._host._cleanControlAfterRemoval(control);
        this._markAsDirty();
        this.onControlRemovedObservable.notifyObservers(control);
        return this;
    }
    /**
     * @internal
     */ _reOrderControl(control) {
        const linkedMesh = control.linkedMesh;
        this.removeControl(control);
        let wasAdded = false;
        for(let index = 0; index < this._children.length; index++)if (this._children[index].zIndex > control.zIndex) {
            this._children.splice(index, 0, control);
            wasAdded = true;
            break;
        }
        if (!wasAdded) this._children.push(control);
        control.parent = this;
        if (linkedMesh) control.linkWithMesh(linkedMesh);
        this._markAsDirty();
    }
    /**
     * @internal
     */ _offsetLeft(offset) {
        super._offsetLeft(offset);
        for (const child of this._children)child._offsetLeft(offset);
    }
    /**
     * @internal
     */ _offsetTop(offset) {
        super._offsetTop(offset);
        for (const child of this._children)child._offsetTop(offset);
    }
    /** @internal */ _markAllAsDirty() {
        super._markAllAsDirty();
        for(let index = 0; index < this._children.length; index++)this._children[index]._markAllAsDirty();
    }
    _getBackgroundColor(context) {
        return this._backgroundGradient ? this._backgroundGradient.getCanvasGradient(context) : this._background;
    }
    /**
     * @internal
     */ _localDraw(context) {
        if (this._background || this._backgroundGradient) {
            context.save();
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowColor = this.shadowColor;
                context.shadowBlur = this.shadowBlur;
                context.shadowOffsetX = this.shadowOffsetX;
                context.shadowOffsetY = this.shadowOffsetY;
            }
            context.fillStyle = this._getBackgroundColor(context);
            context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
            context.restore();
        }
    }
    /**
     * @internal
     */ _link(host) {
        super._link(host);
        for (const child of this._children)child._link(host);
    }
    /** @internal */ _beforeLayout() {
    // Do nothing
    }
    /**
     * @internal
     */ _processMeasures(parentMeasure, context) {
        if (this._isDirty || !this._cachedParentMeasure.isEqualsTo(parentMeasure)) {
            super._processMeasures(parentMeasure, context);
            this._evaluateClippingState(parentMeasure);
            if (this._renderToIntermediateTexture) {
                if (this._intermediateTexture && this._host.getScene() != this._intermediateTexture.getScene()) {
                    this._intermediateTexture.dispose();
                    this._intermediateTexture = null;
                }
                if (!this._intermediateTexture) {
                    this._intermediateTexture = new (0, $b7371b076ec25b92$export$da80c28953472f54)("", {
                        width: this._currentMeasure.width,
                        height: this._currentMeasure.height
                    }, this._host.getScene(), false, (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, (0, $bd523120f282dc29$export$a002182e51710d39).TEXTUREFORMAT_RGBA, false);
                    this._intermediateTexture.hasAlpha = true;
                } else this._intermediateTexture.scaleTo(this._currentMeasure.width, this._currentMeasure.height);
            }
        }
    }
    /**
     * @internal
     */ _layout(parentMeasure, context) {
        if (!this.isDirty && (!this.isVisible || this.notRenderable)) return false;
        this.host._numLayoutCalls++;
        if (this._isDirty) this._currentMeasure.transformToRef(this._transformMatrix, this._prevCurrentMeasureTransformedIntoGlobalSpace);
        let rebuildCount = 0;
        context.save();
        this._applyStates(context);
        this._beforeLayout();
        do {
            let computedWidth = -1;
            let computedHeight = -1;
            this._rebuildLayout = false;
            this._processMeasures(parentMeasure, context);
            if (!this._isClipped) {
                for (const child of this._children){
                    child._tempParentMeasure.copyFrom(this._measureForChildren);
                    if (child._layout(this._measureForChildren, context)) {
                        if (child.isVisible && !child.notRenderable) {
                            if (this.adaptWidthToChildren && child._width.isPixel) computedWidth = Math.max(computedWidth, child._currentMeasure.width + child._paddingLeftInPixels + child._paddingRightInPixels);
                            if (this.adaptHeightToChildren && child._height.isPixel) computedHeight = Math.max(computedHeight, child._currentMeasure.height + child._paddingTopInPixels + child._paddingBottomInPixels);
                        }
                    }
                }
                if (this.adaptWidthToChildren && computedWidth >= 0) {
                    computedWidth += this.paddingLeftInPixels + this.paddingRightInPixels;
                    const width = computedWidth + "px";
                    if (this.width !== width) {
                        this.parent?._markAsDirty();
                        this.width = width;
                        this._width.ignoreAdaptiveScaling = true;
                        this._rebuildLayout = true;
                    }
                }
                if (this.adaptHeightToChildren && computedHeight >= 0) {
                    computedHeight += this.paddingTopInPixels + this.paddingBottomInPixels;
                    const height = computedHeight + "px";
                    if (this.height !== height) {
                        this.parent?._markAsDirty();
                        this.height = height;
                        this._height.ignoreAdaptiveScaling = true;
                        this._rebuildLayout = true;
                    }
                }
                this._postMeasure();
            }
            rebuildCount++;
        }while (this._rebuildLayout && rebuildCount < this.maxLayoutCycle);
        if (rebuildCount >= 3 && this.logLayoutCycleErrors) (0, $kVtWi.Logger).Error(`Layout cycle detected in GUI (Container name=${this.name}, uniqueId=${this.uniqueId})`);
        context.restore();
        if (this._isDirty) {
            this.invalidateRect();
            this._isDirty = false;
        }
        return true;
    }
    _postMeasure() {
    // Do nothing by default
    }
    /**
     * @internal
     */ _draw(context, invalidatedRectangle) {
        const renderToIntermediateTextureThisDraw = this._renderToIntermediateTexture && this._intermediateTexture;
        const contextToDrawTo = renderToIntermediateTextureThisDraw ? this._intermediateTexture.getContext() : context;
        if (renderToIntermediateTextureThisDraw) {
            contextToDrawTo.save();
            contextToDrawTo.translate(-this._currentMeasure.left, -this._currentMeasure.top);
            if (invalidatedRectangle) {
                this._transformMatrix.invertToRef(this._inverseTransformMatrix);
                invalidatedRectangle.transformToRef(this._inverseTransformMatrix, this._inverseMeasure);
                contextToDrawTo.clearRect(this._inverseMeasure.left, this._inverseMeasure.top, this._inverseMeasure.width, this._inverseMeasure.height);
            } else contextToDrawTo.clearRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        }
        this._localDraw(contextToDrawTo);
        context.save();
        if (this.clipChildren) this._clipForChildren(contextToDrawTo);
        for (const child of this._children){
            // Only redraw parts of the screen that are invalidated
            if (invalidatedRectangle) {
                if (!child._intersectsRect(invalidatedRectangle)) continue;
            }
            child._render(contextToDrawTo, invalidatedRectangle);
        }
        if (renderToIntermediateTextureThisDraw) {
            contextToDrawTo.restore();
            context.save();
            context.globalAlpha = this.alpha;
            context.drawImage(contextToDrawTo.canvas, this._currentMeasure.left, this._currentMeasure.top);
            context.restore();
        }
        context.restore();
    }
    getDescendantsToRef(results, directDescendantsOnly = false, predicate) {
        if (!this.children) return;
        for(let index = 0; index < this.children.length; index++){
            const item = this.children[index];
            if (!predicate || predicate(item)) results.push(item);
            if (!directDescendantsOnly) item.getDescendantsToRef(results, false, predicate);
        }
    }
    /**
     * @internal
     */ _processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled || !this.isVisible || this.notRenderable) return false;
        // checks if the picking position is within the container
        const contains = super.contains(x, y);
        // if clipChildren is off, we should still pass picking events to children even if we don't contain the pointer
        if (!contains && this.clipChildren) return false;
        if (this.delegatePickingToChildren) {
            let contains = false;
            for(let index = this._children.length - 1; index >= 0; index--){
                const child = this._children[index];
                if (child.isEnabled && child.isHitTestVisible && child.isVisible && !child.notRenderable && child.contains(x, y)) {
                    contains = true;
                    break;
                }
            }
            if (!contains) return false;
        }
        // Checking backwards to pick closest first
        for(let index = this._children.length - 1; index >= 0; index--){
            const child = this._children[index];
            if (child._processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY)) {
                if (child.hoverCursor) this._host._changeCursor(child.hoverCursor);
                return true;
            }
        }
        if (!contains) return false;
        if (!this.isHitTestVisible) return false;
        return this._processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY);
    }
    /**
     * @internal
     */ _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.copyFrom(this._currentMeasure);
    }
    _getAdaptDimTo(dim) {
        if (dim === "width") return this.adaptWidthToChildren;
        else return this.adaptHeightToChildren;
    }
    isDimensionFullyDefined(dim) {
        if (this._getAdaptDimTo(dim)) {
            for (const child of this.children){
                if (!child.isDimensionFullyDefined(dim)) return false;
            }
            return true;
        }
        return super.isDimensionFullyDefined(dim);
    }
    /**
     * Serializes the current control
     * @param serializationObject defined the JSON serialized object
     * @param force force serialization even if isSerializable === false
     * @param allowCanvas defines if the control is allowed to use a Canvas2D object to serialize (true by default)
     */ serialize(serializationObject, force = false, allowCanvas = true) {
        super.serialize(serializationObject, force, allowCanvas);
        if (!this.isSerializable && !force) return;
        if (this.backgroundGradient) {
            serializationObject.backgroundGradient = {};
            this.backgroundGradient.serialize(serializationObject.backgroundGradient);
        }
        if (!this.children.length) return;
        serializationObject.children = [];
        for (const child of this.children)if (child.isSerializable || force) {
            const childSerializationObject = {};
            child.serialize(childSerializationObject, force, allowCanvas);
            serializationObject.children.push(childSerializationObject);
        }
    }
    /** Releases associated resources */ dispose() {
        super.dispose();
        for(let index = this.children.length - 1; index >= 0; index--)this.children[index].dispose();
        this._intermediateTexture?.dispose();
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host, urlRewriter) {
        super._parseFromContent(serializedObject, host, urlRewriter);
        this._link(host);
        // Gradient
        if (serializedObject.backgroundGradient) {
            const className = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.backgroundGradient.className);
            this._backgroundGradient = new className();
            this._backgroundGradient?.parse(serializedObject.backgroundGradient);
        }
        if (!serializedObject.children) return;
        for (const childData of serializedObject.children)this.addControl((0, $b6009490051f50fb$export$7a7fa4424cb20976).Parse(childData, host, urlRewriter));
    }
    isReady() {
        for (const child of this.children){
            if (!child.isReady()) return false;
        }
        return true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "delegatePickingToChildren", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "renderToIntermediateTexture", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "maxLayoutCycle", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "adaptHeightToChildren", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "adaptWidthToChildren", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "background", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "backgroundGradient", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Container", $a86b55aad2faeec0$export$42a852a2b6b56249);




var $diGQf = parcelRequire("diGQf");

class $bbb45ad35b4d0430$export$d9e45bc13d335801 {
    /**
     * Creates a new style object
     * @param host defines the AdvancedDynamicTexture which hosts this style
     */ constructor(host){
        this._fontFamily = "Arial";
        this._fontStyle = "";
        this._fontWeight = "";
        /** @internal */ this._fontSize = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(18, (0, $a038095510e5ba9b$export$839f347a6ebe19f5).UNITMODE_PIXEL, false);
        /**
         * Observable raised when the style values are changed
         */ this.onChangedObservable = new (0, $diGQf.Observable)();
        this._host = host;
    }
    /**
     * Gets or sets the font size
     */ get fontSize() {
        return this._fontSize.toString(this._host);
    }
    set fontSize(value) {
        if (this._fontSize.toString(this._host) === value) return;
        if (this._fontSize.fromString(value)) this.onChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets the font family
     */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this.onChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets the font style
     */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value;
        this.onChangedObservable.notifyObservers(this);
    }
    /** Gets or sets font weight */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this.onChangedObservable.notifyObservers(this);
    }
    /** Dispose all associated resources */ dispose() {
        this.onChangedObservable.clear();
    }
}





var $191mA = parcelRequire("191mA");

var $7etnY = parcelRequire("7etnY");

var $hUzEl = parcelRequire("hUzEl");

var $321Uk = parcelRequire("321Uk");

var $8DoUR = parcelRequire("8DoUR");

var $eLv1o = parcelRequire("eLv1o");
class $dc13400b3dc126d8$export$f032279d572248ce extends (0, $b7371b076ec25b92$export$da80c28953472f54) {
    /** Gets the number of layout calls made the last time the ADT has been rendered */ get numLayoutCalls() {
        return this._numLayoutCalls;
    }
    /** Gets the number of render calls made the last time the ADT has been rendered */ get numRenderCalls() {
        return this._numRenderCalls;
    }
    /**
     * Gets or sets a number used to scale rendering size (2 means that the texture will be twice bigger).
     * Useful when you want more antialiasing
     */ get renderScale() {
        return this._renderScale;
    }
    set renderScale(value) {
        if (value === this._renderScale) return;
        this._renderScale = value;
        this._onResize();
    }
    /** Gets or sets the background color */ get background() {
        return this._background;
    }
    set background(value) {
        if (this._background === value) return;
        this._background = value;
        this.markAsDirty();
    }
    /**
     * Gets or sets the ideal width used to design controls.
     * The GUI will then rescale everything accordingly
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get idealWidth() {
        return this._idealWidth;
    }
    set idealWidth(value) {
        if (this._idealWidth === value) return;
        this._idealWidth = value;
        this.markAsDirty();
        this._rootContainer._markAllAsDirty();
    }
    /**
     * Gets or sets the ideal height used to design controls.
     * The GUI will then rescale everything accordingly
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get idealHeight() {
        return this._idealHeight;
    }
    set idealHeight(value) {
        if (this._idealHeight === value) return;
        this._idealHeight = value;
        this.markAsDirty();
        this._rootContainer._markAllAsDirty();
    }
    /**
     * Gets or sets a boolean indicating if the smallest ideal value must be used if idealWidth and idealHeight are both set
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get useSmallestIdeal() {
        return this._useSmallestIdeal;
    }
    set useSmallestIdeal(value) {
        if (this._useSmallestIdeal === value) return;
        this._useSmallestIdeal = value;
        this.markAsDirty();
        this._rootContainer._markAllAsDirty();
    }
    /**
     * Gets or sets a boolean indicating if adaptive scaling must be used
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get renderAtIdealSize() {
        return this._renderAtIdealSize;
    }
    set renderAtIdealSize(value) {
        if (this._renderAtIdealSize === value) return;
        this._renderAtIdealSize = value;
        this._onResize();
    }
    /**
     * Gets the ratio used when in "ideal mode"
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     * */ get idealRatio() {
        let rwidth = 0;
        let rheight = 0;
        if (this._idealWidth) rwidth = this.getSize().width / this._idealWidth;
        if (this._idealHeight) rheight = this.getSize().height / this._idealHeight;
        if (this._useSmallestIdeal && this._idealWidth && this._idealHeight) return window.innerWidth < window.innerHeight ? rwidth : rheight;
        if (this._idealWidth) // horizontal
        return rwidth;
        if (this._idealHeight) // vertical
        return rheight;
        return 1;
    }
    /**
     * Gets the underlying layer used to render the texture when in fullscreen mode
     */ get layer() {
        return this._layerToDispose;
    }
    /**
     * Gets the root container control
     */ get rootContainer() {
        return this._rootContainer;
    }
    /**
     * Returns an array containing the root container.
     * This is mostly used to let the Inspector introspects the ADT
     * @returns an array containing the rootContainer
     */ getChildren() {
        return [
            this._rootContainer
        ];
    }
    /**
     * Will return all controls that are inside this texture
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns all child controls
     */ getDescendants(directDescendantsOnly, predicate) {
        return this._rootContainer.getDescendants(directDescendantsOnly, predicate);
    }
    /**
     * Will return all controls with the given type name
     * @param typeName defines the type name to search for
     * @returns an array of all controls found
     */ getControlsByType(typeName) {
        return this._rootContainer.getDescendants(false, (control)=>control.typeName === typeName);
    }
    /**
     * Will return the first control with the given name
     * @param name defines the name to search for
     * @returns the first control found or null
     */ getControlByName(name) {
        return this._getControlByKey("name", name);
    }
    _getControlByKey(key, value) {
        return this._rootContainer.getDescendants().find((control)=>control[key] === value) || null;
    }
    /**
     * Gets or sets the current focused control
     */ get focusedControl() {
        return this._focusedControl;
    }
    set focusedControl(control) {
        if (this._focusedControl == control) return;
        if (this._focusedControl) this._focusedControl.onBlur();
        if (control) control.onFocus();
        this._focusedControl = control;
    }
    /**
     * Gets or sets a boolean indicating if the texture must be rendered in background or foreground when in fullscreen mode
     */ get isForeground() {
        if (!this.layer) return true;
        return !this.layer.isBackground;
    }
    set isForeground(value) {
        if (!this.layer) return;
        if (this.layer.isBackground === !value) return;
        this.layer.isBackground = !value;
    }
    /**
     * Gets or set information about clipboardData
     */ get clipboardData() {
        return this._clipboardData;
    }
    set clipboardData(value) {
        this._clipboardData = value;
    }
    /** @internal */ constructor(name, widthOrOptions, _height = 0, scene, generateMipMaps = false, samplingMode = (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, invertY = true){
        widthOrOptions = widthOrOptions ?? 0;
        const width = typeof widthOrOptions === "object" && widthOrOptions !== undefined ? widthOrOptions.width ?? 0 : widthOrOptions ?? 0;
        const height = typeof widthOrOptions === "object" && widthOrOptions !== undefined ? widthOrOptions.height ?? 0 : _height;
        super(name, {
            width: width,
            height: height
        }, typeof widthOrOptions === "object" && widthOrOptions !== undefined ? widthOrOptions : scene, generateMipMaps, samplingMode, (0, $bd523120f282dc29$export$a002182e51710d39).TEXTUREFORMAT_RGBA, invertY);
        /** Indicates whether the ADT is used autonomously */ this.useStandalone = false;
        /** Observable that fires when the GUI is ready */ this.onGuiReadyObservable = new (0, $diGQf.Observable)();
        this._isDirty = false;
        /** @internal */ this._rootContainer = new (0, $a86b55aad2faeec0$export$42a852a2b6b56249)("root");
        /** @internal */ this._lastControlOver = {};
        /** @internal */ this._lastControlDown = {};
        /** @internal */ this._capturingControl = {};
        /** @internal */ this._linkedControls = new Array();
        /** @internal */ this._isFullscreen = false;
        this._fullscreenViewport = new (0, $191mA.Viewport)(0, 0, 1, 1);
        this._idealWidth = 0;
        this._idealHeight = 0;
        this._useSmallestIdeal = false;
        this._renderAtIdealSize = false;
        this._blockNextFocusCheck = false;
        this._renderScale = 1;
        this._cursorChanged = false;
        this._defaultMousePointerId = 0;
        this._rootChildrenHaveChanged = false;
        /** @internal */ this._capturedPointerIds = new Set();
        /** @internal */ this._numLayoutCalls = 0;
        /** @internal */ this._numRenderCalls = 0;
        /**
         * Define type to string to ensure compatibility across browsers
         * Safari doesn't support DataTransfer constructor
         */ this._clipboardData = "";
        /**
         * Observable event triggered each time an clipboard event is received from the rendering canvas
         */ this.onClipboardObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time a pointer down is intercepted by a control
         */ this.onControlPickedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered before layout is evaluated
         */ this.onBeginLayoutObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered after the layout was evaluated
         */ this.onEndLayoutObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered before the texture is rendered
         */ this.onBeginRenderObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered after the texture was rendered
         */ this.onEndRenderObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean defining if alpha is stored as premultiplied
         */ this.premulAlpha = false;
        /**
         * Gets or sets a boolean indicating that the canvas must be reverted on Y when updating the texture
         */ this.applyYInversionOnUpdate = true;
        /**
         * A boolean indicating whether or not the elements can be navigated to using the tab key.
         * Defaults to false.
         */ this.disableTabNavigation = false;
        /**
         * A boolean indicating whether controls can be picked/clicked on or not. Defaults to false.
         */ this.disablePicking = false;
        /**
         * If set to true, the POINTERTAP event type will be used for "click", instead of POINTERUP
         */ this.usePointerTapForClickEvent = false;
        /**
         * If this is set, even when a control is pointer blocker, some events can still be passed through to the scene.
         * Options from values are PointerEventTypes
         * POINTERDOWN, POINTERUP, POINTERMOVE, POINTERWHEEL, POINTERPICK, POINTERTAP, POINTERDOUBLETAP
         */ this.skipBlockEvents = 0;
        /**
         * If set to true, every scene render will trigger a pointer event for the GUI
         * if it is linked to a mesh or has controls linked to a mesh. This will allow
         * you to catch the pointer moving around the GUI due to camera or mesh movements,
         * but it has a performance cost.
         */ this.checkPointerEveryFrame = false;
        this._useInvalidateRectOptimization = true;
        // Invalidated rectangle which is the combination of all invalidated controls after they have been rotated into absolute position
        this._invalidatedRectangle = null;
        this._clearMeasure = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, 0, 0);
        this._focusProperties = {
            index: 0,
            total: -1
        };
        /**
         * @internal
         */ this._onClipboardCopy = (rawEvt)=>{
            const evt = rawEvt;
            const ev = new (0, $69c5a2609ea6c722$export$738268be25b46e31)((0, $69c5a2609ea6c722$export$1b8ff22bd0e43412).COPY, evt);
            this.onClipboardObservable.notifyObservers(ev);
            evt.preventDefault();
        };
        /**
         * @internal
         */ this._onClipboardCut = (rawEvt)=>{
            const evt = rawEvt;
            const ev = new (0, $69c5a2609ea6c722$export$738268be25b46e31)((0, $69c5a2609ea6c722$export$1b8ff22bd0e43412).CUT, evt);
            this.onClipboardObservable.notifyObservers(ev);
            evt.preventDefault();
        };
        /**
         * @internal
         */ this._onClipboardPaste = (rawEvt)=>{
            const evt = rawEvt;
            const ev = new (0, $69c5a2609ea6c722$export$738268be25b46e31)((0, $69c5a2609ea6c722$export$1b8ff22bd0e43412).PASTE, evt);
            this.onClipboardObservable.notifyObservers(ev);
            evt.preventDefault();
        };
        /**
         * Recreate the content of the ADT from a JSON object
         * @param serializedObject define the JSON serialized object to restore from
         * @param scaleToSize defines whether to scale to texture to the saved size
         * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
         * @deprecated Please use parseSerializedObject instead
         */ this.parseContent = this.parseSerializedObject;
        scene = this.getScene();
        if (!scene || !this._texture) return;
        this.applyYInversionOnUpdate = invertY;
        this._rootElement = scene.getEngine().getInputElement();
        const adtOptions = widthOrOptions;
        this.useStandalone = !!adtOptions?.useStandalone;
        if (!this.useStandalone) this._renderObserver = scene.onBeforeCameraRenderObservable.add((camera)=>this._checkUpdate(camera));
        /** Whenever a control is added or removed to the root, we have to recheck the camera projection as it can have changed  */ this._controlAddedObserver = this._rootContainer.onControlAddedObservable.add((control)=>{
            if (control) this._rootChildrenHaveChanged = true;
        });
        this._controlRemovedObserver = this._rootContainer.onControlRemovedObservable.add((control)=>{
            if (control) this._rootChildrenHaveChanged = true;
        });
        this._preKeyboardObserver = scene.onPreKeyboardObservable.add((info)=>{
            // check if tab is pressed
            if (!this.disableTabNavigation && info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN && info.event.code === "Tab") {
                const forward = !info.event.shiftKey;
                if (forward && this._focusProperties.index === this._focusProperties.total - 1 || !forward && this._focusProperties.index === 0 && this._focusProperties.total > 0) {
                    this.focusedControl = null;
                    this._focusProperties.index = 0;
                    this._focusProperties.total = -1;
                    return;
                }
                this._focusNextElement(forward);
                info.event.preventDefault();
                return;
            }
            if (!this._focusedControl) return;
            if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) this._focusedControl.processKeyboard(info.event);
            info.skipOnPointerObservable = true;
        });
        this._rootContainer._link(this);
        this.hasAlpha = true;
        if (!width || !height) {
            this._resizeObserver = scene.getEngine().onResizeObservable.add(()=>this._onResize());
            this._onResize();
        }
        this._texture.isReady = true;
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "AdvancedDynamicTexture"
     */ getClassName() {
        return "AdvancedDynamicTexture";
    }
    /**
     * Function used to execute a function on all controls
     * @param func defines the function to execute
     * @param container defines the container where controls belong. If null the root container will be used
     */ executeOnAllControls(func, container) {
        if (!container) container = this._rootContainer;
        func(container);
        for (const child of container.children){
            if (child.children) {
                this.executeOnAllControls(func, child);
                continue;
            }
            func(child);
        }
    }
    /**
     * Gets or sets a boolean indicating if the InvalidateRect optimization should be turned on
     */ get useInvalidateRectOptimization() {
        return this._useInvalidateRectOptimization;
    }
    set useInvalidateRectOptimization(value) {
        this._useInvalidateRectOptimization = value;
    }
    /**
     * Invalidates a rectangle area on the gui texture
     * @param invalidMinX left most position of the rectangle to invalidate in the texture
     * @param invalidMinY top most position of the rectangle to invalidate in the texture
     * @param invalidMaxX right most position of the rectangle to invalidate in the texture
     * @param invalidMaxY bottom most position of the rectangle to invalidate in the texture
     */ invalidateRect(invalidMinX, invalidMinY, invalidMaxX, invalidMaxY) {
        if (!this._useInvalidateRectOptimization) return;
        if (!this._invalidatedRectangle) this._invalidatedRectangle = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(invalidMinX, invalidMinY, invalidMaxX - invalidMinX + 1, invalidMaxY - invalidMinY + 1);
        else {
            // Compute intersection
            const maxX = Math.ceil(Math.max(this._invalidatedRectangle.left + this._invalidatedRectangle.width - 1, invalidMaxX));
            const maxY = Math.ceil(Math.max(this._invalidatedRectangle.top + this._invalidatedRectangle.height - 1, invalidMaxY));
            this._invalidatedRectangle.left = Math.floor(Math.min(this._invalidatedRectangle.left, invalidMinX));
            this._invalidatedRectangle.top = Math.floor(Math.min(this._invalidatedRectangle.top, invalidMinY));
            this._invalidatedRectangle.width = maxX - this._invalidatedRectangle.left + 1;
            this._invalidatedRectangle.height = maxY - this._invalidatedRectangle.top + 1;
        }
    }
    /**
     * Marks the texture as dirty forcing a complete update
     */ markAsDirty() {
        this._isDirty = true;
    }
    /**
     * Helper function used to create a new style
     * @returns a new style
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#styles
     */ createStyle() {
        return new (0, $bbb45ad35b4d0430$export$d9e45bc13d335801)(this);
    }
    /**
     * Adds a new control to the root container
     * @param control defines the control to add
     * @returns the current texture
     */ addControl(control) {
        this._rootContainer.addControl(control);
        return this;
    }
    /**
     * Removes a control from the root container
     * @param control defines the control to remove
     * @returns the current texture
     */ removeControl(control) {
        this._rootContainer.removeControl(control);
        return this;
    }
    /**
     * Moves overlapped controls towards a position where it is not overlapping anymore.
     * Please note that this method alters linkOffsetXInPixels and linkOffsetYInPixels.
     * @param overlapGroup the overlap group which will be processed or undefined to process all overlap groups
     * @param deltaStep the step size (speed) to reach the target non overlapping position (default 0.1)
     * @param repelFactor how much is the control repelled by other controls
     */ moveToNonOverlappedPosition(overlapGroup, deltaStep = 1, repelFactor = 1) {
        let controlsForGroup;
        if (Array.isArray(overlapGroup)) controlsForGroup = overlapGroup;
        else {
            const descendants = this.getDescendants(true);
            // get only the controls with an overlapGroup property set
            // if the overlapGroup parameter is set, filter the controls and get only the controls belonging to that overlapGroup
            controlsForGroup = overlapGroup === undefined ? descendants.filter((c)=>c.overlapGroup !== undefined) : descendants.filter((c)=>c.overlapGroup === overlapGroup);
        }
        controlsForGroup.forEach((control1)=>{
            let velocity = (0, $ha1VO.Vector2).Zero();
            const center = new (0, $ha1VO.Vector2)(control1.centerX, control1.centerY);
            controlsForGroup.forEach((control2)=>{
                if (control1 !== control2 && $dc13400b3dc126d8$export$f032279d572248ce._Overlaps(control1, control2)) {
                    // if the two controls overlaps get a direction vector from one control's center to another control's center
                    const diff = center.subtract(new (0, $ha1VO.Vector2)(control2.centerX, control2.centerY));
                    const diffLength = diff.length();
                    if (diffLength > 0) // calculate the velocity
                    velocity = velocity.add(diff.normalize().scale(repelFactor / diffLength));
                }
            });
            if (velocity.length() > 0) {
                // move the control along the direction vector away from the overlapping control
                velocity = velocity.normalize().scale(deltaStep * (control1.overlapDeltaMultiplier ?? 1));
                control1.linkOffsetXInPixels += velocity.x;
                control1.linkOffsetYInPixels += velocity.y;
            }
        });
    }
    /**
     * Release all resources
     */ dispose() {
        const scene = this.getScene();
        if (!scene) return;
        this._rootElement = null;
        scene.onBeforeCameraRenderObservable.remove(this._renderObserver);
        if (this._resizeObserver) scene.getEngine().onResizeObservable.remove(this._resizeObserver);
        if (this._prePointerObserver) scene.onPrePointerObservable.remove(this._prePointerObserver);
        if (this._sceneRenderObserver) scene.onBeforeRenderObservable.remove(this._sceneRenderObserver);
        if (this._pointerObserver) scene.onPointerObservable.remove(this._pointerObserver);
        if (this._preKeyboardObserver) scene.onPreKeyboardObservable.remove(this._preKeyboardObserver);
        if (this._canvasPointerOutObserver) scene.getEngine().onCanvasPointerOutObservable.remove(this._canvasPointerOutObserver);
        if (this._canvasBlurObserver) scene.getEngine().onCanvasBlurObservable.remove(this._canvasBlurObserver);
        if (this._controlAddedObserver) this._rootContainer.onControlAddedObservable.remove(this._controlAddedObserver);
        if (this._controlRemovedObserver) this._rootContainer.onControlRemovedObservable.remove(this._controlRemovedObserver);
        if (this._layerToDispose) {
            this._layerToDispose.texture = null;
            this._layerToDispose.dispose();
            this._layerToDispose = null;
        }
        this._rootContainer.dispose();
        this.onClipboardObservable.clear();
        this.onControlPickedObservable.clear();
        this.onBeginRenderObservable.clear();
        this.onEndRenderObservable.clear();
        this.onBeginLayoutObservable.clear();
        this.onEndLayoutObservable.clear();
        this.onGuiReadyObservable.clear();
        super.dispose();
    }
    _onResize() {
        const scene = this.getScene();
        if (!scene) return;
        // Check size
        const engine = scene.getEngine();
        const textureSize = this.getSize();
        let renderWidth = engine.getRenderWidth() * this._renderScale;
        let renderHeight = engine.getRenderHeight() * this._renderScale;
        if (this._renderAtIdealSize) {
            if (this._idealWidth) {
                renderHeight = renderHeight * this._idealWidth / renderWidth;
                renderWidth = this._idealWidth;
            } else if (this._idealHeight) {
                renderWidth = renderWidth * this._idealHeight / renderHeight;
                renderHeight = this._idealHeight;
            }
        }
        if (textureSize.width !== renderWidth || textureSize.height !== renderHeight) {
            this.scaleTo(renderWidth, renderHeight);
            this.markAsDirty();
            if (this._idealWidth || this._idealHeight) this._rootContainer._markAllAsDirty();
        }
        this.invalidateRect(0, 0, textureSize.width - 1, textureSize.height - 1);
    }
    /** @internal */ _getGlobalViewport() {
        const size = this.getSize();
        const globalViewPort = this._fullscreenViewport.toGlobal(size.width, size.height);
        const targetX = Math.round(globalViewPort.width * (1 / this.rootContainer.scaleX));
        const targetY = Math.round(globalViewPort.height * (1 / this.rootContainer.scaleY));
        globalViewPort.x += (globalViewPort.width - targetX) / 2;
        globalViewPort.y += (globalViewPort.height - targetY) / 2;
        globalViewPort.width = targetX;
        globalViewPort.height = targetY;
        return globalViewPort;
    }
    /**
     * Get screen coordinates for a vector3
     * @param position defines the position to project
     * @param worldMatrix defines the world matrix to use
     * @returns the projected position
     */ getProjectedPosition(position, worldMatrix) {
        const result = this.getProjectedPositionWithZ(position, worldMatrix);
        return new (0, $ha1VO.Vector2)(result.x, result.y);
    }
    /**
     * Get screen coordinates for a vector3
     * @param position defines the position to project
     * @param worldMatrix defines the world matrix to use
     * @returns the projected position with Z
     */ getProjectedPositionWithZ(position, worldMatrix) {
        const scene = this.getScene();
        if (!scene) return (0, $ha1VO.Vector3).Zero();
        const globalViewport = this._getGlobalViewport();
        const projectedPosition = (0, $ha1VO.Vector3).Project(position, worldMatrix, scene.getTransformMatrix(), globalViewport);
        return new (0, $ha1VO.Vector3)(projectedPosition.x, projectedPosition.y, projectedPosition.z);
    }
    /** @internal */ _checkUpdate(camera, skipUpdate) {
        if (this._layerToDispose && camera) {
            if ((camera.layerMask & this._layerToDispose.layerMask) === 0) return;
        }
        if (this._isFullscreen && this._linkedControls.length) {
            const scene = this.getScene();
            if (!scene) return;
            const globalViewport = this._getGlobalViewport();
            for (const control of this._linkedControls){
                if (!control.isVisible) continue;
                const mesh = control._linkedMesh;
                if (!mesh || mesh.isDisposed()) {
                    (0, $bOhSV.Tools).SetImmediate(()=>{
                        control.linkWithMesh(null);
                    });
                    continue;
                }
                const position = mesh.getBoundingInfo ? mesh.getBoundingInfo().boundingSphere.center : (0, $ha1VO.Vector3).ZeroReadOnly;
                const projectedPosition = (0, $ha1VO.Vector3).Project(position, mesh.getWorldMatrix(), scene.getTransformMatrix(), globalViewport);
                if (projectedPosition.z < 0 || projectedPosition.z > 1) {
                    control.notRenderable = true;
                    continue;
                }
                control.notRenderable = false;
                if (this.useInvalidateRectOptimization) control.invalidateRect();
                control._moveToProjectedPosition(projectedPosition);
            }
        }
        if (!this._isDirty && !this._rootContainer.isDirty) return;
        this._isDirty = false;
        this._render(skipUpdate);
        if (!skipUpdate) this.update(this.applyYInversionOnUpdate, this.premulAlpha, $dc13400b3dc126d8$export$f032279d572248ce.AllowGPUOptimizations);
    }
    _render(skipRender) {
        const textureSize = this.getSize();
        const renderWidth = textureSize.width;
        const renderHeight = textureSize.height;
        const context = this.getContext();
        context.font = "18px Arial";
        context.strokeStyle = "white";
        if (this.onGuiReadyObservable.hasObservers()) this._checkGuiIsReady();
        /** We have to recheck the camera projection in the case the root control's children have changed  */ if (this._rootChildrenHaveChanged) {
            const camera = this.getScene()?.activeCamera;
            if (camera) {
                this._rootChildrenHaveChanged = false;
                this._checkUpdate(camera, true);
            }
        }
        // Layout
        this.onBeginLayoutObservable.notifyObservers(this);
        const measure = new (0, $fc6a12d4b9dc7831$export$76df7375f104822f)(0, 0, renderWidth, renderHeight);
        this._numLayoutCalls = 0;
        this._rootContainer._layout(measure, context);
        this.onEndLayoutObservable.notifyObservers(this);
        this._isDirty = false; // Restoring the dirty state that could have been set by controls during layout processing
        if (skipRender) return;
        // Clear
        if (this._invalidatedRectangle) this._clearMeasure.copyFrom(this._invalidatedRectangle);
        else this._clearMeasure.copyFromFloats(0, 0, renderWidth, renderHeight);
        context.clearRect(this._clearMeasure.left, this._clearMeasure.top, this._clearMeasure.width, this._clearMeasure.height);
        if (this._background) {
            context.save();
            context.fillStyle = this._background;
            context.fillRect(this._clearMeasure.left, this._clearMeasure.top, this._clearMeasure.width, this._clearMeasure.height);
            context.restore();
        }
        // Render
        this.onBeginRenderObservable.notifyObservers(this);
        this._numRenderCalls = 0;
        this._rootContainer._render(context, this._invalidatedRectangle);
        this.onEndRenderObservable.notifyObservers(this);
        this._invalidatedRectangle = null;
    }
    /**
     * @internal
     */ _changeCursor(cursor) {
        if (this._rootElement) {
            this._rootElement.style.cursor = cursor;
            this._cursorChanged = true;
        }
    }
    /**
     * @internal
     */ _registerLastControlDown(control, pointerId) {
        this._lastControlDown[pointerId] = control;
        this.onControlPickedObservable.notifyObservers(control);
    }
    _doPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        const scene = this.getScene();
        if (!scene || this.disablePicking) return;
        const engine = scene.getEngine();
        const textureSize = this.getSize();
        if (this._isFullscreen) {
            const camera = scene.cameraToUseForPointers || scene.activeCamera;
            if (!camera) return;
            const viewport = camera.viewport;
            x = x * (textureSize.width / (engine.getRenderWidth() * viewport.width));
            y = y * (textureSize.height / (engine.getRenderHeight() * viewport.height));
        }
        if (this._capturingControl[pointerId]) {
            if (this._capturingControl[pointerId].isPointerBlocker) this._shouldBlockPointer = true;
            this._capturingControl[pointerId]._processObservables(type, x, y, pi, pointerId, buttonIndex);
            return;
        }
        this._cursorChanged = false;
        if (!this._rootContainer._processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY)) {
            if (!scene.doNotHandleCursors) this._changeCursor("");
            if (type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (this._lastControlOver[pointerId]) {
                    this._lastControlOver[pointerId]._onPointerOut(this._lastControlOver[pointerId], pi);
                    delete this._lastControlOver[pointerId];
                }
            }
        }
        if (!this._cursorChanged && !scene.doNotHandleCursors) this._changeCursor("");
        this._manageFocus();
    }
    /**
     * @internal
     */ _cleanControlAfterRemovalFromList(list, control) {
        for(const pointerId in list){
            if (!Object.prototype.hasOwnProperty.call(list, pointerId)) continue;
            const lastControlOver = list[pointerId];
            if (lastControlOver === control) delete list[pointerId];
        }
    }
    /**
     * @internal
     */ _cleanControlAfterRemoval(control) {
        this._cleanControlAfterRemovalFromList(this._lastControlDown, control);
        this._cleanControlAfterRemovalFromList(this._lastControlOver, control);
    }
    /**
     * This function will run a pointer event on this ADT and will trigger any pointer events on any controls
     * This will work on a fullscreen ADT only. For mesh based ADT, simulate pointer events using the scene directly.
     * @param x pointer X on the canvas for the picking
     * @param y pointer Y on the canvas for the picking
     * @param pi optional pointer information
     */ pick(x, y, pi = null) {
        if (this._isFullscreen && this._scene) this._translateToPicking(this._scene, new (0, $191mA.Viewport)(0, 0, 0, 0), pi, x, y);
    }
    _translateToPicking(scene, tempViewport, pi, x = scene.pointerX, y = scene.pointerY) {
        const camera = scene.cameraToUseForPointers || scene.activeCamera;
        const engine = scene.getEngine();
        const originalCameraToUseForPointers = scene.cameraToUseForPointers;
        if (!camera) {
            tempViewport.x = 0;
            tempViewport.y = 0;
            tempViewport.width = engine.getRenderWidth();
            tempViewport.height = engine.getRenderHeight();
        } else if (camera.rigCameras.length) {
            // rig camera - we need to find the camera to use for this event
            const rigViewport = new (0, $191mA.Viewport)(0, 0, 1, 1);
            camera.rigCameras.forEach((rigCamera)=>{
                // generate the viewport of this camera
                rigCamera.viewport.toGlobalToRef(engine.getRenderWidth(), engine.getRenderHeight(), rigViewport);
                const transformedX = x / engine.getHardwareScalingLevel() - rigViewport.x;
                const transformedY = y / engine.getHardwareScalingLevel() - (engine.getRenderHeight() - rigViewport.y - rigViewport.height);
                // check if the pointer is in the camera's viewport
                if (transformedX < 0 || transformedY < 0 || x > rigViewport.width || y > rigViewport.height) // out of viewport - don't use this camera
                return;
                // set the camera to use for pointers until this pointer loop is over
                scene.cameraToUseForPointers = rigCamera;
                // set the viewport
                tempViewport.x = rigViewport.x;
                tempViewport.y = rigViewport.y;
                tempViewport.width = rigViewport.width;
                tempViewport.height = rigViewport.height;
            });
        } else camera.viewport.toGlobalToRef(engine.getRenderWidth(), engine.getRenderHeight(), tempViewport);
        const transformedX = x / engine.getHardwareScalingLevel() - tempViewport.x;
        const transformedY = y / engine.getHardwareScalingLevel() - (engine.getRenderHeight() - tempViewport.y - tempViewport.height);
        this._shouldBlockPointer = false;
        // Do picking modifies _shouldBlockPointer
        if (pi) {
            const pointerId = pi.event.pointerId || this._defaultMousePointerId;
            this._doPicking(transformedX, transformedY, pi, pi.type, pointerId, pi.event.button, pi.event.deltaX, pi.event.deltaY);
            // Avoid overwriting a true skipOnPointerObservable to false
            if (this._shouldBlockPointer && !(pi.type & this.skipBlockEvents) || this._capturingControl[pointerId]) pi.skipOnPointerObservable = true;
        } else this._doPicking(transformedX, transformedY, null, (0, $cfkw4.PointerEventTypes).POINTERMOVE, this._defaultMousePointerId, 0);
        // if overridden by a rig camera - reset back to the original value
        scene.cameraToUseForPointers = originalCameraToUseForPointers;
    }
    /** Attach to all scene events required to support pointer events */ attach() {
        const scene = this.getScene();
        if (!scene) return;
        const tempViewport = new (0, $191mA.Viewport)(0, 0, 0, 0);
        this._prePointerObserver = scene.onPrePointerObservable.add((pi)=>{
            if (scene.isPointerCaptured(pi.event.pointerId) && pi.type === (0, $cfkw4.PointerEventTypes).POINTERUP && !this._capturedPointerIds.has(pi.event.pointerId)) return;
            if (pi.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERUP && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERTAP) return;
            if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                // Avoid pointerMove events firing while the pointer is captured by the scene
                if (scene.isPointerCaptured(pi.event.pointerId)) return;
                if (pi.event.pointerId) this._defaultMousePointerId = pi.event.pointerId; // This is required to make sure we have the correct pointer ID for wheel
            }
            this._translateToPicking(scene, tempViewport, pi);
        });
        this._attachPickingToSceneRender(scene, ()=>this._translateToPicking(scene, tempViewport, null), false);
        this._attachToOnPointerOut(scene);
        this._attachToOnBlur(scene);
    }
    _focusNextElement(forward = true) {
        // generate the order of tab-able controls
        const sortedTabbableControls = [];
        this.executeOnAllControls((control)=>{
            if (control.isFocusInvisible || !control.isVisible || control.tabIndex < 0) return;
            sortedTabbableControls.push(control);
        });
        // if no control is tab-able, return
        if (sortedTabbableControls.length === 0) return;
        sortedTabbableControls.sort((a, b)=>{
            // if tabIndex is 0, put it in the end of the list, otherwise sort by tabIndex
            return a.tabIndex === 0 ? 1 : b.tabIndex === 0 ? -1 : a.tabIndex - b.tabIndex;
        });
        this._focusProperties.total = sortedTabbableControls.length;
        // if no control is focused, focus the first one
        let nextIndex = -1;
        if (!this._focusedControl) nextIndex = forward ? 0 : sortedTabbableControls.length - 1;
        else {
            const currentIndex = sortedTabbableControls.indexOf(this._focusedControl);
            nextIndex = currentIndex + (forward ? 1 : -1);
            if (nextIndex < 0) nextIndex = sortedTabbableControls.length - 1;
            else if (nextIndex >= sortedTabbableControls.length) nextIndex = 0;
        }
        sortedTabbableControls[nextIndex].focus();
        this._focusProperties.index = nextIndex;
    }
    /**
     * Register the clipboard Events onto the canvas
     */ registerClipboardEvents() {
        self.addEventListener("copy", this._onClipboardCopy, false);
        self.addEventListener("cut", this._onClipboardCut, false);
        self.addEventListener("paste", this._onClipboardPaste, false);
    }
    /**
     * Unregister the clipboard Events from the canvas
     */ unRegisterClipboardEvents() {
        self.removeEventListener("copy", this._onClipboardCopy);
        self.removeEventListener("cut", this._onClipboardCut);
        self.removeEventListener("paste", this._onClipboardPaste);
    }
    /**
     * Transform uvs from mesh space to texture space, taking the texture into account
     * @param uv the uvs in mesh space
     * @returns the uvs in texture space
     */ _transformUvs(uv) {
        const textureMatrix = this.getTextureMatrix();
        let result;
        if (textureMatrix.isIdentityAs3x2()) result = uv;
        else {
            const homogeneousTextureMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            textureMatrix.getRowToRef(0, (0, $ha1VO.TmpVectors).Vector4[0]);
            textureMatrix.getRowToRef(1, (0, $ha1VO.TmpVectors).Vector4[1]);
            textureMatrix.getRowToRef(2, (0, $ha1VO.TmpVectors).Vector4[2]);
            const r0 = (0, $ha1VO.TmpVectors).Vector4[0];
            const r1 = (0, $ha1VO.TmpVectors).Vector4[1];
            const r2 = (0, $ha1VO.TmpVectors).Vector4[2];
            homogeneousTextureMatrix.setRowFromFloats(0, r0.x, r0.y, 0, 0);
            homogeneousTextureMatrix.setRowFromFloats(1, r1.x, r1.y, 0, 0);
            homogeneousTextureMatrix.setRowFromFloats(2, 0, 0, 1, 0);
            homogeneousTextureMatrix.setRowFromFloats(3, r2.x, r2.y, 0, 1);
            result = (0, $ha1VO.TmpVectors).Vector2[0];
            (0, $ha1VO.Vector2).TransformToRef(uv, homogeneousTextureMatrix, result);
        }
        // In wrap and mirror mode, the texture coordinate for coordinates more than 1 is the fractional part of the coordinate
        if (this.wrapU === (0, $j2mX5.Texture).WRAP_ADDRESSMODE || this.wrapU === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE) {
            if (result.x > 1) {
                let fX = result.x - Math.trunc(result.x);
                // In mirror mode, the sign of the texture coordinate depends on the integer part -
                // odd integers means it is mirrored from the original coordinate
                if (this.wrapU === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE && Math.trunc(result.x) % 2 === 1) fX = 1 - fX;
                result.x = fX;
            }
        }
        if (this.wrapV === (0, $j2mX5.Texture).WRAP_ADDRESSMODE || this.wrapV === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE) {
            if (result.y > 1) {
                let fY = result.y - Math.trunc(result.y);
                if (this.wrapV === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE && Math.trunc(result.x) % 2 === 1) fY = 1 - fY;
                result.y = fY;
            }
        }
        return result;
    }
    /**
     * Connect the texture to a hosting mesh to enable interactions
     * @param mesh defines the mesh to attach to
     * @param supportPointerMove defines a boolean indicating if pointer move events must be catched as well
     */ attachToMesh(mesh, supportPointerMove = true) {
        const scene = this.getScene();
        if (!scene) return;
        if (this._pointerObserver) scene.onPointerObservable.remove(this._pointerObserver);
        this._pointerObserver = scene.onPointerObservable.add((pi)=>{
            if (pi.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERUP && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE && pi.event.pointerId) this._defaultMousePointerId = pi.event.pointerId; // This is required to make sure we have the correct pointer ID for wheel
            const pointerId = pi.event.pointerId || this._defaultMousePointerId;
            if (pi.pickInfo && pi.pickInfo.hit && pi.pickInfo.pickedMesh === mesh) {
                let uv = pi.pickInfo.getTextureCoordinates();
                if (uv) {
                    uv = this._transformUvs(uv);
                    const size = this.getSize();
                    this._doPicking(uv.x * size.width, (this.applyYInversionOnUpdate ? 1.0 - uv.y : uv.y) * size.height, pi, pi.type, pointerId, pi.event.button, pi.event.deltaX, pi.event.deltaY);
                }
            } else if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                if (this._lastControlDown[pointerId]) this._lastControlDown[pointerId]._forcePointerUp(pointerId);
                delete this._lastControlDown[pointerId];
                if (this.focusedControl) {
                    const friendlyControls = this.focusedControl.keepsFocusWith();
                    let canMoveFocus = true;
                    if (friendlyControls) for (const control of friendlyControls){
                        // Same host, no need to keep the focus
                        if (this === control._host) continue;
                        // Different hosts
                        const otherHost = control._host;
                        if (otherHost._lastControlOver[pointerId] && otherHost._lastControlOver[pointerId].isAscendant(control)) {
                            canMoveFocus = false;
                            break;
                        }
                    }
                    if (canMoveFocus) this.focusedControl = null;
                }
            } else if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (this._lastControlOver[pointerId]) this._lastControlOver[pointerId]._onPointerOut(this._lastControlOver[pointerId], pi, true);
                delete this._lastControlOver[pointerId];
            }
        });
        mesh.enablePointerMoveEvents = supportPointerMove;
        this._attachPickingToSceneRender(scene, ()=>{
            const pointerId = this._defaultMousePointerId;
            const pick = scene?.pick(scene.pointerX, scene.pointerY);
            if (pick && pick.hit && pick.pickedMesh === mesh) {
                let uv = pick.getTextureCoordinates();
                if (uv) {
                    uv = this._transformUvs(uv);
                    const size = this.getSize();
                    this._doPicking(uv.x * size.width, (this.applyYInversionOnUpdate ? 1.0 - uv.y : uv.y) * size.height, null, (0, $cfkw4.PointerEventTypes).POINTERMOVE, pointerId, 0);
                }
            } else {
                if (this._lastControlOver[pointerId]) this._lastControlOver[pointerId]._onPointerOut(this._lastControlOver[pointerId], null, true);
                delete this._lastControlOver[pointerId];
            }
        }, true);
        this._attachToOnPointerOut(scene);
        this._attachToOnBlur(scene);
    }
    /**
     * Move the focus to a specific control
     * @param control defines the control which will receive the focus
     */ moveFocusToControl(control) {
        this.focusedControl = control;
        this._lastPickedControl = control;
        this._blockNextFocusCheck = true;
    }
    _manageFocus() {
        if (this._blockNextFocusCheck) {
            this._blockNextFocusCheck = false;
            this._lastPickedControl = this._focusedControl;
            return;
        }
        // Focus management
        if (this._focusedControl) {
            if (this._focusedControl !== this._lastPickedControl) {
                if (this._lastPickedControl.isFocusInvisible) return;
                this.focusedControl = null;
            }
        }
    }
    _attachPickingToSceneRender(scene, pickFunction, forcePicking) {
        this._sceneRenderObserver = scene.onBeforeRenderObservable.add(()=>{
            if (!this.checkPointerEveryFrame) return;
            if (this._linkedControls.length > 0 || forcePicking) pickFunction();
        });
    }
    _attachToOnPointerOut(scene) {
        this._canvasPointerOutObserver = scene.getEngine().onCanvasPointerOutObservable.add((pointerEvent)=>{
            if (this._lastControlOver[pointerEvent.pointerId]) this._lastControlOver[pointerEvent.pointerId]._onPointerOut(this._lastControlOver[pointerEvent.pointerId], null);
            delete this._lastControlOver[pointerEvent.pointerId];
            if (this._lastControlDown[pointerEvent.pointerId] && this._lastControlDown[pointerEvent.pointerId] !== this._capturingControl[pointerEvent.pointerId]) {
                this._lastControlDown[pointerEvent.pointerId]._forcePointerUp(pointerEvent.pointerId);
                delete this._lastControlDown[pointerEvent.pointerId];
            }
        });
    }
    _attachToOnBlur(scene) {
        this._canvasBlurObserver = scene.getEngine().onCanvasBlurObservable.add(()=>{
            Object.entries(this._lastControlDown).forEach(([, value])=>{
                value._onCanvasBlur();
            });
            this.focusedControl = null;
            this._lastControlDown = {};
        });
    }
    /**
     * Serializes the entire GUI system
     * @returns an object with the JSON serialized data
     */ serializeContent() {
        const size = this.getSize();
        const serializationObject = {
            root: {},
            width: size.width,
            height: size.height
        };
        this._rootContainer.serialize(serializationObject.root);
        return serializationObject;
    }
    /**
     * Recreate the content of the ADT from a JSON object
     * @param serializedObject define the JSON serialized object to restore from
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     */ parseSerializedObject(serializedObject, scaleToSize, urlRewriter) {
        this._rootContainer = (0, $b6009490051f50fb$export$7a7fa4424cb20976).Parse(serializedObject.root, this, urlRewriter);
        if (scaleToSize) {
            const width = serializedObject.width;
            const height = serializedObject.height;
            if (typeof width === "number" && typeof height === "number" && width >= 0 && height >= 0) this.scaleTo(width, height);
            else // scales the GUI to a default size if none was available in the serialized content
            this.scaleTo(1920, 1080);
        }
    }
    /**
     * Clones the ADT. If no mesh is defined, the GUI will be considered as a fullscreen GUI
     * @param newName defines the name of the new ADT
     * @param attachToMesh defines if the new ADT should be attached to a mesh
     * @returns the clone of the ADT
     */ clone(newName, attachToMesh) {
        const scene = this.getScene();
        if (!scene) return this;
        const size = this.getSize();
        const data = this.serializeContent();
        let clone;
        if (!this._isFullscreen) {
            if (attachToMesh) clone = $dc13400b3dc126d8$export$f032279d572248ce.CreateForMesh(attachToMesh, size.width, size.height);
            else clone = new $dc13400b3dc126d8$export$f032279d572248ce(newName ?? "Clone of " + this.name, size.width, size.height, scene, !this.noMipmap, this.samplingMode);
        } else clone = $dc13400b3dc126d8$export$f032279d572248ce.CreateFullscreenUI(newName ?? "Clone of " + this.name);
        clone.parseSerializedObject(data);
        return clone;
    }
    /**
     * Recreate the content of the ADT from a snippet saved by the GUI editor
     * @param snippetId defines the snippet to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param appendToAdt if provided the snippet will be appended to the adt. Otherwise a fullscreen ADT will be created.
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     * @returns a promise that will resolve on success
     */ static async ParseFromSnippetAsync(snippetId, scaleToSize, appendToAdt, urlRewriter) {
        const adt = appendToAdt ?? $dc13400b3dc126d8$export$f032279d572248ce.CreateFullscreenUI("ADT from snippet");
        if (snippetId === "_BLANK") return adt;
        const serialized = await $dc13400b3dc126d8$export$f032279d572248ce._LoadURLContentAsync($dc13400b3dc126d8$export$f032279d572248ce.SnippetUrl + "/" + snippetId.replace(/#/g, "/"), true);
        adt.parseSerializedObject(serialized, scaleToSize, urlRewriter);
        return adt;
    }
    /**
     * Recreate the content of the ADT from a snippet saved by the GUI editor
     * @param snippetId defines the snippet to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     * @returns a promise that will resolve on success
     */ parseFromSnippetAsync(snippetId, scaleToSize, urlRewriter) {
        return $dc13400b3dc126d8$export$f032279d572248ce.ParseFromSnippetAsync(snippetId, scaleToSize, this, urlRewriter);
    }
    /**
     * Recreate the content of the ADT from a url json
     * @param url defines the url to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param appendToAdt if provided the snippet will be appended to the adt. Otherwise a fullscreen ADT will be created.
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     * @returns a promise that will resolve on success
     */ static async ParseFromFileAsync(url, scaleToSize, appendToAdt, urlRewriter) {
        const adt = appendToAdt ?? $dc13400b3dc126d8$export$f032279d572248ce.CreateFullscreenUI("ADT from URL");
        const serialized = await $dc13400b3dc126d8$export$f032279d572248ce._LoadURLContentAsync(url);
        adt.parseSerializedObject(serialized, scaleToSize, urlRewriter);
        return adt;
    }
    /**
     * Recreate the content of the ADT from a url json
     * @param url defines the url to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param urlRewriter defines an url rewriter to update urls before sending them to the controls
     * @returns a promise that will resolve on success
     */ parseFromURLAsync(url, scaleToSize, urlRewriter) {
        return $dc13400b3dc126d8$export$f032279d572248ce.ParseFromFileAsync(url, scaleToSize, this, urlRewriter);
    }
    static _LoadURLContentAsync(url, snippet = false) {
        if (url === "") return Promise.reject("No URL provided");
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        let gui;
                        if (snippet) {
                            const payload = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                            gui = payload.encodedGui ? new TextDecoder("utf-8").decode((0, $eLv1o.DecodeBase64ToBinary)(payload.encodedGui)) : payload.gui;
                        } else gui = request.responseText;
                        const serializationObject = JSON.parse(gui);
                        resolve(serializationObject);
                    } else reject("Unable to load");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    // Statics
    /**
     * Compares two rectangle based controls for pixel overlap
     * @param control1 The first control to compare
     * @param control2 The second control to compare
     * @returns true if overlaps, otherwise false
     */ static _Overlaps(control1, control2) {
        return !(control1.centerX > control2.centerX + control2.widthInPixels || control1.centerX + control1.widthInPixels < control2.centerX || control1.centerY + control1.heightInPixels < control2.centerY || control1.centerY > control2.centerY + control2.heightInPixels);
    }
    /**
     * Creates a new AdvancedDynamicTexture in projected mode (ie. attached to a mesh)
     * @param mesh defines the mesh which will receive the texture
     * @param width defines the texture width (1024 by default)
     * @param height defines the texture height (1024 by default)
     * @param supportPointerMove defines a boolean indicating if the texture must capture move events (true by default)
     * @param onlyAlphaTesting defines a boolean indicating that alpha blending will not be used (only alpha testing) (false by default)
     * @param invertY defines if the texture needs to be inverted on the y axis during loading (true by default)
     * @param materialSetupCallback defines a custom way of creating and setting up the material on the mesh
     * @param sampling defines the texture sampling mode (Texture.TRILINEAR_SAMPLINGMODE by default)
     * @returns a new AdvancedDynamicTexture
     */ static CreateForMesh(mesh, width = 1024, height = 1024, supportPointerMove = true, onlyAlphaTesting = false, invertY, materialSetupCallback = this._CreateMaterial, sampling = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE) {
        // use a unique ID in name so serialization will work even if you create two ADTs for a single mesh
        const uniqueId = (0, $321Uk.RandomGUID)();
        const result = new $dc13400b3dc126d8$export$f032279d572248ce(`AdvancedDynamicTexture for ${mesh.name} [${uniqueId}]`, width, height, mesh.getScene(), true, sampling, invertY);
        materialSetupCallback(mesh, uniqueId, result, onlyAlphaTesting);
        result.attachToMesh(mesh, supportPointerMove);
        return result;
    }
    static _CreateMaterial(mesh, uniqueId, texture, onlyAlphaTesting) {
        const internalClassType = (0, $8DoUR.GetClass)("BABYLON.StandardMaterial");
        if (!internalClassType) // eslint-disable-next-line no-throw-literal
        throw "StandardMaterial needs to be imported before as it contains a side-effect required by your code.";
        const material = new internalClassType(`AdvancedDynamicTextureMaterial for ${mesh.name} [${uniqueId}]`, mesh.getScene());
        material.backFaceCulling = false;
        material.diffuseColor = (0, $7etnY.Color3).Black();
        material.specularColor = (0, $7etnY.Color3).Black();
        if (onlyAlphaTesting) {
            material.diffuseTexture = texture;
            material.emissiveTexture = texture;
            texture.hasAlpha = true;
        } else {
            material.emissiveTexture = texture;
            material.opacityTexture = texture;
        }
        mesh.material = material;
    }
    /**
     * Creates a new AdvancedDynamicTexture in projected mode (ie. attached to a mesh) BUT do not create a new material for the mesh. You will be responsible for connecting the texture
     * @param mesh defines the mesh which will receive the texture
     * @param width defines the texture width (1024 by default)
     * @param height defines the texture height (1024 by default)
     * @param supportPointerMove defines a boolean indicating if the texture must capture move events (true by default)
     * @param invertY defines if the texture needs to be inverted on the y axis during loading (true by default)
     * @param sampling defines the texture sampling mode (Texture.TRILINEAR_SAMPLINGMODE by default)
     * @returns a new AdvancedDynamicTexture
     */ static CreateForMeshTexture(mesh, width = 1024, height = 1024, supportPointerMove = true, invertY, sampling = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE) {
        const result = new $dc13400b3dc126d8$export$f032279d572248ce(mesh.name + " AdvancedDynamicTexture", width, height, mesh.getScene(), true, sampling, invertY);
        result.attachToMesh(mesh, supportPointerMove);
        return result;
    }
    /**
     * Creates a new AdvancedDynamicTexture in fullscreen mode.
     * In this mode the texture will rely on a layer for its rendering.
     * This allows it to be treated like any other layer.
     * As such, if you have a multi camera setup, you can set the layerMask on the GUI as well.
     * LayerMask is set through advancedTexture.layer.layerMask
     * @param name defines name for the texture
     * @param foreground defines a boolean indicating if the texture must be rendered in foreground (default is true)
     * @param sceneOrOptions defines the hosting scene or options (IAdvancedDynamicTextureOptions)
     * @param sampling defines the texture sampling mode (Texture.BILINEAR_SAMPLINGMODE by default)
     * @param adaptiveScaling defines whether to automatically scale root to match hardwarescaling (false by default)
     * @returns a new AdvancedDynamicTexture
     */ static CreateFullscreenUI(name, foreground = true, sceneOrOptions = null, sampling = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, adaptiveScaling = false) {
        const isScene = !sceneOrOptions || sceneOrOptions._isScene;
        const result = isScene ? new $dc13400b3dc126d8$export$f032279d572248ce(name, 0, 0, sceneOrOptions, false, sampling) : new $dc13400b3dc126d8$export$f032279d572248ce(name, sceneOrOptions);
        // Display
        const resultScene = result.getScene();
        const layer = new (0, $601908f1c5e3fa9a$export$936d0764594b6eb3)(name + "_layer", null, resultScene, !foreground);
        layer.texture = result;
        result._layerToDispose = layer;
        result._isFullscreen = true;
        if (result.useStandalone) // Make sure the layer is not rendered by the layer component!
        layer.layerMask = 0;
        if (adaptiveScaling && resultScene) {
            const newScale = 1 / resultScene.getEngine().getHardwareScalingLevel();
            result._rootContainer.scaleX = newScale;
            result._rootContainer.scaleY = newScale;
        }
        // Attach
        result.attach();
        return result;
    }
    /**
     * Scales the texture
     * @param ratio the scale factor to apply to both width and height
     */ scale(ratio) {
        super.scale(ratio);
        this.markAsDirty();
    }
    /**
     * Resizes the texture
     * @param width the new width
     * @param height the new height
     */ scaleTo(width, height) {
        super.scaleTo(width, height);
        this.markAsDirty();
    }
    _checkGuiIsReady() {
        if (this.guiIsReady()) {
            this.onGuiReadyObservable.notifyObservers(this);
            this.onGuiReadyObservable.clear();
        }
    }
    /**
     * @returns true if all the GUI components are ready to render
     */ guiIsReady() {
        return this._rootContainer.isReady();
    }
}
/** Define the url to load snippets */ $dc13400b3dc126d8$export$f032279d572248ce.SnippetUrl = (0, $bd523120f282dc29$export$a002182e51710d39).SnippetUrl;
/** Indicates if some optimizations can be performed in GUI GPU management (the downside is additional memory/GPU texture memory used) */ $dc13400b3dc126d8$export$f032279d572248ce.AllowGPUOptimizations = true;


class $cad696879dc04c5e$export$ae7e1ba247bde573 extends (0, $19190f008fbf8981$export$1cd65882cd591ad1) {
    /**
     * Creates a new System
     * @param canvas Element where the scene will be drawn
     */ constructor(canvas){
        super(canvas), this.scalingLevel = 1, this.isOnMobile = false;
        this.advancedTexture = (0, $dc13400b3dc126d8$export$f032279d572248ce).CreateFullscreenUI("UI", true, this.scene);
        this.scene.hoverCursor = "pointer";
        // this.engine.setHardwareScalingLevel(0.5);
        // this.scalingLevel = 0.5;
        this.checkScreenSize();
        window.onresize = ()=>{
            this.checkScreenSize();
        };
        if (this.checkPlatform()) {
            this.engine.setHardwareScalingLevel(0.5);
            this.scalingLevel = 0.5;
            this.advancedTexture.scale(0.5);
        }
    }
    checkScreenSize() {
        let height = window.innerHeight;
        // let width = window.innerWidth;
        // let ratio = width / height;
        let scaleDiv = Math.min(height / 600, 1);
        let scale = this.scalingLevel / scaleDiv;
        this.advancedTexture.scale(scale);
    }
    checkMobile() {
        if (this.isOnMobile) this.goFullScreen();
    }
    checkPlatform() {
        let isMobile = navigator.userAgent.toLowerCase().match(/mobile/i), isTablet = navigator.userAgent.toLowerCase().match(/tablet/i), isAndroid = navigator.userAgent.toLowerCase().match(/android/i), isiPhone = navigator.userAgent.toLowerCase().match(/iphone/i), isiPad = navigator.userAgent.toLowerCase().match(/ipad/i);
        if (isMobile || isTablet || isAndroid || isiPhone || isiPad) this.isOnMobile = true;
        else this.isOnMobile = false;
        return this.isOnMobile;
    }
    goFullScreen() {
        // if supported
        if (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullscreenEnabled || document.msFullscreenEnabled) {
            if (this.canvas.requestFullscreen) this.canvas.requestFullscreen();
            else if (this.canvas.mozRequestFullScreen) this.canvas.mozRequestFullScreen();
            else if (this.canvas.webkitRequestFullscreen) this.canvas.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            else if (this.canvas.msRequestFullscreen) this.canvas.msRequestFullscreen();
        }
    }
}




parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");


class $10526e257d75d69b$export$616950c67a6e1b09 {
    constructor(system){
        this.mapDetail = 50;
        this.mapSize = 100;
        this.gravityDepth = 2;
        this.gravityAround = 0.15;
        this.keysToPath = {};
        this.center = new (0, $ha1VO.Vector2)(1, 1);
        this.system = system;
        this.initMap();
        this.addRibbon();
        let frame = true;
        this.system.scene.registerBeforeRender(()=>{
            if (frame) try {
                if (this.paths.length == 0) return;
                this.ribbon = (0, $b0df7c384622c537$export$e176487c05830cc5).CreateRibbon('', this.paths, false, false, 0, undefined, true, undefined, this.ribbon);
            // this.ribbon.convertToFlatShadedMesh();
            } catch  {
                console.log('maperror');
                console.log(this.paths);
            }
            frame = !frame;
        });
        this.starCurve = new (0, $005b3f0c7a6c24da$export$796b0dbcc6df23ee)();
        this.starCurve.setEasingMode((0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEINOUT);
        this.blackHoleCurve = new (0, $005b3f0c7a6c24da$export$796b0dbcc6df23ee)();
        this.blackHoleCurve.setEasingMode((0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEOUT);
    }
    addRibbon() {
        this.ribbon = (0, $b0df7c384622c537$export$e176487c05830cc5).CreateRibbon("ribbon", this.paths, false, false, 0, this.system.scene, true, (0, $b0df7c384622c537$export$e176487c05830cc5).BACKSIDE);
        this.ribbon.alwaysSelectAsActiveMesh = true;
        this.ribbon.doNotSyncBoundingInfo = true;
        // this.ribbon.convertToFlatShadedMesh();
        this.ribbon.rotation.x = Math.PI;
        this.ribbon.material = this.system.ribbonMaterial;
    }
    initMap() {
        this.halfDetail = this.mapDetail / 2;
        this.setCenterAndSize((0, $ha1VO.Vector2).Zero(), 1);
    }
    setCenterAndSize(pos, size) {
        size = Math.max(size, 2);
        // Whatever the size of the player, the ribbon will get bigger and small to alway take the all screen
        const halfSize = Math.round(size * this.mapSize / 2);
        this.halfSize = Math.round(halfSize / this.mapDetail) * this.mapDetail;
        this.step = Math.round(2 * this.halfSize / this.mapDetail);
        const xRound = Math.round(pos.x / this.step) * this.step;
        const yRound = Math.round(-pos.y / this.step) * this.step;
        const newCenter = new (0, $ha1VO.Vector2)(xRound, -yRound);
        if (this.center.x == newCenter.x && this.center.y == newCenter.y) return;
        const newPaths = [];
        const newPathToKeys = [];
        for(let x = xRound - this.halfSize; x < xRound + this.halfSize; x += this.step){
            var linepath = [];
            var linekey = [];
            for(let y = yRound - this.halfSize; y < yRound + this.halfSize; y += this.step){
                linepath.push(new (0, $ha1VO.Vector3)(x, 0, y));
                linekey.push('');
            }
            newPaths.push(linepath);
            newPathToKeys.push(linekey);
        }
        this.center = newCenter.clone();
        this.paths = newPaths;
        this.pathToKeys = newPathToKeys;
    }
    setStarPoint(key, pos, size, depth) {
        this.setMassPoint(key, pos, size, this.starCurve, depth);
    }
    setBlackHolePoint(key, pos, size, depth) {
        this.setMassPoint(key, pos, size, this.blackHoleCurve, depth);
    }
    setMassPoint(key, pos, size, curve, depth) {
        this.eraseMass(key);
        const MassToCenter = (0, $ha1VO.Vector2).Distance(pos, this.center);
        // If too far from center, ignore it
        if (MassToCenter > this.halfSize) return;
        const massCenter = pos.subtract(this.center);
        const xRound = Math.round(massCenter.x / this.step) + this.halfDetail;
        const yRound = Math.round(-massCenter.y / this.step) + this.halfDetail;
        size = size / 10;
        const alteredPoints = [];
        if (!depth) depth = size * this.gravityDepth;
        const width = Math.round(size * this.gravityAround * this.mapDetail);
        const newKeysToPath = [];
        for(let x = Math.max(xRound - width, 0); x < Math.min(xRound + width, this.mapDetail); x++)for(let y = Math.max(yRound - width, 0); y < Math.min(yRound + width, this.mapDetail); y++){
            if (!this.paths[x] || !this.paths[x][y]) return;
            const circlePoint = new (0, $ha1VO.Vector2)(x * this.step - this.halfSize, -(y * this.step - this.halfSize));
            const dist = (0, $ha1VO.Vector2).Distance(massCenter, circlePoint);
            const perc = curve.ease(dist / (size * 20));
            const newY = Math.max(depth - depth * perc, 0);
            if (newY > this.paths[x][y].y) {
                this.paths[x][y].y = newY;
                alteredPoints.push(this.paths[x][y]);
                const currentkey = this.pathToKeys[x][y];
                if (currentkey) (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.keysToPath[currentkey], (xy)=>{
                    return xy.x === x && xy.y === y;
                });
                this.pathToKeys[x][y] = key;
                newKeysToPath.push([
                    x,
                    y
                ]);
            }
        }
        this.keysToPath[key] = newKeysToPath;
    }
    eraseMass(key) {
        if (this.keysToPath[key] && this.keysToPath[key].length) {
            for(let i = 0; i < this.keysToPath[key].length; i++){
                if (!this.keysToPath[key] || !this.keysToPath[key][i]) return;
                const xy = this.keysToPath[key][i];
                if (this.pathToKeys[xy[0]] && this.pathToKeys[xy[0]][xy[1]] == key) {
                    this.paths[xy[0]][xy[1]].y = 0;
                    this.pathToKeys[xy[0]][xy[1]] = '';
                }
            }
            this.keysToPath[key] = [];
        }
    }
}


parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");
var $ha1VO = parcelRequire("ha1VO");




var $7etnY = parcelRequire("7etnY");
class $d92ab40db8c700a0$export$611a8e87a207147e {
    /**
     * Creates a new color4 gradient
     * @param gradient gets or sets the gradient value (between 0 and 1)
     * @param color1 gets or sets first associated color
     * @param color2 gets or sets first second color
     */ constructor(/**
     * Gets or sets the gradient value (between 0 and 1)
     */ gradient, /**
     * Gets or sets first associated color
     */ color1, /**
     * Gets or sets second associated color
     */ color2){
        this.gradient = gradient;
        this.color1 = color1;
        this.color2 = color2;
    }
    /**
     * Will get a color picked randomly between color1 and color2.
     * If color2 is undefined then color1 will be used
     * @param result defines the target Color4 to store the result in
     */ getColorToRef(result) {
        if (!this.color2) {
            result.copyFrom(this.color1);
            return;
        }
        (0, $7etnY.Color4).LerpToRef(this.color1, this.color2, Math.random(), result);
    }
}
class $d92ab40db8c700a0$export$9c465576c5b3fff7 {
    /**
     * Creates a new color3 gradient
     * @param gradient gets or sets the gradient value (between 0 and 1)
     * @param color gets or sets associated color
     */ constructor(/**
     * Gets or sets the gradient value (between 0 and 1)
     */ gradient, /**
     * Gets or sets the associated color
     */ color){
        this.gradient = gradient;
        this.color = color;
    }
}
class $d92ab40db8c700a0$export$3722161617a7d2a5 {
    /**
     * Creates a new factor gradient
     * @param gradient gets or sets the gradient value (between 0 and 1)
     * @param factor1 gets or sets first associated factor
     * @param factor2 gets or sets second associated factor
     */ constructor(/**
     * Gets or sets the gradient value (between 0 and 1)
     */ gradient, /**
     * Gets or sets first associated factor
     */ factor1, /**
     * Gets or sets second associated factor
     */ factor2){
        this.gradient = gradient;
        this.factor1 = factor1;
        this.factor2 = factor2;
    }
    /**
     * Will get a number picked randomly between factor1 and factor2.
     * If factor2 is undefined then factor1 will be used
     * @returns the picked number
     */ getFactor() {
        if (this.factor2 === undefined || this.factor2 === this.factor1) return this.factor1;
        return this.factor1 + (this.factor2 - this.factor1) * Math.random();
    }
}
class $d92ab40db8c700a0$export$9547bfcc1522be4f {
    /**
     * Gets the current gradient from an array of IValueGradient
     * @param ratio defines the current ratio to get
     * @param gradients defines the array of IValueGradient
     * @param updateFunc defines the callback function used to get the final value from the selected gradients
     */ static GetCurrentGradient(ratio, gradients, updateFunc) {
        // Use last index if over
        if (gradients[0].gradient > ratio) {
            updateFunc(gradients[0], gradients[0], 1.0);
            return;
        }
        for(let gradientIndex = 0; gradientIndex < gradients.length - 1; gradientIndex++){
            const currentGradient = gradients[gradientIndex];
            const nextGradient = gradients[gradientIndex + 1];
            if (ratio >= currentGradient.gradient && ratio <= nextGradient.gradient) {
                const scale = (ratio - currentGradient.gradient) / (nextGradient.gradient - currentGradient.gradient);
                updateFunc(currentGradient, nextGradient, scale);
                return;
            }
        }
        // Use last index if over
        const lastIndex = gradients.length - 1;
        updateFunc(gradients[lastIndex], gradients[lastIndex], 1.0);
    }
}



var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");
class $41cd6a50c4d71975$export$c6d6cd5ffcb825d2 extends (0, $j2mX5.Texture) {
    /**
     * Instantiates a new RawTexture.
     * Raw texture can help creating a texture directly from an array of data.
     * This can be super useful if you either get the data from an uncompressed source or
     * if you wish to create your texture pixel by pixel.
     * @param data define the array of data to use to create the texture (null to create an empty texture)
     * @param width define the width of the texture
     * @param height define the height of the texture
     * @param format define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps define whether mip maps should be generated or not
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @param waitDataToBeReady If set to true Rawtexture will wait data to be set in order to be flaged as ready.
     */ constructor(data, width, height, /**
     * Define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
     */ format, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags, useSRGBBuffer, waitDataToBeReady){
        super(null, sceneOrEngine, !generateMipMaps, invertY, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, creationFlags);
        this.format = format;
        if (!this._engine) return;
        if (!this._engine._caps.textureFloatLinearFiltering && type === 1) samplingMode = 1;
        if (!this._engine._caps.textureHalfFloatLinearFiltering && type === 2) samplingMode = 1;
        this._texture = this._engine.createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, null, type, creationFlags ?? 0, useSRGBBuffer ?? false);
        this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._waitingForData = !!waitDataToBeReady && !data;
    }
    /**
     * Updates the texture underlying data.
     * @param data Define the new data of the texture
     */ update(data) {
        this._getEngine().updateRawTexture(this._texture, data, this._texture.format, this._texture.invertY, null, this._texture.type, this._texture._useSRGBBuffer);
        this._waitingForData = false;
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        if (!this._texture) return super.clone();
        const rawTexture = new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(null, this.getSize().width, this.getSize().height, this.format, this.getScene(), this._texture.generateMipMaps, this._invertY, this.samplingMode, this._texture.type, this._texture._creationFlags, this._useSRGBBuffer);
        rawTexture._texture = this._texture;
        this._texture.incrementReferences();
        return rawTexture;
    }
    isReady() {
        return super.isReady() && !this._waitingForData;
    }
    /**
     * Creates a luminance texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @returns the luminance texture
     */ static CreateLuminanceTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 1, sceneOrEngine, generateMipMaps, invertY, samplingMode);
    }
    /**
     * Creates a luminance alpha texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @returns the luminance alpha texture
     */ static CreateLuminanceAlphaTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 2, sceneOrEngine, generateMipMaps, invertY, samplingMode);
    }
    /**
     * Creates an alpha texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @returns the alpha texture
     */ static CreateAlphaTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 0, sceneOrEngine, generateMipMaps, invertY, samplingMode);
    }
    /**
     * Creates a RGB texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the RGB alpha texture
     */ static CreateRGBTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags = 0, useSRGBBuffer = false) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 4, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, creationFlags, useSRGBBuffer);
    }
    /**
     * Creates a RGBA texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @param waitDataToBeReady if set to true this will force texture to wait for data to be set before it is considered ready.
     * @returns the RGBA texture
     */ static CreateRGBATexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags = 0, useSRGBBuffer = false, waitDataToBeReady = false) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 5, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, creationFlags, useSRGBBuffer, waitDataToBeReady);
    }
    /**
     * Creates a RGBA storage texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the RGBA texture
     */ static CreateRGBAStorageTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, useSRGBBuffer = false) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 5, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, 1, useSRGBBuffer);
    }
    /**
     * Creates a R texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @returns the R texture
     */ static CreateRTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, type = 1) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 6, sceneOrEngine, generateMipMaps, invertY, samplingMode, type);
    }
    /**
     * Creates a R storage texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @returns the R texture
     */ static CreateRStorageTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, type = 1) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 6, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, 1);
    }
}



var $ejQPp = parcelRequire("ejQPp");

var $ha1VO = parcelRequire("ha1VO");

class $1d53a40ac71847cf$export$b62a68c027a48d03 extends (0, $23fbb8c84eee5c40$export$4c55cb8c02c1a25d) {
    constructor(){
        super();
        this.IMAGEPROCESSING = false;
        this.VIGNETTE = false;
        this.VIGNETTEBLENDMODEMULTIPLY = false;
        this.VIGNETTEBLENDMODEOPAQUE = false;
        this.TONEMAPPING = 0;
        this.CONTRAST = false;
        this.COLORCURVES = false;
        this.COLORGRADING = false;
        this.COLORGRADING3D = false;
        this.SAMPLER3DGREENDEPTH = false;
        this.SAMPLER3DBGRMAP = false;
        this.DITHER = false;
        this.IMAGEPROCESSINGPOSTPROCESS = false;
        this.EXPOSURE = false;
        this.SKIPFINALCOLORCLAMP = false;
        this.rebuild();
    }
}



var $7etnY = parcelRequire("7etnY");
parcelRequire("7G59J");

var $8DoUR = parcelRequire("8DoUR");
class $0f0fba623f54307f$export$27e68fd8fa9be86e {
    /**
     * Gets or sets a texture used to add random noise to particle positions
     */ get noiseTexture() {
        return this._noiseTexture;
    }
    set noiseTexture(value) {
        if (this._noiseTexture === value) return;
        this._noiseTexture = value;
        this._reset();
    }
    /**
     * Gets or sets whether an animation sprite sheet is enabled or not on the particle system
     */ get isAnimationSheetEnabled() {
        return this._isAnimationSheetEnabled;
    }
    set isAnimationSheetEnabled(value) {
        if (this._isAnimationSheetEnabled == value) return;
        this._isAnimationSheetEnabled = value;
        this._reset();
    }
    /**
     * Gets or sets a boolean enabling the use of logarithmic depth buffers, which is good for wide depth buffers.
     */ get useLogarithmicDepth() {
        return this._useLogarithmicDepth;
    }
    set useLogarithmicDepth(value) {
        this._useLogarithmicDepth = value && this.getScene().getEngine().getCaps().fragmentDepthSupported;
    }
    /**
     * Get hosting scene
     * @returns the scene
     */ getScene() {
        return this._scene;
    }
    _hasTargetStopDurationDependantGradient() {
        return this._startSizeGradients && this._startSizeGradients.length > 0 || this._emitRateGradients && this._emitRateGradients.length > 0 || this._lifeTimeGradients && this._lifeTimeGradients.length > 0;
    }
    /**
     * Gets the current list of drag gradients.
     * You must use addDragGradient and removeDragGradient to update this list
     * @returns the list of drag gradients
     */ getDragGradients() {
        return this._dragGradients;
    }
    /**
     * Gets the current list of limit velocity gradients.
     * You must use addLimitVelocityGradient and removeLimitVelocityGradient to update this list
     * @returns the list of limit velocity gradients
     */ getLimitVelocityGradients() {
        return this._limitVelocityGradients;
    }
    /**
     * Gets the current list of color gradients.
     * You must use addColorGradient and removeColorGradient to update this list
     * @returns the list of color gradients
     */ getColorGradients() {
        return this._colorGradients;
    }
    /**
     * Gets the current list of size gradients.
     * You must use addSizeGradient and removeSizeGradient to update this list
     * @returns the list of size gradients
     */ getSizeGradients() {
        return this._sizeGradients;
    }
    /**
     * Gets the current list of color remap gradients.
     * You must use addColorRemapGradient and removeColorRemapGradient to update this list
     * @returns the list of color remap gradients
     */ getColorRemapGradients() {
        return this._colorRemapGradients;
    }
    /**
     * Gets the current list of alpha remap gradients.
     * You must use addAlphaRemapGradient and removeAlphaRemapGradient to update this list
     * @returns the list of alpha remap gradients
     */ getAlphaRemapGradients() {
        return this._alphaRemapGradients;
    }
    /**
     * Gets the current list of life time gradients.
     * You must use addLifeTimeGradient and removeLifeTimeGradient to update this list
     * @returns the list of life time gradients
     */ getLifeTimeGradients() {
        return this._lifeTimeGradients;
    }
    /**
     * Gets the current list of angular speed gradients.
     * You must use addAngularSpeedGradient and removeAngularSpeedGradient to update this list
     * @returns the list of angular speed gradients
     */ getAngularSpeedGradients() {
        return this._angularSpeedGradients;
    }
    /**
     * Gets the current list of velocity gradients.
     * You must use addVelocityGradient and removeVelocityGradient to update this list
     * @returns the list of velocity gradients
     */ getVelocityGradients() {
        return this._velocityGradients;
    }
    /**
     * Gets the current list of start size gradients.
     * You must use addStartSizeGradient and removeStartSizeGradient to update this list
     * @returns the list of start size gradients
     */ getStartSizeGradients() {
        return this._startSizeGradients;
    }
    /**
     * Gets the current list of emit rate gradients.
     * You must use addEmitRateGradient and removeEmitRateGradient to update this list
     * @returns the list of emit rate gradients
     */ getEmitRateGradients() {
        return this._emitRateGradients;
    }
    /**
     * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get direction1() {
        if (this.particleEmitterType.direction1) return this.particleEmitterType.direction1;
        return (0, $ha1VO.Vector3).Zero();
    }
    set direction1(value) {
        if (this.particleEmitterType.direction1) this.particleEmitterType.direction1 = value;
    }
    /**
     * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get direction2() {
        if (this.particleEmitterType.direction2) return this.particleEmitterType.direction2;
        return (0, $ha1VO.Vector3).Zero();
    }
    set direction2(value) {
        if (this.particleEmitterType.direction2) this.particleEmitterType.direction2 = value;
    }
    /**
     * Minimum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get minEmitBox() {
        if (this.particleEmitterType.minEmitBox) return this.particleEmitterType.minEmitBox;
        return (0, $ha1VO.Vector3).Zero();
    }
    set minEmitBox(value) {
        if (this.particleEmitterType.minEmitBox) this.particleEmitterType.minEmitBox = value;
    }
    /**
     * Maximum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get maxEmitBox() {
        if (this.particleEmitterType.maxEmitBox) return this.particleEmitterType.maxEmitBox;
        return (0, $ha1VO.Vector3).Zero();
    }
    set maxEmitBox(value) {
        if (this.particleEmitterType.maxEmitBox) this.particleEmitterType.maxEmitBox = value;
    }
    /**
     * Gets or sets the billboard mode to use when isBillboardBased = true.
     * Value can be: ParticleSystem.BILLBOARDMODE_ALL, ParticleSystem.BILLBOARDMODE_Y, ParticleSystem.BILLBOARDMODE_STRETCHED
     */ get billboardMode() {
        return this._billboardMode;
    }
    set billboardMode(value) {
        if (this._billboardMode === value) return;
        this._billboardMode = value;
        this._reset();
    }
    /**
     * Gets or sets a boolean indicating if the particles must be rendered as billboard or aligned with the direction
     */ get isBillboardBased() {
        return this._isBillboardBased;
    }
    set isBillboardBased(value) {
        if (this._isBillboardBased === value) return;
        this._isBillboardBased = value;
        this._reset();
    }
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
    }
    /**
     * Attaches a new image processing configuration to the Standard Material.
     * @param configuration
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Pick the scene configuration if needed.
        if (!configuration && this._scene) this._imageProcessingConfiguration = this._scene.imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
    }
    /** @internal */ _reset() {}
    /**
     * @internal
     */ _removeGradientAndTexture(gradient, gradients, texture) {
        if (!gradients) return this;
        let index = 0;
        for (const valueGradient of gradients){
            if (valueGradient.gradient === gradient) {
                gradients.splice(index, 1);
                break;
            }
            index++;
        }
        if (texture) texture.dispose();
        return this;
    }
    /**
     * Instantiates a particle system.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * @param name The name of the particle system
     */ constructor(name){
        /**
         * List of animations used by the particle system.
         */ this.animations = [];
        /**
         * The rendering group used by the Particle system to chose when to render.
         */ this.renderingGroupId = 0;
        /**
         * The emitter represents the Mesh or position we are attaching the particle system to.
         */ this.emitter = (0, $ha1VO.Vector3).Zero();
        /**
         * The maximum number of particles to emit per frame
         */ this.emitRate = 10;
        /**
         * If you want to launch only a few particles at once, that can be done, as well.
         */ this.manualEmitCount = -1;
        /**
         * The overall motion speed (0.01 is default update speed, faster updates = faster animation)
         */ this.updateSpeed = 0.01;
        /**
         * The amount of time the particle system is running (depends of the overall update speed).
         */ this.targetStopDuration = 0;
        /**
         * Specifies whether the particle system will be disposed once it reaches the end of the animation.
         */ this.disposeOnStop = false;
        /**
         * Minimum power of emitting particles.
         */ this.minEmitPower = 1;
        /**
         * Maximum power of emitting particles.
         */ this.maxEmitPower = 1;
        /**
         * Minimum life time of emitting particles.
         */ this.minLifeTime = 1;
        /**
         * Maximum life time of emitting particles.
         */ this.maxLifeTime = 1;
        /**
         * Minimum Size of emitting particles.
         */ this.minSize = 1;
        /**
         * Maximum Size of emitting particles.
         */ this.maxSize = 1;
        /**
         * Minimum scale of emitting particles on X axis.
         */ this.minScaleX = 1;
        /**
         * Maximum scale of emitting particles on X axis.
         */ this.maxScaleX = 1;
        /**
         * Minimum scale of emitting particles on Y axis.
         */ this.minScaleY = 1;
        /**
         * Maximum scale of emitting particles on Y axis.
         */ this.maxScaleY = 1;
        /**
         * Gets or sets the minimal initial rotation in radians.
         */ this.minInitialRotation = 0;
        /**
         * Gets or sets the maximal initial rotation in radians.
         */ this.maxInitialRotation = 0;
        /**
         * Minimum angular speed of emitting particles (Z-axis rotation for each particle).
         */ this.minAngularSpeed = 0;
        /**
         * Maximum angular speed of emitting particles (Z-axis rotation for each particle).
         */ this.maxAngularSpeed = 0;
        /**
         * The layer mask we are rendering the particles through.
         */ this.layerMask = 0x0fffffff;
        /**
         * This can help using your own shader to render the particle system.
         * The according effect will be created
         */ this.customShader = null;
        /**
         * By default particle system starts as soon as they are created. This prevents the
         * automatic start to happen and let you decide when to start emitting particles.
         */ this.preventAutoStart = false;
        /**
         * Gets or sets a boolean indicating that this particle system will allow fog to be rendered on it (false by default)
         */ this.applyFog = false;
        /** @internal */ this._wasDispatched = false;
        this._rootUrl = "";
        /** Gets or sets the strength to apply to the noise value (default is (10, 10, 10)) */ this.noiseStrength = new (0, $ha1VO.Vector3)(10, 10, 10);
        /**
         * Callback triggered when the particle animation is ending.
         */ this.onAnimationEnd = null;
        /**
         * Blend mode use to render the particle, it can be either ParticleSystem.BLENDMODE_ONEONE or ParticleSystem.BLENDMODE_STANDARD.
         */ this.blendMode = $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_ONEONE;
        /**
         * Forces the particle to write their depth information to the depth buffer. This can help preventing other draw calls
         * to override the particles.
         */ this.forceDepthWrite = false;
        /** Gets or sets a value indicating how many cycles (or frames) must be executed before first rendering (this value has to be set before starting the system). Default is 0 */ this.preWarmCycles = 0;
        /** Gets or sets a value indicating the time step multiplier to use in pre-warm mode (default is 1) */ this.preWarmStepOffset = 1;
        /**
         * If using a spritesheet (isAnimationSheetEnabled) defines the speed of the sprite loop (default is 1 meaning the animation will play once during the entire particle lifetime)
         */ this.spriteCellChangeSpeed = 1;
        /**
         * If using a spritesheet (isAnimationSheetEnabled) defines the first sprite cell to display
         */ this.startSpriteCellID = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled) defines the last sprite cell to display
         */ this.endSpriteCellID = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled), defines the sprite cell width to use
         */ this.spriteCellWidth = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled), defines the sprite cell height to use
         */ this.spriteCellHeight = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled), defines wether the sprite animation is looping
         */ this.spriteCellLoop = true;
        /**
         * This allows the system to random pick the start cell ID between startSpriteCellID and endSpriteCellID
         */ this.spriteRandomStartCell = false;
        /** Gets or sets a Vector2 used to move the pivot (by default (0,0)) */ this.translationPivot = new (0, $ha1VO.Vector2)(0, 0);
        /**
         * Gets or sets a boolean indicating that hosted animations (in the system.animations array) must be started when system.start() is called
         */ this.beginAnimationOnStart = false;
        /**
         * Gets or sets the frame to start the animation from when beginAnimationOnStart is true
         */ this.beginAnimationFrom = 0;
        /**
         * Gets or sets the frame to end the animation on when beginAnimationOnStart is true
         */ this.beginAnimationTo = 60;
        /**
         * Gets or sets a boolean indicating if animations must loop when beginAnimationOnStart is true
         */ this.beginAnimationLoop = false;
        /**
         * Gets or sets a world offset applied to all particles
         */ this.worldOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._useLogarithmicDepth = false;
        /**
         * You can use gravity if you want to give an orientation to your particles.
         */ this.gravity = (0, $ha1VO.Vector3).Zero();
        this._colorGradients = null;
        this._sizeGradients = null;
        this._lifeTimeGradients = null;
        this._angularSpeedGradients = null;
        this._velocityGradients = null;
        this._limitVelocityGradients = null;
        this._dragGradients = null;
        this._emitRateGradients = null;
        this._startSizeGradients = null;
        this._rampGradients = null;
        this._colorRemapGradients = null;
        this._alphaRemapGradients = null;
        /**
         * Defines the delay in milliseconds before starting the system (0 by default)
         */ this.startDelay = 0;
        /** Gets or sets a value indicating the damping to apply if the limit velocity factor is reached */ this.limitVelocityDamping = 0.4;
        /**
         * Random color of each particle after it has been emitted, between color1 and color2 vectors
         */ this.color1 = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /**
         * Random color of each particle after it has been emitted, between color1 and color2 vectors
         */ this.color2 = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /**
         * Color the particle will have at the end of its lifetime
         */ this.colorDead = new (0, $7etnY.Color4)(0, 0, 0, 1.0);
        /**
         * An optional mask to filter some colors out of the texture, or filter a part of the alpha channel
         */ this.textureMask = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /** @internal */ this._isSubEmitter = false;
        /** @internal */ this._billboardMode = 7;
        /** @internal */ this._isBillboardBased = true;
        /**
         * Local cache of defines for image processing.
         */ this._imageProcessingConfigurationDefines = new (0, $1d53a40ac71847cf$export$b62a68c027a48d03)();
        this.id = name;
        this.name = name;
    }
    /**
     * Creates a Point Emitter for the particle system (emits directly from the emitter position)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     */ createPointEmitter(direction1, direction2) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Hemisphere Emitter for the particle system (emits along the hemisphere radius)
     * @param radius The radius of the hemisphere to emit from
     * @param radiusRange The range of the hemisphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     */ createHemisphericEmitter(radius = 1, radiusRange = 1) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Sphere Emitter for the particle system (emits along the sphere radius)
     * @param radius The radius of the sphere to emit from
     * @param radiusRange The range of the sphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     */ createSphereEmitter(radius = 1, radiusRange = 1) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Directed Sphere Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the sphere to emit from
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the sphere
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the sphere
     */ createDirectedSphereEmitter(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Cylinder Emitter for the particle system (emits from the cylinder to the particle position)
     * @param radius The radius of the emission cylinder
     * @param height The height of the emission cylinder
     * @param radiusRange The range of emission [0-1] 0 Surface only, 1 Entire Radius
     * @param directionRandomizer How much to randomize the particle direction [0-1]
     */ createCylinderEmitter(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Directed Cylinder Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the cylinder to emit from
     * @param height The height of the emission cylinder
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the cylinder
     */ createDirectedCylinderEmitter(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Cone Emitter for the particle system (emits from the cone to the particle position)
     * @param radius The radius of the cone to emit from
     * @param angle The base angle of the cone
     */ createConeEmitter(radius = 1, angle = Math.PI / 4) {
        throw new Error("Method not implemented.");
    }
    createDirectedConeEmitter(radius = 1, angle = Math.PI / 4, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Box Emitter for the particle system. (emits between direction1 and direction2 from withing the box defined by minEmitBox and maxEmitBox)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @param minEmitBox Particles are emitted from the box between minEmitBox and maxEmitBox
     * @param maxEmitBox  Particles are emitted from the box between minEmitBox and maxEmitBox
     */ createBoxEmitter(direction1, direction2, minEmitBox, maxEmitBox) {
        throw new Error("Method not implemented.");
    }
}
/**
 * Source color is added to the destination color without alpha affecting the result
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_ONEONE = 0;
/**
 * Blend current color and particle color using particle’s alpha
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_STANDARD = 1;
/**
 * Add current color and particle color multiplied by particle’s alpha
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_ADD = 2;
/**
 * Multiply current color with particle color
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_MULTIPLY = 3;
/**
 * Multiply current color with particle color then add current color and particle color multiplied by particle’s alpha
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_MULTIPLYADD = 4;
// Register Class Name
(0, $8DoUR.RegisterClass)("BABYLON.BaseParticleSystem", $0f0fba623f54307f$export$27e68fd8fa9be86e);



var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $iosaP = parcelRequire("iosaP");
class $a4515ec770fcd736$export$c36c68baa13912a5 {
    /**
     * Creates a new instance Particle
     * @param particleSystem the particle system the particle belongs to
     */ constructor(/**
     * The particle system the particle belongs to.
     */ particleSystem){
        this.particleSystem = particleSystem;
        /**
         * The world position of the particle in the scene.
         */ this.position = (0, $ha1VO.Vector3).Zero();
        /**
         * The world direction of the particle in the scene.
         */ this.direction = (0, $ha1VO.Vector3).Zero();
        /**
         * The color of the particle.
         */ this.color = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /**
         * The color change of the particle per step.
         */ this.colorStep = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /**
         * Defines how long will the life of the particle be.
         */ this.lifeTime = 1.0;
        /**
         * The current age of the particle.
         */ this.age = 0;
        /**
         * The current size of the particle.
         */ this.size = 0;
        /**
         * The current scale of the particle.
         */ this.scale = new (0, $ha1VO.Vector2)(1, 1);
        /**
         * The current angle of the particle.
         */ this.angle = 0;
        /**
         * Defines how fast is the angle changing.
         */ this.angularSpeed = 0;
        /**
         * Defines the cell index used by the particle to be rendered from a sprite.
         */ this.cellIndex = 0;
        /** @internal */ this._attachedSubEmitters = null;
        /** @internal */ this._currentColor1 = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /** @internal */ this._currentColor2 = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /** @internal */ this._currentSize1 = 0;
        /** @internal */ this._currentSize2 = 0;
        /** @internal */ this._currentAngularSpeed1 = 0;
        /** @internal */ this._currentAngularSpeed2 = 0;
        /** @internal */ this._currentVelocity1 = 0;
        /** @internal */ this._currentVelocity2 = 0;
        /** @internal */ this._currentLimitVelocity1 = 0;
        /** @internal */ this._currentLimitVelocity2 = 0;
        /** @internal */ this._currentDrag1 = 0;
        /** @internal */ this._currentDrag2 = 0;
        this.id = $a4515ec770fcd736$export$c36c68baa13912a5._Count++;
        if (!this.particleSystem.isAnimationSheetEnabled) return;
        this._updateCellInfoFromSystem();
    }
    _updateCellInfoFromSystem() {
        this.cellIndex = this.particleSystem.startSpriteCellID;
    }
    /**
     * Defines how the sprite cell index is updated for the particle
     */ updateCellIndex() {
        let offsetAge = this.age;
        let changeSpeed = this.particleSystem.spriteCellChangeSpeed;
        if (this.particleSystem.spriteRandomStartCell) {
            if (this._randomCellOffset === undefined) this._randomCellOffset = Math.random() * this.lifeTime;
            if (changeSpeed === 0) {
                // Special case when speed = 0 meaning we want to stay on initial cell
                changeSpeed = 1;
                offsetAge = this._randomCellOffset;
            } else offsetAge += this._randomCellOffset;
        }
        const dist = this._initialEndSpriteCellID - this._initialStartSpriteCellID + 1;
        let ratio;
        if (this._initialSpriteCellLoop) ratio = (0, $iosaP.Clamp)(offsetAge * changeSpeed % this.lifeTime / this.lifeTime);
        else ratio = (0, $iosaP.Clamp)(offsetAge * changeSpeed / this.lifeTime);
        this.cellIndex = this._initialStartSpriteCellID + ratio * dist | 0;
    }
    /**
     * @internal
     */ _inheritParticleInfoToSubEmitter(subEmitter) {
        if (subEmitter.particleSystem.emitter.position) {
            const emitterMesh = subEmitter.particleSystem.emitter;
            emitterMesh.position.copyFrom(this.position);
            if (subEmitter.inheritDirection) {
                const temp = (0, $ha1VO.TmpVectors).Vector3[0];
                this.direction.normalizeToRef(temp);
                emitterMesh.setDirection(temp, 0, Math.PI / 2);
            }
        } else {
            const emitterPosition = subEmitter.particleSystem.emitter;
            emitterPosition.copyFrom(this.position);
        }
        // Set inheritedVelocityOffset to be used when new particles are created
        this.direction.scaleToRef(subEmitter.inheritedVelocityAmount / 2, (0, $ha1VO.TmpVectors).Vector3[0]);
        subEmitter.particleSystem._inheritedVelocityOffset.copyFrom((0, $ha1VO.TmpVectors).Vector3[0]);
    }
    /** @internal */ _inheritParticleInfoToSubEmitters() {
        if (this._attachedSubEmitters && this._attachedSubEmitters.length > 0) this._attachedSubEmitters.forEach((subEmitter)=>{
            this._inheritParticleInfoToSubEmitter(subEmitter);
        });
    }
    /** @internal */ _reset() {
        this.age = 0;
        this.id = $a4515ec770fcd736$export$c36c68baa13912a5._Count++;
        this._currentColorGradient = null;
        this._currentSizeGradient = null;
        this._currentAngularSpeedGradient = null;
        this._currentVelocityGradient = null;
        this._currentLimitVelocityGradient = null;
        this._currentDragGradient = null;
        this.cellIndex = this.particleSystem.startSpriteCellID;
        this._randomCellOffset = undefined;
    }
    /**
     * Copy the properties of particle to another one.
     * @param other the particle to copy the information to.
     */ copyTo(other) {
        other.position.copyFrom(this.position);
        if (this._initialDirection) {
            if (other._initialDirection) other._initialDirection.copyFrom(this._initialDirection);
            else other._initialDirection = this._initialDirection.clone();
        } else other._initialDirection = null;
        other.direction.copyFrom(this.direction);
        if (this._localPosition) {
            if (other._localPosition) other._localPosition.copyFrom(this._localPosition);
            else other._localPosition = this._localPosition.clone();
        }
        other.color.copyFrom(this.color);
        other.colorStep.copyFrom(this.colorStep);
        other.lifeTime = this.lifeTime;
        other.age = this.age;
        other._randomCellOffset = this._randomCellOffset;
        other.size = this.size;
        other.scale.copyFrom(this.scale);
        other.angle = this.angle;
        other.angularSpeed = this.angularSpeed;
        other.particleSystem = this.particleSystem;
        other.cellIndex = this.cellIndex;
        other.id = this.id;
        other._attachedSubEmitters = this._attachedSubEmitters;
        if (this._currentColorGradient) {
            other._currentColorGradient = this._currentColorGradient;
            other._currentColor1.copyFrom(this._currentColor1);
            other._currentColor2.copyFrom(this._currentColor2);
        }
        if (this._currentSizeGradient) {
            other._currentSizeGradient = this._currentSizeGradient;
            other._currentSize1 = this._currentSize1;
            other._currentSize2 = this._currentSize2;
        }
        if (this._currentAngularSpeedGradient) {
            other._currentAngularSpeedGradient = this._currentAngularSpeedGradient;
            other._currentAngularSpeed1 = this._currentAngularSpeed1;
            other._currentAngularSpeed2 = this._currentAngularSpeed2;
        }
        if (this._currentVelocityGradient) {
            other._currentVelocityGradient = this._currentVelocityGradient;
            other._currentVelocity1 = this._currentVelocity1;
            other._currentVelocity2 = this._currentVelocity2;
        }
        if (this._currentLimitVelocityGradient) {
            other._currentLimitVelocityGradient = this._currentLimitVelocityGradient;
            other._currentLimitVelocity1 = this._currentLimitVelocity1;
            other._currentLimitVelocity2 = this._currentLimitVelocity2;
        }
        if (this._currentDragGradient) {
            other._currentDragGradient = this._currentDragGradient;
            other._currentDrag1 = this._currentDrag1;
            other._currentDrag2 = this._currentDrag2;
        }
        if (this.particleSystem.isAnimationSheetEnabled) {
            other._initialStartSpriteCellID = this._initialStartSpriteCellID;
            other._initialEndSpriteCellID = this._initialEndSpriteCellID;
            other._initialSpriteCellLoop = this._initialSpriteCellLoop;
        }
        if (this.particleSystem.useRampGradients) {
            if (other.remapData && this.remapData) other.remapData.copyFrom(this.remapData);
            else other.remapData = new (0, $ha1VO.Vector4)(0, 0, 0, 0);
        }
        if (this._randomNoiseCoordinates1) {
            if (other._randomNoiseCoordinates1) {
                other._randomNoiseCoordinates1.copyFrom(this._randomNoiseCoordinates1);
                other._randomNoiseCoordinates2.copyFrom(this._randomNoiseCoordinates2);
            } else {
                other._randomNoiseCoordinates1 = this._randomNoiseCoordinates1.clone();
                other._randomNoiseCoordinates2 = this._randomNoiseCoordinates2.clone();
            }
        }
    }
}
$a4515ec770fcd736$export$c36c68baa13912a5._Count = 0;



var $hOyoX = parcelRequire("hOyoX");

var $7etnY = parcelRequire("7etnY");
parcelRequire("emm58");



var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");

var $fhgis = parcelRequire("fhgis");
class $509d609d93dac4de$export$e7201bab8caf4869 {
    /**
     * Creates a new instance BoxParticleEmitter
     */ constructor(){
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Minimum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
         */ this.minEmitBox = new (0, $ha1VO.Vector3)(-0.5, -0.5, -0.5);
        /**
         * Maximum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
         */ this.maxEmitBox = new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5);
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.x = randX;
            directionToUpdate.y = randY;
            directionToUpdate.z = randZ;
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const randX = (0, $iosaP.RandomRange)(this.minEmitBox.x, this.maxEmitBox.x);
        const randY = (0, $iosaP.RandomRange)(this.minEmitBox.y, this.maxEmitBox.y);
        const randZ = (0, $iosaP.RandomRange)(this.minEmitBox.z, this.maxEmitBox.z);
        if (isLocal) {
            positionToUpdate.x = randX;
            positionToUpdate.y = randY;
            positionToUpdate.z = randZ;
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $509d609d93dac4de$export$e7201bab8caf4869();
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
        uboOrEffect.setVector3("minEmitBox", this.minEmitBox);
        uboOrEffect.setVector3("maxEmitBox", this.maxEmitBox);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
        ubo.addUniform("minEmitBox", 3);
        ubo.addUniform("maxEmitBox", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define BOXEMITTER";
    }
    /**
     * Returns the string "BoxParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "BoxParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        serializationObject.minEmitBox = this.minEmitBox.asArray();
        serializationObject.maxEmitBox = this.maxEmitBox.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.minEmitBox, 0, this.minEmitBox);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.maxEmitBox, 0, this.maxEmitBox);
    }
}



var $iosaP = parcelRequire("iosaP");

var $ePyUi = parcelRequire("ePyUi");




class $95351d116892571a$export$b52eeadd2730cb3f extends (0, $0f0fba623f54307f$export$27e68fd8fa9be86e) {
    /**
     * Sets a callback that will be triggered when the system is disposed
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /** Gets or sets a boolean indicating that ramp gradients must be used
     * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro#ramp-gradients
     */ get useRampGradients() {
        return this._useRampGradients;
    }
    set useRampGradients(value) {
        if (this._useRampGradients === value) return;
        this._useRampGradients = value;
        this._resetEffect();
    }
    /**
     * Gets the current list of active particles
     */ get particles() {
        return this._particles;
    }
    /**
     * Gets the shader language used in this material.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * Gets the number of particles active at the same time.
     * @returns The number of active particles.
     */ getActiveCount() {
        return this._particles.length;
    }
    /**
     * Returns the string "ParticleSystem"
     * @returns a string containing the class name
     */ getClassName() {
        return "ParticleSystem";
    }
    /**
     * Gets a boolean indicating that the system is stopping
     * @returns true if the system is currently stopping
     */ isStopping() {
        return this._stopped && this.isAlive();
    }
    /**
     * Gets the custom effect used to render the particles
     * @param blendMode Blend mode for which the effect should be retrieved
     * @returns The effect
     */ getCustomEffect(blendMode = 0) {
        return this._customWrappers[blendMode]?.effect ?? this._customWrappers[0].effect;
    }
    _getCustomDrawWrapper(blendMode = 0) {
        return this._customWrappers[blendMode] ?? this._customWrappers[0];
    }
    /**
     * Sets the custom effect used to render the particles
     * @param effect The effect to set
     * @param blendMode Blend mode for which the effect should be set
     */ setCustomEffect(effect, blendMode = 0) {
        this._customWrappers[blendMode] = new (0, $hOyoX.DrawWrapper)(this._engine);
        this._customWrappers[blendMode].effect = effect;
        if (this._customWrappers[blendMode].drawContext) this._customWrappers[blendMode].drawContext.useInstancing = this._useInstancing;
    }
    /**
     * Observable that will be called just before the particles are drawn
     */ get onBeforeDrawParticlesObservable() {
        if (!this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable = new (0, $diGQf.Observable)();
        return this._onBeforeDrawParticlesObservable;
    }
    /**
     * Gets the name of the particle vertex shader
     */ get vertexShaderName() {
        return "particles";
    }
    /**
     * Gets the vertex buffers used by the particle system
     */ get vertexBuffers() {
        return this._vertexBuffers;
    }
    /**
     * Gets the index buffer used by the particle system (or null if no index buffer is used (if _useInstancing=true))
     */ get indexBuffer() {
        return this._indexBuffer;
    }
    /**
     * Instantiates a particle system.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * @param name The name of the particle system
     * @param capacity The max number of particles alive at the same time
     * @param sceneOrEngine The scene the particle system belongs to or the engine to use if no scene
     * @param customEffect a custom effect used to change the way particles are rendered by default
     * @param isAnimationSheetEnabled Must be true if using a spritesheet to animate the particles texture
     * @param epsilon Offset used to render the particles
     */ constructor(name, capacity, sceneOrEngine, customEffect = null, isAnimationSheetEnabled = false, epsilon = 0.01){
        super(name);
        this._emitterInverseWorldMatrix = (0, $ha1VO.Matrix).Identity();
        /**
         * @internal
         */ this._inheritedVelocityOffset = new (0, $ha1VO.Vector3)();
        /**
         * An event triggered when the system is disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the system is stopped
         */ this.onStoppedObservable = new (0, $diGQf.Observable)();
        this._particles = new Array();
        this._stockParticles = new Array();
        this._newPartsExcess = 0;
        this._vertexBuffers = {};
        this._scaledColorStep = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._colorDiff = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._scaledDirection = (0, $ha1VO.Vector3).Zero();
        this._scaledGravity = (0, $ha1VO.Vector3).Zero();
        this._currentRenderId = -1;
        this._useInstancing = false;
        this._started = false;
        this._stopped = false;
        this._actualFrame = 0;
        /** @internal */ this._currentEmitRate1 = 0;
        /** @internal */ this._currentEmitRate2 = 0;
        /** @internal */ this._currentStartSize1 = 0;
        /** @internal */ this._currentStartSize2 = 0;
        /** Indicates that the update of particles is done in the animate function */ this.updateInAnimate = true;
        this._rawTextureWidth = 256;
        this._useRampGradients = false;
        /**
         * Specifies if the particles are updated in emitter local space or world space
         */ this.isLocal = false;
        /** Indicates that the particle system is CPU based */ this.isGPU = false;
        /** Shader language used by the material */ this._shaderLanguage = 0 /* ShaderLanguage.GLSL */ ;
        /** @internal */ this._onBeforeDrawParticlesObservable = null;
        /** @internal */ this._emitFromParticle = (particle)=>{
        // Do nothing
        };
        // start of sub system methods
        /**
         * "Recycles" one of the particle by copying it back to the "stock" of particles and removing it from the active list.
         * Its lifetime will start back at 0.
         * @param particle
         */ this.recycleParticle = (particle)=>{
            // move particle from activeParticle list to stock particles
            const lastParticle = this._particles.pop();
            if (lastParticle !== particle) lastParticle.copyTo(particle);
            this._stockParticles.push(lastParticle);
        };
        this._createParticle = ()=>{
            let particle;
            if (this._stockParticles.length !== 0) {
                particle = this._stockParticles.pop();
                particle._reset();
            } else particle = new (0, $a4515ec770fcd736$export$c36c68baa13912a5)(this);
            this._prepareParticle(particle);
            return particle;
        };
        this._shadersLoaded = false;
        this._capacity = capacity;
        this._epsilon = epsilon;
        this._isAnimationSheetEnabled = isAnimationSheetEnabled;
        if (!sceneOrEngine || sceneOrEngine.getClassName() === "Scene") {
            this._scene = sceneOrEngine || (0, $ejQPp.EngineStore).LastCreatedScene;
            this._engine = this._scene.getEngine();
            this.uniqueId = this._scene.getUniqueId();
            this._scene.particleSystems.push(this);
        } else {
            this._engine = sceneOrEngine;
            this.defaultProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovLH(0.8, 1, 0.1, 100, this._engine.isNDCHalfZRange);
        }
        if (this._engine.getCaps().vertexArrayObject) this._vertexArrayObject = null;
        this._initShaderSourceAsync();
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this._customWrappers = {
            0: new (0, $hOyoX.DrawWrapper)(this._engine)
        };
        this._customWrappers[0].effect = customEffect;
        this._drawWrappers = [];
        this._useInstancing = this._engine.getCaps().instancedArrays;
        this._createIndexBuffer();
        this._createVertexBuffers();
        // Default emitter type
        this.particleEmitterType = new (0, $509d609d93dac4de$export$e7201bab8caf4869)();
        let noiseTextureData = null;
        // Update
        this.updateFunction = (particles)=>{
            let noiseTextureSize = null;
            if (this.noiseTexture) {
                // We need to get texture data back to CPU
                noiseTextureSize = this.noiseTexture.getSize();
                this.noiseTexture.getContent()?.then((data)=>{
                    noiseTextureData = data;
                });
            }
            const sameParticleArray = particles === this._particles;
            for(let index = 0; index < particles.length; index++){
                const particle = particles[index];
                let scaledUpdateSpeed = this._scaledUpdateSpeed;
                const previousAge = particle.age;
                particle.age += scaledUpdateSpeed;
                // Evaluate step to death
                if (particle.age > particle.lifeTime) {
                    const diff = particle.age - previousAge;
                    const oldDiff = particle.lifeTime - previousAge;
                    scaledUpdateSpeed = oldDiff * scaledUpdateSpeed / diff;
                    particle.age = particle.lifeTime;
                }
                const ratio = particle.age / particle.lifeTime;
                // Color
                if (this._colorGradients && this._colorGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._colorGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentColorGradient) {
                        particle._currentColor1.copyFrom(particle._currentColor2);
                        nextGradient.getColorToRef(particle._currentColor2);
                        particle._currentColorGradient = currentGradient;
                    }
                    (0, $7etnY.Color4).LerpToRef(particle._currentColor1, particle._currentColor2, scale, particle.color);
                });
                else {
                    particle.colorStep.scaleToRef(scaledUpdateSpeed, this._scaledColorStep);
                    particle.color.addInPlace(this._scaledColorStep);
                    if (particle.color.a < 0) particle.color.a = 0;
                }
                // Angular speed
                if (this._angularSpeedGradients && this._angularSpeedGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._angularSpeedGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentAngularSpeedGradient) {
                        particle._currentAngularSpeed1 = particle._currentAngularSpeed2;
                        particle._currentAngularSpeed2 = nextGradient.getFactor();
                        particle._currentAngularSpeedGradient = currentGradient;
                    }
                    particle.angularSpeed = (0, $iosaP.Lerp)(particle._currentAngularSpeed1, particle._currentAngularSpeed2, scale);
                });
                particle.angle += particle.angularSpeed * scaledUpdateSpeed;
                // Direction
                let directionScale = scaledUpdateSpeed;
                /// Velocity
                if (this._velocityGradients && this._velocityGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._velocityGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentVelocityGradient) {
                        particle._currentVelocity1 = particle._currentVelocity2;
                        particle._currentVelocity2 = nextGradient.getFactor();
                        particle._currentVelocityGradient = currentGradient;
                    }
                    directionScale *= (0, $iosaP.Lerp)(particle._currentVelocity1, particle._currentVelocity2, scale);
                });
                particle.direction.scaleToRef(directionScale, this._scaledDirection);
                /// Limit velocity
                if (this._limitVelocityGradients && this._limitVelocityGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._limitVelocityGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentLimitVelocityGradient) {
                        particle._currentLimitVelocity1 = particle._currentLimitVelocity2;
                        particle._currentLimitVelocity2 = nextGradient.getFactor();
                        particle._currentLimitVelocityGradient = currentGradient;
                    }
                    const limitVelocity = (0, $iosaP.Lerp)(particle._currentLimitVelocity1, particle._currentLimitVelocity2, scale);
                    const currentVelocity = particle.direction.length();
                    if (currentVelocity > limitVelocity) particle.direction.scaleInPlace(this.limitVelocityDamping);
                });
                /// Drag
                if (this._dragGradients && this._dragGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._dragGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentDragGradient) {
                        particle._currentDrag1 = particle._currentDrag2;
                        particle._currentDrag2 = nextGradient.getFactor();
                        particle._currentDragGradient = currentGradient;
                    }
                    const drag = (0, $iosaP.Lerp)(particle._currentDrag1, particle._currentDrag2, scale);
                    this._scaledDirection.scaleInPlace(1.0 - drag);
                });
                if (this.isLocal && particle._localPosition) {
                    particle._localPosition.addInPlace(this._scaledDirection);
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(particle._localPosition, this._emitterWorldMatrix, particle.position);
                } else particle.position.addInPlace(this._scaledDirection);
                // Noise
                if (noiseTextureData && noiseTextureSize && particle._randomNoiseCoordinates1) {
                    const fetchedColorR = this._fetchR(particle._randomNoiseCoordinates1.x, particle._randomNoiseCoordinates1.y, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                    const fetchedColorG = this._fetchR(particle._randomNoiseCoordinates1.z, particle._randomNoiseCoordinates2.x, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                    const fetchedColorB = this._fetchR(particle._randomNoiseCoordinates2.y, particle._randomNoiseCoordinates2.z, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                    const force = (0, $ha1VO.TmpVectors).Vector3[0];
                    const scaledForce = (0, $ha1VO.TmpVectors).Vector3[1];
                    force.copyFromFloats((2 * fetchedColorR - 1) * this.noiseStrength.x, (2 * fetchedColorG - 1) * this.noiseStrength.y, (2 * fetchedColorB - 1) * this.noiseStrength.z);
                    force.scaleToRef(scaledUpdateSpeed, scaledForce);
                    particle.direction.addInPlace(scaledForce);
                }
                // Gravity
                this.gravity.scaleToRef(scaledUpdateSpeed, this._scaledGravity);
                particle.direction.addInPlace(this._scaledGravity);
                // Size
                if (this._sizeGradients && this._sizeGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._sizeGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentSizeGradient) {
                        particle._currentSize1 = particle._currentSize2;
                        particle._currentSize2 = nextGradient.getFactor();
                        particle._currentSizeGradient = currentGradient;
                    }
                    particle.size = (0, $iosaP.Lerp)(particle._currentSize1, particle._currentSize2, scale);
                });
                // Remap data
                if (this._useRampGradients) {
                    if (this._colorRemapGradients && this._colorRemapGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._colorRemapGradients, (currentGradient, nextGradient, scale)=>{
                        const min = (0, $iosaP.Lerp)(currentGradient.factor1, nextGradient.factor1, scale);
                        const max = (0, $iosaP.Lerp)(currentGradient.factor2, nextGradient.factor2, scale);
                        particle.remapData.x = min;
                        particle.remapData.y = max - min;
                    });
                    if (this._alphaRemapGradients && this._alphaRemapGradients.length > 0) (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._alphaRemapGradients, (currentGradient, nextGradient, scale)=>{
                        const min = (0, $iosaP.Lerp)(currentGradient.factor1, nextGradient.factor1, scale);
                        const max = (0, $iosaP.Lerp)(currentGradient.factor2, nextGradient.factor2, scale);
                        particle.remapData.z = min;
                        particle.remapData.w = max - min;
                    });
                }
                if (this._isAnimationSheetEnabled) particle.updateCellIndex();
                // Update the position of the attached sub-emitters to match their attached particle
                particle._inheritParticleInfoToSubEmitters();
                if (particle.age >= particle.lifeTime) {
                    // Recycle by swapping with last particle
                    this._emitFromParticle(particle);
                    if (particle._attachedSubEmitters) {
                        particle._attachedSubEmitters.forEach((subEmitter)=>{
                            subEmitter.particleSystem.disposeOnStop = true;
                            subEmitter.particleSystem.stop();
                        });
                        particle._attachedSubEmitters = null;
                    }
                    this.recycleParticle(particle);
                    if (sameParticleArray) index--;
                    continue;
                }
            }
        };
    }
    serialize(serializeTexture) {
        throw new Error("Method not implemented.");
    }
    /**
     * Clones the particle system.
     * @param name The name of the cloned object
     * @param newEmitter The new emitter to use
     * @param cloneTexture Also clone the textures if true
     */ clone(name, newEmitter, cloneTexture = false) {
        throw new Error("Method not implemented.");
    }
    _addFactorGradient(factorGradients, gradient, factor, factor2) {
        const newGradient = new (0, $d92ab40db8c700a0$export$3722161617a7d2a5)(gradient, factor, factor2);
        factorGradients.push(newGradient);
        factorGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
    }
    _removeFactorGradient(factorGradients, gradient) {
        if (!factorGradients) return;
        let index = 0;
        for (const factorGradient of factorGradients){
            if (factorGradient.gradient === gradient) {
                factorGradients.splice(index, 1);
                break;
            }
            index++;
        }
    }
    /**
     * Adds a new life time gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the life time factor to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addLifeTimeGradient(gradient, factor, factor2) {
        if (!this._lifeTimeGradients) this._lifeTimeGradients = [];
        this._addFactorGradient(this._lifeTimeGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific life time gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeLifeTimeGradient(gradient) {
        this._removeFactorGradient(this._lifeTimeGradients, gradient);
        return this;
    }
    /**
     * Adds a new size gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the size factor to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addSizeGradient(gradient, factor, factor2) {
        if (!this._sizeGradients) this._sizeGradients = [];
        this._addFactorGradient(this._sizeGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific size gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeSizeGradient(gradient) {
        this._removeFactorGradient(this._sizeGradients, gradient);
        return this;
    }
    /**
     * Adds a new color remap gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param min defines the color remap minimal range
     * @param max defines the color remap maximal range
     * @returns the current particle system
     */ addColorRemapGradient(gradient, min, max) {
        if (!this._colorRemapGradients) this._colorRemapGradients = [];
        this._addFactorGradient(this._colorRemapGradients, gradient, min, max);
        return this;
    }
    /**
     * Remove a specific color remap gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeColorRemapGradient(gradient) {
        this._removeFactorGradient(this._colorRemapGradients, gradient);
        return this;
    }
    /**
     * Adds a new alpha remap gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param min defines the alpha remap minimal range
     * @param max defines the alpha remap maximal range
     * @returns the current particle system
     */ addAlphaRemapGradient(gradient, min, max) {
        if (!this._alphaRemapGradients) this._alphaRemapGradients = [];
        this._addFactorGradient(this._alphaRemapGradients, gradient, min, max);
        return this;
    }
    /**
     * Remove a specific alpha remap gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeAlphaRemapGradient(gradient) {
        this._removeFactorGradient(this._alphaRemapGradients, gradient);
        return this;
    }
    /**
     * Adds a new angular speed gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the angular speed  to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addAngularSpeedGradient(gradient, factor, factor2) {
        if (!this._angularSpeedGradients) this._angularSpeedGradients = [];
        this._addFactorGradient(this._angularSpeedGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific angular speed gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeAngularSpeedGradient(gradient) {
        this._removeFactorGradient(this._angularSpeedGradients, gradient);
        return this;
    }
    /**
     * Adds a new velocity gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the velocity to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addVelocityGradient(gradient, factor, factor2) {
        if (!this._velocityGradients) this._velocityGradients = [];
        this._addFactorGradient(this._velocityGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific velocity gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeVelocityGradient(gradient) {
        this._removeFactorGradient(this._velocityGradients, gradient);
        return this;
    }
    /**
     * Adds a new limit velocity gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the limit velocity value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addLimitVelocityGradient(gradient, factor, factor2) {
        if (!this._limitVelocityGradients) this._limitVelocityGradients = [];
        this._addFactorGradient(this._limitVelocityGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific limit velocity gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeLimitVelocityGradient(gradient) {
        this._removeFactorGradient(this._limitVelocityGradients, gradient);
        return this;
    }
    /**
     * Adds a new drag gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the drag value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addDragGradient(gradient, factor, factor2) {
        if (!this._dragGradients) this._dragGradients = [];
        this._addFactorGradient(this._dragGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific drag gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeDragGradient(gradient) {
        this._removeFactorGradient(this._dragGradients, gradient);
        return this;
    }
    /**
     * Adds a new emit rate gradient (please note that this will only work if you set the targetStopDuration property)
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the emit rate value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addEmitRateGradient(gradient, factor, factor2) {
        if (!this._emitRateGradients) this._emitRateGradients = [];
        this._addFactorGradient(this._emitRateGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific emit rate gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeEmitRateGradient(gradient) {
        this._removeFactorGradient(this._emitRateGradients, gradient);
        return this;
    }
    /**
     * Adds a new start size gradient (please note that this will only work if you set the targetStopDuration property)
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the start size value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addStartSizeGradient(gradient, factor, factor2) {
        if (!this._startSizeGradients) this._startSizeGradients = [];
        this._addFactorGradient(this._startSizeGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific start size gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeStartSizeGradient(gradient) {
        this._removeFactorGradient(this._startSizeGradients, gradient);
        return this;
    }
    _createRampGradientTexture() {
        if (!this._rampGradients || !this._rampGradients.length || this._rampGradientsTexture || !this._scene) return;
        const data = new Uint8Array(this._rawTextureWidth * 4);
        const tmpColor = (0, $7etnY.TmpColors).Color3[0];
        for(let x = 0; x < this._rawTextureWidth; x++){
            const ratio = x / this._rawTextureWidth;
            (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._rampGradients, (currentGradient, nextGradient, scale)=>{
                (0, $7etnY.Color3).LerpToRef(currentGradient.color, nextGradient.color, scale, tmpColor);
                data[x * 4] = tmpColor.r * 255;
                data[x * 4 + 1] = tmpColor.g * 255;
                data[x * 4 + 2] = tmpColor.b * 255;
                data[x * 4 + 3] = 255;
            });
        }
        this._rampGradientsTexture = (0, $41cd6a50c4d71975$export$c6d6cd5ffcb825d2).CreateRGBATexture(data, this._rawTextureWidth, 1, this._scene, false, false, 1);
    }
    /**
     * Gets the current list of ramp gradients.
     * You must use addRampGradient and removeRampGradient to update this list
     * @returns the list of ramp gradients
     */ getRampGradients() {
        return this._rampGradients;
    }
    /** Force the system to rebuild all gradients that need to be resync */ forceRefreshGradients() {
        this._syncRampGradientTexture();
    }
    _syncRampGradientTexture() {
        if (!this._rampGradients) return;
        this._rampGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
        if (this._rampGradientsTexture) {
            this._rampGradientsTexture.dispose();
            this._rampGradientsTexture = null;
        }
        this._createRampGradientTexture();
    }
    /**
     * Adds a new ramp gradient used to remap particle colors
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param color defines the color to affect to the specified gradient
     * @returns the current particle system
     */ addRampGradient(gradient, color) {
        if (!this._rampGradients) this._rampGradients = [];
        const rampGradient = new (0, $d92ab40db8c700a0$export$9c465576c5b3fff7)(gradient, color);
        this._rampGradients.push(rampGradient);
        this._syncRampGradientTexture();
        return this;
    }
    /**
     * Remove a specific ramp gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeRampGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._rampGradients, this._rampGradientsTexture);
        this._rampGradientsTexture = null;
        if (this._rampGradients && this._rampGradients.length > 0) this._createRampGradientTexture();
        return this;
    }
    /**
     * Adds a new color gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param color1 defines the color to affect to the specified gradient
     * @param color2 defines an additional color used to define a range ([color, color2]) with main color to pick the final color from
     * @returns this particle system
     */ addColorGradient(gradient, color1, color2) {
        if (!this._colorGradients) this._colorGradients = [];
        const colorGradient = new (0, $d92ab40db8c700a0$export$611a8e87a207147e)(gradient, color1, color2);
        this._colorGradients.push(colorGradient);
        this._colorGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
        return this;
    }
    /**
     * Remove a specific color gradient
     * @param gradient defines the gradient to remove
     * @returns this particle system
     */ removeColorGradient(gradient) {
        if (!this._colorGradients) return this;
        let index = 0;
        for (const colorGradient of this._colorGradients){
            if (colorGradient.gradient === gradient) {
                this._colorGradients.splice(index, 1);
                break;
            }
            index++;
        }
        return this;
    }
    /**
     * Resets the draw wrappers cache
     */ resetDrawCache() {
        for (const drawWrappers of this._drawWrappers){
            if (drawWrappers) for (const drawWrapper of drawWrappers)drawWrapper?.dispose();
        }
        this._drawWrappers = [];
    }
    _fetchR(u, v, width, height, pixels) {
        u = Math.abs(u) * 0.5 + 0.5;
        v = Math.abs(v) * 0.5 + 0.5;
        const wrappedU = u * width % width | 0;
        const wrappedV = v * height % height | 0;
        const position = (wrappedU + wrappedV * width) * 4;
        return pixels[position] / 255;
    }
    _reset() {
        this._resetEffect();
    }
    _resetEffect() {
        if (this._vertexBuffer) {
            this._vertexBuffer.dispose();
            this._vertexBuffer = null;
        }
        if (this._spriteBuffer) {
            this._spriteBuffer.dispose();
            this._spriteBuffer = null;
        }
        if (this._vertexArrayObject) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObject);
            this._vertexArrayObject = null;
        }
        this._createVertexBuffers();
    }
    _createVertexBuffers() {
        this._vertexBufferSize = this._useInstancing ? 10 : 12;
        if (this._isAnimationSheetEnabled) this._vertexBufferSize += 1;
        if (!this._isBillboardBased || this.billboardMode === 8 || this.billboardMode === 9) this._vertexBufferSize += 3;
        if (this._useRampGradients) this._vertexBufferSize += 4;
        const engine = this._engine;
        const vertexSize = this._vertexBufferSize * (this._useInstancing ? 1 : 4);
        this._vertexData = new Float32Array(this._capacity * vertexSize);
        this._vertexBuffer = new (0, $b4i1f.Buffer)(engine, this._vertexData, true, vertexSize);
        let dataOffset = 0;
        const positions = this._vertexBuffer.createVertexBuffer((0, $b4i1f.VertexBuffer).PositionKind, dataOffset, 3, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = positions;
        dataOffset += 3;
        const colors = this._vertexBuffer.createVertexBuffer((0, $b4i1f.VertexBuffer).ColorKind, dataOffset, 4, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).ColorKind] = colors;
        dataOffset += 4;
        const options = this._vertexBuffer.createVertexBuffer("angle", dataOffset, 1, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers["angle"] = options;
        dataOffset += 1;
        const size = this._vertexBuffer.createVertexBuffer("size", dataOffset, 2, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers["size"] = size;
        dataOffset += 2;
        if (this._isAnimationSheetEnabled) {
            const cellIndexBuffer = this._vertexBuffer.createVertexBuffer("cellIndex", dataOffset, 1, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["cellIndex"] = cellIndexBuffer;
            dataOffset += 1;
        }
        if (!this._isBillboardBased || this.billboardMode === 8 || this.billboardMode === 9) {
            const directionBuffer = this._vertexBuffer.createVertexBuffer("direction", dataOffset, 3, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["direction"] = directionBuffer;
            dataOffset += 3;
        }
        if (this._useRampGradients) {
            const rampDataBuffer = this._vertexBuffer.createVertexBuffer("remapData", dataOffset, 4, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["remapData"] = rampDataBuffer;
            dataOffset += 4;
        }
        let offsets;
        if (this._useInstancing) {
            const spriteData = new Float32Array([
                0,
                0,
                1,
                0,
                0,
                1,
                1,
                1
            ]);
            this._spriteBuffer = new (0, $b4i1f.Buffer)(engine, spriteData, false, 2);
            offsets = this._spriteBuffer.createVertexBuffer("offset", 0, 2);
        } else {
            offsets = this._vertexBuffer.createVertexBuffer("offset", dataOffset, 2, this._vertexBufferSize, this._useInstancing);
            dataOffset += 2;
        }
        this._vertexBuffers["offset"] = offsets;
        this.resetDrawCache();
    }
    _createIndexBuffer() {
        if (this._useInstancing) {
            this._linesIndexBufferUseInstancing = this._engine.createIndexBuffer(new Uint32Array([
                0,
                1,
                1,
                3,
                3,
                2,
                2,
                0,
                0,
                3
            ]));
            return;
        }
        const indices = [];
        const indicesWireframe = [];
        let index = 0;
        for(let count = 0; count < this._capacity; count++){
            indices.push(index);
            indices.push(index + 1);
            indices.push(index + 2);
            indices.push(index);
            indices.push(index + 2);
            indices.push(index + 3);
            indicesWireframe.push(index, index + 1, index + 1, index + 2, index + 2, index + 3, index + 3, index, index, index + 3);
            index += 4;
        }
        this._indexBuffer = this._engine.createIndexBuffer(indices);
        this._linesIndexBuffer = this._engine.createIndexBuffer(indicesWireframe);
    }
    /**
     * Gets the maximum number of particles active at the same time.
     * @returns The max number of active particles.
     */ getCapacity() {
        return this._capacity;
    }
    /**
     * Gets whether there are still active particles in the system.
     * @returns True if it is alive, otherwise false.
     */ isAlive() {
        return this._alive;
    }
    /**
     * Gets if the system has been started. (Note: this will still be true after stop is called)
     * @returns True if it has been started, otherwise false.
     */ isStarted() {
        return this._started;
    }
    /** @internal */ _preStart() {
    // Do nothing
    }
    /**
     * Starts the particle system and begins to emit
     * @param delay defines the delay in milliseconds before starting the system (this.startDelay by default)
     */ start(delay = this.startDelay) {
        if (!this.targetStopDuration && this._hasTargetStopDurationDependantGradient()) // eslint-disable-next-line no-throw-literal
        throw "Particle system started with a targetStopDuration dependant gradient (eg. startSizeGradients) but no targetStopDuration set";
        if (delay) {
            setTimeout(()=>{
                this.start(0);
            }, delay);
            return;
        }
        this._started = true;
        this._stopped = false;
        this._actualFrame = 0;
        this._preStart();
        // Reset emit gradient so it acts the same on every start
        if (this._emitRateGradients) {
            if (this._emitRateGradients.length > 0) {
                this._currentEmitRateGradient = this._emitRateGradients[0];
                this._currentEmitRate1 = this._currentEmitRateGradient.getFactor();
                this._currentEmitRate2 = this._currentEmitRate1;
            }
            if (this._emitRateGradients.length > 1) this._currentEmitRate2 = this._emitRateGradients[1].getFactor();
        }
        // Reset start size gradient so it acts the same on every start
        if (this._startSizeGradients) {
            if (this._startSizeGradients.length > 0) {
                this._currentStartSizeGradient = this._startSizeGradients[0];
                this._currentStartSize1 = this._currentStartSizeGradient.getFactor();
                this._currentStartSize2 = this._currentStartSize1;
            }
            if (this._startSizeGradients.length > 1) this._currentStartSize2 = this._startSizeGradients[1].getFactor();
        }
        if (this.preWarmCycles) {
            if (this.emitter?.getClassName().indexOf("Mesh") !== -1) this.emitter.computeWorldMatrix(true);
            const noiseTextureAsProcedural = this.noiseTexture;
            if (noiseTextureAsProcedural && noiseTextureAsProcedural.onGeneratedObservable) noiseTextureAsProcedural.onGeneratedObservable.addOnce(()=>{
                setTimeout(()=>{
                    for(let index = 0; index < this.preWarmCycles; index++){
                        this.animate(true);
                        noiseTextureAsProcedural.render();
                    }
                });
            });
            else for(let index = 0; index < this.preWarmCycles; index++)this.animate(true);
        }
        // Animations
        if (this.beginAnimationOnStart && this.animations && this.animations.length > 0 && this._scene) this._scene.beginAnimation(this, this.beginAnimationFrom, this.beginAnimationTo, this.beginAnimationLoop);
    }
    /**
     * Stops the particle system.
     * @param stopSubEmitters if true it will stop the current system and all created sub-Systems if false it will stop the current root system only, this param is used by the root particle system only. The default value is true.
     */ stop(stopSubEmitters = true) {
        if (this._stopped) return;
        this.onStoppedObservable.notifyObservers(this);
        this._stopped = true;
        this._postStop(stopSubEmitters);
    }
    /** @internal */ _postStop(stopSubEmitters) {
    // Do nothing
    }
    // Animation sheet
    /**
     * Remove all active particles
     */ reset() {
        this._stockParticles.length = 0;
        this._particles.length = 0;
    }
    /**
     * @internal (for internal use only)
     */ _appendParticleVertex(index, particle, offsetX, offsetY) {
        let offset = index * this._vertexBufferSize;
        this._vertexData[offset++] = particle.position.x + this.worldOffset.x;
        this._vertexData[offset++] = particle.position.y + this.worldOffset.y;
        this._vertexData[offset++] = particle.position.z + this.worldOffset.z;
        this._vertexData[offset++] = particle.color.r;
        this._vertexData[offset++] = particle.color.g;
        this._vertexData[offset++] = particle.color.b;
        this._vertexData[offset++] = particle.color.a;
        this._vertexData[offset++] = particle.angle;
        this._vertexData[offset++] = particle.scale.x * particle.size;
        this._vertexData[offset++] = particle.scale.y * particle.size;
        if (this._isAnimationSheetEnabled) this._vertexData[offset++] = particle.cellIndex;
        if (!this._isBillboardBased) {
            if (particle._initialDirection) {
                let initialDirection = particle._initialDirection;
                if (this.isLocal) {
                    (0, $ha1VO.Vector3).TransformNormalToRef(initialDirection, this._emitterWorldMatrix, (0, $ha1VO.TmpVectors).Vector3[0]);
                    initialDirection = (0, $ha1VO.TmpVectors).Vector3[0];
                }
                if (initialDirection.x === 0 && initialDirection.z === 0) initialDirection.x = 0.001;
                this._vertexData[offset++] = initialDirection.x;
                this._vertexData[offset++] = initialDirection.y;
                this._vertexData[offset++] = initialDirection.z;
            } else {
                let direction = particle.direction;
                if (this.isLocal) {
                    (0, $ha1VO.Vector3).TransformNormalToRef(direction, this._emitterWorldMatrix, (0, $ha1VO.TmpVectors).Vector3[0]);
                    direction = (0, $ha1VO.TmpVectors).Vector3[0];
                }
                if (direction.x === 0 && direction.z === 0) direction.x = 0.001;
                this._vertexData[offset++] = direction.x;
                this._vertexData[offset++] = direction.y;
                this._vertexData[offset++] = direction.z;
            }
        } else if (this.billboardMode === 8 || this.billboardMode === 9) {
            this._vertexData[offset++] = particle.direction.x;
            this._vertexData[offset++] = particle.direction.y;
            this._vertexData[offset++] = particle.direction.z;
        }
        if (this._useRampGradients && particle.remapData) {
            this._vertexData[offset++] = particle.remapData.x;
            this._vertexData[offset++] = particle.remapData.y;
            this._vertexData[offset++] = particle.remapData.z;
            this._vertexData[offset++] = particle.remapData.w;
        }
        if (!this._useInstancing) {
            if (this._isAnimationSheetEnabled) {
                if (offsetX === 0) offsetX = this._epsilon;
                else if (offsetX === 1) offsetX = 1 - this._epsilon;
                if (offsetY === 0) offsetY = this._epsilon;
                else if (offsetY === 1) offsetY = 1 - this._epsilon;
            }
            this._vertexData[offset++] = offsetX;
            this._vertexData[offset++] = offsetY;
        }
    }
    /** @internal */ _prepareParticle(particle) {
    //Do nothing
    }
    _update(newParticles) {
        // Update current
        this._alive = this._particles.length > 0;
        if (this.emitter.position) {
            const emitterMesh = this.emitter;
            this._emitterWorldMatrix = emitterMesh.getWorldMatrix();
        } else {
            const emitterPosition = this.emitter;
            this._emitterWorldMatrix = (0, $ha1VO.Matrix).Translation(emitterPosition.x, emitterPosition.y, emitterPosition.z);
        }
        this._emitterWorldMatrix.invertToRef(this._emitterInverseWorldMatrix);
        this.updateFunction(this._particles);
        // Add new ones
        let particle;
        for(let index = 0; index < newParticles; index++){
            if (this._particles.length === this._capacity) break;
            particle = this._createParticle();
            this._particles.push(particle);
            // Life time
            if (this.targetStopDuration && this._lifeTimeGradients && this._lifeTimeGradients.length > 0) {
                const ratio = (0, $iosaP.Clamp)(this._actualFrame / this.targetStopDuration);
                (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._lifeTimeGradients, (currentGradient, nextGradient)=>{
                    const factorGradient1 = currentGradient;
                    const factorGradient2 = nextGradient;
                    const lifeTime1 = factorGradient1.getFactor();
                    const lifeTime2 = factorGradient2.getFactor();
                    const gradient = (ratio - factorGradient1.gradient) / (factorGradient2.gradient - factorGradient1.gradient);
                    particle.lifeTime = (0, $iosaP.Lerp)(lifeTime1, lifeTime2, gradient);
                });
            } else particle.lifeTime = (0, $iosaP.RandomRange)(this.minLifeTime, this.maxLifeTime);
            // Emitter
            const emitPower = (0, $iosaP.RandomRange)(this.minEmitPower, this.maxEmitPower);
            if (this.startPositionFunction) this.startPositionFunction(this._emitterWorldMatrix, particle.position, particle, this.isLocal);
            else this.particleEmitterType.startPositionFunction(this._emitterWorldMatrix, particle.position, particle, this.isLocal);
            if (this.isLocal) {
                if (!particle._localPosition) particle._localPosition = particle.position.clone();
                else particle._localPosition.copyFrom(particle.position);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(particle._localPosition, this._emitterWorldMatrix, particle.position);
            }
            if (this.startDirectionFunction) this.startDirectionFunction(this._emitterWorldMatrix, particle.direction, particle, this.isLocal);
            else this.particleEmitterType.startDirectionFunction(this._emitterWorldMatrix, particle.direction, particle, this.isLocal, this._emitterInverseWorldMatrix);
            if (emitPower === 0) {
                if (!particle._initialDirection) particle._initialDirection = particle.direction.clone();
                else particle._initialDirection.copyFrom(particle.direction);
            } else particle._initialDirection = null;
            particle.direction.scaleInPlace(emitPower);
            // Size
            if (!this._sizeGradients || this._sizeGradients.length === 0) particle.size = (0, $iosaP.RandomRange)(this.minSize, this.maxSize);
            else {
                particle._currentSizeGradient = this._sizeGradients[0];
                particle._currentSize1 = particle._currentSizeGradient.getFactor();
                particle.size = particle._currentSize1;
                if (this._sizeGradients.length > 1) particle._currentSize2 = this._sizeGradients[1].getFactor();
                else particle._currentSize2 = particle._currentSize1;
            }
            // Size and scale
            particle.scale.copyFromFloats((0, $iosaP.RandomRange)(this.minScaleX, this.maxScaleX), (0, $iosaP.RandomRange)(this.minScaleY, this.maxScaleY));
            // Adjust scale by start size
            if (this._startSizeGradients && this._startSizeGradients[0] && this.targetStopDuration) {
                const ratio = this._actualFrame / this.targetStopDuration;
                (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._startSizeGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== this._currentStartSizeGradient) {
                        this._currentStartSize1 = this._currentStartSize2;
                        this._currentStartSize2 = nextGradient.getFactor();
                        this._currentStartSizeGradient = currentGradient;
                    }
                    const value = (0, $iosaP.Lerp)(this._currentStartSize1, this._currentStartSize2, scale);
                    particle.scale.scaleInPlace(value);
                });
            }
            // Angle
            if (!this._angularSpeedGradients || this._angularSpeedGradients.length === 0) particle.angularSpeed = (0, $iosaP.RandomRange)(this.minAngularSpeed, this.maxAngularSpeed);
            else {
                particle._currentAngularSpeedGradient = this._angularSpeedGradients[0];
                particle.angularSpeed = particle._currentAngularSpeedGradient.getFactor();
                particle._currentAngularSpeed1 = particle.angularSpeed;
                if (this._angularSpeedGradients.length > 1) particle._currentAngularSpeed2 = this._angularSpeedGradients[1].getFactor();
                else particle._currentAngularSpeed2 = particle._currentAngularSpeed1;
            }
            particle.angle = (0, $iosaP.RandomRange)(this.minInitialRotation, this.maxInitialRotation);
            // Velocity
            if (this._velocityGradients && this._velocityGradients.length > 0) {
                particle._currentVelocityGradient = this._velocityGradients[0];
                particle._currentVelocity1 = particle._currentVelocityGradient.getFactor();
                if (this._velocityGradients.length > 1) particle._currentVelocity2 = this._velocityGradients[1].getFactor();
                else particle._currentVelocity2 = particle._currentVelocity1;
            }
            // Limit velocity
            if (this._limitVelocityGradients && this._limitVelocityGradients.length > 0) {
                particle._currentLimitVelocityGradient = this._limitVelocityGradients[0];
                particle._currentLimitVelocity1 = particle._currentLimitVelocityGradient.getFactor();
                if (this._limitVelocityGradients.length > 1) particle._currentLimitVelocity2 = this._limitVelocityGradients[1].getFactor();
                else particle._currentLimitVelocity2 = particle._currentLimitVelocity1;
            }
            // Drag
            if (this._dragGradients && this._dragGradients.length > 0) {
                particle._currentDragGradient = this._dragGradients[0];
                particle._currentDrag1 = particle._currentDragGradient.getFactor();
                if (this._dragGradients.length > 1) particle._currentDrag2 = this._dragGradients[1].getFactor();
                else particle._currentDrag2 = particle._currentDrag1;
            }
            // Color
            if (!this._colorGradients || this._colorGradients.length === 0) {
                const step = (0, $iosaP.RandomRange)(0, 1.0);
                (0, $7etnY.Color4).LerpToRef(this.color1, this.color2, step, particle.color);
                this.colorDead.subtractToRef(particle.color, this._colorDiff);
                this._colorDiff.scaleToRef(1.0 / particle.lifeTime, particle.colorStep);
            } else {
                particle._currentColorGradient = this._colorGradients[0];
                particle._currentColorGradient.getColorToRef(particle.color);
                particle._currentColor1.copyFrom(particle.color);
                if (this._colorGradients.length > 1) this._colorGradients[1].getColorToRef(particle._currentColor2);
                else particle._currentColor2.copyFrom(particle.color);
            }
            // Sheet
            if (this._isAnimationSheetEnabled) {
                particle._initialStartSpriteCellID = this.startSpriteCellID;
                particle._initialEndSpriteCellID = this.endSpriteCellID;
                particle._initialSpriteCellLoop = this.spriteCellLoop;
            }
            // Inherited Velocity
            particle.direction.addInPlace(this._inheritedVelocityOffset);
            // Ramp
            if (this._useRampGradients) particle.remapData = new (0, $ha1VO.Vector4)(0, 1, 0, 1);
            // Noise texture coordinates
            if (this.noiseTexture) {
                if (particle._randomNoiseCoordinates1) {
                    particle._randomNoiseCoordinates1.copyFromFloats(Math.random(), Math.random(), Math.random());
                    particle._randomNoiseCoordinates2.copyFromFloats(Math.random(), Math.random(), Math.random());
                } else {
                    particle._randomNoiseCoordinates1 = new (0, $ha1VO.Vector3)(Math.random(), Math.random(), Math.random());
                    particle._randomNoiseCoordinates2 = new (0, $ha1VO.Vector3)(Math.random(), Math.random(), Math.random());
                }
            }
            // Update the position of the attached sub-emitters to match their attached particle
            particle._inheritParticleInfoToSubEmitters();
        }
    }
    /**
     * @internal
     */ static _GetAttributeNamesOrOptions(isAnimationSheetEnabled = false, isBillboardBased = false, useRampGradients = false) {
        const attributeNamesOrOptions = [
            (0, $b4i1f.VertexBuffer).PositionKind,
            (0, $b4i1f.VertexBuffer).ColorKind,
            "angle",
            "offset",
            "size"
        ];
        if (isAnimationSheetEnabled) attributeNamesOrOptions.push("cellIndex");
        if (!isBillboardBased) attributeNamesOrOptions.push("direction");
        if (useRampGradients) attributeNamesOrOptions.push("remapData");
        return attributeNamesOrOptions;
    }
    /**
     * @internal
     */ static _GetEffectCreationOptions(isAnimationSheetEnabled = false, useLogarithmicDepth = false, applyFog = false) {
        const effectCreationOption = [
            "invView",
            "view",
            "projection",
            "textureMask",
            "translationPivot",
            "eyePosition"
        ];
        (0, $7b5d4109d15c2b5f$export$959caf24bcfab1fd)(effectCreationOption);
        if (isAnimationSheetEnabled) effectCreationOption.push("particlesInfos");
        if (useLogarithmicDepth) effectCreationOption.push("logarithmicDepthConstant");
        if (applyFog) {
            effectCreationOption.push("vFogInfos");
            effectCreationOption.push("vFogColor");
        }
        return effectCreationOption;
    }
    /**
     * Fill the defines array according to the current settings of the particle system
     * @param defines Array to be updated
     * @param blendMode blend mode to take into account when updating the array
     * @param fillImageProcessing fills the image processing defines
     */ fillDefines(defines, blendMode, fillImageProcessing = true) {
        if (this._scene) {
            (0, $7b5d4109d15c2b5f$export$8deac9e8ed5fc6a9)(this, this._scene, defines);
            if (this.applyFog && this._scene.fogEnabled && this._scene.fogMode !== 0) defines.push("#define FOG");
        }
        if (this._isAnimationSheetEnabled) defines.push("#define ANIMATESHEET");
        if (this.useLogarithmicDepth) defines.push("#define LOGARITHMICDEPTH");
        if (blendMode === (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_MULTIPLY) defines.push("#define BLENDMULTIPLYMODE");
        if (this._useRampGradients) defines.push("#define RAMPGRADIENT");
        if (this._isBillboardBased) {
            defines.push("#define BILLBOARD");
            switch(this.billboardMode){
                case 2:
                    defines.push("#define BILLBOARDY");
                    break;
                case 8:
                case 9:
                    defines.push("#define BILLBOARDSTRETCHED");
                    if (this.billboardMode === 9) defines.push("#define BILLBOARDSTRETCHED_LOCAL");
                    break;
                case 7:
                    defines.push("#define BILLBOARDMODE_ALL");
                    break;
                default:
                    break;
            }
        }
        if (fillImageProcessing && this._imageProcessingConfiguration) {
            this._imageProcessingConfiguration.prepareDefines(this._imageProcessingConfigurationDefines);
            defines.push(this._imageProcessingConfigurationDefines.toString());
        }
    }
    /**
     * Fill the uniforms, attributes and samplers arrays according to the current settings of the particle system
     * @param uniforms Uniforms array to fill
     * @param attributes Attributes array to fill
     * @param samplers Samplers array to fill
     */ fillUniformsAttributesAndSamplerNames(uniforms, attributes, samplers) {
        attributes.push(...$95351d116892571a$export$b52eeadd2730cb3f._GetAttributeNamesOrOptions(this._isAnimationSheetEnabled, this._isBillboardBased && this.billboardMode !== 8 && this.billboardMode !== 9, this._useRampGradients));
        uniforms.push(...$95351d116892571a$export$b52eeadd2730cb3f._GetEffectCreationOptions(this._isAnimationSheetEnabled, this.useLogarithmicDepth, this.applyFog));
        samplers.push("diffuseSampler", "rampSampler");
        if (this._imageProcessingConfiguration) {
            (0, $ePyUi.PrepareUniformsForImageProcessing)(uniforms, this._imageProcessingConfigurationDefines);
            (0, $ePyUi.PrepareSamplersForImageProcessing)(samplers, this._imageProcessingConfigurationDefines);
        }
    }
    /**
     * @internal
     */ _getWrapper(blendMode) {
        const customWrapper = this._getCustomDrawWrapper(blendMode);
        if (customWrapper?.effect) return customWrapper;
        const defines = [];
        this.fillDefines(defines, blendMode);
        // Effect
        const currentRenderPassId = this._engine._features.supportRenderPasses ? this._engine.currentRenderPassId : 0;
        let drawWrappers = this._drawWrappers[currentRenderPassId];
        if (!drawWrappers) drawWrappers = this._drawWrappers[currentRenderPassId] = [];
        let drawWrapper = drawWrappers[blendMode];
        if (!drawWrapper) {
            drawWrapper = new (0, $hOyoX.DrawWrapper)(this._engine);
            if (drawWrapper.drawContext) drawWrapper.drawContext.useInstancing = this._useInstancing;
            drawWrappers[blendMode] = drawWrapper;
        }
        const join = defines.join("\n");
        if (drawWrapper.defines !== join) {
            const attributesNamesOrOptions = [];
            const effectCreationOption = [];
            const samplers = [];
            this.fillUniformsAttributesAndSamplerNames(effectCreationOption, attributesNamesOrOptions, samplers);
            drawWrapper.setEffect(this._engine.createEffect("particles", attributesNamesOrOptions, effectCreationOption, samplers, join, undefined, undefined, undefined, undefined, this._shaderLanguage), join);
        }
        return drawWrapper;
    }
    /**
     * Animates the particle system for the current frame by emitting new particles and or animating the living ones.
     * @param preWarmOnly will prevent the system from updating the vertex buffer (default is false)
     */ animate(preWarmOnly = false) {
        if (!this._started) return;
        if (!preWarmOnly && this._scene) {
            // Check
            if (!this.isReady()) return;
            if (this._currentRenderId === this._scene.getFrameId()) return;
            this._currentRenderId = this._scene.getFrameId();
        }
        this._scaledUpdateSpeed = this.updateSpeed * (preWarmOnly ? this.preWarmStepOffset : this._scene?.getAnimationRatio() || 1);
        // Determine the number of particles we need to create
        let newParticles;
        if (this.manualEmitCount > -1) {
            newParticles = this.manualEmitCount;
            this._newPartsExcess = 0;
            this.manualEmitCount = 0;
        } else {
            let rate = this.emitRate;
            if (this._emitRateGradients && this._emitRateGradients.length > 0 && this.targetStopDuration) {
                const ratio = this._actualFrame / this.targetStopDuration;
                (0, $d92ab40db8c700a0$export$9547bfcc1522be4f).GetCurrentGradient(ratio, this._emitRateGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== this._currentEmitRateGradient) {
                        this._currentEmitRate1 = this._currentEmitRate2;
                        this._currentEmitRate2 = nextGradient.getFactor();
                        this._currentEmitRateGradient = currentGradient;
                    }
                    rate = (0, $iosaP.Lerp)(this._currentEmitRate1, this._currentEmitRate2, scale);
                });
            }
            newParticles = rate * this._scaledUpdateSpeed >> 0;
            this._newPartsExcess += rate * this._scaledUpdateSpeed - newParticles;
        }
        if (this._newPartsExcess > 1.0) {
            newParticles += this._newPartsExcess >> 0;
            this._newPartsExcess -= this._newPartsExcess >> 0;
        }
        this._alive = false;
        if (!this._stopped) {
            this._actualFrame += this._scaledUpdateSpeed;
            if (this.targetStopDuration && this._actualFrame >= this.targetStopDuration) this.stop();
        } else newParticles = 0;
        this._update(newParticles);
        // Stopped?
        if (this._stopped) {
            if (!this._alive) {
                this._started = false;
                if (this.onAnimationEnd) this.onAnimationEnd();
                if (this.disposeOnStop && this._scene) this._scene._toBeDisposed.push(this);
            }
        }
        if (!preWarmOnly) {
            // Update VBO
            let offset = 0;
            for(let index = 0; index < this._particles.length; index++){
                const particle = this._particles[index];
                this._appendParticleVertices(offset, particle);
                offset += this._useInstancing ? 1 : 4;
            }
            if (this._vertexBuffer) this._vertexBuffer.updateDirectly(this._vertexData, 0, this._particles.length);
        }
        if (this.manualEmitCount === 0 && this.disposeOnStop) this.stop();
    }
    _appendParticleVertices(offset, particle) {
        this._appendParticleVertex(offset++, particle, 0, 0);
        if (!this._useInstancing) {
            this._appendParticleVertex(offset++, particle, 1, 0);
            this._appendParticleVertex(offset++, particle, 1, 1);
            this._appendParticleVertex(offset++, particle, 0, 1);
        }
    }
    /**
     * Rebuilds the particle system.
     */ rebuild() {
        if (this._engine.getCaps().vertexArrayObject) this._vertexArrayObject = null;
        this._createIndexBuffer();
        this._spriteBuffer?._rebuild();
        this._createVertexBuffers();
        this.resetDrawCache();
    }
    async _initShaderSourceAsync() {
        const engine = this._engine;
        if (engine.isWebGPU && !$95351d116892571a$export$b52eeadd2730cb3f.ForceGLSL) {
            this._shaderLanguage = 1 /* ShaderLanguage.WGSL */ ;
            await Promise.all([
                (parcelRequire("k4Loe")),
                (parcelRequire("aj3L0"))
            ]);
        } else await Promise.all([
            (parcelRequire("kdcUk")),
            (parcelRequire("bLhm7"))
        ]);
        this._shadersLoaded = true;
    }
    /**
     * Is this system ready to be used/rendered
     * @returns true if the system is ready
     */ isReady() {
        if (!this._shadersLoaded) return false;
        if (!this.emitter || this._imageProcessingConfiguration && !this._imageProcessingConfiguration.isReady() || !this.particleTexture || !this.particleTexture.isReady()) return false;
        if (this.blendMode !== (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_MULTIPLYADD) {
            if (!this._getWrapper(this.blendMode).effect.isReady()) return false;
        } else {
            if (!this._getWrapper((0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_MULTIPLY).effect.isReady()) return false;
            if (!this._getWrapper((0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_ADD).effect.isReady()) return false;
        }
        return true;
    }
    _render(blendMode) {
        const drawWrapper = this._getWrapper(blendMode);
        const effect = drawWrapper.effect;
        const engine = this._engine;
        // Render
        engine.enableEffect(drawWrapper);
        const viewMatrix = this.defaultViewMatrix ?? this._scene.getViewMatrix();
        effect.setTexture("diffuseSampler", this.particleTexture);
        effect.setMatrix("view", viewMatrix);
        effect.setMatrix("projection", this.defaultProjectionMatrix ?? this._scene.getProjectionMatrix());
        if (this._isAnimationSheetEnabled && this.particleTexture) {
            const baseSize = this.particleTexture.getBaseSize();
            effect.setFloat3("particlesInfos", this.spriteCellWidth / baseSize.width, this.spriteCellHeight / baseSize.height, this.spriteCellWidth / baseSize.width);
        }
        effect.setVector2("translationPivot", this.translationPivot);
        effect.setFloat4("textureMask", this.textureMask.r, this.textureMask.g, this.textureMask.b, this.textureMask.a);
        if (this._isBillboardBased && this._scene) {
            const camera = this._scene.activeCamera;
            effect.setVector3("eyePosition", camera.globalPosition);
        }
        if (this._rampGradientsTexture) {
            if (!this._rampGradients || !this._rampGradients.length) {
                this._rampGradientsTexture.dispose();
                this._rampGradientsTexture = null;
            }
            effect.setTexture("rampSampler", this._rampGradientsTexture);
        }
        const defines = effect.defines;
        if (this._scene) {
            (0, $7b5d4109d15c2b5f$export$99061f41c02073b)(effect, this, this._scene);
            if (this.applyFog) (0, $7893e784ec9add9a$export$531a83026b679e28)(this._scene, undefined, effect);
        }
        if (defines.indexOf("#define BILLBOARDMODE_ALL") >= 0) {
            viewMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            effect.setMatrix("invView", (0, $ha1VO.TmpVectors).Matrix[0]);
        }
        if (this._vertexArrayObject !== undefined) {
            if (this._scene?.forceWireframe) engine.bindBuffers(this._vertexBuffers, this._linesIndexBufferUseInstancing, effect);
            else {
                if (!this._vertexArrayObject) this._vertexArrayObject = this._engine.recordVertexArrayObject(this._vertexBuffers, null, effect);
                this._engine.bindVertexArrayObject(this._vertexArrayObject, this._scene?.forceWireframe ? this._linesIndexBufferUseInstancing : this._indexBuffer);
            }
        } else if (!this._indexBuffer) // Use instancing mode
        engine.bindBuffers(this._vertexBuffers, this._scene?.forceWireframe ? this._linesIndexBufferUseInstancing : null, effect);
        else engine.bindBuffers(this._vertexBuffers, this._scene?.forceWireframe ? this._linesIndexBuffer : this._indexBuffer, effect);
        // Log. depth
        if (this.useLogarithmicDepth && this._scene) (0, $7893e784ec9add9a$export$c51be962d0cbc5db)(defines, effect, this._scene);
        // image processing
        if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) this._imageProcessingConfiguration.bind(effect);
        // Draw order
        switch(blendMode){
            case (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_ADD:
                engine.setAlphaMode(1);
                break;
            case (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_ONEONE:
                engine.setAlphaMode(6);
                break;
            case (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_STANDARD:
                engine.setAlphaMode(2);
                break;
            case (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_MULTIPLY:
                engine.setAlphaMode(4);
                break;
        }
        if (this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable.notifyObservers(effect);
        if (this._useInstancing) {
            if (this._scene?.forceWireframe) engine.drawElementsType(6, 0, 10, this._particles.length);
            else engine.drawArraysType(7, 0, 4, this._particles.length);
        } else if (this._scene?.forceWireframe) engine.drawElementsType(1, 0, this._particles.length * 10);
        else engine.drawElementsType(0, 0, this._particles.length * 6);
        return this._particles.length;
    }
    /**
     * Renders the particle system in its current state.
     * @returns the current number of particles
     */ render() {
        // Check
        if (!this.isReady() || !this._particles.length) return 0;
        const engine = this._engine;
        if (engine.setState) {
            engine.setState(false);
            if (this.forceDepthWrite) engine.setDepthWrite(true);
        }
        let outparticles = 0;
        if (this.blendMode === (0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_MULTIPLYADD) outparticles = this._render((0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_MULTIPLY) + this._render((0, $0f0fba623f54307f$export$27e68fd8fa9be86e).BLENDMODE_ADD);
        else outparticles = this._render(this.blendMode);
        this._engine.unbindInstanceAttributes();
        this._engine.setAlphaMode(0);
        return outparticles;
    }
    /** @internal */ _onDispose(disposeAttachedSubEmitters = false, disposeEndSubEmitters = false) {
    // Do Nothing
    }
    /**
     * Disposes the particle system and free the associated resources
     * @param disposeTexture defines if the particle texture must be disposed as well (true by default)
     * @param disposeAttachedSubEmitters defines if the attached sub-emitters must be disposed as well (false by default)
     * @param disposeEndSubEmitters defines if the end type sub-emitters must be disposed as well (false by default)
     */ dispose(disposeTexture = true, disposeAttachedSubEmitters = false, disposeEndSubEmitters = false) {
        this.resetDrawCache();
        if (this._vertexBuffer) {
            this._vertexBuffer.dispose();
            this._vertexBuffer = null;
        }
        if (this._spriteBuffer) {
            this._spriteBuffer.dispose();
            this._spriteBuffer = null;
        }
        if (this._indexBuffer) {
            this._engine._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        if (this._linesIndexBuffer) {
            this._engine._releaseBuffer(this._linesIndexBuffer);
            this._linesIndexBuffer = null;
        }
        if (this._linesIndexBufferUseInstancing) {
            this._engine._releaseBuffer(this._linesIndexBufferUseInstancing);
            this._linesIndexBufferUseInstancing = null;
        }
        if (this._vertexArrayObject) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObject);
            this._vertexArrayObject = null;
        }
        if (disposeTexture && this.particleTexture) {
            this.particleTexture.dispose();
            this.particleTexture = null;
        }
        if (disposeTexture && this.noiseTexture) {
            this.noiseTexture.dispose();
            this.noiseTexture = null;
        }
        if (this._rampGradientsTexture) {
            this._rampGradientsTexture.dispose();
            this._rampGradientsTexture = null;
        }
        this._onDispose(disposeAttachedSubEmitters, disposeEndSubEmitters);
        if (this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable.clear();
        // Remove from scene
        if (this._scene) {
            const index = this._scene.particleSystems.indexOf(this);
            if (index > -1) this._scene.particleSystems.splice(index, 1);
            this._scene._activeParticleSystems.dispose();
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onStoppedObservable.clear();
        this.reset();
    }
}
/**
 * Force all the particle systems to compile to glsl even on WebGPU engines.
 * False by default. This is mostly meant for backward compatibility.
 */ $95351d116892571a$export$b52eeadd2730cb3f.ForceGLSL = false;



var $ha1VO = parcelRequire("ha1VO");

var $dUFYy = parcelRequire("dUFYy");

var $8DoUR = parcelRequire("8DoUR");
var $808d74f63d298c61$export$5f399ef693937290;
(function(SubEmitterType) {
    /**
     * Attached to the particle over it's lifetime
     */ SubEmitterType[SubEmitterType["ATTACHED"] = 0] = "ATTACHED";
    /**
     * Created when the particle dies
     */ SubEmitterType[SubEmitterType["END"] = 1] = "END";
})($808d74f63d298c61$export$5f399ef693937290 || ($808d74f63d298c61$export$5f399ef693937290 = {}));
class $808d74f63d298c61$export$76f56fc382618136 {
    /**
     * Creates a sub emitter
     * @param particleSystem the particle system to be used by the sub emitter
     */ constructor(/**
     * the particle system to be used by the sub emitter
     */ particleSystem){
        this.particleSystem = particleSystem;
        /**
         * Type of the submitter (Default: END)
         */ this.type = 1 /* SubEmitterType.END */ ;
        /**
         * If the particle should inherit the direction from the particle it's attached to. (+Y will face the direction the particle is moving) (Default: false)
         * Note: This only is supported when using an emitter of type Mesh
         */ this.inheritDirection = false;
        /**
         * How much of the attached particles speed should be added to the sub emitted particle (default: 0)
         */ this.inheritedVelocityAmount = 0;
        // Create mesh as emitter to support rotation
        if (!particleSystem.emitter || !particleSystem.emitter.dispose) {
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.AbstractMesh");
            particleSystem.emitter = new internalClass("SubemitterSystemEmitter", particleSystem.getScene());
            particleSystem._disposeEmitterOnDispose = true;
        }
    }
    /**
     * Clones the sub emitter
     * @returns the cloned sub emitter
     */ clone() {
        // Clone particle system
        let emitter = this.particleSystem.emitter;
        if (!emitter) emitter = new (0, $ha1VO.Vector3)();
        else if (emitter instanceof (0, $ha1VO.Vector3)) emitter = emitter.clone();
        else if (emitter.getClassName().indexOf("Mesh") !== -1) {
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.Mesh");
            emitter = new internalClass("", emitter.getScene());
            emitter.isVisible = false;
        }
        const clone = new $808d74f63d298c61$export$76f56fc382618136(this.particleSystem.clone(this.particleSystem.name, emitter));
        // Clone properties
        clone.particleSystem.name += "Clone";
        clone.type = this.type;
        clone.inheritDirection = this.inheritDirection;
        clone.inheritedVelocityAmount = this.inheritedVelocityAmount;
        clone.particleSystem._disposeEmitterOnDispose = true;
        clone.particleSystem.disposeOnStop = true;
        return clone;
    }
    /**
     * Serialize current object to a JSON object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns the serialized object
     */ serialize(serializeTexture = false) {
        const serializationObject = {};
        serializationObject.type = this.type;
        serializationObject.inheritDirection = this.inheritDirection;
        serializationObject.inheritedVelocityAmount = this.inheritedVelocityAmount;
        serializationObject.particleSystem = this.particleSystem.serialize(serializeTexture);
        return serializationObject;
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _ParseParticleSystem(system, sceneOrEngine, rootUrl, doNotStart = false) {
        throw (0, $dUFYy._WarnImport)("ParseParticle");
    }
    /**
     * Creates a new SubEmitter from a serialized JSON version
     * @param serializationObject defines the JSON object to read from
     * @param sceneOrEngine defines the hosting scene or the hosting engine
     * @param rootUrl defines the rootUrl for data loading
     * @returns a new SubEmitter
     */ static Parse(serializationObject, sceneOrEngine, rootUrl) {
        const system = serializationObject.particleSystem;
        const subEmitter = new $808d74f63d298c61$export$76f56fc382618136($808d74f63d298c61$export$76f56fc382618136._ParseParticleSystem(system, sceneOrEngine, rootUrl, true));
        subEmitter.type = serializationObject.type;
        subEmitter.inheritDirection = serializationObject.inheritDirection;
        subEmitter.inheritedVelocityAmount = serializationObject.inheritedVelocityAmount;
        subEmitter.particleSystem._isSubEmitter = true;
        return subEmitter;
    }
    /** Release associated resources */ dispose() {
        this.particleSystem.dispose();
    }
}



var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $dUFoQ = parcelRequire("dUFoQ");

var $8DoUR = parcelRequire("8DoUR");

var $6Ho1L = parcelRequire("6Ho1L");

var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");

var $b4i1f = parcelRequire("b4i1f");
class $d3091fa0938569db$export$7c52b14cab7afa0e {
    /** Defines the mesh to use as source */ get mesh() {
        return this._mesh;
    }
    set mesh(value) {
        if (this._mesh === value) return;
        this._mesh = value;
        if (value) {
            this._indices = value.getIndices();
            this._positions = value.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            this._normals = value.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        } else {
            this._indices = null;
            this._positions = null;
            this._normals = null;
        }
    }
    /**
     * Creates a new instance MeshParticleEmitter
     * @param mesh defines the mesh to use as source
     */ constructor(mesh = null){
        this._indices = null;
        this._positions = null;
        this._normals = null;
        this._storedNormal = (0, $ha1VO.Vector3).Zero();
        this._mesh = null;
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Gets or sets a boolean indicating that particle directions must be built from mesh face normals
         */ this.useMeshNormalsForDirection = true;
        this.mesh = mesh;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        if (this.useMeshNormalsForDirection && this._normals) {
            (0, $ha1VO.Vector3).TransformNormalToRef(this._storedNormal, worldMatrix, directionToUpdate);
            return;
        }
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        if (!this._indices || !this._positions) return;
        const randomFaceIndex = 3 * Math.random() * (this._indices.length / 3) | 0;
        const bu = Math.random();
        const bv = Math.random() * (1.0 - bu);
        const bw = 1.0 - bu - bv;
        const faceIndexA = this._indices[randomFaceIndex];
        const faceIndexB = this._indices[randomFaceIndex + 1];
        const faceIndexC = this._indices[randomFaceIndex + 2];
        const vertexA = (0, $ha1VO.TmpVectors).Vector3[0];
        const vertexB = (0, $ha1VO.TmpVectors).Vector3[1];
        const vertexC = (0, $ha1VO.TmpVectors).Vector3[2];
        const randomVertex = (0, $ha1VO.TmpVectors).Vector3[3];
        (0, $ha1VO.Vector3).FromArrayToRef(this._positions, faceIndexA * 3, vertexA);
        (0, $ha1VO.Vector3).FromArrayToRef(this._positions, faceIndexB * 3, vertexB);
        (0, $ha1VO.Vector3).FromArrayToRef(this._positions, faceIndexC * 3, vertexC);
        randomVertex.x = bu * vertexA.x + bv * vertexB.x + bw * vertexC.x;
        randomVertex.y = bu * vertexA.y + bv * vertexB.y + bw * vertexC.y;
        randomVertex.z = bu * vertexA.z + bv * vertexB.z + bw * vertexC.z;
        if (isLocal) positionToUpdate.copyFromFloats(randomVertex.x, randomVertex.y, randomVertex.z);
        else (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randomVertex.x, randomVertex.y, randomVertex.z, worldMatrix, positionToUpdate);
        if (this.useMeshNormalsForDirection && this._normals) {
            (0, $ha1VO.Vector3).FromArrayToRef(this._normals, faceIndexA * 3, vertexA);
            (0, $ha1VO.Vector3).FromArrayToRef(this._normals, faceIndexB * 3, vertexB);
            (0, $ha1VO.Vector3).FromArrayToRef(this._normals, faceIndexC * 3, vertexC);
            this._storedNormal.x = bu * vertexA.x + bv * vertexB.x + bw * vertexC.x;
            this._storedNormal.y = bu * vertexA.y + bv * vertexB.y + bw * vertexC.y;
            this._storedNormal.z = bu * vertexA.z + bv * vertexB.z + bw * vertexC.z;
        }
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $d3091fa0938569db$export$7c52b14cab7afa0e(this.mesh);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "";
    }
    /**
     * Returns the string "BoxParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "MeshParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        serializationObject.meshId = this.mesh?.id;
        serializationObject.useMeshNormalsForDirection = this.useMeshNormalsForDirection;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     * @param scene defines the hosting scene
     */ parse(serializationObject, scene) {
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
        if (serializationObject.meshId && scene) this.mesh = scene.getLastMeshById(serializationObject.meshId);
        this.useMeshNormalsForDirection = serializationObject.useMeshNormalsForDirection;
    }
}



var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");
class $84830edb6842e99c$export$d5b809e1fb739630 {
    /**
     * Creates a new instance CustomParticleEmitter
     */ constructor(){
        /**
         * Gets or sets the position generator that will create the initial position of each particle.
         * Index will be provided when used with GPU particle. Particle will be provided when used with CPU particles
         */ this.particlePositionGenerator = ()=>{};
        /**
         * Gets or sets the destination generator that will create the final destination of each particle.
         *  * Index will be provided when used with GPU particle. Particle will be provided when used with CPU particles
         */ this.particleDestinationGenerator = ()=>{};
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        if (this.particleDestinationGenerator) {
            this.particleDestinationGenerator(-1, particle, tmpVector);
            // Get direction
            const diffVector = (0, $ha1VO.TmpVectors).Vector3[1];
            tmpVector.subtractToRef(particle.position, diffVector);
            diffVector.scaleToRef(1 / particle.lifeTime, tmpVector);
        } else tmpVector.set(0, 0, 0);
        if (isLocal) {
            directionToUpdate.copyFrom(tmpVector);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalToRef(tmpVector, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        if (this.particlePositionGenerator) this.particlePositionGenerator(-1, particle, tmpVector);
        else tmpVector.set(0, 0, 0);
        if (isLocal) {
            positionToUpdate.copyFrom(tmpVector);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(tmpVector, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $84830edb6842e99c$export$d5b809e1fb739630();
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    applyToShader(uboOrEffect) {}
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    buildUniformLayout(ubo) {}
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CUSTOMEMITTER";
    }
    /**
     * Returns the string "PointParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "CustomParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.particlePositionGenerator = this.particlePositionGenerator;
        serializationObject.particleDestinationGenerator = this.particleDestinationGenerator;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        if (serializationObject.particlePositionGenerator) this.particlePositionGenerator = serializationObject.particlePositionGenerator;
        if (serializationObject.particleDestinationGenerator) this.particleDestinationGenerator = serializationObject.particleDestinationGenerator;
    }
}




var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");
class $5c71a4fd35120c39$export$a586d70131bc2eeb {
    /**
     * Creates a new instance PointParticleEmitter
     */ constructor(){
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        if (isLocal) {
            positionToUpdate.copyFromFloats(0, 0, 0);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(0, 0, 0, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $5c71a4fd35120c39$export$a586d70131bc2eeb();
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define POINTEMITTER";
    }
    /**
     * Returns the string "PointParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "PointParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
    }
}



var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");
class $213768d534ffed43$export$e972a65960ef3562 {
    /**
     * Creates a new instance HemisphericParticleEmitter
     * @param radius the radius of the emission hemisphere (1 by default)
     * @param radiusRange the range of the emission hemisphere [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1]
     */ constructor(/**
     * [1] The radius of the emission hemisphere.
     */ radius = 1, /**
     * [1] The range of emission [0-1] 0 Surface only, 1 Entire Radius.
     */ radiusRange = 1, /**
     * [0] How much to randomize the particle direction [0-1].
     */ directionRandomizer = 0){
        this.radius = radius;
        this.radiusRange = radiusRange;
        this.directionRandomizer = directionRandomizer;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const direction = particle.position.subtract(worldMatrix.getTranslation()).normalize();
        const randX = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        const randY = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        const randZ = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        direction.x += randX;
        direction.y += randY;
        direction.z += randZ;
        direction.normalize();
        if (isLocal) {
            directionToUpdate.copyFrom(direction);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(direction.x, direction.y, direction.z, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const randRadius = this.radius - (0, $iosaP.RandomRange)(0, this.radius * this.radiusRange);
        const v = (0, $iosaP.RandomRange)(0, 1.0);
        const phi = (0, $iosaP.RandomRange)(0, 2 * Math.PI);
        const theta = Math.acos(2 * v - 1);
        const randX = randRadius * Math.cos(phi) * Math.sin(theta);
        const randY = randRadius * Math.cos(theta);
        const randZ = randRadius * Math.sin(phi) * Math.sin(theta);
        if (isLocal) {
            positionToUpdate.copyFromFloats(randX, Math.abs(randY), randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, Math.abs(randY), randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $213768d534ffed43$export$e972a65960ef3562(this.radius, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define HEMISPHERICEMITTER";
    }
    /**
     * Returns the string "HemisphericParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "HemisphericParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this.radius;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.directionRandomizer = this.directionRandomizer;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.radiusRange = serializationObject.radiusRange;
        this.directionRandomizer = serializationObject.directionRandomizer;
    }
}



var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");

var $fhgis = parcelRequire("fhgis");
class $f9a35a0cd7eb9213$export$2541b18bda6a65ba {
    /**
     * Creates a new instance SphereParticleEmitter
     * @param radius the radius of the emission sphere (1 by default)
     * @param radiusRange the range of the emission sphere [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1]
     */ constructor(/**
     * [1] The radius of the emission sphere.
     */ radius = 1, /**
     * [1] The range of emission [0-1] 0 Surface only, 1 Entire Radius.
     */ radiusRange = 1, /**
     * [0] How much to randomize the particle direction [0-1].
     */ directionRandomizer = 0){
        this.radius = radius;
        this.radiusRange = radiusRange;
        this.directionRandomizer = directionRandomizer;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const direction = particle.position.subtract(worldMatrix.getTranslation()).normalize();
        const randX = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        const randY = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        const randZ = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        direction.x += randX;
        direction.y += randY;
        direction.z += randZ;
        direction.normalize();
        if (isLocal) {
            directionToUpdate.copyFrom(direction);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(direction.x, direction.y, direction.z, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const randRadius = this.radius - (0, $iosaP.RandomRange)(0, this.radius * this.radiusRange);
        const v = (0, $iosaP.RandomRange)(0, 1.0);
        const phi = (0, $iosaP.RandomRange)(0, 2 * Math.PI);
        const theta = Math.acos(2 * v - 1);
        const randX = randRadius * Math.cos(phi) * Math.sin(theta);
        const randY = randRadius * Math.cos(theta);
        const randZ = randRadius * Math.sin(phi) * Math.sin(theta);
        if (isLocal) {
            positionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $f9a35a0cd7eb9213$export$2541b18bda6a65ba(this.radius, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define SPHEREEMITTER";
    }
    /**
     * Returns the string "SphereParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "SphereParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this.radius;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.directionRandomizer = this.directionRandomizer;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.radiusRange = serializationObject.radiusRange;
        this.directionRandomizer = serializationObject.directionRandomizer;
    }
}
class $f9a35a0cd7eb9213$export$3874e23d91438769 extends $f9a35a0cd7eb9213$export$2541b18bda6a65ba {
    /**
     * Creates a new instance SphereDirectedParticleEmitter
     * @param radius the radius of the emission sphere (1 by default)
     * @param direction1 the min limit of the emission direction (up vector by default)
     * @param direction2 the max limit of the emission direction (up vector by default)
     */ constructor(radius = 1, /**
     * [Up vector] The min limit of the emission direction.
     */ direction1 = new (0, $ha1VO.Vector3)(0, 1, 0), /**
     * [Up vector] The max limit of the emission direction.
     */ direction2 = new (0, $ha1VO.Vector3)(0, 1, 0)){
        super(radius);
        this.direction1 = direction1;
        this.direction2 = direction2;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     */ startDirectionFunction(worldMatrix, directionToUpdate) {
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $f9a35a0cd7eb9213$export$3874e23d91438769(this.radius, this.direction1, this.direction2);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define SPHEREEMITTER\n#define DIRECTEDSPHEREEMITTER";
    }
    /**
     * Returns the string "SphereDirectedParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "SphereDirectedParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        super.parse(serializationObject);
        this.direction1.copyFrom(serializationObject.direction1);
        this.direction2.copyFrom(serializationObject.direction2);
    }
}



var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");

var $fhgis = parcelRequire("fhgis");
class $ab4f5a3b0294b2f7$export$1749eea034ebf799 {
    /**
     * Creates a new instance CylinderParticleEmitter
     * @param radius the radius of the emission cylinder (1 by default)
     * @param height the height of the emission cylinder (1 by default)
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1]
     */ constructor(/**
     * [1] The radius of the emission cylinder.
     */ radius = 1, /**
     * [1] The height of the emission cylinder.
     */ height = 1, /**
     * [1] The range of emission [0-1] 0 Surface only, 1 Entire Radius.
     */ radiusRange = 1, /**
     * [0] How much to randomize the particle direction [0-1].
     */ directionRandomizer = 0){
        this.radius = radius;
        this.height = height;
        this.radiusRange = radiusRange;
        this.directionRandomizer = directionRandomizer;
        this._tempVector = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     * @param inverseWorldMatrix defines the inverted world matrix to use if isLocal is false
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal, inverseWorldMatrix) {
        particle.position.subtractToRef(worldMatrix.getTranslation(), this._tempVector);
        this._tempVector.normalize();
        (0, $ha1VO.Vector3).TransformNormalToRef(this._tempVector, inverseWorldMatrix, this._tempVector);
        const randY = (0, $iosaP.RandomRange)(-this.directionRandomizer / 2, this.directionRandomizer / 2);
        let angle = Math.atan2(this._tempVector.x, this._tempVector.z);
        angle += (0, $iosaP.RandomRange)(-Math.PI / 2, Math.PI / 2) * this.directionRandomizer;
        this._tempVector.y = randY; // set direction y to rand y to mirror normal of cylinder surface
        this._tempVector.x = Math.sin(angle);
        this._tempVector.z = Math.cos(angle);
        this._tempVector.normalize();
        if (isLocal) {
            directionToUpdate.copyFrom(this._tempVector);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(this._tempVector.x, this._tempVector.y, this._tempVector.z, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const yPos = (0, $iosaP.RandomRange)(-this.height / 2, this.height / 2);
        const angle = (0, $iosaP.RandomRange)(0, 2 * Math.PI);
        // Pick a properly distributed point within the circle https://programming.guide/random-point-within-circle.html
        const radiusDistribution = (0, $iosaP.RandomRange)((1 - this.radiusRange) * (1 - this.radiusRange), 1);
        const positionRadius = Math.sqrt(radiusDistribution) * this.radius;
        const xPos = positionRadius * Math.cos(angle);
        const zPos = positionRadius * Math.sin(angle);
        if (isLocal) {
            positionToUpdate.copyFromFloats(xPos, yPos, zPos);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(xPos, yPos, zPos, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $ab4f5a3b0294b2f7$export$1749eea034ebf799(this.radius, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("height", this.height);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("height", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CYLINDEREMITTER";
    }
    /**
     * Returns the string "CylinderParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "CylinderParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this.radius;
        serializationObject.height = this.height;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.directionRandomizer = this.directionRandomizer;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.height = serializationObject.height;
        this.radiusRange = serializationObject.radiusRange;
        this.directionRandomizer = serializationObject.directionRandomizer;
    }
}
class $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7 extends $ab4f5a3b0294b2f7$export$1749eea034ebf799 {
    /**
     * Creates a new instance CylinderDirectedParticleEmitter
     * @param radius the radius of the emission cylinder (1 by default)
     * @param height the height of the emission cylinder (1 by default)
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 the min limit of the emission direction (up vector by default)
     * @param direction2 the max limit of the emission direction (up vector by default)
     */ constructor(radius = 1, height = 1, radiusRange = 1, /**
     * [Up vector] The min limit of the emission direction.
     */ direction1 = new (0, $ha1VO.Vector3)(0, 1, 0), /**
     * [Up vector] The max limit of the emission direction.
     */ direction2 = new (0, $ha1VO.Vector3)(0, 1, 0)){
        super(radius, height, radiusRange);
        this.direction1 = direction1;
        this.direction2 = direction2;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param _particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, _particle, isLocal) {
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7(this.radius, this.height, this.radiusRange, this.direction1, this.direction2);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("height", this.height);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("height", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CYLINDEREMITTER\n#define DIRECTEDCYLINDEREMITTER";
    }
    /**
     * Returns the string "CylinderDirectedParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "CylinderDirectedParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        super.parse(serializationObject);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
    }
}



var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");
class $b8bc099bf9944fef$export$2301fb99254f61e8 {
    /**
     * Gets or sets the radius of the emission cone
     */ get radius() {
        return this._radius;
    }
    set radius(value) {
        this._radius = value;
        this._buildHeight();
    }
    /**
     * Gets or sets the angle of the emission cone
     */ get angle() {
        return this._angle;
    }
    set angle(value) {
        this._angle = value;
        this._buildHeight();
    }
    _buildHeight() {
        if (this._angle !== 0) this._height = this._radius / Math.tan(this._angle / 2);
        else this._height = 1;
    }
    /**
     * Creates a new instance ConeParticleEmitter
     * @param radius the radius of the emission cone (1 by default)
     * @param angle the cone base angle (PI by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1] (default is 0)
     */ constructor(radius = 1, angle = Math.PI, /** [0] defines how much to randomize the particle direction [0-1] (default is 0) */ directionRandomizer = 0){
        this.directionRandomizer = directionRandomizer;
        /**
         * Gets or sets a value indicating where on the radius the start position should be picked (1 = everywhere, 0 = only surface)
         */ this.radiusRange = 1;
        /**
         * Gets or sets a value indicating where on the height the start position should be picked (1 = everywhere, 0 = only surface)
         */ this.heightRange = 1;
        /**
         * Gets or sets a value indicating if all the particles should be emitted from the spawn point only (the base of the cone)
         */ this.emitFromSpawnPointOnly = false;
        this.angle = angle;
        this.radius = radius;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        if (isLocal) (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(particle._localPosition).normalize();
        else particle.position.subtractToRef(worldMatrix.getTranslation(), (0, $ha1VO.TmpVectors).Vector3[0]).normalize();
        const randX = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        const randY = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        const randZ = (0, $iosaP.RandomRange)(0, this.directionRandomizer);
        directionToUpdate.x = (0, $ha1VO.TmpVectors).Vector3[0].x + randX;
        directionToUpdate.y = (0, $ha1VO.TmpVectors).Vector3[0].y + randY;
        directionToUpdate.z = (0, $ha1VO.TmpVectors).Vector3[0].z + randZ;
        directionToUpdate.normalize();
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const s = (0, $iosaP.RandomRange)(0, Math.PI * 2);
        let h;
        if (!this.emitFromSpawnPointOnly) {
            h = (0, $iosaP.RandomRange)(0, this.heightRange);
            // Better distribution in a cone at normal angles.
            h = 1 - h * h;
        } else h = 0.0001;
        let radius = this._radius - (0, $iosaP.RandomRange)(0, this._radius * this.radiusRange);
        radius = radius * h;
        const randX = radius * Math.sin(s);
        const randZ = radius * Math.cos(s);
        const randY = h * this._height;
        if (isLocal) {
            positionToUpdate.x = randX;
            positionToUpdate.y = randY;
            positionToUpdate.z = randZ;
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $b8bc099bf9944fef$export$2301fb99254f61e8(this._radius, this._angle, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat2("radius", this._radius, this.radiusRange);
        uboOrEffect.setFloat("coneAngle", this._angle);
        uboOrEffect.setFloat2("height", this._height, this.heightRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 2);
        ubo.addUniform("coneAngle", 1);
        ubo.addUniform("height", 2);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        let defines = "#define CONEEMITTER";
        if (this.emitFromSpawnPointOnly) defines += "\n#define CONEEMITTERSPAWNPOINT";
        return defines;
    }
    /**
     * Returns the string "ConeParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "ConeParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this._radius;
        serializationObject.angle = this._angle;
        serializationObject.directionRandomizer = this.directionRandomizer;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.heightRange = this.heightRange;
        serializationObject.emitFromSpawnPointOnly = this.emitFromSpawnPointOnly;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.angle = serializationObject.angle;
        this.directionRandomizer = serializationObject.directionRandomizer;
        this.radiusRange = serializationObject.radiusRange !== undefined ? serializationObject.radiusRange : 1;
        this.heightRange = serializationObject.radiusRange !== undefined ? serializationObject.heightRange : 1;
        this.emitFromSpawnPointOnly = serializationObject.emitFromSpawnPointOnly !== undefined ? serializationObject.emitFromSpawnPointOnly : false;
    }
}
class $b8bc099bf9944fef$export$edee9da8a522a9cb extends $b8bc099bf9944fef$export$2301fb99254f61e8 {
    constructor(radius = 1, angle = Math.PI, /**
     * [Up vector] The min limit of the emission direction.
     */ direction1 = new (0, $ha1VO.Vector3)(0, 1, 0), /**
     * [Up vector] The max limit of the emission direction.
     */ direction2 = new (0, $ha1VO.Vector3)(0, 1, 0)){
        super(radius, angle);
        this.direction1 = direction1;
        this.direction2 = direction2;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     */ startDirectionFunction(worldMatrix, directionToUpdate) {
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $b8bc099bf9944fef$export$edee9da8a522a9cb(this.radius, this.angle, this.direction1, this.direction2);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CONEEMITTER\n#define DIRECTEDCONEEMITTER";
    }
    /**
     * Returns the string "ConeDirectedParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "ConeDirectedParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        super.parse(serializationObject);
        this.direction1.copyFrom(serializationObject.direction1);
        this.direction2.copyFrom(serializationObject.direction2);
    }
}



var $ha1VO = parcelRequire("ha1VO");





function $aef0333f21b59b40$export$acd6bf7ecae6bc7e(direction1, direction2) {
    const particleEmitter = new (0, $5c71a4fd35120c39$export$a586d70131bc2eeb)();
    particleEmitter.direction1 = direction1;
    particleEmitter.direction2 = direction2;
    return particleEmitter;
}
function $aef0333f21b59b40$export$e69bc76cba09ff3d(radius = 1, radiusRange = 1) {
    return new (0, $213768d534ffed43$export$e972a65960ef3562)(radius, radiusRange);
}
function $aef0333f21b59b40$export$61e795761517135a(radius = 1, radiusRange = 1) {
    return new (0, $f9a35a0cd7eb9213$export$2541b18bda6a65ba)(radius, radiusRange);
}
function $aef0333f21b59b40$export$b0232d023c232833(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
    return new (0, $f9a35a0cd7eb9213$export$3874e23d91438769)(radius, direction1, direction2);
}
function $aef0333f21b59b40$export$5ef0f502a087f2fc(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
    return new (0, $ab4f5a3b0294b2f7$export$1749eea034ebf799)(radius, height, radiusRange, directionRandomizer);
}
function $aef0333f21b59b40$export$fa538e6bc49a5893(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
    return new (0, $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7)(radius, height, radiusRange, direction1, direction2);
}
function $aef0333f21b59b40$export$4b9f1899a72f369e(radius = 1, angle = Math.PI / 4) {
    return new (0, $b8bc099bf9944fef$export$2301fb99254f61e8)(radius, angle);
}
function $aef0333f21b59b40$export$498d6d91b566f0df(radius = 1, angle = Math.PI / 4, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
    return new (0, $b8bc099bf9944fef$export$edee9da8a522a9cb)(radius, angle, direction1, direction2);
}


class $c96920833f35da71$export$f219b6a0e4bb0b6d extends (0, $95351d116892571a$export$b52eeadd2730cb3f) {
    constructor(){
        super(...arguments);
        /**
         * @internal
         * If the particle systems emitter should be disposed when the particle system is disposed
         */ this._disposeEmitterOnDispose = false;
        this._emitFromParticle = (particle)=>{
            if (!this._subEmitters || this._subEmitters.length === 0) return;
            const templateIndex = Math.floor(Math.random() * this._subEmitters.length);
            this._subEmitters[templateIndex].forEach((subEmitter)=>{
                if (subEmitter.type === 1 /* SubEmitterType.END */ ) {
                    const subSystem = subEmitter.clone();
                    particle._inheritParticleInfoToSubEmitter(subSystem);
                    subSystem.particleSystem._rootParticleSystem = this;
                    this.activeSubSystems.push(subSystem.particleSystem);
                    subSystem.particleSystem.start();
                }
            });
        };
    }
    /**
     * Creates a Point Emitter for the particle system (emits directly from the emitter position)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @returns the emitter
     */ createPointEmitter(direction1, direction2) {
        const particleEmitter = (0, $aef0333f21b59b40$export$acd6bf7ecae6bc7e)(direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Hemisphere Emitter for the particle system (emits along the hemisphere radius)
     * @param radius The radius of the hemisphere to emit from
     * @param radiusRange The range of the hemisphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     * @returns the emitter
     */ createHemisphericEmitter(radius = 1, radiusRange = 1) {
        const particleEmitter = (0, $aef0333f21b59b40$export$e69bc76cba09ff3d)(radius, radiusRange);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Sphere Emitter for the particle system (emits along the sphere radius)
     * @param radius The radius of the sphere to emit from
     * @param radiusRange The range of the sphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     * @returns the emitter
     */ createSphereEmitter(radius = 1, radiusRange = 1) {
        const particleEmitter = (0, $aef0333f21b59b40$export$61e795761517135a)(radius, radiusRange);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Directed Sphere Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the sphere to emit from
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the sphere
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the sphere
     * @returns the emitter
     */ createDirectedSphereEmitter(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $aef0333f21b59b40$export$b0232d023c232833)(radius, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Cylinder Emitter for the particle system (emits from the cylinder to the particle position)
     * @param radius The radius of the emission cylinder
     * @param height The height of the emission cylinder
     * @param radiusRange The range of emission [0-1] 0 Surface only, 1 Entire Radius
     * @param directionRandomizer How much to randomize the particle direction [0-1]
     * @returns the emitter
     */ createCylinderEmitter(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
        const particleEmitter = (0, $aef0333f21b59b40$export$5ef0f502a087f2fc)(radius, height, radiusRange, directionRandomizer);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Directed Cylinder Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the cylinder to emit from
     * @param height The height of the emission cylinder
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @returns the emitter
     */ createDirectedCylinderEmitter(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $aef0333f21b59b40$export$fa538e6bc49a5893)(radius, height, radiusRange, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Cone Emitter for the particle system (emits from the cone to the particle position)
     * @param radius The radius of the cone to emit from
     * @param angle The base angle of the cone
     * @returns the emitter
     */ createConeEmitter(radius = 1, angle = Math.PI / 4) {
        const particleEmitter = (0, $aef0333f21b59b40$export$4b9f1899a72f369e)(radius, angle);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    createDirectedConeEmitter(radius = 1, angle = Math.PI / 4, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $aef0333f21b59b40$export$498d6d91b566f0df)(radius, angle, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Box Emitter for the particle system. (emits between direction1 and direction2 from withing the box defined by minEmitBox and maxEmitBox)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @param minEmitBox Particles are emitted from the box between minEmitBox and maxEmitBox
     * @param maxEmitBox  Particles are emitted from the box between minEmitBox and maxEmitBox
     * @returns the emitter
     */ createBoxEmitter(direction1, direction2, minEmitBox, maxEmitBox) {
        const particleEmitter = new (0, $509d609d93dac4de$export$e7201bab8caf4869)();
        this.particleEmitterType = particleEmitter;
        this.direction1 = direction1;
        this.direction2 = direction2;
        this.minEmitBox = minEmitBox;
        this.maxEmitBox = maxEmitBox;
        return particleEmitter;
    }
    _prepareSubEmitterInternalArray() {
        this._subEmitters = new Array();
        if (this.subEmitters) this.subEmitters.forEach((subEmitter)=>{
            if (subEmitter instanceof $c96920833f35da71$export$f219b6a0e4bb0b6d) this._subEmitters.push([
                new (0, $808d74f63d298c61$export$76f56fc382618136)(subEmitter)
            ]);
            else if (subEmitter instanceof (0, $808d74f63d298c61$export$76f56fc382618136)) this._subEmitters.push([
                subEmitter
            ]);
            else if (subEmitter instanceof Array) this._subEmitters.push(subEmitter);
        });
    }
    _stopSubEmitters() {
        if (!this.activeSubSystems) return;
        this.activeSubSystems.forEach((subSystem)=>{
            subSystem.stop(true);
        });
        this.activeSubSystems = [];
    }
    _removeFromRoot() {
        if (!this._rootParticleSystem) return;
        const index = this._rootParticleSystem.activeSubSystems.indexOf(this);
        if (index !== -1) this._rootParticleSystem.activeSubSystems.splice(index, 1);
        this._rootParticleSystem = null;
    }
    _preStart() {
        // Convert the subEmitters field to the constant type field _subEmitters
        this._prepareSubEmitterInternalArray();
        if (this._subEmitters && this._subEmitters.length != 0) this.activeSubSystems = [];
    }
    _postStop(stopSubEmitters) {
        if (stopSubEmitters) this._stopSubEmitters();
    }
    _prepareParticle(particle) {
        // Attach emitters
        if (this._subEmitters && this._subEmitters.length > 0) {
            const subEmitters = this._subEmitters[Math.floor(Math.random() * this._subEmitters.length)];
            particle._attachedSubEmitters = [];
            subEmitters.forEach((subEmitter)=>{
                if (subEmitter.type === 0 /* SubEmitterType.ATTACHED */ ) {
                    const newEmitter = subEmitter.clone();
                    particle._attachedSubEmitters.push(newEmitter);
                    newEmitter.particleSystem.start();
                }
            });
        }
    }
    /** @internal */ _onDispose(disposeAttachedSubEmitters = false, disposeEndSubEmitters = false) {
        this._removeFromRoot();
        if (this.subEmitters && !this._subEmitters) this._prepareSubEmitterInternalArray();
        if (disposeAttachedSubEmitters) this.particles?.forEach((particle)=>{
            if (particle._attachedSubEmitters) for(let i = particle._attachedSubEmitters.length - 1; i >= 0; i -= 1)particle._attachedSubEmitters[i].dispose();
        });
        if (disposeEndSubEmitters) {
            if (this.activeSubSystems) for(let i = this.activeSubSystems.length - 1; i >= 0; i -= 1)this.activeSubSystems[i].dispose();
        }
        if (this._subEmitters && this._subEmitters.length) {
            for(let index = 0; index < this._subEmitters.length; index++)for (const subEmitter of this._subEmitters[index])subEmitter.dispose();
            this._subEmitters = [];
            this.subEmitters = [];
        }
        if (this._disposeEmitterOnDispose && this.emitter && this.emitter.dispose) this.emitter.dispose(true);
    }
    /**
     * @internal
     */ static _Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl) {
        let scene;
        if (sceneOrEngine instanceof (0, $dUFoQ.AbstractEngine)) scene = null;
        else scene = sceneOrEngine;
        const internalClass = (0, $8DoUR.GetClass)("BABYLON.Texture");
        if (internalClass && scene) {
            // Texture
            if (parsedParticleSystem.texture) particleSystem.particleTexture = internalClass.Parse(parsedParticleSystem.texture, scene, rootUrl);
            else if (parsedParticleSystem.textureName) {
                particleSystem.particleTexture = new internalClass(rootUrl + parsedParticleSystem.textureName, scene, false, parsedParticleSystem.invertY !== undefined ? parsedParticleSystem.invertY : true);
                particleSystem.particleTexture.name = parsedParticleSystem.textureName;
            }
        }
        // Emitter
        if (!parsedParticleSystem.emitterId && parsedParticleSystem.emitterId !== 0 && parsedParticleSystem.emitter === undefined) particleSystem.emitter = (0, $ha1VO.Vector3).Zero();
        else if (parsedParticleSystem.emitterId && scene) particleSystem.emitter = scene.getLastMeshById(parsedParticleSystem.emitterId);
        else particleSystem.emitter = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.emitter);
        particleSystem.isLocal = !!parsedParticleSystem.isLocal;
        // Misc.
        if (parsedParticleSystem.renderingGroupId !== undefined) particleSystem.renderingGroupId = parsedParticleSystem.renderingGroupId;
        if (parsedParticleSystem.isBillboardBased !== undefined) particleSystem.isBillboardBased = parsedParticleSystem.isBillboardBased;
        if (parsedParticleSystem.billboardMode !== undefined) particleSystem.billboardMode = parsedParticleSystem.billboardMode;
        if (parsedParticleSystem.useLogarithmicDepth !== undefined) particleSystem.useLogarithmicDepth = parsedParticleSystem.useLogarithmicDepth;
        // Animations
        if (parsedParticleSystem.animations) {
            for(let animationIndex = 0; animationIndex < parsedParticleSystem.animations.length; animationIndex++){
                const parsedAnimation = parsedParticleSystem.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) particleSystem.animations.push(internalClass.Parse(parsedAnimation));
            }
            particleSystem.beginAnimationOnStart = parsedParticleSystem.beginAnimationOnStart;
            particleSystem.beginAnimationFrom = parsedParticleSystem.beginAnimationFrom;
            particleSystem.beginAnimationTo = parsedParticleSystem.beginAnimationTo;
            particleSystem.beginAnimationLoop = parsedParticleSystem.beginAnimationLoop;
        }
        if (parsedParticleSystem.autoAnimate && scene) scene.beginAnimation(particleSystem, parsedParticleSystem.autoAnimateFrom, parsedParticleSystem.autoAnimateTo, parsedParticleSystem.autoAnimateLoop, parsedParticleSystem.autoAnimateSpeed || 1.0);
        // Particle system
        particleSystem.startDelay = parsedParticleSystem.startDelay | 0;
        particleSystem.minAngularSpeed = parsedParticleSystem.minAngularSpeed;
        particleSystem.maxAngularSpeed = parsedParticleSystem.maxAngularSpeed;
        particleSystem.minSize = parsedParticleSystem.minSize;
        particleSystem.maxSize = parsedParticleSystem.maxSize;
        if (parsedParticleSystem.minScaleX) {
            particleSystem.minScaleX = parsedParticleSystem.minScaleX;
            particleSystem.maxScaleX = parsedParticleSystem.maxScaleX;
            particleSystem.minScaleY = parsedParticleSystem.minScaleY;
            particleSystem.maxScaleY = parsedParticleSystem.maxScaleY;
        }
        if (parsedParticleSystem.preWarmCycles !== undefined) {
            particleSystem.preWarmCycles = parsedParticleSystem.preWarmCycles;
            particleSystem.preWarmStepOffset = parsedParticleSystem.preWarmStepOffset;
        }
        if (parsedParticleSystem.minInitialRotation !== undefined) {
            particleSystem.minInitialRotation = parsedParticleSystem.minInitialRotation;
            particleSystem.maxInitialRotation = parsedParticleSystem.maxInitialRotation;
        }
        particleSystem.minLifeTime = parsedParticleSystem.minLifeTime;
        particleSystem.maxLifeTime = parsedParticleSystem.maxLifeTime;
        particleSystem.minEmitPower = parsedParticleSystem.minEmitPower;
        particleSystem.maxEmitPower = parsedParticleSystem.maxEmitPower;
        particleSystem.emitRate = parsedParticleSystem.emitRate;
        particleSystem.gravity = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.gravity);
        if (parsedParticleSystem.noiseStrength) particleSystem.noiseStrength = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.noiseStrength);
        particleSystem.color1 = (0, $7etnY.Color4).FromArray(parsedParticleSystem.color1);
        particleSystem.color2 = (0, $7etnY.Color4).FromArray(parsedParticleSystem.color2);
        particleSystem.colorDead = (0, $7etnY.Color4).FromArray(parsedParticleSystem.colorDead);
        particleSystem.updateSpeed = parsedParticleSystem.updateSpeed;
        particleSystem.targetStopDuration = parsedParticleSystem.targetStopDuration;
        particleSystem.blendMode = parsedParticleSystem.blendMode;
        if (parsedParticleSystem.colorGradients) for (const colorGradient of parsedParticleSystem.colorGradients)particleSystem.addColorGradient(colorGradient.gradient, (0, $7etnY.Color4).FromArray(colorGradient.color1), colorGradient.color2 ? (0, $7etnY.Color4).FromArray(colorGradient.color2) : undefined);
        if (parsedParticleSystem.rampGradients) {
            for (const rampGradient of parsedParticleSystem.rampGradients)particleSystem.addRampGradient(rampGradient.gradient, (0, $7etnY.Color3).FromArray(rampGradient.color));
            particleSystem.useRampGradients = parsedParticleSystem.useRampGradients;
        }
        if (parsedParticleSystem.colorRemapGradients) for (const colorRemapGradient of parsedParticleSystem.colorRemapGradients)particleSystem.addColorRemapGradient(colorRemapGradient.gradient, colorRemapGradient.factor1 !== undefined ? colorRemapGradient.factor1 : colorRemapGradient.factor, colorRemapGradient.factor2);
        if (parsedParticleSystem.alphaRemapGradients) for (const alphaRemapGradient of parsedParticleSystem.alphaRemapGradients)particleSystem.addAlphaRemapGradient(alphaRemapGradient.gradient, alphaRemapGradient.factor1 !== undefined ? alphaRemapGradient.factor1 : alphaRemapGradient.factor, alphaRemapGradient.factor2);
        if (parsedParticleSystem.sizeGradients) for (const sizeGradient of parsedParticleSystem.sizeGradients)particleSystem.addSizeGradient(sizeGradient.gradient, sizeGradient.factor1 !== undefined ? sizeGradient.factor1 : sizeGradient.factor, sizeGradient.factor2);
        if (parsedParticleSystem.angularSpeedGradients) for (const angularSpeedGradient of parsedParticleSystem.angularSpeedGradients)particleSystem.addAngularSpeedGradient(angularSpeedGradient.gradient, angularSpeedGradient.factor1 !== undefined ? angularSpeedGradient.factor1 : angularSpeedGradient.factor, angularSpeedGradient.factor2);
        if (parsedParticleSystem.velocityGradients) for (const velocityGradient of parsedParticleSystem.velocityGradients)particleSystem.addVelocityGradient(velocityGradient.gradient, velocityGradient.factor1 !== undefined ? velocityGradient.factor1 : velocityGradient.factor, velocityGradient.factor2);
        if (parsedParticleSystem.dragGradients) for (const dragGradient of parsedParticleSystem.dragGradients)particleSystem.addDragGradient(dragGradient.gradient, dragGradient.factor1 !== undefined ? dragGradient.factor1 : dragGradient.factor, dragGradient.factor2);
        if (parsedParticleSystem.emitRateGradients) for (const emitRateGradient of parsedParticleSystem.emitRateGradients)particleSystem.addEmitRateGradient(emitRateGradient.gradient, emitRateGradient.factor1 !== undefined ? emitRateGradient.factor1 : emitRateGradient.factor, emitRateGradient.factor2);
        if (parsedParticleSystem.startSizeGradients) for (const startSizeGradient of parsedParticleSystem.startSizeGradients)particleSystem.addStartSizeGradient(startSizeGradient.gradient, startSizeGradient.factor1 !== undefined ? startSizeGradient.factor1 : startSizeGradient.factor, startSizeGradient.factor2);
        if (parsedParticleSystem.lifeTimeGradients) for (const lifeTimeGradient of parsedParticleSystem.lifeTimeGradients)particleSystem.addLifeTimeGradient(lifeTimeGradient.gradient, lifeTimeGradient.factor1 !== undefined ? lifeTimeGradient.factor1 : lifeTimeGradient.factor, lifeTimeGradient.factor2);
        if (parsedParticleSystem.limitVelocityGradients) {
            for (const limitVelocityGradient of parsedParticleSystem.limitVelocityGradients)particleSystem.addLimitVelocityGradient(limitVelocityGradient.gradient, limitVelocityGradient.factor1 !== undefined ? limitVelocityGradient.factor1 : limitVelocityGradient.factor, limitVelocityGradient.factor2);
            particleSystem.limitVelocityDamping = parsedParticleSystem.limitVelocityDamping;
        }
        if (parsedParticleSystem.noiseTexture && scene) {
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.ProceduralTexture");
            particleSystem.noiseTexture = internalClass.Parse(parsedParticleSystem.noiseTexture, scene, rootUrl);
        }
        // Emitter
        let emitterType;
        if (parsedParticleSystem.particleEmitterType) {
            switch(parsedParticleSystem.particleEmitterType.type){
                case "SphereParticleEmitter":
                    emitterType = new (0, $f9a35a0cd7eb9213$export$2541b18bda6a65ba)();
                    break;
                case "SphereDirectedParticleEmitter":
                    emitterType = new (0, $f9a35a0cd7eb9213$export$3874e23d91438769)();
                    break;
                case "ConeEmitter":
                case "ConeParticleEmitter":
                    emitterType = new (0, $b8bc099bf9944fef$export$2301fb99254f61e8)();
                    break;
                case "ConeDirectedParticleEmitter":
                    emitterType = new (0, $b8bc099bf9944fef$export$edee9da8a522a9cb)();
                    break;
                case "CylinderParticleEmitter":
                    emitterType = new (0, $ab4f5a3b0294b2f7$export$1749eea034ebf799)();
                    break;
                case "CylinderDirectedParticleEmitter":
                    emitterType = new (0, $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7)();
                    break;
                case "HemisphericParticleEmitter":
                    emitterType = new (0, $213768d534ffed43$export$e972a65960ef3562)();
                    break;
                case "PointParticleEmitter":
                    emitterType = new (0, $5c71a4fd35120c39$export$a586d70131bc2eeb)();
                    break;
                case "MeshParticleEmitter":
                    emitterType = new (0, $d3091fa0938569db$export$7c52b14cab7afa0e)();
                    break;
                case "CustomParticleEmitter":
                    emitterType = new (0, $84830edb6842e99c$export$d5b809e1fb739630)();
                    break;
                case "BoxEmitter":
                case "BoxParticleEmitter":
                default:
                    emitterType = new (0, $509d609d93dac4de$export$e7201bab8caf4869)();
                    break;
            }
            emitterType.parse(parsedParticleSystem.particleEmitterType, scene);
        } else {
            emitterType = new (0, $509d609d93dac4de$export$e7201bab8caf4869)();
            emitterType.parse(parsedParticleSystem, scene);
        }
        particleSystem.particleEmitterType = emitterType;
        // Animation sheet
        particleSystem.startSpriteCellID = parsedParticleSystem.startSpriteCellID;
        particleSystem.endSpriteCellID = parsedParticleSystem.endSpriteCellID;
        particleSystem.spriteCellLoop = parsedParticleSystem.spriteCellLoop ?? true;
        particleSystem.spriteCellWidth = parsedParticleSystem.spriteCellWidth;
        particleSystem.spriteCellHeight = parsedParticleSystem.spriteCellHeight;
        particleSystem.spriteCellChangeSpeed = parsedParticleSystem.spriteCellChangeSpeed;
        particleSystem.spriteRandomStartCell = parsedParticleSystem.spriteRandomStartCell;
        particleSystem.disposeOnStop = parsedParticleSystem.disposeOnStop ?? false;
        particleSystem.manualEmitCount = parsedParticleSystem.manualEmitCount ?? -1;
    }
    /**
     * Parses a JSON object to create a particle system.
     * @param parsedParticleSystem The JSON object to parse
     * @param sceneOrEngine The scene or the engine to create the particle system in
     * @param rootUrl The root url to use to load external dependencies like texture
     * @param doNotStart Ignore the preventAutoStart attribute and does not start
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns the Parsed particle system
     */ static Parse(parsedParticleSystem, sceneOrEngine, rootUrl, doNotStart = false, capacity) {
        const name = parsedParticleSystem.name;
        let custom = null;
        let program = null;
        let engine;
        let scene;
        if (sceneOrEngine instanceof (0, $dUFoQ.AbstractEngine)) engine = sceneOrEngine;
        else {
            scene = sceneOrEngine;
            engine = scene.getEngine();
        }
        if (parsedParticleSystem.customShader && engine.createEffectForParticles) {
            program = parsedParticleSystem.customShader;
            const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
            custom = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines);
        }
        const particleSystem = new $c96920833f35da71$export$f219b6a0e4bb0b6d(name, capacity || parsedParticleSystem.capacity, sceneOrEngine, custom, parsedParticleSystem.isAnimationSheetEnabled);
        particleSystem.customShader = program;
        particleSystem._rootUrl = rootUrl;
        if (parsedParticleSystem.id) particleSystem.id = parsedParticleSystem.id;
        // SubEmitters
        if (parsedParticleSystem.subEmitters) {
            particleSystem.subEmitters = [];
            for (const cell of parsedParticleSystem.subEmitters){
                const cellArray = [];
                for (const sub of cell)cellArray.push((0, $808d74f63d298c61$export$76f56fc382618136).Parse(sub, sceneOrEngine, rootUrl));
                particleSystem.subEmitters.push(cellArray);
            }
        }
        $c96920833f35da71$export$f219b6a0e4bb0b6d._Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl);
        if (parsedParticleSystem.textureMask) particleSystem.textureMask = (0, $7etnY.Color4).FromArray(parsedParticleSystem.textureMask);
        if (parsedParticleSystem.worldOffset) particleSystem.worldOffset = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.worldOffset);
        // Auto start
        if (parsedParticleSystem.preventAutoStart) particleSystem.preventAutoStart = parsedParticleSystem.preventAutoStart;
        if (!doNotStart && !particleSystem.preventAutoStart) particleSystem.start();
        return particleSystem;
    }
    /**
     * Serializes the particle system to a JSON object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns the JSON object
     */ serialize(serializeTexture = false) {
        const serializationObject = {};
        $c96920833f35da71$export$f219b6a0e4bb0b6d._Serialize(serializationObject, this, serializeTexture);
        serializationObject.textureMask = this.textureMask.asArray();
        serializationObject.customShader = this.customShader;
        serializationObject.preventAutoStart = this.preventAutoStart;
        serializationObject.worldOffset = this.worldOffset.asArray();
        // SubEmitters
        if (this.subEmitters) {
            serializationObject.subEmitters = [];
            if (!this._subEmitters) this._prepareSubEmitterInternalArray();
            for (const subs of this._subEmitters){
                const cell = [];
                for (const sub of subs)cell.push(sub.serialize(serializeTexture));
                serializationObject.subEmitters.push(cell);
            }
        }
        return serializationObject;
    }
    /**
     * @internal
     */ static _Serialize(serializationObject, particleSystem, serializeTexture) {
        serializationObject.name = particleSystem.name;
        serializationObject.id = particleSystem.id;
        serializationObject.capacity = particleSystem.getCapacity();
        serializationObject.disposeOnStop = particleSystem.disposeOnStop;
        serializationObject.manualEmitCount = particleSystem.manualEmitCount;
        // Emitter
        if (particleSystem.emitter.position) {
            const emitterMesh = particleSystem.emitter;
            serializationObject.emitterId = emitterMesh.id;
        } else {
            const emitterPosition = particleSystem.emitter;
            serializationObject.emitter = emitterPosition.asArray();
        }
        // Emitter
        if (particleSystem.particleEmitterType) serializationObject.particleEmitterType = particleSystem.particleEmitterType.serialize();
        if (particleSystem.particleTexture) {
            if (serializeTexture) serializationObject.texture = particleSystem.particleTexture.serialize();
            else {
                serializationObject.textureName = particleSystem.particleTexture.name;
                serializationObject.invertY = !!particleSystem.particleTexture._invertY;
            }
        }
        serializationObject.isLocal = particleSystem.isLocal;
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(particleSystem, serializationObject);
        serializationObject.beginAnimationOnStart = particleSystem.beginAnimationOnStart;
        serializationObject.beginAnimationFrom = particleSystem.beginAnimationFrom;
        serializationObject.beginAnimationTo = particleSystem.beginAnimationTo;
        serializationObject.beginAnimationLoop = particleSystem.beginAnimationLoop;
        // Particle system
        serializationObject.startDelay = particleSystem.startDelay;
        serializationObject.renderingGroupId = particleSystem.renderingGroupId;
        serializationObject.isBillboardBased = particleSystem.isBillboardBased;
        serializationObject.billboardMode = particleSystem.billboardMode;
        serializationObject.minAngularSpeed = particleSystem.minAngularSpeed;
        serializationObject.maxAngularSpeed = particleSystem.maxAngularSpeed;
        serializationObject.minSize = particleSystem.minSize;
        serializationObject.maxSize = particleSystem.maxSize;
        serializationObject.minScaleX = particleSystem.minScaleX;
        serializationObject.maxScaleX = particleSystem.maxScaleX;
        serializationObject.minScaleY = particleSystem.minScaleY;
        serializationObject.maxScaleY = particleSystem.maxScaleY;
        serializationObject.minEmitPower = particleSystem.minEmitPower;
        serializationObject.maxEmitPower = particleSystem.maxEmitPower;
        serializationObject.minLifeTime = particleSystem.minLifeTime;
        serializationObject.maxLifeTime = particleSystem.maxLifeTime;
        serializationObject.emitRate = particleSystem.emitRate;
        serializationObject.gravity = particleSystem.gravity.asArray();
        serializationObject.noiseStrength = particleSystem.noiseStrength.asArray();
        serializationObject.color1 = particleSystem.color1.asArray();
        serializationObject.color2 = particleSystem.color2.asArray();
        serializationObject.colorDead = particleSystem.colorDead.asArray();
        serializationObject.updateSpeed = particleSystem.updateSpeed;
        serializationObject.targetStopDuration = particleSystem.targetStopDuration;
        serializationObject.blendMode = particleSystem.blendMode;
        serializationObject.preWarmCycles = particleSystem.preWarmCycles;
        serializationObject.preWarmStepOffset = particleSystem.preWarmStepOffset;
        serializationObject.minInitialRotation = particleSystem.minInitialRotation;
        serializationObject.maxInitialRotation = particleSystem.maxInitialRotation;
        serializationObject.startSpriteCellID = particleSystem.startSpriteCellID;
        serializationObject.spriteCellLoop = particleSystem.spriteCellLoop;
        serializationObject.endSpriteCellID = particleSystem.endSpriteCellID;
        serializationObject.spriteCellChangeSpeed = particleSystem.spriteCellChangeSpeed;
        serializationObject.spriteCellWidth = particleSystem.spriteCellWidth;
        serializationObject.spriteCellHeight = particleSystem.spriteCellHeight;
        serializationObject.spriteRandomStartCell = particleSystem.spriteRandomStartCell;
        serializationObject.isAnimationSheetEnabled = particleSystem.isAnimationSheetEnabled;
        serializationObject.useLogarithmicDepth = particleSystem.useLogarithmicDepth;
        const colorGradients = particleSystem.getColorGradients();
        if (colorGradients) {
            serializationObject.colorGradients = [];
            for (const colorGradient of colorGradients){
                const serializedGradient = {
                    gradient: colorGradient.gradient,
                    color1: colorGradient.color1.asArray()
                };
                if (colorGradient.color2) serializedGradient.color2 = colorGradient.color2.asArray();
                else serializedGradient.color2 = colorGradient.color1.asArray();
                serializationObject.colorGradients.push(serializedGradient);
            }
        }
        const rampGradients = particleSystem.getRampGradients();
        if (rampGradients) {
            serializationObject.rampGradients = [];
            for (const rampGradient of rampGradients){
                const serializedGradient = {
                    gradient: rampGradient.gradient,
                    color: rampGradient.color.asArray()
                };
                serializationObject.rampGradients.push(serializedGradient);
            }
            serializationObject.useRampGradients = particleSystem.useRampGradients;
        }
        const colorRemapGradients = particleSystem.getColorRemapGradients();
        if (colorRemapGradients) {
            serializationObject.colorRemapGradients = [];
            for (const colorRemapGradient of colorRemapGradients){
                const serializedGradient = {
                    gradient: colorRemapGradient.gradient,
                    factor1: colorRemapGradient.factor1
                };
                if (colorRemapGradient.factor2 !== undefined) serializedGradient.factor2 = colorRemapGradient.factor2;
                else serializedGradient.factor2 = colorRemapGradient.factor1;
                serializationObject.colorRemapGradients.push(serializedGradient);
            }
        }
        const alphaRemapGradients = particleSystem.getAlphaRemapGradients();
        if (alphaRemapGradients) {
            serializationObject.alphaRemapGradients = [];
            for (const alphaRemapGradient of alphaRemapGradients){
                const serializedGradient = {
                    gradient: alphaRemapGradient.gradient,
                    factor1: alphaRemapGradient.factor1
                };
                if (alphaRemapGradient.factor2 !== undefined) serializedGradient.factor2 = alphaRemapGradient.factor2;
                else serializedGradient.factor2 = alphaRemapGradient.factor1;
                serializationObject.alphaRemapGradients.push(serializedGradient);
            }
        }
        const sizeGradients = particleSystem.getSizeGradients();
        if (sizeGradients) {
            serializationObject.sizeGradients = [];
            for (const sizeGradient of sizeGradients){
                const serializedGradient = {
                    gradient: sizeGradient.gradient,
                    factor1: sizeGradient.factor1
                };
                if (sizeGradient.factor2 !== undefined) serializedGradient.factor2 = sizeGradient.factor2;
                else serializedGradient.factor2 = sizeGradient.factor1;
                serializationObject.sizeGradients.push(serializedGradient);
            }
        }
        const angularSpeedGradients = particleSystem.getAngularSpeedGradients();
        if (angularSpeedGradients) {
            serializationObject.angularSpeedGradients = [];
            for (const angularSpeedGradient of angularSpeedGradients){
                const serializedGradient = {
                    gradient: angularSpeedGradient.gradient,
                    factor1: angularSpeedGradient.factor1
                };
                if (angularSpeedGradient.factor2 !== undefined) serializedGradient.factor2 = angularSpeedGradient.factor2;
                else serializedGradient.factor2 = angularSpeedGradient.factor1;
                serializationObject.angularSpeedGradients.push(serializedGradient);
            }
        }
        const velocityGradients = particleSystem.getVelocityGradients();
        if (velocityGradients) {
            serializationObject.velocityGradients = [];
            for (const velocityGradient of velocityGradients){
                const serializedGradient = {
                    gradient: velocityGradient.gradient,
                    factor1: velocityGradient.factor1
                };
                if (velocityGradient.factor2 !== undefined) serializedGradient.factor2 = velocityGradient.factor2;
                else serializedGradient.factor2 = velocityGradient.factor1;
                serializationObject.velocityGradients.push(serializedGradient);
            }
        }
        const dragGradients = particleSystem.getDragGradients();
        if (dragGradients) {
            serializationObject.dragGradients = [];
            for (const dragGradient of dragGradients){
                const serializedGradient = {
                    gradient: dragGradient.gradient,
                    factor1: dragGradient.factor1
                };
                if (dragGradient.factor2 !== undefined) serializedGradient.factor2 = dragGradient.factor2;
                else serializedGradient.factor2 = dragGradient.factor1;
                serializationObject.dragGradients.push(serializedGradient);
            }
        }
        const emitRateGradients = particleSystem.getEmitRateGradients();
        if (emitRateGradients) {
            serializationObject.emitRateGradients = [];
            for (const emitRateGradient of emitRateGradients){
                const serializedGradient = {
                    gradient: emitRateGradient.gradient,
                    factor1: emitRateGradient.factor1
                };
                if (emitRateGradient.factor2 !== undefined) serializedGradient.factor2 = emitRateGradient.factor2;
                else serializedGradient.factor2 = emitRateGradient.factor1;
                serializationObject.emitRateGradients.push(serializedGradient);
            }
        }
        const startSizeGradients = particleSystem.getStartSizeGradients();
        if (startSizeGradients) {
            serializationObject.startSizeGradients = [];
            for (const startSizeGradient of startSizeGradients){
                const serializedGradient = {
                    gradient: startSizeGradient.gradient,
                    factor1: startSizeGradient.factor1
                };
                if (startSizeGradient.factor2 !== undefined) serializedGradient.factor2 = startSizeGradient.factor2;
                else serializedGradient.factor2 = startSizeGradient.factor1;
                serializationObject.startSizeGradients.push(serializedGradient);
            }
        }
        const lifeTimeGradients = particleSystem.getLifeTimeGradients();
        if (lifeTimeGradients) {
            serializationObject.lifeTimeGradients = [];
            for (const lifeTimeGradient of lifeTimeGradients){
                const serializedGradient = {
                    gradient: lifeTimeGradient.gradient,
                    factor1: lifeTimeGradient.factor1
                };
                if (lifeTimeGradient.factor2 !== undefined) serializedGradient.factor2 = lifeTimeGradient.factor2;
                else serializedGradient.factor2 = lifeTimeGradient.factor1;
                serializationObject.lifeTimeGradients.push(serializedGradient);
            }
        }
        const limitVelocityGradients = particleSystem.getLimitVelocityGradients();
        if (limitVelocityGradients) {
            serializationObject.limitVelocityGradients = [];
            for (const limitVelocityGradient of limitVelocityGradients){
                const serializedGradient = {
                    gradient: limitVelocityGradient.gradient,
                    factor1: limitVelocityGradient.factor1
                };
                if (limitVelocityGradient.factor2 !== undefined) serializedGradient.factor2 = limitVelocityGradient.factor2;
                else serializedGradient.factor2 = limitVelocityGradient.factor1;
                serializationObject.limitVelocityGradients.push(serializedGradient);
            }
            serializationObject.limitVelocityDamping = particleSystem.limitVelocityDamping;
        }
        if (particleSystem.noiseTexture) serializationObject.noiseTexture = particleSystem.noiseTexture.serialize();
    }
    // Clone
    /**
     * Clones the particle system.
     * @param name The name of the cloned object
     * @param newEmitter The new emitter to use
     * @param cloneTexture Also clone the textures if true
     * @returns the cloned particle system
     */ clone(name, newEmitter, cloneTexture = false) {
        const custom = {
            ...this._customWrappers
        };
        let program = null;
        const engine = this._engine;
        if (engine.createEffectForParticles) {
            if (this.customShader != null) {
                program = this.customShader;
                const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
                const effect = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines);
                if (!custom[0]) this.setCustomEffect(effect, 0);
                else custom[0].effect = effect;
            }
        }
        const serialization = this.serialize(cloneTexture);
        const result = $c96920833f35da71$export$f219b6a0e4bb0b6d.Parse(serialization, this._scene || this._engine, this._rootUrl);
        result.name = name;
        result.customShader = program;
        result._customWrappers = custom;
        if (newEmitter === undefined) newEmitter = this.emitter;
        if (this.noiseTexture) result.noiseTexture = this.noiseTexture.clone();
        result.emitter = newEmitter;
        if (!this.preventAutoStart) result.start();
        return result;
    }
}
/**
 * Billboard mode will only apply to Y axis
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_Y = 2;
/**
 * Billboard mode will apply to all axes
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_ALL = 7;
/**
 * Special billboard mode where the particle will be biilboard to the camera but rotated to align with direction
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_STRETCHED = 8;
/**
 * Special billboard mode where the particle will be billboard to the camera but only around the axis of the direction of particle emission
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_STRETCHED_LOCAL = 9;
(0, $808d74f63d298c61$export$76f56fc382618136)._ParseParticleSystem = $c96920833f35da71$export$f219b6a0e4bb0b6d.Parse;





parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");



class $6a3a14c6b2599a1e$export$48621a34c6748b5a {
    constructor(animationManager){
        this.catching = true;
        /**
    * Spped of the progress used when positionwheel or drag on phone
    */ this.speed = 0.05;
        this.speedVector = new (0, $ha1VO.Vector2)(0.05, 0.05);
        /**
    * Spped of the progress used when positionwheel or drag on phone
    */ this.accuracy = 0.0002;
        this.step = new (0, $ha1VO.Vector2)(0, 0);
        this.positionReal = new (0, $ha1VO.Vector2)(0, 0);
        this.positionCatch = new (0, $ha1VO.Vector2)(0, 0);
        this.listeners = [];
        this.animation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(animationManager, 10);
        this.curve = new (0, $005b3f0c7a6c24da$export$682c243b9f175ba2)();
        this.curve.setEasingMode((0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEOUT);
    }
    start() {
        this.catching = true;
    }
    stop() {
        this.catching = false;
        this.animation.stop();
    }
    /**
    * Set the speed of the progressCatcher
    * @param speed The new speed
    */ setSpeed(speed) {
        this.speed = speed;
        this.speedVector = new (0, $ha1VO.Vector2)(speed, speed);
    }
    /**
    * Set the speed of the progressCatcher
    * @param speed The new speed
    */ setAccuracy(accuracy) {
        this.accuracy = accuracy;
    }
    catch(position) {
        if (position.x == 0 && position.y == 0) return;
        this.positionReal = position.clone();
        this.animation.infinite(()=>{
            this.step = this.positionReal.clone();
            this.step.multiplyInPlace(this.speedVector);
            this.positionCatch.addInPlace(this.step);
            this.sendToListener();
        });
    }
    sendToListener() {
        for(let i = 0; i < this.listeners.length; i++)// Clone to make sure there is not something which can alter real positionCatch
        this.listeners[i](this.positionCatch.clone(), this.step.clone());
    }
    addListener(callback) {
        this.listeners.push(callback);
    }
    removeListener(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.listeners, (c)=>{});
    }
}



class $a5b0bb2ff0a371ea$export$666df850a0d45340 extends (0, $4373291cff47fc4d$export$8304f7f371e2a37b) {
    constructor(type, system){
        super(type, system), this.moving = true, this.position = (0, $ha1VO.Vector2).Zero(), this.direction = (0, $ha1VO.Vector2).Zero(), this.velocity = 1, this.currentMove = (0, $ha1VO.Vector2).Zero();
        this.addCactcher();
    }
    setMoving(moving) {
        this.moving = moving;
    }
    addCactcher() {
        this.moveCatcher = new (0, $6a3a14c6b2599a1e$export$48621a34c6748b5a)(this.system.animationManager);
        this.moveCatcher.addListener((pos, step)=>{
            if (this.moving) {
                let adaptVelocityWithFps = this.system.animationManager.fpsratio;
                step = step.multiplyInPlace(new (0, $ha1VO.Vector2)(5 * adaptVelocityWithFps, 5 * adaptVelocityWithFps));
                // step = step.multiplyInPlace(new Vector2(5, 5));
                this.move(step);
            }
        });
        this.moveCatcher.start();
    }
    move(step) {
        this.currentMove = (0, $ha1VO.Vector2).Lerp(this.currentMove, step, 0.001);
        this.direction = new (0, $ha1VO.Vector2)(this.currentMove.y * this.velocity, this.currentMove.x * this.velocity);
        let pos = this.position.add(this.direction);
        this.setPosition(pos);
    }
    changeSize(change) {
        let newSize = this.size + change;
        this.setSize(newSize);
    }
    show() {}
    hide() {}
}


const $3f53ef2ed5cbbc5e$export$cff7a146e6677ed7 = 150;
const $3f53ef2ed5cbbc5e$export$a8496a0d7030de1b = 0.6;
const $3f53ef2ed5cbbc5e$export$e121b7707a6fdbfa = 4;
const $3f53ef2ed5cbbc5e$export$9d2a8399cd1966bf = 1;
const $3f53ef2ed5cbbc5e$export$7d31ece96576bc11 = [
    {
        name: 'Red Dwarf',
        temperature: 3000,
        color: new (0, $7etnY.Color3)(1, 0.4, 0.4),
        planets: 2,
        gravity: 1.2,
        velocity: 1
    },
    {
        name: 'Yellow Dwarf',
        temperature: 5000,
        color: new (0, $7etnY.Color3)(0.6, 0.5, 0),
        planets: 3,
        gravity: 1.1,
        velocity: 1.1
    },
    {
        name: 'White Dwarf',
        temperature: 12000,
        color: new (0, $7etnY.Color3)(0.5, 0.5, 0.5),
        planets: 4,
        gravity: 1,
        velocity: 0.9
    },
    {
        name: 'Blue Dwarf',
        temperature: 30000,
        color: new (0, $7etnY.Color3)(0.4, 0.4, 1),
        planets: 5,
        gravity: 0.7,
        velocity: 1.2
    }
];
class $3f53ef2ed5cbbc5e$export$1644ba17714857f1 extends (0, $a5b0bb2ff0a371ea$export$666df850a0d45340) {
    constructor(system, planetMap, options){
        super('star', system), // rotateProgress = 0;
        this.cycleSize = 0, this.accelerating = false, this.cycleAbsorb = 1, this.visibleDistance = 100 // ia Maximum Distance
        , this.mapDistance = $3f53ef2ed5cbbc5e$export$cff7a146e6677ed7 // ia Maximum Distance
        , this.isStarVisible = false;
        this.planetMap = planetMap;
        this.shineAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.system.animationManager);
        this.temperature = options.temperature;
        this.curve = new (0, $005b3f0c7a6c24da$export$2d1c5f5e8681690c)(.76, .01, .51, 1.33);
        // this.curve.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
        setInterval(()=>{
            if (this.direction.x !== 0 && this.trailParticles) {
                //  - Math.PI/4 because Isometric
                var angle = Math.atan(this.direction.y / this.direction.x) - Math.PI / 4; //radians
                this.trailParticles.minInitialRotation = angle;
                this.trailParticles.maxInitialRotation = angle;
            }
        }, 100);
    }
    resetParticles(color) {
        if (this.surfaceParticles) this.surfaceParticles.dispose();
        if (this.coronaParticles) this.coronaParticles.dispose();
        if (this.trailParticles) this.trailParticles.dispose();
        // Create a particle system
        this.surfaceParticles = new (0, $c96920833f35da71$export$f219b6a0e4bb0b6d)("surfaceParticles", 100, this.system.scene);
        this.coronaParticles = new (0, $c96920833f35da71$export$f219b6a0e4bb0b6d)("coronaParticles", 100, this.system.scene);
        this.trailParticles = new (0, $c96920833f35da71$export$f219b6a0e4bb0b6d)("trailParticles", 50, this.system.scene);
        // Texture of each particle
        this.surfaceParticles.particleTexture = this.system.surfaceTexture.clone();
        this.coronaParticles.particleTexture = this.system.sparkleTexture.clone();
        this.trailParticles.particleTexture = this.system.sparkleTexture.clone();
        this.surfaceParticles.preWarmStepOffset = 10;
        this.surfaceParticles.preWarmCycles = 100;
        this.coronaParticles.preWarmStepOffset = 10;
        this.coronaParticles.preWarmCycles = 100;
        // Initial rotation
        this.surfaceParticles.minInitialRotation = -2 * Math.PI;
        this.surfaceParticles.maxInitialRotation = 2 * Math.PI;
        this.coronaParticles.minInitialRotation = -2 * Math.PI;
        this.coronaParticles.maxInitialRotation = 2 * Math.PI;
        // Where the sun particles come from
        var sunEmitter = new (0, $f9a35a0cd7eb9213$export$2541b18bda6a65ba)();
        sunEmitter.radius = 1;
        sunEmitter.radiusRange = 0; // emit only from shape surface
        // Assign particles to emitters
        this.surfaceParticles.emitter = this.coreSphere; // the starting object, the emitter
        this.surfaceParticles.particleEmitterType = sunEmitter;
        this.coronaParticles.emitter = this.coreSphere; // the starting object, the emitter
        this.coronaParticles.particleEmitterType = sunEmitter;
        this.trailParticles.emitter = this.coreSphere; // the starting object, the emitter
        // this.trailParticles.particleEmitterType = sunEmitter;
        // Life time of each particle (random between...
        this.surfaceParticles.minLifeTime = 0.5;
        this.surfaceParticles.maxLifeTime = 1.0;
        this.coronaParticles.minLifeTime = 0.6;
        this.coronaParticles.maxLifeTime = 1.2;
        this.trailParticles.minLifeTime = 0.4;
        this.trailParticles.maxLifeTime = 1.0;
        // Emission rate
        this.surfaceParticles.emitRate = 100;
        this.coronaParticles.emitRate = 100;
        this.trailParticles.emitRate = 50;
        // Blend mode : BLENDMODE_ONEONE, BLENDMODE_STANDARD, or BLENDMODE_ADD
        this.surfaceParticles.blendMode = (0, $c96920833f35da71$export$f219b6a0e4bb0b6d).BLENDMODE_ADD;
        this.coronaParticles.blendMode = (0, $c96920833f35da71$export$f219b6a0e4bb0b6d).BLENDMODE_ADD;
        this.trailParticles.blendMode = (0, $c96920833f35da71$export$f219b6a0e4bb0b6d).BLENDMODE_ADD;
        // Set the gravity of all particles
        this.surfaceParticles.gravity = new (0, $ha1VO.Vector3)(0, 0, 0);
        this.coronaParticles.gravity = new (0, $ha1VO.Vector3)(0, 0, 0);
        // Angular speed, in radians
        this.surfaceParticles.minAngularSpeed = -0.4;
        this.surfaceParticles.maxAngularSpeed = 0.4;
        this.coronaParticles.minAngularSpeed = -0.4;
        this.coronaParticles.maxAngularSpeed = 0.4;
        // Speed
        this.surfaceParticles.minEmitPower = 0;
        this.surfaceParticles.maxEmitPower = 0;
        this.surfaceParticles.updateSpeed = 0.005;
        this.coronaParticles.minEmitPower = 0;
        this.coronaParticles.maxEmitPower = 0;
        // No billboard
        this.surfaceParticles.isBillboardBased = false;
        this.coronaParticles.isBillboardBased = true;
        this.trailParticles.isBillboardBased = true;
        // Render Order
        this.surfaceParticles.renderingGroupId = 3;
        this.coronaParticles.renderingGroupId = 1;
        this.trailParticles.renderingGroupId = 1;
        this.surfaceParticles.addColorGradient(0, new (0, $7etnY.Color4)(0.5, 0.5, 0.5, 0.0));
        this.surfaceParticles.addColorGradient(0.4, color.toColor4(1.0));
        this.surfaceParticles.addColorGradient(1.0, new (0, $7etnY.Color4)(0.5, 0.5, 0.5, 0.0));
        this.coronaParticles.addColorGradient(0, new (0, $7etnY.Color4)(0.1, 0.1, 0.1, 0.0));
        this.coronaParticles.addColorGradient(0.4, color.toColor4(1));
        this.coronaParticles.addColorGradient(1.0, new (0, $7etnY.Color4)(0.1, 0.1, 0.1, 0.0));
        this.trailParticles.addColorGradient(0, color.toColor4(1));
        this.trailParticles.addColorGradient(1.0, color.toColor4(0));
        this.trailParticles.addSizeGradient(0, 0); //size at start of particle lifetime
        this.trailParticles.addSizeGradient(0.1, 1); //size at end of particle lifetime
        let parentPos = this.transformMesh.position;
        let parentPrevius = parentPos.clone();
        let parentChange = (0, $ha1VO.Vector3).Zero();
        const surfaceOldUpdate = this.surfaceParticles.updateFunction;
        this.surfaceParticles.updateFunction = function(particles) {
            surfaceOldUpdate(particles);
            parentChange = parentPos.subtract(parentPrevius);
            parentPrevius = parentPos.clone();
            for(var index = 0; index < particles.length; index++){
                var particle = particles[index];
                particle.position.addInPlace(parentChange);
            }
        };
        const coronaOldUpdate = this.coronaParticles.updateFunction;
        this.coronaParticles.updateFunction = function(particles) {
            coronaOldUpdate(particles);
            for(var index = 0; index < particles.length; index++){
                var particle = particles[index];
                particle.position.addInPlace(parentChange);
            }
        };
        // Start the particle system
        this.surfaceParticles.start();
        this.coronaParticles.start();
        this.trailParticles.start();
    }
    createStar() {
        if (this.coreSphere && this.coreSphere.isVisible) return;
        // Create core sphere
        this.coreSphere = (0, $65e76adba60735aa$export$3be740db72ac9cf4).CreateSphere("coreSphere", {
            diameter: 2,
            segments: 16
        }, this.system.scene);
        this.coreSphere.parent = this.transformMesh;
        this.coreSphere.renderingGroupId = 3;
        // this.coreSphere.rotation.y = Math.PI;
        // this.coreSphere.rotation.z = -Math.PI/3;
        // Create core material
        this.coreMaterial = new (0, $c14168b02f7bcc00$export$cb949309547a0dd7)('', this.system.scene);
        // this.coreMaterial = new NoiseShader(this.system.scene);
        this.coreSphere.material = this.coreMaterial;
        this.setTemperature(this.temperature);
        this.setSize(this.size);
        this.system.checkActiveMeshes();
    }
    setMaxPlanet(maxPlanet) {
        this.maxPlanet = maxPlanet;
    }
    setTemperature(temperature) {
        this.temperature = temperature;
        const starCat = (0, (/*@__PURE__*/$parcel$interopDefault($6578d05764c8afc8$exports)))($3f53ef2ed5cbbc5e$export$7d31ece96576bc11, (s)=>s.temperature === temperature);
        const { color: color } = starCat;
        this.color = color.toColor4();
        if (this.isStarVisible) {
            this.coreMaterial.emissiveColor = color;
            // const hsv = color.toHSV();
            // this.coreMaterial.colors = {color1: [hsv.r/360, hsv.g, 0.6], color2: [hsv.r/360, hsv.g, 0.95]}
            this.resetParticles(color);
            this.setSize(this.size);
        }
    }
    setSize(size) {
        this._setSize(size);
        if (!this.isStarVisible) return;
        this.cycleSize = 1 / Math.sqrt(this.size);
        this.setHeartScale(size * 2);
    }
    setHeartScale(scale) {
        this.coreSphere.scaling.x = scale;
        this.coreSphere.scaling.y = scale;
        this.coreSphere.scaling.z = scale;
        this.surfaceParticles.minSize = scale * 1.0;
        this.surfaceParticles.maxSize = scale * 1.5;
        this.coronaParticles.minScaleX = scale * 0.5;
        this.coronaParticles.minScaleY = scale * 0.75;
        this.coronaParticles.maxScaleX = scale * 1.2;
        this.coronaParticles.maxScaleY = scale * 3.0;
        const trailScale = Math.sqrt(scale * 5);
        this.trailParticles.minScaleX = trailScale * 0.5;
        this.trailParticles.minScaleY = trailScale * 0.75;
        this.trailParticles.maxScaleX = trailScale * 1.2;
        this.trailParticles.maxScaleY = trailScale * 3.0;
        this.trailParticles.minLifeTime = Math.min(this.size * 0.2, 1);
        this.trailParticles.maxLifeTime = Math.min(this.size * 0.4, 1);
    }
    updateSize(size, time, callback) {
        if (!this.isStarVisible) return;
        let currentsize = this.size;
        let change = size - currentsize;
        let animTime = time ? time : 20;
        this.shineAnimation.simple(animTime, (count, perc)=>{
            let newOpacity = 0.6 - Math.pow(perc, 4);
            this.setOpacity(newOpacity);
            let newSize = currentsize + this.curve.ease(perc) * change;
            this.setSize(newSize);
        }, ()=>{
            this.setSize(size);
            if (callback) callback();
        });
    }
    _disposeStar() {
        if (!this.coreSphere) return;
        this.coreSphere.isVisible = false;
        this.coreSphere.dispose();
        this.coreMaterial.dispose();
        this.coronaParticles.dispose();
        this.surfaceParticles.dispose();
        this.system.checkActiveMeshes();
    }
    setOpacity(opacity) {
        this.coreSphere.visibility = opacity;
    }
    isStarOnScreen() {
        let vd = this.visibleDistance;
        let p = this.position;
        let c = this.system.center;
        return p.x < c.x + vd && p.x > c.x - vd && p.y < c.y + vd && p.y > c.y - vd;
    }
    isStarOnMap() {
        let vd = this.mapDistance;
        let p = this.position;
        let c = this.system.center;
        return p.x < c.x + vd && p.x > c.x - vd && p.y < c.y + vd && p.y > c.y - vd;
    }
    show() {
        if (this.isStarVisible) return;
        this.isStarVisible = true;
        this.createStar();
    }
    hide() {
        if (!this.isStarVisible) return;
        this.isStarVisible = false;
        this.removeAllPlanets();
        this._disposeStar();
    }
    removeAllPlanets() {
        for(let i = 0; i < this.satellites.length; i++){
            const planet = this.satellites[i];
            planet.hide();
            this.planetMap.storagePlanet(planet);
        }
        this.removeAllSatellites();
    }
}


/*!
 * hotkeys-js v3.6.10
 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies.
 * 
 * Copyright (c) 2019 kenny wong <wowohoo@qq.com>
 * http://jaywcjlove.github.io/hotkeys
 * 
 * Licensed under the MIT license.
 */ var $d949ebf04c50c323$var$isff = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0 : false; // 绑定事件
function $d949ebf04c50c323$var$addEvent(object, event, method) {
    if (object.addEventListener) object.addEventListener(event, method, false);
    else if (object.attachEvent) object.attachEvent("on".concat(event), function() {
        method(window.event);
    });
} // 修饰键转换成对应的键码
function $d949ebf04c50c323$var$getMods(modifier, key) {
    var mods = key.slice(0, key.length - 1);
    for(var i = 0; i < mods.length; i++)mods[i] = modifier[mods[i].toLowerCase()];
    return mods;
} // 处理传的key字符串转换成数组
function $d949ebf04c50c323$var$getKeys(key) {
    if (!key) key = '';
    key = key.replace(/\s/g, ''); // 匹配任何空白字符,包括空格、制表符、换页符等等
    var keys = key.split(','); // 同时设置多个快捷键，以','分割
    var index = keys.lastIndexOf(''); // 快捷键可能包含','，需特殊处理
    for(; index >= 0;){
        keys[index - 1] += ',';
        keys.splice(index, 1);
        index = keys.lastIndexOf('');
    }
    return keys;
} // 比较修饰键的数组
function $d949ebf04c50c323$var$compareArray(a1, a2) {
    var arr1 = a1.length >= a2.length ? a1 : a2;
    var arr2 = a1.length >= a2.length ? a2 : a1;
    var isIndex = true;
    for(var i = 0; i < arr1.length; i++)if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
    return isIndex;
}
var $d949ebf04c50c323$var$_keyMap = {
    // 特殊键
    backspace: 8,
    tab: 9,
    clear: 12,
    enter: 13,
    "return": 13,
    esc: 27,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    del: 46,
    "delete": 46,
    ins: 45,
    insert: 45,
    home: 36,
    end: 35,
    pageup: 33,
    pagedown: 34,
    capslock: 20,
    "\u21EA": 20,
    ',': 188,
    '.': 190,
    '/': 191,
    '`': 192,
    '-': $d949ebf04c50c323$var$isff ? 173 : 189,
    '=': $d949ebf04c50c323$var$isff ? 61 : 187,
    ';': $d949ebf04c50c323$var$isff ? 59 : 186,
    '\'': 222,
    '[': 219,
    ']': 221,
    '\\': 220
};
var $d949ebf04c50c323$var$_modifier = {
    // 修饰键
    "\u21E7": 16,
    shift: 16,
    "\u2325": 18,
    alt: 18,
    option: 18,
    "\u2303": 17,
    ctrl: 17,
    control: 17,
    "\u2318": $d949ebf04c50c323$var$isff ? 224 : 91,
    cmd: $d949ebf04c50c323$var$isff ? 224 : 91,
    command: $d949ebf04c50c323$var$isff ? 224 : 91
};
var $d949ebf04c50c323$var$modifierMap = {
    16: 'shiftKey',
    18: 'altKey',
    17: 'ctrlKey'
};
var $d949ebf04c50c323$var$_mods = {
    16: false,
    18: false,
    17: false
};
var $d949ebf04c50c323$var$_handlers = {}; // F1~F12 特殊键
for(var $d949ebf04c50c323$var$k = 1; $d949ebf04c50c323$var$k < 20; $d949ebf04c50c323$var$k++)$d949ebf04c50c323$var$_keyMap["f".concat($d949ebf04c50c323$var$k)] = 111 + $d949ebf04c50c323$var$k;
 // 兼容Firefox处理
$d949ebf04c50c323$var$modifierMap[$d949ebf04c50c323$var$isff ? 224 : 91] = 'metaKey';
$d949ebf04c50c323$var$_mods[$d949ebf04c50c323$var$isff ? 224 : 91] = false;
var $d949ebf04c50c323$var$_downKeys = []; // 记录摁下的绑定键
var $d949ebf04c50c323$var$_scope = 'all'; // 默认热键范围
var $d949ebf04c50c323$var$elementHasBindEvent = []; // 已绑定事件的节点记录
// 返回键码
var $d949ebf04c50c323$var$code = function code(x) {
    return $d949ebf04c50c323$var$_keyMap[x.toLowerCase()] || $d949ebf04c50c323$var$_modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
}; // 设置获取当前范围（默认为'所有'）
function $d949ebf04c50c323$var$setScope(scope) {
    $d949ebf04c50c323$var$_scope = scope || 'all';
} // 获取当前范围
function $d949ebf04c50c323$var$getScope() {
    return $d949ebf04c50c323$var$_scope || 'all';
} // 获取摁下绑定键的键值
function $d949ebf04c50c323$var$getPressedKeyCodes() {
    return $d949ebf04c50c323$var$_downKeys.slice(0);
} // 表单控件控件判断 返回 Boolean
// hotkey is effective only when filter return true
function $d949ebf04c50c323$var$filter(event) {
    var target = event.target || event.srcElement;
    var tagName = target.tagName;
    var flag = true; // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
    if (target.isContentEditable || tagName === 'TEXTAREA' || (tagName === 'INPUT' || tagName === 'TEXTAREA') && !target.readOnly) flag = false;
    return flag;
} // 判断摁下的键是否为某个键，返回true或者false
function $d949ebf04c50c323$var$isPressed(keyCode) {
    if (typeof keyCode === 'string') keyCode = $d949ebf04c50c323$var$code(keyCode); // 转换成键码
    return $d949ebf04c50c323$var$_downKeys.indexOf(keyCode) !== -1;
} // 循环删除handlers中的所有 scope(范围)
function $d949ebf04c50c323$var$deleteScope(scope, newScope) {
    var handlers;
    var i; // 没有指定scope，获取scope
    if (!scope) scope = $d949ebf04c50c323$var$getScope();
    for(var key in $d949ebf04c50c323$var$_handlers)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_handlers, key)) {
        handlers = $d949ebf04c50c323$var$_handlers[key];
        for(i = 0; i < handlers.length;)if (handlers[i].scope === scope) handlers.splice(i, 1);
        else i++;
    }
     // 如果scope被删除，将scope重置为all
    if ($d949ebf04c50c323$var$getScope() === scope) $d949ebf04c50c323$var$setScope(newScope || 'all');
} // 清除修饰键
function $d949ebf04c50c323$var$clearModifier(event) {
    var key = event.keyCode || event.which || event.charCode;
    var i = $d949ebf04c50c323$var$_downKeys.indexOf(key); // 从列表中清除按压过的键
    if (i >= 0) $d949ebf04c50c323$var$_downKeys.splice(i, 1);
     // 特殊处理 cmmand 键，在 cmmand 组合快捷键 keyup 只执行一次的问题
    if (event.key && event.key.toLowerCase() === 'meta') $d949ebf04c50c323$var$_downKeys.splice(0, $d949ebf04c50c323$var$_downKeys.length);
     // 修饰键 shiftKey altKey ctrlKey (command||metaKey) 清除
    if (key === 93 || key === 224) key = 91;
    if (key in $d949ebf04c50c323$var$_mods) {
        $d949ebf04c50c323$var$_mods[key] = false; // 将修饰键重置为false
        for(var k in $d949ebf04c50c323$var$_modifier)if ($d949ebf04c50c323$var$_modifier[k] === key) $d949ebf04c50c323$var$hotkeys[k] = false;
    }
} // 解除绑定某个范围的快捷键
function $d949ebf04c50c323$var$unbind(key, scope, method) {
    var multipleKeys = $d949ebf04c50c323$var$getKeys(key);
    var keys;
    var mods = [];
    var obj; // 通过函数判断，是否解除绑定
    // https://github.com/jaywcjlove/hotkeys/issues/44
    if (typeof scope === 'function') {
        method = scope;
        scope = 'all';
    }
    for(var i = 0; i < multipleKeys.length; i++){
        // 将组合快捷键拆分为数组
        keys = multipleKeys[i].split('+'); // 记录每个组合键中的修饰键的键码 返回数组
        if (keys.length > 1) mods = $d949ebf04c50c323$var$getMods($d949ebf04c50c323$var$_modifier, keys);
        else mods = [];
         // 获取除修饰键外的键值key
        key = keys[keys.length - 1];
        key = key === '*' ? '*' : $d949ebf04c50c323$var$code(key); // 判断是否传入范围，没有就获取范围
        if (!scope) scope = $d949ebf04c50c323$var$getScope(); // 如何key不在 _handlers 中返回不做处理
        if (!$d949ebf04c50c323$var$_handlers[key]) return; // 清空 handlers 中数据，
        // 让触发快捷键键之后没有事件执行到达解除快捷键绑定的目的
        for(var r = 0; r < $d949ebf04c50c323$var$_handlers[key].length; r++){
            obj = $d949ebf04c50c323$var$_handlers[key][r]; // 通过函数判断，是否解除绑定，函数相等直接返回
            var isMatchingMethod = method ? obj.method === method : true; // 判断是否在范围内并且键值相同
            if (isMatchingMethod && obj.scope === scope && $d949ebf04c50c323$var$compareArray(obj.mods, mods)) $d949ebf04c50c323$var$_handlers[key][r] = {};
        }
    }
} // 对监听对应快捷键的回调函数进行处理
function $d949ebf04c50c323$var$eventHandler(event, handler, scope) {
    var modifiersMatch; // 看它是否在当前范围
    if (handler.scope === scope || handler.scope === 'all') {
        // 检查是否匹配修饰符（如果有返回true）
        modifiersMatch = handler.mods.length > 0;
        for(var y in $d949ebf04c50c323$var$_mods){
            if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_mods, y)) {
                if (!$d949ebf04c50c323$var$_mods[y] && handler.mods.indexOf(+y) > -1 || $d949ebf04c50c323$var$_mods[y] && handler.mods.indexOf(+y) === -1) modifiersMatch = false;
            }
        } // 调用处理程序，如果是修饰键不做处理
        if (handler.mods.length === 0 && !$d949ebf04c50c323$var$_mods[16] && !$d949ebf04c50c323$var$_mods[18] && !$d949ebf04c50c323$var$_mods[17] && !$d949ebf04c50c323$var$_mods[91] || modifiersMatch || handler.shortcut === '*') {
            if (handler.method(event, handler) === false) {
                if (event.preventDefault) event.preventDefault();
                else event.returnValue = false;
                if (event.stopPropagation) event.stopPropagation();
                if (event.cancelBubble) event.cancelBubble = true;
            }
        }
    }
} // 处理keydown事件
function $d949ebf04c50c323$var$dispatch(event) {
    var asterisk = $d949ebf04c50c323$var$_handlers['*'];
    var key = event.keyCode || event.which || event.charCode; // 表单控件过滤 默认表单控件不触发快捷键
    if (!$d949ebf04c50c323$var$hotkeys.filter.call(this, event)) return; // Collect bound keys
    // If an Input Method Editor is processing key input and the event is keydown, return 229.
    // https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
    // http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
    if ($d949ebf04c50c323$var$_downKeys.indexOf(key) === -1 && key !== 229) $d949ebf04c50c323$var$_downKeys.push(key); // Gecko(Firefox)的command键值224，在Webkit(Chrome)中保持一致
    // Webkit左右command键值不一样
    if (key === 93 || key === 224) key = 91;
    if (key in $d949ebf04c50c323$var$_mods) {
        $d949ebf04c50c323$var$_mods[key] = true; // 将特殊字符的key注册到 hotkeys 上
        for(var k in $d949ebf04c50c323$var$_modifier)if ($d949ebf04c50c323$var$_modifier[k] === key) $d949ebf04c50c323$var$hotkeys[k] = true;
        if (!asterisk) return;
    } // 将modifierMap里面的修饰键绑定到event中
    for(var e in $d949ebf04c50c323$var$_mods)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_mods, e)) $d949ebf04c50c323$var$_mods[e] = event[$d949ebf04c50c323$var$modifierMap[e]];
     // 获取范围 默认为all
    var scope = $d949ebf04c50c323$var$getScope(); // 对任何快捷键都需要做的处理
    if (asterisk) {
        for(var i = 0; i < asterisk.length; i++)if (asterisk[i].scope === scope && (event.type === 'keydown' && asterisk[i].keydown || event.type === 'keyup' && asterisk[i].keyup)) $d949ebf04c50c323$var$eventHandler(event, asterisk[i], scope);
    } // key 不在_handlers中返回
    if (!(key in $d949ebf04c50c323$var$_handlers)) return;
    for(var _i = 0; _i < $d949ebf04c50c323$var$_handlers[key].length; _i++){
        if (event.type === 'keydown' && $d949ebf04c50c323$var$_handlers[key][_i].keydown || event.type === 'keyup' && $d949ebf04c50c323$var$_handlers[key][_i].keyup) {
            if ($d949ebf04c50c323$var$_handlers[key][_i].key) {
                var keyShortcut = $d949ebf04c50c323$var$_handlers[key][_i].key.split('+');
                var _downKeysCurrent = []; // 记录当前按键键值
                for(var a = 0; a < keyShortcut.length; a++)_downKeysCurrent.push($d949ebf04c50c323$var$code(keyShortcut[a]));
                _downKeysCurrent = _downKeysCurrent.sort();
                if (_downKeysCurrent.join('') === $d949ebf04c50c323$var$_downKeys.sort().join('')) // 找到处理内容
                $d949ebf04c50c323$var$eventHandler(event, $d949ebf04c50c323$var$_handlers[key][_i], scope);
            }
        }
    }
} // 判断 element 是否已经绑定事件
function $d949ebf04c50c323$var$isElementBind(element) {
    return $d949ebf04c50c323$var$elementHasBindEvent.indexOf(element) > -1;
}
function $d949ebf04c50c323$var$hotkeys(key, option, method) {
    var keys = $d949ebf04c50c323$var$getKeys(key); // 需要处理的快捷键列表
    var mods = [];
    var scope = 'all'; // scope默认为all，所有范围都有效
    var element = document; // 快捷键事件绑定节点
    var i = 0;
    var keyup = false;
    var keydown = true; // 对为设定范围的判断
    if (method === undefined && typeof option === 'function') method = option;
    if (Object.prototype.toString.call(option) === '[object Object]') {
        if (option.scope) scope = option.scope; // eslint-disable-line
        if (option.element) element = option.element; // eslint-disable-line
        if (option.keyup) keyup = option.keyup; // eslint-disable-line
        if (option.keydown) keydown = option.keydown; // eslint-disable-line
    }
    if (typeof option === 'string') scope = option; // 对于每个快捷键进行处理
    for(; i < keys.length; i++){
        key = keys[i].split('+'); // 按键列表
        mods = []; // 如果是组合快捷键取得组合快捷键
        if (key.length > 1) mods = $d949ebf04c50c323$var$getMods($d949ebf04c50c323$var$_modifier, key); // 将非修饰键转化为键码
        key = key[key.length - 1];
        key = key === '*' ? '*' : $d949ebf04c50c323$var$code(key); // *表示匹配所有快捷键
        // 判断key是否在_handlers中，不在就赋一个空数组
        if (!(key in $d949ebf04c50c323$var$_handlers)) $d949ebf04c50c323$var$_handlers[key] = [];
        $d949ebf04c50c323$var$_handlers[key].push({
            keyup: keyup,
            keydown: keydown,
            scope: scope,
            mods: mods,
            shortcut: keys[i],
            method: method,
            key: keys[i]
        });
    } // 在全局document上设置快捷键
    if (typeof element !== 'undefined' && !$d949ebf04c50c323$var$isElementBind(element) && window) {
        $d949ebf04c50c323$var$elementHasBindEvent.push(element);
        $d949ebf04c50c323$var$addEvent(element, 'keydown', function(e) {
            $d949ebf04c50c323$var$dispatch(e);
        });
        $d949ebf04c50c323$var$addEvent(window, 'focus', function() {
            $d949ebf04c50c323$var$_downKeys = [];
        });
        $d949ebf04c50c323$var$addEvent(element, 'keyup', function(e) {
            $d949ebf04c50c323$var$dispatch(e);
            $d949ebf04c50c323$var$clearModifier(e);
        });
    }
}
var $d949ebf04c50c323$var$_api = {
    setScope: $d949ebf04c50c323$var$setScope,
    getScope: $d949ebf04c50c323$var$getScope,
    deleteScope: $d949ebf04c50c323$var$deleteScope,
    getPressedKeyCodes: $d949ebf04c50c323$var$getPressedKeyCodes,
    isPressed: $d949ebf04c50c323$var$isPressed,
    filter: $d949ebf04c50c323$var$filter,
    unbind: $d949ebf04c50c323$var$unbind
};
for(var $d949ebf04c50c323$var$a in $d949ebf04c50c323$var$_api)if (Object.prototype.hasOwnProperty.call($d949ebf04c50c323$var$_api, $d949ebf04c50c323$var$a)) $d949ebf04c50c323$var$hotkeys[$d949ebf04c50c323$var$a] = $d949ebf04c50c323$var$_api[$d949ebf04c50c323$var$a];
if (typeof window !== 'undefined') {
    var $d949ebf04c50c323$var$_hotkeys = window.hotkeys;
    $d949ebf04c50c323$var$hotkeys.noConflict = function(deep) {
        if (deep && window.hotkeys === $d949ebf04c50c323$var$hotkeys) window.hotkeys = $d949ebf04c50c323$var$_hotkeys;
        return $d949ebf04c50c323$var$hotkeys;
    };
    window.hotkeys = $d949ebf04c50c323$var$hotkeys;
}
var $d949ebf04c50c323$export$2e2bcd8739ae039 = $d949ebf04c50c323$var$hotkeys;


parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");

class $8072025274518023$export$ecb90b230dcf8113 {
    constructor(){
        this.mousecatch = new (0, $ha1VO.Vector2)(0, 0);
        this.catching = true;
        // Code copied from babylon: https://github.com/BabylonJS/Babylon.js/blob/master/src/Cameras/Inputs/freeCameraDeviceOrientationInput.ts
        this.screenQuaternion = new (0, $ha1VO.Quaternion)();
        this.constantTranform = new (0, $ha1VO.Quaternion)(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));
        this.divideVector = new (0, $ha1VO.Vector2)(Math.PI / 8, Math.PI / 8);
        this.deviceMaxVector = new (0, $ha1VO.Vector2)(Math.PI / 4, Math.PI / 4);
        this.deviceMinVector = new (0, $ha1VO.Vector2)(-Math.PI / 4, -Math.PI / 4);
        this.listeners = [];
        window.addEventListener("mousemove", (evt)=>{
            this.mouseOrientation(evt);
        });
        window.addEventListener("deviceorientation", (evt)=>{
            this.deviceOrientation(evt);
        });
        window.addEventListener("orientationchange", ()=>{
            this.orientationChanged();
        });
        this.orientationChanged();
        // Ask for device motion permission now mandatory on iphone since Safari 13 update
        // https://medium.com/@leemartin/three-things-im-excited-about-in-safari-13-994107ac6295
        if (window.DeviceMotionEvent && window.DeviceMotionEvent.requestPermission) window.DeviceMotionEvent.requestPermission().then((response)=>{
            response;
        });
    }
    orientationChanged() {
        let screenOrientationAngle = window.orientation !== undefined ? +window.orientation : window.screen.orientation && window.screen.orientation['angle'] ? window.screen.orientation.angle : 0;
        screenOrientationAngle = -(0, $bOhSV.Tools).ToRadians(screenOrientationAngle / 2);
        this.screenQuaternion.copyFromFloats(0, Math.sin(screenOrientationAngle), 0, Math.cos(screenOrientationAngle));
    }
    deviceOrientation(evt) {
        if (this.catching) {
            let gamma = evt.gamma !== null ? evt.gamma : 0;
            let beta = evt.beta !== null ? evt.beta : 0;
            let alpha = evt.alpha !== null ? evt.alpha : 0;
            if (evt.gamma !== null) {
                let quaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll((0, $bOhSV.Tools).ToRadians(alpha), (0, $bOhSV.Tools).ToRadians(beta), -(0, $bOhSV.Tools).ToRadians(gamma));
                quaternion.multiplyInPlace(this.screenQuaternion);
                quaternion.multiplyInPlace(this.constantTranform);
                quaternion.z *= -1;
                quaternion.w *= -1;
                let angles = quaternion.toEulerAngles();
                let pos = new (0, $ha1VO.Vector2)(angles.y, angles.x);
                pos.divideInPlace(this.divideVector);
                this.sendToListener(pos);
            }
        }
    }
    mouseOrientation(evt) {
        if (this.catching) {
            let pos = (0, $ha1VO.Vector2).Zero();
            let w = window.innerWidth;
            let h = window.innerHeight;
            pos.x = 4 * (evt.y - h / 2) / h;
            pos.y = 4 * (evt.x - w / 2) / w;
            this.sendToListener(pos);
        }
    }
    addListener(callback) {
        this.listeners.push(callback);
    }
    removeListener(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.listeners, (c)=>{});
    }
    sendToListener(pos) {
        for(let i = 0; i < this.listeners.length; i++)// Clone to make sure there is not something which can alter real positionCatch
        this.listeners[i](pos.clone());
    }
}


parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");
class $d83437660dc84bb2$export$f1decad12216e358 {
    /**
     * Use to animate the catching
     * @param system System of the 3D scene
     * @param responsive If there is responsive changes, we may have to adapt scroll height
     */ constructor(container){
        /**
     * Distance left to be reached by scroll animation
     */ this.scrollGap = 0;
        /**
     * Scrollable height (Used to simulate real scroll in Intale)
     */ this.scrollHeight = 1000;
        /**
     * The position of drag start when on smartphone
     */ this.touchStart = null;
        /**
     * The gap of drag between start and current touch when on smartphone
     */ this.touchGap = (0, $ha1VO.Vector2).Zero();
        /**
     * On smartphone, we use the touch events to simulate scroll
     * @ignore
     */ this.touchRatio = 0.01;
        this.listeners = [];
        this._container = container;
        this._setTouchEvent();
    }
    _setTouchEvent() {
        let count = 0;
        this._container.addEventListener("touchstart", (evt)=>{
            // We prevent second touch to allow click acceleration
            if (this.touchStart) return;
            this.touchStart = (0, $ha1VO.Vector2).Zero();
            this.touchStart.x = evt.changedTouches[0].clientX;
            this.touchStart.y = evt.changedTouches[0].clientY;
            count = 0;
        });
        // Need test
        this._container.addEventListener("touchend", (evt)=>{
            // We prevent second touch to allow click acceleration
            if (evt.changedTouches.length > 1) return;
            this.touchStart = null;
            this.touchGap = (0, $ha1VO.Vector2).Zero();
            this.sendToListener(this.touchGap, evt);
        });
        this._container.addEventListener("touchmove", (evt)=>{
            // We prevent second touch to allow click acceleration
            count++;
            if (this.touchStart && count > 2) {
                let x = evt.changedTouches[0].clientX;
                let y = evt.changedTouches[0].clientY;
                this.touchGap.y = (x - this.touchStart.x) * this.touchRatio;
                this.touchGap.x = (y - this.touchStart.y) * this.touchRatio;
                // if (count == 50) {
                //     this.touchStart.x = x;
                //     this.touchStart.y = y;
                //     count = 0;
                // }
                this.sendToListener(this.touchGap, evt);
            }
        });
    }
    /**
     * Allow to add a listener on special events
     * @param what the event: start or stop and mouseWheel for now
     * @param funct the function to be called at the event
     */ addListener(funct) {
        this.listeners.push(funct);
    }
    /**
    * Catch the percentage of the scrollHeight
    * @param perc What is the top position to be catched
    */ sendToListener(change, evt) {
        for(let i = 0; i < this.listeners.length; i++)this.listeners[i](change, evt);
    }
}


parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");


parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

class $58745f722026a6b4$export$965755fbf184a8fc extends (0, $4f85fb42b602b6da$export$7bc9e6fdd5ef4b53) {
    constructor(system){
        super('planet', system);
        this.addMesh();
        this.hide();
    }
    addMesh() {
        // this.mesh = MeshBuilder.CreateIcoSphere(this.key + "star", { radius: 1, flat: true, subdivisions: 2 }, this.system.scene);
        // this.mesh = this.system.planetMesh.clone(this.key + "duststar");
        this.mesh = this.system.planetMesh.createInstance(this.key + "duststar");
        this.mesh.alwaysSelectAsActiveMesh = true;
        this.mesh.doNotSyncBoundingInfo = true;
        this.mesh.isVisible = true;
        this.mesh.rotation.x = Math.random() * Math.PI;
        this.mesh.rotation.y = Math.random() * Math.PI;
        this.mesh.rotation.z = Math.random() * Math.PI;
        this.mesh.parent = this.transformMesh;
    }
    show() {
        // this.mesh.isVisible = true;
        let size = 0.8 + Math.random() * 0.4;
        this.satelliteAnimation.simple(50, (count, perc)=>{
            this.setTransformMeshSize(perc * size);
        }, ()=>{
            this.setTransformMeshSize(size);
        });
    }
    hide() {
        this.setSize(0);
        this.reset();
    // this.mesh.isVisible = false;
    }
    reset() {
        this.setOffset(0);
        this.satelliteAnimation.stop();
        this.setPosition((0, $ha1VO.Vector2).Zero());
        this.cycle = 0;
        this.setParent(null);
    }
}



parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");
var $ha1VO = parcelRequire("ha1VO");




const $14db7726e422e23b$var$BASE_COLOR = new (0, $7etnY.Color4)(0.3, 0.3, 0.3, 0);
const $14db7726e422e23b$var$DIVIDE = new (0, $ha1VO.Vector3)(2, 2, 2);
class $14db7726e422e23b$export$72dcbe5a9760c6f extends (0, $3f53ef2ed5cbbc5e$export$1644ba17714857f1) {
    constructor(system, planetMap, starInterface){
        super(system, planetMap, starInterface), this.isDead = false;
        this.particleCurve = new (0, $005b3f0c7a6c24da$export$b9f6da40882c34cc)();
        this.createParticle();
    }
    createParticle() {
        this.particle = new (0, $c96920833f35da71$export$f219b6a0e4bb0b6d)("particle", 100, this.system.scene);
        this.particle.emitRate = 100;
        this.particle.renderingGroupId = 3;
        this.particle.emitter = this.transformMesh.position;
        this.particle.minEmitBox = new (0, $ha1VO.Vector3)(0, 0, 0); // Starting all from
        this.particle.maxEmitBox = new (0, $ha1VO.Vector3)(0, 0, 0);
        this.particle.minLifeTime = 1;
        this.particle.maxLifeTime = 1;
        this.particle.minSize = 4;
        this.particle.maxSize = 4;
        this.particle.limitVelocityDamping = 0.9;
        // Start rotation
        this.particle.minInitialRotation = -Math.PI / 2;
        this.particle.maxInitialRotation = Math.PI / 2;
        this.particle.particleTexture = this.system.sparkleTexture;
        this.particle.blendMode = (0, $c96920833f35da71$export$f219b6a0e4bb0b6d).BLENDMODE_MULTIPLYADD;
        this.system.scene.registerBeforeRender(this.particle.animate);
    }
    setAbsobUpdateFunction() {
        // Use direction to initialize random value
        let that = this;
        this.particle.emitRate = 100;
        this.particle.startPositionFunction = (worldMatrix, positionToUpdate, particle, isLocal)=>{
            const { size: size, position: position, color: color } = that.target;
            const offset = size * 1;
            let x = Math.random() * offset;
            let y = Math.random() * offset;
            let z = Math.random() * offset;
            positionToUpdate.set(position.x + x, z, position.y + y);
            particle.color = color.subtract($14db7726e422e23b$var$BASE_COLOR);
            particle.startColor = particle.color.clone();
            const colorSub = that.color.subtract($14db7726e422e23b$var$BASE_COLOR);
            particle.changeColor = colorSub.subtract(particle.startColor);
        };
        // Must keep that because we need function word on particle
        this.particle.updateFunction = function(particles) {
            const endPosition = new (0, $ha1VO.Vector3)(that.position.x + that.direction.x, 0, that.position.y + that.direction.y);
            const targetDist = (0, $ha1VO.Vector2).Distance(that.position, that.target.position);
            // const targetcolor = that.target.color;
            // const color = that.color;
            for(var index = 0; index < particles.length; index++){
                var particle = particles[index];
                particle.age += 0.01;
                const targetcolor = particle.startColor;
                const changecolor = particle.changeColor;
                let dist = (0, $ha1VO.Vector3).Distance(particle.position, endPosition);
                if (dist < 2 || particle.age >= 1) {
                    particles.splice(index, 1);
                    this._stockParticles.push(particle);
                    // particle.color.a = 0;
                    index--;
                    continue;
                } else {
                    const percDist = Math.max(Math.min(1 - dist / targetDist, 1), 0);
                    const perc = percDist + particle.age * 3;
                    const clampPerc = Math.max(perc, 0.2);
                    const progresscolor = changecolor.multiply(new (0, $7etnY.Color4)(percDist, percDist, percDist, 1.0));
                    particle.color = progresscolor.add(targetcolor);
                    // const progressGradient = Math.min(particle.age, Math.pow(1 - particle.age, 1 / 2));
                    // particle.scale.x = progressGradient * 5;
                    // particle.scale.y = progressGradient * 5;
                    particle.scale.x = 1;
                    particle.scale.y = 1;
                    particle.position = (0, $ha1VO.Vector3).Lerp(particle.position, endPosition, clampPerc * 0.2);
                }
            }
        };
        if (this.isStarVisible) this.particle.start();
    }
    setGetAbsobByBlackHoleFunction() {
        let that = this;
        this.particle.emitRate = 100;
        this.particle.startPositionFunction = (worldMatrix, positionToUpdate, particle, isLocal)=>{
            positionToUpdate.set(that.target.position.x, 0, that.target.position.y);
            particle.color = that.color.clone();
        };
        this.particle.updateFunction = function(particles) {
            const endPosition = new (0, $ha1VO.Vector3)(that.position.x, (0, $a14cc15addd25440$export$2db13a1b8bcc391d) / 4, that.position.y);
            const targetDist = (0, $ha1VO.Vector2).Distance(that.position, that.target.position);
            for(var index = 0; index < particles.length; index++){
                var particle = particles[index];
                particle.age += 0.01;
                let dist = (0, $ha1VO.Vector3).Distance(particle.position, endPosition);
                if (dist < 2 || particle.age >= 1) {
                    particles.splice(index, 1);
                    this._stockParticles.push(particle);
                    // particle.color.a = 0;
                    index--;
                    continue;
                } else {
                    const perc = 1 - dist / targetDist;
                    const clampPerc = Math.max(Math.min(perc, 1), 0.1) * (1 - particle.age);
                    const scale = clampPerc * 4;
                    particle.scale.x = scale;
                    particle.scale.y = scale;
                    particle.position = (0, $ha1VO.Vector3).Lerp(particle.position, endPosition, clampPerc * 0.2);
                }
            }
        };
        if (this.isStarVisible) this.particle.start();
    }
    absorbStopParticle() {
        this.particle.emitRate = 0;
    }
    explode(callback) {
        this._explode(callback);
    }
    _explode(callback) {
        const MAX_EXPLODE_DIST = 80;
        this.surfaceParticles.dispose();
        // this.coronaParticles.dispose();
        this.system.checkMaterials();
        // this.system.soundManager.playMesh('explodeStart', this.transformMesh);
        this.updateSize(10, 100, ()=>{
            this.setSize(0.01);
            let dist = (0, $ha1VO.Vector2).Distance(this.system.center, this.position);
            if (dist < MAX_EXPLODE_DIST) {
                let powerPerc = (MAX_EXPLODE_DIST - dist) / MAX_EXPLODE_DIST;
                let power = Math.pow(powerPerc, 0.5);
                this.system.cameraShake(power);
                this.system.soundManager.playMesh('explodeEnd', this.transformMesh, power);
            }
            setTimeout(()=>{
                // Wait for the particle effect to end
                if (callback) callback();
            }, 4000);
            this.system.checkActiveMeshes();
        });
    }
    _disposeStarFighter() {
        this._disposeStar();
        setTimeout(()=>{
        // this.particle.dispose();
        }, 2000);
        // this.particle.stop();
        this.system.scene.unregisterBeforeRender(this.particle.animate);
    }
}


let $a14cc15addd25440$export$2db13a1b8bcc391d = 50;
let $a14cc15addd25440$export$7f11072070cb9f52 = 10;
class $a14cc15addd25440$export$3f7f9c056010e9e2 extends (0, $14db7726e422e23b$export$72dcbe5a9760c6f) {
    constructor(system, gravityGrid, planetMap, playerInterface){
        super(system, planetMap, playerInterface), this.depth = $a14cc15addd25440$export$2db13a1b8bcc391d, this.blackHoleSize = 0, this.gravityField = $a14cc15addd25440$export$7f11072070cb9f52 * 1.5, this.isBlackHole = false;
        this.gravityGrid = gravityGrid;
    }
    changeToBlackHole(c) {
        this.setSize(30);
        this.build(c);
    }
    build(c) {
        this.isBlackHole = true;
        this.isStarVisible = false;
        this.introAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.system.animationManager);
        const startSize = this.size;
        this.introAnimation.simple(200, (count, perc)=>{
            this.setHeartScale((1 - perc) * startSize);
            this.blackHoleSize = 0.2 * $a14cc15addd25440$export$7f11072070cb9f52 + perc * 0.8 * $a14cc15addd25440$export$7f11072070cb9f52;
            const depthPerc = Math.pow(perc, 2);
            this.depth = depthPerc * $a14cc15addd25440$export$2db13a1b8bcc391d;
        }, ()=>{
            this.setSize($a14cc15addd25440$export$7f11072070cb9f52);
            this.blackHoleSize = $a14cc15addd25440$export$7f11072070cb9f52;
            this._disposeStarFighter();
            c && c();
        });
    // setInterval(() => {
    //     this.setSize(BLACKHOLE_SIZE)
    //     console.log(this.gravityField);
    // }, 2000);
    }
    eatStar(star) {
        let radius = 0;
        let velocity = 100;
        this.grabSatellite(star, radius, velocity);
        this.fixeSatellite(star);
    }
    dispose() {
        this.moveCatcher.stop();
        this.setMoving(false);
        this.transformMesh.dispose();
        this.gravityGrid.eraseMass(this.key);
    }
}


class $4a26b283e7c333cd$export$2616165974278734 extends (0, $a14cc15addd25440$export$3f7f9c056010e9e2) {
    constructor(system, gravityGrid, planetMap, playerInterface){
        super(system, gravityGrid, planetMap, playerInterface), this.realVelocity = 1, this.ia = false, this.realPlayer = false, this.dustField = true, this.distanceAbsorbRatio = 0.002, this.starAbsorbRatio = 2, this.blackHoleAbsorbRatio = 10, this.direction = (0, $ha1VO.Vector2).Zero(), this.launchAnimationLength = 80;
        this.key = 'player' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        this.accelerateAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.system.animationManager);
        this.absorbAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.system.animationManager);
        this.particleCurve = new (0, $005b3f0c7a6c24da$export$b9f6da40882c34cc)();
    }
    setCategory(category, withPlanets) {
        if (this.category == category) return;
        this.category = category;
        this.updateCategory(category, withPlanets);
    }
    updateCategory(category, withPlanets) {
        this.setVelocity(category.velocity);
        this.setTemperature(category.temperature);
        this.setMaxPlanet(category.planets);
        this.setGravity(category.gravity);
        this.updateGravityGrid();
        this.removeAllPlanets();
        if (withPlanets) for(let i = 0; i < category.planets; i++)this.addPlanet();
        this.system.checkActiveMeshes();
    }
    setVelocity(velocity) {
        this.velocity = velocity;
    }
    updateGravityGrid() {
        if (this.isBlackHole) this.gravityGrid.setBlackHolePoint(this.key, this.position, this.blackHoleSize, this.depth);
        else this.gravityGrid.setStarPoint(this.key, this.position, this.gravityField);
    }
    setRealVelocity(realVelocity) {
        this.realVelocity = realVelocity;
    }
    absorbTarget(target, distanceWithTarget) {
        this.distanceWithTarget = distanceWithTarget;
        this.cycleAbsorb = 1 + 50 / distanceWithTarget;
        // Check target to make sure we always absorb closest target
        if (this.absorbing && target == this.target) return;
        if (this.realPlayer || target.realPlayer) this.system.soundManager.fadeIn('absorb');
        this.absorbStop();
        this.absorbing = target.key;
        this.target = target;
        this.setAbsobUpdateFunction();
        this.system.checkActiveMeshes();
        let lastCount = 0;
        this.absorbAnimation.infinite((count)=>{
            let change = count - lastCount;
            lastCount = count;
            let sizeSpeed = this.target.size * this.starAbsorbRatio;
            let distanceSpeed = this.distanceAbsorbRatio / this.distanceWithTarget;
            let up = change * distanceSpeed / sizeSpeed;
            this.changeSize(up);
            let down = -change * distanceSpeed * sizeSpeed;
            this.target.changeSize(down);
            if (this.target.isDead) this.absorbStop();
        });
    }
    absorbByBlackHole(absorber, distanceWithTarget) {
        this.distanceWithTarget = distanceWithTarget;
        if (this.blackHoleAbsorber) return;
        this.absorbStop();
        this.blackHoleAbsorber = absorber;
        this.absorbing = absorber.key;
        this.setGetAbsobByBlackHoleFunction();
        let lastCount = 0;
        this.absorbAnimation.infinite((count)=>{
            let change = count - lastCount;
            lastCount = count;
            let sizeSpeed = this.absorber.size * this.blackHoleAbsorbRatio;
            let distanceSpeed = this.distanceAbsorbRatio / this.distanceWithTarget;
            let up = change * distanceSpeed / sizeSpeed;
            this.absorber.changeSize(up);
            let down = -change * distanceSpeed * sizeSpeed;
            this.changeSize(down);
        // if (this.absorber.isDead) this.absorbStop();
        });
    }
    setAbsorber(absorber, proximity) {
        this.absorber = absorber;
        let newVelocity = Math.pow(proximity, 0.5);
        this.setRealVelocity(newVelocity);
    }
    absorbStop() {
        if (!this.absorbing) return;
        this.absorbStopParticle();
        if (this.realPlayer || this.target.realPlayer) this.system.soundManager.fadeOut('absorb');
        this.absorbAnimation.stop();
        this.absorbing = null;
        this.blackHoleAbsorber = null;
        this.setRealVelocity(1);
    }
    move(step) {
        if (step.y == 0) step.y = 0.001;
        step = step.normalize();
        let finalVelocity = this.velocity * this.realVelocity / (Math.sqrt(this.size) * 5);
        this.currentMove = (0, $ha1VO.Vector2).Lerp(this.currentMove, step, 0.05);
        this.direction = new (0, $ha1VO.Vector2)(this.currentMove.x * finalVelocity, this.currentMove.y * finalVelocity);
        let pos = this.position.add(this.direction);
        this.setPosition(pos);
    }
    setPosition(pos) {
        this._setPosition(pos);
        this.transformMesh.position.x = this.position.x;
        this.transformMesh.position.z = this.position.y;
        this.updateGravityGrid();
    }
    addPlanet(planet) {
        let planetNumber = this.satellites.length;
        const radius = this.getSatelliteRadius(planetNumber);
        let velocity = 1 / (1 + planetNumber / 2) + Math.random() / 2;
        if (!planet) {
            planet = new (0, $58745f722026a6b4$export$965755fbf184a8fc)(this.system);
            planet.setGeostationnaryMovement(radius, velocity);
            planet.show();
        } else {
            this.grabSatellite(planet, radius, velocity);
            if (this.realPlayer) this.system.soundManager.play('catchPlanet');
        }
        this.fixeSatellite(planet);
    }
    addDust() {
        // if (this.realPlayer) this.system.soundManager.play('catchDust');
        this.changeSize(0.005 / Math.pow(this.size, 3));
    }
    accelerate(callback) {
        const satNumber = this.satellites.length;
        if (!this.moving || this.accelerating || !this.isStarVisible || !satNumber) return false;
        let planet = this.satellites[satNumber - 1];
        // this.system.soundManager.playMesh('accelerate', this.transformMesh);
        if (this.realPlayer) this.system.soundManager.play('accelerate');
        this.accelerating = true;
        this.accelerateAnimation.simple(this.launchAnimationLength, (count, perc)=>{
            const { stationaryRadius: stationaryRadius, stationaryVelocity: stationaryVelocity } = planet;
            const newstationaryRadius = Math.max(stationaryRadius - 0.1, 0);
            const newStationaryVelocity = stationaryVelocity + 0.05;
            planet.setGeostationnaryMovement(newstationaryRadius, newStationaryVelocity);
            // if (perc < 0.5) this.realVelocity = 1 + 4 * perc;
            // else this.realVelocity = 1 + 4 * Math.max(1 - perc, 0);
            this.realVelocity = 1 + 2 * Math.sin(perc * Math.PI);
        }, ()=>{
            this.accelerating = false;
            this.planetMap.storagePlanet(planet);
            this.realVelocity = 1;
            this.satellites.pop();
            if (callback) callback();
        });
        return true;
    }
    die(callback) {
        if (this.isDead) return;
        this.removeAllPlanets();
        if (this.absorber && this.absorber.isBlackHole) {
            setTimeout(()=>{
                this.dispose();
                if (callback) callback();
            }, 5000);
            this.setHeartScale(0);
            this.surfaceParticles.stop();
            this.coronaParticles.stop();
            this.trailParticles.stop();
        } else this.explode(()=>{
            setTimeout(()=>{
                this.dispose();
            }, 2000);
            if (callback) callback();
        });
        this.absorbStop();
        this.setMoving(false);
        this.isDead = true;
        if (this.onDied) this.onDied();
    }
    dispose() {
        this._disposePlayer();
    }
    _disposePlayer() {
        this.isDead = true;
        this.moveCatcher.stop();
        this.accelerateAnimation.stop();
        this.removeAllPlanets();
        this._disposeStarFighter();
        this.absorbStop();
        this.gravityGrid.eraseMass(this.key);
    }
    // For IA
    goToPlayer(player) {
        this.moveCatcher.catch(player.position.subtract(this.position));
    }
}



class $f497f7210301949e$export$17098278a054f4b2 extends (0, $4a26b283e7c333cd$export$2616165974278734) {
    constructor(system, gravityGrid, planetMap){
        super(system, gravityGrid, planetMap, {
            temperature: 5000,
            maxPlanet: 5
        }), // map: onlineMap;
        this.dustField = false, this.realPlayer = true, this.keyDirection = new (0, $ha1VO.Vector2)(0, 0), this.keyMove = 10, this.maxRadius = 70;
        this.isStarVisible = true;
        this.createStar();
        this.addMouseEvent();
        this.addKeyEvent();
        this.addZoomCatcher();
        this.resetCamera();
        // this.map = map;
        (0, $d949ebf04c50c323$export$2e2bcd8739ae039)('space', (event, param)=>{
            if (this.moving) this.realPlayerAccelerate();
        });
        window.addEventListener('click', ()=>{
            if (this.moving) this.realPlayerAccelerate();
        });
        setInterval(()=>{
            if (this.moving) {
                this.gravityGrid.setCenterAndSize(this.position, this.size);
                this.system.setCenterAndSize(this.position, this.size);
            // if (this.map.started) this.map.send({ position: this.position });
            }
        // console.log(this.direction, this.coronaParticles.maxInitialRotation);
        }, 500);
        window.addEventListener("resize", ()=>{
            this.checkScreenSize();
        });
        this.checkScreenSize();
        this.system.camera.parent = this.transformMesh;
    }
    // Test to use Motion Blur but not really working
    realPlayerAccelerate() {
        let test = this.accelerate();
        if (test) this.system.addMotionBLur();
    }
    addMouseEvent() {
        if (this.system.checkPlatform()) {
            let touchCatcher = new (0, $d83437660dc84bb2$export$f1decad12216e358)(window);
            touchCatcher.addListener((pos)=>{
                this.sendMove(pos);
            });
        } else {
            let mouseCatcher = new (0, $8072025274518023$export$ecb90b230dcf8113)();
            mouseCatcher.addListener((pos, step)=>{
                this.sendMove(pos);
            });
        }
    }
    addKeyEvent() {
        window.addEventListener("keydown", (evt)=>{
            let key = evt.keyCode;
            if (key == 37) this.keyDirection.y = -this.keyMove;
            else if (key == 38) this.keyDirection.x = -this.keyMove;
            else if (key == 39) this.keyDirection.y = this.keyMove;
            else if (key == 40) this.keyDirection.x = this.keyMove;
            if (key == 37 || key == 38 || key == 39 || key == 40) this.sendMove(this.keyDirection);
        });
        window.addEventListener("keyup", (evt)=>{
            let key = evt.keyCode;
            if (key == 37 || key == 39) this.keyDirection.y = 0;
            else if (key == 38 || key == 40) this.keyDirection.x = 0;
            if (key == 37 || key == 38 || key == 39 || key == 40) this.sendMove(this.keyDirection);
        });
    }
    sendMove(pos) {
        if (!this.moving) return;
        pos.rotateToRef(Math.PI / 4, pos);
        this.moveCatcher.catch(pos);
    //     if (!this.map.started) {
    //     this.moveCatcher.catch(pos);
    // } else {
    //     this.map.send({ destination: pos });
    // }
    }
    addZoomCatcher() {
        this.system.scene.registerBeforeRender(()=>{
            if (!this.isDead) {
                let newRadius = 30 + Math.pow(this.size * 1000, 0.5);
                newRadius = Math.min(newRadius, this.maxRadius);
                // Large size to check stuff
                // let newRadius = 200;
                this.system.lerpCamera(newRadius);
            }
        });
    }
    checkScreenSize() {
        let width = window.innerWidth;
        let height = window.innerHeight;
        this.maxRadius = 120 * height / width;
    }
    resetCamera() {
        this.system.setCameraRadius(10);
        this.system.setAlpha(0);
    }
    restart() {
        this.resetCamera();
        this.setSize((0, $3f53ef2ed5cbbc5e$export$9d2a8399cd1966bf));
        this.setOpacity(1);
        this.setRealVelocity(1);
        this.setMoving(false);
        this.setPosition((0, $ha1VO.Vector2).Zero());
        this.gravityGrid.setCenterAndSize(this.position, this.size);
        this.transformMesh.position.y = 0;
        this.isDead = false;
        this.show();
        this.updateCategory(this.category, true);
        this.system.checkActiveMeshes();
    }
    dispose() {
        this.setMoving(false);
    }
    show() {
        if (this.isStarVisible) return;
        this.isStarVisible = true;
        this.setSize(this.size);
        this.setOpacity(1);
    }
}



parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");




var $e0Suo = parcelRequire("e0Suo");



var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $kVtWi = parcelRequire("kVtWi");
class $e843197f5ed510f4$export$5296435ac66bdd7 extends (0, $a86b55aad2faeec0$export$42a852a2b6b56249) {
    /** Gets or sets a boolean indicating if the stack panel is vertical or horizontal*/ get isVertical() {
        return this._isVertical;
    }
    set isVertical(value) {
        if (this._isVertical === value) return;
        this._isVertical = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the spacing (in pixels) between each child.
     */ get spacing() {
        return this._spacing;
    }
    set spacing(value) {
        if (this._spacing === value) return;
        this._spacing = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets panel width.
     * This value should not be set when in horizontal mode as it will be computed automatically
     */ set width(value) {
        if (!this._doNotTrackManualChanges) this._manualWidth = true;
        if (this._width.toString(this._host) === value) return;
        if (this._width.fromString(value)) this._markAsDirty();
    }
    get width() {
        return this._width.toString(this._host);
    }
    /**
     * Gets or sets panel height.
     * This value should not be set when in vertical mode as it will be computed automatically
     */ set height(value) {
        if (!this._doNotTrackManualChanges) this._manualHeight = true;
        if (this._height.toString(this._host) === value) return;
        if (this._height.fromString(value)) this._markAsDirty();
    }
    get height() {
        return this._height.toString(this._host);
    }
    /**
     * Creates a new StackPanel
     * @param name defines control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._isVertical = true;
        this._manualWidth = false;
        this._manualHeight = false;
        this._doNotTrackManualChanges = false;
        this._spacing = 0;
        /**
         * Gets or sets a boolean indicating that layout warnings should be ignored
         */ this.ignoreLayoutWarnings = false;
    }
    _getTypeName() {
        return "StackPanel";
    }
    /**
     * @internal
     */ _preMeasure(parentMeasure, context) {
        for (const child of this._children)if (this._isVertical) child.verticalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_TOP;
        else child.horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT;
        super._preMeasure(parentMeasure, context);
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.copyFrom(parentMeasure);
        this._measureForChildren.left = this._currentMeasure.left;
        this._measureForChildren.top = this._currentMeasure.top;
        if (!this.isVertical || this._manualWidth) this._measureForChildren.width = this._currentMeasure.width;
        if (this.isVertical || this._manualHeight) this._measureForChildren.height = this._currentMeasure.height;
    }
    _postMeasure() {
        let stackWidth = 0;
        let stackHeight = 0;
        const childrenCount = this._children.length;
        for(let index = 0; index < childrenCount; index++){
            const child = this._children[index];
            if (!child.isVisible || child.notRenderable) continue;
            if (this._isVertical) {
                const top = stackHeight + "px";
                if (child.top !== top) {
                    child.top = top;
                    this._rebuildLayout = true;
                    child._top.ignoreAdaptiveScaling = true;
                }
                if (!this.ignoreLayoutWarnings && !child.isDimensionFullyDefined("height")) (0, $kVtWi.Logger).Warn(`Control (Name:${child.name}, UniqueId:${child.uniqueId}) is using height in percentage mode inside a vertical StackPanel`, 1);
                else stackHeight += child._currentMeasure.height + child._paddingTopInPixels + child._paddingBottomInPixels + (index < childrenCount - 1 ? this._spacing : 0);
            } else {
                const left = stackWidth + "px";
                if (child.left !== left) {
                    child.left = left;
                    this._rebuildLayout = true;
                    child._left.ignoreAdaptiveScaling = true;
                }
                if (!this.ignoreLayoutWarnings && !child.isDimensionFullyDefined("width")) (0, $kVtWi.Logger).Warn(`Control (Name:${child.name}, UniqueId:${child.uniqueId}) is using width in percentage mode inside a horizontal StackPanel`, 1);
                else stackWidth += child._currentMeasure.width + child._paddingLeftInPixels + child._paddingRightInPixels + (index < childrenCount - 1 ? this._spacing : 0);
            }
        }
        stackWidth += this._paddingLeftInPixels + this._paddingRightInPixels;
        stackHeight += this._paddingTopInPixels + this._paddingBottomInPixels;
        this._doNotTrackManualChanges = true;
        // Let stack panel width or height default to stackHeight and stackWidth if dimensions are not specified.
        // User can now define their own height and width for stack panel.
        let panelWidthChanged = false;
        let panelHeightChanged = false;
        if ((!this._manualHeight || this.adaptHeightToChildren) && this._isVertical) {
            // do not specify height if strictly defined by user
            const previousHeight = this.height;
            this.height = stackHeight + "px";
            panelHeightChanged = previousHeight !== this.height || !this._height.ignoreAdaptiveScaling;
        }
        if ((!this._manualWidth || this.adaptWidthToChildren) && !this._isVertical) {
            // do not specify width if strictly defined by user
            const previousWidth = this.width;
            this.width = stackWidth + "px";
            panelWidthChanged = previousWidth !== this.width || !this._width.ignoreAdaptiveScaling;
        }
        if (panelHeightChanged) this._height.ignoreAdaptiveScaling = true;
        if (panelWidthChanged) this._width.ignoreAdaptiveScaling = true;
        this._doNotTrackManualChanges = false;
        if (panelWidthChanged || panelHeightChanged) this._rebuildLayout = true;
        super._postMeasure();
    }
    _getManualDim(dim) {
        if (dim === "width") return this._manualWidth;
        else return this._manualHeight;
    }
    isDimensionFullyDefined(dim) {
        if (dim === "height" ? this.isVertical : !this.isVertical && !this._getManualDim(dim)) {
            for (const child of this._children){
                if (!child.isDimensionFullyDefined(dim)) return false;
            }
            return true;
        }
        return this.getDimension(dim).isPixel || this._getAdaptDimTo(dim);
    }
    /**
     * Serializes the current control
     * @param serializationObject defined the JSON serialized object
     * @param force force serialization even if isSerializable === false
     */ serialize(serializationObject, force) {
        super.serialize(serializationObject, force);
        if (!this.isSerializable && !force) return;
        serializationObject.manualWidth = this._manualWidth;
        serializationObject.manualHeight = this._manualHeight;
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host) {
        this._manualWidth = serializedObject.manualWidth;
        this._manualHeight = serializedObject.manualHeight;
        super._parseFromContent(serializedObject, host);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "ignoreLayoutWarnings", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "isVertical", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "spacing", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "width", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "height", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.StackPanel", $e843197f5ed510f4$export$5296435ac66bdd7);



var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");


var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $ejQPp = parcelRequire("ejQPp");
class $61f8723933a76099$export$3e431a229df88919 extends (0, $b6009490051f50fb$export$7a7fa4424cb20976) {
    /**
     * Gets a boolean indicating that the content is loaded
     */ get isLoaded() {
        return this._loaded;
    }
    isReady() {
        return this.isLoaded;
    }
    /**
     * Gets or sets a boolean indicating if pointers should only be validated on pixels with alpha > 0.
     * Beware using this as this will consume more memory as the image has to be stored twice
     */ get detectPointerOnOpaqueOnly() {
        return this._detectPointerOnOpaqueOnly;
    }
    set detectPointerOnOpaqueOnly(value) {
        if (this._detectPointerOnOpaqueOnly === value) return;
        this._detectPointerOnOpaqueOnly = value;
    }
    /**
     * Gets or sets the left value for slicing (9-patch)
     */ get sliceLeft() {
        return this._sliceLeft;
    }
    set sliceLeft(value) {
        if (this._sliceLeft === value) return;
        this._sliceLeft = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the right value for slicing (9-patch)
     */ get sliceRight() {
        return this._sliceRight;
    }
    set sliceRight(value) {
        if (this._sliceRight === value) return;
        this._sliceRight = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the top value for slicing (9-patch)
     */ get sliceTop() {
        return this._sliceTop;
    }
    set sliceTop(value) {
        if (this._sliceTop === value) return;
        this._sliceTop = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the bottom value for slicing (9-patch)
     */ get sliceBottom() {
        return this._sliceBottom;
    }
    set sliceBottom(value) {
        if (this._sliceBottom === value) return;
        this._sliceBottom = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the left coordinate in the source image
     */ get sourceLeft() {
        return this._sourceLeft;
    }
    set sourceLeft(value) {
        if (this._sourceLeft === value) return;
        this._sourceLeft = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the top coordinate in the source image
     */ get sourceTop() {
        return this._sourceTop;
    }
    set sourceTop(value) {
        if (this._sourceTop === value) return;
        this._sourceTop = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the width to capture in the source image
     */ get sourceWidth() {
        return this._sourceWidth;
    }
    set sourceWidth(value) {
        if (this._sourceWidth === value) return;
        this._sourceWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the height to capture in the source image
     */ get sourceHeight() {
        return this._sourceHeight;
    }
    set sourceHeight(value) {
        if (this._sourceHeight === value) return;
        this._sourceHeight = value;
        this._markAsDirty();
    }
    /**
     * Gets the image width
     */ get imageWidth() {
        return this._imageWidth;
    }
    /**
     * Gets the image height
     */ get imageHeight() {
        return this._imageHeight;
    }
    /**
     * Gets or sets a boolean indicating if nine patch slices (left, top, right, bottom) should be read from image data
     */ get populateNinePatchSlicesFromImage() {
        return this._populateNinePatchSlicesFromImage;
    }
    set populateNinePatchSlicesFromImage(value) {
        if (this._populateNinePatchSlicesFromImage === value) return;
        this._populateNinePatchSlicesFromImage = value;
        if (this._populateNinePatchSlicesFromImage && this._loaded) this._extractNinePatchSliceDataFromImage();
    }
    /** Indicates if the format of the image is SVG */ get isSVG() {
        return this._isSVG;
    }
    /** Gets the status of the SVG attributes computation (sourceLeft, sourceTop, sourceWidth, sourceHeight) */ get svgAttributesComputationCompleted() {
        return this._svgAttributesComputationCompleted;
    }
    /**
     * Gets or sets a boolean indicating if the image can force its container to adapt its size
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get autoScale() {
        return this._autoScale;
    }
    set autoScale(value) {
        if (this._autoScale === value) return;
        this._autoScale = value;
        if (value && this._loaded) this.synchronizeSizeWithContent();
    }
    /** Gets or sets the stretching mode used by the image */ get stretch() {
        return this._stretch;
    }
    set stretch(value) {
        if (this._stretch === value) return;
        this._stretch = value;
        this._markAsDirty();
    }
    /**
     * @internal
     */ _rotate90(n, preserveProperties = false) {
        const width = this._domImage.width;
        const height = this._domImage.height;
        // Should abstract platform instead of using LastCreatedEngine
        const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        const canvas = engine.createCanvas(height, width);
        const context = canvas.getContext("2d");
        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate(n * Math.PI / 2);
        context.drawImage(this._domImage, 0, 0, width, height, -width / 2, -height / 2, width, height);
        const dataUrl = canvas.toDataURL("image/jpg");
        const rotatedImage = new $61f8723933a76099$export$3e431a229df88919(this.name + "rotated", dataUrl);
        if (preserveProperties) {
            rotatedImage._stretch = this._stretch;
            rotatedImage._autoScale = this._autoScale;
            rotatedImage._cellId = this._cellId;
            rotatedImage._cellWidth = n % 1 ? this._cellHeight : this._cellWidth;
            rotatedImage._cellHeight = n % 1 ? this._cellWidth : this._cellHeight;
        }
        this._handleRotationForSVGImage(this, rotatedImage, n);
        this._imageDataCache.data = null;
        return rotatedImage;
    }
    _handleRotationForSVGImage(srcImage, dstImage, n) {
        if (!srcImage._isSVG) return;
        if (srcImage._svgAttributesComputationCompleted) {
            this._rotate90SourceProperties(srcImage, dstImage, n);
            this._markAsDirty();
        } else srcImage.onSVGAttributesComputedObservable.addOnce(()=>{
            this._rotate90SourceProperties(srcImage, dstImage, n);
            this._markAsDirty();
        });
    }
    _rotate90SourceProperties(srcImage, dstImage, n) {
        let srcLeft = srcImage.sourceLeft, srcTop = srcImage.sourceTop, srcWidth = srcImage.domImage.width, srcHeight = srcImage.domImage.height;
        let dstLeft = srcLeft, dstTop = srcTop, dstWidth = srcImage.sourceWidth, dstHeight = srcImage.sourceHeight;
        if (n != 0) {
            const mult = n < 0 ? -1 : 1;
            n = n % 4;
            for(let i = 0; i < Math.abs(n); ++i){
                dstLeft = -(srcTop - srcHeight / 2) * mult + srcHeight / 2;
                dstTop = (srcLeft - srcWidth / 2) * mult + srcWidth / 2;
                [dstWidth, dstHeight] = [
                    dstHeight,
                    dstWidth
                ];
                if (n < 0) dstTop -= dstHeight;
                else dstLeft -= dstWidth;
                srcLeft = dstLeft;
                srcTop = dstTop;
                [srcWidth, srcHeight] = [
                    srcHeight,
                    srcWidth
                ];
            }
        }
        dstImage.sourceLeft = dstLeft;
        dstImage.sourceTop = dstTop;
        dstImage.sourceWidth = dstWidth;
        dstImage.sourceHeight = dstHeight;
    }
    _extractNinePatchSliceDataFromImage() {
        const width = this._domImage.width;
        const height = this._domImage.height;
        if (!this._workingCanvas) {
            const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
            if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
            this._workingCanvas = engine.createCanvas(width, height);
        }
        const canvas = this._workingCanvas;
        const context = canvas.getContext("2d");
        context.drawImage(this._domImage, 0, 0, width, height);
        const imageData = context.getImageData(0, 0, width, height);
        // Left and right
        this._sliceLeft = -1;
        this._sliceRight = -1;
        for(let x = 0; x < width; x++){
            const alpha = imageData.data[x * 4 + 3];
            if (alpha > 127 && this._sliceLeft === -1) {
                this._sliceLeft = x;
                continue;
            }
            if (alpha < 127 && this._sliceLeft > -1) {
                this._sliceRight = x;
                break;
            }
        }
        // top and bottom
        this._sliceTop = -1;
        this._sliceBottom = -1;
        for(let y = 0; y < height; y++){
            const alpha = imageData.data[y * width * 4 + 3];
            if (alpha > 127 && this._sliceTop === -1) {
                this._sliceTop = y;
                continue;
            }
            if (alpha < 127 && this._sliceTop > -1) {
                this._sliceBottom = y;
                break;
            }
        }
    }
    /**
     * Gets or sets the internal DOM image used to render the control
     */ set domImage(value) {
        this._domImage = value;
        this._loaded = false;
        this._imageDataCache.data = null;
        if (this._domImage.width) this._onImageLoaded();
        else this._domImage.onload = ()=>{
            this._onImageLoaded();
        };
    }
    get domImage() {
        return this._domImage;
    }
    _onImageLoaded() {
        this._imageDataCache.data = null;
        this._imageWidth = this._domImage.width;
        this._imageHeight = this._domImage.height;
        this._loaded = true;
        if (this._populateNinePatchSlicesFromImage) this._extractNinePatchSliceDataFromImage();
        if (this._autoScale) this.synchronizeSizeWithContent();
        this.onImageLoadedObservable.notifyObservers(this);
        this._markAsDirty();
    }
    /**
     * Gets the image source url
     */ get source() {
        return this._source;
    }
    /**
     * Resets the internal Image Element cache. Can reduce memory usage.
     */ static ResetImageCache() {
        $61f8723933a76099$export$3e431a229df88919.SourceImgCache.clear();
    }
    _removeCacheUsage(source) {
        const value = source && $61f8723933a76099$export$3e431a229df88919.SourceImgCache.get(source);
        if (value) {
            value.timesUsed -= 1;
            // Remove from DOM
            const htmlElement = value.img;
            if (htmlElement.parentNode) htmlElement.parentNode.removeChild(htmlElement);
            // Since the image isn't being used anymore, we can clean it from the cache
            if (value.timesUsed === 0) $61f8723933a76099$export$3e431a229df88919.SourceImgCache.delete(source);
        }
    }
    /**
     * Gets or sets image source url
     */ set source(value) {
        if (this._urlRewriter && value) value = this._urlRewriter(value);
        if (this._source === value) return;
        this._removeCacheUsage(this._source);
        this._loaded = false;
        this._source = value;
        this._imageDataCache.data = null;
        if (value) value = this._svgCheck(value);
        // Should abstract platform instead of using LastCreatedEngine
        const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        if (value && $61f8723933a76099$export$3e431a229df88919.SourceImgCache.has(value)) {
            const cachedData = $61f8723933a76099$export$3e431a229df88919.SourceImgCache.get(value);
            this._domImage = cachedData.img;
            cachedData.timesUsed += 1;
            if (cachedData.loaded) this._onImageLoaded();
            else cachedData.waitingForLoadCallback.push(this._onImageLoaded.bind(this));
            return;
        }
        this._domImage = engine.createCanvasImage();
        // need to add to enforce rendering
        const imgElement = this._domImage;
        let addedToDom = false;
        if (imgElement.style && this._source?.endsWith(".svg")) {
            imgElement.style.visibility = "hidden";
            imgElement.style.position = "absolute";
            imgElement.style.top = "0";
            engine.getRenderingCanvas()?.parentNode?.appendChild(imgElement);
            addedToDom = true;
        }
        if (value) $61f8723933a76099$export$3e431a229df88919.SourceImgCache.set(value, {
            img: this._domImage,
            timesUsed: 1,
            loaded: false,
            waitingForLoadCallback: [
                this._onImageLoaded.bind(this)
            ]
        });
        this._domImage.onload = ()=>{
            if (value) {
                const cachedData = $61f8723933a76099$export$3e431a229df88919.SourceImgCache.get(value);
                if (cachedData) {
                    cachedData.loaded = true;
                    for (const waitingCallback of cachedData.waitingForLoadCallback)waitingCallback();
                    cachedData.waitingForLoadCallback.length = 0;
                    addedToDom && imgElement.remove();
                    return;
                }
            }
            this._onImageLoaded();
            addedToDom && imgElement.remove();
        };
        if (value) {
            (0, $bOhSV.Tools).SetCorsBehavior(value, this._domImage);
            (0, $bOhSV.Tools).SetReferrerPolicyBehavior(this.referrerPolicy, this._domImage);
            this._domImage.src = value;
        }
    }
    /**
     * Checks for svg document with icon id present
     * @param value the source svg
     * @returns the svg
     */ _svgCheck(value) {
        if (window.SVGSVGElement && value.search(/(\.svg|\.svg?[?|#].*)$/gi) !== -1 && value.indexOf("#") === value.lastIndexOf("#")) {
            this._isSVG = true;
            const svgsrc = value.split("#")[0];
            const elemid = value.split("#")[1];
            // check if object alr exist in document
            const svgExist = document.body.querySelector('object[data="' + svgsrc + '"]');
            if (svgExist) {
                const svgDoc = svgExist.contentDocument;
                // get viewbox width and height, get svg document width and height in px
                if (svgDoc && svgDoc.documentElement) {
                    const vb = svgDoc.documentElement.getAttribute("viewBox");
                    const docwidth = Number(svgDoc.documentElement.getAttribute("width"));
                    const docheight = Number(svgDoc.documentElement.getAttribute("height"));
                    const elem = svgDoc.getElementById(elemid);
                    if (elem && vb && docwidth && docheight) {
                        this._getSVGAttribs(svgExist, elemid);
                        return value;
                    }
                }
                // wait for object to load
                svgExist.addEventListener("load", ()=>{
                    this._getSVGAttribs(svgExist, elemid);
                });
            } else {
                // create document object
                const svgImage = document.createElement("object");
                svgImage.data = svgsrc;
                svgImage.type = "image/svg+xml";
                svgImage.width = "0%";
                svgImage.height = "0%";
                document.body.appendChild(svgImage);
                // when the object has loaded, get the element attribs
                svgImage.onload = ()=>{
                    const svgobj = document.body.querySelector('object[data="' + svgsrc + '"]');
                    if (svgobj) this._getSVGAttribs(svgobj, elemid);
                };
            }
            return svgsrc;
        } else return value;
    }
    /**
     * Sets sourceLeft, sourceTop, sourceWidth, sourceHeight automatically
     * given external svg file and icon id
     * @param svgsrc
     * @param elemid
     */ _getSVGAttribs(svgsrc, elemid) {
        const svgDoc = svgsrc.contentDocument;
        // get viewbox width and height, get svg document width and height in px
        if (svgDoc && svgDoc.documentElement) {
            const vb = svgDoc.documentElement.getAttribute("viewBox");
            const docwidth = Number(svgDoc.documentElement.getAttribute("width"));
            const docheight = Number(svgDoc.documentElement.getAttribute("height"));
            // get element bbox and matrix transform
            const elem = svgDoc.getElementById(elemid);
            if (vb && docwidth && docheight && elem) {
                const vb_width = Number(vb.split(" ")[2]);
                const vb_height = Number(vb.split(" ")[3]);
                const elem_bbox = elem.getBBox();
                let elem_matrix_a = 1;
                let elem_matrix_d = 1;
                let elem_matrix_e = 0;
                let elem_matrix_f = 0;
                const mainMatrix = elem.transform.baseVal.consolidate().matrix;
                if (elem.transform && elem.transform.baseVal.consolidate()) {
                    elem_matrix_a = mainMatrix.a;
                    elem_matrix_d = mainMatrix.d;
                    elem_matrix_e = mainMatrix.e;
                    elem_matrix_f = mainMatrix.f;
                }
                // compute source coordinates and dimensions
                this.sourceLeft = (elem_matrix_a * elem_bbox.x + elem_matrix_e) * docwidth / vb_width;
                this.sourceTop = (elem_matrix_d * elem_bbox.y + elem_matrix_f) * docheight / vb_height;
                this.sourceWidth = elem_bbox.width * elem_matrix_a * (docwidth / vb_width);
                this.sourceHeight = elem_bbox.height * elem_matrix_d * (docheight / vb_height);
                this._svgAttributesComputationCompleted = true;
                this.onSVGAttributesComputedObservable.notifyObservers(this);
            }
        }
    }
    /**
     * Gets or sets the cell width to use when animation sheet is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get cellWidth() {
        return this._cellWidth;
    }
    set cellWidth(value) {
        if (this._cellWidth === value) return;
        this._cellWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the cell height to use when animation sheet is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get cellHeight() {
        return this._cellHeight;
    }
    set cellHeight(value) {
        if (this._cellHeight === value) return;
        this._cellHeight = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the cell id to use (this will turn on the animation sheet mode)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get cellId() {
        return this._cellId;
    }
    set cellId(value) {
        if (this._cellId === value) return;
        this._cellId = value;
        this._markAsDirty();
    }
    /**
     * Creates a new Image
     * @param name defines the control name
     * @param url defines the image url
     */ constructor(name, url = null){
        super(name);
        this.name = name;
        this._workingCanvas = null;
        this._loaded = false;
        this._stretch = $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL;
        this._source = null;
        this._autoScale = false;
        this._sourceLeft = 0;
        this._sourceTop = 0;
        this._sourceWidth = 0;
        this._sourceHeight = 0;
        this._svgAttributesComputationCompleted = false;
        this._isSVG = false;
        this._cellWidth = 0;
        this._cellHeight = 0;
        this._cellId = -1;
        this._populateNinePatchSlicesFromImage = false;
        this._imageDataCache = {
            data: null,
            key: ""
        };
        /**
         * Observable notified when the content is loaded
         */ this.onImageLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable notified when _sourceLeft, _sourceTop, _sourceWidth and _sourceHeight are computed
         */ this.onSVGAttributesComputedObservable = new (0, $diGQf.Observable)();
        this.source = url;
    }
    /**
     * Tests if a given coordinates belong to the current control
     * @param x defines x coordinate to test
     * @param y defines y coordinate to test
     * @returns true if the coordinates are inside the control
     */ contains(x, y) {
        if (!super.contains(x, y)) return false;
        if (!this._detectPointerOnOpaqueOnly || !this._workingCanvas) return true;
        const width = this._currentMeasure.width | 0;
        const height = this._currentMeasure.height | 0;
        const key = width + "_" + height;
        let imageData = this._imageDataCache.data;
        if (!imageData || this._imageDataCache.key !== key) {
            const canvas = this._workingCanvas;
            const context = canvas.getContext("2d");
            this._imageDataCache.data = imageData = context.getImageData(0, 0, width, height).data;
            this._imageDataCache.key = key;
        }
        x = x - this._currentMeasure.left | 0;
        y = y - this._currentMeasure.top | 0;
        const pickedPixel = imageData[(x + y * width) * 4 + 3];
        return pickedPixel > 0;
    }
    _getTypeName() {
        return "Image";
    }
    /** Force the control to synchronize with its content */ synchronizeSizeWithContent() {
        if (!this._loaded) return;
        this.width = this._domImage.width + "px";
        this.height = this._domImage.height + "px";
    }
    _processMeasures(parentMeasure, context) {
        if (this._loaded) switch(this._stretch){
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NONE:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_UNIFORM:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NINE_PATCH:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_EXTEND:
                if (this._autoScale) this.synchronizeSizeWithContent();
                if (this.parent && this.parent.parent) {
                    // Will update root size if root is not the top root
                    this.parent.adaptWidthToChildren = true;
                    this.parent.adaptHeightToChildren = true;
                }
                break;
        }
        super._processMeasures(parentMeasure, context);
    }
    _prepareWorkingCanvasForOpaqueDetection() {
        if (!this._detectPointerOnOpaqueOnly) return;
        const width = this._currentMeasure.width;
        const height = this._currentMeasure.height;
        if (!this._workingCanvas) {
            const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
            if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
            this._workingCanvas = engine.createCanvas(width, height);
        }
        const canvas = this._workingCanvas;
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, width, height);
    }
    _drawImage(context, sx, sy, sw, sh, tx, ty, tw, th) {
        context.drawImage(this._domImage, sx, sy, sw, sh, tx, ty, tw, th);
        if (!this._detectPointerOnOpaqueOnly) return;
        const transform = context.getTransform();
        const canvas = this._workingCanvas;
        const workingCanvasContext = canvas.getContext("2d");
        workingCanvasContext.save();
        const ttx = tx - this._currentMeasure.left;
        const tty = ty - this._currentMeasure.top;
        workingCanvasContext.setTransform(transform.a, transform.b, transform.c, transform.d, (ttx + tw) / 2, (tty + th) / 2);
        workingCanvasContext.translate(-(ttx + tw) / 2, -(tty + th) / 2);
        workingCanvasContext.drawImage(this._domImage, sx, sy, sw, sh, ttx, tty, tw, th);
        workingCanvasContext.restore();
    }
    _draw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        let x, y, width, height;
        if (this.cellId == -1) {
            x = this._sourceLeft;
            y = this._sourceTop;
            width = this._sourceWidth ? this._sourceWidth : this._imageWidth;
            height = this._sourceHeight ? this._sourceHeight : this._imageHeight;
        } else {
            const rowCount = this._domImage.naturalWidth / this.cellWidth;
            const column = this.cellId / rowCount >> 0;
            const row = this.cellId % rowCount;
            x = this.cellWidth * row;
            y = this.cellHeight * column;
            width = this.cellWidth;
            height = this.cellHeight;
        }
        this._prepareWorkingCanvasForOpaqueDetection();
        this._applyStates(context);
        if (this._loaded) switch(this._stretch){
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NONE:
                this._drawImage(context, x, y, width, height, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL:
                this._drawImage(context, x, y, width, height, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_UNIFORM:
                {
                    const hRatio = this._currentMeasure.width / width;
                    const vRatio = this._currentMeasure.height / height;
                    const ratio = Math.min(hRatio, vRatio);
                    const centerX = (this._currentMeasure.width - width * ratio) / 2;
                    const centerY = (this._currentMeasure.height - height * ratio) / 2;
                    this._drawImage(context, x, y, width, height, this._currentMeasure.left + centerX, this._currentMeasure.top + centerY, width * ratio, height * ratio);
                    break;
                }
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_EXTEND:
                this._drawImage(context, x, y, width, height, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NINE_PATCH:
                this._renderNinePatch(context, x, y, width, height);
                break;
        }
        context.restore();
    }
    _renderNinePatch(context, sx, sy, sw, sh) {
        const idealRatio = this.host.idealWidth ? this._width.getValue(this.host) / this.host.idealWidth : this.host.idealHeight ? this._height.getValue(this.host) / this.host.idealHeight : 1;
        const leftWidth = this._sliceLeft;
        const topHeight = this._sliceTop;
        const bottomHeight = sh - this._sliceBottom;
        const rightWidth = sw - this._sliceRight;
        const centerWidth = this._sliceRight - this._sliceLeft;
        const centerHeight = this._sliceBottom - this._sliceTop;
        const leftWidthAdjusted = Math.round(leftWidth * idealRatio);
        const topHeightAdjusted = Math.round(topHeight * idealRatio);
        const bottomHeightAdjusted = Math.round(bottomHeight * idealRatio);
        const rightWidthAdjusted = Math.round(rightWidth * idealRatio);
        const targetCenterWidth = Math.round(this._currentMeasure.width) - rightWidthAdjusted - leftWidthAdjusted + 2;
        const targetCenterHeight = Math.round(this._currentMeasure.height) - bottomHeightAdjusted - topHeightAdjusted + 2;
        const centerLeftOffset = Math.round(this._currentMeasure.left) + leftWidthAdjusted - 1;
        const centerTopOffset = Math.round(this._currentMeasure.top) + topHeightAdjusted - 1;
        const rightOffset = Math.round(this._currentMeasure.left + this._currentMeasure.width) - rightWidthAdjusted;
        const bottomOffset = Math.round(this._currentMeasure.top + this._currentMeasure.height) - bottomHeightAdjusted;
        //Top Left
        this._drawImage(context, sx, sy, leftWidth, topHeight, this._currentMeasure.left, this._currentMeasure.top, leftWidthAdjusted, topHeightAdjusted);
        //Top
        this._drawImage(context, sx + this._sliceLeft, sy, centerWidth, topHeight, centerLeftOffset + 1, this._currentMeasure.top, targetCenterWidth - 2, topHeightAdjusted);
        //Top Right
        this._drawImage(context, sx + this._sliceRight, sy, rightWidth, topHeight, rightOffset, this._currentMeasure.top, rightWidthAdjusted, topHeightAdjusted);
        //Left
        this._drawImage(context, sx, sy + this._sliceTop, leftWidth, centerHeight, this._currentMeasure.left, centerTopOffset + 1, leftWidthAdjusted, targetCenterHeight - 2);
        // Center
        this._drawImage(context, sx + this._sliceLeft, sy + this._sliceTop, centerWidth, centerHeight, centerLeftOffset + 1, centerTopOffset + 1, targetCenterWidth - 2, targetCenterHeight - 2);
        //Right
        this._drawImage(context, sx + this._sliceRight, sy + this._sliceTop, rightWidth, centerHeight, rightOffset, centerTopOffset + 1, rightWidthAdjusted, targetCenterHeight - 2);
        //Bottom Left
        this._drawImage(context, sx, sy + this._sliceBottom, leftWidth, bottomHeight, this._currentMeasure.left, bottomOffset, leftWidthAdjusted, bottomHeightAdjusted);
        //Bottom
        this._drawImage(context, sx + this.sliceLeft, sy + this._sliceBottom, centerWidth, bottomHeight, centerLeftOffset + 1, bottomOffset, targetCenterWidth - 2, bottomHeightAdjusted);
        //Bottom Right
        this._drawImage(context, sx + this._sliceRight, sy + this._sliceBottom, rightWidth, bottomHeight, rightOffset, bottomOffset, rightWidthAdjusted, bottomHeightAdjusted);
    }
    dispose() {
        super.dispose();
        this.onImageLoadedObservable.clear();
        this.onSVGAttributesComputedObservable.clear();
        this._removeCacheUsage(this._source);
    }
}
/**
 * Cache of images to avoid loading the same image multiple times
 */ $61f8723933a76099$export$3e431a229df88919.SourceImgCache = new Map();
// Static
/** STRETCH_NONE */ $61f8723933a76099$export$3e431a229df88919.STRETCH_NONE = 0;
/** STRETCH_FILL */ $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL = 1;
/** STRETCH_UNIFORM */ $61f8723933a76099$export$3e431a229df88919.STRETCH_UNIFORM = 2;
/** STRETCH_EXTEND */ $61f8723933a76099$export$3e431a229df88919.STRETCH_EXTEND = 3;
/** NINE_PATCH */ $61f8723933a76099$export$3e431a229df88919.STRETCH_NINE_PATCH = 4;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "detectPointerOnOpaqueOnly", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceRight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceBottom", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceHeight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "populateNinePatchSlicesFromImage", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "autoScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "stretch", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "source", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "cellWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "cellHeight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "cellId", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Image", $61f8723933a76099$export$3e431a229df88919);



var $e0Suo = parcelRequire("e0Suo");


var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $9d9e40ba118a9f3c$export$4617fb02663045ef extends (0, $a86b55aad2faeec0$export$42a852a2b6b56249) {
    /** Gets or sets border thickness */ get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        if (this._thickness === value) return;
        this._thickness = value;
        this._markAsDirty();
    }
    /** Gets or sets the corner radius of all angles */ get cornerRadius() {
        return this._cornerRadius[0];
    }
    set cornerRadius(value) {
        if (value < 0) value = 0;
        if (this._cornerRadius[0] === value && this._cornerRadius[1] === value && this._cornerRadius[2] === value && this._cornerRadius[3] === value) return;
        this._cornerRadius[0] = this._cornerRadius[1] = this._cornerRadius[2] = this._cornerRadius[3] = value;
        this._markAsDirty();
    }
    /** Gets or sets the corner radius top left angle */ get cornerRadiusX() {
        return this._cornerRadius[0];
    }
    set cornerRadiusX(value) {
        if (this._cornerRadius[0] === value) return;
        this._cornerRadius[0] = value;
    }
    /** Gets or sets the corner radius top right angle */ get cornerRadiusY() {
        return this._cornerRadius[1];
    }
    set cornerRadiusY(value) {
        if (this._cornerRadius[1] === value) return;
        this._cornerRadius[1] = value;
    }
    /** Gets or sets the corner radius bottom left angle */ get cornerRadiusZ() {
        return this._cornerRadius[2];
    }
    set cornerRadiusZ(value) {
        if (this._cornerRadius[2] === value) return;
        this._cornerRadius[2] = value;
    }
    /** Gets or sets the corner radius bottom right angle */ get cornerRadiusW() {
        return this._cornerRadius[3];
    }
    set cornerRadiusW(value) {
        if (this._cornerRadius[3] === value) return;
        this._cornerRadius[3] = value;
    }
    /**
     * Creates a new Rectangle
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._thickness = 1;
        this._cornerRadius = [
            0,
            0,
            0,
            0
        ];
        this._cachedRadius = [
            0,
            0,
            0,
            0
        ];
    }
    _getTypeName() {
        return "Rectangle";
    }
    /** @internal */ _computeAdditionalOffsetX() {
        let additionalWidth = 0;
        if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) // Take in account the aliasing
        additionalWidth += 1;
        if (this.thickness) additionalWidth += this.thickness / 2;
        return additionalWidth;
    }
    /** @internal */ _computeAdditionalOffsetY() {
        let additionalHeight = 0;
        if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) // Take in account the aliasing
        additionalHeight += 1;
        if (this.thickness) additionalHeight += this.thickness / 2;
        return additionalHeight;
    }
    _getRectangleFill(context) {
        return this._getBackgroundColor(context);
    }
    _localDraw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        if (this._background || this._backgroundGradient) {
            context.fillStyle = this._getRectangleFill(context);
            if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) {
                this._drawRoundedRect(context, this._thickness / 2);
                context.fill();
            } else context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        }
        if (this._thickness) {
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            if (this.color || this.gradient) context.strokeStyle = this.gradient ? this.gradient.getCanvasGradient(context) : this.color;
            context.lineWidth = this._thickness;
            if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) {
                this._drawRoundedRect(context, this._thickness / 2);
                context.stroke();
            } else context.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, this._currentMeasure.width - this._thickness, this._currentMeasure.height - this._thickness);
        }
        context.restore();
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.width -= 2 * this._thickness;
        this._measureForChildren.height -= 2 * this._thickness;
        this._measureForChildren.left += this._thickness;
        this._measureForChildren.top += this._thickness;
    }
    _drawRoundedRect(context, offset = 0) {
        const x = this._currentMeasure.left + offset;
        const y = this._currentMeasure.top + offset;
        const width = this._currentMeasure.width - offset * 2;
        const height = this._currentMeasure.height - offset * 2;
        for(let index = 0; index < this._cornerRadius.length; index++)this._cachedRadius[index] = Math.abs(Math.min(height / 2, Math.min(width / 2, this._cornerRadius[index])));
        context.beginPath();
        context.moveTo(x + this._cachedRadius[0], y);
        context.lineTo(x + width - this._cachedRadius[1], y);
        context.arc(x + width - this._cachedRadius[1], y + this._cachedRadius[1], this._cachedRadius[1], 3 * Math.PI / 2, Math.PI * 2);
        context.lineTo(x + width, y + height - this._cachedRadius[2]);
        context.arc(x + width - this._cachedRadius[2], y + height - this._cachedRadius[2], this._cachedRadius[2], 0, Math.PI / 2);
        context.lineTo(x + this._cachedRadius[3], y + height);
        context.arc(x + this._cachedRadius[3], y + height - this._cachedRadius[3], this._cachedRadius[3], Math.PI / 2, Math.PI);
        context.lineTo(x, y + this._cachedRadius[0]);
        context.arc(x + this._cachedRadius[0], y + this._cachedRadius[0], this._cachedRadius[0], Math.PI, 3 * Math.PI / 2);
        context.closePath();
    }
    _clipForChildren(context) {
        if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) {
            this._drawRoundedRect(context, this._thickness);
            context.clip();
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "thickness", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadius", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusZ", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusW", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Rectangle", $9d9e40ba118a9f3c$export$4617fb02663045ef);




var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");



var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $ejQPp = parcelRequire("ejQPp");
var $6354f78219616d48$export$f3fa101e5726e5b0;
(function(TextWrapping) {
    /**
     * Clip the text when it's larger than Control.width; this is the default mode.
     */ TextWrapping[TextWrapping["Clip"] = 0] = "Clip";
    /**
     * Wrap the text word-wise, i.e. try to add line-breaks at word boundary to fit within Control.width.
     */ TextWrapping[TextWrapping["WordWrap"] = 1] = "WordWrap";
    /**
     * Ellipsize the text, i.e. shrink with trailing … when text is larger than Control.width.
     */ TextWrapping[TextWrapping["Ellipsis"] = 2] = "Ellipsis";
    /**
     * Wrap the text word-wise and clip the text when the text's height is larger than the Control.height, and shrink the last line with trailing … .
     */ TextWrapping[TextWrapping["WordWrapEllipsis"] = 3] = "WordWrapEllipsis";
    /**
     * Use HTML to wrap the text. This is the only mode that supports east-asian languages.
     */ TextWrapping[TextWrapping["HTML"] = 4] = "HTML";
})($6354f78219616d48$export$f3fa101e5726e5b0 || ($6354f78219616d48$export$f3fa101e5726e5b0 = {}));
class $6354f78219616d48$export$2db84c782bfb16e2 extends (0, $b6009490051f50fb$export$7a7fa4424cb20976) {
    /**
     * Return the line list (you may need to use the onLinesReadyObservable to make sure the list is ready)
     */ get lines() {
        return this._lines;
    }
    /**
     * Gets or sets a boolean indicating that the TextBlock will be resized to fit its content

     */ get resizeToFit() {
        return this._resizeToFit;
    }
    /**
     * Gets or sets a boolean indicating that the TextBlock will be resized to fit its content

     */ set resizeToFit(value) {
        if (this._resizeToFit === value) return;
        this._resizeToFit = value;
        if (this._resizeToFit) {
            this._width.ignoreAdaptiveScaling = true;
            this._height.ignoreAdaptiveScaling = true;
        }
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating if text must be wrapped
     */ get textWrapping() {
        return this._textWrapping;
    }
    /**
     * Gets or sets a boolean indicating if text must be wrapped
     */ set textWrapping(value) {
        if (this._textWrapping === value) return;
        this._textWrapping = +value;
        this._markAsDirty();
    }
    /**
     * Gets or sets text to display
     */ get text() {
        return this._text;
    }
    /**
     * Gets or sets text to display
     */ set text(value) {
        if (this._text === value) return;
        this._text = value + ""; // Making sure it is a text
        this._markAsDirty();
        this.onTextChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets text horizontal alignment (BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER by default)
     */ get textHorizontalAlignment() {
        return this._textHorizontalAlignment;
    }
    /**
     * Gets or sets text horizontal alignment (BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER by default)
     */ set textHorizontalAlignment(value) {
        if (this._textHorizontalAlignment === value) return;
        this._textHorizontalAlignment = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets text vertical alignment (BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER by default)
     */ get textVerticalAlignment() {
        return this._textVerticalAlignment;
    }
    /**
     * Gets or sets text vertical alignment (BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER by default)
     */ set textVerticalAlignment(value) {
        if (this._textVerticalAlignment === value) return;
        this._textVerticalAlignment = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets line spacing value
     */ set lineSpacing(value) {
        if (this._lineSpacing.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets line spacing value
     */ get lineSpacing() {
        return this._lineSpacing.toString(this._host);
    }
    /**
     * Gets or sets outlineWidth of the text to display
     */ get outlineWidth() {
        return this._outlineWidth;
    }
    /**
     * Gets or sets outlineWidth of the text to display
     */ set outlineWidth(value) {
        if (this._outlineWidth === value) return;
        this._outlineWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating that text must have underline
     */ get underline() {
        return this._underline;
    }
    /**
     * Gets or sets a boolean indicating that text must have underline
     */ set underline(value) {
        if (this._underline === value) return;
        this._underline = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets an boolean indicating that text must be crossed out
     */ get lineThrough() {
        return this._lineThrough;
    }
    /**
     * Gets or sets an boolean indicating that text must be crossed out
     */ set lineThrough(value) {
        if (this._lineThrough === value) return;
        this._lineThrough = value;
        this._markAsDirty();
    }
    /**
     * If the outline should be applied to the underline/strike-through too. Has different behavior in Edge/Chrome vs Firefox.
     */ get applyOutlineToUnderline() {
        return this._applyOutlineToUnderline;
    }
    set applyOutlineToUnderline(value) {
        if (this._applyOutlineToUnderline === value) return;
        this._applyOutlineToUnderline = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets outlineColor of the text to display
     */ get outlineColor() {
        return this._outlineColor;
    }
    /**
     * Gets or sets outlineColor of the text to display
     */ set outlineColor(value) {
        if (this._outlineColor === value) return;
        this._outlineColor = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets word divider
     */ get wordDivider() {
        return this._wordDivider;
    }
    /**
     * Gets or sets word divider
     */ set wordDivider(value) {
        if (this._wordDivider === value) return;
        this._wordDivider = value;
        this._markAsDirty();
    }
    /**
     * By default, if a text block has text wrapping other than Clip, its width
     * is not resized even if resizeToFit = true. This parameter forces the width
     * to be resized.
     */ get forceResizeWidth() {
        return this._forceResizeWidth;
    }
    set forceResizeWidth(value) {
        if (this._forceResizeWidth === value) return;
        this._forceResizeWidth = value;
        this._markAsDirty();
    }
    /**
     * Creates a new TextBlock object
     * @param name defines the name of the control
     * @param text defines the text to display (empty string by default)
     */ constructor(/**
     * Defines the name of the control
     */ name, text = ""){
        super(name);
        this.name = name;
        this._text = "";
        this._textWrapping = 0 /* TextWrapping.Clip */ ;
        this._textHorizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_CENTER;
        this._textVerticalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_CENTER;
        this._resizeToFit = false;
        this._lineSpacing = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._outlineWidth = 0;
        this._outlineColor = "white";
        this._underline = false;
        this._lineThrough = false;
        this._wordDivider = " ";
        this._forceResizeWidth = false;
        this._applyOutlineToUnderline = false;
        /**
         * An event triggered after the text is changed
         */ this.onTextChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the text was broken up into lines
         */ this.onLinesReadyObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean indicating if the HTML element generated for word wrapping should be reused or removed after each wrapping.
         */ this.reuseHTMLForWordWrapping = false;
        this._linesTemp = [];
        this._htmlElement = null;
        this.text = text;
    }
    _getTypeName() {
        return "TextBlock";
    }
    _processMeasures(parentMeasure, context) {
        if (!this._fontOffset || this.isDirty) this._fontOffset = (0, $b6009490051f50fb$export$7a7fa4424cb20976)._GetFontOffset(context.font, this._host.getScene()?.getEngine());
        super._processMeasures(parentMeasure, context);
        // Prepare lines
        this._lines = this._breakLines(this._currentMeasure.width, this._currentMeasure.height, context);
        this.onLinesReadyObservable.notifyObservers(this);
        let maxLineWidth = 0;
        for(let i = 0; i < this._lines.length; i++){
            const line = this._lines[i];
            if (line.width > maxLineWidth) maxLineWidth = line.width;
        }
        if (this._resizeToFit) {
            if (this._textWrapping === 0 /* TextWrapping.Clip */  || this._forceResizeWidth) {
                const newWidth = Math.ceil(this._paddingLeftInPixels) + Math.ceil(this._paddingRightInPixels) + Math.ceil(maxLineWidth);
                if (newWidth !== this._width.getValueInPixel(this._host, this._tempParentMeasure.width)) {
                    this._width.updateInPlace(newWidth, (0, $a038095510e5ba9b$export$839f347a6ebe19f5).UNITMODE_PIXEL);
                    this._rebuildLayout = true;
                }
            }
            let newHeight = this._paddingTopInPixels + this._paddingBottomInPixels + this._fontOffset.height * this._lines.length | 0;
            if (this._lines.length > 0 && this._lineSpacing.internalValue !== 0) {
                let lineSpacing = 0;
                if (this._lineSpacing.isPixel) lineSpacing = this._lineSpacing.getValue(this._host);
                else lineSpacing = this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
                newHeight += (this._lines.length - 1) * lineSpacing;
            }
            if (newHeight !== this._height.internalValue) {
                this._height.updateInPlace(newHeight, (0, $a038095510e5ba9b$export$839f347a6ebe19f5).UNITMODE_PIXEL);
                this._rebuildLayout = true;
            }
        }
    }
    _drawText(text, textWidth, y, context) {
        const width = this._currentMeasure.width;
        let x = 0;
        switch(this._textHorizontalAlignment){
            case (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT:
                x = 0;
                break;
            case (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_RIGHT:
                x = width - textWidth;
                break;
            case (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_CENTER:
                x = (width - textWidth) / 2;
                break;
        }
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        if (this.outlineWidth) context.strokeText(text, this._currentMeasure.left + x, y);
        context.fillText(text, this._currentMeasure.left + x, y);
        if (this._underline) this._drawLine(this._currentMeasure.left + x, y + 3, this._currentMeasure.left + x + textWidth, y + 3, context);
        if (this._lineThrough) this._drawLine(this._currentMeasure.left + x, y - this.fontSizeInPixels / 3, this._currentMeasure.left + x + textWidth, y - this.fontSizeInPixels / 3, context);
    }
    _drawLine(xFrom, yFrom, xTo, yTo, context) {
        context.beginPath();
        context.lineWidth = Math.round(this.fontSizeInPixels * 0.05);
        context.moveTo(xFrom, yFrom);
        context.lineTo(xTo, yTo);
        if (this.outlineWidth && this.applyOutlineToUnderline) {
            context.stroke();
            context.fill();
        } else {
            const currentStroke = context.strokeStyle;
            context.strokeStyle = context.fillStyle;
            context.stroke();
            context.strokeStyle = currentStroke;
        }
        context.closePath();
    }
    /**
     * @internal
     */ _draw(context) {
        context.save();
        this._applyStates(context);
        // Render lines
        this._renderLines(context);
        context.restore();
    }
    _applyStates(context) {
        super._applyStates(context);
        if (this.outlineWidth) {
            context.lineWidth = this.outlineWidth;
            context.strokeStyle = this.outlineColor;
            context.lineJoin = "miter";
            context.miterLimit = 2;
        }
    }
    _breakLines(refWidth, refHeight, context) {
        this._linesTemp.length = 0;
        const _lines = this._textWrapping === 4 /* TextWrapping.HTML */  ? this._parseHTMLText(refWidth, refHeight, context) : this.text.split("\n");
        switch(this._textWrapping){
            case 1 /* TextWrapping.WordWrap */ :
                for (const _line of _lines)this._linesTemp.push(...this._parseLineWordWrap(_line, refWidth, context));
                break;
            case 2 /* TextWrapping.Ellipsis */ :
                for (const _line of _lines)this._linesTemp.push(this._parseLineEllipsis(_line, refWidth, context));
                break;
            case 3 /* TextWrapping.WordWrapEllipsis */ :
                for (const _line of _lines)this._linesTemp.push(...this._parseLineWordWrapEllipsis(_line, refWidth, refHeight, context));
                break;
            case 4 /* TextWrapping.HTML */ :
            default:
                for (const _line of _lines)this._linesTemp.push(this._parseLine(_line, context));
                break;
        }
        return this._linesTemp;
    }
    _parseHTMLText(refWidth, refHeight, context) {
        const lines = [];
        if (!this._htmlElement) {
            this._htmlElement = document.createElement("div");
            document.body.appendChild(this._htmlElement);
        }
        const htmlElement = this._htmlElement;
        htmlElement.textContent = this.text;
        htmlElement.style.font = context.font;
        htmlElement.style.position = "absolute";
        htmlElement.style.visibility = "hidden";
        htmlElement.style.top = "-1000px";
        htmlElement.style.left = "-1000px";
        this.adjustWordWrappingHTMLElement?.(htmlElement);
        htmlElement.style.width = refWidth + "px";
        htmlElement.style.height = refHeight + "px";
        const textContent = htmlElement.textContent;
        if (!textContent) return lines;
        // get the text node
        const textNode = htmlElement.childNodes[0];
        const range = document.createRange();
        let idx = 0;
        for (const c of textContent){
            range.setStart(textNode, 0);
            range.setEnd(textNode, idx + 1);
            // "select" text from beginning to this position to determine the line
            const lineIndex = range.getClientRects().length - 1;
            lines[lineIndex] = (lines[lineIndex] || "") + c;
            idx++;
        }
        if (!this.reuseHTMLForWordWrapping) {
            htmlElement.remove();
            this._htmlElement = null;
        }
        return lines;
    }
    _parseLine(line = "", context) {
        return {
            text: line,
            width: this._getTextMetricsWidth(context.measureText(line))
        };
    }
    //Calculate how many characters approximately we need to remove
    _getCharsToRemove(lineWidth, width, lineLength) {
        const diff = lineWidth > width ? lineWidth - width : 0;
        // This isn't exact unless the font is monospaced
        const charWidth = lineWidth / lineLength;
        const removeChars = Math.max(Math.floor(diff / charWidth), 1);
        return removeChars;
    }
    _parseLineEllipsis(line = "", width, context) {
        let lineWidth = this._getTextMetricsWidth(context.measureText(line));
        let removeChars = this._getCharsToRemove(lineWidth, width, line.length);
        // unicode support. split('') does not work with unicode!
        // make sure Array.from is available
        const characters = Array.from && Array.from(line);
        if (!characters) {
            // no array.from, use the old method
            while(line.length > 2 && lineWidth > width){
                line = line.slice(0, -removeChars);
                lineWidth = this._getTextMetricsWidth(context.measureText(line + "\u2026"));
                removeChars = this._getCharsToRemove(lineWidth, width, line.length);
            }
            // Add on the end
            line += "\u2026";
        } else while(characters.length && lineWidth > width){
            characters.splice(characters.length - removeChars, removeChars);
            line = `${characters.join("")}\u{2026}`;
            lineWidth = this._getTextMetricsWidth(context.measureText(line));
            removeChars = this._getCharsToRemove(lineWidth, width, line.length);
        }
        return {
            text: line,
            width: lineWidth
        };
    }
    _getTextMetricsWidth(textMetrics) {
        if (textMetrics.actualBoundingBoxLeft !== undefined) return Math.abs(textMetrics.actualBoundingBoxLeft) + Math.abs(textMetrics.actualBoundingBoxRight);
        return textMetrics.width;
    }
    _parseLineWordWrap(line = "", width, context) {
        const lines = [];
        const words = this.wordSplittingFunction ? this.wordSplittingFunction(line) : line.split(this._wordDivider);
        let lineWidth = this._getTextMetricsWidth(context.measureText(line));
        for(let n = 0; n < words.length; n++){
            const testLine = n > 0 ? line + this._wordDivider + words[n] : words[0];
            const testWidth = this._getTextMetricsWidth(context.measureText(testLine));
            if (testWidth > width && n > 0) {
                lines.push({
                    text: line,
                    width: lineWidth
                });
                line = words[n];
                lineWidth = this._getTextMetricsWidth(context.measureText(line));
            } else {
                lineWidth = testWidth;
                line = testLine;
            }
        }
        lines.push({
            text: line,
            width: lineWidth
        });
        return lines;
    }
    _parseLineWordWrapEllipsis(line = "", width, height, context) {
        const lines = this._parseLineWordWrap(line, width, context);
        for(let n = 1; n <= lines.length; n++){
            const currentHeight = this._computeHeightForLinesOf(n);
            if (currentHeight > height && n > 1) {
                const lastLine = lines[n - 2];
                const currentLine = lines[n - 1];
                lines[n - 2] = this._parseLineEllipsis(lastLine.text + this._wordDivider + currentLine.text, width, context);
                const linesToRemove = lines.length - n + 1;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            }
        }
        return lines;
    }
    _renderLines(context) {
        if (!this._fontOffset || !this._lines) return;
        const height = this._currentMeasure.height;
        let rootY = 0;
        switch(this._textVerticalAlignment){
            case (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_TOP:
                rootY = this._fontOffset.ascent;
                break;
            case (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_BOTTOM:
                rootY = height - this._fontOffset.height * (this._lines.length - 1) - this._fontOffset.descent;
                break;
            case (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_CENTER:
                rootY = this._fontOffset.ascent + (height - this._fontOffset.height * this._lines.length) / 2;
                break;
        }
        rootY += this._currentMeasure.top;
        for(let i = 0; i < this._lines.length; i++){
            const line = this._lines[i];
            if (i !== 0 && this._lineSpacing.internalValue !== 0) {
                if (this._lineSpacing.isPixel) rootY += this._lineSpacing.getValue(this._host);
                else rootY = rootY + this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
            }
            this._drawText(line.text, line.width, rootY, context);
            rootY += this._fontOffset.height;
        }
    }
    _computeHeightForLinesOf(lineCount) {
        let newHeight = this._paddingTopInPixels + this._paddingBottomInPixels + this._fontOffset.height * lineCount;
        if (lineCount > 0 && this._lineSpacing.internalValue !== 0) {
            let lineSpacing = 0;
            if (this._lineSpacing.isPixel) lineSpacing = this._lineSpacing.getValue(this._host);
            else lineSpacing = this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
            newHeight += (lineCount - 1) * lineSpacing;
        }
        return newHeight;
    }
    isDimensionFullyDefined(dim) {
        if (this.resizeToFit) return true;
        return super.isDimensionFullyDefined(dim);
    }
    /**
     * Given a width constraint applied on the text block, find the expected height
     * @returns expected height
     */ computeExpectedHeight() {
        if (this.text && this.widthInPixels) {
            // Should abstract platform instead of using LastCreatedEngine
            const context = (0, $ejQPp.EngineStore).LastCreatedEngine?.createCanvas(0, 0).getContext("2d");
            if (context) {
                this._applyStates(context);
                if (!this._fontOffset) this._fontOffset = (0, $b6009490051f50fb$export$7a7fa4424cb20976)._GetFontOffset(context.font, this._host.getScene()?.getEngine());
                const lines = this._lines ? this._lines : this._breakLines(this.widthInPixels - this._paddingLeftInPixels - this._paddingRightInPixels, this.heightInPixels - this._paddingTopInPixels - this._paddingBottomInPixels, context);
                return this._computeHeightForLinesOf(lines.length);
            }
        }
        return 0;
    }
    dispose() {
        super.dispose();
        this.onTextChangedObservable.clear();
        this._htmlElement?.remove();
        this._htmlElement = null;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "resizeToFit", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "textWrapping", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "text", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "textHorizontalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "textVerticalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "lineSpacing", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "outlineWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "underline", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "lineThrough", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "applyOutlineToUnderline", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "outlineColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "wordDivider", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "forceResizeWidth", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.TextBlock", $6354f78219616d48$export$2db84c782bfb16e2);



class $0b985d791bfcec1b$export$5525e5ba287fa6f5 {
    constructor(system){
        this.style = {};
        this.renameEvent = {
            click: 'onPointerUpObservable',
            mousedown: 'onPointerDownObservable',
            enter: 'onPointerEnterObservable',
            leave: 'onPointerOutObservable'
        };
        this.system = system;
        this.anim = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        return this;
    }
    createContainer(texture) {
        this.texture = texture;
        this.container = new (0, $9d9e40ba118a9f3c$export$4617fb02663045ef)("");
        this.texture.addControl(this.container);
        this.container.thickness = 0;
        this.container.isPointerBlocker = false;
    }
    hide() {
        this.container.isVisible = false;
        return this;
    }
    show() {
        this.container.isVisible = true;
        return this;
    }
    _setStyle(style, el) {
        let rel = el ? el : this.container;
        for(let key in style){
            this.style[key] = style[key];
            rel[key] = style[key];
        }
        return this;
    }
    _deleteEvent() {
        // FIXME
        if (this.container) {
            this.container.isHitTestVisible = false;
            this.container.isFocusInvisible = true;
        }
    }
    _setColor(color) {
        this.container.color = color;
        this.style.color = color;
        return this;
    }
    setOpacity(op) {
        this.container.alpha = op;
        this.style.alpha = op;
        return this;
    }
    setBackgroundOpacity(op) {
        if (this.style.background == undefined) return;
        this.backgroundrgb = this.hexToRgb(this.style.background);
        let bgop = 'rgba(' + this.backgroundrgb.r + ', ' + this.backgroundrgb.g + ', ' + this.backgroundrgb.b + ', ' + op + ')';
        this.container.background = bgop;
        return this;
    }
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    addOpacity(op) {
        this.container.alpha += op;
        this.style.alpha += op;
        if (this.container.alpha > 1) this.setOpacity(1);
        if (this.container.alpha < 0) this.setOpacity(0);
        return this;
    }
    setHeight(height) {
        this.height = height;
        this.container.height = height + 4 + 'px';
        return this;
    }
    setWidth(width) {
        this.width = width;
        this.container.width = width + 'px';
        return this;
    }
    setSize(size) {
        this.height = size.height;
        this.width = size.width;
        this.container.height = size.height + 'px';
        this.container.width = size.width + 'px';
        return this;
    }
    setPosition(pos) {
        this.position = pos;
        this.container.left = pos.x + 'px';
        this.container.top = pos.y + 'px';
        return this;
    }
    setRelativePosition(pos) {
        this.position = pos;
        if (this.angle) {
            this.container.left = (pos.x - this.texture._texture.baseWidth / 2 + Math.cos(this.angle) * this.width / 2 + Math.sin(this.angle) * this.height / 2).toString() + 'px';
            this.container.top = (pos.y - this.texture._texture.baseHeight / 2 + Math.sin(this.angle) * this.width / 2 + Math.cos(this.angle) * this.height / 2).toString() + 'px';
        } else {
            this.container.left = (pos.x - this.texture._texture.baseWidth / 2 + this.width / 2).toString() + 'px';
            this.container.top = (pos.y - this.texture._texture.baseHeight / 2 + this.height / 2).toString() + 'px';
        }
        return this;
    }
    setRotation(angle) {
        this.container.rotation = angle;
        this.angle = this.container.rotation;
        return this;
    }
    addRotation(angle) {
        this.container.rotation += angle;
        this.angle = this.container.rotation;
        return this;
    }
    remove() {
        this.texture.removeControl(this.container);
        return this;
    }
    on(event1, funct) {
        let nodeevent = this.renameEvent[event1];
        this.container.isPointerBlocker = true;
        this.container.isHitTestVisible = true;
        this.container.hoverCursor = 'pointer';
        this.container[nodeevent].add(()=>{
            funct();
        });
        return this;
    }
}
class $0b985d791bfcec1b$export$4b50f340f3e0e69a extends $0b985d791bfcec1b$export$5525e5ba287fa6f5 {
    setNode(text, style) {
        this.node = new (0, $b6009490051f50fb$export$7a7fa4424cb20976)();
        this.text = text;
    }
    setStyle(style, el) {
        this._setStyle(style, el);
        return this;
    }
    setColor(color) {
        this._setColor(color);
        return this;
    }
    blow() {
        if (!this.node || !this.style.color) return;
        this._setStyle({
            background: this.style.color
        });
        this.anim.alternate(18, 3, (count, perc)=>{
            this.setBackgroundOpacity(perc);
        }, (count, perc)=>{
            this.setBackgroundOpacity(1 - perc);
        }, ()=>{
            this.setBackgroundOpacity(0);
        });
        return this;
    }
    shine() {
        if (!this.node || !this.style.color) return;
        this._setStyle({
            background: this.style.color
        });
        this.anim.alternate(100, 50, (count, perc)=>{
            this.setBackgroundOpacity(perc);
            this.node.shadowBlur = perc * 10;
        }, (count, perc)=>{
            this.setBackgroundOpacity(1 - perc);
            this.node.shadowBlur = (1 - perc) * 10;
        }, ()=>{
            this.node.shadowBlur = 5;
            this.setBackgroundOpacity(0);
        });
        return this;
    }
    setTextStyle(style, el) {
        for(let key in style)this.node[key] = style[key];
        return this;
    }
    centerText() {
        this.setTextStyle({
            textHorizontalAlignment: (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_CENTER,
            textVerticalAlignment: (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_CENTER
        });
        return this;
    }
    setWidthPosition() {
        if (!this.position) return;
        this.width = this.style.width;
        this.container.width = this.width + 'px';
        let width = this.texture.widthInPixels;
        this.container.left = this.position.x + (this.width - width) / 2 + 'px';
        this.centerText();
        return this;
    }
    deleteEvent() {
        if (this.node) {
            this.node.isHitTestVisible = false;
            this.node.isFocusInvisible = true;
        }
        this._deleteEvent();
        return this;
    }
}
class $0b985d791bfcec1b$export$489206ccede3c264 extends $0b985d791bfcec1b$export$4b50f340f3e0e69a {
    constructor(system, texture, text, pos, style, event1){
        super(system);
        style.fontFamily = "'Aldrich', sans-serif";
        this.setNode(text, style);
        this.createContainer(texture);
        this.setStyle(style);
        this.container.zIndex = 2;
        this.setPosition(pos);
        if (style.width == undefined) this.container.width = '100%';
        else this.setWidth(style.width);
        this.container.addControl(this.node);
        if (!event1) this.deleteEvent();
    }
    setNode(text, style) {
        text = text.toString().toUpperCase();
        this.node = new (0, $6354f78219616d48$export$2db84c782bfb16e2)();
        this.text = text;
        this.node.text = text;
        this.node.textWrapping = true;
        this.setBlur('black');
        if (style.width != undefined) this.node.width = style.width;
        if (style.float == 'right') this.node.textHorizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_RIGHT;
        else if (style.float == 'left') this.node.textHorizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT;
    }
    setText(text) {
        text = text.toString().toUpperCase();
        this.node.text = text;
        this.node.color = this.style.color;
        this.text = text;
        this.show();
        return this;
    }
    setBlur(color) {
        if (this.node) {
            this.node.shadowBlur = 5;
            this.node.shadowColor = color;
        }
        return this;
    }
    setStyle(style, el) {
        this._setStyle(style, el);
        if (style.color && this.text) this.setText(this.text);
        if (style.blur) this.setBlur(style.blur);
        return this;
    }
    setColor(color) {
        this._setColor(color);
        if (this.text) this.setText(this.text);
        return this;
    }
    writeText(text, speed, callback) {
        let newtext = text ? text.toString() : this.text;
        let l = speed ? speed : newtext.length / 2;
        this.anim.simple(l, (count, perc)=>{
            let nbchar = Math.round(perc * newtext.length);
            let writetext = newtext.substring(0, nbchar);
            this.setText(writetext);
            if (callback) callback();
        });
    }
    showAnimate(text) {
        let h = this.height;
        let newtext = text ? text : this.text;
        this.setText('');
        this.anim.simple(10, (count, perc)=>{
            this.setBackgroundOpacity(1 - 0.5 * perc);
            this.setHeight(perc * h);
        }, ()=>{
            this.setBackgroundOpacity(0.5);
            this.setHeight(h);
            this.writeText(newtext);
        });
    }
}
class $0b985d791bfcec1b$export$3e5ae0226b42d67 extends $0b985d791bfcec1b$export$4b50f340f3e0e69a {
    constructor(system, texture, image, pos, style, event1){
        super(system);
        this.setNode(image, style);
        this.createContainer(texture);
        this.setStyle(style);
        this.container.zIndex = 2;
        this.setPosition(pos);
        this.container.addControl(this.node);
        if (!event1) this.deleteEvent();
    }
    setNode(image, style) {
        this.node = new (0, $61f8723933a76099$export$3e431a229df88919)("", image);
        this.image = image;
        this.node.stretch = 2;
    }
}
class $0b985d791bfcec1b$export$728e9fb0bbb6d8f9 extends $0b985d791bfcec1b$export$489206ccede3c264 {
    constructor(system, texture, icon, pos, style, event1){
        super(system, texture, icon, pos, style, event1), this.icon = true, this.icontochar = {
            home: 'a',
            chat: 'b',
            volumeOn: 'c',
            volumeOff: 'd',
            twitter: 'e'
        };
        this.setIcon(icon);
    }
    setIcon(icon) {
        let text = this.icontochar[icon];
        if (text == undefined) return console.log(icon);
        this.setText(text);
        return this;
    }
    setText(text) {
        text = text.toString();
        this.node.fontFamily = 'icomoon';
        this.node.fontSize = this.style.fontSize;
        this.node.text = text;
        this.node.color = this.style.color;
        this.text = text;
        return this;
    }
}
class $0b985d791bfcec1b$export$c1904a6c321bc460 extends $0b985d791bfcec1b$export$4b50f340f3e0e69a {
    constructor(system, texture, pos, style){
        super(system);
        this.createContainer(texture);
        this._setStyle({
            background: style.color
        });
        // this.container.zIndex = 0;
        this.setSize({
            width: style.width,
            height: style.height
        });
        this.setPosition(pos);
        if (style.opacity) this.setBackgroundOpacity(style.opacity);
        if (style.float == 'right') this.container.horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_RIGHT;
        else if (style.float == 'left') this.container.horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT;
        if (!event) this._deleteEvent();
        return this;
    }
}
class $0b985d791bfcec1b$export$77a56bf766fd0532 extends $0b985d791bfcec1b$export$4b50f340f3e0e69a {
    constructor(system, texture, pos, style){
        super(system);
        this.angle = style.angle ? style.angle : 0;
        this.createContainer(texture);
        this.container.zIndex = 1;
        this.setWidth(style.width);
        if (style.color) this._setStyle({
            background: style.color
        });
        if (style.opacity) this.setOpacity(style.opacity);
        if (style.angle) this.setRotation(style.angle);
        this.setHeight(style.border);
        this.setPosition(pos);
        return this;
    }
    setColor(color) {
        this._setStyle({
            background: color
        });
        return this;
    }
}
class $0b985d791bfcec1b$export$54a0a12681da12cd extends $0b985d791bfcec1b$export$4b50f340f3e0e69a {
    constructor(system, texture, pos, style){
        super(system), this.bar = {};
        this.createContainer(texture);
        this.setStyle(style);
        this.container.zIndex = 2;
        this.setPosition(pos);
        return this;
    }
    createBar(name, style) {
        let bar = new (0, $9d9e40ba118a9f3c$export$4617fb02663045ef)("");
        this.bar[name] = bar;
        this.bar[name].thickness = 0;
        if (style.float == 'left') this.bar[name].left = '-50%';
        else if (style.float == 'right') this.bar[name].left = '50%';
        this.container.addControl(bar);
        this.setStyle(style, bar);
        return this;
    }
    setBarValue(name, value) {
        this.bar[name].width = value * 2 + '%';
        return this;
    }
    setBarOpacity(name, op) {
        this.bar[name].opacity = op;
        return this;
    }
}




class $dfe6dd1db453be64$export$73b6d46d29ad40bc extends (0, $0b985d791bfcec1b$export$4b50f340f3e0e69a) {
    showAnim() {
        this.show();
    }
    hideAnim() {
        this.hide();
    }
    setHoverAnimation() {
        this.on('enter', ()=>{
            this.enterAnim();
        });
        this.on('leave', ()=>{
            this.leaveAnim();
        });
        this.setOpacity(this.hoverOpacity);
    }
    enterAnim() {
        this.anim.simple(this.animTime, (count, perc)=>{
            this.setOpacity(this.hoverOpacity + perc * (1 - this.hoverOpacity));
        }, ()=>{
            this.setOpacity(1);
        });
    }
    leaveAnim() {
        this.anim.simple(this.animTime, (count, perc)=>{
            this.setOpacity(1 - perc * (1 - this.hoverOpacity));
        }, ()=>{
            this.setOpacity(this.hoverOpacity);
        });
    }
    constructor(...args){
        super(...args), this.hoverOpacity = 0.7, this.animTime = 5;
    }
}
class $dfe6dd1db453be64$export$3251478e29ed24f0 extends $dfe6dd1db453be64$export$73b6d46d29ad40bc {
    constructor(system, pos, style){
        super(system), this.leftlist = [], this.rightlist = [], this.layernumber = 6, this.style = {
            width: 0.02,
            height: 0.3,
            opacity: 1,
            color: ''
        };
        let angle = 0;
        if (style.scale) {
            this.style.height *= style.scale;
            this.style.width *= style.scale;
        }
        this.style.color = style.color;
        for(let i = 0; i < this.layernumber; i++){
            let back1 = new (0, $0b985d791bfcec1b$export$c1904a6c321bc460)(system, system.advancedTexture, pos, this.style);
            let back2 = new (0, $0b985d791bfcec1b$export$c1904a6c321bc460)(system, system.advancedTexture, pos, this.style);
            back1.setRotation(angle);
            back2.setRotation(angle);
            this.leftlist.push(back1);
            this.rightlist.push(back2);
            angle += 2 * Math.PI / this.layernumber;
        }
        this.animate();
    }
    setColor(color1, color2) {
        for(let i = 0; i < this.layernumber; i++){
            this.leftlist[i].setStyle({
                background: color1
            });
            this.rightlist[i].setStyle({
                background: color1
            });
        }
        return this;
    }
    animate() {
        let lastcount = 0;
        this.anim.infinite((count, perc)=>{
            let addangle = (count - lastcount) / 100;
            for(let i = 0; i < this.layernumber; i++){
                this.leftlist[i].addRotation(-addangle);
                this.rightlist[i].addRotation(addangle);
            }
            lastcount = count;
        });
    }
    show() {
        for(let i = 0; i < this.layernumber; i++){
            this.leftlist[i].show();
            this.rightlist[i].show();
        }
        this.animate();
        return this;
    }
    hide() {
        for(let i = 0; i < this.layernumber; i++){
            this.leftlist[i].hide();
            this.rightlist[i].hide();
        }
        this.anim.stop();
        return this;
    }
    remove() {
        for(let i = 0; i < this.layernumber; i++){
            this.leftlist[i].remove();
            this.rightlist[i].remove();
        }
        this.anim.stop();
        return this;
    }
}
class $dfe6dd1db453be64$export$2465147a477e412e extends $dfe6dd1db453be64$export$73b6d46d29ad40bc {
    constructor(system, texture, content, pos, size, style){
        super(system);
        this.content = content;
        this.style = style;
        this.createContainer(texture);
        this.setPosition(pos);
        this.setSize(size);
        this.setContent(content, style);
        this.setStyle(style);
    }
    setContent(content, style) {
        if (content.ui == 'text') this.ui = new (0, $0b985d791bfcec1b$export$489206ccede3c264)(this.system, this.container, content.text, {
            x: 0,
            y: 0
        }, {
            color: style.color,
            fontSize: style.fontSize
        });
        else if (content.ui == 'icon') this.ui = new (0, $0b985d791bfcec1b$export$728e9fb0bbb6d8f9)(this.system, this.container, content.text, {
            x: 0,
            y: 0
        }, {
            color: style.color,
            fontSize: style.fontSize
        });
        else if (content.ui == 'image') this.ui = new (0, $0b985d791bfcec1b$export$3e5ae0226b42d67)(this.system, this.container, content.text, {
            x: 0,
            y: 0
        }, {
            color: style.color,
            fontSize: style.fontSize
        });
        this.ui.setBlur(0);
    }
    setStyle(style) {
        const { color: color, fontSize: fontSize, background: background, border: border } = style;
        this.ui._setStyle({
            color: color,
            fontSize: fontSize
        });
        this._setStyle({
            color: color,
            background: background,
            thickness: border
        });
        return this;
    }
    setColors(text, background) {
        this.ui.setColor(text);
        this._setStyle({
            background: background
        });
    }
    setText(text) {
        this.ui.setText(text);
        this.ui.setBlur(0);
    }
}
class $dfe6dd1db453be64$export$6e0354b00f1275b3 extends $dfe6dd1db453be64$export$73b6d46d29ad40bc {
    constructor(system, texture, pos, style){
        super(system), this.side = 50, this.mainlineopacity = 0.4;
        this.style = style;
        this.width = style.width;
        if (style.side) this.side = style.side;
        this.createContainer(texture);
        this.setPosition(pos);
        this.container.zIndex = 1;
        this.setWidth(style.width);
        if (style.angle) this.setRotation(style.angle);
        this.setHeight(this.side);
        this.setContent(style);
        this.endShow();
        return this;
    }
    setContent(style) {
        this.mainline = new (0, $0b985d791bfcec1b$export$77a56bf766fd0532)(this.system, this.container, {
            x: 0,
            y: 0
        }, {
            border: style.border,
            width: style.width,
            opacity: this.mainlineopacity
        });
        this.line1 = new (0, $0b985d791bfcec1b$export$77a56bf766fd0532)(this.system, this.container, {
            x: (-style.width + this.side) / 2,
            y: 0
        }, {
            border: style.border,
            width: this.side,
            opacity: 1
        });
        this.line2 = new (0, $0b985d791bfcec1b$export$77a56bf766fd0532)(this.system, this.container, {
            x: (style.width - this.side) / 2,
            y: 0
        }, {
            border: style.border,
            width: this.side,
            opacity: 1
        });
        if (style.color) this.setColor(style.color);
    }
    showAnim() {
        this.mainline.setWidth(0);
        this.show();
        this.anim.simple(10, (cout, perc)=>{
            this.mainline.setWidth(perc * this.width);
            this.mainline.setOpacity(1 - perc * (1 - this.mainlineopacity));
            this.line1.setWidth(perc * this.side);
            // this.line1.setRotation((1 - perc)*Math.PI/2);
            this.line2.setWidth(perc * this.side);
        // this.line2.setRotation((1 - perc)*Math.PI/2);
        }, ()=>{
            this.endShow();
        });
        return this;
    }
    endShow() {
        this.mainline.setWidth(this.width);
        this.mainline.setOpacity(this.mainlineopacity);
        this.line1.setWidth(this.side);
        // this.line1.setRotation(0);
        this.line2.setWidth(this.side);
    // this.line2.setRotation(0);
    }
    hideAnim() {
        this.mainline.setWidth(this.width);
        this.anim.simple(10, (cout, perc)=>{
            let percinv = 1 - perc;
            this.mainline.setWidth(percinv * this.width);
            this.mainline.setOpacity(this.mainlineopacity + perc * (1 - this.mainlineopacity));
            this.line1.setWidth(percinv * this.height);
            // this.line1.setRotation(perc*Math.PI/2);
            this.line2.setWidth(percinv * this.height);
        // this.line2.setRotation(perc*Math.PI/2);
        }, ()=>{
            this.hide();
        });
        return this;
    }
    setColor(color) {
        this.mainline._setStyle({
            background: color
        });
        this.line1._setStyle({
            background: color
        });
        this.line2._setStyle({
            background: color
        });
        return this;
    }
    setBorderSide(borderside) {
        this.side = borderside;
        this.line1.setWidth(this.side);
        this.line2.setWidth(this.side);
        this.line1.setPosition({
            x: (-this.width + this.side) / 2,
            y: 0
        });
        this.line2.setPosition({
            x: (this.width - this.side) / 2,
            y: 0
        });
    }
}
class $dfe6dd1db453be64$export$578827e0a5e517b5 extends $dfe6dd1db453be64$export$73b6d46d29ad40bc {
    constructor(system, texture, title, pos, style){
        super(system), this.fullopacity = 0.8;
        this.style = style;
        this.title = title;
        this.createContainer(texture);
        this.container.zIndex = 3;
        this.setPosition(pos);
        this.setHeight(Math.round(style.fontSize + style.fontSize / 4));
        this.container.horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT;
        this.setWidth(style.width);
        this.iconwidth = Math.round(this.width / 2 - style.fontSize / 2);
        this.iconheight = Math.round(style.fontSize / 8);
        if (style.background) this._setStyle({
            background: style.background
        });
        this.setContent(title, style);
        return this;
    }
    setContent(text, style) {
        this.textNode = new (0, $0b985d791bfcec1b$export$489206ccede3c264)(this.system, this.container, text, {
            x: style.fontSize,
            y: 0
        }, {
            fontSize: style.fontSize
        });
        this.lefticon = new (0, $0b985d791bfcec1b$export$728e9fb0bbb6d8f9)(this.system, this.container, 'slice1', {
            x: 0,
            y: 0
        }, {
            float: 'center',
            fontSize: style.fontSize
        });
        this.righticon = new (0, $0b985d791bfcec1b$export$728e9fb0bbb6d8f9)(this.system, this.container, 'slice2', {
            x: 0,
            y: 0
        }, {
            float: 'center',
            fontSize: style.fontSize
        });
        return this;
    }
    setText(title) {
        this.title = title;
        this.showAnim();
        return this;
    }
    showAnim() {
        this.show();
        this.textNode.setText('');
        this.anim.simple(10, (cout, perc)=>{
            this.lefticon.setPosition({
                x: -perc * this.iconwidth,
                y: this.iconheight
            });
            this.righticon.setPosition({
                x: perc * this.iconwidth,
                y: this.iconheight
            });
            this.setBackgroundOpacity(perc * this.fullopacity);
        }, ()=>{
            this.textNode.writeText(this.title, 10);
            this.lefticon.setPosition({
                x: -this.iconwidth,
                y: this.iconheight
            });
            this.righticon.setPosition({
                x: this.iconwidth,
                y: this.iconheight
            });
            this.setBackgroundOpacity(this.fullopacity);
        });
        return this;
    }
    hideAnim() {
        this.anim.simple(10, (cout, perc)=>{
            this.lefticon.setPosition({
                x: (perc - 1) * this.iconwidth,
                y: this.iconheight
            });
            this.righticon.setPosition({
                x: (1 - perc) * this.iconwidth,
                y: this.iconheight
            });
            this.setBackgroundOpacity((1 - perc) * this.fullopacity);
        }, ()=>{
            this.hide();
        });
        return this;
    }
    setColors(text, background, blur) {
        this.setTextColor(text);
        this.setBackgroundColor(background);
        this.textNode.setBlur(blur);
    }
    setTextColor(textcolor) {
        this.lefticon.setColor(textcolor);
        this.righticon.setColor(textcolor);
        this.textNode.setColor(textcolor);
        return this;
    }
    setBackgroundColor(backgroundcolor) {
        this._setStyle({
            background: backgroundcolor
        });
        return this;
    }
}
class $dfe6dd1db453be64$export$a3ba86d6f28c8a6a extends $dfe6dd1db453be64$export$73b6d46d29ad40bc {
    constructor(system, texture, pos, style){
        super(system), this.fullOpacity = 1, this.fullWidth = 30;
        this.createContainer(texture);
        this.setPosition(pos);
        this.setContent(style);
        this.showAnim();
        this.setWidth(this.fullWidth);
        this.setHeight(this.fullWidth);
        this.setHoverAnimation();
        return this;
    }
    setContent(style) {
        let angle = style.orientation == 'right' ? -Math.PI / 4 : Math.PI / 4;
        this.line1 = new (0, $0b985d791bfcec1b$export$77a56bf766fd0532)(this.system, this.container, {
            x: 0,
            y: 8
        }, {
            width: this.fullWidth,
            border: 4,
            angle: angle
        });
        this.line2 = new (0, $0b985d791bfcec1b$export$77a56bf766fd0532)(this.system, this.container, {
            x: 0,
            y: -8
        }, {
            width: this.fullWidth,
            border: 4,
            angle: -angle
        });
        return this;
    }
    showAnim() {
        this.show();
        this.anim.simple(10, (cout, perc)=>{
            this.line1.setWidth(perc * this.fullWidth);
            this.line2.setWidth(perc * this.fullWidth);
        }, ()=>{
            this.line1.setWidth(this.fullWidth);
            this.line2.setWidth(this.fullWidth);
        });
        return this;
    }
    hideAnim() {
        this.anim.simple(10, (cout, perc)=>{
            this.line1.setWidth((1 - perc) * this.fullWidth);
            this.line2.setWidth((1 - perc) * this.fullWidth);
        }, ()=>{
            this.hide();
        });
        return this;
    }
    setColor(linecolor) {
        this.line1.setColor(linecolor);
        this.line2.setColor(linecolor);
        return this;
    }
}


class $86ae1c9d39c421df$export$8cf279b501ac6d02 extends (0, $0b985d791bfcec1b$export$5525e5ba287fa6f5) {
    constructor(system, container){
        super(system), this.nodes = [], this.textnodes = [], this.stylenodes = [];
        if (container) {
            this.texture = system.advancedTexture;
            this.container = container;
            this.texture.addControl(this.container);
        } else this.createContainer(system.advancedTexture);
    }
    addText(text, pos, style) {
        let textNode = new (0, $0b985d791bfcec1b$export$489206ccede3c264)(this.system, this.container, text, pos, style);
        this.textnodes.push(textNode);
        return textNode;
    }
    addIcon(icon, pos, style) {
        let iconNode = new (0, $0b985d791bfcec1b$export$728e9fb0bbb6d8f9)(this.system, this.container, icon, pos, style);
        this.textnodes.push(iconNode);
        return iconNode;
    }
    addImage(image, pos, style) {
        let imageNode = new (0, $0b985d791bfcec1b$export$3e5ae0226b42d67)(this.system, this.container, image, pos, style);
        this.nodes.push(imageNode);
        return imageNode;
    }
    addBack(pos, style) {
        let back = new (0, $0b985d791bfcec1b$export$c1904a6c321bc460)(this.system, this.container, pos, style);
        this.nodes.push(back);
        return back;
    }
    addLine(pos, style) {
        let line = new (0, $0b985d791bfcec1b$export$77a56bf766fd0532)(this.system, this.container, pos, style);
        this.nodes.push(line);
        return line;
    }
    addArrow(pos, style) {
        let arrow = new (0, $dfe6dd1db453be64$export$a3ba86d6f28c8a6a)(this.system, this.container, pos, style);
        this.stylenodes.push(arrow);
        return arrow;
    }
    addBorder(pos, style) {
        let line = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, pos, style);
        this.stylenodes.push(line);
        return line;
    }
    addBar(pos, style) {
        let bar = new (0, $0b985d791bfcec1b$export$54a0a12681da12cd)(this.system, this.container, pos, style);
        this.nodes.push(bar);
        return bar;
    }
    addButton(content, pos, size, style) {
        let button = new (0, $dfe6dd1db453be64$export$2465147a477e412e)(this.system, this.container, content, pos, size, style);
        this.stylenodes.push(button);
        return button;
    }
    hideAll() {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].hide();
        for(let i = 0; i < this.nodes.length; i++)this.nodes[i].hide();
        for(let i = 0; i < this.stylenodes.length; i++)this.stylenodes[i].hideAnim();
        return this;
    }
    showAll() {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].show();
        for(let i = 0; i < this.nodes.length; i++)this.nodes[i].show();
        for(let i = 0; i < this.stylenodes.length; i++)this.stylenodes[i].showAnim();
        return this;
    }
    initAll() {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].setText('').hide();
        return this;
    }
    stopAll() {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].anim.stop();
        for(let i = 0; i < this.nodes.length; i++)this.nodes[i].anim.stop();
        for(let i = 0; i < this.stylenodes.length; i++)this.stylenodes[i].anim.stop();
        return this;
    }
    removeAll() {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].remove();
        for(let i = 0; i < this.nodes.length; i++)this.nodes[i].remove();
        for(let i = 0; i < this.stylenodes.length; i++)this.stylenodes[i].remove();
        return this;
    }
    setColorAll(color) {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].setColor(color);
        for(let i = 0; i < this.nodes.length; i++)this.nodes[i].setColor(color);
        for(let i = 0; i < this.stylenodes.length; i++)this.stylenodes[i].setColor(color);
        return this;
    }
    setBlurAll(color) {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].setBlur(color);
        return this;
    }
    writeAll() {
        for(let i = 0; i < this.textnodes.length; i++)this.textnodes[i].writeText();
        return this;
    }
    setStyle(style) {
        if (!this.style) this.style = {};
        for(let key in style){
            this.style[key] = style[key];
            this.container[key] = style[key];
        }
        return this;
    }
    setScreenPosition(scpos) {
        if (scpos.top != undefined) {
            this.container.verticalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_TOP;
            this.container.top = scpos.top + "px";
        } else if (scpos.bottom != undefined) {
            this.container.verticalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_BOTTOM;
            this.container.top = '-' + scpos.bottom + "px";
        }
        if (scpos.left != undefined) {
            this.container.horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT;
            this.container.left = scpos.left + "px";
        } else if (scpos.right != undefined) {
            this.container.horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_RIGHT;
            this.container.left = '-' + scpos.right + "px";
        }
        this.screenposition = scpos;
        return this;
    }
    showAnimate() {
        let h = this.height;
        this.hideAll();
        this.anim.simple(20, (count, perc)=>{
            this.setBackgroundOpacity(1 - 0.5 * perc);
            this.setHeight(perc * h);
        }, ()=>{
            this.setBackgroundOpacity(0.5);
            this.setHeight(h);
            this.showNodesByStep();
        });
        return this;
    }
    showNodesByStep() {
        let speed = 10;
        let formercount = 0;
        let l = this.textnodes.length * speed;
        this.anim.simple(l, (count, perc)=>{
            let newcount = Math.round(count / speed);
            for(let i = formercount; i < newcount; i++){
                this.textnodes[i].show();
                this.textnodes[i].writeText();
            }
            formercount = newcount;
        });
        return this;
    }
    setFullScreen() {
        this.container.width = '100%';
        this.container.height = '100%';
    }
}
class $86ae1c9d39c421df$export$a91abd7c5ed96346 extends $86ae1c9d39c421df$export$8cf279b501ac6d02 {
    constructor(system, scpos, size, container){
        super(system, container);
        if (!container) this.container = new (0, $e843197f5ed510f4$export$5296435ac66bdd7)('');
        system.advancedTexture.addControl(this.container);
        this.setScreenPosition(scpos);
        this.setSize(size);
        this.setStyle({
            zIndex: -10
        });
    }
}
class $86ae1c9d39c421df$export$e289df377c340985 extends $86ae1c9d39c421df$export$8cf279b501ac6d02 {
    constructor(system, scpos, size, style, container){
        super(system, container);
        this.createContainer(system.advancedTexture);
        // this.container = new Rectangle("");
        // advancedTexture.addControl(this.container);
        this.setPosition(scpos);
        this.setSize(size);
        this.setStyle({
            thickness: 0
        });
        if (style) this.setStyle(style);
    }
}
class $86ae1c9d39c421df$export$9ce743a992f74401 extends $86ae1c9d39c421df$export$8cf279b501ac6d02 {
    constructor(system, texture, position, size, style){
        super(system), this.fullopacity = 0.7;
        this.createContainer(texture);
        this.setPosition(position);
        this.setSize(size);
        this.width = size.width;
        this.height = size.height;
        this.style = style;
        this.createElements(style);
        this.hide();
        return this;
    }
    createElements(style) {
        if (style.border) {
            this.bordertop = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: 0,
                y: -this.height / 2
            }, {
                width: this.width,
                border: style.border
            });
            this.borderright = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: this.width / 2,
                y: 0
            }, {
                width: this.height,
                angle: Math.PI / 2,
                border: style.border
            });
            this.borderbottom = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: 0,
                y: this.height / 2
            }, {
                width: this.width,
                border: style.border
            });
            this.borderleft = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: -this.width / 2,
                y: 0
            }, {
                width: this.height,
                angle: Math.PI / 2,
                border: style.border
            });
        } else {
            if (style.bordertop) this.bordertop = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: 0,
                y: -this.height / 2
            }, {
                width: this.width,
                border: style.bordertop
            });
            if (style.borderright) this.borderright = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: this.width / 2,
                y: 0
            }, {
                width: this.height,
                angle: Math.PI / 2,
                border: style.borderright
            });
            if (style.borderbottom) this.borderbottom = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: 0,
                y: this.height / 2
            }, {
                width: this.width,
                border: style.borderbottom
            });
            if (style.borderleft) this.borderleft = new (0, $dfe6dd1db453be64$export$6e0354b00f1275b3)(this.system, this.container, {
                x: -this.width / 2,
                y: 0
            }, {
                width: this.height,
                angle: Math.PI / 2,
                border: style.borderleft
            });
        }
        this.background = new (0, $0b985d791bfcec1b$export$c1904a6c321bc460)(this.system, this.container, {
            x: 0,
            y: 0
        }, {
            width: this.width,
            height: 0,
            opacity: 1
        });
        if (style.background) this.background._setStyle({
            background: style.background
        });
        if (style.bordercolor) this.setBorderColor(style.bordercolor);
        if (style.side) this.setBorderSide(style.side);
    }
    showAnim() {
        if (this.bordertop) this.bordertop.showAnim();
        if (this.borderright) this.borderright.showAnim();
        if (this.borderbottom) this.borderbottom.showAnim();
        if (this.borderleft) this.borderleft.showAnim();
        this.background.setHeight(0);
        this.background.setBackgroundOpacity(1);
        this.show();
        this.anim.simple(20, (cout, perc)=>{
            this.background.setHeight(perc * this.height);
            this.background.setBackgroundOpacity(1 - (1 - this.fullopacity) * perc);
        }, ()=>{
            this.background.setHeight(this.height);
            this.background.setBackgroundOpacity(this.fullopacity);
        });
        return this;
    }
    hideAnim() {
        if (this.bordertop) this.bordertop.hideAnim();
        if (this.borderright) this.borderright.hideAnim();
        if (this.borderbottom) this.borderbottom.hideAnim();
        if (this.borderleft) this.borderleft.hideAnim();
        this.background.setHeight(this.height);
        this.background.setBackgroundOpacity(this.fullopacity);
        this.anim.simple(20, (cout, perc)=>{
            let percinv = 1 - perc;
            this.background.setHeight(percinv * this.height);
            this.background.setBackgroundOpacity(this.fullopacity + (1 - this.fullopacity) * perc);
        }, ()=>{
            this.hide();
        });
        return this;
    }
    setColors(bordercolor, backgroundcolor) {
        this.setBorderColor(bordercolor);
        this.setBackgroundColor(backgroundcolor);
    }
    setBorderColor(bordercolor) {
        if (this.bordertop) this.bordertop.setColor(bordercolor);
        if (this.borderright) this.borderright.setColor(bordercolor);
        if (this.borderbottom) this.borderbottom.setColor(bordercolor);
        if (this.borderleft) this.borderleft.setColor(bordercolor);
    }
    setBorderSide(borderside) {
        if (this.bordertop) this.bordertop.setBorderSide(borderside);
        if (this.borderright) this.borderright.setBorderSide(borderside);
        if (this.borderbottom) this.borderbottom.setBorderSide(borderside);
        if (this.borderleft) this.borderleft.setBorderSide(borderside);
    }
    setBackgroundColor(backgroundcolor) {
        this.background._setStyle({
            background: backgroundcolor
        });
    }
}



class $e47a1a1b66165f1d$export$ce9c5a8b83583162 {
    constructor(system, realPlayer, minimap){
        this.menuTop = -220;
        this.iconSize = 35;
        this.nebulaNumber = 0;
        this.nebulaTop = -110;
        this.starNumber = 0;
        this.animAccuracy = 100;
        this.playerTop = 120;
        this.system = system;
        this.realPlayer = realPlayer;
        this.minimap = minimap;
        this.showAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        this.categoryAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        this.curve = new (0, $005b3f0c7a6c24da$export$682c243b9f175ba2)();
        this.addNebulaChoice();
        this.addStarChoice();
        this.addPlayerLayout();
        this.addStartButton();
        this.addMenu();
        this.hide();
    }
    addMenu() {
        this.menuLayout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: this.menuTop
        }, {
            width: 350,
            height: 200
        }, {
            zIndex: 100
        });
        this.chatIcon = this.menuLayout.addIcon('chat', {
            x: this.iconSize + 30,
            y: 0
        }, {
            fontSize: this.iconSize - 5,
            width: this.iconSize + 10,
            height: this.iconSize + 10
        });
        this.chatIcon.on('click', ()=>{
            window.open('https://discord.gg/dm4fXme3');
        });
        this.twitterIcon = this.menuLayout.addIcon('twitter', {
            x: -(this.iconSize + 30),
            y: 0
        }, {
            fontSize: this.iconSize,
            width: this.iconSize,
            height: this.iconSize
        });
        this.twitterIcon.on('click', ()=>{
            window.open('https://twitter.com/PichouPichou');
        });
        this.menuLayout.addText('In 2025, my son Nova is born. This game is dedicated to him.', {
            x: 0,
            y: -60
        }, {
            fontSize: 20,
            height: 50
        });
    }
    addNebulaChoice() {
        this.nebulaLayout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: this.nebulaTop
        }, {
            width: 300,
            height: 200
        }, {
            zIndex: 100
        });
        this.title = this.nebulaLayout.addText('Select Nebula', {
            x: 0,
            y: -50
        }, {
            fontSize: 20
        });
        let firstNebula = this.system.sky.name;
        this.nebulaText = this.nebulaLayout.addText(firstNebula, {
            x: 0,
            y: 0
        }, {
            fontSize: 25
        });
        this.nebulaArrowRight = this.nebulaLayout.addArrow({
            x: 110,
            y: 0
        }, {
            orientation: 'right'
        });
        this.nebulaArrowLeft = this.nebulaLayout.addArrow({
            x: -110,
            y: 0
        }, {
            orientation: 'left'
        });
        this.nebulaArrowRight.on('click', ()=>{
            this.nebulaNumber++;
            if (this.nebulaNumber == 6) this.nebulaNumber = 0;
            this.checkNebula();
        });
        this.nebulaArrowLeft.on('click', ()=>{
            this.nebulaNumber--;
            if (this.nebulaNumber == -1) this.nebulaNumber = 5;
            this.checkNebula();
        });
    }
    checkNebula() {
        this.system.soundManager.play('nebulaChange');
        this.system.setSky(this.nebulaNumber);
        this.minimap.setBackGroundColor(this.system.skyColor);
        this.nebulaText.writeText(this.system.sky.name, 20);
        this.setColor(this.system.skyColorHex);
    }
    addStarChoice() {
        this.starLayout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: 0
        }, {
            width: 300,
            height: 200
        }, {
            zIndex: 100
        });
        this.starTitle = this.starLayout.addText('Select Sun', {
            x: 0,
            y: -50
        }, {
            fontSize: 20
        });
        this.starText = this.starLayout.addText((0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11)[0].name, {
            x: 0,
            y: 50
        }, {
            fontSize: 20
        });
        this.starArrowRight = this.starLayout.addArrow({
            x: 110,
            y: 0
        }, {
            orientation: 'right'
        });
        this.starArrowLeft = this.starLayout.addArrow({
            x: -110,
            y: 0
        }, {
            orientation: 'left'
        });
        this.starArrowRight.on('click', ()=>{
            this.starNumber++;
            if (this.starNumber == (0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11).length) this.starNumber = 0;
            this.checkStarCategory();
        });
        this.starArrowLeft.on('click', ()=>{
            if (this.starNumber == 0) this.starNumber = (0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11).length;
            this.starNumber--;
            this.checkStarCategory();
        });
    }
    checkStarCategory() {
        this.system.soundManager.play('sunChange');
        let starCategory = (0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11)[this.starNumber];
        this.starText.writeText(starCategory.name, 20);
        this.realPlayer.setCategory(starCategory, true);
        this.animateChange(starCategory);
    }
    animateChange(starCategory) {
        this.categoryAnimation.simple(30, (count, perc)=>{
            let easePerc = this.curve.ease(perc);
            let planetPerc = Math.round(starCategory.planets * easePerc * this.animAccuracy) / this.animAccuracy;
            let velocityPerc = Math.round(starCategory.velocity * easePerc * this.animAccuracy) / this.animAccuracy;
            let gravityPerc = Math.round(starCategory.gravity * easePerc * this.animAccuracy) / this.animAccuracy;
            this.planetText.setText('Planets: ' + planetPerc);
            this.planetBar.setWidth(planetPerc * 20);
            this.velocityText.setText('Velocity: ' + velocityPerc);
            this.velocityBar.setWidth(velocityPerc * 50);
            this.gravityText.setText('Gravity: ' + gravityPerc);
            this.gravityBar.setWidth(gravityPerc * 50);
        });
    }
    addPlayerLayout() {
        this.playerLayout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: this.playerTop
        }, {
            width: 250,
            height: 100
        }, {
            zIndex: 100
        });
        this.planetText = this.playerLayout.addText('', {
            x: 0,
            y: -30
        }, {
            fontSize: 20,
            float: 'left'
        });
        this.planetBar = this.playerLayout.addBack({
            x: 0,
            y: -30
        }, {
            height: 15,
            width: 20,
            float: 'right'
        });
        this.velocityText = this.playerLayout.addText('', {
            x: 0,
            y: 0
        }, {
            fontSize: 20,
            float: 'left'
        });
        this.velocityBar = this.playerLayout.addBack({
            x: 0,
            y: 0
        }, {
            height: 15,
            width: 20,
            float: 'right'
        });
        this.gravityText = this.playerLayout.addText('', {
            x: 0,
            y: 30
        }, {
            fontSize: 20,
            float: 'left'
        });
        this.gravityBar = this.playerLayout.addBack({
            x: 0,
            y: 30
        }, {
            height: 15,
            width: 20,
            float: 'right'
        });
    }
    setColor(color) {
        this.playerLayout.setColorAll(color);
        this.nebulaLayout.setColorAll(color);
        this.starLayout.setColorAll(color);
        this.menuLayout.setColorAll(color);
        this.startOnline.setColors('', color);
        this.startLocal.setColors('', color);
        this.planetBar.setStyle({
            background: color
        });
        this.velocityBar.setStyle({
            background: color
        });
        this.gravityBar.setStyle({
            background: color
        });
    }
    addStartButton() {
        this.startOnline = new (0, $dfe6dd1db453be64$export$2465147a477e412e)(this.system, this.system.advancedTexture, {
            ui: 'text',
            text: 'Play online'
        }, {
            x: -110,
            y: 210
        }, {
            width: 250,
            height: 40
        }, {
            color: '#000',
            fontSize: 20,
            border: 2
        });
        this.startOnline.on('click', ()=>{
            this.onStart('online');
        });
        this.startOnline._setStyle({
            zIndex: 100
        });
        this.startOnline._setStyle({
            zIndex: 100
        });
        this.startLocal = new (0, $dfe6dd1db453be64$export$2465147a477e412e)(this.system, this.system.advancedTexture, {
            ui: 'text',
            text: 'Play'
        }, {
            x: 0,
            y: 210
        }, {
            width: 250,
            height: 40
        }, {
            color: '#000',
            fontSize: 20,
            border: 2
        });
        this.startLocal.on('click', ()=>{
            this.onStart('local');
        });
        this.startLocal._setStyle({
            zIndex: 100
        });
    }
    showLink(show) {
        const link = document.querySelector('.furypage_link');
        link.style.display = show ? 'block' : 'none';
    }
    showAnim(callback) {
        this.showLink(true);
        this.showAnimation.simple(50, (count, perc)=>{
            this.setLayerChangeAnim(1 - perc);
        }, ()=>{
            if (callback) callback();
            this.setLayerChangeAnim(0);
        });
        this.starLayout.showAll();
        this.nebulaLayout.showAll();
        this.playerLayout.showAll();
        this.menuLayout.showAll();
        this.startOnline.hide();
        this.startLocal.show();
        this.realPlayer.setSize(1);
        this.realPlayer.setPosition(new (0, $ha1VO.Vector2)(0, 0));
        let starCategory = (0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11)[this.starNumber];
        this.animateChange(starCategory);
        this.minimap.setBackGroundColor(this.system.skyColor);
    }
    show() {
        this.setLayerChangeAnim(0);
        this.starLayout.showAll();
        this.nebulaLayout.showAll();
        this.playerLayout.showAll();
        this.menuLayout.showAll();
        this.startOnline.hide();
        this.startLocal.show();
        this.realPlayer.setSize(1);
        this.realPlayer.setPosition(new (0, $ha1VO.Vector2)(0, 0));
    }
    hideAnim(callback) {
        this.showLink(false);
        this.starTitle.hide();
        this.startLocal.hide();
        this.showAnimation.simple(50, (count, perc)=>{
            this.setLayerChangeAnim(perc);
        }, ()=>{
            this.setLayerChangeAnim(1);
            this.starLayout.hideAll();
            this.nebulaLayout.hideAll();
            this.playerLayout.hideAll();
            this.menuLayout.hideAll();
            this.startOnline.hide();
            this.startLocal.hide();
            if (callback) callback();
        });
    }
    hide() {
        this.starTitle.hide();
        this.startLocal.hide();
        this.setLayerChangeAnim(1);
        this.starLayout.hideAll();
        this.nebulaLayout.hideAll();
        this.playerLayout.hideAll();
        this.menuLayout.hideAll();
        this.startOnline.hide();
        this.startLocal.hide();
    }
    setLayerChangeAnim(perc) {
        let opacity = 1 - perc;
        let easePerc = this.curve.ease(perc);
        this.starLayout.setOpacity(opacity);
        this.starLayout.setPosition({
            x: 0,
            y: easePerc * 50
        });
        this.nebulaLayout.setOpacity(opacity);
        this.nebulaLayout.setPosition({
            x: 0,
            y: this.nebulaTop - easePerc * 50
        });
        this.menuLayout.setOpacity(opacity);
        this.menuLayout.setPosition({
            x: 0,
            y: this.menuTop - easePerc * 50
        });
        this.playerLayout.setOpacity(opacity);
        this.playerLayout.setPosition({
            x: 0,
            y: this.playerTop + easePerc * 50
        });
        this.startLocal.setOpacity(opacity);
    }
}



var $7efd313040cb9ee6$exports = {};
var $e277a64de4eeade6$exports = {};


var $b613e194c1b157de$exports = {};
var $35fa3296f177aa01$exports = {};
var $34edfba366a0cfa1$exports = {};
var $9f0778b809a8c692$exports = {};
var $e7bbde6376f4568a$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$e7bbde6376f4568a$exports = $e7bbde6376f4568a$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $e7bbde6376f4568a$exports();
$9f0778b809a8c692$exports = $9f0778b809a8c692$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $9f0778b809a8c692$exports(object, iteratee, $08f0eaf3fbcb2fde$exports);
}
$34edfba366a0cfa1$exports = $34edfba366a0cfa1$var$baseForOwn;


var $f03eae3721f9ace8$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$ac2c42592aa05543$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f03eae3721f9ace8$exports = $f03eae3721f9ace8$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $f03eae3721f9ace8$exports($34edfba366a0cfa1$exports);
$35fa3296f177aa01$exports = $35fa3296f177aa01$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $ac2c42592aa05543$exports(collection) ? Array(collection.length) : [];
    $35fa3296f177aa01$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$b613e194c1b157de$exports = $b613e194c1b157de$var$baseMap;


var $6f370ce7a904568e$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$6f370ce7a904568e$exports = $6f370ce7a904568e$var$baseSortBy;



var $b53b4bd61680c3b6$exports = {};
var $13e53edf809f77b7$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $6b5a5095e0934938$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $6b5a5095e0934938$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$13e53edf809f77b7$exports = $13e53edf809f77b7$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $13e53edf809f77b7$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b53b4bd61680c3b6$exports = $b53b4bd61680c3b6$var$compareMultiple;



/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    var index = -1;
    iteratees = $d26d80da1ba3948c$exports(iteratees.length ? iteratees : [
        $37dff9aa04444f9c$exports
    ], $692cb5474f422969$exports($5aba4f6d9f8304a3$exports));
    var result = $b613e194c1b157de$exports(collection, function(value, key, collection) {
        var criteria = $d26d80da1ba3948c$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $6f370ce7a904568e$exports(result, function(object, other) {
        return $b53b4bd61680c3b6$exports(object, other, orders);
    });
}
$e277a64de4eeade6$exports = $e277a64de4eeade6$var$baseOrderBy;



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $7efd313040cb9ee6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$0488fde9aa355453$exports(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$0488fde9aa355453$exports(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $e277a64de4eeade6$exports(collection, iteratees, orders);
}
$7efd313040cb9ee6$exports = $7efd313040cb9ee6$var$orderBy;





parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");


class $8d820c6766ebc00a$export$326e0c340a3cd21c extends (0, $4a26b283e7c333cd$export$2616165974278734) {
    constructor(system, gravityGrid, planetMap){
        super(system, gravityGrid, planetMap, {
            temperature: 5000,
            maxPlanet: 5
        }), this.ia = true, this.level = 1, this.movingAround = false;
        let random = Math.pow(Math.random(), 3);
        let size = (0, $3f53ef2ed5cbbc5e$export$9d2a8399cd1966bf) + random * ((0, $3f53ef2ed5cbbc5e$export$e121b7707a6fdbfa) - (0, $3f53ef2ed5cbbc5e$export$a8496a0d7030de1b));
        this.setSize(size);
    }
    setLevel(level) {
        this.level = 1 - level / 10;
    }
    smart() {
        return Math.random() > this.level;
    }
    checkAction(closestTarget, closestAbsorber) {
        if (this.absorber) {
            if (this.smart()) this.avoidAbsorption(this.absorber, true);
        } else if (this.target) {
            if (this.smart()) this.goToPlayer(this.target);
        } else if (closestTarget && closestAbsorber) {
            let distTarget = (0, $ha1VO.Vector2).Distance(this.position, closestTarget.position);
            let distAbsorber = (0, $ha1VO.Vector2).Distance(this.position, closestAbsorber.position);
            if (distAbsorber > distTarget) {
                if (this.smart()) this.avoidAbsorption(closestAbsorber, false);
            } else if (this.smart()) this.goToPlayer(closestTarget);
            else this.moveAround();
        } else this.moveAround();
    }
    moveAround() {
        if (!this.movingAround) {
            this.movingAround = true;
            let move = new (0, $ha1VO.Vector2)(Math.random() - 0.5, Math.random() - 0.5);
            this.moveCatcher.catch(move);
        }
    }
    avoidAbsorption(absorber, accelerate) {
        this.movingAround = false;
        let direction = this.position.subtract(absorber.position);
        this.moveBit(direction);
        if (accelerate) this.tryAccelerate();
    }
    goToPlayer(player) {
        this.movingAround = false;
        let move = player.position.subtract(this.position);
        this.moveCatcher.catch(move);
        this.tryAccelerate();
    }
    moveBit(move) {
        move.x += Math.random() - 0.5;
        move.y += Math.random() - 0.5;
        this.moveCatcher.catch(move);
    }
    tryAccelerate() {
        if (this.smart() && this.satellites.length && !this.accelerating) this.accelerate();
    }
    dispose() {
        this._disposePlayer();
    }
    showIA() {
        if (this.isStarVisible) return;
        this.show();
    }
    hideIA() {
        if (!this.isStarVisible) return;
        this.hide();
    }
}


const $878359ced16369f2$export$fdaad3aec806b2b4 = 30;
class $878359ced16369f2$export$586eb30124091f7c {
    constructor(system, gravityGrid, tileMap){
        this.planetDensity = 200;
        this.iaLevel = 8;
        this.iaNeeded = (0, $3f53ef2ed5cbbc5e$export$cff7a146e6677ed7) / 5;
        // iaNeeded = 2;
        this.ias = {};
        this.system = system;
        this.gravityGrid = gravityGrid;
        this.tileMap = tileMap;
        setInterval(()=>{
            if (this.tileMap.check) {
                this.checkPlayersAbsorbtion();
                this.checkPlanetRessourceMap();
                this.checkIaMap();
            }
        }, 200);
    }
    checkPlayersAbsorbtion() {
        for(const key in this.tileMap.stars)if (this.tileMap.stars.hasOwnProperty(key)) {
            const player = this.tileMap.stars[key];
            if (player.isStarVisible && !player.isBlackHole) {
                this.checkPlayerAbsorption(player);
                this.checkPlanetMap(player);
                this.checkPlayerSize(player);
                if (player.size < (0, $3f53ef2ed5cbbc5e$export$a8496a0d7030de1b)) this.playerDead(player);
            // if (player.size > MAX_LEVEL) this.playerBlackHole(player);
            }
        }
    }
    playerDead(player) {
        this.tileMap.killPlayer(player);
        if (player.ia) this.removeIa(player);
    }
    playerBlackHole(player) {
        this.tileMap.removeStar(player);
        player.changeToBlackHole(()=>{
            this.tileMap.addBlackHole(player);
        });
    }
    // Burning sun cost in size
    checkPlayerSize(player) {
        player.changeSize(-player.size / 10000);
    }
    checkPlayerAbsorption(player) {
        // let blackHoleTest = this.checkBlackHoleAbsorption(player);
        // if (!blackHoleTest) this.checkStarAbsorption(player);
        this.checkStarAbsorption(player);
    }
    checkBlackHoleAbsorption(player) {
        let blackHoleTest = '';
        let minDist = 1000000;
        let minBlackHoleField = 1;
        for(const key in this.tileMap.blackHoles){
            const blackHole = this.tileMap.blackHoles[key];
            let blackHoleField = blackHole.gravityField;
            let dist = (0, $ha1VO.Vector2).Distance(blackHole.position, player.position);
            if (dist < blackHoleField) {
                if (minDist > dist) {
                    minDist = dist;
                    minBlackHoleField = blackHoleField;
                    blackHoleTest = blackHole.key;
                }
            }
        }
        if (blackHoleTest) {
            let blackHole = this.tileMap.blackHoles[blackHoleTest];
            player.absorbByBlackHole(blackHole, minDist);
            player.setAbsorber(blackHole, minDist / minBlackHoleField);
            return true;
        } else if (player.blackHoleAbsorber) player.absorbStop();
        return false;
    }
    checkStarAbsorption(player) {
        let closestTarget;
        let closestAbsorber;
        let minTargetDist = 1000000;
        let minAbsorberDist = 1000000;
        let testTarget = '';
        let playerGravityField = player.gravityField;
        for(const key in this.tileMap.stars){
            const otherplayer = this.tileMap.stars[key];
            if (otherplayer.isStarVisible && otherplayer.key != player.key) {
                let dist = (0, $ha1VO.Vector2).Distance(player.position, otherplayer.position);
                dist /= 1.5; // To make absorb from further possible
                if (player.size > otherplayer.size) {
                    if (minTargetDist > dist) {
                        minTargetDist = dist;
                        closestTarget = otherplayer;
                        if (dist < playerGravityField) testTarget = otherplayer.key;
                    }
                } else if (minAbsorberDist > dist) {
                    minAbsorberDist = dist;
                    closestAbsorber = otherplayer;
                }
            }
        }
        if (player.ia) player.checkAction(closestTarget, closestAbsorber);
        if (testTarget) {
            player.absorbTarget(closestTarget, minTargetDist);
            closestTarget.setAbsorber(player, minTargetDist / playerGravityField);
            return true;
        } else {
            player.absorbStop();
            return false;
        }
    }
    checkPlanetRessourceMap() {
        for(const key in this.tileMap.planets){
            const planet = this.tileMap.planets[key];
            let dist = (0, $ha1VO.Vector2).Distance(planet.position, this.system.center);
            if (dist > this.planetDensity) {
                planet.hide();
                this.tileMap.storagePlanet(planet);
            }
        }
        let newPlanetAvailable = this.tileMap.planetsStorage.length;
        for(let i = 0; i < newPlanetAvailable; i++)this.addNewPlanet();
    }
    checkPlanetMap(player) {
        // add planet while accelerating create bug with planet
        if (player.accelerating) return;
        if (Object.keys(player.satellites).length < player.maxPlanet) for(const key in this.tileMap.planets){
            const planet = this.tileMap.planets[key];
            // New check maxPlanet because in the loop it can change
            if (Object.keys(player.satellites).length < player.maxPlanet) {
                let dist = (0, $ha1VO.Vector2).Distance(planet.position, player.position);
                if (dist < player.gravityField) {
                    this.tileMap.setPlanetWithStar(planet);
                    player.addPlanet(planet);
                }
            }
        }
    }
    addNewPlanet() {
        let newPlanet = this.tileMap.addPlanet();
        let pos = this.getFreePosition(10, 50, 50);
        newPlanet.setPosition(pos);
        return newPlanet;
    }
    setIaLevel(level) {
        this.iaLevel = level;
    }
    checkIaMap() {
        let newIaNeeded = Math.round(this.iaNeeded - Object.keys(this.ias).length);
        for(let i = 0; i < newIaNeeded; i++)this.createIa();
        for(const key in this.ias){
            const ia = this.ias[key];
            if (ia.isStarOnScreen()) ia.showIA();
            else ia.hideIA();
            if (!ia.isStarOnMap()) {
                ia.dispose();
                this.removeIa(ia);
            }
        }
    }
    getRandomCategory() {
        let l = (0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11).length;
        let alea = Math.round(Math.random() * l - 0.5);
        return (0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11)[alea];
    }
    createIa() {
        let newIa = new (0, $8d820c6766ebc00a$export$326e0c340a3cd21c)(this.system, this.gravityGrid, this.tileMap);
        let pos = this.getFreePosition((0, $3f53ef2ed5cbbc5e$export$cff7a146e6677ed7) / 2, 25, 5);
        newIa.setPosition(pos);
        let cat = this.getRandomCategory();
        newIa.setCategory(cat, false);
        newIa.setLevel(this.iaLevel);
        this.addIa(newIa);
    }
    addIa(ia) {
        this.ias[ia.key] = ia;
        this.tileMap.addStar(ia);
    }
    removeIa(ia) {
        this.tileMap.removeStar(ia);
        ia.absorbStop();
        if (ia.target) ia.target.absorbStop();
        delete this.ias[ia.key];
    }
    getFreePosition(gap, close, step) {
        let test = true;
        let distProgress = gap;
        while(test){
            let pos = this.tileMap.getNewRandomPositionFromCenter(this.system.center, distProgress, distProgress);
            let distTest = true;
            for(const key in this.tileMap.stars){
                let player = this.tileMap.stars[key];
                let dist = (0, $ha1VO.Vector2).Distance(pos, player.position);
                if (dist < close) distTest = false;
            }
            if (distTest) {
                test = false;
                return pos;
            }
            distProgress += step;
        }
        return new (0, $ha1VO.Vector2)(0, 0);
    }
    eraseAllIas() {
        for(const key in this.ias){
            this.ias[key].dispose();
            this.removeIa(this.ias[key]);
        }
        this.ias = {};
    }
}



var $e0Suo = parcelRequire("e0Suo");



var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $2e3808b86a8847c0$export$80b0269ab108fa11 extends (0, $a86b55aad2faeec0$export$42a852a2b6b56249) {
    /** Gets or sets border thickness */ get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        if (this._thickness === value) return;
        this._thickness = value;
        this._markAsDirty();
    }
    /** Gets or sets arcing of the ellipse (ratio of the circumference between 0 and 1) */ get arc() {
        return this._arc;
    }
    set arc(value) {
        if (this._arc === value) return;
        this._arc = value;
        this._markAsDirty();
    }
    /**
     * Creates a new Ellipse
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._thickness = 1;
        this._arc = 1;
    }
    _getTypeName() {
        return "Ellipse";
    }
    _localDraw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        (0, $b6009490051f50fb$export$7a7fa4424cb20976).drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, this._currentMeasure.width / 2 - this._thickness / 2, this._currentMeasure.height / 2 - this._thickness / 2, this._arc, context);
        if (this._backgroundGradient || this._background) {
            context.fillStyle = this._getBackgroundColor(context);
            context.fill();
        }
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
        if (this._thickness) {
            if (this.color) context.strokeStyle = this.color;
            context.lineWidth = this._thickness;
            context.stroke();
        }
        context.restore();
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.width -= 2 * this._thickness;
        this._measureForChildren.height -= 2 * this._thickness;
        this._measureForChildren.left += this._thickness;
        this._measureForChildren.top += this._thickness;
    }
    _clipForChildren(context) {
        (0, $b6009490051f50fb$export$7a7fa4424cb20976).drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, this._currentMeasure.width / 2, this._currentMeasure.height / 2, this._arc, context);
        context.clip();
    }
    _renderHighlightSpecific(context) {
        (0, $b6009490051f50fb$export$7a7fa4424cb20976).drawEllipse(this._currentMeasure.left + this._currentMeasure.width / 2, this._currentMeasure.top + this._currentMeasure.height / 2, this._currentMeasure.width / 2 - this._highlightLineWidth / 2, this._currentMeasure.height / 2 - this._highlightLineWidth / 2, this._arc, context);
        context.stroke();
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2e3808b86a8847c0$export$80b0269ab108fa11.prototype, "thickness", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2e3808b86a8847c0$export$80b0269ab108fa11.prototype, "arc", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Ellipse", $2e3808b86a8847c0$export$80b0269ab108fa11);



var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");



var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $3f6c395ecb4154b5$export$17d680238e50603e extends (0, $b6009490051f50fb$export$7a7fa4424cb20976) {
    /** Gets or sets the dash pattern */ get dash() {
        return this._dash;
    }
    set dash(value) {
        if (this._dash === value) return;
        this._dash = value;
        this._markAsDirty();
    }
    /** Gets or sets the control connected with the line end */ get connectedControl() {
        return this._connectedControl;
    }
    set connectedControl(value) {
        if (this._connectedControl === value) return;
        if (this._connectedControlDirtyObserver && this._connectedControl) {
            this._connectedControl.onDirtyObservable.remove(this._connectedControlDirtyObserver);
            this._connectedControlDirtyObserver = null;
        }
        if (value) this._connectedControlDirtyObserver = value.onDirtyObservable.add(()=>this._markAsDirty());
        this._connectedControl = value;
        this._markAsDirty();
    }
    /** Gets or sets start coordinates on X axis */ get x1() {
        return this._x1.toString(this._host);
    }
    set x1(value) {
        if (this._x1.toString(this._host) === value) return;
        if (this._x1.fromString(value)) this._markAsDirty();
    }
    /** Gets or sets start coordinates on Y axis */ get y1() {
        return this._y1.toString(this._host);
    }
    set y1(value) {
        if (this._y1.toString(this._host) === value) return;
        if (this._y1.fromString(value)) this._markAsDirty();
    }
    /** Gets or sets end coordinates on X axis */ get x2() {
        return this._x2.toString(this._host);
    }
    set x2(value) {
        if (this._x2.toString(this._host) === value) return;
        if (this._x2.fromString(value)) this._markAsDirty();
    }
    /** Gets or sets end coordinates on Y axis */ get y2() {
        return this._y2.toString(this._host);
    }
    set y2(value) {
        if (this._y2.toString(this._host) === value) return;
        if (this._y2.fromString(value)) this._markAsDirty();
    }
    /** Gets or sets line width */ get lineWidth() {
        return this._lineWidth;
    }
    set lineWidth(value) {
        if (this._lineWidth === value) return;
        this._lineWidth = value;
        this._markAsDirty();
    }
    /** Gets or sets horizontal alignment */ set horizontalAlignment(value) {
        return;
    }
    /** Gets or sets vertical alignment */ set verticalAlignment(value) {
        return;
    }
    /** @internal */ get _effectiveX2() {
        return (this._connectedControl ? this._connectedControl.centerX : 0) + this._x2.getValue(this._host);
    }
    /** @internal */ get _effectiveY2() {
        return (this._connectedControl ? this._connectedControl.centerY : 0) + this._y2.getValue(this._host);
    }
    /**
     * Creates a new Line
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._lineWidth = 1;
        /** @internal */ this._x1 = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        /** @internal */ this._y1 = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        /** @internal */ this._x2 = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        /** @internal */ this._y2 = new (0, $a038095510e5ba9b$export$839f347a6ebe19f5)(0);
        this._dash = new Array();
        this._automaticSize = true;
        this.isHitTestVisible = false;
        this._horizontalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).HORIZONTAL_ALIGNMENT_LEFT;
        this._verticalAlignment = (0, $b6009490051f50fb$export$7a7fa4424cb20976).VERTICAL_ALIGNMENT_TOP;
    }
    _getTypeName() {
        return "Line";
    }
    _draw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        this._applyStates(context);
        context.strokeStyle = this._getColor(context);
        context.lineWidth = this._lineWidth;
        context.setLineDash(this._dash);
        context.beginPath();
        context.moveTo(this._cachedParentMeasure.left + this._x1.getValue(this._host), this._cachedParentMeasure.top + this._y1.getValue(this._host));
        context.lineTo(this._cachedParentMeasure.left + this._effectiveX2, this._cachedParentMeasure.top + this._effectiveY2);
        context.stroke();
        context.restore();
    }
    _measure() {
        // Width / Height
        this._currentMeasure.width = Math.abs(this._x1.getValue(this._host) - this._effectiveX2) + this._lineWidth;
        this._currentMeasure.height = Math.abs(this._y1.getValue(this._host) - this._effectiveY2) + this._lineWidth;
    }
    _computeAlignment(parentMeasure) {
        this._currentMeasure.left = parentMeasure.left + Math.min(this._x1.getValue(this._host), this._effectiveX2) - this._lineWidth / 2;
        this._currentMeasure.top = parentMeasure.top + Math.min(this._y1.getValue(this._host), this._effectiveY2) - this._lineWidth / 2;
    }
    /**
     * Move one end of the line given 3D cartesian coordinates.
     * @param position Targeted world position
     * @param scene Scene
     * @param end (opt) Set to true to assign x2 and y2 coordinates of the line. Default assign to x1 and y1.
     */ moveToVector3(position, scene, end = false) {
        if (!this._host || this.parent !== this._host._rootContainer) {
            (0, $bOhSV.Tools).Error("Cannot move a control to a vector3 if the control is not at root level");
            return;
        }
        const globalViewport = this._host._getGlobalViewport();
        const projectedPosition = (0, $ha1VO.Vector3).Project(position, (0, $ha1VO.Matrix).IdentityReadOnly, scene.getTransformMatrix(), globalViewport);
        this._moveToProjectedPosition(projectedPosition, end);
        if (projectedPosition.z < 0 || projectedPosition.z > 1) {
            this.notRenderable = true;
            return;
        }
        this.notRenderable = false;
    }
    /**
     * Move one end of the line to a position in screen absolute space.
     * @param projectedPosition Position in screen absolute space (X, Y)
     * @param end (opt) Set to true to assign x2 and y2 coordinates of the line. Default assign to x1 and y1.
     */ _moveToProjectedPosition(projectedPosition, end = false) {
        const x = projectedPosition.x + this._linkOffsetX.getValue(this._host) + "px";
        const y = projectedPosition.y + this._linkOffsetY.getValue(this._host) + "px";
        if (end) {
            this.x2 = x;
            this.y2 = y;
            this._x2.ignoreAdaptiveScaling = true;
            this._y2.ignoreAdaptiveScaling = true;
        } else {
            this.x1 = x;
            this.y1 = y;
            this._x1.ignoreAdaptiveScaling = true;
            this._y1.ignoreAdaptiveScaling = true;
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3f6c395ecb4154b5$export$17d680238e50603e.prototype, "dash", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3f6c395ecb4154b5$export$17d680238e50603e.prototype, "x1", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3f6c395ecb4154b5$export$17d680238e50603e.prototype, "y1", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3f6c395ecb4154b5$export$17d680238e50603e.prototype, "x2", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3f6c395ecb4154b5$export$17d680238e50603e.prototype, "y2", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3f6c395ecb4154b5$export$17d680238e50603e.prototype, "lineWidth", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Line", $3f6c395ecb4154b5$export$17d680238e50603e);


parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");



class $5b40890e52232d51$export$fa1db6ca25356969 {
    constructor(system, realPlayer, tileMap){
        this.screenMargin = 10;
        this.iconNumber = (0, $3f53ef2ed5cbbc5e$export$cff7a146e6677ed7) / 2;
        this.storageIcons = [];
        this.iconSize = 5;
        this.limitSize = 100;
        this.hLines = [];
        this.vLines = [];
        this.mR = 1;
        this.playersIcons = {};
        this.otherPlayerColor = new (0, $7etnY.Color4)(0.7, 0.7, 0.7, 1);
        this.system = system;
        this.realPlayer = realPlayer;
        this.tileMap = tileMap;
        this.addContainer();
        // this.addGridLines();
        this.createAllIcons();
        this.addRealPlayerIcon();
    }
    createAllIcons() {
        for(let i = 0; i < this.iconNumber; i++){
            let icon = new (0, $0b985d791bfcec1b$export$4b50f340f3e0e69a)(this.system);
            icon.container = this.createPlayerIcon(this.otherPlayerColor);
            this.hideIcon(icon);
        }
    }
    createPlayerIcon(color) {
        let plIcon = new (0, $2e3808b86a8847c0$export$80b0269ab108fa11)();
        plIcon.width = this.iconSize + 'px';
        plIcon.height = this.iconSize + 'px';
        plIcon.thickness = 0;
        // plIcon.background = 'white';
        plIcon.background = 'rgb(' + color.r * 255 + ', ' + color.g * 255 + ', ' + color.b * 255 + ')';
        return plIcon;
    }
    addContainer() {
        this.limit = new (0, $2e3808b86a8847c0$export$80b0269ab108fa11)();
        this.limit.width = 2 * this.limitSize + 'px';
        this.limit.height = 2 * this.limitSize + 'px';
        this.limit.thickness = 1;
        this.minimapLayout = new (0, $86ae1c9d39c421df$export$a91abd7c5ed96346)(this.system, {
            right: this.screenMargin,
            bottom: this.screenMargin
        }, {
            width: 200,
            height: 200
        }, this.limit);
    }
    addGridLines() {
        for(let i = 0; i < 1; i++){
            let line = this.getLine();
            this.hLines.push(line);
        }
    }
    getLine() {
        let line = new (0, $3f6c395ecb4154b5$export$17d680238e50603e)();
        line.lineWidth = 5;
        line.x1 = -10;
        line.y1 = 10;
        line.x2 = 10;
        line.y2 = -10;
        line.color = 'rgba(255, 255, 255, 1)';
        this.limit.addControl(line);
        return line;
    }
    setBackGroundColor(color) {
        this.limit.background = 'rgb(' + color.r * 255 + ', ' + color.g * 255 + ', ' + color.b * 255 + ')';
    }
    getIconPosition(player) {
        let rP = this.realPlayer.position;
        let pos = {
            y: (player.position.x - rP.x) * this.mR,
            x: (player.position.y - rP.y) * this.mR
        };
        let ratio = Math.abs(pos.x / pos.y);
        let maxX = Math.sqrt(Math.pow(this.limitSize - 2, 2) * ratio / (ratio + 1));
        let maxY = Math.sqrt(Math.pow(this.limitSize - 2, 2) / (ratio + 1));
        let x = Math.sign(pos.x) * Math.min(Math.abs(pos.x), maxX);
        let y = Math.sign(pos.y) * Math.min(Math.abs(pos.y), maxY);
        return {
            x: x,
            y: y
        };
    }
    getFreeIcon() {
        let newIcon = this.storageIcons.pop();
        if (newIcon) {
            this.limit.addControl(newIcon.container);
            return newIcon;
        }
    }
    hideIcon(icon) {
        this.limit.removeControl(icon.container);
        this.storageIcons.push(icon);
    }
    checkMap() {
        for(const key in this.tileMap.stars)if (this.tileMap.stars.hasOwnProperty(key)) {
            const player = this.tileMap.stars[key];
            if (!this.playersIcons[key]) this.playersIcons[key] = this.getFreeIcon();
            if (key != this.realPlayer.key) {
                let pos = this.getIconPosition(player);
                this.playersIcons[key].setPosition(pos);
            // let size = Math.pow(player.size * 2, 2);
            // this.playersIcons[key].setSize({ width: size, height: size}); 
            }
        }
        for(const key in this.playersIcons)if (this.playersIcons.hasOwnProperty(key)) {
            const icon = this.playersIcons[key];
            if (!this.tileMap.stars.hasOwnProperty(key)) {
                this.hideIcon(icon);
                delete this.playersIcons[key];
            }
        }
    // let pl = this.realPlayer;
    // let size = Math.pow(pl.size * 2, 2);
    // this.playersIcons[pl.key].setSize({ width: size, height: size }); 
    }
    hideAllIcon() {
        for(const key in this.playersIcons)if (this.playersIcons.hasOwnProperty(key)) {
            const icon = this.playersIcons[key];
            this.hideIcon(icon);
            delete this.playersIcons[key];
        }
    }
    setRealPlayerColor() {
        let c = this.realPlayer.color;
        this.realPlayerIcon.container.background = 'rgb(' + c.r * 255 + ', ' + c.g * 255 + ', ' + c.b * 255 + ')';
    }
    addRealPlayerIcon() {
        let pl = this.realPlayer;
        this.realPlayerIcon = new (0, $0b985d791bfcec1b$export$4b50f340f3e0e69a)(this.system);
        this.realPlayerIcon.container = this.createPlayerIcon(pl.color);
        this.realPlayerIcon.container.width = this.iconSize + 3 + 'px';
        this.realPlayerIcon.container.height = this.iconSize + 3 + 'px';
        this.realPlayerIcon.container.zIndex = 10;
        this.limit.addControl(this.realPlayerIcon.container);
    }
}


class $05a2f3fa102a7599$export$700b77f60799a574 extends (0, $5b40890e52232d51$export$fa1db6ca25356969) {
    constructor(system, realPlayer, tileMap){
        super(system, realPlayer, tileMap), this.fontSize = 20, this.width = 200, this.totalPlayers = 500, this.currentWidth = 0, this.currentSize = 0;
        this.system = system;
        this.realPlayer = realPlayer;
        this.tileMap = tileMap;
        this.showAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        this.shineAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        this.checkAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        this.curve = new (0, $005b3f0c7a6c24da$export$682c243b9f175ba2)();
        this.addPlayerStat();
        this.addSupernovaLayer();
        // this.addPlayerList();
        this.hide();
    }
    addPlayerStat() {
        this.statLayout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: 0
        }, {
            width: this.width,
            height: 60
        });
        this.statLayout.setScreenPosition({
            left: this.screenMargin,
            bottom: this.screenMargin
        });
        this.statLayout.addBack({
            x: 0,
            y: 30
        }, {
            width: this.width,
            height: 20,
            float: 'left',
            opacity: 0.3
        });
        this.sizeProgress = this.statLayout.addBack({
            x: 0,
            y: 15
        }, {
            width: this.width,
            height: 20,
            float: 'left'
        });
        this.sizeText = this.statLayout.addText('Level: 2', {
            x: 0,
            y: -15
        }, {
            fontSize: this.fontSize,
            height: 60,
            float: 'left'
        });
        this.sizeText.setBackgroundOpacity(0);
    // this.rankText = this.statLayout.addText('Rank: 5/100', { x: 0, y: -30 }, { fontSize: this.fontSize, float: 'left' });
    }
    addPlayerList() {
        this.listLayout = new (0, $86ae1c9d39c421df$export$a91abd7c5ed96346)(this.system, {
            top: this.screenMargin,
            right: this.screenMargin
        }, {
            width: 250,
            height: 200
        });
        this.listLayout.addText('Winners', {
            x: 0,
            y: -100
        }, {
            fontSize: this.fontSize
        });
        this.player1 = this.listLayout.addText('', {
            x: 0,
            y: 60
        }, {
            fontSize: this.fontSize,
            float: 'left'
        });
        this.player2 = this.listLayout.addText('', {
            x: 0,
            y: 80
        }, {
            fontSize: this.fontSize,
            float: 'left'
        });
        this.player3 = this.listLayout.addText('', {
            x: 0,
            y: 100
        }, {
            fontSize: this.fontSize,
            float: 'left'
        });
        this.player4 = this.listLayout.addText('', {
            x: 0,
            y: 120
        }, {
            fontSize: this.fontSize,
            float: 'left'
        });
        this.player5 = this.listLayout.addText('', {
            x: 0,
            y: 140
        }, {
            fontSize: this.fontSize,
            float: 'left'
        });
    }
    addSupernovaLayer() {
        this.supernovaLayout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: '-45%'
        }, {
            width: '100%',
            height: '10%'
        }, {});
        this.supernovaText = this.supernovaLayout.addText('1 level before supernova', {
            x: 0,
            y: 0
        }, {
            fontSize: this.fontSize + 10
        });
        this.supernovaLayout.hide();
    }
    getRanks() {
        let playerArray = [];
        for(const key in this.tileMap.stars)if (this.tileMap.stars.hasOwnProperty(key)) {
            const player = this.tileMap.stars[key];
            playerArray.push(player);
        }
        let ranks = (0, (/*@__PURE__*/$parcel$interopDefault($7efd313040cb9ee6$exports)))(playerArray, [
            'size'
        ], [
            'desc'
        ]);
        return ranks;
    }
    checkRanks() {
        // let ranks = this.getRanks();
        // let playerIndex = ranks.indexOf(this.realPlayer) + 1;
        // let perc = playerIndex/ranks.length;
        // let fakePlayerIndex = Math.round(perc * this.totalPlayers)
        let perc = (this.realPlayer.size - (0, $3f53ef2ed5cbbc5e$export$a8496a0d7030de1b)) / ((0, $3f53ef2ed5cbbc5e$export$e121b7707a6fdbfa) - (0, $3f53ef2ed5cbbc5e$export$a8496a0d7030de1b));
        // perc = Math.pow(perc, 0.8);
        let fakePlayerIndex = Math.round((1 - perc) * this.totalPlayers);
        this.rankText.setText('Your rank: ' + fakePlayerIndex + '/' + this.totalPlayers);
    }
    getPlayerSize() {
        let plSize = this.realPlayer.size;
        const playerGap = Math.max(plSize - (0, $3f53ef2ed5cbbc5e$export$a8496a0d7030de1b), 0);
        // const maxGap = maxSize - minSize;
        // const playerProg = playerGap / maxGap;
        // return playerProg * MAX_LEVEL;
        return playerGap * 10;
    }
    checkPlayerSize() {
        let sizeAdjusted = this.getPlayerSize();
        let playerSize = Math.floor(sizeAdjusted);
        this.sizeText.setText('Level: ' + playerSize.toString());
        let width = Math.round((sizeAdjusted - playerSize) * this.width);
        if (width != this.currentWidth) {
            this.sizeProgress.setWidth(width);
            this.currentWidth = width;
        }
        if (playerSize != this.currentSize) {
            this.shinePlayerSize();
            if (playerSize > this.currentSize) // this.system.soundManager.play('levelUp');
            // > 5 to avoid showing at the beginning
            {
                if (playerSize > 5 && Math.round(playerSize / 5) == playerSize / 5) this.showLevelBeforeSupernova((0, $878359ced16369f2$export$fdaad3aec806b2b4) - playerSize);
            }
            this.sizeProgress.setWidth(width);
            this.currentSize = playerSize;
        }
    }
    shinePlayerSize() {
        this.shineAnimation.simple(50, (count, perc)=>{
            let easePerc = this.curve.ease(perc);
            let opacity = Math.min(easePerc, 1 - easePerc) * 2;
            this.sizeText.setBackgroundOpacity(opacity);
        }, ()=>{
            this.sizeText.setBackgroundOpacity(0);
        });
    }
    showLevelBeforeSupernova(level) {
        var count, perc;
        return;
    }
    setColor(color) {
        this.supernovaLayout.setColorAll(color);
        this.statLayout.setColorAll(color);
        // this.listLayout.setColorAll(color);
        this.sizeProgress.setColor(color);
        this.sizeProgress.setStyle({
            background: color
        });
        this.sizeText.setStyle({
            background: color
        });
    }
    show() {
        // this.listLayout.show();
        this.statLayout.show();
        // this.minimapLayout.show();
        this.setRealPlayerColor();
        this.totalPlayers = Math.round(Math.random() * 50 + 450);
        let sizeAdjusted = this.getPlayerSize();
        this.currentSize = Math.floor(sizeAdjusted);
        this.setColor(this.system.skyColorHex);
        this.shinePlayerSize();
        this.checkAnimation.interval(200, (count, perc)=>{
            if (!this.realPlayer.isBlackHole) // this.checkRanks();
            this.checkPlayerSize();
            else this.statLayout.hide();
        });
    }
    hideAnim(callback) {
        this.checkAnimation.stop();
        this.setLayerChangeAnim(0);
        this.showAnimation.simple(50, (count, perc)=>{
            this.setLayerChangeAnim(perc);
        }, ()=>{
            this.setLayerChangeAnim(1);
            // this.minimapLayout.hideAll();
            this.statLayout.hideAll();
            // this.listLayout.hideAll();
            this.hide();
            if (callback) callback();
        });
    }
    hide() {
        this.checkAnimation.stop();
        // this.listLayout.hide();
        this.statLayout.hide();
        this.minimapLayout.hide();
        this.hideAllIcon();
    }
    showAnim(callback) {
        this.setLayerChangeAnim(1);
        this.show();
        this.showAnimation.simple(50, (count, perc)=>{
            this.setLayerChangeAnim(1 - perc);
        }, ()=>{
            if (callback) callback();
            this.setLayerChangeAnim(0);
        });
        this.minimapLayout.showAll();
        this.statLayout.showAll();
    // this.listLayout.showAll();
    }
    setLayerChangeAnim(perc) {
        let opacity = 1 - perc;
        let easePerc = this.curve.ease(perc);
        this.minimapLayout.setOpacity(opacity);
        this.minimapLayout.setScreenPosition({
            right: easePerc * 100 + this.screenMargin,
            bottom: this.screenMargin
        });
        this.statLayout.setOpacity(opacity);
        this.statLayout.setScreenPosition({
            left: easePerc * 100 + this.screenMargin,
            bottom: this.screenMargin
        });
    // this.listLayout.setOpacity(opacity);
    // this.listLayout.setScreenPosition({ right: easePerc * 100 + this.screenMargin, top: this.screenMargin });
    }
}



parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");


var $e645fa20844da7aa$exports = {};

var $77836f185896e906$exports = {};

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $77836f185896e906$var$baseFilter(collection, predicate) {
    var result = [];
    $35fa3296f177aa01$exports(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
$77836f185896e906$exports = $77836f185896e906$var$baseFilter;




/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */ function $e645fa20844da7aa$var$filter(collection, predicate) {
    var func = $0488fde9aa355453$exports(collection) ? $6549fed720324048$exports : $77836f185896e906$exports;
    return func(collection, $5aba4f6d9f8304a3$exports(predicate, 3));
}
$e645fa20844da7aa$exports = $e645fa20844da7aa$var$filter;



parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");



class $3adbcb4ac8740d9f$export$c66cf5195eb26104 extends (0, $854be06c1a29939d$export$39459471b3952c34) {
    constructor(system){
        super('dust', system), this.fixeAnimationLength = 40;
        this.animation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.system.animationManager);
        this.addMesh();
        this.curve = new (0, $005b3f0c7a6c24da$export$b9f6da40882c34cc)();
    }
    addMesh() {
        this.mesh = this.system.dustMesh.createInstance(this.key + "duststar");
        this.mesh.alwaysSelectAsActiveMesh = true;
        this.mesh.doNotSyncBoundingInfo = true;
        this.mesh.parent = this.transformMesh;
        this.setSize(0);
        this.hide();
    }
    oscillate() {
        let random = Math.random() * 10;
        this.animation.infinite((count, perc)=>{
            let cossin = new (0, $ha1VO.Vector2)(Math.cos(random + count / 100) / 100, Math.sin(random + count / 100) / 100);
            let newPos = this.position.add(cossin);
            this.setPosition(newPos);
        });
    }
    goToEntity(entity, callback) {
        this.animation.simple(this.fixeAnimationLength / 2, (count, perc)=>{
            let progress = this.curve.ease(perc);
            let sizeProgress = this.size * (1 - progress / 2);
            this.setTransformMeshSize(sizeProgress);
            let change = entity.position.subtract(this.position);
            // let changePos = change.multiply(new Vector2(step, step));
            let changePos = change.multiply(new (0, $ha1VO.Vector2)(progress, progress));
            let newPos = this.position.add(changePos);
            this.setPosition(newPos);
        }, ()=>{
            this.hide();
            if (callback) callback();
        });
    }
    show() {
        // this.mesh.isVisible = true;
        let size = 0.04 + Math.random() * 0.4;
        this.animation.simple(50, (count, perc)=>{
            this.setSize(perc * size);
        }, ()=>{
            this.setSize(size);
            this.oscillate();
        });
    }
    hide() {
        this.setSize(0);
    // this.mesh.isVisible = false;
    }
}


class $ee817e51f3e1169c$export$4ff51264f861fc14 {
    constructor(system){
        ////////// DUST
        this.dustNumbers = 200;
        this.dustsStorage = [];
        this.dusts = [];
        ////////// UPPER DUST
        this.upperDustNumbers = 50;
        this.upperDusts = [];
        this.upDist = 100;
        /////////// CHECK FUNCTIONS 
        this.dustDensity = 100;
        this.sizeDustRatio = 5;
        this.mapSize = 200;
        this.system = system;
        this.createAllDusts();
    // this.createAllUpperDusts();
    }
    createAllDusts() {
        for(let i = 0; i < this.dustNumbers; i++){
            let dust = new (0, $3adbcb4ac8740d9f$export$c66cf5195eb26104)(this.system);
            this.dustsStorage.push(dust);
        }
    }
    addDust(size) {
        let dustSize = size ? size : 0.01;
        if (this.dustsStorage.length != 0) {
            let dust = this.dustsStorage.pop();
            dust.setSize(dustSize);
            dust.show();
            if (this.dusts.indexOf(dust) == -1) this.dusts.push(dust);
            return dust;
        }
        return false;
    }
    addDustField(position) {
        let dustNumber = 50;
        for(let i = 0; i < dustNumber; i++){
            let newDust = this.addDust(0.03);
            if (newDust) {
                let pos = this.getNewRandomPositionFromCenter(position, 20, 0);
                newDust.setPosition(pos);
            }
        }
    }
    removeDust(dust) {
        let removeDust = (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.dusts, (p)=>{
            return dust.key == p.key;
        });
    }
    storageDust(dust) {
        dust.hide();
        dust.animation.stop();
        if (this.dustsStorage.indexOf(dust) == -1) this.dustsStorage.push(dust);
    }
    eraseAllDusts() {
        for(let i = 0; i < this.dusts.length; i++)this.storageDust(this.dusts[i]);
        this.dusts = [];
    }
    createAllUpperDusts() {
        for(let i = 0; i < this.upperDustNumbers; i++){
            let upperDust = this.system.upperDustMesh.createInstance('');
            upperDust.alwaysSelectAsActiveMesh = true;
            upperDust.doNotSyncBoundingInfo = true;
            upperDust.position.x = (Math.random() - 0.5) * this.upDist;
            upperDust.position.z = (Math.random() - 0.5) * this.upDist;
            upperDust.position.y = (Math.random() - 0.5) * 15 + 50;
            // upperDust.startPosition = upperDust.position.clone();
            this.upperDusts.push(upperDust);
        }
    // Tried to make shooting stars
    // let j = 0;
    // this.system.scene.registerBeforeRender(() => {
    //     for (let i = 0; i < this.upperDusts.length; i++) {
    //         let upperDust = this.upperDusts[i];
    //         upperDust.position.x = upperDust.startPosition.x + j * 1;
    //         upperDust.position.z = upperDust.startPosition.z + j * 1;
    //     }
    //     j++;
    //     if (j == 100) {console.log(0);
    //      j = 0;}
    // });
    }
    checkDustMap() {
        let c = this.system.center;
        let s = this.system.size;
        for(let i = 0; i < this.dusts.length; i++){
            const dust = this.dusts[i];
            let dist = (0, $ha1VO.Vector2).Distance(dust.position, c);
            if (dist > Math.sqrt(s) * this.sizeDustRatio * 15) {
                this.removeDust(dust);
                this.storageDust(dust);
            }
        }
        let newDustNeeded = Math.round(s * this.dustDensity - this.dusts.length);
        for(let i = 0; i < newDustNeeded; i++){
            let newDust = this.addDust();
            if (newDust) {
                let pos = this.getNewDustRandomPosition();
                newDust.setPosition(pos);
            }
        }
    }
    checkUpperDustMap() {
        let c = this.system.center;
        let checkDist = this.upDist / 2;
        for(let i = 0; i < this.upperDusts.length; i++){
            const upperDust = this.upperDusts[i];
            let p = upperDust.position;
            if (p.x > c.x + checkDist) p.x -= checkDist * 2;
            if (p.x < c.x - checkDist) p.x += checkDist * 2;
            if (p.z > c.y + checkDist) p.z -= checkDist * 2;
            if (p.z < c.y - checkDist) p.z += checkDist * 2;
        }
    }
    getNewDustRandomPosition() {
        let c = this.system.center;
        let s = this.system.size;
        let sign1 = Math.random() > 0.5 ? 1 : -1;
        let sign2 = Math.random() > 0.5 ? 1 : -1;
        let x = c.x + sign1 * Math.sqrt(s) * (this.sizeDustRatio / 2 + Math.random() * this.sizeDustRatio * 10);
        let y = c.y + sign2 * Math.sqrt(s) * (this.sizeDustRatio / 2 + Math.random() * this.sizeDustRatio * 10);
        return new (0, $ha1VO.Vector2)(x, y);
    }
    getNewRandomPosition() {
        let sign1 = Math.random() > 0.5 ? 1 : -1;
        let sign2 = Math.random() > 0.5 ? 1 : -1;
        let pos = new (0, $ha1VO.Vector2)(0, 0);
        pos.x = sign1 * this.mapSize * Math.random();
        pos.y = sign2 * this.mapSize * Math.random();
        return pos;
    }
    getNewRandomPositionFromCenter(position, size, gap) {
        let angle = Math.random() * Math.PI * 2;
        let centerRatio = Math.pow(Math.random(), 1.5) * size;
        let x = Math.cos(angle) * (gap + centerRatio);
        let y = Math.sin(angle) * (gap + centerRatio);
        return new (0, $ha1VO.Vector2)(position.x + x, position.y + y);
    }
}


class $8076449a1b56aea5$export$f377ab3a921127d8 extends (0, $ee817e51f3e1169c$export$4ff51264f861fc14) {
    constructor(system){
        super(system), this.planetNumbers = 50, this.planetsStorage = [], this.planetsWithStar = [], this.planets = {};
        this.system = system;
        this.createAllPlanets();
    }
    createAllPlanets() {
        for(let i = 0; i < this.planetNumbers; i++){
            let planet = new (0, $58745f722026a6b4$export$965755fbf184a8fc)(this.system);
            this.planetsStorage.push(planet);
        }
    }
    addPlanet() {
        let planetsAvailable = (0, (/*@__PURE__*/$parcel$interopDefault($e645fa20844da7aa$exports)))(this.planetsStorage, (p)=>{
            return !p.attachedToStar;
        });
        if (planetsAvailable.length != 0) {
            let planet = planetsAvailable.pop();
            (0, (/*@__PURE__*/$parcel$interopDefault($e991a8ea9bf02b62$exports)))(this.planetsStorage, (p)=>{
                return p.key == planet.key;
            });
            planet.show();
            this.planets[planet.key] = planet;
            return planet;
        }
        return null;
    }
    removePlanet(planet) {
        delete this.planets[planet.key];
    }
    storagePlanet(planet) {
        this.removePlanet(planet);
        planet.hide();
        if (this.planetsStorage.indexOf(planet) == -1) this.planetsStorage.push(planet);
    }
    setPlanetWithStar(planet) {
        this.removePlanet(planet);
    }
    eraseAllPlanets() {
        for(const key in this.planets)this.storagePlanet(this.planets[key]);
        for(const key in this.planetsStorage)this.planetsStorage[key].hide();
        this.planets = {};
    }
    checkPlanetsCycle() {
        for(const key in this.planets){
            const planet = this.planets[key];
            planet.mesh.rotation.y += 0.01 * this.system.fpsRatio;
        }
    }
}


class $ef345e9d3c74cff5$export$16ec26812de3ce7a extends (0, $8076449a1b56aea5$export$f377ab3a921127d8) {
    constructor(system, gravityGrid){
        super(system), this.check = false, this.stars = {}, ////////// BLACKHOLE
        this.blackHoles = {};
        this.gravityGrid = gravityGrid;
        let frame = 0;
        this.system.scene.registerBeforeRender(()=>{
            this.checkPlanetsCycle();
            this.checkPlayersCycle();
            if (frame > 10 && this.check) {
                this.checkPlayersDust();
                this.checkDustMap();
                this.checkUpperDustMap();
                frame = 0;
            }
            frame++;
        });
    }
    checkPlayerAndRessources(check) {
        this.check = check;
    }
    setPlayerToFollow(player) {
        this.playerToFollow = player;
    }
    disposePlayer(player) {
        this.removeStar(player);
        player.dispose();
    }
    ////////// STAR
    createStar(starInterface) {
        let player = new (0, $4a26b283e7c333cd$export$2616165974278734)(this.system, this.gravityGrid, this, starInterface);
        player.key = starInterface.key;
        this.addStar(player);
        return player;
    }
    addStar(star) {
        this.stars[star.key] = star;
    }
    removeStar(star) {
        delete this.stars[star.key];
    }
    eraseAllStars() {
        for(const key in this.stars){
            let star = this.stars[key];
            if (star != this.playerToFollow) star.dispose();
        }
        this.stars = {};
    }
    addBlackHole(blackHole) {
        this.blackHoles[blackHole.key] = blackHole;
    }
    removeBlackHole(blackHole) {
        delete this.blackHoles[blackHole.key];
    }
    disposeBlackHole(blackHole) {
        this.removeBlackHole(blackHole);
        blackHole.transformMesh.dispose();
    }
    eraseAllBlackHoles() {
        for(const key in this.blackHoles)this.blackHoles[key].dispose();
        this.blackHoles = {};
    }
    ////////// DUST
    checkPlayerDust(player) {
        for(let i = 0; i < this.dusts.length; i++){
            const dust = this.dusts[i];
            let dist = (0, $ha1VO.Vector2).Distance(dust.position, player.position);
            if (dist < player.gravityField) this.moveDustToPlayer(player, dust);
        }
    }
    moveDustToPlayer(player, dust) {
        this.removeDust(dust);
        dust.goToEntity(player, ()=>{
            player.addDust();
            this.storageDust(dust);
        });
    }
    checkPlayersDust() {
        for(const key in this.stars){
            const player = this.stars[key];
            if (!player.accelerating && player.isStarVisible) this.checkPlayerDust(player);
        }
    }
    checkPlayersCycle() {
        for(const key in this.stars){
            const player = this.stars[key];
            if (player.isStarVisible) player.satelliteCycle();
        }
    }
    killPlayer(player) {
        this.removeStar(player);
        player.die(()=>{
            if (player.dustField) this.addDustField(player.position);
        });
    }
    eraseAllEntity() {
        // Erase Players before Planets so that planet are all in storage
        this.eraseAllStars();
        this.eraseAllBlackHoles();
        this.eraseAllDusts();
        this.eraseAllPlanets();
        this.system.checkActiveMeshes();
        this.addStar(this.playerToFollow);
    }
}





class $b662c73acf460d31$export$59271739c008d0aa {
    constructor(system){
        this.iconSize = 35;
        this.system = system;
        this.showAnimation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(system.animationManager);
        this.curve = new (0, $005b3f0c7a6c24da$export$682c243b9f175ba2)();
        this.curve.setEasingMode((0, $005b3f0c7a6c24da$export$2a0047e41c4245d1).EASINGMODE_EASEOUT);
        this.addLayout();
        this.show();
    }
    addLayout() {
        this.layout = new (0, $86ae1c9d39c421df$export$e289df377c340985)(this.system, {
            x: 0,
            y: 0
        }, {
            width: 100,
            height: 100
        }, {
            zIndex: 1000
        });
        this.layout.setFullScreen();
    // let lgo = this.layout.addImage('https://asset.wazana.io/logos/Cosmos.png', { x: 0, y: 0 }, { width: '50%', height: '50%' });
    }
    showAnim(callback) {
        this.showAnimation.simple(100, (count, perc)=>{
            this.setLayerChangeAnim(1 - perc);
        }, ()=>{
            if (callback) callback();
            this.setLayerChangeAnim(0);
        });
        this.layout.showAll();
    }
    show() {
        this.setLayerChangeAnim(0);
        this.layout.showAll();
        this.system.advancedTexture.addControl(this.layout.container);
    }
    hideAnim(callback) {
        this.showAnimation.simple(100, (count, perc)=>{
            this.setLayerChangeAnim(perc);
        }, ()=>{
            this.hide();
            if (callback) callback();
        });
    }
    hide() {
        this.setLayerChangeAnim(1);
        this.layout.hideAll();
        this.system.advancedTexture.removeControl(this.layout.container);
    }
    setLayerChangeAnim(perc) {
        let easePerc = this.curve.ease(1 - perc);
        this.layout.setOpacity(easePerc);
    }
}


const $462c7397f0528202$var$FURYPAGE_COLOR = '#30FF83';
const $462c7397f0528202$var$TEXT_COLOR = '#000000';
class $462c7397f0528202$export$857b11641fa70c36 {
    constructor(){
        this.parentStyle = {
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: '0px',
            left: '0px',
            background: `${$462c7397f0528202$var$FURYPAGE_COLOR}66`
        };
        this.contStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '20px',
            'max-width': '400px',
            display: 'flex',
            gap: '10px',
            'flex-direction': 'column',
            'align-items': 'center',
            'text-decoration': 'none',
            background: `${$462c7397f0528202$var$FURYPAGE_COLOR}`,
            //border: '4mm ridge '+ FURYPAGE_COLOR,
            'box-shadow': `${$462c7397f0528202$var$TEXT_COLOR}AA 10px 10px, ${$462c7397f0528202$var$TEXT_COLOR}77 20px 20px, ${$462c7397f0528202$var$TEXT_COLOR}44 30px 30px, ${$462c7397f0528202$var$TEXT_COLOR}22 40px 40px`,
            border: '10px solid ' + $462c7397f0528202$var$TEXT_COLOR
        };
        this.videoStyle = {
            height: 'auto',
            width: '100%',
            'min-width': '250px'
        };
        this.textStyle = {
            'font-size': '20px',
            'font-weight': '800',
            color: $462c7397f0528202$var$TEXT_COLOR,
            'font-family': 'Arial, sans-serif',
            outline: '0'
        };
        const { body: body } = document;
        // PARENT
        const parent = document.createElement('div');
        this.adContainer = parent;
        this.setStyle(parent, this.parentStyle);
        body.appendChild(parent);
        parent.addEventListener('click', ()=>{
            this.hide();
        });
        // CONTAINER
        const cont = document.createElement('a');
        cont.href = 'https://furypage.com/?ref=supernovae';
        cont.target = '_blank';
        this.setStyle(cont, this.contStyle);
        parent.appendChild(cont);
        // VIDEO
        const video = document.createElement('video');
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.src = 'https://furypage.com/product_video.mp4';
        this.setStyle(video, this.videoStyle);
        cont.appendChild(video);
        // TEXT
        const text = document.createElement('div');
        text.textContent = 'DISCOVER FURYPAGE: DESIGN YOUR 3D INTERACTIVE PORTFOLIO ==>';
        this.setStyle(text, this.textStyle);
        cont.appendChild(text);
        this.hide();
    }
    show() {
        this.adContainer.style.display = 'flex';
    }
    hide() {
        this.adContainer.style.display = 'none';
    }
    setStyle(el, style) {
        for(const key in style)el.style[key] = style[key];
    }
}


class $be0df1807c3bdee2$export$4193d9976a2c789 {
    // onlineMap: onlineMap;
    constructor(){
        const canvas = document.getElementById('gameCanvas');
        this.system = new (0, $cad696879dc04c5e$export$ae7e1ba247bde573)(canvas);
        this.system.optimize();
        this.animation = new (0, $f2ab65773a27cb19$export$c35d437ae5945fcd)(this.system.animationManager);
        let intro = new (0, $b662c73acf460d31$export$59271739c008d0aa)(this.system);
        intro.hideAnim();
        this.gravityGrid = new (0, $10526e257d75d69b$export$616950c67a6e1b09)(this.system);
        this.tileMap = new (0, $ef345e9d3c74cff5$export$16ec26812de3ce7a)(this.system, this.gravityGrid);
        this.localMap = new (0, $878359ced16369f2$export$586eb30124091f7c)(this.system, this.gravityGrid, this.tileMap);
        // this.onlineMap = new onlineMap(this.tileMap);
        // this.onlineMap.onLeave = () => {
        //     this.gameOver();
        // }
        this.realPlayer = new (0, $f497f7210301949e$export$17098278a054f4b2)(this.system, this.gravityGrid, this.tileMap);
        this.realPlayer.setMoving(false);
        this.realPlayer.onDied = ()=>{
            this.gameOver();
        };
        this.tileMap.setPlayerToFollow(this.realPlayer);
        this.tileMap.addStar(this.realPlayer);
        this.ad = new (0, $462c7397f0528202$export$857b11641fa70c36)();
        this.playUI = new (0, $05a2f3fa102a7599$export$700b77f60799a574)(this.system, this.realPlayer, this.tileMap);
        this.pauseUI = new (0, $e47a1a1b66165f1d$export$ce9c5a8b83583162)(this.system, this.realPlayer, this.playUI);
        this.pauseUI.onStart = (mode)=>{
            // if (mode == 'online') this.joinGameServer();
            // else this.joinGameLocal();
            this.joinGameLocal();
        };
        this.system.scene.freezeActiveMeshes();
        this.system.launchRender();
        this.system.setSky(0);
        this.realPlayer.show();
        this.realPlayer.setSize((0, $3f53ef2ed5cbbc5e$export$9d2a8399cd1966bf));
        this.realPlayer.setCategory((0, $3f53ef2ed5cbbc5e$export$7d31ece96576bc11)[0], true);
        setTimeout(()=>{
            this.pauseUI.checkNebula();
            this.pauseUI.showAnim();
        }, 2000);
        this.system.soundManager.load();
    }
    gameOver() {
        this.playUI.hideAnim();
        this.tileMap.checkPlayerAndRessources(false);
        setTimeout(()=>{
            this.system.soundManager.play('dead');
            this.localMap.eraseAllIas();
            this.tileMap.eraseAllEntity();
            this.realPlayer.restart();
            this.ad.show();
            setTimeout(()=>{
                this.pauseUI.showAnim();
            }, 2000);
        }, 4000);
    }
    gameStart() {
        this.system.soundManager.play('play');
        this.system.checkMobile();
        this.system.checkActiveMeshes();
        this.pauseUI.hideAnim(()=>{
            this.playUI.showAnim();
        });
        this.realPlayer.setMoving(true);
        this.realPlayer.removeAllPlanets();
        // In order to test
        setTimeout(()=>{
        // this.gameOver();
        // this.localMap.playerBlackHole(this.realPlayer)
        }, 3000);
    }
    joinGameLocal() {
        this.gameStart();
        this.tileMap.checkPlayerAndRessources(true);
        this.tileMap.addStar(this.realPlayer);
    }
}
new $be0df1807c3bdee2$export$4193d9976a2c789();


//# sourceMappingURL=index.0f1822cd.js.map
